
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired3a3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired3a3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bbzbN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2JHGI"));

});
parcelRegister("2JHGI", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1fe1ac3e21bc136e$export$ffb0004e005737fa; }, function (v) { return $1fe1ac3e21bc136e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1fe1ac3e21bc136e$export$34b9dba7ce09269b; }, function (v) { return $1fe1ac3e21bc136e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1fe1ac3e21bc136e$export$25062201e9e25d76; }, function (v) { return $1fe1ac3e21bc136e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1fe1ac3e21bc136e$export$ffb0004e005737fa;
var $1fe1ac3e21bc136e$export$34b9dba7ce09269b;
var $1fe1ac3e21bc136e$export$25062201e9e25d76;
"use strict";

(function() {
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
            case REACT_VIEW_TRANSITION_TYPE:
                return "ViewTransition";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function jsxDEVImpl(type, config, maybeKey, isStaticChildren, debugStack, debugTask) {
        var children = config.children;
        if (void 0 !== children) {
            if (isStaticChildren) {
                if (isArrayImpl(children)) {
                    for(isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)validateChildKeys(children[isStaticChildren]);
                    Object.freeze && Object.freeze(children);
                } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            } else validateChildKeys(children);
        }
        if (hasOwnProperty.call(config, "key")) {
            children = getComponentNameFromType(type);
            var keys = Object.keys(config).filter(function(k) {
                return "key" !== k;
            });
            isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', isStaticChildren, children, keys, children), didWarnAboutKeySpread[children + isStaticChildren] = !0);
        }
        children = null;
        void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
        hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
        if ("key" in config) {
            maybeKey = {};
            for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
        } else maybeKey = config;
        children && defineKeyPropWarningGetter(maybeKey, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        return ReactElement(type, children, maybeKey, getOwner(), debugStack, debugTask);
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React = (parcelRequire("7fPBF")), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    React = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React.react_stack_bottom_frame.bind(React, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    $1fe1ac3e21bc136e$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $1fe1ac3e21bc136e$export$34b9dba7ce09269b = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        if (trackActualOwner) {
            var previousStackTraceLimit = Error.stackTraceLimit;
            Error.stackTraceLimit = 10;
            var debugStackDEV = Error("react-stack-top-frame");
            Error.stackTraceLimit = previousStackTraceLimit;
        } else debugStackDEV = unknownOwnerDebugStack;
        return jsxDEVImpl(type, config, maybeKey, !1, debugStackDEV, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    $1fe1ac3e21bc136e$export$25062201e9e25d76 = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        if (trackActualOwner) {
            var previousStackTraceLimit = Error.stackTraceLimit;
            Error.stackTraceLimit = 10;
            var debugStackDEV = Error("react-stack-top-frame");
            Error.stackTraceLimit = previousStackTraceLimit;
        } else debugStackDEV = unknownOwnerDebugStack;
        return jsxDEVImpl(type, config, maybeKey, !0, debugStackDEV, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
})();

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3xXTL"));

});
parcelRegister("3xXTL", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
            }
        });
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function warnNoop(publicInstance, callerName) {
        publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
        var warningKey = publicInstance + "." + callerName;
        didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, publicInstance), didWarnStateUpdateForUnmountedComponent[warningKey] = !0);
    }
    function Component(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function ComponentDummy() {}
    function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
            case REACT_VIEW_TRANSITION_TYPE:
                return "ViewTransition";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        newKey = ReactElement(oldElement.type, newKey, oldElement.props, oldElement._owner, oldElement._debugStack, oldElement._debugTask);
        oldElement._store && (newKey._store.validated = oldElement._store.validated);
        return newKey;
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function escape(key) {
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + key.replace(/[=:]/g, function(match) {
            return escaperLookup[match];
        });
    }
    function getElementKey(element, index) {
        return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape("" + element.key)) : index.toString(36);
    }
    function resolveThenable(thenable) {
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenable.reason;
            default:
                switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                    "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
                }, function(error) {
                    "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                })), thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenable.reason;
                }
        }
        throw thenable;
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if ("undefined" === type || "boolean" === type) children = null;
        var invokeCallback = !1;
        if (null === children) invokeCallback = !0;
        else switch(type){
            case "bigint":
            case "string":
            case "number":
                invokeCallback = !0;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = !0;
                        break;
                    case REACT_LAZY_TYPE:
                        return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
                }
        }
        if (invokeCallback) {
            invokeCallback = children;
            callback = callback(invokeCallback);
            var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
            isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
                return c;
            })) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + childKey), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
            return 1;
        }
        invokeCallback = 0;
        childKey = "" === nameSoFar ? "." : nameSoFar + ":";
        if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if (i = getIteratorFn(children), "function" === typeof i) for(i === children.entries && (didWarnAboutMaps || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0), children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if ("object" === type) {
            if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
            array = String(children);
            throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
        }
        return invokeCallback;
    }
    function mapChildren(children, func, context) {
        if (null == children) return children;
        var result = [], count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    function lazyInitializer(payload) {
        if (-1 === payload._status) {
            var resolveDebugValue = null, rejectDebugValue = null, ioInfo = payload._ioInfo;
            null != ioInfo && (ioInfo.start = ioInfo.end = performance.now(), ioInfo.value = new Promise(function(resolve, reject) {
                resolveDebugValue = resolve;
                rejectDebugValue = reject;
            }));
            ioInfo = payload._result;
            var thenable = ioInfo();
            thenable.then(function(moduleObject) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 1;
                    payload._result = moduleObject;
                    var _ioInfo = payload._ioInfo;
                    if (null != _ioInfo) {
                        _ioInfo.end = performance.now();
                        var debugValue = null == moduleObject ? void 0 : moduleObject.default;
                        resolveDebugValue(debugValue);
                        _ioInfo.value.status = "fulfilled";
                        _ioInfo.value.value = debugValue;
                    }
                    void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
                }
            }, function(error) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 2;
                    payload._result = error;
                    var _ioInfo2 = payload._ioInfo;
                    null != _ioInfo2 && (_ioInfo2.end = performance.now(), _ioInfo2.value.then(noop, noop), rejectDebugValue(error), _ioInfo2.value.status = "rejected", _ioInfo2.value.reason = error);
                    void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                }
            });
            ioInfo = payload._ioInfo;
            if (null != ioInfo) {
                var displayName = thenable.displayName;
                "string" === typeof displayName && (ioInfo.name = displayName);
            }
            -1 === payload._status && (payload._status = 0, payload._result = thenable);
        }
        if (1 === payload._status) return ioInfo = payload._result, void 0 === ioInfo && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", ioInfo), "default" in ioInfo || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", ioInfo), ioInfo.default;
        throw payload._result;
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(scope) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop, reportGlobalError));
        } catch (error) {
            reportGlobalError(error);
        } finally{
            null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    }
    function addTransitionType(type) {
        var transition = ReactSharedInternals.T;
        if (null !== transition) {
            var transitionTypes = transition.types;
            null === transitionTypes ? transition.types = [
                type
            ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
        } else 0 === ReactSharedInternals.asyncTransitions && console.error("addTransitionType can only be called inside a `startTransition()` callback. It must be associated with a specific Transition."), startTransition(addTransitionType.bind(null, type));
    }
    function enqueueTask(task) {
        if (null === enqueueTaskImpl) try {
            var requireString = ("require" + Math.random()).slice(0, 7);
            enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
        } catch (_err) {
            enqueueTaskImpl = function(callback) {
                !1 === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = !0, "undefined" === typeof MessageChannel && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(void 0);
            };
        }
        return enqueueTaskImpl(task);
    }
    function aggregateErrors(errors) {
        return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
    }
    function popActScope(prevActQueue, prevActScopeDepth) {
        prevActScopeDepth !== actScopeDepth - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactSharedInternals.actQueue;
        if (null !== queue) {
            if (0 !== queue.length) try {
                flushActQueue(queue);
                enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                });
                return;
            } catch (error) {
                ReactSharedInternals.thrownErrors.push(error);
            }
            else ReactSharedInternals.actQueue = null;
        }
        0 < ReactSharedInternals.thrownErrors.length ? (queue = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue)) : resolve(returnValue);
    }
    function flushActQueue(queue) {
        if (!isFlushing) {
            isFlushing = !0;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do {
                        ReactSharedInternals.didUsePromise = !1;
                        var continuation = callback(!1);
                        if (null !== continuation) {
                            if (ReactSharedInternals.didUsePromise) {
                                queue[i] = callback;
                                queue.splice(0, i);
                                return;
                            }
                            callback = continuation;
                        } else break;
                    }while (1);
                }
                queue.length = 0;
            } catch (error) {
                queue.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
            } finally{
                isFlushing = !1;
            }
        }
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function(publicInstance) {
            warnNoop(publicInstance, "forceUpdate");
        },
        enqueueReplaceState: function(publicInstance) {
            warnNoop(publicInstance, "replaceState");
        },
        enqueueSetState: function(publicInstance) {
            warnNoop(publicInstance, "setState");
        }
    }, assign = Object.assign, emptyObject = {};
    Object.freeze(emptyObject);
    Component.prototype.isReactComponent = {};
    Component.prototype.setState = function(partialState, callback) {
        if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    for(fnName in deprecatedAPIs)deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    ComponentDummy.prototype = Component.prototype;
    deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
    deprecatedAPIs.constructor = PureComponent;
    assign(deprecatedAPIs, Component.prototype);
    deprecatedAPIs.isPureReactComponent = !0;
    var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
    }, hasOwnProperty = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    deprecatedAPIs = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(deprecatedAPIs, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutMaps = !1, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, didWarnAboutMessageChannel = !1, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = !1, isFlushing = !1, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
        queueMicrotask(function() {
            return queueMicrotask(callback);
        });
    } : enqueueTask;
    deprecatedAPIs = Object.freeze({
        __proto__: null,
        c: function(size) {
            return resolveDispatcher().useMemoCache(size);
        }
    });
    var fnName = {
        map: mapChildren,
        forEach: function(children, forEachFunc, forEachContext) {
            mapChildren(children, function() {
                forEachFunc.apply(this, arguments);
            }, forEachContext);
        },
        count: function(children) {
            var n = 0;
            mapChildren(children, function() {
                n++;
            });
            return n;
        },
        toArray: function(children) {
            return mapChildren(children, function(child) {
                return child;
            }) || [];
        },
        only: function(children) {
            if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
            return children;
        }
    };
    exports.Activity = REACT_ACTIVITY_TYPE;
    exports.Children = fnName;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
    exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
    exports.__COMPILER_RUNTIME = deprecatedAPIs;
    exports.act = function(callback) {
        var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        var queue = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = !1;
        try {
            var result = callback();
        } catch (error) {
            ReactSharedInternals.thrownErrors.push(error);
        }
        if (0 < ReactSharedInternals.thrownErrors.length) throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        if (null !== result && "object" === typeof result && "function" === typeof result.then) {
            var thenable = result;
            queueSeveralMicrotasks(function() {
                didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            });
            return {
                then: function(resolve, reject) {
                    didAwaitActCall = !0;
                    thenable.then(function(returnValue) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        if (0 === prevActScopeDepth) {
                            try {
                                flushActQueue(queue), enqueueTask(function() {
                                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                                });
                            } catch (error$0) {
                                ReactSharedInternals.thrownErrors.push(error$0);
                            }
                            if (0 < ReactSharedInternals.thrownErrors.length) {
                                var _thrownError = aggregateErrors(ReactSharedInternals.thrownErrors);
                                ReactSharedInternals.thrownErrors.length = 0;
                                reject(_thrownError);
                            }
                        } else resolve(returnValue);
                    }, function(error) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
                    });
                }
            };
        }
        var returnValue$jscomp$0 = result;
        popActScope(prevActQueue, prevActScopeDepth);
        0 === prevActScopeDepth && (flushActQueue(queue), 0 !== queue.length && queueSeveralMicrotasks(function() {
            didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
        }), ReactSharedInternals.actQueue = null);
        if (0 < ReactSharedInternals.thrownErrors.length) throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        return {
            then: function(resolve, reject) {
                didAwaitActCall = !0;
                0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue, enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue$jscomp$0, resolve, reject);
                })) : resolve(returnValue$jscomp$0);
            }
        };
    };
    exports.addTransitionType = addTransitionType;
    exports.cache = function(fn) {
        return function() {
            return fn.apply(null, arguments);
        };
    };
    exports.cacheSignal = function() {
        return null;
    };
    exports.captureOwnerStack = function() {
        var getCurrentStack = ReactSharedInternals.getCurrentStack;
        return null === getCurrentStack ? null : getCurrentStack();
    };
    exports.cloneElement = function(element, config, children) {
        if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
        var props = assign({}, element.props), key = element.key, owner = element._owner;
        if (null != config) {
            var JSCompiler_inline_result;
            a: {
                if (hasOwnProperty.call(config, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(config, "ref").get) && JSCompiler_inline_result.isReactWarning) {
                    JSCompiler_inline_result = !1;
                    break a;
                }
                JSCompiler_inline_result = void 0 !== config.ref;
            }
            JSCompiler_inline_result && (owner = getOwner());
            hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key);
            for(propName in config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
        }
        var propName = arguments.length - 2;
        if (1 === propName) props.children = children;
        else if (1 < propName) {
            JSCompiler_inline_result = Array(propName);
            for(var i = 0; i < propName; i++)JSCompiler_inline_result[i] = arguments[i + 2];
            props.children = JSCompiler_inline_result;
        }
        props = ReactElement(element.type, key, props, owner, element._debugStack, element._debugTask);
        for(key = 2; key < arguments.length; key++)validateChildKeys(arguments[key]);
        return props;
    };
    exports.createContext = function(defaultValue) {
        defaultValue = {
            $$typeof: REACT_CONTEXT_TYPE,
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        defaultValue.Provider = defaultValue;
        defaultValue.Consumer = {
            $$typeof: REACT_CONSUMER_TYPE,
            _context: defaultValue
        };
        defaultValue._currentRenderer = null;
        defaultValue._currentRenderer2 = null;
        return defaultValue;
    };
    exports.createElement = function(type, config, children) {
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i]);
        var propName;
        i = {};
        var key = null;
        if (null != config) for(propName in didWarnAboutOldJSXRuntime || !("__self" in config) || "key" in config || (didWarnAboutOldJSXRuntime = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config[propName]);
        var childrenLength = arguments.length - 2;
        if (1 === childrenLength) i.children = children;
        else if (1 < childrenLength) {
            for(var childArray = Array(childrenLength), _i = 0; _i < childrenLength; _i++)childArray[_i] = arguments[_i + 2];
            Object.freeze && Object.freeze(childArray);
            i.children = childArray;
        }
        if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === i[propName] && (i[propName] = childrenLength[propName]);
        key && defineKeyPropWarningGetter(i, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        (propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++) ? (childArray = Error.stackTraceLimit, Error.stackTraceLimit = 10, childrenLength = Error("react-stack-top-frame"), Error.stackTraceLimit = childArray) : childrenLength = unknownOwnerDebugStack;
        return ReactElement(type, key, i, getOwner(), childrenLength, propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    exports.createRef = function() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    };
    exports.forwardRef = function(render) {
        null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" !== typeof render ? console.error("forwardRef requires a render function but was given %s.", null === render ? "null" : typeof render) : 0 !== render.length && 2 !== render.length && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        null != render && null != render.defaultProps && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        }, ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                render.name || render.displayName || (Object.defineProperty(render, "name", {
                    value: name
                }), render.displayName = name);
            }
        });
        return elementType;
    };
    exports.isValidElement = isValidElement;
    exports.lazy = function(ctor) {
        ctor = {
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: ctor,
            _init: lazyInitializer
        }, ioInfo = {
            name: "lazy",
            start: -1,
            end: -1,
            value: null,
            owner: null,
            debugStack: Error("react-stack-top-frame"),
            debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        ctor._ioInfo = ioInfo;
        lazyType._debugInfo = [
            {
                awaited: ioInfo
            }
        ];
        return lazyType;
    };
    exports.memo = function(type, compare) {
        null == type && console.error("memo: The first argument must be a component. Instead received: %s", null === type ? "null" : typeof type);
        compare = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: void 0 === compare ? null : compare
        };
        var ownName;
        Object.defineProperty(compare, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                type.name || type.displayName || (Object.defineProperty(type, "name", {
                    value: name
                }), type.displayName = name);
            }
        });
        return compare;
    };
    exports.startTransition = startTransition;
    exports.unstable_useCacheRefresh = function() {
        return resolveDispatcher().useCacheRefresh();
    };
    exports.use = function(usable) {
        return resolveDispatcher().use(usable);
    };
    exports.useActionState = function(action, initialState, permalink) {
        return resolveDispatcher().useActionState(action, initialState, permalink);
    };
    exports.useCallback = function(callback, deps) {
        return resolveDispatcher().useCallback(callback, deps);
    };
    exports.useContext = function(Context) {
        var dispatcher = resolveDispatcher();
        Context.$$typeof === REACT_CONSUMER_TYPE && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?");
        return dispatcher.useContext(Context);
    };
    exports.useDebugValue = function(value, formatterFn) {
        return resolveDispatcher().useDebugValue(value, formatterFn);
    };
    exports.useDeferredValue = function(value, initialValue) {
        return resolveDispatcher().useDeferredValue(value, initialValue);
    };
    exports.useEffect = function(create, deps) {
        null == create && console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useEffect(create, deps);
    };
    exports.useEffectEvent = function(callback) {
        return resolveDispatcher().useEffectEvent(callback);
    };
    exports.useId = function() {
        return resolveDispatcher().useId();
    };
    exports.useImperativeHandle = function(ref, create, deps) {
        return resolveDispatcher().useImperativeHandle(ref, create, deps);
    };
    exports.useInsertionEffect = function(create, deps) {
        null == create && console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useInsertionEffect(create, deps);
    };
    exports.useLayoutEffect = function(create, deps) {
        null == create && console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useLayoutEffect(create, deps);
    };
    exports.useMemo = function(create, deps) {
        return resolveDispatcher().useMemo(create, deps);
    };
    exports.useOptimistic = function(passthrough, reducer) {
        return resolveDispatcher().useOptimistic(passthrough, reducer);
    };
    exports.useReducer = function(reducer, initialArg, init) {
        return resolveDispatcher().useReducer(reducer, initialArg, init);
    };
    exports.useRef = function(initialValue) {
        return resolveDispatcher().useRef(initialValue);
    };
    exports.useState = function(initialState) {
        return resolveDispatcher().useState(initialState);
    };
    exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
        return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    };
    exports.useTransition = function() {
        return resolveDispatcher().useTransition();
    };
    exports.version = "19.3.0";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});




parcelRegister("h3OEn", function(module, exports) {

$parcel$export(module.exports, "AxiosError", function () { return $c6ba0193c6fadd6f$export$c1fbed17c2f6a328; });
$parcel$export(module.exports, "HttpStatusCode", function () { return $c6ba0193c6fadd6f$export$a972f69c851492b3; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("a04va")).default; });

var $a04va = parcelRequire("a04va");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $c6ba0193c6fadd6f$export$1c00760e9e5a4e95, AxiosError: $c6ba0193c6fadd6f$export$c1fbed17c2f6a328, CanceledError: $c6ba0193c6fadd6f$export$1ab0c6b20d94fa14, isCancel: $c6ba0193c6fadd6f$export$3b22524397b493c6, CancelToken: $c6ba0193c6fadd6f$export$fd08e3cb425f0d61, VERSION: $c6ba0193c6fadd6f$export$a4ad2735b021c132, all: $c6ba0193c6fadd6f$export$84bf76cd7afc7469, Cancel: $c6ba0193c6fadd6f$export$848c9b7ead0df967, isAxiosError: $c6ba0193c6fadd6f$export$fbafdbe06a5b5a9a, spread: $c6ba0193c6fadd6f$export$3ae0fd4797ed47c8, toFormData: $c6ba0193c6fadd6f$export$10ae0d317ea97f8b, AxiosHeaders: $c6ba0193c6fadd6f$export$4e7d6ff0f3e6520, HttpStatusCode: $c6ba0193c6fadd6f$export$a972f69c851492b3, formToJSON: $c6ba0193c6fadd6f$export$86d7c59254d6a2c9, getAdapter: $c6ba0193c6fadd6f$export$17ddc20a97d669e2, mergeConfig: $c6ba0193c6fadd6f$export$7ec1ebcfa9d8bd6a, create: $c6ba0193c6fadd6f$export$185802fd694ee1f5 } = (0, $a04va.default);

});
parcelRegister("a04va", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $747d656b899e6115$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $ef5jC = parcelRequire("ef5jC");

var $3aVh3 = parcelRequire("3aVh3");

var $lb2qV = parcelRequire("lb2qV");

var $kZZD0 = parcelRequire("kZZD0");

var $4IsRW = parcelRequire("4IsRW");

var $cR4ZD = parcelRequire("cR4ZD");

var $29a93 = parcelRequire("29a93");

var $fX03H = parcelRequire("fX03H");

var $b676K = parcelRequire("b676K");

var $kgiwQ = parcelRequire("kgiwQ");

var $ha7aM = parcelRequire("ha7aM");

var $gv9ju = parcelRequire("gv9ju");

var $ewGK1 = parcelRequire("ewGK1");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    const context = new (0, $8PZpp.default)(defaultConfig);
    const instance = (0, $6zjya.default)((0, $8PZpp.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $adReO.default).extend(instance, (0, $8PZpp.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $adReO.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance((0, $5f6d7.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance((0, $ef5jC.default));
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = (0, $8PZpp.default);
// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (0, $lb2qV.default);
$747d656b899e6115$var$axios.CancelToken = (0, $kZZD0.default);
$747d656b899e6115$var$axios.isCancel = (0, $4IsRW.default);
$747d656b899e6115$var$axios.VERSION = (0, $cR4ZD.VERSION);
$747d656b899e6115$var$axios.toFormData = (0, $29a93.default);
// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (0, $fX03H.default);
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$747d656b899e6115$var$axios.spread = (0, $b676K.default);
// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (0, $kgiwQ.default);
// Expose mergeConfig
$747d656b899e6115$var$axios.mergeConfig = (0, $5f6d7.default);
$747d656b899e6115$var$axios.AxiosHeaders = (0, $ha7aM.default);
$747d656b899e6115$var$axios.formToJSON = (thing)=>(0, $3aVh3.default)((0, $adReO.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$747d656b899e6115$var$axios.getAdapter = (0, $gv9ju.default).getAdapter;
$747d656b899e6115$var$axios.HttpStatusCode = (0, $ewGK1.default);
$747d656b899e6115$var$axios.default = $747d656b899e6115$var$axios;
var // this module should only have a default export
$747d656b899e6115$export$2e2bcd8739ae039 = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77146a31cb578292$export$2e2bcd8739ae039; });

var $6zjya = parcelRequire("6zjya");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $77146a31cb578292$var$toString } = Object.prototype;
const { getPrototypeOf: $77146a31cb578292$var$getPrototypeOf } = Object;
const { iterator: $77146a31cb578292$var$iterator, toStringTag: $77146a31cb578292$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $77146a31cb578292$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $77146a31cb578292$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $77146a31cb578292$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $77146a31cb578292$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($77146a31cb578292$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $77146a31cb578292$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $77146a31cb578292$var$getPrototypeOf(obj);
        if ($77146a31cb578292$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($77146a31cb578292$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $77146a31cb578292$var$getSafeProp = (obj, prop)=>obj != null && $77146a31cb578292$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $77146a31cb578292$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $77146a31cb578292$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $77146a31cb578292$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $77146a31cb578292$var$getPrototypeOf(current);
        if ($77146a31cb578292$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($77146a31cb578292$var$isUnsafeObjectKey(prop)) continue;
            if (!$77146a31cb578292$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $77146a31cb578292$var$kindOf = ((cache)=>(thing)=>{
        const str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $77146a31cb578292$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$77146a31cb578292$var$kindOf(thing) === type;
};
const $77146a31cb578292$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $77146a31cb578292$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $77146a31cb578292$var$isUndefined = $77146a31cb578292$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && $77146a31cb578292$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $77146a31cb578292$var$isString = $77146a31cb578292$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $77146a31cb578292$var$isFunction = $77146a31cb578292$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $77146a31cb578292$var$isNumber = $77146a31cb578292$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $77146a31cb578292$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $77146a31cb578292$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $77146a31cb578292$var$isPlainObject = (val)=>{
    if (!$77146a31cb578292$var$isObject(val)) return false;
    const prototype = $77146a31cb578292$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $77146a31cb578292$var$getPrototypeOf(prototype) === null) && // Treat safe own/inherited Symbol.toStringTag or Symbol.iterator members as
    // evidence the value is tagged/iterable, while ignoring members reachable
    // only through shared or terminal prototype boundaries.
    !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$toStringTag) && !$77146a31cb578292$var$hasOwnInPrototypeChain(val, $77146a31cb578292$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $77146a31cb578292$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$77146a31cb578292$var$isObject(val) || $77146a31cb578292$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $77146a31cb578292$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $77146a31cb578292$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
const $77146a31cb578292$var$isSet = $77146a31cb578292$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $77146a31cb578292$var$isStream = (val)=>$77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $77146a31cb578292$var$G = $77146a31cb578292$var$getGlobal();
const $77146a31cb578292$var$FormDataCtor = typeof $77146a31cb578292$var$G.FormData !== 'undefined' ? $77146a31cb578292$var$G.FormData : undefined;
const $77146a31cb578292$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($77146a31cb578292$var$FormDataCtor && thing instanceof $77146a31cb578292$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $77146a31cb578292$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$77146a31cb578292$var$isFunction(thing.append)) return false;
    const kind = $77146a31cb578292$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
const [$77146a31cb578292$var$isReadableStream, $77146a31cb578292$var$isRequest, $77146a31cb578292$var$isResponse, $77146a31cb578292$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($77146a31cb578292$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $77146a31cb578292$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $77146a31cb578292$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($77146a31cb578292$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $77146a31cb578292$var$findKey(obj, key) {
    if ($77146a31cb578292$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $77146a31cb578292$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $77146a31cb578292$var$isContextDefined = (context)=>!$77146a31cb578292$var$isUndefined(context) && context !== $77146a31cb578292$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $77146a31cb578292$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $77146a31cb578292$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $77146a31cb578292$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($77146a31cb578292$var$isPlainObject(existing) && $77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge(existing, val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[targetKey] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$77146a31cb578292$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $77146a31cb578292$var$isBuffer(source)) continue;
        $77146a31cb578292$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $77146a31cb578292$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($77146a31cb578292$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $77146a31cb578292$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $77146a31cb578292$var$forEach(b, (val, key)=>{
        if (thisArg && $77146a31cb578292$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $6zjya.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $77146a31cb578292$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $77146a31cb578292$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $77146a31cb578292$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $77146a31cb578292$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $77146a31cb578292$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $77146a31cb578292$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($77146a31cb578292$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$77146a31cb578292$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $77146a31cb578292$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $77146a31cb578292$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $77146a31cb578292$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$77146a31cb578292$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $77146a31cb578292$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $77146a31cb578292$var$isHTMLForm = $77146a31cb578292$var$kindOfTest('HTMLFormElement');
const $77146a31cb578292$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $77146a31cb578292$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $77146a31cb578292$var$isRegExp = $77146a31cb578292$var$kindOfTest('RegExp');
const $77146a31cb578292$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $77146a31cb578292$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $77146a31cb578292$var$freezeMethods = (obj)=>{
    $77146a31cb578292$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($77146a31cb578292$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$77146a31cb578292$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $77146a31cb578292$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $77146a31cb578292$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $77146a31cb578292$var$noop = ()=>{};
const $77146a31cb578292$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $77146a31cb578292$var$isSpecCompliantForm(thing) {
    return !!(thing && $77146a31cb578292$var$isFunction(thing.append) && thing[$77146a31cb578292$var$toStringTag] === 'FormData' && thing[$77146a31cb578292$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $77146a31cb578292$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($77146a31cb578292$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($77146a31cb578292$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($77146a31cb578292$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $77146a31cb578292$var$isArray(source) ? [] : {};
                    $77146a31cb578292$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$77146a31cb578292$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $77146a31cb578292$var$isAsyncFn = $77146a31cb578292$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $77146a31cb578292$var$isThenable = (thing)=>thing && ($77146a31cb578292$var$isObject(thing) || $77146a31cb578292$var$isFunction(thing)) && $77146a31cb578292$var$isFunction(thing.then) && $77146a31cb578292$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $77146a31cb578292$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $77146a31cb578292$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $77146a31cb578292$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $77146a31cb578292$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $77146a31cb578292$var$isFunction($77146a31cb578292$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $77146a31cb578292$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($77146a31cb578292$var$_global) : $77146a31cb578292$var$_setImmediate;
// *********************
const $77146a31cb578292$var$isIterable = (thing)=>thing != null && $77146a31cb578292$var$isFunction(thing[$77146a31cb578292$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $77146a31cb578292$var$isSafeIterable = (thing)=>thing != null && $77146a31cb578292$var$hasOwnInPrototypeChain(thing, $77146a31cb578292$var$iterator) && $77146a31cb578292$var$isIterable(thing);
var $77146a31cb578292$export$2e2bcd8739ae039 = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isBoolean: $77146a31cb578292$var$isBoolean,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isEmptyObject: $77146a31cb578292$var$isEmptyObject,
    isReadableStream: $77146a31cb578292$var$isReadableStream,
    isRequest: $77146a31cb578292$var$isRequest,
    isResponse: $77146a31cb578292$var$isResponse,
    isHeaders: $77146a31cb578292$var$isHeaders,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isReactNativeBlob: $77146a31cb578292$var$isReactNativeBlob,
    isReactNative: $77146a31cb578292$var$isReactNative,
    isBlob: $77146a31cb578292$var$isBlob,
    isRegExp: $77146a31cb578292$var$isRegExp,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    forEachEntry: $77146a31cb578292$var$forEachEntry,
    matchAll: $77146a31cb578292$var$matchAll,
    isHTMLForm: $77146a31cb578292$var$isHTMLForm,
    hasOwnProperty: $77146a31cb578292$var$hasOwnProperty,
    hasOwnProp: $77146a31cb578292$var$hasOwnProperty,
    hasOwnInPrototypeChain: $77146a31cb578292$var$hasOwnInPrototypeChain,
    getSafeProp: $77146a31cb578292$var$getSafeProp,
    toSafeFlatObject: $77146a31cb578292$var$toSafeFlatObject,
    reduceDescriptors: $77146a31cb578292$var$reduceDescriptors,
    freezeMethods: $77146a31cb578292$var$freezeMethods,
    toObjectSet: $77146a31cb578292$var$toObjectSet,
    toCamelCase: $77146a31cb578292$var$toCamelCase,
    noop: $77146a31cb578292$var$noop,
    toFiniteNumber: $77146a31cb578292$var$toFiniteNumber,
    findKey: $77146a31cb578292$var$findKey,
    global: $77146a31cb578292$var$_global,
    isContextDefined: $77146a31cb578292$var$isContextDefined,
    isSpecCompliantForm: $77146a31cb578292$var$isSpecCompliantForm,
    toJSONObject: $77146a31cb578292$var$toJSONObject,
    isAsyncFn: $77146a31cb578292$var$isAsyncFn,
    isThenable: $77146a31cb578292$var$isThenable,
    setImmediate: $77146a31cb578292$var$_setImmediate,
    asap: $77146a31cb578292$var$asap,
    isIterable: $77146a31cb578292$var$isIterable,
    isSafeIterable: $77146a31cb578292$var$isSafeIterable
};

});
parcelRegister("6zjya", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c852d2f6a5a0387$export$2e2bcd8739ae039; });
'use strict';
function $4c852d2f6a5a0387$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("8PZpp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f2b8a41463d1e8$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $40T1q = parcelRequire("40T1q");

var $hxzPz = parcelRequire("hxzPz");

var $2iR5D = parcelRequire("2iR5D");

var $ha7aM = parcelRequire("ha7aM");

var $aP7qx = parcelRequire("aP7qx");
'use strict';
const $66f2b8a41463d1e8$var$validators = (0, $2iR5D.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $66f2b8a41463d1e8$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $khPLX.default)(),
            response: new (0, $khPLX.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                    if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $5f6d7.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $2iR5D.default).assertOptions(transitional, {
            silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            legacyInterceptorReqResOrdering: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            advertiseZstdAcceptEncoding: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
            validateStatusUndefinedResolves: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $adReO.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $2iR5D.default).assertOptions(paramsSerializer, {
                encode: $66f2b8a41463d1e8$var$validators.function,
                serialize: $66f2b8a41463d1e8$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $2iR5D.default).assertOptions(config, {
            baseUrl: $66f2b8a41463d1e8$var$validators.spelling('baseURL'),
            withXsrfToken: $66f2b8a41463d1e8$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $adReO.default).getSafeProp(config, 'method') || (0, $adReO.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $adReO.default).merge(headers.common, headers[config.method]);
        headers && (0, $adReO.default).forEach((0, $hxzPz.default).concat('common'), (method)=>{
            delete headers[method];
        });
        config.headers = (0, $ha7aM.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $aP7qx.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $eystn.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $adReO.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $eystn.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $eystn.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $5f6d7.default)(this.defaults, config);
        const fullPath = (0, $40T1q.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $6nvAH.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $adReO.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $5f6d7.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $adReO.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $adReO.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $5f6d7.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $66f2b8a41463d1e8$export$2e2bcd8739ae039 = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a4d655613ae826e$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $dWNM1 = parcelRequire("dWNM1");
'use strict';
function $4a4d655613ae826e$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $4a4d655613ae826e$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $adReO.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $adReO.default).getSafeProp(_options, 'encode') || $4a4d655613ae826e$export$c564cdbbe6da493;
    const serializeFn = (0, $adReO.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $adReO.default).isURLSearchParams(params) ? params.toString() : new (0, $dWNM1.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("dWNM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2774d1dd3bec636$export$2e2bcd8739ae039; });

var $29a93 = parcelRequire("29a93");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $a2774d1dd3bec636$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $a2774d1dd3bec636$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $29a93.default)(params, this, options);
}
const $a2774d1dd3bec636$var$prototype = $a2774d1dd3bec636$var$AxiosURLSearchParams.prototype;
$a2774d1dd3bec636$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$a2774d1dd3bec636$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $a2774d1dd3bec636$var$encode) : $a2774d1dd3bec636$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $a2774d1dd3bec636$export$2e2bcd8739ae039 = $a2774d1dd3bec636$var$AxiosURLSearchParams;

});
parcelRegister("29a93", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", function () { return $19044a9fa7281693$export$659081b45d03227d; });
$parcel$export(module.exports, "default", function () { return $19044a9fa7281693$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $4htkn = parcelRequire("4htkn");

var $4htkn = parcelRequire("4htkn");
'use strict';
const $19044a9fa7281693$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isVisitable(thing) {
    return (0, $adReO.default).isPlainObject(thing) || (0, $adReO.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $19044a9fa7281693$var$removeBrackets(key) {
    return (0, $adReO.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $19044a9fa7281693$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $19044a9fa7281693$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $19044a9fa7281693$var$isFlatArray(arr) {
    return (0, $adReO.default).isArray(arr) && !arr.some($19044a9fa7281693$var$isVisitable);
}
const $19044a9fa7281693$var$predicates = (0, $adReO.default).toFlatObject((0, $adReO.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $19044a9fa7281693$var$toFormData(obj, formData, options) {
    if (!(0, $adReO.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4htkn.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $adReO.default).getSafeProp(options, name);
        return (0, $adReO.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $19044a9fa7281693$export$659081b45d03227d);
    const useBlob = _Blob && (0, $adReO.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $adReO.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $adReO.default).isDate(value)) return value.toISOString();
        if ((0, $adReO.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $adReO.default).isBlob(value)) throw new (0, $fX03H.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $adReO.default).isArrayBuffer(value) || (0, $adReO.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $4htkn.default) && (0, $4htkn.default).isBufferAvailable()) return (0, $4htkn.default).from(value);
            throw new (0, $fX03H.default)('Blob is not supported. Use a Buffer instead.', (0, $fX03H.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $fX03H.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $fX03H.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $adReO.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $adReO.default).isReactNative(formData) && (0, $adReO.default).isReactNativeBlob(value)) {
            formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $adReO.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $adReO.default).isArray(value) && $19044a9fa7281693$var$isFlatArray(value) || ((0, $adReO.default).isFileList(value) || (0, $adReO.default).endsWith(key, '[]')) && (arr = (0, $adReO.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $19044a9fa7281693$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $adReO.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $19044a9fa7281693$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($19044a9fa7281693$var$isVisitable(value)) return true;
        formData.append($19044a9fa7281693$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($19044a9fa7281693$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $19044a9fa7281693$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $adReO.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $adReO.default).forEach(value, function each(el, key) {
            const result = !((0, $adReO.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $adReO.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $adReO.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $19044a9fa7281693$export$2e2bcd8739ae039 = $19044a9fa7281693$var$toFormData;

});
parcelRegister("fX03H", function(module, exports) {

$parcel$export(module.exports, "REDACTED", function () { return $b9cc6960093b095e$export$6acd2efa8ac62a1b; });
$parcel$export(module.exports, "default", function () { return $b9cc6960093b095e$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ha7aM = parcelRequire("ha7aM");
'use strict';
const $b9cc6960093b095e$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $adReO.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $adReO.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $b9cc6960093b095e$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $adReO.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $ha7aM.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $adReO.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $adReO.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $adReO.default).isPlainObject(source) && $b9cc6960093b095e$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $b9cc6960093b095e$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $adReO.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $b9cc6960093b095e$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $b9cc6960093b095e$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $b9cc6960093b095e$var$stringifySafely(entry.message) : $b9cc6960093b095e$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $b9cc6960093b095e$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $adReO.default).isArray(error.errors) && error.errors.length) message = $b9cc6960093b095e$var$aggregateErrorMessage(error);
        const axiosError = new $b9cc6960093b095e$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $adReO.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $adReO.default).isArray(redactKeys) && redactKeys.length > 0 ? $b9cc6960093b095e$var$redactConfig(config, redactKeys) : (0, $adReO.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$b9cc6960093b095e$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$b9cc6960093b095e$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$b9cc6960093b095e$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$b9cc6960093b095e$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$b9cc6960093b095e$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$b9cc6960093b095e$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$b9cc6960093b095e$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$b9cc6960093b095e$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$b9cc6960093b095e$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$b9cc6960093b095e$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$b9cc6960093b095e$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $b9cc6960093b095e$export$2e2bcd8739ae039 = $b9cc6960093b095e$var$AxiosError;

});
parcelRegister("ha7aM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7e8ef3e2bb241a6$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $hMzvi = parcelRequire("hMzvi");

var $kFIA2 = parcelRequire("kFIA2");
'use strict';
const $c7e8ef3e2bb241a6$var$$internals = Symbol('internals');
function $c7e8ef3e2bb241a6$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c7e8ef3e2bb241a6$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $adReO.default).isArray(value) ? value.map($c7e8ef3e2bb241a6$var$normalizeValue) : (0, $kFIA2.sanitizeHeaderValue)(String(value));
}
function $c7e8ef3e2bb241a6$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c7e8ef3e2bb241a6$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $c7e8ef3e2bb241a6$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $c7e8ef3e2bb241a6$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $c7e8ef3e2bb241a6$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $c7e8ef3e2bb241a6$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(0, equals));
        if (!$c7e8ef3e2bb241a6$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $c7e8ef3e2bb241a6$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $c7e8ef3e2bb241a6$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $c7e8ef3e2bb241a6$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c7e8ef3e2bb241a6$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $adReO.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $adReO.default).isString(value)) return;
    if ((0, $adReO.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $adReO.default).isRegExp(filter)) return filter.test(value);
}
function $c7e8ef3e2bb241a6$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c7e8ef3e2bb241a6$var$buildAccessors(obj, header) {
    const accessorName = (0, $adReO.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c7e8ef3e2bb241a6$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $adReO.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c7e8ef3e2bb241a6$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $adReO.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $adReO.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $adReO.default).isString(header) && (header = header.trim()) && !$c7e8ef3e2bb241a6$var$isValidHeaderName(header)) setHeaders((0, $hMzvi.default)(header), valueOrRewrite);
        else if ((0, $adReO.default).isObject(header) && (0, $adReO.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $adReO.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $adReO.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $adReO.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $adReO.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c7e8ef3e2bb241a6$var$parseTokens(value);
                if ((0, $adReO.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $adReO.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $c7e8ef3e2bb241a6$var$normalizeHeader(header);
        if (header) {
            const key = (0, $adReO.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $adReO.default).findKey(self, _header);
                if (key && (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $adReO.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c7e8ef3e2bb241a6$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $adReO.default).forEach(this, (value, header)=>{
            const key = (0, $adReO.default).findKey(headers, header);
            if (key) {
                self[key] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c7e8ef3e2bb241a6$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c7e8ef3e2bb241a6$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $adReO.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $adReO.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $adReO.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $c7e8ef3e2bb241a6$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c7e8ef3e2bb241a6$var$$internals] = this[$c7e8ef3e2bb241a6$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c7e8ef3e2bb241a6$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c7e8ef3e2bb241a6$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $adReO.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c7e8ef3e2bb241a6$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $adReO.default).reduceDescriptors($c7e8ef3e2bb241a6$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $adReO.default).freezeMethods($c7e8ef3e2bb241a6$var$AxiosHeaders);
var $c7e8ef3e2bb241a6$export$2e2bcd8739ae039 = $c7e8ef3e2bb241a6$var$AxiosHeaders;

});
parcelRegister("hMzvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf2275aca40d6d88$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $cf2275aca40d6d88$var$ignoreDuplicateOf = (0, $adReO.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $cf2275aca40d6d88$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $adReO.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $adReO.default).hasOwnProp($cf2275aca40d6d88$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("kFIA2", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $f0ca37af3d81c31b$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $f0ca37af3d81c31b$export$c30c72bb7e677d54; });

var $adReO = parcelRequire("adReO");
'use strict';
function $f0ca37af3d81c31b$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $f0ca37af3d81c31b$var$sanitizeValue(value, invalidChars) {
    if ((0, $adReO.default).isArray(value)) return value.map((item)=>$f0ca37af3d81c31b$var$sanitizeValue(item, invalidChars));
    return $f0ca37af3d81c31b$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $f0ca37af3d81c31b$export$9e344cffce061a22 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $f0ca37af3d81c31b$export$59dd66c2a12d8f62 = (value)=>$f0ca37af3d81c31b$var$sanitizeValue(value, $f0ca37af3d81c31b$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $f0ca37af3d81c31b$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $adReO.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $f0ca37af3d81c31b$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("4htkn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31df7fcb8acaa73a$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $31df7fcb8acaa73a$export$2e2bcd8739ae039 = null;

});




parcelRegister("khPLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec4d8e24b0699790$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
'use strict';
const $ec4d8e24b0699790$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $ec4d8e24b0699790$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $ec4d8e24b0699790$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
function $ec4d8e24b0699790$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $ec4d8e24b0699790$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $ec4d8e24b0699790$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$ec4d8e24b0699790$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$ec4d8e24b0699790$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$ec4d8e24b0699790$var$$internals];
        $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
        const entry = internals.handlerEntries.get(id);
        if (entry) {
            internals.handlerEntries.delete(id);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $ec4d8e24b0699790$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $ec4d8e24b0699790$var$syncHandlerEntries(this, this[$ec4d8e24b0699790$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$ec4d8e24b0699790$var$$internals];
        $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $adReO.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $ec4d8e24b0699790$var$syncHandlerEntries(this, internals);
                $ec4d8e24b0699790$var$trimHandlers(this.handlers);
                internals.handlersLength = $ec4d8e24b0699790$var$countHandlers(this.handlers);
            }
        }
    }
}
var $ec4d8e24b0699790$export$2e2bcd8739ae039 = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a98a53c8a75f9db0$export$2e2bcd8739ae039; });

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $ef5jC = parcelRequire("ef5jC");

var $lb2qV = parcelRequire("lb2qV");

var $ha7aM = parcelRequire("ha7aM");

var $gv9ju = parcelRequire("gv9ju");

var $adReO = parcelRequire("adReO");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $lb2qV.default)(null, config);
}
function $a98a53c8a75f9db0$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $adReO.default).toSafeFlatObject(_config);
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    config.headers = (0, $ha7aM.default).from((0, $adReO.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $15ANS.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $gv9ju.default).getAdapter(config.adapter || (0, $ef5jC.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $15ANS.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $ha7aM.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $4IsRW.default)(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $15ANS.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $ha7aM.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("15ANS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cb2ce7608ace114$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ef5jC = parcelRequire("ef5jC");

var $ha7aM = parcelRequire("ha7aM");
'use strict';
function $0cb2ce7608ace114$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $ef5jC.default);
    const context = response || config;
    const headers = (0, $ha7aM.default).from(context.headers);
    let data = context.data;
    (0, $adReO.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("ef5jC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5e696f232d0dc12$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $aP7qx = parcelRequire("aP7qx");

var $29a93 = parcelRequire("29a93");

var $kKiHJ = parcelRequire("kKiHJ");

var $lsAph = parcelRequire("lsAph");

var $3aVh3 = parcelRequire("3aVh3");

var $hxzPz = parcelRequire("hxzPz");
'use strict';
const $a5e696f232d0dc12$var$own = (obj, key)=>obj != null && (0, $adReO.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $adReO.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $adReO.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $a5e696f232d0dc12$var$defaults = {
    transitional: (0, $aP7qx.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $adReO.default).isObject(data);
            if (isObjectPayload && (0, $adReO.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $adReO.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $3aVh3.default)(data)) : data;
            if ((0, $adReO.default).isArrayBuffer(data) || (0, $adReO.default).isBuffer(data) || (0, $adReO.default).isStream(data) || (0, $adReO.default).isFile(data) || (0, $adReO.default).isBlob(data) || (0, $adReO.default).isReadableStream(data)) return data;
            if ((0, $adReO.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $adReO.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $a5e696f232d0dc12$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $kKiHJ.default)(data, formSerializer).toString();
                if ((isFileList = (0, $adReO.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $a5e696f232d0dc12$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $29a93.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $a5e696f232d0dc12$var$own(this, 'transitional') || $a5e696f232d0dc12$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $a5e696f232d0dc12$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $adReO.default).isResponse(data) || (0, $adReO.default).isReadableStream(data)) return data;
            if (data && (0, $adReO.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $a5e696f232d0dc12$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $fX03H.default).from(e, (0, $fX03H.default).ERR_BAD_RESPONSE, this, null, $a5e696f232d0dc12$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $lsAph.default).classes.FormData,
        Blob: (0, $lsAph.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $adReO.default).forEach((0, $hxzPz.default), (method)=>{
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
var $a5e696f232d0dc12$export$2e2bcd8739ae039 = $a5e696f232d0dc12$var$defaults;

});
parcelRegister("aP7qx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e146da7bba06216$export$2e2bcd8739ae039; });
'use strict';
var $7e146da7bba06216$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};

});

parcelRegister("kKiHJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1a69cd24a140b61$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $29a93 = parcelRequire("29a93");

var $lsAph = parcelRequire("lsAph");
'use strict';
function $f1a69cd24a140b61$export$2e2bcd8739ae039(data, options) {
    return (0, $29a93.default)(data, new (0, $lsAph.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $lsAph.default).isNode && (0, $adReO.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("lsAph", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9f874191f496b63$export$2e2bcd8739ae039; });

var $jB9at = parcelRequire("jB9at");

var $2nF2h = parcelRequire("2nF2h");
var $f9f874191f496b63$export$2e2bcd8739ae039 = {
    ...$2nF2h,
    ...(0, $jB9at.default)
};

});
parcelRegister("jB9at", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4489594588108ef$export$2e2bcd8739ae039; });

var $de9wd = parcelRequire("de9wd");

var $1U9sr = parcelRequire("1U9sr");

var $8FSfW = parcelRequire("8FSfW");
var $e4489594588108ef$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $de9wd.default,
        FormData: $1U9sr.default,
        Blob: $8FSfW.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("de9wd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a13f762833a66d0$export$2e2bcd8739ae039; });

var $dWNM1 = parcelRequire("dWNM1");
'use strict';
var $9a13f762833a66d0$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $dWNM1.default);

});

parcelRegister("1U9sr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16325b87e107b4bc$export$2e2bcd8739ae039; });
'use strict';
var $16325b87e107b4bc$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("8FSfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $650c3d387ae3fbd4$export$2e2bcd8739ae039; });
'use strict';
var $650c3d387ae3fbd4$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("2nF2h", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $1bbd8fa0325c4f9a$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $1bbd8fa0325c4f9a$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $1bbd8fa0325c4f9a$export$f710a83a91838a36; });
const $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $1bbd8fa0325c4f9a$export$c0bcc9250309d66 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && (!$1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($1bbd8fa0325c4f9a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $1bbd8fa0325c4f9a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $1bbd8fa0325c4f9a$export$f710a83a91838a36 = $1bbd8fa0325c4f9a$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("3aVh3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24febbb5d340c733$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $29a93 = parcelRequire("29a93");
'use strict';
const $24febbb5d340c733$var$MAX_DEPTH = (0, $29a93.DEFAULT_FORM_DATA_MAX_DEPTH);
function $24febbb5d340c733$var$throwIfDepthExceeded(index) {
    if (index > $24febbb5d340c733$var$MAX_DEPTH) throw new (0, $fX03H.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $24febbb5d340c733$var$MAX_DEPTH, (0, $fX03H.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $24febbb5d340c733$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $24febbb5d340c733$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $24febbb5d340c733$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $24febbb5d340c733$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $24febbb5d340c733$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $adReO.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $adReO.default).hasOwnProp(target, name)) target[name] = (0, $adReO.default).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $adReO.default).hasOwnProp(target, name) || !(0, $adReO.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $adReO.default).isArray(target[name])) target[name] = $24febbb5d340c733$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $adReO.default).isFormData(formData) && (0, $adReO.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $adReO.default).forEachEntry(formData, (name, value)=>{
            buildPath($24febbb5d340c733$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $24febbb5d340c733$export$2e2bcd8739ae039 = $24febbb5d340c733$var$formDataToJSON;

});

parcelRegister("hxzPz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc515000d05f04f4$export$2e2bcd8739ae039; });
'use strict';
const $cc515000d05f04f4$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $cc515000d05f04f4$export$2e2bcd8739ae039 = $cc515000d05f04f4$var$methodList;

});



parcelRegister("4IsRW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36f1aa490c1da053$export$2e2bcd8739ae039; });
'use strict';
function $36f1aa490c1da053$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("lb2qV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6ac833a4b31e3dc$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");
'use strict';
class $f6ac833a4b31e3dc$var$CanceledError extends (0, $fX03H.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $fX03H.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $f6ac833a4b31e3dc$export$2e2bcd8739ae039 = $f6ac833a4b31e3dc$var$CanceledError;

});

parcelRegister("gv9ju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c036c406f3928265$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $4htkn = parcelRequire("4htkn");

var $3PMHb = parcelRequire("3PMHb");

var $gFb9g = parcelRequire("gFb9g");

var $fX03H = parcelRequire("fX03H");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $c036c406f3928265$var$knownAdapters = {
    http: (0, $4htkn.default),
    xhr: (0, $3PMHb.default),
    fetch: {
        get: $gFb9g.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $adReO.default).forEach($c036c406f3928265$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $c036c406f3928265$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $c036c406f3928265$var$isResolvedHandle = (adapter)=>(0, $adReO.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $c036c406f3928265$var$getAdapter(adapters, config) {
    adapters = (0, $adReO.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$c036c406f3928265$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $c036c406f3928265$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $fX03H.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $adReO.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($c036c406f3928265$var$renderReason).join('\n') : ' ' + $c036c406f3928265$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $fX03H.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $fX03H.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $c036c406f3928265$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $c036c406f3928265$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $c036c406f3928265$var$knownAdapters
};

});
parcelRegister("3PMHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cabe869ce51dbf6$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $aP7qx = parcelRequire("aP7qx");

var $fX03H = parcelRequire("fX03H");

var $lb2qV = parcelRequire("lb2qV");

var $1pP5g = parcelRequire("1pP5g");

var $41as5 = parcelRequire("41as5");

var $lsAph = parcelRequire("lsAph");

var $ha7aM = parcelRequire("ha7aM");

var $j5Ofq = parcelRequire("j5Ofq");

var $f73QF = parcelRequire("f73QF");

var $kFIA2 = parcelRequire("kFIA2");
const $2cabe869ce51dbf6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $2cabe869ce51dbf6$export$2e2bcd8739ae039 = $2cabe869ce51dbf6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f73QF.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $ha7aM.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $41as5.default)((0, $1pP5g.default)(_config.url)) || (0, $41as5.default)((0, $lsAph.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $fX03H.default)('Request aborted', (0, $fX03H.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $ha7aM.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $3PfpF.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $fX03H.default)('Request aborted', (0, $fX03H.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $fX03H.default)(msg, (0, $fX03H.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $aP7qx.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $fX03H.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $fX03H.default).ETIMEDOUT : (0, $fX03H.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $adReO.default).forEach((0, $kFIA2.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $adReO.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $j5Ofq.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $j5Ofq.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $lb2qV.default)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $41as5.default)(_config.url);
        if (protocol && !(0, $lsAph.default).protocols.includes(protocol)) {
            reject(new (0, $fX03H.default)('Unsupported protocol ' + protocol + ':', (0, $fX03H.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c92173995cdc070$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");
'use strict';
function $2c92173995cdc070$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $fX03H.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $fX03H.default).ERR_BAD_REQUEST : (0, $fX03H.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("1pP5g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $107fc072507f4068$export$2e2bcd8739ae039; });
'use strict';
const $107fc072507f4068$var$urlParserControlCharacters = /[\t\n\r]/g;
function $107fc072507f4068$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($107fc072507f4068$var$urlParserControlCharacters, '');
}

});

parcelRegister("41as5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecf5cf4c0202afd$export$2e2bcd8739ae039; });
'use strict';
function $2ecf5cf4c0202afd$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}

});

parcelRegister("j5Ofq", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $de65761df8a598af$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $de65761df8a598af$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $de65761df8a598af$export$5d35863c355a22a9; });

var $ikQjh = parcelRequire("ikQjh");

var $7nR3y = parcelRequire("7nR3y");

var $adReO = parcelRequire("adReO");
const $de65761df8a598af$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $ikQjh.default)(50, 250);
    return (0, $7nR3y.default)((e)=>{
        if (!e || !(0, $adReO.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $de65761df8a598af$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $de65761df8a598af$export$5d35863c355a22a9 = (fn, scheduler = (0, $adReO.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("ikQjh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d592abf0a04957f1$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $d592abf0a04957f1$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $d592abf0a04957f1$export$2e2bcd8739ae039 = $d592abf0a04957f1$var$speedometer;

});

parcelRegister("7nR3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5603d643a9d93c92$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $5603d643a9d93c92$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $5603d643a9d93c92$export$2e2bcd8739ae039 = $5603d643a9d93c92$var$throttle;

});


parcelRegister("f73QF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b00a7ead3edff84a$export$2e2bcd8739ae039; });

var $lsAph = parcelRequire("lsAph");

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $besJL = parcelRequire("besJL");

var $79n0f = parcelRequire("79n0f");

var $40T1q = parcelRequire("40T1q");

var $5f6d7 = parcelRequire("5f6d7");

var $ha7aM = parcelRequire("ha7aM");

var $3VlFm = parcelRequire("3VlFm");

var $6nvAH = parcelRequire("6nvAH");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $b00a7ead3edff84a$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $b00a7ead3edff84a$var$resolveConfig(config) {
    const newConfig = (0, $5f6d7.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $adReO.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $ha7aM.default).from(headers);
    newConfig.url = (0, $6nvAH.default)((0, $40T1q.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $adReO.default).getSafeProp(auth, 'username') || '';
        const password = (0, $adReO.default).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $b00a7ead3edff84a$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $fX03H.default).from(e, (0, $fX03H.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $adReO.default).isFormData(data)) {
        const getHeaders = (0, $adReO.default).getSafeProp(data, 'getHeaders');
        if ((0, $lsAph.default).hasStandardBrowserEnv || (0, $lsAph.default).hasStandardBrowserWebWorkerEnv || (0, $adReO.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $adReO.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $3VlFm.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $lsAph.default).hasStandardBrowserEnv) {
        if ((0, $adReO.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $besJL.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $79n0f.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $b00a7ead3edff84a$export$2e2bcd8739ae039 = $b00a7ead3edff84a$var$resolveConfig;

});
parcelRegister("besJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82d74b1a5a0a01da$export$2e2bcd8739ae039; });

var $lsAph = parcelRequire("lsAph");
var $82d74b1a5a0a01da$export$2e2bcd8739ae039 = (0, $lsAph.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $lsAph.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $lsAph.default).origin), (0, $lsAph.default).navigator && /(msie|trident)/i.test((0, $lsAph.default).navigator.userAgent)) : ()=>true;

});

parcelRegister("79n0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $534b3794da5c002d$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $lsAph = parcelRequire("lsAph");
var $534b3794da5c002d$export$2e2bcd8739ae039 = (0, $lsAph.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $adReO.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $adReO.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $adReO.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $adReO.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("40T1q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ec1d7b86495f966$export$2e2bcd8739ae039; });

var $fX03H = parcelRequire("fX03H");

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");

var $1pP5g = parcelRequire("1pP5g");
'use strict';
const $2ec1d7b86495f966$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $2ec1d7b86495f966$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $fX03H.REDACTED}`;
    });
}
function $2ec1d7b86495f966$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $fX03H.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $fX03H.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$2ec1d7b86495f966$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $2ec1d7b86495f966$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $1pP5g.default)(url);
        if ($2ec1d7b86495f966$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $fX03H.default)(`Invalid URL ${JSON.stringify($2ec1d7b86495f966$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $fX03H.default).ERR_INVALID_URL, config);
    }
}
function $2ec1d7b86495f966$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $2ec1d7b86495f966$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $1yk63.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $2ec1d7b86495f966$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $l45Ly.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("1yk63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12188e34b7070552$export$2e2bcd8739ae039; });
'use strict';
function $12188e34b7070552$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("l45Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f55e71b6c54c4376$export$2e2bcd8739ae039; });
'use strict';
function $f55e71b6c54c4376$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("5f6d7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d132bbf7812485b$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");

var $ha7aM = parcelRequire("ha7aM");
'use strict';
const $3d132bbf7812485b$var$headersToObject = (thing)=>thing instanceof (0, $ha7aM.default) ? {
        ...thing
    } : thing;
const $3d132bbf7812485b$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $3d132bbf7812485b$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $adReO.default).isPlainObject(target) && (0, $adReO.default).isPlainObject(source)) return (0, $adReO.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $adReO.default).isPlainObject(source)) return (0, $adReO.default).merge({}, source);
        else if ((0, $adReO.default).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $adReO.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $adReO.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $adReO.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $adReO.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $adReO.default).isUndefined(transitional2)) {
            if ((0, $adReO.default).isPlainObject(transitional2)) {
                if ((0, $adReO.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $adReO.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $adReO.default).isPlainObject(transitional1) && (0, $adReO.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $adReO.default).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $adReO.default).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutErrorMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($3d132bbf7812485b$var$headersToObject(a), $3d132bbf7812485b$var$headersToObject(b), prop, true)
    };
    (0, $adReO.default).forEach($3d132bbf7812485b$var$ownEnumerableKeys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $adReO.default).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $adReO.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $adReO.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $adReO.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $adReO.default).hasOwnProp(config2, 'validateStatus') && (0, $adReO.default).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $adReO.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});

parcelRegister("3VlFm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2db7806979b02fe9$export$2e2bcd8739ae039; });
'use strict';
const $2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $2db7806979b02fe9$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2db7806979b02fe9$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("gFb9g", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $c2191f87f9ef3849$export$3105c6651375d4fa; });

var $lsAph = parcelRequire("lsAph");

var $adReO = parcelRequire("adReO");

var $fX03H = parcelRequire("fX03H");

var $8tBgw = parcelRequire("8tBgw");

var $h0KLB = parcelRequire("h0KLB");

var $ha7aM = parcelRequire("ha7aM");

var $j5Ofq = parcelRequire("j5Ofq");

var $f73QF = parcelRequire("f73QF");

var $3PfpF = parcelRequire("3PfpF");

var $hoon5 = parcelRequire("hoon5");

var $cR4ZD = parcelRequire("cR4ZD");

var $kFIA2 = parcelRequire("kFIA2");
const $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE = 65536;
const $c2191f87f9ef3849$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $c2191f87f9ef3849$var$isFunction } = (0, $adReO.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $c2191f87f9ef3849$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $c2191f87f9ef3849$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $adReO.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $c2191f87f9ef3849$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $c2191f87f9ef3849$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $c2191f87f9ef3849$var$factory = (env)=>{
    const globalObject = (0, $adReO.default).global !== undefined && (0, $adReO.default).global !== null ? (0, $adReO.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $adReO.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $c2191f87f9ef3849$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $c2191f87f9ef3849$var$isFunction(Request);
    const isResponseSupported = $c2191f87f9ef3849$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $c2191f87f9ef3849$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $lsAph.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $c2191f87f9ef3849$var$test(()=>(0, $adReO.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $fX03H.default)(`Response type '${type}' is not supported`, (0, $fX03H.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $adReO.default).isBlob(body)) return body.size;
        if ((0, $adReO.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, $lsAph.default).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $adReO.default).isArrayBufferView(body) || (0, $adReO.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $adReO.default).isURLSearchParams(body)) body = body + '';
        if ((0, $adReO.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $adReO.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $f73QF.default)(config);
        const hasMaxContentLength = (0, $adReO.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $adReO.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $adReO.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $8tBgw.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $fX03H.default)('Request body larger than maxBodyLength limit', (0, $fX03H.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $adReO.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $adReO.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($c2191f87f9ef3849$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $lsAph.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $c2191f87f9ef3849$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($c2191f87f9ef3849$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $hoon5.default)(url);
                if (estimated > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $adReO.default).isReadableStream(data) || (0, $adReO.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $h0KLB.trackStream)(stream, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $adReO.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $j5Ofq.progressEventDecorator)(requestContentLength, (0, $j5Ofq.progressEventReducer)((0, $j5Ofq.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $fX03H.default)('Stream request bodies are not supported by the current fetch implementation', (0, $fX03H.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $adReO.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $adReO.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $cR4ZD.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $kFIA2.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $adReO.default).forEach($c2191f87f9ef3849$var$DEFAULT_REQUEST_OPTIONS, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $ha7aM.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $adReO.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $adReO.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $j5Ofq.progressEventDecorator)(responseContentLength, (0, $j5Ofq.progressEventReducer)((0, $j5Ofq.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $h0KLB.trackStream)(response.body, $c2191f87f9ef3849$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $adReO.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $fX03H.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $fX03H.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $3PfpF.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $ha7aM.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $fX03H.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $fX03H.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $fX03H.default)('Network Error', (0, $fX03H.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $fX03H.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $c2191f87f9ef3849$var$seedCache = new Map();
const $c2191f87f9ef3849$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $c2191f87f9ef3849$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $c2191f87f9ef3849$var$factory(env));
        map = target;
    }
    return target;
};
const $c2191f87f9ef3849$var$adapter = $c2191f87f9ef3849$export$3105c6651375d4fa();
var $c2191f87f9ef3849$export$2e2bcd8739ae039 = $c2191f87f9ef3849$var$adapter;

});
parcelRegister("8tBgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62bdf0498e608a4a$export$2e2bcd8739ae039; });

var $lb2qV = parcelRequire("lb2qV");

var $fX03H = parcelRequire("fX03H");

var $adReO = parcelRequire("adReO");
const $62bdf0498e608a4a$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $fX03H.default) ? err : new (0, $lb2qV.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $fX03H.default)(`timeout of ${timeout}ms exceeded`, (0, $fX03H.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $adReO.default).asap(unsubscribe);
    return signal;
};
var $62bdf0498e608a4a$export$2e2bcd8739ae039 = $62bdf0498e608a4a$var$composeSignals;

});

parcelRegister("h0KLB", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $c626b6acbc30fe14$export$b0119225647bd83; });
const $c626b6acbc30fe14$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c626b6acbc30fe14$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c626b6acbc30fe14$var$readStream(iterable))yield* $c626b6acbc30fe14$export$71b051935044bd5d(chunk, chunkSize);
};
const $c626b6acbc30fe14$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c626b6acbc30fe14$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c626b6acbc30fe14$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("hoon5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca979531ea712187$export$2e2bcd8739ae039; });
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $ca979531ea712187$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $ca979531ea712187$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 1)) && $ca979531ea712187$var$isHexDigit(str.charCodeAt(i + 2));
const $ca979531ea712187$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $ca979531ea712187$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $ca979531ea712187$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $ca979531ea712187$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $ca979531ea712187$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $ca979531ea712187$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            code = $ca979531ea712187$var$hexValue(body.charCodeAt(i + 1)) * 16 + $ca979531ea712187$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($ca979531ea712187$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$ca979531ea712187$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $ca979531ea712187$var$estimateBase64BufferAllocation(body);
    return $ca979531ea712187$var$base64Bytes(significant);
};
const $ca979531ea712187$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $ca979531ea712187$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $ca979531ea712187$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $ca979531ea712187$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $ca979531ea712187$var$estimatePercentDecodedBase64Bytes);
}
function $ca979531ea712187$export$1f39e64b554a246f(url) {
    return $ca979531ea712187$var$estimateDataURLBytes(url, $ca979531ea712187$var$estimateBase64BufferAllocation);
}

});

parcelRegister("cR4ZD", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $95be4ecd446de127$export$a4ad2735b021c132; });
const $95be4ecd446de127$export$a4ad2735b021c132 = "1.20.0";

});




parcelRegister("2iR5D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad671c27810423e$export$2e2bcd8739ae039; });

var $cR4ZD = parcelRequire("cR4ZD");

var $fX03H = parcelRequire("fX03H");
'use strict';
const $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $cR4ZD.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $fX03H.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $fX03H.default).ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$1ad671c27810423e$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $fX03H.default)('options must be an object', (0, $fX03H.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $fX03H.default)('option ' + opt + ' must be ' + result, (0, $fX03H.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $fX03H.default)('Unknown option ' + opt, (0, $fX03H.default).ERR_BAD_OPTION);
    }
}
var $1ad671c27810423e$export$2e2bcd8739ae039 = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});


parcelRegister("kZZD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4994f37c883aea2$export$2e2bcd8739ae039; });

var $lb2qV = parcelRequire("lb2qV");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $f4994f37c883aea2$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $lb2qV.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $f4994f37c883aea2$export$2e2bcd8739ae039 = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8145c4b68bfee186$export$2e2bcd8739ae039; });
'use strict';
function $8145c4b68bfee186$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("kgiwQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec03acb464b74212$export$2e2bcd8739ae039; });

var $adReO = parcelRequire("adReO");
'use strict';
function $ec03acb464b74212$export$2e2bcd8739ae039(payload) {
    return (0, $adReO.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("ewGK1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9353565c2e0947e$export$2e2bcd8739ae039; });
const $a9353565c2e0947e$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($a9353565c2e0947e$var$HttpStatusCode).forEach(([key, value])=>{
    if ($a9353565c2e0947e$var$HttpStatusCode[value] === undefined) $a9353565c2e0947e$var$HttpStatusCode[value] = key;
});
var $a9353565c2e0947e$export$2e2bcd8739ae039 = $a9353565c2e0947e$var$HttpStatusCode;

});



parcelRegister("dRarR", function(module, exports) {

$parcel$export(module.exports, "REACT_APP_AUTH_CLIENTID", function () { return $f45e698c9811d3f6$export$86418af64495c91a; });
$parcel$export(module.exports, "REACT_APP_AUTH_AUTHORITY", function () { return $f45e698c9811d3f6$export$b63d04bf2b883c66; });
$parcel$export(module.exports, "REACT_APP_AUTH_REDIRECT_URI", function () { return $f45e698c9811d3f6$export$aa4512a2f7b5b6e0; });
$parcel$export(module.exports, "REACT_APP_AUTH_SCOPE", function () { return $f45e698c9811d3f6$export$1a1ec953b528f792; });
$parcel$export(module.exports, "REACT_APP_BACKENDURL", function () { return $f45e698c9811d3f6$export$5e6c164a709aa411; });
$parcel$export(module.exports, "REACT_APP_CRYSTALURL", function () { return $f45e698c9811d3f6$export$287d2823a454ef64; });
$parcel$export(module.exports, "REACT_APP_STAGE", function () { return $f45e698c9811d3f6$export$b3fcf1fbd33113a9; });
$parcel$export(module.exports, "STYLES_TO_CLEAN", function () { return $f45e698c9811d3f6$export$6766f11fcfb1e821; });
$parcel$export(module.exports, "STYLES_TO_DELETE", function () { return $f45e698c9811d3f6$export$577164c20d9bfb9e; });
const $f45e698c9811d3f6$export$86418af64495c91a = "__REACT_APP_AUTH_CLIENTID__";
const $f45e698c9811d3f6$export$b63d04bf2b883c66 = "__REACT_APP_AUTH_AUTHORITY__";
const $f45e698c9811d3f6$export$aa4512a2f7b5b6e0 = "__REACT_APP_AUTH_REDIRECT_URI__";
const $f45e698c9811d3f6$export$1a1ec953b528f792 = "__REACT_APP_AUTH_SCOPE__";
const $f45e698c9811d3f6$export$5e6c164a709aa411 = "__REACT_APP_BACKENDURL__";
const $f45e698c9811d3f6$export$287d2823a454ef64 = "__REACT_APP_CRYSTALURL__";
const $f45e698c9811d3f6$export$b3fcf1fbd33113a9 = "__REACT_APP_STAGE__";
const $f45e698c9811d3f6$export$6766f11fcfb1e821 = [
    "Optional",
    "OptionalLocked"
];
const $f45e698c9811d3f6$export$577164c20d9bfb9e = [
    "Notes"
];

});

parcelRegister("cP50D", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $955e22349e6523b5$export$882461b6382ed46c; }, function (v) { return $955e22349e6523b5$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $955e22349e6523b5$export$757ceba2d55c277e; }, function (v) { return $955e22349e6523b5$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $955e22349e6523b5$export$83d89fbfd8236492; }, function (v) { return $955e22349e6523b5$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $955e22349e6523b5$export$882461b6382ed46c;
var $955e22349e6523b5$export$757ceba2d55c277e;
var $955e22349e6523b5$export$83d89fbfd8236492;
"use strict";



(function() {
    function findHook(fiber, id) {
        for(fiber = fiber.memoizedState; null !== fiber && 0 < id;)fiber = fiber.next, id--;
        return fiber;
    }
    function copyWithSetImpl(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) console.warn("copyWithRename() expects paths of the same length");
        else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                console.warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
        }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        index + 1 === oldPath.length ? (updated[newPath[index]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    }
    function copyWithDeleteImpl(obj, path, index) {
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    }
    function shouldSuspendImpl() {
        return !1;
    }
    function shouldErrorImpl() {
        return null;
    }
    function warnInvalidHookAccess() {
        console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
    }
    function warnInvalidContextAccess() {
        console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }
    function noop() {}
    function warnForMissingKey() {}
    function setToSortedString(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    }
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function scheduleRoot(root, element) {
        root.context === emptyContextObject && (updateContainerImpl(root.current, 2, element, root, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root, update) {
        if (null !== resolveFamily) {
            var staleFamilies = update.staleFamilies;
            update = update.updatedFamilies;
            flushPendingEffects();
            scheduleFibersWithFamiliesRecursively(root.current, update, staleFamilies);
            flushSyncWork$1();
        }
    }
    function setRefreshHandler(handler) {
        resolveFamily = handler;
    }
    function isValidContainer(node) {
        return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
        for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
        for(; node.return;)node = node.return;
        return 3 === node.tag ? fiber : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (13 === fiber.tag) {
            var suspenseState = fiber.memoizedState;
            null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
            if (null !== suspenseState) return suspenseState.dehydrated;
        }
        return null;
    }
    function getActivityInstanceFromFiber(fiber) {
        if (31 === fiber.tag) {
            var activityState = fiber.memoizedState;
            null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
            if (null !== activityState) return activityState.dehydrated;
        }
        return null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error("Unable to find node on an unmounted component.");
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, _child = parentA.child; _child;){
                    if (_child === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    for(_child = parentB.child; _child;){
                        if (_child === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (3 !== a.tag) throw Error("Unable to find node on an unmounted component.");
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function traverseFragmentInstancesAndTextInstances(fragmentFiber, fn, a, b, c) {
        traverseVisibleInstancesAndTextInstances(fragmentFiber.child, !1, fn, a, b, c);
    }
    function traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
        for(; null !== child;){
            if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
            child = child.sibling;
        }
        return !1;
    }
    function getFragmentParentInstanceOrContainerFiber(fiber) {
        for(fiber = fiber.return; null !== fiber;){
            if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
            fiber = fiber.return;
        }
        return null;
    }
    function fiberIsPortaledIntoHost(fiber) {
        var foundPortalParent = !1;
        for(fiber = fiber.return; null !== fiber;){
            4 === fiber.tag && (foundPortalParent = !0);
            if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
            fiber = fiber.return;
        }
        return foundPortalParent;
    }
    function getFragmentInstanceOrTextInstanceSiblings(fiber) {
        var result = [
            null,
            null
        ], parentHostFiber = getFragmentParentInstanceOrContainerFiber(fiber);
        if (null === parentHostFiber) return result;
        findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
            foundSelf: !1
        });
        return result;
    }
    function findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
        for(; null !== child;){
            if (child === self) state.foundSelf = !0;
            else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
                if (state.foundSelf) return result[1] = child, !0;
                result[0] = child;
            } else if ((22 !== child.tag || null === child.memoizedState) && findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
            child = child.sibling;
        }
        return !1;
    }
    function getInstanceFromHostFiber(fiber) {
        switch(fiber.tag){
            case 5:
            case 27:
            case 6:
                return fiber.stateNode;
            case 3:
                return fiber.stateNode.containerInfo;
            default:
                throw Error("Expected to find a host node. This is a bug in React.");
        }
    }
    function isFiberPrecedingCheck(child, target, boundary) {
        return child === boundary ? !0 : child === target ? (searchTarget = child, !0) : !1;
    }
    function isFiberFollowingCheck(child, target, boundary) {
        return child === boundary ? (searchBoundary = child, !1) : child === target ? (null !== searchBoundary && (searchTarget = child), !0) : !1;
    }
    function getParentForFragmentAncestors(inst) {
        if (null === inst) return null;
        do inst = null === inst ? null : inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
        return inst ? inst : null;
    }
    function getLowestCommonAncestor(instA, instB, getParent) {
        for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
        tempA = 0;
        for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
        for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
        for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
        for(; depthA--;){
            if (instA === instB || null !== instB && instA === instB.alternate) return instA;
            instA = getParent(instA);
            instB = getParent(instB);
        }
        return null;
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
            case REACT_VIEW_TRANSITION_TYPE:
                return "ViewTransition";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getComponentNameFromOwner(owner) {
        return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
        var type = fiber.type;
        switch(fiber.tag){
            case 31:
                return "Activity";
            case 24:
                return "Cache";
            case 9:
                return (type._context.displayName || "Context") + ".Consumer";
            case 10:
                return type.displayName || "Context";
            case 18:
                return "DehydratedFragment";
            case 11:
                return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 26:
            case 27:
            case 5:
                return type;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return getComponentNameFromType(type);
            case 8:
                return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
            case 22:
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
                break;
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 30:
                return "ViewTransition";
            case 1:
            case 0:
            case 14:
            case 15:
                if ("function" === typeof type) return type.displayName || type.name || null;
                if ("string" === typeof type) return type;
                break;
            case 29:
                type = fiber._debugInfo;
                if (null != type) {
                    for(var i = type.length - 1; 0 <= i; i--)if ("string" === typeof type[i].name) return type[i].name;
                }
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value, fiber) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        fiberStack[index$jscomp$0] = fiber;
        cursor.current = value;
    }
    function requiredContext(c) {
        null === c && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor, null, fiber);
        var nextRootContext = nextRootInstance.nodeType;
        switch(nextRootContext){
            case 9:
            case 11:
                nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
                nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
                break;
            default:
                if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(nextRootInstance, nextRootContext);
                else switch(nextRootContext){
                    case "svg":
                        nextRootInstance = HostContextNamespaceSvg;
                        break;
                    case "math":
                        nextRootInstance = HostContextNamespaceMath;
                        break;
                    default:
                        nextRootInstance = HostContextNamespaceNone;
                }
        }
        nextRootContext = nextRootContext.toLowerCase();
        nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
        nextRootContext = {
            context: nextRootInstance,
            ancestorInfo: nextRootContext
        };
        pop(contextStackCursor, fiber);
        push(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
        var stateHook = fiber.memoizedState;
        null !== stateHook && (HostTransitionContext._currentValue = stateHook.memoizedState, push(hostTransitionProviderCursor, fiber, fiber));
        stateHook = requiredContext(contextStackCursor.current);
        var type = fiber.type;
        var nextContext = getChildHostContextProd(stateHook.context, type);
        type = updatedAncestorInfoDev(stateHook.ancestorInfo, type);
        nextContext = {
            context: nextContext,
            ancestorInfo: type
        };
        stateHook !== nextContext && (push(contextFiberStackCursor, fiber, fiber), push(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {}
    function disableLogs() {
        if (0 === disabledDepth) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
                configurable: !0,
                enumerable: !0,
                value: disabledLog,
                writable: !0
            };
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (0 === disabledDepth) {
            var props = {
                configurable: !0,
                enumerable: !0,
                writable: !0
            };
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        }
        0 > disabledDepth && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    function formatOwnerStack(error) {
        var prevPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        error = error.stack;
        Error.prepareStackTrace = prevPrepareStackTrace;
        error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
        prevPrepareStackTrace = error.indexOf("\n");
        -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
        prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
        -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf("\n", prevPrepareStackTrace));
        if (-1 !== prevPrepareStackTrace) error = error.slice(0, prevPrepareStackTrace);
        else return "";
        return error;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (void 0 !== frame) return frame;
        reentry = !0;
        frame = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher = null;
        previousDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = null;
        disableLogs();
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$0) {
                                    control = x$0;
                                }
                                Fake = !1;
                                try {
                                    var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                    Object.defineProperty(fn.prototype, "props", {
                                        configurable: !0,
                                        set: function() {
                                            throw Error();
                                        }
                                    });
                                    Fake = !0;
                                    new fn();
                                } finally{
                                    Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                                }
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$1) {
                                control = x$1;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                for(; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes("DetermineComponentFrameRoot");)_RunInRootFrame$Deter++;
                if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length) for(namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter];)_RunInRootFrame$Deter--;
                for(; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                        do if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                            var _frame = "\n" + sampleLines[namePropDescriptor].replace(" at new ", " at ");
                            fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                            "function" === typeof fn && componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                        while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame;
        }
        sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
        "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
        return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return describeNativeComponentFrame(fiber.type, !1);
            case 11:
                return describeNativeComponentFrame(fiber.type.render, !1);
            case 1:
                return describeNativeComponentFrame(fiber.type, !0);
            case 31:
                return describeBuiltInComponentFrame("Activity");
            case 30:
                return describeBuiltInComponentFrame("ViewTransition");
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "", previous = null;
            do {
                info += describeFiber(workInProgress, previous);
                var debugInfo = workInProgress._debugInfo;
                if (debugInfo) for(var i = debugInfo.length - 1; 0 <= i; i--){
                    var entry = debugInfo[i];
                    if ("string" === typeof entry.name) {
                        var JSCompiler_temp_const = info;
                        a: {
                            var name = entry.name, env = entry.env, location = entry.debugLocation;
                            if (null != location) {
                                var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                                if (-1 !== lastLine.indexOf(name)) {
                                    var JSCompiler_inline_result = "\n" + lastLine;
                                    break a;
                                }
                            }
                            JSCompiler_inline_result = describeBuiltInComponentFrame(name + (env ? " [" + env + "]" : ""));
                        }
                        info = JSCompiler_temp_const + JSCompiler_inline_result;
                    }
                }
                previous = workInProgress;
                workInProgress = workInProgress.return;
            }while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
        return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (null === current) return null;
        var owner = current._debugOwner;
        return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
        if (null === current) return "";
        var workInProgress = current;
        try {
            var info = "";
            6 === workInProgress.tag && (workInProgress = workInProgress.return);
            switch(workInProgress.tag){
                case 26:
                case 27:
                case 5:
                    info += describeBuiltInComponentFrame(workInProgress.type);
                    break;
                case 13:
                    info += describeBuiltInComponentFrame("Suspense");
                    break;
                case 19:
                    info += describeBuiltInComponentFrame("SuspenseList");
                    break;
                case 31:
                    info += describeBuiltInComponentFrame("Activity");
                    break;
                case 30:
                    info += describeBuiltInComponentFrame("ViewTransition");
                    break;
                case 0:
                case 15:
                case 1:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type));
                    break;
                case 11:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type.render));
            }
            for(; workInProgress;)if ("number" === typeof workInProgress.tag) {
                var fiber = workInProgress;
                workInProgress = fiber._debugOwner;
                var debugStack = fiber._debugStack;
                if (workInProgress && debugStack) {
                    var formattedStack = formatOwnerStack(debugStack);
                    "" !== formattedStack && (info += "\n" + formattedStack);
                }
            } else if (null != workInProgress.debugStack) {
                var ownerStack = workInProgress.debugStack;
                (workInProgress = workInProgress.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
            } else break;
            var JSCompiler_inline_result = info;
        } catch (x) {
            JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
        var previousFiber = current;
        setCurrentFiber(fiber);
        try {
            return null !== fiber && fiber._debugTask ? fiber._debugTask.run(callback.bind(null, arg0, arg1, arg2, arg3, arg4)) : callback(arg0, arg1, arg2, arg3, arg4);
        } finally{
            setCurrentFiber(previousFiber);
        }
        throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
    }
    function setCurrentFiber(fiber) {
        ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
        isRendering = !1;
        current = fiber;
    }
    function typeName(value) {
        return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
        try {
            return testStringCoercion(value), !1;
        } catch (e) {
            return !0;
        }
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", attributeName, typeName(value)), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", propName, typeName(value)), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", typeName(value)), testStringCoercion(value);
    }
    function injectInternals(internals) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) return !0;
        if (!hook.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
        try {
            rendererID = hook.inject(internals), injectedHook = hook;
        } catch (err) {
            console.error("React instrumentation encountered an error: %o.", err);
        }
        return hook.checkDCE ? !0 : !1;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return lanes & -lanes;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), lanes;
        }
    }
    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
        root = root.warmLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function getEntangledLanes(root, renderLanes) {
        0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
        var allEntangledLanes = root.entangledLanes;
        if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
            var index = 31 - clz32(allEntangledLanes), lane = 1 << index;
            renderLanes |= root[index];
            allEntangledLanes &= ~lane;
        }
        return renderLanes;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return currentTime + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), -1;
        }
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index = 31 - clz32(remainingLanes), lane = 1 << index;
            entanglements[index] = 0;
            expirationTimes[index] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index] = null, index = 0; index < hiddenUpdatesForLane.length; index++){
                var update = hiddenUpdatesForLane[index];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index = 31 - clz32(rootEntangledLanes), lane = 1 << index;
            lane & entangledLanes | root[index] & entangledLanes && (root[index] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = renderLanes & -renderLanes;
        renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
        return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
        switch(lane){
            case 2:
                lane = 1;
                break;
            case 8:
                lane = 4;
                break;
            case 32:
                lane = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                lane = 128;
                break;
            case 268435456:
                lane = 134217728;
                break;
            default:
                lane = 0;
        }
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (isDevToolsPresent) for(root = root.pendingUpdatersLaneMap; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            root[index].add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (isDevToolsPresent) for(var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap, memoizedUpdaters = root.memoizedUpdaters; 0 < lanes;){
            var index = 31 - clz32(lanes);
            root = 1 << index;
            index = pendingUpdatersLaneMap[index];
            0 < index.size && (index.forEach(function(fiber) {
                var alternate = fiber.alternate;
                null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
            }), index.clear());
            lanes &= ~root;
        }
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 0 !== DiscreteEventPriority && DiscreteEventPriority < lanes ? 0 !== ContinuousEventPriority && ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
        var updatePriority = ReactDOMSharedInternals.p;
        if (0 !== updatePriority) return updatePriority;
        updatePriority = window.event;
        return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            return ReactDOMSharedInternals.p = priority, fn();
        } finally{
            ReactDOMSharedInternals.p = previousPriority;
        }
    }
    function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
        var targetInst;
        if (targetInst = targetNode[internalInstanceKey]) return targetInst;
        for(var parentNode = targetNode.parentNode; parentNode;){
            if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
                parentNode = targetInst.alternate;
                if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                    if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                    targetNode = getParentHydrationBoundary(targetNode);
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    function getInstanceFromNode(node) {
        if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
            var tag = node.tag;
            if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
        }
        return null;
    }
    function getNodeFromInstance(inst) {
        var tag = inst.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root) {
        var resources = root[internalRootNodeResourcesKey];
        resources || (resources = root[internalRootNodeResourcesKey] = {
            hoistableStyles: new Map(),
            hoistableScripts: new Map()
        });
        return resources;
    }
    function markNodeAsHoistable(node) {
        node[internalHoistableMarker] = !0;
    }
    function clearPendingLoadOnNode(node) {
        node[internalLoadPendingKey] = void 0;
    }
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        registrationNameDependencies[registrationName] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
        for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
    }
    function checkControlledValueProps(tagName, props) {
        hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || null == props.value || ("select" === tagName ? console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.") : console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."));
        props.onChange || props.readOnly || props.disabled || null == props.checked || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
        illegalAttributeNameCache[attributeName] = !0;
        console.error("Invalid attribute name: `%s`", attributeName);
        return !1;
    }
    function pushMutationContext() {
        var prev = viewTransitionMutationContext;
        viewTransitionMutationContext = !1;
        return prev;
    }
    function getValueForAttributeOnCustomComponent(node, name, expected) {
        if (isAttributeNameSafe(name)) {
            if (!node.hasAttribute(name)) {
                switch(typeof expected){
                    case "symbol":
                    case "object":
                        return expected;
                    case "function":
                        return expected;
                    case "boolean":
                        if (!1 === expected) return expected;
                }
                return void 0 === expected ? void 0 : null;
            }
            node = "nonce" === name.toLowerCase() ? node.nonce : node.getAttribute(name);
            if ("" === node && !0 === expected) return !0;
            checkAttributeStringCoercion(expected, name);
            return node === "" + expected ? expected : node;
        }
    }
    function setValueForAttribute(node, name, value) {
        if (isAttributeNameSafe(name)) {
            if (null === value) node.removeAttribute(name);
            else {
                switch(typeof value){
                    case "undefined":
                    case "function":
                    case "symbol":
                        node.removeAttribute(name);
                        return;
                    case "boolean":
                        var prefix = name.toLowerCase().slice(0, 5);
                        if ("data-" !== prefix && "aria-" !== prefix) {
                            node.removeAttribute(name);
                            return;
                        }
                }
                checkAttributeStringCoercion(value, name);
                node.setAttribute(name, value);
            }
        }
    }
    function setValueForKnownAttribute(node, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttribute(name, value);
        }
    }
    function setValueForNamespacedAttribute(node, namespace, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttributeNS(namespace, name, value);
        }
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                return checkFormFieldValueStringCoercion(value), value;
            default:
                return "";
        }
    }
    function isCheckable(elem) {
        var type = elem.type;
        return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
            var get = descriptor.get, set = descriptor.set;
            Object.defineProperty(node, valueField, {
                configurable: !0,
                get: function() {
                    return get.call(this);
                },
                set: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                    set.call(this, value);
                }
            });
            Object.defineProperty(node, valueField, {
                enumerable: descriptor.enumerable
            });
            return {
                getValue: function() {
                    return currentValue;
                },
                setValue: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                },
                stopTracking: function() {
                    node._valueTracker = null;
                    delete node[valueField];
                }
            };
        }
    }
    function track(node) {
        if (!node._valueTracker) {
            var valueField = isCheckable(node) ? "checked" : "value";
            node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
        }
    }
    function updateValueIfChanged(node) {
        if (!node) return !1;
        var tracker = node._valueTracker;
        if (!tracker) return !0;
        var lastValue = tracker.getValue();
        var value = "";
        node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
        node = value;
        return node !== lastValue ? (tracker.setValue(node), !0) : !1;
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
        return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
            return "\\" + ch.charCodeAt(0).toString(16) + " ";
        });
    }
    function validateInputProps(element, props) {
        void 0 === props.checked || void 0 === props.defaultChecked || didWarnCheckedDefaultChecked || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnCheckedDefaultChecked = !0);
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue$1 || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnValueDefaultValue$1 = !0);
    }
    function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
        element.name = "";
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element.type = type) : element.removeAttribute("type");
        if (null != value) {
            if ("number" === type) {
                if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
            } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
        } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
        null != value ? "number" === type && element.value == value ? setDefaultValue(element, getToStringValue(element.value)) : setDefaultValue(element, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
        null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
        null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? (checkAttributeStringCoercion(name, "name"), element.name = "" + getToStringValue(name)) : element.removeAttribute("name");
    }
    function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element.type = type);
        if (null != value || null != defaultValue) {
            if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
                track(element);
                return;
            }
            defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
            value = null != value ? "" + getToStringValue(value) : defaultValue;
            isHydrating || value === element.value || (element.value = value);
            element.defaultValue = value;
        }
        checked = null != checked ? checked : defaultChecked;
        checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
        element.checked = isHydrating ? element.checked : !!checked;
        element.defaultChecked = !!checked;
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (checkAttributeStringCoercion(name, "name"), element.name = name);
        track(element);
    }
    function setDefaultValue(node, value) {
        node.defaultValue !== "" + value && (node.defaultValue = "" + value);
    }
    function validateOptionProps(element, props) {
        null == props.value && ("object" === typeof props.children && null !== props.children ? React.Children.forEach(props.children, function(child) {
            null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
        }) : null == props.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")));
        null == props.selected || didWarnSelectedSetOnOption || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), didWarnSelectedSetOnOption = !0);
    }
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        node = node.options;
        if (multiple) {
            multiple = {};
            for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
            for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
        } else {
            propValue = "" + getToStringValue(propValue);
            multiple = null;
            for(i = 0; i < node.length; i++){
                if (node[i].value === propValue) {
                    node[i].selected = !0;
                    setDefaultSelected && (node[i].defaultSelected = !0);
                    return;
                }
                null !== multiple || node[i].disabled || (multiple = node[i]);
            }
            null !== multiple && (multiple.selected = !0);
        }
    }
    function validateSelectProps(element, props) {
        for(element = 0; element < valuePropNames.length; element++){
            var propName = valuePropNames[element];
            if (null != props[propName]) {
                var propNameIsArray = isArrayImpl(props[propName]);
                props.multiple && !propNameIsArray ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum()) : !props.multiple && propNameIsArray && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
            }
        }
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), didWarnValueDefaultValue = !0);
    }
    function validateTextareaProps(element, props) {
        void 0 === props.value || void 0 === props.defaultValue || didWarnValDefaultVal || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component"), didWarnValDefaultVal = !0);
        null != props.children && null == props.value && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
    }
    function updateTextarea(element, value, defaultValue) {
        if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
            element.defaultValue !== value && (element.defaultValue = value);
            return;
        }
        element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    }
    function initTextarea(element, value, defaultValue, children) {
        if (null == value) {
            if (null != children) {
                if (null != defaultValue) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArrayImpl(children)) {
                    if (1 < children.length) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            null == defaultValue && (defaultValue = "");
            value = defaultValue;
        }
        defaultValue = getToStringValue(value);
        element.defaultValue = defaultValue;
        children = element.textContent;
        children === defaultValue && "" !== children && null !== children && (element.value = children);
        track(element);
    }
    function findNotableNode(node, indent) {
        return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent ? findNotableNode(node.children[0], indent) : node;
    }
    function indentation(indent) {
        return "  " + "  ".repeat(indent);
    }
    function added(indent) {
        return "+ " + "  ".repeat(indent);
    }
    function removed(indent) {
        return "- " + "  ".repeat(indent);
    }
    function describeFiberType(fiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return fiber.type;
            case 16:
                return "Lazy";
            case 31:
                return "Activity";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 0:
            case 15:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            case 11:
                return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
            case 1:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            default:
                return null;
        }
    }
    function describeTextNode(content, maxLength) {
        return needsEscaping.test(content) ? (content = JSON.stringify(content), content.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content.slice(0, maxLength - 7) + '..."}' : "{" + content + "}") : content.length > maxLength ? 5 > maxLength ? '{"..."}' : content.slice(0, maxLength - 3) + "..." : content;
    }
    function describeTextDiff(clientText, serverProps, indent) {
        var maxLength = 120 - 2 * indent;
        if (null === serverProps) return added(indent) + describeTextNode(clientText, maxLength) + "\n";
        if ("string" === typeof serverProps) {
            for(var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++);
            firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
            return added(indent) + describeTextNode(clientText, maxLength) + "\n" + removed(indent) + describeTextNode(serverProps, maxLength) + "\n";
        }
        return indentation(indent) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object) {
        return Object.prototype.toString.call(object).replace(/^\[object (.*)\]$/, function(m, p0) {
            return p0;
        });
    }
    function describeValue(value, maxLength) {
        switch(typeof value){
            case "string":
                return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
            case "object":
                if (null === value) return "null";
                if (isArrayImpl(value)) return "[...]";
                if (value.$$typeof === REACT_ELEMENT_TYPE) return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
                var name = objectName(value);
                if ("Object" === name) {
                    name = "";
                    maxLength -= 2;
                    for(var propName in value)if (value.hasOwnProperty(propName)) {
                        var jsonPropName = JSON.stringify(propName);
                        jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                        maxLength -= propName.length - 2;
                        jsonPropName = describeValue(value[propName], 15 > maxLength ? maxLength : 15);
                        maxLength -= jsonPropName.length;
                        if (0 > maxLength) {
                            name += "" === name ? "..." : ", ...";
                            break;
                        }
                        name += ("" === name ? "" : ",") + propName + ":" + jsonPropName;
                    }
                    return "{" + name + "}";
                }
                return name;
            case "function":
                return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
            default:
                return String(value);
        }
    }
    function describePropValue(value, maxLength) {
        return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props, rowPrefix) {
        var remainingRowLength = 120 - rowPrefix.length - type.length, properties = [], propName;
        for(propName in props)if (props.hasOwnProperty(propName) && "children" !== propName) {
            var propValue = describePropValue(props[propName], 120 - rowPrefix.length - propName.length - 1);
            remainingRowLength -= propName.length + propValue.length + 2;
            properties.push(propName + "=" + propValue);
        }
        return 0 === properties.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent) {
        var properties = "", remainingServerProperties = assign({}, serverObject), propName;
        for(propName in clientObject)if (clientObject.hasOwnProperty(propName)) {
            delete remainingServerProperties[propName];
            var maxLength = 120 - 2 * indent - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
            serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties += added(indent) + propName + ": " + clientPropValue + "\n", properties += removed(indent) + propName + ": " + maxLength + "\n") : properties += added(indent) + propName + ": " + clientPropValue + "\n";
        }
        for(var _propName in remainingServerProperties)remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(remainingServerProperties[_propName], 120 - 2 * indent - _propName.length - 2), properties += removed(indent) + _propName + ": " + clientObject + "\n");
        return properties;
    }
    function describeElementDiff(type, clientProps, serverProps, indent) {
        var content = "", serverPropNames = new Map();
        for(propName$jscomp$0 in serverProps)serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(propName$jscomp$0.toLowerCase(), propName$jscomp$0);
        if (1 === serverPropNames.size && serverPropNames.has("children")) content += describeExpandedElement(type, clientProps, indentation(indent));
        else {
            for(var _propName2 in clientProps)if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
                var maxLength$jscomp$0 = 120 - 2 * (indent + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
                if (void 0 !== serverPropName) {
                    serverPropNames.delete(_propName2.toLowerCase());
                    var propName$jscomp$0 = clientProps[_propName2];
                    serverPropName = serverProps[serverPropName];
                    var clientPropValue = describePropValue(propName$jscomp$0, maxLength$jscomp$0);
                    maxLength$jscomp$0 = describePropValue(serverPropName, maxLength$jscomp$0);
                    "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content += indentation(indent + 1) + _propName2 + "={{\n" + describePropertiesDiff(propName$jscomp$0, serverPropName, indent + 2) + indentation(indent + 1) + "}}\n" : (content += added(indent + 1) + _propName2 + "=" + clientPropValue + "\n", content += removed(indent + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
                } else content += indentation(indent + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
            }
            serverPropNames.forEach(function(propName) {
                if ("children" !== propName) {
                    var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
                    content += removed(indent + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
                }
            });
            content = "" === content ? indentation(indent) + "<" + type + ">\n" : indentation(indent) + "<" + type + "\n" + content + indentation(indent) + ">\n";
        }
        type = serverProps.children;
        clientProps = clientProps.children;
        if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
            serverPropNames = "";
            if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) serverPropNames = "" + clientProps;
            content += describeTextDiff(serverPropNames, "" + type, indent + 1);
        } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) content = null == type ? content + describeTextDiff("" + clientProps, null, indent + 1) : content + describeTextDiff("" + clientProps, void 0, indent + 1);
        return content;
    }
    function describeSiblingFiber(fiber, indent) {
        var type = describeFiberType(fiber);
        if (null === type) {
            type = "";
            for(fiber = fiber.child; fiber;)type += describeSiblingFiber(fiber, indent), fiber = fiber.sibling;
            return type;
        }
        return indentation(indent) + "<" + type + ">\n";
    }
    function describeNode(node, indent) {
        var skipToNode = findNotableNode(node, indent);
        if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode)) return indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1);
        skipToNode = "";
        var debugInfo = node.fiber._debugInfo;
        if (debugInfo) for(var i = 0; i < debugInfo.length; i++){
            var serverComponentName = debugInfo[i].name;
            "string" === typeof serverComponentName && (skipToNode += indentation(indent) + "<" + serverComponentName + ">\n", indent++);
        }
        debugInfo = "";
        i = node.fiber.pendingProps;
        if (6 === node.fiber.tag) debugInfo = describeTextDiff(i, node.serverProps, indent), indent++;
        else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName) {
            if (void 0 === node.serverProps) {
                debugInfo = indent;
                var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content = "";
                for(propName in i)if (i.hasOwnProperty(propName) && "children" !== propName) {
                    var propValue = describePropValue(i[propName], 15);
                    maxLength -= propName.length + propValue.length + 2;
                    if (0 > maxLength) {
                        content += " ...";
                        break;
                    }
                    content += " " + propName + "=" + propValue;
                }
                debugInfo = indentation(debugInfo) + "<" + serverComponentName + content + ">\n";
                indent++;
            } else null === node.serverProps ? (debugInfo = describeExpandedElement(serverComponentName, i, added(indent)), indent++) : "string" === typeof node.serverProps ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (debugInfo = describeElementDiff(serverComponentName, i, node.serverProps, indent), indent++);
        }
        var propName = "";
        i = node.fiber.child;
        for(serverComponentName = 0; i && serverComponentName < node.children.length;)maxLength = node.children[serverComponentName], maxLength.fiber === i ? (propName += describeNode(maxLength, indent), serverComponentName++) : propName += describeSiblingFiber(i, indent), i = i.sibling;
        i && 0 < node.children.length && (propName += indentation(indent) + "...\n");
        i = node.serverTail;
        null === node.serverProps && indent--;
        for(node = 0; node < i.length; node++)serverComponentName = i[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent) + describeTextNode(serverComponentName, 120 - 2 * indent) + "\n") : propName + describeExpandedElement(serverComponentName.type, serverComponentName.props, removed(indent));
        return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
        try {
            return "\n\n" + describeNode(rootNode, 0);
        } catch (x) {
            return "";
        }
    }
    function describeAncestors(ancestor, child, props) {
        for(var fiber = child, node = null, distanceFromLeaf = 0; fiber;)fiber === ancestor && (distanceFromLeaf = 0), node = {
            fiber: fiber,
            children: null !== node ? [
                node
            ] : [],
            serverProps: fiber === child ? props : fiber === ancestor ? null : void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
        return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfoDev), info = {
            tag: tag
        };
        -1 !== inScopeTags.indexOf(tag) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
        -1 !== buttonScopeTags.indexOf(tag) && (ancestorInfo.pTagInButtonScope = null);
        -1 !== specialTags.indexOf(tag) && "address" !== tag && "div" !== tag && "p" !== tag && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
        ancestorInfo.current = info;
        "form" === tag && (ancestorInfo.formTag = info);
        "a" === tag && (ancestorInfo.aTagInScope = info);
        "button" === tag && (ancestorInfo.buttonTagInScope = info);
        "nobr" === tag && (ancestorInfo.nobrTagInScope = info);
        "p" === tag && (ancestorInfo.pTagInButtonScope = info);
        "li" === tag && (ancestorInfo.listItemTagAutoclosing = info);
        if ("dd" === tag || "dt" === tag) ancestorInfo.dlItemTagAutoclosing = info;
        "#document" === tag || "html" === tag ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
        null !== oldInfo || "#document" !== tag && "html" !== tag && "body" !== tag ? !0 === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = !1) : ancestorInfo.implicitRootScope = !0;
        return ancestorInfo;
    }
    function isTagValidWithParent(tag, parentTag, implicitRootScope) {
        switch(parentTag){
            case "tr":
                return "th" === tag || "td" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "tbody":
            case "thead":
            case "tfoot":
                return "tr" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "colgroup":
                return "col" === tag || "template" === tag;
            case "table":
                return "caption" === tag || "colgroup" === tag || "tbody" === tag || "tfoot" === tag || "thead" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "head":
                return "base" === tag || "basefont" === tag || "bgsound" === tag || "link" === tag || "meta" === tag || "title" === tag || "noscript" === tag || "noframes" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "html":
                if (implicitRootScope) break;
                return "head" === tag || "body" === tag || "frameset" === tag;
            case "frameset":
                return "frame" === tag;
            case "#document":
                if (!implicitRootScope) return "html" === tag;
        }
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
            case "rp":
            case "rt":
                return -1 === impliedEndTags.indexOf(parentTag);
            case "caption":
            case "col":
            case "colgroup":
            case "input":
                return "select" !== parentTag;
            case "frameset":
            case "frame":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                return null == parentTag;
            case "head":
                return implicitRootScope || null === parentTag;
            case "html":
                return implicitRootScope && "#document" === parentTag || null === parentTag;
            case "body":
                return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
        }
        return !0;
    }
    function findInvalidAncestorForTag(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    }
    function findAncestor(parent, tagName) {
        for(; parent;){
            switch(parent.tag){
                case 5:
                case 26:
                case 27:
                    if (parent.type === tagName) return parent;
            }
            parent = parent.return;
        }
        return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
        var parentInfo = ancestorInfo.current;
        ancestorInfo = (parentInfo = isTagValidWithParent(childTag, parentInfo && parentInfo.tag, ancestorInfo.implicitRootScope) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        ancestorInfo = parentInfo || ancestorInfo;
        if (!ancestorInfo) return !0;
        var ancestorTag = ancestorInfo.tag;
        ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
        if (didWarn[ancestorInfo]) return !1;
        didWarn[ancestorInfo] = !0;
        var ancestor = (ancestorInfo = current) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
        parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error("In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, parentInfo, ancestorDescription)) : console.error("In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, ancestorDescription);
        ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
            console.error("<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.", ancestorTag, tagDisplayName);
        }));
        return !1;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
        if (implicitRootScope || isTagValidWithParent("#text", parentTag, !1)) return !0;
        implicitRootScope = "#text|" + parentTag;
        if (didWarn[implicitRootScope]) return !1;
        didWarn[implicitRootScope] = !0;
        var ancestor = (implicitRootScope = current) ? findAncestor(implicitRootScope, parentTag) : null;
        implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(ancestor, implicitRootScope, 6 !== implicitRootScope.tag ? {
            children: null
        } : null) : "";
        /\S/.test(childText) ? console.error("In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s", parentTag, implicitRootScope) : console.error("In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s", parentTag, implicitRootScope);
        return !1;
    }
    function setTextContent(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    }
    function camelize(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    }
    function setValueForStyle(style, styleName, value) {
        var isCustomProperty = 0 === styleName.indexOf("--");
        isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported style property %s. Did you mean %s?", styleName, camelize(styleName.replace(msPattern, "ms-")))) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", styleName, styleName.charAt(0).toUpperCase() + styleName.slice(1))) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = !0, console.error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', styleName, value.replace(badStyleValueWithSemicolonPattern, ""))), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", styleName)) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", styleName))));
        null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style[styleName] = ("" + value).trim()) : style[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
        if (null != styles && "object" !== typeof styles) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        styles && Object.freeze(styles);
        node = node.style;
        if (null != prevStyles) {
            if (styles) {
                var expandedUpdates = {};
                if (prevStyles) {
                    for(var key in prevStyles)if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key)) for(var longhands = shorthandToLonghand[key] || [
                        key
                    ], i = 0; i < longhands.length; i++)expandedUpdates[longhands[i]] = key;
                }
                for(var _key in styles)if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key])) for(key = shorthandToLonghand[_key] || [
                    _key
                ], longhands = 0; longhands < key.length; longhands++)expandedUpdates[key[longhands]] = _key;
                _key = {};
                for(var key$jscomp$0 in styles)for(key = shorthandToLonghand[key$jscomp$0] || [
                    key$jscomp$0
                ], longhands = 0; longhands < key.length; longhands++)_key[key[longhands]] = key$jscomp$0;
                key$jscomp$0 = {};
                for(var _key2 in expandedUpdates)if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i = key + "," + longhands, !key$jscomp$0[i])) {
                    key$jscomp$0[i] = !0;
                    i = console;
                    var value = styles[key];
                    i.error.call(i, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating", key, longhands);
                }
            }
            for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", viewTransitionMutationContext = !0);
            for(var _styleName in styles)_key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && (setValueForStyle(node, _styleName, _key2), viewTransitionMutationContext = !0);
        } else for(expandedUpdates in styles)styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
        if (-1 === tagName.indexOf("-")) return !1;
        switch(tagName){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    function getAttributeAlias(name) {
        return aliases.get(name) || name;
    }
    function validateProperty$1(tagName, name) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return !0;
        if (rARIACamel$1.test(name)) {
            tagName = "aria-" + name.slice(4).toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name), warnedProperties$1[name] = !0;
            if (name !== tagName) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0;
        }
        if (rARIA$1.test(name)) {
            tagName = name.toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return warnedProperties$1[name] = !0, !1;
            name !== tagName && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0);
        }
        return !0;
    }
    function validateProperties$2(type, props) {
        var invalidProps = [], key;
        for(key in props)validateProperty$1(type, key) || invalidProps.push(key);
        props = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === invalidProps.length ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type) : 1 < invalidProps.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type);
    }
    function validateProperty(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return !0;
        var lowerCasedName = name.toLowerCase();
        if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName) return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), warnedProperties[name] = !0;
        if ("function" === typeof value && ("form" === tagName && "action" === name || "input" === tagName && "formAction" === name || "button" === tagName && "formAction" === name)) return !0;
        if (null != eventRegistry) {
            tagName = eventRegistry.possibleRegistrationNames;
            if (eventRegistry.registrationNameDependencies.hasOwnProperty(name)) return !0;
            eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
            if (null != eventRegistry) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", name, eventRegistry), warnedProperties[name] = !0;
            if (EVENT_NAME_REGEX.test(name)) return console.error("Unknown event handler property `%s`. It will be ignored.", name), warnedProperties[name] = !0;
        } else if (EVENT_NAME_REGEX.test(name)) return INVALID_EVENT_NAME_REGEX.test(name) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name), warnedProperties[name] = !0;
        if (rARIA.test(name) || rARIACamel.test(name)) return !0;
        if ("innerhtml" === lowerCasedName) return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), warnedProperties[name] = !0;
        if ("aria" === lowerCasedName) return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), warnedProperties[name] = !0;
        if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value) return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value), warnedProperties[name] = !0;
        if ("number" === typeof value && isNaN(value)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name), warnedProperties[name] = !0;
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", name, lowerCasedName), warnedProperties[name] = !0;
        } else if (name !== lowerCasedName) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName), warnedProperties[name] = !0;
        switch(name){
            case "dangerouslySetInnerHTML":
            case "children":
            case "style":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                return !0;
            case "innerText":
            case "textContent":
                return !0;
        }
        switch(typeof value){
            case "boolean":
                switch(name){
                    case "autoFocus":
                    case "checked":
                    case "multiple":
                    case "muted":
                    case "selected":
                    case "contentEditable":
                    case "spellCheck":
                    case "draggable":
                    case "value":
                    case "autoReverse":
                    case "externalResourcesRequired":
                    case "focusable":
                    case "preserveAlpha":
                    case "allowFullScreen":
                    case "async":
                    case "autoPlay":
                    case "controls":
                    case "credentialless":
                    case "default":
                    case "defer":
                    case "disabled":
                    case "disablePictureInPicture":
                    case "disableRemotePlayback":
                    case "formNoValidate":
                    case "hidden":
                    case "loop":
                    case "noModule":
                    case "noValidate":
                    case "open":
                    case "playsInline":
                    case "readOnly":
                    case "required":
                    case "reversed":
                    case "scoped":
                    case "seamless":
                    case "itemScope":
                    case "capture":
                    case "download":
                    case "inert":
                        return !0;
                    default:
                        lowerCasedName = name.toLowerCase().slice(0, 5);
                        if ("data-" === lowerCasedName || "aria-" === lowerCasedName) return !0;
                        value ? console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name) : console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
                        return warnedProperties[name] = !0;
                }
            case "function":
            case "symbol":
                return warnedProperties[name] = !0, !1;
            case "string":
                if ("false" === value || "true" === value) {
                    switch(name){
                        case "checked":
                        case "selected":
                        case "multiple":
                        case "muted":
                        case "allowFullScreen":
                        case "async":
                        case "autoPlay":
                        case "controls":
                        case "credentialless":
                        case "default":
                        case "defer":
                        case "disabled":
                        case "disablePictureInPicture":
                        case "disableRemotePlayback":
                        case "formNoValidate":
                        case "hidden":
                        case "loop":
                        case "noModule":
                        case "noValidate":
                        case "open":
                        case "playsInline":
                        case "readOnly":
                        case "required":
                        case "reversed":
                        case "scoped":
                        case "seamless":
                        case "itemScope":
                        case "inert":
                            break;
                        default:
                            return !0;
                    }
                    console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
                    warnedProperties[name] = !0;
                }
        }
        return !0;
    }
    function warnUnknownProperties(type, props, eventRegistry) {
        var unknownProps = [], key;
        for(key in props)validateProperty(type, key, props[key], eventRegistry) || unknownProps.push(key);
        props = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === unknownProps.length ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type) : 1 < unknownProps.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type);
    }
    function sanitizeURL(url) {
        return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$1() {}
    function getEventTarget(nativeEvent) {
        nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
        nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
        return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);
        if (internalInstance && (target = internalInstance.stateNode)) {
            var props = target[internalPropsKey] || null;
            a: switch(target = internalInstance.stateNode, internalInstance.type){
                case "input":
                    updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                    internalInstance = props.name;
                    if ("radio" === props.type && null != internalInstance) {
                        for(props = target; props.parentNode;)props = props.parentNode;
                        checkAttributeStringCoercion(internalInstance, "name");
                        props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                            var otherNode = props[internalInstance];
                            if (otherNode !== target && otherNode.form === target.form) {
                                var otherProps = otherNode[internalPropsKey] || null;
                                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                                updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                            }
                        }
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                    }
                    break a;
                case "textarea":
                    updateTextarea(target, props.value, props.defaultValue);
                    break a;
                case "select":
                    internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
            }
        }
    }
    function batchedUpdates$1(fn, a, b) {
        if (isInsideEventHandler) return fn(a, b);
        isInsideEventHandler = !0;
        try {
            var JSCompiler_inline_result = fn(a);
            return JSCompiler_inline_result;
        } finally{
            if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
                if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
            }
        }
    }
    function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (null === stateNode) return null;
        var props = stateNode[internalPropsKey] || null;
        if (null === props) return null;
        stateNode = props[registrationName];
        a: switch(registrationName){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
                inst = !props;
                break a;
            default:
                inst = !1;
        }
        if (inst) return null;
        if (stateNode && "function" !== typeof stateNode) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type.");
        return stateNode;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
        for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
        return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
        var keyCode = nativeEvent.keyCode;
        "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
        10 === nativeEvent && (nativeEvent = 13);
        return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
        return !0;
    }
    function functionThatReturnsFalse() {
        return !1;
    }
    function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
            this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var event = this.nativeEvent;
                event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
            },
            persist: function() {},
            isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
        var nativeEvent = this.nativeEvent;
        return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
    }
    function getEventModifierState() {
        return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
            case "keydown":
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function getDataFromCustomEvent(nativeEvent) {
        nativeEvent = nativeEvent.detail;
        return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                if (nativeEvent.which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = !0;
                return SPACEBAR_CHAR;
            case "textInput":
                return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
            default:
                return null;
        }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
        switch(domEventName){
            case "paste":
                return null;
            case "keypress":
                if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                    if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                    if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
    }
    function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return !1;
        eventNameSuffix = "on" + eventNameSuffix;
        var isSupported = eventNameSuffix in document;
        isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
        return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
            target
        ] : restoreTarget = target;
        inst = accumulateTwoPhaseListeners(inst, "onChange");
        0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
            event: nativeEvent,
            listeners: inst
        }));
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
        activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
        if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
            var dispatchQueue = [];
            createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
            batchedUpdates$1(runEventInBatch, dispatchQueue);
        }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
        if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function getActiveElement(doc) {
        doc = doc || ("undefined" !== typeof document ? document : void 0);
        if ("undefined" === typeof doc) return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e$2) {
            return doc.body;
        }
    }
    function getLeafNode(node) {
        for(; node && node.firstChild;)node = node.firstChild;
        return node;
    }
    function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        root = 0;
        for(var nodeEnd; node;){
            if (3 === node.nodeType) {
                nodeEnd = root + node.textContent.length;
                if (root <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - root
                };
                root = nodeEnd;
            }
            a: {
                for(; node;){
                    if (node.nextSibling) {
                        node = node.nextSibling;
                        break a;
                    }
                    node = node.parentNode;
                }
                node = void 0;
            }
            node = getLeafNode(node);
        }
    }
    function containsNode(outerNode, innerNode) {
        return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
    }
    function getActiveElementDeep(containerInfo) {
        containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
        for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
            try {
                var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
            } catch (err) {
                JSCompiler_inline_result = !1;
            }
            if (JSCompiler_inline_result) containerInfo = element.contentWindow;
            else break;
            element = getActiveElement(containerInfo.document);
        }
        return element;
    }
    function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
        mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
            start: doc.selectionStart,
            end: doc.selectionEnd
        } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
            anchorNode: doc.anchorNode,
            anchorOffset: doc.anchorOffset,
            focusNode: doc.focusNode,
            focusOffset: doc.focusOffset
        }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
            event: nativeEvent,
            listeners: doc
        }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName], styleProp;
        for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function getViewTransitionName(props, instance) {
        if (null != props.name && "auto" !== props.name) return props.name;
        if (null !== instance.autoName) return instance.autoName;
        props = pendingEffectsRoot.identifierPrefix;
        var globalClientId = globalClientIdCounter$1++;
        props = "_" + props + "t_" + globalClientId.toString(32) + "_";
        return instance.autoName = props;
    }
    function getClassNameByType(classByType) {
        if (null == classByType || "string" === typeof classByType) return classByType;
        var className = null, activeTypes = pendingTransitionTypes;
        if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
            var match = classByType[activeTypes[i]];
            if (null != match) {
                if ("none" === match) return "none";
                className = null == className ? match : className + (" " + match);
            }
        }
        return null == className ? classByType.default : className;
    }
    function getViewTransitionClassName(defaultClass, eventClass) {
        defaultClass = getClassNameByType(defaultClass);
        eventClass = getClassNameByType(eventClass);
        return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
    }
    function getArrayKind(array) {
        for(var kind = EMPTY_ARRAY, i = 0; i < array.length && i < OBJECT_WIDTH_LIMIT; i++){
            var value = array[i];
            if ("object" === typeof value && null !== value) {
                if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
                    if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY) return COMPLEX_ARRAY;
                    kind = ENTRIES_ARRAY;
                } else return COMPLEX_ARRAY;
            } else {
                if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY || "bigint" === typeof value) return COMPLEX_ARRAY;
                kind = PRIMITIVE_ARRAY;
            }
        }
        return kind;
    }
    function addObjectToProperties(object, properties, indent, prefix) {
        if (!ArrayBuffer.isView(object)) {
            var addedProperties = 0, key;
            for(key in object)if (hasOwnProperty.call(object, key) && "_" !== key[0] && (addedProperties++, addValueToProperties(key, object[key], properties, indent, prefix), addedProperties >= OBJECT_WIDTH_LIMIT)) {
                properties.push([
                    prefix + "\u00a0\u00a0".repeat(indent) + "Only " + OBJECT_WIDTH_LIMIT + " properties are shown. React will not log more properties of this object.",
                    ""
                ]);
                break;
            }
        }
    }
    function readReactElementTypeof(value) {
        return "$$typeof" in value && hasOwnProperty.call(value, "$$typeof") ? value.$$typeof : void 0;
    }
    function addValueToProperties(propertyName, value, properties, indent, prefix) {
        switch(typeof value){
            case "object":
                if (null === value) {
                    value = "null";
                    break;
                } else {
                    if (readReactElementTypeof(value) === REACT_ELEMENT_TYPE) {
                        var typeName = getComponentNameFromType(value.type) || "\u2026", key = value.key;
                        value = value.props;
                        var propsKeys = Object.keys(value), propsLength = propsKeys.length;
                        if (null == key && 0 === propsLength) {
                            value = "<" + typeName + " />";
                            break;
                        }
                        if (3 > indent || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                            value = "<" + typeName + " \u2026 />";
                            break;
                        }
                        properties.push([
                            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                            "<" + typeName
                        ]);
                        null !== key && addValueToProperties("key", key, properties, indent + 1, prefix);
                        propertyName = !1;
                        key = 0;
                        for(var propKey in value)if (key++, "children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName = !0) : hasOwnProperty.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(propKey, value[propKey], properties, indent + 1, prefix), key >= OBJECT_WIDTH_LIMIT) break;
                        properties.push([
                            "",
                            propertyName ? ">\u2026</" + typeName + ">" : "/>"
                        ]);
                        return;
                    }
                    typeName = Object.prototype.toString.call(value);
                    typeName = typeName.slice(8, typeName.length - 1);
                    if (ArrayBuffer.isView(value)) {
                        value = value.length;
                        value = "number" === typeof value ? typeName + "(" + value + ")" : typeName;
                        break;
                    }
                    if ("Array" === typeName) {
                        if (propKey = value.length > OBJECT_WIDTH_LIMIT, key = getArrayKind(value), key === PRIMITIVE_ARRAY || key === EMPTY_ARRAY) {
                            value = JSON.stringify(propKey ? value.slice(0, OBJECT_WIDTH_LIMIT).concat("\u2026") : value);
                            break;
                        } else if (key === ENTRIES_ARRAY) {
                            properties.push([
                                prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                                ""
                            ]);
                            for(propertyName = 0; propertyName < value.length && propertyName < OBJECT_WIDTH_LIMIT; propertyName++)typeName = value[propertyName], addValueToProperties(typeName[0], typeName[1], properties, indent + 1, prefix);
                            propKey && addValueToProperties(OBJECT_WIDTH_LIMIT.toString(), "\u2026", properties, indent + 1, prefix);
                            return;
                        }
                    }
                    if ("Promise" === typeName) {
                        if ("fulfilled" === value.status) {
                            if (typeName = properties.length, addValueToProperties(propertyName, value.value, properties, indent, prefix), properties.length > typeName) {
                                properties = properties[typeName];
                                properties[1] = "Promise<" + (properties[1] || "Object") + ">";
                                return;
                            }
                        } else if ("rejected" === value.status && (typeName = properties.length, addValueToProperties(propertyName, value.reason, properties, indent, prefix), properties.length > typeName)) {
                            properties = properties[typeName];
                            properties[1] = "Rejected Promise<" + properties[1] + ">";
                            return;
                        }
                        properties.push([
                            "\u00a0\u00a0".repeat(indent) + propertyName,
                            "Promise"
                        ]);
                        return;
                    }
                    "Object" === typeName && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName = propKey.constructor.name);
                    properties.push([
                        prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                        "Object" === typeName ? 3 > indent ? "" : "\u2026" : typeName
                    ]);
                    3 > indent && addObjectToProperties(value, properties, indent + 1, prefix);
                    return;
                }
            case "function":
                value = value.name;
                value = "" === value || "string" !== typeof value ? "() => {}" : value + "() {}";
                break;
            case "string":
                value = value === OMITTED_PROP_ERROR ? "\u2026" : JSON.stringify(1024 <= value.length ? value.slice(0, 1023) + "\u2026" : value);
                break;
            case "undefined":
                value = "undefined";
                break;
            case "boolean":
                value = value ? "true" : "false";
                break;
            default:
                value = String(value);
        }
        properties.push([
            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
            value
        ]);
    }
    function addObjectDiffToProperties(prev, next, properties, indent) {
        var isDeeplyEqual = !0, prevPropertiesChecked = 0;
        for(key in prev){
            if (prevPropertiesChecked > OBJECT_WIDTH_LIMIT) {
                properties.push([
                    "Previous object has more than " + OBJECT_WIDTH_LIMIT + " properties. React will not attempt to diff objects with too many properties.",
                    ""
                ]);
                isDeeplyEqual = !1;
                break;
            }
            key in next || (properties.push([
                REMOVED + "\u00a0\u00a0".repeat(indent) + key,
                "\u2026"
            ]), isDeeplyEqual = !1);
            prevPropertiesChecked++;
        }
        prevPropertiesChecked = 0;
        for(var _key in next){
            if (prevPropertiesChecked > OBJECT_WIDTH_LIMIT) {
                properties.push([
                    "Next object has more than " + OBJECT_WIDTH_LIMIT + " properties. React will not attempt to diff objects with too many properties.",
                    ""
                ]);
                isDeeplyEqual = !1;
                break;
            }
            if (_key in prev) {
                var key = prev[_key];
                var nextValue = next[_key];
                if (key !== nextValue) {
                    if (0 === indent && "children" === _key) {
                        isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                        properties.push([
                            REMOVED + isDeeplyEqual,
                            "\u2026"
                        ], [
                            ADDED + isDeeplyEqual,
                            "\u2026"
                        ]);
                        isDeeplyEqual = !1;
                        continue;
                    }
                    if (!(3 <= indent)) {
                        if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && readReactElementTypeof(key) === readReactElementTypeof(nextValue)) {
                            if (readReactElementTypeof(nextValue) === REACT_ELEMENT_TYPE) {
                                if (key.type === nextValue.type && key.key === nextValue.key) {
                                    key = getComponentNameFromType(nextValue.type) || "\u2026";
                                    isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                                    key = "<" + key + " \u2026 />";
                                    properties.push([
                                        REMOVED + isDeeplyEqual,
                                        key
                                    ], [
                                        ADDED + isDeeplyEqual,
                                        key
                                    ]);
                                    isDeeplyEqual = !1;
                                    continue;
                                }
                            } else {
                                var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                                if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                                    prevKind = [
                                        UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                        "[object Array]" === nextKind ? "Array" : ""
                                    ];
                                    properties.push(prevKind);
                                    nextKind = properties.length;
                                    addObjectDiffToProperties(key, nextValue, properties, indent + 1) ? nextKind === properties.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = !1;
                                    continue;
                                }
                            }
                        } else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                            key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                            properties.push([
                                UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                key + " Referentially unequal function closure. Consider memoization."
                            ]);
                            continue;
                        }
                    }
                    addValueToProperties(_key, key, properties, indent, REMOVED);
                    addValueToProperties(_key, nextValue, properties, indent, ADDED);
                    isDeeplyEqual = !1;
                }
            } else properties.push([
                ADDED + "\u00a0\u00a0".repeat(indent) + _key,
                "\u2026"
            ]), isDeeplyEqual = !1;
            prevPropertiesChecked++;
        }
        return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
        currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime, endTime, trigger) {
        supportsUserTiming && (reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, trigger, reusableComponentOptions)) : performance.measure(trigger, reusableComponentOptions), performance.clearMeasures(trigger));
    }
    function logComponentReappeared(fiber, startTime, endTime) {
        logComponentTrigger(fiber, startTime, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime, endTime, wasHydrated, committedLanes) {
        var name = getComponentNameFromFiber(fiber);
        if (null !== name && supportsUserTiming) {
            var alternate = fiber.alternate, selfTime = fiber.actualDuration;
            if (null === alternate || alternate.child !== fiber.child) for(var child = fiber.child; null !== child; child = child.sibling)selfTime -= child.actualDuration;
            selfTime = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
            var props = fiber.memoizedProps;
            wasHydrated = fiber._debugTask;
            null !== props && null !== alternate && alternate.memoizedProps !== props ? (child = [
                reusableChangedPropsEntry
            ], props = addObjectDiffToProperties(alternate.memoizedProps, props, child, 0), 1 < child.length ? (props && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = !0, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = selfTime, reusableComponentDevToolDetails.tooltipText = name), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, fiber = "\u200b" + name, null != wasHydrated ? wasHydrated.run(performance.measure.bind(performance, fiber, reusableComponentOptions)) : performance.measure(fiber, reusableComponentOptions), performance.clearMeasures(fiber)) : null != wasHydrated ? wasHydrated.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime)) : null != wasHydrated ? wasHydrated.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime);
        }
    }
    function logComponentErrored(fiber, startTime, endTime, errors) {
        if (supportsUserTiming) {
            var name = getComponentNameFromFiber(fiber);
            if (null !== name) {
                for(var debugTask = null, properties = [], i = 0; i < errors.length; i++){
                    var capturedValue = errors[i];
                    null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
                    capturedValue = capturedValue.value;
                    properties.push([
                        "Error",
                        "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
                    ]);
                }
                null !== fiber.key && addValueToProperties("key", fiber.key, properties, 0, "");
                null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties, 0, "");
                null == debugTask && (debugTask = fiber._debugTask);
                fiber = {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            color: "error",
                            track: COMPONENTS_TRACK,
                            tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                            properties: properties
                        }
                    }
                };
                name = "\u200b" + name;
                debugTask ? debugTask.run(performance.measure.bind(performance, name, fiber)) : performance.measure(name, fiber);
                performance.clearMeasures(name);
            }
        }
    }
    function logComponentEffect(fiber, startTime, endTime, selfTime, errors) {
        if (null !== errors) {
            if (supportsUserTiming) {
                var name = getComponentNameFromFiber(fiber);
                if (null !== name) {
                    selfTime = [];
                    for(var i = 0; i < errors.length; i++){
                        var error = errors[i].value;
                        selfTime.push([
                            "Error",
                            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                        ]);
                    }
                    null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
                    null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
                    startTime = {
                        start: startTime,
                        end: endTime,
                        detail: {
                            devtools: {
                                color: "error",
                                track: COMPONENTS_TRACK,
                                tooltipText: "A lifecycle or effect errored",
                                properties: selfTime
                            }
                        }
                    };
                    fiber = fiber._debugTask;
                    endTime = "\u200b" + name;
                    fiber ? fiber.run(performance.measure.bind(performance, endTime, startTime)) : performance.measure(endTime, startTime);
                    performance.clearMeasures(endTime);
                }
            }
        } else name = getComponentNameFromFiber(fiber), null !== name && supportsUserTiming && (errors = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, errors)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, errors));
    }
    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error"));
    }
    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
    }
    function logCommitErrored(startTime, endTime, errors, passive, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            for(var properties = [], i = 0; i < errors.length; i++){
                var error = errors[i].value;
                properties.push([
                    "Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "error",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
                        properties: properties
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Errored", startTime)) : performance.measure("Errored", startTime);
            performance.clearMeasures("Errored");
        }
    }
    function logCommitPhase(startTime, endTime, errors, abortedViewTransition, debugTask) {
        null !== errors ? logCommitErrored(startTime, endTime, errors, !1, debugTask) : !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Commit Interrupted View Transition" : "Commit", startTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-dark")) : console.timeStamp(abortedViewTransition ? "Commit Interrupted View Transition" : "Commit", startTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-dark"));
    }
    function logAnimatingPhase(startTime, endTime, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
            update
        ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
        null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        for(var node = sourceFiber, parent = node.return; null !== parent;)null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
        return 3 === node.tag ? node.stateNode : null;
    }
    function resolveTypeForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (null === resolveFamily) return !1;
        var resolve = resolveFamily, prevType = fiber.elementType;
        element = element.type;
        var needsCompareFamilies = !1, $$typeofNextType = "object" === typeof element && null !== element ? element.$$typeof : null;
        switch(fiber.tag){
            case 1:
                "function" === typeof element && (needsCompareFamilies = !0);
                break;
            case 0:
                "function" === typeof element ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 11:
                $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 14:
            case 15:
                $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            default:
                return !1;
        }
        return needsCompareFamilies && (fiber = resolve(prevType), void 0 !== fiber && fiber === resolve(element)) ? !0 : !1;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        do {
            var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag = _fiber.tag, type = _fiber.type, elementType = _fiber.elementType, candidateType = null;
            _fiber = null;
            switch(tag){
                case 0:
                case 1:
                    candidateType = type;
                    break;
                case 15:
                    candidateType = type;
                    _fiber = elementType;
                    break;
                case 14:
                    _fiber = elementType;
                    break;
                case 11:
                    candidateType = type.render, _fiber = elementType;
            }
            if (null === resolveFamily) throw Error("Expected resolveFamily to be set during hot reload.");
            var resolve = resolveFamily;
            type = elementType = !1;
            null !== candidateType && (candidateType = resolve(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? type = !0 : updatedFamilies.has(candidateType) && (1 === tag ? type = !0 : elementType = !0)));
            type || null === _fiber || (tag = resolve(_fiber), void 0 !== tag && staleFamilies.has(tag) ? type = !0 : "object" === typeof _fiber && _fiber.$$typeof === REACT_LAZY_TYPE && (tag = _fiber._payload, 1 === tag._status && (tag = resolve(tag._result.default), void 0 !== tag && staleFamilies.has(tag) && (type = !0))));
            null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (type = !0);
            type && (fiber._debugNeedsRemount = !0);
            if (type || elementType) alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
            null === child || type || scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            if (null === sibling) break;
            fiber = sibling;
        }while (1);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
        this.actualDuration = -0;
        this.actualStartTime = -1.1;
        this.treeBaseDuration = this.selfBaseDuration = -0;
        this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
        this._debugNeedsRemount = !1;
        this._debugHookTypes = null;
        hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress._debugOwner = current._debugOwner, workInProgress._debugStack = current._debugStack, workInProgress._debugTask = current._debugTask, workInProgress._debugHookTypes = current._debugHookTypes, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.actualDuration = -0, workInProgress.actualStartTime = -1.1);
        workInProgress.flags = current.flags & 1206910976;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext,
            _debugThenableState: pendingProps._debugThenableState
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugInfo = current._debugInfo;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case 0:
            case 15:
            case 14:
            case 1:
            case 11:
                workInProgress.type = resolveTypeForHotReloading(current.type);
        }
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 1206910978;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null, workInProgress.selfBaseDuration = 0, workInProgress.treeBaseDuration = 0) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext,
            _debugThenableState: renderLanes._debugThenableState
        }, workInProgress.selfBaseDuration = current.selfBaseDuration, workInProgress.treeBaseDuration = current.treeBaseDuration);
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0;
        var resolvedType = resolveTypeForHotReloading(type);
        if ("function" === typeof resolvedType) shouldConstruct(resolvedType) && (fiberTag = 1);
        else if ("string" === typeof resolvedType) fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
        else a: switch(resolvedType){
            case REACT_ACTIVITY_TYPE:
                return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof type.id), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = {
                    effectDuration: 0,
                    passiveEffectDuration: 0
                }, key;
            case REACT_SUSPENSE_TYPE:
                return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
            case REACT_SUSPENSE_LIST_TYPE:
                return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
            case REACT_LEGACY_HIDDEN_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
                return type = mode | SuspenseyImagesMode, key = createFiber(30, pendingProps, key, type), key.elementType = REACT_VIEW_TRANSITION_TYPE, key.lanes = lanes, key.stateNode = {
                    autoName: null,
                    paired: null,
                    clones: null,
                    ref: null
                }, key;
            default:
                if ("object" === typeof resolvedType && null !== resolvedType) switch(resolvedType.$$typeof){
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        resolvedType = null;
                        break a;
                }
                pendingProps = "";
                if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length) pendingProps += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                null === type ? resolvedType = "null" : isArrayImpl(type) ? resolvedType = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (resolvedType = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", pendingProps = " Did you accidentally export a JSX literal instead of a component?") : resolvedType = typeof type;
                (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (pendingProps += "\n\nCheck the render method of `" + fiberTag + "`.");
                fiberTag = 29;
                pendingProps = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (resolvedType + "." + pendingProps));
                resolvedType = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = resolvedType;
        key.lanes = lanes;
        key._debugOwner = owner;
        return key;
    }
    function createFiberFromElement(element, mode, lanes) {
        mode = createFiberFromTypeAndProps(element.type, element.key, element.props, element._owner, mode, lanes);
        mode._debugOwner = element._owner;
        mode._debugStack = element._debugStack;
        mode._debugTask = element._debugTask;
        return mode;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(18, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        return null !== treeContextProvider ? {
            id: treeContextId,
            overflow: treeContextOverflow
        } : null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        isHydrating || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
        if (null === fiber.return) {
            if (null === hydrationDiffRootDEV) hydrationDiffRootDEV = {
                fiber: fiber,
                children: [],
                serverProps: void 0,
                serverTail: [],
                distanceFromLeaf: distanceFromLeaf
            };
            else {
                if (hydrationDiffRootDEV.fiber !== fiber) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
                hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
            }
            return hydrationDiffRootDEV;
        }
        var siblings = buildHydrationDiffNode(fiber.return, distanceFromLeaf + 1).children;
        if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber) return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
        distanceFromLeaf = {
            fiber: fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        };
        siblings.push(distanceFromLeaf);
        return distanceFromLeaf;
    }
    function warnIfHydrating() {
        isHydrating && console.error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
        didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
        var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : !1, diff = "", diffRoot = hydrationDiffRootDEV;
        null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
        queueHydrationError(createCapturedValueAtFiber(Error("Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff), fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
        var didHydrate = fiber.stateNode;
        var type = fiber.type, props = fiber.memoizedProps;
        didHydrate[internalInstanceKey] = fiber;
        didHydrate[internalPropsKey] = props;
        validatePropertiesInDevelopment(type, props);
        switch(type){
            case "dialog":
                listenToNonDelegatedEvent("cancel", didHydrate);
                listenToNonDelegatedEvent("close", didHydrate);
                break;
            case "iframe":
            case "object":
            case "embed":
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "video":
            case "audio":
                for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
                break;
            case "source":
                listenToNonDelegatedEvent("error", didHydrate);
                break;
            case "img":
            case "image":
            case "link":
                listenToNonDelegatedEvent("error", didHydrate);
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", didHydrate);
                break;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateInputProps(didHydrate, props);
                initInput(didHydrate, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
                break;
            case "option":
                validateOptionProps(didHydrate, props);
                break;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateSelectProps(didHydrate, props);
                break;
            case "textarea":
                checkControlledValueProps("textarea", props), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props), initTextarea(didHydrate, props.value, props.defaultValue, props.children);
        }
        type = props.children;
        "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props.onClick && (didHydrate.onclick = noop$1), didHydrate = !0) : didHydrate = !1;
        didHydrate || throwOnHydrationMismatch(fiber, !0);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 5:
            case 31:
            case 13:
                rootOrSingletonContext = !1;
                return;
            case 27:
            case 3:
                rootOrSingletonContext = !0;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var tag = fiber.tag, JSCompiler_temp;
        if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
            if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
            JSCompiler_temp = !JSCompiler_temp;
        }
        if (JSCompiler_temp && nextHydratableInstance) {
            for(JSCompiler_temp = nextHydratableInstance; JSCompiler_temp;){
                var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
                diffNode.serverTail.push(description);
                JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
            }
            throwOnHydrationMismatch(fiber);
        }
        popToNextHostParent(fiber);
        if (13 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else if (31 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
        return !0;
    }
    function resetHydrationState() {
        nextHydratableInstance = hydrationParentFiber = null;
        didSuspendOrErrorDEV = isHydrating = !1;
    }
    function upgradeHydrationErrorsToRecoverable() {
        var queuedErrors = hydrationErrors;
        null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
        return queuedErrors;
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
        var diffRoot = hydrationDiffRootDEV;
        if (null !== diffRoot) {
            hydrationDiffRootDEV = null;
            for(var diff = describeDiff(diffRoot); 0 < diffRoot.children.length;)diffRoot = diffRoot.children[0];
            runWithFiberInDEV(diffRoot.fiber, function() {
                console.error("A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s", "https://react.dev/link/hydration-mismatch", diff);
            });
        }
    }
    function resetContextDependencies() {
        lastContextDependency = currentlyRenderingFiber$1 = null;
        isDisallowedContextReadInDEV = !1;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        push(rendererCursorDEV, context._currentRenderer, providerFiber);
        void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        context._currentValue = valueCursor.current;
        var currentRenderer = rendererCursorDEV.current;
        pop(rendererCursorDEV, providerFiber);
        context._currentRenderer = currentRenderer;
        pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
        parent !== propagationRoot && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
        return null !== current;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber$1 = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        isDisallowedContextReadInDEV && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = context._currentValue;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context,
                _debugThenableState: null
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function retainCache(cache) {
        cache.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React.");
        cache.refCount++;
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 > cache.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React.");
        0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function queueTransitionTypes(root, transitionTypes) {
        if (0 !== (root.pendingLanes & 4194048)) {
            var queued = root.transitionTypes;
            null === queued && (queued = root.transitionTypes = []);
            for(root = 0; root < transitionTypes.length; root++){
                var transitionType = transitionTypes[root];
                -1 === queued.indexOf(transitionType) && queued.push(transitionType);
            }
        }
    }
    function claimQueuedTransitionTypes(root) {
        var claimed = root.transitionTypes;
        root.transitionTypes = null;
        return claimed;
    }
    function startUpdateTimerByLane(lane, method, fiber) {
        if (0 !== (lane & 127)) 0 > blockingUpdateTime && (blockingUpdateTime = now(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = !0, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
        else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
            lane = resolveEventTimeStamp();
            method = resolveEventType();
            if (lane !== transitionEventRepeatTime || method !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = lane;
            transitionEventType = method;
        }
    }
    function startHostActionTimer(fiber) {
        if (0 > blockingUpdateTime) {
            blockingUpdateTime = now();
            blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
            var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
            newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
            blockingEventTime = newEventTime;
            blockingEventType = newEventType;
        }
        if (0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
            fiber = resolveEventTimeStamp();
            newEventTime = resolveEventType();
            if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = fiber;
            transitionEventType = newEventTime;
        }
    }
    function pushNestedEffectDurations() {
        var prevEffectDuration = profilerEffectDuration;
        profilerEffectDuration = 0;
        return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration = prevEffectDuration;
        return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration += prevEffectDuration;
        return elapsedTime;
    }
    function resetComponentEffectTimers() {
        componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
        var prevEffectStart = componentEffectStartTime;
        componentEffectStartTime = -1.1;
        return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
        0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
        var prevEffectDuration = componentEffectDuration;
        componentEffectDuration = -0;
        return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
        0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
        var prevErrors = componentEffectErrors;
        componentEffectErrors = null;
        return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
        var prev = componentEffectSpawnedUpdate;
        componentEffectSpawnedUpdate = !1;
        return prev;
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now();
        0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordEffectDuration() {
        if (0 <= profilerStartTime) {
            var endTime = now(), elapsedTime = endTime - profilerStartTime;
            profilerStartTime = -1;
            profilerEffectDuration += elapsedTime;
            componentEffectDuration += elapsedTime;
            componentEffectEndTime = endTime;
        }
    }
    function recordEffectError(errorInfo) {
        null === componentEffectErrors && (componentEffectErrors = []);
        componentEffectErrors.push(errorInfo);
        null === commitErrors && (commitErrors = []);
        commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
        profilerStartTime = now();
        0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
        for(var child = fiber.child; child;)fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), entangledTransitionTypes = null, null !== currentEntangledListeners)) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current, offscreenWorkInProgress) : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: CacheContext._currentValue,
            pool: cacheFromPool
        };
    }
    function createThenableState() {
        return {
            didWarnAboutUncachedPromise: !1,
            thenables: []
        };
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState, thenable, index, fiber) {
        null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = !0);
        var trackedThenables = thenableState.thenables;
        index = trackedThenables[index];
        void 0 === index ? trackedThenables.push(thenable) : index !== thenable && (thenableState.didWarnAboutUncachedPromise || (thenableState.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), thenable.then(noop$1, noop$1), thenable = index);
        if (void 0 === thenable._debugInfo) {
            thenableState = performance.now();
            trackedThenables = thenable.displayName;
            var ioInfo = {
                name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
                start: thenableState,
                end: thenableState,
                value: thenable
            };
            thenable._debugInfo = [
                {
                    awaited: ioInfo
                }
            ];
            "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState = function() {
                ioInfo.end = performance.now();
            }, thenable.then(thenableState, thenableState));
        }
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                fiber = thenable.reason;
                checkIfUseWrappedInAsyncCatch(fiber);
                if (void 0 === fiber && !("reason" in thenable)) throw Error("A rejected Promise was passed to React without a `reason` property. React threw a generic error from where the Promise was used to assist in identifying the problematic Promise. Make sure that instrumented Promises correctly set the `reason` property when setting `status` to `'rejected'`.");
                throw fiber;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw fiber = thenable.reason, checkIfUseWrappedInAsyncCatch(fiber), fiber;
                }
                suspendedThenable = thenable;
                needsToResetSuspendedThenableDEV = !0;
                didIssueUseWarning || null === fiber || null !== fiber.alternate || (lastSuspendedFiber = fiber, lastSuspendedStack = Error("This library called use() to suspend in a previous render but did not call use() when it finished. This indicates an incorrect use of use(). Learn more: https://react.dev/warnings/conditional-use-of-use"));
                throw SuspenseException;
        }
    }
    function resolveLazy(lazyType) {
        try {
            return callLazyInitInDEV(lazyType);
        } catch (x) {
            if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, needsToResetSuspendedThenableDEV = !0, SuspenseException;
            throw x;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
        var thenable = suspendedThenable;
        suspendedThenable = null;
        needsToResetSuspendedThenableDEV = !1;
        return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
        if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
    }
    function areSameKeyPath(a, b) {
        return a === b ? !0 : a.tag !== b.tag || a.type !== b.type || a.key !== b.key || a.index !== b.index || 3 === a.tag && a.stateNode !== b.stateNode || null === a.return || null === b.return ? !1 : areSameKeyPath(a.return, b.return);
    }
    function pushDebugInfo(debugInfo) {
        var previousDebugInfo = currentDebugInfo;
        null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
        return previousDebugInfo;
    }
    function getCurrentDebugTask() {
        var debugInfo = currentDebugInfo;
        if (null != debugInfo) {
            for(var i = debugInfo.length - 1; 0 <= i; i--)if (null != debugInfo[i].name) {
                var debugTask = debugInfo[i].debugTask;
                if (null != debugTask) return debugTask;
            }
        }
        return null;
    }
    function validateFragmentProps(element, fiber, returnFiber) {
        for(var keys = Object.keys(element.props), i = 0; i < keys.length; i++){
            var key = keys[i];
            if ("children" !== key && "key" !== key && "ref" !== key) {
                null === fiber && (fiber = createFiberFromElement(element, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
                runWithFiberInDEV(fiber, function(erroredKey) {
                    console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key`, `ref`, and `children` props.", erroredKey);
                }, key);
                break;
            }
        }
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = createThenableState());
        return trackUsedThenable(thenableState$1, thenable, index, null);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead.");
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = !0, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)", invalidChild, invalidChild, invalidChild) : console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>", invalidChild, invalidChild, parentName, invalidChild, parentName));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = !0, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error("Symbols are not valid as a React child.\n  root.render(%s)", invalidChild) : console.error("Symbols are not valid as a React child.\n  <%s>%s</%s>", parentName, invalidChild, parentName));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
            newFiber.flags |= 134217730;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return current = updateFragment(returnFiber, current, element.props.children, lanes, element.key), coerceRef(current, element), validateFragmentProps(element, current, returnFiber), current;
            if (null !== current && (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current._debugOwner = element._owner, current._debugInfo = currentDebugInfo, current;
            current = createFiberFromElement(element, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = createChild(returnFiber, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return lanes = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                if ("function" === typeof newChild.then) return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(returnFiber, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
                    if (null !== key) return null;
                    key = pushDebugInfo(newChild._debugInfo);
                    returnFiber = updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                    currentDebugInfo = key;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes), currentDebugInfo = key, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newIdx = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, newIdx, newChild, lanes), currentDebugInfo = existingChildren, returnFiber;
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo7;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(returnFiber, newIdx, newChild, lanes, null), currentDebugInfo = existingChildren, returnFiber;
                if ("function" === typeof newChild.then) return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo7, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys) {
            if ("object" !== typeof child || null === child) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(returnFiber, workInProgress, child);
                    var key = child.key;
                    if ("string" !== typeof key) break;
                    if (null === knownKeys) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    runWithFiberInDEV(workInProgress, function() {
                        console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    });
                    break;
                case REACT_LAZY_TYPE:
                    child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys);
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, newChildren[newIdx], knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, newChildren[newIdx], knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, newChildren[newIdx], knownKeys), shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error("An iterable object provided no iterator.");
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, step.value, knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, step.value, knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, step.value, knownKeys), shouldTrackSideEffects && (step = nextOldFiber.alternate, null !== step && oldFiber.delete(null === step.key ? newIdx : step.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            coerceRef(lanes, newChild);
                                            lanes.return = returnFiber;
                                            lanes._debugOwner = newChild._owner;
                                            lanes._debugInfo = currentDebugInfo;
                                            validateFragmentProps(newChild, lanes, returnFiber);
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(currentFirstChild, newChild) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        lanes._debugOwner = newChild._owner;
                                        lanes._debugInfo = currentDebugInfo;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
                        }
                        returnFiber = placeSingleChild(returnFiber);
                        currentDebugInfo = prevDebugInfo;
                        return returnFiber;
                    case REACT_PORTAL_TYPE:
                        a: {
                            prevDebugInfo = newChild;
                            for(newChild = prevDebugInfo.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === newChild) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, prevDebugInfo.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(prevDebugInfo, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                }
                if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) {
                    prevDebugInfo = newChild;
                    newChild = getIteratorFn(prevDebugInfo);
                    if ("function" !== typeof newChild) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
                    key = newChild.call(prevDebugInfo);
                    if (key === prevDebugInfo) {
                        if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(key)) didWarnAboutGenerators || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), didWarnAboutGenerators = !0;
                    } else prevDebugInfo.entries !== newChild || didWarnAboutMaps || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0);
                    return reconcileChildrenIterator(returnFiber, currentFirstChild, key, lanes);
                }
                if ("function" === typeof newChild.then) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(prevDebugInfo, returnFiber.mode, lanes), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            var prevDebugInfo = currentDebugInfo;
            currentDebugInfo = null;
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException || x === SuspenseActionException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                var debugInfo = fiber._debugInfo = currentDebugInfo;
                fiber._debugOwner = returnFiber._debugOwner;
                fiber._debugTask = returnFiber._debugTask;
                if (null != debugInfo) {
                    for(var i = debugInfo.length - 1; 0 <= i; i--)if ("string" === typeof debugInfo[i].stack) {
                        fiber._debugOwner = debugInfo[i];
                        fiber._debugTask = debugInfo[i].debugTask;
                        break;
                    }
                }
                return fiber;
            } finally{
                currentDebugInfo = prevDebugInfo;
            }
        };
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArrayImpl(childSlot);
        childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
        return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", isAnArray, index, isAnArray), !1) : !0;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
            var componentName = getComponentNameFromFiber(fiber);
            console.error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s", componentName);
            didWarnUpdateInsideUpdate = !0;
        }
        if ((executionContext & RenderContext) !== NoContext) return componentName = updateQueue.pending, null === componentName ? update.next = update : (update.next = componentName.next, componentName.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress.updateQueue;
        hasForceUpdate = !1;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        updateLane = workInProgress;
                        var partialState = pendingQueue;
                        var nextProps = props, instance = instance$jscomp$0;
                        switch(partialState.tag){
                            case ReplaceState:
                                partialState = partialState.payload;
                                if ("function" === typeof partialState) {
                                    isDisallowedContextReadInDEV = !0;
                                    var nextState = partialState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            partialState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                    newState = nextState;
                                    break a;
                                }
                                newState = partialState;
                                break a;
                            case CaptureUpdate:
                                updateLane.flags = updateLane.flags & -65537 | 128;
                            case UpdateState:
                                nextState = partialState.payload;
                                if ("function" === typeof nextState) {
                                    isDisallowedContextReadInDEV = !0;
                                    partialState = nextState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            nextState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                } else partialState = nextState;
                                if (null === partialState || void 0 === partialState) break a;
                                newState = assign({}, newState, partialState);
                                break a;
                            case ForceUpdate:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress.flags |= 64, isHiddenUpdate && (workInProgress.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress.lanes = lastBaseUpdate;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
        var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
        if (null !== hiddenCallbacks) for(updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
        var prevEntangledRenderLanes = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, context, fiber);
        entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current, fiber);
    }
    function popHiddenContext(fiber) {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor, fiber);
        pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask, handler);
        push(suspenseHandlerStackCursor, handler, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, fiber, fiber);
        null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
        22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current, fiber), push(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor, fiber);
    }
    function pushSuspenseListContext(fiber, newContext) {
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseListContext(fiber) {
        pop(suspenseStackCursor, fiber);
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        null === hookTypesDev ? hookTypesDev = [
            hookName
        ] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
            var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName) && (didWarnAboutMismatchedHooksForComponent.add(componentName), null !== hookTypesDev)) {
                for(var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i], newHookName = i === hookTypesUpdateIndexDev ? hookName : oldHookName;
                    for(oldHookName = i + 1 + ". " + oldHookName; 30 > oldHookName.length;)oldHookName += " ";
                    oldHookName += newHookName + "\n";
                    table += oldHookName;
                }
                console.error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function checkDepsAreArrayDev(deps) {
        void 0 === deps || null === deps || isArrayImpl(deps) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnUseFormStateInDev() {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
        didWarnAboutUseFormState.has(componentName) || (didWarnAboutUseFormState.add(componentName), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", componentName));
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) return !1;
        if (null === prevDeps) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev), !1;
        nextDeps.length !== prevDeps.length && console.error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber = workInProgress;
        hookTypesDev = null !== current ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component)) nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"));
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null !== current && null !== current.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
        shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress.mode & StrictLegacyMode) !== NoMode;
        var children = callComponentInDEV(Component, props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        if (nextRenderLanes) {
            setIsStrictModeForDevtools(!0);
            try {
                children = renderWithHooksAgain(workInProgress, Component, props, secondArg);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        finishRenderingHooks(current, workInProgress);
        return children;
    }
    function finishRenderingHooks(current, workInProgress) {
        workInProgress._debugHookTypes = hookTypesDev;
        null === workInProgress.dependencies ? null !== thenableState && (workInProgress.dependencies = {
            lanes: 0,
            firstContext: null,
            _debugThenableState: thenableState
        }) : workInProgress.dependencies._debugThenableState = thenableState;
        var thenableState$jscomp$0 = thenableState;
        null !== lastSuspendedFiber && areSameKeyPath(lastSuspendedFiber, workInProgress) && (null !== thenableState$jscomp$0 || null === lastSuspendedStack || didIssueUseWarning || (didIssueUseWarning = !0, console.error(lastSuspendedStack)), lastSuspendedStack = lastSuspendedFiber = null);
        ReactSharedInternals.H = ContextOnlyDispatcher;
        thenableState$jscomp$0 = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        null !== current && (current.flags & 1206910976) !== (workInProgress.flags & 1206910976) && console.error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (thenableState$jscomp$0) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
        needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = !1, current = !0) : current = !1;
        current && (workInProgress = getComponentNameFromFiber(workInProgress) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress) || didWarnAboutAsyncClientComponent.has(workInProgress) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (numberOfReRenders >= RE_RENDER_LIMIT) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            numberOfReRenders += 1;
            ignorePreviousDependencies = !1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            hookTypesUpdateIndexDev = -1;
            ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
            children = callComponentInDEV(Component, props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags = (workInProgress.mode & StrictEffectsMode) !== NoMode ? workInProgress.flags & -805308421 : workInProgress.flags & -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber.alternate) throw Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.");
                throw Error("Rendered more hooks than during the previous render.");
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = createThenableState());
        thenable = trackUsedThenable(thenableState, thenable, index, currentlyRenderingFiber);
        index = currentlyRenderingFiber;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null !== index && null !== index.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_RECOVERABLE_TYPE) return;
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue || ignorePreviousDependencies) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        else updateQueue.length !== size && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", updateQueue.length, size);
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue !== baseQueue && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    gesture: update.gesture,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            var nextSnapshot = getServerSnapshot();
            didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        } else {
            nextSnapshot = getSnapshot();
            didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0));
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        hook.memoizedState = nextSnapshot;
        getServerSnapshot = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = getServerSnapshot;
        mountEffect(subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, getServerSnapshot, nextSnapshot, getSnapshot), null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            getServerSnapshot = getServerSnapshot();
        } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            objectIs(getServerSnapshot, cachedSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        if (cachedSnapshot = !objectIs((currentHook || hook).memoizedState, getServerSnapshot)) hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0;
        hook = hook.queue;
        var create = subscribeToStore.bind(null, fiber, hook, subscribe);
        updateEffectImpl(2048, Passive, create, [
            subscribe
        ]);
        subscribe = hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && (workInProgressHook.memoizedState.tag & HasEffect) !== NoFlags;
        pushSimpleEffect(subscribe ? HasEffect | Passive : Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (subscribe) {
            fiber.flags |= 2048;
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function mountState(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    }
    function mountOptimistic(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    }
    function updateOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function rerenderOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error("Cannot update action state while rendering.");
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            currentTransition.types = null !== prevTransition ? prevTransition.types : null;
            currentTransition._updatedFibers = new Set();
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
            }
        } else try {
            currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$5) {
            onActionError(actionQueue, node, error$5);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }), node.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var isMatching = currentlyRenderingFiber;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            b: {
                                var markerInstance = nextHydratableInstance;
                                for(var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType;){
                                    if (!inRootOrSingleton) {
                                        markerInstance = null;
                                        break b;
                                    }
                                    markerInstance = getNextHydratable(markerInstance.nextSibling);
                                    if (null === markerInstance) {
                                        markerInstance = null;
                                        break b;
                                    }
                                }
                                inRootOrSingleton = markerInstance.data;
                                markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                            }
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratable(markerInstance.nextSibling);
                                isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(isMatching);
                    }
                    isMatching = !1;
                }
                isMatching && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        isMatching = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = isMatching;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, isMatching);
        isMatching.dispatch = ssrFormState;
        isMatching = mountStateImpl(!1);
        inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, isMatching.queue);
        isMatching = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        isMatching.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, markerInstance, inRootOrSingleton, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        isMatching.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
            var state = useThenable(currentStateHook);
        } catch (x) {
            if (x === SuspenseException) throw SuspenseActionException;
            throw x;
        }
        else state = currentStateHook;
        currentStateHook = updateWorkInProgressHook();
        var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
        action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, actionStateActionEffect.bind(null, actionQueue, action), null));
        return [
            state,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushSimpleEffect(tag, inst, create, deps) {
        tag = {
            tag: tag,
            create: create,
            deps: deps,
            inst: inst,
            next: null
        };
        inst = currentlyRenderingFiber.updateQueue;
        null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
        create = inst.lastEffect;
        null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
        return tag;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber.flags |= fiberFlags;
        hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, {
            destroy: void 0
        }, create, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, inst, create, deps));
    }
    function mountEffect(create, deps) {
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(545261568, Passive, create, deps) : mountEffectImpl(8390656, Passive, create, deps);
    }
    function useEffectEventImpl(payload) {
        currentlyRenderingFiber.flags |= 4;
        var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
        if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
            payload
        ];
        else {
            var events = componentUpdateQueue.events;
            null === events ? componentUpdateQueue.events = [
                payload
            ] : events.push(payload);
        }
    }
    function mountEvent(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function updateEvent(callback) {
        var ref = updateWorkInProgressHook().memoizedState;
        useEffectEventImpl({
            ref: ref,
            nextImpl: callback
        });
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 268435456);
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return ref.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(ref).join(", ") + "}"), create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 268435456);
        mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function updateImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountCallback(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValue(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function rerenderDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 106) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                ReactSharedInternals.asyncTransitions++;
                returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane(fiber));
        } finally{
            ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
        }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startHostActionTimer(formFiber);
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            requestFormReset$1(formFiber);
            return action(formData);
        });
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
        null === ReactSharedInternals.T && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.");
        var stateHook = ensureFormComponentIsStateful(formFiber);
        null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
        dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane(formFiber));
    }
    function mountTransition() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    }
    function updateTransition() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function rerenderTransition() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function mountId() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var treeId = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
            identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
            treeId = localIdCounter++;
            0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
            identifierPrefix += "_";
        } else treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
    function refreshCache(fiber, seedKey) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root = enqueueUpdate(provider, refreshUpdate, lane);
                    null !== root && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    fiber = createCache();
                    null !== seedKey && void 0 !== seedKey && null !== root && console.error("The seed argument is not enabled outside experimental channels.");
                    refreshUpdate.payload = {
                        cache: fiber
                    };
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        var update = {
            lane: args,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update) : (update = enqueueConcurrentHookUpdate(fiber, queue, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue, args)));
    }
    function dispatchSetState(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        dispatchSetStateInternal(fiber, queue, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
                var prevDispatcher = ReactSharedInternals.H;
                ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
                try {
                    var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                    update.hasEagerState = !0;
                    update.eagerState = eagerState;
                    if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
                } catch (error) {} finally{
                    ReactSharedInternals.H = prevDispatcher;
                }
            }
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.");
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error("Cannot update optimistic state while rendering.");
            console.error("Cannot call startTransition while rendering.");
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194048)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function warnOnInvalidCallback(callback) {
        if (null !== callback && "function" !== typeof callback) {
            var key = String(callback);
            didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback));
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(!0);
            try {
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        void 0 === partialState && (ctor = getComponentNameFromType(ctor) || "Component", didWarnAboutUndefinedDerivedState.has(ctor) || (didWarnAboutUndefinedDerivedState.add(ctor), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", ctor)));
        prevState = null === partialState || void 0 === partialState ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = prevState;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if ("function" === typeof instance.shouldComponentUpdate) {
            oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            void 0 === oldProps && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return oldProps;
        }
        return ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== oldState && (workInProgress = getComponentNameFromFiber(workInProgress) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress) || (didWarnAboutStateAssignmentForComponent.add(workInProgress), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", workInProgress)), classComponentUpdater.enqueueReplaceState(instance, instance.state, null));
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var _propName in Component)void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
        }
        return newProps;
    }
    function defaultOnUncaughtError(error) {
        reportGlobalError(error);
        console.warn("%s\n\n%s\n", componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.", "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries.");
    }
    function defaultOnCaughtError(error) {
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
        if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
            var JSCompiler_inline_result = error.environmentName;
            error = [
                "%o\n\n%s\n\n%s\n",
                error,
                componentNameMessage,
                recreateMessage
            ].slice(0);
            "string" === typeof error[0] ? error.splice(0, 1, badgeFormat + " " + error[0], badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle) : error.splice(0, 0, badgeFormat, badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle);
            error.unshift(console);
            JSCompiler_inline_result = bind.apply(console.error, error);
            JSCompiler_inline_result();
        } else console.error("%o\n\n%s\n\n%s\n", error, componentNameMessage, recreateMessage);
    }
    function defaultOnRecoverableError(error) {
        reportGlobalError(error);
    }
    function logUncaughtError(root, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = null;
            var error = errorInfo.value;
            if (null !== ReactSharedInternals.actQueue) ReactSharedInternals.thrownErrors.push(error);
            else {
                var onUncaughtError = root.onUncaughtError;
                onUncaughtError(error, {
                    componentStack: errorInfo.stack
                });
            }
        } catch (e$6) {
            setTimeout(function() {
                throw e$6;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = getComponentNameFromFiber(boundary);
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e$7) {
            setTimeout(function() {
                throw e$7;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            runWithFiberInDEV(errorInfo.source, logUncaughtError, root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
            runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            callComponentDidCatchInDEV(this, errorInfo);
            "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        isDevToolsPresent && restorePendingUpdaters(root, rootRenderLanes);
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            isHydrating && (didSuspendOrErrorDEV = !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 31:
                    case 13:
                    case 19:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error("Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React.");
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return didSuspendOrErrorDEV = !0, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (19 === returnFiber.tag && console.error("SuspenseList should never catch while hydrating. This is a bug in React."), 0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", {
            cause: value
        }), sourceFiber))) : (value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", {
            cause: value
        }), sourceFiber)), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), !1;
        var error = createCapturedValueAtFiber(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", {
            cause: value
        }), sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            error
        ] : workInProgressRootConcurrentErrors.push(error);
        workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    returnFiber = sourceFiber.type;
                    error = sourceFiber.stateNode;
                    if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                    break;
                case 22:
                    if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var resolvedRender = resolveTypeForHotReloading(Component);
        resolvedRender !== Component && (Component = resolvedRender, null !== current && (didReceiveUpdate = !0));
        resolvedRender = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, resolvedRender, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return Component = resolveTypeForHotReloading(type), workInProgress.tag = 15, workInProgress.type = Component, validateFunctionComponentInDev(workInProgress, type), updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
        var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
        null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        if ("hidden" === nextProps.mode) {
            if (0 !== (workInProgress.flags & 128)) {
                prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextProps = workInProgress.child = current.child;
                    for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                    nextProps = nextChildren & ~prevState;
                } else nextProps = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(workInProgress), pushOffscreenSuspenseHandler(workInProgress);
            else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(workInProgress), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function bailoutOffscreenComponent(current, workInProgress) {
        null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        return workInProgress.sibling;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: CacheContext._currentValue,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack(workInProgress);
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        workInProgress.childLanes = remainingChildLanes;
        return null;
    }
    function mountActivityChildren(workInProgress, nextProps) {
        var hiddenProp = nextProps.hidden;
        void 0 !== hiddenProp && console.error('<Activity> doesn\'t accept a hidden prop. Use mode="hidden" instead.\n- <Activity %s>\n+ <Activity %s>', !0 === hiddenProp ? "hidden" : !1 === hiddenProp ? "hidden={false}" : "hidden={...}", hiddenProp ? 'mode="hidden"' : 'mode="visible"');
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: nextProps.mode,
            children: nextProps.children
        }, workInProgress.mode);
        nextProps.ref = workInProgress.ref;
        workInProgress.child = nextProps;
        nextProps.return = workInProgress;
        return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
        current.flags |= 2;
        popSuspenseHandler(workInProgress);
        workInProgress.memoizedState = null;
        return current;
    }
    function updateActivityComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
        workInProgress.flags &= -129;
        if (null === current) {
            if (isHydrating) {
                if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                    baseLanes: 0,
                    cachePool: null
                }, bailoutOffscreenComponent(null, current);
                pushDehydratedActivitySuspenseHandler(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data === ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (nextProps = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes), nextProps.return = workInProgress, workInProgress.child = nextProps, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                workInProgress.lanes = 536870912;
                return null;
            }
            return mountActivityChildren(workInProgress, nextProps);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var activityInstance = prevState.dehydrated;
            pushDehydratedActivitySuspenseHandler(workInProgress);
            if (didSuspend) {
                if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
                else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
                else throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
            } else if (warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
                if (null === currentTreeHiddenStackCursor.current) {
                    nextProps = workInProgressRoot;
                    if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== activityInstance && activityInstance !== prevState.retryLane)) throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current, activityInstance), scheduleUpdateOnFiber(nextProps, current, activityInstance), SelectiveHydrationException;
                    renderDidSuspendDelayIfPossible();
                }
                workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(activityInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
            return workInProgress;
        }
        prevState = current.child;
        nextProps = {
            mode: nextProps.mode,
            children: nextProps.children
        };
        0 !== (renderLanes & 536870912) && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        current = createWorkInProgress(prevState, nextProps);
        current.ref = workInProgress.ref;
        workInProgress.child = current;
        current.return = workInProgress;
        return current;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
            if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (Component.prototype && "function" === typeof Component.prototype.render) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            didWarnAboutBadClass[componentName] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName), didWarnAboutBadClass[componentName] = !0);
        }
        workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        null === current && (validateFunctionComponentInDev(workInProgress, workInProgress.type), Component.contextTypes && (componentName = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName] || (didWarnAboutContextTypes[componentName] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", componentName))));
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current, workInProgress);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        switch(shouldErrorImpl(workInProgress)){
            case !1:
                var _instance = workInProgress.stateNode, state = new workInProgress.type(workInProgress.memoizedProps, _instance.context).state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case !0:
                workInProgress.flags |= 128;
                workInProgress.flags |= 65536;
                _instance = Error("Simulated error coming from DevTools");
                var lane = renderLanes & -renderLanes;
                workInProgress.lanes |= lane;
                state = workInProgressRoot;
                if (null === state) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
                lane = createClassErrorUpdate(lane);
                initializeClassErrorUpdate(lane, state, workInProgress, createCapturedValueAtFiber(_instance, workInProgress));
                enqueueCapturedUpdate(workInProgress, lane);
        }
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            state = emptyContextObject;
            _instance = Component.contextType;
            "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(Component) || "Component", lane));
            "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
            _instance = new Component(nextProps, state);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    _instance = new Component(nextProps, state);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            state = workInProgress.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
            _instance.updater = classComponentUpdater;
            workInProgress.stateNode = _instance;
            _instance._reactInternals = workInProgress;
            _instance._reactInternalInstance = fakeInternalInstance;
            "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", state, null === _instance.state ? "null" : "undefined", state)));
            if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
                var foundWillUpdateName = lane = state = null;
                "function" === typeof _instance.componentWillMount && !0 !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
                "function" === typeof _instance.componentWillReceiveProps && !0 !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
                "function" === typeof _instance.componentWillUpdate && !0 !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
                if (null !== state || null !== lane || null !== foundWillUpdateName) {
                    _instance = getComponentNameFromType(Component) || "Component";
                    var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                    didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles", _instance, newApiName, null !== state ? "\n  " + state : "", null !== lane ? "\n  " + lane : "", null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""));
                }
            }
            _instance = workInProgress.stateNode;
            state = getComponentNameFromType(Component) || "Component";
            _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", state) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", state));
            !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", state);
            _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", state);
            _instance.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", state);
            Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", state));
            Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", state));
            "function" === typeof _instance.componentShouldUpdate && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", state);
            Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(Component) || "A pure component");
            "function" === typeof _instance.componentDidUnmount && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", state);
            "function" === typeof _instance.componentDidReceiveProps && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", state);
            "function" === typeof _instance.componentWillRecieveProps && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", state);
            "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", state);
            lane = _instance.props !== nextProps;
            void 0 !== _instance.props && lane && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", state);
            _instance.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", state, state);
            "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(Component)));
            "function" === typeof _instance.getDerivedStateFromProps && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof _instance.getDerivedStateFromError && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof Component.getSnapshotBeforeUpdate && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", state);
            (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
            "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", state);
            _instance = workInProgress.stateNode;
            _instance.props = nextProps;
            _instance.state = workInProgress.memoizedState;
            _instance.refs = {};
            initializeUpdateQueue(workInProgress);
            state = Component.contextType;
            _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
            _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", state)));
            workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, _instance);
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, _instance);
            _instance.state = workInProgress.memoizedState;
            state = Component.getDerivedStateFromProps;
            "function" === typeof state && (applyDerivedStateFromProps(workInProgress, Component, state, nextProps), _instance.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component"), classComponentUpdater.enqueueReplaceState(_instance, _instance.state, null)), processUpdateQueue(workInProgress, nextProps, _instance, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress.memoizedState);
            "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308);
            (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456);
            _instance = !0;
        } else if (null === current) {
            _instance = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps;
            lane = resolveClassComponentProps(Component, unresolvedOldProps);
            _instance.props = lane;
            var oldContext = _instance.context;
            foundWillUpdateName = Component.contextType;
            state = emptyContextObject;
            "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
            newApiName = Component.getDerivedStateFromProps;
            foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, state);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(workInProgress, Component, newApiName, nextProps), oldContext = workInProgress.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, lane, nextProps, oldState, oldContext, state)) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456)) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456), _instance = !1);
        } else {
            _instance = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            state = workInProgress.memoizedProps;
            foundWillUpdateName = resolveClassComponentProps(Component, state);
            _instance.props = foundWillUpdateName;
            newApiName = workInProgress.pendingProps;
            oldState = _instance.context;
            oldContext = Component.contextType;
            lane = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, lane);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            state !== newApiName || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, foundWillUpdateName, nextProps, oldState, newState, lane) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(nextProps, newState, lane)), "function" === typeof _instance.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), _instance = !1);
        }
        lane = _instance;
        markRef(current, workInProgress);
        state = 0 !== (workInProgress.flags & 128);
        if (lane || state) {
            lane = workInProgress.stateNode;
            setCurrentFiber(workInProgress);
            if (state && "function" !== typeof Component.getDerivedStateFromError) Component = null, profilerStartTime = -1;
            else if (Component = callRenderInDEV(lane), workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    callRenderInDEV(lane);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            workInProgress.flags |= 1;
            null !== current && state ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes);
            workInProgress.memoizedState = lane.state;
            current = workInProgress.child;
        } else current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        renderLanes = workInProgress.stateNode;
        _instance && renderLanes.props !== nextProps && (didWarnAboutReassigningProps || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component"), didWarnAboutReassigningProps = !0);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        Component && Component.childContextTypes && console.error("childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...", Component.displayName || Component.name || "Component");
        "function" === typeof Component.getDerivedStateFromProps && (workInProgress = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] || (console.error("%s: Function components do not support getDerivedStateFromProps.", workInProgress), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] = !0));
        "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error("%s: Function components do not support contextType.", Component), didWarnAboutContextTypeOnFunctionComponent[Component] = !0));
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        shouldSuspendImpl(workInProgress) && (workInProgress.flags |= 128);
        var showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
        (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
        JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
        JSCompiler_temp = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data !== ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (JSCompiler_temp = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = JSCompiler_temp, JSCompiler_temp = createFiberFromDehydratedFragment(renderLanes), JSCompiler_temp.return = workInProgress, workInProgress.child = JSCompiler_temp, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                isSuspenseInstanceFallback(renderLanes) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
                return null;
            }
            didSuspend = nextProps.children;
            nextProps = nextProps.fallback;
            if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, didSuspend = mountWorkInProgressOffscreenFiber({
                mode: "hidden",
                children: didSuspend
            }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, didSuspend);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var _dehydrated2 = prevState.dehydrated;
            if (null !== _dehydrated2) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, _dehydrated2, prevState, renderLanes);
        }
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, _dehydrated2 = prevState.sibling, nextProps = createWorkInProgress(prevState, {
            mode: "hidden",
            children: nextProps.children
        }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== _dehydrated2 ? showFallback = createWorkInProgress(_dehydrated2, showFallback) : (showFallback = createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
            parent: prevState,
            pool: prevState
        } : didSuspend) : didSuspend = getSuspendedCache(), showFallback = {
            baseLanes: showFallback.baseLanes | renderLanes,
            cachePool: didSuspend
        }), nextProps.memoizedState = showFallback, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
        null !== prevState && (renderLanes & 62914560) === renderLanes && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: nextProps.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        offscreenProps = createFiber(22, offscreenProps, null, mode);
        offscreenProps.lanes = 0;
        return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (didSuspend) {
            if (workInProgress.flags & 256) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            if (null !== workInProgress.memoizedState) return reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, null;
            reuseSuspenseHandlerOnStack(workInProgress);
            var fallbackChildren = nextProps.fallback, fiberMode = workInProgress.mode, primaryChildFragment = mountWorkInProgressOffscreenFiber({
                mode: "visible",
                children: nextProps.children
            }, fiberMode);
            fallbackChildren = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null);
            fallbackChildren.flags |= 2;
            primaryChildFragment.return = workInProgress;
            fallbackChildren.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildren;
            workInProgress.child = primaryChildFragment;
            reconcileChildFibers(workInProgress, current.child, null, renderLanes);
            fallbackChildren = workInProgress.child;
            fallbackChildren.memoizedState = mountSuspenseOffscreenState(renderLanes);
            fallbackChildren.childLanes = getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
            workInProgress.memoizedState = SUSPENDED_MARKER;
            return bailoutOffscreenComponent(null, fallbackChildren);
        }
        pushPrimaryTreeSuspenseHandler(workInProgress);
        warnIfHydrating();
        0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress);
        if (isSuspenseInstanceFallback(suspenseInstance)) {
            didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
            if (didPrimaryChildrenDefer) {
                fallbackChildren = didPrimaryChildrenDefer.dgst;
                var message = didPrimaryChildrenDefer.msg;
                fiberMode = didPrimaryChildrenDefer.stck;
                primaryChildFragment = didPrimaryChildrenDefer.cstck;
            }
            suspenseInstance = message;
            suspenseState = fallbackChildren;
            nextProps = fiberMode;
            didPrimaryChildrenDefer = primaryChildFragment;
            fallbackChildren = suspenseState;
            fiberMode = suspenseInstance;
            primaryChildFragment = nextProps;
            nextProps = didPrimaryChildrenDefer;
            fallbackChildren !== REACT_RECOVERABLE_DIGEST && (didPrimaryChildrenDefer = fiberMode ? Error(fiberMode) : Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), didPrimaryChildrenDefer.stack = primaryChildFragment || "", didPrimaryChildrenDefer.digest = fallbackChildren, fallbackChildren = void 0 === nextProps ? null : nextProps, fiberMode = {
                value: didPrimaryChildrenDefer,
                source: null,
                stack: fallbackChildren
            }, "string" === typeof fallbackChildren && CapturedStacks.set(didPrimaryChildrenDefer, fiberMode), queueHydrationError(fiberMode));
            return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        }
        didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1);
        didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
        if (didReceiveUpdate || didPrimaryChildrenDefer) {
            if (null !== currentTreeHiddenStackCursor.current) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            didPrimaryChildrenDefer = workInProgressRoot;
            if (null !== didPrimaryChildrenDefer && (fallbackChildren = getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== fallbackChildren && fallbackChildren !== suspenseState.retryLane)) throw suspenseState.retryLane = fallbackChildren, enqueueConcurrentRenderForLane(current, fallbackChildren), scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, fallbackChildren), SelectiveHydrationException;
            isSuspenseInstancePending(suspenseInstance) || renderDidSuspendDelayIfPossible();
            return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        }
        if (isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
        current = suspenseState.treeContext;
        nextHydratableInstance = getNextHydratable(suspenseInstance.nextSibling);
        hydrationParentFiber = workInProgress;
        isHydrating = !0;
        hydrationErrors = null;
        didSuspendOrErrorDEV = !1;
        hydrationDiffRootDEV = null;
        rootOrSingletonContext = !1;
        null !== current && restoreSuspendedTreeContext(workInProgress, current);
        workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children);
        workInProgress.flags |= 134221824;
        return workInProgress;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function findLastContentRow(firstChild) {
        for(var lastContentRow = null; null !== firstChild;){
            var currentRow = firstChild.alternate;
            null !== currentRow && null === findFirstSuspended(currentRow) && (lastContentRow = firstChild);
            firstChild = firstChild.sibling;
        }
        return lastContentRow;
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            treeForkCount: treeForkCount
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
    }
    function reverseChildren(fiber) {
        var row = fiber.child;
        for(fiber.child = null; null !== row;){
            var nextRow = row.sibling;
            row.sibling = fiber.child;
            fiber.child = row;
            row = nextRow;
        }
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
        if (workInProgress.flags & 128) return pushSuspenseListContext(workInProgress, suspenseContext), null;
        (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
        pushSuspenseListContext(workInProgress, suspenseContext);
        suspenseContext = null == revealOrder ? "null" : revealOrder;
        if (null != revealOrder && "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext]) {
            if (didWarnAboutRevealOrder[suspenseContext] = !0, "string" === typeof revealOrder) switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                case "independent":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    console.error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
            }
            else console.error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
        }
        suspenseContext = null == tailMode ? "null" : tailMode;
        didWarnAboutTailOptions[suspenseContext] || null == tailMode || ("visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = !0, console.error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?', tailMode)) : null != revealOrder && "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = !0, console.error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" (default) or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode)));
        a: if ((null == revealOrder || "forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && !1 !== newChildren) {
            if (isArrayImpl(newChildren)) for(suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++){
                if (!validateSuspenseListNestedChild(newChildren[suspenseContext], suspenseContext)) break a;
            }
            else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
                if (suspenseContext = suspenseContext.call(newChildren)) for(var step = suspenseContext.next(), _i = 0; !step.done; step = suspenseContext.next()){
                    if (!validateSuspenseListNestedChild(step.value, _i)) break a;
                    _i++;
                }
            } else console.error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
        }
        "backwards" === revealOrder && null !== current ? (reverseChildren(current), reconcileChildren(current, workInProgress, newChildren, renderLanes), reverseChildren(current)) : reconcileChildren(current, workInProgress, newChildren, renderLanes);
        isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
        if (!nextProps && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        switch(revealOrder){
            case "backwards":
                renderLanes = findLastContentRow(workInProgress.child);
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, reverseChildren(workInProgress));
                initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, newChildren);
                break;
            case "unstable_legacy-backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, newChildren);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0, newChildren);
                break;
            case "independent":
                workInProgress.memoizedState = null;
                break;
            default:
                renderLanes = findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, newChildren);
        }
        return workInProgress.child;
    }
    function updateContextProvider(current, workInProgress, renderLanes) {
        var context = workInProgress.type, newProps = workInProgress.pendingProps, newValue = newProps.value;
        "value" in newProps || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        pushProvider(workInProgress, context, newValue);
        reconcileChildren(current, workInProgress, newProps.children, renderLanes);
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        profilerStartTime = -1;
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error("Resuming work not yet implemented.");
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 12:
                0 !== (renderLanes & workInProgress.childLanes) && (workInProgress.flags |= 4);
                workInProgress.flags |= 2048;
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = -0;
                stateNode.passiveEffectDuration = -0;
                break;
            case 31:
                if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
                break;
            case 13:
                stateNode = workInProgress.memoizedState;
                if (null !== stateNode) {
                    if (null !== stateNode.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    stateNode = propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                    var primaryChildLanes = workInProgress.child.childLanes;
                    if (stateNode || 0 !== (renderLanes & primaryChildLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                if (workInProgress.flags & 128) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                primaryChildLanes = 0 !== (current.flags & 128);
                stateNode = 0 !== (renderLanes & workInProgress.childLanes);
                stateNode || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), stateNode = 0 !== (renderLanes & workInProgress.childLanes));
                if (primaryChildLanes) {
                    if (stateNode) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                primaryChildLanes = workInProgress.memoizedState;
                null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
                pushSuspenseListContext(workInProgress, suspenseStackCursor.current);
                if (stateNode) break;
                else return null;
            case 22:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && null !== current) {
            renderLanes = createFiberFromTypeAndProps(resolveTypeForHotReloading(workInProgress.elementType), workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes);
            renderLanes._debugStack = workInProgress._debugStack;
            renderLanes._debugTask = workInProgress._debugTask;
            var returnFiber = workInProgress.return;
            if (null === returnFiber) throw Error("Cannot swap the root fiber.");
            current.alternate = null;
            workInProgress.alternate = null;
            renderLanes.index = workInProgress.index;
            renderLanes.sibling = workInProgress.sibling;
            renderLanes.return = workInProgress.return;
            renderLanes.ref = workInProgress.ref;
            renderLanes._debugInfo = workInProgress._debugInfo;
            if (workInProgress === returnFiber.child) returnFiber.child = renderLanes;
            else {
                var prevSibling = returnFiber.child;
                if (null === prevSibling) throw Error("Expected parent to have a child.");
                for(; prevSibling.sibling !== workInProgress;)if (prevSibling = prevSibling.sibling, null === prevSibling) throw Error("Expected to find the previous sibling.");
                prevSibling.sibling = renderLanes;
            }
            workInProgress = returnFiber.deletions;
            null === workInProgress ? (returnFiber.deletions = [
                current
            ], returnFiber.flags |= 16) : workInProgress.push(current);
            renderLanes.flags |= 134217730;
            return renderLanes;
        }
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps || workInProgress.type !== current.type) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else {
            didReceiveUpdate = !1;
            if (returnFiber = isHydrating) warnIfNotHydrating(), returnFiber = 0 !== (workInProgress.flags & 1048576);
            returnFiber && (returnFiber = workInProgress.index, warnIfNotHydrating(), pushTreeId(workInProgress, treeForkCount, returnFiber));
        }
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: if (returnFiber = workInProgress.pendingProps, current = resolveLazy(workInProgress.elementType), current = resolveTypeForHotReloading(current), workInProgress.type = current, "function" === typeof current) shouldConstruct(current) ? (returnFiber = resolveClassComponentProps(current, returnFiber), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, returnFiber, renderLanes)) : (workInProgress.tag = 0, validateFunctionComponentInDev(workInProgress, current), workInProgress = updateFunctionComponent(null, workInProgress, current, returnFiber, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        if (prevSibling = current.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = "";
                    null !== current && "object" === typeof current && current.$$typeof === REACT_LAZY_TYPE && (workInProgress = " Did you wrap a component in React.lazy() more than once?");
                    renderLanes = getComponentNameFromType(current) || current;
                    throw Error("Element type is invalid. Received a promise that resolves to: " + renderLanes + ". Lazy element type must resolve to a class or function." + workInProgress);
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return returnFiber = workInProgress.type, prevSibling = resolveClassComponentProps(returnFiber, workInProgress.pendingProps), updateClassComponent(current, workInProgress, returnFiber, prevSibling, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error("Should have a current fiber. This is a bug in React.");
                    returnFiber = workInProgress.pendingProps;
                    var prevState = workInProgress.memoizedState;
                    prevSibling = prevState.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, returnFiber, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    returnFiber = nextState.cache;
                    pushProvider(workInProgress, CacheContext, returnFiber);
                    returnFiber !== prevState.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    returnFiber = nextState.element;
                    if (prevState.isDehydrated) {
                        if (prevState = {
                            element: returnFiber,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else if (returnFiber !== prevSibling) {
                            prevSibling = createCapturedValueAtFiber(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                            queueHydrationError(prevSibling);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else {
                            current = workInProgress.stateNode.containerInfo;
                            switch(current.nodeType){
                                case 9:
                                    current = current.body;
                                    break;
                                default:
                                    current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                            }
                            nextHydratableInstance = getNextHydratable(current.firstChild);
                            hydrationParentFiber = workInProgress;
                            isHydrating = !0;
                            hydrationErrors = null;
                            didSuspendOrErrorDEV = !1;
                            hydrationDiffRootDEV = null;
                            rootOrSingletonContext = !0;
                            renderLanes = mountChildFibers(workInProgress, null, returnFiber, renderLanes);
                            for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                        }
                    } else {
                        resetHydrationState();
                        if (returnFiber === prevSibling) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, returnFiber, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (workInProgress.stateNode = createHoistableInstance(workInProgress.type, workInProgress.pendingProps, requiredContext(rootInstanceStackCursor.current), workInProgress)) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                return pushHostContext(workInProgress), null === current && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, returnFiber, prevSibling, !1), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(returnFiber, workInProgress.type, workInProgress.pendingProps, prevSibling), null !== prevSibling && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(returnFiber.firstChild)) : nextHydratableInstance = prevSibling), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
            case 5:
                return null === current && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(workInProgress.type, prevState.ancestorInfo), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(prevSibling, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== nextState ? (workInProgress.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(nextState, workInProgress.type, workInProgress.pendingProps, prevState), null !== prevState && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevState)), hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(nextState.firstChild), rootOrSingletonContext = !1, prevState = !0) : prevState = !1, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress, prevSibling), throwOnHydrationMismatch(workInProgress))), pushHostContext(workInProgress), prevSibling = workInProgress.type, prevState = workInProgress.pendingProps, nextState = null !== current ? current.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress.flags |= 32), null !== workInProgress.memoizedState && (prevSibling = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = prevSibling), markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 6:
                return null === current && isHydrating && (renderLanes = workInProgress.pendingProps, current = getHostContext(), returnFiber = current.ancestorInfo.current, renderLanes = null != returnFiber ? validateTextNesting(renderLanes, returnFiber.tag, current.ancestorInfo.implicitRootScope) : !0, current = nextHydratableInstance, (returnFiber = !current) || (returnFiber = canHydrateTextInstance(current, workInProgress.pendingProps, rootOrSingletonContext), null !== returnFiber ? (workInProgress.stateNode = returnFiber, hydrationParentFiber = workInProgress, nextHydratableInstance = null, returnFiber = !0) : returnFiber = !1, returnFiber = !returnFiber), returnFiber && (renderLanes && warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress))), null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), returnFiber = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, returnFiber, renderLanes) : reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return returnFiber = workInProgress.pendingProps, markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return workInProgress.flags |= 4, workInProgress.flags |= 2048, returnFiber = workInProgress.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return updateContextProvider(current, workInProgress, renderLanes);
            case 9:
                return prevSibling = workInProgress.type._context, returnFiber = workInProgress.pendingProps.children, "function" !== typeof returnFiber && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), prepareToReadContext(workInProgress), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(returnFiber, prevSibling, void 0), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 31:
                return updateActivityComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                return prepareToReadContext(workInProgress), returnFiber = readContext(CacheContext), null === current ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes), prevSibling = prevState), workInProgress.memoizedState = {
                    parent: returnFiber,
                    cache: prevSibling
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, prevSibling)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current.memoizedState, prevState = workInProgress.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
                    parent: returnFiber,
                    cache: returnFiber
                }, workInProgress.memoizedState = prevSibling, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = prevSibling), pushProvider(workInProgress, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 30:
                return null === workInProgress.stateNode && (workInProgress.stateNode = {
                    autoName: null,
                    paired: null,
                    clones: null,
                    ref: null
                }), returnFiber = workInProgress.pendingProps, null != returnFiber.name && "auto" !== returnFiber.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : isHydrating && pushMaterializedTreeId(workInProgress), void 0 !== returnFiber.className && (prevSibling = "string" === typeof returnFiber.className ? JSON.stringify(returnFiber.className) : "{...}", didWarnAboutClassNameOnViewTransition[prevSibling] || (didWarnAboutClassNameOnViewTransition[prevSibling] = !0, console.error('<ViewTransition> doesn\'t accept a "className" prop. It has been renamed to "default".\n-   <ViewTransition className=%s>\n+   <ViewTransition default=%s>', prevSibling, prevSibling))), null !== current && current.memoizedProps.name !== returnFiber.name ? workInProgress.flags |= 4194816 : markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
        var JSCompiler_temp;
        if (JSCompiler_temp = (workInProgress.mode & SuspenseyImagesMode) !== NoMode) JSCompiler_temp = null === oldProps ? maySuspendCommit(type, newProps) : maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
        if (JSCompiler_temp) {
            if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
                if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
                else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded) workInProgress.flags &= -16777217;
        else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
            if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "visible":
                break;
            case "collapsed":
                for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
                null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
                break;
            default:
                hasRenderedATailFallback = renderState.tail;
                for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === tailNode ? renderState.tail = null : tailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) {
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                for(var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2;)newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 1206910976, subtreeFlags |= _child2.flags & 1206910976, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 1206910976, subtreeFlags |= _treeBaseDuration.flags & 1206910976, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        } else if ((completedWork.mode & ProfileMode) !== NoMode) {
            _treeBaseDuration = completedWork.actualDuration;
            _child2 = completedWork.selfBaseDuration;
            for(var child = completedWork.child; null !== child;)newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
            completedWork.actualDuration = _treeBaseDuration;
            completedWork.treeBaseDuration = _child2;
        } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext, workInProgress);
                popHostContainer(workInProgress);
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress)) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
                bubbleProperties(workInProgress);
                return null;
            case 26:
                var type = workInProgress.type, nextResource = workInProgress.memoizedState;
                null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
                return null;
            case 27:
                popHostContext(workInProgress);
                renderLanes = requiredContext(rootInstanceStackCursor.current);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        workInProgress.subtreeFlags &= -33554433;
                        return null;
                    }
                    current = getHostContext();
                    popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                }
                bubbleProperties(workInProgress);
                workInProgress.subtreeFlags &= -33554433;
                return null;
            case 5:
                popHostContext(workInProgress);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        workInProgress.subtreeFlags &= -33554433;
                        return null;
                    }
                    var _currentHostContext = getHostContext();
                    if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, _currentHostContext);
                    else {
                        nextResource = requiredContext(rootInstanceStackCursor.current);
                        validateDOMNesting(type, _currentHostContext.ancestorInfo);
                        _currentHostContext = _currentHostContext.context;
                        nextResource = getOwnerDocumentFromRootContainer(nextResource);
                        switch(_currentHostContext){
                            case HostContextNamespaceSvg:
                                nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                break;
                            case HostContextNamespaceMath:
                                nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                break;
                            default:
                                switch(type){
                                    case "svg":
                                        nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                        break;
                                    case "math":
                                        nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                        break;
                                    case "script":
                                        nextResource = nextResource.createElement("div");
                                        didWarnScriptTags || isScriptDataBlock(newProps) || (console.error("Encountered a script tag while rendering React component. Scripts inside React components are never executed when rendering on the client. Consider using template tag instead (https://developer.mozilla.org/en-US/docs/Web/HTML/Element/template)."), didWarnScriptTags = !0);
                                        nextResource.innerHTML = "<script>\x3c/script>";
                                        nextResource = nextResource.removeChild(nextResource.firstChild);
                                        break;
                                    case "select":
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                                            is: newProps.is
                                        }) : nextResource.createElement("select");
                                        newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                        break;
                                    default:
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                                            is: newProps.is
                                        }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type)));
                                }
                        }
                        nextResource[internalInstanceKey] = workInProgress;
                        nextResource[internalPropsKey] = newProps;
                        a: for(_currentHostContext = workInProgress.child; null !== _currentHostContext;){
                            if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag) nextResource.appendChild(_currentHostContext.stateNode);
                            else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                                _currentHostContext.child.return = _currentHostContext;
                                _currentHostContext = _currentHostContext.child;
                                continue;
                            }
                            if (_currentHostContext === workInProgress) break a;
                            for(; null === _currentHostContext.sibling;){
                                if (null === _currentHostContext.return || _currentHostContext.return === workInProgress) break a;
                                _currentHostContext = _currentHostContext.return;
                            }
                            _currentHostContext.sibling.return = _currentHostContext.return;
                            _currentHostContext = _currentHostContext.sibling;
                        }
                        workInProgress.stateNode = nextResource;
                        a: switch(setInitialProperties(nextResource, type, newProps), type){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                newProps = !!newProps.autoFocus;
                                break a;
                            case "img":
                                newProps = !0;
                                break a;
                            default:
                                newProps = !1;
                        }
                        newProps && markUpdate(workInProgress);
                    }
                }
                bubbleProperties(workInProgress);
                workInProgress.subtreeFlags &= -33554433;
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    current = requiredContext(rootInstanceStackCursor.current);
                    renderLanes = getHostContext();
                    if (popHydrationState(workInProgress)) {
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        type = !didSuspendOrErrorDEV;
                        newProps = null;
                        nextResource = hydrationParentFiber;
                        if (null !== nextResource) switch(nextResource.tag){
                            case 3:
                                type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                                break;
                            case 27:
                            case 5:
                                newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                        }
                        current[internalInstanceKey] = workInProgress;
                        current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                        current || throwOnHydrationMismatch(workInProgress, !0);
                    } else type = renderLanes.ancestorInfo.current, null != type && validateTextNesting(newProps, type.tag, renderLanes.ancestorInfo.implicitRootScope), current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 31:
                renderLanes = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState) {
                    newProps = popHydrationState(workInProgress);
                    if (null !== renderLanes) {
                        if (null === current) {
                            if (!newProps) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            current = workInProgress.memoizedState;
                            current = null !== current ? current.dehydrated : null;
                            if (!current) throw Error("Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue.");
                            current[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (renderLanes = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        current = !1;
                    } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                    if (!current) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                    if (0 !== (workInProgress.flags & 128)) throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    type = newProps;
                    nextResource = popHydrationState(workInProgress);
                    if (null !== type && null !== type.dehydrated) {
                        if (null === current) {
                            if (!nextResource) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            nextResource = workInProgress.memoizedState;
                            nextResource = null !== nextResource ? nextResource.dehydrated : null;
                            if (!nextResource) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
                            nextResource[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (type = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        type = !1;
                    } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                    if (!type) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                (workInProgress.mode & ProfileMode) !== NoMode && renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                return null;
            case 4:
                return popHostContainer(workInProgress), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), bubbleProperties(workInProgress), null;
            case 19:
                popSuspenseListContext(workInProgress);
                newProps = workInProgress.memoizedState;
                if (null === newProps) return bubbleProperties(workInProgress), null;
                type = 0 !== (workInProgress.flags & 128);
                nextResource = newProps.rendering;
                if (null === nextResource) {
                    if (type) cutOffTailIfNeeded(newProps, !1);
                    else {
                        if (workInProgressRootExitStatus !== RootInProgress || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            nextResource = findFirstSuspended(current);
                            if (null !== nextResource) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(newProps, !1);
                                current = nextResource.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                pushSuspenseListContext(workInProgress, suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback);
                                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== newProps.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!type) {
                        if (current = findFirstSuspended(nextResource), null !== current) {
                            if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now$1() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                    newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
                }
                if (null !== newProps.tail) {
                    current = newProps.tail;
                    a: {
                        for(renderLanes = current; null !== renderLanes;){
                            if (null !== renderLanes.alternate) {
                                renderLanes = !1;
                                break a;
                            }
                            renderLanes = renderLanes.sibling;
                        }
                        renderLanes = !0;
                    }
                    newProps.rendering = current;
                    newProps.tail = current.sibling;
                    newProps.renderingStartTime = now$1();
                    current.sibling = null;
                    nextResource = suspenseStackCursor.current;
                    nextResource = type ? nextResource & SubtreeSuspenseContextMask | ForceSuspenseFallback : nextResource & SubtreeSuspenseContextMask;
                    "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || isHydrating ? pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, push(suspenseHandlerStackCursor, workInProgress, workInProgress), push(suspenseStackCursor, renderLanes, workInProgress), null === shellBoundary && (shellBoundary = workInProgress));
                    isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                    return current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache, workInProgress), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext, workInProgress), bubbleProperties(workInProgress), null;
            case 25:
                return null;
            case 30:
                return workInProgress.flags |= 33554432, bubbleProperties(workInProgress), null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 3:
                return popProvider(CacheContext, workInProgress), popHostContainer(workInProgress), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 31:
                if (null !== workInProgress.memoizedState) {
                    popSuspenseHandler(workInProgress);
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 19:
                return popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
            case 4:
                return popHostContainer(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), null !== current && pop(resumedCache, workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 24:
                return popProvider(CacheContext, workInProgress), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext, interruptedWork);
                popHostContainer(interruptedWork);
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer(interruptedWork);
                break;
            case 31:
                null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                popSuspenseListContext(interruptedWork);
                break;
            case 10:
                popProvider(interruptedWork.type, interruptedWork);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext(interruptedWork);
                null !== current && pop(resumedCache, interruptedWork);
                break;
            case 24:
                popProvider(CacheContext, interruptedWork);
        }
    }
    function shouldProfile(current) {
        return (current.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = runWithFiberInDEV(finishedWork, callCreateInDEV, updateQueue), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
                        var hookName = void 0;
                        hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
                        var addendum = void 0;
                        addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
                        runWithFiberInDEV(finishedWork, function(n, a) {
                            console.error("%s must not return anything besides a function, which is used for clean-up.%s", n, a);
                        }, hookName, addendum);
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = finishedWork, runWithFiberInDEV(lastEffect, callDestroyInDEV, lastEffect, nearestMountedAncestor, destroy), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1));
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), instance.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
            try {
                runWithFiberInDEV(finishedWork, commitCallbacks, updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
        return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current) {
        var prevProps = current.memoizedProps, prevState = current.memoizedState;
        current = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), current.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
        try {
            var resolvedPrevProps = resolveClassComponentProps(finishedWork.type, prevProps);
            var snapshot = runWithFiberInDEV(finishedWork, callGetSnapshotBeforeUpdates, current, resolvedPrevProps, prevState);
            prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
            void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
                console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
            }));
            current.__reactInternalSnapshotBeforeUpdate = snapshot;
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        shouldProfile(current) ? (startEffectTimer(), runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance), recordEffectDuration()) : runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance);
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (null !== ref) {
            switch(finishedWork.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = finishedWork.stateNode;
                    break;
                case 30:
                    instanceToUse = finishedWork.stateNode;
                    var name = getViewTransitionName(finishedWork.memoizedProps, instanceToUse);
                    if (null === instanceToUse.ref || instanceToUse.ref.name !== name) instanceToUse.ref = createViewTransitionInstance(name);
                    instanceToUse = instanceToUse.ref;
                    break;
                case 7:
                    null === finishedWork.stateNode && (instanceToUse = new FragmentInstance(finishedWork), traverseFragmentInstancesAndTextInstances(finishedWork, addFragmentHandleToFiber, instanceToUse), finishedWork.stateNode = instanceToUse);
                    instanceToUse = finishedWork.stateNode;
                    break;
                default:
                    instanceToUse = finishedWork.stateNode;
            }
            if ("function" === typeof ref) {
                if (shouldProfile(finishedWork)) try {
                    startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
                } finally{
                    recordEffectDuration();
                }
                else finishedWork.refCleanup = ref(instanceToUse);
            } else "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork)), ref.current = instanceToUse;
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            runWithFiberInDEV(current, commitAttachRef, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, refCleanup);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, refCleanup);
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, ref, null);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, ref, null);
            } catch (error$8) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$8);
            }
            else ref.current = null;
        }
    }
    function commitProfiler(finishedWork, current, commitStartTime, effectDuration) {
        var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
        _finishedWork$memoize = _finishedWork$memoize.onRender;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize && _finishedWork$memoize(id, current, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitStartTime);
        "function" === typeof onCommit && onCommit(id, current, effectDuration, commitStartTime);
    }
    function commitProfilerPostCommitImpl(finishedWork, current, commitStartTime, passiveEffectDuration) {
        var _finishedWork$memoize2 = finishedWork.memoizedProps;
        finishedWork = _finishedWork$memoize2.id;
        _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(finishedWork, current, passiveEffectDuration, commitStartTime);
    }
    function commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
        if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
    }
    function commitFragmentInstanceInsertionEffects(fiber) {
        for(var parent = fiber.return; null !== parent;){
            isFragmentInstanceParent(parent) && commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
            if (isFragmentInstanceHostBoundary(parent)) break;
            parent = parent.return;
        }
    }
    function commitFragmentInstanceDeletionEffects(fiber) {
        for(var parent = fiber.return; null !== parent;){
            isFragmentInstanceParent(parent) && deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
            if (isFragmentInstanceHostBoundary(parent)) break;
            parent = parent.return;
        }
    }
    function isFragmentInstanceHostBoundary(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
    }
    function isFragmentInstanceParent(fiber) {
        return fiber && 7 === fiber.tag && null !== fiber.stateNode;
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            runWithFiberInDEV(finishedWork, commitMount, instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            runWithFiberInDEV(finishedWork, commitUpdate, finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
                if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) tag = node.stateNode, before ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before)) : (warnForReactChildrenConflict(parent), before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), tag = parent._reactRootContainer, null !== tag && void 0 !== tag || null !== before.onclick || (before.onclick = noop$1)), commitNewChildToFragmentInstances(node, parentFragmentInstances), viewTransitionMutationContext = !0;
        else if (4 !== tag && (27 === tag && (commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), commitNewChildToFragmentInstances(node, parentFragmentInstances), viewTransitionMutationContext = !0;
        else if (4 !== tag && (27 === tag && (commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
        for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
            if (isHostParent(parentFiber)) {
                hostParentFiber = parentFiber;
                break;
            }
            parentFiber = parentFiber.return;
        }
        parentFiber = null;
        for(var parent = finishedWork.return; null !== parent;){
            if (isFragmentInstanceParent(parent)) {
                var fragmentInstance = parent.stateNode;
                null === parentFiber ? parentFiber = [
                    fragmentInstance
                ] : parentFiber.push(fragmentInstance);
            }
            if (isFragmentInstanceHostBoundary(parent)) break;
            parent = parent.return;
        }
        if (null == hostParentFiber) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        switch(hostParentFiber.tag){
            case 27:
                hostParentFiber = hostParentFiber.stateNode;
                parent = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, parent, hostParentFiber, parentFiber);
                break;
            case 5:
                parent = hostParentFiber.stateNode;
                hostParentFiber.flags & 32 && (resetTextContent(parent), hostParentFiber.flags &= -33);
                hostParentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, hostParentFiber, parent, parentFiber);
                break;
            case 3:
            case 4:
                hostParentFiber = hostParentFiber.stateNode.containerInfo;
                parent = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, parent, hostParentFiber, parentFiber);
                break;
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitHostSingletonAcquisition(finishedWork) {
        var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
        try {
            runWithFiberInDEV(finishedWork, acquireSingletonInstance, finishedWork.type, props, singleton, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function trackEnterViewTransitions(placement) {
        if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) shouldStartViewTransition = !0;
    }
    function pushViewTransitionCancelableScope() {
        var prevChildren = viewTransitionCancelableChildren;
        viewTransitionCancelableChildren = null;
        return prevChildren;
    }
    function applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
        viewTransitionHostInstanceIdx = 0;
        (name = applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions)) && null != fiber._debugTask && null === animatingTask && (animatingTask = fiber._debugTask);
        return name;
    }
    function applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
        for(var inViewport = !1; null !== child;){
            if (5 === child.tag) {
                var _instance = child.stateNode;
                if (null !== collectMeasurements) {
                    var measurement = measureInstance(_instance);
                    collectMeasurements.push(measurement);
                    measurement.view && (inViewport = !0);
                } else inViewport || measureInstance(_instance).view && (inViewport = !0);
                shouldStartViewTransition = !0;
                applyViewTransitionName(_instance, 0 === viewTransitionHostInstanceIdx ? name : name + "_" + viewTransitionHostInstanceIdx, className);
                viewTransitionHostInstanceIdx++;
            } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
            child = child.sibling;
        }
        return inViewport;
    }
    function restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
        for(; null !== child;){
            if (5 === child.tag) restoreViewTransitionName(child.stateNode, child.memoizedProps);
            else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
            child = child.sibling;
        }
    }
    function commitAppearingPairViewTransitions(placement) {
        if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
            if (22 !== placement.tag || null === placement.memoizedState) {
                if (commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                    var props = placement.memoizedProps;
                    if (null == props.name || "auto" === props.name) throw Error("Found a pair with an auto name. This is a bug in React.");
                    var name = props.name;
                    props = getViewTransitionClassName(props.default, props.share);
                    "none" !== props && (applyViewTransitionToHostInstances(placement, name, props, null, !1) || restoreViewTransitionOnHostInstances(placement.child, !1));
                }
            }
            placement = placement.sibling;
        }
    }
    function commitEnterViewTransitions(placement, gesture) {
        if (30 === placement.tag) {
            var state = placement.stateNode, props = placement.memoizedProps, name = getViewTransitionName(props, state), className = getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
            "none" !== className ? applyViewTransitionToHostInstances(placement, name, className, null, !1) ? (commitAppearingPairViewTransitions(placement), state.paired || gesture || scheduleViewTransitionEvent(placement, props.onEnter)) : restoreViewTransitionOnHostInstances(placement.child, !1) : commitAppearingPairViewTransitions(placement);
        } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
        else commitAppearingPairViewTransitions(placement);
    }
    function commitDeletedPairViewTransitions(deletion) {
        if (null !== appearingViewTransitions && 0 !== appearingViewTransitions.size) {
            var pairs = appearingViewTransitions;
            if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
                if (22 !== deletion.tag || null === deletion.memoizedState) {
                    if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                        var props = deletion.memoizedProps, name = props.name;
                        if (null != name && "auto" !== name) {
                            var pair = pairs.get(name);
                            if (void 0 !== pair) {
                                var className = getViewTransitionClassName(props.default, props.share);
                                "none" !== className && (applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, scheduleViewTransitionEvent(deletion, props.onShare)) : restoreViewTransitionOnHostInstances(deletion.child, !1));
                                pairs.delete(name);
                                if (0 === pairs.size) break;
                            }
                        }
                    }
                    commitDeletedPairViewTransitions(deletion);
                }
                deletion = deletion.sibling;
            }
        }
    }
    function commitExitViewTransitions(deletion) {
        if (30 === deletion.tag) {
            var props = deletion.memoizedProps, name = getViewTransitionName(props, deletion.stateNode), pair = null !== appearingViewTransitions ? appearingViewTransitions.get(name) : void 0, className = getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
            "none" !== className && (applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, appearingViewTransitions.delete(name), scheduleViewTransitionEvent(deletion, props.onShare)) : scheduleViewTransitionEvent(deletion, props.onExit) : restoreViewTransitionOnHostInstances(deletion.child, !1));
            null !== appearingViewTransitions && commitDeletedPairViewTransitions(deletion);
        } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)commitExitViewTransitions(deletion), deletion = deletion.sibling;
        else null !== appearingViewTransitions && commitDeletedPairViewTransitions(deletion);
    }
    function commitNestedViewTransitions(changedParent) {
        for(changedParent = changedParent.child; null !== changedParent;){
            if (30 === changedParent.tag) {
                var props = changedParent.memoizedProps, name = getViewTransitionName(props, changedParent.stateNode);
                props = getViewTransitionClassName(props.default, props.update);
                changedParent.flags &= -5;
                "none" !== props && applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
            } else 0 !== (changedParent.subtreeFlags & 33554432) && commitNestedViewTransitions(changedParent);
            changedParent = changedParent.sibling;
        }
    }
    function restorePairedViewTransitions(parent) {
        if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
            if (22 !== parent.tag || null === parent.memoizedState) {
                if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                    var instance = parent.stateNode;
                    null !== instance.paired && (instance.paired = null, restoreViewTransitionOnHostInstances(parent.child, !1));
                }
                restorePairedViewTransitions(parent);
            }
            parent = parent.sibling;
        }
    }
    function restoreEnterOrExitViewTransitions(fiber) {
        if (30 === fiber.tag) fiber.stateNode.paired = null, restoreViewTransitionOnHostInstances(fiber.child, !1), restorePairedViewTransitions(fiber);
        else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
        else restorePairedViewTransitions(fiber);
    }
    function restoreNestedViewTransitions(changedParent) {
        for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
    }
    function measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
        for(var inViewport = !1; null !== child;){
            if (5 === child.tag) {
                var _instance2 = child.stateNode;
                if (null !== previousMeasurements && viewTransitionHostInstanceIdx < previousMeasurements.length) {
                    var previousMeasurement = previousMeasurements[viewTransitionHostInstanceIdx], nextMeasurement = measureInstance(_instance2);
                    if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                    var JSCompiler_temp;
                    if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                        if (nextMeasurement.clip) JSCompiler_temp = !0;
                        else {
                            JSCompiler_temp = previousMeasurement.rect;
                            var newRect = nextMeasurement.rect;
                            JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                        }
                    }
                    JSCompiler_temp && (parentViewTransition.flags |= 4);
                    nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                    nextMeasurement && (parentViewTransition.flags |= 32);
                } else parentViewTransition.flags |= 32;
                0 !== (parentViewTransition.flags & 4) && applyViewTransitionName(_instance2, 0 === viewTransitionHostInstanceIdx ? newName : newName + "_" + viewTransitionHostInstanceIdx, className);
                inViewport && 0 !== (parentViewTransition.flags & 4) || (null === viewTransitionCancelableChildren && (viewTransitionCancelableChildren = []), viewTransitionCancelableChildren.push(_instance2, 0 === viewTransitionHostInstanceIdx ? oldName : oldName + "_" + viewTransitionHostInstanceIdx, child.memoizedProps));
                viewTransitionHostInstanceIdx++;
            } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
            child = child.sibling;
        }
        return inViewport;
    }
    function measureNestedViewTransitions(changedParent, gesture) {
        for(changedParent = changedParent.child; null !== changedParent;){
            if (30 === changedParent.tag) {
                var props = changedParent.memoizedProps, state = changedParent.stateNode, name = getViewTransitionName(props, state), className = getViewTransitionClassName(props.default, props.update);
                if (gesture) {
                    state = state.clones;
                    var previousMeasurements = null === state ? null : state.map(measureClonedInstance);
                } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
                state = changedParent;
                var child = changedParent.child, newName = name;
                viewTransitionHostInstanceIdx = 0;
                className = measureViewTransitionHostInstancesRecursive(state, child, newName, name, className, previousMeasurements, !1);
                0 !== (changedParent.flags & 4) && className && (gesture || scheduleViewTransitionEvent(changedParent, props.onUpdate));
            } else 0 !== (changedParent.subtreeFlags & 33554432) && measureNestedViewTransitions(changedParent, gesture);
            changedParent = changedParent.sibling;
        }
    }
    function trackNamedViewTransition(fiber) {
        var name = fiber.memoizedProps.name;
        if (null != name && "auto" !== name) {
            var existing = mountedNamedViewTransitions.get(name);
            if (void 0 !== existing) {
                if (existing !== fiber && existing !== fiber.alternate && !didWarnAboutName[name]) {
                    didWarnAboutName[name] = !0;
                    var stringifiedName = JSON.stringify(name);
                    runWithFiberInDEV(fiber, function() {
                        console.error("There are two <ViewTransition name=%s> components with the same name mounted at the same time. This is not supported and will cause View Transitions to error. Try to use a more unique name e.g. by using a namespace prefix and adding the id of an item to the name.", stringifiedName);
                    });
                    runWithFiberInDEV(existing, function() {
                        console.error("The existing <ViewTransition name=%s> duplicate has this stack trace.", stringifiedName);
                    });
                }
            } else mountedNamedViewTransitions.set(name, fiber);
        }
    }
    function untrackNamedViewTransition(fiber) {
        var name = fiber.memoizedProps.name;
        if (null != name && "auto" !== name) {
            var existing = mountedNamedViewTransitions.get(name);
            void 0 === existing || existing !== fiber && existing !== fiber.alternate || mountedNamedViewTransitions.delete(name);
        }
    }
    function isHydratingParent(current, finishedWork) {
        return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current = current.memoizedState, finishedWork = finishedWork.memoizedState, null !== current && null !== current.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : !1;
    }
    function commitBeforeMutationEffects(root, firstChild, committedLanes) {
        root = root.containerInfo;
        eventsEnabled = _enabled;
        root = getActiveElementDeep(root);
        if (hasSelectionCapabilities(root)) {
            if ("selectionStart" in root) var JSCompiler_temp = {
                start: root.selectionStart,
                end: root.selectionEnd
            };
            else a: {
                JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
                var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
                if (selection && 0 !== selection.rangeCount) {
                    JSCompiler_temp = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                    selection = selection.focusOffset;
                    try {
                        JSCompiler_temp.nodeType, focusNode.nodeType;
                    } catch (e$3) {
                        JSCompiler_temp = null;
                        break a;
                    }
                    var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                    b: for(;;){
                        for(var next;;){
                            node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                            node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                            3 === node.nodeType && (length += node.nodeValue.length);
                            if (null === (next = node.firstChild)) break;
                            parentNode = node;
                            node = next;
                        }
                        for(;;){
                            if (node === root) break b;
                            parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                            parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                            if (null !== (next = node.nextSibling)) break;
                            node = parentNode;
                            parentNode = node.parentNode;
                        }
                        node = next;
                    }
                    JSCompiler_temp = -1 === start || -1 === end ? null : {
                        start: start,
                        end: end
                    };
                } else JSCompiler_temp = null;
            }
            JSCompiler_temp = JSCompiler_temp || {
                start: 0,
                end: 0
            };
        } else JSCompiler_temp = null;
        selectionInformation = {
            focusedElem: root,
            selectionRange: JSCompiler_temp
        };
        _enabled = !1;
        committedLanes = (committedLanes & 335544064) === committedLanes;
        nextEffect = firstChild;
        for(firstChild = committedLanes ? 9270 : 1024; null !== nextEffect;){
            root = nextEffect;
            if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
            if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && trackEnterViewTransitions(root), commitBeforeMutationEffects_complete(committedLanes);
            else {
                if (22 === root.tag) {
                    if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                        null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && commitExitViewTransitions(JSCompiler_temp);
                        commitBeforeMutationEffects_complete(committedLanes);
                        continue;
                    } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                        committedLanes && trackEnterViewTransitions(root);
                        commitBeforeMutationEffects_complete(committedLanes);
                        continue;
                    }
                }
                JSCompiler_temp = root.child;
                0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, nextEffect = JSCompiler_temp) : (committedLanes && commitNestedViewTransitions(root), commitBeforeMutationEffects_complete(committedLanes));
            }
        }
        appearingViewTransitions = null;
    }
    function commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, finishedWork = fiber, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = finishedWork.alternate, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    0 !== (flags & 1024) && null !== current && commitClassSnapshot(finishedWork, current);
                    break;
                case 3:
                    if (0 !== (flags & 1024)) {
                        if (isViewTransitionEligible = finishedWork.stateNode.containerInfo, finishedWork = isViewTransitionEligible.nodeType, 9 === finishedWork) clearContainerSparingly(isViewTransitionEligible);
                        else if (1 === finishedWork) switch(isViewTransitionEligible.nodeName){
                            case "HEAD":
                            case "HTML":
                            case "BODY":
                                clearContainerSparingly(isViewTransitionEligible);
                                break;
                            default:
                                isViewTransitionEligible.textContent = "";
                        }
                    }
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                case 30:
                    isViewTransitionEligible && null !== current && (isViewTransitionEligible = current, current = finishedWork, finishedWork = getViewTransitionName(isViewTransitionEligible.memoizedProps, isViewTransitionEligible.stateNode), current = current.memoizedProps, current = getViewTransitionClassName(current.default, current.update), "none" !== current && applyViewTransitionToHostInstances(isViewTransitionEligible, finishedWork, current, isViewTransitionEligible.memoizedState = [], !0));
                    break;
                default:
                    if (0 !== (flags & 1024)) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            isViewTransitionEligible = fiber.sibling;
            if (null !== isViewTransitionEligible) {
                isViewTransitionEligible.return = fiber.return;
                nextEffect = isViewTransitionEligible;
                break;
            }
            nextEffect = fiber.return;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance")), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot);
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
                        shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                current = pushNestedEffectDurations();
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    prevProps = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            prevProps = finishedWork.child.stateNode;
                            break;
                        case 1:
                            prevProps = finishedWork.child.stateNode;
                    }
                    try {
                        runWithFiberInDEV(finishedWork, commitCallbacks, flags, prevProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                finishedRoot.effectDuration += popNestedEffectDurations(current);
                break;
            case 27:
                null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (null === current) {
                    if (flags & 4) commitHostMount(finishedWork);
                    else if (flags & 64) {
                        finishedRoot = finishedWork.type;
                        current = finishedWork.memoizedProps;
                        prevProps = finishedWork.stateNode;
                        try {
                            runWithFiberInDEV(finishedWork, commitHydratedInstance, prevProps, finishedRoot, current, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, finishedRoot.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 31:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, flags))));
                break;
            case 22:
                flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!flags) {
                    var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    current = offscreenSubtreeIsHidden;
                    prevProps = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = flags;
                    (offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = IncludeHostSingletons, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= IncludeWorkInProgressEffects), recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = current;
                    offscreenSubtreeWasHidden = prevProps;
                }
                break;
            case 30:
                flags & 18874368 && trackNamedViewTransition(finishedWork);
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function hideOrUnhideAllChildren(parentFiber, isHidden) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
    }
    function hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
        switch(fiber.tag){
            case 5:
            case 26:
                try {
                    var instance = fiber.stateNode;
                    isHidden ? runWithFiberInDEV(fiber, hideInstance, instance) : runWithFiberInDEV(fiber, unhideInstance, fiber.stateNode, fiber.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                hideOrUnhideNearestPortals(fiber, isHidden);
                break;
            case 6:
                try {
                    var instance$jscomp$0 = fiber.stateNode;
                    isHidden ? runWithFiberInDEV(fiber, hideTextInstance, instance$jscomp$0) : runWithFiberInDEV(fiber, unhideTextInstance, instance$jscomp$0, fiber.memoizedProps);
                    viewTransitionMutationContext = !0;
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case 18:
                try {
                    var instance$jscomp$1 = fiber.stateNode;
                    isHidden ? runWithFiberInDEV(fiber, hideDehydratedBoundary, instance$jscomp$1) : runWithFiberInDEV(fiber, unhideDehydratedBoundary, fiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case 22:
            case 23:
                null === fiber.memoizedState && hideOrUnhideAllChildren(fiber, isHidden);
                break;
            default:
                hideOrUnhideAllChildren(fiber, isHidden);
        }
    }
    function hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
        if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
            a: {
                var fiber = parentFiber, isHidden = isHidden$jscomp$0;
                switch(fiber.tag){
                    case 4:
                        hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                        break a;
                    case 22:
                        null === fiber.memoizedState && hideOrUnhideNearestPortals(fiber, isHidden);
                        break a;
                    default:
                        hideOrUnhideNearestPortals(fiber, isHidden);
                }
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber._debugOwner = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(deletedFiber.tag){
            case 26:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !offscreenSubtreeWasHidden && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
                break;
            case 27:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                commitFragmentInstanceDeletionEffects(deletedFiber);
                var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                runWithFiberInDEV(deletedFiber, releaseSingletonInstance, deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor), commitFragmentInstanceDeletionEffects(deletedFiber);
            case 6:
                6 === deletedFiber.tag && commitFragmentInstanceDeletionEffects(deletedFiber);
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (null !== hostParent) {
                    if (hostParentIsContainer) try {
                        runWithFiberInDEV(deletedFiber, removeChildFromContainer, hostParent, deletedFiber.stateNode), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                    else try {
                        runWithFiberInDEV(deletedFiber, removeChild, hostParent, deletedFiber.stateNode), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                }
                break;
            case 18:
                null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = !0;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(Insertion, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(deletedFiber, nearestMountedAncestor, Layout);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            case 30:
                deletedFiber.flags & 18874368 && untrackNamedViewTransition(deletedFiber);
                safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 7:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
        (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(deletedFiber, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
            finishedRoot = finishedRoot.dehydrated;
            try {
                runWithFiberInDEV(finishedWork, commitHydratedActivityInstance, finishedRoot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            runWithFiberInDEV(finishedWork, commitHydratedSuspenseInstance, finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 31:
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error("Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React.");
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            if (!retryCache.has(wakeable)) {
                retryCache.add(wakeable);
                if (isDevToolsPresent) {
                    if (null !== inProgressLanes && null !== inProgressRoot) restorePendingUpdaters(inProgressRoot, inProgressLanes);
                    else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                }
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                wakeable.then(retry, retry);
            }
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var root = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
            a: for(; null !== parent;){
                switch(parent.tag){
                    case 27:
                        if (isSingletonScope(parent.type)) {
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        }
                        break;
                    case 5:
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    case 3:
                    case 4:
                        hostParent = parent.stateNode.containerInfo;
                        hostParentIsContainer = !0;
                        break a;
                }
                parent = parent.return;
            }
            if (null === hostParent) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
            hostParent = null;
            hostParentIsContainer = !1;
            (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(deletedFiber, componentEffectStartTime, componentEffectEndTime, "Unmount");
            popComponentEffectStart(prevEffectStart);
            root = deletedFiber;
            returnFiber = root.alternate;
            null !== returnFiber && (returnFiber.return = null);
            root.return = null;
        }
        if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                    var _eventPayloads$ii2 = current[ii];
                    _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
                }
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout | HasEffect));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                flags & 64 && offscreenSubtreeIsHidden && (root = finishedWork.updateQueue, null !== root && (lanes = root.callbacks, null !== lanes && (flags = root.shared.hiddenCallbacks, root.shared.hiddenCallbacks = null === flags ? lanes : flags.concat(lanes))));
                break;
            case 26:
                ii = currentHoistableRoot;
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 4) {
                    if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                        if (null === lanes) {
                            if (null === finishedWork.stateNode) {
                                if (offscreenSubtreeIsHidden) finishedWork.stateNode = createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                                else {
                                    a: {
                                        root = finishedWork.type;
                                        lanes = finishedWork.memoizedProps;
                                        flags = ii.ownerDocument || ii;
                                        b: switch(root){
                                            case "title":
                                                current = flags.getElementsByTagName("title")[0];
                                                if (!current || current[internalHoistableMarker] || current[internalInstanceKey] || current.namespaceURI === SVG_NAMESPACE || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                                setInitialProperties(current, root, lanes);
                                                current[internalInstanceKey] = finishedWork;
                                                markNodeAsHoistable(current);
                                                root = current;
                                                break a;
                                            case "link":
                                                if (ii = getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                    for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                        ii.splice(_eventPayloads$ii2, 1);
                                                        break b;
                                                    }
                                                }
                                                current = flags.createElement(root);
                                                setInitialProperties(current, root, lanes);
                                                flags.head.appendChild(current);
                                                break;
                                            case "meta":
                                                if (ii = getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                    for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], checkAttributeStringCoercion(lanes.content, "content"), current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                        ii.splice(_eventPayloads$ii2, 1);
                                                        break b;
                                                    }
                                                }
                                                current = flags.createElement(root);
                                                setInitialProperties(current, root, lanes);
                                                flags.head.appendChild(current);
                                                break;
                                            default:
                                                throw Error('getNodesForType encountered a type it did not expect: "' + root + '". This is a bug in React.');
                                        }
                                        current[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(current);
                                        root = current;
                                    }
                                    finishedWork.stateNode = root;
                                }
                            } else offscreenSubtreeIsHidden || mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                        } else finishedWork.stateNode = acquireResource(ii, lanes, finishedWork.memoizedProps);
                    } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? offscreenSubtreeIsHidden || mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                }
                break;
            case 27:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                break;
            case 5:
                ii = offscreenDirectParentIsHidden;
                offscreenDirectParentIsHidden = !1;
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                offscreenDirectParentIsHidden = ii;
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (finishedWork.flags & 32) {
                    root = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, resetTextContent, root), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
                flags & 1024 && (needsFormReset = !0, "form" !== finishedWork.type && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (null === finishedWork.stateNode) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    root = finishedWork.memoizedProps;
                    lanes = null !== current ? current.memoizedProps : root;
                    flags = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitTextUpdate, flags, lanes, root), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                ii = pushNestedEffectDurations();
                viewTransitionMutationContext = !1;
                tagCaches = null;
                _eventPayloads$ii2 = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(root.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                currentHoistableRoot = _eventPayloads$ii2;
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                    runWithFiberInDEV(finishedWork, commitHydratedContainer, root.containerInfo);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                root.effectDuration += popNestedEffectDurations(ii);
                viewTransitionMutationContext = !1;
                break;
            case 4:
                flags = offscreenDirectParentIsHidden;
                offscreenDirectParentIsHidden = offscreenSubtreeIsHidden;
                current = pushMutationContext();
                ii = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                currentHoistableRoot = ii;
                viewTransitionMutationContext && inUpdateViewTransition && (rootViewTransitionAffected = !0);
                viewTransitionMutationContext = current;
                offscreenDirectParentIsHidden = flags;
                break;
            case 12:
                flags = pushNestedEffectDurations();
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
                break;
            case 31:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now$1());
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
                break;
            case 22:
                ii = null !== finishedWork.memoizedState;
                _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
                var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden, _prevOffscreenDirectParentIsHidden2 = offscreenDirectParentIsHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
                offscreenDirectParentIsHidden = _prevOffscreenDirectParentIsHidden2 || ii;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenDirectParentIsHidden = _prevOffscreenDirectParentIsHidden2;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                _eventPayloads$ii2 && !ii && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime);
                commitReconciliationEffects(finishedWork);
                flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & ~OffscreenVisible : root._visibility | OffscreenVisible, !ii || null === current || _eventPayloads$ii2 || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (root = IncludeHostSingletons, lanes = _eventPayloads$ii2 || offscreenSubtreeWasHidden, current = offscreenSubtreeIsHidden, _eventPayloads$ii2 = offscreenSubtreeWasHidden, offscreenSubtreeIsHidden = ii || offscreenSubtreeIsHidden, offscreenSubtreeWasHidden = lanes, recursivelyTraverseDisappearLayoutEffects(finishedWork, root), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect"), offscreenSubtreeIsHidden = current, offscreenSubtreeWasHidden = _eventPayloads$ii2), !ii && offscreenDirectParentIsHidden || hideOrUnhideAllChildren(finishedWork, ii));
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, attachSuspenseRetryListeners(finishedWork, lanes))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
                break;
            case 30:
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                flags = pushMutationContext();
                ii = inUpdateViewTransition;
                _eventPayloads$ii2 = (lanes & 335544064) === lanes;
                prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
                inUpdateViewTransition = _eventPayloads$ii2 && "none" !== getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                _eventPayloads$ii2 && null !== current && viewTransitionMutationContext && (finishedWork.flags |= 4);
                inUpdateViewTransition = ii;
                viewTransitionMutationContext = flags;
                break;
            case 21:
                break;
            case 7:
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
            default:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes), commitReconciliationEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, _enabled = !0, fiber.reset(), _enabled = !1);
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseAfterMutationEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
        else measureNestedViewTransitions(parentFiber, !1);
    }
    function commitAfterMutationEffectsOnFiber(finishedWork, root) {
        var current = finishedWork.alternate;
        if (null === current) commitEnterViewTransitions(finishedWork, !1);
        else switch(finishedWork.tag){
            case 3:
                rootViewTransitionNameCanceled = viewTransitionContextChanged = !1;
                pushViewTransitionCancelableScope();
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                if (!viewTransitionContextChanged && !rootViewTransitionAffected) {
                    finishedWork = viewTransitionCancelableChildren;
                    if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                        current = finishedWork[i];
                        var oldName = finishedWork[i + 1];
                        restoreViewTransitionName(current, finishedWork[i + 2]);
                        current = current.ownerDocument.documentElement;
                        null !== current && current.animate({
                            opacity: [
                                0,
                                0
                            ],
                            pointerEvents: [
                                "none",
                                "none"
                            ]
                        }, {
                            duration: 0,
                            fill: "forwards",
                            pseudoElement: "::view-transition-group(" + oldName + ")"
                        });
                    }
                    finishedWork = root.containerInfo;
                    finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                    null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(root)"
                    }), finishedWork.animate({
                        width: [
                            0,
                            0
                        ],
                        height: [
                            0,
                            0
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition"
                    }));
                    rootViewTransitionNameCanceled = !0;
                }
                viewTransitionCancelableChildren = null;
                break;
            case 5:
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                break;
            case 4:
                i = viewTransitionContextChanged;
                viewTransitionContextChanged = !1;
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                viewTransitionContextChanged && (rootViewTransitionAffected = !0);
                viewTransitionContextChanged = i;
                break;
            case 22:
                null === finishedWork.memoizedState && (null !== current.memoizedState ? commitEnterViewTransitions(finishedWork, !1) : recursivelyTraverseAfterMutationEffects(root, finishedWork));
                break;
            case 30:
                i = viewTransitionContextChanged;
                oldName = pushViewTransitionCancelableScope();
                viewTransitionContextChanged = !1;
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                viewTransitionContextChanged && (finishedWork.flags |= 4);
                var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
                root = getViewTransitionName(props, state);
                state = getViewTransitionName(current.memoizedProps, state);
                var className = getViewTransitionClassName(props.default, props.update);
                "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, viewTransitionHostInstanceIdx = 0, root = measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
                0 !== (finishedWork.flags & 4) && root ? (scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, viewTransitionCancelableChildren), viewTransitionCancelableChildren = oldName);
                viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
                break;
            default:
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork, layoutEffectTraversalFlags) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                (layoutEffectTraversalFlags & IncludeHostSingletons) !== NoLayoutEffectTraversalFlags && runWithFiberInDEV(finishedWork, releaseSingletonInstance, finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || commitFragmentInstanceDeletionEffects(finishedWork);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                finishedWork.flags & 18874368 && untrackNamedViewTransition(finishedWork);
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                safelyDetachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)disappearLayoutEffects(parentFiber, layoutEffectTraversalFlags), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current, finishedWork, layoutEffectTraversalFlags) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags, includeWorkInProgressEffects = (layoutEffectTraversalFlags & IncludeWorkInProgressEffects) !== NoLayoutEffectTraversalFlags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                commitHookLayoutEffects(finishedWork, Layout);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork.stateNode;
                "function" === typeof current.componentDidMount && runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, current);
                current = finishedWork.updateQueue;
                if (null !== current) {
                    finishedRoot = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitHiddenCallbacks, current, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                (layoutEffectTraversalFlags & IncludeHostSingletons) !== NoLayoutEffectTraversalFlags && commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || commitFragmentInstanceInsertionEffects(finishedWork);
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || offscreenSubtreeIsHidden || mountHoistable(getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (includeWorkInProgressEffects && flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                    includeWorkInProgressEffects = finishedWork.stateNode;
                    includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, includeWorkInProgressEffects.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                flags & 18874368 && trackNamedViewTransition(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                safelyAttachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, layoutEffectTraversalFlags) {
        layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & ~IncludeWorkInProgressEffects;
        for(parentFiber = parentFiber.child; null !== parentFiber;)reappearLayoutEffects(finishedRoot, parentFiber.alternate, parentFiber, layoutEffectTraversalFlags), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && retainCache(current), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (retainCache(finishedWork), null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions, endTime) {
        var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
        if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(parentFiber = parentFiber.child; null !== parentFiber;)isViewTransitionEligible = parentFiber.sibling, commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions, null !== isViewTransitionEligible ? isViewTransitionEligible.actualStartTime : endTime), parentFiber = isViewTransitionEligible;
        else isViewTransitionEligible && restoreNestedViewTransitions(parentFiber);
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
        isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && restoreEnterOrExitViewTransitions(finishedWork);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
                break;
            case 1:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, []) : 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
                inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = wasInHydratedSubtree;
                isViewTransitionEligible && rootViewTransitionNameCanceled && (committedLanes = finishedRoot.containerInfo, committedLanes = 9 === committedLanes.nodeType ? committedLanes.body : "HTML" === committedLanes.nodeName ? committedLanes.ownerDocument.body : committedLanes, "root" === committedLanes.style.viewTransitionName && (committedLanes.style.viewTransitionName = ""), committedLanes = committedLanes.ownerDocument.documentElement, null !== committedLanes && "none" === committedLanes.style.viewTransitionName && (committedLanes.style.viewTransitionName = ""));
                flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
                finishedRoot.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                if (flags & 2048) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfilerPostCommitImpl, finishedWork, finishedWork.alternate, commitStartTime, finishedRoot.passiveEffectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 31:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                isViewTransitionEligible = finishedWork.memoizedState;
                null !== prevProfilerEffectDuration && null === isViewTransitionEligible ? (isViewTransitionEligible = finishedWork.deletions, null !== isViewTransitionEligible && 0 < isViewTransitionEligible.length && 18 === isViewTransitionEligible[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0) : inHydratedSubtree = !1;
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 13:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                isViewTransitionEligible = finishedWork.memoizedState;
                null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== isViewTransitionEligible && null !== isViewTransitionEligible.dehydrated ? inHydratedSubtree = !1 : (isViewTransitionEligible = finishedWork.deletions, null !== isViewTransitionEligible && 0 < isViewTransitionEligible.length && 18 === isViewTransitionEligible[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 23:
                break;
            case 22:
                wasInHydratedSubtree = finishedWork.stateNode;
                prevProfilerEffectDuration = finishedWork.alternate;
                null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== prevProfilerEffectDuration && null === prevProfilerEffectDuration.memoizedState && restoreEnterOrExitViewTransitions(prevProfilerEffectDuration), wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime)) : (isViewTransitionEligible && null !== prevProfilerEffectDuration && null !== prevProfilerEffectDuration.memoizedState && restoreEnterOrExitViewTransitions(finishedWork), wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child), endTime), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime))));
                flags & 2048 && commitOffscreenPassiveMountEffects(prevProfilerEffectDuration, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            case 30:
                isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && (restoreViewTransitionOnHostInstances(flags.child, !0), restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
        }
        if ((finishedWork.mode & ProfileMode) !== NoMode) {
            if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate) committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(finishedWork, committedLanes, endTime, "Mount");
            0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount"));
        }
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            reconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
        includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                commitHookPassiveMountEffects(finishedWork, Passive);
                break;
            case 23:
                break;
            case 22:
                var _instance4 = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? _instance4._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (_instance4._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(var child = parentFiber.child; null !== child;){
            parentFiber = child.sibling;
            var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
            (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(child, child.actualStartTime, endTime, inHydratedSubtree, committedLanes);
            var flags = child.flags;
            switch(child.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
            }
            alreadyWarnedForDeepEquality = prevDeepEquality;
            child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && (null !== fiber.memoizedState ? suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && suspendInstance(suspendedState, fiber)));
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && suspendInstance(suspendedState, fiber));
                break;
            case 3:
            case 4:
                var previousHoistableRoot = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                currentHoistableRoot = previousHoistableRoot;
                break;
            case 22:
                null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
                break;
            case 30:
                if (0 !== (fiber.flags & suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                    var state = fiber.stateNode;
                    state.paired = null;
                    null === appearingViewTransitions && (appearingViewTransitions = new Map());
                    appearingViewTransitions.set(previousHoistableRoot, state);
                }
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive | HasEffect);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 22:
                prevProfilerEffectDuration = finishedWork.stateNode;
                null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;)disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive);
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, current = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
            switch(current.tag){
                case 0:
                case 11:
                case 15:
                    commitHookPassiveUnmountEffects(current, nearestMountedAncestor, Passive);
                    break;
                case 23:
                case 22:
                    null !== current.memoizedState && null !== current.memoizedState.cachePool && (nearestMountedAncestor = current.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
                    break;
                case 24:
                    releaseCache(current.memoizedState.cache);
            }
            (current.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(current, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
            popComponentEffectStart(prevEffectStart);
            popComponentEffectDuration(prevEffectDuration);
            componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
            componentEffectErrors = prevEffectErrors;
            current = fiber.child;
            if (null !== current) current.return = fiber, nextEffect = current;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                current = nextEffect;
                prevEffectStart = current.sibling;
                prevEffectDuration = current.return;
                detachFiberAfterEffects(current);
                if (current === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== prevEffectStart) {
                    prevEffectStart.return = prevEffectDuration;
                    nextEffect = prevEffectStart;
                    break a;
                }
                nextEffect = prevEffectDuration;
            }
        }
    }
    function onCommitRoot() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
        isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
        if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
        var transition = ReactSharedInternals.T;
        if (null !== transition) return transition._updatedFibers || (transition._updatedFibers = new Set()), transition._updatedFibers.add(fiber), null !== lastSuspendedFiber && resolveUpdatePriority() === DiscreteEventPriority && (lastSuspendedFiber = null), requestTransitionLane();
        fiber = resolveUpdatePriority();
        fiber === DiscreteEventPriority && (lastSuspendedFiber = null);
        return fiber;
    }
    function requestDeferredLane() {
        if (0 === workInProgressDeferredLane) {
            if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
                var lane = nextTransitionDeferredLane;
                nextTransitionDeferredLane <<= 1;
                0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
                workInProgressDeferredLane = lane;
            } else workInProgressDeferredLane = 536870912;
        }
        lane = suspenseHandlerStackCursor.current;
        null !== lane && (lane.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleViewTransitionEvent(fiber, callback) {
        if (null != callback) {
            var state = fiber.stateNode, instance = state.ref;
            null === instance && (instance = state.ref = createViewTransitionInstance(getViewTransitionName(fiber.memoizedProps, state)));
            null === pendingViewTransitionEvents && (pendingViewTransitionEvents = []);
            pendingViewTransitionEvents.push(callback.bind(null, instance));
        }
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
        isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = !0);
        if (root === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if ((executionContext & RenderContext) !== NoContext && root === workInProgressRoot) {
            if (isRendering) switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    root = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
                    didWarnAboutUpdateInRenderForAnotherComponent.has(root) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", fiber, root, root));
                    break;
                case 1:
                    didWarnAboutUpdateInRender || (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), didWarnAboutUpdateInRender = !0);
            }
        } else isDevToolsPresent && addFiberToLanesMap(root, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root, lanes, forceSync) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
            var yieldedFiber = workInProgress, yieldEndTime = now$1();
            switch(yieldReason){
                case SuspendedOnImmediate:
                case SuspendedOnData:
                    var startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                case SuspendedOnAction:
                    startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                default:
                    supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp("Blocked", yieldStartTime, yieldEndTime, COMPONENTS_TRACK, void 0, 5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"));
            }
        }
        startTime = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root.expiredLanes) || checkIfRootIsPrerendering(root, lanes)) ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes, !0);
        var renderWasConcurrent = forceSync;
        do {
            if (startTime === RootInProgress) {
                workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root, lanes, 0, !1);
                lanes = workInProgressSuspendedReason;
                yieldStartTime = now();
                yieldReason = lanes;
                break;
            } else {
                yieldedFiber = now$1();
                yieldEndTime = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
                    setCurrentTrackFromLanes(lanes);
                    yieldEndTime = renderStartTime;
                    startTime = yieldedFiber;
                    !supportsUserTiming || startTime <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, "Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error"));
                    finalizeRender(lanes, yieldedFiber);
                    startTime = renderRootSync(root, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (startTime === RootErrored) {
                    renderWasConcurrent = lanes;
                    if (root.errorRecoveryDisabledLanes & renderWasConcurrent) var errorRetryLanes = 0;
                    else errorRetryLanes = root.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
                    if (0 !== errorRetryLanes) {
                        setCurrentTrackFromLanes(lanes);
                        logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                        finalizeRender(lanes, yieldedFiber);
                        lanes = errorRetryLanes;
                        a: {
                            yieldedFiber = root;
                            startTime = renderWasConcurrent;
                            renderWasConcurrent = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                            errorRetryLanes = renderRootSync(yieldedFiber, errorRetryLanes, !1);
                            if (errorRetryLanes !== RootErrored && errorRetryLanes !== RootSuspendedAtTheShell) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
                                    workInProgressRootInterleavedUpdatedLanes |= startTime;
                                    startTime = RootSuspendedWithDelay;
                                    break a;
                                }
                                yieldedFiber = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = renderWasConcurrent;
                                null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, yieldedFiber));
                            }
                            startTime = errorRetryLanes;
                        }
                        renderWasConcurrent = !1;
                        if (startTime !== RootErrored) continue;
                        else yieldedFiber = now$1();
                    }
                }
                if (startTime === RootFatalErrored) {
                    setCurrentTrackFromLanes(lanes);
                    logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                    finalizeRender(lanes, yieldedFiber);
                    prepareFreshStack(root, 0);
                    markRootSuspended(root, lanes, 0, !0);
                    break;
                }
                a: {
                    forceSync = root;
                    switch(startTime){
                        case RootInProgress:
                        case RootFatalErrored:
                            throw Error("Root did not complete. This is a bug in React.");
                        case RootSuspendedWithDelay:
                            if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                        case RootSuspendedAtTheShell:
                            setCurrentTrackFromLanes(lanes);
                            logSuspendedRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                            finalizeRender(lanes, yieldedFiber);
                            yieldEndTime = lanes;
                            0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        case RootErrored:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case RootSuspended:
                        case RootCompleted:
                            break;
                        default:
                            throw Error("Unknown root exit status.");
                    }
                    if (null !== ReactSharedInternals.actQueue) completeRoot(forceSync, yieldEndTime, lanes, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, null, renderStartTime, yieldedFiber);
                    else {
                        if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            if (0 !== getNextLanes(forceSync, 0, !0)) break a;
                            pendingEffectsLanes = lanes;
                            forceSync.timeoutHandle = scheduleTimeout(completeRootWhenReady.bind(null, forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, "Throttled", renderStartTime, yieldedFiber), renderWasConcurrent);
                            break a;
                        }
                        completeRootWhenReady(forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, renderStartTime, yieldedFiber);
                    }
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root);
    }
    function completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.timeoutHandle = noTimeout;
        var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes, suspendedState = null;
        if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
            if (suspendedState = {
                stylesheets: null,
                count: 0,
                imgCount: 0,
                imgBytes: 0,
                suspenseyImages: [],
                waitingForImages: !0,
                waitingForViewTransition: !1,
                unsuspend: noop$1
            }, appearingViewTransitions = null, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), isViewTransitionEligible && (subtreeFlags = suspendedState, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$1() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$1() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
                pendingEffectsLanes = lanes;
                root.cancelPendingCommit = subtreeFlags(completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState, suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes = getEntangledLanes(root, suspendedLanes);
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            didAttemptEntireTree[index] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
        return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (workInProgressSuspendedReason === NotSuspended) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function finalizeRender(lanes, finalizationTime) {
        0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
        0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
        0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
        0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root, lanes) {
        supportsUserTiming && (console.timeStamp("Blocking Track", 0.003, 0.003, "Blocking", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Transition Track", 0.003, 0.003, "Transition", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Suspense Track", 0.003, 0.003, "Suspense", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Idle Track", 0.003, 0.003, "Idle", LANES_TRACK_GROUP, "primary-light"));
        var previousRenderStartTime = renderStartTime;
        renderStartTime = now();
        if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
            setCurrentTrackFromLanes(workInProgressRootRenderLanes);
            if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay) logSuspendedRenderPhase(previousRenderStartTime, renderStartTime, lanes, workInProgressUpdateTask);
            else {
                var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
                if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
                    var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
                    debugTask ? debugTask.run(console.timeStamp.bind(console, label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
                }
            }
            finalizeRender(workInProgressRootRenderLanes, renderStartTime);
        }
        previousRenderStartTime = workInProgressUpdateTask;
        workInProgressUpdateTask = null;
        if (0 !== (lanes & 127)) {
            workInProgressUpdateTask = blockingUpdateTask;
            debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
            endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
            color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
            0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(blockingSuspendedTime, color, lanes, previousRenderStartTime)) : 0 !== (animatingLanes & 127) && (setCurrentTrackFromLanes(2), logAnimatingPhase(blockingClampTime, color, animatingTask));
            previousRenderStartTime = debugTask;
            var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
            debugTask = renderStartTime;
            endTime = blockingUpdateTask;
            color = blockingUpdateMethodName;
            label = blockingUpdateComponentName;
            if (supportsUserTiming) {
                currentTrack = "Blocking";
                0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
                0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
                if (null !== eventType && previousRenderStartTime > eventTime) {
                    var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
                    endTime ? endTime.run(console.timeStamp.bind(console, eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0);
                }
                debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label && isPingedUpdate.push([
                    "Component name",
                    label
                ]), null != color && isPingedUpdate.push([
                    "Method name",
                    color
                ]), previousRenderStartTime = {
                    start: previousRenderStartTime,
                    end: debugTask,
                    detail: {
                        devtools: {
                            properties: isPingedUpdate,
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            color: eventTime
                        }
                    }
                }, endTime ? endTime.run(performance.measure.bind(performance, isSpawnedUpdate, previousRenderStartTime)) : performance.measure(isSpawnedUpdate, previousRenderStartTime), performance.clearMeasures(isSpawnedUpdate));
            }
            blockingUpdateTime = -1.1;
            blockingUpdateType = 0;
            blockingUpdateComponentName = blockingUpdateMethodName = null;
            blockingSuspendedTime = -1.1;
            blockingEventRepeatTime = blockingEventTime;
            blockingEventTime = -1.1;
            blockingClampTime = now();
        }
        0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(transitionSuspendedTime, color, lanes, workInProgressUpdateTask)) : 0 !== (animatingLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, color, animatingTask)), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(console.timeStamp.bind(console, eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)), previousRenderStartTime > debugTask && (endTime ? endTime.run(console.timeStamp.bind(console, "Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")) : console.timeStamp("Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push([
            "Component name",
            isSpawnedUpdate
        ]), null != label && isPingedUpdate.push([
            "Method name",
            label
        ]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: color,
            detail: {
                devtools: {
                    properties: isPingedUpdate,
                    track: currentTrack,
                    trackGroup: LANES_TRACK_GROUP,
                    color: "primary-light"
                }
            }
        }, endTime ? endTime.run(performance.measure.bind(performance, debugTask, previousRenderStartTime)) : performance.measure(debugTask, previousRenderStartTime), performance.clearMeasures(debugTask))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now());
        0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime, animatingTask));
        0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime, animatingTask));
        previousRenderStartTime = root.timeoutHandle;
        previousRenderStartTime !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
        previousRenderStartTime = root.cancelPendingCommit;
        null !== previousRenderStartTime && (root.cancelPendingCommit = null, previousRenderStartTime());
        pendingEffectsLanes = 0;
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = previousRenderStartTime = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = NotSuspended;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        entangledRenderLanes = getEntangledLanes(root, lanes);
        finishQueueingConcurrentUpdates();
        root = getCurrentTime();
        1e3 < root - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root);
        ReactStrictModeWarnings.discardPendingWarnings();
        return previousRenderStartTime;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        ReactSharedInternals.getCurrentStack = null;
        isRendering = !1;
        current = null;
        thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
        workInProgressThrownValue = thrownValue;
        var erroredWork = workInProgress;
        null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current))) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
        null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = RootSuspendedWithDelay;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            prepareFreshStack(root, lanes);
        }
        lanes = !1;
        memoizedUpdaters = workInProgressRootExitStatus;
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case SuspendedOnHydration:
                        resetWorkInProgressStack();
                        memoizedUpdaters = RootSuspendedAtTheShell;
                        break a;
                    case SuspendedOnImmediate:
                    case SuspendedOnData:
                    case SuspendedOnAction:
                    case SuspendedOnDeprecatedThrowPromise:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            memoizedUpdaters = RootInProgress;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            memoizedUpdaters = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$9) {
            handleThrow(root, thrownValue$9);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        resetContextDependencies();
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return memoizedUpdaters;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
            prepareFreshStack(root, lanes);
        } else workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) b: switch(lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason){
                case SuspendedOnError:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnError);
                    break;
                case SuspendedOnData:
                case SuspendedOnAction:
                    if (isThenableResolved(memoizedUpdaters)) {
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                        ensureRootIsScheduled(root);
                    };
                    memoizedUpdaters.then(lanes, lanes);
                    break a;
                case SuspendedOnImmediate:
                    workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                    break a;
                case SuspendedOnInstance:
                    workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                    break a;
                case SuspendedAndReadyToContinue:
                    isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedAndReadyToContinue));
                    break;
                case SuspendedOnInstanceAndReadyToContinue:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = NotSuspended;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                            break;
                        default:
                            console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
                    }
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnInstanceAndReadyToContinue);
                    break;
                case SuspendedOnDeprecatedThrowPromise:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnDeprecatedThrowPromise);
                    break;
                case SuspendedOnHydration:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = RootSuspendedAtTheShell;
                    break a;
                default:
                    throw Error("Unexpected SuspendedReason. This is a bug in React.");
            }
            null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
            break;
        } catch (thrownValue$10) {
            handleThrow(root, thrownValue$10);
        }
        while (1);
        resetContextDependencies();
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return RootInProgress;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === current ? completeUnitOfWork(unitOfWork) : workInProgress = current;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
        var current = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
        isProfilingMode && startProfilerTimer(unitOfWork);
        switch(unitOfWork.tag){
            case 15:
            case 0:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type.render, unitOfWork.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(unitOfWork);
                var fiber = unitOfWork;
                fiber === hydrationParentFiber && (isHydrating ? (popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && (nextHydratableInstance = fiber.stateNode)) : (popToNextHostParent(fiber), isHydrating = !0));
            default:
                unwindInterruptedWork(current, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current = beginWork(current, unitOfWork, entangledRenderLanes);
        }
        isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
        return current;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        resetContextDependencies();
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = RootFatalErrored;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = RootFatalErrored;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || suspendedReason === SuspendedOnError) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            var current = completedWork.alternate;
            unitOfWork = completedWork.return;
            startProfilerTimer(completedWork);
            current = runWithFiberInDEV(completedWork, completeWork, current, completedWork, entangledRenderLanes);
            (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
            if (null !== current) {
                workInProgress = current;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            if ((unitOfWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
                next = unitOfWork.actualDuration;
                for(var child = unitOfWork.child; null !== child;)next += child.actualDuration, child = child.sibling;
                unitOfWork.actualDuration = next;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = RootSuspendedAtTheShell;
        workInProgress = null;
    }
    function completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.cancelPendingCommit = null;
        do flushPendingEffects();
        while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        setCurrentTrackFromLanes(lanes);
        if (exitStatus === RootErrored) logErroredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask);
        else if (null !== recoverableErrors) {
            if (didSkipSuspendedSiblings = null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256), didIncludeRenderPhaseUpdate = workInProgressUpdateTask, supportsUserTiming && !(completedRenderEndTime <= completedRenderStartTime)) {
                exitStatus = [];
                for(var i = 0; i < recoverableErrors.length; i++){
                    var error = recoverableErrors[i].value;
                    exitStatus.push([
                        "Recoverable Error",
                        "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                    ]);
                }
                completedRenderStartTime = {
                    start: completedRenderStartTime,
                    end: completedRenderEndTime,
                    detail: {
                        devtools: {
                            color: "primary-dark",
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            tooltipText: didSkipSuspendedSiblings ? "Hydration Failed" : "Recovered after Error",
                            properties: exitStatus
                        }
                    }
                };
                didIncludeRenderPhaseUpdate ? didIncludeRenderPhaseUpdate.run(performance.measure.bind(performance, "Recovered", completedRenderStartTime)) : performance.measure("Recovered", completedRenderStartTime);
                performance.clearMeasures("Recovered");
            }
        } else didIncludeRenderPhaseUpdate = workInProgressUpdateTask, !supportsUserTiming || completedRenderEndTime <= completedRenderStartTime || (didSkipSuspendedSiblings = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", exitStatus = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render", didIncludeRenderPhaseUpdate ? didIncludeRenderPhaseUpdate.run(console.timeStamp.bind(console, exitStatus, completedRenderStartTime, completedRenderEndTime, currentTrack, LANES_TRACK_GROUP, didSkipSuspendedSiblings)) : console.timeStamp(exitStatus, completedRenderStartTime, completedRenderEndTime, currentTrack, LANES_TRACK_GROUP, didSkipSuspendedSiblings));
        if (null !== finishedWork) {
            0 === lanes && console.error("finishedLanes should not be empty during a commit. This is a bug in React.");
            if (finishedWork === root.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
            pendingFinishedWork = finishedWork;
            pendingEffectsRoot = root;
            pendingEffectsLanes = lanes;
            pendingPassiveTransitions = transitions;
            pendingRecoverableErrors = recoverableErrors;
            pendingEffectsRenderEndTime = completedRenderEndTime;
            pendingSuspendedCommitReason = suspendedCommitReason;
            pendingDelayedCommitReason = IMMEDIATE_COMMIT;
            pendingSuspendedViewTransitionReason = null;
            commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState, suspendedCommitReason, completedRenderEndTime);
        }
    }
    function commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState, suspendedCommitReason, completedRenderEndTime) {
        var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
        pendingEffectsRemainingLanes = remainingLanes;
        remainingLanes |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
        pendingViewTransitionEvents = null;
        (lanes & 335544064) === lanes ? (pendingTransitionTypes = claimQueuedTransitionTypes(root), spawnedLane = 10262) : (pendingTransitionTypes = null, spawnedLane = 10256);
        0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            schedulerEvent = window.event;
            pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
            flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        commitErrors = null;
        commitStartTime = now();
        null !== suspendedCommitReason && logSuspendedCommitPhase(completedRenderEndTime, commitStartTime, suspendedCommitReason, workInProgressUpdateTask);
        shouldStartViewTransition = !1;
        suspendedCommitReason = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || suspendedCommitReason) {
            suspendedCommitReason = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            completedRenderEndTime = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = DiscreteEventPriority;
            spawnedLane = executionContext;
            executionContext |= CommitContext;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = completedRenderEndTime, ReactSharedInternals.T = suspendedCommitReason;
            }
        }
        pendingEffectsStatus = PENDING_MUTATION_PHASE;
        shouldStartViewTransition ? (animatingLanes |= lanes, animatingTask = null, pendingViewTransition = startViewTransition(suspendedState, root.containerInfo, pendingTransitionTypes, flushMutationEffects, flushLayoutEffects, flushAfterMutationEffects, flushSpawnedWork, flushPassiveEffects, reportViewTransitionError, suspendedViewTransition, finishedViewTransition.bind(null, lanes))) : (flushMutationEffects(), flushLayoutEffects(), flushSpawnedWork());
    }
    function reportViewTransitionError(error) {
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS) {
            var onRecoverableError = pendingEffectsRoot.onRecoverableError;
            onRecoverableError(error, makeErrorInfo(null));
        }
    }
    function suspendedViewTransition(reason) {
        commitEndTime = now();
        logCommitPhase(null === pendingSuspendedCommitReason ? pendingEffectsRenderEndTime : commitStartTime, commitEndTime, commitErrors, pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT, workInProgressUpdateTask);
        pendingSuspendedCommitReason = pendingSuspendedViewTransitionReason = reason;
    }
    function finishedViewTransition(lanes) {
        if (0 !== (animatingLanes & lanes)) {
            var task = animatingTask;
            animatingLanes &= ~lanes;
            animatingTask = null;
            0 !== (lanes & 4194048) && 0 === (workInProgressRootRenderLanes & 4194048) && 0 === (pendingEffectsLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, now$1(), task));
            0 !== (lanes & 62914560) && 0 === (workInProgressRootRenderLanes & 62914560) && 0 === (pendingEffectsLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, now$1(), task));
            0 !== (lanes & 2080374784) && 0 === (workInProgressRootRenderLanes & 2080374784) && 0 === (pendingEffectsLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, now$1(), task));
        }
    }
    function flushAfterMutationEffects() {
        pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE && (pendingEffectsStatus = NO_PENDING_EFFECTS, commitAfterMutationEffectsOnFiber(pendingFinishedWork, pendingEffectsRoot), pendingEffectsStatus = PENDING_SPAWNED_WORK);
    }
    function flushMutationEffects() {
        if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
                rootMutationHasEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = lanes;
                    inProgressRoot = root;
                    inUpdateViewTransition = rootViewTransitionAffected = !1;
                    resetComponentEffectTimers();
                    commitMutationEffectsOnFiber(finishedWork, root, lanes);
                    inProgressRoot = inProgressLanes = null;
                    lanes = selectionInformation;
                    var curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                    if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                        if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                            var start = priorSelectionRange.start, end = priorSelectionRange.end;
                            void 0 === end && (end = start);
                            if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                            else {
                                var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                                if (win.getSelection) {
                                    var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                    !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                    var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                    if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                        var range = doc.createRange();
                                        range.setStart(startMarker.node, startMarker.offset);
                                        selection.removeAllRanges();
                                        start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                    }
                                }
                            }
                        }
                        doc = [];
                        for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                            element: selection,
                            left: selection.scrollLeft,
                            top: selection.scrollTop
                        });
                        "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                        for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                            var info = doc[priorFocusedElem];
                            info.element.scrollLeft = info.left;
                            info.element.scrollTop = info.top;
                        }
                    }
                    _enabled = !!eventsEnabled;
                    selectionInformation = eventsEnabled = null;
                } finally{
                    executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
                }
            }
            root.current = finishedWork;
            pendingEffectsStatus = PENDING_LAYOUT_PHASE;
        }
    }
    function flushLayoutEffects() {
        if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
            if (null !== suspendedViewTransitionReason) {
                commitStartTime = now();
                var startTime = commitEndTime, endTime = commitStartTime;
                !supportsUserTiming || endTime <= startTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            suspendedViewTransitionReason = pendingEffectsRoot;
            startTime = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
            if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
                rootHasLayoutEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var _previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var _prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(suspendedViewTransitionReason, startTime.alternate, startTime), inProgressRoot = inProgressLanes = null;
                } finally{
                    executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
                }
            }
            suspendedViewTransitionReason = pendingEffectsRenderEndTime;
            startTime = pendingSuspendedCommitReason;
            commitEndTime = now();
            logCommitPhase(null === startTime ? suspendedViewTransitionReason : commitStartTime, commitEndTime, commitErrors, pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT, workInProgressUpdateTask);
            pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
        }
    }
    function flushSpawnedWork() {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
            if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
                var startViewTransitionStartTime = commitEndTime;
                commitEndTime = now();
                var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
                !supportsUserTiming || endTime <= startViewTransitionStartTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-light")) : console.timeStamp(abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? " error" : "secondary-light"));
                pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
            }
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            startViewTransitionStartTime = pendingViewTransition;
            pendingViewTransition = null;
            requestPaint();
            endTime = pendingEffectsRoot;
            var finishedWork = pendingFinishedWork;
            abortedViewTransition = pendingEffectsLanes;
            var recoverableErrors = pendingRecoverableErrors, passiveSubtreeMask = (abortedViewTransition & 335544064) === abortedViewTransition ? 10262 : 10256;
            (passiveSubtreeMask = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask)) ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(endTime, endTime.pendingLanes), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
            var remainingLanes = endTime.pendingLanes;
            0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
            passiveSubtreeMask || commitDoubleInvokeEffectsInDEV(endTime);
            remainingLanes = lanesToEventPriority(abortedViewTransition);
            finishedWork = finishedWork.stateNode;
            if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
                var didError = 128 === (finishedWork.current.flags & 128);
                switch(remainingLanes){
                    case DiscreteEventPriority:
                        var schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority$1;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority$1;
                }
                injectedHook.onCommitFiberRoot(rendererID, finishedWork, schedulerPriority, didError);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            isDevToolsPresent && endTime.memoizedUpdaters.clear();
            onCommitRoot();
            if (null !== recoverableErrors) {
                didError = ReactSharedInternals.T;
                schedulerPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                ReactSharedInternals.T = null;
                try {
                    var onRecoverableError = endTime.onRecoverableError;
                    for(finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++){
                        var recoverableError = recoverableErrors[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
                        runWithFiberInDEV(recoverableError.source, onRecoverableError, recoverableError.value, errorInfo);
                    }
                } finally{
                    ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
                }
            }
            onRecoverableError = pendingViewTransitionEvents;
            recoverableError = pendingTransitionTypes;
            pendingTransitionTypes = null;
            if (null !== onRecoverableError && (pendingViewTransitionEvents = null, null === recoverableError && (recoverableError = []), null !== startViewTransitionStartTime)) for(errorInfo = 0; errorInfo < onRecoverableError.length; errorInfo++)recoverableErrors = (0, onRecoverableError[errorInfo])(recoverableError), void 0 !== recoverableErrors && startViewTransitionStartTime.finished.finally(recoverableErrors);
            0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
            ensureRootIsScheduled(endTime);
            remainingLanes = endTime.pendingLanes;
            0 !== (abortedViewTransition & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = !0, endTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = endTime)) : (nestedUpdateCount = 0, rootWithNestedUpdates = null);
            passiveSubtreeMask || finalizeRender(abortedViewTransition, commitEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
        }
    }
    function makeErrorInfo(componentStack) {
        componentStack = {
            componentStack: componentStack
        };
        Object.defineProperty(componentStack, "digest", {
            get: function() {
                console.error('You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.');
            }
        });
        return componentStack;
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
        null !== pendingViewTransition && (pendingViewTransition.skipTransition(), didWarnAboutInterruptedViewTransitions || (didWarnAboutInterruptedViewTransitions = !0, console.warn("A flushSync update cancelled a View Transition because it was called while the View Transition was still preparing. To preserve the synchronous semantics, React had to skip the View Transition. If you can, try to avoid flushSync() in a scenario that's likely to interfere.")), pendingViewTransition = null, pendingDelayedCommitReason = ABORTED_VIEW_TRANSITION_COMMIT);
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
        return flushPassiveEffects();
    }
    function flushPassiveEffects() {
        if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return !1;
        var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
        pendingEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = 0 === DefaultEventPriority || DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
        renderPriority = ReactSharedInternals.T;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = priority;
            ReactSharedInternals.T = null;
            var transitions = pendingPassiveTransitions;
            pendingPassiveTransitions = null;
            priority = pendingEffectsRoot;
            var lanes = pendingEffectsLanes;
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            pendingFinishedWork = pendingEffectsRoot = null;
            pendingEffectsLanes = 0;
            if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Cannot flush passive effects while already rendering.");
            setCurrentTrackFromLanes(lanes);
            isFlushingPassiveEffects = !0;
            didScheduleUpdateDuringPassiveEffects = !1;
            var passiveEffectStartTime = 0;
            commitErrors = null;
            passiveEffectStartTime = now$1();
            if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT) logAnimatingPhase(commitEndTime, passiveEffectStartTime, animatingTask);
            else {
                var startTime = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
                !supportsUserTiming || endTime <= startTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            startTime = executionContext;
            executionContext |= CommitContext;
            var finishedWork = priority.current;
            resetComponentEffectTimers();
            commitPassiveUnmountOnFiber(finishedWork);
            var finishedWork$jscomp$0 = priority.current;
            finishedWork = pendingEffectsRenderEndTime;
            resetComponentEffectTimers();
            commitPassiveMountOnFiber(priority, finishedWork$jscomp$0, lanes, transitions, finishedWork);
            commitDoubleInvokeEffectsInDEV(priority);
            executionContext = startTime;
            var passiveEffectsEndTime = now$1();
            finishedWork$jscomp$0 = passiveEffectStartTime;
            finishedWork = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(finishedWork$jscomp$0, passiveEffectsEndTime, commitErrors, !0, finishedWork) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(console.timeStamp.bind(console, "Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
            finalizeRender(lanes, passiveEffectsEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
            didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
            didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = !1;
            if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                injectedHook.onPostCommitFiberRoot(rendererID, priority);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            var stateNode = priority.current.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
            return !0;
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
        }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        recordEffectError(sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        isRunningInsertionEffect = !1;
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else {
            for(; null !== nearestMountedAncestor;){
                if (3 === nearestMountedAncestor.tag) {
                    captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                    return;
                }
                if (1 === nearestMountedAncestor.tag) {
                    var instance = nearestMountedAncestor.stateNode;
                    if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                        recordEffectError(sourceFiber);
                        error = createClassErrorUpdate(2);
                        instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                        null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                        return;
                    }
                }
                nearestMountedAncestor = nearestMountedAncestor.return;
            }
            console.error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error);
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act");
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext ? prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 31:
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
        if (0 !== (parentFiber.subtreeFlags & 134225920)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var root = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
            isStrictModeFiber = isInStrictMode || isStrictModeFiber;
            22 !== fiber.tag ? fiber.flags & 134217728 ? isStrictModeFiber && runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, fiber, isStrictModeFiber) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 134225920 ? runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : fiber.subtreeFlags & 134217728 && runWithFiberInDEV(fiber, recursivelyTraverseAndDoubleInvokeEffectsInDEV, root, fiber, isStrictModeFiber));
            parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root, fiber) {
        setIsStrictModeForDevtools(!0);
        try {
            disappearLayoutEffects(fiber, NoLayoutEffectTraversalFlags), disconnectPassiveEffect(fiber), reappearLayoutEffects(root, fiber.alternate, fiber, NoLayoutEffectTraversalFlags), reconnectPassiveEffects(root, fiber, 0, null, !1, 0);
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    function commitDoubleInvokeEffectsInDEV(root) {
        var doubleInvokeEffects = !0;
        root.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = !1);
        recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, root.current, doubleInvokeEffects);
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) === NoContext) {
            var tag = fiber.tag;
            if (3 === tag || 1 === tag || 0 === tag || 11 === tag || 14 === tag || 15 === tag) {
                tag = getComponentNameFromFiber(fiber) || "ReactComponent";
                if (null !== didWarnStateUpdateForNotYetMountedComponent) {
                    if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
                    didWarnStateUpdateForNotYetMountedComponent.add(tag);
                } else didWarnStateUpdateForNotYetMountedComponent = new Set([
                    tag
                ]);
                runWithFiberInDEV(fiber, function() {
                    console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead.");
                });
            }
        }
    }
    function restorePendingUpdaters(root, lanes) {
        isDevToolsPresent && root.memoizedUpdaters.forEach(function(schedulingFiber) {
            addFiberToLanesMap(root, schedulingFiber, lanes);
        });
    }
    function scheduleCallback$1(priorityLevel, callback) {
        var actQueue = ReactSharedInternals.actQueue;
        return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
            console.error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
        });
    }
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = !0, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var nextLanes = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
                            }
                            0 !== nextLanes && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                        } else nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(root, root === workInProgressRoot ? nextLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root, nextLanes) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInImmediateTask() {
        schedulerEvent = window.event;
        processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
        for(var currentTime = now$1(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
        0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index, expirationTime = expirationTimes[index];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) return null !== pingedLanes && cancelCallback(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime !== root.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode) cancelCallback(pingedLanes);
            else return currentTime;
            switch(lanesToEventPriority(suspendedLanes)){
                case DiscreteEventPriority:
                case ContinuousEventPriority:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    suspendedLanes = NormalPriority$1;
                    break;
                case IdleEventPriority:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && cancelCallback(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        nestedUpdateScheduled = currentUpdateIsNested = !1;
        schedulerEvent = window.event;
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return root.callbackNode = null, root.callbackPriority = 0, null;
        var originalCallbackNode = root.callbackNode;
        pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
        if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now$1());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPendingEffects()) return null;
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = !1;
        performWorkOnRoot(root, lanes, !0);
    }
    function cancelCallback(callbackNode) {
        callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
        null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
            processRootScheduleInMicrotask();
            return null;
        });
        scheduleMicrotask(function() {
            (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
        });
    }
    function requestTransitionLane() {
        if (0 === currentEventTransitionLane) {
            var actionScopeLane = currentEntangledLane;
            0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
            currentEventTransitionLane = actionScopeLane;
        }
        return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
        if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp) return null;
        if ("function" === typeof actionProp) return actionProp;
        checkAttributeStringCoercion(actionProp, "action");
        return sanitizeURL(actionProp);
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
        if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
            var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
            submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
            var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: [
                    {
                        instance: null,
                        listener: function() {
                            if (nativeEvent.defaultPrevented) {
                                if (0 !== currentEventTransitionLane) {
                                    var formData = new FormData(nativeEventTarget, submitter), pendingState = {
                                        pending: !0,
                                        data: formData,
                                        method: nativeEventTarget.method,
                                        action: action
                                    };
                                    Object.freeze(pendingState);
                                    startHostTransition(maybeTargetInst, pendingState, null, formData);
                                }
                            } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), pendingState = {
                                pending: !0,
                                data: formData,
                                method: nativeEventTarget.method,
                                action: action
                            }, Object.freeze(pendingState), startHostTransition(maybeTargetInst, pendingState, action, formData));
                        },
                        currentTarget: nativeEventTarget
                    }
                ]
            });
        }
    }
    function executeDispatch(event, listener, currentTarget) {
        event.currentTarget = currentTarget;
        try {
            listener(event);
        } catch (error) {
            reportGlobalError(error);
        }
        event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        eventSystemFlags = 0 !== (eventSystemFlags & 4);
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i];
            a: {
                var previousInstance = void 0, event = _dispatchQueue$i.event;
                _dispatchQueue$i = _dispatchQueue$i.listeners;
                if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                    var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
                else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                    _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                    instance = _dispatchListeners$i.instance;
                    currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
            }
        }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        nonDelegatedEvents.has(domEventName) || console.error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var listenerSet = targetElement[internalEventHandlersKey];
        void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = new Set());
        var listenerSetKey = domEventName + "__bubble";
        listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        isCapturePhaseListener && (eventSystemFlags |= 4);
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    }
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = !0;
            allNativeEvents.forEach(function(domEventName) {
                "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
            });
            var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
            null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
        switch(getEventPriority(domEventName)){
            case DiscreteEventPriority:
                var listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            default:
                listenerWrapper = dispatchEvent;
        }
        eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        listenerWrapper = void 0;
        !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
        isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            capture: !0,
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
        var ancestorInst = targetInst$jscomp$0;
        if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
            if (null === targetInst$jscomp$0) return;
            var nodeTag = targetInst$jscomp$0.tag;
            if (3 === nodeTag || 4 === nodeTag) {
                var container = targetInst$jscomp$0.stateNode.containerInfo;
                if (container === targetContainer) break;
                if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                    var grandTag = nodeTag.tag;
                    if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                    nodeTag = nodeTag.return;
                }
                for(; null !== container;){
                    nodeTag = getClosestInstanceFromNode(container);
                    if (null === nodeTag) return;
                    grandTag = nodeTag.tag;
                    if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                        targetInst$jscomp$0 = ancestorInst = nodeTag;
                        continue a;
                    }
                    container = container.parentNode;
                }
            }
            targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
        batchedUpdates$1(function() {
            var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
            a: {
                var reactName = topLevelEventsToReactNames.get(domEventName);
                if (void 0 !== reactName) {
                    var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                    switch(domEventName){
                        case "keypress":
                            if (0 === getEventCharCode(nativeEvent)) break a;
                        case "keydown":
                        case "keyup":
                            SyntheticEventCtor = SyntheticKeyboardEvent;
                            break;
                        case "focusin":
                            reactEventType = "focus";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "focusout":
                            reactEventType = "blur";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "click":
                            if (2 === nativeEvent.button) break a;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            SyntheticEventCtor = SyntheticMouseEvent;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            SyntheticEventCtor = SyntheticDragEvent;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            SyntheticEventCtor = SyntheticTouchEvent;
                            break;
                        case ANIMATION_END:
                        case ANIMATION_ITERATION:
                        case ANIMATION_START:
                            SyntheticEventCtor = SyntheticAnimationEvent;
                            break;
                        case TRANSITION_END:
                            SyntheticEventCtor = SyntheticTransitionEvent;
                            break;
                        case "scroll":
                        case "scrollend":
                            SyntheticEventCtor = SyntheticUIEvent;
                            break;
                        case "wheel":
                            SyntheticEventCtor = SyntheticWheelEvent;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            SyntheticEventCtor = SyntheticClipboardEvent;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            SyntheticEventCtor = SyntheticPointerEvent;
                            break;
                        case "submit":
                            SyntheticEventCtor = SyntheticSubmitEvent;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            SyntheticEventCtor = SyntheticToggleEvent;
                    }
                    var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                    inCapturePhase = [];
                    for(var instance = targetInst, lastHostComponent; null !== instance;){
                        var _instance2 = instance;
                        lastHostComponent = _instance2.stateNode;
                        _instance2 = _instance2.tag;
                        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(createDispatchListener(instance, _instance2, lastHostComponent)));
                        if (accumulateTargetOnly) break;
                        instance = instance.return;
                    }
                    0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                        event: reactName,
                        listeners: inCapturePhase
                    }));
                }
            }
            if (0 === (eventSystemFlags & 7)) {
                a: {
                    SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                    reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                    if (SyntheticEventCtor && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                    if (reactName || SyntheticEventCtor) {
                        reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                        if (reactName) {
                            if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                        } else reactName = null, SyntheticEventCtor = targetInst;
                        if (reactName !== SyntheticEventCtor) {
                            inCapturePhase = SyntheticMouseEvent;
                            _instance2 = "onMouseLeave";
                            reactEventName = "onMouseEnter";
                            instance = "mouse";
                            if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                            accumulateTargetOnly = null == reactName ? reactEventType : getNodeFromInstance(reactName);
                            lastHostComponent = null == SyntheticEventCtor ? reactEventType : getNodeFromInstance(SyntheticEventCtor);
                            reactEventType = new inCapturePhase(_instance2, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                            reactEventType.target = accumulateTargetOnly;
                            reactEventType.relatedTarget = lastHostComponent;
                            _instance2 = null;
                            getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                            accumulateTargetOnly = _instance2;
                            inCapturePhase = reactName && SyntheticEventCtor ? getLowestCommonAncestor(reactName, SyntheticEventCtor, getParent) : null;
                            null !== reactName && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                            null !== SyntheticEventCtor && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                        }
                    }
                }
                a: {
                    reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                    SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                    if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                    else if (isTextInputElement(reactName)) {
                        if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                        else {
                            getTargetInstFunc = getTargetInstForInputEventPolyfill;
                            var handleEventFunc = handleEventsForInputEventPolyfill;
                        }
                    } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                    if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                        createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                        break a;
                    }
                    handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                }
                handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
                switch(domEventName){
                    case "focusin":
                        if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                        break;
                    case "focusout":
                        lastSelection = activeElementInst = activeElement = null;
                        break;
                    case "mousedown":
                        mouseDown = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        mouseDown = !1;
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                        break;
                    case "selectionchange":
                        if (skipSelectionChangeEvent) break;
                    case "keydown":
                    case "keyup":
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                }
                var fallbackData;
                if (canUseCompositionEvent) b: {
                    switch(domEventName){
                        case "compositionstart":
                            var eventType = "onCompositionStart";
                            break b;
                        case "compositionend":
                            eventType = "onCompositionEnd";
                            break b;
                        case "compositionupdate":
                            eventType = "onCompositionUpdate";
                            break b;
                    }
                    eventType = void 0;
                }
                else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
                eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: eventType,
                    listeners: handleEventFunc
                }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
                if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: handleEventFunc,
                    listeners: eventType
                }), handleEventFunc.data = fallbackData);
                extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            }
            processDispatchQueue(dispatchQueue, eventSystemFlags);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
            var _instance3 = targetFiber, stateNode = _instance3.stateNode;
            _instance3 = _instance3.tag;
            5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(createDispatchListener(targetFiber, _instance3, stateNode)), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(createDispatchListener(targetFiber, _instance3, stateNode)));
            if (3 === targetFiber.tag) return listeners;
            targetFiber = targetFiber.return;
        }
        return [];
    }
    function getParent(inst) {
        if (null === inst) return null;
        do inst = inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag);
        return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
            var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
            _instance4 = _instance4.tag;
            if (null !== alternate && alternate === common) break;
            5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
            target = target.return;
        }
        0 !== listeners.length && dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    }
    function validatePropertiesInDevelopment(type, props) {
        validateProperties$2(type, props);
        "input" !== type && "textarea" !== type && "select" !== type || null == props || null !== props.value || didWarnValueNull || (didWarnValueNull = !0, "select" === type && props.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type));
        var eventRegistry = {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        };
        isCustomElement(type) || "string" === typeof props.is || warnUnknownProperties(type, props, eventRegistry);
        props.contentEditable && !props.suppressContentEditableWarning && null != props.children && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
        serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function hasViewTransition(htmlElement) {
        return !!(htmlElement.getAttribute("vt-share") || htmlElement.getAttribute("vt-exit") || htmlElement.getAttribute("vt-enter") || htmlElement.getAttribute("vt-update"));
    }
    function isExpectedViewTransitionName(htmlElement) {
        if (!hasViewTransition(htmlElement)) return !1;
        var expectedVtName = htmlElement.getAttribute("vt-name");
        htmlElement = htmlElement.style["view-transition-name"];
        return expectedVtName ? expectedVtName === htmlElement : htmlElement.startsWith("_T_");
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
        attributeNames.forEach(function(attributeName) {
            "style" === attributeName ? "" !== domElement.getAttribute(attributeName) && (attributeName = domElement.style, (1 === attributeName.length && "view-transition-name" === attributeName[0] || 2 === attributeName.length && "view-transition-class" === attributeName[0] && "view-transition-name" === attributeName[1]) && isExpectedViewTransitionName(domElement) || (serverDifferences.style = getStylesObjectFromElement(domElement))) : serverDifferences[getPropNameFromAttributeName(attributeName)] = domElement.getAttribute(attributeName);
        });
    }
    function warnForInvalidEventListener(registrationName, listener) {
        !1 === listener ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }
    function normalizeHTML(parent, html) {
        parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName) : parent.ownerDocument.createElement(parent.tagName);
        parent.innerHTML = html;
        return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
        willCoercionThrow(markup) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", typeName(markup)), testStringCoercion(markup));
        return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
        clientText = normalizeMarkupForTextOrAttribute(clientText);
        return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
    }
    function setProp(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "children":
                if ("string" === typeof value) validateTextNesting(value, tag, !1), "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) validateTextNesting("" + value, tag, !1), "body" !== tag && setTextContent(domElement, "" + value);
                else return;
                break;
            case "className":
                setValueForKnownAttribute(domElement, "class", value);
                break;
            case "tabIndex":
                setValueForKnownAttribute(domElement, "tabindex", value);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                setValueForKnownAttribute(domElement, key, value);
                break;
            case "style":
                setValueForStyles(domElement, value, prevValue);
                return;
            case "data":
                if ("object" !== tag) {
                    setValueForKnownAttribute(domElement, "data", value);
                    break;
                }
            case "src":
            case "href":
                if ("" === value && ("a" !== tag || "href" !== key)) {
                    "src" === key ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key);
                    domElement.removeAttribute(key);
                    break;
                }
                if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL(value);
                domElement.setAttribute(key, value);
                break;
            case "action":
            case "formAction":
                null != value && ("form" === tag ? "formAction" === key ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : "function" === typeof value && (null == props.encType && null == props.method || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), null == props.target || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : "input" === tag || "button" === tag ? "action" === key ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : "input" !== tag || "submit" === props.type || "image" === props.type || didWarnFormActionType ? "button" !== tag || null == props.type || "submit" === props.type || didWarnFormActionType ? "function" === typeof value && (null == props.name || didWarnFormActionName || (didWarnFormActionName = !0, console.error('Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.')), null == props.formEncType && null == props.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), null == props.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (didWarnFormActionType = !0, console.error('A button can only specify a formAction along with type="submit" or no type.')) : (didWarnFormActionType = !0, console.error('An input can only specify a formAction along with type="submit" or type="image".')) : "action" === key ? console.error("You can only pass the action prop to <form>.") : console.error("You can only pass the formAction prop to <input> or <button>."));
                if ("function" === typeof value) {
                    domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
                if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL(value);
                domElement.setAttribute(key, value);
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                return;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                return;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                return;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                    }
                }
                break;
            case "multiple":
                domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "muted":
                domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                break;
            case "autoFocus":
                break;
            case "xlinkHref":
                if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                    domElement.removeAttribute("xlink:href");
                    break;
                }
                checkAttributeStringCoercion(value, key);
                key = sanitizeURL(value);
                domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "inert":
                "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", key));
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "credentialless":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
                break;
            case "capture":
            case "download":
                !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "rowSpan":
            case "start":
                null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
                break;
            case "popover":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                setValueForAttribute(domElement, "popover", value);
                break;
            case "xlinkActuate":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:actuate", value);
                break;
            case "xlinkArcrole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:arcrole", value);
                break;
            case "xlinkRole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:role", value);
                break;
            case "xlinkShow":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:show", value);
                break;
            case "xlinkTitle":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:title", value);
                break;
            case "xlinkType":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:type", value);
                break;
            case "xmlBase":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:base", value);
                break;
            case "xmlLang":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:lang", value);
                break;
            case "xmlSpace":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:space", value);
                break;
            case "is":
                null != prevValue && console.error('Cannot update the "is" prop after it has been initialized.');
                setValueForAttribute(domElement, "is", value);
                break;
            case "innerText":
            case "textContent":
                return;
            case "popoverTarget":
                didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", value));
            default:
                if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = getAttributeAlias(key), setValueForAttribute(domElement, key, value);
                else {
                    registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                    return;
                }
        }
        viewTransitionMutationContext = !0;
    }
    function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "style":
                setValueForStyles(domElement, value, prevValue);
                return;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                    }
                }
                break;
            case "children":
                if ("string" === typeof value) setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) setTextContent(domElement, "" + value);
                else return;
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                return;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                return;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                return;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
                return;
            case "innerText":
            case "textContent":
                return;
            default:
                if (registrationNameDependencies.hasOwnProperty(key)) null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                else a: {
                    if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                        "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                        domElement.addEventListener(prevValue, value, props);
                        break a;
                    }
                    viewTransitionMutationContext = !0;
                    key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
                }
                return;
        }
        viewTransitionMutationContext = !0;
    }
    function setInitialProperties(domElement, tag, props) {
        validatePropertiesInDevelopment(tag, props);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                var hasSrc = !1, hasSrcSet = !1, propKey;
                for(propKey in props)if (props.hasOwnProperty(propKey)) {
                    var propValue = props[propKey];
                    if (null != propValue) switch(propKey){
                        case "src":
                            hasSrc = !0;
                            break;
                        case "srcSet":
                            hasSrcSet = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        default:
                            setProp(domElement, tag, propKey, propValue, props, null);
                    }
                }
                hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
                hasSrc && setProp(domElement, tag, "src", props.src, props, null);
                return;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", domElement);
                var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
                for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                    var _propValue = props[hasSrc];
                    if (null != _propValue) switch(hasSrc){
                        case "name":
                            hasSrcSet = _propValue;
                            break;
                        case "type":
                            propValue = _propValue;
                            break;
                        case "checked":
                            checked = _propValue;
                            break;
                        case "defaultChecked":
                            defaultChecked = _propValue;
                            break;
                        case "value":
                            propKey = _propValue;
                            break;
                        case "defaultValue":
                            defaultValue = _propValue;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != _propValue) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            setProp(domElement, tag, hasSrc, _propValue, props, null);
                    }
                }
                validateInputProps(domElement, props);
                initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
                return;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", domElement);
                hasSrc = propValue = propKey = null;
                for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                    case "value":
                        propKey = defaultValue;
                        break;
                    case "defaultValue":
                        propValue = defaultValue;
                        break;
                    case "multiple":
                        hasSrc = defaultValue;
                    default:
                        setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
                }
                validateSelectProps(domElement, props);
                tag = propKey;
                props = propValue;
                domElement.multiple = !!hasSrc;
                null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
                return;
            case "textarea":
                checkControlledValueProps("textarea", props);
                listenToNonDelegatedEvent("invalid", domElement);
                propKey = hasSrcSet = hasSrc = null;
                for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                    case "value":
                        hasSrc = defaultValue;
                        break;
                    case "defaultValue":
                        hasSrcSet = defaultValue;
                        break;
                    case "children":
                        propKey = defaultValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != defaultValue) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        setProp(domElement, tag, propValue, defaultValue, props, null);
                }
                validateTextareaProps(domElement, props);
                initTextarea(domElement, hasSrc, hasSrcSet, propKey);
                return;
            case "option":
                validateOptionProps(domElement, props);
                for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                    case "selected":
                        domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                        break;
                    default:
                        setProp(domElement, tag, checked, hasSrc, props, null);
                }
                return;
            case "dialog":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
                break;
            case "image":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "embed":
            case "source":
            case "link":
                listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                    default:
                        setProp(domElement, tag, defaultChecked, hasSrc, props, null);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(_propValue in props)props.hasOwnProperty(_propValue) && (hasSrc = props[_propValue], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, _propValue, hasSrc, props, void 0));
                    return;
                }
        }
        for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
    }
    function updateProperties(domElement, tag, lastProps, nextProps) {
        validatePropertiesInDevelopment(tag, nextProps);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "input":
                var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
                for(propKey in lastProps){
                    var lastProp = lastProps[propKey];
                    if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                        case "checked":
                            break;
                        case "value":
                            break;
                        case "defaultValue":
                            lastDefaultValue = lastProp;
                        default:
                            nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                    }
                }
                for(var _propKey8 in nextProps){
                    var propKey = nextProps[_propKey8];
                    lastProp = lastProps[_propKey8];
                    if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp)) switch(_propKey8){
                        case "type":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            type = propKey;
                            break;
                        case "name":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            name = propKey;
                            break;
                        case "checked":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            checked = propKey;
                            break;
                        case "defaultChecked":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            defaultChecked = propKey;
                            break;
                        case "value":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            value = propKey;
                            break;
                        case "defaultValue":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            defaultValue = propKey;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != propKey) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            propKey !== lastProp && setProp(domElement, tag, _propKey8, propKey, nextProps, lastProp);
                    }
                }
                tag = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
                nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
                tag || !nextProps || didWarnUncontrolledToControlled || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnUncontrolledToControlled = !0);
                !tag || nextProps || didWarnControlledToUncontrolled || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnControlledToUncontrolled = !0);
                updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
                return;
            case "select":
                propKey = value = defaultValue = _propKey8 = null;
                for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                    case "value":
                        break;
                    case "multiple":
                        propKey = lastDefaultValue;
                    default:
                        nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
                }
                for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                    case "value":
                        type !== lastDefaultValue && (viewTransitionMutationContext = !0);
                        _propKey8 = type;
                        break;
                    case "defaultValue":
                        type !== lastDefaultValue && (viewTransitionMutationContext = !0);
                        defaultValue = type;
                        break;
                    case "multiple":
                        type !== lastDefaultValue && (viewTransitionMutationContext = !0), value = type;
                    default:
                        type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
                }
                nextProps = defaultValue;
                tag = value;
                lastProps = propKey;
                null != _propKey8 ? updateOptions(domElement, !!tag, _propKey8, !1) : !!lastProps !== !!tag && (null != nextProps ? updateOptions(domElement, !!tag, nextProps, !0) : updateOptions(domElement, !!tag, tag ? [] : "", !1));
                return;
            case "textarea":
                propKey = _propKey8 = null;
                for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                    case "value":
                        break;
                    case "children":
                        break;
                    default:
                        setProp(domElement, tag, defaultValue, null, nextProps, name);
                }
                for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                    case "value":
                        name !== type && (viewTransitionMutationContext = !0);
                        _propKey8 = name;
                        break;
                    case "defaultValue":
                        name !== type && (viewTransitionMutationContext = !0);
                        propKey = name;
                        break;
                    case "children":
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != name) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        name !== type && setProp(domElement, tag, value, name, nextProps, type);
                }
                updateTextarea(domElement, _propKey8, propKey);
                return;
            case "option":
                for(var _propKey13 in lastProps)if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13)) switch(_propKey13){
                    case "selected":
                        domElement.selected = !1;
                        break;
                    default:
                        setProp(domElement, tag, _propKey13, null, nextProps, _propKey8);
                }
                for(lastDefaultValue in nextProps)if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(lastDefaultValue){
                    case "selected":
                        _propKey8 !== propKey && (viewTransitionMutationContext = !0);
                        domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                        break;
                    default:
                        setProp(domElement, tag, lastDefaultValue, _propKey8, nextProps, propKey);
                }
                return;
            case "img":
            case "link":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
            case "menuitem":
                for(var _propKey15 in lastProps)_propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(domElement, tag, _propKey15, null, nextProps, _propKey8);
                for(checked in nextProps)if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(checked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != _propKey8) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        break;
                    default:
                        setProp(domElement, tag, checked, _propKey8, nextProps, propKey);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(var _propKey17 in lastProps)_propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(domElement, tag, _propKey17, void 0, nextProps, _propKey8);
                    for(defaultChecked in nextProps)_propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, _propKey8, nextProps, propKey);
                    return;
                }
        }
        for(var _propKey19 in lastProps)_propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag, _propKey19, null, nextProps, _propKey8);
        for(lastProp in nextProps)_propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
        switch(attrName){
            case "class":
                return "className";
            case "for":
                return "htmlFor";
            default:
                return attrName;
        }
    }
    function getStylesObjectFromElement(domElement) {
        for(var serverValueInObjectForm = {}, style = domElement.style, i = 0; i < style.length; i++){
            var styleName = style[i];
            "view-transition-name" === styleName && isExpectedViewTransitionName(domElement) || (serverValueInObjectForm[styleName] = style.getPropertyValue(styleName));
        }
        return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
        if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0) console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        else {
            var clientValue;
            var delimiter = clientValue = "", styleName;
            for(styleName in value$jscomp$0)if (value$jscomp$0.hasOwnProperty(styleName)) {
                var value = value$jscomp$0[styleName];
                null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
            }
            clientValue = clientValue || null;
            value$jscomp$0 = domElement.getAttribute("style");
            value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), value$jscomp$0 = normalizeMarkupForTextOrAttribute(value$jscomp$0), value$jscomp$0 === clientValue || ";" === value$jscomp$0[value$jscomp$0.length - 1] && hasViewTransition(domElement) || (serverDifferences.style = getStylesObjectFromElement(domElement)));
        }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) {
            switch(typeof value){
                case "function":
                case "symbol":
                    return;
            }
            if (!value) return;
        } else switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
            default:
                if (isNaN(value)) return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value)) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag, props, hostContext) {
        for(var serverDifferences = {}, extraAttributes = new Set(), attributes = domElement.attributes, i = 0; i < attributes.length; i++)switch(attributes[i].name.toLowerCase()){
            case "value":
                break;
            case "checked":
                break;
            case "selected":
                break;
            case "vt-name":
            case "vt-update":
            case "vt-enter":
            case "vt-exit":
            case "vt-share":
            case "vt-parent-enter":
            case "vt-parent-exit":
                break;
            default:
                extraAttributes.add(attributes[i].name);
        }
        if (isCustomElement(tag)) {
            for(var propKey in props)if (props.hasOwnProperty(propKey)) {
                var value = props[propKey];
                if (null != value) {
                    if (registrationNameDependencies.hasOwnProperty(propKey)) "function" !== typeof value && warnForInvalidEventListener(propKey, value);
                    else if (!0 !== props.suppressHydrationWarning) switch(propKey){
                        case "children":
                            "string" !== typeof value && "number" !== typeof value || warnForPropDifference("children", domElement.textContent, value, serverDifferences);
                            continue;
                        case "suppressContentEditableWarning":
                        case "suppressHydrationWarning":
                        case "defaultValue":
                        case "defaultChecked":
                        case "innerHTML":
                        case "ref":
                            continue;
                        case "dangerouslySetInnerHTML":
                            attributes = domElement.innerHTML;
                            value = value ? value.__html : void 0;
                            null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(propKey, attributes, value, serverDifferences));
                            continue;
                        case "style":
                            extraAttributes.delete(propKey);
                            diffHydratedStyles(domElement, value, serverDifferences);
                            continue;
                        case "offsetParent":
                        case "offsetTop":
                        case "offsetLeft":
                        case "offsetWidth":
                        case "offsetHeight":
                        case "isContentEditable":
                        case "outerText":
                        case "outerHTML":
                            extraAttributes.delete(propKey.toLowerCase());
                            console.error("Assignment to read-only property will result in a no-op: `%s`", propKey);
                            continue;
                        case "className":
                            extraAttributes.delete("class");
                            attributes = getValueForAttributeOnCustomComponent(domElement, "class", value);
                            warnForPropDifference("className", attributes, value, serverDifferences);
                            continue;
                        default:
                            hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(domElement, propKey, value), warnForPropDifference(propKey, attributes, value, serverDifferences);
                    }
                }
            }
        } else for(value in props)if (props.hasOwnProperty(value) && (propKey = props[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value)) "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (!0 !== props.suppressHydrationWarning) switch(value){
                case "children":
                    "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference("children", domElement.textContent, propKey, serverDifferences);
                    continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                    continue;
                case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    propKey = propKey ? propKey.__html : void 0;
                    null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = {
                        __html: attributes
                    }));
                    continue;
                case "className":
                    hydrateAttribute(domElement, value, "class", propKey, extraAttributes, serverDifferences);
                    continue;
                case "tabIndex":
                    hydrateAttribute(domElement, value, "tabindex", propKey, extraAttributes, serverDifferences);
                    continue;
                case "style":
                    extraAttributes.delete(value);
                    diffHydratedStyles(domElement, propKey, serverDifferences);
                    continue;
                case "multiple":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.multiple, propKey, serverDifferences);
                    continue;
                case "muted":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.muted, propKey, serverDifferences);
                    continue;
                case "autoFocus":
                    extraAttributes.delete("autofocus");
                    warnForPropDifference(value, domElement.autofocus, propKey, serverDifferences);
                    continue;
                case "data":
                    if ("object" !== tag) {
                        extraAttributes.delete(value);
                        attributes = domElement.getAttribute("data");
                        warnForPropDifference(value, attributes, propKey, serverDifferences);
                        continue;
                    }
                case "src":
                case "href":
                    if (!("" !== propKey || "a" === tag && "href" === value || "object" === tag && "data" === value)) {
                        "src" === value ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "action":
                case "formAction":
                    attributes = domElement.getAttribute(value);
                    if ("function" === typeof propKey) {
                        extraAttributes.delete(value.toLowerCase());
                        "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                        continue;
                    } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                        extraAttributes.delete(value.toLowerCase());
                        warnForPropDifference(value, "function", propKey, serverDifferences);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkHref":
                    hydrateSanitizedAttribute(domElement, value, "xlink:href", propKey, extraAttributes, serverDifferences);
                    continue;
                case "contentEditable":
                    hydrateBooleanishAttribute(domElement, value, "contenteditable", propKey, extraAttributes, serverDifferences);
                    continue;
                case "spellCheck":
                    hydrateBooleanishAttribute(domElement, value, "spellcheck", propKey, extraAttributes, serverDifferences);
                    continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                    hydrateBooleanishAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "credentialless":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                    hydrateBooleanAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "capture":
                case "download":
                    a: {
                        i = domElement;
                        var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                                break a;
                            default:
                                if (!1 === propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                                break;
                            case "boolean":
                                if (!0 === propKey && "" === i) break a;
                                break;
                            default:
                                if (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                    a: {
                        i = domElement;
                        attributeName = attributes = value;
                        serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                            case "boolean":
                                break a;
                            default:
                                if (isNaN(propKey) || 1 > propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                            case "boolean":
                                break;
                            default:
                                if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey)) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "rowSpan":
                    hydrateNumericAttribute(domElement, value, "rowspan", propKey, extraAttributes, serverDifferences);
                    continue;
                case "start":
                    hydrateNumericAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "xHeight":
                    hydrateAttribute(domElement, value, "x-height", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkActuate":
                    hydrateAttribute(domElement, value, "xlink:actuate", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkArcrole":
                    hydrateAttribute(domElement, value, "xlink:arcrole", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkRole":
                    hydrateAttribute(domElement, value, "xlink:role", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkShow":
                    hydrateAttribute(domElement, value, "xlink:show", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkTitle":
                    hydrateAttribute(domElement, value, "xlink:title", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkType":
                    hydrateAttribute(domElement, value, "xlink:type", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlBase":
                    hydrateAttribute(domElement, value, "xml:base", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlLang":
                    hydrateAttribute(domElement, value, "xml:lang", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlSpace":
                    hydrateAttribute(domElement, value, "xml:space", propKey, extraAttributes, serverDifferences);
                    continue;
                case "inert":
                    "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", value));
                    hydrateBooleanAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                default:
                    if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                        i = getAttributeAlias(value);
                        attributes = !1;
                        hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(i.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(attributeName) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = !0, extraAttributes.delete(attributeName)), extraAttributes.delete(i));
                        a: if (attributeName = domElement, serverDifferences$jscomp$0 = i, i = propKey, isAttributeNameSafe(serverDifferences$jscomp$0)) {
                            if (attributeName.hasAttribute(serverDifferences$jscomp$0)) attributeName = "nonce" === serverDifferences$jscomp$0.toLowerCase() ? attributeName.nonce : attributeName.getAttribute(serverDifferences$jscomp$0), checkAttributeStringCoercion(i, serverDifferences$jscomp$0), i = attributeName === "" + i ? i : attributeName;
                            else {
                                switch(typeof i){
                                    case "function":
                                    case "symbol":
                                        break a;
                                    case "boolean":
                                        if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName) break a;
                                }
                                i = void 0 === i ? void 0 : null;
                            }
                        } else i = void 0;
                        attributes || warnForPropDifference(value, i, propKey, serverDifferences);
                    }
            }
        }
        0 < extraAttributes.size && !0 !== props.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
        return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list, combinator) {
        switch(list.length){
            case 0:
                return "";
            case 1:
                return list[0];
            case 2:
                return list[0] + " " + combinator + " " + list[1];
            default:
                return list.slice(0, -1).join(", ") + ", " + combinator + " " + list[list.length - 1];
        }
    }
    function isLikelyStaticResource(initiatorType) {
        switch(initiatorType){
            case "css":
            case "script":
            case "font":
            case "img":
            case "image":
            case "input":
            case "link":
                return !0;
            default:
                return !1;
        }
    }
    function estimateBandwidth() {
        if ("function" === typeof performance.getEntriesByType) {
            for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
                var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
                if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                    initiatorType = 0;
                    duration = entry.responseEnd;
                    for(i += 1; i < resourceEntries.length; i++){
                        var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                        if (overlapStartTime > duration) break;
                        var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                        overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                    }
                    --i;
                    bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                    count++;
                    if (10 < count) break;
                }
            }
            if (0 < count) return bits / count / 1e6;
        }
        return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
        switch(namespaceURI){
            case SVG_NAMESPACE:
                return HostContextNamespaceSvg;
            case MATH_NAMESPACE:
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
    }
    function getChildHostContextProd(parentNamespace, type) {
        if (parentNamespace === HostContextNamespaceNone) switch(type){
            case "svg":
                return HostContextNamespaceSvg;
            case "math":
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
        return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
        rootContainerInstance = getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
        rootContainerInstance[internalInstanceKey] = internalInstanceHandle;
        rootContainerInstance[internalPropsKey] = props;
        setInitialProperties(rootContainerInstance, type, props);
        markNodeAsHoistable(rootContainerInstance);
        return rootContainerInstance;
    }
    function isScriptDataBlock(props) {
        props = props.type;
        if ("string" !== typeof props || "" === props) return !1;
        props = props.toLowerCase();
        if ("module" === props || "importmap" === props || "speculationrules" === props) return !1;
        switch(props){
            case "application/ecmascript":
            case "application/javascript":
            case "application/x-ecmascript":
            case "application/x-javascript":
            case "text/ecmascript":
            case "text/javascript":
            case "text/javascript1.0":
            case "text/javascript1.1":
            case "text/javascript1.2":
            case "text/javascript1.3":
            case "text/javascript1.4":
            case "text/javascript1.5":
            case "text/jscript":
            case "text/livescript":
            case "text/x-ecmascript":
            case "text/x-javascript":
                return !1;
        }
        return !0;
    }
    function shouldSetTextContent(type, props) {
        return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
        var event = window.event;
        if (event && "popstate" === event.type) {
            if (event === currentPopstateTransitionEvent) return !1;
            currentPopstateTransitionEvent = event;
            return !0;
        }
        currentPopstateTransitionEvent = null;
        return !1;
    }
    function resolveEventType() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    }
    function commitMount(domElement, type, newProps) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                newProps.autoFocus && domElement.focus();
                break;
            case "img":
                newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
        }
    }
    function commitHydratedInstance() {}
    function commitUpdate(domElement, type, oldProps, newProps) {
        updateProperties(domElement, type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
        if (!container.__reactWarnedAboutChildrenConflict) {
            var props = container[internalPropsKey] || null;
            if (null !== props) {
                var fiber = getInstanceFromNode(container);
                null !== fiber && ("string" === typeof props.children || "number" === typeof props.children ? (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })) : null != props.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })));
            }
        }
    }
    function isSingletonScope(type) {
        return "head" === type;
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
        var node = hydrationInstance, depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
                    if (0 === depth) {
                        parentInstance.removeChild(nextNode);
                        retryIfBlockedOn(hydrationInstance);
                        return;
                    }
                    depth--;
                } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA) depth++;
                else if (node === PREAMBLE_CONTRIBUTION_HTML) clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
                else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
                    node = parentInstance.ownerDocument.head;
                    clearSingletonPreambleContribution(node);
                    for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                        var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                        node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                        node$jscomp$0 = nextNode$jscomp$0;
                    }
                } else node === PREAMBLE_CONTRIBUTION_BODY && clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
            }
            node = nextNode;
        }while (node);
        retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
        var node = suspenseInstance;
        suspenseInstance = 0;
        do {
            var nextNode = node.nextSibling;
            1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA) {
                    if (0 === suspenseInstance) break;
                    else suspenseInstance--;
                } else node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
            }
            node = nextNode;
        }while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
        hideOrUnhideDehydratedBoundary(suspenseInstance, !0);
    }
    function hideInstance(instance) {
        instance = instance.style;
        "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
        hideOrUnhideDehydratedBoundary(dehydratedInstance, !1);
    }
    function unhideInstance(instance, props) {
        props = props[STYLE];
        props = void 0 !== props && null !== props && props.hasOwnProperty("display") ? props.display : null;
        instance.style.display = null == props || "boolean" === typeof props ? "" : ("" + props).trim();
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function warnForBlockInsideInline(instance) {
        for(var nextNode = instance.firstChild; null != nextNode;){
            if (1 === nextNode.nodeType && "block" === getComputedStyle(nextNode).display) {
                var fiber = getInstanceFromNode(nextNode) || getInstanceFromNode(instance);
                runWithFiberInDEV(fiber, function(parentTag, childTag) {
                    console.error("You're about to start a <ViewTransition> around a display: inline element <%s>, which itself has a display: block element <%s> inside it. This might trigger a bug in Safari which causes the View Transition to be skipped with a duplicate name error.\nhttps://bugs.webkit.org/show_bug.cgi?id=290923", parentTag.toLocaleLowerCase(), childTag.toLocaleLowerCase());
                }, instance.tagName, nextNode.tagName);
                break;
            }
            if (null != nextNode.firstChild) nextNode = nextNode.firstChild;
            else {
                if (nextNode === instance) break;
                for(; null == nextNode.nextSibling && null != nextNode.parentNode && nextNode.parentNode !== instance;)nextNode = nextNode.parentNode;
                nextNode = nextNode.nextSibling;
            }
        }
    }
    function applyViewTransitionName(instance, name, className) {
        name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
        instance.style.viewTransitionName = name;
        null != className && (instance.style.viewTransitionClass = className);
        className = getComputedStyle(instance);
        if ("inline" === className.display) {
            name = instance.getClientRects();
            if (1 === name.length) var JSCompiler_inline_result = 1;
            else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
                var rect = name[i];
                0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
            }
            1 === JSCompiler_inline_result ? (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom) : warnForBlockInsideInline(instance);
        }
    }
    function restoreViewTransitionName(instance, props) {
        instance = instance.style;
        props = props[STYLE];
        var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
        instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
        viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
        instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
        "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
    }
    function createMeasurement(rect, computedStyle, element) {
        element = element.ownerDocument.defaultView;
        return {
            rect: rect,
            abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
            clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
            view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
        };
    }
    function measureInstance(instance) {
        var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
        return createMeasurement(rect, computedStyle, instance);
    }
    function measureClonedInstance(instance) {
        var measuredRect = instance.getBoundingClientRect();
        measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
        var computedStyle = getComputedStyle(instance);
        return createMeasurement(measuredRect, computedStyle, instance);
    }
    function customizeViewTransitionError(error, ignoreAbort) {
        if ("object" === typeof error && null !== error) switch(error.name){
            case "TimeoutError":
                return Error("A ViewTransition timed out because a Navigation stalled. This can happen if a Navigation is blocked on React itself. Such as if it's resolved inside useEffect. This can be solved by moving the resolution to useLayoutEffect.", {
                    cause: error
                });
            case "AbortError":
                return ignoreAbort ? null : Error("A ViewTransition was aborted early. This might be because you have other View Transition libraries on the page and only one can run at a time. To avoid this, use only React's built-in <ViewTransition> to coordinate.", {
                    cause: error
                });
            case "InvalidStateError":
                if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) return null;
        }
        return error;
    }
    function forceLayout(ownerDocument) {
        return ownerDocument.documentElement.clientHeight;
    }
    function waitForImageToLoad(resolve) {
        this.addEventListener("load", resolve);
        this.addEventListener("error", resolve);
    }
    function startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback, blockedCallback, finishedAnimation) {
        var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
        try {
            var transition = ownerDocument.startViewTransition({
                update: function() {
                    var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                    mutationCallback();
                    var blockingPromises = [];
                    "loaded" === previousFontLoadingStatus && (forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                    previousFontLoadingStatus = blockingPromises.length;
                    if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                        var suspenseyImage = suspenseyImages[i];
                        if (!suspenseyImage.complete) {
                            var rect = suspenseyImage.getBoundingClientRect();
                            if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                                imgBytes += estimateImageBytes(suspenseyImage);
                                if (imgBytes > estimatedBytesWithinLimit) {
                                    blockingPromises.length = previousFontLoadingStatus;
                                    break;
                                }
                                suspenseyImage = new Promise(waitForImageToLoad.bind(suspenseyImage));
                                blockingPromises.push(suspenseyImage);
                            }
                        }
                    }
                    if (0 < blockingPromises.length) return blockedCallback(0 < previousFontLoadingStatus ? blockingPromises.length > previousFontLoadingStatus ? "Waiting on Fonts and Images" : "Waiting on Fonts" : "Waiting on Images"), ownerWindow = Promise.race([
                        Promise.all(blockingPromises),
                        new Promise(function(resolve) {
                            return setTimeout(resolve, SUSPENSEY_FONT_AND_IMAGE_TIMEOUT);
                        })
                    ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                        pendingNavigation.finished,
                        ownerWindow
                    ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                    layoutCallback();
                    if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                    afterMutationCallback();
                },
                types: transitionTypes
            });
            ownerDocument.__reactViewTransition = transition;
            var viewTransitionAnimations = [];
            transition.ready.then(function() {
                for(var animations = ownerDocument.documentElement.getAnimations({
                    subtree: !0
                }), i = 0; i < animations.length; i++){
                    var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                    if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                        viewTransitionAnimations.push(animation);
                        animation = effect.getKeyframes();
                        for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                            var keyframe = animation[j], w = keyframe.width;
                            if (void 0 === pseudoElement) pseudoElement = w;
                            else if (pseudoElement !== w) {
                                unchangedDimensions = !1;
                                break;
                            }
                            w = keyframe.height;
                            if (void 0 === height) height = w;
                            else if (height !== w) {
                                unchangedDimensions = !1;
                                break;
                            }
                            delete keyframe.width;
                            delete keyframe.height;
                            "none" === keyframe.transform && delete keyframe.transform;
                        }
                        unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                    }
                }
                spawnedWorkCallback();
            }, function(error) {
                ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
                try {
                    error = customizeViewTransitionError(error, !1), null !== error && errorCallback(error);
                } finally{
                    mutationCallback(), layoutCallback(), spawnedWorkCallback(), finishedAnimation();
                }
            });
            transition.finished.finally(function() {
                for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
                ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
                finishedAnimation();
                passiveCallback();
            });
            return transition;
        } catch (x) {
            return mutationCallback(), layoutCallback(), finishedAnimation(), spawnedWorkCallback(), null;
        }
    }
    function ViewTransitionPseudoElement(pseudo, name) {
        this._scope = document.documentElement;
        this._selector = "::view-transition-" + pseudo + "(" + name + ")";
    }
    function createViewTransitionInstance(name) {
        return {
            name: name,
            group: new ViewTransitionPseudoElement("group", name),
            imagePair: new ViewTransitionPseudoElement("image-pair", name),
            old: new ViewTransitionPseudoElement("old", name),
            new: new ViewTransitionPseudoElement("new", name)
        };
    }
    function FragmentInstance(fragmentFiber) {
        this._fragmentFiber = fragmentFiber;
        this._observers = this._eventListeners = null;
    }
    function addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
        getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
        return !1;
    }
    function removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
        getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
        return !1;
    }
    function getAttachOptions(opts) {
        return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
            capture: opts.capture,
            passive: opts.passive
        } : opts;
    }
    function normalizeListenerOptions(opts) {
        return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
    }
    function indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
        if (0 === eventListeners.length) return -1;
        optionsOrUseCapture = normalizeListenerOptions(optionsOrUseCapture);
        for(var i = 0; i < eventListeners.length; i++){
            var item = eventListeners[i];
            if (item.type === type && item.listener === listener && normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
        }
        return -1;
    }
    function setFocusOnFiberIfFocusable(fiber, focusOptions) {
        if (6 === fiber.tag) return !1;
        fiber = getInstanceFromHostFiber(fiber);
        return setFocusIfFocusable(fiber, focusOptions);
    }
    function collectChildren(child, collection) {
        collection.push(child);
        return !1;
    }
    function blurActiveElementWithinFragment(child, activeElement) {
        if (6 === child.tag) return !1;
        child = getInstanceFromHostFiber(child);
        return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
    }
    function observeChild(child, observer) {
        if (6 === child.tag) return !1;
        child = getInstanceFromHostFiber(child);
        observer.observe(child);
        return !1;
    }
    function unobserveChild(child, observer) {
        if (6 === child.tag) return !1;
        child = getInstanceFromHostFiber(child);
        observer.unobserve(child);
        return !1;
    }
    function schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
        pendingIntersectionUnobserves.push({
            fragmentInstance: fragmentInstance,
            observer: observer,
            instance: instance
        });
        intersectionUnobserveScheduled || (intersectionUnobserveScheduled = !0, requestPostPaintCallback(function() {
            intersectionUnobserveScheduled = !1;
            var pending = pendingIntersectionUnobserves;
            pendingIntersectionUnobserves = [];
            for(var i = 0; i < pending.length; i++){
                var item = pending[i];
                item.observer.unobserve(item.instance);
            }
        }));
    }
    function collectClientRects(child, rects) {
        if (6 === child.tag) {
            child = child.stateNode;
            var range = child.ownerDocument.createRange();
            range.selectNodeContents(child);
            rects.push.apply(rects, range.getClientRects());
        } else child = getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
        return !1;
    }
    function validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
        var otherFiber = getClosestInstanceFromNode(otherNode);
        if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            if (precedingBoundaryFiber = !!otherFiber) a: {
                for(; null !== otherFiber;){
                    if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                        precedingBoundaryFiber = !0;
                        break a;
                    }
                    otherFiber = otherFiber.return;
                }
                precedingBoundaryFiber = !1;
            }
            return precedingBoundaryFiber;
        }
        if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
            if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
            a: {
                otherFiber = fragmentFiber;
                for(fragmentFiber = getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                    if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                        otherFiber = !0;
                        break a;
                    }
                    otherFiber = otherFiber.return;
                }
                otherFiber = !1;
            }
            return otherFiber;
        }
        return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : (traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = searchTarget, searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = getLowestCommonAncestor(followingBoundaryFiber, otherFiber, getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : (traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = searchTarget, searchBoundary = searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
    }
    function scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
        var range = textNode.ownerDocument.createRange();
        range.selectNodeContents(textNode);
        textNode = range.getBoundingClientRect();
        window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
    }
    function addFragmentHandleToFiber(child, fragmentInstance) {
        child = getInstanceFromHostFiber(child);
        addFragmentHandleToInstance(child, fragmentInstance);
        return !1;
    }
    function addFragmentHandleToInstance(instance, fragmentInstance) {
        null == instance.reactFragments && (instance.reactFragments = new Set());
        instance.reactFragments.add(fragmentInstance);
    }
    function commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
        var eventListeners = fragmentInstance._eventListeners;
        if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
            var _eventListeners$i2 = eventListeners[i$jscomp$0];
            childInstance.addEventListener(_eventListeners$i2.type, _eventListeners$i2.attachedListener, getAttachOptions(_eventListeners$i2.optionsOrUseCapture));
        }
        3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
            for(var writeIdx = 0, i = 0; i < pendingIntersectionUnobserves.length; i++){
                var pending = pendingIntersectionUnobserves[i];
                if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) pendingIntersectionUnobserves[writeIdx++] = pending;
            }
            pendingIntersectionUnobserves.length = writeIdx;
            observer.observe(childInstance);
        }), addFragmentHandleToInstance(childInstance, fragmentInstance));
    }
    function deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
        var eventListeners = fragmentInstance._eventListeners;
        if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i3 = eventListeners[i];
            childInstance.removeEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
        }
        3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
            "string" === typeof observer.rootMargin ? schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
        }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
    }
    function clearContainerSparingly(container) {
        var nextNode = container.firstChild;
        nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
        for(; nextNode;){
            var node = nextNode;
            nextNode = nextNode.nextSibling;
            switch(node.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    clearContainerSparingly(node);
                    detachDeletedInstance(node);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if ("stylesheet" === node.rel.toLowerCase()) continue;
            }
            container.removeChild(node);
        }
    }
    function canHydrateInstance(instance, type, props, inRootOrSingleton) {
        for(; 1 === instance.nodeType;){
            var anyProps = props;
            if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
                if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
            } else if (!inRootOrSingleton) {
                if ("input" === type && "hidden" === instance.type) {
                    checkAttributeStringCoercion(anyProps.name, "name");
                    var name = null == anyProps.name ? null : "" + anyProps.name;
                    if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
                } else return instance;
            } else if (!instance[internalHoistableMarker]) switch(type){
                case "meta":
                    if (!instance.hasAttribute("itemprop")) break;
                    return instance;
                case "link":
                    name = instance.getAttribute("rel");
                    if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                    else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                    return instance;
                case "style":
                    if (instance.hasAttribute("data-precedence")) break;
                    return instance;
                case "script":
                    name = instance.getAttribute("src");
                    if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                    return instance;
                default:
                    return instance;
            }
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) break;
        }
        return null;
    }
    function canHydrateTextInstance(instance, text, inRootOrSingleton) {
        if ("" === text) return null;
        for(; 3 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
        for(; 8 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        var ownerDocument = instance.ownerDocument;
        if (instance.data === SUSPENSE_QUEUED_START_DATA) instance._reactRetry = callback;
        else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING) callback();
        else {
            var listener = function() {
                callback();
                ownerDocument.removeEventListener("DOMContentLoaded", listener);
            };
            ownerDocument.addEventListener("DOMContentLoaded", listener);
            instance._reactRetry = listener;
        }
    }
    function getNextHydratable(node) {
        for(; null != node; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (1 === nodeType || 3 === nodeType) break;
            if (8 === nodeType) {
                nodeType = node.data;
                if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING) break;
                if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA) return null;
            }
        }
        return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
        if (1 === instance.nodeType) {
            for(var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i = 0; i < attributes.length; i++){
                var attr = attributes[i];
                serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
            }
            return {
                type: JSCompiler_temp_const,
                props: serverDifferences
            };
        }
        return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? {
            type: "Activity",
            props: {}
        } : {
            type: "Suspense",
            props: {}
        } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text, parentProps) {
        return null === parentProps || !0 !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text ? textInstance = null : (text = normalizeMarkupForTextOrAttribute(text), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
        hydrationInstance = hydrationInstance.nextSibling;
        for(var depth = 0; hydrationInstance;){
            if (8 === hydrationInstance.nodeType) {
                var data = hydrationInstance.data;
                if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
                    if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                    depth--;
                } else data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
            }
            hydrationInstance = hydrationInstance.nextSibling;
        }
        return null;
    }
    function getParentHydrationBoundary(targetInstance) {
        targetInstance = targetInstance.previousSibling;
        for(var depth = 0; targetInstance;){
            if (8 === targetInstance.nodeType) {
                var data = targetInstance.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
                    if (0 === depth) return targetInstance;
                    depth--;
                } else data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
            }
            targetInstance = targetInstance.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
        retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
    }
    function setFocusIfFocusable(node, focusOptions) {
        function handleFocus() {
            didFocus = !0;
        }
        if (node.ownerDocument.activeElement === node) return !0;
        var didFocus = !1;
        try {
            node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
        } finally{
            node.ownerDocument.removeEventListener("focus", handleFocus, !0);
        }
        return didFocus;
    }
    function requestPostPaintCallback(callback) {
        localRequestAnimationFrame(function() {
            localRequestAnimationFrame(function(time) {
                return callback(time);
            });
        });
    }
    function resolveSingletonInstance(type, props, rootContainerInstance, hostContext, validateDOMNestingDev) {
        validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
        props = getOwnerDocumentFromRootContainer(rootContainerInstance);
        switch(type){
            case "html":
                type = props.documentElement;
                if (!type) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "head":
                type = props.head;
                if (!type) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "body":
                type = props.body;
                if (!type) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            default:
                throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
    }
    function acquireSingletonInstance(type, props, instance, internalInstanceHandle) {
        if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
            var tagName = instance.tagName.toLowerCase();
            console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", tagName, tagName, tagName);
        }
        switch(type){
            case "html":
            case "head":
            case "body":
                break;
            default:
                console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
        for(tagName = instance.attributes; tagName.length;)instance.removeAttributeNode(tagName[0]);
        setInitialProperties(instance, type, props);
        instance[internalInstanceKey] = internalInstanceHandle;
        instance[internalPropsKey] = props;
    }
    function releaseSingletonInstance(instance, type, props) {
        for(var propKey in props){
            var propValue = props[propKey];
            props.hasOwnProperty(propKey) && null != propValue && setProp(instance, type, propKey, null, emptyProps, propValue);
        }
        null != props.dangerouslySetInnerHTML && (instance.textContent = "");
        instance.onclick === noop$1 && (instance.onclick = null);
        detachDeletedInstance(instance);
    }
    function clearSingletonPreambleContribution(instance) {
        for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
        detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
        if ("function" === typeof container.getRootNode) {
            var rootNode = container.getRootNode();
            if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
        }
        return 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
        var ownerDocument = globalDocument;
        if (ownerDocument && "string" === typeof href && href) {
            var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
            limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
            "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
            preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
                rel: rel,
                crossOrigin: crossOrigin,
                href: href
            }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
        }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
        var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
        if (!resourceRoot) throw Error('"resourceRoot" was expected to exist. This is a bug in React.');
        switch(type){
            case "meta":
            case "title":
                return null;
            case "style":
                return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                    type = getStyleKey(pendingProps.href);
                    var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
                    _resource || (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: NotLoaded,
                            preload: null
                        }
                    }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(getStylesheetSelectorFromKey(type))) ? _styles._p || (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted) : (_styles = preloadPropsMap.get(type), _styles || (_styles = {
                        rel: "preload",
                        as: "style",
                        href: pendingProps.href,
                        crossOrigin: pendingProps.crossOrigin,
                        integrity: pendingProps.integrity,
                        media: pendingProps.media,
                        hrefLang: pendingProps.hrefLang,
                        referrerPolicy: pendingProps.referrerPolicy
                    }, preloadPropsMap.set(type, _styles)), preloadStylesheet(resourceRoot, type, _styles, _resource.state)));
                    if (currentProps && null === currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                    return _resource;
                }
                if (currentProps && null !== currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                return null;
            case "script":
                return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error('getResource encountered a type it did not expect: "' + type + '". this is a bug in React.');
        }
    }
    function describeLinkForResourceErrorDEV(props) {
        var describedProps = 0, description = "<link";
        "string" === typeof props.rel ? (describedProps++, description += ' rel="' + props.rel + '"') : hasOwnProperty.call(props, "rel") && (describedProps++, description += ' rel="' + (null === props.rel ? "null" : "invalid type " + typeof props.rel) + '"');
        "string" === typeof props.href ? (describedProps++, description += ' href="' + props.href + '"') : hasOwnProperty.call(props, "href") && (describedProps++, description += ' href="' + (null === props.href ? "null" : "invalid type " + typeof props.href) + '"');
        "string" === typeof props.precedence ? (describedProps++, description += ' precedence="' + props.precedence + '"') : hasOwnProperty.call(props, "precedence") && (describedProps++, description += " precedence={" + (null === props.precedence ? "null" : "invalid type " + typeof props.precedence) + "}");
        Object.getOwnPropertyNames(props).length > describedProps && (description += " ...");
        return description + " />";
    }
    function getStyleKey(href) {
        return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
        return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
        return assign({}, rawProps, {
            "data-precedence": rawProps.precedence,
            precedence: null
        });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
        if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
            if (!0 !== key[internalLoadPendingKey]) {
                state.loading = Loaded;
                return;
            }
        } else key = ownerDocument.createElement("link"), key[internalLoadPendingKey] = !0, key.onload = key.onerror = clearPendingLoadOnNode.bind(null, key), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
        state.preload = key;
        key.addEventListener("load", function() {
            return state.loading |= Loaded;
        });
        key.addEventListener("error", function() {
            return state.loading |= Errored;
        });
    }
    function getScriptKey(src) {
        return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
        return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props) {
        resource.count++;
        if (null === resource.instance) switch(resource.type){
            case "style":
                var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
                if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
                var styleProps = assign({}, props, {
                    "data-href": props.href,
                    "data-precedence": props.precedence,
                    href: null,
                    precedence: null
                });
                instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
                markNodeAsHoistable(instance);
                setInitialProperties(instance, "style", styleProps);
                insertStylesheet(instance, props.precedence, hoistableRoot);
                return resource.instance = instance;
            case "stylesheet":
                styleProps = getStyleKey(props.href);
                var _instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
                if (_instance) return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
                instance = stylesheetPropsFromRawProps(props);
                (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
                _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
                markNodeAsHoistable(_instance);
                var linkInstance = _instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(_instance, "link", instance);
                resource.state.loading |= Inserted;
                insertStylesheet(_instance, props.precedence, hoistableRoot);
                return resource.instance = _instance;
            case "script":
                _instance = getScriptKey(props.src);
                if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(_instance))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
                instance = props;
                if (styleProps = preloadPropsMap.get(_instance)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                styleProps = hoistableRoot.createElement("script");
                markNodeAsHoistable(styleProps);
                setInitialProperties(styleProps, "link", instance);
                hoistableRoot.head.appendChild(styleProps);
                return resource.instance = styleProps;
            case "void":
                return null;
            default:
                throw Error('acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.');
        }
        else "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props.precedence, hoistableRoot));
        return resource.instance;
    }
    function insertStylesheet(instance, precedence, root) {
        for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
            var node = nodes[i];
            if (node.dataset.precedence === precedence) prior = node;
            else if (prior !== last) break;
        }
        prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
        null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
        null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
        null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
        null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
        null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
        null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
        if (null === tagCaches) {
            var cache = new Map();
            var caches = tagCaches = new Map();
            caches.set(ownerDocument, cache);
        } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
        if (cache.has(type)) return cache;
        cache.set(type, null);
        ownerDocument = ownerDocument.getElementsByTagName(type);
        for(caches = 0; caches < ownerDocument.length; caches++){
            var node = ownerDocument[caches];
            if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
                var nodeKey = node.getAttribute(keyAttribute) || "";
                nodeKey = type + nodeKey;
                var existing = cache.get(nodeKey);
                existing ? existing.push(node) : cache.set(nodeKey, [
                    node
                ]);
            }
        }
        return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
        hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
        hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
    }
    function isHostHoistableType(type, props, hostContext) {
        var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
        if (hostContext.context === HostContextNamespaceSvg || null != props.itemProp) return !outsideHostContainerContext || null == props.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", type, type), !1;
        switch(type){
            case "meta":
            case "title":
                return !0;
            case "style":
                if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) {
                    outsideHostContainerContext && console.error('Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.');
                    break;
                }
                return !0;
            case "link":
                if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) {
                    if ("stylesheet" === props.rel && "string" === typeof props.precedence) {
                        type = props.href;
                        var onError = props.onError, disabled = props.disabled;
                        hostContext = [];
                        props.onLoad && hostContext.push("`onLoad`");
                        onError && hostContext.push("`onError`");
                        null != disabled && hostContext.push("`disabled`");
                        onError = propNamesListJoin(hostContext, "and");
                        onError += 1 === hostContext.length ? " prop" : " props";
                        disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
                        hostContext.length && console.error('React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.', type, disabled, onError);
                    }
                    outsideHostContainerContext && ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (props.onError || props.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
                    break;
                }
                switch(props.rel){
                    case "stylesheet":
                        return type = props.precedence, props = props.disabled, "string" !== typeof type && outsideHostContainerContext && console.error('Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'), "string" === typeof type && null == props;
                    default:
                        return !0;
                }
            case "script":
                type = props.async && "function" !== typeof props.async && "symbol" !== typeof props.async;
                if (!type || props.onLoad || props.onError || !props.src || "string" !== typeof props.src) {
                    outsideHostContainerContext && (type ? props.onLoad || props.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error('Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'));
                    break;
                }
                return !0;
            case "noscript":
            case "template":
                outsideHostContainerContext && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", type);
        }
        return !1;
    }
    function maySuspendCommit(type, props) {
        return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
    }
    function preloadResource(resource) {
        return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? !1 : !0;
    }
    function estimateImageBytes(instance) {
        return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
    }
    function suspendInstance(state, instance) {
        "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = onUnsuspendImg.bind(state), instance.decode().then(state, state));
    }
    function suspendResource(state, hoistableRoot, resource, props) {
        if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
            if (null === resource.instance) {
                var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
                if (instance) {
                    hoistableRoot = instance._p;
                    null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                    resource.state.loading |= Inserted;
                    resource.instance = instance;
                    markNodeAsHoistable(instance);
                    return;
                }
                instance = hoistableRoot.ownerDocument || hoistableRoot;
                props = stylesheetPropsFromRawProps(props);
                (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
                instance = instance.createElement("link");
                markNodeAsHoistable(instance);
                var linkInstance = instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(instance, "link", props);
                resource.instance = instance;
            }
            null === state.stylesheets && (state.stylesheets = new Map());
            state.stylesheets.set(resource, hoistableRoot);
            (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
        }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
        state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
        return 0 < state.count || 0 < state.imgCount ? function(commit) {
            var stylesheetTimer = setTimeout(function() {
                state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
                if (state.unsuspend) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
            0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
            var imgTimer = setTimeout(function() {
                state.waitingForImages = !1;
                if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset);
            state.unsuspend = commit;
            return function() {
                state.unsuspend = null;
                clearTimeout(stylesheetTimer);
                clearTimeout(imgTimer);
            };
        } : null;
    }
    function checkIfFullyUnsuspended(state) {
        if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
            if (state.stylesheets) insertSuspendedStylesheets(state, state.stylesheets);
            else if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }
    }
    function onUnsuspend() {
        this.count--;
        checkIfFullyUnsuspended(this);
    }
    function onUnsuspendImg() {
        this.imgCount--;
        checkIfFullyUnsuspended(this);
    }
    function insertSuspendedStylesheets(state, resources) {
        state.stylesheets = null;
        null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root, resource) {
        if (!(resource.state.loading & Inserted)) {
            var precedences = precedencesByRoot.get(root);
            if (precedences) var last = precedences.get(LAST_PRECEDENCE);
            else {
                precedences = new Map();
                precedencesByRoot.set(root, precedences);
                for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
                }
                last && precedences.set(LAST_PRECEDENCE, last);
            }
            nodes = resource.instance;
            node = nodes.getAttribute("data-precedence");
            i = precedences.get(node) || last;
            i === last && precedences.set(LAST_PRECEDENCE, nodes);
            precedences.set(node, nodes);
            this.count++;
            last = onUnsuspend.bind(this);
            nodes.addEventListener("load", last);
            nodes.addEventListener("error", last);
            i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
            resource.state.loading |= Inserted;
        }
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.transitionTypes = null;
        this.incompleteTransitions = new Map();
        this.passiveEffectDuration = this.effectDuration = -0;
        this.memoizedUpdaters = new Set();
        containerInfo = this.pendingUpdatersLaneMap = [];
        for(tag = 0; 31 > tag; tag++)containerInfo.push(new Set());
        this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
        tag = ConcurrentMode;
        !0 === isStrictMode && (tag |= StrictLegacyMode | StrictEffectsMode);
        tag |= ProfileMode;
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        retainCache(tag);
        containerInfo.pooledCache = tag;
        retainCache(tag);
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot) try {
            injectedHook.onScheduleFiberRoot(rendererID, container, element);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        isRendering && null !== current && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = !0, console.error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown"));
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && ("function" !== typeof callback && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback), container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var lane = requestUpdateLane(fiber);
            lane = getBumpedLaneForHydrationByLane(lane);
            var root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (_enabled) {
            var blockedOn = findInstanceBlockingEvent(nativeEvent);
            if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
            else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
            else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
                for(; null !== blockedOn;){
                    var fiber = getInstanceFromNode(blockedOn);
                    if (null !== fiber) switch(fiber.tag){
                        case 3:
                            fiber = fiber.stateNode;
                            if (fiber.current.memoizedState.isDehydrated) {
                                var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                                if (0 !== lanes) {
                                    var root = fiber;
                                    root.pendingLanes |= 2;
                                    for(root.entangledLanes |= 2; lanes;){
                                        var lane = 1 << 31 - clz32(lanes);
                                        root.entanglements[1] |= lane;
                                        lanes &= ~lane;
                                    }
                                    ensureRootIsScheduled(fiber);
                                    (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0, !1));
                                }
                            }
                            break;
                        case 31:
                        case 13:
                            root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                    }
                    fiber = findInstanceBlockingEvent(nativeEvent);
                    null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                    if (fiber === blockedOn) break;
                    blockedOn = fiber;
                }
                null !== blockedOn && nativeEvent.stopPropagation();
            } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
    }
    function findInstanceBlockingEvent(nativeEvent) {
        nativeEvent = getEventTarget(nativeEvent);
        return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
        return_targetInst = null;
        targetNode = getClosestInstanceFromNode(targetNode);
        if (null !== targetNode) {
            var nearestMounted = getNearestMountedFiber(targetNode);
            if (null === nearestMounted) targetNode = null;
            else {
                var tag = nearestMounted.tag;
                if (13 === tag) {
                    targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (31 === tag) {
                    targetNode = getActivityInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (3 === tag) {
                    if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    targetNode = null;
                } else nearestMounted !== targetNode && (targetNode = null);
            }
        }
        return_targetInst = targetNode;
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "fullscreenerror":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "resize":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                switch(getCurrentPriorityLevel()){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority$1:
                    case LowPriority:
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                queuedPointers.delete(nativeEvent.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                queuedPointerCaptures.delete(nativeEvent.pointerId);
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        blockedOn = existingQueuedEvent.targetContainers;
        null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch(domEventName){
            case "focusin":
                return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "dragenter":
                return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "mouseover":
                return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "pointerover":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
                return !0;
            case "gotpointercapture":
                return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
        }
        return !1;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (null !== targetInst) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (null !== nearestMounted) {
                if (targetInst = nearestMounted.tag, 13 === targetInst) {
                    if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (31 === targetInst) {
                    if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                    queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (null !== queuedEvent.blockedOn) return !1;
        for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
            if (null === nextBlockedOn) {
                nextBlockedOn = queuedEvent.nativeEvent;
                var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn), event = nativeEventClone;
                null !== currentReplayingEvent && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = event;
                nextBlockedOn.target.dispatchEvent(nativeEventClone);
                null === currentReplayingEvent && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = null;
            } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
            targetContainers.shift();
        }
        return !0;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = !1;
        null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
        null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
        null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
        lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
            lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
            for(var i = 0; i < formReplayingQueue.length; i += 3){
                var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
                if ("function" !== typeof submitterOrAction) {
                    if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                    else break;
                }
                var formInst = getInstanceFromNode(form);
                null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, form = {
                    pending: !0,
                    data: formData,
                    method: form.method,
                    action: submitterOrAction
                }, Object.freeze(form), startHostTransition(formInst, form, submitterOrAction, formData));
            }
        }));
    }
    function retryIfBlockedOn(unblocked) {
        function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        }
        null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
            var queuedTarget = queuedExplicitHydrationTargets[i];
            queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
        }
        for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
        i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
        if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
            var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
            if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
            else if (formProps) {
                var action = null;
                if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                    if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                    else {
                        if (null !== findInstanceBlockingTarget(form)) continue;
                    }
                } else action = formProps.action;
                "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
                scheduleReplayQueueIfNeeded(i);
            }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
        function handleNavigate(event) {
            event.canIntercept && "react-transition" === event.info && event.intercept({
                handler: function() {
                    return new Promise(function(resolve) {
                        return pendingResolve = resolve;
                    });
                },
                focusReset: "manual",
                scroll: "manual"
            });
        }
        function handleNavigateComplete() {
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            isCancelled || setTimeout(startFakeNavigation, 20);
        }
        function startFakeNavigation() {
            if (!isCancelled && !navigation.transition) {
                var currentEntry = navigation.currentEntry;
                currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                    state: currentEntry.getState(),
                    info: "react-transition",
                    history: "replace"
                });
            }
        }
        if ("object" === typeof navigation) {
            var isCancelled = !1, pendingResolve = null;
            navigation.addEventListener("navigate", handleNavigate);
            navigation.addEventListener("navigatesuccess", handleNavigateComplete);
            navigation.addEventListener("navigateerror", handleNavigateComplete);
            setTimeout(startFakeNavigation, 100);
            return function() {
                isCancelled = !0;
                navigation.removeEventListener("navigate", handleNavigate);
                navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
                navigation.removeEventListener("navigateerror", handleNavigateComplete);
                null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            };
        }
    }
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
        container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler = (parcelRequire("33s19")), React = (parcelRequire("7fPBF")), ReactDOM = (parcelRequire("fw0lo")), searchTarget = null, searchBoundary = null, assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
        pending: !1,
        data: null,
        method: null,
        action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = !0;
    var prefix, suffix, reentry = !1;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current = null, isRendering = !1, hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now$1 = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = !1, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, internalLoadPendingKey = "__reactLoad$" + randomKey, allNativeEvents = new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, viewTransitionMutationContext = !1, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = !1, didWarnCheckedDefaultChecked = !1, didWarnSelectedSetOnOption = !1, didWarnInvalidChild = !1, didWarnInvalidInnerHTML = !1;
    var didWarnValueDefaultValue = !1;
    var valuePropNames = [
        "value",
        "defaultValue"
    ], didWarnValDefaultVal = !1, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), inScopeTags = "applet caption html table td th marquee object select template foreignObject desc title".split(" "), buttonScopeTags = inScopeTags.concat([
        "button"
    ]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null,
        containerTagInScope: null,
        implicitRootScope: !1
    }, didWarn = {}, shorthandToLonghand = {
        animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "),
        background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "),
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "),
        borderBlock: "borderBlockEndColor borderBlockEndStyle borderBlockEndWidth borderBlockStartColor borderBlockStartStyle borderBlockStartWidth".split(" "),
        borderBlockColor: [
            "borderBlockEndColor",
            "borderBlockStartColor"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBlockStyle: [
            "borderBlockEndStyle",
            "borderBlockStartStyle"
        ],
        borderBlockWidth: [
            "borderBlockEndWidth",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInline: "borderInlineEndColor borderInlineEndStyle borderInlineEndWidth borderInlineStartColor borderInlineStartStyle borderInlineStartWidth".split(" "),
        borderInlineColor: [
            "borderInlineEndColor",
            "borderInlineStartColor"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderInlineStyle: [
            "borderInlineEndStyle",
            "borderInlineStartStyle"
        ],
        borderInlineWidth: [
            "borderInlineEndWidth",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        colorAdjust: [
            "printColorAdjust"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        containIntrinsicSize: [
            "containIntrinsicHeight",
            "containIntrinsicWidth"
        ],
        container: [
            "containerName",
            "containerType"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "),
        fontSynthesis: [
            "fontSynthesisPosition",
            "fontSynthesisSmallCaps",
            "fontSynthesisStyle",
            "fontSynthesisWeight"
        ],
        fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "),
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "),
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        inset: [
            "bottom",
            "left",
            "right",
            "top"
        ],
        insetBlock: [
            "insetBlockEnd",
            "insetBlockStart"
        ],
        insetInline: [
            "insetInlineEnd",
            "insetInlineStart"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marginBlock: [
            "marginBlockEnd",
            "marginBlockStart"
        ],
        marginInline: [
            "marginInlineEnd",
            "marginInlineStart"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "),
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        offset: [
            "offsetAnchor",
            "offsetDistance",
            "offsetPath",
            "offsetPosition",
            "offsetRotate"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        overscrollBehavior: [
            "overscrollBehaviorX",
            "overscrollBehaviorY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        paddingBlock: [
            "paddingBlockEnd",
            "paddingBlockStart"
        ],
        paddingInline: [
            "paddingInlineEnd",
            "paddingInlineStart"
        ],
        pageBreakAfter: [
            "breakAfter"
        ],
        pageBreakBefore: [
            "breakBefore"
        ],
        pageBreakInside: [
            "breakInside"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        scrollMargin: [
            "scrollMarginBottom",
            "scrollMarginLeft",
            "scrollMarginRight",
            "scrollMarginTop"
        ],
        scrollMarginBlock: [
            "scrollMarginBlockEnd",
            "scrollMarginBlockStart"
        ],
        scrollMarginInline: [
            "scrollMarginInlineEnd",
            "scrollMarginInlineStart"
        ],
        scrollPadding: [
            "scrollPaddingBottom",
            "scrollPaddingLeft",
            "scrollPaddingRight",
            "scrollPaddingTop"
        ],
        scrollPaddingBlock: [
            "scrollPaddingBlockEnd",
            "scrollPaddingBlockStart"
        ],
        scrollPaddingInline: [
            "scrollPaddingInlineEnd",
            "scrollPaddingInlineStart"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle",
            "textDecorationThickness"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        textWrap: [
            "textWrapMode",
            "textWrapStyle"
        ],
        transition: [
            "transitionBehavior",
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        verticalAlign: [
            "alignmentBaseline",
            "baselineShift",
            "baselineSource"
        ],
        whiteSpace: [
            "textWrapMode",
            "whiteSpaceCollapse"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = !1, warnedForInfinityValue = !1, unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "maskType",
            "mask-type"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        credentialless: "credentialless",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        fetchpriority: "fetchPriority",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        inert: "inert",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        masktype: "maskType",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        popover: "popover",
        popovertarget: "popoverTarget",
        popovertargetaction: "popoverTargetAction",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        transformorigin: "transformOrigin",
        "transform-origin": "transformOrigin",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    }, ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0,
        "aria-braillelabel": 0,
        "aria-brailleroledescription": 0,
        "aria-colindextext": 0,
        "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel$1 = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), didWarnValueNull = !1, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = !1, canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
    if (canUseDOM) try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
            get: function() {
                passiveBrowserEventsSupported = !0;
            }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
    } catch (e) {
        passiveBrowserEventsSupported = !1;
    }
    var root = null, startText = null, fallbackText = null, EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
            return lastMovementX;
        },
        movementY: function(event) {
            return "movementY" in event ? event.movementY : lastMovementY;
        }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, translateToKey = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }, KeyboardEventInterface = assign({}, UIEventInterface, {
        key: function(nativeEvent) {
            if (nativeEvent.key) {
                var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                if ("Unidentified" !== key) return key;
            }
            return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : 0;
        },
        keyCode: function(event) {
            return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        },
        which: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), SubmitEventInterface = assign({}, EventInterface, {
        submitter: 0
    }), SyntheticSubmitEvent = createSyntheticEvent(SubmitEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
        newState: 0,
        oldState: 0,
        source: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
        9,
        13,
        27,
        32
    ], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
    canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = !1, isComposing = !1, supportedInputTypes = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = !1;
    canUseDOM && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is, skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1, vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionrun: makePrefixMap("Transition", "TransitionRun"),
        transitionstart: makePrefixMap("Transition", "TransitionStart"),
        transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    simpleEventPluginEvents.push("scrollEnd");
    var globalClientIdCounter$1 = 0, lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        var getCurrentTime = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        getCurrentTime = function() {
            return localDate.now();
        };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, OBJECT_WIDTH_LIMIT = 100, REMOVED = "-\u00a0", ADDED = "+\u00a0", UNCHANGED = "\u2007\u00a0", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components \u269b", LANES_TRACK_GROUP = "Scheduler \u269b", currentTrack = "Blocking", alreadyWarnedForDeepEquality = !1, reusableComponentDevToolDetails = {
        color: "primary",
        properties: null,
        tooltipText: "",
        track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
        start: -0,
        end: -0,
        detail: {
            devtools: reusableComponentDevToolDetails
        }
    }, reusableChangedPropsEntry = [
        "Changed Props",
        ""
    ], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = [
        "Changed Props",
        DEEP_EQUALITY_WARNING
    ], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = !1;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    } catch (e$4) {
        hasBadMapPolyfill = !0;
    }
    var CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = !1, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0,
        _currentRenderer: null,
        _currentRenderer2: null
    }, entangledTransitionTypes = null, now = Scheduler.unstable_now, createTask = console.createTask ? console.createTask : function() {
        return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = !1, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = !1, nestedUpdateScheduled = !1, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        globalMostRecentTransitionTime = now$1();
        if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
            if (0 > transitionStartTime && 0 > transitionUpdateTime) {
                transitionStartTime = now();
                var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
                if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType) transitionEventRepeatTime = -1.1;
                transitionEventTime = newEventTime;
                transitionEventType = newEventType;
            }
            entangleAsyncAction(transition, returnValue);
        }
        if (null !== entangledTransitionTypes) for(newEventTime = firstScheduledRoot; null !== newEventTime;)queueTransitionTypes(newEventTime, entangledTransitionTypes), newEventTime = newEventTime.next;
        newEventTime = transition.types;
        if (null !== newEventTime) {
            for(newEventType = firstScheduledRoot; null !== newEventType;)queueTransitionTypes(newEventType, newEventTime), newEventType = newEventType.next;
            if (0 !== currentEntangledLane) {
                newEventType = entangledTransitionTypes;
                null === newEventType && (newEventType = entangledTransitionTypes = []);
                for(var i = 0; i < newEventTime.length; i++){
                    var transitionType = newEventTime[i];
                    -1 === newEventType.indexOf(transitionType) && newEventType.push(transitionType);
                }
            }
        }
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function() {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function() {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && !0 !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && !0 !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && !0 !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        var componentWillMountUniqueNames = new Set();
        0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
            componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillMountWarnings = []);
        var UNSAFE_componentWillMountUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
            UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillMountWarnings = []);
        var componentWillReceivePropsUniqueNames = new Set();
        0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
            componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillReceivePropsWarnings = []);
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
            UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
        var componentWillUpdateUniqueNames = new Set();
        0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
            componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillUpdateWarnings = []);
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
            UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
        if (0 < UNSAFE_componentWillMountUniqueNames.size) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            console.error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames), console.error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s", sortedNames));
        0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillUpdateUniqueNames), console.error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn("componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(componentWillReceivePropsUniqueNames), console.warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn("componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
    };
    var pendingLegacyContextWarning = new Map(), didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = null;
        for(var node = fiber; null !== node;)node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
        null === strictRoot ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray) {
            if (0 !== fiberArray.length) {
                var firstFiber = fiberArray[0], uniqueNames = new Set();
                fiberArray.forEach(function(fiber) {
                    uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                    didWarnAboutLegacyContext.add(fiber.type);
                });
                var sortedNames = setToSortedString(uniqueNames);
                runWithFiberInDEV(firstFiber, function() {
                    console.error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context", sortedNames);
                });
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var REACT_RECOVERABLE_DIGEST = "", callComponent = {
        react_stack_bottom_frame: function(Component, props, secondArg) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return Component(props, secondArg);
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
        react_stack_bottom_frame: function(instance) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return instance.render();
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
        react_stack_bottom_frame: function(finishedWork, instance) {
            try {
                instance.componentDidMount();
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(callComponentDidMount), callComponentDidUpdate = {
        react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
            try {
                instance.componentDidUpdate(prevProps, prevState, snapshot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(callComponentDidUpdate), callComponentDidCatch = {
        react_stack_bottom_frame: function(instance, errorInfo) {
            var stack = errorInfo.stack;
            instance.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(callComponentDidCatch), callComponentWillUnmount = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, instance) {
            try {
                instance.componentWillUnmount();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(callComponentWillUnmount), callCreate = {
        react_stack_bottom_frame: function(effect) {
            var create = effect.create;
            effect = effect.inst;
            create = create();
            return effect.destroy = create;
        }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, destroy) {
            try {
                destroy();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
        react_stack_bottom_frame: function(lazy) {
            var init = lazy._init;
            return init(lazy._payload);
        }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), SuspenseyCommitException = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), SuspenseActionException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), noopSuspenseyCommitThenable = {
        then: function() {
            console.error('Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.');
        }
    }, lastSuspendedFiber = null, lastSuspendedStack = null, didIssueUseWarning = !1, suspendedThenable = null, needsToResetSuspendedThenableDEV = !1, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = !1;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress, child) {
        if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
            if ("object" !== typeof child._store) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            child._store.validated = 1;
            var componentName = getComponentNameFromFiber(returnFiber), componentKey = componentName || "null";
            if (!ownerHasKeyUseWarning[componentKey]) {
                ownerHasKeyUseWarning[componentKey] = !0;
                child = child._owner;
                returnFiber = returnFiber._debugOwner;
                var currentComponentErrorInfo = "";
                returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
                currentComponentErrorInfo || componentName && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName + ">.");
                var childOwnerAppendix = "";
                null != child && returnFiber !== child && (componentName = null, "number" === typeof child.tag ? componentName = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName = child.name), componentName && (childOwnerAppendix = " It was passed a child from " + componentName + "."));
                runWithFiberInDEV(workInProgress, function() {
                    console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', currentComponentErrorInfo, childOwnerAppendix);
                });
            }
        }
    };
    var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = !1;
    var didWarnUpdateInsideUpdate = !1;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = !1, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = new Set();
    var didWarnAboutUseWrappedInTryCatch = new Set();
    var didWarnAboutAsyncClientComponent = new Set();
    var didWarnAboutUseFormState = new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = !1, ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        useHostTransitionStatus: throwInvalidHookError,
        useFormState: throwInvalidHookError,
        useActionState: throwInvalidHookError,
        useOptimistic: throwInvalidHookError,
        useMemoCache: throwInvalidHookError,
        useCacheRefresh: throwInvalidHookError,
        useEffectEvent: throwInvalidHookError
    }, HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            mountHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return mountActionState(action, initialState);
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = new Set();
    var didWarnAboutUninitializedState = new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    var didWarnAboutDirectlyAssigningPropsToState = new Set();
    var didWarnAboutUndefinedDerivedState = new Set();
    var didWarnAboutContextTypes$1 = new Set();
    var didWarnAboutChildContextTypes = new Set();
    var didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ReplaceState;
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ForceUpdate;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), didReceiveUpdate = !1;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = !1;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var didWarnAboutClassNameOnViewTransition = {};
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = !1, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var shouldStartViewTransition = !1, appearingViewTransitions = null, viewTransitionCancelableChildren = null, viewTransitionHostInstanceIdx = 0, mountedNamedViewTransitions = new Map(), didWarnAboutName = {}, NoLayoutEffectTraversalFlags = 0, IncludeWorkInProgressEffects = 1, IncludeHostSingletons = 2, offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, offscreenDirectParentIsHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, viewTransitionContextChanged = !1, inUpdateViewTransition = !1, rootViewTransitionAffected = !1, rootViewTransitionNameCanceled = !1, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, inHydratedSubtree = !1, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        },
        cacheSignal: function() {
            return readContext(CacheContext).controller.signal;
        },
        getOwner: function() {
            return current;
        }
    };
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        symbolFor("selector.component");
        symbolFor("selector.has_pseudo_class");
        symbolFor("selector.role");
        symbolFor("selector.test_id");
        symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingViewTransition = null, pendingViewTransitionEvents = null, pendingTransitionTypes = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = !1, didScheduleUpdateDuringPassiveEffects = !1, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = !1, didWarnAboutInterruptedViewTransitions = !1, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = !1;
    var didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, didScheduleMicrotask_act = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i], domEventName = eventName.toLowerCase();
            eventName = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + eventName);
        }
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
        registerSimpleEvent(TRANSITION_START, "onTransitionStart");
        registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]);
    registerDirectEvent("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]);
    registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
    registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
    registerTwoPhaseEvent("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]);
    registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = !1, didWarnUncontrolledToControlled = !1, didWarnFormActionType = !1, didWarnFormActionName = !1, didWarnFormActionTarget = !1, didWarnFormActionMethod = !1, didWarnPopoverTargetObject = !1;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", emptyProps = {}, EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, didWarnScriptTags = !1, warnedUnknownTags = {
        dialog: !0,
        webview: !0
    }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : scheduleTimeout, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, SUSPENSEY_FONT_AND_IMAGE_TIMEOUT = 500;
    ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
        options = "number" === typeof options ? {
            duration: options
        } : assign({}, options);
        options.pseudoElement = this._selector;
        return this._scope.animate(keyframes, options);
    };
    ViewTransitionPseudoElement.prototype.getAnimations = function() {
        for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
            subtree: !0
        }), result = [], i = 0; i < animations.length; i++){
            var effect = animations[i].effect;
            null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
        }
        return result;
    };
    ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
        return getComputedStyle(this._scope, this._selector);
    };
    FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
        var signal = null, cleanup = null;
        if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
        null === this._eventListeners && (this._eventListeners = []);
        var listeners = this._eventListeners;
        if (-1 === indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
            var fragmentInstance = this, attachedListener = listener;
            null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
                fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
                "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
            });
            null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
                once: !0
            }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
            signal = getAttachOptions(optionsOrUseCapture);
            listeners.push({
                type: type,
                listener: listener,
                optionsOrUseCapture: optionsOrUseCapture,
                attachedListener: attachedListener,
                cleanup: cleanup
            });
            traverseFragmentInstancesAndTextInstances(this._fragmentFiber, addEventListenerToChild, type, attachedListener, signal);
        }
        this._eventListeners = listeners;
    };
    FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
        var listeners = this._eventListeners;
        if (null !== listeners && (listener = indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
            var _listeners$index = listeners[listener];
            optionsOrUseCapture = _listeners$index.attachedListener;
            var cleanup = _listeners$index.cleanup;
            _listeners$index = getAttachOptions(_listeners$index.optionsOrUseCapture);
            traverseFragmentInstancesAndTextInstances(this._fragmentFiber, removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
            listeners.splice(listener, 1);
            null !== cleanup && cleanup();
        }
    };
    FragmentInstance.prototype.dispatchEvent = function(event) {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        if (null === parentHostFiber) return !0;
        parentHostFiber = getInstanceFromHostFiber(parentHostFiber);
        var eventListeners = this._eventListeners;
        if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
            var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
            if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
                var _eventListeners$i = eventListeners[i];
                temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, getAttachOptions(_eventListeners$i.optionsOrUseCapture));
            }
            parentHostFiber.appendChild(temp);
            event = temp.dispatchEvent(event);
            if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, getAttachOptions(_eventListeners$i.optionsOrUseCapture));
            parentHostFiber.removeChild(temp);
            return event;
        }
        return parentHostFiber.dispatchEvent(event);
    };
    FragmentInstance.prototype.focus = function(focusOptions) {
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
    };
    FragmentInstance.prototype.focusLast = function(focusOptions) {
        var children = [];
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, collectChildren, children, void 0, void 0);
        for(var i = children.length - 1; 0 <= i && !setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
    };
    FragmentInstance.prototype.blur = function() {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        null !== parentHostFiber && (parentHostFiber = getInstanceFromHostFiber(parentHostFiber), parentHostFiber = getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && traverseFragmentInstancesAndTextInstances(this._fragmentFiber, blurActiveElementWithinFragment, parentHostFiber));
    };
    FragmentInstance.prototype.observeUsing = function(observer) {
        var hasText = !1, hasElement = !1;
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, function(child) {
            if (6 === child.tag) hasText = !0;
            else return hasElement = !0;
            return !1;
        });
        hasText && !hasElement && console.error("observeUsing() was called on a FragmentInstance with only text children. Observers do not work on text nodes.");
        null === this._observers && (this._observers = new Set());
        this._observers.add(observer);
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, observeChild, observer);
    };
    FragmentInstance.prototype.unobserveUsing = function(observer) {
        var observers = this._observers;
        if (null !== observers && observers.has(observer)) {
            observers.delete(observer);
            traverseFragmentInstancesAndTextInstances(this._fragmentFiber, unobserveChild, observer);
            for(var i = observers = 0; i < pendingIntersectionUnobserves.length; i++){
                var pending = pendingIntersectionUnobserves[i];
                pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : pendingIntersectionUnobserves[observers++] = pending;
            }
            pendingIntersectionUnobserves.length = observers;
        } else console.error("You are calling unobserveUsing() with an observer that is not being observed with this fragment instance. First attach the observer with observeUsing()");
    };
    var pendingIntersectionUnobserves = [], intersectionUnobserveScheduled = !1;
    FragmentInstance.prototype.getClientRects = function() {
        var rects = [];
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, collectClientRects, rects);
        return rects;
    };
    FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        return null === parentHostFiber ? this : getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
    };
    FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
        var children = [];
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, collectChildren, children);
        var parentHostInstance = getInstanceFromHostFiber(parentHostFiber);
        if (0 === children.length) {
            parentHostFiber = parentHostInstance;
            if (fiberIsPortaledIntoHost(this._fragmentFiber)) {
                a: {
                    for(children = this._fragmentFiber.return; null !== children;){
                        if (4 === children.tag) {
                            children = children.stateNode.containerInfo;
                            break a;
                        }
                        if (3 === children.tag || 5 === children.tag || 27 === children.tag) break;
                        children = children.return;
                    }
                    children = null;
                }
                null != children && (parentHostFiber = children);
            }
            children = this._fragmentFiber;
            var result = parentHostInstance = parentHostFiber.compareDocumentPosition(otherNode);
            parentHostFiber === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = getFragmentInstanceOrTextInstanceSiblings(children)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
            return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
        }
        parentHostFiber = getInstanceFromHostFiber(children[0]);
        result = getInstanceFromHostFiber(children[children.length - 1]);
        var parentHostInstanceFromDOM = fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
        if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
        parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
        parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
        var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
        lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
        parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
        return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    };
    FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
        if ("object" === typeof alignToTop) throw Error("FragmentInstance.scrollIntoView() does not support scrollIntoViewOptions. Use the alignToTop boolean instead.");
        var children = [];
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, collectChildren, children);
        var resolvedAlignToTop = !1 !== alignToTop;
        if (0 === children.length) {
            var hostSiblings = getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
            hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
            if (null === hostSiblings) return;
            if (6 === hostSiblings.tag) {
                alignToTop = getInstanceFromHostFiber(hostSiblings);
                scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
                return;
            }
            hostSiblings = getInstanceFromHostFiber(hostSiblings);
            if (9 !== hostSiblings.nodeType) {
                if (11 === hostSiblings.nodeType) {
                    resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                    null !== resolvedAlignToTop ? resolvedAlignToTop.scrollIntoView(alignToTop) : console.warn("You are attempting to scroll a FragmentInstance that is only mounted inside a detached DocumentFragment. No scroll was performed.");
                    return;
                }
                hostSiblings.scrollIntoView(alignToTop);
            }
        }
        for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
            var child = children[hostSiblings];
            6 === child.tag ? (child = getInstanceFromHostFiber(child), scrollTextNodeIntoView(child, resolvedAlignToTop)) : getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
            hostSiblings += resolvedAlignToTop ? -1 : 1;
        }
    };
    var previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = new Map(), preconnectsSet = new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
        f: function() {
            var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
            return previousWasRendering || wasRendering;
        },
        r: function(form) {
            var formInst = getInstanceFromNode(form);
            null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
        },
        D: function(href) {
            previousDispatcher.D(href);
            preconnectAs("dns-prefetch", href, null);
        },
        C: function(href, crossOrigin) {
            previousDispatcher.C(href, crossOrigin);
            preconnectAs("preconnect", href, crossOrigin);
        },
        L: function(href, as, options) {
            previousDispatcher.L(href, as, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href && as) {
                var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
                "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
                var key = preloadSelector;
                switch(as){
                    case "style":
                        key = getStyleKey(href);
                        break;
                    case "script":
                        key = getScriptKey(href);
                }
                if (!(preloadPropsMap.has(key) || (href = assign({
                    rel: "preload",
                    href: "image" === as && options && options.imageSrcSet ? void 0 : href,
                    as: as
                }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key))))) {
                    var instance = ownerDocument.createElement("link");
                    setInitialProperties(instance, "link", href);
                    "style" === as && (instance[internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                        clearPendingLoadOnNode(instance);
                    });
                    markNodeAsHoistable(instance);
                    ownerDocument.head.appendChild(instance);
                }
            }
        },
        m: function(href, options) {
            previousDispatcher.m(href, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
                switch(as){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        key = getScriptKey(href);
                }
                if (!preloadPropsMap.has(key) && (href = assign({
                    rel: "modulepreload",
                    href: href
                }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
                    switch(as){
                        case "audioworklet":
                        case "paintworklet":
                        case "serviceworker":
                        case "sharedworker":
                        case "worker":
                        case "script":
                            if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
                    }
                    as = ownerDocument.createElement("link");
                    setInitialProperties(as, "link", href);
                    markNodeAsHoistable(as);
                    ownerDocument.head.appendChild(as);
                }
            }
        },
        X: function(src, options) {
            previousDispatcher.X(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        },
        S: function(href, precedence, options) {
            previousDispatcher.S(href, precedence, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
                precedence = precedence || "default";
                var resource = styles.get(key);
                if (!resource) {
                    var state = {
                        loading: NotLoaded,
                        preload: null
                    };
                    if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = Loaded | Inserted;
                    else {
                        href = assign({
                            rel: "stylesheet",
                            href: href,
                            "data-precedence": precedence
                        }, options);
                        (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                        var link = resource = ownerDocument.createElement("link");
                        markNodeAsHoistable(link);
                        setInitialProperties(link, "link", href);
                        link._p = new Promise(function(resolve, reject) {
                            link.onload = resolve;
                            link.onerror = reject;
                        });
                        link.addEventListener("load", function() {
                            state.loading |= Loaded;
                        });
                        link.addEventListener("error", function() {
                            state.loading |= Errored;
                        });
                        state.loading |= Inserted;
                        insertStylesheet(resource, precedence, ownerDocument);
                    }
                    resource = {
                        type: "stylesheet",
                        instance: resource,
                        count: 1,
                        state: state
                    };
                    styles.set(key, resource);
                }
            }
        },
        M: function(src, options) {
            previousDispatcher.M(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0,
                    type: "module"
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Provider: null,
        Consumer: null,
        _currentValue: NotPendingTransition,
        _currentValue2: NotPendingTransition,
        _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind = Function.prototype.bind;
    var didWarnAboutNestedUpdates = !1;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id, path, value) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithSetImpl(id.memoizedState, path, 0, value), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithDeleteImpl(id.memoizedState, path, 0), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        id = findHook(fiber, id);
        null !== id && (oldPath = copyWithRename(id.memoizedState, oldPath, newPath), id.memoizedState = oldPath, id.baseState = oldPath, fiber.memoizedProps = assign({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        oldPath = enqueueConcurrentRenderForLane(fiber, 2);
        null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    };
    scheduleRetry = function(fiber) {
        var lane = claimNextRetryLane(), root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = !0, return_targetInst = null, hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (null === root) throw Error("Cannot update an unmounted root.");
        var args = arguments;
        "function" === typeof args[1] ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : isValidContainer(args[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : "undefined" !== typeof args[1] && console.error("You passed a second argument to root.render(...) but it only accepts one argument.");
        args = children;
        var current = root.current, lane = requestUpdateLane(current);
        updateContainerImpl(current, lane, args, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        var args = arguments;
        "function" === typeof args[0] && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        args = this._internalRoot;
        if (null !== args) {
            this._internalRoot = null;
            var container = args.containerInfo;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            updateContainerImpl(args.current, 2, null, args, null, null);
            flushSyncWork$1();
            container[internalContainerInstanceKey] = null;
        }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
        if (target) {
            var updatePriority = resolveUpdatePriority();
            target = {
                blockedOn: null,
                target: target,
                priority: updatePriority
            };
            for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
            queuedExplicitHydrationTargets.splice(i, 0, target);
            0 === i && attemptExplicitHydrationTarget(target);
        }
    };
    (function() {
        var isomorphicReactPackageVersion = React.version;
        if ("19.3.0" !== isomorphicReactPackageVersion) throw Error('Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.3.0\nLearn more: https://react.dev/warnings/version-mismatch"));
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills");
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
        var fiber = componentOrElement._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof componentOrElement.render) throw Error("Unable to find node on an unmounted component.");
            componentOrElement = Object.keys(componentOrElement).join(",");
            throw Error("Argument appears to not be a ReactComponent. Keys: " + componentOrElement);
        }
        componentOrElement = findCurrentFiberUsingSlowPath(fiber);
        componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
        componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
        return componentOrElement;
    };
    if (!function() {
        var internals = {
            bundleType: 1,
            version: "19.3.0",
            rendererPackageName: "react-dom",
            currentDispatcherRef: ReactSharedInternals,
            reconcilerVersion: "19.3.0"
        };
        internals.overrideHookState = overrideHookState;
        internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
        internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
        internals.overrideProps = overrideProps;
        internals.overridePropsDeletePath = overridePropsDeletePath;
        internals.overridePropsRenamePath = overridePropsRenamePath;
        internals.scheduleUpdate = scheduleUpdate;
        internals.scheduleRetry = scheduleRetry;
        internals.setErrorHandler = setErrorHandler;
        internals.setSuspenseHandler = setSuspenseHandler;
        internals.scheduleRefresh = scheduleRefresh;
        internals.scheduleRoot = scheduleRoot;
        internals.setRefreshHandler = setRefreshHandler;
        internals.getCurrentFiber = getCurrentFiberForDevTools;
        return injectInternals(internals);
    }() && canUseDOM && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
        var protocol = window.location.protocol;
        /^(https?|file):$/.test(protocol) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""), "font-weight:bold");
    }
    $955e22349e6523b5$export$882461b6382ed46c = function(container, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
        null !== options && void 0 !== options && (options.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : "object" === typeof options && null !== options && options.$$typeof === REACT_ELEMENT_TYPE && console.error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
        options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        container[internalContainerInstanceKey] = options.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMRoot(options);
    };
    $955e22349e6523b5$export$757ceba2d55c277e = function(container, initialChildren, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        void 0 === initialChildren && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
        null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
        initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        initialChildren.context = getContextForSubtree(null);
        options = initialChildren.current;
        isStrictMode = requestUpdateLane(options);
        isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
        identifierPrefix = createUpdate(isStrictMode);
        identifierPrefix.callback = null;
        enqueueUpdate(options, identifierPrefix, isStrictMode);
        startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
        options = isStrictMode;
        initialChildren.current.lanes = options;
        markRootUpdated$1(initialChildren, options);
        ensureRootIsScheduled(initialChildren);
        container[internalContainerInstanceKey] = initialChildren.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMHydrationRoot(initialChildren);
    };
    $955e22349e6523b5$export$83d89fbfd8236492 = "19.3.0";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8sVyu"));

});
parcelRegister("8sVyu", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $629d958c29320def$export$c4744153514ff05d; }, function (v) { return $629d958c29320def$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $629d958c29320def$export$3e506c1ccc9cc1a7; }, function (v) { return $629d958c29320def$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $629d958c29320def$export$e26fe2ed2fa76875; }, function (v) { return $629d958c29320def$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $629d958c29320def$export$502329bbf4b505b1; }, function (v) { return $629d958c29320def$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $629d958c29320def$export$6e3807111c4874c4; }, function (v) { return $629d958c29320def$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $629d958c29320def$export$c27134553091fb3a; }, function (v) { return $629d958c29320def$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $629d958c29320def$export$33ee1acdc04fd2a2; }, function (v) { return $629d958c29320def$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $629d958c29320def$export$b00a404bbd5edef2; }, function (v) { return $629d958c29320def$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $629d958c29320def$export$d66a1c1c77bd778b; }, function (v) { return $629d958c29320def$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $629d958c29320def$export$d3dfb8e4810cb555; }, function (v) { return $629d958c29320def$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $629d958c29320def$export$72fdf0e06517287b; }, function (v) { return $629d958c29320def$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $629d958c29320def$export$816d2913ae6b83b1; }, function (v) { return $629d958c29320def$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $629d958c29320def$export$61bcfe829111a1d0; }, function (v) { return $629d958c29320def$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $629d958c29320def$export$7ee8c9beb337bc3f; }, function (v) { return $629d958c29320def$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $629d958c29320def$export$b5836b71941fa3ed; }, function (v) { return $629d958c29320def$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $629d958c29320def$export$cf845f2c119da08a; }, function (v) { return $629d958c29320def$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $629d958c29320def$export$c4744153514ff05d;
var $629d958c29320def$export$3e506c1ccc9cc1a7;
var $629d958c29320def$export$e26fe2ed2fa76875;
var $629d958c29320def$export$502329bbf4b505b1;
var $629d958c29320def$export$6e3807111c4874c4;
var $629d958c29320def$export$c27134553091fb3a;
var $629d958c29320def$export$33ee1acdc04fd2a2;
var $629d958c29320def$export$b00a404bbd5edef2;
var $629d958c29320def$export$d66a1c1c77bd778b;
var $629d958c29320def$export$d3dfb8e4810cb555;
var $629d958c29320def$export$72fdf0e06517287b;
var $629d958c29320def$export$816d2913ae6b83b1;
var $629d958c29320def$export$61bcfe829111a1d0;
var $629d958c29320def$export$7ee8c9beb337bc3f;
var $629d958c29320def$export$b5836b71941fa3ed;
var $629d958c29320def$export$cf845f2c119da08a;
"use strict";
(function() {
    function performWorkUntilDeadline() {
        needsPaint = !1;
        if (isMessageLoopRunning) {
            var currentTime = $629d958c29320def$export$c4744153514ff05d();
            startTime = currentTime;
            var hasMoreWork = !0;
            try {
                a: {
                    isHostCallbackScheduled = !1;
                    isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                    isPerformingWork = !0;
                    var previousPriorityLevel = currentPriorityLevel;
                    try {
                        b: {
                            advanceTimers(currentTime);
                            for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                                var callback = currentTask.callback;
                                if ("function" === typeof callback) {
                                    currentTask.callback = null;
                                    currentPriorityLevel = currentTask.priorityLevel;
                                    var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                    currentTime = $629d958c29320def$export$c4744153514ff05d();
                                    if ("function" === typeof continuationCallback) {
                                        currentTask.callback = continuationCallback;
                                        advanceTimers(currentTime);
                                        hasMoreWork = !0;
                                        break b;
                                    }
                                    currentTask === peek(taskQueue) && pop(taskQueue);
                                    advanceTimers(currentTime);
                                } else pop(taskQueue);
                                currentTask = peek(taskQueue);
                            }
                            if (null !== currentTask) hasMoreWork = !0;
                            else {
                                var firstTimer = peek(timerQueue);
                                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                                hasMoreWork = !1;
                            }
                        }
                        break a;
                    } finally{
                        currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                    }
                    hasMoreWork = void 0;
                }
            } finally{
                hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
            }
        }
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        a: for(; 0 < index;){
            var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
            if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
            else break a;
        }
    }
    function peek(heap) {
        return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
        if (0 === heap.length) return null;
        var first = heap[0], last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
                var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
                if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
                else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
                else break a;
            }
        }
        return first;
    }
    function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return 0 !== diff ? diff : a.id - b.id;
    }
    function advanceTimers(currentTime) {
        for(var timer = peek(timerQueue); null !== timer;){
            if (null === timer.callback) pop(timerQueue);
            else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
            else break;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = !1;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
            else {
                var firstTimer = peek(timerQueue);
                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function shouldYieldToHost() {
        return needsPaint ? !0 : $629d958c29320def$export$c4744153514ff05d() - startTime < frameInterval ? !1 : !0;
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($629d958c29320def$export$c4744153514ff05d());
        }, ms);
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    $629d958c29320def$export$c4744153514ff05d = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        $629d958c29320def$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date, initialTime = localDate.now();
        $629d958c29320def$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    if ("function" === typeof localSetImmediate) var schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    $629d958c29320def$export$3e506c1ccc9cc1a7 = 5;
    $629d958c29320def$export$e26fe2ed2fa76875 = 1;
    $629d958c29320def$export$502329bbf4b505b1 = 4;
    $629d958c29320def$export$6e3807111c4874c4 = 3;
    $629d958c29320def$export$c27134553091fb3a = null;
    $629d958c29320def$export$33ee1acdc04fd2a2 = 2;
    $629d958c29320def$export$b00a404bbd5edef2 = function(task) {
        task.callback = null;
    };
    $629d958c29320def$export$d66a1c1c77bd778b = function(fps) {
        0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    $629d958c29320def$export$d3dfb8e4810cb555 = function() {
        return currentPriorityLevel;
    };
    $629d958c29320def$export$72fdf0e06517287b = function(eventHandler) {
        switch(currentPriorityLevel){
            case 1:
            case 2:
            case 3:
                var priorityLevel = 3;
                break;
            default:
                priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $629d958c29320def$export$816d2913ae6b83b1 = function() {
        needsPaint = !0;
    };
    $629d958c29320def$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $629d958c29320def$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
        var currentTime = $629d958c29320def$export$c4744153514ff05d();
        "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
        switch(priorityLevel){
            case 1:
                var timeout = -1;
                break;
            case 2:
                timeout = 250;
                break;
            case 5:
                timeout = 1073741823;
                break;
            case 4:
                timeout = 1e4;
                break;
            default:
                timeout = 5e3;
        }
        timeout = options + timeout;
        priorityLevel = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: options,
            expirationTime: timeout,
            sortIndex: -1
        };
        options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
    };
    $629d958c29320def$export$b5836b71941fa3ed = shouldYieldToHost;
    $629d958c29320def$export$cf845f2c119da08a = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("kyS4G"));

});
parcelRegister("kyS4G", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $ef80edb8fcbcdfb6$export$69ce8ef3fe5cead0; }, function (v) { return $ef80edb8fcbcdfb6$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $ef80edb8fcbcdfb6$export$3f2684e5d7cb1006; }, function (v) { return $ef80edb8fcbcdfb6$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $ef80edb8fcbcdfb6$export$d39a5bbd09211389; }, function (v) { return $ef80edb8fcbcdfb6$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $ef80edb8fcbcdfb6$export$cd75ccfd720a3cd4; }, function (v) { return $ef80edb8fcbcdfb6$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $ef80edb8fcbcdfb6$export$a0816fa17a9e79be; }, function (v) { return $ef80edb8fcbcdfb6$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $ef80edb8fcbcdfb6$export$7292efcadded39f3; }, function (v) { return $ef80edb8fcbcdfb6$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $ef80edb8fcbcdfb6$export$da407abadb9b8f86; }, function (v) { return $ef80edb8fcbcdfb6$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $ef80edb8fcbcdfb6$export$314cfea32580671c; }, function (v) { return $ef80edb8fcbcdfb6$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $ef80edb8fcbcdfb6$export$513ccb98c53b8039; }, function (v) { return $ef80edb8fcbcdfb6$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $ef80edb8fcbcdfb6$export$dbca993bc2d264a; }, function (v) { return $ef80edb8fcbcdfb6$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $ef80edb8fcbcdfb6$export$4797a8006f0655d0; }, function (v) { return $ef80edb8fcbcdfb6$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $ef80edb8fcbcdfb6$export$c78a37762a8d58e1; }, function (v) { return $ef80edb8fcbcdfb6$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $ef80edb8fcbcdfb6$export$606f11b2eb45ecc6; }, function (v) { return $ef80edb8fcbcdfb6$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $ef80edb8fcbcdfb6$export$f7e8a0bf92324b1e; }, function (v) { return $ef80edb8fcbcdfb6$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $ef80edb8fcbcdfb6$export$83d89fbfd8236492; }, function (v) { return $ef80edb8fcbcdfb6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef80edb8fcbcdfb6$export$69ce8ef3fe5cead0;
var $ef80edb8fcbcdfb6$export$3f2684e5d7cb1006;
var $ef80edb8fcbcdfb6$export$d39a5bbd09211389;
var $ef80edb8fcbcdfb6$export$cd75ccfd720a3cd4;
var $ef80edb8fcbcdfb6$export$a0816fa17a9e79be;
var $ef80edb8fcbcdfb6$export$7292efcadded39f3;
var $ef80edb8fcbcdfb6$export$da407abadb9b8f86;
var $ef80edb8fcbcdfb6$export$314cfea32580671c;
var $ef80edb8fcbcdfb6$export$513ccb98c53b8039;
var $ef80edb8fcbcdfb6$export$dbca993bc2d264a;
var $ef80edb8fcbcdfb6$export$4797a8006f0655d0;
var $ef80edb8fcbcdfb6$export$c78a37762a8d58e1;
var $ef80edb8fcbcdfb6$export$606f11b2eb45ecc6;
var $ef80edb8fcbcdfb6$export$f7e8a0bf92324b1e;
var $ef80edb8fcbcdfb6$export$83d89fbfd8236492;
"use strict";

(function() {
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        if (null == key) key = null;
        else if (key === REACT_OPTIMISTIC_KEY) key = REACT_OPTIMISTIC_KEY;
        else {
            try {
                testStringCoercion(key);
                var JSCompiler_inline_result = !1;
            } catch (e) {
                JSCompiler_inline_result = !0;
            }
            JSCompiler_inline_result && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", "function" === typeof Symbol && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"), testStringCoercion(key));
            key = "" + key;
        }
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    function getCrossOriginStringAs(as, input) {
        if ("font" === as) return "";
        if ("string" === typeof input) return "use-credentials" === input ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : "string" === typeof thing ? JSON.stringify(thing) : "number" === typeof thing ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("7fPBF")), Internals = {
        d: {
            f: noop,
            r: function() {
                throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
            },
            D: noop,
            C: noop,
            L: noop,
            m: noop,
            X: noop,
            S: noop,
            M: noop
        },
        p: 0,
        findDOMNode: null
    }, REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    $ef80edb8fcbcdfb6$export$69ce8ef3fe5cead0 = Internals;
    $ef80edb8fcbcdfb6$export$3f2684e5d7cb1006 = function(reason) {
        return {
            $$typeof: REACT_RECOVERABLE_TYPE,
            _reason: reason
        };
    };
    $ef80edb8fcbcdfb6$export$d39a5bbd09211389 = function(children, container) {
        var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error("Target container is not a DOM element.");
        return createPortal$1(children, container, null, key);
    };
    $ef80edb8fcbcdfb6$export$cd75ccfd720a3cd4 = function(fn) {
        var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
        try {
            if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
        } finally{
            ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        }
    };
    $ef80edb8fcbcdfb6$export$a0816fa17a9e79be = function(href, options) {
        "string" === typeof href && href ? null != options && "object" !== typeof options ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", getValueDescriptorExpectingEnumForWarning(options)) : null != options && "string" !== typeof options.crossOrigin && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", getValueDescriptorExpectingObjectForWarning(options.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
    };
    $ef80edb8fcbcdfb6$export$7292efcadded39f3 = function(href) {
        if ("string" !== typeof href || !href) console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        else if (1 < arguments.length) {
            var options = arguments[1];
            "object" === typeof options && options.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options));
        }
        "string" === typeof href && Internals.d.D(href);
    };
    $ef80edb8fcbcdfb6$export$da407abadb9b8f86 = function(href, options) {
        "string" === typeof href && href ? null == options || "object" !== typeof options ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", getValueDescriptorExpectingEnumForWarning(options)) : "style" !== options.as && "script" !== options.as && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', getValueDescriptorExpectingEnumForWarning(options.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        if ("string" === typeof href && options && "string" === typeof options.as) {
            var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
            "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority
            }) : "script" === as && Internals.d.X(href, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0
            });
        }
    };
    $ef80edb8fcbcdfb6$export$314cfea32580671c = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "script" !== options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
        if (encountered) console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", encountered);
        else switch(encountered = options && "string" === typeof options.as ? options.as : "script", encountered){
            case "script":
                break;
            default:
                encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', encountered, href);
        }
        if ("string" === typeof href) {
            if ("object" === typeof options && null !== options) {
                if (null == options.as || "script" === options.as) encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.M(href, {
                    crossOrigin: encountered,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            } else null == options && Internals.d.M(href);
        }
    };
    $ef80edb8fcbcdfb6$export$513ccb98c53b8039 = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        null == options || "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : "string" === typeof options.as && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', encountered);
        if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
            encountered = options.as;
            var crossOrigin = getCrossOriginStringAs(encountered, options.crossOrigin);
            Internals.d.L(href, encountered, {
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                type: "string" === typeof options.type ? options.type : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
                referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
                imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
                imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
                media: "string" === typeof options.media ? options.media : void 0
            });
        }
    };
    $ef80edb8fcbcdfb6$export$dbca993bc2d264a = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "string" !== typeof options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', encountered);
        "string" === typeof href && (options ? (encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.m(href, {
            as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
            crossOrigin: encountered,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
        })) : Internals.d.m(href));
    };
    $ef80edb8fcbcdfb6$export$4797a8006f0655d0 = function(form) {
        Internals.d.r(form);
    };
    $ef80edb8fcbcdfb6$export$c78a37762a8d58e1 = function(fn, a) {
        return fn(a);
    };
    $ef80edb8fcbcdfb6$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
        return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    $ef80edb8fcbcdfb6$export$f7e8a0bf92324b1e = function() {
        return resolveDispatcher().useHostTransitionStatus();
    };
    $ef80edb8fcbcdfb6$export$83d89fbfd8236492 = "19.3.0";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("gxpCl", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_RELATIVE_URL_REGEX", function () { return $469b705c8fa11364$export$825a82322d91916e; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $469b705c8fa11364$export$719fc203c4e16dee; });
$parcel$export(module.exports, "invariant", function () { return $469b705c8fa11364$export$f5708dca728d7177; });
$parcel$export(module.exports, "createContext", function () { return $469b705c8fa11364$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "RouterContextProvider", function () { return $469b705c8fa11364$export$b8d3e69d4b3eff04; });
$parcel$export(module.exports, "convertRoutesToDataRoutes", function () { return $469b705c8fa11364$export$87cb1a9238dc3fba; });
$parcel$export(module.exports, "matchRoutes", function () { return $469b705c8fa11364$export$2708184779ceb39d; });
$parcel$export(module.exports, "matchRoutesImpl", function () { return $469b705c8fa11364$export$5c7b09132f833c25; });
$parcel$export(module.exports, "stripBasename", function () { return $469b705c8fa11364$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "resolvePath", function () { return $469b705c8fa11364$export$b09f2ff0bbcb43c7; });
$parcel$export(module.exports, "redirect", function () { return $469b705c8fa11364$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "redirectDocument", function () { return $469b705c8fa11364$export$a6cd19cd1951a23c; });
$parcel$export(module.exports, "replace", function () { return $469b705c8fa11364$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "ErrorResponseImpl", function () { return $469b705c8fa11364$export$f2680fa305b734ca; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $469b705c8fa11364$export$972111febbeef05b; });
$parcel$export(module.exports, "instrumentHandler", function () { return $469b705c8fa11364$export$8f7a8e481272777; });
$parcel$export(module.exports, "validateNavigationTarget", function () { return $469b705c8fa11364$export$6c8e41f66e7aa990; });
$parcel$export(module.exports, "createRouter", function () { return $469b705c8fa11364$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "isMutationMethod", function () { return $469b705c8fa11364$export$cbae47800eb95bc3; });
$parcel$export(module.exports, "createStaticHandler", function () { return $469b705c8fa11364$export$3336b097a6fbc59a; });
$parcel$export(module.exports, "isResponse", function () { return $469b705c8fa11364$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isRedirectResponse", function () { return $469b705c8fa11364$export$6e80290866a84dd4; });
$parcel$export(module.exports, "isDataWithResponseInit", function () { return $469b705c8fa11364$export$e0163cfdf7bc9cfa; });
$parcel$export(module.exports, "getStaticContextFromError", function () { return $469b705c8fa11364$export$fec11da027c70692; });
$parcel$export(module.exports, "hasInvalidProtocol", function () { return $469b705c8fa11364$export$961a3ef7a4da3a39; });
$parcel$export(module.exports, "isRedirectStatusCode", function () { return $469b705c8fa11364$export$794b2760043cf8cd; });
$parcel$export(module.exports, "RSCRouterContext", function () { return $469b705c8fa11364$export$717f757c655223f1; });
$parcel$export(module.exports, "ENABLE_DEV_WARNINGS", function () { return $469b705c8fa11364$export$945fecf35a8ef089; });
$parcel$export(module.exports, "decodeRedirectErrorDigest", function () { return $469b705c8fa11364$export$30db792b333fd2ee; });
$parcel$export(module.exports, "decodeRouteErrorResponseDigest", function () { return $469b705c8fa11364$export$2b5950305b3e7eaf; });
$parcel$export(module.exports, "useLocation", function () { return $469b705c8fa11364$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $469b705c8fa11364$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $469b705c8fa11364$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteError", function () { return $469b705c8fa11364$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "useNavigation", function () { return $469b705c8fa11364$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useLoaderData", function () { return $469b705c8fa11364$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useBlocker", function () { return $469b705c8fa11364$export$b273b3273281a049; });
$parcel$export(module.exports, "warnOnce", function () { return $469b705c8fa11364$export$5b28268982f175ba; });
$parcel$export(module.exports, "mapRouteProperties", function () { return $469b705c8fa11364$export$9269a41d8c4635e; });
$parcel$export(module.exports, "hydrationRouteProperties", function () { return $469b705c8fa11364$export$e2fd2c03906469db; });
$parcel$export(module.exports, "createMemoryRouter", function () { return $469b705c8fa11364$export$f30f7e456d254e83; });
$parcel$export(module.exports, "RouterProvider", function () { return $469b705c8fa11364$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Outlet", function () { return $469b705c8fa11364$export$910ae8079b2c2852; });
$parcel$export(module.exports, "withComponentProps", function () { return $469b705c8fa11364$export$1a5de91a5c3255e0; });
$parcel$export(module.exports, "withHydrateFallbackProps", function () { return $469b705c8fa11364$export$cd4a5850c74ba029; });
$parcel$export(module.exports, "withErrorBoundaryProps", function () { return $469b705c8fa11364$export$26aea97ad016e70c; });
$parcel$export(module.exports, "encode", function () { return $469b705c8fa11364$export$c564cdbbe6da493; });
$parcel$export(module.exports, "createRequestInit", function () { return $469b705c8fa11364$export$a30aa2a0fce6c468; });
$parcel$export(module.exports, "escapeHtml", function () { return $469b705c8fa11364$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeAttribute", function () { return $469b705c8fa11364$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "SingleFetchRedirectSymbol", function () { return $469b705c8fa11364$export$60644022b8b46aaa; });
$parcel$export(module.exports, "SINGLE_FETCH_REDIRECT_STATUS", function () { return $469b705c8fa11364$export$ae9272e641ead836; });
$parcel$export(module.exports, "NO_BODY_STATUS_CODES", function () { return $469b705c8fa11364$export$e35ccdcde387134d; });
$parcel$export(module.exports, "StreamTransfer", function () { return $469b705c8fa11364$export$2b0b5f24fd77a79f; });
$parcel$export(module.exports, "getTurboStreamSingleFetchDataStrategy", function () { return $469b705c8fa11364$export$77d7799427e365da; });
$parcel$export(module.exports, "getSingleFetchDataStrategyImpl", function () { return $469b705c8fa11364$export$7144ac7f1a8613d3; });
$parcel$export(module.exports, "stripIndexParam", function () { return $469b705c8fa11364$export$425969b7f98e2c9c; });
$parcel$export(module.exports, "singleFetchUrl", function () { return $469b705c8fa11364$export$7b977381851b2c; });
$parcel$export(module.exports, "decodeViaTurboStream", function () { return $469b705c8fa11364$export$4023ad4ecd4126a2; });
$parcel$export(module.exports, "createServerRoutes", function () { return $469b705c8fa11364$export$5be2318464878170; });
$parcel$export(module.exports, "createClientRoutesWithHMRRevalidationOptOut", function () { return $469b705c8fa11364$export$49d9dc160d22054c; });
$parcel$export(module.exports, "createClientRoutes", function () { return $469b705c8fa11364$export$af76e85f27ba0229; });
$parcel$export(module.exports, "noActionDefinedError", function () { return $469b705c8fa11364$export$2754e84c8e66e57d; });
$parcel$export(module.exports, "shouldHydrateRouteLoader", function () { return $469b705c8fa11364$export$6ac68922d4e92125; });
$parcel$export(module.exports, "URL_LIMIT", function () { return $469b705c8fa11364$export$b5915cf27fa06b9f; });
$parcel$export(module.exports, "getPathsWithAncestors", function () { return $469b705c8fa11364$export$791cac19ae57137a; });
$parcel$export(module.exports, "getPatchRoutesOnNavigationFunction", function () { return $469b705c8fa11364$export$72ab377a1030deb9; });
$parcel$export(module.exports, "useFogOFWarDiscovery", function () { return $469b705c8fa11364$export$5ef046b23d96090d; });
$parcel$export(module.exports, "getManifestPath", function () { return $469b705c8fa11364$export$bcb79c3deff01d56; });
$parcel$export(module.exports, "FrameworkContext", function () { return $469b705c8fa11364$export$208d6a3bc3aa62bd; });
$parcel$export(module.exports, "setIsHydrated", function () { return $469b705c8fa11364$export$3be068dde909e563; });
$parcel$export(module.exports, "RemixErrorBoundary", function () { return $469b705c8fa11364$export$32e57f52df4b6e34; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $469b705c8fa11364$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $469b705c8fa11364$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $469b705c8fa11364$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useSearchParams", function () { return $469b705c8fa11364$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "StaticRouterProvider", function () { return $469b705c8fa11364$export$3d80f15952491985; });
$parcel$export(module.exports, "createStaticRouter", function () { return $469b705c8fa11364$export$3dd6171c30258b6f; });
/**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
var $469b705c8fa11364$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-OB3PAWPO.mjs"
});
var $469b705c8fa11364$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $469b705c8fa11364$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $469b705c8fa11364$var$__typeError("Cannot " + msg);
var $469b705c8fa11364$var$__privateGet = (obj, member, getter)=>($469b705c8fa11364$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $469b705c8fa11364$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $469b705c8fa11364$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $469b705c8fa11364$var$__privateSet = (obj, member, value, setter)=>($469b705c8fa11364$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $469b705c8fa11364$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $469b705c8fa11364$export$825a82322d91916e = /^[\\/]{2}/;
function $469b705c8fa11364$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $469b705c8fa11364$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($469b705c8fa11364$export$e19cd5f9376f8cee || {});
var $469b705c8fa11364$var$PopStateEventType = "popstate";
function $469b705c8fa11364$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $469b705c8fa11364$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $469b705c8fa11364$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $469b705c8fa11364$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $469b705c8fa11364$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $469b705c8fa11364$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $469b705c8fa11364$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $469b705c8fa11364$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    }
    return $469b705c8fa11364$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $469b705c8fa11364$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $469b705c8fa11364$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $469b705c8fa11364$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $469b705c8fa11364$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $469b705c8fa11364$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $469b705c8fa11364$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $469b705c8fa11364$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $469b705c8fa11364$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $469b705c8fa11364$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $469b705c8fa11364$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $469b705c8fa11364$var$createKey(),
        mask: mask
    };
    return location;
}
function $469b705c8fa11364$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $469b705c8fa11364$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $469b705c8fa11364$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $469b705c8fa11364$var$isLocation(to) ? to : $469b705c8fa11364$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $469b705c8fa11364$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $469b705c8fa11364$var$isLocation(to) ? to : $469b705c8fa11364$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $469b705c8fa11364$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $469b705c8fa11364$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($469b705c8fa11364$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($469b705c8fa11364$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $469b705c8fa11364$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $469b705c8fa11364$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $469b705c8fa11364$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $469b705c8fa11364$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $469b705c8fa11364$var$_map;
var $469b705c8fa11364$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_map).has(context)) return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_map).set(context, value);
    }
};
$469b705c8fa11364$var$_map = new WeakMap();
var $469b705c8fa11364$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $469b705c8fa11364$var$isUnsupportedLazyRouteObjectKey(key) {
    return $469b705c8fa11364$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $469b705c8fa11364$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $469b705c8fa11364$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $469b705c8fa11364$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $469b705c8fa11364$var$isIndexRoute(route) {
    return route.index === true;
}
function $469b705c8fa11364$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $469b705c8fa11364$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $469b705c8fa11364$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($469b705c8fa11364$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $469b705c8fa11364$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $469b705c8fa11364$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $469b705c8fa11364$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $469b705c8fa11364$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $469b705c8fa11364$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $469b705c8fa11364$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $469b705c8fa11364$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $469b705c8fa11364$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $469b705c8fa11364$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $469b705c8fa11364$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $469b705c8fa11364$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $469b705c8fa11364$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $469b705c8fa11364$var$flattenAndRankRoutes(routes) {
    let branches = $469b705c8fa11364$var$flattenRoutes(routes);
    $469b705c8fa11364$var$rankRouteBranches(branches);
    return branches;
}
function $469b705c8fa11364$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $469b705c8fa11364$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $469b705c8fa11364$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $469b705c8fa11364$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $469b705c8fa11364$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $469b705c8fa11364$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $469b705c8fa11364$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $469b705c8fa11364$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $469b705c8fa11364$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $469b705c8fa11364$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $469b705c8fa11364$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $469b705c8fa11364$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $469b705c8fa11364$var$paramRe = /^:[\w-]+$/;
var $469b705c8fa11364$var$dynamicSegmentValue = 3;
var $469b705c8fa11364$var$indexRouteValue = 2;
var $469b705c8fa11364$var$emptySegmentValue = 1;
var $469b705c8fa11364$var$staticSegmentValue = 10;
var $469b705c8fa11364$var$splatPenalty = -2;
var $469b705c8fa11364$var$isSplat = (s)=>s === "*";
function $469b705c8fa11364$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($469b705c8fa11364$var$isSplat)) initialScore += $469b705c8fa11364$var$splatPenalty;
    if (index) initialScore += $469b705c8fa11364$var$indexRouteValue;
    return segments.filter((s)=>!$469b705c8fa11364$var$isSplat(s)).reduce((score, segment)=>score + ($469b705c8fa11364$var$paramRe.test(segment) ? $469b705c8fa11364$var$dynamicSegmentValue : segment === "" ? $469b705c8fa11364$var$emptySegmentValue : $469b705c8fa11364$var$staticSegmentValue), initialScore);
}
function $469b705c8fa11364$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $469b705c8fa11364$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $469b705c8fa11364$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $469b705c8fa11364$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $469b705c8fa11364$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $469b705c8fa11364$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $469b705c8fa11364$var$normalizePathname($469b705c8fa11364$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $469b705c8fa11364$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $469b705c8fa11364$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $469b705c8fa11364$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $469b705c8fa11364$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $469b705c8fa11364$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $469b705c8fa11364$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $469b705c8fa11364$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $469b705c8fa11364$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $469b705c8fa11364$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $469b705c8fa11364$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $469b705c8fa11364$var$compilePath(path, caseSensitive = false, end = true) {
    $469b705c8fa11364$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $469b705c8fa11364$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $469b705c8fa11364$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $469b705c8fa11364$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $469b705c8fa11364$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
        basename,
        pathname
    ]);
}
var $469b705c8fa11364$var$isAbsoluteUrl = (url)=>$469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(url);
function $469b705c8fa11364$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $469b705c8fa11364$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $469b705c8fa11364$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $469b705c8fa11364$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $469b705c8fa11364$var$normalizeSearch(search),
        hash: $469b705c8fa11364$var$normalizeHash(hash)
    };
}
function $469b705c8fa11364$var$resolvePathname(relativePath, fromPathname) {
    let segments = $469b705c8fa11364$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $469b705c8fa11364$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $469b705c8fa11364$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $469b705c8fa11364$var$getResolveToMatches(matches) {
    let pathMatches = $469b705c8fa11364$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $469b705c8fa11364$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $469b705c8fa11364$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $469b705c8fa11364$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $469b705c8fa11364$var$getInvalidPathError("?", "pathname", "search", to));
        $469b705c8fa11364$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $469b705c8fa11364$var$getInvalidPathError("#", "pathname", "hash", to));
        $469b705c8fa11364$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $469b705c8fa11364$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $469b705c8fa11364$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $469b705c8fa11364$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $469b705c8fa11364$var$joinPaths = (paths)=>$469b705c8fa11364$var$removeDoubleSlashes(paths.join("/"));
function $469b705c8fa11364$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $469b705c8fa11364$var$normalizePathname = (pathname)=>$469b705c8fa11364$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $469b705c8fa11364$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $469b705c8fa11364$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $469b705c8fa11364$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $469b705c8fa11364$export$4051a07651545597(data2, init) {
    return new $469b705c8fa11364$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $469b705c8fa11364$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $469b705c8fa11364$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $469b705c8fa11364$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $469b705c8fa11364$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $469b705c8fa11364$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $469b705c8fa11364$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $469b705c8fa11364$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $469b705c8fa11364$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $469b705c8fa11364$var$joinPaths(parts) || "/";
}
var $469b705c8fa11364$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $469b705c8fa11364$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($469b705c8fa11364$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $469b705c8fa11364$export$825a82322d91916e.test(to) ? new URL($469b705c8fa11364$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $469b705c8fa11364$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $469b705c8fa11364$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $469b705c8fa11364$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $469b705c8fa11364$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $469b705c8fa11364$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $469b705c8fa11364$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$469b705c8fa11364$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $469b705c8fa11364$var$wrapImpl(aggregated[key], original, (...args)=>$469b705c8fa11364$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$469b705c8fa11364$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$469b705c8fa11364$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $469b705c8fa11364$var$wrapImpl(aggregated.middleware, original, (...args)=>$469b705c8fa11364$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$469b705c8fa11364$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $469b705c8fa11364$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$469b705c8fa11364$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $469b705c8fa11364$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $469b705c8fa11364$export$fe53371bee54353d(to) : ".",
                ...$469b705c8fa11364$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$469b705c8fa11364$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$469b705c8fa11364$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $469b705c8fa11364$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$469b705c8fa11364$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$469b705c8fa11364$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $469b705c8fa11364$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $469b705c8fa11364$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $469b705c8fa11364$var$getReadonlyRequest(request),
            context: context != null ? $469b705c8fa11364$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $469b705c8fa11364$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $469b705c8fa11364$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $469b705c8fa11364$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $469b705c8fa11364$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $469b705c8fa11364$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $469b705c8fa11364$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $469b705c8fa11364$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $469b705c8fa11364$var$getReadonlyContext(context)
    };
}
function $469b705c8fa11364$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $469b705c8fa11364$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $469b705c8fa11364$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $469b705c8fa11364$var$getReadonlyContext(context) {
    if ($469b705c8fa11364$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $469b705c8fa11364$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $469b705c8fa11364$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $469b705c8fa11364$var$objectProtoNames;
}
// lib/router/navigation.ts
var $469b705c8fa11364$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $469b705c8fa11364$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $469b705c8fa11364$var$DEFAULT_NAVIGATION_URL;
    }
}
function $469b705c8fa11364$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $469b705c8fa11364$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $469b705c8fa11364$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$469b705c8fa11364$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$469b705c8fa11364$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$469b705c8fa11364$var$isExplicitUrl(original, originalUrl) || !$469b705c8fa11364$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $469b705c8fa11364$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $469b705c8fa11364$var$validMutationMethods = new Set($469b705c8fa11364$var$validMutationMethodsArr);
var $469b705c8fa11364$var$validRequestMethodsArr = [
    "GET",
    ...$469b705c8fa11364$var$validMutationMethodsArr
];
var $469b705c8fa11364$var$validRequestMethods = new Set($469b705c8fa11364$var$validRequestMethodsArr);
var $469b705c8fa11364$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $469b705c8fa11364$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $469b705c8fa11364$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $469b705c8fa11364$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $469b705c8fa11364$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $469b705c8fa11364$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $469b705c8fa11364$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $469b705c8fa11364$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $469b705c8fa11364$var$_routes, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$_hmrRoutes, $469b705c8fa11364$var$_hmrBranches;
var $469b705c8fa11364$var$DataRoutes = class {
    constructor(routes){
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_routes);
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_branches);
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_hmrRoutes);
        $469b705c8fa11364$var$__privateAdd(this, $469b705c8fa11364$var$_hmrBranches);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_routes, routes);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes) ?? $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrBranches) ?? $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_branches);
    }
    get hasHMRRoutes() {
        return $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_routes, routes);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrRoutes, routes);
        $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrBranches, $469b705c8fa11364$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes)) {
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_routes, $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrRoutes));
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_branches, $469b705c8fa11364$var$__privateGet(this, $469b705c8fa11364$var$_hmrBranches));
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrRoutes, void 0);
            $469b705c8fa11364$var$__privateSet(this, $469b705c8fa11364$var$_hmrBranches, void 0);
        }
    }
};
$469b705c8fa11364$var$_routes = new WeakMap();
$469b705c8fa11364$var$_branches = new WeakMap();
$469b705c8fa11364$var$_hmrRoutes = new WeakMap();
$469b705c8fa11364$var$_hmrBranches = new WeakMap();
function $469b705c8fa11364$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $469b705c8fa11364$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $469b705c8fa11364$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$469b705c8fa11364$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $469b705c8fa11364$var$DataRoutes($469b705c8fa11364$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $469b705c8fa11364$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$469b705c8fa11364$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $469b705c8fa11364$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $469b705c8fa11364$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $469b705c8fa11364$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $469b705c8fa11364$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $469b705c8fa11364$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$469b705c8fa11364$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $469b705c8fa11364$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $469b705c8fa11364$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $469b705c8fa11364$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $469b705c8fa11364$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $469b705c8fa11364$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $469b705c8fa11364$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $469b705c8fa11364$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $469b705c8fa11364$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($469b705c8fa11364$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $469b705c8fa11364$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $469b705c8fa11364$export$fe53371bee54353d(opts.mask), $469b705c8fa11364$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $469b705c8fa11364$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $469b705c8fa11364$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $469b705c8fa11364$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $469b705c8fa11364$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $469b705c8fa11364$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $469b705c8fa11364$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $469b705c8fa11364$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $469b705c8fa11364$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $469b705c8fa11364$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($469b705c8fa11364$var$isErrorResult(result) && $469b705c8fa11364$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $469b705c8fa11364$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $469b705c8fa11364$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$469b705c8fa11364$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $469b705c8fa11364$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $469b705c8fa11364$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $469b705c8fa11364$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $469b705c8fa11364$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($469b705c8fa11364$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $469b705c8fa11364$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $469b705c8fa11364$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $469b705c8fa11364$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $469b705c8fa11364$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $469b705c8fa11364$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$469b705c8fa11364$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $469b705c8fa11364$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $469b705c8fa11364$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $469b705c8fa11364$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$469b705c8fa11364$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $469b705c8fa11364$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $469b705c8fa11364$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $469b705c8fa11364$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $469b705c8fa11364$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $469b705c8fa11364$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $469b705c8fa11364$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $469b705c8fa11364$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $469b705c8fa11364$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $469b705c8fa11364$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($469b705c8fa11364$var$isRedirectResult(actionResult) || $469b705c8fa11364$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($469b705c8fa11364$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $469b705c8fa11364$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($469b705c8fa11364$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $469b705c8fa11364$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $469b705c8fa11364$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $469b705c8fa11364$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $469b705c8fa11364$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $469b705c8fa11364$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $469b705c8fa11364$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $469b705c8fa11364$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $469b705c8fa11364$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $469b705c8fa11364$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $469b705c8fa11364$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $469b705c8fa11364$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $469b705c8fa11364$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $469b705c8fa11364$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $469b705c8fa11364$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $469b705c8fa11364$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $469b705c8fa11364$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
            return;
        }
        if ($469b705c8fa11364$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $469b705c8fa11364$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $469b705c8fa11364$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $469b705c8fa11364$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $469b705c8fa11364$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($469b705c8fa11364$var$isAbsoluteUrl(location)) {
                const url = $469b705c8fa11364$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $469b705c8fa11364$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $469b705c8fa11364$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($469b705c8fa11364$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $469b705c8fa11364$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $469b705c8fa11364$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $469b705c8fa11364$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$469b705c8fa11364$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($469b705c8fa11364$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $469b705c8fa11364$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $469b705c8fa11364$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $469b705c8fa11364$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $469b705c8fa11364$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $469b705c8fa11364$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $469b705c8fa11364$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $469b705c8fa11364$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $469b705c8fa11364$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $469b705c8fa11364$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $469b705c8fa11364$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $469b705c8fa11364$export$386d57f03f0b2883;
        $469b705c8fa11364$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $469b705c8fa11364$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $469b705c8fa11364$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$469b705c8fa11364$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $469b705c8fa11364$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($469b705c8fa11364$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $469b705c8fa11364$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $469b705c8fa11364$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $469b705c8fa11364$export$3336b097a6fbc59a(routes, opts) {
    $469b705c8fa11364$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $469b705c8fa11364$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$469b705c8fa11364$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $469b705c8fa11364$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $469b705c8fa11364$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $469b705c8fa11364$var$defaultNormalizePath;
        let method = request.method;
        let location = $469b705c8fa11364$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        if (!$469b705c8fa11364$var$isValidMethod(method) && method !== "HEAD") {
            let error = $469b705c8fa11364$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $469b705c8fa11364$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $469b705c8fa11364$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $469b705c8fa11364$export$f5708dca728d7177(requestContext instanceof $469b705c8fa11364$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $469b705c8fa11364$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $469b705c8fa11364$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $469b705c8fa11364$var$createDataFunctionUrl(request, location),
                    pattern: $469b705c8fa11364$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($469b705c8fa11364$export$6e80290866a84dd4(error)) return error;
                    if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $469b705c8fa11364$export$f2680fa305b734ca(error.status, error.statusText, await $469b705c8fa11364$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(error)) error = $469b705c8fa11364$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $469b705c8fa11364$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $469b705c8fa11364$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $469b705c8fa11364$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $469b705c8fa11364$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $469b705c8fa11364$var$defaultNormalizePath;
        let method = request.method;
        let location = $469b705c8fa11364$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $469b705c8fa11364$export$b8d3e69d4b3eff04();
        if (!$469b705c8fa11364$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $469b705c8fa11364$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $469b705c8fa11364$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $469b705c8fa11364$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $469b705c8fa11364$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $469b705c8fa11364$export$f5708dca728d7177(requestContext instanceof $469b705c8fa11364$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $469b705c8fa11364$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $469b705c8fa11364$var$runServerMiddlewarePipeline({
                request: request,
                url: $469b705c8fa11364$var$createDataFunctionUrl(request, location),
                pattern: $469b705c8fa11364$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $469b705c8fa11364$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($469b705c8fa11364$var$dataWithResponseInitToResponse(error));
                if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $469b705c8fa11364$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($469b705c8fa11364$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $469b705c8fa11364$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $469b705c8fa11364$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($469b705c8fa11364$var$isDataStrategyResult(e) && $469b705c8fa11364$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($469b705c8fa11364$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $469b705c8fa11364$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $469b705c8fa11364$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($469b705c8fa11364$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($469b705c8fa11364$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($469b705c8fa11364$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $469b705c8fa11364$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $469b705c8fa11364$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $469b705c8fa11364$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $469b705c8fa11364$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $469b705c8fa11364$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $469b705c8fa11364$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $469b705c8fa11364$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $469b705c8fa11364$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $469b705c8fa11364$var$callDataStrategyImpl(dataStrategy || $469b705c8fa11364$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($469b705c8fa11364$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $469b705c8fa11364$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(result.result)) throw $469b705c8fa11364$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $469b705c8fa11364$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $469b705c8fa11364$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $469b705c8fa11364$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $469b705c8fa11364$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $469b705c8fa11364$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $469b705c8fa11364$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $469b705c8fa11364$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $469b705c8fa11364$var$resolveTo(to ? to : ".", $469b705c8fa11364$var$getResolveToMatches(contextualMatches), $469b705c8fa11364$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $469b705c8fa11364$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $469b705c8fa11364$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $469b705c8fa11364$export$fe53371bee54353d(path);
}
function $469b705c8fa11364$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$469b705c8fa11364$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$469b705c8fa11364$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $469b705c8fa11364$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $469b705c8fa11364$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $469b705c8fa11364$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$469b705c8fa11364$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$469b705c8fa11364$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $469b705c8fa11364$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $469b705c8fa11364$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $469b705c8fa11364$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $469b705c8fa11364$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $469b705c8fa11364$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $469b705c8fa11364$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $469b705c8fa11364$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $469b705c8fa11364$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $469b705c8fa11364$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $469b705c8fa11364$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$469b705c8fa11364$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $469b705c8fa11364$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($469b705c8fa11364$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($469b705c8fa11364$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $469b705c8fa11364$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $469b705c8fa11364$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $469b705c8fa11364$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $469b705c8fa11364$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($469b705c8fa11364$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $469b705c8fa11364$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $469b705c8fa11364$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$469b705c8fa11364$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $469b705c8fa11364$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $469b705c8fa11364$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $469b705c8fa11364$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $469b705c8fa11364$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $469b705c8fa11364$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$469b705c8fa11364$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $469b705c8fa11364$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $469b705c8fa11364$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $469b705c8fa11364$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$469b705c8fa11364$var$isSameRoute(aChild, bChild))) ?? false;
}
var $469b705c8fa11364$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $469b705c8fa11364$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $469b705c8fa11364$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $469b705c8fa11364$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $469b705c8fa11364$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $469b705c8fa11364$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $469b705c8fa11364$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $469b705c8fa11364$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $469b705c8fa11364$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $469b705c8fa11364$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $469b705c8fa11364$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $469b705c8fa11364$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $469b705c8fa11364$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $469b705c8fa11364$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $469b705c8fa11364$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $469b705c8fa11364$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $469b705c8fa11364$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $469b705c8fa11364$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $469b705c8fa11364$var$isNonNullable(value) {
    return value !== void 0;
}
function $469b705c8fa11364$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $469b705c8fa11364$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($469b705c8fa11364$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $469b705c8fa11364$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $469b705c8fa11364$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $469b705c8fa11364$var$defaultDataStrategy(args);
    return $469b705c8fa11364$var$runClientMiddlewarePipeline(args, ()=>$469b705c8fa11364$var$defaultDataStrategy(args));
}
function $469b705c8fa11364$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $469b705c8fa11364$var$runMiddlewarePipeline(args, handler, processResult, $469b705c8fa11364$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $469b705c8fa11364$export$e0163cfdf7bc9cfa(result) ? $469b705c8fa11364$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $469b705c8fa11364$var$runClientMiddlewarePipeline(args, handler) {
    return $469b705c8fa11364$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($469b705c8fa11364$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $469b705c8fa11364$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $469b705c8fa11364$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $469b705c8fa11364$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $469b705c8fa11364$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $469b705c8fa11364$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $469b705c8fa11364$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $469b705c8fa11364$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $469b705c8fa11364$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $469b705c8fa11364$var$loadLazyRoute(match.route, $469b705c8fa11364$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $469b705c8fa11364$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $469b705c8fa11364$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $469b705c8fa11364$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $469b705c8fa11364$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$469b705c8fa11364$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($469b705c8fa11364$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $469b705c8fa11364$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $469b705c8fa11364$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $469b705c8fa11364$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $469b705c8fa11364$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $469b705c8fa11364$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $469b705c8fa11364$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $469b705c8fa11364$var$createDataFunctionUrl(request, path),
        pattern: $469b705c8fa11364$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $469b705c8fa11364$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $469b705c8fa11364$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $469b705c8fa11364$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $469b705c8fa11364$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $469b705c8fa11364$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $469b705c8fa11364$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $469b705c8fa11364$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $469b705c8fa11364$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $469b705c8fa11364$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $469b705c8fa11364$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $469b705c8fa11364$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $469b705c8fa11364$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $469b705c8fa11364$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($469b705c8fa11364$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $469b705c8fa11364$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $469b705c8fa11364$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$469b705c8fa11364$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $469b705c8fa11364$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $469b705c8fa11364$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $469b705c8fa11364$export$961a3ef7a4da3a39(location) {
    try {
        return $469b705c8fa11364$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $469b705c8fa11364$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($469b705c8fa11364$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $469b705c8fa11364$export$825a82322d91916e.test(normalizedLocation) ? new URL($469b705c8fa11364$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($469b705c8fa11364$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $469b705c8fa11364$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $469b705c8fa11364$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($469b705c8fa11364$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $469b705c8fa11364$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($469b705c8fa11364$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $469b705c8fa11364$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $469b705c8fa11364$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $469b705c8fa11364$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $469b705c8fa11364$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $469b705c8fa11364$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $469b705c8fa11364$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $469b705c8fa11364$export$f5708dca728d7177(!$469b705c8fa11364$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $469b705c8fa11364$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $469b705c8fa11364$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $469b705c8fa11364$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $469b705c8fa11364$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $469b705c8fa11364$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($469b705c8fa11364$var$isErrorResult(result)) {
            let boundaryMatch = $469b705c8fa11364$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($469b705c8fa11364$var$isRedirectResult(result)) $469b705c8fa11364$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $469b705c8fa11364$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $469b705c8fa11364$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $469b705c8fa11364$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $469b705c8fa11364$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $469b705c8fa11364$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $469b705c8fa11364$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $469b705c8fa11364$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $469b705c8fa11364$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $469b705c8fa11364$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $469b705c8fa11364$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($469b705c8fa11364$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $469b705c8fa11364$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(path) : path;
    return $469b705c8fa11364$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $469b705c8fa11364$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $469b705c8fa11364$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $469b705c8fa11364$var$dataWithResponseInitToErrorResponse(data2) {
    return new $469b705c8fa11364$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $469b705c8fa11364$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $469b705c8fa11364$var$isDataStrategyResult(value));
}
function $469b705c8fa11364$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $469b705c8fa11364$var$isRedirectDataStrategyResult(result) {
    return $469b705c8fa11364$export$3f1eb41d9a6a6a27(result.result) && $469b705c8fa11364$var$redirectStatusCodes.has(result.result.status);
}
function $469b705c8fa11364$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $469b705c8fa11364$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $469b705c8fa11364$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $469b705c8fa11364$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $469b705c8fa11364$export$794b2760043cf8cd(statusCode) {
    return $469b705c8fa11364$var$redirectStatusCodes.has(statusCode);
}
function $469b705c8fa11364$export$6e80290866a84dd4(result) {
    return $469b705c8fa11364$export$3f1eb41d9a6a6a27(result) && $469b705c8fa11364$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $469b705c8fa11364$var$isValidMethod(method) {
    return $469b705c8fa11364$var$validRequestMethods.has(method.toUpperCase());
}
function $469b705c8fa11364$export$cbae47800eb95bc3(method) {
    return $469b705c8fa11364$var$validMutationMethods.has(method.toUpperCase());
}
function $469b705c8fa11364$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $469b705c8fa11364$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $469b705c8fa11364$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $469b705c8fa11364$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $469b705c8fa11364$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $469b705c8fa11364$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $469b705c8fa11364$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $469b705c8fa11364$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $469b705c8fa11364$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $469b705c8fa11364$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $469b705c8fa11364$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($469b705c8fa11364$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $469b705c8fa11364$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($469b705c8fa11364$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $469b705c8fa11364$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $469b705c8fa11364$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $469b705c8fa11364$export$2eeee58951ff3c1c = $7fPBF.createContext(null);
$469b705c8fa11364$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $469b705c8fa11364$export$315e3ffb01f217 = $7fPBF.createContext(null);
$469b705c8fa11364$export$315e3ffb01f217.displayName = "DataRouterState";
var $469b705c8fa11364$export$717f757c655223f1 = $7fPBF.createContext(false);
function $469b705c8fa11364$var$useIsRSCRouterContext() {
    return $7fPBF.useContext($469b705c8fa11364$export$717f757c655223f1);
}
var $469b705c8fa11364$export$3681f408decb40d1 = $7fPBF.createContext({
    isTransitioning: false
});
$469b705c8fa11364$export$3681f408decb40d1.displayName = "ViewTransition";
var $469b705c8fa11364$export$cb3f1df1bef00a39 = $7fPBF.createContext(/* @__PURE__ */ new Map());
$469b705c8fa11364$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $469b705c8fa11364$var$AwaitContext = $7fPBF.createContext(null);
$469b705c8fa11364$var$AwaitContext.displayName = "Await";
var $469b705c8fa11364$export$2666c20e15407622 = (props)=>$7fPBF.createElement($469b705c8fa11364$var$AwaitContext.Provider, props);
var $469b705c8fa11364$export$3044ab7fdabeaee6 = $7fPBF.createContext(null);
$469b705c8fa11364$export$3044ab7fdabeaee6.displayName = "Navigation";
var $469b705c8fa11364$export$e6a44b110a0c44d3 = $7fPBF.createContext(null);
$469b705c8fa11364$export$e6a44b110a0c44d3.displayName = "Location";
var $469b705c8fa11364$export$aac280ed165a4397 = $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$469b705c8fa11364$export$aac280ed165a4397.displayName = "Route";
var $469b705c8fa11364$var$RouteErrorContext = $7fPBF.createContext(null);
$469b705c8fa11364$var$RouteErrorContext.displayName = "RouteError";
var $469b705c8fa11364$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $469b705c8fa11364$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $469b705c8fa11364$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $469b705c8fa11364$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $469b705c8fa11364$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$469b705c8fa11364$var$ERROR_DIGEST_BASE}:${$469b705c8fa11364$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $469b705c8fa11364$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$469b705c8fa11364$var$ERROR_DIGEST_BASE}:${$469b705c8fa11364$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $469b705c8fa11364$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $469b705c8fa11364$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $469b705c8fa11364$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($469b705c8fa11364$export$e6a44b110a0c44d3) != null;
}
function $469b705c8fa11364$export$45d76561a5302f2b() {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $7fPBF.useContext($469b705c8fa11364$export$e6a44b110a0c44d3).location;
}
function $469b705c8fa11364$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($469b705c8fa11364$export$e6a44b110a0c44d3).navigationType;
}
function $469b705c8fa11364$export$6c330e8992e8a295(pattern) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>$469b705c8fa11364$export$81336c211d5ff295(pattern, $469b705c8fa11364$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $469b705c8fa11364$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $469b705c8fa11364$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6).static;
    if (!isStatic) $7fPBF.useLayoutEffect(cb);
}
function $469b705c8fa11364$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    return isDataRoute ? $469b705c8fa11364$var$useNavigateStable() : $469b705c8fa11364$var$useNavigateUnstable();
}
function $469b705c8fa11364$var$useNavigateUnstable() {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let { pathname: locationPathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($469b705c8fa11364$var$getResolveToMatches(matches));
    let activeRef = $7fPBF.useRef(false);
    $469b705c8fa11364$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback((to, options = {})=>{
        $469b705c8fa11364$var$warning(activeRef.current, $469b705c8fa11364$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $469b705c8fa11364$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
            basename,
            path.pathname
        ]);
        $469b705c8fa11364$export$6c8e41f66e7aa990(typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to), navigator.createHref(path), $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $469b705c8fa11364$var$OutletContext = $7fPBF.createContext(null);
function $469b705c8fa11364$export$4138103a3ae699cc() {
    return $7fPBF.useContext($469b705c8fa11364$var$OutletContext);
}
function $469b705c8fa11364$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397).outlet;
    return $7fPBF.useMemo(()=>outlet && /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $469b705c8fa11364$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $469b705c8fa11364$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let { pathname: locationPathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($469b705c8fa11364$var$getResolveToMatches(matches));
    return $7fPBF.useMemo(()=>$469b705c8fa11364$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $469b705c8fa11364$export$5d3fca4a98652595(routes, locationArg) {
    return $469b705c8fa11364$var$useRoutesImpl(routes, locationArg);
}
function $469b705c8fa11364$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($469b705c8fa11364$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $469b705c8fa11364$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $469b705c8fa11364$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $469b705c8fa11364$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $469b705c8fa11364$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $469b705c8fa11364$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($469b705c8fa11364$export$945fecf35a8ef089) {
        $469b705c8fa11364$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $469b705c8fa11364$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $469b705c8fa11364$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $469b705c8fa11364$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $469b705c8fa11364$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $469b705c8fa11364$var$DefaultErrorComponent() {
    let error = $469b705c8fa11364$export$ed527bf60f6e05f2();
    let message = $469b705c8fa11364$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($469b705c8fa11364$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $7fPBF.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $7fPBF.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $469b705c8fa11364$var$defaultErrorElement = /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$DefaultErrorComponent, null);
var $469b705c8fa11364$var$RenderErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $469b705c8fa11364$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$469b705c8fa11364$var$RenderErrorBoundary.contextType = $469b705c8fa11364$export$717f757c655223f1;
var $469b705c8fa11364$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $469b705c8fa11364$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $469b705c8fa11364$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $469b705c8fa11364$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $469b705c8fa11364$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $469b705c8fa11364$export$6c8e41f66e7aa990(redirect2.location, target, $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($469b705c8fa11364$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($469b705c8fa11364$var$isBrowser && !$469b705c8fa11364$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $469b705c8fa11364$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $7fPBF.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $469b705c8fa11364$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $469b705c8fa11364$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $469b705c8fa11364$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $469b705c8fa11364$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $469b705c8fa11364$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $469b705c8fa11364$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $469b705c8fa11364$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $469b705c8fa11364$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    $469b705c8fa11364$export$f5708dca728d7177(ctx, $469b705c8fa11364$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $469b705c8fa11364$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    $469b705c8fa11364$export$f5708dca728d7177(state, $469b705c8fa11364$var$getDataRouterConsoleError(hookName));
    return state;
}
function $469b705c8fa11364$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    $469b705c8fa11364$export$f5708dca728d7177(route, $469b705c8fa11364$var$getDataRouterConsoleError(hookName));
    return route;
}
function $469b705c8fa11364$var$useCurrentRouteId(hookName) {
    let route = $469b705c8fa11364$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $469b705c8fa11364$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $469b705c8fa11364$var$useRouteId() {
    return $469b705c8fa11364$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $469b705c8fa11364$export$d0fd4b7106de2769() {
    let state = $469b705c8fa11364$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $7fPBF.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $469b705c8fa11364$export$600dc272ed516c15() {
    let dataRouterContext = $469b705c8fa11364$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $469b705c8fa11364$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $7fPBF.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $7fPBF.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $469b705c8fa11364$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $469b705c8fa11364$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $7fPBF.useMemo(()=>matches.map((m)=>$469b705c8fa11364$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $469b705c8fa11364$export$1448a5050d252c4d() {
    let state = $469b705c8fa11364$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $469b705c8fa11364$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $469b705c8fa11364$export$fd5d37484eab868d(routeId) {
    let state = $469b705c8fa11364$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $469b705c8fa11364$export$fdc00f3f26066d5e() {
    let state = $469b705c8fa11364$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $469b705c8fa11364$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $469b705c8fa11364$export$ed527bf60f6e05f2() {
    let error = $7fPBF.useContext($469b705c8fa11364$var$RouteErrorContext);
    let state = $469b705c8fa11364$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $469b705c8fa11364$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $469b705c8fa11364$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($469b705c8fa11364$var$AwaitContext);
    return value?._data;
}
function $469b705c8fa11364$export$17f53340677d5831() {
    let value = $7fPBF.useContext($469b705c8fa11364$var$AwaitContext);
    return value?._error;
}
var $469b705c8fa11364$var$blockerId = 0;
function $469b705c8fa11364$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $469b705c8fa11364$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $469b705c8fa11364$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $469b705c8fa11364$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $469b705c8fa11364$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $7fPBF.useEffect(()=>{
        let key = String(++$469b705c8fa11364$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $469b705c8fa11364$export$386d57f03f0b2883;
}
function $469b705c8fa11364$var$useNavigateStable() {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $469b705c8fa11364$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $7fPBF.useRef(false);
    $469b705c8fa11364$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(async (to, options = {})=>{
        $469b705c8fa11364$var$warning(activeRef.current, $469b705c8fa11364$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $469b705c8fa11364$var$alreadyWarned = {};
function $469b705c8fa11364$var$warningOnce(key, cond, message) {
    if (!cond && !$469b705c8fa11364$var$alreadyWarned[key]) {
        $469b705c8fa11364$var$alreadyWarned[key] = true;
        $469b705c8fa11364$var$warning(false, message);
    }
}
function $469b705c8fa11364$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $469b705c8fa11364$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $469b705c8fa11364$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $469b705c8fa11364$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $469b705c8fa11364$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $469b705c8fa11364$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $7fPBF.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$469b705c8fa11364$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $7fPBF.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$469b705c8fa11364$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $7fPBF.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $469b705c8fa11364$var$alreadyWarned2 = {};
function $469b705c8fa11364$export$5b28268982f175ba(condition, message) {
    if (!condition && !$469b705c8fa11364$var$alreadyWarned2[message]) {
        $469b705c8fa11364$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $469b705c8fa11364$var$USE_OPTIMISTIC = "useOptimistic";
var $469b705c8fa11364$var$useOptimisticImpl = $7fPBF[$469b705c8fa11364$var$USE_OPTIMISTIC];
var $469b705c8fa11364$var$stableUseOptimisticSetter = ()=>void 0;
function $469b705c8fa11364$var$useOptimisticSafe(val) {
    if ($469b705c8fa11364$var$useOptimisticImpl) return $469b705c8fa11364$var$useOptimisticImpl(val);
    else return [
        val,
        $469b705c8fa11364$var$stableUseOptimisticSetter
    ];
}
function $469b705c8fa11364$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($469b705c8fa11364$export$945fecf35a8ef089) {
            if (route.element) $469b705c8fa11364$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $7fPBF.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($469b705c8fa11364$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $469b705c8fa11364$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $7fPBF.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($469b705c8fa11364$export$945fecf35a8ef089) {
            if (route.errorElement) $469b705c8fa11364$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $7fPBF.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $469b705c8fa11364$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $469b705c8fa11364$export$f30f7e456d254e83(routes, opts) {
    return $469b705c8fa11364$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $469b705c8fa11364$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $469b705c8fa11364$export$e2fd2c03906469db,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $469b705c8fa11364$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $469b705c8fa11364$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $469b705c8fa11364$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $7fPBF.useState(router.state);
    let [state, setOptimisticState] = $469b705c8fa11364$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(/* @__PURE__ */ new Map());
    let setState = $7fPBF.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $469b705c8fa11364$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $469b705c8fa11364$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $469b705c8fa11364$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $7fPBF.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$469b705c8fa11364$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $469b705c8fa11364$var$Deferred());
    }, [
        vtContext
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $7fPBF.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$469b705c8fa11364$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $469b705c8fa11364$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $469b705c8fa11364$var$MemoizedDataRoutes = $7fPBF.memo($469b705c8fa11364$var$DataRoutes2);
function $469b705c8fa11364$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $469b705c8fa11364$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $469b705c8fa11364$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $469b705c8fa11364$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $469b705c8fa11364$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $469b705c8fa11364$export$f5708dca728d7177($469b705c8fa11364$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    $469b705c8fa11364$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let { pathname: locationPathname } = $469b705c8fa11364$export$45d76561a5302f2b();
    let navigate = $469b705c8fa11364$export$9770f232ac06a008();
    let path = $469b705c8fa11364$var$resolveTo(to, $469b705c8fa11364$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $469b705c8fa11364$export$6c8e41f66e7aa990(typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to), navigator.createHref(path), $469b705c8fa11364$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $469b705c8fa11364$export$910ae8079b2c2852(props) {
    return $469b705c8fa11364$export$a3be3530d8e40d0b(props.context);
}
function $469b705c8fa11364$export$e7b0ac011bb776c6(props) {
    $469b705c8fa11364$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $469b705c8fa11364$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $469b705c8fa11364$export$f5708dca728d7177(!$469b705c8fa11364$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $469b705c8fa11364$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = $469b705c8fa11364$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $469b705c8fa11364$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $469b705c8fa11364$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $469b705c8fa11364$export$5d3fca4a98652595($469b705c8fa11364$export$16da398f5434bdec(children), location);
}
function $469b705c8fa11364$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    let onError = $7fPBF.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $469b705c8fa11364$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$ResolveAwait, null, children));
}
var $469b705c8fa11364$var$AwaitErrorBoundary = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $469b705c8fa11364$var$ResolveAwait({ children: children }) {
    let data2 = $469b705c8fa11364$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
function $469b705c8fa11364$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!$7fPBF.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            routes.push.apply(routes, $469b705c8fa11364$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $469b705c8fa11364$export$f5708dca728d7177(element.type === $469b705c8fa11364$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $469b705c8fa11364$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $469b705c8fa11364$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $469b705c8fa11364$export$9b5b6d122dea0c88 = $469b705c8fa11364$export$16da398f5434bdec;
function $469b705c8fa11364$export$daf73786167a7f72(matches) {
    return $469b705c8fa11364$var$_renderMatches(matches);
}
function $469b705c8fa11364$var$useRouteComponentProps() {
    return {
        params: $469b705c8fa11364$export$99eaa27ddbbb95ef(),
        loaderData: $469b705c8fa11364$export$1448a5050d252c4d(),
        actionData: $469b705c8fa11364$export$fdc00f3f26066d5e(),
        matches: $469b705c8fa11364$export$2378eb7f5ff86053()
    };
}
function $469b705c8fa11364$export$6c4f3826290c37af({ children: children }) {
    const props = $469b705c8fa11364$var$useRouteComponentProps();
    return $7fPBF.cloneElement(children, props);
}
function $469b705c8fa11364$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $469b705c8fa11364$var$useRouteComponentProps();
        return $7fPBF.createElement(Component4, props);
    };
}
function $469b705c8fa11364$var$useHydrateFallbackProps() {
    return {
        params: $469b705c8fa11364$export$99eaa27ddbbb95ef(),
        loaderData: $469b705c8fa11364$export$1448a5050d252c4d(),
        actionData: $469b705c8fa11364$export$fdc00f3f26066d5e()
    };
}
function $469b705c8fa11364$export$f8cff34f39c1932a({ children: children }) {
    const props = $469b705c8fa11364$var$useHydrateFallbackProps();
    return $7fPBF.cloneElement(children, props);
}
function $469b705c8fa11364$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $469b705c8fa11364$var$useHydrateFallbackProps();
        return $7fPBF.createElement(HydrateFallback, props);
    };
}
function $469b705c8fa11364$var$useErrorBoundaryProps() {
    return {
        params: $469b705c8fa11364$export$99eaa27ddbbb95ef(),
        loaderData: $469b705c8fa11364$export$1448a5050d252c4d(),
        actionData: $469b705c8fa11364$export$fdc00f3f26066d5e(),
        error: $469b705c8fa11364$export$ed527bf60f6e05f2()
    };
}
function $469b705c8fa11364$export$e5afde5c4b6d747b({ children: children }) {
    const props = $469b705c8fa11364$var$useErrorBoundaryProps();
    return $7fPBF.cloneElement(children, props);
}
function $469b705c8fa11364$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $469b705c8fa11364$var$useErrorBoundaryProps();
        return $7fPBF.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $469b705c8fa11364$var$defaultMethod = "get";
var $469b705c8fa11364$var$defaultEncType = "application/x-www-form-urlencoded";
function $469b705c8fa11364$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $469b705c8fa11364$var$isButtonElement(object) {
    return $469b705c8fa11364$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $469b705c8fa11364$var$isFormElement(object) {
    return $469b705c8fa11364$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $469b705c8fa11364$var$isInputElement(object) {
    return $469b705c8fa11364$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $469b705c8fa11364$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $469b705c8fa11364$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$469b705c8fa11364$var$isModifiedEvent(event);
}
function $469b705c8fa11364$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $469b705c8fa11364$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $469b705c8fa11364$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $469b705c8fa11364$var$_formDataSupportsSubmitter = null;
function $469b705c8fa11364$var$isFormDataSubmitterSupported() {
    if ($469b705c8fa11364$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $469b705c8fa11364$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $469b705c8fa11364$var$_formDataSupportsSubmitter = true;
    }
    return $469b705c8fa11364$var$_formDataSupportsSubmitter;
}
var $469b705c8fa11364$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $469b705c8fa11364$var$getFormEncType(encType) {
    if (encType != null && !$469b705c8fa11364$var$supportedFormEncTypes.has(encType)) {
        $469b705c8fa11364$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$469b705c8fa11364$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $469b705c8fa11364$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($469b705c8fa11364$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $469b705c8fa11364$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $469b705c8fa11364$var$defaultMethod;
        encType = $469b705c8fa11364$var$getFormEncType(target.getAttribute("enctype")) || $469b705c8fa11364$var$defaultEncType;
        formData = new FormData(target);
    } else if ($469b705c8fa11364$var$isButtonElement(target) || $469b705c8fa11364$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $469b705c8fa11364$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $469b705c8fa11364$var$defaultMethod;
        encType = $469b705c8fa11364$var$getFormEncType(target.getAttribute("formenctype")) || $469b705c8fa11364$var$getFormEncType(form.getAttribute("enctype")) || $469b705c8fa11364$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$469b705c8fa11364$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($469b705c8fa11364$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $469b705c8fa11364$var$defaultMethod;
        action = null;
        encType = $469b705c8fa11364$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $469b705c8fa11364$var$HOLE = -1;
var $469b705c8fa11364$var$NAN = -2;
var $469b705c8fa11364$var$NEGATIVE_INFINITY = -3;
var $469b705c8fa11364$var$NEGATIVE_ZERO = -4;
var $469b705c8fa11364$var$NULL = -5;
var $469b705c8fa11364$var$POSITIVE_INFINITY = -6;
var $469b705c8fa11364$var$UNDEFINED = -7;
var $469b705c8fa11364$var$TYPE_BIGINT = "B";
var $469b705c8fa11364$var$TYPE_DATE = "D";
var $469b705c8fa11364$var$TYPE_ERROR = "E";
var $469b705c8fa11364$var$TYPE_MAP = "M";
var $469b705c8fa11364$var$TYPE_NULL_OBJECT = "N";
var $469b705c8fa11364$var$TYPE_PROMISE = "P";
var $469b705c8fa11364$var$TYPE_REGEXP = "R";
var $469b705c8fa11364$var$TYPE_SET = "S";
var $469b705c8fa11364$var$TYPE_SYMBOL = "Y";
var $469b705c8fa11364$var$TYPE_URL = "U";
var $469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $469b705c8fa11364$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $469b705c8fa11364$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $469b705c8fa11364$var$TIME_LIMIT_MS = 1;
var $469b705c8fa11364$var$getNow = ()=>Date.now();
var $469b705c8fa11364$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $469b705c8fa11364$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $469b705c8fa11364$var$UNDEFINED;
    if (input === null) return $469b705c8fa11364$var$NULL;
    if (Number.isNaN(input)) return $469b705c8fa11364$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $469b705c8fa11364$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $469b705c8fa11364$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $469b705c8fa11364$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $469b705c8fa11364$var$stringify.call(this, stack);
    return index;
}
async function $469b705c8fa11364$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $469b705c8fa11364$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $469b705c8fa11364$var$UNDEFINED;
        if (value === null) return $469b705c8fa11364$var$NULL;
        if (Number.isNaN(value)) return $469b705c8fa11364$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $469b705c8fa11364$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $469b705c8fa11364$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $469b705c8fa11364$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $469b705c8fa11364$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $469b705c8fa11364$var$TIME_LIMIT_MS) {
            await $469b705c8fa11364$var$yieldToMain();
            lastYieldTime = $469b705c8fa11364$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$469b705c8fa11364$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$469b705c8fa11364$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$469b705c8fa11364$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $469b705c8fa11364$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$469b705c8fa11364$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$469b705c8fa11364$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$469b705c8fa11364$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$469b705c8fa11364$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$469b705c8fa11364$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$469b705c8fa11364$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$469b705c8fa11364$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$469b705c8fa11364$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$469b705c8fa11364$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$469b705c8fa11364$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($469b705c8fa11364$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $469b705c8fa11364$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $469b705c8fa11364$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $469b705c8fa11364$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $469b705c8fa11364$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $469b705c8fa11364$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $469b705c8fa11364$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $469b705c8fa11364$var$hydrate.call(this, startIndex);
}
function $469b705c8fa11364$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $469b705c8fa11364$var$UNDEFINED:
                set(void 0);
                continue;
            case $469b705c8fa11364$var$NULL:
                set(null);
                continue;
            case $469b705c8fa11364$var$NAN:
                set(NaN);
                continue;
            case $469b705c8fa11364$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $469b705c8fa11364$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $469b705c8fa11364$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $469b705c8fa11364$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $469b705c8fa11364$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $469b705c8fa11364$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $469b705c8fa11364$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $469b705c8fa11364$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $469b705c8fa11364$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $469b705c8fa11364$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $469b705c8fa11364$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $469b705c8fa11364$var$globalObj && $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $469b705c8fa11364$var$globalObj && typeof $469b705c8fa11364$var$globalObj[errorType] === "function" ? new $469b705c8fa11364$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $469b705c8fa11364$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $469b705c8fa11364$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $469b705c8fa11364$var$Deferred2();
    const reader = readable.pipeThrough($469b705c8fa11364$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $469b705c8fa11364$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $469b705c8fa11364$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $469b705c8fa11364$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $469b705c8fa11364$var$unflatten.call(this, line)
    };
}
async function $469b705c8fa11364$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $469b705c8fa11364$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $469b705c8fa11364$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $469b705c8fa11364$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $469b705c8fa11364$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $469b705c8fa11364$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $469b705c8fa11364$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $469b705c8fa11364$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_PROMISE}${deferredId}:[["${$469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $469b705c8fa11364$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_ERROR}${deferredId}:[["${$469b705c8fa11364$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$469b705c8fa11364$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $469b705c8fa11364$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $469b705c8fa11364$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $469b705c8fa11364$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $469b705c8fa11364$export$4cf11838cdc2a8a8(html) {
    return html.replace($469b705c8fa11364$var$ESCAPE_REGEX, (match)=>$469b705c8fa11364$var$ESCAPE_LOOKUP[match]);
}
function $469b705c8fa11364$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $469b705c8fa11364$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $469b705c8fa11364$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $469b705c8fa11364$var$SingleFetchNoResultError = class extends Error {
};
var $469b705c8fa11364$export$ae9272e641ead836 = 202;
var $469b705c8fa11364$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $469b705c8fa11364$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, scriptTag, /* @__PURE__ */ $7fPBF.createElement($7fPBF.Suspense, null, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $469b705c8fa11364$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $469b705c8fa11364$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $469b705c8fa11364$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $469b705c8fa11364$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $469b705c8fa11364$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $469b705c8fa11364$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $469b705c8fa11364$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $469b705c8fa11364$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $469b705c8fa11364$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $469b705c8fa11364$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $469b705c8fa11364$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($469b705c8fa11364$export$3f1eb41d9a6a6a27(result.result) || $469b705c8fa11364$export$972111febbeef05b(result.result) || $469b705c8fa11364$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $469b705c8fa11364$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $469b705c8fa11364$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $469b705c8fa11364$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$469b705c8fa11364$var$createDeferred2());
    let singleFetchDfd = $469b705c8fa11364$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $469b705c8fa11364$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $469b705c8fa11364$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $469b705c8fa11364$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $469b705c8fa11364$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $469b705c8fa11364$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $469b705c8fa11364$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $469b705c8fa11364$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $469b705c8fa11364$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $469b705c8fa11364$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$469b705c8fa11364$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$469b705c8fa11364$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $469b705c8fa11364$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $469b705c8fa11364$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $469b705c8fa11364$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $469b705c8fa11364$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $469b705c8fa11364$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $469b705c8fa11364$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($469b705c8fa11364$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $469b705c8fa11364$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $469b705c8fa11364$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($469b705c8fa11364$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$469b705c8fa11364$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $469b705c8fa11364$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $469b705c8fa11364$export$4023ad4ecd4126a2(body, global) {
    return $469b705c8fa11364$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $469b705c8fa11364$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$469b705c8fa11364$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $469b705c8fa11364$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $469b705c8fa11364$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $469b705c8fa11364$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $469b705c8fa11364$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $469b705c8fa11364$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $469b705c8fa11364$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $469b705c8fa11364$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $469b705c8fa11364$var$getModuleLinkHrefs(matches, manifest);
    return $469b705c8fa11364$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $469b705c8fa11364$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $469b705c8fa11364$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $469b705c8fa11364$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($469b705c8fa11364$var$prefetchStyleLink));
}
async function $469b705c8fa11364$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$469b705c8fa11364$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$469b705c8fa11364$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$469b705c8fa11364$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($469b705c8fa11364$var$prefetchStyleLink));
}
async function $469b705c8fa11364$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $469b705c8fa11364$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $469b705c8fa11364$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $469b705c8fa11364$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $469b705c8fa11364$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $469b705c8fa11364$var$dedupeLinkDescriptors(links.flat(1).filter($469b705c8fa11364$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $469b705c8fa11364$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $469b705c8fa11364$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $469b705c8fa11364$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $469b705c8fa11364$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $469b705c8fa11364$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $469b705c8fa11364$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$469b705c8fa11364$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($469b705c8fa11364$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $469b705c8fa11364$var$_isPreloadSupported;
function $469b705c8fa11364$var$isPreloadSupported() {
    if ($469b705c8fa11364$var$_isPreloadSupported !== void 0) return $469b705c8fa11364$var$_isPreloadSupported;
    let el = document.createElement("link");
    $469b705c8fa11364$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $469b705c8fa11364$var$_isPreloadSupported;
}
function $469b705c8fa11364$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $469b705c8fa11364$var$useFrameworkContext();
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $469b705c8fa11364$export$945fecf35a8ef089 ? /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $469b705c8fa11364$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $469b705c8fa11364$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $469b705c8fa11364$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $469b705c8fa11364$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RemixRootDefaultErrorBoundary, {
            error: $469b705c8fa11364$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $7fPBF.createElement(routeModule.Layout, null, /* @__PURE__ */ $7fPBF.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $469b705c8fa11364$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $469b705c8fa11364$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $469b705c8fa11364$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$469b705c8fa11364$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $469b705c8fa11364$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $469b705c8fa11364$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $469b705c8fa11364$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $469b705c8fa11364$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $469b705c8fa11364$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $469b705c8fa11364$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $469b705c8fa11364$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $469b705c8fa11364$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $469b705c8fa11364$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $469b705c8fa11364$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $469b705c8fa11364$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $469b705c8fa11364$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $469b705c8fa11364$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$469b705c8fa11364$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $469b705c8fa11364$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $469b705c8fa11364$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $469b705c8fa11364$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $469b705c8fa11364$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $469b705c8fa11364$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $469b705c8fa11364$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $469b705c8fa11364$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $469b705c8fa11364$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $469b705c8fa11364$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $469b705c8fa11364$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $469b705c8fa11364$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $469b705c8fa11364$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $469b705c8fa11364$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $469b705c8fa11364$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $469b705c8fa11364$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $469b705c8fa11364$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $469b705c8fa11364$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $469b705c8fa11364$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $469b705c8fa11364$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $469b705c8fa11364$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $469b705c8fa11364$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $469b705c8fa11364$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $469b705c8fa11364$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $469b705c8fa11364$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $469b705c8fa11364$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $469b705c8fa11364$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $469b705c8fa11364$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $469b705c8fa11364$var$nextPaths = /* @__PURE__ */ new Set();
var $469b705c8fa11364$var$discoveredPathsMaxSize = 1e3;
var $469b705c8fa11364$var$discoveredPaths = /* @__PURE__ */ new Set();
var $469b705c8fa11364$export$b5915cf27fa06b9f = 7680;
function $469b705c8fa11364$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $469b705c8fa11364$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $469b705c8fa11364$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $469b705c8fa11364$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($469b705c8fa11364$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $469b705c8fa11364$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $469b705c8fa11364$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $469b705c8fa11364$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $7fPBF.useEffect(()=>{
        if (!$469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$469b705c8fa11364$var$discoveredPaths.has(pathname)) $469b705c8fa11364$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($469b705c8fa11364$var$nextPaths.keys()).filter((path)=>{
                if ($469b705c8fa11364$var$discoveredPaths.has(path)) {
                    $469b705c8fa11364$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $469b705c8fa11364$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $469b705c8fa11364$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $469b705c8fa11364$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $469b705c8fa11364$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $469b705c8fa11364$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $469b705c8fa11364$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($469b705c8fa11364$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $469b705c8fa11364$export$b5915cf27fa06b9f) {
        $469b705c8fa11364$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($469b705c8fa11364$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$469b705c8fa11364$var$addToFifoQueue(p, $469b705c8fa11364$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $469b705c8fa11364$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $469b705c8fa11364$var$addToFifoQueue(path, queue) {
    if (queue.size >= $469b705c8fa11364$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $469b705c8fa11364$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $469b705c8fa11364$var$useDataRouterContext2() {
    let context = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    $469b705c8fa11364$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $469b705c8fa11364$var$useDataRouterStateContext() {
    let context = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    $469b705c8fa11364$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $469b705c8fa11364$export$208d6a3bc3aa62bd = $7fPBF.createContext(void 0);
$469b705c8fa11364$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $469b705c8fa11364$var$useFrameworkContext() {
    let context = $7fPBF.useContext($469b705c8fa11364$export$208d6a3bc3aa62bd);
    $469b705c8fa11364$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $469b705c8fa11364$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $7fPBF.useContext($469b705c8fa11364$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $7fPBF.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $7fPBF.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $7fPBF.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $469b705c8fa11364$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $469b705c8fa11364$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $469b705c8fa11364$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $469b705c8fa11364$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $469b705c8fa11364$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $469b705c8fa11364$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $469b705c8fa11364$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$469b705c8fa11364$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $469b705c8fa11364$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $469b705c8fa11364$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $469b705c8fa11364$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $469b705c8fa11364$var$useDataRouterStateContext();
    let matches = $469b705c8fa11364$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $7fPBF.createElement("style", {
        [$469b705c8fa11364$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $7fPBF.createElement("link", {
        [$469b705c8fa11364$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$469b705c8fa11364$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $469b705c8fa11364$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $469b705c8fa11364$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $469b705c8fa11364$var$useFrameworkContext();
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext2();
    let matches = $7fPBF.useMemo(()=>$469b705c8fa11364$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $469b705c8fa11364$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $7fPBF.useState([]);
    $7fPBF.useEffect(()=>{
        let interrupted = false;
        $469b705c8fa11364$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $469b705c8fa11364$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let { future: future } = $469b705c8fa11364$var$useFrameworkContext();
    let { basename: basename } = $469b705c8fa11364$var$useDataRouterContext2();
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $469b705c8fa11364$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $469b705c8fa11364$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    let { basename: basename } = $469b705c8fa11364$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $469b705c8fa11364$var$useDataRouterStateContext();
    let newMatchesForData = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $7fPBF.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $469b705c8fa11364$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $7fPBF.useMemo(()=>$469b705c8fa11364$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $469b705c8fa11364$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $7fPBF.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $469b705c8fa11364$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $469b705c8fa11364$var$useDataRouterStateContext();
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let _matches = $469b705c8fa11364$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$469b705c8fa11364$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $7fPBF.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $7fPBF.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $7fPBF.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $469b705c8fa11364$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $7fPBF.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $469b705c8fa11364$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $469b705c8fa11364$var$isHydrated = false;
function $469b705c8fa11364$export$3be068dde909e563() {
    $469b705c8fa11364$var$isHydrated = true;
}
function $469b705c8fa11364$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $469b705c8fa11364$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $469b705c8fa11364$var$useDataRouterContext2();
    let { matches: routerMatches } = $469b705c8fa11364$var$useDataRouterStateContext();
    let isRSCRouterContext = $469b705c8fa11364$var$useIsRSCRouterContext();
    let enableFogOfWar = $469b705c8fa11364$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $469b705c8fa11364$var$getActiveMatches(routerMatches, null, isSpaMode);
    $7fPBF.useEffect(()=>{
        $469b705c8fa11364$export$3be068dde909e563();
    }, []);
    let initialScripts = $7fPBF.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $469b705c8fa11364$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($469b705c8fa11364$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $7fPBF.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $469b705c8fa11364$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($469b705c8fa11364$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $469b705c8fa11364$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $469b705c8fa11364$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $7fPBF.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $7fPBF.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $7fPBF.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $469b705c8fa11364$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $469b705c8fa11364$export$32e57f52df4b6e34 = class extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $469b705c8fa11364$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $469b705c8fa11364$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $7fPBF.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($469b705c8fa11364$export$972111febbeef05b(error)) return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $469b705c8fa11364$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $7fPBF.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $7fPBF.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $469b705c8fa11364$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $469b705c8fa11364$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $7fPBF.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $7fPBF.createElement("head", null, /* @__PURE__ */ $7fPBF.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $7fPBF.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $7fPBF.createElement("title", null, title)), /* @__PURE__ */ $7fPBF.createElement("body", null, /* @__PURE__ */ $7fPBF.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$ff0bf87698939488, null) : null)));
}
var $469b705c8fa11364$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($469b705c8fa11364$var$isBrowser2) window.__reactRouterVersion = "7.18.4";
} catch (e) {}
function $469b705c8fa11364$export$1f3f55432a00e06d(routes, opts) {
    return $469b705c8fa11364$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $469b705c8fa11364$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $469b705c8fa11364$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e,
        hydrationRouteProperties: $469b705c8fa11364$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $469b705c8fa11364$export$1ba7ed8a3a7b3765(routes, opts) {
    return $469b705c8fa11364$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $469b705c8fa11364$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $469b705c8fa11364$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e,
        hydrationRouteProperties: $469b705c8fa11364$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $469b705c8fa11364$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $469b705c8fa11364$var$deserializeErrors(state.errors)
    };
    return state;
}
function $469b705c8fa11364$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $469b705c8fa11364$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $469b705c8fa11364$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $469b705c8fa11364$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $469b705c8fa11364$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $469b705c8fa11364$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = $469b705c8fa11364$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $469b705c8fa11364$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let setState = $7fPBF.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $7fPBF.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$469b705c8fa11364$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $469b705c8fa11364$export$a6c7ac8248d6e38a = $7fPBF.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $469b705c8fa11364$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $469b705c8fa11364$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $469b705c8fa11364$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $469b705c8fa11364$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $469b705c8fa11364$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $7fPBF.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $469b705c8fa11364$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, link, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$469b705c8fa11364$export$a6c7ac8248d6e38a.displayName = "Link";
var $469b705c8fa11364$export$b0d92dbee9b5b60d = $7fPBF.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let routerState = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $469b705c8fa11364$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $469b705c8fa11364$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$469b705c8fa11364$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $469b705c8fa11364$export$a7fed597f4b8afd8 = $7fPBF.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $469b705c8fa11364$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let submit = $469b705c8fa11364$export$47c85c6e3a081d3();
    let formAction = $469b705c8fa11364$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $7fPBF.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $7fPBF.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$469b705c8fa11364$export$a7fed597f4b8afd8.displayName = "Form";
function $469b705c8fa11364$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $7fPBF.useContext($469b705c8fa11364$export$208d6a3bc3aa62bd);
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let matches = $469b705c8fa11364$export$2378eb7f5ff86053();
    $469b705c8fa11364$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $7fPBF.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $469b705c8fa11364$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $7fPBF.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$469b705c8fa11364$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $469b705c8fa11364$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $469b705c8fa11364$var$useDataRouterContext3(hookName) {
    let ctx = $7fPBF.useContext($469b705c8fa11364$export$2eeee58951ff3c1c);
    $469b705c8fa11364$export$f5708dca728d7177(ctx, $469b705c8fa11364$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $469b705c8fa11364$var$useDataRouterState2(hookName) {
    let state = $7fPBF.useContext($469b705c8fa11364$export$315e3ffb01f217);
    $469b705c8fa11364$export$f5708dca728d7177(state, $469b705c8fa11364$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $469b705c8fa11364$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $469b705c8fa11364$export$9770f232ac06a008();
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let path = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($469b705c8fa11364$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $469b705c8fa11364$export$fe53371bee54353d(location) === $469b705c8fa11364$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $7fPBF.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $469b705c8fa11364$export$f1a78c17382fe22a(defaultInit) {
    $469b705c8fa11364$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $7fPBF.useRef($469b705c8fa11364$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $469b705c8fa11364$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $469b705c8fa11364$export$9770f232ac06a008();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $469b705c8fa11364$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $469b705c8fa11364$var$fetcherId = 0;
var $469b705c8fa11364$var$getUniqueFetcherId = ()=>`__${String(++$469b705c8fa11364$var$fetcherId)}__`;
function $469b705c8fa11364$export$47c85c6e3a081d3() {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let currentRouteId = $469b705c8fa11364$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $7fPBF.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $469b705c8fa11364$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $469b705c8fa11364$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $469b705c8fa11364$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let routeContext = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    $469b705c8fa11364$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$469b705c8fa11364$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $469b705c8fa11364$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $469b705c8fa11364$export$fe53371bee54353d(path);
}
function $469b705c8fa11364$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $469b705c8fa11364$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $7fPBF.useContext($469b705c8fa11364$export$cb3f1df1bef00a39);
    let route = $7fPBF.useContext($469b705c8fa11364$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $469b705c8fa11364$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $469b705c8fa11364$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $469b705c8fa11364$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $7fPBF.useId();
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $7fPBF.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $7fPBF.useCallback(async (href, opts)=>{
        $469b705c8fa11364$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $469b705c8fa11364$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $7fPBF.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm2 = $7fPBF.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $469b705c8fa11364$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $469b705c8fa11364$export$fa996778a3a31087() {
    let state = $469b705c8fa11364$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $7fPBF.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $469b705c8fa11364$var$savedScrollPositions = {};
function $469b705c8fa11364$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $469b705c8fa11364$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $469b705c8fa11364$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $469b705c8fa11364$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $469b705c8fa11364$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $7fPBF.useContext($469b705c8fa11364$export$3044ab7fdabeaee6);
    let location = $469b705c8fa11364$export$45d76561a5302f2b();
    let matches = $469b705c8fa11364$export$2378eb7f5ff86053();
    let navigation = $469b705c8fa11364$export$d0fd4b7106de2769();
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $469b705c8fa11364$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $469b705c8fa11364$var$getScrollRestorationKey(location, matches, basename, getKey);
            $469b705c8fa11364$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($469b705c8fa11364$var$savedScrollPositions));
        } catch (error) {
            $469b705c8fa11364$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $469b705c8fa11364$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $469b705c8fa11364$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($469b705c8fa11364$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$469b705c8fa11364$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $7fPBF.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $469b705c8fa11364$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $469b705c8fa11364$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $469b705c8fa11364$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $469b705c8fa11364$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $469b705c8fa11364$export$b273b3273281a049(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $469b705c8fa11364$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $7fPBF.useContext($469b705c8fa11364$export$3681f408decb40d1);
    $469b705c8fa11364$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $469b705c8fa11364$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $469b705c8fa11364$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $469b705c8fa11364$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $469b705c8fa11364$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $469b705c8fa11364$export$81336c211d5ff295(path.pathname, nextPath) != null || $469b705c8fa11364$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $469b705c8fa11364$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $469b705c8fa11364$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $469b705c8fa11364$var$getStatelessNavigator();
    return /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $469b705c8fa11364$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $469b705c8fa11364$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $469b705c8fa11364$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $469b705c8fa11364$var$serializeErrors(context.errors)
        };
        let json = $469b705c8fa11364$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $7fPBF.createElement($469b705c8fa11364$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $7fPBF.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $469b705c8fa11364$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($469b705c8fa11364$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $469b705c8fa11364$var$getStatelessNavigator() {
    return {
        createHref: $469b705c8fa11364$var$createHref,
        encodeLocation: $469b705c8fa11364$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $469b705c8fa11364$export$69163f0b72ec60d9(routes, opts) {
    return $469b705c8fa11364$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $469b705c8fa11364$export$9269a41d8c4635e
    });
}
function $469b705c8fa11364$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $469b705c8fa11364$export$87cb1a9238dc3fba(routes, $469b705c8fa11364$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $469b705c8fa11364$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $469b705c8fa11364$var$createHref,
        encodeLocation: $469b705c8fa11364$var$encodeLocation,
        getFetcher () {
            return $469b705c8fa11364$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $469b705c8fa11364$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $469b705c8fa11364$var$createHref(to) {
    return typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
}
function $469b705c8fa11364$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $469b705c8fa11364$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $469b705c8fa11364$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("P0x5y", function(module, exports) {
$parcel$export(module.exports, "AioIconButton", function () { return (parcelRequire("5m3yv")).AioIconButton; });
$parcel$export(module.exports, "AioReplacementDisplay", function () { return (parcelRequire("i7ZQC")).AioReplacementDisplay; });
$parcel$export(module.exports, "isAioExternalReplacements", function () { return (parcelRequire("cXvVz")).isAioExternalReplacements; });
$parcel$export(module.exports, "isAioExternalSingle", function () { return (parcelRequire("cXvVz")).isAioExternalSingle; });
$parcel$export(module.exports, "newExternalReplacements", function () { return (parcelRequire("gqdtF")).newExternalReplacements; });
$parcel$export(module.exports, "updateExternal", function () { return (parcelRequire("jBp7n")).updateExternal; });
$parcel$export(module.exports, "AnalysisMethodControl", function () { return (parcelRequire("7uNID")).AnalysisMethodControl; });
$parcel$export(module.exports, "AnalysisSetControl", function () { return (parcelRequire("9ijW6")).AnalysisSetControl; });
$parcel$export(module.exports, "ARS", function () { return (parcelRequire("1cA0K")); });
$parcel$export(module.exports, "ArsBlock", function () { return (parcelRequire("iGqDA")).ArsBlock; });
$parcel$export(module.exports, "ArsContextProvider", function () { return (parcelRequire("fZCs4")).ArsContextProvider; });
$parcel$export(module.exports, "ArsListing", function () { return (parcelRequire("lremW")).ArsListing; });
$parcel$export(module.exports, "ArsTable", function () { return (parcelRequire("3Q1wz")).ArsTable; });
$parcel$export(module.exports, "cloneArsObject", function () { return (parcelRequire("kDIpz")).cloneArsObject; });
$parcel$export(module.exports, "createNewAnalysisMethod", function () { return (parcelRequire("3CgTd")).createNewAnalysisMethod; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return (parcelRequire("3CgTd")).createNewAnalysisSet; });
$parcel$export(module.exports, "createNewDataSubset", function () { return (parcelRequire("3CgTd")).createNewDataSubset; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return (parcelRequire("3CgTd")).createNewGroupingFactor; });
$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return (parcelRequire("cIJV5")).CURRENT_HIERARCHY_ID; });
$parcel$export(module.exports, "DataSubsetControl", function () { return (parcelRequire("b1QeS")).DataSubsetControl; });
$parcel$export(module.exports, "GroupingFactorControl", function () { return (parcelRequire("bRDEW")).GroupingFactorControl; });
$parcel$export(module.exports, "hasArsObjectWithName", function () { return (parcelRequire("kDIpz")).hasArsObjectWithName; });
$parcel$export(module.exports, "isAnalysisMethod", function () { return (parcelRequire("ek4hO")).isAnalysisMethod; });
$parcel$export(module.exports, "isArsListingBody", function () { return (parcelRequire("awEAB")).isArsListingBody; });
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("GtyWr")).isArsTableBody; });
$parcel$export(module.exports, "isDataSubset", function () { return (parcelRequire("74VXB")).isDataSubset; });
$parcel$export(module.exports, "isObjectRecord", function () { return (parcelRequire("8CFpa")).isObjectRecord; });
$parcel$export(module.exports, "isSubClauseWithReference", function () { return (parcelRequire("5KlUB")).isSubClauseWithReference; });
$parcel$export(module.exports, "MultipleDatasetCheck", function () { return (parcelRequire("ihppY")).MultipleDatasetCheck; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return (parcelRequire("cIJV5")).PATCH_ARS_STATE; });
$parcel$export(module.exports, "ReferencedEntityControl", function () { return (parcelRequire("kupca")).ReferencedEntityControl; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return (parcelRequire("cIJV5")).SET_SIDEBAR_ANALYSIS_METHOD_ID; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return (parcelRequire("cIJV5")).SET_VARIABLES_IN_USE; });
$parcel$export(module.exports, "totalSidebarItem", function () { return (parcelRequire("40D4s")).totalSidebarItem; });
$parcel$export(module.exports, "useArsContext", function () { return (parcelRequire("fZCs4")).useArsContext; });
$parcel$export(module.exports, "AibLineType", function () { return (parcelRequire("79DyI")).AibLineType; });
$parcel$export(module.exports, "AsupInternalBlock", function () { return (parcelRequire("hG9sA")).AsupInternalBlock; });
$parcel$export(module.exports, "AddLinkButton", function () { return (parcelRequire("ktLOc")).AddLinkButton; });
$parcel$export(module.exports, "AsyncButton", function () { return (parcelRequire("8HzIe")).AsyncButton; });
$parcel$export(module.exports, "Control210", function () { return (parcelRequire("9Er6k")).Control210; });
$parcel$export(module.exports, "Control211", function () { return (parcelRequire("isQD0")).Control211; });
$parcel$export(module.exports, "Control213", function () { return (parcelRequire("egunj")).Control213; });
$parcel$export(module.exports, "ControlBase", function () { return (parcelRequire("fQHYQ")).ControlBase; });
$parcel$export(module.exports, "ControlDate", function () { return (parcelRequire("fHRX3")).ControlDate; });
$parcel$export(module.exports, "ControlNavList", function () { return (parcelRequire("ceSEx")).ControlNavList; });
$parcel$export(module.exports, "ControlsGroup", function () { return (parcelRequire("dImYe")).ControlsGroup; });
$parcel$export(module.exports, "ControlTags", function () { return (parcelRequire("creWj")).ControlTags; });
$parcel$export(module.exports, "ControlTypeAhead", function () { return (parcelRequire("k6Ixm")).ControlTypeAhead; });
$parcel$export(module.exports, "InTextLink", function () { return (parcelRequire("eYprk")).InTextLink; });
$parcel$export(module.exports, "SortableListHolder", function () { return (parcelRequire("7Tnbh")).SortableListHolder; });
$parcel$export(module.exports, "BeFigure", function () { return (parcelRequire("ladZM")).BeFigure; });
$parcel$export(module.exports, "isFigureSettingsDto", function () { return (parcelRequire("aSzWy")).isFigureSettingsDto; });
$parcel$export(module.exports, "preProcessFigureInput", function () { return (parcelRequire("Hzrzh")).preProcessFigureInput; });
$parcel$export(module.exports, "AitTablePosition", function () { return (parcelRequire("feHBz")).AitTablePosition; });
$parcel$export(module.exports, "AsupInternalTable", function () { return (parcelRequire("c3Q0Y")).AsupInternalTable; });
$parcel$export(module.exports, "isAitRowGroupData", function () { return (parcelRequire("04Jlz")).isAitRowGroupData; });
$parcel$export(module.exports, "isGridItemTrafficLight", function () { return (parcelRequire("2xRzL")).isGridItemTrafficLight; });
$parcel$export(module.exports, "newCell", function () { return (parcelRequire("iIj1X")).newCell; });
$parcel$export(module.exports, "newHeaderCell", function () { return (parcelRequire("iIj1X")).newHeaderCell; });
$parcel$export(module.exports, "newHeaderRow", function () { return (parcelRequire("3LImB")).newHeaderRow; });
$parcel$export(module.exports, "newRow", function () { return (parcelRequire("3LImB")).newRow; });
$parcel$export(module.exports, "newRowGroup", function () { return (parcelRequire("5mofv")).newRowGroup; });
$parcel$export(module.exports, "isMosaicTrafficLightsValue", function () { return (parcelRequire("l3p07")).isMosaicTrafficLightsValue; });
$parcel$export(module.exports, "isMosaicTrafficLightSwitch", function () { return (parcelRequire("a6nWU")).isMosaicTrafficLightSwitch; });
$parcel$export(module.exports, "MosaicTrafficLightClass", function () { return (parcelRequire("8vQMY")).MosaicTrafficLightClass; });
$parcel$export(module.exports, "MosaicTrafficLightColors", function () { return (parcelRequire("8vQMY")).MosaicTrafficLightColors; });
$parcel$export(module.exports, "checkName", function () { return (parcelRequire("kct4w")).checkName; });
$parcel$export(module.exports, "classMerge", function () { return (parcelRequire("cqVqv")).classMerge; });
$parcel$export(module.exports, "convertDateToLocaleString", function () { return (parcelRequire("lUIe4")).convertDateToLocaleString; });
$parcel$export(module.exports, "convertLocaleDateToUTCString", function () { return (parcelRequire("lUIe4")).convertLocaleDateToUTCString; });
$parcel$export(module.exports, "datasetToAnnotatedVariables", function () { return (parcelRequire("8u0AX")).datasetToAnnotatedVariables; });
$parcel$export(module.exports, "getFromDataPath", function () { return (parcelRequire("eAPMz")).getFromDataPath; });
$parcel$export(module.exports, "loadWrapper", function () { return (parcelRequire("30Ra3")).loadWrapper; });
$parcel$export(module.exports, "PauseCover", function () { return (parcelRequire("9eqKP")).PauseCover; });
$parcel$export(module.exports, "stringDateCheck", function () { return (parcelRequire("c72HK")).stringDateCheck; });
$parcel$export(module.exports, "TLF_VIEW_MODES", function () { return (parcelRequire("gMkmM")).TLF_VIEW_MODES; });
$parcel$export(module.exports, "valueFix", function () { return (parcelRequire("hQ7Qt")).valueFix; });
parcelRequire("152v7");
parcelRequire("jgbJm");
parcelRequire("ic4Os");
parcelRequire("gYROb");
parcelRequire("jP1kl");
parcelRequire("6rtuc");
parcelRequire("aNOKz");
parcelRequire("hU1Hd");
parcelRequire("2nuru");

});
parcelRegister("152v7", function(module, exports) {
$parcel$export(module.exports, "AioIconButton", function () { return (parcelRequire("5m3yv")).AioIconButton; });
$parcel$export(module.exports, "AioReplacementDisplay", function () { return (parcelRequire("i7ZQC")).AioReplacementDisplay; });
$parcel$export(module.exports, "isAioExternalReplacements", function () { return (parcelRequire("cXvVz")).isAioExternalReplacements; });
$parcel$export(module.exports, "isAioExternalSingle", function () { return (parcelRequire("cXvVz")).isAioExternalSingle; });
$parcel$export(module.exports, "isAioReplacement", function () { return (parcelRequire("cXvVz")).isAioReplacement; });
$parcel$export(module.exports, "newExternalReplacements", function () { return (parcelRequire("gqdtF")).newExternalReplacements; });
$parcel$export(module.exports, "updateExternal", function () { return (parcelRequire("jBp7n")).updateExternal; });
parcelRequire("jWyw9");
parcelRequire("cniV6");
parcelRequire("fq9h5");
parcelRequire("5m3yv");
parcelRequire("l72nQ");
parcelRequire("4gy1I");
parcelRequire("i7ZQC");
parcelRequire("3gAtF");
parcelRequire("dJxI5");
parcelRequire("hbWqi");
parcelRequire("Dy1AI");
parcelRequire("dGStb");
parcelRequire("cXvVz");
parcelRequire("gqdtF");
parcelRequire("82xZo");
parcelRequire("haC0j");
parcelRequire("jBp7n");
parcelRequire("9YWkm");

});
parcelRegister("jWyw9", function(module, exports) {

$parcel$export(module.exports, "AioBoolean", function () { return $6e006f9783652608$export$178e417a4db5ac38; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $l72nQ = parcelRequire("l72nQ");
const $6e006f9783652608$export$178e417a4db5ac38 = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $l72nQ.AioLabel), {
                id: `${props.id}-label`,
                label: props.label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInputHolder,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                    id: props.id,
                    "aria-labelledby": `${props.id}-label`,
                    checked: props.value,
                    disabled: !(typeof props.setValue === "function") || props.disabled,
                    onChange: (e)=>props.setValue(e.currentTarget.checked),
                    type: "checkbox"
                })
            })
        ]
    });
};
$6e006f9783652608$export$178e417a4db5ac38.displayName = "AioBoolean";

});
parcelRegister("gOa7m", function(module, exports) {

$parcel$export(module.exports, "absoluteLeft0", function () { return $c3c92a06f5e48398$export$4f17df0ebee58067; }, function (v) { return $c3c92a06f5e48398$export$4f17df0ebee58067 = v; });
$parcel$export(module.exports, "absoluteTopRight", function () { return $c3c92a06f5e48398$export$736d3278694cc0fd; }, function (v) { return $c3c92a06f5e48398$export$736d3278694cc0fd = v; });
$parcel$export(module.exports, "aibBlock", function () { return $c3c92a06f5e48398$export$7f77d671e2687ea; }, function (v) { return $c3c92a06f5e48398$export$7f77d671e2687ea = v; });
$parcel$export(module.exports, "aibLine", function () { return $c3c92a06f5e48398$export$89918ebbc3c127c7; }, function (v) { return $c3c92a06f5e48398$export$89918ebbc3c127c7 = v; });
$parcel$export(module.exports, "aibLineButtons", function () { return $c3c92a06f5e48398$export$66df7e9d68209f2d; }, function (v) { return $c3c92a06f5e48398$export$66df7e9d68209f2d = v; });
$parcel$export(module.exports, "aibLineItem", function () { return $c3c92a06f5e48398$export$ac63149497c27d24; }, function (v) { return $c3c92a06f5e48398$export$ac63149497c27d24 = v; });
$parcel$export(module.exports, "aibLineItemHolder", function () { return $c3c92a06f5e48398$export$ae3f66ca17a91b3; }, function (v) { return $c3c92a06f5e48398$export$ae3f66ca17a91b3 = v; });
$parcel$export(module.exports, "aibReadOnly", function () { return $c3c92a06f5e48398$export$a91deb551c57e7a5; }, function (v) { return $c3c92a06f5e48398$export$a91deb551c57e7a5 = v; });
$parcel$export(module.exports, "aieOuter", function () { return $c3c92a06f5e48398$export$e84853277b98a973; }, function (v) { return $c3c92a06f5e48398$export$e84853277b98a973 = v; });
$parcel$export(module.exports, "aioBodyRow", function () { return $c3c92a06f5e48398$export$f4f787701cf85254; }, function (v) { return $c3c92a06f5e48398$export$f4f787701cf85254 = v; });
$parcel$export(module.exports, "aioButtonHolder", function () { return $c3c92a06f5e48398$export$131bac28331688a9; }, function (v) { return $c3c92a06f5e48398$export$131bac28331688a9 = v; });
$parcel$export(module.exports, "aioCommentHolder", function () { return $c3c92a06f5e48398$export$29397c928c4a5781; }, function (v) { return $c3c92a06f5e48398$export$29397c928c4a5781 = v; });
$parcel$export(module.exports, "aioDropItem", function () { return $c3c92a06f5e48398$export$3f13e480f6c5271a; }, function (v) { return $c3c92a06f5e48398$export$3f13e480f6c5271a = v; });
$parcel$export(module.exports, "aioDropItemsHolder", function () { return $c3c92a06f5e48398$export$992e111a1534dd31; }, function (v) { return $c3c92a06f5e48398$export$992e111a1534dd31 = v; });
$parcel$export(module.exports, "aioDropItemsInnerHolder", function () { return $c3c92a06f5e48398$export$53de806239109854; }, function (v) { return $c3c92a06f5e48398$export$53de806239109854 = v; });
$parcel$export(module.exports, "aioInput", function () { return $c3c92a06f5e48398$export$94a472f130bf47c; }, function (v) { return $c3c92a06f5e48398$export$94a472f130bf47c = v; });
$parcel$export(module.exports, "aioInputHolder", function () { return $c3c92a06f5e48398$export$7fe9b8b6deeca5a5; }, function (v) { return $c3c92a06f5e48398$export$7fe9b8b6deeca5a5 = v; });
$parcel$export(module.exports, "aioLabel", function () { return $c3c92a06f5e48398$export$8bf3840a8957b76; }, function (v) { return $c3c92a06f5e48398$export$8bf3840a8957b76 = v; });
$parcel$export(module.exports, "aioRoValue", function () { return $c3c92a06f5e48398$export$aab6956240d8473; }, function (v) { return $c3c92a06f5e48398$export$aab6956240d8473 = v; });
$parcel$export(module.exports, "aioRow", function () { return $c3c92a06f5e48398$export$143e3912c99e9ff8; }, function (v) { return $c3c92a06f5e48398$export$143e3912c99e9ff8 = v; });
$parcel$export(module.exports, "aioSelect", function () { return $c3c92a06f5e48398$export$67ec89fec3652885; }, function (v) { return $c3c92a06f5e48398$export$67ec89fec3652885 = v; });
$parcel$export(module.exports, "aioTip", function () { return $c3c92a06f5e48398$export$4d4d141944f68e7b; }, function (v) { return $c3c92a06f5e48398$export$4d4d141944f68e7b = v; });
$parcel$export(module.exports, "aioTipBottom", function () { return $c3c92a06f5e48398$export$39303ae8a955ff80; }, function (v) { return $c3c92a06f5e48398$export$39303ae8a955ff80 = v; });
$parcel$export(module.exports, "aioTipBottom2", function () { return $c3c92a06f5e48398$export$2c2ee864cc2b56ef; }, function (v) { return $c3c92a06f5e48398$export$2c2ee864cc2b56ef = v; });
$parcel$export(module.exports, "aioTipLeft", function () { return $c3c92a06f5e48398$export$4c5ef43f16eec51e; }, function (v) { return $c3c92a06f5e48398$export$4c5ef43f16eec51e = v; });
$parcel$export(module.exports, "aioTipLeft2", function () { return $c3c92a06f5e48398$export$8b1c716ddb7d836f; }, function (v) { return $c3c92a06f5e48398$export$8b1c716ddb7d836f = v; });
$parcel$export(module.exports, "aioTipLhs", function () { return $c3c92a06f5e48398$export$2159c038930d1595; }, function (v) { return $c3c92a06f5e48398$export$2159c038930d1595 = v; });
$parcel$export(module.exports, "aioTipRhs", function () { return $c3c92a06f5e48398$export$c03d9c90aff15581; }, function (v) { return $c3c92a06f5e48398$export$c03d9c90aff15581 = v; });
$parcel$export(module.exports, "aioTipRight", function () { return $c3c92a06f5e48398$export$2407bd150fcd71d8; }, function (v) { return $c3c92a06f5e48398$export$2407bd150fcd71d8 = v; });
$parcel$export(module.exports, "aioTipRight2", function () { return $c3c92a06f5e48398$export$2be84b11fc1cc84a; }, function (v) { return $c3c92a06f5e48398$export$2be84b11fc1cc84a = v; });
$parcel$export(module.exports, "aioTipTop", function () { return $c3c92a06f5e48398$export$9588e6031755613e; }, function (v) { return $c3c92a06f5e48398$export$9588e6031755613e = v; });
$parcel$export(module.exports, "aioTipTop2", function () { return $c3c92a06f5e48398$export$1a7319974a0b196d; }, function (v) { return $c3c92a06f5e48398$export$1a7319974a0b196d = v; });
$parcel$export(module.exports, "aioTiptext", function () { return $c3c92a06f5e48398$export$a5ba150a6cd3665d; }, function (v) { return $c3c92a06f5e48398$export$a5ba150a6cd3665d = v; });
$parcel$export(module.exports, "aioTiptext2", function () { return $c3c92a06f5e48398$export$70b5f208320769cb; }, function (v) { return $c3c92a06f5e48398$export$70b5f208320769cb = v; });
$parcel$export(module.exports, "aioTiptextBottomarrow", function () { return $c3c92a06f5e48398$export$a9167f570deabdf3; }, function (v) { return $c3c92a06f5e48398$export$a9167f570deabdf3 = v; });
$parcel$export(module.exports, "aioTiptextLeftarrow", function () { return $c3c92a06f5e48398$export$e4e1a0786f152291; }, function (v) { return $c3c92a06f5e48398$export$e4e1a0786f152291 = v; });
$parcel$export(module.exports, "aioTiptextRightarrow", function () { return $c3c92a06f5e48398$export$e5f4a6b7e232f3b2; }, function (v) { return $c3c92a06f5e48398$export$e5f4a6b7e232f3b2 = v; });
$parcel$export(module.exports, "aioTiptextToparrow", function () { return $c3c92a06f5e48398$export$c39c6162216fb32d; }, function (v) { return $c3c92a06f5e48398$export$c39c6162216fb32d = v; });
$parcel$export(module.exports, "aioUpdateButton", function () { return $c3c92a06f5e48398$export$497deef337205b54; }, function (v) { return $c3c92a06f5e48398$export$497deef337205b54 = v; });
$parcel$export(module.exports, "aioValue", function () { return $c3c92a06f5e48398$export$954d66e350b33664; }, function (v) { return $c3c92a06f5e48398$export$954d66e350b33664 = v; });
$parcel$export(module.exports, "aiordMain", function () { return $c3c92a06f5e48398$export$ac8617dc00b55765; }, function (v) { return $c3c92a06f5e48398$export$ac8617dc00b55765 = v; });
$parcel$export(module.exports, "aiordvMain", function () { return $c3c92a06f5e48398$export$42ad9a1f9232e67d; }, function (v) { return $c3c92a06f5e48398$export$42ad9a1f9232e67d = v; });
$parcel$export(module.exports, "aiox", function () { return $c3c92a06f5e48398$export$91ab19af263ed1e5; }, function (v) { return $c3c92a06f5e48398$export$91ab19af263ed1e5 = v; });
$parcel$export(module.exports, "aioxAddDown", function () { return $c3c92a06f5e48398$export$5af554cb0e1c69ad; }, function (v) { return $c3c92a06f5e48398$export$5af554cb0e1c69ad = v; });
$parcel$export(module.exports, "aioxButton", function () { return $c3c92a06f5e48398$export$8a7c2065a6431a02; }, function (v) { return $c3c92a06f5e48398$export$8a7c2065a6431a02 = v; });
$parcel$export(module.exports, "aioxButtonCell", function () { return $c3c92a06f5e48398$export$a77474c7ffd9b171; }, function (v) { return $c3c92a06f5e48398$export$a77474c7ffd9b171 = v; });
$parcel$export(module.exports, "aioxButtonHolder", function () { return $c3c92a06f5e48398$export$10d4ca81a4f67998; }, function (v) { return $c3c92a06f5e48398$export$10d4ca81a4f67998 = v; });
$parcel$export(module.exports, "aioxButtonRowGroup", function () { return $c3c92a06f5e48398$export$61a59f7a4de889f3; }, function (v) { return $c3c92a06f5e48398$export$61a59f7a4de889f3 = v; });
$parcel$export(module.exports, "aioxButtonRowOptions", function () { return $c3c92a06f5e48398$export$42e3bbcebe288980; }, function (v) { return $c3c92a06f5e48398$export$42e3bbcebe288980 = v; });
$parcel$export(module.exports, "aioxButtonSettings", function () { return $c3c92a06f5e48398$export$eb941bdcd92a43d1; }, function (v) { return $c3c92a06f5e48398$export$eb941bdcd92a43d1 = v; });
$parcel$export(module.exports, "aioxCircle", function () { return $c3c92a06f5e48398$export$6b79775752681cf8; }, function (v) { return $c3c92a06f5e48398$export$6b79775752681cf8 = v; });
$parcel$export(module.exports, "aioxCircleRed", function () { return $c3c92a06f5e48398$export$88c6530c3b4d23cf; }, function (v) { return $c3c92a06f5e48398$export$88c6530c3b4d23cf = v; });
$parcel$export(module.exports, "aioxDown", function () { return $c3c92a06f5e48398$export$bfec69f8cbe4c4d6; }, function (v) { return $c3c92a06f5e48398$export$bfec69f8cbe4c4d6 = v; });
$parcel$export(module.exports, "aioxExplode", function () { return $c3c92a06f5e48398$export$68ea70fb62bde31c; }, function (v) { return $c3c92a06f5e48398$export$68ea70fb62bde31c = v; });
$parcel$export(module.exports, "aioxGrip", function () { return $c3c92a06f5e48398$export$1e9a6bab843d251a; }, function (v) { return $c3c92a06f5e48398$export$1e9a6bab843d251a = v; });
$parcel$export(module.exports, "aioxImplode", function () { return $c3c92a06f5e48398$export$f9fc73d7b6311543; }, function (v) { return $c3c92a06f5e48398$export$f9fc73d7b6311543 = v; });
$parcel$export(module.exports, "aioxLabel", function () { return $c3c92a06f5e48398$export$8b1dbac6337160ce; }, function (v) { return $c3c92a06f5e48398$export$8b1dbac6337160ce = v; });
$parcel$export(module.exports, "aioxList", function () { return $c3c92a06f5e48398$export$570ca4ca47e6110e; }, function (v) { return $c3c92a06f5e48398$export$570ca4ca47e6110e = v; });
$parcel$export(module.exports, "aioxMinus", function () { return $c3c92a06f5e48398$export$638d7b7a98bf4800; }, function (v) { return $c3c92a06f5e48398$export$638d7b7a98bf4800 = v; });
$parcel$export(module.exports, "aioxOpenClose", function () { return $c3c92a06f5e48398$export$daf8802eb43d7f66; }, function (v) { return $c3c92a06f5e48398$export$daf8802eb43d7f66 = v; });
$parcel$export(module.exports, "aioxPlus", function () { return $c3c92a06f5e48398$export$37edeaef6dea6; }, function (v) { return $c3c92a06f5e48398$export$37edeaef6dea6 = v; });
$parcel$export(module.exports, "aioxRemoveUp", function () { return $c3c92a06f5e48398$export$7e4603536a9f1f5a; }, function (v) { return $c3c92a06f5e48398$export$7e4603536a9f1f5a = v; });
$parcel$export(module.exports, "aioxTable", function () { return $c3c92a06f5e48398$export$949a8d6e33131d43; }, function (v) { return $c3c92a06f5e48398$export$949a8d6e33131d43 = v; });
$parcel$export(module.exports, "aioxUp", function () { return $c3c92a06f5e48398$export$c676ef791a38437e; }, function (v) { return $c3c92a06f5e48398$export$c676ef791a38437e = v; });
$parcel$export(module.exports, "aitAieHolder", function () { return $c3c92a06f5e48398$export$1d47042371b84542; }, function (v) { return $c3c92a06f5e48398$export$1d47042371b84542 = v; });
$parcel$export(module.exports, "aitAieHolderButton", function () { return $c3c92a06f5e48398$export$b92d6afdcd523774; }, function (v) { return $c3c92a06f5e48398$export$b92d6afdcd523774 = v; });
$parcel$export(module.exports, "aitBodyCell", function () { return $c3c92a06f5e48398$export$342f2ecab8e21136; }, function (v) { return $c3c92a06f5e48398$export$342f2ecab8e21136 = v; });
$parcel$export(module.exports, "aitBorderCell", function () { return $c3c92a06f5e48398$export$e2040b8db4e5c9f6; }, function (v) { return $c3c92a06f5e48398$export$e2040b8db4e5c9f6 = v; });
$parcel$export(module.exports, "aitCell", function () { return $c3c92a06f5e48398$export$3b9f395efd9e3155; }, function (v) { return $c3c92a06f5e48398$export$3b9f395efd9e3155 = v; });
$parcel$export(module.exports, "aitColumnButtons", function () { return $c3c92a06f5e48398$export$54ec96a9c09dc200; }, function (v) { return $c3c92a06f5e48398$export$54ec96a9c09dc200 = v; });
$parcel$export(module.exports, "aitHeaderCell", function () { return $c3c92a06f5e48398$export$57b3b332a0c04132; }, function (v) { return $c3c92a06f5e48398$export$57b3b332a0c04132 = v; });
$parcel$export(module.exports, "aitHolder", function () { return $c3c92a06f5e48398$export$f8b7bb939646bdba; }, function (v) { return $c3c92a06f5e48398$export$f8b7bb939646bdba = v; });
$parcel$export(module.exports, "aitOptionsButton", function () { return $c3c92a06f5e48398$export$27cb2bbe58ae21a; }, function (v) { return $c3c92a06f5e48398$export$27cb2bbe58ae21a = v; });
$parcel$export(module.exports, "aitReadonlyCell", function () { return $c3c92a06f5e48398$export$1f43ce3225eaafa6; }, function (v) { return $c3c92a06f5e48398$export$1f43ce3225eaafa6 = v; });
$parcel$export(module.exports, "aitRowButtons", function () { return $c3c92a06f5e48398$export$bdce32b86360bdde; }, function (v) { return $c3c92a06f5e48398$export$bdce32b86360bdde = v; });
$parcel$export(module.exports, "aitRowGroupButtons", function () { return $c3c92a06f5e48398$export$e2f53b1e18778678; }, function (v) { return $c3c92a06f5e48398$export$e2f53b1e18778678 = v; });
$parcel$export(module.exports, "aitRowHeaderCell", function () { return $c3c92a06f5e48398$export$6a9d38fd999674d0; }, function (v) { return $c3c92a06f5e48398$export$6a9d38fd999674d0 = v; });
$parcel$export(module.exports, "aitSpaceCell", function () { return $c3c92a06f5e48398$export$81cc2b81fa8469a5; }, function (v) { return $c3c92a06f5e48398$export$81cc2b81fa8469a5 = v; });
$parcel$export(module.exports, "aitTable", function () { return $c3c92a06f5e48398$export$d5b17522385c7e4e; }, function (v) { return $c3c92a06f5e48398$export$d5b17522385c7e4e = v; });
$parcel$export(module.exports, "aitTableOptions", function () { return $c3c92a06f5e48398$export$893505c455e9813b; }, function (v) { return $c3c92a06f5e48398$export$893505c455e9813b = v; });
$parcel$export(module.exports, "aiwBody", function () { return $c3c92a06f5e48398$export$866ea484f3a6b390; }, function (v) { return $c3c92a06f5e48398$export$866ea484f3a6b390 = v; });
$parcel$export(module.exports, "aiwBodyRow", function () { return $c3c92a06f5e48398$export$bfa9e64f43371c4b; }, function (v) { return $c3c92a06f5e48398$export$bfa9e64f43371c4b = v; });
$parcel$export(module.exports, "aiwHolder", function () { return $c3c92a06f5e48398$export$b7a8a3aa000ba043; }, function (v) { return $c3c92a06f5e48398$export$b7a8a3aa000ba043 = v; });
$parcel$export(module.exports, "borderBlackSolid", function () { return $c3c92a06f5e48398$export$6df1d6c7dea98904; }, function (v) { return $c3c92a06f5e48398$export$6df1d6c7dea98904 = v; });
$parcel$export(module.exports, "borderBottomBurlyWood", function () { return $c3c92a06f5e48398$export$b7cbe781f039733b; }, function (v) { return $c3c92a06f5e48398$export$b7cbe781f039733b = v; });
$parcel$export(module.exports, "borderBurlyWoodDotted", function () { return $c3c92a06f5e48398$export$f136e0ad00f5f517; }, function (v) { return $c3c92a06f5e48398$export$f136e0ad00f5f517 = v; });
$parcel$export(module.exports, "borderLeftBurlyWood", function () { return $c3c92a06f5e48398$export$c8594d35c2fcdbd; }, function (v) { return $c3c92a06f5e48398$export$c8594d35c2fcdbd = v; });
$parcel$export(module.exports, "borderNone", function () { return $c3c92a06f5e48398$export$695e5a0c7f545a4e; }, function (v) { return $c3c92a06f5e48398$export$695e5a0c7f545a4e = v; });
$parcel$export(module.exports, "borderRadiusBottomRight", function () { return $c3c92a06f5e48398$export$1987e8fd2120747d; }, function (v) { return $c3c92a06f5e48398$export$1987e8fd2120747d = v; });
$parcel$export(module.exports, "borderRadiusTopLeft", function () { return $c3c92a06f5e48398$export$d4a57905f285d6a0; }, function (v) { return $c3c92a06f5e48398$export$d4a57905f285d6a0 = v; });
$parcel$export(module.exports, "borderRadiusTopRight", function () { return $c3c92a06f5e48398$export$1cf3dcb00b707e64; }, function (v) { return $c3c92a06f5e48398$export$1cf3dcb00b707e64 = v; });
$parcel$export(module.exports, "borderTopBottomBurlyWood", function () { return $c3c92a06f5e48398$export$b72258acdf45e466; }, function (v) { return $c3c92a06f5e48398$export$b72258acdf45e466 = v; });
$parcel$export(module.exports, "borderTopBurlyWood", function () { return $c3c92a06f5e48398$export$3069856c381821fd; }, function (v) { return $c3c92a06f5e48398$export$3069856c381821fd = v; });
$parcel$export(module.exports, "calcSize", function () { return $c3c92a06f5e48398$export$ffb38d77b69e936e; }, function (v) { return $c3c92a06f5e48398$export$ffb38d77b69e936e = v; });
$parcel$export(module.exports, "closed", function () { return $c3c92a06f5e48398$export$15ff61f90f7efc74; }, function (v) { return $c3c92a06f5e48398$export$15ff61f90f7efc74 = v; });
$parcel$export(module.exports, "colorRed", function () { return $c3c92a06f5e48398$export$821c049260f9784c; }, function (v) { return $c3c92a06f5e48398$export$821c049260f9784c = v; });
$parcel$export(module.exports, "editorInput", function () { return $c3c92a06f5e48398$export$92e7d85052fbf2bf; }, function (v) { return $c3c92a06f5e48398$export$92e7d85052fbf2bf = v; });
$parcel$export(module.exports, "flexCenter", function () { return $c3c92a06f5e48398$export$6f9e4349aad79600; }, function (v) { return $c3c92a06f5e48398$export$6f9e4349aad79600 = v; });
$parcel$export(module.exports, "flexColumn", function () { return $c3c92a06f5e48398$export$ba9a56610c2a1379; }, function (v) { return $c3c92a06f5e48398$export$ba9a56610c2a1379 = v; });
$parcel$export(module.exports, "flexColumnGap2", function () { return $c3c92a06f5e48398$export$e7f624d71a302dc4; }, function (v) { return $c3c92a06f5e48398$export$e7f624d71a302dc4 = v; });
$parcel$export(module.exports, "flexGrow1", function () { return $c3c92a06f5e48398$export$edd148d0ba8d7e28; }, function (v) { return $c3c92a06f5e48398$export$edd148d0ba8d7e28 = v; });
$parcel$export(module.exports, "flexRow", function () { return $c3c92a06f5e48398$export$3b0508b4994f1c2d; }, function (v) { return $c3c92a06f5e48398$export$3b0508b4994f1c2d = v; });
$parcel$export(module.exports, "flexRowCenter", function () { return $c3c92a06f5e48398$export$e775859361eabb6a; }, function (v) { return $c3c92a06f5e48398$export$e775859361eabb6a = v; });
$parcel$export(module.exports, "flexRowEnd", function () { return $c3c92a06f5e48398$export$9446d87636e6bee2; }, function (v) { return $c3c92a06f5e48398$export$9446d87636e6bee2 = v; });
$parcel$export(module.exports, "flexRowStart", function () { return $c3c92a06f5e48398$export$132b47f05e1a488d; }, function (v) { return $c3c92a06f5e48398$export$132b47f05e1a488d = v; });
$parcel$export(module.exports, "fontItalic", function () { return $c3c92a06f5e48398$export$20cdc57ab9d905f9; }, function (v) { return $c3c92a06f5e48398$export$20cdc57ab9d905f9 = v; });
$parcel$export(module.exports, "fullSize", function () { return $c3c92a06f5e48398$export$431f51906092b59f; }, function (v) { return $c3c92a06f5e48398$export$431f51906092b59f = v; });
$parcel$export(module.exports, "hidden", function () { return $c3c92a06f5e48398$export$73920f18ca706874; }, function (v) { return $c3c92a06f5e48398$export$73920f18ca706874 = v; });
$parcel$export(module.exports, "margin2", function () { return $c3c92a06f5e48398$export$5dbac88aa7d65388; }, function (v) { return $c3c92a06f5e48398$export$5dbac88aa7d65388 = v; });
$parcel$export(module.exports, "margin6", function () { return $c3c92a06f5e48398$export$196a89292c4f85f5; }, function (v) { return $c3c92a06f5e48398$export$196a89292c4f85f5 = v; });
$parcel$export(module.exports, "marginBottom2", function () { return $c3c92a06f5e48398$export$f10ee6d57d6fb05e; }, function (v) { return $c3c92a06f5e48398$export$f10ee6d57d6fb05e = v; });
$parcel$export(module.exports, "marginLeft25", function () { return $c3c92a06f5e48398$export$9ec761144c658cdb; }, function (v) { return $c3c92a06f5e48398$export$9ec761144c658cdb = v; });
$parcel$export(module.exports, "marginRight025", function () { return $c3c92a06f5e48398$export$8d6076201b3f1dd5; }, function (v) { return $c3c92a06f5e48398$export$8d6076201b3f1dd5 = v; });
$parcel$export(module.exports, "marginTop2", function () { return $c3c92a06f5e48398$export$8aebfe367061b934; }, function (v) { return $c3c92a06f5e48398$export$8aebfe367061b934 = v; });
$parcel$export(module.exports, "marginTopBottom6", function () { return $c3c92a06f5e48398$export$1e900c5a84bf0f8b; }, function (v) { return $c3c92a06f5e48398$export$1e900c5a84bf0f8b = v; });
$parcel$export(module.exports, "maxHeight75vh", function () { return $c3c92a06f5e48398$export$9971c0517e8beb25; }, function (v) { return $c3c92a06f5e48398$export$9971c0517e8beb25 = v; });
$parcel$export(module.exports, "one", function () { return $c3c92a06f5e48398$export$80bf7733f1207381; }, function (v) { return $c3c92a06f5e48398$export$80bf7733f1207381 = v; });
$parcel$export(module.exports, "open", function () { return $c3c92a06f5e48398$export$3ce6949f20cea765; }, function (v) { return $c3c92a06f5e48398$export$3ce6949f20cea765 = v; });
$parcel$export(module.exports, "overflowVisible", function () { return $c3c92a06f5e48398$export$484949d7e9999497; }, function (v) { return $c3c92a06f5e48398$export$484949d7e9999497 = v; });
$parcel$export(module.exports, "padding2", function () { return $c3c92a06f5e48398$export$3b51273408708f4a; }, function (v) { return $c3c92a06f5e48398$export$3b51273408708f4a = v; });
$parcel$export(module.exports, "positionAbsolute", function () { return $c3c92a06f5e48398$export$f8d144aafbd3a470; }, function (v) { return $c3c92a06f5e48398$export$f8d144aafbd3a470 = v; });
$parcel$export(module.exports, "positionRelative", function () { return $c3c92a06f5e48398$export$fc51f1cf90283cd4; }, function (v) { return $c3c92a06f5e48398$export$fc51f1cf90283cd4 = v; });
$parcel$export(module.exports, "replacementButtonArea", function () { return $c3c92a06f5e48398$export$a29862c53985aa32; }, function (v) { return $c3c92a06f5e48398$export$a29862c53985aa32 = v; });
$parcel$export(module.exports, "replacementContainer", function () { return $c3c92a06f5e48398$export$de098d98afae6c81; }, function (v) { return $c3c92a06f5e48398$export$de098d98afae6c81 = v; });
$parcel$export(module.exports, "replacementRow", function () { return $c3c92a06f5e48398$export$280ab2fe54c0c581; }, function (v) { return $c3c92a06f5e48398$export$280ab2fe54c0c581 = v; });
$parcel$export(module.exports, "replacementRowIndented", function () { return $c3c92a06f5e48398$export$296b2fde5c74285a; }, function (v) { return $c3c92a06f5e48398$export$296b2fde5c74285a = v; });
$parcel$export(module.exports, "showBorders", function () { return $c3c92a06f5e48398$export$5226b987273bdf30; }, function (v) { return $c3c92a06f5e48398$export$5226b987273bdf30 = v; });
$parcel$export(module.exports, "three", function () { return $c3c92a06f5e48398$export$c93cff18cf760708; }, function (v) { return $c3c92a06f5e48398$export$c93cff18cf760708 = v; });
$parcel$export(module.exports, "two", function () { return $c3c92a06f5e48398$export$7dfe6c2e21a8ba69; }, function (v) { return $c3c92a06f5e48398$export$7dfe6c2e21a8ba69 = v; });
$parcel$export(module.exports, "width170", function () { return $c3c92a06f5e48398$export$957f4aac05bf3d72; }, function (v) { return $c3c92a06f5e48398$export$957f4aac05bf3d72 = v; });
$parcel$export(module.exports, "width5", function () { return $c3c92a06f5e48398$export$5a30a35b9f478dc6; }, function (v) { return $c3c92a06f5e48398$export$5a30a35b9f478dc6 = v; });
var $c3c92a06f5e48398$export$4f17df0ebee58067;
var $c3c92a06f5e48398$export$736d3278694cc0fd;
var $c3c92a06f5e48398$export$7f77d671e2687ea;
var $c3c92a06f5e48398$export$89918ebbc3c127c7;
var $c3c92a06f5e48398$export$66df7e9d68209f2d;
var $c3c92a06f5e48398$export$ac63149497c27d24;
var $c3c92a06f5e48398$export$ae3f66ca17a91b3;
var $c3c92a06f5e48398$export$a91deb551c57e7a5;
var $c3c92a06f5e48398$export$e84853277b98a973;
var $c3c92a06f5e48398$export$f4f787701cf85254;
var $c3c92a06f5e48398$export$131bac28331688a9;
var $c3c92a06f5e48398$export$29397c928c4a5781;
var $c3c92a06f5e48398$export$3f13e480f6c5271a;
var $c3c92a06f5e48398$export$992e111a1534dd31;
var $c3c92a06f5e48398$export$53de806239109854;
var $c3c92a06f5e48398$export$94a472f130bf47c;
var $c3c92a06f5e48398$export$7fe9b8b6deeca5a5;
var $c3c92a06f5e48398$export$8bf3840a8957b76;
var $c3c92a06f5e48398$export$aab6956240d8473;
var $c3c92a06f5e48398$export$143e3912c99e9ff8;
var $c3c92a06f5e48398$export$67ec89fec3652885;
var $c3c92a06f5e48398$export$4d4d141944f68e7b;
var $c3c92a06f5e48398$export$39303ae8a955ff80;
var $c3c92a06f5e48398$export$2c2ee864cc2b56ef;
var $c3c92a06f5e48398$export$4c5ef43f16eec51e;
var $c3c92a06f5e48398$export$8b1c716ddb7d836f;
var $c3c92a06f5e48398$export$2159c038930d1595;
var $c3c92a06f5e48398$export$c03d9c90aff15581;
var $c3c92a06f5e48398$export$2407bd150fcd71d8;
var $c3c92a06f5e48398$export$2be84b11fc1cc84a;
var $c3c92a06f5e48398$export$9588e6031755613e;
var $c3c92a06f5e48398$export$1a7319974a0b196d;
var $c3c92a06f5e48398$export$a5ba150a6cd3665d;
var $c3c92a06f5e48398$export$70b5f208320769cb;
var $c3c92a06f5e48398$export$a9167f570deabdf3;
var $c3c92a06f5e48398$export$e4e1a0786f152291;
var $c3c92a06f5e48398$export$e5f4a6b7e232f3b2;
var $c3c92a06f5e48398$export$c39c6162216fb32d;
var $c3c92a06f5e48398$export$497deef337205b54;
var $c3c92a06f5e48398$export$954d66e350b33664;
var $c3c92a06f5e48398$export$ac8617dc00b55765;
var $c3c92a06f5e48398$export$42ad9a1f9232e67d;
var $c3c92a06f5e48398$export$91ab19af263ed1e5;
var $c3c92a06f5e48398$export$5af554cb0e1c69ad;
var $c3c92a06f5e48398$export$8a7c2065a6431a02;
var $c3c92a06f5e48398$export$a77474c7ffd9b171;
var $c3c92a06f5e48398$export$10d4ca81a4f67998;
var $c3c92a06f5e48398$export$61a59f7a4de889f3;
var $c3c92a06f5e48398$export$42e3bbcebe288980;
var $c3c92a06f5e48398$export$eb941bdcd92a43d1;
var $c3c92a06f5e48398$export$6b79775752681cf8;
var $c3c92a06f5e48398$export$88c6530c3b4d23cf;
var $c3c92a06f5e48398$export$bfec69f8cbe4c4d6;
var $c3c92a06f5e48398$export$68ea70fb62bde31c;
var $c3c92a06f5e48398$export$1e9a6bab843d251a;
var $c3c92a06f5e48398$export$f9fc73d7b6311543;
var $c3c92a06f5e48398$export$8b1dbac6337160ce;
var $c3c92a06f5e48398$export$570ca4ca47e6110e;
var $c3c92a06f5e48398$export$638d7b7a98bf4800;
var $c3c92a06f5e48398$export$daf8802eb43d7f66;
var $c3c92a06f5e48398$export$37edeaef6dea6;
var $c3c92a06f5e48398$export$7e4603536a9f1f5a;
var $c3c92a06f5e48398$export$949a8d6e33131d43;
var $c3c92a06f5e48398$export$c676ef791a38437e;
var $c3c92a06f5e48398$export$1d47042371b84542;
var $c3c92a06f5e48398$export$b92d6afdcd523774;
var $c3c92a06f5e48398$export$342f2ecab8e21136;
var $c3c92a06f5e48398$export$e2040b8db4e5c9f6;
var $c3c92a06f5e48398$export$3b9f395efd9e3155;
var $c3c92a06f5e48398$export$54ec96a9c09dc200;
var $c3c92a06f5e48398$export$57b3b332a0c04132;
var $c3c92a06f5e48398$export$f8b7bb939646bdba;
var $c3c92a06f5e48398$export$27cb2bbe58ae21a;
var $c3c92a06f5e48398$export$1f43ce3225eaafa6;
var $c3c92a06f5e48398$export$bdce32b86360bdde;
var $c3c92a06f5e48398$export$e2f53b1e18778678;
var $c3c92a06f5e48398$export$6a9d38fd999674d0;
var $c3c92a06f5e48398$export$81cc2b81fa8469a5;
var $c3c92a06f5e48398$export$d5b17522385c7e4e;
var $c3c92a06f5e48398$export$893505c455e9813b;
var $c3c92a06f5e48398$export$866ea484f3a6b390;
var $c3c92a06f5e48398$export$bfa9e64f43371c4b;
var $c3c92a06f5e48398$export$b7a8a3aa000ba043;
var $c3c92a06f5e48398$export$6df1d6c7dea98904;
var $c3c92a06f5e48398$export$b7cbe781f039733b;
var $c3c92a06f5e48398$export$f136e0ad00f5f517;
var $c3c92a06f5e48398$export$c8594d35c2fcdbd;
var $c3c92a06f5e48398$export$695e5a0c7f545a4e;
var $c3c92a06f5e48398$export$1987e8fd2120747d;
var $c3c92a06f5e48398$export$d4a57905f285d6a0;
var $c3c92a06f5e48398$export$1cf3dcb00b707e64;
var $c3c92a06f5e48398$export$b72258acdf45e466;
var $c3c92a06f5e48398$export$3069856c381821fd;
var $c3c92a06f5e48398$export$ffb38d77b69e936e;
var $c3c92a06f5e48398$export$15ff61f90f7efc74;
var $c3c92a06f5e48398$export$821c049260f9784c;
var $c3c92a06f5e48398$export$92e7d85052fbf2bf;
var $c3c92a06f5e48398$export$6f9e4349aad79600;
var $c3c92a06f5e48398$export$ba9a56610c2a1379;
var $c3c92a06f5e48398$export$e7f624d71a302dc4;
var $c3c92a06f5e48398$export$edd148d0ba8d7e28;
var $c3c92a06f5e48398$export$3b0508b4994f1c2d;
var $c3c92a06f5e48398$export$e775859361eabb6a;
var $c3c92a06f5e48398$export$9446d87636e6bee2;
var $c3c92a06f5e48398$export$132b47f05e1a488d;
var $c3c92a06f5e48398$export$20cdc57ab9d905f9;
var $c3c92a06f5e48398$export$431f51906092b59f;
var $c3c92a06f5e48398$export$73920f18ca706874;
var $c3c92a06f5e48398$export$5dbac88aa7d65388;
var $c3c92a06f5e48398$export$196a89292c4f85f5;
var $c3c92a06f5e48398$export$f10ee6d57d6fb05e;
var $c3c92a06f5e48398$export$9ec761144c658cdb;
var $c3c92a06f5e48398$export$8d6076201b3f1dd5;
var $c3c92a06f5e48398$export$8aebfe367061b934;
var $c3c92a06f5e48398$export$1e900c5a84bf0f8b;
var $c3c92a06f5e48398$export$9971c0517e8beb25;
var $c3c92a06f5e48398$export$80bf7733f1207381;
var $c3c92a06f5e48398$export$3ce6949f20cea765;
var $c3c92a06f5e48398$export$484949d7e9999497;
var $c3c92a06f5e48398$export$3b51273408708f4a;
var $c3c92a06f5e48398$export$f8d144aafbd3a470;
var $c3c92a06f5e48398$export$fc51f1cf90283cd4;
var $c3c92a06f5e48398$export$a29862c53985aa32;
var $c3c92a06f5e48398$export$de098d98afae6c81;
var $c3c92a06f5e48398$export$280ab2fe54c0c581;
var $c3c92a06f5e48398$export$296b2fde5c74285a;
var $c3c92a06f5e48398$export$5226b987273bdf30;
var $c3c92a06f5e48398$export$c93cff18cf760708;
var $c3c92a06f5e48398$export$7dfe6c2e21a8ba69;
var $c3c92a06f5e48398$export$957f4aac05bf3d72;
var $c3c92a06f5e48398$export$5a30a35b9f478dc6;
$c3c92a06f5e48398$export$4f17df0ebee58067 = `mos-aic-module-9x6Wxa-absoluteLeft0`;
$c3c92a06f5e48398$export$736d3278694cc0fd = `mos-aic-module-9x6Wxa-absoluteTopRight`;
$c3c92a06f5e48398$export$7f77d671e2687ea = `mos-aic-module-9x6Wxa-aibBlock`;
$c3c92a06f5e48398$export$89918ebbc3c127c7 = `mos-aic-module-9x6Wxa-aibLine`;
$c3c92a06f5e48398$export$66df7e9d68209f2d = `mos-aic-module-9x6Wxa-aibLineButtons`;
$c3c92a06f5e48398$export$ac63149497c27d24 = `mos-aic-module-9x6Wxa-aibLineItem`;
$c3c92a06f5e48398$export$ae3f66ca17a91b3 = `mos-aic-module-9x6Wxa-aibLineItemHolder`;
$c3c92a06f5e48398$export$a91deb551c57e7a5 = `mos-aic-module-9x6Wxa-aibReadOnly`;
$c3c92a06f5e48398$export$e84853277b98a973 = `mos-aic-module-9x6Wxa-aieOuter`;
$c3c92a06f5e48398$export$f4f787701cf85254 = `mos-aic-module-9x6Wxa-aioBodyRow`;
$c3c92a06f5e48398$export$131bac28331688a9 = `mos-aic-module-9x6Wxa-aioButtonHolder`;
$c3c92a06f5e48398$export$29397c928c4a5781 = `mos-aic-module-9x6Wxa-aioCommentHolder`;
$c3c92a06f5e48398$export$3f13e480f6c5271a = `mos-aic-module-9x6Wxa-aioDropItem`;
$c3c92a06f5e48398$export$992e111a1534dd31 = `mos-aic-module-9x6Wxa-aioDropItemsHolder`;
$c3c92a06f5e48398$export$53de806239109854 = `mos-aic-module-9x6Wxa-aioDropItemsInnerHolder`;
$c3c92a06f5e48398$export$94a472f130bf47c = `mos-aic-module-9x6Wxa-aioInput`;
$c3c92a06f5e48398$export$7fe9b8b6deeca5a5 = `mos-aic-module-9x6Wxa-aioInputHolder`;
$c3c92a06f5e48398$export$8bf3840a8957b76 = `mos-aic-module-9x6Wxa-aioLabel`;
$c3c92a06f5e48398$export$aab6956240d8473 = `mos-aic-module-9x6Wxa-aioRoValue`;
$c3c92a06f5e48398$export$143e3912c99e9ff8 = `mos-aic-module-9x6Wxa-aioRow`;
$c3c92a06f5e48398$export$67ec89fec3652885 = `mos-aic-module-9x6Wxa-aioSelect`;
$c3c92a06f5e48398$export$4d4d141944f68e7b = `mos-aic-module-9x6Wxa-aioTip`;
$c3c92a06f5e48398$export$39303ae8a955ff80 = `mos-aic-module-9x6Wxa-aioTipBottom`;
$c3c92a06f5e48398$export$2c2ee864cc2b56ef = `mos-aic-module-9x6Wxa-aioTipBottom2`;
$c3c92a06f5e48398$export$4c5ef43f16eec51e = `mos-aic-module-9x6Wxa-aioTipLeft`;
$c3c92a06f5e48398$export$8b1c716ddb7d836f = `mos-aic-module-9x6Wxa-aioTipLeft2`;
$c3c92a06f5e48398$export$2159c038930d1595 = `mos-aic-module-9x6Wxa-aioTipLhs`;
$c3c92a06f5e48398$export$c03d9c90aff15581 = `mos-aic-module-9x6Wxa-aioTipRhs`;
$c3c92a06f5e48398$export$2407bd150fcd71d8 = `mos-aic-module-9x6Wxa-aioTipRight`;
$c3c92a06f5e48398$export$2be84b11fc1cc84a = `mos-aic-module-9x6Wxa-aioTipRight2`;
$c3c92a06f5e48398$export$9588e6031755613e = `mos-aic-module-9x6Wxa-aioTipTop`;
$c3c92a06f5e48398$export$1a7319974a0b196d = `mos-aic-module-9x6Wxa-aioTipTop2`;
$c3c92a06f5e48398$export$a5ba150a6cd3665d = `mos-aic-module-9x6Wxa-aioTiptext`;
$c3c92a06f5e48398$export$70b5f208320769cb = `mos-aic-module-9x6Wxa-aioTiptext2`;
$c3c92a06f5e48398$export$a9167f570deabdf3 = `mos-aic-module-9x6Wxa-aioTiptextBottomarrow`;
$c3c92a06f5e48398$export$e4e1a0786f152291 = `mos-aic-module-9x6Wxa-aioTiptextLeftarrow`;
$c3c92a06f5e48398$export$e5f4a6b7e232f3b2 = `mos-aic-module-9x6Wxa-aioTiptextRightarrow`;
$c3c92a06f5e48398$export$c39c6162216fb32d = `mos-aic-module-9x6Wxa-aioTiptextToparrow`;
$c3c92a06f5e48398$export$497deef337205b54 = `mos-aic-module-9x6Wxa-aioUpdateButton`;
$c3c92a06f5e48398$export$954d66e350b33664 = `mos-aic-module-9x6Wxa-aioValue`;
$c3c92a06f5e48398$export$ac8617dc00b55765 = `mos-aic-module-9x6Wxa-aiordMain`;
$c3c92a06f5e48398$export$42ad9a1f9232e67d = `mos-aic-module-9x6Wxa-aiordvMain`;
$c3c92a06f5e48398$export$91ab19af263ed1e5 = `mos-aic-module-9x6Wxa-aiox`;
$c3c92a06f5e48398$export$5af554cb0e1c69ad = `mos-aic-module-9x6Wxa-aioxAddDown`;
$c3c92a06f5e48398$export$8a7c2065a6431a02 = `mos-aic-module-9x6Wxa-aioxButton`;
$c3c92a06f5e48398$export$a77474c7ffd9b171 = `mos-aic-module-9x6Wxa-aioxButtonCell`;
$c3c92a06f5e48398$export$10d4ca81a4f67998 = `mos-aic-module-9x6Wxa-aioxButtonHolder`;
$c3c92a06f5e48398$export$61a59f7a4de889f3 = `mos-aic-module-9x6Wxa-aioxButtonRowGroup`;
$c3c92a06f5e48398$export$42e3bbcebe288980 = `mos-aic-module-9x6Wxa-aioxButtonRowOptions`;
$c3c92a06f5e48398$export$eb941bdcd92a43d1 = `mos-aic-module-9x6Wxa-aioxButtonSettings`;
$c3c92a06f5e48398$export$6b79775752681cf8 = `mos-aic-module-9x6Wxa-aioxCircle`;
$c3c92a06f5e48398$export$88c6530c3b4d23cf = `mos-aic-module-9x6Wxa-aioxCircleRed`;
$c3c92a06f5e48398$export$bfec69f8cbe4c4d6 = `mos-aic-module-9x6Wxa-aioxDown`;
$c3c92a06f5e48398$export$68ea70fb62bde31c = `mos-aic-module-9x6Wxa-aioxExplode`;
$c3c92a06f5e48398$export$1e9a6bab843d251a = `mos-aic-module-9x6Wxa-aioxGrip`;
$c3c92a06f5e48398$export$f9fc73d7b6311543 = `mos-aic-module-9x6Wxa-aioxImplode`;
$c3c92a06f5e48398$export$8b1dbac6337160ce = `mos-aic-module-9x6Wxa-aioxLabel`;
$c3c92a06f5e48398$export$570ca4ca47e6110e = `mos-aic-module-9x6Wxa-aioxList`;
$c3c92a06f5e48398$export$638d7b7a98bf4800 = `mos-aic-module-9x6Wxa-aioxMinus`;
$c3c92a06f5e48398$export$daf8802eb43d7f66 = `mos-aic-module-9x6Wxa-aioxOpenClose`;
$c3c92a06f5e48398$export$37edeaef6dea6 = `mos-aic-module-9x6Wxa-aioxPlus`;
$c3c92a06f5e48398$export$7e4603536a9f1f5a = `mos-aic-module-9x6Wxa-aioxRemoveUp`;
$c3c92a06f5e48398$export$949a8d6e33131d43 = `mos-aic-module-9x6Wxa-aioxTable`;
$c3c92a06f5e48398$export$c676ef791a38437e = `mos-aic-module-9x6Wxa-aioxUp`;
$c3c92a06f5e48398$export$1d47042371b84542 = `mos-aic-module-9x6Wxa-aitAieHolder`;
$c3c92a06f5e48398$export$b92d6afdcd523774 = `mos-aic-module-9x6Wxa-aitAieHolderButton`;
$c3c92a06f5e48398$export$342f2ecab8e21136 = `mos-aic-module-9x6Wxa-aitBodyCell`;
$c3c92a06f5e48398$export$e2040b8db4e5c9f6 = `mos-aic-module-9x6Wxa-aitBorderCell`;
$c3c92a06f5e48398$export$3b9f395efd9e3155 = `mos-aic-module-9x6Wxa-aitCell`;
$c3c92a06f5e48398$export$54ec96a9c09dc200 = `mos-aic-module-9x6Wxa-aitColumnButtons`;
$c3c92a06f5e48398$export$57b3b332a0c04132 = `mos-aic-module-9x6Wxa-aitHeaderCell`;
$c3c92a06f5e48398$export$f8b7bb939646bdba = `mos-aic-module-9x6Wxa-aitHolder`;
$c3c92a06f5e48398$export$27cb2bbe58ae21a = `mos-aic-module-9x6Wxa-aitOptionsButton`;
$c3c92a06f5e48398$export$1f43ce3225eaafa6 = `mos-aic-module-9x6Wxa-aitReadonlyCell`;
$c3c92a06f5e48398$export$bdce32b86360bdde = `mos-aic-module-9x6Wxa-aitRowButtons`;
$c3c92a06f5e48398$export$e2f53b1e18778678 = `mos-aic-module-9x6Wxa-aitRowGroupButtons`;
$c3c92a06f5e48398$export$6a9d38fd999674d0 = `mos-aic-module-9x6Wxa-aitRowHeaderCell`;
$c3c92a06f5e48398$export$81cc2b81fa8469a5 = `mos-aic-module-9x6Wxa-aitSpaceCell`;
$c3c92a06f5e48398$export$d5b17522385c7e4e = `mos-aic-module-9x6Wxa-aitTable`;
$c3c92a06f5e48398$export$893505c455e9813b = `mos-aic-module-9x6Wxa-aitTableOptions`;
$c3c92a06f5e48398$export$866ea484f3a6b390 = `mos-aic-module-9x6Wxa-aiwBody`;
$c3c92a06f5e48398$export$bfa9e64f43371c4b = `mos-aic-module-9x6Wxa-aiwBodyRow`;
$c3c92a06f5e48398$export$b7a8a3aa000ba043 = `mos-aic-module-9x6Wxa-aiwHolder`;
$c3c92a06f5e48398$export$6df1d6c7dea98904 = `mos-aic-module-9x6Wxa-borderBlackSolid`;
$c3c92a06f5e48398$export$b7cbe781f039733b = `mos-aic-module-9x6Wxa-borderBottomBurlyWood`;
$c3c92a06f5e48398$export$f136e0ad00f5f517 = `mos-aic-module-9x6Wxa-borderBurlyWoodDotted`;
$c3c92a06f5e48398$export$c8594d35c2fcdbd = `mos-aic-module-9x6Wxa-borderLeftBurlyWood`;
$c3c92a06f5e48398$export$695e5a0c7f545a4e = `mos-aic-module-9x6Wxa-borderNone`;
$c3c92a06f5e48398$export$1987e8fd2120747d = `mos-aic-module-9x6Wxa-borderRadiusBottomRight`;
$c3c92a06f5e48398$export$d4a57905f285d6a0 = `mos-aic-module-9x6Wxa-borderRadiusTopLeft`;
$c3c92a06f5e48398$export$1cf3dcb00b707e64 = `mos-aic-module-9x6Wxa-borderRadiusTopRight`;
$c3c92a06f5e48398$export$b72258acdf45e466 = `mos-aic-module-9x6Wxa-borderTopBottomBurlyWood`;
$c3c92a06f5e48398$export$3069856c381821fd = `mos-aic-module-9x6Wxa-borderTopBurlyWood`;
$c3c92a06f5e48398$export$ffb38d77b69e936e = `mos-aic-module-9x6Wxa-calcSize`;
$c3c92a06f5e48398$export$15ff61f90f7efc74 = `mos-aic-module-9x6Wxa-closed`;
$c3c92a06f5e48398$export$821c049260f9784c = `mos-aic-module-9x6Wxa-colorRed`;
$c3c92a06f5e48398$export$92e7d85052fbf2bf = `mos-aic-module-9x6Wxa-editorInput`;
$c3c92a06f5e48398$export$6f9e4349aad79600 = `mos-aic-module-9x6Wxa-flexCenter`;
$c3c92a06f5e48398$export$ba9a56610c2a1379 = `mos-aic-module-9x6Wxa-flexColumn`;
$c3c92a06f5e48398$export$e7f624d71a302dc4 = `mos-aic-module-9x6Wxa-flexColumnGap2`;
$c3c92a06f5e48398$export$edd148d0ba8d7e28 = `mos-aic-module-9x6Wxa-flexGrow1`;
$c3c92a06f5e48398$export$3b0508b4994f1c2d = `mos-aic-module-9x6Wxa-flexRow`;
$c3c92a06f5e48398$export$e775859361eabb6a = `mos-aic-module-9x6Wxa-flexRowCenter`;
$c3c92a06f5e48398$export$9446d87636e6bee2 = `mos-aic-module-9x6Wxa-flexRowEnd`;
$c3c92a06f5e48398$export$132b47f05e1a488d = `mos-aic-module-9x6Wxa-flexRowStart`;
$c3c92a06f5e48398$export$20cdc57ab9d905f9 = `mos-aic-module-9x6Wxa-fontItalic`;
$c3c92a06f5e48398$export$431f51906092b59f = `mos-aic-module-9x6Wxa-fullSize`;
$c3c92a06f5e48398$export$73920f18ca706874 = `mos-aic-module-9x6Wxa-hidden`;
$c3c92a06f5e48398$export$5dbac88aa7d65388 = `mos-aic-module-9x6Wxa-margin2`;
$c3c92a06f5e48398$export$196a89292c4f85f5 = `mos-aic-module-9x6Wxa-margin6`;
$c3c92a06f5e48398$export$f10ee6d57d6fb05e = `mos-aic-module-9x6Wxa-marginBottom2`;
$c3c92a06f5e48398$export$9ec761144c658cdb = `mos-aic-module-9x6Wxa-marginLeft25`;
$c3c92a06f5e48398$export$8d6076201b3f1dd5 = `mos-aic-module-9x6Wxa-marginRight025`;
$c3c92a06f5e48398$export$8aebfe367061b934 = `mos-aic-module-9x6Wxa-marginTop2`;
$c3c92a06f5e48398$export$1e900c5a84bf0f8b = `mos-aic-module-9x6Wxa-marginTopBottom6`;
$c3c92a06f5e48398$export$9971c0517e8beb25 = `mos-aic-module-9x6Wxa-maxHeight75vh`;
$c3c92a06f5e48398$export$80bf7733f1207381 = `mos-aic-module-9x6Wxa-one`;
$c3c92a06f5e48398$export$3ce6949f20cea765 = `mos-aic-module-9x6Wxa-open`;
$c3c92a06f5e48398$export$484949d7e9999497 = `mos-aic-module-9x6Wxa-overflowVisible`;
$c3c92a06f5e48398$export$3b51273408708f4a = `mos-aic-module-9x6Wxa-padding2`;
$c3c92a06f5e48398$export$f8d144aafbd3a470 = `mos-aic-module-9x6Wxa-positionAbsolute`;
$c3c92a06f5e48398$export$fc51f1cf90283cd4 = `mos-aic-module-9x6Wxa-positionRelative`;
$c3c92a06f5e48398$export$a29862c53985aa32 = `mos-aic-module-9x6Wxa-replacementButtonArea`;
$c3c92a06f5e48398$export$de098d98afae6c81 = `mos-aic-module-9x6Wxa-replacementContainer`;
$c3c92a06f5e48398$export$280ab2fe54c0c581 = `mos-aic-module-9x6Wxa-replacementRow`;
$c3c92a06f5e48398$export$296b2fde5c74285a = `mos-aic-module-9x6Wxa-replacementRowIndented`;
$c3c92a06f5e48398$export$5226b987273bdf30 = `mos-aic-module-9x6Wxa-showBorders`;
$c3c92a06f5e48398$export$c93cff18cf760708 = `mos-aic-module-9x6Wxa-three`;
$c3c92a06f5e48398$export$7dfe6c2e21a8ba69 = `mos-aic-module-9x6Wxa-two`;
$c3c92a06f5e48398$export$957f4aac05bf3d72 = `mos-aic-module-9x6Wxa-width170`;
$c3c92a06f5e48398$export$5a30a35b9f478dc6 = `mos-aic-module-9x6Wxa-width5`;

});

parcelRegister("l72nQ", function(module, exports) {

$parcel$export(module.exports, "AioLabel", function () { return $3b0d89dc47fbf6bb$export$46150af52b680b36; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");
const $3b0d89dc47fbf6bb$export$46150af52b680b36 = (props)=>{
    if (props.label === undefined) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    return /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
        id: props.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioLabel,
        htmlFor: props.htmlFor,
        children: `${props.label}${!props.noColon && props.label ? ":" : ""}`
    });
};
$3b0d89dc47fbf6bb$export$46150af52b680b36.displayName = "AioLabel";

});


parcelRegister("cniV6", function(module, exports) {

$parcel$export(module.exports, "AioComment", function () { return $294376d0937314af$export$f855cb22882ac682; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $88YCB = parcelRequire("88YCB");

var $l72nQ = parcelRequire("l72nQ");
const $294376d0937314af$export$f855cb22882ac682 = ({ id: id, editable: editable, label: label, setValue: setValue, value: value })=>{
    // Context
    const { state: state } = (0, $88YCB.useTableContext)();
    const Editor = state?.editorProps.Editor;
    return !state || !Editor ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $l72nQ.AioLabel), {
                id: `${id}-label`,
                label: label,
                htmlFor: `${id}-editor`
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioCommentHolder,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                    id: `${id}-editor`,
                    "aria-labelledby": `${id}-label`,
                    editable: state?.editable && editable !== false,
                    setValue: (ret)=>setValue(ret),
                    value: value
                })
            })
        ]
    });
};
$294376d0937314af$export$f855cb22882ac682.displayName = "AioComment";

});
parcelRegister("88YCB", function(module, exports) {

$parcel$export(module.exports, "TableContextProvider", function () { return $1704667ebbdfb8b3$export$2304abde66e33a52; });
$parcel$export(module.exports, "useTableContext", function () { return $1704667ebbdfb8b3$export$3cb274deb6c2d854; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $feHBz = parcelRequire("feHBz");

var $3IXBZ = parcelRequire("3IXBZ");

var $bnhRS = parcelRequire("bnhRS");
const $1704667ebbdfb8b3$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
/**
 * Provider that supplies table state and dispatch to child components.
 *
 * @template T - Table payload type
 * @param props - Component props
 * @param props.initialState - Initial state used to seed the table reducer
 * @param props.children - Child nodes wrapped by the provider
 * @param props.onChange - Callback invoked when table data is pushed
 */ const $1704667ebbdfb8b3$var$TableContextProviderInner = ({ initialState: initialState, children: children, onChange: onChange })=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $3IXBZ.tableReducer), {
        ...initialState,
        changed: false,
        showOptionsWindow: [],
        processedTableData: (0, $bnhRS.trProcessTable)(initialState)
    });
    // Update state from top down
    (0, $7fPBF.useEffect)(()=>{
        // Compare properties that are passed down
        const initialStateForComparison = {
            ...(0, $gSkQi.omit)(initialState, [
                "changed",
                "showOptionsWindow",
                "processedTableData"
            ])
        };
        const currentStateForComparison = {
            ...(0, $gSkQi.omit)(state, [
                "changed",
                "showOptionsWindow",
                "processedTableData"
            ])
        };
        const hasChanges = !(0, $gSkQi.isEqual)(initialStateForComparison, currentStateForComparison);
        if (hasChanges) {
            if (state.changed) {
                onChange(state.originalTableData);
                dispatch({
                    operation: (0, $feHBz.TABLE_CHANGE_PUSHED)
                });
            } else dispatch({
                operation: (0, $feHBz.LOAD_STATE),
                newState: initialState
            });
        }
    }, [
        initialState,
        onChange,
        state
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($1704667ebbdfb8b3$export$93e4b0b2cc49b648.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
const $1704667ebbdfb8b3$export$2304abde66e33a52 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($1704667ebbdfb8b3$var$TableContextProviderInner);
function $1704667ebbdfb8b3$export$3cb274deb6c2d854() {
    const context = (0, $7fPBF.useContext)($1704667ebbdfb8b3$export$93e4b0b2cc49b648);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
}
$1704667ebbdfb8b3$var$TableContextProviderInner.displayName = "TableContextProvider";

});
parcelRegister("gSkQi", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("feHBz", function(module, exports) {

$parcel$export(module.exports, "AitTablePosition", function () { return $bcfe2726d4d92b13$export$e1ae152cdf8268f0; });
$parcel$export(module.exports, "AitCellType", function () { return $bcfe2726d4d92b13$export$17673bdfcfce3de9; });
$parcel$export(module.exports, "AitRowType", function () { return $bcfe2726d4d92b13$export$df5087a2c354e5b1; });
$parcel$export(module.exports, "GridItemChangeType", function () { return $bcfe2726d4d92b13$export$5c42d5a0bc41f791; });
$parcel$export(module.exports, "ADD_COLUMN", function () { return $bcfe2726d4d92b13$export$b1bd2b223d0ce7d0; });
$parcel$export(module.exports, "ADD_COLUMN_SPAN", function () { return $bcfe2726d4d92b13$export$22ee848e0a588553; });
$parcel$export(module.exports, "ADD_NEW_HEADER", function () { return $bcfe2726d4d92b13$export$1f0180bd2af66aee; });
$parcel$export(module.exports, "ADD_ROW", function () { return $bcfe2726d4d92b13$export$ab3740b814ea86bd; });
$parcel$export(module.exports, "ADD_ROW_GROUP", function () { return $bcfe2726d4d92b13$export$bad0637c061bfb20; });
$parcel$export(module.exports, "ADD_ROW_SPAN", function () { return $bcfe2726d4d92b13$export$ce456c8fc5a7760d; });
$parcel$export(module.exports, "DUPLICATE_COLUMN", function () { return $bcfe2726d4d92b13$export$16ad9d1ad0c7b153; });
$parcel$export(module.exports, "DUPLICATE_ROW", function () { return $bcfe2726d4d92b13$export$a5b937a7720f54b4; });
$parcel$export(module.exports, "DUPLICATE_ROW_GROUP", function () { return $bcfe2726d4d92b13$export$47418fab3a00ce65; });
$parcel$export(module.exports, "HIDE_OPTIONS_WINDOW", function () { return $bcfe2726d4d92b13$export$b69ec4aab5df8df9; });
$parcel$export(module.exports, "LOAD_STATE", function () { return $bcfe2726d4d92b13$export$c303146534fe0490; });
$parcel$export(module.exports, "REMOVE_COLUMN", function () { return $bcfe2726d4d92b13$export$880be170b22764b8; });
$parcel$export(module.exports, "REMOVE_COLUMN_SPAN", function () { return $bcfe2726d4d92b13$export$1221f725a67c1599; });
$parcel$export(module.exports, "REMOVE_ROW", function () { return $bcfe2726d4d92b13$export$6629255ca195427; });
$parcel$export(module.exports, "REMOVE_ROW_GROUP", function () { return $bcfe2726d4d92b13$export$f45f2db52671a683; });
$parcel$export(module.exports, "REMOVE_ROW_SPAN", function () { return $bcfe2726d4d92b13$export$ffd0e1e7ade2502c; });
$parcel$export(module.exports, "SET_DECIMAL_ALIGN_PERCENT", function () { return $bcfe2726d4d92b13$export$9c8d488ddebd2547; });
$parcel$export(module.exports, "SET_REPLACEMENTS", function () { return $bcfe2726d4d92b13$export$48171674ada024a2; });
$parcel$export(module.exports, "SET_ROW_HEADER_COLUMNS", function () { return $bcfe2726d4d92b13$export$e8fea413d1f48458; });
$parcel$export(module.exports, "SET_SPACE_AFTER", function () { return $bcfe2726d4d92b13$export$8419baaf3b79c261; });
$parcel$export(module.exports, "SET_TRAFFIC_LIGHTS", function () { return $bcfe2726d4d92b13$export$3dad91993096c745; });
$parcel$export(module.exports, "SHOW_OPTIONS_WINDOW", function () { return $bcfe2726d4d92b13$export$b78ab6f56f27b4a1; });
$parcel$export(module.exports, "TABLE_CHANGE_PUSHED", function () { return $bcfe2726d4d92b13$export$3b6d3e69d0d7fd73; });
$parcel$export(module.exports, "UPDATE_TABLE_CELL", function () { return $bcfe2726d4d92b13$export$21524ed19486bdb9; });
$parcel$export(module.exports, "UPDATE_COLUMN_WIDTH", function () { return $bcfe2726d4d92b13$export$27579dc167134645; });
$parcel$export(module.exports, "UPDATE_COMMENTS", function () { return $bcfe2726d4d92b13$export$e3b5e95c47cb1275; });
$parcel$export(module.exports, "UPDATE_HEADER_CELL", function () { return $bcfe2726d4d92b13$export$11765fbf334c4d6a; });
var $bcfe2726d4d92b13$export$e1ae152cdf8268f0 = /*#__PURE__*/ function(AitTablePosition) {
    AitTablePosition["table"] = "table";
    AitTablePosition["header"] = "header";
    AitTablePosition["headerRow"] = "headerRow";
    AitTablePosition["headerCell"] = "headerCell";
    AitTablePosition["body"] = "body";
    AitTablePosition["bodyRowGroup"] = "bodyRowGroup";
    AitTablePosition["bodyRow"] = "bodyRow";
    AitTablePosition["bodyCell"] = "bodyCell";
    AitTablePosition["column"] = "column";
    return AitTablePosition;
}({});
var $bcfe2726d4d92b13$export$17673bdfcfce3de9 = /*#__PURE__*/ function(AitCellType) {
    AitCellType["header"] = "header";
    AitCellType["rowHeader"] = "rowHeader";
    AitCellType["body"] = "body";
    return AitCellType;
}({});
var $bcfe2726d4d92b13$export$df5087a2c354e5b1 = /*#__PURE__*/ function(AitRowType) {
    AitRowType["header"] = "header";
    AitRowType["body"] = "body";
    AitRowType["bodyRowGroup"] = "bodyRowGroup";
    return AitRowType;
}({});
var $bcfe2726d4d92b13$export$5c42d5a0bc41f791 = /*#__PURE__*/ function(GridItemChangeType) {
    GridItemChangeType["deleted"] = "deleted";
    GridItemChangeType["added"] = "added";
    return GridItemChangeType;
}({});
const $bcfe2726d4d92b13$export$b1bd2b223d0ce7d0 = "ADD_COLUMN";
const $bcfe2726d4d92b13$export$22ee848e0a588553 = "ADD_COLUMN_SPAN";
const $bcfe2726d4d92b13$export$1f0180bd2af66aee = "ADD_NEW_HEADER";
const $bcfe2726d4d92b13$export$ab3740b814ea86bd = "ADD_ROW";
const $bcfe2726d4d92b13$export$bad0637c061bfb20 = "ADD_ROW_GROUP";
const $bcfe2726d4d92b13$export$ce456c8fc5a7760d = "ADD_ROW_SPAN";
const $bcfe2726d4d92b13$export$16ad9d1ad0c7b153 = "DUPLICATE_COLUMN";
const $bcfe2726d4d92b13$export$a5b937a7720f54b4 = "DUPLICATE_ROW";
const $bcfe2726d4d92b13$export$47418fab3a00ce65 = "DUPLICATE_ROW_GROUP";
const $bcfe2726d4d92b13$export$b69ec4aab5df8df9 = "HIDE_OPTIONS_WINDOW";
const $bcfe2726d4d92b13$export$c303146534fe0490 = "LOAD_STATE";
const $bcfe2726d4d92b13$export$880be170b22764b8 = "REMOVE_COLUMN";
const $bcfe2726d4d92b13$export$1221f725a67c1599 = "REMOVE_COLUMN_SPAN";
const $bcfe2726d4d92b13$export$6629255ca195427 = "REMOVE_ROW";
const $bcfe2726d4d92b13$export$f45f2db52671a683 = "REMOVE_ROW_GROUP";
const $bcfe2726d4d92b13$export$ffd0e1e7ade2502c = "REMOVE_ROW_SPAN";
const $bcfe2726d4d92b13$export$9c8d488ddebd2547 = "SET_DECIMAL_ALIGN_PERCENT";
const $bcfe2726d4d92b13$export$48171674ada024a2 = "SET_REPLACEMENTS";
const $bcfe2726d4d92b13$export$e8fea413d1f48458 = "SET_ROW_HEADER_COLUMNS";
const $bcfe2726d4d92b13$export$8419baaf3b79c261 = "SET_SPACE_AFTER";
const $bcfe2726d4d92b13$export$3dad91993096c745 = "SET_TRAFFIC_LIGHTS";
const $bcfe2726d4d92b13$export$b78ab6f56f27b4a1 = "SHOW_OPTIONS_WINDOW";
const $bcfe2726d4d92b13$export$3b6d3e69d0d7fd73 = "TABLE_CHANGE_PUSHED";
const $bcfe2726d4d92b13$export$21524ed19486bdb9 = "UPDATE_TABLE_CELL";
const $bcfe2726d4d92b13$export$27579dc167134645 = "UPDATE_COLUMN_WIDTH";
const $bcfe2726d4d92b13$export$e3b5e95c47cb1275 = "UPDATE_COMMENTS";
const $bcfe2726d4d92b13$export$11765fbf334c4d6a = "UPDATE_HEADER_CELL";

});

parcelRegister("3IXBZ", function(module, exports) {

$parcel$export(module.exports, "tableReducer", function () { return $a14f1d463da13075$export$a093025a80a6d2a7; });

var $gSkQi = parcelRequire("gSkQi");

var $feHBz = parcelRequire("feHBz");

var $3LImB = parcelRequire("3LImB");

var $3zeKa = parcelRequire("3zeKa");

var $5IOQZ = parcelRequire("5IOQZ");

var $h5gNQ = parcelRequire("h5gNQ");

var $bT2kY = parcelRequire("bT2kY");

var $dAmd5 = parcelRequire("dAmd5");

var $9Oxbr = parcelRequire("9Oxbr");

var $kYiTl = parcelRequire("kYiTl");

var $dRjEq = parcelRequire("dRjEq");

var $bnhRS = parcelRequire("bnhRS");

var $gpwEh = parcelRequire("gpwEh");

var $3hAid = parcelRequire("3hAid");

var $k56mL = parcelRequire("k56mL");

var $ey1Zf = parcelRequire("ey1Zf");

var $6B5Zi = parcelRequire("6B5Zi");

var $euIy3 = parcelRequire("euIy3");
const $a14f1d463da13075$export$a093025a80a6d2a7 = (state, action)=>{
    let newState = {
        ...state
    };
    switch(action.operation){
        // Done
        case 0, $feHBz.ADD_COLUMN:
            /* istanbul ignore else */ if (state.originalTableData.bodyData.length > 0 && state.originalTableData.bodyData[0].rows.length > 0 && state.originalTableData.bodyData[0].rows[0].cells.length < action.newColumnLength) {
                const addedColumn = (0, $5IOQZ.trAddColumn)(state.originalTableData.headerData, state.originalTableData.bodyData, action.columnIndex, state.defaultCellWidth, state.editorProps.blankT, state.originalTableData.columnInformation, action.newColumnLength);
                // Determine the cell ID to use for tracking the new column
                const newColumnIndex = action.columnIndex + 1;
                let idAfterTrafficLightIsShown = "";
                // Get the aitid of the first cell in the new column position
                /* istanbul ignore else */ if (addedColumn.headerData && addedColumn.headerData.rows.length > 0) // Use header cell if available
                idAfterTrafficLightIsShown = addedColumn.headerData.rows[0].cells[newColumnIndex].aitid;
                else if (addedColumn.bodyData.length > 0 && addedColumn.bodyData[0].rows.length > 0) // Fall back to first body cell
                idAfterTrafficLightIsShown = addedColumn.bodyData[0].rows[0].cells[newColumnIndex].aitid;
                // Add the new column to changedColumns
                const newChangedColumns = [
                    ...newState.originalTableData.changedColumns ?? // istanbul ignore next
                    [],
                    {
                        gridItemId: newColumnIndex.toString(),
                        coreTrafficLight: "ChangedUnknown",
                        isOptional: false,
                        gridItemChangeType: (0, $feHBz.GridItemChangeType).added,
                        idAfterTrafficLightIsShown: idAfterTrafficLightIsShown
                    }
                ];
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: addedColumn.headerData,
                    bodyData: addedColumn.bodyData,
                    changedColumns: newChangedColumns,
                    columnInformation: addedColumn.columnInformation
                };
                /* istanbul ignore else */ if (action.columnIndex < (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0)) // If the column is before the row header columns, we need to increase the count
                newState.originalTableData.rowHeaderColumns = (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0) + 1;
            }
            newState.changed = true;
            break;
        // Done
        case 0, $feHBz.ADD_COLUMN_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $3zeKa.trAddColSpan)(state.originalTableData.headerData, action.location, action.newSpan, state.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0);
                /* istanbul ignore else */ if (newHeaderData) newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $feHBz.ADD_NEW_HEADER:
            newState.changed = true;
            // Create new row
            /* istanbul ignore else */ if (newState.originalTableData.headerData === false) {
                // Get columnIds from the first body row
                const columnIds = state.originalTableData.columnInformation.map((ci)=>ci.columnId);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: {
                        aitid: crypto.randomUUID(),
                        rows: [
                            (0, $3LImB.newHeaderRow)(state.defaultCellWidth, state.editorProps.blankT, state.originalTableData.bodyData[0].rows[0].cells.length, columnIds)
                        ],
                        coreTrafficLight: "BlankNotEvaluated"
                    }
                };
            }
            break;
        // Done
        case 0, $feHBz.ADD_ROW:
            {
                newState.changed = true;
                // Check ok to proceed
                const addedRow = (0, $h5gNQ.trAddRow)(state.originalTableData.headerData, state.originalTableData.bodyData, action.location, action.newLength, state.defaultCellWidth, state.editorProps.blankT);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: addedRow.headerData ?? state.originalTableData.headerData,
                    bodyData: addedRow.bodyData ?? state.originalTableData.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        // Done
        case 0, $feHBz.ADD_ROW_GROUP:
            {
                newState.changed = true;
                const newBodyData = (0, $bT2kY.trAddRowGroup)(state.originalTableData.bodyData, state.groupTemplates, action.newLength, state.defaultCellWidth, state.editorProps.blankT, action.location.rowGroup, action.templateName);
                /* istanbul ignore else */ if (newBodyData) newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newBodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        case 0, $feHBz.ADD_ROW_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $dAmd5.trAddRowSpan)(state.originalTableData.headerData, action.location, action.newSpan);
                /* istanbul ignore else */ if (newHeaderData) newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $feHBz.DUPLICATE_COLUMN:
            newState.changed = true;
            // Check ok to proceed
            /* istanbul ignore else */ if (state.originalTableData.bodyData.length > 0 && state.originalTableData.bodyData[0].rows.length > 0 && state.originalTableData.bodyData[0].rows[0].cells.length < action.newColumnLength) {
                const duplicatedColumn = (0, $9Oxbr.trDuplicateColumn)(state.originalTableData.headerData, state.originalTableData.bodyData, action.columnIndex, state.defaultCellWidth, state.editorProps.blankT, state.originalTableData.columnInformation, action.newColumnLength);
                // Determine the cell ID to use for tracking the new column
                const newColumnIndex = action.columnIndex + 1;
                let idAfterTrafficLightIsShown = "";
                // Get the aitid of the first cell in the new column position
                /* istanbul ignore else */ if (duplicatedColumn.headerData && duplicatedColumn.headerData.rows.length > 0) // Use header cell if available
                idAfterTrafficLightIsShown = duplicatedColumn.headerData.rows[0].cells[newColumnIndex].aitid;
                else if (duplicatedColumn.bodyData.length > 0 && duplicatedColumn.bodyData[0].rows.length > 0) // Fall back to first body cell
                idAfterTrafficLightIsShown = duplicatedColumn.bodyData[0].rows[0].cells[newColumnIndex].aitid;
                // Add the new column to changedColumns
                const newChangedColumns = [
                    ...newState.originalTableData.changedColumns ?? // istanbul ignore next
                    [],
                    {
                        gridItemId: newColumnIndex.toString(),
                        coreTrafficLight: "ChangedUnknown",
                        isOptional: false,
                        gridItemChangeType: (0, $feHBz.GridItemChangeType).added,
                        idAfterTrafficLightIsShown: idAfterTrafficLightIsShown
                    }
                ];
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: duplicatedColumn.headerData,
                    bodyData: duplicatedColumn.bodyData,
                    changedColumns: newChangedColumns,
                    columnInformation: duplicatedColumn.columnInformation
                };
                if (action.columnIndex < (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0)) // If the column is before the row header columns, we need to increase the count
                newState.originalTableData.rowHeaderColumns = (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0) + 1;
            }
            break;
        // Done
        case 0, $feHBz.DUPLICATE_ROW:
            {
                newState.changed = true;
                // Add new row under the original row
                const duplicateRow = (0, $kYiTl.trDuplicateRow)(state.originalTableData.headerData, state.originalTableData.bodyData, action.location, action.newLength);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: duplicateRow.headerData,
                    bodyData: duplicateRow.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        // Done
        case 0, $feHBz.DUPLICATE_ROW_GROUP:
            newState.changed = true;
            /* istanbul ignore else */ if (newState.originalTableData.bodyData.length < action.newLength) {
                const newBodyData = (0, $dRjEq.trDuplicateRowGroup)(state.originalTableData.bodyData, action.location.rowGroup, action.newLength);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newBodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $feHBz.HIDE_OPTIONS_WINDOW:
            newState.showOptionsWindow = newState.showOptionsWindow.filter((l)=>!(0, $gSkQi.isEqual)(l, action.location));
            break;
        // Done
        case 0, $feHBz.LOAD_STATE:
            newState = {
                ...action.newState,
                showOptionsWindow: newState.showOptionsWindow,
                /* This will be processed later */ processedTableData: {
                    headerData: false,
                    bodyData: [],
                    coreTrafficLight: "BlankNotEvaluated",
                    decimalAlignPercent: 60,
                    columnInformation: []
                },
                changed: false
            };
            break;
        // Done
        case 0, $feHBz.REMOVE_COLUMN:
            {
                newState.changed = true;
                const removedColumn = (0, $3hAid.trRemoveColumn)(state.originalTableData.headerData, state.originalTableData.bodyData, action.cellIds);
                if (newState.originalTableData.rowHeaderColumns && action.value < newState.originalTableData.rowHeaderColumns) newState.originalTableData.rowHeaderColumns = Math.max(0, newState.originalTableData.rowHeaderColumns - 1);
                // Update columnInformation: remove the column and decrement indices for columns after it
                const removedColumnIndex = action.value;
                const updatedColumnInformation = newState.originalTableData.columnInformation?.filter((ci)=>ci.originalColumnIndex !== removedColumnIndex).map((ci)=>ci.originalColumnIndex > removedColumnIndex ? {
                        ...ci,
                        originalColumnIndex: ci.originalColumnIndex - 1
                    } : ci);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: removedColumn.headerData,
                    bodyData: removedColumn.bodyData,
                    coreTrafficLight: "ChangedUnknown",
                    columnInformation: updatedColumnInformation
                };
                break;
            }
        // Done
        case 0, $feHBz.REMOVE_COLUMN_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $gpwEh.trRemoveColSpan)(state.originalTableData.headerData, action.location, action.newSpan);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData ?? state.originalTableData.headerData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $feHBz.REMOVE_ROW:
            {
                newState.changed = true;
                const removedRow = (0, $k56mL.trRemoveRow)(state.originalTableData.headerData, state.originalTableData.bodyData, action.location);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: removedRow.headerData ?? state.originalTableData.headerData,
                    bodyData: removedRow.bodyData ?? state.originalTableData.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        // Done
        case 0, $feHBz.REMOVE_ROW_GROUP:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                bodyData: newState.originalTableData.bodyData.filter((rowGroup)=>rowGroup.aitid !== action.location.rowGroupId),
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $feHBz.REMOVE_ROW_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $ey1Zf.trRemoveRowSpan)(state.originalTableData.headerData, action.location, action.newSpan);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData ?? state.originalTableData.headerData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $feHBz.SET_DECIMAL_ALIGN_PERCENT:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                decimalAlignPercent: action.value,
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $feHBz.SET_REPLACEMENTS:
            newState.changed = true;
            /* istanbul ignore else */ if (action.location.position === (0, $feHBz.AitTablePosition).header && newState.originalTableData.headerData) newState.originalTableData = {
                ...newState.originalTableData,
                headerData: {
                    ...newState.originalTableData.headerData,
                    coreTrafficLight: "ChangedUnknown",
                    replacements: action.replacements
                },
                coreTrafficLight: "ChangedUnknown"
            };
            else if (action.location.position === (0, $feHBz.AitTablePosition).bodyRowGroup && newState.originalTableData.bodyData.findIndex((rg)=>rg.aitid === action.location.rowGroupId) !== -1) newState.originalTableData = {
                ...newState.originalTableData,
                bodyData: newState.originalTableData.bodyData.map((rg)=>rg.aitid === action.location.rowGroupId ? {
                        ...rg,
                        replacements: action.replacements,
                        coreTrafficLight: "ChangedUnknown"
                    } : rg),
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $feHBz.SET_ROW_HEADER_COLUMNS:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                rowHeaderColumns: action.value,
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $feHBz.SET_SPACE_AFTER:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                bodyData: newState.originalTableData.bodyData.map((rowGroup)=>rowGroup.aitid === action.location.rowGroupId ? {
                        ...rowGroup,
                        spaceAfter: action.bool
                    } : rowGroup),
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $feHBz.SET_TRAFFIC_LIGHTS:
            newState.noTrafficLights = action.bool;
            break;
        // Done
        case 0, $feHBz.TABLE_CHANGE_PUSHED:
            newState.changed = false;
            break;
        // Done
        case 0, $feHBz.SHOW_OPTIONS_WINDOW:
            newState.showOptionsWindow = [
                ...newState.showOptionsWindow.filter((l)=>!(0, $gSkQi.isEqual)(l, action.location)),
                action.location
            ];
            break;
        // Done
        case 0, $feHBz.UPDATE_TABLE_CELL:
            newState.changed = true;
            // Update the replacements in the bodyData
            /* istanbul ignore else */ if (newState.originalTableData) newState.originalTableData = {
                ...newState.originalTableData,
                coreTrafficLight: "ChangedUnknown",
                bodyData: newState.originalTableData.bodyData.map((rowGroup)=>({
                        ...rowGroup,
                        coreTrafficLight: rowGroup.aitid === action.location.rowGroupId ? "ChangedUnknown" : rowGroup.coreTrafficLight,
                        rows: rowGroup.rows.map((row)=>({
                                ...row,
                                coreTrafficLight: action.location.rowId === row.aitid ? "ChangedUnknown" : row.coreTrafficLight,
                                cells: row.cells.map((c)=>c.aitid === action.location.cellId ? {
                                        ...c,
                                        ...action.cellData,
                                        coreTrafficLight: "ChangedUnknown"
                                    } : c)
                            }))
                    }))
            };
            break;
        // Done
        case 0, $feHBz.UPDATE_COLUMN_WIDTH:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData && newState.originalTableData) {
                const updatedWidth = (0, $6B5Zi.trUpdateColumnWidth)(state.originalTableData, action.location.originalColumn, action.value);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: updatedWidth.headerData,
                    bodyData: updatedWidth.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $feHBz.UPDATE_COMMENTS:
            newState.changed = true;
            newState = (0, $euIy3.trUpdateComments)(newState, action);
            break;
        case 0, $feHBz.UPDATE_HEADER_CELL:
            newState.changed = true;
            // Update the replacements in the bodyData
            /* istanbul ignore else */ if (newState.originalTableData.headerData) {
                const headerData = newState.originalTableData.headerData;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: {
                        ...headerData,
                        coreTrafficLight: "ChangedUnknown",
                        rows: headerData.rows.map((row)=>row.aitid === action.location.rowId ? {
                                ...row,
                                coreTrafficLight: "ChangedUnknown",
                                cells: row.cells.map((c)=>c.aitid === action.location.cellId ? {
                                        ...c,
                                        ...action.cellData,
                                        coreTrafficLight: "ChangedUnknown"
                                    } : c)
                            } : row)
                    }
                };
            }
            break;
    }
    newState.processedTableData = (0, $bnhRS.trProcessTable)(newState);
    return newState;
};

});
parcelRegister("3LImB", function(module, exports) {

$parcel$export(module.exports, "newRow", function () { return $3b7c0f9d86af3993$export$fbe120a39049074a; });
$parcel$export(module.exports, "newHeaderRow", function () { return $3b7c0f9d86af3993$export$dd59b3336ab2d42a; });

var $iIj1X = parcelRequire("iIj1X");
const $3b7c0f9d86af3993$export$fbe120a39049074a = (defaultCellWidth, blank, l, columnIds)=>{
    const newRow = {
        aitid: crypto.randomUUID(),
        cells: [],
        coreTrafficLight: "BlankNotEvaluated"
    };
    // Add new cells in a loop to avoid duplicate aitid
    for(let i = 0; i < l; i++){
        const columnId = columnIds[i];
        newRow.cells.push((0, $iIj1X.newCell)(defaultCellWidth, blank, columnId));
    }
    return newRow;
};
const $3b7c0f9d86af3993$export$dd59b3336ab2d42a = (defaultCellWidth, blank, l, columnIds)=>{
    const newRow = {
        aitid: crypto.randomUUID(),
        cells: [],
        coreTrafficLight: "BlankNotEvaluated"
    };
    // Add new cells in a loop to avoid duplicate aitid
    for(let i = 0; i < l; i++){
        const columnId = columnIds[i];
        newRow.cells.push((0, $iIj1X.newHeaderCell)(defaultCellWidth, blank, columnId));
    }
    return newRow;
};

});
parcelRegister("iIj1X", function(module, exports) {

$parcel$export(module.exports, "newCell", function () { return $bf82cc3b74ca0cba$export$80320bc05f4522a4; });
$parcel$export(module.exports, "newHeaderCell", function () { return $bf82cc3b74ca0cba$export$1d3e6a75a388edd1; });
const $bf82cc3b74ca0cba$export$80320bc05f4522a4 = (cellWidth, blank, columnId)=>{
    const cell = {
        aitid: crypto.randomUUID(),
        text: blank,
        comments: blank,
        colWidth: cellWidth,
        coreTrafficLight: "BlankNotEvaluated",
        columnId: columnId
    };
    return cell;
};
const $bf82cc3b74ca0cba$export$1d3e6a75a388edd1 = (cellWidth, blank, columnId)=>{
    const cell = {
        aitid: crypto.randomUUID(),
        text: blank,
        comments: blank,
        rowSpan: 1,
        colSpan: 1,
        colWidth: cellWidth,
        coreTrafficLight: "BlankNotEvaluated",
        columnId: columnId
    };
    return cell;
};

});


parcelRegister("3zeKa", function(module, exports) {

$parcel$export(module.exports, "trCanAddColSpan", function () { return $0414990a428361e2$export$36a01ae58920cd3a; });
$parcel$export(module.exports, "trAddColSpan", function () { return $0414990a428361e2$export$ce1763e3b9c43eb8; });

var $fCWrt = parcelRequire("fCWrt");
const $0414990a428361e2$export$36a01ae58920cd3a = (headerData, location, newColSpan, rowHeaderColumns)=>{
    let reasonNot = "";
    let hideCell;
    // Check target cell exists
    const targetCell = (0, $fCWrt.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        coreTrafficLight: "BlankNotEvaluated",
        columnInformation: []
    }, location, true);
    if (targetCell === undefined) reasonNot = "AddColSpan: target cell not found";
    else if (location.isRepeat) reasonNot = "AddColSpan: this is a repeat cell";
    else if (targetCell.rowSpan !== 1) reasonNot = "AddColSpan: cell already has row span";
    else if (location.originalColumn + newColSpan === rowHeaderColumns + 1) reasonNot = "AddColSpan: colSpan would go over the rowHeader";
    else if (location.row + 1 === headerData.rows.length) reasonNot = "AddColSpan: cannot add colSpan on the last row";
    else {
        // Get the cell to hide
        const hideColumn = location.originalColumn + newColSpan - 1;
        if (headerData.rows[location.row].cells.length <= hideColumn) reasonNot = "AddColSpan: header does not have enough columns to expand";
        else {
            hideCell = headerData.rows[location.row].cells[hideColumn];
            if (hideCell.colSpan !== 1 || hideCell.rowSpan !== 1) reasonNot = "AddColSpan: hide cell is not suitable for hiding";
        }
    }
    return reasonNot !== "" ? {
        canAdd: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        hideCell: hideCell
    } : {
        canAdd: true,
        reasonNot: undefined,
        targetCell: targetCell,
        hideCell: hideCell
    };
};
const $0414990a428361e2$export$ce1763e3b9c43eb8 = (headerData, location, newSpan, rowHeaderColumns)=>{
    // Check ok to add row span
    const { canAdd: canAdd, reasonNot: reasonNot, targetCell: targetCell, hideCell: hideCell } = $0414990a428361e2$export$36a01ae58920cd3a(headerData, location, newSpan, rowHeaderColumns);
    // Already done
    if (targetCell?.colSpan === newSpan) return;
    // Cannot add
    if (!canAdd) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = headerData.rows.map((row)=>{
        if (row.aitid !== location.rowId) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                colSpan: newSpan
            };
            if (cell.aitid === hideCell.aitid) return {
                ...cell,
                colSpan: 0
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});
parcelRegister("fCWrt", function(module, exports) {

$parcel$export(module.exports, "trGetCellFromLocation", function () { return $d274885f65254a80$export$4b3baeebec5fb406; });

var $feHBz = parcelRequire("feHBz");
function $d274885f65254a80$export$844a59309eb2fddd(rows, rowId, cellId, rowIndex, columnIndex, ignoreRepeats) {
    return rows.find((row, ri)=>row.aitid === rowId && (ignoreRepeats || rowIndex === ri))?.cells.find((cell, ci)=>cell.aitid === cellId && (ignoreRepeats || columnIndex === ci));
}
function $d274885f65254a80$export$4b3baeebec5fb406(tableData, location, ignoreRepeats) {
    if (location.position === (0, $feHBz.AitTablePosition).headerCell && tableData?.headerData) return $d274885f65254a80$export$844a59309eb2fddd(tableData.headerData.rows, location.rowId, location.cellId, location.row, location.column, ignoreRepeats);
    if (location.position === (0, $feHBz.AitTablePosition).bodyCell && tableData?.bodyData) {
        const rowGroup = tableData.bodyData[location.rowGroup];
        /* istanbul ignore else */ if (rowGroup) return $d274885f65254a80$export$844a59309eb2fddd(rowGroup.rows, location.rowId, location.cellId, location.row, location.column, ignoreRepeats);
    }
    return undefined;
}

});


parcelRegister("5IOQZ", function(module, exports) {

$parcel$export(module.exports, "trAddColumn", function () { return $1374ec079488ff72$export$80fe9699b1b96651; });

var $iIj1X = parcelRequire("iIj1X");
const $1374ec079488ff72$export$80fe9699b1b96651 = (headerData, bodyData, columnIndex, defaultCellWidth, blankT, columnInformation, newLength)=>{
    // Check column index is acceptable
    if (columnIndex < -1) throw new Error("Column index is too low");
    if (bodyData.length === 0) throw new Error("No row groups in body data");
    if (bodyData[0].rows.length === 0) throw new Error("No rows in body data");
    if (columnIndex >= bodyData[0].rows[0].cells.length) throw new Error("Column index is too high");
    if (newLength <= bodyData[0].rows[0].cells.length) return {
        headerData: headerData,
        bodyData: bodyData,
        columnInformation: columnInformation
    };
    // Generate a new columnId for the new column
    const newColumnId = crypto.randomUUID();
    // Update columnInformation array
    let updatedColumnInformation = columnInformation.map((ci)=>ci.originalColumnIndex > columnIndex ? {
            ...ci,
            originalColumnIndex: ci.originalColumnIndex + 1
        } : ci);
    // Add new columnInformation entry for the added column (with empty annotation)
    /* istanbul ignore else */ if (updatedColumnInformation) {
        const newColumnInfo = {
            columnId: newColumnId,
            originalColumnIndex: columnIndex + 1
        };
        updatedColumnInformation = [
            ...updatedColumnInformation.slice(0, columnIndex + 1),
            newColumnInfo,
            ...updatedColumnInformation.slice(columnIndex + 1)
        ];
    }
    // Update body data
    const newBody = bodyData.map((rg)=>({
            ...rg,
            rows: rg.rows.map((r)=>{
                const newCellData = (0, $iIj1X.newCell)(defaultCellWidth, blankT, newColumnId);
                return {
                    ...r,
                    cells: [
                        ...r.cells.slice(0, columnIndex + 1),
                        newCellData,
                        ...r.cells.slice(columnIndex + 1)
                    ]
                };
            })
        }));
    // Update header group
    const newHeader = headerData ? {
        ...headerData,
        rows: headerData.rows.map((r)=>{
            const cells = r.cells;
            if (columnIndex >= 0 && cells[columnIndex + 1]?.colSpan === 0) {
                let lookback = 1;
                while(lookback <= columnIndex && cells[columnIndex + 1 - lookback].colSpan === 0)lookback++;
                const spannerIx = columnIndex + 1 - lookback;
                // Only clone the spanner cell
                const spannerCell = {
                    ...cells[spannerIx],
                    colSpan: cells[spannerIx].colSpan + 1
                };
                // Add in blank cell
                const newHeaderCellData = (0, $iIj1X.newHeaderCell)(defaultCellWidth, blankT, newColumnId);
                newHeaderCellData.colSpan = 0;
                const newCells = [
                    ...cells.slice(0, columnIndex + 1),
                    newHeaderCellData,
                    ...cells.slice(columnIndex + 1)
                ];
                // Update the spanner cell in the new cells
                newCells[spannerIx] = spannerCell;
                return {
                    ...r,
                    cells: newCells
                };
            } else {
                // Only insert a new cell, reuse others
                const newHeaderCellData = (0, $iIj1X.newHeaderCell)(defaultCellWidth, blankT, newColumnId);
                const newCells = [
                    ...cells.slice(0, columnIndex + 1),
                    newHeaderCellData,
                    ...cells.slice(columnIndex + 1)
                ];
                return {
                    ...r,
                    cells: newCells
                };
            }
        })
    } : false;
    return {
        headerData: newHeader,
        bodyData: newBody,
        columnInformation: updatedColumnInformation
    };
};

});

parcelRegister("h5gNQ", function(module, exports) {

$parcel$export(module.exports, "trAddRow", function () { return $3dbbb00fcbff9446$export$8cf66db1735c9e22; });

var $feHBz = parcelRequire("feHBz");

var $iIj1X = parcelRequire("iIj1X");

var $3LImB = parcelRequire("3LImB");
const $3dbbb00fcbff9446$export$8cf66db1735c9e22 = (headerData, bodyData, location, newLength, defaultCellWidth, blankT)=>{
    // Add row to header
    if ((location.position === (0, $feHBz.AitTablePosition).header || location.position === (0, $feHBz.AitTablePosition).headerRow) && headerData !== false && headerData.rows.length < newLength) {
        // For header insertion prepend (rowIndex -1); for row-level locate by rowId
        const rowIndex = location.position === (0, $feHBz.AitTablePosition).header ? -1 : headerData.rows.findIndex((row)=>row.aitid === location.rowId);
        const newrs = [
            ...headerData.rows
        ];
        const newr = (0, $3LImB.newHeaderRow)(defaultCellWidth, blankT, 0, []);
        const cols = headerData.rows[0].cells.map((c)=>c.colSpan).reduce((sum, a)=>sum + a, 0);
        for(let ci = 0; ci < cols; ci++){
            // Create new cell, use column width and columnId from row 0
            const c = (0, $iIj1X.newHeaderCell)(headerData.rows[0].cells[ci].colWidth ?? // istanbul ignore next
            defaultCellWidth, blankT, headerData.rows[0].cells[ci].columnId);
            // Check rowSpans on previous row
            if (rowIndex >= 0 && newrs[rowIndex].cells[ci].rowSpan !== 1) {
                let riUp = 0;
                while(riUp <= rowIndex && newrs[rowIndex - riUp].cells[ci].rowSpan === 0)riUp++;
                newrs[rowIndex - riUp].cells[ci].rowSpan = newrs[rowIndex - riUp].cells[ci].rowSpan + 1;
                c.rowSpan = 0;
            }
            newr.cells.push(c);
        }
        newr.coreTrafficLight = "ChangedUnknown";
        newrs.splice(rowIndex + 1, 0, newr);
        return {
            headerData: {
                ...headerData,
                rows: newrs,
                coreTrafficLight: "ChangedUnknown"
            }
        };
    } else if ((location.position === (0, $feHBz.AitTablePosition).bodyRowGroup || location.position === (0, $feHBz.AitTablePosition).bodyRow) && bodyData[location.rowGroup].rows.length < newLength) {
        // Add row to body row group
        const newBodyData = [
            ...bodyData
        ];
        const newRowGroup = newBodyData[location.rowGroup];
        // For group-level insertion prepend (rowIndex -1); for row-level locate by rowId
        const rowIndex = location.position === (0, $feHBz.AitTablePosition).bodyRowGroup ? -1 : newRowGroup.rows.findIndex((row)=>row.aitid === location.rowId);
        // Add row to body
        const newrs = [
            ...newRowGroup.rows
        ];
        const newr = (0, $3LImB.newRow)(defaultCellWidth, blankT, 0, []);
        const cols = newRowGroup.rows[0].cells.length;
        for(let ci = 0; ci < cols; ci++){
            // Create new cell, use column width and columnId from row 0
            const c = (0, $iIj1X.newCell)(newRowGroup.rows[0].cells[ci].colWidth ?? // istanbul ignore next
            defaultCellWidth, blankT, newRowGroup.rows[0].cells[ci].columnId);
            newr.cells.push(c);
        }
        newr.coreTrafficLight = "ChangedUnknown";
        newrs.splice(rowIndex + 1, 0, newr);
        newBodyData[location.rowGroup] = {
            ...newRowGroup,
            rows: newrs,
            coreTrafficLight: "ChangedUnknown"
        };
        return {
            bodyData: newBodyData
        };
    }
    return {};
};

});

parcelRegister("bT2kY", function(module, exports) {

$parcel$export(module.exports, "trAddRowGroup", function () { return $474096170c19394a$export$a3e94cf82ca01a25; });

var $5mofv = parcelRequire("5mofv");
const $474096170c19394a$export$a3e94cf82ca01a25 = (bodyData, groupTemplates, newLength, defaultCellWidth, blankT, rgi, templateName)=>{
    /* istanbul ignore else */ if (bodyData.length < newLength) {
        const newBody = [
            ...bodyData
        ];
        // Create new body, take template if it can be found
        const ix = !templateName || !groupTemplates ? -1 : groupTemplates.findIndex((g)=>g.name === templateName);
        const newRowGroupTemplate = ix > -1 && groupTemplates ? groupTemplates[ix] : {
            aitid: crypto.randomUUID(),
            rows: [
                {
                    aitid: crypto.randomUUID(),
                    cells: [],
                    coreTrafficLight: "BlankNotEvaluated"
                }
            ],
            coreTrafficLight: "BlankNotEvaluated"
        };
        // Ensure new template meets requirements
        if (bodyData.length) {
            // Get columnIds from existing bodyData
            const columnIds = bodyData[0].rows[0].cells.map((c)=>c.columnId);
            const newrg = (0, $5mofv.newRowGroup)(defaultCellWidth, blankT, bodyData[0].rows[0].cells.length, newRowGroupTemplate, columnIds);
            // Set traffic light to indicate this is a newly added row group
            newrg.coreTrafficLight = "ChangedUnknown";
            // Set column widths (columnIds already set by newRowGroup)
            newrg.rows.forEach((r)=>r.cells.forEach((c, ci)=>{
                    c.colWidth = bodyData[0].rows[0].cells[ci].colWidth;
                }));
            // Copy existing body and splice in new data
            newBody.splice(rgi + 1, 0, newrg);
        }
        return newBody;
    }
};

});
parcelRegister("5mofv", function(module, exports) {

$parcel$export(module.exports, "newRowGroup", function () { return $8a68f03480af74b6$export$9c8e61b6f140016c; });

var $iIj1X = parcelRequire("iIj1X");

var $3LImB = parcelRequire("3LImB");
const $8a68f03480af74b6$export$9c8e61b6f140016c = (defaultCellWidth, blank, rowLength, newRowGroupTemplate, columnIds)=>{
    // Generate columnIds if not provided
    const finalColumnIds = columnIds ?? Array.from({
        length: rowLength
    }, ()=>crypto.randomUUID());
    return {
        aitid: crypto.randomUUID(),
        replacements: newRowGroupTemplate?.replacements ?? [],
        rows: newRowGroupTemplate?.rows.map((row)=>{
            const newCells = [];
            for(let ci = 0; ci < rowLength; ci++)newCells.push(row.cells[ci] !== undefined ? {
                ...row.cells[ci],
                aitid: crypto.randomUUID()
            } : (0, $iIj1X.newCell)(defaultCellWidth, blank, finalColumnIds[ci]));
            return {
                aitid: crypto.randomUUID(),
                cells: newCells,
                coreTrafficLight: "BlankNotEvaluated"
            };
        }) ?? [
            (0, $3LImB.newRow)(defaultCellWidth, blank, rowLength, finalColumnIds)
        ],
        spaceAfter: true,
        coreTrafficLight: "BlankNotEvaluated"
    };
};

});


parcelRegister("dAmd5", function(module, exports) {

$parcel$export(module.exports, "trCanAddRowSpan", function () { return $f07df4eb83ed5334$export$25e3d2af48d28306; });
$parcel$export(module.exports, "trAddRowSpan", function () { return $f07df4eb83ed5334$export$383f3f36b6a92876; });

var $fCWrt = parcelRequire("fCWrt");
const $f07df4eb83ed5334$export$25e3d2af48d28306 = (headerData, location, newRowSpan)=>{
    let reasonNot = "";
    let hideCell;
    // Check target cell exists
    const targetCell = (0, $fCWrt.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        coreTrafficLight: "BlankNotEvaluated",
        columnInformation: []
    }, location, true);
    if (targetCell === undefined) reasonNot = "AddRowSpan: target cell not found";
    else if (targetCell.rowSpan === newRowSpan) reasonNot = "";
    else if (location.isRepeat) reasonNot = "AddRowSpan: this is a repeat cell";
    else if (targetCell.colSpan !== 1) reasonNot = "AddRowSpan: cell already has column span";
    else // Get the cell to hide
    if (headerData.rows.length <= location.row + newRowSpan - 1) reasonNot = "AddRowSpan: header does not have enough rows to expand";
    else {
        hideCell = headerData.rows[location.row + newRowSpan - 1].cells[location.originalColumn];
        if (hideCell.colSpan !== 1 || hideCell.rowSpan !== 1) reasonNot = "AddRowSpan: hide cell is not suitable for hiding";
    }
    return reasonNot !== "" ? {
        canAdd: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        hideCell: hideCell
    } : {
        canAdd: true,
        reasonNot: undefined,
        targetCell: targetCell,
        hideCell: hideCell
    };
};
const $f07df4eb83ed5334$export$383f3f36b6a92876 = (headerData, location, newSpan)=>{
    // Check ok to add row span
    const { canAdd: canAdd, reasonNot: reasonNot, targetCell: targetCell, hideCell: hideCell } = $f07df4eb83ed5334$export$25e3d2af48d28306(headerData, location, newSpan);
    // Already updated
    if (targetCell?.rowSpan === newSpan) return;
    // Cannot add
    if (!canAdd) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = headerData.rows.map((row)=>{
        if (row.aitid !== location.rowId && !row.cells.find((c)=>c.aitid === hideCell.aitid)) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                rowSpan: newSpan
            };
            if (cell.aitid === hideCell.aitid) return {
                ...cell,
                rowSpan: 0
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});

parcelRegister("9Oxbr", function(module, exports) {

$parcel$export(module.exports, "trDuplicateColumn", function () { return $007b65bef8aae7c0$export$511a7861c15a00a8; });

var $iIj1X = parcelRequire("iIj1X");

var $gNU2R = parcelRequire("gNU2R");
const $007b65bef8aae7c0$export$511a7861c15a00a8 = (headerData, bodyData, columnIndex, defaultCellWidth, blankT, columnInformation, newLength)=>{
    // Check column index is acceptable
    if (columnIndex < 0) throw new Error("Column index is too low");
    if (bodyData.length === 0) throw new Error("No row groups in body data");
    if (bodyData.some((rg)=>rg.rows.length === 0)) throw new Error("No rows in body data");
    if (columnIndex >= bodyData[0].rows[0].cells.length) throw new Error("Column index is too high");
    // Add new columnInformation entry for the duplicated column
    const originalColumnInfo = columnInformation.find((ci)=>ci.originalColumnIndex === columnIndex);
    if (!originalColumnInfo) throw new Error("Original column information not found");
    if (newLength <= bodyData[0].rows[0].cells.length) return {
        headerData: headerData,
        bodyData: bodyData,
        columnInformation: columnInformation
    };
    // Generate a new unique columnId for the duplicated column
    const newColumnId = crypto.randomUUID();
    // Copy the annotation from the original column with the new columnId
    const newColumnInfo = {
        ...originalColumnInfo,
        columnId: newColumnId,
        originalColumnIndex: columnIndex + 1
    };
    const updatedColumnInformation = [
        ...columnInformation.slice(0, columnIndex + 1),
        newColumnInfo,
        ...columnInformation.slice(columnIndex + 1).map((ci)=>({
                ...ci,
                originalColumnIndex: ci.originalColumnIndex + 1
            }))
    ];
    // Update body data
    const newBody = bodyData.map((rg)=>{
        return {
            ...rg,
            rows: rg.rows.map((r)=>{
                const duplicate = (0, $gNU2R.trDuplicate)(r.cells[columnIndex]);
                // Assign new unique columnId for the duplicated cell
                duplicate.columnId = newColumnId;
                const newCells = [
                    ...r.cells.slice(0, columnIndex + 1),
                    duplicate,
                    ...r.cells.slice(columnIndex + 1)
                ];
                return {
                    ...r,
                    cells: newCells
                };
            })
        };
    });
    // Update header group
    const newHeader = headerData === false ? false : {
        ...headerData,
        rows: headerData.rows.map((r)=>{
            const newHeaderCells = [
                ...r.cells
            ];
            // Check for colSpan
            if (r.cells[columnIndex + 1]?.colSpan === 0) {
                // Change colSpan on previous spanner
                let lookback = 1;
                while(lookback <= columnIndex && r.cells[columnIndex + 1 - lookback].colSpan === 0)lookback++;
                r.cells[columnIndex + 1 - lookback].colSpan = r.cells[columnIndex + 1 - lookback].colSpan + 1;
                // Add in blank cell
                const n = (0, $iIj1X.newHeaderCell)(defaultCellWidth, blankT, newColumnId);
                n.colSpan = 0;
                newHeaderCells.splice(columnIndex + 1, 0, n);
            } else {
                const duplicate = (0, $gNU2R.trDuplicate)(r.cells[columnIndex]);
                duplicate.colSpan = 1;
                // Assign new unique columnId for the duplicated cell
                duplicate.columnId = newColumnId;
                newHeaderCells.splice(columnIndex + 1, 0, duplicate);
            }
            return {
                ...r,
                cells: newHeaderCells
            };
        })
    };
    return {
        headerData: newHeader,
        bodyData: newBody,
        columnInformation: updatedColumnInformation
    };
};

});
parcelRegister("gNU2R", function(module, exports) {

$parcel$export(module.exports, "trDuplicate", function () { return $7caa9d0825881813$export$1484bd025c6fff3e; });
/**
 * Deep-clone a value and assign new `aitid` values where present.
 *
 * This performs a recursive clone of objects and arrays. When an object has
 * an `aitid` property the clone will receive a fresh `aitid` (via
 * `crypto.randomUUID()`); `templateAitId` and `templateColumnAitId` keys are
 * removed. If `coreTrafficLight` is present it is set to `ChangedUnknown` on
 * the clone.
 *
 * @template T - The type of the value to duplicate
 * @param obj - The value to clone; primitives are returned unchanged
 * @returns A deep-cloned value with new `aitid` values and adjusted template/traffic-light fields
 */ const $7caa9d0825881813$export$1484bd025c6fff3e = (obj)=>{
    if (typeof obj !== "object" || obj === null) return obj;
    else if (Array.isArray(obj)) return obj.map((item)=>$7caa9d0825881813$export$1484bd025c6fff3e(item));
    else {
        const newObj = {};
        for(const key in obj)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $7caa9d0825881813$export$1484bd025c6fff3e(obj[key]);
        // Assign new aitid
        if ("aitid" in newObj) newObj.aitid = crypto.randomUUID();
        if ("coreTrafficLight" in newObj) newObj.coreTrafficLight = "ChangedUnknown";
        // Remove template AitIds when duplicating
        if ("templateAitId" in newObj) delete newObj.templateAitId;
        if ("templateColumnAitId" in newObj) delete newObj.templateColumnAitId;
        return newObj;
    }
};

});


parcelRegister("kYiTl", function(module, exports) {

$parcel$export(module.exports, "trDuplicateRow", function () { return $a60cb4dfe73ea157$export$f067bb49ab7f78bc; });

var $feHBz = parcelRequire("feHBz");

var $gNU2R = parcelRequire("gNU2R");
const $a60cb4dfe73ea157$export$f067bb49ab7f78bc = (headerData, bodyData, location, newLength)=>{
    /* istanbul ignore else */ if (location.position === (0, $feHBz.AitTablePosition).headerRow && headerData !== false && headerData.rows.length < newLength && headerData.rows.find((row)=>row.aitid === location.rowId)) {
        const rowIndex = headerData.rows.findIndex((row)=>row.aitid === location.rowId);
        const newRows = [
            ...headerData.rows
        ];
        const duplicateRow = (0, $gNU2R.trDuplicate)(headerData.rows[rowIndex]);
        /* istanbul ignore else */ if (duplicateRow) {
            // Check rowSpans
            const cols = duplicateRow.cells.length;
            for(let ci = 0; ci < cols; ci++)// Change any duplicate row rowSpans to zero if they are not 1
            if (duplicateRow.cells[ci].rowSpan !== 1) {
                duplicateRow.cells[ci].rowSpan = 0;
                // Look for the previous cell to expand
                let riUp = 0;
                while(riUp <= rowIndex && newRows[rowIndex - riUp].cells[ci].rowSpan === 0)riUp++;
                // Get new length based on number of cells below with zero rowSpan
                let zeroCells = 1;
                while(newRows[rowIndex - riUp + zeroCells] && newRows[rowIndex - riUp + zeroCells].cells[ci].rowSpan === 0)zeroCells++;
                newRows[rowIndex - riUp].cells[ci] = {
                    ...newRows[rowIndex - riUp].cells[ci],
                    rowSpan: zeroCells + 1
                };
                newRows[rowIndex - riUp] = {
                    ...newRows[rowIndex - riUp],
                    cells: [
                        ...newRows[rowIndex - riUp].cells
                    ]
                };
            }
            newRows.splice(rowIndex + 1, 0, duplicateRow);
            headerData = {
                ...headerData,
                rows: newRows
            };
        }
    } else if (location.position === (0, $feHBz.AitTablePosition).bodyRow && bodyData[location.rowGroup].rows.length < newLength && bodyData[location.rowGroup].rows.find((row)=>row.aitid === location.rowId)) {
        const rowGroupIndex = location.rowGroup;
        const rowIndex = bodyData[rowGroupIndex].rows.findIndex((row)=>row.aitid === location.rowId);
        const duplicateRow = (0, $gNU2R.trDuplicate)(bodyData[rowGroupIndex].rows[rowIndex]);
        /* istanbul ignore else */ if (duplicateRow) {
            const newRows = [
                ...bodyData[rowGroupIndex].rows.slice(0, rowIndex + 1),
                duplicateRow,
                ...bodyData[rowGroupIndex].rows.slice(rowIndex + 1)
            ];
            bodyData = [
                ...bodyData.slice(0, rowGroupIndex),
                {
                    ...bodyData[rowGroupIndex],
                    rows: newRows
                },
                ...bodyData.slice(rowGroupIndex + 1)
            ];
        }
    }
    return {
        headerData: headerData,
        bodyData: bodyData
    };
};

});

parcelRegister("dRjEq", function(module, exports) {

$parcel$export(module.exports, "trDuplicateRowGroup", function () { return $74268ab2bc5aff98$export$89d5f4468b909739; });

var $gNU2R = parcelRequire("gNU2R");
const $74268ab2bc5aff98$export$89d5f4468b909739 = (bodyData, rgi, newLength)=>{
    return bodyData[rgi] === undefined || bodyData.length >= newLength ? bodyData : [
        ...bodyData.slice(0, rgi + 1),
        (0, $gNU2R.trDuplicate)(bodyData[rgi]),
        ...bodyData.slice(rgi + 1)
    ];
};

});

parcelRegister("bnhRS", function(module, exports) {

$parcel$export(module.exports, "trProcessTable", function () { return $aa1e77a4c14a4e59$export$748437235d87bd84; });

var $gSkQi = parcelRequire("gSkQi");

var $U6yOc = parcelRequire("U6yOc");

var $7s2RK = parcelRequire("7s2RK");
const $aa1e77a4c14a4e59$export$748437235d87bd84 = (state)=>{
    const tableData = state.originalTableData;
    let columnRepeats = tableData.bodyData.length === 0 || tableData.bodyData[0].rows.length === 0 ? null : Array.from(tableData.bodyData[0].rows[0].cells.keys()).map((n)=>{
        return {
            columnIndex: n
        };
    });
    let processedHeaderData = tableData.headerData;
    if (processedHeaderData !== false && (processedHeaderData.rows.length ?? // istanbul ignore next
    0) > 0) {
        const headerDataUpdate = (0, $U6yOc.repeatHeaders)(processedHeaderData.rows, processedHeaderData.replacements ?? // istanbul ignore next
        [], state.defaultCellWidth, state.editorProps.getTextFromT, state.editorProps.replaceTextInT, state.editorProps.blankT, state.tlfViewMode, tableData.rowHeaderColumns ?? // istanbul ignore next
        0, state.externalLists, state.externalSingles);
        processedHeaderData = {
            aitid: processedHeaderData.aitid,
            name: processedHeaderData.name,
            rows: headerDataUpdate.rows,
            comments: processedHeaderData.comments,
            spaceAfter: processedHeaderData.spaceAfter,
            replacements: processedHeaderData.replacements,
            coreTrafficLight: processedHeaderData.coreTrafficLight
        };
        columnRepeats = headerDataUpdate.columnRepeats;
    }
    // Create processed body
    const processedBodyData = tableData.bodyData.map((rg)=>{
        return {
            ...rg,
            rows: (0, $7s2RK.repeatRows)(rg.rows, state.defaultCellWidth, state.editorProps.getTextFromT, state.editorProps.replaceTextInT, state.editorProps.blankT, rg.replacements, rg.spaceAfter, state.tlfViewMode, state.externalLists, state.externalSingles).map((r)=>{
                return {
                    ...r,
                    cells: columnRepeats?.map((ci)=>r.cells[ci.columnIndex]) ?? // istanbul ignore next
                    r.cells
                };
            })
        };
    });
    const processedTableData = {
        ...(0, $gSkQi.cloneDeep)(tableData),
        headerData: processedHeaderData,
        bodyData: processedBodyData,
        columnRepeats: columnRepeats
    };
    return processedTableData;
};

});
parcelRegister("U6yOc", function(module, exports) {

$parcel$export(module.exports, "repeatHeaders", function () { return $a9f8249cb6c47260$export$ebd88f229b89fe9b; });

var $9YWkm = parcelRequire("9YWkm");

var $lDYsF = parcelRequire("lDYsF");

var $hnJfr = parcelRequire("hnJfr");

var $kCyUQ = parcelRequire("kCyUQ");
const $a9f8249cb6c47260$export$ebd88f229b89fe9b = (rows, replacements, defaultCellWidth, getTextFromT, replaceTextInT, blankT, tlfViewMode, rowHeaderColumns, externalLists, externalSingles)=>{
    // Start with blank slate, need to strip repeat information every time!
    let newHeaderRows = (0, $lDYsF.removeHeaderRowRepeatInfo)(rows);
    let newColumnRepeats = Array.from(rows[rows.length - 1].cells.keys()).map((n)=>{
        return {
            columnIndex: n
        };
    });
    // Strip repeat data if flagged
    if (tlfViewMode.noRepeatProcessing) return {
        rows: newHeaderRows,
        columnRepeats: newColumnRepeats
    };
    // Process replacements
    (0, $9YWkm.updateExternals)(replacements, externalLists)?.forEach((rep)=>{
        const afterReplacement = (0, $hnJfr.replaceHeaders)(rowHeaderColumns, newHeaderRows, newColumnRepeats, defaultCellWidth, getTextFromT, replaceTextInT, blankT, rep, undefined);
        newHeaderRows = afterReplacement.newHeaderRows;
        newColumnRepeats = afterReplacement.newColumnRepeats;
    });
    // Single post processing rep
    newHeaderRows = (0, $kCyUQ.singleReplacements)(externalSingles, newHeaderRows, replaceTextInT);
    return {
        rows: newHeaderRows,
        columnRepeats: newColumnRepeats
    };
};

});
parcelRegister("9YWkm", function(module, exports) {

$parcel$export(module.exports, "updateExternals", function () { return $56b0adf66b616f0b$export$8ad79e12c8182d35; });

var $jBp7n = parcelRequire("jBp7n");
const $56b0adf66b616f0b$export$8ad79e12c8182d35 = (reps, exts)=>{
    return reps?.map((rep)=>(0, $jBp7n.updateExternal)(rep, exts));
};

});
parcelRegister("jBp7n", function(module, exports) {

$parcel$export(module.exports, "updateExternal", function () { return $d9ba2be523aab5c4$export$760e8c77fc5f1148; });

var $gSkQi = parcelRequire("gSkQi");

var $9YWkm = parcelRequire("9YWkm");
const $d9ba2be523aab5c4$export$760e8c77fc5f1148 = (rep, exts)=>{
    const ix = rep.externalName !== undefined && exts !== undefined ? exts.findIndex((e)=>e.givenName === rep.externalName) : -1;
    let found = ix > -1 && exts !== undefined && exts.length > ix ? (0, $gSkQi.cloneDeep)(exts[ix].newTexts) : undefined;
    if (!found) found = rep.newTexts.some((nt)=>nt.subLists !== undefined) ? rep.newTexts.map((nts)=>{
        return {
            ...nts,
            subLists: (0, $9YWkm.updateExternals)(nts.subLists, exts)
        };
    }) : rep.newTexts;
    const newR = {
        ...rep,
        newTexts: found
    };
    return newR;
};

});


parcelRegister("lDYsF", function(module, exports) {

$parcel$export(module.exports, "removeRowRepeatInfo", function () { return $0297def564dfe029$export$b25987bc78488782; });
$parcel$export(module.exports, "removeHeaderRowRepeatInfo", function () { return $0297def564dfe029$export$7083d1cd335b5e35; });
const $0297def564dfe029$export$b25987bc78488782 = (rows)=>{
    return rows.map((r)=>{
        const ret = {
            aitid: r.aitid,
            cells: r.cells// .filter(c => !c.replacedText?.includes("__filler"))
            .map((c)=>{
                return {
                    aitid: c.aitid,
                    text: c.text,
                    justifyText: c.justifyText,
                    comments: c.comments,
                    // colSpan: c.colSpan,
                    // rowSpan: c.rowSpan,
                    colWidth: c.colWidth,
                    textIndents: c.textIndents,
                    coreTrafficLight: c.coreTrafficLight,
                    templateAitId: c.templateAitId,
                    templateColumnAitId: c.templateColumnAitId,
                    columnId: c.columnId
                };
            }),
            // spaceAfter: false,
            // rowRepeat: undefined,
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
        return ret;
    });
};
const $0297def564dfe029$export$7083d1cd335b5e35 = (rows)=>{
    return rows.map((r)=>{
        const ret = {
            aitid: r.aitid,
            cells: r.cells// .filter(c => !c.replacedText?.includes("__filler"))
            .map((c)=>{
                return {
                    aitid: c.aitid,
                    text: c.text,
                    justifyText: c.justifyText,
                    comments: c.comments,
                    colSpan: c.colSpan,
                    rowSpan: c.rowSpan,
                    colWidth: c.colWidth,
                    textIndents: c.textIndents,
                    coreTrafficLight: c.coreTrafficLight,
                    templateAitId: c.templateAitId,
                    templateColumnAitId: c.templateColumnAitId,
                    columnId: c.columnId
                };
            }),
            // spaceAfter: false,
            // rowRepeat: undefined,
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
        return ret;
    });
};

});

parcelRegister("hnJfr", function(module, exports) {

$parcel$export(module.exports, "replaceHeaders", function () { return $b8126129c31adf80$export$e3af655bc6f14763; });

var $dGStb = parcelRequire("dGStb");

var $dtJ3W = parcelRequire("dtJ3W");

var $iIj1X = parcelRequire("iIj1X");

var $gKnse = parcelRequire("gKnse");
const $b8126129c31adf80$export$e3af655bc6f14763 = (rowHeaderColumns, rows, columnRepeats, defaultCellWidth, getTextFromT, replaceTextInT, blankT, replacement, externalLists)=>{
    // Check there are rows
    if (rows.length === 0) return {
        newHeaderRows: [],
        newColumnRepeats: []
    };
    // Set up holders
    let newHeaderRows = rows.map((r)=>{
        return {
            aitid: r.aitid,
            cells: [],
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
    });
    let newColumnRepeats = [];
    // Go through each column
    let colsProcessed = 1;
    let addedCols = 0;
    for(let ci = 0; ci < rows[0].cells.length; ci = ci + colsProcessed){
        // Look for match, is there is one to find
        let found = replacement === undefined || replacement.oldText === "" || replacement.newTexts.length === 0 || replacement.newTexts[0].texts.join("") === "";
        colsProcessed = 1;
        // Add next column if the text is already found
        if (found || ci < rowHeaderColumns) {
            newHeaderRows = (0, $dtJ3W.appendCells)(newHeaderRows, rows.map((r)=>{
                return {
                    aitid: r.aitid,
                    cells: [
                        r.cells[ci]
                    ],
                    coreTrafficLight: r.coreTrafficLight,
                    templateAitId: r.templateAitId,
                    annotation: r.annotation
                };
            }));
            newColumnRepeats = [
                ...newColumnRepeats,
                columnRepeats[ci]
            ];
        } else {
            for(let ri = 0; ri < rows.length; ri++){
                // Skip processing if any cell below the current row in this column has colSpan === 0
                if (rows.slice(ri + 1).some((row)=>row.cells[ci].colSpan === 0)) continue;
                // Skip processing if the cell is hidden
                if (rows[ri].cells[ci].colSpan === 0 || rows[ri].cells[ci].rowSpan === 0) continue;
                // Get text parts of the cell
                const cellTextParts = getTextFromT(rows[ri].cells[ci].replacedText ?? rows[ri].cells[ci].text);
                // React if found
                if (replacement && cellTextParts.some((t)=>t.includes(replacement.oldText))) {
                    const targetCell = rows[ri].cells[ci];
                    found = true;
                    const repeatSpan = Math.max(...rows.slice(ri).map((r)=>r.cells[ci].colSpan));
                    let midRows = rows.slice(ri).map((r)=>{
                        return {
                            aitid: r.aitid,
                            cells: [],
                            coreTrafficLight: r.coreTrafficLight,
                            templateAitId: r.templateAitId,
                            annotation: r.annotation
                        };
                    });
                    let midRepeats = [];
                    // Cycle through reach replacement value
                    for(let rvi = 0; rvi < replacement.newTexts.length; rvi++){
                        const rv = replacement.newTexts[rvi];
                        // Process sublist
                        const lowerQuad = rows.slice(ri + 1).map((r)=>{
                            return {
                                aitid: r.aitid,
                                cells: r.cells.slice(ci, ci + repeatSpan),
                                coreTrafficLight: r.coreTrafficLight,
                                templateAitId: r.templateAitId,
                                annotation: r.annotation
                            };
                        });
                        const nextReplacement = (0, $dGStb.flattenReplacements)(rv.subLists, externalLists, blankT);
                        const { newHeaderRows: lowerProcessed, newColumnRepeats: lowerColumnRepeats } = $b8126129c31adf80$export$e3af655bc6f14763(0, lowerQuad, lowerQuad.length > 0 && lowerQuad[0].cells.length > 0 ? Array.from(lowerQuad[0].cells.keys()).map((n)=>{
                            return {
                                columnIndex: n
                            };
                        }) : [], defaultCellWidth, getTextFromT, replaceTextInT, blankT, nextReplacement);
                        // Perform replacements for each text entry
                        for(let ti = 0; ti < rv.texts.length; ti++){
                            const thisRepeat = (0, $gKnse.replaceCellText)(targetCell, replacement.oldText, rv.texts[ti], replaceTextInT);
                            // Expand to cover all lower columns
                            if (lowerProcessed.length > 0 && lowerProcessed[0].cells.length > repeatSpan) thisRepeat.repeatColSpan = lowerProcessed[0].cells.length + repeatSpan - targetCell.colSpan;
                            // Add into mid cells
                            const targetRow = {
                                aitid: rows[ri].aitid,
                                cells: [
                                    thisRepeat
                                ],
                                coreTrafficLight: rows[ri].coreTrafficLight,
                                templateAitId: rows[ri].templateAitId,
                                annotation: rows[ri].annotation
                            };
                            // Add usual trailing cells
                            if (thisRepeat.colSpan > 1) targetRow.cells.push(...rows[ri].cells.slice(ci + 1, ci + targetCell.colSpan));
                            // Add new blank cells
                            if (thisRepeat.colSpan !== undefined && thisRepeat.repeatColSpan !== undefined && thisRepeat.repeatColSpan > thisRepeat.colSpan) {
                                const nIns = thisRepeat.repeatColSpan - thisRepeat.colSpan;
                                for(let nci = 0; nci < nIns; nci++){
                                    const n = (0, $iIj1X.newHeaderCell)(defaultCellWidth, blankT, targetCell.columnId);
                                    n.colSpan = 0;
                                    n.repeatColSpan = 0;
                                    targetRow.cells.push(n);
                                }
                            }
                            // Add extra cells covered by repeatSpan
                            if (repeatSpan > targetCell.colSpan) targetRow.cells.push(...rows[ri].cells.slice(ci + targetCell.colSpan, ci + repeatSpan));
                            // Add this repeat into the output
                            midRows = (0, $dtJ3W.appendCells)(midRows, [
                                targetRow,
                                ...lowerProcessed
                            ]);
                            // Work out new repeat for this cell
                            if (lowerColumnRepeats.length > 0) midRepeats = [
                                ...midRepeats,
                                ...lowerColumnRepeats.map((crep)=>{
                                    return {
                                        columnIndex: columnRepeats[ci].columnIndex + crep.columnIndex,
                                        colRepeat: `${columnRepeats[ci].colRepeat ?? ""}${`[${rvi},${ti}]${crep.colRepeat ?? ""}`}`
                                    };
                                })
                            ];
                            else midRepeats = [
                                ...midRepeats,
                                ...Array.from(Array(repeatSpan).keys()).map((n)=>{
                                    return {
                                        columnIndex: columnRepeats[ci + n].columnIndex,
                                        colRepeat: `${columnRepeats[ci].colRepeat ?? ""}${`[${rvi},${ti}]`}`
                                    };
                                })
                            ];
                        }
                    }
                    // Add full column
                    newHeaderRows = (0, $dtJ3W.appendCells)(newHeaderRows, rows.map((r, rj)=>{
                        // Return row above
                        if (rj < ri) return {
                            aitid: r.aitid,
                            cells: [
                                ...r.cells.slice(ci, ci + repeatSpan)
                            ],
                            coreTrafficLight: r.coreTrafficLight,
                            templateAitId: r.templateAitId,
                            annotation: r.annotation
                        };
                        else return {
                            aitid: r.aitid,
                            cells: midRows[rj - ri].cells,
                            coreTrafficLight: r.coreTrafficLight,
                            templateAitId: r.templateAitId,
                            annotation: r.annotation
                        };
                    }));
                    newColumnRepeats = [
                        ...newColumnRepeats,
                        ...midRepeats
                    ];
                    // Ensure that columns above cover the repeats
                    const nIns = midRows[0].cells.length - repeatSpan;
                    /* istanbul ignore else */ if (nIns > 0) {
                        // Number of cells to insert / colSpan to increase
                        for(let rj = ri - 1; rj >= 0; rj--){
                            let targetCellAbove = newHeaderRows[rj].cells[ci + addedCols];
                            // Update the target to have minimum repeatColSpan
                            /* istanbul ignore else */ if (targetCellAbove !== undefined) {
                                // Check that the target is showing
                                let lookup = 0;
                                // TODO: Remove this ignore
                                // istanbul ignore next
                                while(targetCellAbove.colSpan === 0 && lookup < ci){
                                    // Move to previous cell
                                    lookup++;
                                    targetCellAbove = rows[rj].cells[ci - lookup];
                                }
                                // Calculated new colSpan and add in fillers
                                targetCellAbove.repeatColSpan = (targetCellAbove.repeatColSpan ?? targetCellAbove.colSpan) + nIns;
                                const newCells2 = [];
                                for(let nci = 0; nci < nIns; nci++){
                                    const n = (0, $iIj1X.newHeaderCell)(defaultCellWidth, blankT, targetCellAbove.columnId);
                                    n.colSpan = 0;
                                    n.repeatColSpan = 0;
                                    newCells2.push(n);
                                }
                                newHeaderRows[rj].cells.splice(ci + addedCols - lookup + 1, 0, ...newCells2);
                            }
                        }
                        // Update number of columns added so far
                        addedCols = addedCols + nIns;
                    }
                    colsProcessed = repeatSpan;
                    break;
                }
            }
            // Append the row if it was not found on this pass
            if (!found) {
                newHeaderRows = (0, $dtJ3W.appendCells)(newHeaderRows, rows.map((r)=>{
                    return {
                        aitid: r.aitid,
                        cells: [
                            r.cells[ci]
                        ],
                        coreTrafficLight: r.coreTrafficLight,
                        templateAitId: r.templateAitId,
                        annotation: r.annotation
                    };
                }));
                newColumnRepeats = [
                    ...newColumnRepeats,
                    columnRepeats[ci]
                ];
            }
        }
    }
    return {
        newHeaderRows: newHeaderRows,
        newColumnRepeats: newColumnRepeats
    };
};

});
parcelRegister("dGStb", function(module, exports) {

$parcel$export(module.exports, "flattenReplacements", function () { return $19d6c22ade32894d$export$fc0ddbef0309c989; });

var $Dy1AI = parcelRequire("Dy1AI");

var $82xZo = parcelRequire("82xZo");

var $jBp7n = parcelRequire("jBp7n");
const $19d6c22ade32894d$export$fc0ddbef0309c989 = (reps, exts, blankT = "")=>{
    // Do nothing if there is nothing to do
    if (reps === undefined || reps.length === 0) return undefined;
    // Create holder
    let newRep = (0, $82xZo.newReplacement)(blankT);
    // Check append is ok
    reps.map((rep, repi)=>{
        // First update any external list
        const uEx = (0, $jBp7n.updateExternal)(rep, exts);
        const incoming = uEx;
        // First entry can be used as a base
        if (repi === 0) newRep = incoming;
        else newRep.newTexts = newRep.newTexts.map((nt)=>{
            return {
                ...nt,
                subLists: (0, $Dy1AI.appendReplacement)(incoming, nt.subLists)
            };
        });
        return true;
    });
    return newRep;
};

});
parcelRegister("Dy1AI", function(module, exports) {

$parcel$export(module.exports, "appendReplacement", function () { return $9672b5fb26528cdb$export$b032f7476d2f2712; });

var $gSkQi = parcelRequire("gSkQi");
const $9672b5fb26528cdb$export$b032f7476d2f2712 = (incoming, subLists)=>{
    let newSubLists = [];
    if (subLists === undefined || subLists.length === 0) newSubLists.push((0, $gSkQi.cloneDeep)(incoming));
    else newSubLists = subLists.map((s)=>{
        return {
            ...s,
            newTexts: s.newTexts.map((nt)=>{
                return {
                    ...nt,
                    subLists: $9672b5fb26528cdb$export$b032f7476d2f2712(incoming, nt.subLists)
                };
            })
        };
    });
    return newSubLists;
};

});

parcelRegister("82xZo", function(module, exports) {

$parcel$export(module.exports, "newReplacement", function () { return $e7761b8f71dfc325$export$b9e899552636205; });

var $haC0j = parcelRequire("haC0j");
const $e7761b8f71dfc325$export$b9e899552636205 = (blankT)=>{
    return {
        airid: crypto.randomUUID(),
        oldText: "",
        newTexts: [
            (0, $haC0j.newReplacementValues)(blankT)
        ],
        includeTrailing: false
    };
};

});
parcelRegister("haC0j", function(module, exports) {

$parcel$export(module.exports, "newReplacementValues", function () { return $b9d44ec115f7c944$export$ad5c2ff5b6cd676b; });
const $b9d44ec115f7c944$export$ad5c2ff5b6cd676b = (blankT)=>{
    return {
        airid: crypto.randomUUID(),
        texts: [
            blankT
        ],
        spaceAfter: false,
        subLists: []
    };
};

});



parcelRegister("dtJ3W", function(module, exports) {

$parcel$export(module.exports, "appendCells", function () { return $a6652fde560dcd38$export$222317b6d213f2f0; });
const $a6652fde560dcd38$export$222317b6d213f2f0 = (base, append)=>{
    return base.map((r, ri)=>{
        return {
            aitid: r.aitid,
            cells: [
                ...r.cells,
                ...append[ri].cells
            ],
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
    });
};

});

parcelRegister("gKnse", function(module, exports) {

$parcel$export(module.exports, "replaceCellText", function () { return $9be376dc437841ea$export$aa26aef3d93a492f; });

var $gSkQi = parcelRequire("gSkQi");
const $9be376dc437841ea$export$aa26aef3d93a492f = (cell, oldText, newText, replaceText)=>{
    const replacedText = replaceText(cell.replacedText ?? cell.text, oldText, newText);
    return {
        ...cell,
        replacedText: !(0, $gSkQi.isEqual)(cell.text, replacedText) ? replacedText : undefined
    };
};

});


parcelRegister("kCyUQ", function(module, exports) {

$parcel$export(module.exports, "singleReplacements", function () { return $f4ef02554ba9d6b6$export$2ae140bc64d582e5; });

var $gKnse = parcelRequire("gKnse");
function $f4ef02554ba9d6b6$export$2ae140bc64d582e5(externalSingles, newRows, replaceText) {
    if (externalSingles !== undefined && externalSingles.length > 0) externalSingles.forEach((e)=>{
        /* istanbul ignore else */ if (e.oldText !== "") newRows = newRows.map((r)=>{
            return {
                ...r,
                cells: r.cells.map((c)=>(0, $gKnse.replaceCellText)(c, e.oldText, e.newText, replaceText))
            };
        });
    });
    return newRows;
}

});


parcelRegister("7s2RK", function(module, exports) {

$parcel$export(module.exports, "repeatRows", function () { return $6312f4ddbfb295ef$export$aa13dffe14e158da; });

var $9YWkm = parcelRequire("9YWkm");

var $lDYsF = parcelRequire("lDYsF");

var $2htje = parcelRequire("2htje");

var $kCyUQ = parcelRequire("kCyUQ");
const $6312f4ddbfb295ef$export$aa13dffe14e158da = (rows, defaultCellWidth, getTextFromT, replaceTextInT, blankT, replacements, spaceAfter, tlfViewMode, externalLists, externalSingles)=>{
    // Create initial return
    let newRows = (0, $lDYsF.removeRowRepeatInfo)(rows);
    // Strip repeat data if flagged
    if (tlfViewMode?.noRepeatProcessing) {
        newRows[newRows.length - 1].spaceAfter = spaceAfter;
        return newRows;
    }
    // Process rows if there are replacements
    const extReplacements = (0, $9YWkm.updateExternals)(replacements, externalLists);
    // Check other spaceAfter if there are replacements
    if (extReplacements && extReplacements.length > 0) for(let si = 0; si < extReplacements.length; si++){
        // Data fix
        // istanbul ignore next
        if (si > 0 && extReplacements[si].includeTrailing) extReplacements[si].includeTrailing = false;
        // Run current replacement
        newRows = (0, $2htje.replaceRows)(newRows, defaultCellWidth, blankT, getTextFromT, replaceTextInT, extReplacements[si]);
    }
    // Add spaceAfter for the group
    /* istanbul ignore else */ if (spaceAfter) newRows[newRows.length - 1].spaceAfter = true;
    // Check row space after
    newRows.forEach((row)=>{
        if (row.cells.some((cell)=>cell.spaceAfterRepeat)) row.spaceAfter = true;
    });
    // Single post processing replacements
    newRows = (0, $kCyUQ.singleReplacements)(externalSingles, newRows, replaceTextInT);
    return newRows;
};

});
parcelRegister("2htje", function(module, exports) {

$parcel$export(module.exports, "replaceRows", function () { return $1e994624b9611284$export$3c20b2ff62792dc4; });

var $9YWkm = parcelRequire("9YWkm");
parcelRequire("2nuru");
var $8EK1C = parcelRequire("8EK1C");

var $gKnse = parcelRequire("gKnse");
const $1e994624b9611284$export$3c20b2ff62792dc4 = (rows, defaultCellWidth, blankT, getTextFromT, replaceTextInT, replacement, externalLists)=>{
    // Look for match, is there is one to find
    if (replacement === undefined || replacement.oldText === "" || replacement.newTexts.length === 0 || replacement.newTexts[0].texts.join("") === "") return rows;
    // Set up holders
    const newRows = [];
    let found = false;
    // Look through each cell
    let ri = 0;
    let processedRows = 0;
    let emergencyExit = 0;
    while(ri < rows.length && emergencyExit < 10000){
        // istanbul ignore next
        if (ri >= rows.length || rows[ri] === undefined || rows[ri].cells.length === undefined) {
            console.group("High ri value somehow");
            console.warn(`ri: ${ri}`);
            console.warn(`${JSON.stringify(rows)}`);
            console.groupEnd();
        } else for(let ci = 0; ci < rows[ri].cells.length && !found; ci++){
            const cellTextParts = getTextFromT(rows[ri].cells[ci].replacedText ?? rows[ri].cells[ci].text ?? blankT);
            if (replacement !== undefined && // Compare as non-HTML text
            cellTextParts.some((t)=>t.includes((0, $8EK1C.fromHtml)(replacement.oldText)))) {
                // Get targetCell
                found = true;
                const targetCell = rows[ri].cells[ci];
                const midRows = [];
                // Cycle through newTexts
                for(let rvi = 0; rvi < replacement.newTexts.length; rvi++){
                    const rv = replacement.newTexts[rvi];
                    // Perform replacements for each text entry
                    for(let ti = 0; ti < rv.texts.length; ti++){
                        const thisRepeat = (0, $gKnse.replaceCellText)(targetCell, replacement.oldText, rv.texts[ti], replaceTextInT);
                        // Process remaining cells, including target after replacement
                        let lowerQuad = replacement.includeTrailing ?? false ? rows.slice(ri).map((r, rj)=>{
                            const cells = rj === 0 ? [
                                thisRepeat,
                                ...r.cells.slice(ci + 1).map((c)=>(0, $gKnse.replaceCellText)(c, replacement.oldText, rv.texts[ti], replaceTextInT))
                            ] : [
                                ...r.cells.slice(ci).map((c)=>(0, $gKnse.replaceCellText)(c, replacement.oldText, rv.texts[ti], replaceTextInT))
                            ];
                            return {
                                aitid: r.aitid,
                                rowRepeat: `${r.rowRepeat ?? ""}${`[${rvi},${ti}]`}`,
                                cells: cells,
                                coreTrafficLight: r.coreTrafficLight,
                                templateAitId: r.templateAitId,
                                annotation: r.annotation
                            };
                        }) : [
                            {
                                aitid: rows[ri].aitid,
                                rowRepeat: `${rows[ri].rowRepeat ?? ""}${`[${rvi},${ti}]`}`,
                                cells: [
                                    thisRepeat,
                                    ...rows[ri].cells.slice(ci + 1).map((c)=>(0, $gKnse.replaceCellText)(c, replacement.oldText, rv.texts[ti], replaceTextInT))
                                ],
                                coreTrafficLight: rows[ri].coreTrafficLight,
                                templateAitId: rows[ri].templateAitId,
                                annotation: rows[ri].annotation
                            }
                        ];
                        // Find amount to move row cursor
                        processedRows = lowerQuad.length;
                        // Process lowerQuad if there are subLists
                        const subLists = (0, $9YWkm.updateExternals)(rv.subLists, externalLists);
                        if (subLists && subLists.length > 0) for(let si = 0; si < subLists.length; si++)lowerQuad = $1e994624b9611284$export$3c20b2ff62792dc4(lowerQuad, defaultCellWidth, blankT, getTextFromT, replaceTextInT, subLists[si]);
                        // Expand to cover rest of the row
                        midRows.push(...lowerQuad);
                        // Add spaceAfter to bottom left cell in the block
                        if (rv.spaceAfter) midRows[midRows.length - 1].cells[0].spaceAfterRepeat = true;
                    }
                }
                // Add preceeding cells from current row
                if (midRows.length > 0) midRows.forEach((r, ix)=>{
                    r.cells.splice(0, 0, ...rows[ri].cells.slice(0, ci).map((c)=>({
                            ...c,
                            replacedText: ix === 0 ? c.replacedText : "",
                            spaceAfterRepeat: c.spaceAfterRepeat && ix === midRows.length - 1
                        })));
                });
                // Add returned rows
                newRows.push(...midRows);
            }
        }
        // Add the row if it was not found on this pass
        if (!found) {
            newRows.push(rows[ri]);
            ri++;
        }
        if (found) {
            ri = ri + processedRows;
            found = false;
        }
        emergencyExit++;
    }
    return newRows;
};

});
parcelRegister("2nuru", function(module, exports) {
$parcel$export(module.exports, "checkName", function () { return (parcelRequire("kct4w")).checkName; });
$parcel$export(module.exports, "classMerge", function () { return (parcelRequire("cqVqv")).classMerge; });
$parcel$export(module.exports, "convertDateToLocaleString", function () { return (parcelRequire("lUIe4")).convertDateToLocaleString; });
$parcel$export(module.exports, "convertLocaleDateToUTCString", function () { return (parcelRequire("lUIe4")).convertLocaleDateToUTCString; });
$parcel$export(module.exports, "datasetToAnnotatedVariables", function () { return (parcelRequire("8u0AX")).datasetToAnnotatedVariables; });
$parcel$export(module.exports, "defaultEditorDefns", function () { return (parcelRequire("jP37Y")).defaultEditorDefns; });
$parcel$export(module.exports, "formatJson", function () { return (parcelRequire("aS1zf")).formatJson; });
$parcel$export(module.exports, "getFromDataPath", function () { return (parcelRequire("eAPMz")).getFromDataPath; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("eAPMz")).isString; });
$parcel$export(module.exports, "TLF_VIEW_MODES", function () { return (parcelRequire("gMkmM")).TLF_VIEW_MODES; });
$parcel$export(module.exports, "loadWrapper", function () { return (parcelRequire("30Ra3")).loadWrapper; });
$parcel$export(module.exports, "mapById", function () { return (parcelRequire("8FPZx")).mapById; });
$parcel$export(module.exports, "mutateByPath", function () { return (parcelRequire("dsPLF")).mutateByPath; });
$parcel$export(module.exports, "encodePath", function () { return (parcelRequire("1P8vv")).encodePath; });
$parcel$export(module.exports, "PauseCover", function () { return (parcelRequire("9eqKP")).PauseCover; });
$parcel$export(module.exports, "reduceDataPath", function () { return (parcelRequire("ci0ss")).reduceDataPath; });
$parcel$export(module.exports, "removeByPath", function () { return (parcelRequire("34cNk")).removeByPath; });
$parcel$export(module.exports, "setToUTCMidnight", function () { return (parcelRequire("iLcka")).setToUTCMidnight; });
$parcel$export(module.exports, "stringDateCheck", function () { return (parcelRequire("c72HK")).stringDateCheck; });
$parcel$export(module.exports, "stripDisallowedNameCharacters", function () { return (parcelRequire("9AhVX")).stripDisallowedNameCharacters; });
$parcel$export(module.exports, "fromHtml", function () { return (parcelRequire("8EK1C")).fromHtml; });
$parcel$export(module.exports, "toHtml", function () { return (parcelRequire("8EK1C")).toHtml; });
$parcel$export(module.exports, "valueFix", function () { return (parcelRequire("hQ7Qt")).valueFix; });
parcelRequire("kct4w");
parcelRequire("cqVqv");
parcelRequire("lUIe4");
parcelRequire("8u0AX");
parcelRequire("jP37Y");
parcelRequire("aS1zf");
parcelRequire("eAPMz");
parcelRequire("45bIq");
parcelRequire("52icS");
parcelRequire("gMkmM");
parcelRequire("30Ra3");
parcelRequire("8FPZx");
parcelRequire("dsPLF");
parcelRequire("1P8vv");
parcelRequire("9eqKP");
parcelRequire("ci0ss");
parcelRequire("34cNk");
parcelRequire("iLcka");
parcelRequire("3RLhI");
parcelRequire("c72HK");
parcelRequire("9AhVX");
parcelRequire("8EK1C");
parcelRequire("hQ7Qt");

});
parcelRegister("kct4w", function(module, exports) {

$parcel$export(module.exports, "checkName", function () { return $2c899dbbfd23f8e5$export$f7ed3bd26bb64653; });

var $9AhVX = parcelRequire("9AhVX");
const $2c899dbbfd23f8e5$export$f7ed3bd26bb64653 = async (_, target)=>{
    let valid = false;
    let validationText = "Not validated";
    if (target.value.trim() === "") {
        valid = false;
        validationText = "Name cannot be blank";
    } else if ((target.options?.existingValues ?? []).findIndex((s)=>s.trim().toLowerCase() === target.value.trim().toLowerCase()) >= 0) {
        valid = false;
        validationText = "This name is taken";
    } else if (target.value.match((0, $9AhVX.allowedNameCharactersPattern)) === null) {
        valid = false;
        validationText = "Only alphanumeric characters and -_ can be used";
    } else {
        valid = true;
        validationText = "Successfully validated";
    }
    return {
        success: true,
        data: {
            valid: valid,
            validationText: validationText
        }
    };
};

});
parcelRegister("9AhVX", function(module, exports) {

$parcel$export(module.exports, "allowedNameCharactersPattern", function () { return $e52906a03304ecb7$export$1da226a1c1989e36; });
$parcel$export(module.exports, "stripDisallowedNameCharacters", function () { return $e52906a03304ecb7$export$c319ba1644e8a90d; });
/**
 * Pattern that matches only characters allowed in ARS/hierarchy names: letters, digits,
 * underscores, and hyphens. Used both to validate names (see `checkName`) and to strip disallowed
 * characters from names before they are committed to state (see `stripDisallowedNameCharacters`).
 */ const $e52906a03304ecb7$export$1da226a1c1989e36 = /^[A-Za-z0-9_-]*$/;
const $e52906a03304ecb7$export$c319ba1644e8a90d = (value)=>value.replace(/[^A-Za-z0-9_-]/g, "");

});


parcelRegister("cqVqv", function(module, exports) {

$parcel$export(module.exports, "classMerge", function () { return $5a2d8691c78bc73f$export$ea666cc515e97dc4; });
/**
 * Merges multiple class names into a single string, ignoring undefined/blank values.
 *
 * @param classes - List of classes to merge
 * @returns A single string containing all valid class names
 */ function $5a2d8691c78bc73f$export$ea666cc515e97dc4(classes) {
    return classes.map((c)=>c?.trim()).filter(Boolean).join(" ");
}

});

parcelRegister("lUIe4", function(module, exports) {

$parcel$export(module.exports, "convertDateToLocaleString", function () { return $096cc4fd59226a15$export$886dc98a901f1d4f; });
$parcel$export(module.exports, "convertLocaleDateToUTCString", function () { return $096cc4fd59226a15$export$e50c52e1a45b9cde; });
/**
 * Converts a date or date string to a locale string.
 *
 * @param s - The string or date
 * @returns string
 */ const $096cc4fd59226a15$export$886dc98a901f1d4f = (s)=>{
    const d = s instanceof Date ? s : new Date(s);
    return !isNaN(d.getTime()) ? `${new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16).replace(/[T]/, " ")}` : "Invalid date";
};
const $096cc4fd59226a15$export$e50c52e1a45b9cde = (s)=>{
    const d = new Date(s);
    return d instanceof Date && !isNaN(d.getTime()) ? `${new Date(d.getTime()).toISOString()}` : "Invalid date";
};

});

parcelRegister("8u0AX", function(module, exports) {

$parcel$export(module.exports, "datasetToAnnotatedVariables", function () { return $945eb22dbfd09728$export$2556cc2a604b3767; });
function $945eb22dbfd09728$export$2556cc2a604b3767(dataset) {
    return dataset.clinicalVariables.map((variable)=>({
            value: `${dataset.name.trim()}.${variable.name.trim()}`,
            oid: variable.oid,
            name: variable.name,
            dataType: variable.dataType,
            length: parseInt(variable.length ?? "8", 10),
            description: variable.description,
            dataset: dataset.name,
            codeList: variable.clinicalCodeListId
        }));
}

});

parcelRegister("jP37Y", function(module, exports) {

$parcel$export(module.exports, "defaultEditorDefns", function () { return $d83782ffc318770d$export$a56bfc049012f820; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cqVqv = parcelRequire("cqVqv");

var $eAPMz = parcelRequire("eAPMz");
const $d83782ffc318770d$export$2e7dc17ee6bf4ebd = (props)=>{
    const [text, setText] = (0, $7fPBF.useState)();
    (0, $7fPBF.useEffect)(()=>{
        /* istanbul ignore else */ if (typeof props.value === "string") (0, $7fPBF.startTransition)(()=>setText(props.value));
    }, [
        props.value
    ]);
    if (typeof props.value !== "string") throw new Error("If newText is not a string, a custom function is required");
    const textAlign = props.textAlignment === "decimal" ? "center" : props.textAlignment === "default" ? "left" : props.textAlignment ?? "left";
    const inputProps = {
        "aria-label": props["aria-label"],
        "aria-labelledby": props["aria-labelledby"],
        className: (0, $cqVqv.classMerge)([
            "test-editor",
            props.className
        ]),
        disabled: !props.setValue || !props.editable,
        id: props.id,
        onBlur: ()=>props.setValue && props.setValue(text),
        onChange: (e)=>setText(e.currentTarget.value),
        style: {
            background: "transparent",
            border: "none",
            boxSizing: "border-box",
            padding: "4px 8px",
            textAlign: textAlign,
            width: "100%"
        },
        value: text ?? ""
    };
    return props.resize ? /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
        ...inputProps,
        "data-testid": `test-editor-${props.id}`
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
        ...inputProps,
        "data-testid": `test-editor-${props.id}`
    });
};
$d83782ffc318770d$export$2e7dc17ee6bf4ebd.displayName = "DefaultEditor";
/**
 * Check if the text in the test editor is a string
 *
 * @param o - The value to check
 */ const $d83782ffc318770d$var$checkTextInDefaultEditor = (o)=>typeof o === "string";
/**
 * Get text from the editor
 *
 * @param text - The text content to extract from the default editor
 */ const $d83782ffc318770d$var$getTextFromDefaultEditor = (text)=>{
    if (!$d83782ffc318770d$var$checkTextInDefaultEditor(text)) throw new Error("Update function when using an object for text");
    return [
        text
    ];
};
/**
 * Replace text in the editor
 *
 * @param s - The source string to perform replacement on
 * @param oldPhrase - The phrase to find and replace
 * @param newPhrase - The phrase to replace with
 */ const $d83782ffc318770d$var$replaceTextInDefaultEditor = (s, oldPhrase, newPhrase)=>{
    if (!$d83782ffc318770d$var$checkTextInDefaultEditor(s) || !$d83782ffc318770d$var$checkTextInDefaultEditor(newPhrase)) throw new Error("Update function when using an object for text");
    return s.replace(oldPhrase, newPhrase);
};
/**
 * Join lines into a block of text
 *
 * @param lines - The array of text lines to process
 */ const $d83782ffc318770d$var$joinDefaultEditorIntoBlock = (lines)=>{
    if (lines.some((line)=>!$d83782ffc318770d$var$checkTextInDefaultEditor(line))) throw new Error("Update function when using an object for text");
    return lines.join("\n");
};
/**
 * Split text into lines
 *
 * @param text - The text content to split into lines
 */ const $d83782ffc318770d$var$splitDefaultEditorIntoLines = (text)=>{
    if (!$d83782ffc318770d$var$checkTextInDefaultEditor(text)) throw new Error("Update function when using an object for text");
    return text.split("\n");
};
const $d83782ffc318770d$export$a56bfc049012f820 = {
    Editor: $d83782ffc318770d$export$2e7dc17ee6bf4ebd,
    blankT: "",
    getTextFromT: $d83782ffc318770d$var$getTextFromDefaultEditor,
    isT: (0, $eAPMz.isString),
    joinTintoBlock: $d83782ffc318770d$var$joinDefaultEditorIntoBlock,
    replaceTextInT: $d83782ffc318770d$var$replaceTextInDefaultEditor,
    splitTintoLines: $d83782ffc318770d$var$splitDefaultEditorIntoLines,
    textToT: (text)=>text
};
const $d83782ffc318770d$export$9e76654b4bc1019 = $d83782ffc318770d$export$a56bfc049012f820;

});
parcelRegister("eAPMz", function(module, exports) {

$parcel$export(module.exports, "getFromDataPath", function () { return $90faa0cf89912f24$export$fd69a3f4242d4d5d; });
$parcel$export(module.exports, "isString", function () { return $90faa0cf89912f24$export$844ec244b1367d54; });

var $6hWPd = parcelRequire("6hWPd");
const $90faa0cf89912f24$export$fd69a3f4242d4d5d = (dataPath, source, isFunction)=>{
    const pointer = (0, $6hWPd.Pointer).fromJSON(dataPath);
    const value = pointer.get(source);
    if (isFunction(value)) return value;
    return undefined;
};
const $90faa0cf89912f24$export$844ec244b1367d54 = (obj)=>typeof obj === "string";
const $90faa0cf89912f24$export$7e4aa119212bc614 = (obj)=>typeof obj === "number";
const $90faa0cf89912f24$export$f9ce7b637dfbe238 = (obj)=>typeof obj === "boolean";

});
parcelRegister("6hWPd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pointer = void 0;
module.exports.applyPatch = $4941f60e8b37af78$var$applyPatch;
module.exports.createPatch = $4941f60e8b37af78$var$createPatch;
module.exports.createTests = $4941f60e8b37af78$var$createTests;

var $bRGjh = parcelRequire("bRGjh");
Object.defineProperty(module.exports, "Pointer", {
    enumerable: true,
    get: function() {
        return $bRGjh.Pointer;
    }
});

var $ccPv5 = parcelRequire("ccPv5");

var $3cYaz = parcelRequire("3cYaz");
/**
Apply a 'application/json-patch+json'-type patch to an object.

`patch` *must* be an array of operations.

> Operation objects MUST have exactly one "op" member, whose value
> indicates the operation to perform.  Its value MUST be one of "add",
> "remove", "replace", "move", "copy", or "test"; other values are
> errors.

This method mutates the target object in-place.

@param object The object to apply the patch to
@param patch Array of operations to apply
@param options Optional customization of patch application behavior
@returns list of results, one for each operation: `null` indicated success,
         otherwise, the result will be an instance of one of the Error classes:
         MissingError, InvalidOperationError, or TestError.
*/ function $4941f60e8b37af78$var$applyPatch(object, patch, options) {
    return patch.map(function(operation) {
        return (0, $ccPv5.apply)(object, operation, options);
    });
}
function $4941f60e8b37af78$var$wrapVoidableDiff(diff) {
    function wrappedDiff(input, output, ptr) {
        var custom_patch = diff(input, output, ptr);
        // ensure an array is always returned
        return Array.isArray(custom_patch) ? custom_patch : (0, $3cYaz.diffAny)(input, output, ptr, wrappedDiff);
    }
    return wrappedDiff;
}
/**
Produce a 'application/json-patch+json'-type patch to get from one object to
another.

This does not alter `input` or `output` unless they have a property getter with
side-effects (which is not a good idea anyway).

`diff` is called on each pair of comparable non-primitive nodes in the
`input`/`output` object trees, producing nested patches. Return `undefined`
to fall back to default behaviour.

Returns list of operations to perform on `input` to produce `output`.
*/ function $4941f60e8b37af78$var$createPatch(input, output, diff) {
    var ptr = new $bRGjh.Pointer();
    // a new Pointer gets a default path of [''] if not specified
    return (diff ? $4941f60e8b37af78$var$wrapVoidableDiff(diff) : $3cYaz.diffAny)(input, output, ptr);
}
/**
Create a test operation based on `input`'s current evaluation of the JSON
Pointer `path`; if such a pointer cannot be resolved, returns undefined.
*/ function $4941f60e8b37af78$var$createTest(input, path) {
    var endpoint = $bRGjh.Pointer.fromJSON(path).evaluate(input);
    if (endpoint !== undefined) return {
        op: 'test',
        path: path,
        value: endpoint.value
    };
}
/**
Produce an 'application/json-patch+json'-type list of tests, to verify that
existing values in an object are identical to the those captured at some
checkpoint (whenever this function is called).

This does not alter `input` or `output` unless they have a property getter with
side-effects (which is not a good idea anyway).

Returns list of test operations.
*/ function $4941f60e8b37af78$var$createTests(input, patch) {
    var tests = new Array();
    patch.filter($3cYaz.isDestructive).forEach(function(operation) {
        var pathTest = $4941f60e8b37af78$var$createTest(input, operation.path);
        if (pathTest) tests.push(pathTest);
        if ('from' in operation) {
            var fromTest = $4941f60e8b37af78$var$createTest(input, operation.from);
            if (fromTest) tests.push(fromTest);
        }
    });
    return tests;
}

});
parcelRegister("bRGjh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pointer = void 0;
module.exports.unescapeToken = $8a3576d4cdcdcedd$var$unescapeToken;
module.exports.escapeToken = $8a3576d4cdcdcedd$var$escapeToken;
/**
Unescape token part of a JSON Pointer string

`token` should *not* contain any '/' characters.

> Evaluation of each reference token begins by decoding any escaped
> character sequence.  This is performed by first transforming any
> occurrence of the sequence '~1' to '/', and then transforming any
> occurrence of the sequence '~0' to '~'.  By performing the
> substitutions in this order, an implementation avoids the error of
> turning '~01' first into '~1' and then into '/', which would be
> incorrect (the string '~01' correctly becomes '~1' after
> transformation).

Here's my take:

~1 is unescaped with higher priority than ~0 because it is a lower-order escape character.
I say "lower order" because '/' needs escaping due to the JSON Pointer serialization technique.
Whereas, '~' is escaped because escaping '/' uses the '~' character.
*/ function $8a3576d4cdcdcedd$var$unescapeToken(token) {
    return token.replace(/~1/g, '/').replace(/~0/g, '~');
}
/** Escape token part of a JSON Pointer string

> '~' needs to be encoded as '~0' and '/'
> needs to be encoded as '~1' when these characters appear in a
> reference token.

This is the exact inverse of `unescapeToken()`, so the reverse replacements must take place in reverse order.
*/ function $8a3576d4cdcdcedd$var$escapeToken(token) {
    return token.replace(/~/g, '~0').replace(/\//g, '~1');
}
/**
JSON Pointer representation
*/ var $8a3576d4cdcdcedd$var$Pointer = /** @class */ function() {
    function Pointer(tokens) {
        if (tokens === void 0) tokens = [
            ''
        ];
        this.tokens = tokens;
    }
    /**
    `path` *must* be a properly escaped string.
    */ Pointer.fromJSON = function(path) {
        var tokens = path.split('/').map($8a3576d4cdcdcedd$var$unescapeToken);
        if (tokens[0] !== '') throw new Error("Invalid JSON Pointer: ".concat(path));
        return new Pointer(tokens);
    };
    Pointer.prototype.toString = function() {
        return this.tokens.map($8a3576d4cdcdcedd$var$escapeToken).join('/');
    };
    /**
    Returns an object with 'parent', 'key', and 'value' properties.
    In the special case that this Pointer's path == "",
    this object will be {parent: null, key: '', value: object}.
    Otherwise, parent and key will have the property such that parent[key] == value.
    */ Pointer.prototype.evaluate = function(object) {
        var parent = null;
        var key = '';
        var value = object;
        for(var i = 1, l = this.tokens.length; i < l; i++){
            parent = value;
            key = this.tokens[i];
            if (key == '__proto__' || key == 'constructor' || key == 'prototype') continue;
            // not sure if this the best way to handle non-existant paths...
            value = (parent || {})[key];
        }
        return {
            parent: parent,
            key: key,
            value: value
        };
    };
    Pointer.prototype.get = function(object) {
        return this.evaluate(object).value;
    };
    Pointer.prototype.set = function(object, value) {
        var endpoint = this.evaluate(object);
        if (endpoint.parent) endpoint.parent[endpoint.key] = value;
    };
    Pointer.prototype.push = function(token) {
        // mutable
        this.tokens.push(token);
    };
    /**
    `token` should be a String. It'll be coerced to one anyway.
  
    immutable (shallowly)
    */ Pointer.prototype.add = function(token) {
        var tokens = this.tokens.concat(String(token));
        return new Pointer(tokens);
    };
    /**
    Create a new Pointer representing the parent of this one.
  
    The parent of the empty pointer is the empty pointer.
  
    immutable (shallowly)
    */ Pointer.prototype.parent = function() {
        var tokens = this.tokens.length > 1 ? this.tokens.slice(0, -1) : [
            ''
        ];
        return new Pointer(tokens);
    };
    return Pointer;
}();
module.exports.Pointer = $8a3576d4cdcdcedd$var$Pointer;

});

parcelRegister("ccPv5", function(module, exports) {
"use strict";
var $8e2e8df38c64b23d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidOperationError = module.exports.TestError = module.exports.MissingError = void 0;
module.exports.add = $8e2e8df38c64b23d$var$add;
module.exports.remove = $8e2e8df38c64b23d$var$remove;
module.exports.replace = $8e2e8df38c64b23d$var$replace;
module.exports.move = $8e2e8df38c64b23d$var$move;
module.exports.copy = $8e2e8df38c64b23d$var$copy;
module.exports.test = $8e2e8df38c64b23d$var$test;
module.exports.apply = $8e2e8df38c64b23d$var$apply;

var $bRGjh = parcelRequire("bRGjh");

var $3htTN = parcelRequire("3htTN");

var $3cYaz = parcelRequire("3cYaz");
var $8e2e8df38c64b23d$var$MissingError = /** @class */ function(_super) {
    $8e2e8df38c64b23d$var$__extends(MissingError, _super);
    function MissingError(path) {
        var _this = _super.call(this, "Value required at path: ".concat(path)) || this;
        _this.path = path;
        _this.name = 'MissingError';
        return _this;
    }
    return MissingError;
}(Error);
module.exports.MissingError = $8e2e8df38c64b23d$var$MissingError;
var $8e2e8df38c64b23d$var$TestError = /** @class */ function(_super) {
    $8e2e8df38c64b23d$var$__extends(TestError, _super);
    function TestError(actual, expected) {
        var _this = _super.call(this, "Test failed: ".concat(actual, " != ").concat(expected)) || this;
        _this.actual = actual;
        _this.expected = expected;
        _this.name = 'TestError';
        return _this;
    }
    return TestError;
}(Error);
module.exports.TestError = $8e2e8df38c64b23d$var$TestError;
function $8e2e8df38c64b23d$var$_add(object, key, value) {
    if (Array.isArray(object)) {
        // `key` must be an index
        if (key == '-') object.push(value);
        else {
            var index = parseInt(key, 10);
            object.splice(index, 0, value);
        }
    } else object[key] = value;
}
function $8e2e8df38c64b23d$var$_remove(object, key) {
    if (Array.isArray(object)) {
        // '-' syntax doesn't make sense when removing
        var index = parseInt(key, 10);
        object.splice(index, 1);
    } else // not sure what the proper behavior is when path = ''
    delete object[key];
}
/**
>  o  If the target location specifies an array index, a new value is
>     inserted into the array at the specified index.
>  o  If the target location specifies an object member that does not
>     already exist, a new member is added to the object.
>  o  If the target location specifies an object member that does exist,
>     that member's value is replaced.
*/ function $8e2e8df38c64b23d$var$add(object, operation, options) {
    var pointer = $bRGjh.Pointer.fromJSON(operation.path);
    // Handle implicit array creation for terminal "/-" paths
    if ((options === null || options === void 0 ? void 0 : options.implicitArrayCreation) && pointer.tokens[pointer.tokens.length - 1] === '-') {
        // Try to evaluate the parent (the array itself)
        var parentEndpoint = pointer.parent().evaluate(object);
        // If the array property doesn't exist but its parent does,
        // and this parent is a plain object (not an array),
        // create an (empty) array that we will add to below.
        if (parentEndpoint.value === undefined && (0, $3htTN.objectType)(parentEndpoint.parent) === 'object') parentEndpoint.parent[parentEndpoint.key] = [];
    }
    var endpoint = pointer.evaluate(object);
    // it's not exactly a "MissingError" in the same way that `remove` is -- more like a MissingParent, or something
    if (endpoint.parent === undefined || endpoint.parent === null) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    // When using implicitArrayCreation, validate that "/-" targets are actually arrays
    if ((options === null || options === void 0 ? void 0 : options.implicitArrayCreation) && endpoint.key === '-' && !Array.isArray(endpoint.parent)) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    $8e2e8df38c64b23d$var$_add(endpoint.parent, endpoint.key, (0, $3htTN.clone)(operation.value));
    return null;
}
/**
> The "remove" operation removes the value at the target location.
> The target location MUST exist for the operation to be successful.
*/ function $8e2e8df38c64b23d$var$remove(object, operation, options) {
    // endpoint has parent, key, and value properties
    var endpoint = $bRGjh.Pointer.fromJSON(operation.path).evaluate(object);
    // the root pointer "" has no parent to remove from (mirrors `replace`)
    if (endpoint.parent === null) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    if (endpoint.value === undefined) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    $8e2e8df38c64b23d$var$_remove(endpoint.parent, endpoint.key);
    return null;
}
/**
> The "replace" operation replaces the value at the target location
> with a new value.  The operation object MUST contain a "value" member
> whose content specifies the replacement value.
> The target location MUST exist for the operation to be successful.

> This operation is functionally identical to a "remove" operation for
> a value, followed immediately by an "add" operation at the same
> location with the replacement value.

Even more simply, it's like the add operation with an existence check.
*/ function $8e2e8df38c64b23d$var$replace(object, operation, options) {
    var endpoint = $bRGjh.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === null) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    // this existence check treats arrays as a special case
    if (Array.isArray(endpoint.parent)) {
        if (parseInt(endpoint.key, 10) >= endpoint.parent.length) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    } else if (endpoint.value === undefined) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    endpoint.parent[endpoint.key] = (0, $3htTN.clone)(operation.value);
    return null;
}
/**
> The "move" operation removes the value at a specified location and
> adds it to the target location.
> The operation object MUST contain a "from" member, which is a string
> containing a JSON Pointer value that references the location in the
> target document to move the value from.
> This operation is functionally identical to a "remove" operation on
> the "from" location, followed immediately by an "add" operation at
> the target location with the value that was just removed.

> The "from" location MUST NOT be a proper prefix of the "path"
> location; i.e., a location cannot be moved into one of its children.
*/ function $8e2e8df38c64b23d$var$move(object, operation, options) {
    var from_pointer = $bRGjh.Pointer.fromJSON(operation.from);
    var from_endpoint = from_pointer.evaluate(object);
    if (from_endpoint.value === undefined) return new $8e2e8df38c64b23d$var$MissingError(operation.from);
    var pointer = $bRGjh.Pointer.fromJSON(operation.path);
    // a location cannot be moved into one of its own children; doing so would
    // detach the destination along with the value and silently lose data
    if (from_pointer.tokens.length < pointer.tokens.length && from_pointer.tokens.every(function(token, index) {
        return token === pointer.tokens[index];
    })) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    var endpoint = pointer.evaluate(object);
    if (endpoint.parent === undefined || endpoint.parent === null) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    $8e2e8df38c64b23d$var$_remove(from_endpoint.parent, from_endpoint.key);
    $8e2e8df38c64b23d$var$_add(endpoint.parent, endpoint.key, from_endpoint.value);
    return null;
}
/**
> The "copy" operation copies the value at a specified location to the
> target location.
> The operation object MUST contain a "from" member, which is a string
> containing a JSON Pointer value that references the location in the
> target document to copy the value from.
> The "from" location MUST exist for the operation to be successful.

> This operation is functionally identical to an "add" operation at the
> target location using the value specified in the "from" member.

Alternatively, it's like 'move' without the 'remove'.
*/ function $8e2e8df38c64b23d$var$copy(object, operation, options) {
    var from_endpoint = $bRGjh.Pointer.fromJSON(operation.from).evaluate(object);
    if (from_endpoint.value === undefined) return new $8e2e8df38c64b23d$var$MissingError(operation.from);
    var endpoint = $bRGjh.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === undefined || endpoint.parent === null) return new $8e2e8df38c64b23d$var$MissingError(operation.path);
    $8e2e8df38c64b23d$var$_add(endpoint.parent, endpoint.key, (0, $3htTN.clone)(from_endpoint.value));
    return null;
}
/**
> The "test" operation tests that a value at the target location is
> equal to a specified value.
> The operation object MUST contain a "value" member that conveys the
> value to be compared to the target location's value.
> The target location MUST be equal to the "value" value for the
> operation to be considered successful.
*/ function $8e2e8df38c64b23d$var$test(object, operation, options) {
    var endpoint = $bRGjh.Pointer.fromJSON(operation.path).evaluate(object);
    // TODO: this diffAny(...).length usage could/should be lazy
    if ((0, $3cYaz.diffAny)(endpoint.value, operation.value, new $bRGjh.Pointer()).length) return new $8e2e8df38c64b23d$var$TestError(endpoint.value, operation.value);
    return null;
}
var $8e2e8df38c64b23d$var$InvalidOperationError = /** @class */ function(_super) {
    $8e2e8df38c64b23d$var$__extends(InvalidOperationError, _super);
    function InvalidOperationError(operation) {
        var _this = _super.call(this, "Invalid operation: ".concat(operation.op)) || this;
        _this.operation = operation;
        _this.name = 'InvalidOperationError';
        return _this;
    }
    return InvalidOperationError;
}(Error);
module.exports.InvalidOperationError = $8e2e8df38c64b23d$var$InvalidOperationError;
/**
Switch on `operation.op`, applying the corresponding patch function for each
case to `object`.
*/ function $8e2e8df38c64b23d$var$apply(object, operation, options) {
    // not sure why TypeScript can't infer typesafety of:
    //   {add, remove, replace, move, copy, test}[operation.op](object, operation)
    // (seems like a bug)
    switch(operation.op){
        case 'add':
            return $8e2e8df38c64b23d$var$add(object, operation, options);
        case 'remove':
            return $8e2e8df38c64b23d$var$remove(object, operation, options);
        case 'replace':
            return $8e2e8df38c64b23d$var$replace(object, operation, options);
        case 'move':
            return $8e2e8df38c64b23d$var$move(object, operation, options);
        case 'copy':
            return $8e2e8df38c64b23d$var$copy(object, operation, options);
        case 'test':
            return $8e2e8df38c64b23d$var$test(object, operation, options);
    }
    return new $8e2e8df38c64b23d$var$InvalidOperationError(operation);
}

});
parcelRegister("3htTN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasOwnProperty = void 0;
module.exports.objectType = $263a26e9e4c96e8c$var$objectType;
module.exports.clone = $263a26e9e4c96e8c$var$clone;
module.exports.hasOwnProperty = Object.prototype.hasOwnProperty;
function $263a26e9e4c96e8c$var$objectType(object) {
    if (object === undefined) return 'undefined';
    if (object === null) return 'null';
    if (Array.isArray(object)) return 'array';
    return typeof object;
}
function $263a26e9e4c96e8c$var$isNonPrimitive(value) {
    // loose-equality checking for null is faster than strict checking for each of null/undefined/true/false
    // checking null first, then calling typeof, is faster than vice-versa
    return value != null && typeof value == 'object';
}
/**
Recursively copy a value.

@param source - should be a JavaScript primitive, Array, Date, or (plain old) Object.
@returns copy of source where every Array and Object have been recursively
         reconstructed from their constituent elements
*/ function $263a26e9e4c96e8c$var$clone(source) {
    if (!$263a26e9e4c96e8c$var$isNonPrimitive(source)) // short-circuiting is faster than a single return
    return source;
    // x.constructor == Array is the fastest way to check if x is an Array
    if (source.constructor == Array) {
        // construction via imperative for-loop is faster than source.map(arrayVsObject)
        var length = source.length;
        // setting the Array length during construction is faster than just `[]` or `new Array()`
        var arrayTarget = new Array(length);
        for(var i = 0; i < length; i++)arrayTarget[i] = $263a26e9e4c96e8c$var$clone(source[i]);
        return arrayTarget;
    }
    // Date
    if (source.constructor == Date) {
        var dateTarget = new Date(+source);
        return dateTarget;
    }
    // Object
    var objectTarget = {};
    // declaring the variable (with const) inside the loop is faster
    for(var key in source)// hasOwnProperty costs a bit of performance, but it's semantically necessary
    // using a global helper is MUCH faster than calling source.hasOwnProperty(key)
    if (module.exports.hasOwnProperty.call(source, key)) objectTarget[key] = $263a26e9e4c96e8c$var$clone(source[key]);
    return objectTarget;
}

});

parcelRegister("3cYaz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDestructive = $25612a7dbe8ee4ca$var$isDestructive;
module.exports.subtract = $25612a7dbe8ee4ca$var$subtract;
module.exports.intersection = $25612a7dbe8ee4ca$var$intersection;
module.exports.diffArrays = $25612a7dbe8ee4ca$var$diffArrays;
module.exports.diffObjects = $25612a7dbe8ee4ca$var$diffObjects;
module.exports.diffAny = $25612a7dbe8ee4ca$var$diffAny;

var $3htTN = parcelRequire("3htTN");
function $25612a7dbe8ee4ca$var$isDestructive(_a) {
    var op = _a.op;
    return op === 'remove' || op === 'replace' || op === 'copy' || op === 'move';
}
/**
List the keys in `minuend` that are not in `subtrahend`.

A key is only considered if it is both 1) an own-property (o.hasOwnProperty(k))
of the object, and 2) has a value that is not undefined. This is to match JSON
semantics, where JSON object serialization drops keys with undefined values.

@param minuend Object of interest
@param subtrahend Object of comparison
@returns Array of keys that are in `minuend` but not in `subtrahend`.
*/ function $25612a7dbe8ee4ca$var$subtract(minuend, subtrahend) {
    var keys = [];
    for(var key in minuend)if ($3htTN.hasOwnProperty.call(minuend, key) && minuend[key] !== undefined && !($3htTN.hasOwnProperty.call(subtrahend, key) && subtrahend[key] !== undefined)) keys.push(key);
    return keys;
}
/**
List the keys that shared by all `objects`.

The semantics of what constitutes a "key" is described in {@link subtract}.

@param objects Array of objects to compare
@returns Array of keys that are in ("own-properties" of) every object in `objects`.
*/ function $25612a7dbe8ee4ca$var$intersection(objects) {
    var length = objects.length;
    // prepare empty counter to keep track of how many objects each key occurred in
    var counter = {};
    // go through each object and increment the counter for each key in that object
    for(var i = 0; i < length; i++){
        var object = objects[i];
        for(var key in object)if ($3htTN.hasOwnProperty.call(object, key) && object[key] !== undefined) counter[key] = (counter[key] || 0) + 1;
    }
    // now delete all keys from the counter that were not seen in every object
    for(var key in counter)if (counter[key] < length) delete counter[key];
    // finally, extract whatever keys remain in the counter
    return Object.keys(counter);
}
/**
List the keys that shared by all `a` and `b`.

The semantics of what constitutes a "key" is described in {@link subtract}.

@param a First object to compare
@param b Second object to compare
@returns Array of keys that are in ("own-properties" of) `a` and `b`.
*/ function $25612a7dbe8ee4ca$var$intersection2(a, b) {
    var keys = [];
    for(var key in a)if ($3htTN.hasOwnProperty.call(a, key) && a[key] !== undefined && $3htTN.hasOwnProperty.call(b, key) && b[key] !== undefined) keys.push(key);
    return keys;
}
function $25612a7dbe8ee4ca$var$isArrayAdd(array_operation) {
    return array_operation.op === 'add';
}
function $25612a7dbe8ee4ca$var$isArrayRemove(array_operation) {
    return array_operation.op === 'remove';
}
function $25612a7dbe8ee4ca$var$appendArrayOperation(base, operation) {
    return {
        // the new operation must be pushed on the end
        operations: base.operations.concat(operation),
        cost: base.cost + 1
    };
}
/**
Calculate the shortest sequence of operations to get from `input` to `output`,
using a dynamic programming implementation of the Levenshtein distance algorithm.

To get from the input ABC to the output AZ we could just delete all the input
and say "insert A, insert Z" and be done with it. That's what we do if the
input is empty. But we can be smarter.

          output
               A   Z
               -   -
          [0]  1   2
input A |  1  [0]  1
      B |  2  [1]  1
      C |  3   2  [2]

1) start at 0,0 (+0)
2) keep A (+0)
3) remove B (+1)
4) replace C with Z (+1)

If the `input` (source) is empty, they'll all be in the top row, resulting in an
array of 'add' operations.
If the `output` (target) is empty, everything will be in the left column,
resulting in an array of 'remove' operations.

@returns A list of add/remove/replace operations.
*/ function $25612a7dbe8ee4ca$var$diffArrays(input, output, ptr, diff) {
    if (diff === void 0) diff = $25612a7dbe8ee4ca$var$diffAny;
    // set up cost matrix (very simple initialization: just a map)
    var max_length = Math.max(input.length, output.length);
    var memo = new Map([
        [
            0,
            {
                operations: [],
                cost: 0
            }
        ]
    ]);
    /**
    Calculate the cheapest sequence of operations required to get from
    input.slice(0, i) to output.slice(0, j).
    There may be other valid sequences with the same cost, but none cheaper.
  
    @param i The row in the layout above
    @param j The column in the layout above
    @returns An object containing a list of operations, along with the total cost
             of applying them (+1 for each add/remove/replace operation)
    */ function dist(i, j) {
        // memoized
        var memo_key = i * (max_length + 1) + j;
        var memoized = memo.get(memo_key);
        if (memoized === undefined) {
            // TODO: this !diff(...).length usage could/should be lazy
            if (i > 0 && j > 0 && !diff(input[i - 1], output[j - 1], ptr.add(String(i - 1))).length) // equal (no operations => no cost)
            memoized = dist(i - 1, j - 1);
            else {
                var alternatives = [];
                if (i > 0) {
                    // NOT topmost row
                    var remove_base = dist(i - 1, j);
                    var remove_operation = {
                        op: 'remove',
                        index: i - 1
                    };
                    alternatives.push($25612a7dbe8ee4ca$var$appendArrayOperation(remove_base, remove_operation));
                }
                if (j > 0) {
                    // NOT leftmost column
                    var add_base = dist(i, j - 1);
                    var add_operation = {
                        op: 'add',
                        index: i - 1,
                        value: output[j - 1]
                    };
                    alternatives.push($25612a7dbe8ee4ca$var$appendArrayOperation(add_base, add_operation));
                }
                if (i > 0 && j > 0) {
                    // TABLE MIDDLE
                    // supposing we replaced it, compute the rest of the costs:
                    var replace_base = dist(i - 1, j - 1);
                    // okay, the general plan is to replace it, but we can be smarter,
                    // recursing into the structure and replacing only part of it if
                    // possible, but to do so we'll need the original value
                    var replace_operation = {
                        op: 'replace',
                        index: i - 1,
                        original: input[i - 1],
                        value: output[j - 1]
                    };
                    alternatives.push($25612a7dbe8ee4ca$var$appendArrayOperation(replace_base, replace_operation));
                }
                // the only other case, i === 0 && j === 0, has already been memoized
                // the meat of the algorithm:
                // sort by cost to find the lowest one (might be several ties for lowest)
                // [4, 6, 7, 1, 2].sort((a, b) => a - b) -> [ 1, 2, 4, 6, 7 ]
                var best = alternatives.sort(function(a, b) {
                    return a.cost - b.cost;
                })[0];
                memoized = best;
            }
            memo.set(memo_key, memoized);
        }
        return memoized;
    }
    // handle weird objects masquerading as Arrays that don't have proper length
    // properties by using 0 for everything but positive numbers
    var input_length = isNaN(input.length) || input.length <= 0 ? 0 : input.length;
    var output_length = isNaN(output.length) || output.length <= 0 ? 0 : output.length;
    var array_operations = dist(input_length, output_length).operations;
    var padded_operations = array_operations.reduce(function(_a, array_operation) {
        var operations = _a[0], padding = _a[1];
        if ($25612a7dbe8ee4ca$var$isArrayAdd(array_operation)) {
            var padded_index = array_operation.index + 1 + padding;
            var index_token = padded_index < input_length + padding ? String(padded_index) : '-';
            var operation = {
                op: array_operation.op,
                path: ptr.add(index_token).toString(),
                value: array_operation.value
            };
            // padding++ // maybe only if array_operation.index > -1 ?
            return [
                operations.concat(operation),
                padding + 1
            ];
        } else if ($25612a7dbe8ee4ca$var$isArrayRemove(array_operation)) {
            var operation = {
                op: array_operation.op,
                path: ptr.add(String(array_operation.index + padding)).toString()
            };
            // padding--
            return [
                operations.concat(operation),
                padding - 1
            ];
        } else {
            var replace_ptr = ptr.add(String(array_operation.index + padding));
            var replace_operations = diff(array_operation.original, array_operation.value, replace_ptr);
            return [
                operations.concat.apply(operations, replace_operations),
                padding
            ];
        }
    }, [
        [],
        0
    ])[0];
    return padded_operations;
}
function $25612a7dbe8ee4ca$var$diffObjects(input, output, ptr, diff) {
    if (diff === void 0) diff = $25612a7dbe8ee4ca$var$diffAny;
    // if a key is in input but not output -> remove it
    var operations = [];
    $25612a7dbe8ee4ca$var$subtract(input, output).forEach(function(key) {
        operations.push({
            op: 'remove',
            path: ptr.add(key).toString()
        });
    });
    // if a key is in output but not input -> add it
    $25612a7dbe8ee4ca$var$subtract(output, input).forEach(function(key) {
        operations.push({
            op: 'add',
            path: ptr.add(key).toString(),
            value: output[key]
        });
    });
    // if a key is in both, diff it recursively
    $25612a7dbe8ee4ca$var$intersection2(input, output).forEach(function(key) {
        operations.push.apply(operations, diff(input[key], output[key], ptr.add(key)));
    });
    return operations;
}
/**
`diffAny()` returns an empty array if `input` and `output` are materially equal
(i.e., would produce equivalent JSON); otherwise it produces an array of patches
that would transform `input` into `output`.

> Here, "equal" means that the value at the target location and the
> value conveyed by "value" are of the same JSON type, and that they
> are considered equal by the following rules for that type:
> o  strings: are considered equal if they contain the same number of
>    Unicode characters and their code points are byte-by-byte equal.
> o  numbers: are considered equal if their values are numerically
>    equal.
> o  arrays: are considered equal if they contain the same number of
>    values, and if each value can be considered equal to the value at
>    the corresponding position in the other array, using this list of
>    type-specific rules.
> o  objects: are considered equal if they contain the same number of
>    members, and if each member can be considered equal to a member in
>    the other object, by comparing their keys (as strings) and their
>    values (using this list of type-specific rules).
> o  literals (false, true, and null): are considered equal if they are
>    the same.
*/ function $25612a7dbe8ee4ca$var$diffAny(input, output, ptr, diff) {
    if (diff === void 0) diff = $25612a7dbe8ee4ca$var$diffAny;
    // strict equality handles literals, numbers, and strings (a sufficient but not necessary cause)
    if (input === output) return [];
    var input_type = (0, $3htTN.objectType)(input);
    var output_type = (0, $3htTN.objectType)(output);
    if (input_type == 'array' && output_type == 'array') return $25612a7dbe8ee4ca$var$diffArrays(input, output, ptr, diff);
    if (input_type == 'object' && output_type == 'object') return $25612a7dbe8ee4ca$var$diffObjects(input, output, ptr, diff);
    // at this point we know that input and output are materially different;
    // could be array -> object, object -> array, boolean -> undefined,
    // number -> string, or some other combination, but nothing that can be split
    // up into multiple patches: so `output` must replace `input` wholesale.
    return [
        {
            op: 'replace',
            path: ptr.toString(),
            value: output
        }
    ];
}

});





parcelRegister("aS1zf", function(module, exports) {

$parcel$export(module.exports, "formatJson", function () { return $360e9bfc6b5e67ad$export$caaf42eec70aeca7; });
/**
 * Helper function to format a JSON string with specified indentation.
 *
 * @param input - The JSON input to format
 * @param indentation - The indentation level or string to use for formatting
 * @returns string
 */ const $360e9bfc6b5e67ad$export$caaf42eec70aeca7 = (input, indentation = 2)=>{
    try {
        const parsed = JSON.parse(input.trim());
        return JSON.stringify(parsed, null, indentation);
    } catch  {
        return input;
    }
};

});

parcelRegister("45bIq", function(module, exports) {

$parcel$export(module.exports, "getNestedValue", function () { return $02986495da52eac9$export$2516322ffbb7f3fb; });
/**
 * Gets or creates a nested value at the current path level for recursive operations.
 * If the existing value is an object or array, a copy is returned to maintain immutability.
 * Otherwise, a new object or array is created based on whether the next path part is numeric.
 *
 * @param obj - The current object or array being traversed.
 * @param firstPart - The current path part (property name or array index).
 * @param restParts - The remaining path parts.
 * @returns A copy of the nested value to recurse into, either copied or newly created.
 */ const $02986495da52eac9$export$2516322ffbb7f3fb = (obj, firstPart, restParts)=>{
    const existingValue = obj[firstPart];
    const nested = (typeof existingValue === "object" || Array.isArray(existingValue)) && existingValue !== null ? Array.isArray(existingValue) ? [
        ...existingValue
    ] : {
        ...existingValue
    } : /^\d+$/.test(restParts[0]) ? [] : {};
    return nested;
};

});

parcelRegister("52icS", function(module, exports) {

$parcel$export(module.exports, "getValidationOptions", function () { return $c826ddb3017877d3$export$6ba34a08af76995f; });
const $c826ddb3017877d3$export$6ba34a08af76995f = (input, values)=>typeof input.validationOptions === "function" ? input.validationOptions(values) : input.validationOptions;

});

parcelRegister("gMkmM", function(module, exports) {

$parcel$export(module.exports, "TLF_VIEW_MODES", function () { return $7277cf52e303d1d4$export$fbd78b4dd0bb31e2; });

var $7Wd8C = parcelRequire("7Wd8C");
const $7277cf52e303d1d4$export$fbd78b4dd0bb31e2 = [
    // The first value will be used as the default
    {
        value: "TLF",
        label: "TLF view"
    },
    {
        value: "ANNOTATIONS",
        label: "Annotations view"
    },
    {
        value: "SUPPRESS_REPEATS",
        label: "Suppress repeats",
        showOnlyForTlfTypes: new Set([
            (0, $7Wd8C.eTlfItemType).table,
            (0, $7Wd8C.eTlfItemType).listing
        ]),
        noRepeatProcessing: true
    },
    {
        value: "ARS_VIEW",
        label: "ARS view",
        showOnlyForTlfTypes: new Set([
            (0, $7Wd8C.eTlfItemType).arsListing,
            (0, $7Wd8C.eTlfItemType).arsTable
        ])
    }
];

});
parcelRegister("7Wd8C", function(module, exports) {

$parcel$export(module.exports, "eAccessLevel", function () { return $9c67977a66fdd02e$export$a80b30d56dd149b1; });
$parcel$export(module.exports, "eAccessRights", function () { return $9c67977a66fdd02e$export$4bec5847cb5ff3a; });
$parcel$export(module.exports, "eApplicationPermission", function () { return $9c67977a66fdd02e$export$d8ac1aa81292809d; });
$parcel$export(module.exports, "eHierarchy", function () { return $9c67977a66fdd02e$export$e7266695cf55e88a; });
$parcel$export(module.exports, "eHierarchyLevel", function () { return $9c67977a66fdd02e$export$5a585d9be59e92c4; });
$parcel$export(module.exports, "eLinkType", function () { return $9c67977a66fdd02e$export$e870f6113b70591b; });
$parcel$export(module.exports, "eReleaseStatus", function () { return $9c67977a66fdd02e$export$164fbd244bbd9b38; });
$parcel$export(module.exports, "eTlfItemType", function () { return $9c67977a66fdd02e$export$2ada4144fce9aac8; });
$parcel$export(module.exports, "eHistoryType", function () { return $9c67977a66fdd02e$export$b19998638fca5954; });
$parcel$export(module.exports, "eTlfOutputType", function () { return $9c67977a66fdd02e$export$39b5e962b0bc717b; });
$parcel$export(module.exports, "eShowTiFo", function () { return $9c67977a66fdd02e$export$f7aaabe3472f411a; });
$parcel$export(module.exports, "SearchableEditorBlocks", function () { return $9c67977a66fdd02e$export$850e61c9e6223cb4; });
var $9c67977a66fdd02e$export$a80b30d56dd149b1 = /*#__PURE__*/ function(eAccessLevel) {
    eAccessLevel["none"] = "No access";
    eAccessLevel["viewer"] = "Viewer";
    eAccessLevel["editor"] = "Editor";
    eAccessLevel["lead"] = "Lead";
    eAccessLevel["admin"] = "Admin";
    eAccessLevel["remove"] = "Remove rights";
    return eAccessLevel;
}({});
var $9c67977a66fdd02e$export$4bec5847cb5ff3a = /*#__PURE__*/ function(eAccessRights) {
    eAccessRights["CreateHierarchy"] = "CreateHierarchy";
    eAccessRights["DeleteHierarchy"] = "DeleteHierarchy";
    eAccessRights["DeleteReport"] = "DeleteReport";
    eAccessRights["MaintainHierarchy"] = "MaintainHierarchy";
    eAccessRights["MaintainHierarchyComments"] = "MaintainHierarchyComments";
    eAccessRights["MaintainHierarchyUsers"] = "MaintainHierarchyUsers";
    eAccessRights["ReadTlfItemsFromHierarchy"] = "ReadTlfItemsFromHierarchy";
    eAccessRights["WriteToTlfItemsInHierarchy"] = "WriteToTlfItemsInHierarchy";
    return eAccessRights;
}({});
var $9c67977a66fdd02e$export$d8ac1aa81292809d = /*#__PURE__*/ function(eApplicationPermission) {
    eApplicationPermission["AllowJsonDownload"] = "AllowJsonDownload";
    eApplicationPermission["AllowJsonUpload"] = "AllowJsonUpload";
    eApplicationPermission["AllowHelpEdit"] = "AllowHelpEdit";
    eApplicationPermission["AllowNewsEdit"] = "AllowNewsEdit";
    eApplicationPermission["AllowStudyStandardDateEdit"] = "AllowStudyStandardDateEdit";
    eApplicationPermission["UpdateStandardsSettings"] = "UpdateStandardsSettings";
    eApplicationPermission["AllowStyleManagement"] = "AllowStyleManagement";
    eApplicationPermission["AllowTextRuleManagement"] = "AllowTextRuleManagement";
    eApplicationPermission["AllowDefineXmlUpload"] = "AllowDefineXmlUpload";
    eApplicationPermission["ManageTlfTags"] = "ManageTlfTags";
    eApplicationPermission["EditAnalysisMethods"] = "EditAnalysisMethods";
    return eApplicationPermission;
}({});
var $9c67977a66fdd02e$export$e7266695cf55e88a = /*#__PURE__*/ function(eHierarchy) {
    eHierarchy["TopLevel"] = "TopLevel";
    eHierarchy["Directory"] = "Directory";
    eHierarchy["StudyDirectory"] = "StudyDirectory";
    eHierarchy["Report"] = "Report";
    return eHierarchy;
}({});
var $9c67977a66fdd02e$export$5a585d9be59e92c4 = /*#__PURE__*/ function(eHierarchyLevel) {
    eHierarchyLevel["TopLevel"] = "TopLevel";
    eHierarchyLevel["Corporate"] = "Corporate";
    eHierarchyLevel["TA"] = "TA";
    eHierarchyLevel["Project"] = "Project";
    eHierarchyLevel["Study"] = "Study";
    eHierarchyLevel["Report"] = "Report";
    return eHierarchyLevel;
}({});
var $9c67977a66fdd02e$export$e870f6113b70591b = /*#__PURE__*/ function(eLinkType) {
    eLinkType["CopiedFromTemplate"] = "CopiedFromTemplate";
    eLinkType["BasedOn"] = "BasedOn";
    eLinkType["HasVersion"] = "HasVersion";
    eLinkType["Successor"] = "Successor";
    eLinkType["Predecessor"] = "Predecessor";
    return eLinkType;
}({});
var $9c67977a66fdd02e$export$164fbd244bbd9b38 = /*#__PURE__*/ function(eReleaseStatus) {
    eReleaseStatus["Draft"] = "Draft";
    eReleaseStatus["ReleasePending"] = "ReleasePending";
    eReleaseStatus["Valid"] = "Valid";
    eReleaseStatus["DecommissingPending"] = "DecomissionPending";
    eReleaseStatus["Decommissioned"] = "Decommissioned";
    eReleaseStatus["RetirePending"] = "RetirePending";
    eReleaseStatus["Retired"] = "Retired";
    return eReleaseStatus;
}({});
var $9c67977a66fdd02e$export$2ada4144fce9aac8 = /*#__PURE__*/ function(eTlfItemType) {
    eTlfItemType["arsListing"] = "ArsListing";
    eTlfItemType["arsTable"] = "ArsTable";
    eTlfItemType["figure"] = "Figure";
    eTlfItemType["listing"] = "Listing";
    eTlfItemType["section"] = "Section";
    eTlfItemType["table"] = "Table";
    eTlfItemType["v1figure"] = "V1Figure";
    return eTlfItemType;
}({});
var $9c67977a66fdd02e$export$b19998638fca5954 = /*#__PURE__*/ function(eHistoryType) {
    eHistoryType["Created"] = "Created";
    eHistoryType["Updated"] = "Updated";
    eHistoryType["Released"] = "Released";
    eHistoryType["Decommissioned"] = "Decommissioned";
    eHistoryType["Deleted"] = "Deleted";
    eHistoryType["DeletionWithdrawn"] = "DeletionWithdrawn";
    eHistoryType["Retired"] = "Retired";
    return eHistoryType;
}({});
var $9c67977a66fdd02e$export$39b5e962b0bc717b = /*#__PURE__*/ function(eTlfOutputType) {
    eTlfOutputType["Docx"] = "docx";
    eTlfOutputType["Pdf"] = "pdf";
    eTlfOutputType["Rtf"] = "rtf";
    eTlfOutputType["Lst"] = "lst";
    return eTlfOutputType;
}({});
var $9c67977a66fdd02e$export$f7aaabe3472f411a = /*#__PURE__*/ function(eShowTiFo) {
    eShowTiFo["ToC"] = "ToC view";
    eShowTiFo["Titles"] = "Titles";
    eShowTiFo["Footnotes"] = "Footnotes";
    eShowTiFo["Comments"] = "Comments";
    eShowTiFo["ProgramInfo"] = "Program info";
    return eShowTiFo;
}({});
var $9c67977a66fdd02e$export$850e61c9e6223cb4 = /*#__PURE__*/ function(SearchableEditorBlocks) {
    SearchableEditorBlocks["Titles"] = "Titles";
    SearchableEditorBlocks["PageBy"] = "Page by";
    SearchableEditorBlocks["Footnotes"] = "Footnotes";
    SearchableEditorBlocks["TableHeaderData"] = "Table header";
    SearchableEditorBlocks["TableComments"] = "Table comments";
    SearchableEditorBlocks["TableBodyData"] = "Table body";
    SearchableEditorBlocks["TableBodyRowGroupComments"] = "Table body comments";
    SearchableEditorBlocks["StandardsNotes"] = "Standards notes";
    SearchableEditorBlocks["ProgrammerNotes"] = "Programmer notes";
    return SearchableEditorBlocks;
}({});

});


parcelRegister("30Ra3", function(module, exports) {

$parcel$export(module.exports, "loadWrapper", function () { return $69f17d0f750c8dc2$export$c7ac62050b844f22; });

var $gSkQi = parcelRequire("gSkQi");
async function $69f17d0f750c8dc2$export$c7ac62050b844f22(loadFunction, target, status, setStatus, backEndUrl, onProgress) {
    // Assume nothing is happening
    const doLoad = status.requesting && !(0, $gSkQi.isEqual)(status.requestingId, target) || !status.requesting && !(0, $gSkQi.isEqual)(status.requestedId, target);
    // Check there is a need to request
    if (doLoad && status.cancel) status.cancel();
    // Stop if hierarchy is less than zero or already requesting, or already errored
    if (doLoad && !status.error) {
        const controller = new AbortController();
        setStatus({
            requesting: true,
            requestingId: (0, $gSkQi.cloneDeep)(target),
            cancel: ()=>controller.abort(),
            error: false
        });
        const response = await loadFunction(backEndUrl, target, controller, onProgress);
        if (response.success) {
            setStatus({
                requesting: false,
                requestedId: (0, $gSkQi.cloneDeep)(target),
                error: false
            });
            return response;
        } else {
            console.warn(`LoadWrapper fail: ${response.errorText} from ${backEndUrl}/${JSON.stringify(target)}`);
            // Do nothing on a cancellation error
            /* istanbul ignore else */ if (!response.errorText?.toLocaleLowerCase().includes("request cancelled")) {
                setStatus({
                    requesting: false,
                    requestedId: (0, $gSkQi.cloneDeep)(target),
                    error: true,
                    errorText: response.errorText
                });
                return response;
            }
        }
    }
    return null;
}

});

parcelRegister("8FPZx", function(module, exports) {

$parcel$export(module.exports, "mapById", function () { return $bd300029e4a4b22e$export$513947f29ba0afbf; });
/**
 * Maps an array of ID-based items into a record keyed by item ID.
 *
 * @param items - Collection of ARS entities to index by ID.
 * @returns Record keyed by each entity ID.
 */ const $bd300029e4a4b22e$export$513947f29ba0afbf = (items)=>Object.fromEntries(items.map((item)=>[
            item.id,
            item
        ]));

});

parcelRegister("dsPLF", function(module, exports) {

$parcel$export(module.exports, "mutateByPath", function () { return $e8a84eeffcae2e83$export$d3634dfc1866e1d; });

var $45bIq = parcelRequire("45bIq");

var $1P8vv = parcelRequire("1P8vv");

var $3RLhI = parcelRequire("3RLhI");
const $e8a84eeffcae2e83$export$d3634dfc1866e1d = (obj, dataPath, newValue)=>{
    const { firstPart: firstPart, restParts: restParts } = (0, $1P8vv.parsePathParts)(dataPath);
    const isArray = Array.isArray(obj);
    const newObj = isArray ? [
        ...obj
    ] : {
        ...obj
    };
    if (restParts.length === 0) // Base case: last part, set the value
    (0, $3RLhI.setValueAtKey)(newObj, firstPart, newValue, isArray);
    else {
        // Recursive case: get or create the nested value (with copy) and recurse
        const nested = (0, $45bIq.getNestedValue)(obj, firstPart, restParts);
        const nextPath = (0, $1P8vv.joinPathParts)(restParts);
        const recursiveResult = $e8a84eeffcae2e83$export$d3634dfc1866e1d(nested, nextPath, newValue);
        (0, $3RLhI.setValueAtKey)(newObj, firstPart, recursiveResult, isArray);
    }
    return newObj;
};

});
parcelRegister("1P8vv", function(module, exports) {

$parcel$export(module.exports, "parsePathParts", function () { return $8eca8f90a5fdec3c$export$4ff252707494f8d1; });
$parcel$export(module.exports, "encodePath", function () { return $8eca8f90a5fdec3c$export$20c03ce31e68a433; });
$parcel$export(module.exports, "joinPathParts", function () { return $8eca8f90a5fdec3c$export$b7c2900d5da733e5; });
/**
 * Normalizes a JSON Pointer path and splits it into parts with RFC 6901 escape sequences decoded.
 *
 * @param dataPath - The RFC 6901 JSON Pointer path (e.g., "/a/b/c" or "/items/0").
 * @returns An object containing the normalized path parts and the first part separated from the rest.
 */ const $8eca8f90a5fdec3c$export$4ff252707494f8d1 = (dataPath)=>{
    const normalizedPath = dataPath.startsWith("/") ? dataPath.slice(1) : dataPath;
    const pathParts = normalizedPath.split("/").map((part)=>// Decode RFC 6901 escape sequences: ~1 -> /, ~0 -> ~
        part.replace(/~1/g, "/").replace(/~0/g, "~"));
    const [firstPart, ...restParts] = pathParts;
    return {
        firstPart: firstPart,
        restParts: restParts
    };
};
const $8eca8f90a5fdec3c$export$20c03ce31e68a433 = (path)=>{
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
};
const $8eca8f90a5fdec3c$export$b7c2900d5da733e5 = (parts)=>{
    return "/" + parts.map($8eca8f90a5fdec3c$export$20c03ce31e68a433).join("/");
};

});

parcelRegister("3RLhI", function(module, exports) {

$parcel$export(module.exports, "setValueAtKey", function () { return $7e6f8e0151c8bec4$export$3e9deff39cbbd85a; });
/**
 * Sets a value in an object or array, handling both string keys (for objects) and numeric indices (for arrays).
 *
 * @param target - The object or array to set the value in.
 * @param key - The property name or array index as a string.
 * @param value - The value to set.
 * @param isArray - Whether the target is an array.
 */ const $7e6f8e0151c8bec4$export$3e9deff39cbbd85a = (target, key, value, isArray)=>{
    if (isArray) {
        const index = parseInt(key, 10);
        /* istanbul ignore else - NaN index is a no-op, item remains unchanged */ if (!isNaN(index)) target[index] = value;
    } else target[key] = value;
};

});


parcelRegister("9eqKP", function(module, exports) {

$parcel$export(module.exports, "PauseCover", function () { return $6768d1f09c8d6d34$export$8860b6543868183a; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4WD1L = parcelRequire("4WD1L");
const $6768d1f09c8d6d34$export$8860b6543868183a = /*#__PURE__*/ (0, $7fPBF.forwardRef)(({ text: text, spinner: spinner = true, variant: variant }, coverRef)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 1,
            backgroundColor: "#ccc",
            opacity: "0.75",
            color: "--var(--bs-black)",
            borderRadius: "4px",
            border: "1px --var(--bs-dark) solid",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxHeight: "100%",
            cursor: "wait"
        },
        onClickCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        children: [
            spinner && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4WD1L.default), {
                animation: "border",
                "aria-label": "Please wait",
                size: "sm",
                variant: variant ?? "dark",
                style: {
                    alignSelf: "center"
                }
            }),
            text && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                ref: coverRef,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                    className: `text-${variant ?? "dark"} ms-2`,
                    children: text
                })
            })
        ]
    });
});
$6768d1f09c8d6d34$export$8860b6543868183a.displayName = "PauseCover";

});
parcelRegister("4WD1L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $399ada388bd30559$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $399ada388bd30559$var$Spinner = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$399ada388bd30559$var$Spinner.displayName = 'Spinner';
var $399ada388bd30559$export$2e2bcd8739ae039 = $399ada388bd30559$var$Spinner;

});
parcelRegister("jicu4", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("jbn4d", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", function () { return $df70f00bf051b623$export$7f387860ebffb32c; });
$parcel$export(module.exports, "useBootstrapBreakpoints", function () { return $df70f00bf051b623$export$8970c8db816a5863; });
$parcel$export(module.exports, "useBootstrapMinBreakpoint", function () { return $df70f00bf051b623$export$d926d6ef38f3fd32; });
$parcel$export(module.exports, "useIsRTL", function () { return $df70f00bf051b623$export$35e511eefa30ac5a; });

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $df70f00bf051b623$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $df70f00bf051b623$export$ff817e17bad2e091 = 'xs';
const $df70f00bf051b623$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext({
    prefixes: {},
    breakpoints: $df70f00bf051b623$export$666ad80b5007f835,
    minBreakpoint: $df70f00bf051b623$export$ff817e17bad2e091
});
const { Consumer: $df70f00bf051b623$export$b631efc24e9d5e2f, Provider: $df70f00bf051b623$var$Provider } = $df70f00bf051b623$var$ThemeContext;
function $df70f00bf051b623$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $df70f00bf051b623$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $df70f00bf051b623$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($df70f00bf051b623$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $df70f00bf051b623$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $7fPBF.useContext)($df70f00bf051b623$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $df70f00bf051b623$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $7fPBF.useContext)($df70f00bf051b623$var$ThemeContext);
    return breakpoints;
}
function $df70f00bf051b623$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $7fPBF.useContext)($df70f00bf051b623$var$ThemeContext);
    return minBreakpoint;
}
function $df70f00bf051b623$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $7fPBF.useContext)($df70f00bf051b623$var$ThemeContext);
    return dir === 'rtl';
}
function $df70f00bf051b623$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $7fPBF.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $df70f00bf051b623$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $df70f00bf051b623$export$2e2bcd8739ae039 = $df70f00bf051b623$var$ThemeProvider;

});



parcelRegister("ci0ss", function(module, exports) {

$parcel$export(module.exports, "reduceDataPath", function () { return $448154885e4de562$export$54a39e6c3d52a8a3; });
/**
 * Utility function to reduce a data path by a specified number of levels, used for targeting parent nodes in the table's bodyData structure.
 *
 * @param dataPath - The original data path string (e.g., "/columns/0/subGroups/1")
 * @param levels - The number of levels to reduce from the end of the path
 * @returns The reduced data path string (e.g., "/columns/0" if levels is 2)
 */ const $448154885e4de562$export$54a39e6c3d52a8a3 = (dataPath, levels)=>{
    const parts = dataPath.split("/").filter(Boolean);
    if (parts.length <= levels) return "";
    return "/" + parts.slice(0, -levels).join("/");
};

});

parcelRegister("34cNk", function(module, exports) {

$parcel$export(module.exports, "removeByPath", function () { return $4addd93c534ca502$export$ceab6855354994b2; });

var $45bIq = parcelRequire("45bIq");

var $1P8vv = parcelRequire("1P8vv");

var $3RLhI = parcelRequire("3RLhI");
const $4addd93c534ca502$export$ceab6855354994b2 = (obj, dataPath, newLength)=>{
    const { firstPart: firstPart, restParts: restParts } = (0, $1P8vv.parsePathParts)(dataPath);
    const isArray = Array.isArray(obj);
    if (restParts.length === 0) {
        // Base case: last part, remove the property
        if (isArray) {
            // Check new length if provided to prevent unintended removals
            if (newLength === undefined) throw new Error("newLength must be provided when removing an item from an array");
            else if (newLength !== obj.length - 1) return obj;
            else {
                const newArr = [
                    ...obj
                ];
                const index = parseInt(firstPart, 10);
                if (!isNaN(index) && index < obj.length && index >= 0) {
                    newArr.splice(index, 1);
                    return newArr;
                } else return obj;
            }
        } else {
            const newObj = {
                ...obj
            };
            if (firstPart in obj) {
                delete newObj[firstPart];
                return newObj;
            }
            // Return original object if the property does not exist
            return obj;
        }
    } else {
        // Recursive case: get or create the nested value (with copy) and recurse
        const existingValue = obj[firstPart];
        const newObj = isArray ? [
            ...obj
        ] : {
            ...obj
        };
        if (existingValue !== undefined) {
            const nested = (0, $45bIq.getNestedValue)(obj, firstPart, restParts);
            const nextPath = (0, $1P8vv.joinPathParts)(restParts);
            const recursiveResult = $4addd93c534ca502$export$ceab6855354994b2(nested, nextPath, newLength);
            (0, $3RLhI.setValueAtKey)(newObj, firstPart, recursiveResult, isArray);
        }
        return newObj;
    }
};

});

parcelRegister("iLcka", function(module, exports) {

$parcel$export(module.exports, "setToUTCMidnight", function () { return $e0297ab9eeb732bb$export$5932491ae1c7e059; });

var $lUIe4 = parcelRequire("lUIe4");
const $e0297ab9eeb732bb$export$5932491ae1c7e059 = (s, tomorrow)=>{
    const date = s instanceof Date ? s : new Date(s);
    if (!isNaN(date.getTime())) {
        /* istanbul ignore else */ if (tomorrow) date.setDate(date.getDate() + 1);
        date.setUTCHours(0, 0, 0, 0);
        return (0, $lUIe4.convertDateToLocaleString)(date);
    } else {
        console.warn(`Invalid date: ${s}`);
        return "";
    }
};

});

parcelRegister("c72HK", function(module, exports) {

$parcel$export(module.exports, "stringDateCheck", function () { return $6606d373a33e8b7d$export$ba21b05758a2af71; });
const $6606d373a33e8b7d$export$ba21b05758a2af71 = (date, options)=>{
    if (date === "" && !options?.blankBad) return {
        success: true,
        returnedDate: null,
        validationText: "No date"
    };
    else if (date === "") return {
        success: false,
        returnedDate: null,
        validationText: "Date missing"
    };
    else {
        const badDate = isNaN(Date.parse(date));
        /* istanbul ignore else */ if (badDate) return {
            success: false,
            validationText: "Invalid date"
        };
        const newDate = new Date(date);
        /* istanbul ignore else */ if (options?.pastBad && newDate < new Date()) return {
            success: false,
            validationText: "Cannot be in the past",
            returnedDate: newDate
        };
        /* istanbul ignore else */ if (options?.futureBad && newDate > new Date()) return {
            success: false,
            validationText: "Cannot be in the future",
            returnedDate: newDate
        };
        else return {
            success: true,
            validationText: `${newDate.toString()}`,
            returnedDate: newDate
        };
    }
};

});

parcelRegister("8EK1C", function(module, exports) {

$parcel$export(module.exports, "toHtml", function () { return $f9712b380bd05d23$export$a10125c086a4df16; });
$parcel$export(module.exports, "fromHtml", function () { return $f9712b380bd05d23$export$657711bc6c3b0a5b; });
/**
 * Converts a string to HTML entities.
 *
 * @param text - The text to convert.
 * @returns The converted HTML string.
 */ const $f9712b380bd05d23$export$a10125c086a4df16 = (text)=>text.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/≥/g, "&ge;").replace(/≤/g, "&le;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\n/g, "<br/>").replace(/\u00a0/g, "&nbsp;");
const $f9712b380bd05d23$export$657711bc6c3b0a5b = (text)=>text.replace(/&nbsp;/g, "\u00a0").replace(/<br\/>/g, "\n").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&le;/g, "\u2264").replace(/&ge;/g, "\u2265").replace(/&gt;/g, ">").replace(/&amp;/g, "&");

});

parcelRegister("hQ7Qt", function(module, exports) {

$parcel$export(module.exports, "valueFix", function () { return $0a95f16956e39915$export$c949713a1ce95c7e; });
/**
 * Fixes the value by trimming whitespace if specified.
 *
 * @param inString - The input string to process and format
 * @param trim - Whether to trim whitespace from the string
 */ const $0a95f16956e39915$export$c949713a1ce95c7e = (inString, trim)=>{
    let n = inString;
    /* istanbul ignore else */ if (trim) n = n.replace(/\s+/g, " ").trim();
    return n;
};

});





parcelRegister("gpwEh", function(module, exports) {

$parcel$export(module.exports, "trCanRemoveColSpan", function () { return $43758dc79ad9f81d$export$e52aa4c13a9232fe; });
$parcel$export(module.exports, "trRemoveColSpan", function () { return $43758dc79ad9f81d$export$eabc64b75793e7ef; });

var $fCWrt = parcelRequire("fCWrt");
const $43758dc79ad9f81d$export$e52aa4c13a9232fe = (headerData, location, newColSpan)=>{
    let reasonNot = "";
    let showCell;
    // Check target cell exists
    const targetCell = (0, $fCWrt.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        columnInformation: [],
        coreTrafficLight: "BlankNotEvaluated"
    }, location, true);
    if (targetCell === undefined) reasonNot = "RemoveColSpan: target cell not found";
    else if (targetCell.colSpan === newColSpan) reasonNot = "";
    else if (location.isRepeat) reasonNot = "RemoveColSpan: this is a repeat cell";
    else if (newColSpan < 1) reasonNot = "RemoveColSpan: col span cannot be reduced";
    else {
        const oldColSpan = targetCell.colSpan;
        // Get the cell to show
        showCell = headerData.rows[location.row]?.cells[location.originalColumn + oldColSpan - 1];
        if (showCell === undefined) reasonNot = "RemoveColSpan: show cell does not exist";
        else if (showCell.colSpan !== 0) reasonNot = "RemoveColSpan: show cell is not hidden";
    }
    return reasonNot !== "" ? {
        canRemove: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        showCell: showCell
    } : {
        canRemove: true,
        reasonNot: undefined,
        targetCell: targetCell,
        showCell: showCell
    };
};
const $43758dc79ad9f81d$export$eabc64b75793e7ef = (headerData, location, newSpan)=>{
    // Check if we can remove
    const { canRemove: canRemove, reasonNot: reasonNot, targetCell: targetCell, showCell: showCell } = $43758dc79ad9f81d$export$e52aa4c13a9232fe(headerData, location, newSpan);
    // Already done
    if (targetCell?.colSpan === newSpan) return;
    // Cannot remove
    if (!canRemove) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = newHeaderData.rows.map((row)=>{
        if (row.aitid !== location.rowId) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                colSpan: newSpan
            };
            if (cell.aitid === showCell.aitid) return {
                ...cell,
                colSpan: 1
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});

parcelRegister("3hAid", function(module, exports) {

$parcel$export(module.exports, "trRemoveColumn", function () { return $413df995e2b3d7f9$export$b837ed71e9eb942; });
const $413df995e2b3d7f9$export$b837ed71e9eb942 = (headerData, bodyData, cellIds)=>{
    let newHeaderData = headerData ? {
        ...headerData
    } : false;
    // Update header data
    if (newHeaderData !== false) newHeaderData = {
        ...newHeaderData,
        rows: newHeaderData.rows.map((r)=>{
            const newRow = {
                ...r
            };
            const newCells = [
                ...newRow.cells
            ];
            // Check for colSpan
            const c = newCells.find((c)=>cellIds.includes(c.aitid));
            /* istanbul ignore else */ if (c) {
                const columnIndex = newCells.indexOf(c);
                // Reduce where a hidden cell has been removed
                if (c.colSpan === 0) {
                    let lookBack = 1;
                    while(newCells[columnIndex - lookBack].colSpan === 0)lookBack++;
                    newCells[columnIndex - lookBack] = {
                        ...newCells[columnIndex - lookBack],
                        colSpan: newCells[columnIndex - lookBack].colSpan - 1
                    };
                } else if (c.colSpan > 1) for(let cj = 1; cj < c.colSpan; cj++)newCells[columnIndex + cj] = {
                    ...newCells[columnIndex + cj],
                    colSpan: 1
                };
                newCells.splice(columnIndex, 1);
            }
            return {
                ...newRow,
                cells: newCells
            };
        })
    };
    // Update body groups
    const newBodyData = bodyData.map((rg)=>{
        const newRg = {
            ...rg
        };
        newRg.rows = rg.rows.map((r)=>{
            const newRow = {
                ...r
            };
            // Remove cells that match the cellIds
            newRow.cells = newRow.cells.filter((c)=>!cellIds.includes(c.aitid));
            return newRow;
        });
        return newRg;
    });
    // Check each row is the same length
    const rowLength = bodyData[0].rows[0].cells.length;
    if (bodyData.some((rg)=>rg.rows.some((r)=>r.cells.length !== rowLength)) || headerData !== false && headerData.rows.some((r)=>r.cells.length !== rowLength)) throw new Error("Row lengths are not consistent after removing column");
    return {
        headerData: newHeaderData,
        bodyData: newBodyData
    };
};

});

parcelRegister("k56mL", function(module, exports) {

$parcel$export(module.exports, "trRemoveRow", function () { return $9e6f57759d05a3da$export$8697e7b3bc5752f8; });

var $feHBz = parcelRequire("feHBz");
const $9e6f57759d05a3da$export$8697e7b3bc5752f8 = (headerData, bodyData, location)=>{
    if (location.position === (0, $feHBz.AitTablePosition).headerRow && headerData !== false && headerData.rows.findIndex((row)=>row.aitid === location.rowId) > -1) {
        const ri = headerData.rows.findIndex((row)=>row.aitid === location.rowId);
        const newRows = [
            ...headerData.rows
        ];
        // Check cells for rowSpan
        newRows[ri].cells.forEach((c, ci)=>{
            // Found hidden cell
            if (c.rowSpan > 1) // Adjust the rowSpan of the cells below
            for(let i = 1; i < c.rowSpan; i++)newRows[ri + i].cells[ci].rowSpan = 1;
            // Found hidden cell
            if (c.rowSpan === 0) {
                let riUp = 1;
                let found = false;
                // Adjust the rowSpan of the cell above
                while(!found && riUp <= ri){
                    /* istanbul ignore else */ if (newRows[ri - riUp].cells[ci].rowSpan > 1) {
                        newRows[ri - riUp].cells[ci].rowSpan = newRows[ri - riUp].cells[ci].rowSpan - 1;
                        found = true;
                    }
                    riUp++;
                }
            }
        });
        // Remove the row
        newRows.splice(ri, 1);
        // Check that the bottom row has no colSpan
        if (ri === newRows.length && ri > 0) newRows[ri - 1].cells = newRows[ri - 1].cells.map((c)=>{
            c.colSpan = 1;
            return c;
        });
        return {
            headerData: newRows.length === 0 ? false : {
                ...headerData,
                rows: newRows
            }
        };
    } else if (location.position === (0, $feHBz.AitTablePosition).bodyRow && bodyData[location.rowGroup].rows.findIndex((row)=>row.aitid === location.rowId) > -1) {
        const ri = bodyData[location.rowGroup].rows.findIndex((row)=>row.aitid === location.rowId);
        const newBody = [
            ...bodyData
        ];
        const newRows = [
            ...newBody[location.rowGroup].rows
        ];
        newRows.splice(ri, 1);
        newBody[location.rowGroup] = {
            ...bodyData[location.rowGroup],
            rows: newRows
        };
        return {
            bodyData: newBody
        };
    }
    return {};
};

});

parcelRegister("ey1Zf", function(module, exports) {

$parcel$export(module.exports, "trCanRemoveRowSpan", function () { return $374c3f2d7688e5fe$export$584bbb513d75641; });
$parcel$export(module.exports, "trRemoveRowSpan", function () { return $374c3f2d7688e5fe$export$97909e0a16849ca2; });

var $fCWrt = parcelRequire("fCWrt");
const $374c3f2d7688e5fe$export$584bbb513d75641 = (headerData, location, newRowSpan)=>{
    let reasonNot = "";
    let showCell;
    // Check target cell exists
    const targetCell = (0, $fCWrt.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        coreTrafficLight: "BlankNotEvaluated",
        columnInformation: []
    }, location, true);
    if (targetCell === undefined) reasonNot = "RemoveRowSpan: target cell not found";
    else if (targetCell.rowSpan === newRowSpan) reasonNot = "";
    else if (location.isRepeat) reasonNot = "RemoveRowSpan: this is a repeat cell";
    else {
        // Calculated new row span
        const oldRowSpan = targetCell.rowSpan;
        if (newRowSpan < 1) reasonNot = "RemoveRowSpan: row span cannot be reduced";
        else {
            // Get the cell to show
            showCell = headerData.rows[location.row + oldRowSpan - 1]?.cells[location.originalColumn];
            if (showCell === undefined) reasonNot = "RemoveRowSpan: show cell does not exist";
            else if (showCell.rowSpan !== 0) reasonNot = "RemoveRowSpan: show cell is not hidden";
        }
    }
    return reasonNot !== "" ? {
        canRemove: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        showCell: showCell
    } : {
        canRemove: true,
        reasonNot: undefined,
        targetCell: targetCell,
        showCell: showCell
    };
};
const $374c3f2d7688e5fe$export$97909e0a16849ca2 = (headerData, location, newSpan)=>{
    const { canRemove: canRemove, reasonNot: reasonNot, targetCell: targetCell, showCell: showCell } = $374c3f2d7688e5fe$export$584bbb513d75641(headerData, location, newSpan);
    // Already updated
    if (targetCell?.rowSpan === newSpan) return;
    // Cannot remove
    if (!canRemove) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = headerData.rows.map((row)=>{
        if (row.aitid !== location.rowId && !row.cells.find((c)=>c.aitid === showCell.aitid)) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                rowSpan: newSpan
            };
            if (cell.aitid === showCell.aitid) return {
                ...cell,
                rowSpan: 1
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});

parcelRegister("6B5Zi", function(module, exports) {

$parcel$export(module.exports, "trUpdateColumnWidth", function () { return $30c985f9018552ab$export$c4c807c4c39aa044; });
const $30c985f9018552ab$export$c4c807c4c39aa044 = (table, colNo, colWidth)=>{
    const newHeaderData = table.headerData !== undefined && table.headerData !== false ? {
        ...table.headerData,
        rows: table.headerData.rows.map((r)=>({
                ...r,
                cells: r.cells.map((c, ci)=>({
                        ...c,
                        colWidth: ci === colNo ? colWidth : c.colWidth,
                        coreTrafficLight: "ChangedUnknown"
                    }))
            })),
        coreTrafficLight: "ChangedUnknown"
    } : table.headerData;
    const newBodyData = table.bodyData.map((rg)=>({
            ...rg,
            rows: rg.rows.map((r)=>({
                    ...r,
                    cells: r.cells.map((c, ci)=>({
                            ...c,
                            colWidth: ci === colNo ? colWidth : c.colWidth,
                            coreTrafficLight: "ChangedUnknown"
                        })),
                    coreTrafficLight: "ChangedUnknown"
                })),
            coreTrafficLight: "ChangedUnknown"
        }));
    return {
        headerData: newHeaderData,
        bodyData: newBodyData
    };
};

});

parcelRegister("euIy3", function(module, exports) {

$parcel$export(module.exports, "trUpdateComments", function () { return $71bcebde003a3c62$export$e3ed0b249227508f; });

var $feHBz = parcelRequire("feHBz");
const $71bcebde003a3c62$export$e3ed0b249227508f = (newState, action)=>{
    switch(action.location.position){
        case (0, $feHBz.AitTablePosition).table:
            // Update the comments in the tableData
            newState.originalTableData = {
                ...newState.originalTableData,
                comments: action.comment
            };
            break;
        case (0, $feHBz.AitTablePosition).header:
            // Update the comments in the headerData
            /* istanbul ignore else */ if (newState.originalTableData.headerData) newState.originalTableData = {
                ...newState.originalTableData,
                headerData: {
                    ...newState.originalTableData.headerData,
                    comments: action.comment
                }
            };
            break;
        case (0, $feHBz.AitTablePosition).headerCell:
            // Update the comments in the headerData
            /* istanbul ignore else */ if (newState.originalTableData.headerData) {
                const location = action.location;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: {
                        ...newState.originalTableData.headerData,
                        rows: newState.originalTableData.headerData.rows.map((row)=>({
                                ...row,
                                cells: row.cells.map((c)=>c.aitid === location.cellId ? {
                                        ...c,
                                        comments: action.comment
                                    } : c)
                            }))
                    }
                };
            }
            break;
        case (0, $feHBz.AitTablePosition).bodyRowGroup:
            {
                // Update the comments in the bodyData
                const location = action.location;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newState.originalTableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                            ...rowGroup,
                            comments: action.comment
                        } : rowGroup)
                };
                break;
            }
        case (0, $feHBz.AitTablePosition).bodyCell:
            {
                // Update the comments in the bodyData
                const location = action.location;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newState.originalTableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                            ...rowGroup,
                            rows: rowGroup.rows.map((row)=>row.aitid === location.rowId ? {
                                    ...row,
                                    cells: row.cells.map((c)=>c.aitid === location.cellId ? {
                                            ...c,
                                            comments: action.comment
                                        } : c)
                                } : row)
                        } : rowGroup)
                };
                break;
            }
    }
    return newState;
};

});




parcelRegister("fq9h5", function(module, exports) {

$parcel$export(module.exports, "AioDropSelect", function () { return $8fee20896adf6565$export$4a80a85fb7744798; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $5m3yv = parcelRequire("5m3yv");
const $8fee20896adf6565$export$4a80a85fb7744798 = ({ id: id, value: value, setValue: setValue, availableValues: availableValues, ...rest })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            ...rest,
            id: id,
            style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    id: `${id}-value`,
                    style: {
                        marginRight: "0.25rem"
                    },
                    "data-available-items": availableValues?.join(","),
                    children: value
                }),
                setValue && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                    id: `${id}-button`,
                    menuItems: availableValues?.map((s)=>({
                            label: s,
                            action: ()=>setValue(s)
                        }))
                })
            ]
        })
    });
};
$8fee20896adf6565$export$4a80a85fb7744798.displayName = "AioDropSelect";

});
parcelRegister("5m3yv", function(module, exports) {

$parcel$export(module.exports, "AioIconButton", function () { return $7a31ccffe60226d1$export$df2853518659514; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");
parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");
const $7a31ccffe60226d1$export$df2853518659514 = ({ id: id, onClick: onClick, iconName: iconName = "aioxDown", tipText: tipText, popUpTip: popUpTip = false, menuItems: menuItems, style: style })=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioButtonHolder,
        style: style,
        id: `${id}-holder`,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ClickForMenu), {
            className: (0, $cqVqv.classMerge)([
                (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioTip,
                (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexCenter
            ]),
            id: `${id}-menu`,
            menuItems: menuItems,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    id: id,
                    className: (0, $cqVqv.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m)))[iconName]
                    ]),
                    "aria-label": tipText,
                    title: tipText,
                    role: "button",
                    onClick: onClick
                }),
                popUpTip && tipText && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: (0, $cqVqv.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioTiptext,
                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioTipTop
                    ]),
                    children: tipText
                })
            ]
        })
    });
$7a31ccffe60226d1$export$df2853518659514.displayName = "AioIconButton";

});
parcelRegister("d8dTd", function(module, exports) {

$parcel$export(module.exports, "AutoHeight", function () { return $98f6cbe75d03e006$export$77bf000da9303d1; });
$parcel$export(module.exports, "ClickForMenu", function () { return $98f6cbe75d03e006$export$d4ebdd58e04c6ace; });
$parcel$export(module.exports, "ContextMenuHandler", function () { return $98f6cbe75d03e006$export$ed4f9641643dc7e4; });
$parcel$export(module.exports, "ContextWindow", function () { return $98f6cbe75d03e006$export$1af8984c69ba1b24; });
$parcel$export(module.exports, "useMouseMove", function () { return $98f6cbe75d03e006$export$f93615b9594453fc; });


var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
function $98f6cbe75d03e006$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $98f6cbe75d03e006$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $98f6cbe75d03e006$var$$b65191f6d0a0a991$exports = {};
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$b65191f6d0a0a991$exports, "AutoHeight", function() {
    return $98f6cbe75d03e006$export$77bf000da9303d1;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$b65191f6d0a0a991$exports, "ClickForMenu", function() {
    return $98f6cbe75d03e006$export$d4ebdd58e04c6ace;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$b65191f6d0a0a991$exports, "ContextMenu", function() {
    return $98f6cbe75d03e006$export$8dc6765e8be191c7;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$b65191f6d0a0a991$exports, "ContextMenuHandler", function() {
    return $98f6cbe75d03e006$export$ed4f9641643dc7e4;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$b65191f6d0a0a991$exports, "ContextWindow", function() {
    return $98f6cbe75d03e006$export$1af8984c69ba1b24;
});
var $98f6cbe75d03e006$var$$181673e3e0e596f3$exports = {};
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$181673e3e0e596f3$exports, "autoHeightInner", function() {
    return $98f6cbe75d03e006$var$$181673e3e0e596f3$export$df919f6b0f7f84e6;
}, function(v) {
    return $98f6cbe75d03e006$var$$181673e3e0e596f3$export$df919f6b0f7f84e6 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$181673e3e0e596f3$exports, "autoHeightWrapper", function() {
    return $98f6cbe75d03e006$var$$181673e3e0e596f3$export$563bd8f955c52746;
}, function(v) {
    return $98f6cbe75d03e006$var$$181673e3e0e596f3$export$563bd8f955c52746 = v;
});
var $98f6cbe75d03e006$var$$181673e3e0e596f3$export$df919f6b0f7f84e6;
var $98f6cbe75d03e006$var$$181673e3e0e596f3$export$563bd8f955c52746;
$98f6cbe75d03e006$var$$181673e3e0e596f3$export$df919f6b0f7f84e6 = `aiw-AutoHeight-module-pDlSVW-autoHeightInner`;
$98f6cbe75d03e006$var$$181673e3e0e596f3$export$563bd8f955c52746 = `aiw-AutoHeight-module-pDlSVW-autoHeightWrapper`;
function $98f6cbe75d03e006$export$77bf000da9303d1({ children: children, hide: hide = false, duration: duration = 300, ...rest }) {
    const wrapperRef = (0, $7fPBF.useRef)(null);
    const innerRef = (0, $7fPBF.useRef)(null);
    const [height, setHeight] = (0, $7fPBF.useState)(null);
    const [animationState, setAnimationState] = (0, $7fPBF.useState)(!hide ? "open" : "closed");
    const rafRef = (0, $7fPBF.useRef)(null);
    const timeoutRef = (0, $7fPBF.useRef)(null);
    const targetChildren = animationState === "closed" || !children ? null : children;
    const setTargetHeight = (0, $7fPBF.useEffectEvent)((newHeight)=>{
        setHeight(newHeight);
    });
    const transitionToOpening = (0, $7fPBF.useEffectEvent)(()=>{
        // Cancel any pending close timeout
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setAnimationState("opening");
        const id = window.requestAnimationFrame(()=>{
            rafRef.current = null;
            setTargetHeight(1);
            const frameId = window.requestAnimationFrame(()=>{
                const inner = innerRef.current;
                if (inner) {
                    setTargetHeight(inner.offsetHeight);
                    setAnimationState("open");
                }
            });
            rafRef.current = frameId;
        });
        rafRef.current = id;
    });
    const transitionToClosing = (0, $7fPBF.useEffectEvent)(()=>{
        // Cancel any pending RAF
        if (rafRef.current !== null) {
            cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        }
        setAnimationState("closing");
        setTargetHeight(1);
        timeoutRef.current = window.setTimeout(()=>{
            timeoutRef.current = null;
            setAnimationState("closed");
        }, duration);
    });
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (!hide) {
            if (animationState === "closed" || animationState === "closing") transitionToOpening();
        } else if (animationState === "open" || animationState === "opening") transitionToClosing();
    }, [
        hide,
        animationState
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const transition = innerRef.current;
        if (transition) {
            const observer = new ResizeObserver(()=>{
                if (animationState === "open") setTargetHeight(transition.offsetHeight);
            });
            observer.observe(transition);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        animationState
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            if (rafRef.current !== null) {
                cancelAnimationFrame(rafRef.current);
                rafRef.current = null;
            }
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);
    return (0, $bbzbN.jsx)("div", {
        ...rest,
        className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$181673e3e0e596f3$exports).autoHeightWrapper,
        ref: wrapperRef,
        style: {
            ...rest.style,
            display: animationState === "closed" ? "none" : undefined,
            height: height ? `${height}px` : "auto",
            transitionDuration: `${duration}ms`
        },
        children: (0, $bbzbN.jsx)("div", {
            className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$181673e3e0e596f3$exports).autoHeightInner,
            ref: innerRef,
            children: targetChildren
        })
    });
}
$98f6cbe75d03e006$export$77bf000da9303d1.displayName = "AutoHeight";
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$exports = {};
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "anchor", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$2e2992790a6f69a8;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$2e2992790a6f69a8 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "caretHolder", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "contextMenu", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$218b899e1d476006;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$218b899e1d476006 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "contextMenuHandler", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "contextMenuItem", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$e5ea51c279904378;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$e5ea51c279904378 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "contextMenuItemCheck", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "contextMenuItemLabel", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ada86c5b962aa22;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ada86c5b962aa22 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "disabled", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$683472f6198a076e;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$683472f6198a076e = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "hidden", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$73920f18ca706874;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$73920f18ca706874 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "subMenu", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports, "visible", function() {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$664c6d24e3175067;
}, function(v) {
    return $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$664c6d24e3175067 = v;
});
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$2e2992790a6f69a8;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$218b899e1d476006;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$e5ea51c279904378;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ada86c5b962aa22;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$683472f6198a076e;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$73920f18ca706874;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361;
var $98f6cbe75d03e006$var$$47067f35ca62d4a5$export$664c6d24e3175067;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$2e2992790a6f69a8 = `aiw-ContextMenu-module-WinFxq-anchor`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07 = `aiw-ContextMenu-module-WinFxq-caretHolder`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$218b899e1d476006 = `aiw-ContextMenu-module-WinFxq-contextMenu`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8 = `aiw-ContextMenu-module-WinFxq-contextMenuHandler`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$e5ea51c279904378 = `aiw-ContextMenu-module-WinFxq-contextMenuItem`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68 = `aiw-ContextMenu-module-WinFxq-contextMenuItemCheck`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6ada86c5b962aa22 = `aiw-ContextMenu-module-WinFxq-contextMenuItemLabel`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$683472f6198a076e = `aiw-ContextMenu-module-WinFxq-disabled`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$73920f18ca706874 = `aiw-ContextMenu-module-WinFxq-hidden`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361 = `aiw-ContextMenu-module-WinFxq-subMenu`;
$98f6cbe75d03e006$var$$47067f35ca62d4a5$export$664c6d24e3175067 = `aiw-ContextMenu-module-WinFxq-visible`;
const $98f6cbe75d03e006$var$$6ca59110355c8bf1$export$7e4e6110f96afd7e = ({ entries: entries, toClose: toClose, visible: visible })=>{
    return (0, $bbzbN.jsxs)("span", {
        className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).caretHolder,
        children: [
            (0, $bbzbN.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                viewBox: "0 0 16 16",
                children: (0, $bbzbN.jsx)("path", {
                    d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
                })
            }),
            visible && (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).subMenu,
                children: (0, $bbzbN.jsx)($98f6cbe75d03e006$export$8dc6765e8be191c7, {
                    visible: true,
                    entries: entries,
                    xPos: 14,
                    yPos: -21,
                    toClose: toClose
                })
            })
        ]
    });
};
$98f6cbe75d03e006$var$$6ca59110355c8bf1$export$7e4e6110f96afd7e.displayName = "ContextSubMenu";
const $98f6cbe75d03e006$var$$813754bb7a4251f1$export$c868ef28d2ba36f1 = ({ entry: entry, toClose: toClose })=>{
    const [target, setTarget] = (0, $7fPBF.useState)(null);
    const [subMenuVisible, setSubMenuVisible] = (0, $7fPBF.useState)(false);
    return (0, $bbzbN.jsxs)("div", {
        className: [
            /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).contextMenuItem,
            entry.disabled ? /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).disabled : ""
        ].filter((c)=>c !== "").join(" "),
        onMouseEnter: entry.group ? ()=>{
            setSubMenuVisible(true);
        } : undefined,
        onMouseLeave: entry.group ? ()=>{
            setSubMenuVisible(false);
        } : undefined,
        children: [
            (0, $bbzbN.jsx)("span", {
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).contextMenuItemCheck,
                "aria-hidden": "true",
                children: entry.selected ? entry.selectedIcon ?? "\u2713" : "\u00a0"
            }),
            typeof entry.label === "string" ? (0, $bbzbN.jsx)("span", {
                "aria-label": entry.label,
                "aria-disabled": entry.disabled,
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).contextMenuItemLabel,
                onMouseEnter: ()=>{
                    const sel = window.getSelection();
                    const target = sel && sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
                    setTarget(target);
                },
                onMouseLeave: ()=>{
                    setTarget(null);
                },
                onMouseDownCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    if (!entry.disabled) {
                        if (entry.action) entry.action(target, e);
                        toClose();
                    }
                },
                children: entry.label
            }) : entry.label,
            entry.group && (0, $bbzbN.jsx)($98f6cbe75d03e006$var$$6ca59110355c8bf1$export$7e4e6110f96afd7e, {
                toClose: toClose,
                entries: entry.group,
                visible: subMenuVisible
            })
        ]
    });
};
// Constants for menu size estimation when ref is not yet available
const $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_ITEM_HEIGHT = 34;
const $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING = 4;
const $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_WIDTH = 200;
const $98f6cbe75d03e006$export$8dc6765e8be191c7 = (0, $7fPBF.forwardRef)(({ visible: visible, entries: entries, xPos: xPos, yPos: yPos, toClose: toClose }, ref)=>{
    // Measure menu size after mount/render to avoid accessing refs during render
    const [menuHeight, setMenuHeight] = (0, $7fPBF.useState)(entries.length * $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_ITEM_HEIGHT + $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING);
    const [menuWidth, setMenuWidth] = (0, $7fPBF.useState)($98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_WIDTH);
    (0, $7fPBF.useLayoutEffect)(()=>{
        // Only measure when visible; ref access inside effect is allowed
        if (visible && ref && typeof ref !== "function" && ref.current instanceof HTMLDivElement) {
            setMenuHeight(ref.current.offsetHeight);
            setMenuWidth(ref.current.offsetWidth);
        }
        // When not visible, fall back to estimates
        if (!visible) {
            setMenuHeight(entries.length * $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_ITEM_HEIGHT + $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING);
            setMenuWidth($98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_WIDTH);
        }
    }, [
        visible,
        entries,
        ref
    ]);
    const adjustedYPos = yPos + menuHeight > window.innerHeight ? Math.max(window.innerHeight - menuHeight - $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING, 0) : yPos;
    const adjustedXPos = xPos + menuWidth > window.innerWidth ? Math.max(window.innerWidth - menuWidth - $98f6cbe75d03e006$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING, 0) : xPos;
    return (0, $bbzbN.jsx)("div", {
        ref: ref,
        className: [
            /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).contextMenu,
            visible ? /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).visible : /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).hidden
        ].filter((c)=>c !== "").join(" "),
        style: {
            top: `${adjustedYPos}px`,
            left: `${adjustedXPos}px`
        },
        onContextMenu: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        children: entries.map((entry, i)=>(0, $bbzbN.jsx)($98f6cbe75d03e006$var$$813754bb7a4251f1$export$c868ef28d2ba36f1, {
                entry: entry,
                toClose: toClose
            }, i))
    });
});
$98f6cbe75d03e006$export$8dc6765e8be191c7.displayName = "ContextMenu";
const $98f6cbe75d03e006$export$d4ebdd58e04c6ace = ({ id: id, menuItems: menuItems, children: children, ...rest })=>{
    // Menu state
    const [menuInDom, setMenuInDom] = (0, $7fPBF.useState)(false);
    const [menuVisible, setMenuVisible] = (0, $7fPBF.useState)(false);
    const [menuXPos, setMenuXPos] = (0, $7fPBF.useState)(0);
    const [menuYPos, setMenuYPos] = (0, $7fPBF.useState)(0);
    // Set up outsideClick handler
    const menuRef = (0, $7fPBF.useRef)(null);
    // Handle click off the menu
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleClick = (e)=>{
        if (menuRef.current && (e.target instanceof Element && !menuRef.current.contains(e.target) || !(e.target instanceof Element))) setMenuInDom(false);
    };
    const removeController = (0, $7fPBF.useRef)(null);
    const removeTimeoutRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!menuVisible && removeTimeoutRef.current === null) {
            // Only create a new controller when scheduling a new timeout
            if (removeController.current) removeController.current.abort();
            removeController.current = new AbortController();
            const controller = removeController.current;
            // Set up the timeout with a reference to the current controller
            removeTimeoutRef.current = setTimeout(()=>{
                if (!controller.signal.aborted) setMenuInDom(false);
                removeTimeoutRef.current = null;
            }, 300);
        }
        return ()=>{
            // Clean up on unmount or when menuVisible changes
            if (removeTimeoutRef.current) {
                clearTimeout(removeTimeoutRef.current);
                removeTimeoutRef.current = null;
            }
        };
    }, [
        menuVisible
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (menuInDom) document.addEventListener("mousedown", handleClick);
        return ()=>{
            document.removeEventListener("mousedown", handleClick);
            if (removeController.current) removeController.current.abort();
        };
    }, [
        handleClick,
        menuInDom
    ]);
    return (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            (0, $bbzbN.jsx)("div", {
                ...rest,
                id: id,
                onClick: (e)=>{
                    if (menuItems) {
                        setMenuInDom(true);
                        e.preventDefault();
                        e.stopPropagation();
                        setTimeout(()=>{
                            if (removeController.current) removeController.current.abort();
                            setMenuVisible(true);
                            setMenuXPos(e.pageX);
                            setMenuYPos(e.pageY);
                        }, 1);
                    } else rest.onClick?.(e);
                },
                children: children
            }),
            menuInDom && menuItems && (0, $fw0lo.createPortal)((0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).anchor,
                children: (0, $bbzbN.jsx)($98f6cbe75d03e006$export$8dc6765e8be191c7, {
                    visible: menuVisible,
                    ref: menuRef,
                    entries: menuItems,
                    xPos: menuXPos,
                    yPos: menuYPos,
                    toClose: ()=>{
                        setMenuVisible(false);
                        setMenuInDom(false);
                    }
                })
            }), document.body)
        ]
    });
};
$98f6cbe75d03e006$export$d4ebdd58e04c6ace.displayName = "ClickForMenu";
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$exports = {};
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "caretHolder", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "disabled", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$683472f6198a076e;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$683472f6198a076e = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "hidden", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$73920f18ca706874;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$73920f18ca706874 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "lowMenu", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$59e4b099a896b33;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$59e4b099a896b33 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "lowMenu-item", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$19fbf76b734bf310;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$19fbf76b734bf310 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "lowMenuButtonHolder", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$22ec12d194e0789c;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$22ec12d194e0789c = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "lowMenuItem", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$2ad34a478577e75d;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$2ad34a478577e75d = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "lowMenuItemCheck", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$507a880a74122b06;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$507a880a74122b06 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "subMenu", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports, "visible", function() {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$664c6d24e3175067;
}, function(v) {
    return $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$664c6d24e3175067 = v;
});
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$683472f6198a076e;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$73920f18ca706874;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$59e4b099a896b33;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$19fbf76b734bf310;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$22ec12d194e0789c;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$2ad34a478577e75d;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$507a880a74122b06;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361;
var $98f6cbe75d03e006$var$$c7a6ae87165004e6$export$664c6d24e3175067;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07 = `aiw-LowMenu-module-JfzGeq-caretHolder`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$683472f6198a076e = `aiw-LowMenu-module-JfzGeq-disabled`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$73920f18ca706874 = `aiw-LowMenu-module-JfzGeq-hidden`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$59e4b099a896b33 = `aiw-LowMenu-module-JfzGeq-lowMenu`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$19fbf76b734bf310 = `aiw-LowMenu-module-JfzGeq-lowMenu-item`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$22ec12d194e0789c = `aiw-LowMenu-module-JfzGeq-lowMenuButtonHolder`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$2ad34a478577e75d = `aiw-LowMenu-module-JfzGeq-lowMenuItem`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$507a880a74122b06 = `aiw-LowMenu-module-JfzGeq-lowMenuItemCheck`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361 = `aiw-LowMenu-module-JfzGeq-subMenu`;
$98f6cbe75d03e006$var$$c7a6ae87165004e6$export$664c6d24e3175067 = `aiw-LowMenu-module-JfzGeq-visible`;
const $98f6cbe75d03e006$var$$61945e5157f5e5bf$export$251b9f54013cdfac = ({ entry: entry })=>{
    const [visible, setVisible] = (0, $7fPBF.useState)(false);
    if (!entry.group || entry.group.length === 0) return (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    return (0, $bbzbN.jsxs)("span", {
        "aria-label": `Sub menu for ${entry.label}`,
        className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).caretHolder,
        onMouseEnter: ()=>{
            setVisible(true);
        },
        onMouseLeave: ()=>{
            setVisible(false);
        },
        children: [
            (0, $bbzbN.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                fill: "currentColor",
                viewBox: "0 0 16 16",
                children: (0, $bbzbN.jsx)("path", {
                    d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
                })
            }),
            (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).subMenu,
                children: visible && (0, $bbzbN.jsx)($98f6cbe75d03e006$export$8dc6765e8be191c7, {
                    visible: visible,
                    entries: entry.group,
                    xPos: 14,
                    yPos: entry.group.length * -21 - 8,
                    toClose: ()=>setVisible(false)
                })
            })
        ]
    });
};
$98f6cbe75d03e006$var$$61945e5157f5e5bf$export$251b9f54013cdfac.displayName = "LowSubMenu";
const $98f6cbe75d03e006$var$$556d6f9158abfc99$export$aafc28aea571c4bc = ({ entry: entry })=>{
    const [target, setTarget] = (0, $7fPBF.useState)(null);
    return (0, $bbzbN.jsxs)("div", {
        className: [
            /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).lowMenuItem,
            entry.disabled ? /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).disabled : ""
        ].filter((c)=>c !== "").join(" "),
        "aria-label": typeof entry.label === "string" ? entry.label : undefined,
        "aria-disabled": entry.disabled,
        onMouseEnter: ()=>{
            const sel = window.getSelection();
            const target = sel && sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
            setTarget(target);
        },
        onMouseLeave: ()=>{
            setTarget(null);
        },
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (!entry.disabled) entry.action?.(target);
        },
        children: [
            (0, $bbzbN.jsx)("span", {
                children: entry.label
            }),
            entry.selected && (0, $bbzbN.jsx)("span", {
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).lowMenuItemCheck,
                "aria-hidden": "true",
                children: entry.selectedIcon ?? "\u2713"
            }),
            entry.group && (0, $bbzbN.jsx)($98f6cbe75d03e006$var$$61945e5157f5e5bf$export$251b9f54013cdfac, {
                entry: entry
            })
        ]
    });
};
$98f6cbe75d03e006$var$$556d6f9158abfc99$export$aafc28aea571c4bc.displayName = "LowMenuButton";
const $98f6cbe75d03e006$var$$914758b0c9d59759$export$49e8edc8ebca5f25 = ({ entries: entries, visible: visible, xPos: xPos, yPos: yPos, maxWidth: maxWidth })=>{
    // Only show the low menu if it is on the screen
    if (xPos >= window.innerWidth || yPos >= window.innerHeight) return (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    // Show the menu
    return (0, $bbzbN.jsx)("div", {
        className: [
            /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).lowMenu,
            visible ? /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).visible : /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).hidden
        ].join(" "),
        "aria-label": "Low context menu",
        style: {
            left: `${xPos}px`,
            top: `${yPos}px`,
            maxWidth: `calc(${maxWidth}px)`,
            width: `calc(${maxWidth}px - 4px)`
        },
        children: (0, $bbzbN.jsx)("div", {
            className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$c7a6ae87165004e6$exports).lowMenuButtonHolder,
            children: entries.map((e, i)=>(0, $bbzbN.jsx)($98f6cbe75d03e006$var$$556d6f9158abfc99$export$aafc28aea571c4bc, {
                    entry: e
                }, i))
        })
    });
};
$98f6cbe75d03e006$var$$914758b0c9d59759$export$49e8edc8ebca5f25.displayName = "LowMenu";
const $98f6cbe75d03e006$var$$1e1c1e9e0b943830$export$fc58dc71afe92de2 = (0, $7fPBF.createContext)(null);
function $98f6cbe75d03e006$var$$1e1c1e9e0b943830$var$isDivider(label) {
    return typeof label !== "string" && label.type === "hr";
}
const $98f6cbe75d03e006$export$ed4f9641643dc7e4 = ({ children: children, menuItems: menuItems, showLowMenu: showLowMenu = false, ...rest })=>{
    // Check for higher content menu
    const higherContext = (0, $7fPBF.useContext)($98f6cbe75d03e006$var$$1e1c1e9e0b943830$export$fc58dc71afe92de2);
    const thisMenuItems = [
        ...higherContext !== null ? [
            ...higherContext.menuItems,
            ...[
                higherContext.menuItems.length > 0 && !$98f6cbe75d03e006$var$$1e1c1e9e0b943830$var$isDivider(higherContext.menuItems[higherContext.menuItems.length - 1].label) && menuItems.length > 0 && !$98f6cbe75d03e006$var$$1e1c1e9e0b943830$var$isDivider(menuItems[0].label) ? {
                    label: (0, $bbzbN.jsx)("hr", {
                        style: {
                            flexGrow: 1,
                            cursor: "none",
                            margin: "0",
                            padding: "0"
                        }
                    })
                } : null
            ].filter((item)=>item !== null)
        ] : [],
        ...menuItems
    ];
    // Menu resources
    const divHandlderRef = (0, $7fPBF.useRef)(null);
    const menuRef = (0, $7fPBF.useRef)(null);
    const [menuXPos, setMenuXPos] = (0, $7fPBF.useState)(0);
    const [menuYPos, setMenuYPos] = (0, $7fPBF.useState)(0);
    const [menuVisible, setMenuVisible] = (0, $7fPBF.useState)(false);
    const [menuInDom, setMenuInDom] = (0, $7fPBF.useState)(false);
    const [mouseOverHandlerDiv, setMouseOverHandlerDiv] = (0, $7fPBF.useState)(false);
    const [mouseOverMenu, setMouseOverMenu] = (0, $7fPBF.useState)(false);
    // Holder position - measured in an effect to avoid reading refs during render
    const [divHandlerPos, setDivHandlerPos] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useLayoutEffect)(()=>{
        function updatePos() {
            if (divHandlderRef.current) setDivHandlerPos(divHandlderRef.current.getBoundingClientRect());
        }
        // When the handler is hovered or the menu is mounted, ensure we have a fresh position
        if (mouseOverHandlerDiv || menuInDom) updatePos();
        // Attach listeners while the menu/low-menu may be visible so the position stays correct
        if (mouseOverHandlerDiv || menuInDom) {
            window.addEventListener("resize", updatePos);
            // listen on capture to catch scrolls from ancestor elements as well
            window.addEventListener("scroll", updatePos, true);
            let ro = null;
            if (typeof ResizeObserver !== "undefined" && divHandlderRef.current) {
                ro = new ResizeObserver(updatePos);
                ro.observe(divHandlderRef.current);
            }
            return ()=>{
                window.removeEventListener("resize", updatePos);
                window.removeEventListener("scroll", updatePos, true);
                if (ro) ro.disconnect();
            };
        }
    }, [
        mouseOverHandlerDiv,
        menuInDom
    ]);
    // Handle click off the menu
    const handleClick = (0, $7fPBF.useCallback)((e)=>{
        if (menuRef.current && (e.target instanceof Element && !menuRef.current?.contains(e.target) || !(e.target instanceof Element))) setMenuVisible(false);
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (menuVisible) document.addEventListener("mousedown", handleClick);
        return ()=>{
            document.removeEventListener("mousedown", handleClick);
        };
    }, [
        handleClick,
        menuVisible
    ]);
    const removeController = (0, $7fPBF.useRef)(new AbortController());
    (0, $7fPBF.useEffect)(()=>{
        if (!mouseOverMenu && !menuVisible && !mouseOverHandlerDiv) {
            removeController.current.abort();
            removeController.current = new AbortController();
            setTimeout(()=>{
                if (!removeController.current.signal.aborted) setMenuInDom(false);
            }, 300);
        }
    }, [
        mouseOverHandlerDiv,
        menuVisible,
        mouseOverMenu
    ]);
    return (0, $bbzbN.jsxs)($98f6cbe75d03e006$var$$1e1c1e9e0b943830$export$fc58dc71afe92de2.Provider, {
        value: {
            menuItems: thisMenuItems
        },
        children: [
            (0, $bbzbN.jsx)("div", {
                ref: divHandlderRef,
                ...rest,
                className: [
                    /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).contextMenuHandler,
                    rest.className
                ].join(" "),
                onContextMenu: async (e)=>{
                    if (!showLowMenu) {
                        setMenuInDom(true);
                        e.preventDefault();
                        e.stopPropagation();
                        setTimeout(()=>{
                            removeController.current.abort();
                            setMenuVisible(true);
                            setMenuXPos(e.pageX);
                            setMenuYPos(e.pageY);
                        }, 1);
                    }
                },
                onMouseEnter: async (e)=>{
                    if (showLowMenu) {
                        setMenuInDom(true);
                        setMouseOverHandlerDiv(false);
                        setTimeout(()=>{
                            removeController.current.abort();
                            setMouseOverHandlerDiv(true);
                        }, 1);
                    }
                    rest.onMouseEnter?.(e);
                },
                onMouseLeave: async (e)=>{
                    if (showLowMenu) {
                        removeController.current.abort();
                        removeController.current = new AbortController();
                        setMouseOverHandlerDiv(false);
                    }
                    rest.onMouseLeave?.(e);
                },
                children: children
            }),
            menuInDom && divHandlerPos && (0, $fw0lo.createPortal)((0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$47067f35ca62d4a5$exports).anchor,
                onMouseEnter: ()=>{
                    removeController.current.abort();
                    setMouseOverMenu(true);
                },
                onMouseLeave: ()=>{
                    removeController.current.abort();
                    removeController.current = new AbortController();
                    setMouseOverMenu(false);
                },
                children: showLowMenu ? (0, $bbzbN.jsx)($98f6cbe75d03e006$var$$914758b0c9d59759$export$49e8edc8ebca5f25, {
                    visible: mouseOverHandlerDiv,
                    entries: menuItems,
                    xPos: divHandlerPos.left,
                    yPos: divHandlerPos.bottom,
                    maxWidth: divHandlerPos.width
                }) : (0, $bbzbN.jsx)($98f6cbe75d03e006$export$8dc6765e8be191c7, {
                    visible: menuVisible,
                    ref: menuRef,
                    entries: thisMenuItems,
                    xPos: menuXPos,
                    yPos: menuYPos,
                    toClose: ()=>{
                        setMenuVisible(false);
                        setMouseOverMenu(false);
                    }
                })
            }), document.body)
        ]
    });
};
$98f6cbe75d03e006$export$ed4f9641643dc7e4.displayName = "ContextMenuHandler";
const $98f6cbe75d03e006$var$$ab4d5d6bf03370d0$export$d81cfea7c54be196 = (divRef)=>{
    if (!divRef.current) return {
        translateX: 0,
        translateY: 0
    };
    else {
        const innerBounce = 16;
        const posn = divRef.current.getBoundingClientRect();
        let translateX = 0;
        if (posn.left < innerBounce) translateX = -posn.left + innerBounce;
        else if (posn.right > window.innerWidth) translateX = Math.max(-posn.left + innerBounce, window.innerWidth - posn.right - innerBounce);
        let translateY = 0;
        if (posn.top < innerBounce) translateY = -posn.top + innerBounce;
        else if (posn.bottom > window.innerHeight) translateY = Math.max(-posn.top + innerBounce, window.innerHeight - posn.bottom - innerBounce);
        return {
            translateX: translateX,
            translateY: translateY
        };
    }
};
const $98f6cbe75d03e006$export$f93615b9594453fc = ({ onMouseDown: onMouseDownCallback, onMouseMove: onMouseMoveCallback, onMouseUp: onMouseUpCallback, onInteractionEnd: onInteractionEndCallback, interactionEndEnabled: interactionEndEnabled = true, onViewportResize: onViewportResizeCallback, viewportResizeEnabled: viewportResizeEnabled = true })=>{
    const mouseMoveRef = (0, $7fPBF.useRef)(null);
    const mouseUpRef = (0, $7fPBF.useRef)(null);
    const activeInputRef = (0, $7fPBF.useRef)(null);
    const mouseDownElementRef = (0, $7fPBF.useRef)(null);
    const mouseDownUserSelectRef = (0, $7fPBF.useRef)(null);
    const interactionEndRef = (0, $7fPBF.useRef)(null);
    const interactionEndCallbackRef = (0, $7fPBF.useRef)(onInteractionEndCallback);
    const viewportResizeCallbackRef = (0, $7fPBF.useRef)(onViewportResizeCallback);
    (0, $7fPBF.useEffect)(()=>{
        interactionEndCallbackRef.current = onInteractionEndCallback;
    }, [
        onInteractionEndCallback
    ]);
    (0, $7fPBF.useEffect)(()=>{
        viewportResizeCallbackRef.current = onViewportResizeCallback;
    }, [
        onViewportResizeCallback
    ]);
    const removeMouseListeners = (0, $7fPBF.useCallback)(()=>{
        if (mouseMoveRef.current) {
            document.removeEventListener("mousemove", mouseMoveRef.current);
            document.removeEventListener("pointermove", mouseMoveRef.current);
        }
        if (mouseUpRef.current) {
            document.removeEventListener("mouseup", mouseUpRef.current);
            document.removeEventListener("pointerup", mouseUpRef.current);
        }
        activeInputRef.current = null;
    }, []);
    const restoreMouseDownUserSelect = (0, $7fPBF.useCallback)(()=>{
        if (mouseDownElementRef.current) {
            /* v8 ignore next */ mouseDownElementRef.current.style.userSelect = mouseDownUserSelectRef.current ?? "";
            mouseDownElementRef.current = null;
            mouseDownUserSelectRef.current = null;
        }
    }, []);
    const removeInteractionEndListeners = (0, $7fPBF.useCallback)(()=>{
        if (interactionEndRef.current) {
            document.removeEventListener("mouseup", interactionEndRef.current, true);
            document.removeEventListener("pointerup", interactionEndRef.current, true);
            interactionEndRef.current = null;
        }
    }, []);
    const onMouseMove = (0, $7fPBF.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        onMouseMoveCallback?.(e);
    }, [
        onMouseMoveCallback
    ]);
    const onMouseUp = (0, $7fPBF.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        removeMouseListeners();
        restoreMouseDownUserSelect();
        onMouseUpCallback?.(e);
    }, [
        onMouseUpCallback,
        removeMouseListeners,
        restoreMouseDownUserSelect
    ]);
    const onMouseDown = (0, $7fPBF.useCallback)((e)=>{
        restoreMouseDownUserSelect();
        mouseDownElementRef.current = e.currentTarget;
        mouseDownUserSelectRef.current = e.currentTarget.style.userSelect;
        e.currentTarget.style.userSelect = "none";
        mouseMoveRef.current = onMouseMove;
        mouseUpRef.current = onMouseUp;
        // React can emit both pointer and mouse streams for one interaction.
        // Subscribe to only one stream to avoid applying movement deltas twice.
        if (e.type === "pointerdown") {
            activeInputRef.current = "pointer";
            document.addEventListener("pointermove", onMouseMove);
        } else {
            activeInputRef.current = "mouse";
            document.addEventListener("mousemove", onMouseMove);
        }
        // Release events can arrive on either stream depending on the browser
        // and the element the interaction finishes over.
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("pointerup", onMouseUp);
        onMouseDownCallback?.(e);
    }, [
        onMouseDownCallback,
        onMouseMove,
        onMouseUp,
        restoreMouseDownUserSelect
    ]);
    const armInteractionEnd = (0, $7fPBF.useCallback)(()=>{
        if (!interactionEndEnabled || interactionEndRef.current) return;
        const onInteractionEnd = (e)=>{
            removeInteractionEndListeners();
            interactionEndCallbackRef.current?.(e);
        };
        interactionEndRef.current = onInteractionEnd;
        document.addEventListener("mouseup", onInteractionEnd, true);
        document.addEventListener("pointerup", onInteractionEnd, true);
    }, [
        interactionEndEnabled,
        removeInteractionEndListeners
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!interactionEndEnabled) removeInteractionEndListeners();
    }, [
        interactionEndEnabled,
        removeInteractionEndListeners
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!viewportResizeEnabled || !viewportResizeCallbackRef.current || !onViewportResizeCallback) return;
        const onViewportResize = (e)=>{
            viewportResizeCallbackRef.current?.(e);
        };
        window.addEventListener("resize", onViewportResize);
        return ()=>{
            window.removeEventListener("resize", onViewportResize);
        };
    }, [
        onViewportResizeCallback,
        viewportResizeEnabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            removeMouseListeners();
            removeInteractionEndListeners();
            restoreMouseDownUserSelect();
        };
    }, [
        removeInteractionEndListeners,
        removeMouseListeners,
        restoreMouseDownUserSelect
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        armInteractionEnd: armInteractionEnd
    };
};
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$exports = {};
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "contextWindow", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "contextWindowAnchor", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "contextWindowBody", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "contextWindowTitle", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "contextWindowTitleClose", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "contextWindowTitleText", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$cebbac70b4d99c48;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$cebbac70b4d99c48 = v;
});
$98f6cbe75d03e006$var$$parcel$export($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports, "moving", function() {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$d03a2f3acc60252b;
}, function(v) {
    return $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$d03a2f3acc60252b = v;
});
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674;
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d;
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f;
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4;
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66;
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$cebbac70b4d99c48;
var $98f6cbe75d03e006$var$$ddf7153c7c69b209$export$d03a2f3acc60252b;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674 = `aiw-ContextWindow-module-RIIF9a-contextWindow`;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d = `aiw-ContextWindow-module-RIIF9a-contextWindowAnchor`;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f = `aiw-ContextWindow-module-RIIF9a-contextWindowBody`;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4 = `aiw-ContextWindow-module-RIIF9a-contextWindowTitle`;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66 = `aiw-ContextWindow-module-RIIF9a-contextWindowTitleClose`;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$cebbac70b4d99c48 = `aiw-ContextWindow-module-RIIF9a-contextWindowTitleText`;
$98f6cbe75d03e006$var$$ddf7153c7c69b209$export$d03a2f3acc60252b = `aiw-ContextWindow-module-RIIF9a-moving`;
const $98f6cbe75d03e006$var$$b5e8657823def5be$export$4f9fb66ac71c7da5 = 3000;
const $98f6cbe75d03e006$var$$b5e8657823def5be$export$e2f9a725ee199e81 = 3010;
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_DATA_ATTR = "data-context-window";
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_MIN_Z_INDEX_DATA_ATTR = "data-context-window-min-z-index";
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_EVENT = "context-window-reset-z-index";
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_COUNTER_DATA_ATTR = "data-context-window-reset-counter";
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_SOURCE_DATA_ATTR = "data-context-window-reset-source";
// Helper function to get the highest zIndex from all context windows in the DOM
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$getMaxZIndex = (componentMinZIndex, currentWindow)=>{
    const windows = document.body.querySelectorAll(`[${$98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_DATA_ATTR}]`);
    let maxZIndex = componentMinZIndex - 1;
    windows.forEach((win)=>{
        if (currentWindow && win === currentWindow) return;
        const zIndexStr = win.style.zIndex;
        if (zIndexStr) {
            const zIndex = parseInt(zIndexStr, 10);
            if (!isNaN(zIndex) && zIndex > maxZIndex) maxZIndex = zIndex;
        }
    });
    return maxZIndex;
};
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$getWindowMinZIndex = (windowElement, fallbackMinZIndex)=>{
    const minZIndexAttr = windowElement.getAttribute($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_MIN_Z_INDEX_DATA_ATTR);
    const parsedMinZIndex = minZIndexAttr ? parseInt(minZIndexAttr, 10) : NaN;
    return Number.isNaN(parsedMinZIndex) ? fallbackMinZIndex : parsedMinZIndex;
};
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$markBodyResetState = (sourceWindowId)=>{
    const currentCounter = parseInt(document.body.getAttribute($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_COUNTER_DATA_ATTR) ?? "0", 10);
    const nextCounter = Number.isNaN(currentCounter) ? 1 : currentCounter + 1;
    document.body.setAttribute($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_COUNTER_DATA_ATTR, `${nextCounter}`);
    if (sourceWindowId) {
        document.body.setAttribute($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_SOURCE_DATA_ATTR, sourceWindowId);
        return;
    }
    document.body.removeAttribute($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_SOURCE_DATA_ATTR);
};
const $98f6cbe75d03e006$var$$b5e8657823def5be$var$resetAllWindowZIndexes = (fallbackMinZIndex, sourceWindowId)=>{
    const windows = document.body.querySelectorAll(`[${$98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_DATA_ATTR}]`);
    windows.forEach((win)=>{
        const element = win;
        element.style.zIndex = `${$98f6cbe75d03e006$var$$b5e8657823def5be$var$getWindowMinZIndex(element, fallbackMinZIndex)}`;
    });
    $98f6cbe75d03e006$var$$b5e8657823def5be$var$markBodyResetState(sourceWindowId);
    document.dispatchEvent(new Event($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_EVENT));
};
const $98f6cbe75d03e006$export$1af8984c69ba1b24 = (0, $7fPBF.forwardRef)(({ id: id, visible: visible, title: title, titleElement: titleElement, children: children, onOpen: onOpen, onClose: onClose, minZIndex: minZIndex = $98f6cbe75d03e006$var$$b5e8657823def5be$export$4f9fb66ac71c7da5, maxZIndex: maxZIndex = $98f6cbe75d03e006$var$$b5e8657823def5be$export$e2f9a725ee199e81, ...rest }, ref)=>{
    const divRef = (0, $7fPBF.useRef)(null);
    const windowRef = (0, $7fPBF.useRef)(null);
    const [zIndex, setZIndex] = (0, $7fPBF.useState)(minZIndex);
    // Track internal state: whether window is in DOM and whether it's been positioned
    const [windowInDOM, setWindowInDOM] = (0, $7fPBF.useState)(false);
    const [windowVisible, setWindowVisible] = (0, $7fPBF.useState)(false);
    const [, startTransition] = (0, $7fPBF.useTransition)();
    // Position
    const windowPos = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const [moving, setMoving] = (0, $7fPBF.useState)(false);
    const move = (0, $7fPBF.useCallback)((x, y)=>{
        if (windowRef.current) {
            windowPos.current.x += x;
            windowPos.current.y += y;
            windowRef.current.style.transform = `translate(${windowPos.current.x}px, ${windowPos.current.y}px)`;
        }
    }, []);
    const fitToViewport = (0, $7fPBF.useCallback)(()=>{
        if (!windowRef.current) return;
        const viewportPadding = 32;
        const availableWidth = Math.max(0, window.innerWidth - viewportPadding);
        const availableHeight = Math.max(0, window.innerHeight - viewportPadding);
        const rect = windowRef.current.getBoundingClientRect();
        const horizontalChrome = rect.width - windowRef.current.clientWidth;
        const verticalChrome = rect.height - windowRef.current.clientHeight;
        if (rect.width > availableWidth) windowRef.current.style.width = `${Math.max(0, availableWidth - horizontalChrome)}px`;
        if (rect.height > availableHeight) windowRef.current.style.height = `${Math.max(0, availableHeight - verticalChrome)}px`;
    }, []);
    const checkPosition = (0, $7fPBF.useCallback)(()=>{
        const chkPos = $98f6cbe75d03e006$var$$ab4d5d6bf03370d0$export$d81cfea7c54be196(windowRef);
        move(chkPos.translateX, chkPos.translateY);
        fitToViewport();
    }, [
        fitToViewport,
        move
    ]);
    const getRecalculatedMaxZIndex = (0, $7fPBF.useCallback)(()=>{
        let maxZIndexInUse = $98f6cbe75d03e006$var$$b5e8657823def5be$var$getMaxZIndex(minZIndex, windowRef.current);
        let resetApplied = false;
        if (typeof maxZIndex === "number" && maxZIndexInUse >= maxZIndex) {
            $98f6cbe75d03e006$var$$b5e8657823def5be$var$resetAllWindowZIndexes(minZIndex, id);
            maxZIndexInUse = $98f6cbe75d03e006$var$$b5e8657823def5be$var$getMaxZIndex(minZIndex, windowRef.current);
            resetApplied = true;
        }
        return {
            maxZIndexInUse: maxZIndexInUse,
            resetApplied: resetApplied
        };
    }, [
        id,
        maxZIndex,
        minZIndex
    ]);
    // Helper function to push this window to the top
    const pushToTop = (0, $7fPBF.useCallback)(()=>{
        const { maxZIndexInUse: maxZIndexInUse, resetApplied: resetApplied } = getRecalculatedMaxZIndex();
        const nextZIndex = maxZIndexInUse + 1;
        if (resetApplied && windowRef.current) windowRef.current.style.zIndex = `${nextZIndex}`;
        setZIndex((currentZIndex)=>{
            return resetApplied || currentZIndex <= maxZIndexInUse ? nextZIndex : currentZIndex;
        });
    }, [
        getRecalculatedMaxZIndex
    ]);
    const parseTranslate = (transform)=>{
        const match = transform?.match(/translate\((-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px\)/);
        if (match) return {
            x: Number.parseFloat(match[1]),
            y: Number.parseFloat(match[2])
        };
        /* v8 ignore next */ return {
            x: 0,
            y: 0
        };
    };
    const { onMouseDown: onMouseDown, armInteractionEnd: armInteractionEnd } = $98f6cbe75d03e006$export$f93615b9594453fc({
        onMouseDown: ()=>{
            windowPos.current = parseTranslate(windowRef.current?.style.transform);
            setMoving(true);
            pushToTop();
        },
        onMouseMove: (e)=>{
            move(e.movementX, e.movementY);
        },
        onMouseUp: ()=>{
            checkPosition();
            setMoving(false);
        },
        onInteractionEnd: ()=>{
            checkPosition();
        },
        interactionEndEnabled: windowVisible,
        onViewportResize: ()=>{
            checkPosition();
        },
        viewportResizeEnabled: windowVisible
    });
    (0, $7fPBF.useImperativeHandle)(ref, ()=>({
            pushToTop: pushToTop
        }), [
        pushToTop
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (visible && !windowInDOM) startTransition(()=>{
            setWindowInDOM(true);
        });
        else if (!visible && windowInDOM) startTransition(()=>{
            setWindowInDOM(false);
            setWindowVisible(false);
        });
    }, [
        visible,
        windowInDOM,
        startTransition
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const handleResetZIndex = ()=>{
            const sourceWindowId = document.body.getAttribute($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_SOURCE_DATA_ATTR);
            if (sourceWindowId === id) return;
            setZIndex(minZIndex);
        };
        document.addEventListener($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_EVENT, handleResetZIndex);
        return ()=>{
            document.removeEventListener($98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_RESET_EVENT, handleResetZIndex);
        };
    }, [
        id,
        minZIndex
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (windowInDOM && !windowVisible && visible && divRef.current && windowRef.current) {
            // Position the window
            const parentPos = divRef.current.getBoundingClientRect();
            const pos = windowRef.current.getBoundingClientRect();
            const windowHeight = pos.bottom - pos.top;
            windowRef.current.style.left = `${parentPos.left}px`;
            windowRef.current.style.top = `${parentPos.bottom + windowHeight < window.innerHeight ? parentPos.bottom : Math.max(0, parentPos.top - windowHeight)}px`;
            windowRef.current.style.transform = "";
            const checkedPosition = $98f6cbe75d03e006$var$$ab4d5d6bf03370d0$export$d81cfea7c54be196(windowRef);
            windowRef.current.style.transform = `translate(${checkedPosition.translateX}px, ${checkedPosition.translateY}px)`;
            if (windowPos && windowPos.current) windowPos.current = {
                x: checkedPosition.translateX,
                y: checkedPosition.translateY
            };
            // Update z-index and make visible - use startTransition
            const { maxZIndexInUse: maxZIndexInUse, resetApplied: resetApplied } = getRecalculatedMaxZIndex();
            onOpen?.();
            startTransition(()=>{
                const nextZIndex = maxZIndexInUse + 1;
                if (resetApplied && windowRef.current) windowRef.current.style.zIndex = `${nextZIndex}`;
                setZIndex((currentZIndex)=>{
                    return resetApplied || currentZIndex <= maxZIndexInUse ? nextZIndex : currentZIndex;
                });
                setWindowVisible(true);
            });
        }
    }, [
        getRecalculatedMaxZIndex,
        onOpen,
        startTransition,
        visible,
        windowInDOM,
        windowVisible
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!windowVisible || !windowRef.current || typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(()=>{
            armInteractionEnd();
        });
        observer.observe(windowRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        armInteractionEnd,
        windowVisible
    ]);
    return (0, $bbzbN.jsx)("div", {
        className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).contextWindowAnchor,
        ref: divRef,
        children: windowInDOM && (0, $fw0lo.createPortal)((0, $bbzbN.jsxs)("div", {
            ...rest,
            ref: windowRef,
            id: id,
            [$98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_DATA_ATTR]: "true",
            [$98f6cbe75d03e006$var$$b5e8657823def5be$var$CONTEXT_WINDOW_MIN_Z_INDEX_DATA_ATTR]: `${minZIndex}`,
            className: [
                /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).contextWindow,
                rest.className
            ].filter((c)=>c).join(" "),
            style: {
                ...rest.style,
                opacity: moving ? 0.8 : windowVisible ? 1 : 0,
                visibility: windowVisible ? "visible" : "hidden",
                zIndex: zIndex,
                minHeight: rest.style?.minHeight ?? "150px",
                minWidth: rest.style?.minWidth ?? "200px",
                maxHeight: rest.style?.maxHeight ?? "1000px",
                maxWidth: rest.style?.maxWidth ?? "1000px"
            },
            onClickCapture: (e)=>{
                pushToTop();
                rest.onClickCapture?.(e);
            },
            children: [
                (0, $bbzbN.jsxs)("div", {
                    className: [
                        /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).contextWindowTitle,
                        moving ? /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).moving : ""
                    ].filter((c)=>c !== "").join(" "),
                    onMouseDown: onMouseDown,
                    children: [
                        (0, $bbzbN.jsx)("div", {
                            className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).contextWindowTitleText,
                            title: title,
                            children: titleElement ? titleElement : title
                        }),
                        (0, $bbzbN.jsx)("div", {
                            className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).contextWindowTitleClose,
                            role: "button",
                            "aria-label": "Close",
                            onClick: onClose,
                            title: `Close ${title && title.trim() !== "" ? title : "window"}`,
                            children: (0, $bbzbN.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "16",
                                height: "16",
                                fill: "currentColor",
                                viewBox: "0 0 16 16",
                                children: (0, $bbzbN.jsx)("path", {
                                    d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                                })
                            })
                        })
                    ]
                }),
                (0, $bbzbN.jsx)("div", {
                    className: /*@__PURE__*/ $98f6cbe75d03e006$var$$parcel$interopDefault($98f6cbe75d03e006$var$$ddf7153c7c69b209$exports).contextWindowBody,
                    children: (0, $bbzbN.jsx)("div", {
                        children: children
                    })
                })
            ]
        }), document.body)
    });
});
$98f6cbe75d03e006$export$1af8984c69ba1b24.displayName = "ContextWindow";

});



parcelRegister("4gy1I", function(module, exports) {

$parcel$export(module.exports, "AioNumber", function () { return $5ee30f17dc4571ec$export$34024c4c1ca38817; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $l72nQ = parcelRequire("l72nQ");
const $5ee30f17dc4571ec$export$34024c4c1ca38817 = (props)=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [value, setValue] = (0, $7fPBF.useState)(props.value);
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>setValue(Math.max(props.minValue ?? -Infinity, Math.min(props.maxValue ?? Infinity, props.value))));
    }, [
        props.maxValue,
        props.minValue,
        props.value
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $l72nQ.AioLabel), {
                id: `${props.id}-label`,
                label: props.label,
                htmlFor: props.id
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInputHolder,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                    id: props.id,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInput,
                    "aria-labelledby": `${props.id}-label`,
                    value: `${value}`,
                    type: "number",
                    disabled: !props.setValue,
                    onChange: (e)=>setValue(parseFloat(e.currentTarget.value)),
                    onBlur: ()=>props.setValue?.(value),
                    step: props.step,
                    min: props.minValue,
                    max: props.maxValue
                })
            })
        ]
    });
};
$5ee30f17dc4571ec$export$34024c4c1ca38817.displayName = "AioNumber";

});

parcelRegister("i7ZQC", function(module, exports) {

$parcel$export(module.exports, "AioReplacementDisplay", function () { return $cffc351350152e8f$export$6079dbe36a5ae246; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");
var $8EK1C = parcelRequire("8EK1C");

var $cqVqv = parcelRequire("cqVqv");

var $fq9h5 = parcelRequire("fq9h5");

var $5m3yv = parcelRequire("5m3yv");

var $dJxI5 = parcelRequire("dJxI5");

var $haC0j = parcelRequire("haC0j");
const $cffc351350152e8f$export$6079dbe36a5ae246 = ({ id: id, airid: airid, oldText: oldText, newTexts: newTexts, includeTrailing: includeTrailing, externalName: externalName, setReplacement: setReplacement, externalLists: externalLists, dontAskSpace: dontAskSpace, dontAskTrail: dontAskTrail, noText: noText, editorProps: editorProps = (0, $jP37Y.defaultEditorDefns), level: level })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [displayText, setDisplayText] = (0, $7fPBF.useState)((0, $8EK1C.fromHtml)(oldText));
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>setDisplayText((0, $8EK1C.fromHtml)(oldText)));
    }, [
        oldText
    ]);
    const availableListNames = (0, $7fPBF.useMemo)(()=>{
        const a = [
            "with..."
        ];
        const exl = [];
        externalLists?.map((rep)=>{
            exl.push(rep.givenName);
            return true;
        });
        a.push(...exl.sort((a, b)=>a.localeCompare(b)));
        return a;
    }, [
        externalLists
    ]);
    /**
   * Return updated replacement object
   *
   * @param newReplacement - Partial replacement object with updated values
   */ const returnData = (newReplacement)=>{
        /* istanbul ignore else */ if (setReplacement) {
            // Create new object
            const r = {
                airid: airid ?? crypto.randomUUID(),
                oldText: oldText,
                newTexts: newTexts,
                includeTrailing: includeTrailing,
                externalName: externalName,
                ...newReplacement
            };
            // Remove default
            if (r.externalName === "with...") delete r.externalName;
            // Update existing object
            setReplacement(r);
        }
    };
    /**
   * Add new text entry
   *
   * @param i - Index to add at
   */ const addNewText = (i)=>{
        /* istanbul ignore else */ if (setReplacement) {
            const nts = [
                ...newTexts
            ];
            nts.splice(i, 0, (0, $haC0j.newReplacementValues)(editorProps.blankT));
            returnData({
                newTexts: nts
            });
        }
    };
    /**
   * Remove new text entry
   *
   * @param i - Index to remove at
   */ const removeNewText = (i)=>{
        /* istanbul ignore else */ if (setReplacement) {
            const nts = [
                ...newTexts
            ];
            nts.splice(i, 1);
            returnData({
                newTexts: nts
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).replacementContainer,
        children: [
            !noText && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                children: [
                    typeof setReplacement !== "function" ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        children: `${oldText}`.trim() !== "" ? (0, $8EK1C.fromHtml)(oldText) : /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                            children: "Nothing"
                        })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        id: `${id}-input`,
                        className: (0, $cqVqv.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInput,
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).width170
                        ]),
                        type: "text",
                        value: displayText,
                        onChange: (e)=>setDisplayText(e.currentTarget.value),
                        onBlur: (e)=>{
                            returnData({
                                oldText: (0, $8EK1C.toHtml)(e.currentTarget.value)
                            });
                        }
                    }),
                    !dontAskTrail && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).replacementButtonArea,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                htmlFor: `${id}-includetrailing`,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                                    children: "Include trailing rows"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                id: `${id}-includetrailing`,
                                disabled: typeof setReplacement !== "function",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).margin6,
                                type: "checkbox",
                                checked: includeTrailing,
                                onChange: (e)=>returnData({
                                        includeTrailing: e.currentTarget.checked
                                    })
                            })
                        ]
                    })
                ]
            }),
            typeof setReplacement === "function" && externalLists !== undefined && externalLists.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fq9h5.AioDropSelect), {
                    id: `${id}-dropselect`,
                    value: !externalName ? "with..." : externalName,
                    availableValues: availableListNames,
                    setValue: (ret)=>{
                        returnData({
                            externalName: ret
                        });
                    }
                })
            }) : externalName !== undefined && externalName !== "" ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).fontItalic,
                children: externalName
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: externalLists?.some((e)=>e.givenName === externalName) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                    children: externalLists?.find((e)=>e.givenName === externalName)?.newTexts.map((e)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $dJxI5.AioReplacementValuesDisplay), {
                            id: `${id}-subdisplay`,
                            airid: e.airid,
                            texts: e.texts,
                            spaceAfter: e.spaceAfter,
                            subLists: e.subLists,
                            editorProps: editorProps,
                            level: level
                        }, e.airid))
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                    children: newTexts.map((rv, i)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dJxI5.AioReplacementValuesDisplay), {
                                    id: `${id}-subdisplay`,
                                    airid: rv.airid,
                                    texts: rv.texts,
                                    spaceAfter: rv.spaceAfter,
                                    subLists: rv.subLists,
                                    externalLists: externalLists,
                                    dontAskSpace: dontAskSpace,
                                    dontAskTrail: typeof setReplacement === "function" ? dontAskTrail : true,
                                    setReplacementValue: typeof setReplacement === "function" ? (ret)=>{
                                        const nts = [
                                            ...newTexts
                                        ];
                                        nts.splice(i, 1, ret);
                                        returnData({
                                            newTexts: nts
                                        });
                                    } : undefined,
                                    editorProps: editorProps,
                                    level: level
                                }, rv.airid),
                                typeof setReplacement === "function" && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: (0, $cqVqv.classMerge)([
                                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButtonHolder,
                                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).replacementRowIndented
                                    ]),
                                    children: [
                                        newTexts && newTexts.length > 1 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                                            id: `${id}-remove`,
                                            iconName: "aioxRemoveUp",
                                            onClick: ()=>removeNewText(i),
                                            tipText: "Remove new text"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                                            id: `${id}-add`,
                                            iconName: "aioxAddDown",
                                            onClick: ()=>addNewText(i + 1),
                                            tipText: "Add new text"
                                        })
                                    ]
                                })
                            ]
                        }, `${i}-${rv.airid}`))
                })
            })
        ]
    });
};
$cffc351350152e8f$export$6079dbe36a5ae246.displayName = "AioReplacementDisplay";

});
parcelRegister("dJxI5", function(module, exports) {

$parcel$export(module.exports, "AioReplacementValuesDisplay", function () { return $e0586a570b599904$export$b2a4f9c268dcb341; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $jP37Y = parcelRequire("jP37Y");

var $3gAtF = parcelRequire("3gAtF");
const $e0586a570b599904$export$b2a4f9c268dcb341 = ({ id: id, airid: airid, texts: texts, spaceAfter: spaceAfter = false, subLists: subLists = [], setReplacementValue: setReplacementValue, dontAskSpace: dontAskSpace, dontAskTrail: dontAskTrail, externalLists: externalLists, editorProps: editorProps = (0, $jP37Y.defaultEditorDefns), level: level })=>{
    const Editor = editorProps.Editor;
    const returnData = (0, $7fPBF.useCallback)((newRV)=>{
        /* istanbul ignore else */ if (setReplacementValue) {
            const r = {
                airid: airid,
                spaceAfter: newRV.spaceAfter ?? spaceAfter,
                texts: newRV.texts ?? texts,
                subLists: newRV.subLists ?? subLists
            };
            setReplacementValue(r);
        }
    }, [
        airid,
        setReplacementValue,
        spaceAfter,
        subLists,
        texts
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiordvMain,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                style: {
                    marginRight: "4px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "2px"
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                        id: id,
                        "aria-label": "Replacement values",
                        editable: setReplacementValue !== undefined,
                        value: editorProps.joinTintoBlock(texts),
                        setValue: (ret)=>returnData({
                                texts: editorProps.splitTintoLines(ret)
                            }),
                        style: {
                            width: "170px",
                            minWidth: "170px",
                            minHeight: "64px",
                            marginTop: "4px",
                            height: "Calc(100% - 16px)",
                            padding: "4px",
                            border: "1px solid black",
                            borderRadius: "4px"
                        },
                        resize: true
                    }),
                    !dontAskSpace && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                htmlFor: `${id}-spaceafter`,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                                    children: "Space after repeat"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                id: `${id}-spaceafter`,
                                style: {
                                    margin: "6px"
                                },
                                type: "checkbox",
                                checked: spaceAfter,
                                disabled: !setReplacementValue,
                                onChange: (e)=>returnData({
                                        spaceAfter: e.currentTarget.checked
                                    })
                            })
                        ]
                    })
                ]
            }),
            setReplacementValue || subLists.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    level < 4 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        style: {
                                            flexGrow: 1,
                                            minWidth: "5px",
                                            width: "5px",
                                            borderBottom: "1px burlywood solid",
                                            borderBottomRightRadius: "4px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        style: {
                                            flexGrow: 1,
                                            minWidth: "5px",
                                            width: "5px",
                                            borderTop: "1px burlywood solid",
                                            borderTopRightRadius: "4px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                style: {
                                    minWidth: "5px",
                                    width: "5px",
                                    marginTop: "6px",
                                    marginBottom: "6px",
                                    borderLeft: "1px burlywood solid",
                                    borderTop: "1px burlywood solid",
                                    borderBottom: "1px burlywood solid",
                                    borderTopLeftRadius: "4px",
                                    borderBottomLeftRadius: "4px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3gAtF.AioReplacementList), {
                        id: `${id}-sublists`,
                        replacements: subLists,
                        setReplacements: setReplacementValue ? (ret)=>returnData({
                                subLists: ret
                            }) : undefined,
                        dontAskSpace: setReplacementValue ? dontAskSpace : true,
                        dontAskTrail: dontAskTrail,
                        externalLists: externalLists,
                        editorProps: editorProps,
                        level: level + 1
                    })
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {})
        ]
    });
};
$e0586a570b599904$export$b2a4f9c268dcb341.displayName = "AioReplacementValuesDisplay";

});
parcelRegister("3gAtF", function(module, exports) {

$parcel$export(module.exports, "AioReplacementList", function () { return $fe8ccf32c7f5ec42$export$e09e09c0bb6298e3; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");

var $cqVqv = parcelRequire("cqVqv");

var $5m3yv = parcelRequire("5m3yv");

var $l72nQ = parcelRequire("l72nQ");

var $i7ZQC = parcelRequire("i7ZQC");

var $82xZo = parcelRequire("82xZo");
const $fe8ccf32c7f5ec42$export$e09e09c0bb6298e3 = ({ id: id, label: label, replacements: replacements, setReplacements: setReplacements, dontAskSpace: dontAskSpace, dontAskTrail: dontAskTrail, externalLists: externalLists, editorProps: editorProps = (0, $jP37Y.defaultEditorDefns), level: level })=>{
    const updateReplacement = (0, $7fPBF.useCallback)((ret, i)=>{
        /* istanbul ignore else */ if (setReplacements) {
            const newValue = [
                ...replacements
            ];
            newValue[i] = ret;
            setReplacements(newValue);
        }
    }, [
        replacements,
        setReplacements
    ]);
    const addReplacement = (0, $7fPBF.useCallback)((i)=>{
        /* istanbul ignore else */ if (setReplacements) {
            const newReplacements = [
                ...replacements
            ];
            newReplacements.splice(i, 0, (0, $82xZo.newReplacement)(editorProps.blankT));
            setReplacements(newReplacements);
        }
    }, [
        editorProps.blankT,
        replacements,
        setReplacements
    ]);
    const removeReplacement = (0, $7fPBF.useCallback)((i)=>{
        /* istanbul ignore else */ if (setReplacements) {
            const newReplacements = [
                ...replacements
            ];
            newReplacements.splice(i, 1);
            setReplacements(newReplacements);
        }
    }, [
        replacements,
        setReplacements
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $l72nQ.AioLabel), {
                id: `${id}-label`,
                label: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                children: [
                    level < 5 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            !label && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        children: "then..."
                                    }),
                                    " "
                                ]
                            }),
                            setReplacements && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                id: `${id}-addreplacement`,
                                title: "Add replacement",
                                className: (0, $cqVqv.classMerge)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxAddDown
                                ]),
                                onClick: ()=>addReplacement(0)
                            })
                        ]
                    }),
                    replacements.map((repl, i)=>{
                        return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                i > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    children: " and..."
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i7ZQC.AioReplacementDisplay), {
                                    id: `${id}-replacementdisplay-${i}`,
                                    airid: repl.airid,
                                    oldText: repl.oldText,
                                    newTexts: repl.newTexts,
                                    includeTrailing: repl.includeTrailing,
                                    externalName: repl.externalName,
                                    setReplacement: setReplacements ? (ret)=>updateReplacement(ret, i) : undefined,
                                    dontAskSpace: dontAskSpace,
                                    dontAskTrail: dontAskTrail,
                                    externalLists: externalLists,
                                    editorProps: editorProps,
                                    level: level
                                }),
                                setReplacements && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: (0, $cqVqv.classMerge)([
                                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButtonHolder,
                                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexRowCenter,
                                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).marginBottom2
                                    ]),
                                    children: [
                                        replacements && replacements.length >= 1 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                                            id: `${id}-remove`,
                                            iconName: "aioxRemoveUp",
                                            onClick: ()=>removeReplacement(i),
                                            tipText: "Remove old text"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                                            id: `${id}-add`,
                                            iconName: "aioxAddDown",
                                            onClick: ()=>addReplacement(i + 1),
                                            tipText: "Add old text"
                                        })
                                    ]
                                })
                            ]
                        }, `${i}-${repl.airid}`);
                    })
                ]
            })
        ]
    });
};
$fe8ccf32c7f5ec42$export$e09e09c0bb6298e3.displayName = "AioReplacementList";

});



parcelRegister("hbWqi", function(module, exports) {

$parcel$export(module.exports, "AioSelect", function () { return $c247b9d33dca4899$export$56481f24960d73ae; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $l72nQ = parcelRequire("l72nQ");
const $c247b9d33dca4899$export$56481f24960d73ae = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $l72nQ.AioLabel), {
                id: `${props.id}-label`,
                label: props.label,
                htmlFor: props.id
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInputHolder,
                children: !props.setValue ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    id: props.id,
                    children: props.value
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)("select", {
                    id: props.id,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioSelect,
                    value: props.value,
                    onChange: (e)=>props.setValue(e.currentTarget.value),
                    children: props.availableValues && props.availableValues.map((v, i)=>{
                        return /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                            value: v,
                            children: v
                        }, i);
                    })
                })
            })
        ]
    });
};
$c247b9d33dca4899$export$56481f24960d73ae.displayName = "AioSelect";

});

parcelRegister("cXvVz", function(module, exports) {

$parcel$export(module.exports, "isAioReplacement", function () { return $e1c0fecbc1eb72f2$export$c8b64ff2405d449e; });
$parcel$export(module.exports, "isAioExternalReplacements", function () { return $e1c0fecbc1eb72f2$export$e4d19c9b1a11fefc; });
$parcel$export(module.exports, "isAioExternalSingle", function () { return $e1c0fecbc1eb72f2$export$51e8bc9d3e0fab16; });

var $8CFpa = parcelRequire("8CFpa");
const $e1c0fecbc1eb72f2$export$c8b64ff2405d449e = (obj, chkT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check basic props
    if (typeof obj.airid !== "string") return false;
    if (typeof obj.oldText !== "string") return false;
    if (!Array.isArray(obj.newTexts) || obj.newTexts.some((o)=>!$e1c0fecbc1eb72f2$export$6b777ae226a0af37(o, chkT))) return false;
    // Check optional props
    if (obj.includeTrailing !== undefined && typeof obj.includeTrailing !== "boolean") return false;
    if (obj.externalName !== undefined && typeof obj.externalName !== "string") return false;
    // Everything is good
    return true;
};
const $e1c0fecbc1eb72f2$export$6b777ae226a0af37 = (obj, chkT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check basic props
    if (typeof obj.airid !== "string") return false;
    // texts must be an array and none of the entries should fail the chkT guard
    if (!Array.isArray(obj.texts) || obj.texts.some((t)=>!chkT(t))) return false;
    // Check optional props
    if (obj.spaceAfter !== undefined && typeof obj.spaceAfter !== "boolean") return false;
    if (obj.subLists !== undefined && (!Array.isArray(obj.subLists) || obj.subLists.some((s)=>!$e1c0fecbc1eb72f2$export$c8b64ff2405d449e(s, chkT)))) return false;
    // Everything is good
    return true;
};
const $e1c0fecbc1eb72f2$export$e4d19c9b1a11fefc = (obj, isT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check lower interface
    if (typeof obj.givenName !== "string") return false;
    if (!Array.isArray(obj.newTexts) || obj.newTexts.some((o)=>!$e1c0fecbc1eb72f2$export$6b777ae226a0af37(o, isT))) return false;
    // Everything is good
    return true;
};
const $e1c0fecbc1eb72f2$export$51e8bc9d3e0fab16 = (obj, isT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check basic props
    if (typeof obj.airid !== "string") return false;
    if (typeof obj.oldText !== "string") return false;
    // Check generic type
    if (!isT(obj.newText)) return false;
    // Everything is good
    return true;
};
var $e1c0fecbc1eb72f2$export$edfa68647a85ef1 = /*#__PURE__*/ function(AioOptionType) {
    AioOptionType["string"] = "string";
    AioOptionType["number"] = "number";
    AioOptionType["array"] = "array";
    AioOptionType["object"] = "object";
    AioOptionType["boolean"] = "boolean";
    AioOptionType["select"] = "select";
    AioOptionType["replacements"] = "replacements";
    return AioOptionType;
}({});
var $e1c0fecbc1eb72f2$export$55057b6697351b90 = /*#__PURE__*/ function(AioNewItem) {
    AioNewItem["newKey"] = "newKey";
    AioNewItem["newType"] = "newType";
    return AioNewItem;
}({});

});
parcelRegister("8CFpa", function(module, exports) {

$parcel$export(module.exports, "isObjectRecord", function () { return $75c093fe3a41f3e5$export$ff15efac2955c26a; });
/**
 * Type guard to check if a value is a non-null object record.
 *
 * @param obj - The value to check
 * @returns True if the value is an object record
 */ const $75c093fe3a41f3e5$export$ff15efac2955c26a = (obj)=>{
    return typeof obj === "object" && obj !== null;
};

});


parcelRegister("gqdtF", function(module, exports) {

$parcel$export(module.exports, "newExternalReplacements", function () { return $5a7359f414c6136b$export$3658d80c4fee3eff; });

var $haC0j = parcelRequire("haC0j");
const $5a7359f414c6136b$export$3658d80c4fee3eff = (blankT)=>{
    return {
        givenName: "",
        newTexts: [
            (0, $haC0j.newReplacementValues)(blankT)
        ]
    };
};

});


parcelRegister("jgbJm", function(module, exports) {
$parcel$export(module.exports, "ArsBlock", function () { return (parcelRequire("iGqDA")).ArsBlock; });
$parcel$export(module.exports, "AnalysisMethodControl", function () { return (parcelRequire("7uNID")).AnalysisMethodControl; });
$parcel$export(module.exports, "AnalysisSetControl", function () { return (parcelRequire("9ijW6")).AnalysisSetControl; });
$parcel$export(module.exports, "DataSubsetControl", function () { return (parcelRequire("b1QeS")).DataSubsetControl; });
$parcel$export(module.exports, "GroupingFactorControl", function () { return (parcelRequire("bRDEW")).GroupingFactorControl; });
$parcel$export(module.exports, "ReferencedEntityControl", function () { return (parcelRequire("kupca")).ReferencedEntityControl; });
$parcel$export(module.exports, "ArsContextProvider", function () { return (parcelRequire("fZCs4")).ArsContextProvider; });
$parcel$export(module.exports, "cloneArsObject", function () { return (parcelRequire("kDIpz")).cloneArsObject; });
$parcel$export(module.exports, "createNewAnalysisMethod", function () { return (parcelRequire("3CgTd")).createNewAnalysisMethod; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return (parcelRequire("3CgTd")).createNewAnalysisSet; });
$parcel$export(module.exports, "createNewDataSubset", function () { return (parcelRequire("3CgTd")).createNewDataSubset; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return (parcelRequire("3CgTd")).createNewGroupingFactor; });
$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return (parcelRequire("cIJV5")).CURRENT_HIERARCHY_ID; });
$parcel$export(module.exports, "hasArsObjectWithName", function () { return (parcelRequire("kDIpz")).hasArsObjectWithName; });
$parcel$export(module.exports, "MultipleDatasetCheck", function () { return (parcelRequire("ihppY")).MultipleDatasetCheck; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return (parcelRequire("cIJV5")).PATCH_ARS_STATE; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return (parcelRequire("cIJV5")).SET_SIDEBAR_ANALYSIS_METHOD_ID; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return (parcelRequire("cIJV5")).SET_VARIABLES_IN_USE; });
$parcel$export(module.exports, "useArsContext", function () { return (parcelRequire("fZCs4")).useArsContext; });
$parcel$export(module.exports, "ArsListing", function () { return (parcelRequire("lremW")).ArsListing; });
$parcel$export(module.exports, "isArsListingBody", function () { return (parcelRequire("awEAB")).isArsListingBody; });
$parcel$export(module.exports, "totalSidebarItem", function () { return (parcelRequire("40D4s")).totalSidebarItem; });
$parcel$export(module.exports, "ArsTable", function () { return (parcelRequire("3Q1wz")).ArsTable; });
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("GtyWr")).isArsTableBody; });
$parcel$export(module.exports, "isAnalysisMethod", function () { return (parcelRequire("ek4hO")).isAnalysisMethod; });
$parcel$export(module.exports, "isDataSubset", function () { return (parcelRequire("74VXB")).isDataSubset; });
$parcel$export(module.exports, "isObjectRecord", function () { return (parcelRequire("8CFpa")).isObjectRecord; });
$parcel$export(module.exports, "isSubClauseWithReference", function () { return (parcelRequire("5KlUB")).isSubClauseWithReference; });

$parcel$export(module.exports, "ARS", function () { return (parcelRequire("1cA0K")); });

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("72Rdc");
parcelRequire("bIAbO");
parcelRequire("k7fIt");
parcelRequire("0PqYf");
parcelRequire("fJUVM");
parcelRequire("kevCO");
parcelRequire("loI62");
parcelRequire("6yroJ");
parcelRequire("jbjc3");

});
parcelRegister("1cA0K", function(module, exports) {

$parcel$export(module.exports, "OutputFileTypeEnum", function () { return $41eb1f4c6eec049c$export$47f803b406f26046; });
$parcel$export(module.exports, "ExpressionLogicalOperatorEnum", function () { return $41eb1f4c6eec049c$export$348d7552f54576b; });
$parcel$export(module.exports, "ConditionComparatorEnum", function () { return $41eb1f4c6eec049c$export$ea8e51ef45e00dd8; });
$parcel$export(module.exports, "DisplaySectionTypeEnum", function () { return $41eb1f4c6eec049c$export$fd824ba75eca195; });
$parcel$export(module.exports, "OperationRoleEnum", function () { return $41eb1f4c6eec049c$export$efdc6d0631ac9420; });
$parcel$export(module.exports, "AnalysisReasonEnum", function () { return $41eb1f4c6eec049c$export$d1a83c055b3f235e; });
$parcel$export(module.exports, "AnalysisPurposeEnum", function () { return $41eb1f4c6eec049c$export$dec38678dda78c02; });
$parcel$export(module.exports, "ExtensibleTerminologyEnum", function () { return $41eb1f4c6eec049c$export$e9ba74e51b2847c6; });
$parcel$export(module.exports, "PageRefTypeEnum", function () { return $41eb1f4c6eec049c$export$4fd4a62032f22875; });
var $41eb1f4c6eec049c$export$47f803b406f26046 = /*#__PURE__*/ function(OutputFileTypeEnum) {
    /** Portable Document Format (PDF) */ OutputFileTypeEnum["pdf"] = "pdf";
    /** Rich Text Format (RTF) */ OutputFileTypeEnum["rtf"] = "rtf";
    /** Plain text */ OutputFileTypeEnum["txt"] = "txt";
    return OutputFileTypeEnum;
}({});
var $41eb1f4c6eec049c$export$348d7552f54576b = /*#__PURE__*/ function(ExpressionLogicalOperatorEnum) {
    ExpressionLogicalOperatorEnum["AND"] = "AND";
    ExpressionLogicalOperatorEnum["OR"] = "OR";
    ExpressionLogicalOperatorEnum["NOT"] = "NOT";
    return ExpressionLogicalOperatorEnum;
}({});
var $41eb1f4c6eec049c$export$ea8e51ef45e00dd8 = /*#__PURE__*/ function(ConditionComparatorEnum) {
    /** Is equal to */ ConditionComparatorEnum["EQ"] = "EQ";
    /** Is not equal to */ ConditionComparatorEnum["NE"] = "NE";
    /** Is greater than */ ConditionComparatorEnum["GT"] = "GT";
    /** Is greater than or equal to */ ConditionComparatorEnum["GE"] = "GE";
    /** Is less than */ ConditionComparatorEnum["LT"] = "LT";
    /** Is less than or equal to */ ConditionComparatorEnum["LE"] = "LE";
    /** Is in */ ConditionComparatorEnum["IN"] = "IN";
    /** Is not in */ ConditionComparatorEnum["NOTIN"] = "NOTIN";
    return ConditionComparatorEnum;
}({});
var $41eb1f4c6eec049c$export$fd824ba75eca195 = /*#__PURE__*/ function(DisplaySectionTypeEnum) {
    /** Lines of text appearing above the title and containing additional generic information such as study identifier or page numbering. */ DisplaySectionTypeEnum["Header"] = "Header";
    /** The title is a caption of a table beginning with "Table" followed by sequenced numbers or letters and separated by full stops. The title includes additional lines describing the content. */ DisplaySectionTypeEnum["Title"] = "Title";
    /** Optional text placed in the column header for a column containing row/stub labels. */ DisplaySectionTypeEnum["Rowlabel_Header"] = "Rowlabel Header";
    /** Lines of text placed immediately after the body of the table containing statements explaining the use of terms or values. May be prefaced with a word such as 'Note:'. */ DisplaySectionTypeEnum["Legend"] = "Legend";
    /** Lines of text defining abbreviations, acronyms, and terms used in the body of the display. */ DisplaySectionTypeEnum["Abbreviation"] = "Abbreviation";
    /** Placed after the abbreviations and definitions, if any. Footnotes lead with symbols (asterisk, dagger, double dagger, or section symbol) or superscripted letters (a, b, c) or numbers (1, 2, 3) which are in the table behind units of measure or words. Footnotes add information regarding the associated values where they occur in the body. */ DisplaySectionTypeEnum["Footnote"] = "Footnote";
    /** Lines of text appearing below any footnote and containing additional information such as traceability of the source program or page numbering. */ DisplaySectionTypeEnum["Footer"] = "Footer";
    /** ADDED BY AZ */ /** Page by */ DisplaySectionTypeEnum["PageBy"] = "PageBy";
    /** Columns in the table */ DisplaySectionTypeEnum["Columns"] = "Columns";
    /** Rows in the table */ DisplaySectionTypeEnum["Rows"] = "Rows";
    return DisplaySectionTypeEnum;
}({});
var $41eb1f4c6eec049c$export$efdc6d0631ac9420 = /*#__PURE__*/ function(OperationRoleEnum) {
    /** The dividend of a fraction. */ OperationRoleEnum["NUMERATOR"] = "NUMERATOR";
    /** The divisor of a fraction. */ OperationRoleEnum["DENOMINATOR"] = "DENOMINATOR";
    return OperationRoleEnum;
}({});
var $41eb1f4c6eec049c$export$d1a83c055b3f235e = /*#__PURE__*/ function(AnalysisReasonEnum) {
    /** The analysis is specified in a protocol. */ AnalysisReasonEnum["SPECIFIED_IN_PROTOCOL"] = "SPECIFIED IN PROTOCOL";
    /** The analysis is specified in a statistical analysis plan. */ AnalysisReasonEnum["SPECIFIED_IN_SAP"] = "SPECIFIED IN SAP";
    /** The analysis was triggered by findings in the data. */ AnalysisReasonEnum["DATA_DRIVEN"] = "DATA DRIVEN";
    /** The analysis has been requested by a regulatory agency. */ AnalysisReasonEnum["REQUESTED_BY_REGULATORY_AGENCY"] = "REQUESTED BY REGULATORY AGENCY";
    return AnalysisReasonEnum;
}({});
var $41eb1f4c6eec049c$export$dec38678dda78c02 = /*#__PURE__*/ function(AnalysisPurposeEnum) {
    /** The outcome measure(s) of greatest importance specified in the protocol, usually the one(s) used in the power calculation, to evaluate the primary endpoint(s) associated with the primary study objective(s). (After Clinicaltrials.gov) */ AnalysisPurposeEnum["PRIMARY_OUTCOME_MEASURE"] = "PRIMARY OUTCOME MEASURE";
    /** The outcome measure(s) that is part of a pre-specified analysis plan used to evaluate the secondary endpoint(s) associated with secondary study objective(s) and/or used to evaluate any measure(s) ancillary to the primary or secondary endpoint(s). (After Clinicaltrials.gov). */ AnalysisPurposeEnum["SECONDARY_OUTCOME_MEASURE"] = "SECONDARY OUTCOME MEASURE";
    /** The outcome measure(s) that is part of a pre-specified analysis plan used to evaluate the exploratory endpoint(s) associated with exploratory study objective(s) and/or any other measures, excluding post-hoc measures, that are a focus of the study. (After clinicaltrials.gov) */ AnalysisPurposeEnum["EXPLORATORY_OUTCOME_MEASURE"] = "EXPLORATORY OUTCOME MEASURE";
    return AnalysisPurposeEnum;
}({});
var $41eb1f4c6eec049c$export$e9ba74e51b2847c6 = /*#__PURE__*/ function(ExtensibleTerminologyEnum) {
    /** The rationale for performing this analysis. It indicates when the analysis was planned. */ ExtensibleTerminologyEnum["AnalysisReasonEnum"] = "AnalysisReasonEnum";
    /** The purpose of the analysis within the body of evidence (e.g., section in the clinical study report). */ ExtensibleTerminologyEnum["AnalysisPurposeEnum"] = "AnalysisPurposeEnum";
    /** The role that the referenced operation's result plays in the calculation of the result of this operation. */ ExtensibleTerminologyEnum["OperationRoleEnum"] = "OperationRoleEnum";
    /** The file format of the file containing output from analyses. */ ExtensibleTerminologyEnum["OutputFileTypeEnum"] = "OutputFileTypeEnum";
    return ExtensibleTerminologyEnum;
}({});
var $41eb1f4c6eec049c$export$4fd4a62032f22875 = /*#__PURE__*/ function(PageRefTypeEnum) {
    /** References are to page numbers. */ PageRefTypeEnum["PhysicalRef"] = "PhysicalRef";
    /** References are to named destinations in the referenced document. */ PageRefTypeEnum["NamedDestination"] = "NamedDestination";
    return PageRefTypeEnum;
}({});

});

parcelRegister("72Rdc", function(module, exports) {
$parcel$export(module.exports, "ArsBlock", function () { return (parcelRequire("iGqDA")).ArsBlock; });
parcelRequire("iGqDA");
parcelRequire("4K7d5");

});
parcelRegister("iGqDA", function(module, exports) {

$parcel$export(module.exports, "ArsBlock", function () { return $9e9532ce95b5fe74$export$eb18248e32b55f71; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $g3GSA = parcelRequire("g3GSA");

var $clOgJ = parcelRequire("clOgJ");

var $6odg7 = parcelRequire("6odg7");

var $3BGiR = parcelRequire("3BGiR");
const $9e9532ce95b5fe74$export$eb18248e32b55f71 = ({ disabled: disabled, dropText: dropText, editorDefns: editorDefns, id: id, setValue: setValue, style: style, value: value })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    /**
   * Appends grouping factors dropped onto the block.
   *
   * @param event - Drop event from a grouping-factor drag source
   * @param ix - Index of the page-by item being dropped onto, used when multiple page-by blocks are present; currently unused as only one block is supported, but included for future extensibility
   */ const addGroupingFactors = (event, ix)=>{
        event.preventDefault();
        if (disabled) return;
        const transferText = event.dataTransfer.getData("application/json");
        if (!transferText) return;
        try {
            const parsed = JSON.parse(transferText);
            if (!Array.isArray(parsed.data)) return;
            const newValue = [
                ...value
            ];
            const addValues = [];
            for (const item of parsed.data){
                if (!(0, $clOgJ.isArsSidebarItemData)(item) || item.kind !== (0, $g3GSA.ArsSidebarItemKind).GroupingFactor) continue;
                if (!state.groupingFactors[item.dropItem.id]) continue;
                if (newValue.some(({ groupingFactorId: groupingFactorId })=>groupingFactorId === item.dropItem.id) || addValues.some(({ groupingFactorId: groupingFactorId })=>groupingFactorId === item.dropItem.id)) continue;
                addValues.push({
                    groupingFactorId: item.dropItem.id,
                    label: editorDefns.textToT([
                        item.dropItem.label,
                        item.dropItem.name,
                        item.dropItem.description,
                        item.dropItem.id
                    ].map((value)=>value?.trim() ?? "").find((value)=>value !== ""))
                });
            }
            newValue.splice(ix, 0, ...addValues);
            if (newValue.length !== value.length) setValue(newValue);
        } catch  {
            return;
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibBlock,
        style: style,
        children: value.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLine,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineButtons
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineItemHolder,
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexGrow1,
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6odg7.ArsBlockDropZone), {
                                id: `${id}-dropzone`,
                                onDrop: (e)=>addGroupingFactors(e, 0),
                                top: "0",
                                bottom: "0"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: (0, $cqVqv.classMerge)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineItem,
                                    "fst-italic"
                                ]),
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)(editorDefns.Editor, {
                                    id: `ars-block-line-editor-ro`,
                                    editable: false,
                                    value: dropText ?? editorDefns.textToT("Drop grouping factors here"),
                                    setValue: // istanbul ignore next
                                    ()=>undefined
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineButtons
                })
            ]
        }) : value.map((pageByItem, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLine,
                style: {
                    position: "relative"
                },
                children: [
                    index === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6odg7.ArsBlockDropZone), {
                        id: `${id}-dropzone-${index}`,
                        onDrop: (e)=>addGroupingFactors(e, 0),
                        top: "-8px",
                        bottom: "calc(100% - 8px)"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6odg7.ArsBlockDropZone), {
                        id: `${id}-dropzone-${index}`,
                        onDrop: (e)=>addGroupingFactors(e, index + 1),
                        top: "calc(100% - 8px)",
                        bottom: "-8px"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3BGiR.ArsBlockLine), {
                        disabled: disabled,
                        editorDefns: editorDefns,
                        pageByIndex: index,
                        setValue: setValue,
                        value: value
                    })
                ]
            }, `${pageByItem.groupingFactorId}-${index}`))
    });
};
$9e9532ce95b5fe74$export$eb18248e32b55f71.displayName = "ArsBlock";

});
parcelRegister("k7fIt", function(module, exports) {
$parcel$export(module.exports, "ArsContextProvider", function () { return (parcelRequire("fZCs4")).ArsContextProvider; });
$parcel$export(module.exports, "useArsContext", function () { return (parcelRequire("fZCs4")).useArsContext; });
$parcel$export(module.exports, "createNewAnalysisMethod", function () { return (parcelRequire("3CgTd")).createNewAnalysisMethod; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return (parcelRequire("3CgTd")).createNewAnalysisSet; });
$parcel$export(module.exports, "createNewDataSubset", function () { return (parcelRequire("3CgTd")).createNewDataSubset; });
$parcel$export(module.exports, "createNewGroup", function () { return (parcelRequire("3CgTd")).createNewGroup; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return (parcelRequire("3CgTd")).createNewGroupingFactor; });
$parcel$export(module.exports, "cloneArsObject", function () { return (parcelRequire("kDIpz")).cloneArsObject; });
$parcel$export(module.exports, "hasArsObjectWithName", function () { return (parcelRequire("kDIpz")).hasArsObjectWithName; });
$parcel$export(module.exports, "ADD_EXTRA_WHERE_CLAUSE", function () { return (parcelRequire("cIJV5")).ADD_EXTRA_WHERE_CLAUSE; });
$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return (parcelRequire("cIJV5")).CURRENT_HIERARCHY_ID; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return (parcelRequire("cIJV5")).PATCH_ARS_STATE; });
$parcel$export(module.exports, "REMOVE_WHERE_CLAUSE", function () { return (parcelRequire("cIJV5")).REMOVE_WHERE_CLAUSE; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return (parcelRequire("cIJV5")).SET_SIDEBAR_ANALYSIS_METHOD_ID; });
$parcel$export(module.exports, "SET_SIDEBAR_DATASET", function () { return (parcelRequire("cIJV5")).SET_SIDEBAR_DATASET; });
$parcel$export(module.exports, "SET_SIDEBAR_FILTER", function () { return (parcelRequire("cIJV5")).SET_SIDEBAR_FILTER; });
$parcel$export(module.exports, "SET_SIDEBAR_VIEW", function () { return (parcelRequire("cIJV5")).SET_SIDEBAR_VIEW; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return (parcelRequire("cIJV5")).SET_VARIABLES_IN_USE; });
$parcel$export(module.exports, "MultipleDatasetCheck", function () { return (parcelRequire("ihppY")).MultipleDatasetCheck; });
parcelRequire("1vUkc");
parcelRequire("fZCs4");
parcelRequire("eoLh7");
parcelRequire("3CgTd");
parcelRequire("kDIpz");
parcelRequire("cIJV5");
parcelRequire("ihppY");

});
parcelRegister("1vUkc", function(module, exports) {

$parcel$export(module.exports, "ArsContext", function () { return $20d571d7c19715f7$export$8498abec16db8a5d; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");
const $20d571d7c19715f7$export$a81908c0103a1f28 = {
    // Read-only reference data
    comparators: [],
    variables: [],
    // Editable/sharable lists
    analyses: {},
    analysisMethods: {},
    analysisSets: {},
    caseWhenConditions: {},
    dataSubsets: {},
    groupingFactors: {},
    // UI state
    changed: false,
    datasetsInUse: new Set(),
    disableAnalysisMethodEdit: false,
    editorDefns: (0, $jP37Y.defaultEditorDefns),
    uiRequestStatus: {
        requesting: false,
        error: false
    },
    variablesInUse: new Set(),
    // Undo/redo state
    patches: [],
    ixPatch: -1,
    // Sidebar state
    currentSidebar: {
        isOpen: true,
        view: "groupingFactor",
        filter: ""
    }
};
const $20d571d7c19715f7$export$8498abec16db8a5d = (0, $7fPBF.createContext)({
    state: $20d571d7c19715f7$export$a81908c0103a1f28,
    dispatch: // istanbul ignore next
    ()=>{}
});

});

parcelRegister("fZCs4", function(module, exports) {

$parcel$export(module.exports, "ArsContextProvider", function () { return $400cef9b7ef52e07$export$e673e34db547c51c; });
$parcel$export(module.exports, "useArsContext", function () { return $400cef9b7ef52e07$export$9f8067ef80b208f8; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("2nuru");
var $8FPZx = parcelRequire("8FPZx");

var $1vUkc = parcelRequire("1vUkc");

var $eoLh7 = parcelRequire("eoLh7");

var $cIJV5 = parcelRequire("cIJV5");
const $400cef9b7ef52e07$var$contextMenuStyle = {
    outline: "none",
    width: "100%",
    height: "100%"
};
const $400cef9b7ef52e07$export$e673e34db547c51c = ({ children: children, analyses: analyses, analysisMethods: analysisMethods, analysisSets: analysisSets, caseWhenConditions: caseWhenConditions, comparators: comparators, dataSubsets: dataSubsets, disableAnalysisMethodEdit: disableAnalysisMethodEdit = false, editorDefns: editorDefns, groupingFactors: groupingFactors, initialSidebarView: initialSidebarView = "groupingFactor", updateARS: updateARS, variables: variables })=>{
    const initialDataState = (0, $7fPBF.useMemo)(()=>({
            analyses: (0, $8FPZx.mapById)(analyses),
            analysisMethods: (0, $8FPZx.mapById)(analysisMethods),
            analysisSets: (0, $8FPZx.mapById)(analysisSets),
            caseWhenConditions: (0, $8FPZx.mapById)(caseWhenConditions),
            changed: false,
            comparators: comparators,
            dataSubsets: (0, $8FPZx.mapById)(dataSubsets),
            datasetsInUse: new Set(),
            disableAnalysisMethodEdit: disableAnalysisMethodEdit,
            editorDefns: editorDefns,
            groupingFactors: (0, $8FPZx.mapById)(groupingFactors),
            uiRequestStatus: {
                requesting: false,
                error: false
            },
            variables: variables,
            variablesInUse: new Set()
        }), [
        analyses,
        analysisMethods,
        analysisSets,
        caseWhenConditions,
        comparators,
        dataSubsets,
        disableAnalysisMethodEdit,
        editorDefns,
        groupingFactors,
        variables
    ]);
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $eoLh7.arsContextReducer), {
        ...initialDataState,
        editorDefns: editorDefns,
        patches: [],
        ixPatch: -1,
        currentSidebar: {
            filter: "",
            isOpen: true,
            view: initialSidebarView
        }
    });
    /**
   * Toggles the sidebar open state from the ARS context menu.
   */ const handleToggleSidebar = ()=>{
        dispatch({
            operation: (0, $cIJV5.TOGGLE_SIDEBAR)
        });
    };
    const contextMenuItems = [
        {
            label: state.currentSidebar.isOpen ? "Hide sidebar" : "Show sidebar",
            action: handleToggleSidebar
        }
    ];
    (0, $7fPBF.useEffect)(()=>{
        const eq = (0, $gSkQi.isEqual)(state, initialDataState);
        // Send changes up
        /* istanbul ignore else */ if (state.changed && !eq) {
            updateARS(state);
            dispatch({
                operation: (0, $cIJV5.ARS_CHANGE_SENT)
            });
        } else if (!state.changed && !eq) {
            const updates = [];
            if (!(0, $gSkQi.isEqual)(analyses, Object.values(state.analyses))) updates.push({
                dataPath: "/analyses",
                value: (0, $8FPZx.mapById)(analyses)
            });
            if (!(0, $gSkQi.isEqual)(analysisMethods, Object.values(state.analysisMethods))) updates.push({
                dataPath: "/analysisMethods",
                value: (0, $8FPZx.mapById)(analysisMethods)
            });
            if (!(0, $gSkQi.isEqual)(analysisSets, Object.values(state.analysisSets))) updates.push({
                dataPath: "/analysisSets",
                value: (0, $8FPZx.mapById)(analysisSets)
            });
            if (!(0, $gSkQi.isEqual)(caseWhenConditions, Object.values(state.caseWhenConditions))) updates.push({
                dataPath: "/caseWhenConditions",
                value: (0, $8FPZx.mapById)(caseWhenConditions)
            });
            if (!(0, $gSkQi.isEqual)(dataSubsets, Object.values(state.dataSubsets))) updates.push({
                dataPath: "/dataSubsets",
                value: (0, $8FPZx.mapById)(dataSubsets)
            });
            if (!(0, $gSkQi.isEqual)(groupingFactors, Object.values(state.groupingFactors))) updates.push({
                dataPath: "/groupingFactors",
                value: (0, $8FPZx.mapById)(groupingFactors)
            });
            if (!(0, $gSkQi.isEqual)(variables, state.variables)) updates.push({
                dataPath: "/variables",
                value: variables
            });
            if (!(0, $gSkQi.isEqual)(comparators, state.comparators)) updates.push({
                dataPath: "/comparators",
                value: comparators
            });
            if (updates.length > 0) dispatch({
                operation: (0, $cIJV5.LOAD_ARS_PATCH),
                updates: updates
            });
        }
    }, [
        analyses,
        analysisMethods,
        analysisSets,
        caseWhenConditions,
        comparators,
        dataSubsets,
        groupingFactors,
        initialDataState,
        state,
        updateARS,
        variables
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1vUkc.ArsContext).Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
            tabIndex: -1,
            style: $400cef9b7ef52e07$var$contextMenuStyle,
            menuItems: contextMenuItems,
            children: children
        })
    });
};
$400cef9b7ef52e07$export$e673e34db547c51c.displayName = "ArsContextProvider";
const $400cef9b7ef52e07$export$9f8067ef80b208f8 = ()=>{
    const context = (0, $7fPBF.useContext)((0, $1vUkc.ArsContext));
    return context;
};

});
parcelRegister("eoLh7", function(module, exports) {

$parcel$export(module.exports, "arsContextReducer", function () { return $497c4f477171936e$export$e206421faa69fe86; });
parcelRequire("lJFJ8");
var $lHBsX = parcelRequire("lHBsX");
var $cS2B3 = parcelRequire("cS2B3");
var $jE6rq = parcelRequire("jE6rq");
var $d6PjO = parcelRequire("d6PjO");
var $1uVjM = parcelRequire("1uVjM");
var $lxahc = parcelRequire("lxahc");
var $1MNFJ = parcelRequire("1MNFJ");
var $64MNY = parcelRequire("64MNY");
var $etlyI = parcelRequire("etlyI");
var $03TIL = parcelRequire("03TIL");
var $84Bax = parcelRequire("84Bax");
var $iIZ6k = parcelRequire("iIZ6k");
var $afscR = parcelRequire("afscR");
var $lp2xD = parcelRequire("lp2xD");
var $czMJ8 = parcelRequire("czMJ8");
var $6FHig = parcelRequire("6FHig");
var $cpput = parcelRequire("cpput");
var $ayftj = parcelRequire("ayftj");

var $cIJV5 = parcelRequire("cIJV5");
const $497c4f477171936e$export$e206421faa69fe86 = (state, action)=>{
    switch(action.operation){
        case 0, $cIJV5.ADD_EXTRA_WHERE_CLAUSE:
            return (0, $lHBsX.arsc_addExtraWhereClause)(state, action);
        case 0, $cIJV5.ARS_CHANGE_SENT:
            return (0, $jE6rq.arsc_changeSent)(state);
        case 0, $cIJV5.ADD_NOT_TO_WHERE_CLAUSE:
            return (0, $cS2B3.arsc_addNotToWhereClause)(state, action);
        case 0, $cIJV5.LOAD_ARS_PATCH:
            return (0, $d6PjO.arsc_loadArsPatch)(state, action);
        case 0, $cIJV5.PATCH_ARS_STATE:
            return (0, $1uVjM.arsc_patchArsState)(state, action);
        case 0, $cIJV5.REMOVE_ARS_ITEM:
            return (0, $1MNFJ.arsc_removeArsItem)(state, action);
        case 0, $cIJV5.REMOVE_NOT_FROM_WHERE_CLAUSE:
            return (0, $64MNY.arsc_removeNotFromWhereClause)(state, action);
        case 0, $cIJV5.REDO_ARS_CHANGE:
            return (0, $lxahc.arsc_redoArsChange)(state, action);
        case 0, $cIJV5.REMOVE_WHERE_CLAUSE:
            return (0, $etlyI.arsc_removeWhereClause)(state, action);
        case 0, $cIJV5.SET_SIDEBAR_VIEW:
            return (0, $afscR.arsc_setSidebarView)(state, action);
        case 0, $cIJV5.SET_SIDEBAR_ANALYSIS_METHOD_ID:
            return (0, $03TIL.arsc_setSidebarAnalysisMethodId)(state, action);
        case 0, $cIJV5.SET_SIDEBAR_DATASET:
            return (0, $84Bax.arsc_setSidebarDataset)(state, action);
        case 0, $cIJV5.SET_SIDEBAR_FILTER:
            return (0, $iIZ6k.arsc_setSidebarFilter)(state, action);
        case 0, $cIJV5.SET_SIDEBAR_WIDTH:
            return (0, $lp2xD.arsc_setSidebarWidth)(state, action);
        case 0, $cIJV5.SET_UI_REQUEST_STATUS:
            return (0, $czMJ8.arsc_setUiRequestStatus)(state, action);
        case 0, $cIJV5.SET_VARIABLES_IN_USE:
            return (0, $6FHig.arsc_setVariablesInUse)(state, action);
        case 0, $cIJV5.TOGGLE_SIDEBAR:
            return (0, $cpput.arsc_toggleSidebar)(state, action);
        case 0, $cIJV5.UNDO_ARS_CHANGE:
            return (0, $ayftj.arsc_undoArsChange)(state, action);
        default:
            return state;
    }
};

});
parcelRegister("lJFJ8", function(module, exports) {
$parcel$export(module.exports, "arsc_addExtraWhereClause", function () { return (parcelRequire("lHBsX")).arsc_addExtraWhereClause; });
$parcel$export(module.exports, "arsc_addNotToWhereClause", function () { return (parcelRequire("cS2B3")).arsc_addNotToWhereClause; });
$parcel$export(module.exports, "arsc_changeSent", function () { return (parcelRequire("jE6rq")).arsc_changeSent; });
$parcel$export(module.exports, "arsc_loadArsPatch", function () { return (parcelRequire("d6PjO")).arsc_loadArsPatch; });
$parcel$export(module.exports, "arsc_patchArsState", function () { return (parcelRequire("1uVjM")).arsc_patchArsState; });
$parcel$export(module.exports, "arsc_redoArsChange", function () { return (parcelRequire("lxahc")).arsc_redoArsChange; });
$parcel$export(module.exports, "arsc_removeArsItem", function () { return (parcelRequire("1MNFJ")).arsc_removeArsItem; });
$parcel$export(module.exports, "arsc_removeNotFromWhereClause", function () { return (parcelRequire("64MNY")).arsc_removeNotFromWhereClause; });
$parcel$export(module.exports, "arsc_removeWhereClause", function () { return (parcelRequire("etlyI")).arsc_removeWhereClause; });
$parcel$export(module.exports, "arsc_setSidebarAnalysisMethodId", function () { return (parcelRequire("03TIL")).arsc_setSidebarAnalysisMethodId; });
$parcel$export(module.exports, "arsc_setSidebarDataset", function () { return (parcelRequire("84Bax")).arsc_setSidebarDataset; });
$parcel$export(module.exports, "arsc_setSidebarFilter", function () { return (parcelRequire("iIZ6k")).arsc_setSidebarFilter; });
$parcel$export(module.exports, "arsc_setSidebarView", function () { return (parcelRequire("afscR")).arsc_setSidebarView; });
$parcel$export(module.exports, "arsc_setSidebarWidth", function () { return (parcelRequire("lp2xD")).arsc_setSidebarWidth; });
$parcel$export(module.exports, "arsc_setUiRequestStatus", function () { return (parcelRequire("czMJ8")).arsc_setUiRequestStatus; });
$parcel$export(module.exports, "arsc_setVariablesInUse", function () { return (parcelRequire("6FHig")).arsc_setVariablesInUse; });
$parcel$export(module.exports, "arsc_toggleSidebar", function () { return (parcelRequire("cpput")).arsc_toggleSidebar; });
$parcel$export(module.exports, "arsc_undoArsChange", function () { return (parcelRequire("ayftj")).arsc_undoArsChange; });
parcelRequire("lHBsX");
parcelRequire("cS2B3");
parcelRequire("jE6rq");
parcelRequire("d6PjO");
parcelRequire("1uVjM");
parcelRequire("6YHm6");
parcelRequire("lxahc");
parcelRequire("1MNFJ");
parcelRequire("64MNY");
parcelRequire("etlyI");
parcelRequire("03TIL");
parcelRequire("84Bax");
parcelRequire("iIZ6k");
parcelRequire("afscR");
parcelRequire("lp2xD");
parcelRequire("czMJ8");
parcelRequire("6FHig");
parcelRequire("cpput");
parcelRequire("ayftj");

});
parcelRegister("lHBsX", function(module, exports) {

$parcel$export(module.exports, "arsc_addExtraWhereClause", function () { return $6541e28b01a288e2$export$82d2d4cb4703cd00; });

var $gSkQi = parcelRequire("gSkQi");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("6yroJ");
var $6Ugly = parcelRequire("6Ugly");
var $jc9tE = parcelRequire("jc9tE");

var $6YHm6 = parcelRequire("6YHm6");
const $6541e28b01a288e2$export$82d2d4cb4703cd00 = (state, action)=>{
    const whereClause = (0, $eAPMz.getFromDataPath)(action.dataPath, state, (0, $6Ugly.isWhereClause));
    if (!whereClause) throw new Error(`Invalid dataPath for ADD_EXTRA_WHERE_CLAUSE: ${action.dataPath}`);
    if ((0, $jc9tE.isWhereClauseWithCondition)(whereClause)) {
        const newCompoundExpression = {
            logicalOperator: (0, $1cA0K.ExpressionLogicalOperatorEnum).AND,
            whereClauses: [
                {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    condition: whereClause.condition,
                    level: whereClause.level + 1,
                    order: 0
                },
                {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    condition: {},
                    level: whereClause.level + 1,
                    order: 1
                }
            ]
        };
        const newEntity = {
            ...(0, $gSkQi.omit)(whereClause, "condition"),
            compoundExpression: newCompoundExpression,
            level: whereClause.level,
            order: whereClause.order
        };
        return (0, $6YHm6.addPatchToStack)(state, (0, $dsPLF.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newEntity));
    }
    const ce = whereClause.compoundExpression;
    const newClause = {
        id: crypto.randomUUID(),
        subClauseId: "",
        condition: {},
        level: ce.whereClauses?.[0]?.level ?? // istanbul ignore next
        1,
        order: (ce.whereClauses ?? // istanbul ignore next
        []).length
    };
    const newWhereClauses = [
        ...ce.whereClauses ?? // istanbul ignore next
        [],
        newClause
    ];
    const newCompoundExpression = {
        ...ce,
        logicalOperator: ce.logicalOperator === (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT ? (0, $1cA0K.ExpressionLogicalOperatorEnum).AND : ce.logicalOperator,
        whereClauses: newWhereClauses
    };
    return (0, $6YHm6.addPatchToStack)(state, (0, $dsPLF.mutateByPath)({
        ...state,
        changed: true
    }, `${action.dataPath}/compoundExpression`, newCompoundExpression));
};

});
parcelRegister("6yroJ", function(module, exports) {
$parcel$export(module.exports, "isAnalysisMethod", function () { return (parcelRequire("ek4hO")).isAnalysisMethod; });
$parcel$export(module.exports, "isAnalysisOutputProgrammingCodeValue", function () { return (parcelRequire("bdF2Z")).isAnalysisOutputProgrammingCodeValue; });
$parcel$export(module.exports, "isAnalysisProgrammingCodeTemplate", function () { return (parcelRequire("ICeOG")).isAnalysisProgrammingCodeTemplate; });
$parcel$export(module.exports, "isAnalysisSet", function () { return (parcelRequire("gzOGG")).isAnalysisSet; });
$parcel$export(module.exports, "isCaseWhenCondition", function () { return (parcelRequire("cGJVG")).isCaseWhenCondition; });
$parcel$export(module.exports, "isCaseWhenItem", function () { return (parcelRequire("484ww")).isCaseWhenItem; });
$parcel$export(module.exports, "isDataSubset", function () { return (parcelRequire("74VXB")).isDataSubset; });
$parcel$export(module.exports, "isGroup", function () { return (parcelRequire("4aFWD")).isGroup; });
$parcel$export(module.exports, "isGroupingFactor", function () { return (parcelRequire("4AU0o")).isGroupingFactor; });
$parcel$export(module.exports, "isObjectRecord", function () { return (parcelRequire("8CFpa")).isObjectRecord; });
$parcel$export(module.exports, "isOperation", function () { return (parcelRequire("hoYmS")).isOperation; });
$parcel$export(module.exports, "isSubClauseWithCompoundExpression", function () { return (parcelRequire("fAJMp")).isSubClauseWithCompoundExpression; });
$parcel$export(module.exports, "isSubClauseWithCondition", function () { return (parcelRequire("cNv0d")).isSubClauseWithCondition; });
$parcel$export(module.exports, "isSubClauseWithReference", function () { return (parcelRequire("5KlUB")).isSubClauseWithReference; });
$parcel$export(module.exports, "isWhereClause", function () { return (parcelRequire("6Ugly")).isWhereClause; });
$parcel$export(module.exports, "isWhereClauseWithCompoundExpression", function () { return (parcelRequire("kC2sO")).isWhereClauseWithCompoundExpression; });
$parcel$export(module.exports, "isWhereClauseWithCondition", function () { return (parcelRequire("jc9tE")).isWhereClauseWithCondition; });
parcelRequire("aJVDk");
parcelRequire("ek4hO");
parcelRequire("4ePeZ");
parcelRequire("bdF2Z");
parcelRequire("ICeOG");
parcelRequire("gzOGG");
parcelRequire("4qgA8");
parcelRequire("cGJVG");
parcelRequire("484ww");
parcelRequire("74VXB");
parcelRequire("iwmqf");
parcelRequire("aAcTg");
parcelRequire("4aFWD");
parcelRequire("4AU0o");
parcelRequire("lDUyo");
parcelRequire("8ENpM");
parcelRequire("bR6qc");
parcelRequire("4FNuj");
parcelRequire("8CFpa");
parcelRequire("hoYmS");
parcelRequire("jvEhp");
parcelRequire("fetPG");
parcelRequire("gl7IP");
parcelRequire("fAJMp");
parcelRequire("cNv0d");
parcelRequire("5KlUB");
parcelRequire("8YNmV");
parcelRequire("6Ugly");
parcelRequire("9QI9D");
parcelRequire("3GY9d");
parcelRequire("kC2sO");
parcelRequire("jc9tE");

});
parcelRegister("aJVDk", function(module, exports) {

$parcel$export(module.exports, "isAnalysis", function () { return $e46a3500a997abcf$export$617b58bca42992df; });

var $iwmqf = parcelRequire("iwmqf");

var $aAcTg = parcelRequire("aAcTg");

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");
const $e46a3500a997abcf$export$617b58bca42992df = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $4FNuj.isNamedObject)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (!(0, $aAcTg.isExtensibleTerminologyTerm)(obj.reason)) return false;
    if (!(0, $aAcTg.isExtensibleTerminologyTerm)(obj.purpose)) return false;
    if (typeof obj.methodId !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.version)) return false;
    if (obj.documentRefs !== undefined && (!Array.isArray(obj.documentRefs) || obj.documentRefs.some((documentRef)=>!(0, $iwmqf.isDocumentReference)(documentRef)))) return false;
    return true;
};

});
parcelRegister("iwmqf", function(module, exports) {

$parcel$export(module.exports, "isDocumentReference", function () { return $843eb4f44b8c7921$export$69664ad679805f4e; });

var $8CFpa = parcelRequire("8CFpa");

var $jvEhp = parcelRequire("jvEhp");
const $843eb4f44b8c7921$export$69664ad679805f4e = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.referenceDocumentId !== "string") return false;
    if (obj.pageRefs !== undefined) {
        if (!Array.isArray(obj.pageRefs)) return false;
        if (obj.pageRefs.some((pageRef)=>!(0, $jvEhp.isPageRef)(pageRef))) return false;
    }
    return true;
};

});
parcelRegister("jvEhp", function(module, exports) {

$parcel$export(module.exports, "isPageRef", function () { return $6cfd3c2a9cce93b8$export$f54921fd905b8d5d; });

var $8CFpa = parcelRequire("8CFpa");
const $6cfd3c2a9cce93b8$export$f54921fd905b8d5d = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.refType !== "string") return false;
    if (obj.label !== undefined && typeof obj.label !== "string") return false;
    if (obj.pageNames !== undefined) {
        if (!Array.isArray(obj.pageNames)) return false;
        if (obj.pageNames.some((name)=>typeof name !== "string")) return false;
    }
    if (obj.pageNumbers !== undefined) {
        if (!Array.isArray(obj.pageNumbers)) return false;
        if (obj.pageNumbers.some((pageNumber)=>typeof pageNumber !== "number")) return false;
    }
    if (obj.firstPage !== undefined && typeof obj.firstPage !== "number") return false;
    if (obj.lastPage !== undefined && typeof obj.lastPage !== "number") return false;
    return true;
};

});


parcelRegister("aAcTg", function(module, exports) {

$parcel$export(module.exports, "isExtensibleTerminologyTerm", function () { return $1349cc166633aa0e$export$d43c57bf932db175; });

var $8CFpa = parcelRequire("8CFpa");
const $1349cc166633aa0e$export$d43c57bf932db175 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (obj.controlledTerm !== undefined && typeof obj.controlledTerm !== "string") return false;
    if (obj.sponsorTermId !== undefined && typeof obj.sponsorTermId !== "string") return false;
    if (obj.controlledTerm === undefined && obj.sponsorTermId === undefined) return false;
    return true;
};

});

parcelRegister("4FNuj", function(module, exports) {

$parcel$export(module.exports, "isNamedObject", function () { return $cbb5491080140c2f$export$8f7d4fd01ac01edc; });

var $8CFpa = parcelRequire("8CFpa");
const $cbb5491080140c2f$export$8f7d4fd01ac01edc = (obj)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check properties exist
    if (typeof obj.name !== "string") return false;
    if (obj.description !== undefined && typeof obj.description !== "string") return false;
    if (obj.label !== undefined && typeof obj.label !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("ek4hO", function(module, exports) {

$parcel$export(module.exports, "isAnalysisMethod", function () { return $c65735e937907d25$export$18a4c8014c5fb20f; });

var $ICeOG = parcelRequire("ICeOG");

var $iwmqf = parcelRequire("iwmqf");

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");

var $hoYmS = parcelRequire("hoYmS");
const $c65735e937907d25$export$18a4c8014c5fb20f = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $4FNuj.isNamedObject)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    // Required: operations must be an array of valid Operations
    if (!Array.isArray(obj.operations)) return false;
    if (obj.operations.some((op)=>!(0, $hoYmS.isOperation)(op))) return false;
    // Optional: documentRefs must be an array of valid DocumentReference values
    if (obj.documentRefs !== undefined) {
        if (!Array.isArray(obj.documentRefs)) return false;
        if (obj.documentRefs.some((documentReference)=>!(0, $iwmqf.isDocumentReference)(documentReference))) return false;
    }
    // Optional: codeTemplate must be a valid AnalysisProgrammingCodeTemplate value
    if (obj.codeTemplate !== undefined && !(0, $ICeOG.isAnalysisProgrammingCodeTemplate)(obj.codeTemplate)) return false;
    return true;
};

});
parcelRegister("ICeOG", function(module, exports) {

$parcel$export(module.exports, "isAnalysisProgrammingCodeTemplate", function () { return $6b5e7bf249fb2e2c$export$5eec27d0d9461f05; });

var $iwmqf = parcelRequire("iwmqf");

var $8CFpa = parcelRequire("8CFpa");

var $8YNmV = parcelRequire("8YNmV");
const $6b5e7bf249fb2e2c$export$5eec27d0d9461f05 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.context !== "string") return false;
    if (obj.code !== undefined && typeof obj.code !== "string") return false;
    if (obj.documentRef !== undefined && !(0, $iwmqf.isDocumentReference)(obj.documentRef)) return false;
    if (obj.parameters !== undefined) {
        if (!Array.isArray(obj.parameters)) return false;
        if (obj.parameters.some((parameter)=>!(0, $8YNmV.isTemplateCodeParameter)(parameter))) return false;
    }
    return true;
};

});
parcelRegister("8YNmV", function(module, exports) {

$parcel$export(module.exports, "isTemplateCodeParameter", function () { return $a6218a626e9b522b$export$6d20581905e381a8; });

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");
const $a6218a626e9b522b$export$6d20581905e381a8 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $4FNuj.isNamedObject)(obj)) return false;
    if (typeof obj.valueSource !== "string" || ![
        "groupingFactor",
        "operation"
    ].includes(obj.valueSource)) return false;
    if (obj.value !== undefined && (!Array.isArray(obj.value) || obj.value.some((value)=>typeof value !== "string"))) return false;
    if (typeof obj.parameterType !== "string" || ![
        "string",
        "number",
        "boolean",
        "stringList",
        "numberList",
        "select",
        "multiSelect",
        "dataset.variable"
    ].includes(obj.parameterType)) return false;
    if (obj.availableValues !== undefined && (!Array.isArray(obj.availableValues) || obj.availableValues.some((value)=>typeof value !== "string"))) return false;
    /* Everything is good */ return true;
};

});


parcelRegister("hoYmS", function(module, exports) {

$parcel$export(module.exports, "isOperation", function () { return $862b20067472a3a3$export$13853810e01af068; });

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");

var $fetPG = parcelRequire("fetPG");
const $862b20067472a3a3$export$13853810e01af068 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $4FNuj.isNamedObject)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.order !== "number") return false;
    // Optional: resultPattern must be a string if present
    if (obj.resultPattern !== undefined && typeof obj.resultPattern !== "string") return false;
    // Optional: referencedOperationRelationships must be an array if present,
    // and each element must be a valid ReferencedOperationRelationship
    if (obj.referencedOperationRelationships !== undefined) {
        if (!Array.isArray(obj.referencedOperationRelationships)) return false;
        if (obj.referencedOperationRelationships.some((rel)=>!(0, $fetPG.isReferencedOperationRelationship)(rel))) return false;
    }
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.denominatorOnly)) return false;
    return true;
};

});
parcelRegister("fetPG", function(module, exports) {

$parcel$export(module.exports, "isReferencedOperationRelationship", function () { return $9753d50af1319955$export$b872dcc21978c18f; });

var $aAcTg = parcelRequire("aAcTg");

var $8CFpa = parcelRequire("8CFpa");
const $9753d50af1319955$export$b872dcc21978c18f = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.operationId !== "string") return false;
    if (!(0, $aAcTg.isExtensibleTerminologyTerm)(obj.referencedOperationRole)) return false;
    if (obj.analysisId !== undefined && typeof obj.analysisId !== "string") return false;
    if (obj.description !== undefined && typeof obj.description !== "string") return false;
    return true;
};

});



parcelRegister("4ePeZ", function(module, exports) {

$parcel$export(module.exports, "isAnalysisOutputCodeParameter", function () { return $d3be1f15f6464691$export$237bc416e5e84312; });

var $8CFpa = parcelRequire("8CFpa");
const $d3be1f15f6464691$export$237bc416e5e84312 = (obj)=>{
    // Check type
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check Properties
    if (!Array.isArray(obj.value) || obj.value.some((value)=>typeof value !== "string")) return false;
    if (typeof obj.name !== "string") return false;
    if ([
        "string",
        "undefined"
    ].includes(typeof obj.description) === false) return false;
    if ([
        "string",
        "undefined"
    ].includes(typeof obj.label) === false) return false;
    // Everything is good
    return true;
};

});

parcelRegister("bdF2Z", function(module, exports) {

$parcel$export(module.exports, "isAnalysisOutputProgrammingCodeValue", function () { return $b0745583556304bd$export$3de1f488c0332f3b; });

var $4ePeZ = parcelRequire("4ePeZ");

var $iwmqf = parcelRequire("iwmqf");

var $8CFpa = parcelRequire("8CFpa");
const $b0745583556304bd$export$3de1f488c0332f3b = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.context !== "string") return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.code)) return false;
    if (obj.documentRef !== undefined && !(0, $iwmqf.isDocumentReference)(obj.documentRef)) return false;
    if (obj.parameters !== undefined && (!Array.isArray(obj.parameters) || obj.parameters.some((param)=>!(0, $4ePeZ.isAnalysisOutputCodeParameter)(param)))) return false;
    return true;
};

});

parcelRegister("gzOGG", function(module, exports) {

$parcel$export(module.exports, "isAnalysisSet", function () { return $25f0f2ae4e8ba860$export$14fdd86edf0a5540; });

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");

var $6Ugly = parcelRequire("6Ugly");
const $25f0f2ae4e8ba860$export$14fdd86edf0a5540 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check NamedObject and WhereClause
    if (!(0, $4FNuj.isNamedObject)(obj) || !(0, $6Ugly.isWhereClause)(obj)) return false;
    // Check id
    if (typeof obj.id !== "string") return false;
    // Everything is good
    return true;
};

});
parcelRegister("6Ugly", function(module, exports) {

$parcel$export(module.exports, "isWhereClause", function () { return $d579c4727866a10f$export$2c9b8aab4e488ca5; });

var $kC2sO = parcelRequire("kC2sO");

var $jc9tE = parcelRequire("jc9tE");
const $d579c4727866a10f$export$2c9b8aab4e488ca5 = (obj)=>{
    return (0, $jc9tE.isWhereClauseWithCondition)(obj) || (0, $kC2sO.isWhereClauseWithCompoundExpression)(obj);
};

});
parcelRegister("kC2sO", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseWithCompoundExpression", function () { return $7d1e8dd41f913dff$export$5a5d6d060341749a; });

var $bR6qc = parcelRequire("bR6qc");

var $8CFpa = parcelRequire("8CFpa");

var $9QI9D = parcelRequire("9QI9D");
const $7d1e8dd41f913dff$export$5a5d6d060341749a = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $bR6qc.isLevelOrder)(obj)) return false;
    // Must have a valid compoundExpression
    if (!(0, $9QI9D.isWhereClauseCompoundExpression)(objectRecord.compoundExpression)) return false;
    // Must not have condition property
    if (objectRecord.condition !== undefined) return false;
    return true;
};

});
parcelRegister("bR6qc", function(module, exports) {

$parcel$export(module.exports, "isLevelOrder", function () { return $65e20114a37004fe$export$3039618a6f988e1d; });

var $8CFpa = parcelRequire("8CFpa");
const $65e20114a37004fe$export$3039618a6f988e1d = (obj)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check properties exist
    if (typeof obj.level !== "number") return false;
    if (typeof obj.order !== "number") return false;
    // Everything is good
    return true;
};

});

parcelRegister("9QI9D", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseCompoundExpression", function () { return $44b53734ec3c296d$export$84b60981a7879d23; });

var $1cA0K = parcelRequire("1cA0K");

var $8CFpa = parcelRequire("8CFpa");

var $gl7IP = parcelRequire("gl7IP");
const $44b53734ec3c296d$export$84b60981a7879d23 = (obj)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check properties exist
    if (!Object.values((0, $1cA0K.ExpressionLogicalOperatorEnum)).includes(obj.logicalOperator)) return false;
    if (obj.whereClauses !== undefined && (!Array.isArray(obj.whereClauses) || obj.whereClauses.some((item)=>!(0, $gl7IP.isSubClause)(item)))) return false;
    // Validate logical operator constraints
    const whereClausesCount = Array.isArray(obj.whereClauses) ? obj.whereClauses.length : 0;
    // If NOT, max 1 whereClause
    if (obj.logicalOperator === (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT && whereClausesCount > 1) return false;
    // Everything is good
    return true;
};

});
parcelRegister("gl7IP", function(module, exports) {

$parcel$export(module.exports, "isSubClause", function () { return $1be7a1235a975f16$export$7ff1e2a1f10ca427; });

var $fAJMp = parcelRequire("fAJMp");

var $cNv0d = parcelRequire("cNv0d");

var $5KlUB = parcelRequire("5KlUB");
const $1be7a1235a975f16$export$7ff1e2a1f10ca427 = (obj)=>{
    return (0, $cNv0d.isSubClauseWithCondition)(obj) || (0, $fAJMp.isSubClauseWithCompoundExpression)(obj) || (0, $5KlUB.isSubClauseWithReference)(obj);
};

});
parcelRegister("fAJMp", function(module, exports) {

$parcel$export(module.exports, "isSubClauseWithCompoundExpression", function () { return $d3a94744eb90d8b4$export$68e2647985da6ebf; });

var $bR6qc = parcelRequire("bR6qc");

var $8CFpa = parcelRequire("8CFpa");

var $9QI9D = parcelRequire("9QI9D");
const $d3a94744eb90d8b4$export$68e2647985da6ebf = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $bR6qc.isLevelOrder)(obj)) return false;
    // Check id is a non-blank string
    if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;
    // Check subClauseId is "" (empty string for non-referenced clauses)
    if (objectRecord.subClauseId !== "") return false;
    // Must have a valid compoundExpression
    if (!(0, $9QI9D.isWhereClauseCompoundExpression)(objectRecord.compoundExpression)) return false;
    // Must not have condition property
    if (objectRecord.condition !== undefined) return false;
    return true;
};

});

parcelRegister("cNv0d", function(module, exports) {

$parcel$export(module.exports, "isSubClauseWithCondition", function () { return $763bb042acba0603$export$e0a1c5e124a468e6; });

var $bR6qc = parcelRequire("bR6qc");

var $8CFpa = parcelRequire("8CFpa");

var $3GY9d = parcelRequire("3GY9d");
const $763bb042acba0603$export$e0a1c5e124a468e6 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $bR6qc.isLevelOrder)(obj)) return false;
    // Check id is a non-blank string
    if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;
    // Check subClauseId is "" (empty string for non-referenced clauses)
    if (objectRecord.subClauseId !== "") return false;
    // Must have a valid condition
    if (!(0, $3GY9d.isWhereClauseCondition)(objectRecord.condition)) return false;
    // Must not have compoundExpression property
    if (objectRecord.compoundExpression !== undefined) return false;
    return true;
};

});
parcelRegister("3GY9d", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseCondition", function () { return $a70062e0f346cfbe$export$df0591a812ecba90; });

var $8CFpa = parcelRequire("8CFpa");
const $a70062e0f346cfbe$export$df0591a812ecba90 = (value)=>{
    if (!(0, $8CFpa.isObjectRecord)(value)) return false;
    // Check strings
    if (![
        "undefined",
        "string"
    ].includes(typeof value.dataset)) return false;
    if (![
        "undefined",
        "string"
    ].includes(typeof value.variable)) return false;
    if (![
        "undefined",
        "string"
    ].includes(typeof value.comparator)) return false;
    // Check value array
    if (value.value !== undefined && (!Array.isArray(value.value) || !value.value.every((v)=>typeof v === "string"))) return false;
    // Everything is good
    return true;
};

});


parcelRegister("5KlUB", function(module, exports) {

$parcel$export(module.exports, "isSubClauseWithReference", function () { return $728b4869be77cd49$export$279cd76c77d09678; });

var $bR6qc = parcelRequire("bR6qc");

var $8CFpa = parcelRequire("8CFpa");
const $728b4869be77cd49$export$279cd76c77d09678 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $bR6qc.isLevelOrder)(obj)) return false;
    // Check id is a non-blank string
    if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;
    // Check subClauseId is a non-blank string
    if (typeof objectRecord.subClauseId !== "string" || objectRecord.subClauseId === "") return false;
    // Must not have condition property
    if (objectRecord.condition !== undefined) return false;
    // Must not have compoundExpression property
    if (objectRecord.compoundExpression !== undefined) return false;
    return true;
};

});




parcelRegister("jc9tE", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseWithCondition", function () { return $188b7ec4e00aaae5$export$2f7410233cb1ab51; });

var $bR6qc = parcelRequire("bR6qc");

var $8CFpa = parcelRequire("8CFpa");

var $3GY9d = parcelRequire("3GY9d");
const $188b7ec4e00aaae5$export$2f7410233cb1ab51 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $bR6qc.isLevelOrder)(obj)) return false;
    // Must have a valid condition
    if (!(0, $3GY9d.isWhereClauseCondition)(objectRecord.condition)) return false;
    // Must not have compoundExpression property
    if (objectRecord.compoundExpression !== undefined) return false;
    return true;
};

});



parcelRegister("4qgA8", function(module, exports) {

$parcel$export(module.exports, "isAnnotationVariable", function () { return $2fe8c8f82fcd44ff$export$62d7bd2ac80ebe0f; });

var $8CFpa = parcelRequire("8CFpa");
const $2fe8c8f82fcd44ff$export$62d7bd2ac80ebe0f = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.value !== "string") return false;
    if (typeof obj.oid !== "string") return false;
    if (typeof obj.name !== "string") return false;
    if (typeof obj.dataType !== "string") return false;
    if (typeof obj.length !== "number") return false;
    if (typeof obj.description !== "string") return false;
    if (typeof obj.dataset !== "string") return false;
    if (![
        "number",
        "string",
        "undefined"
    ].includes(typeof obj.codeList)) return false;
    return true;
};

});

parcelRegister("cGJVG", function(module, exports) {

$parcel$export(module.exports, "isCaseWhenCondition", function () { return $2525cbb438a6cae3$export$85ab7521cb4ddb45; });

var $484ww = parcelRequire("484ww");

var $8CFpa = parcelRequire("8CFpa");
const $2525cbb438a6cae3$export$85ab7521cb4ddb45 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (!Array.isArray(obj.caseWhenItems)) return false;
    if (obj.caseWhenItems.some((item)=>!(0, $484ww.isCaseWhenItem)(item, isT))) return false;
    return true;
};

});
parcelRegister("484ww", function(module, exports) {

$parcel$export(module.exports, "isCaseWhenItem", function () { return $3b6aa6aa4dc61e13$export$880314432ed2ddf0; });

var $8CFpa = parcelRequire("8CFpa");

var $6Ugly = parcelRequire("6Ugly");
const $3b6aa6aa4dc61e13$export$880314432ed2ddf0 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (!isT(obj.thenDisplayPattern)) return false;
    if (typeof obj.thenResultPattern !== "string") return false;
    if (obj.when !== null && !(0, $6Ugly.isWhereClause)(obj.when)) return false;
    // Everything is good
    return true;
};

});


parcelRegister("74VXB", function(module, exports) {

$parcel$export(module.exports, "isDataSubset", function () { return $60d1f9d0cb4ff160$export$8c73c4b825c9c990; });

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");

var $6Ugly = parcelRequire("6Ugly");
const $60d1f9d0cb4ff160$export$8c73c4b825c9c990 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check NamedObject and WhereClause
    if (!(0, $4FNuj.isNamedObject)(obj) || !(0, $6Ugly.isWhereClause)(obj)) return false;
    // Check id
    if (typeof obj.id !== "string") return false;
    // Check uniqueSubjects if present
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.uniqueSubjects)) return false;
    // Check uniqueDataSet if present
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.uniqueDataSet)) return false;
    // Check uniqueVariables if present
    if (obj.uniqueVariables !== undefined && !(Array.isArray(obj.uniqueVariables) && obj.uniqueVariables.every((v)=>typeof v === "string"))) return false;
    // Everything is good
    return true;
};

});

parcelRegister("4aFWD", function(module, exports) {

$parcel$export(module.exports, "isGroup", function () { return $29641da2607366d6$export$d7976824e9f55785; });

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");

var $6Ugly = parcelRequire("6Ugly");
const $29641da2607366d6$export$d7976824e9f55785 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check NamedObject and WhereClause
    if (!(0, $4FNuj.isNamedObject)(obj) || !(0, $6Ugly.isWhereClause)(obj)) return false;
    // Check id
    if (typeof obj.id !== "string") return false;
    // Everything is good
    return true;
};

});

parcelRegister("4AU0o", function(module, exports) {

$parcel$export(module.exports, "isGroupingFactor", function () { return $ced0321c0be876c0$export$b662cc52f4a905e8; });

var $lDUyo = parcelRequire("lDUyo");

var $8ENpM = parcelRequire("8ENpM");
const $ced0321c0be876c0$export$b662cc52f4a905e8 = (obj)=>{
    return (0, $lDUyo.isGroupingFactorDataDriven)(obj) || (0, $8ENpM.isGroupingFactorWithGroups)(obj);
};

});
parcelRegister("lDUyo", function(module, exports) {

$parcel$export(module.exports, "isGroupingFactorDataDriven", function () { return $90cd752270c3b6e0$export$d792980dd40fdeec; });

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");
const $90cd752270c3b6e0$export$d792980dd40fdeec = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check NamedObject properties
    if (!(0, $4FNuj.isNamedObject)(obj)) return false;
    // Check required properties and their types
    if (obj.dataDriven !== true) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.groupingDataset !== "string") return false;
    if (typeof obj.groupingVariable !== "string") return false;
    if (!Array.isArray(obj.dataValues)) return false;
    if (obj.dataValues.some((v)=>typeof v !== "string")) return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.fromHierarchyId)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("8ENpM", function(module, exports) {

$parcel$export(module.exports, "isGroupingFactorWithGroups", function () { return $8a1ed524189ad714$export$565b5810163ecf52; });

var $4aFWD = parcelRequire("4aFWD");

var $4FNuj = parcelRequire("4FNuj");

var $8CFpa = parcelRequire("8CFpa");
const $8a1ed524189ad714$export$565b5810163ecf52 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check NamedObject properties
    if (!(0, $4FNuj.isNamedObject)(obj)) return false;
    // Check required properties and their types
    if (typeof obj.id !== "string") return false;
    if (obj.dataDriven !== false) return false;
    if (!Array.isArray(obj.groups)) return false;
    if (obj.groups.some((group)=>!(0, $4aFWD.isGroup)(group))) return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.fromHierarchyId)) return false;
    // Everything is good
    return true;
};

});



parcelRegister("6YHm6", function(module, exports) {

$parcel$export(module.exports, "extractDataState", function () { return $1e619bc04e7955ab$export$e4062f19eb6ef86b; });
$parcel$export(module.exports, "addPatchToStack", function () { return $1e619bc04e7955ab$export$f6157cbbc48c0b49; });

var $6hWPd = parcelRequire("6hWPd");
const $1e619bc04e7955ab$export$e4062f19eb6ef86b = (state)=>({
        analyses: state.analyses,
        analysisMethods: state.analysisMethods,
        analysisSets: state.analysisSets,
        caseWhenConditions: state.caseWhenConditions,
        changed: state.changed,
        comparators: state.comparators,
        dataSubsets: state.dataSubsets,
        datasetsInUse: state.datasetsInUse,
        disableAnalysisMethodEdit: state.disableAnalysisMethodEdit,
        editorDefns: state.editorDefns,
        groupingFactors: state.groupingFactors,
        uiRequestStatus: state.uiRequestStatus,
        variables: state.variables,
        variablesInUse: state.variablesInUse
    });
const $1e619bc04e7955ab$export$f6157cbbc48c0b49 = (previousState, newState)=>{
    const previousData = $1e619bc04e7955ab$export$e4062f19eb6ef86b(previousState);
    const newData = $1e619bc04e7955ab$export$e4062f19eb6ef86b(newState);
    const forwardPatch = (0, $6hWPd.createPatch)(previousData, newData);
    const reversePatch = (0, $6hWPd.createPatch)(newData, previousData);
    if (forwardPatch.length === 0) return newState;
    const newPatch = {
        forward: forwardPatch,
        reverse: reversePatch
    };
    const newPatches = [
        ...previousState.patches.slice(0, previousState.ixPatch + 1),
        newPatch
    ];
    return {
        ...newState,
        patches: newPatches,
        ixPatch: newPatches.length - 1
    };
};

});


parcelRegister("cS2B3", function(module, exports) {

$parcel$export(module.exports, "arsc_addNotToWhereClause", function () { return $4cee95046f0d2fa1$export$42fe98b3d28e2ad; });

var $gSkQi = parcelRequire("gSkQi");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("6yroJ");
var $6Ugly = parcelRequire("6Ugly");
var $jc9tE = parcelRequire("jc9tE");

var $6YHm6 = parcelRequire("6YHm6");
const $4cee95046f0d2fa1$export$42fe98b3d28e2ad = (state, action)=>{
    const whereClause = (0, $eAPMz.getFromDataPath)(action.dataPath, state, (0, $6Ugly.isWhereClause));
    if (!whereClause) throw new Error(`Invalid dataPath for NOT_WHERE_CLAUSE: ${action.dataPath}`);
    if ((0, $jc9tE.isWhereClauseWithCondition)(whereClause)) {
        const newCompoundExpression = {
            logicalOperator: (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT,
            whereClauses: [
                {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    condition: whereClause.condition,
                    level: whereClause.level + 1,
                    order: 0
                }
            ]
        };
        const newEntity = {
            ...(0, $gSkQi.omit)(whereClause, "condition"),
            compoundExpression: newCompoundExpression,
            level: whereClause.level,
            order: whereClause.order
        };
        return (0, $6YHm6.addPatchToStack)(state, (0, $dsPLF.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newEntity));
    }
    const ce = whereClause.compoundExpression;
    if ((ce.whereClauses?.length ?? // istanbul ignore next
    0) > 1) throw new Error(`Cannot apply NOT operator to ${action.dataPath} because it has multiple sub-clauses`);
    const newCompoundExpression = {
        logicalOperator: (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT,
        whereClauses: ce.whereClauses ?? // istanbul ignore next
        []
    };
    const newWhereClause = {
        compoundExpression: newCompoundExpression,
        level: whereClause.level,
        order: whereClause.order
    };
    return (0, $6YHm6.addPatchToStack)(state, (0, $dsPLF.mutateByPath)({
        ...state,
        changed: true
    }, action.dataPath, newWhereClause));
};

});

parcelRegister("jE6rq", function(module, exports) {

$parcel$export(module.exports, "arsc_changeSent", function () { return $8963e9b54abc4834$export$4e092654bb1f798b; });
const $8963e9b54abc4834$export$4e092654bb1f798b = (state)=>({
        ...state,
        changed: false
    });

});

parcelRegister("d6PjO", function(module, exports) {

$parcel$export(module.exports, "arsc_loadArsPatch", function () { return $e3a61b9ad043a1a1$export$4cc49bc08b78b13d; });
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");
const $e3a61b9ad043a1a1$export$4cc49bc08b78b13d = (state, action)=>{
    let newState = state;
    action.updates.forEach((update)=>{
        newState = (0, $dsPLF.mutateByPath)(newState, update.dataPath, update.value);
    });
    return newState;
};

});

parcelRegister("1uVjM", function(module, exports) {

$parcel$export(module.exports, "arsc_patchArsState", function () { return $c5cb7013674bf638$export$f23861c9f47d05a; });
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");

var $6YHm6 = parcelRequire("6YHm6");
const $c5cb7013674bf638$export$f23861c9f47d05a = (state, action)=>{
    let newState = state;
    const updates = "updates" in action ? action.updates : [
        action
    ];
    for (const update of updates)newState = (0, $dsPLF.mutateByPath)(newState, update.dataPath, update.value);
    return (0, $6YHm6.addPatchToStack)(state, {
        ...newState,
        changed: true
    });
};

});

parcelRegister("lxahc", function(module, exports) {

$parcel$export(module.exports, "arsc_redoArsChange", function () { return $871d5d11f9261fd7$export$266c33469d0a03d3; });

var $gSkQi = parcelRequire("gSkQi");

var $6hWPd = parcelRequire("6hWPd");

var $6YHm6 = parcelRequire("6YHm6");
const $871d5d11f9261fd7$export$266c33469d0a03d3 = (state, action)=>{
    const steps = action.steps ?? 1;
    const newIx = Math.min(state.patches.length - 1, state.ixPatch + steps);
    if (newIx === state.ixPatch || newIx < 0) return state;
    const currentState = (0, $gSkQi.cloneDeep)((0, $6YHm6.extractDataState)(state));
    for(let i = state.ixPatch + 1; i <= newIx; i++){
        const patch = state.patches[i];
        /* istanbul ignore else */ if (patch) (0, $6hWPd.applyPatch)(currentState, patch.forward);
    }
    return {
        ...state,
        ...currentState,
        ixPatch: newIx
    };
};

});

parcelRegister("1MNFJ", function(module, exports) {

$parcel$export(module.exports, "arsc_removeArsItem", function () { return $0e713ddd6514ede5$export$67c0acf52a3db53d; });
parcelRequire("2nuru");
var $34cNk = parcelRequire("34cNk");

var $6YHm6 = parcelRequire("6YHm6");
const $0e713ddd6514ede5$export$67c0acf52a3db53d = (state, action)=>(0, $6YHm6.addPatchToStack)(state, (0, $34cNk.removeByPath)({
        ...state,
        changed: true
    }, action.dataPath, action.newLength));

});

parcelRegister("64MNY", function(module, exports) {

$parcel$export(module.exports, "arsc_removeNotFromWhereClause", function () { return $0a3c65cf029a9e13$export$1c49aa48bdaaa522; });

var $gSkQi = parcelRequire("gSkQi");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("6yroJ");
var $fAJMp = parcelRequire("fAJMp");
var $cNv0d = parcelRequire("cNv0d");
var $6Ugly = parcelRequire("6Ugly");
var $kC2sO = parcelRequire("kC2sO");

var $6YHm6 = parcelRequire("6YHm6");
const $0a3c65cf029a9e13$export$1c49aa48bdaaa522 = (state, action)=>{
    const whereClause = (0, $eAPMz.getFromDataPath)(action.dataPath, state, (0, $6Ugly.isWhereClause));
    if (!whereClause || !(0, $kC2sO.isWhereClauseWithCompoundExpression)(whereClause) || !whereClause.compoundExpression.whereClauses || whereClause.compoundExpression.whereClauses.length > 1) throw new Error(`Invalid dataPath for REMOVE_NOT_FROM_WHERE_CLAUSE: ${action.dataPath}`);
    if (whereClause.compoundExpression.logicalOperator !== (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT) throw new Error(`Cannot remove NOT operator from ${action.dataPath} because it is not a NOT clause`);
    if (whereClause.compoundExpression.whereClauses.length === 0) throw new Error(`Cannot remove NOT operator from ${action.dataPath} because it has no sub-clauses`);
    const subClause = whereClause.compoundExpression.whereClauses[0];
    if ((0, $cNv0d.isSubClauseWithCondition)(subClause)) {
        const newEntity = {
            ...(0, $gSkQi.omit)(whereClause, "compoundExpression"),
            condition: subClause.condition,
            level: subClause.level - 1,
            order: whereClause.order
        };
        return (0, $6YHm6.addPatchToStack)(state, (0, $dsPLF.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newEntity));
    }
    if ((0, $fAJMp.isSubClauseWithCompoundExpression)(subClause)) {
        const newWhereClause = {
            compoundExpression: subClause.compoundExpression,
            level: subClause.level - 1,
            order: whereClause.order
        };
        return (0, $6YHm6.addPatchToStack)(state, (0, $dsPLF.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newWhereClause));
    }
    throw new Error(`Cannot remove NOT operator from ${action.dataPath} - sub-clause is a reference`);
};

});

parcelRegister("etlyI", function(module, exports) {

$parcel$export(module.exports, "arsc_removeWhereClause", function () { return $f9b19b8c84e61d63$export$58ecff8ba85d96f; });

var $gwE3k = parcelRequire("gwE3k");

var $6YHm6 = parcelRequire("6YHm6");
const $f9b19b8c84e61d63$export$58ecff8ba85d96f = (state, action)=>{
    const removedState = (0, $gwE3k.removeWhereClause)(state, action.dataPath, action.id);
    if (removedState !== state) return (0, $6YHm6.addPatchToStack)(state, removedState);
    return state;
};

});
parcelRegister("gwE3k", function(module, exports) {

$parcel$export(module.exports, "removeWhereClause", function () { return $821d6784c7d80c9f$export$3bff2824b94a5f2; });

var $gSkQi = parcelRequire("gSkQi");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");
parcelRequire("6yroJ");
var $kC2sO = parcelRequire("kC2sO");
var $jc9tE = parcelRequire("jc9tE");

var $ecq7a = parcelRequire("ecq7a");
const $821d6784c7d80c9f$export$3bff2824b94a5f2 = (state, dataPath, id)=>{
    const whereClause = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $kC2sO.isWhereClauseWithCompoundExpression));
    if (whereClause) {
        const ce = whereClause.compoundExpression;
        if (!ce.whereClauses || ce.whereClauses.length <= 1) throw new Error(`Cannot remove where clause from ${dataPath} because it does not have multiple clauses`);
        else if (ce.whereClauses.length === 2) {
            // If only 2 clauses, remove the compound expression and revert to single condition
            const remainingClause = ce.whereClauses.find((clause)=>clause.id !== id);
            if (!remainingClause) // It may have already been removed
            return state;
            else if ((0, $jc9tE.isWhereClauseWithCondition)(remainingClause)) {
                const newEntity = {
                    ...(0, $gSkQi.omit)(whereClause, "compoundExpression"),
                    condition: remainingClause.condition,
                    level: remainingClause.level - 1,
                    order: 0
                };
                return (0, $dsPLF.mutateByPath)({
                    ...state,
                    changed: true
                }, dataPath, newEntity);
            } else if ((0, $kC2sO.isWhereClauseWithCompoundExpression)(remainingClause)) {
                // Check if parent entity only has one SubClause - if so, promote compoundExpression up
                const parentPath = dataPath.substring(0, dataPath.lastIndexOf("/compoundExpression/whereClauses"));
                const parentEntity = (0, $eAPMz.getFromDataPath)(parentPath, state, (0, $kC2sO.isWhereClauseWithCompoundExpression));
                if (parentEntity && parentEntity.compoundExpression.whereClauses?.length === 1) {
                    // Promote the compound expression to replace the parent's compoundExpression
                    const normalizedCompound = {
                        ...remainingClause.compoundExpression,
                        whereClauses: remainingClause.compoundExpression.whereClauses?.map((clause)=>({
                                ...clause
                            }))
                    };
                    // Normalize levels based on parent entity level
                    normalizedCompound.whereClauses?.forEach((clause, index)=>{
                        (0, $ecq7a.normalizeSubClauseLevelsAndOrders)(clause, parentEntity.level + 1, index);
                    });
                    return (0, $dsPLF.mutateByPath)({
                        ...state,
                        changed: true
                    }, `${parentPath}/compoundExpression`, normalizedCompound);
                } else {
                    // Multiple SubClauses in parent, just update this one
                    const normalizedCompound = {
                        ...remainingClause.compoundExpression,
                        whereClauses: remainingClause.compoundExpression.whereClauses?.map((clause)=>({
                                ...clause
                            }))
                    };
                    normalizedCompound.whereClauses?.forEach((clause, index)=>{
                        (0, $ecq7a.normalizeSubClauseLevelsAndOrders)(clause, whereClause.level + 1, index);
                    });
                    const newEntity = {
                        ...whereClause,
                        compoundExpression: normalizedCompound,
                        level: whereClause.level,
                        order: whereClause.order
                    };
                    return (0, $dsPLF.mutateByPath)({
                        ...state,
                        changed: true
                    }, dataPath, newEntity);
                }
            } else if ("subClauseId" in whereClause) {
                const newEntity = {
                    ...(0, $gSkQi.omit)(whereClause, "compoundExpression"),
                    subClauseId: remainingClause.subClauseId,
                    level: remainingClause.level - 1,
                    order: whereClause.order
                };
                return (0, $dsPLF.mutateByPath)({
                    ...state,
                    changed: true
                }, dataPath, newEntity);
            } else // Shouldn't be left with a reference on a whereClause
            throw new Error(`Cannot collapse to single clause at ${dataPath} - remaining clause is a reference`);
        } else {
            // More than 2 clauses, just remove the specified clause
            const newWhereClauses = ce.whereClauses.filter((clause)=>clause.id !== id);
            const newCompoundExpression = {
                ...ce,
                whereClauses: newWhereClauses
            };
            return (0, $dsPLF.mutateByPath)({
                ...state,
                changed: true
            }, `${dataPath}/compoundExpression`, newCompoundExpression);
        }
    } else return state;
};

});
parcelRegister("ecq7a", function(module, exports) {

$parcel$export(module.exports, "parseWhereClauseFromCode", function () { return $cf8c1c2d41879e66$export$6baa19d4f0d0724a; });
$parcel$export(module.exports, "normalizeSubClauseLevelsAndOrders", function () { return $cf8c1c2d41879e66$export$ff15257b9599a61a; });

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("6yroJ");
var $fAJMp = parcelRequire("fAJMp");
var $kC2sO = parcelRequire("kC2sO");

var $3pTyh = parcelRequire("3pTyh");
/**
 * Checks whether a character should be treated as part of a word token.
 *
 * @param char - The character to check.
 * @returns True when the character is a word character.
 */ const $cf8c1c2d41879e66$var$isWordChar = (char)=>/[A-Za-z0-9_]/.test(char);
/**
 * Attempts to match a logical operator at the provided index.
 *
 * @param code - The full input string.
 * @param index - The current scan index.
 * @returns The matched operator or null if none is matched.
 */ const $cf8c1c2d41879e66$var$matchLogicalOperator = (code, index)=>{
    const remaining = code.slice(index);
    const upper = remaining.toUpperCase();
    const operators = [
        (0, $1cA0K.ExpressionLogicalOperatorEnum).AND,
        (0, $1cA0K.ExpressionLogicalOperatorEnum).OR,
        (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT
    ];
    for (const operator of operators){
        if (!upper.startsWith(operator)) continue;
        const before = index === 0 ? "" : code[index - 1];
        const after = code[index + operator.length];
        const beforeOk = before === "" || !$cf8c1c2d41879e66$var$isWordChar(before);
        const afterOk = after === "" || !$cf8c1c2d41879e66$var$isWordChar(after);
        if (beforeOk && afterOk) return operator;
    }
    return null;
};
/**
 * Tokenises a where clause string into logical operators, groupings, references, and predicates.
 * Predicates keep comparator and value text intact, including IN list parentheses.
 *
 * @param code - The raw where clause string.
 * @returns An array of tokens or null when lexing fails.
 */ const $cf8c1c2d41879e66$var$tokenizeWhereClause = (code)=>{
    const tokens = [];
    let buffer = "";
    let inQuote = null;
    let predicateParenDepth = 0;
    /**
   * Pushes the current buffer as a predicate token if it contains non-whitespace content.
   */ const pushPredicate = ()=>{
        const trimmed = buffer.trim();
        if (trimmed) tokens.push({
            type: "predicate",
            value: trimmed
        });
        buffer = "";
    };
    /**
   * Returns the type of the most recently emitted token, or null if no tokens have been emitted.
   *
   * @returns The last token type or null.
   */ const lastTokenType = ()=>tokens.length > 0 ? tokens[tokens.length - 1].type : null;
    /**
   * Determines whether a unary NOT operator can be emitted based on the last token type.
   *
   * @returns True if a NOT operator can start at the current position.
   */ const canStartUnary = ()=>{
        const lastType = lastTokenType();
        return lastType === null || lastType === "and" || lastType === "or" || lastType === "not" || lastType === "lparen";
    };
    /**
   * Determines whether a binary AND/OR operator can be emitted based on the last token type.
   *
   * @returns True if an AND or OR operator can start at the current position.
   */ const canStartBinary = ()=>{
        const lastType = lastTokenType();
        return lastType === "predicate" || lastType === "reference" || lastType === "rparen";
    };
    let i = 0;
    while(i < code.length){
        const char = code[i];
        if (inQuote) {
            buffer += char;
            if (char === inQuote && code[i - 1] !== "\\") inQuote = null;
            i += 1;
            continue;
        }
        if (char === "'" || char === '"') {
            buffer += char;
            inQuote = char;
            i += 1;
            continue;
        }
        // Skip leading whitespace outside predicates
        if (char === " " && buffer.trim() === "" && predicateParenDepth === 0) {
            i += 1;
            continue;
        }
        if (char === "(" && buffer.trim() === "" && predicateParenDepth === 0) {
            tokens.push({
                type: "lparen"
            });
            i += 1;
            continue;
        }
        if (char === ")" && predicateParenDepth === 0) {
            pushPredicate();
            tokens.push({
                type: "rparen"
            });
            i += 1;
            continue;
        }
        if (char === "[" && buffer.trim() === "") {
            const closingIndex = code.indexOf("]", i + 1);
            /* istanbul ignore else - Defensive: malformed reference with no closing bracket */ if (closingIndex > i + 1) {
                const referenceId = code.slice(i + 1, closingIndex).trim();
                /* istanbul ignore else - Defensive: empty reference ID like [] */ if (referenceId) {
                    tokens.push({
                        type: "reference",
                        value: referenceId
                    });
                    i = closingIndex + 1;
                    continue;
                }
            }
        }
        if (char === "(" && buffer.trim() !== "") {
            predicateParenDepth += 1;
            buffer += char;
            i += 1;
            continue;
        }
        if (char === ")" && predicateParenDepth > 0) {
            predicateParenDepth -= 1;
            buffer += char;
            i += 1;
            continue;
        }
        const operator = $cf8c1c2d41879e66$var$matchLogicalOperator(code, i);
        if (operator && predicateParenDepth === 0) {
            if (operator === (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT && buffer.trim() === "" && canStartUnary()) {
                tokens.push({
                    type: "not"
                });
                i += operator.length;
                continue;
            }
            if (operator !== (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT) {
                if (buffer.trim() !== "") {
                    pushPredicate();
                    tokens.push({
                        type: operator === (0, $1cA0K.ExpressionLogicalOperatorEnum).AND ? "and" : "or"
                    });
                    i += operator.length;
                    continue;
                }
                /* istanbul ignore else - Defensive: binary operator in invalid position */ if (canStartBinary()) {
                    tokens.push({
                        type: operator === (0, $1cA0K.ExpressionLogicalOperatorEnum).AND ? "and" : "or"
                    });
                    i += operator.length;
                    continue;
                }
            }
        }
        buffer += char;
        i += 1;
    }
    if (inQuote || predicateParenDepth !== 0) return null;
    pushPredicate();
    return tokens.length > 0 ? tokens : null;
};
/**
 * Converts a parsed clause node into a sub-clause structure.
 *
 * @param node - The parsed clause node.
 * @returns The sub-clause or null if conversion fails.
 */ const $cf8c1c2d41879e66$var$buildSubClause = (node)=>{
    switch(node.kind){
        case "condition":
            return {
                id: crypto.randomUUID(),
                subClauseId: "",
                condition: node.condition,
                level: 0,
                order: 0
            };
        case "reference":
            return {
                id: crypto.randomUUID(),
                subClauseId: node.subClauseId,
                level: 0,
                order: 0
            };
        case "compound":
            {
                const whereClauses = node.whereClauses.map((child)=>$cf8c1c2d41879e66$var$buildSubClause(child)).filter((child)=>child !== null);
                /* istanbul ignore next - Defensive: parser guarantees valid node types */ if (whereClauses.length !== node.whereClauses.length) return null;
                return {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    compoundExpression: {
                        logicalOperator: node.logicalOperator,
                        whereClauses: whereClauses
                    },
                    level: 0,
                    order: 0
                };
            }
        /* istanbul ignore next - Defensive: TypeScript ensures exhaustive case coverage */ default:
            return null;
    }
};
/**
 * Parses tokens into a clause tree using logical operator precedence.
 *
 * @param tokens - The token stream to parse.
 * @param availableVariables - List of available dataset.variable combinations for validation.
 * @param availableSubClauseIds - List of available subClauseIds for validation.
 * @returns The root clause node or null when parsing fails.
 */ const $cf8c1c2d41879e66$var$parseTokensToClauseNode = (tokens, availableVariables, availableSubClauseIds)=>{
    let index = 0;
    let acceptedUnlistedVariable = false;
    /**
   * Returns the current token without advancing the index.
   *
   * @returns The current token or null if at end of stream.
   */ const peek = ()=>index < tokens.length ? tokens[index] : null;
    /**
   * Returns the current token and advances the index to the next token.
   *
   * @returns The consumed token or null if at end of stream.
   */ const consume = ()=>index < tokens.length ? tokens[index++] : null;
    /**
   * Parses a complete expression, starting with the lowest precedence (OR).
   *
   * @returns The parsed clause node or null if parsing fails.
   */ const parseExpression = ()=>parseOr();
    /**
   * Parses OR expressions (lowest precedence binary operator).
   * Accumulates multiple AND expressions separated by OR.
   *
   * @returns The parsed OR clause node or null if parsing fails.
   */ const parseOr = ()=>{
        const left = parseAnd();
        if (!left) return null;
        const clauses = [
            left
        ];
        while(peek()?.type === "or"){
            consume();
            const right = parseAnd();
            if (!right) return null;
            clauses.push(right);
        }
        return clauses.length === 1 ? left : {
            kind: "compound",
            logicalOperator: (0, $1cA0K.ExpressionLogicalOperatorEnum).OR,
            whereClauses: clauses
        };
    };
    /**
   * Parses AND expressions (higher precedence than OR).
   * Accumulates multiple NOT expressions separated by AND.
   *
   * @returns The parsed AND clause node or null if parsing fails.
   */ const parseAnd = ()=>{
        const left = parseNot();
        if (!left) return null;
        const clauses = [
            left
        ];
        while(peek()?.type === "and"){
            consume();
            const right = parseNot();
            if (!right) return null;
            clauses.push(right);
        }
        return clauses.length === 1 ? left : {
            kind: "compound",
            logicalOperator: (0, $1cA0K.ExpressionLogicalOperatorEnum).AND,
            whereClauses: clauses
        };
    };
    /**
   * Parses NOT expressions (highest precedence unary operator).
   * Recursively handles multiple consecutive NOTs.
   *
   * @returns The parsed NOT clause node or null if parsing fails.
   */ const parseNot = ()=>{
        if (peek()?.type === "not") {
            consume();
            const target = parseNot();
            if (!target) return null;
            return {
                kind: "compound",
                logicalOperator: (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT,
                whereClauses: [
                    target
                ]
            };
        }
        return parsePrimary();
    };
    /**
   * Parses primary expressions (predicates, references, and parenthesized expressions).
   * This is the highest precedence level in the grammar.
   *
   * @returns The parsed primary clause node or null if parsing fails.
   */ const parsePrimary = ()=>{
        const token = peek();
        /* istanbul ignore next - Defensive: parser logic ensures tokens exist before calling parsePrimary */ if (!token) return null;
        if (token.type === "lparen") {
            consume();
            const inner = parseExpression();
            if (!inner || peek()?.type !== "rparen") return null;
            consume();
            return inner;
        }
        if (token.type === "reference") {
            consume();
            if (!availableSubClauseIds.includes(token.value)) return null;
            return {
                kind: "reference",
                subClauseId: token.value
            };
        }
        if (token.type === "predicate") {
            consume();
            const conditionResult = (0, $3pTyh.parseConditionFromCode)(token.value, availableVariables);
            if (!conditionResult) return null;
            acceptedUnlistedVariable ||= conditionResult.acceptedUnlistedVariable;
            return {
                kind: "condition",
                condition: conditionResult.condition
            };
        }
        return null;
    };
    const result = parseExpression();
    if (!result || index !== tokens.length) return {
        node: null,
        acceptedUnlistedVariable: false
    };
    return {
        node: result,
        acceptedUnlistedVariable: acceptedUnlistedVariable
    };
};
function $cf8c1c2d41879e66$export$6baa19d4f0d0724a(code, availableVariables, availableSubClauseIds = []) {
    if (!code || code.trim() === "") return false;
    const tokens = $cf8c1c2d41879e66$var$tokenizeWhereClause(code);
    if (!tokens) return false;
    const { node: rootNode, acceptedUnlistedVariable: acceptedUnlistedVariable } = $cf8c1c2d41879e66$var$parseTokensToClauseNode(tokens, availableVariables, availableSubClauseIds);
    if (!rootNode) return false;
    if (rootNode.kind === "condition") return {
        whereClause: {
            condition: rootNode.condition,
            level: 0,
            order: 0
        },
        acceptedUnlistedVariable: acceptedUnlistedVariable
    };
    if (rootNode.kind === "reference") return false;
    const whereClauses = rootNode.whereClauses.map((child)=>$cf8c1c2d41879e66$var$buildSubClause(child)).filter((child)=>child !== null);
    /* istanbul ignore next - Defensive: parser guarantees valid node types */ if (whereClauses.length !== rootNode.whereClauses.length) return false;
    const whereClause = {
        compoundExpression: {
            logicalOperator: rootNode.logicalOperator,
            whereClauses: whereClauses
        },
        level: 0,
        order: 0
    };
    $cf8c1c2d41879e66$var$normalizeWhereClauseLevelsAndOrders(whereClause);
    return {
        whereClause: whereClause,
        acceptedUnlistedVariable: acceptedUnlistedVariable
    };
}
/**
 * Normalizes level and order values in a WhereClause hierarchy.
 * Sets level = parent level + 1 for child subclauses, and incrementing order values for siblings.
 *
 * @param whereClause - The WhereClause to normalize.
 * @param parentLevel - The level of the parent (default 0 for top-level).
 */ const $cf8c1c2d41879e66$var$normalizeWhereClauseLevelsAndOrders = (whereClause, parentLevel = 0)=>{
    whereClause.level = parentLevel;
    whereClause.order = 0;
    /* istanbul ignore else */ if ((0, $kC2sO.isWhereClauseWithCompoundExpression)(whereClause) && whereClause.compoundExpression.whereClauses) {
        const childLevel = parentLevel + 1;
        whereClause.compoundExpression.whereClauses.forEach((subClause, index)=>{
            $cf8c1c2d41879e66$export$ff15257b9599a61a(subClause, childLevel, index);
        });
    }
};
const $cf8c1c2d41879e66$export$ff15257b9599a61a = (subClause, level, order)=>{
    subClause.level = level;
    subClause.order = order;
    if ((0, $fAJMp.isSubClauseWithCompoundExpression)(subClause) && subClause.compoundExpression.whereClauses) {
        const childLevel = level + 1;
        subClause.compoundExpression.whereClauses.forEach((child, index)=>{
            $cf8c1c2d41879e66$export$ff15257b9599a61a(child, childLevel, index);
        });
    }
};

});
parcelRegister("3pTyh", function(module, exports) {

$parcel$export(module.exports, "comparatorDefinitions", function () { return $920b15e4d637535a$export$278773736a300e33; });
$parcel$export(module.exports, "parseConditionFromCode", function () { return $920b15e4d637535a$export$8e83f93584123e08; });

var $1cA0K = parcelRequire("1cA0K");

var $9usef = parcelRequire("9usef");
const $920b15e4d637535a$export$278773736a300e33 = {
    EQ: {
        enum: (0, $1cA0K.ConditionComparatorEnum).EQ,
        write: "=",
        read: [
            "EQ",
            "="
        ]
    },
    NE: {
        enum: (0, $1cA0K.ConditionComparatorEnum).NE,
        write: "!=",
        read: [
            "NE",
            "!=",
            "<>"
        ]
    },
    GT: {
        enum: (0, $1cA0K.ConditionComparatorEnum).GT,
        write: ">",
        read: [
            "GT",
            ">"
        ]
    },
    GE: {
        enum: (0, $1cA0K.ConditionComparatorEnum).GE,
        write: ">=",
        read: [
            "GE",
            ">="
        ]
    },
    LT: {
        enum: (0, $1cA0K.ConditionComparatorEnum).LT,
        write: "<",
        read: [
            "LT",
            "<"
        ]
    },
    LE: {
        enum: (0, $1cA0K.ConditionComparatorEnum).LE,
        write: "<=",
        read: [
            "LE",
            "<="
        ]
    },
    IN: {
        enum: (0, $1cA0K.ConditionComparatorEnum).IN,
        write: "IN",
        read: [
            "IN"
        ]
    },
    NOTIN: {
        enum: (0, $1cA0K.ConditionComparatorEnum).NOTIN,
        write: "NOT IN",
        read: [
            "NOTIN",
            "NOT IN"
        ]
    }
};
/**
 * Builds a regex pattern group from read strings, escaping special regex characters.
 * Sorts by length (descending) to ensure longer patterns like "NOT IN" match before "IN".
 *
 * @param readStrings - Array of strings that should match this comparator.
 * @returns Escaped pattern string for use in regex alternation.
 */ const $920b15e4d637535a$var$buildComparatorPattern = (readStrings)=>{
    return readStrings.slice().sort((a, b)=>b.length - a.length).map((s)=>s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
};
/**
 * Finds the comparator definition that matches the given token.
 *
 * @param token - The comparator token to look up.
 * @returns The matching comparator definition or undefined.
 */ const $920b15e4d637535a$var$findComparatorDef = (token)=>{
    const upperToken = token.toUpperCase();
    return Object.values($920b15e4d637535a$export$278773736a300e33).find((def)=>def.read.map((r)=>r.toUpperCase()).includes(upperToken));
};
function $920b15e4d637535a$export$8e83f93584123e08(code, availableVariables) {
    if (!code || code.trim() === "") return false;
    const trimmed = code.trim();
    // Build regex patterns from comparator definitions
    const singleValueComparators = [];
    const listValueComparators = [];
    Object.values($920b15e4d637535a$export$278773736a300e33).forEach((def)=>{
        const pattern = $920b15e4d637535a$var$buildComparatorPattern(def.read);
        if (def.enum === (0, $1cA0K.ConditionComparatorEnum).IN || def.enum === (0, $1cA0K.ConditionComparatorEnum).NOTIN) listValueComparators.push(pattern);
        else singleValueComparators.push(pattern);
    });
    // Sort patterns by length (descending) to match longer patterns first
    const sortedSingleValueComparators = singleValueComparators.sort((a, b)=>b.length - a.length);
    const sortedListValueComparators = listValueComparators.sort((a, b)=>b.length - a.length);
    // Allow optional spaces around comparators (e.g., ADSL.SAFFL='Y' or ADSL.SAFFL = 'Y')
    const singleValuePattern = new RegExp(`^([A-Z0-9_]+)\\.([A-Z0-9_]+)\\s*(${sortedSingleValueComparators.join("|")})\\s*(?:'([^']*)'|"([^"]*)"|([^\\s]+))$`, "i");
    const inPattern = new RegExp(`^([A-Z0-9_]+)\\.([A-Z0-9_]+)\\s*(${sortedListValueComparators.join("|")})\\s*\\(([^)]+)\\)$`, "i");
    let match = trimmed.match(singleValuePattern);
    if (match) {
        const [, dataset, variable, comparator, singleQuotedValue, doubleQuotedValue, unquotedValue] = match;
        const datasetVariable = `${dataset.toUpperCase()}.${variable.toUpperCase()}`;
        const acceptedUnlistedVariable = (0, $9usef.normaliseDatasetVariable)(datasetVariable) === datasetVariable;
        const isAvailableVariable = availableVariables.map((v)=>v.toUpperCase()).includes(datasetVariable);
        // Validate that the variable exists
        if (!isAvailableVariable && !acceptedUnlistedVariable) return false;
        const value = singleQuotedValue !== undefined ? singleQuotedValue : doubleQuotedValue !== undefined ? doubleQuotedValue : unquotedValue;
        const def = $920b15e4d637535a$var$findComparatorDef(comparator);
        return def ? {
            condition: {
                dataset: dataset.toUpperCase(),
                variable: variable.toUpperCase(),
                comparator: def.enum,
                value: [
                    value
                ]
            },
            acceptedUnlistedVariable: !isAvailableVariable && acceptedUnlistedVariable
        } : false;
    }
    match = trimmed.match(inPattern);
    if (match) {
        const [, dataset, variable, comparator, valuesString] = match;
        const datasetVariable = `${dataset.toUpperCase()}.${variable.toUpperCase()}`;
        const acceptedUnlistedVariable = (0, $9usef.normaliseDatasetVariable)(datasetVariable) === datasetVariable;
        const isAvailableVariable = availableVariables.map((v)=>v.toUpperCase()).includes(datasetVariable);
        // Validate that the variable exists
        if (!isAvailableVariable && !acceptedUnlistedVariable) return false;
        // Parse values from the IN clause
        const values = valuesString.split(",").map((v)=>v.trim()).filter((v)=>v.length > 0).map((v)=>{
            // Remove quotes if present
            if (v.startsWith("'") && v.endsWith("'") || v.startsWith('"') && v.endsWith('"')) return v.slice(1, -1);
            return v;
        });
        if (values.length === 0) return false;
        const def = $920b15e4d637535a$var$findComparatorDef(comparator);
        // istanbul ignore next - defensive check, should never fail since regex is built from definitions
        return def ? {
            condition: {
                dataset: dataset.toUpperCase(),
                variable: variable.toUpperCase(),
                comparator: def.enum,
                value: values
            },
            acceptedUnlistedVariable: !isAvailableVariable && acceptedUnlistedVariable
        } : false;
    }
    // No match found
    return false;
}

});
parcelRegister("9usef", function(module, exports) {

$parcel$export(module.exports, "normaliseDatasetVariable", function () { return $6f5d160cf767b2ad$export$bae91192748a9ffb; });

var $4yc3n = parcelRequire("4yc3n");
const $6f5d160cf767b2ad$export$bae91192748a9ffb = (value)=>{
    const trimmedValue = value.trim();
    const match = (0, $4yc3n.DATASET_VARIABLE_PATTERN).exec(trimmedValue);
    return match ? `${match[1].toUpperCase()}.${match[2].toUpperCase()}` : null;
};

});
parcelRegister("4yc3n", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_DATASET_VARIABLE_WARNING", function () { return $0c43af8b66c81d1f$export$871b3f531f482a32; });
$parcel$export(module.exports, "DATASET_VARIABLE_PATTERN", function () { return $0c43af8b66c81d1f$export$93f0d4ea94b02498; });
/**
 * Warning shown when a correctly formatted dataset.variable value is not present in the
 * available variables list.
 */ const $0c43af8b66c81d1f$export$871b3f531f482a32 = "This 'dataset.variable' is not in the list of available variables";
/**
 * Maximum allowed length for the dataset and variable parts of a dataset.variable value.
 */ const $0c43af8b66c81d1f$var$DATASET_VARIABLE_PART_MAX_LENGTH = 32;
const $0c43af8b66c81d1f$export$93f0d4ea94b02498 = new RegExp(`^([A-Za-z_][A-Za-z0-9_]{0,${$0c43af8b66c81d1f$var$DATASET_VARIABLE_PART_MAX_LENGTH - 1}})\\.([A-Za-z_][A-Za-z0-9_]{0,${$0c43af8b66c81d1f$var$DATASET_VARIABLE_PART_MAX_LENGTH - 1}})$`, "i");

});






parcelRegister("03TIL", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarAnalysisMethodId", function () { return $8894fae0c0a5cd46$export$573b6539ae3901d3; });
const $8894fae0c0a5cd46$export$573b6539ae3901d3 = (state, action)=>{
    if (action.analysisMethodId && !Object.keys(state.analysisMethods).includes(action.analysisMethodId)) return state;
    return {
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            analysisMethodId: action.analysisMethodId
        }
    };
};

});

parcelRegister("84Bax", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarDataset", function () { return $2a6d4809eefe5dd4$export$6e6ba20af486399c; });
const $2a6d4809eefe5dd4$export$6e6ba20af486399c = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            dataset: action.dataset
        }
    });

});

parcelRegister("iIZ6k", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarFilter", function () { return $f22822f8fb282082$export$3a3cd8a9efe6302d; });
const $f22822f8fb282082$export$3a3cd8a9efe6302d = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            filter: action.filter
        }
    });

});

parcelRegister("afscR", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarView", function () { return $424908b36f443b5c$export$7f9c530b737fb37b; });
const $424908b36f443b5c$export$7f9c530b737fb37b = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            view: action.view
        }
    });

});

parcelRegister("lp2xD", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarWidth", function () { return $0073b3e0b633821a$export$db59ec7aa206b1ba; });
const $0073b3e0b633821a$export$db59ec7aa206b1ba = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            width: action.width
        }
    });

});

parcelRegister("czMJ8", function(module, exports) {

$parcel$export(module.exports, "arsc_setUiRequestStatus", function () { return $82157eceb6fb1e1f$export$a77aff271a01de06; });
const $82157eceb6fb1e1f$export$a77aff271a01de06 = (state, action)=>({
        ...state,
        uiRequestStatus: action.uiRequestStatus
    });

});

parcelRegister("6FHig", function(module, exports) {

$parcel$export(module.exports, "arsc_setVariablesInUse", function () { return $64a6e8d8598abe41$export$3536b4a3d351827e; });
const $64a6e8d8598abe41$export$3536b4a3d351827e = (state, action)=>{
    const datasetsInUse = new Set(Array.from(action.variablesInUse).flatMap((varName)=>varName.split(".")[0]));
    return {
        ...state,
        datasetsInUse: datasetsInUse,
        variablesInUse: action.variablesInUse
    };
};

});

parcelRegister("cpput", function(module, exports) {

$parcel$export(module.exports, "arsc_toggleSidebar", function () { return $f6a7512727761bf2$export$62a995e0ef08a37c; });
const $f6a7512727761bf2$export$62a995e0ef08a37c = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            isOpen: action.showSidebar ?? !state.currentSidebar.isOpen
        }
    });

});

parcelRegister("ayftj", function(module, exports) {

$parcel$export(module.exports, "arsc_undoArsChange", function () { return $44eea4add76eed0d$export$f19bef7440b297e6; });

var $gSkQi = parcelRequire("gSkQi");

var $6hWPd = parcelRequire("6hWPd");

var $6YHm6 = parcelRequire("6YHm6");
const $44eea4add76eed0d$export$f19bef7440b297e6 = (state, action)=>{
    const steps = action.steps ?? 1;
    const newIx = Math.max(-1, state.ixPatch - steps);
    if (newIx === state.ixPatch) return state;
    const currentState = (0, $gSkQi.cloneDeep)((0, $6YHm6.extractDataState)(state));
    for(let i = state.ixPatch; i > newIx; i--){
        const patch = state.patches[i];
        /* istanbul ignore else */ if (patch) (0, $6hWPd.applyPatch)(currentState, patch.reverse);
    }
    return {
        ...state,
        ...currentState,
        ixPatch: newIx
    };
};

});


parcelRegister("cIJV5", function(module, exports) {

$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return $66e5674f232522b3$export$4f0b6970955c9123; });
$parcel$export(module.exports, "ADD_EXTRA_WHERE_CLAUSE", function () { return $66e5674f232522b3$export$3912afcb6b7edd68; });
$parcel$export(module.exports, "ADD_NOT_TO_WHERE_CLAUSE", function () { return $66e5674f232522b3$export$545344ae9a096bed; });
$parcel$export(module.exports, "ARS_CHANGE_SENT", function () { return $66e5674f232522b3$export$6fabd0b616fe4052; });
$parcel$export(module.exports, "LOAD_ARS_PATCH", function () { return $66e5674f232522b3$export$f8a4a712c6311d83; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return $66e5674f232522b3$export$4bb8ad8cad329501; });
$parcel$export(module.exports, "REDO_ARS_CHANGE", function () { return $66e5674f232522b3$export$116945c1c743e77f; });
$parcel$export(module.exports, "REMOVE_ARS_ITEM", function () { return $66e5674f232522b3$export$d176a2e1750e98f9; });
$parcel$export(module.exports, "REMOVE_NOT_FROM_WHERE_CLAUSE", function () { return $66e5674f232522b3$export$cabe4bcf8c89f956; });
$parcel$export(module.exports, "REMOVE_WHERE_CLAUSE", function () { return $66e5674f232522b3$export$d21ab455e9f38f6e; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return $66e5674f232522b3$export$cffad4d3def4d19f; });
$parcel$export(module.exports, "SET_SIDEBAR_DATASET", function () { return $66e5674f232522b3$export$44da99aaf8bfb48b; });
$parcel$export(module.exports, "SET_SIDEBAR_FILTER", function () { return $66e5674f232522b3$export$765fe3a6e1d0b478; });
$parcel$export(module.exports, "SET_SIDEBAR_VIEW", function () { return $66e5674f232522b3$export$8dd709d4cb9f58f8; });
$parcel$export(module.exports, "SET_SIDEBAR_WIDTH", function () { return $66e5674f232522b3$export$e06dbb4ee3239acb; });
$parcel$export(module.exports, "SET_UI_REQUEST_STATUS", function () { return $66e5674f232522b3$export$db8956672730be81; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return $66e5674f232522b3$export$ffc598eb026768a5; });
$parcel$export(module.exports, "TOGGLE_SIDEBAR", function () { return $66e5674f232522b3$export$658c05a40550f51d; });
$parcel$export(module.exports, "UNDO_ARS_CHANGE", function () { return $66e5674f232522b3$export$ff8cd805a10fd858; });
const $66e5674f232522b3$export$4f0b6970955c9123 = "__current__";
const $66e5674f232522b3$export$3912afcb6b7edd68 = "ADD_EXTRA_WHERE_CLAUSE";
const $66e5674f232522b3$export$545344ae9a096bed = "ADD_NOT_TO_WHERE_CLAUSE";
const $66e5674f232522b3$export$6fabd0b616fe4052 = "ARS_CHANGE_SENT";
const $66e5674f232522b3$export$f8a4a712c6311d83 = "LOAD_ARS_PATCH";
const $66e5674f232522b3$export$4bb8ad8cad329501 = "PATCH_ARS_STATE";
const $66e5674f232522b3$export$116945c1c743e77f = "REDO_ARS_CHANGE";
const $66e5674f232522b3$export$d176a2e1750e98f9 = "REMOVE_ARS_ITEM";
const $66e5674f232522b3$export$cabe4bcf8c89f956 = "REMOVE_NOT_FROM_WHERE_CLAUSE";
const $66e5674f232522b3$export$d21ab455e9f38f6e = "REMOVE_WHERE_CLAUSE";
const $66e5674f232522b3$export$7431817582ed8a25 = "RESET_STATE";
const $66e5674f232522b3$export$cffad4d3def4d19f = "SET_SIDEBAR_ANALYSIS_METHOD_ID";
const $66e5674f232522b3$export$44da99aaf8bfb48b = "SET_SIDEBAR_DATASET";
const $66e5674f232522b3$export$765fe3a6e1d0b478 = "SET_SIDEBAR_FILTER";
const $66e5674f232522b3$export$8dd709d4cb9f58f8 = "SET_SIDEBAR_VIEW";
const $66e5674f232522b3$export$e06dbb4ee3239acb = "SET_SIDEBAR_WIDTH";
const $66e5674f232522b3$export$db8956672730be81 = "SET_UI_REQUEST_STATUS";
const $66e5674f232522b3$export$ffc598eb026768a5 = "SET_VARIABLES_IN_USE";
const $66e5674f232522b3$export$658c05a40550f51d = "TOGGLE_SIDEBAR";
const $66e5674f232522b3$export$ff8cd805a10fd858 = "UNDO_ARS_CHANGE";

});



parcelRegister("3CgTd", function(module, exports) {

$parcel$export(module.exports, "createNewAnalysisMethod", function () { return $6bb4c581f89f59b2$export$c5681825d741e59e; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return $6bb4c581f89f59b2$export$3f54066e8c80d26f; });
$parcel$export(module.exports, "createNewDataSubset", function () { return $6bb4c581f89f59b2$export$e01d8a5d48196499; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return $6bb4c581f89f59b2$export$ab13c7a12bef3f24; });
$parcel$export(module.exports, "createNewGroup", function () { return $6bb4c581f89f59b2$export$8197413158a6a707; });

var $cIJV5 = parcelRequire("cIJV5");
const $6bb4c581f89f59b2$export$c5681825d741e59e = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        operations: [],
        codeTemplate: {
            context: "",
            code: ""
        },
        fromHierarchyId: (0, $cIJV5.CURRENT_HIERARCHY_ID)
    });
const $6bb4c581f89f59b2$export$3f54066e8c80d26f = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        level: 0,
        order: 0,
        condition: {
            dataset: "",
            variable: ""
        },
        fromHierarchyId: (0, $cIJV5.CURRENT_HIERARCHY_ID)
    });
const $6bb4c581f89f59b2$export$e01d8a5d48196499 = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        level: 0,
        order: 0,
        condition: {
            dataset: "",
            variable: ""
        },
        fromHierarchyId: (0, $cIJV5.CURRENT_HIERARCHY_ID)
    });
const $6bb4c581f89f59b2$export$ab13c7a12bef3f24 = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        dataDriven: false,
        groups: [],
        fromHierarchyId: (0, $cIJV5.CURRENT_HIERARCHY_ID)
    });
const $6bb4c581f89f59b2$export$8197413158a6a707 = (name, order)=>({
        id: crypto.randomUUID(),
        name: name,
        label: name,
        description: "",
        condition: {},
        level: 0,
        order: order
    });

});

parcelRegister("kDIpz", function(module, exports) {

$parcel$export(module.exports, "hasArsObjectWithName", function () { return $ca05ce9d4df88e11$export$a746c501b6d0fc51; });
$parcel$export(module.exports, "cloneArsObject", function () { return $ca05ce9d4df88e11$export$87722bce1ba81ee0; });

var $gSkQi = parcelRequire("gSkQi");

var $cIJV5 = parcelRequire("cIJV5");
const $ca05ce9d4df88e11$export$a746c501b6d0fc51 = (items, item)=>(items ?? []).some((currentItem)=>currentItem.name === item.name);
const $ca05ce9d4df88e11$export$87722bce1ba81ee0 = (item)=>{
    const copiedItem = (0, $gSkQi.cloneDeep)(item);
    copiedItem.id = crypto.randomUUID();
    copiedItem.fromHierarchyId = (0, $cIJV5.CURRENT_HIERARCHY_ID);
    delete copiedItem.disableEditing;
    return copiedItem;
};

});

parcelRegister("ihppY", function(module, exports) {

$parcel$export(module.exports, "MultipleDatasetCheck", function () { return $97705d1e49657436$export$983eb9c426b83475; });

var $bbzbN = parcelRequire("bbzbN");

var $lnphf = parcelRequire("lnphf");

var $fZCs4 = parcelRequire("fZCs4");
const $97705d1e49657436$export$983eb9c426b83475 = ()=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    return Array.from(state.datasetsInUse).filter((d)=>d !== "ADSL").length <= 1 ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `text-danger`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lnphf.default), {}),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                className: "mx-1",
                children: [
                    "The listing is being built from multiple datasets (",
                    Array.from(state.datasetsInUse).join(", "),
                    ")."
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                children: "This may result in unexpected behaviour."
            })
        ]
    });
};
$97705d1e49657436$export$983eb9c426b83475.displayName = "MultipleDatasetCheck";

});
parcelRegister("lnphf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8ff5a813c10c7ea$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $f8ff5a813c10c7ea$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $f8ff5a813c10c7ea$var$_extends() {
    return $f8ff5a813c10c7ea$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f8ff5a813c10c7ea$var$_extends.apply(null, arguments);
}
function $f8ff5a813c10c7ea$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f8ff5a813c10c7ea$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f8ff5a813c10c7ea$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f8ff5a813c10c7ea$var$ExclamationOctagonFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $f8ff5a813c10c7ea$var$_objectWithoutProperties(_ref, $f8ff5a813c10c7ea$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $f8ff5a813c10c7ea$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-octagon-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    }));
});
$f8ff5a813c10c7ea$var$ExclamationOctagonFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $f8ff5a813c10c7ea$export$2e2bcd8739ae039 = $f8ff5a813c10c7ea$var$ExclamationOctagonFill;

});
parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $RhbpY = parcelRequire("RhbpY");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $1bfc5778dcd4841a$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("86JB7"))($RhbpY.isElement, $1bfc5778dcd4841a$var$throwOnDirectAccess);

});
parcelRegister("RhbpY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("l7Vb0"));

});
parcelRegister("l7Vb0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f6169a7d1d3dda71$export$2b8d127b894957b9; }, function (v) { return $f6169a7d1d3dda71$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f6169a7d1d3dda71$export$cea3a54a6425200c; }, function (v) { return $f6169a7d1d3dda71$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f6169a7d1d3dda71$export$a7c73072b1a182ae; }, function (v) { return $f6169a7d1d3dda71$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f6169a7d1d3dda71$export$9f27bc3417b4524d; }, function (v) { return $f6169a7d1d3dda71$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f6169a7d1d3dda71$export$db77ccec0bb4ccac; }, function (v) { return $f6169a7d1d3dda71$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f6169a7d1d3dda71$export$8392c0c9d3dcbd35; }, function (v) { return $f6169a7d1d3dda71$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f6169a7d1d3dda71$export$ffb0004e005737fa; }, function (v) { return $f6169a7d1d3dda71$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f6169a7d1d3dda71$export$b624eff549462981; }, function (v) { return $f6169a7d1d3dda71$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f6169a7d1d3dda71$export$7897aa7841a5380c; }, function (v) { return $f6169a7d1d3dda71$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f6169a7d1d3dda71$export$602eac185826482c; }, function (v) { return $f6169a7d1d3dda71$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f6169a7d1d3dda71$export$e2c29f18771995cb; }, function (v) { return $f6169a7d1d3dda71$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f6169a7d1d3dda71$export$5f8d39834fd61797; }, function (v) { return $f6169a7d1d3dda71$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f6169a7d1d3dda71$export$74bf444e3cd11ea5; }, function (v) { return $f6169a7d1d3dda71$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f6169a7d1d3dda71$export$92387174baf9b227; }, function (v) { return $f6169a7d1d3dda71$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f6169a7d1d3dda71$export$ec112efeb987d9c6; }, function (v) { return $f6169a7d1d3dda71$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f6169a7d1d3dda71$export$b706b080d889d2c9; }, function (v) { return $f6169a7d1d3dda71$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f6169a7d1d3dda71$export$5be5a87408f70ddc; }, function (v) { return $f6169a7d1d3dda71$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f6169a7d1d3dda71$export$45a5e7f76e0caa8d; }, function (v) { return $f6169a7d1d3dda71$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f6169a7d1d3dda71$export$455c2e768291efa6; }, function (v) { return $f6169a7d1d3dda71$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f6169a7d1d3dda71$export$9522e17588c12572; }, function (v) { return $f6169a7d1d3dda71$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f6169a7d1d3dda71$export$2110ac352bb060b9; }, function (v) { return $f6169a7d1d3dda71$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f6169a7d1d3dda71$export$56885ab8b9c456ab; }, function (v) { return $f6169a7d1d3dda71$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f6169a7d1d3dda71$export$d927fcb6adf8f9de; }, function (v) { return $f6169a7d1d3dda71$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f6169a7d1d3dda71$export$b82d16f27459e05a; }, function (v) { return $f6169a7d1d3dda71$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f6169a7d1d3dda71$export$522c17b4f5e123e8; }, function (v) { return $f6169a7d1d3dda71$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f6169a7d1d3dda71$export$1aabd8a0274ecfd6; }, function (v) { return $f6169a7d1d3dda71$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f6169a7d1d3dda71$export$9b621391a187a31a; }, function (v) { return $f6169a7d1d3dda71$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f6169a7d1d3dda71$export$f5bbd400c2f4426f; }, function (v) { return $f6169a7d1d3dda71$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f6169a7d1d3dda71$export$2b8d127b894957b9;
var $f6169a7d1d3dda71$export$cea3a54a6425200c;
var $f6169a7d1d3dda71$export$a7c73072b1a182ae;
var $f6169a7d1d3dda71$export$9f27bc3417b4524d;
var $f6169a7d1d3dda71$export$db77ccec0bb4ccac;
var $f6169a7d1d3dda71$export$8392c0c9d3dcbd35;
var $f6169a7d1d3dda71$export$ffb0004e005737fa;
var $f6169a7d1d3dda71$export$b624eff549462981;
var $f6169a7d1d3dda71$export$7897aa7841a5380c;
var $f6169a7d1d3dda71$export$602eac185826482c;
var $f6169a7d1d3dda71$export$e2c29f18771995cb;
var $f6169a7d1d3dda71$export$5f8d39834fd61797;
var $f6169a7d1d3dda71$export$74bf444e3cd11ea5;
var $f6169a7d1d3dda71$export$92387174baf9b227;
var $f6169a7d1d3dda71$export$ec112efeb987d9c6;
var $f6169a7d1d3dda71$export$b706b080d889d2c9;
var $f6169a7d1d3dda71$export$5be5a87408f70ddc;
var $f6169a7d1d3dda71$export$45a5e7f76e0caa8d;
var $f6169a7d1d3dda71$export$455c2e768291efa6;
var $f6169a7d1d3dda71$export$9522e17588c12572;
var $f6169a7d1d3dda71$export$2110ac352bb060b9;
var $f6169a7d1d3dda71$export$56885ab8b9c456ab;
var $f6169a7d1d3dda71$export$d927fcb6adf8f9de;
var $f6169a7d1d3dda71$export$b82d16f27459e05a;
var $f6169a7d1d3dda71$export$522c17b4f5e123e8;
var $f6169a7d1d3dda71$export$1aabd8a0274ecfd6;
var $f6169a7d1d3dda71$export$9b621391a187a31a;
var $f6169a7d1d3dda71$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $f6169a7d1d3dda71$export$2b8d127b894957b9 = AsyncMode;
    $f6169a7d1d3dda71$export$cea3a54a6425200c = ConcurrentMode;
    $f6169a7d1d3dda71$export$a7c73072b1a182ae = ContextConsumer;
    $f6169a7d1d3dda71$export$9f27bc3417b4524d = ContextProvider;
    $f6169a7d1d3dda71$export$db77ccec0bb4ccac = Element;
    $f6169a7d1d3dda71$export$8392c0c9d3dcbd35 = ForwardRef;
    $f6169a7d1d3dda71$export$ffb0004e005737fa = Fragment;
    $f6169a7d1d3dda71$export$b624eff549462981 = Lazy;
    $f6169a7d1d3dda71$export$7897aa7841a5380c = Memo;
    $f6169a7d1d3dda71$export$602eac185826482c = Portal;
    $f6169a7d1d3dda71$export$e2c29f18771995cb = Profiler;
    $f6169a7d1d3dda71$export$5f8d39834fd61797 = StrictMode;
    $f6169a7d1d3dda71$export$74bf444e3cd11ea5 = Suspense;
    $f6169a7d1d3dda71$export$92387174baf9b227 = isAsyncMode;
    $f6169a7d1d3dda71$export$ec112efeb987d9c6 = isConcurrentMode;
    $f6169a7d1d3dda71$export$b706b080d889d2c9 = isContextConsumer;
    $f6169a7d1d3dda71$export$5be5a87408f70ddc = isContextProvider;
    $f6169a7d1d3dda71$export$45a5e7f76e0caa8d = isElement;
    $f6169a7d1d3dda71$export$455c2e768291efa6 = isForwardRef;
    $f6169a7d1d3dda71$export$9522e17588c12572 = isFragment;
    $f6169a7d1d3dda71$export$2110ac352bb060b9 = isLazy;
    $f6169a7d1d3dda71$export$56885ab8b9c456ab = isMemo;
    $f6169a7d1d3dda71$export$d927fcb6adf8f9de = isPortal;
    $f6169a7d1d3dda71$export$b82d16f27459e05a = isProfiler;
    $f6169a7d1d3dda71$export$522c17b4f5e123e8 = isStrictMode;
    $f6169a7d1d3dda71$export$1aabd8a0274ecfd6 = isSuspense;
    $f6169a7d1d3dda71$export$9b621391a187a31a = isValidElementType;
    $f6169a7d1d3dda71$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("86JB7", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $RhbpY = parcelRequire("RhbpY");

var $013Yp = parcelRequire("013Yp");

var $7KQqJ = parcelRequire("7KQqJ");

var $6FmTs = parcelRequire("6FmTs");

var $4QToq = parcelRequire("4QToq");
var $5e7240ff7ef28fbd$var$printWarning = function() {};
$5e7240ff7ef28fbd$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $5e7240ff7ef28fbd$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $7KQqJ) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $5e7240ff7ef28fbd$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($5e7240ff7ef28fbd$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $7KQqJ);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$RhbpY.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $5e7240ff7ef28fbd$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $5e7240ff7ef28fbd$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $5e7240ff7ef28fbd$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($6FmTs(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $7KQqJ);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $5e7240ff7ef28fbd$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $5e7240ff7ef28fbd$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $5e7240ff7ef28fbd$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $5e7240ff7ef28fbd$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $7KQqJ);
                if (checkerResult == null) return null;
                if (checkerResult.data && $6FmTs(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $7KQqJ);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $013Yp({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($6FmTs(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $7KQqJ);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $4QToq;
    ReactPropTypes.resetWarningCache = $4QToq.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});

parcelRegister("6FmTs", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("4QToq", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $3886fca70ca650be$var$printWarning = function() {};

var $7KQqJ = parcelRequire("7KQqJ");
var $3886fca70ca650be$var$loggedTypeFailures = {};

var $6FmTs = parcelRequire("6FmTs");
$3886fca70ca650be$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $3886fca70ca650be$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($6FmTs(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $7KQqJ);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $3886fca70ca650be$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $3886fca70ca650be$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $3886fca70ca650be$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $3886fca70ca650be$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $3886fca70ca650be$var$checkPropTypes.resetWarningCache = function() {
    $3886fca70ca650be$var$loggedTypeFailures = {};
};
module.exports = $3886fca70ca650be$var$checkPropTypes;

});






parcelRegister("g3GSA", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarItemKind", function () { return $3c6ab50dd3ece5fb$export$255c8eaae90ff2f5; });
var $3c6ab50dd3ece5fb$export$255c8eaae90ff2f5 = /*#__PURE__*/ function(ArsSidebarItemKind) {
    ArsSidebarItemKind["AnalysisMethod"] = "analysisMethod";
    ArsSidebarItemKind["GroupingFactor"] = "groupingFactor";
    ArsSidebarItemKind["Operation"] = "operation";
    ArsSidebarItemKind["Variable"] = "variable";
    return ArsSidebarItemKind;
}({});

});

parcelRegister("clOgJ", function(module, exports) {

$parcel$export(module.exports, "isArsSidebarItemData", function () { return $3eec9d045e1c87cc$export$c346f5059222947c; });

var $ek4hO = parcelRequire("ek4hO");

var $4qgA8 = parcelRequire("4qgA8");

var $4AU0o = parcelRequire("4AU0o");

var $8CFpa = parcelRequire("8CFpa");

var $hoYmS = parcelRequire("hoYmS");
const $3eec9d045e1c87cc$export$c346f5059222947c = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj) || !("kind" in obj) || !("dropItem" in obj)) return false;
    // Check sub object
    if (obj.kind === "groupingFactor") return (0, $4AU0o.isGroupingFactor)(obj.dropItem);
    else if (obj.kind === "analysisMethod") return (0, $ek4hO.isAnalysisMethod)(obj.dropItem);
    else if (obj.kind === "operation") return (0, $hoYmS.isOperation)(obj.dropItem);
    else if (obj.kind === "variable") return (0, $4qgA8.isAnnotationVariable)(obj.dropItem);
    // Not good
    return false;
};

});

parcelRegister("6odg7", function(module, exports) {

$parcel$export(module.exports, "ArsBlockDropZone", function () { return $47d31b3890098c52$export$4616c5256231f105; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
const $47d31b3890098c52$export$ea09616471217332 = "#4dabf7";
const $47d31b3890098c52$export$4616c5256231f105 = ({ id: id, onDrop: onDrop, top: top, bottom: bottom })=>{
    const { state: arsState } = (0, $fZCs4.useArsContext)();
    const [showHighlight, setShowHighlight] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: id,
        className: "ars-block-drop-zone",
        onDragOver: (e)=>{
            e.preventDefault();
            // Can only drop when the current view is showing the right thing
            if (arsState.currentSidebar.view === "groupingFactor") {
                setShowHighlight(true);
                e.dataTransfer.dropEffect = "copy";
            } else {
                setShowHighlight(false);
                e.dataTransfer.dropEffect = "none";
            }
        },
        onDragLeave: (e)=>{
            e.preventDefault();
            e.dataTransfer.dropEffect = "none";
            setShowHighlight(false);
        },
        onDrop: (e)=>{
            e.preventDefault();
            setShowHighlight(false);
            onDrop(e);
        },
        style: {
            backgroundColor: showHighlight ? $47d31b3890098c52$export$ea09616471217332 : undefined,
            border: showHighlight ? `2px solid ${$47d31b3890098c52$export$ea09616471217332}` : undefined,
            bottom: bottom,
            left: 0,
            opacity: showHighlight ? "0.5" : "0",
            position: "absolute",
            right: 0,
            top: top,
            zIndex: 199
        }
    });
};
$47d31b3890098c52$export$4616c5256231f105.displayName = "ArsBlockDropZone";

});

parcelRegister("3BGiR", function(module, exports) {

$parcel$export(module.exports, "ArsBlockLine", function () { return $cbc9af3be20d9aa2$export$3a579d6a3465a635; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $5m3yv = parcelRequire("5m3yv");

var $gOa7m = parcelRequire("gOa7m");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
const $cbc9af3be20d9aa2$export$3a579d6a3465a635 = ({ disabled: disabled = false, editorDefns: editorDefns, pageByIndex: pageByIndex, setValue: setValue, value: value })=>{
    const { state: arsState } = (0, $fZCs4.useArsContext)();
    const pageByItem = value[pageByIndex];
    const groupingFactor = arsState.groupingFactors[pageByItem.groupingFactorId];
    const label = pageByItem.label !== undefined ? pageByItem.label : editorDefns.textToT(groupingFactor?.label ?? groupingFactor?.name ?? // istanbul ignore next
    "Unknown grouping factor");
    /**
   * Remove the current line from the array
   */ const removeLine = ()=>{
        setValue(value.filter((_, itemIndex)=>itemIndex !== pageByIndex));
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLine,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineButtons
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).calcSize,
                menuItems: disabled ? [] : [
                    {
                        label: "Delete line",
                        action: removeLine
                    }
                ],
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineItemHolder,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexGrow1,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineItem,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)(editorDefns.Editor, {
                                id: `ars-block-line-editor-${pageByIndex}`,
                                value: label,
                                editable: !disabled,
                                setValue: (ret)=>{
                                    const newPageItem = {
                                        ...pageByItem,
                                        label: ret
                                    };
                                    const newPageBy = value.map((item, index)=>index === pageByIndex ? newPageItem : item);
                                    setValue(newPageBy);
                                }
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineButtons,
                children: !disabled ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                    id: `ars-block-remove-line-${pageByIndex}`,
                    iconName: "aioxMinus",
                    onClick: removeLine,
                    tipText: "Remove page by line"
                }) : null
            })
        ]
    });
};
$cbc9af3be20d9aa2$export$3a579d6a3465a635.displayName = "ArsBlockLine";

});


parcelRegister("4K7d5", function(module, exports) {

});


parcelRegister("bIAbO", function(module, exports) {
$parcel$export(module.exports, "AnalysisMethodControl", function () { return (parcelRequire("7uNID")).AnalysisMethodControl; });
$parcel$export(module.exports, "AnalysisSetControl", function () { return (parcelRequire("9ijW6")).AnalysisSetControl; });
$parcel$export(module.exports, "CaseWhenControl", function () { return (parcelRequire("i5A9K")).CaseWhenControl; });
$parcel$export(module.exports, "DataSubsetControl", function () { return (parcelRequire("b1QeS")).DataSubsetControl; });
$parcel$export(module.exports, "GroupingFactorControl", function () { return (parcelRequire("bRDEW")).GroupingFactorControl; });
$parcel$export(module.exports, "OperationControl", function () { return (parcelRequire("apoy8")).OperationControl; });
$parcel$export(module.exports, "ReferencedEntityControl", function () { return (parcelRequire("kupca")).ReferencedEntityControl; });
parcelRequire("kLYcB");
parcelRequire("bgFHV");
parcelRequire("7uNID");
parcelRequire("9iqjg");
parcelRequire("dBJIX");
parcelRequire("5GCs5");
parcelRequire("f55zq");
parcelRequire("9ijW6");
parcelRequire("i5A9K");
parcelRequire("b1QeS");
parcelRequire("5zEFB");
parcelRequire("3qrfA");
parcelRequire("bRDEW");
parcelRequire("kteXq");
parcelRequire("apoy8");
parcelRequire("jA618");
parcelRequire("kupca");
parcelRequire("dPdcj");
parcelRequire("rRNEc");
parcelRequire("8lrKZ");
parcelRequire("9apvI");
parcelRequire("gDWp8");
parcelRequire("e5Poo");
parcelRequire("bNdmh");
parcelRequire("h9QS8");

});
parcelRegister("kLYcB", function(module, exports) {

$parcel$export(module.exports, "AddWhereClauseButton", function () { return $b4080fefbf2410a6$export$49cc53c327ca84a7; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");

var $8HzIe = parcelRequire("8HzIe");
const $b4080fefbf2410a6$export$49cc53c327ca84a7 = ({ id: id, onClick: onClick, isPending: isPending, disabled: disabled = false })=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
        "aria-label": "Add clause",
        className: "mt-2 d-flex align-items-center",
        disabled: isPending || disabled,
        id: id,
        onClick: onClick,
        requestStatus: isPending ? {
            requesting: true,
            error: false
        } : undefined,
        size: "sm",
        variant: "success",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "me-2",
                children: "Add clause"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
        ]
    });
$b4080fefbf2410a6$export$49cc53c327ca84a7.displayName = "AddWhereClauseButton";

});
parcelRegister("6dv4K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $486c0ff330f0cc85$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $486c0ff330f0cc85$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $486c0ff330f0cc85$var$_extends() {
    return $486c0ff330f0cc85$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $486c0ff330f0cc85$var$_extends.apply(null, arguments);
}
function $486c0ff330f0cc85$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $486c0ff330f0cc85$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $486c0ff330f0cc85$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $486c0ff330f0cc85$var$PlusCircle = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $486c0ff330f0cc85$var$_objectWithoutProperties(_ref, $486c0ff330f0cc85$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $486c0ff330f0cc85$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-plus-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
    }));
});
$486c0ff330f0cc85$var$PlusCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $486c0ff330f0cc85$export$2e2bcd8739ae039 = $486c0ff330f0cc85$var$PlusCircle;

});

parcelRegister("8HzIe", function(module, exports) {

$parcel$export(module.exports, "AsyncButton", function () { return $be53c7f8956feafa$export$3956658c2d361270; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $b6fw7 = parcelRequire("b6fw7");

var $aNfx0 = parcelRequire("aNfx0");
parcelRequire("2nuru");
var $9eqKP = parcelRequire("9eqKP");
const $be53c7f8956feafa$export$3956658c2d361270 = ({ requestStatus: requestStatus, pauseCoverText: pauseCoverText, ...props })=>{
    const requesting = Array.isArray(requestStatus) ? requestStatus.some((s)=>s.requesting) : requestStatus?.requesting;
    const error = Array.isArray(requestStatus) ? requestStatus.some((s)=>s.error) : requestStatus?.error;
    const errorText = Array.isArray(requestStatus) ? requestStatus.filter((s)=>s.error && s.errorText)?.map((s)=>s.errorText).join(", ") : requestStatus?.errorText;
    const buttonRef = (0, $7fPBF.useRef)(null);
    const coverTextRef = (0, $7fPBF.useRef)(null);
    const [minWidth, setMinWidth] = (0, $7fPBF.useState)("0px");
    (0, $7fPBF.useEffect)(()=>{
        const button = buttonRef.current;
        const coverText = coverTextRef.current;
        if (button && coverText && requesting) {
            let coverTextWidth = coverText.offsetWidth;
            coverTextWidth = coverTextWidth + 26; // 26 for the spinner and a bit of padding
            const buttonWidth = button.offsetWidth;
            /* istanbul ignore else */ if (coverTextWidth > buttonWidth) setMinWidth(`${coverTextWidth}px`);
        } else setMinWidth("0px");
    }, [
        requesting
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
        ref: buttonRef,
        role: "button",
        ...props,
        disabled: props.disabled || requesting,
        onClick: !requesting ? props.onClick : undefined,
        title: error ? errorText : props.title,
        style: {
            ...props.style,
            minWidth: minWidth,
            position: "relative"
        },
        children: requesting ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                    ref: coverTextRef,
                    text: pauseCoverText
                }),
                props.children
            ]
        }) : error ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aNfx0.default), {}),
                " ",
                errorText?.trim() !== "" ? errorText : "Error"
            ]
        }) : props.children
    });
};
$be53c7f8956feafa$export$3956658c2d361270.displayName = "AsyncButton";

});
parcelRegister("b6fw7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $814c4aa0f1ac4245$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $bqB2L = parcelRequire("bqB2L");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $814c4aa0f1ac4245$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $bqB2L.useButtonProps)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$814c4aa0f1ac4245$var$Button.displayName = 'Button';
var $814c4aa0f1ac4245$export$2e2bcd8739ae039 = $814c4aa0f1ac4245$var$Button;

});
parcelRegister("bqB2L", function(module, exports) {

$parcel$export(module.exports, "useButtonProps", function () { return $851edb81f0994b16$export$a0ee72f2c720a5c3; });
$parcel$export(module.exports, "default", function () { return $851edb81f0994b16$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
const $851edb81f0994b16$var$_excluded = [
    "as",
    "disabled"
];
function $851edb81f0994b16$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $851edb81f0994b16$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $851edb81f0994b16$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $851edb81f0994b16$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $851edb81f0994b16$var$Button = /*#__PURE__*/ $7fPBF.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $851edb81f0994b16$var$_objectWithoutPropertiesLoose(_ref, $851edb81f0994b16$var$_excluded);
    const [buttonProps, { tagName: Component }] = $851edb81f0994b16$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$851edb81f0994b16$var$Button.displayName = 'Button';
var $851edb81f0994b16$export$2e2bcd8739ae039 = $851edb81f0994b16$var$Button;

});


parcelRegister("aNfx0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7dba872b6e5fd371$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $7dba872b6e5fd371$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $7dba872b6e5fd371$var$_extends() {
    return $7dba872b6e5fd371$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7dba872b6e5fd371$var$_extends.apply(null, arguments);
}
function $7dba872b6e5fd371$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7dba872b6e5fd371$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7dba872b6e5fd371$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7dba872b6e5fd371$var$ExclamationCircle = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $7dba872b6e5fd371$var$_objectWithoutProperties(_ref, $7dba872b6e5fd371$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $7dba872b6e5fd371$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"
    }));
});
$7dba872b6e5fd371$var$ExclamationCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $7dba872b6e5fd371$export$2e2bcd8739ae039 = $7dba872b6e5fd371$var$ExclamationCircle;

});



parcelRegister("bgFHV", function(module, exports) {

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4tJ7o = parcelRequire("4tJ7o");
var $gLW8Q = parcelRequire("gLW8Q");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
parcelRequire("0PqYf");
var $h7VrC = parcelRequire("h7VrC");
var $3EZep = parcelRequire("3EZep");

var $aJVDk = parcelRequire("aJVDk");

var $dBJIX = parcelRequire("dBJIX");

var $5GCs5 = parcelRequire("5GCs5");

var $5zEFB = parcelRequire("5zEFB");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");
/**
 * Builds dropdown options for ARS entity ID selectors.
 *
 * Includes the current value when it is not present in state to avoid
 * rendering an empty selection for legacy or out-of-sync data.
 *
 * @param records - Available ARS entities from context state.
 * @param selectedId - Currently selected ID on the edited analysis.
 * @returns Select options for use with ArsSelect.
 */ const $313400f53bce5278$var$buildIdOptions = (records, selectedId)=>{
    const entityIds = Object.keys(records);
    const knownIds = [
        ...entityIds,
        ...[
            selectedId
        ].filter((id)=>id && !entityIds.includes(id))
    ];
    return knownIds.map((id)=>{
        const name = records[id]?.name ?? id;
        return {
            value: id,
            label: `${name} (${id})`
        };
    });
};
const $313400f53bce5278$export$1c12e92016548ee4 = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)("properties");
    const analysis = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $aJVDk.isAnalysis));
    const documentReferences = (0, $7fPBF.useMemo)(()=>analysis?.documentRefs ?? // istanbul ignore next
        [], [
        analysis
    ]);
    const analysisSetOptions = (0, $7fPBF.useMemo)(()=>$313400f53bce5278$var$buildIdOptions(state.analysisSets, analysis?.analysisSetId ?? // istanbul ignore next
        ""), [
        state.analysisSets,
        analysis?.analysisSetId
    ]);
    const dataSubsetOptions = (0, $7fPBF.useMemo)(()=>$313400f53bce5278$var$buildIdOptions(state.dataSubsets, analysis?.dataSubsetId ?? // istanbul ignore next
        ""), [
        state.dataSubsets,
        analysis?.dataSubsetId
    ]);
    const methodOptions = (0, $7fPBF.useMemo)(()=>$313400f53bce5278$var$buildIdOptions(state.analysisMethods, analysis?.methodId ?? // istanbul ignore next
        ""), [
        state.analysisMethods,
        analysis?.methodId
    ]);
    const hasProgrammingCode = analysis?.programmingCode !== undefined;
    /**
   * Handles adding a new document reference to the analysis.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysis) {
            const documentReferenceCount = documentReferences.length;
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRefs/${documentReferenceCount}`,
                value: newDocumentReference
            });
        }
    };
    /**
   * Handles adding a programming code block to the analysis.
   */ const handleAddProgrammingCode = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysis && !hasProgrammingCode) {
            const newProgrammingCode = {
                context: "",
                code: "",
                parameters: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/programmingCode`,
                value: newProgrammingCode
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            canRename && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Container, {
                activeKey: activeTab,
                onSelect: (k)=>{
                    /* istanbul ignore else */ if (k) setActiveTab(k);
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default), {
                        variant: "tabs",
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "properties",
                                    children: "Properties"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "data-selection",
                                    children: "Data selection"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "document-refs",
                                    children: "Document references"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "programming-code",
                                    children: "Programming code"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "programming-parameters",
                                    children: "Programming parameters"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Content, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                eventKey: "properties",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                                        dataPath: dataPath,
                                        canRename: canRename,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                                        dataPath: `${dataPath}/reason/controlledTerm`,
                                        id: `${idRoute}-reason-controlled-term`,
                                        label: "Reason controlled term",
                                        labelWidth: 2,
                                        placeholder: "Enter reason controlled term",
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                                        dataPath: `${dataPath}/purpose/controlledTerm`,
                                        id: `${idRoute}-purpose-controlled-term`,
                                        label: "Purpose controlled term",
                                        labelWidth: 2,
                                        placeholder: "Enter purpose controlled term",
                                        disabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                eventKey: "data-selection",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                                        dataPath: `${dataPath}/dataset`,
                                        id: `${idRoute}-dataset`,
                                        label: "Dataset",
                                        labelWidth: 2,
                                        placeholder: "Enter dataset",
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                                        dataPath: `${dataPath}/variable`,
                                        id: `${idRoute}-variable`,
                                        label: "Variable",
                                        labelWidth: 2,
                                        placeholder: "Enter variable",
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                                        dataPath: `${dataPath}/analysisSetId`,
                                        id: `${idRoute}-analysis-set-id`,
                                        label: "Analysis set id",
                                        labelWidth: 2,
                                        options: analysisSetOptions,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                                        dataPath: `${dataPath}/dataSubsetId`,
                                        id: `${idRoute}-data-subset-id`,
                                        label: "Data subset id",
                                        labelWidth: 2,
                                        options: dataSubsetOptions,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                                        dataPath: `${dataPath}/methodId`,
                                        id: `${idRoute}-method-id`,
                                        label: "Method id",
                                        labelWidth: 2,
                                        options: methodOptions,
                                        disabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                eventKey: "document-refs",
                                children: [
                                    documentReferences.map((documentReference, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $5zEFB.DocumentReferenceControl), {
                                            dataPath: `${dataPath}/documentRefs/${index}`,
                                            disabled: disabled,
                                            siblingCount: documentReferences.length
                                        }, `${documentReference.referenceDocumentId}-${index}`)),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                                        id: `${idRoute}-add-document-reference`,
                                        onClick: handleAddDocumentReference,
                                        className: "d-flex align-items-center btn-sm btn-success",
                                        disabled: disabled,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "me-2",
                                                children: "Add document reference"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                eventKey: "programming-code",
                                children: [
                                    hasProgrammingCode && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dBJIX.AnalysisOutputProgrammingCodeControl), {
                                        dataPath: `${dataPath}/programmingCode`,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                                        id: `${idRoute}-add-programming-code`,
                                        onClick: handleAddProgrammingCode,
                                        className: "d-flex align-items-center btn-sm btn-success",
                                        disabled: disabled || hasProgrammingCode,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "me-2",
                                                children: "Add programming code"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                                eventKey: "programming-parameters",
                                children: hasProgrammingCode && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5GCs5.AnalysisOutputProgrammingCodeParametersControl), {
                                    dataPath: `${dataPath}/programmingCode`,
                                    disabled: disabled
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$313400f53bce5278$export$1c12e92016548ee4.displayName = "AnalysisControl";

});
parcelRegister("4tJ7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $342cde640f6986bd$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("ecgdb");
var $9GY4V = parcelRequire("9GY4V");

var $bNAtM = parcelRequire("bNAtM");

var $jbn4d = parcelRequire("jbn4d");

var $2VW10 = parcelRequire("2VW10");

var $2mRgJ = parcelRequire("2mRgJ");

var $jDlQd = parcelRequire("jDlQd");

var $87bIP = parcelRequire("87bIP");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $342cde640f6986bd$var$Nav = /*#__PURE__*/ $7fPBF.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $9GY4V.default)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $jbn4d.useBootstrapPrefix)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $7fPBF.useContext)((0, $2VW10.default));
    const cardHeaderContext = (0, $7fPBF.useContext)((0, $2mRgJ.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bNAtM.default), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$342cde640f6986bd$var$Nav.displayName = 'Nav';
var $342cde640f6986bd$export$2e2bcd8739ae039 = Object.assign($342cde640f6986bd$var$Nav, {
    Item: (0, $jDlQd.default),
    Link: (0, $87bIP.default)
});

});
parcelRegister("ecgdb", function(module, exports) {

$parcel$export(module.exports, "useUncontrolled", function () { return (parcelRequire("9GY4V")).default; });

var $9GY4V = parcelRequire("9GY4V");

var $k0T6w = parcelRequire("k0T6w");

});
parcelRegister("9GY4V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70e6a39b2985f538$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $2N39r = parcelRequire("2N39r");
function $70e6a39b2985f538$var$_toPropertyKey(arg) {
    var key = $70e6a39b2985f538$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $70e6a39b2985f538$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $70e6a39b2985f538$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $7fPBF.useRef)(propValue !== undefined);
    var _useState = (0, $7fPBF.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $7fPBF.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $70e6a39b2985f538$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$2N39r.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, $cFLic.default)(_ref, [
            $2N39r.defaultKey(fieldName),
            fieldName
        ].map($70e6a39b2985f538$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $70e6a39b2985f538$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $kY3Ke.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("2N39r", function(module, exports) {

$parcel$export(module.exports, "defaultKey", function () { return $20829a2be69c8f06$export$26cbf8c37e721e67; });
$parcel$export(module.exports, "uncontrolledPropTypes", function () { return $20829a2be69c8f06$export$8abd944bed26e726; });
$parcel$export(module.exports, "isProp", function () { return $20829a2be69c8f06$export$12ae2baa35bd9b8b; });
$parcel$export(module.exports, "canAcceptRef", function () { return $20829a2be69c8f06$export$95e5b18573b29087; });

var $9ZxFg = parcelRequire("9ZxFg");
var $20829a2be69c8f06$var$noop = function noop() {};
function $20829a2be69c8f06$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $20829a2be69c8f06$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $20829a2be69c8f06$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$20829a2be69c8f06$export$26cbf8c37e721e67(prop)] = $20829a2be69c8f06$var$noop;
        var handler = controlledValues[prop];
        !(typeof handler === 'string' && handler.trim().length) && (0, (/*@__PURE__*/$parcel$interopDefault($9ZxFg)))(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
        propTypes[prop] = $20829a2be69c8f06$var$readOnlyPropType(handler, displayName);
    });
    return propTypes;
}
function $20829a2be69c8f06$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $20829a2be69c8f06$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $20829a2be69c8f06$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

});
parcelRegister("9ZxFg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $7463ec9ff5b588fd$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (format === undefined) throw new Error('invariant requires an error message argument');
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $7463ec9ff5b588fd$var$invariant;

});



parcelRegister("k0T6w", function(module, exports) {

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $1KLsX = parcelRequire("1KLsX");

var $7fPBF = parcelRequire("7fPBF");

var $gerGz = parcelRequire("gerGz");

var $9ZxFg = parcelRequire("9ZxFg");

var $2N39r = parcelRequire("2N39r");
var $e91e8d4234b7087d$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $e91e8d4234b7087d$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $2N39r.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($2N39r.defaultKey);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($9ZxFg)))(false, "[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: " + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $1KLsX.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $kY3Ke.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$2N39r.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $kY3Ke.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$2N39r.isProp(props, key) && $2N39r.isProp(prevProps, key)) nextState.values[key] = props[$2N39r.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $cFLic.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $kY3Ke.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
    (0, $gerGz.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $kY3Ke.default)({
        innerRef: function innerRef() {}
    }, $2N39r.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(UncontrolledComponent, (0, $kY3Ke.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $e91e8d4234b7087d$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $e91e8d4234b7087d$export$2e2bcd8739ae039(newComponent, (0, $kY3Ke.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

});
parcelRegister("1KLsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146ee816144a450d$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $iJeDO.default)(t, o);
}

});
parcelRegister("iJeDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da27c96857818bcc$export$2e2bcd8739ae039; });
function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("gerGz", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $bd136de90080c1b8$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $bd136de90080c1b8$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $bd136de90080c1b8$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $bd136de90080c1b8$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$bd136de90080c1b8$var$componentWillMount.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $bd136de90080c1b8$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $bd136de90080c1b8$var$componentWillMount;
        prototype.componentWillReceiveProps = $bd136de90080c1b8$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $bd136de90080c1b8$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("bNAtM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8970915407f5855a$export$2e2bcd8739ae039; });

var $cKYDs = parcelRequire("cKYDs");

var $7fPBF = parcelRequire("7fPBF");

var $aRhbx = parcelRequire("aRhbx");

var $f2Ftg = parcelRequire("f2Ftg");

var $68Mia = parcelRequire("68Mia");

var $cpnTQ = parcelRequire("cpnTQ");

var $d6KM4 = parcelRequire("d6KM4");

var $1l3ik = parcelRequire("1l3ik");

var $3rd7w = parcelRequire("3rd7w");

var $bbzbN = parcelRequire("bbzbN");
const $8970915407f5855a$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $8970915407f5855a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8970915407f5855a$var$noop = ()=>{};
const $8970915407f5855a$var$EVENT_KEY_ATTR = (0, $1l3ik.dataAttr)('event-key');
const $8970915407f5855a$var$Nav = /*#__PURE__*/ $7fPBF.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $8970915407f5855a$var$_objectWithoutPropertiesLoose(_ref, $8970915407f5855a$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $aRhbx.default)();
    const needsRefocusRef = (0, $7fPBF.useRef)(false);
    const parentOnSelect = (0, $7fPBF.useContext)((0, $cpnTQ.default));
    const tabContext = (0, $7fPBF.useContext)((0, $d6KM4.default));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $7fPBF.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $cKYDs.default)(currentListNode, `[${$8970915407f5855a$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $1l3ik.dataProp)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $7fPBF.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$8970915407f5855a$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $f2Ftg.default)(ref, listNode);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cpnTQ.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $68Mia.default).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $cpnTQ.makeEventKey)(activeKey),
                getControlledId: getControlledId || $8970915407f5855a$var$noop,
                getControllerId: getControllerId || $8970915407f5855a$var$noop
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$8970915407f5855a$var$Nav.displayName = 'Nav';
var $8970915407f5855a$export$2e2bcd8739ae039 = Object.assign($8970915407f5855a$var$Nav, {
    Item: (0, $3rd7w.default)
});

});
parcelRegister("cKYDs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9498d0dbbc461bdc$export$2e2bcd8739ae039; });
var $9498d0dbbc461bdc$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $9498d0dbbc461bdc$export$2e2bcd8739ae039(element, selector) {
    return $9498d0dbbc461bdc$var$toArray(element.querySelectorAll(selector));
}

});

parcelRegister("aRhbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e7c2f351ac84d4c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $7e7c2f351ac84d4c$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $7fPBF.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}

});

parcelRegister("f2Ftg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af3736314ab34f62$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $af3736314ab34f62$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $af3736314ab34f62$export$c9058316764c140e(refA, refB) {
    const a = $af3736314ab34f62$var$toFnRef(refA);
    const b = $af3736314ab34f62$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $af3736314ab34f62$var$useMergedRefs(refA, refB) {
    return (0, $7fPBF.useMemo)(()=>$af3736314ab34f62$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $af3736314ab34f62$export$2e2bcd8739ae039 = $af3736314ab34f62$var$useMergedRefs;

});

parcelRegister("68Mia", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4788f334f27fc7a8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $4788f334f27fc7a8$var$NavContext = /*#__PURE__*/ $7fPBF.createContext(null);
$4788f334f27fc7a8$var$NavContext.displayName = 'NavContext';
var $4788f334f27fc7a8$export$2e2bcd8739ae039 = $4788f334f27fc7a8$var$NavContext;

});

parcelRegister("cpnTQ", function(module, exports) {

$parcel$export(module.exports, "makeEventKey", function () { return $908a5bcfbdded983$export$eef49b42fde998a3; });
$parcel$export(module.exports, "default", function () { return $908a5bcfbdded983$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $908a5bcfbdded983$var$SelectableContext = /*#__PURE__*/ $7fPBF.createContext(null);
const $908a5bcfbdded983$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $908a5bcfbdded983$export$2e2bcd8739ae039 = $908a5bcfbdded983$var$SelectableContext;

});

parcelRegister("d6KM4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98b01e4e5ba772d8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $98b01e4e5ba772d8$var$TabContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $98b01e4e5ba772d8$export$2e2bcd8739ae039 = $98b01e4e5ba772d8$var$TabContext;

});

parcelRegister("1l3ik", function(module, exports) {

$parcel$export(module.exports, "dataAttr", function () { return $0f9a4ede3a340f0d$export$5cc3b7b83e34ade7; });
$parcel$export(module.exports, "dataProp", function () { return $0f9a4ede3a340f0d$export$7776c0a7cd2eb3e0; });
const $0f9a4ede3a340f0d$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $0f9a4ede3a340f0d$export$635202801f9383a0 = `rrUi`;
function $0f9a4ede3a340f0d$export$5cc3b7b83e34ade7(property) {
    return `${$0f9a4ede3a340f0d$export$fd7bcb7e9bef4e8a}${property}`;
}
function $0f9a4ede3a340f0d$export$7776c0a7cd2eb3e0(property) {
    return `${$0f9a4ede3a340f0d$export$635202801f9383a0}${property}`;
}

});

parcelRegister("3rd7w", function(module, exports) {

$parcel$export(module.exports, "useNavItem", function () { return $280e1225a4f64c8c$export$d7a68693710982a; });
$parcel$export(module.exports, "default", function () { return $280e1225a4f64c8c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $29zbc = parcelRequire("29zbc");

var $68Mia = parcelRequire("68Mia");

var $cpnTQ = parcelRequire("cpnTQ");

var $bqB2L = parcelRequire("bqB2L");

var $1l3ik = parcelRequire("1l3ik");

var $d6KM4 = parcelRequire("d6KM4");

var $bbzbN = parcelRequire("bbzbN");
const $280e1225a4f64c8c$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $280e1225a4f64c8c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $280e1225a4f64c8c$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $7fPBF.useContext)((0, $cpnTQ.default));
    const navContext = (0, $7fPBF.useContext)((0, $68Mia.default));
    const tabContext = (0, $7fPBF.useContext)((0, $d6KM4.default));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $1l3ik.dataAttr)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $29zbc.default)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $280e1225a4f64c8c$var$NavItem = /*#__PURE__*/ $7fPBF.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $bqB2L.default), active: active, eventKey: eventKey } = _ref, options = $280e1225a4f64c8c$var$_objectWithoutPropertiesLoose(_ref, $280e1225a4f64c8c$var$_excluded);
    const [props, meta] = $280e1225a4f64c8c$export$d7a68693710982a(Object.assign({
        key: (0, $cpnTQ.makeEventKey)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $1l3ik.dataAttr)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$280e1225a4f64c8c$var$NavItem.displayName = 'NavItem';
var $280e1225a4f64c8c$export$2e2bcd8739ae039 = $280e1225a4f64c8c$var$NavItem;

});
parcelRegister("29zbc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1917b5fd2b0eb2de$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $kqE80 = parcelRequire("kqE80");
function $1917b5fd2b0eb2de$export$2e2bcd8739ae039(fn) {
    const ref = (0, $kqE80.default)(fn);
    return (0, $7fPBF.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("kqE80", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edf55cf35c567337$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $edf55cf35c567337$var$useCommittedRef(value) {
    const ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $edf55cf35c567337$export$2e2bcd8739ae039 = $edf55cf35c567337$var$useCommittedRef;

});




parcelRegister("2VW10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222de83d63bdd590$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
// TODO: check
const $222de83d63bdd590$var$context = /*#__PURE__*/ $7fPBF.createContext(null);
$222de83d63bdd590$var$context.displayName = 'NavbarContext';
var $222de83d63bdd590$export$2e2bcd8739ae039 = $222de83d63bdd590$var$context;

});

parcelRegister("2mRgJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b96f4ee9082ccd8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $1b96f4ee9082ccd8$var$context = /*#__PURE__*/ $7fPBF.createContext(null);
$1b96f4ee9082ccd8$var$context.displayName = 'CardHeaderContext';
var $1b96f4ee9082ccd8$export$2e2bcd8739ae039 = $1b96f4ee9082ccd8$var$context;

});

parcelRegister("jDlQd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4b29a0d973a62cd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e4b29a0d973a62cd$var$NavItem = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$e4b29a0d973a62cd$var$NavItem.displayName = 'NavItem';
var $e4b29a0d973a62cd$export$2e2bcd8739ae039 = $e4b29a0d973a62cd$var$NavItem;

});

parcelRegister("87bIP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e8811f317ff7ab4$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $hq4kX = parcelRequire("hq4kX");

var $3rd7w = parcelRequire("3rd7w");

var $cpnTQ = parcelRequire("cpnTQ");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $5e8811f317ff7ab4$var$NavLink = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $hq4kX.default), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $3rd7w.useNavItem)({
        key: (0, $cpnTQ.makeEventKey)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$5e8811f317ff7ab4$var$NavLink.displayName = 'NavLink';
var $5e8811f317ff7ab4$export$2e2bcd8739ae039 = $5e8811f317ff7ab4$var$NavLink;

});
parcelRegister("hq4kX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cae83aa1bb164a1b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("lsxjs");
var $29zbc = parcelRequire("29zbc");

var $bqB2L = parcelRequire("bqB2L");

var $bbzbN = parcelRequire("bbzbN");
const $cae83aa1bb164a1b$var$_excluded = [
    "onKeyDown"
];
function $cae83aa1bb164a1b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $cae83aa1bb164a1b$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $cae83aa1bb164a1b$var$Anchor = /*#__PURE__*/ $7fPBF.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $cae83aa1bb164a1b$var$_objectWithoutPropertiesLoose(_ref, $cae83aa1bb164a1b$var$_excluded);
    const [buttonProps] = (0, $bqB2L.useButtonProps)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $29zbc.default)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($cae83aa1bb164a1b$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $bbzbN.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$cae83aa1bb164a1b$var$Anchor.displayName = 'Anchor';
var $cae83aa1bb164a1b$export$2e2bcd8739ae039 = $cae83aa1bb164a1b$var$Anchor;

});
parcelRegister("lsxjs", function(module, exports) {

$parcel$export(module.exports, "useEventCallback", function () { return (parcelRequire("29zbc")).default; });

var $je0yT = parcelRequire("je0yT");

var $kqE80 = parcelRequire("kqE80");

var $29zbc = parcelRequire("29zbc");

var $4HOKy = parcelRequire("4HOKy");

var $iNsTX = parcelRequire("iNsTX");

var $4uT1v = parcelRequire("4uT1v");

var $6Belx = parcelRequire("6Belx");

var $04kPp = parcelRequire("04kPp");

var $gbXIt = parcelRequire("gbXIt");

var $h3OEp = parcelRequire("h3OEp");

var $aJTM3 = parcelRequire("aJTM3");

var $1s5uv = parcelRequire("1s5uv");

var $hK952 = parcelRequire("hK952");

});
parcelRegister("je0yT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dfefc2b5da6c6e13$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $dfefc2b5da6c6e13$export$2e2bcd8739ae039() {
    return (0, $7fPBF.useState)(null);
}

});

parcelRegister("4HOKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36d28b7579ecdddd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $29zbc = parcelRequire("29zbc");
function $36d28b7579ecdddd$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $29zbc.default)(listener);
    (0, $7fPBF.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

});

parcelRegister("iNsTX", function(module, exports) {

var $4HOKy = parcelRequire("4HOKy");

var $7fPBF = parcelRequire("7fPBF");
function $daf338d9f9609b1c$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $7fPBF.useCallback)(()=>document, []);
    return (0, $4HOKy.default)(documentTarget, event, handler, capture);
}

});

parcelRegister("4uT1v", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $kqE80 = parcelRequire("kqE80");
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $3464a53ff76a4531$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $kqE80.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $kqE80.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $3464a53ff76a4531$export$2e2bcd8739ae039 = $3464a53ff76a4531$var$useInterval;

});

parcelRegister("6Belx", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $kqE80 = parcelRequire("kqE80");
function $4ce153b2a1cbee8f$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $kqE80.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $kqE80.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $7fPBF.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $4ce153b2a1cbee8f$export$2e2bcd8739ae039 = $4ce153b2a1cbee8f$var$useRafInterval;

});

parcelRegister("04kPp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00d087df0419de1c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $00d087df0419de1c$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $7fPBF.useState)(initialState);
    const updater = (0, $7fPBF.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

});

parcelRegister("gbXIt", function(module, exports) {

var $04kPp = parcelRequire("04kPp");
function $bc9bfed08d090c15$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $04kPp.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

});

parcelRegister("h3OEp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ba01ae161f5c5c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $c6ba01ae161f5c5c$export$2e2bcd8739ae039() {
    const mounted = (0, $7fPBF.useRef)(true);
    const isMounted = (0, $7fPBF.useRef)(()=>mounted.current);
    (0, $7fPBF.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("aJTM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d195ee9d935d931$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $7d195ee9d935d931$export$2e2bcd8739ae039(value) {
    const ref = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("1s5uv", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");
function $10ecaa640fed8ad2$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $7fPBF.useState)({
        image: null,
        error: null
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

});

parcelRegister("hK952", function(module, exports) {

var $7fPBF = parcelRequire("7fPBF");

var $etwAC = parcelRequire("etwAC");
const $ceadc6ae1605cc2c$var$targetMap = new WeakMap();
let $ceadc6ae1605cc2c$var$resizeObserver;
function $ceadc6ae1605cc2c$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $ceadc6ae1605cc2c$var$resizeObserver = $ceadc6ae1605cc2c$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $ceadc6ae1605cc2c$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $ceadc6ae1605cc2c$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $7fPBF.useState)(null);
    (0, $etwAC.default)(()=>{
        if (!element) return;
        $ceadc6ae1605cc2c$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $ceadc6ae1605cc2c$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $ceadc6ae1605cc2c$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

});
parcelRegister("etwAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a89d0dbecad95bc2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $a89d0dbecad95bc2$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $a89d0dbecad95bc2$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $a89d0dbecad95bc2$export$2e2bcd8739ae039 = $a89d0dbecad95bc2$var$isDOM || $a89d0dbecad95bc2$var$isReactNative ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);

});






parcelRegister("gLW8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c35e22db9990e050$export$2e2bcd8739ae039; });

var $2oXYc = parcelRequire("2oXYc");

var $yeWYk = parcelRequire("yeWYk");

var $jurNP = parcelRequire("jurNP");

var $jjS1K = parcelRequire("jjS1K");
const $c35e22db9990e050$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).object
};
const $c35e22db9990e050$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$c35e22db9990e050$var$Tab.propTypes = $c35e22db9990e050$var$propTypes;
var $c35e22db9990e050$export$2e2bcd8739ae039 = Object.assign($c35e22db9990e050$var$Tab, {
    Container: (0, $yeWYk.default),
    Content: (0, $jurNP.default),
    Pane: (0, $jjS1K.default)
});

});
parcelRegister("yeWYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066ec5e1a94ca708$export$2e2bcd8739ae039; });

var $330Qj = parcelRequire("330Qj");

var $dtOsQ = parcelRequire("dtOsQ");

var $bbzbN = parcelRequire("bbzbN");
const $066ec5e1a94ca708$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $330Qj.default), {
        ...props,
        transition: (0, $dtOsQ.default)(transition)
    });
$066ec5e1a94ca708$var$TabContainer.displayName = 'TabContainer';
var $066ec5e1a94ca708$export$2e2bcd8739ae039 = $066ec5e1a94ca708$var$TabContainer;

});
parcelRegister("330Qj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23824e48e8c37d1e$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $k9tSY = parcelRequire("k9tSY");

var $kLJoI = parcelRequire("kLJoI");

var $d6KM4 = parcelRequire("d6KM4");

var $cpnTQ = parcelRequire("cpnTQ");

var $a72HS = parcelRequire("a72HS");

var $bbzbN = parcelRequire("bbzbN");
const $23824e48e8c37d1e$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $k9tSY.useUncontrolledProp)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $kLJoI.useSSRSafeId)(userId);
    const generateChildId = (0, $7fPBF.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $7fPBF.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d6KM4.default).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cpnTQ.default).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$23824e48e8c37d1e$var$Tabs.Panel = (0, $a72HS.default);
var $23824e48e8c37d1e$export$2e2bcd8739ae039 = $23824e48e8c37d1e$var$Tabs;

});
parcelRegister("k9tSY", function(module, exports) {

$parcel$export(module.exports, "useUncontrolledProp", function () { return $eabbd49b34f6b6b7$export$2ee51287a16ca325; });

var $7fPBF = parcelRequire("7fPBF");
function $eabbd49b34f6b6b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $eabbd49b34f6b6b7$var$_toPropertyKey(arg) {
    var key = $eabbd49b34f6b6b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $eabbd49b34f6b6b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $eabbd49b34f6b6b7$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $eabbd49b34f6b6b7$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $7fPBF.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $7fPBF.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $7fPBF.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $eabbd49b34f6b6b7$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $eabbd49b34f6b6b7$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $eabbd49b34f6b6b7$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($eabbd49b34f6b6b7$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $eabbd49b34f6b6b7$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}

});

parcelRegister("kLJoI", function(module, exports) {

$parcel$export(module.exports, "useSSRSafeId", function () { return $f1eb69780868fb33$export$619500959fc48b26; });

var $7fPBF = parcelRequire("7fPBF");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $f1eb69780868fb33$var$$85138adc03e1f057$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $f1eb69780868fb33$var$$85138adc03e1f057$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext($f1eb69780868fb33$var$$85138adc03e1f057$var$defaultContext);
const $f1eb69780868fb33$var$$85138adc03e1f057$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(false);
// This is only used in React < 18.
function $f1eb69780868fb33$var$$85138adc03e1f057$var$LegacySSRProvider(props) {
    let cur = (0, $7fPBF.useContext)($f1eb69780868fb33$var$$85138adc03e1f057$var$SSRContext);
    let counter = $f1eb69780868fb33$var$$85138adc03e1f057$var$useCounter(cur === $f1eb69780868fb33$var$$85138adc03e1f057$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $7fPBF.useState)(true);
    let value = (0, $7fPBF.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $f1eb69780868fb33$var$$85138adc03e1f057$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $7fPBF.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f1eb69780868fb33$var$$85138adc03e1f057$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f1eb69780868fb33$var$$85138adc03e1f057$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $f1eb69780868fb33$var$$85138adc03e1f057$var$warnedAboutSSRProvider = false;
function $f1eb69780868fb33$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))['useId'] === 'function') {
        if (!$f1eb69780868fb33$var$$85138adc03e1f057$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            // oxlint-disable-next-line react/react-compiler
            $f1eb69780868fb33$var$$85138adc03e1f057$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($f1eb69780868fb33$var$$85138adc03e1f057$var$LegacySSRProvider, props);
}
let $f1eb69780868fb33$var$$85138adc03e1f057$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $f1eb69780868fb33$var$$85138adc03e1f057$var$componentIds = new WeakMap();
function $f1eb69780868fb33$var$$85138adc03e1f057$var$useCounter(isDisabled = false) {
    let ctx = (0, $7fPBF.useContext)($f1eb69780868fb33$var$$85138adc03e1f057$var$SSRContext);
    let ref = (0, $7fPBF.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $f1eb69780868fb33$var$$85138adc03e1f057$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $f1eb69780868fb33$var$$85138adc03e1f057$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $f1eb69780868fb33$var$$85138adc03e1f057$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $f1eb69780868fb33$var$$85138adc03e1f057$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $7fPBF.useContext)($f1eb69780868fb33$var$$85138adc03e1f057$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $f1eb69780868fb33$var$$85138adc03e1f057$var$defaultContext && !$f1eb69780868fb33$var$$85138adc03e1f057$var$canUseDOM && true) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $f1eb69780868fb33$var$$85138adc03e1f057$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $f1eb69780868fb33$var$$85138adc03e1f057$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useId();
    let [didSSR] = (0, $7fPBF.useState)($f1eb69780868fb33$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$f1eb69780868fb33$var$$85138adc03e1f057$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $f1eb69780868fb33$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))['useId'] === 'function' ? $f1eb69780868fb33$var$$85138adc03e1f057$var$useModernSSRSafeId : $f1eb69780868fb33$var$$85138adc03e1f057$var$useLegacySSRSafeId;
function $f1eb69780868fb33$var$$85138adc03e1f057$var$getSnapshot() {
    return false;
}
function $f1eb69780868fb33$var$$85138adc03e1f057$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $f1eb69780868fb33$var$$85138adc03e1f057$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $f1eb69780868fb33$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF)))['useSyncExternalStore']($f1eb69780868fb33$var$$85138adc03e1f057$var$subscribe, $f1eb69780868fb33$var$$85138adc03e1f057$var$getSnapshot, $f1eb69780868fb33$var$$85138adc03e1f057$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $7fPBF.useContext)($f1eb69780868fb33$var$$85138adc03e1f057$var$IsSSRContext);
}

});

parcelRegister("a72HS", function(module, exports) {

$parcel$export(module.exports, "useTabPanel", function () { return $75cca858aad3be7b$export$fae0121b5afe572d; });
$parcel$export(module.exports, "default", function () { return $75cca858aad3be7b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $d6KM4 = parcelRequire("d6KM4");

var $cpnTQ = parcelRequire("cpnTQ");

var $id1uP = parcelRequire("id1uP");

var $bbzbN = parcelRequire("bbzbN");
const $75cca858aad3be7b$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $75cca858aad3be7b$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $75cca858aad3be7b$var$_excluded3 = [
    "as"
];
function $75cca858aad3be7b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $75cca858aad3be7b$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $75cca858aad3be7b$var$_objectWithoutPropertiesLoose(_ref, $75cca858aad3be7b$var$_excluded);
    const context = (0, $7fPBF.useContext)((0, $d6KM4.default));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $75cca858aad3be7b$var$_objectWithoutPropertiesLoose(context, $75cca858aad3be7b$var$_excluded2);
    const key = (0, $cpnTQ.makeEventKey)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $cpnTQ.makeEventKey)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $75cca858aad3be7b$var$TabPanel = /*#__PURE__*/ $7fPBF.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $75cca858aad3be7b$var$_objectWithoutPropertiesLoose(_ref2, $75cca858aad3be7b$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $id1uP.default) }] = $75cca858aad3be7b$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d6KM4.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cpnTQ.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$75cca858aad3be7b$var$TabPanel.displayName = 'TabPanel';
var $75cca858aad3be7b$export$2e2bcd8739ae039 = $75cca858aad3be7b$var$TabPanel;

});
parcelRegister("id1uP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d41a9a034e8786f3$export$2e2bcd8739ae039; });

var $29zbc = parcelRequire("29zbc");

var $f2Ftg = parcelRequire("f2Ftg");

var $7fPBF = parcelRequire("7fPBF");

var $lfw25 = parcelRequire("lfw25");
function $d41a9a034e8786f3$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $7fPBF.useRef)(null);
    const hasEnteredRef = (0, $7fPBF.useRef)(inProp);
    const handleExited = (0, $29zbc.default)(onExited);
    (0, $7fPBF.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $f2Ftg.default)(ref, (0, $lfw25.getChildRef)(children));
    const child = /*#__PURE__*/ (0, $7fPBF.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $d41a9a034e8786f3$export$2e2bcd8739ae039 = $d41a9a034e8786f3$var$NoopTransition;

});
parcelRegister("lfw25", function(module, exports) {

$parcel$export(module.exports, "isEscKey", function () { return $f783d8b265d01412$export$806fcc22e55e107d; });
$parcel$export(module.exports, "getChildRef", function () { return $f783d8b265d01412$export$87943f2672146d57; });

var $7fPBF = parcelRequire("7fPBF");
function $f783d8b265d01412$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $f783d8b265d01412$export$13e065f3a74cfe36() {
    const parts = $7fPBF.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $f783d8b265d01412$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $f783d8b265d01412$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}

});




parcelRegister("dtOsQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d0520f39a76112e$export$2e2bcd8739ae039; });

var $id1uP = parcelRequire("id1uP");

var $e2eQx = parcelRequire("e2eQx");
function $9d0520f39a76112e$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $e2eQx.default) : (0, $id1uP.default);
    return transition;
}

});
parcelRegister("e2eQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a37cc4c4d6eb517c$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");

var $lfw25 = parcelRequire("lfw25");

var $kndvq = parcelRequire("kndvq");

var $crcja = parcelRequire("crcja");

var $g8anv = parcelRequire("g8anv");

var $bbzbN = parcelRequire("bbzbN");
const $a37cc4c4d6eb517c$var$fadeStyles = {
    [(0, $8qMCX.ENTERING)]: 'show',
    [(0, $8qMCX.ENTERED)]: 'show'
};
const $a37cc4c4d6eb517c$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $7fPBF.useCallback)((node, isAppearing)=>{
        (0, $crcja.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g8anv.default), {
        ref: ref,
        addEndListener: (0, $kndvq.default),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $lfw25.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $7fPBF.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))('fade', className, children.props.className, $a37cc4c4d6eb517c$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$a37cc4c4d6eb517c$var$Fade.displayName = 'Fade';
var $a37cc4c4d6eb517c$export$2e2bcd8739ae039 = $a37cc4c4d6eb517c$var$Fade;

});
parcelRegister("8qMCX", function(module, exports) {

$parcel$export(module.exports, "EXITED", function () { return $623678cbb6daf054$export$84cbff306f539230; });
$parcel$export(module.exports, "ENTERING", function () { return $623678cbb6daf054$export$df38205c966be359; });
$parcel$export(module.exports, "ENTERED", function () { return $623678cbb6daf054$export$78e9e6e3e014d60a; });
$parcel$export(module.exports, "EXITING", function () { return $623678cbb6daf054$export$4aacc83d4d59139f; });
$parcel$export(module.exports, "default", function () { return $623678cbb6daf054$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $1KLsX = parcelRequire("1KLsX");

var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $bTMtR = parcelRequire("bTMtR");

var $jz78T = parcelRequire("jz78T");

var $8ovTL = parcelRequire("8ovTL");

var $kKJSm = parcelRequire("kKJSm");
var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1KLsX.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $kKJSm.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $bTMtR.default).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8ovTL.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $8ovTL.default);
$623678cbb6daf054$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $jz78T.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func
}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;

});
parcelRegister("bTMtR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a9a7006a9b8efe4$export$2e2bcd8739ae039; });
var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("jz78T", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", function () { return $e3e6d3864ad6dad3$export$3458ee1082941f5e; });

var $2oXYc = parcelRequire("2oXYc");
var $e3e6d3864ad6dad3$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    }).isRequired
]);
var $e3e6d3864ad6dad3$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
    })
]);

});

parcelRegister("8ovTL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61c94efb1735eff6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);

});

parcelRegister("kKJSm", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $f1bbb084f2fb10b7$export$7d26bbb1236dafd6; });
var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("kndvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed506e9ca22d5c74$export$2e2bcd8739ae039; });

var $6kugr = parcelRequire("6kugr");

var $gLt8q = parcelRequire("gLt8q");
function $ed506e9ca22d5c74$var$parseDuration(node, property) {
    const str = (0, $6kugr.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $ed506e9ca22d5c74$export$2e2bcd8739ae039(element, handler) {
    const duration = $ed506e9ca22d5c74$var$parseDuration(element, 'transitionDuration');
    const delay = $ed506e9ca22d5c74$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $gLt8q.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});
parcelRegister("6kugr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49bc1628a4b8fc8b$export$2e2bcd8739ae039; });

var $h76vL = parcelRequire("h76vL");

var $6enef = parcelRequire("6enef");

var $25iPY = parcelRequire("25iPY");
function $49bc1628a4b8fc8b$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $6enef.default)(property)) || (0, $h76vL.default)(node).getPropertyValue((0, $6enef.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $6enef.default)(key));
        else if ((0, $25iPY.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $6enef.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $49bc1628a4b8fc8b$export$2e2bcd8739ae039 = $49bc1628a4b8fc8b$var$style;

});
parcelRegister("h76vL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7582420511d37a4$export$2e2bcd8739ae039; });

var $jzlT8 = parcelRequire("jzlT8");
function $c7582420511d37a4$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $jzlT8.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("jzlT8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3f243c3a7eff1b7$export$2e2bcd8739ae039; });

var $eSNaH = parcelRequire("eSNaH");
function $e3f243c3a7eff1b7$export$2e2bcd8739ae039(node) {
    var doc = (0, $eSNaH.default)(node);
    return doc && doc.defaultView || window;
}

});
parcelRegister("eSNaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad5c404268f3dd2b$export$2e2bcd8739ae039; });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $ad5c404268f3dd2b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("6enef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $489611a7dca5c130$export$2e2bcd8739ae039; });
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $iagYm = parcelRequire("iagYm");
var $489611a7dca5c130$var$msPattern = /^ms-/;
function $489611a7dca5c130$export$2e2bcd8739ae039(string) {
    return (0, $iagYm.default)(string).replace($489611a7dca5c130$var$msPattern, '-ms-');
}

});
parcelRegister("iagYm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d396538f86f29fe5$export$2e2bcd8739ae039; });
var $d396538f86f29fe5$var$rUpper = /([A-Z])/g;
function $d396538f86f29fe5$export$2e2bcd8739ae039(string) {
    return string.replace($d396538f86f29fe5$var$rUpper, '-$1').toLowerCase();
}

});


parcelRegister("25iPY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $184aa915f5998098$export$2e2bcd8739ae039; });
var $184aa915f5998098$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $184aa915f5998098$export$2e2bcd8739ae039(value) {
    return !!(value && $184aa915f5998098$var$supportedTransforms.test(value));
}

});


parcelRegister("gLt8q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c347a2b869d4dc30$export$2e2bcd8739ae039; });

var $6kugr = parcelRequire("6kugr");

var $22FgH = parcelRequire("22FgH");

var $16avf = parcelRequire("16avf");
function $c347a2b869d4dc30$var$parseDuration(node) {
    var str = (0, $6kugr.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $c347a2b869d4dc30$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $16avf.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $22FgH.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $c347a2b869d4dc30$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $c347a2b869d4dc30$var$parseDuration(element) || 0;
    var removeEmulate = $c347a2b869d4dc30$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $22FgH.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("22FgH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17cbc7b30f0b3603$export$2e2bcd8739ae039; });

var $8S3wI = parcelRequire("8S3wI");

var $73lTM = parcelRequire("73lTM");
function $17cbc7b30f0b3603$var$listen(node, eventName, handler, options) {
    (0, $8S3wI.default)(node, eventName, handler, options);
    return function() {
        (0, $73lTM.default)(node, eventName, handler, options);
    };
}
var $17cbc7b30f0b3603$export$2e2bcd8739ae039 = $17cbc7b30f0b3603$var$listen;

});
parcelRegister("8S3wI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67561a2e4ea73dc2$export$2e2bcd8739ae039; });
/* eslint-disable no-return-assign */ 
var $kkTu9 = parcelRequire("kkTu9");
var $67561a2e4ea73dc2$export$63fefd044b2bc624 = false;
var $67561a2e4ea73dc2$export$a614c6b395900f69 = false;
try {
    var $67561a2e4ea73dc2$var$options = {
        get passive () {
            return $67561a2e4ea73dc2$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $67561a2e4ea73dc2$export$a614c6b395900f69 = $67561a2e4ea73dc2$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $kkTu9.default) {
        window.addEventListener('test', $67561a2e4ea73dc2$var$options, $67561a2e4ea73dc2$var$options);
        window.removeEventListener('test', $67561a2e4ea73dc2$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $67561a2e4ea73dc2$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$67561a2e4ea73dc2$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$67561a2e4ea73dc2$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $67561a2e4ea73dc2$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $67561a2e4ea73dc2$export$2e2bcd8739ae039 = $67561a2e4ea73dc2$var$addEventListener;

});
parcelRegister("kkTu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ece0b71c621c599e$export$2e2bcd8739ae039; });
var $ece0b71c621c599e$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("73lTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5229ccd7d48a65ac$export$2e2bcd8739ae039; });
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $5229ccd7d48a65ac$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $5229ccd7d48a65ac$export$2e2bcd8739ae039 = $5229ccd7d48a65ac$var$removeEventListener;

});


parcelRegister("16avf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cce7fa66fad42c8$export$2e2bcd8739ae039; });
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $0cce7fa66fad42c8$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("crcja", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90e18dcfffc5b708$export$2e2bcd8739ae039; });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $90e18dcfffc5b708$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});

parcelRegister("g8anv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bbe571940e9519dd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");

var $kbUnX = parcelRequire("kbUnX");

var $46NT0 = parcelRequire("46NT0");

var $bbzbN = parcelRequire("bbzbN");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $bbe571940e9519dd$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $7fPBF.useRef)(null);
    const mergedRef = (0, $kbUnX.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $46NT0.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $7fPBF.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $7fPBF.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $7fPBF.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $7fPBF.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $7fPBF.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $7fPBF.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $7fPBF.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8qMCX.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$bbe571940e9519dd$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $bbe571940e9519dd$export$2e2bcd8739ae039 = $bbe571940e9519dd$var$TransitionWrapper;

});
parcelRegister("kbUnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb3092b04f47f993$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $eb3092b04f47f993$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $eb3092b04f47f993$export$c9058316764c140e(refA, refB) {
    const a = $eb3092b04f47f993$var$toFnRef(refA);
    const b = $eb3092b04f47f993$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $eb3092b04f47f993$var$useMergedRefs(refA, refB) {
    return (0, $7fPBF.useMemo)(()=>$eb3092b04f47f993$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $eb3092b04f47f993$export$2e2bcd8739ae039 = $eb3092b04f47f993$var$useMergedRefs;

});

parcelRegister("46NT0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fde6b54b233b841$export$2e2bcd8739ae039; });

var $fw0lo = parcelRequire("fw0lo");
function $2fde6b54b233b841$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});





parcelRegister("jurNP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e30662ae8f3c7daf$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e30662ae8f3c7daf$var$TabContent = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$e30662ae8f3c7daf$var$TabContent.displayName = 'TabContent';
var $e30662ae8f3c7daf$export$2e2bcd8739ae039 = $e30662ae8f3c7daf$var$TabContent;

});

parcelRegister("jjS1K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e109b358b3128e34$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $cpnTQ = parcelRequire("cpnTQ");

var $d6KM4 = parcelRequire("d6KM4");

var $a72HS = parcelRequire("a72HS");

var $jbn4d = parcelRequire("jbn4d");

var $e2eQx = parcelRequire("e2eQx");

var $dtOsQ = parcelRequire("dtOsQ");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e109b358b3128e34$var$TabPane = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $e2eQx.default) }] = (0, $a72HS.useTabPanel)({
        ...props,
        transition: (0, $dtOsQ.default)(transition)
    });
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d6KM4.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cpnTQ.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$e109b358b3128e34$var$TabPane.displayName = 'TabPane';
var $e109b358b3128e34$export$2e2bcd8739ae039 = $e109b358b3128e34$var$TabPane;

});


parcelRegister("gYROb", function(module, exports) {
$parcel$export(module.exports, "AddLinkButton", function () { return (parcelRequire("ktLOc")).AddLinkButton; });
$parcel$export(module.exports, "AsyncButton", function () { return (parcelRequire("8HzIe")).AsyncButton; });
$parcel$export(module.exports, "CollapseRow", function () { return (parcelRequire("gxUSF")).CollapseRow; });
$parcel$export(module.exports, "Control210", function () { return (parcelRequire("9Er6k")).Control210; });
$parcel$export(module.exports, "Control211", function () { return (parcelRequire("isQD0")).Control211; });
$parcel$export(module.exports, "Control213", function () { return (parcelRequire("egunj")).Control213; });
$parcel$export(module.exports, "ControlBase", function () { return (parcelRequire("fQHYQ")).ControlBase; });
$parcel$export(module.exports, "ControlDate", function () { return (parcelRequire("fHRX3")).ControlDate; });
$parcel$export(module.exports, "ControlNavList", function () { return (parcelRequire("ceSEx")).ControlNavList; });
$parcel$export(module.exports, "ControlsGroup", function () { return (parcelRequire("dImYe")).ControlsGroup; });
$parcel$export(module.exports, "ControlTags", function () { return (parcelRequire("creWj")).ControlTags; });
$parcel$export(module.exports, "ControlTypeAhead", function () { return (parcelRequire("k6Ixm")).ControlTypeAhead; });
$parcel$export(module.exports, "DraggableSidebar", function () { return (parcelRequire("dKaWY")).DraggableSidebar; });
$parcel$export(module.exports, "HorizontalDrawer", function () { return (parcelRequire("cdwkg")).HorizontalDrawer; });
$parcel$export(module.exports, "InTextLink", function () { return (parcelRequire("eYprk")).InTextLink; });
$parcel$export(module.exports, "ReorderableNavList", function () { return (parcelRequire("6LYdD")).ReorderableNavList; });
$parcel$export(module.exports, "SortableListHolder", function () { return (parcelRequire("7Tnbh")).SortableListHolder; });
parcelRequire("ktLOc");
parcelRequire("8HzIe");
parcelRequire("gxUSF");
parcelRequire("9Er6k");
parcelRequire("isQD0");
parcelRequire("egunj");
parcelRequire("fQHYQ");
parcelRequire("fHRX3");
parcelRequire("ceSEx");
parcelRequire("dImYe");
parcelRequire("creWj");
parcelRequire("k6Ixm");
parcelRequire("8HfzK");
parcelRequire("dKaWY");
parcelRequire("cdwkg");
parcelRequire("eYprk");
parcelRequire("6LYdD");
parcelRequire("7Tnbh");
parcelRequire("9LtqM");

});
parcelRegister("ktLOc", function(module, exports) {

$parcel$export(module.exports, "AddLinkButton", function () { return $1ce122d45d247f11$export$25406dc469b0f375; });

var $bbzbN = parcelRequire("bbzbN");

var $b6fw7 = parcelRequire("b6fw7");
var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");

var $6dv4K = parcelRequire("6dv4K");
const $1ce122d45d247f11$export$25406dc469b0f375 = ({ label: label, onClick: onClick, disabled: disabled = false, colWidth: colWidth = 9, className: className = "" })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Group, {
        as: (0, $kYoG1.default),
        className: `mb-3 ${className}`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
            sm: colWidth,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b6fw7.default), {
                variant: "link",
                className: "p-0 text-primary d-flex align-items-center text-decoration-none",
                onClick: onClick,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
                        size: 16,
                        className: "me-1"
                    }),
                    label
                ]
            })
        })
    });
};
$1ce122d45d247f11$export$25406dc469b0f375.displayName = "AddLinkButton";

});
parcelRegister("h1xuz", function(module, exports) {

$parcel$export(module.exports, "useCol", function () { return $c64c827ac029facf$export$2ed43d61a0a9f5a3; });
$parcel$export(module.exports, "default", function () { return $c64c827ac029facf$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $c64c827ac029facf$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'col');
    const breakpoints = (0, $jbn4d.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $jbn4d.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $c64c827ac029facf$var$Col = /*#__PURE__*/ $7fPBF.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $c64c827ac029facf$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, !spans.length && bsPrefix)
    });
});
$c64c827ac029facf$var$Col.displayName = 'Col';
var $c64c827ac029facf$export$2e2bcd8739ae039 = $c64c827ac029facf$var$Col;

});

parcelRegister("8d4Ob", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fa34478fa5061cc$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");

var $5hOEv = parcelRequire("5hOEv");

var $exPB1 = parcelRequire("exPB1");

var $emxef = parcelRequire("emxef");

var $7rToa = parcelRequire("7rToa");

var $9ZX3s = parcelRequire("9ZX3s");

var $1UkE0 = parcelRequire("1UkE0");

var $fhTR2 = parcelRequire("fhTR2");

var $gTLXo = parcelRequire("gTLXo");

var $lP3zN = parcelRequire("lP3zN");

var $8PAec = parcelRequire("8PAec");

var $bbzbN = parcelRequire("bbzbN");
const $5fa34478fa5061cc$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType
};
const $5fa34478fa5061cc$var$Form = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, validated && 'was-validated')
    }));
$5fa34478fa5061cc$var$Form.displayName = 'Form';
$5fa34478fa5061cc$var$Form.propTypes = $5fa34478fa5061cc$var$propTypes;
var $5fa34478fa5061cc$export$2e2bcd8739ae039 = Object.assign($5fa34478fa5061cc$var$Form, {
    Group: (0, $7rToa.default),
    Control: (0, $exPB1.default),
    Floating: (0, $emxef.default),
    Check: (0, $5hOEv.default),
    Switch: $lP3zN.default,
    Label: (0, $9ZX3s.default),
    Text: (0, $gTLXo.default),
    Range: (0, $1UkE0.default),
    Select: (0, $fhTR2.default),
    FloatingLabel: $8PAec.default
});

});
parcelRegister("5hOEv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d95d4c37c0327c3$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $czXUE = parcelRequire("czXUE");

var $drxvW = parcelRequire("drxvW");

var $g6iZW = parcelRequire("g6iZW");

var $3gD82 = parcelRequire("3gD82");

var $jbn4d = parcelRequire("jbn4d");

var $bk9WF = parcelRequire("bk9WF");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3d95d4c37c0327c3$var$FormCheck = /*#__PURE__*/ $7fPBF.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $jbn4d.useBootstrapPrefix)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    const innerFormContext = (0, $7fPBF.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $bk9WF.hasChildOfType)(children, (0, $g6iZW.default));
    const input = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $drxvW.default), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3gD82.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g6iZW.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $czXUE.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$3d95d4c37c0327c3$var$FormCheck.displayName = 'FormCheck';
var $3d95d4c37c0327c3$export$2e2bcd8739ae039 = Object.assign($3d95d4c37c0327c3$var$FormCheck, {
    Input: (0, $drxvW.default),
    Label: (0, $g6iZW.default)
});

});
parcelRegister("czXUE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92873a580391b633$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $bbzbN = parcelRequire("bbzbN");
const $92873a580391b633$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).elementType
};
const $92873a580391b633$var$Feedback = /*#__PURE__*/ $7fPBF.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$92873a580391b633$var$Feedback.displayName = 'Feedback';
$92873a580391b633$var$Feedback.propTypes = $92873a580391b633$var$propTypes;
var $92873a580391b633$export$2e2bcd8739ae039 = $92873a580391b633$var$Feedback;

});

parcelRegister("drxvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c97cb30644bcdee$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $3gD82 = parcelRequire("3gD82");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9c97cb30644bcdee$var$FormCheckInput = /*#__PURE__*/ $7fPBF.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$9c97cb30644bcdee$var$FormCheckInput.displayName = 'FormCheckInput';
var $9c97cb30644bcdee$export$2e2bcd8739ae039 = $9c97cb30644bcdee$var$FormCheckInput;

});
parcelRegister("3gD82", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $261137d673c172f3$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
// TODO
const $261137d673c172f3$var$FormContext = /*#__PURE__*/ $7fPBF.createContext({});
var $261137d673c172f3$export$2e2bcd8739ae039 = $261137d673c172f3$var$FormContext;

});


parcelRegister("g6iZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8bf18323169f3a$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $3gD82 = parcelRequire("3gD82");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bb8bf18323169f3a$var$FormCheckLabel = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix)
    });
});
$bb8bf18323169f3a$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $bb8bf18323169f3a$export$2e2bcd8739ae039 = $bb8bf18323169f3a$var$FormCheckLabel;

});

parcelRegister("bk9WF", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $83e946e8d792d11c$export$871de8747c9eaa88; });
$parcel$export(module.exports, "forEach", function () { return $83e946e8d792d11c$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "hasChildOfType", function () { return $83e946e8d792d11c$export$500fd6099226ffae; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $83e946e8d792d11c$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $7fPBF.Children.map(children, (child)=>/*#__PURE__*/ $7fPBF.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $83e946e8d792d11c$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $7fPBF.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $83e946e8d792d11c$export$500fd6099226ffae(children, type) {
    return $7fPBF.Children.toArray(children).some((child)=>/*#__PURE__*/ $7fPBF.isValidElement(child) && child.type === type);
}

});


parcelRegister("exPB1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a96c2ba64921f510$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $6Buvl = parcelRequire("6Buvl");

var $czXUE = parcelRequire("czXUE");

var $3gD82 = parcelRequire("3gD82");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a96c2ba64921f510$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-control');
    (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$a96c2ba64921f510$var$FormControl.displayName = 'FormControl';
var $a96c2ba64921f510$export$2e2bcd8739ae039 = Object.assign($a96c2ba64921f510$var$FormControl, {
    Feedback: $czXUE.default
});

});
parcelRegister("6Buvl", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4ceddc5ee7e9d694$var$__DEV__ = true;
var $4ceddc5ee7e9d694$var$warning = function() {};
if ($4ceddc5ee7e9d694$var$__DEV__) {
    var $4ceddc5ee7e9d694$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4ceddc5ee7e9d694$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4ceddc5ee7e9d694$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $4ceddc5ee7e9d694$var$warning;

});


parcelRegister("emxef", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a74ce54df1fe19c5$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a74ce54df1fe19c5$var$FormFloating = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$a74ce54df1fe19c5$var$FormFloating.displayName = 'FormFloating';
var $a74ce54df1fe19c5$export$2e2bcd8739ae039 = $a74ce54df1fe19c5$var$FormFloating;

});

parcelRegister("7rToa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56c6051a6ae65bcd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $3gD82 = parcelRequire("3gD82");

var $bbzbN = parcelRequire("bbzbN");
const $56c6051a6ae65bcd$var$FormGroup = /*#__PURE__*/ $7fPBF.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $7fPBF.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3gD82.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$56c6051a6ae65bcd$var$FormGroup.displayName = 'FormGroup';
var $56c6051a6ae65bcd$export$2e2bcd8739ae039 = $56c6051a6ae65bcd$var$FormGroup;

});

parcelRegister("9ZX3s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74779e9a5c5d233e$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $6Buvl = parcelRequire("6Buvl");

var $h1xuz = parcelRequire("h1xuz");

var $3gD82 = parcelRequire("3gD82");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $74779e9a5c5d233e$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.');
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$74779e9a5c5d233e$var$FormLabel.displayName = 'FormLabel';
var $74779e9a5c5d233e$export$2e2bcd8739ae039 = $74779e9a5c5d233e$var$FormLabel;

});

parcelRegister("1UkE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $163b08ebdc2cf478$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $3gD82 = parcelRequire("3gD82");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $163b08ebdc2cf478$var$FormRange = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        id: id || controlId
    });
});
$163b08ebdc2cf478$var$FormRange.displayName = 'FormRange';
var $163b08ebdc2cf478$export$2e2bcd8739ae039 = $163b08ebdc2cf478$var$FormRange;

});

parcelRegister("fhTR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b213c518bfff31cf$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $3gD82 = parcelRequire("3gD82");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $b213c518bfff31cf$var$FormSelect = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $7fPBF.useContext)((0, $3gD82.default));
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $bbzbN.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$b213c518bfff31cf$var$FormSelect.displayName = 'FormSelect';
var $b213c518bfff31cf$export$2e2bcd8739ae039 = $b213c518bfff31cf$var$FormSelect;

});

parcelRegister("gTLXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4d6fba50f304552$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c4d6fba50f304552$var$FormText = /*#__PURE__*/ $7fPBF.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, muted && 'text-muted')
    });
});
$c4d6fba50f304552$var$FormText.displayName = 'FormText';
var $c4d6fba50f304552$export$2e2bcd8739ae039 = $c4d6fba50f304552$var$FormText;

});

parcelRegister("lP3zN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe31229430e4ae08$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $5hOEv = parcelRequire("5hOEv");

var $bbzbN = parcelRequire("bbzbN");
const $fe31229430e4ae08$var$Switch = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $5hOEv.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$fe31229430e4ae08$var$Switch.displayName = 'Switch';
var $fe31229430e4ae08$export$2e2bcd8739ae039 = Object.assign($fe31229430e4ae08$var$Switch, {
    Input: (0, $5hOEv.default).Input,
    Label: (0, $5hOEv.default).Label
});

});

parcelRegister("8PAec", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66df30432d7ca873$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $7rToa = parcelRequire("7rToa");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $66df30432d7ca873$var$FloatingLabel = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7rToa.default), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$66df30432d7ca873$var$FloatingLabel.displayName = 'FloatingLabel';
var $66df30432d7ca873$export$2e2bcd8739ae039 = $66df30432d7ca873$var$FloatingLabel;

});


parcelRegister("kYoG1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f44c8d900ca3444d$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $f44c8d900ca3444d$var$Row = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'row');
    const breakpoints = (0, $jbn4d.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $jbn4d.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, decoratedBsPrefix, ...classes)
    });
});
$f44c8d900ca3444d$var$Row.displayName = 'Row';
var $f44c8d900ca3444d$export$2e2bcd8739ae039 = $f44c8d900ca3444d$var$Row;

});


parcelRegister("gxUSF", function(module, exports) {

$parcel$export(module.exports, "CollapseRow", function () { return $521542b0a86f8066$export$d0d261886ae9657b; });

var $bbzbN = parcelRequire("bbzbN");

var $h1xuz = parcelRequire("h1xuz");
var $euDav = parcelRequire("euDav");
var $9ZX3s = parcelRequire("9ZX3s");
var $kYoG1 = parcelRequire("kYoG1");

var $k2m6c = parcelRequire("k2m6c");
var $cnmTv = parcelRequire("cnmTv");
const $521542b0a86f8066$export$d0d261886ae9657b = ({ label: label, isOpen: isOpen, setIsOpen: setIsOpen, children: children, ...rest })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
        ...rest,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9ZX3s.default), {
                            onClick: ()=>setIsOpen((prev)=>!prev),
                            className: "d-flex align-items-center cursor-pointer",
                            children: [
                                typeof label === "string" ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: "fw-bold",
                                    children: label
                                }) : label,
                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: "ms-2",
                                    children: isOpen ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k2m6c.default), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cnmTv.default), {})
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $euDav.default), {
                    className: "mb-2",
                    in: isOpen,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: children
                    })
                })
            ]
        })
    });
$521542b0a86f8066$export$d0d261886ae9657b.displayName = "CollapseRow";

});
parcelRegister("euDav", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8d2400c90612023$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $6kugr = parcelRequire("6kugr");

var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");

var $lfw25 = parcelRequire("lfw25");

var $kndvq = parcelRequire("kndvq");

var $iVanP = parcelRequire("iVanP");

var $crcja = parcelRequire("crcja");

var $g8anv = parcelRequire("g8anv");

var $bbzbN = parcelRequire("bbzbN");
const $a8d2400c90612023$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $a8d2400c90612023$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $a8d2400c90612023$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $6kugr.default)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $6kugr.default)(elem, margins[1]), 10);
}
const $a8d2400c90612023$var$collapseStyles = {
    [(0, $8qMCX.EXITED)]: 'collapse',
    [(0, $8qMCX.EXITING)]: 'collapsing',
    [(0, $8qMCX.ENTERING)]: 'collapsing',
    [(0, $8qMCX.ENTERED)]: 'collapse show'
};
const $a8d2400c90612023$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $a8d2400c90612023$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $7fPBF.useMemo)(()=>(0, $iVanP.default)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $7fPBF.useMemo)(()=>(0, $iVanP.default)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $7fPBF.useMemo)(()=>(0, $iVanP.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $7fPBF.useMemo)(()=>(0, $iVanP.default)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $crcja.default)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $7fPBF.useMemo)(()=>(0, $iVanP.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g8anv.default), {
        ref: ref,
        addEndListener: (0, $kndvq.default),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $lfw25.getChildRef)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, children.props.className, $a8d2400c90612023$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$a8d2400c90612023$var$Collapse.displayName = 'Collapse';
var $a8d2400c90612023$export$2e2bcd8739ae039 = $a8d2400c90612023$var$Collapse;

});
parcelRegister("iVanP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc659ac513468827$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $dc659ac513468827$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $dc659ac513468827$export$2e2bcd8739ae039 = $dc659ac513468827$var$createChainedFunction;

});


parcelRegister("k2m6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e96522f32f866845$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $e96522f32f866845$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $e96522f32f866845$var$_extends() {
    return $e96522f32f866845$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e96522f32f866845$var$_extends.apply(null, arguments);
}
function $e96522f32f866845$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e96522f32f866845$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e96522f32f866845$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e96522f32f866845$var$ChevronDown = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $e96522f32f866845$var$_objectWithoutProperties(_ref, $e96522f32f866845$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $e96522f32f866845$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chevron-down',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
    }));
});
$e96522f32f866845$var$ChevronDown.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $e96522f32f866845$export$2e2bcd8739ae039 = $e96522f32f866845$var$ChevronDown;

});

parcelRegister("cnmTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9029645c42733abb$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $9029645c42733abb$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $9029645c42733abb$var$_extends() {
    return $9029645c42733abb$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9029645c42733abb$var$_extends.apply(null, arguments);
}
function $9029645c42733abb$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9029645c42733abb$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $9029645c42733abb$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9029645c42733abb$var$ChevronRight = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $9029645c42733abb$var$_objectWithoutProperties(_ref, $9029645c42733abb$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $9029645c42733abb$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chevron-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
    }));
});
$9029645c42733abb$var$ChevronRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $9029645c42733abb$export$2e2bcd8739ae039 = $9029645c42733abb$var$ChevronRight;

});


parcelRegister("9Er6k", function(module, exports) {

$parcel$export(module.exports, "Control210", function () { return $8c5e961f94697873$export$8bdae7a3d24bf7ec; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gSkQi = parcelRequire("gSkQi");

var $b6fw7 = parcelRequire("b6fw7");
var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");

var $2jFYR = parcelRequire("2jFYR");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");
var $aS1zf = parcelRequire("aS1zf");
var $30Ra3 = parcelRequire("30Ra3");

var $fQHYQ = parcelRequire("fQHYQ");

var $8HfzK = parcelRequire("8HfzK");

var $eYprk = parcelRequire("eYprk");
const $8c5e961f94697873$export$8bdae7a3d24bf7ec = ({ id: id, ActionButton: ActionButton, allowCarriageReturn: allowCarriageReturn = false, allowCopy: allowCopy = false, autoFocus: autoFocus, disabled: disabled, editButton: editButton = false, forcePrefix: forcePrefix = "", invalidMessage: invalidMessage, isJsonText: isJsonText = false, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, noInvalidReturn: noInvalidReturn, onEditChange: onEditChange, ReadComponent: ReadComponent, rows: rows, setValue: setValue, spellCheck: spellCheck = true, subText: subText, type: type = "string", validCondition: validCondition, validMessage: validMessage, validationTargetOptions: validationTargetOptions, validationRequestUrl: validationRequestUrl = "", validationReturn: validationReturn, value: value, whiteSpaceFix: whiteSpaceFix = false, ...rest })=>{
    // Run validation check on current value
    const [validationStatus, setValidationStatus] = (0, $7fPBF.useState)({
        success: false,
        errorText: ""
    });
    const [validationRequest, setValidationRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    // Edit-button mode state; starts as true when there is no edit button so the input is always active
    const [isEditing, setIsEditing] = (0, $7fPBF.useState)(!editButton);
    const cancelRef = (0, $7fPBF.useRef)(false);
    // Tracks the value the user is currently typing in edit mode so validation runs live.
    // When not in edit mode, validation uses the committed `value` prop instead.
    const [editingValue, setEditingValue] = (0, $7fPBF.useState)(value);
    // The value to validate: use the in-progress editing value while editing, otherwise the committed prop value.
    const validationValue = editButton && isEditing ? editingValue : value;
    const lastEffectValidationTarget = (0, $7fPBF.useRef)(undefined);
    /**
   * Runs validation for a candidate control value and updates validation state.
   *
   * @param newValue - Candidate value and validation options to check
   * @returns The completed validation response, or null when no response is returned
   */ const runValidation = async (newValue)=>{
        if (!validCondition) {
            const response = {
                success: true,
                data: {
                    valid: true,
                    validationText: ""
                }
            };
            setValidationStatus(response);
            setValidationRequest({
                requesting: false,
                error: false,
                requestedId: newValue
            });
            return response;
        } else {
            const response = await (0, $30Ra3.loadWrapper)(validCondition, newValue, {
                ...validationRequest,
                error: false,
                errorText: undefined
            }, (ret)=>{
                // Report the current name as not-yet-valid as soon as a new validation check starts if a check needs to occur
                // consumers (e.g. save/set buttons) cannot act on a stale valid result while this one is pending.
                if (ret.requesting) validationReturn?.(false);
                setValidationRequest(ret);
            }, validationRequestUrl);
            /* istanbul ignore else */ if (response) {
                setValidationStatus(response);
                validationReturn?.(response.success === false ? false : response.data.valid);
            }
            return response;
        }
    };
    const checkValidation = (0, $7fPBF.useEffectEvent)(runValidation);
    /**
   * Updates the committed value after completing validation for the proposed value.
   *
   * @param newValue - Value produced by the input control
   */ const setValidatedValue = async (newValue)=>{
        if (validCondition) {
            const response = await runValidation({
                value: newValue,
                options: validationTargetOptions
            });
            const isValid = response?.success === true && response.data.valid === true;
            if (!noInvalidReturn || isValid) setValue?.(newValue);
        } else setValue?.(newValue);
    };
    /** Call validation when the value or options change */ (0, $7fPBF.useEffect)(()=>{
        const target = {
            value: validationValue,
            options: validationTargetOptions
        };
        if (!(0, $gSkQi.isEqual)(target, lastEffectValidationTarget.current)) {
            lastEffectValidationTarget.current = target;
            checkValidation(target);
        }
    }, [
        validationRequest.requesting,
        validationTargetOptions,
        validationValue
    ]);
    /**
   * Handles entering edit mode when the pen button is clicked.
   * Captures the current value in the edit buffer and notifies the parent.
   */ const handlePenClick = ()=>{
        setEditingValue(value);
        setIsEditing(true);
        onEditChange?.(true);
    };
    /**
   * Captures key events on the input wrapper to handle Escape (cancel) and Enter (confirm) in edit mode.
   * For Escape: sets the cancel flag and blurs the focused input so the blur handler discards the edit.
   * For Enter (commit): blurs the focused input so the blur handler commits the edit.
   * Enter commits in all cases except Shift+Enter in a textarea with allowCarriageReturn, where
   * Shift+Enter instead inserts a newline — so plain Enter submits and Shift+Enter creates a new line.
   *
   * @param e - The keyboard event fired during the capture phase
   */ const handleKeyDownCapture = (e)=>{
        if (editButton && isEditing) {
            if (e.key === "Escape") {
                e.preventDefault();
                e.stopPropagation();
                cancelRef.current = true;
                const target = e.currentTarget.querySelector("input, textarea");
                /* istanbul ignore else */ if (target instanceof HTMLElement) target.blur();
            } else if (e.key === "Enter" && !(e.shiftKey && allowCarriageReturn && type === "textarea")) {
                e.preventDefault();
                const target = e.currentTarget.querySelector("input, textarea");
                /* istanbul ignore else */ if (target instanceof HTMLElement) target.blur();
            }
        }
    };
    /**
   * Handles blur events on the input wrapper div.
   * When the cancel flag is set (Escape was pressed), exits edit mode without committing any change.
   * Otherwise, commits the current field value to the external setValue and exits edit mode.
   *
   * @param e - The focus event from the blur
   */ const handleEditWrapperBlur = (e)=>{
        if (!editButton) return;
        // Ignore focus moving to a child element (e.g. clicking inside the same wrapper)
        if (e.currentTarget.contains(e.relatedTarget)) return;
        /* istanbul ignore else */ if (cancelRef.current) {
            cancelRef.current = false;
            setIsEditing(false);
            onEditChange?.(false);
        } else if (isEditing) {
            const input = e.currentTarget.querySelector("input, textarea");
            const commitValue = input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement ? input.value : editingValue;
            setValidatedValue(commitValue);
            setIsEditing(false);
            onEditChange?.(false);
        }
    };
    // Calculate extra column deductions (allowCopy and actionButton each take 1 col)
    const extraColDeduction = (allowCopy ? 1 : 0) + (ActionButton ? 1 : 0);
    // Disabled when the edit button is present but edit mode is not active, or when externally disabled/read-only
    const isInputDisabled = editButton && !isEditing || disabled === true || !setValue;
    const validationClassName = validationStatus.success && !validationRequest.requesting ? validationStatus.data.warning ? "is-warning" : validationStatus.data.valid === true ? "is-valid" : "is-invalid" : "";
    const combinedClassName = (0, $cqVqv.classMerge)([
        rest.className,
        validationClassName
    ]);
    const hasWarningState = combinedClassName.split(/\s+/).includes("is-warning");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
        controlId: `${id}`,
        as: (0, $kYoG1.default),
        className: "my-1",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                md: labelWidth === "auto" ? undefined : Math.max(maxWidthCols - labelWidth - extraColDeduction, 1),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "d-flex align-items-center gap-1",
                        onKeyDownCapture: handleKeyDownCapture,
                        onBlur: handleEditWrapperBlur,
                        children: [
                            isInputDisabled && ReadComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(ReadComponent, {
                                value: value
                            }) : /*#__PURE__*/ (0, $7fPBF.createElement)((0, $fQHYQ.ControlBase), {
                                ...rest,
                                key: editButton ? `${id}-${isEditing}` : id,
                                value: isJsonText ? (0, $aS1zf.formatJson)(value) : value,
                                setValue: editButton ? (ret)=>{
                                    setEditingValue(ret);
                                } : (ret)=>void setValidatedValue(ret),
                                whiteSpaceFix: whiteSpaceFix,
                                disabled: isInputDisabled,
                                type: isJsonText ? "textarea" : type,
                                forcePrefix: forcePrefix,
                                rows: rows,
                                allowCarriageReturn: allowCarriageReturn,
                                className: combinedClassName,
                                spellCheck: spellCheck,
                                autoFocus: editButton ? isEditing : autoFocus
                            }),
                            editButton && setValue && !isEditing && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
                                variant: "outline-primary",
                                size: "sm",
                                disabled: disabled,
                                onClick: handlePenClick,
                                "aria-label": "Edit",
                                title: "Edit",
                                style: {
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2jFYR.default), {})
                            })
                        ]
                    }),
                    (subText || validCondition) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                        className: `${validationStatus.success && !validationRequest.requesting ? hasWarningState ? "warning-feedback d-block" : validationStatus.data?.valid === true ? "valid-feedback d-block" : "invalid-feedback d-block" : "text-muted"}`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eYprk.InTextLink), {
                            text: [
                                subText ?? "",
                                validationRequest.requesting ? "updating status..." : validationStatus.success ? validationStatus.data.validationText !== "" ? validationStatus.data.validationText : validationStatus.data.valid === true ? validMessage ?? // istanbul ignore next
                                "" : invalidMessage ?? // istanbul ignore next
                                "" : validationStatus.errorText
                            ].filter((s)=>s !== "").join(", ")
                        })
                    })
                ]
            }),
            allowCopy && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                xs: 1,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HfzK.CopyText), {
                    value: value
                })
            }),
            ActionButton && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                xs: 1,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(ActionButton, {})
            })
        ]
    });
};
$8c5e961f94697873$export$8bdae7a3d24bf7ec.displayName = "Control210";

});
parcelRegister("2jFYR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1afdeb9a7e0a75ec$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $1afdeb9a7e0a75ec$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $1afdeb9a7e0a75ec$var$_extends() {
    return $1afdeb9a7e0a75ec$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1afdeb9a7e0a75ec$var$_extends.apply(null, arguments);
}
function $1afdeb9a7e0a75ec$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $1afdeb9a7e0a75ec$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $1afdeb9a7e0a75ec$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $1afdeb9a7e0a75ec$var$Pen = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $1afdeb9a7e0a75ec$var$_objectWithoutProperties(_ref, $1afdeb9a7e0a75ec$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $1afdeb9a7e0a75ec$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pen',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"
    }));
});
$1afdeb9a7e0a75ec$var$Pen.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $1afdeb9a7e0a75ec$export$2e2bcd8739ae039 = $1afdeb9a7e0a75ec$var$Pen;

});

parcelRegister("fQHYQ", function(module, exports) {

$parcel$export(module.exports, "ControlBase", function () { return $4f4c4c24c11f3244$export$176dfbb73f409824; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");
parcelRequire("2nuru");
var $hQ7Qt = parcelRequire("hQ7Qt");

const $4f4c4c24c11f3244$export$176dfbb73f409824 = (props)=>{
    const { allowCarriageReturn: allowCarriageReturn = false, className: className = "", debounceMilliseconds: debounceMilliseconds = 500, disabled: disabled = false, forcePrefix: forcePrefix = "", sanitiseValue: sanitiseValue, setValue: setValue, spellCheck: spellCheck = true, type: type = "string", value: value, whiteSpaceFix: whiteSpaceFix = false, ...rest } = props;
    const [currentValue, setCurrentValue] = (0, $7fPBF.useState)(value);
    const debounceTimer = (0, $7fPBF.useRef)(null);
    /**
   * Force an immediate update, bypassing debounce.
   *
   * @param newValue - Optional new value to set before forcing the update
   */ const forceUpdate = (newValue)=>{
        // Clear any pending debounce timer
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
        // Use provided value or current value
        const valueToUpdate = newValue ?? currentValue;
        // Update parent if setValue is available
        setValue?.(valueToUpdate);
        // Update local state if new value provided
        if (newValue !== undefined) setCurrentValue(valueToUpdate);
    };
    // Sync with parent value changes
    (0, $7fPBF.useEffect)(()=>{
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
        (0, $7fPBF.startTransition)(()=>setCurrentValue(value));
    }, [
        value
    ]);
    // Handle debounced updates when currentValue changes
    (0, $7fPBF.useEffect)(()=>{
        const fixedValue = whiteSpaceFix ? (0, $hQ7Qt.valueFix)(value, true) : value;
        // Only debounce if setValue exists and value differs from parent
        /* istanbul ignore else */ if (setValue && currentValue !== fixedValue) {
            // Clear existing timer
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
            // Set up debounced update (0ms for immediate, for negative values no need to set)
            if (debounceMilliseconds >= 0) debounceTimer.current = setTimeout(()=>{
                setValue(currentValue);
                debounceTimer.current = null;
            }, debounceMilliseconds);
        } else if (currentValue === fixedValue) // If values are the same, ensure no pending timer
        {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
                debounceTimer.current = null;
            }
        }
        // Cleanup function to clear timer on unmount
        return ()=>{
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
        };
    }, [
        currentValue,
        debounceMilliseconds,
        setValue,
        value,
        whiteSpaceFix
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
        ...rest,
        autoFocus: props.autoFocus,
        as: type === "textarea" ? "textarea" : undefined,
        className: className,
        disabled: disabled || !setValue,
        onBlur: (e)=>{
            if (e.currentTarget.value !== value) {
                const fixedValue = whiteSpaceFix ? (0, $hQ7Qt.valueFix)(e.currentTarget.value, true) : e.currentTarget.value;
                setCurrentValue(fixedValue);
                forceUpdate(fixedValue);
            }
        },
        onChange: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            /* istanbul ignore else */ if (e.currentTarget.value.startsWith(forcePrefix)) {
                const newValue = sanitiseValue?.(e.currentTarget.value) ?? e.currentTarget.value;
                setCurrentValue(newValue);
            }
        },
        onKeyDown: (e)=>{
            if (e.key === "Enter" && !allowCarriageReturn || e.key === "Enter" && e.shiftKey && allowCarriageReturn && type === "textarea") {
                e.preventDefault();
                e.stopPropagation();
                forceUpdate();
            }
        },
        placeholder: props.placeholder,
        size: "sm",
        spellCheck: spellCheck,
        type: type !== "textarea" ? type : undefined,
        value: currentValue
    });
};
$4f4c4c24c11f3244$export$176dfbb73f409824.displayName = "ControlBase";

});

parcelRegister("8HfzK", function(module, exports) {

$parcel$export(module.exports, "CopyText", function () { return $a8503a5a828c0168$export$1d8a493107fb4b3a; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $ggM0l = parcelRequire("ggM0l");
var $3kLzB = parcelRequire("3kLzB");

const $a8503a5a828c0168$export$1d8a493107fb4b3a = ({ value: value, disabled: disabled = false, onCopy: onCopy })=>{
    const [copied, setCopied] = (0, $7fPBF.useState)(false);
    /**
   * Copies text to clipboard and shows confirmation feedback.
   */ const handleCopy = async ()=>{
        if (disabled) return;
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            if (onCopy) onCopy();
            setTimeout(()=>setCopied(false), 2000);
        } catch (error) {
            console.warn("Failed to copy text: ", error);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `copy-text-container ${disabled ? "disabled" : ""}`,
        onClick: handleCopy,
        title: copied ? "Copied!" : "Copy to Clipboard",
        children: copied ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ggM0l.default), {
            className: "copied-icon"
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3kLzB.default), {
            className: "copy-icon"
        })
    });
};
$a8503a5a828c0168$export$1d8a493107fb4b3a.displayName = "CopyText";

});
parcelRegister("ggM0l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8360a563f6ff2c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $bd8360a563f6ff2c$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $bd8360a563f6ff2c$var$_extends() {
    return $bd8360a563f6ff2c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd8360a563f6ff2c$var$_extends.apply(null, arguments);
}
function $bd8360a563f6ff2c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bd8360a563f6ff2c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bd8360a563f6ff2c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bd8360a563f6ff2c$var$Check = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $bd8360a563f6ff2c$var$_objectWithoutProperties(_ref, $bd8360a563f6ff2c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $bd8360a563f6ff2c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-check',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"
    }));
});
$bd8360a563f6ff2c$var$Check.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $bd8360a563f6ff2c$export$2e2bcd8739ae039 = $bd8360a563f6ff2c$var$Check;

});

parcelRegister("3kLzB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26d8246c1de7915c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $26d8246c1de7915c$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $26d8246c1de7915c$var$_extends() {
    return $26d8246c1de7915c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $26d8246c1de7915c$var$_extends.apply(null, arguments);
}
function $26d8246c1de7915c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $26d8246c1de7915c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $26d8246c1de7915c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $26d8246c1de7915c$var$Copy = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $26d8246c1de7915c$var$_objectWithoutProperties(_ref, $26d8246c1de7915c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $26d8246c1de7915c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-copy',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
    }));
});
$26d8246c1de7915c$var$Copy.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $26d8246c1de7915c$export$2e2bcd8739ae039 = $26d8246c1de7915c$var$Copy;

});


parcelRegister("eYprk", function(module, exports) {

$parcel$export(module.exports, "InTextLink", function () { return $3cf9b938e18de1a4$export$7dedd20f026aa918; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $3cf9b938e18de1a4$export$c98178282bbfc788 = (groups)=>{
    const newGroups = [];
    const urlRe = /\[([^[]+)\]\((.*)\)/gm;
    let match;
    groups.forEach((group)=>{
        if (group.type === "string" && group.text !== undefined) {
            let i = 0;
            while((match = urlRe.exec(group.text)) !== null){
                if (match.index > i) newGroups.push({
                    type: "string",
                    text: group.text.substring(i, match.index)
                });
                newGroups.push({
                    type: "link",
                    text: match[1],
                    href: match[2]
                });
                i = match.index + match[0].length;
            }
            if (i < group.text.length) newGroups.push({
                type: "string",
                text: group.text.substring(i)
            });
        } else newGroups.push(group);
    });
    return newGroups;
};
const $3cf9b938e18de1a4$export$5a387c01ade40f44 = (groups)=>{
    const newGroups = [];
    const urlRe = /(http:\/\/[\w\d.]+)/gm;
    let match;
    groups.forEach((group)=>{
        if (group.type === "string" && group.text !== undefined) {
            let i = 0;
            while((match = urlRe.exec(group.text)) !== null){
                /* istanbul ignore else */ if (match.index > i) newGroups.push({
                    type: "string",
                    text: group.text.substring(i, match.index)
                });
                newGroups.push({
                    type: "link",
                    text: "link",
                    href: match[1]
                });
                i = match.index + match[0].length;
            }
            if (i < group.text.length) newGroups.push({
                type: "string",
                text: group.text.substring(i)
            });
        } else newGroups.push(group);
    });
    return newGroups;
};
const $3cf9b938e18de1a4$export$7dedd20f026aa918 = ({ text: text })=>{
    let groups = [
        {
            type: "string",
            text: text
        }
    ];
    groups = $3cf9b938e18de1a4$export$c98178282bbfc788(groups);
    groups = $3cf9b938e18de1a4$export$5a387c01ade40f44(groups);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: groups.map((group, i)=>{
            switch(group.type){
                case "string":
                    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fPBF.Fragment), {
                        children: group.text
                    }, i);
                case "link":
                    return /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                        href: group.href,
                        target: "_blank",
                        rel: "noreferrer",
                        children: group.text
                    }, i);
            }
        })
    });
};
$3cf9b938e18de1a4$export$7dedd20f026aa918.displayName = "InTextLink";

});


parcelRegister("isQD0", function(module, exports) {

$parcel$export(module.exports, "Control211", function () { return $90e8f7b7c8ec2e0f$export$62b044822953a2ee; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");
parcelRequire("2nuru");
var $30Ra3 = parcelRequire("30Ra3");

var $eYprk = parcelRequire("eYprk");
const $90e8f7b7c8ec2e0f$export$62b044822953a2ee = ({ id: id, contentSize: contentSize = false, disabled: disabled, invalidMessage: invalidMessage, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, multiple: multiple, options: options, setValue: setValue, subText: subText, title: title, validCondition: validCondition, validMessage: validMessage, validationTargetOptions: validationTargetOptions, validationRequestUrl: validationRequestUrl = "", validationReturn: validationReturn, value: value })=>{
    // Run validation check on current value
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    const [validationStatus, setValidationStatus] = (0, $7fPBF.useState)({
        success: false,
        errorText: ""
    });
    const [validationRequest, setValidationRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Checks validation for the current value.
   *
   * @param newValue - The validation target containing the value to check
   */ const checkValidation = (0, $7fPBF.useEffectEvent)(async (newValue)=>{
        if (!validCondition) startTransition(()=>{
            setValidationStatus({
                success: true,
                data: {
                    valid: true,
                    validationText: ""
                }
            });
            setValidationRequest({
                requesting: false,
                error: false,
                requestedId: newValue
            });
        });
        else {
            const response = await (0, $30Ra3.loadWrapper)(validCondition, newValue, {
                ...validationRequest,
                error: false,
                errorText: undefined
            }, setValidationRequest, validationRequestUrl);
            /* istanbul ignore else */ if (response) {
                startTransition(()=>setValidationStatus(response));
                validationReturn?.(response.success === false ? false : response.data.valid);
            }
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!validationRequest.requesting && (value !== validationRequest.requestedId?.value || !(0, $gSkQi.isEqual)(validationTargetOptions, validationRequest.requestedId?.options))) checkValidation({
            value: value,
            options: validationTargetOptions
        });
    }, [
        validationRequest,
        validationTargetOptions,
        value
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
        controlId: `${id}`,
        as: (0, $kYoG1.default),
        className: "my-1",
        title: title,
        children: [
            labelWidth !== 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                md: labelWidth === 0 ? maxWidthCols : labelWidth === "auto" ? undefined : maxWidthCols - labelWidth,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Select, {
                        multiple: multiple,
                        style: {
                            minHeight: multiple ? "120px" : undefined,
                            fieldSizing: contentSize ? "content" : undefined
                        },
                        size: "sm",
                        value: multiple ? value ? value.split("|") : [] : value,
                        disabled: disabled || !setValue,
                        onChange: (e)=>setValue?.(multiple ? Array.from(e.currentTarget.selectedOptions, (option)=>option.value).join("|") : e.currentTarget.value),
                        "aria-label": label,
                        className: `${validationStatus.success && !validationRequest.requesting ? validationStatus.data.valid === true ? "is-valid" : "is-invalid" : ""}`,
                        children: options.map((o)=>typeof o === "string" ? {
                                value: o,
                                label: o
                            } : o).map((o, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, i))
                    }),
                    (subText || validCondition) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                        style: {
                            minHeight: "1.5em",
                            display: "block"
                        },
                        className: `${validationStatus.success && !validationRequest.requesting ? validationStatus.data?.valid === true ? "valid-feedback" : "invalid-feedback" : "text-muted"}`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eYprk.InTextLink), {
                            text: [
                                subText ?? "",
                                validationRequest.requesting || pending ? "updating status..." : validationStatus.success ? validationStatus.data.validationText !== "" ? validationStatus.data.validationText : validationStatus.data.valid === true ? validMessage ?? // istanbul ignore next
                                "" : invalidMessage ?? // istanbul ignore next
                                "" : ""
                            ].filter((f)=>f !== "").join(" ")
                        })
                    })
                ]
            })
        ]
    });
};
$90e8f7b7c8ec2e0f$export$62b044822953a2ee.displayName = "Control211";

});

parcelRegister("egunj", function(module, exports) {

$parcel$export(module.exports, "Control213", function () { return $66a266dfd04c0484$export$a68e0b398c3ef1ab; });

var $bbzbN = parcelRequire("bbzbN");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");
/**
 * Internal component for rendering a group of related checkboxes with a "Select All" option.
 *
 * @param props - Component props
 * @param props.id - Unique identifier for the checkbox group
 * @param props.checked - Array of checked states for each checkbox
 * @param props.disabled - Whether all checkboxes are disabled
 * @param props.groupLabel - Overall label for the group
 * @param props.labelWidth - Width of the label column in Bootstrap grid units
 * @param props.labels - Array of labels for individual checkboxes
 * @param props.maxWidthCols - Maximum width in Bootstrap grid columns
 * @param props.offsetCols - Number of columns to offset the group
 * @param props.setChecked - Callback function to update all checked states
 * @returns A React functional component rendering a Form.Group with multiple checkboxes
 */ const $66a266dfd04c0484$var$CheckedGroup = ({ id: id, groupLabel: groupLabel, labels: labels, labelWidth: labelWidth, maxWidthCols: maxWidthCols, offsetCols: offsetCols, checked: checked, setChecked: setChecked, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
        controlId: id,
        as: (0, $kYoG1.default),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                column: true,
                md: labelWidth,
                offset: offsetCols,
                children: groupLabel
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                md: maxWidthCols - labelWidth - offsetCols,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                        id: `${id}-select-all`,
                        className: "mb-1",
                        label: "Select All",
                        type: "checkbox",
                        checked: labels.length === checked.filter((c)=>c).length,
                        onChange: (e)=>{
                            setChecked(labels.map(()=>e.target.checked));
                        },
                        disabled: disabled
                    }),
                    labels.map((label, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                            id: `${id}-${index}`,
                            type: "checkbox",
                            name: `${id}-${index}`,
                            label: label,
                            checked: checked[index],
                            onChange: (e)=>{
                                const newChecked = [
                                    ...checked
                                ];
                                newChecked[index] = e.target.checked;
                                setChecked(newChecked);
                            },
                            disabled: disabled
                        }, index))
                ]
            })
        ]
    });
};
$66a266dfd04c0484$var$CheckedGroup.displayName = "CheckedGroup";
const $66a266dfd04c0484$export$a68e0b398c3ef1ab = ({ id: id, label: label, groupLabel: groupLabel, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, offsetCols: offsetCols, checked: checked, setChecked: setChecked, disabled: disabled })=>{
    const sensibleCheck = new Set([
        Array.isArray(checked),
        Array.isArray(label)
    ]);
    return sensibleCheck.size > 1 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: "Mismatch in labels/checks"
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: typeof label === "string" && typeof checked === "boolean" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Group, {
            controlId: `${id}`,
            as: (0, $kYoG1.default),
            className: "mb-1",
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                md: {
                    span: maxWidthCols - labelWidth - (offsetCols ?? 0),
                    offset: offsetCols
                },
                className: "d-flex align-items-center",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                    type: "checkbox",
                    name: id,
                    label: label,
                    checked: checked,
                    onChange: (e)=>setChecked && setChecked(e.target.checked),
                    disabled: disabled
                })
            })
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)($66a266dfd04c0484$var$CheckedGroup, {
            id: id,
            groupLabel: groupLabel || "",
            labels: label,
            labelWidth: labelWidth,
            maxWidthCols: maxWidthCols,
            offsetCols: offsetCols ?? 0,
            checked: checked,
            setChecked: setChecked,
            disabled: disabled
        })
    });
};
$66a266dfd04c0484$export$a68e0b398c3ef1ab.displayName = "Control213";

});

parcelRegister("fHRX3", function(module, exports) {

$parcel$export(module.exports, "ControlDate", function () { return $878f30419efc3524$export$5cef76cf8c55602b; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");
parcelRequire("2nuru");
var $lUIe4 = parcelRequire("lUIe4");
var $iLcka = parcelRequire("iLcka");
var $c72HK = parcelRequire("c72HK");

var $8HzIe = parcelRequire("8HzIe");

var $eYprk = parcelRequire("eYprk");
const $878f30419efc3524$export$5cef76cf8c55602b = ({ id: id, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, value: value, setValue: setValue, disabled: disabled, timeAllowed: timeAllowed, pastBad: pastBad, futureBad: futureBad, blankBad: blankBad, showNowButton: showNowButton = false })=>{
    const [currentDate, setCurrentDate] = (0, $7fPBF.useState)("");
    const [currentTime, setCurrentTime] = (0, $7fPBF.useState)("");
    const [isNowActive, setIsNowActive] = (0, $7fPBF.useState)(false);
    const [, startTransition] = (0, $7fPBF.useTransition)();
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>{
            switch(value){
                case "now":
                    setIsNowActive(true);
                    break;
                case "":
                    setIsNowActive(false);
                    setCurrentDate("");
                    setCurrentTime("");
                    break;
                default:
                    {
                        setIsNowActive(false);
                        const d = (0, $lUIe4.convertDateToLocaleString)(new Date(value));
                        setCurrentDate(d.slice(0, 10));
                        setCurrentTime(d.slice(11, 19));
                        break;
                    }
            }
        });
    }, [
        timeAllowed,
        value
    ]);
    const validationReturn = currentDate === "" && blankBad ? {
        success: false,
        validationText: "Date missing"
    } : isNowActive ? {
        success: true,
        returnedDate: "now"
    } : (0, $c72HK.stringDateCheck)(`${currentDate} ${currentTime}`.trim(), {
        blankBad: blankBad,
        pastBad: pastBad,
        futureBad: futureBad
    });
    /**
   * Return the current date and time in UTC format or "now" via setValue callback.
   *
   * @param now - -Whether to set the value to "now"
   */ const returnDate = (now)=>{
        if (now) setValue?.("now");
        else {
            const s = `${currentDate} ${currentTime}`.trim();
            const ret = s !== "" ? (0, $lUIe4.convertLocaleDateToUTCString)(s) : "";
            if (ret !== value && ret !== "Invalid date") setValue?.(ret);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
                as: (0, $kYoG1.default),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                        column: true,
                        md: labelWidth,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                        md: Math.floor((maxWidthCols - labelWidth) / 2),
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                            id: `${id}-date`,
                            "aria-label": `${label} date`,
                            size: "sm",
                            value: isNowActive ? "" : currentDate,
                            disabled: disabled || !setValue || isNowActive,
                            type: "date",
                            min: pastBad ? new Date().getDate() : undefined,
                            max: futureBad ? new Date().getDate() : undefined,
                            onChange: setValue ? (e)=>{
                                let newDate = "";
                                if (!timeAllowed && e.currentTarget.value !== "") {
                                    const d = new Date(e.currentTarget.value);
                                    /* istanbul ignore else */ if (!isNaN(d.getTime())) {
                                        const m = (0, $iLcka.setToUTCMidnight)(d, d.getTimezoneOffset() > 0);
                                        newDate = m.slice(0, 10);
                                        setCurrentTime(m.slice(11, 19));
                                    }
                                } else newDate = e.currentTarget.value;
                                setCurrentDate(newDate);
                            } : undefined,
                            className: `${validationReturn.success === true ? "is-valid" : "is-invalid"}`,
                            onBlur: setValue ? (e)=>{
                                setCurrentDate(e.currentTarget.value);
                                returnDate();
                            } : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                        md: Math.ceil((maxWidthCols - labelWidth) / 2),
                        className: "d-flex gap-4 align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                                id: `${id}-time`,
                                "aria-label": `${label} time`,
                                size: "sm",
                                value: isNowActive ? "" : currentTime,
                                disabled: disabled || !setValue || !timeAllowed || isNowActive,
                                type: "time",
                                onChange: setValue ? (e)=>{
                                    setCurrentTime(e.currentTarget.value);
                                    if (e.currentTarget.value === "") setCurrentDate("");
                                } : undefined,
                                className: `${validationReturn.success === true ? "is-valid" : "is-invalid"}`,
                                onBlur: setValue ? (e)=>{
                                    setCurrentTime(e.currentTarget.value);
                                    returnDate();
                                } : undefined
                            }),
                            showNowButton && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                id: `${id}-now-button`,
                                size: "sm",
                                variant: isNowActive ? "success" : "outline-primary",
                                "aria-label": "Now",
                                style: {
                                    width: "72px"
                                },
                                title: "Set the date and time to now",
                                onClick: ()=>{
                                    returnDate(!isNowActive);
                                },
                                children: "Now"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                className: "mb-1",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    md: {
                        offset: labelWidth
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                        style: validationReturn.success === false ? {
                            color: "var(--bs-danger)"
                        } : undefined,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eYprk.InTextLink), {
                            text: isNowActive ? "Time is set when submitted" : validationReturn.success === true ? validationReturn.returnedDate ? validationReturn.returnedDate.toString() : "" : validationReturn.validationText ?? // istanbul ignore next
                            ""
                        })
                    })
                })
            })
        ]
    });
};
$878f30419efc3524$export$5cef76cf8c55602b.displayName = "ControlDate";

});

parcelRegister("ceSEx", function(module, exports) {

$parcel$export(module.exports, "ControlNavList", function () { return $0d94643ea9dd211d$export$5ab1e435eaa08dbd; });

var $bbzbN = parcelRequire("bbzbN");

var $4tJ7o = parcelRequire("4tJ7o");

var $1Vem2 = parcelRequire("1Vem2");
var $2jFYR = parcelRequire("2jFYR");
var $6dv4K = parcelRequire("6dv4K");

const $0d94643ea9dd211d$export$5ab1e435eaa08dbd = ({ id: id, list: list, selected: selected, setSelected: setSelected, addItem: addItem, addLabel: addLabel = "Add new", removeItem: removeItem, removeLabel: removeLabel = "Remove", renameItem: renameItem, renameLabel: renameLabel = "Rename", renderItem: renderItem = ({ label: label })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: label
    }) })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default), {
        variant: "pills",
        className: "flex-column",
        id: `${id}`,
        children: [
            list.map((l)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default).Link, {
                    id: `${id}-link-${l.id}`,
                    className: `control-nav-item ${selected === l.id ? "active" : ""}`,
                    onClick: ()=>{
                        setSelected?.(l.id);
                    },
                    children: [
                        removeItem && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "icon-holder",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1Vem2.default), {
                                id: `${id}-remove-${l.id}`,
                                onClick: ()=>removeItem(l.id),
                                "aria-label": `${removeLabel} ${l.label}`,
                                style: {
                                    color: selected === l.id ? "var(--bs-light)" : "var(--bs-danger)"
                                }
                            })
                        }),
                        renameItem && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "icon-holder",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2jFYR.default), {
                                id: `${id}-rename-${l.id}`,
                                onClick: ()=>renameItem(l.id),
                                "aria-label": `${renameLabel} ${l.label}`,
                                style: {
                                    color: selected === l.id ? "var(--bs-light)" : "var(--bs-dark)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "control-nav-inner",
                            children: renderItem(l)
                        })
                    ]
                }, l.id)),
            addItem && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default).Link, {
                id: `${id}-add`,
                className: "control-nav-item",
                onClick: ()=>addItem(),
                children: [
                    " ",
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "icon-holder",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                    }),
                    addLabel
                ]
            })
        ]
    });
};
$0d94643ea9dd211d$export$5ab1e435eaa08dbd.displayName = "ControlNavList";

});
parcelRegister("1Vem2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16663fcf1adaec0a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $16663fcf1adaec0a$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $16663fcf1adaec0a$var$_extends() {
    return $16663fcf1adaec0a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $16663fcf1adaec0a$var$_extends.apply(null, arguments);
}
function $16663fcf1adaec0a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $16663fcf1adaec0a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $16663fcf1adaec0a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $16663fcf1adaec0a$var$DashCircleDotted = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $16663fcf1adaec0a$var$_objectWithoutProperties(_ref, $16663fcf1adaec0a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $16663fcf1adaec0a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-dash-circle-dotted',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 0q-.264 0-.523.017l.064.998a7 7 0 0 1 .918 0l.064-.998A8 8 0 0 0 8 0M6.44.152q-.52.104-1.012.27l.321.948q.43-.147.884-.237L6.44.153zm4.132.271a8 8 0 0 0-1.011-.27l-.194.98q.453.09.884.237zm1.873.925a8 8 0 0 0-.906-.524l-.443.896q.413.205.793.459zM4.46.824q-.471.233-.905.524l.556.83a7 7 0 0 1 .793-.458zM2.725 1.985q-.394.346-.74.74l.752.66q.303-.345.648-.648zm11.29.74a8 8 0 0 0-.74-.74l-.66.752q.346.303.648.648zm1.161 1.735a8 8 0 0 0-.524-.905l-.83.556q.254.38.458.793l.896-.443zM1.348 3.555q-.292.433-.524.906l.896.443q.205-.413.459-.793zM.423 5.428a8 8 0 0 0-.27 1.011l.98.194q.09-.453.237-.884zM15.848 6.44a8 8 0 0 0-.27-1.012l-.948.321q.147.43.237.884zM.017 7.477a8 8 0 0 0 0 1.046l.998-.064a7 7 0 0 1 0-.918zM16 8a8 8 0 0 0-.017-.523l-.998.064a7 7 0 0 1 0 .918l.998.064A8 8 0 0 0 16 8M.152 9.56q.104.52.27 1.012l.948-.321a7 7 0 0 1-.237-.884l-.98.194zm15.425 1.012q.168-.493.27-1.011l-.98-.194q-.09.453-.237.884zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a7 7 0 0 1-.458-.793zm13.828.905q.292-.434.524-.906l-.896-.443q-.205.413-.459.793zm-12.667.83q.346.394.74.74l.66-.752a7 7 0 0 1-.648-.648zm11.29.74q.394-.346.74-.74l-.752-.66q-.302.346-.648.648zm-1.735 1.161q.471-.233.905-.524l-.556-.83a7 7 0 0 1-.793.458zm-7.985-.524q.434.292.906.524l.443-.896a7 7 0 0 1-.793-.459zm1.873.925q.493.168 1.011.27l.194-.98a7 7 0 0 1-.884-.237zm4.132.271a8 8 0 0 0 1.012-.27l-.321-.948a7 7 0 0 1-.884.237l.194.98zm-2.083.135a8 8 0 0 0 1.046 0l-.064-.998a7 7 0 0 1-.918 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
    }));
});
$16663fcf1adaec0a$var$DashCircleDotted.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $16663fcf1adaec0a$export$2e2bcd8739ae039 = $16663fcf1adaec0a$var$DashCircleDotted;

});


parcelRegister("dImYe", function(module, exports) {

$parcel$export(module.exports, "ControlsGroup", function () { return $aee6e1651ece7c9b$export$ceef51eaa926795d; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $euDav = parcelRequire("euDav");

var $52icS = parcelRequire("52icS");

var $9Er6k = parcelRequire("9Er6k");

var $isQD0 = parcelRequire("isQD0");
const $aee6e1651ece7c9b$export$ceef51eaa926795d = ({ baseId: baseId, currentValues: currentValues, inputs: inputs, onFieldChange: onFieldChange, setCurrentValues: setCurrentValues, setTextValid: setTextValid, spellCheck: spellCheck = true })=>{
    // Recompute derived values when currentValues change
    const computedValues = Object.fromEntries(inputs.filter((inp)=>inp.computeValue).map((inp)=>[
            inp.inputName,
            inp.computeValue(currentValues)
        ]));
    // Compute hidden states for all inputs
    const hiddenStates = inputs.map((inp)=>typeof inp.hidden === "function" ? inp.hidden({
            ...currentValues,
            ...computedValues
        }) : inp.hidden ?? false);
    // Track previous hidden states to detect changes
    const [prevHiddenStates, setPrevHiddenStates] = (0, $7fPBF.useState)([]);
    const validateHidden = (0, $7fPBF.useEffectEvent)(async (hiddenStates)=>{
        for (const [ix, hidden] of hiddenStates.entries()){
            // If an input is hidden, it is valid
            if (hidden) (0, $7fPBF.startTransition)(()=>setTextValid?.((prev)=>[
                        ...prev.slice(0, ix),
                        true,
                        ...prev.slice(ix + 1)
                    ]));
            else if (!hidden && prevHiddenStates[ix] === true && inputs[ix].validCondition) {
                const mergedValues = {
                    ...currentValues,
                    ...computedValues
                };
                let valid = false;
                try {
                    const ret = await inputs[ix].validCondition(inputs[ix].validationRequestUrl ?? "", {
                        value: mergedValues[inputs[ix].inputName],
                        options: (0, $52icS.getValidationOptions)(inputs[ix], mergedValues)
                    }, new AbortController());
                    valid = ret?.success ? ret.data.valid : false;
                } catch  {
                    valid = false;
                }
                (0, $7fPBF.startTransition)(()=>setTextValid?.((prev)=>[
                            ...prev.slice(0, ix),
                            valid,
                            ...prev.slice(ix + 1)
                        ]));
            }
        }
        (0, $7fPBF.startTransition)(()=>setPrevHiddenStates(hiddenStates));
    });
    // Validate hidden states on mount and when they change
    (0, $7fPBF.useEffect)(()=>{
        if (!hiddenStates.every((val, ix)=>val === prevHiddenStates[ix])) validateHidden(hiddenStates);
    }, [
        hiddenStates,
        prevHiddenStates
    ]);
    return inputs.map((inp, ix)=>{
        const mergedValues = {
            ...currentValues,
            ...computedValues
        };
        const sharedProps = {
            id: `${baseId}-${ix}`,
            label: inp.inputLabel,
            labelWidth: 4,
            value: mergedValues[inp.inputName],
            setValue: (ret)=>{
                const newCurrentValues = {
                    ...currentValues,
                    [inp.inputName]: ret
                };
                const newComputedValues = Object.fromEntries(inputs.filter((i)=>i.computeValue).map((i)=>[
                        i.inputName,
                        i.computeValue(newCurrentValues)
                    ]));
                setCurrentValues({
                    ...newCurrentValues,
                    ...newComputedValues
                });
                onFieldChange?.({
                    ...newCurrentValues,
                    ...newComputedValues
                });
            },
            disabled: typeof inp.readonly === "function" ? inp.readonly(mergedValues) : inp.readonly,
            validationTargetOptions: (0, $52icS.getValidationOptions)(inp, mergedValues)
        };
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $euDav.default), {
            in: !hiddenStates[ix],
            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: inp.dropdownOptions ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                    ...sharedProps,
                    multiple: inp.multiple,
                    options: [
                        ...!inp.multiple && !inp.dropdownOptions.includes(mergedValues[inp.inputName]) ? [
                            {
                                label: "Select...",
                                value: ""
                            }
                        ] : [],
                        ...inp.dropdownOptions.map((opt)=>({
                                label: opt,
                                value: opt
                            }))
                    ],
                    validCondition: inp.validCondition,
                    validationReturn: (ret)=>setTextValid?.((prev)=>[
                                ...prev.slice(0, ix),
                                ret,
                                ...prev.slice(ix + 1)
                            ]),
                    validationRequestUrl: inp.validationRequestUrl
                }, inp.inputName) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                    ...sharedProps,
                    autoFocus: ix === 0,
                    forcePrefix: inp.forcePrefix,
                    placeholder: inp.placeholder,
                    spellCheck: spellCheck,
                    validCondition: inp.validCondition,
                    validationReturn: (ret)=>setTextValid?.((prev)=>[
                                ...prev.slice(0, ix),
                                ret,
                                ...prev.slice(ix + 1)
                            ]),
                    validationRequestUrl: inp.validationRequestUrl,
                    whiteSpaceFix: true
                }, inp.inputName)
            })
        }, ix);
    });
};

});

parcelRegister("creWj", function(module, exports) {

$parcel$export(module.exports, "ControlTags", function () { return $cc269a18ed2b065b$export$b1411b87eeeb7c6c; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $bNVAi = parcelRequire("bNVAi");

var $chrMr = parcelRequire("chrMr");

var $0Wjqu = parcelRequire("0Wjqu");
const $cc269a18ed2b065b$export$b1411b87eeeb7c6c = ({ allowCreate: allowCreate = false, allowEdit: allowEdit = false, automaticallyCreateOnReturn: automaticallyCreateOnReturn = false, availableOptions: availableOptions, className: className, disabled: disabled = false, height: height = "80px", inputAriaLabel: inputAriaLabel = "Search tags", onSelectionChange: onSelectionChange, placeholder: placeholder = "Select...", selectedTags: selectedTags, showCheckboxes: showCheckboxes = true })=>{
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    const [showDropdown, setShowDropdown] = (0, $7fPBF.useState)(false);
    const [selectedIndex, setSelectedIndex] = (0, $7fPBF.useState)(-1);
    /** Index of the chip currently being edited inline, or null when not editing. */ const [editingIndex, setEditingIndex] = (0, $7fPBF.useState)(null);
    /** Current text value of the chip being edited inline. */ const [editValue, setEditValue] = (0, $7fPBF.useState)("");
    const containerRef = (0, $7fPBF.useRef)(null);
    const inputRef = (0, $7fPBF.useRef)(null);
    /** Whether the dropdown has content to display (options or create capability). */ const hasDropdown = availableOptions.length > 0 || allowCreate;
    /**
   * The control is effectively disabled when explicitly disabled OR when there
   * are no available options, creation is not allowed, and free-text entry is not allowed.
   */ const effectivelyDisabled = disabled || !hasDropdown && !automaticallyCreateOnReturn;
    /**
   * Whether the input should commit its value on blur. This is only true in
   * pure free-text mode (no dropdown present) to avoid blur-triggered commits
   * conflicting with dropdown item selection.
   */ const commitOnBlur = automaticallyCreateOnReturn && !hasDropdown;
    /**
   * Build dropdown items from the union of available options and currently-selected tags,
   * filtered by the current search text. Each item carries a `checked` flag so the dropdown
   * renders a checkbox indicating whether the tag is already selected.
   * An optional "Create" entry is prepended when `allowCreate` is on and the search text
   * is a novel value.
   */ const dropdownItems = (0, $7fPBF.useMemo)(()=>{
        if (!hasDropdown) return [];
        // Union of available options and any orphaned selected tags not in the options list
        const allOptions = [
            ...new Set([
                ...availableOptions,
                ...selectedTags
            ])
        ];
        const filtered = allOptions.filter((option)=>option.toLowerCase().includes(searchText.toLowerCase()));
        const items = filtered.map((option, index)=>({
                id: `option-${index}`,
                text: option,
                ...showCheckboxes ? {
                    checked: selectedTags.includes(option)
                } : {}
            }));
        // Prepend a "Create" entry when allowCreate is true and the search text is a novel value
        if (allowCreate && searchText.trim() && !allOptions.some((opt)=>opt.toLowerCase() === searchText.toLowerCase()) && !selectedTags.includes(searchText.trim())) items.unshift({
            id: "create-option",
            text: `Create: "${searchText.trim()}"`,
            data: searchText.trim(),
            isCreateOption: true
        });
        return items;
    }, [
        availableOptions,
        selectedTags,
        searchText,
        allowCreate,
        showCheckboxes,
        hasDropdown
    ]);
    /**
   * Toggle a tag on or off via the dropdown. For "Create" options the new tag is added
   * and the search text is cleared. For regular items the tag is added when unchecked or
   * removed when already checked. The dropdown remains open after each interaction to
   * support multi-select without re-opening.
   */ const handleToggleTag = (0, $7fPBF.useCallback)((item)=>{
        const tag = item.isCreateOption ? item.data : item.text;
        if (item.isCreateOption) {
            onSelectionChange([
                ...selectedTags,
                tag
            ]);
            setSearchText("");
        } else if (selectedTags.includes(tag)) onSelectionChange(selectedTags.filter((t)=>t !== tag));
        else onSelectionChange([
            ...selectedTags,
            tag
        ]);
    // Dropdown intentionally stays open for multi-select
    }, [
        selectedTags,
        onSelectionChange
    ]);
    /**
   * Remove an individual tag via its chip close button.
   *
   * @param tagToRemove - The tag string value to remove from the selection.
   */ const handleRemoveTag = (0, $7fPBF.useCallback)((tagToRemove)=>{
        onSelectionChange(selectedTags.filter((tag)=>tag !== tagToRemove));
    }, [
        selectedTags,
        onSelectionChange
    ]);
    /**
   * Commits a free-text tag from the primary input. Trims whitespace,
   * rejects empty strings and duplicates, then appends the new tag.
   */ const commitFreeText = (0, $7fPBF.useCallback)(()=>{
        const trimmed = searchText.trim();
        if (trimmed && !selectedTags.includes(trimmed)) onSelectionChange([
            ...selectedTags,
            trimmed
        ]);
        setSearchText("");
    }, [
        searchText,
        selectedTags,
        onSelectionChange
    ]);
    /**
   * Commits the in-progress inline chip edit, updating or removing the tag.
   * If the edited value is empty, the tag is removed. If the edited value
   * duplicates another tag, the edit is rejected and the original value restored.
   */ const commitEdit = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else */ if (editingIndex !== null) {
            const trimmed = editValue.trim();
            const updated = [
                ...selectedTags
            ];
            if (trimmed) {
                // Reject edits that would create a duplicate (excluding the tag being edited)
                const isDuplicate = selectedTags.some((tag, index)=>index !== editingIndex && tag === trimmed);
                if (!isDuplicate) {
                    updated[editingIndex] = trimmed;
                    onSelectionChange(updated);
                }
            } else {
                // Empty value removes the tag
                updated.splice(editingIndex, 1);
                onSelectionChange(updated);
            }
            setEditingIndex(null);
            setEditValue("");
        }
    }, [
        editingIndex,
        editValue,
        onSelectionChange,
        selectedTags
    ]);
    /**
   * Cancels the in-progress inline chip edit, restoring the original value.
   */ const cancelEdit = (0, $7fPBF.useCallback)(()=>{
        setEditingIndex(null);
        setEditValue("");
    }, []);
    /**
   * Open the dropdown (if available) and focus the search input when the
   * container area is clicked. Does nothing when editing a chip.
   */ const handleContainerClick = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else */ if (!effectivelyDisabled && editingIndex === null) {
            if (hasDropdown) setShowDropdown(true);
            inputRef.current?.focus();
        }
    }, [
        effectivelyDisabled,
        editingIndex,
        hasDropdown
    ]);
    /**
   * Close the dropdown and reset search state. Called by DropdownPortal on
   * click-outside and Escape key.
   */ const handleClose = (0, $7fPBF.useCallback)(()=>{
        setShowDropdown(false);
        setSearchText("");
        setSelectedIndex(-1);
    }, []);
    /**
   * Handles keydown events on the primary input. Manages Enter for free-text
   * creation, Escape for clearing, and delegates to existing dropdown keyboard
   * navigation when appropriate.
   *
   * @param e - The keyboard event from the primary input.
   */ const handleInputKeyDown = (0, $7fPBF.useCallback)((e)=>{
        if (e.key === "Enter") {
            // If the dropdown has a highlighted item, let DropdownPortal handle it
            if (hasDropdown && selectedIndex >= 0) return;
            // Otherwise, commit free-text if enabled
            if (automaticallyCreateOnReturn && searchText.trim()) {
                e.preventDefault();
                commitFreeText();
                // Re-focus the input for continuous entry
                setTimeout(()=>inputRef.current?.focus(), 0);
            }
        } else if (e.key === "Escape") // In free-text-only mode, clear the input text
        /* istanbul ignore else */ {
            if (automaticallyCreateOnReturn) setSearchText("");
        }
    }, [
        automaticallyCreateOnReturn,
        commitFreeText,
        hasDropdown,
        searchText,
        selectedIndex
    ]);
    /**
   * Handles keydown events on the inline edit input.
   * Enter commits the edit; Escape cancels it.
   *
   * @param e - The keyboard event from the edit input.
   */ const handleEditKeyDown = (0, $7fPBF.useCallback)((e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            commitEdit();
        } else if (e.key === "Escape") cancelEdit();
    }, [
        commitEdit,
        cancelEdit
    ]);
    /**
   * Handles blur on the primary input. In pure free-text mode (no dropdown),
   * commits the current text as a new tag.
   */ const handleInputBlur = (0, $7fPBF.useCallback)(()=>{
        if (commitOnBlur && searchText.trim()) commitFreeText();
    }, [
        commitOnBlur,
        commitFreeText,
        searchText
    ]);
    /**
   * Enters inline edit mode for a chip at the given index.
   *
   * @param index - The index of the tag to edit.
   * @param currentValue - The current text value of the tag.
   */ const enterEditMode = (0, $7fPBF.useCallback)((index, currentValue)=>{
        /* istanbul ignore else */ if (allowEdit && !effectivelyDisabled) {
            setEditingIndex(index);
            setEditValue(currentValue);
        }
    }, [
        allowEdit,
        effectivelyDisabled
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `tag-multiselect ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                ref: containerRef,
                role: "combobox",
                "aria-expanded": showDropdown && !effectivelyDisabled && hasDropdown,
                "aria-haspopup": "listbox",
                className: "form-control d-flex flex-wrap align-items-start gap-1 p-2",
                style: {
                    height: height,
                    overflowY: "auto",
                    overflowX: "auto",
                    cursor: effectivelyDisabled ? "default" : "text",
                    backgroundColor: effectivelyDisabled ? "var(--bs-secondary-bg)" : undefined
                },
                onClick: handleContainerClick,
                onMouseDown: (e)=>{
                    // Prevent container clicks from blurring the inline edit input
                    if (editingIndex !== null) e.preventDefault();
                },
                children: [
                    selectedTags.map((tag, index)=>allowEdit && !effectivelyDisabled && editingIndex === index ? /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                            type: "text",
                            className: `border rounded px-1 ${(0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).editInput}`,
                            value: editValue,
                            autoFocus: true,
                            onChange: (e)=>{
                                setEditValue(e.target.value);
                            },
                            onBlur: commitEdit,
                            onKeyDown: handleEditKeyDown,
                            "aria-label": `Edit tag: ${tag}`,
                            onClick: (e)=>e.stopPropagation()
                        }, `edit-${index}`) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bNVAi.default), {
                            bg: "secondary",
                            className: `d-flex align-items-center ${(0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).chip} ${effectivelyDisabled ? (0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).chipDisabled : (0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).chipClickable}`,
                            onClick: (e)=>{
                                /* istanbul ignore else */ if (!effectivelyDisabled) {
                                    e.stopPropagation();
                                    if (allowEdit) enterEditMode(index, tag);
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    children: tag
                                }),
                                !effectivelyDisabled && /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                    type: "button",
                                    className: "btn-close btn-close-white ms-1",
                                    style: {
                                        fontSize: "0.6em"
                                    },
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleRemoveTag(tag);
                                    },
                                    "aria-label": `Remove ${tag}`
                                })
                            ]
                        }, tag)),
                    !effectivelyDisabled && /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        className: `border-0 flex-grow-1 ${(0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).tagInput}`,
                        placeholder: selectedTags.length === 0 ? placeholder : "",
                        value: searchText,
                        onChange: (e)=>{
                            setSearchText(e.target.value);
                            if (hasDropdown && !showDropdown) setShowDropdown(true);
                        },
                        onFocus: ()=>{
                            if (hasDropdown) setShowDropdown(true);
                        },
                        onBlur: handleInputBlur,
                        onKeyDown: handleInputKeyDown,
                        disabled: effectivelyDisabled,
                        autoComplete: "off",
                        "aria-label": inputAriaLabel,
                        onClick: (e)=>e.stopPropagation()
                    })
                ]
            }),
            hasDropdown && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0Wjqu.DropdownPortal), {
                isOpen: showDropdown && dropdownItems.length > 0 && !effectivelyDisabled,
                items: dropdownItems,
                onSelect: handleToggleTag,
                onClose: handleClose,
                anchorRef: containerRef,
                selectedIndex: selectedIndex,
                onSelectedIndexChange: setSelectedIndex
            })
        ]
    });
};
$cc269a18ed2b065b$export$b1411b87eeeb7c6c.displayName = "ControlTags";

});
parcelRegister("bNVAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8980f05de1c63f28$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $8980f05de1c63f28$var$Badge = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$8980f05de1c63f28$var$Badge.displayName = 'Badge';
var $8980f05de1c63f28$export$2e2bcd8739ae039 = $8980f05de1c63f28$var$Badge;

});

parcelRegister("chrMr", function(module, exports) {

$parcel$export(module.exports, "chip", function () { return $8f0c9f298a1bc9e8$export$aa2a4c698c03a4c8; }, function (v) { return $8f0c9f298a1bc9e8$export$aa2a4c698c03a4c8 = v; });
$parcel$export(module.exports, "chipClickable", function () { return $8f0c9f298a1bc9e8$export$81380617abd11352; }, function (v) { return $8f0c9f298a1bc9e8$export$81380617abd11352 = v; });
$parcel$export(module.exports, "chipDisabled", function () { return $8f0c9f298a1bc9e8$export$1614914b034795e5; }, function (v) { return $8f0c9f298a1bc9e8$export$1614914b034795e5 = v; });
$parcel$export(module.exports, "dropdownCheckbox", function () { return $8f0c9f298a1bc9e8$export$c34e0625d8499c68; }, function (v) { return $8f0c9f298a1bc9e8$export$c34e0625d8499c68 = v; });
$parcel$export(module.exports, "dropdownItem", function () { return $8f0c9f298a1bc9e8$export$a8f2ac991e6b7a5; }, function (v) { return $8f0c9f298a1bc9e8$export$a8f2ac991e6b7a5 = v; });
$parcel$export(module.exports, "dropdownItemActive", function () { return $8f0c9f298a1bc9e8$export$1608f866457f675e; }, function (v) { return $8f0c9f298a1bc9e8$export$1608f866457f675e = v; });
$parcel$export(module.exports, "dropdownItemCreate", function () { return $8f0c9f298a1bc9e8$export$35b16a6e2ae70fba; }, function (v) { return $8f0c9f298a1bc9e8$export$35b16a6e2ae70fba = v; });
$parcel$export(module.exports, "editInput", function () { return $8f0c9f298a1bc9e8$export$4f56ae17fec11c82; }, function (v) { return $8f0c9f298a1bc9e8$export$4f56ae17fec11c82 = v; });
$parcel$export(module.exports, "tagInput", function () { return $8f0c9f298a1bc9e8$export$915122dd47a5f34c; }, function (v) { return $8f0c9f298a1bc9e8$export$915122dd47a5f34c = v; });
var $8f0c9f298a1bc9e8$export$aa2a4c698c03a4c8;
var $8f0c9f298a1bc9e8$export$81380617abd11352;
var $8f0c9f298a1bc9e8$export$1614914b034795e5;
var $8f0c9f298a1bc9e8$export$c34e0625d8499c68;
var $8f0c9f298a1bc9e8$export$a8f2ac991e6b7a5;
var $8f0c9f298a1bc9e8$export$1608f866457f675e;
var $8f0c9f298a1bc9e8$export$35b16a6e2ae70fba;
var $8f0c9f298a1bc9e8$export$4f56ae17fec11c82;
var $8f0c9f298a1bc9e8$export$915122dd47a5f34c;
$8f0c9f298a1bc9e8$export$aa2a4c698c03a4c8 = `mos-ControlTags-module-3IyqPa-chip`;
$8f0c9f298a1bc9e8$export$81380617abd11352 = `mos-ControlTags-module-3IyqPa-chipClickable`;
$8f0c9f298a1bc9e8$export$1614914b034795e5 = `mos-ControlTags-module-3IyqPa-chipDisabled`;
$8f0c9f298a1bc9e8$export$c34e0625d8499c68 = `mos-ControlTags-module-3IyqPa-dropdownCheckbox`;
$8f0c9f298a1bc9e8$export$a8f2ac991e6b7a5 = `mos-ControlTags-module-3IyqPa-dropdownItem`;
$8f0c9f298a1bc9e8$export$1608f866457f675e = `mos-ControlTags-module-3IyqPa-dropdownItemActive`;
$8f0c9f298a1bc9e8$export$35b16a6e2ae70fba = `mos-ControlTags-module-3IyqPa-dropdownItemCreate`;
$8f0c9f298a1bc9e8$export$4f56ae17fec11c82 = `mos-ControlTags-module-3IyqPa-editInput`;
$8f0c9f298a1bc9e8$export$915122dd47a5f34c = `mos-ControlTags-module-3IyqPa-tagInput`;

});

parcelRegister("0Wjqu", function(module, exports) {

$parcel$export(module.exports, "DropdownPortal", function () { return $bf753b0c9bce2ee8$export$6fde95e347518364; });

var $bbzbN = parcelRequire("bbzbN");

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $chrMr = parcelRequire("chrMr");
/**
 * Calculate dropdown position relative to anchor element.
 * When positioning above, the top is set to the anchor's top edge,
 * and the transform translateY(-100%) moves it up by its own height.
 * When positioning below, the top is set to the anchor's bottom edge.
 *
 * @param anchorEl - The anchor HTML element to position the dropdown relative to
 * @param dropdownHeight - The height of the dropdown to determine if it fits below or needs to be shown above
 * @returns The calculated dropdown position with all positioning properties
 */ const $bf753b0c9bce2ee8$var$calculatePosition = (anchorEl, dropdownHeight)=>{
    const rect = anchorEl.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    // Position below by default, above if not enough space
    const showAbove = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;
    return {
        calculated: true,
        left: rect.left,
        top: showAbove ? rect.top : rect.bottom,
        width: rect.width,
        showAbove: showAbove
    };
};
const $bf753b0c9bce2ee8$export$6fde95e347518364 = ({ isOpen: isOpen, items: items, onSelect: onSelect, onClose: onClose, anchorRef: anchorRef, maxHeight: maxHeight = 200, zIndex: zIndex = 10000, className: className = "", backgroundColor: backgroundColor = "var(--bs-body-bg)", selectedIndex: selectedIndex = -1, onSelectedIndexChange: onSelectedIndexChange })=>{
    const dropdownRef = (0, $7fPBF.useRef)(null);
    const [position, setPosition] = (0, $7fPBF.useState)({
        calculated: false
    });
    /**
   * Update dropdown position when anchor changes or dropdown opens
   */ const updatePosition = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else */ if (anchorRef.current && isOpen) {
            const newPosition = $bf753b0c9bce2ee8$var$calculatePosition(anchorRef.current, maxHeight);
            setPosition(newPosition);
        }
    }, [
        anchorRef,
        isOpen,
        maxHeight
    ]);
    /**
   * Update position on open and window resize/scroll
   */ (0, $7fPBF.useEffect)(()=>{
        if (isOpen) {
            updatePosition();
            window.addEventListener("resize", updatePosition);
            window.addEventListener("scroll", updatePosition, true);
            return ()=>{
                window.removeEventListener("resize", updatePosition);
                window.removeEventListener("scroll", updatePosition, true);
            };
        }
    }, [
        isOpen,
        updatePosition
    ]);
    /**
   * Handle keyboard navigation
   */ const handleKeyDown = (0, $7fPBF.useCallback)((e)=>{
        if (!isOpen || items.length === 0) return;
        switch(e.key){
            case "ArrowDown":
                {
                    e.preventDefault();
                    e.stopPropagation();
                    const nextIndex = Math.min(selectedIndex + 1, items.length - 1);
                    onSelectedIndexChange?.(nextIndex);
                    break;
                }
            case "ArrowUp":
                {
                    e.preventDefault();
                    e.stopPropagation();
                    const prevIndex = Math.max(selectedIndex - 1, 0);
                    onSelectedIndexChange?.(prevIndex);
                    break;
                }
            case "Enter":
            case "Tab":
                if (selectedIndex >= 0 && selectedIndex < items.length) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSelect(items[selectedIndex]);
                }
                break;
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                onClose();
                break;
        }
    }, [
        isOpen,
        items,
        selectedIndex,
        onSelect,
        onClose,
        onSelectedIndexChange
    ]);
    /**
   * Set up keyboard event listeners
   */ (0, $7fPBF.useEffect)(()=>{
        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown);
            return ()=>document.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        isOpen,
        handleKeyDown
    ]);
    /**
   * Scroll selected item into view
   */ (0, $7fPBF.useEffect)(()=>{
        if (isOpen && selectedIndex >= 0 && dropdownRef.current) {
            const selectedElement = dropdownRef.current.children[selectedIndex];
            /* istanbul ignore else */ if (selectedElement) selectedElement.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    }, [
        isOpen,
        selectedIndex
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isOpen) return;
        /**
     * Handle click outside to close dropdown.
     *
     * @param e - The event object
     */ const handleClickOutside = (e)=>{
            const target = e.target;
            // Don't close if clicking on anchor element or dropdown
            if (anchorRef.current?.contains(target) || dropdownRef.current?.contains(target)) return;
            onClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        isOpen,
        onClose,
        anchorRef
    ]);
    /**
   * Don't render if not open or no items or position not calculated yet
   */ if (!isOpen || items.length === 0 || !position.calculated) return null;
    /**
   * Render dropdown content
   */ const dropdownContent = /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ref: dropdownRef,
        role: "menu",
        className: `dropdown-menu show position-fixed ${className}`,
        style: {
            left: position.left,
            top: position.top,
            width: position.width,
            maxHeight: maxHeight,
            overflowY: "auto",
            zIndex: zIndex,
            backgroundColor: backgroundColor,
            transform: position.showAbove ? "translateY(-100%)" : "none"
        },
        children: items.map((item, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                type: "button",
                role: "menuitem",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))("dropdown-item d-flex align-items-center", (0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).dropdownItem, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).dropdownItemActive]: index === selectedIndex,
                    active: index === selectedIndex
                }, item.isCreateOption && (0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).dropdownItemCreate, item.className),
                onMouseDown: (e)=>{
                    e.preventDefault(); // Prevent input blur
                    onSelect(item);
                },
                children: [
                    item.checked !== undefined && /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        type: "checkbox",
                        checked: item.checked,
                        readOnly: true,
                        className: `form-check-input me-2 flex-shrink-0 ${(0, (/*@__PURE__*/$parcel$interopDefault($chrMr))).dropdownCheckbox}`,
                        tabIndex: -1
                    }),
                    item.text
                ]
            }, item.id))
    });
    /**
   * Render as portal to document body
   */ return /*#__PURE__*/ (0, $fw0lo.createPortal)(dropdownContent, document.body);
};
$bf753b0c9bce2ee8$export$6fde95e347518364.displayName = "DropdownPortal";

});


parcelRegister("k6Ixm", function(module, exports) {

$parcel$export(module.exports, "ControlTypeAhead", function () { return $e05abac25ec30fb2$export$f475efa2efc7dadf; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");
parcelRequire("2nuru");
var $30Ra3 = parcelRequire("30Ra3");

var $cqVqv = parcelRequire("cqVqv");

var $8HzIe = parcelRequire("8HzIe");


var $0Wjqu = parcelRequire("0Wjqu");
const $e05abac25ec30fb2$export$f475efa2efc7dadf = ({ id: id, availableList: availableList, backgroundColor: backgroundColor = "var(--bs-body-bg)", buttonLabel: buttonLabel = "OK", disabled: disabled, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, onButtonClick: onButtonClick, pauseCoverText: pauseCoverText, placeHolder: placeHolder, requestStatus: requestStatus, setValue: setValue, spellCheck: spellCheck = true, validCondition: validCondition, validationReturn: validationReturn, value: value })=>{
    // Current value in the control
    const [currentValue, setCurrentValue] = (0, $7fPBF.useState)(value);
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    (0, $7fPBF.useEffect)(()=>startTransition(()=>setCurrentValue(value)), [
        value
    ]);
    const [validationStatus, setValidationStatus] = (0, $7fPBF.useState)({
        success: true,
        data: {
            valid: true,
            validationText: ""
        }
    });
    const [validationRequest, setValidationRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    // Input ref for dropdown positioning
    const inputRef = (0, $7fPBF.useRef)(null);
    // Currently available values
    const currentList = availableList.filter((i)=>i.value.toLowerCase().includes(currentValue.toLowerCase()));
    const [selectedIndex, setSelectedIndex] = (0, $7fPBF.useState)(-1);
    // Show dropdown state
    const [showDropdown, setShowDropdown] = (0, $7fPBF.useState)(false);
    const validationTargetOptions = (0, $7fPBF.useMemo)(()=>({
            existingValues: availableList.map((item)=>item.value)
        }), [
        availableList
    ]);
    /**
   * Checks validation for the current value.
   *
   * @param newValue - The validation target containing the value to check.
   */ const checkValidation = (0, $7fPBF.useEffectEvent)(async (newValue)=>{
        if (!validCondition) {
            setValidationStatus({
                success: true,
                data: {
                    valid: newValue.value !== "" && validationTargetOptions.existingValues.includes(newValue.value),
                    validationText: ""
                }
            });
            setValidationRequest({
                requesting: false,
                error: false,
                requestedId: newValue
            });
            validationReturn?.(newValue.value !== "" && validationTargetOptions.existingValues.includes(newValue.value));
        } else {
            const response = await (0, $30Ra3.loadWrapper)(validCondition, newValue, {
                ...validationRequest,
                error: false,
                errorText: undefined
            }, setValidationRequest, "");
            /* istanbul ignore else */ if (response) {
                setValidationStatus(response);
                validationReturn?.(response.success === false ? false : response.data.valid);
            }
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!validationRequest.requesting && (currentValue !== validationRequest.requestedId?.value || !(0, $gSkQi.isEqual)(validationTargetOptions, validationRequest.requestedId?.options))) startTransition(()=>{
            checkValidation({
                value: currentValue,
                options: validationTargetOptions
            });
        });
    }, [
        currentValue,
        validationRequest,
        validationTargetOptions
    ]);
    // Convert available items to dropdown items
    const dropdownItems = currentList.map((item, index)=>({
            id: `${id}-item-${index}`,
            text: item.value,
            data: item
        }));
    /**
   * Handle return
   *
   * @param e - FocusEvent<HTMLInputElement>
   */ const handleBlur = (e)=>{
        const n = e.currentTarget.value.replace(/\s+/g, " ").trim();
        setCurrentValue(n);
        // Set value if valid or if no validation function provided
        const isValidValue = validCondition ? true : n !== "" && validationTargetOptions.existingValues.includes(n);
        if (n !== value && isValidValue) setValue(n);
        setShowDropdown(false);
    };
    // Handle dropdown item selection
    /**
   * Handles selection of an item from the dropdown.
   *
   * @param item - The selected dropdown item
   */ const handleDropdownSelect = (item)=>{
        const selectedValue = item.text;
        setCurrentValue(selectedValue);
        /* istanbul ignore else */ if (value !== selectedValue) setValue?.(selectedValue);
        setShowDropdown(false);
        setSelectedIndex(-1);
    };
    /**
   * Handle typing
   *
   * @param e - React.KeyboardEvent<HTMLInputElement>
   */ const handleKeyDown = (e)=>{
        if (e.key === "Enter" && showDropdown && dropdownItems.length > 0) {
            e.preventDefault();
            /* istanbul ignore else */ if (selectedIndex < dropdownItems.length && selectedIndex >= 0) handleDropdownSelect(dropdownItems[selectedIndex]);
        } else if (e.key === "Enter") inputRef.current?.blur();
        else if (e.key === "Escape" && showDropdown && dropdownItems.length > 0) {
            setShowDropdown(false);
            setSelectedIndex(-1);
        } else if (e.key === "Escape") {
            setCurrentValue(value);
            setTimeout(()=>{
                inputRef.current?.blur();
            }, 1);
        }
    };
    /**
   * Handle input changes.
   *
   * @param e - React.ChangeEvent<HTMLInputElement>
   */ const handleChange = (e)=>{
        setCurrentValue(e.currentTarget.value);
        setShowDropdown(e.currentTarget.value.trim().length > 0);
        setSelectedIndex(-1);
    };
    /**
   * Handle input focus
   */ const handleFocus = ()=>{
        setShowDropdown(currentValue.trim().length > 0 && (!validationStatus.success || !validationStatus.data.valid) && currentList.length > 0);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
        controlId: `${id}`,
        as: (0, $kYoG1.default),
        className: "my-1",
        children: [
            labelWidth > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                md: maxWidthCols - labelWidth - (onButtonClick ? 2 : 0),
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                            ref: inputRef,
                            size: "sm",
                            value: currentValue,
                            disabled: disabled || !setValue,
                            onChange: handleChange,
                            placeholder: placeHolder,
                            className: (0, $cqVqv.classMerge)([
                                validationStatus.success && validationStatus.data.warning ? "is-warning" : currentValue !== "" && validationStatus.success && validationStatus.data.valid ? "is-valid" : currentValue !== "" && (validationStatus.success === false || validationStatus.success && !validationStatus.data.valid) ? "is-invalid" : ""
                            ]),
                            onBlur: handleBlur,
                            onFocus: handleFocus,
                            onKeyDown: handleKeyDown,
                            autoComplete: "off",
                            spellCheck: spellCheck
                        }),
                        validationStatus.success && validationStatus.data.validationText && (validationStatus.data.warning || !validationStatus.data.valid) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                            className: validationStatus.data.warning ? "warning-feedback d-block" : "invalid-feedback d-block",
                            children: validationStatus.data.validationText
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0Wjqu.DropdownPortal), {
                            isOpen: showDropdown && dropdownItems.length > 0 && !disabled,
                            items: dropdownItems,
                            onSelect: handleDropdownSelect,
                            onClose: ()=>{
                                setShowDropdown(false);
                                setSelectedIndex(-1);
                            },
                            anchorRef: inputRef,
                            backgroundColor: backgroundColor,
                            selectedIndex: selectedIndex,
                            onSelectedIndexChange: setSelectedIndex
                        })
                    ]
                })
            }),
            onButtonClick && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                md: 2,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                    id: `${id}-button`,
                    disabled: !(validationStatus.success && validationStatus.data.valid),
                    onClick: onButtonClick,
                    size: "sm",
                    requestStatus: requestStatus,
                    pauseCoverText: pauseCoverText,
                    children: buttonLabel
                })
            })
        ]
    });
};
$e05abac25ec30fb2$export$f475efa2efc7dadf.displayName = "ControlTypeAhead";

});

parcelRegister("dKaWY", function(module, exports) {

$parcel$export(module.exports, "DraggableSidebar", function () { return $5201b0e02a5ce9cc$export$22be37e491cc9b49; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cdwkg = parcelRequire("cdwkg");
/**
 * Custom drag MIME type for sidebar items.
 */ const $5201b0e02a5ce9cc$var$DRAG_ITEM_MIME_TYPE = "application/x-mosaic-draggable-sidebar-item";
/**
 * Creates a stacked drag preview element for multi-item drags.
 *
 * @param labels - Labels for the items included in the drag operation
 * @returns A detached DOM element suitable for DataTransfer.setDragImage
 */ const $5201b0e02a5ce9cc$var$createMultiItemDragPreview = (labels)=>{
    const previewRoot = document.createElement("div");
    previewRoot.setAttribute("data-mosaic-drag-preview", "true");
    previewRoot.style.position = "fixed";
    previewRoot.style.top = "-1000px";
    previewRoot.style.left = "-1000px";
    previewRoot.style.pointerEvents = "none";
    previewRoot.style.zIndex = "2147483647";
    const stack = document.createElement("div");
    stack.style.position = "relative";
    stack.style.width = "220px";
    stack.style.height = "48px";
    previewRoot.appendChild(stack);
    labels.slice(0, 3).reverse().forEach((label, index)=>{
        const card = document.createElement("div");
        card.textContent = label;
        card.style.position = "absolute";
        card.style.inset = "0";
        card.style.transform = `translate(${index * 6}px, ${index * 6}px)`;
        card.style.padding = "10px 12px";
        card.style.border = "1px solid #0d6efd";
        card.style.borderRadius = "6px";
        card.style.backgroundColor = "#ffffff";
        card.style.boxShadow = "0 4px 10px rgba(13, 110, 253, 0.25)";
        card.style.color = "#0d6efd";
        card.style.fontSize = "12px";
        card.style.fontWeight = "600";
        card.style.whiteSpace = "nowrap";
        card.style.overflow = "hidden";
        card.style.textOverflow = "ellipsis";
        stack.appendChild(card);
    });
    return previewRoot;
};
/**
 * Default renderer for sidebar items (button element). Displays in primary colour when selected.
 *
 * @param props - Props containing the sidebar item and selection state
 * @param props.item - The sidebar item to render
 * @param props.selected - Whether the item is currently selected
 * @returns A button element with the item label, styled to reflect selection state
 */ const $5201b0e02a5ce9cc$var$DefaultRenderItem = ({ item: item, selected: selected })=>/*#__PURE__*/ (0, $bbzbN.jsx)("button", {
        type: "button",
        className: `btn ${selected ? "btn-primary" : "btn-outline-secondary"} text-start w-100`,
        children: item.label
    });
$5201b0e02a5ce9cc$var$DefaultRenderItem.displayName = "DefaultRenderItem";
const $5201b0e02a5ce9cc$export$22be37e491cc9b49 = ({ header: header, items: items, multiSelect: multiSelect = false, onItemDragEnd: onItemDragEnd, onItemDragStart: onItemDragStart, RenderItem: RenderItem = $5201b0e02a5ce9cc$var$DefaultRenderItem, style: style, ...drawerProps })=>{
    const [selectedIds, setSelectedIds] = (0, $7fPBF.useState)([]);
    const [anchorId, setAnchorId] = (0, $7fPBF.useState)(null);
    const dragPreviewRef = (0, $7fPBF.useRef)(null);
    const itemsById = new Map(items.map((item)=>[
            item.id,
            item
        ]));
    // Clean up drag preview element on unmount to prevent orphaned DOM nodes
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            dragPreviewRef.current?.remove();
            dragPreviewRef.current = null;
        };
    }, []);
    // Derive effective selection: items are only considered selected when multiSelect is enabled
    const effectiveSelectedIds = multiSelect ? selectedIds : [];
    /**
   * Handles item click for selection, supporting shift and ctrl/meta modifier keys.
   * - Plain click selects only the clicked item and sets it as the range anchor.
   * - Ctrl/Meta+click toggles the clicked item's selection and updates the anchor.
   * - Shift+click selects the range between the anchor and the clicked item.
   *
   * @param item - The item that was clicked
   * @param event - The originating mouse event
   */ const handleItemClick = (item, event)=>{
        if (!multiSelect) return;
        if (event.shiftKey && anchorId !== null) {
            const anchorIndex = items.findIndex((i)=>i.id === anchorId);
            const currentIndex = items.findIndex((i)=>i.id === item.id);
            const start = Math.min(anchorIndex, currentIndex);
            const end = Math.max(anchorIndex, currentIndex);
            const rangeIdsUnordered = items.slice(start, end + 1).map((i)=>i.id);
            const rangeIds = currentIndex >= anchorIndex ? rangeIdsUnordered : rangeIdsUnordered.reverse();
            if (event.ctrlKey || event.metaKey) // Ctrl/Meta + Shift expands selection without removing previously selected items.
            setSelectedIds((previousSelectedIds)=>[
                    ...previousSelectedIds,
                    ...rangeIds.filter((rangeId)=>!previousSelectedIds.includes(rangeId))
                ]);
            else setSelectedIds(rangeIds);
        } else if (event.ctrlKey || event.metaKey) {
            setSelectedIds((prev)=>prev.includes(item.id) ? prev.filter((id)=>id !== item.id) : [
                    ...prev,
                    item.id
                ]);
            setAnchorId(item.id);
        } else {
            setSelectedIds([
                item.id
            ]);
            setAnchorId(item.id);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cdwkg.HorizontalDrawer), {
        ...drawerProps,
        style: {
            overflowY: "auto",
            backgroundColor: "var(--bs-body-bg)",
            border: "1px solid var(--bs-border-color)",
            ...style
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "d-flex flex-column",
            style: {
                height: "100%"
            },
            children: [
                header !== undefined && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "p-2 border-bottom flex-shrink-0",
                    children: header
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "small-scrollbar flex-grow-1 p-2 overflow-auto",
                    style: {
                        minHeight: 0
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("ul", {
                        className: "list-unstyled d-flex flex-column gap-2 m-0",
                        children: items.map((item)=>{
                            const isSelected = effectiveSelectedIds.includes(item.id);
                            const itemsToDrag = isSelected && effectiveSelectedIds.length > 1 ? effectiveSelectedIds.map((selectedId)=>itemsById.get(selectedId)).filter((selectedItem)=>selectedItem !== undefined) : [
                                item
                            ];
                            const itemsToDragResolved = itemsToDrag.map((i)=>({
                                    ...i,
                                    data: typeof i.data === "function" ? i.data() : i.data
                                }));
                            return /*#__PURE__*/ (0, $bbzbN.jsx)("li", {
                                draggable: true,
                                onClick: (event)=>handleItemClick(item, event),
                                onDragStart: (event)=>{
                                    if (multiSelect && !isSelected) {
                                        setSelectedIds([
                                            item.id
                                        ]);
                                        setAnchorId(item.id);
                                    }
                                    event.dataTransfer.effectAllowed = "copy";
                                    const payload = JSON.stringify({
                                        data: itemsToDragResolved.map((i)=>i.data)
                                    });
                                    event.dataTransfer.setData("text/plain", itemsToDrag.map((i)=>i.label).join(", "));
                                    event.dataTransfer.setData("application/json", payload);
                                    event.dataTransfer.setData($5201b0e02a5ce9cc$var$DRAG_ITEM_MIME_TYPE, payload);
                                    const dragPreview = $5201b0e02a5ce9cc$var$createMultiItemDragPreview(itemsToDrag.map((draggedItem)=>draggedItem.label));
                                    if (itemsToDrag.length > 1) {
                                        dragPreviewRef.current?.remove();
                                        dragPreviewRef.current = dragPreview;
                                        document.body.appendChild(dragPreview);
                                        event.dataTransfer.setDragImage(dragPreview, 24, 24);
                                    }
                                    onItemDragStart?.(itemsToDragResolved, event);
                                },
                                onDragEnd: (event)=>{
                                    dragPreviewRef.current?.remove();
                                    dragPreviewRef.current = null;
                                    onItemDragEnd?.(itemsToDragResolved, event);
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)(RenderItem, {
                                    item: item,
                                    selected: isSelected
                                })
                            }, item.id);
                        })
                    })
                })
            ]
        })
    });
};
$5201b0e02a5ce9cc$export$22be37e491cc9b49.displayName = "DraggableSidebar";

});
parcelRegister("cdwkg", function(module, exports) {

$parcel$export(module.exports, "HorizontalDrawer", function () { return $59589976f3a974f8$export$e9a1a4cc82d693ab; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");
/** Minimum width in pixels enforced during resize operations. */ const $59589976f3a974f8$var$MIN_HORIZONTAL_DRAWER_WIDTH_PX = 100;
/** Default localStorage key used when no id prop is supplied. */ const $59589976f3a974f8$var$HORIZONTAL_DRAWER_DEFAULT_STORAGE_KEY = "horizontalDrawer-width";
const $59589976f3a974f8$export$e9a1a4cc82d693ab = ({ show: show, width: width = "600px", side: side = "right", timeMs: timeMs = 300, bodyLevel: bodyLevel = false, pushContent: pushContent = true, targetElement: targetElement, resizable: resizable = false, children: children, style: style, ...divProps })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [state, setState] = (0, $7fPBF.useState)(show ? "open" : "closed");
    const [lastShow, setLastShow] = (0, $7fPBF.useState)(show);
    // Parse numeric width value for margin calculations
    const defaultWidthPx = parseInt(width, 10);
    const widthUnit = width.replace(/\d+/g, "");
    // Internal width state for resizable mode, initialised from the width prop
    const [widthPx, setWidthPx] = (0, $7fPBF.useState)(defaultWidthPx);
    const widthPxRef = (0, $7fPBF.useRef)(widthPx);
    // Keep the ref current so resize callbacks always use the latest value
    (0, $7fPBF.useLayoutEffect)(()=>{
        widthPxRef.current = widthPx;
    }, [
        widthPx
    ]);
    // Derive the localStorage key from the supplied id prop, falling back to a default
    const storageKey = divProps.id !== undefined ? `horizontalDrawer-${divProps.id}-width` : `${$59589976f3a974f8$var$HORIZONTAL_DRAWER_DEFAULT_STORAGE_KEY}-${side}-${bodyLevel ? "body" : "container"}`;
    // Load persisted width from localStorage on mount when resizable
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (resizable) {
            const stored = window.localStorage.getItem(storageKey);
            if (stored !== null) {
                const parsed = parseInt(stored, 10);
                if (!isNaN(parsed) && parsed > 0) startTransition(()=>setWidthPx(parsed));
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // intentionally runs once on mount only
    // Effective width string used for rendering
    const effectiveWidth = resizable ? `${widthPx}${widthUnit}` : width;
    const effectiveWidthValue = parseInt(effectiveWidth, 10);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (show !== lastShow) {
            if (show) startTransition(()=>setState("placing"));
            else startTransition(()=>setState("closing"));
            startTransition(()=>setLastShow(show));
        }
    }, [
        state,
        show,
        lastShow
    ]);
    // Store timeout IDs to clear them on cleanup
    const timeoutsRef = (0, $7fPBF.useRef)([]);
    const targetRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (state === "placing") {
            const id = window.setTimeout(()=>{
                setState("opening");
            }, 5);
            timeoutsRef.current.push(id);
        }
        if (state === "opening") {
            const id = window.setTimeout(()=>{
                setState("open");
            }, timeMs);
            timeoutsRef.current.push(id);
        }
        if (state === "closing") {
            const id = window.setTimeout(()=>{
                setState("closed");
            }, timeMs);
            timeoutsRef.current.push(id);
        }
        // Cleanup: clear all scheduled timeouts
        return ()=>{
            timeoutsRef.current.forEach((id)=>clearTimeout(id));
            timeoutsRef.current = [];
        };
    }, [
        state,
        timeMs
    ]);
    // Handle pushing content when drawer opens/closes (only when bodyLevel is enabled)
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (!bodyLevel || !pushContent) return;
        // Store the target element in a ref to avoid ESLint warnings about modifying props
        targetRef.current = targetElement ?? document.body;
        const target = targetRef.current;
        const isOpen = [
            "open",
            "opening"
        ].includes(state);
        const marginValue = isOpen ? `${effectiveWidthValue}${widthUnit}` : "0";
        const marginProperty = side === "left" ? "marginLeft" : "marginRight";
        // Apply margin with transition
        target.style.transition = `margin ${timeMs}ms ease-in-out`;
        target.style[marginProperty] = marginValue;
        // Cleanup function to remove styles when component unmounts
        return ()=>{
            target.style[marginProperty] = "";
            target.style.transition = "";
        };
    }, [
        state,
        bodyLevel,
        pushContent,
        side,
        targetElement,
        effectiveWidthValue,
        widthUnit,
        timeMs
    ]);
    // Refs for direct DOM manipulation during resize to avoid React re-render overhead
    const outerDivRef = (0, $7fPBF.useRef)(null);
    const innerDivRef = (0, $7fPBF.useRef)(null);
    const bodyDivRef = (0, $7fPBF.useRef)(null);
    const resizeSessionRef = (0, $7fPBF.useRef)(null);
    /**
   * Applies drawer width updates during drag by manipulating DOM style directly (no React state).
   * Dragging left expands a right-side drawer; dragging right expands a left-side drawer.
   *
   * @param e - Native mouse move event emitted on the window.
   */ const handleResizeMouseMove = (e)=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        // Right-side drawer: handle is on the left edge; dragging left widens the drawer (invert delta).
        // Left-side drawer: handle is on the right edge; dragging right widens the drawer (positive delta).
        // TODO: Accurate review comment...
        // When bodyLevel + pushContent is enabled, the pushed target margin is derived from React state (effectiveWidthValue).
        // During a resize drag, the drawer width is updated via direct DOM writes, but the pushed margin is not updated until
        // mouse-up commits state. This can cause the drawer width and pushed content margin to get out of sync while dragging.
        const deltaMultiplier = side === "right" ? -1 : 1;
        const nextWidth = Math.max($59589976f3a974f8$var$MIN_HORIZONTAL_DRAWER_WIDTH_PX, Math.round(session.startWidthPx + deltaMultiplier * (e.clientX - session.startX)));
        if (nextWidth === session.latestWidthPx) return;
        session.latestWidthPx = nextWidth;
        session.elements.forEach((el)=>{
            el.style.width = `${nextWidth}px`;
        });
    };
    /**
   * Completes a drawer width drag, commits the final width to state, and persists it to localStorage.
   */ const handleResizeMouseUp = (0, $7fPBF.useCallback)(()=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const finalWidth = session.latestWidthPx;
        resizeSessionRef.current = null;
        setWidthPx(finalWidth);
        window.localStorage.setItem(storageKey, String(finalWidth));
    }, [
        storageKey
    ]);
    /**
   * Starts a drawer width drag from the resize handle.
   *
   * @param event - React mouse down event from the resize handle.
   */ const handleResizeMouseDown = (event)=>{
        /* istanbul ignore else -- handle is only rendered when resizable is true */ if (resizable) {
            event.preventDefault();
            const elements = [];
            if (bodyDivRef.current !== null) elements.push(bodyDivRef.current);
            if (outerDivRef.current !== null) elements.push(outerDivRef.current);
            if (innerDivRef.current !== null) elements.push(innerDivRef.current);
            /* istanbul ignore else */ if (elements.length > 0) resizeSessionRef.current = {
                startX: event.clientX,
                startWidthPx: widthPxRef.current,
                latestWidthPx: widthPxRef.current,
                elements: elements
            };
        }
    };
    /**
   * Clears any active resize session on unmount.
   */ (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            resizeSessionRef.current = null;
        };
    }, []);
    const { onMouseDown: onResizeHandleMouseDown } = (0, $d8dTd.useMouseMove)({
        onMouseDown: handleResizeMouseDown,
        onMouseMove: handleResizeMouseMove,
        onMouseUp: handleResizeMouseUp
    });
    // Resize handle style: a narrow strip at the inner edge of the drawer with a resize cursor
    const resizeHandleStyle = {
        position: "absolute",
        top: 0,
        [side === "right" ? "left" : "right"]: 0,
        width: "6px",
        height: "100%",
        cursor: "col-resize",
        zIndex: 1,
        userSelect: "none"
    };
    // For body-level drawers use transform-based sliding so height remains constant
    const bodyVisible = [
        "open",
        "opening"
    ].includes(state);
    const translateX = bodyVisible ? "0%" : side === "right" ? "100%" : "-100%";
    return state === "closed" ? null : bodyLevel ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        ...divProps,
        ref: bodyDivRef,
        style: {
            ...style,
            width: effectiveWidth,
            transform: `translateX(${translateX})`,
            transition: `transform ${timeMs}ms ease-in-out`,
            willChange: "transform",
            overflowX: "hidden",
            overflowY: "auto",
            position: "fixed",
            top: 0,
            [side]: 0,
            height: "100vh",
            zIndex: 1000
        },
        children: [
            resizable && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                "aria-label": "Resize drawer",
                style: resizeHandleStyle,
                onMouseDown: onResizeHandleMouseDown
            }),
            children
        ]
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ref: outerDivRef,
        style: {
            width: [
                "open",
                "opening"
            ].includes(state) ? effectiveWidth : "0",
            transition: `width ${timeMs}ms ease-in-out`,
            overflowX: "hidden",
            overflowY: "auto",
            position: "relative",
            height: "100%",
            marginLeft: side === "right" ? "auto" : undefined,
            marginRight: side === "left" ? "auto" : undefined
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            ...divProps,
            ref: innerDivRef,
            style: {
                ...style,
                width: effectiveWidth,
                position: "absolute",
                top: 0,
                [side === "right" ? "left" : "right"]: 0,
                height: "100%"
            },
            children: [
                resizable && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    "aria-label": "Resize drawer",
                    style: resizeHandleStyle,
                    onMouseDown: onResizeHandleMouseDown
                }),
                children
            ]
        })
    });
};
$59589976f3a974f8$export$e9a1a4cc82d693ab.displayName = "HorizontalDrawer";

});


parcelRegister("6LYdD", function(module, exports) {

$parcel$export(module.exports, "ReorderableNavList", function () { return $e8bb9fc55c9a3c0a$export$2b90471a4b629a80; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4tJ7o = parcelRequire("4tJ7o");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");

var $ece8k = parcelRequire("ece8k");
const $e8bb9fc55c9a3c0a$export$2b90471a4b629a80 = ({ list: list, setList: setList, getEventKey: getEventKey, disabled: disabled = false, disableReorder: disableReorder = false })=>{
    /** Whether tabs may be picked up, as either flag blocks reordering */ const canReorder = !disabled && !disableReorder;
    const [dragIndex, setDragIndex] = (0, $7fPBF.useState)(null);
    const [overIndex, setOverIndex] = (0, $7fPBF.useState)(null);
    const [dragWidth, setDragWidth] = (0, $7fPBF.useState)(0);
    /** Horizontal midpoints of each tab, captured before any drag transforms are applied */ const midPoints = (0, $7fPBF.useRef)([]);
    /** Latest calculated drop index, read on drop because state updates lag drag events */ const targetIndex = (0, $7fPBF.useRef)(null);
    /** Extent of the tab strip, used to ignore drops released outside it */ const listBounds = (0, $7fPBF.useRef)({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    });
    /** The tab strip element, listened to during a drag so gaps between tabs accept the drop */ const container = (0, $7fPBF.useRef)(null);
    /** Index of the tab being dragged, mirrored in a ref for the native strip listeners */ const activeDragIndex = (0, $7fPBF.useRef)(null);
    /** Whether the pointer was last seen over the tab strip, recorded during the drag */ const overList = (0, $7fPBF.useRef)(false);
    /**
   * Marks the whole tab strip as a valid drop zone. Without this the gaps between
   * tabs reject the drag and the browser shows the "not allowed" cursor even though
   * releasing there would still reorder the list.
   *
   * @param event - The native drag event raised anywhere over the tab strip.
   */ const allowDrop = (event)=>{
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
        /* istanbul ignore else -- the strip only listens while a drag is in progress */ if (activeDragIndex.current !== null) {
            const nextIndex = getTargetIndex(event.clientX, activeDragIndex.current);
            targetIndex.current = nextIndex;
            setOverIndex(nextIndex);
        }
    };
    /**
   * Records whether the pointer is still over the tab strip. Drag end reports
   * unreliable coordinates, so the last known position decides whether the move is
   * committed, and this runs on the document so positions outside the strip count.
   *
   * @param event - The native drag event raised anywhere in the document.
   */ const trackPointer = (event)=>{
        overList.current = event.clientX >= listBounds.current.left && event.clientX <= listBounds.current.right && event.clientY >= listBounds.current.top && event.clientY <= listBounds.current.bottom;
    };
    /**
   * Stops the tab strip accepting drops once the drag is over.
   */ const releaseContainer = ()=>{
        container.current?.removeEventListener("dragover", allowDrop);
        container.current?.removeEventListener("drop", allowDrop);
        document.removeEventListener("dragover", trackPointer);
        container.current = null;
    };
    /**
   * Moves the dragged item to the target position and notifies the caller.
   *
   * @param from - Index of the item being dragged.
   * @param to - Index the item should be moved to.
   */ const moveItem = (from, to)=>{
        if (from !== to) {
            const newList = [
                ...list
            ];
            const [moved] = newList.splice(from, 1);
            newList.splice(to, 0, moved);
            setList(newList);
        }
    };
    /**
   * Clears all drag tracking state once a drag has finished or been cancelled.
   */ const endDrag = ()=>{
        setDragIndex(null);
        setOverIndex(null);
        setDragWidth(0);
        midPoints.current = [];
        listBounds.current = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        targetIndex.current = null;
        overList.current = false;
        releaseContainer();
    };
    /**
   * Commits the pending move when the drag finishes. This runs on drag end rather
   * than only on drop because the sliding tabs can leave a gap beneath the pointer,
   * in which case no drop event is raised by any tab.
   */ const commitDrag = ()=>{
        if (dragIndex !== null && targetIndex.current !== null && overList.current) moveItem(dragIndex, targetIndex.current);
        activeDragIndex.current = null;
        endDrag();
    };
    /**
   * Records the untransformed midpoint of every tab so that the drop position can
   * be calculated from the pointer while the tabs are being slid out of the way.
   *
   * @param source - The tab wrapper the drag started from.
   */ const captureLayout = (source)=>{
        // The tabs are always rendered as div > Nav.Item > Nav, so the strip is present
        const strip = source.parentElement.parentElement;
        const wrappers = Array.from(strip.querySelectorAll("[data-reorderable-index]"));
        midPoints.current = wrappers.map((wrapper)=>{
            const rect = wrapper.getBoundingClientRect();
            return rect.left + rect.width / 2;
        });
        const stripRect = strip.getBoundingClientRect();
        listBounds.current = {
            left: stripRect.left,
            right: stripRect.right,
            top: stripRect.top,
            bottom: stripRect.bottom
        };
        container.current = strip;
        strip.addEventListener("dragover", allowDrop);
        strip.addEventListener("drop", allowDrop);
        document.addEventListener("dragover", trackPointer);
    };
    /**
   * Works out which position the dragged tab would take if dropped at the pointer.
   *
   * @param clientX - Horizontal pointer position of the drag event.
   * @param fallback - Index used when the layout could not be captured.
   * @returns The index the dragged tab should move to.
   */ const getTargetIndex = (clientX, fallback)=>{
        let target = fallback;
        /* istanbul ignore else -- the layout is always captured before a drag reports a position */ if (midPoints.current.length === list.length) {
            target = midPoints.current.filter((midPoint)=>midPoint < clientX).length;
            target = Math.min(target, list.length - 1);
        }
        return target;
    };
    /**
   * Uses a detached copy of the dragged tab as the drag image, so the item
   * following the cursor looks identical to the tab that was picked up.
   *
   * @param event - The drag start event raised by the tab wrapper.
   */ const setDragImageFromTab = (event)=>{
        const source = event.currentTarget;
        const preview = source.cloneNode(true);
        preview.style.width = `${source.offsetWidth}px`;
        preview.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavDragImage);
        // The clone is decorative only, so it must not be discoverable as content
        preview.setAttribute("aria-hidden", "true");
        preview.removeAttribute("data-reorderable-index");
        document.body.appendChild(preview);
        const rect = source.getBoundingClientRect();
        event.dataTransfer.setDragImage(preview, event.clientX - rect.left, event.clientY - rect.top);
        // The preview must remain in the document until the browser has snapshotted it
        setTimeout(()=>preview.remove(), 0);
    };
    /**
   * Determines how far a tab should slide to show where the dragged tab will land.
   *
   * @param index - Index of the tab being rendered.
   * @returns The CSS module class applying the required shift, or an empty string.
   */ const getShiftClass = (index)=>{
        let shiftClass = "";
        if (dragIndex !== null && overIndex !== null) {
            if (index === dragIndex) shiftClass = (0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavItemDragging;
            else if (index > dragIndex && index <= overIndex) shiftClass = (0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavItemShiftStart;
            else if (index < dragIndex && index >= overIndex) shiftClass = (0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavItemShiftEnd;
        }
        return shiftClass;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: list.map((item, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    draggable: canReorder,
                    onDragStart: (e)=>{
                        if (canReorder) {
                            e.dataTransfer.effectAllowed = "move";
                            e.dataTransfer.setData("text/plain", item.id);
                            activeDragIndex.current = index;
                            targetIndex.current = index;
                            captureLayout(e.currentTarget);
                            setDragImageFromTab(e);
                            setDragWidth(e.currentTarget.offsetWidth);
                            setDragIndex(index);
                        }
                    },
                    onDragEnd: commitDrag,
                    className: (0, $cqVqv.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavItem,
                        dragIndex === null ? (0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavItemStatic : "",
                        canReorder ? (0, (/*@__PURE__*/$parcel$interopDefault($ece8k))).reorderableNavItemDraggable : "",
                        getShiftClass(index)
                    ]),
                    style: {
                        "--mos-reorderable-drag-width": `${dragWidth}px`
                    },
                    "data-reorderable-index": index,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                        eventKey: getEventKey?.(item, index) ?? `${index}`,
                        disabled: disabled,
                        children: item.name
                    })
                })
            }, item.id))
    });
};
$e8bb9fc55c9a3c0a$export$2b90471a4b629a80.displayName = "ReorderableNavList";

});
parcelRegister("ece8k", function(module, exports) {

$parcel$export(module.exports, "reorderableNavDragImage", function () { return $a55d2647fbe160f6$export$9c92d948e9dd4ee7; }, function (v) { return $a55d2647fbe160f6$export$9c92d948e9dd4ee7 = v; });
$parcel$export(module.exports, "reorderableNavItem", function () { return $a55d2647fbe160f6$export$7a962dd883273575; }, function (v) { return $a55d2647fbe160f6$export$7a962dd883273575 = v; });
$parcel$export(module.exports, "reorderableNavItemDraggable", function () { return $a55d2647fbe160f6$export$6a3f25430dd3bce5; }, function (v) { return $a55d2647fbe160f6$export$6a3f25430dd3bce5 = v; });
$parcel$export(module.exports, "reorderableNavItemDragging", function () { return $a55d2647fbe160f6$export$1eab8ffd3e812b6e; }, function (v) { return $a55d2647fbe160f6$export$1eab8ffd3e812b6e = v; });
$parcel$export(module.exports, "reorderableNavItemShiftEnd", function () { return $a55d2647fbe160f6$export$ba03773125e0d26b; }, function (v) { return $a55d2647fbe160f6$export$ba03773125e0d26b = v; });
$parcel$export(module.exports, "reorderableNavItemShiftStart", function () { return $a55d2647fbe160f6$export$555dedc82c5ac17c; }, function (v) { return $a55d2647fbe160f6$export$555dedc82c5ac17c = v; });
$parcel$export(module.exports, "reorderableNavItemStatic", function () { return $a55d2647fbe160f6$export$53abb5e85e1c97b6; }, function (v) { return $a55d2647fbe160f6$export$53abb5e85e1c97b6 = v; });
var $a55d2647fbe160f6$export$9c92d948e9dd4ee7;
var $a55d2647fbe160f6$export$7a962dd883273575;
var $a55d2647fbe160f6$export$6a3f25430dd3bce5;
var $a55d2647fbe160f6$export$1eab8ffd3e812b6e;
var $a55d2647fbe160f6$export$ba03773125e0d26b;
var $a55d2647fbe160f6$export$555dedc82c5ac17c;
var $a55d2647fbe160f6$export$53abb5e85e1c97b6;
$a55d2647fbe160f6$export$9c92d948e9dd4ee7 = `mos-ReorderableNavList-module-Kvegya-reorderableNavDragImage`;
$a55d2647fbe160f6$export$7a962dd883273575 = `mos-ReorderableNavList-module-Kvegya-reorderableNavItem`;
$a55d2647fbe160f6$export$6a3f25430dd3bce5 = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemDraggable`;
$a55d2647fbe160f6$export$1eab8ffd3e812b6e = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemDragging`;
$a55d2647fbe160f6$export$ba03773125e0d26b = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemShiftEnd`;
$a55d2647fbe160f6$export$555dedc82c5ac17c = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemShiftStart`;
$a55d2647fbe160f6$export$53abb5e85e1c97b6 = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemStatic`;

});


parcelRegister("7Tnbh", function(module, exports) {

$parcel$export(module.exports, "SortableListHolder", function () { return $4d10f89b80b1da26$export$ee2d8054d5691374; });

var $bbzbN = parcelRequire("bbzbN");

var $kkPzd = parcelRequire("kkPzd");

var $gyOLv = parcelRequire("gyOLv");

var $dQqd9 = parcelRequire("dQqd9");

var $9LtqM = parcelRequire("9LtqM");
const $4d10f89b80b1da26$export$ee2d8054d5691374 = ({ id: id, canMove: canMove, handleDragEnd: handleDragEnd, items: items, maxHeights: maxHeights, showBorder: showBorder = true })=>{
    // Set up sortable list
    const sensors = (0, $kkPzd.useSensors)((0, $kkPzd.useSensor)((0, $kkPzd.PointerSensor)), (0, $kkPzd.useSensor)((0, $kkPzd.KeyboardSensor), {
        coordinateGetter: (0, $dQqd9.sortableKeyboardCoordinates)
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kkPzd.DndContext), {
        sensors: sensors,
        modifiers: [
            (0, $gyOLv.restrictToVerticalAxis)
        ],
        collisionDetection: (0, $kkPzd.closestCenter),
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("ol", {
            id: id,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dQqd9.SortableContext), {
                strategy: (0, $dQqd9.verticalListSortingStrategy),
                items: items,
                children: items.map((t, ix)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $9LtqM.SortableListItem), {
                        id: t.id,
                        canMove: canMove,
                        maxHeight: maxHeights ? maxHeights[ix] : undefined,
                        showBorder: showBorder,
                        children: t.element
                    }, t.id))
            })
        })
    });
};
$4d10f89b80b1da26$export$ee2d8054d5691374.displayName = "SortableListHolder";

});
parcelRegister("kkPzd", function(module, exports) {

$parcel$export(module.exports, "useSensor", function () { return $ecddad0aaeff3d51$export$cc72dd71f4ec69eb; });
$parcel$export(module.exports, "useSensors", function () { return $ecddad0aaeff3d51$export$19012f58216d597f; });
$parcel$export(module.exports, "getFirstCollision", function () { return $ecddad0aaeff3d51$export$ef1beab6d7287295; });
$parcel$export(module.exports, "closestCenter", function () { return $ecddad0aaeff3d51$export$c8e785ae6b74bab8; });
$parcel$export(module.exports, "closestCorners", function () { return $ecddad0aaeff3d51$export$c3a6c1c7122b31c9; });
$parcel$export(module.exports, "getClientRect", function () { return $ecddad0aaeff3d51$export$b6aa1f30c53d7454; });
$parcel$export(module.exports, "getScrollableAncestors", function () { return $ecddad0aaeff3d51$export$e4864aa91b5ed091; });
$parcel$export(module.exports, "KeyboardCode", function () { return $ecddad0aaeff3d51$export$a8b1916dba3ae88b; });
$parcel$export(module.exports, "KeyboardSensor", function () { return $ecddad0aaeff3d51$export$44d67f2a438aeba9; });
$parcel$export(module.exports, "PointerSensor", function () { return $ecddad0aaeff3d51$export$b26af955418d6638; });
$parcel$export(module.exports, "DndContext", function () { return $ecddad0aaeff3d51$export$2d5c5ceac203fc1e; });
$parcel$export(module.exports, "useDraggable", function () { return $ecddad0aaeff3d51$export$df30c81f5aa01ff7; });
$parcel$export(module.exports, "useDndContext", function () { return $ecddad0aaeff3d51$export$4930f6bf413be70e; });
$parcel$export(module.exports, "useDroppable", function () { return $ecddad0aaeff3d51$export$d74e5d67dc2b3176; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $1m8VR = parcelRequire("1m8VR");

var $kl7pE = parcelRequire("kl7pE");
const $ecddad0aaeff3d51$var$DndMonitorContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
function $ecddad0aaeff3d51$export$1182af90218a7b81(listener) {
    const registerListener = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$DndMonitorContext);
    (0, $7fPBF.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $ecddad0aaeff3d51$var$useDndMonitorProvider() {
    const [listeners] = (0, $7fPBF.useState)(()=>new Set());
    const registerListener = (0, $7fPBF.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $7fPBF.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $ecddad0aaeff3d51$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $ecddad0aaeff3d51$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $ecddad0aaeff3d51$var$Accessibility(_ref) {
    let { announcements: announcements = $ecddad0aaeff3d51$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $ecddad0aaeff3d51$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $kl7pE.useAnnouncement)();
    const liveRegionId = (0, $1m8VR.useUniqueId)("DndLiveRegion");
    const [mounted, setMounted] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setMounted(true);
    }, []);
    $ecddad0aaeff3d51$export$1182af90218a7b81((0, $7fPBF.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $kl7pE.HiddenText), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $kl7pE.LiveRegion), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $fw0lo.createPortal)(markup, container) : markup;
}
var $ecddad0aaeff3d51$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($ecddad0aaeff3d51$var$Action || ($ecddad0aaeff3d51$var$Action = {}));
function $ecddad0aaeff3d51$var$noop() {}
function $ecddad0aaeff3d51$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $7fPBF.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $ecddad0aaeff3d51$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $ecddad0aaeff3d51$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $ecddad0aaeff3d51$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $ecddad0aaeff3d51$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $1m8VR.getEventCoordinates)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $ecddad0aaeff3d51$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $ecddad0aaeff3d51$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $ecddad0aaeff3d51$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $ecddad0aaeff3d51$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $ecddad0aaeff3d51$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $ecddad0aaeff3d51$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $ecddad0aaeff3d51$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $ecddad0aaeff3d51$var$distanceBetween($ecddad0aaeff3d51$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $ecddad0aaeff3d51$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $ecddad0aaeff3d51$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $ecddad0aaeff3d51$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $ecddad0aaeff3d51$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $ecddad0aaeff3d51$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $ecddad0aaeff3d51$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $ecddad0aaeff3d51$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $ecddad0aaeff3d51$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $ecddad0aaeff3d51$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $ecddad0aaeff3d51$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $ecddad0aaeff3d51$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $ecddad0aaeff3d51$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($ecddad0aaeff3d51$var$sortCollisionsAsc);
};
function $ecddad0aaeff3d51$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $ecddad0aaeff3d51$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
}
function $ecddad0aaeff3d51$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $ecddad0aaeff3d51$var$getAdjustedRect = /*#__PURE__*/ $ecddad0aaeff3d51$var$createRectAdjustmentFn(1);
function $ecddad0aaeff3d51$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $ecddad0aaeff3d51$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $ecddad0aaeff3d51$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $ecddad0aaeff3d51$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $ecddad0aaeff3d51$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $ecddad0aaeff3d51$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $1m8VR.getWindow)(element).getComputedStyle(element);
        if (transform) rect = $ecddad0aaeff3d51$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $ecddad0aaeff3d51$var$getTransformAgnosticClientRect(element) {
    return $ecddad0aaeff3d51$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $ecddad0aaeff3d51$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $ecddad0aaeff3d51$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $1m8VR.getWindow)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $ecddad0aaeff3d51$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $1m8VR.getWindow)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $ecddad0aaeff3d51$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $1m8VR.isDocument)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $1m8VR.isHTMLElement)(node) || (0, $1m8VR.isSVGElement)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $1m8VR.getWindow)(element).getComputedStyle(node);
        if (node !== element) {
            if ($ecddad0aaeff3d51$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($ecddad0aaeff3d51$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $ecddad0aaeff3d51$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $ecddad0aaeff3d51$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $ecddad0aaeff3d51$var$getScrollableElement(element) {
    if (!(0, $1m8VR.canUseDOM) || !element) return null;
    if ((0, $1m8VR.isWindow)(element)) return element;
    if (!(0, $1m8VR.isNode)(element)) return null;
    if ((0, $1m8VR.isDocument)(element) || element === (0, $1m8VR.getOwnerDocument)(element).scrollingElement) return window;
    if ((0, $1m8VR.isHTMLElement)(element)) return element;
    return null;
}
function $ecddad0aaeff3d51$var$getScrollXCoordinate(element) {
    if ((0, $1m8VR.isWindow)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $ecddad0aaeff3d51$var$getScrollYCoordinate(element) {
    if ((0, $1m8VR.isWindow)(element)) return element.scrollY;
    return element.scrollTop;
}
function $ecddad0aaeff3d51$var$getScrollCoordinates(element) {
    return {
        x: $ecddad0aaeff3d51$var$getScrollXCoordinate(element),
        y: $ecddad0aaeff3d51$var$getScrollYCoordinate(element)
    };
}
var $ecddad0aaeff3d51$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($ecddad0aaeff3d51$var$Direction || ($ecddad0aaeff3d51$var$Direction = {}));
function $ecddad0aaeff3d51$var$isDocumentScrollingElement(element) {
    if (!(0, $1m8VR.canUseDOM) || !element) return false;
    return element === document.scrollingElement;
}
function $ecddad0aaeff3d51$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $ecddad0aaeff3d51$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $ecddad0aaeff3d51$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $ecddad0aaeff3d51$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $ecddad0aaeff3d51$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $ecddad0aaeff3d51$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $ecddad0aaeff3d51$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $ecddad0aaeff3d51$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $ecddad0aaeff3d51$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $ecddad0aaeff3d51$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $ecddad0aaeff3d51$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $ecddad0aaeff3d51$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $1m8VR.add)(acc, $ecddad0aaeff3d51$var$getScrollCoordinates(node));
    }, $ecddad0aaeff3d51$export$597cbd7bbd10deb4);
}
function $ecddad0aaeff3d51$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $ecddad0aaeff3d51$var$getScrollXCoordinate(node);
    }, 0);
}
function $ecddad0aaeff3d51$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $ecddad0aaeff3d51$var$getScrollYCoordinate(node);
    }, 0);
}
function $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $ecddad0aaeff3d51$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $ecddad0aaeff3d51$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $ecddad0aaeff3d51$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $ecddad0aaeff3d51$var$getScrollYOffset
    ]
];
class $ecddad0aaeff3d51$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $ecddad0aaeff3d51$export$e4864aa91b5ed091(element);
        const scrollOffsets = $ecddad0aaeff3d51$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $ecddad0aaeff3d51$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $ecddad0aaeff3d51$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $ecddad0aaeff3d51$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $1m8VR.getWindow)(target);
    return target instanceof EventTarget ? target : (0, $1m8VR.getOwnerDocument)(target);
}
function $ecddad0aaeff3d51$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $ecddad0aaeff3d51$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($ecddad0aaeff3d51$var$EventName || ($ecddad0aaeff3d51$var$EventName = {}));
function $ecddad0aaeff3d51$var$preventDefault(event) {
    event.preventDefault();
}
function $ecddad0aaeff3d51$var$stopPropagation(event) {
    event.stopPropagation();
}
var $ecddad0aaeff3d51$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($ecddad0aaeff3d51$export$a8b1916dba3ae88b || ($ecddad0aaeff3d51$export$a8b1916dba3ae88b = {}));
const $ecddad0aaeff3d51$var$defaultKeyboardCodes = {
    start: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Space,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Space,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Enter,
        $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Tab
    ]
};
const $ecddad0aaeff3d51$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $ecddad0aaeff3d51$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $ecddad0aaeff3d51$var$Listeners((0, $1m8VR.getOwnerDocument)(target));
        this.windowListeners = new $ecddad0aaeff3d51$var$Listeners((0, $1m8VR.getWindow)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($ecddad0aaeff3d51$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(node);
        onStart($ecddad0aaeff3d51$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $1m8VR.isKeyboardEvent)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $ecddad0aaeff3d51$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $ecddad0aaeff3d51$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $1m8VR.subtract)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $ecddad0aaeff3d51$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $ecddad0aaeff3d51$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right && !isRight || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down && !isBottom || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $1m8VR.add)((0, $1m8VR.subtract)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$ecddad0aaeff3d51$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $ecddad0aaeff3d51$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $ecddad0aaeff3d51$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $ecddad0aaeff3d51$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $ecddad0aaeff3d51$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $1m8VR.getOwnerDocument)(target);
        this.documentListeners = new $ecddad0aaeff3d51$var$Listeners(this.document);
        this.listeners = new $ecddad0aaeff3d51$var$Listeners(listenerTarget);
        this.windowListeners = new $ecddad0aaeff3d51$var$Listeners((0, $1m8VR.getWindow)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $1m8VR.getEventCoordinates)(event)) != null ? _getEventCoordinates : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.DragStart, $ecddad0aaeff3d51$var$preventDefault);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($ecddad0aaeff3d51$var$EventName.ContextMenu, $ecddad0aaeff3d51$var$preventDefault);
        this.documentListeners.add($ecddad0aaeff3d51$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($ecddad0aaeff3d51$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($ecddad0aaeff3d51$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($ecddad0aaeff3d51$var$EventName.Click, $ecddad0aaeff3d51$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($ecddad0aaeff3d51$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $1m8VR.getEventCoordinates)(event)) != null ? _getEventCoordinates2 : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        const delta = (0, $1m8VR.subtract)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($ecddad0aaeff3d51$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($ecddad0aaeff3d51$var$isDelayConstraint(activationConstraint)) {
                if ($ecddad0aaeff3d51$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $ecddad0aaeff3d51$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $ecddad0aaeff3d51$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $ecddad0aaeff3d51$export$b26af955418d6638 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $1m8VR.getOwnerDocument)(event.target);
        super(props, $ecddad0aaeff3d51$var$events, listenerTarget);
    }
}
$ecddad0aaeff3d51$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $ecddad0aaeff3d51$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $ecddad0aaeff3d51$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($ecddad0aaeff3d51$var$MouseButton || ($ecddad0aaeff3d51$var$MouseButton = {}));
class $ecddad0aaeff3d51$export$b28554b50bf7f273 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        super(props, $ecddad0aaeff3d51$var$events$1, (0, $1m8VR.getOwnerDocument)(props.event.target));
    }
}
$ecddad0aaeff3d51$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $ecddad0aaeff3d51$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $ecddad0aaeff3d51$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $ecddad0aaeff3d51$export$19b41baf2e1bcdc0 extends $ecddad0aaeff3d51$var$AbstractPointerSensor {
    constructor(props){
        super(props, $ecddad0aaeff3d51$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($ecddad0aaeff3d51$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($ecddad0aaeff3d51$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$ecddad0aaeff3d51$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $ecddad0aaeff3d51$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($ecddad0aaeff3d51$export$eefe60e26f04c318 || ($ecddad0aaeff3d51$export$eefe60e26f04c318 = {}));
var $ecddad0aaeff3d51$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($ecddad0aaeff3d51$export$f93aa492a37e1b0e || ($ecddad0aaeff3d51$export$f93aa492a37e1b0e = {}));
function $ecddad0aaeff3d51$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $ecddad0aaeff3d51$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $ecddad0aaeff3d51$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $ecddad0aaeff3d51$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $1m8VR.useInterval)();
    const scrollSpeed = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $7fPBF.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $7fPBF.useMemo)(()=>{
        switch(activator){
            case $ecddad0aaeff3d51$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $ecddad0aaeff3d51$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $7fPBF.useRef)(null);
    const autoScroll = (0, $7fPBF.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $7fPBF.useMemo)(()=>order === $ecddad0aaeff3d51$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $ecddad0aaeff3d51$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $ecddad0aaeff3d51$var$defaultScrollIntent = {
    x: {
        [$ecddad0aaeff3d51$var$Direction.Backward]: false,
        [$ecddad0aaeff3d51$var$Direction.Forward]: false
    },
    y: {
        [$ecddad0aaeff3d51$var$Direction.Backward]: false,
        [$ecddad0aaeff3d51$var$Direction.Forward]: false
    }
};
function $ecddad0aaeff3d51$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $1m8VR.usePrevious)(delta);
    return (0, $1m8VR.useLazyMemo)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $ecddad0aaeff3d51$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$ecddad0aaeff3d51$var$Direction.Backward]: previousIntent.x[$ecddad0aaeff3d51$var$Direction.Backward] || direction.x === -1,
                [$ecddad0aaeff3d51$var$Direction.Forward]: previousIntent.x[$ecddad0aaeff3d51$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$ecddad0aaeff3d51$var$Direction.Backward]: previousIntent.y[$ecddad0aaeff3d51$var$Direction.Backward] || direction.y === -1,
                [$ecddad0aaeff3d51$var$Direction.Forward]: previousIntent.y[$ecddad0aaeff3d51$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $ecddad0aaeff3d51$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $1m8VR.useLazyMemo)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $ecddad0aaeff3d51$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $7fPBF.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $ecddad0aaeff3d51$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($ecddad0aaeff3d51$export$571c10ffffe014ab || ($ecddad0aaeff3d51$export$571c10ffffe014ab = {}));
var $ecddad0aaeff3d51$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($ecddad0aaeff3d51$export$8e062c3160beefd5 || ($ecddad0aaeff3d51$export$8e062c3160beefd5 = {}));
const $ecddad0aaeff3d51$var$defaultValue = /*#__PURE__*/ new Map();
function $ecddad0aaeff3d51$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $7fPBF.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $7fPBF.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $1m8VR.useLatestValue)(disabled);
    const measureDroppableContainers = (0, $7fPBF.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $7fPBF.useRef)(null);
    const droppableRects = (0, $1m8VR.useLazyMemo)((previousValue)=>{
        if (disabled && !dragging) return $ecddad0aaeff3d51$var$defaultValue;
        if (!previousValue || previousValue === $ecddad0aaeff3d51$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $ecddad0aaeff3d51$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $7fPBF.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $ecddad0aaeff3d51$export$571c10ffffe014ab.Always:
                return false;
            case $ecddad0aaeff3d51$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $ecddad0aaeff3d51$var$useInitialValue(value, computeFn) {
    return (0, $1m8VR.useLazyMemo)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $ecddad0aaeff3d51$var$useInitialRect(node, measure) {
    return $ecddad0aaeff3d51$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $ecddad0aaeff3d51$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $1m8VR.useEvent)(callback);
    const mutationObserver = (0, $7fPBF.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $ecddad0aaeff3d51$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $1m8VR.useEvent)(callback);
    const resizeObserver = (0, $7fPBF.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $ecddad0aaeff3d51$var$defaultMeasure(element) {
    return new $ecddad0aaeff3d51$var$Rect($ecddad0aaeff3d51$export$b6aa1f30c53d7454(element), element);
}
function $ecddad0aaeff3d51$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$var$defaultMeasure;
    const [rect, setRect] = (0, $7fPBF.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $ecddad0aaeff3d51$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: measureRect
    });
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $ecddad0aaeff3d51$var$useRectDelta(rect) {
    const initialRect = $ecddad0aaeff3d51$var$useInitialValue(rect);
    return $ecddad0aaeff3d51$var$getRectDelta(rect, initialRect);
}
const $ecddad0aaeff3d51$var$defaultValue$1 = [];
function $ecddad0aaeff3d51$var$useScrollableAncestors(node) {
    const previousNode = (0, $7fPBF.useRef)(node);
    const ancestors = (0, $1m8VR.useLazyMemo)((previousValue)=>{
        if (!node) return $ecddad0aaeff3d51$var$defaultValue$1;
        if (previousValue && previousValue !== $ecddad0aaeff3d51$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $ecddad0aaeff3d51$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $7fPBF.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $ecddad0aaeff3d51$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $7fPBF.useState)(null);
    const prevElements = (0, $7fPBF.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $7fPBF.useCallback)((event)=>{
        const scrollingElement = $ecddad0aaeff3d51$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $ecddad0aaeff3d51$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $ecddad0aaeff3d51$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $ecddad0aaeff3d51$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $ecddad0aaeff3d51$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $7fPBF.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $1m8VR.add)(acc, coordinates), $ecddad0aaeff3d51$export$597cbd7bbd10deb4) : $ecddad0aaeff3d51$var$getScrollOffsets(elements);
        return $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $7fPBF.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $1m8VR.subtract)(scrollOffsets, initialScrollOffsets.current) : $ecddad0aaeff3d51$export$597cbd7bbd10deb4;
}
function $ecddad0aaeff3d51$var$useSensorSetup(sensors) {
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $1m8VR.canUseDOM)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $ecddad0aaeff3d51$var$useSyntheticListeners(listeners, id) {
    return (0, $7fPBF.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $ecddad0aaeff3d51$var$useWindowRect(element) {
    return (0, $7fPBF.useMemo)(()=>element ? $ecddad0aaeff3d51$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $ecddad0aaeff3d51$var$defaultValue$2 = [];
function $ecddad0aaeff3d51$var$useRects(elements, measure) {
    if (measure === void 0) measure = $ecddad0aaeff3d51$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $ecddad0aaeff3d51$var$useWindowRect(firstElement ? (0, $1m8VR.getWindow)(firstElement) : null);
    const [rects, setRects] = (0, $7fPBF.useState)($ecddad0aaeff3d51$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $ecddad0aaeff3d51$var$defaultValue$2;
            return elements.map((element)=>$ecddad0aaeff3d51$var$isDocumentScrollingElement(element) ? windowRect : new $ecddad0aaeff3d51$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: measureRects
    });
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $ecddad0aaeff3d51$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $1m8VR.isHTMLElement)(firstChild) ? firstChild : node;
}
function $ecddad0aaeff3d51$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $7fPBF.useState)(null);
    const handleResize = (0, $7fPBF.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $1m8VR.isHTMLElement)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $7fPBF.useCallback)((element)=>{
        const node = $ecddad0aaeff3d51$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $1m8VR.useNodeRef)(handleNodeChange);
    return (0, $7fPBF.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $ecddad0aaeff3d51$var$defaultSensors = [
    {
        sensor: $ecddad0aaeff3d51$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $ecddad0aaeff3d51$export$44d67f2a438aeba9,
        options: {}
    }
];
const $ecddad0aaeff3d51$var$defaultData = {
    current: {}
};
const $ecddad0aaeff3d51$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $ecddad0aaeff3d51$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $ecddad0aaeff3d51$var$getTransformAgnosticClientRect,
        strategy: $ecddad0aaeff3d51$export$571c10ffffe014ab.WhileDragging,
        frequency: $ecddad0aaeff3d51$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $ecddad0aaeff3d51$export$b6aa1f30c53d7454
    }
};
class $ecddad0aaeff3d51$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $ecddad0aaeff3d51$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $ecddad0aaeff3d51$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $ecddad0aaeff3d51$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $ecddad0aaeff3d51$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $ecddad0aaeff3d51$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $ecddad0aaeff3d51$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $ecddad0aaeff3d51$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $ecddad0aaeff3d51$var$noop
};
const $ecddad0aaeff3d51$var$InternalContext = /*#__PURE__*/ (0, $7fPBF.createContext)($ecddad0aaeff3d51$var$defaultInternalContext);
const $ecddad0aaeff3d51$var$PublicContext = /*#__PURE__*/ (0, $7fPBF.createContext)($ecddad0aaeff3d51$var$defaultPublicContext);
function $ecddad0aaeff3d51$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $ecddad0aaeff3d51$var$DroppableContainersMap()
        }
    };
}
function $ecddad0aaeff3d51$var$reducer(state, action) {
    switch(action.type){
        case $ecddad0aaeff3d51$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $ecddad0aaeff3d51$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $ecddad0aaeff3d51$var$Action.DragEnd:
        case $ecddad0aaeff3d51$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $ecddad0aaeff3d51$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $ecddad0aaeff3d51$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $ecddad0aaeff3d51$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $ecddad0aaeff3d51$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $ecddad0aaeff3d51$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const previousActivatorEvent = (0, $1m8VR.usePrevious)(activatorEvent);
    const previousActiveId = (0, $1m8VR.usePrevious)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $7fPBF.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $1m8VR.isKeyboardEvent)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $1m8VR.findFirstFocusableNode)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $ecddad0aaeff3d51$var$useMeasuringConfiguration(config) {
    return (0, $7fPBF.useMemo)(()=>({
            draggable: {
                ...$ecddad0aaeff3d51$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$ecddad0aaeff3d51$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$ecddad0aaeff3d51$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $ecddad0aaeff3d51$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $7fPBF.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $ecddad0aaeff3d51$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $ecddad0aaeff3d51$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $ecddad0aaeff3d51$var$ActiveDraggableContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    ...$ecddad0aaeff3d51$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $ecddad0aaeff3d51$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($ecddad0aaeff3d51$var$Status || ($ecddad0aaeff3d51$var$Status = {}));
const $ecddad0aaeff3d51$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $7fPBF.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $ecddad0aaeff3d51$var$defaultSensors, collisionDetection: collisionDetection = $ecddad0aaeff3d51$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $7fPBF.useReducer)($ecddad0aaeff3d51$var$reducer, undefined, $ecddad0aaeff3d51$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $ecddad0aaeff3d51$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $7fPBF.useState)($ecddad0aaeff3d51$var$Status.Uninitialized);
    const isInitialized = status === $ecddad0aaeff3d51$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $7fPBF.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $7fPBF.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $ecddad0aaeff3d51$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $7fPBF.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $7fPBF.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $7fPBF.useState)(null);
    const latestProps = (0, $1m8VR.useLatestValue)(props, Object.values(props));
    const draggableDescribedById = (0, $1m8VR.useUniqueId)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $7fPBF.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $ecddad0aaeff3d51$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $ecddad0aaeff3d51$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $ecddad0aaeff3d51$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $7fPBF.useMemo)(()=>activatorEvent ? (0, $1m8VR.getEventCoordinates)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $ecddad0aaeff3d51$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $ecddad0aaeff3d51$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $ecddad0aaeff3d51$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $ecddad0aaeff3d51$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $7fPBF.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $ecddad0aaeff3d51$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $ecddad0aaeff3d51$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $ecddad0aaeff3d51$var$useWindowRect(draggingNode ? (0, $1m8VR.getWindow)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $ecddad0aaeff3d51$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $ecddad0aaeff3d51$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $1m8VR.add)(activationCoordinates, translate) : null;
    const scrollOffsets = $ecddad0aaeff3d51$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $ecddad0aaeff3d51$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $1m8VR.add)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $ecddad0aaeff3d51$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $ecddad0aaeff3d51$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $7fPBF.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $1m8VR.add)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $ecddad0aaeff3d51$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $7fPBF.useRef)(null);
    const instantiateSensor = (0, $7fPBF.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $fw0lo.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($ecddad0aaeff3d51$var$Status.Initializing);
                    dispatch({
                        type: $ecddad0aaeff3d51$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $ecddad0aaeff3d51$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($ecddad0aaeff3d51$var$Action.DragEnd),
            onCancel: createHandler($ecddad0aaeff3d51$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $ecddad0aaeff3d51$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $ecddad0aaeff3d51$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $fw0lo.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($ecddad0aaeff3d51$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $ecddad0aaeff3d51$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $7fPBF.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $ecddad0aaeff3d51$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $ecddad0aaeff3d51$var$useSensorSetup(sensors);
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        if (activeNodeRect && status === $ecddad0aaeff3d51$var$Status.Initializing) setStatus($ecddad0aaeff3d51$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $fw0lo.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $ecddad0aaeff3d51$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $7fPBF.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $7fPBF.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $ecddad0aaeff3d51$var$NullContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $ecddad0aaeff3d51$var$defaultRole = 'button';
const $ecddad0aaeff3d51$var$ID_PREFIX = 'Draggable';
function $ecddad0aaeff3d51$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $1m8VR.useUniqueId)($ecddad0aaeff3d51$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const { role: role = $ecddad0aaeff3d51$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $7fPBF.useContext)(isDragging ? $ecddad0aaeff3d51$var$ActiveDraggableContext : $ecddad0aaeff3d51$var$NullContext);
    const [node, setNodeRef] = (0, $1m8VR.useNodeRef)();
    const [activatorNode, setActivatorNodeRef] = (0, $1m8VR.useNodeRef)();
    const listeners = $ecddad0aaeff3d51$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $1m8VR.useLatestValue)(data);
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $7fPBF.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $ecddad0aaeff3d51$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $ecddad0aaeff3d51$export$4930f6bf413be70e() {
    return (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$PublicContext);
}
const $ecddad0aaeff3d51$var$ID_PREFIX$1 = 'Droppable';
const $ecddad0aaeff3d51$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $ecddad0aaeff3d51$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $1m8VR.useUniqueId)($ecddad0aaeff3d51$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$InternalContext);
    const previous = (0, $7fPBF.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $7fPBF.useRef)(false);
    const rect = (0, $7fPBF.useRef)(null);
    const callbackId = (0, $7fPBF.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$ecddad0aaeff3d51$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $1m8VR.useLatestValue)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $7fPBF.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $ecddad0aaeff3d51$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $7fPBF.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $1m8VR.useNodeRef)(handleNodeChange);
    const dataRef = (0, $1m8VR.useLatestValue)(data);
    (0, $7fPBF.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $7fPBF.useEffect)(()=>{
        dispatch({
            type: $ecddad0aaeff3d51$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $ecddad0aaeff3d51$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $ecddad0aaeff3d51$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $ecddad0aaeff3d51$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $7fPBF.useState)(null);
    const [element, setElement] = (0, $7fPBF.useState)(null);
    const previousChildren = (0, $1m8VR.usePrevious)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children, clonedChildren ? (0, $7fPBF.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $ecddad0aaeff3d51$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $ecddad0aaeff3d51$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$InternalContext.Provider, {
        value: $ecddad0aaeff3d51$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$ActiveDraggableContext.Provider, {
        value: $ecddad0aaeff3d51$var$defaultTransform
    }, children));
}
const $ecddad0aaeff3d51$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $ecddad0aaeff3d51$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $1m8VR.isKeyboardEvent)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $ecddad0aaeff3d51$var$PositionedOverlay = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $ecddad0aaeff3d51$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$ecddad0aaeff3d51$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $1m8VR.CSS).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $ecddad0aaeff3d51$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $ecddad0aaeff3d51$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $ecddad0aaeff3d51$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $1m8VR.CSS).Transform.toString(initial)
        },
        {
            transform: (0, $1m8VR.CSS).Transform.toString(final)
        }
    ];
};
const $ecddad0aaeff3d51$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $ecddad0aaeff3d51$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $ecddad0aaeff3d51$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $ecddad0aaeff3d51$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $1m8VR.useEvent)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $ecddad0aaeff3d51$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $1m8VR.getWindow)(node).getComputedStyle(node);
        const parsedTransform = $ecddad0aaeff3d51$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $ecddad0aaeff3d51$var$createDefaultDropAnimation(config);
        $ecddad0aaeff3d51$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $ecddad0aaeff3d51$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$ecddad0aaeff3d51$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $ecddad0aaeff3d51$var$key = 0;
function $ecddad0aaeff3d51$var$useKey(id) {
    return (0, $7fPBF.useMemo)(()=>{
        if (id == null) return;
        $ecddad0aaeff3d51$var$key++;
        return $ecddad0aaeff3d51$var$key;
    }, [
        id
    ]);
}
const $ecddad0aaeff3d51$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $ecddad0aaeff3d51$export$4930f6bf413be70e();
    const transform = (0, $7fPBF.useContext)($ecddad0aaeff3d51$var$ActiveDraggableContext);
    const key = $ecddad0aaeff3d51$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $ecddad0aaeff3d51$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $ecddad0aaeff3d51$var$useInitialValue(activeNodeRect);
    const dropAnimation = $ecddad0aaeff3d51$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ecddad0aaeff3d51$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});

});
parcelRegister("1m8VR", function(module, exports) {

$parcel$export(module.exports, "useCombinedRefs", function () { return $0fcec64c9b7e118d$export$2f8294366bb2d67a; });
$parcel$export(module.exports, "canUseDOM", function () { return $0fcec64c9b7e118d$export$71594e8a50f746f4; });
$parcel$export(module.exports, "isWindow", function () { return $0fcec64c9b7e118d$export$5a096129d439f843; });
$parcel$export(module.exports, "isNode", function () { return $0fcec64c9b7e118d$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "getWindow", function () { return $0fcec64c9b7e118d$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "isDocument", function () { return $0fcec64c9b7e118d$export$62858bae88b53fd0; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0fcec64c9b7e118d$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isSVGElement", function () { return $0fcec64c9b7e118d$export$17eda790a720ec57; });
$parcel$export(module.exports, "getOwnerDocument", function () { return $0fcec64c9b7e118d$export$b204af158042fbac; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $0fcec64c9b7e118d$export$700979bc83e7db82; });
$parcel$export(module.exports, "useEvent", function () { return $0fcec64c9b7e118d$export$90fc3a17d93f704c; });
$parcel$export(module.exports, "useInterval", function () { return $0fcec64c9b7e118d$export$f4b266cd2aae9cb1; });
$parcel$export(module.exports, "useLatestValue", function () { return $0fcec64c9b7e118d$export$86c4283a11f23f95; });
$parcel$export(module.exports, "useLazyMemo", function () { return $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1; });
$parcel$export(module.exports, "useNodeRef", function () { return $0fcec64c9b7e118d$export$bc23c270f170c912; });
$parcel$export(module.exports, "usePrevious", function () { return $0fcec64c9b7e118d$export$5cae361ad82dce8b; });
$parcel$export(module.exports, "useUniqueId", function () { return $0fcec64c9b7e118d$export$c485849f2e393253; });
$parcel$export(module.exports, "add", function () { return $0fcec64c9b7e118d$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "isKeyboardEvent", function () { return $0fcec64c9b7e118d$export$130b789831072f4c; });
$parcel$export(module.exports, "getEventCoordinates", function () { return $0fcec64c9b7e118d$export$36195c8aa1517e04; });
$parcel$export(module.exports, "CSS", function () { return $0fcec64c9b7e118d$export$c4ffa16951855e28; });
$parcel$export(module.exports, "findFirstFocusableNode", function () { return $0fcec64c9b7e118d$export$44f71d798fd0a62b; });

var $7fPBF = parcelRequire("7fPBF");
function $0fcec64c9b7e118d$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $7fPBF.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $0fcec64c9b7e118d$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $0fcec64c9b7e118d$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $0fcec64c9b7e118d$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($0fcec64c9b7e118d$export$5a096129d439f843(target)) return target;
    if (!$0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $0fcec64c9b7e118d$export$62858bae88b53fd0(node) {
    const { Document: Document } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $0fcec64c9b7e118d$export$1b3bfaa9684536aa(node) {
    if ($0fcec64c9b7e118d$export$5a096129d439f843(node)) return false;
    return node instanceof $0fcec64c9b7e118d$export$38b2d434cce3ea22(node).HTMLElement;
}
function $0fcec64c9b7e118d$export$17eda790a720ec57(node) {
    return node instanceof $0fcec64c9b7e118d$export$38b2d434cce3ea22(node).SVGElement;
}
function $0fcec64c9b7e118d$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($0fcec64c9b7e118d$export$5a096129d439f843(target)) return target.document;
    if (!$0fcec64c9b7e118d$export$8ee0fc9ee280b4ee(target)) return document;
    if ($0fcec64c9b7e118d$export$62858bae88b53fd0(target)) return target;
    if ($0fcec64c9b7e118d$export$1b3bfaa9684536aa(target) || $0fcec64c9b7e118d$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $0fcec64c9b7e118d$export$700979bc83e7db82 = $0fcec64c9b7e118d$export$71594e8a50f746f4 ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $0fcec64c9b7e118d$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $7fPBF.useRef)(handler);
    $0fcec64c9b7e118d$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $7fPBF.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $0fcec64c9b7e118d$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $7fPBF.useRef)(null);
    const set = (0, $7fPBF.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $7fPBF.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $0fcec64c9b7e118d$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $7fPBF.useRef)(value);
    $0fcec64c9b7e118d$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $0fcec64c9b7e118d$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $7fPBF.useRef)();
    return (0, $7fPBF.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $0fcec64c9b7e118d$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $0fcec64c9b7e118d$export$90fc3a17d93f704c(onChange);
    const node = (0, $7fPBF.useRef)(null);
    const setNodeRef = (0, $7fPBF.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $0fcec64c9b7e118d$export$5cae361ad82dce8b(value) {
    const ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $0fcec64c9b7e118d$var$ids = {};
function $0fcec64c9b7e118d$export$c485849f2e393253(prefix, value) {
    return (0, $7fPBF.useMemo)(()=>{
        if (value) return value;
        const id = $0fcec64c9b7e118d$var$ids[prefix] == null ? 0 : $0fcec64c9b7e118d$var$ids[prefix] + 1;
        $0fcec64c9b7e118d$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $0fcec64c9b7e118d$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $0fcec64c9b7e118d$export$e16d8520af44a096 = /*#__PURE__*/ $0fcec64c9b7e118d$var$createAdjustmentFn(1);
const $0fcec64c9b7e118d$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $0fcec64c9b7e118d$var$createAdjustmentFn(-1);
function $0fcec64c9b7e118d$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $0fcec64c9b7e118d$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $0fcec64c9b7e118d$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $0fcec64c9b7e118d$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $0fcec64c9b7e118d$export$36195c8aa1517e04(event) {
    if ($0fcec64c9b7e118d$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($0fcec64c9b7e118d$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $0fcec64c9b7e118d$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $0fcec64c9b7e118d$export$c4ffa16951855e28.Translate.toString(transform),
                $0fcec64c9b7e118d$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $0fcec64c9b7e118d$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $0fcec64c9b7e118d$export$44f71d798fd0a62b(element) {
    if (element.matches($0fcec64c9b7e118d$var$SELECTOR)) return element;
    return element.querySelector($0fcec64c9b7e118d$var$SELECTOR);
}

});

parcelRegister("kl7pE", function(module, exports) {

$parcel$export(module.exports, "HiddenText", function () { return $eceb84cdc2b532ec$export$1496ac55023363a5; });
$parcel$export(module.exports, "LiveRegion", function () { return $eceb84cdc2b532ec$export$ae99b902be98b17; });
$parcel$export(module.exports, "useAnnouncement", function () { return $eceb84cdc2b532ec$export$97d78af8d95ca8bd; });

var $7fPBF = parcelRequire("7fPBF");
const $eceb84cdc2b532ec$var$hiddenStyles = {
    display: 'none'
};
function $eceb84cdc2b532ec$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id,
        style: $eceb84cdc2b532ec$var$hiddenStyles
    }, value);
}
function $eceb84cdc2b532ec$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $eceb84cdc2b532ec$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $7fPBF.useState)('');
    const announce = (0, $7fPBF.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}

});


parcelRegister("gyOLv", function(module, exports) {

$parcel$export(module.exports, "restrictToVerticalAxis", function () { return $c0e7333d10974924$export$1ed98a87b7c51b89; });

var $1m8VR = parcelRequire("1m8VR");
function $c0e7333d10974924$export$7f11ea1f0ba255b5(gridSize) {
    return (_ref)=>{
        let { transform: transform } = _ref;
        return {
            ...transform,
            x: Math.ceil(transform.x / gridSize) * gridSize,
            y: Math.ceil(transform.y / gridSize) * gridSize
        };
    };
}
const $c0e7333d10974924$export$29320759dd5f3702 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        y: 0
    };
};
function $c0e7333d10974924$var$restrictToBoundingRect(transform, rect, boundingRect) {
    const value = {
        ...transform
    };
    if (rect.top + transform.y <= boundingRect.top) value.y = boundingRect.top - rect.top;
    else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - rect.bottom;
    if (rect.left + transform.x <= boundingRect.left) value.x = boundingRect.left - rect.left;
    else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - rect.right;
    return value;
}
const $c0e7333d10974924$export$c7685f801ed492b5 = (_ref)=>{
    let { containerNodeRect: containerNodeRect, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (!draggingNodeRect || !containerNodeRect) return transform;
    return $c0e7333d10974924$var$restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
const $c0e7333d10974924$export$85bf625d52c1d097 = (_ref)=>{
    let { draggingNodeRect: draggingNodeRect, transform: transform, scrollableAncestorRects: scrollableAncestorRects } = _ref;
    const firstScrollableAncestorRect = scrollableAncestorRects[0];
    if (!draggingNodeRect || !firstScrollableAncestorRect) return transform;
    return $c0e7333d10974924$var$restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
const $c0e7333d10974924$export$1ed98a87b7c51b89 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        x: 0
    };
};
const $c0e7333d10974924$export$57196ad89f591aab = (_ref)=>{
    let { transform: transform, draggingNodeRect: draggingNodeRect, windowRect: windowRect } = _ref;
    if (!draggingNodeRect || !windowRect) return transform;
    return $c0e7333d10974924$var$restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
const $c0e7333d10974924$export$70a75ea36ecd3098 = (_ref)=>{
    let { activatorEvent: activatorEvent, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (draggingNodeRect && activatorEvent) {
        const activatorCoordinates = (0, $1m8VR.getEventCoordinates)(activatorEvent);
        if (!activatorCoordinates) return transform;
        const offsetX = activatorCoordinates.x - draggingNodeRect.left;
        const offsetY = activatorCoordinates.y - draggingNodeRect.top;
        return {
            ...transform,
            x: transform.x + offsetX - draggingNodeRect.width / 2,
            y: transform.y + offsetY - draggingNodeRect.height / 2
        };
    }
    return transform;
};

});

parcelRegister("dQqd9", function(module, exports) {

$parcel$export(module.exports, "verticalListSortingStrategy", function () { return $a14476affb27f7d7$export$fe2be640df2ffb9e; });
$parcel$export(module.exports, "SortableContext", function () { return $a14476affb27f7d7$export$86155fde54f06e6a; });
$parcel$export(module.exports, "useSortable", function () { return $a14476affb27f7d7$export$4ebcb6201122185a; });
$parcel$export(module.exports, "sortableKeyboardCoordinates", function () { return $a14476affb27f7d7$export$a6f27ecf02eb3a67; });

var $7fPBF = parcelRequire("7fPBF");

var $kkPzd = parcelRequire("kkPzd");

var $1m8VR = parcelRequire("1m8VR");
/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $a14476affb27f7d7$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $a14476affb27f7d7$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $a14476affb27f7d7$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $a14476affb27f7d7$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $a14476affb27f7d7$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $a14476affb27f7d7$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $a14476affb27f7d7$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $a14476affb27f7d7$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $a14476affb27f7d7$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$a14476affb27f7d7$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$a14476affb27f7d7$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$a14476affb27f7d7$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$a14476affb27f7d7$var$defaultScale
    };
};
function $a14476affb27f7d7$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $a14476affb27f7d7$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $a14476affb27f7d7$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $a14476affb27f7d7$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $a14476affb27f7d7$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $a14476affb27f7d7$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$a14476affb27f7d7$var$defaultScale$1
        };
    }
    const itemGap = $a14476affb27f7d7$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$a14476affb27f7d7$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$a14476affb27f7d7$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$a14476affb27f7d7$var$defaultScale$1
    };
};
function $a14476affb27f7d7$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $a14476affb27f7d7$var$ID_PREFIX = 'Sortable';
const $a14476affb27f7d7$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext({
    activeIndex: -1,
    containerId: $a14476affb27f7d7$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $a14476affb27f7d7$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $a14476affb27f7d7$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $a14476affb27f7d7$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $kkPzd.useDndContext)();
    const containerId = (0, $1m8VR.useUniqueId)($a14476affb27f7d7$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $7fPBF.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $7fPBF.useRef)(items);
    const itemsHaveChanged = !$a14476affb27f7d7$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $a14476affb27f7d7$var$normalizeDisabled(disabledProp);
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $a14476affb27f7d7$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($a14476affb27f7d7$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $a14476affb27f7d7$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $a14476affb27f7d7$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $a14476affb27f7d7$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $a14476affb27f7d7$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $a14476affb27f7d7$var$transitionProperty = 'transform';
const $a14476affb27f7d7$var$disabledTransition = /*#__PURE__*/ (0, $1m8VR.CSS).Transition.toString({
    property: $a14476affb27f7d7$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $a14476affb27f7d7$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $a14476affb27f7d7$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $7fPBF.useState)(null);
    const previousIndex = (0, $7fPBF.useRef)(index);
    (0, $1m8VR.useIsomorphicLayoutEffect)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $kkPzd.getClientRect)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $a14476affb27f7d7$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $a14476affb27f7d7$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $a14476affb27f7d7$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $a14476affb27f7d7$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $7fPBF.useContext)($a14476affb27f7d7$var$Context);
    const disabled = $a14476affb27f7d7$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $7fPBF.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $7fPBF.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $kkPzd.useDroppable)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $kkPzd.useDraggable)({
        id: id,
        data: data,
        attributes: {
            ...$a14476affb27f7d7$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $1m8VR.useCombinedRefs)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $a14476affb27f7d7$var$isValidIndex(activeIndex) && $a14476affb27f7d7$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $a14476affb27f7d7$var$isValidIndex(activeIndex) && $a14476affb27f7d7$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $7fPBF.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $a14476affb27f7d7$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $7fPBF.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $a14476affb27f7d7$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $1m8VR.isKeyboardEvent)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $1m8VR.CSS).Transition.toString({
            ...transition,
            property: $a14476affb27f7d7$var$transitionProperty
        });
        return undefined;
    }
}
function $a14476affb27f7d7$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $a14476affb27f7d7$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $a14476affb27f7d7$var$directions = [
    (0, $kkPzd.KeyboardCode).Down,
    (0, $kkPzd.KeyboardCode).Right,
    (0, $kkPzd.KeyboardCode).Up,
    (0, $kkPzd.KeyboardCode).Left
];
const $a14476affb27f7d7$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($a14476affb27f7d7$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $kkPzd.KeyboardCode).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $kkPzd.KeyboardCode).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $kkPzd.KeyboardCode).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $kkPzd.KeyboardCode).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $kkPzd.closestCorners)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $kkPzd.getFirstCollision)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $kkPzd.getScrollableAncestors)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $a14476affb27f7d7$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $a14476affb27f7d7$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $1m8VR.subtract)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $a14476affb27f7d7$var$isSameContainer(a, b) {
    if (!$a14476affb27f7d7$export$6424ec8a0d450b09(a) || !$a14476affb27f7d7$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $a14476affb27f7d7$var$isAfter(a, b) {
    if (!$a14476affb27f7d7$export$6424ec8a0d450b09(a) || !$a14476affb27f7d7$export$6424ec8a0d450b09(b)) return false;
    if (!$a14476affb27f7d7$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}

});

parcelRegister("9LtqM", function(module, exports) {

$parcel$export(module.exports, "SortableListItem", function () { return $3510a34009ee2472$export$3548239ca3a82858; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $dQqd9 = parcelRequire("dQqd9");

var $1m8VR = parcelRequire("1m8VR");

var $ggWrA = parcelRequire("ggWrA");

var $agWKd = parcelRequire("agWKd");
/**
 * Drag handle button for sortable list items.
 *
 * @param props - The component props
 * @param props.listeners - Event listeners for drag interactions
 * @param props.maxHeight - Optional maximum height for the grip container
 */ const $3510a34009ee2472$var$ButtonGrip = ({ listeners: listeners, maxHeight: maxHeight })=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($agWKd))).sortableItemGripHolder,
        ...listeners,
        role: "button",
        style: {
            maxHeight: maxHeight !== undefined ? `${maxHeight}px` : "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ggWrA.default), {})
    });
$3510a34009ee2472$var$ButtonGrip.displayName = "ButtonGrip";
function $3510a34009ee2472$export$3548239ca3a82858({ id: id, canMove: canMove, children: children, maxHeight: maxHeight, showBorder: showBorder = true }) {
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition } = (0, $dQqd9.useSortable)({
        id: id
    });
    const style = {
        transform: (0, $1m8VR.CSS).Translate.toString(transform),
        transition: transition
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ref: setNodeRef,
        ...attributes,
        role: "tab",
        style: style,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.AutoHeight), {
            hide: maxHeight === 0,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                children: [
                    canMove && /*#__PURE__*/ (0, $bbzbN.jsx)($3510a34009ee2472$var$ButtonGrip, {
                        listeners: listeners,
                        maxHeight: maxHeight
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($agWKd))).sortableItemAfterGrip,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: showBorder ? `m-1 ${(0, (/*@__PURE__*/$parcel$interopDefault($agWKd))).sortableItemBorder}` : "m-1",
                            children: children
                        })
                    })
                ]
            })
        })
    });
}
$3510a34009ee2472$export$3548239ca3a82858.displayName = "SortableListItem";

});
parcelRegister("ggWrA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8b79bd60c1764f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $bd8b79bd60c1764f$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $bd8b79bd60c1764f$var$_extends() {
    return $bd8b79bd60c1764f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bd8b79bd60c1764f$var$_extends.apply(null, arguments);
}
function $bd8b79bd60c1764f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bd8b79bd60c1764f$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bd8b79bd60c1764f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bd8b79bd60c1764f$var$GripVertical = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $bd8b79bd60c1764f$var$_objectWithoutProperties(_ref, $bd8b79bd60c1764f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $bd8b79bd60c1764f$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-grip-vertical',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$bd8b79bd60c1764f$var$GripVertical.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $bd8b79bd60c1764f$export$2e2bcd8739ae039 = $bd8b79bd60c1764f$var$GripVertical;

});

parcelRegister("agWKd", function(module, exports) {

$parcel$export(module.exports, "sortableItemAfterGrip", function () { return $77a8f767be0903ca$export$289a2c9e71ad6f06; }, function (v) { return $77a8f767be0903ca$export$289a2c9e71ad6f06 = v; });
$parcel$export(module.exports, "sortableItemBorder", function () { return $77a8f767be0903ca$export$471747347fece6a; }, function (v) { return $77a8f767be0903ca$export$471747347fece6a = v; });
$parcel$export(module.exports, "sortableItemGripHolder", function () { return $77a8f767be0903ca$export$585fa63c8a467d37; }, function (v) { return $77a8f767be0903ca$export$585fa63c8a467d37 = v; });
var $77a8f767be0903ca$export$289a2c9e71ad6f06;
var $77a8f767be0903ca$export$471747347fece6a;
var $77a8f767be0903ca$export$585fa63c8a467d37;
$77a8f767be0903ca$export$289a2c9e71ad6f06 = `mos-SortableList-module-fytC_a-sortableItemAfterGrip`;
$77a8f767be0903ca$export$471747347fece6a = `mos-SortableList-module-fytC_a-sortableItemBorder`;
$77a8f767be0903ca$export$585fa63c8a467d37 = `mos-SortableList-module-fytC_a-sortableItemGripHolder`;

});




parcelRegister("0PqYf", function(module, exports) {
$parcel$export(module.exports, "ArsSelect", function () { return (parcelRequire("h7VrC")).ArsSelect; });
$parcel$export(module.exports, "ArsText", function () { return (parcelRequire("3EZep")).ArsText; });
$parcel$export(module.exports, "ArsVariable", function () { return (parcelRequire("eUQaa")).ArsVariable; });
parcelRequire("h7VrC");
parcelRequire("3EZep");
parcelRequire("eUQaa");

});
parcelRegister("h7VrC", function(module, exports) {

$parcel$export(module.exports, "ArsSelect", function () { return $63aa29a092ee81ff$export$2a6c033596672218; });

var $bbzbN = parcelRequire("bbzbN");

var $6hWPd = parcelRequire("6hWPd");

var $isQD0 = parcelRequire("isQD0");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
parcelRequire("loI62");
var $i3Ps9 = parcelRequire("i3Ps9");

var $6Llki = parcelRequire("6Llki");
const $63aa29a092ee81ff$export$2a6c033596672218 = ({ dataPath: dataPath, options: options, tableDataPath: tableDataPath = false, ...rest })=>{
    const ars = (0, $fZCs4.useArsContext)();
    const table = (0, $6Llki.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    // Get the current value from state using the dataPath
    const pointer = (0, $6hWPd.Pointer).fromJSON(dataPath);
    const value = pointer.get(sourceState) ?? "";
    // Get all available values
    const availableValues = options.map((opt)=>typeof opt === "string" ? opt : opt.value);
    // Add current value to options at the start of the list if it's not already present
    if (!availableValues.includes(value)) {
        if (typeof options[0] === "string" || options.length === 0) options = [
            value,
            ...options
        ];
        else options = [
            {
                value: value,
                label: value
            },
            ...options
        ];
    }
    /**
   * Handle selection change by dispatching PATCH_ARS_STATE action.
   *
   * @param newValue - The new value to set.
   */ const handleChange = (newValue)=>{
        if (newValue !== "-- None --") {
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: dataPath,
                value: newValue
            });
            else table.dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                dataPath: dataPath,
                value: newValue
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
        labelWidth: 2,
        options: options,
        setValue: handleChange,
        value: value,
        ...rest
    });
};
$63aa29a092ee81ff$export$2a6c033596672218.displayName = "ArsSelect";

});
parcelRegister("loI62", function(module, exports) {
$parcel$export(module.exports, "ArsTable", function () { return (parcelRequire("3Q1wz")).ArsTable; });
$parcel$export(module.exports, "ARST_PATCH_DATA", function () { return (parcelRequire("i3Ps9")).ARST_PATCH_DATA; });
$parcel$export(module.exports, "ArsTableCellType", function () { return (parcelRequire("i3Ps9")).ArsTableCellType; });
$parcel$export(module.exports, "ArsTextJustification", function () { return (parcelRequire("i3Ps9")).ArsTextJustification; });
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("GtyWr")).isArsTableBody; });
parcelRequire("3Q1wz");
parcelRequire("4dESf");
parcelRequire("8GZ3J");
parcelRequire("bT9kO");
parcelRequire("heZv5");
parcelRequire("kDPjn");
parcelRequire("i3Ps9");
parcelRequire("2YSoS");

});
parcelRegister("3Q1wz", function(module, exports) {

$parcel$export(module.exports, "ArsTable", function () { return $ec7b645eee441a6c$export$7a45b4d483fef7bf; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");

var $1NxUJ = parcelRequire("1NxUJ");

var $6Llki = parcelRequire("6Llki");

var $i3Ps9 = parcelRequire("i3Ps9");
const $ec7b645eee441a6c$export$7a45b4d483fef7bf = ({ id: id = "ars-table", arsTableBody: arsTableBody, calculatedTableRows: calculatedTableRows, disabled: disabled = false, editorProps: editorProps = (0, $jP37Y.defaultEditorDefns), justification: justification = (0, $i3Ps9.ArsTableJustification).Center, sidebarStyle: sidebarStyle, style: style, tlfViewMode: tlfViewMode, updateArsTableBody: updateArsTableBody })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6Llki.ArsTableContextProvider), {
        bodyData: arsTableBody,
        calculatedTableRows: calculatedTableRows,
        updateBodyData: updateArsTableBody,
        settings: {
            id: id,
            disabled: disabled,
            editorProps: editorProps,
            justification: justification,
            sidebarStyle: sidebarStyle,
            style: style,
            tlfViewMode: tlfViewMode
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1NxUJ.ArsTableContent), {})
    });
};
$ec7b645eee441a6c$export$7a45b4d483fef7bf.displayName = "ArsTable";

});
parcelRegister("1NxUJ", function(module, exports) {

$parcel$export(module.exports, "ArsTableContent", function () { return $4fefb578c8b7432c$export$26fdf0e2e5a3507d; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("6rtuc");
var $3k2bR = parcelRequire("3k2bR");
parcelRequire("kevCO");
var $clOgJ = parcelRequire("clOgJ");

var $2FEZT = parcelRequire("2FEZT");

var $4dESf = parcelRequire("4dESf");

var $1MNbD = parcelRequire("1MNbD");

var $6Llki = parcelRequire("6Llki");

var $8GZ3J = parcelRequire("8GZ3J");

var $diMS5 = parcelRequire("diMS5");

var $heZv5 = parcelRequire("heZv5");
parcelRequire("kDPjn");
var $4bSb7 = parcelRequire("4bSb7");

var $i3Ps9 = parcelRequire("i3Ps9");
const $4fefb578c8b7432c$export$26fdf0e2e5a3507d = ()=>{
    const { state: state, dispatch: dispatch } = (0, $6Llki.useArsTable)();
    const disabled = state?.settings.disabled;
    const justification = state?.settings.justification;
    const scaffoldModel = state?.scaffoldModel;
    const [dragItem, setDragItem] = (0, $7fPBF.useState)(null);
    // Return if things are missing
    if (!state || !scaffoldModel) return null;
    const zoneColors = (0, $4bSb7.buildArsTableZoneColors)(state, dragItem?.[0]?.kind ?? null);
    /**
   * Handles scaffold drop events by building and dispatching table-drop actions.
   *
   * @param event - Drop event
   * @param rowId - Target row id
   * @param colId - Target column id
   * @param zone - Drop zone within the target cell
   */ const handleScaffoldDrop = (event, rowId, colId, zone)=>{
        if (!disabled && state && state.scaffoldModel) {
            event.preventDefault();
            try {
                // Parse dropped data from the drag event
                const jsonPayload = JSON.parse(event.dataTransfer.getData("application/json"));
                // Validate the parsed data
                if (jsonPayload.data.every((0, $clOgJ.isArsSidebarItemData))) {
                    const payload = jsonPayload.data;
                    // Check all payload items are the same kind
                    const firstKind = payload[0].kind;
                    if (!payload.every((item)=>item.kind === firstKind)) return;
                    // Get target cell data
                    const targetCell = state.scaffoldModel.cellData?.[rowId]?.[colId];
                    // Now we have enough information to create the action payload
                    if (targetCell) {
                        // Get the cell config for the target cell type
                        const cellConfig = (0, $heZv5.cellActionConfig)(targetCell, state);
                        // Get the action for this zone & dropped data
                        const matchedDropAction = cellConfig?.dropActions.find((action)=>action.dropZones.has(zone) && action.droppedDataKinds.includes(firstKind));
                        if (matchedDropAction) dispatch({
                            operation: matchedDropAction.operation,
                            rowId: rowId,
                            columnId: colId,
                            payload: payload,
                            zone: zone
                        });
                    }
                }
            } catch  {
                return;
            }
        }
    };
    /**
   * Handles scaffold column resize updates.
   *
   * @param colId - Resized column id
   * @param col - Updated scaffold column definition
   */ const handleChangeCol = (colId, col)=>{
        if (!disabled) dispatch({
            operation: (0, $i3Ps9.ARST_SET_SCAFFOLD_COL_WIDTH),
            colId: colId,
            width: col.width
        });
    };
    /**
   * Handles scaffold row resize updates.
   *
   * @param rowId - Resized row id
   * @param row - Updated scaffold row definition
   */ const handleChangeRow = (rowId, row)=>{
        if (!disabled) dispatch({
            operation: (0, $i3Ps9.ARST_SET_SCAFFOLD_ROW_HEIGHT),
            rowId: rowId,
            height: row.height
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "d-flex flex-row",
                style: {
                    width: "100%",
                    minWidth: 0,
                    minHeight: "500px"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "flex-grow-1",
                    style: {
                        minWidth: 0
                    },
                    children: [
                        "TLF",
                        "ANNOTATIONS"
                    ].includes(state.settings.tlfViewMode.value) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1MNbD.ArsTableContextMenuProvider), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3k2bR.Scaffold), {
                            id: `ars-table-scaffold-${state.settings.id}`,
                            cellComponent: (0, $4dESf.ArsTableCellEditorProps)(state.settings.editorProps),
                            cellData: scaffoldModel.cellData,
                            columns: scaffoldModel.columns,
                            disabled: disabled,
                            headerCellSpans: scaffoldModel.headerColSpans,
                            justification: justification,
                            onChangeCol: handleChangeCol,
                            onChangeRow: handleChangeRow,
                            onDrop: handleScaffoldDrop,
                            rows: scaffoldModel.rows,
                            style: state.settings.style,
                            zoneColors: zoneColors
                        })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $diMS5.ArsTableTreeView), {})
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2FEZT.ArsDraggableSidebar), {
                onItemDragStart: (items)=>setDragItem(items.map((i)=>i.data)),
                onItemDragEnd: ()=>setDragItem(null),
                showGroupingFactors: true,
                showOperations: true,
                showTotalGroupingFactor: true,
                style: state.settings.sidebarStyle
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8GZ3J.ArsTableItemProperties), {})
        ]
    });
};
$4fefb578c8b7432c$export$26fdf0e2e5a3507d.displayName = "ArsTableContent";

});
parcelRegister("6rtuc", function(module, exports) {
$parcel$export(module.exports, "ScaffoldDropZone", function () { return (parcelRequire("4zamZ")).ScaffoldDropZone; });
$parcel$export(module.exports, "Scaffold", function () { return (parcelRequire("3k2bR")).Scaffold; });
parcelRequire("6sNBS");
parcelRequire("2wRcQ");
parcelRequire("7j5F4");
parcelRequire("4zamZ");
parcelRequire("3k2bR");
parcelRequire("2efi6");
parcelRequire("kZbhv");
parcelRequire("iQhKl");
parcelRequire("98R3j");
parcelRequire("1UWJN");
parcelRequire("1xmT4");
parcelRequire("jV9ZK");
parcelRequire("hQZyf");

});
parcelRegister("6sNBS", function(module, exports) {

$parcel$export(module.exports, "computeHeaderSpanState", function () { return $7dc8689f9b24ae21$export$572859033bdbdb98; });
function $7dc8689f9b24ae21$export$572859033bdbdb98(rows, cols, spans, previewColWidths, previewRowHeights) {
    if (!spans) return {};
    const orderedCols = [
        ...cols
    ].sort((a, b)=>a.colNumber - b.colNumber);
    /** Rows grouped by rowGroupNumber, each group sorted by rowNumber. */ const rowsByGroup = rows.reduce((acc, row)=>{
        if (!acc[row.rowGroupNumber]) acc[row.rowGroupNumber] = [];
        acc[row.rowGroupNumber].push(row);
        return acc;
    }, {});
    for (const group of Object.values(rowsByGroup))group.sort((a, b)=>a.rowNumber - b.rowNumber);
    const result = {};
    /**
   * Stores cells that are covered by a spanning cell from the same row (colSpan) or a
   * previous row (rowSpan). Keyed as "rowId:colId".
   * Value "same-row" means col-span covered; "other-row" means row-span covered.
   */ const coveredCells = new Map();
    for (const row of rows){
        const rowSpanDefs = spans[row.id];
        if (!rowSpanDefs) continue;
        for (const col of orderedCols){
            const span = rowSpanDefs[col.id];
            if (!span) continue;
            const colSpan = span.colSpan ?? 1;
            const rowSpan = span.rowSpan ?? 1;
            if (colSpan <= 1 && rowSpan <= 1) continue;
            const colIndex = orderedCols.indexOf(col);
            /**
       * `rowsByGroup` is built from the same `rows` array we iterate over, so every
       * `row.rowGroupNumber` is guaranteed to be a key in the map.  The fallback is
       * unreachable but kept as a defensive default.
       */ const groupRows = rowsByGroup[row.rowGroupNumber] ?? // istanbul ignore next – rowsByGroup is populated from the same rows array, so the key always exists
            [];
            const rowIndex = groupRows.indexOf(row);
            /** Effective pixel width: sum of the spanned columns' widths. */ let effectiveWidth;
            if (colSpan > 1) {
                effectiveWidth = 0;
                for(let i = colIndex; i < Math.min(colIndex + colSpan, orderedCols.length); i++)effectiveWidth += previewColWidths[orderedCols[i].id] ?? orderedCols[i].width;
            }
            /** Effective pixel height: sum of the spanned rows' heights. */ let effectiveHeight;
            if (rowSpan > 1) {
                effectiveHeight = 0;
                for(let j = rowIndex; j < Math.min(rowIndex + rowSpan, groupRows.length); j++){
                    effectiveHeight += previewRowHeights[groupRows[j].id] ?? groupRows[j].height;
                    /** Mark cells in subsequent rows as covered (invisible placeholder). */ if (j > rowIndex) for(let k = colIndex; k < Math.min(colIndex + colSpan, orderedCols.length); k++){
                        const key = `${groupRows[j].id}:${orderedCols[k].id}`;
                        if (!coveredCells.has(key)) coveredCells.set(key, "other-row");
                    }
                }
            }
            /** Mark same-row cells absorbed by this colSpan as not-rendered. */ for(let k = colIndex + 1; k < Math.min(colIndex + colSpan, orderedCols.length); k++){
                const key = `${row.id}:${orderedCols[k].id}`;
                if (!coveredCells.has(key)) coveredCells.set(key, "same-row");
            }
            if (!result[row.id]) result[row.id] = {};
            result[row.id][col.id] = {
                mode: "spanning",
                effectiveWidth: effectiveWidth,
                effectiveHeight: effectiveHeight,
                hasRowSpan: rowSpan > 1
            };
        }
    }
    /** Write the covered-cell entries into the result map. */ for (const [cellKey, coverType] of coveredCells){
        const colonIndex = cellKey.indexOf(":");
        const rowId = cellKey.slice(0, colonIndex);
        const colId = cellKey.slice(colonIndex + 1);
        if (!result[rowId]) result[rowId] = {};
        result[rowId][colId] = {
            mode: coverType === "same-row" ? "covered-same-row" : "covered-other-row",
            hasRowSpan: false
        };
    }
    return result;
}

});

parcelRegister("2wRcQ", function(module, exports) {
$parcel$export(module.exports, "addCellRangeToSelection", function () { return (parcelRequire("81DrV")).addCellRangeToSelection; });
$parcel$export(module.exports, "addColRangeToSelection", function () { return (parcelRequire("53f6K")).addColRangeToSelection; });
$parcel$export(module.exports, "addRowRangeToSelection", function () { return (parcelRequire("72F2M")).addRowRangeToSelection; });
$parcel$export(module.exports, "hasAnySelection", function () { return (parcelRequire("bSvJh")).hasAnySelection; });
$parcel$export(module.exports, "isCellHighlighted", function () { return (parcelRequire("ckvsA")).isCellHighlighted; });
$parcel$export(module.exports, "isColInSelection", function () { return (parcelRequire("aLSh4")).isColInSelection; });
$parcel$export(module.exports, "isRowInSelection", function () { return (parcelRequire("5wuBZ")).isRowInSelection; });
$parcel$export(module.exports, "setCellRangeSelection", function () { return (parcelRequire("ifvOs")).setCellRangeSelection; });
$parcel$export(module.exports, "setColRangeSelection", function () { return (parcelRequire("iKq5X")).setColRangeSelection; });
$parcel$export(module.exports, "setRowRangeSelection", function () { return (parcelRequire("1p2ZA")).setRowRangeSelection; });
$parcel$export(module.exports, "toggleCellInSelection", function () { return (parcelRequire("f8FMA")).toggleCellInSelection; });
$parcel$export(module.exports, "toggleColInSelection", function () { return (parcelRequire("ipPyr")).toggleColInSelection; });
$parcel$export(module.exports, "toggleRowInSelection", function () { return (parcelRequire("fxikI")).toggleRowInSelection; });
parcelRequire("81DrV");
parcelRequire("53f6K");
parcelRequire("72F2M");
parcelRequire("eGUd6");
parcelRequire("bSvJh");
parcelRequire("ckvsA");
parcelRequire("6nbIt");
parcelRequire("aLSh4");
parcelRequire("5wuBZ");
parcelRequire("ifvOs");
parcelRequire("iKq5X");
parcelRequire("1p2ZA");
parcelRequire("f8FMA");
parcelRequire("ipPyr");
parcelRequire("fxikI");
parcelRequire("eDXZe");

});
parcelRegister("81DrV", function(module, exports) {

$parcel$export(module.exports, "addCellRangeToSelection", function () { return $b6c20d8554337486$export$53257f033e096296; });

var $6vebO = parcelRequire("6vebO");
const $b6c20d8554337486$export$53257f033e096296 = (selection, rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)=>{
    const rangeItems = (0, $6vebO.buildCellRange)(rows, cols, anchorRowId, anchorColId, targetRowId, targetColId);
    const colIdsByRow = new Map();
    for (const item of selection.selectedCells)colIdsByRow.set(item.rowId, new Set(item.colId));
    for (const rangeRow of rangeItems){
        const existing = colIdsByRow.get(rangeRow.rowId);
        if (existing) rangeRow.colId.forEach((c)=>existing.add(c));
        else colIdsByRow.set(rangeRow.rowId, new Set(rangeRow.colId));
    }
    const merged = Array.from(colIdsByRow.entries()).map(([rowId, colIdSet])=>({
            rowId: rowId,
            colId: Array.from(colIdSet)
        }));
    return {
        ...selection,
        selectedCells: merged
    };
};

});
parcelRegister("6vebO", function(module, exports) {

$parcel$export(module.exports, "buildCellRange", function () { return $deb74d43ce1969d7$export$32cb3a3235922788; });
const $deb74d43ce1969d7$export$32cb3a3235922788 = (rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)=>{
    const anchorRow = rows.find((r)=>r.id === anchorRowId);
    const targetRow = rows.find((r)=>r.id === targetRowId);
    const anchorCol = cols.find((c)=>c.id === anchorColId);
    const targetCol = cols.find((c)=>c.id === targetColId);
    if (!anchorRow || !targetRow || !anchorCol || !targetCol) return [];
    const minRowNum = Math.min(anchorRow.rowNumber, targetRow.rowNumber);
    const maxRowNum = Math.max(anchorRow.rowNumber, targetRow.rowNumber);
    const minColNum = Math.min(anchorCol.colNumber, targetCol.colNumber);
    const maxColNum = Math.max(anchorCol.colNumber, targetCol.colNumber);
    const rangeRows = rows.filter((r)=>r.rowNumber >= minRowNum && r.rowNumber <= maxRowNum);
    const rangeCols = cols.filter((c)=>c.colNumber >= minColNum && c.colNumber <= maxColNum);
    return rangeRows.map((r)=>({
            rowId: r.id,
            colId: rangeCols.map((c)=>c.id)
        }));
};

});


parcelRegister("53f6K", function(module, exports) {

$parcel$export(module.exports, "addColRangeToSelection", function () { return $76fda19ba49a56ba$export$5135606fbaabac99; });

var $eekqi = parcelRequire("eekqi");
const $76fda19ba49a56ba$export$5135606fbaabac99 = (selection, cols, anchorColId, targetColId)=>{
    const rangeItems = (0, $eekqi.buildColRange)(cols, anchorColId, targetColId);
    const existingIds = new Set(selection.selectedCols.map((c)=>c.firstCellId));
    const newItems = rangeItems.filter((c)=>!existingIds.has(c.firstCellId));
    return {
        ...selection,
        selectedCols: [
            ...selection.selectedCols,
            ...newItems
        ]
    };
};

});
parcelRegister("eekqi", function(module, exports) {

$parcel$export(module.exports, "buildColRange", function () { return $c25a7189bea4a99c$export$1c4606c9f13cde10; });
const $c25a7189bea4a99c$export$1c4606c9f13cde10 = (cols, anchorColId, targetColId)=>{
    const anchorCol = cols.find((c)=>c.id === anchorColId);
    const targetCol = cols.find((c)=>c.id === targetColId);
    if (!anchorCol || !targetCol) return [];
    const minColNum = Math.min(anchorCol.colNumber, targetCol.colNumber);
    const maxColNum = Math.max(anchorCol.colNumber, targetCol.colNumber);
    return cols.filter((c)=>c.colNumber >= minColNum && c.colNumber <= maxColNum).map((c)=>({
            firstCellId: c.id
        }));
};

});


parcelRegister("72F2M", function(module, exports) {

$parcel$export(module.exports, "addRowRangeToSelection", function () { return $a9178a4f4bceb6d5$export$170aeaa87a3eaf97; });

var $76rLx = parcelRequire("76rLx");
const $a9178a4f4bceb6d5$export$170aeaa87a3eaf97 = (selection, rows, anchorRowId, targetRowId)=>{
    const rangeItems = (0, $76rLx.buildRowRange)(rows, anchorRowId, targetRowId);
    const existingIds = new Set(selection.selectedRows.map((r)=>r.firstCellId));
    const newItems = rangeItems.filter((r)=>!existingIds.has(r.firstCellId));
    return {
        ...selection,
        selectedRows: [
            ...selection.selectedRows,
            ...newItems
        ]
    };
};

});
parcelRegister("76rLx", function(module, exports) {

$parcel$export(module.exports, "buildRowRange", function () { return $be0d188c6e8ab85c$export$5193858f270a72a7; });
const $be0d188c6e8ab85c$export$5193858f270a72a7 = (rows, anchorRowId, targetRowId)=>{
    const anchorRow = rows.find((r)=>r.id === anchorRowId);
    const targetRow = rows.find((r)=>r.id === targetRowId);
    if (!anchorRow || !targetRow) return [];
    const minRowNum = Math.min(anchorRow.rowNumber, targetRow.rowNumber);
    const maxRowNum = Math.max(anchorRow.rowNumber, targetRow.rowNumber);
    return rows.filter((r)=>r.rowNumber >= minRowNum && r.rowNumber <= maxRowNum).map((r)=>({
            firstCellId: r.id
        }));
};

});


parcelRegister("eGUd6", function(module, exports) {

$parcel$export(module.exports, "addSelectedCell", function () { return $33ebb8f9005fb95a$export$a58c5a182741e394; });
/**
 * Adds a selected cell into a row-indexed map used to build selectedCells arrays.
 *
 * @param selectedCellMap - Mutable map of row IDs to selected column ID sets.
 * @param rowId - Row ID for the cell.
 * @param colId - Column ID for the cell.
 */ const $33ebb8f9005fb95a$export$a58c5a182741e394 = (selectedCellMap, rowId, colId)=>{
    const rowCols = selectedCellMap.get(rowId) ?? new Set();
    rowCols.add(colId);
    selectedCellMap.set(rowId, rowCols);
};

});

parcelRegister("bSvJh", function(module, exports) {

$parcel$export(module.exports, "hasAnySelection", function () { return $062d4c0d65d51611$export$ec980a602e9ab582; });
const $062d4c0d65d51611$export$ec980a602e9ab582 = (selection)=>selection.selectedCells.length > 0 || selection.selectedRows.length > 0 || selection.selectedCols.length > 0;

});

parcelRegister("ckvsA", function(module, exports) {

$parcel$export(module.exports, "isCellHighlighted", function () { return $1df92519816eaa99$export$dc55bf97786b2f87; });

var $6nbIt = parcelRequire("6nbIt");

var $aLSh4 = parcelRequire("aLSh4");

var $5wuBZ = parcelRequire("5wuBZ");
const $1df92519816eaa99$export$dc55bf97786b2f87 = (selection, rowId, colId)=>(0, $6nbIt.isCellInSelection)(selection, rowId, colId) || (0, $5wuBZ.isRowInSelection)(selection, rowId) || (0, $aLSh4.isColInSelection)(selection, colId);

});
parcelRegister("6nbIt", function(module, exports) {

$parcel$export(module.exports, "isCellInSelection", function () { return $a7686382a5306d6f$export$d8be2823b9effa13; });
const $a7686382a5306d6f$export$d8be2823b9effa13 = (selection, rowId, colId)=>selection.selectedCells.some((r)=>r.rowId === rowId && r.colId.some((selectedColId)=>selectedColId === colId));

});

parcelRegister("aLSh4", function(module, exports) {

$parcel$export(module.exports, "isColInSelection", function () { return $1a043d9fe1c4d5fc$export$f3465d08b8694844; });
const $1a043d9fe1c4d5fc$export$f3465d08b8694844 = (selection, colId)=>selection.selectedCols.some((c)=>c.firstCellId === colId);

});

parcelRegister("5wuBZ", function(module, exports) {

$parcel$export(module.exports, "isRowInSelection", function () { return $942903b7597f5839$export$54f247f36fd0f222; });
const $942903b7597f5839$export$54f247f36fd0f222 = (selection, rowId)=>selection.selectedRows.some((r)=>r.firstCellId === rowId);

});


parcelRegister("ifvOs", function(module, exports) {

$parcel$export(module.exports, "setCellRangeSelection", function () { return $ffcaf3a81ff9d6d6$export$e84f3d196fb0aaa8; });

var $4zamZ = parcelRequire("4zamZ");

var $6vebO = parcelRequire("6vebO");
const $ffcaf3a81ff9d6d6$export$e84f3d196fb0aaa8 = (rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)=>({
        ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
        selectedCells: (0, $6vebO.buildCellRange)(rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)
    });

});
parcelRegister("4zamZ", function(module, exports) {

$parcel$export(module.exports, "ScaffoldDropZone", function () { return $cf262c02de1cf817$export$54f682ad17b9257d; });
$parcel$export(module.exports, "ZONE_GRID_ORDER", function () { return $cf262c02de1cf817$export$50b5cb74f7905444; });
$parcel$export(module.exports, "HORIZONTAL_SIDE_ZONES", function () { return $cf262c02de1cf817$export$dae00fd59d927e43; });
$parcel$export(module.exports, "VERTICAL_SIDE_ZONES", function () { return $cf262c02de1cf817$export$c797460f28ae5418; });
$parcel$export(module.exports, "SCAFFOLD_ZONE_GRID_BOUNDS", function () { return $cf262c02de1cf817$export$416249cdd7a6641c; });
$parcel$export(module.exports, "DEFAULT_SCAFFOLD_ZONE_COLORS", function () { return $cf262c02de1cf817$export$798b07a71ab66d07; });
$parcel$export(module.exports, "MIN_SCAFFOLD_COL_WIDTH_PX", function () { return $cf262c02de1cf817$export$98e57f844c986948; });
$parcel$export(module.exports, "MIN_SCAFFOLD_ROW_HEIGHT_PX", function () { return $cf262c02de1cf817$export$9496fe9da1ae70f8; });
$parcel$export(module.exports, "SCAFFOLD_ANIMATION_DURATION_MS", function () { return $cf262c02de1cf817$export$fc1a1e82e02399ea; });
$parcel$export(module.exports, "SCAFFOLD_ANIMATION_START_DELAY_MS", function () { return $cf262c02de1cf817$export$cb496f56a9ae9cb; });
$parcel$export(module.exports, "SIDE_ZONE_SIZE", function () { return $cf262c02de1cf817$export$4b4867e05e0827b; });
$parcel$export(module.exports, "SIDE_ZONE_MIN_SIZE", function () { return $cf262c02de1cf817$export$6001d82b46aba704; });
$parcel$export(module.exports, "EMPTY_SCAFFOLD_SELECTION", function () { return $cf262c02de1cf817$export$6a055c40c2b95347; });
$parcel$export(module.exports, "SCAFFOLD_SELECT_HANDLE_SIZE_PX", function () { return $cf262c02de1cf817$export$b24452eaa684ddeb; });
var $cf262c02de1cf817$export$54f682ad17b9257d = /*#__PURE__*/ function(ScaffoldDropZone) {
    ScaffoldDropZone["TopLeft"] = "TL";
    ScaffoldDropZone["TopEdgeLeft"] = "TEL";
    ScaffoldDropZone["TopEdgeRight"] = "TER";
    ScaffoldDropZone["TopRight"] = "TR";
    ScaffoldDropZone["LeftEdgeTop"] = "LET";
    ScaffoldDropZone["CentreTopLeft"] = "CTL";
    ScaffoldDropZone["CentreTopRight"] = "CTR";
    ScaffoldDropZone["RightEdgeTop"] = "RET";
    ScaffoldDropZone["LeftEdgeBottom"] = "LEB";
    ScaffoldDropZone["CentreBottomLeft"] = "CBL";
    ScaffoldDropZone["CentreBottomRight"] = "CBR";
    ScaffoldDropZone["RightEdgeBottom"] = "REB";
    ScaffoldDropZone["BottomLeft"] = "BL";
    ScaffoldDropZone["BottomEdgeLeft"] = "BEL";
    ScaffoldDropZone["BottomEdgeRight"] = "BER";
    ScaffoldDropZone["BottomRight"] = "BR";
    return ScaffoldDropZone;
}({});
const $cf262c02de1cf817$export$50b5cb74f7905444 = [
    "TL",
    "TEL",
    "TER",
    "TR",
    "LET",
    "CTL",
    "CTR",
    "RET",
    "LEB",
    "CBL",
    "CBR",
    "REB",
    "BL",
    "BEL",
    "BER",
    "BR"
];
const $cf262c02de1cf817$export$dae00fd59d927e43 = new Set([
    "TL",
    "LET",
    "LEB",
    "BL",
    "TR",
    "RET",
    "REB",
    "BR"
]);
const $cf262c02de1cf817$export$c797460f28ae5418 = new Set([
    "TL",
    "TEL",
    "TER",
    "TR",
    "BL",
    "BEL",
    "BER",
    "BR"
]);
const $cf262c02de1cf817$export$416249cdd7a6641c = {
    ["TL"]: {
        top: 1,
        bottom: 2,
        left: 1,
        right: 2
    },
    ["TEL"]: {
        top: 1,
        bottom: 2,
        left: 2,
        right: 3
    },
    ["TER"]: {
        top: 1,
        bottom: 2,
        left: 3,
        right: 4
    },
    ["TR"]: {
        top: 1,
        bottom: 2,
        left: 4,
        right: 5
    },
    ["LET"]: {
        top: 2,
        bottom: 3,
        left: 1,
        right: 2
    },
    ["CTL"]: {
        top: 2,
        bottom: 3,
        left: 2,
        right: 3
    },
    ["CTR"]: {
        top: 2,
        bottom: 3,
        left: 3,
        right: 4
    },
    ["RET"]: {
        top: 2,
        bottom: 3,
        left: 4,
        right: 5
    },
    ["LEB"]: {
        top: 3,
        bottom: 4,
        left: 1,
        right: 2
    },
    ["CBL"]: {
        top: 3,
        bottom: 4,
        left: 2,
        right: 3
    },
    ["CBR"]: {
        top: 3,
        bottom: 4,
        left: 3,
        right: 4
    },
    ["REB"]: {
        top: 3,
        bottom: 4,
        left: 4,
        right: 5
    },
    ["BL"]: {
        top: 4,
        bottom: 5,
        left: 1,
        right: 2
    },
    ["BEL"]: {
        top: 4,
        bottom: 5,
        left: 2,
        right: 3
    },
    ["BER"]: {
        top: 4,
        bottom: 5,
        left: 3,
        right: 4
    },
    ["BR"]: {
        top: 4,
        bottom: 5,
        left: 4,
        right: 5
    }
};
const $cf262c02de1cf817$export$798b07a71ab66d07 = {
    ["TL"]: "#ff6b6b",
    ["TEL"]: "#ff9999",
    ["TER"]: "#ff9999",
    ["TR"]: "#ff6b6b",
    ["LET"]: "#ff9999",
    ["CTL"]: "#4dabf7",
    ["CTR"]: "#4dabf7",
    ["RET"]: "#ff9999",
    ["LEB"]: "#ff9999",
    ["CBL"]: "#4dabf7",
    ["CBR"]: "#4dabf7",
    ["REB"]: "#ff9999",
    ["BL"]: "#ff6b6b",
    ["BEL"]: "#ff9999",
    ["BER"]: "#ff9999",
    ["BR"]: "#ff6b6b"
};
const $cf262c02de1cf817$export$98e57f844c986948 = 8;
const $cf262c02de1cf817$export$9496fe9da1ae70f8 = 8;
const $cf262c02de1cf817$export$fc1a1e82e02399ea = 200;
const $cf262c02de1cf817$export$cb496f56a9ae9cb = 5;
const $cf262c02de1cf817$export$4b4867e05e0827b = 11;
const $cf262c02de1cf817$export$6001d82b46aba704 = $cf262c02de1cf817$export$4b4867e05e0827b * 2 + 2;
const $cf262c02de1cf817$export$6a055c40c2b95347 = {
    selectedCells: [],
    selectedRows: [],
    selectedCols: []
};
const $cf262c02de1cf817$export$b24452eaa684ddeb = 12;

});


parcelRegister("iKq5X", function(module, exports) {

$parcel$export(module.exports, "setColRangeSelection", function () { return $c640305e25d8950a$export$ff67db96b671f950; });

var $4zamZ = parcelRequire("4zamZ");

var $eekqi = parcelRequire("eekqi");
const $c640305e25d8950a$export$ff67db96b671f950 = (cols, anchorColId, targetColId)=>({
        ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
        selectedCols: (0, $eekqi.buildColRange)(cols, anchorColId, targetColId)
    });

});

parcelRegister("1p2ZA", function(module, exports) {

$parcel$export(module.exports, "setRowRangeSelection", function () { return $490b4f59a9656d61$export$bc043024ab74f0e7; });

var $4zamZ = parcelRequire("4zamZ");

var $76rLx = parcelRequire("76rLx");
const $490b4f59a9656d61$export$bc043024ab74f0e7 = (rows, anchorRowId, targetRowId)=>({
        ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
        selectedRows: (0, $76rLx.buildRowRange)(rows, anchorRowId, targetRowId)
    });

});

parcelRegister("f8FMA", function(module, exports) {

$parcel$export(module.exports, "toggleCellInSelection", function () { return $9b2f95d9720b9879$export$9e443a4ca015dc8e; });

var $eGUd6 = parcelRequire("eGUd6");

var $6nbIt = parcelRequire("6nbIt");

var $aLSh4 = parcelRequire("aLSh4");

var $5wuBZ = parcelRequire("5wuBZ");

var $eDXZe = parcelRequire("eDXZe");
const $9b2f95d9720b9879$export$9e443a4ca015dc8e = (selection, prevRows, prevCols, rowId, colId)=>{
    if ((0, $6nbIt.isCellInSelection)(selection, rowId, colId)) {
        const newSelectedCells = selection.selectedCells.map((r)=>r.rowId === rowId ? {
                ...r,
                colId: r.colId.filter((c)=>c !== colId)
            } : r).filter((r)=>r.colId.length > 0);
        return {
            ...selection,
            selectedCells: newSelectedCells
        };
    }
    const rowSelected = (0, $5wuBZ.isRowInSelection)(selection, rowId);
    const colSelected = (0, $aLSh4.isColInSelection)(selection, colId);
    if (rowSelected || colSelected) {
        const selectedCellMap = new Map();
        selection.selectedCells.forEach((selectedRow)=>{
            selectedRow.colId.forEach((selectedColId)=>{
                (0, $eGUd6.addSelectedCell)(selectedCellMap, selectedRow.rowId, selectedColId);
            });
        });
        if (rowSelected) prevCols.forEach((col)=>{
            if (col.id !== colId) (0, $eGUd6.addSelectedCell)(selectedCellMap, rowId, col.id);
        });
        if (colSelected) prevRows.forEach((row)=>{
            if (row.id !== rowId) (0, $eGUd6.addSelectedCell)(selectedCellMap, row.id, colId);
        });
        selectedCellMap.get(rowId)?.delete(colId);
        return {
            ...selection,
            selectedCells: (0, $eDXZe.toSelectedCells)(selectedCellMap, prevRows, prevCols),
            selectedRows: rowSelected ? selection.selectedRows.filter((selectedRow)=>selectedRow.firstCellId !== rowId) : selection.selectedRows,
            selectedCols: colSelected ? selection.selectedCols.filter((selectedCol)=>selectedCol.firstCellId !== colId) : selection.selectedCols
        };
    }
    const existingRow = selection.selectedCells.find((r)=>r.rowId === rowId);
    if (existingRow) return {
        ...selection,
        selectedCells: selection.selectedCells.map((r)=>r.rowId === rowId ? {
                ...r,
                colId: [
                    ...r.colId,
                    colId
                ]
            } : r)
    };
    return {
        ...selection,
        selectedCells: [
            ...selection.selectedCells,
            {
                rowId: rowId,
                colId: [
                    colId
                ]
            }
        ]
    };
};

});
parcelRegister("eDXZe", function(module, exports) {

$parcel$export(module.exports, "toSelectedCells", function () { return $b9720508e7e7537f$export$b242ca1596b7c393; });
const $b9720508e7e7537f$export$b242ca1596b7c393 = (selectedCellMap, prevRows, prevCols)=>{
    const rowOrder = prevRows.map((row)=>row.id);
    const colOrder = prevCols.map((col)=>col.id);
    const remainingRows = Array.from(selectedCellMap.keys()).filter((rowId)=>!rowOrder.includes(rowId));
    const orderedRowIds = [
        ...rowOrder,
        ...remainingRows
    ];
    return orderedRowIds.map((orderedRowId)=>{
        const cols = selectedCellMap.get(orderedRowId);
        if (!cols || cols.size === 0) return null;
        const remainingCols = Array.from(cols).filter((currentColId)=>!colOrder.includes(currentColId));
        const orderedColIds = [
            ...colOrder.filter((currentColId)=>cols.has(currentColId)),
            ...remainingCols
        ];
        return {
            rowId: orderedRowId,
            colId: orderedColIds
        };
    }).filter((selectedRow)=>selectedRow !== null);
};

});


parcelRegister("ipPyr", function(module, exports) {

$parcel$export(module.exports, "toggleColInSelection", function () { return $b416c31f3377448e$export$9185b7ffb76520e5; });

var $aLSh4 = parcelRequire("aLSh4");
const $b416c31f3377448e$export$9185b7ffb76520e5 = (selection, colId)=>{
    if ((0, $aLSh4.isColInSelection)(selection, colId)) return {
        ...selection,
        selectedCols: selection.selectedCols.filter((c)=>c.firstCellId !== colId)
    };
    return {
        ...selection,
        selectedCols: [
            ...selection.selectedCols,
            {
                firstCellId: colId
            }
        ]
    };
};

});

parcelRegister("fxikI", function(module, exports) {

$parcel$export(module.exports, "toggleRowInSelection", function () { return $2e5c2dd7261a625f$export$d14b6cbc81a35dc0; });

var $5wuBZ = parcelRequire("5wuBZ");
const $2e5c2dd7261a625f$export$d14b6cbc81a35dc0 = (selection, rowId)=>{
    if ((0, $5wuBZ.isRowInSelection)(selection, rowId)) return {
        ...selection,
        selectedRows: selection.selectedRows.filter((r)=>r.firstCellId !== rowId)
    };
    return {
        ...selection,
        selectedRows: [
            ...selection.selectedRows,
            {
                firstCellId: rowId
            }
        ]
    };
};

});


parcelRegister("7j5F4", function(module, exports) {

$parcel$export(module.exports, "getScaffoldContextMenuTarget", function () { return $be11cc94915a3be5$export$797de89932b1ad68; });
/**
 * The row and column ids resolved from a context menu event target.
 */ const $be11cc94915a3be5$export$797de89932b1ad68 = (target)=>{
    if (target instanceof Element) {
        const scaffoldCell = target.closest("[data-scaffold-col-id]");
        const colId = scaffoldCell?.getAttribute("data-scaffold-col-id");
        const rowId = scaffoldCell?.getAttribute("data-scaffold-row-id");
        if (colId && rowId) return {
            colId: colId,
            rowId: rowId
        };
    }
    return undefined;
};

});

parcelRegister("3k2bR", function(module, exports) {

$parcel$export(module.exports, "Scaffold", function () { return $65842f453df0a238$export$e460bf4b68e36254; });
$parcel$export(module.exports, "useScaffold", function () { return $65842f453df0a238$export$5746fe70af142290; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $6sNBS = parcelRequire("6sNBS");

var $k4Vha = parcelRequire("k4Vha");

var $j1f43 = parcelRequire("j1f43");

var $4zamZ = parcelRequire("4zamZ");

var $8XxPo = parcelRequire("8XxPo");

var $bK3BV = parcelRequire("bK3BV");

var $kZbhv = parcelRequire("kZbhv");

var $iQhKl = parcelRequire("iQhKl");

var $1UWJN = parcelRequire("1UWJN");
const $65842f453df0a238$export$3c94731494ab08e8 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $65842f453df0a238$export$e460bf4b68e36254 = (props)=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)((s, a)=>(0, $j1f43.scaffoldReducer)(s, a), undefined, ()=>({
            prevCols: props.columns,
            prevRows: props.rows,
            enteringColIds: new Set(),
            enteringRowIds: new Set(),
            leavingCols: [],
            leavingRows: [],
            isDragging: false,
            previewColWidths: {},
            previewRowHeights: {},
            selection: props.selection ?? (0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
            selectionAnchor: null
        }));
    const tableWrapperRef = (0, $7fPBF.useRef)(null);
    const prevSelectionPropRef = (0, $7fPBF.useRef)(props.selection);
    const handleDragStart = (0, $7fPBF.useEffectEvent)(()=>dispatch({
            operation: (0, $k4Vha.SET_DRAGGING),
            isDragging: true
        }));
    const handleDragEnd = (0, $7fPBF.useEffectEvent)(()=>dispatch({
            operation: (0, $k4Vha.SET_DRAGGING),
            isDragging: false
        }));
    const handleClickOutside = (0, $7fPBF.useEffectEvent)((event)=>{
        if (tableWrapperRef.current && !tableWrapperRef.current.contains(event.target) && props.onSelectionChange) dispatch({
            operation: (0, $k4Vha.CLICK_OUTSIDE)
        });
    });
    (0, $7fPBF.useEffect)(()=>{
        document.addEventListener("dragstart", handleDragStart);
        document.addEventListener("dragend", handleDragEnd);
        return ()=>{
            document.removeEventListener("dragstart", handleDragStart);
            document.removeEventListener("dragend", handleDragEnd);
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    // These are outside a useEffect for animation purposes
    if ((0, $8XxPo.reconcileScaffoldItems)(props.columns, state.prevCols, state.leavingCols).hasChanged) dispatch({
        operation: (0, $k4Vha.COLS_CHANGED),
        cols: props.columns
    });
    if ((0, $8XxPo.reconcileScaffoldItems)(props.rows, state.prevRows, state.leavingRows).hasChanged) dispatch({
        operation: (0, $k4Vha.ROWS_CHANGED),
        rows: props.rows
    });
    const onSelectionChangeRef = (0, $7fPBF.useRef)(props.onSelectionChange);
    (0, $7fPBF.useLayoutEffect)(()=>{
        onSelectionChangeRef.current = props.onSelectionChange;
    });
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (props.selection !== undefined && !(0, $gSkQi.isEqual)(props.selection, prevSelectionPropRef.current)) {
            prevSelectionPropRef.current = props.selection;
            dispatch({
                operation: (0, $k4Vha.SELECTION_CHANGED),
                selection: props.selection
            });
        }
    }, [
        props.selection
    ]);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (!(0, $gSkQi.isEqual)(state.selection, props.selection ?? (0, $4zamZ.EMPTY_SCAFFOLD_SELECTION))) {
            onSelectionChangeRef.current?.(state.selection);
            prevSelectionPropRef.current = state.selection;
        }
    }, [
        state.selection,
        props.selection
    ]);
    /**
   * Prevents browser text selection on shift+mousedown when cell selection is already active.
   * This keeps shift+click range selection focused on scaffold behaviour instead of selecting text.
   *
   * @param event - Mouse event raised while pressing on the scaffold.
   */ const onTableMouseDownCapture = (event)=>{
        const hasActiveCellSelection = state.selection.selectedCells.length > 0;
        if (event.shiftKey && hasActiveCellSelection) event.preventDefault();
    };
    const scaffoldContextValue = {
        dispatch: dispatch,
        state: state,
        settings: {
            id: props.id,
            cellComponent: props.cellComponent,
            cellData: props.cellData,
            columns: props.columns,
            rows: props.rows,
            disabled: props.disabled,
            justification: props.justification,
            zoneColors: props.zoneColors ?? (0, $4zamZ.DEFAULT_SCAFFOLD_ZONE_COLORS),
            onChangeCol: props.onChangeCol,
            onChangeRow: props.onChangeRow,
            onChangeCell: props.onChangeCell,
            onDrop: props.onDrop,
            onSelectionChange: props.onSelectionChange,
            headerCellSpans: props.headerCellSpans
        },
        headerSpanMap: props.headerCellSpans !== undefined ? (0, $6sNBS.computeHeaderSpanState)(props.rows, props.columns, props.headerCellSpans, state.previewColWidths, state.previewRowHeights) : undefined
    };
    const orderedCols = [
        ...props.columns
    ].sort((a, b)=>a.colNumber - b.colNumber);
    const shouldRenderSelectionHandles = props.onSelectionChange !== undefined;
    let nextSelectLeft = 0;
    const colSelectLayout = orderedCols.map((col)=>{
        const colLeft = nextSelectLeft;
        const colWidth = state.previewColWidths[col.id] ?? col.width;
        nextSelectLeft += colWidth;
        return {
            colId: col.id,
            left: colLeft,
            width: colWidth
        };
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($65842f453df0a238$export$3c94731494ab08e8.Provider, {
        value: scaffoldContextValue,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).tableWrapper,
            onMouseDownCapture: onTableMouseDownCapture,
            ref: tableWrapperRef,
            style: props.style,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).table,
                id: props.id,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1UWJN.ScaffoldRowGroups), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).colResizeOverlay,
                        children: [
                            shouldRenderSelectionHandles && colSelectLayout.map((colSelect)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $iQhKl.ScaffoldColSelectHandle), {
                                    colId: colSelect.colId,
                                    left: colSelect.left,
                                    width: colSelect.width
                                }, `col-select-handle-${colSelect.colId}`)),
                            orderedCols.filter((oc)=>!oc.noResize).map((oc, ix, arr)=>{
                                let id = oc.id;
                                // istanbul ignore next - added for debugging bad data
                                if (arr.findIndex((col)=>col.id === oc.id) !== ix) {
                                    console.warn("Having to reassign colId for resize handle due to non-unique column IDs:", oc.id);
                                    id = `${oc.id}-${ix}`;
                                }
                                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kZbhv.ScaffoldColResizeHandle), {
                                    colId: oc.id
                                }, `col-resize-handle-${id}`);
                            })
                        ]
                    })
                ]
            })
        })
    });
};
$65842f453df0a238$export$e460bf4b68e36254.displayName = "Scaffold";
const $65842f453df0a238$export$5746fe70af142290 = ()=>{
    const context = (0, $7fPBF.useContext)($65842f453df0a238$export$3c94731494ab08e8);
    if (!context) throw new Error("useScaffold must be used within a ScaffoldContext provider");
    return context;
};

});
parcelRegister("k4Vha", function(module, exports) {

$parcel$export(module.exports, "SET_DRAGGING", function () { return $6fc9bdfd94bebe2e$export$e890ace773f2db9; });
$parcel$export(module.exports, "COLS_CHANGED", function () { return $6fc9bdfd94bebe2e$export$be358cce7c15e51e; });
$parcel$export(module.exports, "ROWS_CHANGED", function () { return $6fc9bdfd94bebe2e$export$2de7ede39bdbf015; });
$parcel$export(module.exports, "COL_LEAVE_COMPLETE", function () { return $6fc9bdfd94bebe2e$export$54793146d18d1169; });
$parcel$export(module.exports, "COL_ENTER_COMPLETE", function () { return $6fc9bdfd94bebe2e$export$5e210e20e021e0e3; });
$parcel$export(module.exports, "ROW_LEAVE_COMPLETE", function () { return $6fc9bdfd94bebe2e$export$23dc4d35ed125193; });
$parcel$export(module.exports, "ROW_ENTER_COMPLETE", function () { return $6fc9bdfd94bebe2e$export$96bf00166c391748; });
$parcel$export(module.exports, "PREVIEW_COL_WIDTH_CHANGE", function () { return $6fc9bdfd94bebe2e$export$76f33e721b9a3a40; });
$parcel$export(module.exports, "PREVIEW_ROW_HEIGHT_CHANGE", function () { return $6fc9bdfd94bebe2e$export$cc62c6a7cb0da32f; });
$parcel$export(module.exports, "CELL_CLICKED", function () { return $6fc9bdfd94bebe2e$export$d924b85e5b48c870; });
$parcel$export(module.exports, "ROW_CLICKED", function () { return $6fc9bdfd94bebe2e$export$bbeb390aa40344d9; });
$parcel$export(module.exports, "COL_CLICKED", function () { return $6fc9bdfd94bebe2e$export$2cbb51811aa951a1; });
$parcel$export(module.exports, "CLICK_OUTSIDE", function () { return $6fc9bdfd94bebe2e$export$75af710a6c1304e5; });
$parcel$export(module.exports, "SELECTION_CHANGED", function () { return $6fc9bdfd94bebe2e$export$9b2609dade4b2e2a; });
const $6fc9bdfd94bebe2e$export$e890ace773f2db9 = "SET_DRAGGING";
const $6fc9bdfd94bebe2e$export$be358cce7c15e51e = "COLS_CHANGED";
const $6fc9bdfd94bebe2e$export$2de7ede39bdbf015 = "ROWS_CHANGED";
const $6fc9bdfd94bebe2e$export$54793146d18d1169 = "COL_LEAVE_COMPLETE";
const $6fc9bdfd94bebe2e$export$5e210e20e021e0e3 = "COL_ENTER_COMPLETE";
const $6fc9bdfd94bebe2e$export$23dc4d35ed125193 = "ROW_LEAVE_COMPLETE";
const $6fc9bdfd94bebe2e$export$96bf00166c391748 = "ROW_ENTER_COMPLETE";
const $6fc9bdfd94bebe2e$export$76f33e721b9a3a40 = "PREVIEW_COL_WIDTH_CHANGE";
const $6fc9bdfd94bebe2e$export$cc62c6a7cb0da32f = "PREVIEW_ROW_HEIGHT_CHANGE";
const $6fc9bdfd94bebe2e$export$d924b85e5b48c870 = "CELL_CLICKED";
const $6fc9bdfd94bebe2e$export$bbeb390aa40344d9 = "ROW_CLICKED";
const $6fc9bdfd94bebe2e$export$2cbb51811aa951a1 = "COL_CLICKED";
const $6fc9bdfd94bebe2e$export$75af710a6c1304e5 = "CLICK_OUTSIDE";
const $6fc9bdfd94bebe2e$export$9b2609dade4b2e2a = "SELECTION_CHANGED";

});

parcelRegister("j1f43", function(module, exports) {

$parcel$export(module.exports, "scaffoldReducer", function () { return $5d3c30ec8759c11a$export$55cbe0465d7cf493; });

var $k4Vha = parcelRequire("k4Vha");

var $bO1TU = parcelRequire("bO1TU");

var $38X2W = parcelRequire("38X2W");

var $hdzsS = parcelRequire("hdzsS");

var $5Vl9D = parcelRequire("5Vl9D");

var $lzYfO = parcelRequire("lzYfO");

var $cRbMY = parcelRequire("cRbMY");

var $lqLuI = parcelRequire("lqLuI");

var $5Mfbi = parcelRequire("5Mfbi");

var $4CKhC = parcelRequire("4CKhC");

var $elNJs = parcelRequire("elNJs");

var $7m2g8 = parcelRequire("7m2g8");

var $zX8gw = parcelRequire("zX8gw");

var $9k7ni = parcelRequire("9k7ni");

var $1SvMT = parcelRequire("1SvMT");
const $5d3c30ec8759c11a$export$55cbe0465d7cf493 = (state, action)=>{
    switch(action.operation){
        case 0, $k4Vha.SET_DRAGGING:
            return (0, $1SvMT.scr_setDragging)(action, state);
        case 0, $k4Vha.COLS_CHANGED:
            return (0, $cRbMY.scr_colsChanged)(action, state);
        case 0, $k4Vha.ROWS_CHANGED:
            return (0, $zX8gw.scr_rowsChanged)(action, state);
        case 0, $k4Vha.COL_LEAVE_COMPLETE:
            return (0, $lzYfO.scr_colLeaveComplete)(action, state);
        case 0, $k4Vha.COL_ENTER_COMPLETE:
            return (0, $5Vl9D.scr_colEnterComplete)(action, state);
        case 0, $k4Vha.ROW_LEAVE_COMPLETE:
            return (0, $7m2g8.scr_rowLeaveComplete)(action, state);
        case 0, $k4Vha.ROW_ENTER_COMPLETE:
            return (0, $elNJs.scr_rowEnterComplete)(action, state);
        case 0, $k4Vha.PREVIEW_COL_WIDTH_CHANGE:
            return (0, $lqLuI.scr_previewColWidthChange)(action, state);
        case 0, $k4Vha.PREVIEW_ROW_HEIGHT_CHANGE:
            return (0, $5Mfbi.scr_previewRowHeightChange)(action, state);
        case 0, $k4Vha.CELL_CLICKED:
            return (0, $bO1TU.scr_cellClicked)(action, state);
        case 0, $k4Vha.ROW_CLICKED:
            return (0, $4CKhC.scr_rowClicked)(action, state);
        case 0, $k4Vha.COL_CLICKED:
            return (0, $hdzsS.scr_colClicked)(action, state);
        case 0, $k4Vha.CLICK_OUTSIDE:
            return (0, $38X2W.scr_clickOutside)(state);
        case 0, $k4Vha.SELECTION_CHANGED:
            return (0, $9k7ni.scr_selectionChanged)(action, state);
    }
};

});
parcelRegister("bO1TU", function(module, exports) {

$parcel$export(module.exports, "scr_cellClicked", function () { return $dfa103838c13a6cb$export$8a28a4f362790a4; });

var $4zamZ = parcelRequire("4zamZ");
parcelRequire("2wRcQ");
var $81DrV = parcelRequire("81DrV");
var $bSvJh = parcelRequire("bSvJh");
var $ifvOs = parcelRequire("ifvOs");
var $f8FMA = parcelRequire("f8FMA");
const $dfa103838c13a6cb$export$8a28a4f362790a4 = (action, state)=>{
    const { rowId: rowId, colId: colId, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = action;
    const { selection: selection, selectionAnchor: selectionAnchor, prevRows: prevRows, prevCols: prevCols } = state;
    if (shiftKey) {
        if (selectionAnchor && selectionAnchor.type === "cell") return {
            ...state,
            selection: ctrlKey || metaKey ? (0, $81DrV.addCellRangeToSelection)(selection, prevRows, prevCols, selectionAnchor.rowId, selectionAnchor.colId, rowId, colId) : (0, $ifvOs.setCellRangeSelection)(prevRows, prevCols, selectionAnchor.rowId, selectionAnchor.colId, rowId, colId)
        };
        return {
            ...state,
            selection: {
                ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
                selectedCells: [
                    {
                        rowId: rowId,
                        colId: [
                            colId
                        ]
                    }
                ]
            },
            selectionAnchor: {
                type: "cell",
                rowId: rowId,
                colId: colId
            }
        };
    }
    if (ctrlKey || metaKey) return {
        ...state,
        selection: (0, $f8FMA.toggleCellInSelection)(selection, prevRows, prevCols, rowId, colId),
        selectionAnchor: {
            type: "cell",
            rowId: rowId,
            colId: colId
        }
    };
    if ((0, $bSvJh.hasAnySelection)(selection)) return {
        ...state,
        selection: (0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
        selectionAnchor: null
    };
    return state;
};

});

parcelRegister("38X2W", function(module, exports) {

$parcel$export(module.exports, "scr_clickOutside", function () { return $62bdab9378312dfa$export$8053598e85c798e4; });

var $4zamZ = parcelRequire("4zamZ");
parcelRequire("2wRcQ");
var $bSvJh = parcelRequire("bSvJh");
const $62bdab9378312dfa$export$8053598e85c798e4 = (state)=>{
    if ((0, $bSvJh.hasAnySelection)(state.selection)) return {
        ...state,
        selection: (0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
        selectionAnchor: null
    };
    return state;
};

});

parcelRegister("hdzsS", function(module, exports) {

$parcel$export(module.exports, "scr_colClicked", function () { return $da15045d8fe3d3d7$export$951dc268b55f27d8; });

var $4zamZ = parcelRequire("4zamZ");
parcelRequire("2wRcQ");
var $53f6K = parcelRequire("53f6K");
var $iKq5X = parcelRequire("iKq5X");
var $ipPyr = parcelRequire("ipPyr");
const $da15045d8fe3d3d7$export$951dc268b55f27d8 = (action, state)=>{
    const { colId: colId, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = action;
    const { selection: selection, selectionAnchor: selectionAnchor, prevCols: prevCols } = state;
    if (shiftKey) {
        if (selectionAnchor && selectionAnchor.type === "col") return {
            ...state,
            selection: ctrlKey || metaKey ? (0, $53f6K.addColRangeToSelection)(selection, prevCols, selectionAnchor.colId, colId) : (0, $iKq5X.setColRangeSelection)(prevCols, selectionAnchor.colId, colId)
        };
        return {
            ...state,
            selection: {
                ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
                selectedCols: [
                    {
                        firstCellId: colId
                    }
                ]
            },
            selectionAnchor: {
                type: "col",
                colId: colId
            }
        };
    }
    return {
        ...state,
        selection: ctrlKey || metaKey ? (0, $ipPyr.toggleColInSelection)(selection, colId) : {
            ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
            selectedCols: [
                {
                    firstCellId: colId
                }
            ]
        },
        selectionAnchor: {
            type: "col",
            colId: colId
        }
    };
};

});

parcelRegister("5Vl9D", function(module, exports) {

$parcel$export(module.exports, "scr_colEnterComplete", function () { return $bf7e5f098163f521$export$75ca774af0b5b6e7; });
const $bf7e5f098163f521$export$75ca774af0b5b6e7 = (action, state)=>{
    if (!state.enteringColIds.has(action.colId)) return state;
    const next = new Set(state.enteringColIds);
    next.delete(action.colId);
    return {
        ...state,
        enteringColIds: next
    };
};

});

parcelRegister("lzYfO", function(module, exports) {

$parcel$export(module.exports, "scr_colLeaveComplete", function () { return $6f523d3e1614228c$export$199b4ad1e2e17f2e; });
const $6f523d3e1614228c$export$199b4ad1e2e17f2e = (action, state)=>({
        ...state,
        leavingCols: state.leavingCols.filter((c)=>c.id !== action.colId)
    });

});

parcelRegister("cRbMY", function(module, exports) {

$parcel$export(module.exports, "scr_colsChanged", function () { return $8aaf6c84d1a6cd2a$export$e8399f2559dbfa73; });

var $8XxPo = parcelRequire("8XxPo");
const $8aaf6c84d1a6cd2a$export$e8399f2559dbfa73 = (action, state)=>{
    const reconciliation = (0, $8XxPo.reconcileScaffoldItems)(action.cols, state.prevCols, state.leavingCols);
    return !reconciliation.hasChanged ? state : {
        ...state,
        enteringColIds: reconciliation.enteringIds,
        leavingCols: reconciliation.nextLeavingItems,
        prevCols: action.cols
    };
};

});
parcelRegister("8XxPo", function(module, exports) {

$parcel$export(module.exports, "reconcileScaffoldItems", function () { return $f3a75ed1ba2c8207$export$991f8dffdded4e61; });
/**
 * Reconciliation result for scaffold collections such as rows and columns.
 */ const $f3a75ed1ba2c8207$export$991f8dffdded4e61 = (currentItems, previousItems, leavingItems)=>{
    const currentItemIds = currentItems.map((item)=>item.id);
    const previousItemIds = previousItems.map((item)=>item.id);
    const currentItemIdSet = new Set(currentItemIds);
    const previousItemIdSet = new Set(previousItemIds);
    const hasChanged = currentItemIds.some((id)=>!previousItemIdSet.has(id)) || previousItemIds.some((id)=>!currentItemIdSet.has(id));
    if (!hasChanged) return {
        hasChanged: false,
        enteringIds: new Set(),
        nextLeavingItems: leavingItems
    };
    const enteringIds = new Set(currentItemIds.filter((id)=>!previousItemIdSet.has(id)));
    const reconciledLeavingItems = leavingItems.filter((item)=>!currentItemIdSet.has(item.id));
    const alreadyLeavingIds = new Set(reconciledLeavingItems.map((item)=>item.id));
    const newLeavingItems = previousItems.filter((item)=>!currentItemIdSet.has(item.id) && !alreadyLeavingIds.has(item.id));
    return {
        hasChanged: true,
        enteringIds: enteringIds,
        nextLeavingItems: [
            ...reconciledLeavingItems,
            ...newLeavingItems
        ]
    };
};

});


parcelRegister("lqLuI", function(module, exports) {

$parcel$export(module.exports, "scr_previewColWidthChange", function () { return $732daf05340a9dd2$export$97d1d429cdc91eb7; });
const $732daf05340a9dd2$export$97d1d429cdc91eb7 = (action, state)=>{
    if (action.width === null) {
        if (!(action.colId in state.previewColWidths)) return state;
        const { [action.colId]: _removed, ...remaining } = state.previewColWidths;
        return {
            ...state,
            previewColWidths: remaining
        };
    }
    if (state.previewColWidths[action.colId] === action.width) return state;
    return {
        ...state,
        previewColWidths: {
            ...state.previewColWidths,
            [action.colId]: action.width
        }
    };
};

});

parcelRegister("5Mfbi", function(module, exports) {

$parcel$export(module.exports, "scr_previewRowHeightChange", function () { return $faae3cc8de4b6c4d$export$a439fe2bb228ad9a; });
const $faae3cc8de4b6c4d$export$a439fe2bb228ad9a = (action, state)=>{
    if (action.height === null) {
        if (!(action.rowId in state.previewRowHeights)) return state;
        const { [action.rowId]: _removed, ...remaining } = state.previewRowHeights;
        return {
            ...state,
            previewRowHeights: remaining
        };
    }
    if (state.previewRowHeights[action.rowId] === action.height) return state;
    return {
        ...state,
        previewRowHeights: {
            ...state.previewRowHeights,
            [action.rowId]: action.height
        }
    };
};

});

parcelRegister("4CKhC", function(module, exports) {

$parcel$export(module.exports, "scr_rowClicked", function () { return $b62631d5c0dea72f$export$1ee5a0c821b1d4e1; });

var $4zamZ = parcelRequire("4zamZ");
parcelRequire("2wRcQ");
var $72F2M = parcelRequire("72F2M");
var $1p2ZA = parcelRequire("1p2ZA");
var $fxikI = parcelRequire("fxikI");
const $b62631d5c0dea72f$export$1ee5a0c821b1d4e1 = (action, state)=>{
    const { rowId: rowId, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = action;
    const { selection: selection, selectionAnchor: selectionAnchor, prevRows: prevRows } = state;
    if (shiftKey) {
        if (selectionAnchor && selectionAnchor.type === "row") return {
            ...state,
            selection: ctrlKey || metaKey ? (0, $72F2M.addRowRangeToSelection)(selection, prevRows, selectionAnchor.rowId, rowId) : (0, $1p2ZA.setRowRangeSelection)(prevRows, selectionAnchor.rowId, rowId)
        };
        return {
            ...state,
            selection: {
                ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
                selectedRows: [
                    {
                        firstCellId: rowId
                    }
                ]
            },
            selectionAnchor: {
                type: "row",
                rowId: rowId
            }
        };
    }
    return {
        ...state,
        selection: ctrlKey || metaKey ? (0, $fxikI.toggleRowInSelection)(selection, rowId) : {
            ...(0, $4zamZ.EMPTY_SCAFFOLD_SELECTION),
            selectedRows: [
                {
                    firstCellId: rowId
                }
            ]
        },
        selectionAnchor: {
            type: "row",
            rowId: rowId
        }
    };
};

});

parcelRegister("elNJs", function(module, exports) {

$parcel$export(module.exports, "scr_rowEnterComplete", function () { return $e98de9c45f7d4445$export$ea15e708dbe5ac65; });
const $e98de9c45f7d4445$export$ea15e708dbe5ac65 = (action, state)=>{
    if (!state.enteringRowIds.has(action.rowId)) return state;
    const next = new Set(state.enteringRowIds);
    next.delete(action.rowId);
    return {
        ...state,
        enteringRowIds: next
    };
};

});

parcelRegister("7m2g8", function(module, exports) {

$parcel$export(module.exports, "scr_rowLeaveComplete", function () { return $61f6578b83241311$export$1a3bf6161f0a2204; });
const $61f6578b83241311$export$1a3bf6161f0a2204 = (action, state)=>({
        ...state,
        leavingRows: state.leavingRows.filter((r)=>r.id !== action.rowId)
    });

});

parcelRegister("zX8gw", function(module, exports) {

$parcel$export(module.exports, "scr_rowsChanged", function () { return $9c5d0e97c61e5e6e$export$6522f061e582ef5c; });

var $8XxPo = parcelRequire("8XxPo");
const $9c5d0e97c61e5e6e$export$6522f061e582ef5c = (action, state)=>{
    const reconciliation = (0, $8XxPo.reconcileScaffoldItems)(action.rows, state.prevRows, state.leavingRows);
    return !reconciliation.hasChanged ? state : {
        ...state,
        enteringRowIds: reconciliation.enteringIds,
        leavingRows: reconciliation.nextLeavingItems,
        prevRows: action.rows
    };
};

});

parcelRegister("9k7ni", function(module, exports) {

$parcel$export(module.exports, "scr_selectionChanged", function () { return $9b2505b88cb0c2a1$export$6079fe221acffb85; });
const $9b2505b88cb0c2a1$export$6079fe221acffb85 = (action, state)=>({
        ...state,
        selection: action.selection,
        selectionAnchor: null
    });

});

parcelRegister("1SvMT", function(module, exports) {

$parcel$export(module.exports, "scr_setDragging", function () { return $585e4b3c71458dea$export$ab01bf5fd45ff60b; });
const $585e4b3c71458dea$export$ab01bf5fd45ff60b = (action, state)=>({
        ...state,
        isDragging: action.isDragging
    });

});


parcelRegister("bK3BV", function(module, exports) {

$parcel$export(module.exports, "body", function () { return $88c6ca9a081dc5f8$export$32180ef41b15b513; }, function (v) { return $88c6ca9a081dc5f8$export$32180ef41b15b513 = v; });
$parcel$export(module.exports, "cell", function () { return $88c6ca9a081dc5f8$export$e2e1361cdc35271d; }, function (v) { return $88c6ca9a081dc5f8$export$e2e1361cdc35271d = v; });
$parcel$export(module.exports, "cellContent", function () { return $88c6ca9a081dc5f8$export$b3e5b2f2dfaeed75; }, function (v) { return $88c6ca9a081dc5f8$export$b3e5b2f2dfaeed75 = v; });
$parcel$export(module.exports, "cellLeaving", function () { return $88c6ca9a081dc5f8$export$8a3f5022f873121c; }, function (v) { return $88c6ca9a081dc5f8$export$8a3f5022f873121c = v; });
$parcel$export(module.exports, "cellResizing", function () { return $88c6ca9a081dc5f8$export$7b65290b667564b4; }, function (v) { return $88c6ca9a081dc5f8$export$7b65290b667564b4 = v; });
$parcel$export(module.exports, "cellSelected", function () { return $88c6ca9a081dc5f8$export$5ce057a02585195d; }, function (v) { return $88c6ca9a081dc5f8$export$5ce057a02585195d = v; });
$parcel$export(module.exports, "cellWithRowSpan", function () { return $88c6ca9a081dc5f8$export$e9e8bf8107bcc6bb; }, function (v) { return $88c6ca9a081dc5f8$export$e9e8bf8107bcc6bb = v; });
$parcel$export(module.exports, "colResizeHandle", function () { return $88c6ca9a081dc5f8$export$afc04767dd1cd2dc; }, function (v) { return $88c6ca9a081dc5f8$export$afc04767dd1cd2dc = v; });
$parcel$export(module.exports, "colResizeHandleDisabled", function () { return $88c6ca9a081dc5f8$export$a8a189742dc309ea; }, function (v) { return $88c6ca9a081dc5f8$export$a8a189742dc309ea = v; });
$parcel$export(module.exports, "colResizeOverlay", function () { return $88c6ca9a081dc5f8$export$307b7c34e981e610; }, function (v) { return $88c6ca9a081dc5f8$export$307b7c34e981e610 = v; });
$parcel$export(module.exports, "colSelectHandle", function () { return $88c6ca9a081dc5f8$export$e640260e805140e7; }, function (v) { return $88c6ca9a081dc5f8$export$e640260e805140e7 = v; });
$parcel$export(module.exports, "colSelectHandleSelected", function () { return $88c6ca9a081dc5f8$export$36ffebeca4bf609a; }, function (v) { return $88c6ca9a081dc5f8$export$36ffebeca4bf609a = v; });
$parcel$export(module.exports, "footer", function () { return $88c6ca9a081dc5f8$export$adb608be33961c98; }, function (v) { return $88c6ca9a081dc5f8$export$adb608be33961c98 = v; });
$parcel$export(module.exports, "header", function () { return $88c6ca9a081dc5f8$export$38e42c68cf43b5d4; }, function (v) { return $88c6ca9a081dc5f8$export$38e42c68cf43b5d4 = v; });
$parcel$export(module.exports, "row", function () { return $88c6ca9a081dc5f8$export$120ff0929b202a6d; }, function (v) { return $88c6ca9a081dc5f8$export$120ff0929b202a6d = v; });
$parcel$export(module.exports, "rowCells", function () { return $88c6ca9a081dc5f8$export$41e54bef763a37c2; }, function (v) { return $88c6ca9a081dc5f8$export$41e54bef763a37c2 = v; });
$parcel$export(module.exports, "rowCellsWithSpan", function () { return $88c6ca9a081dc5f8$export$90ce25cc2b233c4a; }, function (v) { return $88c6ca9a081dc5f8$export$90ce25cc2b233c4a = v; });
$parcel$export(module.exports, "rowGroup", function () { return $88c6ca9a081dc5f8$export$da117b1940f09074; }, function (v) { return $88c6ca9a081dc5f8$export$da117b1940f09074 = v; });
$parcel$export(module.exports, "rowLeaving", function () { return $88c6ca9a081dc5f8$export$84868fcdcc3bde41; }, function (v) { return $88c6ca9a081dc5f8$export$84868fcdcc3bde41 = v; });
$parcel$export(module.exports, "rowResizeHandle", function () { return $88c6ca9a081dc5f8$export$2bb1efb2b04c9462; }, function (v) { return $88c6ca9a081dc5f8$export$2bb1efb2b04c9462 = v; });
$parcel$export(module.exports, "rowResizeHandleDisabled", function () { return $88c6ca9a081dc5f8$export$7572739fd2d70b89; }, function (v) { return $88c6ca9a081dc5f8$export$7572739fd2d70b89 = v; });
$parcel$export(module.exports, "rowResizing", function () { return $88c6ca9a081dc5f8$export$6ef4649251b223a4; }, function (v) { return $88c6ca9a081dc5f8$export$6ef4649251b223a4 = v; });
$parcel$export(module.exports, "rowSelectHandle", function () { return $88c6ca9a081dc5f8$export$5dc579b272dc7ce1; }, function (v) { return $88c6ca9a081dc5f8$export$5dc579b272dc7ce1 = v; });
$parcel$export(module.exports, "rowSelectHandleSelected", function () { return $88c6ca9a081dc5f8$export$2a0421a348c2718c; }, function (v) { return $88c6ca9a081dc5f8$export$2a0421a348c2718c = v; });
$parcel$export(module.exports, "table", function () { return $88c6ca9a081dc5f8$export$9852986a3ec5f6a0; }, function (v) { return $88c6ca9a081dc5f8$export$9852986a3ec5f6a0 = v; });
$parcel$export(module.exports, "tableWrapper", function () { return $88c6ca9a081dc5f8$export$e7d47881ec916f76; }, function (v) { return $88c6ca9a081dc5f8$export$e7d47881ec916f76 = v; });
$parcel$export(module.exports, "zoneGrid", function () { return $88c6ca9a081dc5f8$export$e8728c4dee7ee1ba; }, function (v) { return $88c6ca9a081dc5f8$export$e8728c4dee7ee1ba = v; });
$parcel$export(module.exports, "zoneGridCell", function () { return $88c6ca9a081dc5f8$export$38ed7698121dea36; }, function (v) { return $88c6ca9a081dc5f8$export$38ed7698121dea36 = v; });
var $88c6ca9a081dc5f8$export$32180ef41b15b513;
var $88c6ca9a081dc5f8$export$e2e1361cdc35271d;
var $88c6ca9a081dc5f8$export$b3e5b2f2dfaeed75;
var $88c6ca9a081dc5f8$export$8a3f5022f873121c;
var $88c6ca9a081dc5f8$export$7b65290b667564b4;
var $88c6ca9a081dc5f8$export$5ce057a02585195d;
var $88c6ca9a081dc5f8$export$e9e8bf8107bcc6bb;
var $88c6ca9a081dc5f8$export$afc04767dd1cd2dc;
var $88c6ca9a081dc5f8$export$a8a189742dc309ea;
var $88c6ca9a081dc5f8$export$307b7c34e981e610;
var $88c6ca9a081dc5f8$export$e640260e805140e7;
var $88c6ca9a081dc5f8$export$36ffebeca4bf609a;
var $88c6ca9a081dc5f8$export$adb608be33961c98;
var $88c6ca9a081dc5f8$export$38e42c68cf43b5d4;
var $88c6ca9a081dc5f8$export$120ff0929b202a6d;
var $88c6ca9a081dc5f8$export$41e54bef763a37c2;
var $88c6ca9a081dc5f8$export$90ce25cc2b233c4a;
var $88c6ca9a081dc5f8$export$da117b1940f09074;
var $88c6ca9a081dc5f8$export$84868fcdcc3bde41;
var $88c6ca9a081dc5f8$export$2bb1efb2b04c9462;
var $88c6ca9a081dc5f8$export$7572739fd2d70b89;
var $88c6ca9a081dc5f8$export$6ef4649251b223a4;
var $88c6ca9a081dc5f8$export$5dc579b272dc7ce1;
var $88c6ca9a081dc5f8$export$2a0421a348c2718c;
var $88c6ca9a081dc5f8$export$9852986a3ec5f6a0;
var $88c6ca9a081dc5f8$export$e7d47881ec916f76;
var $88c6ca9a081dc5f8$export$e8728c4dee7ee1ba;
var $88c6ca9a081dc5f8$export$38ed7698121dea36;
$88c6ca9a081dc5f8$export$32180ef41b15b513 = `mos-Scaffold-module-XdYGQG-body`;
$88c6ca9a081dc5f8$export$e2e1361cdc35271d = `mos-Scaffold-module-XdYGQG-cell`;
$88c6ca9a081dc5f8$export$b3e5b2f2dfaeed75 = `mos-Scaffold-module-XdYGQG-cellContent`;
$88c6ca9a081dc5f8$export$8a3f5022f873121c = `mos-Scaffold-module-XdYGQG-cellLeaving`;
$88c6ca9a081dc5f8$export$7b65290b667564b4 = `mos-Scaffold-module-XdYGQG-cellResizing`;
$88c6ca9a081dc5f8$export$5ce057a02585195d = `mos-Scaffold-module-XdYGQG-cellSelected`;
$88c6ca9a081dc5f8$export$e9e8bf8107bcc6bb = `mos-Scaffold-module-XdYGQG-cellWithRowSpan`;
$88c6ca9a081dc5f8$export$afc04767dd1cd2dc = `mos-Scaffold-module-XdYGQG-colResizeHandle`;
$88c6ca9a081dc5f8$export$a8a189742dc309ea = `mos-Scaffold-module-XdYGQG-colResizeHandleDisabled`;
$88c6ca9a081dc5f8$export$307b7c34e981e610 = `mos-Scaffold-module-XdYGQG-colResizeOverlay`;
$88c6ca9a081dc5f8$export$e640260e805140e7 = `mos-Scaffold-module-XdYGQG-colSelectHandle`;
$88c6ca9a081dc5f8$export$36ffebeca4bf609a = `mos-Scaffold-module-XdYGQG-colSelectHandleSelected`;
$88c6ca9a081dc5f8$export$adb608be33961c98 = `mos-Scaffold-module-XdYGQG-footer`;
$88c6ca9a081dc5f8$export$38e42c68cf43b5d4 = `mos-Scaffold-module-XdYGQG-header`;
$88c6ca9a081dc5f8$export$120ff0929b202a6d = `mos-Scaffold-module-XdYGQG-row`;
$88c6ca9a081dc5f8$export$41e54bef763a37c2 = `mos-Scaffold-module-XdYGQG-rowCells`;
$88c6ca9a081dc5f8$export$90ce25cc2b233c4a = `mos-Scaffold-module-XdYGQG-rowCellsWithSpan`;
$88c6ca9a081dc5f8$export$da117b1940f09074 = `mos-Scaffold-module-XdYGQG-rowGroup`;
$88c6ca9a081dc5f8$export$84868fcdcc3bde41 = `mos-Scaffold-module-XdYGQG-rowLeaving`;
$88c6ca9a081dc5f8$export$2bb1efb2b04c9462 = `mos-Scaffold-module-XdYGQG-rowResizeHandle`;
$88c6ca9a081dc5f8$export$7572739fd2d70b89 = `mos-Scaffold-module-XdYGQG-rowResizeHandleDisabled`;
$88c6ca9a081dc5f8$export$6ef4649251b223a4 = `mos-Scaffold-module-XdYGQG-rowResizing`;
$88c6ca9a081dc5f8$export$5dc579b272dc7ce1 = `mos-Scaffold-module-XdYGQG-rowSelectHandle`;
$88c6ca9a081dc5f8$export$2a0421a348c2718c = `mos-Scaffold-module-XdYGQG-rowSelectHandleSelected`;
$88c6ca9a081dc5f8$export$9852986a3ec5f6a0 = `mos-Scaffold-module-XdYGQG-table`;
$88c6ca9a081dc5f8$export$e7d47881ec916f76 = `mos-Scaffold-module-XdYGQG-tableWrapper`;
$88c6ca9a081dc5f8$export$e8728c4dee7ee1ba = `mos-Scaffold-module-XdYGQG-zoneGrid`;
$88c6ca9a081dc5f8$export$38ed7698121dea36 = `mos-Scaffold-module-XdYGQG-zoneGridCell`;

});

parcelRegister("kZbhv", function(module, exports) {

$parcel$export(module.exports, "ScaffoldColResizeHandle", function () { return $a85978fb0d77bc36$export$c92236b18139d109; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $cqVqv = parcelRequire("cqVqv");

var $4zamZ = parcelRequire("4zamZ");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");
const $a85978fb0d77bc36$export$9153ba04ac8b58a9 = (headerSpanMap, orderedColIds, rowId, cellColId, targetColId)=>{
    if (cellColId === targetColId) return true;
    if (headerSpanMap === undefined || rowId === undefined) return false;
    const rowSpanInfo = headerSpanMap[rowId];
    const cellInfo = rowSpanInfo?.[cellColId];
    if (cellInfo?.mode !== "spanning" || cellInfo.effectiveWidth === undefined) return false;
    const startIndex = orderedColIds.indexOf(cellColId);
    const targetIndex = orderedColIds.indexOf(targetColId);
    if (startIndex < 0 || targetIndex < 0 || targetIndex <= startIndex) return false;
    for(let i = startIndex + 1; i <= targetIndex; i++){
        const coveredInfo = rowSpanInfo?.[orderedColIds[i]];
        if (coveredInfo?.mode !== "covered-same-row") return false;
    }
    return true;
};
const $a85978fb0d77bc36$export$c92236b18139d109 = ({ colId: colId })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const leavingCol = scaffoldContext.state.leavingCols.find((c)=>c.id === colId);
    const enteringCol = scaffoldContext.state.enteringColIds.has(colId);
    const col = scaffoldContext.settings.columns.find((c)=>c.id === colId) ?? leavingCol;
    const justification = scaffoldContext.settings.justification ?? "left";
    // Calculate left offset by accumulating column widths (including this column)
    const orderedCols = [
        ...scaffoldContext.settings.columns,
        ...scaffoldContext.state.leavingCols
    ].sort((a, b)=>a.colNumber - b.colNumber);
    const orderedColIds = orderedCols.map((orderedCol)=>orderedCol.id);
    let leftOffset = 0;
    for (const c of orderedCols){
        leftOffset += scaffoldContext.state.previewColWidths[c.id] ?? c.width;
        if (c.id === colId) break;
    }
    // For right justification the handle sits at the left edge of the column so that
    // dragging leftward widens the column as the table grows toward the left.
    const thisColWidth = scaffoldContext.state.previewColWidths[colId] ?? col?.width ?? 0;
    const handleLeftOffset = justification === "right" ? leftOffset - thisColWidth : leftOffset;
    // Derive canResize from context state
    const isDragging = scaffoldContext.state.isDragging === true;
    const canResize = scaffoldContext.settings.disabled !== true && scaffoldContext.settings.onChangeCol !== undefined && !isDragging && !leavingCol && !enteringCol && col !== undefined;
    const resizeSessionRef = (0, $7fPBF.useRef)(null);
    const colRef = (0, $7fPBF.useRef)(col);
    const leavingColRef = (0, $7fPBF.useRef)(leavingCol);
    const onChangeColRef = (0, $7fPBF.useRef)(scaffoldContext.settings.onChangeCol);
    const scaffoldRootRef = (0, $7fPBF.useRef)(null);
    /**
   * Adds the cellResizing CSS class to the scaffold root so all cells show the col-resize
   * cursor throughout the drag, regardless of where the pointer is within the scaffold.
   */ const applyResizingClass = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else -- scaffoldRootRef is always set before applyResizingClass is called */ if (scaffoldRootRef.current !== null) scaffoldRootRef.current.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cellResizing);
    }, []);
    /**
   * Removes the cellResizing CSS class from the scaffold root after a resize session ends.
   */ const clearResizingClass = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else -- scaffoldRootRef is always set before clearResizingClass is called */ if (scaffoldRootRef.current !== null) scaffoldRootRef.current.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cellResizing);
    }, []);
    /**
   * Keeps mutable refs synchronised for document-level column resize handlers.
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        colRef.current = col;
        leavingColRef.current = leavingCol;
        onChangeColRef.current = scaffoldContext.settings.onChangeCol;
    }, [
        col,
        leavingCol,
        scaffoldContext.settings.onChangeCol
    ]);
    /**
   * Applies column width updates during drag by manipulating DOM style directly (no React state).
   * Uses delta-based calculation from initial width for instant visual feedback and jsdom compatibility.
   * The delta is multiplied by 2 for centre-justified tables (the table expands symmetrically so
   * the column edge moves at half the mouse rate) and inverted for right-justified tables (the handle
   * sits at the left edge and dragging left widens the column).
   *
   * @param e - Native mouse move event emitted on the window.
   */ const handleResizeMouseMove = (e)=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const deltaMultiplier = justification === "center" ? 2 : justification === "right" ? -1 : 1;
        const nextWidth = Math.max((0, $4zamZ.MIN_SCAFFOLD_COL_WIDTH_PX), Math.round(session.startWidth + deltaMultiplier * (e.clientX - session.startX)));
        if (nextWidth === session.latestWidth) return;
        const widthDelta = nextWidth - session.startWidth;
        session.latestWidth = nextWidth;
        session.targetCells.forEach((targetCell)=>{
            const targetWidth = Math.max((0, $4zamZ.MIN_SCAFFOLD_COL_WIDTH_PX), targetCell.startWidth + widthDelta);
            targetCell.cell.style.width = `${targetWidth}px`;
        });
    };
    /**
   * Clears transient inline width styles from all cells participating in an active column resize.
   */ const clearColumnResizeStyles = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore next -- only called from handleResizeMouseUp when session is non-null */ if (resizeSessionRef.current === null) return;
        resizeSessionRef.current.targetCells.forEach((targetCell)=>{
            targetCell.cell.style.width = "";
        });
    }, []);
    /**
   * Reads an element's inline width in pixels, falling back to a provided default width.
   *
   * @param cell - Cell element whose width should be measured.
   * @param fallbackWidth - Width to use when no parseable inline width exists.
   * @returns The parsed or fallback width in pixels.
   */ const getCellWidthOrFallback = (0, $7fPBF.useCallback)((cell, fallbackWidth)=>{
        const parsedWidth = Math.round(parseFloat(cell.style.width));
        return parsedWidth || fallbackWidth;
    }, []);
    /**
   * Completes column resize by extracting final width from inline style and emitting single update.
   */ const handleResizeMouseUp = (0, $7fPBF.useCallback)(()=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) {
            clearResizingClass();
            scaffoldRootRef.current = null;
            return;
        }
        clearResizingClass();
        scaffoldRootRef.current = null;
        const width = session.latestWidth;
        resizeSessionRef.current = null;
        const currentCol = colRef.current;
        const currentLeavingCol = leavingColRef.current;
        if (currentCol !== undefined && !currentLeavingCol && width !== currentCol.width) onChangeColRef.current?.(colId, {
            ...currentCol,
            width: width
        });
    }, [
        clearResizingClass,
        colId
    ]);
    /**
   * Ensures document listeners are cleaned up on unmount.
   */ (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            clearResizingClass();
            scaffoldRootRef.current = null;
            clearColumnResizeStyles();
            resizeSessionRef.current = null;
        };
    }, [
        clearColumnResizeStyles,
        clearResizingClass
    ]);
    /**
   * Starts a column width drag operation from this resize handle.
   *
   * @param event - React mouse down event from the resize handle.
   */ const handleResizeMouseDown = (event)=>{
        if (canResize) {
            event.preventDefault();
            const scaffoldRoot = document.getElementById(scaffoldContext.settings.id);
            /* istanbul ignore else */ if (scaffoldRoot !== null) {
                const targetCells = Array.from(scaffoldRoot.querySelectorAll("div[data-scaffold-col-id]")).filter((element)=>{
                    if (!(element instanceof HTMLDivElement)) return false;
                    const cellRowId = element.dataset.scaffoldRowId;
                    const cellColId = element.dataset.scaffoldColId;
                    if (cellColId === undefined) return false;
                    return $a85978fb0d77bc36$export$9153ba04ac8b58a9(scaffoldContext.headerSpanMap, orderedColIds, cellRowId, cellColId, colId);
                });
                /* istanbul ignore else */ if (targetCells.length > 0) {
                    const referenceCell = targetCells.find((targetCell)=>{
                        if (targetCell.dataset.scaffoldColId !== colId) return false;
                        const targetRowId = targetCell.dataset.scaffoldRowId;
                        const targetCellInfo = targetRowId !== undefined ? scaffoldContext.headerSpanMap?.[targetRowId]?.[colId] : undefined;
                        return targetCellInfo?.mode !== "spanning";
                    });
                    const currentWidth = referenceCell !== undefined ? getCellWidthOrFallback(referenceCell, col.width) : col.width;
                    resizeSessionRef.current = {
                        startX: event.clientX,
                        startWidth: currentWidth,
                        latestWidth: currentWidth,
                        targetCells: targetCells.map((targetCell)=>({
                                cell: targetCell,
                                startWidth: getCellWidthOrFallback(targetCell, currentWidth)
                            }))
                    };
                    resizeSessionRef.current.targetCells.forEach((targetCell)=>{
                        targetCell.cell.style.width = `${targetCell.startWidth}px`;
                    });
                    scaffoldRootRef.current = scaffoldRoot;
                    clearResizingClass();
                    applyResizingClass();
                }
            }
        }
    };
    const { onMouseDown: onResizeHandleMouseDown } = (0, $d8dTd.useMouseMove)({
        onMouseDown: handleResizeMouseDown,
        onMouseMove: handleResizeMouseMove,
        onMouseUp: handleResizeMouseUp
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).colResizeHandle,
            canResize ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).colResizeHandleDisabled
        ]),
        style: {
            left: handleLeftOffset
        },
        onMouseDown: onResizeHandleMouseDown
    });
};
$a85978fb0d77bc36$export$c92236b18139d109.displayName = "ScaffoldColResizeHandle";

});

parcelRegister("iQhKl", function(module, exports) {

$parcel$export(module.exports, "ScaffoldColSelectHandle", function () { return $59ab119c2235e3ea$export$938d1c980c519dd7; });

var $bbzbN = parcelRequire("bbzbN");

var $cqVqv = parcelRequire("cqVqv");

var $k4Vha = parcelRequire("k4Vha");
parcelRequire("2wRcQ");
var $aLSh4 = parcelRequire("aLSh4");

var $4zamZ = parcelRequire("4zamZ");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");
const $59ab119c2235e3ea$export$938d1c980c519dd7 = ({ colId: colId, left: left, width: width })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const isSelected = (0, $aLSh4.isColInSelection)(scaffoldContext.state.selection, colId);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
        type: "button",
        "aria-label": "Select column",
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).colSelectHandle,
            isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).colSelectHandleSelected : undefined
        ]),
        style: {
            left: left,
            width: width,
            height: (0, $4zamZ.SCAFFOLD_SELECT_HANDLE_SIZE_PX)
        },
        onClick: (event)=>{
            event.preventDefault();
            scaffoldContext.dispatch({
                operation: (0, $k4Vha.COL_CLICKED),
                colId: colId,
                ctrlKey: event.ctrlKey,
                metaKey: event.metaKey,
                shiftKey: event.shiftKey
            });
        }
    });
};
$59ab119c2235e3ea$export$938d1c980c519dd7.displayName = "ScaffoldColSelectHandle";

});

parcelRegister("1UWJN", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRowGroups", function () { return $324e0dcefe87bf48$export$38b33fefcd8c69b9; });

var $bbzbN = parcelRequire("bbzbN");

var $cqVqv = parcelRequire("cqVqv");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");

var $98R3j = parcelRequire("98R3j");
const $324e0dcefe87bf48$export$38b33fefcd8c69b9 = ()=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const currentRowIdSet = new Set(scaffoldContext.settings.rows.map((r)=>r.id));
    const rgStyles = {
        header: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).header,
        body: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).body,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).footer
    };
    const allDisplayRows = [
        ...scaffoldContext.settings.rows,
        ...scaffoldContext.state.leavingRows
    ].sort((a, b)=>{
        if (a.rowNumber !== b.rowNumber) return a.rowNumber - b.rowNumber;
        // When row numbers collide during removal, keep the leaving row first so it visibly collapses.
        const isALeavingRow = !currentRowIdSet.has(a.id);
        const isBLeavingRow = !currentRowIdSet.has(b.id);
        if (isALeavingRow === isBLeavingRow) return 0;
        return isALeavingRow ? -1 : 1;
    });
    const rowGroupList = new Set(allDisplayRows.map((r)=>r.rowGroupNumber));
    const rowGroupTypes = allDisplayRows.reduce((acc, r)=>{
        acc[r.rowGroupNumber] = r.type;
        return acc;
    }, {});
    return Array.from(rowGroupList).map((rgNum)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: (0, $cqVqv.classMerge)([
                (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowGroup,
                rgStyles[rowGroupTypes[rgNum]]
            ]),
            children: allDisplayRows.filter((r)=>r.rowGroupNumber === rgNum).map((r, ix, arr)=>{
                let id = r.id;
                const style = {};
                /* Check for non-unique rowIDs from bad input data and highlight them,
             added for debugging, doesn't require testing */ // istanbul ignore next
                if (arr.findIndex((row)=>row.id === r.id) !== ix) {
                    console.warn(`Duplicate row ID detected: ${r.id}. Appending index to make unique.`);
                    id = `${r.id}-${ix}`;
                    style.background = "rgba(255, 0, 0, 0.1)";
                }
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $98R3j.ScaffoldRow), {
                    rowId: r.id,
                    style: style
                }, `row-${id}`);
            })
        }, `row-group-${rgNum}`));
};
$324e0dcefe87bf48$export$38b33fefcd8c69b9.displayName = "ScaffoldRowGroups";

});
parcelRegister("98R3j", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRow", function () { return $a146ee5c295c3210$export$3bcb108d4b2aa233; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cqVqv = parcelRequire("cqVqv");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");

var $2efi6 = parcelRequire("2efi6");

var $1xmT4 = parcelRequire("1xmT4");

var $jV9ZK = parcelRequire("jV9ZK");

var $k4Vha = parcelRequire("k4Vha");

var $4zamZ = parcelRequire("4zamZ");
const $a146ee5c295c3210$export$3bcb108d4b2aa233 = ({ rowId: rowId, style: style })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const { columns: columns, rows: rows } = scaffoldContext.settings;
    const { leavingCols: leavingCols, enteringRowIds: enteringRowIds, leavingRows: leavingRows } = scaffoldContext.state;
    const isEnteringRow = enteringRowIds.has(rowId);
    const leavingRow = leavingRows.find((r)=>r.id === rowId);
    const row = rows.find((r)=>r.id === rowId) || leavingRow;
    /**
   * Determine initial state: entering rows start at "placed" (0px), leaving start at "open" (full)
   */ const getInitialState = ()=>isEnteringRow ? "placed" : "open";
    const [state, setState] = (0, $7fPBF.useState)(getInitialState());
    // Store timeout IDs to clear them on cleanup
    const timeoutsRef = (0, $7fPBF.useRef)([]);
    const wasLeavingRowRef = (0, $7fPBF.useRef)(Boolean(leavingRow));
    const hasNotifiedRowLeaveCompleteRef = (0, $7fPBF.useRef)(false);
    const hasNotifiedRowEnterCompleteRef = (0, $7fPBF.useRef)(false);
    /**
   * State machine for entering rows: placed (5ms delay) → opening (animate for 200ms) → open
   * State machine for leaving rows: open → closing (animate for 200ms) → closed (unmount)
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        if (state !== "closing") hasNotifiedRowLeaveCompleteRef.current = false;
        if (state !== "opening") hasNotifiedRowEnterCompleteRef.current = false;
        if (state === "placed") {
            const id = window.setTimeout(()=>{
                setState("opening");
            }, (0, $4zamZ.SCAFFOLD_ANIMATION_START_DELAY_MS));
            timeoutsRef.current.push(id);
        }
        if (state === "opening") {
            const id = window.setTimeout(()=>{
                setState("open");
                /* istanbul ignore else */ if (isEnteringRow && !hasNotifiedRowEnterCompleteRef.current) {
                    hasNotifiedRowEnterCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $k4Vha.ROW_ENTER_COMPLETE),
                        rowId: rowId
                    });
                }
            }, (0, $4zamZ.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        if (state === "closing") {
            const id = window.setTimeout(()=>{
                setState("closed");
                /* istanbul ignore else */ if (leavingRow && !hasNotifiedRowLeaveCompleteRef.current) {
                    hasNotifiedRowLeaveCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $k4Vha.ROW_LEAVE_COMPLETE),
                        rowId: rowId
                    });
                }
            }, (0, $4zamZ.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        // Cleanup: clear all scheduled timeouts
        return ()=>{
            timeoutsRef.current.forEach((id)=>clearTimeout(id));
            timeoutsRef.current = [];
        };
    }, [
        isEnteringRow,
        leavingRow,
        rowId,
        scaffoldContext,
        state
    ]);
    /**
   * When a row enters the leaving state, trigger the closing animation.
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        if (leavingRow && state === "open") // This needs to be disabled as immediate effects need to occur from useLayoutEffect
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setState("closing");
    }, [
        leavingRow,
        state
    ]);
    /**
   * If a row stops being a leaving row before the close animation completes,
   * reset its state so it can remain visible.
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        const wasLeavingRow = wasLeavingRowRef.current;
        const isLeavingRow = Boolean(leavingRow);
        if (wasLeavingRow && !isLeavingRow) // This needs to be disabled as immediate effects need to occur from useLayoutEffect
        setState(isEnteringRow ? "placed" : "open");
        wasLeavingRowRef.current = isLeavingRow;
    }, [
        isEnteringRow,
        leavingRow
    ]);
    const currentColIdSet = new Set(columns.map((c)=>c.id));
    const allDisplayCols = [
        ...columns,
        ...leavingCols.filter((c)=>!currentColIdSet.has(c.id))
    ].sort((a, b)=>{
        if (a.colNumber !== b.colNumber) return a.colNumber - b.colNumber;
        // When col numbers collide during removal, keep the leaving col first so it visibly collapses.
        const isALeavingCol = !currentColIdSet.has(a.id);
        const isBLeavingCol = !currentColIdSet.has(b.id);
        if (isALeavingCol === isBLeavingCol) return 0;
        return isALeavingCol ? -1 : 1;
    });
    const rowHeight = row?.height ?? // istanbul ignore next
    0;
    const previewRowHeight = scaffoldContext.state.previewRowHeights[rowId];
    const liveRowHeight = previewRowHeight ?? rowHeight;
    // Height is 0 in "placed" state (entering), or when "closing" (leaving). Otherwise full height.
    const displayHeight = state === "placed" || state === "closing" ? 0 : liveRowHeight;
    /** True when any cell in this row has an active rowSpan; requires overflow:visible on rowCells. */ const rowHasRowSpanningCells = allDisplayCols.some((c)=>scaffoldContext.headerSpanMap?.[rowId]?.[c.id]?.hasRowSpan);
    return state === "closed" ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).row,
            leavingRow ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowLeaving : undefined,
            previewRowHeight !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowResizing : undefined
        ]),
        style: {
            ...style,
            height: displayHeight,
            transition: previewRowHeight === undefined && (state === "opening" || state === "closing") ? `height ${0, $4zamZ.SCAFFOLD_ANIMATION_DURATION_MS}ms linear` : undefined
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1xmT4.ScaffoldRowResizeHandle), {
                rowId: rowId
            }),
            scaffoldContext.settings.onSelectionChange !== undefined && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jV9ZK.ScaffoldRowSelectHandle), {
                rowId: rowId
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowCells,
                    rowHasRowSpanningCells ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowCellsWithSpan : undefined
                ]),
                children: allDisplayCols.map((c, ix, arr)=>{
                    let id = c.id;
                    const style = {};
                    /* Check for non-unique columnIDs from bad input data and highlight them,
             added for debugging, doesn't require testing */ // istanbul ignore next
                    if (arr.findIndex((col)=>col.id === c.id) !== ix) {
                        console.warn(`Duplicate column ID detected: ${c.id}. Appending index to make unique.`);
                        id = `${c.id}-${ix}`;
                        style.background = "rgba(255, 0, 0, 0.1)";
                    }
                    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2efi6.ScaffoldCell), {
                        rowId: rowId,
                        colId: c.id,
                        rowHeightOverride: previewRowHeight,
                        style: style
                    }, `${rowId}-${id}`);
                })
            })
        ]
    });
};
$a146ee5c295c3210$export$3bcb108d4b2aa233.displayName = "ScaffoldRow";

});
parcelRegister("2efi6", function(module, exports) {

$parcel$export(module.exports, "ScaffoldCell", function () { return $eb1a621ac3225c0c$export$dbbbdee3e4fba4de; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cqVqv = parcelRequire("cqVqv");

var $k4Vha = parcelRequire("k4Vha");
parcelRequire("2wRcQ");
var $ckvsA = parcelRequire("ckvsA");

var $4zamZ = parcelRequire("4zamZ");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");

var $hQZyf = parcelRequire("hQZyf");
const $eb1a621ac3225c0c$export$dbbbdee3e4fba4de = ({ rowId: rowId, colId: colId, rowHeightOverride: rowHeightOverride, style: style })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const isEnteringCol = scaffoldContext.state.enteringColIds.has(colId);
    const leavingCol = scaffoldContext.state.leavingCols.find((c)=>c.id === colId);
    const col = scaffoldContext.settings.columns.find((c)=>c.id === colId) ?? leavingCol;
    const row = scaffoldContext.settings.rows.find((r)=>r.id === rowId) ?? scaffoldContext.state.leavingRows.find((r)=>r.id === rowId);
    /**
   * Determine initial state: entering columns start at "placed" (0px), leaving start at "open" (full).
   * All other columns start in the settled open state.
   *
   * @returns The initial animation state for the cell.
   */ const getInitialState = ()=>{
        if (isEnteringCol) return "placed";
        if (leavingCol) return "open";
        return "open";
    };
    const [animationState, setAnimationState] = (0, $7fPBF.useState)(getInitialState());
    const timeoutsRef = (0, $7fPBF.useRef)([]);
    const wasLeavingColRef = (0, $7fPBF.useRef)(Boolean(leavingCol));
    const hasNotifiedColLeaveCompleteRef = (0, $7fPBF.useRef)(false);
    const hasNotifiedColEnterCompleteRef = (0, $7fPBF.useRef)(false);
    /**
   * State machine for entering columns: placed (5ms delay) -> opening (animate for 200ms) -> open.
   * State machine for leaving columns: open -> closing (animate for 200ms) -> closed (unmount).
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        if (animationState !== "closing") hasNotifiedColLeaveCompleteRef.current = false;
        if (animationState !== "opening") hasNotifiedColEnterCompleteRef.current = false;
        if (animationState === "placed") {
            const id = window.setTimeout(()=>{
                setAnimationState("opening");
            }, (0, $4zamZ.SCAFFOLD_ANIMATION_START_DELAY_MS));
            timeoutsRef.current.push(id);
        }
        if (animationState === "opening") {
            const id = window.setTimeout(()=>{
                setAnimationState("open");
                /* istanbul ignore else */ if (isEnteringCol && !hasNotifiedColEnterCompleteRef.current) {
                    hasNotifiedColEnterCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $k4Vha.COL_ENTER_COMPLETE),
                        colId: colId
                    });
                }
            }, (0, $4zamZ.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        if (animationState === "closing") {
            const id = window.setTimeout(()=>{
                setAnimationState("closed");
                /* istanbul ignore else */ if (leavingCol && !hasNotifiedColLeaveCompleteRef.current) {
                    hasNotifiedColLeaveCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $k4Vha.COL_LEAVE_COMPLETE),
                        colId: colId
                    });
                }
            }, (0, $4zamZ.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        return ()=>{
            timeoutsRef.current.forEach((id)=>clearTimeout(id));
            timeoutsRef.current = [];
        };
    }, [
        animationState,
        colId,
        isEnteringCol,
        leavingCol,
        scaffoldContext
    ]);
    /**
   * When a column enters the leaving state, trigger the closing animation.
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        if (leavingCol && animationState === "open") (0, $7fPBF.startTransition)(()=>setAnimationState("closing"));
    }, [
        leavingCol,
        animationState
    ]);
    /**
   * If a column stops being a leaving column before close completes,
   * reset so it can remain visible.
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        const wasLeavingCol = wasLeavingColRef.current;
        const isLeavingCol = Boolean(leavingCol);
        if (wasLeavingCol && !isLeavingCol) (0, $7fPBF.startTransition)(()=>setAnimationState(isEnteringCol ? "placed" : "open"));
        wasLeavingColRef.current = isLeavingCol;
    }, [
        isEnteringCol,
        leavingCol
    ]);
    const colWidth = col?.width ?? 0;
    const rowHeight = rowHeightOverride ?? row?.height;
    const textAlignment = row?.textAlignment ?? col?.textAlignment ?? "default";
    const cellEditor = col?.cellComponent ?? scaffoldContext.settings.cellComponent;
    const cellValue = leavingCol || scaffoldContext.settings.cellData[rowId]?.[colId] === undefined ? cellEditor.blankT : scaffoldContext.settings.cellData[rowId]?.[colId];
    const CellEditor = cellEditor.Editor;
    /** Span information for this cell, if any span definitions are active. */ const spanInfo = scaffoldContext.headerSpanMap?.[rowId]?.[colId];
    /**
   * Cells covered by a colSpan in the same row are removed from the DOM so the spanning
   * cell's width fills the correct space without duplication.
   */ const isCoveredSameRow = spanInfo?.mode === "covered-same-row";
    /**
   * Cells covered by a rowSpan from a preceding row are rendered as invisible placeholders
   * to preserve flex column alignment in subsequent rows.
   */ const isCoveredOtherRow = spanInfo?.mode === "covered-other-row";
    /** Effective width: use merged column width for spanning cells, otherwise normal column width. */ const effectiveColWidth = spanInfo?.effectiveWidth ?? colWidth;
    /** Effective height: use merged row height for spanning cells, otherwise normal row height. */ const effectiveRowHeight = spanInfo?.effectiveHeight ?? rowHeight;
    const displayWidth = animationState === "placed" || animationState === "closing" ? 0 : effectiveColWidth;
    const isSelected = (0, $ckvsA.isCellHighlighted)(scaffoldContext.state.selection, rowId, colId);
    return animationState === "closed" || !col || isCoveredSameRow ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cell,
            leavingCol ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cellLeaving : undefined,
            isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cellSelected : undefined,
            spanInfo?.hasRowSpan ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cellWithRowSpan : undefined
        ]),
        "data-scaffold-col-id": colId,
        "data-scaffold-row-id": rowId,
        style: {
            ...style,
            visibility: isCoveredOtherRow ? "hidden" : undefined,
            width: displayWidth,
            height: effectiveRowHeight,
            transition: animationState === "opening" || animationState === "closing" ? `width ${0, $4zamZ.SCAFFOLD_ANIMATION_DURATION_MS}ms linear` : undefined
        },
        onClick: (event)=>{
            if (!isCoveredOtherRow) {
                if (event.shiftKey) event.preventDefault();
                scaffoldContext.dispatch({
                    operation: (0, $k4Vha.CELL_CLICKED),
                    rowId: rowId,
                    colId: colId,
                    ctrlKey: event.ctrlKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
            }
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).cellContent,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(CellEditor, {
                    id: `${rowId}-${colId}`,
                    colId: colId,
                    editable: !scaffoldContext.settings.disabled,
                    rowId: rowId,
                    setValue: (newValue)=>scaffoldContext.settings.onChangeCell?.(rowId, colId, newValue),
                    textAlignment: textAlignment,
                    value: cellValue
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hQZyf.ScaffoldZoneGrid), {
                rowId: rowId,
                colId: colId
            })
        ]
    });
};
$eb1a621ac3225c0c$export$dbbbdee3e4fba4de.displayName = "ScaffoldCell";

});
parcelRegister("hQZyf", function(module, exports) {

$parcel$export(module.exports, "ScaffoldZoneGrid", function () { return $fd775f2bd94586bc$export$831bc2bab2690d94; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");

var $k4Vha = parcelRequire("k4Vha");

var $4zamZ = parcelRequire("4zamZ");
const $fd775f2bd94586bc$export$831bc2bab2690d94 = ({ rowId: rowId, colId: colId })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const [activeZone, setActiveZone] = (0, $7fPBF.useState)(null);
    const [activeHighlightedZones, setActiveHighlightedZones] = (0, $7fPBF.useState)(new Set());
    const [activeHighlightColor, setActiveHighlightColor] = (0, $7fPBF.useState)(undefined);
    const [containerSize, setContainerSize] = (0, $7fPBF.useState)({
        width: 0,
        height: 0
    });
    const divRef = (0, $7fPBF.useRef)(null);
    /**
   * Resolves highlight behaviour for a zone from static or function-based zoneColors.
   *
   * @param zone - Zone being evaluated.
   * @returns Resolved highlight colour and additional highlighted zones.
   */ const resolveZoneHighlight = (zone)=>{
        const zoneColors = scaffoldContext.settings.zoneColors;
        const row = scaffoldContext.settings.rows.find((r)=>r.id === rowId) ?? scaffoldContext.state.leavingRows.find((r)=>r.id === rowId);
        const col = scaffoldContext.settings.columns.find((c)=>c.id === colId) ?? scaffoldContext.state.leavingCols.find((c)=>c.id === colId);
        if (typeof zoneColors === "function") return zoneColors({
            rowId: rowId,
            colId: colId,
            rowNumber: row?.rowNumber,
            colNumber: col?.colNumber,
            zone: zone
        });
        return {
            color: zoneColors[zone],
            additionalHighlightedZones: []
        };
    };
    (0, $7fPBF.useLayoutEffect)(()=>{
        const el = divRef.current;
        /* istanbul ignore else */ if (el) {
            const observer = new ResizeObserver(([entry])=>{
                const { width: width, height: height } = entry.contentRect;
                setContainerSize({
                    width: width,
                    height: height
                });
            });
            observer.observe(el);
            return ()=>observer.disconnect();
        }
    }, []);
    /** Hide zones if the container is smaller than the minimum size for side zones */ const showHorizontalSides = containerSize.width >= (0, $4zamZ.SIDE_ZONE_MIN_SIZE);
    const showVerticalSides = containerSize.height >= (0, $4zamZ.SIDE_ZONE_MIN_SIZE);
    const visibleZones = (0, $4zamZ.ZONE_GRID_ORDER).filter((zone)=>{
        if (!showHorizontalSides && (0, $4zamZ.HORIZONTAL_SIDE_ZONES).has(zone)) return false;
        if (!showVerticalSides && (0, $4zamZ.VERTICAL_SIDE_ZONES).has(zone)) return false;
        return true;
    });
    const colTemplate = showHorizontalSides ? `${0, $4zamZ.SIDE_ZONE_SIZE}px 1fr 1fr ${0, $4zamZ.SIDE_ZONE_SIZE}px` : "1fr 1fr";
    const rowTemplate = showVerticalSides ? `${0, $4zamZ.SIDE_ZONE_SIZE}px 1fr 1fr ${0, $4zamZ.SIDE_ZONE_SIZE}px` : "1fr 1fr";
    /**
   * Clears any active zone highlight state.
   */ const clearActiveZoneHighlight = ()=>{
        setActiveZone(null);
        setActiveHighlightedZones(new Set());
        setActiveHighlightColor(undefined);
    };
    /**
   * Handles drag-over highlighting for a zone.
   *
   * @param event - Drag event from the hovered zone element.
   * @param zone - Zone currently being hovered.
   */ const onZoneDragOver = (event, zone)=>{
        const highlight = resolveZoneHighlight(zone);
        if (highlight.color !== null) {
            event.preventDefault();
            const highlightedZones = new Set([
                zone,
                ...highlight.additionalHighlightedZones ?? []
            ]);
            setActiveZone(zone);
            setActiveHighlightedZones(highlightedZones);
            setActiveHighlightColor(highlight.color);
        } else clearActiveZoneHighlight();
    };
    /**
   * Clears highlight state when the pointer leaves the zone-grid container.
   *
   * @param event - Drag leave event from any zone cell.
   */ const onZoneDragLeave = (event)=>{
        // Only clear zone if leaving entirely (not moving to a sibling zone in the grid)
        if (event.relatedTarget instanceof Node && event.currentTarget.parentElement?.contains(event.relatedTarget)) return;
        clearActiveZoneHighlight();
    };
    /**
   * Handles a drop for a zone, including optional drop suppression via zone-color resolver.
   *
   * @param event - Drop event from the target zone element.
   * @param zone - Zone receiving the drop.
   */ const onZoneDrop = (event, zone)=>{
        const highlight = resolveZoneHighlight(zone);
        if (highlight.color !== null) {
            event.preventDefault();
            event.stopPropagation();
            clearActiveZoneHighlight();
            scaffoldContext.dispatch({
                operation: (0, $k4Vha.SET_DRAGGING),
                isDragging: false
            });
            scaffoldContext.settings.onDrop?.(event, rowId, colId, zone);
        } else clearActiveZoneHighlight();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ref: divRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).zoneGrid,
        style: {
            gridTemplateColumns: colTemplate,
            gridTemplateRows: rowTemplate,
            zIndex: scaffoldContext.state.isDragging && !scaffoldContext.settings.disabled ? 1 : -1
        },
        children: scaffoldContext.state.isDragging && visibleZones.map((zone)=>{
            const canonicalBounds = (0, $4zamZ.SCAFFOLD_ZONE_GRID_BOUNDS)[zone];
            const rowOffset = showVerticalSides ? 0 : 1;
            const colOffset = showHorizontalSides ? 0 : 1;
            const top = canonicalBounds.top - rowOffset;
            const bottom = canonicalBounds.bottom - rowOffset;
            const left = canonicalBounds.left - colOffset;
            const right = canonicalBounds.right - colOffset;
            return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                "data-zone": zone,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).zoneGridCell,
                onDragOver: (event)=>onZoneDragOver(event, zone),
                onDragLeave: onZoneDragLeave,
                onDrop: (event)=>onZoneDrop(event, zone),
                style: {
                    gridRow: `${top} / ${bottom}`,
                    gridColumn: `${left} / ${right}`,
                    backgroundColor: activeZone !== null && activeHighlightedZones.has(zone) && activeHighlightColor !== undefined ? activeHighlightColor : "transparent",
                    opacity: activeZone !== null && activeHighlightedZones.has(zone) && activeHighlightColor !== undefined ? 0.5 : 0,
                    border: activeZone !== null && activeHighlightedZones.has(zone) && activeHighlightColor !== undefined ? `2px solid ${activeHighlightColor}` : "none"
                }
            }, zone);
        })
    });
};
$fd775f2bd94586bc$export$831bc2bab2690d94.displayName = "ScaffoldZoneGrid";

});


parcelRegister("1xmT4", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRowResizeHandle", function () { return $7f8968b247f3350f$export$4451812414ec2bc2; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $cqVqv = parcelRequire("cqVqv");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");

var $k4Vha = parcelRequire("k4Vha");

var $4zamZ = parcelRequire("4zamZ");
const $7f8968b247f3350f$export$4451812414ec2bc2 = ({ rowId: rowId })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const leavingRow = scaffoldContext.state.leavingRows.find((r)=>r.id === rowId);
    const row = scaffoldContext.settings.rows.find((r)=>r.id === rowId) ?? leavingRow;
    const canResize = scaffoldContext.settings.disabled !== true && scaffoldContext.settings.onChangeRow !== undefined && !leavingRow && row !== undefined && !scaffoldContext.state.enteringRowIds.has(rowId);
    const resizeSessionRef = (0, $7fPBF.useRef)(null);
    const rowRef = (0, $7fPBF.useRef)(row);
    const leavingRowRef = (0, $7fPBF.useRef)(leavingRow);
    const onChangeRowRef = (0, $7fPBF.useRef)(scaffoldContext.settings.onChangeRow);
    const dispatchRef = (0, $7fPBF.useRef)(scaffoldContext.dispatch);
    /**
   * Keeps mutable refs synchronised with the latest row data for document-level mouse handlers.
   */ (0, $7fPBF.useLayoutEffect)(()=>{
        rowRef.current = row;
        leavingRowRef.current = leavingRow;
        onChangeRowRef.current = scaffoldContext.settings.onChangeRow;
        dispatchRef.current = scaffoldContext.dispatch;
    }, [
        row,
        leavingRow,
        scaffoldContext.settings.onChangeRow,
        scaffoldContext.dispatch
    ]);
    /**
   * Applies transient row height updates while the user drags the resize handle.
   *
   * @param e - Native mouse move event from useMouseMove.
   */ const handleResizeMouseMove = (e)=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const nextHeight = Math.max((0, $4zamZ.MIN_SCAFFOLD_ROW_HEIGHT_PX), Math.round(session.startHeight + (e.clientY - session.startY)));
        if (nextHeight === session.latestHeight) return;
        session.latestHeight = nextHeight;
        dispatchRef.current({
            operation: (0, $k4Vha.PREVIEW_ROW_HEIGHT_CHANGE),
            rowId: rowId,
            height: nextHeight
        });
    };
    /**
   * Completes an active row resize, resets transient state, and emits a single row update.
   */ const handleResizeMouseUp = (0, $7fPBF.useCallback)(()=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const latestHeight = session.latestHeight;
        resizeSessionRef.current = null;
        dispatchRef.current({
            operation: (0, $k4Vha.PREVIEW_ROW_HEIGHT_CHANGE),
            rowId: rowId,
            height: null
        });
        const currentRow = rowRef.current;
        const currentLeavingRow = leavingRowRef.current;
        if (currentRow !== undefined && !currentLeavingRow && latestHeight !== currentRow.height) onChangeRowRef.current?.(rowId, {
            ...currentRow,
            height: latestHeight
        });
    }, [
        rowId
    ]);
    /**
   * Starts a row height drag operation from this resize handle.
   *
   * @param event - React mouse down event from the resize handle.
   */ const handleResizeMouseDown = (event)=>{
        if (canResize) {
            event.preventDefault();
            const initialHeight = Math.max((0, $4zamZ.MIN_SCAFFOLD_ROW_HEIGHT_PX), rowRef.current.height);
            resizeSessionRef.current = {
                startY: event.clientY,
                startHeight: initialHeight,
                latestHeight: initialHeight
            };
            dispatchRef.current({
                operation: (0, $k4Vha.PREVIEW_ROW_HEIGHT_CHANGE),
                rowId: rowId,
                height: initialHeight
            });
        }
    };
    /**
   * Clears transient preview state if the component unmounts mid-drag.
   */ (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            resizeSessionRef.current = null;
            dispatchRef.current({
                operation: (0, $k4Vha.PREVIEW_ROW_HEIGHT_CHANGE),
                rowId: rowId,
                height: null
            });
        };
    }, [
        rowId
    ]);
    const { onMouseDown: onMouseDown } = (0, $d8dTd.useMouseMove)({
        onMouseDown: handleResizeMouseDown,
        onMouseMove: handleResizeMouseMove,
        onMouseUp: handleResizeMouseUp
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowResizeHandle,
            canResize ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowResizeHandleDisabled
        ]),
        onMouseDown: onMouseDown
    });
};
$7f8968b247f3350f$export$4451812414ec2bc2.displayName = "ScaffoldRowResizeHandle";

});

parcelRegister("jV9ZK", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRowSelectHandle", function () { return $73c957ad678396cf$export$4095f1cf56c9041d; });

var $bbzbN = parcelRequire("bbzbN");

var $cqVqv = parcelRequire("cqVqv");

var $k4Vha = parcelRequire("k4Vha");
parcelRequire("2wRcQ");
var $5wuBZ = parcelRequire("5wuBZ");

var $4zamZ = parcelRequire("4zamZ");

var $3k2bR = parcelRequire("3k2bR");

var $bK3BV = parcelRequire("bK3BV");
const $73c957ad678396cf$export$4095f1cf56c9041d = ({ rowId: rowId })=>{
    const scaffoldContext = (0, $3k2bR.useScaffold)();
    const isSelected = (0, $5wuBZ.isRowInSelection)(scaffoldContext.state.selection, rowId);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
        type: "button",
        "aria-label": "Select row",
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowSelectHandle,
            isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($bK3BV))).rowSelectHandleSelected : undefined
        ]),
        style: {
            width: (0, $4zamZ.SCAFFOLD_SELECT_HANDLE_SIZE_PX)
        },
        onClick: (event)=>{
            event.preventDefault();
            scaffoldContext.dispatch({
                operation: (0, $k4Vha.ROW_CLICKED),
                rowId: rowId,
                ctrlKey: event.ctrlKey,
                metaKey: event.metaKey,
                shiftKey: event.shiftKey
            });
        }
    });
};
$73c957ad678396cf$export$4095f1cf56c9041d.displayName = "ScaffoldRowSelectHandle";

});





parcelRegister("kevCO", function(module, exports) {
$parcel$export(module.exports, "ArsSidebarItemKind", function () { return (parcelRequire("g3GSA")).ArsSidebarItemKind; });
$parcel$export(module.exports, "totalSidebarItem", function () { return (parcelRequire("40D4s")).totalSidebarItem; });
$parcel$export(module.exports, "isArsSidebarItemData", function () { return (parcelRequire("clOgJ")).isArsSidebarItemData; });
parcelRequire("2FEZT");
parcelRequire("ajuS8");
parcelRequire("g3GSA");
parcelRequire("5Jw7w");
parcelRequire("40D4s");
parcelRequire("7gMgY");
parcelRequire("c1YHT");

});
parcelRegister("2FEZT", function(module, exports) {

$parcel$export(module.exports, "ArsDraggableSidebar", function () { return $003c892c083fcf32$export$9c5dc59b1a987623; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("gYROb");
var $dKaWY = parcelRequire("dKaWY");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $aghJT = parcelRequire("aghJT");

var $icOFS = parcelRequire("icOFS");

var $3Ggtq = parcelRequire("3Ggtq");

var $g3GSA = parcelRequire("g3GSA");

var $jh2aH = parcelRequire("jh2aH");

var $40D4s = parcelRequire("40D4s");
const $003c892c083fcf32$export$9c5dc59b1a987623 = ({ onItemDragStart: onItemDragStart, onItemDragEnd: onItemDragEnd, showGroupingFactors: showGroupingFactors = true, showOperations: showOperations = false, showTotalGroupingFactor: showTotalGroupingFactor = false, showVariables: showVariables = false, style: style })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const currentView = state.currentSidebar.view;
    const availableViews = [
        showGroupingFactors ? "groupingFactor" : null,
        showOperations ? "operation" : null,
        showVariables ? "variable" : null
    ].filter(Boolean);
    const filterText = state.currentSidebar.filter.toLowerCase();
    // Update current view if it is not available
    (0, $7fPBF.useEffect)(()=>{
        if (availableViews.length > 0 && !availableViews.includes(currentView)) dispatch({
            operation: (0, $cIJV5.SET_SIDEBAR_VIEW),
            view: availableViews[0]
        });
    }, [
        availableViews,
        currentView,
        dispatch
    ]);
    if (availableViews.length === 0) return null;
    const groupingFactorItems = showGroupingFactors ? Object.values(state.groupingFactors).map((gf)=>({
            id: `ars-table-sidebar-grouping-factor-${gf.id}`,
            label: gf.description && gf.description.trim() !== "" ? gf.description.trim() : gf.name,
            data: {
                kind: (0, $g3GSA.ArsSidebarItemKind).GroupingFactor,
                dropItem: gf
            }
        })) : [];
    const analysisMethodItems = showOperations ? Object.values(state.analysisMethods).filter((am)=>!state.currentSidebar.analysisMethodId || state.currentSidebar.analysisMethodId && am.id === state.currentSidebar.analysisMethodId).flatMap((am)=>{
        const analysisItems = [
            {
                id: `ars-table-sidebar-analysis-method-${am.id}`,
                label: am.description && am.description.trim() !== "" ? am.description.trim() : am.name,
                data: {
                    kind: (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod,
                    dropItem: am
                }
            }
        ];
        const operationSidebarItems = am.operations.map((operation)=>({
                id: `ars-table-sidebar-operation-${operation.id}`,
                label: operation.label ?? operation.name,
                data: {
                    kind: (0, $g3GSA.ArsSidebarItemKind).Operation,
                    dropItem: operation,
                    analysisMethodId: am.id
                }
            }));
        return [
            ...analysisItems,
            ...operationSidebarItems
        ];
    }) : [];
    const variables = showVariables ? state.variables.filter((v)=>v.dataset === state.currentSidebar.dataset).map((v)=>({
            id: `ars-table-sidebar-variable-${v.oid}`,
            label: v.value,
            data: {
                kind: (0, $g3GSA.ArsSidebarItemKind).Variable,
                dropItem: v
            }
        })) : [];
    const sidebarItems = (currentView === "groupingFactor" ? [
        ...showTotalGroupingFactor ? [
            (0, $40D4s.totalSidebarItem)
        ] : [],
        ...groupingFactorItems
    ] : currentView === "operation" ? analysisMethodItems : variables).filter((item)=>item.label.toLowerCase().includes(filterText));
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "d-flex justify-content-end align-items-start",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dKaWY.DraggableSidebar), {
            id: "ars-draggable-sidebar",
            bodyLevel: true,
            items: sidebarItems,
            multiSelect: true,
            onItemDragEnd: onItemDragEnd,
            onItemDragStart: onItemDragStart,
            pushContent: true,
            RenderItem: (0, $icOFS.ArsSidebarItem),
            resizable: true,
            show: state.currentSidebar.isOpen,
            side: "right",
            style: style,
            width: state.currentSidebar.width,
            header: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "d-flex flex-column gap-2",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3Ggtq.ArsSidebarViewRadio), {
                        showGroupingFactors: showGroupingFactors,
                        showOperations: showOperations,
                        showVariables: showVariables
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aghJT.ArsSidebarFilter), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jh2aH.NewItemButton), {})
                ]
            })
        })
    });
};
$003c892c083fcf32$export$9c5dc59b1a987623.displayName = "ArsDraggableSidebar";

});
parcelRegister("aghJT", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarFilter", function () { return $b38474982c9b015c$export$37caa1f917380740; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $8YJ8Z = parcelRequire("8YJ8Z");
const $b38474982c9b015c$export$37caa1f917380740 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            state.currentSidebar.view === "variable" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8YJ8Z.DatasetSelect), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                id: "ars-sidebar-filter",
                size: "sm",
                type: "text",
                "aria-label": "Filter sidebar items",
                placeholder: "Filter items\u2026",
                value: state.currentSidebar.filter,
                onChange: (event)=>{
                    dispatch({
                        operation: (0, $cIJV5.SET_SIDEBAR_FILTER),
                        filter: event.currentTarget.value
                    });
                }
            })
        ]
    });
};
$b38474982c9b015c$export$37caa1f917380740.displayName = "ArsSidebarFilter";

});
parcelRegister("8YJ8Z", function(module, exports) {

$parcel$export(module.exports, "DatasetSelect", function () { return $4b6ab8581a1c84f2$export$d90fb6e23f5d91a5; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
const $4b6ab8581a1c84f2$export$d90fb6e23f5d91a5 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const datasets = new Set(state.variables.map((v)=>v.dataset));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Select, {
        id: "ars-sidebar-dataset-select",
        size: "sm",
        value: state.currentSidebar.dataset ?? "",
        disabled: datasets.size === 0,
        onChange: (event)=>{
            dispatch({
                operation: (0, $cIJV5.SET_SIDEBAR_DATASET),
                dataset: event.currentTarget.value
            });
        },
        children: [
            !datasets.has(state.currentSidebar.dataset ?? "") && /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                value: "",
                children: "-- Select --"
            }),
            Array.from(datasets).map((dataset)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                    value: dataset,
                    children: dataset
                }, dataset))
        ]
    });
};
$4b6ab8581a1c84f2$export$d90fb6e23f5d91a5.displayName = "DatasetSelect";

});


parcelRegister("icOFS", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarItem", function () { return $7a2b72ead4a97756$export$6b7fddce67934df4; });

var $bbzbN = parcelRequire("bbzbN");

var $ajuS8 = parcelRequire("ajuS8");

var $g3GSA = parcelRequire("g3GSA");

var $5Jw7w = parcelRequire("5Jw7w");

var $40D4s = parcelRequire("40D4s");

var $c1YHT = parcelRequire("c1YHT");
const $7a2b72ead4a97756$export$6b7fddce67934df4 = ({ item: item, selected: selected })=>{
    const resolvedItem = typeof item.data === "function" ? {
        ...item,
        data: item.data()
    } : item;
    return item.id === (0, $40D4s.totalSidebarItem).id ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40D4s.TotalGroupingFactorSidebarItem), {
        selected: selected
    }) : resolvedItem.data.kind === (0, $g3GSA.ArsSidebarItemKind).GroupingFactor ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ajuS8.GroupingFactorSidebarItem), {
        item: resolvedItem,
        selected: selected
    }) : resolvedItem.data.kind === (0, $g3GSA.ArsSidebarItemKind).Operation || resolvedItem.data.kind === (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Jw7w.OperationSidebarItem), {
        item: resolvedItem,
        selected: selected
    }) : resolvedItem.data.kind === (0, $g3GSA.ArsSidebarItemKind).Variable ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1YHT.VariableSidebarItem), {
        item: resolvedItem,
        selected: selected
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        children: "Unknown sidebar item type"
    });
};
$7a2b72ead4a97756$export$6b7fddce67934df4.displayName = "ArsSidebarItem";

});
parcelRegister("ajuS8", function(module, exports) {

$parcel$export(module.exports, "GroupingFactorSidebarItem", function () { return $7f5bd7e534054014$export$72a518a9654d1160; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");
parcelRequire("bIAbO");
var $bRDEW = parcelRequire("bRDEW");
const $7f5bd7e534054014$export$72a518a9654d1160 = ({ item: item, selected: selected })=>{
    const groupingFactor = item.data.dropItem;
    const [showWindow, setShowWindow] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                className: "w-100",
                menuItems: [
                    {
                        label: showWindow ? "Hide properties" : "Show properties",
                        action: ()=>setShowWindow(!showWindow)
                    }
                ],
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: (0, $cqVqv.classMerge)([
                        "grouping-factor-sidebar-item",
                        "px-2",
                        "py-1",
                        "border",
                        "rounded",
                        "w-100",
                        selected ? "border-primary bg-primary-subtle" : ""
                    ]),
                    style: {
                        cursor: "grab"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "fw-semibold",
                            children: item.label
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                            className: "text-muted",
                            children: [
                                groupingFactor.dataDriven ? "Data driven" : "Groups",
                                " \u2022 ",
                                groupingFactor.name,
                                " ",
                                groupingFactor.disableEditing ? /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                    className: "px-1",
                                    children: "\u2022 Read only"
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextWindow), {
                id: `grouping-factor-sidebar-item-${groupingFactor.id}-context-window`,
                minZIndex: 1000,
                title: `Grouping Factor: ${groupingFactor.name}`,
                visible: showWindow,
                onClose: ()=>setShowWindow(false),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bRDEW.GroupingFactorControl), {
                    dataPath: `/groupingFactors/${groupingFactor.id}`,
                    canRename: true
                })
            })
        ]
    });
};
$7f5bd7e534054014$export$72a518a9654d1160.displayName = "GroupingFactorSidebarItem";

});

parcelRegister("5Jw7w", function(module, exports) {

$parcel$export(module.exports, "OperationSidebarItem", function () { return $757c63baa1843aed$export$33fd664cf87b548e; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");

var $7uNID = parcelRequire("7uNID");

var $apoy8 = parcelRequire("apoy8");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
const $757c63baa1843aed$export$33fd664cf87b548e = ({ item: item, selected: selected })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    const [showWindow, setShowWindow] = (0, $7fPBF.useState)(false);
    const isMethod = item.data.kind === "analysisMethod";
    const isOperation = item.data.kind === "operation";
    // Type assertion needed due to discriminated union limitation with generic components
    const analysisMethod = isMethod ? item.data.dropItem : null;
    const operation = isOperation ? item.data.dropItem : null;
    let operationControlProps = null;
    if (operation) for (const [analysisMethodId, method] of Object.entries(state.analysisMethods)){
        const operationIndex = method.operations.findIndex((methodOperation)=>methodOperation.id === operation.id);
        if (operationIndex >= 0) {
            operationControlProps = {
                dataPath: `/analysisMethods/${analysisMethodId}/operations/${operationIndex}`,
                siblingCount: method.operations.length,
                disableEditing: method.disableEditing
            };
            break;
        }
    }
    const windowTitle = analysisMethod ? `Analysis method: ${analysisMethod.name}` : `Operation: ${item.data.dropItem.name}`;
    const windowId = analysisMethod ? `analysis-method-sidebar-item-${analysisMethod.id}-context-window` : `operation-sidebar-item-${item.data.dropItem.id}-context-window`;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                className: "w-100",
                menuItems: [
                    {
                        label: showWindow ? "Hide properties" : "Show properties",
                        action: ()=>setShowWindow(!showWindow)
                    }
                ],
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, $cqVqv.classMerge)([
                        "operation-sidebar-item",
                        "px-2",
                        "py-1",
                        "border",
                        "rounded",
                        "w-100",
                        selected ? "border-primary bg-primary-subtle" : ""
                    ]),
                    style: {
                        cursor: "grab"
                    },
                    children: isMethod ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "fw-bold",
                                children: item.label
                            }),
                            analysisMethod && /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                                className: "text-muted",
                                children: [
                                    "Analysis method \u2022 ",
                                    analysisMethod.name,
                                    analysisMethod.disableEditing ? /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                        className: "px-1",
                                        children: "\u2022 Read only"
                                    }) : null
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "fw-semibold",
                                children: item.label
                            }),
                            operation && /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                                className: "text-muted",
                                children: [
                                    operation.name,
                                    " ",
                                    operation.label && `\u{2022} ${operation.label}`,
                                    operationControlProps?.disableEditing ? /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                        className: "px-1",
                                        children: "\u2022 Read only"
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ContextWindow), {
                id: windowId,
                title: windowTitle,
                visible: showWindow,
                onClose: ()=>setShowWindow(false),
                children: [
                    analysisMethod && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7uNID.AnalysisMethodControl), {
                        dataPath: `/analysisMethods/${analysisMethod.id}`,
                        canRename: true
                    }),
                    operation && operationControlProps && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $apoy8.OperationControl), {
                        dataPath: operationControlProps.dataPath,
                        siblingCount: operationControlProps.siblingCount
                    })
                ]
            })
        ]
    });
};
$757c63baa1843aed$export$33fd664cf87b548e.displayName = "OperationSidebarItem";

});
parcelRegister("7uNID", function(module, exports) {

$parcel$export(module.exports, "AnalysisMethodControl", function () { return $7da678018e6ef8e0$export$a77a2f024136e812; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");
var $4tJ7o = parcelRequire("4tJ7o");
var $gLW8Q = parcelRequire("gLW8Q");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");

var $ek4hO = parcelRequire("ek4hO");

var $cR7P2 = parcelRequire("cR7P2");

var $s05f4 = parcelRequire("s05f4");

var $f55zq = parcelRequire("f55zq");

var $5zEFB = parcelRequire("5zEFB");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");
const $7da678018e6ef8e0$export$a77a2f024136e812 = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)("named-object");
    const analysisMethod = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $ek4hO.isAnalysisMethod));
    const documentReferences = (0, $7fPBF.useMemo)(()=>analysisMethod?.documentRefs ?? [], [
        analysisMethod
    ]);
    const operations = (0, $7fPBF.useMemo)(()=>analysisMethod?.operations ?? [], [
        analysisMethod
    ]);
    const hasCodeTemplate = analysisMethod?.codeTemplate !== undefined;
    // Disable editing for parent templates
    if (analysisMethod?.disableEditing) disabled = true;
    // Check state settings for disableAnalysisMethodEdit
    if (state.disableAnalysisMethodEdit) disabled = true;
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $7fPBF.useEffectEvent)((newTab)=>(0, $7fPBF.startTransition)(()=>setActiveTab(newTab)));
    /**
   * Change the active document tab if it no longer exists.
   */ (0, $7fPBF.useEffect)(()=>{
        if (activeTab.startsWith("document-references-") && documentReferences.length > 0 && parseInt(activeTab.split("-")[2], 10) >= documentReferences.length) updateActiveTab(`document-references-${documentReferences.length - 1}`);
        else if (activeTab.startsWith("document-references-") && documentReferences.length === 0) updateActiveTab(`named-object`);
    }, [
        operations.length,
        documentReferences.length,
        activeTab
    ]);
    /**
   * Handles adding a new document reference to the method.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysisMethod) {
            const documentReferenceCount = documentReferences.length;
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRefs/${documentReferenceCount}`,
                value: newDocumentReference
            });
        }
    };
    /**
   * Handles adding a new programming code template to the method.
   */ const handleAddCodeTemplate = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysisMethod && !hasCodeTemplate) {
            const newCodeTemplate = {
                context: "",
                code: "",
                parameters: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/codeTemplate`,
                value: newCodeTemplate
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            analysisMethod && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                        children: [
                            "Id: ",
                            dataPath.split("/").pop()
                        ]
                    })
                })
            }),
            canRename && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Container, {
                activeKey: activeTab,
                onSelect: (k)=>{
                    /* istanbul ignore else */ if (k) setActiveTab(k);
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default), {
                        variant: "tabs",
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "named-object",
                                    children: "Properties"
                                })
                            }),
                            documentReferences.length > 0 && documentReferences.map((documentReference, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default).Link, {
                                        eventKey: `document-references-${index}`,
                                        children: [
                                            "Document reference ",
                                            index + 1
                                        ]
                                    })
                                }, documentReference.referenceDocumentId)),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "code-template",
                                    children: "Code template"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: `operations`,
                                    children: "Operations"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                    eventKey: "parameters",
                                    children: "Parameters"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Content, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                eventKey: "named-object",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                                        dataPath: dataPath,
                                        canRename: canRename,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                                        id: `${idRoute}-add-document-reference`,
                                        onClick: handleAddDocumentReference,
                                        className: "d-flex align-items-center btn-sm btn-success m-2",
                                        disabled: disabled,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "me-2",
                                                children: "Add document reference"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                                        ]
                                    })
                                ]
                            }),
                            documentReferences.map((documentReference, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                                    eventKey: `document-references-${index}`,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5zEFB.DocumentReferenceControl), {
                                        dataPath: `${dataPath}/documentRefs/${index}`,
                                        disabled: disabled,
                                        siblingCount: documentReferences.length
                                    }, `${documentReference.referenceDocumentId}-${index}`)
                                }, `${documentReference.referenceDocumentId}-${index}`)),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                eventKey: "code-template",
                                children: [
                                    hasCodeTemplate && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f55zq.AnalysisProgrammingCodeTemplateControl), {
                                        dataPath: `${dataPath}/codeTemplate`,
                                        disabled: disabled
                                    }),
                                    !disabled && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                                        id: `${idRoute}-add-code-template`,
                                        onClick: handleAddCodeTemplate,
                                        className: "d-flex align-items-center btn-sm btn-success",
                                        disabled: hasCodeTemplate,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "me-2",
                                                children: "Add code template"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                                eventKey: "parameters",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $s05f4.AnalysisMethodParametersControl), {
                                    dataPath: `${dataPath}/codeTemplate`,
                                    disabled: disabled
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                                eventKey: `operations`,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cR7P2.AnalysisMethodOperationsControl), {
                                    dataPath: dataPath,
                                    disabled: disabled
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$7da678018e6ef8e0$export$a77a2f024136e812.displayName = "AnalysisMethodControl";

});
parcelRegister("cR7P2", function(module, exports) {

$parcel$export(module.exports, "AnalysisMethodOperationsControl", function () { return $721c0b5581d034cc$export$2d02eae519161b1b; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4tJ7o = parcelRequire("4tJ7o");
var $gLW8Q = parcelRequire("gLW8Q");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
var $6LYdD = parcelRequire("6LYdD");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $ek4hO = parcelRequire("ek4hO");

var $apoy8 = parcelRequire("apoy8");
const $721c0b5581d034cc$export$2d02eae519161b1b = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const analysisMethod = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $ek4hO.isAnalysisMethod));
    const operations = analysisMethod?.operations ?? [];
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)(operations.length > 0 ? "operation-0" : "");
    /**
   * Handles adding a new operation to the method.
   */ const handleAddOperation = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysisMethod) {
            const operationCount = operations.length;
            const newOperation = {
                id: crypto.randomUUID(),
                name: `Operation_${operationCount + 1}`,
                label: `Operation ${operationCount + 1}`,
                description: "",
                order: operationCount,
                referencedOperationRelationships: [],
                resultPattern: ""
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/operations/${operationCount}`,
                value: newOperation
            });
        }
    };
    /**
   * Handles reordering operations and reapplies their sequential order values.
   *
   * @param newOperations - The operations in their new order.
   */ const handleReorderOperations = (newOperations)=>{
        /* istanbul ignore else -- reordering is disabled unless an analysis method is present */ if (!disabled && analysisMethod) dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: `${dataPath}/operations`,
            value: newOperations.map((operation, index)=>({
                    ...operation,
                    order: index
                }))
        });
    };
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $7fPBF.useEffectEvent)((newTab)=>(0, $7fPBF.startTransition)(async ()=>setActiveTab(newTab)));
    /** Move tabs */ (0, $7fPBF.useEffect)(()=>{
        if (parseInt(activeTab.split("-")[1], 10) >= operations.length) updateActiveTab(operations.length > 0 ? "operation-0" : "");
        else if (activeTab === "" && operations.length > 0) updateActiveTab("operation-0");
    }, [
        operations.length,
        activeTab
    ]);
    const idRoute = dataPath.replace(/\//g, "-") + "-operations";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Container, {
        activeKey: activeTab,
        onSelect: (k)=>{
            /* istanbul ignore else */ if (k) setActiveTab(k);
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default), {
                variant: "tabs",
                className: "mb-3",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6LYdD.ReorderableNavList), {
                    list: operations,
                    setList: handleReorderOperations,
                    getEventKey: (_operation, index)=>`operation-${index}`,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Content, {
                children: operations.map((operation, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                        eventKey: `operation-${index}`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $apoy8.OperationControl), {
                            dataPath: `${dataPath}/operations/${index}`,
                            disabled: disabled,
                            siblingCount: operations.length
                        })
                    }, operation.id))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-operation`,
                onClick: handleAddOperation,
                className: "d-flex align-items-center btn-sm btn-success m-2",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add operation"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$721c0b5581d034cc$export$2d02eae519161b1b.displayName = "AnalysisMethodOperationsControl";

});
parcelRegister("apoy8", function(module, exports) {

$parcel$export(module.exports, "OperationControl", function () { return $313dee4c835c222a$export$1693b8e4288ddb91; });

var $bbzbN = parcelRequire("bbzbN");

var $8d4Ob = parcelRequire("8d4Ob");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");

var $TpTu7 = parcelRequire("TpTu7");

var $3EZep = parcelRequire("3EZep");

var $hoYmS = parcelRequire("hoYmS");

var $kteXq = parcelRequire("kteXq");

var $dPdcj = parcelRequire("dPdcj");

var $rRNEc = parcelRequire("rRNEc");
const $313dee4c835c222a$export$1693b8e4288ddb91 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    let correctedDataPath = dataPath;
    // Find correct datapath for the operation in the analysisMethods
    if (correctedDataPath.startsWith("/operations/")) {
        let ix = -1;
        const holdingAnalysisMethod = Object.values(state.analysisMethods).find((am)=>{
            const thisIx = am.operations.findIndex((op)=>op.id === correctedDataPath.split("/").pop());
            ix = thisIx;
            return thisIx > -1;
        });
        /* istanbul ignore else */ if (holdingAnalysisMethod) correctedDataPath = `/analysisMethods/${holdingAnalysisMethod.id}/operations/${ix}`;
    }
    // Check state settings for disableAnalysisMethodEdit
    if (state.disableAnalysisMethodEdit) disabled = true;
    const operation = (0, $eAPMz.getFromDataPath)(correctedDataPath, state, (0, $hoYmS.isOperation));
    const relationships = operation?.referencedOperationRelationships ?? [];
    /**
   * Handles adding a new referenced operation relationship.
   */ const handleAddRelationship = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && operation) {
            const relationshipCount = relationships.length;
            const newRelationship = {
                id: crypto.randomUUID(),
                referencedOperationRole: {
                    controlledTerm: "NUMERATOR"
                },
                operationId: "",
                analysisId: "",
                description: ""
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${correctedDataPath}/referencedOperationRelationships/${relationshipCount}`,
                value: newRelationship
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            operation && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                        children: [
                            "Id: ",
                            operation.id
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: correctedDataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                dataPath: correctedDataPath,
                canRename: true,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${correctedDataPath}/resultPattern`,
                id: `${idRoute}-result-pattern`,
                label: "Result pattern",
                labelWidth: 2,
                placeholder: "Enter result pattern",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $TpTu7.ArsBoolean), {
                dataPath: `${correctedDataPath}/denominatorOnly`,
                id: `${idRoute}-denominator-only`,
                label: "Denominator only",
                labelWidth: 2,
                disabled: disabled
            }),
            relationships.map((relationship, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $dPdcj.ReferencedOperationRelationshipControl), {
                    dataPath: `${correctedDataPath}/referencedOperationRelationships/${index}`,
                    disabled: disabled,
                    siblingCount: relationships.length
                }, relationship.id)),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-relationship`,
                onClick: handleAddRelationship,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add relationship"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$313dee4c835c222a$export$1693b8e4288ddb91.displayName = "OperationControl";

});
parcelRegister("TpTu7", function(module, exports) {

$parcel$export(module.exports, "ArsBoolean", function () { return $b68050ef73d712cb$export$b83579e3cc9aa2a8; });

var $bbzbN = parcelRequire("bbzbN");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
const $b68050ef73d712cb$export$b83579e3cc9aa2a8 = ({ dataPath: dataPath, disabled: disabled = false, falseIsUndefined: falseIsUndefined = false, id: id, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12 })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const value = (0, $eAPMz.getFromDataPath)(dataPath, state, (v)=>typeof v === "boolean") ?? false;
    /**
   * Handles updating the boolean value in ArsContext state.
   *
   * @param e - The change event from the checkbox input.
   */ const handleChange = (e)=>{
        const newValue = e.target.checked;
        const updatedValue = falseIsUndefined && newValue === false ? undefined : newValue;
        dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: dataPath,
            value: updatedValue
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
        controlId: `${id}`,
        as: (0, $kYoG1.default),
        className: "mb-1",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                md: {
                    span: maxWidthCols - labelWidth
                },
                className: "d-flex align-items-center",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                    type: "switch",
                    name: id,
                    checked: value,
                    onChange: handleChange,
                    disabled: disabled
                })
            })
        ]
    });
};
$b68050ef73d712cb$export$b83579e3cc9aa2a8.displayName = "ArsBoolean";

});

parcelRegister("3EZep", function(module, exports) {

$parcel$export(module.exports, "ArsText", function () { return $16edc863048d3b8a$export$a465d06d3ea2cdc1; });

var $bbzbN = parcelRequire("bbzbN");

var $6hWPd = parcelRequire("6hWPd");

var $9Er6k = parcelRequire("9Er6k");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
parcelRequire("loI62");
var $i3Ps9 = parcelRequire("i3Ps9");

var $6Llki = parcelRequire("6Llki");
const $16edc863048d3b8a$export$a465d06d3ea2cdc1 = ({ dataPath: dataPath, isArray: isArray = false, isMultiline: isMultiline = false, tableDataPath: tableDataPath = false, ...rest })=>{
    const ars = (0, $fZCs4.useArsContext)();
    const table = (0, $6Llki.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    // Get the current value from state using the dataPath
    const pointer = (0, $6hWPd.Pointer).fromJSON(dataPath);
    const rawValue = pointer.get(sourceState) ?? (isArray ? [] : "");
    // Auto-detect if value is an array
    const isArrayValue = isArray || Array.isArray(rawValue);
    // Handle both string and string[] values
    // If it's an array, convert to newline-separated string for textarea display
    const value = isArrayValue ? rawValue.join("\n") : rawValue;
    /**
   * Handle input change by dispatching PATCH_ARS_STATE action.
   * If the original value was an array, convert newline-separated string back to array.
   *
   * @param newValue - The new value to set.
   */ const handleChange = (newValue)=>{
        let valueToSave;
        if (isArrayValue) // Convert newline-separated string back to array
        valueToSave = newValue.split("\n").map((v)=>v.trim()).filter((v)=>v.length > 0);
        else if (rest.type === "number") {
            const numValue = Number(newValue);
            valueToSave = newValue.trim() === "" || !isFinite(numValue) ? undefined : numValue;
        } else valueToSave = newValue;
        if (!tableDataPath) ars.dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: dataPath,
            value: valueToSave
        });
        else table.dispatch({
            operation: (0, $i3Ps9.ARST_PATCH_DATA),
            dataPath: dataPath,
            value: valueToSave
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
        value: value,
        setValue: handleChange,
        type: isArrayValue || isMultiline ? "textarea" : rest.type,
        allowCarriageReturn: isArrayValue || isMultiline,
        ...rest
    });
};
$16edc863048d3b8a$export$a465d06d3ea2cdc1.displayName = "ArsText";

});
parcelRegister("6Llki", function(module, exports) {

$parcel$export(module.exports, "ArsTableContextProvider", function () { return $6401bbe987d35371$export$7163c3f2ae2eebce; });
$parcel$export(module.exports, "useArsTable", function () { return $6401bbe987d35371$export$643c750033874924; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $bT9kO = parcelRequire("bT9kO");
parcelRequire("kDPjn");
var $1c7o5 = parcelRequire("1c7o5");
var $dSnsn = parcelRequire("dSnsn");

var $i3Ps9 = parcelRequire("i3Ps9");
const $6401bbe987d35371$export$945521e500a6f7d5 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $6401bbe987d35371$export$7163c3f2ae2eebce = ({ children: children, bodyData: bodyData, calculatedTableRows: calculatedTableRows, settings: settings, updateBodyData: updateBodyData })=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $bT9kO.arsTableReducer), {
        bodyData: bodyData,
        scaffoldModel: (0, $1c7o5.buildArsTableScaffoldModel)(calculatedTableRows, settings.editorProps),
        calculatedTableRows: calculatedTableRows,
        settings: settings,
        changed: false,
        usedGroupingFactorIds: (0, $dSnsn.computeUsedGroupingFactorIds)(bodyData),
        viewItem: undefined
    });
    (0, $7fPBF.useEffect)(()=>{
        const eq = (0, $gSkQi.isEqual)(state.bodyData, bodyData);
        // Send changes up
        if (!eq && state.bodyData.id === bodyData.id && state.changed) {
            updateBodyData(state.bodyData, state.calculatedTableRows ?? // istanbul ignore next
            []);
            dispatch({
                operation: (0, $i3Ps9.ARST_CHANGE_SENT)
            });
        } else if (state.bodyData.id !== bodyData.id || !eq) dispatch({
            operation: (0, $i3Ps9.ARST_LOAD_DATA),
            bodyData: bodyData
        });
    }, [
        bodyData,
        state.bodyData,
        state.calculatedTableRows,
        state.changed,
        updateBodyData
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $gSkQi.isEqual)(state.settings.tlfViewMode, settings.tlfViewMode)) dispatch({
            operation: (0, $i3Ps9.ARST_SET_TLF_VIEW_MODE),
            tlfViewMode: settings.tlfViewMode
        });
    }, [
        settings.tlfViewMode,
        state.settings.tlfViewMode
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const eq = (0, $gSkQi.isEqual)(state.calculatedTableRows, calculatedTableRows);
        if (!eq && calculatedTableRows) dispatch({
            operation: (0, $i3Ps9.ARST_UPDATE_SCAFFOLD),
            calculatedTableRows: calculatedTableRows
        });
    }, [
        calculatedTableRows,
        state.calculatedTableRows
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6401bbe987d35371$export$945521e500a6f7d5.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$6401bbe987d35371$export$7163c3f2ae2eebce.displayName = "ArsTableContextProvider";
const $6401bbe987d35371$export$643c750033874924 = ()=>{
    const context = (0, $7fPBF.useContext)($6401bbe987d35371$export$945521e500a6f7d5);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
};

});
parcelRegister("bT9kO", function(module, exports) {

$parcel$export(module.exports, "arsTableReducer", function () { return $1c9db376aa923b69$export$a5201d85a1deb82f; });
parcelRequire("kDPjn");
var $lsgLV = parcelRequire("lsgLV");
var $iqF5u = parcelRequire("iqF5u");
var $zfKzR = parcelRequire("zfKzR");
var $4VjTy = parcelRequire("4VjTy");
var $6h9L6 = parcelRequire("6h9L6");
var $dymQq = parcelRequire("dymQq");
var $b7JlK = parcelRequire("b7JlK");
var $2w3jh = parcelRequire("2w3jh");
var $2dkgH = parcelRequire("2dkgH");
var $iTvLk = parcelRequire("iTvLk");
var $gXBDA = parcelRequire("gXBDA");
var $c8oBZ = parcelRequire("c8oBZ");
var $cO1sB = parcelRequire("cO1sB");
var $ermqj = parcelRequire("ermqj");

var $i3Ps9 = parcelRequire("i3Ps9");
const $1c9db376aa923b69$export$a5201d85a1deb82f = (state, action)=>{
    switch(action.operation){
        case 0, $i3Ps9.ARST_CHANGE_SENT:
            return (0, $lsgLV.arst_changeSent)(state);
        case 0, $i3Ps9.ARST_INSERT_COLUMN_AFTER:
        case 0, $i3Ps9.ARST_INSERT_COLUMN_BEFORE:
        case 0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_AFTER:
        case 0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_BEFORE:
        case 0, $i3Ps9.ARST_INSERT_OPERATION_ROW_AFTER:
        case 0, $i3Ps9.ARST_INSERT_OPERATION_ROW_BEFORE:
        case 0, $i3Ps9.ARST_INSERT_OPERATION_SUBGROUP:
        case 0, $i3Ps9.ARST_INSERT_ROW_AFTER:
        case 0, $i3Ps9.ARST_INSERT_ROW_BEFORE:
        case 0, $i3Ps9.ARST_INSERT_SUBGROUP:
            return (0, $iqF5u.arst_insertDroppedItem)(state, action);
        case 0, $i3Ps9.ARST_LOAD_DATA:
            return (0, $zfKzR.arst_loadData)(state, action);
        case 0, $i3Ps9.ARST_PATCH_DATA:
            return (0, $4VjTy.arst_patchData)(state, action);
        case 0, $i3Ps9.ARST_REMOVE_GROUPINGFACTOR:
            return (0, $6h9L6.arst_removeGroupingFactor)(state, action);
        case 0, $i3Ps9.ARST_REMOVE_OPERATION:
            return (0, $dymQq.arst_removeOperation)(state, action);
        case 0, $i3Ps9.ARST_SET_SCAFFOLD_COL_WIDTH:
            return (0, $b7JlK.arst_setScaffoldColWidth)(state, action);
        case 0, $i3Ps9.ARST_SET_SCAFFOLD_ROW_HEIGHT:
            return (0, $2w3jh.arst_setScaffoldRowHeight)(state, action);
        case 0, $i3Ps9.ARST_SET_TLF_VIEW_MODE:
            return (0, $2dkgH.arst_setTlfViewMode)(state, action);
        case 0, $i3Ps9.ARST_SET_VIEW_ITEM:
            return (0, $iTvLk.arst_setViewItem)(state, action);
        case 0, $i3Ps9.ARST_TOGGLE_GROUP_LABEL_VISIBILITY:
            return (0, $gXBDA.arst_toggleGroupLabelVisibility)(state, action);
        case 0, $i3Ps9.ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL:
            return (0, $cO1sB.arst_toggleInlineWithPreviousLevel)(state, action);
        case 0, $i3Ps9.ARST_TOGGLE_GROUP_LABEL_INLINE:
            return (0, $c8oBZ.arst_toggleInlineRowHeader)(state, action);
        case 0, $i3Ps9.ARST_UPDATE_SCAFFOLD:
            return (0, $ermqj.arst_updateScaffold)(state, action);
    }
    return state;
};

});
parcelRegister("kDPjn", function(module, exports) {
$parcel$export(module.exports, "arst_changeSent", function () { return (parcelRequire("lsgLV")).arst_changeSent; });
$parcel$export(module.exports, "arst_insertDroppedItem", function () { return (parcelRequire("iqF5u")).arst_insertDroppedItem; });
$parcel$export(module.exports, "arst_loadData", function () { return (parcelRequire("zfKzR")).arst_loadData; });
$parcel$export(module.exports, "arst_patchData", function () { return (parcelRequire("4VjTy")).arst_patchData; });
$parcel$export(module.exports, "arst_removeGroupingFactor", function () { return (parcelRequire("6h9L6")).arst_removeGroupingFactor; });
$parcel$export(module.exports, "arst_removeOperation", function () { return (parcelRequire("dymQq")).arst_removeOperation; });
$parcel$export(module.exports, "arst_resolveTargetPath", function () { return (parcelRequire("12bze")).arst_resolveTargetPath; });
$parcel$export(module.exports, "arst_setScaffoldColWidth", function () { return (parcelRequire("b7JlK")).arst_setScaffoldColWidth; });
$parcel$export(module.exports, "arst_setScaffoldRowHeight", function () { return (parcelRequire("2w3jh")).arst_setScaffoldRowHeight; });
$parcel$export(module.exports, "arst_setTlfViewMode", function () { return (parcelRequire("2dkgH")).arst_setTlfViewMode; });
$parcel$export(module.exports, "arst_setViewItem", function () { return (parcelRequire("iTvLk")).arst_setViewItem; });
$parcel$export(module.exports, "arst_toggleGroupLabelVisibility", function () { return (parcelRequire("gXBDA")).arst_toggleGroupLabelVisibility; });
$parcel$export(module.exports, "arst_toggleInlineRowHeader", function () { return (parcelRequire("c8oBZ")).arst_toggleInlineRowHeader; });
$parcel$export(module.exports, "arst_toggleInlineWithPreviousLevel", function () { return (parcelRequire("cO1sB")).arst_toggleInlineWithPreviousLevel; });
$parcel$export(module.exports, "arst_updateScaffold", function () { return (parcelRequire("ermqj")).arst_updateScaffold; });
$parcel$export(module.exports, "buildArsTableScaffoldModel", function () { return (parcelRequire("1c7o5")).buildArsTableScaffoldModel; });
$parcel$export(module.exports, "buildArsTableZoneColors", function () { return (parcelRequire("4bSb7")).buildArsTableZoneColors; });
$parcel$export(module.exports, "computeUsedGroupingFactorIds", function () { return (parcelRequire("dSnsn")).computeUsedGroupingFactorIds; });
$parcel$export(module.exports, "groupToTreeNode", function () { return (parcelRequire("7uH5j")).groupToTreeNode; });
parcelRequire("9Du9L");
parcelRequire("lsgLV");
parcelRequire("6RjQK");
parcelRequire("iqF5u");
parcelRequire("zfKzR");
parcelRequire("4VjTy");
parcelRequire("6h9L6");
parcelRequire("dymQq");
parcelRequire("12bze");
parcelRequire("b7JlK");
parcelRequire("2w3jh");
parcelRequire("2dkgH");
parcelRequire("iTvLk");
parcelRequire("gXBDA");
parcelRequire("c8oBZ");
parcelRequire("cO1sB");
parcelRequire("ermqj");
parcelRequire("cfguK");
parcelRequire("1c7o5");
parcelRequire("4bSb7");
parcelRequire("dSnsn");
parcelRequire("6tpHV");
parcelRequire("6WIx0");
parcelRequire("7uH5j");

});
parcelRegister("9Du9L", function(module, exports) {

$parcel$export(module.exports, "arst_groupingFactorToTableGroup", function () { return $b2e92e89a26e2f74$export$c39ac8d686174190; });
$parcel$export(module.exports, "arst_operationToTableGroup", function () { return $b2e92e89a26e2f74$export$ecb4203dbcf899c6; });
$parcel$export(module.exports, "arst_analysisMethodToTableGroup", function () { return $b2e92e89a26e2f74$export$e905566fc5d81d62; });
$parcel$export(module.exports, "arst_tableGroupDepth", function () { return $b2e92e89a26e2f74$export$51689c75fc7b9724; });

var $40D4s = parcelRequire("40D4s");
parcelRequire("2YSoS");
var $ev45l = parcelRequire("ev45l");
var $bi6dQ = parcelRequire("bi6dQ");
const $b2e92e89a26e2f74$export$92ce999aba37533e = (group, editorProps)=>({
        id: crypto.randomUUID(),
        label: editorProps.textToT(group.label?.replaceAll("~", "\n") ?? group.name),
        group: group,
        groupId: group.id
    });
const $b2e92e89a26e2f74$export$c39ac8d686174190 = (groupingFactor, editorProps)=>({
        id: crypto.randomUUID(),
        groupingFactor: groupingFactor,
        groupingFactorId: groupingFactor.id,
        label: editorProps.textToT(groupingFactor.label?.replaceAll("~", "\n") ?? groupingFactor.name),
        isPlaceholder: groupingFactor.name === (0, $40D4s.PLACEHOLDERGROUPINGFACTOR)
    });
const $b2e92e89a26e2f74$export$ecb4203dbcf899c6 = (operation, editorProps)=>({
        id: crypto.randomUUID(),
        label: editorProps.textToT(operation.label?.replaceAll("~", "\n") ?? operation.name),
        operation: operation,
        operationId: operation.id,
        targetVariable: ""
    });
const $b2e92e89a26e2f74$export$e905566fc5d81d62 = (analysisMethod, editorProps)=>({
        id: crypto.randomUUID(),
        label: editorProps.textToT(analysisMethod.label?.replaceAll("~", "\n") ?? analysisMethod.name),
        analysisMethod: analysisMethod,
        analysisMethodId: analysisMethod.id,
        subGroups: analysisMethod.operations.map((operation)=>$b2e92e89a26e2f74$export$ecb4203dbcf899c6(operation, editorProps))
    });
const $b2e92e89a26e2f74$export$51689c75fc7b9724 = (group, editorProps)=>{
    const subGroups = "subGroups" in group && group.subGroups ? group.subGroups : [];
    const subGroupDepth = Math.max(...subGroups.map((subGroup)=>$b2e92e89a26e2f74$export$51689c75fc7b9724(subGroup, editorProps)), 0);
    let thisDepth = (0, $bi6dQ.isArsTableSubGroupGroupingFactor)(group, editorProps.isT) && !group.hidden && (group.groupingFactor.dataDriven && group.groupingFactor.dataValues.length > 0 || !group.groupingFactor.dataDriven && group.groupingFactor.groups.length > 0) ? 2 : (0, $ev45l.isArsTableOperation)(group, editorProps.isT) && group.hidden ? 0 : 1;
    if (group.inlineWithPreviousLevel) thisDepth = thisDepth - 1;
    return thisDepth + subGroupDepth;
};

});
parcelRegister("40D4s", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDERGROUPINGFACTOR", function () { return $955211b8f30b05df$export$416a1f95adf53e00; });
$parcel$export(module.exports, "totalSidebarItem", function () { return $955211b8f30b05df$export$b81ccfe0ad0c2cd5; });
$parcel$export(module.exports, "TotalGroupingFactorSidebarItem", function () { return $955211b8f30b05df$export$70468526533b0af0; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");

var $g3GSA = parcelRequire("g3GSA");
const $955211b8f30b05df$var$PLACEHOLDERLABEL = "Placeholder";
const $955211b8f30b05df$var$PLACEHOLDERDESCRIPTION = "Blank placeholder for display only";
const $955211b8f30b05df$export$416a1f95adf53e00 = "__placeholder__";
const $955211b8f30b05df$export$b81ccfe0ad0c2cd5 = {
    id: "placeholder-sidebar-item",
    label: $955211b8f30b05df$var$PLACEHOLDERLABEL,
    data: ()=>({
            kind: (0, $g3GSA.ArsSidebarItemKind).GroupingFactor,
            dropItem: {
                id: crypto.randomUUID(),
                name: $955211b8f30b05df$export$416a1f95adf53e00,
                label: $955211b8f30b05df$var$PLACEHOLDERLABEL,
                description: $955211b8f30b05df$var$PLACEHOLDERDESCRIPTION,
                groups: [],
                dataDriven: false,
                fromHierarchyId: (0, $cIJV5.CURRENT_HIERARCHY_ID)
            }
        })
};
const $955211b8f30b05df$export$70468526533b0af0 = ({ selected: selected })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`,
        style: {
            cursor: "grab"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "fw-semibold",
                children: $955211b8f30b05df$var$PLACEHOLDERLABEL
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                className: "text-muted",
                children: $955211b8f30b05df$var$PLACEHOLDERDESCRIPTION
            })
        ]
    });
};
$955211b8f30b05df$export$70468526533b0af0.displayName = "TotalGroupingFactorSidebarItem";

});

parcelRegister("2YSoS", function(module, exports) {
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("GtyWr")).isArsTableBody; });
$parcel$export(module.exports, "isArsTableColumnGroupLabel", function () { return (parcelRequire("cXBe8")).isArsTableColumnGroupLabel; });
$parcel$export(module.exports, "isArsTableColumnOperationCell", function () { return (parcelRequire("cviTh")).isArsTableColumnOperationCell; });
$parcel$export(module.exports, "isArsTableGroupCalculationDto", function () { return (parcelRequire("egJ4L")).isArsTableGroupCalculationDto; });
$parcel$export(module.exports, "isArsTableHeaderCell", function () { return (parcelRequire("8PhYZ")).isArsTableHeaderCell; });
$parcel$export(module.exports, "isArsTableHeaderRow", function () { return (parcelRequire("65ClW")).isArsTableHeaderRow; });
$parcel$export(module.exports, "isArsTableOperation", function () { return (parcelRequire("ev45l")).isArsTableOperation; });
$parcel$export(module.exports, "isArsTableRowHeaderCell", function () { return (parcelRequire("cooPK")).isArsTableRowHeaderCell; });
$parcel$export(module.exports, "isArsTableSubGroupAnalysisMethod", function () { return (parcelRequire("bi6dQ")).isArsTableSubGroupAnalysisMethod; });
$parcel$export(module.exports, "isArsTableSubGroupGroupingFactor", function () { return (parcelRequire("bi6dQ")).isArsTableSubGroupGroupingFactor; });
parcelRequire("GtyWr");
parcelRequire("cdpze");
parcelRequire("egNpM");
parcelRequire("8ZwbD");
parcelRequire("bRgSZ");
parcelRequire("cXBe8");
parcelRequire("cviTh");
parcelRequire("7BHt4");
parcelRequire("egJ4L");
parcelRequire("8PhYZ");
parcelRequire("65ClW");
parcelRequire("ev45l");
parcelRequire("dxGL5");
parcelRequire("1aiGj");
parcelRequire("kF8mV");
parcelRequire("ggGKt");
parcelRequire("cooPK");
parcelRequire("5VdL8");
parcelRequire("bi6dQ");

});
parcelRegister("GtyWr", function(module, exports) {

$parcel$export(module.exports, "isArsTableBody", function () { return $9ed90fa7b7618ee2$export$44ab8a672ac1389f; });

var $8CFpa = parcelRequire("8CFpa");

var $egJ4L = parcelRequire("egJ4L");

var $ggGKt = parcelRequire("ggGKt");
const $9ed90fa7b7618ee2$export$44ab8a672ac1389f = (obj, isT = (value)=>typeof value === "string")=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (typeof obj.analysisMethodId !== "string") return false;
    if (!Array.isArray(obj.columns) || obj.columns.some((col)=>!(0, $egJ4L.isArsTableGroupCalculationDto)(col, isT))) return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.dataSubsetId)) return false;
    if (!Array.isArray(obj.rowHeaders) || obj.rowHeaders.some((rh)=>!(0, $ggGKt.isArsTableRowHeader)(rh, isT))) return false;
    if (!Array.isArray(obj.rows) || obj.rows.some((row)=>!(0, $egJ4L.isArsTableGroupCalculationDto)(row, isT))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("egJ4L", function(module, exports) {

$parcel$export(module.exports, "isArsTableGroupCalculationDto", function () { return $ba228cca599928b6$export$203b2f7d0b312e07; });

var $ev45l = parcelRequire("ev45l");

var $bi6dQ = parcelRequire("bi6dQ");
const $ba228cca599928b6$export$203b2f7d0b312e07 = (obj, isT)=>(0, $bi6dQ.isArsTableSubGroup)(obj, isT) || (0, $ev45l.isArsTableOperation)(obj, isT);

});
parcelRegister("ev45l", function(module, exports) {

$parcel$export(module.exports, "isArsTableOperation", function () { return $5a3a20fc3ed90277$export$1a71d9da30d9c479; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");
var $hoYmS = parcelRequire("hoYmS");

var $egJ4L = parcelRequire("egJ4L");
const $5a3a20fc3ed90277$export$1a71d9da30d9c479 = (obj, isT = (val)=>typeof val === "string")=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.decimalAlignPercent)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.dimension)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (!isT(obj.label)) return false;
    if (!(0, $hoYmS.isOperation)(obj.operation)) return false;
    if (typeof obj.operationId !== "string") return false;
    if (obj.subGroups !== undefined && (!Array.isArray(obj.subGroups) || obj.subGroups.some((subGroup)=>!(0, $egJ4L.isArsTableGroupCalculationDto)(subGroup, isT)))) return false;
    // Everything is good
    return true;
};

});

parcelRegister("bi6dQ", function(module, exports) {

$parcel$export(module.exports, "isArsTableSubGroupAnalysisMethod", function () { return $b285a9f6dfdde192$export$37d1de1a885b6445; });
$parcel$export(module.exports, "isArsTableSubGroupGroupingFactor", function () { return $b285a9f6dfdde192$export$300858b96baac018; });
$parcel$export(module.exports, "isArsTableSubGroup", function () { return $b285a9f6dfdde192$export$9135b42996dd97b6; });
parcelRequire("6yroJ");
var $ek4hO = parcelRequire("ek4hO");
var $4aFWD = parcelRequire("4aFWD");
var $8CFpa = parcelRequire("8CFpa");

var $4AU0o = parcelRequire("4AU0o");

var $egJ4L = parcelRequire("egJ4L");
/**
 * Validates shared ArsTableSubGroup properties that all subgroup variants have.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the subgroup label
 * @returns - True if all common subgroup fields are valid
 */ const $b285a9f6dfdde192$var$isArsTableSubGroupBase = (obj, isT)=>{
    if (typeof obj.id !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.dimension)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (!isT(obj.label)) return false;
    if (obj.subGroups !== undefined && (!Array.isArray(obj.subGroups) || obj.subGroups.some((subGroup)=>!(0, $egJ4L.isArsTableGroupCalculationDto)(subGroup, isT)))) return false;
    return true;
};
const $b285a9f6dfdde192$export$37d1de1a885b6445 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.analysisMethodId !== "string") return false;
    if (!$b285a9f6dfdde192$var$isArsTableSubGroupBase(obj, isT)) return false;
    if (!(0, $ek4hO.isAnalysisMethod)(obj.analysisMethod)) return false;
    if (!Array.isArray(obj.subGroups)) return false;
    return true;
};
const $b285a9f6dfdde192$export$9cebbe6bbf8073dc = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.groupId !== "string") return false;
    if (!$b285a9f6dfdde192$var$isArsTableSubGroupBase(obj, isT)) return false;
    if (!(0, $4aFWD.isGroup)(obj.group)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.isDataDriven)) return false;
    return true;
};
const $b285a9f6dfdde192$export$300858b96baac018 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $4AU0o.isGroupingFactor)(obj.groupingFactor)) return false;
    if (!$b285a9f6dfdde192$var$isArsTableSubGroupBase(obj, isT)) return false;
    if (typeof obj.groupingFactorId !== "string") return false;
    return true;
};
const $b285a9f6dfdde192$export$9135b42996dd97b6 = (obj, isT)=>$b285a9f6dfdde192$export$300858b96baac018(obj, isT) || $b285a9f6dfdde192$export$9cebbe6bbf8073dc(obj, isT) || $b285a9f6dfdde192$export$37d1de1a885b6445(obj, isT);

});


parcelRegister("ggGKt", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowHeader", function () { return $88d31227a696f198$export$b5fd69fb9037f7f3; });

var $8CFpa = parcelRequire("8CFpa");
const $88d31227a696f198$export$b5fd69fb9037f7f3 = (obj, isT = (value)=>typeof value === "string")=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!Array.isArray(obj.heights) || obj.heights.some((h)=>typeof h !== "number")) return false;
    if (!isT(obj.label)) return false;
    if (typeof obj.width !== "number") return false;
    return true;
};

});


parcelRegister("cdpze", function(module, exports) {

$parcel$export(module.exports, "isArsTableBodyCell", function () { return $58f17856ff6dbb63$export$65000cda1567003b; });

var $7BHt4 = parcelRequire("7BHt4");

var $1aiGj = parcelRequire("1aiGj");

var $kF8mV = parcelRequire("kF8mV");

var $5VdL8 = parcelRequire("5VdL8");
const $58f17856ff6dbb63$export$65000cda1567003b = (obj, isT)=>(0, $7BHt4.isArsTableDataCell)(obj, isT) || (0, $1aiGj.isArsTableRowGroupCell)(obj, isT) || (0, $kF8mV.isArsTableRowGroupLabel)(obj, isT) || (0, $5VdL8.isArsTableRowOperationCell)(obj, isT);

});
parcelRegister("7BHt4", function(module, exports) {

$parcel$export(module.exports, "isArsTableDataCell", function () { return $cebb534d67a80312$export$3ecf0544bb36b9a7; });

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $cebb534d67a80312$export$3ecf0544bb36b9a7 = (obj, isT)=>{
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).DataCell) return false;
    if (obj.targetType !== "data") return false;
    // Everything is good
    return true;
};

});
parcelRegister("i3Ps9", function(module, exports) {

$parcel$export(module.exports, "ArsTableJustification", function () { return $964e517945c0f6db$export$7d9f6ee099b6db7b; });
$parcel$export(module.exports, "ArsTextJustification", function () { return $964e517945c0f6db$export$ee40378e59d6a6c; });
$parcel$export(module.exports, "defaultColumnWidth", function () { return $964e517945c0f6db$export$886404f422f393c4; });
$parcel$export(module.exports, "defaultRowHeight", function () { return $964e517945c0f6db$export$6936fd3acc6fc2ae; });
$parcel$export(module.exports, "ArsTableCellType", function () { return $964e517945c0f6db$export$47ff599de1827f35; });
$parcel$export(module.exports, "ARST_CHANGE_SENT", function () { return $964e517945c0f6db$export$cfed06c756844cf6; });
$parcel$export(module.exports, "ARST_LOAD_DATA", function () { return $964e517945c0f6db$export$5ada652acce7912f; });
$parcel$export(module.exports, "ARST_PATCH_DATA", function () { return $964e517945c0f6db$export$6ecacf39e0a26df2; });
$parcel$export(module.exports, "ARST_SET_SCAFFOLD_COL_WIDTH", function () { return $964e517945c0f6db$export$218f0f67ef351e1c; });
$parcel$export(module.exports, "ARST_SET_SCAFFOLD_ROW_HEIGHT", function () { return $964e517945c0f6db$export$155c0e95cab929f1; });
$parcel$export(module.exports, "ARST_SET_TLF_VIEW_MODE", function () { return $964e517945c0f6db$export$483d097f90c2cc26; });
$parcel$export(module.exports, "ARST_UPDATE_SCAFFOLD", function () { return $964e517945c0f6db$export$1a03622c6b060f45; });
$parcel$export(module.exports, "ARST_SET_VIEW_ITEM", function () { return $964e517945c0f6db$export$86669dc20b972f5a; });
$parcel$export(module.exports, "ARST_REMOVE_GROUPINGFACTOR", function () { return $964e517945c0f6db$export$70a7af7c9f0d8e12; });
$parcel$export(module.exports, "ARST_REMOVE_OPERATION", function () { return $964e517945c0f6db$export$c23f96b8e147acf0; });
$parcel$export(module.exports, "ARST_TOGGLE_GROUP_LABEL_INLINE", function () { return $964e517945c0f6db$export$537a49b218fbef41; });
$parcel$export(module.exports, "ARST_TOGGLE_GROUP_LABEL_VISIBILITY", function () { return $964e517945c0f6db$export$5c51c9231c63c37a; });
$parcel$export(module.exports, "ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL", function () { return $964e517945c0f6db$export$1b8f7a1b6e30aa10; });
$parcel$export(module.exports, "ARST_INSERT_COLUMN_AFTER", function () { return $964e517945c0f6db$export$2c17c1ca0f467a4b; });
$parcel$export(module.exports, "ARST_INSERT_COLUMN_BEFORE", function () { return $964e517945c0f6db$export$b9122efadb51714e; });
$parcel$export(module.exports, "ARST_INSERT_ROW_AFTER", function () { return $964e517945c0f6db$export$1eae02ed16bfbdf5; });
$parcel$export(module.exports, "ARST_INSERT_ROW_BEFORE", function () { return $964e517945c0f6db$export$d07bcef33db63800; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_COLUMN_AFTER", function () { return $964e517945c0f6db$export$ad448d57afd9077; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_COLUMN_BEFORE", function () { return $964e517945c0f6db$export$d38b740e1f7a68d1; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_ROW_AFTER", function () { return $964e517945c0f6db$export$451ee3a8df697c4e; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_ROW_BEFORE", function () { return $964e517945c0f6db$export$adb710d4cbc8f45f; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_SUBGROUP", function () { return $964e517945c0f6db$export$64cf2863dc911646; });
$parcel$export(module.exports, "ARST_INSERT_SUBGROUP", function () { return $964e517945c0f6db$export$43e16b6ac3552ed5; });
var $964e517945c0f6db$export$7d9f6ee099b6db7b = /*#__PURE__*/ function(ArsTableJustification) {
    ArsTableJustification["Left"] = "left";
    ArsTableJustification["Center"] = "center";
    ArsTableJustification["Right"] = "right";
    return ArsTableJustification;
}({});
var $964e517945c0f6db$export$ee40378e59d6a6c = /*#__PURE__*/ function(ArsTextJustification) {
    ArsTextJustification["Default"] = "default";
    ArsTextJustification["Left"] = "left";
    ArsTextJustification["Center"] = "center";
    ArsTextJustification["Right"] = "right";
    ArsTextJustification["Decimal"] = "decimal";
    return ArsTextJustification;
}({});
const $964e517945c0f6db$export$886404f422f393c4 = 120;
const $964e517945c0f6db$export$6936fd3acc6fc2ae = 40;
var $964e517945c0f6db$export$47ff599de1827f35 = /*#__PURE__*/ function(ArsTableCellType) {
    ArsTableCellType["ColumnGroupCell"] = "columnGroupCell";
    ArsTableCellType["ColumnGroupLabel"] = "columnGroupLabel";
    ArsTableCellType["ColumnOperation"] = "columnOperation";
    ArsTableCellType["DataCell"] = "dataCell";
    ArsTableCellType["RowGroupCell"] = "rowGroupCell";
    ArsTableCellType["RowGroupLabel"] = "rowGroupLabel";
    ArsTableCellType["RowHeader"] = "rowHeader";
    ArsTableCellType["RowOperation"] = "rowOperation";
    return ArsTableCellType;
}({});
const $964e517945c0f6db$export$b92d99cadb25c9f8 = new Set([
    "rowGroupCell",
    "rowGroupLabel",
    "rowOperation"
]);
const $964e517945c0f6db$export$1db9ab1cef372d16 = new Set([
    "columnGroupCell",
    "columnGroupLabel",
    "columnOperation"
]);
const $964e517945c0f6db$export$ddfb028992d54455 = new Set([
    "rowHeader"
]);
const $964e517945c0f6db$export$137715ee943ad637 = new Set([
    "columnGroupLabel",
    "rowGroupLabel"
]);
const $964e517945c0f6db$export$a61d1802597b7710 = new Set([
    ...$964e517945c0f6db$export$1db9ab1cef372d16,
    ...$964e517945c0f6db$export$b92d99cadb25c9f8
]);
const $964e517945c0f6db$export$cfed06c756844cf6 = "ARST_CHANGE_SENT";
const $964e517945c0f6db$export$5ada652acce7912f = "ARST_LOAD_DATA";
const $964e517945c0f6db$export$6ecacf39e0a26df2 = "ARST_PATCH_DATA";
const $964e517945c0f6db$export$218f0f67ef351e1c = "ARST_SET_SCAFFOLD_COL_WIDTH";
const $964e517945c0f6db$export$155c0e95cab929f1 = "ARST_SET_SCAFFOLD_ROW_HEIGHT";
const $964e517945c0f6db$export$e599521a5514fb1d = "ARST_SET_SIDEBAR_FILTER";
const $964e517945c0f6db$export$fefc559b78ddf85 = "ARST_SET_SIDEBAR_VIEW";
const $964e517945c0f6db$export$606135a5ddef388a = "ARST_TOGGLE_SIDEBAR";
const $964e517945c0f6db$export$483d097f90c2cc26 = "ARST_SET_TLF_VIEW_MODE";
const $964e517945c0f6db$export$1a03622c6b060f45 = "ARST_UPDATE_SCAFFOLD";
const $964e517945c0f6db$export$86669dc20b972f5a = "ARST_SET_VIEW_ITEM";
const $964e517945c0f6db$export$70a7af7c9f0d8e12 = "ARST_REMOVE_GROUPINGFACTOR";
const $964e517945c0f6db$export$c23f96b8e147acf0 = "ARST_REMOVE_OPERATION";
const $964e517945c0f6db$export$537a49b218fbef41 = "ARST_TOGGLE_GROUP_LABEL_INLINE";
const $964e517945c0f6db$export$5c51c9231c63c37a = "ARST_TOGGLE_GROUP_LABEL_VISIBILITY";
const $964e517945c0f6db$export$1b8f7a1b6e30aa10 = "ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL";
const $964e517945c0f6db$export$2c17c1ca0f467a4b = "ARST_INSERT_COLUMN_AFTER";
const $964e517945c0f6db$export$b9122efadb51714e = "ARST_INSERT_COLUMN_BEFORE";
const $964e517945c0f6db$export$1eae02ed16bfbdf5 = "ARST_INSERT_ROW_AFTER";
const $964e517945c0f6db$export$d07bcef33db63800 = "ARST_INSERT_ROW_BEFORE";
const $964e517945c0f6db$export$ad448d57afd9077 = "ARST_INSERT_OPERATION_COLUMN_AFTER";
const $964e517945c0f6db$export$d38b740e1f7a68d1 = "ARST_INSERT_OPERATION_COLUMN_BEFORE";
const $964e517945c0f6db$export$451ee3a8df697c4e = "ARST_INSERT_OPERATION_ROW_AFTER";
const $964e517945c0f6db$export$adb710d4cbc8f45f = "ARST_INSERT_OPERATION_ROW_BEFORE";
const $964e517945c0f6db$export$64cf2863dc911646 = "ARST_INSERT_OPERATION_SUBGROUP";
const $964e517945c0f6db$export$43e16b6ac3552ed5 = "ARST_INSERT_SUBGROUP";

});

parcelRegister("egNpM", function(module, exports) {

$parcel$export(module.exports, "isArsTableCellBase", function () { return $89f05baa3614e878$export$2780cb1ef49f9bdd; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");
const $89f05baa3614e878$export$2780cb1ef49f9bdd = (obj, isT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.annotationContent !== "string") return false;
    if (!Object.values((0, $i3Ps9.ArsTableCellType)).includes(obj.cellType)) return false;
    if (typeof obj.dataPath !== "string") return false;
    if (!isT(obj.displayContent)) return false;
    // Everything is good
    return true;
};

});


parcelRegister("1aiGj", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowGroupCell", function () { return $203c3837c2605662$export$baa85814fe3f2d0c; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $203c3837c2605662$export$baa85814fe3f2d0c = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupCell) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.indents)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.height)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (typeof obj.targetType !== "string" || ![
        "analysisMethod",
        "groupingFactor"
    ].includes(obj.targetType)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("kF8mV", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowGroupLabel", function () { return $9d5fd17510aa28b5$export$b1f1aba6be74dad8; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $9d5fd17510aa28b5$export$b1f1aba6be74dad8 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupLabel) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.height)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.indents)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (typeof obj.targetType !== "string" || ![
        "dataDriven",
        "group"
    ].includes(obj.targetType)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("5VdL8", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowOperationCell", function () { return $36ec5eb78f86e5e0$export$f296242daf9cf562; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $36ec5eb78f86e5e0$export$f296242daf9cf562 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).RowOperation) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.height)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.indents)) return false;
    if (typeof obj.targetId !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("8ZwbD", function(module, exports) {

var $cdpze = parcelRequire("cdpze");

var $8PhYZ = parcelRequire("8PhYZ");
const $87fc3001b2edc499$export$29b498ea8d90aec4 = (obj, isT)=>(0, $8PhYZ.isArsTableHeaderCell)(obj, isT) || (0, $cdpze.isArsTableBodyCell)(obj, isT);

});
parcelRegister("8PhYZ", function(module, exports) {

$parcel$export(module.exports, "isArsTableHeaderCell", function () { return $561d0d0c6ecbfab5$export$9b9801f30387dcd4; });

var $bRgSZ = parcelRequire("bRgSZ");

var $cXBe8 = parcelRequire("cXBe8");

var $cviTh = parcelRequire("cviTh");

var $cooPK = parcelRequire("cooPK");
const $561d0d0c6ecbfab5$export$9b9801f30387dcd4 = (obj, isT)=>(0, $bRgSZ.isArsTableColumnGroupCell)(obj, isT) || (0, $cXBe8.isArsTableColumnGroupLabel)(obj, isT) || (0, $cviTh.isArsTableColumnOperationCell)(obj, isT) || (0, $cooPK.isArsTableRowHeaderCell)(obj, isT);

});
parcelRegister("bRgSZ", function(module, exports) {

$parcel$export(module.exports, "isArsTableColumnGroupCell", function () { return $f594f1a1beecc820$export$f30dbcde1814eba3; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $f594f1a1beecc820$export$f30dbcde1814eba3 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnGroupCell) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.width)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("cXBe8", function(module, exports) {

$parcel$export(module.exports, "isArsTableColumnGroupLabel", function () { return $0f9dfd43c7c65f7a$export$cd51abffdf7e351d; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $0f9dfd43c7c65f7a$export$cd51abffdf7e351d = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnGroupLabel) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.width)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("cviTh", function(module, exports) {

$parcel$export(module.exports, "isArsTableColumnOperationCell", function () { return $5071ef93de47db08$export$fcdcc125580624b1; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $5071ef93de47db08$export$fcdcc125580624b1 = (obj, isT)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnOperation) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (typeof obj.targetId !== "string") return false;
    if (obj.targetType !== "operation") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.width)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("cooPK", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowHeaderCell", function () { return $06a7dffbb8bf0d35$export$dd40550f5f871171; });

var $i3Ps9 = parcelRequire("i3Ps9");

var $egNpM = parcelRequire("egNpM");
const $06a7dffbb8bf0d35$export$dd40550f5f871171 = (obj, isT)=>{
    if (!(0, $egNpM.isArsTableCellBase)(obj, isT)) return false;
    const rowHeaderCell = obj;
    if (rowHeaderCell.cellType !== (0, $i3Ps9.ArsTableCellType).RowHeader) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof rowHeaderCell.width)) return false;
    // Everything is good
    return true;
};

});



parcelRegister("65ClW", function(module, exports) {

$parcel$export(module.exports, "isArsTableHeaderRow", function () { return $564ad88195869525$export$966b773f074095b5; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $8PhYZ = parcelRequire("8PhYZ");
const $564ad88195869525$export$966b773f074095b5 = (obj, isT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.height !== "number") return false;
    if (!Array.isArray(obj.arsTableCells) || obj.arsTableCells.some((cell)=>!(0, $8PhYZ.isArsTableHeaderCell)(cell, isT))) return false;
    // Everything is good
    return true;
};

});

parcelRegister("dxGL5", function(module, exports) {

var $2mtW4 = parcelRequire("2mtW4");

var $65ClW = parcelRequire("65ClW");
const $8eaa64b8d1973810$export$1e1e66a8334346dd = (obj, isT)=>(0, $65ClW.isArsTableHeaderRow)(obj, isT) || (0, $2mtW4.isArsTableDataRow)(obj, isT);

});
parcelRegister("2mtW4", function(module, exports) {

$parcel$export(module.exports, "isArsTableDataRow", function () { return $611964600d33d70c$export$af65e8726e5f60d4; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $cdpze = parcelRequire("cdpze");
const $611964600d33d70c$export$af65e8726e5f60d4 = (obj, isT)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.height !== "number") return false;
    if (typeof obj.rowGroup !== "number") return false;
    if (!Array.isArray(obj.arsTableCells) || obj.arsTableCells.some((cell)=>!(0, $cdpze.isArsTableBodyCell)(cell, isT))) return false;
    // Everything is good
    return true;
};

});




parcelRegister("lsgLV", function(module, exports) {

$parcel$export(module.exports, "arst_changeSent", function () { return $c4ac5c8ccc83dbca$export$c402551ff46b4719; });
const $c4ac5c8ccc83dbca$export$c402551ff46b4719 = (state)=>({
        ...state,
        changed: false
    });

});

parcelRegister("6RjQK", function(module, exports) {

$parcel$export(module.exports, "arst_checkRowHeaders", function () { return $e5ecbf79cae10878$export$f85f9a86e4c625f2; });

var $i3Ps9 = parcelRequire("i3Ps9");

var $9Du9L = parcelRequire("9Du9L");

var $cfguK = parcelRequire("cfguK");
const $e5ecbf79cae10878$export$f85f9a86e4c625f2 = (bodyData, editorProps)=>{
    const columnDepth = Math.max(...bodyData.columns.map((group)=>(0, $9Du9L.arst_tableGroupDepth)(group, editorProps)), 1);
    const rowDepth = Math.max(...bodyData.rows.map((group)=>(0, $9Du9L.arst_tableGroupDepth)(group, editorProps)), 1);
    const rowHeaderTemplate = (0, $cfguK.blankRowHeaderCell)(editorProps.blankT, columnDepth);
    // Check that a change is required
    if (bodyData.rowHeaders.length === rowDepth && bodyData.rowHeaders.every((rowHeader)=>rowHeader.heights.length === columnDepth && rowHeader.heights.every((height)=>height === rowHeaderTemplate.heights[0]))) return bodyData.rowHeaders;
    // Otherwise create new rowHeaders with correct heights and number of cells
    const currentRowHeights = bodyData.rowHeaders.length > 0 ? bodyData.rowHeaders[0].heights : [];
    const newRowHeights = [
        ...currentRowHeights.slice(0, columnDepth),
        ...Array.from({
            length: columnDepth - currentRowHeights.length
        }, ()=>(0, $i3Ps9.defaultRowHeight))
    ];
    const newRowHeaders = [
        ...bodyData.rowHeaders.slice(0, rowDepth).map((rowHeader)=>({
                ...rowHeader,
                heights: newRowHeights
            })),
        ...Array.from({
            length: rowDepth - bodyData.rowHeaders.length
        }, ()=>({
                ...rowHeaderTemplate
            }))
    ];
    return newRowHeaders;
};

});
parcelRegister("cfguK", function(module, exports) {

$parcel$export(module.exports, "blankRowHeaderCell", function () { return $ed0d3c1756e07f0b$export$c3378a17afe7beab; });

var $i3Ps9 = parcelRequire("i3Ps9");
const $ed0d3c1756e07f0b$export$c3378a17afe7beab = (blankT, columnHeaderHeights)=>({
        width: (0, $i3Ps9.defaultColumnWidth),
        label: blankT,
        heights: Array.isArray(columnHeaderHeights) ? columnHeaderHeights : Array(columnHeaderHeights).fill((0, $i3Ps9.defaultRowHeight))
    });

});


parcelRegister("iqF5u", function(module, exports) {

$parcel$export(module.exports, "arst_insertDroppedItem", function () { return $8dae3f6384c18c84$export$807a30f214efc0ee; });
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");
var $ci0ss = parcelRequire("ci0ss");
parcelRequire("kevCO");
var $g3GSA = parcelRequire("g3GSA");
parcelRequire("6yroJ");
var $ek4hO = parcelRequire("ek4hO");
var $4AU0o = parcelRequire("4AU0o");
var $hoYmS = parcelRequire("hoYmS");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $egJ4L = parcelRequire("egJ4L");

var $9Du9L = parcelRequire("9Du9L");

var $6RjQK = parcelRequire("6RjQK");

var $12bze = parcelRequire("12bze");
const $8dae3f6384c18c84$export$807a30f214efc0ee = (state, action)=>{
    const targetCell = state.scaffoldModel?.cellData?.[action.rowId]?.[action.columnId];
    if (!targetCell) return state;
    const targetDataPath = (0, $12bze.arst_resolveTargetPath)(targetCell.dataPath);
    // Create new table groups from the dropped item
    const newTableGroups = action.payload.map((item)=>item.dropItem).map((item)=>{
        return (0, $4AU0o.isGroupingFactor)(item) ? (0, $9Du9L.arst_groupingFactorToTableGroup)(item, state.settings.editorProps) : (0, $hoYmS.isOperation)(item) ? (0, $9Du9L.arst_operationToTableGroup)(item, state.settings.editorProps) : (0, $ek4hO.isAnalysisMethod)(item) ? (0, $9Du9L.arst_analysisMethodToTableGroup)(item, state.settings.editorProps) : null;
    }).filter((group)=>group !== null);
    if (newTableGroups.length === 0) return state;
    // Update AnalysisMethodId
    const newAnalysisMethodIds = new Set([
        state.bodyData.analysisMethodId,
        ...action.payload.filter((item)=>item.kind === "analysisMethod").map((item)=>item.dropItem.id),
        ...action.payload.filter((item)=>item.kind === "operation").map((item)=>item.analysisMethodId)
    ].filter(Boolean));
    if (newAnalysisMethodIds.size > 1) // Abort if multiple analysis methods are being inserted or if the new analysis method is different from the current one
    return state;
    // Insert subGroup under target group
    /* istanbul ignore else */ if ([
        (0, $i3Ps9.ARST_INSERT_SUBGROUP),
        (0, $i3Ps9.ARST_INSERT_OPERATION_SUBGROUP)
    ].includes(action.operation)) {
        let newBodyData = state.bodyData;
        // Get target group
        const currentGroup = (0, $eAPMz.getFromDataPath)(targetDataPath, newBodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
        // Abort if target is not found
        if (!currentGroup) return state;
        // Get new subGroups for the current group
        const newSubGroups = [
            ...currentGroup.subGroups ?? [],
            ...newTableGroups
        ];
        newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, `${targetDataPath}/subGroups`, newSubGroups);
        const newGroupingFactorIds = new Set(state.usedGroupingFactorIds);
        action.payload.forEach((item)=>{
            // TODO: This shouldn't be here, there should an an operation test!
            /* istanbul ignore else */ if (item.kind === (0, $g3GSA.ArsSidebarItemKind).GroupingFactor) newGroupingFactorIds.add(item.dropItem.id);
        });
        newBodyData.rowHeaders = (0, $6RjQK.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
        return {
            ...state,
            bodyData: {
                ...newBodyData,
                analysisMethodId: newAnalysisMethodIds.values().next().value ?? // istanbul ignore next
                ""
            },
            usedGroupingFactorIds: newGroupingFactorIds,
            changed: true
        };
    } else if ([
        (0, $i3Ps9.ARST_INSERT_COLUMN_AFTER),
        (0, $i3Ps9.ARST_INSERT_COLUMN_BEFORE),
        (0, $i3Ps9.ARST_INSERT_ROW_AFTER),
        (0, $i3Ps9.ARST_INSERT_ROW_BEFORE),
        (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_BEFORE),
        (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_AFTER),
        (0, $i3Ps9.ARST_INSERT_OPERATION_ROW_BEFORE),
        (0, $i3Ps9.ARST_INSERT_OPERATION_ROW_AFTER)
    ].includes(action.operation)) {
        // Set up return
        let newBodyData = state.bodyData;
        // Resolve if before or after
        const isInsertAfter = [
            (0, $i3Ps9.ARST_INSERT_COLUMN_AFTER),
            (0, $i3Ps9.ARST_INSERT_ROW_AFTER),
            (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_AFTER),
            (0, $i3Ps9.ARST_INSERT_OPERATION_ROW_AFTER)
        ].includes(action.operation);
        // Resolve if column or row
        const isInsertColumn = [
            (0, $i3Ps9.ARST_INSERT_COLUMN_AFTER),
            (0, $i3Ps9.ARST_INSERT_COLUMN_BEFORE),
            (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_AFTER),
            (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_BEFORE)
        ].includes(action.operation);
        // Get path parts here
        const targetPathParts = targetDataPath.split("/").filter(Boolean);
        // Inserting at start of root
        if (targetPathParts.length === 0 || targetPathParts[0] === "rowHeaders") {
            const newRootGroups = isInsertColumn ? [
                ...newTableGroups,
                ...state.bodyData.columns ?? []
            ] : [
                ...newTableGroups,
                ...state.bodyData.rows ?? []
            ];
            const newBodyData = isInsertColumn ? {
                ...state.bodyData,
                columns: newRootGroups
            } : {
                ...state.bodyData,
                rows: newRootGroups
            };
            newBodyData.rowHeaders = (0, $6RjQK.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
            return {
                ...state,
                bodyData: {
                    ...newBodyData,
                    analysisMethodId: newAnalysisMethodIds.values().next().value ?? ""
                },
                changed: true
            };
        } else {
            // Update inserting index if inserting after
            const thisIndex = parseInt(targetPathParts[targetPathParts.length - 1], 10);
            const insertAt = thisIndex + (isInsertAfter ? 1 : 0);
            if (Number.isNaN(thisIndex)) return state;
            if (isInsertAfter) targetPathParts[targetPathParts.length - 1] = insertAt.toString();
            const insertDataPath = `/${targetPathParts.join("/")}`;
            // Update table groups, either rows or columns
            const parentPath = (0, $ci0ss.reduceDataPath)(insertDataPath, 2);
            const parentGroup = (0, $eAPMz.getFromDataPath)(parentPath, newBodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
            if (parentGroup) {
                const newSubGroups = [
                    ...parentGroup.subGroups ?? []
                ];
                newSubGroups.splice(insertAt, 0, ...newTableGroups);
                newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, `${parentPath}/subGroups`, newSubGroups);
            } else // Inserting at root level
            if (isInsertColumn) {
                const newColumns = [
                    ...state.bodyData.columns ?? []
                ];
                newColumns.splice(insertAt, 0, ...newTableGroups);
                newBodyData = {
                    ...newBodyData,
                    columns: newColumns
                };
            } else {
                const newRows = [
                    ...state.bodyData.rows ?? []
                ];
                newRows.splice(insertAt, 0, ...newTableGroups);
                newBodyData = {
                    ...newBodyData,
                    rows: newRows
                };
            }
            // Update rowHeaders if required
            newBodyData.rowHeaders = (0, $6RjQK.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
        }
        // Update used grouping factor ids
        const newUsedGroupingFactorIds = new Set(state.usedGroupingFactorIds);
        action.payload.forEach((item)=>{
            if (item.kind === (0, $g3GSA.ArsSidebarItemKind).GroupingFactor) newUsedGroupingFactorIds.add(item.dropItem.id);
        });
        return {
            ...state,
            bodyData: {
                ...newBodyData,
                analysisMethodId: newAnalysisMethodIds.values().next().value ?? ""
            },
            usedGroupingFactorIds: newUsedGroupingFactorIds,
            changed: true
        };
    }
    // istanbul ignore next - should not happen
    return state;
};

});
parcelRegister("12bze", function(module, exports) {

$parcel$export(module.exports, "arst_resolveTargetPath", function () { return $3ce26e67fb84b03c$export$13cf4a2dbbe8a783; });
parcelRequire("2nuru");
var $ci0ss = parcelRequire("ci0ss");
function $3ce26e67fb84b03c$export$13cf4a2dbbe8a783(inp) {
    // Standard string
    if (typeof inp === "string") {
        const pathParts = inp.split("/").filter(Boolean);
        // Check for dataValues/groups
        if ([
            "dataValues",
            "groups"
        ].includes(pathParts[pathParts.length - 2])) pathParts.splice(-2, 2);
        return `/${pathParts.join("/")}`;
    } else return "targetType" in inp.cellValue && [
        "group",
        "dataDriven"
    ].includes(inp.cellValue.targetType) ? (0, $ci0ss.reduceDataPath)(inp.cellValue.dataPath, 2) : inp.cellValue.dataPath;
}

});


parcelRegister("zfKzR", function(module, exports) {

$parcel$export(module.exports, "arst_loadData", function () { return $6bff49d88a172623$export$30f618da6e7a7d27; });

var $dSnsn = parcelRequire("dSnsn");
const $6bff49d88a172623$export$30f618da6e7a7d27 = (state, action)=>({
        ...state,
        bodyData: action.bodyData,
        usedGroupingFactorIds: (0, $dSnsn.computeUsedGroupingFactorIds)(action.bodyData),
        changed: false
    });

});
parcelRegister("dSnsn", function(module, exports) {

$parcel$export(module.exports, "computeUsedGroupingFactorIds", function () { return $d67b2b6bf9d6c2d0$export$695e8c0c21c59820; });
/**
 * Recursively collects all grouping factor IDs present in an ArsTable group tree.
 *
 * @param groups - The array of table groups to inspect
 * @param ids - Set to accumulate IDs into
 */ const $d67b2b6bf9d6c2d0$var$collectGroupingFactorIds = (groups, ids)=>{
    for (const group of groups){
        if ("groupingFactor" in group) ids.add(group.groupingFactor.id);
        if ("subGroups" in group && group.subGroups) $d67b2b6bf9d6c2d0$var$collectGroupingFactorIds(group.subGroups, ids);
    }
};
const $d67b2b6bf9d6c2d0$export$695e8c0c21c59820 = (bodyData)=>{
    const ids = new Set();
    $d67b2b6bf9d6c2d0$var$collectGroupingFactorIds(bodyData.columns, ids);
    $d67b2b6bf9d6c2d0$var$collectGroupingFactorIds(bodyData.rows, ids);
    return ids;
};

});


parcelRegister("4VjTy", function(module, exports) {

$parcel$export(module.exports, "arst_patchData", function () { return $c462b16b940e571a$export$68f982a626f4c267; });
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");

var $dSnsn = parcelRequire("dSnsn");
const $c462b16b940e571a$export$68f982a626f4c267 = (state, action)=>{
    let newBodyData = {
        ...state.bodyData
    };
    let scaffoldModel = state.scaffoldModel ? {
        ...state.scaffoldModel
    } : null;
    let calculatedTableRows = state.calculatedTableRows ? [
        ...state.calculatedTableRows
    ] : [];
    const updates = "updates" in action ? action.updates : [
        {
            dataPath: action.dataPath,
            value: action.value
        }
    ];
    for (const update of updates){
        if (update.dataPath.startsWith("scaffoldModel")) {
            if (!scaffoldModel) continue;
            scaffoldModel = (0, $dsPLF.mutateByPath)(scaffoldModel, update.dataPath.replace("scaffoldModel/", ""), update.value);
        } else if (update.dataPath.startsWith("calculatedTableRows")) calculatedTableRows = (0, $dsPLF.mutateByPath)(calculatedTableRows, update.dataPath.replace("calculatedTableRows/", ""), update.value);
        else newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, update.dataPath, update.value);
    }
    return {
        ...state,
        bodyData: newBodyData,
        scaffoldModel: scaffoldModel,
        calculatedTableRows: calculatedTableRows,
        usedGroupingFactorIds: (0, $dSnsn.computeUsedGroupingFactorIds)(newBodyData),
        changed: true
    };
};

});

parcelRegister("6h9L6", function(module, exports) {

$parcel$export(module.exports, "arst_removeGroupingFactor", function () { return $2024a971fda98b11$export$ced1eb8c2ea8a585; });
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $ci0ss = parcelRequire("ci0ss");
var $34cNk = parcelRequire("34cNk");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $egJ4L = parcelRequire("egJ4L");

var $6RjQK = parcelRequire("6RjQK");

var $12bze = parcelRequire("12bze");

var $dSnsn = parcelRequire("dSnsn");

var $VWM8I = parcelRequire("VWM8I");
const $2024a971fda98b11$export$ced1eb8c2ea8a585 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnGroupCell && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnGroupLabel && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupLabel) return state;
    // Get updates dataPath
    const targetDataPath = (0, $12bze.arst_resolveTargetPath)(action);
    // Check if the target dataPath exists in the bodyData
    let targetValue = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    if (!targetValue) return state;
    // Get sibling count
    let siblingCount = action.cellValue.siblingCount;
    const isRemoveColumn = [
        (0, $i3Ps9.ArsTableCellType).ColumnGroupCell,
        (0, $i3Ps9.ArsTableCellType).ColumnGroupLabel
    ].includes(action.cellValue.cellType);
    // Get grouping factor sibling count
    if (targetDataPath !== action.cellValue.dataPath) targetValue = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    // Refresh sibling count
    const parentDataPath = (0, $ci0ss.reduceDataPath)(targetDataPath, 2);
    const parentGroup = (0, $eAPMz.getFromDataPath)(parentDataPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    siblingCount = parentGroup?.subGroups?.length ?? (isRemoveColumn ? state.bodyData.columns.length : state.bodyData.rows.length);
    // Remove grouping factor node from bodyData
    const newBodyData = (0, $34cNk.removeByPath)(state.bodyData, targetDataPath, siblingCount - 1);
    // Check if row headers need to be updated
    newBodyData.rowHeaders = (0, $6RjQK.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    // Check some operations are still present in the table, if not, clear the analysisMethodId
    if (!(0, $VWM8I.containsAnalysisMethod)(newBodyData.columns) && !(0, $VWM8I.containsAnalysisMethod)(newBodyData.rows)) newBodyData.analysisMethodId = "";
    return {
        ...state,
        bodyData: newBodyData,
        usedGroupingFactorIds: (0, $dSnsn.computeUsedGroupingFactorIds)(newBodyData),
        changed: true
    };
};

});
parcelRegister("VWM8I", function(module, exports) {

$parcel$export(module.exports, "containsAnalysisMethod", function () { return $156483d3635ce653$export$6f148dcbdf337b4c; });
const $156483d3635ce653$export$6f148dcbdf337b4c = (tableGroups)=>{
    return tableGroups?.some((tableGroup)=>{
        if ("analysisMethod" in tableGroup || "operation" in tableGroup) return true;
        else return $156483d3635ce653$export$6f148dcbdf337b4c(tableGroup.subGroups);
    }) ?? false;
};

});


parcelRegister("dymQq", function(module, exports) {

$parcel$export(module.exports, "arst_removeOperation", function () { return $d0ace4b291feae72$export$a8417f1f72e65940; });
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $ci0ss = parcelRequire("ci0ss");
var $34cNk = parcelRequire("34cNk");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $egJ4L = parcelRequire("egJ4L");

var $6RjQK = parcelRequire("6RjQK");

var $VWM8I = parcelRequire("VWM8I");
const $d0ace4b291feae72$export$a8417f1f72e65940 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnOperation && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowOperation) return state;
    // Get target dataPath
    const targetDataPath = action.cellValue.dataPath;
    // Check if the target dataPath exists in the bodyData
    const targetValue = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    if (!targetValue) return state;
    const isRemoveColumn = action.cellValue.cellType === (0, $i3Ps9.ArsTableCellType).ColumnOperation;
    // Get sibling count
    const parentDataPath = (0, $ci0ss.reduceDataPath)(action.cellValue.dataPath, 2);
    const parentGroup = (0, $eAPMz.getFromDataPath)(parentDataPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    const siblingCount = parentGroup?.subGroups?.length ?? (isRemoveColumn ? state.bodyData.columns.length : state.bodyData.rows.length);
    const newBodyData = (0, $34cNk.removeByPath)(state.bodyData, targetDataPath, siblingCount - 1);
    // Check if row headers need to be updated
    newBodyData.rowHeaders = (0, $6RjQK.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    // Check some operations are still present in the table, if not, clear the analysisMethodId
    if (!(0, $VWM8I.containsAnalysisMethod)(newBodyData.columns) && !(0, $VWM8I.containsAnalysisMethod)(newBodyData.rows)) newBodyData.analysisMethodId = "";
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("b7JlK", function(module, exports) {

$parcel$export(module.exports, "arst_setScaffoldColWidth", function () { return $282ac461779682e1$export$8fd5e5a4535a87c8; });
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");
parcelRequire("2YSoS");
var $cXBe8 = parcelRequire("cXBe8");
var $cviTh = parcelRequire("cviTh");
var $cooPK = parcelRequire("cooPK");

var $12bze = parcelRequire("12bze");

var $6WIx0 = parcelRequire("6WIx0");
const $282ac461779682e1$export$8fd5e5a4535a87c8 = (state, action)=>{
    // Find correct target
    const colCells = (0, $6WIx0.getColumnCells)(state.calculatedTableRows, action.colId);
    const targetCell = colCells.find((cell)=>(0, $cooPK.isArsTableRowHeaderCell)(cell, state.settings.editorProps.isT) || (0, $cviTh.isArsTableColumnOperationCell)(cell, state.settings.editorProps.isT) || (0, $cXBe8.isArsTableColumnGroupLabel)(cell, state.settings.editorProps.isT) && (cell.colSpan ?? 1) === 1);
    if (!targetCell || !state.scaffoldModel) return state;
    // Update scaffold model with new column width
    const newScaffoldModel = (0, $dsPLF.mutateByPath)(state.scaffoldModel, `/columns/${targetCell.columnIndex}/width`, action.width);
    let newBodyData = state.bodyData;
    if (targetCell.dataPath.startsWith("/rowHeaders")) newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, `${targetCell.dataPath}/width`, action.width);
    else {
        const targetDataPath = (0, $12bze.arst_resolveTargetPath)(targetCell.dataPath);
        newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, `${targetDataPath}/dimension`, action.width);
    }
    return {
        ...state,
        bodyData: newBodyData,
        scaffoldModel: newScaffoldModel,
        changed: true
    };
};

});
parcelRegister("6WIx0", function(module, exports) {

$parcel$export(module.exports, "getColumnCells", function () { return $34a7e4e18a36119d$export$772487724a7ca0b6; });
const $34a7e4e18a36119d$export$772487724a7ca0b6 = (tableRows, columnId)=>{
    if (!tableRows) return [];
    return tableRows.map((row)=>row.arsTableCells.find((cell)=>cell.columnId === columnId)).filter((cell)=>cell !== undefined);
};

});


parcelRegister("2w3jh", function(module, exports) {

$parcel$export(module.exports, "arst_setScaffoldRowHeight", function () { return $d670322f02b94557$export$1990263dcc98afc6; });
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");

var $12bze = parcelRequire("12bze");
const $d670322f02b94557$export$1990263dcc98afc6 = (state, action)=>{
    if (!state.scaffoldModel) return state;
    const rowIndex = state.scaffoldModel.rows.findIndex((row)=>row.id === action.rowId);
    if (rowIndex === -1) return state;
    // Update scaffold model with new row height
    const scaffoldRow = state.scaffoldModel.rows[rowIndex];
    const newScaffoldModel = (0, $dsPLF.mutateByPath)(state.scaffoldModel, `/rows/${rowIndex}/height`, action.height);
    let newBodyData = state.bodyData;
    // Update all rowHeaders if a header row, otherwise find target cell and update height/rowspan as needed
    if (scaffoldRow.type === "header") {
        const newHeights = state.scaffoldModel.rows.filter((row)=>row.type === "header").map((row)=>row.id === action.rowId ? action.height : row.height);
        newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, `/rowHeaders`, state.bodyData.rowHeaders.map((rowHeader)=>({
                ...rowHeader,
                heights: newHeights
            })));
    } else {
        const targetRow = Object.values(state.scaffoldModel.cellData[action.rowId] ?? // istanbul ignore next
        {});
        const targetCell = targetRow.find((cell)=>!("rowSpan" in cell) || (cell.rowSpan ?? 1) === 1);
        /* istanbul ignore else */ if (targetCell) {
            const targetDataPath = (0, $12bze.arst_resolveTargetPath)(targetCell.dataPath);
            newBodyData = (0, $dsPLF.mutateByPath)(newBodyData, `${targetDataPath}/dimension`, action.height);
        }
    }
    return {
        ...state,
        bodyData: newBodyData,
        scaffoldModel: newScaffoldModel,
        changed: true
    };
};

});

parcelRegister("2dkgH", function(module, exports) {

$parcel$export(module.exports, "arst_setTlfViewMode", function () { return $d1cf12970ccf3b95$export$e58696dbc96dad07; });
const $d1cf12970ccf3b95$export$e58696dbc96dad07 = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            tlfViewMode: action.tlfViewMode
        }
    });

});

parcelRegister("iTvLk", function(module, exports) {

$parcel$export(module.exports, "arst_setViewItem", function () { return $a8d7c270b1c04bf5$export$3f068d8d146a97b3; });
const $a8d7c270b1c04bf5$export$3f068d8d146a97b3 = (state, action)=>{
    return {
        ...state,
        viewItem: action.viewItem
    };
};

});

parcelRegister("gXBDA", function(module, exports) {

$parcel$export(module.exports, "arst_toggleGroupLabelVisibility", function () { return $8926853317cdc311$export$9780ca33f4ba43ca; });
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");
var $34cNk = parcelRequire("34cNk");

var $i3Ps9 = parcelRequire("i3Ps9");

var $bi6dQ = parcelRequire("bi6dQ");

var $6RjQK = parcelRequire("6RjQK");

var $12bze = parcelRequire("12bze");
const $8926853317cdc311$export$9780ca33f4ba43ca = (state, action)=>{
    if (action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnGroupCell && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).ColumnGroupLabel && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupLabel) return state;
    const targetGroupingFactorPath = (0, $12bze.arst_resolveTargetPath)(action.cellValue.dataPath);
    const targetItem = (0, $eAPMz.getFromDataPath)(targetGroupingFactorPath, state.bodyData, (obj)=>(0, $bi6dQ.isArsTableSubGroup)(obj, state.settings.editorProps.isT));
    if (!targetItem) return state;
    let newBodyData = {
        ...state.bodyData
    };
    /* istanbul ignore else */ if (targetItem?.hidden) {
        // Remove if it is already there
        newBodyData = (0, $34cNk.removeByPath)(newBodyData, `${targetGroupingFactorPath}/hidden`);
        // Add rowHeader cell back in
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
            heights: [],
            label: state.settings.editorProps.blankT,
            width: 120
        });
    } else if (targetItem) {
        // Add if it is not there or false
        newBodyData = (0, $dsPLF.mutateByPath)(state.bodyData, `${targetGroupingFactorPath}/hidden`, true);
        newBodyData.rowHeaders = (0, $6RjQK.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    }
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("c8oBZ", function(module, exports) {

$parcel$export(module.exports, "arst_toggleInlineRowHeader", function () { return $d2adc6650bdc2300$export$49fdd18eac83b9f7; });
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");
var $34cNk = parcelRequire("34cNk");

var $i3Ps9 = parcelRequire("i3Ps9");

var $bi6dQ = parcelRequire("bi6dQ");

var $12bze = parcelRequire("12bze");
const $d2adc6650bdc2300$export$49fdd18eac83b9f7 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupLabel) return state;
    const targetGroupingFactorPath = (0, $12bze.arst_resolveTargetPath)(action.cellValue.dataPath);
    const targetItem = (0, $eAPMz.getFromDataPath)(targetGroupingFactorPath, state.bodyData, (obj)=>(0, $bi6dQ.isArsTableSubGroup)(obj, state.settings.editorProps.isT));
    if (!targetItem) return state;
    let newBodyData = {
        ...state.bodyData
    };
    /* istanbul ignore else */ if (targetItem?.inlineRowHeaders) {
        // Remove if it is already there
        newBodyData = (0, $34cNk.removeByPath)(newBodyData, `${targetGroupingFactorPath}/inlineRowHeaders`);
        // Add rowHeader cell back in
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
            heights: [],
            label: state.settings.editorProps.blankT,
            width: 120
        });
    } else if (targetItem) {
        // Add if it is not there or false
        newBodyData = (0, $dsPLF.mutateByPath)(state.bodyData, `${targetGroupingFactorPath}/inlineRowHeaders`, true);
        // Remove rowHeader cell, there should be less now
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex - (action.cellValue.cellType === (0, $i3Ps9.ArsTableCellType).RowGroupLabel ? 1 : 0), 1);
    }
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("cO1sB", function(module, exports) {

$parcel$export(module.exports, "arst_toggleInlineWithPreviousLevel", function () { return $6f57650c37d9d54d$export$60b999c71accaf34; });
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $dsPLF = parcelRequire("dsPLF");
var $34cNk = parcelRequire("34cNk");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $egJ4L = parcelRequire("egJ4L");

var $12bze = parcelRequire("12bze");
const $6f57650c37d9d54d$export$60b999c71accaf34 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $i3Ps9.ArsTableCellType).RowGroupLabel) return state;
    const targetGroupingFactorPath = (0, $12bze.arst_resolveTargetPath)(action.cellValue.dataPath);
    const targetItem = (0, $eAPMz.getFromDataPath)(targetGroupingFactorPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    if (!targetItem) return state;
    let newBodyData = {
        ...state.bodyData
    };
    /* istanbul ignore else */ if (targetItem?.inlineWithPreviousLevel) {
        // Remove if it is already there
        newBodyData = (0, $34cNk.removeByPath)(newBodyData, `${targetGroupingFactorPath}/inlineWithPreviousLevel`);
        // Add rowHeader cell back in
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
            heights: [],
            label: state.settings.editorProps.blankT,
            width: 120
        });
    } else if (targetItem) {
        // Add if it is not there or false
        newBodyData = (0, $dsPLF.mutateByPath)(state.bodyData, `${targetGroupingFactorPath}/inlineWithPreviousLevel`, true);
        // Remove rowHeader cell, there should be less now
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex - (action.cellValue.cellType === (0, $i3Ps9.ArsTableCellType).RowGroupLabel ? 1 : 0), 1);
    }
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("ermqj", function(module, exports) {

$parcel$export(module.exports, "arst_updateScaffold", function () { return $0e9045e291c22a6a$export$4c13525f5a2bcc23; });

var $1c7o5 = parcelRequire("1c7o5");
const $0e9045e291c22a6a$export$4c13525f5a2bcc23 = (state, action)=>({
        ...state,
        calculatedTableRows: action.calculatedTableRows,
        scaffoldModel: (0, $1c7o5.buildArsTableScaffoldModel)(action.calculatedTableRows, state.settings.editorProps)
    });

});
parcelRegister("1c7o5", function(module, exports) {

$parcel$export(module.exports, "buildArsTableScaffoldModel", function () { return $80211f3a3d26154e$export$e2602cebd0c576ca; });

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $8PhYZ = parcelRequire("8PhYZ");
var $65ClW = parcelRequire("65ClW");
const $80211f3a3d26154e$var$defaultColumnWidth = 120;
const $80211f3a3d26154e$var$defaultRowHeight = 40;
const $80211f3a3d26154e$export$e2602cebd0c576ca = (calculatedTableRows, editorProps)=>{
    // Send blank table is there is nothing to see here
    if (!calculatedTableRows || calculatedTableRows.length === 0) return {
        cellData: {
            blankRow: {
                blankCol: {
                    annotationContent: "Drop items here",
                    cellType: (0, $i3Ps9.ArsTableCellType).RowHeader,
                    columnId: "blankCol",
                    columnIndex: 0,
                    dataPath: "",
                    disabled: true,
                    displayContent: editorProps.textToT("Drop items here"),
                    justification: (0, $i3Ps9.ArsTextJustification).Center,
                    rowId: "blankRow",
                    targetType: "rowHeader"
                }
            }
        },
        columns: [
            {
                id: "blankCol",
                colNumber: 1,
                width: $80211f3a3d26154e$var$defaultColumnWidth + 80,
                noResize: true
            }
        ],
        rows: [
            {
                id: "blankRow",
                height: $80211f3a3d26154e$var$defaultRowHeight,
                rowGroupNumber: 0,
                rowNumber: 1,
                type: "header"
            }
        ],
        headerColSpans: {}
    };
    // Set up base objects to return
    const cellData = {};
    const columns = [];
    const rows = [];
    const headerColSpans = {};
    // Tranverse the calculated rows to populate the scaffold model. This will respect any header row spans and use the calculated layout as the source of truth for dimensions and cell placement.
    calculatedTableRows.forEach((calculatedRow, rowIndex)=>{
        const rowId = calculatedRow.arsTableCells[0].rowId;
        const rowNumber = rowIndex + 1;
        // Add new row on each pass
        const newRowScaffold = {
            id: rowId,
            rowGroupNumber: (0, $65ClW.isArsTableHeaderRow)(calculatedRow, editorProps.isT) ? -1 : calculatedRow.rowGroup,
            rowNumber: rowNumber,
            type: (0, $65ClW.isArsTableHeaderRow)(calculatedRow, editorProps.isT) ? "header" : "body",
            height: calculatedRow.height
        };
        rows.push(newRowScaffold);
        // Look at each cell
        calculatedRow.arsTableCells.forEach((cell)=>{
            const colSpan = "colSpan" in cell && cell.colSpan ? cell.colSpan : 1;
            const rowSpan = "rowSpan" in cell && cell.rowSpan ? cell.rowSpan : 1;
            const colId = cell.columnId;
            if (!columns[cell.columnIndex] && (0, $8PhYZ.isArsTableHeaderCell)(cell, editorProps.isT) && colSpan === 1) columns[cell.columnIndex] = {
                id: colId,
                colNumber: cell.columnIndex + 1,
                width: cell.width ?? $80211f3a3d26154e$var$defaultColumnWidth
            };
            // Add cells to cellData map on each pass
            if (!cellData[rowId]) cellData[rowId] = {};
            cellData[rowId][colId] = cell;
            // Add span info to headerColSpans
            if (colSpan > 1 || rowSpan > 1) {
                if (!headerColSpans[rowId]) headerColSpans[rowId] = {};
                headerColSpans[rowId][colId] = {
                    colSpan: colSpan,
                    rowSpan: rowSpan
                };
            }
        });
    });
    return {
        cellData: cellData,
        columns: columns,
        rows: rows,
        headerColSpans: headerColSpans
    };
};

});


parcelRegister("4bSb7", function(module, exports) {

$parcel$export(module.exports, "buildArsTableZoneColors", function () { return $ac1734f1bf3da901$export$401b74ce86f9914d; });
parcelRequire("6rtuc");
var $4zamZ = parcelRequire("4zamZ");

var $heZv5 = parcelRequire("heZv5");

var $i3Ps9 = parcelRequire("i3Ps9");
const $ac1734f1bf3da901$export$75f4aa1e3eaf7003 = "#4dabf7";
const $ac1734f1bf3da901$var$LEFT_EDGE_ZONES = new Set([
    (0, $4zamZ.ScaffoldDropZone).TopLeft,
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeBottom,
    (0, $4zamZ.ScaffoldDropZone).BottomLeft
]);
/**
 * Drop zones on the right edge of a cell (insert-after).
 */ const $ac1734f1bf3da901$var$RIGHT_EDGE_ZONES = new Set([
    (0, $4zamZ.ScaffoldDropZone).TopRight,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeBottom,
    (0, $4zamZ.ScaffoldDropZone).BottomRight
]);
const $ac1734f1bf3da901$export$401b74ce86f9914d = (state, dragKind, suppressAllZones = false)=>({ rowId: rowId, colId: colId, zone: zone })=>{
        const result = {
            color: null
        };
        if (suppressAllZones) return result;
        if (!state?.scaffoldModel) return result;
        const targetCell = state.scaffoldModel.cellData?.[rowId]?.[colId];
        if (!targetCell) return result;
        const config = (0, $heZv5.cellActionConfig)(targetCell, state);
        const matchedAction = config.dropActions.find((action)=>action.dropZones.has(zone) && (dragKind === null || action.droppedDataKinds.includes(dragKind)));
        if (!matchedAction) return result;
        const matchedZones = Array.from(matchedAction.dropZones);
        // For RowHeader cells, suppress RHS actions on non-last headers and
        // LHS actions on non-first headers to avoid misleading drop targets.
        if (targetCell.cellType === (0, $i3Ps9.ArsTableCellType).RowHeader && state.bodyData.rowHeaders.length > 1) {
            const rowHeaderIndex = parseInt(targetCell.dataPath.replace("/rowHeaders/", ""), 10);
            const rowHeaderCount = state.bodyData.rowHeaders.length;
            const isLastRowHeader = !isNaN(rowHeaderIndex) && rowHeaderIndex === rowHeaderCount - 1;
            const isFirstRowHeader = !isNaN(rowHeaderIndex) && rowHeaderIndex === 0;
            if (!isLastRowHeader && matchedZones.some((z)=>$ac1734f1bf3da901$var$RIGHT_EDGE_ZONES.has(z))) return result;
            if (!isFirstRowHeader && matchedZones.some((z)=>$ac1734f1bf3da901$var$LEFT_EDGE_ZONES.has(z))) return result;
        }
        return {
            color: $ac1734f1bf3da901$export$75f4aa1e3eaf7003,
            additionalHighlightedZones: matchedZones
        };
    };

});
parcelRegister("heZv5", function(module, exports) {

$parcel$export(module.exports, "cellActionConfig", function () { return $888752d418414f55$export$9d3272000e6dcb39; });
parcelRequire("6rtuc");
var $4zamZ = parcelRequire("4zamZ");

var $g3GSA = parcelRequire("g3GSA");

var $i3Ps9 = parcelRequire("i3Ps9");
const $888752d418414f55$export$4694e219efffa1d = new Set([
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeBottom
]);
const $888752d418414f55$export$99c6501f32dd4b22 = new Set([
    (0, $4zamZ.ScaffoldDropZone).RightEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeBottom
]);
const $888752d418414f55$export$2e88df9459aef37b = new Set([
    (0, $4zamZ.ScaffoldDropZone).TopLeft,
    (0, $4zamZ.ScaffoldDropZone).TopEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).TopEdgeRight,
    (0, $4zamZ.ScaffoldDropZone).TopRight
]);
const $888752d418414f55$export$953f010e02ba9e77 = new Set([
    (0, $4zamZ.ScaffoldDropZone).BottomLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeRight,
    (0, $4zamZ.ScaffoldDropZone).BottomRight
]);
const $888752d418414f55$export$75b722808fb4f534 = new Set([
    (0, $4zamZ.ScaffoldDropZone).TopLeft,
    (0, $4zamZ.ScaffoldDropZone).TopEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).TopEdgeRight
]);
const $888752d418414f55$export$a3a44b12c2858e12 = new Set([
    (0, $4zamZ.ScaffoldDropZone).BottomLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeRight
]);
const $888752d418414f55$export$31125a4b8fc0a7c3 = new Set([
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).CentreTopLeft,
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeBottom,
    (0, $4zamZ.ScaffoldDropZone).CentreBottomLeft
]);
const $888752d418414f55$export$2923c563557780b7 = new Set([
    (0, $4zamZ.ScaffoldDropZone).TopRight,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeBottom,
    (0, $4zamZ.ScaffoldDropZone).BottomRight
]);
const $888752d418414f55$export$5a25131cc91898d6 = new Set([
    (0, $4zamZ.ScaffoldDropZone).TopRight,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeBottom,
    (0, $4zamZ.ScaffoldDropZone).BottomRight
]);
const $888752d418414f55$export$a639a1623e19ea0b = new Set([
    (0, $4zamZ.ScaffoldDropZone).BottomLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeRight
]);
const $888752d418414f55$export$53152418615043d6 = {
    label: "Remove group",
    operation: (0, $i3Ps9.ARST_REMOVE_GROUPINGFACTOR)
};
const $888752d418414f55$export$3327bf6f84120a1e = {
    label: "Remove operation",
    operation: (0, $i3Ps9.ARST_REMOVE_OPERATION)
};
const $888752d418414f55$export$321f564fb61ba3ef = {
    label: "Toggle visible group label",
    operation: (0, $i3Ps9.ARST_TOGGLE_GROUP_LABEL_VISIBILITY)
};
const $888752d418414f55$export$31e23ca08a82c9c5 = {
    label: "Toggle inline group label",
    operation: (0, $i3Ps9.ARST_TOGGLE_GROUP_LABEL_INLINE)
};
const $888752d418414f55$export$549b00ca91309c2e = {
    label: "Toggle inline with previous level",
    operation: (0, $i3Ps9.ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL)
};
const $888752d418414f55$var$columnDropActions = [
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $888752d418414f55$export$4694e219efffa1d,
        operation: (0, $i3Ps9.ARST_INSERT_COLUMN_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $888752d418414f55$export$99c6501f32dd4b22,
        operation: (0, $i3Ps9.ARST_INSERT_COLUMN_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $888752d418414f55$export$953f010e02ba9e77,
        operation: (0, $i3Ps9.ARST_INSERT_SUBGROUP)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).Operation,
            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $888752d418414f55$export$4694e219efffa1d,
        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).Operation,
            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $888752d418414f55$export$99c6501f32dd4b22,
        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).Operation,
            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $888752d418414f55$export$953f010e02ba9e77,
        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_SUBGROUP)
    }
];
const $888752d418414f55$var$rowDropActions = [
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $888752d418414f55$export$75b722808fb4f534,
        operation: (0, $i3Ps9.ARST_INSERT_ROW_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $888752d418414f55$export$a3a44b12c2858e12,
        operation: (0, $i3Ps9.ARST_INSERT_ROW_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $888752d418414f55$export$2923c563557780b7,
        operation: (0, $i3Ps9.ARST_INSERT_SUBGROUP)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).Operation,
            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $888752d418414f55$export$75b722808fb4f534,
        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_ROW_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).Operation,
            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $888752d418414f55$export$a3a44b12c2858e12,
        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_ROW_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $g3GSA.ArsSidebarItemKind).Operation,
            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $888752d418414f55$export$2923c563557780b7,
        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_SUBGROUP)
    }
];
const $888752d418414f55$export$9d3272000e6dcb39 = (value, state)=>{
    if (!state) return {
        contextMenuActions: [],
        dropActions: []
    };
    switch(value.cellType){
        case (0, $i3Ps9.ArsTableCellType).ColumnGroupCell:
        case (0, $i3Ps9.ArsTableCellType).ColumnGroupLabel:
            return {
                contextMenuActions: [
                    $888752d418414f55$export$321f564fb61ba3ef,
                    $888752d418414f55$export$53152418615043d6
                ],
                dropActions: $888752d418414f55$var$columnDropActions
            };
        case (0, $i3Ps9.ArsTableCellType).RowGroupCell:
        case (0, $i3Ps9.ArsTableCellType).RowGroupLabel:
            {
                const ret = {
                    contextMenuActions: [
                        $888752d418414f55$export$321f564fb61ba3ef,
                        $888752d418414f55$export$53152418615043d6,
                        $888752d418414f55$export$31e23ca08a82c9c5
                    ],
                    dropActions: $888752d418414f55$var$rowDropActions
                };
                if (value.dataPath.split("/").length > 3) ret.contextMenuActions.push($888752d418414f55$export$549b00ca91309c2e);
                return ret;
            }
        case (0, $i3Ps9.ArsTableCellType).ColumnOperation:
            return {
                contextMenuActions: [
                    $888752d418414f55$export$3327bf6f84120a1e
                ],
                dropActions: $888752d418414f55$var$columnDropActions
            };
        case (0, $i3Ps9.ArsTableCellType).RowOperation:
            return {
                contextMenuActions: [
                    $888752d418414f55$export$3327bf6f84120a1e
                ],
                dropActions: $888752d418414f55$var$rowDropActions
            };
        case (0, $i3Ps9.ArsTableCellType).RowHeader:
            return {
                contextMenuActions: [],
                dropActions: [
                    {
                        droppedDataKinds: [
                            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
                        ],
                        dropZones: $888752d418414f55$export$5a25131cc91898d6,
                        operation: (0, $i3Ps9.ARST_INSERT_COLUMN_AFTER)
                    },
                    {
                        droppedDataKinds: [
                            (0, $g3GSA.ArsSidebarItemKind).GroupingFactor
                        ],
                        dropZones: $888752d418414f55$export$a639a1623e19ea0b,
                        operation: (0, $i3Ps9.ARST_INSERT_ROW_AFTER)
                    },
                    {
                        droppedDataKinds: [
                            (0, $g3GSA.ArsSidebarItemKind).Operation,
                            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
                        ],
                        dropZones: $888752d418414f55$export$5a25131cc91898d6,
                        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_COLUMN_AFTER)
                    },
                    {
                        droppedDataKinds: [
                            (0, $g3GSA.ArsSidebarItemKind).Operation,
                            (0, $g3GSA.ArsSidebarItemKind).AnalysisMethod
                        ],
                        dropZones: $888752d418414f55$export$a639a1623e19ea0b,
                        operation: (0, $i3Ps9.ARST_INSERT_OPERATION_ROW_AFTER)
                    }
                ]
            };
        default:
            return {
                contextMenuActions: [],
                dropActions: []
            };
    }
};

});


parcelRegister("6tpHV", function(module, exports) {
parcelRequire("2YSoS");
var $ev45l = parcelRequire("ev45l");
var $bi6dQ = parcelRequire("bi6dQ");
const $225c953f426eb58a$export$6fe6f31bd6746336 = (tableGroups, id, isT)=>{
    const ret = [];
    for (const group of tableGroups){
        if ((0, $bi6dQ.isArsTableSubGroupGroupingFactor)(group, isT) && group.groupingFactor?.id === id) ret.push(group);
        else if ((0, $ev45l.isArsTableOperation)(group, isT) && group.operation?.id === id) ret.push(group);
        if (group.subGroups && group.subGroups.length > 0) ret.push(...$225c953f426eb58a$export$6fe6f31bd6746336(group.subGroups, id, isT));
    }
    return ret;
};

});

parcelRegister("7uH5j", function(module, exports) {

$parcel$export(module.exports, "groupToTreeNode", function () { return $7251a7cfbd51e868$export$c18dc29351454736; });
const $7251a7cfbd51e868$export$c18dc29351454736 = (group, isT)=>{
    // SubGroup node
    const children = (group.subGroups ?? []).map((g)=>$7251a7cfbd51e868$export$c18dc29351454736(g, isT));
    if ("groupingFactor" in group) {
        const sggf = group;
        return {
            id: sggf.id,
            label: sggf.label,
            type: "groupingFactor",
            subNodes: children.length > 0 ? children : undefined
        };
    } else if ("group" in group) {
        const sgg = group;
        return {
            id: sgg.id,
            label: sgg.label,
            type: "group",
            subNodes: children.length > 0 ? children : undefined
        };
    } else if ("operation" in group) {
        const op = group;
        return {
            id: op.id,
            label: op.label,
            type: "operation",
            subNodes: children.length > 0 ? children : undefined
        };
    } else {
        const sgam = group;
        return {
            id: sgam.id,
            label: sgam.label,
            type: "analysisMethod",
            subNodes: children.length > 0 ? children : undefined
        };
    }
};

});





parcelRegister("kteXq", function(module, exports) {

$parcel$export(module.exports, "NamedObjectControl", function () { return $5969aefd2dcef3c8$export$d09896024493583c; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("2nuru");
var $kct4w = parcelRequire("kct4w");
var $9AhVX = parcelRequire("9AhVX");

var $3EZep = parcelRequire("3EZep");
const $5969aefd2dcef3c8$export$d09896024493583c = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false, invalidNames: invalidNames = [] })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/name`,
                debounceMilliseconds: -1,
                disabled: !canRename || disabled,
                id: `${dataPath.replace(/\//g, "-")}-name`,
                label: "Name",
                labelWidth: 2,
                noInvalidReturn: true,
                placeholder: "Enter name",
                sanitiseValue: (0, $9AhVX.stripDisallowedNameCharacters),
                validCondition: (0, $kct4w.checkName),
                validationTargetOptions: {
                    existingValues: invalidNames
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/label`,
                disabled: disabled,
                id: `${dataPath.replace(/\//g, "-")}-label`,
                isMultiline: true,
                label: "Label",
                labelWidth: 2,
                placeholder: "Enter label"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                allowCarriageReturn: true,
                dataPath: `${dataPath}/description`,
                disabled: disabled,
                id: `${dataPath.replace(/\//g, "-")}-description`,
                label: "Description",
                labelWidth: 2,
                placeholder: "Enter description",
                rows: 3,
                type: "textarea"
            })
        ]
    });
};
$5969aefd2dcef3c8$export$d09896024493583c.displayName = "NamedObjectControl";

});

parcelRegister("dPdcj", function(module, exports) {

$parcel$export(module.exports, "ReferencedOperationRelationshipControl", function () { return $35c8abe1b62dd2f8$export$849f0aa9bced019; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $ci0ss = parcelRequire("ci0ss");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $h7VrC = parcelRequire("h7VrC");

var $3EZep = parcelRequire("3EZep");
parcelRequire("6yroJ");
var $ek4hO = parcelRequire("ek4hO");
var $hoYmS = parcelRequire("hoYmS");

var $rRNEc = parcelRequire("rRNEc");
const $35c8abe1b62dd2f8$export$849f0aa9bced019 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    const roleOptions = Object.values((0, $1cA0K.OperationRoleEnum)).map((role)=>({
            value: role,
            label: role
        }));
    const idRoute = dataPath.replace(/\//g, "-");
    const thisAnalysisMethod = (0, $eAPMz.getFromDataPath)((0, $ci0ss.reduceDataPath)(dataPath, 4), state, (0, $ek4hO.isAnalysisMethod));
    const thisOperation = (0, $eAPMz.getFromDataPath)((0, $ci0ss.reduceDataPath)(dataPath, 2), state, (0, $hoYmS.isOperation));
    if (!thisAnalysisMethod || !thisOperation) return null;
    const otherOperationNames = thisAnalysisMethod.operations.map((op)=>({
            value: op.id,
            label: op.name
        })).filter((op)=>op.label !== thisOperation.name);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                dataPath: `${dataPath}/referencedOperationRole/controlledTerm`,
                id: `${idRoute}-role`,
                label: "Role",
                labelWidth: 2,
                options: roleOptions,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                dataPath: `${dataPath}/operationId`,
                id: `${idRoute}-operation-id`,
                label: "Operation name",
                labelWidth: 2,
                options: otherOperationNames,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/description`,
                id: `${idRoute}-description`,
                label: "Description",
                labelWidth: 2,
                placeholder: "Enter description",
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            })
        ]
    });
};
$35c8abe1b62dd2f8$export$849f0aa9bced019.displayName = "ReferencedOperationRelationshipControl";

});
parcelRegister("rRNEc", function(module, exports) {

$parcel$export(module.exports, "RemoveArsItemButton", function () { return $4e7ff7854261cc97$export$16cd719b01abfc97; });

var $bbzbN = parcelRequire("bbzbN");

var $jVHe9 = parcelRequire("jVHe9");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
const $4e7ff7854261cc97$export$16cd719b01abfc97 = ({ dataPath: dataPath, disabled: disabled = false, onChange: onChange, siblingCount: siblingCount, ...iconProps })=>{
    const { dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    /**
   * Handles removing the item.
   */ const handleRemove = ()=>{
        /* istanbul ignore else -- Disabled buttons do not invoke the click handler */ if (!disabled) {
            if (onChange) onChange();
            else dispatch({
                operation: (0, $cIJV5.REMOVE_ARS_ITEM),
                dataPath: dataPath,
                newLength: siblingCount !== undefined ? siblingCount - 1 : undefined
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jVHe9.default), {
        ...iconProps,
        id: `${dataPath.replace(/\//g, "-")}-remove-button`,
        className: "text-danger",
        role: "button",
        "aria-label": "Remove item",
        title: "Remove item",
        "aria-disabled": disabled,
        onClick: disabled ? undefined : handleRemove,
        style: {
            cursor: disabled ? "not-allowed" : "pointer",
            ...iconProps.style
        }
    });
};
$4e7ff7854261cc97$export$16cd719b01abfc97.displayName = "RemoveArsItemButton";

});
parcelRegister("jVHe9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e824df38736578a3$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $e824df38736578a3$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $e824df38736578a3$var$_extends() {
    return $e824df38736578a3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e824df38736578a3$var$_extends.apply(null, arguments);
}
function $e824df38736578a3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e824df38736578a3$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e824df38736578a3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e824df38736578a3$var$DashCircle = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $e824df38736578a3$var$_objectWithoutProperties(_ref, $e824df38736578a3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $e824df38736578a3$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-dash-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"
    }));
});
$e824df38736578a3$var$DashCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $e824df38736578a3$export$2e2bcd8739ae039 = $e824df38736578a3$var$DashCircle;

});





parcelRegister("s05f4", function(module, exports) {

$parcel$export(module.exports, "AnalysisMethodParametersControl", function () { return $d679d6add01af1f6$export$92a4aae0289a9db; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4tJ7o = parcelRequire("4tJ7o");
var $gLW8Q = parcelRequire("gLW8Q");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
var $6LYdD = parcelRequire("6LYdD");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $ICeOG = parcelRequire("ICeOG");

var $9apvI = parcelRequire("9apvI");
const $d679d6add01af1f6$export$92a4aae0289a9db = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const codeTemplate = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $ICeOG.isAnalysisProgrammingCodeTemplate));
    const parameters = codeTemplate?.parameters ?? [];
    const reorderableParameters = parameters.map((parameter, index)=>({
            ...parameter,
            id: `${index}`
        }));
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)(parameters.length > 0 ? "parameter-0" : "");
    /**
   * Handles adding a template code parameter.
   */ const handleAddParameter = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && codeTemplate) {
            const parameterCount = parameters.length;
            const newParameter = {
                name: `Parameter_${parameterCount + 1}`,
                label: `Parameter ${parameterCount + 1}`,
                description: "",
                valueSource: "operation",
                value: [],
                parameterType: "string"
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/parameters/${parameterCount}`,
                value: newParameter
            });
        }
    };
    /**
   * Handles reordering the template code parameters.
   *
   * @param newParameters - The parameters in their new order.
   */ const handleReorderParameters = (newParameters)=>{
        /* istanbul ignore else -- reordering is disabled unless a code template is present */ if (!disabled && codeTemplate) dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: `${dataPath}/parameters`,
            value: newParameters.map((parameter)=>parameters[Number(parameter.id)])
        });
    };
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $7fPBF.useEffectEvent)((newTab)=>(0, $7fPBF.startTransition)(()=>setActiveTab(newTab)));
    /** Move tabs */ (0, $7fPBF.useEffect)(()=>{
        if (parseInt(activeTab.split("-")[1], 10) >= parameters.length) updateActiveTab(parameters.length > 0 ? "parameter-0" : "");
        else if (activeTab === "" && parameters.length > 0) updateActiveTab("parameter-0");
    }, [
        parameters.length,
        activeTab
    ]);
    const idRoute = dataPath.replace(/\//g, "-") + "-parameters";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Container, {
        activeKey: activeTab,
        onSelect: (k)=>{
            /* istanbul ignore else */ if (k) setActiveTab(k);
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default), {
                variant: "tabs",
                className: "mb-3",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6LYdD.ReorderableNavList), {
                    list: reorderableParameters,
                    setList: handleReorderParameters,
                    getEventKey: (_parameter, index)=>`parameter-${index}`,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Content, {
                children: parameters.map((parameter, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                        eventKey: `parameter-${index}`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9apvI.TemplateCodeParameterControl), {
                            dataPath: `${dataPath}/parameters/${index}`,
                            disabled: disabled,
                            siblingCount: parameters.length
                        }, `${parameter.name}-${index}`)
                    }, index))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-parameter`,
                onClick: handleAddParameter,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add parameter"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$d679d6add01af1f6$export$92a4aae0289a9db.displayName = "AnalysisMethodParametersControl";

});
parcelRegister("9apvI", function(module, exports) {

$parcel$export(module.exports, "TemplateCodeParameterControl", function () { return $de4643893873d1ac$export$bdb8b8609127e8cd; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
var $ci0ss = parcelRequire("ci0ss");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $h7VrC = parcelRequire("h7VrC");

var $3EZep = parcelRequire("3EZep");
parcelRequire("6yroJ");
var $ek4hO = parcelRequire("ek4hO");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");
const $de4643893873d1ac$export$bdb8b8609127e8cd = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    const idRoute = dataPath.replace(/\//g, "-");
    const parameterType = (0, $eAPMz.getFromDataPath)(`${dataPath}/parameterType`, state, (0, $eAPMz.isString)) ?? // istanbul ignore next
    "string";
    const holdingAnalysisMethod = (0, $eAPMz.getFromDataPath)((0, $ci0ss.reduceDataPath)(dataPath, 3), state, (0, $ek4hO.isAnalysisMethod));
    /** Get other existing parameter names */ const otherParameterNames = holdingAnalysisMethod?.codeTemplate?.parameters?.map((p)=>p.name) ?? // istanbul ignore next
    [];
    const thisIx = dataPath.split("/").pop();
    otherParameterNames.splice(Number(thisIx), 1); // Remove this parameter's name from the list
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                dataPath: dataPath,
                canRename: true,
                disabled: disabled,
                invalidNames: otherParameterNames
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                dataPath: `${dataPath}/valueSource`,
                id: `${idRoute}-value-source`,
                label: "Value source",
                labelWidth: 2,
                options: [
                    {
                        value: "operation",
                        label: "Operation"
                    },
                    {
                        value: "groupingFactor",
                        label: "Grouping Factor"
                    }
                ],
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/value`,
                id: `${idRoute}-value`,
                label: "Default value(s)",
                labelWidth: 2,
                placeholder: "Enter one value per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                dataPath: `${dataPath}/parameterType`,
                id: `${idRoute}-parameter-type`,
                label: "Parameter type",
                labelWidth: 2,
                disabled: disabled,
                options: [
                    {
                        value: "boolean",
                        label: "Boolean"
                    },
                    {
                        value: "multiSelect",
                        label: "Multiselect"
                    },
                    {
                        value: "number",
                        label: "Number"
                    },
                    {
                        value: "numberList",
                        label: "Number List"
                    },
                    {
                        value: "select",
                        label: "Select"
                    },
                    {
                        value: "string",
                        label: "String"
                    },
                    {
                        value: "stringList",
                        label: "String List"
                    },
                    {
                        value: "dataset.variable",
                        label: "Variable"
                    }
                ]
            }),
            [
                "multiSelect",
                "select"
            ].includes(parameterType) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/availableValues`,
                id: `${idRoute}-available-values`,
                label: "Available values",
                labelWidth: 2,
                placeholder: "Enter one value per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 5,
                disabled: disabled
            })
        ]
    });
};
$de4643893873d1ac$export$bdb8b8609127e8cd.displayName = "TemplateCodeParameterControl";

});


parcelRegister("f55zq", function(module, exports) {

$parcel$export(module.exports, "AnalysisProgrammingCodeTemplateControl", function () { return $4d73f9a3e3a3e0b5$export$e24891d9b51594b8; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");

var $3EZep = parcelRequire("3EZep");

var $ICeOG = parcelRequire("ICeOG");

var $5zEFB = parcelRequire("5zEFB");
const $4d73f9a3e3a3e0b5$export$e24891d9b51594b8 = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const codeTemplate = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $ICeOG.isAnalysisProgrammingCodeTemplate));
    /**
   * Handles adding a document reference for the code template.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && codeTemplate && codeTemplate.documentRef === undefined) {
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRef`,
                value: newDocumentReference
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/context`,
                id: `${idRoute}-context`,
                label: "Context",
                labelWidth: 2,
                placeholder: "Enter context",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/code`,
                id: `${idRoute}-code`,
                label: "Code",
                labelWidth: 2,
                placeholder: "Enter code",
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 6,
                disabled: disabled
            }),
            codeTemplate?.documentRef && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5zEFB.DocumentReferenceControl), {
                dataPath: `${dataPath}/documentRef`,
                disabled: disabled,
                siblingCount: 1
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-document-reference`,
                onClick: handleAddDocumentReference,
                className: "d-flex align-items-center btn-sm btn-success mb-3",
                disabled: disabled || codeTemplate?.documentRef !== undefined,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add document reference"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$4d73f9a3e3a3e0b5$export$e24891d9b51594b8.displayName = "AnalysisProgrammingCodeTemplateControl";

});
parcelRegister("5zEFB", function(module, exports) {

$parcel$export(module.exports, "DocumentReferenceControl", function () { return $5e244f96e79c3021$export$cd9be9681dddf8ba; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");

var $3EZep = parcelRequire("3EZep");

var $iwmqf = parcelRequire("iwmqf");

var $jA618 = parcelRequire("jA618");

var $rRNEc = parcelRequire("rRNEc");
const $5e244f96e79c3021$export$cd9be9681dddf8ba = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const documentReference = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $iwmqf.isDocumentReference));
    const pageRefs = documentReference?.pageRefs ?? [];
    const idRoute = dataPath.replace(/\//g, "-");
    /**
   * Handles adding a new page reference to the current document reference.
   */ const handleAddPageRef = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && documentReference) {
            const pageRefCount = pageRefs.length;
            const newPageRef = {
                refType: (0, $1cA0K.PageRefTypeEnum).PhysicalRef,
                label: "",
                pageNames: [],
                pageNumbers: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/pageRefs/${pageRefCount}`,
                value: newPageRef
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/referenceDocumentId`,
                id: `${idRoute}-reference-document-id`,
                label: "Reference document id",
                labelWidth: 2,
                placeholder: "Enter reference document id",
                disabled: disabled
            }),
            pageRefs.map((pageRef, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $jA618.PageRefControl), {
                    dataPath: `${dataPath}/pageRefs/${index}`,
                    disabled: disabled,
                    siblingCount: pageRefs.length
                }, `${pageRef.refType}-${index}`)),
            !disabled && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-page-reference`,
                onClick: handleAddPageRef,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add page reference"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$5e244f96e79c3021$export$cd9be9681dddf8ba.displayName = "DocumentReferenceControl";

});
parcelRegister("jA618", function(module, exports) {

$parcel$export(module.exports, "PageRefControl", function () { return $cd3578ae4a7fb3fe$export$3b60448f76d704d1; });

var $bbzbN = parcelRequire("bbzbN");

var $1cA0K = parcelRequire("1cA0K");

var $h7VrC = parcelRequire("h7VrC");

var $3EZep = parcelRequire("3EZep");

var $rRNEc = parcelRequire("rRNEc");
const $cd3578ae4a7fb3fe$export$3b60448f76d704d1 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const pageRefTypeOptions = Object.values((0, $1cA0K.PageRefTypeEnum)).map((value)=>({
            value: value,
            label: value
        }));
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                dataPath: `${dataPath}/refType`,
                id: `${idRoute}-ref-type`,
                label: "Reference type",
                labelWidth: 2,
                options: pageRefTypeOptions,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/label`,
                id: `${idRoute}-label`,
                label: "Label",
                labelWidth: 2,
                placeholder: "Enter page reference label",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/pageNames`,
                id: `${idRoute}-page-names`,
                label: "Page names",
                labelWidth: 2,
                placeholder: "Enter one page name per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/pageNumbers`,
                id: `${idRoute}-page-numbers`,
                label: "Page numbers",
                labelWidth: 2,
                placeholder: "Enter one page number per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/firstPage`,
                id: `${idRoute}-first-page`,
                label: "First page",
                labelWidth: 2,
                placeholder: "Enter first page",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/lastPage`,
                id: `${idRoute}-last-page`,
                label: "Last page",
                labelWidth: 2,
                placeholder: "Enter last page",
                disabled: disabled
            })
        ]
    });
};
$cd3578ae4a7fb3fe$export$3b60448f76d704d1.displayName = "PageRefControl";

});





parcelRegister("c1YHT", function(module, exports) {

$parcel$export(module.exports, "VariableSidebarItem", function () { return $8eec3b43f1bdf3b7$export$1a2f8a0c656327a6; });

var $bbzbN = parcelRequire("bbzbN");
const $8eec3b43f1bdf3b7$export$1a2f8a0c656327a6 = ({ item: item, selected: selected })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`,
        style: {
            cursor: "grab"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "fw-semibold",
                children: item.label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                className: "text-muted",
                children: [
                    item.data.dropItem.name,
                    " ",
                    item.data.dropItem.dataType
                ]
            })
        ]
    });
$8eec3b43f1bdf3b7$export$1a2f8a0c656327a6.displayName = "VariableSidebarItem";

});


parcelRegister("3Ggtq", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarViewRadio", function () { return $33ad9d8cb308d080$export$eac86e21b49fd3fc; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
const $33ad9d8cb308d080$export$eac86e21b49fd3fc = ({ showGroupingFactors: showGroupingFactors = true, showOperations: showOperations = false, showVariables: showVariables = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const currentView = state.currentSidebar.view;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "d-flex gap-3",
        children: [
            showGroupingFactors && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                type: "radio",
                id: "ars-table-sidebar-view-grouping-factors",
                label: "Grouping factors",
                name: "ars-table-sidebar-view",
                value: "groupingFactor",
                checked: currentView === "groupingFactor",
                onChange: ()=>{
                    dispatch({
                        operation: (0, $cIJV5.SET_SIDEBAR_VIEW),
                        view: "groupingFactor"
                    });
                }
            }),
            showOperations && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                type: "radio",
                id: "ars-table-sidebar-view-operations",
                label: "Operations",
                name: "ars-table-sidebar-view",
                value: "operation",
                checked: currentView === "operation",
                onChange: ()=>{
                    dispatch({
                        operation: (0, $cIJV5.SET_SIDEBAR_VIEW),
                        view: "operation"
                    });
                }
            }),
            showVariables && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                type: "radio",
                id: "ars-table-sidebar-view-variables",
                label: "Variables",
                name: "ars-table-sidebar-view",
                value: "variable",
                checked: currentView === "variable",
                onChange: ()=>{
                    dispatch({
                        operation: (0, $cIJV5.SET_SIDEBAR_VIEW),
                        view: "variable"
                    });
                }
            })
        ]
    });
};
$33ad9d8cb308d080$export$eac86e21b49fd3fc.displayName = "ArsSidebarViewRadio";

});

parcelRegister("jh2aH", function(module, exports) {

$parcel$export(module.exports, "NewItemButton", function () { return $4cbf9e7e12e520b2$export$f9da8ac0bf4c10b; });

var $bbzbN = parcelRequire("bbzbN");

var $b6fw7 = parcelRequire("b6fw7");
parcelRequire("k7fIt");
var $3CgTd = parcelRequire("3CgTd");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
const $4cbf9e7e12e520b2$export$f9da8ac0bf4c10b = ()=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    if (![
        "operation",
        "groupingFactor"
    ].includes(state.currentSidebar.view)) return null;
    /* Do not show add button when an analysisMethod is selected */ if (state.currentSidebar.view === "operation" && state.currentSidebar.analysisMethodId) return null;
    /**
   * Add new item to the current sidebar view
   */ const addItem = ()=>{
        if (state.currentSidebar.view === "groupingFactor") {
            const newFactor = (0, $3CgTd.createNewGroupingFactor)("New grouping factor");
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: "/groupingFactors/" + newFactor.id,
                value: newFactor
            });
        } else {
            const newMethod = (0, $3CgTd.createNewAnalysisMethod)("New analysis method");
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: "/analysisMethods/" + newMethod.id,
                value: newMethod
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b6fw7.default), {
        id: "ars-sidebar-new-item-button",
        variant: "primary",
        className: "w-100 mt-2",
        onClick: addItem,
        children: [
            "Add new",
            state.currentSidebar.view === "groupingFactor" ? " grouping factor" : " analysis method"
        ]
    });
};
$4cbf9e7e12e520b2$export$f9da8ac0bf4c10b.displayName = "NewItemButton";

});


parcelRegister("7gMgY", function(module, exports) {
$parcel$export(module.exports, "isArsSidebarItemData", function () { return (parcelRequire("clOgJ")).isArsSidebarItemData; });
parcelRequire("clOgJ");

});


parcelRegister("4dESf", function(module, exports) {

$parcel$export(module.exports, "ArsTableCellEditorProps", function () { return $3fc58ca55f9cc096$export$fadae6fc2a19ab98; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");
var $1P8vv = parcelRequire("1P8vv");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $2Ce6S = parcelRequire("2Ce6S");

var $6Llki = parcelRequire("6Llki");
parcelRequire("kDPjn");
var $12bze = parcelRequire("12bze");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $ev45l = parcelRequire("ev45l");
var $bi6dQ = parcelRequire("bi6dQ");
// FE-only display metadata that must not affect content-equality checks below
const $3fc58ca55f9cc096$var$DISPLAY_ONLY_KEYS = [
    "disableEditing",
    "fromHierarchyId"
];
const $3fc58ca55f9cc096$export$438b09b12f54002e = ({ id: id, colId: colId, rowId: rowId, value: value })=>{
    const ars = (0, $fZCs4.useArsContext)();
    const { state: state, dispatch: dispatch } = (0, $6Llki.useArsTable)();
    /**
   * Check table group against state and update if groupingFactor has changed
   * @param targetDataPath DataPath for table group to check
   */ const checkGroupingFactorChanges = (0, $7fPBF.useEffectEvent)((targetDataPath)=>{
        // istanbul ignore next
        if (!state) return;
        const thisTableGroup = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $bi6dQ.isArsTableSubGroupGroupingFactor)(obj, state.settings.editorProps.isT));
        /* istanbul ignore else */ if (thisTableGroup) {
            const stateGroupingFactor = ars.state.groupingFactors[thisTableGroup.groupingFactor.id];
            if (stateGroupingFactor && !(0, $gSkQi.isEqual)((0, $gSkQi.omit)(thisTableGroup.groupingFactor, $3fc58ca55f9cc096$var$DISPLAY_ONLY_KEYS), (0, $gSkQi.omit)(stateGroupingFactor, $3fc58ca55f9cc096$var$DISPLAY_ONLY_KEYS))) dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                dataPath: `${targetDataPath}/groupingFactor`,
                value: stateGroupingFactor
            });
        }
    });
    /**
   * Check table group against state and update if analysisMethod has changed
   * @param targetDataPath DataPath for table group to check
   */ const checkAnalysisMethodChanges = (0, $7fPBF.useEffectEvent)((targetDataPath)=>{
        // istanbul ignore next
        if (!state) return;
        const thisTableGroup = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $bi6dQ.isArsTableSubGroupAnalysisMethod)(obj, state.settings.editorProps.isT));
        /* istanbul ignore else */ if (thisTableGroup) {
            const stateAnalysisMethod = ars.state.analysisMethods[thisTableGroup.analysisMethodId];
            if (stateAnalysisMethod && !(0, $gSkQi.isEqual)((0, $gSkQi.omit)(thisTableGroup.analysisMethod, $3fc58ca55f9cc096$var$DISPLAY_ONLY_KEYS), (0, $gSkQi.omit)(stateAnalysisMethod, $3fc58ca55f9cc096$var$DISPLAY_ONLY_KEYS))) dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                dataPath: `${targetDataPath}/analysisMethod`,
                value: stateAnalysisMethod
            });
        }
    });
    /**
   * Check table against state and update if operation has changed
   * @param targetDataPath DataPath for table operation to check
   */ const checkOperationChanges = (0, $7fPBF.useEffectEvent)((targetDataPath)=>{
        // istanbul ignore next
        if (!state) return;
        const thisTableOperation = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $ev45l.isArsTableOperation)(obj, state.settings.editorProps.isT));
        /* istanbul ignore else */ if (thisTableOperation) {
            const stateOperation = Object.values(ars.state.analysisMethods).flatMap((am)=>am.operations).find((op)=>op.id === thisTableOperation.operation.id);
            if (stateOperation && !(0, $gSkQi.isEqual)(thisTableOperation.operation, stateOperation)) dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                dataPath: `${targetDataPath}/operation`,
                value: stateOperation
            });
        }
    });
    /* Monitor for groupingFactor changes, on grouping factor cells */ (0, $7fPBF.useEffect)(()=>{
        if (state?.bodyData && state?.settings && value.targetType === "groupingFactor") checkGroupingFactorChanges(value.dataPath);
    }, [
        ars.state.groupingFactors,
        dispatch,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    /* Monitor for groupingFactor changes on group/dataValues cells */ (0, $7fPBF.useEffect)(()=>{
        if (value.dataPath.endsWith("/0") && state?.bodyData && state?.settings && (value.targetType === "group" || value.targetType === "dataDriven")) {
            const targetDataPath = (0, $12bze.arst_resolveTargetPath)(value.dataPath);
            checkGroupingFactorChanges(targetDataPath);
        }
    }, [
        ars.state.groupingFactors,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    /* Monitor for analysisMethod changes, on analysis method cells */ (0, $7fPBF.useEffect)(()=>{
        if (state?.bodyData && state?.settings && value.targetType === "analysisMethod") checkAnalysisMethodChanges(value.dataPath);
    }, [
        ars.state.analysisMethods,
        dispatch,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    /* Monitor for operation changes, on operation cells */ (0, $7fPBF.useEffect)(()=>{
        if (state?.bodyData && state?.settings && value.targetType === "operation") checkOperationChanges(value.dataPath);
    }, [
        ars.state.analysisMethods,
        dispatch,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    if (!state || !rowId || !colId) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    const editorProps = state.settings.editorProps;
    const Editor = editorProps.Editor;
    const isAnnotationsView = state.settings.tlfViewMode.value === "ANNOTATIONS";
    const displayContent = value.displayContent;
    const annotationContent = value.annotationContent;
    const editable = !isAnnotationsView && !state.settings.disabled && !value.disabled && value.targetType !== "dataDriven" && value.targetType !== "group" && value.cellType !== (0, $i3Ps9.ArsTableCellType).DataCell;
    let justification = value.justification ?? // istanbul ignore next
    (0, $i3Ps9.ArsTextJustification).Default;
    if (justification === (0, $i3Ps9.ArsTextJustification).Default) {
        if ([
            (0, $i3Ps9.ArsTableCellType).RowHeader,
            (0, $i3Ps9.ArsTableCellType).RowGroupCell,
            (0, $i3Ps9.ArsTableCellType).RowGroupLabel,
            (0, $i3Ps9.ArsTableCellType).RowOperation
        ].includes(value.cellType)) justification = (0, $i3Ps9.ArsTextJustification).Left;
        else justification = (0, $i3Ps9.ArsTextJustification).Center;
    }
    const rowIndex = Object.keys(state.scaffoldModel?.cellData ?? {}).indexOf(rowId);
    const row = state.scaffoldModel?.cellData?.[rowId];
    const colIndex = Object.keys(row ?? {}).indexOf(colId);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($2Ce6S))).arsTableCell,
            (0, (/*@__PURE__*/$parcel$interopDefault($2Ce6S)))[value.cellType],
            editable ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($2Ce6S))).disabled
        ]),
        style: {
            paddingLeft: value.inlineIndent ? `${value.inlineIndent}em` : undefined
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
            id: id,
            decimalAlignPercent: "decimalAlignPercent" in value ? value.decimalAlignPercent : undefined,
            editable: editable,
            pending: state.changed,
            setValue: (newValue)=>{
                const updates = [
                    {
                        dataPath: `${value.dataPath}/label`,
                        value: newValue
                    },
                    {
                        dataPath: `scaffoldModel/cellData/${(0, $1P8vv.encodePath)(rowId)}/${(0, $1P8vv.encodePath)(colId)}/displayContent`,
                        value: newValue
                    }
                ];
                /* istanbul ignore else */ if (rowIndex > -1 && colIndex > -1) updates.push({
                    dataPath: `calculatedTableRows/${rowIndex}/arsTableCells/${colIndex}/displayContent`,
                    value: newValue
                });
                dispatch({
                    operation: (0, $i3Ps9.ARST_PATCH_DATA),
                    updates: updates
                });
            },
            textAlignment: justification,
            value: isAnnotationsView ? editorProps.textToT(annotationContent) : displayContent ?? // istanbul ignore next
            editorProps.blankT
        })
    });
};
$3fc58ca55f9cc096$export$438b09b12f54002e.displayName = "ArsTableCell";
const $3fc58ca55f9cc096$export$fadae6fc2a19ab98 = (tProps)=>({
        Editor: $3fc58ca55f9cc096$export$438b09b12f54002e,
        blankT: {
            annotationContent: "",
            cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
            columnId: "",
            columnIndex: -1,
            dataPath: "",
            displayContent: tProps.textToT(""),
            justification: (0, $i3Ps9.ArsTextJustification).Default,
            rowId: "",
            targetType: "data"
        },
        getTextFromT: (cellValue)=>{
            const cellDisplay = cellValue.displayContent;
            return tProps.getTextFromT(cellDisplay);
        },
        isT: (value)=>{
            return (0, $8CFpa.isObjectRecord)(value) && "annotationContent" in value && (0, $eAPMz.isString)(value.annotationContent) && "cellType" in value && Object.values((0, $i3Ps9.ArsTableCellType)).includes(value.cellType) && "dataPath" in value && (0, $eAPMz.isString)(value.dataPath) && "displayContent" in value && tProps.isT(value.displayContent);
        },
        joinTintoBlock: (cellValues)=>{
            const displayContents = cellValues.map((cv)=>cv.displayContent);
            return {
                annotationContent: cellValues.map((cv)=>cv.annotationContent).join("\n"),
                cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
                columnId: cellValues[0]?.columnId ?? // istanbul ignore next
                "",
                columnIndex: cellValues[0]?.columnIndex ?? // istanbul ignore next
                -1,
                dataPath: cellValues[0]?.dataPath ?? // istanbul ignore next
                "",
                displayContent: tProps.joinTintoBlock(displayContents),
                justification: cellValues[0]?.justification ?? // istanbul ignore next
                (0, $i3Ps9.ArsTextJustification).Default,
                rowId: cellValues[0]?.rowId ?? // istanbul ignore next
                "",
                targetType: "data"
            };
        },
        replaceTextInT: (cellValue, oldPhrase, newPhrase)=>{
            return {
                ...cellValue,
                displayContent: tProps.replaceTextInT(cellValue.displayContent, oldPhrase, newPhrase.displayContent)
            };
        },
        splitTintoLines: (cellValue)=>{
            const displayContent = cellValue.displayContent;
            const splitDisplay = tProps.splitTintoLines(displayContent);
            return splitDisplay.map((line)=>({
                    annotationContent: cellValue.annotationContent,
                    cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
                    columnId: cellValue.columnId,
                    columnIndex: cellValue.columnIndex,
                    dataPath: cellValue.dataPath,
                    displayContent: line,
                    justification: cellValue.justification,
                    rowId: cellValue.rowId,
                    targetType: "data"
                }));
        },
        textToT: (text)=>({
                annotationContent: "",
                cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
                columnId: "",
                columnIndex: -1,
                dataPath: "",
                displayContent: tProps.textToT(text),
                rowId: "",
                justification: (0, $i3Ps9.ArsTextJustification).Default,
                targetType: "data"
            })
    });

});
parcelRegister("2Ce6S", function(module, exports) {

$parcel$export(module.exports, "arsTableCell", function () { return $1e7a1352da19030e$export$4e76e29d6076414e; }, function (v) { return $1e7a1352da19030e$export$4e76e29d6076414e = v; });
$parcel$export(module.exports, "disabled", function () { return $1e7a1352da19030e$export$683472f6198a076e; }, function (v) { return $1e7a1352da19030e$export$683472f6198a076e = v; });
var $1e7a1352da19030e$export$4e76e29d6076414e;
var $1e7a1352da19030e$export$683472f6198a076e;
$1e7a1352da19030e$export$4e76e29d6076414e = `mos-ArsTableCell-module--j4d_W-arsTableCell`;
$1e7a1352da19030e$export$683472f6198a076e = `mos-ArsTableCell-module--j4d_W-disabled`;

});


parcelRegister("1MNbD", function(module, exports) {

$parcel$export(module.exports, "ArsTableContextMenuProvider", function () { return $5ab3f2bc2cc722e6$export$25eb647dcebd95bd; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $dRarR = parcelRequire("dRarR");

var $7j5F4 = parcelRequire("7j5F4");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("6yroJ");
var $4AU0o = parcelRequire("4AU0o");

var $6Llki = parcelRequire("6Llki");

var $heZv5 = parcelRequire("heZv5");
parcelRequire("kDPjn");
var $12bze = parcelRequire("12bze");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $egJ4L = parcelRequire("egJ4L");
/**
 * Resolves a view-item payload from a scaffold cell when the target is supported.
 *
 * @param cellValue - Current scaffold cell value
 * @param state - Current ArsTableContext state
 * @returns View-item payload for the properties panel, or undefined when unsupported
 */ const $5ab3f2bc2cc722e6$var$resolveViewItem = (cellValue, state)=>{
    // istanbul ignore next - typeGuard that has already been validated before this call
    if (!("targetId" in cellValue)) return undefined;
    /** For groups and dataValues return the groupingFactor */ if (cellValue.targetType === "group" || cellValue.targetType === "dataDriven") {
        const targetDataPath = (0, $12bze.arst_resolveTargetPath)(cellValue.dataPath);
        const groupingFactor = (0, $eAPMz.getFromDataPath)(`${targetDataPath}/groupingFactor`, state.bodyData, (obj)=>(0, $4AU0o.isGroupingFactor)(obj));
        /* istanbul ignore else */ if (groupingFactor) return {
            id: groupingFactor.id,
            type: "groupingFactor",
            dataPath: targetDataPath
        };
        else return undefined;
    }
    return {
        id: cellValue.targetId,
        type: cellValue.targetType,
        dataPath: cellValue.dataPath
    };
};
/**
 * Builds sorted context-menu labels for developer inspection groups.
 *
 * @param obj - Source object used to build display rows
 * @returns Context-menu items for developer display
 */ // istanbul ignore next -- developer-only inspection helper is intentionally excluded from coverage gate
const $5ab3f2bc2cc722e6$var$getDeveloperMenuItems = (obj)=>Object.entries(obj ?? {}).filter(([key])=>![
            "analysisMethod",
            "groupingFactor",
            "operation",
            "displayContent"
        ].includes(key)).sort(([keyA], [keyB])=>keyA.localeCompare(keyB)).map(([key, val])=>({
            label: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: `${key}`
                    }),
                    `: ${val}`
                ]
            })
        }));
const $5ab3f2bc2cc722e6$export$25eb647dcebd95bd = ({ children: children })=>{
    const { state: state, dispatch: dispatch } = (0, $6Llki.useArsTable)();
    const [contextMenuTarget, setContextMenuTarget] = (0, $7fPBF.useState)(undefined);
    if (!state) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: children
    });
    /**
   * Function to blur active element
   */ const blurActiveElement = ()=>{
        /* istanbul ignore else */ if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    };
    /**
   * Captures scaffold row and column ids before opening the context menu.
   *
   * @param event - Context menu event fired from scaffold cells
   */ const handleScaffoldContextMenuCapture = (event)=>{
        let ret = undefined;
        const target = (0, $7j5F4.getScaffoldContextMenuTarget)(event.target);
        /* istanbul ignore else */ if (target) {
            const resolvedValue = state?.scaffoldModel?.cellData?.[target.rowId]?.[target.colId];
            /* istanbul ignore else */ if (resolvedValue) ret = {
                ...target,
                value: resolvedValue
            };
        }
        setContextMenuTarget(ret);
    };
    const actionList = [];
    if (contextMenuTarget) {
        if ("targetId" in contextMenuTarget.value && contextMenuTarget.value.targetType) actionList.push({
            label: "Show item properties",
            action: ()=>{
                blurActiveElement();
                const viewItem = $5ab3f2bc2cc722e6$var$resolveViewItem(contextMenuTarget.value, state);
                /* istanbul ignore else */ if (viewItem) dispatch({
                    operation: (0, $i3Ps9.ARST_SET_VIEW_ITEM),
                    viewItem: viewItem
                });
            }
        });
        const cellActions = (0, $heZv5.cellActionConfig)(contextMenuTarget.value, state).contextMenuActions.map((actionDefn)=>({
                label: actionDefn.label,
                action: ()=>{
                    blurActiveElement();
                    dispatch({
                        operation: actionDefn.operation,
                        cellValue: contextMenuTarget.value
                    });
                }
            }));
        actionList.push(...cellActions);
        /** Add developer info display */ // istanbul ignore next
        if ([
            "local",
            "development",
            "test",
            "__REACT_APP_STAGE__"
        ].includes((0, $dRarR.REACT_APP_STAGE)) && state.bodyData) {
            const developerMenuItems = [
                {
                    label: "Developer info",
                    group: $5ab3f2bc2cc722e6$var$getDeveloperMenuItems(contextMenuTarget.value)
                }
            ];
            actionList.push(...developerMenuItems);
            const targetDataPath = (0, $12bze.arst_resolveTargetPath)(contextMenuTarget.value.dataPath);
            const dataPathData = (0, $eAPMz.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
            if (dataPathData) {
                const developerGroupMenuItems = [
                    {
                        label: "Developer info (group)",
                        group: $5ab3f2bc2cc722e6$var$getDeveloperMenuItems(dataPathData)
                    }
                ];
                if ("groupingFactor" in dataPathData) developerGroupMenuItems[0].group?.push(...$5ab3f2bc2cc722e6$var$getDeveloperMenuItems(dataPathData.groupingFactor));
                if ("analysisMethod" in dataPathData) developerGroupMenuItems[0].group?.push(...$5ab3f2bc2cc722e6$var$getDeveloperMenuItems(dataPathData.analysisMethod));
                if ("operation" in dataPathData) developerGroupMenuItems[0].group?.push(...$5ab3f2bc2cc722e6$var$getDeveloperMenuItems(dataPathData.operation));
                actionList.push(...developerGroupMenuItems);
            }
        }
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
        menuItems: actionList,
        onContextMenuCapture: handleScaffoldContextMenuCapture,
        children: children
    });
};
$5ab3f2bc2cc722e6$export$25eb647dcebd95bd.displayName = "ArsTableContextMenuProvider";

});

parcelRegister("8GZ3J", function(module, exports) {

$parcel$export(module.exports, "ArsTableItemProperties", function () { return $fb364072f46e301e$export$f9216f51529681b3; });

var $bbzbN = parcelRequire("bbzbN");

var $aQsQo = parcelRequire("aQsQo");
parcelRequire("bIAbO");
var $7uNID = parcelRequire("7uNID");
var $bRDEW = parcelRequire("bRDEW");
var $apoy8 = parcelRequire("apoy8");

var $6Llki = parcelRequire("6Llki");

var $hsydd = parcelRequire("hsydd");

var $i3Ps9 = parcelRequire("i3Ps9");
const $fb364072f46e301e$export$f9216f51529681b3 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $6Llki.useArsTable)();
    if (!state?.viewItem) return null;
    /**
   * Clears the current view item and closes the properties panel.
   */ const handleHide = ()=>{
        dispatch({
            operation: (0, $i3Ps9.ARST_SET_VIEW_ITEM),
            viewItem: undefined
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aQsQo.default), {
        id: "ars-table-item-properties",
        show: state.viewItem !== undefined,
        onHide: handleHide,
        backdrop: false,
        scroll: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Title, {
                    children: "Item properties"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Body, {
                children: state.viewItem.type === "analysisMethod" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7uNID.AnalysisMethodControl), {
                    dataPath: `/analysisMethods/${state.viewItem.id}`,
                    disabled: true
                }) : state.viewItem.type === "operation" ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $apoy8.OperationControl), {
                            dataPath: `/operations/${state.viewItem.id}`,
                            siblingCount: -9,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hsydd.ArsTableItemParameters), {
                            dataPath: state.viewItem.dataPath
                        })
                    ]
                }) : state.viewItem.type === "groupingFactor" ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bRDEW.GroupingFactorControl), {
                            dataPath: `/groupingFactors/${state.viewItem.id}`,
                            disabled: true
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hsydd.ArsTableItemParameters), {
                            dataPath: state.viewItem.dataPath
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "text-danger",
                    children: "Invalid item type"
                })
            })
        ]
    });
};
$fb364072f46e301e$export$f9216f51529681b3.displayName = "ArsTableItemProperties";

});
parcelRegister("aQsQo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e55228b53ac64e9$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7quyp = parcelRequire("7quyp");

var $jbhqg = parcelRequire("jbhqg");

var $7fPBF = parcelRequire("7fPBF");

var $h4kX5 = parcelRequire("h4kX5");

var $e2eQx = parcelRequire("e2eQx");

var $iGcKF = parcelRequire("iGcKF");

var $25vNT = parcelRequire("25vNT");

var $i1mVH = parcelRequire("i1mVH");

var $2WT7i = parcelRequire("2WT7i");

var $5bjrv = parcelRequire("5bjrv");

var $jbn4d = parcelRequire("jbn4d");

var $90GdC = parcelRequire("90GdC");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $7e55228b53ac64e9$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $25vNT.default), {
        ...props
    });
}
function $7e55228b53ac64e9$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e2eQx.default), {
        ...props
    });
}
const $7e55228b53ac64e9$var$Offcanvas = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $7fPBF.useRef)();
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $7fPBF.useState)(false);
    const handleHide = (0, $jbhqg.default)(onHide);
    const hideResponsiveOffcanvas = (0, $7quyp.default)(responsive || 'xs', 'up');
    (0, $7fPBF.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $7fPBF.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $90GdC.default)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $90GdC.getSharedManager)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $7fPBF.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i1mVH.default).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h4kX5.default), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $7e55228b53ac64e9$var$DialogTransition,
                    backdropTransition: $7e55228b53ac64e9$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$7e55228b53ac64e9$var$Offcanvas.displayName = 'Offcanvas';
var $7e55228b53ac64e9$export$2e2bcd8739ae039 = Object.assign($7e55228b53ac64e9$var$Offcanvas, {
    Body: (0, $iGcKF.default),
    Header: (0, $2WT7i.default),
    Title: (0, $5bjrv.default)
});

});
parcelRegister("7quyp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5682a97c2018153c$export$2e2bcd8739ae039; });

var $gpUKm = parcelRequire("gpUKm");

var $7fPBF = parcelRequire("7fPBF");
function $5682a97c2018153c$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $7fPBF.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $gpUKm.default)(query, window);
    }
    return useBreakpoint;
}
const $5682a97c2018153c$var$useBreakpoint = $5682a97c2018153c$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $5682a97c2018153c$export$2e2bcd8739ae039 = $5682a97c2018153c$var$useBreakpoint;

});
parcelRegister("gpUKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf3affd8fe860219$export$2e2bcd8739ae039; });

var $lKzMT = parcelRequire("lKzMT");

var $7fPBF = parcelRequire("7fPBF");
const $bf3affd8fe860219$var$matchersByWindow = new WeakMap();
const $bf3affd8fe860219$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $bf3affd8fe860219$var$matchersByWindow.get(targetWindow) || new Map();
    $bf3affd8fe860219$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $bf3affd8fe860219$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $bf3affd8fe860219$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $7fPBF.useState)(()=>mql ? mql.matches : false);
    (0, $lKzMT.default)(()=>{
        let mql = $bf3affd8fe860219$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $bf3affd8fe860219$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}

});
parcelRegister("lKzMT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd59a7843d3d978c$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $fd59a7843d3d978c$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $fd59a7843d3d978c$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $fd59a7843d3d978c$export$2e2bcd8739ae039 = $fd59a7843d3d978c$var$isDOM || $fd59a7843d3d978c$var$isReactNative ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);

});



parcelRegister("jbhqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df6c8f2834bda015$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $3dfVS = parcelRequire("3dfVS");
function $df6c8f2834bda015$export$2e2bcd8739ae039(fn) {
    const ref = (0, $3dfVS.default)(fn);
    return (0, $7fPBF.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("3dfVS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $256ef1e11f93e676$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $256ef1e11f93e676$var$useCommittedRef(value) {
    const ref = (0, $7fPBF.useRef)(value);
    (0, $7fPBF.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $256ef1e11f93e676$export$2e2bcd8739ae039 = $256ef1e11f93e676$var$useCommittedRef;

});


parcelRegister("h4kX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6d3100a2d3f9e0a$export$2e2bcd8739ae039; });

var $lfInN = parcelRequire("lfInN");

var $lvBJh = parcelRequire("lvBJh");

var $kkTu9 = parcelRequire("kkTu9");

var $22FgH = parcelRequire("22FgH");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $h3OEp = parcelRequire("h3OEp");

var $ax9Ko = parcelRequire("ax9Ko");

var $aJTM3 = parcelRequire("aJTM3");

var $29zbc = parcelRequire("29zbc");

var $2CiGk = parcelRequire("2CiGk");

var $5Gx8F = parcelRequire("5Gx8F");

var $2HPLt = parcelRequire("2HPLt");

var $5aSAE = parcelRequire("5aSAE");

var $lfw25 = parcelRequire("lfw25");

var $bbzbN = parcelRequire("bbzbN");
const $c6d3100a2d3f9e0a$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $c6d3100a2d3f9e0a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $c6d3100a2d3f9e0a$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $c6d3100a2d3f9e0a$var$getManager(window) {
    if (!$c6d3100a2d3f9e0a$var$manager) $c6d3100a2d3f9e0a$var$manager = new (0, $2CiGk.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $c6d3100a2d3f9e0a$var$manager;
}
function $c6d3100a2d3f9e0a$var$useModalManager(provided) {
    const window = (0, $2HPLt.default)();
    const modalManager = provided || $c6d3100a2d3f9e0a$var$getManager(window);
    const modal = (0, $7fPBF.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $7fPBF.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $7fPBF.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $c6d3100a2d3f9e0a$var$Modal = /*#__PURE__*/ (0, $7fPBF.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $c6d3100a2d3f9e0a$var$_objectWithoutPropertiesLoose(_ref, $c6d3100a2d3f9e0a$var$_excluded);
    const ownerWindow = (0, $2HPLt.default)();
    const container = (0, $5Gx8F.default)(containerRef);
    const modal = $c6d3100a2d3f9e0a$var$useModalManager(providedManager);
    const isMounted = (0, $h3OEp.default)();
    const prevShow = (0, $aJTM3.default)(show);
    const [exited, setExited] = (0, $7fPBF.useState)(!show);
    const lastFocusRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $kkTu9.default) && !prevShow && show) lastFocusRef.current = (0, $lfInN.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $29zbc.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $22FgH.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $22FgH.default)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $lfInN.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $lvBJh.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $29zbc.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $7fPBF.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $7fPBF.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $ax9Ko.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $29zbc.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $lfInN.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $lvBJh.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $29zbc.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $29zbc.default)((e)=>{
        if (keyboard && (0, $lfw25.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $7fPBF.useRef)();
    const removeKeydownListenerRef = (0, $7fPBF.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $5aSAE.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $5aSAE.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).createPortal(/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$c6d3100a2d3f9e0a$var$Modal.displayName = 'Modal';
var $c6d3100a2d3f9e0a$export$2e2bcd8739ae039 = Object.assign($c6d3100a2d3f9e0a$var$Modal, {
    Manager: (0, $2CiGk.default)
});

});
parcelRegister("lfInN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f78d6d30df7f1e68$export$2e2bcd8739ae039; });

var $eSNaH = parcelRequire("eSNaH");
function $f78d6d30df7f1e68$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $eSNaH.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

});

parcelRegister("lvBJh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa89c27ce6ca962e$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $fa89c27ce6ca962e$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("ax9Ko", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ab48c124c9155bd$export$2e2bcd8739ae039; });

var $aqSco = parcelRequire("aqSco");

var $7fPBF = parcelRequire("7fPBF");
function $7ab48c124c9155bd$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $aqSco.default)(fn);
    (0, $7fPBF.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("aqSco", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79865fda08bfda0f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $79865fda08bfda0f$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $7fPBF.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("2CiGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e7d9f28d127eb9c$export$2e2bcd8739ae039; });

var $6kugr = parcelRequire("6kugr");

var $1l3ik = parcelRequire("1l3ik");

var $aFb2W = parcelRequire("aFb2W");
const $1e7d9f28d127eb9c$export$1a88c12b8b979fa0 = (0, $1l3ik.dataAttr)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $1e7d9f28d127eb9c$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $aFb2W.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $6kugr.default)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($1e7d9f28d127eb9c$export$1a88c12b8b979fa0, '');
        (0, $6kugr.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($1e7d9f28d127eb9c$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $1e7d9f28d127eb9c$export$2e2bcd8739ae039 = $1e7d9f28d127eb9c$var$ModalManager;

});
parcelRegister("aFb2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c364d50fbe461a4$export$2e2bcd8739ae039; });
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $7c364d50fbe461a4$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

});


parcelRegister("5Gx8F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $423a94a69da069d9$export$2e2bcd8739ae039; });

var $eSNaH = parcelRequire("eSNaH");

var $kkTu9 = parcelRequire("kkTu9");

var $7fPBF = parcelRequire("7fPBF");

var $2HPLt = parcelRequire("2HPLt");
const $423a94a69da069d9$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $kkTu9.default)) return null;
    if (ref == null) return (document || (0, $eSNaH.default)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $423a94a69da069d9$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $2HPLt.default)();
    const [resolvedRef, setRef] = (0, $7fPBF.useState)(()=>$423a94a69da069d9$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $423a94a69da069d9$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $7fPBF.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const nextRef = $423a94a69da069d9$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});
parcelRegister("2HPLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f87c0546ce85bf8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $kkTu9 = parcelRequire("kkTu9");
const $1f87c0546ce85bf8$var$Context = /*#__PURE__*/ (0, $7fPBF.createContext)((0, $kkTu9.default) ? window : undefined);
const $1f87c0546ce85bf8$export$f7d306aeb1cf5fbc = $1f87c0546ce85bf8$var$Context.Provider;
function $1f87c0546ce85bf8$export$2e2bcd8739ae039() {
    return (0, $7fPBF.useContext)($1f87c0546ce85bf8$var$Context);
}

});


parcelRegister("5aSAE", function(module, exports) {

$parcel$export(module.exports, "renderTransition", function () { return $3c483b638b6cde02$export$f41d64aae6d6dba5; });

var $f2Ftg = parcelRequire("f2Ftg");

var $29zbc = parcelRequire("29zbc");

var $etwAC = parcelRequire("etwAC");

var $7fPBF = parcelRequire("7fPBF");

var $id1uP = parcelRequire("id1uP");

var $eNfFp = parcelRequire("eNfFp");

var $lfw25 = parcelRequire("lfw25");

var $bbzbN = parcelRequire("bbzbN");
function $3c483b638b6cde02$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $7fPBF.useRef)(null);
    const isInitialRef = (0, $7fPBF.useRef)(true);
    const handleTransition = (0, $29zbc.default)(onTransition);
    (0, $etwAC.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $etwAC.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $3c483b638b6cde02$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $7fPBF.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $3c483b638b6cde02$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $f2Ftg.default)(ref, (0, $lfw25.getChildRef)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $7fPBF.cloneElement)(children, {
        ref: combinedRef
    });
}
function $3c483b638b6cde02$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eNfFp.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $bbzbN.jsx)($3c483b638b6cde02$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $id1uP.default), Object.assign({}, props));
}

});
parcelRegister("eNfFp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac51cb66f154384d$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $1YSZB = parcelRequire("1YSZB");

var $bbzbN = parcelRequire("bbzbN");
const $ac51cb66f154384d$var$_excluded = [
    "component"
];
function $ac51cb66f154384d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $ac51cb66f154384d$var$RTGTransition = /*#__PURE__*/ $7fPBF.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $ac51cb66f154384d$var$_objectWithoutPropertiesLoose(_ref, $ac51cb66f154384d$var$_excluded);
    const transitionProps = (0, $1YSZB.default)(props);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $ac51cb66f154384d$export$2e2bcd8739ae039 = $ac51cb66f154384d$var$RTGTransition;

});
parcelRegister("1YSZB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17160d6f1793c531$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $f2Ftg = parcelRequire("f2Ftg");

var $lfw25 = parcelRequire("lfw25");
const $17160d6f1793c531$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $17160d6f1793c531$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $17160d6f1793c531$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $17160d6f1793c531$var$_objectWithoutPropertiesLoose(_ref, $17160d6f1793c531$var$_excluded);
    const nodeRef = (0, $7fPBF.useRef)(null);
    const mergedRef = (0, $f2Ftg.default)(nodeRef, (0, $lfw25.getChildRef)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $7fPBF.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $7fPBF.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $7fPBF.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $7fPBF.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $7fPBF.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $7fPBF.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $7fPBF.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $7fPBF.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

});




parcelRegister("iGcKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9960a7bb31b623a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $d9960a7bb31b623a$var$OffcanvasBody = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$d9960a7bb31b623a$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $d9960a7bb31b623a$export$2e2bcd8739ae039 = $d9960a7bb31b623a$var$OffcanvasBody;

});

parcelRegister("25vNT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1854b7f828b7ccca$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $8qMCX = parcelRequire("8qMCX");

var $lfw25 = parcelRequire("lfw25");

var $kndvq = parcelRequire("kndvq");

var $g8anv = parcelRequire("g8anv");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $1854b7f828b7ccca$var$transitionStyles = {
    [(0, $8qMCX.ENTERING)]: 'show',
    [(0, $8qMCX.ENTERED)]: 'show'
};
const $1854b7f828b7ccca$var$OffcanvasToggling = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g8anv.default), {
        ref: ref,
        addEndListener: (0, $kndvq.default),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $lfw25.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $7fPBF.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, children.props.className, (status === (0, $8qMCX.ENTERING) || status === (0, $8qMCX.EXITING)) && `${bsPrefix}-toggling`, $1854b7f828b7ccca$var$transitionStyles[status])
            })
    });
});
$1854b7f828b7ccca$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $1854b7f828b7ccca$export$2e2bcd8739ae039 = $1854b7f828b7ccca$var$OffcanvasToggling;

});

parcelRegister("i1mVH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1ea1b5c1899e3b2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $d1ea1b5c1899e3b2$var$ModalContext = /*#__PURE__*/ $7fPBF.createContext({
    onHide () {}
});
var $d1ea1b5c1899e3b2$export$2e2bcd8739ae039 = $d1ea1b5c1899e3b2$var$ModalContext;

});

parcelRegister("2WT7i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $225bc09936a6cba0$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $hcUZE = parcelRequire("hcUZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $225bc09936a6cba0$var$OffcanvasHeader = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hcUZE.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$225bc09936a6cba0$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $225bc09936a6cba0$export$2e2bcd8739ae039 = $225bc09936a6cba0$var$OffcanvasHeader;

});
parcelRegister("hcUZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c86fc4541898ca8b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jbhqg = parcelRequire("jbhqg");

var $gYgRC = parcelRequire("gYgRC");

var $i1mVH = parcelRequire("i1mVH");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $c86fc4541898ca8b$var$AbstractModalHeader = /*#__PURE__*/ $7fPBF.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $7fPBF.useContext)((0, $i1mVH.default));
    const handleClick = (0, $jbhqg.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gYgRC.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$c86fc4541898ca8b$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $c86fc4541898ca8b$export$2e2bcd8739ae039 = $c86fc4541898ca8b$var$AbstractModalHeader;

});
parcelRegister("gYgRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5af54be7385b617$export$2e2bcd8739ae039; });

var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $bbzbN = parcelRequire("bbzbN");
const $c5af54be7385b617$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        'white'
    ])
};
const $c5af54be7385b617$var$CloseButton = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $bbzbN.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$c5af54be7385b617$var$CloseButton.displayName = 'CloseButton';
$c5af54be7385b617$var$CloseButton.propTypes = $c5af54be7385b617$var$propTypes;
var $c5af54be7385b617$export$2e2bcd8739ae039 = $c5af54be7385b617$var$CloseButton;

});



parcelRegister("5bjrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c5d0fbf99e2854e$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $kmq8T = parcelRequire("kmq8T");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3c5d0fbf99e2854e$var$DivStyledAsH5 = (0, $kmq8T.default)('h5');
const $3c5d0fbf99e2854e$var$OffcanvasTitle = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $3c5d0fbf99e2854e$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$3c5d0fbf99e2854e$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $3c5d0fbf99e2854e$export$2e2bcd8739ae039 = $3c5d0fbf99e2854e$var$OffcanvasTitle;

});
parcelRegister("kmq8T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed2a240fc05bf925$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $bbzbN = parcelRequire("bbzbN");
var $ed2a240fc05bf925$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $7fPBF.forwardRef((p, ref)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(p.className, className)
        }));

});


parcelRegister("90GdC", function(module, exports) {

$parcel$export(module.exports, "getSharedManager", function () { return $68f4dce88602d1c2$export$a03641438014b436; });
$parcel$export(module.exports, "default", function () { return $68f4dce88602d1c2$export$2e2bcd8739ae039; });

var $2B0G6 = parcelRequire("2B0G6");

var $6kugr = parcelRequire("6kugr");

var $cKYDs = parcelRequire("cKYDs");

var $bQbU1 = parcelRequire("bQbU1");

var $2CiGk = parcelRequire("2CiGk");
const $68f4dce88602d1c2$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $68f4dce88602d1c2$var$BootstrapModalManager extends (0, $2CiGk.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $6kugr.default)(element, {
            [prop]: `${parseFloat((0, $6kugr.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $6kugr.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $2B0G6.default)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $cKYDs.default)(container, $68f4dce88602d1c2$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $cKYDs.default)(container, $68f4dce88602d1c2$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $cKYDs.default)(container, $68f4dce88602d1c2$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $bQbU1.default)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $cKYDs.default)(container, $68f4dce88602d1c2$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $cKYDs.default)(container, $68f4dce88602d1c2$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $cKYDs.default)(container, $68f4dce88602d1c2$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $68f4dce88602d1c2$var$sharedManager;
function $68f4dce88602d1c2$export$a03641438014b436(options) {
    if (!$68f4dce88602d1c2$var$sharedManager) $68f4dce88602d1c2$var$sharedManager = new $68f4dce88602d1c2$var$BootstrapModalManager(options);
    return $68f4dce88602d1c2$var$sharedManager;
}
var $68f4dce88602d1c2$export$2e2bcd8739ae039 = $68f4dce88602d1c2$var$BootstrapModalManager;

});
parcelRegister("2B0G6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3f901d29816e8c$export$2e2bcd8739ae039; });

var $85lB0 = parcelRequire("85lB0");
function $1e3f901d29816e8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $85lB0.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("85lB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $5e2f8ad2f75c6c7a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("bQbU1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89edc8a1840ff9c1$export$2e2bcd8739ae039; });
function $89edc8a1840ff9c1$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $89edc8a1840ff9c1$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $89edc8a1840ff9c1$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $89edc8a1840ff9c1$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});



parcelRegister("hsydd", function(module, exports) {

$parcel$export(module.exports, "ArsTableItemParameters", function () { return $a62798e33f75cac3$export$821b30b6c0d300f5; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("0PqYf");
var $h7VrC = parcelRequire("h7VrC");
var $3EZep = parcelRequire("3EZep");
var $eUQaa = parcelRequire("eUQaa");
parcelRequire("6yroJ");
var $ek4hO = parcelRequire("ek4hO");
var $hoYmS = parcelRequire("hoYmS");

var $4AU0o = parcelRequire("4AU0o");

var $6Llki = parcelRequire("6Llki");

var $egwZr = parcelRequire("egwZr");

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("2YSoS");
var $egJ4L = parcelRequire("egJ4L");
const $a62798e33f75cac3$export$821b30b6c0d300f5 = ({ dataPath: dataPath, disabled: disabled })=>{
    const ars = (0, $fZCs4.useArsContext)();
    const { state: state } = (0, $6Llki.useArsTable)();
    const tableBodyData = state?.bodyData;
    const thisItem = tableBodyData ? (0, $eAPMz.getFromDataPath)(dataPath, tableBodyData, (obj)=>(0, $egJ4L.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT)) : null;
    const analysisMethod = state && state.bodyData.analysisMethodId ? (0, $eAPMz.getFromDataPath)(`/analysisMethods/${state.bodyData.analysisMethodId}`, ars.state, (0, $ek4hO.isAnalysisMethod)) : null;
    if (!state || !thisItem || !analysisMethod) return null;
    const groupingFactor = tableBodyData ? (0, $eAPMz.getFromDataPath)(`${dataPath}/groupingFactor`, tableBodyData, (0, $4AU0o.isGroupingFactor)) : null;
    const operation = tableBodyData ? (0, $eAPMz.getFromDataPath)(`${dataPath}/operation`, tableBodyData, (0, $hoYmS.isOperation)) : null;
    const availableParameters = analysisMethod.codeTemplate?.parameters?.filter((tcp)=>tcp.valueSource === "groupingFactor" && groupingFactor || tcp.valueSource === "operation" && operation) ?? [];
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            operation && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eUQaa.ArsVariable), {
                id: `${dataPath.replace(/\//g, "-")}-target-variable`,
                combinedDataPath: `${dataPath}/targetVariable`,
                tableDataPath: true,
                label: "Target variable",
                labelWidth: 5,
                disabled: disabled
            }),
            availableParameters.map((parameter, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $egwZr.ArsTableItemParameterValue), {
                    parameter: parameter,
                    index: index,
                    dataPath: dataPath,
                    disabled: disabled
                }, `${parameter.name}-${index}`)),
            operation && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                        id: `${dataPath.replace(/\//g, "-")}-justification`,
                        dataPath: `${dataPath}/justification`,
                        tableDataPath: true,
                        label: "Justification",
                        labelWidth: 5,
                        options: Object.entries((0, $i3Ps9.ArsTextJustification)).map(([label, value])=>({
                                value: value,
                                label: label
                            })),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                        id: `${dataPath.replace(/\//g, "-")}-decimal-align-percent`,
                        dataPath: `${dataPath}/decimalAlignPercent`,
                        disabled: disabled,
                        label: "Decimal align %",
                        labelWidth: 5,
                        type: "number",
                        tableDataPath: true
                    })
                ]
            })
        ]
    });
};
$a62798e33f75cac3$export$821b30b6c0d300f5.displayName = "ArsTableItemParameters";

});
parcelRegister("egwZr", function(module, exports) {

$parcel$export(module.exports, "ArsTableItemParameterValue", function () { return $006dddd5fa259c83$export$9948cf09eae9aad2; });

var $bbzbN = parcelRequire("bbzbN");

var $h7VrC = parcelRequire("h7VrC");

var $3EZep = parcelRequire("3EZep");

var $eUQaa = parcelRequire("eUQaa");
const $006dddd5fa259c83$export$9948cf09eae9aad2 = ({ index: index, dataPath: dataPath, disabled: disabled, parameter: parameter })=>{
    const baseDataPath = `${dataPath}/parameters`;
    const parameterPath = `${baseDataPath}/${parameter.name}`;
    const idRoute = `${dataPath.replace(/\//g, "-")}-parameter-${index}`;
    const label = parameter.label ?? parameter.name;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: parameter.parameterType === "select" || parameter.parameterType === "multiSelect" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
            dataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-select`,
            label: label,
            labelWidth: 5,
            options: (parameter.availableValues ?? []).map((value)=>({
                    value: value,
                    label: value
                })),
            multiple: parameter.parameterType === "multiSelect",
            disabled: disabled || (parameter.availableValues ?? []).length === 0
        }) : parameter.parameterType === "boolean" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
            dataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-boolean`,
            label: label,
            labelWidth: 5,
            options: [
                {
                    value: "true",
                    label: "True"
                },
                {
                    value: "false",
                    label: "False"
                }
            ],
            disabled: disabled
        }) : parameter.parameterType === "dataset.variable" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eUQaa.ArsVariable), {
            combinedDataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-dataset-variable`,
            label: label,
            labelWidth: 5,
            disabled: disabled
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
            dataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-text`,
            label: label,
            labelWidth: 5,
            placeholder: `Enter ${label}`,
            isArray: parameter.parameterType === "stringList" || parameter.parameterType === "numberList",
            disabled: disabled
        })
    });
};
$006dddd5fa259c83$export$9948cf09eae9aad2.displayName = "ArsTableItemParameter";

});
parcelRegister("eUQaa", function(module, exports) {

$parcel$export(module.exports, "ArsVariable", function () { return $69bceb04b03b674b$export$d5912eafadbcc42a; });

var $bbzbN = parcelRequire("bbzbN");

var $k6Ixm = parcelRequire("k6Ixm");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
parcelRequire("loI62");
var $i3Ps9 = parcelRequire("i3Ps9");

var $6Llki = parcelRequire("6Llki");

var $8t4Ms = parcelRequire("8t4Ms");
/**
 * Type guard for the combined path prop shape.
 *
 * @param props - ArsVariable props in either mode.
 * @returns True when props use a single combined data path.
 */ const $69bceb04b03b674b$var$isCombinedPathProps = (props)=>"combinedDataPath" in props;
const $69bceb04b03b674b$export$d5912eafadbcc42a = (props)=>{
    const { canChangeDataset: canChangeDataset = true, tableDataPath: tableDataPath = false, validCondition: validCondition, ...rest } = props;
    const ars = (0, $fZCs4.useArsContext)();
    const table = (0, $6Llki.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    const isCombinedPath = $69bceb04b03b674b$var$isCombinedPathProps(props);
    // Get the current values from state using the dataPaths
    let combinedValue = "";
    let dataset = "";
    if (isCombinedPath) {
        combinedValue = (0, $eAPMz.getFromDataPath)(props.combinedDataPath, sourceState, (0, $eAPMz.isString)) ?? "";
        dataset = combinedValue.split(".")[0];
    } else {
        dataset = (0, $eAPMz.getFromDataPath)(props.datasetDataPath, sourceState, (0, $eAPMz.isString)) ?? "";
        const variable = (0, $eAPMz.getFromDataPath)(props.variableDataPath, sourceState, (0, $eAPMz.isString)) ?? "";
        combinedValue = dataset && variable ? `${dataset}.${variable}` : "";
    }
    /**
   * Handle selection change by splitting the value and dispatching updates to both paths.
   * Expected format: "DATASET.VARIABLE" (e.g., "ADSL.AGE")
   *
   * @param newValue - The new combined value in format "DATASET.VARIABLE".
   */ const handleChange = (newValue)=>{
        // Split the value on the first period to separate dataset and variable
        const dotIndex = newValue.indexOf(".");
        let newDataset = "";
        let newVariable = "";
        if (isCombinedPath) {
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                updates: [
                    {
                        dataPath: props.combinedDataPath,
                        value: newValue
                    }
                ]
            });
            else table.dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                updates: [
                    {
                        dataPath: props.combinedDataPath,
                        value: newValue
                    }
                ]
            });
            return;
        }
        // When dataset changes are disabled and input is cleared, only clear variable.
        if (!canChangeDataset && newValue === "") {
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: ""
                    }
                ]
            });
            else table.dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: ""
                    }
                ]
            });
            return;
        }
        if (dotIndex > 0) {
            newDataset = newValue.substring(0, dotIndex);
            newVariable = newValue.substring(dotIndex + 1);
        } else // If no period found, treat entire value as dataset
        newDataset = newValue;
        if (!canChangeDataset) {
            // Ignore values that would change dataset or that are dataset-only.
            if (dotIndex <= 0 || newDataset !== dataset) return;
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: newVariable
                    }
                ]
            });
            else table.dispatch({
                operation: (0, $i3Ps9.ARST_PATCH_DATA),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: newVariable
                    }
                ]
            });
            return;
        }
        // Dispatch both updates atomically
        if (!tableDataPath) ars.dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            updates: [
                {
                    dataPath: props.datasetDataPath,
                    value: newDataset
                },
                {
                    dataPath: props.variableDataPath,
                    value: newVariable
                }
            ]
        });
        else table.dispatch({
            operation: (0, $i3Ps9.ARST_PATCH_DATA),
            updates: [
                {
                    dataPath: props.datasetDataPath,
                    value: newDataset
                },
                {
                    dataPath: props.variableDataPath,
                    value: newVariable
                }
            ]
        });
    };
    const availableVariables = canChangeDataset ? ars.state.variables : ars.state.variables.filter((variable)=>variable.dataset === dataset);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k6Ixm.ControlTypeAhead), {
        ...rest,
        availableList: availableVariables,
        value: combinedValue,
        setValue: handleChange,
        validCondition: canChangeDataset ? (0, $8t4Ms.isUnlistedDatasetVariableValue) : validCondition
    });
};
$69bceb04b03b674b$export$d5912eafadbcc42a.displayName = "ArsVariable";

});
parcelRegister("8t4Ms", function(module, exports) {

$parcel$export(module.exports, "isUnlistedDatasetVariableValue", function () { return $fbbea46a4c549c7e$export$6b881c0dedb4dc3b; });

var $4yc3n = parcelRequire("4yc3n");

var $9usef = parcelRequire("9usef");
/**
 * Builds a successful validation response for dataset.variable validation.
 *
 * @param valid - Whether the candidate value is valid.
 * @param validationText - Feedback text to display for the validation result.
 * @param warning - Whether the valid result should be shown as a warning.
 * @returns A successful validation result payload.
 */ const $fbbea46a4c549c7e$var$buildDatasetVariableValidationResult = (valid, validationText, warning = false)=>({
        success: true,
        data: {
            valid: valid,
            validationText: validationText,
            warning: warning
        }
    });
const $fbbea46a4c549c7e$export$6b881c0dedb4dc3b = async (_backEndUrl, target, _controller)=>{
    const trimmedValue = target.value.trim();
    const normalisedValue = (0, $9usef.normaliseDatasetVariable)(trimmedValue);
    const existingValues = (target.options?.existingValues ?? []).map((value)=>value.toUpperCase());
    const upperTrimmedValue = trimmedValue.toUpperCase();
    if (existingValues.includes(upperTrimmedValue)) return $fbbea46a4c549c7e$var$buildDatasetVariableValidationResult(true, "Valid dataset and variable");
    if (normalisedValue) return $fbbea46a4c549c7e$var$buildDatasetVariableValidationResult(true, (0, $4yc3n.CUSTOM_DATASET_VARIABLE_WARNING), true);
    return $fbbea46a4c549c7e$var$buildDatasetVariableValidationResult(false, "");
};

});





parcelRegister("diMS5", function(module, exports) {

$parcel$export(module.exports, "ArsTableTreeView", function () { return $74bd511b1532ef3a$export$56249a5b523308ba; });

var $bbzbN = parcelRequire("bbzbN");

var $6Llki = parcelRequire("6Llki");

var $adjLT = parcelRequire("adjLT");

var $hirFS = parcelRequire("hirFS");
parcelRequire("kDPjn");
var $7uH5j = parcelRequire("7uH5j");
/**
 * Renders one side of the ArsTableTreeView (either rows or columns) with a heading and tree nodes.
 *
 * @param props - Component properties
 * @param props.label - Heading label for the tree side (e.g., "Rows" or "Columns")
 * @param props.nodes - Array of tree nodes to render under this side
 * @param props.defaultExpanded - Whether tree nodes should be expanded by default (default: true)
 * @returns Rendered tree view side component
 */ const $74bd511b1532ef3a$var$ArsTableTreeViewSide = ({ label: label, nodes: nodes, defaultExpanded: defaultExpanded })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-body-tree-section"],
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-body-tree-heading"],
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-body-tree-content"],
                children: nodes.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-body-tree-empty"],
                    children: "No groups defined"
                }) : nodes.map((node)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $hirFS.ArsTableTreeNode), {
                        defaultExpanded: defaultExpanded,
                        ...node
                    }, node.id))
            })
        ]
    });
};
$74bd511b1532ef3a$var$ArsTableTreeViewSide.displayName = "ArsTableTreeViewSide";
const $74bd511b1532ef3a$export$56249a5b523308ba = ({ defaultExpanded: defaultExpanded = true })=>{
    const { state: state } = (0, $6Llki.useArsTable)();
    if (!state) return null;
    const rowNodes = state.bodyData.rows.map((row)=>(0, $7uH5j.groupToTreeNode)(row, state.settings.editorProps.isT));
    const columnNodes = state.bodyData.columns.map((col)=>(0, $7uH5j.groupToTreeNode)(col, state.settings.editorProps.isT));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-body-tree-view"],
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($74bd511b1532ef3a$var$ArsTableTreeViewSide, {
                label: "Rows",
                nodes: rowNodes,
                defaultExpanded: defaultExpanded
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($74bd511b1532ef3a$var$ArsTableTreeViewSide, {
                label: "Columns",
                nodes: columnNodes,
                defaultExpanded: defaultExpanded
            })
        ]
    });
};
$74bd511b1532ef3a$export$56249a5b523308ba.displayName = "ArsTableTreeView";

});
parcelRegister("adjLT", function(module, exports) {

$parcel$export(module.exports, "mos-ars-body-tree-content", function () { return $76fa74777fde1cda$export$e73c47a2197af69b; }, function (v) { return $76fa74777fde1cda$export$e73c47a2197af69b = v; });
$parcel$export(module.exports, "mos-ars-body-tree-empty", function () { return $76fa74777fde1cda$export$24888271bc299ff7; }, function (v) { return $76fa74777fde1cda$export$24888271bc299ff7 = v; });
$parcel$export(module.exports, "mos-ars-body-tree-heading", function () { return $76fa74777fde1cda$export$ff5b88941eeddb72; }, function (v) { return $76fa74777fde1cda$export$ff5b88941eeddb72 = v; });
$parcel$export(module.exports, "mos-ars-body-tree-section", function () { return $76fa74777fde1cda$export$3715647d719cacd5; }, function (v) { return $76fa74777fde1cda$export$3715647d719cacd5 = v; });
$parcel$export(module.exports, "mos-ars-body-tree-view", function () { return $76fa74777fde1cda$export$606fb8533ca7774f; }, function (v) { return $76fa74777fde1cda$export$606fb8533ca7774f = v; });
$parcel$export(module.exports, "mos-ars-tree-node", function () { return $76fa74777fde1cda$export$96ae3f9c054415b3; }, function (v) { return $76fa74777fde1cda$export$96ae3f9c054415b3 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-children", function () { return $76fa74777fde1cda$export$cf04eda64b18505b; }, function (v) { return $76fa74777fde1cda$export$cf04eda64b18505b = v; });
$parcel$export(module.exports, "mos-ars-tree-node-content", function () { return $76fa74777fde1cda$export$bdbd357637db81e3; }, function (v) { return $76fa74777fde1cda$export$bdbd357637db81e3 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-id", function () { return $76fa74777fde1cda$export$3cee6b62e86b25c6; }, function (v) { return $76fa74777fde1cda$export$3cee6b62e86b25c6 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-label", function () { return $76fa74777fde1cda$export$8fd2cfb32f8466d4; }, function (v) { return $76fa74777fde1cda$export$8fd2cfb32f8466d4 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-spacer", function () { return $76fa74777fde1cda$export$7c06628002aa3fe8; }, function (v) { return $76fa74777fde1cda$export$7c06628002aa3fe8 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-toggle", function () { return $76fa74777fde1cda$export$acde1c1bf05b2cde; }, function (v) { return $76fa74777fde1cda$export$acde1c1bf05b2cde = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type", function () { return $76fa74777fde1cda$export$c09494a2673157df; }, function (v) { return $76fa74777fde1cda$export$c09494a2673157df = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-analysisMethod", function () { return $76fa74777fde1cda$export$7bf88682578e874c; }, function (v) { return $76fa74777fde1cda$export$7bf88682578e874c = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-group", function () { return $76fa74777fde1cda$export$b2c4c3b6783bb4f9; }, function (v) { return $76fa74777fde1cda$export$b2c4c3b6783bb4f9 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-groupingFactor", function () { return $76fa74777fde1cda$export$826cf34c869b6802; }, function (v) { return $76fa74777fde1cda$export$826cf34c869b6802 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-operation", function () { return $76fa74777fde1cda$export$619c2077ebcc21b0; }, function (v) { return $76fa74777fde1cda$export$619c2077ebcc21b0 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-subgroup", function () { return $76fa74777fde1cda$export$6b2a74972bf44a8a; }, function (v) { return $76fa74777fde1cda$export$6b2a74972bf44a8a = v; });
var $76fa74777fde1cda$export$e73c47a2197af69b;
var $76fa74777fde1cda$export$24888271bc299ff7;
var $76fa74777fde1cda$export$ff5b88941eeddb72;
var $76fa74777fde1cda$export$3715647d719cacd5;
var $76fa74777fde1cda$export$606fb8533ca7774f;
var $76fa74777fde1cda$export$96ae3f9c054415b3;
var $76fa74777fde1cda$export$cf04eda64b18505b;
var $76fa74777fde1cda$export$bdbd357637db81e3;
var $76fa74777fde1cda$export$3cee6b62e86b25c6;
var $76fa74777fde1cda$export$8fd2cfb32f8466d4;
var $76fa74777fde1cda$export$7c06628002aa3fe8;
var $76fa74777fde1cda$export$acde1c1bf05b2cde;
var $76fa74777fde1cda$export$c09494a2673157df;
var $76fa74777fde1cda$export$7bf88682578e874c;
var $76fa74777fde1cda$export$b2c4c3b6783bb4f9;
var $76fa74777fde1cda$export$826cf34c869b6802;
var $76fa74777fde1cda$export$619c2077ebcc21b0;
var $76fa74777fde1cda$export$6b2a74972bf44a8a;
$76fa74777fde1cda$export$e73c47a2197af69b = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-content`;
$76fa74777fde1cda$export$24888271bc299ff7 = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-empty`;
$76fa74777fde1cda$export$ff5b88941eeddb72 = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-heading`;
$76fa74777fde1cda$export$3715647d719cacd5 = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-section`;
$76fa74777fde1cda$export$606fb8533ca7774f = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-view`;
$76fa74777fde1cda$export$96ae3f9c054415b3 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node`;
$76fa74777fde1cda$export$cf04eda64b18505b = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-children`;
$76fa74777fde1cda$export$bdbd357637db81e3 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-content`;
$76fa74777fde1cda$export$3cee6b62e86b25c6 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-id`;
$76fa74777fde1cda$export$8fd2cfb32f8466d4 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-label`;
$76fa74777fde1cda$export$7c06628002aa3fe8 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-spacer`;
$76fa74777fde1cda$export$acde1c1bf05b2cde = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-toggle`;
$76fa74777fde1cda$export$c09494a2673157df = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type`;
$76fa74777fde1cda$export$7bf88682578e874c = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-analysisMethod`;
$76fa74777fde1cda$export$b2c4c3b6783bb4f9 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-group`;
$76fa74777fde1cda$export$826cf34c869b6802 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-groupingFactor`;
$76fa74777fde1cda$export$619c2077ebcc21b0 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-operation`;
$76fa74777fde1cda$export$6b2a74972bf44a8a = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-subgroup`;

});

parcelRegister("hirFS", function(module, exports) {

$parcel$export(module.exports, "ArsTableTreeNode", function () { return $2c7a3db52e84e946$export$81350f32bf958e67; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $6Llki = parcelRequire("6Llki");

var $adjLT = parcelRequire("adjLT");
const $2c7a3db52e84e946$export$81350f32bf958e67 = ({ defaultExpanded: defaultExpanded = true, id: id, label: label, subNodes: subNodes, type: type })=>{
    const { state: state } = (0, $6Llki.useArsTable)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(defaultExpanded);
    if (!state) return null;
    const hasChildren = subNodes && subNodes.length > 0;
    const stringLabel = state.settings.editorProps.getTextFromT(label).join("");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node"],
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-content"],
                children: [
                    hasChildren ? /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-toggle"],
                        onClick: ()=>setIsExpanded(!isExpanded),
                        type: "button",
                        "aria-label": `Toggle ${stringLabel}`,
                        children: isExpanded ? "\u25bc" : "\u25b6"
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-spacer"]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-type"]} ${(0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))[`mos-ars-tree-node-type-${type}`]}`,
                        children: type
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-label"],
                        children: stringLabel
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-id"],
                        children: id
                    })
                ]
            }),
            hasChildren && isExpanded && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($adjLT)))["mos-ars-tree-node-children"],
                children: subNodes.map((child)=>/*#__PURE__*/ (0, $bbzbN.jsx)($2c7a3db52e84e946$export$81350f32bf958e67, {
                        ...child,
                        defaultExpanded: defaultExpanded
                    }, child.id))
            })
        ]
    });
};
$2c7a3db52e84e946$export$81350f32bf958e67.displayName = "ArsTableTreeNode";

});







parcelRegister("dBJIX", function(module, exports) {

$parcel$export(module.exports, "AnalysisOutputProgrammingCodeControl", function () { return $a5c69a83d26d1a14$export$ef66fa1ea94f6f9b; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");

var $3EZep = parcelRequire("3EZep");
parcelRequire("6yroJ");
var $bdF2Z = parcelRequire("bdF2Z");

var $5zEFB = parcelRequire("5zEFB");
const $a5c69a83d26d1a14$export$ef66fa1ea94f6f9b = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const programmingCode = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $bdF2Z.isAnalysisOutputProgrammingCodeValue));
    /**
   * Handles adding a document reference for the programming code.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && programmingCode && programmingCode.documentRef === undefined) {
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRef`,
                value: newDocumentReference
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/context`,
                id: `${idRoute}-context`,
                label: "Context",
                labelWidth: 2,
                placeholder: "Enter context",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/code`,
                id: `${idRoute}-code`,
                label: "Code",
                labelWidth: 2,
                placeholder: "Enter code",
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 6,
                disabled: disabled
            }),
            programmingCode?.documentRef && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5zEFB.DocumentReferenceControl), {
                dataPath: `${dataPath}/documentRef`,
                disabled: disabled,
                siblingCount: 1
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-document-reference`,
                onClick: handleAddDocumentReference,
                className: "d-flex align-items-center btn-sm btn-success mb-3",
                disabled: disabled || programmingCode?.documentRef !== undefined || programmingCode === undefined,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add document reference"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$a5c69a83d26d1a14$export$ef66fa1ea94f6f9b.displayName = "AnalysisOutputProgrammingCodeControl";

});

parcelRegister("5GCs5", function(module, exports) {

$parcel$export(module.exports, "AnalysisOutputProgrammingCodeParametersControl", function () { return $b816b69de266b247$export$ec04ac7a6b87501f; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4tJ7o = parcelRequire("4tJ7o");
var $gLW8Q = parcelRequire("gLW8Q");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $bdF2Z = parcelRequire("bdF2Z");

var $9iqjg = parcelRequire("9iqjg");
const $b816b69de266b247$export$ec04ac7a6b87501f = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const programmingCode = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $bdF2Z.isAnalysisOutputProgrammingCodeValue));
    const parameters = programmingCode?.parameters ?? [];
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)(parameters.length > 0 ? "parameter-0" : "");
    /**
   * Handles adding an analysis output code parameter.
   */ const handleAddParameter = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && programmingCode) {
            const parameterCount = parameters.length;
            const newParameter = {
                name: `Parameter_${parameterCount + 1}`,
                label: `Parameter ${parameterCount + 1}`,
                description: "",
                value: []
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/parameters/${parameterCount}`,
                value: newParameter
            });
        }
    };
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $7fPBF.useEffectEvent)((newTab)=>(0, $7fPBF.startTransition)(async ()=>setActiveTab(newTab)));
    /** Move tabs */ (0, $7fPBF.useEffect)(()=>{
        if (parseInt(activeTab.split("-")[1], 10) >= parameters.length) updateActiveTab(parameters.length > 0 ? "parameter-0" : "");
        else if (activeTab === "" && parameters.length > 0) updateActiveTab("parameter-0");
    }, [
        parameters.length,
        activeTab
    ]);
    const idRoute = dataPath.replace(/\//g, "-") + "-parameters";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Container, {
        activeKey: activeTab,
        onSelect: (k)=>{
            /* istanbul ignore else */ if (k) setActiveTab(k);
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default), {
                variant: "tabs",
                className: "mb-3",
                children: parameters.map((parameter, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                            eventKey: `parameter-${index}`,
                            children: parameter.name
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Content, {
                children: parameters.map((parameter, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                        eventKey: `parameter-${index}`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9iqjg.AnalysisOutputCodeParameterControl), {
                            dataPath: `${dataPath}/parameters/${index}`,
                            disabled: disabled,
                            siblingCount: parameters.length
                        }, `${parameter.name}-${index}`)
                    }, index))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: `${idRoute}-add-parameter`,
                onClick: handleAddParameter,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled || programmingCode === undefined,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "me-2",
                        children: "Add parameter"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                ]
            })
        ]
    });
};
$b816b69de266b247$export$ec04ac7a6b87501f.displayName = "AnalysisOutputProgrammingCodeParametersControl";

});
parcelRegister("9iqjg", function(module, exports) {

$parcel$export(module.exports, "AnalysisOutputCodeParameterControl", function () { return $0edea2710f4147d1$export$f621922ff05ed0e1; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("0PqYf");
var $3EZep = parcelRequire("3EZep");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");
const $0edea2710f4147d1$export$f621922ff05ed0e1 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                dataPath: dataPath,
                canRename: true,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                dataPath: `${dataPath}/value`,
                id: `${idRoute}-value`,
                label: "Value(s)",
                labelWidth: 2,
                placeholder: "Enter one value per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            })
        ]
    });
};
$0edea2710f4147d1$export$f621922ff05ed0e1.displayName = "AnalysisOutputCodeParameterControl";

});



parcelRegister("9ijW6", function(module, exports) {

$parcel$export(module.exports, "AnalysisSetControl", function () { return $32d735dc2f60ea1a$export$50ac7856e9864cb8; });

var $bbzbN = parcelRequire("bbzbN");

var $8d4Ob = parcelRequire("8d4Ob");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $gzOGG = parcelRequire("gzOGG");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");

var $h9QS8 = parcelRequire("h9QS8");
const $32d735dc2f60ea1a$export$50ac7856e9864cb8 = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    const analysisSet = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $gzOGG.isAnalysisSet));
    // Disable editing for parent templates
    if (analysisSet?.disableEditing) disabled = true;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                        children: [
                            "Id: ",
                            dataPath.split("/").pop()
                        ]
                    })
                })
            }),
            canRename && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                dataPath: dataPath,
                canRename: canRename,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h9QS8.WhereClauseManager), {
                dataPath: dataPath,
                disabled: disabled
            })
        ]
    });
};
$32d735dc2f60ea1a$export$50ac7856e9864cb8.displayName = "AnalysisSetControl";

});
parcelRegister("h9QS8", function(module, exports) {

$parcel$export(module.exports, "WhereClauseManager", function () { return $462fbc6c36c8ae06$export$d4fb6a65856f09b4; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $b6fw7 = parcelRequire("b6fw7");
var $euDav = parcelRequire("euDav");

var $k2m6c = parcelRequire("k2m6c");
var $cnmTv = parcelRequire("cnmTv");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $6Ugly = parcelRequire("6Ugly");

var $k7ogs = parcelRequire("k7ogs");

var $e5Poo = parcelRequire("e5Poo");

var $bNdmh = parcelRequire("bNdmh");
const $462fbc6c36c8ae06$export$d4fb6a65856f09b4 = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    // Get the current entity from state
    const whereClause = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $6Ugly.isWhereClause));
    const idPath = `${dataPath.replace(/\//g, "-")}`;
    return !whereClause ? /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: "text-danger",
        children: [
            "Entity not found at path: ",
            dataPath
        ]
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).compactContainer,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
                        id: `${idPath}-toggle-expand`,
                        onClick: ()=>setIsExpanded(!isExpanded),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).toggleButton,
                        variant: "link",
                        size: "sm",
                        "aria-label": isExpanded ? "Collapse" : "Expand",
                        disabled: disabled,
                        children: isExpanded ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k2m6c.default), {
                            size: 16
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cnmTv.default), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-grow-1",
                        style: {
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bNdmh.WhereClauseInput), {
                            dataPath: dataPath,
                            disabled: disabled
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $euDav.default), {
                in: isExpanded,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e5Poo.WhereClauseEditor), {
                        dataPath: dataPath,
                        disabled: disabled
                    })
                })
            })
        ]
    });
};
$462fbc6c36c8ae06$export$d4fb6a65856f09b4.displayName = "WhereClauseManager";

});
parcelRegister("k7ogs", function(module, exports) {

$parcel$export(module.exports, "actionButtons", function () { return $ea574882bfa90bcf$export$b6fb1741c7f64881; }, function (v) { return $ea574882bfa90bcf$export$b6fb1741c7f64881 = v; });
$parcel$export(module.exports, "codeBlock", function () { return $ea574882bfa90bcf$export$7bb0d5c671655cc4; }, function (v) { return $ea574882bfa90bcf$export$7bb0d5c671655cc4 = v; });
$parcel$export(module.exports, "compactContainer", function () { return $ea574882bfa90bcf$export$5613def557f780e6; }, function (v) { return $ea574882bfa90bcf$export$5613def557f780e6 = v; });
$parcel$export(module.exports, "toggleButton", function () { return $ea574882bfa90bcf$export$c3f9788a1ddcf2d9; }, function (v) { return $ea574882bfa90bcf$export$c3f9788a1ddcf2d9 = v; });
$parcel$export(module.exports, "validationText", function () { return $ea574882bfa90bcf$export$82d15ec6f07228ea; }, function (v) { return $ea574882bfa90bcf$export$82d15ec6f07228ea = v; });
var $ea574882bfa90bcf$export$b6fb1741c7f64881;
var $ea574882bfa90bcf$export$7bb0d5c671655cc4;
var $ea574882bfa90bcf$export$5613def557f780e6;
var $ea574882bfa90bcf$export$c3f9788a1ddcf2d9;
var $ea574882bfa90bcf$export$82d15ec6f07228ea;
$ea574882bfa90bcf$export$b6fb1741c7f64881 = `mos-WhereClauseConditionItemControl-module-tdtjtq-actionButtons`;
$ea574882bfa90bcf$export$7bb0d5c671655cc4 = `mos-WhereClauseConditionItemControl-module-tdtjtq-codeBlock`;
$ea574882bfa90bcf$export$5613def557f780e6 = `mos-WhereClauseConditionItemControl-module-tdtjtq-compactContainer`;
$ea574882bfa90bcf$export$c3f9788a1ddcf2d9 = `mos-WhereClauseConditionItemControl-module-tdtjtq-toggleButton`;
$ea574882bfa90bcf$export$82d15ec6f07228ea = `mos-WhereClauseConditionItemControl-module-tdtjtq-validationText`;

});

parcelRegister("e5Poo", function(module, exports) {

$parcel$export(module.exports, "WhereClauseEditor", function () { return $c36d1d63a2ac9108$export$2c5072d85c877532; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("gYROb");
var $7Tnbh = parcelRequire("7Tnbh");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
parcelRequire("6yroJ");
var $5KlUB = parcelRequire("5KlUB");
var $6Ugly = parcelRequire("6Ugly");
var $kC2sO = parcelRequire("kC2sO");
var $jc9tE = parcelRequire("jc9tE");

var $kLYcB = parcelRequire("kLYcB");

var $8lrKZ = parcelRequire("8lrKZ");

var $gDWp8 = parcelRequire("gDWp8");
const $c36d1d63a2ac9108$export$2c5072d85c877532 = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [isPending, startTransition] = (0, $7fPBF.useTransition)();
    // Get the current entity from state
    const whereClause = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $6Ugly.isWhereClause));
    const condition = (0, $jc9tE.isWhereClauseWithCondition)(whereClause) ? whereClause.condition : undefined;
    const ce = (0, $kC2sO.isWhereClauseWithCompoundExpression)(whereClause) ? whereClause.compoundExpression : undefined;
    const hasCondition = condition !== undefined;
    const whereClauseCount = hasCondition ? 1 : ce?.whereClauses?.length ?? 0;
    const refClauseCount = ce?.whereClauses?.filter((clause)=>(0, $5KlUB.isSubClauseWithReference)(clause)).length ?? 0;
    /**
   * Handles NOT checkbox change.
   * Dispatches ADD_NOT_TO_WHERE_CLAUSE when checked, or REMOVE_NOT_FROM_WHERE_CLAUSE when unchecked.
   *
   * @param event - The checkbox change event.
   */ const handleNotCheckboxChange = (event)=>{
        startTransition(()=>{
            if (event.target.checked) dispatch({
                operation: (0, $cIJV5.ADD_NOT_TO_WHERE_CLAUSE),
                dataPath: dataPath
            });
            else dispatch({
                operation: (0, $cIJV5.REMOVE_NOT_FROM_WHERE_CLAUSE),
                dataPath: dataPath
            });
        });
    };
    /**
   * Handles adding a new where clause.
   * Converts single condition to compound expression if needed.
   */ const handleAddClause = ()=>{
        startTransition(()=>{
            dispatch({
                operation: (0, $cIJV5.ADD_EXTRA_WHERE_CLAUSE),
                dataPath: dataPath,
                newLength: whereClauseCount + 1
            });
        });
    };
    /**
   * Handles drag-end event for reordering clauses.
   *
   * @param event - The drag end event from dnd-kit.
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore else */ if (over !== null && over.id !== active.id && ce) {
            const whereClauses = ce.whereClauses ?? // istanbul ignore next
            [];
            const oldIndex = whereClauses.findIndex((clause)=>clause.id === active.id);
            const newIndex = whereClauses.findIndex((clause)=>clause.id === over.id);
            // Reorder the array
            const reorderedClauses = [
                ...whereClauses
            ];
            const [movedClause] = reorderedClauses.splice(oldIndex, 1);
            reorderedClauses.splice(newIndex, 0, movedClause);
            // Update order properties
            const updatedClauses = reorderedClauses.map((clause, index)=>({
                    ...clause,
                    order: index
                }));
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/compoundExpression/whereClauses`,
                value: updatedClauses
            });
        }
    };
    return !whereClause ? /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: "text-danger",
        children: [
            "Entity not found at path: ",
            dataPath
        ]
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            whereClauseCount <= 1 ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "d-flex align-items-center",
                style: {
                    height: "32px"
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                        className: "form-check-label",
                        htmlFor: `${dataPath.replace(/\//g, "-")}-not-checkbox`,
                        children: "NOT"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        type: "checkbox",
                        className: "form-check-input ms-2",
                        id: `${dataPath.replace(/\//g, "-")}-not-checkbox`,
                        checked: ce?.logicalOperator === "NOT",
                        disabled: disabled,
                        onChange: handleNotCheckboxChange
                    })
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "d-flex align-items-center",
                style: {
                    height: "32px"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                    className: "form-select form-select-sm w-auto",
                    id: `${dataPath.replace(/\//g, "-")}-logical-operator-select`,
                    disabled: disabled,
                    onChange: (ret)=>{
                        dispatch({
                            operation: (0, $cIJV5.PATCH_ARS_STATE),
                            dataPath: `${dataPath}/compoundExpression/logicalOperator`,
                            value: ret.currentTarget.value
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                            value: (0, $1cA0K.ExpressionLogicalOperatorEnum).AND,
                            children: "AND"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                            value: (0, $1cA0K.ExpressionLogicalOperatorEnum).OR,
                            children: "OR"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7Tnbh.SortableListHolder), {
                canMove: !disabled,
                handleDragEnd: handleDragEnd,
                showBorder: false,
                items: hasCondition ? [
                    {
                        id: "single-condition",
                        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gDWp8.WhereClauseConditionItemControl), {
                            dataPath: `${dataPath}/condition`,
                            disabled: disabled
                        })
                    }
                ] : (ce?.whereClauses ?? // istanbul ignore next
                []).map((clause, ix)=>({
                        id: clause.id,
                        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8lrKZ.SubClauseItemControl), {
                            isRemovable: whereClauseCount - refClauseCount > 1,
                            dataPath: `${dataPath}/compoundExpression/whereClauses/${ix}`,
                            disabled: disabled
                        })
                    }))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kLYcB.AddWhereClauseButton), {
                id: `${dataPath.replace(/\//g, "-")}-add-clause-button`,
                onClick: handleAddClause,
                isPending: isPending,
                disabled: disabled
            })
        ]
    });
};
$c36d1d63a2ac9108$export$2c5072d85c877532.displayName = "WhereClauseEditor";

});
parcelRegister("8lrKZ", function(module, exports) {

$parcel$export(module.exports, "SubClauseItemControl", function () { return $c2886ab61a0534af$export$f2f4d85386f16cde; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $eAPMz = parcelRequire("eAPMz");
var $5KlUB = parcelRequire("5KlUB");
var $kupca = parcelRequire("kupca");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $gl7IP = parcelRequire("gl7IP");

var $fAJMp = parcelRequire("fAJMp");

var $cNv0d = parcelRequire("cNv0d");

var $gDWp8 = parcelRequire("gDWp8");

var $e5Poo = parcelRequire("e5Poo");
const $c2886ab61a0534af$export$f2f4d85386f16cde = ({ dataPath: dataPath, isRemovable: isRemovable = false, disabled: disabled = false })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    // Get the sub-clause from state
    const subClause = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $gl7IP.isSubClause));
    return (0, $fAJMp.isSubClauseWithCompoundExpression)(subClause) ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        style: {
            paddingLeft: "1rem",
            borderLeft: "2px solid #dee2e6"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e5Poo.WhereClauseEditor), {
            dataPath: dataPath,
            disabled: disabled
        })
    }) : (0, $cNv0d.isSubClauseWithCondition)(subClause) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gDWp8.WhereClauseConditionItemControl), {
        dataPath: `${dataPath}/condition`,
        isRemovable: isRemovable,
        disabled: disabled
    }) : (0, $5KlUB.isSubClauseWithReference)(subClause) ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kupca.ReferencedEntityControl), {
            dataPath: `${dataPath}/subClauseId`,
            entityType: "DataSubset",
            disabled: disabled
        })
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: "text-danger",
        children: [
            "SubClause not found at path: ",
            dataPath
        ]
    });
};
$c2886ab61a0534af$export$f2f4d85386f16cde.displayName = "SubClauseItemControl";

});
parcelRegister("gDWp8", function(module, exports) {

$parcel$export(module.exports, "WhereClauseConditionItemControl", function () { return $8aa9400323e4e05e$export$e47a210cc0c53b08; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $fQHYQ = parcelRequire("fQHYQ");
var $eAPMz = parcelRequire("eAPMz");

var $7fPBF = parcelRequire("7fPBF");

var $b6fw7 = parcelRequire("b6fw7");
var $euDav = parcelRequire("euDav");
var $8d4Ob = parcelRequire("8d4Ob");

var $6QORW = parcelRequire("6QORW");
var $k2m6c = parcelRequire("k2m6c");
var $cnmTv = parcelRequire("cnmTv");
var $jVHe9 = parcelRequire("jVHe9");
var $2jFYR = parcelRequire("2jFYR");
var $6dv4K = parcelRequire("6dv4K");

var $cqVqv = parcelRequire("cqVqv");

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $h7VrC = parcelRequire("h7VrC");

var $3EZep = parcelRequire("3EZep");

var $eUQaa = parcelRequire("eUQaa");

var $gl7IP = parcelRequire("gl7IP");

var $cNv0d = parcelRequire("cNv0d");

var $3GY9d = parcelRequire("3GY9d");

var $470Zy = parcelRequire("470Zy");

var $3pTyh = parcelRequire("3pTyh");

var $k7ogs = parcelRequire("k7ogs");
const $8aa9400323e4e05e$export$e47a210cc0c53b08 = ({ dataPath: dataPath, isRemovable: isRemovable = false, disabled: disabled = false, ...rest })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [isExpanded, setIsExpanded] = (0, $7fPBF.useState)(false);
    const [isEditing, setIsEditing] = (0, $7fPBF.useState)(false);
    const [editValue, setEditValue] = (0, $7fPBF.useState)("");
    const cancelRef = (0, $7fPBF.useRef)(false);
    const subClausePath = dataPath.endsWith("/condition") ? dataPath.substring(0, dataPath.lastIndexOf("/condition")) : "";
    const subClause = (0, $eAPMz.getFromDataPath)(subClausePath, state, (0, $cNv0d.isSubClauseWithCondition));
    const canSwapToReference = subClause !== undefined;
    // Get the condition from state
    const whereClauseCondition = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $3GY9d.isWhereClauseCondition));
    const thisId = (0, $eAPMz.getFromDataPath)(dataPath.substring(0, dataPath.lastIndexOf("/")), state, (0, $gl7IP.isSubClause))?.id ?? "";
    const groupComparator = whereClauseCondition?.comparator === (0, $1cA0K.ConditionComparatorEnum).IN || whereClauseCondition?.comparator === (0, $1cA0K.ConditionComparatorEnum).NOTIN;
    // Convert comparators enum to options for ArsSelect
    const comparatorOptions = state.comparators.map((comp)=>({
            value: comp,
            label: comp
        }));
    // Compact mode with toggle (default view)
    const compactCode = (0, $470Zy.formatConditionAsCode)(whereClauseCondition, state.variables);
    // Get available variables for validation
    const availableVariables = state.variables.map((v)=>v.value);
    // Validate current edit value
    const parsedCondition = isEditing && editValue ? (0, $3pTyh.parseConditionFromCode)(editValue, availableVariables) : undefined;
    const isValid = parsedCondition !== false;
    const isInvalid = isEditing && editValue.length > 0 && !isValid;
    // Focus effect - focus input when entering edit mode
    (0, $7fPBF.useEffect)(()=>{
        if (isEditing) {
            const input = document.getElementById(`${dataPath.replace(/\//g, "-")}-edit-input`);
            /* istanbul ignore else -- Input element should always be present in edit mode */ if (input) input.focus();
        }
    }, [
        isEditing,
        dataPath
    ]);
    /**
   * Handles entering edit mode.
   */ const handleStartEdit = ()=>{
        setEditValue(compactCode);
        setIsEditing(true);
        cancelRef.current = false;
    };
    /**
   * Saves the changes to the condition.
   *
   * @param value - The value to save
   */ const saveChanges = (value)=>{
        const parsed = (0, $3pTyh.parseConditionFromCode)(value, availableVariables);
        if (parsed) dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: dataPath,
            value: parsed.condition
        });
        setIsEditing(false);
    };
    /**
   * Handles key down events in edit mode.
   *
   * @param e - Keyboard event.
   */ const handleKeyDown = (e)=>{
        /* istanbul ignore else -- Handler only processes keys in edit mode */ if (isEditing) {
            if (e.key === "Escape") {
                e.preventDefault();
                e.stopPropagation();
                cancelRef.current = true;
                /* istanbul ignore else -- Event target should always be an HTMLElement */ if (e.target instanceof HTMLElement) e.target.blur();
            } else if (e.key === "Enter") {
                e.preventDefault();
                /* istanbul ignore else -- Event target should always be an HTMLElement */ if (e.target instanceof HTMLElement) e.target.blur();
            }
        }
    };
    /**
   * Handles the blur event for the input field.
   * Saves changes if the blur was not caused by a cancel action.
   *
   * @param e - The focus event from the blur.
   */ const handleBlur = (e)=>{
        if (cancelRef.current) {
            // Canceling - revert to original value
            setEditValue(compactCode);
            cancelRef.current = false;
            setIsEditing(false);
        } else if (isEditing) {
            // Get the actual input value from the event target to avoid stale state closures
            const inputElement = e.target;
            saveChanges(inputElement.value);
        }
    };
    /**
   * Handles removing a where clause.
   * Reverts to single condition if only 2 clauses remain.
   */ const handleRemoveClause = ()=>{
        const parentPath = dataPath.substring(0, dataPath.lastIndexOf("/compoundExpression/whereClauses/"));
        dispatch({
            operation: (0, $cIJV5.REMOVE_WHERE_CLAUSE),
            dataPath: parentPath,
            id: thisId
        });
    };
    /**
   * Handles swapping a condition clause to a referenced entity.
   */ const handleSwapToReference = ()=>{
        /* istanbul ignore else */ if (subClause && subClausePath) dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: subClausePath,
            value: {
                id: subClause.id,
                level: subClause.level,
                order: subClause.order,
                subClauseId: "-- None --"
            }
        });
    };
    /**
   * Converts the current SubClauseWithCondition into a SubClauseWithCompoundExpression.
   */ const handleSwapToCompound = ()=>{
        dispatch({
            operation: (0, $cIJV5.ADD_EXTRA_WHERE_CLAUSE),
            dataPath: subClausePath,
            newLength: 2
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).compactContainer,
                onKeyDownCapture: handleKeyDown,
                onBlur: handleBlur,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
                        id: `${dataPath.replace(/\//g, "-")}-toggle-expand`,
                        onClick: ()=>setIsExpanded(!isExpanded),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).toggleButton,
                        variant: "link",
                        size: "sm",
                        "aria-label": isExpanded ? "Collapse" : "Expand",
                        disabled: isEditing || disabled,
                        children: isExpanded ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k2m6c.default), {
                            size: 16
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cnmTv.default), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-grow-1",
                        style: {
                            minWidth: 0
                        },
                        children: !isEditing ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "form-control form-control-sm",
                            style: {
                                border: "none"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).codeBlock,
                                onClick: ()=>setIsExpanded(!isExpanded),
                                children: compactCode || /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: "text-muted",
                                    children: "No condition defined"
                                })
                            })
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fQHYQ.ControlBase), {
                                id: `${dataPath.replace(/\//g, "-")}-edit-input`,
                                "aria-label": "Enter condition",
                                disabled: disabled,
                                autoFocus: isEditing,
                                value: editValue,
                                whiteSpaceFix: true,
                                setValue: setEditValue,
                                spellCheck: false,
                                className: (0, $cqVqv.classMerge)([
                                    isEditing && isValid && editValue.length > 0 ? "is-valid" : isInvalid ? "is-invalid" : ""
                                ])
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).actionButtons,
                        children: !isEditing && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6QORW.default), {
                                    id: `${dataPath.replace(/\//g, "-")}-swap`,
                                    className: canSwapToReference ? "text-primary" : "text-muted",
                                    role: "button",
                                    "aria-label": "Swap to reference",
                                    "aria-disabled": !canSwapToReference || disabled,
                                    onClick: canSwapToReference && !disabled ? handleSwapToReference : undefined,
                                    style: {
                                        cursor: canSwapToReference && !disabled ? "pointer" : "not-allowed"
                                    }
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2jFYR.default), {
                                    id: `${dataPath.replace(/\//g, "-")}-edit`,
                                    className: (0, $cqVqv.classMerge)([
                                        `text-primary`
                                    ]),
                                    role: "button",
                                    "aria-label": "Edit condition",
                                    "aria-disabled": disabled,
                                    onClick: disabled ? undefined : handleStartEdit
                                }),
                                isRemovable && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jVHe9.default), {
                                    id: `${dataPath.replace(/\//g, "-")}-remove`,
                                    className: "text-danger",
                                    role: "button",
                                    "aria-label": `Remove clause`,
                                    "aria-disabled": disabled,
                                    onClick: disabled ? undefined : ()=>handleRemoveClause(),
                                    style: {
                                        cursor: disabled ? "not-allowed" : "pointer"
                                    }
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                style: {
                    height: isEditing ? "1.5em" : 0,
                    minHeight: isEditing ? "1.5em" : 0,
                    transition: "height 0.2s ease, min-height 0.2s ease"
                },
                className: (0, $cqVqv.classMerge)([
                    isValid && editValue.length > 0 ? "valid-feedback" : isInvalid ? "invalid-feedback" : "text-muted",
                    (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).validationText
                ]),
                children: isValid && editValue.length > 0 ? "Valid condition" : isInvalid ? "Invalid condition format" : ""
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $euDav.default), {
                in: isExpanded,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eUQaa.ArsVariable), {
                            datasetDataPath: `${dataPath}/dataset`,
                            variableDataPath: `${dataPath}/variable`,
                            id: `${dataPath.replace(/\//g, "-")}-variable`,
                            label: "Variable",
                            placeHolder: "Select dataset and variable",
                            disabled: isEditing || disabled
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                            dataPath: `${dataPath}/comparator`,
                            id: `${dataPath.replace(/\//g, "-")}-comparator`,
                            label: "Comparator",
                            options: comparatorOptions,
                            disabled: isEditing || disabled
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                            dataPath: `${dataPath}/value`,
                            isArray: true,
                            id: `${dataPath.replace(/\//g, "-")}-value`,
                            label: groupComparator ? "Values" : "Value",
                            type: "textarea",
                            rows: groupComparator ? 3 : 1,
                            placeholder: "Enter values (one per line)",
                            allowCarriageReturn: true,
                            disabled: isEditing || disabled
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                            "aria-label": "Add nested clause",
                            className: "mt-2 d-flex align-items-center",
                            disabled: disabled,
                            id: `${dataPath.replace(/\//g, "-")}-to-compound-expression`,
                            onClick: handleSwapToCompound,
                            size: "sm",
                            variant: "success",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: "me-2",
                                    children: "Add nested clause"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
$8aa9400323e4e05e$export$e47a210cc0c53b08.displayName = "WhereClauseConditionItemControl";

});
parcelRegister("6QORW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fcf0eee2c600730$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $4fcf0eee2c600730$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $4fcf0eee2c600730$var$_extends() {
    return $4fcf0eee2c600730$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4fcf0eee2c600730$var$_extends.apply(null, arguments);
}
function $4fcf0eee2c600730$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4fcf0eee2c600730$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4fcf0eee2c600730$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4fcf0eee2c600730$var$ArrowLeftRight = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $4fcf0eee2c600730$var$_objectWithoutProperties(_ref, $4fcf0eee2c600730$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $4fcf0eee2c600730$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-left-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
    }));
});
$4fcf0eee2c600730$var$ArrowLeftRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $4fcf0eee2c600730$export$2e2bcd8739ae039 = $4fcf0eee2c600730$var$ArrowLeftRight;

});

parcelRegister("470Zy", function(module, exports) {

$parcel$export(module.exports, "formatConditionAsCode", function () { return $b2ee2aa83987abb3$export$416fe34beaf1829a; });

var $1cA0K = parcelRequire("1cA0K");

var $3pTyh = parcelRequire("3pTyh");
const $b2ee2aa83987abb3$export$416fe34beaf1829a = (condition, availableVariables)=>{
    if (!condition || !condition.dataset || !condition.variable) return "";
    const dataset = condition.dataset;
    const variable = condition.variable;
    // Determine comparator enum (default to EQ)
    const compEnum = condition.comparator ?? (0, $1cA0K.ConditionComparatorEnum).EQ;
    // Default to empty array when value is undefined (provably unreachable in normal operation)
    const values = condition.value ?? // istanbul ignore next
    [];
    const displayComparator = (0, $3pTyh.comparatorDefinitions)[compEnum] ? (0, $3pTyh.comparatorDefinitions)[compEnum].write : compEnum;
    if (values.length === 0) return `${dataset}.${variable} ${displayComparator} ?`;
    // Find the variable in the available list to determine its dataType
    const variableKey = `${dataset}.${variable}`;
    const variableInfo = availableVariables?.find((v)=>v.value === variableKey);
    const isNumeric = variableInfo?.dataType?.toLowerCase() === "integer" || variableInfo?.dataType?.toLowerCase() === "float" || variableInfo?.dataType?.toLowerCase() === "numeric" || variableInfo?.dataType?.toLowerCase() === "number" || !variableInfo && !isNaN(Number(values[0])); // Fallback: if variable info is not available, check if value is numeric
    /**
   * Formats a single value with or without quotes based on dataType.
   *
   * @param v - The value to format.
   * @returns The formatted value.
   */ const formatValue = (v)=>{
        return isNumeric ? v : `'${v}'`;
    };
    // Format values based on comparator
    if (compEnum === (0, $1cA0K.ConditionComparatorEnum).IN || compEnum === (0, $1cA0K.ConditionComparatorEnum).NOTIN) {
        const formattedValues = values.map(formatValue).join(", ");
        const compString = compEnum === (0, $1cA0K.ConditionComparatorEnum).NOTIN ? "NOT IN" : "IN";
        return `${dataset}.${variable} ${compString} (${formattedValues})`;
    }
    // Single value comparators
    const value = values[0];
    return `${dataset}.${variable} ${displayComparator} ${formatValue(value)}`;
};

});




parcelRegister("bNdmh", function(module, exports) {

$parcel$export(module.exports, "WhereClauseInput", function () { return $7b376540111c47a1$export$220896b0b25e2f48; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $fQHYQ = parcelRequire("fQHYQ");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");

var $2jFYR = parcelRequire("2jFYR");

var $0Wjqu = parcelRequire("0Wjqu");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");

var $cqVqv = parcelRequire("cqVqv");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");
parcelRequire("6yroJ");
var $6Ugly = parcelRequire("6Ugly");

var $4yc3n = parcelRequire("4yc3n");

var $hp2BB = parcelRequire("hp2BB");

var $ecq7a = parcelRequire("ecq7a");

var $k7ogs = parcelRequire("k7ogs");
/**
 * Extracts the last contiguous variable-name token from the end of a string.
 * A token is a sequence of alphanumeric characters, underscores, and dots.
 *
 * @param value - The input string to extract the last token from
 * @returns The last token, or an empty string if none found
 */ const $7b376540111c47a1$var$getLastToken = (value)=>/[A-Za-z0-9_.]+$/.exec(value)?.[0] ?? "";
/**
 * Replaces the last variable-name token in a string with a replacement and appends a space.
 * Uses a `*`-quantifier so the regex always matches, handling both cases (token present
 * or absent) without branching: when no token exists an empty string is replaced, which
 * has the same effect as appending the replacement.
 *
 * @param inputValue - The current input string
 * @param replacement - The string to replace the last token with
 * @returns The updated string with the token replaced and a trailing space appended
 */ const $7b376540111c47a1$var$replaceLastToken = (inputValue, replacement)=>inputValue.replace(/[A-Za-z0-9_.]*$/, `${replacement} `);
const $7b376540111c47a1$export$220896b0b25e2f48 = ({ dataPath: dataPath, disabled: disabled = false, onChange: onChange })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [isEditing, setIsEditing] = (0, $7fPBF.useState)(false);
    const cancelRef = (0, $7fPBF.useRef)(false);
    const wrapperRef = (0, $7fPBF.useRef)(null);
    const [currentValue, setCurrentValue] = (0, $7fPBF.useState)("");
    const [selectedIndex, setSelectedIndex] = (0, $7fPBF.useState)(-1);
    /** The token value for which the dropdown was explicitly closed by the user */ const [closedForToken, setClosedForToken] = (0, $7fPBF.useState)(null);
    const whereClause = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $6Ugly.isWhereClause));
    const compactCode = whereClause ? (0, $hp2BB.formatWhereClauseAsCode)(whereClause, state.variables) : "";
    const availableVariables = state.variables.map((variable)=>variable.value);
    const valueToValidate = isEditing ? currentValue : compactCode;
    const parsedWhereClauseResult = valueToValidate.length > 0 ? (0, $ecq7a.parseWhereClauseFromCode)(valueToValidate, availableVariables, Object.keys(state.dataSubsets)) : false;
    const isValid = parsedWhereClauseResult !== false;
    const isWarning = parsedWhereClauseResult && parsedWhereClauseResult.acceptedUnlistedVariable;
    const isInvalid = isEditing && currentValue.length > 0 && !isValid;
    // Get the last variable-like token being typed (e.g. "ADSL.AG" from "x = 1 AND ADSL.AG")
    const lastToken = $7b376540111c47a1$var$getLastToken(currentValue);
    // Filter available variables matching the last token (requires 3+ chars)
    const filteredVariables = lastToken.length >= 3 ? state.variables.filter((v)=>v.value.toLowerCase().includes(lastToken.toLowerCase())) : [];
    // Show dropdown when matches exist and the user has not explicitly closed it for this token
    const isDropdownOpen = filteredVariables.length > 0 && closedForToken !== lastToken;
    // Build dropdown items from the filtered variable list
    const inputId = `${dataPath.replace(/\//g, "-")}-edit-input`;
    const dropdownItems = filteredVariables.map((v, i)=>({
            id: `${inputId}-var-${i}`,
            text: v.value
        }));
    /**
   * Enters edit mode and initialises the editable value.
   */ const handleStartEdit = ()=>{
        setCurrentValue(compactCode);
        setIsEditing(true);
        cancelRef.current = false;
        setSelectedIndex(-1);
        setClosedForToken(null);
    };
    /**
   * Saves edits back into ARS state when parsing succeeds.
   *
   * @param value - Edited where clause code
   */ const saveChanges = (value)=>{
        // handle onChange first
        if (onChange) {
            if (value.trim() === "") onChange(null);
            else {
                const parsed = (0, $ecq7a.parseWhereClauseFromCode)(value, availableVariables, Object.keys(state.dataSubsets));
                if (parsed) onChange(parsed.whereClause);
            }
            setIsEditing(false);
            return;
        }
        // handle dispatch changes - include non-WhereClause properties to avoid overwriting them
        const parsed = (0, $ecq7a.parseWhereClauseFromCode)(value, availableVariables, Object.keys(state.dataSubsets));
        // Replace valid or blank clauses
        if (parsed || value.trim() === "") {
            const newValue = {
                ...(0, $gSkQi.omit)(whereClause, [
                    "compoundExpression",
                    "condition"
                ]),
                ...parsed ? parsed.whereClause : {
                    level: 0,
                    order: 0,
                    condition: {
                        dataset: "",
                        variable: ""
                    }
                }
            };
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: dataPath,
                value: newValue
            });
        }
        setIsEditing(false);
    };
    /**
   * Signals that edit mode should cancel on blur.
   */ const handleCancelEdit = ()=>{
        cancelRef.current = true;
    };
    /**
   * Handles blur for commit/cancel behaviour.
   *
   * @param e - The focus event from blur.
   */ const handleBlur = (e)=>{
        /* istanbul ignore else -- Blur should only occur while editing */ if (cancelRef.current) {
            setCurrentValue(compactCode);
            cancelRef.current = false;
            setIsEditing(false);
        } else if (isEditing) {
            const inputElement = e.target;
            saveChanges(inputElement.value);
        }
    };
    /**
   * Intercepts the setValue callback from ControlBase to keep local currentValue in sync,
   * then updates local edit state.
   *
   * @param newValue - The new value reported by ControlBase
   */ const handleSetValue = (newValue)=>{
        const parsed = (0, $ecq7a.parseWhereClauseFromCode)(newValue, availableVariables, Object.keys(state.dataSubsets));
        if (parsed || newValue.length === 0) setCurrentValue(newValue);
    };
    /**
   * Tracks the input value on every keystroke so the dropdown can update in real time,
   * without waiting for ControlBase to fire its debounced setValue callback.
   *
   * @param e - The change event bubbling up from the inner input element
   */ const handleChangeCapture = (e)=>{
        /* istanbul ignore else -- The only child is a ControlBase input, so target is always HTMLInputElement */ if (e.target instanceof HTMLInputElement) setCurrentValue(e.target.value);
    };
    /**
   * Inserts a selected variable into the input by replacing the last token,
   * appending a trailing space, and resetting dropdown state.
   * Reads the current DOM value directly to avoid stale debounced state.
   *
   * @param variable - The variable string to insert into the input
   */ const insertVariable = (variable)=>{
        const inputEl = wrapperRef.current?.querySelector("input");
        const inputValue = inputEl?.value ?? // istanbul ignore next -- Unreachable: wrapperRef always contains an input when this function is called
        currentValue;
        const newValue = $7b376540111c47a1$var$replaceLastToken(inputValue, variable);
        setCurrentValue(newValue);
        setSelectedIndex(-1);
        setClosedForToken(null);
    };
    /**
   * Handles keyboard events in the capture phase to intercept navigation keys.
   *
   * When the dropdown is open:
   * - ArrowDown / ArrowUp: navigate the highlighted item
   * - Enter: insert the highlighted variable (or close dropdown if none highlighted)
   * - Escape: close the dropdown and reset selection
   *
   * When the dropdown is closed:
   * - Enter: blur the input to trigger save in the parent
   * - Escape: call onCancel then blur the input to trigger cancel in the parent
   *
   * @param e - The keyboard event from the capture phase
   */ const handleKeyDown = (e)=>{
        /* istanbul ignore else -- Handler only fires on keyboard events within the wrapper */ if (isDropdownOpen) switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                setSelectedIndex((prev)=>Math.min(prev + 1, dropdownItems.length - 1));
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                setSelectedIndex((prev)=>Math.max(prev - 1, 0));
                break;
            case "Enter":
            case "Tab":
                e.preventDefault();
                e.stopPropagation();
                if (selectedIndex >= 0 && selectedIndex < dropdownItems.length) insertVariable(dropdownItems[selectedIndex].text);
                else setClosedForToken(lastToken);
                break;
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                setClosedForToken(lastToken);
                setSelectedIndex(-1);
                break;
        }
        else switch(e.key){
            case "Enter":
                e.preventDefault();
                e.stopPropagation();
                /* istanbul ignore else -- Event target is always an HTMLElement in this context */ if (e.target instanceof HTMLElement) e.target.blur();
                break;
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                handleCancelEdit();
                /* istanbul ignore else -- Event target is always an HTMLElement in this context */ if (e.target instanceof HTMLElement) e.target.blur();
                break;
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        onBlur: handleBlur,
        children: [
            !isEditing ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).actionButtons,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                            id: `${dataPath.replace(/\//g, "-")}-edit`,
                            type: "button",
                            className: "btn btn-link p-0 border-0 text-primary",
                            "aria-label": "Edit where clause",
                            disabled: disabled,
                            onClick: disabled ? undefined : handleStartEdit,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2jFYR.default), {
                                "aria-hidden": "true"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "form-control form-control-sm",
                        style: {
                            border: "none"
                        },
                        onDoubleClick: disabled ? undefined : handleStartEdit,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).codeBlock,
                            children: compactCode || /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "text-muted",
                                children: "No where clause defined"
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                ref: wrapperRef,
                onKeyDownCapture: handleKeyDown,
                onChangeCapture: handleChangeCapture,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fQHYQ.ControlBase), {
                        id: inputId,
                        "aria-label": "Enter where clause",
                        disabled: disabled,
                        autoFocus: isEditing,
                        value: currentValue,
                        setValue: handleSetValue,
                        spellCheck: false,
                        debounceMilliseconds: 250,
                        className: (0, $cqVqv.classMerge)([
                            isWarning ? "is-warning" : isValid && currentValue.length > 0 ? "is-valid" : isInvalid ? "is-invalid" : ""
                        ]),
                        whiteSpaceFix: true
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0Wjqu.DropdownPortal), {
                        isOpen: isDropdownOpen && !disabled,
                        items: dropdownItems,
                        onSelect: (item)=>insertVariable(item.text),
                        onClose: ()=>{
                            setClosedForToken(lastToken);
                            setSelectedIndex(-1);
                        },
                        anchorRef: wrapperRef,
                        selectedIndex: selectedIndex,
                        onSelectedIndexChange: setSelectedIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                style: {
                    height: isEditing ? "1.5em" : 0,
                    minHeight: isEditing ? "1.5em" : 0,
                    transition: "height 0.2s ease, min-height 0.2s ease"
                },
                className: (0, $cqVqv.classMerge)([
                    isWarning ? "warning-feedback" : isValid && currentValue.length > 0 ? "valid-feedback" : isInvalid ? "invalid-feedback" : "text-muted",
                    (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).validationText
                ]),
                children: isWarning ? (0, $4yc3n.CUSTOM_DATASET_VARIABLE_WARNING) : isValid && currentValue.length > 0 ? "Valid where clause" : isInvalid ? "Invalid where clause format" : ""
            })
        ]
    });
};
$7b376540111c47a1$export$220896b0b25e2f48.displayName = "WhereClauseInput";

});
parcelRegister("hp2BB", function(module, exports) {

$parcel$export(module.exports, "formatWhereClauseAsCode", function () { return $266f25ec2107f77b$export$d99b8d05a55e7c39; });

var $1cA0K = parcelRequire("1cA0K");
parcelRequire("6yroJ");
var $fAJMp = parcelRequire("fAJMp");
var $cNv0d = parcelRequire("cNv0d");
var $5KlUB = parcelRequire("5KlUB");
var $kC2sO = parcelRequire("kC2sO");
var $jc9tE = parcelRequire("jc9tE");

var $470Zy = parcelRequire("470Zy");
const $266f25ec2107f77b$export$d99b8d05a55e7c39 = (whereClause, availableVariables)=>{
    if ((0, $5KlUB.isSubClauseWithReference)(whereClause) && whereClause.subClauseId !== "") return `[${whereClause.subClauseId}]`;
    else if ((0, $jc9tE.isWhereClauseWithCondition)(whereClause) || (0, $cNv0d.isSubClauseWithCondition)(whereClause)) return (0, $470Zy.formatConditionAsCode)(whereClause.condition, availableVariables);
    else if ((0, $kC2sO.isWhereClauseWithCompoundExpression)(whereClause) || (0, $fAJMp.isSubClauseWithCompoundExpression)(whereClause)) {
        const { logicalOperator: logicalOperator, whereClauses: whereClauses } = whereClause.compoundExpression;
        if (!whereClauses || whereClauses.length === 0) return "";
        // Format each sub-clause
        const formattedClauses = whereClauses.map((subClause)=>$266f25ec2107f77b$var$formatSubClause(subClause, availableVariables)).filter((clause)=>clause !== "");
        if (formattedClauses.length === 0) return "";
        // Handle NOT operator
        if (logicalOperator === (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT) {
            const clause = formattedClauses[0];
            // Clause is either already bracketed or a simple condition
            return `NOT ${clause}`;
        }
        // Handle AND/OR operators
        const operator = logicalOperator === (0, $1cA0K.ExpressionLogicalOperatorEnum).AND ? " AND " : " OR ";
        const combined = formattedClauses.join(operator);
        // Wrap in brackets for compound expressions
        return `(${combined})`;
    }
    return "";
};
/**
 * Formats a sub-clause (part of a compound expression) as code.
 *
 * @param subClause - The sub-clause to format.
 * @param availableVariables - List of available variables with dataType information.
 * @returns Formatted string for the sub-clause.
 */ const $266f25ec2107f77b$var$formatSubClause = (subClause, availableVariables)=>{
    // Handle referenced where clause (subClauseId)
    /* istanbul ignore else  */ if ((0, $5KlUB.isSubClauseWithReference)(subClause) && subClause.subClauseId !== "") return `[${subClause.subClauseId}]`;
    else if ((0, $cNv0d.isSubClauseWithCondition)(subClause)) return (0, $470Zy.formatConditionAsCode)(subClause.condition, availableVariables);
    else if ((0, $fAJMp.isSubClauseWithCompoundExpression)(subClause)) {
        const { logicalOperator: logicalOperator, whereClauses: whereClauses } = subClause.compoundExpression;
        if (!whereClauses || whereClauses.length === 0) return "";
        const formattedClauses = whereClauses.map((sc)=>$266f25ec2107f77b$var$formatSubClause(sc, availableVariables)).filter((clause)=>clause !== "");
        if (formattedClauses.length === 0) return "";
        // Handle NOT operator
        if (logicalOperator === (0, $1cA0K.ExpressionLogicalOperatorEnum).NOT) {
            const clause = formattedClauses[0];
            // Clause is either already bracketed or a simple condition
            return `NOT ${clause}`;
        }
        // Handle AND/OR operators
        const operator = logicalOperator === (0, $1cA0K.ExpressionLogicalOperatorEnum).AND ? " AND " : " OR ";
        return `(${formattedClauses.join(operator)})`;
    }
    // istanbul ignore next
    return "";
};

});




parcelRegister("i5A9K", function(module, exports) {

$parcel$export(module.exports, "CaseWhenControl", function () { return $0b6284500bd915d4$export$d181fee453ee208f; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $7Tnbh = parcelRequire("7Tnbh");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $cGJVG = parcelRequire("cGJVG");

var $d6VIT = parcelRequire("d6VIT");

var $1BhrA = parcelRequire("1BhrA");
const $0b6284500bd915d4$export$d181fee453ee208f = ({ id: id, dataPath: dataPath, disabled: disabled, editorDefns: editorDefns = (0, $jP37Y.defaultEditorDefns), onChange: onChange })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const thisCaseWhenCondition = (0, $7fPBF.useMemo)(()=>(0, $eAPMz.getFromDataPath)(dataPath, state, (obj)=>(0, $cGJVG.isCaseWhenCondition)(obj, editorDefns.isT)) ?? (dataPath.split("/").slice(-2)[0] === "caseWhenConditions" ? {
            id: dataPath.split("/").slice(-1)[0],
            caseWhenItems: []
        } : undefined), [
        dataPath,
        editorDefns,
        state
    ]);
    if (!thisCaseWhenCondition) return /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: "text-danger",
        children: [
            "Entity not found at path: ",
            dataPath
        ]
    });
    /**
   * Handle variable reordering
   *
   * @param event - Sortable list drag end event
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore else */ if (active.id !== over?.id) {
            const activeIndex = thisCaseWhenCondition.caseWhenItems.findIndex((item)=>item.id === active.id);
            const overIndex = thisCaseWhenCondition.caseWhenItems.findIndex((item)=>item.id === over?.id);
            const newItems = [
                ...thisCaseWhenCondition.caseWhenItems
            ];
            const [movedItem] = newItems.splice(activeIndex, 1);
            newItems.splice(overIndex, 0, movedItem);
            if (onChange) onChange({
                ...thisCaseWhenCondition,
                caseWhenItems: newItems
            });
            else dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `/caseWhenConditions/${thisCaseWhenCondition.id}/caseWhenItems`,
                value: newItems
            });
        }
    };
    /**
   * Add new item to the condition
   */ const handleAddItem = ()=>{
        const newCaseWhenItem = {
            id: crypto.randomUUID(),
            thenDisplayPattern: state.editorDefns.blankT,
            thenResultPattern: "",
            when: null
        };
        const newItems = [
            ...thisCaseWhenCondition.caseWhenItems,
            newCaseWhenItem
        ];
        if (onChange) onChange({
            ...thisCaseWhenCondition,
            caseWhenItems: newItems
        });
        else {
            if (newItems.length === 1) // If this is the first item, we need to create the parent condition as well
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `/caseWhenConditions/${thisCaseWhenCondition.id}`,
                value: {
                    ...thisCaseWhenCondition,
                    caseWhenItems: newItems
                }
            });
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `/caseWhenConditions/${thisCaseWhenCondition.id}/caseWhenItems`,
                value: newItems
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
        className: $d6VIT.itemsHolder,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7Tnbh.SortableListHolder), {
                id: id,
                canMove: !disabled,
                handleDragEnd: handleDragEnd,
                items: thisCaseWhenCondition.caseWhenItems.map((v, ix)=>({
                        id: v.id,
                        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1BhrA.CaseWhenItemControl), {
                            id: `${id}-item-${ix}`,
                            dataPath: `${dataPath}/caseWhenItems/${ix}`,
                            disabled: disabled,
                            onChange: onChange ? (ret)=>{
                                const newItems = [
                                    ...thisCaseWhenCondition.caseWhenItems
                                ];
                                const thisIx = newItems.findIndex((item)=>item.id === v.id);
                                if (thisIx !== -1) {
                                    if (ret) newItems[thisIx] = ret;
                                    else newItems.splice(thisIx, 1);
                                    onChange({
                                        ...thisCaseWhenCondition,
                                        caseWhenItems: newItems
                                    });
                                }
                            } : undefined,
                            siblingCount: thisCaseWhenCondition.caseWhenItems.length
                        })
                    }))
            }),
            !disabled && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
                id: `${id}-add-item-button`,
                className: "text-success",
                role: "button",
                "aria-label": "Add item",
                onClick: handleAddItem,
                style: {
                    cursor: "pointer"
                }
            })
        ]
    });
};
$0b6284500bd915d4$export$d181fee453ee208f.displayName = "CaseWhenControl";

});
parcelRegister("d6VIT", function(module, exports) {

$parcel$export(module.exports, "itemHolder", function () { return $98b89c82e1eab3b9$export$1aea70eb3432192b; }, function (v) { return $98b89c82e1eab3b9$export$1aea70eb3432192b = v; });
$parcel$export(module.exports, "itemPropertyHolder", function () { return $98b89c82e1eab3b9$export$c614277c8b92264f; }, function (v) { return $98b89c82e1eab3b9$export$c614277c8b92264f = v; });
$parcel$export(module.exports, "itemPropertyInput", function () { return $98b89c82e1eab3b9$export$f8a603587aa593ca; }, function (v) { return $98b89c82e1eab3b9$export$f8a603587aa593ca = v; });
$parcel$export(module.exports, "itemPropertyLabel", function () { return $98b89c82e1eab3b9$export$7ca45c7ba071faf8; }, function (v) { return $98b89c82e1eab3b9$export$7ca45c7ba071faf8 = v; });
$parcel$export(module.exports, "itemsHolder", function () { return $98b89c82e1eab3b9$export$f0e1e65e737ee5a9; }, function (v) { return $98b89c82e1eab3b9$export$f0e1e65e737ee5a9 = v; });
$parcel$export(module.exports, "removeButtonHolder", function () { return $98b89c82e1eab3b9$export$f5c6df7622a3a9e0; }, function (v) { return $98b89c82e1eab3b9$export$f5c6df7622a3a9e0 = v; });
var $98b89c82e1eab3b9$export$c38d73f44da0bd96;
var $98b89c82e1eab3b9$export$1aea70eb3432192b;
var $98b89c82e1eab3b9$export$c614277c8b92264f;
var $98b89c82e1eab3b9$export$f8a603587aa593ca;
var $98b89c82e1eab3b9$export$7ca45c7ba071faf8;
var $98b89c82e1eab3b9$export$27f39136c7b0387a;
var $98b89c82e1eab3b9$export$d13e7c52906aadd2;
var $98b89c82e1eab3b9$export$f0e1e65e737ee5a9;
var $98b89c82e1eab3b9$export$f5c6df7622a3a9e0;
$98b89c82e1eab3b9$export$c38d73f44da0bd96 = `mos-CaseWhen-module-5rP9JG-itemDeleteButton`;
$98b89c82e1eab3b9$export$1aea70eb3432192b = `mos-CaseWhen-module-5rP9JG-itemHolder`;
$98b89c82e1eab3b9$export$c614277c8b92264f = `mos-CaseWhen-module-5rP9JG-itemPropertyHolder`;
$98b89c82e1eab3b9$export$f8a603587aa593ca = `mos-CaseWhen-module-5rP9JG-itemPropertyInput`;
$98b89c82e1eab3b9$export$7ca45c7ba071faf8 = `mos-CaseWhen-module-5rP9JG-itemPropertyLabel`;
$98b89c82e1eab3b9$export$27f39136c7b0387a = `mos-CaseWhen-module-5rP9JG-itemTypeOption`;
$98b89c82e1eab3b9$export$d13e7c52906aadd2 = `mos-CaseWhen-module-5rP9JG-itemTypeSelect`;
$98b89c82e1eab3b9$export$f0e1e65e737ee5a9 = `mos-CaseWhen-module-5rP9JG-itemsHolder`;
$98b89c82e1eab3b9$export$f5c6df7622a3a9e0 = `mos-CaseWhen-module-5rP9JG-removeButtonHolder`;

});

parcelRegister("1BhrA", function(module, exports) {

$parcel$export(module.exports, "CaseWhenItemControl", function () { return $92898cf26475e22e$export$aed991923e1439fd; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("gYROb");
var $fQHYQ = parcelRequire("fQHYQ");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");
parcelRequire("6yroJ");
var $484ww = parcelRequire("484ww");

var $d6VIT = parcelRequire("d6VIT");

var $rRNEc = parcelRequire("rRNEc");

var $bNdmh = parcelRequire("bNdmh");
const $92898cf26475e22e$export$aed991923e1439fd = ({ id: id, dataPath: dataPath, disabled: disabled, onChange: onChange, siblingCount: siblingCount })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const thisCaseWhenItem = (0, $eAPMz.getFromDataPath)(dataPath, state, (obj)=>(0, $484ww.isCaseWhenItem)(obj, state.editorDefns.isT));
    if (!thisCaseWhenItem) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        id: id,
        className: $d6VIT.itemHolder,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: $d6VIT.itemPropertyHolder,
                style: {
                    flexGrow: 2,
                    flexShrink: 1,
                    flexBasis: 0,
                    minWidth: 0,
                    justifyContent: "flex-start",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bNdmh.WhereClauseInput), {
                    dataPath: `${dataPath}/when`,
                    disabled: disabled,
                    onChange: (newValue)=>{
                        if (onChange) onChange({
                            ...thisCaseWhenItem,
                            when: newValue
                        });
                        else dispatch({
                            operation: (0, $cIJV5.PATCH_ARS_STATE),
                            dataPath: `${dataPath}/when`,
                            value: newValue
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: $d6VIT.itemPropertyHolder,
                style: {
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: 0,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: $d6VIT.itemPropertyLabel,
                        children: "Display"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)(state.editorDefns.Editor, {
                        id: `${id}-then-display-pattern`,
                        "aria-label": "Display pattern",
                        className: $d6VIT.itemPropertyInput,
                        editable: !disabled,
                        setValue: (newValue)=>onChange ? onChange({
                                ...thisCaseWhenItem,
                                thenDisplayPattern: newValue
                            }) : dispatch({
                                operation: (0, $cIJV5.PATCH_ARS_STATE),
                                dataPath: `${dataPath}/thenDisplayPattern`,
                                value: newValue
                            }),
                        type: "string",
                        value: thisCaseWhenItem.thenDisplayPattern
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: $d6VIT.itemPropertyHolder,
                style: {
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: 0,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: $d6VIT.itemPropertyLabel,
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fQHYQ.ControlBase), {
                        "aria-label": "Result pattern",
                        disabled: disabled,
                        setValue: (newValue)=>onChange ? onChange({
                                ...thisCaseWhenItem,
                                thenResultPattern: newValue
                            }) : dispatch({
                                operation: (0, $cIJV5.PATCH_ARS_STATE),
                                dataPath: `${dataPath}/thenResultPattern`,
                                value: newValue
                            }),
                        type: "string",
                        value: thisCaseWhenItem.thenResultPattern
                    }),
                    !disabled && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: $d6VIT.removeButtonHolder,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                            id: `${id}-remove-button`,
                            dataPath: dataPath,
                            onChange: ()=>onChange?.(),
                            siblingCount: siblingCount
                        })
                    })
                ]
            })
        ]
    });
};
$92898cf26475e22e$export$aed991923e1439fd.displayName = "CaseWhenItemControl";

});


parcelRegister("b1QeS", function(module, exports) {

$parcel$export(module.exports, "DataSubsetControl", function () { return $8d4ee83e65d6bb11$export$e92914d539e7b41b; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $eAPMz = parcelRequire("eAPMz");
var $74VXB = parcelRequire("74VXB");
var $fZCs4 = parcelRequire("fZCs4");

var $8d4Ob = parcelRequire("8d4Ob");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");

var $h9QS8 = parcelRequire("h9QS8");
const $8d4ee83e65d6bb11$export$e92914d539e7b41b = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state } = (0, $fZCs4.useArsContext)();
    const dataSubset = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $74VXB.isDataSubset));
    // Disable editing for parent templates
    if (dataSubset?.disableEditing) disabled = true;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                        children: [
                            "Id: ",
                            dataPath.split("/").pop()
                        ]
                    })
                })
            }),
            canRename && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                dataPath: dataPath,
                canRename: canRename,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h9QS8.WhereClauseManager), {
                dataPath: dataPath,
                disabled: disabled
            })
        ]
    });
};
$8d4ee83e65d6bb11$export$e92914d539e7b41b.displayName = "DataSubsetControl";

});

parcelRegister("3qrfA", function(module, exports) {

$parcel$export(module.exports, "GroupControl", function () { return $9d6091ae71365c54$export$33557f4114f177b3; });

var $bbzbN = parcelRequire("bbzbN");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");

var $h9QS8 = parcelRequire("h9QS8");
const $9d6091ae71365c54$export$33557f4114f177b3 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "position-relative",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-absolute",
                style: {
                    zIndex: 1,
                    top: "-0.75rem",
                    right: "-.75rem"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                dataPath: dataPath,
                canRename: true,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h9QS8.WhereClauseManager), {
                dataPath: dataPath,
                disabled: disabled
            })
        ]
    });
};
$9d6091ae71365c54$export$33557f4114f177b3.displayName = "GroupControl";

});

parcelRegister("bRDEW", function(module, exports) {

$parcel$export(module.exports, "GroupingFactorControl", function () { return $3995c8714c8e4bf7$export$95bd92bc1dba1edd; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $b6fw7 = parcelRequire("b6fw7");
var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $d8uJi = parcelRequire("d8uJi");
var $4tJ7o = parcelRequire("4tJ7o");
var $kYoG1 = parcelRequire("kYoG1");
var $gLW8Q = parcelRequire("gLW8Q");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
var $6LYdD = parcelRequire("6LYdD");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $3CgTd = parcelRequire("3CgTd");
var $fZCs4 = parcelRequire("fZCs4");

var $cIJV5 = parcelRequire("cIJV5");

var $3EZep = parcelRequire("3EZep");

var $eUQaa = parcelRequire("eUQaa");

var $4AU0o = parcelRequire("4AU0o");

var $lDUyo = parcelRequire("lDUyo");

var $8ENpM = parcelRequire("8ENpM");

var $3qrfA = parcelRequire("3qrfA");

var $kteXq = parcelRequire("kteXq");

var $rRNEc = parcelRequire("rRNEc");
const $3995c8714c8e4bf7$export$95bd92bc1dba1edd = ({ dataPath: dataPath, canRename: canRename, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)("named-object");
    const [showConfirmModal, setShowConfirmModal] = (0, $7fPBF.useState)(false);
    // Get the current grouping factor from state
    const groupingFactor = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $4AU0o.isGroupingFactor));
    const dataDriven = (0, $lDUyo.isGroupingFactorDataDriven)(groupingFactor);
    const groups = (0, $7fPBF.useMemo)(()=>(0, $8ENpM.isGroupingFactorWithGroups)(groupingFactor) ? groupingFactor.groups : [], [
        groupingFactor
    ]);
    // Disable editing for parent templates
    if (groupingFactor?.disableEditing) disabled = true;
    /**
   * Event handler to update the active tab.
   */ const updateActiveTab = (0, $7fPBF.useEffectEvent)((newTab)=>{
        (0, $7fPBF.startTransition)(()=>setActiveTab(newTab));
    });
    /**
   * Change the active group tab if it no longer exists
   */ (0, $7fPBF.useEffect)(()=>{
        if (activeTab.startsWith("group-") && groups.length > 0 && parseInt(activeTab.split("-")[1], 10) >= groups.length) {
            const lastGroupIndex = groups.length - 1;
            updateActiveTab(`group-${lastGroupIndex}`);
        } else if (activeTab.startsWith("group-") && groups.length === 0) updateActiveTab("named-object");
    }, [
        groups.length,
        dataDriven,
        activeTab
    ]);
    /**
   * Handles showing the confirmation modal when toggling dataDriven.
   */ const handleDataDrivenChange = ()=>{
        // istanbul ignore next
        if (disabled) return;
        if (dataDriven && groupingFactor.groupingDataset === "" && groupingFactor.groupingVariable === "" && groupingFactor.dataValues.length === 0) confirmDataDrivenChange();
        else if (!dataDriven && groups.length === 0) confirmDataDrivenChange();
        else setShowConfirmModal(true);
    };
    /**
   * Confirms the dataDriven toggle after user acknowledgement.
   */ const confirmDataDrivenChange = ()=>{
        /* istanbul ignore else */ if (groupingFactor) {
            if ((0, $lDUyo.isGroupingFactorDataDriven)(groupingFactor)) {
                const newGroupingFactor = {
                    dataDriven: false,
                    description: groupingFactor.description,
                    fromHierarchyId: groupingFactor.fromHierarchyId,
                    groups: [],
                    id: groupingFactor.id,
                    label: groupingFactor.label,
                    name: groupingFactor.name
                };
                dispatch({
                    operation: (0, $cIJV5.PATCH_ARS_STATE),
                    dataPath: dataPath,
                    value: newGroupingFactor
                });
            } else {
                const newGroupingFactor = {
                    dataDriven: true,
                    dataValues: [],
                    description: groupingFactor.description,
                    fromHierarchyId: groupingFactor.fromHierarchyId,
                    groupingDataset: "",
                    groupingVariable: "",
                    id: groupingFactor.id,
                    label: groupingFactor.label,
                    name: groupingFactor.name
                };
                dispatch({
                    operation: (0, $cIJV5.PATCH_ARS_STATE),
                    dataPath: dataPath,
                    value: newGroupingFactor
                });
            }
        }
        setShowConfirmModal(false);
    };
    /**
   * Handles adding a new group to the groups array.
   */ const handleAddGroup = ()=>{
        /* istanbul ignore else */ if (!disabled && (0, $8ENpM.isGroupingFactorWithGroups)(groupingFactor)) {
            const newGroup = (0, $3CgTd.createNewGroup)(`Group_${groups.length + 1}`, groups.length);
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/groups`,
                value: [
                    ...groupingFactor.groups,
                    newGroup
                ]
            });
        }
    };
    /**
   * Handles reordering of the groups array after a tab has been dragged.
   *
   * @param newGroups - The groups in their new order, with order values re-applied.
   */ const handleReorderGroups = (newGroups)=>{
        /* istanbul ignore else -- reordering is disabled unless groups are present */ if (!disabled && (0, $8ENpM.isGroupingFactorWithGroups)(groupingFactor)) {
            const groups = newGroups.map((group, index)=>({
                    ...group,
                    order: index
                }));
            dispatch({
                operation: (0, $cIJV5.PATCH_ARS_STATE),
                dataPath: `${dataPath}/groups`,
                value: groups
            });
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "border rounded p-3 mb-3 position-relative",
                children: [
                    groupingFactor && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "position-absolute bottom-0 end-0 m-1",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                                children: [
                                    "Id: ",
                                    dataPath.split("/").pop()
                                ]
                            })
                        })
                    }),
                    canRename && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "position-absolute top-0 end-0 m-2",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $rRNEc.RemoveArsItemButton), {
                            dataPath: dataPath,
                            disabled: disabled
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Container, {
                        activeKey: activeTab,
                        onSelect: (k)=>{
                            /* istanbul ignore else -- Disabled tabs and null selections are not reachable from the UI */ if (k) setActiveTab(k);
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4tJ7o.default), {
                                variant: "tabs",
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                            eventKey: "named-object",
                                            children: "Properties"
                                        })
                                    }),
                                    dataDriven ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Item, {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tJ7o.default).Link, {
                                            eventKey: "dataset-variable",
                                            children: "Dataset/Variable"
                                        })
                                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6LYdD.ReorderableNavList), {
                                        list: groups,
                                        setList: handleReorderGroups,
                                        getEventKey: (_group, index)=>`group-${index}`,
                                        disabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Content, {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                        eventKey: "named-object",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kteXq.NamedObjectControl), {
                                                dataPath: dataPath,
                                                canRename: canRename,
                                                disabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
                                                controlId: `${dataPath.replace(/\//g, "-")}-data-driven`,
                                                as: (0, $kYoG1.default),
                                                className: "my-1",
                                                title: "Data driven",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                                                        column: true,
                                                        md: 2,
                                                        children: "Data driven"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                                        md: 10,
                                                        className: "d-flex align-items-center justify-content-start",
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Check, {
                                                            type: "switch",
                                                            checked: dataDriven,
                                                            disabled: disabled,
                                                            onChange: handleDataDrivenChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Group, {
                                                controlId: `${dataPath.replace(/\//g, "-")}-add-group`,
                                                className: "mt-3",
                                                children: !disabled && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                                                    id: `${dataPath.replace(/\//g, "-")}-add-group-btn`,
                                                    onClick: handleAddGroup,
                                                    className: "d-flex align-items-center btn-sm btn-success",
                                                    disabled: dataDriven,
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: "me-2",
                                                            children: "Add group"
                                                        }),
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    dataDriven ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gLW8Q.default).Pane, {
                                        eventKey: "dataset-variable",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eUQaa.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/groupingVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-grouping-variable`,
                                                label: "Grouping variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable",
                                                disabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eUQaa.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/orderVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-order-variable`,
                                                canChangeDataset: false,
                                                disabled: disabled || !groupingFactor?.groupingDataset,
                                                label: "Order variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eUQaa.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/unitVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-unit-variable`,
                                                canChangeDataset: false,
                                                disabled: disabled || !groupingFactor?.groupingDataset,
                                                label: "Unit variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3EZep.ArsText), {
                                                dataPath: `${dataPath}/dataValues`,
                                                id: `${dataPath.replace(/\//g, "-")}-data-values`,
                                                debounceMilliseconds: 2000,
                                                disabled: disabled,
                                                isArray: true,
                                                label: "Data values",
                                                labelWidth: 2,
                                                rows: 5,
                                                type: "textarea"
                                            })
                                        ]
                                    }) : groups.map((group, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gLW8Q.default).Pane, {
                                            eventKey: `group-${index}`,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3qrfA.GroupControl), {
                                                dataPath: `${dataPath}/groups/${index}`,
                                                disabled: disabled,
                                                siblingCount: groups.length
                                            })
                                        }, group.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default), {
                show: showConfirmModal,
                onHide: ()=>setShowConfirmModal(false),
                centered: true,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                            children: "Confirm change"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default).Body, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: "Changing the Data driven setting will result in loss of any existing changes."
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: "Are you sure you want to proceed?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default).Footer, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
                                variant: "secondary",
                                onClick: ()=>setShowConfirmModal(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
                                variant: "primary",
                                onClick: confirmDataDrivenChange,
                                children: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$3995c8714c8e4bf7$export$95bd92bc1dba1edd.displayName = "GroupingFactorControl";

});
parcelRegister("d8uJi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0277cddebf9a4b62$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $8S3wI = parcelRequire("8S3wI");

var $kkTu9 = parcelRequire("kkTu9");

var $eSNaH = parcelRequire("eSNaH");

var $73lTM = parcelRequire("73lTM");

var $bDmK0 = parcelRequire("bDmK0");

var $9PvQe = parcelRequire("9PvQe");

var $jbhqg = parcelRequire("jbhqg");

var $kbUnX = parcelRequire("kbUnX");

var $ZvfsD = parcelRequire("ZvfsD");

var $gLt8q = parcelRequire("gLt8q");

var $7fPBF = parcelRequire("7fPBF");

var $h4kX5 = parcelRequire("h4kX5");

var $90GdC = parcelRequire("90GdC");

var $e2eQx = parcelRequire("e2eQx");

var $jsGRP = parcelRequire("jsGRP");

var $i1mVH = parcelRequire("i1mVH");

var $f1b2Q = parcelRequire("f1b2Q");

var $5oI9P = parcelRequire("5oI9P");

var $k4fGF = parcelRequire("k4fGF");

var $599zS = parcelRequire("599zS");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $0277cddebf9a4b62$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e2eQx.default), {
        ...props,
        timeout: null
    });
}
function $0277cddebf9a4b62$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e2eQx.default), {
        ...props,
        timeout: null
    });
}
const $0277cddebf9a4b62$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $f1b2Q.default), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $7fPBF.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $7fPBF.useState)(false);
    const waitingForMouseUpRef = (0, $7fPBF.useRef)(false);
    const ignoreBackdropClickRef = (0, $7fPBF.useRef)(false);
    const removeStaticModalAnimationRef = (0, $7fPBF.useRef)(null);
    const [modal, setModalRef] = (0, $9PvQe.default)();
    const mergedRef = (0, $kbUnX.default)(ref, setModalRef);
    const handleHide = (0, $jbhqg.default)(onHide);
    const isRTL = (0, $jbn4d.useIsRTL)();
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'modal');
    const modalContext = (0, $7fPBF.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $90GdC.getSharedManager)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $kkTu9.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $eSNaH.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $bDmK0.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $bDmK0.default)() : undefined
        });
    }
    const handleWindowResize = (0, $jbhqg.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $ZvfsD.default)(()=>{
        (0, $73lTM.default)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $gLt8q.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $8S3wI.default)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $73lTM.default)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $7fPBF.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i1mVH.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h4kX5.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $0277cddebf9a4b62$var$DialogTransition : undefined,
            backdropTransition: animation ? $0277cddebf9a4b62$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$0277cddebf9a4b62$var$Modal.displayName = 'Modal';
var $0277cddebf9a4b62$export$2e2bcd8739ae039 = Object.assign($0277cddebf9a4b62$var$Modal, {
    Body: (0, $jsGRP.default),
    Header: (0, $k4fGF.default),
    Title: (0, $599zS.default),
    Footer: (0, $5oI9P.default),
    Dialog: (0, $f1b2Q.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

});
parcelRegister("bDmK0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8784fa22e7efeec8$export$2e2bcd8739ae039; });

var $kkTu9 = parcelRequire("kkTu9");
var $8784fa22e7efeec8$var$size;
function $8784fa22e7efeec8$export$2e2bcd8739ae039(recalc) {
    if (!$8784fa22e7efeec8$var$size && $8784fa22e7efeec8$var$size !== 0 || recalc) {
        if (0, $kkTu9.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $8784fa22e7efeec8$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $8784fa22e7efeec8$var$size;
}

});

parcelRegister("9PvQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $728193870743dd6d$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $728193870743dd6d$export$2e2bcd8739ae039() {
    return (0, $7fPBF.useState)(null);
}

});

parcelRegister("ZvfsD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b8defe52d8ae453$export$2e2bcd8739ae039; });

var $kjAPI = parcelRequire("kjAPI");

var $7fPBF = parcelRequire("7fPBF");
function $0b8defe52d8ae453$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $kjAPI.default)(fn);
    (0, $7fPBF.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("kjAPI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca2274413b29840$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
function $eca2274413b29840$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $7fPBF.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("jsGRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2b1e2605157a95f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e2b1e2605157a95f$var$ModalBody = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$e2b1e2605157a95f$var$ModalBody.displayName = 'ModalBody';
var $e2b1e2605157a95f$export$2e2bcd8739ae039 = $e2b1e2605157a95f$var$ModalBody;

});

parcelRegister("f1b2Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeef844f14e83898$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $aeef844f14e83898$var$ModalDialog = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$aeef844f14e83898$var$ModalDialog.displayName = 'ModalDialog';
var $aeef844f14e83898$export$2e2bcd8739ae039 = $aeef844f14e83898$var$ModalDialog;

});

parcelRegister("5oI9P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ee172692c62bd7b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3ee172692c62bd7b$var$ModalFooter = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$3ee172692c62bd7b$var$ModalFooter.displayName = 'ModalFooter';
var $3ee172692c62bd7b$export$2e2bcd8739ae039 = $3ee172692c62bd7b$var$ModalFooter;

});

parcelRegister("k4fGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9c059808df360c8$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $hcUZE = parcelRequire("hcUZE");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e9c059808df360c8$var$ModalHeader = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hcUZE.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$e9c059808df360c8$var$ModalHeader.displayName = 'ModalHeader';
var $e9c059808df360c8$export$2e2bcd8739ae039 = $e9c059808df360c8$var$ModalHeader;

});

parcelRegister("599zS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bf538ec0b62828b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $kmq8T = parcelRequire("kmq8T");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $3bf538ec0b62828b$var$DivStyledAsH4 = (0, $kmq8T.default)('h4');
const $3bf538ec0b62828b$var$ModalTitle = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $3bf538ec0b62828b$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$3bf538ec0b62828b$var$ModalTitle.displayName = 'ModalTitle';
var $3bf538ec0b62828b$export$2e2bcd8739ae039 = $3bf538ec0b62828b$var$ModalTitle;

});



parcelRegister("kupca", function(module, exports) {

$parcel$export(module.exports, "ReferencedEntityControl", function () { return $61433d7beb2bd05e$export$7e5b7980c50e925f; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $6QORW = parcelRequire("6QORW");
var $bhmzU = parcelRequire("bhmzU");
var $jVHe9 = parcelRequire("jVHe9");
parcelRequire("2nuru");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("k7fIt");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $h7VrC = parcelRequire("h7VrC");

var $5KlUB = parcelRequire("5KlUB");

var $9ijW6 = parcelRequire("9ijW6");

var $b1QeS = parcelRequire("b1QeS");

var $k7ogs = parcelRequire("k7ogs");
const $61433d7beb2bd05e$export$502b2f06a26bc541 = {
    AnalysisSet: {
        name: "Analysis set",
        label: "Analysis set",
        arsKey: "analysisSets"
    },
    DataSubset: {
        name: "Data subset",
        label: "Data subset",
        arsKey: "dataSubsets"
    }
};
const $61433d7beb2bd05e$export$7e5b7980c50e925f = ({ dataPath: dataPath, entityType: entityType, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [isContextWindowOpen, setIsContextWindowOpen] = (0, $7fPBF.useState)(false);
    const subClausePath = dataPath.endsWith("/subClauseId") ? dataPath.substring(0, dataPath.lastIndexOf("/subClauseId")) : "";
    const subClause = (0, $eAPMz.getFromDataPath)(subClausePath, state, (0, $5KlUB.isSubClauseWithReference));
    const canSwapToCondition = subClause !== undefined;
    // Get the current subClauseId value
    const subClauseId = (0, $eAPMz.getFromDataPath)(dataPath, state, (0, $eAPMz.isString)) ?? "-- None --";
    /**
   * Get the entity configuration based on the entity type and subClauseId.
   * This includes the collection of entities, display name, label for the dropdown, and options for the dropdown.
   *
   * @param entityType - The type of entity being referenced (AnalysisSet or DataSubset)
   * @param subClauseId - The ID of the referenced entity to find the full details for
   * @return The entity configuration for the specified entity type, or undefined if the subClauseId does not correspond to a valid entity
   */ const getEntityConfig = ()=>{
        // Get the right entity collection based on the entity type
        const entities = entityType === "AnalysisSet" ? state.analysisSets : state.dataSubsets;
        // Find the specific entity being referenced using the subClauseId
        const entity = subClauseId ? entities[subClauseId] : undefined;
        // Return undefined if the subClauseId does not correspond to a valid entity
        const name = $61433d7beb2bd05e$export$502b2f06a26bc541[entityType].name;
        const label = $61433d7beb2bd05e$export$502b2f06a26bc541[entityType].label;
        const options = Object.values(entities).map((e)=>({
                value: e.id,
                label: e.name
            }));
        if (subClauseId === "-- None --" || subClauseId === "") options.unshift({
            value: "-- None --",
            label: "-- None --"
        });
        // Otherwise return the full entity configuration for the specified entity type
        return {
            entity: entity,
            name: name,
            label: label,
            options: options
        };
    };
    const entityConfig = getEntityConfig();
    /**
   * Get the dataPath for the referenced entity based on entity type.
   *
   * @returns The RFC 6901 JSON Pointer path to the referenced entity in ArsContext state
   */ const getEntityDataPath = ()=>{
        const typePrefix = $61433d7beb2bd05e$export$502b2f06a26bc541[entityType].arsKey;
        return `/${typePrefix}/${subClauseId}`;
    };
    /**
   * Handles opening the context window to view the referenced entity.
   */ const handleOpenContextWindow = ()=>{
        setIsContextWindowOpen(true);
    };
    /**
   * Handles removing a where clause.
   * Reverts to single condition if only 2 clauses remain.
   */ const handleRemoveClause = ()=>{
        const parentPath = dataPath.substring(0, dataPath.lastIndexOf("/compoundExpression/whereClauses/"));
        dispatch({
            operation: (0, $cIJV5.REMOVE_WHERE_CLAUSE),
            dataPath: parentPath,
            id: subClauseId
        });
    };
    /**
   * Handles swapping a referenced entity back to a condition clause.
   */ const handleSwapToCondition = ()=>{
        /* istanbul ignore else */ if (subClause && subClausePath) dispatch({
            operation: (0, $cIJV5.PATCH_ARS_STATE),
            dataPath: subClausePath,
            value: {
                id: subClause.id,
                level: subClause.level,
                order: subClause.order,
                subClauseId: "",
                condition: {}
            }
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).compactContainer,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex-grow-1",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h7VrC.ArsSelect), {
                    dataPath: dataPath,
                    labelWidth: 2,
                    label: entityConfig.label,
                    options: entityConfig.options,
                    id: `${dataPath.replace(/\//g, "-")}-${entityType.toLowerCase()}`,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($k7ogs))).actionButtons,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6QORW.default), {
                        id: `${dataPath.replace(/\//g, "-")}-swap`,
                        className: canSwapToCondition ? "text-primary" : "text-muted",
                        "aria-label": "Swap to condition",
                        "aria-disabled": !canSwapToCondition || disabled,
                        onClick: canSwapToCondition && !disabled ? handleSwapToCondition : undefined,
                        style: {
                            cursor: canSwapToCondition && !disabled ? "pointer" : "not-allowed"
                        }
                    }),
                    entityConfig.entity && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bhmzU.default), {
                                className: "text-primary",
                                "aria-label": `Open referenced ${entityType.toLowerCase()}`,
                                "aria-disabled": disabled,
                                onClick: disabled ? undefined : handleOpenContextWindow,
                                style: {
                                    cursor: disabled ? "not-allowed" : "pointer"
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jVHe9.default), {
                                id: `${dataPath.replace(/\//g, "-")}-remove`,
                                className: "text-danger",
                                "aria-label": "Remove clause",
                                "aria-disabled": disabled,
                                onClick: disabled ? undefined : ()=>handleRemoveClause(),
                                style: {
                                    cursor: disabled ? "not-allowed" : "pointer"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextWindow), {
                id: `ref-${entityType.toLowerCase()}-${subClauseId}`,
                title: entityConfig.name,
                visible: isContextWindowOpen,
                onClose: ()=>setIsContextWindowOpen(false),
                style: {
                    width: "500px",
                    minHeight: "300px",
                    maxHeight: "70vh",
                    maxWidth: "80vw"
                },
                children: entityType === "DataSubset" ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b1QeS.DataSubsetControl), {
                    dataPath: getEntityDataPath(),
                    disabled: disabled
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9ijW6.AnalysisSetControl), {
                    dataPath: getEntityDataPath(),
                    disabled: disabled
                })
            })
        ]
    });
};
$61433d7beb2bd05e$export$7e5b7980c50e925f.displayName = "ReferencedEntityControl";

});
parcelRegister("bhmzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8362cbc75ad1a3db$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $8362cbc75ad1a3db$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $8362cbc75ad1a3db$var$_extends() {
    return $8362cbc75ad1a3db$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8362cbc75ad1a3db$var$_extends.apply(null, arguments);
}
function $8362cbc75ad1a3db$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8362cbc75ad1a3db$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $8362cbc75ad1a3db$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $8362cbc75ad1a3db$var$BoxArrowUpRight = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $8362cbc75ad1a3db$var$_objectWithoutProperties(_ref, $8362cbc75ad1a3db$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $8362cbc75ad1a3db$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-box-arrow-up-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
    }));
});
$8362cbc75ad1a3db$var$BoxArrowUpRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $8362cbc75ad1a3db$export$2e2bcd8739ae039 = $8362cbc75ad1a3db$var$BoxArrowUpRight;

});



parcelRegister("fJUVM", function(module, exports) {
$parcel$export(module.exports, "ArsListing", function () { return (parcelRequire("lremW")).ArsListing; });
$parcel$export(module.exports, "isArsListingBody", function () { return (parcelRequire("awEAB")).isArsListingBody; });
parcelRequire("lremW");
parcelRequire("2vnze");
parcelRequire("9VYub");
parcelRequire("8A1Qb");
parcelRequire("awEAB");
parcelRequire("3dB4J");
parcelRequire("jkCk4");
parcelRequire("5KRpm");

});
parcelRegister("lremW", function(module, exports) {

$parcel$export(module.exports, "ArsListing", function () { return $b224bfa267aa096c$export$b5fd9e15e5729e76; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");

var $4Myfs = parcelRequire("4Myfs");

var $bsFOF = parcelRequire("bsFOF");
const $b224bfa267aa096c$export$b5fd9e15e5729e76 = ({ id: id = "ars-listing", arsListingBody: arsListingBody, calculatedTableRows: calculatedTableRows, disabled: disabled = false, editorProps: editorProps = (0, $jP37Y.defaultEditorDefns), justification: justification, sidebarWidth: sidebarWidth = "360px", tlfViewMode: tlfViewMode, updateArsListingBody: updateArsListingBody, sidebarStyle: sidebarStyle, style: style })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bsFOF.ArsListingContextProvider), {
        bodyData: arsListingBody,
        calculatedTableRows: calculatedTableRows,
        updateBodyData: updateArsListingBody,
        settings: {
            id: id,
            disabled: disabled,
            editorProps: editorProps,
            justification: justification,
            sidebarStyle: sidebarStyle,
            sidebarWidth: sidebarWidth,
            style: style,
            tlfViewMode: tlfViewMode,
            variableFilter: ""
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4Myfs.ArsListingContent), {})
    });
};
$b224bfa267aa096c$export$b5fd9e15e5729e76.displayName = "ArsListing";

});
parcelRegister("4Myfs", function(module, exports) {

$parcel$export(module.exports, "ArsListingContent", function () { return $993850779e38dcf0$export$918e1fc4c9b36de5; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("6rtuc");
var $3k2bR = parcelRequire("3k2bR");
parcelRequire("k7fIt");
var $fZCs4 = parcelRequire("fZCs4");

var $2FEZT = parcelRequire("2FEZT");

var $iIa81 = parcelRequire("iIa81");

var $iCEGP = parcelRequire("iCEGP");

var $2vnze = parcelRequire("2vnze");

var $eYQSj = parcelRequire("eYQSj");

var $ey46M = parcelRequire("ey46M");

var $bsFOF = parcelRequire("bsFOF");
parcelRequire("9VYub");
var $hdg2u = parcelRequire("hdg2u");
var $gptzB = parcelRequire("gptzB");

var $8A1Qb = parcelRequire("8A1Qb");
const $993850779e38dcf0$export$918e1fc4c9b36de5 = ()=>{
    const arsContext = (0, $fZCs4.useArsContext)();
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    const scaffoldModel = state?.scaffoldModel;
    if (!state || !scaffoldModel) return null;
    const arsListingBody = state.bodyData;
    const arsListingColumns = arsListingBody.arsListingColumns;
    const disabled = state.settings.disabled;
    const id = state.settings.id;
    const justification = state.settings.justification;
    /**
   * Handles variable drops on scaffold cells.
   *
   * @param event - Drop event
   * @param rowId - Target scaffold row id
   * @param colId - Target scaffold column id
   * @param zone - Classified drop zone within the target cell
   */ const handleScaffoldDrop = (event, rowId, colId, zone)=>{
        /* istanbul ignore else */ if (!disabled && rowId === (0, $8A1Qb.HEADER_ROW_ID)) {
            event.preventDefault();
            const jsonPayload = event.dataTransfer.getData("application/json");
            const action = (0, $gptzB.buildApplyDroppedColumnsAction)(jsonPayload, colId, zone, state.settings.editorProps.textToT);
            /* istanbul ignore else */ if (action !== null) dispatch(action);
        }
    };
    /**
   * Handles column width changes from user resize operations.
   *
   * @param colId - Column id being resized
   * @param col - Updated column definition with new width
   */ const handleChangeCol = (colId, col)=>{
        if (!disabled) {
            const updatedColumns = arsListingColumns.map((column)=>column.id === colId ? {
                    ...column,
                    columnWidth: col.width
                } : column);
            dispatch({
                operation: (0, $8A1Qb.ARSL_SET_COLUMNS),
                columns: updatedColumns
            });
        }
    };
    /**
   * Handles row height changes from user resize operations.
   *
   * @param rowId - Row id being resized
   * @param row - Updated row definition with new height
   */ const handleChangeRow = (rowId, row)=>{
        if (!disabled) {
            if (rowId === (0, $8A1Qb.HEADER_ROW_ID)) dispatch({
                operation: (0, $8A1Qb.ARSL_SET_COLUMNS),
                columns: arsListingColumns.map((column)=>({
                        ...column,
                        headerHeight: row.height
                    }))
            });
            else {
                const bodyRowIndex = arsListingBody.arsBodyRows.findIndex((r)=>r.id === rowId);
                /* istanbul ignore else -- scaffold only passes rowIds built from arsBodyRows */ if (bodyRowIndex !== -1) dispatch({
                    operation: (0, $8A1Qb.ARSL_SET_ROW_HEIGHT),
                    rowId: rowId,
                    rowHeight: row.height
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "d-flex flex-row",
                style: {
                    width: "100%",
                    minWidth: 0,
                    minHeight: "500px"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        width: "100%",
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "d-flex flex-row gap-1",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ey46M.ArsListingContextMenuProvider), {
                                    selectedColumns: arsListingColumns,
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3k2bR.Scaffold), {
                                        id: id,
                                        cellComponent: (0, $2vnze.ArsListingCellEditorProps)(state.settings.editorProps),
                                        cellData: scaffoldModel.cellData,
                                        columns: scaffoldModel.columns,
                                        disabled: disabled,
                                        justification: justification,
                                        onChangeCol: handleChangeCol,
                                        onChangeRow: handleChangeRow,
                                        onDrop: arsContext.state.currentSidebar.view === "variable" ? handleScaffoldDrop : undefined,
                                        rows: scaffoldModel.rows,
                                        style: state.settings.style,
                                        zoneColors: arsContext.state.currentSidebar.view === "variable" ? (0, $hdg2u.arsListingZoneColorResolver) : ()=>({
                                                color: null
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iIa81.ArsListingAddColumnButton), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "ars-listing-footer",
                            style: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iCEGP.ArsListingAddRowButton), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2FEZT.ArsDraggableSidebar), {
                showGroupingFactors: true,
                showOperations: false,
                showVariables: true,
                style: state.settings.sidebarStyle
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eYQSj.ArsListingColumnProperties), {})
        ]
    });
};
$993850779e38dcf0$export$918e1fc4c9b36de5.displayName = "ArsListingContent";

});
parcelRegister("iIa81", function(module, exports) {

$parcel$export(module.exports, "ArsListingAddColumnButton", function () { return $75e7b595b24f4877$export$5acfa20267893247; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $75e7b595b24f4877$export$5acfa20267893247 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    if (!state || state.settings.disabled) return null;
    const totalCols = state.bodyData.arsListingColumns.length;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "ars-listing-add-column-button",
        title: "Add blank column",
        role: "button",
        tabIndex: 0,
        onClick: ()=>{
            const colId = crypto.randomUUID();
            dispatch({
                operation: (0, $8A1Qb.ARSL_ADD_BLANK_COLUMN),
                colIx: totalCols,
                colId: colId
            });
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
            "aria-label": "Add column"
        })
    });
};
$75e7b595b24f4877$export$5acfa20267893247.displayName = "ArsListingAddColumnButton";

});
parcelRegister("bsFOF", function(module, exports) {

$parcel$export(module.exports, "ArsListingContextProvider", function () { return $bcd30983ea72cb41$export$bb061f9f796add9a; });
$parcel$export(module.exports, "useArsListing", function () { return $bcd30983ea72cb41$export$d63771a112713ff8; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $igkXn = parcelRequire("igkXn");
parcelRequire("9VYub");
var $6pMR2 = parcelRequire("6pMR2");
var $gE8Gl = parcelRequire("gE8Gl");

var $8A1Qb = parcelRequire("8A1Qb");
const $bcd30983ea72cb41$export$7c5696f82472f580 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $bcd30983ea72cb41$export$bb061f9f796add9a = ({ children: children, bodyData: bodyData, calculatedTableRows: calculatedTableRows, settings: settings, updateBodyData: updateBodyData })=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $igkXn.arsListingReducer), {
        bodyData: bodyData,
        calculatedTableRows: calculatedTableRows,
        scaffoldModel: (0, $6pMR2.buildScaffoldFromCalculatedRows)(calculatedTableRows, settings.editorProps),
        changed: false,
        datasets: (0, $gE8Gl.datasetsFromColumns)(bodyData.arsListingColumns),
        settings: settings
    });
    (0, $7fPBF.useEffect)(()=>{
        const eq = (0, $gSkQi.isEqual)(state.bodyData, bodyData);
        // Send changes up
        if (!eq && state.bodyData.id === bodyData.id && state.changed) {
            updateBodyData(state.bodyData);
            dispatch({
                operation: (0, $8A1Qb.ARSL_CHANGE_SENT)
            });
        } else if (state.bodyData.id !== bodyData.id || !eq) dispatch({
            operation: (0, $8A1Qb.ARSL_LOAD_DATA),
            bodyData: bodyData
        });
    }, [
        bodyData,
        state.changed,
        state.bodyData,
        updateBodyData
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $gSkQi.isEqual)(state.settings.tlfViewMode, settings.tlfViewMode)) dispatch({
            operation: (0, $8A1Qb.ARSL_SET_TLF_VIEW_MODE),
            tlfViewMode: settings.tlfViewMode
        });
    }, [
        settings.tlfViewMode,
        state.settings.tlfViewMode
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const eq = (0, $gSkQi.isEqual)(state.calculatedTableRows, calculatedTableRows ?? []);
        if (!eq && calculatedTableRows) dispatch({
            operation: (0, $8A1Qb.ARSL_UPDATE_SCAFFOLD),
            calculatedTableRows: calculatedTableRows
        });
    }, [
        calculatedTableRows,
        state.calculatedTableRows
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bcd30983ea72cb41$export$7c5696f82472f580.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$bcd30983ea72cb41$export$bb061f9f796add9a.displayName = "ArsListingContextProvider";
const $bcd30983ea72cb41$export$d63771a112713ff8 = ()=>{
    const context = (0, $7fPBF.useContext)($bcd30983ea72cb41$export$7c5696f82472f580);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
};

});
parcelRegister("igkXn", function(module, exports) {

$parcel$export(module.exports, "arsListingReducer", function () { return $b04469ca2cee1ee2$export$575da89f0b9456a2; });
parcelRequire("9VYub");
var $1eEiI = parcelRequire("1eEiI");
var $aaZgE = parcelRequire("aaZgE");
var $jgOa1 = parcelRequire("jgOa1");
var $8gm0i = parcelRequire("8gm0i");
var $aC1hs = parcelRequire("aC1hs");
var $OfFpi = parcelRequire("OfFpi");
var $ihJSG = parcelRequire("ihJSG");
var $1vGeP = parcelRequire("1vGeP");
var $cSebs = parcelRequire("cSebs");
var $7ao1K = parcelRequire("7ao1K");
var $g65sx = parcelRequire("g65sx");
var $hvCDU = parcelRequire("hvCDU");
var $i4FhC = parcelRequire("i4FhC");
var $8RWYf = parcelRequire("8RWYf");
var $4zGre = parcelRequire("4zGre");
var $febCJ = parcelRequire("febCJ");
var $7i1R6 = parcelRequire("7i1R6");

var $eX5o6 = parcelRequire("eX5o6");

var $8A1Qb = parcelRequire("8A1Qb");
const $b04469ca2cee1ee2$export$575da89f0b9456a2 = (state, action)=>{
    switch(action.operation){
        case 0, $8A1Qb.ARSL_ADD_BLANK_COLUMN:
            return (0, $eX5o6.arsl_addBlankColumn)(state, action);
        case 0, $8A1Qb.ARSL_ADD_ROW:
            return (0, $1eEiI.arsl_addRow)(state, action);
        case 0, $8A1Qb.ARSL_ADD_VARIABLES_TO_COLUMN:
            return (0, $aaZgE.arsl_addVariablesToColumn)(state, action);
        case 0, $8A1Qb.ARSL_ALIGN_TEXT:
            return (0, $jgOa1.arsl_alignText)(state, action);
        case 0, $8A1Qb.ARSL_APPLY_DROPPED_COLUMNS:
            return (0, $8gm0i.arsl_applyDroppedColumns)(state, action);
        case 0, $8A1Qb.ARSL_APPLY_DROPPED_SORT_COLUMNS:
            return (0, $aC1hs.arsl_applyDroppedSortColumns)(state, action);
        case 0, $8A1Qb.ARSL_CELL_UPDATE:
            return (0, $OfFpi.arsl_cellUpdate)(state, action);
        case 0, $8A1Qb.ARSL_COLUMN_UPDATE:
            return (0, $1vGeP.arsl_columnUpdate)(state, action);
        case 0, $8A1Qb.ARSL_CHANGE_SENT:
            return (0, $ihJSG.arsl_changeSent)(state);
        case 0, $8A1Qb.ARSL_LOAD_DATA:
            return (0, $cSebs.arsl_loadData)(state, action);
        case 0, $8A1Qb.ARSL_REMOVE_COLUMN:
            return (0, $7ao1K.arsl_removeColumn)(state, action);
        case 0, $8A1Qb.ARSL_REMOVE_ROW:
            return (0, $g65sx.arsl_removeRow)(state, action);
        case 0, $8A1Qb.ARSL_SET_COLUMNS:
            return (0, $hvCDU.arsl_setColumns)(state, action);
        case 0, $8A1Qb.ARSL_SET_ROW_HEIGHT:
            return (0, $i4FhC.arsl_setRowHeight)(state, action);
        case 0, $8A1Qb.ARSL_SET_TLF_VIEW_MODE:
            return (0, $8RWYf.arsl_setTlfViewMode)(state, action);
        case 0, $8A1Qb.ARSL_SET_VARIABLE_FILTER:
            return (0, $4zGre.arsl_setVariableFilter)(state, action);
        case 0, $8A1Qb.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID:
            return (0, $febCJ.arsl_setViewColumnPropertiesId)(state, action);
        case 0, $8A1Qb.ARSL_UPDATE_SCAFFOLD:
            return (0, $7i1R6.arsl_updateScaffold)(state, action);
    }
    return state;
};

});
parcelRegister("9VYub", function(module, exports) {
$parcel$export(module.exports, "arsl_addRow", function () { return (parcelRequire("1eEiI")).arsl_addRow; });
$parcel$export(module.exports, "arsl_addVariablesToColumn", function () { return (parcelRequire("aaZgE")).arsl_addVariablesToColumn; });
$parcel$export(module.exports, "arsl_alignText", function () { return (parcelRequire("jgOa1")).arsl_alignText; });
$parcel$export(module.exports, "arsl_applyDroppedColumns", function () { return (parcelRequire("8gm0i")).arsl_applyDroppedColumns; });
$parcel$export(module.exports, "arsl_applyDroppedSortColumns", function () { return (parcelRequire("aC1hs")).arsl_applyDroppedSortColumns; });
$parcel$export(module.exports, "arsl_cellUpdate", function () { return (parcelRequire("OfFpi")).arsl_cellUpdate; });
$parcel$export(module.exports, "arsl_changeSent", function () { return (parcelRequire("ihJSG")).arsl_changeSent; });
$parcel$export(module.exports, "arsl_columnUpdate", function () { return (parcelRequire("1vGeP")).arsl_columnUpdate; });
$parcel$export(module.exports, "arsl_loadData", function () { return (parcelRequire("cSebs")).arsl_loadData; });
$parcel$export(module.exports, "arsl_removeColumn", function () { return (parcelRequire("7ao1K")).arsl_removeColumn; });
$parcel$export(module.exports, "arsl_removeRow", function () { return (parcelRequire("g65sx")).arsl_removeRow; });
$parcel$export(module.exports, "arsl_setColumns", function () { return (parcelRequire("hvCDU")).arsl_setColumns; });
$parcel$export(module.exports, "arsl_setRowHeight", function () { return (parcelRequire("i4FhC")).arsl_setRowHeight; });
$parcel$export(module.exports, "arsl_setTlfViewMode", function () { return (parcelRequire("8RWYf")).arsl_setTlfViewMode; });
$parcel$export(module.exports, "arsl_setVariableFilter", function () { return (parcelRequire("4zGre")).arsl_setVariableFilter; });
$parcel$export(module.exports, "arsl_setViewColumnPropertiesId", function () { return (parcelRequire("febCJ")).arsl_setViewColumnPropertiesId; });
$parcel$export(module.exports, "arsl_updateScaffold", function () { return (parcelRequire("7i1R6")).arsl_updateScaffold; });
$parcel$export(module.exports, "arsListingZoneColorResolver", function () { return (parcelRequire("hdg2u")).arsListingZoneColorResolver; });
$parcel$export(module.exports, "buildApplyDroppedColumnsAction", function () { return (parcelRequire("gptzB")).buildApplyDroppedColumnsAction; });
$parcel$export(module.exports, "buildScaffoldFromCalculatedRows", function () { return (parcelRequire("6pMR2")).buildScaffoldFromCalculatedRows; });
$parcel$export(module.exports, "datasetsFromColumns", function () { return (parcelRequire("gE8Gl")).datasetsFromColumns; });
parcelRequire("1eEiI");
parcelRequire("aaZgE");
parcelRequire("jgOa1");
parcelRequire("8gm0i");
parcelRequire("aC1hs");
parcelRequire("OfFpi");
parcelRequire("ihJSG");
parcelRequire("1vGeP");
parcelRequire("cSebs");
parcelRequire("7ao1K");
parcelRequire("g65sx");
parcelRequire("hvCDU");
parcelRequire("i4FhC");
parcelRequire("8RWYf");
parcelRequire("4zGre");
parcelRequire("febCJ");
parcelRequire("7i1R6");
parcelRequire("hdg2u");
parcelRequire("gptzB");
parcelRequire("6pMR2");
parcelRequire("gE8Gl");

});
parcelRegister("1eEiI", function(module, exports) {

$parcel$export(module.exports, "arsl_addRow", function () { return $25f46a0f217843b0$export$a452f9d2653afda; });
const $25f46a0f217843b0$export$a452f9d2653afda = (state, action)=>{
    const targetIndex = state.bodyData.arsBodyRows.findIndex((row)=>row.id === action.rowId);
    const insertAt = targetIndex + 1;
    const updatedRows = [
        ...state.bodyData.arsBodyRows.slice(0, insertAt),
        {
            id: crypto.randomUUID(),
            rowHeight: 34,
            ellipsis: action.type === "ellipsis"
        },
        ...state.bodyData.arsBodyRows.slice(insertAt)
    ];
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsBodyRows: updatedRows
        }
    };
};

});

parcelRegister("aaZgE", function(module, exports) {

$parcel$export(module.exports, "arsl_addVariablesToColumn", function () { return $d1865986063985f9$export$cb35876320fd6625; });

var $gptzB = parcelRequire("gptzB");
const $d1865986063985f9$export$cb35876320fd6625 = (state, action)=>{
    const targetColumn = state.bodyData.arsListingColumns.find((col)=>col.id === action.colId);
    if (!targetColumn) return state;
    const textToT = state.settings.editorProps.textToT;
    const getTextFromT = state.settings.editorProps.getTextFromT;
    const newDisplayPattern = [
        ...targetColumn.displayPattern.map((displayPattern)=>getTextFromT(displayPattern)),
        ...action.variables.map((variable)=>(0, $gptzB.resolvePlaceholderText)(variable.dataType))
    ].join("/");
    const newHeaderText = [
        getTextFromT(targetColumn.headerText),
        ...action.variables.map((variable)=>variable.description?.trim() !== "" ? variable.description : variable.name)
    ].join("/");
    const newResultPattern = [
        targetColumn.resultPattern,
        ...action.variables.map((variable)=>`{${variable.name.toLowerCase()}}`)
    ].join("/");
    const newColumn = {
        ...targetColumn,
        displayPattern: [
            textToT(newDisplayPattern)
        ],
        resultPattern: newResultPattern,
        headerText: textToT(newHeaderText),
        variables: [
            ...targetColumn.variables,
            ...action.variables.map((variable)=>({
                    id: crypto.randomUUID(),
                    dataset: variable.dataset,
                    variable: variable.name,
                    variableType: "displayOnly"
                }))
        ]
    };
    const newState = {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: state.bodyData.arsListingColumns.map((col)=>col.id === action.colId ? newColumn : col)
        }
    };
    // Check new datasets
    if (newColumn.variables.some((v)=>!state.datasets.has(v.dataset))) newState.datasets = new Set([
        ...state.datasets,
        ...newColumn.variables.map((v)=>v.dataset)
    ]);
    return newState;
};

});
parcelRegister("gptzB", function(module, exports) {

$parcel$export(module.exports, "resolvePlaceholderText", function () { return $4a7d83d0e8027255$export$6226a6356d56e9d9; });
$parcel$export(module.exports, "buildApplyDroppedColumnsAction", function () { return $4a7d83d0e8027255$export$1bb0b1f17dd71c6f; });

var $4qgA8 = parcelRequire("4qgA8");

var $8A1Qb = parcelRequire("8A1Qb");
/**
 * Parses a JSON drop payload string into an array of ArsListing variables.
 *
 * @param jsonPayload - Raw JSON string from a DataTransfer object
 * @returns Parsed variable list, or an empty array when the payload is invalid
 */ const $4a7d83d0e8027255$var$parseVariables = (jsonPayload)=>{
    try {
        const parsed = JSON.parse(jsonPayload);
        const parsedDataArray = typeof parsed === "object" ? Array.isArray(parsed.data) ? parsed.data : [
            parsed.data
        ] : [];
        const variables = parsedDataArray.map((item)=>item.dropItem).filter((0, $4qgA8.isAnnotationVariable));
        return variables;
    } catch  {
        return [];
    }
};
const $4a7d83d0e8027255$export$6226a6356d56e9d9 = (dataType)=>{
    switch(dataType.toLowerCase()){
        case "boolean":
            return "true/false";
        case "datetime":
            return "01Jan2025 12:00";
        case "date":
            return "01Jan2025";
        case "time":
            return "12:00";
        case "integer":
        case "float":
        case "double":
        case "number":
        case "numeric":
        case "decimal":
            return "xx.x";
        default:
            return "xxxxx";
    }
};
/**
 * Maps a scaffold drop zone to a column placement action.
 *
 * @param zone - Classified drop zone within the target cell
 * @returns Column placement action
 */ const $4a7d83d0e8027255$var$resolveDropAction = (zone)=>{
    if ((0, $8A1Qb.LEFT_HEADER_ZONES).includes(zone)) return "insert-before";
    else if ((0, $8A1Qb.RIGHT_HEADER_ZONES).includes(zone)) return "insert-after";
    else return "replace";
};
function $4a7d83d0e8027255$export$1bb0b1f17dd71c6f(jsonPayload, colId, zone, textToT) {
    const variables = $4a7d83d0e8027255$var$parseVariables(jsonPayload);
    if (variables.length === 0) return null;
    if ((0, $8A1Qb.BOTTOM_HEADER_ZONES).includes(zone) && colId !== (0, $8A1Qb.EMPTY_HEADER_COL_ID)) return {
        operation: (0, $8A1Qb.ARSL_ADD_VARIABLES_TO_COLUMN),
        colId: colId,
        variables: variables
    };
    const columns = variables.map((variable)=>{
        const placeholderText = $4a7d83d0e8027255$export$6226a6356d56e9d9(variable.dataType);
        const displayPattern = [
            textToT(placeholderText)
        ];
        const resultPattern = `{${variable.name.toLowerCase()}}`;
        const headerText = textToT(variable.description?.trim() !== "" ? variable.description : variable.name);
        return {
            id: crypto.randomUUID(),
            columnWidth: (0, $8A1Qb.ARSL_DEFAULT_COLUMN_WIDTH),
            displayPattern: displayPattern,
            resultPattern: resultPattern,
            headerText: headerText,
            variables: [
                {
                    id: crypto.randomUUID(),
                    dataset: variable.dataset,
                    variable: variable.name,
                    variableType: "displayOnly"
                }
            ]
        };
    });
    return {
        operation: (0, $8A1Qb.ARSL_APPLY_DROPPED_COLUMNS),
        colId: colId,
        columns: columns,
        dropAction: $4a7d83d0e8027255$var$resolveDropAction(zone)
    };
}

});
parcelRegister("8A1Qb", function(module, exports) {

$parcel$export(module.exports, "ARSL_DEFAULT_COLUMN_WIDTH", function () { return $f0d1ebb5275c7523$export$44f8c3d174a4d96; });
$parcel$export(module.exports, "HEADER_ROW_ID", function () { return $f0d1ebb5275c7523$export$a721ca93c346c699; });
$parcel$export(module.exports, "EMPTY_HEADER_COL_ID", function () { return $f0d1ebb5275c7523$export$ffa019c98ea23dbb; });
$parcel$export(module.exports, "ARSL_ADD_BLANK_COLUMN", function () { return $f0d1ebb5275c7523$export$5fce5e704635675e; });
$parcel$export(module.exports, "ARSL_ADD_ROW", function () { return $f0d1ebb5275c7523$export$db5e3b0d3f7bb985; });
$parcel$export(module.exports, "ARSL_ADD_VARIABLES_TO_COLUMN", function () { return $f0d1ebb5275c7523$export$44766ae23dffaa6d; });
$parcel$export(module.exports, "ARSL_ALIGN_TEXT", function () { return $f0d1ebb5275c7523$export$570ec6e2b98dfc6d; });
$parcel$export(module.exports, "ARSL_APPLY_DROPPED_COLUMNS", function () { return $f0d1ebb5275c7523$export$29d129289d7e12de; });
$parcel$export(module.exports, "ARSL_APPLY_DROPPED_SORT_COLUMNS", function () { return $f0d1ebb5275c7523$export$9f3c533acc804246; });
$parcel$export(module.exports, "ARSL_CELL_UPDATE", function () { return $f0d1ebb5275c7523$export$b6c3821a1eb72b88; });
$parcel$export(module.exports, "ARSL_CHANGE_SENT", function () { return $f0d1ebb5275c7523$export$ccea787a9f2e730a; });
$parcel$export(module.exports, "ARSL_COLUMN_UPDATE", function () { return $f0d1ebb5275c7523$export$b81ea38594802f40; });
$parcel$export(module.exports, "ARSL_LOAD_DATA", function () { return $f0d1ebb5275c7523$export$350c0380e4705ad4; });
$parcel$export(module.exports, "ARSL_REMOVE_COLUMN", function () { return $f0d1ebb5275c7523$export$a89107a5dd1f225; });
$parcel$export(module.exports, "ARSL_REMOVE_ROW", function () { return $f0d1ebb5275c7523$export$fe4b47de842515fc; });
$parcel$export(module.exports, "ARSL_SET_COLUMNS", function () { return $f0d1ebb5275c7523$export$d36d0fbebee1931a; });
$parcel$export(module.exports, "ARSL_SET_ROW_HEIGHT", function () { return $f0d1ebb5275c7523$export$913bdfd40ec3aaee; });
$parcel$export(module.exports, "ARSL_SET_TLF_VIEW_MODE", function () { return $f0d1ebb5275c7523$export$3d99936c4a6c70b; });
$parcel$export(module.exports, "ARSL_SET_VARIABLE_FILTER", function () { return $f0d1ebb5275c7523$export$a6c62932fb112c5e; });
$parcel$export(module.exports, "ARSL_SET_VIEW_COLUMN_PROPERTIES_ID", function () { return $f0d1ebb5275c7523$export$2ef97af8c15aad9d; });
$parcel$export(module.exports, "ARSL_UPDATE_SCAFFOLD", function () { return $f0d1ebb5275c7523$export$b92f08f85dc30d43; });
$parcel$export(module.exports, "LEFT_HEADER_ZONES", function () { return $f0d1ebb5275c7523$export$6252eef46558336d; });
$parcel$export(module.exports, "CENTRE_HEADER_ZONES", function () { return $f0d1ebb5275c7523$export$f3256a048c3f3c69; });
$parcel$export(module.exports, "RIGHT_HEADER_ZONES", function () { return $f0d1ebb5275c7523$export$9114f44185bfc9f6; });
$parcel$export(module.exports, "BOTTOM_HEADER_ZONES", function () { return $f0d1ebb5275c7523$export$77da637b1b6e60a7; });
parcelRequire("6rtuc");
var $4zamZ = parcelRequire("4zamZ");
const $f0d1ebb5275c7523$export$44f8c3d174a4d96 = 200;
const $f0d1ebb5275c7523$export$a721ca93c346c699 = "ars-listing-header-row";
const $f0d1ebb5275c7523$export$ffa019c98ea23dbb = "ars-listing-empty-header-col";
const $f0d1ebb5275c7523$export$5fce5e704635675e = "ARSL_ADD_BLANK_COLUMN";
const $f0d1ebb5275c7523$export$db5e3b0d3f7bb985 = "ARSL_ADD_ROW";
const $f0d1ebb5275c7523$export$44766ae23dffaa6d = "ARSL_ADD_VARIABLES_TO_COLUMN";
const $f0d1ebb5275c7523$export$570ec6e2b98dfc6d = "ARSL_ALIGN_TEXT";
const $f0d1ebb5275c7523$export$29d129289d7e12de = "ARSL_APPLY_DROPPED_COLUMNS";
const $f0d1ebb5275c7523$export$9f3c533acc804246 = "ARSL_APPLY_DROPPED_SORT_COLUMNS";
const $f0d1ebb5275c7523$export$b6c3821a1eb72b88 = "ARSL_CELL_UPDATE";
const $f0d1ebb5275c7523$export$ccea787a9f2e730a = "ARSL_CHANGE_SENT";
const $f0d1ebb5275c7523$export$b81ea38594802f40 = "ARSL_COLUMN_UPDATE";
const $f0d1ebb5275c7523$export$350c0380e4705ad4 = "ARSL_LOAD_DATA";
const $f0d1ebb5275c7523$export$a89107a5dd1f225 = "ARSL_REMOVE_COLUMN";
const $f0d1ebb5275c7523$export$fe4b47de842515fc = "ARSL_REMOVE_ROW";
const $f0d1ebb5275c7523$export$3ba6fd23c11c3238 = "ARSL_SET_CHANGED";
const $f0d1ebb5275c7523$export$d36d0fbebee1931a = "ARSL_SET_COLUMNS";
const $f0d1ebb5275c7523$export$913bdfd40ec3aaee = "ARSL_SET_ROW_HEIGHT";
const $f0d1ebb5275c7523$export$3d99936c4a6c70b = "ARSL_SET_TLF_VIEW_MODE";
const $f0d1ebb5275c7523$export$a6c62932fb112c5e = "ARSL_SET_VARIABLE_FILTER";
const $f0d1ebb5275c7523$export$2ef97af8c15aad9d = "ARSL_SET_VIEW_COLUMN_PROPERTIES_ID";
const $f0d1ebb5275c7523$export$b92f08f85dc30d43 = "ARSL_UPDATE_SCAFFOLD";
const $f0d1ebb5275c7523$export$6252eef46558336d = [
    (0, $4zamZ.ScaffoldDropZone).TopLeft,
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).LeftEdgeBottom
];
const $f0d1ebb5275c7523$export$f3256a048c3f3c69 = [
    (0, $4zamZ.ScaffoldDropZone).TopEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).TopEdgeRight,
    (0, $4zamZ.ScaffoldDropZone).CentreTopLeft,
    (0, $4zamZ.ScaffoldDropZone).CentreTopRight,
    (0, $4zamZ.ScaffoldDropZone).CentreBottomLeft,
    (0, $4zamZ.ScaffoldDropZone).CentreBottomRight
];
const $f0d1ebb5275c7523$export$9114f44185bfc9f6 = [
    (0, $4zamZ.ScaffoldDropZone).TopRight,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeTop,
    (0, $4zamZ.ScaffoldDropZone).RightEdgeBottom
];
const $f0d1ebb5275c7523$export$77da637b1b6e60a7 = [
    (0, $4zamZ.ScaffoldDropZone).BottomLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeLeft,
    (0, $4zamZ.ScaffoldDropZone).BottomEdgeRight,
    (0, $4zamZ.ScaffoldDropZone).BottomRight
];

});



parcelRegister("jgOa1", function(module, exports) {

$parcel$export(module.exports, "arsl_alignText", function () { return $4274d9493409a79d$export$84f09db62243ed6f; });
const $4274d9493409a79d$export$84f09db62243ed6f = (state, action)=>{
    const updatedColumns = state.bodyData.arsListingColumns.map((column)=>column.id === action.colId ? {
            ...column,
            [action.isHeader ? "headerTextAlignment" : "bodyTextAlignment"]: action.alignment
        } : column);
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: updatedColumns
        }
    };
};

});

parcelRegister("8gm0i", function(module, exports) {

$parcel$export(module.exports, "arsl_applyDroppedColumns", function () { return $ba2ffdec873200ee$export$c61a9ec237dbc53; });

var $8A1Qb = parcelRequire("8A1Qb");

var $gE8Gl = parcelRequire("gE8Gl");
const $ba2ffdec873200ee$export$c61a9ec237dbc53 = (state, action)=>{
    if (state.bodyData.arsListingColumns.length >= 20) return state;
    const existingColumns = state.bodyData.arsListingColumns;
    if (existingColumns.length === 0 || action.colId === (0, $8A1Qb.EMPTY_HEADER_COL_ID)) return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: action.columns.slice(0, 20)
        }
    };
    const targetIndex = existingColumns.findIndex((column)=>column.id === action.colId);
    let updatedColumns;
    if (targetIndex < 0) updatedColumns = [
        ...existingColumns,
        ...action.columns
    ];
    else if (action.dropAction === "insert-before") updatedColumns = [
        ...existingColumns.slice(0, targetIndex),
        ...action.columns,
        ...existingColumns.slice(targetIndex)
    ];
    else if (action.dropAction === "insert-after") updatedColumns = [
        ...existingColumns.slice(0, targetIndex + 1),
        ...action.columns,
        ...existingColumns.slice(targetIndex + 1)
    ];
    else {
        const [replacementColumn, ...remainingColumns] = action.columns;
        const nextColumns = [
            ...existingColumns
        ];
        nextColumns[targetIndex] = replacementColumn;
        if (remainingColumns.length > 0) nextColumns.splice(targetIndex + 1, 0, ...remainingColumns);
        updatedColumns = nextColumns;
    }
    const newState = {
        ...state,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: updatedColumns.slice(0, 20)
        },
        changed: true,
        datasets: (0, $gE8Gl.datasetsFromColumns)(updatedColumns)
    };
    return newState;
};

});
parcelRegister("gE8Gl", function(module, exports) {

$parcel$export(module.exports, "datasetsFromColumns", function () { return $8302cbddeacf0289$export$77e7561f74373956; });
parcelRequire("6yroJ");
var $fAJMp = parcelRequire("fAJMp");
var $cNv0d = parcelRequire("cNv0d");
var $5KlUB = parcelRequire("5KlUB");
var $jc9tE = parcelRequire("jc9tE");
const $8302cbddeacf0289$export$84cc69fa060e55b1 = (columns)=>{
    const datasets = new Set();
    const variables = new Set();
    columns.forEach((column)=>{
        column.variables.forEach((variable)=>{
            datasets.add(variable.dataset.toUpperCase());
            variables.add(`${variable.dataset}.${variable.variable}`.toUpperCase());
        });
        if (column.caseWhenCondition) $8302cbddeacf0289$export$733df0fb66151793([
            column.caseWhenCondition
        ]).forEach((caseWhenVariable)=>{
            variables.add(caseWhenVariable.toUpperCase());
            const [dataset] = caseWhenVariable.split(".");
            if (dataset) datasets.add(dataset.toUpperCase());
        });
    });
    return {
        datasets: datasets,
        variables: variables
    };
};
const $8302cbddeacf0289$export$77e7561f74373956 = (columns)=>{
    return $8302cbddeacf0289$export$84cc69fa060e55b1(columns).datasets;
};
const $8302cbddeacf0289$export$733df0fb66151793 = (caseWhenConditions)=>{
    const variables = new Set();
    caseWhenConditions.forEach((caseWhen)=>{
        caseWhen.caseWhenItems.forEach((item)=>{
            if (item.when) $8302cbddeacf0289$export$53eb125b3e27834d(item.when).forEach((variable)=>{
                variables.add(variable.toUpperCase());
            });
        });
    });
    return variables;
};
const $8302cbddeacf0289$export$d7dd435d21d58c23 = (condition)=>{
    const variables = new Set();
    if (condition.variable) variables.add(`${condition.dataset ?? ""}.${condition.variable}`.toUpperCase());
    return variables;
};
const $8302cbddeacf0289$export$67cc1df9fc753923 = (compoundExpression)=>{
    const variables = new Set();
    compoundExpression.whereClauses?.forEach((sc)=>{
        if ((0, $cNv0d.isSubClauseWithCondition)(sc)) $8302cbddeacf0289$export$d7dd435d21d58c23(sc.condition).forEach((variable)=>{
            variables.add(variable.toUpperCase());
        });
        else if ((0, $fAJMp.isSubClauseWithCompoundExpression)(sc)) $8302cbddeacf0289$export$67cc1df9fc753923(sc.compoundExpression).forEach((variable)=>{
            variables.add(variable.toUpperCase());
        });
        else if ((0, $5KlUB.isSubClauseWithReference)(sc)) $8302cbddeacf0289$export$a30ae6c413e0164b(sc.subClauseId).forEach((variable)=>{
            variables.add(variable.toUpperCase());
        });
    });
    return variables;
};
const $8302cbddeacf0289$export$53eb125b3e27834d = (whereClause)=>{
    if ((0, $jc9tE.isWhereClauseWithCondition)(whereClause)) return $8302cbddeacf0289$export$d7dd435d21d58c23(whereClause.condition);
    else return $8302cbddeacf0289$export$67cc1df9fc753923(whereClause.compoundExpression);
};
const $8302cbddeacf0289$export$a30ae6c413e0164b = (subClauseId)=>{
    return new Set([
        `ARS_REF: ${subClauseId.toUpperCase()}`
    ]);
};

});


parcelRegister("aC1hs", function(module, exports) {

$parcel$export(module.exports, "arsl_applyDroppedSortColumns", function () { return $a23eec140ee573f8$export$52c25efc7e3e10fd; });
parcelRequire("kevCO");
var $clOgJ = parcelRequire("clOgJ");
const $a23eec140ee573f8$export$52c25efc7e3e10fd = (state, action)=>{
    const targetColumnVars = state.bodyData.arsListingColumns.find((column)=>column.id === action.colId)?.variables;
    if (!targetColumnVars) return state;
    /* Get jsonPayload - should be ArsSidebarItemVariable[] */ try {
        const jsonData = JSON.parse(action.jsonPayload).data;
        if (!jsonData || !Array.isArray(jsonData) || !jsonData.length || jsonData.some((item)=>!(0, $clOgJ.isArsSidebarItemData)(item) || item.kind !== "variable")) return state;
        const newSortVars = jsonData.map((item)=>({
                id: crypto.randomUUID(),
                dataset: item.dropItem.dataset,
                variable: item.dropItem.name,
                variableType: "hidden-sort"
            }));
        const newVariables = [
            ...targetColumnVars.slice(0, action.variableIndex),
            ...newSortVars,
            ...targetColumnVars.slice(action.variableIndex)
        ];
        const newColumns = state.bodyData.arsListingColumns.map((column)=>column.id === action.colId ? {
                ...column,
                variables: newVariables
            } : column);
        const newState = {
            ...state,
            bodyData: {
                ...state.bodyData,
                arsListingColumns: newColumns
            },
            changed: true
        };
        // Check new datasets
        if (newSortVars.some((ds)=>!state.datasets.has(ds.dataset))) newState.datasets = new Set([
            ...state.datasets,
            ...newSortVars.map((v)=>v.dataset)
        ]);
        return newState;
    } catch  {
        return state;
    }
};

});

parcelRegister("OfFpi", function(module, exports) {

$parcel$export(module.exports, "arsl_cellUpdate", function () { return $8d3b359baedd725b$export$a5610229829d3479; });

var $8A1Qb = parcelRequire("8A1Qb");
const $8d3b359baedd725b$export$a5610229829d3479 = (state, action)=>{
    const targetColumn = state.bodyData.arsListingColumns.find((col)=>col.id === action.colId);
    if (!targetColumn) return state;
    /* Update from a header cell */ if (action.rowId === (0, $8A1Qb.HEADER_ROW_ID)) {
        if (state.settings.tlfViewMode.value === "ANNOTATIONS") return state;
        const updatedColumn = {
            ...targetColumn,
            headerText: action.value
        };
        return {
            ...state,
            changed: true,
            bodyData: {
                ...state.bodyData,
                arsListingColumns: state.bodyData.arsListingColumns.map((col)=>col.id === action.colId ? updatedColumn : col)
            }
        };
    }
    /* Update from a body cell */ const updatedColumn = {
        ...targetColumn
    };
    /* Update to annotations */ if (state.settings.tlfViewMode.value === "ANNOTATIONS") updatedColumn.resultPattern = state.settings.editorProps.getTextFromT(action.value).join("\n");
    else {
        /* Update to disable pattern */ const rowIndex = state.bodyData.arsBodyRows.findIndex((row)=>row.id === action.rowId);
        /* Update a the only displayPattern in the column if it's the first row and the column has a single displayPattern */ if (updatedColumn.displayPattern.length === 1) {
            if (rowIndex <= 0) updatedColumn.displayPattern = [
                action.value
            ];
            else {
                /* Change to a displayPattern array */ const displayPatternArray = new Array(state.bodyData.arsBodyRows.length).fill(updatedColumn.displayPattern[0]);
                displayPatternArray[rowIndex] = action.value;
                updatedColumn.displayPattern = displayPatternArray;
            }
        } else {
            /* Update existing displayPattern array */ const displayPatternArray = [
                ...updatedColumn.displayPattern
            ];
            /* Extend the array if the rowIndex is greater than the current length */ while(rowIndex >= displayPatternArray.length)displayPatternArray.push(...updatedColumn.displayPattern);
            displayPatternArray[rowIndex] = action.value;
            updatedColumn.displayPattern = displayPatternArray;
        }
    }
    /* Create new array */ const updatedColumns = state.bodyData.arsListingColumns.map((col)=>col.id === action.colId ? updatedColumn : col);
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: updatedColumns
        }
    };
};

});

parcelRegister("ihJSG", function(module, exports) {

$parcel$export(module.exports, "arsl_changeSent", function () { return $b9345c96e7a56455$export$448e6498526c95f7; });
const $b9345c96e7a56455$export$448e6498526c95f7 = (state)=>({
        ...state,
        changed: false
    });

});

parcelRegister("1vGeP", function(module, exports) {

$parcel$export(module.exports, "arsl_columnUpdate", function () { return $8d62ef6561ce554f$export$15b3baa4a4604709; });
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");

var $gE8Gl = parcelRequire("gE8Gl");
const $8d62ef6561ce554f$export$15b3baa4a4604709 = (state, action)=>{
    const ix = state.bodyData.arsListingColumns.findIndex((col)=>col.id === action.colId);
    if (ix === -1) return state;
    const dataPath = `/bodyData/arsListingColumns/${ix}`;
    const newColumn = {
        ...state.bodyData.arsListingColumns[ix],
        ...action.column
    };
    const newState = (0, $dsPLF.mutateByPath)(state, dataPath, newColumn);
    // Check new datasets
    const actionDatasets = (0, $gE8Gl.datasetsFromColumns)([
        newColumn
    ]);
    const newDatasets = new Set([
        ...state.datasets,
        ...actionDatasets
    ]);
    if (newDatasets.size > state.datasets.size) newState.datasets = newDatasets;
    return {
        ...newState,
        changed: true
    };
};

});

parcelRegister("cSebs", function(module, exports) {

$parcel$export(module.exports, "arsl_loadData", function () { return $347db252ad9b54a8$export$38ae57f74bddbb6f; });

var $gE8Gl = parcelRequire("gE8Gl");
const $347db252ad9b54a8$export$38ae57f74bddbb6f = (state, action)=>({
        ...state,
        bodyData: action.bodyData,
        datasets: (0, $gE8Gl.datasetsFromColumns)(action.bodyData.arsListingColumns),
        changed: false
    });

});

parcelRegister("7ao1K", function(module, exports) {

$parcel$export(module.exports, "arsl_removeColumn", function () { return $f9a5c54dd318f9c5$export$8746c262b165b4d4; });

var $gE8Gl = parcelRequire("gE8Gl");
const $f9a5c54dd318f9c5$export$8746c262b165b4d4 = (state, action)=>{
    if (state.bodyData.arsListingColumns.length <= 1) return state;
    const newState = {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: state.bodyData.arsListingColumns.filter((column)=>column.id !== action.colId)
        }
    };
    // Refresh datasets list
    newState.datasets = (0, $gE8Gl.datasetsFromColumns)(newState.bodyData.arsListingColumns);
    return newState;
};

});

parcelRegister("g65sx", function(module, exports) {

$parcel$export(module.exports, "arsl_removeRow", function () { return $adc199bfd13bef68$export$4e03b044ac474182; });
const $adc199bfd13bef68$export$4e03b044ac474182 = (state, action)=>state.bodyData.arsBodyRows.length <= 1 ? state : {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsBodyRows: state.bodyData.arsBodyRows.filter((row)=>row.id !== action.rowId)
        }
    };

});

parcelRegister("hvCDU", function(module, exports) {

$parcel$export(module.exports, "arsl_setColumns", function () { return $be6e99b97005fc28$export$d4ed0c6524d30911; });

var $gE8Gl = parcelRequire("gE8Gl");
const $be6e99b97005fc28$export$d4ed0c6524d30911 = (state, action)=>({
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: action.columns.slice(0, 20)
        },
        datasets: (0, $gE8Gl.datasetsFromColumns)(action.columns)
    });

});

parcelRegister("i4FhC", function(module, exports) {

$parcel$export(module.exports, "arsl_setRowHeight", function () { return $b1417c14b8294a05$export$75b17e304e06698f; });
const $b1417c14b8294a05$export$75b17e304e06698f = (state, action)=>({
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsBodyRows: state.bodyData.arsBodyRows.map((row)=>row.id === action.rowId ? {
                    ...row,
                    rowHeight: action.rowHeight
                } : row)
        }
    });

});

parcelRegister("8RWYf", function(module, exports) {

$parcel$export(module.exports, "arsl_setTlfViewMode", function () { return $9d6f9f247ccd3b31$export$5067cd37822e11d6; });
const $9d6f9f247ccd3b31$export$5067cd37822e11d6 = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            tlfViewMode: action.tlfViewMode
        }
    });

});

parcelRegister("4zGre", function(module, exports) {

$parcel$export(module.exports, "arsl_setVariableFilter", function () { return $e0f9536ed46d65cf$export$b057419fc26ea6ca; });
const $e0f9536ed46d65cf$export$b057419fc26ea6ca = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            variableFilter: action.variableFilter
        }
    });

});

parcelRegister("febCJ", function(module, exports) {

$parcel$export(module.exports, "arsl_setViewColumnPropertiesId", function () { return $0487ac1294ccec40$export$4f117c9059f03748; });
const $0487ac1294ccec40$export$4f117c9059f03748 = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            viewColumnPropertiesId: action.colId
        }
    });

});

parcelRegister("7i1R6", function(module, exports) {

$parcel$export(module.exports, "arsl_updateScaffold", function () { return $50238bcfe4f27e5e$export$78274a534fcede62; });

var $6pMR2 = parcelRequire("6pMR2");
const $50238bcfe4f27e5e$export$78274a534fcede62 = (state, action)=>({
        ...state,
        calculatedTableRows: action.calculatedTableRows,
        scaffoldModel: (0, $6pMR2.buildScaffoldFromCalculatedRows)(action.calculatedTableRows, state.settings.editorProps)
    });

});
parcelRegister("6pMR2", function(module, exports) {

$parcel$export(module.exports, "buildScaffoldFromCalculatedRows", function () { return $17c170ca423605b9$export$abf95200d511c1a0; });

var $1c7o5 = parcelRequire("1c7o5");

var $8A1Qb = parcelRequire("8A1Qb");
const $17c170ca423605b9$export$abf95200d511c1a0 = (calculatedTableRows, editorDefns)=>{
    const scaffoldModel = (0, $1c7o5.buildArsTableScaffoldModel)(calculatedTableRows, editorDefns);
    const rows = scaffoldModel.rows.map((row)=>{
        const isHeader = row.id === (0, $8A1Qb.HEADER_ROW_ID) || row.type === "header";
        return {
            id: row.id,
            height: row.height,
            rowGroupNumber: isHeader ? 0 : 1,
            rowNumber: row.rowNumber,
            type: isHeader ? "header" : "body"
        };
    });
    return {
        cellData: scaffoldModel.cellData,
        columns: scaffoldModel.columns,
        headerColSpans: scaffoldModel.headerColSpans,
        rows: rows
    };
};

});


parcelRegister("hdg2u", function(module, exports) {

$parcel$export(module.exports, "arsListingZoneColorResolver", function () { return $2b15552d3050d9ff$export$5b89438c23ec2281; });

var $8A1Qb = parcelRequire("8A1Qb");
/**
 * All header drop zones grouped into a single set for use with the empty column header.
 * When there are no existing columns the entire cell acts as one drop target.
 */ const $2b15552d3050d9ff$var$ALL_HEADER_ZONES = [
    ...(0, $8A1Qb.LEFT_HEADER_ZONES),
    ...(0, $8A1Qb.CENTRE_HEADER_ZONES),
    ...(0, $8A1Qb.RIGHT_HEADER_ZONES),
    ...(0, $8A1Qb.BOTTOM_HEADER_ZONES)
];
/**
 * Drop-zone colours used for each header placement action.
 */ const $2b15552d3050d9ff$var$HEADER_ZONE_GROUP_COLORS = {
    left: "var(--bs-primary)",
    centre: "var(--bs-primary)",
    right: "var(--bs-primary)",
    bottom: "var(--bs-primary)"
};
/**
 * Builds a colour resolution result for one grouped header action.
 *
 * @param color - Highlight colour for the grouped action.
 * @param zone - Active drop zone.
 * @param groupedZones - Zones belonging to the same action.
 * @returns Zone highlight result with sibling zones included.
 */ const $2b15552d3050d9ff$var$buildGroupedHeaderZoneResult = (color, zone, groupedZones)=>{
    return {
        color: color,
        additionalHighlightedZones: groupedZones.filter((groupedZone)=>groupedZone !== zone)
    };
};
const $2b15552d3050d9ff$export$5b89438c23ec2281 = ({ rowId: rowId, colId: colId, zone: zone })=>{
    if (rowId !== (0, $8A1Qb.HEADER_ROW_ID)) return {
        color: null,
        additionalHighlightedZones: []
    };
    if (colId === (0, $8A1Qb.EMPTY_HEADER_COL_ID)) return $2b15552d3050d9ff$var$buildGroupedHeaderZoneResult($2b15552d3050d9ff$var$HEADER_ZONE_GROUP_COLORS.left, zone, $2b15552d3050d9ff$var$ALL_HEADER_ZONES);
    if ((0, $8A1Qb.LEFT_HEADER_ZONES).includes(zone)) return $2b15552d3050d9ff$var$buildGroupedHeaderZoneResult($2b15552d3050d9ff$var$HEADER_ZONE_GROUP_COLORS.left, zone, (0, $8A1Qb.LEFT_HEADER_ZONES));
    if ((0, $8A1Qb.RIGHT_HEADER_ZONES).includes(zone)) return $2b15552d3050d9ff$var$buildGroupedHeaderZoneResult($2b15552d3050d9ff$var$HEADER_ZONE_GROUP_COLORS.right, zone, (0, $8A1Qb.RIGHT_HEADER_ZONES));
    if ((0, $8A1Qb.BOTTOM_HEADER_ZONES).includes(zone)) return $2b15552d3050d9ff$var$buildGroupedHeaderZoneResult($2b15552d3050d9ff$var$HEADER_ZONE_GROUP_COLORS.bottom, zone, (0, $8A1Qb.BOTTOM_HEADER_ZONES));
    return $2b15552d3050d9ff$var$buildGroupedHeaderZoneResult($2b15552d3050d9ff$var$HEADER_ZONE_GROUP_COLORS.centre, zone, (0, $8A1Qb.CENTRE_HEADER_ZONES));
};

});


parcelRegister("eX5o6", function(module, exports) {

$parcel$export(module.exports, "arsl_addBlankColumn", function () { return $7e8b0fdd2ffabc81$export$33d9c547b1d61026; });

var $8A1Qb = parcelRequire("8A1Qb");
const $7e8b0fdd2ffabc81$export$33d9c547b1d61026 = (state, action)=>{
    const newColumn = {
        id: action.colId,
        columnWidth: (0, $8A1Qb.ARSL_DEFAULT_COLUMN_WIDTH),
        displayPattern: [
            state.settings.editorProps.blankT
        ],
        headerText: state.settings.editorProps.blankT,
        resultPattern: "",
        variables: []
    };
    const newColumns = [
        ...state.bodyData.arsListingColumns.slice(0, action.colIx),
        newColumn,
        ...state.bodyData.arsListingColumns.slice(action.colIx)
    ];
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: newColumns
        }
    };
};

});




parcelRegister("iCEGP", function(module, exports) {

$parcel$export(module.exports, "ArsListingAddRowButton", function () { return $a02ba697f78d4751$export$9a89baf7ce95c149; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $a02ba697f78d4751$export$9a89baf7ce95c149 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    if (!state || state.settings.disabled) return null;
    const lastRowId = state.bodyData.arsBodyRows[state.bodyData.arsBodyRows.length - 1].id;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "ars-listing-add-row-button",
        title: "Add default row",
        role: "button",
        tabIndex: 0,
        onClick: ()=>{
            dispatch({
                operation: (0, $8A1Qb.ARSL_ADD_ROW),
                rowId: lastRowId,
                type: "default"
            });
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
            "aria-label": "Add row"
        })
    });
};
$a02ba697f78d4751$export$9a89baf7ce95c149.displayName = "ArsListingAddRowButton";

});

parcelRegister("2vnze", function(module, exports) {

$parcel$export(module.exports, "ArsListingCellEditorProps", function () { return $71440376774d0940$export$fe981243cbee0d02; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");
var $eAPMz = parcelRequire("eAPMz");
parcelRequire("loI62");
var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");

var $41gBZ = parcelRequire("41gBZ");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $71440376774d0940$export$33da031833176af6 = ({ id: id, colId: colId, rowId: rowId, value: value })=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    if (!state || !colId || !rowId) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    const isHeaderRow = rowId === (0, $8A1Qb.HEADER_ROW_ID);
    const column = state.bodyData.arsListingColumns.find((col)=>col.id === colId);
    if (!column) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    const textJustification = value.justification;
    const editorProps = state.settings.editorProps;
    const Editor = editorProps.Editor;
    const isAnnotationsView = state.settings.tlfViewMode.value === "ANNOTATIONS";
    const displayValue = value.displayContent;
    const annotationValue = value.annotationContent;
    const disabled = state.settings.disabled || value.disabled || state.settings.tlfViewMode.value === "ANNOTATIONS" && isHeaderRow || state.bodyData.arsBodyRows.find((row)=>row.id === rowId)?.ellipsis;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        style: {
            paddingLeft: value.inlineIndent ? `${value.inlineIndent}em` : undefined
        },
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($41gBZ))).cell,
            disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($41gBZ))).disabled : ""
        ]),
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
            id: id,
            decimalAlignPercent: column.decimalAlignPercent,
            editable: !disabled,
            pending: state.changed,
            setValue: (newValue)=>{
                dispatch({
                    operation: (0, $8A1Qb.ARSL_CELL_UPDATE),
                    rowId: rowId,
                    colId: colId,
                    value: newValue
                });
            },
            textAlignment: textJustification,
            value: isAnnotationsView ? editorProps.textToT(annotationValue) : displayValue ?? // istanbul ignore next
            editorProps.blankT
        })
    });
};
$71440376774d0940$export$33da031833176af6.displayName = "ArsListingCell";
const $71440376774d0940$export$fe981243cbee0d02 = (tProps)=>({
        Editor: $71440376774d0940$export$33da031833176af6,
        blankT: {
            annotationContent: "",
            cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
            columnId: "",
            columnIndex: -1,
            dataPath: "",
            displayContent: tProps.textToT(""),
            justification: (0, $i3Ps9.ArsTextJustification).Default,
            rowId: "",
            targetType: "data"
        },
        getTextFromT: (cellValue)=>{
            const cellDisplay = cellValue.displayContent;
            return tProps.getTextFromT(cellDisplay);
        },
        isT: (value)=>{
            return (0, $8CFpa.isObjectRecord)(value) && "annotationContent" in value && (0, $eAPMz.isString)(value.annotationContent) && "cellType" in value && Object.values((0, $i3Ps9.ArsTableCellType)).includes(value.cellType) && "dataPath" in value && (0, $eAPMz.isString)(value.dataPath) && "displayContent" in value && tProps.isT(value.displayContent);
        },
        joinTintoBlock: (cellValues)=>{
            const displayContents = cellValues.map((cv)=>cv.displayContent);
            return {
                annotationContent: cellValues.map((cv)=>cv.annotationContent).join("\n"),
                cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
                columnId: cellValues[0]?.columnId ?? // istanbul ignore next
                "",
                columnIndex: cellValues[0]?.columnIndex ?? // istanbul ignore next
                -1,
                dataPath: cellValues[0]?.dataPath ?? // istanbul ignore next
                "",
                displayContent: tProps.joinTintoBlock(displayContents),
                justification: cellValues[0]?.justification ?? // istanbul ignore next
                (0, $i3Ps9.ArsTextJustification).Default,
                rowId: cellValues[0]?.rowId ?? // istanbul ignore next
                "",
                targetType: "data"
            };
        },
        replaceTextInT: (cellValue, oldPhrase, newPhrase)=>{
            return {
                ...cellValue,
                displayContent: tProps.replaceTextInT(cellValue.displayContent, oldPhrase, newPhrase.displayContent)
            };
        },
        splitTintoLines: (cellValue)=>{
            const displayContent = cellValue.displayContent;
            const splitDisplay = tProps.splitTintoLines(displayContent);
            return splitDisplay.map((line)=>({
                    annotationContent: cellValue.annotationContent,
                    cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
                    columnId: cellValue.columnId,
                    columnIndex: cellValue.columnIndex,
                    dataPath: cellValue.dataPath,
                    displayContent: line,
                    justification: cellValue.justification,
                    rowId: cellValue.rowId,
                    targetType: "data"
                }));
        },
        textToT: (text)=>({
                annotationContent: "",
                cellType: (0, $i3Ps9.ArsTableCellType).DataCell,
                columnId: "",
                columnIndex: -1,
                dataPath: "",
                displayContent: tProps.textToT(text),
                rowId: "",
                justification: (0, $i3Ps9.ArsTextJustification).Default,
                targetType: "data"
            })
    });

});
parcelRegister("41gBZ", function(module, exports) {

$parcel$export(module.exports, "arsListingColumnPropertiesEditor", function () { return $2ed4242b75bd08cb$export$530e747465b29b1a; }, function (v) { return $2ed4242b75bd08cb$export$530e747465b29b1a = v; });
$parcel$export(module.exports, "cell", function () { return $2ed4242b75bd08cb$export$e2e1361cdc35271d; }, function (v) { return $2ed4242b75bd08cb$export$e2e1361cdc35271d = v; });
$parcel$export(module.exports, "columnVariablesHolder", function () { return $2ed4242b75bd08cb$export$30859f03d3fe0786; }, function (v) { return $2ed4242b75bd08cb$export$30859f03d3fe0786 = v; });
$parcel$export(module.exports, "disabled", function () { return $2ed4242b75bd08cb$export$683472f6198a076e; }, function (v) { return $2ed4242b75bd08cb$export$683472f6198a076e = v; });
$parcel$export(module.exports, "variableDropSortTarget", function () { return $2ed4242b75bd08cb$export$67c494eca312b214; }, function (v) { return $2ed4242b75bd08cb$export$67c494eca312b214 = v; });
$parcel$export(module.exports, "variableDropSortTargetActive", function () { return $2ed4242b75bd08cb$export$b5e1d054d0a23f64; }, function (v) { return $2ed4242b75bd08cb$export$b5e1d054d0a23f64 = v; });
$parcel$export(module.exports, "variableProperties", function () { return $2ed4242b75bd08cb$export$94c7ae51d7c1a64d; }, function (v) { return $2ed4242b75bd08cb$export$94c7ae51d7c1a64d = v; });
$parcel$export(module.exports, "variablePropertiesDeleteButton", function () { return $2ed4242b75bd08cb$export$c4d39b54c987408b; }, function (v) { return $2ed4242b75bd08cb$export$c4d39b54c987408b = v; });
$parcel$export(module.exports, "variablePropertiesLabel", function () { return $2ed4242b75bd08cb$export$667005cb11d04864; }, function (v) { return $2ed4242b75bd08cb$export$667005cb11d04864 = v; });
$parcel$export(module.exports, "variablePropertiesTypeHolder", function () { return $2ed4242b75bd08cb$export$abaca76971a02943; }, function (v) { return $2ed4242b75bd08cb$export$abaca76971a02943 = v; });
$parcel$export(module.exports, "variablePropertiesTypeOption", function () { return $2ed4242b75bd08cb$export$1412b2356b50248a; }, function (v) { return $2ed4242b75bd08cb$export$1412b2356b50248a = v; });
$parcel$export(module.exports, "variablePropertiesTypeSelect", function () { return $2ed4242b75bd08cb$export$6498b5ed1a142206; }, function (v) { return $2ed4242b75bd08cb$export$6498b5ed1a142206 = v; });
var $2ed4242b75bd08cb$export$530e747465b29b1a;
var $2ed4242b75bd08cb$export$e2e1361cdc35271d;
var $2ed4242b75bd08cb$export$30859f03d3fe0786;
var $2ed4242b75bd08cb$export$683472f6198a076e;
var $2ed4242b75bd08cb$export$67c494eca312b214;
var $2ed4242b75bd08cb$export$b5e1d054d0a23f64;
var $2ed4242b75bd08cb$export$94c7ae51d7c1a64d;
var $2ed4242b75bd08cb$export$c4d39b54c987408b;
var $2ed4242b75bd08cb$export$667005cb11d04864;
var $2ed4242b75bd08cb$export$abaca76971a02943;
var $2ed4242b75bd08cb$export$1412b2356b50248a;
var $2ed4242b75bd08cb$export$6498b5ed1a142206;
$2ed4242b75bd08cb$export$530e747465b29b1a = `mos-ArsListing-module-7zIQ-G-arsListingColumnPropertiesEditor`;
$2ed4242b75bd08cb$export$e2e1361cdc35271d = `mos-ArsListing-module-7zIQ-G-cell`;
$2ed4242b75bd08cb$export$30859f03d3fe0786 = `mos-ArsListing-module-7zIQ-G-columnVariablesHolder`;
$2ed4242b75bd08cb$export$683472f6198a076e = `mos-ArsListing-module-7zIQ-G-disabled`;
$2ed4242b75bd08cb$export$67c494eca312b214 = `mos-ArsListing-module-7zIQ-G-variableDropSortTarget`;
$2ed4242b75bd08cb$export$b5e1d054d0a23f64 = `mos-ArsListing-module-7zIQ-G-variableDropSortTargetActive`;
$2ed4242b75bd08cb$export$94c7ae51d7c1a64d = `mos-ArsListing-module-7zIQ-G-variableProperties`;
$2ed4242b75bd08cb$export$c4d39b54c987408b = `mos-ArsListing-module-7zIQ-G-variablePropertiesDeleteButton`;
$2ed4242b75bd08cb$export$667005cb11d04864 = `mos-ArsListing-module-7zIQ-G-variablePropertiesLabel`;
$2ed4242b75bd08cb$export$abaca76971a02943 = `mos-ArsListing-module-7zIQ-G-variablePropertiesTypeHolder`;
$2ed4242b75bd08cb$export$1412b2356b50248a = `mos-ArsListing-module-7zIQ-G-variablePropertiesTypeOption`;
$2ed4242b75bd08cb$export$6498b5ed1a142206 = `mos-ArsListing-module-7zIQ-G-variablePropertiesTypeSelect`;

});


parcelRegister("eYQSj", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnProperties", function () { return $db7d332c91973f09$export$759167ce2a1509da; });

var $bbzbN = parcelRequire("bbzbN");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $aQsQo = parcelRequire("aQsQo");
var $kYoG1 = parcelRequire("kYoG1");
parcelRequire("gYROb");
var $9Er6k = parcelRequire("9Er6k");
var $isQD0 = parcelRequire("isQD0");
var $7Tnbh = parcelRequire("7Tnbh");
parcelRequire("bIAbO");
var $i5A9K = parcelRequire("i5A9K");
parcelRequire("loI62");
var $i3Ps9 = parcelRequire("i3Ps9");

var $41gBZ = parcelRequire("41gBZ");

var $5Hqzu = parcelRequire("5Hqzu");

var $bdP47 = parcelRequire("bdP47");

var $bngf5 = parcelRequire("bngf5");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $db7d332c91973f09$export$759167ce2a1509da = ()=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    if (!state?.settings.viewColumnPropertiesId) return null;
    const colId = state?.settings.viewColumnPropertiesId;
    const colIx = state.bodyData.arsListingColumns.findIndex((col)=>col.id === colId);
    const column = colIx >= 0 ? state.bodyData.arsListingColumns[colIx] : undefined;
    if (!column) return null;
    /**
   * Update component state
   */ const handleHide = ()=>dispatch({
            operation: (0, $8A1Qb.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID),
            colId: undefined
        });
    const value = state.settings.editorProps.joinTintoBlock(column.displayPattern);
    const alignOptions = Object.entries((0, $i3Ps9.ArsTextJustification)).map(([k, v])=>({
            label: k,
            value: v
        }));
    const Editor = state.settings.editorProps.Editor;
    const editorProps = {
        className: `${$41gBZ.arsListingColumnPropertiesEditor}`,
        disabled: state.settings.disabled,
        editable: true,
        resize: "vertical"
    };
    /**
   * Handle variable reordering
   *
   * @param event - Sortable list drag end event
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore else */ if (column && over !== null && over.id !== active.id) {
            const oldIndex = column.variables.findIndex((v)=>`${v.id}` === active.id);
            const newIndex = column.variables.findIndex((v)=>`${v.id}` === over.id);
            // Reorder the array
            const reorderedVariables = [
                ...column.variables
            ];
            const [movedVariable] = reorderedVariables.splice(oldIndex, 1);
            reorderedVariables.splice(newIndex, 0, movedVariable);
            dispatch({
                operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                colId: colId,
                column: {
                    variables: reorderedVariables
                }
            });
        }
    };
    /**
   * Validate that all variables in the result pattern are present
   * in the column's variables.
   *
   * @param _backEndUrl - Backend URL (not used in this validation)
   * @param value - The value to validate
   * @param _controller - Abort controller (not used in this validation)
   * @returns A promise that resolves to an IValidReturn object indicating whether the validation passed or failed
   */ const validateResultPattern = (_backEndUrl, value, _controller)=>{
        /* Use regex to find all variable references between curly braces */ const variablePattern = /\{([^}]+)\}/g;
        const matches = value.value.match(variablePattern);
        if (!matches) {
            const ret = {
                success: true,
                data: {
                    valid: true,
                    validationText: ""
                }
            };
            return Promise.resolve(ret);
        }
        const variableNamesInPattern = matches.map((match)=>match.slice(1, -1));
        /* Get the variable names from the column's variables */ const variableNamesInColumn = column.variables.map((v)=>v.variable.toLowerCase());
        /* Check if all variables in the pattern are present in the column's variables */ const missingVariables = variableNamesInPattern.filter((varName)=>!variableNamesInColumn.includes(varName.toLowerCase()));
        /* It's not good */ if (missingVariables.length > 0) {
            const ret = {
                success: true,
                data: {
                    valid: false,
                    validationText: `Missing variables: ${missingVariables.join(", ")}`
                }
            };
            return Promise.resolve(ret);
        }
        /* Everything is good */ const ret = {
            success: true,
            data: {
                valid: true,
                validationText: ""
            }
        };
        return Promise.resolve(ret);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aQsQo.default), {
        id: "ars-listing-column-properties",
        show: column !== undefined,
        onHide: handleHide,
        backdrop: false,
        scroll: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aQsQo.default).Title, {
                    className: "d-flex flex-row justify-content-between w-100",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                            className: "d-flex flex-row align-items-left gap-1",
                            children: [
                                "Column",
                                " ",
                                colIx !== undefined ? colIx + 1 : "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bdP47.ArsListingColumnNavButtons), {
                            colIx: colIx
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Body, {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                            children: [
                                "Id: ",
                                colId
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                            id: "ars-listing-column-properties-column-width",
                            disabled: true,
                            label: "Column width",
                            labelWidth: 3,
                            value: `${column.columnWidth}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                            id: "ars-listing-column-properties-body-text-alignment",
                            disabled: state.settings.disabled,
                            label: "Body text alignment",
                            labelWidth: 3,
                            options: alignOptions,
                            setValue: (ret)=>dispatch({
                                    operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        bodyTextAlignment: ret
                                    }
                                }),
                            value: column.bodyTextAlignment ?? "left"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                            id: "ars-listing-column-properties-decimal-align-percent",
                            disabled: state.settings.disabled,
                            label: "Decimal align %",
                            labelWidth: 3,
                            setValue: (ret)=>{
                                const parsed = parseFloat(ret);
                                const parsedValue = isNaN(parsed) ? undefined : parsed;
                                dispatch({
                                    operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        decimalAlignPercent: parsedValue
                                    }
                                });
                            },
                            type: "number",
                            value: `${column.decimalAlignPercent ?? ""}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                            className: "my-1",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                    md: 3,
                                    id: "ars-listing-column-properties-display-pattern-label",
                                    htmlFor: "ars-listing-column-properties-display-pattern",
                                    className: "form-label col-form-label",
                                    children: "Display value"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                                        ...editorProps,
                                        id: "ars-listing-column-properties-display-pattern",
                                        "aria-labelledby": "ars-listing-column-properties-display-pattern-label",
                                        decimalAlignPercent: column.decimalAlignPercent,
                                        setValue: (ret)=>{
                                            const newValue = state.settings.editorProps.splitTintoLines(ret);
                                            dispatch({
                                                operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                                colId: colId,
                                                column: {
                                                    displayPattern: newValue
                                                }
                                            });
                                        },
                                        textAlignment: column.bodyTextAlignment ?? "left",
                                        value: value
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                            className: "my-1",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                    className: "form-label col-form-label",
                                    htmlFor: "ars-listing-column-properties-header-text",
                                    id: "ars-listing-column-properties-header-text-label",
                                    md: 3,
                                    children: "Header text"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                                        ...editorProps,
                                        id: "ars-listing-column-properties-header-text",
                                        "aria-labelledby": "ars-listing-column-properties-header-text-label",
                                        decimalAlignPercent: column.decimalAlignPercent,
                                        setValue: (ret)=>{
                                            dispatch({
                                                operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                                colId: colId,
                                                column: {
                                                    headerText: ret
                                                }
                                            });
                                        },
                                        textAlignment: column.headerTextAlignment ?? "center",
                                        value: column.headerText ?? state.settings.editorProps.blankT
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                            id: "ars-listing-column-properties-header-height",
                            disabled: true,
                            label: "Header height",
                            labelWidth: 3,
                            value: `${column.headerHeight ?? ""}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                            id: "ars-listing-column-properties-header-text-alignment",
                            disabled: state.settings.disabled,
                            label: "Header text alignment",
                            labelWidth: 3,
                            options: alignOptions.filter((option)=>option.value !== (0, $i3Ps9.ArsTextJustification).Decimal),
                            setValue: (ret)=>dispatch({
                                    operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        headerTextAlignment: ret
                                    }
                                }),
                            value: column.headerTextAlignment ?? "left"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                            id: "ars-listing-column-properties-result-pattern",
                            disabled: state.settings.disabled,
                            label: "Result pattern",
                            labelWidth: 3,
                            setValue: (ret)=>{
                                dispatch({
                                    operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        resultPattern: ret
                                    }
                                });
                            },
                            validCondition: validateResultPattern,
                            value: column.resultPattern
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            className: "my-1",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                id: "ars-listing-column-properties-variables-label",
                                "aria-label": "Variables associated with the column",
                                className: "mt-3 form-label col-form-label",
                                htmlFor: "ars-listing-column-properties-variables",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    children: "Variables"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                                className: $41gBZ.columnVariablesHolder,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7Tnbh.SortableListHolder), {
                                        id: "ars-listing-column-properties-variables",
                                        "aria-labelledby": "ars-listing-column-properties-variables-label",
                                        canMove: !state.settings.disabled,
                                        handleDragEnd: handleDragEnd,
                                        items: column.variables.map((v)=>({
                                                id: v.id,
                                                label: v.dataset,
                                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bngf5.ArsListingColumnVariableProperties), {
                                                    id: v.id
                                                })
                                            }))
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Hqzu.ArsListingColumnDropSortVariableTarget), {
                                        colId: column.id,
                                        addVarIx: column.variables.length
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                                        className: "ms-2",
                                        children: "Variables dropped here will be added to the sort order"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            className: "my-1",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                id: "ars-listing-column-properties-case-when-label",
                                "aria-label": "Complex display conditions",
                                className: "mt-3 form-label col-form-label",
                                htmlFor: "ars-listing-column-properties-case-when",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    children: "Complex display conditions"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i5A9K.CaseWhenControl), {
                                    id: "ars-listing-column-properties-case-when",
                                    "aria-labelledby": "ars-listing-column-properties-case-when-label",
                                    dataPath: `/caseWhenConditions/${column.id}`,
                                    disabled: state.settings.disabled,
                                    editorDefns: state.settings.editorProps,
                                    onChange: (ret)=>{
                                        // Update the ARS listing state to show a change has been made
                                        dispatch({
                                            operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                            colId: colId,
                                            column: {
                                                caseWhenCondition: ret
                                            }
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$db7d332c91973f09$export$759167ce2a1509da.displayName = "ArsListingColumnProperties";

});
parcelRegister("alDlg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $788a620df7863748$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $788a620df7863748$var$Container = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$788a620df7863748$var$Container.displayName = 'Container';
var $788a620df7863748$export$2e2bcd8739ae039 = $788a620df7863748$var$Container;

});

parcelRegister("5Hqzu", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnDropSortVariableTarget", function () { return $cf433e13adeb5817$export$3ada8fdbf5078124; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("2nuru");
var $cqVqv = parcelRequire("cqVqv");

var $41gBZ = parcelRequire("41gBZ");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $cf433e13adeb5817$export$3ada8fdbf5078124 = ({ colId: colId, addVarIx: addVarIx })=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    const [isBeingDraggedOver, setIsBeingDraggedOver] = (0, $7fPBF.useState)(false);
    if (!state) return null;
    /**
   * Handles the drop event when sort columns are dropped onto the target div.
   *
   * @param e - Drag event
   */ const handleDrop = (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        const jsonPayLoad = e.dataTransfer.getData("application/json");
        setIsBeingDraggedOver(false);
        dispatch({
            operation: (0, $8A1Qb.ARSL_APPLY_DROPPED_SORT_COLUMNS),
            colId: colId,
            variableIndex: addVarIx,
            jsonPayload: jsonPayLoad
        });
    };
    /**
   * Handles the drag over event to allow dropping of sort columns onto the target div.
   *
   * @param e - Drag event
   */ const handleDragOver = (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
        setIsBeingDraggedOver(true);
    };
    /**
   * Handle the drag leave event to reset the drag over state when the dragged item leaves the target div.
   *
   * @param e - Drag event
   */ const handleDragLeave = (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setIsBeingDraggedOver(false);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: `ars-listing-column-drop-sort-variable-target-${colId}-${addVarIx}`,
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($41gBZ))).variableDropSortTarget,
            isBeingDraggedOver ? (0, (/*@__PURE__*/$parcel$interopDefault($41gBZ))).variableDropSortTargetActive : ""
        ]),
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave
    });
};
$cf433e13adeb5817$export$3ada8fdbf5078124.displayName = "ArsListingColumnDropSortVariableTarget";

});

parcelRegister("bdP47", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnNavButtons", function () { return $90ea6b89e8287476$export$4b0139ab3db60234; });

var $bbzbN = parcelRequire("bbzbN");

var $87hiV = parcelRequire("87hiV");
var $cnmTv = parcelRequire("cnmTv");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $90ea6b89e8287476$export$4b0139ab3db60234 = ({ colIx: colIx })=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    if (!state || !state.settings.viewColumnPropertiesId) return null;
    const totalColumns = state.bodyData.arsListingColumns.length;
    const leftDest = colIx > 0 ? state.bodyData.arsListingColumns[colIx - 1].id : null;
    const rightDest = colIx < totalColumns - 1 ? state.bodyData.arsListingColumns[colIx + 1].id : null;
    /**
   * Change properties view column with a dispatch action
   *
   * @param id - New column id
   */ const setNewviewColumnPropertiesId = (id)=>{
        dispatch({
            operation: (0, $8A1Qb.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID),
            colId: id
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87hiV.default), {
                style: leftDest ? {
                    cursor: "pointer",
                    color: "black"
                } : {
                    cursor: "not-allowed",
                    color: "grey"
                },
                "aria-label": "Previous column",
                title: "Previous column",
                onClick: ()=>leftDest && setNewviewColumnPropertiesId(leftDest)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cnmTv.default), {
                style: rightDest ? {
                    cursor: "pointer",
                    color: "black"
                } : {
                    cursor: "not-allowed",
                    color: "grey"
                },
                "aria-label": "Next column",
                title: "Next column",
                onClick: ()=>rightDest && setNewviewColumnPropertiesId(rightDest)
            })
        ]
    });
};
$90ea6b89e8287476$export$4b0139ab3db60234.displayName = "ArsListingColumnNavButtons";

});
parcelRegister("87hiV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e8c666c56153077$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $5e8c666c56153077$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $5e8c666c56153077$var$_extends() {
    return $5e8c666c56153077$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e8c666c56153077$var$_extends.apply(null, arguments);
}
function $5e8c666c56153077$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5e8c666c56153077$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $5e8c666c56153077$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5e8c666c56153077$var$ChevronLeft = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $5e8c666c56153077$var$_objectWithoutProperties(_ref, $5e8c666c56153077$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $5e8c666c56153077$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chevron-left',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
    }));
});
$5e8c666c56153077$var$ChevronLeft.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $5e8c666c56153077$export$2e2bcd8739ae039 = $5e8c666c56153077$var$ChevronLeft;

});


parcelRegister("bngf5", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnVariableProperties", function () { return $0320fb8047d90fe1$export$192cf663e2a3ea11; });

var $bbzbN = parcelRequire("bbzbN");

var $jVHe9 = parcelRequire("jVHe9");

var $41gBZ = parcelRequire("41gBZ");

var $5Hqzu = parcelRequire("5Hqzu");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $0320fb8047d90fe1$export$192cf663e2a3ea11 = ({ id: id })=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    if (!state?.settings.viewColumnPropertiesId) return null;
    const colId = state?.settings.viewColumnPropertiesId;
    const colIx = state.bodyData.arsListingColumns.findIndex((col)=>col.id === colId);
    const column = colIx >= 0 ? state.bodyData.arsListingColumns[colIx] : undefined;
    const varIx = column?.variables.findIndex((v)=>v.id === id) ?? -1;
    const variable = varIx >= 0 ? column?.variables[varIx] : undefined;
    if (!column || !variable) return null;
    /**
   * Handles the change of variable type in the select dropdown.
   *
   * @param e - Select change event
   */ const handleChange = (e)=>{
        const newVariableType = e.target.value;
        const newVariable = {
            ...variable,
            variableType: newVariableType
        };
        const newVariables = column?.variables.map((v)=>v.id === variable.id ? newVariable : v);
        dispatch({
            operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
            colId: colId,
            column: {
                variables: newVariables
            }
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: $41gBZ.variableProperties,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Hqzu.ArsListingColumnDropSortVariableTarget), {
                colId: column.id,
                addVarIx: varIx
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                className: $41gBZ.variablePropertiesLabel,
                children: [
                    variable.dataset,
                    ".",
                    variable.variable
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                className: $41gBZ.variablePropertiesTypeHolder,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                        className: $41gBZ.variablePropertiesTypeSelect,
                        "aria-label": "Variable type",
                        value: variable.variableType,
                        onChange: handleChange,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                value: "displayOnly",
                                className: $41gBZ.variablePropertiesTypeOption,
                                children: "Display only"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                value: "group",
                                className: $41gBZ.variablePropertiesTypeOption,
                                children: "Group"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                value: "hidden-sort",
                                className: $41gBZ.variablePropertiesTypeOption,
                                children: "Sort"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: $41gBZ.variablePropertiesDeleteButton,
                        role: "button",
                        tabIndex: 0,
                        title: "Delete variable",
                        onClick: ()=>{
                            const newVariables = column?.variables.filter((v)=>v.id !== variable.id);
                            dispatch({
                                operation: (0, $8A1Qb.ARSL_COLUMN_UPDATE),
                                colId: colId,
                                column: {
                                    variables: newVariables
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jVHe9.default), {
                            "aria-label": "Delete variable"
                        })
                    })
                ]
            })
        ]
    });
};
$0320fb8047d90fe1$export$192cf663e2a3ea11.displayName = "ArsListingColumnVariableProperties";

});


parcelRegister("ey46M", function(module, exports) {

$parcel$export(module.exports, "ArsListingContextMenuProvider", function () { return $8bc8dfc3f3a73e8a$export$d924be207432a3dc; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $7j5F4 = parcelRequire("7j5F4");
parcelRequire("loI62");
var $i3Ps9 = parcelRequire("i3Ps9");

var $bsFOF = parcelRequire("bsFOF");

var $8A1Qb = parcelRequire("8A1Qb");
const $8bc8dfc3f3a73e8a$export$d924be207432a3dc = ({ children: children, selectedColumns: selectedColumns })=>{
    const { state: state, dispatch: dispatch } = (0, $bsFOF.useArsListing)();
    const [contextMenuTarget, setContextMenuTarget] = (0, $7fPBF.useState)(undefined);
    if (!state) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: children
    });
    /**
   * Function to blur active element
   */ const blurActiveElement = ()=>{
        /* istanbul ignore else */ if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    };
    /**
   * Captures scaffold row and column ids before opening the context menu.
   *
   * @param event - Context menu event fired from scaffold cells
   */ const handleScaffoldContextMenuCapture = (event)=>{
        setContextMenuTarget((0, $7j5F4.getScaffoldContextMenuTarget)(event.target));
    };
    /**
   * Dispatches text-alignment changes for the selected context-menu column.
   *
   * @param alignment - Desired text alignment
   * @param isHeader - Whether alignment applies to header cells
   */ const handleChangeTextAlignment = (alignment, isHeader)=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget) dispatch({
            operation: (0, $8A1Qb.ARSL_ALIGN_TEXT),
            colId: contextMenuTarget.colId,
            alignment: alignment,
            isHeader: isHeader
        });
    };
    /**
   * Adds a blank column at at the index provided
   *
   * @param before - whether to insert the column before or after the current column
   */ const handleAddBlankColumn = (before)=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget) {
            const ix = state.bodyData.arsListingColumns.findIndex((col)=>col.id === contextMenuTarget.colId) + (before ? 0 : 1);
            dispatch({
                operation: (0, $8A1Qb.ARSL_ADD_BLANK_COLUMN),
                colIx: ix,
                colId: crypto.randomUUID()
            });
        }
    };
    /**
   * Adds a new row after the currently targeted context-menu row.
   *
   * @param ellipsis - Whether the inserted row is an ellipsis row
   */ const handleAddRow = (ellipsis)=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget) dispatch({
            operation: (0, $8A1Qb.ARSL_ADD_ROW),
            rowId: contextMenuTarget.rowId,
            type: ellipsis ? "ellipsis" : "default"
        });
    };
    /**
   * Removes the currently targeted body row when allowed.
   */ const handleRemoveRow = ()=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget && state.bodyData.arsBodyRows.length > 1) {
            const bodyRowIndex = state.bodyData.arsBodyRows.findIndex((row)=>row.id === contextMenuTarget.rowId);
            /* istanbul ignore else */ if (bodyRowIndex !== -1) dispatch({
                operation: (0, $8A1Qb.ARSL_REMOVE_ROW),
                rowId: contextMenuTarget.rowId
            });
        }
    };
    /**
   * Removes the currently targeted column when allowed.
   */ const handleRemoveColumn = ()=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget && selectedColumns.length > 1) dispatch({
            operation: (0, $8A1Qb.ARSL_REMOVE_COLUMN),
            colId: contextMenuTarget.colId
        });
    };
    const isHeaderRow = contextMenuTarget?.rowId === (0, $8A1Qb.HEADER_ROW_ID);
    const isRowActionDisabled = state.settings.disabled || contextMenuTarget === undefined || isHeaderRow;
    const arslContextMenuItems = [
        {
            label: "Show column properties",
            disabled: state.settings.disabled || contextMenuTarget === undefined,
            action: ()=>{
                dispatch({
                    operation: (0, $8A1Qb.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID),
                    colId: contextMenuTarget?.colId
                });
            }
        },
        {
            label: "Justify text",
            disabled: state.settings.disabled || contextMenuTarget === undefined,
            group: [
                {
                    label: "Left",
                    action: ()=>handleChangeTextAlignment((0, $i3Ps9.ArsTextJustification).Left, isHeaderRow)
                },
                {
                    label: "Centre",
                    action: ()=>handleChangeTextAlignment((0, $i3Ps9.ArsTextJustification).Center, isHeaderRow)
                },
                ...contextMenuTarget?.rowId !== (0, $8A1Qb.HEADER_ROW_ID) ? [
                    {
                        label: "Decimal",
                        action: ()=>handleChangeTextAlignment((0, $i3Ps9.ArsTextJustification).Decimal, isHeaderRow)
                    }
                ] : [],
                {
                    label: "Right",
                    action: ()=>handleChangeTextAlignment((0, $i3Ps9.ArsTextJustification).Right, isHeaderRow)
                }
            ]
        },
        {
            label: "Add blank column",
            disabled: state.settings.disabled,
            group: [
                {
                    label: "Before",
                    action: ()=>handleAddBlankColumn(true)
                },
                {
                    label: "After",
                    action: ()=>handleAddBlankColumn(false)
                }
            ]
        },
        {
            label: "Add row below",
            disabled: isRowActionDisabled,
            group: [
                {
                    label: "Display",
                    action: ()=>handleAddRow(false)
                },
                {
                    label: "Ellipsis",
                    action: ()=>handleAddRow(true)
                }
            ]
        },
        {
            label: "Remove row",
            action: handleRemoveRow,
            disabled: isRowActionDisabled || state.bodyData.arsBodyRows.length <= 1
        },
        {
            label: "Remove column",
            action: handleRemoveColumn,
            disabled: state.settings.disabled || contextMenuTarget === undefined || selectedColumns.length <= 1
        }
    ];
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
        menuItems: arslContextMenuItems,
        onContextMenuCapture: handleScaffoldContextMenuCapture,
        children: children
    });
};
$8bc8dfc3f3a73e8a$export$d924be207432a3dc.displayName = "ArsListingContextMenuProvider";

});



parcelRegister("awEAB", function(module, exports) {

$parcel$export(module.exports, "isArsListingBody", function () { return $04b6cf67133060a8$export$c2d867a9a9d41163; });

var $8CFpa = parcelRequire("8CFpa");

var $3dB4J = parcelRequire("3dB4J");

var $jkCk4 = parcelRequire("jkCk4");
/**
 * Validates if a value is an array of ArsListingColumn objects.
 *
 * @param value - Unknown value to validate
 * @param isT - Optional type guard for the generic type T used in the columns' displayPattern and headerText
 * @returns True when value is an array of valid ArsListingColumn objects
 */ function $04b6cf67133060a8$var$isColumnsArray(value, isT) {
    if (!Array.isArray(value)) return false;
    /* istanbul ignore next Check for valid columns array structure */ for (const item of value){
        if (!(0, $3dB4J.isArsListingColumn)(item, isT)) return false;
    }
    return true;
}
/**
 * Validates if a value is an array of ArsListingRow objects.
 *
 * @param value - Unknown value to validate
 * @returns True when value is an array of valid ArsListingRow objects
 */ function $04b6cf67133060a8$var$isRowsArray(value) {
    if (!Array.isArray(value)) return false;
    /* istanbul ignore next Check for valid rows array structure */ for (const item of value){
        if (!(0, $jkCk4.isArsListingRow)(item)) return false;
    }
    return true;
}
const $04b6cf67133060a8$export$c2d867a9a9d41163 = (obj, isT = (value)=>typeof value === "string")=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (!$04b6cf67133060a8$var$isColumnsArray(obj.arsListingColumns, isT)) return false;
    if (!$04b6cf67133060a8$var$isRowsArray(obj.arsBodyRows)) return false;
    if (obj.dataSubsetId !== undefined && typeof obj.dataSubsetId !== "string") return false;
    // Everything is good
    return true;
};

});
parcelRegister("3dB4J", function(module, exports) {

$parcel$export(module.exports, "isArsListingColumn", function () { return $8b81ece8d30e5606$export$d1bb9cd001fd45c; });

var $i3Ps9 = parcelRequire("i3Ps9");
parcelRequire("6yroJ");
var $cGJVG = parcelRequire("cGJVG");
var $8CFpa = parcelRequire("8CFpa");

var $5KRpm = parcelRequire("5KRpm");
const $8b81ece8d30e5606$var$arsTextJustifications = new Set(Object.values((0, $i3Ps9.ArsTextJustification)));
/**
 * Validates if a value is a valid ArsTextAlignment.
 *
 * @param value - Unknown value to validate
 * @returns True when value is one of the ArsTextJustification enum values
 */ function $8b81ece8d30e5606$var$isArsTextJustification(value) {
    return typeof value === "string" && $8b81ece8d30e5606$var$arsTextJustifications.has(value);
}
const $8b81ece8d30e5606$export$d1bb9cd001fd45c = (obj, isT = (value)=>typeof value === "string")=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (typeof obj.columnWidth !== "number") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.decimalAlignPercent)) return false;
    if (obj.displayPattern === undefined || obj.displayPattern === null) return false;
    if (Array.isArray(obj.displayPattern) && obj.displayPattern.some((item)=>!isT(item))) return false;
    if (!Array.isArray(obj.displayPattern) && !isT(obj.displayPattern)) return false;
    if (!isT(obj.headerText)) return false;
    if (typeof obj.resultPattern !== "string") return false;
    // Check optional properties if present
    if (obj.bodyTextAlignment !== undefined && !$8b81ece8d30e5606$var$isArsTextJustification(obj.bodyTextAlignment)) return false;
    if (obj.headerHeight !== undefined && typeof obj.headerHeight !== "number") return false;
    if (obj.headerTextAlignment !== undefined && !$8b81ece8d30e5606$var$isArsTextJustification(obj.headerTextAlignment)) return false;
    if (obj.variables !== undefined && (!Array.isArray(obj.variables) || obj.variables.some((v)=>!(0, $5KRpm.isArsListingVariable)(v)))) return false;
    if (obj.caseWhenCondition !== undefined && !(0, $cGJVG.isCaseWhenCondition)(obj.caseWhenCondition, isT)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("5KRpm", function(module, exports) {

$parcel$export(module.exports, "isArsListingVariable", function () { return $33e5170b5b2277f6$export$af65bf5b59bad20b; });
parcelRequire("6yroJ");
var $8CFpa = parcelRequire("8CFpa");
const $33e5170b5b2277f6$export$af65bf5b59bad20b = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.dataset !== "string") return false;
    if (typeof obj.variable !== "string") return false;
    if (typeof obj.variableType !== "string" || ![
        "displayOnly",
        "group",
        "hidden-sort"
    ].includes(obj.variableType)) return false;
    // Everything is good
    return true;
};

});


parcelRegister("jkCk4", function(module, exports) {

$parcel$export(module.exports, "isArsListingRow", function () { return $22632a4e67d68710$export$ade33056063d8e64; });

var $8CFpa = parcelRequire("8CFpa");
const $22632a4e67d68710$export$ade33056063d8e64 = (obj)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (typeof obj.rowHeight !== "number") return false;
    if (typeof obj.ellipsis !== "boolean") return false;
    // Everything is good
    return true;
};

});



parcelRegister("jbjc3", function(module, exports) {
parcelRequire("470Zy");
parcelRequire("hp2BB");
parcelRequire("3pTyh");
parcelRequire("ecq7a");

});


parcelRegister("ic4Os", function(module, exports) {
$parcel$export(module.exports, "AsupInternalBlock", function () { return (parcelRequire("hG9sA")).AsupInternalBlock; });
$parcel$export(module.exports, "AibLineType", function () { return (parcelRequire("79DyI")).AibLineType; });
parcelRequire("g9YFX");
parcelRequire("ee4ue");
parcelRequire("uq2Vj");
parcelRequire("llQ3w");
parcelRequire("1REUe");
parcelRequire("hG9sA");
parcelRequire("bWgGl");
parcelRequire("kOA1G");
parcelRequire("9IYbD");
parcelRequire("79DyI");
parcelRequire("bYCc7");
parcelRequire("8gVWl");
parcelRequire("eCKHS");

});
parcelRegister("g9YFX", function(module, exports) {

$parcel$export(module.exports, "AddLineButton", function () { return $17fc0bed3beb8eae$export$d727bc568a614a1d; });

var $bbzbN = parcelRequire("bbzbN");

var $5m3yv = parcelRequire("5m3yv");

var $bWgGl = parcelRequire("bWgGl");

var $kOA1G = parcelRequire("kOA1G");

var $bYCc7 = parcelRequire("bYCc7");
const $17fc0bed3beb8eae$export$d727bc568a614a1d = ({ aifid: aifid, lineAbove: lineAbove = false })=>{
    const ADD_LINE_BUTTON_TOP_OFFSET = -18;
    const { state: state, dispatch: dispatch } = (0, $bWgGl.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = ix > -1 ? state.lines[ix] : null;
    const canAddLineBelow = !state.disabled && state.lines.length < state.maxLines && thisLine?.addBelow;
    return !thisLine || state.maxLines === 1 ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${state.id}-${ix}-add-line`,
        iconName: lineAbove || canAddLineBelow ? "aioxPlus" : "aioxCircle",
        tipText: "Add line",
        style: lineAbove ? {
            position: "absolute",
            top: ADD_LINE_BUTTON_TOP_OFFSET,
            marginLeft: 0
        } : {},
        onClick: ()=>{
            if (canAddLineBelow || lineAbove) {
                const line = (0, $bYCc7.newBlockLine)(state.defaultType, state.editorProps.blankT);
                line.canChangeType = state.canChangeType;
                dispatch({
                    operation: (0, $kOA1G.ADD_LINE),
                    ix: lineAbove ? ix : ix + 1,
                    line: line
                });
            }
        }
    });
};
$17fc0bed3beb8eae$export$d727bc568a614a1d.displayName = "AddLineButton";

});
parcelRegister("bWgGl", function(module, exports) {

$parcel$export(module.exports, "BlockContextProvider", function () { return $d3cd171e466613bd$export$703b49f54ceaa9bf; });
$parcel$export(module.exports, "useBlockContext", function () { return $d3cd171e466613bd$export$41562f444cfa7f67; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $kOA1G = parcelRequire("kOA1G");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d3cd171e466613bd$var$BlockContext = /*#__PURE__*/ (0, $7fPBF.createContext)({
    state: (0, $kOA1G.defaultBlockState),
    dispatch: // istanbul ignore next
    ()=>{}
});
/**
 * Provides block context
 *
 * @param props - Destructured parameter object
 * @param props.initialState - Initial block state used to seed the provider
 * @param props.children - React children to render within the provider
 * @param props.onChange - Callback invoked with the updated lines when the block state is pushed
 */ const $d3cd171e466613bd$var$BlockContextProviderInner = ({ initialState: initialState, children: children, onChange: onChange })=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $kOA1G.blockReducer), initialState);
    // Update or push state
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $gSkQi.isEqual)(state, initialState)) {
            if (state.changed) {
                onChange(state.lines);
                dispatch({
                    operation: (0, $kOA1G.CHANGE_PUSHED)
                });
            } else dispatch({
                operation: (0, $kOA1G.SET_STATE),
                ...initialState
            });
        }
    }, [
        initialState,
        onChange,
        state
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d3cd171e466613bd$var$BlockContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
const $d3cd171e466613bd$export$703b49f54ceaa9bf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).memo($d3cd171e466613bd$var$BlockContextProviderInner);
function $d3cd171e466613bd$export$41562f444cfa7f67() {
    const { state: state, dispatch: dispatch } = (0, $7fPBF.useContext)($d3cd171e466613bd$var$BlockContext);
    return {
        state: state,
        dispatch: dispatch
    };
}
$d3cd171e466613bd$var$BlockContextProviderInner.displayName = "BlockContextProvider";

});
parcelRegister("kOA1G", function(module, exports) {

$parcel$export(module.exports, "defaultBlockState", function () { return $b102eb2271e74d83$export$946ce68b1b7b58; });
$parcel$export(module.exports, "ADD_LINE", function () { return $b102eb2271e74d83$export$7d6abe52e266964b; });
$parcel$export(module.exports, "CHANGE_PUSHED", function () { return $b102eb2271e74d83$export$b485dc6ccc0d10c4; });
$parcel$export(module.exports, "REMOVE_LINE", function () { return $b102eb2271e74d83$export$31431e5ed4c8ceb7; });
$parcel$export(module.exports, "SET_STATE", function () { return $b102eb2271e74d83$export$4a4b66c21ebf4dc9; });
$parcel$export(module.exports, "UPDATE_BLOCK_CELL", function () { return $b102eb2271e74d83$export$3127bc3075cb06b2; });
$parcel$export(module.exports, "UPDATE_LINE", function () { return $b102eb2271e74d83$export$128e89fa5a52e2d5; });
$parcel$export(module.exports, "blockReducer", function () { return $b102eb2271e74d83$export$4fa1eaa1ae0609f5; });
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");

var $79DyI = parcelRequire("79DyI");
const $b102eb2271e74d83$export$946ce68b1b7b58 = {
    id: "default-block-id",
    canAddFirstRow: false,
    canChangeType: false,
    changed: false,
    changedBlocks: [],
    disabled: true,
    editorProps: (0, $jP37Y.defaultEditorDefns),
    externalSingles: [],
    defaultType: (0, $79DyI.AibLineType).leftOnly,
    lines: [],
    lineStyle: {},
    minLines: 1,
    maxLines: 10,
    noComments: false,
    noTrafficLights: false
};
const $b102eb2271e74d83$export$7d6abe52e266964b = "ADD_LINE";
const $b102eb2271e74d83$export$b485dc6ccc0d10c4 = "CHANGE_PUSHED";
const $b102eb2271e74d83$export$31431e5ed4c8ceb7 = "REMOVE_LINE";
const $b102eb2271e74d83$export$4a4b66c21ebf4dc9 = "SET_STATE";
const $b102eb2271e74d83$export$3127bc3075cb06b2 = "UPDATE_BLOCK_CELL";
const $b102eb2271e74d83$export$128e89fa5a52e2d5 = "UPDATE_LINE";
const $b102eb2271e74d83$export$4fa1eaa1ae0609f5 = (state, action)=>{
    // Do nothing if disabled
    if (state.disabled && action.operation !== $b102eb2271e74d83$export$4a4b66c21ebf4dc9) return state;
    // Create new state
    let newState = {
        ...state
    };
    const errCheck = [];
    // Check action type
    switch(action.operation){
        case $b102eb2271e74d83$export$7d6abe52e266964b:
            if (action.ix < 0 || action.ix > newState.lines.length) errCheck.push("ADD_LINE: index out of bounds");
            if (newState.lines.length >= state.maxLines) errCheck.push("ADD_LINE: max lines reached");
            if (errCheck.length > 0) break;
            /* istanbul ignore else */ if (!newState.lines.some((line)=>line.aifid === action.line.aifid)) {
                const lineWithTrafficLight = {
                    ...action.line,
                    coreTrafficLight: "ChangedUnknown"
                };
                newState.lines = [
                    ...newState.lines.slice(0, action.ix),
                    lineWithTrafficLight,
                    ...newState.lines.slice(action.ix)
                ];
            }
            newState.changed = true;
            break;
        case $b102eb2271e74d83$export$b485dc6ccc0d10c4:
            newState.changed = false;
            break;
        case $b102eb2271e74d83$export$31431e5ed4c8ceb7:
            {
                const ix = newState.lines.findIndex((line)=>line.aifid === action.aifid);
                if (ix === -1) errCheck.push("REMOVE_LINE: line not found");
                if (newState.lines.length <= state.minLines) errCheck.push("REMOVE_LINE: min lines reached");
                if (errCheck.length > 0) break;
                newState.lines = [
                    ...newState.lines.slice(0, ix),
                    ...newState.lines.slice(ix + 1)
                ];
                newState.changed = true;
                break;
            }
        case $b102eb2271e74d83$export$4a4b66c21ebf4dc9:
            newState = {
                ...newState,
                id: action.id,
                canChangeType: action.canChangeType,
                changed: false,
                changedBlocks: action.changedBlocks,
                defaultType: action.defaultType,
                disabled: action.disabled,
                editorProps: action.editorProps,
                externalSingles: action.externalSingles,
                lineStyle: action.lineStyle,
                lines: action.lines,
                maxLines: action.maxLines,
                minLines: action.minLines,
                noTrafficLights: action.noTrafficLights
            };
            break;
        case $b102eb2271e74d83$export$3127bc3075cb06b2:
            {
                const ix = newState.lines.findIndex((line)=>line.aifid === action.aifid);
                if (ix === -1) {
                    errCheck.push("UPDATE_BLOCK_CELL: line not found");
                    break;
                }
                const updatedLine = {
                    ...newState.lines[ix],
                    [action.position]: action.cellContent,
                    coreTrafficLight: "ChangedUnknown"
                };
                newState.lines = [
                    ...newState.lines.slice(0, ix),
                    updatedLine,
                    ...newState.lines.slice(ix + 1)
                ];
                newState.changed = true;
                break;
            }
        case $b102eb2271e74d83$export$128e89fa5a52e2d5:
            {
                const ix = newState.lines.findIndex((line)=>line.aifid === action.line.aifid);
                if (ix === -1) {
                    errCheck.push("UPDATE_LINE: line not found");
                    break;
                }
                newState.lines[ix] = action.line;
                newState.changed = true;
                break;
            }
    }
    if (errCheck.length > 0) {
        console.warn(errCheck);
        return state;
    }
    return newState;
};

});
parcelRegister("79DyI", function(module, exports) {

$parcel$export(module.exports, "AibLineType", function () { return $c77f9f64540c5408$export$38e3d412c155a865; });
var $c77f9f64540c5408$export$38e3d412c155a865 = /*#__PURE__*/ function(AibLineType) {
    AibLineType["leftOnly"] = "Left only";
    AibLineType["centerOnly"] = "Center only";
    AibLineType["leftAndRight"] = "Left and Right";
    AibLineType["leftCenterAndRight"] = "Left, Center and Right";
    return AibLineType;
}({});

});



parcelRegister("bYCc7", function(module, exports) {

$parcel$export(module.exports, "newBlockLine", function () { return $cfe92b5e022255a9$export$cf8236c8de36cfbf; });

var $79DyI = parcelRequire("79DyI");
const $cfe92b5e022255a9$export$cf8236c8de36cfbf = (lineType, blankT)=>{
    const ret = {
        aifid: crypto.randomUUID(),
        lineType: lineType,
        left: [
            (0, $79DyI.AibLineType).leftOnly,
            (0, $79DyI.AibLineType).leftAndRight,
            (0, $79DyI.AibLineType).leftCenterAndRight
        ].includes(lineType) ? blankT : null,
        center: [
            (0, $79DyI.AibLineType).centerOnly,
            (0, $79DyI.AibLineType).leftCenterAndRight
        ].includes(lineType) ? blankT : null,
        right: [
            (0, $79DyI.AibLineType).leftAndRight,
            (0, $79DyI.AibLineType).leftCenterAndRight
        ].includes(lineType) ? blankT : null,
        addBelow: true,
        canEdit: true,
        canMove: true,
        canRemove: true,
        canChangeType: true,
        coreTrafficLight: "BlankNotEvaluated"
    };
    return ret;
};

});


parcelRegister("ee4ue", function(module, exports) {

$parcel$export(module.exports, "AibBlock", function () { return $f1e59bbf121bba12$export$b8aa0f45b9cca988; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $uq2Vj = parcelRequire("uq2Vj");

var $bWgGl = parcelRequire("bWgGl");
const $f1e59bbf121bba12$export$b8aa0f45b9cca988 = ()=>{
    const { state: state } = (0, $bWgGl.useBlockContext)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: state.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibBlock,
        children: state.lines.map((l, li)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $uq2Vj.AibLineDisplay), {
                aifid: l.aifid
            }, `${li}-${l.aifid}`))
    });
};
$f1e59bbf121bba12$export$b8aa0f45b9cca988.displayName = "AibBlock";

});
parcelRegister("uq2Vj", function(module, exports) {

$parcel$export(module.exports, "AibLineDisplay", function () { return $a08679a54cbe4753$export$51ec7c783e305e71; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $8vQMY = parcelRequire("8vQMY");

var $cqVqv = parcelRequire("cqVqv");

var $g9YFX = parcelRequire("g9YFX");

var $llQ3w = parcelRequire("llQ3w");

var $1REUe = parcelRequire("1REUe");

var $bWgGl = parcelRequire("bWgGl");

var $kOA1G = parcelRequire("kOA1G");

var $9IYbD = parcelRequire("9IYbD");

var $79DyI = parcelRequire("79DyI");

var $bYCc7 = parcelRequire("bYCc7");

var $eCKHS = parcelRequire("eCKHS");
const $a08679a54cbe4753$export$51ec7c783e305e71 = ({ aifid: aifid })=>{
    const { state: state, dispatch: dispatch } = (0, $bWgGl.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = ix > -1 ? state.lines[ix] : null;
    const [showOptions, setShowOptions] = (0, $7fPBF.useState)(false);
    const displayType = thisLine?.lineType;
    const isFirstLine = ix === 0;
    const canAddLineAbove = isFirstLine && state.canAddFirstRow && state.lines.length < state.maxLines && !state.disabled;
    const canAddLineBelow = !state.disabled && state.lines.length < state.maxLines && thisLine?.addBelow;
    const divClassName = [
        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineItem,
        displayType && [
            (0, $79DyI.AibLineType).leftOnly,
            (0, $79DyI.AibLineType).centerOnly
        ].includes(displayType) ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).one : displayType && [
            (0, $79DyI.AibLineType).leftAndRight
        ].includes(displayType) ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).two : (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).three
    ].filter((c)=>c !== "").join(" ");
    const lineCoreTrafficLight = (0, $7fPBF.useMemo)(()=>{
        if (state && !state.noTrafficLights && thisLine && thisLine.coreTrafficLight && thisLine.coreTrafficLight !== "BlankNotEvaluated") {
            const tl = new (0, $8vQMY.MosaicTrafficLightClass)(thisLine.coreTrafficLight, "-4px", "-8px");
            return tl.element;
        } else return null;
    }, [
        state,
        thisLine
    ]);
    return !thisLine || !displayType ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        id: `${state.id}-${ix}`,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLine,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineButtons
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1REUe.AibOptionsWindow), {
                aifid: aifid,
                showWindow: showOptions,
                onClose: ()=>setShowOptions(false)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).calcSize,
                menuItems: [
                    {
                        label: "Show line options",
                        action: ()=>{
                            const focusDummy = document.createElement("input");
                            document.body.appendChild(focusDummy);
                            focusDummy.focus();
                            focusDummy.remove();
                            setShowOptions(true);
                        }
                    },
                    {
                        label: "Insert line",
                        group: [
                            {
                                label: "Above",
                                action: ()=>{
                                    const line = (0, $bYCc7.newBlockLine)(state.defaultType, state.editorProps.blankT);
                                    line.canChangeType = state.canChangeType;
                                    dispatch({
                                        operation: (0, $kOA1G.ADD_LINE),
                                        ix: ix,
                                        line: line
                                    });
                                },
                                disabled: !canAddLineAbove
                            },
                            {
                                label: "Below",
                                action: ()=>{
                                    const line = (0, $bYCc7.newBlockLine)(state.defaultType, state.editorProps.blankT);
                                    line.canChangeType = state.canChangeType;
                                    dispatch({
                                        operation: (0, $kOA1G.ADD_LINE),
                                        ix: ix + 1,
                                        line: line
                                    });
                                },
                                disabled: !canAddLineBelow
                            }
                        ]
                    },
                    {
                        label: "Delete line",
                        action: ()=>{
                            dispatch({
                                operation: (0, $kOA1G.REMOVE_LINE),
                                aifid: aifid
                            });
                        },
                        disabled: state.lines.length <= state.minLines || !thisLine.canRemove
                    }
                ],
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineItemHolder,
                    style: {
                        ...state.lineStyle
                    },
                    children: [
                        lineCoreTrafficLight,
                        [
                            (0, $79DyI.AibLineType).leftOnly,
                            (0, $79DyI.AibLineType).leftAndRight,
                            (0, $79DyI.AibLineType).leftCenterAndRight
                        ].includes(displayType) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: divClassName,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9IYbD.CellEditor), {
                                aifid: aifid,
                                position: "left"
                            })
                        }),
                        [
                            (0, $79DyI.AibLineType).centerOnly,
                            (0, $79DyI.AibLineType).leftCenterAndRight
                        ].includes(displayType) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: (0, $cqVqv.classMerge)([
                                divClassName,
                                (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexGrow1
                            ]),
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9IYbD.CellEditor), {
                                aifid: aifid,
                                position: "center"
                            })
                        }),
                        [
                            (0, $79DyI.AibLineType).leftAndRight,
                            (0, $79DyI.AibLineType).leftCenterAndRight
                        ].includes(displayType) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: divClassName,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9IYbD.CellEditor), {
                                aifid: aifid,
                                position: "right"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibLineButtons,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g9YFX.AddLineButton), {
                        aifid: aifid
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eCKHS.RemoveLineButton), {
                        aifid: aifid
                    }),
                    canAddLineAbove && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $g9YFX.AddLineButton), {
                        aifid: aifid,
                        lineAbove: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $llQ3w.AibLineTrafficLight), {
                aifid: aifid
            }),
            ix === state.lines.length - 1 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $llQ3w.AibLineTrafficLight), {
                aifid: "final",
                top: "20px"
            })
        ]
    });
};
$a08679a54cbe4753$export$51ec7c783e305e71.displayName = "AibLineDisplay";

});
parcelRegister("8vQMY", function(module, exports) {

$parcel$export(module.exports, "MosaicTrafficLightColors", function () { return $e6019a87ab6f4473$export$e67a65ddc96bddf7; });
$parcel$export(module.exports, "MosaicTrafficLightClass", function () { return $e6019a87ab6f4473$export$34a14484f72df501; });

var $bbzbN = parcelRequire("bbzbN");

var $4fBSB = parcelRequire("4fBSB");
var $elvNc = parcelRequire("elvNc");
const $e6019a87ab6f4473$export$e67a65ddc96bddf7 = {
    none: {
        displayLabel: "",
        cssColor: "",
        icon: null
    },
    FromScratch: {
        displayLabel: "Created without using an existing template or basic layout",
        cssColor: "#3C1053",
        icon: (0, $elvNc.default)
    },
    FromBasicLayout: {
        displayLabel: "Created using a basic layout",
        cssColor: "#D0006F",
        icon: (0, $elvNc.default)
    },
    FromTemplate: {
        displayLabel: "Created using an existing template",
        cssColor: "#68D2DF",
        icon: (0, $elvNc.default)
    },
    RedError: {
        displayLabel: "The shell includes changes that strongly deviate from the AZSOL template. Please submit a change request in CRYSTAL. In case of any questions, please reach out to the AZSOL team.",
        cssColor: "#FF0000",
        icon: (0, $elvNc.default),
        priority: 90
    },
    AmberChangeExpected: {
        displayLabel: "A customisation is required, please follow the AZSOL General principles.",
        cssColor: "#FFA500",
        icon: (0, $elvNc.default),
        priority: 80
    },
    GreenOk: {
        displayLabel: "OK",
        cssColor: "#008000",
        icon: (0, $elvNc.default),
        priority: 50
    },
    GreenOverride: {
        displayLabel: "Override applied",
        cssColor: "#006400",
        icon: (0, $elvNc.default),
        priority: 60
    },
    BlankNotEvaluated: {
        displayLabel: "Not evaluated",
        cssColor: "#808080",
        icon: (0, $elvNc.default),
        priority: 10
    },
    ChangedUnknown: {
        displayLabel: "Changed",
        cssColor: "#FF00FF",
        icon: (0, $4fBSB.default),
        priority: 100
    }
};
class $e6019a87ab6f4473$export$34a14484f72df501 {
    /**
   * Gets the current traffic light value.
   */ get value() {
        return this._value;
    }
    /**
   * Sets the current traffic light value.
   */ set value(newValue) {
        this._value = newValue;
    }
    /**
   * Gets the display label for the current traffic light.
   */ get displayLabel() {
        return $e6019a87ab6f4473$export$e67a65ddc96bddf7[this._value].displayLabel;
    }
    /**
   * Gets the CSS colour for the current traffic light.
   */ get cssColor() {
        return $e6019a87ab6f4473$export$e67a65ddc96bddf7[this._value].cssColor;
    }
    /**
   * Gets the JSX element for rendering the traffic light icon.
   */ get element() {
        const current = $e6019a87ab6f4473$export$e67a65ddc96bddf7[this._value];
        return current.icon ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: "traffic-light",
            style: this._position === "absolute" || this._top !== "0px" && this._top !== "0" || this._left !== "0px" && this._left !== "0" ? {
                position: "relative"
            } : {
                display: "inline-block"
            },
            "aria-label": "Traffic light holder",
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(current.icon, {
                role: "alert",
                style: this._left !== "0px" && this._left !== "0" && this._top !== "0px" && this._top !== "0" ? {
                    position: "absolute",
                    left: `${this._left}`,
                    top: `${this._top}`
                } : undefined,
                title: current.displayLabel,
                "aria-label": `${this.displayLabel}`,
                color: current.cssColor
            })
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    }
    /**
   * Creates a new traffic light instance.
   *
   * @param value - The traffic light value or array of values to determine priority
   * @param top - The top position offset for the icon
   * @param left - The left position offset for the icon
   * @param position - The CSS position property for the icon
   */ constructor(value, top = "-8px", left = "-16px", position = "relative"){
        this._value = "none";
        this._position = "relative";
        this._top = "-8px";
        this._left = "-16px";
        /* Take highest priority value if array is given */ if (Array.isArray(value)) this.value = value.reduce((highest, current)=>{
            const currentPriority = $e6019a87ab6f4473$export$e67a65ddc96bddf7[current]?.priority ?? 0;
            const highestPriority = $e6019a87ab6f4473$export$e67a65ddc96bddf7[highest]?.priority ?? 0;
            return currentPriority > highestPriority ? current : highest;
        }, value[0]);
        else this.value = value;
        this._top = top;
        this._left = left;
        this._position = position;
    }
}

});
parcelRegister("4fBSB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3185f24379e261be$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $3185f24379e261be$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $3185f24379e261be$var$_extends() {
    return $3185f24379e261be$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3185f24379e261be$var$_extends.apply(null, arguments);
}
function $3185f24379e261be$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3185f24379e261be$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3185f24379e261be$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3185f24379e261be$var$QuestionOctagonFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $3185f24379e261be$var$_objectWithoutProperties(_ref, $3185f24379e261be$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $3185f24379e261be$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-question-octagon-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927"
    }));
});
$3185f24379e261be$var$QuestionOctagonFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $3185f24379e261be$export$2e2bcd8739ae039 = $3185f24379e261be$var$QuestionOctagonFill;

});

parcelRegister("elvNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a71bb02afd165280$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $a71bb02afd165280$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $a71bb02afd165280$var$_extends() {
    return $a71bb02afd165280$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a71bb02afd165280$var$_extends.apply(null, arguments);
}
function $a71bb02afd165280$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a71bb02afd165280$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a71bb02afd165280$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a71bb02afd165280$var$StoplightsFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $a71bb02afd165280$var$_objectWithoutProperties(_ref, $a71bb02afd165280$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $a71bb02afd165280$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-stoplights-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M6 0a2 2 0 0 0-2 2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1c1.2-.4 1.833-1.5 2-2h-2V8c1.2-.4 1.833-1.5 2-2h-2V4c1.2-.4 1.833-1.5 2-2h-2a2 2 0 0 0-2-2zm3.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    }));
});
$a71bb02afd165280$var$StoplightsFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $a71bb02afd165280$export$2e2bcd8739ae039 = $a71bb02afd165280$var$StoplightsFill;

});


parcelRegister("llQ3w", function(module, exports) {

$parcel$export(module.exports, "AibLineTrafficLight", function () { return $23d19cd3f408ef69$export$1d14acef5129c4e1; });

var $8vQMY = parcelRequire("8vQMY");

var $bWgGl = parcelRequire("bWgGl");
const $23d19cd3f408ef69$export$1d14acef5129c4e1 = ({ aifid: aifid, top: top = "-4px" })=>{
    const { state: state } = (0, $bWgGl.useBlockContext)();
    // Check for traffic lights in changedBlocks (existing logic)
    const changedBlockTlValue = state.changedBlocks?.find((b)=>b.coreTrafficLight === "RedError" && (b.idAfterTrafficLightIsShown === aifid || b.idAfterTrafficLightIsShown === "" && aifid === "final"))?.coreTrafficLight;
    // Check for traffic light on the line itself
    const thisLine = state.lines.find((line)=>line.aifid === aifid);
    const lineTlValue = thisLine?.coreTrafficLight;
    // Use changedBlocks traffic light if available, otherwise use line traffic light
    const thisTlValue = changedBlockTlValue ?? (lineTlValue === "ChangedUnknown" || lineTlValue === "RedError" ? lineTlValue : "BlankNotEvaluated");
    const thisTrafficLight = !state?.noTrafficLights && thisTlValue !== "BlankNotEvaluated" ? new (0, $8vQMY.MosaicTrafficLightClass)(thisTlValue, top, "-8px").element : null;
    return !thisTrafficLight ? null : thisTrafficLight;
};
$23d19cd3f408ef69$export$1d14acef5129c4e1.displayName = "AibLineTrafficLight";

});

parcelRegister("1REUe", function(module, exports) {

$parcel$export(module.exports, "AibOptionsWindow", function () { return $bf199f219fb3d76a$export$a4434985949c680e; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $hbWqi = parcelRequire("hbWqi");

var $gOa7m = parcelRequire("gOa7m");

var $bWgGl = parcelRequire("bWgGl");

var $kOA1G = parcelRequire("kOA1G");

var $8gVWl = parcelRequire("8gVWl");
const $bf199f219fb3d76a$export$a4434985949c680e = ({ aifid: aifid, onClose: onClose, showWindow: showWindow })=>{
    const { state: state, dispatch: dispatch } = (0, $bWgGl.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    return !thisLine ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ContextWindow), {
        id: `${state.id}-${ix}-options-window`,
        title: "Line options",
        visible: showWindow,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hbWqi.AioSelect), {
                    id: `${state.id}-${ix}-linetype`,
                    label: "Line type",
                    availableValues: [
                        "Left only",
                        "Center only",
                        "Left, Center and Right",
                        "Left and Right"
                    ],
                    value: thisLine.lineType,
                    setValue: !state.disabled && thisLine.canChangeType ? (ret)=>dispatch({
                            operation: (0, $kOA1G.UPDATE_LINE),
                            line: {
                                ...thisLine,
                                lineType: ret
                            }
                        }) : undefined
                })
            }),
            thisLine.lineType.toString().includes("Left") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gVWl.OriginalTextEditor), {
                aifid: aifid,
                position: "left"
            }),
            thisLine.lineType.toString().includes("Center") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gVWl.OriginalTextEditor), {
                aifid: aifid,
                position: "center"
            }),
            " ",
            thisLine.lineType.toString().includes("Right") && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gVWl.OriginalTextEditor), {
                aifid: aifid,
                position: "right"
            })
        ]
    });
};
$bf199f219fb3d76a$export$a4434985949c680e.displayName = "AibOptionsWindow";

});
parcelRegister("8gVWl", function(module, exports) {

$parcel$export(module.exports, "OriginalTextEditor", function () { return $f2a1db9b71d0a00b$export$d9e75a14757ff5ac; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $bWgGl = parcelRequire("bWgGl");

var $kOA1G = parcelRequire("kOA1G");
const $f2a1db9b71d0a00b$export$d9e75a14757ff5ac = ({ aifid: aifid, position: position })=>{
    const { state: state, dispatch: dispatch } = (0, $bWgGl.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    const thisCell = thisLine[position];
    const Editor = state.editorProps.Editor;
    const id = `${state.id}-${ix}-${position}-original-text`;
    const label = position.slice(0, 1).toUpperCase() + position.slice(1) + " text";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioLabel,
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInputHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).borderBlackSolid
                ]),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                    id: id,
                    value: thisCell,
                    editable: !state.disabled && thisLine?.canEdit,
                    allowWindowView: false,
                    allowMarkdown: false,
                    setValue: (ret)=>dispatch({
                            operation: (0, $kOA1G.UPDATE_BLOCK_CELL),
                            aifid: aifid,
                            position: position,
                            cellContent: ret
                        })
                })
            })
        ]
    });
};
$f2a1db9b71d0a00b$export$d9e75a14757ff5ac.displayName = "OriginalTextEditor";

});


parcelRegister("9IYbD", function(module, exports) {

$parcel$export(module.exports, "CellEditor", function () { return $560135d75921d4c1$export$142345a3064ebeb3; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $bWgGl = parcelRequire("bWgGl");

var $kOA1G = parcelRequire("kOA1G");
const $560135d75921d4c1$export$142345a3064ebeb3 = ({ aifid: aifid, position: position })=>{
    const { state: state, dispatch: dispatch } = (0, $bWgGl.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    const thisCell = thisLine[position];
    const Editor = state.editorProps.Editor;
    // Update for replacements
    const displayValue = (0, $7fPBF.useMemo)(()=>{
        if (thisCell === undefined || thisCell === null) return undefined;
        let ret = (0, $gSkQi.cloneDeep)(thisCell);
        state.externalSingles.forEach((repl)=>{
            ret = state.editorProps.replaceTextInT(ret, repl.oldText, repl.newText);
        });
        return ret;
    }, [
        state.editorProps,
        state.externalSingles,
        thisCell
    ]);
    const editable = !state.disabled && thisLine?.canEdit;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
        id: `${state.id}-${ix}-${position}-text`,
        className: !editable ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aibReadOnly : "",
        editable: editable,
        preReplacedText: thisCell,
        setValue: (ret)=>dispatch({
                operation: (0, $kOA1G.UPDATE_BLOCK_CELL),
                aifid: aifid,
                position: position,
                cellContent: ret
            }),
        textAlignment: position,
        value: displayValue ?? state.editorProps.blankT,
        commentConfig: state.noComments ? undefined : {
            id: aifid,
            activeContext: "TlfItem",
            label: "New line comment",
            iconPosition: {
                top: "-2px",
                left: "-2px"
            }
        }
    });
};
$560135d75921d4c1$export$142345a3064ebeb3.displayName = "CellEditor";

});

parcelRegister("eCKHS", function(module, exports) {

$parcel$export(module.exports, "RemoveLineButton", function () { return $3481620bc65a34b6$export$a284800d32a54efe; });

var $bbzbN = parcelRequire("bbzbN");

var $5m3yv = parcelRequire("5m3yv");

var $bWgGl = parcelRequire("bWgGl");

var $kOA1G = parcelRequire("kOA1G");
const $3481620bc65a34b6$export$a284800d32a54efe = ({ aifid: aifid })=>{
    const { state: state, dispatch: dispatch } = (0, $bWgGl.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    return state.disabled || state.maxLines === 1 && state.minLines === 1 || !thisLine ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${state.id}-${ix}-remove-line`,
        iconName: state.lines.length <= state.minLines || !thisLine.canRemove ? "aioxCircleRed" : "aioxMinus",
        onClick: ()=>!state.disabled && state.lines.length > state.minLines && thisLine.canRemove && dispatch({
                operation: (0, $kOA1G.REMOVE_LINE),
                aifid: aifid
            }),
        tipText: "Remove line"
    });
};
$3481620bc65a34b6$export$a284800d32a54efe.displayName = "RemoveLineButton";

});



parcelRegister("hG9sA", function(module, exports) {

$parcel$export(module.exports, "AsupInternalBlock", function () { return $c02e10ee39e8050b$export$35969708b67f5ce6; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $ee4ue = parcelRequire("ee4ue");

var $bWgGl = parcelRequire("bWgGl");

var $79DyI = parcelRequire("79DyI");
const $c02e10ee39e8050b$export$35969708b67f5ce6 = ({ id: id, canAddFirstRow: canAddFirstRow = false, canChangeType: canChangeType = false, changedBlocks: changedBlocks = [], defaultType: defaultType = (0, $79DyI.AibLineType).centerOnly, disabled: disabled = false, editorProps: editorProps, externalSingles: externalSingles = [], lineStyle: lineStyle = {}, lines: lines, maxLines: maxLines = 10, minLines: minLines = 1, noComments: noComments = false, noTrafficLights: noTrafficLights = false, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bWgGl.BlockContextProvider), {
        initialState: {
            id: id,
            canAddFirstRow: canAddFirstRow,
            canChangeType: canChangeType,
            changed: false,
            changedBlocks: changedBlocks,
            defaultType: defaultType,
            disabled: disabled,
            editorProps: editorProps,
            externalSingles: externalSingles,
            lineStyle: lineStyle,
            lines: lines,
            maxLines: maxLines,
            minLines: minLines,
            noComments: noComments,
            noTrafficLights: noTrafficLights
        },
        onChange: onChange,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee4ue.AibBlock), {})
    });
};
$c02e10ee39e8050b$export$35969708b67f5ce6.displayName = "AsupInternalBlock";

});


parcelRegister("jP1kl", function(module, exports) {
$parcel$export(module.exports, "BeFigure", function () { return (parcelRequire("ladZM")).BeFigure; });
$parcel$export(module.exports, "preProcessFigureInput", function () { return (parcelRequire("Hzrzh")).preProcessFigureInput; });
$parcel$export(module.exports, "isFigureSettingsDto", function () { return (parcelRequire("aSzWy")).isFigureSettingsDto; });
parcelRequire("ladZM");
parcelRequire("iSZ2J");
parcelRequire("6rhFC");
parcelRequire("i9zLN");
parcelRequire("ghk6m");

});
parcelRegister("ladZM", function(module, exports) {

$parcel$export(module.exports, "BeFigure", function () { return $95e0bec42148d6d0$export$ef68e6ff349d0dd2; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $97wH2 = parcelRequire("97wH2");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("2nuru");
var $30Ra3 = parcelRequire("30Ra3");
var $9eqKP = parcelRequire("9eqKP");

var $iSZ2J = parcelRequire("iSZ2J");

var $6rhFC = parcelRequire("6rhFC");
const $95e0bec42148d6d0$export$ef68e6ff349d0dd2 = ({ backEndUrl: backEndUrl, externalFigureRequest: externalFigureRequest, figureInput: figureInput, figureSettings: figureSettings, updateFigureInput: updateFigureInput, varNames: varNames })=>{
    const [showBeFigure, setShowBeFigure] = (0, $7fPBF.useState)(false);
    const [generatedImage, setGeneratedImage] = (0, $7fPBF.useState)("");
    const [requestStatus, setRequestStatus] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    /**
   * Load an image based on the current parameters
   */ const loadFigure = (0, $7fPBF.useEffectEvent)(async (input)=>{
        const request = await (0, $30Ra3.loadWrapper)(externalFigureRequest, input, requestStatus, setRequestStatus, backEndUrl);
        if (request?.success) startTransition(()=>setGeneratedImage(request.data));
    });
    /**
   * Reset requesting state on error click
   */ const handleErrorClick = ()=>{
        setRequestStatus({
            requesting: false,
            error: false
        });
    };
    /**
   * Figure load/reload
   */ (0, $7fPBF.useEffect)(()=>{
        if (!requestStatus.error && !requestStatus.requesting) loadFigure(figureInput);
    }, [
        figureInput,
        requestStatus
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $iSZ2J.BeFigureContextProvider), {
        figureInput: figureInput,
        figureSettings: figureSettings,
        varNames: varNames,
        updateFigureInput: updateFigureInput,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "w-100 mt-3 d-flex justify-content-end",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                    id: "figure-options-toggle",
                    "aria-label": "Toggle figure options",
                    variant: "secondary",
                    size: "sm",
                    onClick: ()=>setShowBeFigure(!showBeFigure),
                    className: "my-2",
                    children: [
                        showBeFigure ? "Hide" : "Show",
                        " figure options"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "d-flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-grow-1 d-flex justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "border border-1 border-gray-500 rounded p-2 position-relative d-flex justify-content-center align-items-center",
                            children: [
                                (requestStatus.requesting || pending) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {}),
                                requestStatus.error ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "text-center align-items-center",
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        minHeight: "600px"
                                    },
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                        className: "text-danger",
                                        onClick: handleErrorClick,
                                        role: "button",
                                        children: "Error loading figure, click to retry"
                                    })
                                }) : generatedImage ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $97wH2.default), {
                                    id: "be-image",
                                    src: generatedImage,
                                    alt: "Generated figure",
                                    style: {
                                        maxWidth: "100%",
                                        maxHeight: "600px",
                                        objectFit: "contain"
                                    }
                                }) : /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    children: "Loading..."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "d-flex justify-content-end align-items-start ms-3",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6rhFC.BeFigureOptions), {
                            show: showBeFigure
                        })
                    })
                ]
            })
        ]
    });
};
$95e0bec42148d6d0$export$ef68e6ff349d0dd2.displayName = "BeFigure";

});
parcelRegister("97wH2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a3e20b00e97499d$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6a3e20b00e97499d$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
const $6a3e20b00e97499d$var$Image = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$6a3e20b00e97499d$var$Image.displayName = 'Image';
var $6a3e20b00e97499d$export$2e2bcd8739ae039 = $6a3e20b00e97499d$var$Image;

});

parcelRegister("iSZ2J", function(module, exports) {

$parcel$export(module.exports, "BeFigureContextProvider", function () { return $62e67df51a3d53ca$export$cd63364b4fef623c; });
$parcel$export(module.exports, "useBeFigure", function () { return $62e67df51a3d53ca$export$e384a75e65f89108; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $9JydI = parcelRequire("9JydI");

var $5U7KB = parcelRequire("5U7KB");
const $62e67df51a3d53ca$export$4b7e741aafc2baa4 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $62e67df51a3d53ca$export$cd63364b4fef623c = ({ children: children, figureInput: figureInput, figureSettings: figureSettings, updateFigureInput: updateFigureInput, varNames: varNames })=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $9JydI.figureReducer), {
        figureInput: figureInput,
        figureSettings: figureSettings,
        varNames: varNames,
        changed: false
    });
    (0, $7fPBF.useEffect)(()=>{
        const eq = (0, $gSkQi.isEqual)(state.figureInput, figureInput);
        // Send changes up
        if (!eq && state.figureInput.id === figureInput.id && state.changed) {
            updateFigureInput(state.figureInput);
            dispatch({
                operation: (0, $5U7KB.FIGURE_CHANGE_SENT)
            });
        } else if (state.figureInput.id !== figureInput.id || !eq) dispatch({
            operation: (0, $5U7KB.LOAD_FIGURE_INPUT),
            figureInput: figureInput
        });
    }, [
        figureInput,
        state.changed,
        state.figureInput,
        updateFigureInput
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($62e67df51a3d53ca$export$4b7e741aafc2baa4.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$62e67df51a3d53ca$export$cd63364b4fef623c.displayName = "BeFigureContextProvider";
const $62e67df51a3d53ca$export$e384a75e65f89108 = ()=>{
    const context = (0, $7fPBF.useContext)($62e67df51a3d53ca$export$4b7e741aafc2baa4);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
};

});
parcelRegister("9JydI", function(module, exports) {

$parcel$export(module.exports, "figureReducer", function () { return $8e67870340906ea2$export$af91632802d2877e; });

var $6hWPd = parcelRequire("6hWPd");
parcelRequire("2nuru");
var $dsPLF = parcelRequire("dsPLF");
var $34cNk = parcelRequire("34cNk");

var $8xZZY = parcelRequire("8xZZY");

var $5U7KB = parcelRequire("5U7KB");
const $8e67870340906ea2$export$af91632802d2877e = (state, action)=>{
    switch(action.operation){
        case 0, $5U7KB.ADD_DATA_GROUP:
            if (state.figureInput.dataGroups.length === action.newLength - 1) {
                const newDataGroup = {
                    id: crypto.randomUUID(),
                    dataGroupName: `DataGroup_${action.newLength}`,
                    dataGroupLabel: `Data Group ${action.newLength}`,
                    properties: (0, $8xZZY.fillPropertiesArray)(state.figureSettings.figureTypeSettings.find((ft)=>ft.value === state.figureInput.figureType)?.dataRowVars ?? [])
                };
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        dataGroups: [
                            ...state.figureInput.dataGroups,
                            newDataGroup
                        ]
                    }
                };
            }
            return state;
        case 0, $5U7KB.ADD_PROPERTY:
            {
                const newProperty = {
                    varName: action.varName,
                    value: ""
                };
                const pointer = (0, $6hWPd.Pointer).fromJSON(action.pointer);
                const currentProperties = pointer.get(state.figureInput);
                const newProperties = [
                    ...currentProperties,
                    newProperty
                ];
                const updatedFigureInput = (0, $dsPLF.mutateByPath)(state.figureInput, action.pointer, newProperties);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5U7KB.ADD_REFERENCE_LINE:
            if (state.figureInput.referenceLines.length === action.newLength - 1) {
                const newReferenceLine = {
                    id: crypto.randomUUID(),
                    properties: (0, $8xZZY.fillPropertiesArray)(state.figureSettings.figureReferenceLinesSettings)
                };
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        referenceLines: [
                            ...state.figureInput.referenceLines,
                            newReferenceLine
                        ]
                    }
                };
            }
            return state;
        case 0, $5U7KB.ADD_REGRESSION_LINE:
            if (state.figureInput.regressionLines.length === action.newLength - 1) {
                const defaultRLSettings = state.figureSettings.figureRegressionLineSettings[0];
                const newRegressionLine = {
                    id: crypto.randomUUID(),
                    lineType: defaultRLSettings?.lineType || "linear",
                    properties: (0, $8xZZY.fillPropertiesArray)(defaultRLSettings?.parameters ?? [])
                };
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        regressionLines: [
                            ...state.figureInput.regressionLines,
                            newRegressionLine
                        ]
                    }
                };
            }
            return state;
        case 0, $5U7KB.CHANGE_REGRESSION_LINE_TYPE:
            {
                const newLineTypeSettings = state.figureSettings.figureRegressionLineSettings.find((rls)=>rls.lineType === action.lineType);
                const thisRegressionLine = (0, $6hWPd.Pointer).fromJSON(action.pointer).get(state.figureInput);
                const newRegressionLine = {
                    ...thisRegressionLine,
                    lineType: action.lineType,
                    properties: (0, $8xZZY.fillPropertiesArray)(newLineTypeSettings?.parameters ?? [], thisRegressionLine.properties)
                };
                const updatedFigureInput = (0, $dsPLF.mutateByPath)(state.figureInput, action.pointer, newRegressionLine);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5U7KB.FIGURE_CHANGE_SENT:
            return {
                ...state,
                changed: false
            };
        case 0, $5U7KB.LOAD_FIGURE_INPUT:
            return {
                ...state,
                changed: false,
                figureInput: action.figureInput,
                savedFigureData: {}
            };
        case 0, $5U7KB.PATCH_FIGURE_STATE:
            {
                const updatedFigureInput = (0, $dsPLF.mutateByPath)(state.figureInput, action.pointer, action.value);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5U7KB.REMOVE_FIGURE_ITEM:
            {
                const updatedFigureInput = (0, $34cNk.removeByPath)(state.figureInput, action.dataPath, action.newLength);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5U7KB.SET_FIGURE_TYPE:
            {
                const oldFigureType = state.figureInput.figureType;
                const newFigureTypeSettings = state.figureSettings.figureTypeSettings.find((ft)=>ft.value === action.newValue);
                // Save current figure data before switching
                const savedFigureData = {
                    ...state.savedFigureData ?? {},
                    [oldFigureType]: {
                        figureTypeProperties: state.figureInput.figureTypeProperties,
                        dataGroups: state.figureInput.dataGroups,
                        regressionLines: state.figureInput.regressionLines,
                        axes: state.figureInput.axes
                    }
                };
                // Check if we have saved data for the new figure type
                const restoredData = savedFigureData[action.newValue];
                let dataGroups;
                let axes;
                const figureTypeProperties = (0, $8xZZY.fillPropertiesArray)(newFigureTypeSettings?.properties ?? [], restoredData?.figureTypeProperties);
                const regressionLines = restoredData?.regressionLines ?? [];
                if (restoredData?.dataGroups && restoredData.dataGroups.length > 0) // Restore saved data groups
                dataGroups = restoredData.dataGroups.map((dg)=>({
                        ...dg,
                        properties: (0, $8xZZY.fillPropertiesArray)(newFigureTypeSettings?.dataRowVars ?? [], dg.properties)
                    }));
                else {
                    // Create default data groups
                    const numberOfSeries = newFigureTypeSettings?.defaultNumberOfSeries ?? 1;
                    const defaultSeries = newFigureTypeSettings?.defaultSeries ?? [];
                    dataGroups = [];
                    for(let i = 0; i < numberOfSeries; i++){
                        const thisDefaultSeries = defaultSeries.length > 0 ? defaultSeries[i % defaultSeries.length] : undefined;
                        const defaultGroupName = thisDefaultSeries?.dataGroupName ?? "DataGroup";
                        const defaultGroupLabel = thisDefaultSeries?.dataGroupLabel ?? "Data Group";
                        const newDataGroup = {
                            id: crypto.randomUUID(),
                            dataGroupName: `${defaultGroupName}`,
                            dataGroupLabel: `${defaultGroupLabel}`,
                            properties: (0, $8xZZY.fillPropertiesArray)(newFigureTypeSettings?.dataRowVars ?? [], thisDefaultSeries?.properties)
                        };
                        dataGroups.push(newDataGroup);
                    }
                }
                if (restoredData?.axes && restoredData.axes.length > 0) // Restore saved axes
                axes = restoredData.axes.map((axis)=>{
                    const axisSettings = state.figureSettings.figureAxisSettings.find((as)=>as.axisType === axis.axisType);
                    return {
                        ...axis,
                        properties: (0, $8xZZY.fillPropertiesArray)(axisSettings?.parameters ?? // istanbul ignore next
                        [], axis.properties)
                    };
                });
                else {
                    // Create default axes based on requiredAxis
                    const requiredAxis = newFigureTypeSettings?.requiredAxis ?? [];
                    axes = requiredAxis.map((axisType)=>{
                        const axisSettings = state.figureSettings.figureAxisSettings.find((as)=>as.axisType === axisType);
                        return {
                            id: crypto.randomUUID(),
                            axisType: axisType,
                            properties: (0, $8xZZY.fillPropertiesArray)(axisSettings?.parameters ?? // istanbul ignore next
                            [])
                        };
                    });
                }
                return {
                    ...state,
                    changed: true,
                    savedFigureData: savedFigureData,
                    figureInput: {
                        ...state.figureInput,
                        figureType: action.newValue,
                        figureTypeProperties: figureTypeProperties,
                        dataGroups: dataGroups,
                        regressionLines: regressionLines,
                        axes: axes
                    }
                };
            }
        case 0, $5U7KB.SET_LEGEND_TYPE:
            {
                const legendTypeSettings = state.figureSettings.figureLegendSettings.find((lt)=>lt.legendType === action.newValue);
                const updatedLegend = state.figureInput.legend.map((li)=>({
                        ...li,
                        properties: (0, $8xZZY.fillPropertiesArray)(legendTypeSettings?.parameters ?? [], li.properties)
                    }));
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        legendType: action.newValue,
                        legend: updatedLegend
                    }
                };
            }
    }
};

});
parcelRegister("8xZZY", function(module, exports) {

$parcel$export(module.exports, "fillPropertiesArray", function () { return $153b0640bd1cf7d7$export$e4e898be1499fefb; });

var $gSkQi = parcelRequire("gSkQi");
const $153b0640bd1cf7d7$export$e4e898be1499fefb = (propertiesSettings, existingProperties)=>{
    const newProperties = [
        ...existingProperties ?? []
    ];
    propertiesSettings.forEach((propSetting)=>{
        if (!newProperties.find((p)=>p.varName === propSetting.varName)) newProperties.push({
            varName: propSetting.varName,
            value: propSetting.defaultValue ?? (propSetting.varName === "seed" ? (0, $gSkQi.random)(1, 100).toString() : "")
        });
    });
    return newProperties;
};

});

parcelRegister("5U7KB", function(module, exports) {

$parcel$export(module.exports, "ADD_DATA_GROUP", function () { return $e8ed7ec9bd856631$export$f5562b4a1c8c97cf; });
$parcel$export(module.exports, "ADD_PROPERTY", function () { return $e8ed7ec9bd856631$export$a4e3dcfda69557dc; });
$parcel$export(module.exports, "ADD_REFERENCE_LINE", function () { return $e8ed7ec9bd856631$export$5c91032a07a83b14; });
$parcel$export(module.exports, "ADD_REGRESSION_LINE", function () { return $e8ed7ec9bd856631$export$4d568f079db6bac7; });
$parcel$export(module.exports, "CHANGE_REGRESSION_LINE_TYPE", function () { return $e8ed7ec9bd856631$export$85262a788ce8b3ce; });
$parcel$export(module.exports, "FIGURE_CHANGE_SENT", function () { return $e8ed7ec9bd856631$export$dfc3134222855010; });
$parcel$export(module.exports, "LOAD_FIGURE_INPUT", function () { return $e8ed7ec9bd856631$export$c6dd21050e43e00; });
$parcel$export(module.exports, "PATCH_FIGURE_STATE", function () { return $e8ed7ec9bd856631$export$6673c6260a15e737; });
$parcel$export(module.exports, "REMOVE_FIGURE_ITEM", function () { return $e8ed7ec9bd856631$export$6fd04a860a2d0c0c; });
$parcel$export(module.exports, "SET_FIGURE_TYPE", function () { return $e8ed7ec9bd856631$export$97d14988a0f67fc5; });
$parcel$export(module.exports, "SET_LEGEND_TYPE", function () { return $e8ed7ec9bd856631$export$d7d24c2ec485dfe4; });
const $e8ed7ec9bd856631$export$f5562b4a1c8c97cf = "ADD_DATA_GROUP";
const $e8ed7ec9bd856631$export$a4e3dcfda69557dc = "ADD_PROPERTY";
const $e8ed7ec9bd856631$export$5c91032a07a83b14 = "ADD_REFERENCE_LINE";
const $e8ed7ec9bd856631$export$4d568f079db6bac7 = "ADD_REGRESSION_LINE";
const $e8ed7ec9bd856631$export$85262a788ce8b3ce = "CHANGE_REGRESSION_LINE_TYPE";
const $e8ed7ec9bd856631$export$dfc3134222855010 = "FIGURE_CHANGE_SENT";
const $e8ed7ec9bd856631$export$c6dd21050e43e00 = "LOAD_FIGURE_INPUT";
const $e8ed7ec9bd856631$export$6673c6260a15e737 = "PATCH_FIGURE_STATE";
const $e8ed7ec9bd856631$export$6fd04a860a2d0c0c = "REMOVE_FIGURE_ITEM";
const $e8ed7ec9bd856631$export$97d14988a0f67fc5 = "SET_FIGURE_TYPE";
const $e8ed7ec9bd856631$export$d7d24c2ec485dfe4 = "SET_LEGEND_TYPE";

});



parcelRegister("6rhFC", function(module, exports) {

$parcel$export(module.exports, "BeFigureOptions", function () { return $756fa7b2317ef2b2$export$32d8307fb3ca4d02; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");
parcelRequire("gYROb");
var $gxUSF = parcelRequire("gxUSF");
var $isQD0 = parcelRequire("isQD0");
var $cdwkg = parcelRequire("cdwkg");

var $iSZ2J = parcelRequire("iSZ2J");

var $aouAn = parcelRequire("aouAn");

var $gvKSY = parcelRequire("gvKSY");

var $5U7KB = parcelRequire("5U7KB");
parcelRequire("ghk6m");
var $g9Z7k = parcelRequire("g9Z7k");
const $756fa7b2317ef2b2$export$ab11e7d7d71c291f = [
    {
        varName: "order",
        label: "Order",
        type: (0, $g9Z7k.FigureVarTypeDto).number
    },
    {
        varName: "orderHeader",
        label: "Label",
        type: (0, $g9Z7k.FigureVarTypeDto).string
    },
    {
        varName: "seed",
        label: "Seed",
        type: (0, $g9Z7k.FigureVarTypeDto).number
    },
    {
        varName: "length",
        label: "Length",
        type: (0, $g9Z7k.FigureVarTypeDto).number
    }
];
const $756fa7b2317ef2b2$export$32d8307fb3ca4d02 = ({ show: show })=>{
    const { state: state, dispatch: dispatch } = (0, $iSZ2J.useBeFigure)();
    const figureInput = state?.figureInput;
    const figureSettings = state?.figureSettings;
    const figureTypes = state?.figureSettings.figureTypeSettings.map((ft)=>({
            label: ft.label,
            value: ft.value
        })) ?? [];
    const figureTypeProperties = state?.figureSettings.figureTypeSettings.find((ft)=>ft.value === figureInput?.figureType)?.properties ?? [];
    const allowedRegressionTypes = state?.figureSettings.figureTypeSettings.find((ft)=>ft.value === figureInput?.figureType)?.allowedRegressionTypes ?? [];
    const isLegendVisible = state?.figureSettings.figureTypeSettings.find((ft)=>ft.value === figureInput?.figureType)?.isLegendVisible ?? true;
    const legendTypes = state?.figureSettings.figureLegendSettings.map((lt)=>lt.legendType) ?? [];
    const [showImageProps, setShowImageProps] = (0, $7fPBF.useState)(false);
    const [showTypeProps, setShowTypeProps] = (0, $7fPBF.useState)(false);
    return !figureSettings || !figureTypes || !figureInput ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cdwkg.HorizontalDrawer), {
        show: show,
        side: "right",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
            className: "border rounded border-gray-500 border-2 ps-3 pe-4 me-3 pb-1",
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                    label: "Figure type",
                    labelWidth: 3,
                    value: figureInput.figureType,
                    options: figureTypes,
                    setValue: (newValue)=>dispatch({
                            operation: (0, $5U7KB.SET_FIGURE_TYPE),
                            newValue: newValue
                        }),
                    id: "figure-type"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                    label: "Legend type",
                    labelWidth: 3,
                    value: figureInput.legendType,
                    options: legendTypes,
                    setValue: (newValue)=>dispatch({
                            operation: (0, $5U7KB.SET_LEGEND_TYPE),
                            newValue: newValue
                        }),
                    id: "legend-type"
                }),
                figureSettings.figureProperties.length > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxUSF.CollapseRow), {
                    label: "Image properties",
                    isOpen: showImageProps,
                    setIsOpen: setShowImageProps,
                    className: "border rounded border-gray-500 border-2 px-1",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gvKSY.FigureVars), {
                        id: "properties",
                        dataPath: "/properties",
                        varSettings: figureSettings.figureProperties,
                        properties: figureInput.properties
                    })
                }),
                figureTypeProperties.length > 0 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxUSF.CollapseRow), {
                            label: "Figure properties",
                            isOpen: showTypeProps,
                            setIsOpen: setShowTypeProps,
                            className: "border rounded border-gray-500 border-2 px-1",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gvKSY.FigureVars), {
                                id: "figure-properties",
                                dataPath: "/figureTypeProperties",
                                varSettings: figureTypeProperties,
                                properties: figureInput.figureTypeProperties
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {}),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aouAn.FigureDataRows), {
                    dataPath: "/axes",
                    itemLabel: "Axis",
                    label: "Axes",
                    noAddRemove: true,
                    propertiesKey: "properties"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {}),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aouAn.FigureDataRows), {
                    addType: (0, $5U7KB.ADD_DATA_GROUP),
                    dataPath: "/dataGroups",
                    itemLabel: "Data series",
                    label: "Data Groups",
                    propertiesKey: "properties"
                }),
                isLegendVisible && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aouAn.FigureDataRows), {
                            dataPath: "/legend",
                            itemLabel: "Settings",
                            label: "Legend",
                            propertiesKey: "properties",
                            noAddRemove: true,
                            noNumber: true
                        })
                    ]
                }),
                allowedRegressionTypes.length > 0 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aouAn.FigureDataRows), {
                            addType: (0, $5U7KB.ADD_REGRESSION_LINE),
                            dataPath: "/regressionLines",
                            itemLabel: "Regression line",
                            label: "Regression Lines",
                            propertiesKey: "properties"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {}),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aouAn.FigureDataRows), {
                    addType: (0, $5U7KB.ADD_REFERENCE_LINE),
                    dataPath: "/referenceLines",
                    itemLabel: "Reference line",
                    label: "Reference Lines",
                    propertiesKey: "properties"
                })
            ]
        })
    });
};
$756fa7b2317ef2b2$export$32d8307fb3ca4d02.displayName = "BeFigureOptions";

});
parcelRegister("aouAn", function(module, exports) {

$parcel$export(module.exports, "FigureDataRows", function () { return $516058c338a0160c$export$a044f389a74b8cc8; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $6hWPd = parcelRequire("6hWPd");
parcelRequire("gYROb");
var $gxUSF = parcelRequire("gxUSF");

var $cF7pr = parcelRequire("cF7pr");

var $iSZ2J = parcelRequire("iSZ2J");

var $6AlUQ = parcelRequire("6AlUQ");
const $516058c338a0160c$export$a044f389a74b8cc8 = ({ addType: addType, dataPath: dataPath, itemLabel: itemLabel, label: label, noAddRemove: noAddRemove = false, noNumber: noNumber = false, propertiesKey: propertiesKey })=>{
    const { state: state } = (0, $iSZ2J.useBeFigure)();
    const figureInput = state?.figureInput;
    const figureSettings = state?.figureSettings;
    const figureType = figureInput?.figureType;
    const figureTypeSettings = figureSettings?.figureTypeSettings.find((fts)=>fts.value === figureType);
    const pointer = (0, $6hWPd.Pointer).fromJSON(dataPath);
    const item = pointer.get(figureInput);
    const itemArray = Array.isArray(item) ? item : undefined;
    const [show, setShow] = (0, $7fPBF.useState)(false);
    return !itemArray || typeof itemArray === "string" || !figureType || !figureSettings || !figureTypeSettings ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxUSF.CollapseRow), {
        label: label,
        isOpen: show,
        setIsOpen: setShow,
        className: "border rounded border-gray-500 border-2 px-1",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            children: [
                itemArray.map((item, ix)=>{
                    let varSettings = [];
                    switch(dataPath){
                        case "/axes":
                            varSettings = figureSettings.figureAxisSettings.find((ftas)=>figureTypeSettings.requiredAxis[ix] === ftas.axisType)?.parameters ?? // istanbul ignore next
                            [];
                            break;
                        case "/legend":
                            varSettings = figureSettings.figureLegendSettings.find((ls)=>ls.legendType === figureInput.legendType)?.parameters ?? // istanbul ignore next
                            [];
                            break;
                        case "/referenceLines":
                            varSettings = figureSettings.figureReferenceLinesSettings;
                            break;
                        case "/regressionLines":
                            varSettings = figureSettings.figureRegressionLineSettings.find((fs)=>fs.lineType === item.lineType)?.parameters ?? // istanbul ignore next
                            [];
                            break;
                        case "/dataGroups":
                        default:
                            varSettings = figureTypeSettings.dataRowVars;
                            break;
                    }
                    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6AlUQ.FigureDataRow), {
                        id: item.id,
                        dataPath: `${dataPath}/${ix}`,
                        itemLabel: itemLabel,
                        noNumber: noNumber,
                        noRemove: noAddRemove,
                        propertiesKey: propertiesKey,
                        siblingCount: itemArray.length,
                        varSettings: varSettings
                    }, ix);
                }),
                !noAddRemove && addType && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cF7pr.AddNewButton), {
                    id: "add-data-row-btn",
                    operation: addType,
                    newLength: itemArray.length + 1
                })
            ]
        })
    });
};
$516058c338a0160c$export$a044f389a74b8cc8.displayName = "FigureDataRows";

});
parcelRegister("cF7pr", function(module, exports) {

$parcel$export(module.exports, "AddNewButton", function () { return $a59a441516037b11$export$f48e59479b265be9; });

var $bbzbN = parcelRequire("bbzbN");

var $6dv4K = parcelRequire("6dv4K");
parcelRequire("gYROb");
var $8HzIe = parcelRequire("8HzIe");

var $iSZ2J = parcelRequire("iSZ2J");
const $a59a441516037b11$export$f48e59479b265be9 = ({ operation: operation, newLength: newLength, label: label = "Add", ...rest })=>{
    const { dispatch: dispatch } = (0, $iSZ2J.useBeFigure)();
    return !dispatch ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
        onClick: ()=>dispatch({
                operation: operation,
                newLength: newLength
            }),
        className: "my-2 d-flex align-items-center btn btn-sm btn-success justify-content-center",
        ...rest,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "me-2",
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {})
        ]
    });
};
$a59a441516037b11$export$f48e59479b265be9.displayName = "AddNewButton";

});

parcelRegister("6AlUQ", function(module, exports) {

$parcel$export(module.exports, "FigureDataRow", function () { return $cbb3e2bfe46d38bd$export$f09f1e74b11b6073; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $6hWPd = parcelRequire("6hWPd");
parcelRequire("gYROb");
var $gxUSF = parcelRequire("gxUSF");
var $isQD0 = parcelRequire("isQD0");

var $iSZ2J = parcelRequire("iSZ2J");

var $gvKSY = parcelRequire("gvKSY");

var $5U7KB = parcelRequire("5U7KB");

var $uiwZA = parcelRequire("uiwZA");
parcelRequire("ghk6m");
var $gfHMt = parcelRequire("gfHMt");
const $cbb3e2bfe46d38bd$export$f09f1e74b11b6073 = ({ id: id, dataPath: dataPath, itemLabel: itemLabel, noNumber: noNumber = false, noRemove: noRemove = false, propertiesKey: propertiesKey, siblingCount: siblingCount, varSettings: varSettings })=>{
    const { state: state, dispatch: dispatch } = (0, $iSZ2J.useBeFigure)();
    const figureSettings = state?.figureSettings;
    const figureInput = state?.figureInput;
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(true);
    const figureTypeSettings = figureSettings?.figureTypeSettings.find((fts)=>fts.value === figureInput?.figureType);
    const allowedRegressionLines = figureTypeSettings?.allowedRegressionTypes ?? [];
    // Get the array from figureInput using dataPath
    const pointer = (0, $6hWPd.Pointer).fromJSON(dataPath);
    const item = pointer.get(figureInput);
    const thisProps = (0, $7fPBF.useMemo)(()=>Array.isArray(item?.properties) && item.properties.every((p)=>(0, $gfHMt.isFigureVarDataDto)(p)) ? item.properties : [], [
        item
    ]);
    const ix = parseInt(pointer.tokens[pointer.tokens.length - 1]);
    // Get the display label from the "name" property if it exists, otherwise use itemLabel N
    const displayLabel = (0, $7fPBF.useMemo)(()=>{
        const nameProperty = thisProps.find((p)=>p.varName === "name");
        const labelProperty = thisProps.find((p)=>p.varName === "label");
        if (nameProperty?.value) return nameProperty.value;
        if (labelProperty?.value) return labelProperty.value;
        return noNumber ? itemLabel : `${itemLabel} ${ix + 1}`;
    }, [
        thisProps,
        itemLabel,
        noNumber,
        ix
    ]);
    // Check props exist for all varSettings, if not add empty
    const addMissingProps = (0, $7fPBF.useEffectEvent)((varSettings, thisProps)=>varSettings.forEach((varSetting)=>{
            const pix = thisProps.findIndex((p)=>p.varName === varSetting.varName);
            if (pix < 0) dispatch({
                operation: (0, $5U7KB.ADD_PROPERTY),
                pointer: `${dataPath}/properties`,
                varName: varSetting.varName
            });
        }));
    (0, $7fPBF.useEffect)(()=>{
        addMissingProps(varSettings, thisProps);
    }, [
        varSettings,
        thisProps
    ]);
    return !figureSettings || !figureInput || !item || !thisProps || varSettings.length === 0 ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $gxUSF.CollapseRow), {
        className: "border rounded border-gray-500 border-2 px-1 mb-2",
        label: /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
            className: "fw-bold d-flex align-items-center",
            children: [
                displayLabel,
                !noRemove && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $uiwZA.RemoveFigureItemButton), {
                    id: `${id}-remove-btn`,
                    dataPath: dataPath,
                    siblingCount: siblingCount
                })
            ]
        }),
        isOpen: isOpen,
        setIsOpen: ()=>setIsOpen(!isOpen),
        children: [
            dataPath.startsWith("/regressionLines") && item.lineType && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                id: `${id}-line-type`,
                label: "Regression line type",
                labelWidth: 3,
                value: item.lineType,
                options: allowedRegressionLines,
                setValue: (newValue)=>{
                    dispatch({
                        operation: (0, $5U7KB.CHANGE_REGRESSION_LINE_TYPE),
                        pointer: `${dataPath}`,
                        lineType: newValue
                    });
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gvKSY.FigureVars), {
                id: id,
                dataPath: `${dataPath}/${propertiesKey}`,
                varSettings: varSettings,
                properties: thisProps
            })
        ]
    });
};
$cbb3e2bfe46d38bd$export$f09f1e74b11b6073.displayName = "FigureDataRow";

});
parcelRegister("gvKSY", function(module, exports) {

$parcel$export(module.exports, "FigureVars", function () { return $0fc796a0052e1c1d$export$491ad496ac74ba0e; });

var $bbzbN = parcelRequire("bbzbN");

var $e5w6J = parcelRequire("e5w6J");
const $0fc796a0052e1c1d$export$491ad496ac74ba0e = ({ id: id, dataPath: dataPath, varSettings: varSettings, properties: properties })=>{
    return varSettings.map((varSetting)=>{
        const pix = properties.findIndex((p)=>p.varName === varSetting.varName);
        // Return null if property is missing, should be added by parent component
        if (pix < 0) return null;
        // Check if this variable has conditional requirements
        if (varSetting.requires) {
            const requiredProperty = properties.find((p)=>p.varName === varSetting.requires?.varName);
            // If the required property doesn't exist or its value is not in the allowed values, don't render
            if (!requiredProperty || !varSetting.requires.values.includes(requiredProperty.value)) return null;
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e5w6J.FigureVar), {
            pointer: `${dataPath}/${pix}/value`,
            figureVarType: varSetting.type,
            label: varSetting.label,
            varName: varSetting.varName,
            options: varSetting.options
        }, `${id}-${varSetting.varName}`);
    });
};

});
parcelRegister("e5w6J", function(module, exports) {

$parcel$export(module.exports, "FigureVar", function () { return $e26070d892f8ba62$export$9e617fe7cdf38346; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $6hWPd = parcelRequire("6hWPd");
parcelRequire("gYROb");
var $9Er6k = parcelRequire("9Er6k");
var $isQD0 = parcelRequire("isQD0");

var $iSZ2J = parcelRequire("iSZ2J");

var $5U7KB = parcelRequire("5U7KB");
parcelRequire("ghk6m");
var $g9Z7k = parcelRequire("g9Z7k");
const $e26070d892f8ba62$export$9e617fe7cdf38346 = ({ label: label, figureVarType: figureVarType, pointer: pointer, varName: varName, options: options })=>{
    const id = (0, $7fPBF.useId)();
    const { state: state, dispatch: dispatch } = (0, $iSZ2J.useBeFigure)();
    const figureInput = state?.figureInput;
    const dp = (0, $6hWPd.Pointer).fromJSON(pointer);
    const val = dp.get(figureInput) ?? "";
    return !state ? null : figureVarType === (0, $g9Z7k.FigureVarTypeDto).select ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
        id: `${id}-${varName}`,
        label: label,
        labelWidth: 3,
        value: val,
        setValue: (newValue)=>dispatch({
                operation: (0, $5U7KB.PATCH_FIGURE_STATE),
                pointer: pointer,
                value: newValue
            }),
        options: [
            ...!options?.includes(val) ? [
                {
                    value: "",
                    label: "-- Select --"
                }
            ] : [],
            ...(options ?? []).map((s)=>({
                    value: s,
                    label: s
                }))
        ]
    }, `${id}-${varName}`) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
        id: `${id}-${varName}`,
        label: label,
        labelWidth: 3,
        value: val,
        type: figureVarType === (0, $g9Z7k.FigureVarTypeDto).number ? "number" : "string",
        debounceMilliseconds: 500,
        setValue: (newValue)=>dispatch({
                operation: (0, $5U7KB.PATCH_FIGURE_STATE),
                pointer: pointer,
                value: newValue
            })
    }, `${id}-${varName}`);
};
$e26070d892f8ba62$export$9e617fe7cdf38346.displayName = "FigureVar";

});
parcelRegister("ghk6m", function(module, exports) {
$parcel$export(module.exports, "isFigureSettingsDto", function () { return (parcelRequire("aSzWy")).isFigureSettingsDto; });
$parcel$export(module.exports, "isFigureVarDataDto", function () { return (parcelRequire("gfHMt")).isFigureVarDataDto; });
$parcel$export(module.exports, "FigureVarTypeDto", function () { return (parcelRequire("g9Z7k")).FigureVarTypeDto; });
parcelRequire("gDZYu");
parcelRequire("defL5");
parcelRequire("7tt1L");
parcelRequire("bZwuB");
parcelRequire("2FBRb");
parcelRequire("iCwy0");
parcelRequire("hXGCZ");
parcelRequire("s85Yh");
parcelRequire("jBtmk");
parcelRequire("4hqPB");
parcelRequire("aSzWy");
parcelRequire("70Y7p");
parcelRequire("ddWKn");
parcelRequire("gfHMt");
parcelRequire("g9Z7k");

});
parcelRegister("gDZYu", function(module, exports) {

$parcel$export(module.exports, "isFigureAxisDataDto", function () { return $a742d14891eb9e4c$export$67f3b38a36d6773c; });

var $gfHMt = parcelRequire("gfHMt");
const $a742d14891eb9e4c$export$67f3b38a36d6773c = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.axisType !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    return true;
};

});
parcelRegister("gfHMt", function(module, exports) {

$parcel$export(module.exports, "isFigureVarDataDto", function () { return $08a1d82e71bebbc1$export$1599e7102407b3b1; });
/**
 * Represents variable data for a figure property, pairing a variable name with its current value.
 */ const $08a1d82e71bebbc1$export$1599e7102407b3b1 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.varName !== "string") return false;
    if (typeof chkObj.value !== "string") return false;
    return true;
};

});


parcelRegister("defL5", function(module, exports) {

$parcel$export(module.exports, "isFigureAxisSettingsDto", function () { return $ac1437dd8c23dbbc$export$9a3403397094d501; });

var $g9Z7k = parcelRequire("g9Z7k");
const $ac1437dd8c23dbbc$export$9a3403397094d501 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.axisType !== "string") return false;
    if (!Array.isArray(chkObj.parameters)) return false;
    if (chkObj.parameters.some((parameter)=>!(0, $g9Z7k.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});
parcelRegister("g9Z7k", function(module, exports) {

$parcel$export(module.exports, "FigureVarTypeDto", function () { return $750c7f66f9070aa6$export$189a7cbcdf9d114f; });
$parcel$export(module.exports, "isFigureVarSettingsDto", function () { return $750c7f66f9070aa6$export$5bafd2b3c43240fb; });
/**
 * Enumeration of all supported figure variable setting types.
 * Used to discriminate between different variable setting shapes.
 */ var $750c7f66f9070aa6$export$189a7cbcdf9d114f = /*#__PURE__*/ function(FigureVarTypeDto) {
    FigureVarTypeDto["list"] = "list";
    FigureVarTypeDto["number"] = "number";
    FigureVarTypeDto["string"] = "string";
    FigureVarTypeDto["select"] = "select";
    FigureVarTypeDto["variable"] = "variable";
    return FigureVarTypeDto;
}({});
const $750c7f66f9070aa6$export$5bafd2b3c43240fb = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.varName !== "string") return false;
    if (typeof chkObj.label !== "string") return false;
    if (chkObj.type !== "list" && chkObj.type !== "number" && chkObj.type !== "string" && chkObj.type !== "select" && chkObj.type !== "variable") return false;
    if (chkObj.type === "select") {
        const selectObj = chkObj;
        if (!Array.isArray(selectObj.options) || selectObj.options.some((option)=>typeof option !== "string")) return false;
    }
    if (chkObj.type !== "select" && "options" in chkObj) return false;
    if ("requires" in chkObj && chkObj.requires !== undefined) {
        if (typeof chkObj.requires !== "object" || chkObj.requires === null) return false;
        const requires = chkObj.requires;
        if (typeof requires.varName !== "string") return false;
        if (!Array.isArray(requires.values) || requires.values.some((value)=>typeof value !== "string")) return false;
    }
    return true;
};

});


parcelRegister("7tt1L", function(module, exports) {

var $gDZYu = parcelRequire("gDZYu");

var $bZwuB = parcelRequire("bZwuB");

var $2FBRb = parcelRequire("2FBRb");

var $hXGCZ = parcelRequire("hXGCZ");

var $jBtmk = parcelRequire("jBtmk");

var $gfHMt = parcelRequire("gfHMt");
const $673d7b39cd1ed216$export$174325b5313169ff = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.figureType !== "string") return false;
    if (typeof chkObj.legendType !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    if (!Array.isArray(chkObj.figureTypeProperties)) return false;
    if (chkObj.figureTypeProperties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    if (!Array.isArray(chkObj.axes)) return false;
    if (chkObj.axes.some((axis)=>!(0, $gDZYu.isFigureAxisDataDto)(axis))) return false;
    if (!Array.isArray(chkObj.dataGroups)) return false;
    if (chkObj.dataGroups.some((group)=>!(0, $bZwuB.isFigureGroupDataDto)(group))) return false;
    if (!Array.isArray(chkObj.legend)) return false;
    if (chkObj.legend.some((item)=>!(0, $2FBRb.isFigureLegendDataDto)(item))) return false;
    if (!Array.isArray(chkObj.referenceLines)) return false;
    if (chkObj.referenceLines.some((item)=>!(0, $hXGCZ.isFigureReferenceLineDataDto)(item))) return false;
    if (!Array.isArray(chkObj.regressionLines)) return false;
    if (chkObj.regressionLines.some((line)=>!(0, $jBtmk.isFigureRegressionLineDataDto)(line))) return false;
    return true;
};

});
parcelRegister("bZwuB", function(module, exports) {

$parcel$export(module.exports, "isFigureGroupDataDto", function () { return $855aab5d481fec30$export$c908729a68fb157e; });

var $gfHMt = parcelRequire("gfHMt");
const $855aab5d481fec30$export$c908729a68fb157e = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.dataGroupName !== "string") return false;
    if (typeof chkObj.dataGroupLabel !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    return true;
};

});

parcelRegister("2FBRb", function(module, exports) {

$parcel$export(module.exports, "isFigureLegendDataDto", function () { return $47d8e1c1ffd5cab0$export$c1b4fefa80f8f98d; });

var $gfHMt = parcelRequire("gfHMt");
const $47d8e1c1ffd5cab0$export$c1b4fefa80f8f98d = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.legendLabel !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    return true;
};

});

parcelRegister("hXGCZ", function(module, exports) {

$parcel$export(module.exports, "isFigureReferenceLineDataDto", function () { return $c3f71d5d65549b65$export$8771148fb5a37a45; });

var $gfHMt = parcelRequire("gfHMt");
const $c3f71d5d65549b65$export$8771148fb5a37a45 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    return true;
};

});

parcelRegister("jBtmk", function(module, exports) {

$parcel$export(module.exports, "isFigureRegressionLineDataDto", function () { return $4268134087c0576d$export$e2bf1a36c884a0f; });

var $gfHMt = parcelRequire("gfHMt");
const $4268134087c0576d$export$e2bf1a36c884a0f = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.lineType !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $gfHMt.isFigureVarDataDto)(property))) return false;
    return true;
};

});


parcelRegister("iCwy0", function(module, exports) {

$parcel$export(module.exports, "isFigureLegendSettingsDto", function () { return $73ade1cda12fa1f6$export$a92d26051cc06363; });

var $g9Z7k = parcelRequire("g9Z7k");
const $73ade1cda12fa1f6$export$a92d26051cc06363 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.legendType !== "string") return false;
    if (!Array.isArray(chkObj.parameters)) return false;
    if (chkObj.parameters.some((parameter)=>!(0, $g9Z7k.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});

parcelRegister("s85Yh", function(module, exports) {

var $g9Z7k = parcelRequire("g9Z7k");
const $283983c61989cd3d$export$c1bd2fdbab4b5aaf = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (chkObj.parameters !== undefined && !Array.isArray(chkObj.parameters)) return false;
    if (Array.isArray(chkObj.parameters) && chkObj.parameters.some((parameter)=>!(0, $g9Z7k.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});

parcelRegister("4hqPB", function(module, exports) {

$parcel$export(module.exports, "isFigureRegressionLineSettingsDto", function () { return $7bbdfe29ca53d56d$export$16033d1ff371ffed; });

var $g9Z7k = parcelRequire("g9Z7k");
const $7bbdfe29ca53d56d$export$16033d1ff371ffed = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.lineType !== "string") return false;
    if (!Array.isArray(chkObj.parameters)) return false;
    if (chkObj.parameters.some((parameter)=>!(0, $g9Z7k.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});

parcelRegister("aSzWy", function(module, exports) {

$parcel$export(module.exports, "isFigureSettingsDto", function () { return $8e01919c0c1351a8$export$30699a739844a206; });

var $defL5 = parcelRequire("defL5");

var $iCwy0 = parcelRequire("iCwy0");

var $4hqPB = parcelRequire("4hqPB");

var $ddWKn = parcelRequire("ddWKn");

var $g9Z7k = parcelRequire("g9Z7k");
const $8e01919c0c1351a8$export$30699a739844a206 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (!Array.isArray(chkObj.figureTypeSettings)) return false;
    if (chkObj.figureTypeSettings.some((option)=>!(0, $ddWKn.isFigureTypeSettingsDto)(option))) return false;
    if (!Array.isArray(chkObj.figureProperties)) return false;
    if (chkObj.figureProperties.some((setting)=>!(0, $g9Z7k.isFigureVarSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureAxisSettings)) return false;
    if (chkObj.figureAxisSettings.some((setting)=>!(0, $defL5.isFigureAxisSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureLegendSettings)) return false;
    if (chkObj.figureLegendSettings.some((setting)=>!(0, $iCwy0.isFigureLegendSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureRegressionLineSettings)) return false;
    if (chkObj.figureRegressionLineSettings.some((setting)=>!(0, $4hqPB.isFigureRegressionLineSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureReferenceLinesSettings)) return false;
    if (chkObj.figureReferenceLinesSettings.some((setting)=>!(0, $g9Z7k.isFigureVarSettingsDto)(setting))) return false;
    return true;
};

});
parcelRegister("ddWKn", function(module, exports) {

$parcel$export(module.exports, "isFigureTypeSettingsDto", function () { return $d7acf75c4b849acb$export$9cddc0daa427d07c; });

var $g9Z7k = parcelRequire("g9Z7k");
const $d7acf75c4b849acb$export$9cddc0daa427d07c = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.value !== "string") return false;
    if (typeof chkObj.label !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $g9Z7k.isFigureVarSettingsDto)(property))) return false;
    if (!Array.isArray(chkObj.dataRowVars)) return false;
    if (chkObj.dataRowVars.some((property)=>!(0, $g9Z7k.isFigureVarSettingsDto)(property))) return false;
    if (!Array.isArray(chkObj.requiredAxis)) return false;
    if (chkObj.requiredAxis.some((name)=>typeof name !== "string")) return false;
    if (chkObj.allowedRegressionTypes !== undefined && (!Array.isArray(chkObj.allowedRegressionTypes) || chkObj.allowedRegressionTypes.some((type)=>typeof type !== "string"))) return false;
    if (chkObj.defaultNumberOfSeries !== undefined && (!Number.isFinite(chkObj.defaultNumberOfSeries) || !Number.isInteger(chkObj.defaultNumberOfSeries) || chkObj.defaultNumberOfSeries < 0)) return false;
    if (chkObj.defaultSeries !== undefined && !Array.isArray(chkObj.defaultSeries)) return false;
    if (chkObj.isLegendVisible !== undefined && typeof chkObj.isLegendVisible !== "boolean") return false;
    return true;
};

});


parcelRegister("70Y7p", function(module, exports) {
/**
 * Describes a data-row variable option for a selectable figure type.
 */ 
});




parcelRegister("uiwZA", function(module, exports) {

$parcel$export(module.exports, "RemoveFigureItemButton", function () { return $3792d01cec299ee1$export$1a767f0a5c160b74; });

var $bbzbN = parcelRequire("bbzbN");

var $jVHe9 = parcelRequire("jVHe9");

var $iSZ2J = parcelRequire("iSZ2J");

var $5U7KB = parcelRequire("5U7KB");
const $3792d01cec299ee1$export$1a767f0a5c160b74 = ({ dataPath: dataPath, id: id, siblingCount: siblingCount })=>{
    const { dispatch: dispatch } = (0, $iSZ2J.useBeFigure)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jVHe9.default), {
        id: `remove-${id}`,
        className: "text-danger ms-2",
        role: "button",
        "aria-label": "Remove item",
        onClick: ()=>{
            dispatch({
                operation: (0, $5U7KB.REMOVE_FIGURE_ITEM),
                dataPath: dataPath,
                newLength: siblingCount - 1
            });
        }
    });
};
$3792d01cec299ee1$export$1a767f0a5c160b74.displayName = "RemoveFigureItemButton";

});





parcelRegister("i9zLN", function(module, exports) {
$parcel$export(module.exports, "preProcessFigureInput", function () { return (parcelRequire("Hzrzh")).preProcessFigureInput; });
parcelRequire("hT5M5");
parcelRequire("Hzrzh");

});
parcelRegister("hT5M5", function(module, exports) {
const $f83e43498c8fbb18$export$2749cd6bc8a1a83a = (obj)=>Object.entries(obj).map(([varName, value])=>({
            varName: varName,
            value: String(value)
        }));

});

parcelRegister("Hzrzh", function(module, exports) {

$parcel$export(module.exports, "preProcessFigureInput", function () { return $89989b7804d5c7ea$export$73d7fc73149626a8; });

var $8xZZY = parcelRequire("8xZZY");
const $89989b7804d5c7ea$export$73d7fc73149626a8 = (figureSettings, figureInput)=>{
    const preProcessedFigureInput = {
        ...figureInput ?? {}
    };
    // Throw if there are no figure type settings
    if (figureSettings.figureTypeSettings.length === 0) throw new Error("preProcessFigureInput: No figure type settings available in figureSettings");
    // Check id exists, if not create one
    if (!preProcessedFigureInput.id) preProcessedFigureInput.id = crypto.randomUUID();
    // Check figureType exists in settings or take the first
    let figureTypeSetting = figureSettings.figureTypeSettings.find((ft)=>ft.value === preProcessedFigureInput.figureType);
    if (!figureTypeSetting) {
        console.warn(`preProcessFigureInput: figureType "${preProcessedFigureInput.figureType}" not found in figureSettings`);
        figureTypeSetting = figureSettings.figureTypeSettings[0];
        preProcessedFigureInput.figureType = figureTypeSetting.value;
    }
    // Check legendType exists in settings or take the first
    let legendSetting = figureSettings.figureLegendSettings.find((ls)=>ls.legendType === preProcessedFigureInput.legendType);
    if (!legendSetting) {
        console.warn(`preProcessFigureInput: legend type "${preProcessedFigureInput.legendType}" not found in figureSettings`);
        legendSetting = figureSettings.figureLegendSettings[0];
        preProcessedFigureInput.legendType = legendSetting.legendType;
    }
    // Check all required lists exist, if not create empty
    if (!preProcessedFigureInput.properties) preProcessedFigureInput.properties = [];
    if (!preProcessedFigureInput.figureTypeProperties) preProcessedFigureInput.figureTypeProperties = [];
    if (!preProcessedFigureInput.axes) preProcessedFigureInput.axes = [];
    if (!preProcessedFigureInput.dataGroups) preProcessedFigureInput.dataGroups = [];
    if (!preProcessedFigureInput.legend) preProcessedFigureInput.legend = [];
    if (!preProcessedFigureInput.referenceLines) preProcessedFigureInput.referenceLines = [];
    if (!preProcessedFigureInput.regressionLines) preProcessedFigureInput.regressionLines = [];
    const processedFigureInput = preProcessedFigureInput;
    // Check all required figure settings exist
    processedFigureInput.properties = (0, $8xZZY.fillPropertiesArray)(figureSettings.figureProperties, processedFigureInput.properties);
    processedFigureInput.figureTypeProperties = (0, $8xZZY.fillPropertiesArray)(figureTypeSetting.properties, processedFigureInput.figureTypeProperties);
    // Ensure there is exactly one legend entry and that it has all required properties
    if (processedFigureInput.legend.length > 1) {
        console.warn(`preProcessFigureInput: More than one legend entry found, only the first will be used. Found ${processedFigureInput.legend.length} entries.`);
        processedFigureInput.legend = [
            processedFigureInput.legend[0]
        ];
    }
    // Ensure legend array has at least one entry
    if (processedFigureInput.legend.length === 0) processedFigureInput.legend.push({
        id: crypto.randomUUID(),
        legendLabel: legendSetting.legendType,
        properties: []
    });
    processedFigureInput.legend[0].properties = (0, $8xZZY.fillPropertiesArray)(legendSetting.parameters, processedFigureInput.legend[0].properties);
    // Check all required axes exist and have required fields
    const requiredAxes = figureTypeSetting.requiredAxis;
    requiredAxes.forEach((axisType)=>{
        const axisSetting = figureSettings.figureAxisSettings.find((ats)=>ats.axisType === axisType);
        if (!axisSetting) throw new Error(`preProcessFigureInput: required axis "${axisType}" not found in figureSettings`);
        let axis = processedFigureInput.axes.find((a)=>a.axisType === axisType);
        if (!axis) {
            axis = {
                id: crypto.randomUUID(),
                axisType: axisType,
                properties: (0, $8xZZY.fillPropertiesArray)(axisSetting.parameters)
            };
            processedFigureInput.axes.push(axis);
        } else axis.properties = (0, $8xZZY.fillPropertiesArray)(axisSetting.parameters, axis.properties);
    });
    // Check all required properites for dataGroups
    if (processedFigureInput.dataGroups.length > 0) processedFigureInput.dataGroups = processedFigureInput.dataGroups.map((dg)=>({
            ...dg,
            properties: (0, $8xZZY.fillPropertiesArray)(figureTypeSetting.dataRowVars, dg.properties)
        }));
    // Add default number of dataGroups if none exist
    if (processedFigureInput.dataGroups.length === 0) {
        const numberOfSeries = figureTypeSetting.defaultNumberOfSeries ?? 1;
        for(let i = 0; i < numberOfSeries; i++){
            const thisDefaultSeries = figureTypeSetting.defaultSeries?.[Math.floor(i % (figureTypeSetting.defaultSeries?.length ?? 1))];
            const newDataGroup = {
                id: crypto.randomUUID(),
                dataGroupName: `${thisDefaultSeries?.dataGroupName ?? "DataGroup_"}${i + 1}`,
                dataGroupLabel: `${thisDefaultSeries?.dataGroupLabel ?? "Data Group"} ${i + 1}`,
                properties: (0, $8xZZY.fillPropertiesArray)(figureTypeSetting.dataRowVars, thisDefaultSeries?.properties)
            };
            processedFigureInput.dataGroups.push(newDataGroup);
        }
    }
    // Check all required properites for regressionLines
    processedFigureInput.regressionLines = processedFigureInput.regressionLines.map((rl)=>{
        const rlSettings = figureSettings.figureRegressionLineSettings.find((rls)=>rls.lineType === rl.lineType);
        if (!rlSettings) throw new Error(`preProcessFigureInput: regression line type "${rl.lineType}" not found in figureSettings`);
        return {
            ...rl,
            properties: (0, $8xZZY.fillPropertiesArray)(rlSettings.parameters, rl.properties)
        };
    });
    return processedFigureInput;
};

});



parcelRegister("aNOKz", function(module, exports) {
$parcel$export(module.exports, "AsupInternalTable", function () { return (parcelRequire("c3Q0Y")).AsupInternalTable; });
$parcel$export(module.exports, "AitTablePosition", function () { return (parcelRequire("feHBz")).AitTablePosition; });
$parcel$export(module.exports, "isAitRowGroupData", function () { return (parcelRequire("04Jlz")).isAitRowGroupData; });
$parcel$export(module.exports, "isGridItemTrafficLight", function () { return (parcelRequire("2xRzL")).isGridItemTrafficLight; });
$parcel$export(module.exports, "newCell", function () { return (parcelRequire("iIj1X")).newCell; });
$parcel$export(module.exports, "newHeaderCell", function () { return (parcelRequire("iIj1X")).newHeaderCell; });
$parcel$export(module.exports, "newHeaderRow", function () { return (parcelRequire("3LImB")).newHeaderRow; });
$parcel$export(module.exports, "newRow", function () { return (parcelRequire("3LImB")).newRow; });
$parcel$export(module.exports, "newRowGroup", function () { return (parcelRequire("5mofv")).newRowGroup; });
parcelRequire("6r6BK");
parcelRequire("5LsQw");
parcelRequire("tzgiU");
parcelRequire("hFMjS");
parcelRequire("3s4yO");
parcelRequire("1qN19");
parcelRequire("dNXfz");
parcelRequire("c51fb");
parcelRequire("9WSJ8");
parcelRequire("fQdeH");
parcelRequire("a9tvf");
parcelRequire("asuxf");
parcelRequire("3dl7l");
parcelRequire("95odm");
parcelRequire("6Ks5m");
parcelRequire("8gmiT");
parcelRequire("3ZsBw");
parcelRequire("llmyo");
parcelRequire("kbkyI");
parcelRequire("34Mfo");
parcelRequire("fBigz");
parcelRequire("5Kh11");
parcelRequire("hcezh");
parcelRequire("bx6jT");
parcelRequire("6DbFS");
parcelRequire("l2vMU");
parcelRequire("bilUw");
parcelRequire("kzPKK");
parcelRequire("brOC3");
parcelRequire("7QFkw");
parcelRequire("33DLH");
parcelRequire("5f5pt");
parcelRequire("lH8yx");
parcelRequire("h5qDy");
parcelRequire("hOlvX");
parcelRequire("jq6k8");
parcelRequire("gW6K8");
parcelRequire("qLJkH");
parcelRequire("afZri");
parcelRequire("guNKk");
parcelRequire("9u87i");
parcelRequire("6u5Us");
parcelRequire("j2lyp");
parcelRequire("c3Q0Y");
parcelRequire("f63Eo");
parcelRequire("88YCB");

});
parcelRegister("6r6BK", function(module, exports) {

$parcel$export(module.exports, "AitAddColumnButton", function () { return $aed51f0f3d570e06$export$49075aa79614575a; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $5m3yv = parcelRequire("5m3yv");

var $88YCB = parcelRequire("88YCB");

var $feHBz = parcelRequire("feHBz");
const $aed51f0f3d570e06$export$49075aa79614575a = ({ originalColumnIndex: originalColumnIndex })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const currentCols = (0, $7fPBF.useMemo)(()=>state?.originalTableData.bodyData[0].rows[0].cells.length ?? 0, [
        state
    ]);
    const menuItems = (0, $7fPBF.useMemo)(()=>{
        const ret = state ? [
            {
                label: "Add column",
                action: ()=>dispatch({
                        operation: (0, $feHBz.ADD_COLUMN),
                        columnIndex: originalColumnIndex,
                        newColumnLength: currentCols + 1
                    })
            }
        ] : [];
        if (state && originalColumnIndex >= 0) ret.push({
            label: "Duplicate previous column",
            action: ()=>dispatch({
                    operation: (0, $feHBz.DUPLICATE_COLUMN),
                    columnIndex: originalColumnIndex,
                    newColumnLength: currentCols + 1
                })
        });
        return ret;
    }, [
        currentCols,
        dispatch,
        originalColumnIndex,
        state
    ]);
    return !state ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${state.id}-addcol-${originalColumnIndex}`,
        tipText: "Add column",
        "aria-label": "Add column",
        iconName: "aioxPlus",
        menuItems: menuItems,
        style: {
            position: "absolute",
            top: "0",
            right: "-2px"
        }
    });
};
$aed51f0f3d570e06$export$49075aa79614575a.displayName = "AitAddColumnButton";

});

parcelRegister("5LsQw", function(module, exports) {

$parcel$export(module.exports, "AitAddRowButton", function () { return $c0f0b1fa86e37a1a$export$ef15b734f74df3b1; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $5m3yv = parcelRequire("5m3yv");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $c0f0b1fa86e37a1a$export$ef15b734f74df3b1 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const thisRowGroup = state && (location.position === (0, $feHBz.AitTablePosition).bodyRowGroup || location.position === (0, $feHBz.AitTablePosition).bodyRow) ? state.originalTableData.bodyData.find((rg)=>rg.aitid === location.rowGroupId) : state && state.originalTableData.headerData ? state.originalTableData.headerData : null;
    const newLength = thisRowGroup ? thisRowGroup.rows.length + 1 : 0;
    const menuItems = (0, $7fPBF.useMemo)(()=>{
        const ret = [
            {
                label: "Add row",
                action: ()=>{
                    dispatch({
                        operation: (0, $feHBz.ADD_ROW),
                        location: location,
                        newLength: newLength
                    });
                }
            }
        ];
        if (location.position === (0, $feHBz.AitTablePosition).headerRow || location.position === (0, $feHBz.AitTablePosition).bodyRow) ret.push({
            label: "Duplicate row",
            action: ()=>dispatch({
                    operation: (0, $feHBz.DUPLICATE_ROW),
                    location: location,
                    newLength: newLength
                })
        });
        return ret;
    }, [
        dispatch,
        location,
        newLength
    ]);
    return !state || !state.editable || "isRepeat" in location && location.isRepeat ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${id}-add-row`,
        tipText: "Add row",
        iconName: "aioxPlus",
        menuItems: menuItems
    });
};
$c0f0b1fa86e37a1a$export$ef15b734f74df3b1.displayName = "AitAddRowButton";

});
parcelRegister("gqx25", function(module, exports) {

$parcel$export(module.exports, "getBaseId", function () { return $d2dd57efcedc0ca1$export$fcd700871ba79533; });

var $feHBz = parcelRequire("feHBz");
const $d2dd57efcedc0ca1$export$fcd700871ba79533 = (location, stateId)=>{
    let id = stateId ?? "table";
    // Table level
    if (location.position === (0, $feHBz.AitTablePosition).table) return id;
    // Column level
    if (location.position === (0, $feHBz.AitTablePosition).column) {
        id += `~column~${location.columnId}`;
        return id;
    }
    // Row group level
    id += `~${location.tableSection}`;
    if (location.position === (0, $feHBz.AitTablePosition).header || location.position === (0, $feHBz.AitTablePosition).body) return id;
    // Specific row group
    id += `~rowGroup~${location.rowGroupId}`;
    if (location.position === (0, $feHBz.AitTablePosition).bodyRowGroup) return id;
    // Row level
    id += `~row~${location.rowId}`;
    if (location.position === (0, $feHBz.AitTablePosition).headerRow || location.position === (0, $feHBz.AitTablePosition).bodyRow) return id;
    // Cell level
    id += `~cell~${location.cellId}`;
    /* istanbul ignore else */ if (location.position === (0, $feHBz.AitTablePosition).headerCell || location.position === (0, $feHBz.AitTablePosition).bodyCell) return id;
};

});


parcelRegister("tzgiU", function(module, exports) {

$parcel$export(module.exports, "AitAddRowGroupButton", function () { return $dc73b660269a4f71$export$cd69d962c0fcfa7f; });

var $bbzbN = parcelRequire("bbzbN");

var $5m3yv = parcelRequire("5m3yv");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $dc73b660269a4f71$export$cd69d962c0fcfa7f = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const currentRowGroupNumber = state?.originalTableData.bodyData.length ?? 0;
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const groupTemplateNames = (Array.isArray(state?.groupTemplates) ? state.groupTemplates.filter((g)=>(g.name ?? "").trim() !== "") : []).map((g)=>g.name).sort((a, b)=>a.localeCompare(b));
    return !thisRowGroup || !state?.editable ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${id}-add-rowgroup`,
        tipText: "Add row group",
        iconName: "aioxPlus",
        menuItems: [
            {
                label: "Add row group",
                action: ()=>dispatch({
                        operation: (0, $feHBz.ADD_ROW_GROUP),
                        location: location,
                        newLength: currentRowGroupNumber + 1
                    })
            },
            {
                label: "Duplicate row group",
                action: ()=>dispatch({
                        operation: (0, $feHBz.DUPLICATE_ROW_GROUP),
                        location: location,
                        newLength: currentRowGroupNumber + 1
                    })
            },
            {
                label: "Add row group from template",
                group: groupTemplateNames.map((templateName)=>({
                        label: templateName,
                        action: ()=>dispatch({
                                operation: (0, $feHBz.ADD_ROW_GROUP),
                                location: location,
                                templateName: templateName,
                                newLength: currentRowGroupNumber + 1
                            })
                    }))
            }
        ]
    });
};
$dc73b660269a4f71$export$cd69d962c0fcfa7f.displayName = "AitAddRowGroupButton";

});
parcelRegister("5mBpH", function(module, exports) {

$parcel$export(module.exports, "trGetPositionFromLocation", function () { return $b842b482b2445c2c$export$f7884aed6c5ea447; });

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");
function $b842b482b2445c2c$export$f7884aed6c5ea447(state, location, processed = false) {
    /* Check state */ if (!state) return {
        data: undefined,
        tableLevel: undefined
    };
    const tableData = processed ? state.processedTableData : state.originalTableData;
    /* Table level */ if (!location || location.position === (0, $feHBz.AitTablePosition).table) return {
        tableLevel: (0, $feHBz.AitTablePosition).table,
        data: tableData
    };
    else if (location.position === (0, $feHBz.AitTablePosition).column) {
        /* Column level - find the column information for this column */ const columnInfo = tableData?.columnInformation.find((ci)=>ci.columnId === location.columnId);
        if (columnInfo) return {
            tableLevel: (0, $feHBz.AitTablePosition).column,
            data: columnInfo
        };
        else return {
            data: undefined,
            tableLevel: undefined
        };
    } else if (location.tableSection === (0, $feHBz.AitRowType).header && tableData?.headerData) {
        /* Header data */ if (location.position === (0, $feHBz.AitTablePosition).headerCell) return {
            tableLevel: location.position,
            data: (0, $fCWrt.trGetCellFromLocation)(tableData, location)
        };
        else if (location.position === (0, $feHBz.AitTablePosition).headerRow) return {
            tableLevel: location.position,
            data: tableData.headerData.rows[location.row].aitid === location.rowId ? tableData.headerData.rows[location.row] : undefined
        };
        else return {
            tableLevel: location.position,
            data: tableData?.headerData
        };
    } else if (location.tableSection === (0, $feHBz.AitRowType).body && tableData?.bodyData) {
        /* Body data */ /* istanbul ignore else */ if (location.position === (0, $feHBz.AitTablePosition).bodyCell) return {
            tableLevel: location.position,
            data: (0, $fCWrt.trGetCellFromLocation)(tableData, location)
        };
        else if (location.position === (0, $feHBz.AitTablePosition).bodyRow) return {
            tableLevel: location.position,
            data: tableData.bodyData[location.rowGroup].rows[location.row].aitid === location.rowId ? tableData.bodyData[location.rowGroup].rows[location.row] : undefined
        };
        else if (location.position === (0, $feHBz.AitTablePosition).bodyRowGroup) return {
            tableLevel: location.position,
            data: tableData.bodyData[location.rowGroup]
        };
        else if (location.position === (0, $feHBz.AitTablePosition).body) return {
            tableLevel: location.position,
            data: tableData.bodyData
        };
    }
    return {
        data: undefined,
        tableLevel: undefined
    };
}

});


parcelRegister("hFMjS", function(module, exports) {

$parcel$export(module.exports, "AitBlankRow", function () { return $1a1f974facd16555$export$4d92939def9257e4; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $88YCB = parcelRequire("88YCB");
const $1a1f974facd16555$export$4d92939def9257e4 = ({ id: id, border: border })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const processedTableData = state?.processedTableData;
    const columnRepeats = processedTableData?.columnRepeats;
    const cis = columnRepeats ? Array.from(Array(columnRepeats.length).keys()) : undefined;
    return !cis ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {}),
            cis.map((ci)=>/*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                    className: border ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitBorderCell : (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitSpaceCell
                }, ci)),
            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {})
        ]
    });
};
$1a1f974facd16555$export$4d92939def9257e4.displayName = "AitBlankRow";

});

parcelRegister("3s4yO", function(module, exports) {

$parcel$export(module.exports, "AitBorderRow", function () { return $975c79a4f6f330bc$export$6f67978067436e20; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $6r6BK = parcelRequire("6r6BK");

var $hFMjS = parcelRequire("hFMjS");

var $6Ks5m = parcelRequire("6Ks5m");

var $j2lyp = parcelRequire("j2lyp");

var $88YCB = parcelRequire("88YCB");
const $975c79a4f6f330bc$export$6f67978067436e20 = (props)=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const topRow = state?.processedTableData?.headerData && state.processedTableData.headerData.rows.length > 0 ? state.processedTableData.headerData.rows[0].cells : state?.processedTableData?.bodyData && state.processedTableData.bodyData.length > 0 ? state.processedTableData.bodyData[0].rows[0].cells : [];
    const originalTopRow = state?.originalTableData.headerData && state.originalTableData.headerData.rows.length > 0 ? state.originalTableData.headerData.rows[0].cells : state?.originalTableData.bodyData && state.originalTableData.bodyData.length > 0 ? state.originalTableData.bodyData[0].rows[0].cells : [];
    const cis = topRow.map((c)=>({
            aitid: c.aitid,
            originalIx: originalTopRow.findIndex((o)=>c.aitid === o.aitid),
            columnId: c.columnId
        }));
    return !state || !state.processedTableData?.columnRepeats ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            props.topBorder && /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                id: `${props.id}`,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
                        children: state.editable && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: (0, $cqVqv.classMerge)([
                                (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder,
                                (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitColumnButtons
                            ]),
                            style: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6r6BK.AitAddColumnButton), {
                                originalColumnIndex: -1
                            })
                        })
                    }),
                    cis.map((c, ci)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $j2lyp.AitTopBorderCell), {
                            cellid: c.aitid,
                            columnIndex: ci,
                            originalColumnIndex: c.originalIx,
                            columnId: c.columnId
                        }, ci)),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
                        style: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6Ks5m.AitColumnTrafficLight), {
                            cellid: "final"
                        })
                    })
                ]
            }),
            props.spaceBefore && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hFMjS.AitBlankRow), {
                id: `${props.id}-spacebeforerow`
            }),
            !props.noBorder && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hFMjS.AitBlankRow), {
                id: `${props.id}-borderrow`,
                border: true
            }),
            props.spaceAfter && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hFMjS.AitBlankRow), {
                id: `${props.id}-spaceafterrow`
            })
        ]
    });
};
$975c79a4f6f330bc$export$6f67978067436e20.displayName = "AitBorderRow";

});
parcelRegister("6Ks5m", function(module, exports) {

$parcel$export(module.exports, "AitColumnTrafficLight", function () { return $cb3e19a779f8ebe7$export$4b8588d67f997cd2; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $8vQMY = parcelRequire("8vQMY");

var $88YCB = parcelRequire("88YCB");
const $cb3e19a779f8ebe7$export$4b8588d67f997cd2 = ({ cellid: cellid })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    // Find all columns matching this cellid
    const matchingColumns = state?.processedTableData?.changedColumns?.filter((dc)=>dc.idAfterTrafficLightIsShown === cellid || dc.idAfterTrafficLightIsShown === "" && cellid === "final") ?? [];
    const tlValues = matchingColumns.length === 0 ? [
        "BlankNotEvaluated"
    ] : matchingColumns.map((col)=>col.coreTrafficLight);
    const thisTrafficLight = !state?.noTrafficLights && tlValues.some((v)=>v !== "BlankNotEvaluated" && v !== "none") ? new (0, $8vQMY.MosaicTrafficLightClass)(tlValues, "-16px", "-8px").element : null;
    return !thisTrafficLight ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).absoluteLeft0,
        children: thisTrafficLight
    });
};
$cb3e19a779f8ebe7$export$4b8588d67f997cd2.displayName = "AitColumnTrafficLight";

});

parcelRegister("j2lyp", function(module, exports) {

$parcel$export(module.exports, "AitTopBorderCell", function () { return $e24d3bc32687f0ed$export$d3c63ae19ffd01aa; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $6r6BK = parcelRequire("6r6BK");

var $3dl7l = parcelRequire("3dl7l");

var $6Ks5m = parcelRequire("6Ks5m");

var $hcezh = parcelRequire("hcezh");

var $88YCB = parcelRequire("88YCB");
const $e24d3bc32687f0ed$export$d3c63ae19ffd01aa = ({ columnIndex: columnIndex, originalColumnIndex: originalColumnIndex, cellid: cellid, columnId: columnId })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const tableData = state?.processedTableData;
    const isColumnRepeat = tableData && tableData.columnRepeats && tableData.columnRepeats.length > columnIndex && tableData.columnRepeats[columnIndex].colRepeat !== undefined && (tableData.columnRepeats[columnIndex].isRepeat || tableData.columnRepeats[columnIndex].colRepeat?.match(/^[[\]0,]+$/) === null) ? true : false;
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 0;
    const maxColumnIndex = (tableData?.bodyData[0].rows[0].cells.length ?? 0) - 1;
    return !tableData ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
        style: {
            position: "relative"
        },
        children: isColumnRepeat || originalColumnIndex === -1 ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6Ks5m.AitColumnTrafficLight), {
                    cellid: cellid
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3dl7l.AitColumnAnnotationButton), {
                    originalColumnIndex: originalColumnIndex,
                    columnId: columnId
                }),
                state?.editable && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: (0, $cqVqv.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder,
                        (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitColumnButtons
                    ]),
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        width: "100%"
                    },
                    children: [
                        !(rowHeaderColumns === 1 && columnIndex === 0) && !(columnIndex === rowHeaderColumns && columnIndex === maxColumnIndex) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hcezh.AitRemoveColumnButton), {
                            originalColumnIndex: originalColumnIndex
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6r6BK.AitAddColumnButton), {
                            originalColumnIndex: originalColumnIndex
                        })
                    ]
                })
            ]
        })
    }, columnIndex);
};
$e24d3bc32687f0ed$export$d3c63ae19ffd01aa.displayName = "AitTopBorderCell";

});
parcelRegister("3dl7l", function(module, exports) {

$parcel$export(module.exports, "AitColumnAnnotationButton", function () { return $c362821365e8930b$export$d7b7b867019d7ed7; });

var $bbzbN = parcelRequire("bbzbN");

var $2ocuT = parcelRequire("2ocuT");

var $88YCB = parcelRequire("88YCB");

var $feHBz = parcelRequire("feHBz");
const $c362821365e8930b$export$d7b7b867019d7ed7 = ({ originalColumnIndex: originalColumnIndex, columnId: columnId })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    if (!state || originalColumnIndex < 0 || !columnId) return null;
    // Get the annotation from the columnInformation list using columnId
    const columnAnnotation = state.originalTableData.columnInformation.find((ci)=>ci.columnId === columnId)?.annotation;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ocuT.AnnotationButton), {
        buttonId: `column-${columnId}-annotation`,
        annotationType: "Column",
        annotationLocation: {
            position: (0, $feHBz.AitTablePosition).column,
            originalColumn: originalColumnIndex,
            columnId: columnId
        },
        existingAnnotation: columnAnnotation,
        hidden: state.tlfViewMode.value !== "ANNOTATIONS",
        showPreview: false
    });
};
$c362821365e8930b$export$d7b7b867019d7ed7.displayName = "AitColumnAnnotationButton";

});
parcelRegister("2ocuT", function(module, exports) {

$parcel$export(module.exports, "AnnotationButton", function () { return $1bcb5752cef8612f$export$6716fe781c56d87e; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $cqVqv = parcelRequire("cqVqv");

var $giacK = parcelRequire("giacK");
parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $7fPBF = parcelRequire("7fPBF");

var $cvdxK = parcelRequire("cvdxK");
var $6dv4K = parcelRequire("6dv4K");

var $6ls2G = parcelRequire("6ls2G");

var $aKDek = parcelRequire("aKDek");
const $1bcb5752cef8612f$export$6716fe781c56d87e = ({ existingAnnotation: existingAnnotation, annotationType: annotationType, annotationLocation: annotationLocation, buttonId: buttonId, hidden: hidden = false, showPreview: showPreview = false, repositionKey: repositionKey })=>{
    const ref = (0, $7fPBF.useRef)(null);
    const [showAnnotationModal, setShowAnnotationModal] = (0, $7fPBF.useState)(false);
    const annotationActionText = !existingAnnotation ? `Add ${annotationType} annotation` : `Edit ${annotationType} annotation`;
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const canEdit = !tlfContext.tlfData || !tlfContext.readOnly;
    // Determine bubble position based on annotation type
    const bubblePosition = annotationType === "Column" ? "top" : annotationType === "Row" ? "right" : "left";
    return hidden ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                id: buttonId,
                type: "button",
                title: annotationActionText,
                "aria-label": annotationActionText,
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).annotationBtn,
                    !existingAnnotation ? (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).empty : undefined
                ]),
                onClick: ()=>setShowAnnotationModal(true),
                style: {
                    position: "relative"
                },
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).glyph,
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).icon,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).letter,
                                    children: "A"
                                }),
                                canEdit && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).hoverIcon,
                                    children: !existingAnnotation ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
                                        size: 12
                                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cvdxK.default), {
                                        size: 12
                                    })
                                })
                            ]
                        })
                    }),
                    showPreview && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aKDek.AnnotationPreviewBubble), {
                        annotation: existingAnnotation,
                        position: bubblePosition,
                        target: ref,
                        repositionKey: repositionKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $giacK.AnnotationContextWindow), {
                isOpen: showAnnotationModal,
                onClose: ()=>setShowAnnotationModal(false),
                annotationLocation: annotationLocation,
                annotationType: annotationType,
                contextAnnotation: existingAnnotation,
                disabled: !canEdit
            })
        ]
    });
};
$1bcb5752cef8612f$export$6716fe781c56d87e.displayName = "AnnotationButton";

});
parcelRegister("giacK", function(module, exports) {

$parcel$export(module.exports, "AnnotationContextWindow", function () { return $2cc388aca6574c56$export$382cf34d7a242f86; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $gBRiD = parcelRequire("gBRiD");

var $dDC3L = parcelRequire("dDC3L");

var $lNt9u = parcelRequire("lNt9u");

var $7fPBF = parcelRequire("7fPBF");

var $etWjK = parcelRequire("etWjK");
var $8d4Ob = parcelRequire("8d4Ob");

var $ifbDg = parcelRequire("ifbDg");

var $8rXpb = parcelRequire("8rXpb");

var $24HWe = parcelRequire("24HWe");

var $c1NeV = parcelRequire("c1NeV");

var $9vpQh = parcelRequire("9vpQh");

var $gPXbA = parcelRequire("gPXbA");

var $iNYVQ = parcelRequire("iNYVQ");

var $kWPAB = parcelRequire("kWPAB");

var $6oeuS = parcelRequire("6oeuS");

var $f05qt = parcelRequire("f05qt");
const $2cc388aca6574c56$export$382cf34d7a242f86 = ({ isOpen: isOpen, onClose: onClose, annotationType: annotationType, annotationLocation: annotationLocation, contextAnnotation: contextAnnotation, disabled: disabled = false })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const [isPending, startTransition] = (0, $7fPBF.useTransition)();
    const clinicalLibrary = hierarchyContext?.hierarchy && !hierarchyContext?.isClinicalLibraryLoading ? (0, $gBRiD.getClinicalDataWithInheritance)(hierarchyContext.parentTemplates.clinicalDatasets, hierarchyContext.parentTemplates.clinicalCodeLists, hierarchyContext.parentTemplates.clinicalValueLists, hierarchyContext.parentTemplates.clinicalComments, hierarchyContext.parentTemplates.clinicalMethods, hierarchyContext.parentTemplates.clinicalWhereClauses, hierarchyContext.hierarchy.clinicalLibrary) : undefined;
    const { formState: formState, updateFormField: updateFormField, resetForm: resetForm, restoreInitial: restoreInitial, isFormValid: isFormValid, canAddNewClause: canAddNewClause, canRemoveClause: canRemoveClause, initialAnnotation: initialAnnotation, buildFinalAnnotation: buildFinalAnnotation, isUnchanged: isUnchanged, setDatasetAndVariable: setDatasetAndVariable, currentClauseIndex: currentClauseIndex, goToPreviousClause: goToPreviousClause, goToNextClause: goToNextClause, addNewWhereClause: addNewWhereClause, removeCurrentClause: removeCurrentClause, codeLists: codeLists, comparatorTypes: comparatorTypes, previewText: previewText, totalClauseCount: totalClauseCount } = (0, $f05qt.useAnnotationContextWindow)({
        annotationLocation: annotationLocation,
        annotationType: annotationType,
        clinicalLibrary: clinicalLibrary,
        initialAnnotation: contextAnnotation
    });
    const datasets = clinicalLibrary?.clinicalDatasets ?? [];
    const isClinicalLibraryAvailable = clinicalLibrary && clinicalLibrary.clinicalDatasets && clinicalLibrary.clinicalDatasets.length > 0;
    /**
   * Handler for primary variable selection in "dataset.variable" format.
   * Parses the format and updates both dataset and variable fields atomically.
   *
   * @param value - Selected value in "dataset.variable" format
   */ const handlePrimaryVariableChange = (value)=>{
        const parts = value.split(".");
        /* istanbul ignore else -- ControlTypeAhead only calls setValue with values from availableList, which are always in "dataset.variable" format */ if (parts.length === 2) {
            const [datasetName, variableName] = parts;
            setDatasetAndVariable(datasetName, variableName);
        }
    };
    /**
   * Get current primary variable value in "dataset.variable" format
   */ const primaryVariableValue = formState.selectedDataset && formState.selectedVariable ? `${formState.selectedDataset}.${formState.selectedVariable.name}` : "";
    /**
   * Handler for companion variables changes
   *
   * @param state - State object containing companion variables array
   * @param state.companionVariables - Array of companion variables with their types and values
   */ const handleCompanionsChange = (state)=>{
        updateFormField("companionVariables", state.companionVariables);
    };
    const contextDisplayText = (0, $gPXbA.getContextDisplayText)(annotationLocation);
    /**
   * Cancel handler for the annotation modal.
   * Restores initial annotation if editing, otherwise resets form to defaults.
   */ const handleCancel = ()=>{
        if (initialAnnotation) restoreInitial();
        else resetForm();
        onClose();
    };
    /**
   * Save handler for the annotation modal.
   * Builds the final annotation and dispatches updates to the TLF context.
   * Uses startTransition to show a loader on the save button during the operation.
   */ const handleSave = ()=>{
        startTransition(()=>{
            const finalAnnotation = buildFinalAnnotation();
            // Handle table body annotations
            /* istanbul ignore else */ if (tlfContext && annotationLocation && (0, $lNt9u.isTlfItemReadDto)(tlfContext.tlfData)) {
                const body = tlfContext.tlfData.body;
                const updatedTableData = (0, $6oeuS.updateTableDataWithAnnotations)(body, annotationLocation, finalAnnotation);
                tlfContext.dispatch({
                    operation: (0, $dDC3L.UPDATE_TLF),
                    calledFrom: "AnnotationContextWindow: TableBody",
                    tlfData: {
                        body: updatedTableData
                    }
                });
            } else if (tlfContext && annotationType === "PageBy" && (0, $lNt9u.isTlfItemReadDto)(tlfContext.tlfData) && (0, $lNt9u.isEditorPageBy)(tlfContext.tlfData.pageBy)) tlfContext.dispatch({
                operation: (0, $dDC3L.UPDATE_TLF),
                calledFrom: "AnnotationContextWindow: PageBy",
                tlfData: {
                    pageBy: {
                        content: tlfContext.tlfData.pageBy.content,
                        annotation: finalAnnotation
                    }
                }
            });
            // Reset form if this was a new annotation (not editing existing)
            /* istanbul ignore else */ if (!initialAnnotation) resetForm();
            onClose();
        });
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextWindow), {
        id: `annotation-modal-${annotationType}${contextDisplayText}`,
        title: `Select ${annotationType} annotation ${contextDisplayText}`,
        visible: isOpen,
        onClose: handleCancel,
        style: {
            width: "600px",
            minHeight: "500px",
            maxHeight: "80vh",
            maxWidth: "90vw"
        },
        children: hierarchyContext && hierarchyContext.isClinicalLibraryLoading ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $etWjK.default), {
            variant: "info",
            children: "Loading clinical library data. This may take a few seconds..."
        }) : !isClinicalLibraryAvailable ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $etWjK.default), {
            variant: "warning",
            children: "No clinical library data is available. Clinical libraries must be loaded at the hierarchy level to use annotations."
        }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default), {
            style: {
                padding: "16px",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8rXpb.AnnotationNavigationHeader), {
                    currentClauseIndex: currentClauseIndex,
                    totalClauseCount: totalClauseCount,
                    canRemoveClause: canRemoveClause,
                    canAddNewClause: canAddNewClause,
                    disabled: disabled,
                    onPrevious: goToPreviousClause,
                    onNext: goToNextClause,
                    onRemove: removeCurrentClause,
                    onAdd: addNewWhereClause
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iNYVQ.PrimaryVariableSelector), {
                    datasets: datasets,
                    selectedValue: primaryVariableValue,
                    onChange: handlePrimaryVariableChange,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9vpQh.CompanionVariableControl), {
                    datasets: datasets,
                    primaryDataset: formState.selectedDataset,
                    companionVariables: formState.companionVariables,
                    onChange: handleCompanionsChange,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kWPAB.TerminologySelector), {
                    formState: formState,
                    codeLists: codeLists,
                    comparatorTypes: comparatorTypes,
                    updateFormField: updateFormField,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {
                    className: "my-3"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c1NeV.AnnotationPreview), {
                            previewText: previewText
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $24HWe.AnnotationNotesField), {
                            value: formState.additionalNotes ?? // istanbul ignore next
                            "",
                            onChange: (value)=>updateFormField("additionalNotes", value),
                            disabled: disabled
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ifbDg.AnnotationActionButtons), {
                    isUnchanged: isUnchanged,
                    isFormValid: isFormValid,
                    isClinicalLibraryAvailable: isClinicalLibraryAvailable,
                    disabled: disabled,
                    onReset: restoreInitial,
                    onCancel: handleCancel,
                    onSave: handleSave,
                    isPending: isPending
                })
            ]
        })
    });
};
$2cc388aca6574c56$export$382cf34d7a242f86.displayName = "AnnotationContextWindow";

});
parcelRegister("hWsmt", function(module, exports) {

$parcel$export(module.exports, "unifiedInitialState", function () { return $f94a58dc43ca74e3$export$f989076045d6f27b; });
$parcel$export(module.exports, "AppSettingsContext", function () { return $f94a58dc43ca74e3$export$759b9d795f2426a4; });
$parcel$export(module.exports, "useAppSettings", function () { return $f94a58dc43ca74e3$export$f77a225b49e0e356; });
$parcel$export(module.exports, "useHierarchyContext", function () { return $f94a58dc43ca74e3$export$b04f4289a6970a95; });
$parcel$export(module.exports, "useTocContext", function () { return $f94a58dc43ca74e3$export$4605dc24e6d468d4; });
$parcel$export(module.exports, "useTlfContext", function () { return (parcelRequire("cgEO2")).useTlfContext; });

var $7Wd8C = parcelRequire("7Wd8C");

var $7fPBF = parcelRequire("7fPBF");

var $5RbkJ = parcelRequire("5RbkJ");

var $ksBxS = parcelRequire("ksBxS");

var $bQJeo = parcelRequire("bQJeo");

var $1FMNJ = parcelRequire("1FMNJ");

var $cgEO2 = parcelRequire("cgEO2");
const $f94a58dc43ca74e3$export$f989076045d6f27b = {
    ...(0, $5RbkJ.defaultSettings),
    hierarchyState: (0, $ksBxS.hierarchyInitialState),
    tocState: (0, $1FMNJ.tocInitialState),
    tlfState: (0, $bQJeo.tlfInitialState)
};
const $f94a58dc43ca74e3$export$759b9d795f2426a4 = (0, $7fPBF.createContext)({
    state: $f94a58dc43ca74e3$export$f989076045d6f27b,
    dispatch: // istanbul ignore next
    ()=>{}
});
const $f94a58dc43ca74e3$export$f77a225b49e0e356 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $7fPBF.useContext)($f94a58dc43ca74e3$export$759b9d795f2426a4);
    return {
        ...state,
        dispatch: dispatch
    };
};
const $f94a58dc43ca74e3$export$b04f4289a6970a95 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $7fPBF.useContext)($f94a58dc43ca74e3$export$759b9d795f2426a4);
    if (state.hierarchyState === (0, $ksBxS.hierarchyInitialState)) return null;
    const hierarchyState = state.hierarchyState;
    const title = hierarchyState.hierarchy ? `${hierarchyState.hierarchy.name}` : `Loading hierarchy... ${hierarchyState.id}`;
    return {
        ...hierarchyState,
        dispatch: dispatch,
        title: title
    };
};
const $f94a58dc43ca74e3$export$4605dc24e6d468d4 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $7fPBF.useContext)($f94a58dc43ca74e3$export$759b9d795f2426a4);
    return {
        state: {
            ...state.tocState,
            readOnly: state.hierarchyState.hierarchy?.isBackupVersion || !state.hierarchyState.accessRights.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy)
        },
        dispatch: dispatch,
        tocRequest: state.tocState.tocRequestStatus
    };
};

});
parcelRegister("5RbkJ", function(module, exports) {

$parcel$export(module.exports, "defaultSettings", function () { return $787fa832c2a00218$export$62680b65e63e14ec; });

var $7Wd8C = parcelRequire("7Wd8C");

var $60Lfh = parcelRequire("60Lfh");
const $787fa832c2a00218$var$defaultDownloadOptions = [
    {
        label: "Standard notes",
        selected: true,
        propertiesKey: "Notes"
    },
    {
        label: "Programmer notes",
        selected: true,
        propertiesKey: "ProgrammerNotes"
    },
    {
        label: "SAP reference",
        selected: true,
        propertiesKey: "SapReference"
    },
    {
        label: "Program name",
        selected: true,
        propertiesKey: "ProgramName"
    },
    {
        label: "Output name",
        selected: true,
        propertiesKey: "OutputName"
    }
];
const $787fa832c2a00218$export$775d9407c4c2c2da = [
    {
        key: "domainList",
        value: "",
        type: "string",
        label: "Available domains",
        /**
     * Validate the `domainList` value using a comparator object.
     *
     * @param _ - Unused first parameter kept for signature compatibility.
     * @param c - Comparator object containing the value to validate.
     * @returns A promise resolving to the validation result object.
     */ validCondition: async (_, c)=>({
                success: true,
                data: {
                    valid: c.value.match(/^[A-Z,]+$/) !== null,
                    validationText: c.value.match(/^[A-Z,]+$/) === null ? "Domains must be uppercase and separated by commas" : ""
                }
            })
    }
];
const $787fa832c2a00218$var$TAProps = [
    (0, $60Lfh.createHierarchyTagProperty)((0, $7Wd8C.eHierarchyLevel).TA)
];
const $787fa832c2a00218$var$ProjectProps = [
    (0, $60Lfh.createHierarchyTagProperty)((0, $7Wd8C.eHierarchyLevel).Project, "D")
];
const $787fa832c2a00218$export$4b7587805fb94eb6 = [
    (0, $60Lfh.createHierarchyTagProperty)((0, $7Wd8C.eHierarchyLevel).Study),
    {
        key: "description",
        value: "",
        type: "textarea",
        label: "Description"
    },
    {
        key: "phase",
        value: "",
        type: "string",
        label: "Phase"
    },
    {
        key: "status",
        value: "Not started",
        type: "select",
        label: "Status",
        allowedValues: [
            "Not started",
            "In progress",
            "Completed"
        ]
    },
    {
        key: "studyStandardsDate",
        value: new Date(Date()).toISOString().slice(0, 11) + "00:00:00.000Z",
        type: "datetime-local",
        label: "Standards date",
        futureBad: true,
        blankBad: true,
        permissionRequired: [
            (0, $7Wd8C.eApplicationPermission).AllowStudyStandardDateEdit
        ]
    }
];
const $787fa832c2a00218$var$ReportProps = [
    {
        key: "description",
        value: "",
        type: "textarea",
        label: "Description"
    },
    {
        key: "reportType",
        value: "",
        type: "string",
        label: "Report type"
    }
];
const $787fa832c2a00218$export$62680b65e63e14ec = {
    appSettingsLoaded: true,
    applicationPermissions: [],
    backEndUrl: "http://localhost:5218/",
    backEndVersion: "0.0.0",
    colWidthMod: 4.4,
    crystalUrl: "https://localhost:5000/",
    defaultColumnWidth: 30,
    defaultDownloadOptions: $787fa832c2a00218$var$defaultDownloadOptions,
    defaultLevelProperties: {
        Corporate: $787fa832c2a00218$export$775d9407c4c2c2da,
        TA: $787fa832c2a00218$var$TAProps,
        Project: $787fa832c2a00218$var$ProjectProps,
        Study: $787fa832c2a00218$export$4b7587805fb94eb6,
        Report: $787fa832c2a00218$var$ReportProps
    },
    defaultTableStyle: {
        fontFamily: "Courier New",
        fontSize: "9pt",
        fontWeight: 500
    },
    displayName: "DEFAULT NoAuth",
    domain: "astrazeneca.net",
    figureSettings: {
        figureTypeSettings: [],
        figureProperties: [],
        figureAxisSettings: [],
        figureLegendSettings: [],
        figureRegressionLineSettings: [],
        figureReferenceLinesSettings: []
    },
    helpLinks: [],
    isAdmin: false,
    maintenanceMessage: "",
    maintenanceMode: false,
    prid: "no-prid",
    styles: [],
    annotationComparatorTypes: [],
    userId: 0
};

});
parcelRegister("60Lfh", function(module, exports) {

$parcel$export(module.exports, "createHierarchyTagProperty", function () { return $7f1207ab6b4d70a4$export$79c7e0752e2e9ff2; });

var $a45co = parcelRequire("a45co");

var $fGy1K = parcelRequire("fGy1K");
const $7f1207ab6b4d70a4$export$79c7e0752e2e9ff2 = (level, value = "")=>{
    const tagInfo = (0, $a45co.getHierarchyTagInfo)(level);
    return {
        key: tagInfo.key,
        value: value,
        type: "hierarchyTag",
        label: tagInfo.label,
        mandatory: true,
        validCondition: (0, $fGy1K.checkTag)(level, tagInfo.description, tagInfo.validationText)
    };
};

});
parcelRegister("a45co", function(module, exports) {

$parcel$export(module.exports, "getHierarchyTagInfo", function () { return $6310be1a03928aa7$export$1f43db1b1dc198e9; });

var $7Wd8C = parcelRequire("7Wd8C");
const $6310be1a03928aa7$export$1f43db1b1dc198e9 = (level)=>{
    switch(level){
        case (0, $7Wd8C.eHierarchyLevel).Corporate:
            return {
                label: "Corporate tag",
                description: "corporate tag",
                key: "hierarchyTag",
                validationText: ""
            };
        case (0, $7Wd8C.eHierarchyLevel).TA:
            return {
                label: "TA prefix",
                description: "TA prefix",
                key: "taPrefix",
                validationText: "Prefix must be 2 or 3 upper case characters"
            };
        case (0, $7Wd8C.eHierarchyLevel).Project:
            return {
                label: "Project code",
                description: "project code",
                key: "projectCode",
                validationText: "Project code must begin with D followed by 3 digits"
            };
        case (0, $7Wd8C.eHierarchyLevel).Study:
            return {
                label: "D number",
                description: "D number",
                key: "dNumber",
                validationText: "Field should be D followed by 10 characters"
            };
        case (0, $7Wd8C.eHierarchyLevel).Report:
            return {
                label: "Report tag",
                description: "report tag",
                key: "hierarchyTag",
                validationText: ""
            };
        default:
            return {
                label: "Hierarchy tag",
                description: "hierarchy tag",
                key: "hierarchyTag",
                validationText: ""
            };
    }
};

});

parcelRegister("fGy1K", function(module, exports) {

$parcel$export(module.exports, "checkTag", function () { return $42cdf78918e4dfc4$export$36711d2e9c2363c8; });

var $7Wd8C = parcelRequire("7Wd8C");
/**
 * Regex patterns for validating hierarchy tags at each level, matching the backend validation rules:
 * - TA: exactly 2 or 3 uppercase letters
 * - Project: D followed by 3 digits, then optional letters, digits, spaces, underscores, or hyphens
 * - Study: D followed by 3 digits, 2 uppercase alphanumeric characters, then exactly 5 digits
 */ const $42cdf78918e4dfc4$var$tagPatterns = {
    [(0, $7Wd8C.eHierarchyLevel).TA]: /^[A-Z]{2,3}$/,
    [(0, $7Wd8C.eHierarchyLevel).Project]: /^D\d{3}[A-Za-z0-9 _-]*$/,
    [(0, $7Wd8C.eHierarchyLevel).Study]: /^D[0-9]{3}[A-Z0-9]{2}[0-9]{5}$/
};
const $42cdf78918e4dfc4$export$36711d2e9c2363c8 = (level, tagDesc, helpText)=>async (_backEndUrl, target, _controller)=>{
        // Short-circuit if the value hasn't changed
        if (target.options?.previousValue === target.value) return {
            success: true,
            data: {
                valid: true,
                validationText: ""
            }
        };
        // Return help text for empty values
        if (target.value === "") return {
            success: true,
            data: {
                valid: false,
                validationText: helpText
            }
        };
        // Format validation using level-specific regex pattern
        const pattern = $42cdf78918e4dfc4$var$tagPatterns[level];
        if (pattern && !pattern.test(target.value)) return {
            success: true,
            data: {
                valid: false,
                validationText: helpText
            }
        };
        // Uniqueness check using sibling tag list from context
        if (target.options?.existingValues?.includes(target.value)) return {
            success: true,
            data: {
                valid: false,
                validationText: `This ${tagDesc} is already in use`
            }
        };
        return {
            success: true,
            data: {
                valid: true,
                validationText: ""
            }
        };
    };

});



parcelRegister("ksBxS", function(module, exports) {

$parcel$export(module.exports, "hierarchyInitialState", function () { return $3a127386abe8f448$export$3c7483feed2a7f6b; });
const $3a127386abe8f448$export$3c7483feed2a7f6b = {
    id: "",
    accessRights: [],
    changed: false,
    hierarchyNodes: [],
    parentTemplates: {
        clinicalDatasets: [],
        clinicalCodeLists: [],
        clinicalValueLists: [],
        clinicalComments: [],
        clinicalMethods: [],
        clinicalWhereClauses: [],
        domainReplacements: [],
        lists: [],
        rowGroups: [],
        singles: [],
        analysisSets: [],
        analysisMethods: [],
        dataSubsets: [],
        groupingFactors: []
    },
    prefix: "",
    commentPanelStatus: {
        highlightCommentId: "",
        activeRelatedTo: "",
        showComments: false,
        commentFilter: "all"
    },
    doGetAccessRights: false,
    doSave: false,
    doTocSave: false,
    hierarchy: null,
    isClinicalLibraryLoading: false,
    isSubscribed: false,
    saveBlockers: {
        singles: new Set(),
        domainReplacements: new Set(),
        hierarchyName: undefined
    },
    saveRequestStatus: {
        requesting: false,
        error: false
    },
    saveTocRequestStatus: {
        requesting: false,
        error: false
    },
    savedHierarchy: null,
    tlfItemIndex: null,
    isNameChanged: false
};

});

parcelRegister("bQJeo", function(module, exports) {

$parcel$export(module.exports, "tlfInitialState", function () { return $92fedab55f9b9192$export$1787cd27aeb7cc5e; });

var $gMkmM = parcelRequire("gMkmM");

var $7Wd8C = parcelRequire("7Wd8C");
const $92fedab55f9b9192$export$1787cd27aeb7cc5e = {
    applyDelayedHierarchyUpdatesTrigger: 0,
    changed: false,
    commentPanelStatus: {
        highlightCommentId: "",
        activeRelatedTo: "",
        showComments: false,
        commentFilter: "all"
    },
    delayedHierarchyUpdates: false,
    discardDelayedHierarchyUpdatesTrigger: 0,
    editorBlocksSearchPanelStatus: {
        showSearchPanel: false,
        searchText: "",
        blocksToSearch: Object.values((0, $7Wd8C.SearchableEditorBlocks))
    },
    forcePushToParent: false,
    isSubscribed: false,
    ixSaveVersion: -1,
    isTlfNew: false,
    ixTlfDataVersion: -1,
    readOnly: false,
    receivedMessages: [],
    requestStatus: {
        requesting: false,
        error: false
    },
    showModalWindow: "",
    showTrafficLights: true,
    tlfData: null,
    tlfDataVersions: [],
    tlfViewMode: (0, $gMkmM.TLF_VIEW_MODES)[0]
};

});

parcelRegister("1FMNJ", function(module, exports) {

$parcel$export(module.exports, "tocInitialState", function () { return $c6f60c4632fe669c$export$b43c86e3b65fe4b6; });

var $7Wd8C = parcelRequire("7Wd8C");
const $c6f60c4632fe669c$export$b43c86e3b65fe4b6 = {
    blocked: false,
    changed: false,
    hierarchyId: "",
    readOnly: true,
    receivedMessages: [],
    removedItems: [],
    saving: false,
    saveError: false,
    searchText: "",
    sendUpdate: false,
    showTypes: Object.values((0, $7Wd8C.eTlfItemType)),
    showTiFo: (0, $7Wd8C.eShowTiFo).ToC,
    tocItems: [],
    commentsFilter: "all",
    lastMinorVersionSavedAt: null,
    lastMajorVersionSavedAt: 0,
    tocRequestStatus: {
        requesting: false,
        error: false
    },
    showSaveAlert: false,
    tocIdFromMessage: undefined,
    showNeedRefresh: false
};

});

parcelRegister("cgEO2", function(module, exports) {

$parcel$export(module.exports, "useTlfContext", function () { return $affe9cbc9745cbf8$export$e82c27c02bea6148; });

var $hGHEx = parcelRequire("hGHEx");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $4PTZu = parcelRequire("4PTZu");

var $6E9u3 = parcelRequire("6E9u3");

var $7Wd8C = parcelRequire("7Wd8C");

var $lNt9u = parcelRequire("lNt9u");

var $khRaj = parcelRequire("khRaj");

var $jDoW3 = parcelRequire("jDoW3");

var $1Kj4K = parcelRequire("1Kj4K");

var $3cBoK = parcelRequire("3cBoK");

var $7fPBF = parcelRequire("7fPBF");

var $6hWPd = parcelRequire("6hWPd");

var $hWsmt = parcelRequire("hWsmt");

var $gD2t9 = parcelRequire("gD2t9");

var $9Jgpw = parcelRequire("9Jgpw");

var $7KklJ = parcelRequire("7KklJ");

var $dDC3L = parcelRequire("dDC3L");
const $affe9cbc9745cbf8$export$e82c27c02bea6148 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $7fPBF.useContext)((0, $hWsmt.AppSettingsContext));
    const signalR = (0, $7fPBF.useContext)((0, $gD2t9.SignalRContext));
    const { navigateAfterSave: navigateAfterSave } = (0, $4PTZu.useUnsavedChanges)("tlf-context");
    const hierarchyState = state.hierarchyState;
    const { state: tocState } = (0, $hWsmt.useTocContext)();
    const tlfState = state.tlfState;
    const setRequestStatus = (0, $7fPBF.useCallback)((status)=>dispatch({
            operation: (0, $dDC3L.SET_TLF_REQUEST_STATUS),
            requestStatus: status,
            calledFrom: "useTlfContext:SetSaveRequestStatus"
        }), [
        dispatch
    ]);
    const sendSignalRPatch = (0, $7fPBF.useCallback)(async (newTlfData)=>{
        // istanbul ignore next
        if (!tlfState.tlfData || signalR?.connection?.state !== (0, $hGHEx.HubConnectionState).Connected) return;
        // Save and patch responses invoke this callback only while a TLF item is loaded.
        const signalRGroup = `tlf${tlfState.tlfData.id}`;
        // The callback is only used for connected SignalR updates.
        /* istanbul ignore else */ const lastSave = tlfState.tlfDataVersions[tlfState.ixSaveVersion];
        if (lastSave) {
            const allowedKeys = Object.keys(lastSave).filter((key)=>![
                    "saved",
                    "changed",
                    "inError",
                    "history"
                ].includes(key));
            const signalRUpdate = {
                updatedItemId: lastSave.id,
                patch: (0, $6hWPd.createPatch)(Object.fromEntries(allowedKeys.map((key)=>[
                        key,
                        lastSave[key]
                    ])), Object.fromEntries(allowedKeys.map((key)=>[
                        key,
                        newTlfData[key]
                    ])))
            };
            const sentMessage = await signalR.sendTlfUpdateToGroup(signalRUpdate, signalRGroup);
            const receivedMessageAction = {
                operation: (0, $dDC3L.ADD_RECEIVED_MESSAGE),
                calledFrom: "useTlfContext:SendSignalRPatch",
                receivedMessage: sentMessage
            };
            dispatch(receivedMessageAction);
        }
    }, [
        dispatch,
        signalR,
        tlfState.ixSaveVersion,
        tlfState.tlfData,
        tlfState.tlfDataVersions
    ]);
    const saveTlf = (0, $7fPBF.useCallback)(async (azsolId, version, domain, primaryHierarchyId, additionalInformation, copiedFromHierarchyLevel, tocNumber, sapReference)=>{
        // Save commands are issued only from a loaded TLF route with a hierarchy context.
        /* istanbul ignore else */ if (hierarchyState.hierarchy && tlfState.tlfData && (0, $lNt9u.isTlfItemReadDto)(tlfState.tlfData)) {
            const currentTlfData = tlfState.tlfData;
            const response = await (0, $30Ra3.loadWrapper)((0, $1Kj4K.saveTlfItem), {
                tlfItem: {
                    ...currentTlfData,
                    tocNumber: tocNumber ?? currentTlfData.tocNumber,
                    sapReference: sapReference ?? currentTlfData.sapReference
                },
                newDetails: azsolId && version !== undefined && additionalInformation !== undefined && primaryHierarchyId ? {
                    azsolId: azsolId,
                    version: version,
                    domain: domain ?? "",
                    additionalInformation: additionalInformation,
                    primaryHierarchyId: primaryHierarchyId
                } : undefined,
                copiedFromHierarchyLevel: copiedFromHierarchyLevel
            }, tlfState.requestStatus, setRequestStatus, state.backEndUrl);
            if (response?.success) {
                if (response.data.type === (0, $7Wd8C.eTlfItemType).arsTable) (0, $khRaj.hydrateArsTableBody)(hierarchyState.hierarchyNodes, response.data);
                const newTlfItemIndex = (0, $3cBoK.toIndexDto)(response.data);
                const newTlfIndex = [
                    ...(hierarchyState.tlfItemIndex ?? []).filter((item)=>!(item.azsolId === response.data.azsolId && item.version === response.data.version)),
                    newTlfItemIndex
                ].sort((first, second)=>first.azsolId.localeCompare(second.azsolId));
                dispatch({
                    operation: (0, $9Jgpw.UPDATE_TLF_ITEM_INDEX),
                    tlfItemIndex: newTlfIndex
                });
                if (hierarchyState.changed) dispatch({
                    operation: (0, $9Jgpw.SAVE_HIERARCHY),
                    noRedirect: true
                });
                const newTocItem = {
                    ...response.data,
                    changed: false,
                    inError: false,
                    changedTitles: response.data.changedTitles ?? []
                };
                const newTocItems = [
                    ...tocState.tocItems.filter((item)=>!(item.id === newTocItem.id)),
                    newTocItem
                ];
                dispatch({
                    operation: (0, $6E9u3.REFRESH),
                    hierarchyId: hierarchyState.hierarchy.id,
                    items: newTocItems
                });
                dispatch({
                    operation: (0, $dDC3L.UPDATE_TLF),
                    tlfData: response.data,
                    newSavePoint: true,
                    calledFrom: "useTlfContext:SaveResponse"
                });
                await sendSignalRPatch(response.data);
                const targetHierarchy = hierarchyState.hierarchyNodes.find((item)=>item.id === response.data.primaryHierarchyId);
                // The route loader supplies the target hierarchy for a successful save.
                const newUrl = targetHierarchy ? (0, $7KklJ.getTlfUrl)(targetHierarchy, response.data) : `/TlfDesigner/${response.data.azsolId}/${response.data.version}`;
                // Save navigation is only needed when the saved route differs from the current route.
                /* istanbul ignore else */ if (newUrl !== window.location.pathname) navigateAfterSave(newUrl);
            }
        }
    }, [
        dispatch,
        hierarchyState.changed,
        hierarchyState.hierarchy,
        hierarchyState.hierarchyNodes,
        hierarchyState.tlfItemIndex,
        navigateAfterSave,
        sendSignalRPatch,
        setRequestStatus,
        state.backEndUrl,
        tlfState.requestStatus,
        tlfState.tlfData,
        tocState.tocItems
    ]);
    const patchTlf = (0, $7fPBF.useCallback)(async (id, azsolId, key, newValue)=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $jDoW3.patchTlfItem), {
            id: id,
            azsolId: azsolId,
            key: key,
            newValue: newValue
        }, tlfState.requestStatus, setRequestStatus, state.backEndUrl);
        // The API wrapper reports successful responses for the current TLF item.
        /* istanbul ignore else */ if (response?.success) {
            // Update TLF item
            // Successful patches are returned for the loaded TLF item.
            /* istanbul ignore else */ if (tlfState.tlfData && response.data.id === tlfState.tlfData.id) dispatch({
                operation: (0, $dDC3L.UPDATE_TLF),
                calledFrom: "useTlfContext:PatchResponse",
                tlfData: response.data,
                newSavePoint: true
            });
            // Update tocContext
            // TODO: Should be updated by UPDATE_TLF
            dispatch({
                operation: (0, $6E9u3.UPDATE_ENTRY),
                update: response.data
            });
            await sendSignalRPatch(response.data);
        }
    }, [
        dispatch,
        sendSignalRPatch,
        setRequestStatus,
        state.backEndUrl,
        tlfState.requestStatus,
        tlfState.tlfData
    ]);
    const readOnly = tlfState.readOnly || hierarchyState.hierarchy?.isBackupVersion === true || !hierarchyState.accessRights.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy) || tlfState.tlfData !== null && ![
        (0, $7Wd8C.eReleaseStatus).Draft,
        (0, $7Wd8C.eReleaseStatus).ReleasePending
    ].includes(tlfState.tlfData.releaseStatus);
    return {
        ...tlfState,
        dispatch: dispatch,
        patchTlf: patchTlf,
        readOnly: readOnly,
        saveTlf: saveTlf
    };
};
$affe9cbc9745cbf8$export$e82c27c02bea6148.displayName = "useTlfContext";

});
parcelRegister("hGHEx", function(module, exports) {

$parcel$export(module.exports, "HubConnectionState", function () { return $ce083871c7226cf7$export$b8b4168ab851a6c3; });
$parcel$export(module.exports, "HubConnection", function () { return $ce083871c7226cf7$export$e5dbe756ed73e8c8; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $1Fv48 = parcelRequire("1Fv48");

var $e70Ea = parcelRequire("e70Ea");

var $c7ba6 = parcelRequire("c7ba6");

var $2lJPz = parcelRequire("2lJPz");

var $bzYhd = parcelRequire("bzYhd");

var $2ni4V = parcelRequire("2ni4V");

var $lnViE = parcelRequire("lnViE");
const $ce083871c7226cf7$var$DEFAULT_TIMEOUT_IN_MS = 30000;
const $ce083871c7226cf7$var$DEFAULT_PING_INTERVAL_IN_MS = 15000;
const $ce083871c7226cf7$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE = 100000;
var $ce083871c7226cf7$export$b8b4168ab851a6c3;
(function(HubConnectionState) {
    /** The hub connection is disconnected. */ HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */ HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */ HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */ HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */ HubConnectionState["Reconnecting"] = "Reconnecting";
})($ce083871c7226cf7$export$b8b4168ab851a6c3 || ($ce083871c7226cf7$export$b8b4168ab851a6c3 = {}));
class $ce083871c7226cf7$export$e5dbe756ed73e8c8 {
    /** @internal */ // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    static create(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize) {
        return new $ce083871c7226cf7$export$e5dbe756ed73e8c8(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize);
    }
    constructor(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize){
        this._nextKeepAlive = 0;
        this._freezeEventListener = ()=>{
            this._logger.log((0, $2lJPz.LogLevel).Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        };
        (0, $2ni4V.Arg).isRequired(connection, "connection");
        (0, $2ni4V.Arg).isRequired(logger, "logger");
        (0, $2ni4V.Arg).isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = serverTimeoutInMilliseconds !== null && serverTimeoutInMilliseconds !== void 0 ? serverTimeoutInMilliseconds : $ce083871c7226cf7$var$DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = keepAliveIntervalInMilliseconds !== null && keepAliveIntervalInMilliseconds !== void 0 ? keepAliveIntervalInMilliseconds : $ce083871c7226cf7$var$DEFAULT_PING_INTERVAL_IN_MS;
        this._statefulReconnectBufferSize = statefulReconnectBufferSize !== null && statefulReconnectBufferSize !== void 0 ? statefulReconnectBufferSize : $ce083871c7226cf7$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE;
        this._logger = logger;
        this._protocol = protocol;
        this.connection = connection;
        this._reconnectPolicy = reconnectPolicy;
        this._handshakeProtocol = new (0, $1Fv48.HandshakeProtocol)();
        this.connection.onreceive = (data)=>this._processIncomingData(data);
        this.connection.onclose = (error)=>this._connectionClosed(error);
        this._callbacks = {};
        this._methods = {};
        this._closedCallbacks = [];
        this._reconnectingCallbacks = [];
        this._reconnectedCallbacks = [];
        this._invocationId = 0;
        this._receivedHandshakeResponse = false;
        this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnected;
        this._connectionStarted = false;
        this._cachedPingMessage = this._protocol.writeMessage({
            type: (0, $c7ba6.MessageType).Ping
        });
    }
    /** Indicates the state of the {@link HubConnection} to the server. */ get state() {
        return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */ get connectionId() {
        return this.connection ? this.connection.connectionId || null : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */ get baseUrl() {
        return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */ set baseUrl(url) {
        if (this._connectionState !== $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnected && this._connectionState !== $ce083871c7226cf7$export$b8b4168ab851a6c3.Reconnecting) throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        if (!url) throw new Error("The HubConnection url must be a valid url.");
        this.connection.baseUrl = url;
    }
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */ start() {
        this._startPromise = this._startWithStateTransitions();
        return this._startPromise;
    }
    async _startWithStateTransitions() {
        if (this._connectionState !== $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnected) return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Connecting;
        this._logger.log((0, $2lJPz.LogLevel).Debug, "Starting HubConnection.");
        try {
            await this._startInternal();
            if ((0, $2ni4V.Platform).isBrowser) // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
            window.document.addEventListener("freeze", this._freezeEventListener);
            this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected;
            this._connectionStarted = true;
            this._logger.log((0, $2lJPz.LogLevel).Debug, "HubConnection connected successfully.");
        } catch (e) {
            this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnected;
            this._logger.log((0, $2lJPz.LogLevel).Debug, `HubConnection failed to start successfully because of error '${e}'.`);
            return Promise.reject(e);
        }
    }
    async _startInternal() {
        this._stopDuringStartError = undefined;
        this._receivedHandshakeResponse = false;
        // Set up the promise before any connection is (re)started otherwise it could race with received messages
        const handshakePromise = new Promise((resolve, reject)=>{
            this._handshakeResolver = resolve;
            this._handshakeRejecter = reject;
        });
        await this.connection.start(this._protocol.transferFormat);
        try {
            let version = this._protocol.version;
            if (!this.connection.features.reconnect) // Stateful Reconnect starts with HubProtocol version 2, newer clients connecting to older servers will fail to connect due to
            // the handshake only supporting version 1, so we will try to send version 1 during the handshake to keep old servers working.
            version = 1;
            const handshakeRequest = {
                protocol: this._protocol.name,
                version: version
            };
            this._logger.log((0, $2lJPz.LogLevel).Debug, "Sending handshake request.");
            await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
            this._logger.log((0, $2lJPz.LogLevel).Information, `Using HubProtocol '${this._protocol.name}'.`);
            // defensively cleanup timeout in case we receive a message from the server before we finish start
            this._cleanupTimeout();
            this._resetTimeoutPeriod();
            this._resetKeepAliveInterval();
            await handshakePromise;
            // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
            // being rejected on close, because this continuation can run after both the handshake completed successfully
            // and the connection was closed.
            if (this._stopDuringStartError) // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
            // will cause the calling continuation to get scheduled to run later.
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw this._stopDuringStartError;
            const useStatefulReconnect = this.connection.features.reconnect || false;
            if (useStatefulReconnect) {
                this._messageBuffer = new (0, $lnViE.MessageBuffer)(this._protocol, this.connection, this._statefulReconnectBufferSize);
                this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer);
                this.connection.features.resend = ()=>{
                    if (this._messageBuffer) return this._messageBuffer._resend();
                };
            }
            if (!this.connection.features.inherentKeepAlive) await this._sendMessage(this._cachedPingMessage);
        } catch (e) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
            this._cleanupTimeout();
            this._cleanupPingTimer();
            // HttpConnection.stop() should not complete until after the onclose callback is invoked.
            // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
            await this.connection.stop(e);
            throw e;
        }
    }
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */ async stop() {
        // Capture the start promise before the connection might be restarted in an onclose callback.
        const startPromise = this._startPromise;
        this.connection.features.reconnect = false;
        this._stopPromise = this._stopInternal();
        await this._stopPromise;
        try {
            // Awaiting undefined continues immediately
            await startPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
    }
    _stopInternal(error) {
        if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnected) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Call to HubConnection.stop(${error}) ignored because it is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnecting) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        const state = this._connectionState;
        this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnecting;
        this._logger.log((0, $2lJPz.LogLevel).Debug, "Stopping HubConnection.");
        if (this._reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this._logger.log((0, $2lJPz.LogLevel).Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this._reconnectDelayHandle);
            this._reconnectDelayHandle = undefined;
            this._completeClose();
            return Promise.resolve();
        }
        if (state === $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendCloseMessage();
        this._cleanupTimeout();
        this._cleanupPingTimer();
        this._stopDuringStartError = error || new (0, $e70Ea.AbortError)("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    }
    async _sendCloseMessage() {
        try {
            await this._sendWithProtocol(this._createCloseMessage());
        } catch  {
        // Ignore, this is a best effort attempt to let the server know the client closed gracefully.
        }
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */ stream(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
        // eslint-disable-next-line prefer-const
        let promiseQueue;
        const subject = new (0, $bzYhd.Subject)();
        subject.cancelCallback = ()=>{
            const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
            delete this._callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(()=>{
                return this._sendWithProtocol(cancelInvocation);
            });
        };
        this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
            if (error) {
                subject.error(error);
                return;
            } else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === (0, $c7ba6.MessageType).Completion) {
                    if (invocationEvent.error) subject.error(new Error(invocationEvent.error));
                    else subject.complete();
                } else subject.next(invocationEvent.item);
            }
        };
        promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
            subject.error(e);
            delete this._callbacks[invocationDescriptor.invocationId];
        });
        this._launchStreams(streams, promiseQueue);
        return subject;
    }
    _sendMessage(message) {
        this._resetKeepAliveInterval();
        return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */ _sendWithProtocol(message) {
        if (this._messageBuffer) return this._messageBuffer._send(message);
        else return this._sendMessage(this._protocol.writeMessage(message));
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */ send(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
        this._launchStreams(streams, sendPromise);
        return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */ invoke(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
        const p = new Promise((resolve, reject)=>{
            // invocationId will always have a value for a non-blocking invocation
            this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
                if (error) {
                    reject(error);
                    return;
                } else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === (0, $c7ba6.MessageType).Completion) {
                        if (invocationEvent.error) reject(new Error(invocationEvent.error));
                        else resolve(invocationEvent.result);
                    } else reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
                }
            };
            const promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete this._callbacks[invocationDescriptor.invocationId];
            });
            this._launchStreams(streams, promiseQueue);
        });
        return p;
    }
    on(methodName, newMethod) {
        if (!methodName || !newMethod) return;
        methodName = methodName.toLowerCase();
        if (!this._methods[methodName]) this._methods[methodName] = [];
        // Preventing adding the same handler multiple times.
        if (this._methods[methodName].indexOf(newMethod) !== -1) return;
        this._methods[methodName].push(newMethod);
    }
    off(methodName, method) {
        if (!methodName) return;
        methodName = methodName.toLowerCase();
        const handlers = this._methods[methodName];
        if (!handlers) return;
        if (method) {
            const removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) delete this._methods[methodName];
            }
        } else delete this._methods[methodName];
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */ onclose(callback) {
        if (callback) this._closedCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */ onreconnecting(callback) {
        if (callback) this._reconnectingCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */ onreconnected(callback) {
        if (callback) this._reconnectedCallbacks.push(callback);
    }
    _processIncomingData(data) {
        this._cleanupTimeout();
        if (!this._receivedHandshakeResponse) {
            data = this._processHandshakeResponse(data);
            this._receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            const messages = this._protocol.parseMessages(data, this._logger);
            for (const message of messages){
                if (this._messageBuffer && !this._messageBuffer._shouldProcessMessage(message)) continue;
                switch(message.type){
                    case (0, $c7ba6.MessageType).Invocation:
                        this._invokeClientMethod(message).catch((e)=>{
                            this._logger.log((0, $2lJPz.LogLevel).Error, `Invoke client method threw error: ${(0, $2ni4V.getErrorString)(e)}`);
                        });
                        break;
                    case (0, $c7ba6.MessageType).StreamItem:
                    case (0, $c7ba6.MessageType).Completion:
                        {
                            const callback = this._callbacks[message.invocationId];
                            if (callback) {
                                if (message.type === (0, $c7ba6.MessageType).Completion) delete this._callbacks[message.invocationId];
                                try {
                                    callback(message);
                                } catch (e) {
                                    this._logger.log((0, $2lJPz.LogLevel).Error, `Stream callback threw error: ${(0, $2ni4V.getErrorString)(e)}`);
                                }
                            }
                            break;
                        }
                    case (0, $c7ba6.MessageType).Ping:
                        break;
                    case (0, $c7ba6.MessageType).Close:
                        {
                            this._logger.log((0, $2lJPz.LogLevel).Information, "Close message received from server.");
                            const error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                            if (message.allowReconnect === true) // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this.connection.stop(error);
                            else // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this._stopPromise = this._stopInternal(error);
                            break;
                        }
                    case (0, $c7ba6.MessageType).Ack:
                        if (this._messageBuffer) this._messageBuffer._ack(message);
                        break;
                    case (0, $c7ba6.MessageType).Sequence:
                        if (this._messageBuffer) this._messageBuffer._resetSequence(message);
                        break;
                    default:
                        this._logger.log((0, $2lJPz.LogLevel).Warning, `Invalid message type: ${message.type}.`);
                        break;
                }
            }
        }
        this._resetTimeoutPeriod();
    }
    _processHandshakeResponse(data) {
        let responseMessage;
        let remainingData;
        try {
            [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data);
        } catch (e) {
            const message = "Error parsing handshake response: " + e;
            this._logger.log((0, $2lJPz.LogLevel).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            const message = "Server returned handshake error: " + responseMessage.error;
            this._logger.log((0, $2lJPz.LogLevel).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        } else this._logger.log((0, $2lJPz.LogLevel).Debug, "Server handshake complete.");
        this._handshakeResolver();
        return remainingData;
    }
    _resetKeepAliveInterval() {
        if (this.connection.features.inherentKeepAlive) return;
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this._cleanupPingTimer();
    }
    _resetTimeoutPeriod() {
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this._timeoutHandle = setTimeout(()=>this.serverTimeout(), this.serverTimeoutInMilliseconds);
            // Immediately fire Keep-Alive ping if nextPing is overdue to avoid dependency on JS timers
            let nextPing = this._nextKeepAlive - new Date().getTime();
            if (nextPing < 0) {
                if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._trySendPingMessage();
                return;
            }
            // Set keepAlive timer if there isn't one
            if (this._pingServerHandle === undefined) {
                if (nextPing < 0) nextPing = 0;
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this._pingServerHandle = setTimeout(async ()=>{
                    if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected) await this._trySendPingMessage();
                }, nextPing);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    serverTimeout() {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
    async _invokeClientMethod(invocationMessage) {
        const methodName = invocationMessage.target.toLowerCase();
        const methods = this._methods[methodName];
        if (!methods) {
            this._logger.log((0, $2lJPz.LogLevel).Warning, `No client method with the name '${methodName}' found.`);
            // No handlers provided by client but the server is expecting a response still, so we send an error
            if (invocationMessage.invocationId) {
                this._logger.log((0, $2lJPz.LogLevel).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                await this._sendWithProtocol(this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null));
            }
            return;
        }
        // Avoid issues with handlers removing themselves thus modifying the list while iterating through it
        const methodsCopy = methods.slice();
        // Server expects a response
        const expectsResponse = invocationMessage.invocationId ? true : false;
        // We preserve the last result or exception but still call all handlers
        let res;
        let exception;
        let completionMessage;
        for (const m of methodsCopy)try {
            const prevRes = res;
            res = await m.apply(this, invocationMessage.arguments);
            if (expectsResponse && res && prevRes) {
                this._logger.log((0, $2lJPz.LogLevel).Error, `Multiple results provided for '${methodName}'. Sending error to server.`);
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `Client provided multiple results.`, null);
            }
            // Ignore exception if we got a result after, the exception will be logged
            exception = undefined;
        } catch (e) {
            exception = e;
            this._logger.log((0, $2lJPz.LogLevel).Error, `A callback for the method '${methodName}' threw error '${e}'.`);
        }
        if (completionMessage) await this._sendWithProtocol(completionMessage);
        else if (expectsResponse) {
            // If there is an exception that means either no result was given or a handler after a result threw
            if (exception) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `${exception}`, null);
            else if (res !== undefined) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, null, res);
            else {
                this._logger.log((0, $2lJPz.LogLevel).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                // Client didn't provide a result or throw from a handler, server expects a response so we send an error
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null);
            }
            await this._sendWithProtocol(completionMessage);
        } else if (res) this._logger.log((0, $2lJPz.LogLevel).Error, `Result given for '${methodName}' method but server is not expecting a result.`);
    }
    _connectionClosed(error) {
        this._logger.log((0, $2lJPz.LogLevel).Debug, `HubConnection.connectionClosed(${error}) called while in state ${this._connectionState}.`);
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this._stopDuringStartError = this._stopDuringStartError || error || new (0, $e70Ea.AbortError)("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this._handshakeResolver) this._handshakeResolver();
        this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this._cleanupTimeout();
        this._cleanupPingTimer();
        if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnecting) this._completeClose(error);
        else if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected && this._reconnectPolicy) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._reconnect(error);
        else if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected) this._completeClose(error);
    // If none of the above if conditions were true were called the HubConnection must be in either:
    // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
    // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
    //    and potentially continue the reconnect() loop.
    // 3. The Disconnected state in which case we're already done.
    }
    _completeClose(error) {
        if (this._connectionStarted) {
            this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnected;
            this._connectionStarted = false;
            if (this._messageBuffer) {
                this._messageBuffer._dispose(error !== null && error !== void 0 ? error : new Error("Connection closed."));
                this._messageBuffer = undefined;
            }
            if ((0, $2ni4V.Platform).isBrowser) window.document.removeEventListener("freeze", this._freezeEventListener);
            try {
                this._closedCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $2lJPz.LogLevel).Error, `An onclose callback called with error '${error}' threw error '${e}'.`);
            }
        }
    }
    async _reconnect(error) {
        const reconnectStartTime = Date.now();
        let previousReconnectAttempts = 0;
        let retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
        let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, 0, retryError);
        if (nextRetryDelay === null) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
            this._completeClose(error);
            return;
        }
        this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Reconnecting;
        if (error) this._logger.log((0, $2lJPz.LogLevel).Information, `Connection reconnecting because of error '${error}'.`);
        else this._logger.log((0, $2lJPz.LogLevel).Information, "Connection reconnecting.");
        if (this._reconnectingCallbacks.length !== 0) {
            try {
                this._reconnectingCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $2lJPz.LogLevel).Error, `An onreconnecting callback called with error '${error}' threw error '${e}'.`);
            }
            // Exit early if an onreconnecting callback called connection.stop().
            if (this._connectionState !== $ce083871c7226cf7$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $2lJPz.LogLevel).Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                return;
            }
        }
        while(nextRetryDelay !== null){
            this._logger.log((0, $2lJPz.LogLevel).Information, `Reconnect attempt number ${previousReconnectAttempts + 1} will start in ${nextRetryDelay} ms.`);
            await new Promise((resolve)=>{
                this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
            });
            this._reconnectDelayHandle = undefined;
            if (this._connectionState !== $ce083871c7226cf7$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $2lJPz.LogLevel).Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                return;
            }
            try {
                await this._startInternal();
                this._connectionState = $ce083871c7226cf7$export$b8b4168ab851a6c3.Connected;
                this._logger.log((0, $2lJPz.LogLevel).Information, "HubConnection reconnected successfully.");
                if (this._reconnectedCallbacks.length !== 0) try {
                    this._reconnectedCallbacks.forEach((c)=>c.apply(this, [
                            this.connection.connectionId
                        ]));
                } catch (e) {
                    this._logger.log((0, $2lJPz.LogLevel).Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
                }
                return;
            } catch (e) {
                this._logger.log((0, $2lJPz.LogLevel).Information, `Reconnect attempt failed because of error '${e}'.`);
                if (this._connectionState !== $ce083871c7226cf7$export$b8b4168ab851a6c3.Reconnecting) {
                    this._logger.log((0, $2lJPz.LogLevel).Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
                    // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                    if (this._connectionState === $ce083871c7226cf7$export$b8b4168ab851a6c3.Disconnecting) this._completeClose();
                    return;
                }
                previousReconnectAttempts++;
                retryError = e instanceof Error ? e : new Error(e.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, Date.now() - reconnectStartTime, retryError);
            }
        }
        this._logger.log((0, $2lJPz.LogLevel).Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
        this._completeClose();
    }
    _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this._reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason
            });
        } catch (e) {
            this._logger.log((0, $2lJPz.LogLevel).Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
            return null;
        }
    }
    _cancelCallbacksWithError(error) {
        const callbacks = this._callbacks;
        this._callbacks = {};
        Object.keys(callbacks).forEach((key)=>{
            const callback = callbacks[key];
            try {
                callback(null, error);
            } catch (e) {
                this._logger.log((0, $2lJPz.LogLevel).Error, `Stream 'error' callback called with '${error}' threw error: ${(0, $2ni4V.getErrorString)(e)}`);
            }
        });
    }
    _cleanupPingTimer() {
        if (this._pingServerHandle) {
            clearTimeout(this._pingServerHandle);
            this._pingServerHandle = undefined;
        }
    }
    _cleanupTimeout() {
        if (this._timeoutHandle) clearTimeout(this._timeoutHandle);
    }
    _createInvocation(methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                streamIds: streamIds,
                type: (0, $c7ba6.MessageType).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                type: (0, $c7ba6.MessageType).Invocation
            };
        } else {
            const invocationId = this._invocationId;
            this._invocationId++;
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                type: (0, $c7ba6.MessageType).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                type: (0, $c7ba6.MessageType).Invocation
            };
        }
    }
    _launchStreams(streams, promiseQueue) {
        if (streams.length === 0) return;
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) promiseQueue = Promise.resolve();
        // We want to iterate over the keys, since the keys are the stream ids
        // eslint-disable-next-line guard-for-in
        for(const streamId in streams)streams[streamId].subscribe({
            complete: ()=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId)));
            },
            error: (err)=>{
                let message;
                if (err instanceof Error) message = err.message;
                else if (err && err.toString) message = err.toString();
                else message = "Unknown error";
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId, message)));
            },
            next: (item)=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createStreamItemMessage(streamId, item)));
            }
        });
    }
    _replaceStreamingParams(args) {
        const streams = [];
        const streamIds = [];
        for(let i = 0; i < args.length; i++){
            const argument = args[i];
            if (this._isObservable(argument)) {
                const streamId = this._invocationId;
                this._invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [
            streams,
            streamIds
        ];
    }
    _isObservable(arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
    _createStreamInvocation(methodName, args, streamIds) {
        const invocationId = this._invocationId;
        this._invocationId++;
        if (streamIds.length !== 0) return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            type: (0, $c7ba6.MessageType).StreamInvocation
        };
        else return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            type: (0, $c7ba6.MessageType).StreamInvocation
        };
    }
    _createCancelInvocation(id) {
        return {
            invocationId: id,
            type: (0, $c7ba6.MessageType).CancelInvocation
        };
    }
    _createStreamItemMessage(id, item) {
        return {
            invocationId: id,
            item: item,
            type: (0, $c7ba6.MessageType).StreamItem
        };
    }
    _createCompletionMessage(id, error, result) {
        if (error) return {
            error: error,
            invocationId: id,
            type: (0, $c7ba6.MessageType).Completion
        };
        return {
            invocationId: id,
            result: result,
            type: (0, $c7ba6.MessageType).Completion
        };
    }
    _createCloseMessage() {
        return {
            type: (0, $c7ba6.MessageType).Close
        };
    }
    async _trySendPingMessage() {
        try {
            await this._sendMessage(this._cachedPingMessage);
        } catch  {
            // We don't care about the error. It should be seen elsewhere in the client.
            // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
            this._cleanupPingTimer();
        }
    }
}

});
parcelRegister("1Fv48", function(module, exports) {

$parcel$export(module.exports, "HandshakeProtocol", function () { return $1371b7c9d24d606e$export$b23df48528d3f5f4; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $lYlVt = parcelRequire("lYlVt");

var $2ni4V = parcelRequire("2ni4V");
class $1371b7c9d24d606e$export$b23df48528d3f5f4 {
    // Handshake request is always JSON
    writeHandshakeRequest(handshakeRequest) {
        return (0, $lYlVt.TextMessageFormat).write(JSON.stringify(handshakeRequest));
    }
    parseHandshakeResponse(data) {
        let messageData;
        let remainingData;
        if ((0, $2ni4V.isArrayBuffer)(data)) {
            // Format is binary but still need to read JSON text from handshake response
            const binaryData = new Uint8Array(data);
            const separatorIndex = binaryData.indexOf((0, $lYlVt.TextMessageFormat).RecordSeparatorCode);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
            remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
        } else {
            const textData = data;
            const separatorIndex = textData.indexOf((0, $lYlVt.TextMessageFormat).RecordSeparator);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = textData.length > responseLength ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        const messages = (0, $lYlVt.TextMessageFormat).parse(messageData);
        const response = JSON.parse(messages[0]);
        if (response.type) throw new Error("Expected a handshake response from the server.");
        const responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [
            remainingData,
            responseMessage
        ];
    }
}

});
parcelRegister("lYlVt", function(module, exports) {

$parcel$export(module.exports, "TextMessageFormat", function () { return $fff0359777bdf8b3$export$fc2e5d47850f626b; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Not exported from index
/** @private */ class $fff0359777bdf8b3$export$fc2e5d47850f626b {
    static write(output) {
        return `${output}${$fff0359777bdf8b3$export$fc2e5d47850f626b.RecordSeparator}`;
    }
    static parse(input) {
        if (input[input.length - 1] !== $fff0359777bdf8b3$export$fc2e5d47850f626b.RecordSeparator) throw new Error("Message is incomplete.");
        const messages = input.split($fff0359777bdf8b3$export$fc2e5d47850f626b.RecordSeparator);
        messages.pop();
        return messages;
    }
}
$fff0359777bdf8b3$export$fc2e5d47850f626b.RecordSeparatorCode = 0x1e;
$fff0359777bdf8b3$export$fc2e5d47850f626b.RecordSeparator = String.fromCharCode($fff0359777bdf8b3$export$fc2e5d47850f626b.RecordSeparatorCode);

});

parcelRegister("2ni4V", function(module, exports) {

$parcel$export(module.exports, "Arg", function () { return $1babc0bcca9f1a91$export$83f0753fc4347e43; });
$parcel$export(module.exports, "Platform", function () { return $1babc0bcca9f1a91$export$2dffd0b5373a4389; });
$parcel$export(module.exports, "getDataDetail", function () { return $1babc0bcca9f1a91$export$a688b91586df8fd9; });
$parcel$export(module.exports, "isArrayBuffer", function () { return $1babc0bcca9f1a91$export$9dd3754ae86f0017; });
$parcel$export(module.exports, "sendMessage", function () { return $1babc0bcca9f1a91$export$465cb47180de50f0; });
$parcel$export(module.exports, "getUserAgentHeader", function () { return $1babc0bcca9f1a91$export$56c7340f89ca57c5; });
$parcel$export(module.exports, "createLogger", function () { return $1babc0bcca9f1a91$export$fe2e61603b61130d; });
$parcel$export(module.exports, "ConsoleLogger", function () { return $1babc0bcca9f1a91$export$ba6a9c7ac8291f7f; });
$parcel$export(module.exports, "SubjectSubscription", function () { return $1babc0bcca9f1a91$export$b7a41f2bfb5c60c3; });
$parcel$export(module.exports, "getErrorString", function () { return $1babc0bcca9f1a91$export$375b49718dbd9ced; });
$parcel$export(module.exports, "getGlobalThis", function () { return $1babc0bcca9f1a91$export$ff5f2eeb11fc7e14; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $2lJPz = parcelRequire("2lJPz");

var $6Ulgh = parcelRequire("6Ulgh");

var $fC0ZB = parcelRequire("fC0ZB");

var $4ZL0H = parcelRequire("4ZL0H");
class $1babc0bcca9f1a91$export$83f0753fc4347e43 {
    static isRequired(val, name) {
        if (val === null || val === undefined) throw new Error(`The '${name}' argument is required.`);
    }
    static isNotEmpty(val, name) {
        if (!val || val.match(/^\s*$/)) throw new Error(`The '${name}' argument should not be empty.`);
    }
    static isIn(val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) throw new Error(`Unknown ${name} value: ${val}.`);
    }
}
class $1babc0bcca9f1a91$export$2dffd0b5373a4389 {
    // react-native has a window but no document so we should check both
    static get isBrowser() {
        return !$1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "object";
    }
    // WebWorkers don't have a window object so the isBrowser check would fail
    static get isWebWorker() {
        return !$1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode && typeof self === "object" && "importScripts" in self;
    }
    // react-native has a window but no document
    static get isReactNative() {
        return !$1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "undefined";
    }
    // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
    static get isNode() {
        return false;
    }
}
function $1babc0bcca9f1a91$export$a688b91586df8fd9(data, includeContent) {
    let detail = "";
    if ($1babc0bcca9f1a91$export$9dd3754ae86f0017(data)) {
        detail = `Binary data of length ${data.byteLength}`;
        if (includeContent) detail += `. Content: '${$1babc0bcca9f1a91$export$3ddcef0d22959f49(data)}'`;
    } else if (typeof data === "string") {
        detail = `String data of length ${data.length}`;
        if (includeContent) detail += `. Content: '${data}'`;
    }
    return detail;
}
function $1babc0bcca9f1a91$export$3ddcef0d22959f49(data) {
    const view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    let str = "";
    view.forEach((num)=>{
        const pad = num < 16 ? "0" : "";
        str += `0x${pad}${num.toString(16)} `;
    });
    // Trim of trailing space.
    return str.substring(0, str.length - 1);
}
function $1babc0bcca9f1a91$export$9dd3754ae86f0017(val) {
    return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
    val.constructor && val.constructor.name === "ArrayBuffer");
}
async function $1babc0bcca9f1a91$export$465cb47180de50f0(logger, transportName, httpClient, url, content, options) {
    const headers = {};
    const [name, value] = $1babc0bcca9f1a91$export$56c7340f89ca57c5();
    headers[name] = value;
    logger.log((0, $2lJPz.LogLevel).Trace, `(${transportName} transport) sending data. ${$1babc0bcca9f1a91$export$a688b91586df8fd9(content, options.logMessageContent)}.`);
    const responseType = $1babc0bcca9f1a91$export$9dd3754ae86f0017(content) ? "arraybuffer" : "text";
    const response = await httpClient.post(url, {
        content: content,
        headers: {
            ...headers,
            ...options.headers
        },
        responseType: responseType,
        timeout: options.timeout,
        withCredentials: options.withCredentials
    });
    logger.log((0, $2lJPz.LogLevel).Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
function $1babc0bcca9f1a91$export$fe2e61603b61130d(logger) {
    if (logger === undefined) return new $1babc0bcca9f1a91$export$ba6a9c7ac8291f7f((0, $2lJPz.LogLevel).Information);
    if (logger === null) return (0, $6Ulgh.NullLogger).instance;
    if (logger.log !== undefined) return logger;
    return new $1babc0bcca9f1a91$export$ba6a9c7ac8291f7f(logger);
}
class $1babc0bcca9f1a91$export$b7a41f2bfb5c60c3 {
    constructor(subject, observer){
        this._subject = subject;
        this._observer = observer;
    }
    dispose() {
        const index = this._subject.observers.indexOf(this._observer);
        if (index > -1) this._subject.observers.splice(index, 1);
        if (this._subject.observers.length === 0 && this._subject.cancelCallback) this._subject.cancelCallback().catch((_)=>{});
    }
}
class $1babc0bcca9f1a91$export$ba6a9c7ac8291f7f {
    constructor(minimumLogLevel){
        this._minLevel = minimumLogLevel;
        this.out = console;
    }
    log(logLevel, message) {
        if (logLevel >= this._minLevel) {
            const msg = `[${new Date().toISOString()}] ${(0, $2lJPz.LogLevel)[logLevel]}: ${message}`;
            switch(logLevel){
                case (0, $2lJPz.LogLevel).Critical:
                case (0, $2lJPz.LogLevel).Error:
                    this.out.error(msg);
                    break;
                case (0, $2lJPz.LogLevel).Warning:
                    this.out.warn(msg);
                    break;
                case (0, $2lJPz.LogLevel).Information:
                    this.out.info(msg);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.out.log(msg);
                    break;
            }
        }
    }
}
function $1babc0bcca9f1a91$export$56c7340f89ca57c5() {
    let userAgentHeaderName = "X-SignalR-User-Agent";
    if ($1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode) userAgentHeaderName = "User-Agent";
    return [
        userAgentHeaderName,
        $1babc0bcca9f1a91$export$1feb51270b0ce71b((0, $fC0ZB.VERSION), $1babc0bcca9f1a91$var$getOsName(), $1babc0bcca9f1a91$var$getRuntime(), $1babc0bcca9f1a91$var$getRuntimeVersion())
    ];
}
function $1babc0bcca9f1a91$export$1feb51270b0ce71b(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    let userAgent = "Microsoft SignalR/";
    const majorAndMinor = version.split(".");
    userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
    userAgent += ` (${version}; `;
    if (os && os !== "") userAgent += `${os}; `;
    else userAgent += "Unknown OS; ";
    userAgent += `${runtime}`;
    if (runtimeVersion) userAgent += `; ${runtimeVersion}`;
    else userAgent += "; Unknown Runtime Version";
    userAgent += ")";
    return userAgent;
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $1babc0bcca9f1a91$var$getOsName() {
    if ($1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode) switch($4ZL0H.platform){
        case "win32":
            return "Windows NT";
        case "darwin":
            return "macOS";
        case "linux":
            return "Linux";
        default:
            return $4ZL0H.platform;
    }
    else return "";
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $1babc0bcca9f1a91$var$getRuntimeVersion() {
    if ($1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode) return $4ZL0H.versions.node;
    return undefined;
}
function $1babc0bcca9f1a91$var$getRuntime() {
    if ($1babc0bcca9f1a91$export$2dffd0b5373a4389.isNode) return "NodeJS";
    else return "Browser";
}
function $1babc0bcca9f1a91$export$375b49718dbd9ced(e) {
    if (e.stack) return e.stack;
    else if (e.message) return e.message;
    return `${e}`;
}
function $1babc0bcca9f1a91$export$ff5f2eeb11fc7e14() {
    // globalThis is semi-new and not available in Node until v12
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("could not find global");
}

});
parcelRegister("2lJPz", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $1b6117fba0d0f3ae$export$243e62d78d3b544d; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */ var $1b6117fba0d0f3ae$export$243e62d78d3b544d;
(function(LogLevel) {
    /** Log level for very low severity diagnostic messages. */ LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */ LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */ LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */ LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */ LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */ LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */ LogLevel[LogLevel["None"] = 6] = "None";
})($1b6117fba0d0f3ae$export$243e62d78d3b544d || ($1b6117fba0d0f3ae$export$243e62d78d3b544d = {}));

});

parcelRegister("6Ulgh", function(module, exports) {

$parcel$export(module.exports, "NullLogger", function () { return $50787727af72dda3$export$17ac58a1138ded46; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** A logger that does nothing when log messages are sent to it. */ class $50787727af72dda3$export$17ac58a1138ded46 {
    constructor(){}
    /** @inheritDoc */ // eslint-disable-next-line
    log(_logLevel, _message) {}
}
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */ $50787727af72dda3$export$17ac58a1138ded46.instance = new $50787727af72dda3$export$17ac58a1138ded46();

});

parcelRegister("fC0ZB", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $b5db2cba4a7b73a8$export$a4ad2735b021c132; });
const $b5db2cba4a7b73a8$export$a4ad2735b021c132 = '10.0.11';

});

parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = 'browser';
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ''; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3a3153321729209f$var$process.cwd = function() {
    return '/';
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});



parcelRegister("e70Ea", function(module, exports) {

$parcel$export(module.exports, "HttpError", function () { return $a46238943153b77e$export$65bd6083489bd8bb; });
$parcel$export(module.exports, "TimeoutError", function () { return $a46238943153b77e$export$66d311bf29d5c89c; });
$parcel$export(module.exports, "AbortError", function () { return $a46238943153b77e$export$18b052ffd8c84d7; });
$parcel$export(module.exports, "UnsupportedTransportError", function () { return $a46238943153b77e$export$c7cbd7482d8bece8; });
$parcel$export(module.exports, "DisabledTransportError", function () { return $a46238943153b77e$export$764b8cd64449c5b0; });
$parcel$export(module.exports, "FailedToStartTransportError", function () { return $a46238943153b77e$export$264839a6ea29f91a; });
$parcel$export(module.exports, "FailedToNegotiateWithServerError", function () { return $a46238943153b77e$export$b4f59905103de78d; });
$parcel$export(module.exports, "AggregateErrors", function () { return $a46238943153b77e$export$9341e26d19ed3783; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Error thrown when an HTTP request fails. */ class $a46238943153b77e$export$65bd6083489bd8bb extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */ constructor(errorMessage, statusCode){
        const trueProto = new.target.prototype;
        super(`${errorMessage}: Status code '${statusCode}'`);
        this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$66d311bf29d5c89c extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "A timeout occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$18b052ffd8c84d7 extends Error {
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "An abort occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$c7cbd7482d8bece8 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'UnsupportedTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$764b8cd64449c5b0 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'DisabledTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$264839a6ea29f91a extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'FailedToStartTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$b4f59905103de78d extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
     *
     * @param {string} message A descriptive error message.
     */ constructor(message){
        const trueProto = new.target.prototype;
        super(message);
        this.errorType = 'FailedToNegotiateWithServerError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $a46238943153b77e$export$9341e26d19ed3783 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
     *
     * @param {string} message A descriptive error message.
     * @param {Error[]} innerErrors The collection of errors this error is aggregating.
     */ constructor(message, innerErrors){
        const trueProto = new.target.prototype;
        super(message);
        this.innerErrors = innerErrors;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}

});

parcelRegister("c7ba6", function(module, exports) {

$parcel$export(module.exports, "MessageType", function () { return $8d1ecbfd9ca633ca$export$80edbf15fa61a4db; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Defines the type of a Hub Message. */ var $8d1ecbfd9ca633ca$export$80edbf15fa61a4db;
(function(MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */ MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */ MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */ MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */ MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */ MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */ MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */ MessageType[MessageType["Close"] = 7] = "Close";
    MessageType[MessageType["Ack"] = 8] = "Ack";
    MessageType[MessageType["Sequence"] = 9] = "Sequence";
})($8d1ecbfd9ca633ca$export$80edbf15fa61a4db || ($8d1ecbfd9ca633ca$export$80edbf15fa61a4db = {}));

});

parcelRegister("bzYhd", function(module, exports) {

$parcel$export(module.exports, "Subject", function () { return $86e1b8458318eb1a$export$b6bbab5a9b109038; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $2ni4V = parcelRequire("2ni4V");
class $86e1b8458318eb1a$export$b6bbab5a9b109038 {
    constructor(){
        this.observers = [];
    }
    next(item) {
        for (const observer of this.observers)observer.next(item);
    }
    error(err) {
        for (const observer of this.observers)if (observer.error) observer.error(err);
    }
    complete() {
        for (const observer of this.observers)if (observer.complete) observer.complete();
    }
    subscribe(observer) {
        this.observers.push(observer);
        return new (0, $2ni4V.SubjectSubscription)(this, observer);
    }
}

});

parcelRegister("lnViE", function(module, exports) {

$parcel$export(module.exports, "MessageBuffer", function () { return $f9183183e07497be$export$9d24a0f7b61acd07; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $c7ba6 = parcelRequire("c7ba6");

var $2ni4V = parcelRequire("2ni4V");
class $f9183183e07497be$export$9d24a0f7b61acd07 {
    constructor(protocol, connection, bufferSize){
        this._bufferSize = 100000;
        this._messages = [];
        this._totalMessageCount = 0;
        this._waitForSequenceMessage = false;
        // Message IDs start at 1 and always increment by 1
        this._nextReceivingSequenceId = 1;
        this._latestReceivedSequenceId = 0;
        this._bufferedByteCount = 0;
        this._reconnectInProgress = false;
        this._protocol = protocol;
        this._connection = connection;
        this._bufferSize = bufferSize;
    }
    async _send(message) {
        const serializedMessage = this._protocol.writeMessage(message);
        let backpressurePromise = Promise.resolve();
        // Only count invocation messages. Acks, pings, etc. don't need to be resent on reconnect
        if (this._isInvocationMessage(message)) {
            this._totalMessageCount++;
            let backpressurePromiseResolver = ()=>{};
            let backpressurePromiseRejector = ()=>{};
            if ((0, $2ni4V.isArrayBuffer)(serializedMessage)) this._bufferedByteCount += serializedMessage.byteLength;
            else this._bufferedByteCount += serializedMessage.length;
            if (this._bufferedByteCount >= this._bufferSize) backpressurePromise = new Promise((resolve, reject)=>{
                backpressurePromiseResolver = resolve;
                backpressurePromiseRejector = reject;
            });
            this._messages.push(new $f9183183e07497be$var$BufferedItem(serializedMessage, this._totalMessageCount, backpressurePromiseResolver, backpressurePromiseRejector));
        }
        try {
            // If this is set it means we are reconnecting or resending
            // We don't want to send on a disconnected connection
            // And we don't want to send if resend is running since that would mean sending
            // this message twice
            if (!this._reconnectInProgress) await this._connection.send(serializedMessage);
        } catch  {
            this._disconnected();
        }
        await backpressurePromise;
    }
    _ack(ackMessage) {
        let newestAckedMessage = -1;
        // Find index of newest message being acked
        for(let index = 0; index < this._messages.length; index++){
            const element = this._messages[index];
            if (element._id <= ackMessage.sequenceId) {
                newestAckedMessage = index;
                if ((0, $2ni4V.isArrayBuffer)(element._message)) this._bufferedByteCount -= element._message.byteLength;
                else this._bufferedByteCount -= element._message.length;
                // resolve items that have already been sent and acked
                element._resolver();
            } else if (this._bufferedByteCount < this._bufferSize) // resolve items that now fall under the buffer limit but haven't been acked
            element._resolver();
            else break;
        }
        if (newestAckedMessage !== -1) // We're removing everything including the message pointed to, so add 1
        this._messages = this._messages.slice(newestAckedMessage + 1);
    }
    _shouldProcessMessage(message) {
        if (this._waitForSequenceMessage) {
            if (message.type !== (0, $c7ba6.MessageType).Sequence) return false;
            else {
                this._waitForSequenceMessage = false;
                return true;
            }
        }
        // No special processing for acks, pings, etc.
        if (!this._isInvocationMessage(message)) return true;
        const currentId = this._nextReceivingSequenceId;
        this._nextReceivingSequenceId++;
        if (currentId <= this._latestReceivedSequenceId) {
            if (currentId === this._latestReceivedSequenceId) // Should only hit this if we just reconnected and the server is sending
            // Messages it has buffered, which would mean it hasn't seen an Ack for these messages
            this._ackTimer();
            // Ignore, this is a duplicate message
            return false;
        }
        this._latestReceivedSequenceId = currentId;
        // Only start the timer for sending an Ack message when we have a message to ack. This also conveniently solves
        // timer throttling by not having a recursive timer, and by starting the timer via a network call (recv)
        this._ackTimer();
        return true;
    }
    _resetSequence(message) {
        if (message.sequenceId > this._nextReceivingSequenceId) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
            return;
        }
        this._nextReceivingSequenceId = message.sequenceId;
    }
    _disconnected() {
        this._reconnectInProgress = true;
        this._waitForSequenceMessage = true;
    }
    async _resend() {
        const sequenceId = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
        await this._connection.send(this._protocol.writeMessage({
            type: (0, $c7ba6.MessageType).Sequence,
            sequenceId: sequenceId
        }));
        // Get a local variable to the _messages, just in case messages are acked while resending
        // Which would slice the _messages array (which creates a new copy)
        const messages = this._messages;
        for (const element of messages)await this._connection.send(element._message);
        this._reconnectInProgress = false;
    }
    _dispose(error) {
        error !== null && error !== void 0 ? error : error = new Error("Unable to reconnect to server.");
        // Unblock backpressure if any
        for (const element of this._messages)element._rejector(error);
    }
    _isInvocationMessage(message) {
        // There is no way to check if something implements an interface.
        // So we individually check the messages in a switch statement.
        // To make sure we don't miss any message types we rely on the compiler
        // seeing the function returns a value and it will do the
        // exhaustive check for us on the switch statement, since we don't use 'case default'
        switch(message.type){
            case (0, $c7ba6.MessageType).Invocation:
            case (0, $c7ba6.MessageType).StreamItem:
            case (0, $c7ba6.MessageType).Completion:
            case (0, $c7ba6.MessageType).StreamInvocation:
            case (0, $c7ba6.MessageType).CancelInvocation:
                return true;
            case (0, $c7ba6.MessageType).Close:
            case (0, $c7ba6.MessageType).Sequence:
            case (0, $c7ba6.MessageType).Ping:
            case (0, $c7ba6.MessageType).Ack:
                return false;
        }
    }
    _ackTimer() {
        if (this._ackTimerHandle === undefined) this._ackTimerHandle = setTimeout(async ()=>{
            try {
                if (!this._reconnectInProgress) await this._connection.send(this._protocol.writeMessage({
                    type: (0, $c7ba6.MessageType).Ack,
                    sequenceId: this._latestReceivedSequenceId
                }));
            // Ignore errors, that means the connection is closed and we don't care about the Ack message anymore.
            } catch  {}
            clearTimeout(this._ackTimerHandle);
            this._ackTimerHandle = undefined;
        // 1 second delay so we don't spam Ack messages if there are many messages being received at once.
        }, 1000);
    }
}
class $f9183183e07497be$var$BufferedItem {
    constructor(message, id, resolver, rejector){
        this._message = message;
        this._id = id;
        this._resolver = resolver;
        this._rejector = rejector;
    }
}

});


parcelRegister("4PTZu", function(module, exports) {

$parcel$export(module.exports, "UnsavedChangesProvider", function () { return $7f797c278561724f$export$94e7b68100342a47; });
$parcel$export(module.exports, "useUnsavedChanges", function () { return $7f797c278561724f$export$13d7b18655d4746; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");

var $6NgCq = parcelRequire("6NgCq");
const $7f797c278561724f$export$41bdd42c1cc3b964 = {
    clearUnsavedChanges: // istanbul ignore next
    ()=>{},
    hasUnsavedChanges: false,
    isLoading: null,
    /**
   * Fallback navigate implementation used when the provider is not available.
   * This performs a hard navigation by setting `window.location.href`.
   */ navigate: ()=>{
        window.location.href = "/";
    },
    /**
   * Fallback navigate-after-save used when the provider is not mounted.
   * Intended to be no-op in test environments; real behaviour is provided
   * by the `UnsavedChangesProvider` implementation.
   */ navigateAfterSave: // istanbul ignore next
    ()=>{},
    /**
   * Fallback registerUnsavedChanges used when the provider is not mounted.
   */ registerUnsavedChanges: // istanbul ignore next
    ()=>{}
};
const $7f797c278561724f$export$c6190abc0aa2e52c = /*#__PURE__*/ (0, $7fPBF.createContext)($7f797c278561724f$export$41bdd42c1cc3b964);
const $7f797c278561724f$export$94e7b68100342a47 = ({ children: children })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const rrNavigate = (0, $gxpCl.useNavigate)();
    const [unsavedChangesSources, setUnsavedChangesSources] = (0, $7fPBF.useState)({});
    const location = (0, $gxpCl.useLocation)();
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>setIsLoading(null));
    }, [
        location.pathname
    ]);
    const clearUnsavedChanges = (0, $7fPBF.useCallback)(()=>{
        setUnsavedChangesSources({});
    }, []);
    /**
   * Clear all registered unsaved-change flags.
   * Used after a successful save or when navigation is forced.
   */ const registerUnsavedChanges = (0, $7fPBF.useCallback)((id, hasChanges)=>{
        setUnsavedChangesSources((prev)=>({
                ...prev,
                [id]: hasChanges
            }));
    }, []);
    /**
   * Register or update a component's unsaved-changes state.
   *
   * @param id - The identifier for the component registering changes
   * @param hasChanges - True if the component currently has unsaved changes
   */ const hasUnsavedChanges = (0, $7fPBF.useMemo)(()=>Object.values(unsavedChangesSources).some(Boolean), [
        unsavedChangesSources
    ]);
    const navigate = (0, $7fPBF.useCallback)((url, id, options)=>{
        setIsLoading(id);
        rrNavigate(url, options);
    }, [
        rrNavigate
    ]);
    /**
   * Trigger navigation and set the component `id` as the loading source.
   * This prevents the unsaved-changes blocker from prompting while
   * navigation initiated by the same component proceeds.
   *
   * @param url - The destination to navigate to
   * @param id - The component id initiating navigation
   * @param options - Optional navigation options forwarded to the router
   */ const navigateAfterSave = (0, $7fPBF.useCallback)((url, id, options)=>{
        setIsLoading(id);
        clearUnsavedChanges();
        setTimeout(()=>{
            rrNavigate(url, options);
        }, 1);
    }, [
        clearUnsavedChanges,
        rrNavigate
    ]);
    /**
   * Navigate after performing a save: clear any unsaved flags and then
   * navigate to the supplied `url`. `setTimeout` is used to allow any
   * save completion logic to settle before routing.
   *
   * @param url - The destination to navigate to after save
   * @param id - The component id initiating the save-and-navigate flow
   * @param options - Optional navigation options forwarded to the router
   */ // Single beforeunload handler
    (0, $7fPBF.useEffect)(()=>{
        /**
     * Beforeunload handler that prompts the browser to show a confirmation
     * if there are registered unsaved changes.
     *
     * @param event - The beforeunload event provided by the browser
     */ const handleBeforeUnload = (event)=>{
            /* istanbul ignore else */ if (hasUnsavedChanges) {
                event.preventDefault();
                return "";
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [
        hasUnsavedChanges
    ]);
    // Register the blocker with the router
    (0, $gxpCl.useBlocker)((args)=>{
        if (!hasUnsavedChanges) return false;
        const { currentLocation: currentLocation, nextLocation: nextLocation } = args;
        if ((0, $6NgCq.locationCheck)(currentLocation.pathname, nextLocation.pathname)) {
            const question = window.confirm("You have unsaved changes. Do you want to discard them and navigate away?");
            // Clear loading flag if you don't want to navigate
            if (!question) setIsLoading(null);
            return !question;
        }
        return false;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7f797c278561724f$export$c6190abc0aa2e52c.Provider, {
        value: {
            clearUnsavedChanges: clearUnsavedChanges,
            hasUnsavedChanges: hasUnsavedChanges,
            isLoading: isLoading,
            navigate: navigate,
            navigateAfterSave: navigateAfterSave,
            registerUnsavedChanges: registerUnsavedChanges
        },
        children: children
    });
};
$7f797c278561724f$export$94e7b68100342a47.displayName = "UnsavedChangesProvider";
const $7f797c278561724f$export$13d7b18655d4746 = (id)=>{
    const cxt = (0, $7fPBF.useContext)($7f797c278561724f$export$c6190abc0aa2e52c);
    return {
        ...cxt,
        /**
     * Navigate while scoping the call to this hook's `id` so that the
     * provider can mark which component initiated loading.
     *
     * @param url - The destination to navigate to
     * @param options - Optional navigate options forwarded to the router
     */ navigate: (url, options)=>{
            cxt.navigate(url, id, options);
        },
        /**
     * Navigate after a successful save, clearing this component's
     * unsaved-changes state before performing the navigation.
     *
     * @param url - The destination to navigate to after save
     * @param options - Optional navigate options forwarded to the router
     */ navigateAfterSave: (url, options)=>{
            cxt.navigateAfterSave(url, id, options);
        }
    };
};

});
parcelRegister("6NgCq", function(module, exports) {

$parcel$export(module.exports, "locationCheck", function () { return $f39a20b9f8e3bb74$export$e1d44f3ebb457149; });

var $gSkQi = parcelRequire("gSkQi");

var $hhEdZ = parcelRequire("hhEdZ");
const $f39a20b9f8e3bb74$export$e1d44f3ebb457149 = (currentLocation, nextLocation)=>{
    const currentParams = (0, $hhEdZ.getRouteLoaderParams)(currentLocation);
    const targetParams = (0, $hhEdZ.getRouteLoaderParams)(nextLocation);
    const loaderChange = !(0, $gSkQi.isEqual)(currentParams, targetParams);
    return loaderChange;
};

});
parcelRegister("hhEdZ", function(module, exports) {

$parcel$export(module.exports, "getRouteLoaderParams", function () { return $18d053c7310e098d$export$216bdd1e94d01766; });

var $gxpCl = parcelRequire("gxpCl");

var $f4Ua7 = parcelRequire("f4Ua7");
const $18d053c7310e098d$export$216bdd1e94d01766 = (path)=>{
    return (0, $gxpCl.matchRoutes)((0, $f4Ua7.routes), path)?.filter((match)=>match.route.loader).map((m)=>({
            params: m.params,
            pathname: m.pathname
        })).pop();
};

});
parcelRegister("f4Ua7", function(module, exports) {

$parcel$export(module.exports, "routes", function () { return $6921d10a59af4a10$export$66b32f6f30eb4b4; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $9eqKP = parcelRequire("9eqKP");

var $gBchy = parcelRequire("gBchy");

var $4Klmq = parcelRequire("4Klmq");

var $k79Le = parcelRequire("k79Le");

var $fgSZv = parcelRequire("fgSZv");

var $e1HPF = parcelRequire("e1HPF");

var $8lP2T = parcelRequire("8lP2T");

var $gVAKq = parcelRequire("gVAKq");

var $aQn9V = parcelRequire("aQn9V");

var $87sNd = parcelRequire("87sNd");

var $bEjPP = parcelRequire("bEjPP");

var $9fTRU = parcelRequire("9fTRU");

var $kIGng = parcelRequire("kIGng");
/**
 * Determines whether a route loader should be revalidated.
 * When a navigation occurs (currentUrl differs from nextUrl), revalidation is
 * only triggered if the pathname changes, preventing unnecessary loader runs
 * when only search parameters are modified. For non-navigation triggers such
 * as explicit revalidation or action-driven refreshes (where both URLs are
 * identical), the router's default decision is used.
 *
 * @param args - Revalidation arguments from React Router.
 * @param args.currentUrl - URL for the current route state before navigation.
 * @param args.nextUrl - URL for the target route state after navigation.
 * @param args.defaultShouldRevalidate - The router's default revalidation decision,
 *        used as a fallback for non-navigation triggers.
 * @returns True when the pathname changes, or when the router would revalidate by default.
 */ const $6921d10a59af4a10$var$shouldRevalidateOnPathnameChange = ({ currentUrl: currentUrl, nextUrl: nextUrl, defaultShouldRevalidate: defaultShouldRevalidate })=>{
    return currentUrl.href === nextUrl.href ? defaultShouldRevalidate : currentUrl.pathname !== nextUrl.pathname;
};









































const $6921d10a59af4a10$export$66b32f6f30eb4b4 = [
    {
        path: "/",
        loader: (0, $aQn9V.appSettingsLoader),
        errorElement: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bEjPP.default), {}),
        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gBchy.default), {}),
        hydrateFallbackElement: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
            text: "Loading application..."
        }),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9fTRU.default), {})
            },
            // Admin page
            {
                path: "/Admin",
                lazy: async ()=>({
                        Component: (await (parcelRequire("hRJrV"))).AdminPage
                    })
            },
            // Maintenance page
            {
                path: "/Maintenance",
                lazy: async ()=>({
                        Component: (await (parcelRequire("lhSAP"))).MaintenancePage
                    })
            },
            // Not Allowed Page
            {
                path: "/NotAllowed",
                lazy: async ()=>({
                        Component: (await (parcelRequire("9U5RK"))).NotAllowedPage
                    })
            },
            // Legacy tag-based hierarchy redirects — preserve backward compatibility
            // for bookmarks and external links that used the old level-prefixed URL scheme,
            // including deep links (for example: /TA/:hierarchyTag/Access).
            ...[
                "/TA/:hierarchyTag",
                "/TA/:hierarchyTag/:more",
                "/TA/:hierarchyTag/:more/*",
                "/Project/:hierarchyTag",
                "/Project/:hierarchyTag/:more",
                "/Project/:hierarchyTag/:more/*",
                "/Study/:hierarchyTag",
                "/Study/:hierarchyTag/:more",
                "/Study/:hierarchyTag/:more/*",
                "/Study/:studyName/Report/:reportName",
                "/Study/:studyName/Report/:reportName/:more",
                "/Study/:studyName/Report/:reportName/:more/*",
                "/Study/:studyName/Report/:reportName/Version/:tocMajorVersion",
                "/Study/:studyName/Report/:reportName/Version/:tocMajorVersion/:more",
                "/Study/:studyName/Report/:reportName/Version/:tocMajorVersion/:more/*"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4Klmq.hierarchyLegacyTagRedirectLoader),
                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87sNd.default), {})
                })),
            // Ancestor tags encoded in path segments so the
            // backend can resolve the hierarchy within the correct parent scope.
            ...[
                "/Corporate",
                "/:taPrefix",
                "/:taPrefix/:projectCode",
                "/:taPrefix/:projectCode/:studyTag",
                "/:taPrefix/:projectCode/:studyTag/:reportName",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Version/:tocMajorVersion"
            ].map((path)=>({
                    path: path,
                    loader: (0, $k79Le.hierarchyLoader),
                    lazy: async ()=>({
                            Component: (await (parcelRequire("jA3bI"))).HierarchyPage
                        }),
                    children: [
                        {
                            index: true,
                            lazy: async ()=>({
                                    Component: path.includes(":reportName") ? (await (parcelRequire("8ISDu"))).TOC : (await (parcelRequire("eAVG6"))).HierarchyProperties
                                })
                        },
                        {
                            path: "Access",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("lHEd3"))).AccessRights
                                })
                        },
                        {
                            path: "ClinicalLibrary",
                            children: [
                                {
                                    index: true,
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("aY3gf"))).LibraryNavigation
                                        })
                                },
                                {
                                    path: "CodeLists",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "CodeList/:codeListName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "DataSets",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "DataSet/:dataSetName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "ValueLists",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "ValueList/:valueListName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Comments",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Methods",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "WhereClauses",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "WhereClause/:whereClauseName/RangeCheck/:rangeCheckId",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "WhereClause/:whereClauseName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Comment/:commentId",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Method/:methodOid",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("kyGdZ"))).LibraryTable
                                        })
                                }
                            ]
                        },
                        {
                            path: "DomainReplacements",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("likeG"))).HierarchyDomainReplacements
                                })
                        },
                        {
                            path: "Lists",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("cWHH6"))).HierarchyLists
                                })
                        },
                        {
                            path: "Properties",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("eAVG6"))).HierarchyProperties
                                })
                        },
                        {
                            path: "Replacements",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("cjUIt"))).ExternalSinglesTable
                                })
                        },
                        {
                            path: "Tags",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("itAGi"))).HierarchyTags
                                })
                        },
                        {
                            path: "RowGroups",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("HdcsK"))).HierarchyRowGroups
                                })
                        },
                        {
                            path: "AnalysisMethods",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("9OqCd"))).HierarchyAnalysisMethods
                                })
                        },
                        {
                            path: "AnalysisSets",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("6Wv5Q"))).HierarchyAnalysisSets
                                })
                        },
                        {
                            path: "DataSubsets",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("bLP2B"))).HierarchyDataSubsets
                                })
                        },
                        {
                            path: "GroupingFactors",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("edhEb"))).HierarchyGroupingFactors
                                })
                        },
                        {
                            path: "TOC",
                            lazy: async ()=>({
                                    Component: path.includes(":reportName") ? (await (parcelRequire("8ISDu"))).TOC : (await (parcelRequire("8zjnF"))).NotFound
                                })
                        },
                        {
                            path: "Versions",
                            lazy: async ()=>({
                                    Component: path.includes(":reportName") ? (await (parcelRequire("6vA7u"))).ReportVersions : (await (parcelRequire("l3DSi"))).HierarchyHistoryTable
                                })
                        },
                        {
                            path: "AdvancedSearch",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("g8Sep"))).EditorBlocksSearchControls
                                })
                        }
                    ]
                })),
            // TLF pages (with hierarchy ancestor tags)
            ...[
                "/Corporate",
                "/:taPrefix",
                "/:taPrefix/:projectCode",
                "/:taPrefix/:projectCode/:studyTag",
                "/:taPrefix/:projectCode/:studyTag/:reportName"
            ].map((path)=>({
                    path: `${path}/NewTlf/:newType`,
                    loader: (0, $e1HPF.newTlfLoader),
                    lazy: async ()=>({
                            Component: (await (parcelRequire("lvvd5"))).TlfPage
                        })
                })),
            // Old redirect links (numeric / UUID IDs)
            ...[
                "/H/:hierarchyId",
                "/H/:hierarchyId/:more",
                "/S/:hierarchyId",
                "/S/:hierarchyId/:more",
                "/R/:hierarchyId",
                "/R/:hierarchyId/:more"
            ].map((path)=>({
                    path: path,
                    loader: (0, $fgSZv.hierarchyRedirectLoader),
                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87sNd.default), {})
                })),
            // Old TlfDesigner pages and redirect from search
            ...[
                "/TlfDesigner/:azsolId/:version",
                "/TlfDesigner/:id"
            ].map((path)=>({
                    path: path,
                    loader: (0, $gVAKq.tlfRedirectLoader),
                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87sNd.default), {})
                })),
            // Legacy template TLF URLs — redirect to the new /Template/-prefixed canonical routes.
            // Corporate: /Corporate/:azsolId/:version is unambiguous because the static "Corporate"
            // segment outranks the all-dynamic ancestor-path hierarchy routes.
            // TA / Project: the old level-prefix segments (/TA/, /Project/) are static, so these
            // four-segment routes are ranked above the all-dynamic
            // /:taPrefix/:projectCode/:studyTag/:reportName Report hierarchy route that would
            // otherwise consume them.
            ...[
                "/Corporate/:azsolId/:version",
                "/TA/:taPrefix/:azsolId/:version",
                "/Project/:projectCode/:azsolId/:version"
            ].map((path)=>({
                    path: path,
                    loader: (0, $gVAKq.tlfRedirectLoader),
                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87sNd.default), {})
                })),
            // Load tlf (with hierarchy ancestor tags)
            ...[
                "/Corporate/Load",
                "/:taPrefix/Load",
                "/:taPrefix/:projectCode/Load",
                "/:taPrefix/:projectCode/:studyTag/Load",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Load",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Version/:tocMajorVersion/Load"
            ].map((path)=>({
                    path: path,
                    loader: (0, $8lP2T.tlfLoader),
                    shouldRevalidate: $6921d10a59af4a10$var$shouldRevalidateOnPathnameChange,
                    lazy: async ()=>({
                            Component: (await (parcelRequire("lvvd5"))).TlfPage
                        })
                })),
            // Template pages — a static "Template" segment is required for all levels to avoid
            // ambiguity with the all-dynamic hierarchy routes. Without it,
            // /:taPrefix/:azsolId/:version is indistinguishable from
            // /:taPrefix/:projectCode/:studyTag (Study hierarchy), and
            // /:taPrefix/:projectCode/:azsolId/:version is indistinguishable from
            // /:taPrefix/:projectCode/:studyTag/:reportName (Report hierarchy).
            // Corporate could technically omit the prefix (the static "Corporate" segment
            // already disambiguates), but the prefix is kept for consistency.
            ...[
                "/Corporate/Template/:azsolId/:version",
                "/:taPrefix/Template/:azsolId/:version",
                "/:taPrefix/:projectCode/Template/:azsolId/:version"
            ].map((path)=>({
                    path: path,
                    loader: (0, $8lP2T.tlfLoader),
                    shouldRevalidate: $6921d10a59af4a10$var$shouldRevalidateOnPathnameChange,
                    lazy: async ()=>({
                            Component: (await (parcelRequire("lvvd5"))).TlfPage
                        })
                })),
            // Shell pages (with hierarchy ancestor tag)
            ...[
                "/:taPrefix/:projectCode/:studyTag/:reportName/:tocNumber",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Version/:tocMajorVersion/:tocNumber"
            ].map((path)=>({
                    path: path,
                    loader: (0, $8lP2T.tlfLoader),
                    shouldRevalidate: $6921d10a59af4a10$var$shouldRevalidateOnPathnameChange,
                    lazy: async ()=>({
                            Component: (await (parcelRequire("lvvd5"))).TlfPage
                        })
                })),
            // Review pages (with hierarchy ancestor tags)
            ...[
                "/:taPrefix/:projectCode/:studyTag/:reportName/Review"
            ].map((path)=>({
                    path: path,
                    loader: (0, $k79Le.hierarchyLoader),
                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kIGng.default), {}),
                    children: [
                        {
                            path: ":tocNumber",
                            loader: (0, $8lP2T.tlfLoader),
                            element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kIGng.TlfReviewRHS), {})
                        },
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "w-100 h-100 d-flex align-items-center justify-content-center",
                                children: "Choose from the list of TLF items"
                            })
                        }
                    ]
                })),
            // Not found splat
            {
                path: "/*",
                lazy: async ()=>({
                        Component: (await (parcelRequire("8zjnF"))).NotFound
                    })
            }
        ]
    }
];

});
parcelRegister("gBchy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5368b9ba8939901$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $it3LR = parcelRequire("it3LR");

var $4PTZu = parcelRequire("4PTZu");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");

var $hPlgS = parcelRequire("hPlgS");

var $5RbkJ = parcelRequire("5RbkJ");

var $hWsmt = parcelRequire("hWsmt");

var $gD2t9 = parcelRequire("gD2t9");
const $a5368b9ba8939901$export$b89f06cf587ba0db = ()=>{
    const loaderData = (0, $gxpCl.useLoaderData)();
    const navigate = (0, $gxpCl.useNavigate)(); // Save not to use useCheckBeforeNavigate here - there are no unsaved changes in this context
    const location = (0, $gxpCl.useLocation)();
    // MSAL info
    const { accounts: accounts } = (0, $it3LR.useMsal)();
    const account = (0, $it3LR.useAccount)(accounts[0]);
    const backEndUrl = loaderData.backEndUrl;
    const crystalUrl = loaderData.crystalUrl;
    let displayName = (0, $5RbkJ.defaultSettings).displayName;
    let prid = (0, $5RbkJ.defaultSettings).prid;
    if (account) {
        displayName = `${account.name} (${account.username})`;
        prid = account.username.split("@")[0];
    }
    // Navigate for bad people
    if (account && account.username.split("@")[1] !== (0, $5RbkJ.defaultSettings).domain && account.username.split("@")[0].length > 20 && location.pathname !== "/NotAllowed") navigate("/NotAllowed");
    // Get application permissions
    const userId = loaderData.me.userId ?? // istanbul ignore next
    (0, $5RbkJ.defaultSettings).userId;
    const isAdmin = loaderData.me.isAdmin ?? // istanbul ignore next
    false;
    const applicationPermissions = loaderData.me.applicationPermissions ?? // istanbul ignore next
    [];
    // Get back end version number
    const backEndVersion = loaderData.backEndVersion ?? // istanbul ignore next
    "Error getting version";
    // Check maintenance mode
    const maintenanceMode = loaderData.maintenanceMode.maintenanceMode;
    const maintenanceMessage = loaderData.maintenanceMode.maintenanceMessage ?? // istanbul ignore next
    "";
    // Redirect for maintenance mode
    /* istanbul ignore else */ if (maintenanceMode && !location.pathname.startsWith("/Admin") && location.pathname !== "/Maintenance") navigate("/Maintenance");
    // Extra context data
    const helpLinks = loaderData.helpLinks;
    const styles = loaderData.styles;
    const figureSettings = loaderData.figureSettings;
    const annotationComparatorTypes = loaderData.annotationComparatorTypes;
    // Unified reducer managing hierarchy and ToC slices
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $hPlgS.appSettingsContextReducer), {
        ...(0, $hWsmt.unifiedInitialState),
        appSettingsLoaded: true,
        applicationPermissions: applicationPermissions,
        backEndUrl: backEndUrl,
        backEndVersion: backEndVersion,
        crystalUrl: crystalUrl,
        displayName: displayName,
        figureSettings: figureSettings,
        helpLinks: helpLinks,
        isAdmin: isAdmin,
        maintenanceMessage: maintenanceMessage,
        maintenanceMode: maintenanceMode,
        prid: prid,
        styles: styles,
        userId: userId,
        annotationComparatorTypes: annotationComparatorTypes
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hWsmt.AppSettingsContext).Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gD2t9.SignalRProvider), {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4PTZu.UnsavedChangesProvider), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    id: "app-root",
                    style: {
                        paddingBottom: "42px",
                        height: "100vh",
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxpCl.Outlet), {})
                })
            })
        })
    });
};
$a5368b9ba8939901$export$b89f06cf587ba0db.displayName = "AppSettingsContextProvider";
var $a5368b9ba8939901$export$2e2bcd8739ae039 = $a5368b9ba8939901$export$b89f06cf587ba0db;

});
parcelRegister("it3LR", function(module, exports) {

$parcel$export(module.exports, "MsalAuthenticationTemplate", function () { return $c609fcf788b89cb7$export$c9cd7a02d4bd7707; }, function (v) { return $c609fcf788b89cb7$export$c9cd7a02d4bd7707 = v; });
$parcel$export(module.exports, "MsalProvider", function () { return $c609fcf788b89cb7$export$25bac41dc3d78d47; }, function (v) { return $c609fcf788b89cb7$export$25bac41dc3d78d47 = v; });
$parcel$export(module.exports, "useAccount", function () { return $c609fcf788b89cb7$export$83a8e409853da004; }, function (v) { return $c609fcf788b89cb7$export$83a8e409853da004 = v; });
$parcel$export(module.exports, "useMsal", function () { return $c609fcf788b89cb7$export$f41558044a1dd55; }, function (v) { return $c609fcf788b89cb7$export$f41558044a1dd55 = v; });
/*! @azure/msal-react v5.7.1 2026-09-15 */ var $c609fcf788b89cb7$export$3f7734c901feade6;
var $c609fcf788b89cb7$export$c9cd7a02d4bd7707;
var $c609fcf788b89cb7$export$b74154d0810e24c1;
var $c609fcf788b89cb7$export$66324aeea97dd1e5;
var $c609fcf788b89cb7$export$25bac41dc3d78d47;
var $c609fcf788b89cb7$export$8285a35799c5812b;
var $c609fcf788b89cb7$export$83a8e409853da004;
var $c609fcf788b89cb7$export$7e9c60d6d1836c84;
var $c609fcf788b89cb7$export$f41558044a1dd55;
var $c609fcf788b89cb7$export$d130d543558e611f;
var $c609fcf788b89cb7$export$83d89fbfd8236492;
var $c609fcf788b89cb7$export$8dea26c30ebc61cd;
'use strict';
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $lp1At = parcelRequire("lp1At");
function $c609fcf788b89cb7$var$_interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n.default = e;
    return Object.freeze(n);
}
var $c609fcf788b89cb7$var$React__namespace = /*#__PURE__*/ $c609fcf788b89cb7$var$_interopNamespaceDefault($7fPBF);
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $c609fcf788b89cb7$var$defaultMsalContext = {
    instance: $lp1At.stubbedPublicClientApplication,
    inProgress: $lp1At.InteractionStatus.None,
    accounts: [],
    logger: new $lp1At.Logger({})
};
const $c609fcf788b89cb7$var$MsalContext = $c609fcf788b89cb7$var$React__namespace.createContext($c609fcf788b89cb7$var$defaultMsalContext);
const $c609fcf788b89cb7$var$MsalConsumer = $c609fcf788b89cb7$var$MsalContext.Consumer;
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $c609fcf788b89cb7$var$getChildrenOrFunction(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $c609fcf788b89cb7$var$accountArraysAreEqual(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $c609fcf788b89cb7$var$getAccountByIdentifiers(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}
/* eslint-disable header/header */ const $c609fcf788b89cb7$var$name = "@azure/msal-react";
const $c609fcf788b89cb7$var$version = "5.7.1";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c609fcf788b89cb7$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $c609fcf788b89cb7$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $c609fcf788b89cb7$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === $lp1At.InteractionStatus.Startup) {
                newInProgress = $lp1At.InteractionStatus.None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'", "");
            }
            break;
        case $c609fcf788b89cb7$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = $lp1At.EventMessageUtils.getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - '${message.eventType}' results in setting inProgress from '${previousState.inProgress}' to '${status}'`, "");
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    if (newInProgress === $lp1At.InteractionStatus.Startup) // Can't start checking accounts until initialization is complete
    return previousState;
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !$c609fcf788b89cb7$var$accountArraysAreEqual(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!$c609fcf788b89cb7$var$accountArraysAreEqual(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $c609fcf788b89cb7$var$MsalProvider({ instance: instance, children: children }) {
    $7fPBF.useEffect(()=>{
        instance.initializeWrapperLibrary($lp1At.WrapperSKU.React, $c609fcf788b89cb7$var$version);
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = $7fPBF.useMemo(()=>{
        return instance.getLogger().clone($c609fcf788b89cb7$var$name, $c609fcf788b89cb7$var$version);
    }, [
        instance
    ]);
    const [state, updateState] = $7fPBF.useReducer($c609fcf788b89cb7$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: $lp1At.InteractionStatus.Startup,
            accounts: []
        };
    });
    $7fPBF.useEffect(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $c609fcf788b89cb7$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: '${callbackId}'`, "");
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $c609fcf788b89cb7$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback '${callbackId}'`, "");
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return $7fPBF.createElement($c609fcf788b89cb7$var$MsalContext.Provider, {
        value: contextValue
    }, children);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $c609fcf788b89cb7$var$useMsal = ()=>$7fPBF.useContext($c609fcf788b89cb7$var$MsalContext);
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $c609fcf788b89cb7$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!$c609fcf788b89cb7$var$getAccountByIdentifiers(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $c609fcf788b89cb7$var$useIsAuthenticated(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = $c609fcf788b89cb7$var$useMsal();
    const isUserAuthenticated = $7fPBF.useMemo(()=>{
        if (inProgress === $lp1At.InteractionStatus.Startup) return false;
        return $c609fcf788b89cb7$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $c609fcf788b89cb7$var$AuthenticatedTemplate({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = $c609fcf788b89cb7$var$useMsal();
    const accountIdentifier = $7fPBF.useMemo(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = $c609fcf788b89cb7$var$useIsAuthenticated(accountIdentifier);
    if (isAuthenticated && context.inProgress !== $lp1At.InteractionStatus.Startup) return $7fPBF.createElement($7fPBF.Fragment, null, $c609fcf788b89cb7$var$getChildrenOrFunction(children, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $c609fcf788b89cb7$var$UnauthenticatedTemplate({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = $c609fcf788b89cb7$var$useMsal();
    const accountIdentifier = $7fPBF.useMemo(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = $c609fcf788b89cb7$var$useIsAuthenticated(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== $lp1At.InteractionStatus.Startup && context.inProgress !== $lp1At.InteractionStatus.HandleRedirect) return $7fPBF.createElement($7fPBF.Fragment, null, $c609fcf788b89cb7$var$getChildrenOrFunction(children, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $c609fcf788b89cb7$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return $c609fcf788b89cb7$var$getAccountByIdentifiers(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Helper function to determine whether 2 accountInfo objects represent the same account
 * @param accountA
 * @param accountB
 */ function $c609fcf788b89cb7$var$accountInfoIsEqual(accountA, accountB) {
    if (!accountA || !accountB) return false;
    const accountAClaims = accountA.idTokenClaims || {};
    const accountBClaims = accountB.idTokenClaims || {};
    // issued at timestamp and nonce are expected to change each time a new id token is acquired
    const claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
    return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $c609fcf788b89cb7$var$useAccount(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = $c609fcf788b89cb7$var$useMsal();
    const [account, setAccount] = $7fPBF.useState(()=>{
        if (inProgress === $lp1At.InteractionStatus.Startup) return null;
        else return $c609fcf788b89cb7$var$getAccount(instance, accountIdentifiers);
    });
    const updateAccount = $7fPBF.useCallback(()=>{
        const nextAccount = $c609fcf788b89cb7$var$getAccount(instance, accountIdentifiers);
        setAccount((currentAccount)=>{
            if (!$c609fcf788b89cb7$var$accountInfoIsEqual(currentAccount, nextAccount)) {
                logger.info("useAccount - Updating account", "");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        accountIdentifiers,
        instance,
        logger
    ]);
    $7fPBF.useEffect(()=>{
        if (inProgress !== $lp1At.InteractionStatus.Startup) updateAccount();
        const callbackId = instance.addEventCallback((message)=>{
            if (message.eventType === $lp1At.EventType.ACTIVE_ACCOUNT_CHANGED || message.eventType === $lp1At.EventType.LOGIN_SUCCESS && message.interactionType === $lp1At.InteractionType.Silent) updateAccount();
        });
        return ()=>{
            if (callbackId) instance.removeEventCallback(callbackId);
        };
    }, [
        updateAccount,
        inProgress,
        instance
    ]);
    return account;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $c609fcf788b89cb7$var$ReactAuthErrorMessage = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $c609fcf788b89cb7$var$ReactAuthError extends $lp1At.AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, $c609fcf788b89cb7$var$ReactAuthError.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError(correlationId) {
        return new $c609fcf788b89cb7$var$ReactAuthError($c609fcf788b89cb7$var$ReactAuthErrorMessage.invalidInteractionType.code, correlationId || "", $c609fcf788b89cb7$var$ReactAuthErrorMessage.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError(correlationId) {
        return new $c609fcf788b89cb7$var$ReactAuthError($c609fcf788b89cb7$var$ReactAuthErrorMessage.unableToFallbackToInteraction.code, correlationId || "", $c609fcf788b89cb7$var$ReactAuthErrorMessage.unableToFallbackToInteraction.desc);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $c609fcf788b89cb7$var$useMsalAuthentication(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = $c609fcf788b89cb7$var$useMsal();
    const isAuthenticated = $c609fcf788b89cb7$var$useIsAuthenticated(accountIdentifiers);
    const account = $c609fcf788b89cb7$var$useAccount(accountIdentifiers);
    const [[result, error], setResponse] = $7fPBF.useState([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = $7fPBF.useRef(true);
    $7fPBF.useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = $7fPBF.useRef(inProgress !== $lp1At.InteractionStatus.None);
    $7fPBF.useEffect(()=>{
        interactionInProgress.current = inProgress !== $lp1At.InteractionStatus.None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = $7fPBF.useRef(true);
    $7fPBF.useEffect(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = $7fPBF.useCallback(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling getToken", callbackRequest?.correlationId || "");
            switch(loginType){
                case $lp1At.InteractionType.Popup:
                    logger.verbose("useMsalAuthentication - Calling loginPopup", callbackRequest?.correlationId || "");
                    return instance.loginPopup(loginRequest);
                case $lp1At.InteractionType.Redirect:
                    // This promise is not expected to resolve due to full frame redirect
                    logger.verbose("useMsalAuthentication - Calling loginRedirect", callbackRequest?.correlationId || "");
                    await instance.handleRedirectPromise();
                    return instance.loginRedirect(loginRequest).then(()=>null);
                case $lp1At.InteractionType.Silent:
                    logger.verbose("useMsalAuthentication - Calling ssoSilent", callbackRequest?.correlationId || "");
                    return instance.ssoSilent(!!loginRequest ? loginRequest : {});
                default:
                    const invalidTypeError = $c609fcf788b89cb7$var$ReactAuthError.createInvalidInteractionTypeError(loginRequest?.correlationId);
                    if (mounted.current) setResponse([
                        null,
                        invalidTypeError
                    ]);
                    throw invalidTypeError;
            }
        };
        return getToken().then((response)=>{
            if (response && mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = $7fPBF.useCallback(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback", callbackRequest.correlationId || "");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook", authenticationRequest.correlationId || "");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || $lp1At.OIDC_DEFAULT_SCOPES
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.", "");
            tokenRequest = {
                scopes: $lp1At.OIDC_DEFAULT_SCOPES
            };
        }
        const correlationId = tokenRequest.correlationId || $lp1At.BrowserUtils.createGuid();
        tokenRequest.correlationId = correlationId;
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request", correlationId);
            tokenRequest.account = account;
        }
        return instance.acquireTokenSilent(tokenRequest).then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch(async (e)=>{
            if (e instanceof $lp1At.InteractionRequiredAuthError) {
                if (!interactionInProgress.current) {
                    logger.error("useMsalAuthentication - Interaction required, falling back to interaction", correlationId);
                    return login(fallbackInteractionType, tokenRequest);
                } else {
                    const fallbackError = $c609fcf788b89cb7$var$ReactAuthError.createUnableToFallbackToInteractionError(correlationId);
                    logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.", correlationId);
                    if (mounted.current) setResponse([
                        null,
                        fallbackError
                    ]);
                    throw fallbackError;
                }
            }
            // Handle other errors
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    $7fPBF.useEffect(()=>{
        if (shouldAcquireToken.current && inProgress === $lp1At.InteractionStatus.None) {
            if (!isAuthenticated) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login", "");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token", "");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        // If logging out, set the state to null so the component doesn't display authenticated content for a user that is logged out
        } else if (!account && result) setResponse([
            null,
            null
        ]);
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $c609fcf788b89cb7$var$MsalAuthenticationTemplate({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = $7fPBF.useMemo(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = $c609fcf788b89cb7$var$useMsal();
    const msalAuthResult = $c609fcf788b89cb7$var$useMsalAuthentication(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = $c609fcf788b89cb7$var$useIsAuthenticated(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === $lp1At.InteractionStatus.None) {
        if (!!ErrorComponent) return $7fPBF.createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return $7fPBF.createElement($7fPBF.Fragment, null, $c609fcf788b89cb7$var$getChildrenOrFunction(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== $lp1At.InteractionStatus.None) return $7fPBF.createElement(LoadingComponent, {
        ...context
    });
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $c609fcf788b89cb7$var$withMsal = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = $c609fcf788b89cb7$var$useMsal();
        return $7fPBF.createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};
$c609fcf788b89cb7$export$3f7734c901feade6 = $c609fcf788b89cb7$var$AuthenticatedTemplate;
$c609fcf788b89cb7$export$c9cd7a02d4bd7707 = $c609fcf788b89cb7$var$MsalAuthenticationTemplate;
$c609fcf788b89cb7$export$b74154d0810e24c1 = $c609fcf788b89cb7$var$MsalConsumer;
$c609fcf788b89cb7$export$66324aeea97dd1e5 = $c609fcf788b89cb7$var$MsalContext;
$c609fcf788b89cb7$export$25bac41dc3d78d47 = $c609fcf788b89cb7$var$MsalProvider;
$c609fcf788b89cb7$export$8285a35799c5812b = $c609fcf788b89cb7$var$UnauthenticatedTemplate;
$c609fcf788b89cb7$export$83a8e409853da004 = $c609fcf788b89cb7$var$useAccount;
$c609fcf788b89cb7$export$7e9c60d6d1836c84 = $c609fcf788b89cb7$var$useIsAuthenticated;
$c609fcf788b89cb7$export$f41558044a1dd55 = $c609fcf788b89cb7$var$useMsal;
$c609fcf788b89cb7$export$d130d543558e611f = $c609fcf788b89cb7$var$useMsalAuthentication;
$c609fcf788b89cb7$export$83d89fbfd8236492 = $c609fcf788b89cb7$var$version;
$c609fcf788b89cb7$export$8dea26c30ebc61cd = $c609fcf788b89cb7$var$withMsal; //# sourceMappingURL=msal-react.cjs.map

});
parcelRegister("lp1At", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $9ed9a547f6786bdc$export$243e62d78d3b544d; }, function (v) { return $9ed9a547f6786bdc$export$243e62d78d3b544d = v; });
$parcel$export(module.exports, "InteractionType", function () { return $9ed9a547f6786bdc$export$4ec29255e7e7f68f; }, function (v) { return $9ed9a547f6786bdc$export$4ec29255e7e7f68f = v; });
$parcel$export(module.exports, "AuthError", function () { return $9ed9a547f6786bdc$export$145273558d58e0ac; }, function (v) { return $9ed9a547f6786bdc$export$145273558d58e0ac = v; });
$parcel$export(module.exports, "BrowserUtils", function () { return $9ed9a547f6786bdc$export$311899ae85124b2d; }, function (v) { return $9ed9a547f6786bdc$export$311899ae85124b2d = v; });
$parcel$export(module.exports, "EventMessageUtils", function () { return $9ed9a547f6786bdc$export$ba9166e03da6599c; }, function (v) { return $9ed9a547f6786bdc$export$ba9166e03da6599c = v; });
$parcel$export(module.exports, "EventType", function () { return $9ed9a547f6786bdc$export$3d7865934588d77e; }, function (v) { return $9ed9a547f6786bdc$export$3d7865934588d77e = v; });
$parcel$export(module.exports, "InteractionRequiredAuthError", function () { return $9ed9a547f6786bdc$export$6ba3e818c6bc76ba; }, function (v) { return $9ed9a547f6786bdc$export$6ba3e818c6bc76ba = v; });
$parcel$export(module.exports, "InteractionStatus", function () { return $9ed9a547f6786bdc$export$bec20eda0179362b; }, function (v) { return $9ed9a547f6786bdc$export$bec20eda0179362b = v; });
$parcel$export(module.exports, "Logger", function () { return $9ed9a547f6786bdc$export$efa9a398d6368992; }, function (v) { return $9ed9a547f6786bdc$export$efa9a398d6368992 = v; });
$parcel$export(module.exports, "OIDC_DEFAULT_SCOPES", function () { return $9ed9a547f6786bdc$export$893b1b5b686d84ef; }, function (v) { return $9ed9a547f6786bdc$export$893b1b5b686d84ef = v; });
$parcel$export(module.exports, "PublicClientApplication", function () { return $9ed9a547f6786bdc$export$89f4855ef88b7920; }, function (v) { return $9ed9a547f6786bdc$export$89f4855ef88b7920 = v; });
$parcel$export(module.exports, "WrapperSKU", function () { return $9ed9a547f6786bdc$export$8abb9de997bb4e44; }, function (v) { return $9ed9a547f6786bdc$export$8abb9de997bb4e44 = v; });
$parcel$export(module.exports, "stubbedPublicClientApplication", function () { return $9ed9a547f6786bdc$export$29650b96fd06034a; }, function (v) { return $9ed9a547f6786bdc$export$29650b96fd06034a = v; });
/*! @azure/msal-browser v5.22.0 2026-09-15 */ /*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $9ed9a547f6786bdc$export$243e62d78d3b544d;
/*
 * Interaction type of the API - used for state and telemetry
 */ var $9ed9a547f6786bdc$export$4ec29255e7e7f68f;
var $9ed9a547f6786bdc$export$192d74ad69b40705;
var $9ed9a547f6786bdc$export$145273558d58e0ac;
var $9ed9a547f6786bdc$export$473ab0b56598aacd;
var $9ed9a547f6786bdc$export$46f6771f16bdfbc6;
var $9ed9a547f6786bdc$export$901491a717da2ba5;
var $9ed9a547f6786bdc$export$4cda21933050d9ec;
var $9ed9a547f6786bdc$export$f8eb6760ca13876a;
var $9ed9a547f6786bdc$export$a206205e46059d69;
var $9ed9a547f6786bdc$export$573384e47a12d835;
var $9ed9a547f6786bdc$export$2eb7a1dfdc4c5fba;
var $9ed9a547f6786bdc$export$5b6860c1e1ad8019;
var $9ed9a547f6786bdc$export$3714d85cfc8f4a02;
var $9ed9a547f6786bdc$export$f97b8b5459a3aa4;
var $9ed9a547f6786bdc$export$2ae77374159d4955;
var $9ed9a547f6786bdc$export$311899ae85124b2d;
var $9ed9a547f6786bdc$export$4394baa7e922d42d;
var $9ed9a547f6786bdc$export$a839ff85a7957561;
var $9ed9a547f6786bdc$export$dc9623d93fc077da;
var $9ed9a547f6786bdc$export$ac9d9d20c2327339;
var $9ed9a547f6786bdc$export$5fde068af21a5dfb;
var $9ed9a547f6786bdc$export$f3ffe700be354b19;
var $9ed9a547f6786bdc$export$ce0ba2422a1c7815;
var $9ed9a547f6786bdc$export$ba9166e03da6599c;
var $9ed9a547f6786bdc$export$3d7865934588d77e;
var $9ed9a547f6786bdc$export$6ba3e818c6bc76ba;
var $9ed9a547f6786bdc$export$ecddfe385fe09c26;
var $9ed9a547f6786bdc$export$bec20eda0179362b;
var $9ed9a547f6786bdc$export$fe5c42ed17efe603;
var $9ed9a547f6786bdc$export$19fffca37ef3e106;
var $9ed9a547f6786bdc$export$efa9a398d6368992;
var $9ed9a547f6786bdc$export$d7392285c701ecf5;
var $9ed9a547f6786bdc$export$d0d362a73d466c9b;
var $9ed9a547f6786bdc$export$893b1b5b686d84ef;
var $9ed9a547f6786bdc$export$49a06cbda5acaa5;
var $9ed9a547f6786bdc$export$73a3e3dedd37150d;
var $9ed9a547f6786bdc$export$89f4855ef88b7920;
var $9ed9a547f6786bdc$export$f990a5bae1260b8c;
var $9ed9a547f6786bdc$export$ea52035eac03daf0;
var $9ed9a547f6786bdc$export$2c4b17e1c2e0931;
var $9ed9a547f6786bdc$export$e1f04f41501741ea;
var $9ed9a547f6786bdc$export$c70f2989a65fda3e;
var $9ed9a547f6786bdc$export$8abb9de997bb4e44;
var $9ed9a547f6786bdc$export$210078d2745a65ac;
var $9ed9a547f6786bdc$export$f28b97cfb2f3098;
var $9ed9a547f6786bdc$export$df47a28b08fa2370;
var $9ed9a547f6786bdc$export$bce61db0d62ff8e2;
var $9ed9a547f6786bdc$export$267894f3740f96bf;
var $9ed9a547f6786bdc$export$29650b96fd06034a;
var $9ed9a547f6786bdc$export$83d89fbfd8236492;
'use strict';
'use strict';
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$CLIENT_ID = "client_id";
const $9ed9a547f6786bdc$var$REDIRECT_URI = "redirect_uri";
const $9ed9a547f6786bdc$var$RESPONSE_TYPE = "response_type";
const $9ed9a547f6786bdc$var$RESPONSE_MODE = "response_mode";
const $9ed9a547f6786bdc$var$GRANT_TYPE = "grant_type";
const $9ed9a547f6786bdc$var$CLAIMS = "claims";
const $9ed9a547f6786bdc$var$SCOPE = "scope";
const $9ed9a547f6786bdc$var$REFRESH_TOKEN = "refresh_token";
const $9ed9a547f6786bdc$var$STATE = "state";
const $9ed9a547f6786bdc$var$NONCE = "nonce";
const $9ed9a547f6786bdc$var$PROMPT = "prompt";
const $9ed9a547f6786bdc$var$CODE = "code";
const $9ed9a547f6786bdc$var$CODE_CHALLENGE = "code_challenge";
const $9ed9a547f6786bdc$var$CODE_CHALLENGE_METHOD = "code_challenge_method";
const $9ed9a547f6786bdc$var$CODE_VERIFIER = "code_verifier";
const $9ed9a547f6786bdc$var$CLIENT_REQUEST_ID = "client-request-id";
const $9ed9a547f6786bdc$var$X_CLIENT_SKU = "x-client-SKU";
const $9ed9a547f6786bdc$var$X_CLIENT_VER = "x-client-VER";
const $9ed9a547f6786bdc$var$X_CLIENT_OS = "x-client-OS";
const $9ed9a547f6786bdc$var$X_CLIENT_CPU = "x-client-CPU";
const $9ed9a547f6786bdc$var$X_CLIENT_CURR_TELEM = "x-client-current-telemetry";
const $9ed9a547f6786bdc$var$X_CLIENT_LAST_TELEM = "x-client-last-telemetry";
const $9ed9a547f6786bdc$var$X_MS_LIB_CAPABILITY = "x-ms-lib-capability";
const $9ed9a547f6786bdc$var$X_APP_NAME = "x-app-name";
const $9ed9a547f6786bdc$var$X_APP_VER = "x-app-ver";
const $9ed9a547f6786bdc$var$POST_LOGOUT_URI = "post_logout_redirect_uri";
const $9ed9a547f6786bdc$var$ID_TOKEN_HINT = "id_token_hint";
const $9ed9a547f6786bdc$var$CLIENT_SECRET = "client_secret";
const $9ed9a547f6786bdc$var$CLIENT_ASSERTION = "client_assertion";
const $9ed9a547f6786bdc$var$CLIENT_ASSERTION_TYPE = "client_assertion_type";
const $9ed9a547f6786bdc$var$TOKEN_TYPE = "token_type";
const $9ed9a547f6786bdc$var$REQ_CNF = "req_cnf";
const $9ed9a547f6786bdc$var$DPOP_JKT = "dpop_jkt";
const $9ed9a547f6786bdc$var$RETURN_SPA_CODE = "return_spa_code";
const $9ed9a547f6786bdc$var$NATIVE_BROKER = "nativebroker";
const $9ed9a547f6786bdc$var$LOGOUT_HINT = "logout_hint";
const $9ed9a547f6786bdc$var$SID = "sid";
const $9ed9a547f6786bdc$var$LOGIN_HINT = "login_hint";
const $9ed9a547f6786bdc$var$DOMAIN_HINT = "domain_hint";
const $9ed9a547f6786bdc$var$X_CLIENT_EXTRA_SKU = "x-client-xtra-sku";
const $9ed9a547f6786bdc$var$BROKER_CLIENT_ID = "brk_client_id";
const $9ed9a547f6786bdc$var$BROKER_REDIRECT_URI = "brk_redirect_uri";
const $9ed9a547f6786bdc$var$INSTANCE_AWARE = "instance_aware";
const $9ed9a547f6786bdc$var$EAR_JWK = "ear_jwk";
const $9ed9a547f6786bdc$var$EAR_JWE_CRYPTO = "ear_jwe_crypto";
const $9ed9a547f6786bdc$var$RESOURCE = "resource";
const $9ed9a547f6786bdc$var$CLI_DATA = "clidata";
const $9ed9a547f6786bdc$var$ATTRIBUTE_TOKENS = "attribute_tokens";
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$SKU = "msal.js.common";
// default authority
const $9ed9a547f6786bdc$var$DEFAULT_AUTHORITY = "https://login.microsoftonline.com/common/";
const $9ed9a547f6786bdc$var$DEFAULT_AUTHORITY_HOST = "login.microsoftonline.com";
const $9ed9a547f6786bdc$var$DEFAULT_COMMON_TENANT = "common";
// ADFS String
const $9ed9a547f6786bdc$var$ADFS = "adfs";
// Default AAD Instance Discovery Endpoint
const $9ed9a547f6786bdc$var$AAD_INSTANCE_DISCOVERY_ENDPT = `${$9ed9a547f6786bdc$var$DEFAULT_AUTHORITY}discovery/instance?api-version=1.1&authorization_endpoint=`;
// CIAM URL
const $9ed9a547f6786bdc$var$CIAM_AUTH_URL = ".ciamlogin.com";
const $9ed9a547f6786bdc$var$AAD_TENANT_DOMAIN_SUFFIX = ".onmicrosoft.com";
// Resource delimiter - used for certain cache entries
const $9ed9a547f6786bdc$var$RESOURCE_DELIM = "|";
// Default scopes
const $9ed9a547f6786bdc$var$OPENID_SCOPE = "openid";
const $9ed9a547f6786bdc$var$PROFILE_SCOPE = "profile";
const $9ed9a547f6786bdc$var$OFFLINE_ACCESS_SCOPE = "offline_access";
const $9ed9a547f6786bdc$var$EMAIL_SCOPE = "email";
const $9ed9a547f6786bdc$var$S256_CODE_CHALLENGE_METHOD = "S256";
const $9ed9a547f6786bdc$var$URL_FORM_CONTENT_TYPE = "application/x-www-form-urlencoded;charset=utf-8";
const $9ed9a547f6786bdc$var$NOT_APPLICABLE = "N/A";
const $9ed9a547f6786bdc$var$NOT_AVAILABLE = "Not Available";
const $9ed9a547f6786bdc$var$FORWARD_SLASH = "/";
const $9ed9a547f6786bdc$var$IMDS_ENDPOINT = "http://169.254.169.254/metadata/instance/compute";
const $9ed9a547f6786bdc$var$IMDS_VERSION = "2021-02-01";
const $9ed9a547f6786bdc$var$IMDS_TIMEOUT = 2000;
const $9ed9a547f6786bdc$var$AZURE_REGION_AUTO_DISCOVER_FLAG = "TryAutoDetect";
const $9ed9a547f6786bdc$var$REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX = "login.microsoft.com";
const $9ed9a547f6786bdc$var$KNOWN_PUBLIC_CLOUDS = [
    "login.microsoftonline.com",
    "login.windows.net",
    "login.microsoft.com",
    "sts.windows.net"
];
const $9ed9a547f6786bdc$var$SHR_NONCE_VALIDITY = 240;
const $9ed9a547f6786bdc$var$INVALID_INSTANCE = "invalid_instance";
const $9ed9a547f6786bdc$var$HTTP_SUCCESS = 200;
const $9ed9a547f6786bdc$var$HTTP_CLIENT_ERROR_RANGE_START = 400;
const $9ed9a547f6786bdc$var$HTTP_BAD_REQUEST = 400;
const $9ed9a547f6786bdc$var$HTTP_CLIENT_ERROR_RANGE_END = 499;
const $9ed9a547f6786bdc$var$HTTP_SERVER_ERROR_RANGE_START = 500;
const $9ed9a547f6786bdc$var$HTTP_SERVER_ERROR_RANGE_END = 599;
const $9ed9a547f6786bdc$var$HttpMethod = {
    GET: "GET",
    POST: "POST"
};
const $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1 = [
    $9ed9a547f6786bdc$var$OPENID_SCOPE,
    $9ed9a547f6786bdc$var$PROFILE_SCOPE,
    $9ed9a547f6786bdc$var$OFFLINE_ACCESS_SCOPE
];
const $9ed9a547f6786bdc$var$OIDC_SCOPES = [
    ...$9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1,
    $9ed9a547f6786bdc$var$EMAIL_SCOPE
];
/**
 * Request header names
 */ const $9ed9a547f6786bdc$var$HeaderNames = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    DPOP: "DPoP",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $9ed9a547f6786bdc$var$PersistentCacheKeys = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $9ed9a547f6786bdc$var$AADAuthority = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $9ed9a547f6786bdc$var$ClaimsRequestKeys = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc",
    ID_TOKEN: "id_token",
    SIGNIN_STATE: "signin_state",
    LOGIN_HINT: "login_hint",
    TENANT_REGION_SUB_SCOPE: "tenant_region_sub_scope"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $9ed9a547f6786bdc$var$PromptValue$1 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * Allowed values for response_type
 */ const $9ed9a547f6786bdc$var$OAuthResponseType = {
    CODE: "code",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for response_mode
 */ const $9ed9a547f6786bdc$var$ResponseMode$1 = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $9ed9a547f6786bdc$var$GrantType = {
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    REFRESH_TOKEN_GRANT: "refresh_token"
};
/**
 * Account types in Cache
 */ const $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_MSSTS = "MSSTS";
const $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_ADFS = "ADFS";
const $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_GENERIC = "Generic";
/**
 * Separators used in cache
 */ const $9ed9a547f6786bdc$var$CACHE_KEY_SEPARATOR$1 = "-";
const $9ed9a547f6786bdc$var$CLIENT_INFO_SEPARATOR = ".";
/**
 * Credential Type stored in the cache
 */ const $9ed9a547f6786bdc$var$CredentialType = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * More Cache related constants
 */ const $9ed9a547f6786bdc$var$APP_METADATA = "appmetadata";
const $9ed9a547f6786bdc$var$CLIENT_INFO = "client_info";
const $9ed9a547f6786bdc$var$THE_FAMILY_ID = "1";
const $9ed9a547f6786bdc$var$AUTHORITY_METADATA_CACHE_KEY = "authority-metadata";
const $9ed9a547f6786bdc$var$AUTHORITY_METADATA_REFRESH_TIME_SECONDS = 86400; // 24 Hours
const $9ed9a547f6786bdc$var$AuthorityMetadataSource = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $9ed9a547f6786bdc$var$SERVER_TELEM_SCHEMA_VERSION = 5;
const $9ed9a547f6786bdc$var$SERVER_TELEM_MAX_LAST_HEADER_BYTES = 330; // ESTS limit is 350B, set to 330 to provide a 20B buffer,
const $9ed9a547f6786bdc$var$SERVER_TELEM_MAX_CACHED_ERRORS = 50; // Limit the number of errors that can be stored to prevent uncontrolled size gains
const $9ed9a547f6786bdc$var$SERVER_TELEM_CACHE_KEY = "server-telemetry";
const $9ed9a547f6786bdc$var$SERVER_TELEM_CATEGORY_SEPARATOR = "|";
const $9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR = ",";
const $9ed9a547f6786bdc$var$SERVER_TELEM_OVERFLOW_TRUE = "1";
const $9ed9a547f6786bdc$var$SERVER_TELEM_OVERFLOW_FALSE = "0";
const $9ed9a547f6786bdc$var$SERVER_TELEM_UNKNOWN_ERROR = "unknown_error";
/**
 * Type of the authentication request
 */ const $9ed9a547f6786bdc$var$AuthenticationScheme$1 = {
    BEARER: "Bearer",
    POP: "pop",
    DPOP: "DPoP",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $9ed9a547f6786bdc$var$DEFAULT_THROTTLE_TIME_SECONDS = 60;
// Default maximum time to throttle in seconds, overrides what the server sends back
const $9ed9a547f6786bdc$var$DEFAULT_MAX_THROTTLE_TIME_SECONDS = 3600;
// Prefix for storing throttling entries
const $9ed9a547f6786bdc$var$THROTTLING_PREFIX = "throttling";
// Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
const $9ed9a547f6786bdc$var$X_MS_LIB_CAPABILITY_VALUE = "retry-after, h429";
/**
 * Errors
 */ const $9ed9a547f6786bdc$var$INVALID_GRANT_ERROR = "invalid_grant";
const $9ed9a547f6786bdc$var$CLIENT_MISMATCH_ERROR = "client_mismatch";
/**
 * Region Discovery Sources
 */ const $9ed9a547f6786bdc$var$RegionDiscoverySources = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $9ed9a547f6786bdc$var$RegionDiscoveryOutcomes = {
    CONFIGURED_NO_AUTO_DETECTION: "2",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $9ed9a547f6786bdc$var$CacheOutcome = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $9ed9a547f6786bdc$var$JsonWebTokenTypes$1 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop",
    Dpop: "dpop+jwt"
};
// Token renewal offset default in seconds
const $9ed9a547f6786bdc$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$getDefaultErrorMessage$1(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * General error class thrown by the MSAL.js library.
 */ class $9ed9a547f6786bdc$var$AuthError extends Error {
    constructor(errorCode, correlationId, errorMessage, suberror){
        const message = errorMessage || (errorCode ? $9ed9a547f6786bdc$var$getDefaultErrorMessage$1(errorCode) : "");
        const errorString = message ? `${errorCode}: ${message}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$AuthError.prototype);
        this.errorCode = errorCode || "";
        this.errorMessage = message || "";
        this.subError = suberror || "";
        this.correlationId = correlationId;
        this.name = "AuthError";
    }
}
function $9ed9a547f6786bdc$var$createAuthError(code, correlationId, additionalMessage) {
    return new $9ed9a547f6786bdc$var$AuthError(code, correlationId, additionalMessage || $9ed9a547f6786bdc$var$getDefaultErrorMessage$1(code));
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $9ed9a547f6786bdc$var$ClientAuthError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, additionalMessage){
        super(errorCode, correlationId, additionalMessage);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$ClientAuthError.prototype);
    }
}
function $9ed9a547f6786bdc$var$createClientAuthError(errorCode, correlationId, additionalMessage) {
    return new $9ed9a547f6786bdc$var$ClientAuthError(errorCode, correlationId, additionalMessage);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$clientInfoDecodingError = "client_info_decoding_error";
const $9ed9a547f6786bdc$var$clientInfoEmptyError = "client_info_empty_error";
const $9ed9a547f6786bdc$var$tokenParsingError = "token_parsing_error";
const $9ed9a547f6786bdc$var$nullOrEmptyToken = "null_or_empty_token";
const $9ed9a547f6786bdc$var$endpointResolutionError = "endpoints_resolution_error";
const $9ed9a547f6786bdc$var$networkError = "network_error";
const $9ed9a547f6786bdc$var$openIdConfigError = "openid_config_error";
const $9ed9a547f6786bdc$var$hashNotDeserialized = "hash_not_deserialized";
const $9ed9a547f6786bdc$var$invalidState = "invalid_state";
const $9ed9a547f6786bdc$var$stateMismatch = "state_mismatch";
const $9ed9a547f6786bdc$var$stateNotFound = "state_not_found";
const $9ed9a547f6786bdc$var$nonceMismatch = "nonce_mismatch";
const $9ed9a547f6786bdc$var$multipleMatchingTokens = "multiple_matching_tokens";
const $9ed9a547f6786bdc$var$multipleMatchingAppMetadata = "multiple_matching_appMetadata";
const $9ed9a547f6786bdc$var$requestCannotBeMade = "request_cannot_be_made";
const $9ed9a547f6786bdc$var$cannotRemoveEmptyScope = "cannot_remove_empty_scope";
const $9ed9a547f6786bdc$var$cannotAppendScopeSet = "cannot_append_scopeset";
const $9ed9a547f6786bdc$var$emptyInputScopeSet = "empty_input_scopeset";
const $9ed9a547f6786bdc$var$noAccountInSilentRequest = "no_account_in_silent_request";
const $9ed9a547f6786bdc$var$invalidCacheRecord = "invalid_cache_record";
const $9ed9a547f6786bdc$var$invalidCacheEnvironment = "invalid_cache_environment";
const $9ed9a547f6786bdc$var$noAccountFound = "no_account_found";
const $9ed9a547f6786bdc$var$noCryptoObject = "no_crypto_object";
const $9ed9a547f6786bdc$var$unexpectedCredentialType = "unexpected_credential_type";
const $9ed9a547f6786bdc$var$dpopTokenTypeMismatch = "dpop_token_type_mismatch";
const $9ed9a547f6786bdc$var$tokenRefreshRequired = "token_refresh_required";
const $9ed9a547f6786bdc$var$tokenClaimsCnfRequiredForSignedJwt = "token_claims_cnf_required_for_signedjwt";
const $9ed9a547f6786bdc$var$authorizationCodeMissingFromServerResponse = "authorization_code_missing_from_server_response";
const $9ed9a547f6786bdc$var$bindingKeyNotRemoved = "binding_key_not_removed";
const $9ed9a547f6786bdc$var$endSessionEndpointNotSupported = "end_session_endpoint_not_supported";
const $9ed9a547f6786bdc$var$keyIdMissing = "key_id_missing";
const $9ed9a547f6786bdc$var$noNetworkConnectivity$1 = "no_network_connectivity";
const $9ed9a547f6786bdc$var$userCanceled = "user_canceled";
const $9ed9a547f6786bdc$var$methodNotImplemented = "method_not_implemented";
const $9ed9a547f6786bdc$var$nestedAppAuthBridgeDisabled = "nested_app_auth_bridge_disabled";
const $9ed9a547f6786bdc$var$platformBrokerError = "platform_broker_error";
const $9ed9a547f6786bdc$var$resourceParameterRequired = "resource_parameter_required";
const $9ed9a547f6786bdc$var$misplacedResourceParam = "misplaced_resource_parameter";
var $9ed9a547f6786bdc$var$ClientAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    authorizationCodeMissingFromServerResponse: $9ed9a547f6786bdc$var$authorizationCodeMissingFromServerResponse,
    bindingKeyNotRemoved: $9ed9a547f6786bdc$var$bindingKeyNotRemoved,
    cannotAppendScopeSet: $9ed9a547f6786bdc$var$cannotAppendScopeSet,
    cannotRemoveEmptyScope: $9ed9a547f6786bdc$var$cannotRemoveEmptyScope,
    clientInfoDecodingError: $9ed9a547f6786bdc$var$clientInfoDecodingError,
    clientInfoEmptyError: $9ed9a547f6786bdc$var$clientInfoEmptyError,
    dpopTokenTypeMismatch: $9ed9a547f6786bdc$var$dpopTokenTypeMismatch,
    emptyInputScopeSet: $9ed9a547f6786bdc$var$emptyInputScopeSet,
    endSessionEndpointNotSupported: $9ed9a547f6786bdc$var$endSessionEndpointNotSupported,
    endpointResolutionError: $9ed9a547f6786bdc$var$endpointResolutionError,
    hashNotDeserialized: $9ed9a547f6786bdc$var$hashNotDeserialized,
    invalidCacheEnvironment: $9ed9a547f6786bdc$var$invalidCacheEnvironment,
    invalidCacheRecord: $9ed9a547f6786bdc$var$invalidCacheRecord,
    invalidState: $9ed9a547f6786bdc$var$invalidState,
    keyIdMissing: $9ed9a547f6786bdc$var$keyIdMissing,
    methodNotImplemented: $9ed9a547f6786bdc$var$methodNotImplemented,
    misplacedResourceParam: $9ed9a547f6786bdc$var$misplacedResourceParam,
    multipleMatchingAppMetadata: $9ed9a547f6786bdc$var$multipleMatchingAppMetadata,
    multipleMatchingTokens: $9ed9a547f6786bdc$var$multipleMatchingTokens,
    nestedAppAuthBridgeDisabled: $9ed9a547f6786bdc$var$nestedAppAuthBridgeDisabled,
    networkError: $9ed9a547f6786bdc$var$networkError,
    noAccountFound: $9ed9a547f6786bdc$var$noAccountFound,
    noAccountInSilentRequest: $9ed9a547f6786bdc$var$noAccountInSilentRequest,
    noCryptoObject: $9ed9a547f6786bdc$var$noCryptoObject,
    noNetworkConnectivity: $9ed9a547f6786bdc$var$noNetworkConnectivity$1,
    nonceMismatch: $9ed9a547f6786bdc$var$nonceMismatch,
    nullOrEmptyToken: $9ed9a547f6786bdc$var$nullOrEmptyToken,
    openIdConfigError: $9ed9a547f6786bdc$var$openIdConfigError,
    platformBrokerError: $9ed9a547f6786bdc$var$platformBrokerError,
    requestCannotBeMade: $9ed9a547f6786bdc$var$requestCannotBeMade,
    resourceParameterRequired: $9ed9a547f6786bdc$var$resourceParameterRequired,
    stateMismatch: $9ed9a547f6786bdc$var$stateMismatch,
    stateNotFound: $9ed9a547f6786bdc$var$stateNotFound,
    tokenClaimsCnfRequiredForSignedJwt: $9ed9a547f6786bdc$var$tokenClaimsCnfRequiredForSignedJwt,
    tokenParsingError: $9ed9a547f6786bdc$var$tokenParsingError,
    tokenRefreshRequired: $9ed9a547f6786bdc$var$tokenRefreshRequired,
    unexpectedCredentialType: $9ed9a547f6786bdc$var$unexpectedCredentialType,
    userCanceled: $9ed9a547f6786bdc$var$userCanceled
});
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $9ed9a547f6786bdc$var$buildClientInfo(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$clientInfoEmptyError, "");
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$clientInfoDecodingError, "");
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(homeAccountId) {
    if (!homeAccountId) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$clientInfoDecodingError, "");
    const clientInfoParts = homeAccountId.split($9ed9a547f6786bdc$var$CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? "" : clientInfoParts[1]
    };
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $9ed9a547f6786bdc$var$extractTokenClaims(encodedToken, base64Decode, correlationId) {
    const jswPayload = $9ed9a547f6786bdc$var$getJWSPayload(encodedToken, correlationId);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenParsingError, correlationId);
    }
}
/**
 * Check if the signin_state claim contains "kmsi"
 * @param idTokenClaims
 * @returns
 */ function $9ed9a547f6786bdc$var$isKmsi(idTokenClaims) {
    if (!idTokenClaims.signin_state) return false;
    /**
     * Signin_state claim known values:
     * dvc_mngd - device is managed
     * dvc_dmjd - device is domain joined
     * kmsi - user opted to "keep me signed in"
     * inknownntwk - Request made inside a known network. Don't use this, use CAE instead.
     */ const kmsiClaims = [
        "kmsi",
        "dvc_dmjd"
    ]; // There are some cases where kmsi may not be returned but persistent storage is still OK - allow dvc_dmjd as well
    return idTokenClaims.signin_state.some((value)=>kmsiClaims.includes(value.trim().toLowerCase()));
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $9ed9a547f6786bdc$var$getJWSPayload(authToken, correlationId) {
    if (!authToken) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$nullOrEmptyToken, correlationId);
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenParsingError, correlationId);
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $9ed9a547f6786bdc$var$tenantIdMatchesHomeTenant(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param nativeAccountId - Native account identifier for this tenant
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $9ed9a547f6786bdc$var$buildTenantProfile(homeAccountId, localAccountId, tenantId, nativeAccountId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr, preferred_username: preferred_username, upn: upn, login_hint: login_hint } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            username: preferred_username || upn || "",
            loginHint: login_hint,
            isHomeTenant: $9ed9a547f6786bdc$var$tenantIdMatchesHomeTenant(tenantId, homeAccountId),
            upn: upn,
            ...nativeAccountId && {
                nativeAccountId: nativeAccountId
            }
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        username: "",
        isHomeTenant: $9ed9a547f6786bdc$var$tenantIdMatchesHomeTenant(tenantId, homeAccountId),
        ...nativeAccountId && {
            nativeAccountId: nativeAccountId
        }
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $9ed9a547f6786bdc$var$updateAccountTenantProfileData(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant which is a utility property of tenant profile but not required in base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $9ed9a547f6786bdc$var$buildTenantProfile(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, updatedAccountInfo.nativeAccountId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret,
            kmsi: $9ed9a547f6786bdc$var$isKmsi(idTokenClaims)
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $9ed9a547f6786bdc$var$AuthorityType = {
    Default: 0,
    Adfs: 1,
    Ciam: 3
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $9ed9a547f6786bdc$var$getTenantIdFromIdTokenClaims(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $9ed9a547f6786bdc$var$ProtocolMode = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /**
 * Returns the AccountInfo interface for this account.
 * @internal
 */ function $9ed9a547f6786bdc$var$getAccountInfo(accountEntity) {
    const tenantProfiles = accountEntity.tenantProfiles || [];
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountEntity.realm && accountEntity.localAccountId) tenantProfiles.push($9ed9a547f6786bdc$var$buildTenantProfile(accountEntity.homeAccountId, accountEntity.localAccountId, accountEntity.realm, accountEntity.nativeAccountId));
    // Resolve nativeAccountId from the home tenant profile first, fall back to top-level (deprecated) for old cache entries
    const homeTenantProfile = tenantProfiles.find((tp)=>tp.tenantId === accountEntity.realm);
    const nativeAccountId = homeTenantProfile?.nativeAccountId || accountEntity.nativeAccountId;
    return {
        homeAccountId: accountEntity.homeAccountId,
        environment: accountEntity.environment,
        tenantId: accountEntity.realm,
        username: accountEntity.username,
        localAccountId: accountEntity.localAccountId,
        loginHint: accountEntity.loginHint,
        name: accountEntity.name,
        nativeAccountId: nativeAccountId,
        authorityType: accountEntity.authorityType,
        // Deserialize tenant profiles array into a Map
        tenantProfiles: new Map(tenantProfiles.map((tenantProfile)=>{
            return [
                tenantProfile.tenantId,
                tenantProfile
            ];
        })),
        dataBoundary: accountEntity.dataBoundary
    };
}
/**
 * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
 * @param accountDetails
 * @internal
 */ function $9ed9a547f6786bdc$var$createAccountEntity(accountDetails, authority, correlationId, base64Decode) {
    let authorityType;
    if (authority.authorityType === $9ed9a547f6786bdc$var$AuthorityType.Adfs) authorityType = $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_ADFS;
    else if (authority.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.OIDC) authorityType = $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_GENERIC;
    else authorityType = $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_MSSTS;
    let clientInfo;
    let dataBoundary;
    if (accountDetails.clientInfo && base64Decode) {
        clientInfo = $9ed9a547f6786bdc$var$buildClientInfo(accountDetails.clientInfo, base64Decode);
        if (clientInfo.xms_tdbr) dataBoundary = clientInfo.xms_tdbr === "EU" ? "EU" : "None";
    }
    const env = accountDetails.environment || authority && authority.getPreferredCache();
    if (!env) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidCacheEnvironment, correlationId);
    /*
     * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
     * In most cases it will contain a single email. This field should not be relied upon if a custom
     * policy is configured to return more than 1 email.
     */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
    const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
    const username = preferredUsername || email || "";
    const loginHint = accountDetails.idTokenClaims?.login_hint;
    const realm = clientInfo?.utid || $9ed9a547f6786bdc$var$getTenantIdFromIdTokenClaims(accountDetails.idTokenClaims) || ""; // non-AAD scenarios can have empty realm
    // How do you account for MSA CID here?
    const localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
    let tenantProfiles;
    if (accountDetails.tenantProfiles) tenantProfiles = accountDetails.tenantProfiles;
    else {
        const tenantProfile = $9ed9a547f6786bdc$var$buildTenantProfile(accountDetails.homeAccountId, localAccountId, realm, accountDetails.nativeAccountId, accountDetails.idTokenClaims);
        tenantProfiles = [
            tenantProfile
        ];
    }
    return {
        homeAccountId: accountDetails.homeAccountId,
        environment: env,
        realm: realm,
        localAccountId: localAccountId,
        username: username,
        authorityType: authorityType,
        loginHint: loginHint,
        clientInfo: accountDetails.clientInfo,
        name: accountDetails.idTokenClaims?.name || "",
        lastModificationTime: undefined,
        lastModificationApp: undefined,
        cloudGraphHostName: accountDetails.cloudGraphHostName,
        msGraphHost: accountDetails.msGraphHost,
        nativeAccountId: accountDetails.nativeAccountId,
        tenantProfiles: tenantProfiles,
        dataBoundary: dataBoundary
    };
}
/**
 * Creates an AccountEntity object from AccountInfo
 * @param accountInfo
 * @param cloudGraphHostName
 * @param msGraphHost
 * @returns
 * @internal
 */ function $9ed9a547f6786bdc$var$createAccountEntityFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
    // Serialize tenant profiles map into an array
    const tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountInfo.tenantId && accountInfo.localAccountId) tenantProfiles.push($9ed9a547f6786bdc$var$buildTenantProfile(accountInfo.homeAccountId, accountInfo.localAccountId, accountInfo.tenantId, accountInfo.nativeAccountId, accountInfo.idTokenClaims));
    else if (accountInfo.nativeAccountId) {
        // Ensure nativeAccountId is set on the matching tenant profile
        const matchingProfile = tenantProfiles.find((tp)=>tp.tenantId === accountInfo.tenantId);
        if (matchingProfile && !matchingProfile.nativeAccountId) matchingProfile.nativeAccountId = accountInfo.nativeAccountId;
    }
    return {
        authorityType: accountInfo.authorityType || $9ed9a547f6786bdc$var$CACHE_ACCOUNT_TYPE_GENERIC,
        homeAccountId: accountInfo.homeAccountId,
        localAccountId: accountInfo.localAccountId,
        nativeAccountId: accountInfo.nativeAccountId,
        realm: accountInfo.tenantId,
        environment: accountInfo.environment,
        username: accountInfo.username,
        loginHint: accountInfo.loginHint,
        name: accountInfo.name,
        cloudGraphHostName: cloudGraphHostName,
        msGraphHost: msGraphHost,
        tenantProfiles: tenantProfiles,
        dataBoundary: accountInfo.dataBoundary
    };
}
/**
 * Generate HomeAccountId from server response
 * @param serverClientInfo
 * @param authType
 */ function $9ed9a547f6786bdc$var$generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, correlationId, idTokenClaims) {
    // ADFS does not have tid and does not set client_info
    if (authType !== $9ed9a547f6786bdc$var$AuthorityType.Adfs) {
        // for cases where there is clientInfo
        if (serverClientInfo) try {
            const clientInfo = $9ed9a547f6786bdc$var$buildClientInfo(serverClientInfo, cryptoObj.base64Decode);
            if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
        } catch (e) {}
        logger.warning("1ub6wv", correlationId);
    }
    // default to "sub" claim
    return idTokenClaims?.sub || "";
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 * @internal
 */ function $9ed9a547f6786bdc$var$isAccountEntity(entity) {
    if (!entity) return false;
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $9ed9a547f6786bdc$var$unexpectedError = "unexpected_error";
const $9ed9a547f6786bdc$var$postRequestFailed$1 = "post_request_failed";
var $9ed9a547f6786bdc$var$AuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    postRequestFailed: $9ed9a547f6786bdc$var$postRequestFailed$1,
    unexpectedError: $9ed9a547f6786bdc$var$unexpectedError
});
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $9ed9a547f6786bdc$var$ClientConfigurationError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId){
        super(errorCode, correlationId);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$ClientConfigurationError.prototype);
    }
}
function $9ed9a547f6786bdc$var$createClientConfigurationError(errorCode, correlationId) {
    return new $9ed9a547f6786bdc$var$ClientConfigurationError(errorCode, correlationId);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$redirectUriEmpty = "redirect_uri_empty";
const $9ed9a547f6786bdc$var$claimsRequestParsingError = "claims_request_parsing_error";
const $9ed9a547f6786bdc$var$authorityUriInsecure = "authority_uri_insecure";
const $9ed9a547f6786bdc$var$urlParseError = "url_parse_error";
const $9ed9a547f6786bdc$var$urlEmptyError = "empty_url_error";
const $9ed9a547f6786bdc$var$emptyInputScopesError = "empty_input_scopes_error";
const $9ed9a547f6786bdc$var$invalidClaims = "invalid_claims";
const $9ed9a547f6786bdc$var$tokenRequestEmpty = "token_request_empty";
const $9ed9a547f6786bdc$var$logoutRequestEmpty = "logout_request_empty";
const $9ed9a547f6786bdc$var$invalidCodeChallengeMethod = "invalid_code_challenge_method";
const $9ed9a547f6786bdc$var$pkceParamsMissing = "pkce_params_missing";
const $9ed9a547f6786bdc$var$invalidCloudDiscoveryMetadata = "invalid_cloud_discovery_metadata";
const $9ed9a547f6786bdc$var$invalidAuthorityMetadata = "invalid_authority_metadata";
const $9ed9a547f6786bdc$var$untrustedAuthority = "untrusted_authority";
const $9ed9a547f6786bdc$var$missingSshJwk = "missing_ssh_jwk";
const $9ed9a547f6786bdc$var$missingSshKid = "missing_ssh_kid";
const $9ed9a547f6786bdc$var$unsupportedAuthenticationScheme = "unsupported_authentication_scheme";
const $9ed9a547f6786bdc$var$missingNonceAuthenticationHeader = "missing_nonce_authentication_header";
const $9ed9a547f6786bdc$var$invalidAuthenticationHeader = "invalid_authentication_header";
const $9ed9a547f6786bdc$var$cannotSetOIDCOptions = "cannot_set_OIDCOptions";
const $9ed9a547f6786bdc$var$cannotAllowPlatformBroker = "cannot_allow_platform_broker";
const $9ed9a547f6786bdc$var$authorityMismatch = "authority_mismatch";
const $9ed9a547f6786bdc$var$invalidRequestMethodForEAR = "invalid_request_method_for_EAR";
const $9ed9a547f6786bdc$var$invalidPlatformBrokerConfiguration = "invalid_platform_broker_configuration";
const $9ed9a547f6786bdc$var$issuerValidationFailed = "issuer_validation_failed";
const $9ed9a547f6786bdc$var$invalidResponseMode = "invalid_response_mode";
const $9ed9a547f6786bdc$var$invalidDpopHtm = "invalid_dpop_htm";
const $9ed9a547f6786bdc$var$invalidDpopHtu = "invalid_dpop_htu";
const $9ed9a547f6786bdc$var$invalidDpopNonce = "invalid_dpop_nonce";
const $9ed9a547f6786bdc$var$dpopMissingResourceContext = "dpop_missing_resource_context";
var $9ed9a547f6786bdc$var$ClientConfigurationErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    authorityMismatch: $9ed9a547f6786bdc$var$authorityMismatch,
    authorityUriInsecure: $9ed9a547f6786bdc$var$authorityUriInsecure,
    cannotAllowPlatformBroker: $9ed9a547f6786bdc$var$cannotAllowPlatformBroker,
    cannotSetOIDCOptions: $9ed9a547f6786bdc$var$cannotSetOIDCOptions,
    claimsRequestParsingError: $9ed9a547f6786bdc$var$claimsRequestParsingError,
    dpopMissingResourceContext: $9ed9a547f6786bdc$var$dpopMissingResourceContext,
    emptyInputScopesError: $9ed9a547f6786bdc$var$emptyInputScopesError,
    invalidAuthenticationHeader: $9ed9a547f6786bdc$var$invalidAuthenticationHeader,
    invalidAuthorityMetadata: $9ed9a547f6786bdc$var$invalidAuthorityMetadata,
    invalidClaims: $9ed9a547f6786bdc$var$invalidClaims,
    invalidCloudDiscoveryMetadata: $9ed9a547f6786bdc$var$invalidCloudDiscoveryMetadata,
    invalidCodeChallengeMethod: $9ed9a547f6786bdc$var$invalidCodeChallengeMethod,
    invalidDpopHtm: $9ed9a547f6786bdc$var$invalidDpopHtm,
    invalidDpopHtu: $9ed9a547f6786bdc$var$invalidDpopHtu,
    invalidDpopNonce: $9ed9a547f6786bdc$var$invalidDpopNonce,
    invalidPlatformBrokerConfiguration: $9ed9a547f6786bdc$var$invalidPlatformBrokerConfiguration,
    invalidRequestMethodForEAR: $9ed9a547f6786bdc$var$invalidRequestMethodForEAR,
    invalidResponseMode: $9ed9a547f6786bdc$var$invalidResponseMode,
    issuerValidationFailed: $9ed9a547f6786bdc$var$issuerValidationFailed,
    logoutRequestEmpty: $9ed9a547f6786bdc$var$logoutRequestEmpty,
    missingNonceAuthenticationHeader: $9ed9a547f6786bdc$var$missingNonceAuthenticationHeader,
    missingSshJwk: $9ed9a547f6786bdc$var$missingSshJwk,
    missingSshKid: $9ed9a547f6786bdc$var$missingSshKid,
    pkceParamsMissing: $9ed9a547f6786bdc$var$pkceParamsMissing,
    redirectUriEmpty: $9ed9a547f6786bdc$var$redirectUriEmpty,
    tokenRequestEmpty: $9ed9a547f6786bdc$var$tokenRequestEmpty,
    unsupportedAuthenticationScheme: $9ed9a547f6786bdc$var$unsupportedAuthenticationScheme,
    untrustedAuthority: $9ed9a547f6786bdc$var$untrustedAuthority,
    urlEmptyError: $9ed9a547f6786bdc$var$urlEmptyError,
    urlParseError: $9ed9a547f6786bdc$var$urlParseError
});
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This is a helper class that parses supported HTTP response authentication headers to extract and return
 * header challenge values that can be used outside the basic authorization flows.
 */ class $9ed9a547f6786bdc$var$AuthenticationHeaderParser {
    constructor(headers){
        this.headers = headers;
    }
    /**
     * This method parses the SHR nonce value out of either the Authentication-Info or WWW-Authenticate authentication headers.
     * @returns
     */ getShrNonce() {
        // Attempt to parse nonce from Authentiacation-Info
        const authenticationInfo = this.headers[$9ed9a547f6786bdc$var$HeaderNames.AuthenticationInfo];
        if (authenticationInfo) {
            const authenticationInfoChallenges = this.parseChallenges(authenticationInfo);
            if (authenticationInfoChallenges.nextnonce) return authenticationInfoChallenges.nextnonce;
            throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidAuthenticationHeader, "");
        }
        // Attempt to parse nonce from WWW-Authenticate
        const wwwAuthenticate = this.headers[$9ed9a547f6786bdc$var$HeaderNames.WWWAuthenticate];
        if (wwwAuthenticate) {
            const wwwAuthenticateChallenges = this.parseChallenges(wwwAuthenticate);
            if (wwwAuthenticateChallenges.nonce) return wwwAuthenticateChallenges.nonce;
            throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidAuthenticationHeader, "");
        }
        // If neither header is present, throw missing headers error
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$missingNonceAuthenticationHeader, "");
    }
    /**
     * Parses an HTTP header's challenge set into a key/value map.
     * @param header
     * @returns
     */ parseChallenges(header) {
        const schemeSeparator = header.indexOf(" ");
        const challenges = header.substr(schemeSeparator + 1).split(",");
        const challengeMap = {};
        challenges.forEach((challenge)=>{
            const [key, value] = challenge.split("=");
            // Remove escaped quotation marks (', ") from challenge string to keep only the challenge value
            challengeMap[key] = unescape(value.replace(/['"]+/g, ""));
        });
        return challengeMap;
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$isOpenIdConfigResponse(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $9ed9a547f6786bdc$var$StringUtils {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $9ed9a547f6786bdc$var$UrlString {
    get urlString() {
        return this._urlString;
    }
    constructor(url, correlationId){
        this._urlString = url;
        this.correlationId = correlationId;
        if (!this._urlString) // Throws error if url is empty
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlEmptyError, correlationId);
        if (!url.includes("#")) this._urlString = $9ed9a547f6786bdc$var$UrlString.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ($9ed9a547f6786bdc$var$StringUtils.endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ($9ed9a547f6786bdc$var$StringUtils.endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!$9ed9a547f6786bdc$var$StringUtils.endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, this.correlationId);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, this.correlationId);
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$authorityUriInsecure, this.correlationId);
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $9ed9a547f6786bdc$var$UrlString.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === $9ed9a547f6786bdc$var$AADAuthority.COMMON || pathArray[0] === $9ed9a547f6786bdc$var$AADAuthority.ORGANIZATIONS)) pathArray[0] = tenantId;
        return $9ed9a547f6786bdc$var$UrlString.constructAuthorityUriFromObject(urlObject, this.correlationId);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, this.correlationId);
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url, correlationId) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, correlationId);
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl, correlationId) {
        if (relativeUrl[0] === $9ed9a547f6786bdc$var$FORWARD_SLASH) {
            const url = new $9ed9a547f6786bdc$var$UrlString(baseUrl, correlationId);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject, correlationId) {
        return new $9ed9a547f6786bdc$var$UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"), correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Build endpoint metadata dynamically to avoid string duplication
const $9ed9a547f6786bdc$var$endpointHosts = [
    {
        host: "login.microsoftonline.com"
    },
    {
        host: "login.partner.microsoftonline.cn"
    },
    {
        host: "login.microsoftonline.us"
    },
    {
        host: "login.sovcloud-identity.fr"
    },
    {
        host: "login.sovcloud-identity.de"
    },
    {
        host: "login.sovcloud-identity.sg"
    }
];
function $9ed9a547f6786bdc$var$buildOpenIdConfig(host, issuerHost) {
    return {
        token_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/token`,
        jwks_uri: `https://${host}/{tenantid}/discovery/v2.0/keys`,
        issuer: `https://${issuerHost}/{tenantid}/v2.0`,
        authorization_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/authorize`,
        end_session_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/logout`
    };
}
const $9ed9a547f6786bdc$var$dynamicEndpointMetadata = $9ed9a547f6786bdc$var$endpointHosts.reduce((acc, { host: host, issuerHost: issuerHost })=>{
    acc[host] = $9ed9a547f6786bdc$var$buildOpenIdConfig(host, issuerHost || host);
    return acc;
}, {});
const $9ed9a547f6786bdc$var$rawMetdataJSON = {
    endpointMetadata: $9ed9a547f6786bdc$var$dynamicEndpointMetadata,
    instanceDiscoveryMetadata: {
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.fr",
                preferred_cache: "login.sovcloud-identity.fr",
                aliases: [
                    "login.sovcloud-identity.fr"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.de",
                preferred_cache: "login.sovcloud-identity.de",
                aliases: [
                    "login.sovcloud-identity.de"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.sg",
                preferred_cache: "login.sovcloud-identity.sg",
                aliases: [
                    "login.sovcloud-identity.sg"
                ]
            }
        ]
    }
};
const $9ed9a547f6786bdc$var$EndpointMetadata = $9ed9a547f6786bdc$var$rawMetdataJSON.endpointMetadata;
const $9ed9a547f6786bdc$var$InstanceDiscoveryMetadata = $9ed9a547f6786bdc$var$rawMetdataJSON.instanceDiscoveryMetadata;
const $9ed9a547f6786bdc$var$InstanceDiscoveryMetadataAliases = new Set();
$9ed9a547f6786bdc$var$InstanceDiscoveryMetadata.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $9ed9a547f6786bdc$var$InstanceDiscoveryMetadataAliases.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $9ed9a547f6786bdc$var$getAliasesFromStaticSources(staticAuthorityOptions, logger, correlationId) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new $9ed9a547f6786bdc$var$UrlString(canonicalAuthority, correlationId).getUrlComponents().HostNameAndPort;
        staticAliases = $9ed9a547f6786bdc$var$getAliasesFromMetadata(logger, correlationId, authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, $9ed9a547f6786bdc$var$AuthorityMetadataSource.CONFIG) || $9ed9a547f6786bdc$var$getAliasesFromMetadata(logger, correlationId, authorityHost, $9ed9a547f6786bdc$var$InstanceDiscoveryMetadata.metadata, $9ed9a547f6786bdc$var$AuthorityMetadataSource.HARDCODED_VALUES) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $9ed9a547f6786bdc$var$getAliasesFromMetadata(logger, correlationId, authorityHost, cloudDiscoveryMetadata, source) {
    logger.trace(`1bmquz ${source}`, correlationId);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromNetworkResponse(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger.trace(`1fotbt ${source}`, correlationId);
            return metadata.aliases;
        } else logger.trace(`14avvj ${source}`, correlationId);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromHardcodedValues(authorityHost) {
    const metadata = $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromNetworkResponse($9ed9a547f6786bdc$var$InstanceDiscoveryMetadata.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromNetworkResponse(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$AzureCloudInstance = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$isCloudInstanceDiscoveryResponse(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$isCloudInstanceDiscoveryErrorResponse(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Time spent sending/waiting for the response of a request to the token endpoint
 */ const $9ed9a547f6786bdc$var$NetworkClientSendPostRequestAsync = "networkClientSendPostRequestAsync";
const $9ed9a547f6786bdc$var$RefreshTokenClientExecutePostToTokenEndpoint = "refreshTokenClientExecutePostToTokenEndpoint";
const $9ed9a547f6786bdc$var$AuthorizationCodeClientExecutePostToTokenEndpoint = "authorizationCodeClientExecutePostToTokenEndpoint";
/**
 * Time spent on the network for refresh token acquisition
 */ const $9ed9a547f6786bdc$var$RefreshTokenClientExecuteTokenRequest = "refreshTokenClientExecuteTokenRequest";
/**
 * Time taken for acquiring refresh token , records RT size
 */ const $9ed9a547f6786bdc$var$RefreshTokenClientAcquireToken = "refreshTokenClientAcquireToken";
/**
 * Time taken for acquiring cached refresh token
 */ const $9ed9a547f6786bdc$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
/**
 * Helper function to create token request body in RefreshTokenClient (msal-common).
 */ const $9ed9a547f6786bdc$var$RefreshTokenClientCreateTokenRequestBody = "refreshTokenClientCreateTokenRequestBody";
const $9ed9a547f6786bdc$var$SilentFlowClientGenerateResultFromCacheRecord = "silentFlowClientGenerateResultFromCacheRecord";
/**
 * getAuthCodeUrl API (msal-browser and msal-node).
 */ const $9ed9a547f6786bdc$var$GetAuthCodeUrl = "getAuthCodeUrl";
/**
 * Functions from InteractionHandler (msal-browser)
 */ const $9ed9a547f6786bdc$var$HandleCodeResponseFromServer = "handleCodeResponseFromServer";
/**
 * APIs in Authorization Code Client (msal-common)
 */ const $9ed9a547f6786bdc$var$AuthClientExecuteTokenRequest = "authClientExecuteTokenRequest";
const $9ed9a547f6786bdc$var$AuthClientCreateTokenRequestBody = "authClientCreateTokenRequestBody";
const $9ed9a547f6786bdc$var$UpdateTokenEndpointAuthority = "updateTokenEndpointAuthority";
/**
 * Generate functions in PopTokenGenerator (msal-common)
 */ const $9ed9a547f6786bdc$var$PopTokenGenerateCnf = "popTokenGenerateCnf";
/**
 * handleServerTokenResponse API in ResponseHandler (msal-common)
 */ const $9ed9a547f6786bdc$var$HandleServerTokenResponse = "handleServerTokenResponse";
/**
 * Authority functions
 */ const $9ed9a547f6786bdc$var$AuthorityResolveEndpointsAsync = "authorityResolveEndpointsAsync";
const $9ed9a547f6786bdc$var$AuthorityGetCloudDiscoveryMetadataFromNetwork = "authorityGetCloudDiscoveryMetadataFromNetwork";
const $9ed9a547f6786bdc$var$AuthorityUpdateCloudDiscoveryMetadata = "authorityUpdateCloudDiscoveryMetadata";
const $9ed9a547f6786bdc$var$AuthorityGetEndpointMetadataFromNetwork = "authorityGetEndpointMetadataFromNetwork";
const $9ed9a547f6786bdc$var$AuthorityUpdateEndpointMetadata = "authorityUpdateEndpointMetadata";
const $9ed9a547f6786bdc$var$AuthorityUpdateMetadataWithRegionalInformation = "authorityUpdateMetadataWithRegionalInformation";
/**
 * Region Discovery functions
 */ const $9ed9a547f6786bdc$var$RegionDiscoveryDetectRegion = "regionDiscoveryDetectRegion";
const $9ed9a547f6786bdc$var$RegionDiscoveryGetRegionFromIMDS = "regionDiscoveryGetRegionFromIMDS";
const $9ed9a547f6786bdc$var$RegionDiscoveryGetCurrentVersion = "regionDiscoveryGetCurrentVersion";
/**
 * Cache operations
 */ const $9ed9a547f6786bdc$var$CacheManagerGetRefreshToken = "cacheManagerGetRefreshToken";
const $9ed9a547f6786bdc$var$SetUserData = "setUserData";
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9ed9a547f6786bdc$var$invoke = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`1plfzx ${eventName}`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        try {
            const result = callback(...args);
            inProgressEvent.end({
                success: true
            });
            logger.trace(`1g8n6a ${eventName}`, correlationId);
            return result;
        } catch (e) {
            logger.trace(`0cfd8i ${eventName}`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("00dty7", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9ed9a547f6786bdc$var$invokeAsync = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`1plfzx ${eventName}`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`1g8n6a ${eventName}`, correlationId);
            inProgressEvent.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`0cfd8i ${eventName}`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("00dty7", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        });
    };
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$RegionDiscovery {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $9ed9a547f6786bdc$var$RegionDiscovery.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await $9ed9a547f6786bdc$var$invokeAsync(this.getRegionFromIMDS.bind(this), $9ed9a547f6786bdc$var$RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)($9ed9a547f6786bdc$var$IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === $9ed9a547f6786bdc$var$HTTP_SUCCESS) {
                    autodetectedRegionName = localIMDSVersionResponse.body?.location;
                    if (autodetectedRegionName) regionDiscoveryMetadata.region_source = $9ed9a547f6786bdc$var$RegionDiscoverySources.IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === $9ed9a547f6786bdc$var$HTTP_BAD_REQUEST) {
                    const currentIMDSVersion = await $9ed9a547f6786bdc$var$invokeAsync(this.getCurrentVersion.bind(this), $9ed9a547f6786bdc$var$RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = $9ed9a547f6786bdc$var$RegionDiscoverySources.FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await $9ed9a547f6786bdc$var$invokeAsync(this.getRegionFromIMDS.bind(this), $9ed9a547f6786bdc$var$RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === $9ed9a547f6786bdc$var$HTTP_SUCCESS) {
                        autodetectedRegionName = currentIMDSVersionResponse.body?.location;
                        if (autodetectedRegionName) regionDiscoveryMetadata.region_source = $9ed9a547f6786bdc$var$RegionDiscoverySources.IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = $9ed9a547f6786bdc$var$RegionDiscoverySources.FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = $9ed9a547f6786bdc$var$RegionDiscoverySources.ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = $9ed9a547f6786bdc$var$RegionDiscoverySources.FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param version
     * @param options
     * @returns Promise<NetworkResponse<ImdsComputeResponse>>
     */ async getRegionFromIMDS(version, options) {
        return this.networkInterface.sendGetRequestAsync(`${$9ed9a547f6786bdc$var$IMDS_ENDPOINT}?api-version=${version}`, options, $9ed9a547f6786bdc$var$IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${$9ed9a547f6786bdc$var$IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === $9ed9a547f6786bdc$var$HTTP_BAD_REQUEST && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$9ed9a547f6786bdc$var$RegionDiscovery.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $9ed9a547f6786bdc$var$nowSeconds() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function $9ed9a547f6786bdc$var$toSecondsFromDate(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function $9ed9a547f6786bdc$var$toDateFromSeconds(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $9ed9a547f6786bdc$var$isTokenExpired(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $9ed9a547f6786bdc$var$nowSeconds() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * Checks if a cache entry is expired based on the last updated time and cache retention days.
 * @param lastUpdatedAt
 * @param cacheRetentionDays
 * @returns
 */ function $9ed9a547f6786bdc$var$isCacheExpired(lastUpdatedAt, cacheRetentionDays) {
    const cacheExpirationTimestamp = Number(lastUpdatedAt) + cacheRetentionDays * 86400000;
    return Date.now() > cacheExpirationTimestamp;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $9ed9a547f6786bdc$var$wasClockTurnedBack(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $9ed9a547f6786bdc$var$nowSeconds();
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ed9a547f6786bdc$var$createIdTokenEntity(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: $9ed9a547f6786bdc$var$CredentialType.ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId,
        lastUpdatedAt: Date.now().toString()
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $9ed9a547f6786bdc$var$createAccessTokenEntity(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, correlationId, refreshOn, tokenType, userAssertionHash, keyId, additionalCacheKeyComponents) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: $9ed9a547f6786bdc$var$nowSeconds().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    const normalizedTokenType = atEntity.tokenType?.toLowerCase();
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER.toLowerCase()) {
        atEntity.credentialType = $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(normalizedTokenType){
            case $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(accessToken, base64Decode, correlationId);
                if (!tokenClaims?.cnf?.kid) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenClaimsCnfRequiredForSignedJwt, correlationId);
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case "dpop":
                if (!keyId) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$keyIdMissing, correlationId);
                atEntity.keyId = keyId;
                break;
            case $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH:
                atEntity.keyId = keyId;
        }
    }
    /* Additional cache key components for cache isolation (e.g., FMI path) */ if (additionalCacheKeyComponents && Object.keys(additionalCacheKeyComponents).length > 0) atEntity.additionalCacheKeyComponents = additionalCacheKeyComponents;
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9ed9a547f6786bdc$var$createRefreshTokenEntity(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: $9ed9a547f6786bdc$var$CredentialType.REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $9ed9a547f6786bdc$var$isCredentialEntity(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ed9a547f6786bdc$var$isAccessTokenEntity(entity) {
    if (!entity) return false;
    return $9ed9a547f6786bdc$var$isCredentialEntity(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN || entity["credentialType"] === $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ed9a547f6786bdc$var$isIdTokenEntity(entity) {
    if (!entity) return false;
    return $9ed9a547f6786bdc$var$isCredentialEntity(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === $9ed9a547f6786bdc$var$CredentialType.ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ed9a547f6786bdc$var$isRefreshTokenEntity(entity) {
    if (!entity) return false;
    return $9ed9a547f6786bdc$var$isCredentialEntity(entity) && entity["credentialType"] === $9ed9a547f6786bdc$var$CredentialType.REFRESH_TOKEN;
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $9ed9a547f6786bdc$var$isServerTelemetryEntity(key, entity) {
    const validateKey = key.indexOf($9ed9a547f6786bdc$var$SERVER_TELEM_CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $9ed9a547f6786bdc$var$isThrottlingEntity(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf($9ed9a547f6786bdc$var$THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $9ed9a547f6786bdc$var$generateAppMetadataKey({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        $9ed9a547f6786bdc$var$APP_METADATA,
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join($9ed9a547f6786bdc$var$CACHE_KEY_SEPARATOR$1).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ed9a547f6786bdc$var$isAppMetadataEntity(key, entity) {
    if (!entity) return false;
    return key.indexOf($9ed9a547f6786bdc$var$APP_METADATA) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9ed9a547f6786bdc$var$isAuthorityMetadataEntity(key, entity) {
    if (!entity) return false;
    return key.indexOf($9ed9a547f6786bdc$var$AUTHORITY_METADATA_CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $9ed9a547f6786bdc$var$generateAuthorityMetadataExpiresAt() {
    return $9ed9a547f6786bdc$var$nowSeconds() + $9ed9a547f6786bdc$var$AUTHORITY_METADATA_REFRESH_TIME_SECONDS;
}
/** @internal */ function $9ed9a547f6786bdc$var$updateAuthorityEndpointMetadata(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
/** @internal */ function $9ed9a547f6786bdc$var$updateCloudDiscoveryMetadata(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 * @internal
 */ function $9ed9a547f6786bdc$var$isAuthorityMetadataExpired(metadata) {
    return metadata.expiresAt <= $9ed9a547f6786bdc$var$nowSeconds();
}
/**
 * Serialize attribute tokens synchronously (sort and join).
 * This is a sync-only operation for use at request construction time.
 * @param attributeTokens - array of tokens
 * @returns serialized partition string or undefined if no tokens
 */ function $9ed9a547f6786bdc$var$serializeAttributeTokens(attributeTokens) {
    if (!attributeTokens || attributeTokens.length === 0) return undefined;
    // Serialize: sort and join tokens
    return [
        ...attributeTokens
    ].sort().join(" ");
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $9ed9a547f6786bdc$var$Authority {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new $9ed9a547f6786bdc$var$RegionDiscovery(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType:type}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith($9ed9a547f6786bdc$var$CIAM_AUTH_URL)) return $9ed9a547f6786bdc$var$AuthorityType.Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case $9ed9a547f6786bdc$var$ADFS:
                return $9ed9a547f6786bdc$var$AuthorityType.Adfs;
        }
        return $9ed9a547f6786bdc$var$AuthorityType.Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new $9ed9a547f6786bdc$var$UrlString(url, this.correlationId);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endSessionEndpointNotSupported, this.correlationId);
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$9ed9a547f6786bdc$var$Authority.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === $9ed9a547f6786bdc$var$AuthorityType.Default && this.protocolMode !== $9ed9a547f6786bdc$var$ProtocolMode.OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new $9ed9a547f6786bdc$var$UrlString(this.metadata.canonical_authority, this.correlationId);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new $9ed9a547f6786bdc$var$UrlString(this.metadata.authorization_endpoint, this.correlationId).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`1q3g2x ${cachedPart} ${tenantId}`, this.correlationId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === $9ed9a547f6786bdc$var$AuthorityType.Adfs || this.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await $9ed9a547f6786bdc$var$invokeAsync(this.updateCloudDiscoveryMetadata.bind(this), $9ed9a547f6786bdc$var$AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await $9ed9a547f6786bdc$var$invokeAsync(this.updateEndpointMetadata.bind(this), $9ed9a547f6786bdc$var$AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwise returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort, this.correlationId);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: $9ed9a547f6786bdc$var$generateAuthorityMetadataExpiresAt(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== $9ed9a547f6786bdc$var$AuthorityMetadataSource.CACHE && endpointMetadataResult?.source !== $9ed9a547f6786bdc$var$AuthorityMetadataSource.CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = $9ed9a547f6786bdc$var$generateAuthorityMetadataExpiresAt();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache, this.correlationId);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity, this.correlationId);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === $9ed9a547f6786bdc$var$AuthorityMetadataSource.HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await $9ed9a547f6786bdc$var$invokeAsync(this.updateMetadataWithRegionalInformation.bind(this), $9ed9a547f6786bdc$var$AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        $9ed9a547f6786bdc$var$updateAuthorityEndpointMetadata(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await $9ed9a547f6786bdc$var$invokeAsync(this.getEndpointMetadataFromNetwork.bind(this), $9ed9a547f6786bdc$var$AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // Validate the issuer returned by the OIDC discovery document.
            this.validateIssuer(metadata.issuer);
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await $9ed9a547f6786bdc$var$invokeAsync(this.updateMetadataWithRegionalInformation.bind(this), $9ed9a547f6786bdc$var$AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            $9ed9a547f6786bdc$var$updateAuthorityEndpointMetadata(metadataEntity, metadata, true);
            return $9ed9a547f6786bdc$var$AuthorityMetadataSource.NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$openIdConfigError, this.defaultOpenIdConfigurationEndpoint, this.correlationId);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("1fi0kc", this.correlationId);
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("06t0uj", this.correlationId);
            $9ed9a547f6786bdc$var$updateAuthorityEndpointMetadata(metadataEntity, configMetadata, false);
            return {
                source: $9ed9a547f6786bdc$var$AuthorityMetadataSource.CONFIG
            };
        }
        this.logger.verbose("151k0p", this.correlationId);
        const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
        if (hardcodedMetadata) {
            $9ed9a547f6786bdc$var$updateAuthorityEndpointMetadata(metadataEntity, hardcodedMetadata, false);
            return {
                source: $9ed9a547f6786bdc$var$AuthorityMetadataSource.HARDCODED_VALUES,
                metadata: hardcodedMetadata
            };
        } else this.logger.verbose("1imop5", this.correlationId);
        // Check cached metadata entity expiration status
        const metadataEntityExpired = $9ed9a547f6786bdc$var$isAuthorityMetadataExpired(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("16uq31", "");
            return {
                source: $9ed9a547f6786bdc$var$AuthorityMetadataSource.CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("0uoibc", "");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new $9ed9a547f6786bdc$var$UrlString(metadataEntity.canonical_authority, this.correlationId);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidAuthorityMetadata, this.correlationId);
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`1y65x6 ${openIdConfigurationEndpoint}`, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = $9ed9a547f6786bdc$var$isOpenIdConfigResponse(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose("1koyv8", this.correlationId);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`0a9wik ${e}`, this.correlationId);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in $9ed9a547f6786bdc$var$EndpointMetadata) return $9ed9a547f6786bdc$var$EndpointMetadata[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== $9ed9a547f6786bdc$var$AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = $9ed9a547f6786bdc$var$RegionDiscoveryOutcomes.CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $9ed9a547f6786bdc$var$Authority.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion, this.correlationId);
            }
            const autodetectedRegionName = await $9ed9a547f6786bdc$var$invokeAsync(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), $9ed9a547f6786bdc$var$RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = $9ed9a547f6786bdc$var$RegionDiscoveryOutcomes.AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $9ed9a547f6786bdc$var$Authority.replaceWithRegionalInformation(metadata, autodetectedRegionName, this.correlationId);
            }
            this.regionDiscoveryMetadata.region_outcome = $9ed9a547f6786bdc$var$RegionDiscoveryOutcomes.AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await $9ed9a547f6786bdc$var$invokeAsync(this.getCloudDiscoveryMetadataFromNetwork.bind(this), $9ed9a547f6786bdc$var$AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            $9ed9a547f6786bdc$var$updateCloudDiscoveryMetadata(metadataEntity, metadata, true);
            return $9ed9a547f6786bdc$var$AuthorityMetadataSource.NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$untrustedAuthority, this.correlationId);
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("1tpqlr", this.correlationId);
        this.logger.verbosePii(`1fy7uz ${this.authorityOptions.knownAuthorities || $9ed9a547f6786bdc$var$NOT_APPLICABLE}`, this.correlationId);
        this.logger.verbosePii(`08zabj ${this.authorityOptions.authorityMetadata || $9ed9a547f6786bdc$var$NOT_APPLICABLE}`, this.correlationId);
        this.logger.verbosePii(`1o1kv3 ${metadataEntity.canonical_authority || $9ed9a547f6786bdc$var$NOT_APPLICABLE}`, this.correlationId);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("1nakio", this.correlationId);
            $9ed9a547f6786bdc$var$updateCloudDiscoveryMetadata(metadataEntity, metadata, false);
            return $9ed9a547f6786bdc$var$AuthorityMetadataSource.CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("1x74aj", this.correlationId);
        const hardcodedMetadata = $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromHardcodedValues(this.hostnameAndPort);
        if (hardcodedMetadata) {
            this.logger.verbose("0by47c", this.correlationId);
            $9ed9a547f6786bdc$var$updateCloudDiscoveryMetadata(metadataEntity, hardcodedMetadata, false);
            return $9ed9a547f6786bdc$var$AuthorityMetadataSource.HARDCODED_VALUES;
        }
        this.logger.verbose("0r2fzy", this.correlationId);
        const metadataEntityExpired = $9ed9a547f6786bdc$var$isAuthorityMetadataExpired(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("1uffgh", "");
            // No need to update
            return $9ed9a547f6786bdc$var$AuthorityMetadataSource.CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("0uoibc", "");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === $9ed9a547f6786bdc$var$AuthorityType.Ciam) {
            this.logger.verbose("04y84h", this.correlationId);
            return $9ed9a547f6786bdc$var$Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("0gszr3", this.correlationId);
            try {
                this.logger.verbose("1iifkx", this.correlationId);
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("0q67e3", "");
                if (metadata) {
                    this.logger.verbose("0hzfao", this.correlationId);
                    return metadata;
                } else this.logger.verbose("1ajz3u", this.correlationId);
            } catch (e) {
                this.logger.verbose("1wq5tu", this.correlationId);
                throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidCloudDiscoveryMetadata, this.correlationId);
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities(this.hostnameAndPort)) {
            this.logger.verbose("0mt9al", this.correlationId);
            return $9ed9a547f6786bdc$var$Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        const instanceDiscoveryEndpoint = `${$9ed9a547f6786bdc$var$AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ($9ed9a547f6786bdc$var$isCloudInstanceDiscoveryResponse(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`1vglyt ${typedResponseBody.tenant_discovery_endpoint}`, this.correlationId);
            } else if ($9ed9a547f6786bdc$var$isCloudInstanceDiscoveryErrorResponse(response.body)) {
                this.logger.warning(`062uto ${response.status}`, this.correlationId);
                typedResponseBody = response.body;
                if (typedResponseBody.error === $9ed9a547f6786bdc$var$INVALID_INSTANCE) {
                    this.logger.error("1x90tm", this.correlationId);
                    return null;
                }
                this.logger.warning(`0wchdm ${typedResponseBody.error}`, this.correlationId);
                this.logger.warning(`1s5mpv ${typedResponseBody.error_description}`, this.correlationId);
                this.logger.warning("1yhqpw", this.correlationId);
                metadata = [];
            } else {
                this.logger.error("0768g0", this.correlationId);
                return null;
            }
            this.logger.verbose("1lrobr", this.correlationId);
            match = $9ed9a547f6786bdc$var$getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof $9ed9a547f6786bdc$var$AuthError) this.logger.error(`0vwhc7 ${error.errorCode} ${error.errorMessage}`, this.correlationId);
            else {
                const typedError = error;
                this.logger.error(`0s2z41 ${typedError.name} ${typedError.message}`, this.correlationId);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("0jp28q", this.correlationId);
            this.logger.verbose("130sd8", this.correlationId);
            match = $9ed9a547f6786bdc$var$Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if a host is included in the knownAuthorities config option.
     */ isInKnownAuthorities(host) {
        const normalizedHost = host.toLowerCase();
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && $9ed9a547f6786bdc$var$UrlString.getDomainFromUrl(authority, this.correlationId).toLowerCase() === normalizedHost;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== $9ed9a547f6786bdc$var$AzureCloudInstance.None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : $9ed9a547f6786bdc$var$DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return $9ed9a547f6786bdc$var$DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, this.correlationId);
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return $9ed9a547f6786bdc$var$InstanceDiscoveryMetadataAliases.has(host);
    }
    /**
     * Validates the `issuer` returned by an OIDC discovery document against
     * this authority, per
     * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationValidation
     *
     * The issuer is accepted when ANY of the following holds:
     *  1. The issuer scheme + host + port match the authority's (path may
     *     differ). Applies to all authorities.
     *  2. The authority is a Microsoft cloud authority (public, sovereign,
     *     or CIAM), the issuer is HTTPS, and the issuer host is in the known
     *     Microsoft authority host set.
     *  3. Same as (2), but the issuer host is a single-label regional variant
     *     of a known Microsoft host (e.g. `westus.login.microsoftonline.com`).
     *  4. Same as (2), but the issuer host matches the CIAM tenant pattern
     *     `{tenant}.ciamlogin.com` with an optional `/{tenant}[.onmicrosoft.com][/v2.0]`
     *     path.
     *  5. The issuer host is HTTPS and is explicitly listed in the
     *     developer-configured `knownAuthorities`. This covers scenarios where
     *     the OIDC discovery document returns an issuer host that differs from
     *     the authority (e.g., a GUID-based issuer for a name-based CIAM authority).
     *
     * @param issuer The `issuer` value returned in the OIDC discovery document.
     * @throws ClientConfigurationError("issuer_validation_failed") on failure.
     */ validateIssuer(issuer) {
        if (!issuer) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$issuerValidationFailed, this.correlationId);
        // Parse with the WHATWG URL API. URL normalizes scheme + host to lowercase per RFC 3986.
        let issuerUrl;
        try {
            issuerUrl = new URL(issuer);
        } catch  {
            throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$issuerValidationFailed, this.correlationId);
        }
        const issuerScheme = issuerUrl.protocol;
        const issuerHost = issuerUrl.host;
        const authorityScheme = (this.canonicalAuthorityUrlComponents.Protocol || "").toLowerCase();
        const authorityHost = (this.canonicalAuthorityUrlComponents.HostNameAndPort || "").toLowerCase();
        // Rule 1: Same scheme and host
        const matchesAuthorityOrigin = this.matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost);
        // Rule 2: The issuer host is a well-known Microsoft authority host (HTTPS only)
        const matchesKnownMicrosoftHost = issuerScheme === "https:" && this.isAliasOfKnownMicrosoftAuthority(issuerHost);
        /*
         * Rule 3: The issuer host is a regional variant ({region}.{host}) of a well-known host
         * (HTTPS only). E.g. westus2.login.microsoft.com
         */ const matchesRegionalMicrosoftHost = issuerScheme === "https:" && this.matchesRegionalMicrosoftHost(issuerHost);
        /*
         * Rule 4: CIAM-specific validation. In a CIAM scenario the issuer is expected to
         * have "{tenant}.ciamlogin.com" as the host, even when using a custom domain.
         */ const matchesCiamTenantPattern = this.matchesCiamTenantPattern(issuerUrl, authorityHost, this.canonicalAuthorityUrlComponents.PathSegments);
        /*
         * Rule 5: The issuer host is explicitly listed in the developer-configured
         * knownAuthorities. This covers scenarios where the OIDC discovery document
         * returns an issuer with a different host than the authority
         * (e.g., a GUID-based issuer for a name-based authority).
         */ const matchesKnownAuthority = issuerScheme === "https:" && this.isInKnownAuthorities(issuerHost);
        // Each rule is an independent boolean; the issuer is valid if ANY rule matches.
        if (matchesAuthorityOrigin || matchesKnownMicrosoftHost || matchesRegionalMicrosoftHost || matchesCiamTenantPattern || matchesKnownAuthority) return;
        // issuer validation fails if none of the above rules are satisfied
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$issuerValidationFailed, this.correlationId);
    }
    /**
     * Rule 1: The issuer scheme + host (and port) match the authority's. Path
     * may differ. Applies to all authorities.
     */ matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost) {
        return issuerScheme === authorityScheme && issuerHost === authorityHost;
    }
    /**
     * Rule 3: The issuer host is a regional variant
     * (`{region}.{host}`) of a known Microsoft authority host.
     * E.g. `westus2.login.microsoft.com`.
     */ matchesRegionalMicrosoftHost(issuerHost) {
        const firstDot = issuerHost.indexOf(".");
        if (firstDot > 0 && firstDot < issuerHost.length - 1) {
            const hostWithoutRegion = issuerHost.substring(firstDot + 1);
            return this.isAliasOfKnownMicrosoftAuthority(hostWithoutRegion);
        }
        return false;
    }
    /**
     * Rule 4: The issuer matches one of the well-known CIAM tenant patterns
     * (`https://{tenant}.ciamlogin.com[/{tenant}[.onmicrosoft.com][/v2.0]]`).
     *
     * The bare tenant name is extracted from the authority's first path segment
     * when available (stripping the `.onmicrosoft.com` suffix that
     * `transformCIAMAuthority` adds), or otherwise from the leftmost label of
     * the authority host (to support CIAM custom domain scenarios).
     *
     * Both `/{tenant}` and `/{tenant}.onmicrosoft.com` path forms are accepted
     * because the OIDC issuer may use either form depending on the authority URL
     * that was used to trigger discovery.
     */ matchesCiamTenantPattern(issuerUrl, authorityHost, authorityPathSegments) {
        /*
         * authorityPathSegments[0] is the first path segment of the *authority
         * URL* after transformCIAMAuthority runs (e.g. "contoso.onmicrosoft.com").
         * Additional CIAM issuer path segments such as "/v2.0" are part of the
         * issuer string, not the authority URL's PathSegments.
         */ const pathSegment = authorityPathSegments[0];
        /*
         * Extract the bare tenant name: strip the .onmicrosoft.com suffix when
         * present (introduced by transformCIAMAuthority), or fall back to the
         * first label of the authority hostname for non-transformed/custom-domain
         * CIAM authorities.
         */ const tenantName = pathSegment ? pathSegment.endsWith($9ed9a547f6786bdc$var$AAD_TENANT_DOMAIN_SUFFIX) ? pathSegment.slice(0, -$9ed9a547f6786bdc$var$AAD_TENANT_DOMAIN_SUFFIX.length) : pathSegment : authorityHost.split(".")[0];
        if (!tenantName) return false;
        const ciamBaseURL = `https://${tenantName}${$9ed9a547f6786bdc$var$CIAM_AUTH_URL}`;
        const validCiamPatterns = [
            ciamBaseURL,
            `${ciamBaseURL}/${tenantName}`,
            `${ciamBaseURL}/${tenantName}/v2.0`,
            `${ciamBaseURL}/${tenantName}${$9ed9a547f6786bdc$var$AAD_TENANT_DOMAIN_SUFFIX}`,
            `${ciamBaseURL}/${tenantName}${$9ed9a547f6786bdc$var$AAD_TENANT_DOMAIN_SUFFIX}/v2.0`
        ];
        /*
         * Compose the canonical issuer string from URL components and strip any
         * trailing slashes from the path so it can be compared to the pattern set.
         */ const issuerPath = issuerUrl.pathname.replace(/\/+$/, "");
        const normalizedIssuer = `${issuerUrl.protocol}//${issuerUrl.host}${issuerPath}`;
        return validCiamPatterns.some((pattern)=>pattern === normalizedIssuer);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return $9ed9a547f6786bdc$var$KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, correlationId, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new $9ed9a547f6786bdc$var$UrlString(host, correlationId);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${$9ed9a547f6786bdc$var$REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = $9ed9a547f6786bdc$var$UrlString.constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }, correlationId).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion, correlationId) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $9ed9a547f6786bdc$var$Authority.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion, correlationId);
        regionalMetadata.token_endpoint = $9ed9a547f6786bdc$var$Authority.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion, correlationId);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $9ed9a547f6786bdc$var$Authority.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion, correlationId);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority, correlationId) {
        let ciamAuthority = authority;
        const authorityUrl = new $9ed9a547f6786bdc$var$UrlString(authority, correlationId);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith($9ed9a547f6786bdc$var$CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${$9ed9a547f6786bdc$var$AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$9ed9a547f6786bdc$var$Authority.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    $9ed9a547f6786bdc$var$AADAuthority.COMMON,
    $9ed9a547f6786bdc$var$AADAuthority.CONSUMERS,
    $9ed9a547f6786bdc$var$AADAuthority.ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $9ed9a547f6786bdc$var$getTenantFromAuthorityString(authority, correlationId) {
    const authorityUrl = new $9ed9a547f6786bdc$var$UrlString(authority, correlationId);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case $9ed9a547f6786bdc$var$AADAuthority.COMMON:
        case $9ed9a547f6786bdc$var$AADAuthority.ORGANIZATIONS:
        case $9ed9a547f6786bdc$var$AADAuthority.CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $9ed9a547f6786bdc$var$formatAuthorityUri(authorityUri) {
    return authorityUri.endsWith($9ed9a547f6786bdc$var$FORWARD_SLASH) ? authorityUri : `${authorityUri}${$9ed9a547f6786bdc$var$FORWARD_SLASH}`;
}
function $9ed9a547f6786bdc$var$buildStaticAuthorityOptions(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidCloudDiscoveryMetadata, "");
    }
    return {
        canonicalAuthority: authOptions.authority ? $9ed9a547f6786bdc$var$formatAuthorityUri(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param cacheManager
 * @param authorityOptions
 * @param logger
 * @param correlationId
 * @param performanceClient
 * @internal
 */ async function $9ed9a547f6786bdc$var$createDiscoveredInstance(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    const authorityUriFinal = $9ed9a547f6786bdc$var$Authority.transformCIAMAuthority($9ed9a547f6786bdc$var$formatAuthorityUri(authorityUri), correlationId);
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new $9ed9a547f6786bdc$var$Authority(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await $9ed9a547f6786bdc$var$invokeAsync(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), $9ed9a547f6786bdc$var$AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$endpointResolutionError, correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $9ed9a547f6786bdc$var$ScopeSet {
    constructor(inputScopes, correlationId){
        this.correlationId = correlationId;
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? $9ed9a547f6786bdc$var$StringUtils.trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? $9ed9a547f6786bdc$var$StringUtils.removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$emptyInputScopesError, correlationId);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString, correlationId) {
        const scopeString = inputScopeString || "";
        const inputScopes = scopeString.split(" ");
        return new $9ed9a547f6786bdc$var$ScopeSet(inputScopes, correlationId);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString, correlationId) {
        // Handle empty scopes by using default OIDC scopes for cache lookup
        const scopesToUse = inputScopeString && inputScopeString.length > 0 ? inputScopeString : [
            ...$9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1
        ];
        const scopeSet = new $9ed9a547f6786bdc$var$ScopeSet(scopesToUse, correlationId);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope($9ed9a547f6786bdc$var$OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $9ed9a547f6786bdc$var$ScopeSet(lowerCaseScopes, this.correlationId);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        $9ed9a547f6786bdc$var$OIDC_SCOPES.forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$cannotAppendScopeSet, this.correlationId);
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$cannotRemoveEmptyScope, this.correlationId);
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        $9ed9a547f6786bdc$var$OIDC_SCOPES.forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$emptyInputScopeSet, this.correlationId);
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$emptyInputScopeSet, this.correlationId);
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return "";
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$instrumentBrokerParams(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get($9ed9a547f6786bdc$var$CLIENT_ID);
    if (clientId && parameters.has($9ed9a547f6786bdc$var$BROKER_CLIENT_ID)) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get($9ed9a547f6786bdc$var$REDIRECT_URI)
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function $9ed9a547f6786bdc$var$addResponseType(parameters, responseType) {
    parameters.set($9ed9a547f6786bdc$var$RESPONSE_TYPE, responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function $9ed9a547f6786bdc$var$addResponseMode(parameters, responseMode) {
    parameters.set($9ed9a547f6786bdc$var$RESPONSE_MODE, responseMode ? responseMode : $9ed9a547f6786bdc$var$ResponseMode$1.QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function $9ed9a547f6786bdc$var$addNativeBroker(parameters) {
    parameters.set($9ed9a547f6786bdc$var$NATIVE_BROKER, "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function $9ed9a547f6786bdc$var$addScopes(parameters, scopes, correlationId, addOidcScopes = true, defaultScopes = $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new $9ed9a547f6786bdc$var$ScopeSet(requestScopes, correlationId);
    parameters.set($9ed9a547f6786bdc$var$SCOPE, scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function $9ed9a547f6786bdc$var$addClientId(parameters, clientId) {
    parameters.set($9ed9a547f6786bdc$var$CLIENT_ID, clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function $9ed9a547f6786bdc$var$addRedirectUri(parameters, redirectUri) {
    parameters.set($9ed9a547f6786bdc$var$REDIRECT_URI, redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function $9ed9a547f6786bdc$var$addPostLogoutRedirectUri(parameters, redirectUri) {
    parameters.set($9ed9a547f6786bdc$var$POST_LOGOUT_URI, redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function $9ed9a547f6786bdc$var$addIdTokenHint(parameters, idTokenHint) {
    parameters.set($9ed9a547f6786bdc$var$ID_TOKEN_HINT, idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function $9ed9a547f6786bdc$var$addDomainHint(parameters, domainHint) {
    parameters.set($9ed9a547f6786bdc$var$DOMAIN_HINT, domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function $9ed9a547f6786bdc$var$addLoginHint(parameters, loginHint) {
    parameters.set($9ed9a547f6786bdc$var$LOGIN_HINT, loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function $9ed9a547f6786bdc$var$addCcsUpn(parameters, loginHint) {
    parameters.set($9ed9a547f6786bdc$var$HeaderNames.CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function $9ed9a547f6786bdc$var$addCcsOid(parameters, clientInfo) {
    parameters.set($9ed9a547f6786bdc$var$HeaderNames.CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function $9ed9a547f6786bdc$var$addSid(parameters, sid) {
    parameters.set($9ed9a547f6786bdc$var$SID, sid);
}
/**
 * Adds claims to request parameters, conditionally excluding clientCapabilities
 * when skipBrokerClaims is true and a brokered flow is in effect.
 * @param parameters - The request parameters map
 * @param correlationId - The request correlation id
 * @param claims - The claims string from the request
 * @param clientCapabilities - The client capabilities from configuration
 * @param skipBrokerClaims - When true and BROKER_CLIENT_ID is present, excludes clientCapabilities from claims
 * @param claimsToMerge - Optional client-originated claims JSON string (e.g. `claimsFromClient`) deep-merged into `claims` with precedence on conflicts
 */ function $9ed9a547f6786bdc$var$addClaims(parameters, correlationId, claims, clientCapabilities, skipBrokerClaims, claimsToMerge) {
    // Skip clientCapabilities if skipBrokerClaims is set to true and this is a brokered authentication flow
    const configClaims = skipBrokerClaims && parameters.has($9ed9a547f6786bdc$var$BROKER_CLIENT_ID) ? undefined : clientCapabilities;
    const mergedClaims = $9ed9a547f6786bdc$var$buildMergedClaims$1(claims, configClaims, correlationId, claimsToMerge);
    parameters.set($9ed9a547f6786bdc$var$CLAIMS, mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function $9ed9a547f6786bdc$var$addCorrelationId(parameters, correlationId) {
    parameters.set($9ed9a547f6786bdc$var$CLIENT_REQUEST_ID, correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function $9ed9a547f6786bdc$var$addLibraryInfo(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set($9ed9a547f6786bdc$var$X_CLIENT_SKU, libraryInfo.sku);
    parameters.set($9ed9a547f6786bdc$var$X_CLIENT_VER, libraryInfo.version);
    if (libraryInfo.os) parameters.set($9ed9a547f6786bdc$var$X_CLIENT_OS, libraryInfo.os);
    if (libraryInfo.cpu) parameters.set($9ed9a547f6786bdc$var$X_CLIENT_CPU, libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function $9ed9a547f6786bdc$var$addApplicationTelemetry(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set($9ed9a547f6786bdc$var$X_APP_NAME, appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set($9ed9a547f6786bdc$var$X_APP_VER, appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function $9ed9a547f6786bdc$var$addPrompt(parameters, prompt) {
    parameters.set($9ed9a547f6786bdc$var$PROMPT, prompt);
}
/**
 * add state
 * @param state
 */ function $9ed9a547f6786bdc$var$addState(parameters, state) {
    if (state) parameters.set($9ed9a547f6786bdc$var$STATE, state);
}
/**
 * add nonce
 * @param nonce
 */ function $9ed9a547f6786bdc$var$addNonce(parameters, nonce) {
    parameters.set($9ed9a547f6786bdc$var$NONCE, nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function $9ed9a547f6786bdc$var$addCodeChallengeParams(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set($9ed9a547f6786bdc$var$CODE_CHALLENGE, codeChallenge);
        parameters.set($9ed9a547f6786bdc$var$CODE_CHALLENGE_METHOD, codeChallengeMethod);
    } else throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$pkceParamsMissing, "");
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $9ed9a547f6786bdc$var$addAuthorizationCode(parameters, code) {
    parameters.set($9ed9a547f6786bdc$var$CODE, code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function $9ed9a547f6786bdc$var$addRefreshToken(parameters, refreshToken) {
    parameters.set($9ed9a547f6786bdc$var$REFRESH_TOKEN, refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function $9ed9a547f6786bdc$var$addCodeVerifier(parameters, codeVerifier) {
    parameters.set($9ed9a547f6786bdc$var$CODE_VERIFIER, codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function $9ed9a547f6786bdc$var$addClientSecret(parameters, clientSecret) {
    parameters.set($9ed9a547f6786bdc$var$CLIENT_SECRET, clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function $9ed9a547f6786bdc$var$addClientAssertion(parameters, clientAssertion) {
    if (clientAssertion) parameters.set($9ed9a547f6786bdc$var$CLIENT_ASSERTION, clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function $9ed9a547f6786bdc$var$addClientAssertionType(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set($9ed9a547f6786bdc$var$CLIENT_ASSERTION_TYPE, clientAssertionType);
}
/**
 * add grant type
 * @param grantType
 */ function $9ed9a547f6786bdc$var$addGrantType(parameters, grantType) {
    parameters.set($9ed9a547f6786bdc$var$GRANT_TYPE, grantType);
}
/**
 * add client info
 *
 */ function $9ed9a547f6786bdc$var$addClientInfo(parameters) {
    parameters.set($9ed9a547f6786bdc$var$CLIENT_INFO, "1");
}
/**
 * add clidata=1 to request to indicate client data support
 */ function $9ed9a547f6786bdc$var$addCliData(parameters) {
    parameters.set($9ed9a547f6786bdc$var$CLI_DATA, "1");
}
function $9ed9a547f6786bdc$var$addInstanceAware(parameters) {
    if (!parameters.has($9ed9a547f6786bdc$var$INSTANCE_AWARE)) parameters.set($9ed9a547f6786bdc$var$INSTANCE_AWARE, "true");
}
/**
 * Add extraParameters
 * @param extraParams - String dictionary containing extra parameters to be added.
 */ function $9ed9a547f6786bdc$var$addExtraParameters(parameters, extraParams) {
    Object.entries(extraParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
/**
 * Default optional idToken claims requested on all auth requests.
 * signin_state enables KMSI detection; login_hint enables login hint propagation;
 * tenant_region_sub_scope identifies the sovereign enclave a tenant belongs to.
 */ const $9ed9a547f6786bdc$var$DEFAULT_ID_TOKEN_CLAIMS = {
    [$9ed9a547f6786bdc$var$ClaimsRequestKeys.SIGNIN_STATE]: {
        essential: false
    },
    [$9ed9a547f6786bdc$var$ClaimsRequestKeys.LOGIN_HINT]: {
        essential: false
    },
    [$9ed9a547f6786bdc$var$ClaimsRequestKeys.TENANT_REGION_SUB_SCOPE]: {
        essential: false
    }
};
/**
 * Parses a claims JSON string into an object, throwing a ClientConfigurationError
 * (error code `invalid_claims`) if the value is not a valid JSON object. The raw
 * claims value is never included in the error - it may contain sensitive data.
 * @param claims - Claims JSON string. Must be valid JSON representing an object.
 * @param correlationId - The request correlation id
 * @returns The parsed claims object
 */ function $9ed9a547f6786bdc$var$parseClaims(claims, correlationId = "") {
    let parsed;
    try {
        parsed = JSON.parse(claims);
    } catch (e) {
        // Malformed JSON
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidClaims, correlationId);
    }
    if (!$9ed9a547f6786bdc$var$isPlainObject$1(parsed)) // Valid JSON, but not an object (e.g. an array, a scalar, or the literal `null`).
    throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidClaims, correlationId);
    return parsed;
}
/**
 * Type guard for a non-null, non-array object (a JSON "object" value).
 * @param value - The value to test
 * @returns True when value is a plain object that can be deep-merged
 */ function $9ed9a547f6786bdc$var$isPlainObject$1(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
/**
 * Recursively deep-merges two parsed claims objects. Nested objects are merged key-by-key;
 * for any other value type (arrays, scalars, null) the value from `claimsToMerge` replaces
 * the base. This mirrors the deep merge used by msal-dotnet so that, for example, a server
 * `access_token` challenge and a client-originated `access_token` claim are combined rather
 * than one clobbering the other.
 * @param baseClaims - The parsed base claims object
 * @param claimsToMerge - The parsed claims object merged in with precedence
 * @returns The deep-merged claims object
 */ function $9ed9a547f6786bdc$var$deepMergeClaims(baseClaims, claimsToMerge) {
    const merged = {
        ...baseClaims
    };
    for (const [key, mergeInValue] of Object.entries(claimsToMerge)){
        const baseValue = merged[key];
        if ($9ed9a547f6786bdc$var$isPlainObject$1(baseValue) && $9ed9a547f6786bdc$var$isPlainObject$1(mergeInValue)) merged[key] = $9ed9a547f6786bdc$var$deepMergeClaims(baseValue, mergeInValue);
        else merged[key] = mergeInValue;
    }
    return merged;
}
/**
 * Parses claims JSON, optionally deep-merges a second client-originated claims string
 * (`claimsToMerge`, e.g. `claimsFromClient`) with precedence on conflicting keys, merges
 * default optional idToken claims (signin_state, login_hint, tenant_region_sub_scope), and appends client
 * capabilities (xms_cc) to the access_token section
 * Does not overwrite idToken claims already specified by the caller.
 * @param claims - Existing claims JSON string from the request (may be undefined)
 * @param clientCapabilities - Client capabilities array from configuration
 * @param correlationId - The request correlation id
 * @param claimsToMerge - Optional second claims JSON string (e.g. client-originated `claimsFromClient`)
 * deep-merged into `claims` with precedence on conflicts; parsed and validated when present. Nested
 * objects are merged recursively; arrays and scalar values are replaced.
 * @returns Merged claims JSON string
 */ function $9ed9a547f6786bdc$var$buildMergedClaims$1(claims, clientCapabilities, correlationId = "", claimsToMerge) {
    // Parse provided claims into JSON object or initialize empty object
    let mergedClaims = claims ? $9ed9a547f6786bdc$var$parseClaims(claims, correlationId) : {};
    // Deep-merge client-originated claims (e.g. `claimsFromClient`) with precedence on conflicts
    if (claimsToMerge?.trim()) mergedClaims = $9ed9a547f6786bdc$var$deepMergeClaims(mergedClaims, $9ed9a547f6786bdc$var$parseClaims(claimsToMerge, correlationId));
    // Add default optional idToken claims
    if (!Object.prototype.hasOwnProperty.call(mergedClaims, $9ed9a547f6786bdc$var$ClaimsRequestKeys.ID_TOKEN)) mergedClaims[$9ed9a547f6786bdc$var$ClaimsRequestKeys.ID_TOKEN] = {};
    const idTokenClaims = mergedClaims[$9ed9a547f6786bdc$var$ClaimsRequestKeys.ID_TOKEN];
    for (const [key, value] of Object.entries($9ed9a547f6786bdc$var$DEFAULT_ID_TOKEN_CLAIMS))if (!(key in idTokenClaims)) idTokenClaims[key] = value;
    // Add client capabilities
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!Object.prototype.hasOwnProperty.call(mergedClaims, $9ed9a547f6786bdc$var$ClaimsRequestKeys.ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[$9ed9a547f6786bdc$var$ClaimsRequestKeys.ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[$9ed9a547f6786bdc$var$ClaimsRequestKeys.ACCESS_TOKEN][$9ed9a547f6786bdc$var$ClaimsRequestKeys.XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function $9ed9a547f6786bdc$var$addPopToken(parameters, cnfString) {
    if (cnfString) {
        parameters.set($9ed9a547f6786bdc$var$TOKEN_TYPE, $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP);
        parameters.set($9ed9a547f6786bdc$var$REQ_CNF, cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function $9ed9a547f6786bdc$var$addSshJwk(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set($9ed9a547f6786bdc$var$TOKEN_TYPE, $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH);
        parameters.set($9ed9a547f6786bdc$var$REQ_CNF, sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 * @internal
 */ function $9ed9a547f6786bdc$var$addServerTelemetry(parameters, serverTelemetryManager) {
    parameters.set($9ed9a547f6786bdc$var$X_CLIENT_CURR_TELEM, serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set($9ed9a547f6786bdc$var$X_CLIENT_LAST_TELEM, serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function $9ed9a547f6786bdc$var$addThrottling(parameters) {
    parameters.set($9ed9a547f6786bdc$var$X_MS_LIB_CAPABILITY, $9ed9a547f6786bdc$var$X_MS_LIB_CAPABILITY_VALUE);
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function $9ed9a547f6786bdc$var$addLogoutHint(parameters, logoutHint) {
    parameters.set($9ed9a547f6786bdc$var$LOGOUT_HINT, logoutHint);
}
function $9ed9a547f6786bdc$var$addBrokerParameters(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has($9ed9a547f6786bdc$var$BROKER_CLIENT_ID)) parameters.set($9ed9a547f6786bdc$var$BROKER_CLIENT_ID, brokerClientId);
    if (!parameters.has($9ed9a547f6786bdc$var$BROKER_REDIRECT_URI)) parameters.set($9ed9a547f6786bdc$var$BROKER_REDIRECT_URI, brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function $9ed9a547f6786bdc$var$addEARParameters(parameters, jwk) {
    parameters.set($9ed9a547f6786bdc$var$EAR_JWK, encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set($9ed9a547f6786bdc$var$EAR_JWE_CRYPTO, jweCryptoB64Encoded);
}
function $9ed9a547f6786bdc$var$addResource(parameters, resource) {
    if (resource) parameters.set($9ed9a547f6786bdc$var$RESOURCE, resource);
}
/**
 * Add the `attribute_tokens` parameter to a /token request body.
 *
 * When `attributeTokens` is a non-empty array the values are sorted lexicographically and joined
 * with a single space, then written to the request body. When `attributeTokens` is an empty array
 * the parameter is deleted from the request body.
 *
 * @param parameters - request parameter map that will be serialized into the /token body
 * @param attributeTokens - caller-provided attribute token strings
 */ function $9ed9a547f6786bdc$var$addAttributeTokens(parameters, attributeTokens) {
    const serialized = $9ed9a547f6786bdc$var$serializeAttributeTokens(attributeTokens);
    if (serialized) parameters.set($9ed9a547f6786bdc$var$ATTRIBUTE_TOKENS, serialized);
    else parameters.delete($9ed9a547f6786bdc$var$ATTRIBUTE_TOKENS);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $9ed9a547f6786bdc$var$stripLeadingHashOrQuery(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $9ed9a547f6786bdc$var$getDeserializedResponse(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $9ed9a547f6786bdc$var$stripLeadingHashOrQuery(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$hashNotDeserialized, "");
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function $9ed9a547f6786bdc$var$mapToQueryString(parameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}
/**
 * Normalizes URLs for comparison per MDN & RFC 3986 standards:
 * - Hash/fragment is removed
 * - Scheme and host are lowercased (case-insensitive per spec)
 * - Path and query parameters preserve original casing (case-sensitive per spec)
 * - Percent-encoding in pathname is normalized (e.g., %27 and ' are treated equivalently)
 * - Ensures pathname ends with /
 * Throws a urlParseError if the provided URL is malformed and cannot be parsed.
 * @param url - URL to normalize
 * @param logger - Optional logger used to log parse failures
 * @param correlationId - Optional correlationId associated with the log entry
 * @returns Normalized URL string for comparison
 */ function $9ed9a547f6786bdc$var$normalizeUrlForComparison(url, logger, correlationId) {
    if (!url) return url;
    const urlWithoutHash = url.split("#")[0];
    if (!urlWithoutHash) return urlWithoutHash;
    try {
        const urlObj = new URL(urlWithoutHash);
        // Treat an empty query string (a bare trailing "?") as equivalent to no query
        if (!urlObj.search) urlObj.search = "";
        // Decode the pathname to normalize percent-encoding and ensure trailing slash
        let pathname;
        try {
            pathname = decodeURIComponent(urlObj.pathname);
        } catch (e) {
            pathname = urlObj.pathname;
        }
        if (!pathname.endsWith("/")) pathname += "/";
        urlObj.pathname = pathname;
        return urlObj.href;
    } catch (e) {
        logger?.error(`15apdm ${e}`, correlationId || "");
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, correlationId || "");
    }
}
/**
 * Validates that the provided value is a well-formed, parseable absolute URL.
 * Throws a urlParseError if the value cannot be parsed by the URL API (e.g. the
 * literal string "null", an empty string, or any malformed/relative URL). Use this
 * to guard against persisting an invalid value (such as a redirect URL) to the cache.
 * @param url - URL to validate
 * @param logger - Optional logger used to log validation failures
 * @param correlationId - Optional correlationId associated with the log entry
 */ function $9ed9a547f6786bdc$var$validateUrl(url, logger, correlationId) {
    try {
        new URL(url);
    } catch (e) {
        logger?.error(`1lrjz7 ${e}`, correlationId || "");
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, correlationId || "");
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Shared JOSE algorithm literals used by MSAL package internals.
 * @internal
 */ const $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms = {
    ES256: "ES256",
    RS256: "RS256"
};
/**
 * Default crypto implementation used when a platform-specific implementation has
 * not been provided.
 */ const $9ed9a547f6786bdc$var$DEFAULT_CRYPTO_IMPLEMENTATION = {
    createNewGuid: ()=>{
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    },
    base64Decode: ()=>{
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    },
    base64Encode: ()=>{
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    },
    base64UrlEncode: ()=>{
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    },
    encodeKid: ()=>{
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    },
    async removeTokenBindingKey (kid, correlationId) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, correlationId);
    },
    async clearKeystore (correlationId) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, correlationId);
    },
    async signTokenBindingJwt (header, payload, kid, correlationId) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, correlationId);
    },
    async hashString () {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Default token-binding key manager used when a platform-specific implementation
 * has not been provided.
 * @internal
 */ const $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER = {
    async provisionTokenBindingKey (request) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, request.correlationId);
    },
    async removeTokenBindingKey (_kid, correlationId) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, correlationId);
    },
    async getTokenBindingPublicKeyJwk (_kid, correlationId) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, correlationId);
    }
};
$9ed9a547f6786bdc$export$243e62d78d3b544d = void 0;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($9ed9a547f6786bdc$export$243e62d78d3b544d || ($9ed9a547f6786bdc$export$243e62d78d3b544d = {}));
// Shared cache state for better minification - using Map's insertion order for LRU
const $9ed9a547f6786bdc$var$CACHE_CAPACITY = 50;
const $9ed9a547f6786bdc$var$MAX_LOGS_PER_CORRELATION = 500;
const $9ed9a547f6786bdc$var$correlationCache = new Map();
/**
 * Mark correlation ID as recently used by moving it to end of Map
 * @param correlationId
 * @param {CorrelationLogData} data
 */ function $9ed9a547f6786bdc$var$markAsRecentlyUsed(correlationId, data) {
    $9ed9a547f6786bdc$var$correlationCache.delete(correlationId);
    $9ed9a547f6786bdc$var$correlationCache.set(correlationId, data);
}
/**
 * Add log message to cache for specific correlation ID
 * @param correlationId
 * @param {LoggedMessage} loggedMessage
 */ function $9ed9a547f6786bdc$var$addLogToCache(correlationId, loggedMessage) {
    const currentTime = Date.now();
    let data = $9ed9a547f6786bdc$var$correlationCache.get(correlationId);
    if (data) // Mark as recently used
    $9ed9a547f6786bdc$var$markAsRecentlyUsed(correlationId, data);
    else {
        // Create new entry
        data = {
            logs: [],
            firstEventTime: currentTime
        };
        $9ed9a547f6786bdc$var$correlationCache.set(correlationId, data);
        // Remove LRU (first entry) if capacity exceeded
        if ($9ed9a547f6786bdc$var$correlationCache.size > $9ed9a547f6786bdc$var$CACHE_CAPACITY) {
            const firstKey = $9ed9a547f6786bdc$var$correlationCache.keys().next().value;
            if (firstKey !== undefined) $9ed9a547f6786bdc$var$correlationCache.delete(firstKey);
        }
    }
    // Add log to the data, maintaining max logs per correlation
    data.logs.push({
        ...loggedMessage,
        milliseconds: currentTime - data.firstEventTime
    });
    if (data.logs.length > $9ed9a547f6786bdc$var$MAX_LOGS_PER_CORRELATION) data.logs.shift(); // Remove oldest log
}
/**
 * Get logs for correlation ID and flush them from cache
 * Attaches logs with empty correlation id to the requested correlation logs
 * @param correlationId
 */ function $9ed9a547f6786bdc$var$getAndFlushLogsFromCache(correlationId) {
    const res = [];
    for (const id of [
        "",
        correlationId
    ]){
        const data = $9ed9a547f6786bdc$var$correlationCache.get(id);
        res.push(...data?.logs ?? []);
        $9ed9a547f6786bdc$var$correlationCache.delete(id); // Remove the correlation ID completely from cache
    }
    return res;
}
/**
 * Extracts the leading minification hash from a log message, if present.
 *
 * Minified messages are produced by the logger-minify rollup plugin and are
 * either a bare 6-character alphanumeric hash, or that hash followed by a space
 * and runtime variables appended for local (console) logging, e.g.
 * "abc123 user-1 popup". Only the leading hash is returned so that telemetry
 * never captures the appended variables. Returns null when the message is not
 * a minified message.
 */ function $9ed9a547f6786bdc$var$getMessageHash(str) {
    if (str.length < 6) return null;
    /*
     * If the message is longer than the hash, the hash must be delimited by a
     * space (the separator the plugin inserts before appended variables).
     */ if (str.length > 6 && str[6] !== " ") return null;
    for(let i = 0; i < 6; i++){
        const char = str[i];
        const isAlphaNumeric = char >= "a" && char <= "z" || char >= "A" && char <= "Z" || char >= "0" && char <= "9";
        if (!isAlphaNumeric) return null;
    }
    return str.substring(0, 6);
}
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $9ed9a547f6786bdc$var$Logger {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $9ed9a547f6786bdc$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $9ed9a547f6786bdc$var$Logger.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $9ed9a547f6786bdc$export$243e62d78d3b544d.Info;
        this.packageName = packageName || "";
        this.packageVersion = packageVersion || "";
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion) {
        return new $9ed9a547f6786bdc$var$Logger({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        const correlationId = options.correlationId;
        const messageHash = $9ed9a547f6786bdc$var$getMessageHash(logMessage);
        if (messageHash) {
            const loggedMessage = {
                hash: messageHash,
                level: options.logLevel,
                containsPii: options.containsPii || false,
                milliseconds: 0
            };
            $9ed9a547f6786bdc$var$addLogToCache(correlationId, loggedMessage);
        }
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${correlationId}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$9ed9a547f6786bdc$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /* eslint-disable header/header */ const $9ed9a547f6786bdc$var$name$1 = "@azure/msal-common";
const $9ed9a547f6786bdc$var$version$1 = "16.14.1";
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$cacheQuotaExceeded = "cache_quota_exceeded";
const $9ed9a547f6786bdc$var$cacheErrorUnknown = "cache_error_unknown";
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the cache
 */ class $9ed9a547f6786bdc$var$CacheError extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || $9ed9a547f6786bdc$var$getDefaultErrorMessage$1(errorCode);
        super(message);
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$CacheError.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $9ed9a547f6786bdc$var$createCacheError(e) {
    if (!(e instanceof Error)) return new $9ed9a547f6786bdc$var$CacheError($9ed9a547f6786bdc$var$cacheErrorUnknown);
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $9ed9a547f6786bdc$var$CacheError($9ed9a547f6786bdc$var$cacheQuotaExceeded);
    else return new $9ed9a547f6786bdc$var$CacheError(e.name, e.message);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $9ed9a547f6786bdc$var$CacheManager {
    constructor(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions, tokenBindingKeyManager){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
        this.commonLogger = logger.clone($9ed9a547f6786bdc$var$name$1, $9ed9a547f6786bdc$var$version$1);
        this.staticAuthorityOptions = staticAuthorityOptions;
        this.performanceClient = performanceClient;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter = {}, correlationId) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        if (Object.keys(accountFilter).length === 0 || Object.values(accountFilter).every((value)=>value === null || value === undefined || value === "")) {
            this.commonLogger.warning("1skb02", correlationId);
            return null;
        }
        const allAccounts = this.getAllAccounts(accountFilter, correlationId);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((a, b)=>{
                const aHasClaims = a.idTokenClaims ? 1 : 0;
                const bHasClaims = b.idTokenClaims ? 1 : 0;
                return bHasClaims - aHasClaims;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return $9ed9a547f6786bdc$var$getAccountInfo(accountEntities[0]);
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(idToken.secret, this.cryptoImpl.base64Decode, correlationId);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = $9ed9a547f6786bdc$var$updateAccountTenantProfileData(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = $9ed9a547f6786bdc$var$getAccountInfo(accountEntity);
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        if (!!tenantProfileFilter.username && !this.matchUsername(tenantProfile.username, tenantProfileFilter.username) && !this.matchUsername(tenantProfile.upn, tenantProfileFilter.username)) return false;
        if (!!tenantProfileFilter.loginHint && !this.matchLoginHintWithTenantProfile(tenantProfile, tenantProfileFilter.loginHint)) return false;
        if (!!tenantProfileFilter.upn && !(tenantProfile.upn === tenantProfileFilter.upn)) return false;
        if (!!tenantProfileFilter.nativeAccountId && tenantProfile.nativeAccountId !== tenantProfileFilter.nativeAccountId) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username) && !this.matchUsername(idTokenClaims.upn, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        if (!cacheRecord) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidCacheRecord, correlationId);
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId, kmsi, apiId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId, kmsi);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId, kmsi);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId, kmsi);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error("0j476p", correlationId);
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) throw e;
            else throw $9ed9a547f6786bdc$var$createCacheError(e);
        }
    }
    /**
     * saves access token credential
     * @param credential - the access token entity to save
     * @param correlationId - unique identifier for the request
     * @param kmsi - keep me signed in flag
     */ async saveAccessToken(credential, correlationId, kmsi) {
        // Compute hash from components on the entity itself — no need to thread externally.
        let additionalCacheKeyHash;
        if (credential.additionalCacheKeyComponents && Object.keys(credential.additionalCacheKeyComponents).length > 0) additionalCacheKeyHash = await this.cryptoImpl.hashString(JSON.stringify(credential.additionalCacheKeyComponents));
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = $9ed9a547f6786bdc$var$ScopeSet.fromString(credential.target, correlationId);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter, correlationId)) {
                const tokenScopeSet = $9ed9a547f6786bdc$var$ScopeSet.fromString(tokenEntity.target, correlationId);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        await this.setAccessTokenCredential(credential, correlationId, kmsi, additionalCacheKeyHash);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            const entity = this.getAccount(cacheKey, correlationId);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment, correlationId)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name,
                username: accountFilter?.username,
                loginHint: accountFilter?.loginHint,
                upn: accountFilter?.upn,
                nativeAccountId: accountFilter?.nativeAccountId
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @param correlationId
     * @returns
     */ credentialMatchesFilter(entity, filter, correlationId) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target, correlationId)) return false;
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!this.matchAccessTokenWithAuthScheme(entity, filter)) return false;
        }
        // Additional cache key components matching (bidirectional isolation)
        const entityComponents = entity.additionalCacheKeyComponents;
        const filterComponents = filter.additionalCacheKeyComponents;
        const entityHasComponents = !!entityComponents && Object.keys(entityComponents).length > 0;
        const filterHasComponents = !!filterComponents && Object.keys(filterComponents).length > 0;
        if (entityHasComponents !== filterHasComponents) return false;
        if (entityHasComponents && filterHasComponents) {
            const entityKeys = Object.keys(entityComponents).sort();
            const filterKeys = Object.keys(filterComponents).sort();
            if (entityKeys.length !== filterKeys.length) return false;
            for(let i = 0; i < entityKeys.length; i++){
                if (entityKeys[i] !== filterKeys[i] || entityComponents[entityKeys[i]] !== filterComponents[filterKeys[i]]) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     * @param correlationId
     */ getAppMetadataFilteredBy(filter, correlationId) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param host
     * @param correlationId
     */ getAuthorityMetadataByAlias(host, correlationId) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ removeAllAccounts(correlationId) {
        const accounts = this.getAllAccounts({}, correlationId);
        accounts.forEach((account)=>{
            this.removeAccount(account, correlationId);
        });
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ removeAccount(account, correlationId) {
        this.removeAccountContext(account, correlationId);
        const accountKeys = this.getAccountKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        accountKeys.filter(keyFilter).forEach((key)=>{
            this.removeItem(key, correlationId);
            this.performanceClient.incrementFields({
                accountsRemoved: 1
            }, correlationId);
        });
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        allTokenKeys.idToken.filter(keyFilter).forEach((key)=>{
            this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.filter(keyFilter).forEach((key)=>{
            this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.filter(keyFilter).forEach((key)=>{
            this.removeRefreshToken(key, correlationId);
        });
    }
    /**
     * returns a boolean if the given credential is removed
     * @param key
     * @param correlationId
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        if (!credential) return;
        this.removeItem(key, correlationId);
        this.performanceClient.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        // Remove Token Binding Key from key store for token-bound access token credentials
        if (credential.credentialType.toLowerCase() === $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) {
            const tokenType = credential.tokenType?.toLowerCase();
            switch(tokenType){
                case $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP:
                case $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP.toLowerCase():
                    {
                        const accessTokenWithAuthSchemeEntity = credential;
                        const kid = accessTokenWithAuthSchemeEntity.keyId;
                        if (kid) this.tokenBindingKeyManager.removeTokenBindingKey(kid, correlationId).catch(()=>{
                            this.commonLogger.error("0id34f", correlationId);
                            this.performanceClient?.incrementFields({
                                removeTokenBindingKeyFailure: 1
                            }, correlationId);
                        });
                        break;
                    }
            }
        }
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm) {
        this.commonLogger.trace("1drz22", correlationId);
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: $9ed9a547f6786bdc$var$CredentialType.ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("1atvtd", correlationId);
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("0ooalx", correlationId);
                    return idTokenMap.values().next().value ?? null;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("1eq2vc", correlationId);
                    return homeIdTokenMap.values().next().value ?? null;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("1ws328", correlationId);
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("1sm769", correlationId);
        return idTokenMap.values().next().value ?? null;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter, correlationId)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getAccessToken(account, request, tokenKeys, targetRealm) {
        const correlationId = request.correlationId;
        this.commonLogger.trace("1t7hz1", correlationId);
        const scopes = $9ed9a547f6786bdc$var$ScopeSet.createSearchScopes(request.scopes, correlationId);
        const authScheme = request.authenticationScheme || $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER.toLowerCase() ? $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME : $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN;
        const attributeTokenPartition = $9ed9a547f6786bdc$var$serializeAttributeTokens(request.attributeTokens);
        const additionalCacheKeyComponents = attributeTokenPartition ? {
            attribute_tokens: attributeTokenPartition
        } : undefined;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: authScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH ? request.sshKid : undefined,
            additionalCacheKeyComponents: additionalCacheKeyComponents
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        const matchedKeys = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter, correlationId)) {
                    accessTokens.push(accessToken);
                    matchedKeys.push(key);
                }
            }
        });
        if (accessTokens.length < 1) {
            this.commonLogger.info("1nckna", correlationId);
            return null;
        } else if (accessTokens.length > 1) {
            this.commonLogger.info("1wkfwp", correlationId);
            matchedKeys.forEach((key)=>{
                this.removeAccessToken(key, correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("06yt98", correlationId);
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter, correlationId)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys) {
        this.commonLogger.trace("0x53vi", correlationId);
        const id = familyRT ? $9ed9a547f6786bdc$var$THE_FAMILY_ID : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: $9ed9a547f6786bdc$var$CredentialType.REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter, correlationId)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("0dlw11", correlationId);
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1) this.performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("0wcnep", correlationId);
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment, correlationId) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter, correlationId);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$multipleMatchingAppMetadata, correlationId);
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment, correlationId) {
        const appMetadata = this.readAppMetadataFromCache(environment, correlationId);
        return !!(appMetadata && appMetadata.familyId === $9ed9a547f6786bdc$var$THE_FAMILY_ID);
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match loginhints
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintWithTenantProfile(tenantProfile, loginHintFilter) {
        return tenantProfile.loginHint === loginHintFilter || tenantProfile.username === loginHintFilter || tenantProfile.upn === loginHintFilter;
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment, correlationId) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = $9ed9a547f6786bdc$var$getAliasesFromStaticSources(this.staticAuthorityOptions, this.commonLogger, correlationId);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment, correlationId);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        // check login hint against list of emails in token claims
        if (tokenClaims.emails && tokenClaims.emails.includes(loginHint)) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target, correlationId) {
        const isNotAccessTokenCredential = entity.credentialType !== $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN && entity.credentialType !== $9ed9a547f6786bdc$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = $9ed9a547f6786bdc$var$ScopeSet.fromString(entity.target, correlationId);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType.toLowerCase() === tokenType.toLowerCase());
    }
    matchAccessTokenWithAuthScheme(entity, filter) {
        const normalizedFilterTokenType = filter.tokenType?.toLowerCase();
        if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
        switch(normalizedFilterTokenType){
            case "dpop":
            case $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH:
                return this.matchKeyBoundAccessToken(entity, filter);
            default:
                return true;
        }
    }
    matchKeyBoundAccessToken(entity, filter) {
        if (!filter.keyId) return true;
        return this.matchKeyId(entity, filter.keyId);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf($9ed9a547f6786bdc$var$APP_METADATA) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf($9ed9a547f6786bdc$var$AUTHORITY_METADATA_CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${$9ed9a547f6786bdc$var$AUTHORITY_METADATA_CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $9ed9a547f6786bdc$var$DefaultStorageClass extends $9ed9a547f6786bdc$var$CacheManager {
    async setAccount() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getAccount() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    async setIdTokenCredential() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getIdTokenCredential() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    async setAccessTokenCredential() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getAccessTokenCredential() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    async setRefreshTokenCredential() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getRefreshTokenCredential() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    setAppMetadata() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getAppMetadata() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    setServerTelemetry() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getServerTelemetry() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    setAuthorityMetadata() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getAuthorityMetadata() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getAuthorityMetadataKeys() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    setThrottlingCache() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getThrottlingCache() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    removeItem() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getKeys() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getAccountKeys() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    getTokenKeys() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */ generateCredentialKey(_credential, _hash) {
        /* eslint-enable @typescript-eslint/no-unused-vars */ throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    generateAccountKey() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $9ed9a547f6786bdc$var$PerformanceEventStatus = {
    InProgress: 1,
    Completed: 2
};
/**
 * Prefix used to mark telemetry field names as dynamic.
 * Fields with this prefix in addFields/incrementFields calls will be routed
 * to the PerformanceEvent.ext sub-object.
 */ const $9ed9a547f6786bdc$var$EXT_FIELD_PREFIX = "ext.";
const $9ed9a547f6786bdc$var$IntFields = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount",
    "oldAccountCount",
    "oldAccessCount",
    "oldIdCount",
    "oldRefreshCount",
    "currAccountCount",
    "currAccessCount",
    "currIdCount",
    "currRefreshCount",
    "ttlExpiredAcntCount",
    "ttlExpiredITCount",
    "ttlExpiredATCount",
    "ttlExpiredRTCount",
    "decryptFailedAcntCount",
    "decryptFailedITCount",
    "decryptFailedATCount",
    "decryptFailedRTCount",
    "invalidAcntCount",
    "invalidITCount",
    "invalidATCount",
    "invalidRTCount",
    "expiredATCount",
    "expiredRTCount",
    "upgradedCacheCount",
    "cacheMatchedAccounts",
    "networkRtt",
    "redirectBridgeTimeoutMs",
    "redirectBridgeMessageVersion",
    "fetchRetryCount"
]);
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$StubPerformanceClient {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: $9ed9a547f6786bdc$var$PerformanceEventStatus.InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            }
        };
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    addGlobalFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$DEFAULT_SYSTEM_OPTIONS = {
    tokenRenewalOffsetSeconds: $9ed9a547f6786bdc$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC,
    preventCorsPreflight: false
};
const $9ed9a547f6786bdc$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Info,
    correlationId: ""
};
const $9ed9a547f6786bdc$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    },
    async sendPostRequestAsync () {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
};
const $9ed9a547f6786bdc$var$DEFAULT_LIBRARY_INFO = {
    sku: $9ed9a547f6786bdc$var$SKU,
    version: $9ed9a547f6786bdc$var$version$1,
    cpu: "",
    os: ""
};
const $9ed9a547f6786bdc$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: "",
    clientAssertion: undefined
};
const $9ed9a547f6786bdc$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: $9ed9a547f6786bdc$var$AzureCloudInstance.None,
    tenant: `${$9ed9a547f6786bdc$var$DEFAULT_COMMON_TENANT}`
};
const $9ed9a547f6786bdc$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 * @internal
 */ function $9ed9a547f6786bdc$var$buildClientConfiguration({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, tokenBindingKeyManager: tokenBindingKeyManager, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$9ed9a547f6786bdc$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    const resolvedTokenBindingKeyManager = tokenBindingKeyManager || $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER;
    return {
        authOptions: $9ed9a547f6786bdc$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$9ed9a547f6786bdc$var$DEFAULT_SYSTEM_OPTIONS,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        storageInterface: storageImplementation || new $9ed9a547f6786bdc$var$DefaultStorageClass(userAuthOptions.clientId, $9ed9a547f6786bdc$var$DEFAULT_CRYPTO_IMPLEMENTATION, new $9ed9a547f6786bdc$var$Logger(loggerOptions, $9ed9a547f6786bdc$var$name$1, $9ed9a547f6786bdc$var$version$1), new $9ed9a547f6786bdc$var$StubPerformanceClient(), undefined, resolvedTokenBindingKeyManager),
        networkInterface: networkImplementation || $9ed9a547f6786bdc$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || $9ed9a547f6786bdc$var$DEFAULT_CRYPTO_IMPLEMENTATION,
        tokenBindingKeyManager: resolvedTokenBindingKeyManager,
        clientCredentials: clientCredentials || $9ed9a547f6786bdc$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$9ed9a547f6786bdc$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$9ed9a547f6786bdc$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $9ed9a547f6786bdc$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $9ed9a547f6786bdc$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        instanceAware: false,
        isMcp: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $9ed9a547f6786bdc$var$isOidcProtocolMode(config) {
    return config.authOptions.authority.options.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.OIDC;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $9ed9a547f6786bdc$var$TokenCacheContext {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $9ed9a547f6786bdc$var$JoseHeaderError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$JoseHeaderError.prototype);
    }
}
/** Returns JoseHeaderError object */ function $9ed9a547f6786bdc$var$createJoseHeaderError(code, correlationId) {
    return new $9ed9a547f6786bdc$var$JoseHeaderError(code, correlationId);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks whether a value is a plain JSON-like object.
 * Allows objects with null prototypes, but rejects arrays and object subclasses.
 */ function $9ed9a547f6786bdc$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$missingKidError = "missing_kid_error";
const $9ed9a547f6786bdc$var$missingAlgError = "missing_alg_error";
const $9ed9a547f6786bdc$var$missingJwkError = "missing_jwk_error";
const $9ed9a547f6786bdc$var$invalidJwkError = "invalid_jwk_error";
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9ed9a547f6786bdc$var$JoseHeader {
    constructor(options, correlationId){
        if (typeof options.alg !== "string" || !options.alg) throw $9ed9a547f6786bdc$var$createJoseHeaderError($9ed9a547f6786bdc$var$missingAlgError, correlationId);
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
        this.jwk = options.jwk;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @param correlationId
     * @returns
     */ static getShrHeader(shrHeaderOptions, correlationId) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw $9ed9a547f6786bdc$var$createJoseHeaderError($9ed9a547f6786bdc$var$missingKidError, correlationId);
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw $9ed9a547f6786bdc$var$createJoseHeaderError($9ed9a547f6786bdc$var$missingAlgError, correlationId);
        return new $9ed9a547f6786bdc$var$JoseHeader({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || $9ed9a547f6786bdc$var$JsonWebTokenTypes$1.Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        }, correlationId);
    }
    /**
     * Builds a DPoP formatted JOSE Header from the JOSE Header options provided.
     * Throws if public JWK or algorithm aren't provided since they are required for DPoP.
     * @param dpopHeaderOptions
     * @param correlationId
     * @returns
     */ static getDpopHeader(dpopHeaderOptions, correlationId) {
        if (!$9ed9a547f6786bdc$var$isPlainObject(dpopHeaderOptions.jwk)) throw $9ed9a547f6786bdc$var$createJoseHeaderError($9ed9a547f6786bdc$var$missingJwkError, correlationId);
        if (!dpopHeaderOptions.alg) throw $9ed9a547f6786bdc$var$createJoseHeaderError($9ed9a547f6786bdc$var$missingAlgError, correlationId);
        if (Object.keys(dpopHeaderOptions.jwk).length === 0) throw $9ed9a547f6786bdc$var$createJoseHeaderError($9ed9a547f6786bdc$var$invalidJwkError, correlationId);
        return new $9ed9a547f6786bdc$var$JoseHeader({
            typ: $9ed9a547f6786bdc$var$JsonWebTokenTypes$1.Dpop,
            alg: dpopHeaderOptions.alg,
            jwk: dpopHeaderOptions.jwk
        }, correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$KeyLocation = {
    SW: "sw"
};
const $9ed9a547f6786bdc$var$SHR_TOKEN_BINDING_KEY_TYPE = "shr";
const $9ed9a547f6786bdc$var$SHR_TOKEN_BINDING_KEY_ALGORITHM = $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.RS256;
/** @internal */ class $9ed9a547f6786bdc$var$PopTokenGenerator {
    constructor(cryptoUtils, tokenBindingKeyManager, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        const reqCnf = await $9ed9a547f6786bdc$var$invokeAsync(this.generateKid.bind(this), $9ed9a547f6786bdc$var$PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        const kidThumbprint = await this.tokenBindingKeyManager.provisionTokenBindingKey({
            correlationId: request.correlationId,
            tokenBindingKeyType: $9ed9a547f6786bdc$var$SHR_TOKEN_BINDING_KEY_TYPE,
            tokenBindingKeyAlgorithm: $9ed9a547f6786bdc$var$SHR_TOKEN_BINDING_KEY_ALGORITHM
        });
        return {
            kid: kidThumbprint,
            xms_ksl: $9ed9a547f6786bdc$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new $9ed9a547f6786bdc$var$UrlString(resourceRequestUri, request.correlationId) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        const publicKeyJwk = await this.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(keyId, request.correlationId);
        const encodedKeyIdThumbprint = this.cryptoUtils.base64UrlEncode(JSON.stringify({
            kid: keyId
        }));
        const shrAlgorithm = shrOptions?.header?.alg || publicKeyJwk.alg || $9ed9a547f6786bdc$var$SHR_TOKEN_BINDING_KEY_ALGORITHM;
        const shrHeader = $9ed9a547f6786bdc$var$JoseHeader.getShrHeader({
            ...shrOptions?.header,
            alg: shrAlgorithm,
            kid: encodedKeyIdThumbprint
        }, request.correlationId);
        const shrPayload = {
            at: payload,
            ts: $9ed9a547f6786bdc$var$nowSeconds(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims,
            cnf: {
                jwk: publicKeyJwk
            }
        };
        return this.cryptoUtils.signTokenBindingJwt(shrHeader, shrPayload, keyId, request.correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$DPOP_HTM_REGEX = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
const $9ed9a547f6786bdc$var$DPOP_TOKEN_BINDING_KEY_TYPE = "dpop";
const $9ed9a547f6786bdc$var$DPOP_JWT_HEADER_ALGORITHM = $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.ES256;
function $9ed9a547f6786bdc$var$buildProofHeader(publicJwk, correlationId) {
    return $9ed9a547f6786bdc$var$JoseHeader.getDpopHeader({
        alg: $9ed9a547f6786bdc$var$DPOP_JWT_HEADER_ALGORITHM,
        jwk: publicJwk
    }, correlationId);
}
function $9ed9a547f6786bdc$var$normalizeHtm(htm, correlationId) {
    if (typeof htm !== "string" || !$9ed9a547f6786bdc$var$DPOP_HTM_REGEX.test(htm)) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidDpopHtm, correlationId);
    return htm.toUpperCase();
}
/**
 * Normalizes a URL for use as the DPoP htu claim.
 * Per RFC 9449 §4.2, htu is the target URI without query and fragment components.
 * WHATWG URL serialization handles RFC 3986 syntax- and scheme-based normalization
 * such as lowercasing scheme/host and eliding default ports.
 */ function $9ed9a547f6786bdc$var$normalizeHtu(url, correlationId) {
    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch  {
        throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$urlParseError, correlationId);
    }
    if (!/^https:\/\//i.test(url) || parsedUrl.protocol !== "https:" || parsedUrl.username || parsedUrl.password) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidDpopHtu, correlationId);
    parsedUrl.search = "";
    parsedUrl.hash = "";
    return parsedUrl.href;
}
function $9ed9a547f6786bdc$var$validateDpopNonce(nonce, correlationId) {
    if (nonce !== undefined && nonce.trim().length === 0) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidDpopNonce, correlationId);
}
/**
 * Builds RFC 9449 DPoP proof JWT payloads for token-endpoint and
 * resource-endpoint proof bindings.
 *
 * Not exported from any public package entry point.
 * This helper is internal-only until DPoP is wired into acquisition flows
 * in a subsequent work item.
 *
 * DPoP proofs do not contain SHR fields (at, ts, m, u, p, q).
 * @internal
 */ class $9ed9a547f6786bdc$var$DpopProofGenerator {
    constructor(cryptoUtils, tokenBindingKeyManager){
        this.cryptoUtils = cryptoUtils;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
    }
    /**
     * Provisions a fresh DPoP key and returns the RFC 7638 JWK thumbprint used
     * as `dpop_jkt`.
     */ async generateJkt(correlationId = "") {
        return this.tokenBindingKeyManager.provisionTokenBindingKey({
            tokenBindingKeyType: $9ed9a547f6786bdc$var$DPOP_TOKEN_BINDING_KEY_TYPE,
            tokenBindingKeyAlgorithm: $9ed9a547f6786bdc$var$DPOP_JWT_HEADER_ALGORITHM,
            correlationId: correlationId
        });
    }
    /**
     * Builds RFC 9449 claims for a token-endpoint DPoP proof.
     * - htm is always "POST" because token endpoint requests use HTTP POST (RFC 9449 §5).
     * - htu is the normalized token endpoint URI (query and fragment stripped).
     * - jti is a fresh CSPRNG-backed unique identifier for every proof.
     */ buildTokenProofClaims(params, correlationId = "") {
        $9ed9a547f6786bdc$var$validateDpopNonce(params.nonce, correlationId);
        const claims = {
            jti: this.cryptoUtils.createNewGuid(),
            htm: "POST",
            htu: $9ed9a547f6786bdc$var$normalizeHtu(params.tokenEndpoint, correlationId),
            iat: $9ed9a547f6786bdc$var$nowSeconds()
        };
        if (params.nonce !== undefined) claims.nonce = params.nonce;
        return claims;
    }
    /**
     * Builds and signs a compact DPoP proof JWT for a token-endpoint request.
     */ async generateTokenProof(params, keyId, correlationId = "") {
        return this.generateProof(this.buildTokenProofClaims(params, correlationId), keyId, correlationId);
    }
    /**
     * Builds RFC 9449 claims for a resource-endpoint DPoP proof.
     * - htm is uppercased per RFC 9449 §4.2.
     * - htu is the normalized resource URI (query and fragment stripped).
     * - ath is the base64url-encoded SHA-256 hash of the ASCII access token.
     * - jti is a fresh CSPRNG-backed unique identifier for every proof.
     */ buildResourceProofClaims(params, correlationId = "") {
        $9ed9a547f6786bdc$var$validateDpopNonce(params.nonce, correlationId);
        const claims = {
            jti: this.cryptoUtils.createNewGuid(),
            htm: $9ed9a547f6786bdc$var$normalizeHtm(params.htm, correlationId),
            htu: $9ed9a547f6786bdc$var$normalizeHtu(params.htu, correlationId),
            ath: params.ath,
            iat: $9ed9a547f6786bdc$var$nowSeconds()
        };
        if (params.nonce !== undefined) claims.nonce = params.nonce;
        return claims;
    }
    /**
     * Builds and signs a compact DPoP proof JWT for a resource request.
     */ async generateResourceProof(params, keyId, correlationId = "") {
        const { htu: htu, htm: htm, nonce: nonce } = params;
        if (!htu || !htm) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$dpopMissingResourceContext, correlationId);
        const ath = await this.cryptoUtils.hashString(params.accessToken);
        return this.generateProof(this.buildResourceProofClaims({
            htu: htu,
            htm: htm,
            ath: ath,
            nonce: nonce
        }, correlationId), keyId, correlationId);
    }
    async generateProof(claims, keyId, correlationId) {
        const publicJwk = await this.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(keyId, correlationId);
        return this.cryptoUtils.signTokenBindingJwt($9ed9a547f6786bdc$var$buildProofHeader(publicJwk, correlationId), claims, keyId, correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * MSAL-defined interaction required error code indicating no tokens are found in cache.
 * @public
 */ const $9ed9a547f6786bdc$var$noTokensFound = "no_tokens_found";
/**
 * MSAL-defined error code indicating a native account is unavailable on the platform.
 * @public
 */ const $9ed9a547f6786bdc$var$nativeAccountUnavailable = "native_account_unavailable";
/**
 * MSAL-defined error code indicating the refresh token has expired and user interaction is needed.
 * @public
 */ const $9ed9a547f6786bdc$var$refreshTokenExpired = "refresh_token_expired";
/**
 * MSAL-defined error code indicating UI/UX is not allowed (e.g., blocked by policy), requiring alternate interaction.
 * @public
 */ const $9ed9a547f6786bdc$var$uiNotAllowed = "ui_not_allowed";
/**
 * Server-originated error code indicating interaction is required to complete the request.
 * @public
 */ const $9ed9a547f6786bdc$var$interactionRequired = "interaction_required";
/**
 * Server-originated error code indicating user consent is required.
 * @public
 */ const $9ed9a547f6786bdc$var$consentRequired = "consent_required";
/**
 * Server-originated error code indicating user login is required.
 * @public
 */ const $9ed9a547f6786bdc$var$loginRequired = "login_required";
/**
 * Server-originated error code indicating the token is invalid or corrupted.
 * @public
 */ const $9ed9a547f6786bdc$var$badToken = "bad_token";
/**
 * Server-originated error code indicating the user is in an interrupted state and interaction is required.
 * @public
 */ const $9ed9a547f6786bdc$var$interruptedUser = "interrupted_user";
var $9ed9a547f6786bdc$var$InteractionRequiredAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    badToken: $9ed9a547f6786bdc$var$badToken,
    consentRequired: $9ed9a547f6786bdc$var$consentRequired,
    interactionRequired: $9ed9a547f6786bdc$var$interactionRequired,
    interruptedUser: $9ed9a547f6786bdc$var$interruptedUser,
    loginRequired: $9ed9a547f6786bdc$var$loginRequired,
    nativeAccountUnavailable: $9ed9a547f6786bdc$var$nativeAccountUnavailable,
    noTokensFound: $9ed9a547f6786bdc$var$noTokensFound,
    refreshTokenExpired: $9ed9a547f6786bdc$var$refreshTokenExpired,
    uiNotAllowed: $9ed9a547f6786bdc$var$uiNotAllowed
});
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $9ed9a547f6786bdc$var$InteractionRequiredServerErrorMessage = [
    $9ed9a547f6786bdc$var$interactionRequired,
    $9ed9a547f6786bdc$var$consentRequired,
    $9ed9a547f6786bdc$var$loginRequired,
    $9ed9a547f6786bdc$var$badToken,
    $9ed9a547f6786bdc$var$uiNotAllowed,
    $9ed9a547f6786bdc$var$interruptedUser
];
const $9ed9a547f6786bdc$var$InteractionRequiredAuthSubErrorMessage = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token",
    "ui_not_allowed",
    "interrupted_user"
];
/**
 * Error thrown when user interaction is required.
 */ class $9ed9a547f6786bdc$var$InteractionRequiredAuthError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, errorMessage, subError, timestamp, traceId, claims, errorNo){
        super(errorCode, correlationId, errorMessage, subError);
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$InteractionRequiredAuthError.prototype);
        this.timestamp = timestamp || "";
        this.traceId = traceId || "";
        this.claims = claims || "";
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $9ed9a547f6786bdc$var$isInteractionRequiredError(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $9ed9a547f6786bdc$var$InteractionRequiredServerErrorMessage.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $9ed9a547f6786bdc$var$InteractionRequiredAuthSubErrorMessage.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $9ed9a547f6786bdc$var$InteractionRequiredServerErrorMessage.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $9ed9a547f6786bdc$var$createInteractionRequiredAuthError(errorCode, correlationId, errorMessage) {
    return new $9ed9a547f6786bdc$var$InteractionRequiredAuthError(errorCode, correlationId, errorMessage);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $9ed9a547f6786bdc$var$ServerError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, errorMessage, subError, errorNo, status){
        super(errorCode, correlationId, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$ServerError.prototype);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Appends user state with random guid, or returns random guid.
 * @param cryptoObj
 * @param userState
 * @param meta
 * @param correlationId
 */ function $9ed9a547f6786bdc$var$setRequestState(cryptoObj, userState, meta, correlationId) {
    const libraryState = $9ed9a547f6786bdc$var$generateLibraryState(cryptoObj, correlationId, meta);
    return userState ? `${libraryState}${$9ed9a547f6786bdc$var$RESOURCE_DELIM}${userState}` : libraryState;
}
/**
 * Generates the state value used by the common library.
 * @param cryptoObj
 * @param correlationId
 * @param meta
 */ function $9ed9a547f6786bdc$var$generateLibraryState(cryptoObj, correlationId, meta) {
    if (!cryptoObj) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$noCryptoObject, correlationId);
    // Create a state object containing a unique id and the timestamp of the request creation
    const stateObj = {
        id: cryptoObj.createNewGuid()
    };
    if (meta) stateObj.meta = meta;
    const stateString = JSON.stringify(stateObj);
    return cryptoObj.base64Encode(stateString);
}
/**
 * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
 * @param base64Decode
 * @param state
 * @param correlationId
 */ function $9ed9a547f6786bdc$var$parseRequestState(base64Decode, state, correlationId) {
    if (!base64Decode) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$noCryptoObject, correlationId);
    if (!state) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidState, correlationId);
    try {
        // Split the state between library state and user passed state and decode them separately
        const splitState = state.split($9ed9a547f6786bdc$var$RESOURCE_DELIM);
        const libraryState = splitState[0];
        const userState = splitState.length > 1 ? splitState.slice(1).join($9ed9a547f6786bdc$var$RESOURCE_DELIM) : "";
        const libraryStateString = base64Decode(libraryState);
        const libraryStateObj = JSON.parse(libraryStateString);
        return {
            userRequestState: userState || "",
            libraryState: libraryStateObj
        };
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidState, correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class $9ed9a547f6786bdc$var$ResponseHandler {
    constructor(clientId, cacheStorage, cryptoObj, logger, performanceClient, serializableCache, persistencePlugin, tokenBindingKeyManager = $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param correlationId
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, correlationId, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || $9ed9a547f6786bdc$var$NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || $9ed9a547f6786bdc$var$NOT_AVAILABLE} - Description: ${serverResponse.error_description || $9ed9a547f6786bdc$var$NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || $9ed9a547f6786bdc$var$NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || $9ed9a547f6786bdc$var$NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new $9ed9a547f6786bdc$var$ServerError(serverResponse.error || "", serverResponse.correlation_id || "", errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= $9ed9a547f6786bdc$var$HTTP_SERVER_ERROR_RANGE_START && serverResponse.status <= $9ed9a547f6786bdc$var$HTTP_SERVER_ERROR_RANGE_END) {
                this.logger.warning(`16ks7j ${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= $9ed9a547f6786bdc$var$HTTP_CLIENT_ERROR_RANGE_START && serverResponse.status <= $9ed9a547f6786bdc$var$HTTP_CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`0g61x3 ${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ($9ed9a547f6786bdc$var$isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new $9ed9a547f6786bdc$var$InteractionRequiredAuthError(serverResponse.error || "", serverResponse.correlation_id || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, apiId, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId, additionalCacheKeyComponents) {
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(serverTokenResponse.id_token || "", this.cryptoObj.base64Decode, request.correlationId);
        /*
         * Callers opt in to strict nonce-presence validation by including
         * the nonce property, even when its value is undefined.
         */ if (authCodePayload && Object.prototype.hasOwnProperty.call(authCodePayload, "nonce")) {
            const expectedNonce = authCodePayload.nonce;
            const tokenNonce = idTokenClaims?.nonce;
            // Warn when the ID Token nonce cannot be bound to the request.
            if (tokenNonce !== undefined && expectedNonce === undefined) {
                this.logger.warning("0thba9", request.correlationId);
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$nonceMismatch, request.correlationId);
            }
            // If the request supplies a nonce, the ID Token value must be a matching string.
            if (expectedNonce !== undefined && (typeof expectedNonce !== "string" || typeof tokenNonce !== "string" || expectedNonce !== tokenNonce)) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$nonceMismatch, request.correlationId);
        }
        // generate homeAccountId
        this.homeAccountIdentifier = $9ed9a547f6786bdc$var$generateHomeAccountId(serverTokenResponse.client_info || "", authority.authorityType, this.logger, this.cryptoObj, request.correlationId, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = $9ed9a547f6786bdc$var$parseRequestState(this.cryptoObj.base64Decode, authCodePayload.state, request.correlationId);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.dpopJkt || request.sshKid || undefined;
        if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP) {
            if (serverTokenResponse.token_type?.toLowerCase() !== $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP.toLowerCase()) {
                this.performanceClient?.addFields({
                    dpopTokenTypeMismatch: serverTokenResponse.token_type
                }, request.correlationId);
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$dpopTokenTypeMismatch, request.correlationId);
            }
            serverTokenResponse.token_type = $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP;
        }
        // Compute components once for entity storage (fallback if hash not provided by client)
        const attributeTokenPartition = $9ed9a547f6786bdc$var$serializeAttributeTokens(request.attributeTokens);
        const cacheKeyComponents = additionalCacheKeyComponents ?? (attributeTokenPartition ? {
            attribute_tokens: attributeTokenPartition
        } : undefined);
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, cacheKeyComponents);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("0jbz5k", request.correlationId);
                cacheContext = new $9ed9a547f6786bdc$var$TokenCacheContext(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const cachedAccounts = this.cacheStorage.getAllAccounts({
                    homeAccountId: cacheRecord.account.homeAccountId,
                    environment: cacheRecord.account.environment
                }, request.correlationId);
                if (cachedAccounts.length < 1) {
                    this.logger.warning("1gmt66", request.correlationId);
                    this.performanceClient?.addFields({
                        acntLoggedOut: true
                    }, request.correlationId);
                    return await $9ed9a547f6786bdc$var$ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, {
                        idTokenClaims: idTokenClaims,
                        requestState: requestStateObj,
                        requestId: serverRequestId,
                        tokenBindingKeyManager: this.tokenBindingKeyManager
                    });
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, $9ed9a547f6786bdc$var$isKmsi(idTokenClaims || {}), apiId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("1bh17u", request.correlationId);
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $9ed9a547f6786bdc$var$ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, {
            idTokenClaims: idTokenClaims,
            requestState: requestStateObj,
            serverTokenResponse: serverTokenResponse,
            requestId: serverRequestId,
            tokenBindingKeyManager: this.tokenBindingKeyManager
        });
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, additionalCacheKeyComponents) {
        const env = authority.getPreferredCache();
        if (!env) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidCacheEnvironment, request.correlationId);
        const claimsTenantId = $9ed9a547f6786bdc$var$getTenantIdFromIdTokenClaims(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = $9ed9a547f6786bdc$var$createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $9ed9a547f6786bdc$var$buildAccountToCache(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger, this.performanceClient);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? $9ed9a547f6786bdc$var$ScopeSet.fromString(serverTokenResponse.scope, request.correlationId) : new $9ed9a547f6786bdc$var$ScopeSet(request.scopes || [], request.correlationId);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = $9ed9a547f6786bdc$var$createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, request.correlationId, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, additionalCacheKeyComponents);
            // Set resource (to be used for MCP scenarios)
            const resource = request.resource || null;
            if (resource) cachedAccessToken.resource = resource;
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
                this.performanceClient?.addFields({
                    ntwkRtExpiresOnSeconds: rtExpiresOn
                }, request.correlationId);
            }
            cachedRefreshToken = $9ed9a547f6786bdc$var$createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, performanceClient, options = {}) {
        const { idTokenClaims: idTokenClaims, requestState: requestState, serverTokenResponse: serverTokenResponse, requestId: requestId, tokenBindingKeyManager: tokenBindingKeyManager = $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER } = options;
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = "";
        let dpopProof;
        if (cacheRecord.accessToken) {
            const accessTokenType = cacheRecord.accessToken.tokenType?.toLowerCase();
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP && !request.popKid) {
                const popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(cryptoObj, tokenBindingKeyManager, performanceClient);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$keyIdMissing, request.correlationId);
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            if (accessTokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP.toLowerCase()) {
                if (!cacheRecord.accessToken.keyId) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$keyIdMissing, request.correlationId);
                const dpopProofGenerator = new $9ed9a547f6786bdc$var$DpopProofGenerator(cryptoObj, tokenBindingKeyManager);
                dpopProof = await dpopProofGenerator.generateResourceProof({
                    htu: request.resourceRequestUri,
                    htm: request.resourceRequestMethod,
                    accessToken: cacheRecord.accessToken.secret
                }, cacheRecord.accessToken.keyId, request.correlationId);
            }
            responseScopes = $9ed9a547f6786bdc$var$ScopeSet.fromString(cacheRecord.accessToken.target, request.correlationId).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = $9ed9a547f6786bdc$var$toDateFromSeconds(cacheRecord.accessToken.expiresOn);
            extExpiresOn = $9ed9a547f6786bdc$var$toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = $9ed9a547f6786bdc$var$toDateFromSeconds(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === $9ed9a547f6786bdc$var$THE_FAMILY_ID ? $9ed9a547f6786bdc$var$THE_FAMILY_ID : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        /*
         * Surface the sovereign enclave for telemetry. This runs for both freshly acquired
         * and cache-served tokens because SilentFlowClient shares this method, so the field
         * is present on silent requests that never hit the network.
         */ const regionSubScope = idTokenClaims?.tenant_region_sub_scope;
        if (typeof regionSubScope === "string") performanceClient?.addFields({
            regionSubScope: regionSubScope
        }, request.correlationId);
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) {
            // Set on deprecated top-level for downgrade compat
            cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
            // Set on the matching tenant profile (source of truth)
            const targetTenantId = tid || cacheRecord.account.realm;
            if (cacheRecord.account.tenantProfiles) {
                const matchingProfile = cacheRecord.account.tenantProfiles.find((tp)=>tp.tenantId === targetTenantId);
                if (matchingProfile) matchingProfile.nativeAccountId = serverTokenResponse.spa_accountid;
            }
        }
        const accountInfo = cacheRecord.account ? $9ed9a547f6786bdc$var$updateAccountTenantProfileData($9ed9a547f6786bdc$var$getAccountInfo(cacheRecord.account), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            dpopProof: dpopProof,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || "",
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType?.toLowerCase() === $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP.toLowerCase() ? $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP : cacheRecord.accessToken?.tokenType || "",
            state: requestState ? requestState.userRequestState : "",
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || "",
            msGraphHost: cacheRecord.account?.msGraphHost || "",
            code: serverTokenResponse?.spa_code,
            fromPlatformBroker: false
        };
    }
}
/** @internal */ function $9ed9a547f6786bdc$var$buildAccountToCache(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger, performanceClient) {
    logger?.verbose("09jz0t", correlationId);
    /*
     * Check if base account is already cached. Filter by homeAccountId (identifies
     * the user's home identity) and environment (identifies the cloud) — the two
     * tenant-agnostic properties that uniquely locate a base AccountEntity.
     */ const accountEnvironment = environment || authority.getPreferredCache();
    const matchedAccounts = cacheStorage.getAccountsFilteredBy({
        homeAccountId: homeAccountId,
        environment: accountEnvironment
    }, correlationId);
    performanceClient?.addFields({
        cacheMatchedAccounts: matchedAccounts.length
    }, correlationId);
    if (matchedAccounts.length > 1) /*
         * Base accounts are expected to be unique for a given homeAccountId in normal cache usage.
         * If multiple matches exist, ignore the cache hit rather than arbitrarily choosing one.
         */ logger?.warning("0x7ad1", correlationId);
    const cachedAccount = matchedAccounts.length === 1 ? matchedAccounts[0] : null;
    const baseAccount = cachedAccount || $9ed9a547f6786bdc$var$createAccountEntity({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, correlationId, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = $9ed9a547f6786bdc$var$buildTenantProfile(homeAccountId, baseAccount.localAccountId, tenantId, nativeAccountId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$CcsCredentialType = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $9ed9a547f6786bdc$var$getClientAssertion(clientAssertion, clientId, tokenEndpoint, fmiPath) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            fmiPath: fmiPath
        };
        return clientAssertion(config);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$getRequestThumbprint(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.extraParameters?.clientId,
        resource: request.resource,
        attributeTokens: $9ed9a547f6786bdc$var$serializeAttributeTokens(request.attributeTokens)
    };
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9ed9a547f6786bdc$var$ThrottlingUtils {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${$9ed9a547f6786bdc$var$THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $9ed9a547f6786bdc$var$ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key, correlationId);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new $9ed9a547f6786bdc$var$ServerError(value.errorCodes?.join(" ") || "", correlationId, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if ($9ed9a547f6786bdc$var$ThrottlingUtils.checkResponseStatus(response) || $9ed9a547f6786bdc$var$ThrottlingUtils.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $9ed9a547f6786bdc$var$ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[$9ed9a547f6786bdc$var$HeaderNames.RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($9ed9a547f6786bdc$var$ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty($9ed9a547f6786bdc$var$HeaderNames.RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || $9ed9a547f6786bdc$var$DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + $9ed9a547f6786bdc$var$DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = $9ed9a547f6786bdc$var$getRequestThumbprint(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $9ed9a547f6786bdc$var$NetworkError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.correlationId, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$NetworkError.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $9ed9a547f6786bdc$var$createNetworkError(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new $9ed9a547f6786bdc$var$NetworkError(error, httpStatus, responseHeaders);
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates default headers for requests to token endpoint
 */ function $9ed9a547f6786bdc$var$createTokenRequestHeaders(logger, preventCorsPreflight, ccsCred) {
    const headers = {};
    headers[$9ed9a547f6786bdc$var$HeaderNames.CONTENT_TYPE] = $9ed9a547f6786bdc$var$URL_FORM_CONTENT_TYPE;
    if (!preventCorsPreflight && ccsCred) switch(ccsCred.type){
        case $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID:
            try {
                const clientInfo = $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(ccsCred.credential);
                headers[$9ed9a547f6786bdc$var$HeaderNames.CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
            } catch (e) {
                logger.verbose(`1qhtee ${e}`, "");
            }
            break;
        case $9ed9a547f6786bdc$var$CcsCredentialType.UPN:
            headers[$9ed9a547f6786bdc$var$HeaderNames.CCS_HEADER] = `UPN: ${ccsCred.credential}`;
            break;
    }
    return headers;
}
/**
 * Adds the DPoP proof header for token endpoint requests when DPoP is requested.
 * @internal
 */ async function $9ed9a547f6786bdc$var$addDpopTokenProofHeader(headers, request, tokenEndpoint, cryptoUtils, tokenBindingKeyManager) {
    if (request.authenticationScheme !== $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP) return;
    const dpopProofGenerator = new $9ed9a547f6786bdc$var$DpopProofGenerator(cryptoUtils, tokenBindingKeyManager);
    const keyId = request.dpopJkt;
    if (!keyId?.trim()) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$keyIdMissing, request.correlationId);
    headers[$9ed9a547f6786bdc$var$HeaderNames.DPOP] = await dpopProofGenerator.generateTokenProof({
        tokenEndpoint: tokenEndpoint
    }, keyId, request.correlationId);
}
/**
 * Creates query string for the /token request
 * @param request
 */ function $9ed9a547f6786bdc$var$createTokenQueryParameters(request, clientId, redirectUri, performanceClient) {
    const parameters = new Map();
    if (request.embeddedClientId) $9ed9a547f6786bdc$var$addBrokerParameters(parameters, clientId, redirectUri);
    if (request.extraQueryParameters) $9ed9a547f6786bdc$var$addExtraParameters(parameters, request.extraQueryParameters);
    $9ed9a547f6786bdc$var$addCorrelationId(parameters, request.correlationId);
    $9ed9a547f6786bdc$var$instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return $9ed9a547f6786bdc$var$mapToQueryString(parameters);
}
/**
 * Http post to token endpoint
 * @param tokenEndpoint
 * @param queryString
 * @param headers
 * @param thumbprint
 * @internal
 */ async function $9ed9a547f6786bdc$var$executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, cacheManager, networkClient, logger, performanceClient, serverTelemetryManager) {
    const response = await $9ed9a547f6786bdc$var$sendPostRequest(thumbprint, tokenEndpoint, {
        body: queryString,
        headers: headers
    }, correlationId, cacheManager, networkClient, logger, performanceClient);
    if (serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
    serverTelemetryManager.clearTelemetryCache();
    return response;
}
/**
 * Wraps sendPostRequestAsync with necessary preflight and postflight logic
 * @param thumbprint - Request thumbprint for throttling
 * @param tokenEndpoint - Endpoint to make the POST to
 * @param options - Body and Headers to include on the POST request
 * @param correlationId - CorrelationId for telemetry
 * @param cacheManager - Cache manager instance
 * @param networkClient - Network module instance
 * @param logger - Logger instance
 * @param performanceClient - Performance client instance
 * @internal
 */ async function $9ed9a547f6786bdc$var$sendPostRequest(thumbprint, tokenEndpoint, options, correlationId, cacheManager, networkClient, logger, performanceClient) {
    $9ed9a547f6786bdc$var$ThrottlingUtils.preProcess(cacheManager, thumbprint, correlationId);
    let response;
    try {
        response = await $9ed9a547f6786bdc$var$invokeAsync(networkClient.sendPostRequestAsync.bind(networkClient), $9ed9a547f6786bdc$var$NetworkClientSendPostRequestAsync, logger, performanceClient, correlationId)(tokenEndpoint, {
            ...options,
            correlationId: correlationId,
            performanceClient: performanceClient
        });
        const responseHeaders = response.headers || {};
        performanceClient?.addFields({
            refreshTokenSize: response.body.refresh_token?.length || 0,
            httpVerToken: responseHeaders[$9ed9a547f6786bdc$var$HeaderNames.X_MS_HTTP_VERSION] || "",
            requestId: responseHeaders[$9ed9a547f6786bdc$var$HeaderNames.X_MS_REQUEST_ID] || ""
        }, correlationId);
    } catch (e) {
        if (e instanceof $9ed9a547f6786bdc$var$NetworkError) {
            const responseHeaders = e.responseHeaders;
            if (responseHeaders) performanceClient?.addFields({
                httpVerToken: responseHeaders[$9ed9a547f6786bdc$var$HeaderNames.X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[$9ed9a547f6786bdc$var$HeaderNames.X_MS_REQUEST_ID] || "",
                contentTypeHeader: responseHeaders[$9ed9a547f6786bdc$var$HeaderNames.CONTENT_TYPE] || undefined,
                contentLengthHeader: responseHeaders[$9ed9a547f6786bdc$var$HeaderNames.CONTENT_LENGTH] || undefined,
                httpStatus: e.httpStatus
            }, correlationId);
            throw e.error;
        }
        if (e instanceof $9ed9a547f6786bdc$var$AuthError) throw e;
        else throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$networkError, correlationId);
    }
    $9ed9a547f6786bdc$var$ThrottlingUtils.postProcess(cacheManager, thumbprint, response, correlationId);
    return response;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $9ed9a547f6786bdc$var$AuthorizationCodeClient {
    constructor(configuration, performanceClient){
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        // Set the configuration
        this.config = $9ed9a547f6786bdc$var$buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new $9ed9a547f6786bdc$var$Logger(this.config.loggerOptions, $9ed9a547f6786bdc$var$name$1, $9ed9a547f6786bdc$var$version$1);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, apiId, authCodePayload) {
        if (!request.code) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$requestCannotBeMade, request.correlationId);
        // Check for new cloud instance
        if (authCodePayload && authCodePayload.cloud_instance_host_name) await $9ed9a547f6786bdc$var$invokeAsync(this.updateTokenEndpointAuthority.bind(this), $9ed9a547f6786bdc$var$UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodePayload.cloud_instance_host_name, request.correlationId);
        const reqTimestamp = $9ed9a547f6786bdc$var$nowSeconds();
        const response = await $9ed9a547f6786bdc$var$invokeAsync(this.executeTokenRequest.bind(this), $9ed9a547f6786bdc$var$AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request, this.serverTelemetryManager);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[$9ed9a547f6786bdc$var$HeaderNames.X_MS_REQUEST_ID];
        const responseHandler = new $9ed9a547f6786bdc$var$ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin, this.config.tokenBindingKeyManager);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return $9ed9a547f6786bdc$var$invokeAsync(responseHandler.handleServerTokenResponse.bind(responseHandler), $9ed9a547f6786bdc$var$HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$logoutRequestEmpty, "");
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return $9ed9a547f6786bdc$var$UrlString.appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request, serverTelemetryManager) {
        const queryParametersString = $9ed9a547f6786bdc$var$createTokenQueryParameters(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = $9ed9a547f6786bdc$var$UrlString.appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await $9ed9a547f6786bdc$var$invokeAsync(this.createTokenRequestBody.bind(this), $9ed9a547f6786bdc$var$AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = $9ed9a547f6786bdc$var$buildClientInfo(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${$9ed9a547f6786bdc$var$CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`0wznt3 ${e}`, request.correlationId);
        }
        const headers = $9ed9a547f6786bdc$var$createTokenRequestHeaders(this.logger, this.config.systemOptions.preventCorsPreflight, ccsCredential || request.ccsCredential);
        await $9ed9a547f6786bdc$var$addDpopTokenProofHeader(headers, request, endpoint, this.cryptoUtils, this.config.tokenBindingKeyManager);
        const thumbprint = $9ed9a547f6786bdc$var$getRequestThumbprint(this.config.authOptions.clientId, request);
        return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$executePostToTokenEndpoint, $9ed9a547f6786bdc$var$AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, serverTelemetryManager);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        $9ed9a547f6786bdc$var$addClientId(parameters, request.embeddedClientId || request.extraParameters?.[$9ed9a547f6786bdc$var$CLIENT_ID] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) {
            // Just validate
            if (!request.redirectUri) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$redirectUriEmpty, request.correlationId);
        } else // Validate and include redirect uri
        $9ed9a547f6786bdc$var$addRedirectUri(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        $9ed9a547f6786bdc$var$addScopes(parameters, request.scopes, request.correlationId, true, this.oidcDefaultScopes);
        $9ed9a547f6786bdc$var$addResource(parameters, request.resource);
        if (request.attributeTokens) $9ed9a547f6786bdc$var$addAttributeTokens(parameters, request.attributeTokens);
        this.performanceClient?.addFields({
            hasAttributeTokens: !!request.attributeTokens?.length
        }, request.correlationId);
        // add code: user set, not validated
        $9ed9a547f6786bdc$var$addAuthorizationCode(parameters, request.code);
        // Add library metadata
        $9ed9a547f6786bdc$var$addLibraryInfo(parameters, this.config.libraryInfo);
        $9ed9a547f6786bdc$var$addApplicationTelemetry(parameters, this.config.telemetry.application);
        $9ed9a547f6786bdc$var$addThrottling(parameters);
        if (this.serverTelemetryManager && !$9ed9a547f6786bdc$var$isOidcProtocolMode(this.config)) $9ed9a547f6786bdc$var$addServerTelemetry(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) $9ed9a547f6786bdc$var$addCodeVerifier(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) $9ed9a547f6786bdc$var$addClientSecret(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            $9ed9a547f6786bdc$var$addClientAssertion(parameters, await $9ed9a547f6786bdc$var$getClientAssertion(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            $9ed9a547f6786bdc$var$addClientAssertionType(parameters, clientAssertion.assertionType);
        }
        $9ed9a547f6786bdc$var$addGrantType(parameters, $9ed9a547f6786bdc$var$GrantType.AUTHORIZATION_CODE_GRANT);
        $9ed9a547f6786bdc$var$addClientInfo(parameters);
        if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP) {
            const popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(this.cryptoUtils, this.config.tokenBindingKeyManager, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await $9ed9a547f6786bdc$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9ed9a547f6786bdc$var$PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            $9ed9a547f6786bdc$var$addPopToken(parameters, reqCnfData);
        } else if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH) {
            if (request.sshJwk) $9ed9a547f6786bdc$var$addSshJwk(parameters, request.sshJwk);
            else throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$missingSshJwk, request.correlationId);
        }
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = $9ed9a547f6786bdc$var$buildClientInfo(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${$9ed9a547f6786bdc$var$CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`0wznt3 ${e}`, request.correlationId);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID:
                try {
                    const clientInfo = $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(ccsCred.credential);
                    $9ed9a547f6786bdc$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`1qhtee ${e}`, request.correlationId);
                }
                break;
            case $9ed9a547f6786bdc$var$CcsCredentialType.UPN:
                $9ed9a547f6786bdc$var$addCcsUpn(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) $9ed9a547f6786bdc$var$addBrokerParameters(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) $9ed9a547f6786bdc$var$addExtraParameters(parameters, request.extraParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.extraParameters || !request.extraParameters[$9ed9a547f6786bdc$var$RETURN_SPA_CODE])) $9ed9a547f6786bdc$var$addExtraParameters(parameters, {
            [$9ed9a547f6786bdc$var$RETURN_SPA_CODE]: "1"
        });
        $9ed9a547f6786bdc$var$instrumentBrokerParams(parameters, request.correlationId, this.performanceClient);
        $9ed9a547f6786bdc$var$addClaims(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return $9ed9a547f6786bdc$var$mapToQueryString(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) $9ed9a547f6786bdc$var$addPostLogoutRedirectUri(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) $9ed9a547f6786bdc$var$addCorrelationId(parameters, request.correlationId);
        if (request.idTokenHint) $9ed9a547f6786bdc$var$addIdTokenHint(parameters, request.idTokenHint);
        if (request.state) $9ed9a547f6786bdc$var$addState(parameters, request.state);
        if (request.logoutHint) $9ed9a547f6786bdc$var$addLogoutHint(parameters, request.logoutHint);
        if (request.extraQueryParameters) $9ed9a547f6786bdc$var$addExtraParameters(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) $9ed9a547f6786bdc$var$addInstanceAware(parameters);
        return $9ed9a547f6786bdc$var$mapToQueryString(parameters);
    }
    /**
     * Updates the authority to the cloud instance provided in the authorization response
     * @param cloudInstanceHostName - cloud instance host name from authorization code payload
     * @param correlationId - request correlation id
     */ async updateTokenEndpointAuthority(cloudInstanceHostName, correlationId) {
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostName}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await $9ed9a547f6786bdc$var$createDiscoveredInstance(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 * @internal
 */ function $9ed9a547f6786bdc$var$getStandardAuthorizeRequestParameters(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    $9ed9a547f6786bdc$var$addClientId(parameters, request.embeddedClientId || request.extraQueryParameters?.[$9ed9a547f6786bdc$var$CLIENT_ID] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    $9ed9a547f6786bdc$var$addScopes(parameters, requestScopes, request.correlationId, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    $9ed9a547f6786bdc$var$addResource(parameters, request.resource);
    $9ed9a547f6786bdc$var$addRedirectUri(parameters, request.redirectUri);
    $9ed9a547f6786bdc$var$addCorrelationId(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    $9ed9a547f6786bdc$var$addResponseMode(parameters, request.responseMode);
    // add client_info=1
    $9ed9a547f6786bdc$var$addClientInfo(parameters);
    // add clidata=1
    $9ed9a547f6786bdc$var$addCliData(parameters);
    if (request.prompt) {
        $9ed9a547f6786bdc$var$addPrompt(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        $9ed9a547f6786bdc$var$addDomainHint(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== $9ed9a547f6786bdc$var$PromptValue$1.SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === $9ed9a547f6786bdc$var$PromptValue$1.NONE) {
            // SessionID is only used in silent calls
            logger.verbose("1tvqyx", request.correlationId);
            $9ed9a547f6786bdc$var$addSid(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = $9ed9a547f6786bdc$var$extractAccountSid(request.account);
            let accountLoginHintClaim = $9ed9a547f6786bdc$var$extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning("0wkg3v", request.correlationId);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("1eyfsw", request.correlationId);
                $9ed9a547f6786bdc$var$addLoginHint(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                    $9ed9a547f6786bdc$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            } else if (accountSid && request.prompt === $9ed9a547f6786bdc$var$PromptValue$1.NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("1rmd8s", request.correlationId);
                $9ed9a547f6786bdc$var$addSid(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                    $9ed9a547f6786bdc$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            } else if (request.loginHint) {
                logger.verbose("0y3007", request.correlationId);
                $9ed9a547f6786bdc$var$addLoginHint(parameters, request.loginHint);
                $9ed9a547f6786bdc$var$addCcsUpn(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("02f507", request.correlationId);
                $9ed9a547f6786bdc$var$addLoginHint(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                    $9ed9a547f6786bdc$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            }
        } else if (request.loginHint) {
            logger.verbose("0g01ey", request.correlationId);
            $9ed9a547f6786bdc$var$addLoginHint(parameters, request.loginHint);
            $9ed9a547f6786bdc$var$addCcsUpn(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("169k9v", request.correlationId);
    if (request.nonce) $9ed9a547f6786bdc$var$addNonce(parameters, request.nonce);
    if (request.state) $9ed9a547f6786bdc$var$addState(parameters, request.state);
    if (request.embeddedClientId) $9ed9a547f6786bdc$var$addBrokerParameters(parameters, authOptions.clientId, authOptions.redirectUri);
    $9ed9a547f6786bdc$var$addClaims(parameters, request.correlationId, request.claims, authOptions.clientCapabilities, request.skipBrokerClaims);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes($9ed9a547f6786bdc$var$INSTANCE_AWARE))) $9ed9a547f6786bdc$var$addInstanceAware(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 * @internal
 */ function $9ed9a547f6786bdc$var$getAuthorizeUrl(authority, requestParameters) {
    const queryString = $9ed9a547f6786bdc$var$mapToQueryString(requestParameters);
    return $9ed9a547f6786bdc$var$UrlString.appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 * @param correlationId
 */ function $9ed9a547f6786bdc$var$getAuthorizationCodePayload(serverParams, cachedState, correlationId) {
    // Get code response
    $9ed9a547f6786bdc$var$validateAuthorizationResponse(serverParams, cachedState, correlationId);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$authorizationCodeMissingFromServerResponse, correlationId);
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 * @param correlationId
 */ function $9ed9a547f6786bdc$var$validateAuthorizationResponse(serverResponse, requestState, correlationId) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$stateNotFound, correlationId, "Cached State") : $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$stateNotFound, correlationId, "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidState, correlationId, serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidState, correlationId, serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$stateMismatch, correlationId);
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = $9ed9a547f6786bdc$var$parseServerErrorNo(serverResponse);
        if ($9ed9a547f6786bdc$var$isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new $9ed9a547f6786bdc$var$InteractionRequiredAuthError(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
        throw new $9ed9a547f6786bdc$var$ServerError(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function $9ed9a547f6786bdc$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function $9ed9a547f6786bdc$var$extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function $9ed9a547f6786bdc$var$extractLoginHint(account) {
    return account.loginHint || account.idTokenClaims?.login_hint || null;
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Starts context by adding payload to the stack
 * @param event {PerformanceEvent}
 * @param stack {?PerformanceEventStackedContext[]} stack
 */ function $9ed9a547f6786bdc$var$startContext(event, stack) {
    if (!stack) return;
    stack.push({
        name: event.name
    });
}
/**
 * Ends context by removing payload from the stack and returning parent or self, if stack is empty, payload
 *
 * @param event {PerformanceEvent}
 * @param stack {?PerformanceEventStackedContext[]} stack
 * @param error {?unknown} error
 */ function $9ed9a547f6786bdc$var$endContext(event, stack, error) {
    if (!stack?.length) return;
    const peek = (stack)=>{
        return stack.length ? stack[stack.length - 1] : undefined;
    };
    const abbrEventName = event.name;
    const top = peek(stack);
    if (top?.name !== abbrEventName) return;
    const current = stack?.pop();
    if (!current) return;
    const errorCode = error instanceof $9ed9a547f6786bdc$var$AuthError ? error.errorCode : error instanceof Error ? error.name : undefined;
    const subErr = error instanceof $9ed9a547f6786bdc$var$AuthError ? error.subError : undefined;
    if (errorCode && current.childErr !== errorCode) {
        current.err = errorCode;
        if (subErr) current.subErr = subErr;
    }
    delete current.name;
    delete current.childErr;
    const context = {
        ...current,
        dur: event.durationMs
    };
    if (!event.success) context.fail = 1;
    const parent = peek(stack);
    if (!parent) return {
        [abbrEventName]: context
    };
    if (errorCode) parent.childErr = errorCode;
    let childName;
    if (!parent[abbrEventName]) childName = abbrEventName;
    else {
        const siblings = Object.keys(parent).filter((key)=>key.startsWith(abbrEventName)).length;
        childName = `${abbrEventName}_${siblings + 1}`;
    }
    parent[childName] = context;
    return parent;
}
/**
 * Adds error name and stack trace to the telemetry event
 * @param error {Error}
 * @param logger {Logger}
 * @param event {PerformanceEvent}
 * @param stackMaxSize {number} max error stack size to capture
 */ function $9ed9a547f6786bdc$var$addError(error, logger, event, stackMaxSize = 5) {
    if (!(error instanceof Error)) {
        logger.trace("0gcyox", event.correlationId);
        return;
    } else if (error instanceof $9ed9a547f6786bdc$var$AuthError) {
        event.errorCode = error.errorCode;
        event.subErrorCode = error.subError;
        if (!event.serverErrorNo && (error instanceof $9ed9a547f6786bdc$var$ServerError || error instanceof $9ed9a547f6786bdc$var$InteractionRequiredAuthError) && error.errorNo) event.serverErrorNo = error.errorNo;
        return;
    } else if (error instanceof $9ed9a547f6786bdc$var$CacheError) {
        event.errorCode = error.errorCode;
        return;
    } else if (event.errorStack?.length) {
        logger.trace("0lmqrh", event.correlationId);
        return;
    } else if (!error.stack?.length) {
        logger.trace("1cnpwa", event.correlationId);
        return;
    }
    if (error.stack) event.errorStack = $9ed9a547f6786bdc$var$compactStack(error.stack, stackMaxSize);
    event.errorName = error.name;
}
/**
 * Compacts error stack into array by fetching N first entries
 * @param stack {string} error stack
 * @param stackMaxSize {number} max error stack size to capture
 * @returns {string[]}
 */ function $9ed9a547f6786bdc$var$compactStack(stack, stackMaxSize) {
    if (stackMaxSize < 0) return [];
    const stackArr = stack.split("\n") || [];
    const res = [];
    // Check for a handful of known, common runtime errors and log them (with redaction where applicable).
    const firstLine = stackArr[0];
    if (firstLine.startsWith("TypeError: Cannot read property") || firstLine.startsWith("TypeError: Cannot read properties of") || firstLine.startsWith("TypeError: Cannot set property") || firstLine.startsWith("TypeError: Cannot set properties of") || firstLine.endsWith("is not a function")) // These types of errors are not at risk of leaking PII. They will indicate unavailable APIs
    res.push($9ed9a547f6786bdc$var$compactStackLine(firstLine));
    else if (firstLine.startsWith("SyntaxError") || firstLine.startsWith("TypeError")) // Prevent unintentional leaking of arbitrary info by redacting contents between both single and double quotes
    res.push($9ed9a547f6786bdc$var$compactStackLine(// Example: SyntaxError: Unexpected token 'e', "test" is not valid JSON -> SyntaxError: Unexpected token <redacted>, <redacted> is not valid JSON
    firstLine.replace(/['].*[']|["].*["]/g, "<redacted>")));
    // Get top N stack lines
    for(let ix = 1; ix < stackArr.length; ix++){
        if (res.length >= stackMaxSize) break;
        const line = stackArr[ix];
        res.push($9ed9a547f6786bdc$var$compactStackLine(line));
    }
    return res;
}
/**
 * Compacts error stack line by shortening file path
 * Example: https://localhost/msal-common/src/authority/Authority.js:100:1 -> Authority.js:100:1
 * @param line {string} stack line
 * @returns {string}
 */ function $9ed9a547f6786bdc$var$compactStackLine(line) {
    const filePathIx = line.lastIndexOf(" ") + 1;
    if (filePathIx < 1) return line;
    const filePath = line.substring(filePathIx);
    let fileNameIx = filePath.lastIndexOf("/");
    fileNameIx = fileNameIx < 0 ? filePath.lastIndexOf("\\") : fileNameIx;
    if (fileNameIx >= 0) return (line.substring(0, filePathIx) + "(" + filePath.substring(fileNameIx + 1) + (filePath.charAt(filePath.length - 1) === ")" ? "" : ")")).trimStart();
    return line.trimStart();
}
function $9ed9a547f6786bdc$var$getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
class $9ed9a547f6786bdc$var$PerformanceClient {
    /**
     * Creates an instance of PerformanceClient,
     * an abstract class containing core performance telemetry logic.
     *
     * @constructor
     * @param {string} clientId Client ID of the application
     * @param {string} authority Authority used by the application
     * @param {Logger} logger Logger used by the application
     * @param {string} libraryName Name of the library
     * @param {string} libraryVersion Version of the library
     * @param {ApplicationTelemetry} applicationTelemetry application name and version
     * @param {Set<String>} intFields integer fields to be truncated
     */ constructor(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry, intFields){
        this.authority = authority;
        this.libraryName = libraryName;
        this.libraryVersion = libraryVersion;
        this.globalFields = {};
        this.applicationTelemetry = applicationTelemetry;
        this.clientId = clientId;
        this.logger = logger;
        this.callbacks = new Map();
        this.eventsByCorrelationId = new Map();
        this.eventStack = new Map();
        this.intFields = intFields || new Set();
        for (const item of $9ed9a547f6786bdc$var$IntFields)this.intFields.add(item);
    }
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {InProgressPerformanceEvent}
     */ startMeasurement(measureName, correlationId) {
        // Generate a placeholder correlation if the request does not provide one
        const eventCorrelationId = correlationId || this.generateId();
        const inProgressEvent = {
            eventId: this.generateId(),
            status: $9ed9a547f6786bdc$var$PerformanceEventStatus.InProgress,
            authority: this.authority,
            libraryName: this.libraryName,
            libraryVersion: this.libraryVersion,
            clientId: this.clientId,
            name: measureName,
            startTimeMs: Date.now(),
            correlationId: eventCorrelationId,
            appName: this.applicationTelemetry?.appName,
            appVersion: this.applicationTelemetry?.appVersion
        };
        // Store in progress events so they can be discarded if not ended properly
        this.cacheEventByCorrelationId(inProgressEvent);
        $9ed9a547f6786bdc$var$startContext(inProgressEvent, this.eventStack.get(eventCorrelationId));
        // Return the event and functions the caller can use to properly end/flush the measurement
        return {
            end: (event, error, account)=>{
                return this.endMeasurement({
                    // Initial set of event properties
                    ...inProgressEvent,
                    // Properties set when event ends
                    ...event
                }, error, account);
            },
            discard: ()=>{
                return this.discardMeasurements(inProgressEvent.correlationId);
            },
            add: (fields)=>{
                return this.addFields(fields, inProgressEvent.correlationId);
            },
            increment: (fields)=>{
                return this.incrementFields(fields, inProgressEvent.correlationId);
            },
            event: inProgressEvent
        };
    }
    /**
     * Stops measuring the performance for an operation. Should only be called directly by PerformanceClient classes,
     * as consumers should instead use the function returned by startMeasurement.
     * Adds a new field named as "[event name]DurationMs" for sub-measurements, completes and emits an event
     * otherwise.
     *
     * @param {PerformanceEvent} event
     * @param {unknown} error
     * @param {AccountInfo?} account
     * @returns {(PerformanceEvent | null)}
     */ endMeasurement(event, error, account) {
        const rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (!rootEvent) {
            this.logger.trace(`0k9ti8 ${event.eventId}`, event.correlationId);
            return null;
        }
        const isRoot = event.eventId === rootEvent.eventId;
        event.durationMs = Math.round(event.durationMs || this.getDurationMs(event.startTimeMs));
        const context = JSON.stringify($9ed9a547f6786bdc$var$endContext(event, this.eventStack.get(rootEvent.correlationId), error));
        if (isRoot) this.discardMeasurements(rootEvent.correlationId);
        else rootEvent.incompleteSubMeasurements?.delete(event.eventId);
        if (error) $9ed9a547f6786bdc$var$addError(error, this.logger, rootEvent);
        // Add sub-measurement attribute to root event's ext field.
        if (!isRoot) {
            rootEvent.ext = {
                ...rootEvent.ext,
                ...event.ext
            };
            rootEvent.ext[event.name + "DurationMs"] = Math.floor(event.durationMs);
            return {
                ...rootEvent
            };
        }
        if (isRoot && !error && (rootEvent.errorCode || rootEvent.subErrorCode)) {
            this.logger.trace(`1fm1tm ${event.name}`, event.correlationId);
            rootEvent.errorCode = undefined;
            rootEvent.subErrorCode = undefined;
        }
        let finalEvent = {
            ...rootEvent,
            ...event
        };
        let incompleteSubsCount = 0;
        // Incomplete sub-measurements are discarded. They are likely an instrumentation bug that should be fixed.
        finalEvent.incompleteSubMeasurements?.forEach((subMeasurement)=>{
            this.logger.trace(`0nxk52 ${subMeasurement.name} ${event.name}`, finalEvent.correlationId);
            incompleteSubsCount++;
        });
        finalEvent.incompleteSubMeasurements = undefined;
        const logs = $9ed9a547f6786bdc$var$getAndFlushLogsFromCache(event.correlationId);
        // Format logs: [millis1,hash1;millis2,hash2;...]
        const formattedLogs = logs.map((logMessage)=>`${logMessage.milliseconds},${logMessage.hash}`).join(";");
        finalEvent = {
            ...finalEvent,
            status: $9ed9a547f6786bdc$var$PerformanceEventStatus.Completed,
            incompleteSubsCount: incompleteSubsCount,
            context: context,
            logs: formattedLogs,
            /*
             * Global fields are spread last so they are always present on the
             * emitted event and never overridden, even when registered after
             * the measurement started.
             */ ...this.globalFields
        };
        if (account) {
            finalEvent.accountType = $9ed9a547f6786bdc$var$getAccountType(account);
            finalEvent.dataBoundary = account.dataBoundary;
        }
        this.truncateIntegralFields(finalEvent);
        this.emitEvents([
            finalEvent
        ], event.correlationId);
        return finalEvent;
    }
    /**
     * Saves extra information to be emitted when the measurements are flushed
     * @param fields
     * @param correlationId
     */ addFields(fields, correlationId) {
        const event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            const staticFields = {};
            const dynamicFields = {};
            for(const key in fields)if (key.startsWith($9ed9a547f6786bdc$var$EXT_FIELD_PREFIX)) {
                const dynamicKey = key.slice($9ed9a547f6786bdc$var$EXT_FIELD_PREFIX.length);
                const value = fields[key];
                if (typeof value === "string" || typeof value === "number") dynamicFields[dynamicKey] = value;
            } else staticFields[key] = fields[key];
            const updatedEvent = {
                ...event,
                ...staticFields
            };
            if (Object.keys(dynamicFields).length) updatedEvent.ext = {
                ...updatedEvent.ext,
                ...dynamicFields
            };
            this.eventsByCorrelationId.set(correlationId, updatedEvent);
        } else this.logger.trace("0thl6s", correlationId);
    }
    /**
     * Saves fields to be emitted on every event measured by this client.
     * Unlike addFields, these are not scoped to a single correlationId and persist for the
     * lifetime of the client (e.g. previousLibraryVersion for upgrade/downgrade telemetry).
     * @param fields
     */ addGlobalFields(fields) {
        this.globalFields = {
            ...this.globalFields,
            ...fields
        };
    }
    /**
     * Increment counters to be emitted when the measurements are flushed
     * @param fields {string[]}
     * @param correlationId {string} correlation identifier
     */ incrementFields(fields, correlationId) {
        const event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            for(const counter in fields)if (counter.startsWith($9ed9a547f6786bdc$var$EXT_FIELD_PREFIX)) {
                event.ext = event.ext || {};
                // Route to ext sub-object
                const dynamicKey = counter.slice($9ed9a547f6786bdc$var$EXT_FIELD_PREFIX.length);
                const currentValue = event.ext[dynamicKey];
                if (currentValue === undefined) event.ext[dynamicKey] = 0;
                else if (isNaN(Number(currentValue))) return;
                event.ext[dynamicKey] = (Number(event.ext[dynamicKey]) || 0) + (fields[counter] ?? 0);
            } else {
                /* eslint-disable custom-msal/no-dynamic-telemetry-fields -- internal dispatching of static fields by name */ if (!event.hasOwnProperty(counter)) event[counter] = 0;
                else if (isNaN(Number(event[counter]))) return;
                event[counter] += fields[counter];
            /* eslint-enable custom-msal/no-dynamic-telemetry-fields */ }
        } else this.logger.trace("0thl6s", correlationId);
    }
    /**
     * Upserts event into event cache.
     * First key is the correlation id, second key is the event id.
     * Allows for events to be grouped by correlation id,
     * and to easily allow for properties on them to be updated.
     *
     * @private
     * @param {PerformanceEvent} event
     */ cacheEventByCorrelationId(event) {
        const rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (rootEvent) {
            rootEvent.incompleteSubMeasurements = rootEvent.incompleteSubMeasurements || new Map();
            rootEvent.incompleteSubMeasurements.set(event.eventId, {
                name: event.name,
                startTimeMs: event.startTimeMs
            });
        } else {
            this.eventsByCorrelationId.set(event.correlationId, {
                ...event
            });
            this.eventStack.set(event.correlationId, []);
        }
    }
    /**
     * Removes measurements and aux data for a given correlation id.
     *
     * @param {string} correlationId
     */ discardMeasurements(correlationId) {
        this.eventsByCorrelationId.delete(correlationId);
        this.eventStack.delete(correlationId);
    }
    /**
     * Registers a callback function to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        for (const [id, cb] of this.callbacks)if (cb.toString() === callback.toString()) {
            this.logger.warning(`1eap5p ${id}`, "");
            return id;
        }
        const callbackId = this.generateId();
        this.callbacks.set(callbackId, callback);
        this.logger.verbose(`0c9ujz ${callbackId}`, "");
        return callbackId;
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        const result = this.callbacks.delete(callbackId);
        if (result) this.logger.verbose(`0253if ${callbackId}`, "");
        else this.logger.verbose(`0iqk07 ${callbackId}`, "");
        return result;
    }
    /**
     * Emits events to all registered callbacks.
     *
     * @param {PerformanceEvent[]} events
     * @param {?string} [correlationId]
     */ emitEvents(events, correlationId) {
        this.logger.verbose("11jb1y", correlationId);
        this.callbacks.forEach((callback, callbackId)=>{
            this.logger.trace(`0p2pjl ${callbackId}`, correlationId);
            callback.apply(null, [
                events
            ]);
        });
    }
    /**
     * Enforce truncation of integral fields in performance event.
     * @param {PerformanceEvent} event performance event to update.
     */ truncateIntegralFields(event) {
        this.intFields.forEach((key)=>{
            /* eslint-disable custom-msal/no-dynamic-telemetry-fields -- internal truncation of known integer fields */ if (key in event && typeof event[key] === "number") event[key] = Math.floor(event[key]);
        /* eslint-enable custom-msal/no-dynamic-telemetry-fields */ });
    }
    /**
     * Returns event duration in milliseconds
     * @param startTimeMs {number}
     * @returns {number}
     */ getDurationMs(startTimeMs) {
        const durationMs = Date.now() - startTimeMs;
        // Handle clock skew
        return durationMs < 0 ? durationMs : 0;
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $9ed9a547f6786bdc$var$RefreshTokenClient {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = $9ed9a547f6786bdc$var$buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new $9ed9a547f6786bdc$var$Logger(this.config.loggerOptions, $9ed9a547f6786bdc$var$name$1, $9ed9a547f6786bdc$var$version$1);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    async acquireToken(request, apiId) {
        const reqTimestamp = $9ed9a547f6786bdc$var$nowSeconds();
        const response = await $9ed9a547f6786bdc$var$invokeAsync(this.executeTokenRequest.bind(this), $9ed9a547f6786bdc$var$RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[$9ed9a547f6786bdc$var$HeaderNames.X_MS_REQUEST_ID];
        const responseHandler = new $9ed9a547f6786bdc$var$ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin, this.config.tokenBindingKeyManager);
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return $9ed9a547f6786bdc$var$invokeAsync(responseHandler.handleServerTokenResponse.bind(responseHandler), $9ed9a547f6786bdc$var$HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request, apiId) {
        // Cannot renew token if no request object is given.
        if (!request) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$tokenRequestEmpty, "");
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$noAccountInSilentRequest, request.correlationId);
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment, request.correlationId);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenWithCachedRefreshToken.bind(this), $9ed9a547f6786bdc$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true, apiId);
        } catch (e) {
            const noFamilyRTInCache = e instanceof $9ed9a547f6786bdc$var$InteractionRequiredAuthError && e.errorCode === $9ed9a547f6786bdc$var$noTokensFound;
            const clientMismatchErrorWithFamilyRT = e instanceof $9ed9a547f6786bdc$var$ServerError && e.errorCode === $9ed9a547f6786bdc$var$INVALID_GRANT_ERROR && e.subError === $9ed9a547f6786bdc$var$CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenWithCachedRefreshToken.bind(this), $9ed9a547f6786bdc$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenWithCachedRefreshToken.bind(this), $9ed9a547f6786bdc$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci, apiId) {
        // fetches family RT or application RT based on FOCI value
        const refreshToken = $9ed9a547f6786bdc$var$invoke(this.cacheManager.getRefreshToken.bind(this.cacheManager), $9ed9a547f6786bdc$var$CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined);
        if (!refreshToken) throw $9ed9a547f6786bdc$var$createInteractionRequiredAuthError($9ed9a547f6786bdc$var$noTokensFound, request.correlationId);
        if (refreshToken.expiresOn) {
            const offset = request.refreshTokenExpirationOffsetSeconds || $9ed9a547f6786bdc$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS;
            this.performanceClient?.addFields({
                cacheRtExpiresOnSeconds: Number(refreshToken.expiresOn),
                rtOffsetSeconds: offset
            }, request.correlationId);
            if ($9ed9a547f6786bdc$var$isTokenExpired(refreshToken.expiresOn, offset)) throw $9ed9a547f6786bdc$var$createInteractionRequiredAuthError($9ed9a547f6786bdc$var$refreshTokenExpired, request.correlationId);
        }
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID
            }
        };
        if (refreshTokenRequest.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP && !refreshTokenRequest.dpopJkt) {
            const dpopProofGenerator = new $9ed9a547f6786bdc$var$DpopProofGenerator(this.cryptoUtils, this.config.tokenBindingKeyManager);
            refreshTokenRequest.dpopJkt = await dpopProofGenerator.generateJkt(request.correlationId);
        }
        try {
            return await $9ed9a547f6786bdc$var$invokeAsync(this.acquireToken.bind(this), $9ed9a547f6786bdc$var$RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest, apiId);
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$InteractionRequiredAuthError) {
                if (e.subError === $9ed9a547f6786bdc$var$badToken) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("1pg3ap", request.correlationId);
                    const badRefreshTokenKey = this.cacheManager.generateCredentialKey(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        const queryParametersString = $9ed9a547f6786bdc$var$createTokenQueryParameters(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = $9ed9a547f6786bdc$var$UrlString.appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await $9ed9a547f6786bdc$var$invokeAsync(this.createTokenRequestBody.bind(this), $9ed9a547f6786bdc$var$RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = $9ed9a547f6786bdc$var$createTokenRequestHeaders(this.logger, this.config.systemOptions.preventCorsPreflight, request.ccsCredential);
        await $9ed9a547f6786bdc$var$addDpopTokenProofHeader(headers, request, endpoint, this.cryptoUtils, this.config.tokenBindingKeyManager);
        const thumbprint = $9ed9a547f6786bdc$var$getRequestThumbprint(this.config.authOptions.clientId, request);
        return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$executePostToTokenEndpoint, $9ed9a547f6786bdc$var$RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, this.serverTelemetryManager);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        $9ed9a547f6786bdc$var$addClientId(parameters, request.embeddedClientId || request.extraParameters?.[$9ed9a547f6786bdc$var$CLIENT_ID] || this.config.authOptions.clientId);
        if (request.redirectUri) $9ed9a547f6786bdc$var$addRedirectUri(parameters, request.redirectUri);
        $9ed9a547f6786bdc$var$addScopes(parameters, request.scopes, request.correlationId, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        $9ed9a547f6786bdc$var$addGrantType(parameters, $9ed9a547f6786bdc$var$GrantType.REFRESH_TOKEN_GRANT);
        $9ed9a547f6786bdc$var$addClientInfo(parameters);
        $9ed9a547f6786bdc$var$addLibraryInfo(parameters, this.config.libraryInfo);
        $9ed9a547f6786bdc$var$addApplicationTelemetry(parameters, this.config.telemetry.application);
        $9ed9a547f6786bdc$var$addThrottling(parameters);
        if (this.serverTelemetryManager && !$9ed9a547f6786bdc$var$isOidcProtocolMode(this.config)) $9ed9a547f6786bdc$var$addServerTelemetry(parameters, this.serverTelemetryManager);
        $9ed9a547f6786bdc$var$addRefreshToken(parameters, request.refreshToken);
        if (request.attributeTokens) $9ed9a547f6786bdc$var$addAttributeTokens(parameters, request.attributeTokens);
        this.performanceClient?.addFields({
            hasAttributeTokens: !!request.attributeTokens?.length
        }, request.correlationId);
        if (this.config.clientCredentials.clientSecret) $9ed9a547f6786bdc$var$addClientSecret(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            $9ed9a547f6786bdc$var$addClientAssertion(parameters, await $9ed9a547f6786bdc$var$getClientAssertion(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            $9ed9a547f6786bdc$var$addClientAssertionType(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP) {
            const popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(this.cryptoUtils, this.config.tokenBindingKeyManager, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await $9ed9a547f6786bdc$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9ed9a547f6786bdc$var$PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            $9ed9a547f6786bdc$var$addPopToken(parameters, reqCnfData);
        } else if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH) {
            if (request.sshJwk) $9ed9a547f6786bdc$var$addSshJwk(parameters, request.sshJwk);
            else throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$missingSshJwk, request.correlationId);
        }
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID:
                try {
                    const clientInfo = $9ed9a547f6786bdc$var$buildClientInfoFromHomeAccountId(request.ccsCredential.credential);
                    $9ed9a547f6786bdc$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`1qhtee ${e}`, request.correlationId);
                }
                break;
            case $9ed9a547f6786bdc$var$CcsCredentialType.UPN:
                $9ed9a547f6786bdc$var$addCcsUpn(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) $9ed9a547f6786bdc$var$addBrokerParameters(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) $9ed9a547f6786bdc$var$addExtraParameters(parameters, {
            ...request.extraParameters
        });
        $9ed9a547f6786bdc$var$instrumentBrokerParams(parameters, request.correlationId, this.performanceClient);
        $9ed9a547f6786bdc$var$addClaims(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return $9ed9a547f6786bdc$var$mapToQueryString(parameters);
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$skuGroupSeparator = ",";
const $9ed9a547f6786bdc$var$skuValueSeparator = "|";
function $9ed9a547f6786bdc$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($9ed9a547f6786bdc$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$9ed9a547f6786bdc$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $9ed9a547f6786bdc$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($9ed9a547f6786bdc$var$skuGroupSeparator);
}
function $9ed9a547f6786bdc$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($9ed9a547f6786bdc$var$skuValueSeparator);
}
/** @internal */ class $9ed9a547f6786bdc$var$ServerTelemetryManager {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = $9ed9a547f6786bdc$var$CacheOutcome.NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || "";
        this.wrapperVer = telemetryRequest.wrapperVer || "";
        this.telemetryCacheKey = $9ed9a547f6786bdc$var$SERVER_TELEM_CACHE_KEY + $9ed9a547f6786bdc$var$CACHE_KEY_SEPARATOR$1 + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${$9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join($9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join($9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR);
        return [
            $9ed9a547f6786bdc$var$SERVER_TELEM_SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join($9ed9a547f6786bdc$var$SERVER_TELEM_CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $9ed9a547f6786bdc$var$ServerTelemetryManager.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join($9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join($9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? $9ed9a547f6786bdc$var$SERVER_TELEM_OVERFLOW_TRUE : $9ed9a547f6786bdc$var$SERVER_TELEM_OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join($9ed9a547f6786bdc$var$SERVER_TELEM_VALUE_SEPARATOR);
        return [
            $9ed9a547f6786bdc$var$SERVER_TELEM_SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join($9ed9a547f6786bdc$var$SERVER_TELEM_CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        try {
            const lastRequests = this.getLastRequests();
            if (lastRequests.errors.length >= $9ed9a547f6786bdc$var$SERVER_TELEM_MAX_CACHED_ERRORS) {
                // Remove a cached error to make room, first in first out
                lastRequests.failedRequests.shift(); // apiId
                lastRequests.failedRequests.shift(); // correlationId
                lastRequests.errors.shift();
            }
            lastRequests.failedRequests.push(this.apiId, this.correlationId);
            if (error instanceof Error && !!error && error.toString()) {
                if (error instanceof $9ed9a547f6786bdc$var$AuthError) {
                    if (error.subError) lastRequests.errors.push(error.subError);
                    else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                    else lastRequests.errors.push(error.toString());
                } else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push($9ed9a547f6786bdc$var$SERVER_TELEM_UNKNOWN_ERROR);
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        } catch  {
        // Ignore telemetry cache failures to avoid masking the original auth error path.
        }
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey, this.correlationId);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $9ed9a547f6786bdc$var$ServerTelemetryManager.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || "";
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || "";
            const errorCode = serverTelemetryEntity.errors[i] || "";
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < $9ed9a547f6786bdc$var$SERVER_TELEM_MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || "");
        regionDiscoveryFields.push(this.regionSource || "");
        regionDiscoveryFields.push(this.regionOutcome || "");
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $9ed9a547f6786bdc$var$makeExtraSkuString(params);
    }
}
/** @internal */ class $9ed9a547f6786bdc$var$StubServerTelemetryManager extends $9ed9a547f6786bdc$var$ServerTelemetryManager {
    constructor(){
        super({
            clientId: "",
            apiId: 0,
            correlationId: "",
            forceRefresh: false
        }, {});
    }
    generateCurrentRequestHeaderValue() {
        return "";
    }
    generateLastRequestHeaderValue() {
        return "";
    }
    cacheFailedRequest() {}
    incrementCacheHits() {
        return 0;
    }
    clearTelemetryCache() {}
    getRegionDiscoveryFields() {
        return "";
    }
    updateRegionDiscoveryMetadata() {}
    setCacheOutcome() {}
    setNativeBrokerErrorCode() {}
    getNativeBrokerErrorCode() {
        return undefined;
    }
    clearNativeBrokerErrorCode() {}
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9ed9a547f6786bdc$var$SilentFlowClient {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = $9ed9a547f6786bdc$var$buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new $9ed9a547f6786bdc$var$Logger(this.config.loggerOptions, $9ed9a547f6786bdc$var$name$1, $9ed9a547f6786bdc$var$version$1);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        let lastCacheOutcome = $9ed9a547f6786bdc$var$CacheOutcome.NOT_APPLICABLE;
        if (request.forceRefresh || !$9ed9a547f6786bdc$var$StringUtils.isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome($9ed9a547f6786bdc$var$CacheOutcome.FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, request.correlationId);
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$noAccountInSilentRequest, request.correlationId);
        const requestTenantId = request.account.tenantId || $9ed9a547f6786bdc$var$getTenantFromAuthorityString(request.authority, request.correlationId);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome($9ed9a547f6786bdc$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, request.correlationId);
        } else if ($9ed9a547f6786bdc$var$wasClockTurnedBack(cachedAccessToken.cachedAt) || $9ed9a547f6786bdc$var$isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome($9ed9a547f6786bdc$var$CacheOutcome.CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, request.correlationId);
        } else if (request.resource) // cached access token must have a resource that matches the request resource for MCP scenarios
        {
            if (cachedAccessToken.resource !== request.resource) {
                this.setCacheOutcome($9ed9a547f6786bdc$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, request.correlationId);
            }
        } else if (cachedAccessToken.refreshOn && $9ed9a547f6786bdc$var$isTokenExpired(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = $9ed9a547f6786bdc$var$CacheOutcome.PROACTIVELY_REFRESHED;
        const cachedAccessTokenType = cachedAccessToken.tokenType?.toLowerCase();
        if (cachedAccessTokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP.toLowerCase()) {
            if (!cachedAccessToken.keyId) {
                this.logger.info("1enswf", request.correlationId);
                this.setCacheOutcome($9ed9a547f6786bdc$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, request.correlationId);
            }
            try {
                await this.config.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(cachedAccessToken.keyId, request.correlationId);
            } catch  {
                this.logger.info("14djth", request.correlationId);
                this.setCacheOutcome($9ed9a547f6786bdc$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, request.correlationId);
            }
        }
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(request.account), request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment, request.correlationId)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await $9ed9a547f6786bdc$var$invokeAsync(this.generateResultFromCacheRecord.bind(this), $9ed9a547f6786bdc$var$SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== $9ed9a547f6786bdc$var$CacheOutcome.NOT_APPLICABLE) this.logger.info(`09ingz ${cacheOutcome}`, correlationId);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode, request.correlationId);
        return $9ed9a547f6786bdc$var$ResponseHandler.generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, this.performanceClient, {
            idTokenClaims: idTokenClaims,
            tokenBindingKeyManager: this.config.tokenBindingKeyManager
        });
    }
}
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$StubbedNetworkModule = {
    // Module-level singleton: no per-request correlationId available
    sendGetRequestAsync: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, ""));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, ""));
    }
};
/*! @azure/msal-common v16.14.1 2026-09-15 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Helper to enforce resource parameter presence in token requests when isMcp is set in the configuration.
 * If resource parameter is set in both the request and in extraQueryParameters or extraParameters, an error will be thrown.
 * This is used for MCP flows.
 * @param isMcp - Flag indicating if application is an MCP app, from configuration
 * @param request - Auth request
 */ function $9ed9a547f6786bdc$var$enforceResourceParameter(isMcp, request) {
    if (!isMcp) return;
    if (request.resource && ($9ed9a547f6786bdc$var$containsResourceParam(request.extraParameters) || $9ed9a547f6786bdc$var$containsResourceParam(request.extraQueryParameters))) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$misplacedResourceParam, request.correlationId || "");
    if (!request.resource) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$resourceParameterRequired, request.correlationId || "");
}
function $9ed9a547f6786bdc$var$containsResourceParam(params) {
    if (!params) return false;
    return Object.prototype.hasOwnProperty.call(params, "resource");
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenFromCache (msal-browser).
 * Internal API for acquiring token from cache
 */ const $9ed9a547f6786bdc$var$AcquireTokenFromCache = "acquireTokenFromCache";
/**
 * acquireTokenByRefreshToken API (msal-browser and msal-node).
 * Used to renew an access token using a refresh token against the token endpoint.
 */ const $9ed9a547f6786bdc$var$AcquireTokenByRefreshToken = "acquireTokenByRefreshToken";
/**
 * acquireTokenSilentAsync (msal-browser).
 * Internal API for acquireTokenSilent.
 */ const $9ed9a547f6786bdc$var$AcquireTokenSilentAsync = "acquireTokenSilentAsync";
/**
 * provisionTokenBindingKey API in TokenBindingKeyManager class (msal-browser).
 * Used to provision token-binding key material and return a key identifier.
 */ const $9ed9a547f6786bdc$var$CryptoOptsGetPublicKeyThumbprint = "cryptoOptsGetPublicKeyThumbprint";
/**
 * signTokenBindingJwt API in CryptoOpts class (msal-browser).
 * Used to sign token-binding JWTs.
 */ const $9ed9a547f6786bdc$var$CryptoOptsSignJwt = "cryptoOptsSignJwt";
/**
 * acquireToken API in the SilentCacheClient class (msal-browser).
 * Used to read access tokens from the cache.
 */ const $9ed9a547f6786bdc$var$SilentCacheClientAcquireToken = "silentCacheClientAcquireToken";
/**
 * acquireToken API in the SilentIframeClient class (msal-browser).
 * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
 */ const $9ed9a547f6786bdc$var$SilentIframeClientAcquireToken = "silentIframeClientAcquireToken";
const $9ed9a547f6786bdc$var$AwaitConcurrentIframe = "awaitConcurrentIframe"; // Time spent waiting for a concurrent iframe to complete
/**
 * acquireToken API in SilentRereshClient (msal-browser).
 * Used to acquire a new set of tokens from the token endpoint using a refresh token.
 */ const $9ed9a547f6786bdc$var$SilentRefreshClientAcquireToken = "silentRefreshClientAcquireToken";
/**
 * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
 * Used to load authority metadata for a request.
 */ const $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority = "standardInteractionClientGetDiscoveredAuthority";
/**
 * acquireToken API in NativeInteractionClient class (msal-browser).
 * Used to acquire a token from Native component when native brokering is enabled.
 */ const $9ed9a547f6786bdc$var$NativeInteractionClientAcquireToken = "nativeInteractionClientAcquireToken";
const $9ed9a547f6786bdc$var$NativeInteractionClientAcquireTokenRedirect = "nativeInteractionClientAcquireToken";
/**
 * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
 */ const $9ed9a547f6786bdc$var$RefreshTokenClientAcquireTokenByRefreshToken = "refreshTokenClientAcquireTokenByRefreshToken";
/**
 * acquireTokenBySilentIframe (msal-browser).
 * Internal API for acquiring token by silent Iframe
 */ const $9ed9a547f6786bdc$var$AcquireTokenBySilentIframe = "acquireTokenBySilentIframe";
/**
 * Internal API for initializing base request in BaseInteractionClient (msal-browser)
 */ const $9ed9a547f6786bdc$var$InitializeBaseRequest = "initializeBaseRequest";
/**
 * Internal API for initializing silent request in SilentCacheClient (msal-browser)
 */ const $9ed9a547f6786bdc$var$InitializeSilentRequest = "initializeSilentRequest";
const $9ed9a547f6786bdc$var$InitializeCache = "initializeCache";
/**
 * Helper function in SilentIframeClient class (msal-browser).
 */ const $9ed9a547f6786bdc$var$SilentIframeClientTokenHelper = "silentIframeClientTokenHelper";
/**
 * SilentHandler
 */ const $9ed9a547f6786bdc$var$SilentHandlerInitiateAuthRequest = "silentHandlerInitiateAuthRequest";
const $9ed9a547f6786bdc$var$SilentHandlerMonitorIframeForHash = "silentHandlerMonitorIframeForHash";
/**
 * Helper functions in StandardInteractionClient class (msal-browser)
 */ const $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient = "standardInteractionClientCreateAuthCodeClient";
const $9ed9a547f6786bdc$var$StandardInteractionClientGetClientConfiguration = "standardInteractionClientGetClientConfiguration";
const $9ed9a547f6786bdc$var$StandardInteractionClientInitializeAuthorizationRequest = "standardInteractionClientInitializeAuthorizationRequest";
const $9ed9a547f6786bdc$var$SilentFlowClientAcquireCachedToken = "silentFlowClientAcquireCachedToken";
const $9ed9a547f6786bdc$var$GetStandardParams = "getStandardParams";
const $9ed9a547f6786bdc$var$HandleCodeResponse = "handleCodeResponse";
const $9ed9a547f6786bdc$var$HandleResponseEar = "handleResponseEar";
const $9ed9a547f6786bdc$var$HandleResponsePlatformBroker = "handleResponsePlatformBroker";
const $9ed9a547f6786bdc$var$HandleResponseCode = "handleResponseCode";
const $9ed9a547f6786bdc$var$AuthClientAcquireToken = "authClientAcquireToken";
const $9ed9a547f6786bdc$var$DeserializeResponse = "deserializeResponse";
const $9ed9a547f6786bdc$var$AuthorityFactoryCreateDiscoveredInstance = "authorityFactoryCreateDiscoveredInstance";
const $9ed9a547f6786bdc$var$AcquireTokenByCodeAsync = "acquireTokenByCodeAsync";
const $9ed9a547f6786bdc$var$HandleRedirectPromiseMeasurement = "handleRedirectPromise";
const $9ed9a547f6786bdc$var$HandleNativeRedirectPromiseMeasurement = "handleNativeRedirectPromise";
const $9ed9a547f6786bdc$var$NativeMessageHandlerHandshake = "nativeMessageHandlerHandshake";
const $9ed9a547f6786bdc$var$RemoveHiddenIframe = "removeHiddenIframe";
const $9ed9a547f6786bdc$var$ImportExistingCache = "importExistingCache";
/**
 * Crypto Operations
 */ const $9ed9a547f6786bdc$var$GeneratePkceCodes = "generatePkceCodes";
const $9ed9a547f6786bdc$var$GenerateCodeVerifier = "generateCodeVerifier";
const $9ed9a547f6786bdc$var$GenerateCodeChallengeFromVerifier = "generateCodeChallengeFromVerifier";
const $9ed9a547f6786bdc$var$Sha256Digest = "sha256Digest";
const $9ed9a547f6786bdc$var$GetRandomValues = "getRandomValues";
const $9ed9a547f6786bdc$var$GenerateHKDF = "generateHKDF";
const $9ed9a547f6786bdc$var$GenerateBaseKey = "generateBaseKey";
const $9ed9a547f6786bdc$var$Base64Decode = "base64Decode";
const $9ed9a547f6786bdc$var$UrlEncodeArr = "urlEncodeArr";
const $9ed9a547f6786bdc$var$Encrypt = "encrypt";
const $9ed9a547f6786bdc$var$Decrypt = "decrypt";
const $9ed9a547f6786bdc$var$GenerateEarKey = "generateEarKey";
const $9ed9a547f6786bdc$var$DecryptEarResponse = "decryptEarResponse";
const $9ed9a547f6786bdc$var$LoadAccount = "loadAccount";
const $9ed9a547f6786bdc$var$LoadIdToken = "loadIdToken";
const $9ed9a547f6786bdc$var$LoadAccessToken = "loadAccessToken";
const $9ed9a547f6786bdc$var$LoadRefreshToken = "loadRefreshToken";
/**
 * Background telemetry measurement that tracks whether a late bridge response
 * arrives after the iframe timeout has already fired.
 */ const $9ed9a547f6786bdc$var$WaitForBridgeLateResponse$1 = "waitForBridgeLateResponse";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$pkceNotCreated = "pkce_not_created";
const $9ed9a547f6786bdc$var$earJwkEmpty = "ear_jwk_empty";
const $9ed9a547f6786bdc$var$earJweEmpty = "ear_jwe_empty";
const $9ed9a547f6786bdc$var$cryptoNonExistent = "crypto_nonexistent";
const $9ed9a547f6786bdc$var$emptyNavigateUri = "empty_navigate_uri";
const $9ed9a547f6786bdc$var$hashEmptyError = "hash_empty_error";
const $9ed9a547f6786bdc$var$noStateInHash = "no_state_in_hash";
const $9ed9a547f6786bdc$var$hashDoesNotContainKnownProperties = "hash_does_not_contain_known_properties";
const $9ed9a547f6786bdc$var$unableToParseState = "unable_to_parse_state";
const $9ed9a547f6786bdc$var$stateInteractionTypeMismatch = "state_interaction_type_mismatch";
const $9ed9a547f6786bdc$var$interactionInProgress = "interaction_in_progress";
const $9ed9a547f6786bdc$var$interactionInProgressCancelled = "interaction_in_progress_cancelled";
const $9ed9a547f6786bdc$var$popupWindowError = "popup_window_error";
const $9ed9a547f6786bdc$var$emptyWindowError = "empty_window_error";
const $9ed9a547f6786bdc$var$userCancelled = "user_cancelled";
const $9ed9a547f6786bdc$var$redirectBridgeEmptyResponse = "redirect_bridge_empty_response";
const $9ed9a547f6786bdc$var$redirectInIframe = "redirect_in_iframe";
const $9ed9a547f6786bdc$var$blockIframeReload = "block_iframe_reload";
const $9ed9a547f6786bdc$var$blockNestedPopups = "block_nested_popups";
const $9ed9a547f6786bdc$var$popupRelayUnsupportedFlow = "popup_relay_unsupported_flow";
const $9ed9a547f6786bdc$var$iframeClosedPrematurely = "iframe_closed_prematurely";
const $9ed9a547f6786bdc$var$silentLogoutUnsupported = "silent_logout_unsupported";
const $9ed9a547f6786bdc$var$noAccountError = "no_account_error";
const $9ed9a547f6786bdc$var$silentPromptValueError = "silent_prompt_value_error";
const $9ed9a547f6786bdc$var$noTokenRequestCacheError = "no_token_request_cache_error";
const $9ed9a547f6786bdc$var$unableToParseTokenRequestCacheError = "unable_to_parse_token_request_cache_error";
const $9ed9a547f6786bdc$var$authRequestNotSetError = "auth_request_not_set_error";
const $9ed9a547f6786bdc$var$invalidCacheType = "invalid_cache_type";
const $9ed9a547f6786bdc$var$nonBrowserEnvironment = "non_browser_environment";
const $9ed9a547f6786bdc$var$databaseNotOpen = "database_not_open";
const $9ed9a547f6786bdc$var$noNetworkConnectivity = "no_network_connectivity";
const $9ed9a547f6786bdc$var$postRequestFailed = "post_request_failed";
const $9ed9a547f6786bdc$var$getRequestFailed = "get_request_failed";
const $9ed9a547f6786bdc$var$failedToParseResponse = "failed_to_parse_response";
const $9ed9a547f6786bdc$var$unableToLoadToken = "unable_to_load_token";
const $9ed9a547f6786bdc$var$cryptoKeyNotFound = "crypto_key_not_found";
const $9ed9a547f6786bdc$var$invalidPublicJwk = "invalid_public_jwk";
const $9ed9a547f6786bdc$var$authCodeRequired = "auth_code_required";
const $9ed9a547f6786bdc$var$authCodeOrNativeAccountIdRequired = "auth_code_or_nativeAccountId_required";
const $9ed9a547f6786bdc$var$spaCodeAndNativeAccountIdPresent = "spa_code_and_nativeAccountId_present";
const $9ed9a547f6786bdc$var$databaseUnavailable = "database_unavailable";
const $9ed9a547f6786bdc$var$unableToAcquireTokenFromNativePlatform = "unable_to_acquire_token_from_native_platform";
const $9ed9a547f6786bdc$var$nativeHandshakeTimeout = "native_handshake_timeout";
const $9ed9a547f6786bdc$var$nativeExtensionNotInstalled = "native_extension_not_installed";
const $9ed9a547f6786bdc$var$nativeConnectionNotEstablished = "native_connection_not_established";
const $9ed9a547f6786bdc$var$uninitializedPublicClientApplication = "uninitialized_public_client_application";
const $9ed9a547f6786bdc$var$nativePromptNotSupported = "native_prompt_not_supported";
const $9ed9a547f6786bdc$var$invalidBase64String = "invalid_base64_string";
const $9ed9a547f6786bdc$var$invalidPopTokenRequest = "invalid_pop_token_request";
const $9ed9a547f6786bdc$var$unsupportedTokenBindingAlgorithm = "unsupported_token_binding_algorithm";
const $9ed9a547f6786bdc$var$tokenBindingKeyAlgorithmMismatch = "token_binding_key_algorithm_mismatch";
const $9ed9a547f6786bdc$var$tokenBindingKeyJwkThumbprintMismatch = "token_binding_key_jwk_thumbprint_mismatch";
const $9ed9a547f6786bdc$var$failedToBuildHeaders = "failed_to_build_headers";
const $9ed9a547f6786bdc$var$failedToParseHeaders = "failed_to_parse_headers";
const $9ed9a547f6786bdc$var$failedToDecryptEarResponse = "failed_to_decrypt_ear_response";
const $9ed9a547f6786bdc$var$timedOut = "timed_out";
const $9ed9a547f6786bdc$var$emptyResponse = "empty_response";
var $9ed9a547f6786bdc$var$BrowserAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    authCodeOrNativeAccountIdRequired: $9ed9a547f6786bdc$var$authCodeOrNativeAccountIdRequired,
    authCodeRequired: $9ed9a547f6786bdc$var$authCodeRequired,
    authRequestNotSetError: $9ed9a547f6786bdc$var$authRequestNotSetError,
    blockIframeReload: $9ed9a547f6786bdc$var$blockIframeReload,
    blockNestedPopups: $9ed9a547f6786bdc$var$blockNestedPopups,
    cryptoKeyNotFound: $9ed9a547f6786bdc$var$cryptoKeyNotFound,
    cryptoNonExistent: $9ed9a547f6786bdc$var$cryptoNonExistent,
    databaseNotOpen: $9ed9a547f6786bdc$var$databaseNotOpen,
    databaseUnavailable: $9ed9a547f6786bdc$var$databaseUnavailable,
    earJweEmpty: $9ed9a547f6786bdc$var$earJweEmpty,
    earJwkEmpty: $9ed9a547f6786bdc$var$earJwkEmpty,
    emptyNavigateUri: $9ed9a547f6786bdc$var$emptyNavigateUri,
    emptyResponse: $9ed9a547f6786bdc$var$emptyResponse,
    emptyWindowError: $9ed9a547f6786bdc$var$emptyWindowError,
    failedToBuildHeaders: $9ed9a547f6786bdc$var$failedToBuildHeaders,
    failedToDecryptEarResponse: $9ed9a547f6786bdc$var$failedToDecryptEarResponse,
    failedToParseHeaders: $9ed9a547f6786bdc$var$failedToParseHeaders,
    failedToParseResponse: $9ed9a547f6786bdc$var$failedToParseResponse,
    getRequestFailed: $9ed9a547f6786bdc$var$getRequestFailed,
    hashDoesNotContainKnownProperties: $9ed9a547f6786bdc$var$hashDoesNotContainKnownProperties,
    hashEmptyError: $9ed9a547f6786bdc$var$hashEmptyError,
    iframeClosedPrematurely: $9ed9a547f6786bdc$var$iframeClosedPrematurely,
    interactionInProgress: $9ed9a547f6786bdc$var$interactionInProgress,
    interactionInProgressCancelled: $9ed9a547f6786bdc$var$interactionInProgressCancelled,
    invalidBase64String: $9ed9a547f6786bdc$var$invalidBase64String,
    invalidCacheType: $9ed9a547f6786bdc$var$invalidCacheType,
    invalidPopTokenRequest: $9ed9a547f6786bdc$var$invalidPopTokenRequest,
    invalidPublicJwk: $9ed9a547f6786bdc$var$invalidPublicJwk,
    nativeConnectionNotEstablished: $9ed9a547f6786bdc$var$nativeConnectionNotEstablished,
    nativeExtensionNotInstalled: $9ed9a547f6786bdc$var$nativeExtensionNotInstalled,
    nativeHandshakeTimeout: $9ed9a547f6786bdc$var$nativeHandshakeTimeout,
    nativePromptNotSupported: $9ed9a547f6786bdc$var$nativePromptNotSupported,
    noAccountError: $9ed9a547f6786bdc$var$noAccountError,
    noNetworkConnectivity: $9ed9a547f6786bdc$var$noNetworkConnectivity,
    noStateInHash: $9ed9a547f6786bdc$var$noStateInHash,
    noTokenRequestCacheError: $9ed9a547f6786bdc$var$noTokenRequestCacheError,
    nonBrowserEnvironment: $9ed9a547f6786bdc$var$nonBrowserEnvironment,
    pkceNotCreated: $9ed9a547f6786bdc$var$pkceNotCreated,
    popupRelayUnsupportedFlow: $9ed9a547f6786bdc$var$popupRelayUnsupportedFlow,
    popupWindowError: $9ed9a547f6786bdc$var$popupWindowError,
    postRequestFailed: $9ed9a547f6786bdc$var$postRequestFailed,
    redirectBridgeEmptyResponse: $9ed9a547f6786bdc$var$redirectBridgeEmptyResponse,
    redirectInIframe: $9ed9a547f6786bdc$var$redirectInIframe,
    silentLogoutUnsupported: $9ed9a547f6786bdc$var$silentLogoutUnsupported,
    silentPromptValueError: $9ed9a547f6786bdc$var$silentPromptValueError,
    spaCodeAndNativeAccountIdPresent: $9ed9a547f6786bdc$var$spaCodeAndNativeAccountIdPresent,
    stateInteractionTypeMismatch: $9ed9a547f6786bdc$var$stateInteractionTypeMismatch,
    timedOut: $9ed9a547f6786bdc$var$timedOut,
    tokenBindingKeyAlgorithmMismatch: $9ed9a547f6786bdc$var$tokenBindingKeyAlgorithmMismatch,
    tokenBindingKeyJwkThumbprintMismatch: $9ed9a547f6786bdc$var$tokenBindingKeyJwkThumbprintMismatch,
    unableToAcquireTokenFromNativePlatform: $9ed9a547f6786bdc$var$unableToAcquireTokenFromNativePlatform,
    unableToLoadToken: $9ed9a547f6786bdc$var$unableToLoadToken,
    unableToParseState: $9ed9a547f6786bdc$var$unableToParseState,
    unableToParseTokenRequestCacheError: $9ed9a547f6786bdc$var$unableToParseTokenRequestCacheError,
    uninitializedPublicClientApplication: $9ed9a547f6786bdc$var$uninitializedPublicClientApplication,
    unsupportedTokenBindingAlgorithm: $9ed9a547f6786bdc$var$unsupportedTokenBindingAlgorithm,
    userCancelled: $9ed9a547f6786bdc$var$userCancelled
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$getDefaultErrorMessage(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $9ed9a547f6786bdc$var$BrowserAuthError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, subError){
        super(errorCode, correlationId, $9ed9a547f6786bdc$var$getDefaultErrorMessage(errorCode), subError);
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$BrowserAuthError.prototype);
        this.name = "BrowserAuthError";
    }
}
function $9ed9a547f6786bdc$var$createBrowserAuthError(errorCode, correlationId, subError) {
    return new $9ed9a547f6786bdc$var$BrowserAuthError(errorCode, correlationId, subError);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $9ed9a547f6786bdc$var$base64Decode(input) {
    return new TextDecoder().decode($9ed9a547f6786bdc$var$base64DecToArr(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $9ed9a547f6786bdc$var$base64DecToArr(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidBase64String, "");
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $9ed9a547f6786bdc$var$BrowserConstants = {
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $9ed9a547f6786bdc$var$PlatformAuthConstants = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const $9ed9a547f6786bdc$var$NativeExtensionMethod = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $9ed9a547f6786bdc$var$BrowserCacheLocation = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $9ed9a547f6786bdc$var$HTTP_REQUEST_TYPE = {
    GET: "GET",
    POST: "POST"
};
const $9ed9a547f6786bdc$var$INTERACTION_TYPE = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $9ed9a547f6786bdc$var$TemporaryCacheKeys = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
/**
 * Cache keys stored in-memory
 */ const $9ed9a547f6786bdc$var$InMemoryCacheKeys = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 * 900-999 Misc
 */ const $9ed9a547f6786bdc$var$ApiId = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962,
    hydrateCache: 963,
    loadExternalTokens: 964
};
/**
 * API Names for Telemetry purposes.
 */ const $9ed9a547f6786bdc$var$ApiName = {
    861: "acquireTokenRedirect",
    862: "acquireTokenPopup",
    863: "ssoSilent",
    864: "acquireTokenSilent_authCode",
    865: "handleRedirectPromise",
    866: "acquireTokenByCode",
    61: "acquireTokenSilent_silentFlow",
    961: "logout",
    962: "logoutPopup",
    963: "hydrateCache",
    964: "loadExternalTokens"
};
const $9ed9a547f6786bdc$var$apiIdToName = (id)=>{
    if (typeof id === "number" && id in $9ed9a547f6786bdc$var$ApiName) return $9ed9a547f6786bdc$var$ApiName[id];
    return "unknown";
};
$9ed9a547f6786bdc$export$4ec29255e7e7f68f = void 0;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($9ed9a547f6786bdc$export$4ec29255e7e7f68f || ($9ed9a547f6786bdc$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $9ed9a547f6786bdc$var$InteractionStatus = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $9ed9a547f6786bdc$var$DEFAULT_REQUEST = {
    scopes: $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $9ed9a547f6786bdc$var$KEY_FORMAT_JWK = "jwk";
// Supported wrapper SKUs
const $9ed9a547f6786bdc$var$WrapperSKU = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $9ed9a547f6786bdc$var$DB_NAME = "msal.db";
const $9ed9a547f6786bdc$var$DB_VERSION = 1;
const $9ed9a547f6786bdc$var$DB_TABLE_NAME = `${$9ed9a547f6786bdc$var$DB_NAME}.keys`;
const $9ed9a547f6786bdc$var$CacheLookupPolicy = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $9ed9a547f6786bdc$var$iFrameRenewalPolicies = [
    $9ed9a547f6786bdc$var$CacheLookupPolicy.Default,
    $9ed9a547f6786bdc$var$CacheLookupPolicy.Skip,
    $9ed9a547f6786bdc$var$CacheLookupPolicy.RefreshTokenAndNetwork
];
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $9ed9a547f6786bdc$var$urlEncode(input) {
    return encodeURIComponent($9ed9a547f6786bdc$var$base64Encode(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $9ed9a547f6786bdc$var$urlEncodeArr(inputArr) {
    return $9ed9a547f6786bdc$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $9ed9a547f6786bdc$var$base64Encode(input) {
    return $9ed9a547f6786bdc$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $9ed9a547f6786bdc$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const $9ed9a547f6786bdc$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const $9ed9a547f6786bdc$var$AES_GCM = "AES-GCM";
const $9ed9a547f6786bdc$var$HKDF = "HKDF";
// SHA-256 hashing algorithm
const $9ed9a547f6786bdc$var$S256_HASH_ALG = "SHA-256";
// JWK values used by browser-internal WebCrypto helpers.
const $9ed9a547f6786bdc$var$JSON_WEB_KEY_CURVE_P256 = "P-256";
const $9ed9a547f6786bdc$var$JSON_WEB_KEY_TYPE_EC = "EC";
const $9ed9a547f6786bdc$var$JSON_WEB_KEY_TYPE_RSA = "RSA";
const $9ed9a547f6786bdc$var$MISSING_JWK_KTY_SUBERROR = "missing_jwk_kty";
const $9ed9a547f6786bdc$var$UNSUPPORTED_JWK_KTY_SUBERROR = "unsupported_jwk_kty";
const $9ed9a547f6786bdc$var$MISSING_JWK_MEMBER_SUBERROR = "missing_jwk_member";
const $9ed9a547f6786bdc$var$EMPTY_JWK_MEMBER_SUBERROR = "empty_jwk_member";
// MOD length for PoP tokens
const $9ed9a547f6786bdc$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $9ed9a547f6786bdc$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $9ed9a547f6786bdc$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $9ed9a547f6786bdc$var$UINT32_ARR = new Uint32Array(1);
// Key Format
const $9ed9a547f6786bdc$var$RAW = "raw";
// Key Usages
const $9ed9a547f6786bdc$var$ENCRYPT = "encrypt";
const $9ed9a547f6786bdc$var$DECRYPT = "decrypt";
const $9ed9a547f6786bdc$var$DERIVE_KEY = "deriveKey";
// Suberror
const $9ed9a547f6786bdc$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $9ed9a547f6786bdc$var$RSA_KEYGEN_ALGORITHM_OPTIONS = {
    name: $9ed9a547f6786bdc$var$PKCS1_V15_KEYGEN_ALG,
    hash: $9ed9a547f6786bdc$var$S256_HASH_ALG,
    modulusLength: $9ed9a547f6786bdc$var$MODULUS_LENGTH,
    publicExponent: $9ed9a547f6786bdc$var$PUBLIC_EXPONENT
};
const $9ed9a547f6786bdc$var$RSA_SIGN_ALGORITHM_OPTIONS = {
    name: $9ed9a547f6786bdc$var$PKCS1_V15_KEYGEN_ALG
};
const $9ed9a547f6786bdc$var$ECDSA_P256_KEYGEN_ALGORITHM_OPTIONS = {
    name: "ECDSA",
    namedCurve: $9ed9a547f6786bdc$var$JSON_WEB_KEY_CURVE_P256
};
const $9ed9a547f6786bdc$var$ECDSA_SHA256_SIGN_ALGORITHM_OPTIONS = {
    name: "ECDSA",
    hash: {
        name: $9ed9a547f6786bdc$var$S256_HASH_ALG
    }
};
/**
 * Check whether browser crypto is available.
 */ function $9ed9a547f6786bdc$var$validateCryptoAvailable(skipValidateSubtleCrypto) {
    if (!window) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nonBrowserEnvironment, "");
    if (!window.crypto) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$cryptoNonExistent, "");
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$cryptoNonExistent, "", $9ed9a547f6786bdc$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $9ed9a547f6786bdc$var$sha256Digest(dataString) {
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($9ed9a547f6786bdc$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $9ed9a547f6786bdc$var$getRandomValues(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $9ed9a547f6786bdc$var$getRandomUint32() {
    window.crypto.getRandomValues($9ed9a547f6786bdc$var$UINT32_ARR);
    return $9ed9a547f6786bdc$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $9ed9a547f6786bdc$var$createNewGuid() {
    const currentTimestamp = Date.now();
    const baseRand = $9ed9a547f6786bdc$var$getRandomUint32() * 0x400 + ($9ed9a547f6786bdc$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $9ed9a547f6786bdc$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $9ed9a547f6786bdc$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $9ed9a547f6786bdc$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on the provided algorithm config.
 * @param extractable
 * @param usages
 * @param algorithm
 */ async function $9ed9a547f6786bdc$var$generateKeyPair(extractable, usages, algorithm) {
    return window.crypto.subtle.generateKey(algorithm, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $9ed9a547f6786bdc$var$exportJwk(key) {
    return window.crypto.subtle.exportKey($9ed9a547f6786bdc$var$KEY_FORMAT_JWK, key);
}
/**
 * Signs given data with given key.
 * @param key
 * @param data
 * @param algorithm
 */ async function $9ed9a547f6786bdc$var$sign(key, data, algorithm) {
    return window.crypto.subtle.sign(algorithm, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function $9ed9a547f6786bdc$var$generateEarKey() {
    const key = await $9ed9a547f6786bdc$var$generateBaseKey();
    const keyStr = $9ed9a547f6786bdc$var$urlEncodeArr(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return $9ed9a547f6786bdc$var$base64Encode(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function $9ed9a547f6786bdc$var$importEarKey(earJwk) {
    const b64DecodedJwk = $9ed9a547f6786bdc$var$base64Decode(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = $9ed9a547f6786bdc$var$base64DecToArr(rawKey);
    return window.crypto.subtle.importKey($9ed9a547f6786bdc$var$RAW, keyBuffer, $9ed9a547f6786bdc$var$AES_GCM, false, [
        $9ed9a547f6786bdc$var$DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function $9ed9a547f6786bdc$var$decryptEarResponse(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToDecryptEarResponse, "", "jwe_length");
    const key = await $9ed9a547f6786bdc$var$importEarKey(earJwk).catch(()=>{
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToDecryptEarResponse, "", "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = $9ed9a547f6786bdc$var$base64DecToArr(earJweParts[2]);
        const ciphertext = $9ed9a547f6786bdc$var$base64DecToArr(earJweParts[3]);
        const tag = $9ed9a547f6786bdc$var$base64DecToArr(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: $9ed9a547f6786bdc$var$AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToDecryptEarResponse, "", "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function $9ed9a547f6786bdc$var$generateBaseKey() {
    const key = await window.crypto.subtle.generateKey({
        name: $9ed9a547f6786bdc$var$AES_GCM,
        length: 256
    }, true, [
        $9ed9a547f6786bdc$var$ENCRYPT,
        $9ed9a547f6786bdc$var$DECRYPT
    ]);
    return window.crypto.subtle.exportKey($9ed9a547f6786bdc$var$RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function $9ed9a547f6786bdc$var$generateHKDF(baseKey) {
    return window.crypto.subtle.importKey($9ed9a547f6786bdc$var$RAW, baseKey, $9ed9a547f6786bdc$var$HKDF, false, [
        $9ed9a547f6786bdc$var$DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function $9ed9a547f6786bdc$var$deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: $9ed9a547f6786bdc$var$HKDF,
        salt: nonce,
        hash: $9ed9a547f6786bdc$var$S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: $9ed9a547f6786bdc$var$AES_GCM,
        length: 256
    }, false, [
        $9ed9a547f6786bdc$var$ENCRYPT,
        $9ed9a547f6786bdc$var$DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function $9ed9a547f6786bdc$var$encrypt(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await $9ed9a547f6786bdc$var$deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: $9ed9a547f6786bdc$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: $9ed9a547f6786bdc$var$urlEncodeArr(new Uint8Array(encryptedData)),
        nonce: $9ed9a547f6786bdc$var$urlEncodeArr(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function $9ed9a547f6786bdc$var$decrypt(baseKey, nonce, context, encryptedData) {
    const encodedData = $9ed9a547f6786bdc$var$base64DecToArr(encryptedData);
    const derivedKey = await $9ed9a547f6786bdc$var$deriveKey(baseKey, $9ed9a547f6786bdc$var$base64DecToArr(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: $9ed9a547f6786bdc$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $9ed9a547f6786bdc$var$hashString(plainText) {
    const hashBuffer = await $9ed9a547f6786bdc$var$sha256Digest(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return $9ed9a547f6786bdc$var$urlEncodeArr(hashBytes);
}
const $9ed9a547f6786bdc$var$JWK_THUMBPRINT_REQUIRED_MEMBERS = {
    [$9ed9a547f6786bdc$var$JSON_WEB_KEY_TYPE_EC]: [
        "crv",
        "kty",
        "x",
        "y"
    ],
    [$9ed9a547f6786bdc$var$JSON_WEB_KEY_TYPE_RSA]: [
        "e",
        "kty",
        "n"
    ]
};
function $9ed9a547f6786bdc$var$getJwkThumbprintMembers(publicJwk, correlationId) {
    const kty = publicJwk.kty;
    if (typeof kty !== "string" || kty.length === 0) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidPublicJwk, correlationId, $9ed9a547f6786bdc$var$MISSING_JWK_KTY_SUBERROR);
    const requiredMembers = $9ed9a547f6786bdc$var$JWK_THUMBPRINT_REQUIRED_MEMBERS[kty];
    if (!requiredMembers) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidPublicJwk, correlationId, $9ed9a547f6786bdc$var$UNSUPPORTED_JWK_KTY_SUBERROR);
    return requiredMembers.reduce((thumbprintMembers, memberName)=>{
        const memberValue = publicJwk[memberName];
        if (typeof memberValue !== "string") throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidPublicJwk, correlationId, $9ed9a547f6786bdc$var$MISSING_JWK_MEMBER_SUBERROR);
        if (memberValue.length === 0) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidPublicJwk, correlationId, $9ed9a547f6786bdc$var$EMPTY_JWK_MEMBER_SUBERROR);
        thumbprintMembers[memberName] = memberValue;
        return thumbprintMembers;
    }, {});
}
/**
 * Computes an RFC 7638 JWK thumbprint for a public key.
 * The required members for the JWK key type are serialised in lexicographic order
 * and the SHA-256 digest is returned as a base64url string.
 * @internal
 */ async function $9ed9a547f6786bdc$var$computeJwkThumbprint(publicJwk, correlationId) {
    const thumbprintMembers = $9ed9a547f6786bdc$var$getJwkThumbprintMembers(publicJwk, correlationId);
    // RFC 7638 §3.3: use only required members, sorted lexicographically
    const thumbprintJson = JSON.stringify(thumbprintMembers, Object.keys(thumbprintMembers).sort());
    return $9ed9a547f6786bdc$var$hashString(thumbprintJson);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$storageNotSupported = "storage_not_supported";
const $9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled = "stubbed_public_client_application_called";
const $9ed9a547f6786bdc$var$inMemRedirectUnavailable = "in_mem_redirect_unavailable";
var $9ed9a547f6786bdc$var$BrowserConfigurationAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    inMemRedirectUnavailable: $9ed9a547f6786bdc$var$inMemRedirectUnavailable,
    storageNotSupported: $9ed9a547f6786bdc$var$storageNotSupported,
    stubbedPublicClientApplicationCalled: $9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $9ed9a547f6786bdc$var$BrowserConfigurationAuthError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$BrowserConfigurationAuthError.prototype);
    }
}
function $9ed9a547f6786bdc$var$createBrowserConfigurationAuthError(errorCode, correlationId) {
    return new $9ed9a547f6786bdc$var$BrowserConfigurationAuthError(errorCode, correlationId, $9ed9a547f6786bdc$var$getDefaultErrorMessage(errorCode));
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts and parses the authentication response from URL (hash and/or query string).
 * This is a shared utility used across multiple components in msal-browser.
 *
 * @returns {Object} An object containing the parsed state information and URL parameters.
 * @returns {URLSearchParams} params - The parsed URL parameters from the payload.
 * @returns {string} payload - The combined query string and hash content.
 * @returns {string} urlHash - The original URL hash.
 * @returns {string} urlQuery - The original URL query string.
 * @returns {LibraryStateObject} libraryState - The decoded library state from the state parameter.
 *
 * @throws {AuthError} If no authentication payload is found in the URL.
 * @throws {AuthError} If the state parameter is missing.
 * @throws {AuthError} If the state is missing required 'id' or 'meta' attributes.
 */ function $9ed9a547f6786bdc$var$parseAuthResponseFromUrl() {
    // Extract both hash and query string to support hybrid response format
    const urlHash = window.location.hash;
    const urlQuery = window.location.search;
    // Determine which part contains the auth response by checking for 'state' parameter
    let hasResponseInHash = false;
    let hasResponseInQuery = false;
    let payload = "";
    let params = undefined;
    if (urlHash && urlHash.length > 1) {
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        const hashParams = new URLSearchParams(hashContent);
        if (hashParams.has("state")) {
            hasResponseInHash = true;
            payload = hashContent;
            params = hashParams;
        }
    }
    if (urlQuery && urlQuery.length > 1) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const queryParams = new URLSearchParams(queryContent);
        if (queryParams.has("state")) {
            hasResponseInQuery = true;
            payload = queryContent;
            params = queryParams;
        }
    }
    // If response is in both, combine them (hybrid format)
    if (hasResponseInHash && hasResponseInQuery) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        payload = `${queryContent}${hashContent}`;
        params = new URLSearchParams(payload);
    }
    /*
     * Called by the redirect-bridge entry point before any request context exists,
     * so correlationId is intentionally empty for the throws below.
     */ if (!payload || !params) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$emptyResponse, "");
    const state = params.get("state");
    if (!state) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$noStateInHash, "");
    const { libraryState: libraryState } = $9ed9a547f6786bdc$var$parseRequestState($9ed9a547f6786bdc$var$base64Decode, state, "");
    const { id: id, meta: meta } = libraryState;
    if (!id || !meta) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unableToParseState, "", "missing_library_state");
    return {
        params: params,
        payload: payload,
        urlHash: urlHash,
        urlQuery: urlQuery,
        hasResponseInHash: hasResponseInHash,
        hasResponseInQuery: hasResponseInQuery,
        libraryState: {
            id: id,
            meta: meta
        }
    };
}
/**
 * Clears hash from window url.
 */ function $9ed9a547f6786bdc$var$clearHash(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Strips both hash and query string from the given window's URL by replacing
 * with origin + pathname only. Used to remove auth response parameters
 * (auth code, state, etc.) before the window is closed or navigated away.
 */ function $9ed9a547f6786bdc$var$clearAuthResponseFromUrl(contentWindow) {
    if (typeof contentWindow.history?.replaceState === "function") contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $9ed9a547f6786bdc$var$replaceHash(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $9ed9a547f6786bdc$var$isInIframe() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $9ed9a547f6786bdc$var$isInPopup() {
    if ($9ed9a547f6786bdc$var$isInIframe()) return false;
    try {
        const { libraryState: libraryState } = $9ed9a547f6786bdc$var$parseAuthResponseFromUrl();
        const { meta: meta } = libraryState;
        return meta["interactionType"] === $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup;
    } catch (e) {
        // If parsing fails (no state, invalid URL, etc.), we're not in a popup
        return false;
    }
}
/**
 * Await a response from a redirect bridge using BroadcastChannel.
 * This unified function works for both popup and iframe scenarios by listening on a
 * BroadcastChannel for the server payload.
 *
 * @param timeoutMs - Timeout in milliseconds.
 * @param logger - Logger instance for logging monitoring events.
 * @param browserCrypto - Browser crypto instance for decoding state.
 * @param request - The authorization or end session request.
 * @returns Promise<string> - Resolves with the response string (query or hash) from the window.
 */ // Track the active bridge monitor to allow cancellation when overriding interactions
let $9ed9a547f6786bdc$var$activeBridgeMonitor = null;
/**
 * Cancels the pending bridge response monitor if one exists.
 * This is called when overrideInteractionInProgress is used to cancel
 * any pending popup interaction before starting a new one.
 */ function $9ed9a547f6786bdc$var$cancelPendingBridgeResponse(logger, correlationId) {
    if ($9ed9a547f6786bdc$var$activeBridgeMonitor) {
        logger.verbose("18y01k", correlationId);
        clearTimeout($9ed9a547f6786bdc$var$activeBridgeMonitor.timeoutId);
        $9ed9a547f6786bdc$var$activeBridgeMonitor.channel.close();
        $9ed9a547f6786bdc$var$activeBridgeMonitor.reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$interactionInProgressCancelled, ""));
        $9ed9a547f6786bdc$var$activeBridgeMonitor = null;
    }
}
/** @internal */ async function $9ed9a547f6786bdc$var$waitForBridgeResponse(timeoutMs, logger, request, performanceClient, experimentalConfig) {
    return new Promise((resolve, reject)=>{
        logger.verbose("1rf6em", request.correlationId);
        const correlationId = request.correlationId;
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs,
            lateResponseExperimentEnabled: experimentalConfig?.iframeTimeoutTelemetry || false
        }, correlationId);
        const { libraryState: libraryState } = $9ed9a547f6786bdc$var$parseRequestState($9ed9a547f6786bdc$var$base64Decode, request.state || "", request.correlationId);
        const channel = new BroadcastChannel(libraryState.id);
        let responseString = undefined;
        let timedOut$1 = false;
        let lateTimeoutId;
        let lateMeasurement;
        const timeoutId = window.setTimeout(()=>{
            // Clear the active monitor
            $9ed9a547f6786bdc$var$activeBridgeMonitor = null;
            if (experimentalConfig?.iframeTimeoutTelemetry) {
                lateMeasurement = performanceClient.startMeasurement($9ed9a547f6786bdc$var$WaitForBridgeLateResponse$1, correlationId);
                timedOut$1 = true;
                lateTimeoutId = window.setTimeout(()=>{
                    lateMeasurement?.end({
                        success: false
                    });
                    clearTimeout(lateTimeoutId);
                    channel.close();
                }, 60000); // 60s late response timeout to allow for telemetry of late responses
            } else channel.close();
            reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$timedOut, "", "redirect_bridge_timeout"));
        }, timeoutMs);
        // Track this monitor so it can be cancelled if needed
        $9ed9a547f6786bdc$var$activeBridgeMonitor = {
            timeoutId: timeoutId,
            channel: channel,
            reject: reject
        };
        channel.onmessage = (event)=>{
            responseString = event.data.payload;
            const messageVersion = event?.data && typeof event.data.v === "number" ? event.data.v : undefined;
            if (timedOut$1) {
                lateMeasurement?.end({
                    success: responseString ? true : false
                });
                clearTimeout(lateTimeoutId);
                channel.close();
                return;
            }
            performanceClient.addFields({
                redirectBridgeMessageVersion: messageVersion
            }, correlationId);
            // Clear the active monitor
            $9ed9a547f6786bdc$var$activeBridgeMonitor = null;
            clearTimeout(timeoutId);
            channel.close();
            if (responseString) resolve(responseString);
            else reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$redirectBridgeEmptyResponse, correlationId));
        };
    });
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $9ed9a547f6786bdc$var$getCurrentUri() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $9ed9a547f6786bdc$var$getHomepage(correlationId) {
    const currentUrl = new $9ed9a547f6786bdc$var$UrlString(window.location.href, correlationId || "");
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $9ed9a547f6786bdc$var$blockReloadInHiddenIframes() {
    const isResponseHash = $9ed9a547f6786bdc$var$getDeserializedResponse(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $9ed9a547f6786bdc$var$isInIframe()) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$blockIframeReload, "");
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $9ed9a547f6786bdc$var$blockRedirectInIframe(allowRedirectInIframe) {
    if ($9ed9a547f6786bdc$var$isInIframe() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$redirectInIframe, "");
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $9ed9a547f6786bdc$var$blockAcquireTokenInPopups() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($9ed9a547f6786bdc$var$isInPopup()) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$blockNestedPopups, "");
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $9ed9a547f6786bdc$var$blockNonBrowserEnvironment() {
    if (typeof window === "undefined") throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nonBrowserEnvironment, "");
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $9ed9a547f6786bdc$var$blockAPICallsBeforeInitialize(initialized) {
    if (!initialized) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$uninitializedPublicClientApplication, "");
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $9ed9a547f6786bdc$var$preflightCheck$1(initialized) {
    // Block request if not in browser environment
    $9ed9a547f6786bdc$var$blockNonBrowserEnvironment();
    // Block auth requests inside a hidden iframe
    $9ed9a547f6786bdc$var$blockReloadInHiddenIframes();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $9ed9a547f6786bdc$var$blockAcquireTokenInPopups();
    // Block token acquisition before initialize has been called
    $9ed9a547f6786bdc$var$blockAPICallsBeforeInitialize(initialized);
}
/**
 * Helper to validate app environment before making redirect request
 * @param initialized
 * @param config
 * @internal
 */ function $9ed9a547f6786bdc$var$redirectPreflightCheck(initialized, config) {
    $9ed9a547f6786bdc$var$preflightCheck$1(initialized);
    $9ed9a547f6786bdc$var$blockRedirectInIframe(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled
    if (config.cache.cacheLocation === $9ed9a547f6786bdc$var$BrowserCacheLocation.MemoryStorage) throw $9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$inMemRedirectUnavailable, "");
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $9ed9a547f6786bdc$var$preconnect(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $9ed9a547f6786bdc$var$createGuid() {
    return $9ed9a547f6786bdc$var$createNewGuid();
}
const $9ed9a547f6786bdc$var$buildMergedClaims = $9ed9a547f6786bdc$var$buildMergedClaims$1;
var $9ed9a547f6786bdc$var$BrowserUtils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blockAPICallsBeforeInitialize: $9ed9a547f6786bdc$var$blockAPICallsBeforeInitialize,
    blockAcquireTokenInPopups: $9ed9a547f6786bdc$var$blockAcquireTokenInPopups,
    blockNonBrowserEnvironment: $9ed9a547f6786bdc$var$blockNonBrowserEnvironment,
    blockRedirectInIframe: $9ed9a547f6786bdc$var$blockRedirectInIframe,
    blockReloadInHiddenIframes: $9ed9a547f6786bdc$var$blockReloadInHiddenIframes,
    buildMergedClaims: $9ed9a547f6786bdc$var$buildMergedClaims,
    cancelPendingBridgeResponse: $9ed9a547f6786bdc$var$cancelPendingBridgeResponse,
    clearAuthResponseFromUrl: $9ed9a547f6786bdc$var$clearAuthResponseFromUrl,
    clearHash: $9ed9a547f6786bdc$var$clearHash,
    createGuid: $9ed9a547f6786bdc$var$createGuid,
    getCurrentUri: $9ed9a547f6786bdc$var$getCurrentUri,
    getHomepage: $9ed9a547f6786bdc$var$getHomepage,
    invoke: $9ed9a547f6786bdc$var$invoke,
    invokeAsync: $9ed9a547f6786bdc$var$invokeAsync,
    isInIframe: $9ed9a547f6786bdc$var$isInIframe,
    isInPopup: $9ed9a547f6786bdc$var$isInPopup,
    parseAuthResponseFromUrl: $9ed9a547f6786bdc$var$parseAuthResponseFromUrl,
    preconnect: $9ed9a547f6786bdc$var$preconnect,
    preflightCheck: $9ed9a547f6786bdc$var$preflightCheck$1,
    redirectPreflightCheck: $9ed9a547f6786bdc$var$redirectPreflightCheck,
    replaceHash: $9ed9a547f6786bdc$var$replaceHash,
    waitForBridgeResponse: $9ed9a547f6786bdc$var$waitForBridgeResponse
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $9ed9a547f6786bdc$var$DatabaseStorage {
    constructor(){
        this.dbName = $9ed9a547f6786bdc$var$DB_NAME;
        this.version = $9ed9a547f6786bdc$var$DB_VERSION;
        this.tableName = $9ed9a547f6786bdc$var$DB_TABLE_NAME;
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$databaseUnavailable, "")));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase($9ed9a547f6786bdc$var$DB_NAME);
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$MemoryStorage {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
    decryptData() {
        // Memory storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $9ed9a547f6786bdc$var$AsyncMemoryStorage {
    constructor(logger){
        this.inMemoryCache = new $9ed9a547f6786bdc$var$MemoryStorage();
        this.indexedDBCache = new $9ed9a547f6786bdc$var$DatabaseStorage();
        this.logger = logger;
    }
    handleDatabaseAccessError(error, correlationId) {
        if (error instanceof $9ed9a547f6786bdc$var$BrowserAuthError && error.errorCode === $9ed9a547f6786bdc$var$databaseUnavailable) this.logger.error("1wx7zz", correlationId);
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     * @param correlationId
     */ async getItem(key, correlationId) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("0naxpl", correlationId);
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     * @param correlationId
     */ async setItem(key, value, correlationId) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     * @param correlationId
     */ async removeItem(key, correlationId) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Get all keys from both in-memory and persistent storage.
     * @param correlationId
     */ async getKeys(correlationId) {
        const cacheKeys = this.inMemoryCache.getKeys();
        try {
            const persistentCacheKeys = await this.indexedDBCache.getKeys();
            return Array.from(new Set([
                ...cacheKeys,
                ...persistentCacheKeys
            ]));
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
            return cacheKeys;
        }
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     * @param correlationId
     */ async containsKey(key, correlationId) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("03zl2j", correlationId);
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     * @param correlationId
     */ clearInMemory(correlationId) {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("03r21p", correlationId);
        this.inMemoryCache.clear();
        this.logger.verbose("0uksk1", correlationId);
    }
    /**
     * Tries to delete the IndexedDB database
     * @param correlationId
     * @returns
     */ async clearPersistent(correlationId) {
        try {
            this.logger.verbose("0rdqut", correlationId);
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("149ouc", correlationId);
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
            return false;
        }
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Owns browser token-binding key lifecycle and storage lookup.
 * @internal
 */ class $9ed9a547f6786bdc$var$TokenBindingKeyManager {
    constructor(logger, performanceClient){
        this.logger = logger;
        this.cache = $9ed9a547f6786bdc$var$TokenBindingKeyManager.getTokenBindingKeyStorage(this.logger);
        this.performanceClient = performanceClient;
    }
    static getTokenBindingKeyStorage(logger) {
        if (!$9ed9a547f6786bdc$var$TokenBindingKeyManager.tokenBindingKeyStorage) $9ed9a547f6786bdc$var$TokenBindingKeyManager.tokenBindingKeyStorage = new $9ed9a547f6786bdc$var$AsyncMemoryStorage(logger);
        return $9ed9a547f6786bdc$var$TokenBindingKeyManager.tokenBindingKeyStorage;
    }
    /**
     * Provisions a browser token-binding key and returns its key identifier.
     * @param request - Key provisioning policy.
     */ async provisionTokenBindingKey(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement($9ed9a547f6786bdc$var$CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        try {
            const activeKeyPair = await this.createTokenBindingKey(request);
            publicKeyThumbMeasurement?.end({
                success: true,
                ...this.getTokenBindingKeyTelemetry(activeKeyPair)
            });
            return activeKeyPair.keyId;
        } catch (e) {
            publicKeyThumbMeasurement?.end({
                success: false,
                tokenBindingKeyType: request.tokenBindingKeyType,
                tokenBindingKeyAlgorithm: request.tokenBindingKeyAlgorithm
            });
            throw e;
        }
    }
    /**
     * Removes a browser token-binding key by identifier.
     * @param kid - Token-binding key identifier.
     * @param correlationId - Request correlation identifier.
     */ async removeTokenBindingKey(kid, correlationId) {
        await this.cache.removeItem(kid, correlationId);
        const keyFound = await this.cache.containsKey(kid, correlationId);
        if (keyFound) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$bindingKeyNotRemoved, correlationId);
    }
    /**
     * Clears browser token-binding keys from memory and persistent storage.
     * @param correlationId - Request correlation identifier.
     */ async clearKeystore(correlationId) {
        this.cache.clearInMemory(correlationId);
        try {
            await this.cache.clearPersistent(correlationId);
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`1owpn8 ${e.message}`, correlationId);
            else this.logger.error("0yrmwo", correlationId);
            return false;
        }
    }
    /**
     * Gets a token-binding public key as a JWK by identifier.
     * @param keyId - Token-binding key identifier.
     * @param correlationId - Request correlation identifier.
     */ async getTokenBindingPublicKeyJwk(keyId, correlationId) {
        const cachedKeyPair = await this.getTokenBindingKeyPair(keyId, correlationId);
        return $9ed9a547f6786bdc$var$exportJwk(cachedKeyPair.publicKey);
    }
    async createTokenBindingKey(request) {
        const keyGenAlgorithm = this.getTokenBindingKeyGenAlgorithmOptions(request.tokenBindingKeyAlgorithm, request.correlationId);
        const generatedKeyPair = await this.generateKeyPairAndThumbprint($9ed9a547f6786bdc$var$TokenBindingKeyManager.TOKEN_BINDING_KEY_USAGES, keyGenAlgorithm, request.correlationId);
        await this.cache.setItem(generatedKeyPair.keyId, {
            ...generatedKeyPair,
            tokenBindingKeyType: request.tokenBindingKeyType,
            tokenBindingKeyAlgorithm: request.tokenBindingKeyAlgorithm
        }, request.correlationId);
        return {
            ...generatedKeyPair,
            tokenBindingKeyType: request.tokenBindingKeyType,
            tokenBindingKeyAlgorithm: request.tokenBindingKeyAlgorithm
        };
    }
    async generateKeyPairAndThumbprint(usages, keyGenAlgorithm, correlationId) {
        const keyPair = await $9ed9a547f6786bdc$var$generateKeyPair(false, usages, keyGenAlgorithm);
        const publicJwk = await $9ed9a547f6786bdc$var$exportJwk(keyPair.publicKey);
        const keyId = await $9ed9a547f6786bdc$var$computeJwkThumbprint(publicJwk, correlationId);
        return {
            publicKey: keyPair.publicKey,
            privateKey: keyPair.privateKey,
            keyId: keyId
        };
    }
    /** @internal */ async getTokenBindingKeyPair(keyId, correlationId) {
        const cachedKeyPair = await this.cache.getItem(keyId, correlationId);
        if (!cachedKeyPair) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$cryptoKeyNotFound, correlationId);
        return cachedKeyPair;
    }
    /** @internal */ getTokenBindingKeyTelemetry(cachedKeyPair, fallbackAlgorithm) {
        return {
            ...cachedKeyPair.tokenBindingKeyType && {
                tokenBindingKeyType: cachedKeyPair.tokenBindingKeyType
            },
            ...cachedKeyPair.tokenBindingKeyAlgorithm || fallbackAlgorithm ? {
                tokenBindingKeyAlgorithm: cachedKeyPair.tokenBindingKeyAlgorithm || fallbackAlgorithm
            } : {}
        };
    }
    getTokenBindingKeyGenAlgorithmOptions(tokenBindingKeyAlgorithm, correlationId) {
        if (tokenBindingKeyAlgorithm === $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.RS256) return $9ed9a547f6786bdc$var$RSA_KEYGEN_ALGORITHM_OPTIONS;
        if (tokenBindingKeyAlgorithm === $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.ES256) return $9ed9a547f6786bdc$var$ECDSA_P256_KEYGEN_ALGORITHM_OPTIONS;
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unsupportedTokenBindingAlgorithm, correlationId);
    }
}
$9ed9a547f6786bdc$var$TokenBindingKeyManager.TOKEN_BINDING_KEY_USAGES = [
    "sign",
    "verify"
];
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $9ed9a547f6786bdc$var$CryptoOps {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        $9ed9a547f6786bdc$var$validateCryptoAvailable(skipValidateSubtleCrypto ?? false);
        this.performanceClient = performanceClient;
        this.tokenBindingKeyManager = new $9ed9a547f6786bdc$var$TokenBindingKeyManager(this.logger, this.performanceClient);
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return $9ed9a547f6786bdc$var$createNewGuid();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return $9ed9a547f6786bdc$var$base64Encode(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return $9ed9a547f6786bdc$var$base64Decode(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return $9ed9a547f6786bdc$var$urlEncode(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     * @param correlationId
     */ async removeTokenBindingKey(kid, correlationId) {
        await this.tokenBindingKeyManager.removeTokenBindingKey(kid, correlationId);
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     * @param correlationId
     */ async clearKeystore(correlationId) {
        return this.tokenBindingKeyManager.clearKeystore(correlationId);
    }
    /** @internal */ async signTokenBindingJwt(header, payload, kid, correlationId) {
        let telemetry = {};
        const signTokenBindingJwtMeasurement = this.performanceClient?.startMeasurement($9ed9a547f6786bdc$var$CryptoOptsSignJwt, correlationId);
        try {
            const cachedKeyPair = await this.tokenBindingKeyManager.getTokenBindingKeyPair(kid, correlationId);
            await this.validateTokenBindingJwtHeaderKey(header, kid, correlationId);
            telemetry = this.tokenBindingKeyManager.getTokenBindingKeyTelemetry(cachedKeyPair, header.alg);
            const signingAlgorithm = this.getTokenBindingKeySigningAlgorithm(cachedKeyPair, header.alg, correlationId);
            const tokenString = `${$9ed9a547f6786bdc$var$urlEncode(JSON.stringify(header))}.${$9ed9a547f6786bdc$var$urlEncode(JSON.stringify(payload))}`;
            const encodedSignature = await this.signInput(cachedKeyPair, tokenString, signingAlgorithm);
            signTokenBindingJwtMeasurement?.end({
                success: true,
                ...telemetry
            });
            return `${tokenString}.${encodedSignature}`;
        } catch (e) {
            signTokenBindingJwtMeasurement?.end({
                success: false,
                ...telemetry
            });
            throw e;
        }
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return $9ed9a547f6786bdc$var$hashString(plainText);
    }
    async signInput(cachedKeyPair, signingInput, algorithm) {
        const encoder = new TextEncoder();
        const signatureBuffer = await $9ed9a547f6786bdc$var$sign(cachedKeyPair.privateKey, encoder.encode(signingInput), algorithm);
        return $9ed9a547f6786bdc$var$urlEncodeArr(new Uint8Array(signatureBuffer));
    }
    getTokenBindingKeySigningAlgorithm(cachedKeyPair, requestedAlgorithm, correlationId) {
        const keyAlgorithm = cachedKeyPair.privateKey.algorithm;
        if (requestedAlgorithm === $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.RS256 && keyAlgorithm.name === $9ed9a547f6786bdc$var$RSA_SIGN_ALGORITHM_OPTIONS.name) return $9ed9a547f6786bdc$var$RSA_SIGN_ALGORITHM_OPTIONS;
        if (requestedAlgorithm === $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.ES256 && keyAlgorithm.name === $9ed9a547f6786bdc$var$ECDSA_SHA256_SIGN_ALGORITHM_OPTIONS.name && keyAlgorithm.namedCurve === $9ed9a547f6786bdc$var$ECDSA_P256_KEYGEN_ALGORITHM_OPTIONS.namedCurve) return $9ed9a547f6786bdc$var$ECDSA_SHA256_SIGN_ALGORITHM_OPTIONS;
        if (requestedAlgorithm === $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.RS256 || requestedAlgorithm === $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.ES256) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unsupportedTokenBindingAlgorithm, correlationId, $9ed9a547f6786bdc$var$tokenBindingKeyAlgorithmMismatch);
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unsupportedTokenBindingAlgorithm, correlationId);
    }
    async validateTokenBindingJwtHeaderKey(header, kid, correlationId) {
        if (!header.jwk) return;
        const headerKeyId = await $9ed9a547f6786bdc$var$computeJwkThumbprint(header.jwk, correlationId);
        if (headerKeyId !== kid) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidPublicJwk, correlationId, $9ed9a547f6786bdc$var$tokenBindingKeyJwkThumbprintMismatch);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenSilent API (msal-browser and msal-node).
 * Used to silently acquire a new access token (from the cache or the network).
 */ const $9ed9a547f6786bdc$var$AcquireTokenSilent = "acquireTokenSilent";
/**
 * acquireTokenByCode API (msal-browser and msal-node).
 * Used to acquire tokens by trading an authorization code against the token endpoint.
 */ const $9ed9a547f6786bdc$var$AcquireTokenByCode = "acquireTokenByCode";
/**
 * acquireTokenPopup (msal-browser).
 * Used to acquire a new access token interactively through pop ups
 */ const $9ed9a547f6786bdc$var$AcquireTokenPopup = "acquireTokenPopup";
/**
 * acquireTokenPreRedirect (msal-browser).
 * First part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const $9ed9a547f6786bdc$var$AcquireTokenPreRedirect = "acquireTokenPreRedirect";
/**
 * acquireTokenRedirect (msal-browser).
 * Second part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const $9ed9a547f6786bdc$var$AcquireTokenRedirect = "acquireTokenRedirect";
/**
 * ssoSilent API (msal-browser).
 * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
 */ const $9ed9a547f6786bdc$var$SsoSilent = "ssoSilent";
// Initialize client application
const $9ed9a547f6786bdc$var$InitializeClientApplication = "initializeClientApplication";
// Update cache storage
const $9ed9a547f6786bdc$var$LocalStorageUpdated = "localStorageUpdated";
// Load external tokens
const $9ed9a547f6786bdc$var$LoadExternalTokens = "loadExternalTokens";
/**
 * SSO capability verification call (msal-browser).
 * Fire-and-forget SSO verification call made after interactive authentication completes.
 */ const $9ed9a547f6786bdc$var$SsoCapable = "ssoCapable";
// Wait for late response from bridge after timeout has already occurred
const $9ed9a547f6786bdc$var$WaitForBridgeLateResponse = "waitForBridgeLateResponse";
var $9ed9a547f6786bdc$var$BrowserRootPerformanceEvents = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AcquireTokenByCode: $9ed9a547f6786bdc$var$AcquireTokenByCode,
    AcquireTokenPopup: $9ed9a547f6786bdc$var$AcquireTokenPopup,
    AcquireTokenPreRedirect: $9ed9a547f6786bdc$var$AcquireTokenPreRedirect,
    AcquireTokenRedirect: $9ed9a547f6786bdc$var$AcquireTokenRedirect,
    AcquireTokenSilent: $9ed9a547f6786bdc$var$AcquireTokenSilent,
    InitializeClientApplication: $9ed9a547f6786bdc$var$InitializeClientApplication,
    LoadExternalTokens: $9ed9a547f6786bdc$var$LoadExternalTokens,
    LocalStorageUpdated: $9ed9a547f6786bdc$var$LocalStorageUpdated,
    SsoCapable: $9ed9a547f6786bdc$var$SsoCapable,
    SsoSilent: $9ed9a547f6786bdc$var$SsoSilent,
    WaitForBridgeLateResponse: $9ed9a547f6786bdc$var$WaitForBridgeLateResponse
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$PREFIX = "msal";
const $9ed9a547f6786bdc$var$BROWSER_PREFIX = "browser";
const $9ed9a547f6786bdc$var$CACHE_KEY_SEPARATOR = "|";
const $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION = 3;
const $9ed9a547f6786bdc$var$ACCOUNT_SCHEMA_VERSION = 3;
const $9ed9a547f6786bdc$var$LOG_LEVEL_CACHE_KEY = `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$BROWSER_PREFIX}.log.level`;
const $9ed9a547f6786bdc$var$LOG_PII_CACHE_KEY = `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$BROWSER_PREFIX}.log.pii`;
const $9ed9a547f6786bdc$var$BROWSER_PERF_ENABLED_KEY = `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$BROWSER_PREFIX}.performance.enabled`;
const $9ed9a547f6786bdc$var$VERSION_CACHE_KEY = `${$9ed9a547f6786bdc$var$PREFIX}.version`;
const $9ed9a547f6786bdc$var$ACCOUNT_KEYS = "account.keys";
const $9ed9a547f6786bdc$var$TOKEN_KEYS = "token.keys";
const $9ed9a547f6786bdc$var$SSO_CAPABLE = `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$BROWSER_PREFIX}.sso.capable`;
function $9ed9a547f6786bdc$var$getAccountKeysCacheKey(schema = $9ed9a547f6786bdc$var$ACCOUNT_SCHEMA_VERSION) {
    if (schema < 1) return `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$ACCOUNT_KEYS}`;
    return `${$9ed9a547f6786bdc$var$PREFIX}.${schema}.${$9ed9a547f6786bdc$var$ACCOUNT_KEYS}`;
}
function $9ed9a547f6786bdc$var$getTokenKeysCacheKey(clientId, schema = $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION) {
    if (schema < 1) return `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$TOKEN_KEYS}.${clientId}`;
    return `${$9ed9a547f6786bdc$var$PREFIX}.${schema}.${$9ed9a547f6786bdc$var$TOKEN_KEYS}.${clientId}`;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $9ed9a547f6786bdc$var$COOKIE_LIFE_MULTIPLIER = 86400000;
const $9ed9a547f6786bdc$var$SameSiteOptions = {
    Lax: "Lax",
    None: "None"
};
class $9ed9a547f6786bdc$var$CookieStorage {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = encodeURIComponent(key);
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i].trim();
            const eqIndex = cookie.indexOf("=");
            const rawKey = eqIndex === -1 ? cookie : cookie.substring(0, eqIndex);
            if (rawKey === name) {
                const rawValue = eqIndex === -1 ? "" : cookie.substring(eqIndex + 1);
                try {
                    return decodeURIComponent(rawValue);
                } catch  {
                    return rawValue;
                }
            }
        }
        return "";
    }
    getUserData() {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, "");
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = $9ed9a547f6786bdc$var$SameSiteOptions.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = $9ed9a547f6786bdc$var$getCookieExpirationTime(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === $9ed9a547f6786bdc$var$SameSiteOptions.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData(_key, _value, correlationId) {
        return Promise.reject($9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$methodNotImplemented, correlationId));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const trimmed = cookie.trim();
            const eqIndex = trimmed.indexOf("=");
            const rawKey = eqIndex === -1 ? trimmed : trimmed.substring(0, eqIndex);
            try {
                keys.push(decodeURIComponent(rawKey));
            } catch  {
            // Skip cookies with malformed percent-encoded sequences in the key
            }
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
    decryptData() {
        // Cookie storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $9ed9a547f6786bdc$var$getCookieExpirationTime(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $9ed9a547f6786bdc$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function $9ed9a547f6786bdc$var$getAccountKeys(storage, schemaVersion) {
    const accountKeys = storage.getItem($9ed9a547f6786bdc$var$getAccountKeysCacheKey(schemaVersion));
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function $9ed9a547f6786bdc$var$getTokenKeys(clientId, storage, schemaVersion) {
    const item = storage.getItem($9ed9a547f6786bdc$var$getTokenKeysCacheKey(clientId, schemaVersion));
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$isEncrypted(data) {
    return data.hasOwnProperty("id") && data.hasOwnProperty("nonce") && data.hasOwnProperty("data");
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$ENCRYPTION_KEY = "msal.cache.encryption";
const $9ed9a547f6786bdc$var$BROADCAST_CHANNEL_NAME$1 = "msal.broadcast.cache";
class $9ed9a547f6786bdc$var$LocalStorage {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw $9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$storageNotSupported, "");
        this.memoryStorage = new $9ed9a547f6786bdc$var$MemoryStorage();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel($9ed9a547f6786bdc$var$BROADCAST_CHANNEL_NAME$1);
    }
    async initialize(correlationId) {
        const cookies = new $9ed9a547f6786bdc$var$CookieStorage();
        const cookieString = cookies.getItem($9ed9a547f6786bdc$var$ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$base64DecToArr, $9ed9a547f6786bdc$var$Base64Decode, this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateHKDF, $9ed9a547f6786bdc$var$GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one
            const id = $9ed9a547f6786bdc$var$createNewGuid();
            const baseKey = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateBaseKey, $9ed9a547f6786bdc$var$GenerateBaseKey, this.logger, this.performanceClient, correlationId)();
            const keyStr = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$urlEncodeArr, $9ed9a547f6786bdc$var$UrlEncodeArr, this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateHKDF, $9ed9a547f6786bdc$var$GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem($9ed9a547f6786bdc$var$ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, $9ed9a547f6786bdc$var$SameSiteOptions.None // SameSite must be None to support iframed apps
            );
        }
        await $9ed9a547f6786bdc$var$invokeAsync(this.importExistingCache.bind(this), $9ed9a547f6786bdc$var$ImportExistingCache, this.logger, this.performanceClient, correlationId)(correlationId);
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", (event)=>{
            this.updateCache(event, correlationId);
        });
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$uninitializedPublicClientApplication, "");
        return this.memoryStorage.getItem(key);
    }
    async decryptData(key, data, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$uninitializedPublicClientApplication, "");
        if (data.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$decrypt, $9ed9a547f6786bdc$var$Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, data.nonce, this.getContext(key), data.data);
        if (!decryptedData) return null;
        try {
            return {
                ...JSON.parse(decryptedData),
                lastUpdatedAt: data.lastUpdatedAt
            };
        } catch (e) {
            this.performanceClient.incrementFields({
                encryptedCacheCorruptionCount: 1
            }, correlationId);
            return null;
        }
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId, timestamp, kmsi) {
        if (!this.initialized || !this.encryptionCookie) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$uninitializedPublicClientApplication, "");
        if (kmsi) this.setItem(key, value);
        else {
            const { data: data, nonce: nonce } = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$encrypt, $9ed9a547f6786bdc$var$Encrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
            const encryptedData = {
                id: this.encryptionCookie.id,
                nonce: nonce,
                data: data,
                lastUpdatedAt: timestamp
            };
            this.setItem(key, JSON.stringify(encryptedData));
        }
        this.memoryStorage.setItem(key, value);
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getContext(key)
        });
    }
    removeItem(key) {
        if (this.memoryStorage.containsKey(key)) {
            this.memoryStorage.removeItem(key);
            this.broadcast.postMessage({
                key: key,
                value: null,
                context: this.getContext(key)
            });
        }
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = $9ed9a547f6786bdc$var$getAccountKeys(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith($9ed9a547f6786bdc$var$PREFIX) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = $9ed9a547f6786bdc$var$getAccountKeys(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        if (accountKeys.length) this.setItem($9ed9a547f6786bdc$var$getAccountKeysCacheKey(), JSON.stringify(accountKeys));
        else this.removeItem($9ed9a547f6786bdc$var$getAccountKeysCacheKey());
        const tokenKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        if (tokenKeys.idToken.length || tokenKeys.accessToken.length || tokenKeys.refreshToken.length) this.setItem($9ed9a547f6786bdc$var$getTokenKeysCacheKey(this.clientId), JSON.stringify(tokenKeys));
        else this.removeItem($9ed9a547f6786bdc$var$getTokenKeysCacheKey(this.clientId));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!$9ed9a547f6786bdc$var$isEncrypted(encObj)) {
            // Data is not encrypted
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return rawCache;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        this.performanceClient.incrementFields({
            encryptedCacheCount: 1
        }, correlationId);
        return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$decrypt, $9ed9a547f6786bdc$var$Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    /**
     * Gets encryption context for a given cache entry. This is clientId for app specific entries, empty string for shared entries
     * @param key
     * @returns
     */ getContext(key) {
        let context = "";
        if (key.includes(this.clientId)) context = this.clientId; // Used to bind encryption key to this appId
        return context;
    }
    updateCache(event, correlationId) {
        this.logger.trace("17cxcm", correlationId);
        const perfMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$LocalStorageUpdated);
        perfMeasurement.add({
            isBackground: true
        });
        const { key: key, value: value, context: context } = event.data;
        if (!key) {
            this.logger.error("0e10qr", correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (context && context !== this.clientId) {
            this.logger.trace(`04rtdy ${context}`, correlationId);
            /*
             * Discarded rather than ended: this is expected routing, not a failure.
             * BroadcastChannel has no server-side filtering, so every MSAL instance on
             * the origin receives every message and drops the ones scoped to another
             * clientId. With N instances sharing an origin each write produces N-1 of
             * these no-ops, so emitting them scales O(N^2) - and because they were
             * previously reported with success: false they bypassed both the 1% misc
             * sampler and the observability trimming in the 1P telemetry reporter,
             * shipping at full payload. On origins hosting many embedded first-party
             * apps that dwarfed all other MSAL telemetry combined. These events carry
             * no diagnostic value, so drop the measurement entirely. Genuine faults
             * such as the noKey case above are still reported.
             */ perfMeasurement.discard();
            return;
        }
        if (!value) {
            this.memoryStorage.removeItem(key);
            this.logger.verbose("04ypih", correlationId);
        } else {
            this.memoryStorage.setItem(key, value);
            this.logger.verbose("1vzsgt", correlationId);
        }
        perfMeasurement.end({
            success: true
        });
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$SessionStorage {
    constructor(){
        if (!window.sessionStorage) throw $9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$storageNotSupported, "");
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
    decryptData() {
        // Session storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$EventType = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_SUCCESS: "msal:loginSuccess",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    BROKERED_REQUEST_START: "msal:brokeredRequestStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    BROKERED_REQUEST_SUCCESS: "msal:brokeredRequestSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    BROKERED_REQUEST_FAILURE: "msal:brokeredRequestFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};
/* eslint-disable header/header */ const $9ed9a547f6786bdc$var$name = "@azure/msal-browser";
const $9ed9a547f6786bdc$var$version = "5.22.0";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility function to remove an element from an array in place.
 * @param array - The array from which to remove the element.
 * @param element - The element to remove from the array.
 */ function $9ed9a547f6786bdc$var$removeElementFromArray(array, element) {
    const index = array.indexOf(element);
    if (index > -1) array.splice(index, 1);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Reason an old-schema cache entry was removed during migration.
 */ const $9ed9a547f6786bdc$var$MigrationRemovalReason = {
    Invalid: "invalid",
    TtlExpired: "ttlExpired",
    DecryptFailed: "decryptFailed",
    Expired: "expired"
};
/**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 */ class $9ed9a547f6786bdc$var$BrowserCacheManager extends $9ed9a547f6786bdc$var$CacheManager {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions, tokenBindingKeyManager = $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER){
        super(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions, tokenBindingKeyManager);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new $9ed9a547f6786bdc$var$MemoryStorage();
        this.browserStorage = $9ed9a547f6786bdc$var$getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = $9ed9a547f6786bdc$var$getStorageImplementation(clientId, $9ed9a547f6786bdc$var$BrowserCacheLocation.SessionStorage, logger, performanceClient);
        this.cookieStorage = new $9ed9a547f6786bdc$var$CookieStorage();
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        this.performanceClient.addFields({
            cacheLocation: this.cacheConfig.cacheLocation,
            cacheRetentionDays: this.cacheConfig.cacheRetentionDays
        }, correlationId);
        await this.browserStorage.initialize(correlationId);
        await this.migrateExistingCache(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Migrates any existing cache data from previous versions of MSAL.js into the current cache structure.
     */ async migrateExistingCache(correlationId) {
        let accountKeys = $9ed9a547f6786bdc$var$getAccountKeys(this.browserStorage);
        let tokenKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            preMigrateAcntCount: accountKeys.length,
            preMigrateATCount: tokenKeys.accessToken.length,
            preMigrateITCount: tokenKeys.idToken.length,
            preMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
        for(let i = 0; i < $9ed9a547f6786bdc$var$ACCOUNT_SCHEMA_VERSION; i++){
            const credentialSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.removeStaleAccounts(i, credentialSchema, correlationId);
        }
        // Must migrate idTokens first to ensure we have KMSI info for the rest
        for(let i = 0; i < $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION; i++){
            const accountSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.migrateIdTokens(i, accountSchema, correlationId);
        }
        const kmsiMap = this.getKMSIValues();
        for(let i = 0; i < $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION; i++){
            await this.migrateAccessTokens(i, kmsiMap, correlationId);
            await this.migrateRefreshTokens(i, kmsiMap, correlationId);
        }
        accountKeys = $9ed9a547f6786bdc$var$getAccountKeys(this.browserStorage);
        tokenKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            postMigrateAcntCount: accountKeys.length,
            postMigrateATCount: tokenKeys.accessToken.length,
            postMigrateITCount: tokenKeys.idToken.length,
            postMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
    }
    /**
     * Parses entry, adds lastUpdatedAt if it doesn't exist, removes entry if expired or invalid
     * @param key
     * @param correlationId
     * @returns
     */ async updateOldEntry(key, correlationId) {
        const rawValue = this.browserStorage.getItem(key);
        const parsedValue = this.validateAndParseJson(rawValue || "");
        if (!parsedValue) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9ed9a547f6786bdc$var$MigrationRemovalReason.Invalid
            };
        }
        if (!parsedValue.lastUpdatedAt) {
            // Add lastUpdatedAt to the existing v0 entry if it doesnt exist so we know when it's safe to remove it
            parsedValue.lastUpdatedAt = Date.now().toString();
            this.setItem(key, JSON.stringify(parsedValue), correlationId);
        } else if ($9ed9a547f6786bdc$var$isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9ed9a547f6786bdc$var$MigrationRemovalReason.TtlExpired
            };
        }
        const wasEncrypted = $9ed9a547f6786bdc$var$isEncrypted(parsedValue);
        const decryptedData = wasEncrypted ? await this.browserStorage.decryptData(key, parsedValue, correlationId) : parsedValue;
        if (!decryptedData) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: wasEncrypted ? $9ed9a547f6786bdc$var$MigrationRemovalReason.DecryptFailed : $9ed9a547f6786bdc$var$MigrationRemovalReason.Invalid
            };
        }
        if (!$9ed9a547f6786bdc$var$isCredentialEntity(decryptedData)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9ed9a547f6786bdc$var$MigrationRemovalReason.Invalid
            };
        }
        if (($9ed9a547f6786bdc$var$isAccessTokenEntity(decryptedData) || $9ed9a547f6786bdc$var$isRefreshTokenEntity(decryptedData)) && decryptedData.expiresOn && $9ed9a547f6786bdc$var$isTokenExpired(decryptedData.expiresOn, $9ed9a547f6786bdc$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9ed9a547f6786bdc$var$MigrationRemovalReason.Expired
            };
        }
        return {
            entry: decryptedData
        };
    }
    /**
     * Remove accounts from the cache for older schema versions if they have not been updated in the last cacheRetentionDays
     * @param accountSchema
     * @param credentialSchema
     * @param correlationId
     * @returns
     */ async removeStaleAccounts(accountSchema, credentialSchema, correlationId) {
        const accountKeysToCheck = $9ed9a547f6786bdc$var$getAccountKeys(this.browserStorage, accountSchema);
        if (accountKeysToCheck.length === 0) return;
        for (const accountKey of [
            ...accountKeysToCheck
        ]){
            this.performanceClient.incrementFields({
                oldAcntCount: 1
            }, correlationId);
            const rawValue = this.browserStorage.getItem(accountKey);
            const parsedValue = this.validateAndParseJson(rawValue || "");
            if (!parsedValue) {
                this.browserStorage.removeItem(accountKey);
                this.performanceClient.incrementFields({
                    invalidAcntCount: 1
                }, correlationId);
                $9ed9a547f6786bdc$var$removeElementFromArray(accountKeysToCheck, accountKey);
                continue;
            }
            if (!parsedValue.lastUpdatedAt) {
                // Add lastUpdatedAt to the existing entry if it doesnt exist so we know when it's safe to remove it
                parsedValue.lastUpdatedAt = Date.now().toString();
                this.setItem(accountKey, JSON.stringify(parsedValue), correlationId);
                continue;
            } else if ($9ed9a547f6786bdc$var$isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
                // Cache expired remove account and associated tokens
                await this.removeAccountOldSchema(accountKey, parsedValue, credentialSchema, correlationId);
                this.performanceClient.incrementFields({
                    ttlExpiredAcntCount: 1
                }, correlationId);
                $9ed9a547f6786bdc$var$removeElementFromArray(accountKeysToCheck, accountKey);
            } else if ($9ed9a547f6786bdc$var$isEncrypted(parsedValue)) {
                // Remove accounts encrypted with a different key (session cookie expired/changed)
                const decrypted = await this.browserStorage.decryptData(accountKey, parsedValue, correlationId);
                if (!decrypted) {
                    this.browserStorage.removeItem(accountKey);
                    this.performanceClient.incrementFields({
                        decryptFailedAcntCount: 1
                    }, correlationId);
                    $9ed9a547f6786bdc$var$removeElementFromArray(accountKeysToCheck, accountKey);
                }
            }
        }
        this.setAccountKeys(accountKeysToCheck, correlationId, accountSchema);
    }
    /**
     * Remove the given account and all associated tokens from the cache
     * @param accountKey
     * @param rawObject
     * @param credentialSchema
     * @param correlationId
     */ async removeAccountOldSchema(accountKey, rawObject, credentialSchema, correlationId) {
        const decryptedData = $9ed9a547f6786bdc$var$isEncrypted(rawObject) ? await this.browserStorage.decryptData(accountKey, rawObject, correlationId) : rawObject;
        const homeAccountId = decryptedData?.homeAccountId;
        if (homeAccountId) {
            const tokenKeys = this.getTokenKeys(credentialSchema);
            [
                ...tokenKeys.idToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                $9ed9a547f6786bdc$var$removeElementFromArray(tokenKeys.idToken, key);
            });
            [
                ...tokenKeys.accessToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                $9ed9a547f6786bdc$var$removeElementFromArray(tokenKeys.accessToken, key);
            });
            [
                ...tokenKeys.refreshToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                $9ed9a547f6786bdc$var$removeElementFromArray(tokenKeys.refreshToken, key);
            });
            this.setTokenKeys(tokenKeys, correlationId, credentialSchema);
        }
        this.browserStorage.removeItem(accountKey);
    }
    /**
     * Gets key value pair mapping homeAccountId to KMSI value
     * @returns
     */ getKMSIValues() {
        const kmsiMap = {};
        const tokenKeys = this.getTokenKeys().idToken;
        for (const key of tokenKeys){
            const rawValue = this.browserStorage.getUserData(key);
            if (rawValue) {
                const idToken = JSON.parse(rawValue);
                const claims = $9ed9a547f6786bdc$var$extractTokenClaims(idToken.secret, $9ed9a547f6786bdc$var$base64Decode, "");
                if (claims) kmsiMap[idToken.homeAccountId] = $9ed9a547f6786bdc$var$isKmsi(claims);
            }
        }
        return kmsiMap;
    }
    /**
     * Migrates id tokens from the old schema to the new schema, also migrates associated account object if it doesn't already exist in the new schema
     * @param credentialSchema
     * @param accountSchema
     * @param correlationId
     * @returns
     */ async migrateIdTokens(credentialSchema, accountSchema, correlationId) {
        const credentialKeysToMigrate = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.idToken.length === 0) return;
        const currentCredentialKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION);
        const currentAccountKeys = $9ed9a547f6786bdc$var$getAccountKeys(this.browserStorage);
        const previousAccountKeys = $9ed9a547f6786bdc$var$getAccountKeys(this.browserStorage, accountSchema);
        for (const idTokenKey of [
            ...credentialKeysToMigrate.idToken
        ]){
            this.performanceClient.incrementFields({
                oldITCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(idTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredITCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedITCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidITCount: 1
                        }, correlationId);
                        break;
                }
                $9ed9a547f6786bdc$var$removeElementFromArray(credentialKeysToMigrate.idToken, idTokenKey);
                continue;
            }
            const currentAccountKey = currentAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            const previousAccountKey = previousAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            let account = null;
            if (currentAccountKey) account = this.getAccount(currentAccountKey, correlationId);
            else if (previousAccountKey) {
                const rawValue = this.browserStorage.getItem(previousAccountKey);
                const parsedValue = this.validateAndParseJson(rawValue || "");
                account = parsedValue && $9ed9a547f6786bdc$var$isEncrypted(parsedValue) ? await this.browserStorage.decryptData(previousAccountKey, parsedValue, correlationId) : parsedValue;
            }
            if (!account) {
                // Don't migrate idToken if we don't have an account for it
                this.performanceClient.incrementFields({
                    skipITMigrateCount: 1
                }, correlationId);
                continue;
            }
            const claims = $9ed9a547f6786bdc$var$extractTokenClaims(oldSchemaData.secret, $9ed9a547f6786bdc$var$base64Decode, correlationId);
            const newIdTokenKey = this.generateCredentialKey(oldSchemaData);
            const currentIdToken = this.getIdTokenCredential(newIdTokenKey, correlationId);
            const oldTokenHasSignInState = Object.keys(claims).includes("signin_state");
            const currentTokenHasSignInState = currentIdToken && Object.keys($9ed9a547f6786bdc$var$extractTokenClaims(currentIdToken.secret, $9ed9a547f6786bdc$var$base64Decode, correlationId) || {}).includes("signin_state");
            /**
             * Only migrate if:
             * 1. Token doesn't yet exist in current schema
             * 2. Old schema token has been updated more recently than the current one AND migrating it won't result in loss of KMSI state
             */ if (!currentIdToken || oldSchemaData.lastUpdatedAt > currentIdToken.lastUpdatedAt && (oldTokenHasSignInState || !currentTokenHasSignInState)) {
                const tenantProfiles = account.tenantProfiles || [];
                const tenantId = $9ed9a547f6786bdc$var$getTenantIdFromIdTokenClaims(claims) || account.realm;
                if (tenantId && !tenantProfiles.find((tenantProfile)=>{
                    return tenantProfile.tenantId === tenantId;
                })) {
                    const newTenantProfile = $9ed9a547f6786bdc$var$buildTenantProfile(account.homeAccountId, account.localAccountId, tenantId, account.nativeAccountId, claims);
                    tenantProfiles.push(newTenantProfile);
                }
                account.tenantProfiles = tenantProfiles;
                const newAccountKey = this.generateAccountKey($9ed9a547f6786bdc$var$getAccountInfo(account));
                const kmsi = $9ed9a547f6786bdc$var$isKmsi(claims);
                await this.setUserData(newAccountKey, JSON.stringify(account), correlationId, account.lastUpdatedAt, kmsi);
                if (!currentAccountKeys.includes(newAccountKey)) currentAccountKeys.push(newAccountKey);
                await this.setUserData(newIdTokenKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedITCount: 1
                }, correlationId);
                if (!currentCredentialKeys.idToken.includes(newIdTokenKey)) currentCredentialKeys.idToken.push(newIdTokenKey);
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
        this.setAccountKeys(currentAccountKeys, correlationId);
    }
    /**
     * Migrates access tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateAccessTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.accessToken.length === 0) return;
        const currentCredentialKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION);
        for (const accessTokenKey of [
            ...credentialKeysToMigrate.accessToken
        ]){
            this.performanceClient.incrementFields({
                oldATCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(accessTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredATCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedATCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredATCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidATCount: 1
                        }, correlationId);
                        break;
                }
                $9ed9a547f6786bdc$var$removeElementFromArray(credentialKeysToMigrate.accessToken, accessTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipATMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.accessToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedATCount: 1
                }, correlationId);
                currentCredentialKeys.accessToken.push(newKey);
            } else {
                const currentToken = this.getAccessTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedATCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Migrates refresh tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateRefreshTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.refreshToken.length === 0) return;
        const currentCredentialKeys = $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION);
        for (const refreshTokenKey of [
            ...credentialKeysToMigrate.refreshToken
        ]){
            this.performanceClient.incrementFields({
                oldRTCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(refreshTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredRTCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedRTCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredRTCount: 1
                        }, correlationId);
                        break;
                    case $9ed9a547f6786bdc$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidRTCount: 1
                        }, correlationId);
                        break;
                }
                $9ed9a547f6786bdc$var$removeElementFromArray(credentialKeysToMigrate.refreshToken, refreshTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipRTMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.refreshToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedRTCount: 1
                }, correlationId);
                currentCredentialKeys.refreshToken.push(newKey);
            } else {
                const currentToken = this.getRefreshTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedRTCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem($9ed9a547f6786bdc$var$VERSION_CACHE_KEY);
        if (previousVersion) {
            this.logger.info(`1wuc87 ${previousVersion}`, correlationId);
            this.performanceClient.addGlobalFields({
                previousLibraryVersion: previousVersion
            });
        }
        if (previousVersion !== $9ed9a547f6786bdc$var$version) this.setItem($9ed9a547f6786bdc$var$VERSION_CACHE_KEY, $9ed9a547f6786bdc$var$version, correlationId);
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        if (!jsonValue) return null;
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Helper to setItem in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        const tokenKeysCount = new Array($9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)// Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
        try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION; schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = $9ed9a547f6786bdc$var$createCacheError(e);
            if (cacheError.errorCode === $9ed9a547f6786bdc$var$cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    // If we are currently trying to set the token keys, use the value we're trying to set
                    for(let i = 0; i <= $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION; i++)if (key === $9ed9a547f6786bdc$var$getTokenKeysCacheKey(this.clientId, i)) {
                        const tokenKeys = JSON.parse(value).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    } else {
                        const tokenKeys = this.getTokenKeys(i).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    }
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Helper to setUserData in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     * @param correlationId
     */ async setUserData(key, value, correlationId, timestamp, kmsi) {
        const tokenKeysCount = new Array($9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            // Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
            await $9ed9a547f6786bdc$var$invokeAsync(this.browserStorage.setUserData.bind(this.browserStorage), $9ed9a547f6786bdc$var$SetUserData, this.logger, this.performanceClient, correlationId)(key, value, correlationId, timestamp, kmsi);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION; schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = $9ed9a547f6786bdc$var$createCacheError(e);
            if (cacheError.errorCode === $9ed9a547f6786bdc$var$cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) // If we are currently trying to set the token keys, use the value we're trying to set
                for(let i = 0; i <= $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION; i++){
                    const tokenKeys = this.getTokenKeys(i).accessToken;
                    accessTokenKeys.push(...tokenKeys);
                    tokenKeysCount[i] = tokenKeys.length;
                }
                if (accessTokenKeys.length <= i) // Nothing left to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey, correlationId) {
        this.logger.trace("1lfvm6", correlationId);
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !$9ed9a547f6786bdc$var$isAccountEntity(parsedAccount)) return null;
        const account = $9ed9a547f6786bdc$var$CacheManager.toObject({}, parsedAccount);
        this.performanceClient.addFields({
            accountCachedBy: $9ed9a547f6786bdc$var$apiIdToName(account.cachedByApiId)
        }, correlationId);
        return account;
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId, kmsi, apiId) {
        this.logger.trace("1bz3wr", correlationId);
        const key = this.generateAccountKey($9ed9a547f6786bdc$var$getAccountInfo(account));
        const timestamp = Date.now().toString();
        account.lastUpdatedAt = timestamp;
        account.cachedByApiId = apiId;
        await this.setUserData(key, JSON.stringify(account), correlationId, timestamp, kmsi);
        this.addAccountKeyToMap(key, correlationId);
        this.performanceClient.addFields({
            kmsi: kmsi
        }, correlationId);
    }
    setAccountKeys(accountKeys, correlationId, schemaVersion = $9ed9a547f6786bdc$var$ACCOUNT_SCHEMA_VERSION) {
        if (accountKeys.length === 0) this.removeItem($9ed9a547f6786bdc$var$getAccountKeysCacheKey(schemaVersion));
        else this.setItem($9ed9a547f6786bdc$var$getAccountKeysCacheKey(schemaVersion), JSON.stringify(accountKeys), correlationId);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return $9ed9a547f6786bdc$var$getAccountKeys(this.browserStorage);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("0rb85k", correlationId);
        this.logger.tracePii(`1l9bdo ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem($9ed9a547f6786bdc$var$getAccountKeysCacheKey(), JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("0xia39", correlationId);
            return true;
        } else {
            this.logger.verbose("0161kk", correlationId);
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("1jpigu", correlationId);
        this.logger.tracePii(`1xzspl ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setAccountKeys(accountKeys, correlationId);
        } else this.logger.trace("1dytu2", correlationId);
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ removeAccount(account, correlationId) {
        const activeAccount = this.getActiveAccount(correlationId);
        if (activeAccount?.homeAccountId === account.homeAccountId && activeAccount?.environment === account.environment) this.setActiveAccount(null, correlationId);
        super.removeAccount(account, correlationId);
        this.removeAccountKeyFromMap(this.generateAccountKey(account), correlationId);
        // Remove all other associated cache items
        this.browserStorage.getKeys().forEach((key)=>{
            if (key.includes(account.homeAccountId) && key.includes(account.environment)) this.browserStorage.removeItem(key);
        });
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const idRemoval = tokenKeys.idToken.indexOf(key);
        if (idRemoval > -1) {
            this.logger.info("05udv9", correlationId);
            tokenKeys.idToken.splice(idRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        updateTokenKeys && this.removeAccessTokenKeys([
            key
        ], correlationId);
    }
    /**
     * Remove access token key from the key map
     * @param key
     * @param correlationId
     * @param tokenKeys
     */ removeAccessTokenKeys(keys, correlationId, schemaVersion = $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION) {
        this.logger.trace("17o18n", correlationId);
        const tokenKeys = this.getTokenKeys(schemaVersion);
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`15i5d5 ${keysRemoved}`, correlationId);
            this.setTokenKeys(tokenKeys, correlationId, schemaVersion);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
        if (refreshRemoval > -1) {
            this.logger.info("1f4fq3", correlationId);
            tokenKeys.refreshToken.splice(refreshRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys(schemaVersion = $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION) {
        return $9ed9a547f6786bdc$var$getTokenKeys(this.clientId, this.browserStorage, schemaVersion);
    }
    /**
     * Sets the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId, schemaVersion = $9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem($9ed9a547f6786bdc$var$getTokenKeysCacheKey(this.clientId, schemaVersion));
            return;
        } else this.setItem($9ed9a547f6786bdc$var$getTokenKeysCacheKey(this.clientId, schemaVersion), JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("1jukz6", correlationId);
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !$9ed9a547f6786bdc$var$isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("1jukz6", correlationId);
            return null;
        }
        this.logger.trace("01ju66", correlationId);
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId, kmsi) {
        this.logger.trace("13hjll", correlationId);
        const idTokenKey = this.generateCredentialKey(idToken);
        const timestamp = Date.now().toString();
        idToken.lastUpdatedAt = timestamp;
        await this.setUserData(idTokenKey, JSON.stringify(idToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.idToken.indexOf(idTokenKey) === -1) {
            this.logger.info("07jy92", correlationId);
            tokenKeys.idToken.push(idTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("0bqvx8", correlationId);
            this.removeAccessTokenKeys([
                accessTokenKey
            ], correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !$9ed9a547f6786bdc$var$isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("0bqvx8", correlationId);
            return null;
        }
        this.logger.trace("1o81rl", correlationId);
        return parsedAccessToken;
    }
    /**
     * Set accessToken credential to the platform cache
     * @param accessToken - the access token entity to cache
     */ async setAccessTokenCredential(accessToken, correlationId, kmsi, additionalCacheKeyHash) {
        this.logger.trace("1pondb", correlationId);
        const accessTokenKey = this.generateCredentialKey(accessToken, additionalCacheKeyHash);
        const timestamp = Date.now().toString();
        accessToken.lastUpdatedAt = timestamp;
        await this.setUserData(accessTokenKey, JSON.stringify(accessToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        const index = tokenKeys.accessToken.indexOf(accessTokenKey);
        if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
        this.logger.trace(`1onhey ${index === -1 ? "added to" : "updated in"}`, correlationId);
        tokenKeys.accessToken.push(accessTokenKey);
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("0jlizt", correlationId);
            this.removeRefreshToken(refreshTokenKey, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !$9ed9a547f6786bdc$var$isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("0jlizt", correlationId);
            return null;
        }
        this.logger.trace("0nokxi", correlationId);
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId, kmsi) {
        this.logger.trace("0tcg8d", correlationId);
        const refreshTokenKey = this.generateCredentialKey(refreshToken);
        const timestamp = Date.now().toString();
        refreshToken.lastUpdatedAt = timestamp;
        await this.setUserData(refreshTokenKey, JSON.stringify(refreshToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.refreshToken.indexOf(refreshTokenKey) === -1) {
            this.logger.info("0eckjs", correlationId);
            tokenKeys.refreshToken.push(refreshTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     * @param correlationId
     */ getAppMetadata(appMetadataKey, correlationId) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !$9ed9a547f6786bdc$var$isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        this.logger.trace("19pvg2", correlationId);
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     * @param correlationId
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("0cyma6", correlationId);
        const appMetadataKey = $9ed9a547f6786bdc$var$generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     * @param correlationId
     */ getServerTelemetry(serverTelemetryKey, correlationId) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !$9ed9a547f6786bdc$var$isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        this.logger.trace("12jguk", correlationId);
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("1poh61", correlationId);
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key, correlationId) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("1r39oe", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && $9ed9a547f6786bdc$var$isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("1ohvk3", correlationId);
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem($9ed9a547f6786bdc$var$InMemoryCacheKeys.WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem($9ed9a547f6786bdc$var$InMemoryCacheKeys.WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem($9ed9a547f6786bdc$var$InMemoryCacheKeys.WRAPPER_SKU) || "";
        const version = this.internalStorage.getItem($9ed9a547f6786bdc$var$InMemoryCacheKeys.WRAPPER_VER) || "";
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param key
     * @param entity
     * @param correlationId
     */ setAuthorityMetadata(key, entity, correlationId) {
        this.logger.trace("07w8n2", correlationId);
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey($9ed9a547f6786bdc$var$PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("08gw0e", correlationId);
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("1t3ch7", correlationId);
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("0me1up", correlationId);
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey($9ed9a547f6786bdc$var$PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("0rsj80", correlationId);
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
        } else {
            this.logger.verbose("1bp5z5", correlationId);
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACTIVE_ACCOUNT_CHANGED, correlationId);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     * @param correlationId
     */ getThrottlingCache(throttlingCacheKey, correlationId) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !$9ed9a547f6786bdc$var$isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        this.logger.trace("0of6n8", correlationId);
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("0wfgh6", correlationId);
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * @param cacheKey
     * @param correlationId
     * @param generateKey
     */ getTemporaryCache(cacheKey, correlationId, generateKey) {
        this.logger.trace("1ordf8", correlationId);
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        return this.temporaryCacheStorage.getItem(key);
    }
    /**
     * Sets the cache item with the key and value given.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ clear(correlationId) {
        // Removes all accounts and their credentials
        this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf($9ed9a547f6786bdc$var$PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf($9ed9a547f6786bdc$var$PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Prepend msal.<client-id> to each key
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        if ($9ed9a547f6786bdc$var$StringUtils.startsWith(key, $9ed9a547f6786bdc$var$PREFIX)) return key;
        return `${$9ed9a547f6786bdc$var$PREFIX}.${this.clientId}.${key}`;
    }
    /**
     * Generate Credential Key. All changes to the key REQUIRE a schema version update.
     * Cache Key: msal.<schema_version>|<home_account_id>|<environment>|<credential_type>|<client_id or familyId>|<realm>|<scopes>|<scheme>|<additional_cache_key_components_hash>
     *
     * @param credentialEntity
     * @param hash - optional precomputed hash of additionalCacheKeyComponents
     * @returns
     */ generateCredentialKey(credential, additionalCacheKeyHash) {
        const familyId = credential.credentialType === $9ed9a547f6786bdc$var$CredentialType.REFRESH_TOKEN && credential.familyId || credential.clientId;
        const scheme = credential.tokenType && credential.tokenType.toLowerCase() !== $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER.toLowerCase() ? credential.tokenType.toLowerCase() : "";
        const credentialKey = [
            `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$CREDENTIAL_SCHEMA_VERSION}`,
            credential.homeAccountId,
            credential.environment,
            credential.credentialType,
            familyId,
            credential.realm || "",
            credential.target || "",
            scheme
        ];
        // Append precomputed component-hash segment.
        if (credential.additionalCacheKeyComponents && Object.keys(credential.additionalCacheKeyComponents).length > 0 && additionalCacheKeyHash) credentialKey.push(additionalCacheKeyHash);
        return credentialKey.join($9ed9a547f6786bdc$var$CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Cache Key: msal.<schema_version>.<home_account_id>.<environment>.<tenant_id>
     * @param account
     * @returns
     */ generateAccountKey(account) {
        const homeTenantId = account.homeAccountId.split(".")[1];
        const accountKey = [
            `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$ACCOUNT_SCHEMA_VERSION}`,
            account.homeAccountId,
            account.environment,
            homeTenantId || account.tenantId || ""
        ];
        return accountKey.join($9ed9a547f6786bdc$var$CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Reset all temporary cache items
     * @param correlationId
     */ resetRequestCache(correlationId) {
        this.logger.trace("0h0ynu", correlationId);
        this.removeTemporaryItem(this.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.NATIVE_REQUEST));
        this.setInteractionInProgress(false, undefined);
    }
    cacheAuthorizeRequest(authCodeRequest, correlationId, codeVerifier) {
        this.logger.trace("1tzef5", correlationId);
        const encodedValue = $9ed9a547f6786bdc$var$base64Encode(JSON.stringify(authCodeRequest));
        this.setTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = $9ed9a547f6786bdc$var$base64Encode(codeVerifier);
            this.setTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     * @param correlationId
     */ getCachedRequest(correlationId) {
        this.logger.trace("0uen20", correlationId);
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.REQUEST_PARAMS, correlationId, true);
        if (!encodedTokenRequest) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$noTokenRequestCacheError, "");
        const encodedVerifier = this.getTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.VERIFIER, correlationId, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse($9ed9a547f6786bdc$var$base64Decode(encodedTokenRequest));
            if (encodedVerifier) verifier = $9ed9a547f6786bdc$var$base64Decode(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`0ewsey ${encodedTokenRequest}`, correlationId);
            this.logger.error(`0tvdic ${e}`, correlationId);
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unableToParseTokenRequestCacheError, "");
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     * @param correlationId
     */ getCachedNativeRequest() {
        this.logger.trace("1yxcdm", "");
        const cachedRequest = this.getTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.NATIVE_REQUEST, "", true);
        if (!cachedRequest) {
            this.logger.trace("0mnxd4", "");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("0rrkip", "");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$TemporaryCacheKeys.INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, "", false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error("0jjyys", "");
            this.removeTemporaryItem(key);
            this.resetRequestCache("");
            $9ed9a547f6786bdc$var$clearHash(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNIN, allowOverride = false, correlationId = "") {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${$9ed9a547f6786bdc$var$PREFIX}.${$9ed9a547f6786bdc$var$TemporaryCacheKeys.INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            const existingInteraction = this.getInteractionInProgress();
            if (existingInteraction) {
                if (allowOverride) {
                    this.logger.warning(`1pmscr ${existingInteraction.clientId} ${existingInteraction.type}`, correlationId);
                    // Cancel any active bridge monitor from the previous interaction
                    $9ed9a547f6786bdc$var$cancelPendingBridgeResponse(this.logger, correlationId);
                    // Clear existing interaction to allow new one
                    this.removeTemporaryItem(key);
                } else throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$interactionInProgress, "");
            }
            // Set new interaction
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type: type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = $9ed9a547f6786bdc$var$createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.clientId, result.tenantId);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = $9ed9a547f6786bdc$var$createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? $9ed9a547f6786bdc$var$toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? $9ed9a547f6786bdc$var$toSecondsFromDate(result.extExpiresOn) : 0, $9ed9a547f6786bdc$var$base64Decode, request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid);
        if (request.resource) accessTokenEntity.resource = request.resource;
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId, $9ed9a547f6786bdc$var$isKmsi($9ed9a547f6786bdc$var$extractTokenClaims(result.idToken, $9ed9a547f6786bdc$var$base64Decode, result.correlationId)), $9ed9a547f6786bdc$var$ApiId.hydrateCache);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache);
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$CacheError && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function $9ed9a547f6786bdc$var$getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case $9ed9a547f6786bdc$var$BrowserCacheLocation.LocalStorage:
                return new $9ed9a547f6786bdc$var$LocalStorage(clientId, logger, performanceClient);
            case $9ed9a547f6786bdc$var$BrowserCacheLocation.SessionStorage:
                return new $9ed9a547f6786bdc$var$SessionStorage();
            case $9ed9a547f6786bdc$var$BrowserCacheLocation.MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e, "");
    }
    return new $9ed9a547f6786bdc$var$MemoryStorage();
}
const $9ed9a547f6786bdc$var$DEFAULT_BROWSER_CACHE_MANAGER = (clientId, logger, performanceClient, eventHandler, staticAuthorityOptions, tokenBindingKeyManager = $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER)=>{
    const cacheOptions = {
        cacheLocation: $9ed9a547f6786bdc$var$BrowserCacheLocation.MemoryStorage,
        cacheRetentionDays: 5
    };
    return new $9ed9a547f6786bdc$var$BrowserCacheManager(clientId, cacheOptions, $9ed9a547f6786bdc$var$DEFAULT_CRYPTO_IMPLEMENTATION, logger, performanceClient, eventHandler, staticAuthorityOptions, tokenBindingKeyManager);
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $9ed9a547f6786bdc$var$getAllAccounts(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("1yd030", correlationId);
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter, correlationId) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $9ed9a547f6786bdc$var$getAccount(accountFilter, logger, browserStorage, correlationId) {
    logger.trace("0u7b90", correlationId);
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("0btgll", correlationId);
        return account;
    } else {
        logger.verbose("0ltaj5", correlationId);
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $9ed9a547f6786bdc$var$setActiveAccount(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $9ed9a547f6786bdc$var$getActiveAccount(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class $9ed9a547f6786bdc$var$EventHandler {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new $9ed9a547f6786bdc$var$Logger({}, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel($9ed9a547f6786bdc$var$BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || $9ed9a547f6786bdc$var$createGuid();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`1578i0 ${id}`, "");
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`1cnec4 ${id}`, "");
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`12zotd ${callbackId}`, "");
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, correlationId, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            correlationId: correlationId,
            timestamp: Date.now()
        };
        switch(eventType){
            case $9ed9a547f6786bdc$var$EventType.LOGIN_SUCCESS:
            case $9ed9a547f6786bdc$var$EventType.LOGOUT_SUCCESS:
            case $9ed9a547f6786bdc$var$EventType.ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
        }
        // Emit event to callbacks registered in this instance
        this.invokeCallbacks(message);
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`15jpwk ${callbackId} ${message.eventType}`, "");
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$BaseInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId;
        this.logger = logger.clone($9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
        this.performanceClient = performanceClient;
        this.tokenBindingKeyManager = tokenBindingKeyManager || new $9ed9a547f6786bdc$var$TokenBindingKeyManager(this.logger, this.performanceClient);
    }
}
/**
 * Use to get the redirect URI configured in MSAL or construct one from the current page.
 * @param requestRedirectUri - Redirect URI from the request or undefined if not configured
 * @param clientConfigRedirectUri - Redirect URI from the client configuration or undefined if not configured
 * @param logger - Logger instance from the calling client
 * @param correlationId
 * @returns Absolute redirect URL constructed from the provided URI, config, or current page
 */ function $9ed9a547f6786bdc$var$getRedirectUri(requestRedirectUri, clientConfigRedirectUri, logger, correlationId) {
    logger.verbose("0bd1la", correlationId);
    const redirectUri = requestRedirectUri || clientConfigRedirectUri || "";
    return $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(redirectUri, $9ed9a547f6786bdc$var$getCurrentUri(), correlationId);
}
/**
 * Initializes and returns a ServerTelemetryManager with the provided telemetry configuration.
 * @param apiId - The API identifier for telemetry tracking
 * @param clientId - The client application identifier
 * @param correlationId - Unique identifier for correlating requests
 * @param browserStorage - Browser cache manager instance for storing telemetry data
 * @param logger - Optional logger instance for verbose logging
 * @param forceRefresh - Optional flag to force refresh of telemetry data
 * @param enabled - Optional flag to enable or disable server telemetry (default: true for custom_auth flows, false for standard flows)
 * @returns Configured ServerTelemetryManager instance
 */ function $9ed9a547f6786bdc$var$initializeServerTelemetryManager(apiId, clientId, correlationId, browserStorage, logger, forceRefresh, enabled = true) {
    logger.verbose("1p12tq", correlationId);
    if (!enabled) {
        logger.verbose("0tajnr", correlationId);
        return new $9ed9a547f6786bdc$var$StubServerTelemetryManager();
    }
    const telemetryPayload = {
        clientId: clientId,
        correlationId: correlationId,
        apiId: apiId,
        forceRefresh: false,
        wrapperSKU: browserStorage.getWrapperMetadata()[0],
        wrapperVer: browserStorage.getWrapperMetadata()[1]
    };
    return new $9ed9a547f6786bdc$var$ServerTelemetryManager(telemetryPayload, browserStorage);
}
/**
 * Used to get a discovered version of the default authority.
 * @param params - Configuration object containing authority and cloud options
 * @param params.requestAuthority - Optional specific authority URL to use
 * @param params.requestAzureCloudOptions - Optional Azure cloud configuration options
 * @param params.requestExtraQueryParameters - Optional additional query parameters
 * @param params.account - Optional account info for instance-aware scenarios
 * @param config - Browser configuration containing auth settings
 * @param correlationId - Unique identifier for correlating requests
 * @param performanceClient - Performance monitoring client instance
 * @param browserStorage - Browser cache manager instance
 * @param logger - Logger instance for tracking operations
 * @returns Promise that resolves to a discovered Authority instance
 */ async function $9ed9a547f6786bdc$var$getDiscoveredAuthority(config, correlationId, performanceClient, browserStorage, logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account) {
    const instanceAwareEQ = requestExtraQueryParameters && requestExtraQueryParameters.hasOwnProperty("instance_aware") ? requestExtraQueryParameters["instance_aware"] : undefined;
    const authorityOptions = {
        protocolMode: config.system.protocolMode,
        OIDCOptions: config.auth.OIDCOptions,
        knownAuthorities: config.auth.knownAuthorities,
        cloudDiscoveryMetadata: config.auth.cloudDiscoveryMetadata,
        authorityMetadata: config.auth.authorityMetadata
    };
    // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
    const resolvedAuthority = requestAuthority || config.auth.authority;
    const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : config.auth.instanceAware;
    const userAuthority = account && resolvedInstanceAware ? config.auth.authority.replace($9ed9a547f6786bdc$var$UrlString.getDomainFromUrl(resolvedAuthority, correlationId), account.environment) : resolvedAuthority;
    // fall back to the authority from config
    const builtAuthority = $9ed9a547f6786bdc$var$Authority.generateAuthority(userAuthority, requestAzureCloudOptions || config.auth.azureCloudOptions);
    const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$createDiscoveredInstance, $9ed9a547f6786bdc$var$AuthorityFactoryCreateDiscoveredInstance, logger, performanceClient, correlationId)(builtAuthority, config.system.networkClient, browserStorage, authorityOptions, logger, correlationId, performanceClient);
    if (account && !discoveredAuthority.isAlias(account.environment)) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$authorityMismatch, correlationId);
    return discoveredAuthority;
}
/**
 * Clears cache and account information during logout.
 *
 * If an account is provided, removes the account from cache and, if it is the active account, sets the active account to null.
 * If no account is provided, clears all accounts and tokens from cache.
 *
 * @param browserStorage - The browser cache manager instance used to manage cache.
 * @param browserCrypto - The crypto interface for cache operations.
 * @param logger - Logger instance for logging operations.
 * @param correlationId - Correlation ID for the logout operation.
 * @param account - (Optional) The account to clear from cache. If not provided, all accounts are cleared.
 * @returns A promise that resolves when the cache has been cleared.
 */ async function $9ed9a547f6786bdc$var$clearCacheOnLogout(browserStorage, browserCrypto, logger, correlationId, account) {
    if (account) // Clear given account.
    try {
        browserStorage.removeAccount(account, correlationId);
        logger.verbose("0s4z6h", correlationId);
    } catch (error) {
        logger.error("0mgg1d", correlationId);
    }
    else try {
        logger.verbose("0zj631", correlationId);
        // Clear all accounts and tokens
        browserStorage.clear(correlationId);
        // Clear any stray keys from IndexedDB
        await browserCrypto.clearKeystore(correlationId);
    } catch (e) {
        logger.error("12ih0c", correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$SUPPORTED_AUTHENTICATION_SCHEMES = new Set([
    $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER,
    $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP,
    $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP,
    $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH
]);
function $9ed9a547f6786bdc$var$validateSshRequest(request, correlationId) {
    if (!request.sshJwk) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$missingSshJwk, correlationId);
    if (!request.sshKid) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$missingSshKid, correlationId);
}
function $9ed9a547f6786bdc$var$validateDpopRequest(request, correlationId) {
    if (!request.resourceRequestMethod?.trim() || !request.resourceRequestUri?.trim()) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$dpopMissingResourceContext, correlationId);
}
/**
 * Resolves the token-binding parameters needed before building authorize or token requests.
 * Public PCA DPoP requests use a dpopJkt thumbprint, while platform broker PoP requests use
 * a reqCnf confirmation claim. Requests that do not require request-time token binding return
 * no additional parameters.
 */ async function $9ed9a547f6786bdc$var$getTokenBindingRequestParams(request, tokenBindingKeyManager, logger, performanceClient) {
    switch(request.authenticationScheme){
        case $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP:
            if (request.platformBroker) return {};
            if (request.dpopJkt) return {
                dpopJkt: request.dpopJkt
            };
            return {
                dpopJkt: await tokenBindingKeyManager.provisionTokenBindingKey({
                    tokenBindingKeyType: $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP.toLowerCase(),
                    tokenBindingKeyAlgorithm: $9ed9a547f6786bdc$var$JsonWebTokenAlgorithms.ES256,
                    correlationId: request.correlationId
                })
            };
        case $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP:
            if (!request.platformBroker) return {};
            const cryptoOps = new $9ed9a547f6786bdc$var$CryptoOps(logger, performanceClient);
            if (request.popKid) return {
                reqCnf: cryptoOps.encodeKid(request.popKid)
            };
            const popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(cryptoOps, tokenBindingKeyManager, performanceClient);
            const generatedReqCnfData = await $9ed9a547f6786bdc$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9ed9a547f6786bdc$var$PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
            return {
                reqCnf: generatedReqCnfData.reqCnfString
            };
        default:
            return {};
    }
}
/**
 * Initializer function for all request APIs
 * @param request
 * @param config
 * @param performanceClient
 * @param logger
 * @param correlationId
 */ async function $9ed9a547f6786bdc$var$initializeBaseRequest(request, config, performanceClient, logger, correlationId) {
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER;
        logger.verbose("1l4fwv", correlationId);
    } else {
        if (!$9ed9a547f6786bdc$var$SUPPORTED_AUTHENTICATION_SCHEMES.has(validatedRequest.authenticationScheme)) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$unsupportedAuthenticationScheme, correlationId);
        switch(validatedRequest.authenticationScheme){
            case $9ed9a547f6786bdc$var$AuthenticationScheme$1.SSH:
                $9ed9a547f6786bdc$var$validateSshRequest(request, correlationId);
                break;
            case $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP:
                $9ed9a547f6786bdc$var$validateDpopRequest(request, correlationId);
                break;
        }
        logger.verbose(`1ecmns ${validatedRequest.authenticationScheme}`, correlationId);
    }
    return validatedRequest;
}
async function $9ed9a547f6786bdc$var$initializeSilentRequest(request, account, config, performanceClient, logger) {
    const baseRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeBaseRequest, $9ed9a547f6786bdc$var$InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger, request.correlationId);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}
/**
 * Validates that the combination of request method, protocol mode and authorize body parameters is correct.
 * Returns the validated or defaulted HTTP method or throws if the configured combination is invalid.
 * @param interactionRequest
 * @param protocolMode
 * @returns
 */ function $9ed9a547f6786bdc$var$validateRequestMethod(interactionRequest, protocolMode) {
    let httpMethod;
    const requestMethod = interactionRequest.httpMethod;
    if (protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.EAR) {
        // Validate that method can only be POST when protocol mode is EAR
        if (requestMethod && requestMethod !== $9ed9a547f6786bdc$var$HttpMethod.POST) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidRequestMethodForEAR, "");
        else httpMethod = $9ed9a547f6786bdc$var$HttpMethod.POST;
    } else // For non-EAR protocol modes, default to GET if httpMethod is not set
    httpMethod = requestMethod || $9ed9a547f6786bdc$var$HttpMethod.GET;
    return httpMethod;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $9ed9a547f6786bdc$var$StandardInteractionClient extends $9ed9a547f6786bdc$var$BaseInteractionClient {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("0546u4", this.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId,
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from account loginHint or ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = logoutRequest.account.loginHint || this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("0d7s8p", this.correlationId);
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("0pdtc3", this.correlationId);
            } else this.logger.verbose("12k4l4", this.correlationId);
        } else this.logger.verbose("07ndze", this.correlationId);
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("1vamm6", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, $9ed9a547f6786bdc$var$getCurrentUri(), validLogoutRequest.correlationId);
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("15m5g7", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("1f4xlz", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, $9ed9a547f6786bdc$var$getCurrentUri(), validLogoutRequest.correlationId);
            } else {
                this.logger.verbose("17s5rf", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl($9ed9a547f6786bdc$var$getCurrentUri(), $9ed9a547f6786bdc$var$getCurrentUri(), validLogoutRequest.correlationId);
            }
        } else this.logger.verbose("0ljv63", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) {
                this.logger.verbose("0u5bmc", this.correlationId);
                return idTokenClaims.login_hint;
            } else this.logger.verbose("0mvp54", this.correlationId);
        } else this.logger.verbose("1e7bdp", this.correlationId);
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        // Create auth module.
        const clientConfig = await $9ed9a547f6786bdc$var$invokeAsync(this.getClientConfiguration.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new $9ed9a547f6786bdc$var$AuthorizationCodeClient(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        const discoveredAuthority = params.authority || await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account);
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri,
                isMcp: this.config.auth.isMcp
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cryptoInterface: this.browserCrypto,
            tokenBindingKeyManager: this.tokenBindingKeyManager,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: $9ed9a547f6786bdc$var$BrowserConstants.MSAL_SKU,
                version: $9ed9a547f6786bdc$var$version,
                cpu: "",
                os: ""
            },
            telemetry: this.config.telemetry
        };
    }
}
/**
 * Helper to initialize required request parameters for interactive APIs and ssoSilent().
 *
 * @param request - The authentication request object (RedirectRequest, PopupRequest, or SsoSilentRequest).
 * @param interactionType - The type of interaction (e.g., redirect, popup, silent).
 * @param config - The browser configuration object.
 * @param browserCrypto - The cryptographic interface for browser operations.
 * @param browserStorage - The browser storage manager instance.
 * @param logger - The logger instance for logging messages.
 * @param performanceClient - The performance client for telemetry.
 * @param correlationId - The correlation ID for the request.
 * @returns A promise that resolves to a CommonAuthorizationUrlRequest object with initialized parameters.
 */ async function $9ed9a547f6786bdc$var$initializeAuthorizationRequest(request, interactionType, config, browserCrypto, browserStorage, logger, performanceClient, correlationId) {
    const redirectUri = $9ed9a547f6786bdc$var$getRedirectUri(request.redirectUri, config.auth.redirectUri, logger, correlationId);
    if (new URL(redirectUri).origin !== new URL(window.location.href).origin) {
        logger.warning("08qbvw", correlationId);
        performanceClient.addFields({
            isRedirectUriCrossOrigin: true
        }, correlationId);
    }
    const browserState = {
        interactionType: interactionType
    };
    const state = $9ed9a547f6786bdc$var$setRequestState(browserCrypto, request && request.state || "", browserState, correlationId);
    const baseRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeBaseRequest, $9ed9a547f6786bdc$var$InitializeBaseRequest, logger, performanceClient, correlationId)({
        ...request,
        correlationId: correlationId
    }, config, performanceClient, logger, correlationId);
    const interactionRequest = {
        ...baseRequest,
        redirectUri: redirectUri,
        state: state,
        nonce: request.nonce || $9ed9a547f6786bdc$var$createNewGuid(),
        responseMode: config.auth.OIDCOptions.responseMode
    };
    const validatedRequest = {
        ...interactionRequest,
        httpMethod: $9ed9a547f6786bdc$var$validateRequestMethod(interactionRequest, config.system.protocolMode)
    };
    // Skip active account lookup if either login hint or session id is set
    if (request.loginHint || request.sid) return validatedRequest;
    const account = request.account || browserStorage.getActiveAccount(correlationId);
    if (account) {
        logger.verbose("1eqlb3", correlationId);
        logger.verbosePii(`0tf99t ${account.homeAccountId}`, correlationId);
        validatedRequest.account = account;
    }
    return validatedRequest;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * postMessage envelope type used to relay an auth response from a popup-relay
 * page (see `runPopupRelay`) back to the embedded frame that opened it. See
 * {@link BrowserAuthOptions.popupRelayUri}.
 *
 * Kept dependency-free so both the relay-page entry (`./index.js`) and the
 * client-side helpers (`./relayClient.js`) can import it without either bundle
 * pulling in the other's dependencies.
 *
 * @internal
 */ const $9ed9a547f6786bdc$var$POPUP_RELAY_RESPONSE_TYPE = "msal:popup-relay-response:v1";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Builds the URL of the popup-relay page to open. The action the relay page
 * must perform (GET navigation or POST form) is carried in the page's hash
 * (client-side only, never sent to a server), keyed by the per-request
 * library-state `id` so the relay page can listen on the right BroadcastChannel
 * and echo the id back. The relay URI is resolved against the app origin, so it
 * must be same-origin as the embedded frame. See `runPopupRelay`.
 *
 * @internal
 */ function $9ed9a547f6786bdc$var$buildPopupRelayUrl(popupRelayUri, id, action, correlationId) {
    const req = {
        id: id,
        ...action
    };
    const target = new URL(popupRelayUri, window.location.origin);
    /*
     * The relay page must be same-origin as the embedded frame: the response is
     * relayed back via postMessage and only accepted from this origin, and a
     * cross-origin page would also receive the relayed /authorize request. Fail
     * fast with a clear error instead of silently relaying to (and timing out
     * against) the wrong origin.
     */ if (target.origin !== window.location.origin) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$popupRelayUnsupportedFlow, correlationId, "popup_relay_cross_origin");
    const hashParams = new URLSearchParams();
    hashParams.set("req", JSON.stringify(req));
    target.hash = hashParams.toString();
    return target.toString();
}
/**
 * Waits for the popup-relay page to relay the raw auth response back to the
 * embedded frame via postMessage. Used in place of `waitForBridgeResponse`
 * when `auth.popupRelayUri` is configured, because third-party storage
 * partitioning blocks the BroadcastChannel the redirect bridge uses from
 * reaching the embedded frame.
 *
 * The response is accepted only from the popup window we opened, on our own
 * origin (the relay page is same-origin as the embedded frame), and only when
 * it carries the matching per-request library-state id.
 *
 * @internal
 */ async function $9ed9a547f6786bdc$var$waitForPopupRelayResponse(timeoutMs, logger, request, popupWindow, performanceClient) {
    return new Promise((resolve, reject)=>{
        const correlationId = request.correlationId;
        logger.verbose("1d05g9", correlationId);
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs
        }, correlationId);
        const { libraryState: libraryState } = $9ed9a547f6786bdc$var$parseRequestState($9ed9a547f6786bdc$var$base64Decode, request.state || "", correlationId);
        const expectedId = libraryState.id;
        const expectedOrigin = window.location.origin;
        let settled = false;
        const cleanup = ()=>{
            window.removeEventListener("message", onMessage);
            clearTimeout(timeoutId);
            clearInterval(closedPoll);
        };
        const onMessage = (event)=>{
            if (event.origin !== expectedOrigin || event.source !== popupWindow) return;
            const data = event.data;
            if (!data || data.type !== $9ed9a547f6786bdc$var$POPUP_RELAY_RESPONSE_TYPE || data.id !== expectedId) return;
            if (settled) return;
            settled = true;
            cleanup();
            if (data.error) reject($9ed9a547f6786bdc$var$createBrowserAuthError(data.error, correlationId));
            else if (data.payload) resolve(data.payload);
            else reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$redirectBridgeEmptyResponse, correlationId));
        };
        window.addEventListener("message", onMessage);
        const timeoutId = window.setTimeout(()=>{
            if (settled) return;
            settled = true;
            cleanup();
            reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$timedOut, correlationId, "popup_relay_timeout"));
        }, timeoutMs);
        const closedPoll = window.setInterval(()=>{
            if (popupWindow.closed && !settled) {
                settled = true;
                cleanup();
                reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$userCancelled, correlationId));
            }
        }, 500);
    });
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $9ed9a547f6786bdc$var$extractBrowserRequestState(browserCrypto, state, correlationId) {
    if (!state) return null;
    try {
        const requestStateObj = $9ed9a547f6786bdc$var$parseRequestState(browserCrypto.base64Decode, state, correlationId);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidState, correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$deserializeResponse(responseString, responseLocation, logger, correlationId) {
    // Deserialize hash fragment response parameters.
    const serverParams = $9ed9a547f6786bdc$var$getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!$9ed9a547f6786bdc$var$stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`18h0l1 ${responseLocation} ${responseLocation}`, correlationId);
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$hashEmptyError, correlationId);
        } else {
            logger.error(`13pl0s ${responseLocation} ${responseLocation}`, correlationId);
            logger.errorPii(`1097vx ${responseLocation} ${responseString}`, correlationId);
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$hashDoesNotContainKnownProperties, correlationId);
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $9ed9a547f6786bdc$var$validateInteractionType(response, browserCrypto, interactionType, correlationId) {
    if (!response.state) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$noStateInHash, correlationId);
    const platformStateObj = $9ed9a547f6786bdc$var$extractBrowserRequestState(browserCrypto, response.state, correlationId);
    if (!platformStateObj) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unableToParseState, correlationId);
    if (platformStateObj.interactionType !== interactionType) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$stateInteractionTypeMismatch, correlationId);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $9ed9a547f6786bdc$var$InteractionHandler {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request, apiId) {
        let authCodeResponse;
        try {
            authCodeResponse = $9ed9a547f6786bdc$var$getAuthorizationCodePayload(response, request.state, request.correlationId);
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$ServerError && e.subError === $9ed9a547f6786bdc$var$userCancelled) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$userCancelled, request.correlationId);
            else throw e;
        }
        return $9ed9a547f6786bdc$var$invokeAsync(this.handleCodeResponseFromServer.bind(this), $9ed9a547f6786bdc$var$HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request, apiId);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param request
     * @param validateNonce
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, apiId, validateNonce = true) {
        this.logger.trace("0mf2hb", request.correlationId);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await $9ed9a547f6786bdc$var$invokeAsync(this.authModule.acquireToken.bind(this.authModule), $9ed9a547f6786bdc$var$AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, apiId, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: $9ed9a547f6786bdc$var$CcsCredentialType.HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: $9ed9a547f6786bdc$var$CcsCredentialType.UPN
        };
        return null;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$contentError = "ContentError";
const $9ed9a547f6786bdc$var$pageException = "PageException";
const $9ed9a547f6786bdc$var$userSwitch = "user_switch";
const $9ed9a547f6786bdc$var$unsupportedMethod = "unsupported_method";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $9ed9a547f6786bdc$var$USER_INTERACTION_REQUIRED = "USER_INTERACTION_REQUIRED";
const $9ed9a547f6786bdc$var$USER_CANCEL = "USER_CANCEL";
const $9ed9a547f6786bdc$var$NO_NETWORK = "NO_NETWORK";
const $9ed9a547f6786bdc$var$DISABLED = "DISABLED";
const $9ed9a547f6786bdc$var$ACCOUNT_UNAVAILABLE = "ACCOUNT_UNAVAILABLE";
const $9ed9a547f6786bdc$var$UI_NOT_ALLOWED = "UI_NOT_ALLOWED";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$INVALID_METHOD_ERROR = -2147186943;
class $9ed9a547f6786bdc$var$NativeAuthError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, description, ext){
        super(errorCode, correlationId, description || $9ed9a547f6786bdc$var$getDefaultErrorMessage(errorCode));
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$NativeAuthError.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $9ed9a547f6786bdc$var$isFatalNativeAuthError(error) {
    if (error.ext && error.ext.status && error.ext.status === $9ed9a547f6786bdc$var$DISABLED) return true;
    if (error.ext && error.ext.error && error.ext.error === $9ed9a547f6786bdc$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case $9ed9a547f6786bdc$var$contentError:
        case $9ed9a547f6786bdc$var$pageException:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $9ed9a547f6786bdc$var$createNativeAuthError(code, correlationId, description, ext) {
    let error;
    if (ext && ext.status) {
        switch(ext.status){
            case $9ed9a547f6786bdc$var$ACCOUNT_UNAVAILABLE:
                error = $9ed9a547f6786bdc$var$createInteractionRequiredAuthError($9ed9a547f6786bdc$var$nativeAccountUnavailable, correlationId, $9ed9a547f6786bdc$var$getDefaultErrorMessage(code));
                break;
            case $9ed9a547f6786bdc$var$USER_INTERACTION_REQUIRED:
                error = new $9ed9a547f6786bdc$var$InteractionRequiredAuthError(code, correlationId, description);
                break;
            case $9ed9a547f6786bdc$var$USER_CANCEL:
                error = $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$userCancelled, correlationId);
                break;
            case $9ed9a547f6786bdc$var$NO_NETWORK:
                error = $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$noNetworkConnectivity, correlationId);
                break;
            case $9ed9a547f6786bdc$var$UI_NOT_ALLOWED:
                error = $9ed9a547f6786bdc$var$createInteractionRequiredAuthError($9ed9a547f6786bdc$var$uiNotAllowed, correlationId);
                break;
            default:
                error = new $9ed9a547f6786bdc$var$NativeAuthError(code, correlationId, description, ext);
        }
        return error;
    }
    error = new $9ed9a547f6786bdc$var$NativeAuthError(code, correlationId, description, ext);
    return error;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$SilentCacheClient extends $9ed9a547f6786bdc$var$StandardInteractionClient {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const clientConfig = await $9ed9a547f6786bdc$var$invokeAsync(this.getClientConfiguration.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new $9ed9a547f6786bdc$var$SilentFlowClient(clientConfig, this.performanceClient);
        this.logger.verbose("0wa871", this.correlationId);
        try {
            const response = await $9ed9a547f6786bdc$var$invokeAsync(silentAuthClient.acquireCachedToken.bind(silentAuthClient), $9ed9a547f6786bdc$var$SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof $9ed9a547f6786bdc$var$BrowserAuthError && error.errorCode === $9ed9a547f6786bdc$var$cryptoKeyNotFound) this.logger.verbose("06wena", this.correlationId);
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return $9ed9a547f6786bdc$var$clearCacheOnLogout(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$PlatformAuthInteractionClient extends $9ed9a547f6786bdc$var$BaseInteractionClient {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId, tokenBindingKeyManager){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider, tokenBindingKeyManager);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new $9ed9a547f6786bdc$var$SilentCacheClient(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider, this.tokenBindingKeyManager);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = $9ed9a547f6786bdc$var$ServerTelemetryManager.makeExtraSkuString({
            libraryName: $9ed9a547f6786bdc$var$BrowserConstants.MSAL_SKU,
            libraryVersion: $9ed9a547f6786bdc$var$version,
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [$9ed9a547f6786bdc$var$X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.logger.trace("03qeos", this.correlationId);
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$NativeInteractionClientAcquireToken, this.correlationId);
        const reqTimestamp = $9ed9a547f6786bdc$var$nowSeconds();
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        // initialize native request (statically builds the request; does not contact the broker)
        let nativeRequest;
        try {
            nativeRequest = await this.initializePlatformRequest(request);
        } catch (e) {
            /*
             * Request initialization (e.g. PoP token generation or authority
             * resolution) failed before the broker was contacted, so end the
             * measurement here to avoid an orphaned sub-measurement.
             * Broker was never engaged, so this was not a native broker outcome.
             */ nativeATMeasurement.add({
                isNativeBroker: false
            });
            nativeATMeasurement.end({
                success: false
            }, e);
            throw e;
        }
        // check if the tokens can be retrieved from internal cache
        try {
            const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
            // Served from the native internal cache; token did not come directly from the broker
            nativeATMeasurement.add({
                isNativeBroker: false
            });
            nativeATMeasurement.end({
                success: true,
                fromCache: true
            });
            return result;
        } catch (e) {
            if (cacheLookupPolicy === $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessToken) {
                this.logger.info("0eitbc", this.correlationId);
                nativeATMeasurement.add({
                    isNativeBroker: false
                });
                nativeATMeasurement.end({
                    success: false
                });
                throw e;
            }
            // continue with a native call for any and all errors
            this.logger.info("0957j1", this.correlationId);
        }
        // dispatch the request to the broker
        try {
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            const result = await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp, request.storeInCache);
            nativeATMeasurement.end({
                success: true,
                requestId: result.requestId
            });
            serverTelemetryManager.clearNativeBrokerErrorCode();
            return result;
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            nativeATMeasurement.end({
                success: false
            }, e);
            this.setBrokerErrorTelemetry(e);
            throw e;
        }
    }
    /**
     * Records platform-broker error telemetry on the root event for the current
     * correlationId. `isNativeBroker` is set optimistically to true because the
     * broker was engaged; when the caller subsequently falls back to a web flow
     * that succeeds, the root success measurement overrides it to false via
     * `result.fromPlatformBroker`. Terminal broker errors (no fallback) retain
     * true. `brokerErrorName`/`brokerErrorCode` are recorded when the error is an `AuthError`.
     * @param error error thrown by the broker interaction
     */ setBrokerErrorTelemetry(error) {
        if (error instanceof $9ed9a547f6786bdc$var$AuthError) this.performanceClient.addFields({
            isNativeBroker: true,
            brokerErrorName: error.name,
            brokerErrorCode: error.errorCode
        }, this.correlationId);
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        const silentRequest = {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: $9ed9a547f6786bdc$var$ScopeSet.fromString(request.scope, this.correlationId).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
        // Preserve FMI partition semantics for silent cache filtering.
        if (request.attributeTokens) silentRequest.attributeTokens = request.attributeTokens.split(" ");
        return silentRequest;
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("1ndf3e", this.correlationId);
            throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$noAccountFound, this.correlationId);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, this.correlationId);
        if (!account) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$noAccountFound, this.correlationId);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const idToken = this.browserStorage.getIdToken(account, this.correlationId, this.browserStorage.getTokenKeys(), account.tenantId);
            const idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(idToken?.secret || "", $9ed9a547f6786bdc$var$base64Decode, this.correlationId);
            const fullAccount = $9ed9a547f6786bdc$var$updateAccountTenantProfileData(account, undefined, idTokenClaims, idToken?.secret);
            return {
                ...result,
                idToken: idToken?.secret || "",
                idTokenClaims: idTokenClaims,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     * @param {HandleRedirectPromiseOptions} options
     */ async acquireTokenRedirect(request, rootMeasurement, options) {
        this.logger.trace("0luikq", this.correlationId);
        const nativeRequest = await this.initializePlatformRequest(request);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError) {
                const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ($9ed9a547f6786bdc$var$isFatalNativeAuthError(e)) {
                    /*
                     * Fatal error on redirect initiate always falls back to a
                     * regular web redirect, so this request did not complete
                     * natively. Token telemetry for the eventual outcome lands
                     * in handleRedirectPromise (phase 2).
                     */ this.setBrokerErrorTelemetry(e);
                    throw e;
                }
            }
        }
        this.browserStorage.setTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.NATIVE_REQUEST, JSON.stringify({
            ...nativeRequest,
            storeInCache: request.storeInCache
        }), true);
        const navigationOptions = {
            apiId: $9ed9a547f6786bdc$var$ApiId.acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = navigateToLoginRequestUrl ? $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(request.redirectStartPage || window.location.href, $9ed9a547f6786bdc$var$getCurrentUri(), this.correlationId) : $9ed9a547f6786bdc$var$getRedirectUri(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise() {
        this.logger.trace("1c5lhw", this.correlationId);
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", this.correlationId);
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("0a6zjb", this.correlationId);
            this.performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, this.correlationId);
            return null;
        }
        /*
         * storeInCache is a client-side cache directive persisted alongside the cached
         * request (not a broker-contract parameter), so extract it here before resending.
         */ const { prompt: prompt, storeInCache: storeInCache, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("0ac34v", this.correlationId);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.NATIVE_REQUEST));
        const reqTimestamp = $9ed9a547f6786bdc$var$nowSeconds();
        try {
            this.logger.verbose("003x5a", this.correlationId);
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await this.handleNativeResponse(response, request, reqTimestamp, storeInCache);
            const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            return authResult;
        } catch (e) {
            this.setBrokerErrorTelemetry(e);
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("0u2sjm", this.correlationId);
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp, storeInCache) {
        this.logger.trace("1bojln", this.correlationId);
        // generate identifiers
        const idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(response.id_token, $9ed9a547f6786bdc$var$base64Decode, this.correlationId);
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("1ub1in", this.correlationId);
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw $9ed9a547f6786bdc$var$createNativeAuthError($9ed9a547f6786bdc$var$userSwitch, this.correlationId);
        // Get the preferred_cache domain for the given authority
        const authority = await $9ed9a547f6786bdc$var$getDiscoveredAuthority(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, request.authority);
        const baseAccount = $9ed9a547f6786bdc$var$buildAccountToCache(this.browserStorage, authority, homeAccountIdentifier, $9ed9a547f6786bdc$var$base64Decode, this.correlationId, idTokenClaims, response.client_info, authority.getPreferredCache(), idTokenClaims.tid, undefined, response.account.id, this.logger, this.performanceClient);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await this.cacheAccount(baseAccount, $9ed9a547f6786bdc$var$isKmsi(idTokenClaims));
        await this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, result.tenantId, reqTimestamp, authority.getPreferredCache(), storeInCache);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = $9ed9a547f6786bdc$var$generateHomeAccountId(response.client_info || "", $9ed9a547f6786bdc$var$AuthorityType.Default, this.logger, this.browserCrypto, this.correlationId, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? $9ed9a547f6786bdc$var$ScopeSet.fromString(responseScopes, this.correlationId) : $9ed9a547f6786bdc$var$ScopeSet.fromString(requestScopes, this.correlationId);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("0coqhu", this.correlationId);
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(this.browserCrypto, this.tokenBindingKeyManager, this.performanceClient);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$keyIdMissing, this.correlationId);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || "";
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || "";
        const accountInfo = $9ed9a547f6786bdc$var$updateAccountTenantProfileData($9ed9a547f6786bdc$var$getAccountInfo(accountEntity), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) {
            accountInfo.nativeAccountId = response.account.id;
            // Also update the matching tenant profile (source of truth)
            const targetTenantId = tid || accountInfo.tenantId;
            const tenantProfile = accountInfo.tenantProfiles?.get(targetTenantId);
            if (tenantProfile) tenantProfile.nativeAccountId = response.account.id;
        }
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP ? $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP : $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: $9ed9a547f6786bdc$var$toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromPlatformBroker: true,
            ...request.extraParameters?.resource && {
                resource: request.extraParameters.resource
            }
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity, kmsi) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId, kmsi, this.apiId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext($9ed9a547f6786bdc$var$getAccountInfo(accountEntity), this.correlationId);
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ async cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, tenantId, reqTimestamp, environment, storeInCache) {
        const cachedIdToken = $9ed9a547f6786bdc$var$createIdTokenEntity(homeAccountIdentifier, environment, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP ? $9ed9a547f6786bdc$var$SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const additionalCacheKeyComponents = request.attributeTokens ? {
            attribute_tokens: request.attributeTokens
        } : undefined;
        const cachedAccessToken = $9ed9a547f6786bdc$var$createAccessTokenEntity(homeAccountIdentifier, environment, response.access_token, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, $9ed9a547f6786bdc$var$base64Decode, request.correlationId, undefined, request.tokenType, undefined, request.keyId, additionalCacheKeyComponents);
        // save idtoken credential in configured browser storage
        if (!!cachedIdToken && storeInCache?.idToken !== false) await this.browserStorage.setIdTokenCredential(cachedIdToken, this.correlationId, $9ed9a547f6786bdc$var$isKmsi(idTokenClaims));
        // save access token credential in memory storage
        const nativeCacheRecord = {
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, $9ed9a547f6786bdc$var$isKmsi(idTokenClaims), this.apiId, storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP ? $9ed9a547f6786bdc$var$SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("0b3l57", this.correlationId);
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("1okqev", this.correlationId);
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializePlatformRequest(request) {
        this.logger.trace("1xdm2a", this.correlationId);
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && !!request.embeddedClientId ? undefined : this.config.auth.clientCapabilities;
        /*
         * scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
         * attributeTokens is destructured out because PlatformAuthRequest represents it as a pre-serialized string, not the caller-provided Array<string>.
         */ const { scopes: scopes, claims: claims } = request;
        const scopeSet = new $9ed9a547f6786bdc$var$ScopeSet(scopes || [], this.correlationId);
        scopeSet.appendScopes($9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1);
        const mergedClaims = $9ed9a547f6786bdc$var$buildMergedClaims$1(claims, configClaims?.length ? configClaims : undefined);
        const hasAttributeTokens = !!request.attributeTokens?.length;
        this.performanceClient?.addFields({
            hasAttributeTokens: hasAttributeTokens
        }, this.correlationId);
        const validatedRequest = {
            claims: mergedClaims,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: $9ed9a547f6786bdc$var$getRedirectUri(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            isSts: false,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            nonce: request.nonce,
            state: request.state,
            loginHint: request.loginHint,
            extraParameters: {
                ...request.extraParameters,
                ...request.resource && {
                    resource: request.resource
                }
            },
            extendedExpiryToken: false,
            keyId: request.popKid,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            shrNonce: request.shrNonce
        };
        if (hasAttributeTokens) validatedRequest.attributeTokens = $9ed9a547f6786bdc$var$serializeAttributeTokens(request.attributeTokens);
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$invalidPopTokenRequest, this.correlationId);
        this.handleExtraBrokerParams(validatedRequest, request.embeddedClientId);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = $9ed9a547f6786bdc$var$PlatformAuthConstants.MATS_TELEMETRY;
        if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            const popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(this.browserCrypto, this.tokenBindingKeyManager, this.performanceClient);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await $9ed9a547f6786bdc$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9ed9a547f6786bdc$var$PopTokenGenerateCnf, this.logger, this.performanceClient, this.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        const { azureCloudOptions: azureCloudOptions, account: account } = request;
        if (account) // validate authority
        await $9ed9a547f6786bdc$var$getDiscoveredAuthority(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, azureCloudOptions, undefined, account);
        const canonicalAuthority = new $9ed9a547f6786bdc$var$UrlString(requestAuthority, this.correlationId);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case $9ed9a547f6786bdc$var$ApiId.ssoSilent:
            case $9ed9a547f6786bdc$var$ApiId.acquireTokenSilent_silentFlow:
                this.logger.trace("12n1y2", this.correlationId);
                return $9ed9a547f6786bdc$var$PromptValue$1.NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("0uid1p", this.correlationId);
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case $9ed9a547f6786bdc$var$PromptValue$1.NONE:
            case $9ed9a547f6786bdc$var$PromptValue$1.CONSENT:
            case $9ed9a547f6786bdc$var$PromptValue$1.LOGIN:
                this.logger.trace("0i0hco", this.correlationId);
                return prompt;
            default:
                this.logger.trace(`0w3tpw ${prompt}`, this.correlationId);
                throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nativePromptNotSupported, this.correlationId);
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request, embeddedClientId) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty($9ed9a547f6786bdc$var$BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty($9ed9a547f6786bdc$var$BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty($9ed9a547f6786bdc$var$CLIENT_ID);
        if (!embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[$9ed9a547f6786bdc$var$BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[$9ed9a547f6786bdc$var$CLIENT_ID];
        }
        const { // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [$9ed9a547f6786bdc$var$BROKER_CLIENT_ID]: _brkClientId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [$9ed9a547f6786bdc$var$BROKER_REDIRECT_URI]: _brkRedirectUri, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [$9ed9a547f6786bdc$var$CLIENT_ID]: _clientId, ...remainingExtraParameters } = request.extraParameters || {};
        request.extraParameters = {
            ...remainingExtraParameters,
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, this.correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$clientDataAccountTypeMapping = new Map([
    [
        "e",
        "AAD"
    ],
    [
        "m",
        "MSA"
    ]
]);
/**
 * Parses the clientdata response parameter from the /authorize endpoint.
 *
 * Logically, the clientdata value is URL-encoded and pipe-delimited:
 *   urlencoded(account_type | error | sub_error | cloud_instance | caller_data_boundary)
 *
 * In normal browser flows, this value may already have been URL-decoded
 * (e.g. by URLSearchParams). This function will only apply decodeURIComponent
 * when the string appears to contain percent-encoded sequences to avoid
 * double-decoding.
 *
 * @param clientdata - The raw clientdata string from the authorize response
 * @returns Parsed ClientData object, or null if the input is empty/invalid
 */ function $9ed9a547f6786bdc$var$parseClientData(clientdata) {
    if (!clientdata) return null;
    try {
        // Only decode when the string appears to contain percent-encoded sequences
        const shouldDecode = /%(?:[0-9A-Fa-f]{2})/.test(clientdata);
        const decoded = shouldDecode ? decodeURIComponent(clientdata) : clientdata;
        const parts = decoded.split("|");
        if (parts.length < 5) return null;
        return {
            accountType: $9ed9a547f6786bdc$var$clientDataAccountTypeMapping.get(parts[0]?.trim() || "") || "",
            error: parts[1]?.trim() || "",
            subError: parts[2]?.trim() || "",
            cloudInstance: parts[3]?.trim() || "",
            callerDataBoundary: parts[4]?.trim() || ""
        };
    } catch  {
        return null;
    }
}
/**
 * Instruments account type, error, and suberror from clientdata
 */ function $9ed9a547f6786bdc$var$instrumentClientData(response, correlationId, performanceClient) {
    const parsed = $9ed9a547f6786bdc$var$parseClientData(response.clientdata);
    parsed?.accountType && performanceClient.addFields({
        accountType: parsed.accountType
    }, correlationId);
    parsed?.error && performanceClient.addFields({
        serverErrorNo: parsed.error
    }, correlationId);
    parsed?.subError && performanceClient.addFields({
        serverSubErrorNo: parsed.subError
    }, correlationId);
}
/**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $9ed9a547f6786bdc$var$getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = $9ed9a547f6786bdc$var$getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, request, logger, performanceClient);
    $9ed9a547f6786bdc$var$addLibraryInfo(parameters, {
        sku: $9ed9a547f6786bdc$var$BrowserConstants.MSAL_SKU,
        version: $9ed9a547f6786bdc$var$version,
        os: "",
        cpu: ""
    });
    if (config.system.protocolMode !== $9ed9a547f6786bdc$var$ProtocolMode.OIDC) $9ed9a547f6786bdc$var$addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        $9ed9a547f6786bdc$var$addNativeBroker(parameters);
        // instrument JS-platform bridge specific fields
        performanceClient.addFields({
            isPlatformAuthorizeRequest: true
        }, request.correlationId);
        // pass the req_cnf for POP
        if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP && request.reqCnf) $9ed9a547f6786bdc$var$addPopToken(parameters, request.reqCnf);
    }
    if (request.authenticationScheme === $9ed9a547f6786bdc$var$AuthenticationScheme$1.DPOP && request.dpopJkt) parameters.set($9ed9a547f6786bdc$var$DPOP_JKT, request.dpopJkt);
    $9ed9a547f6786bdc$var$instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $9ed9a547f6786bdc$var$getAuthCodeRequestUrl(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$pkceParamsMissing, request.correlationId);
    const parameters = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getStandardParameters, $9ed9a547f6786bdc$var$GetStandardParams, logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    $9ed9a547f6786bdc$var$addResponseType(parameters, $9ed9a547f6786bdc$var$OAuthResponseType.CODE);
    $9ed9a547f6786bdc$var$addCodeChallengeParams(parameters, request.codeChallenge, $9ed9a547f6786bdc$var$S256_CODE_CHALLENGE_METHOD);
    // Merge extraQueryParameters and extraParameters to be appended to request URL
    $9ed9a547f6786bdc$var$addExtraParameters(parameters, {
        ...request.extraQueryParameters,
        ...request.extraParameters
    });
    return $9ed9a547f6786bdc$var$getAuthorizeUrl(authority, parameters);
}
/**
 * Builds the action URL + POST-body fields for the EAR /authorize form.
 */ async function $9ed9a547f6786bdc$var$getEARFormData(config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$earJwkEmpty, request.correlationId);
    const parameters = await $9ed9a547f6786bdc$var$getStandardParameters(config, authority, request, logger, performanceClient);
    $9ed9a547f6786bdc$var$addResponseType(parameters, $9ed9a547f6786bdc$var$OAuthResponseType.IDTOKEN_TOKEN_REFRESHTOKEN);
    $9ed9a547f6786bdc$var$addEARParameters(parameters, request.earJwk);
    // Also add codeChallenge as backup in case EAR is not supported
    $9ed9a547f6786bdc$var$addCodeChallengeParams(parameters, request.codeChallenge, $9ed9a547f6786bdc$var$S256_CODE_CHALLENGE_METHOD);
    $9ed9a547f6786bdc$var$addExtraParameters(parameters, {
        ...request.extraParameters
    });
    const queryParams = new Map();
    $9ed9a547f6786bdc$var$addExtraParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    $9ed9a547f6786bdc$var$addCorrelationId(queryParams, request.correlationId);
    const action = $9ed9a547f6786bdc$var$getAuthorizeUrl(authority, queryParams);
    return {
        action: action,
        fields: Object.fromEntries(parameters)
    };
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function $9ed9a547f6786bdc$var$getEARForm(frame, config, authority, request, logger, performanceClient) {
    const { action: action, fields: fields } = await $9ed9a547f6786bdc$var$getEARFormData(config, authority, request, logger, performanceClient);
    return $9ed9a547f6786bdc$var$createForm(frame, action, fields);
}
/**
 * Builds the action URL + POST-body fields for the auth-code /authorize form.
 */ async function $9ed9a547f6786bdc$var$getCodeFormData(config, authority, request, logger, performanceClient) {
    const parameters = await $9ed9a547f6786bdc$var$getStandardParameters(config, authority, request, logger, performanceClient);
    $9ed9a547f6786bdc$var$addResponseType(parameters, $9ed9a547f6786bdc$var$OAuthResponseType.CODE);
    $9ed9a547f6786bdc$var$addCodeChallengeParams(parameters, request.codeChallenge, request.codeChallengeMethod || $9ed9a547f6786bdc$var$S256_CODE_CHALLENGE_METHOD);
    // Add extraParameters to the request body
    $9ed9a547f6786bdc$var$addExtraParameters(parameters, {
        ...request.extraParameters
    });
    // Add extraQueryParameters to be appended to request URL
    const queryParams = new Map();
    $9ed9a547f6786bdc$var$addExtraParameters(queryParams, request.extraQueryParameters || {});
    // Add correlationId to query params so gateway can propagate it to IDPs
    $9ed9a547f6786bdc$var$addCorrelationId(queryParams, request.correlationId);
    const action = $9ed9a547f6786bdc$var$getAuthorizeUrl(authority, queryParams);
    return {
        action: action,
        fields: Object.fromEntries(parameters)
    };
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using POST method
 */ async function $9ed9a547f6786bdc$var$getCodeForm(frame, config, authority, request, logger, performanceClient) {
    const { action: action, fields: fields } = await $9ed9a547f6786bdc$var$getCodeFormData(config, authority, request, logger, performanceClient);
    return $9ed9a547f6786bdc$var$createForm(frame, action, fields);
}
/**
 * Creates a POST `<form>` in the provided document with the given auth
 * parameters as hidden inputs, targeting `action`. Shared by the popup auth
 * flows (`getEARForm` / `getCodeForm`) and the popup-relay page
 * (`runPopupRelay`) so the form is built one way only.
 *
 * @param frame - document to create the form in
 * @param action - form action (the /authorize URL)
 * @param fields - POST-body fields
 * @internal
 */ function $9ed9a547f6786bdc$var$createForm(frame, action, fields) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = action;
    Object.keys(fields).forEach((name)=>{
        const input = frame.createElement("input");
        input.hidden = true;
        input.name = name;
        input.value = fields[name];
        form.appendChild(input);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $9ed9a547f6786bdc$var$handleResponsePlatformBroker(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("11qcow", request.correlationId);
    if (!platformAuthProvider) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nativeConnectionNotEstablished, request.correlationId);
    const browserCrypto = new $9ed9a547f6786bdc$var$CryptoOps(logger, performanceClient);
    const nativeInteractionClient = new $9ed9a547f6786bdc$var$PlatformAuthInteractionClient(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState: userRequestState } = $9ed9a547f6786bdc$var$parseRequestState(browserCrypto.base64Decode, request.state, request.correlationId);
    return $9ed9a547f6786bdc$var$invokeAsync(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), $9ed9a547f6786bdc$var$NativeInteractionClientAcquireToken, logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $9ed9a547f6786bdc$var$handleResponseCode(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    $9ed9a547f6786bdc$var$ThrottlingUtils.removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $9ed9a547f6786bdc$var$instrumentClientData(response, request.correlationId, performanceClient);
    if (response.accountId) return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponsePlatformBroker, $9ed9a547f6786bdc$var$HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new $9ed9a547f6786bdc$var$InteractionHandler(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await $9ed9a547f6786bdc$var$invokeAsync(interactionHandler.handleCodeResponse.bind(interactionHandler), $9ed9a547f6786bdc$var$HandleCodeResponse, logger, performanceClient, request.correlationId)(response, request, apiId);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $9ed9a547f6786bdc$var$handleResponseEAR(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    $9ed9a547f6786bdc$var$ThrottlingUtils.removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $9ed9a547f6786bdc$var$instrumentClientData(response, request.correlationId, performanceClient);
    // Validate state & check response for errors
    $9ed9a547f6786bdc$var$validateAuthorizationResponse(response, request.state, request.correlationId);
    if (!response.ear_jwe) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$earJweEmpty, request.correlationId);
    if (!request.earJwk) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$earJwkEmpty, request.correlationId);
    const decryptedData = JSON.parse(await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$decryptEarResponse, $9ed9a547f6786bdc$var$DecryptEarResponse, logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponsePlatformBroker, $9ed9a547f6786bdc$var$HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new $9ed9a547f6786bdc$var$ResponseHandler(config.auth.clientId, browserStorage, new $9ed9a547f6786bdc$var$CryptoOps(logger, performanceClient), logger, performanceClient, null, null, new $9ed9a547f6786bdc$var$TokenBindingKeyManager(logger, performanceClient));
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData, request.correlationId);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await $9ed9a547f6786bdc$var$invokeAsync(responseHandler.handleServerTokenResponse.bind(responseHandler), $9ed9a547f6786bdc$var$HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, $9ed9a547f6786bdc$var$nowSeconds(), request, apiId, additionalData, undefined, undefined, undefined, undefined);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $9ed9a547f6786bdc$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $9ed9a547f6786bdc$var$generatePkceCodes(performanceClient, logger, correlationId) {
    const codeVerifier = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$generateCodeVerifier, $9ed9a547f6786bdc$var$GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateCodeChallengeFromVerifier, $9ed9a547f6786bdc$var$GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $9ed9a547f6786bdc$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($9ed9a547f6786bdc$var$RANDOM_BYTE_ARR_LENGTH);
        $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$getRandomValues, $9ed9a547f6786bdc$var$GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = $9ed9a547f6786bdc$var$urlEncodeArr(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$pkceNotCreated, correlationId);
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $9ed9a547f6786bdc$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$sha256Digest, $9ed9a547f6786bdc$var$Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier);
        // encode hash as base64
        return $9ed9a547f6786bdc$var$urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$pkceNotCreated, correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$NavigationClient {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $9ed9a547f6786bdc$var$NavigationClient.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $9ed9a547f6786bdc$var$NavigationClient.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$timedOut, "", "failed_to_redirect"));
            }, options.timeout);
        });
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$MAX_FETCH_POST_RETRIES = 1;
const $9ed9a547f6786bdc$var$RETRY_DELAY_MS = 100;
/**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $9ed9a547f6786bdc$var$FetchClient {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $9ed9a547f6786bdc$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: $9ed9a547f6786bdc$var$HTTP_REQUEST_TYPE.GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw $9ed9a547f6786bdc$var$createNetworkError($9ed9a547f6786bdc$var$createBrowserAuthError(window.navigator.onLine ? $9ed9a547f6786bdc$var$getRequestFailed : $9ed9a547f6786bdc$var$noNetworkConnectivity, ""), undefined, undefined, e);
        }
        responseHeaders = $9ed9a547f6786bdc$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw $9ed9a547f6786bdc$var$createNetworkError($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToParseResponse, ""), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $9ed9a547f6786bdc$var$getFetchHeaders(options);
        const correlationId = options?.correlationId;
        const performanceClient = options?.performanceClient;
        let response;
        let lastError;
        for(let attempt = 1; attempt <= $9ed9a547f6786bdc$var$MAX_FETCH_POST_RETRIES + 1; attempt++)try {
            response = await fetch(url, {
                method: $9ed9a547f6786bdc$var$HTTP_REQUEST_TYPE.POST,
                headers: reqHeaders,
                body: reqBody
            });
            break;
        } catch (e) {
            lastError = e;
            if (!$9ed9a547f6786bdc$var$shouldRetryPostFetchError(lastError, attempt)) throw $9ed9a547f6786bdc$var$createNetworkError($9ed9a547f6786bdc$var$createBrowserAuthError(window.navigator.onLine !== false ? $9ed9a547f6786bdc$var$postRequestFailed : $9ed9a547f6786bdc$var$noNetworkConnectivity, correlationId || ""), undefined, undefined, lastError);
            // Brief backoff before retry
            await new Promise((resolve)=>setTimeout(resolve, $9ed9a547f6786bdc$var$RETRY_DELAY_MS));
            if (correlationId) performanceClient?.incrementFields({
                fetchRetryCount: 1
            }, correlationId);
        }
        if (!response) throw $9ed9a547f6786bdc$var$createNetworkError($9ed9a547f6786bdc$var$createBrowserAuthError(window.navigator.onLine !== false ? $9ed9a547f6786bdc$var$postRequestFailed : $9ed9a547f6786bdc$var$noNetworkConnectivity, correlationId || ""), undefined, undefined, lastError);
        let responseStatus = 0;
        let responseHeaders = {};
        responseHeaders = $9ed9a547f6786bdc$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw $9ed9a547f6786bdc$var$createNetworkError($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToParseResponse, correlationId || ""), responseStatus, responseHeaders, e);
        }
    }
}
function $9ed9a547f6786bdc$var$shouldRetryPostFetchError(error, attempt) {
    return attempt <= $9ed9a547f6786bdc$var$MAX_FETCH_POST_RETRIES && window.navigator.onLine !== false && error.name !== "AbortError";
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $9ed9a547f6786bdc$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createNetworkError($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToBuildHeaders, ""), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $9ed9a547f6786bdc$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$failedToParseHeaders, "");
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $9ed9a547f6786bdc$var$DEFAULT_POPUP_TIMEOUT_MS = 60000;
const $9ed9a547f6786bdc$var$DEFAULT_IFRAME_TIMEOUT_MS = 10000;
const $9ed9a547f6786bdc$var$DEFAULT_REDIRECT_TIMEOUT_MS = 30000;
const $9ed9a547f6786bdc$var$DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $9ed9a547f6786bdc$var$buildConfiguration({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, experimental: userInputExperimental, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: "",
        authority: `${$9ed9a547f6786bdc$var$DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: "",
        authorityMetadata: "",
        redirectUri: typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "",
        postLogoutRedirectUri: "",
        popupRelayUri: "",
        clientCapabilities: [],
        OIDCOptions: {
            responseMode: $9ed9a547f6786bdc$var$ResponseMode$1.FRAGMENT,
            defaultScopes: [
                $9ed9a547f6786bdc$var$OPENID_SCOPE,
                $9ed9a547f6786bdc$var$PROFILE_SCOPE,
                $9ed9a547f6786bdc$var$OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: $9ed9a547f6786bdc$var$AzureCloudInstance.None,
            tenant: ""
        },
        instanceAware: false,
        isMcp: false,
        verifySSO: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: $9ed9a547f6786bdc$var$BrowserCacheLocation.SessionStorage,
        cacheRetentionDays: 5
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: $9ed9a547f6786bdc$export$243e62d78d3b544d.Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...$9ed9a547f6786bdc$var$DEFAULT_SYSTEM_OPTIONS,
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new $9ed9a547f6786bdc$var$FetchClient() : $9ed9a547f6786bdc$var$StubbedNetworkModule,
        navigationClient: new $9ed9a547f6786bdc$var$NavigationClient(),
        popupBridgeTimeout: userInputSystem?.popupBridgeTimeout || $9ed9a547f6786bdc$var$DEFAULT_POPUP_TIMEOUT_MS,
        iframeBridgeTimeout: userInputSystem?.iframeBridgeTimeout || $9ed9a547f6786bdc$var$DEFAULT_IFRAME_TIMEOUT_MS,
        redirectNavigationTimeout: $9ed9a547f6786bdc$var$DEFAULT_REDIRECT_TIMEOUT_MS,
        allowRedirectInIframe: false,
        navigatePopups: true,
        allowPlatformBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $9ed9a547f6786bdc$var$DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS,
        protocolMode: $9ed9a547f6786bdc$var$ProtocolMode.AAD,
        serverTelemetryEnabled: false
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: "",
            appVersion: ""
        },
        client: new $9ed9a547f6786bdc$var$StubPerformanceClient()
    };
    const DEFAULT_EXPERIMENTAL_OPTIONS = {
        iframeTimeoutTelemetry: false,
        allowPlatformBrokerWithDOM: false
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputSystem?.protocolMode !== $9ed9a547f6786bdc$var$ProtocolMode.OIDC && userInputAuth?.OIDCOptions) {
        const logger = new $9ed9a547f6786bdc$var$Logger(providedSystemOptions.loggerOptions, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
        logger.warning(JSON.stringify($9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$cannotSetOIDCOptions, "")), "");
    }
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputSystem?.protocolMode && userInputSystem.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.OIDC && providedSystemOptions?.allowPlatformBroker) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$cannotAllowPlatformBroker, "");
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        experimental: {
            ...DEFAULT_EXPERIMENTAL_OPTIONS,
            ...userInputExperimental
        },
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$PlatformAuthExtensionHandler {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$NativeMessageHandlerHandshake);
        this.platformAuthType = $9ed9a547f6786bdc$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        this.logger.trace(`0on4p2 ${this.platformAuthType}`, request.correlationId);
        // fall back to native calls
        const messageBody = {
            method: $9ed9a547f6786bdc$var$NativeExtensionMethod.GetToken,
            request: request
        };
        const req = {
            channel: $9ed9a547f6786bdc$var$PlatformAuthConstants.CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: $9ed9a547f6786bdc$var$createNewGuid(),
            body: messageBody
        };
        this.logger.trace(`1qadfi ${this.platformAuthType}`, request.correlationId);
        this.logger.tracePii(`1xm533 ${this.platformAuthType} ${JSON.stringify(req)}`, request.correlationId);
        this.messageChannel.port1.postMessage(req);
        const response = await new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
        const validatedResponse = this.validatePlatformBrokerResponse(response);
        return validatedResponse;
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient, correlationId) {
        logger.trace("15zfnw", correlationId);
        try {
            const preferredProvider = new $9ed9a547f6786bdc$var$PlatformAuthExtensionHandler(logger, handshakeTimeoutMs, performanceClient, $9ed9a547f6786bdc$var$PlatformAuthConstants.PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest(correlationId);
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $9ed9a547f6786bdc$var$PlatformAuthExtensionHandler(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest(correlationId);
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest(correlationId) {
        this.logger.trace(`1dpg9o ${this.platformAuthType}`, correlationId);
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: $9ed9a547f6786bdc$var$PlatformAuthConstants.CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: $9ed9a547f6786bdc$var$createNewGuid(),
            body: {
                method: $9ed9a547f6786bdc$var$NativeExtensionMethod.HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nativeHandshakeTimeout, ""));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        const correlationId = $9ed9a547f6786bdc$var$createGuid();
        this.logger.trace(`0jpn5u ${this.platformAuthType}`, correlationId);
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== $9ed9a547f6786bdc$var$PlatformAuthConstants.CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === $9ed9a547f6786bdc$var$NativeExtensionMethod.HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`07buhm ${this.platformAuthType} ${request.responseId}`, correlationId);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `0xrkug ${request.extensionId}` : "No extension installed", correlationId);
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nativeExtensionNotInstalled, ""));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        const correlationId = $9ed9a547f6786bdc$var$createGuid();
        this.logger.trace(`1py8yf ${this.platformAuthType}`, correlationId);
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === $9ed9a547f6786bdc$var$NativeExtensionMethod.Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace(`19hpgm ${this.platformAuthType}`, correlationId);
                this.logger.tracePii(`179a24 ${this.platformAuthType} ${JSON.stringify(response)}`, correlationId);
                if (response.status !== "Success") resolver.reject($9ed9a547f6786bdc$var$createNativeAuthError(response.code, correlationId, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject($9ed9a547f6786bdc$var$createNativeAuthError(response.result["code"], correlationId, response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw $9ed9a547f6786bdc$var$createAuthError($9ed9a547f6786bdc$var$unexpectedError, correlationId, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === $9ed9a547f6786bdc$var$NativeExtensionMethod.HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`082qnt ${this.platformAuthType} ${request.responseId}`, correlationId);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(`0yf5ib ${this.platformAuthType} ${this.extensionId}`, correlationId);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("0xf978", correlationId);
            this.logger.errorPii(`04i99o ${err}`, correlationId);
            this.logger.errorPii(`0xdvsy ${event}`, correlationId);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw $9ed9a547f6786bdc$var$createAuthError($9ed9a547f6786bdc$var$unexpectedError, "", "Response missing expected properties.");
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === $9ed9a547f6786bdc$var$PlatformAuthConstants.PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$PlatformAuthDOMHandler {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = $9ed9a547f6786bdc$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("12mj4a", correlationId);
        // @ts-ignore
        if (window.navigator?.platformAuthentication) {
            const supportedContracts = // @ts-ignore
            await window.navigator.platformAuthentication.getSupportedContracts($9ed9a547f6786bdc$var$PlatformAuthConstants.MICROSOFT_ENTRA_BROKERID);
            if (supportedContracts?.includes($9ed9a547f6786bdc$var$PlatformAuthConstants.PLATFORM_DOM_APIS)) {
                logger.trace("1h5q1r", correlationId);
                return new $9ed9a547f6786bdc$var$PlatformAuthDOMHandler(logger, performanceClient, correlationId);
            }
        }
        return undefined;
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return $9ed9a547f6786bdc$var$PlatformAuthConstants.MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return $9ed9a547f6786bdc$var$PlatformAuthConstants.DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        this.logger.trace(`02bcil ${this.platformAuthType}`, request.correlationId);
        try {
            const platformDOMRequest = this.initializePlatformDOMRequest(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            return this.validatePlatformBrokerResponse(response, request.correlationId);
        } catch (e) {
            this.logger.error(`11im7g ${this.platformAuthType}`, request.correlationId);
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        this.logger.trace(`15d6yv ${this.platformAuthType}`, request.correlationId);
        const { accountId: accountId, clientId: clientId, authority: authority, scope: scope, redirectUri: redirectUri, correlationId: correlationId, state: state, extraParameters: extraParameters, ...remainingProperties } = request;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties, correlationId);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: correlationId || this.correlationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response, correlationId) {
        if (response.hasOwnProperty("isSuccess")) {
            if (response.hasOwnProperty("accessToken") && response.hasOwnProperty("idToken") && response.hasOwnProperty("clientInfo") && response.hasOwnProperty("account") && response.hasOwnProperty("scopes") && response.hasOwnProperty("expiresIn")) {
                this.logger.trace(`0h4vei ${this.platformAuthType}`, correlationId);
                return this.convertToPlatformBrokerResponse(response, correlationId);
            } else if (response.hasOwnProperty("error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(`0g92vm ${this.platformAuthType}`, correlationId);
                    throw $9ed9a547f6786bdc$var$createNativeAuthError(errorResponse.error.code, correlationId, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                }
            }
        }
        throw $9ed9a547f6786bdc$var$createAuthError($9ed9a547f6786bdc$var$unexpectedError, correlationId, "Response missing expected properties.");
    }
    convertToPlatformBrokerResponse(response, correlationId) {
        this.logger.trace(`14913t ${this.platformAuthType}`, correlationId);
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: response.properties || {},
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload
        };
        return nativeResponse;
    }
    getDOMExtraParams(extraParameters, correlationId) {
        try {
            const stringifiedProperties = {};
            for (const [key, value] of Object.entries(extraParameters)){
                if (!value) continue;
                if (typeof value === "object") stringifiedProperties[key] = JSON.stringify(value);
                else stringifiedProperties[key] = String(value);
            }
            return stringifiedProperties;
        } catch (e) {
            this.logger.error(`0eu9o3 ${this.platformAuthType}`, correlationId);
            this.logger.errorPii(`17rpl5 ${this.platformAuthType} ${e}`, correlationId);
            return {};
        }
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param domConfig - Whether to enable platform broker DOM API support (required)
 * @param loggerOptions - Optional logger options
 * @param perfClient - Optional performance client
 * @param correlationId - Optional correlation ID
 * @returns Promise<boolean> indicating if platform broker is available
 */ async function $9ed9a547f6786bdc$var$isPlatformBrokerAvailable(domConfig, loggerOptions, perfClient, correlationId) {
    const logger = new $9ed9a547f6786bdc$var$Logger(loggerOptions || {}, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
    const performanceClient = perfClient || new $9ed9a547f6786bdc$var$StubPerformanceClient();
    if (typeof window === "undefined") {
        logger.trace("082ed3", correlationId || $9ed9a547f6786bdc$var$createNewGuid());
        return false;
    }
    return !!await $9ed9a547f6786bdc$var$getPlatformAuthProvider(logger, performanceClient, correlationId || $9ed9a547f6786bdc$var$createNewGuid(), undefined, domConfig);
}
async function $9ed9a547f6786bdc$var$getPlatformAuthProvider(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout, enablePlatformBrokerDOMSupport) {
    logger.trace("134j0v", correlationId);
    logger.trace(`04c81g ${enablePlatformBrokerDOMSupport}`, correlationId);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) // Check if DOM platform API is supported first
        platformAuthProvider = await $9ed9a547f6786bdc$var$PlatformAuthDOMHandler.createProvider(logger, performanceClient, correlationId);
        if (!platformAuthProvider) {
            logger.trace("0l3na8", correlationId);
            /*
             * If DOM APIs are not available, check if browser extension is available.
             * Platform authentication via DOM APIs is preferred over extension APIs.
             */ platformAuthProvider = await $9ed9a547f6786bdc$var$PlatformAuthExtensionHandler.createProvider(logger, nativeBrokerHandshakeTimeout || $9ed9a547f6786bdc$var$DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS, performanceClient, correlationId);
        }
    } catch (e) {
        logger.trace("0icbd7", e);
    }
    return platformAuthProvider;
}
/**
 * Returns boolean indicating whether or not the request should attempt to use platform broker
 * @param logger
 * @param config
 * @param correlationId
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function $9ed9a547f6786bdc$var$isPlatformAuthAllowed(config, logger, correlationId, platformAuthProvider, authenticationScheme) {
    logger.trace("0uko3r", correlationId);
    // throw an error if allowPlatformBroker is not enabled and allowPlatformBrokerWithDOM is enabled
    if (!config.system.allowPlatformBroker && config.experimental.allowPlatformBrokerWithDOM) throw $9ed9a547f6786bdc$var$createClientConfigurationError($9ed9a547f6786bdc$var$invalidPlatformBrokerConfiguration, "");
    if (!config.system.allowPlatformBroker) {
        logger.trace("04hozs", correlationId);
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("0kvv1r", correlationId);
        // Platform broker auth providers are not available
        return false;
    }
    if (authenticationScheme) switch(authenticationScheme){
        case $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER:
        case $9ed9a547f6786bdc$var$AuthenticationScheme$1.POP:
            logger.trace("18tev1", correlationId);
            return true;
        default:
            logger.trace("1dd2nh", correlationId);
            return false;
    }
    return true;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$PopupClient extends $9ed9a547f6786bdc$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler, waitForPopupResponseHook, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler, tokenBindingKeyManager);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
        this.waitForPopupResponseHook = waitForPopupResponseHook;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        let popupParams = undefined;
        try {
            const popupName = this.generatePopupName(request.scopes || $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1, request.authority || this.config.auth.authority);
            popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: !this.config.system.navigatePopups
            }, this.correlationId);
            // navigatePopups flag is false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("162h4u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // navigatePopups flag is set to true. Opens popup before acquiring token.
                // Pre-validate request method to avoid opening popup if the request is invalid
                const validatedRequest = {
                    ...request,
                    httpMethod: $9ed9a547f6786bdc$var$validateRequestMethod(request, this.config.system.protocolMode)
                };
                this.logger.verbose("1f9ok3", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(validatedRequest, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("068rup", this.correlationId);
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // navigatePopups flag set to false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("1phd8u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // navigatePopups flag is set to true. Opens popup before logging out.
                this.logger.verbose("1a28da", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("1g77pg", this.correlationId);
        const validRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeAuthorizationRequest, $9ed9a547f6786bdc$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) $9ed9a547f6786bdc$var$preconnect(validRequest.authority);
        const isPlatformBroker = $9ed9a547f6786bdc$var$isPlatformAuthAllowed(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if (this.config.system.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.EAR) return this.executeEarFlow(validRequest, popupParams, pkceCodes);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.acquireTokenPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkce = pkceCodes || await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge,
            ...tokenBindingParams
        };
        try {
            // Initialize the client
            const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            if (popupRequest.httpMethod === $9ed9a547f6786bdc$var$HttpMethod.POST) return await this.executeCodeFlowWithPost(popupRequest, popupParams, authClient, pkce.verifier);
            else {
                // Create acquire token url.
                const navigateUrl = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getAuthCodeRequestUrl, $9ed9a547f6786bdc$var$GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
                /*
                 * When a popup-relay page is configured, open it top-level
                 * (same first-party origin) instead of navigating the popup
                 * straight to the IdP, and carry the /authorize URL in its hash.
                 * The relay page opens the IdP child popup and relays the
                 * response back via postMessage (see waitForPopupResponse).
                 */ const popupRelayUri = this.config.auth.popupRelayUri;
                const popupNavigateUrl = popupRelayUri ? $9ed9a547f6786bdc$var$buildPopupRelayUrl(popupRelayUri, this.getRelayStateId(request.state, correlationId), {
                    method: "GET",
                    url: navigateUrl
                }, correlationId) : navigateUrl;
                // Show the UI once the url has been created. Get the window handle for the popup.
                const popupWindow = this.initiateAuthRequest(popupNavigateUrl, popupParams);
                this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.POPUP_OPENED, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, {
                    popupWindow: popupWindow
                }, null);
                // Wait for the redirect bridge response
                const responseString = await this.waitForPopupResponse(request, popupWindow, popupParams.popupWindowParent);
                const serverParams = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$deserializeResponse, $9ed9a547f6786bdc$var$DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
                return await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseCode, $9ed9a547f6786bdc$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, $9ed9a547f6786bdc$var$ApiId.acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
            }
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams, pkceCodes) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateEarKey, $9ed9a547f6786bdc$var$GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkce = pkceCodes || await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const popupRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkce.challenge,
            ...tokenBindingParams
        };
        const popupWindow = await this.openPostFormPopup(popupRequest, discoveredAuthority, popupParams, correlationId, true);
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await $9ed9a547f6786bdc$var$invokeAsync(this.waitForPopupResponse.bind(this), $9ed9a547f6786bdc$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupRequest, popupWindow, popupParams.popupWindowParent);
        const serverParams = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$deserializeResponse, $9ed9a547f6786bdc$var$DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.acquireTokenPopup, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseCode, $9ed9a547f6786bdc$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, $9ed9a547f6786bdc$var$ApiId.acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseEAR, $9ed9a547f6786bdc$var$HandleResponseEar, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, $9ed9a547f6786bdc$var$ApiId.acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async executeCodeFlowWithPost(request, popupParams, authClient, pkceVerifier) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        const popupWindow = await this.openPostFormPopup(request, discoveredAuthority, popupParams, correlationId, false);
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await $9ed9a547f6786bdc$var$invokeAsync(this.waitForPopupResponse.bind(this), $9ed9a547f6786bdc$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(request, popupWindow, popupParams.popupWindowParent);
        const serverParams = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$deserializeResponse, $9ed9a547f6786bdc$var$DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseCode, $9ed9a547f6786bdc$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceVerifier, $9ed9a547f6786bdc$var$ApiId.acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("0b7yrk", this.correlationId);
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_START, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, validRequest);
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.logoutPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Clear cache on logout
            await $9ed9a547f6786bdc$var$clearCacheOnLogout(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validRequest.account);
            // Initialize the client
            const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.OIDC) {
                    this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_SUCCESS, validRequest.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: $9ed9a547f6786bdc$var$ApiId.logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(mainWindowRedirectUri, $9ed9a547f6786bdc$var$getCurrentUri(), this.correlationId);
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validRequest.state = $9ed9a547f6786bdc$var$setRequestState(this.browserCrypto, validRequest.state || "", {
                interactionType: $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup
            }, validRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_SUCCESS, validRequest.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, validRequest);
            /*
             * When a popup-relay page is configured, open it top-level (same
             * first-party origin) and carry the end-session URL in its hash,
             * exactly like the login flow. The relay page opens the IdP child
             * popup and the post-logout redirect page (running the redirect
             * bridge) relays completion back via postMessage — so logout works
             * from an embedded, cross-origin iframe where a direct popup to the
             * IdP cannot. See runPopupRelay / waitForPopupResponse.
             */ const popupRelayUri = this.config.auth.popupRelayUri;
            const popupNavigateUrl = popupRelayUri ? $9ed9a547f6786bdc$var$buildPopupRelayUrl(popupRelayUri, this.getRelayStateId(validRequest.state || "", this.correlationId), {
                method: "GET",
                url: logoutUri
            }, this.correlationId) : logoutUri;
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(popupNavigateUrl, popupParams);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.POPUP_OPENED, validRequest.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, {
                popupWindow: popupWindow
            }, null);
            await this.waitForPopupResponse(validRequest, popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: $9ed9a547f6786bdc$var$ApiId.logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(mainWindowRedirectUri, $9ed9a547f6786bdc$var$getCurrentUri(), this.correlationId);
                this.logger.verbose("0qcur2", this.correlationId);
                this.logger.verbosePii(`0oj7lk ${absoluteUrl}`, this.correlationId);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("03zgcf", this.correlationId);
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_FAILURE, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, null, e);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_END, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup);
            throw e;
        }
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_END, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`1kcr9k ${requestUrl}`, this.correlationId);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("1l7hyp", this.correlationId);
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$emptyNavigateUri, this.correlationId);
        }
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`0cgeo7 ${urlNavigate}`, this.correlationId);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`0c2awd ${urlNavigate}`, this.correlationId);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$emptyWindowError, this.correlationId);
            try {
                popupWindow.document.title = "Microsoft Authentication";
            } catch (e) {
                if (typeof DOMException !== "undefined" && e instanceof DOMException && e.name === "SecurityError") ;
                else this.logger.verbose("1s1yfs", this.correlationId);
            }
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            return popupWindow;
        } catch (e) {
            this.logger.error(`0dxfb9 ${e.message}`, this.correlationId);
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$popupWindowError, this.correlationId);
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("08vfmo", this.correlationId);
            width = $9ed9a547f6786bdc$var$BrowserConstants.POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("09cxa0", this.correlationId);
            height = $9ed9a547f6786bdc$var$BrowserConstants.POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("1qh4wo", this.correlationId);
            top = Math.max(0, winHeight / 2 - $9ed9a547f6786bdc$var$BrowserConstants.POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("1sz3en", this.correlationId);
            left = Math.max(0, winWidth / 2 - $9ed9a547f6786bdc$var$BrowserConstants.POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${$9ed9a547f6786bdc$var$BrowserConstants.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${$9ed9a547f6786bdc$var$BrowserConstants.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
    /**
     * Decodes the per-request library-state id from the encoded request state.
     */ getRelayStateId(state, correlationId) {
        return $9ed9a547f6786bdc$var$parseRequestState($9ed9a547f6786bdc$var$base64Decode, state, correlationId).libraryState.id;
    }
    /**
     * Opens the interactive popup for a POST-form /authorize request. Shared by
     * the auth-code POST and EAR flows, which are identical apart from the form
     * builder (`isEAR` selects the EAR vs auth-code builders). When a
     * popup-relay page is configured the form is carried to the relay page
     * (which opens the IdP child popup); otherwise the form is submitted
     * directly into the popup.
     */ async openPostFormPopup(request, discoveredAuthority, popupParams, correlationId, isEAR) {
        const popupRelayUri = this.config.auth.popupRelayUri;
        if (popupRelayUri) {
            const getFormData = isEAR ? $9ed9a547f6786bdc$var$getEARFormData : $9ed9a547f6786bdc$var$getCodeFormData;
            const formData = await getFormData(this.config, discoveredAuthority, request, this.logger, this.performanceClient);
            const relayUrl = $9ed9a547f6786bdc$var$buildPopupRelayUrl(popupRelayUri, this.getRelayStateId(request.state, correlationId), {
                method: "POST",
                action: formData.action,
                fields: formData.fields
            }, correlationId);
            return this.initiateAuthRequest(relayUrl, popupParams);
        }
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const getForm = isEAR ? $9ed9a547f6786bdc$var$getEARForm : $9ed9a547f6786bdc$var$getCodeForm;
        const form = await getForm(popupWindow.document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return popupWindow;
    }
    async waitForPopupResponse(request, popupWindow, popupWindowParent) {
        /*
         * When a popup-relay page is configured the response is relayed back to
         * this frame by the relay page via postMessage, and the relay popup's
         * lifecycle (including the user dismissing it before signing in) must be
         * tracked here. This takes precedence over the default bridge response
         * hook, whose BroadcastChannel cannot reach a partitioned cross-site
         * frame and which does not track the relay popup.
         */ if (this.config.auth.popupRelayUri) return $9ed9a547f6786bdc$var$waitForPopupRelayResponse(this.config.system.popupBridgeTimeout, this.logger, request, popupWindow, this.performanceClient);
        if (this.waitForPopupResponseHook) return this.waitForPopupResponseHook(request, popupWindow, popupWindowParent);
        return $9ed9a547f6786bdc$var$waitForBridgeResponse(this.config.system.popupBridgeTimeout, this.logger, request, this.performanceClient);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $9ed9a547f6786bdc$var$RedirectClient extends $9ed9a547f6786bdc$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler, tokenBindingKeyManager);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeAuthorizationRequest, $9ed9a547f6786bdc$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        validRequest.platformBroker = $9ed9a547f6786bdc$var$isPlatformAuthAllowed(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("0udvtt", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.RESTORE_FROM_BFCACHE, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`0zao0a ${redirectStartPage}`, this.correlationId);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            if (this.config.system.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.EAR) await this.executeEarFlow(validRequest);
            else await this.executeCodeFlow(validRequest);
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) e.correlationId = this.correlationId;
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.acquireTokenRedirect, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkceCodes = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge,
            ...tokenBindingParams
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        try {
            if (redirectRequest.httpMethod === $9ed9a547f6786bdc$var$HttpMethod.POST) return await this.executeCodeFlowWithPost(redirectRequest);
            else {
                // Initialize the client
                const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                    serverTelemetryManager: serverTelemetryManager,
                    requestAuthority: redirectRequest.authority,
                    requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                    requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                    account: redirectRequest.account
                });
                // Create acquire token url.
                const navigateUrl = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getAuthCodeRequestUrl, $9ed9a547f6786bdc$var$GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                return await this.initiateAuthRequest(navigateUrl);
            }
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateEarKey, $9ed9a547f6786bdc$var$GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const redirectRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge,
            ...tokenBindingParams
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        const form = await $9ed9a547f6786bdc$var$getEARForm(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$timedOut, "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Executes classic Authorization Code flow with a POST request.
     * @param request
     */ async executeCodeFlowWithPost(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        this.browserStorage.cacheAuthorizeRequest(request, this.correlationId);
        const form = await $9ed9a547f6786bdc$var$getCodeForm(document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$timedOut, "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     * @param request {CommonAuthorizationUrlRequest} request object
     * @param pkceVerifier {string} PKCE verifier
     * @param options {HandleRedirectPromiseOptions} options for handling redirect promise
     */ async handleRedirectPromise(request, pkceVerifier, parentMeasurement, options) {
        const originalTitle = document.title;
        document.title = "Microsoft Authentication";
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.handleRedirectPromise, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            const [serverParams, responseString] = this.getRedirectResponse(options?.hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("1qmv0q", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                // Do not instrument "no_server_response" if user clicked back button
                if ($9ed9a547f6786bdc$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("1eqegq", this.correlationId);
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.ORIGIN_URI, this.correlationId, true) || "";
            const loginRequestUrlNormalized = $9ed9a547f6786bdc$var$normalizeUrlForComparison(loginRequestUrl, this.logger, this.correlationId);
            const currentUrlNormalized = $9ed9a547f6786bdc$var$normalizeUrlForComparison(window.location.href, this.logger, this.correlationId);
            if (loginRequestUrlNormalized === currentUrlNormalized && navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("11yred", this.correlationId);
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                $9ed9a547f6786bdc$var$replaceHash(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!navigateToLoginRequestUrl) {
                this.logger.verbose("0v4sdv", this.correlationId);
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!$9ed9a547f6786bdc$var$isInIframe() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: $9ed9a547f6786bdc$var$ApiId.handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl) {
                    // Redirect to home page if login request url is empty
                    const homepage = $9ed9a547f6786bdc$var$getHomepage(this.correlationId);
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.ORIGIN_URI, homepage, true);
                    this.logger.warning("1dutq1", this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`08jpy1 ${loginRequestUrl}`, this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        } finally{
            document.title = originalTitle;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("1c5i8m", this.correlationId);
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.responseMode === $9ed9a547f6786bdc$var$ResponseMode$1.QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = $9ed9a547f6786bdc$var$getDeserializedResponse(responseString);
        if (response) {
            try {
                $9ed9a547f6786bdc$var$validateInteractionType(response, this.browserCrypto, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, this.correlationId);
            } catch (e) {
                if (e instanceof $9ed9a547f6786bdc$var$AuthError) this.logger.error(`0bkq6p ${e.errorCode} ${e.errorMessage}`, this.correlationId);
                return [
                    null,
                    ""
                ];
            }
            $9ed9a547f6786bdc$var$clearHash(window);
            this.logger.verbose("00uvho", this.correlationId);
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache($9ed9a547f6786bdc$var$TemporaryCacheKeys.URL_HASH, this.correlationId, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey($9ed9a547f6786bdc$var$TemporaryCacheKeys.URL_HASH));
        if (cachedHash) {
            response = $9ed9a547f6786bdc$var$getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("001671", this.correlationId);
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$noStateInHash, request.correlationId);
        const { authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, request.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
            return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseEAR, $9ed9a547f6786bdc$var$HandleResponseEar, this.logger, this.performanceClient, request.correlationId)(request, serverParams, $9ed9a547f6786bdc$var$ApiId.acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: request.authority
        });
        return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseCode, $9ed9a547f6786bdc$var$HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, $9ed9a547f6786bdc$var$ApiId.acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl) {
        this.logger.verbose("0yaw2e", this.correlationId);
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`1luf83 ${requestUrl}`, this.correlationId);
            const navigationOptions = {
                apiId: $9ed9a547f6786bdc$var$ApiId.acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("1nehvl", this.correlationId);
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("1a0jxh", this.correlationId);
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("09k5h5", this.correlationId);
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("0klwf7", this.correlationId);
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("0rlh4e", this.correlationId);
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$emptyNavigateUri, this.correlationId);
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.logout, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_START, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, logoutRequest);
            // Clear cache on logout
            await $9ed9a547f6786bdc$var$clearCacheOnLogout(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
            const navigationOptions = {
                apiId: $9ed9a547f6786bdc$var$ApiId.logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_SUCCESS, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, validLogoutRequest);
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validLogoutRequest.state = $9ed9a547f6786bdc$var$setRequestState(this.browserCrypto, validLogoutRequest.state || "", {
                interactionType: $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect
            }, validLogoutRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            if (validLogoutRequest.account?.homeAccountId) this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_SUCCESS, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            if (typeof onRedirectNavigate === "function") {
                const navigate = onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("06v57e", this.correlationId);
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("0xqes1", this.correlationId);
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_FAILURE, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, null, e);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_END, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
            throw e;
        }
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGOUT_END, this.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        const absoluteRedirectStartPage = $9ed9a547f6786bdc$var$UrlString.getAbsoluteUrl(redirectStartPage, $9ed9a547f6786bdc$var$getCurrentUri(), this.correlationId);
        // Sanity check the URL before it is cached so we never persist a malformed value (e.g. the literal string "null")
        $9ed9a547f6786bdc$var$validateUrl(absoluteRedirectStartPage, this.logger, this.correlationId);
        return absoluteRedirectStartPage;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Navigates the given hidden iframe to the provided URL.
 * @param frame
 * @param requestUrl
 */ async function $9ed9a547f6786bdc$var$initiateCodeRequest(frame, requestUrl, logger, correlationId) {
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("1l7hyp", correlationId);
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$emptyNavigateUri, correlationId);
    }
    frame.src = requestUrl;
    return frame;
}
async function $9ed9a547f6786bdc$var$initiateCodeFlowWithPost(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await $9ed9a547f6786bdc$var$getCodeForm(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
async function $9ed9a547f6786bdc$var$initiateEarRequest(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await $9ed9a547f6786bdc$var$getEARForm(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * @hidden
 * Creates a new hidden iframe for silent token renewal. Callers navigate it
 * (set `src` or submit a form) after registering the response listener.
 * @ignore
 */ function $9ed9a547f6786bdc$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.title = "Microsoft Authentication";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    authFrame.setAttribute("allow", "local-network-access *");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from `document.body` if it is a direct child.
 * @param iframe - The iframe element to remove.
 */ function $9ed9a547f6786bdc$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$SilentIframeClient extends $9ed9a547f6786bdc$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, correlationId, platformAuthProvider, waitForIframeResponseHook, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
        this.waitForIframeResponseHook = waitForIframeResponseHook;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("1kl318", this.correlationId);
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== $9ed9a547f6786bdc$var$PromptValue$1.NONE && inputRequest.prompt !== $9ed9a547f6786bdc$var$PromptValue$1.NO_SESSION) {
                this.logger.warning(`0bmctg ${inputRequest.prompt} ${$9ed9a547f6786bdc$var$PromptValue$1.NONE}`, this.correlationId);
                inputRequest.prompt = $9ed9a547f6786bdc$var$PromptValue$1.NONE;
            }
        } else inputRequest.prompt = $9ed9a547f6786bdc$var$PromptValue$1.NONE;
        // Create silent request
        const silentRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeAuthorizationRequest, $9ed9a547f6786bdc$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(inputRequest, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        silentRequest.platformBroker = $9ed9a547f6786bdc$var$isPlatformAuthAllowed(this.config, this.logger, this.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme);
        $9ed9a547f6786bdc$var$preconnect(silentRequest.authority);
        if (this.config.system.protocolMode === $9ed9a547f6786bdc$var$ProtocolMode.EAR) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Initialize the client
            authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await $9ed9a547f6786bdc$var$invokeAsync(this.silentTokenHelper.bind(this), $9ed9a547f6786bdc$var$SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof $9ed9a547f6786bdc$var$AuthError) || e.errorCode !== $9ed9a547f6786bdc$var$BrowserConstants.INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await $9ed9a547f6786bdc$var$invokeAsync(this.silentTokenHelper.bind(this), $9ed9a547f6786bdc$var$SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        const discoveredAuthority = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getDiscoveredAuthority, $9ed9a547f6786bdc$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generateEarKey, $9ed9a547f6786bdc$var$GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = $9ed9a547f6786bdc$var$createHiddenIframe();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        let responseString;
        try {
            const responsePromise = $9ed9a547f6786bdc$var$invokeAsync(this.waitForIframeResponse.bind(this), $9ed9a547f6786bdc$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If navigation below throws before responsePromise is awaited,
                 * the listener still rejects on timeout. Swallow it here so it
                 * does not surface as an unhandled rejection; the navigation
                 * error is propagated instead.
                 */ });
            await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initiateEarRequest, $9ed9a547f6786bdc$var$SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(iframe, this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
            responseString = await responsePromise;
        } finally{
            $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$removeHiddenIframe, $9ed9a547f6786bdc$var$RemoveHiddenIframe, this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$deserializeResponse, $9ed9a547f6786bdc$var$DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            // If server doesn't support EAR, they may fallback to auth code flow instead
            const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseCode, $9ed9a547f6786bdc$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseEAR, $9ed9a547f6786bdc$var$HandleResponseEar, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Verifies SSO capability by making an iframe request to /authorize without exchanging the code for tokens.
     * This is useful for verifying SSO capability in the background without the overhead of a full token exchange.
     * @param request - The SSO silent request
     * @returns true if SSO verification was successful with a valid authorization code, false otherwise
     */ async verifySso(request) {
        const inputRequest = {
            ...request
        };
        if (!inputRequest.prompt) inputRequest.prompt = $9ed9a547f6786bdc$var$PromptValue$1.NONE;
        // Create silent request
        const silentRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeAuthorizationRequest, $9ed9a547f6786bdc$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(inputRequest, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        const authClient = await $9ed9a547f6786bdc$var$invokeAsync(this.createAuthCodeClient.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            requestExtraQueryParameters: silentRequest.extraQueryParameters,
            account: silentRequest.account
        });
        const { serverParams: serverParams } = await this.silentAuthorizeHelper(authClient, silentRequest);
        const correlationId = silentRequest.correlationId;
        // Validate the response - this checks for errors and validates state
        $9ed9a547f6786bdc$var$validateAuthorizationResponse(serverParams, silentRequest.state, correlationId);
        // Verify a valid authorization code is present
        if (!serverParams.code) {
            this.logger.warning("0y34ti", correlationId);
            return false;
        }
        this.logger.verbose("0kkkcj", correlationId);
        return true;
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$silentLogoutUnsupported, ""));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const { serverParams: serverParams, pkceCodes: pkceCodes, silentRequest: silentRequest } = await this.silentAuthorizeHelper(authClient, request);
        return $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$handleResponseCode, $9ed9a547f6786bdc$var$HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Shared helper that generates PKCE codes, builds the /authorize URL,
     * loads it in a hidden iframe, waits for the redirect-bridge response,
     * and returns the deserialized server parameters along with the PKCE codes
     * and the request that was sent.
     */ async silentAuthorizeHelper(authClient, request) {
        const correlationId = request.correlationId;
        const pkceCodes = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge,
            ...tokenBindingParams
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = $9ed9a547f6786bdc$var$createHiddenIframe();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        // Wait for response from the redirect bridge.
        let responseString;
        try {
            const responsePromise = $9ed9a547f6786bdc$var$invokeAsync(this.waitForIframeResponse.bind(this), $9ed9a547f6786bdc$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If URL creation or navigation below throws before
                 * responsePromise is awaited, the listener still rejects on
                 * timeout. Swallow it here so it does not surface as an
                 * unhandled rejection; the navigation error is propagated
                 * instead.
                 */ });
            if (request.httpMethod === $9ed9a547f6786bdc$var$HttpMethod.POST) await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initiateCodeFlowWithPost, $9ed9a547f6786bdc$var$SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(iframe, this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
            else {
                // Create authorize request url
                const navigateUrl = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$getAuthCodeRequestUrl, $9ed9a547f6786bdc$var$GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
                // Navigate the iframe to the authorize request url
                await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initiateCodeRequest, $9ed9a547f6786bdc$var$SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(iframe, navigateUrl, this.logger, correlationId);
            }
            responseString = await responsePromise;
        } finally{
            $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$removeHiddenIframe, $9ed9a547f6786bdc$var$RemoveHiddenIframe, this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = $9ed9a547f6786bdc$var$invoke($9ed9a547f6786bdc$var$deserializeResponse, $9ed9a547f6786bdc$var$DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        return {
            serverParams: serverParams,
            pkceCodes: pkceCodes,
            silentRequest: silentRequest
        };
    }
    async waitForIframeResponse(iframe, request) {
        if (this.waitForIframeResponseHook) return this.waitForIframeResponseHook(iframe, request);
        return $9ed9a547f6786bdc$var$waitForBridgeResponse(this.config.system.iframeBridgeTimeout, this.logger, request, this.performanceClient, this.config.experimental);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$SilentRefreshClient extends $9ed9a547f6786bdc$var$StandardInteractionClient {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        const baseRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeBaseRequest, $9ed9a547f6786bdc$var$InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger, this.correlationId);
        const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(baseRequest, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const silentRequest = {
            ...request,
            ...baseRequest,
            ...tokenBindingParams
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = $9ed9a547f6786bdc$var$getRedirectUri(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager($9ed9a547f6786bdc$var$ApiId.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return $9ed9a547f6786bdc$var$invokeAsync(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), $9ed9a547f6786bdc$var$RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest, $9ed9a547f6786bdc$var$ApiId.acquireTokenSilent_silentFlow).catch((e)=>{
            e.correlationId = this.correlationId;
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$silentLogoutUnsupported, ""));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await $9ed9a547f6786bdc$var$invokeAsync(this.getClientConfiguration.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new $9ed9a547f6786bdc$var$RefreshTokenClient(clientConfig, this.performanceClient);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$HybridSpaAuthorizationCodeClient extends $9ed9a547f6786bdc$var$AuthorizationCodeClient {
    constructor(config, performanceClient){
        super(config, performanceClient);
        this.includeRedirectUri = false;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$SilentAuthCodeClient extends $9ed9a547f6786bdc$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$authCodeRequired, this.correlationId);
        // Create silent request
        const silentRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeAuthorizationRequest, $9ed9a547f6786bdc$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, /*
         * correlationId is optional in request payload, while this.correlationId is always instantiated as request.correlationId || createGuid().
         * Each auth request creates a new instance of *Client so we can safely use this.correlationId.
         */ this.correlationId);
        const serverTelemetryManager = $9ed9a547f6786bdc$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            const tokenBindingParams = await $9ed9a547f6786bdc$var$getTokenBindingRequestParams(silentRequest, this.tokenBindingKeyManager, this.logger, this.performanceClient);
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code,
                ...tokenBindingParams
            };
            // Initialize the client
            const clientConfig = await $9ed9a547f6786bdc$var$invokeAsync(this.getClientConfiguration.bind(this), $9ed9a547f6786bdc$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new $9ed9a547f6786bdc$var$HybridSpaAuthorizationCodeClient(clientConfig, this.performanceClient);
            this.logger.verbose("1uic5e", this.correlationId);
            // Create silent handler
            const interactionHandler = new $9ed9a547f6786bdc$var$InteractionHandler(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await $9ed9a547f6786bdc$var$invokeAsync(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), $9ed9a547f6786bdc$var$HandleCodeResponseFromServer, this.logger, this.performanceClient, this.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, this.apiId, false);
        } catch (e) {
            if (e instanceof $9ed9a547f6786bdc$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$silentLogoutUnsupported, ""));
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Get network information for telemetry purposes. This is only supported in Chromium-based browsers.
 * @returns Network connection information, or an empty object if not available.
 */ function $9ed9a547f6786bdc$var$getNetworkInfo() {
    if (typeof window === "undefined" || !window.navigator) return {};
    const connection = "connection" in window.navigator ? window.navigator.connection : undefined;
    return {
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt
    };
}
function $9ed9a547f6786bdc$var$collectInstanceStats(currentClientId, performanceEvent, logger, correlationId) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("1e88vg", correlationId);
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$preflightCheck(initialized, performanceEvent, config, request) {
    try {
        $9ed9a547f6786bdc$var$preflightCheck$1(initialized);
        $9ed9a547f6786bdc$var$enforceResourceParameter(config.auth.isMcp, request);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e, request.account);
        throw e;
    }
}
class $9ed9a547f6786bdc$var$StandardController {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize environment-specific crypto and token-binding services.
        if (this.isBrowserEnvironment) {
            this.browserCrypto = new $9ed9a547f6786bdc$var$CryptoOps(this.logger, this.performanceClient);
            this.tokenBindingKeyManager = new $9ed9a547f6786bdc$var$TokenBindingKeyManager(this.logger, this.performanceClient);
        } else {
            this.browserCrypto = $9ed9a547f6786bdc$var$DEFAULT_CRYPTO_IMPLEMENTATION;
            this.tokenBindingKeyManager = $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER;
        }
        this.eventHandler = new $9ed9a547f6786bdc$var$EventHandler(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new $9ed9a547f6786bdc$var$BrowserCacheManager(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, $9ed9a547f6786bdc$var$buildStaticAuthorityOptions(this.config.auth), this.tokenBindingKeyManager) : $9ed9a547f6786bdc$var$DEFAULT_BROWSER_CACHE_MANAGER(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler, undefined, this.tokenBindingKeyManager);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: $9ed9a547f6786bdc$var$BrowserCacheLocation.MemoryStorage,
            cacheRetentionDays: 5
        };
        this.nativeInternalStorage = new $9ed9a547f6786bdc$var$BrowserCacheManager(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, undefined, this.tokenBindingKeyManager);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackStateChange = this.trackStateChange.bind(this);
        // Register listener functions
        this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $9ed9a547f6786bdc$var$StandardController(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackStateChange(correlationId, event) {
        if (!correlationId) return;
        if (event.type === "visibilitychange") {
            this.logger.info("16v6hv", correlationId);
            this.performanceClient.incrementFields({
                visibilityChangeCount: 1
            }, correlationId);
        } else if (event.type === "online") {
            this.logger.info("0zirfd", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        } else if (event.type === "offline") {
            this.logger.info("1xk9ef", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        }
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1f7joy", correlationId);
        if (this.initialized) {
            this.logger.info("061m5x", correlationId);
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("19fvpi", correlationId);
            this.initialized = true;
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.INITIALIZE_END, correlationId);
            return;
        }
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$InitializeClientApplication, correlationId);
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.INITIALIZE_START, correlationId);
        // Broker applications are initialized twice, so we avoid double-counting it
        this.logMultipleInstances(initMeasurement, correlationId);
        initMeasurement.add({
            isMcp: this.config.auth.isMcp
        });
        await $9ed9a547f6786bdc$var$invokeAsync(this.browserStorage.initialize.bind(this.browserStorage), $9ed9a547f6786bdc$var$InitializeCache, this.logger, this.performanceClient, correlationId)(correlationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await $9ed9a547f6786bdc$var$getPlatformAuthProvider(this.logger, this.performanceClient, correlationId, this.config.system.nativeBrokerHandshakeTimeout, this.config.experimental.allowPlatformBrokerWithDOM);
        } catch (e) {
            this.logger.verbose(e, correlationId);
        }
        if (this.config.cache.cacheLocation === $9ed9a547f6786bdc$var$BrowserCacheLocation.LocalStorage) this.eventHandler.subscribeCrossTab();
        !this.config.system.navigatePopups && await this.preGeneratePkceCodes(correlationId);
        this.initialized = true;
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.INITIALIZE_END, correlationId);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(options) {
        this.logger.verbose("02l8bm", "");
        // Block token acquisition before initialize has been called
        $9ed9a547f6786bdc$var$blockAPICallsBeforeInitialize(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = options?.hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(options);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("1wn9kp", "");
            } else this.logger.verbose("0w0gm3", "");
            return response;
        }
        this.logger.verbose("12xi63", "");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(options) {
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", "");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNOUT) {
            this.logger.verbose("1ywcv2", "");
            this.browserStorage.setInteractionInProgress(false);
            return Promise.resolve(null);
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && !options?.hash;
        let rootMeasurement;
        let redirectResponse;
        let cachedRedirectRequest;
        try {
            if (useNative && this.platformAuthProvider) {
                const correlationId = platformBrokerRequest?.correlationId || "";
                this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.HANDLE_REDIRECT_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
                rootMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenRedirect, correlationId);
                this.logger.trace("12v7is", correlationId);
                // Cached nativeAccountId routes directly to the broker (no /authorize call)
                rootMeasurement.add({
                    isPlatformBrokerRequest: true
                });
                const nativeClient = new $9ed9a547f6786bdc$var$PlatformAuthInteractionClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9ed9a547f6786bdc$var$ApiId.handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId, this.tokenBindingKeyManager);
                redirectResponse = $9ed9a547f6786bdc$var$invokeAsync(nativeClient.handleRedirectPromise.bind(nativeClient), $9ed9a547f6786bdc$var$HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)();
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest("");
                cachedRedirectRequest = standardRequest;
                const correlationId = standardRequest.correlationId;
                this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.HANDLE_REDIRECT_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenRedirect, correlationId);
                this.logger.trace("0znzs5", correlationId);
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = $9ed9a547f6786bdc$var$invokeAsync(redirectClient.handleRedirectPromise.bind(redirectClient), $9ed9a547f6786bdc$var$HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(standardRequest, codeVerifier, rootMeasurement, options);
            }
        } catch (e) {
            this.browserStorage.resetRequestCache("");
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache(result.correlationId);
                this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, result.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, result);
                this.logger.verbose("0ui8f5", result.correlationId);
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGIN_SUCCESS, result.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, result.account);
                    this.logger.verbose("16im3l", result.correlationId);
                }
                rootMeasurement.end({
                    success: true,
                    isNativeBroker: result.fromPlatformBroker ?? false
                }, undefined, result.account);
                // Fire-and-forget SSO capability verification in background
                this.verifySsoCapability(cachedRedirectRequest, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (!!rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            });
            else rootMeasurement.discard();
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache(rootMeasurement.event.correlationId);
            const eventError = e;
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, rootMeasurement.event.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, null, eventError);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0os66p", correlationId);
        $9ed9a547f6786bdc$var$redirectPreflightCheck(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNIN);
        const atrMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            scenarioId: request.scenarioId
        });
        const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
        this.config.auth.onRedirectNavigate = (url)=>{
            const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
            atrMeasurement.add({
                navigateCallbackResult: navigate !== false
            });
            atrMeasurement.event = atrMeasurement.end({
                success: true
            }, undefined, request.account) || atrMeasurement.event;
            return navigate;
        };
        try {
            $9ed9a547f6786bdc$var$enforceResourceParameter(this.config.auth.isMcp, request);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, request);
            let result;
            if (this.platformAuthProvider && this.canUsePlatformBroker(request)) {
                const nativeClient = new $9ed9a547f6786bdc$var$PlatformAuthInteractionClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9ed9a547f6786bdc$var$ApiId.acquireTokenRedirect, this.performanceClient, this.platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId, this.tokenBindingKeyManager);
                result = $9ed9a547f6786bdc$var$invokeAsync(nativeClient.acquireTokenRedirect.bind(nativeClient), $9ed9a547f6786bdc$var$NativeInteractionClientAcquireTokenRedirect, this.logger, this.performanceClient, correlationId)(request, atrMeasurement).catch((e)=>{
                    if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError && $9ed9a547f6786bdc$var$isFatalNativeAuthError(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof $9ed9a547f6786bdc$var$InteractionRequiredAuthError) {
                        this.logger.verbose("1ipyz4", correlationId);
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache(correlationId);
            /*
             * Pre-redirect event completes before navigation occurs.
             * Timed out navigation needs to be instrumented separately as a post-redirect event.
             */ if (atrMeasurement.event.status === 2) this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenRedirect, correlationId).end({
                success: false
            }, e, request.account);
            else atrMeasurement.end({
                success: false
            }, e, request.account);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            this.logger.verbose("0ch87b", correlationId);
            $9ed9a547f6786bdc$var$preflightCheck(this.initialized, atPopupMeasurement, this.config, request);
            this.browserStorage.setInteractionInProgress(true, $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNIN, request.overrideInteractionInProgress, correlationId);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) {
            // Cached nativeAccountId routes directly to the broker (no /authorize call)
            atPopupMeasurement.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative({
                ...request,
                correlationId: correlationId
            }, $9ed9a547f6786bdc$var$ApiId.acquireTokenPopup).then((response)=>{
                atPopupMeasurement.end({
                    success: true,
                    isNativeBroker: response.fromPlatformBroker ?? false
                }, undefined, response.account);
                return response;
            }).catch((e)=>{
                if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError && $9ed9a547f6786bdc$var$isFatalNativeAuthError(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                } else if (e instanceof $9ed9a547f6786bdc$var$InteractionRequiredAuthError) {
                    this.logger.verbose("0yy5fw", correlationId);
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                }
                throw e;
            });
        } else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, result);
            if (isLoggingIn) this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGIN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, result.account);
            atPopupMeasurement.end({
                success: true,
                isNativeBroker: result.fromPlatformBroker ?? false,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            // SSO capability verification in background
            this.verifySsoCapability(request, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup);
            return result;
        }).catch((e)=>{
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (!this.config.system.navigatePopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackStateChangeWithMeasurement(event) {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        if (event.type === "visibilitychange") {
            this.logger.info(`0yzimq ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                visibilityChangeCount: 1
            });
        } else if (event.type === "online") {
            this.logger.info(`1caf53 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        } else if (event.type === "offline") {
            this.logger.info(`0fdyk7 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        }
    }
    addStateChangeListeners(listener) {
        document.addEventListener("visibilitychange", listener);
        window.addEventListener("online", listener);
        window.addEventListener("offline", listener);
    }
    removeStateChangeListeners(listener) {
        document.removeEventListener("visibilitychange", listener);
        window.removeEventListener("online", listener);
        window.removeEventListener("offline", listener);
    }
    /**
     * Reads the cached ssoCapable value from localStorage.
     * @returns The cached ssoCapable boolean value, or undefined if not cached or expired.
     */ getCachedSsoCapable() {
        try {
            const cachedValue = window.localStorage.getItem($9ed9a547f6786bdc$var$SSO_CAPABLE);
            if (cachedValue) {
                const parsed = JSON.parse(cachedValue);
                if (parsed && typeof parsed.ssoCapable === "boolean" && parsed.expiresOn && Date.now() < parsed.expiresOn) return parsed.ssoCapable;
            }
        } catch  {
        // If parsing fails, return undefined
        }
        return undefined;
    }
    /**
     * SSO capability verification in the background.
     * This method makes an iframe request to /authorize to verify SSO capability without calling /token.
     * This method does not block the caller and tracks telemetry for success/failure.
     * This method only executes if verifySSO is set to true in the auth configuration.
     * The result is cached in localStorage with a 24-hour TTL; the SSO verification call
     * is only attempted when the cached value is absent or expired.
     * @param request - The original request used for the authentication flow
     * @param interactionType - The interactionType of the AT operation for logging purposes
     */ verifySsoCapability(request, interactionType) {
        // Check if SSO capability verification is enabled
        if (!this.config.auth.verifySSO) return;
        // Check TTL: derive ssoCapable state from localStorage and skip if not expired
        const ssoCacheKey = $9ed9a547f6786bdc$var$SSO_CAPABLE;
        const SSO_CAPABLE_TTL_MS = 86400000; // 24 hours
        const cachedSsoCapable = this.getCachedSsoCapable();
        if (cachedSsoCapable !== undefined) {
            this.logger.verbose(`13poou ${interactionType}`, "");
            return;
        }
        const correlationId = $9ed9a547f6786bdc$var$createNewGuid();
        const ssoCapableMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$SsoCapable, correlationId);
        ssoCapableMeasurement.add({
            "ext.interactionType": interactionType
        });
        this.logger.verbose(`0pbr0i ${interactionType}`, correlationId);
        /*
         * Use setTimeout to ensure this runs in a separate macrotask after the current call stack completes
         * This ensures the result is returned to the caller before the SSO verification starts and doesn't affect performance
         */ setTimeout(()=>{
            const ssoVerificationRequest = {
                ...request,
                correlationId: correlationId
            };
            const silentIframeClient = this.createSilentIframeClient(correlationId);
            silentIframeClient.verifySso(ssoVerificationRequest).then((result)=>{
                this.logger.verbose(`1gd1iv ${interactionType} ${result}`, correlationId);
                // TBD to add profileTelemetry later in localStorage with 24h TTL
                try {
                    const cacheEntry = JSON.stringify({
                        ssoCapable: result,
                        expiresOn: Date.now() + SSO_CAPABLE_TTL_MS
                    });
                    window.localStorage.setItem(ssoCacheKey, cacheEntry);
                } catch  {
                    this.logger.warning(`18lmoj ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: result
                }, undefined);
            }).catch((error)=>{
                this.logger.warning(`05g83w ${interactionType} ${error.message}`, correlationId);
                // reset the cache
                try {
                    window.localStorage.removeItem(ssoCacheKey);
                } catch  {
                    this.logger.warning(`0nlf9q ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: false
                }, error);
            });
        }, 0);
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        $9ed9a547f6786bdc$var$preflightCheck(this.initialized, this.ssoSilentMeasurement, this.config, validRequest);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const loggedInAccounts = this.getAllAccounts();
        this.logger.verbose("0w1b45", correlationId);
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) {
            // Cached nativeAccountId routes directly to the broker (no /authorize call)
            this.ssoSilentMeasurement?.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative(validRequest, $9ed9a547f6786bdc$var$ApiId.ssoSilent).catch((e)=>{
                // If native token acquisition fails for availability reasons fallback to standard flow
                if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError && $9ed9a547f6786bdc$var$isFatalNativeAuthError(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    return silentIframeClient.acquireToken(validRequest);
                }
                throw e;
            });
        } else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, response);
            if (isLoggingIn) this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.LOGIN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, response.account);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromPlatformBroker ?? false,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length
            }, undefined, response.account);
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw e;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0ch6ga", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenByCode, correlationId);
        $9ed9a547f6786bdc$var$preflightCheck(this.initialized, atbcMeasurement, this.config, request);
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$spaCodeAndNativeAccountIdPresent, correlationId);
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("06eh73", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            isNativeBroker: false,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        }, undefined, result.account);
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("0qgp28", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    atbcMeasurement.add({
                        isPlatformBrokerRequest: true
                    });
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, $9ed9a547f6786bdc$var$ApiId.acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError && $9ed9a547f6786bdc$var$isFatalNativeAuthError(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        success: true,
                        isNativeBroker: result.fromPlatformBroker ?? false
                    }, undefined, result.account);
                    return result;
                } else throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unableToAcquireTokenFromNativePlatform, correlationId);
            } else throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$authCodeOrNativeAccountIdRequired, correlationId);
        } catch (e) {
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("10d9hy", correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenByCodeAsync, correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                isNativeBroker: false,
                fromCache: response.fromCache
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.Default:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessToken:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return $9ed9a547f6786bdc$var$invokeAsync(silentCacheClient.acquireToken.bind(silentCacheClient), $9ed9a547f6786bdc$var$SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.Default:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessTokenAndRefreshToken:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.RefreshToken:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return $9ed9a547f6786bdc$var$invokeAsync(silentRefreshClient.acquireToken.bind(silentRefreshClient), $9ed9a547f6786bdc$var$SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return $9ed9a547f6786bdc$var$invokeAsync(silentIframeClient.acquireToken.bind(silentIframeClient), $9ed9a547f6786bdc$var$SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        $9ed9a547f6786bdc$var$redirectPreflightCheck(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            $9ed9a547f6786bdc$var$preflightCheck$1(this.initialized);
            this.browserStorage.setInteractionInProgress(true, $9ed9a547f6786bdc$var$INTERACTION_TYPE.SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) return;
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return $9ed9a547f6786bdc$var$getAllAccounts(this.logger, this.browserStorage, this.isBrowserEnvironment, this.getRequestCorrelationId(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return $9ed9a547f6786bdc$var$getAccount(accountFilter, this.logger, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        $9ed9a547f6786bdc$var$setActiveAccount(account, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return $9ed9a547f6786bdc$var$getActiveAccount(this.browserStorage, this.getRequestCorrelationId());
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = $9ed9a547f6786bdc$var$createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, $9ed9a547f6786bdc$var$isKmsi(result.idTokenClaims), $9ed9a547f6786bdc$var$ApiId.hydrateCache);
        if (result.fromPlatformBroker) {
            this.logger.verbose("1i5atf", result.correlationId);
            // Create idToken entity and store in browser storage
            const idTokenEntity = $9ed9a547f6786bdc$var$createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.config.auth.clientId, result.tenantId);
            // Create accessToken entity and store in native internal storage
            const attributeTokenPartition = $9ed9a547f6786bdc$var$serializeAttributeTokens(request.attributeTokens);
            const additionalCacheKeyComponents = attributeTokenPartition ? {
                attribute_tokens: attributeTokenPartition
            } : undefined;
            const accessTokenEntity = $9ed9a547f6786bdc$var$createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.config.auth.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? $9ed9a547f6786bdc$var$toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? $9ed9a547f6786bdc$var$toSecondsFromDate(result.extExpiresOn) : 0, $9ed9a547f6786bdc$var$base64Decode, request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid, additionalCacheKeyComponents);
            if (request.resource) accessTokenEntity.resource = request.resource;
            // Get attribute token partition hash for cache key isolation
            const components = additionalCacheKeyComponents;
            const additionalCacheKeyHash = components ? await this.browserCrypto.hashString(JSON.stringify(components)) : undefined;
            const kmsi = $9ed9a547f6786bdc$var$isKmsi(result.idTokenClaims);
            // Store idToken in browser storage
            await this.browserStorage.setIdTokenCredential(idTokenEntity, result.correlationId, kmsi);
            // Store accessToken in native internal storage
            await this.nativeInternalStorage.setAccessTokenCredential(accessTokenEntity, result.correlationId, kmsi, additionalCacheKeyHash);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     * @param apiId
     * @param accountId
     * @param cacheLookupPolicy
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        /*
         * Callers always normalize correlationId onto the request before delegating
         * here, so it is guaranteed defined and is the single id used to key this
         * flow's telemetry.
         */ const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0b9y3p", correlationId);
        if (!this.platformAuthProvider) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$nativeConnectionNotEstablished, correlationId);
        const nativeClient = new $9ed9a547f6786bdc$var$PlatformAuthInteractionClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, correlationId, this.tokenBindingKeyManager);
        return $9ed9a547f6786bdc$var$invokeAsync(nativeClient.acquireToken.bind(nativeClient), $9ed9a547f6786bdc$var$NativeInteractionClientAcquireToken, this.logger, this.performanceClient, correlationId)(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1n9lbl", correlationId);
        if (!this.platformAuthProvider) {
            this.logger.trace("0vnu11", correlationId);
            return false;
        }
        if (!$9ed9a547f6786bdc$var$isPlatformAuthAllowed(this.config, this.logger, correlationId, this.platformAuthProvider, request.authenticationScheme)) {
            this.logger.trace("0yoy1g", correlationId);
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case $9ed9a547f6786bdc$var$PromptValue$1.NONE:
            case $9ed9a547f6786bdc$var$PromptValue$1.CONSENT:
            case $9ed9a547f6786bdc$var$PromptValue$1.LOGIN:
                this.logger.trace("0vdv8e", correlationId);
                break;
            default:
                this.logger.trace(`0pdzw6 ${request.prompt}`, correlationId);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("16lbtk", correlationId);
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || (!request.loginHint && !request.sid ? this.getActiveAccount() : null);
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new $9ed9a547f6786bdc$var$PopupClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForPopupResponse, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new $9ed9a547f6786bdc$var$RedirectClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new $9ed9a547f6786bdc$var$SilentIframeClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9ed9a547f6786bdc$var$ApiId.ssoSilent, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForIframeResponse, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new $9ed9a547f6786bdc$var$SilentCacheClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new $9ed9a547f6786bdc$var$SilentRefreshClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new $9ed9a547f6786bdc$var$SilentAuthCodeClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9ed9a547f6786bdc$var$ApiId.acquireTokenByCode, this.performanceClient, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        $9ed9a547f6786bdc$var$blockNonBrowserEnvironment();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return $9ed9a547f6786bdc$var$createNewGuid();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return "";
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0lz9hf", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || $9ed9a547f6786bdc$var$DEFAULT_REQUEST
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0qw7v5", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || $9ed9a547f6786bdc$var$DEFAULT_REQUEST
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        $9ed9a547f6786bdc$var$preflightCheck(this.initialized, atsMeasurement, this.config, request);
        this.logger.verbose("0x1c4s", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$noAccountError, correlationId);
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                isNativeBroker: result.fromPlatformBroker ?? false,
                fromCache: result.fromCache,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof $9ed9a547f6786bdc$var$AuthError) // Ensures PWB scenarios can correctly match request to response
            error.correlationId = correlationId;
            atsMeasurement.end({
                success: false
            }, error, account);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const thumbprint = $9ed9a547f6786bdc$var$getRequestThumbprint(this.config.auth.clientId, {
            ...request,
            authority: request.authority || this.config.auth.authority
        }, account.homeAccountId);
        const silentRequestKey = JSON.stringify(thumbprint);
        const inProgressRequest = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("0fcjbk", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenSilentAsync.bind(this), $9ed9a547f6786bdc$var$AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account);
            this.activeSilentTokenRequests.set(silentRequestKey, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
            });
        } else {
            this.logger.verbose("1yq7nb", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackStateChange = (event)=>this.trackStateChange(request.correlationId, event);
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, request.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        }, request.correlationId);
        this.addStateChangeListeners(trackStateChange);
        const silentRequest = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$initializeSilentRequest, $9ed9a547f6786bdc$var$InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || $9ed9a547f6786bdc$var$CacheLookupPolicy.Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $9ed9a547f6786bdc$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                const silentRefreshReason = `${refreshTokenError.errorCode}${refreshTokenError.subError ? `|${refreshTokenError.subError}` : ""}`;
                this.performanceClient.addFields({
                    silentRefreshReason: silentRefreshReason
                }, request.correlationId);
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("0rh08z", silentRequest.correlationId);
                    return $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenBySilentIframe.bind(this), $9ed9a547f6786bdc$var$AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== $9ed9a547f6786bdc$var$CacheLookupPolicy.Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`1w8fso ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`0ywzzi ${activeCorrelationId}`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`17y14q ${activeCorrelationId}`, silentRequest.correlationId);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("1bd4p8", silentRequest.correlationId);
                    return $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenBySilentIframe.bind(this), $9ed9a547f6786bdc$var$AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, request.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromPlatformBroker ?? false
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, request.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(trackStateChange);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ($9ed9a547f6786bdc$var$isPlatformAuthAllowed(this.config, this.logger, silentRequest.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("0sczo4", silentRequest.correlationId);
            this.performanceClient.addFields({
                isPlatformBrokerRequest: true
            }, silentRequest.correlationId);
            return this.acquireTokenNative(silentRequest, $9ed9a547f6786bdc$var$ApiId.acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof $9ed9a547f6786bdc$var$NativeAuthError && $9ed9a547f6786bdc$var$isFatalNativeAuthError(e)) {
                    this.logger.verbose("07rkmb", silentRequest.correlationId);
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$tokenRefreshRequired, silentRequest.correlationId);
                }
                throw e;
            });
        } else {
            this.logger.verbose("0ox81t", silentRequest.correlationId);
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessToken) this.logger.verbose("0fvwxe", silentRequest.correlationId);
            return $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenFromCache.bind(this), $9ed9a547f6786bdc$var$AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessToken) throw cacheError;
                this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_NETWORK_START, silentRequest.correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, silentRequest);
                return $9ed9a547f6786bdc$var$invokeAsync(this.acquireTokenByRefreshToken.bind(this), $9ed9a547f6786bdc$var$AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("1x6uj6", correlationId);
        this.pkceCode = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$generatePkceCodes, $9ed9a547f6786bdc$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        if (res) this.logger.verbose("12js1o", correlationId);
        else this.logger.verbose("1oe9ci", correlationId);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent, correlationId) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("1qtz3l", correlationId);
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        $9ed9a547f6786bdc$var$collectInstanceStats(clientId, performanceEvent, this.logger, correlationId);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $9ed9a547f6786bdc$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof $9ed9a547f6786bdc$var$InteractionRequiredAuthError && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== $9ed9a547f6786bdc$var$badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === $9ed9a547f6786bdc$var$BrowserConstants.INVALID_GRANT_ERROR || refreshTokenError.errorCode === $9ed9a547f6786bdc$var$tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === $9ed9a547f6786bdc$var$noTokensFound || refreshTokenError.errorCode === $9ed9a547f6786bdc$var$refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = $9ed9a547f6786bdc$var$iFrameRenewalPolicies.includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $9ed9a547f6786bdc$var$BaseOperatingContext {
    static loggerCallback(level, message) {
        switch(level){
            case $9ed9a547f6786bdc$export$243e62d78d3b544d.Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case $9ed9a547f6786bdc$export$243e62d78d3b544d.Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case $9ed9a547f6786bdc$export$243e62d78d3b544d.Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case $9ed9a547f6786bdc$export$243e62d78d3b544d.Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config, responseHandlers){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = $9ed9a547f6786bdc$var$buildConfiguration(config, this.browserEnvironment);
        this.responseHandlers = responseHandlers;
        let sessionStorage;
        try {
            sessionStorage = window[$9ed9a547f6786bdc$var$BrowserCacheLocation.SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem($9ed9a547f6786bdc$var$LOG_LEVEL_CACHE_KEY);
        const piiLoggingKey = sessionStorage?.getItem($9ed9a547f6786bdc$var$LOG_PII_CACHE_KEY)?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys($9ed9a547f6786bdc$export$243e62d78d3b544d).includes(logLevelKey) ? $9ed9a547f6786bdc$export$243e62d78d3b544d[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $9ed9a547f6786bdc$var$BaseOperatingContext.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new $9ed9a547f6786bdc$var$Logger(loggerOptions, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the internal response handlers supplied by PublicClientApplication, if any.
     * @returns AuthResponseHandlers | undefined
     */ getResponseHandlers() {
        return this.responseHandlers;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$StandardOperatingContext extends $9ed9a547f6786bdc$var$BaseOperatingContext {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $9ed9a547f6786bdc$var$StandardOperatingContext.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $9ed9a547f6786bdc$var$StandardOperatingContext.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async initialize(correlationId) {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $9ed9a547f6786bdc$var$StandardOperatingContext.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $9ed9a547f6786bdc$var$StandardOperatingContext.ID = "StandardOperatingContext";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9ed9a547f6786bdc$var$isBridgeError(error) {
    return error.status !== undefined;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$BridgeStatusCode = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Unified error taxonomy shared by NAA and PWB.
 *
 * Each code maps to exactly one of the four base MSAL error classes
 * (`AuthError`, `ClientAuthError`, `ServerError`,
 * `InteractionRequiredAuthError`) via `toAuthError` in
 * `./WebBrokerBridgeErrorMap`.
 */ const $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode = {
    /* Interaction / auth outcomes */ UserInteractionRequired: "user_interaction_required",
    UserCanceled: "user_canceled",
    /* Environment / connectivity */ NoNetwork: "no_network",
    AccountUnavailable: "account_unavailable",
    BridgeDisabled: "bridge_disabled",
    BridgeUnavailable: "bridge_unavailable",
    /* Server-side outcomes */ TransientError: "transient_error",
    PersistentError: "persistent_error",
    /* Broker-channel failures */ BridgeTimeout: "bridge_timeout",
    BridgeHandshakeFailed: "bridge_handshake_failed",
    BridgeConnectionReset: "bridge_connection_reset",
    BridgeResponseInvalid: "bridge_response_invalid",
    PopupWillRedirect: "popup_will_redirect",
    ShrGenerationError: "shr_generation_error",
    /* Fallback */ Unknown: "unknown"
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Lift a normalized `WebBrokerBridgeError` to one of the four base
 * MSAL error classes. Callers are responsible for lowering
 * transport-specific errors into `WebBrokerBridgeError` before calling
 * this function.
 */ function $9ed9a547f6786bdc$var$toAuthError(err) {
    const correlationId = err.correlationId ?? "";
    switch(err.code){
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.UserInteractionRequired:
            return new $9ed9a547f6786bdc$var$InteractionRequiredAuthError(err.innerErrorCode || "", correlationId, err.description, err.subError);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.TransientError:
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.PersistentError:
            return new $9ed9a547f6786bdc$var$ServerError(err.innerErrorCode || "", correlationId, err.description, err.subError);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.UserCanceled:
            return new $9ed9a547f6786bdc$var$ClientAuthError($9ed9a547f6786bdc$var$userCanceled, correlationId);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.NoNetwork:
            return new $9ed9a547f6786bdc$var$ClientAuthError($9ed9a547f6786bdc$var$noNetworkConnectivity$1, correlationId);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.AccountUnavailable:
            return new $9ed9a547f6786bdc$var$ClientAuthError($9ed9a547f6786bdc$var$noAccountFound, correlationId);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeDisabled:
            return new $9ed9a547f6786bdc$var$ClientAuthError($9ed9a547f6786bdc$var$nestedAppAuthBridgeDisabled, correlationId);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeUnavailable:
            /*
             * NAA parity: pass through inner code when the broker supplied
             * one, otherwise fall back to the disabled code.
             */ return new $9ed9a547f6786bdc$var$ClientAuthError(err.innerErrorCode || $9ed9a547f6786bdc$var$nestedAppAuthBridgeDisabled, correlationId, err.description);
        /*
         * PWB broker-channel failures. The common code doubles as the
         * concrete errorCode on AuthError so the original error identity
         * can be recovered by round-tripping the string.
         */ case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeTimeout:
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeHandshakeFailed:
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeConnectionReset:
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeResponseInvalid:
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.PopupWillRedirect:
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.ShrGenerationError:
            return new $9ed9a547f6786bdc$var$AuthError(err.code, correlationId, err.description, err.subError);
        case $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.Unknown:
        default:
            return new $9ed9a547f6786bdc$var$AuthError(err.innerErrorCode || "unknown_error", correlationId, err.description || "An unknown error occurred", err.subError);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$NestedAppAuthAdapter {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = $9ed9a547f6786bdc$var$buildMergedClaims$1(request.claims, this.clientCapabilities);
        const scopes = request.scopes || $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1;
        const attributeTokens = $9ed9a547f6786bdc$var$serializeAttributeTokens(request.attributeTokens);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            resource: request.resource,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !$9ed9a547f6786bdc$var$StringUtils.isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER,
            extraParameters: extraParams,
            attributeTokens: attributeTokens
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$nullOrEmptyToken, request.correlationId);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = $9ed9a547f6786bdc$var$toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(response.token.id_token, this.crypto.base64Decode, request.correlationId);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        /*
         * In B2C scenarios tid may not be present, use getTenantIdFromIdTokenClaims
         * which handles tid, tfp (modern B2C), and acr (legacy B2C) claims
         */ const tenantId = fromAccount.tenantId || $9ed9a547f6786bdc$var$getTenantIdFromIdTokenClaims(effectiveIdTokenClaims) || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        // Validate environment - required field
        const environment = fromAccount.environment;
        if (!environment) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$invalidCacheEnvironment, "");
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = effectiveIdTokenClaims?.preferred_username || effectiveIdTokenClaims?.upn;
        const email = effectiveIdTokenClaims?.emails?.[0] || null;
        const username = fromAccount.username || preferredUsername || email || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name || "";
        const loginHint = fromAccount.loginHint || effectiveIdTokenClaims?.login_hint;
        const tenantProfiles = new Map();
        const tenantProfile = $9ed9a547f6786bdc$var$buildTenantProfile(homeAccountId, localAccountId, tenantId, fromAccount.platformBrokerId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            loginHint: loginHint,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            nativeAccountId: fromAccount.platformBrokerId,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ($9ed9a547f6786bdc$var$isBridgeError(error)) return $9ed9a547f6786bdc$var$toAuthError($9ed9a547f6786bdc$var$bridgeErrorToWebBrokerBridgeError(error));
        return new $9ed9a547f6786bdc$var$AuthError("unknown_error", "", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw $9ed9a547f6786bdc$var$createClientAuthError($9ed9a547f6786bdc$var$nullOrEmptyToken, correlationId);
        const idTokenClaims = $9ed9a547f6786bdc$var$extractTokenClaims(idToken.secret, this.crypto.base64Decode, correlationId);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: $9ed9a547f6786bdc$var$toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: $9ed9a547f6786bdc$var$toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || $9ed9a547f6786bdc$var$AuthenticationScheme$1.BEARER,
            correlationId: correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}
/**
 * Converts NAA `BridgeError` into the shared `WebBrokerBridgeError`
 * taxonomy.
 */ function $9ed9a547f6786bdc$var$bridgeErrorToWebBrokerBridgeError(error) {
    switch(error.status){
        case $9ed9a547f6786bdc$var$BridgeStatusCode.UserCancel:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.UserCanceled
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.NoNetwork:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.NoNetwork
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.AccountUnavailable:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.AccountUnavailable
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.Disabled:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeDisabled
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.NestedAppAuthUnavailable:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.BridgeUnavailable,
                innerErrorCode: error.code,
                description: error.description
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.TransientError:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.TransientError,
                innerErrorCode: error.code,
                description: error.description
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.PersistentError:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.PersistentError,
                innerErrorCode: error.code,
                description: error.description
            };
        case $9ed9a547f6786bdc$var$BridgeStatusCode.UserInteractionRequired:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.UserInteractionRequired,
                innerErrorCode: error.code,
                description: error.description
            };
        default:
            return {
                code: $9ed9a547f6786bdc$var$WebBrokerBridgeErrorCode.Unknown,
                innerErrorCode: error.code,
                description: error.description
            };
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$NestedAppAuthError extends $9ed9a547f6786bdc$var$AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, $9ed9a547f6786bdc$var$NestedAppAuthError.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError(correlationId) {
        /*
         * Some controller stubs (perf callbacks, getPerformanceClient, getRedirectResponse)
         * have no request param and thus no correlationId to forward
         */ return new $9ed9a547f6786bdc$var$NestedAppAuthError($9ed9a547f6786bdc$var$unsupportedMethod, correlationId || "");
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$NestedAppAuthController {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new $9ed9a547f6786bdc$var$CryptoOps(this.logger, this.performanceClient, true) : $9ed9a547f6786bdc$var$DEFAULT_CRYPTO_IMPLEMENTATION;
        const tokenBindingKeyManager = operatingContext.isBrowserEnvironment() ? new $9ed9a547f6786bdc$var$TokenBindingKeyManager(this.logger, this.performanceClient) : $9ed9a547f6786bdc$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER;
        this.eventHandler = new $9ed9a547f6786bdc$var$EventHandler(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new $9ed9a547f6786bdc$var$BrowserCacheManager(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, $9ed9a547f6786bdc$var$buildStaticAuthorityOptions(this.config.auth), tokenBindingKeyManager) : $9ed9a547f6786bdc$var$DEFAULT_BROWSER_CACHE_MANAGER(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler, undefined, tokenBindingKeyManager);
        this.nestedAppAuthAdapter = new $9ed9a547f6786bdc$var$NestedAppAuthAdapter(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $9ed9a547f6786bdc$var$NestedAppAuthController(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || $9ed9a547f6786bdc$var$createNewGuid();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || $9ed9a547f6786bdc$var$createNewGuid();
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            $9ed9a547f6786bdc$var$enforceResourceParameter(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = $9ed9a547f6786bdc$var$nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof $9ed9a547f6786bdc$var$AuthError ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || $9ed9a547f6786bdc$var$createNewGuid();
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$SsoSilent, correlationId);
        ssoSilentMeasurement.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement.add({
            nestedAppAuthRequest: true
        });
        try {
            $9ed9a547f6786bdc$var$enforceResourceParameter(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            naaRequest.forceRefresh = validRequest.forceRefresh;
            const reqTimestamp = $9ed9a547f6786bdc$var$nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof $9ed9a547f6786bdc$var$AuthError ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const correlationId = request.correlationId || $9ed9a547f6786bdc$var$createNewGuid();
        const atsMeasurement = this.performanceClient.startMeasurement($9ed9a547f6786bdc$var$AcquireTokenSilent, correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("11t57w", correlationId);
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("1ovnmo", correlationId);
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = $9ed9a547f6786bdc$var$CacheLookupPolicy.Default;
        switch(request.cacheLookupPolicy){
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.Default:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessToken:
            case $9ed9a547f6786bdc$var$CacheLookupPolicy.AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, result);
            atsMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atsMeasurement.end({
                success: true
            }, undefined, result.account);
            return result;
        }
        this.logger.warning("1yb4fi", correlationId);
        this.eventHandler.emitEvent($9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Silent, null);
        atsMeasurement.end({
            success: false
        }, undefined, request.account);
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        const correlationId = request.correlationId || $9ed9a547f6786bdc$var$createNewGuid();
        let currentAccount = null;
        if (accountContext) currentAccount = $9ed9a547f6786bdc$var$getAccount(accountContext, this.logger, this.browserStorage, correlationId);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("10qnr0", correlationId);
            return Promise.resolve(null);
        }
        this.logger.verbose("1u7hux", correlationId);
        const authRequest = {
            ...request,
            correlationId: correlationId,
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...$9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("03vm49", correlationId);
            return Promise.resolve(null);
        } else if ($9ed9a547f6786bdc$var$wasClockTurnedBack(cachedAccessToken.cachedAt) || $9ed9a547f6786bdc$var$isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("18egye", correlationId);
            return Promise.resolve(null);
        } else if (authRequest.resource) {
            const requestedResource = authRequest.resource;
            const cachedResource = cachedAccessToken.resource;
            if (!cachedResource || cachedResource !== requestedResource) {
                this.logger.verbose("0qraxd", correlationId);
                return Promise.resolve(null);
            }
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId);
        if (!cachedIdToken) {
            this.logger.verbose("0d68kd", correlationId);
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ acquireTokenRedirect(request) {
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError(request?.correlationId);
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ acquireTokenByCode(request) {
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError(request?.correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        // No request context: callback registration is not per-request
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        // No request context: callback registration is not per-request
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return $9ed9a547f6786bdc$var$getAllAccounts(this.logger, this.browserStorage, this.isBrowserEnv(), $9ed9a547f6786bdc$var$createNewGuid(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return $9ed9a547f6786bdc$var$getAccount(accountFilter, this.logger, this.browserStorage, $9ed9a547f6786bdc$var$createNewGuid());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ return $9ed9a547f6786bdc$var$setActiveAccount(account, this.browserStorage, $9ed9a547f6786bdc$var$createNewGuid());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return $9ed9a547f6786bdc$var$getActiveAccount(this.browserStorage, $9ed9a547f6786bdc$var$createNewGuid());
    }
    // #endregion
    handleRedirectPromise(options // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || $9ed9a547f6786bdc$var$DEFAULT_REQUEST);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError(request?.correlationId);
    }
    logoutRedirect(logoutRequest) {
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError(logoutRequest?.correlationId);
    }
    logoutPopup(logoutRequest) {
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError(logoutRequest?.correlationId);
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("1k8729", "");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        // Accessor stub with no request context
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError();
    }
    getRedirectResponse() {
        // Accessor stub with no request context
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw $9ed9a547f6786bdc$var$NestedAppAuthError.createUnsupportedError(logoutRequest?.correlationId);
    }
    async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        const accountEntity = $9ed9a547f6786bdc$var$createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, $9ed9a547f6786bdc$var$isKmsi(result.idTokenClaims), $9ed9a547f6786bdc$var$ApiId.hydrateCache);
        return this.browserStorage.hydrateCache(result, request);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Correlates outbound requests with inbound responses by `requestId`.
 */ class $9ed9a547f6786bdc$var$PendingRequestRegistry {
    constructor(){
        this.pending = new Map();
    }
    /**
     * Register a pending request. Returns a promise that resolves when a
     * response with the matching `requestId` arrives, or rejects if the
     * caller invokes `reject` for that id.
     */ register(requestId) {
        return new Promise((resolve, reject)=>{
            this.pending.set(requestId, {
                resolve: resolve,
                reject: reject
            });
        });
    }
    /** Resolve a pending request. No-op if `requestId` isn't registered. */ resolve(requestId, response) {
        const entry = this.pending.get(requestId);
        if (entry === undefined) return;
        this.pending.delete(requestId);
        entry.resolve(response);
    }
    /** Reject a pending request. No-op if `requestId` isn't registered. */ reject(requestId, reason) {
        const entry = this.pending.get(requestId);
        if (entry === undefined) return;
        this.pending.delete(requestId);
        entry.reject(reason);
    }
    /** True if `requestId` has an in-flight registration. */ has(requestId) {
        return this.pending.has(requestId);
    }
    /**
     * Register, then invoke `send` synchronously. If `send` throws, the
     * pending entry is cleared and the promise rejects with the thrown
     * error.
     */ async sendAndAwait(message, send) {
        const promise = this.register(message.requestId);
        try {
            send(message);
        } catch (err) {
            this.reject(message.requestId, err);
        }
        return promise;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $9ed9a547f6786bdc$var$BridgeProxy {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                if (responseEnvelope.success) $9ed9a547f6786bdc$var$BridgeProxy.pendingRegistry.resolve(responseEnvelope.requestId, responseEnvelope);
                else $9ed9a547f6786bdc$var$BridgeProxy.pendingRegistry.reject(responseEnvelope.requestId, responseEnvelope.error);
            });
            const bridgeResponse = await $9ed9a547f6786bdc$var$BridgeProxy.sendRequestViaRegistry($9ed9a547f6786bdc$var$BridgeProxy.buildRequest("GetInitContext"));
            return $9ed9a547f6786bdc$var$BridgeProxy.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $9ed9a547f6786bdc$var$BridgeProxy.validateBridgeResultOrThrow(result.token),
            account: $9ed9a547f6786bdc$var$BridgeProxy.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: $9ed9a547f6786bdc$var$createNewGuid(),
            sendTime: Date.now(),
            clientLibrary: $9ed9a547f6786bdc$var$BrowserConstants.MSAL_SKU,
            clientLibraryVersion: $9ed9a547f6786bdc$var$version,
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        return $9ed9a547f6786bdc$var$BridgeProxy.sendRequestViaRegistry($9ed9a547f6786bdc$var$BridgeProxy.buildRequest(method, requestParams));
    }
    /**
     * Registers `message.requestId` with the shared pending-request
     * registry, then posts the envelope over the host bridge. Resolves
     * with the matching response envelope; rejects with the raw
     * `BridgeError` payload.
     */ static sendRequestViaRegistry(message) {
        const correlationKey = {
            requestId: message.requestId,
            type: message.method
        };
        return $9ed9a547f6786bdc$var$BridgeProxy.pendingRegistry.sendAndAwait(correlationKey, ()=>{
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: $9ed9a547f6786bdc$var$BridgeStatusCode.NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $9ed9a547f6786bdc$var$BridgeProxy.initializeNestedAppAuthBridge();
        return new $9ed9a547f6786bdc$var$BridgeProxy(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
/**
 * Correlates outbound bridge requests with inbound responses by
 * `requestId`
 */ $9ed9a547f6786bdc$var$BridgeProxy.pendingRegistry = new $9ed9a547f6786bdc$var$PendingRequestRegistry();
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$NestedAppOperatingContext extends $9ed9a547f6786bdc$var$BaseOperatingContext {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $9ed9a547f6786bdc$var$NestedAppOperatingContext.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $9ed9a547f6786bdc$var$NestedAppOperatingContext.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @param correlationId
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize(correlationId) {
        const cid = correlationId || "";
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await $9ed9a547f6786bdc$var$BridgeProxy.create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`1mdxyj ${ex}`, cid);
        }
        this.logger.info(`12jy9a ${this.available}`, cid);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $9ed9a547f6786bdc$var$NestedAppOperatingContext.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $9ed9a547f6786bdc$var$NestedAppOperatingContext.ID = "NestedAppOperatingContext";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $9ed9a547f6786bdc$var$PublicClientApplication {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new $9ed9a547f6786bdc$var$StandardController(new $9ed9a547f6786bdc$var$StandardOperatingContext(configuration, {
            waitForPopupResponse: this.waitForPopupResponse.bind(this),
            waitForIframeResponse: this.waitForIframeResponse.bind(this)
        }));
    }
    /**
     * Waits for the auth response from a popup window opened by MSAL.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param request The in-flight authorization or end-session request.
     * @param popupWindow The popup window opened by MSAL.
     * @param popupWindowParent The parent window that opened the popup.
     */ async waitForPopupResponse(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popupWindow, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    popupWindowParent) {
        const controller = this.controller;
        return $9ed9a547f6786bdc$var$waitForBridgeResponse(controller.getConfiguration().system.popupBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient());
    }
    /**
     * Waits for the auth response from a hidden iframe used by MSAL silent flows.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param iframe The hidden iframe MSAL attached to the document.
     * @param request The in-flight authorization request.
     */ async waitForIframeResponse(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    iframe, request) {
        const controller = this.controller;
        const config = controller.getConfiguration();
        return $9ed9a547f6786bdc$var$waitForBridgeResponse(config.system.iframeBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient(), config.experimental);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(options) {
        return this.controller.handleRedirectPromise(options);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @param correlationId
 * @param pcaFactory
 * @returns IPublicClientApplication
 *
 */ async function $9ed9a547f6786bdc$var$createNestablePublicClientApplication(configuration, correlationId, pcaFactory) {
    const nestedAppAuth = new $9ed9a547f6786bdc$var$NestedAppOperatingContext(configuration);
    await nestedAppAuth.initialize(correlationId);
    if (nestedAppAuth.isAvailable()) {
        const cid = correlationId || $9ed9a547f6786bdc$var$createNewGuid();
        const controller = new $9ed9a547f6786bdc$var$NestedAppAuthController(nestedAppAuth);
        const nestablePCA = pcaFactory ? pcaFactory(configuration, controller) : new $9ed9a547f6786bdc$var$PublicClientApplication(configuration, controller);
        await nestablePCA.initialize({
            correlationId: cid
        });
        return nestablePCA;
    }
    return $9ed9a547f6786bdc$var$createStandardPublicClientApplication(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $9ed9a547f6786bdc$var$createStandardPublicClientApplication(configuration) {
    const pca = new $9ed9a547f6786bdc$var$PublicClientApplication(configuration);
    await pca.initialize();
    return pca;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9ed9a547f6786bdc$var$stubbedPublicClientApplication = {
    initialize: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    loginPopup: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    loginRedirect: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    logoutRedirect: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    logoutPopup: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    ssoSilent: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    getLogger: ()=>{
        throw $9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, "");
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw $9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, "");
    },
    hydrateCache: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    },
    clearCache: ()=>{
        return Promise.reject($9ed9a547f6786bdc$var$createBrowserConfigurationAuthError($9ed9a547f6786bdc$var$stubbedPublicClientApplicationCalled, ""));
    }
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * API to load tokens to msal-browser cache.
 * @param config - Object to configure the MSAL app.
 * @param request - Silent request containing authority, scopes, and account.
 * @param response - External token response to load into the cache.
 * @param options - Options controlling how tokens are loaded into the cache.
 * @param performanceClient - Optional performance client used for telemetry measurements.
 * @returns `AuthenticationResult` for the response that was loaded.
 */ async function $9ed9a547f6786bdc$var$loadExternalTokens(config, request, response, options, performanceClient = new $9ed9a547f6786bdc$var$StubPerformanceClient()) {
    $9ed9a547f6786bdc$var$blockNonBrowserEnvironment();
    const browserConfig = $9ed9a547f6786bdc$var$buildConfiguration(config, true);
    const correlationId = request.correlationId || $9ed9a547f6786bdc$var$createNewGuid();
    const rootMeasurement = performanceClient.startMeasurement($9ed9a547f6786bdc$var$LoadExternalTokens, correlationId);
    try {
        const idTokenClaims = response.id_token ? $9ed9a547f6786bdc$var$extractTokenClaims(response.id_token, $9ed9a547f6786bdc$var$base64Decode, correlationId) : undefined;
        const kmsi = $9ed9a547f6786bdc$var$isKmsi(idTokenClaims || {});
        const authorityOptions = {
            protocolMode: browserConfig.system.protocolMode,
            knownAuthorities: browserConfig.auth.knownAuthorities,
            cloudDiscoveryMetadata: browserConfig.auth.cloudDiscoveryMetadata,
            authorityMetadata: browserConfig.auth.authorityMetadata
        };
        const logger = new $9ed9a547f6786bdc$var$Logger(browserConfig.system.loggerOptions || {}, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
        const cryptoOps = new $9ed9a547f6786bdc$var$CryptoOps(logger, browserConfig.telemetry.client);
        const storage = new $9ed9a547f6786bdc$var$BrowserCacheManager(browserConfig.auth.clientId, browserConfig.cache, cryptoOps, logger, browserConfig.telemetry.client, new $9ed9a547f6786bdc$var$EventHandler(logger), $9ed9a547f6786bdc$var$buildStaticAuthorityOptions(browserConfig.auth), new $9ed9a547f6786bdc$var$TokenBindingKeyManager(logger, browserConfig.telemetry.client));
        await storage.initialize(correlationId);
        const authorityString = request.authority || browserConfig.auth.authority;
        const authority = await $9ed9a547f6786bdc$var$createDiscoveredInstance($9ed9a547f6786bdc$var$Authority.generateAuthority(authorityString, request.azureCloudOptions), browserConfig.system.networkClient, storage, authorityOptions, logger, correlationId, performanceClient);
        const cacheRecordAccount = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$loadAccount, $9ed9a547f6786bdc$var$LoadAccount, logger, performanceClient, correlationId)(request, options.clientInfo || response.client_info || "", correlationId, storage, logger, cryptoOps, authority, idTokenClaims, performanceClient);
        const idToken = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$loadIdToken, $9ed9a547f6786bdc$var$LoadIdToken, logger, performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, kmsi, correlationId, storage, logger, config.auth.clientId);
        const accessToken = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$loadAccessToken, $9ed9a547f6786bdc$var$LoadAccessToken, logger, performanceClient, correlationId)(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, kmsi, options, correlationId, storage, logger, config.auth.clientId);
        const refreshToken = await $9ed9a547f6786bdc$var$invokeAsync($9ed9a547f6786bdc$var$loadRefreshToken, $9ed9a547f6786bdc$var$LoadRefreshToken, logger, performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, kmsi, correlationId, storage, logger, config.auth.clientId, performanceClient);
        rootMeasurement.end({
            success: true
        }, undefined, $9ed9a547f6786bdc$var$getAccountInfo(cacheRecordAccount));
        return $9ed9a547f6786bdc$var$generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, authority, idTokenClaims);
    } catch (error) {
        rootMeasurement.end({
            success: false
        }, error);
        throw error;
    }
}
/**
 * Helper function to load account to msal-browser cache
 * @param idToken
 * @param environment
 * @param clientInfo
 * @param authorityType
 * @param requestHomeAccountId
 * @returns `AccountEntity`
 */ async function $9ed9a547f6786bdc$var$loadAccount(request, clientInfo, correlationId, storage, logger, cryptoObj, authority, idTokenClaims, performanceClient) {
    logger.verbose("0ke46k", correlationId);
    if (request.account) {
        const accountEntity = $9ed9a547f6786bdc$var$createAccountEntityFromAccountInfo(request.account);
        await storage.setAccount(accountEntity, correlationId, $9ed9a547f6786bdc$var$isKmsi(idTokenClaims || {}), $9ed9a547f6786bdc$var$ApiId.loadExternalTokens);
        return accountEntity;
    } else if (!clientInfo && !idTokenClaims) {
        logger.error("0hzcn4", correlationId);
        throw $9ed9a547f6786bdc$var$createBrowserAuthError($9ed9a547f6786bdc$var$unableToLoadToken, "");
    }
    const homeAccountId = $9ed9a547f6786bdc$var$generateHomeAccountId(clientInfo, authority.authorityType, logger, cryptoObj, correlationId, idTokenClaims);
    const claimsTenantId = idTokenClaims?.tid;
    const cachedAccount = $9ed9a547f6786bdc$var$buildAccountToCache(storage, authority, homeAccountId, $9ed9a547f6786bdc$var$base64Decode, correlationId, idTokenClaims, clientInfo, authority.getPreferredCache(), claimsTenantId, undefined, undefined, logger, performanceClient);
    await storage.setAccount(cachedAccount, correlationId, $9ed9a547f6786bdc$var$isKmsi(idTokenClaims || {}), $9ed9a547f6786bdc$var$ApiId.loadExternalTokens);
    return cachedAccount;
}
/**
 * Helper function to load id tokens to msal-browser cache
 * @param idToken
 * @param homeAccountId
 * @param environment
 * @param tenantId
 * @returns `IdTokenEntity`
 */ async function $9ed9a547f6786bdc$var$loadIdToken(response, homeAccountId, environment, tenantId, kmsi, correlationId, storage, logger, clientId) {
    if (!response.id_token) {
        logger.verbose("1pm7g1", correlationId);
        return null;
    }
    logger.verbose("168lyi", correlationId);
    const idTokenEntity = $9ed9a547f6786bdc$var$createIdTokenEntity(homeAccountId, environment, response.id_token, clientId, tenantId);
    await storage.setIdTokenCredential(idTokenEntity, correlationId, kmsi);
    return idTokenEntity;
}
/**
 * Helper function to load access tokens to msal-browser cache
 * @param request
 * @param response
 * @param homeAccountId
 * @param environment
 * @param tenantId
 * @returns `AccessTokenEntity`
 */ async function $9ed9a547f6786bdc$var$loadAccessToken(request, response, homeAccountId, environment, tenantId, kmsi, options, correlationId, storage, logger, clientId) {
    if (!response.access_token) {
        logger.verbose("1ckp9e", correlationId);
        return null;
    } else if (!response.expires_in) {
        logger.error("15mzx8", correlationId);
        return null;
    } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
        logger.error("1h7xse", correlationId);
        return null;
    }
    logger.verbose("01kmxb", correlationId);
    const scopes = response.scope ? $9ed9a547f6786bdc$var$ScopeSet.fromString(response.scope, correlationId) : new $9ed9a547f6786bdc$var$ScopeSet(request.scopes, correlationId);
    const expiresOn = options.expiresOn || response.expires_in + $9ed9a547f6786bdc$var$nowSeconds();
    const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + $9ed9a547f6786bdc$var$nowSeconds();
    const accessTokenEntity = $9ed9a547f6786bdc$var$createAccessTokenEntity(homeAccountId, environment, response.access_token, clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, $9ed9a547f6786bdc$var$base64Decode, correlationId);
    await storage.setAccessTokenCredential(accessTokenEntity, correlationId, kmsi);
    return accessTokenEntity;
}
/**
 * Helper function to load refresh tokens to msal-browser cache
 * @param request
 * @param response
 * @param homeAccountId
 * @param environment
 * @returns `RefreshTokenEntity`
 */ async function $9ed9a547f6786bdc$var$loadRefreshToken(response, homeAccountId, environment, kmsi, correlationId, storage, logger, clientId, performanceClient) {
    if (!response.refresh_token) {
        logger.verbose("1l7um5", correlationId);
        return null;
    }
    const expiresOn = response.refresh_token_expires_in ? response.refresh_token_expires_in + $9ed9a547f6786bdc$var$nowSeconds() : undefined;
    performanceClient.addFields({
        extRtExpiresOnSeconds: expiresOn
    }, correlationId);
    logger.verbose("0qy8ev", correlationId);
    const refreshTokenEntity = $9ed9a547f6786bdc$var$createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, clientId, response.foci, undefined, expiresOn);
    await storage.setRefreshTokenCredential(refreshTokenEntity, correlationId, kmsi);
    return refreshTokenEntity;
}
/**
 * Helper function to generate an `AuthenticationResult` for the result.
 * @param request
 * @param idTokenObj
 * @param cacheRecord
 * @param authority
 * @returns `AuthenticationResult`
 */ function $9ed9a547f6786bdc$var$generateAuthenticationResult(request, cacheRecord, authority, idTokenClaims) {
    let accessToken = "";
    let responseScopes = [];
    let expiresOn = null;
    let extExpiresOn;
    if (cacheRecord?.accessToken) {
        accessToken = cacheRecord.accessToken.secret;
        responseScopes = $9ed9a547f6786bdc$var$ScopeSet.fromString(cacheRecord.accessToken.target, request.correlationId || "").asArray();
        // Access token expiresOn stored in seconds, converting to Date for AuthenticationResult
        expiresOn = $9ed9a547f6786bdc$var$toDateFromSeconds(cacheRecord.accessToken.expiresOn);
        extExpiresOn = $9ed9a547f6786bdc$var$toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
    }
    const accountEntity = cacheRecord.account;
    return {
        authority: authority.canonicalAuthority,
        uniqueId: cacheRecord.account.localAccountId,
        tenantId: cacheRecord.account.realm,
        scopes: responseScopes,
        account: $9ed9a547f6786bdc$var$getAccountInfo(accountEntity),
        idToken: cacheRecord.idToken?.secret || "",
        idTokenClaims: idTokenClaims || {},
        accessToken: accessToken,
        fromCache: true,
        expiresOn: expiresOn,
        correlationId: request.correlationId || "",
        requestId: "",
        extExpiresOn: extExpiresOn,
        familyId: cacheRecord.refreshToken?.familyId || "",
        tokenType: cacheRecord?.accessToken?.tokenType || "",
        state: request.state || "",
        cloudGraphHostName: accountEntity.cloudGraphHostName || "",
        msGraphHost: accountEntity.msGraphHost || "",
        fromPlatformBroker: false
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$EventMessageUtils {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case $9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_START:
                if (message.interactionType === $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect || message.interactionType === $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup) return $9ed9a547f6786bdc$var$InteractionStatus.AcquireToken;
                break;
            case $9ed9a547f6786bdc$var$EventType.HANDLE_REDIRECT_START:
                return $9ed9a547f6786bdc$var$InteractionStatus.HandleRedirect;
            case $9ed9a547f6786bdc$var$EventType.LOGOUT_START:
                return $9ed9a547f6786bdc$var$InteractionStatus.Logout;
            case $9ed9a547f6786bdc$var$EventType.LOGOUT_END:
                if (currentStatus && currentStatus !== $9ed9a547f6786bdc$var$InteractionStatus.Logout) break;
                return $9ed9a547f6786bdc$var$InteractionStatus.None;
            case $9ed9a547f6786bdc$var$EventType.HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== $9ed9a547f6786bdc$var$InteractionStatus.HandleRedirect) break;
                return $9ed9a547f6786bdc$var$InteractionStatus.None;
            case $9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_SUCCESS:
            case $9ed9a547f6786bdc$var$EventType.ACQUIRE_TOKEN_FAILURE:
            case $9ed9a547f6786bdc$var$EventType.RESTORE_FROM_BFCACHE:
                if (message.interactionType === $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Redirect || message.interactionType === $9ed9a547f6786bdc$export$4ec29255e7e7f68f.Popup) {
                    if (currentStatus && currentStatus !== $9ed9a547f6786bdc$var$InteractionStatus.AcquireToken) break;
                    return $9ed9a547f6786bdc$var$InteractionStatus.None;
                }
                break;
        }
        return null;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$SignedHttpRequest {
    constructor(shrParameters, shrOptions){
        const loggerOptions = shrOptions && shrOptions.loggerOptions || {};
        this.logger = new $9ed9a547f6786bdc$var$Logger(loggerOptions, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version);
        this.cryptoOps = new $9ed9a547f6786bdc$var$CryptoOps(this.logger);
        const tokenBindingKeyManager = new $9ed9a547f6786bdc$var$TokenBindingKeyManager(this.logger);
        this.popTokenGenerator = new $9ed9a547f6786bdc$var$PopTokenGenerator(this.cryptoOps, tokenBindingKeyManager, new $9ed9a547f6786bdc$var$StubPerformanceClient());
        this.shrParameters = shrParameters;
    }
    /**
     * Generates and caches a keypair for the given request options.
     * @returns Public key digest, which should be sent to the token issuer.
     */ async generatePublicKeyThumbprint() {
        const { kid: kid } = await this.popTokenGenerator.generateKid(this.shrParameters);
        return kid;
    }
    /**
     * Generates a signed http request for the given payload with the given key.
     * @param payload Payload to sign (e.g. access token)
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param claims Additional claims to include/override in the signed JWT
     * @returns Pop token signed with the corresponding private key
     */ async signRequest(payload, publicKeyThumbprint, claims) {
        return this.popTokenGenerator.signPayload(payload, publicKeyThumbprint, this.shrParameters, claims);
    }
    /**
     * Removes cached keys from browser for given public key thumbprint
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param correlationId
     * @returns If keys are properly deleted
     */ async removeKeys(publicKeyThumbprint, correlationId) {
        return this.cryptoOps.removeTokenBindingKey(publicKeyThumbprint, correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns browser performance measurement module if session flag is enabled. Returns undefined otherwise.
 */ function $9ed9a547f6786bdc$var$getPerfMeasurementModule() {
    let sessionStorage;
    try {
        sessionStorage = window[$9ed9a547f6786bdc$var$BrowserCacheLocation.SessionStorage];
        const perfEnabled = sessionStorage?.getItem($9ed9a547f6786bdc$var$BROWSER_PERF_ENABLED_KEY);
        if (Number(perfEnabled) === 1) return Promise.resolve().then(function() {
            return $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement$1;
        });
    // Mute errors if it's a non-browser environment or cookies are blocked.
    } catch (e) {}
    return undefined;
}
/**
 * Returns boolean, indicating whether browser supports window.performance.now() function.
 */ function $9ed9a547f6786bdc$var$supportsBrowserPerformanceNow() {
    return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.now === "function";
}
/**
 * Returns event duration in milliseconds using window performance API if available. Returns undefined otherwise.
 * @param startTime {DOMHighResTimeStamp | undefined}
 * @returns {number | undefined}
 */ function $9ed9a547f6786bdc$var$getPerfDurationMs(startTime) {
    if (!startTime || !$9ed9a547f6786bdc$var$supportsBrowserPerformanceNow()) return undefined;
    return Math.round(window.performance.now() - startTime);
}
class $9ed9a547f6786bdc$var$BrowserPerformanceClient extends $9ed9a547f6786bdc$var$PerformanceClient {
    constructor(configuration, intFields){
        super(configuration.auth.clientId, configuration.auth.authority || `${$9ed9a547f6786bdc$var$DEFAULT_AUTHORITY}`, new $9ed9a547f6786bdc$var$Logger(configuration.system?.loggerOptions || {}, $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version), $9ed9a547f6786bdc$var$name, $9ed9a547f6786bdc$var$version, configuration.telemetry?.application || {
            appName: "",
            appVersion: ""
        }, intFields);
    }
    generateId() {
        return $9ed9a547f6786bdc$var$createNewGuid();
    }
    getPageVisibility() {
        return document.visibilityState?.toString() || null;
    }
    getOnlineStatus() {
        return typeof navigator !== "undefined" ? navigator.onLine : null;
    }
    deleteIncompleteSubMeasurements(inProgressEvent) {
        $9ed9a547f6786bdc$var$getPerfMeasurementModule()?.then((module)=>{
            const rootEvent = this.eventsByCorrelationId.get(inProgressEvent.event.correlationId);
            const isRootEvent = rootEvent && rootEvent.eventId === inProgressEvent.event.eventId;
            const incompleteMeasurements = [];
            if (isRootEvent && rootEvent?.incompleteSubMeasurements) rootEvent.incompleteSubMeasurements.forEach((subMeasurement)=>{
                incompleteMeasurements.push({
                    ...subMeasurement
                });
            });
            // Clean up remaining marks for incomplete sub-measurements
            module.BrowserPerformanceMeasurement.flushMeasurements(inProgressEvent.event.correlationId, incompleteMeasurements);
        });
    }
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     * Also captures browser page visibilityState.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {((event?: Partial<PerformanceEvent>) => PerformanceEvent| null)}
     */ startMeasurement(measureName, correlationId) {
        // Capture page visibilityState and then invoke start/end measurement
        const startPageVisibility = this.getPageVisibility();
        const startOnlineStatus = this.getOnlineStatus();
        const inProgressEvent = super.startMeasurement(measureName, correlationId);
        const startTime = $9ed9a547f6786bdc$var$supportsBrowserPerformanceNow() ? window.performance.now() : undefined;
        const browserMeasurement = $9ed9a547f6786bdc$var$getPerfMeasurementModule()?.then((module)=>{
            return new module.BrowserPerformanceMeasurement(measureName, inProgressEvent.event.correlationId);
        });
        browserMeasurement?.then((measurement)=>measurement.startMeasurement());
        return {
            ...inProgressEvent,
            end: (event, error, account)=>{
                const networkInfo = $9ed9a547f6786bdc$var$getNetworkInfo();
                const res = inProgressEvent.end({
                    ...event,
                    startPageVisibility: startPageVisibility,
                    startOnlineStatus: startOnlineStatus,
                    endPageVisibility: this.getPageVisibility(),
                    durationMs: $9ed9a547f6786bdc$var$getPerfDurationMs(startTime),
                    networkEffectiveType: networkInfo.effectiveType,
                    networkRtt: networkInfo.rtt
                }, error, account);
                browserMeasurement?.then((measurement)=>measurement.endMeasurement());
                this.deleteIncompleteSubMeasurements(inProgressEvent);
                return res;
            },
            discard: ()=>{
                inProgressEvent.discard();
                browserMeasurement?.then((measurement)=>measurement.flushMeasurement());
                this.deleteIncompleteSubMeasurements(inProgressEvent);
            }
        };
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement {
    constructor(name, correlationId){
        this.correlationId = correlationId;
        this.measureName = $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.makeMeasureName(name, correlationId);
        this.startMark = $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.makeStartMark(name, correlationId);
        this.endMark = $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.makeEndMark(name, correlationId);
    }
    static makeMeasureName(name, correlationId) {
        return `msal.measure.${name}.${correlationId}`;
    }
    static makeStartMark(name, correlationId) {
        return `msal.start.${name}.${correlationId}`;
    }
    static makeEndMark(name, correlationId) {
        return `msal.end.${name}.${correlationId}`;
    }
    static supportsBrowserPerformance() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.mark === "function" && typeof window.performance.measure === "function" && typeof window.performance.clearMarks === "function" && typeof window.performance.clearMeasures === "function" && typeof window.performance.getEntriesByName === "function";
    }
    /**
     * Flush browser marks and measurements.
     * @param {string} correlationId
     * @param {SubMeasurement} measurements
     */ static flushMeasurements(correlationId, measurements) {
        if ($9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            measurements.forEach((measurement)=>{
                const measureName = $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.makeMeasureName(measurement.name, correlationId);
                const entriesForMeasurement = window.performance.getEntriesByName(measureName, "measure");
                if (entriesForMeasurement.length > 0) {
                    window.performance.clearMeasures(measureName);
                    window.performance.clearMarks($9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.makeStartMark(measureName, correlationId));
                    window.performance.clearMarks($9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.makeEndMark(measureName, correlationId));
                }
            });
        } catch (e) {
        // Silently catch and return null
        }
    }
    startMeasurement() {
        if ($9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.startMark);
        } catch (e) {
        // Silently catch
        }
    }
    endMeasurement() {
        if ($9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.endMark);
            window.performance.measure(this.measureName, this.startMark, this.endMark);
        } catch (e) {
        // Silently catch
        }
    }
    flushMeasurement() {
        if ($9ed9a547f6786bdc$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            const entriesForMeasurement = window.performance.getEntriesByName(this.measureName, "measure");
            if (entriesForMeasurement.length > 0) {
                const durationMs = entriesForMeasurement[0].duration;
                window.performance.clearMeasures(this.measureName);
                window.performance.clearMarks(this.startMark);
                window.performance.clearMarks(this.endMark);
                return durationMs;
            }
        } catch (e) {
        // Silently catch and return null
        }
        return null;
    }
}
var $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BrowserPerformanceMeasurement: $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @packageDocumentation
 * @module @azure/msal-browser
 */ // Common constants
const $9ed9a547f6786bdc$var$AuthenticationScheme = $9ed9a547f6786bdc$var$AuthenticationScheme$1;
const $9ed9a547f6786bdc$var$ResponseMode = $9ed9a547f6786bdc$var$ResponseMode$1;
const $9ed9a547f6786bdc$var$PromptValue = $9ed9a547f6786bdc$var$PromptValue$1;
const $9ed9a547f6786bdc$var$JsonWebTokenTypes = $9ed9a547f6786bdc$var$JsonWebTokenTypes$1;
const $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES = $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES$1;
$9ed9a547f6786bdc$export$192d74ad69b40705 = $9ed9a547f6786bdc$var$ApiId;
$9ed9a547f6786bdc$export$145273558d58e0ac = $9ed9a547f6786bdc$var$AuthError;
$9ed9a547f6786bdc$export$473ab0b56598aacd = $9ed9a547f6786bdc$var$AuthErrorCodes;
$9ed9a547f6786bdc$export$46f6771f16bdfbc6 = $9ed9a547f6786bdc$var$AuthenticationHeaderParser;
$9ed9a547f6786bdc$export$901491a717da2ba5 = $9ed9a547f6786bdc$var$AuthenticationScheme;
$9ed9a547f6786bdc$export$4cda21933050d9ec = $9ed9a547f6786bdc$var$AzureCloudInstance;
$9ed9a547f6786bdc$export$f8eb6760ca13876a = $9ed9a547f6786bdc$var$BrowserAuthError;
$9ed9a547f6786bdc$export$a206205e46059d69 = $9ed9a547f6786bdc$var$BrowserAuthErrorCodes;
$9ed9a547f6786bdc$export$573384e47a12d835 = $9ed9a547f6786bdc$var$BrowserCacheLocation;
$9ed9a547f6786bdc$export$2eb7a1dfdc4c5fba = $9ed9a547f6786bdc$var$BrowserConfigurationAuthError;
$9ed9a547f6786bdc$export$5b6860c1e1ad8019 = $9ed9a547f6786bdc$var$BrowserConfigurationAuthErrorCodes;
$9ed9a547f6786bdc$export$3714d85cfc8f4a02 = $9ed9a547f6786bdc$var$BrowserPerformanceClient;
$9ed9a547f6786bdc$export$f97b8b5459a3aa4 = $9ed9a547f6786bdc$var$BrowserPerformanceMeasurement;
$9ed9a547f6786bdc$export$2ae77374159d4955 = $9ed9a547f6786bdc$var$BrowserRootPerformanceEvents;
$9ed9a547f6786bdc$export$311899ae85124b2d = $9ed9a547f6786bdc$var$BrowserUtils;
$9ed9a547f6786bdc$export$4394baa7e922d42d = $9ed9a547f6786bdc$var$CacheLookupPolicy;
$9ed9a547f6786bdc$export$a839ff85a7957561 = $9ed9a547f6786bdc$var$ClientAuthError;
$9ed9a547f6786bdc$export$dc9623d93fc077da = $9ed9a547f6786bdc$var$ClientAuthErrorCodes;
$9ed9a547f6786bdc$export$ac9d9d20c2327339 = $9ed9a547f6786bdc$var$ClientConfigurationError;
$9ed9a547f6786bdc$export$5fde068af21a5dfb = $9ed9a547f6786bdc$var$ClientConfigurationErrorCodes;
$9ed9a547f6786bdc$export$f3ffe700be354b19 = $9ed9a547f6786bdc$var$DEFAULT_IFRAME_TIMEOUT_MS;
$9ed9a547f6786bdc$export$ce0ba2422a1c7815 = $9ed9a547f6786bdc$var$EventHandler;
$9ed9a547f6786bdc$export$ba9166e03da6599c = $9ed9a547f6786bdc$var$EventMessageUtils;
$9ed9a547f6786bdc$export$3d7865934588d77e = $9ed9a547f6786bdc$var$EventType;
$9ed9a547f6786bdc$export$6ba3e818c6bc76ba = $9ed9a547f6786bdc$var$InteractionRequiredAuthError;
$9ed9a547f6786bdc$export$ecddfe385fe09c26 = $9ed9a547f6786bdc$var$InteractionRequiredAuthErrorCodes;
$9ed9a547f6786bdc$export$bec20eda0179362b = $9ed9a547f6786bdc$var$InteractionStatus;
$9ed9a547f6786bdc$export$fe5c42ed17efe603 = $9ed9a547f6786bdc$var$JsonWebTokenTypes;
$9ed9a547f6786bdc$export$19fffca37ef3e106 = $9ed9a547f6786bdc$var$LocalStorage;
$9ed9a547f6786bdc$export$efa9a398d6368992 = $9ed9a547f6786bdc$var$Logger;
$9ed9a547f6786bdc$export$d7392285c701ecf5 = $9ed9a547f6786bdc$var$MemoryStorage;
$9ed9a547f6786bdc$export$d0d362a73d466c9b = $9ed9a547f6786bdc$var$NavigationClient;
$9ed9a547f6786bdc$export$893b1b5b686d84ef = $9ed9a547f6786bdc$var$OIDC_DEFAULT_SCOPES;
$9ed9a547f6786bdc$export$49a06cbda5acaa5 = $9ed9a547f6786bdc$var$PromptValue;
$9ed9a547f6786bdc$export$73a3e3dedd37150d = $9ed9a547f6786bdc$var$ProtocolMode;
$9ed9a547f6786bdc$export$89f4855ef88b7920 = $9ed9a547f6786bdc$var$PublicClientApplication;
$9ed9a547f6786bdc$export$f990a5bae1260b8c = $9ed9a547f6786bdc$var$ResponseMode;
$9ed9a547f6786bdc$export$ea52035eac03daf0 = $9ed9a547f6786bdc$var$ServerError;
$9ed9a547f6786bdc$export$2c4b17e1c2e0931 = $9ed9a547f6786bdc$var$SessionStorage;
$9ed9a547f6786bdc$export$e1f04f41501741ea = $9ed9a547f6786bdc$var$SignedHttpRequest;
$9ed9a547f6786bdc$export$c70f2989a65fda3e = $9ed9a547f6786bdc$var$StubPerformanceClient;
$9ed9a547f6786bdc$export$8abb9de997bb4e44 = $9ed9a547f6786bdc$var$WrapperSKU;
$9ed9a547f6786bdc$export$210078d2745a65ac = $9ed9a547f6786bdc$var$createNestablePublicClientApplication;
$9ed9a547f6786bdc$export$f28b97cfb2f3098 = $9ed9a547f6786bdc$var$createStandardPublicClientApplication;
$9ed9a547f6786bdc$export$df47a28b08fa2370 = $9ed9a547f6786bdc$var$enforceResourceParameter;
$9ed9a547f6786bdc$export$bce61db0d62ff8e2 = $9ed9a547f6786bdc$var$isPlatformBrokerAvailable;
$9ed9a547f6786bdc$export$267894f3740f96bf = $9ed9a547f6786bdc$var$loadExternalTokens;
$9ed9a547f6786bdc$export$29650b96fd06034a = $9ed9a547f6786bdc$var$stubbedPublicClientApplication;
$9ed9a547f6786bdc$export$83d89fbfd8236492 = $9ed9a547f6786bdc$var$version; //# sourceMappingURL=msal-browser.cjs.map

});


parcelRegister("hPlgS", function(module, exports) {

$parcel$export(module.exports, "appSettingsContextReducer", function () { return $fa10936fb2ca30ca$export$8a7b894edd181779; });

var $b4LrQ = parcelRequire("b4LrQ");

var $9Jgpw = parcelRequire("9Jgpw");

var $dDC3L = parcelRequire("dDC3L");

var $b0Sri = parcelRequire("b0Sri");

var $8EyAa = parcelRequire("8EyAa");
/**
 * Internal reducer state slice holding the hierarchy and ToC sub-states.
 * App-level settings are not managed by this reducer — they are derived
 * from loader data in {@link AppSettingsContextProvider}.
 */ /** Set of all operation strings that belong to the hierarchy domain */ const $fa10936fb2ca30ca$var$hierarchyOperationSet = new Set([
    (0, $9Jgpw.ADD_DOMAIN_REPLACEMENT),
    (0, $9Jgpw.ADD_HIERARCHY_NODES),
    (0, $9Jgpw.ADD_SINGLE_REPLACEMENT),
    (0, $9Jgpw.CLEAR_HIERARCHY),
    (0, $9Jgpw.LOAD_HIERARCHY),
    (0, $9Jgpw.LOAD_CLINICAL_LIBRARY),
    (0, $9Jgpw.PATCH_HIERARCHY_COMMENTS),
    (0, $9Jgpw.REMOVE_DOMAIN_REPLACEMENT),
    (0, $9Jgpw.REMOVE_HIERARCHY_COMMENT),
    (0, $9Jgpw.REMOVE_HIERARCHY_NODE),
    (0, $9Jgpw.REMOVE_SINGLE_REPLACEMENT),
    (0, $9Jgpw.SAVE_HIERARCHY),
    (0, $9Jgpw.SAVE_HIERARCHY_COMPLETED),
    (0, $9Jgpw.SAVE_HIERARCHY_FAILED),
    (0, $9Jgpw.SAVE_TOC_MAJOR_VERSION),
    (0, $9Jgpw.SET_ACCESS_RIGHTS),
    (0, $9Jgpw.SET_CLINICAL_LIBRARY_LOADING),
    (0, $9Jgpw.SET_HIERARCHY_COMMENT_PANEL),
    (0, $9Jgpw.SET_HIERARCHY_ID),
    (0, $9Jgpw.SET_HIERARCHY_NAME_SAVE_BLOCKER),
    (0, $9Jgpw.SET_HIERARCHY_SAVE_REQUEST_STATUS),
    (0, $9Jgpw.SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS),
    (0, $9Jgpw.SET_HIERARCHY_SUBSCRIPTION_STATUS),
    (0, $9Jgpw.UPDATE_DOMAIN_REPLACEMENT),
    (0, $9Jgpw.UPDATE_HIERARCHY),
    (0, $9Jgpw.UPDATE_HIERARCHY_COMMENT),
    (0, $9Jgpw.UPDATE_SINGLE_REPLACEMENT),
    (0, $9Jgpw.UPDATE_TLF_ITEM_INDEX)
]);
/** Set of operation strings that belong to the TLF domain. */ const $fa10936fb2ca30ca$var$tlfOperationSet = new Set([
    (0, $dDC3L.ADD_RECEIVED_MESSAGE),
    (0, $dDC3L.APPLY_ARS_UPDATES),
    (0, $dDC3L.CLEAR_TLF),
    (0, $dDC3L.DISCARD_ARS_UPDATES),
    (0, $dDC3L.CLOSE_MODAL_WINDOW),
    (0, $dDC3L.LOAD_TLF),
    (0, $dDC3L.PATCH_TLF_COMMENTS),
    (0, $dDC3L.PROCESS_SIGNALR_NOTIFICATION),
    (0, $dDC3L.REDO_TLF_CHANGE),
    (0, $dDC3L.REMOVE_TLF_COMMENT),
    (0, $dDC3L.SET_DELAYED_HIERARCHY_UPDATES),
    (0, $dDC3L.SET_EDITOR_BLOCKS_SEARCH_PANEL),
    (0, $dDC3L.SET_TLF_REQUEST_STATUS),
    (0, $dDC3L.SET_TLF_REQUEST_STATUS),
    (0, $dDC3L.SET_TLF_COMMENT_PANEL),
    (0, $dDC3L.SET_TLF_READ_ONLY),
    (0, $dDC3L.SET_TLF_SUBSCRIPTION_STATUS),
    (0, $dDC3L.SET_VIEW_MODE),
    (0, $dDC3L.SHOW_MODAL_WINDOW),
    (0, $dDC3L.TOGGLE_TRAFFIC_LIGHTS),
    (0, $dDC3L.UNDO_TLF_CHANGE),
    (0, $dDC3L.UPDATE_TLF),
    (0, $dDC3L.UPDATE_TLF_COMMENT)
]);
const $fa10936fb2ca30ca$export$44fc53dd087087eb = (action)=>$fa10936fb2ca30ca$var$hierarchyOperationSet.has(action.operation);
const $fa10936fb2ca30ca$export$d166174244e8d1db = (action)=>$fa10936fb2ca30ca$var$tlfOperationSet.has(action.operation);
const $fa10936fb2ca30ca$export$8a7b894edd181779 = (state, action)=>{
    if ($fa10936fb2ca30ca$export$44fc53dd087087eb(action)) return {
        ...state,
        hierarchyState: (0, $b4LrQ.hierarchyContextReducer)(state.hierarchyState, action)
    };
    if ($fa10936fb2ca30ca$export$d166174244e8d1db(action)) return {
        ...state,
        tlfState: (0, $b0Sri.tlfContextReducer)(state.tlfState, action)
    };
    return {
        ...state,
        tocState: (0, $8EyAa.tocContextReducer)(state.tocState, action)
    };
};

});
parcelRegister("b4LrQ", function(module, exports) {

$parcel$export(module.exports, "hierarchyContextReducer", function () { return $c6396d913e185cb0$export$838445f5c4442b47; });
parcelRequire("jv0dr");
var $j8NNh = parcelRequire("j8NNh");
var $577bh = parcelRequire("577bh");
var $hIQPm = parcelRequire("hIQPm");
var $snn47 = parcelRequire("snn47");
var $jhVng = parcelRequire("jhVng");
var $i5TEl = parcelRequire("i5TEl");
var $6a54O = parcelRequire("6a54O");
var $dMLQD = parcelRequire("dMLQD");
var $mBTCv = parcelRequire("mBTCv");
var $dU5i9 = parcelRequire("dU5i9");
var $9ijz0 = parcelRequire("9ijz0");
var $fGSHE = parcelRequire("fGSHE");
var $51kMy = parcelRequire("51kMy");
var $4oUWJ = parcelRequire("4oUWJ");
var $5YqWX = parcelRequire("5YqWX");
var $9nYQ2 = parcelRequire("9nYQ2");
var $5Ieiq = parcelRequire("5Ieiq");
var $3RrHT = parcelRequire("3RrHT");
var $6oA8K = parcelRequire("6oA8K");
var $9rt0F = parcelRequire("9rt0F");
var $7upe4 = parcelRequire("7upe4");
var $jWkMB = parcelRequire("jWkMB");
var $d39cI = parcelRequire("d39cI");
var $1T8QL = parcelRequire("1T8QL");
var $atbJz = parcelRequire("atbJz");
var $iNVjQ = parcelRequire("iNVjQ");
var $2w1A4 = parcelRequire("2w1A4");
var $6F3sl = parcelRequire("6F3sl");

var $9Jgpw = parcelRequire("9Jgpw");
const $c6396d913e185cb0$export$838445f5c4442b47 = (state, action)=>{
    switch(action.operation){
        case 0, $9Jgpw.ADD_DOMAIN_REPLACEMENT:
            return (0, $j8NNh.hcr_addDomainReplacement)(state, action);
        case 0, $9Jgpw.ADD_HIERARCHY_NODES:
            return (0, $577bh.hcr_addHierarchyNodes)(state, action);
        case 0, $9Jgpw.ADD_SINGLE_REPLACEMENT:
            return (0, $hIQPm.hcr_addSingleReplacement)(state, action);
        case 0, $9Jgpw.CLEAR_HIERARCHY:
            return (0, $snn47.hcr_clearHierarchy)(state);
        case 0, $9Jgpw.LOAD_HIERARCHY:
            return (0, $i5TEl.hcr_loadHierarchy)(state, action);
        case 0, $9Jgpw.LOAD_CLINICAL_LIBRARY:
            return (0, $jhVng.hcr_loadClinicalLibrary)(state, action);
        case 0, $9Jgpw.PATCH_HIERARCHY_COMMENTS:
            return (0, $6a54O.hcr_patchHierarchyComments)(state, action);
        case 0, $9Jgpw.REMOVE_DOMAIN_REPLACEMENT:
            return (0, $dMLQD.hcr_removeDomainReplacement)(state, action);
        case 0, $9Jgpw.REMOVE_HIERARCHY_COMMENT:
            return (0, $mBTCv.hcr_removeHierarchyComment)(state, action);
        case 0, $9Jgpw.REMOVE_HIERARCHY_NODE:
            return (0, $dU5i9.hcr_removeHierarchyNode)(state, action);
        case 0, $9Jgpw.REMOVE_SINGLE_REPLACEMENT:
            return (0, $9ijz0.hcr_removeSingleReplacement)(state, action);
        case 0, $9Jgpw.SAVE_HIERARCHY:
            return (0, $fGSHE.hcr_saveHierarchy)(state, action);
        case 0, $9Jgpw.SAVE_HIERARCHY_COMPLETED:
            return (0, $51kMy.hcr_saveHierarchyCompleted)(state, action);
        case 0, $9Jgpw.SAVE_HIERARCHY_FAILED:
            return (0, $4oUWJ.hcr_saveHierarchyFailed)(state);
        case 0, $9Jgpw.SAVE_TOC_MAJOR_VERSION:
            return (0, $5YqWX.hcr_saveTocMajorVersion)(state, action);
        case 0, $9Jgpw.SET_CLINICAL_LIBRARY_LOADING:
            return (0, $5Ieiq.hcr_setClinicalLibraryLoading)(state, action);
        case 0, $9Jgpw.SET_HIERARCHY_SAVE_REQUEST_STATUS:
            return (0, $7upe4.hcr_setHierarchySaveRequestStatus)(state, action);
        case 0, $9Jgpw.SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS:
            return (0, $jWkMB.hcr_setHierarchySaveTocRequestStatus)(state, action);
        case 0, $9Jgpw.SET_ACCESS_RIGHTS:
            return (0, $9nYQ2.hcr_setAccessRights)(state, action);
        case 0, $9Jgpw.SET_HIERARCHY_COMMENT_PANEL:
            return (0, $3RrHT.hcr_setHierarchyCommentPanel)(state, action);
        case 0, $9Jgpw.SET_HIERARCHY_ID:
            return (0, $6oA8K.hcr_setHierarchyId)(state, action);
        case 0, $9Jgpw.SET_HIERARCHY_NAME_SAVE_BLOCKER:
            return (0, $9rt0F.hcr_setHierarchyNameSaveBlocker)(state, action);
        case 0, $9Jgpw.UPDATE_DOMAIN_REPLACEMENT:
            return (0, $1T8QL.hcr_updateDomainReplacement)(state, action);
        case 0, $9Jgpw.UPDATE_HIERARCHY:
            return (0, $atbJz.hcr_updateHierarchy)(state, action);
        case 0, $9Jgpw.UPDATE_HIERARCHY_COMMENT:
            return (0, $iNVjQ.hcr_updateHierarchyComment)(state, action);
        case 0, $9Jgpw.UPDATE_SINGLE_REPLACEMENT:
            return (0, $2w1A4.hcr_updateSingleReplacements)(state, action);
        case 0, $9Jgpw.UPDATE_TLF_ITEM_INDEX:
            return (0, $6F3sl.hcr_updateTlfItemIndex)(state, action);
        case 0, $9Jgpw.SET_HIERARCHY_SUBSCRIPTION_STATUS:
            return (0, $d39cI.hcr_setHierarchySubscriptionStatus)(state, action);
    }
};

});
parcelRegister("jv0dr", function(module, exports) {
$parcel$export(module.exports, "hcr_addDomainReplacement", function () { return (parcelRequire("j8NNh")).hcr_addDomainReplacement; });
$parcel$export(module.exports, "hcr_addHierarchyNodes", function () { return (parcelRequire("577bh")).hcr_addHierarchyNodes; });
$parcel$export(module.exports, "hcr_addSingleReplacement", function () { return (parcelRequire("hIQPm")).hcr_addSingleReplacement; });
$parcel$export(module.exports, "hcr_clearHierarchy", function () { return (parcelRequire("snn47")).hcr_clearHierarchy; });
$parcel$export(module.exports, "hcr_loadClinicalLibrary", function () { return (parcelRequire("jhVng")).hcr_loadClinicalLibrary; });
$parcel$export(module.exports, "hcr_loadHierarchy", function () { return (parcelRequire("i5TEl")).hcr_loadHierarchy; });
$parcel$export(module.exports, "hcr_patchHierarchyComments", function () { return (parcelRequire("6a54O")).hcr_patchHierarchyComments; });
$parcel$export(module.exports, "hcr_removeDomainReplacement", function () { return (parcelRequire("dMLQD")).hcr_removeDomainReplacement; });
$parcel$export(module.exports, "hcr_removeHierarchyComment", function () { return (parcelRequire("mBTCv")).hcr_removeHierarchyComment; });
$parcel$export(module.exports, "hcr_removeHierarchyNode", function () { return (parcelRequire("dU5i9")).hcr_removeHierarchyNode; });
$parcel$export(module.exports, "hcr_removeSingleReplacement", function () { return (parcelRequire("9ijz0")).hcr_removeSingleReplacement; });
$parcel$export(module.exports, "hcr_saveHierarchy", function () { return (parcelRequire("fGSHE")).hcr_saveHierarchy; });
$parcel$export(module.exports, "hcr_saveHierarchyCompleted", function () { return (parcelRequire("51kMy")).hcr_saveHierarchyCompleted; });
$parcel$export(module.exports, "hcr_saveHierarchyFailed", function () { return (parcelRequire("4oUWJ")).hcr_saveHierarchyFailed; });
$parcel$export(module.exports, "hcr_saveTocMajorVersion", function () { return (parcelRequire("5YqWX")).hcr_saveTocMajorVersion; });
$parcel$export(module.exports, "hcr_setAccessRights", function () { return (parcelRequire("9nYQ2")).hcr_setAccessRights; });
$parcel$export(module.exports, "hcr_setClinicalLibraryLoading", function () { return (parcelRequire("5Ieiq")).hcr_setClinicalLibraryLoading; });
$parcel$export(module.exports, "hcr_setHierarchyCommentPanel", function () { return (parcelRequire("3RrHT")).hcr_setHierarchyCommentPanel; });
$parcel$export(module.exports, "hcr_setHierarchyId", function () { return (parcelRequire("6oA8K")).hcr_setHierarchyId; });
$parcel$export(module.exports, "hcr_setHierarchyNameSaveBlocker", function () { return (parcelRequire("9rt0F")).hcr_setHierarchyNameSaveBlocker; });
$parcel$export(module.exports, "hcr_setHierarchySaveRequestStatus", function () { return (parcelRequire("7upe4")).hcr_setHierarchySaveRequestStatus; });
$parcel$export(module.exports, "hcr_setHierarchySaveTocRequestStatus", function () { return (parcelRequire("jWkMB")).hcr_setHierarchySaveTocRequestStatus; });
$parcel$export(module.exports, "hcr_setHierarchySubscriptionStatus", function () { return (parcelRequire("d39cI")).hcr_setHierarchySubscriptionStatus; });
$parcel$export(module.exports, "hcr_updateDomainReplacement", function () { return (parcelRequire("1T8QL")).hcr_updateDomainReplacement; });
$parcel$export(module.exports, "hcr_updateHierarchy", function () { return (parcelRequire("atbJz")).hcr_updateHierarchy; });
$parcel$export(module.exports, "hcr_updateHierarchyComment", function () { return (parcelRequire("iNVjQ")).hcr_updateHierarchyComment; });
$parcel$export(module.exports, "hcr_updateSingleReplacements", function () { return (parcelRequire("2w1A4")).hcr_updateSingleReplacements; });
$parcel$export(module.exports, "hcr_updateTlfItemIndex", function () { return (parcelRequire("6F3sl")).hcr_updateTlfItemIndex; });
parcelRequire("j8NNh");
parcelRequire("577bh");
parcelRequire("hIQPm");
parcelRequire("3KKXH");
parcelRequire("3V2FF");
parcelRequire("snn47");
parcelRequire("jhVng");
parcelRequire("i5TEl");
parcelRequire("6a54O");
parcelRequire("dMLQD");
parcelRequire("mBTCv");
parcelRequire("dU5i9");
parcelRequire("9ijz0");
parcelRequire("fGSHE");
parcelRequire("51kMy");
parcelRequire("4oUWJ");
parcelRequire("5YqWX");
parcelRequire("9nYQ2");
parcelRequire("5Ieiq");
parcelRequire("3RrHT");
parcelRequire("6oA8K");
parcelRequire("9rt0F");
parcelRequire("7upe4");
parcelRequire("jWkMB");
parcelRequire("d39cI");
parcelRequire("lj90j");
parcelRequire("1T8QL");
parcelRequire("atbJz");
parcelRequire("iNVjQ");
parcelRequire("2w1A4");
parcelRequire("6F3sl");

});
parcelRegister("j8NNh", function(module, exports) {

$parcel$export(module.exports, "hcr_addDomainReplacement", function () { return $653dda9c348e26a5$export$79ada65322d17b0; });

var $3KKXH = parcelRequire("3KKXH");

var $lj90j = parcelRequire("lj90j");
const $653dda9c348e26a5$export$79ada65322d17b0 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $lj90j.hcr_updateChangedFlag)((0, $3KKXH.hcr_checkDRs)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            domainReplacements: [
                ...state.hierarchy.domainReplacements,
                action.domainReplacement
            ]
        }
    }), action);
};

});
parcelRegister("3KKXH", function(module, exports) {

$parcel$export(module.exports, "hcr_checkDRs", function () { return $a4f4687861ad4a46$export$eeaeab622222f087; });
const $a4f4687861ad4a46$export$eeaeab622222f087 = (state)=>{
    if (state.hierarchy) {
        const warnings = new Set();
        state.hierarchy.domainReplacements.forEach((dr)=>{
            if (dr.oldText === "") warnings.add({
                airid: dr.airid,
                warningText: "Missing text will be ignored"
            });
            if (state.hierarchy.domainReplacements.filter((o)=>o.domain === dr.domain && o.oldText === dr.oldText).length > 1) warnings.add({
                airid: dr.airid,
                warningText: "Duplicates will cause unpredictable results"
            });
            if (dr.oldText !== "" && dr.newText.lines.map((l)=>l.textBlocks.map((b)=>b.text).join("")).join("\n").includes(dr.oldText)) warnings.add({
                airid: dr.airid,
                warningText: "New text cannot contain the original text"
            });
        });
        return {
            ...state,
            saveBlockers: {
                ...state.saveBlockers,
                domainReplacements: warnings
            }
        };
    }
    return state;
};

});

parcelRegister("lj90j", function(module, exports) {

$parcel$export(module.exports, "hcr_updateChangedFlag", function () { return $f182f5ad9c28ab56$export$447b516ea97d3601; });

var $1iDss = parcelRequire("1iDss");

var $iQGjt = parcelRequire("iQGjt");

var $9Jgpw = parcelRequire("9Jgpw");
/**
 * Reducer operations that should recompute the changed flag from hierarchy diffs.
 */ const $f182f5ad9c28ab56$var$changedOperations = new Set([
    (0, $9Jgpw.ADD_DOMAIN_REPLACEMENT),
    (0, $9Jgpw.ADD_SINGLE_REPLACEMENT),
    (0, $9Jgpw.PATCH_HIERARCHY_COMMENTS),
    (0, $9Jgpw.REMOVE_DOMAIN_REPLACEMENT),
    (0, $9Jgpw.REMOVE_HIERARCHY_COMMENT),
    (0, $9Jgpw.REMOVE_SINGLE_REPLACEMENT),
    (0, $9Jgpw.UPDATE_DOMAIN_REPLACEMENT),
    (0, $9Jgpw.UPDATE_HIERARCHY),
    (0, $9Jgpw.UPDATE_HIERARCHY_COMMENT),
    (0, $9Jgpw.UPDATE_SINGLE_REPLACEMENT),
    (0, $9Jgpw.UPDATE_TLF_ITEM_INDEX)
]);
/**
 * Hierarchy fields excluded from changed-flag diffing because they are transient,
 * derived, or intentionally ignored by save-change detection.
 */ const $f182f5ad9c28ab56$var$changedIgnorePaths = [
    "comments",
    "tocMinorVersion",
    "sections",
    "children",
    "studyStandardsDate",
    "history",
    "clinicalLibrary"
];
const $f182f5ad9c28ab56$export$447b516ea97d3601 = (state, action)=>{
    if (action.operation === (0, $9Jgpw.LOAD_HIERARCHY) || action.operation === (0, $9Jgpw.SAVE_HIERARCHY) || action.operation === (0, $9Jgpw.SAVE_HIERARCHY_COMPLETED) || action.operation === (0, $9Jgpw.SAVE_HIERARCHY_FAILED) || action.operation === (0, $9Jgpw.SAVE_TOC_MAJOR_VERSION)) return state;
    if (!$f182f5ad9c28ab56$var$changedOperations.has(action.operation)) return {
        ...state,
        changed: state.changed
    };
    const changed = (0, $1iDss.getObjectDiff)((0, $iQGjt.omitDeep)(state.hierarchy, $f182f5ad9c28ab56$var$changedIgnorePaths), (0, $iQGjt.omitDeep)(state.savedHierarchy, $f182f5ad9c28ab56$var$changedIgnorePaths));
    return {
        ...state,
        changed: changed !== undefined
    };
};

});
parcelRegister("1iDss", function(module, exports) {

$parcel$export(module.exports, "EditorV3Content", function () { return $0f261471404994f4$export$1a4903393d6b1b7d; });
$parcel$export(module.exports, "isIEditorV3", function () { return $0f261471404994f4$export$a2e4f3e0d013ef9f; });
$parcel$export(module.exports, "stringToV3", function () { return $0f261471404994f4$export$4c11677f6b5bfb11; });
$parcel$export(module.exports, "EditorV3", function () { return $0f261471404994f4$export$c410cc7dbb67874b; });
$parcel$export(module.exports, "cleanIsEqual", function () { return $0f261471404994f4$export$501d19eb8a679b38; });
$parcel$export(module.exports, "splitV3intoLines", function () { return $0f261471404994f4$export$9046ef79d808c3d9; });
$parcel$export(module.exports, "joinV3intoBlock", function () { return $0f261471404994f4$export$6be11f3b04f364b4; });
$parcel$export(module.exports, "getObjectDiff", function () { return $0f261471404994f4$export$db8269090bd3dd4; });
$parcel$export(module.exports, "getTextFromEditorV3", function () { return $0f261471404994f4$export$59ffc450e12fbd65; });
$parcel$export(module.exports, "hasStylesToRemove", function () { return $0f261471404994f4$export$5bbd286e9783a47b; });
$parcel$export(module.exports, "removeStylesFromEditorV3", function () { return $0f261471404994f4$export$c4055ded8e1007ea; });
$parcel$export(module.exports, "replaceTextInEditorV3", function () { return $0f261471404994f4$export$4473dc511c49aabc; });
$parcel$export(module.exports, "searchEditorV3Content", function () { return $0f261471404994f4$export$458b3725b25c35e4; });


var $gSkQi = parcelRequire("gSkQi");

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");
function $0f261471404994f4$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $0f261471404994f4$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $0f261471404994f4$var$$805c218341f5a4f1$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$805c218341f5a4f1$exports, "EditorV3Align", ()=>$0f261471404994f4$export$e6890f8825213b0d);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$805c218341f5a4f1$exports, "EditorV3AtBlock", ()=>$0f261471404994f4$export$2762eb7a56f6d4be);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$805c218341f5a4f1$exports, "EditorV3Content", ()=>$0f261471404994f4$export$1a4903393d6b1b7d);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$805c218341f5a4f1$exports, "EditorV3Line", ()=>$0f261471404994f4$export$f727c5bfed9e77d4);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$805c218341f5a4f1$exports, "EditorV3TextBlock", ()=>$0f261471404994f4$export$4ed6c3ca0061f49b);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$805c218341f5a4f1$exports, "isIEditorV3", ()=>$0f261471404994f4$export$a2e4f3e0d013ef9f);
const $0f261471404994f4$var$$651e6b8a46a239ec$export$bb271ec44122dc39 = {
    defaultStyle: "defaultStyle",
    styleStartTag: "(~(",
    styleNameEndTag: "::",
    styleEndTag: ")~)",
    dropDownStartTag: "(\xac(",
    dropDownEndTag: ")\xac)",
    dropDownValueSeparator: "||",
    dropDownSelectedValueTag: "**",
    calcStartTag: "[![",
    calcNameEndTag: "::",
    calcEndTag: "]!]",
    calcConditionSeparator: "||",
    calcAndSeparator: "&&",
    atStartTag: "@[",
    atEndTag: "@]"
};
var $0f261471404994f4$export$e6890f8825213b0d = /*#__PURE__*/ function(EditorV3Align) {
    EditorV3Align["left"] = "left";
    EditorV3Align["center"] = "center";
    EditorV3Align["decimal"] = "decimal";
    EditorV3Align["right"] = "right";
    return EditorV3Align;
}({});
const $0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54 = {
    allowMarkdown: false,
    allowNewLine: false,
    allowWindowView: false,
    decimalAlignPercent: 60,
    markdownSettings: $0f261471404994f4$var$$651e6b8a46a239ec$export$bb271ec44122dc39,
    showMarkdown: false,
    styles: undefined,
    textAlignment: $0f261471404994f4$export$e6890f8825213b0d.left,
    atListFunction: undefined,
    maxAtListLength: 10
};
class $0f261471404994f4$export$4ed6c3ca0061f49b {
    /**
   * End character position of this text block in the containing line.
   * Calculated from `lineStartPosition` + visible character length of `text`.
   */ get lineEndPosition() {
        return this.lineStartPosition + this.text.replaceAll(/[\u2009-\u200f]/g, "").length;
    }
    /**
   * Unique merge key identifying adjacent blocks that can be coalesced.
   * Combines lock state, type, style and label to produce a stable string key.
   *
   * @returns string
   */ get mergeKey() {
        return `${this.isLocked ? this.lineStartPosition : "-"}:${this.type}:${this.style ?? ""}:${this.label ?? ""}`;
    }
    /**
   * Whether this block should be considered 'enhanced' (non-default)
   * i.e. it has a style, label or a non-default type.
   */ get isEnhanced() {
        return this.style !== undefined && this.style !== this._defaultContentProps.markdownSettings.defaultStyle || this.label !== undefined || this.type !== "text";
    }
    // Read only variables
    /**
   * Serialise this block to its plain data shape used by the EditorV3 model.
   *
   * @returns IEditorV3TextBlock
   */ get data() {
        return {
            text: this.text,
            label: this.label,
            style: this.style,
            type: this.type,
            isLocked: this.isLocked
        };
    }
    /**
   * Compute positions for each word within this block. Words inside locked
   * blocks return a locked position so caret logic can treat them atomically.
   */ get wordPositions() {
        const ret = [];
        let _counted = 0;
        if (this.isLocked) ret.push({
            line: -1,
            startChar: this.lineStartPosition,
            endChar: this.lineStartPosition + this.text.length,
            isLocked: true
        });
        else while(_counted < this.text.length && this.text.slice(_counted).search(/\S/) > -1){
            const remainingText = this.text.slice(_counted);
            const nextWord = remainingText.match(/\S+/);
            /* istanbul ignore else */ if (nextWord) {
                ret.push({
                    line: -1,
                    startChar: this.lineStartPosition + _counted + remainingText.search(/\S/),
                    endChar: this.lineStartPosition + _counted + remainingText.search(/\S/) + nextWord[0].length,
                    isLocked: false
                });
                _counted += remainingText.search(/\S/) + nextWord[0].length;
            }
        }
        return ret;
    }
    // Constructor
    /**
   * Construct a text block from a model, DOM element, fragment or plain text.
   *
   * @param arg - Optional source value: model object, `HTMLSpanElement`, `DocumentFragment` or plain string
   * @param forcedParams - Optional parameters to override parsed values
   */ constructor(arg, forcedParams){
        this._defaultContentProps = (0, $gSkQi.cloneDeep)($0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54);
        // Variables
        this.text = "";
        this.type = "text";
        this.isActive = false;
        this.isSelected = false;
        this.lineStartPosition = 0;
        // Update defaults if specified
        if (forcedParams?.markdownSettings) this._defaultContentProps.markdownSettings = forcedParams.markdownSettings;
        // Document Fragment processing
        if (arg instanceof DocumentFragment) {
            this.text = "";
            const errors = [];
            arg.childNodes.forEach((child, ix)=>{
                if (child instanceof Text || child instanceof HTMLSpanElement) {
                    const childData = this.fromHtml(child);
                    // Set parameters
                    if (ix === 0) {
                        this.text = childData.text;
                        this.label = childData.label;
                        this.style = childData.style;
                        this.type = childData.type;
                        this.isLocked = childData.isLocked;
                        this.lineStartPosition = childData.lineStartPosition ?? // istanbul ignore next
                        0;
                    } else {
                        if (childData.type !== this.type) errors.push("Multiple types in fragment");
                        if (childData.style !== this.style) errors.push("Multiple styles in fragment");
                        if (childData.isLocked !== this.isLocked) errors.push("Multiple isLocked in fragment");
                        this.text += childData.text;
                    }
                } else errors.push("Unknown node type in fragment");
            });
            if (errors.length > 0) throw new Error("EditorV3TextBlock:Constructor:" + errors.join(", "));
        } else if (typeof arg === "string") this.fromMarkdown(arg, this._defaultContentProps.markdownSettings);
        else if (arg instanceof HTMLSpanElement || arg instanceof Text) {
            const spanData = this.fromHtml(arg);
            this.text = spanData.text;
            this.label = spanData.label;
            this.style = spanData.style;
            this.type = spanData.type ?? "text";
            this.isLocked = spanData.isLocked;
            this.lineStartPosition = spanData.lineStartPosition ?? // istanbul ignore next
            0;
        } else {
            this.text = arg?.text.replaceAll(/[\r\n\t]/g, "") ?? "";
            this.label = arg?.label;
            this.style = arg?.style === "" ? undefined : arg?.style;
            this.type = arg?.type ?? "text";
            this.isLocked = arg?.isLocked;
            this.lineStartPosition = arg?.lineStartPosition ?? 0;
        }
        // Forced any parameters
        if (forcedParams) {
            if (forcedParams.label) this.label = forcedParams.label;
            if (forcedParams.style) this.style = forcedParams.style;
            if (forcedParams.isLocked) this.isLocked = forcedParams.isLocked;
            if (forcedParams.lineStartPosition) this.lineStartPosition = forcedParams.lineStartPosition;
        }
        if (this.type === undefined) this.type = "text";
    }
    // Protected functions
    /**
   * Parse an `HTMLSpanElement` or `Text` node into the block's data shape.
   *
   * @param arg - The source HTML span or text node
   */ fromHtml(arg) {
        const text = (arg.textContent ?? // istanbul ignore next
        "").replaceAll(/\u00a0/g, " ").replaceAll(/[\u2009-\u200f]/g, "");
        const spanData = {
            text: text,
            lineStartPosition: arg instanceof HTMLSpanElement && arg.dataset.lineStartPosition ? parseInt(arg.dataset.lineStartPosition) : 0,
            label: arg instanceof HTMLSpanElement && arg.title !== "" ? arg.title : undefined,
            style: arg instanceof HTMLSpanElement ? arg.dataset.styleName : undefined,
            type: arg instanceof HTMLSpanElement ? arg.dataset.type : "text",
            isLocked: arg instanceof HTMLSpanElement && arg.dataset.isLocked === "true" ? true : undefined
        };
        return spanData;
    }
    /**
   * Extract a style, label and bare text from a markdown-style annotated string.
   *
   * @param markdownText - The markdown text containing optional style/label tags
   * @param markdownSettings - Settings describing the start/end tag strings
   * @param set - When true, apply the parsed values to this instance
   * @returns An object containing `{ style, label, text }`
   */ markdownStyleLabel(markdownText, markdownSettings, set = true) {
        const styleTag = markdownText.indexOf(markdownSettings.styleNameEndTag);
        let style = undefined;
        let label = undefined;
        let text = undefined;
        // No style tag, return text
        if (styleTag === -1) text = markdownText;
        else {
            const labelTag = markdownText.indexOf(markdownSettings.styleNameEndTag, styleTag + markdownSettings.styleNameEndTag.length);
            // No label tag, return text
            if (labelTag === -1) {
                style = markdownText.slice(0, styleTag);
                text = markdownText.slice(styleTag + markdownSettings.styleNameEndTag.length);
            } else {
                // Style and label tags found
                if (styleTag > 0) style = markdownText.slice(0, styleTag);
                /* istanbul ignore else */ if (labelTag > styleTag + markdownSettings.styleNameEndTag.length) label = markdownText.slice(styleTag + markdownSettings.styleNameEndTag.length, labelTag);
                text = markdownText.slice(labelTag + markdownSettings.styleNameEndTag.length);
            }
        }
        // Set if required
        if (set) {
            this.style = style;
            this.label = label;
            this.text = text;
        }
        // Return results
        return {
            style: style,
            label: label,
            text: text
        };
    }
    /**
   * Parse a markdown string into the block fields using given markdown settings.
   *
   * @param markdown - The source markdown text for this block
   * @param arg - Markdown settings used to interpret tags
   */ fromMarkdown(markdown, arg) {
        const markdownSettings = arg;
        this.isLocked = undefined;
        this.style = undefined;
        this.label = undefined;
        this.text = markdown.replaceAll(/u00a0/g, " ").replaceAll(/[\u2009-\u200f]/g, "");
        if (this.text.startsWith(markdownSettings.styleStartTag) && this.text.endsWith(markdownSettings.styleEndTag)) {
            this.text = this.text.slice(markdownSettings.styleStartTag.length, -markdownSettings.styleEndTag.length);
            // Only time default style is used
            const defaultStyle = !this.text.includes(markdownSettings.styleNameEndTag);
            // Read style and label
            this.markdownStyleLabel(this.text, markdownSettings);
            // Update default style if required
            if (defaultStyle) this.style = markdownSettings.defaultStyle;
        }
    }
    // Status updated functions
    /**
   * Mark this block as active/inactive in the UI.
   *
   * @param active - True to mark the block active
   */ setActive(active) {
        this.isActive = active;
    }
    /**
   * Apply style attributes to an element and set dataset values used by rendering.
   *
   * @param span - The span element to apply styles to
   * @param style - Optional style map used to set CSS properties
   */ applyStyle(span, style) {
        if (this.style) {
            span.classList.add(`editorv3style-${this.style}`);
            span.dataset.styleName = this.style;
            Object.entries(style ?? {}).forEach(([k, v])=>{
                if (k === "isLocked") span.dataset.isLocked = "true";
                else span.style.setProperty(k.replace(/[A-Z]/g, (m)=>"-" + m.toLowerCase()), v);
            });
        }
    }
    // Content returns
    /**
   * Render this text block into a `DocumentFragment` appropriate for the
   * editor DOM. Handles locking, labels and active state.
   *
   * @param renderProps - The render properties controlling output
   * @param style - Optional style map used when rendering
   * @returns A `DocumentFragment` containing DOM nodes for this block
   */ toHtml(renderProps, style) {
        const text = this.text === "" ? "\u200b" : this.text.replaceAll(" ", "\u00a0\u200c");
        const ret = new DocumentFragment();
        if (this.type !== "text") throw new Error("Use correct class for non-text blocks");
        else {
            const words = renderProps.doNotSplitWordSpans ? [
                text.replaceAll(/[\u2009-\u200f]/g, "")
            ] : text.split("\u200c");
            words.filter((w)=>w !== "").forEach((word)=>{
                const span = document.createElement("span");
                span.classList.add("aiev3-tb");
                span.dataset.lineStartPosition = this.lineStartPosition.toString();
                const textNode = document.createTextNode(word);
                span.appendChild(textNode);
                // Add label
                if (this.label) span.title = this.label;
                // Apply lock
                if (this.isLocked && style?.isLocked) {
                    span.classList.add("is-locked");
                    span.dataset.isLocked = "true";
                    span.contentEditable = "false";
                }
                if (this.isActive) span.classList.add("is-active");
                // Apply style
                this.applyStyle(span, style);
                // Append to return
                ret.append(span);
            });
        }
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        return ret;
    }
    /**
   * Create the markdown-style label prefix for this block using settings.
   *
   * @param markdownSettings - The markdown settings used to format the label
   * @returns A string to prefix the block's text with style/label metadata
   */ toMarkdownStyleLabel(markdownSettings) {
        if (this.label) return (this.style ?? "") + markdownSettings.styleNameEndTag + this.label + markdownSettings.styleNameEndTag;
        else if (this.style && this.style !== markdownSettings.defaultStyle) return this.style + markdownSettings.styleNameEndTag;
        else return "";
    }
    /**
   * Convert this text block into its markdown representation using the
   * provided markdown settings. Style and label metadata are encoded
   * using the configured start/end tags.
   *
   * @param markdownSettings - Optional markdown settings; defaults to the
   *        block's default content properties.
   * @returns The markdown string representing this block.
   */ toMarkdown(markdownSettings = this._defaultContentProps.markdownSettings) {
        // Set base text
        let text = this.text;
        // Update text with style and label
        if (this.style || this.label) {
            text = markdownSettings.styleStartTag;
            text += this.toMarkdownStyleLabel(markdownSettings);
            text += this.text;
            text += markdownSettings.styleEndTag;
        }
        return text;
    }
}
/**
 * Render a single list item indicating an empty dropdown state. This
 * appends an `li` with an appropriate class and text to the provided
 * `ul` element.
 *
 * @param dropdownUl - The `ul` element to append the empty state into.
 */ const $0f261471404994f4$var$$7cf7e0ac61e95dc6$export$f1ad8b47dc439258 = (dropdownUl)=>{
    const noItems = document.createElement("li");
    noItems.classList.add("aiev3-drop-no-items");
    noItems.textContent = "No items found";
    dropdownUl.appendChild(noItems);
};
/**
 * Render an error placeholder into the dropdown when the item list
 * cannot be fetched.
 *
 * @param dropdownUl - The dropdown `ul` to render the error into.
 */ const $0f261471404994f4$var$$86c9c925a494dce9$export$367a5a17e4123093 = (dropdownUl)=>{
    dropdownUl.innerHTML = "";
    const errorItem = document.createElement("li");
    errorItem.classList.add("aiev3-drop-items-error");
    errorItem.textContent = "Error fetching list";
    dropdownUl.appendChild(errorItem);
};
const $0f261471404994f4$var$$993189bfb4c3bf83$export$38113ea00f19b1ee = (dropdownUl, dropItem)=>{
    const dropSpan = dropItem.listRender ?? document.createElement("li");
    /* istanbul ignore else */ if (!dropSpan.classList.contains("aiev3-drop-item")) dropSpan.classList.add("aiev3-drop-item");
    /* istanbul ignore else */ if (!dropSpan.dataset.text) dropSpan.dataset.text = dropItem.text;
    /* istanbul ignore else */ if (dropSpan.textContent === "" || !dropSpan.textContent) dropSpan.textContent = dropItem.text;
    // Add in data from atItem
    /* istanbul ignore else */ if (dropItem.data) Object.keys(dropItem.data).forEach((key)=>{
        /* istanbul ignore else */ if (dropItem.data) dropSpan.dataset[key] = dropItem.data[key];
    });
    dropdownUl.appendChild(dropSpan);
};
/**
 * Append a list item indicating there are more hidden items.
 *
 * @param dropdownUl - The dropdown unordered list element to render into
 * @param moreNumber - The number of additional items to display
 * @returns The created `HTMLLIElement` appended to `dropdownUl`
 */ const $0f261471404994f4$var$$591d0e585054a39b$export$af9d94bc34a616d5 = (dropdownUl, moreNumber)=>{
    const atSpan = document.createElement("li");
    atSpan.classList.add("aiev3-more-items");
    atSpan.textContent = `...${moreNumber} more`;
    dropdownUl.appendChild(atSpan);
    return atSpan;
};
const $0f261471404994f4$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6 = (span, text, renderProps, noaction = false)=>{
    // Clear any existing dropdowns
    const previousDropdown = document.querySelectorAll("ul.aiev3-dropdown-list");
    previousDropdown.forEach((dropdown)=>dropdown.remove());
    // Double check class list
    /* istanbul ignore else */ if (span.classList.contains("show-dropdown") && span.offsetParent) {
        // Create download
        const dropdownUl = document.createElement("ul");
        // Append to editor
        document.body.appendChild(dropdownUl);
        // Set up dropdown internals
        dropdownUl.classList.add("aiev3-dropdown-list", "skip-read");
        dropdownUl.contentEditable = "false";
        dropdownUl.innerHTML = "<li>Loading...</li>";
        // Add event listener
        if (!noaction) dropdownUl.addEventListener("mousedown", (e)=>{
            // Set long timeout to enable stack to clear
            const dropItem = e.target instanceof Element && e.target.classList.contains("aiev3-drop-item") ? e.target : e.target instanceof Element && e.target.closest(".aiev3-drop-item") ? e.target.closest(".aiev3-drop-item") : undefined;
            /* istanbul ignore else */ if (dropItem && dropItem instanceof HTMLElement) {
                // Update span
                const thisText = dropItem.textContent;
                span.textContent = dropItem.dataset.text ?? thisText;
                delete span.dataset.styleName;
                span.classList.forEach((className)=>{
                    if (className.startsWith("editorv3style-")) span.classList.remove(className);
                });
                if (dropItem.dataset.style) {
                    span.dataset.styleName = dropItem.dataset.style;
                    span.classList.add(`editorv3style-${dropItem.dataset.style}`);
                }
                span.classList.remove("is-active");
                span.classList.add("is-locked");
                span.dataset.isLocked = "true";
                // Copy any other data from the atItem
                /* istanbul ignore else */ if (dropItem.dataset) Object.keys(dropItem.dataset).filter((key)=>![
                        "isLocked",
                        "text",
                        "style"
                    ].includes(key)).forEach((key)=>{
                    span.dataset[key] = dropItem.dataset[key];
                });
                // Move dropdown to span before removing it
                span.appendChild(dropdownUl);
                // Remove dropdown
                dropdownUl.style.display = "none";
                window.setTimeout(()=>{
                    dropdownUl.remove();
                    // Dispatch refresh event to refresh the editor
                    const refreshEvent = new CustomEvent("editorv3refresh", {
                        bubbles: true,
                        detail: {
                            target: span
                        }
                    });
                    span.dispatchEvent(refreshEvent);
                }, 1);
            }
        });
        /**
     * Document-level click handler used to close the dropdown when the
     * user clicks outside of it.
     *
     * @param e - The mouse event from the document.
     */ const clickHandler = (e)=>{
            const target = e.target;
            const dropdownUl = document.querySelector(".aiev3-dropdown-list");
            if (dropdownUl && !dropdownUl.contains(target)) {
                dropdownUl.remove();
                span.classList.remove("is-active");
                span.classList.add("is-locked");
                span.dataset.isLocked = "true";
            }
            document.removeEventListener("mousedown", clickHandler);
        };
        document.addEventListener("mousedown", clickHandler);
        // Position dropdown
        const spanRect = span.getBoundingClientRect();
        dropdownUl.style.left = `${spanRect.left}px`;
        dropdownUl.style.top = `${spanRect.bottom}px`;
        // Add items to dropdown when promise resolves
        /* istanbul ignore else */ if (renderProps.atListFunction) renderProps.atListFunction(text).then((resolvedList)=>{
            const maxAtListLength = renderProps.maxAtListLength ?? 10;
            dropdownUl.innerHTML = "";
            if (resolvedList.length === 0) $0f261471404994f4$var$$7cf7e0ac61e95dc6$export$f1ad8b47dc439258(dropdownUl);
            else {
                resolvedList.slice(0, maxAtListLength).forEach((atItem)=>$0f261471404994f4$var$$993189bfb4c3bf83$export$38113ea00f19b1ee(dropdownUl, atItem));
                // Add in more items list item
                if (resolvedList.length > maxAtListLength) $0f261471404994f4$var$$591d0e585054a39b$export$af9d94bc34a616d5(dropdownUl, resolvedList.length - maxAtListLength);
            }
        }).catch(()=>{
            $0f261471404994f4$var$$86c9c925a494dce9$export$367a5a17e4123093(dropdownUl);
        });
    }
};
class $0f261471404994f4$export$2762eb7a56f6d4be extends $0f261471404994f4$export$4ed6c3ca0061f49b {
    /**
   * Returns the data representation of the at block.
   *
   * @returns The at block data interface
   */ get data() {
        const ret = super.data;
        if (Object.keys(this.atData).length > 0) ret.atData = this.atData;
        return ret;
    }
    /**
   * Returns the word positions within the at block.
   *
   * @returns Array of word positions
   */ get wordPositions() {
        return [
            {
                line: -1,
                startChar: this.lineStartPosition,
                endChar: this.lineStartPosition + this.text.length,
                isLocked: this.isLocked === true
            }
        ];
    }
    /**
   * Creates a new EditorV3AtBlock instance.
   *
   * @param arg - The source data (interface, HTML element, fragment, or string)
   * @param forcedParams - Optional parameters to force on the block
   */ constructor(arg, forcedParams){
        // Usual text block constructor
        super(arg, forcedParams), /**
   * Promise function that will return list of string values to display.
   *
   * @param typedString - Text entered into the block so far
   * @returns Promise of array of dropdown list items
   */ this.atListFunction = ()=>new Promise((resolve)=>resolve([])), /**
   * Maximum number of items to display in the returned list.
   */ this.maxAtListLength = 10, this.atData = {};
        // Force type
        this.type = "at";
        // Check for at specific information
        if (typeof arg === "string") this.furtherMarkdown(forcedParams?.markdownSettings);
        else if (arg instanceof HTMLSpanElement) this.furtherHtml(arg);
        else if (arg instanceof DocumentFragment) {
            if (arg.childNodes.length !== 1) throw new Error("EditorV3AtBlock:Constructor: DocumentFragment must have 1 child node");
            else if (!(arg.childNodes[0] instanceof HTMLSpanElement)) throw new Error("EditorV3AtBlock:Constructor: Child node must be HTMLSpanElement");
            // Read element
            this.furtherHtml(arg.childNodes[0]);
        } else {
            if (arg.atListFunction) this.atListFunction = arg.atListFunction;
            if (arg.maxAtListLength) this.maxAtListLength = arg.maxAtListLength;
            if (arg.atData) this.atData = arg.atData;
        }
        // Force any parameters
        if (forcedParams) {
            if (forcedParams.atListFunction) this.atListFunction = forcedParams.atListFunction;
            if (forcedParams.maxAtListLength) this.maxAtListLength = forcedParams.maxAtListLength;
            if (forcedParams.atData) this.atData = forcedParams.atData;
        }
    }
    /**
   * Read extra data from HTML element.
   *
   * @param arg - The HTML span element to extract data from
   */ furtherHtml(arg) {
        // Copy dataset to atFactory
        Object.keys(arg.dataset).forEach((key)=>{
            if (![
                "styleName",
                "isLocked",
                "type",
                "text",
                "lineStartPosition"
            ].includes(key)) this.atData[key] = arg.dataset[key];
        });
    }
    /**
   * Extract markdown information from block text.
   *
   * @param arg - Optional markdown settings to use
   */ furtherMarkdown(arg) {
        const markdownSettings = arg ?? this._defaultContentProps.markdownSettings;
        this.atData = {};
        /* istanbul ignore else */ if (this.text.startsWith(markdownSettings.atStartTag) && this.text.endsWith(markdownSettings.atEndTag) && this.text.includes(markdownSettings.dropDownSelectedValueTag)) {
            // Remove start and end tags
            this.text = this.text.slice(markdownSettings.atStartTag.length, -markdownSettings.atEndTag.length);
            // Find the dropdown selected value tag
            const dd = this.text.indexOf(markdownSettings.dropDownSelectedValueTag);
            // Get the data text
            const atDataText = this.text.slice(dd + markdownSettings.dropDownSelectedValueTag.length);
            try {
                this.atData = JSON.parse(atDataText);
            } catch  {
                this.atData = {};
            }
            // Get the text/style/label
            const current = this.text.slice(0, dd);
            this.markdownStyleLabel(current, markdownSettings);
        }
    }
    /**
   * Converts the at block to an HTML document fragment.
   *
   * @param renderProps - The rendering properties
   * @param style - Optional style to apply
   * @returns Document fragment containing the rendered HTML
   */ toHtml(renderProps, style) {
        // Create holder
        const ret = new DocumentFragment();
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        const span = document.createElement("span");
        ret.appendChild(span);
        span.classList.add("aiev3-tb", "at-block");
        span.dataset.lineStartPosition = this.lineStartPosition.toString();
        span.dataset.type = "at";
        // Add Text node
        const textNode = document.createTextNode(this.text.replaceAll(/[\u2009-\u200f]/g, "").replace(/^ /, "\u00a0").replace(/ $/, "\u00a0"));
        span.appendChild(textNode);
        // Add style
        this.applyStyle(span, style);
        // Add label
        if (this.label) span.title = this.label;
        // Add locked status
        /* istanbul ignore else */ if (this.isLocked || !this.isActive) {
            span.classList.add("is-locked");
            span.dataset.isLocked = "true";
            span.contentEditable = "false";
            // Add any other data items from the at item
            /* istanbul ignore else */ if (this.atData) Object.keys(this.atData).forEach((key)=>{
                span.dataset[key] = this.atData[key];
            });
        } else if (this.isActive) {
            span.classList.add("is-active");
            // Throttle render
            let renderTimeout = null;
            /* istanbul ignore else */ if (!renderTimeout) {
                span.classList.add("show-dropdown");
                renderTimeout = window.setTimeout(()=>$0f261471404994f4$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6(span, this.text, {
                        ...renderProps,
                        atListFunction: renderProps.atListFunction ?? this.atListFunction,
                        maxAtListLength: renderProps.maxAtListLength ?? this.maxAtListLength
                    }), 100);
            }
        }
        // Add to current element if specified
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        // Always return
        return ret;
    }
    /**
   * Converts the at block to markdown string representation.
   *
   * @param markdownSettings - The markdown settings to use
   * @returns Markdown string representation
   */ toMarkdown(markdownSettings = this._defaultContentProps.markdownSettings) {
        // Set base text
        let text = markdownSettings.atStartTag;
        // Update text with style and label
        text += this.toMarkdownStyleLabel(markdownSettings);
        // Add text
        text += this.text;
        // Add atData
        text += markdownSettings.dropDownSelectedValueTag + JSON.stringify(this.atData);
        // Complete tag
        text += markdownSettings.atEndTag;
        return text;
    }
}
/**
 * Get the item position within the container.
 *
 * @param containerEl - The container element
 * @param targetNode - The DOM node (or text node) where the caret is located; used to derive the line container
 * @param offset - The character offset
 * @param targetRange - A mutable `Range` instance used to compute character offsets within the line
 * @returns Position object or null
 */ const $0f261471404994f4$var$$87c84f58544c8738$var$getItemPosition = (containerEl, targetNode, offset, targetRange)=>{
    // Retrieve the target element (move up in the DOM if the element is a Text node)
    //  then find the line div
    const line = (targetNode instanceof Element ? targetNode : targetNode.parentElement).closest("div.aiev3-line, div.aiev3-markdown-line");
    // Get the line number by checking the siblings
    const lineIndex = line && containerEl.contains(line) && line.parentElement ? [
        ...line.parentElement.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line")
    ].indexOf(line) : null;
    // Stop if not found
    if (lineIndex === null || !line) return null;
    // Get the character number by checking the text content
    targetRange.selectNodeContents(line);
    targetRange.setEnd(targetNode, offset);
    const charIndex = targetRange.toString().replace(/[\u2009-\u200f]/g, "").length;
    return {
        lineIndex: lineIndex,
        charIndex: charIndex
    };
};
function $0f261471404994f4$var$$87c84f58544c8738$export$7d120213748299d3(element) {
    // Check a selection is present
    let range;
    let preCaretRange;
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
        range = sel.getRangeAt(0);
        preCaretRange = range.cloneRange();
    } else return null;
    /**
   * Get the anchor line and character of the caret.
   */ const anchor = (sel.anchorNode && $0f261471404994f4$var$$87c84f58544c8738$var$getItemPosition(element, sel.anchorNode, sel.anchorOffset, preCaretRange)) ?? null;
    /**
   * Get the end line and character of the caret.
   */ const focus = (sel.focusNode && $0f261471404994f4$var$$87c84f58544c8738$var$getItemPosition(element, sel.focusNode, sel.focusOffset, preCaretRange)) ?? null;
    return anchor && focus ? {
        initialLine: anchor.lineIndex,
        initialChar: anchor.charIndex,
        focusLine: focus.lineIndex,
        focusChar: focus.charIndex
    } : null;
}
class $0f261471404994f4$var$$55b76cc9e420f966$export$e7963cc196b8739d extends $0f261471404994f4$export$4ed6c3ca0061f49b {
    /**
   * List of available dropdown options for this select block.
   *
   * @returns EditorV3DropListItem<Record<string, string>>[]
   */ get availableOptions() {
        return this._availableOptions;
    }
    /**
   * Set the available options for this select block.
   *
   * @param value - Array of options to use for this select block.
   */ set availableOptions(value) {
        this._availableOptions = value.map(this._styleOrNot);
    }
    /**
   * Serialise this select block including available options.
   *
   * @returns IEditorV3SelectBlock
   */ get data() {
        const ret = super.data;
        ret.availableOptions = this.availableOptions;
        return ret;
    }
    /**
   * Word position for the entire select block (treated as a locked token).
   *
   * @returns EditorV3WordPosition[]
   */ get wordPositions() {
        return [
            {
                line: -1,
                startChar: this.lineStartPosition,
                endChar: this.lineStartPosition + this.text.length,
                isLocked: this.isLocked === true
            }
        ];
    }
    /**
   * Construct a select block from model, DOM or markdown input.
   *
   * @param arg - Source for the block content
   * @param forcedParams - Optional overrides such as available options
   */ constructor(arg, forcedParams){
        // Usual text block constructor
        super(arg, forcedParams), this._availableOptions = [], /**
   * Normalise a raw option object into the internal `EditorV3DropListItem`
   * shape used by the select block, ensuring `data` contains either a
   * `style` property or an explicit `noStyle` marker.
   *
   * @param o Raw option object with optional `text` and `data`.
   * @returns A normalised `EditorV3DropListItem<Record<string,string>>`.
   */ this._styleOrNot = (o)=>{
            const option = {
                text: o.text,
                data: {}
            };
            /* istanbul ignore else */ if (o.data?.style && option.data) option.data.style = o.data.style;
            else if (option.data) option.data.noStyle = "true";
            return option;
        }, this.showDropdown = ()=>{
            this.isActive = true;
            this.isSelected = true;
        };
        // Force type
        this.type = "select";
        this.isLocked = true;
        // Check for at specific information
        if (typeof arg === "string") this.furtherMarkdown(forcedParams?.markdownSettings);
        else if (arg instanceof HTMLSpanElement) this.furtherHtml(arg);
        else if (arg instanceof DocumentFragment) {
            if (arg.childNodes.length !== 1) throw new Error("EditorV3SelectBlock:Constructor: DocumentFragment must have 1 child node");
            else if (!(arg.childNodes[0] instanceof HTMLSpanElement)) throw new Error("EditorV3SelectBlock:Constructor: DocumentFragment child node must be HTMLSpanElement");
            // Read element
            this.furtherHtml(arg.childNodes[0]);
        } else if (arg.availableOptions) this.availableOptions = arg.availableOptions;
        // Force any parameters
        if (forcedParams) {
            if (forcedParams.availableOptions) this.availableOptions = forcedParams.availableOptions;
        }
    }
    // Read extra data from HTML
    /**
   * Populate additional fields from an HTML span element's dataset (used
   * when constructing from DOM).
   *
   * @param arg - The span element containing dataset values
   */ furtherHtml(arg) {
        // Copy dataset to selectFactory
        /* istanbul ignore else */ if (arg.dataset.availableOptions) this.availableOptions = JSON.parse(arg.dataset.availableOptions);
    }
    // Get markdown information
    /**
   * Parse markdown-formatted dropdown text into `availableOptions`.
   *
   * @param arg - Optional markdown settings used to interpret tags
   */ furtherMarkdown(arg) {
        const markdownSettings = arg ?? this._defaultContentProps.markdownSettings;
        this.availableOptions = [];
        /* istanbul ignore else */ if (this.text.startsWith(markdownSettings.dropDownStartTag) && this.text.endsWith(markdownSettings.dropDownEndTag) && this.text.includes(markdownSettings.dropDownSelectedValueTag)) {
            this.text = this.text.slice(markdownSettings.dropDownStartTag.length, -markdownSettings.dropDownEndTag.length);
            const dd = this.text.indexOf(markdownSettings.dropDownSelectedValueTag);
            const current = this.text.slice(0, dd);
            const optionsTexts = this.text.slice(dd + markdownSettings.dropDownSelectedValueTag.length).split(markdownSettings.dropDownValueSeparator);
            this.markdownStyleLabel(current, markdownSettings);
            this.availableOptions = optionsTexts.map((optionText)=>{
                const ret = this.markdownStyleLabel(optionText, markdownSettings, false);
                return {
                    text: ret.text,
                    data: ret.style ? {
                        style: ret.style
                    } : undefined
                };
            });
        }
    }
    // Overload html return
    /**
   * Render the select block as a DocumentFragment containing a span that
   * includes option metadata. When editable, also displays the dropdown.
   *
   * @param renderProps - Render options and callbacks used by the editor
   * @param style - Optional style map
   * @returns DocumentFragment
   */ toHtml(renderProps, style) {
        // Create holder
        const ret = new DocumentFragment();
        const span = document.createElement("span");
        ret.appendChild(span);
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        span.classList.add("aiev3-tb", "select-block");
        span.dataset.lineStartPosition = this.lineStartPosition.toString();
        span.dataset.type = "select";
        // Add Text node
        const textNode = document.createTextNode(this.text.replaceAll(/[\u2009-\u200f]/g, "").replace(/^ /, "\u00a0").replace(/ $/, "\u00a0"));
        span.appendChild(textNode);
        // Add style
        this.applyStyle(span, style);
        // Add label
        if (this.label) span.title = this.label;
        // Add locked status
        span.classList.add("is-locked");
        span.dataset.isLocked = "true";
        span.contentEditable = "false";
        // Add other data items from the at item
        span.dataset.availableOptions = JSON.stringify(this.availableOptions);
        // Add caret
        const caret = document.createElement("span");
        caret.classList.add("select-block-caret", "skip-read");
        span.prepend(caret);
        // Throttle dropdown render
        let renderTimeout = null;
        // Editable render dropdown when selected
        if (!renderTimeout && this.isSelected && this.availableOptions.length > 0 && renderProps.caretPosition?.isCollapsed === false && renderProps.editableEl?.contentEditable === "true") {
            span.classList.add("show-dropdown");
            renderTimeout = window.setTimeout(()=>{
                $0f261471404994f4$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6(span, this.text, {
                    ...renderProps,
                    atListFunction: async ()=>{
                        return this.availableOptions.map((option)=>{
                            const listItem = document.createElement("li");
                            const tb = new $0f261471404994f4$export$4ed6c3ca0061f49b({
                                text: option.text,
                                style: option.data?.style
                            });
                            tb.toHtml({
                                currentEl: listItem
                            }, renderProps.styles?.[option.data?.style ?? // istanbul ignore next
                            ""]);
                            return {
                                text: option.text,
                                data: option.data,
                                listRender: listItem
                            };
                        });
                    },
                    maxAtListLength: Math.max(1, this.availableOptions.length)
                });
            }, 100);
        }
        // Read-only render dropdown on hover
        if (renderProps.editableEl?.contentEditable === "false") {
            span.style.pointerEvents = "auto";
            span.onmousedown = (e)=>{
                e.preventDefault();
                e.stopPropagation();
            };
            span.addEventListener("mouseenter", ()=>{
                span.classList.add("show-dropdown");
                $0f261471404994f4$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6(span, this.text, {
                    ...renderProps,
                    atListFunction: async ()=>{
                        return this.availableOptions.map((option)=>{
                            const listItem = document.createElement("li");
                            const tb = new $0f261471404994f4$export$4ed6c3ca0061f49b({
                                text: option.text,
                                style: option.data?.style
                            });
                            tb.toHtml({
                                currentEl: listItem
                            }, renderProps.styles?.[option.data?.style ?? // istanbul ignore next
                            ""]);
                            return {
                                text: option.text,
                                data: option.data,
                                listRender: listItem
                            };
                        });
                    },
                    maxAtListLength: Math.max(1, this.availableOptions.length)
                }, true);
            });
            span.addEventListener("mouseleave", ()=>{
                const dropdown = document.querySelector(".aiev3-dropdown-list");
                /* istanbul ignore else */ if (dropdown) window.setTimeout(()=>{
                    dropdown.remove();
                }, 100);
            });
        }
        if (this.isActive) span.classList.add("is-active");
        // Add to current element if specified
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        // Always return
        return ret;
    }
    /**
   * Convert this select block into a markdown dropdown representation
   * using the provided settings. The returned string contains the
   * selected value followed by available options separated by the
   * configured separator tags.
   *
   * @param markdownSettings - Optional markdown settings used to control
   *        the encoding of options and selection.
   * @returns A markdown string representing the select block and its
   *          available options.
   */ toMarkdown(markdownSettings = this._defaultContentProps.markdownSettings) {
        let text = markdownSettings.dropDownStartTag;
        text += this.toMarkdownStyleLabel(markdownSettings);
        text += this.text + markdownSettings.dropDownSelectedValueTag + this._availableOptions.map((option)=>(option.data?.style ? option.data.style + markdownSettings.styleNameEndTag : "") + option.text).join(markdownSettings.dropDownValueSeparator);
        text += markdownSettings.dropDownEndTag;
        return text;
    }
}
const $0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d = (arg, forcedParams)=>{
    // Span element
    if (arg instanceof HTMLSpanElement) switch(arg.dataset.type){
        case "at":
            return new $0f261471404994f4$export$2762eb7a56f6d4be(arg, forcedParams);
        case "select":
            return new $0f261471404994f4$var$$55b76cc9e420f966$export$e7963cc196b8739d(arg, forcedParams);
        default:
            return new $0f261471404994f4$export$4ed6c3ca0061f49b(arg, forcedParams);
    }
    else if (arg instanceof DocumentFragment) {
        if (arg.childNodes.length > 0 && arg.childNodes[0] instanceof HTMLSpanElement) {
            const span = arg.childNodes[0];
            switch(span.dataset.type){
                case "at":
                    return new $0f261471404994f4$export$2762eb7a56f6d4be(arg, forcedParams);
                case "select":
                    return new $0f261471404994f4$var$$55b76cc9e420f966$export$e7963cc196b8739d(arg, forcedParams);
                default:
                    return new $0f261471404994f4$export$4ed6c3ca0061f49b(arg, forcedParams);
            }
        }
        throw new Error("TextBlockFactory:DocumentFragment: Bad contents");
    } else if (arg instanceof Text) return new $0f261471404994f4$export$4ed6c3ca0061f49b({
        text: (arg.textContent ?? // istanbul ignore next
        "").replaceAll("\u00a0", " ")
    }, forcedParams);
    else switch(forcedParams?.type ?? arg.type){
        case "at":
            return new $0f261471404994f4$export$2762eb7a56f6d4be(arg, forcedParams);
        case "select":
            return new $0f261471404994f4$var$$55b76cc9e420f966$export$e7963cc196b8739d(arg, forcedParams);
        default:
            return new $0f261471404994f4$export$4ed6c3ca0061f49b(arg, forcedParams);
    }
};
const $0f261471404994f4$var$$283486dc8b1946f0$export$1fe33d47a8cb2fd9 = (arg)=>{
    const ret = {
        textBlocks: [],
        decimalAlignPercent: 60,
        textAlignment: $0f261471404994f4$export$e6890f8825213b0d.left
    };
    // Remove skip-read elements
    const skipRead = arg.querySelectorAll(".skip-read");
    skipRead.forEach((el)=>el.remove());
    // Decimal aligned
    if (arg.classList.contains("aiev3-line")) {
        if (arg.classList.contains("decimal")) {
            ret.textAlignment = $0f261471404994f4$export$e6890f8825213b0d.decimal;
            ret.decimalAlignPercent = arg.children.length === 2 && arg.style.gridTemplateColumns ? parseFloat(arg.style.gridTemplateColumns.split("%")[0]) : 60;
            // This will skip the inner offcanvas span
            ret.textBlocks = arg.firstChild instanceof HTMLSpanElement && arg.lastChild instanceof HTMLSpanElement && arg.firstChild.classList.contains("lhs") && arg.lastChild.classList.contains("rhs") ? [
                ...[
                    ...arg.firstChild.childNodes
                ].map((el)=>$0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    })),
                ...[
                    ...arg.lastChild.childNodes
                ].map((el)=>$0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    }))
            ].filter((tb)=>tb.text !== "" && tb.text !== "\u200b") : [
                ...[
                    ...arg.childNodes
                ].map((el)=>$0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    }))
            ].filter((tb)=>tb.text !== "" && tb.text !== "\u200b");
        } else {
            ret.textBlocks = [
                ...[
                    ...arg.childNodes
                ].map((el)=>$0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    }))
            ].filter((tb)=>tb.text !== "" && tb.text !== "\u200b");
            ret.textAlignment = [
                "left",
                "center",
                "right"
            ].includes(arg.classList[1]) ? arg.classList[1] : $0f261471404994f4$export$e6890f8825213b0d.left;
        }
    }
    // Ensure there is at least something
    if (ret.textBlocks.length === 0) ret.textBlocks = [
        new $0f261471404994f4$export$4ed6c3ca0061f49b()
    ];
    return ret;
};
const $0f261471404994f4$var$$a6492f8421d8d930$export$dd39f3dafa818d0c = (renderProps, contentProps, lhsContent, rhsContent)=>{
    /* istanbul ignore else */ if (renderProps.currentEl) {
        const prePoint = document.createElement("span");
        prePoint.className = "aiev3-span-point lhs";
        renderProps.currentEl.append(prePoint);
        if (lhsContent.length) lhsContent.forEach((tb)=>prePoint.append(tb.toHtml({
                ...renderProps,
                currentEl: prePoint
            }, tb.style ? contentProps.styles?.[tb.style] : undefined)));
        else prePoint.textContent = "\u200b";
        // Set up space after (excluding) decimal
        const postPoint = document.createElement("span");
        postPoint.className = "aiev3-span-point rhs";
        renderProps.currentEl.append(postPoint);
        if (rhsContent.length) rhsContent.forEach((tb)=>{
            postPoint.append(tb.toHtml({
                ...renderProps,
                currentEl: postPoint
            }, tb.style ? contentProps.styles?.[tb.style] : undefined));
        });
        else postPoint.textContent = "\u200b";
        // Set grid column widths
        renderProps.currentEl.style.gridTemplateColumns = `${contentProps.decimalAlignPercent}% ${100 - contentProps.decimalAlignPercent}%`;
    }
};
class $0f261471404994f4$export$f727c5bfed9e77d4 {
    // #region Renderers
    /**
   * Render the line as editable HTML for the editor DOM.
   *
   * @param renderProps - Rendering options and targets used during build
   */ toHtml(renderProps) {
        const h = document.createElement("div");
        this._setBlockStartPositions();
        renderProps.currentEl = h;
        h.className = `aiev3-line ${this.contentProps.textAlignment}`;
        if (this.contentProps.textAlignment === $0f261471404994f4$export$e6890f8825213b0d.decimal) {
            const decimalPosition = this.lineText.match(/\./)?.index ?? Infinity;
            const upTo = this.upToPos(decimalPosition, true);
            const from = this.fromPos(decimalPosition, true);
            $0f261471404994f4$var$$a6492f8421d8d930$export$dd39f3dafa818d0c(renderProps, this.contentProps, upTo, from);
        } else {
            if (this.textBlocks[0]?.isLocked) {
                const startLineEl = document.createElement("span");
                startLineEl.textContent = "\u2009";
                h.appendChild(startLineEl);
            }
            this.textBlocks.forEach((tb)=>h.append(tb.toHtml(renderProps, tb.style ? this.contentProps.styles?.[tb.style] : undefined)));
        }
        // Need to add a space to the end of the line to allow for the cursor to be placed at the end
        if (this.textBlocks.length > 0 && this.textBlocks[this.textBlocks.length - 1].isLocked && this.contentProps.textAlignment !== $0f261471404994f4$export$e6890f8825213b0d.decimal) {
            const endLineEl = document.createElement("span");
            endLineEl.textContent = "\u200b";
            h.append(endLineEl);
        }
        if (renderProps.editableEl) renderProps.editableEl.append(h);
        return h;
    }
    /**
   * Render the line as a markdown-style HTML div. Used for read-only or
   * markdown-mode rendering.
   *
   * @param renderProps - Rendering options and targets used during build
   */ toMarkdown(renderProps) {
        const h = document.createElement("div");
        renderProps.currentEl = h;
        h.className = "aiev3-markdown-line";
        h.textContent = this.textBlocks.map((tb)=>tb.toMarkdown(renderProps.markdownSettings ?? this.contentProps.markdownSettings)).join("");
        if (h.textContent === "") h.textContent = "\u200b";
        if (renderProps.editableEl) renderProps.editableEl.append(h);
        return h;
    }
    // #endregion Renderers
    // #region Getters
    /**
   * Combined text of all blocks in the line.
   */ get lineText() {
        return this.textBlocks.map((tb)=>tb.text).join("");
    }
    /**
   * The markdown representation of the line by concatenating block markdowns.
   */ get lineMarkdown() {
        return this.textBlocks.map((tb)=>tb.toMarkdown()).join("");
    }
    /**
   * Word-level positions across all blocks in this line.
   */ get wordPositions() {
        return this.textBlocks.flatMap((tb)=>tb.wordPositions);
    }
    /**
   * Total character length of the line's text.
   */ get lineLength() {
        return this.lineText.length;
    }
    /**
   * Whether any block in the line is enhanced (non-default style/label/type).
   */ get isEnhanced() {
        return this.textBlocks.some((tb)=>tb.isEnhanced);
    }
    /**
   * Serialise the line to the model shape used by the EditorV3 API.
   */ get data() {
        const contentProps = (0, $gSkQi.cloneDeep)(this.contentProps);
        Object.keys($0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54).forEach((k)=>{
            const key = k;
            if ((0, $gSkQi.isEqual)(this.contentProps[key], this._defaultContentProps[key])) delete contentProps[key];
        });
        const textBlocks = this.textBlocks.map((tb)=>tb.data);
        return Object.keys(contentProps).length === 0 ? {
            textBlocks: textBlocks
        } : {
            contentProps: contentProps,
            textBlocks: textBlocks
        };
    }
    // #endregion Getters
    // #region Constructors
    // Constructor
    /**
   * Construct a line from a model object, HTML div, block array or markdown string.
   *
   * @param arg - Source value used to build the line
   * @param contentProps - Optional content property overrides
   */ constructor(arg, contentProps){
        this._defaultContentProps = (0, $gSkQi.cloneDeep)($0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54);
        // Set defaults
        this.textBlocks = [];
        this.contentProps = (0, $gSkQi.cloneDeep)(this._defaultContentProps);
        // Markdown HTMLDivElement
        if (arg instanceof HTMLDivElement && arg.classList.contains("aiev3-markdown-line")) {
            this.contentProps = {
                ...contentProps,
                ...this._defaultContentProps
            };
            this.fromMarkdown(arg.textContent ?? // istanbul ignore next
            "");
        } else if (arg instanceof HTMLDivElement) {
            const ret = $0f261471404994f4$var$$283486dc8b1946f0$export$1fe33d47a8cb2fd9(arg);
            this.textBlocks = ret.textBlocks;
            this.contentProps.textAlignment = ret.textAlignment;
            this.contentProps.decimalAlignPercent = ret.decimalAlignPercent;
            // Only need to merge after HMTL read?
            this._mergeBlocks();
        } else if (typeof arg === "string") {
            this.contentProps = {
                ...contentProps,
                ...this._defaultContentProps
            };
            this.fromMarkdown(arg);
        } else if (Array.isArray(arg)) {
            this.textBlocks = arg;
            this._mergeBlocks();
        } else {
            this.textBlocks = arg?.textBlocks.map((tb)=>$0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d(tb)) ?? [
                new $0f261471404994f4$export$4ed6c3ca0061f49b()
            ];
            this.contentProps = {
                ...this.contentProps,
                ...arg?.contentProps
            };
        }
        // Always take these if provided
        if (contentProps) this.contentProps = {
            ...this._defaultContentProps,
            ...contentProps
        };
        // Fix any problems
        this._lockTextBlocksByStyle();
        this._setBlockStartPositions();
    }
    /**
   * Parse a markdown string and populate `textBlocks` according to markdown rules.
   *
   * @param markdown - The markdown string representing this line
   */ fromMarkdown(markdown) {
        /* istanbul ignore else */ if (this.contentProps.markdownSettings) {
            let remainingMarkdown = markdown.replace(/[\u2009-\u200f]/g, "");
            let safety = 0;
            while(remainingMarkdown.length > 0 && safety < 100){
                safety++;
                // Start of complete select block
                if (remainingMarkdown.startsWith(this.contentProps.markdownSettings.dropDownStartTag) && remainingMarkdown.indexOf(this.contentProps.markdownSettings.dropDownSelectedValueTag) > -1 && remainingMarkdown.indexOf(this.contentProps.markdownSettings.dropDownEndTag) > -1) {
                    const blockEnd = remainingMarkdown.indexOf(this.contentProps.markdownSettings.dropDownEndTag);
                    this.textBlocks.push(new $0f261471404994f4$var$$55b76cc9e420f966$export$e7963cc196b8739d(remainingMarkdown.slice(0, blockEnd + this.contentProps.markdownSettings.dropDownEndTag.length), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd + this.contentProps.markdownSettings.dropDownEndTag.length);
                } else if (remainingMarkdown.startsWith(this.contentProps.markdownSettings.atStartTag) && remainingMarkdown.indexOf(this.contentProps.markdownSettings.atEndTag) > -1) {
                    const blockEnd = remainingMarkdown.indexOf(this.contentProps.markdownSettings.atEndTag);
                    this.textBlocks.push(new $0f261471404994f4$export$2762eb7a56f6d4be(remainingMarkdown.slice(0, blockEnd + this.contentProps.markdownSettings.atEndTag.length), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd + this.contentProps.markdownSettings.atEndTag.length);
                } else if (remainingMarkdown.startsWith(this.contentProps.markdownSettings.styleStartTag) && remainingMarkdown.indexOf(this.contentProps.markdownSettings.styleEndTag) > -1) {
                    const blockEnd = remainingMarkdown.indexOf(this.contentProps.markdownSettings.styleEndTag);
                    this.textBlocks.push(new $0f261471404994f4$export$4ed6c3ca0061f49b(remainingMarkdown.slice(0, blockEnd + this.contentProps.markdownSettings.styleEndTag.length), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd + this.contentProps.markdownSettings.styleEndTag.length);
                } else {
                    const nextDropTag = remainingMarkdown.slice(1).indexOf(this.contentProps.markdownSettings.dropDownStartTag);
                    const nextAtTag = remainingMarkdown.slice(1).indexOf(this.contentProps.markdownSettings.atStartTag);
                    const nextStyleTag = remainingMarkdown.slice(1).indexOf(this.contentProps.markdownSettings.styleStartTag);
                    const blockEnd = Math.min(nextDropTag > -1 ? nextDropTag + 1 : Infinity, nextAtTag > -1 ? nextAtTag + 1 : Infinity, nextStyleTag > -1 ? nextStyleTag + 1 : Infinity, remainingMarkdown.length);
                    this.textBlocks.push(new $0f261471404994f4$export$4ed6c3ca0061f49b(remainingMarkdown.slice(0, blockEnd), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd);
                }
            }
        }
    }
    // #endregion Constructors
    // #region Get/Set block methods
    /**
   * Return the block containing a given character position.
   *
   * @param pos - Character index within the line
   */ getBlockAt(pos) {
        return this.textBlocks.find((tb)=>tb.lineStartPosition <= pos && tb.lineEndPosition > pos);
    }
    /**
   * Return the style name applied at a character position.
   *
   * @param pos - Character index within the line
   */ getStyleAt(pos) {
        return this.getBlockAt(pos)?.style;
    }
    /**
   * Return the names of all the styles used in the line.
   */ getAllStyles() {
        const stylesSet = new Set();
        this.textBlocks.forEach((tb)=>{
            if (tb.style) stylesSet.add(tb.style);
        });
        return Array.from(stylesSet);
    }
    /**
   * Set the active block according to a caret/selection position.
   *
   * @param pos - Position object describing the caret or selection
   */ setActiveBlock(pos) {
        this.textBlocks.forEach((tb)=>tb.setActive(false));
        const nextBlock = this.getBlockAt(pos.startChar);
        const lastBlock = this.getBlockAt(Math.max(0, pos.startChar - 1));
        if (lastBlock && lastBlock instanceof $0f261471404994f4$export$2762eb7a56f6d4be && pos.isCollapsed) {
            lastBlock.setActive(true);
            return lastBlock;
        } else if (nextBlock && nextBlock instanceof $0f261471404994f4$var$$55b76cc9e420f966$export$e7963cc196b8739d) {
            nextBlock.showDropdown();
            return nextBlock;
        } else {
            nextBlock?.setActive(true);
            return nextBlock;
        }
    }
    // #endregion Get/Set block methods
    // #region Subset methods
    /**
   * Extract a list of blocks representing a subset of the line between
   * `startPos` and `endPosOpt`. Optionally split locked blocks.
   *
   * @param startPos - Start character index
   * @param endPosOpt - Optional end character index
   * @param splitLocked - When true, locked blocks may be split to fit
   */ subBlocks(startPos, endPosOpt, splitLocked = false) {
        const ret = [];
        const endPos = endPosOpt ?? this.lineLength + 1;
        // Return empty styled block for start/end same
        if (startPos >= endPos || endPos <= 0) return ret;
        for(let _i = 0; _i < this.textBlocks.length; _i++){
            const block = this.textBlocks[_i];
            // Block after start and before end
            if (startPos <= block.lineStartPosition && block.lineEndPosition < endPos) ret.push((0, $gSkQi.cloneDeep)(block));
            else if (block.lineStartPosition < startPos && block.lineEndPosition > startPos && (!block.isLocked || splitLocked)) {
                const slicedBlock = $0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    ...block.data,
                    // Split locked occurs on decimals, so lineStartPosition is needed
                    lineStartPosition: splitLocked ? block.lineStartPosition : undefined,
                    text: block.text.slice(startPos - block.lineStartPosition, endPos - block.lineStartPosition)
                });
                ret.push(slicedBlock);
            } else if (block.lineStartPosition >= startPos && block.lineStartPosition < endPos && block.lineEndPosition >= endPos) {
                if (block.isLocked && !splitLocked) ret.push((0, $gSkQi.cloneDeep)(block));
                else {
                    const slicedBlock = $0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                        ...block,
                        text: block.text.slice(0, endPos - block.lineStartPosition)
                    });
                    ret.push(slicedBlock);
                }
            }
            // Stop if the end is reached
            if (block.lineStartPosition >= endPos) break;
        }
        if (!splitLocked) this._setBlockStartPositions(ret, startPos);
        return ret;
    }
    /**
   * Return blocks from the start of the line up to `pos`.
   *
   * @param pos - Character index to cut off at
   * @param splitLocked - Whether locked blocks can be split
   */ upToPos(pos, splitLocked = false) {
        return this.subBlocks(0, pos, splitLocked);
    }
    /**
   * Return blocks from `pos` to the end of the line.
   *
   * @param pos - Character index to start from
   * @param splitLocked - Whether locked blocks can be split
   */ fromPos(pos, splitLocked = false) {
        return this.subBlocks(pos, undefined, splitLocked);
    }
    // #endregion Subset methods
    // #region Insert and remove methods
    /**
   * Split the line at `pos` returning the tail as a new `EditorV3Line`.
   *
   * @param pos - Character index where the split occurs
   */ splitLine(pos) {
        if (pos >= this.lineLength) return new $0f261471404994f4$export$f727c5bfed9e77d4(undefined, this.contentProps);
        else {
            const preSplit = this.upToPos(pos);
            const postSplit = this.fromPos(pos);
            this.textBlocks = preSplit.length > 0 ? preSplit : [
                new $0f261471404994f4$export$4ed6c3ca0061f49b()
            ];
            this._setBlockStartPositions();
            return new $0f261471404994f4$export$f727c5bfed9e77d4(postSplit, this.contentProps);
        }
    }
    /**
   * Insert blocks at a character position within the line.
   *
   * @param newTextBlocks - Blocks to insert
   * @param pos - Character index where insertion begins
   */ insertBlocks(newTextBlocks, pos) {
        const pre = this.upToPos(pos);
        const post = this.fromPos(pos);
        this.textBlocks = [
            ...pre,
            ...newTextBlocks,
            ...post
        ];
        this._mergeBlocks();
        this._setBlockStartPositions();
    }
    /**
   * Remove a section of the line between `startPos` and `endPos` and
   * return the removed blocks.
   *
   * @param startPos - Starting character index (inclusive)
   * @param endPos - Ending character index (exclusive)
   */ removeSection(startPos, endPos) {
        let ret = [];
        if (startPos < endPos && startPos < this.lineLength) {
            const pre = this.upToPos(startPos);
            ret = this.subBlocks(startPos, endPos);
            const post = this.fromPos(endPos);
            this.textBlocks = [
                ...pre,
                ...post
            ];
            this._mergeBlocks();
            this._setBlockStartPositions();
        }
        return ret;
    }
    /**
   * Delete a single character at position `pos` and return the mutated line.
   *
   * @param pos - Character index to delete
   */ deleteCharacter(pos) {
        this.removeSection(pos, pos + 1);
        return this;
    }
    // #endregion Insert and remove methods
    // #region Update style methods
    /**
   * Apply a named style to a range of characters in the line.
   *
   * @param styleName - Style identifier to apply
   * @param startPos - Start character index
   * @param endPos - End character index
   */ applyStyle(styleName, startPos, endPos) {
        if (startPos < endPos) {
            const upTo = this.upToPos(startPos);
            const mid = this.subBlocks(startPos, endPos).map((tb)=>{
                tb.style = styleName;
                if (this.contentProps.styles?.[styleName]?.isLocked) tb.isLocked = true;
                return tb;
            });
            const from = this.fromPos(endPos);
            this.textBlocks = [
                ...upTo,
                ...mid,
                ...from
            ];
            this._mergeBlocks();
            this._setBlockStartPositions();
        }
        return this;
    }
    /**
   * Remove style information from blocks in the supplied range.
   *
   * @param startPos - Start character index
   * @param endPos - End character index
   */ removeStyle(startPos, endPos) {
        if (startPos < endPos) {
            this.textBlocks = [
                ...this.upToPos(startPos),
                ...this.subBlocks(startPos, endPos).map((tb)=>{
                    tb.style = undefined;
                    if (tb.isLocked) delete tb.isLocked;
                    return tb;
                }),
                ...this.fromPos(endPos)
            ];
            this._mergeBlocks();
            this._setBlockStartPositions();
        }
        return this;
    }
    /**
   * Remove the style information from all blocks that have any of the specified styles.
   *
   * @param styleNames - Array of style names to remove
   * @returns The updated line instance
   */ cleanStyles(styleNames) {
        this.textBlocks = this.textBlocks.map((tb)=>{
            if (tb.style && styleNames.includes(tb.style)) {
                tb.style = undefined;
                if (tb.isLocked) delete tb.isLocked;
            }
            return tb;
        });
        this._mergeBlocks();
        this._setBlockStartPositions();
        return this;
    }
    /**
   * Delete text blocks that have any of the specified styles.
   *
   * @param styleNames - Array of style names to delete
   * @returns The updated line instance
   */ deleteStyles(styleNames) {
        this.textBlocks = this.textBlocks.filter((tb)=>styleNames.includes(tb.style ?? "") === false);
        if (this.textBlocks.length === 0) this.textBlocks = [
            new $0f261471404994f4$export$4ed6c3ca0061f49b()
        ];
        this._mergeBlocks();
        this._setBlockStartPositions();
        return this;
    }
    // #endregion Update style methods
    // #region Private methods
    /**
   * Merge adjacent blocks that share the same merge key into single blocks.
   */ _mergeBlocks() {
        if (new Set(this.textBlocks.map((tb)=>tb.mergeKey)).size < this.textBlocks.length) {
            const mergedBlocks = [];
            let lastTypeStyle = null;
            for(let _i = 0; _i < this.textBlocks.length; _i++)if (this.textBlocks[_i].mergeKey === lastTypeStyle && mergedBlocks.length > 0) mergedBlocks[mergedBlocks.length - 1] = $0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                ...mergedBlocks[mergedBlocks.length - 1].data,
                text: mergedBlocks[mergedBlocks.length - 1].text + this.textBlocks[_i].text
            });
            else {
                mergedBlocks.push(this.textBlocks[_i]);
                lastTypeStyle = this.textBlocks[_i].mergeKey;
            }
            this.textBlocks = mergedBlocks.filter((tb)=>tb.text !== "");
        }
    }
    /**
   * Apply `isLocked` to blocks when their style is defined as locked in
   * the content properties.
   */ _lockTextBlocksByStyle() {
        // Check for any locked styles
        const lockedStyles = Object.keys(this.contentProps.styles ?? []).filter((k)=>this.contentProps.styles[k].isLocked);
        if (lockedStyles.length > 0) this.textBlocks.forEach((tb)=>{
            if (lockedStyles.includes(tb.style ?? "")) tb.isLocked = true;
        });
    }
    /**
   * Calculate and set `lineStartPosition` for each block, optionally for a
   * provided subset starting at `initialPos`.
   *
   * @param blocks - Optional block array to update (defaults to this.textBlocks)
   * @param initialPos - Starting character position for the first block
   */ _setBlockStartPositions(blocks, initialPos = 0) {
        let _linePos = initialPos;
        const tbs = blocks ?? this.textBlocks;
        tbs.forEach((tb)=>{
            tb.lineStartPosition = _linePos;
            /* istanbul ignore else */ if (tb.lineEndPosition !== undefined) _linePos = tb.lineEndPosition;
        });
    }
}
const $0f261471404994f4$export$4c11677f6b5bfb11 = (value)=>{
    return {
        lines: value.replace(/[\u2009-\u200f\r\t]/g, "") // Undesirable non-printing chars
        .split(/\n/).map((line)=>({
                textBlocks: [
                    {
                        text: line,
                        type: "text"
                    }
                ]
            }))
    };
};
const $0f261471404994f4$var$$2067a2da3f93f04c$export$e225106f908d1c80 = (div, contentProps)=>{
    const ret = {
        lines: [],
        contentProps: contentProps
    };
    // Set up line counter
    let currentLine = 0;
    // Loop through all child nodes of the div
    div.childNodes.forEach((node)=>{
        // Handle aiev3-line div elements
        /* istanbul ignore else */ if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "DIV") {
            const div = node;
            let line = new $0f261471404994f4$export$f727c5bfed9e77d4("");
            /* istanbul ignore else */ if (div.classList.contains("aiev3-line")) line = new $0f261471404994f4$export$f727c5bfed9e77d4(div);
            else if (div.classList.contains("aiev3-markdown-line")) line = new $0f261471404994f4$export$f727c5bfed9e77d4(div.textContent ?? "", {
                ...$0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54,
                ...ret.contentProps,
                ...contentProps
            });
            // if the current line is not empty, append it
            if (currentLine < ret.lines.length && ret.lines[currentLine].lineText.length > 0) {
                ret.lines[currentLine] = new $0f261471404994f4$export$f727c5bfed9e77d4([
                    ...ret.lines[currentLine].textBlocks,
                    ...line.textBlocks
                ], ret.contentProps);
                currentLine++;
            } else {
                ret.lines.push(line);
                currentLine++;
            }
        } else if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent ?? "";
            const lines = $0f261471404994f4$export$4c11677f6b5bfb11(text).lines.map((l)=>new $0f261471404994f4$export$f727c5bfed9e77d4(l));
            // Push each line to the ret.lines array, do not increment currentLine
            ret.lines.push(...lines);
        }
        // Always take contentProps from the input if it exists
        /* istanbul ignore else */ if (contentProps) ret.contentProps = contentProps;
    });
    // Trim down to data to return
    return {
        lines: ret.lines.map((l)=>l.data),
        contentProps: ret.contentProps
    };
};
/**
 * Finds the text node at a specific character offset within an HTML element.
 * Traverses child nodes accounting for locked blocks and special formatting to locate the text node and its internal offset.
 *
 * @param el - The HTML element to search for text nodes in
 * @param offset - The character offset position to locate within the element's text content
 * @returns Object with the text node and internal offset, or null if not found
 */ const $0f261471404994f4$var$$ca31a371b094ebb3$export$dded4910b0de370b = (el, offset)=>{
    let currentPos = 0;
    if (el) for(let _i = 0; _i < el.childNodes.length && currentPos <= offset; _i++){
        const currentNode = el.childNodes[_i];
        /* istanbul ignore else */ if (currentPos + (currentNode?.textContent?.replaceAll(/[\u2009-\u200f]/g, "") ?? "").length < offset) currentPos += (currentNode?.textContent?.replaceAll(/[\u2009-\u200f]/g, "") ?? "").length;
        else if (currentNode instanceof HTMLSpanElement && currentNode.classList.contains("is-locked") && offset !== 0) {
            const nextSibling = currentNode.nextSibling;
            if (nextSibling instanceof Text) return {
                node: nextSibling,
                offset: 0
            };
            else {
                const newTextNode = document.createTextNode("");
                el.insertBefore(newTextNode, nextSibling);
                return {
                    node: newTextNode,
                    offset: 0
                };
            }
        } else if (currentNode instanceof Element) return $0f261471404994f4$var$$ca31a371b094ebb3$export$dded4910b0de370b(currentNode, offset - currentPos);
        else if (currentNode instanceof Text) /* istanbul ignore else */ return {
            node: currentNode,
            offset: offset - currentPos
        };
    }
    return null;
};
function $0f261471404994f4$var$$91b8bca718afa68e$export$97ab23b40042f8af(el, pos) {
    // Go to a lower line if required
    /* istanbul ignore else */ if (el instanceof HTMLDivElement && el.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line").length > 0) {
        const lines = el.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line");
        /* istanbul ignore else */ if (lines && pos.startLine < lines.length) {
            const f = $0f261471404994f4$var$$ca31a371b094ebb3$export$dded4910b0de370b(lines[pos.startLine], pos.startChar);
            const l = $0f261471404994f4$var$$ca31a371b094ebb3$export$dded4910b0de370b(lines[pos.endLine], pos.endChar);
            /* istanbul ignore else */ if (f) {
                const range = document.createRange();
                range.setStart(f.node, f.offset);
                /* istanbul ignore else */ if (l) range.setEnd(l.node, l.offset);
                const sel = window.getSelection();
                /* istanbul ignore else */ if (sel && document.contains(range.startContainer) && document.contains(range.endContainer)) {
                    sel.removeAllRanges();
                    // Text node between locked spans
                    if (range.startOffset === 0 && range.startContainer instanceof Text && range.startContainer.parentElement instanceof HTMLDivElement && range.startContainer.nextSibling instanceof HTMLSpanElement && range.startContainer.nextSibling.classList.contains("is-locked") && range.startContainer.previousSibling instanceof HTMLSpanElement && range.startContainer.previousSibling.classList.contains("is-locked") && range.startContainer.textContent === "") range.startContainer.textContent = "\u200b";
                    if (range.endOffset === 0 && range.endContainer instanceof Text && range.endContainer.parentElement instanceof HTMLDivElement && range.endContainer.nextSibling instanceof HTMLSpanElement && range.endContainer.nextSibling.classList.contains("is-locked") && range.endContainer.previousSibling instanceof HTMLSpanElement && range.endContainer.previousSibling.classList.contains("is-locked") && range.endContainer.textContent === "") range.endContainer.textContent = "\u200b";
                    // Backwards selection
                    if (pos.data.focusAt === "start") sel.setBaseAndExtent(range.endContainer, range.endOffset, range.startContainer, range.startOffset);
                    else {
                        sel.addRange(range);
                        /* istanbul ignore else */ if (pos.isCollapsed) sel.collapseToEnd();
                    }
                }
            }
            return $0f261471404994f4$var$$87c84f58544c8738$export$7d120213748299d3(el);
        }
    }
    return null;
}
class $0f261471404994f4$var$$5a0668075ad354fa$export$79e893ac3b4e6564 {
    /**
   * Whether the selection is collapsed (caret) rather than a range.
   *
   * @returns boolean
   */ get isCollapsed() {
        return this.initialLine === this.focusLine && this.initialChar === this.focusChar;
    }
    /**
   * The lower of the two line indices making up the selection.
   *
   * @returns number
   */ get startLine() {
        return Math.min(this.initialLine, this.focusLine);
    }
    /**
   * The higher of the two line indices making up the selection.
   *
   * @returns number
   */ get endLine() {
        return Math.max(this.initialLine, this.focusLine);
    }
    /**
   * The starting character index of the selection (smallest character index
   * considering line ordering and collapsed selections).
   *
   * @returns number
   */ get startChar() {
        return this.initialLine < this.focusLine ? this.initialChar : this.initialLine > this.focusLine ? this.focusChar : Math.min(this.initialChar, this.focusChar);
    }
    /**
   * The ending character index of the selection (largest character index
   * considering line ordering and collapsed selections).
   *
   * @returns number
   */ get endChar() {
        return this.initialLine < this.focusLine ? this.focusChar : this.initialLine > this.focusLine ? this.initialChar : Math.max(this.initialChar, this.focusChar);
    }
    /**
   * Current start/end selection information derived from this position.
   * Includes `isCollapsed` and the computed `focusAt` direction.
   *
   * @returns A plain `EditorV3Position` object representing the current
   *          selection range.
   */ get pos() {
        return {
            startLine: this.startLine,
            startChar: this.startChar,
            endLine: this.endLine,
            endChar: this.endChar,
            isCollapsed: this.isCollapsed,
            focusAt: this.endLine === this.focusLine && this.endChar === this.focusChar ? "end" : "start"
        };
    }
    /**
   * The raw floating position data with initial/focus coordinates.
   * Useful for serialising or restoring precise caret state.
   *
   * @returns An `EditorV3PositionF` representing the internal anchor and
   *          focus coordinates.
   */ get posF() {
        return {
            initialLine: this.initialLine,
            initialChar: this.initialChar,
            focusLine: this.focusLine,
            focusChar: this.focusChar
        };
    }
    /**
   * Serialised position data including start/end, collapse state and
   * caret focus direction.
   */ get data() {
        return {
            ...this.pos,
            initialLine: this.initialLine,
            initialChar: this.initialChar,
            focusLine: this.focusLine,
            focusChar: this.focusChar
        };
    }
    /**
   * Create a new position instance.
   *
   * @param initialLine - Initial anchor line index
   * @param initialChar - Initial anchor character index
   * @param focusLine - Focus line index
   * @param focusChar - Focus character index
   * @param lineLengths - Array of line lengths used for bounds checking
   * @param words - Word positions used for word-wise navigation
   */ constructor(initialLine, initialChar, focusLine, focusChar, lineLengths, words){
        this.lastAction = "move";
        this.lastKey = undefined;
        this.initialLine = initialLine;
        this.initialChar = initialChar;
        this.focusLine = focusLine;
        this.focusChar = focusChar;
        this.lineLengths = lineLengths;
        this.words = words;
    }
    /**
   * Internal helper used to adjust collapse state after movement operations.
   *
   * @param shiftKey - Whether the shift key is pressed
   */ _checkCollapse(shiftKey) {
        if (this.lastAction === "move" && !shiftKey) {
            this.initialLine = this.focusLine;
            this.initialChar = this.focusChar;
        } else if (this.lastAction !== "select" && shiftKey) this.lastAction = "select";
    }
    /**
   * Set the caret/selection based on an external `EditorV3Position` input.
   *
   * @param posInput - Position object describing the desired selection
   */ setCaret(posInput) {
        const pos = posInput;
        if (pos && !pos.focusAt) pos.focusAt = "end";
        if (pos && !(0, $gSkQi.isEqual)(pos, this.pos)) {
            if (pos.focusAt === "end") {
                this.initialLine = pos.startLine;
                this.initialChar = pos.startChar;
                this.focusLine = pos.endLine;
                this.focusChar = pos.endChar;
            } else {
                this.initialLine = pos.endLine;
                this.initialChar = pos.endChar;
                this.focusLine = pos.startLine;
                this.focusChar = pos.startChar;
            }
        }
    }
    /**
   * Move the caret left by one character or word depending on modifier keys.
   *
   * @param shiftKey - Whether the shift key is pressed (extend selection)
   * @param ctrlKey - Whether the ctrl key is pressed (jump by word)
   */ moveLeft(shiftKey, ctrlKey) {
        // CTRL at the start of a line to beginning of item
        if (ctrlKey && this.focusChar === 0 && this.focusLine > 0) {
            this.focusLine = 0;
            this.focusChar = 0;
        } else if (ctrlKey) {
            const nextWordBoundary = this.words.filter((w)=>w.line === this.focusLine && w.startChar < this.focusChar).reduce((acc, cur)=>cur.startChar > acc ? cur.startChar : acc, 0);
            this.focusChar = nextWordBoundary;
        } else if (!this.isCollapsed && !shiftKey) {
            this.focusChar = this.startChar;
            this.lastAction = "move";
        } else if (this.focusChar === 0) {
            if (this.focusLine > 0) {
                this.focusLine -= 1;
                this.focusChar = this.lineLengths[this.focusLine];
            }
        } else {
            this.focusChar -= 1;
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.startChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.endChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move the caret right by one character or word depending on modifier keys.
   *
   * @param shiftKey - Whether the shift key is pressed (extend selection)
   * @param ctrlKey - Whether the ctrl key is pressed (jump by word)
   */ moveRight(shiftKey, ctrlKey) {
        // CTRL at the end of a line to end of item
        if (ctrlKey && this.focusChar === this.lineLengths[this.focusLine] && this.focusLine < this.lineLengths.length - 1) {
            this.focusLine = this.lineLengths.length - 1;
            this.focusChar = this.lineLengths[this.focusLine];
        } else if (ctrlKey) {
            const nextWordBoundary = this.words.filter((w)=>w.line === this.focusLine && w.endChar > this.focusChar).reduce((acc, cur)=>cur.endChar < acc ? cur.endChar : acc, this.lineLengths[this.focusLine]);
            this.focusChar = nextWordBoundary;
        } else if (!this.isCollapsed && !shiftKey) {
            this.focusChar = this.endChar;
            this.lastAction = "move";
        } else if (this.focusChar === this.lineLengths[this.focusLine]) {
            if (this.focusLine < this.lineLengths.length - 1) {
                this.focusLine += 1;
                this.focusChar = 0;
            }
        } else {
            this.focusChar += 1;
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.endChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.startChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move the caret up one line, adjusting character position and handling
   * locked-word expansion.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the top/beginning
   */ moveUp(shiftKey, ctrlKey) {
        // Already at the top
        /* istanbul ignore else */ if (this.focusLine === 0) {
            this.focusChar = 0;
            this.lastAction = "move";
        } else if (this.focusLine > 0) {
            if (ctrlKey) this.focusLine = 0;
            else this.focusLine -= 1;
            // Check line length
            if (this.focusChar > this.lineLengths[this.focusLine]) this.focusChar = this.lineLengths[this.focusLine];
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.startChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.endChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move the caret down one line, adjusting character position and handling
   * locked-word expansion.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the end/bottom
   */ moveDown(shiftKey, ctrlKey) {
        // Already at the bottom
        /* istanbul ignore else */ if (this.focusLine === this.lineLengths.length - 1) {
            this.focusChar = this.lineLengths[this.focusLine];
            this.lastAction = "move";
        } else if (this.focusLine < this.lineLengths.length - 1) {
            if (ctrlKey) this.focusLine = this.lineLengths.length - 1;
            else this.focusLine += 1;
            // Check line length
            if (this.focusChar > this.lineLengths[this.focusLine]) this.focusChar = this.lineLengths[this.focusLine];
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.endChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.startChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move caret to the start of the current line or top of content if `ctrlKey`.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the very start
   */ moveHome(shiftKey, ctrlKey) {
        // Move to the top line on CTRL to already at the start
        if (ctrlKey || this.startChar === 0) this.focusLine = 0;
        this.focusChar = 0;
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move caret to the end of the current line or bottom of content if `ctrlKey`.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the very end
   */ moveEnd(shiftKey, ctrlKey) {
        if (ctrlKey || this.endChar === this.lineLengths[this.endLine]) this.focusLine = this.lineLengths.length - 1;
        this.focusChar = this.lineLengths[this.focusLine];
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
}
class $0f261471404994f4$export$1a4903393d6b1b7d {
    /**
   * Current text alignment.
   */ get textAlignment() {
        return this._textAlignment;
    }
    /**
   * Set text alignment.
   *
   * @param newTa - The new text alignment value
   */ set textAlignment(newTa) {
        /* istanbul ignore else */ if (newTa !== this._textAlignment) {
            this.lines.forEach((l)=>l.contentProps.textAlignment = newTa);
            this._textAlignment = newTa;
        }
    }
    /**
   * Current decimal alignment percent.
   */ get decimalAlignPercent() {
        return this._decimalAlignPercent;
    }
    /**
   * Set decimal alignment percent.
   *
   * @param newDap - The new decimal alignment percentage
   */ set decimalAlignPercent(newDap) {
        /* istanbul ignore else */ if (newDap !== this._decimalAlignPercent) {
            this.lines.forEach((l)=>l.contentProps.decimalAlignPercent = newDap);
            this._decimalAlignPercent = newDap;
        }
    }
    /**
   * Current available styles in the editor.
   */ get styles() {
        return this._styles;
    }
    /**
   * Set available styles.
   *
   * @param newStyles - The new style definitions
   */ set styles(newStyles) {
        this._styles = newStyles;
    }
    /**
   * Get all styles currently used in the content.
   */ get hasStyles() {
        const usedStyles = new Set();
        this.lines.forEach((line)=>{
            line.getAllStyles().forEach((s)=>usedStyles.add(s));
        });
        return Array.from(usedStyles).sort((a, b)=>a.localeCompare(b));
    }
    /**
   * Whether markdown syntax is allowed.
   */ get allowMarkdown() {
        return this._allowMarkdown;
    }
    /**
   * Set whether markdown syntax is allowed.
   *
   * @param newAllow - Whether to allow markdown
   */ set allowMarkdown(newAllow) {
        this._allowMarkdown = newAllow;
    }
    /**
   * Current markdown parsing settings.
   */ get markdownSettings() {
        return this._markdownSettings;
    }
    /**
   * Set markdown parsing settings.
   *
   * @param newSettings - The new markdown settings
   */ set markdownSettings(newSettings) {
        this._markdownSettings = newSettings;
        this.lines.forEach((l)=>l.contentProps.markdownSettings = newSettings);
    }
    /**
   * Whether to display markdown syntax instead of rendered content.
   */ get showMarkdown() {
        return this._showMarkdown;
    }
    /**
   * Set whether to display markdown syntax.
   *
   * @param newShow - Whether to show markdown
   */ set showMarkdown(newShow) {
        this._showMarkdown = newShow;
    }
    /**
   * Whether window view mode is allowed.
   */ get allowWindowView() {
        return this._allowWindowView;
    }
    /**
   * Set whether window view mode is allowed.
   *
   * @param newAllow - Whether to allow window view
   */ set allowWindowView(newAllow) {
        this._allowWindowView = newAllow;
    }
    /**
   * Function to fetch at-mention suggestions.
   */ get atListFunction() {
        return this._atListFunction;
    }
    /**
   * Maximum number of at-mention suggestions to display.
   */ get maxAtListLength() {
        return this._maxAtListLength;
    }
    /**
   * Whether multiple lines are allowed.
   */ get allowNewLine() {
        return this._allowNewLine;
    }
    /**
   * Set whether multiple lines are allowed.
   *
   * @param newAllow - Whether to allow new lines
   */ set allowNewLine(newAllow) {
        this._allowNewLine = newAllow;
    }
    /**
   * Array of line lengths.
   */ get lineLengths() {
        return this.lines.map((l)=>l.lineLength);
    }
    /**
   * Array of word positions across all lines.
   */ get wordPositions() {
        return this.lines.flatMap((l, ix)=>l.wordPositions.map((w)=>({
                    ...w,
                    line: ix
                })));
    }
    /**
   * Gets the caret position.
   *
   * @returns The current caret position or null
   */ get caretPosition() {
        return this._caretPosition?.pos ?? null;
    }
    /**
   * Sets the caret position.
   *
   * @param posInput - The new caret position or null
   */ set caretPosition(posInput) {
        if (posInput === null) this._caretPosition = null;
        else if (this._caretPosition) this._caretPosition.setCaret(posInput);
        else {
            const newPos = posInput.focusAt === "start" ? new $0f261471404994f4$var$$5a0668075ad354fa$export$79e893ac3b4e6564(posInput.endLine, posInput.endChar, posInput.startLine, posInput.startChar, this.lineLengths, this.wordPositions) : new $0f261471404994f4$var$$5a0668075ad354fa$export$79e893ac3b4e6564(posInput.startLine, posInput.startChar, posInput.endLine, posInput.endChar, this.lineLengths, this.wordPositions);
            this._caretPosition = newPos;
        }
    }
    /**
   * Gets the caret position with focus information.
   *
   * @returns The current caret position with focus or null
   */ get caretPositionF() {
        return this._caretPosition?.posF ?? null;
    }
    /**
   * Sets the caret position with focus information.
   *
   * @param posInput - The new caret position with focus or null
   */ set caretPositionF(posInput) {
        if (posInput === null) this._caretPosition = null;
        else this._caretPosition = new $0f261471404994f4$var$$5a0668075ad354fa$export$79e893ac3b4e6564(posInput.initialLine, posInput.initialChar, posInput.focusLine, posInput.focusChar, this.lineLengths, this.wordPositions);
    }
    /**
   * Indicates if the current content can be updated with this selection.
   *
   * @param pos - The position to check
   * @returns True if caret is locked
   */ isCaretLocked(pos = this._caretPosition) {
        /* istanbul ignore else */ if (!pos || pos.isCollapsed) return false;
        const selectedBlocks = this.subLines(pos).flatMap((l)=>l.textBlocks);
        return selectedBlocks.length > 1 && selectedBlocks.some((b)=>b.isLocked);
    }
    /**
   * Check if any at blocks are present that can be locked.
   *
   * @returns True if lockable at blocks exist
   */ get _isLockable() {
        return this.lines.some((l)=>l.textBlocks.some((tb)=>tb.type === "at" && !tb.isLocked));
    }
    /**
   * Text from the element.
   *
   * @returns Plain text content
   */ get text() {
        return this.lines.map((l)=>l.lineText).join("\n");
    }
    /**
   * Markdown text from the element.
   *
   * @returns Markdown formatted content
   */ get markdownText() {
        return this.lines.map((l)=>l.lineMarkdown).join("\n");
    }
    /**
   * Returns true if the content is not plain text.
   *
   * @returns True if content has styles or special blocks
   */ get isEnhanced() {
        return this.lines.some((l)=>l.isEnhanced);
    }
    /**
   * Current content properties.
   *
   * @returns Content properties object
   */ get contentProps() {
        return {
            textAlignment: this._textAlignment,
            decimalAlignPercent: this._decimalAlignPercent,
            styles: this._styles,
            allowNewLine: this._allowNewLine,
            allowWindowView: this._allowWindowView,
            showMarkdown: this._showMarkdown,
            markdownSettings: this._markdownSettings,
            allowMarkdown: this._allowMarkdown,
            atListFunction: this.atListFunction,
            maxAtListLength: this._maxAtListLength
        };
    }
    /**
   * Data representation of content.
   *
   * @returns Serializable content data
   */ get data() {
        const contentProps = (0, $gSkQi.cloneDeep)(this.contentProps);
        Object.keys($0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54).forEach((k)=>{
            const key = k;
            /* istanbul ignore else */ if (typeof this[key] === "function") delete contentProps[key];
            if ((0, $gSkQi.isEqual)(this[key], this._defaultContentProps[key])) delete contentProps[key];
        });
        const lines = this.lines.map((l)=>({
                textBlocks: l.textBlocks.map((tb)=>tb.data)
            }));
        const ret = {
            lines: lines
        };
        if (Object.keys(contentProps).length > 0) ret.contentProps = contentProps;
        if (this._caretPosition) ret.caretPosition = this._caretPosition.pos;
        return ret;
    }
    /**
   * Element to render.
   *
   * @param renderProps - The rendering properties
   * @returns Document fragment containing the rendered HTML
   */ toHtml(renderProps) {
        // Remove any existing dropdowns
        const previousDropdown = document.querySelectorAll(".aiev3-dropdown-list");
        previousDropdown.forEach((dropdown)=>dropdown.remove());
        // Create new DocumentFragment
        const ret = new DocumentFragment();
        // Add each line to the element
        this.lines.forEach((l)=>ret.append(l.toHtml(renderProps)));
        // Add content properties node
        /* istanbul ignore else */ if (renderProps.editableEl) renderProps.editableEl.append(ret);
        return ret;
    }
    /**
   * Convert the editor model into a markdown-styled HTML fragment.
   *
   * @param renderProps - Rendering options applied during build
   */ toMarkdownHtml(renderProps) {
        const ret = new DocumentFragment();
        // Add content to the element
        this.lines.forEach((l)=>ret.append(l.toMarkdown(renderProps)));
        /* istanbul ignore else */ if (renderProps.editableEl) renderProps.editableEl.append(ret);
        return ret;
    }
    /**
   * Create a new EditorV3Content instance from a string, DOM node or model.
   *
   * @param arg - Optional source content: HTML `div`, serialized JSON string or model
   * @param props - Optional content properties to override defaults
   */ constructor(arg, props){
        this._defaultContentProps = (0, $gSkQi.cloneDeep)($0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54);
        // Standard attributes
        this._textAlignment = this._defaultContentProps.textAlignment;
        this._decimalAlignPercent = this._defaultContentProps.decimalAlignPercent;
        this._styles = this._defaultContentProps.styles;
        this._allowMarkdown = this._defaultContentProps.allowMarkdown;
        this._markdownSettings = this._defaultContentProps.markdownSettings;
        this._showMarkdown = this._defaultContentProps.showMarkdown;
        this._allowWindowView = this._defaultContentProps.allowWindowView;
        this._maxAtListLength = this._defaultContentProps.maxAtListLength;
        /**
   * Current lines in the editor.
   */ this.lines = [];
        this._allowNewLine = this._defaultContentProps.allowNewLine;
        /**
   * Current caret position and lock status.
   */ this._caretPosition = null;
        /**
   * Handle copy and cut inside the holding div
   *
   * @param e Copy or cut event
   */ this.handleCopy = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            /* istanbul ignore else */ if (this._caretPosition) {
                const toClipboard = this.subLines(this._caretPosition);
                e.clipboardData.setData("text/plain", toClipboard.map((l)=>l.lineText).join("\n"));
                e.clipboardData.setData("text/html", toClipboard.map((l)=>l.toHtml({}).outerHTML).join(""));
                e.clipboardData.setData("data/aiev3", JSON.stringify(toClipboard.map((l)=>l.data)));
                /* istanbul ignore else */ if (e.type === "cut" && !this.isCaretLocked()) this.splice(this._caretPosition);
            }
        };
        // Process incoming data
        /* istanbul ignore else */ if (arg instanceof HTMLDivElement) {
            // Remove skip-read elements
            const skipRead = arg.querySelectorAll(".skip-read");
            skipRead.forEach((el)=>el.remove());
            // Read in HTML
            const r = $0f261471404994f4$var$$2067a2da3f93f04c$export$e225106f908d1c80(arg, props ?? this.contentProps);
            this._copyImport(r);
            this.caretPositionF = $0f261471404994f4$var$$87c84f58544c8738$export$7d120213748299d3(arg);
        } else if (typeof arg === "string") this.loadString(arg, props);
        else if (arg !== undefined) this._copyImport(arg, props);
        else this.lines = [
            new $0f261471404994f4$export$f727c5bfed9e77d4()
        ];
        // Forced parameters
        if (props) {
            this._updateProps(props);
            this.lines.map((l)=>l.contentProps = this.contentProps);
        }
        if (this.lines.length === 0) this.lines = [
            new $0f261471404994f4$export$f727c5bfed9e77d4()
        ];
    }
    /**
   * Update internal content properties from provided settings.
   *
   * @param props - Partial content properties to merge into the instance
   */ _updateProps(props) {
        if (props.allowMarkdown !== undefined) this._allowMarkdown = props.allowMarkdown;
        if (props.allowNewLine !== undefined) this._allowNewLine = props.allowNewLine;
        if (props.allowWindowView !== undefined) this._allowWindowView = props.allowWindowView;
        if (props.decimalAlignPercent !== undefined) this._decimalAlignPercent = props.decimalAlignPercent;
        if (props.markdownSettings !== undefined) this._markdownSettings = props.markdownSettings;
        if (props.showMarkdown !== undefined) this._showMarkdown = props.showMarkdown;
        if (props.styles !== undefined) this._styles = props.styles;
        if (props.textAlignment !== undefined) this._textAlignment = props.textAlignment;
        if (props.atListFunction !== undefined) this._atListFunction = props.atListFunction;
        if (props.maxAtListLength !== undefined) this._maxAtListLength = props.maxAtListLength;
    }
    /* istanbul ignore else */ /**
   * Debug helper that logs a representation of the content lines to the console.
   *
   * @param from - Label to prefix the debug output
   */ _debugText(from) {
        console.debug(from + "\n", this.lines.map((l)=>l.textBlocks.map((tb)=>tb.text).join("|")).join("\n"));
    }
    /**
   * Copy data from a parsed model into this instance, merging content props.
   *
   * @param read - Model data to import into this instance
   * @param props - Optional properties to merge during import
   */ _copyImport(read, props) {
        const consolidatedProps = {
            ...read.contentProps,
            ...props
        };
        this._updateProps(consolidatedProps);
        this.lines = read.lines.map((l)=>l instanceof $0f261471404994f4$export$f727c5bfed9e77d4 ? l : new $0f261471404994f4$export$f727c5bfed9e77d4(l, consolidatedProps));
        this.caretPosition = read.caretPosition ?? null;
    }
    /**
   * Load content from a serialized string representation. Attempts JSON first,
   * falls back to parsing HTML and finally to a V3 string conversion.
   *
   * @param arg - String input containing JSON, HTML or plain text
   * @param props - Optional content props to apply during load
   */ loadString(arg, props) {
        try {
            // Check for stringified class input
            const jsonInput = JSON.parse(arg);
            if (!Array.isArray(jsonInput.lines)) throw "No lines";
            this._copyImport(jsonInput, props);
        } catch  {
            // Check if the input is HTML
            /* istanbul ignore else */ if (arg.match(/^<div(.*)<\/div>$/i)) {
                // Read in v3 HTML/text
                const div = document.createElement("div");
                div.innerHTML = arg;
                // Check this is a v3 input
                /* istanbul ignore else */ if (Array.from(div.childNodes).every((node)=>node.nodeType === Node.ELEMENT_NODE && node.nodeName === "DIV" && (node.classList.contains("aiev3-line") || node.classList.contains("aiev3-markdown-line")))) {
                    const r = $0f261471404994f4$var$$2067a2da3f93f04c$export$e225106f908d1c80(div, props ?? this.contentProps);
                    this._copyImport(r);
                    return;
                }
            }
            this._copyImport($0f261471404994f4$export$4c11677f6b5bfb11(arg));
        }
    }
    /**
   * Return a subset of `EditorV3Line` instances from the content based on a position.
   *
   * @param pos - Position object describing a range within the content
   */ subLines(pos) {
        const ret = [];
        if (pos.startLine === pos.endLine && pos.startChar === pos.endChar && pos.startLine < this.lines.length) {
            const style = this.lines[pos.startLine].getStyleAt(pos.startChar);
            ret.push(new $0f261471404994f4$export$f727c5bfed9e77d4([
                $0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    text: "",
                    style: style
                })
            ], this.contentProps));
        }
        // Check selection contains something
        if (pos.startLine < this.lines.length && (pos.startLine === pos.endLine && pos.startChar < pos.endChar || pos.startLine < pos.endLine)) {
            // First line
            /* istanbul ignore else */ if (pos.startLine <= pos.endLine) {
                const subBlocks = new $0f261471404994f4$export$f727c5bfed9e77d4(this.lines[pos.startLine].subBlocks(pos.startChar, pos.startLine === pos.endLine ? pos.endChar : undefined), this.contentProps);
                if (subBlocks.textBlocks.length === 0) subBlocks.textBlocks.push($0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    text: ""
                }));
                ret.push(subBlocks);
            }
            // At least one line between
            if (pos.startLine + 1 < pos.endLine) ret.push(...this.lines.slice(pos.startLine + 1, pos.endLine));
            // End line to end character
            if (pos.startLine < pos.endLine && pos.endLine < this.lines.length) ret.push(new $0f261471404994f4$export$f727c5bfed9e77d4(this.lines[pos.endLine].upToPos(pos.endChar), this.contentProps));
        }
        return ret;
    }
    /**
   * Return the lines from the start of the content up to the specified
   * end position. The returned array represents the content slice ending
   * at the given line/character (exclusive of any subsequent content).
   *
   * @param endLine - Zero-based index of the line to end at.
   * @param endChar - Character index on `endLine` to end at.
   * @returns An array of `EditorV3Line` representing the content up to the
   *          specified position.
   */ upToPos(endLine, endChar) {
        return this.subLines({
            startLine: 0,
            startChar: 0,
            endLine: endLine,
            endChar: endChar
        });
    }
    /**
   * Return the lines from the specified start position to the end of the
   * content. This is the complement of `upToPos` and includes all content
   * from `startLine`/`startChar` through the last line.
   *
   * @param startLine - Zero-based index of the line to start from.
   * @param startChar - Character index on `startLine` to start from.
   * @returns An array of `EditorV3Line` representing the content from the
   *          specified position to the end.
   */ fromPos(startLine, startChar) {
        return this.subLines({
            startLine: startLine,
            startChar: startChar,
            endLine: this.lines.length - 1,
            endChar: this.lines[this.lines.length - 1].lineLength
        });
    }
    /**
   * Get the active style at a particular line and character index.
   * Returns the style name if present, otherwise `undefined`.
   *
   * @param line - Zero-based line index to query.
   * @param character - Character index within the line to query.
   * @returns The style name at the specified position, or `undefined`.
   */ getStyleAt(line, character) {
        return line < this.lines.length ? this.lines[line].getStyleAt(character) : undefined;
    }
    /**
   * Split the content at the given position. The line containing `pos`
   * will be split into two lines and the internal `lines` array updated.
   * The returned value is the new collapsed caret position after the split.
   *
   * @param pos - Position at which to split the line.
   * @returns A collapsed `EditorV3Position` representing the caret after
   *          the split.
   */ splitLine(pos) {
        const u = this.upToPos(pos.startLine, pos.startChar);
        const f = this.fromPos(pos.endLine, pos.endChar);
        const newLines = [
            ...u,
            ...f
        ];
        this.lines = newLines;
        return {
            isCollapsed: true,
            startLine: pos.startLine + 1,
            startChar: 0,
            endLine: pos.startLine + 1,
            endChar: 0
        };
    }
    /**
   * Merge the specified line with the following line if the following
   * line exists. After merging, the following line is removed.
   *
   * @param line - Index of the line to merge with the next line.
   */ mergeLines(line) {
        if (this.lines.length > line + 1) {
            this.lines[line].insertBlocks(this.lines[line + 1].textBlocks, this.lines[line].lineLength);
            this.lines.splice(line + 1, 1);
        }
    }
    /**
   * Delete a character at or around the current caret position. When
   * `backwards` is true the method behaves like a backspace; otherwise
   * it behaves like a forward delete. Optionally provide a `pos` to set
   * the caret before deletion.
   *
   * @param backwards - If true, delete backwards (backspace). If false,
   *        delete forwards (delete).
   * @param pos - Optional position to set as the caret before deletion.
   */ deleteCharacter(backwards, pos) {
        // Update caret position
        if (pos) this.caretPosition = pos;
        // Check caret position exists
        if (this._caretPosition && this._caretPosition.isCollapsed) {
            // Extend selection one place backwards
            if (backwards) this._caretPosition?.moveLeft(true, false);
            else this._caretPosition?.moveRight(true, false);
        }
        /* istanbul ignore else */ if (this._caretPosition) this.splice(this._caretPosition.pos);
    }
    /**
   * Find all occurrences of the given text in the content and return an
   * array of `EditorV3Position` ranges for each match. Returns `null` if
   * no matches are found.
   *
   * @param text - The substring to search for.
   * @returns An array of positions for each match, or `null` when none are
   *          found.
   */ getTextPosition(text) {
        const ret = [];
        this.lines.forEach((l, ix)=>{
            l.textBlocks.forEach((tb)=>{
                let pos = 0;
                while(tb.text.indexOf(text, pos) >= 0){
                    const found = tb.text.indexOf(text, pos);
                    /* istanbul ignore else */ if (found >= 0) {
                        ret.push({
                            isCollapsed: false,
                            startLine: ix,
                            startChar: tb.lineStartPosition + found,
                            endLine: ix,
                            endChar: tb.lineStartPosition + found + text.length
                        });
                        pos = found + text.length;
                    }
                }
            });
        });
        return ret.length > 0 ? ret : null;
    }
    /**
   * Replace the content in `pos` with the optional `newLines`. Returns
   * the lines that were removed by the splice operation.
   *
   * @param pos - The position range to replace.
   * @param newLines - Optional array of `EditorV3Line` to insert at `pos`.
   * @returns An array of `EditorV3Line` representing the removed content.
   */ splice(pos, newLines) {
        // if (this._showMarkdown) {
        //   return this.spliceMarkdown(pos, newLines);
        // } else
        if (pos.startLine < this.lines.length && pos.startLine <= pos.endLine && !(pos.startLine === pos.endLine && pos.endChar < pos.startChar)) {
            const ret = this.subLines(pos);
            const u = this.upToPos(pos.startLine, pos.startChar);
            const f = this.fromPos(pos.endLine, pos.endChar);
            this.lines = [
                ...u,
                ...newLines ? newLines.map((l)=>new $0f261471404994f4$export$f727c5bfed9e77d4(l, this.contentProps)) : [],
                ...f
            ];
            // Merge line after U
            this.mergeLines(pos.startLine);
            // Merge line after newLines if it exists and there is something after it
            if (newLines?.length) this.mergeLines(pos.startLine + newLines.length - 1);
            // Check all lines have at least 1 text block
            this.lines.forEach((l)=>{
                /* istanbul ignore else */ if (l.textBlocks.length === 0) l.textBlocks.push($0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    text: "",
                    style: l.getStyleAt(0)
                }));
            });
            // Calculate end character position
            const endChar = !newLines || newLines.length === 0 ? pos.startChar : newLines?.length === 1 ? pos.startChar + newLines[0].lineLength : newLines[newLines.length - 1].lineLength;
            // Update caret position if it is set
            if (this._caretPosition) this._caretPosition = new $0f261471404994f4$var$$5a0668075ad354fa$export$79e893ac3b4e6564(pos.startLine + (newLines ? newLines.length - 1 : 0), endChar, pos.startLine + (newLines ? newLines?.length - 1 : 0), endChar, this.lineLengths, this.wordPositions);
            return ret;
        }
        return [];
    }
    /**
   * Apply a named style to the text within the given position or the
   * current selection. When `applyPos` is omitted the current caret
   * selection is used. The method returns `this` to allow chaining.
   *
   * @param styleName - The style identifier to apply.
   * @param applyPos - Optional position to apply the style to instead of
   *        using the current selection.
   * @returns The current `EditorV3Content` instance for chaining.
   */ applyStyle(styleName, applyPos) {
        /* istanbul ignore else */ if (applyPos || this._caretPosition && !this._caretPosition.isCollapsed) {
            const pos = applyPos ?? this._caretPosition?.pos;
            /* istanbul ignore else */ if (pos.startLine < this.lines.length && pos.startLine <= pos.endLine) {
                for(let _i = pos.startLine; _i <= pos.endLine && _i < this.lines.length; _i++)this.lines[_i].applyStyle(styleName, _i === pos.startLine ? pos.startChar : 0, _i === pos.endLine ? pos.endChar : Infinity);
                this.caretPosition = {
                    startLine: pos.endLine,
                    startChar: pos.endChar,
                    endLine: pos.endLine,
                    endChar: pos.endChar
                };
            }
        }
        return this;
    }
    /**
   * Remove any applied style from the text within `removePos` or the
   * current selection. Returns `this` for chaining.
   *
   * @param removePos - Optional position to remove styles from. If omitted
   *        the current selection is used.
   * @returns The current `EditorV3Content` instance.
   */ removeStyle(removePos) {
        /* istanbul ignore else */ if (removePos || this._caretPosition && !this._caretPosition.isCollapsed) {
            const pos = removePos ?? this._caretPosition?.pos;
            /* istanbul ignore else */ if (pos.startLine < this.lines.length && pos.startLine <= pos.endLine) {
                for(let _i = pos.startLine; _i <= pos.endLine && _i < this.lines.length; _i++)this.lines[_i].removeStyle(_i === pos.startLine ? pos.startChar : 0, _i === pos.endLine ? pos.endChar : Infinity);
                this.caretPosition = {
                    startLine: pos.endLine,
                    startChar: pos.endChar,
                    endLine: pos.endLine,
                    endChar: pos.endChar
                };
            }
        }
        return this;
    }
    /**
   * Remove styles from the content that match the specified style names.
   *
   * @param styleNames - Array of style names to remove
   */ cleanStyles(styleNames) {
        this.lines.forEach((l)=>l.cleanStyles(styleNames));
    }
    /**
   * Delete text from the content that uses the specified styles.
   *
   * @param styleNames - Array of style names to delete
   */ deleteStyles(styleNames) {
        const lengthsBefore = this.lineLengths;
        this.lines.forEach((l)=>l.deleteStyles(styleNames));
        // Delete whole lines if they are now empty
        if (this.lines.length > 1) this.lines = this.lines.filter((l, ix)=>l.lineLength !== 0 || lengthsBefore[ix] === 0);
    }
    /**
   * Redraw the editor content into the provided editable element. This
   * will render the content as HTML (or markdown) and restore the caret
   * position if it is set.
   *
   * @param editableEl - The `HTMLDivElement` to render the editor content
   *        into.
   */ redraw(editableEl) {
        // Set active block
        /* istanbul ignore else */ if (this._caretPosition) this.lines[this._caretPosition.startLine].setActiveBlock(this._caretPosition);
        // Draw HTML
        editableEl.innerHTML = "";
        if (this._showMarkdown) this.toMarkdownHtml({
            editableEl: editableEl,
            markdownSettings: this._markdownSettings
        });
        else this.toHtml({
            editableEl: editableEl,
            atListFunction: this._atListFunction,
            maxAtListLength: this._maxAtListLength,
            caretPosition: this._caretPosition,
            styles: this._styles
        });
        // Set caret position
        /* istanbul ignore else */ if (this._caretPosition) $0f261471404994f4$var$$91b8bca718afa68e$export$97ab23b40042f8af(editableEl, this._caretPosition);
    }
    /**
   * Validate and enforce the editor's current status: update the active
   * block based on the caret and enforce locked-block selection rules.
   */ checkStatus() {
        // Set active block
        const activeBlock = this._caretPosition && this._caretPosition.endChar < this.lines[this._caretPosition.endLine].lineLength && this.lines[this._caretPosition.focusLine].setActiveBlock(this._caretPosition);
        // If active block is locked select all
        /* istanbul ignore else */ if (activeBlock && activeBlock.isLocked && this._caretPosition) this.caretPosition = {
            startLine: this._caretPosition.focusLine,
            startChar: activeBlock.lineStartPosition,
            endLine: this._caretPosition.focusLine,
            endChar: activeBlock.lineEndPosition
        };
    }
    /**
   * Handle keyboard down events for editor interactions including
   * selection, navigation, deletion and special key behaviours.
   *
   * @param e - The keyboard event from the editable element.
   */ handleKeydown(e) {
        // Select all
        /* istanbul ignore else */ if (e.ctrlKey && e.code === "KeyA" && this.text !== "") {
            e.stopPropagation();
            e.preventDefault();
            this.caretPosition = {
                startLine: 0,
                startChar: 0,
                endLine: this.lines.length - 1,
                endChar: this.lines[this.lines.length - 1].lineLength
            };
        } else if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End",
            "Backspace",
            "Delete",
            "Escape"
        ].includes(e.key)) {
            e.stopPropagation();
            e.preventDefault();
            if (this._caretPosition === null) this.caretPosition = {
                startLine: 0,
                startChar: 0,
                endLine: 0,
                endChar: 0
            };
            switch(e.key){
                case "ArrowLeft":
                    this._caretPosition.moveLeft(e.shiftKey, e.ctrlKey);
                    break;
                case "ArrowRight":
                    this._caretPosition.moveRight(e.shiftKey, e.ctrlKey);
                    break;
                case "ArrowUp":
                    this._caretPosition.moveUp(e.shiftKey, e.ctrlKey);
                    break;
                case "ArrowDown":
                    this._caretPosition.moveDown(e.shiftKey, e.ctrlKey);
                    break;
                case "Home":
                    this._caretPosition.moveHome(e.shiftKey, e.ctrlKey);
                    break;
                case "End":
                    this._caretPosition.moveEnd(e.shiftKey, e.ctrlKey);
                    break;
                case "Backspace":
                    this.deleteCharacter(true);
                    break;
                case "Delete":
                    this.deleteCharacter(false);
                    break;
                case "Escape":
                    /* istanbul ignore else */ if (this._isLockable) {
                        const lockBlock = this.lines[this._caretPosition.startLine].setActiveBlock(this._caretPosition);
                        /* istanbul ignore else */ if (lockBlock && lockBlock.type === "at") {
                            lockBlock.setActive(false);
                            lockBlock.isLocked = true;
                        }
                    }
            }
        } else if (this._caretPosition && this.allowNewLine && e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            this.caretPosition = this.splitLine(this._caretPosition);
        } else if (this._caretPosition) {
            this._caretPosition.lastAction = "keydown";
            // Reset a locked block to no style if it is the active block
            const activeBlock = this.lines[this._caretPosition.startLine].getBlockAt(this._caretPosition.startChar);
            /* istanbul ignore else */ if (activeBlock && (this.lines[this._caretPosition.endLine].getBlockAt(this._caretPosition.endChar), activeBlock.isLocked && !this._caretPosition.isCollapsed)) activeBlock.style = undefined;
        }
    }
    /**
   * Handle keyboard up events. This updates the caret-derived position
   * cache and suppresses default behaviour for keys managed by the
   * editor.
   *
   * @param e - The keyboard event from the editable element.
   */ handleKeyup(e) {
        // Update caret position
        /* istanbul ignore else */ if (this._caretPosition) this.caretPositionF = $0f261471404994f4$var$$87c84f58544c8738$export$7d120213748299d3(e.currentTarget);
        // Suppress returns on movement keys
        /* istanbul ignore else */ if ([
            "Enter",
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(e.code) || e.ctrlKey && e.code === "KeyA") {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    /**
   * Handle paste events into the editor. This supports pastes from the
   * editor's custom clipboard format (`data/aiev3`) as well as plain text
   * and inserts the resulting lines at the current caret position.
   *
   * @param e - The clipboard event generated by the paste action.
   */ handlePaste(e) {
        e.preventDefault();
        e.stopPropagation();
        // Check cursor is present, and is does not contain a locked block
        /* istanbul ignore else */ if (this._caretPosition && !this.isCaretLocked()) {
            // Get clipboard data
            const lines = [];
            const linesImport = e.clipboardData.getData("data/aiev3") !== "" ? JSON.parse(e.clipboardData.getData("data/aiev3")) : e.clipboardData.getData("text/plain").split("\n").map((t)=>({
                    textBlocks: [
                        {
                            text: t
                        }
                    ]
                }));
            // Just text blocks if only one line is allowed
            /* istanbul ignore else */ if (linesImport.length > 1 && !this.allowNewLine) {
                const textBlocks = linesImport.flatMap((l)=>l.textBlocks).map((tb)=>$0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d(tb));
                lines.push(new $0f261471404994f4$export$f727c5bfed9e77d4(textBlocks, this.contentProps));
            } else lines.push(...linesImport.map((l)=>new $0f261471404994f4$export$f727c5bfed9e77d4(l, this.contentProps)));
            // Splice in new data and set new content
            this.splice(this._caretPosition, lines);
        }
    }
}
const $0f261471404994f4$var$$c6b2f5cf3d81c3c9$export$85877a110f55e05c = (obj)=>{
    return typeof obj === "object" && obj !== null && // Check properties exist
    "textBlocks" in obj && // Check properties types
    Array.isArray(obj.textBlocks) && obj.textBlocks.every((tb)=>"text" in tb);
};
const $0f261471404994f4$export$a2e4f3e0d013ef9f = (obj)=>{
    return typeof obj === "object" && obj !== null && // Check properties exist
    "lines" in obj && // Check properties types
    Array.isArray(obj.lines) && obj.lines.every((line)=>$0f261471404994f4$var$$c6b2f5cf3d81c3c9$export$85877a110f55e05c(line));
};
var $0f261471404994f4$var$$a69491ea5a126553$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "BaseCheckbox", ()=>$0f261471404994f4$export$2148d73965a312db);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "BaseEditorV3", ()=>$0f261471404994f4$export$64d7be461af4ab3e);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "BaseInput", ()=>$0f261471404994f4$export$e1f706e5673fef9e);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "BaseSelect", ()=>$0f261471404994f4$export$dcee1aa94a106d27);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "EditorV3", ()=>$0f261471404994f4$export$c410cc7dbb67874b);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "Expander", ()=>$0f261471404994f4$export$1cfea591e85f6e12);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "ItemInput", ()=>$0f261471404994f4$export$267c05bbab99602d);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "ObjectEditor", ()=>$0f261471404994f4$export$ec7da929f39d97c8);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$a69491ea5a126553$exports, "StylesEditor", ()=>$0f261471404994f4$export$bf67e8fa85c2bdc7);
var $0f261471404994f4$var$$d1df120914c5e45a$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "baseButton", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$ae1096218b504ef6, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$ae1096218b504ef6 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "baseCheckbox", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$ba9edc512d3c089d, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$ba9edc512d3c089d = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "baseCheckboxLabel", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$da22a9df4fc77cee, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$da22a9df4fc77cee = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "baseInput", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$a683444876b8f754, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$a683444876b8f754 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "baseSelect", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$a332407e56744979, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$a332407e56744979 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "closed", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$15ff61f90f7efc74, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$15ff61f90f7efc74 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "closing", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$4e69df80cd44263b, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$4e69df80cd44263b = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "disabled", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$683472f6198a076e, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$683472f6198a076e = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "editorHolder", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$6c8af10980e1f329, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$6c8af10980e1f329 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "errorText", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$f1a76e4a6085c675, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$f1a76e4a6085c675 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "expander", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$f194ed9df726ec47, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$f194ed9df726ec47 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "expanderContent", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$ea222bb8b20e6221, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$ea222bb8b20e6221 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "holder", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$f57c6e831b0d072a, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$f57c6e831b0d072a = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "label", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$1237798dc640739a, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$1237798dc640739a = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "open", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$3ce6949f20cea765, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$3ce6949f20cea765 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "opening", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$47fa9d71658d4a69, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$47fa9d71658d4a69 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$d1df120914c5e45a$exports, "placing", ()=>$0f261471404994f4$var$$d1df120914c5e45a$export$fe2e9688f7413ae2, (v)=>$0f261471404994f4$var$$d1df120914c5e45a$export$fe2e9688f7413ae2 = v);
var $0f261471404994f4$var$$d1df120914c5e45a$export$ae1096218b504ef6;
var $0f261471404994f4$var$$d1df120914c5e45a$export$ba9edc512d3c089d;
var $0f261471404994f4$var$$d1df120914c5e45a$export$da22a9df4fc77cee;
var $0f261471404994f4$var$$d1df120914c5e45a$export$a683444876b8f754;
var $0f261471404994f4$var$$d1df120914c5e45a$export$a332407e56744979;
var $0f261471404994f4$var$$d1df120914c5e45a$export$15ff61f90f7efc74;
var $0f261471404994f4$var$$d1df120914c5e45a$export$4e69df80cd44263b;
var $0f261471404994f4$var$$d1df120914c5e45a$export$683472f6198a076e;
var $0f261471404994f4$var$$d1df120914c5e45a$export$6c8af10980e1f329;
var $0f261471404994f4$var$$d1df120914c5e45a$export$f1a76e4a6085c675;
var $0f261471404994f4$var$$d1df120914c5e45a$export$f194ed9df726ec47;
var $0f261471404994f4$var$$d1df120914c5e45a$export$ea222bb8b20e6221;
var $0f261471404994f4$var$$d1df120914c5e45a$export$f57c6e831b0d072a;
var $0f261471404994f4$var$$d1df120914c5e45a$export$1237798dc640739a;
var $0f261471404994f4$var$$d1df120914c5e45a$export$3ce6949f20cea765;
var $0f261471404994f4$var$$d1df120914c5e45a$export$47fa9d71658d4a69;
var $0f261471404994f4$var$$d1df120914c5e45a$export$fe2e9688f7413ae2;
$0f261471404994f4$var$$d1df120914c5e45a$export$ae1096218b504ef6 = `_5aJ9Rq_baseButton`;
$0f261471404994f4$var$$d1df120914c5e45a$export$ba9edc512d3c089d = `_5aJ9Rq_baseCheckbox`;
$0f261471404994f4$var$$d1df120914c5e45a$export$da22a9df4fc77cee = `_5aJ9Rq_baseCheckboxLabel`;
$0f261471404994f4$var$$d1df120914c5e45a$export$a683444876b8f754 = `_5aJ9Rq_baseInput`;
$0f261471404994f4$var$$d1df120914c5e45a$export$a332407e56744979 = `_5aJ9Rq_baseSelect`;
$0f261471404994f4$var$$d1df120914c5e45a$export$15ff61f90f7efc74 = `_5aJ9Rq_closed`;
$0f261471404994f4$var$$d1df120914c5e45a$export$4e69df80cd44263b = `_5aJ9Rq_closing`;
$0f261471404994f4$var$$d1df120914c5e45a$export$683472f6198a076e = `_5aJ9Rq_disabled`;
$0f261471404994f4$var$$d1df120914c5e45a$export$6c8af10980e1f329 = `_5aJ9Rq_editorHolder`;
$0f261471404994f4$var$$d1df120914c5e45a$export$f1a76e4a6085c675 = `_5aJ9Rq_errorText`;
$0f261471404994f4$var$$d1df120914c5e45a$export$f194ed9df726ec47 = `_5aJ9Rq_expander`;
$0f261471404994f4$var$$d1df120914c5e45a$export$ea222bb8b20e6221 = `_5aJ9Rq_expanderContent`;
$0f261471404994f4$var$$d1df120914c5e45a$export$f57c6e831b0d072a = `_5aJ9Rq_holder`;
$0f261471404994f4$var$$d1df120914c5e45a$export$1237798dc640739a = `_5aJ9Rq_label`;
$0f261471404994f4$var$$d1df120914c5e45a$export$3ce6949f20cea765 = `_5aJ9Rq_open`;
$0f261471404994f4$var$$d1df120914c5e45a$export$47fa9d71658d4a69 = `_5aJ9Rq_opening`;
$0f261471404994f4$var$$d1df120914c5e45a$export$fe2e9688f7413ae2 = `_5aJ9Rq_placing`;
/**
 * Utility function to remove undefined and function properties from an object.
 *
 * @param obj - The object to clean.
 * @returns A new object with undefined and function properties removed.
 */ const $0f261471404994f4$export$969b205aa1357eaa = (obj)=>{
    if (Array.isArray(obj)) return obj.map($0f261471404994f4$export$969b205aa1357eaa);
    else if (obj && typeof obj === "object") return Object.fromEntries(Object.entries(obj).filter(([_, value])=>value !== undefined && typeof value !== "function").map(([key, value])=>[
            key,
            $0f261471404994f4$export$969b205aa1357eaa(value)
        ]));
    return obj;
};
const $0f261471404994f4$export$501d19eb8a679b38 = (oldValue, newValue)=>(0, $gSkQi.isEqual)($0f261471404994f4$export$969b205aa1357eaa(oldValue), $0f261471404994f4$export$969b205aa1357eaa(newValue));
const $0f261471404994f4$var$$98996439382bbb96$export$c7afb07461c8486f = "SET_VALUE";
const $0f261471404994f4$var$$98996439382bbb96$export$f989f01be2123b61 = "UPDATE_INDEX";
const $0f261471404994f4$var$$98996439382bbb96$export$3fc97931b5a4e60a = "RESET_FLAGS";
const $0f261471404994f4$var$$98996439382bbb96$export$432e34d6a5e9350a = "SYNC_FROM_PARENT";
const $0f261471404994f4$var$$98996439382bbb96$export$4e684cecef6a0c5f = "FORCE_WITH_VALUE";
const $0f261471404994f4$var$$98996439382bbb96$export$48e583575aa70c22 = "CLEAR_ON_CHANGE_PAYLOAD";
function $0f261471404994f4$var$$cd8df934cc145ba4$export$6012a5cc1fdeb5ea(state, action) {
    switch(action.operation){
        case $0f261471404994f4$var$$98996439382bbb96$export$c7afb07461c8486f:
            {
                let newStack = [
                    ...state.stack
                ];
                let newIndex = state.index;
                const comparisonChanged = action.payload.addToStack;
                if (action.payload.addToStack) {
                    // Add to stack - comparison detected a change
                    newIndex = state.index + 1;
                    newStack = [
                        ...state.stack.slice(0, newIndex),
                        action.payload.newValue
                    ];
                } else newStack[state.index] = action.payload.newValue;
                return {
                    stack: newStack,
                    index: newIndex,
                    changed: true,
                    comparisonChanged: comparisonChanged,
                    onChangePayload: {
                        value: newStack[newIndex],
                        index: newIndex,
                        stack: newStack
                    }
                };
            }
        case $0f261471404994f4$var$$98996439382bbb96$export$f989f01be2123b61:
            return {
                ...state,
                index: action.payload.index,
                changed: true,
                comparisonChanged: true,
                onChangePayload: {
                    value: state.stack[action.payload.index],
                    index: action.payload.index,
                    stack: state.stack
                }
            };
        case $0f261471404994f4$var$$98996439382bbb96$export$3fc97931b5a4e60a:
            return {
                ...state,
                changed: false,
                comparisonChanged: false
            };
        case $0f261471404994f4$var$$98996439382bbb96$export$432e34d6a5e9350a:
            {
                let newStack = [
                    ...state.stack
                ];
                let newIndex = state.index;
                if (action.payload.addToStack) {
                    // Add to stack - comparison detected a change
                    newIndex = state.index + 1;
                    newStack = [
                        ...state.stack.slice(0, newIndex),
                        action.payload.newValue
                    ];
                } else newStack[state.index] = action.payload.newValue;
                return {
                    stack: newStack,
                    index: newIndex,
                    changed: false,
                    comparisonChanged: false,
                    onChangePayload: action.payload.triggerOnChange ? {
                        value: newStack[newIndex],
                        index: newIndex,
                        stack: newStack
                    } : null
                };
            }
        case $0f261471404994f4$var$$98996439382bbb96$export$4e684cecef6a0c5f:
            {
                let newStack = [
                    ...state.stack
                ];
                let newIndex = state.index;
                if (action.payload.addToStack) {
                    // Add to stack - comparison detected a change
                    newIndex = state.index + 1;
                    newStack = [
                        ...state.stack.slice(0, newIndex),
                        action.payload.newValue
                    ];
                } else newStack[state.index] = action.payload.newValue;
                return {
                    stack: newStack,
                    index: newIndex,
                    changed: false,
                    comparisonChanged: false,
                    onChangePayload: action.payload.triggerOnChange ? {
                        value: newStack[newIndex],
                        index: newIndex,
                        stack: newStack
                    } : null
                };
            }
        case $0f261471404994f4$var$$98996439382bbb96$export$48e583575aa70c22:
            return {
                ...state,
                onChangePayload: null
            };
    }
}
const $0f261471404994f4$export$426a3338f36cbf0a = ({ value: value, setValue: setValue, debounceMilliseconds: debounceMilliseconds = 500, onChange: onChange = ()=>{}, comparisonFunction: comparisonFunction = (0, $gSkQi.isEqual), blockReturnFunction: blockReturnFunction, blockOnChange: blockOnChange })=>{
    const [state, dispatch] = (0, $7fPBF.useReducer)($0f261471404994f4$var$$cd8df934cc145ba4$export$6012a5cc1fdeb5ea, {
        stack: [
            value
        ],
        index: 0,
        changed: false,
        comparisonChanged: false,
        onChangePayload: null
    });
    const debounceTimer = (0, $7fPBF.useRef)(null);
    /**
   * Set the current value in the stack, updating the stack and index if necessary
   * @param newValue The new value to set as current
   * @returns void
   */ const setCurrentValue = (0, $7fPBF.useCallback)((newValue)=>{
        // There will always be an update if the value is different
        if (!$0f261471404994f4$export$501d19eb8a679b38(newValue, state.stack[state.index])) {
            // Determine if comparison fails (values are different)
            const addToStack = !comparisonFunction(state.stack[state.index], newValue);
            // Dispatch the update (onChange will be triggered by useEffect)
            dispatch({
                operation: $0f261471404994f4$var$$98996439382bbb96$export$c7afb07461c8486f,
                payload: {
                    newValue: newValue,
                    addToStack: addToStack
                }
            });
        }
    }, [
        state.index,
        state.stack,
        comparisonFunction
    ]);
    /**
   * Undo the last change by moving back in the stack
   * @param steps Number of steps to go back, defaults to 1
   * @returns void
   */ const undo = (0, $7fPBF.useCallback)((steps = 1)=>{
        const newIndex = Math.max(0, state.index - steps);
        dispatch({
            operation: $0f261471404994f4$var$$98996439382bbb96$export$f989f01be2123b61,
            payload: {
                index: newIndex
            }
        });
    }, [
        state.index
    ]);
    /**
   * Redo the last undone change by moving forward in the stack
   * @param steps Number of steps to go forward, defaults to 1
   * @returns void
   */ const redo = (0, $7fPBF.useCallback)((steps = 1)=>{
        const newIndex = Math.min(state.stack.length - 1, state.index + steps);
        dispatch({
            operation: $0f261471404994f4$var$$98996439382bbb96$export$f989f01be2123b61,
            payload: {
                index: newIndex
            }
        });
    }, [
        state.index,
        state.stack
    ]);
    /**
   * Force an update to the current value, bypassing debounce
   * @param newValue Optional new value to set, if provided it will update the stack
   * @returns void
   */ const forceUpdate = (0, $7fPBF.useCallback)((newValue)=>{
        // Check for a timer and clear it
        const waitingTimer = debounceTimer.current !== null;
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        // Determine the value to pass to setValue
        let valueToSet = state.stack[state.index];
        // Check if new value is provided and update the stack accordingly
        /* istanbul ignore else */ if (newValue !== undefined && !$0f261471404994f4$export$501d19eb8a679b38(newValue, state.stack[state.index])) {
            // Determine if comparison fails (values are different)
            const addToStack = !comparisonFunction(state.stack[state.index], newValue);
            // Determine if onChange should be triggered
            const triggerOnChange = addToStack || waitingTimer || debounceMilliseconds === -1;
            // Dispatch the update (all stack manipulation happens in reducer)
            dispatch({
                operation: $0f261471404994f4$var$$98996439382bbb96$export$4e684cecef6a0c5f,
                payload: {
                    newValue: newValue,
                    addToStack: addToStack,
                    triggerOnChange: triggerOnChange
                }
            });
            // Use the new value for setValue
            valueToSet = newValue;
        }
        // Push update to parent for the current value
        setValue(valueToSet);
        if (newValue === undefined) dispatch({
            operation: $0f261471404994f4$var$$98996439382bbb96$export$3fc97931b5a4e60a
        });
    }, [
        debounceMilliseconds,
        state.index,
        state.stack,
        setValue,
        comparisonFunction
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (state.onChangePayload) {
            onChange(state.onChangePayload.value, state.onChangePayload.index, state.onChangePayload.stack);
            dispatch({
                operation: $0f261471404994f4$var$$98996439382bbb96$export$48e583575aa70c22
            });
        }
    }, [
        state.onChangePayload,
        onChange
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const thisCurrentValue = state.stack[state.index];
        // If no change via setCurrentValue, must be a top down change
        if (!state.changed && !$0f261471404994f4$export$501d19eb8a679b38(value, thisCurrentValue)) {
            // Determine if comparison fails (values are different)
            const addToStack = !comparisonFunction(state.stack[state.index], value);
            // Clear timer
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
            // Determine if onChange should be triggered
            const triggerOnChange = !blockOnChange?.(thisCurrentValue, value);
            // Dispatch the update
            dispatch({
                operation: $0f261471404994f4$var$$98996439382bbb96$export$432e34d6a5e9350a,
                payload: {
                    newValue: value,
                    addToStack: addToStack,
                    triggerOnChange: triggerOnChange
                }
            });
        } else if (state.changed && $0f261471404994f4$export$501d19eb8a679b38(value, thisCurrentValue)) {
            /* istanbul ignore else */ if (debounceTimer.current) clearTimeout(debounceTimer.current);
            dispatch({
                operation: $0f261471404994f4$var$$98996439382bbb96$export$3fc97931b5a4e60a
            });
        } else if (debounceMilliseconds !== null && debounceMilliseconds >= 0 && state.comparisonChanged) {
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
            if (!blockReturnFunction?.(thisCurrentValue)) debounceTimer.current = setTimeout(()=>{
                setValue(thisCurrentValue);
                dispatch({
                    operation: $0f261471404994f4$var$$98996439382bbb96$export$3fc97931b5a4e60a
                });
            }, debounceMilliseconds);
        // Do not add a return function to clear the timer here,
        // as it would clear the timer on every render, which is not desired.
        // The time will be cleared in the other scenario handlers or should be allowed to run
        // return () => {
        //   if (debounceTimer.current) clearTimeout(debounceTimer.current);
        // };
        } else if (debounceMilliseconds === null && state.comparisonChanged && !blockReturnFunction?.(thisCurrentValue)) {
            setValue(thisCurrentValue);
            dispatch({
                operation: $0f261471404994f4$var$$98996439382bbb96$export$3fc97931b5a4e60a
            });
        }
    }, [
        blockOnChange,
        blockReturnFunction,
        state.changed,
        state.comparisonChanged,
        state.index,
        state.stack,
        debounceMilliseconds,
        setValue,
        comparisonFunction,
        value
    ]);
    return {
        currentValue: state.stack[state.index],
        setCurrentValue: setCurrentValue,
        forceUpdate: forceUpdate,
        undo: undo,
        redo: redo,
        stack: state.stack,
        index: state.index
    };
};
/**
 * Clears the timeout held in the given ref, if there is one.
 *
 * @param ref - The ref holding the timer handle.
 */ const $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer = (ref)=>{
    if (ref.current !== null) {
        clearTimeout(ref.current);
        ref.current = null;
    }
};
const $0f261471404994f4$export$f13a708d2a7a10f9 = ({ input: input, onRelease: onRelease, pending: pending, timeoutMilliseconds: timeoutMilliseconds = 5000, windowMilliseconds: windowMilliseconds = 500 })=>{
    const [isWaiting, setIsWaiting] = (0, $7fPBF.useState)(false);
    const armedRef = (0, $7fPBF.useRef)(false);
    const windowTimerRef = (0, $7fPBF.useRef)(null);
    const timeoutTimerRef = (0, $7fPBF.useRef)(null);
    const releaseTimerRef = (0, $7fPBF.useRef)(null);
    const deferredEventRef = (0, $7fPBF.useRef)(null);
    const previousInputRef = (0, $7fPBF.useRef)(input);
    const onReleaseRef = (0, $7fPBF.useRef)(onRelease);
    (0, $7fPBF.useEffect)(()=>{
        onReleaseRef.current = onRelease;
    }, [
        onRelease
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!pending) {
            armedRef.current = false;
            return undefined;
        }
        armedRef.current = true;
        windowTimerRef.current = setTimeout(()=>{
            windowTimerRef.current = null;
            armedRef.current = false;
        }, windowMilliseconds);
        return ()=>$0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(windowTimerRef);
    }, [
        pending,
        windowMilliseconds
    ]);
    const release = (0, $7fPBF.useCallback)(()=>{
        $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
        $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
        setIsWaiting(false);
        const deferredEvent = deferredEventRef.current;
        deferredEventRef.current = null;
        /* istanbul ignore else */ if (deferredEvent) onReleaseRef.current(deferredEvent);
    }, []);
    const captureFocus = (0, $7fPBF.useCallback)((e)=>{
        if (!pending || !armedRef.current) return false;
        deferredEventRef.current = e;
        setIsWaiting(true);
        return true;
    }, [
        pending
    ]);
    const cancelWaiting = (0, $7fPBF.useCallback)(()=>{
        $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
        $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
        deferredEventRef.current = null;
        setIsWaiting(false);
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        const inputChanged = !$0f261471404994f4$export$501d19eb8a679b38(previousInputRef.current, input);
        previousInputRef.current = input;
        if (isWaiting && (!pending || inputChanged)) {
            $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
            // Let the redraw triggered by the incoming value land before the focus event is replayed
            releaseTimerRef.current = setTimeout(()=>{
                releaseTimerRef.current = null;
                release();
            }, 0);
        }
    }, [
        input,
        isWaiting,
        pending,
        release
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isWaiting) return undefined;
        timeoutTimerRef.current = setTimeout(()=>{
            timeoutTimerRef.current = null;
            release();
        }, timeoutMilliseconds);
        return ()=>$0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
    }, [
        isWaiting,
        release,
        timeoutMilliseconds
    ]);
    (0, $7fPBF.useEffect)(()=>()=>{
            $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(windowTimerRef);
            $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
            $0f261471404994f4$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
        }, []);
    return {
        isWaiting: isWaiting,
        captureFocus: captureFocus,
        cancelWaiting: cancelWaiting
    };
};
const $0f261471404994f4$export$9046ef79d808c3d9 = (value)=>{
    return value.lines.map((line)=>({
            lines: [
                (0, $gSkQi.cloneDeep)(line)
            ],
            contentProps: value.contentProps
        }));
};
const $0f261471404994f4$var$$077aaa442e4d7d24$export$7d6abe52e266964b = "ADD_LINE";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$31431e5ed4c8ceb7 = "REMOVE_LINE";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$128e89fa5a52e2d5 = "UPDATE_LINE";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$27c9658dd64ba792 = "ADD_BLOCK";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$f227699a52faa480 = "REMOVE_BLOCK";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$62e6b7d114efe4d4 = "UPDATE_BLOCK";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$3923dd9698ac182b = "UPDATE_BLOCK_TYPE";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$fb62af2ed61328b8 = "UPDATE_BLOCK_STYLE";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$3f6c2651d04c707 = "UPDATE_BLOCK_LABEL";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$ce4d39216b82c0ea = "UPDATE_BLOCK_TEXT";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$d4d1727b5880aab3 = "UPDATE_BLOCK_OPTIONS";
const $0f261471404994f4$var$$077aaa442e4d7d24$export$91eaa669ef26a074 = (lines, action)=>{
    const newLines = (0, $gSkQi.cloneDeep)(lines);
    switch(action.operation){
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$7d6abe52e266964b:
            {
                const newLine = action.line ?? new $0f261471404994f4$export$f727c5bfed9e77d4();
                /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex <= newLines.length) newLines.splice(action.lineIndex, 0, newLine);
                break;
            }
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$31431e5ed4c8ceb7:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length) newLines.splice(action.lineIndex, 1);
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$128e89fa5a52e2d5:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.line) newLines[action.lineIndex] = action.line;
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$27c9658dd64ba792:
            {
                const newBlock = action.block ?? new $0f261471404994f4$export$4ed6c3ca0061f49b();
                /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex <= newLines[action.lineIndex].textBlocks.length) newLines[action.lineIndex].textBlocks.splice(action.blockIndex, 0, newBlock);
                break;
            }
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$f227699a52faa480:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length) newLines[action.lineIndex].textBlocks.splice(action.blockIndex, 1);
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$62e6b7d114efe4d4:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.block) newLines[action.lineIndex].textBlocks[action.blockIndex] = action.block;
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$3923dd9698ac182b:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockType !== newLines[action.lineIndex].textBlocks[action.blockIndex].type) {
                const currentBlock = {
                    ...newLines[action.lineIndex].textBlocks[action.blockIndex]
                };
                const newBlock = $0f261471404994f4$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    ...currentBlock,
                    type: action.blockType,
                    isLocked: action.blockType === "at" || action.blockType === "select" ? true : undefined
                });
                newLines[action.lineIndex].textBlocks[action.blockIndex] = newBlock;
            }
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$fb62af2ed61328b8:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockStyle !== newLines[action.lineIndex].textBlocks[action.blockIndex].style) newLines[action.lineIndex].textBlocks[action.blockIndex].style = action.blockStyle === "" ? undefined : action.blockStyle;
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$3f6c2651d04c707:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockLabel !== newLines[action.lineIndex].textBlocks[action.blockIndex].label) newLines[action.lineIndex].textBlocks[action.blockIndex].label = action.blockLabel === "" ? undefined : action.blockLabel;
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$ce4d39216b82c0ea:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockText !== newLines[action.lineIndex].textBlocks[action.blockIndex].text) newLines[action.lineIndex].textBlocks[action.blockIndex].text = action.blockText ?? // istanbul ignore next
            "";
            break;
        case $0f261471404994f4$var$$077aaa442e4d7d24$export$d4d1727b5880aab3:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && newLines[action.lineIndex].textBlocks[action.blockIndex].type === "select" && action.blockOptions) {
                const newBlockOptions = $0f261471404994f4$export$9046ef79d808c3d9(action.blockOptions).map((l)=>{
                    const ret = {
                        text: l.lines[0].textBlocks[0].text,
                        data: {}
                    };
                    if (l.lines[0].textBlocks[0].style) ret.data.style = l.lines[0].textBlocks[0].style;
                    return ret;
                });
                newLines[action.lineIndex].textBlocks[action.blockIndex].availableOptions = newBlockOptions;
            }
            break;
    }
    return newLines;
};
var $0f261471404994f4$var$$ede054dcbe564586$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "addDiv", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$6758c6c7563dc60e, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$6758c6c7563dc60e = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "addIcon", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$3488242433cbedb, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$3488242433cbedb = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "redoBtn", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$56506a0c7710b298, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$56506a0c7710b298 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "relativeDiv", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$77612d80d648ab13, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$77612d80d648ab13 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "removeIcon", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$b62b2eefc26b7697, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$b62b2eefc26b7697 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "removeLineIcon", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$999deec9ef14a402, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$999deec9ef14a402 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ede054dcbe564586$exports, "undoBtn", ()=>$0f261471404994f4$var$$ede054dcbe564586$export$f4cd59694124b9f, (v)=>$0f261471404994f4$var$$ede054dcbe564586$export$f4cd59694124b9f = v);
var $0f261471404994f4$var$$ede054dcbe564586$export$6758c6c7563dc60e;
var $0f261471404994f4$var$$ede054dcbe564586$export$3488242433cbedb;
var $0f261471404994f4$var$$ede054dcbe564586$export$56506a0c7710b298;
var $0f261471404994f4$var$$ede054dcbe564586$export$77612d80d648ab13;
var $0f261471404994f4$var$$ede054dcbe564586$export$b62b2eefc26b7697;
var $0f261471404994f4$var$$ede054dcbe564586$export$999deec9ef14a402;
var $0f261471404994f4$var$$ede054dcbe564586$export$f4cd59694124b9f;
$0f261471404994f4$var$$ede054dcbe564586$export$6758c6c7563dc60e = `hDWuzq_addDiv`;
$0f261471404994f4$var$$ede054dcbe564586$export$3488242433cbedb = `hDWuzq_addIcon`;
$0f261471404994f4$var$$ede054dcbe564586$export$56506a0c7710b298 = `hDWuzq_redoBtn`;
$0f261471404994f4$var$$ede054dcbe564586$export$77612d80d648ab13 = `hDWuzq_relativeDiv`;
$0f261471404994f4$var$$ede054dcbe564586$export$b62b2eefc26b7697 = `hDWuzq_removeIcon`;
$0f261471404994f4$var$$ede054dcbe564586$export$999deec9ef14a402 = `hDWuzq_removeLineIcon`;
$0f261471404994f4$var$$ede054dcbe564586$export$f4cd59694124b9f = `hDWuzq_undoBtn`;
const $0f261471404994f4$var$$e775624493c4cd98$export$5bcea036881b4cf4 = ({ index: index })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    /**
   * Handle click event to add line.
   */ const onClick = ()=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$7d6abe52e266964b,
            lineIndex: index
        });
    };
    return (0, $bbzbN.jsx)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).addDiv,
        onClick: onClick,
        children: (0, $bbzbN.jsx)("svg", {
            className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).addIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            "aria-label": "Add line",
            children: (0, $bbzbN.jsx)("path", {
                fill: "currentColor",
                d: "M26 30h-2V20H12v10h-2V20a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zM5.17 16L2 19.17l1.411 1.419L8 16l-4.58-4.58L2 12.83zM24 14H12a2 2 0 0 1-2-2V2h2v10h12V2h2v10a2 2 0 0 1-2 2"
            })
        })
    });
};
$0f261471404994f4$var$$e775624493c4cd98$export$5bcea036881b4cf4.displayName = "AddLine";
const $0f261471404994f4$var$$4d0ecc9f8afaf0d5$export$3167bef587fc42aa = ({ onClick: onClick, fill: fill })=>(0, $bbzbN.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        viewBox: "0 0 24 24",
        width: "16",
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).redoBtn,
        fill: fill,
        onClick: ()=>onClick(),
        "aria-label": "Redo",
        children: [
            (0, $bbzbN.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $bbzbN.jsx)("path", {
                d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
            })
        ]
    });
$0f261471404994f4$var$$4d0ecc9f8afaf0d5$export$3167bef587fc42aa.displayName = "RedoBtn";
const $0f261471404994f4$var$$63b04b789bb9c5d5$export$1085475ec51f1baf = ({ index: index })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    /**
   * Handle click event to remove line.
   */ const onClick = ()=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$31431e5ed4c8ceb7,
            lineIndex: index
        });
    };
    return (0, $bbzbN.jsx)("span", {
        onClick: onClick,
        children: (0, $bbzbN.jsxs)("svg", {
            className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).removeLineIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            "aria-label": "Remove line",
            children: [
                (0, $bbzbN.jsx)("path", {
                    fill: "currentColor",
                    d: "M29 26H12a1 1 0 0 1-.707-.293l-9-9a1 1 0 0 1 0-1.414l9-9A1 1 0 0 1 12 6h17a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-16.586-2H28V8H12.414l-8 8z"
                }),
                (0, $bbzbN.jsx)("path", {
                    fill: "currentColor",
                    d: "M20.414 16L25 11.414L23.586 10L19 14.586L14.414 10L13 11.414L17.586 16L13 20.586L14.414 22L19 17.414L23.586 22L25 20.586z"
                })
            ]
        })
    });
};
$0f261471404994f4$var$$63b04b789bb9c5d5$export$1085475ec51f1baf.displayName = "RemoveLine";
const $0f261471404994f4$var$$16b3747771ec0ba5$export$a7a4427ce0cafbea = ({ onClick: onClick, fill: fill })=>(0, $bbzbN.jsxs)("svg", {
        fill: fill,
        onClick: ()=>onClick(),
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        viewBox: "0 0 24 24",
        width: "16",
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).undoBtn,
        "aria-label": "Undo",
        children: [
            (0, $bbzbN.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $bbzbN.jsx)("path", {
                d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
            })
        ]
    });
$0f261471404994f4$var$$16b3747771ec0ba5$export$a7a4427ce0cafbea.displayName = "UndoBtn";
var $0f261471404994f4$var$$8a8ca0442c015654$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$8a8ca0442c015654$exports, "height", ()=>$0f261471404994f4$var$$8a8ca0442c015654$export$ac607276a8fe9f0a, (v)=>$0f261471404994f4$var$$8a8ca0442c015654$export$ac607276a8fe9f0a = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$8a8ca0442c015654$exports, "noHeight", ()=>$0f261471404994f4$var$$8a8ca0442c015654$export$18d78b54c5658614, (v)=>$0f261471404994f4$var$$8a8ca0442c015654$export$18d78b54c5658614 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$8a8ca0442c015654$exports, "windowViewBlock", ()=>$0f261471404994f4$var$$8a8ca0442c015654$export$81010ebbeae2a09, (v)=>$0f261471404994f4$var$$8a8ca0442c015654$export$81010ebbeae2a09 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$8a8ca0442c015654$exports, "windowViewBody", ()=>$0f261471404994f4$var$$8a8ca0442c015654$export$15388d7be80e2abc, (v)=>$0f261471404994f4$var$$8a8ca0442c015654$export$15388d7be80e2abc = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$8a8ca0442c015654$exports, "windowViewLine", ()=>$0f261471404994f4$var$$8a8ca0442c015654$export$cd545671e9c668a3, (v)=>$0f261471404994f4$var$$8a8ca0442c015654$export$cd545671e9c668a3 = v);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$8a8ca0442c015654$exports, "windowViewLineTitle", ()=>$0f261471404994f4$var$$8a8ca0442c015654$export$84df755deca3a30d, (v)=>$0f261471404994f4$var$$8a8ca0442c015654$export$84df755deca3a30d = v);
var $0f261471404994f4$var$$8a8ca0442c015654$export$ac607276a8fe9f0a;
var $0f261471404994f4$var$$8a8ca0442c015654$export$18d78b54c5658614;
var $0f261471404994f4$var$$8a8ca0442c015654$export$81010ebbeae2a09;
var $0f261471404994f4$var$$8a8ca0442c015654$export$15388d7be80e2abc;
var $0f261471404994f4$var$$8a8ca0442c015654$export$cd545671e9c668a3;
var $0f261471404994f4$var$$8a8ca0442c015654$export$84df755deca3a30d;
$0f261471404994f4$var$$8a8ca0442c015654$export$ac607276a8fe9f0a = `AR1p1G_height`;
$0f261471404994f4$var$$8a8ca0442c015654$export$18d78b54c5658614 = `AR1p1G_noHeight`;
$0f261471404994f4$var$$8a8ca0442c015654$export$81010ebbeae2a09 = `AR1p1G_windowViewBlock`;
$0f261471404994f4$var$$8a8ca0442c015654$export$15388d7be80e2abc = `AR1p1G_windowViewBody`;
$0f261471404994f4$var$$8a8ca0442c015654$export$cd545671e9c668a3 = `AR1p1G_windowViewLine`;
$0f261471404994f4$var$$8a8ca0442c015654$export$84df755deca3a30d = `AR1p1G_windowViewLineTitle`;
const $0f261471404994f4$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f = ({ onClick: onClick })=>(0, $bbzbN.jsx)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).addDiv,
        onClick: onClick,
        children: (0, $bbzbN.jsx)("svg", {
            className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).addIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            "aria-label": "Add text block",
            children: (0, $bbzbN.jsx)("path", {
                fill: "currentColor",
                d: "M28 12H10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M10 4v6h18V4zm18 26H10a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2m-18-8v6h18v-6zm-1-6l-5.586-5.586L2 11.828L6.172 16L2 20.172l1.414 1.414z"
            })
        })
    });
$0f261471404994f4$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f.displayName = "AddBlock";
const $0f261471404994f4$var$$034e76b6a38d6263$export$59fc62fa579fbc85 = ({ onClick: onClick })=>(0, $bbzbN.jsx)("span", {
        onClick: onClick,
        children: (0, $bbzbN.jsxs)("svg", {
            className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).removeIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            fill: "red",
            "aria-label": "Remove text block",
            children: [
                (0, $bbzbN.jsx)("path", {
                    fill: "currentColor",
                    d: "M24 30H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M4 22h-.002L4 28h20v-6zM30 3.41L28.59 2L25 5.59L21.41 2L20 3.41L23.59 7L20 10.59L21.41 12L25 8.41L28.59 12L30 10.59L26.41 7z"
                }),
                (0, $bbzbN.jsx)("path", {
                    fill: "currentColor",
                    d: "M4 14V8h14V6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h22v-2Z"
                })
            ]
        })
    });
$0f261471404994f4$var$$034e76b6a38d6263$export$59fc62fa579fbc85.displayName = "RemoveBlock";
const $0f261471404994f4$export$dcee1aa94a106d27 = ({ id: id, value: value, availableOptions: availableOptions, change: change, label: label, ...rest })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [thisValueString, setThisValueString] = (0, $7fPBF.useState)(`${value}`);
    (0, $7fPBF.useEffect)(()=>{
        const ix = availableOptions.findIndex((o)=>o.value === value);
        startTransition(()=>setThisValueString(`${ix !== -1 ? `${ix}-` : ""}${value}`));
    }, [
        availableOptions,
        value
    ]);
    const availableOptionsStrings = availableOptions.map((item, ix)=>({
            label: item.label,
            value: `${ix}-${item.value?.toString() ?? "undefined"}`,
            disabled: item.disabled
        }));
    /**
   * Handle selection changes, update internal string representation and
   * propagate the selected option value via the `change` callback.
   *
   * @param e - The change event from the select element.
   */ const handleChange = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const newValueIx = availableOptionsStrings.findIndex((item)=>item.value === e.target.value);
        setThisValueString(e.target.value);
        /* istanbul ignore else */ if (newValueIx !== -1) change(availableOptions[newValueIx].value);
    };
    return (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).holder,
        children: [
            label !== undefined && (0, $bbzbN.jsx)("label", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).label,
                id: `${id}-label`,
                htmlFor: id,
                children: label
            }),
            (0, $bbzbN.jsxs)("select", {
                ...rest,
                id: id,
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).baseSelect,
                value: thisValueString,
                onChange: handleChange,
                children: [
                    availableOptions.findIndex((o)=>o.value === value) === -1 && (0, $bbzbN.jsx)("option", {
                        value: thisValueString,
                        disabled: true,
                        children: thisValueString
                    }),
                    availableOptionsStrings.map((o, ix)=>(0, $bbzbN.jsx)("option", {
                            value: o.value,
                            disabled: o.disabled,
                            children: o.label
                        }, `${ix}-${o.value}`))
                ]
            })
        ]
    });
};
$0f261471404994f4$export$dcee1aa94a106d27.displayName = "BaseSelect";
const $0f261471404994f4$var$$8d91142d51e3ea2b$export$c6f5bf772b2d320d = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const selectStyleId = (0, $7fPBF.useId)();
    const availableOptions = (0, $7fPBF.useMemo)(()=>{
        const ret = [
            {
                label: "None",
                value: undefined
            }
        ];
        /* istanbul ignore else */ if (wvc && wvc.contentProps.styles) ret.push(...Object.keys(wvc.contentProps.styles).map((sn)=>({
                label: sn,
                value: sn,
                disabled: wvc.contentProps.styles[sn].isNotAvailable
            })));
        return ret;
    }, [
        wvc
    ]);
    return !wvc || !thisBlock ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : (0, $bbzbN.jsx)($0f261471404994f4$export$dcee1aa94a106d27, {
        id: selectStyleId,
        label: "Style",
        value: thisBlock.style,
        availableOptions: availableOptions,
        disabled: !wvc.editable,
        change: (ret)=>{
            wvc.dispatch({
                operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$fb62af2ed61328b8,
                lineIndex: lineIndex,
                blockIndex: blockIndex,
                blockStyle: ret
            });
        }
    });
};
$0f261471404994f4$var$$8d91142d51e3ea2b$export$c6f5bf772b2d320d.displayName = "WindowViewBlockStyle";
const $0f261471404994f4$export$e1f706e5673fef9e = ({ id: id, value: value, onNewValue: onNewValue, label: label, ...rest })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [inputValue, setInputValue] = (0, $7fPBF.useState)(value?.toString() ?? "");
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>setInputValue(value?.toString() ?? ""));
    }, [
        value
    ]);
    /**
   * Update the local input state when the user types. The updated value
   * will be propagated to the parent on blur via `onNewValue`.
   *
   * @param e - The change event from the input element.
   */ const handleInputChange = (e)=>{
        setInputValue(e.target.value);
    };
    const handleInputBlur = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else */ if (onNewValue) {
            const newValue = typeof value === "number" ? parseFloat(inputValue) : inputValue;
            onNewValue(newValue);
        }
    }, [
        onNewValue,
        inputValue,
        value
    ]);
    return (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).holder,
        children: [
            label !== undefined && (0, $bbzbN.jsx)("label", {
                id: `${id}-label`,
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).label,
                htmlFor: id,
                children: label
            }),
            (0, $bbzbN.jsx)("input", {
                ...rest,
                type: typeof value === "number" ? "number" : "text",
                id: id,
                className: [
                    /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).baseInput,
                    rest.className
                ].filter((c)=>c).join(" "),
                value: inputValue,
                onChange: handleInputChange,
                onBlur: handleInputBlur
            })
        ]
    });
};
$0f261471404994f4$export$e1f706e5673fef9e.displayName = "BaseInput";
const $0f261471404994f4$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422 = ({ lineIndex: lineIndex, blockIndex: blockIndex, label: label = false })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const thisId = (0, $7fPBF.useId)();
    return !wvc || !thisBlock ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : (0, $bbzbN.jsx)($0f261471404994f4$export$e1f706e5673fef9e, {
        id: thisId,
        label: label ? "Label" : "Text",
        value: label ? thisBlock.label : thisBlock.text,
        disabled: !wvc.editable,
        onNewValue: (ret)=>{
            /* istanbul ignore else */ if (wvc && typeof ret === "string") {
                /* istanbul ignore else */ if (label) wvc.dispatch({
                    operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$3f6c2651d04c707,
                    lineIndex: lineIndex,
                    blockIndex: blockIndex,
                    blockLabel: ret
                });
                else wvc.dispatch({
                    operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$ce4d39216b82c0ea,
                    lineIndex: lineIndex,
                    blockIndex: blockIndex,
                    blockText: ret
                });
            }
        }
    });
};
$0f261471404994f4$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422.displayName = "WindowViewBlockText";
const $0f261471404994f4$var$$bf15b2638bfe15a8$export$290931a7697344ba = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const selectTypeId = (0, $7fPBF.useId)();
    const availableOptions = (0, $7fPBF.useMemo)(()=>{
        const ret = [];
        /* istanbul ignore else */ if (wvc) {
            ret.push(...[
                {
                    label: "Text",
                    value: "text"
                },
                {
                    label: "Select",
                    value: "select"
                }
            ]);
            if (wvc.includeAt) ret.push({
                label: "At",
                value: "at",
                disabled: true
            });
        }
        return ret;
    }, [
        wvc
    ]);
    return !wvc || !thisBlock ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : (0, $bbzbN.jsx)($0f261471404994f4$export$dcee1aa94a106d27, {
        id: selectTypeId,
        label: "Type",
        value: thisBlock.type,
        availableOptions: availableOptions,
        disabled: !wvc.editable,
        change: (ret)=>{
            wvc.dispatch({
                operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$3923dd9698ac182b,
                lineIndex: lineIndex,
                blockIndex: blockIndex,
                blockType: ret
            });
        }
    });
};
$0f261471404994f4$var$$bf15b2638bfe15a8$export$290931a7697344ba.displayName = "WindowViewBlockType";
const $0f261471404994f4$export$6be11f3b04f364b4 = (lines)=>{
    const retLines = lines.flatMap((l)=>l.lines);
    const retContent = lines.map((l)=>l.contentProps).reduce((p, c)=>p ?? c, undefined);
    return {
        lines: retLines,
        contentProps: retContent
    };
};
const $0f261471404994f4$var$$fbcab087cdb8341f$export$44b5c9777d5218fc = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const selectOptionsId = (0, $7fPBF.useId)();
    // Holder for available options
    const input = (0, $7fPBF.useMemo)(()=>{
        if (thisBlock && thisBlock.type === "select") {
            const availableOptions = thisBlock.availableOptions;
            return $0f261471404994f4$export$6be11f3b04f364b4(availableOptions.map((o)=>({
                    lines: [
                        {
                            textBlocks: [
                                {
                                    text: o.text,
                                    style: o.data?.style
                                }
                            ]
                        }
                    ]
                })));
        } else return new $0f261471404994f4$export$1a4903393d6b1b7d().data;
    }, [
        thisBlock
    ]);
    const [validationText, setValidationText] = (0, $7fPBF.useState)([]);
    const setObject = (0, $7fPBF.useCallback)((value)=>{
        const validationText = [];
        if (value.lines.some((l)=>l.textBlocks.length > 1)) validationText.push("Each line must have only one style");
        if (value.lines.some((l)=>l.textBlocks.map((tb)=>tb.text.trim()).join("") === "")) validationText.push("Each line must have at least one character");
        setValidationText(validationText);
        if (validationText.length === 0) wvc?.dispatch({
            operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$d4d1727b5880aab3,
            lineIndex: lineIndex,
            blockIndex: blockIndex,
            blockOptions: value
        });
    }, [
        blockIndex,
        lineIndex,
        wvc
    ]);
    return !wvc || !thisLine || !thisBlock ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : (0, $bbzbN.jsx)("div", {
        className: [
            /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).windowViewBlock,
            thisBlock.type !== "select" ? /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).noHeight : /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).height
        ].join(" "),
        children: thisBlock.type !== "select" ? null : (0, $bbzbN.jsx)($0f261471404994f4$export$64d7be461af4ab3e, {
            id: `available-${selectOptionsId}`,
            style: {
                width: "100%",
                minHeight: "80px"
            },
            label: "Available options",
            errorText: validationText.join("\n"),
            allowNewLine: true,
            editable: wvc.editable,
            customStyleMap: wvc.contentProps.styles,
            input: input,
            setObject: setObject,
            debounceMilliseconds: -1,
            resize: "vertical"
        })
    });
};
$0f261471404994f4$var$$fbcab087cdb8341f$export$44b5c9777d5218fc.displayName = "WindowViewBlockOptions";
const $0f261471404994f4$var$$f1c5b02e089086d0$export$89d87d4877cd77dc = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    return !wvc || !thisBlock ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            (0, $bbzbN.jsxs)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).windowViewBlock,
                children: [
                    (0, $bbzbN.jsx)($0f261471404994f4$var$$bf15b2638bfe15a8$export$290931a7697344ba, {
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    }),
                    wvc.contentProps?.styles && Object.keys(wvc.contentProps.styles).length > 0 && (0, $bbzbN.jsx)($0f261471404994f4$var$$8d91142d51e3ea2b$export$c6f5bf772b2d320d, {
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    }),
                    (0, $bbzbN.jsx)($0f261471404994f4$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422, {
                        label: true,
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    }),
                    (0, $bbzbN.jsx)($0f261471404994f4$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422, {
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    })
                ]
            }),
            (0, $bbzbN.jsx)($0f261471404994f4$var$$fbcab087cdb8341f$export$44b5c9777d5218fc, {
                lineIndex: lineIndex,
                blockIndex: blockIndex
            })
        ]
    });
};
$0f261471404994f4$var$$f1c5b02e089086d0$export$89d87d4877cd77dc.displayName = "WindowViewBlock";
const $0f261471404994f4$var$$b0a19385787b7450$export$c4d333414b1626fb = ({ lineIndex: lineIndex })=>{
    const wvc = (0, $7fPBF.useContext)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const addBlock = (0, $7fPBF.useCallback)((ix)=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$27c9658dd64ba792,
            lineIndex: lineIndex,
            blockIndex: ix
        });
    }, [
        lineIndex,
        wvc
    ]);
    const removeBlock = (0, $7fPBF.useCallback)((ix)=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $0f261471404994f4$var$$077aaa442e4d7d24$export$f227699a52faa480,
            lineIndex: lineIndex,
            blockIndex: ix
        });
    }, [
        lineIndex,
        wvc
    ]);
    return !wvc || !thisLine ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).windowViewLine,
        children: [
            wvc.contentProps.allowNewLine && (0, $bbzbN.jsxs)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).windowViewLineTitle,
                children: [
                    "Line ",
                    lineIndex + 1
                ]
            }),
            wvc.editable && (0, $bbzbN.jsx)($0f261471404994f4$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f, {
                onClick: ()=>addBlock(0)
            }),
            wvc.lines[lineIndex].textBlocks.map((textBlock, ix)=>(0, $bbzbN.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    children: [
                        wvc.editable && (0, $bbzbN.jsx)($0f261471404994f4$var$$034e76b6a38d6263$export$59fc62fa579fbc85, {
                            onClick: ()=>removeBlock(ix)
                        }),
                        (0, $bbzbN.jsx)($0f261471404994f4$var$$f1c5b02e089086d0$export$89d87d4877cd77dc, {
                            lineIndex: lineIndex,
                            blockIndex: ix
                        }),
                        wvc.editable && (0, $bbzbN.jsx)($0f261471404994f4$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f, {
                            onClick: ()=>addBlock(ix + 1)
                        })
                    ]
                }, ix))
        ]
    });
};
$0f261471404994f4$var$$b0a19385787b7450$export$c4d333414b1626fb.displayName = "WindowViewLine";
const $0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733 = (0, $7fPBF.createContext)(null);
const $0f261471404994f4$var$$969bb2bbbbbb17fd$export$a634f244d0bbcc40 = ({ id: id, showWindowView: showWindowView, setShowWindowView: setShowWindowView, state: state, setState: setState, includeAt: includeAt = false })=>{
    const { currentValue: currentValue, setCurrentValue: setCurrentValue, forceUpdate: forceUpdate, undo: undo, redo: redo, stack: stack, index: index } = $0f261471404994f4$export$426a3338f36cbf0a({
        value: state.lines,
        /**
     * WindowView - wrapper that renders a draggable/resizable editor window.
     *
     * @param value - Current value used to control window visibility or state.
     */ setValue: (value)=>{
            const ret = new $0f261471404994f4$export$1a4903393d6b1b7d({
                lines: value
            }, state.contentProps);
            if (!(0, $gSkQi.isEqual)(ret.lines.map((l)=>l.data), state.lines.map((l)=>l.data))) setState(ret);
        },
        debounceMilliseconds: -1
    });
    return (0, $bbzbN.jsx)((0, $d8dTd.ContextWindow), {
        id: id,
        visible: showWindowView,
        title: "Editor contents",
        titleElement: (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                "Editor contents",
                (0, $bbzbN.jsx)($0f261471404994f4$var$$16b3747771ec0ba5$export$a7a4427ce0cafbea, {
                    fill: index > 0 ? "black" : "gray",
                    onClick: ()=>undo()
                }),
                (0, $bbzbN.jsx)($0f261471404994f4$var$$4d0ecc9f8afaf0d5$export$3167bef587fc42aa, {
                    fill: index < stack.length - 1 ? "black" : "gray",
                    onClick: ()=>redo()
                })
            ]
        }),
        style: {
            height: "400px",
            width: "700px",
            maxHeight: "80vh",
            maxWidth: "90vw"
        },
        onClose: ()=>{
            forceUpdate();
            setShowWindowView(false);
        },
        children: (0, $bbzbN.jsx)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733.Provider, {
            value: {
                id: id,
                lines: currentValue,
                /**
           * Handle block actions such as add/remove/move originating from the
           * window control and dispatch to the editor callbacks.
           *
           * @param action - The action identifier describing the block operation.
           */ dispatch: (action)=>{
                    const newLines = $0f261471404994f4$var$$077aaa442e4d7d24$export$91eaa669ef26a074(currentValue, action);
                    setCurrentValue(newLines);
                },
                editable: true,
                contentProps: state.contentProps,
                includeAt: includeAt
            },
            children: (0, $bbzbN.jsxs)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$8a8ca0442c015654$exports).windowViewBody,
                children: [
                    state.contentProps?.allowNewLine && (0, $bbzbN.jsx)($0f261471404994f4$var$$e775624493c4cd98$export$5bcea036881b4cf4, {
                        index: 0
                    }),
                    currentValue.map((line, ix)=>(0, $bbzbN.jsxs)("div", {
                            className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$ede054dcbe564586$exports).relativeDiv,
                            children: [
                                (0, $bbzbN.jsx)($0f261471404994f4$var$$63b04b789bb9c5d5$export$1085475ec51f1baf, {
                                    index: ix
                                }),
                                (0, $bbzbN.jsx)($0f261471404994f4$var$$b0a19385787b7450$export$c4d333414b1626fb, {
                                    lineIndex: ix
                                }, ix),
                                state.contentProps?.allowNewLine && (0, $bbzbN.jsx)($0f261471404994f4$var$$e775624493c4cd98$export$5bcea036881b4cf4, {
                                    index: ix + 1
                                })
                            ]
                        }, ix))
                ]
            })
        })
    });
};
$0f261471404994f4$var$$969bb2bbbbbb17fd$export$a634f244d0bbcc40.displayName = "WindowView";
/**
 * Checks if the content has any active unlocked at-mention blocks.
 *
 * @param currentValue - The editor content to check
 * @returns True if there are active at blocks
 */ const $0f261471404994f4$var$$089ef8d015806446$var$hasActiveAt = (currentValue)=>{
    return currentValue.lines.some((i)=>i.textBlocks.some((tb)=>tb.type === "at" && !tb.isLocked));
};
/**
 * Checks if two EditorV3 content values have the same text content.
 *
 * @param oldValue - The previous EditorV3 content value
 * @param newValue - The new EditorV3 content value to compare
 */ const $0f261471404994f4$var$$089ef8d015806446$var$sameText = (oldValue, newValue)=>$0f261471404994f4$export$501d19eb8a679b38({
        lines: oldValue.lines.map((l)=>l.textBlocks.map((tb)=>tb.data)),
        showMarkdown: oldValue?.showMarkdown
    }, {
        lines: newValue.lines.map((l)=>l.textBlocks.map((tb)=>tb.data)),
        showMarkdown: newValue.showMarkdown
    });
/**
 * Checks if two EditorV3 content values have the same text but new value has no cursor.
 *
 * @param oldValue - The previous EditorV3 content value
 * @param newValue - The new EditorV3 content value to compare
 */ const $0f261471404994f4$var$$089ef8d015806446$var$sameTextNoCursor = (oldValue, newValue)=>oldValue.caretPosition !== null && newValue.caretPosition === null && $0f261471404994f4$var$$089ef8d015806446$var$sameText(oldValue, newValue);
const $0f261471404994f4$export$c410cc7dbb67874b = ({ allowMarkdown: allowMarkdown = $0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54.allowMarkdown, allowNewLine: allowNewLine = $0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54.allowNewLine, allowWindowView: allowWindowView = $0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54.allowWindowView, atListFunction: atListFunction, customStyleMap: customStyleMap, debounceMilliseconds: debounceMilliseconds = null, decimalAlignPercent: decimalAlignPercent = $0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54.decimalAlignPercent, editable: editable = true, id: id, input: input, markdownSettings: markdownSettings = {
    ...$0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54.markdownSettings
}, maxAtListLength: maxAtListLength = 10, noBorder: noBorder = false, onFocus: onFocus, onFocusCapture: onFocusCapture, pending: pending = false, pendingTimeoutMilliseconds: pendingTimeoutMilliseconds = 5000, pendingWindowMilliseconds: pendingWindowMilliseconds = 500, resize: resize = false, setObject: setObject, spellCheck: spellCheck = false, style: style, styleOnContextMenu: styleOnContextMenu = true, textAlignment: textAlignment = $0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54.textAlignment, ...rest })=>{
    // Set up reference to main div
    const aiev3Ref = (0, $7fPBF.useRef)(null);
    // Set up reference to inner div
    const editableRef = (0, $7fPBF.useRef)(null);
    // other state variables
    const [showMarkdown, setShowMarkdown] = (0, $7fPBF.useState)(false);
    const [showWindowView, setShowWindowView] = (0, $7fPBF.useState)(false);
    const contentProps = (0, $7fPBF.useMemo)(()=>{
        return {
            ...$0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54,
            allowMarkdown: allowMarkdown,
            allowNewLine: allowNewLine,
            atListFunction: atListFunction,
            decimalAlignPercent: decimalAlignPercent,
            markdownSettings: markdownSettings,
            maxAtListLength: maxAtListLength,
            showMarkdown: showMarkdown,
            styles: customStyleMap,
            textAlignment: textAlignment
        };
    }, [
        allowMarkdown,
        allowNewLine,
        atListFunction,
        customStyleMap,
        decimalAlignPercent,
        markdownSettings,
        maxAtListLength,
        showMarkdown,
        textAlignment
    ]);
    // General return function
    const [hasDrawnElement, setHasDrawnElement] = (0, $7fPBF.useState)(false);
    // #region Handling update
    // Redraw element, used in debounced stack as onChange callback
    const redrawElement = (0, $7fPBF.useCallback)((ret)=>{
        /* istanbul ignore else */ if (editableRef.current) ret.redraw(editableRef.current);
    }, []);
    // Create debounce stack
    const { currentValue: currentValue, setCurrentValue: setCurrentValue, undo: undo, redo: redo, forceUpdate: forceReturn } = $0f261471404994f4$export$426a3338f36cbf0a({
        value: new $0f261471404994f4$export$1a4903393d6b1b7d(input, {
            ...$0f261471404994f4$var$$f19be80785b1b837$export$fd3826d97a0a3c54,
            textAlignment: textAlignment,
            decimalAlignPercent: decimalAlignPercent,
            styles: customStyleMap,
            showMarkdown: showMarkdown,
            markdownSettings: markdownSettings,
            allowMarkdown: allowMarkdown,
            allowNewLine: allowNewLine
        }),
        // Send data base to the parent
        setValue: (ret)=>setObject({
                lines: ret.data.lines,
                contentProps: ret.data.contentProps
            }),
        debounceMilliseconds: debounceMilliseconds,
        onChange: redrawElement,
        comparisonFunction: $0f261471404994f4$var$$089ef8d015806446$var$sameText,
        blockReturnFunction: $0f261471404994f4$var$$089ef8d015806446$var$hasActiveAt,
        blockDebounceReturn: $0f261471404994f4$var$$089ef8d015806446$var$hasActiveAt,
        blockOnChange: $0f261471404994f4$var$$089ef8d015806446$var$sameTextNoCursor
    });
    // Utility callback for debugging
    const setContent = (0, $7fPBF.useCallback)((newContent, _calledFrom)=>{
        // console.debug(
        //   "Set content ↓\n",
        //   newContent.markdownText,
        //   "\nCaret position: ",
        //   newContent.caretPosition,
        // );
        setCurrentValue(newContent);
    }, [
        setCurrentValue
    ]);
    // #endregion Handling update
    // #region Input utilities
    // Set up menu items
    const menuItems = (0, $7fPBF.useMemo)(()=>{
        // Add different styles
        const styleIMenuItem = !editable || !contentProps.styles || Object.keys(contentProps.styles).length === 0 ? [] : [
            {
                label: "Style",
                disabled: contentProps.showMarkdown,
                group: [
                    ...Object.keys(contentProps.styles).map((s)=>{
                        return {
                            label: s,
                            disabled: contentProps.showMarkdown || currentValue.isCaretLocked() || contentProps.styles?.[s].isNotAvailable || currentValue.caretPosition?.isCollapsed,
                            action: ()=>{
                                /* istanbul ignore else */ // eslint-disable-next-line react-hooks/refs
                                if (editableRef.current) {
                                    const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                                    newContent.applyStyle(s);
                                    setContent(newContent, "Apply style from menu");
                                }
                            }
                        };
                    }),
                    {
                        label: "Remove style",
                        disabled: contentProps.showMarkdown || currentValue.caretPosition?.isCollapsed,
                        action: ()=>{
                            /* istanbul ignore else */ if (editableRef.current) {
                                const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                                newContent.removeStyle();
                                setContent(newContent, "Remove style from menu");
                            }
                        }
                    }
                ]
            }
        ];
        // Add markdown switch
        const showMarkdownMenu = !allowMarkdown ? [] : [
            {
                label: `${contentProps.showMarkdown ? "Hide" : "Show"} markdown`,
                action: ()=>{
                    /* istanbul ignore else */ if (editableRef.current) {
                        const newShowMarkdown = !contentProps.showMarkdown;
                        setShowMarkdown(newShowMarkdown);
                        const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, {
                            ...contentProps,
                            showMarkdown: newShowMarkdown
                        });
                        newContent.caretPosition = null; // Reset caret position
                        setContent(newContent, "Markdown toggle");
                    }
                }
            }
        ];
        // Add window view
        const showWindowViewMenu = !allowWindowView || !editable ? [] : [
            {
                label: `${showWindowView ? "Hide" : "Show"} window view`,
                action: ()=>{
                    /* istanbul ignore else */ if (editableRef.current) {
                        const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                        newContent.caretPosition = null;
                        setContent(newContent, "Window view menu");
                        setShowWindowView(!showWindowView);
                    }
                }
            }
        ];
        return [
            ...styleIMenuItem,
            ...showMarkdownMenu,
            ...showWindowViewMenu
        ];
    }, [
        allowMarkdown,
        allowWindowView,
        contentProps,
        currentValue,
        editable,
        setContent,
        showWindowView
    ]);
    // Create custom refresh event used by renderDropdown.
    const handleRefreshEvent = (0, $7fPBF.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        /* istanbul ignore else */ if (editableRef.current) {
            const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            /* istanbul ignore else */ if (newContent.caretPosition) newContent.caretPosition = {
                startLine: newContent.caretPosition.endLine,
                startChar: newContent.caretPosition.endChar,
                endLine: newContent.caretPosition.endLine,
                endChar: newContent.caretPosition.endChar
            };
            setContent(newContent, "Handle refresh event");
        }
    }, [
        contentProps,
        setContent
    ]);
    (0, $7fPBF.useEffect)(()=>{
        /* istanbul ignore else */ if (editableRef.current) {
            const editableRefCurrent = editableRef.current;
            editableRefCurrent.addEventListener("editorv3refresh", handleRefreshEvent);
            return ()=>{
                editableRefCurrent?.removeEventListener("editorv3refresh", handleRefreshEvent);
            };
        }
    }, [
        handleRefreshEvent
    ]);
    // #endregion Input utilities
    // #region Handle focus/blur
    // Focus and blur events are container not contenteditable level events!
    const runFocusHandlers = (0, $7fPBF.useCallback)((e)=>{
        onFocusCapture?.(e);
        onFocus?.(e);
    }, [
        onFocus,
        onFocusCapture
    ]);
    const { isWaiting: isWaiting, captureFocus: captureFocus, cancelWaiting: cancelWaiting } = $0f261471404994f4$export$f13a708d2a7a10f9({
        pending: pending,
        input: input,
        windowMilliseconds: pendingWindowMilliseconds,
        timeoutMilliseconds: pendingTimeoutMilliseconds,
        onRelease: runFocusHandlers
    });
    const handleFocus = (0, $7fPBF.useCallback)((e)=>{
        if (captureFocus(e)) return;
        runFocusHandlers(e);
    }, [
        captureFocus,
        runFocusHandlers
    ]);
    const handleClick = (0, $7fPBF.useCallback)((e)=>{
        if (e.target instanceof Node && e.target === aiev3Ref.current && editableRef.current && editable) {
            // Simulate click on editable div
            // As the target is editor, need to select all content
            const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            // Select everything
            newContent.caretPositionF = {
                initialLine: 0,
                initialChar: 0,
                focusLine: newContent.lines.length - 1,
                focusChar: newContent.showMarkdown ? newContent.lines[newContent.lines.length - 1].lineMarkdown.length : newContent.lines[newContent.lines.length - 1].lineLength
            };
            setContent(newContent, "aiev3 click select all");
            editableRef.current.focus();
        }
    }, [
        contentProps,
        editable,
        setContent
    ]);
    const handleBlur = (0, $7fPBF.useCallback)(()=>{
        cancelWaiting();
        /* istanbul ignore else */ if (editableRef.current) {
            // Get current content (this should alreact be correct);
            const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            // Select nothing
            newContent.caretPosition = null;
            forceReturn(newContent);
        }
    }, [
        cancelWaiting,
        contentProps,
        forceReturn
    ]);
    // #endregion Handle focus/blur
    // #region Handle key/mouse events
    const handleKeyDown = (0, $7fPBF.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) {
            e.preventDefault();
            return;
        }
        /* istanbul ignore else */ if (editableRef.current && !contentProps.showMarkdown) {
            // Handle undo/redo
            /* istanbul ignore else */ if (e.ctrlKey && e.code === "KeyZ") {
                e.preventDefault();
                undo();
            } else if (e.ctrlKey && e.code === "KeyY") {
                e.preventDefault();
                redo();
            } else if (currentValue.isCaretLocked() && ![
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(e.key)) e.preventDefault();
            else if (![
                "Control",
                "Shift",
                "Alt"
            ].includes(e.key) && !(e.ctrlKey && (e.code === "KeyC" || e.code === "KeyX" || e.code === "KeyV"))) {
                // Get current information and update content buffer for positions
                const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                newContent.handleKeydown(e);
                setContent(newContent, `Handle key down: ${e.key}`);
            }
        }
    }, [
        contentProps,
        isWaiting,
        redo,
        setContent,
        currentValue,
        undo
    ]);
    const handleKeyUp = (0, $7fPBF.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) {
            e.preventDefault();
            return;
        }
        // Markdown editing should not be handled
        /* istanbul ignore else */ if (editableRef.current && !currentValue.showMarkdown) {
            // Stop handled keys
            /* istanbul ignore else */ if ([
                "KeyY",
                "KeyZ"
            ].includes(e.code) && e.ctrlKey) {
                e.stopPropagation();
                e.preventDefault();
                return;
            } else if ([
                "Backspace",
                "Delete"
            ].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
            } else if (![
                "Control",
                "Shift",
                "Alt"
            ].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                newContent.handleKeyup(e);
                // Create @block if @ has been typed
                if (atListFunction && newContent.caretPosition && newContent.caretPosition.startChar > 0) {
                    const replacePos = {
                        ...newContent.caretPosition,
                        startChar: newContent.caretPosition.startChar - 1
                    };
                    const lastChar = newContent.subLines(replacePos).map((l)=>l.lineText).reduce((a, b)=>a += b, "");
                    // Look for the @ character
                    if (lastChar.trim() === "@") newContent.splice(replacePos, [
                        new $0f261471404994f4$export$f727c5bfed9e77d4([
                            new $0f261471404994f4$export$2762eb7a56f6d4be({
                                text: "@",
                                type: "at"
                            })
                        ], contentProps)
                    ]);
                }
                setContent(newContent, `Handle key up: ${e.key}`);
            }
        }
    }, [
        atListFunction,
        contentProps,
        isWaiting,
        setContent,
        currentValue
    ]);
    const handleMouseUp = (0, $7fPBF.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) return;
        // Drop down list last entry can target again resize (current.parentElement)
        if (editableRef.current && e.target instanceof Node && (editableRef.current.parentElement === e.target || editableRef.current === e.target || editableRef.current.contains(e.target))) setTimeout(()=>{
            /* istanbul ignore else */ if (editableRef.current) {
                const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                newContent.checkStatus();
                setContent(newContent, "Handle mouse up on timeout");
            }
        }, 0);
    }, [
        contentProps,
        isWaiting,
        setContent
    ]);
    // #endregion Handle key/mouse events
    // #region Handle clipboard events
    const handleCopy = (0, $7fPBF.useCallback)((e)=>{
        e.stopPropagation();
        // Copy is harmless while waiting, cut is not
        if (isWaiting && e.type === "cut") {
            e.preventDefault();
            return;
        }
        /* istanbul ignore else */ if (editableRef.current) {
            const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            newContent.handleCopy(e);
            setContent(newContent, "Handle copy");
        }
    }, [
        contentProps,
        isWaiting,
        setContent
    ]);
    const handlePaste = (0, $7fPBF.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) {
            e.preventDefault();
            return;
        }
        /* istanbul ignore else */ if (editableRef.current) {
            const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            newContent.handlePaste(e);
            setContent(newContent, "Handle paste");
        }
    }, [
        contentProps,
        isWaiting,
        setContent
    ]);
    const handleBlock = (0, $7fPBF.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    // #endregion Handle clipboard events
    // #region Style recalculation
    const styleRecalc = (0, $7fPBF.useMemo)(()=>{
        const s = {
            ...style
        };
        switch(resize){
            case "vertical":
                s.resize = "vertical";
                s.overflow = "auto";
                break;
            case true:
                s.resize = "both";
                s.overflow = "auto";
                break;
        }
        if (showWindowView) s.backgroundColor = "rgba(0, 0, 0, 0.2)";
        return s;
    }, [
        resize,
        showWindowView,
        style
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (editableRef.current && !hasDrawnElement) {
            redrawElement(currentValue);
            setHasDrawnElement(true);
        }
    }, [
        hasDrawnElement,
        redrawElement,
        currentValue
    ]);
    return (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            (0, $bbzbN.jsx)("div", {
                ...rest,
                ref: aiev3Ref,
                className: [
                    "aiev3",
                    editable ? "" : "disabled",
                    currentValue.caretPosition !== null ? "editing" : "",
                    showWindowView ? "window-view-active" : "",
                    isWaiting ? "pending" : "",
                    rest.className ?? ""
                ].filter(Boolean).join(" "),
                id: id,
                onFocusCapture: handleFocus,
                onBlurCapture: (e)=>{
                    rest.onBlurCapture?.(e);
                    handleBlur();
                    window.getSelection()?.removeAllRanges();
                    rest.onBlur?.(e);
                    e.preventDefault();
                    e.stopPropagation();
                },
                onMouseUp: (e)=>{
                    handleMouseUp(e);
                    rest.onMouseUp?.(e);
                },
                onClick: (e)=>{
                    handleClick(e);
                    rest.onClick?.(e);
                },
                children: (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                    menuItems: menuItems,
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    showLowMenu: spellCheck || !styleOnContextMenu,
                    children: (0, $bbzbN.jsx)("div", {
                        className: `aiev3-resize${!noBorder ? " aiev3-resize-border" : ""}`,
                        style: styleRecalc,
                        children: (0, $bbzbN.jsx)("div", {
                            id: `${id}-editable`,
                            className: `aiev3-editing ${allowNewLine ? "multiline" : "singleline"}`,
                            contentEditable: editable && !showWindowView,
                            suppressContentEditableWarning: true,
                            role: editable ? "textbox" : undefined,
                            spellCheck: spellCheck,
                            ref: editableRef,
                            onKeyDownCapture: handleKeyDown,
                            onKeyUpCapture: handleKeyUp,
                            onCutCapture: handleCopy,
                            onCopyCapture: handleCopy,
                            onPasteCapture: handlePaste,
                            onDragStart: handleBlock,
                            onDragOver: handleBlock,
                            onDrop: handleBlock,
                            onDragEnter: handleBlock,
                            onDragLeave: handleBlock,
                            onDragEnd: handleBlock
                        })
                    })
                })
            }),
            allowWindowView && editable && (0, $bbzbN.jsx)($0f261471404994f4$var$$969bb2bbbbbb17fd$export$a634f244d0bbcc40, {
                id: `${id}-window`,
                showWindowView: showWindowView,
                setShowWindowView: setShowWindowView,
                state: currentValue,
                setState: (ret)=>{
                    forceReturn(ret);
                    // Refocus editable after closing window view
                    setTimeout(()=>editableRef.current?.focus(), 10);
                },
                includeAt: atListFunction !== undefined
            })
        ]
    });
};
$0f261471404994f4$export$c410cc7dbb67874b.displayName = "AsupEditorV3";
const $0f261471404994f4$export$64d7be461af4ab3e = ({ label: label, errorText: errorText, style: style, resize: resize, ...rest })=>{
    const outerStyle = {};
    const innerStyle = {
        ...style
    };
    /* istanbul ignore else */ if (style) {
        /* istanbul ignore else */ if (style.width) {
            outerStyle.width = style.width;
            innerStyle.width = "100%";
        }
        /* istanbul ignore else */ if (style.maxWidth) {
            outerStyle.maxWidth = style.maxWidth;
            innerStyle.maxWidth = "100%";
        }
        /* istanbul ignore else */ if (style.minWidth) {
            outerStyle.minWidth = style.minWidth;
            innerStyle.minWidth = "100%";
        }
        /* istanbul ignore else */ if (style.height) {
            outerStyle.height = style.height;
            innerStyle.height = "100%";
        } else {
            outerStyle.height = "calc(1.5em + 26px)";
            innerStyle.height = "100%";
        }
        /* istanbul ignore else */ if (style.maxHeight) {
            outerStyle.maxHeight = style.maxHeight;
            innerStyle.maxHeight = "100%";
        }
        /* istanbul ignore else */ if (style.minHeight) {
            outerStyle.minHeight = style.minHeight;
            innerStyle.minHeight = "100%";
        } else {
            outerStyle.minHeight = "calc(1.5em + 26px)";
            innerStyle.minHeight = "100%";
        }
        /* istanbul ignore else */ if (resize === true || resize === "vertical") {
            outerStyle.resize = "vertical";
            outerStyle.overflow = "auto";
        }
    }
    return (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).holder,
        style: outerStyle,
        children: [
            label !== undefined && (0, $bbzbN.jsx)("label", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).label,
                id: `${rest.id}-label`,
                htmlFor: `${rest.id}`,
                children: label
            }),
            errorText !== undefined && errorText.trim() !== "" && (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).errorText,
                children: (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                    children: errorText.split("\n").map((errorLine, ix)=>(0, $bbzbN.jsx)("div", {
                            children: errorLine
                        }, ix))
                })
            }),
            (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).editorHolder,
                children: (0, $bbzbN.jsx)($0f261471404994f4$export$c410cc7dbb67874b, {
                    ...rest,
                    "aria-labelledby": `${rest.id}-label`,
                    style: innerStyle,
                    noBorder: true,
                    resize: false
                })
            })
        ]
    });
};
$0f261471404994f4$export$64d7be461af4ab3e.displayName = "BaseEditorV3";
const $0f261471404994f4$export$2148d73965a312db = ({ id: id, checked: checked, change: change, label: label, ...rest })=>{
    /**
   * Toggle the checkbox state and notify change handlers.
   *
   * @param e - The event object
   */ const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        change(!checked);
    };
    return (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).holder,
        children: [
            (0, $bbzbN.jsx)("input", {
                ...rest,
                type: "checkbox",
                id: id,
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).baseCheckbox,
                checked: checked,
                onChange: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onClick: handleClick
            }),
            label !== undefined && (0, $bbzbN.jsx)("label", {
                id: `${id}-label`,
                htmlFor: id,
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).baseCheckboxLabel,
                onClick: handleClick,
                children: label
            })
        ]
    });
};
$0f261471404994f4$export$2148d73965a312db.displayName = "BaseCheckbox";
const $0f261471404994f4$export$1cfea591e85f6e12 = ({ lineChild: lineChild, children: children, open: open = false, timeMs: timeMs = 300, height: height = 300, disabled: disabled = false, contentBoxStyle: contentBoxStyle, ...rest })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [expanded, setExpanded] = (0, $7fPBF.useState)("closed");
    const [lastOpen, setLastOpen] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (open !== lastOpen) {
            if (open) startTransition(()=>setExpanded("placing"));
            else if (lastOpen !== null) startTransition(()=>setExpanded("closing"));
            startTransition(()=>setLastOpen(open));
        }
    }, [
        expanded,
        open,
        lastOpen
    ]);
    /**
   * Toggles the expanded state between "open" and "closed".
   *
   * @param e - Mouse event triggering the toggle action.
   */ const toggle = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        switch(expanded){
            case "closed":
                setExpanded("placing");
                break;
            case "open":
                setExpanded("closing");
                break;
        }
    };
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (expanded === "placing") setTimeout(()=>{
            setExpanded("opening");
        }, 5);
        if (expanded === "opening") setTimeout(()=>{
            setExpanded("open");
        }, timeMs);
        if (expanded === "closing") setTimeout(()=>{
            setExpanded("closed");
        }, timeMs);
    }, [
        expanded,
        timeMs
    ]);
    return (0, $bbzbN.jsxs)("div", {
        ...rest,
        className: [
            /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).expander,
            /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports)[expanded],
            disabled ? /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).disabled : "",
            ...rest.className ?? ""
        ].join(" "),
        onClick: (e)=>{
            if (!disabled && e.target instanceof HTMLDivElement && e.target.parentElement?.classList.contains(/*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).expander) && e.target.classList.contains(/*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).holder)) toggle(e);
        },
        children: [
            (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).holder,
                children: lineChild
            }),
            expanded !== "closed" && (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).expanderContent,
                style: {
                    ...contentBoxStyle,
                    transition: `min-height ${timeMs}ms ease-in-out, max-height ${timeMs}ms ease-in-out, opacity ${timeMs}ms ease-in-out`,
                    maxHeight: [
                        "open",
                        "opening"
                    ].includes(expanded) ? `${height}px` : "0",
                    minHeight: [
                        "open",
                        "opening"
                    ].includes(expanded) ? `${height}px` : "0"
                },
                children: children
            })
        ]
    });
};
$0f261471404994f4$export$1cfea591e85f6e12.displayName = "Expander";
const $0f261471404994f4$var$$533e9b937ad6d455$export$8554d9663e8a7107 = (0, $7fPBF.createContext)(null);
const $0f261471404994f4$var$$533e9b937ad6d455$export$fed038e1a302e255 = ({ object: object, setObject: setObject, objectTemplate: objectTemplate, children: children })=>{
    return (0, $bbzbN.jsx)($0f261471404994f4$var$$533e9b937ad6d455$export$8554d9663e8a7107.Provider, {
        value: {
            object: object,
            setObject: setObject,
            objectTemplate: objectTemplate
        },
        children: children
    });
};
$0f261471404994f4$var$$533e9b937ad6d455$export$fed038e1a302e255.displayName = "ObjectEditorContextProvider";
const $0f261471404994f4$export$267c05bbab99602d = ({ dataPoint: dataPoint, ...rest })=>{
    const objectEditorContext = (0, $7fPBF.useContext)($0f261471404994f4$var$$533e9b937ad6d455$export$8554d9663e8a7107);
    const thisOption = dataPoint.split(".").pop();
    const thisOptionType = objectEditorContext?.objectTemplate.find((item)=>item.name === thisOption)?.type;
    const thisOptionValues = objectEditorContext?.objectTemplate.find((item)=>item.name === thisOption)?.options;
    const thisOptionLabel = objectEditorContext?.objectTemplate.find((item)=>item.name === thisOption)?.label ?? thisOption;
    const thisValueRaw = (0, $gSkQi.get)(objectEditorContext?.object, dataPoint);
    /**
   * Update the parent object with the new value for this data point.
   *
   * @param ret - The new value (string|number|boolean|undefined) provided
   *        by the child input component.
   */ const handleChange = (ret)=>{
        /* istanbul ignore else */ if (objectEditorContext) {
            const newObject = (0, $gSkQi.cloneDeep)(objectEditorContext.object);
            /* istanbul ignore else */ if ((0, $gSkQi.get)(newObject, dataPoint) !== ret) {
                (0, $gSkQi.set)(newObject, dataPoint, ret);
                objectEditorContext.setObject(newObject);
            }
        }
    };
    return !objectEditorContext ? null : (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: thisOptionType === "boolean" ? (0, $bbzbN.jsx)($0f261471404994f4$export$2148d73965a312db, {
            id: `id-${dataPoint}`,
            checked: thisValueRaw ?? false,
            change: handleChange,
            label: thisOptionLabel,
            ...rest
        }) : thisOptionType === "select" && thisOptionValues ? (0, $bbzbN.jsx)($0f261471404994f4$export$dcee1aa94a106d27, {
            id: `id-${dataPoint}`,
            value: thisValueRaw,
            availableOptions: thisOptionValues,
            change: handleChange,
            label: thisOptionLabel,
            ...rest
        }) : (0, $bbzbN.jsx)($0f261471404994f4$export$e1f706e5673fef9e, {
            id: `id-${dataPoint}`,
            value: thisValueRaw,
            onNewValue: handleChange,
            label: thisOptionLabel,
            ...rest
        })
    });
};
$0f261471404994f4$export$267c05bbab99602d.displayName = "ItemInput";
const $0f261471404994f4$var$$7822d9152214a22a$export$8d67358b399a570 = ({ dataPath: dataPath, ...rest })=>{
    const objectEditorContext = (0, $7fPBF.useContext)($0f261471404994f4$var$$533e9b937ad6d455$export$8554d9663e8a7107);
    const parentObject = (0, $7fPBF.useMemo)(()=>objectEditorContext?.object ?? {}, [
        objectEditorContext?.object
    ]);
    const thisName = dataPath.split(".").pop();
    const thisObject = (0, $7fPBF.useMemo)(()=>parentObject[thisName], [
        parentObject,
        thisName
    ]);
    const availableItems = objectEditorContext?.objectTemplate ?? [];
    const ix = thisObject ? Object.keys(parentObject).indexOf(thisName) : -1;
    const [currentName, setCurrentName] = (0, $7fPBF.useState)(dataPath.split(".").pop() ?? // istanbul ignore next
    "");
    const handleBlur = (0, $7fPBF.useCallback)(()=>{
        /* istanbul ignore else */ if (objectEditorContext && parentObject) {
            // Get full original object
            const newParentObject = Object.entries((0, $gSkQi.cloneDeep)(parentObject));
            newParentObject[ix][0] = currentName;
            objectEditorContext.setObject(Object.fromEntries(newParentObject));
        }
    }, [
        currentName,
        ix,
        objectEditorContext,
        parentObject
    ]);
    const handleChange = (0, $7fPBF.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setCurrentName(e.currentTarget.value.replace(/[^a-zA-Z0-9_]/g, ""));
    }, []);
    return ix === -1 ? (0, $bbzbN.jsxs)("div", {
        children: [
            dataPath,
            " not found"
        ]
    }) : (0, $bbzbN.jsx)($0f261471404994f4$export$1cfea591e85f6e12, {
        ...rest,
        lineChild: (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                (0, $bbzbN.jsx)("label", {
                    className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).label,
                    id: `label-${dataPath}`,
                    htmlFor: `name-${dataPath}`,
                    children: "Name"
                }),
                (0, $bbzbN.jsx)("input", {
                    id: `name-${dataPath}`,
                    className: /*@__PURE__*/ $0f261471404994f4$var$$parcel$interopDefault($0f261471404994f4$var$$d1df120914c5e45a$exports).baseInput,
                    value: currentName,
                    onChange: handleChange,
                    onBlur: handleBlur
                })
            ]
        }),
        children: availableItems.map((item, ix)=>(0, $bbzbN.jsx)((0, $7fPBF.Fragment), {
                children: (0, $bbzbN.jsx)($0f261471404994f4$export$267c05bbab99602d, {
                    dataPoint: `${dataPath}.${item.name}`
                })
            }, ix))
    });
};
$0f261471404994f4$var$$7822d9152214a22a$export$8d67358b399a570.displayName = "InternalObjectEditor";
const $0f261471404994f4$export$ec7da929f39d97c8 = ({ object: object, setObject: setObject, objectTemplate: objectTemplate })=>{
    return (0, $bbzbN.jsx)($0f261471404994f4$var$$533e9b937ad6d455$export$fed038e1a302e255, {
        object: object,
        setObject: setObject,
        objectTemplate: objectTemplate,
        children: Object.keys(object).map((property, ix)=>(0, $bbzbN.jsx)($0f261471404994f4$var$$7822d9152214a22a$export$8d67358b399a570, {
                dataPath: property
            }, `${ix}-${property}`))
    });
};
$0f261471404994f4$export$ec7da929f39d97c8.displayName = "ObjectEditor";
var $0f261471404994f4$var$$a26c210fc5bc2447$export$2e2bcd8739ae039 = $0f261471404994f4$export$ec7da929f39d97c8;
const $0f261471404994f4$var$$2cd891dbea8e972b$export$f1a0852707cadfcc = [
    {
        name: "fontFamily",
        label: "Font family",
        type: "select",
        options: [
            {
                value: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', sans-serif",
                label: "Sans Serif"
            },
            {
                value: "'Courier New', monospace",
                label: "Monospace"
            }
        ]
    },
    {
        name: "fontSize",
        label: "Font size",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: "8pt",
                label: "8pt"
            },
            {
                value: "9pt",
                label: "9pt"
            },
            {
                value: "10pt",
                label: "10pt"
            },
            {
                value: "11pt",
                label: "11pt"
            },
            {
                value: "12pt",
                label: "12pt"
            },
            {
                value: "14pt",
                label: "14pt"
            },
            {
                value: "16pt",
                label: "16pt"
            },
            {
                value: "18pt",
                label: "18pt"
            }
        ]
    },
    {
        name: "fontStyle",
        label: "Font style",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: "italic",
                label: "Italic"
            }
        ]
    },
    {
        name: "fontWeight",
        label: "Font weight",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: 300,
                label: "Thin"
            },
            {
                value: 600,
                label: "Normal"
            },
            {
                value: 700,
                label: "Heavy"
            },
            {
                value: 1000,
                label: "Very heavy"
            }
        ]
    },
    {
        name: "color",
        label: "Colour",
        type: "string"
    },
    {
        name: "textDecoration",
        label: "Text decoration",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: "underline",
                label: "Underline"
            },
            {
                value: "line-through",
                label: "Line Through"
            }
        ]
    },
    {
        name: "isLocked",
        label: "Stop blocks being edited (isLocked)",
        type: "boolean"
    },
    {
        name: "isNotAvailable",
        label: "Stop user from choosing this style (isNotAvailable)",
        type: "boolean"
    }
];
const $0f261471404994f4$export$bf67e8fa85c2bdc7 = ({ styles: styles, setStyles: setStyles, styleItems: styleItems = $0f261471404994f4$var$$2cd891dbea8e972b$export$f1a0852707cadfcc })=>(0, $bbzbN.jsx)($0f261471404994f4$var$$a26c210fc5bc2447$export$2e2bcd8739ae039, {
        object: styles,
        setObject: setStyles,
        objectTemplate: styleItems
    });
$0f261471404994f4$export$bf67e8fa85c2bdc7.displayName = "StylesEditor";
var $0f261471404994f4$var$$4c5fb5bb6e826a01$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "getObjectDiff", ()=>$0f261471404994f4$export$db8269090bd3dd4);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "getTextFromEditorV3", ()=>$0f261471404994f4$export$59ffc450e12fbd65);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "hasStylesToRemove", ()=>$0f261471404994f4$export$5bbd286e9783a47b);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "joinV3intoBlock", ()=>$0f261471404994f4$export$6be11f3b04f364b4);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "removeStylesFromEditorV3", ()=>$0f261471404994f4$export$c4055ded8e1007ea);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "replaceTextInEditorV3", ()=>$0f261471404994f4$export$4473dc511c49aabc);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "searchEditorV3Content", ()=>$0f261471404994f4$export$458b3725b25c35e4);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "splitV3intoLines", ()=>$0f261471404994f4$export$9046ef79d808c3d9);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$4c5fb5bb6e826a01$exports, "stringToV3", ()=>$0f261471404994f4$export$4c11677f6b5bfb11);
function $0f261471404994f4$export$db8269090bd3dd4(obj1, obj2, returnChange) {
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) return obj1 !== obj2 ? [
        obj1,
        obj2
    ] : undefined;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    const uniqueKeys = new Set([
        ...keys1,
        ...keys2
    ]);
    /* Set up the return object */ const isArray = Array.isArray(obj1);
    const differences = {};
    /* Loop through the keys and compare values */ for (const key of uniqueKeys){
        const value1 = obj1[key];
        const value2 = obj2[key];
        if (typeof value1 === "object" && value1 !== null && typeof value2 === "object" && value2 !== null && !returnChange) {
            const nestedDifferences = $0f261471404994f4$export$db8269090bd3dd4(value1, value2, false);
            if (nestedDifferences) differences[key] = nestedDifferences;
        } else if (typeof value1 === "object" && value1 !== null && typeof value2 === "object" && value2 !== null && returnChange && !(0, $gSkQi.isEqual)(value1, value2)) differences[key] = value2;
        else if (!(typeof value1 === "object" && value1 !== null && typeof value2 === "object" && value2 !== null) && value1 !== value2) /* Add any differences according to the return type */ differences[key] = returnChange ? value2 : [
            value1,
            value2
        ];
    }
    /* Check if there are any differences */ const hasChanges = Object.keys(differences).length > 0;
    if (!hasChanges) return undefined;
    /* Return as array if input was array, otherwise as object */ if (isArray) {
        const arrayResult = [];
        for (const key of Object.keys(differences)){
            const index = parseInt(key);
            /* istanbul ignore else */ if (!isNaN(index)) arrayResult[index] = differences[key];
        }
        return arrayResult;
    }
    return differences;
}
const $0f261471404994f4$export$59ffc450e12fbd65 = (input)=>input && input.lines.length > 0 ? input.lines.map((l)=>l.textBlocks.map((tb)=>tb.text).join("")) : [
        ""
    ];
const $0f261471404994f4$export$5bbd286e9783a47b = (content, styleList)=>{
    if (!$0f261471404994f4$export$a2e4f3e0d013ef9f(content)) return false;
    const hasStyles = new $0f261471404994f4$export$1a4903393d6b1b7d(content).hasStyles;
    return hasStyles.some((s)=>styleList.includes(s));
};
const $0f261471404994f4$export$c4055ded8e1007ea = (content, stylesToDelete, stylesToClean)=>{
    if (!$0f261471404994f4$export$a2e4f3e0d013ef9f(content)) return content;
    const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(content);
    newContent.deleteStyles(stylesToDelete);
    newContent.cleanStyles(stylesToClean);
    return {
        ...content,
        lines: newContent.data.lines
    };
};
const $0f261471404994f4$export$4473dc511c49aabc = (input, oldPhrase, newPhrase, newLineChar = "~")=>{
    const ret = new $0f261471404994f4$export$1a4903393d6b1b7d(input);
    // Check for characters in the old phrase
    // Check the phrase exists in the target
    /* istanbul ignore else */ if (oldPhrase !== "" && ret.getTextPosition(oldPhrase)) {
        // Get replacement content
        const newContent = new $0f261471404994f4$export$1a4903393d6b1b7d(newPhrase);
        // New content style
        const newContentStyleMap = new Set(newContent.lines.flatMap((line)=>line.textBlocks.map((block)=>block.style)));
        const newContentStyle = newContentStyleMap.size === 1 ? newContentStyleMap.values().next().value : undefined;
        // Add line breaks to replacement content
        while(newContent.getTextPosition(newLineChar)?.length ?? false){
            const pos = newContent.getTextPosition(newLineChar);
            /* istanbul ignore else */ if (pos) newContent.splitLine(pos[0]);
        }
        // Update all lines
        const pos = ret.getTextPosition(oldPhrase);
        /* istanbul ignore else */ if (pos && pos.length > 0) for(let i = pos.length - 1; i >= 0; i--){
            const thisPos = pos[i];
            // Check if target has a single style
            const target = ret.subLines(thisPos);
            const targetStyle = target.length === 1 && target[0].textBlocks.length === 1 ? target[0].textBlocks[0].style : undefined;
            // Create this replacement
            const thisReplacement = new $0f261471404994f4$export$1a4903393d6b1b7d(newContent);
            // Check new content has no style
            /* istanbul ignore else */ if (targetStyle && !newContentStyle) thisReplacement.applyStyle(targetStyle, {
                startLine: 0,
                startChar: 0,
                endLine: thisReplacement.lines.length - 1,
                endChar: thisReplacement.lines[thisReplacement.lines.length - 1].lineLength
            });
            // Update the content
            ret.splice(thisPos, thisReplacement.lines);
        }
    }
    return ret.data;
};
const $0f261471404994f4$export$458b3725b25c35e4 = (searchText, editorV3Content)=>{
    if (!editorV3Content || !editorV3Content.lines) return 0;
    const content = new $0f261471404994f4$export$1a4903393d6b1b7d(editorV3Content);
    // Extracted function to count line matches
    return content.lines.map((l)=>l.lineText.toLowerCase().includes(searchText.toLowerCase()) ? 1 : 0).reduce((a, b)=>a + b, 0);
};
var $0f261471404994f4$var$$ca43fe01b6155439$exports = {};
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ca43fe01b6155439$exports, "cleanIsEqual", ()=>$0f261471404994f4$export$501d19eb8a679b38);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ca43fe01b6155439$exports, "cleanObject", ()=>$0f261471404994f4$export$969b205aa1357eaa);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ca43fe01b6155439$exports, "useDebounceStack", ()=>$0f261471404994f4$export$426a3338f36cbf0a);
$0f261471404994f4$var$$parcel$export($0f261471404994f4$var$$ca43fe01b6155439$exports, "usePendingUpdate", ()=>$0f261471404994f4$export$f13a708d2a7a10f9);

});

parcelRegister("iQGjt", function(module, exports) {

$parcel$export(module.exports, "omitDeep", function () { return $9d3ee067e7590e16$export$77ceec6772d0c749; });

var $gSkQi = parcelRequire("gSkQi");
function $9d3ee067e7590e16$export$77ceec6772d0c749(obj, keys) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isArray(obj)) return obj.map((item)=>$9d3ee067e7590e16$export$77ceec6772d0c749(item, keys));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).isObject(obj)) {
        const omitted = (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).omit((0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).omitBy(obj, (value)=>value === undefined), keys);
        return (0, (/*@__PURE__*/$parcel$interopDefault($gSkQi))).mapValues(omitted, (value)=>$9d3ee067e7590e16$export$77ceec6772d0c749(value, keys));
    }
    return obj;
}

});

parcelRegister("9Jgpw", function(module, exports) {

$parcel$export(module.exports, "eSingleSource", function () { return $c80561b1cdde8de2$export$abb8334d921faac2; });
$parcel$export(module.exports, "ADD_DOMAIN_REPLACEMENT", function () { return $c80561b1cdde8de2$export$aebf9a63aeca33a2; });
$parcel$export(module.exports, "ADD_HIERARCHY_NODES", function () { return $c80561b1cdde8de2$export$af63543297d305d3; });
$parcel$export(module.exports, "ADD_SINGLE_REPLACEMENT", function () { return $c80561b1cdde8de2$export$1f26f8a4b9501121; });
$parcel$export(module.exports, "CLEAR_HIERARCHY", function () { return $c80561b1cdde8de2$export$257c673177a91d25; });
$parcel$export(module.exports, "LOAD_CLINICAL_LIBRARY", function () { return $c80561b1cdde8de2$export$ac3998a107a43651; });
$parcel$export(module.exports, "LOAD_HIERARCHY", function () { return $c80561b1cdde8de2$export$7cc68a8d696fbd52; });
$parcel$export(module.exports, "PATCH_HIERARCHY_COMMENTS", function () { return $c80561b1cdde8de2$export$271d48053b04aeae; });
$parcel$export(module.exports, "REMOVE_DOMAIN_REPLACEMENT", function () { return $c80561b1cdde8de2$export$70df1c7f38ea0a27; });
$parcel$export(module.exports, "REMOVE_HIERARCHY_COMMENT", function () { return $c80561b1cdde8de2$export$a8285857be72f67d; });
$parcel$export(module.exports, "REMOVE_HIERARCHY_NODE", function () { return $c80561b1cdde8de2$export$5dad260e960f0189; });
$parcel$export(module.exports, "REMOVE_SINGLE_REPLACEMENT", function () { return $c80561b1cdde8de2$export$ab292c949b56bfc7; });
$parcel$export(module.exports, "SAVE_HIERARCHY", function () { return $c80561b1cdde8de2$export$e53831f0c7cb521e; });
$parcel$export(module.exports, "SAVE_HIERARCHY_COMPLETED", function () { return $c80561b1cdde8de2$export$655b96db8658da6c; });
$parcel$export(module.exports, "SAVE_HIERARCHY_FAILED", function () { return $c80561b1cdde8de2$export$9109a1640aa38ed; });
$parcel$export(module.exports, "SAVE_TOC_MAJOR_VERSION", function () { return $c80561b1cdde8de2$export$c347f60526f1d96e; });
$parcel$export(module.exports, "SET_ACCESS_RIGHTS", function () { return $c80561b1cdde8de2$export$1738d08d010c5538; });
$parcel$export(module.exports, "SET_CLINICAL_LIBRARY_LOADING", function () { return $c80561b1cdde8de2$export$8289db70244884a2; });
$parcel$export(module.exports, "SET_HIERARCHY_COMMENT_PANEL", function () { return $c80561b1cdde8de2$export$ef54187a16f8d1d8; });
$parcel$export(module.exports, "SET_HIERARCHY_ID", function () { return $c80561b1cdde8de2$export$9d2edfc625b73cbb; });
$parcel$export(module.exports, "SET_HIERARCHY_NAME_SAVE_BLOCKER", function () { return $c80561b1cdde8de2$export$c29646e44b25c121; });
$parcel$export(module.exports, "SET_HIERARCHY_SAVE_REQUEST_STATUS", function () { return $c80561b1cdde8de2$export$a5abb8ce3f5e191b; });
$parcel$export(module.exports, "SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS", function () { return $c80561b1cdde8de2$export$ad7562a69c9ee774; });
$parcel$export(module.exports, "SET_HIERARCHY_SUBSCRIPTION_STATUS", function () { return $c80561b1cdde8de2$export$efd77e54249e655e; });
$parcel$export(module.exports, "UPDATE_DOMAIN_REPLACEMENT", function () { return $c80561b1cdde8de2$export$69e68a1ae7b0c92; });
$parcel$export(module.exports, "UPDATE_HIERARCHY", function () { return $c80561b1cdde8de2$export$ab8bfe308b46c5f6; });
$parcel$export(module.exports, "UPDATE_HIERARCHY_COMMENT", function () { return $c80561b1cdde8de2$export$e68420b86c7c0e7b; });
$parcel$export(module.exports, "UPDATE_SINGLE_REPLACEMENT", function () { return $c80561b1cdde8de2$export$bc2926584d3936e1; });
$parcel$export(module.exports, "UPDATE_TLF_ITEM_INDEX", function () { return $c80561b1cdde8de2$export$cf1d4a398dc07663; });
$parcel$export(module.exports, "eShowDomainText", function () { return $c80561b1cdde8de2$export$5aeb33928fc04af7; });
var $c80561b1cdde8de2$export$abb8334d921faac2 = /*#__PURE__*/ function(eSingleSource) {
    eSingleSource["hierarchy"] = "Hierarchy";
    eSingleSource["tlfItem"] = "TlfItem";
    eSingleSource["domain"] = "Domain";
    return eSingleSource;
}({});
const $c80561b1cdde8de2$export$aebf9a63aeca33a2 = "ADD_DOMAIN_REPLACEMENT";
const $c80561b1cdde8de2$export$af63543297d305d3 = "ADD_HIERARCHY_NODES";
const $c80561b1cdde8de2$export$1f26f8a4b9501121 = "ADD_SINGLE_REPLACEMENT";
const $c80561b1cdde8de2$export$257c673177a91d25 = "CLEAR_HIERARCHY";
const $c80561b1cdde8de2$export$ac3998a107a43651 = "LOAD_CLINICAL_LIBRARY";
const $c80561b1cdde8de2$export$7cc68a8d696fbd52 = "LOAD_HIERARCHY";
const $c80561b1cdde8de2$export$271d48053b04aeae = "PATCH_HIERARCHY_COMMENTS";
const $c80561b1cdde8de2$export$70df1c7f38ea0a27 = "REMOVE_DOMAIN_REPLACEMENT";
const $c80561b1cdde8de2$export$a8285857be72f67d = "REMOVE_HIERARCHY_COMMENT";
const $c80561b1cdde8de2$export$5dad260e960f0189 = "REMOVE_HIERARCHY_NODE";
const $c80561b1cdde8de2$export$ab292c949b56bfc7 = "REMOVE_SINGLE_REPLACEMENT";
const $c80561b1cdde8de2$export$e53831f0c7cb521e = "SAVE_HIERARCHY";
const $c80561b1cdde8de2$export$655b96db8658da6c = "SAVE_HIERARCHY_COMPLETED";
const $c80561b1cdde8de2$export$9109a1640aa38ed = "SAVE_HIERARCHY_FAILED";
const $c80561b1cdde8de2$export$c347f60526f1d96e = "SAVE_TOC_MAJOR_VERSION";
const $c80561b1cdde8de2$export$1738d08d010c5538 = "SET_ACCESS_RIGHTS";
const $c80561b1cdde8de2$export$8289db70244884a2 = "SET_CLINICAL_LIBRARY_LOADING";
const $c80561b1cdde8de2$export$ef54187a16f8d1d8 = "SET_HIERARCHY_COMMENT_PANEL";
const $c80561b1cdde8de2$export$9d2edfc625b73cbb = "SET_HIERARCHY_ID";
const $c80561b1cdde8de2$export$c29646e44b25c121 = "SET_HIERARCHY_NAME_SAVE_BLOCKER";
const $c80561b1cdde8de2$export$a5abb8ce3f5e191b = "SET_HIERARCHY_SAVE_REQUEST_STATUS";
const $c80561b1cdde8de2$export$ad7562a69c9ee774 = "SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS";
const $c80561b1cdde8de2$export$efd77e54249e655e = "SET_HIERARCHY_SUBSCRIPTION_STATUS";
const $c80561b1cdde8de2$export$69e68a1ae7b0c92 = "UPDATE_DOMAIN_REPLACEMENT";
const $c80561b1cdde8de2$export$ab8bfe308b46c5f6 = "UPDATE_HIERARCHY";
const $c80561b1cdde8de2$export$e68420b86c7c0e7b = "UPDATE_HIERARCHY_COMMENT";
const $c80561b1cdde8de2$export$bc2926584d3936e1 = "UPDATE_SINGLE_REPLACEMENT";
const $c80561b1cdde8de2$export$cf1d4a398dc07663 = "UPDATE_TLF_ITEM_INDEX";
var $c80561b1cdde8de2$export$5aeb33928fc04af7 = /*#__PURE__*/ function(eShowDomainText) {
    eShowDomainText["Domain"] = "Domain";
    eShowDomainText["Original text"] = "Original Text";
    return eShowDomainText;
}({});

});



parcelRegister("577bh", function(module, exports) {

$parcel$export(module.exports, "hcr_addHierarchyNodes", function () { return $0532d585724a871b$export$d962c2733f17e2f3; });

var $6sBTi = parcelRequire("6sBTi");
const $0532d585724a871b$export$d962c2733f17e2f3 = (state, action)=>{
    const updatedHierarchyNodes = [
        ...state.hierarchyNodes.filter((hn)=>!action.hierarchyNodes.find((h)=>h.id === hn.id)),
        ...action.hierarchyNodes
    ];
    return {
        ...state,
        hierarchyNodes: updatedHierarchyNodes,
        parentTemplates: state.hierarchy ? (0, $6sBTi.hcr_buildParentTemplates)(state.hierarchy, updatedHierarchyNodes) : state.parentTemplates
    };
};

});
parcelRegister("6sBTi", function(module, exports) {

$parcel$export(module.exports, "hcr_buildParentTemplates", function () { return $2294a9ef65e666f3$export$213b383f0aab3bdf; });

var $9BAl1 = parcelRequire("9BAl1");

var $1vmng = parcelRequire("1vmng");

var $2GHO7 = parcelRequire("2GHO7");
const $2294a9ef65e666f3$export$213b383f0aab3bdf = (currentHierarchy, hierarchyNodes)=>{
    const parents = (0, $9BAl1.getThisAndParentHierarchies)(currentHierarchy.parentId, hierarchyNodes);
    const parentsWithTlfType = parents.map((ph)=>({
            ...ph,
            tlfType: (0, $1vmng.getHierarchyTlfType)(ph.level)
        }));
    /**
   * The resolved TLF type (Template or Shell) of the current hierarchy, used to
   * determine which parent hierarchies' data should be included in the parentTemplates.
   */ const currentTlfType = (0, $1vmng.getHierarchyTlfType)(currentHierarchy.level);
    return parentsWithTlfType.reduce((acc, ph)=>{
        // Add in new domain replacements from this hierarchy - Shell levels still inherit
        // from other Shell-level ancestors (e.g. Report inherits from Study, but Study itself
        // has no Shell-level ancestors so gets none)
        if (currentTlfType === ph.tlfType) acc.domainReplacements = [
            ...acc.domainReplacements,
            ...ph.domainReplacements.filter((dr)=>!acc.domainReplacements.some((r)=>r.domain === dr.domain && r.oldText === dr.oldText))
        ];
        // Add in new external list replacements from this hierarchy - Shell levels still inherit
        // from other Shell-level ancestors (e.g. Report inherits from Study)
        if (currentTlfType === ph.tlfType) acc.lists = [
            ...acc.lists,
            ...ph.lists.filter((list)=>!acc.lists.some((l)=>l.givenName === (list.givenName ?? // istanbul ignore next
                    "blank"))).map((list)=>({
                    ...list,
                    fromHierarchyId: ph.id
                }))
        ];
        // Add in new row groups from this hierarchy - no level type filter
        acc.rowGroups = [
            ...acc.rowGroups,
            ...ph.rowGroups.filter((rowGroup)=>!acc.rowGroups.some((rg)=>rg.name === (rowGroup.name ?? // istanbul ignore next
                    "blank"))).map((rg)=>({
                    ...rg,
                    fromHierarchyId: ph.id
                }))
        ];
        // Get current single names (Report inherits from Study)
        if (currentTlfType === ph.tlfType) acc.singles = [
            ...acc.singles,
            ...ph.singles.filter((single)=>!acc.singles.some((s)=>s.oldText === single.oldText)).map((single)=>({
                    ...single,
                    fromHierarchyId: ph.id
                }))
        ];
        // Add clinical library data from parent hierarchies with matching TLF type - Shell
        // levels still inherit from other Shell-level ancestors (Report inherits from
        // Study, but Study itself has no Shell-level ancestors so gets none)
        if (currentTlfType === ph.tlfType && ph.clinicalLibrary) {
            const mergedClinicalData = (0, $2GHO7.mergeClinicalLibraryData)({
                clinicalDatasets: acc.clinicalDatasets,
                clinicalCodeLists: acc.clinicalCodeLists,
                clinicalValueLists: acc.clinicalValueLists,
                clinicalComments: acc.clinicalComments,
                clinicalMethods: acc.clinicalMethods,
                clinicalWhereClauses: acc.clinicalWhereClauses
            }, ph.clinicalLibrary);
            acc.clinicalDatasets = mergedClinicalData.clinicalDatasets;
            acc.clinicalCodeLists = mergedClinicalData.clinicalCodeLists;
            acc.clinicalValueLists = mergedClinicalData.clinicalValueLists;
            acc.clinicalComments = mergedClinicalData.clinicalComments;
            acc.clinicalMethods = mergedClinicalData.clinicalMethods;
            acc.clinicalWhereClauses = mergedClinicalData.clinicalWhereClauses;
        }
        // Add ARS entities from parent hierarchies - no level type filter, so the full ancestor chain contributes
        acc.analysisMethods = [
            ...acc.analysisMethods,
            ...(ph.analysisMethods ?? []).filter((am)=>!acc.analysisMethods.some((a)=>a.name === am.name)).map((am)=>({
                    ...am,
                    fromHierarchyId: ph.id
                }))
        ];
        // Add ARS entities from parent hierarchies
        if (currentTlfType === ph.tlfType) {
            acc.analysisSets = [
                ...acc.analysisSets,
                ...(ph.analysisSets ?? []).filter((ans)=>!acc.analysisSets.some((a)=>a.name === ans.name)).map((as)=>({
                        ...as,
                        fromHierarchyId: ph.id
                    }))
            ];
            acc.dataSubsets = [
                ...acc.dataSubsets,
                ...(ph.dataSubsets ?? []).filter((ds)=>!acc.dataSubsets.some((d)=>d.name === ds.name)).map((ds)=>({
                        ...ds,
                        fromHierarchyId: ph.id
                    }))
            ];
            acc.groupingFactors = [
                ...acc.groupingFactors,
                ...(ph.groupingFactors ?? []).filter((gf)=>!acc.groupingFactors.some((g)=>g.name === gf.name)).map((gf)=>({
                        ...gf,
                        fromHierarchyId: ph.id
                    }))
            ];
        }
        return acc;
    }, {
        clinicalDatasets: [],
        clinicalCodeLists: [],
        clinicalValueLists: [],
        clinicalComments: [],
        clinicalMethods: [],
        clinicalWhereClauses: [],
        domainReplacements: [],
        lists: [],
        rowGroups: [],
        singles: [],
        analysisSets: [],
        analysisMethods: [],
        caseWhenConditions: [],
        dataSubsets: [],
        groupingFactors: []
    });
};

});
parcelRegister("9BAl1", function(module, exports) {

$parcel$export(module.exports, "getThisAndParentHierarchies", function () { return $4fc8ecb643689b56$export$ce82dff99bac84cc; });

var $7Wd8C = parcelRequire("7Wd8C");
const $4fc8ecb643689b56$export$ce82dff99bac84cc = (id, hierarchyNodes)=>{
    const ret = [];
    // Get first node
    let current = hierarchyNodes.find((h)=>h.id === id && h.level !== (0, $7Wd8C.eHierarchyLevel).TopLevel);
    // Loop through parents
    while(current){
        ret.push(current);
        current = hierarchyNodes.find((h)=>h.id === current.parentId && h.level !== (0, $7Wd8C.eHierarchyLevel).TopLevel);
    }
    return ret;
};

});

parcelRegister("1vmng", function(module, exports) {

$parcel$export(module.exports, "getHierarchyTlfType", function () { return $9b3433dacc87673b$export$2a23292893528fc; });

var $7Wd8C = parcelRequire("7Wd8C");

var $98Em8 = parcelRequire("98Em8");
/**
 * The hierarchy levels that are classified as Template-type levels. All other levels
 * (Study, Report) are classified as Shell-type levels.
 */ const $9b3433dacc87673b$var$templateLevels = [
    (0, $7Wd8C.eHierarchyLevel).TopLevel,
    (0, $7Wd8C.eHierarchyLevel).Corporate,
    (0, $7Wd8C.eHierarchyLevel).TA,
    (0, $7Wd8C.eHierarchyLevel).Project
];
const $9b3433dacc87673b$export$2a23292893528fc = (level)=>{
    return $9b3433dacc87673b$var$templateLevels.includes(level) ? (0, $98Em8.eTlfType).Template : (0, $98Em8.eTlfType).Shell;
};

});
parcelRegister("98Em8", function(module, exports) {

$parcel$export(module.exports, "eTlfType", function () { return $f35cccf15d184dac$export$f9a29ff46b9877a8; });
$parcel$export(module.exports, "getAllStyles", function () { return $f35cccf15d184dac$export$f54e945d4d58df5e; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
var $f35cccf15d184dac$export$f9a29ff46b9877a8 = /*#__PURE__*/ function(eTlfType) {
    eTlfType["Template"] = "Template";
    eTlfType["Shell"] = "Shell";
    return eTlfType;
}({});
const $f35cccf15d184dac$export$f54e945d4d58df5e = async (backEndUrl, _, controller)=>{
    const url = `${backEndUrl}Styles`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load styles failed", error);
    }
};

});
parcelRegister("8A5VF", function(module, exports) {

$parcel$export(module.exports, "processAxiosError", function () { return $af5112622b07bc1b$export$a55fd5fdaaeb0e70; });

var $h3OEn = parcelRequire("h3OEn");
const $af5112622b07bc1b$export$a55fd5fdaaeb0e70 = (msg, error)=>{
    // Base error
    let errorText = `${msg}, unknown error`;
    // Check for axios error
    switch(error.response?.status){
        case (0, $h3OEn.HttpStatusCode).TooManyRequests:
            errorText = `${msg}, ${error.response.data?.message ?? "The report you are trying to access is currently in use, please try again later."}`;
            break;
        case (0, $h3OEn.HttpStatusCode).Forbidden:
            errorText = `${msg}, ${error.response.data?.message ?? "access denied"}`;
            break;
        case (0, $h3OEn.HttpStatusCode).BadRequest:
            {
                const data = error.response.data;
                const message = typeof data === "string" ? data : data?.message;
                errorText = `${msg}${message ? `, ${message}` : ""}`;
            }
            break;
        case (0, $h3OEn.HttpStatusCode).InternalServerError:
            errorText = `${msg}, server error`;
            break;
        default:
            switch(error.code){
                case "ERR_NETWORK":
                    errorText = `${msg}, network error`;
                    break;
                case "ERR_CANCELED":
                    errorText = `${msg}, request cancelled`;
                    break;
                case "ERR_BAD_RESPONSE":
                    errorText = `${msg}, server error`;
                    break;
                case "ERR_BAD_REQUEST":
                    {
                        errorText = `${msg}`;
                        const badRequestMessage = error.response.data?.message ?? "";
                        if (badRequestMessage !== "") errorText += `, ${badRequestMessage}`;
                    }
                    break;
                default:
                    if (error.message) errorText = `${msg}, ${error.message}`;
            }
            break;
    }
    return {
        success: false,
        errorText: errorText
    };
};

});



parcelRegister("2GHO7", function(module, exports) {

$parcel$export(module.exports, "mergeClinicalLibraryData", function () { return $58fc56bdf9a13d65$export$b9a2f7993287c44; });
const $58fc56bdf9a13d65$export$b9a2f7993287c44 = (acc, clinicalLibrary)=>{
    // Add clinical datasets
    const clinicalDatasets = [
        ...acc.clinicalDatasets,
        ...clinicalLibrary.clinicalDatasets.filter((dataset)=>!acc.clinicalDatasets.some((d)=>d.oid === dataset.oid))
    ];
    // Add clinical code lists
    const clinicalCodeLists = [
        ...acc.clinicalCodeLists,
        ...clinicalLibrary.clinicalCodeLists.filter((codeList)=>!acc.clinicalCodeLists.some((cl)=>cl.oid === codeList.oid))
    ];
    // Add clinical value lists
    const clinicalValueLists = [
        ...acc.clinicalValueLists,
        ...clinicalLibrary.clinicalValueLists.filter((valueList)=>!acc.clinicalValueLists.some((vl)=>vl.oid === valueList.oid))
    ];
    // Add clinical comments
    const clinicalComments = [
        ...acc.clinicalComments,
        ...clinicalLibrary.clinicalComments.filter((comment)=>!acc.clinicalComments.some((c)=>c.oid === comment.oid))
    ];
    // Add clinical methods
    const clinicalMethods = [
        ...acc.clinicalMethods,
        ...clinicalLibrary.clinicalMethods.filter((method)=>!acc.clinicalMethods.some((m)=>m.oid === method.oid))
    ];
    // Add clinical where clauses
    const clinicalWhereClauses = [
        ...acc.clinicalWhereClauses,
        ...clinicalLibrary.clinicalWhereClauses.filter((whereClause)=>!acc.clinicalWhereClauses.some((wc)=>wc.oid === whereClause.oid))
    ];
    return {
        clinicalDatasets: clinicalDatasets,
        clinicalCodeLists: clinicalCodeLists,
        clinicalValueLists: clinicalValueLists,
        clinicalComments: clinicalComments,
        clinicalMethods: clinicalMethods,
        clinicalWhereClauses: clinicalWhereClauses
    };
};

});



parcelRegister("hIQPm", function(module, exports) {

$parcel$export(module.exports, "hcr_addSingleReplacement", function () { return $f5e5af5c18a2df5a$export$34c8489a963a8cfe; });

var $3V2FF = parcelRequire("3V2FF");

var $lj90j = parcelRequire("lj90j");
const $f5e5af5c18a2df5a$export$34c8489a963a8cfe = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    if (state.hierarchy.singles.some((single)=>single.airid === action.single.airid)) return state;
    return (0, $lj90j.hcr_updateChangedFlag)((0, $3V2FF.hcr_checkSingles)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            singles: [
                ...state.hierarchy.singles,
                action.single
            ]
        }
    }), action);
};

});
parcelRegister("3V2FF", function(module, exports) {

$parcel$export(module.exports, "hcr_checkSingles", function () { return $3270227f9e0a3c5d$export$fa2091ec4f755f4c; });
const $3270227f9e0a3c5d$export$fa2091ec4f755f4c = (state)=>{
    if (state.hierarchy) {
        const warnings = new Set();
        state.hierarchy.singles.forEach((single)=>{
            if (single.oldText === "") warnings.add({
                airid: single.airid,
                warningText: "Missing text will be ignored"
            });
            if (state.hierarchy.singles.filter((o)=>o.oldText === single.oldText).length > 1) warnings.add({
                airid: single.airid,
                warningText: "Duplicates will cause unpredictable results"
            });
            if (single.oldText !== "" && single.newText.lines.map((l)=>l.textBlocks.map((b)=>b.text).join("")).join("\n").includes(single.oldText)) warnings.add({
                airid: single.airid,
                warningText: "New text cannot contain the original text"
            });
        });
        return {
            ...state,
            saveBlockers: {
                ...state.saveBlockers,
                singles: warnings
            }
        };
    }
    return state;
};

});


parcelRegister("snn47", function(module, exports) {

$parcel$export(module.exports, "hcr_clearHierarchy", function () { return $c86312b05b482e40$export$3fbad32e71c0faaa; });

var $ksBxS = parcelRequire("ksBxS");
const $c86312b05b482e40$export$3fbad32e71c0faaa = (state)=>{
    return {
        ...(0, $ksBxS.hierarchyInitialState),
        hierarchyNodes: state.hierarchyNodes
    };
};

});

parcelRegister("jhVng", function(module, exports) {

$parcel$export(module.exports, "hcr_loadClinicalLibrary", function () { return $db685a2e8c74a78b$export$f434806804f769fe; });

var $1vmng = parcelRequire("1vmng");

var $2GHO7 = parcelRequire("2GHO7");
const $db685a2e8c74a78b$export$f434806804f769fe = (state, action)=>{
    if (action.clinicalLibrary.length === 0) return {
        ...state,
        isClinicalLibraryLoading: false
    };
    const updatedHierarchyNodes = state.hierarchyNodes.map((hn)=>{
        const matchingLibrary = action.clinicalLibrary.find((cl)=>cl.hierarchyId === hn.id);
        if (matchingLibrary) return {
            ...hn,
            clinicalLibrary: matchingLibrary
        };
        return hn;
    });
    const matchingHierarchyLibrary = state.hierarchy ? action.clinicalLibrary.find((cl)=>cl.hierarchyId === state.hierarchy?.id) : undefined;
    const updatedHierarchy = state.hierarchy && matchingHierarchyLibrary ? {
        ...state.hierarchy,
        clinicalLibrary: matchingHierarchyLibrary
    } : state.hierarchy;
    if (!state.hierarchy) return {
        ...state,
        hierarchyNodes: updatedHierarchyNodes,
        isClinicalLibraryLoading: false
    };
    const currentHierarchy = state.hierarchy;
    const thisTlfType = (0, $1vmng.getHierarchyTlfType)(currentHierarchy.level);
    const relevantLibraries = action.clinicalLibrary.filter((cl)=>cl.hierarchyId !== currentHierarchy.id && (0, $1vmng.getHierarchyTlfType)(cl.hierarchyLevel) === thisTlfType && updatedHierarchyNodes.some((hn)=>hn.id === cl.hierarchyId));
    const clinicalTemplates = relevantLibraries.reduce((acc, clinicalLibrary)=>(0, $2GHO7.mergeClinicalLibraryData)(acc, clinicalLibrary), {
        clinicalDatasets: [
            ...state.parentTemplates.clinicalDatasets
        ],
        clinicalCodeLists: [
            ...state.parentTemplates.clinicalCodeLists
        ],
        clinicalValueLists: [
            ...state.parentTemplates.clinicalValueLists
        ],
        clinicalComments: [
            ...state.parentTemplates.clinicalComments
        ],
        clinicalMethods: [
            ...state.parentTemplates.clinicalMethods
        ],
        clinicalWhereClauses: [
            ...state.parentTemplates.clinicalWhereClauses
        ]
    });
    return {
        ...state,
        hierarchyNodes: updatedHierarchyNodes,
        hierarchy: updatedHierarchy,
        isClinicalLibraryLoading: false,
        parentTemplates: {
            ...clinicalTemplates,
            domainReplacements: [
                ...state.parentTemplates.domainReplacements
            ],
            lists: [
                ...state.parentTemplates.lists
            ],
            rowGroups: [
                ...state.parentTemplates.rowGroups
            ],
            singles: [
                ...state.parentTemplates.singles
            ],
            analysisSets: [
                ...state.parentTemplates.analysisSets
            ],
            analysisMethods: [
                ...state.parentTemplates.analysisMethods
            ],
            dataSubsets: [
                ...state.parentTemplates.dataSubsets
            ],
            groupingFactors: [
                ...state.parentTemplates.groupingFactors
            ]
        }
    };
};

});

parcelRegister("i5TEl", function(module, exports) {

$parcel$export(module.exports, "hcr_loadHierarchy", function () { return $fa72d32f4f8ef6cf$export$e2294dfdfcd7c99b; });

var $7Wd8C = parcelRequire("7Wd8C");

var $gSkQi = parcelRequire("gSkQi");

var $4kgVC = parcelRequire("4kgVC");

var $6sBTi = parcelRequire("6sBTi");
const $fa72d32f4f8ef6cf$export$e2294dfdfcd7c99b = (state, action)=>{
    const hierarchyNodes = [
        ...state.hierarchyNodes.filter((h)=>![
                ...action.hierarchyNodes.map((hn)=>hn.id),
                action.hierarchy.id
            ].includes(h.id)),
        action.hierarchy,
        ...action.hierarchyNodes.filter((h)=>h.level !== (0, $7Wd8C.eHierarchyLevel).TopLevel)
    ];
    const commentPanelStatus = state.commentPanelStatus.showComments ? {
        showComments: false,
        highlightCommentId: "",
        activeRelatedTo: "",
        commentFilter: "all"
    } : state.commentPanelStatus;
    return {
        ...state,
        changed: false,
        id: action.hierarchy.id,
        hierarchy: action.hierarchy,
        savedHierarchy: (0, $gSkQi.cloneDeep)(action.hierarchy),
        isNameChanged: false,
        prefix: (0, $4kgVC.getHierarchyPrefix)(action.hierarchy.level),
        hierarchyNodes: hierarchyNodes,
        parentTemplates: (0, $6sBTi.hcr_buildParentTemplates)(action.hierarchy, hierarchyNodes),
        accessRights: action.accessRights,
        tlfItemIndex: action.hierarchy.id === state.hierarchy?.id ? state.tlfItemIndex : null,
        isSubscribed: action.isSubscribed,
        commentPanelStatus: commentPanelStatus
    };
};

});
parcelRegister("4kgVC", function(module, exports) {

$parcel$export(module.exports, "getHierarchyPrefix", function () { return $785bd757ef18848e$export$6b93194f3da1639a; });

var $7Wd8C = parcelRequire("7Wd8C");
const $785bd757ef18848e$export$6b93194f3da1639a = (type)=>{
    switch(type){
        case (0, $7Wd8C.eHierarchyLevel).Report:
        case (0, $7Wd8C.eHierarchy).Report:
            return "R";
        case (0, $7Wd8C.eHierarchyLevel).Study:
        case (0, $7Wd8C.eHierarchy).StudyDirectory:
            return "S";
        case (0, $7Wd8C.eHierarchy).Directory:
        case (0, $7Wd8C.eHierarchy).TopLevel:
        case (0, $7Wd8C.eHierarchyLevel).TopLevel:
        case (0, $7Wd8C.eHierarchyLevel).Corporate:
        case (0, $7Wd8C.eHierarchyLevel).TA:
        case (0, $7Wd8C.eHierarchyLevel).Project:
        case undefined:
        default:
            return "H";
    }
};

});


parcelRegister("6a54O", function(module, exports) {

$parcel$export(module.exports, "hcr_patchHierarchyComments", function () { return $8ab202f1fca8608a$export$fa1003f096db3dbf; });

var $k5SrI = parcelRequire("k5SrI");

var $gSkQi = parcelRequire("gSkQi");

var $6hWPd = parcelRequire("6hWPd");

var $lj90j = parcelRequire("lj90j");
const $8ab202f1fca8608a$export$fa1003f096db3dbf = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const commentsPatch = action.patch;
    /* istanbul ignore else */ if (commentsPatch.length > 0) {
        const newComments = (0, $gSkQi.cloneDeep)(state.hierarchy.comments).sort((0, $k5SrI.sortCommentsAscending));
        (0, $6hWPd.applyPatch)(newComments, commentsPatch);
        return (0, $lj90j.hcr_updateChangedFlag)({
            ...state,
            hierarchy: {
                ...state.hierarchy,
                comments: newComments
            }
        }, action);
    }
    return state;
};

});
parcelRegister("k5SrI", function(module, exports) {

$parcel$export(module.exports, "sortComments", function () { return $b72d0e03ed2ef704$export$6d9937f48401e58a; });
$parcel$export(module.exports, "sortCommentsAscending", function () { return $b72d0e03ed2ef704$export$1d50cb8071ce747e; });
const $b72d0e03ed2ef704$export$6d9937f48401e58a = (a, b)=>{
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};
const $b72d0e03ed2ef704$export$1d50cb8071ce747e = (a, b)=>{
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
};

});


parcelRegister("dMLQD", function(module, exports) {

$parcel$export(module.exports, "hcr_removeDomainReplacement", function () { return $44dba12f7088f875$export$878863058d2e2b5; });

var $3KKXH = parcelRequire("3KKXH");

var $lj90j = parcelRequire("lj90j");
const $44dba12f7088f875$export$878863058d2e2b5 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.domainReplacements.findIndex((dr)=>dr.airid === action.domainReplacement.airid);
    if (ix > -1) return (0, $lj90j.hcr_updateChangedFlag)((0, $3KKXH.hcr_checkDRs)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            domainReplacements: state.hierarchy.domainReplacements.filter((dr)=>dr.airid !== action.domainReplacement.airid)
        }
    }), action);
    return state;
};

});

parcelRegister("mBTCv", function(module, exports) {

$parcel$export(module.exports, "hcr_removeHierarchyComment", function () { return $668659f95f6e17c0$export$8345555f51e6810a; });

var $lj90j = parcelRequire("lj90j");
const $668659f95f6e17c0$export$8345555f51e6810a = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $lj90j.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            comments: state.hierarchy.comments.filter((c)=>c.id !== action.commentId)
        }
    }, action);
};

});

parcelRegister("dU5i9", function(module, exports) {

$parcel$export(module.exports, "hcr_removeHierarchyNode", function () { return $07a32844dec1bd0b$export$e73995fd5cd4a52a; });
const $07a32844dec1bd0b$export$e73995fd5cd4a52a = (state, action)=>({
        ...state,
        hierarchyNodes: state.hierarchyNodes.filter((hn)=>hn.id !== action.hierarchyId)
    });

});

parcelRegister("9ijz0", function(module, exports) {

$parcel$export(module.exports, "hcr_removeSingleReplacement", function () { return $6e2e4493ce01ecbc$export$7b2a51d8d75587d4; });

var $3V2FF = parcelRequire("3V2FF");

var $lj90j = parcelRequire("lj90j");
const $6e2e4493ce01ecbc$export$7b2a51d8d75587d4 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.singles.findIndex((s)=>s.airid === action.single.airid);
    if (ix > -1) return (0, $lj90j.hcr_updateChangedFlag)((0, $3V2FF.hcr_checkSingles)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            singles: state.hierarchy.singles.filter((s)=>s.airid !== action.single.airid)
        }
    }), action);
    return state;
};

});

parcelRegister("fGSHE", function(module, exports) {

$parcel$export(module.exports, "hcr_saveHierarchy", function () { return $8679e6e170cbf75b$export$11ce44e85071ce5c; });
const $8679e6e170cbf75b$export$11ce44e85071ce5c = (state, action)=>({
        ...state,
        doSave: true,
        noRedirect: action.noRedirect
    });

});

parcelRegister("51kMy", function(module, exports) {

$parcel$export(module.exports, "hcr_saveHierarchyCompleted", function () { return $d2d4d865ddf3fdf7$export$e52ae9003a99ba3e; });

var $9Jgpw = parcelRequire("9Jgpw");

var $3KKXH = parcelRequire("3KKXH");

var $3V2FF = parcelRequire("3V2FF");

var $i5TEl = parcelRequire("i5TEl");
const $d2d4d865ddf3fdf7$export$e52ae9003a99ba3e = (state, action)=>{
    const filteredHierarchyNodes = [
        ...state.hierarchyNodes.filter((hn)=>hn.id !== action.hierarchy.id && hn.id !== action.oldHierarchyId).map((hn)=>{
            if (action.oldHierarchyId && hn.id === action.hierarchy.parentId) return {
                ...hn,
                children: [
                    ...hn.children.filter((cid)=>cid.id !== action.oldHierarchyId),
                    {
                        id: action.hierarchy.id,
                        hierarchyTag: hn.hierarchyTag,
                        level: hn.level,
                        name: action.hierarchy.name,
                        parentTag: hn.parentTag,
                        type: hn.type,
                        tocMajorVersion: action.hierarchy.tocMajorVersion,
                        tocMinorVersion: action.hierarchy.tocMinorVersion
                    }
                ]
            };
            return hn;
        }),
        action.hierarchy
    ];
    const loadLikeAction = {
        operation: (0, $9Jgpw.LOAD_HIERARCHY),
        hierarchy: action.hierarchy,
        hierarchyNodes: [],
        accessRights: state.accessRights,
        isSubscribed: state.isSubscribed
    };
    const loadedState = (0, $i5TEl.hcr_loadHierarchy)({
        ...state,
        hierarchyNodes: filteredHierarchyNodes
    }, loadLikeAction);
    const checkedSingles = (0, $3V2FF.hcr_checkSingles)((0, $3KKXH.hcr_checkDRs)(loadedState));
    return {
        ...checkedSingles,
        isNameChanged: false,
        doSave: false,
        doTocSave: false,
        hierarchyNodes: filteredHierarchyNodes,
        noRedirect: undefined
    };
};

});

parcelRegister("4oUWJ", function(module, exports) {

$parcel$export(module.exports, "hcr_saveHierarchyFailed", function () { return $4f12761c76a2081a$export$9d61445d901f8233; });
const $4f12761c76a2081a$export$9d61445d901f8233 = (state)=>({
        ...state,
        doSave: false,
        doTocSave: false,
        saveTocDescription: undefined
    });

});

parcelRegister("5YqWX", function(module, exports) {

$parcel$export(module.exports, "hcr_saveTocMajorVersion", function () { return $70e49f1f5a76eac2$export$5f26c6cd46f36614; });
const $70e49f1f5a76eac2$export$5f26c6cd46f36614 = (state, action)=>({
        ...state,
        doTocSave: true,
        saveTocDescription: action.saveTocDescription,
        hierarchyNodes: state.hierarchyNodes.filter((hn)=>hn.id !== action.oldHierarchyId)
    });

});

parcelRegister("9nYQ2", function(module, exports) {

$parcel$export(module.exports, "hcr_setAccessRights", function () { return $866e1e85ade197b7$export$665db080416fe367; });
const $866e1e85ade197b7$export$665db080416fe367 = (state, action)=>({
        ...state,
        accessRights: action.accessRights,
        doGetAccessRights: false
    });

});

parcelRegister("5Ieiq", function(module, exports) {

$parcel$export(module.exports, "hcr_setClinicalLibraryLoading", function () { return $1d845791d204a9ab$export$160ed4ec6785ce84; });
const $1d845791d204a9ab$export$160ed4ec6785ce84 = (state, action)=>({
        ...state,
        isClinicalLibraryLoading: action.isClinicalLibraryLoading
    });

});

parcelRegister("3RrHT", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchyCommentPanel", function () { return $8ab03b10a2c8e0e9$export$9b7ea640d911e0e1; });
const $8ab03b10a2c8e0e9$export$9b7ea640d911e0e1 = (state, action)=>({
        ...state,
        commentPanelStatus: {
            ...state.commentPanelStatus,
            ...action.commentPanelStatus
        }
    });

});

parcelRegister("6oA8K", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchyId", function () { return $52182fdb1c168451$export$b92f04a6e50f033e; });
const $52182fdb1c168451$export$b92f04a6e50f033e = (state, action)=>({
        ...state,
        id: action.hierarchyId
    });

});

parcelRegister("9rt0F", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchyNameSaveBlocker", function () { return $5bc380ae3209b0ad$export$eaef114055aba0b4; });
const $5bc380ae3209b0ad$export$eaef114055aba0b4 = (state, action)=>({
        ...state,
        saveBlockers: {
            ...state.saveBlockers,
            hierarchyName: action.warningText ?? undefined
        }
    });

});

parcelRegister("7upe4", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchySaveRequestStatus", function () { return $6d8561a1e1b4c8d4$export$450b53273f39217d; });
const $6d8561a1e1b4c8d4$export$450b53273f39217d = (state, action)=>({
        ...state,
        saveRequestStatus: action.saveRequestStatus
    });

});

parcelRegister("jWkMB", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchySaveTocRequestStatus", function () { return $d8a392d5c86b2314$export$9c5154ece3fcf2c6; });
const $d8a392d5c86b2314$export$9c5154ece3fcf2c6 = (state, action)=>({
        ...state,
        saveTocRequestStatus: action.saveTocRequestStatus
    });

});

parcelRegister("d39cI", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchySubscriptionStatus", function () { return $9b02af69f71bb373$export$401c19560aaf0b70; });
const $9b02af69f71bb373$export$401c19560aaf0b70 = (state, action)=>({
        ...state,
        isSubscribed: action.isSubscribed
    });

});

parcelRegister("1T8QL", function(module, exports) {

$parcel$export(module.exports, "hcr_updateDomainReplacement", function () { return $bf1d65ee32634c00$export$9c8b9b5d0dd030a1; });

var $lj90j = parcelRequire("lj90j");
const $bf1d65ee32634c00$export$9c8b9b5d0dd030a1 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.domainReplacements.findIndex((dr)=>dr.airid === action.domainReplacement.airid);
    if (ix > -1) return (0, $lj90j.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            domainReplacements: state.hierarchy.domainReplacements.map((dr)=>dr.airid === action.domainReplacement.airid ? action.domainReplacement : dr)
        }
    }, action);
    return state;
};

});

parcelRegister("atbJz", function(module, exports) {

$parcel$export(module.exports, "hcr_updateHierarchy", function () { return $ad02876aed7ecb0f$export$bc351d584c8a03db; });

var $gSkQi = parcelRequire("gSkQi");

var $3KKXH = parcelRequire("3KKXH");

var $3V2FF = parcelRequire("3V2FF");

var $lj90j = parcelRequire("lj90j");
const $ad02876aed7ecb0f$export$bc351d584c8a03db = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const newState = {
        ...state,
        hierarchy: {
            ...state.hierarchy,
            ...action.hierarchy
        },
        isNameChanged: typeof action.isNameChanged === "boolean" ? action.isNameChanged : state.isNameChanged
    };
    if (action.savedHierarchy) newState.savedHierarchy = (0, $gSkQi.cloneDeep)(action.savedHierarchy);
    return (0, $lj90j.hcr_updateChangedFlag)((0, $3V2FF.hcr_checkSingles)((0, $3KKXH.hcr_checkDRs)(newState)), action);
};

});

parcelRegister("iNVjQ", function(module, exports) {

$parcel$export(module.exports, "hcr_updateHierarchyComment", function () { return $e4633da84a3945f1$export$2aff6d62e3e3128c; });

var $lj90j = parcelRequire("lj90j");
const $e4633da84a3945f1$export$2aff6d62e3e3128c = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $lj90j.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            comments: [
                ...state.hierarchy.comments.filter((c)=>c.id !== action.comment.id),
                action.comment
            ]
        }
    }, action);
};

});

parcelRegister("2w1A4", function(module, exports) {

$parcel$export(module.exports, "hcr_updateSingleReplacements", function () { return $4dc3e2b87944476c$export$7a9546419291dc25; });

var $lj90j = parcelRequire("lj90j");
const $4dc3e2b87944476c$export$7a9546419291dc25 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.singles.findIndex((s)=>s.airid === action.single.airid);
    if (ix > -1) return (0, $lj90j.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            singles: state.hierarchy.singles.map((s)=>s.airid === action.single.airid ? action.single : s)
        }
    }, action);
    return state;
};

});

parcelRegister("6F3sl", function(module, exports) {

$parcel$export(module.exports, "hcr_updateTlfItemIndex", function () { return $0bc71f67dc24d2fc$export$95eac10549f91727; });

var $lj90j = parcelRequire("lj90j");
const $0bc71f67dc24d2fc$export$95eac10549f91727 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $lj90j.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            tocMinorVersion: action.tocMinorVersion
        },
        tlfItemIndex: action.tlfItemIndex
    }, action);
};

});



parcelRegister("dDC3L", function(module, exports) {

$parcel$export(module.exports, "ADD_RECEIVED_MESSAGE", function () { return $985217d0c0541dd8$export$3c62dc6ab23ad792; });
$parcel$export(module.exports, "APPLY_ARS_UPDATES", function () { return $985217d0c0541dd8$export$3447924a14bbcbf3; });
$parcel$export(module.exports, "DISCARD_ARS_UPDATES", function () { return $985217d0c0541dd8$export$36722055b950f671; });
$parcel$export(module.exports, "CLEAR_TLF", function () { return $985217d0c0541dd8$export$3af482df2ad31151; });
$parcel$export(module.exports, "CLOSE_MODAL_WINDOW", function () { return $985217d0c0541dd8$export$8bebc2c59bb445dd; });
$parcel$export(module.exports, "LOAD_TLF", function () { return $985217d0c0541dd8$export$92293c49dfbf16c8; });
$parcel$export(module.exports, "PATCH_TLF_COMMENTS", function () { return $985217d0c0541dd8$export$fcd722cd200d15dd; });
$parcel$export(module.exports, "PROCESS_SIGNALR_NOTIFICATION", function () { return $985217d0c0541dd8$export$91599a31b0c51ba5; });
$parcel$export(module.exports, "REDO_TLF_CHANGE", function () { return $985217d0c0541dd8$export$d1dc41bdf364a566; });
$parcel$export(module.exports, "REMOVE_TLF_COMMENT", function () { return $985217d0c0541dd8$export$566a8457e5e3d6ec; });
$parcel$export(module.exports, "SET_DELAYED_HIERARCHY_UPDATES", function () { return $985217d0c0541dd8$export$f90cfd80956cd0ad; });
$parcel$export(module.exports, "SET_EDITOR_BLOCKS_SEARCH_PANEL", function () { return $985217d0c0541dd8$export$ef29ffe579696bff; });
$parcel$export(module.exports, "SET_TLF_COMMENT_PANEL", function () { return $985217d0c0541dd8$export$4b8e3a51d569628c; });
$parcel$export(module.exports, "SET_TLF_READ_ONLY", function () { return $985217d0c0541dd8$export$23531c5f8d8474af; });
$parcel$export(module.exports, "SET_TLF_SUBSCRIPTION_STATUS", function () { return $985217d0c0541dd8$export$ebc224f02d8ba54; });
$parcel$export(module.exports, "SET_TLF_REQUEST_STATUS", function () { return $985217d0c0541dd8$export$eaac9cf48bc1ae34; });
$parcel$export(module.exports, "SET_VIEW_MODE", function () { return $985217d0c0541dd8$export$3e7ee65482c898f7; });
$parcel$export(module.exports, "SHOW_MODAL_WINDOW", function () { return $985217d0c0541dd8$export$c504062535f04932; });
$parcel$export(module.exports, "TOGGLE_TRAFFIC_LIGHTS", function () { return $985217d0c0541dd8$export$6d2c6383eac39e42; });
$parcel$export(module.exports, "UNDO_TLF_CHANGE", function () { return $985217d0c0541dd8$export$c3a2f83f794c3cc1; });
$parcel$export(module.exports, "UPDATE_TLF", function () { return $985217d0c0541dd8$export$6f0385e6121525d0; });
$parcel$export(module.exports, "UPDATE_TLF_COMMENT", function () { return $985217d0c0541dd8$export$3906df64ba9b193b; });
const $985217d0c0541dd8$export$3c62dc6ab23ad792 = "ADD_RECEIVED_MESSAGE";
const $985217d0c0541dd8$export$3447924a14bbcbf3 = "APPLY_ARS_UPDATES";
const $985217d0c0541dd8$export$36722055b950f671 = "DISCARD_ARS_UPDATES";
const $985217d0c0541dd8$export$3af482df2ad31151 = "CLEAR_TLF";
const $985217d0c0541dd8$export$8bebc2c59bb445dd = "CLOSE_MODAL_WINDOW";
const $985217d0c0541dd8$export$92293c49dfbf16c8 = "LOAD_TLF";
const $985217d0c0541dd8$export$fcd722cd200d15dd = "PATCH_TLF_COMMENTS";
const $985217d0c0541dd8$export$91599a31b0c51ba5 = "PROCESS_SIGNALR_NOTIFICATION";
const $985217d0c0541dd8$export$d1dc41bdf364a566 = "REDO_TLF_CHANGE";
const $985217d0c0541dd8$export$566a8457e5e3d6ec = "REMOVE_TLF_COMMENT";
const $985217d0c0541dd8$export$f90cfd80956cd0ad = "SET_DELAYED_HIERARCHY_UPDATES";
const $985217d0c0541dd8$export$ef29ffe579696bff = "SET_EDITOR_BLOCKS_SEARCH_PANEL";
const $985217d0c0541dd8$export$4b8e3a51d569628c = "SET_TLF_COMMENT_PANEL";
const $985217d0c0541dd8$export$23531c5f8d8474af = "SET_TLF_READ_ONLY";
const $985217d0c0541dd8$export$ebc224f02d8ba54 = "SET_TLF_SUBSCRIPTION_STATUS";
const $985217d0c0541dd8$export$eaac9cf48bc1ae34 = "SET_TLF_REQUEST_STATUS";
const $985217d0c0541dd8$export$3e7ee65482c898f7 = "SET_VIEW_MODE";
const $985217d0c0541dd8$export$c504062535f04932 = "SHOW_MODAL_WINDOW";
const $985217d0c0541dd8$export$6d2c6383eac39e42 = "TOGGLE_TRAFFIC_LIGHTS";
const $985217d0c0541dd8$export$c3a2f83f794c3cc1 = "UNDO_TLF_CHANGE";
const $985217d0c0541dd8$export$6f0385e6121525d0 = "UPDATE_TLF";
const $985217d0c0541dd8$export$3906df64ba9b193b = "UPDATE_TLF_COMMENT";

});

parcelRegister("b0Sri", function(module, exports) {

$parcel$export(module.exports, "tlfContextReducer", function () { return $ddbeb426ccbb452b$export$56aa56b5d8cbeba3; });

var $dDC3L = parcelRequire("dDC3L");
parcelRequire("lhDlG");
var $3igPC = parcelRequire("3igPC");
var $kKKE2 = parcelRequire("kKKE2");
var $bqogq = parcelRequire("bqogq");
var $a4QO6 = parcelRequire("a4QO6");
var $jYWY8 = parcelRequire("jYWY8");
var $2ySie = parcelRequire("2ySie");
var $HgvJb = parcelRequire("HgvJb");
var $5pX8I = parcelRequire("5pX8I");
var $2GxHO = parcelRequire("2GxHO");
var $hbnrn = parcelRequire("hbnrn");
var $l2qJU = parcelRequire("l2qJU");
var $e7jVG = parcelRequire("e7jVG");
var $ijcuO = parcelRequire("ijcuO");
var $d0Jxg = parcelRequire("d0Jxg");
var $2PKe7 = parcelRequire("2PKe7");
var $9yfR0 = parcelRequire("9yfR0");
var $eE3LV = parcelRequire("eE3LV");
var $b6Zww = parcelRequire("b6Zww");
var $apwQ7 = parcelRequire("apwQ7");
var $6IgnR = parcelRequire("6IgnR");
var $lbpQw = parcelRequire("lbpQw");
var $f5VZi = parcelRequire("f5VZi");
const $ddbeb426ccbb452b$export$56aa56b5d8cbeba3 = (state, action)=>{
    switch(action.operation){
        case 0, $dDC3L.ADD_RECEIVED_MESSAGE:
            return (0, $3igPC.tlf_addReceivedMessage)(state, action);
        case 0, $dDC3L.APPLY_ARS_UPDATES:
            return (0, $kKKE2.tlf_applyArsUpdates)(state);
        case 0, $dDC3L.CLEAR_TLF:
            return (0, $bqogq.tlf_clearTlf)();
        case 0, $dDC3L.CLOSE_MODAL_WINDOW:
            return (0, $a4QO6.tlf_closeModalWindow)(state);
        case 0, $dDC3L.DISCARD_ARS_UPDATES:
            return (0, $jYWY8.tlf_discardArsUpdates)(state);
        case 0, $dDC3L.LOAD_TLF:
            return (0, $2ySie.tlf_loadTlf)(state, action);
        case 0, $dDC3L.PATCH_TLF_COMMENTS:
            return (0, $HgvJb.tlf_patchTlfComments)(state, action);
        case 0, $dDC3L.PROCESS_SIGNALR_NOTIFICATION:
            return (0, $5pX8I.tlf_processSignalrNotification)(state, action);
        case 0, $dDC3L.REDO_TLF_CHANGE:
            return (0, $2GxHO.tlf_redoTlfChange)(state, action);
        case 0, $dDC3L.REMOVE_TLF_COMMENT:
            return (0, $hbnrn.tlf_removeTlfComment)(state, action);
        case 0, $dDC3L.SET_DELAYED_HIERARCHY_UPDATES:
            return (0, $l2qJU.tlf_setDelayedHierarchyUpdates)(state, action);
        case 0, $dDC3L.SET_EDITOR_BLOCKS_SEARCH_PANEL:
            return (0, $e7jVG.tlf_setEditorBlocksSearchPanel)(state, action);
        case 0, $dDC3L.SET_TLF_COMMENT_PANEL:
            return (0, $ijcuO.tlf_setTlfCommentPanel)(state, action);
        case 0, $dDC3L.SET_TLF_READ_ONLY:
            return (0, $d0Jxg.tlf_setTlfReadOnly)(state, action);
        case 0, $dDC3L.SET_TLF_REQUEST_STATUS:
            return (0, $2PKe7.tlf_setTlfRequestStatus)(state, action);
        case 0, $dDC3L.SET_TLF_SUBSCRIPTION_STATUS:
            return (0, $9yfR0.tlf_setTlfSubscriptionStatus)(state, action);
        case 0, $dDC3L.SET_VIEW_MODE:
            return (0, $eE3LV.tlf_setViewMode)(state, action);
        case 0, $dDC3L.SHOW_MODAL_WINDOW:
            return (0, $b6Zww.tlf_showModalWindow)(state, action);
        case 0, $dDC3L.TOGGLE_TRAFFIC_LIGHTS:
            return (0, $apwQ7.tlf_toggleTrafficLights)(state, action);
        case 0, $dDC3L.UNDO_TLF_CHANGE:
            return (0, $6IgnR.tlf_undoTlfChange)(state, action);
        case 0, $dDC3L.UPDATE_TLF:
            return (0, $lbpQw.tlf_updateTlf)(state, action);
        case 0, $dDC3L.UPDATE_TLF_COMMENT:
            return (0, $f5VZi.tlf_updateTlfComment)(state, action);
        default:
            return state;
    }
};

});
parcelRegister("lhDlG", function(module, exports) {
$parcel$export(module.exports, "tlf_addReceivedMessage", function () { return (parcelRequire("3igPC")).tlf_addReceivedMessage; });
$parcel$export(module.exports, "tlf_applyArsUpdates", function () { return (parcelRequire("kKKE2")).tlf_applyArsUpdates; });
$parcel$export(module.exports, "tlf_clearTlf", function () { return (parcelRequire("bqogq")).tlf_clearTlf; });
$parcel$export(module.exports, "tlf_closeModalWindow", function () { return (parcelRequire("a4QO6")).tlf_closeModalWindow; });
$parcel$export(module.exports, "tlf_discardArsUpdates", function () { return (parcelRequire("jYWY8")).tlf_discardArsUpdates; });
$parcel$export(module.exports, "tlf_loadTlf", function () { return (parcelRequire("2ySie")).tlf_loadTlf; });
$parcel$export(module.exports, "tlf_patchTlfComments", function () { return (parcelRequire("HgvJb")).tlf_patchTlfComments; });
$parcel$export(module.exports, "tlf_processSignalrNotification", function () { return (parcelRequire("5pX8I")).tlf_processSignalrNotification; });
$parcel$export(module.exports, "tlf_redoTlfChange", function () { return (parcelRequire("2GxHO")).tlf_redoTlfChange; });
$parcel$export(module.exports, "tlf_removeTlfComment", function () { return (parcelRequire("hbnrn")).tlf_removeTlfComment; });
$parcel$export(module.exports, "tlf_setDelayedHierarchyUpdates", function () { return (parcelRequire("l2qJU")).tlf_setDelayedHierarchyUpdates; });
$parcel$export(module.exports, "tlf_setEditorBlocksSearchPanel", function () { return (parcelRequire("e7jVG")).tlf_setEditorBlocksSearchPanel; });
$parcel$export(module.exports, "tlf_setTlfCommentPanel", function () { return (parcelRequire("ijcuO")).tlf_setTlfCommentPanel; });
$parcel$export(module.exports, "tlf_setTlfReadOnly", function () { return (parcelRequire("d0Jxg")).tlf_setTlfReadOnly; });
$parcel$export(module.exports, "tlf_setTlfRequestStatus", function () { return (parcelRequire("2PKe7")).tlf_setTlfRequestStatus; });
$parcel$export(module.exports, "tlf_setTlfSubscriptionStatus", function () { return (parcelRequire("9yfR0")).tlf_setTlfSubscriptionStatus; });
$parcel$export(module.exports, "tlf_setViewMode", function () { return (parcelRequire("eE3LV")).tlf_setViewMode; });
$parcel$export(module.exports, "tlf_showModalWindow", function () { return (parcelRequire("b6Zww")).tlf_showModalWindow; });
$parcel$export(module.exports, "tlf_toggleTrafficLights", function () { return (parcelRequire("apwQ7")).tlf_toggleTrafficLights; });
$parcel$export(module.exports, "tlf_undoTlfChange", function () { return (parcelRequire("6IgnR")).tlf_undoTlfChange; });
$parcel$export(module.exports, "tlf_updateTlf", function () { return (parcelRequire("lbpQw")).tlf_updateTlf; });
$parcel$export(module.exports, "tlf_updateTlfComment", function () { return (parcelRequire("f5VZi")).tlf_updateTlfComment; });
parcelRequire("3igPC");
parcelRequire("kKKE2");
parcelRequire("bqogq");
parcelRequire("a4QO6");
parcelRequire("jYWY8");
parcelRequire("2ySie");
parcelRequire("HgvJb");
parcelRequire("5pX8I");
parcelRequire("2GxHO");
parcelRequire("hbnrn");
parcelRequire("l2qJU");
parcelRequire("e7jVG");
parcelRequire("ijcuO");
parcelRequire("d0Jxg");
parcelRequire("2PKe7");
parcelRequire("9yfR0");
parcelRequire("eE3LV");
parcelRequire("b6Zww");
parcelRequire("apwQ7");
parcelRequire("6IgnR");
parcelRequire("lbpQw");
parcelRequire("f5VZi");

});
parcelRegister("3igPC", function(module, exports) {

$parcel$export(module.exports, "tlf_addReceivedMessage", function () { return $c227d56995444cb2$export$172e2a06c5a427eb; });
const $c227d56995444cb2$export$172e2a06c5a427eb = (state, action)=>{
    const newState = {
        ...state
    };
    if (state.receivedMessages.some((message)=>message.messageId === action.receivedMessage.messageId)) return newState;
    newState.receivedMessages = [
        ...state.receivedMessages,
        {
            messageId: action.receivedMessage.messageId,
            updatedId: action.receivedMessage.groupName,
            updateTS: new Date(action.receivedMessage.timeStamp)
        }
    ];
    return newState;
};

});

parcelRegister("kKKE2", function(module, exports) {

$parcel$export(module.exports, "tlf_applyArsUpdates", function () { return $5a3fa992f85d55c9$export$c9d7a76cf80e13a2; });
const $5a3fa992f85d55c9$export$c9d7a76cf80e13a2 = (state)=>{
    const newState = {
        ...state
    };
    newState.applyDelayedHierarchyUpdatesTrigger = state.applyDelayedHierarchyUpdatesTrigger + 1;
    newState.delayedHierarchyUpdates = false;
    return newState;
};

});

parcelRegister("bqogq", function(module, exports) {

$parcel$export(module.exports, "tlf_clearTlf", function () { return $698de277a6a28028$export$f8e802e005da8a74; });

var $bQJeo = parcelRequire("bQJeo");
const $698de277a6a28028$export$f8e802e005da8a74 = ()=>({
        ...(0, $bQJeo.tlfInitialState)
    });

});

parcelRegister("a4QO6", function(module, exports) {

$parcel$export(module.exports, "tlf_closeModalWindow", function () { return $fbd1bb8be529fbd0$export$148267ba3cea07bf; });
const $fbd1bb8be529fbd0$export$148267ba3cea07bf = (state)=>{
    const newState = {
        ...state
    };
    newState.showModalWindow = "";
    newState.requestStatus = {
        requesting: false,
        error: false
    };
    return newState;
};

});

parcelRegister("jYWY8", function(module, exports) {

$parcel$export(module.exports, "tlf_discardArsUpdates", function () { return $97f9cbf100524120$export$760846fa229f3ac8; });
const $97f9cbf100524120$export$760846fa229f3ac8 = (state)=>{
    const newState = {
        ...state
    };
    newState.discardDelayedHierarchyUpdatesTrigger = state.discardDelayedHierarchyUpdatesTrigger + 1;
    newState.delayedHierarchyUpdates = false;
    return newState;
};

});

parcelRegister("2ySie", function(module, exports) {

$parcel$export(module.exports, "tlf_loadTlf", function () { return $fa08048daa74246c$export$e1cc49f6061b463e; });

var $gSkQi = parcelRequire("gSkQi");

var $a3tUH = parcelRequire("a3tUH");
const $fa08048daa74246c$export$e1cc49f6061b463e = (state, action)=>{
    const newState = {
        ...state
    };
    newState.ixTlfDataVersion = 0;
    newState.ixSaveVersion = 0;
    newState.tlfData = action.tlfData;
    newState.tlfDataVersions = [
        (0, $gSkQi.cloneDeep)(action.tlfData)
    ];
    newState.showModalWindow = "";
    newState.isSubscribed = action.isSubscribed;
    newState.readOnly = action.readOnly;
    newState.isTlfNew = action.isTlfNew;
    (0, $a3tUH.checkChanged)(newState);
    return newState;
};

});
parcelRegister("a3tUH", function(module, exports) {

$parcel$export(module.exports, "checkChanged", function () { return $136752492a081abe$export$b7b8859ed511125; });

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $gMkmM = parcelRequire("gMkmM");

var $7Wd8C = parcelRequire("7Wd8C");

var $iQGjt = parcelRequire("iQGjt");
const $136752492a081abe$export$b7b8859ed511125 = (state)=>{
    // Changed memo
    const current = (0, $iQGjt.omitDeep)(state.tlfDataVersions[state.ixTlfDataVersion], [
        "relationships",
        "isLocked",
        "contentProps",
        "coreTrafficLight"
    ]);
    delete current?.comments;
    const saved = state.ixSaveVersion >= 0 ? (0, $iQGjt.omitDeep)(state.tlfDataVersions[state.ixSaveVersion], [
        "relationships",
        "isLocked",
        "contentProps",
        "coreTrafficLight"
    ]) : undefined;
    delete saved?.comments;
    const changed = (0, $1iDss.getObjectDiff)(current, saved);
    // Get changed (unsaved) flag
    state.changed = state.ixTlfDataVersion !== state.ixSaveVersion && changed !== undefined;
    // Check if traffic lights should be hidden initially
    if (state.tlfData?.primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report && state.tlfData?.coreTrafficLightSwitch === "DoNotCalculate" && ("tocOriginTrafficLight" in state.tlfData ? state.tlfData.tocOriginTrafficLight === "FromScratch" || state.tlfData.tocOriginTrafficLight === "FromBasicLayout" || state.tlfData.type === (0, $7Wd8C.eTlfItemType).figure || state.tlfData.type === (0, $7Wd8C.eTlfItemType).v1figure : true)) state.showTrafficLights = false;
    // Check if view mode is ok
    if (state.tlfViewMode.showOnlyForTlfTypes && state.tlfData?.type && !state.tlfViewMode.showOnlyForTlfTypes.has(state.tlfData.type)) state.tlfViewMode = (0, $gMkmM.TLF_VIEW_MODES)[0];
};

});


parcelRegister("HgvJb", function(module, exports) {

$parcel$export(module.exports, "tlf_patchTlfComments", function () { return $06495f101afdc47f$export$57df786e368e6641; });

var $k5SrI = parcelRequire("k5SrI");

var $gSkQi = parcelRequire("gSkQi");

var $6hWPd = parcelRequire("6hWPd");

var $a3tUH = parcelRequire("a3tUH");

var $dDC3L = parcelRequire("dDC3L");
const $06495f101afdc47f$export$57df786e368e6641 = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $dDC3L.PATCH_TLF_COMMENTS)}:${action.calledFrom}: TLF data not set`);
    const commentsPatch = action.patch;
    /* istanbul ignore else -- empty patches intentionally leave the current comment state unchanged. */ if (commentsPatch && commentsPatch.length > 0) {
        const newComments = (0, $gSkQi.cloneDeep)(newState.tlfData.comments).sort((0, $k5SrI.sortCommentsAscending));
        (0, $6hWPd.applyPatch)(newComments, commentsPatch);
        newState.tlfData = {
            ...newState.tlfData,
            comments: newComments
        };
        newState.forcePushToParent = true;
        (0, $a3tUH.checkChanged)(newState);
    }
    return newState;
};

});

parcelRegister("5pX8I", function(module, exports) {

$parcel$export(module.exports, "tlf_processSignalrNotification", function () { return $868a71905e332a7f$export$103f2d6f36dcaaa9; });

var $gSkQi = parcelRequire("gSkQi");

var $6hWPd = parcelRequire("6hWPd");

var $a3tUH = parcelRequire("a3tUH");

var $dDC3L = parcelRequire("dDC3L");
const $868a71905e332a7f$export$103f2d6f36dcaaa9 = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $dDC3L.PROCESS_SIGNALR_NOTIFICATION)}:${action.calledFrom}: TLF data not set`);
    newState.tlfData = (0, $gSkQi.cloneDeep)(newState.tlfData);
    (0, $6hWPd.applyPatch)(newState.tlfData, action.patch);
    newState.ixSaveVersion = state.ixSaveVersion === state.ixTlfDataVersion ? state.tlfDataVersions.length : -1;
    newState.ixTlfDataVersion = state.tlfDataVersions.length;
    newState.tlfDataVersions = [
        ...state.tlfDataVersions,
        (0, $gSkQi.cloneDeep)(newState.tlfData)
    ];
    newState.showModalWindow = "";
    newState.forcePushToParent = true;
    (0, $a3tUH.checkChanged)(newState);
    return newState;
};

});

parcelRegister("2GxHO", function(module, exports) {

$parcel$export(module.exports, "tlf_redoTlfChange", function () { return $5c18c94c32e96252$export$9399082aeafc5cde; });

var $gSkQi = parcelRequire("gSkQi");

var $a3tUH = parcelRequire("a3tUH");
const $5c18c94c32e96252$export$9399082aeafc5cde = (state, action)=>{
    const newState = {
        ...state
    };
    const newIx = Math.min(state.tlfDataVersions.length - 1, state.ixTlfDataVersion + (action.steps ?? 1));
    if (newIx !== state.ixTlfDataVersion) {
        newState.ixTlfDataVersion = newIx;
        newState.tlfData = (0, $gSkQi.cloneDeep)(state.tlfDataVersions[newIx]);
        (0, $a3tUH.checkChanged)(newState);
        newState.forcePushToParent = true;
    }
    return newState;
};

});

parcelRegister("hbnrn", function(module, exports) {

$parcel$export(module.exports, "tlf_removeTlfComment", function () { return $32549ad423c23c86$export$6ecd8cae5022f959; });

var $a3tUH = parcelRequire("a3tUH");

var $dDC3L = parcelRequire("dDC3L");
const $32549ad423c23c86$export$6ecd8cae5022f959 = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $dDC3L.REMOVE_TLF_COMMENT)}: TLF data not set`);
    newState.tlfData = {
        ...newState.tlfData,
        comments: newState.tlfData.comments.filter((comment)=>comment.id !== action.commentId)
    };
    newState.forcePushToParent = true;
    (0, $a3tUH.checkChanged)(newState);
    return newState;
};

});

parcelRegister("l2qJU", function(module, exports) {

$parcel$export(module.exports, "tlf_setDelayedHierarchyUpdates", function () { return $04ec80c03a49db65$export$c8b807f53f8279ad; });
const $04ec80c03a49db65$export$c8b807f53f8279ad = (state, action)=>({
        ...state,
        delayedHierarchyUpdates: action.delayedHierarchyUpdates
    });

});

parcelRegister("e7jVG", function(module, exports) {

$parcel$export(module.exports, "tlf_setEditorBlocksSearchPanel", function () { return $93514dd478328ed7$export$1576c29562e0a760; });
const $93514dd478328ed7$export$1576c29562e0a760 = (state, action)=>({
        ...state,
        editorBlocksSearchPanelStatus: action.editorBlocksSearchPanelStatus
    });

});

parcelRegister("ijcuO", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfCommentPanel", function () { return $ee6e2453f2ddc0cb$export$1b59748e23a96a7b; });
const $ee6e2453f2ddc0cb$export$1b59748e23a96a7b = (state, action)=>({
        ...state,
        commentPanelStatus: action.commentPanelStatus
    });

});

parcelRegister("d0Jxg", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfReadOnly", function () { return $b2a089e58d9a377d$export$9087dbcea44de9d6; });
const $b2a089e58d9a377d$export$9087dbcea44de9d6 = (state, action)=>({
        ...state,
        readOnly: action.readOnly
    });

});

parcelRegister("2PKe7", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfRequestStatus", function () { return $063ac861257f8c3e$export$860a79930037e837; });
const $063ac861257f8c3e$export$860a79930037e837 = (state, action)=>({
        ...state,
        requestStatus: action.requestStatus
    });

});

parcelRegister("9yfR0", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfSubscriptionStatus", function () { return $852aaf2d170d53f8$export$f3264ae9cebda665; });
const $852aaf2d170d53f8$export$f3264ae9cebda665 = (state, action)=>({
        ...state,
        isSubscribed: action.isSubscribed
    });

});

parcelRegister("eE3LV", function(module, exports) {

$parcel$export(module.exports, "tlf_setViewMode", function () { return $7dc18431b08dab60$export$53ea11b202e6a10d; });
const $7dc18431b08dab60$export$53ea11b202e6a10d = (state, action)=>({
        ...state,
        tlfViewMode: action.tlfViewMode
    });

});

parcelRegister("b6Zww", function(module, exports) {

$parcel$export(module.exports, "tlf_showModalWindow", function () { return $cabc01e20ec969e3$export$54c52b9fc6ae4c60; });
const $cabc01e20ec969e3$export$54c52b9fc6ae4c60 = (state, action)=>({
        ...state,
        showModalWindow: action.modalWindow
    });

});

parcelRegister("apwQ7", function(module, exports) {

$parcel$export(module.exports, "tlf_toggleTrafficLights", function () { return $3a6551a5a6323504$export$e5aafac61afa59f9; });
const $3a6551a5a6323504$export$e5aafac61afa59f9 = (state, action)=>({
        ...state,
        showTrafficLights: action.showTrafficLights
    });

});

parcelRegister("6IgnR", function(module, exports) {

$parcel$export(module.exports, "tlf_undoTlfChange", function () { return $632ee420665bf91c$export$75cd277b342e577e; });

var $gSkQi = parcelRequire("gSkQi");

var $a3tUH = parcelRequire("a3tUH");
const $632ee420665bf91c$export$75cd277b342e577e = (state, action)=>{
    const newState = {
        ...state
    };
    const newIx = Math.max(0, state.ixTlfDataVersion - (action.steps ?? 1));
    if (newIx !== state.ixTlfDataVersion) {
        newState.ixTlfDataVersion = newIx;
        newState.tlfData = (0, $gSkQi.cloneDeep)(state.tlfDataVersions[newIx]);
        (0, $a3tUH.checkChanged)(newState);
        newState.forcePushToParent = true;
    }
    return newState;
};

});

parcelRegister("lbpQw", function(module, exports) {

$parcel$export(module.exports, "tlf_updateTlf", function () { return $273ba76bd00d7587$export$95cad242a2a55eb6; });

var $gSkQi = parcelRequire("gSkQi");

var $a3tUH = parcelRequire("a3tUH");

var $dDC3L = parcelRequire("dDC3L");
const $273ba76bd00d7587$export$95cad242a2a55eb6 = (state, action)=>{
    if (!state.tlfData) throw new Error(`tlfContextReducer: ${(0, $dDC3L.UPDATE_TLF)}: TLF data not set`);
    const newState = {
        ...state
    };
    const newTlfData = {
        ...state.tlfData,
        ...action.tlfData
    };
    newState.tlfData = newTlfData;
    if (action.reset) {
        newState.ixTlfDataVersion = 0;
        newState.ixSaveVersion = 0;
        newState.tlfDataVersions = [
            (0, $gSkQi.cloneDeep)(newTlfData)
        ];
        newState.showModalWindow = "";
        newState.forcePushToParent = true;
    } else if (action.newSavePoint) {
        newState.ixSaveVersion = state.ixTlfDataVersion;
        newState.tlfDataVersions = [
            ...state.tlfDataVersions.slice(0, state.ixTlfDataVersion),
            (0, $gSkQi.cloneDeep)(newTlfData)
        ];
        newState.showModalWindow = "";
        newState.forcePushToParent = true;
    } else if (action.doNotAddUndo) {
        newState.ixTlfDataVersion = state.ixTlfDataVersion;
        newState.tlfDataVersions = [
            ...state.tlfDataVersions.slice(0, state.ixTlfDataVersion),
            (0, $gSkQi.cloneDeep)(newTlfData)
        ];
        newState.forcePushToParent = true;
    } else {
        if (state.ixSaveVersion > state.ixTlfDataVersion) newState.ixSaveVersion = -1;
        newState.ixTlfDataVersion = state.ixTlfDataVersion + 1;
        newState.tlfDataVersions = [
            ...state.tlfDataVersions.slice(0, newState.ixTlfDataVersion),
            (0, $gSkQi.cloneDeep)(newTlfData)
        ];
    }
    (0, $a3tUH.checkChanged)(newState);
    return newState;
};

});

parcelRegister("f5VZi", function(module, exports) {

$parcel$export(module.exports, "tlf_updateTlfComment", function () { return $73bc7e706a0eb981$export$f997fd347dcfde9a; });

var $a3tUH = parcelRequire("a3tUH");

var $dDC3L = parcelRequire("dDC3L");
const $73bc7e706a0eb981$export$f997fd347dcfde9a = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $dDC3L.UPDATE_TLF_COMMENT)}: TLF data not set`);
    newState.tlfData = {
        ...newState.tlfData,
        comments: [
            ...newState.tlfData.comments.filter((comment)=>comment.id !== action.comment.id),
            action.comment
        ]
    };
    newState.forcePushToParent = true;
    (0, $a3tUH.checkChanged)(newState);
    return newState;
};

});



parcelRegister("8EyAa", function(module, exports) {

$parcel$export(module.exports, "tocContextReducer", function () { return $0ee81865aa665a0f$export$80233f876f620d20; });

var $6E9u3 = parcelRequire("6E9u3");
parcelRequire("h4Ok8");
var $4DSpH = parcelRequire("4DSpH");
var $hQpv0 = parcelRequire("hQpv0");
var $jf4N1 = parcelRequire("jf4N1");
var $5nHT1 = parcelRequire("5nHT1");
var $jpf00 = parcelRequire("jpf00");
var $fsWUX = parcelRequire("fsWUX");
var $4ZllF = parcelRequire("4ZllF");
var $aKevL = parcelRequire("aKevL");
var $hvFWq = parcelRequire("hvFWq");
var $lfPoH = parcelRequire("lfPoH");
var $85LhP = parcelRequire("85LhP");
var $de3cU = parcelRequire("de3cU");
var $88SIw = parcelRequire("88SIw");
var $goO3C = parcelRequire("goO3C");
var $brYBY = parcelRequire("brYBY");
var $eCOue = parcelRequire("eCOue");
var $1jxAP = parcelRequire("1jxAP");
var $a0QnL = parcelRequire("a0QnL");
var $2JOzY = parcelRequire("2JOzY");
var $9kbdQ = parcelRequire("9kbdQ");
var $5REiI = parcelRequire("5REiI");
var $6oN9f = parcelRequire("6oN9f");
var $bzDbj = parcelRequire("bzDbj");
var $f3Oq5 = parcelRequire("f3Oq5");
var $f6aTn = parcelRequire("f6aTn");
var $93waG = parcelRequire("93waG");
const $0ee81865aa665a0f$export$80233f876f620d20 = (state, action)=>{
    switch(action.operation){
        case 0, $6E9u3.ADD_NEW_TOC_ENTRIES:
            return (0, $4DSpH.toc_addNewTocEntries)(state, action);
        case 0, $6E9u3.ADD_SECTION:
            return (0, $hQpv0.toc_addSection)(state, action);
        case 0, $6E9u3.CLEAR_REMOVED:
            return (0, $jf4N1.toc_clearRemoved)(state);
        case 0, $6E9u3.CLOSE_TOC_NEED_REFRESH:
            return (0, $5nHT1.toc_closeTocNeedRefresh)(state);
        case 0, $6E9u3.CLOSE_TOC_SAVE_ALERT:
            return (0, $jpf00.toc_closeTocSaveAlert)(state);
        case 0, $6E9u3.DELETE:
            return (0, $fsWUX.toc_delete)(state, action);
        case 0, $6E9u3.FROM_SIGNALR:
            return (0, $4ZllF.toc_fromSignalR)(state, action);
        case 0, $6E9u3.MOVE_ITEM:
            return (0, $aKevL.toc_moveItem)(state, action);
        case 0, $6E9u3.REASSIGN_TOC_NUMBERS:
            return (0, $hvFWq.toc_reassignTocNumbers)(state);
        case 0, $6E9u3.REFRESH:
            return (0, $lfPoH.toc_refresh)(state, action);
        case 0, $6E9u3.SAVE_FAIL:
            return (0, $85LhP.toc_saveFail)(state);
        case 0, $6E9u3.SAVE_SUCCESS:
            return (0, $de3cU.toc_saveSuccess)(state, action);
        case 0, $6E9u3.SAVING_TOC_ITEM_VIA_TLF:
            return (0, $88SIw.toc_savingTocItemViaTlf)(state);
        case 0, $6E9u3.SET_TOC_REQUEST_STATUS:
            return (0, $goO3C.toc_setTocRequestStatus)(state, action);
        case 0, $6E9u3.SET_TYPE_FILTER:
            return (0, $brYBY.toc_setTypeFilter)(state, action);
        case 0, $6E9u3.SHOW_TOC_NEED_REFRESH:
            return (0, $eCOue.toc_showTocNeedRefresh)(state);
        case 0, $6E9u3.SHOW_TOC_SAVE_ALERT:
            return (0, $1jxAP.toc_showTocSaveAlert)(state, action);
        case 0, $6E9u3.SORT_TOC:
            return (0, $a0QnL.toc_sortToc)(state);
        case 0, $6E9u3.UPDATE_AFTER_PATCH:
            return (0, $2JOzY.toc_updateAfterPatch)(state);
        case 0, $6E9u3.UPDATE_COMMENTS_FILTER:
            return (0, $9kbdQ.toc_updateCommentsFilter)(state, action);
        case 0, $6E9u3.UPDATE_ENTRY:
            return (0, $5REiI.toc_updateEntry)(state, action);
        case 0, $6E9u3.UPDATE_LAST_MAJOR_VERSION_SAVED_AT:
            return (0, $6oN9f.toc_updateLastMajorVersionSavedAt)(state, action);
        case 0, $6E9u3.UPDATE_SEARCH_TEXT:
            return (0, $bzDbj.toc_updateSearchText)(state, action);
        case 0, $6E9u3.UPDATE_SECTION:
            return (0, $f3Oq5.toc_updateSection)(state, action);
        case 0, $6E9u3.UPDATE_TRAFFIC_LIGHTS_FILTER:
            return (0, $f6aTn.toc_updateTrafficLightsFilter)(state, action);
        case 0, $6E9u3.UPDATE_VIEW_TIFO:
            return (0, $93waG.toc_updateViewTiFo)(state, action);
    }
};

});
parcelRegister("6E9u3", function(module, exports) {

$parcel$export(module.exports, "ADD_NEW_TOC_ENTRIES", function () { return $186636d2a7dff76b$export$b34d12c25bb2dd91; });
$parcel$export(module.exports, "ADD_SECTION", function () { return $186636d2a7dff76b$export$c7111862174a3986; });
$parcel$export(module.exports, "CLEAR_REMOVED", function () { return $186636d2a7dff76b$export$d1bc7c5f629d50ed; });
$parcel$export(module.exports, "CLOSE_TOC_NEED_REFRESH", function () { return $186636d2a7dff76b$export$99d31802a554c5b; });
$parcel$export(module.exports, "CLOSE_TOC_SAVE_ALERT", function () { return $186636d2a7dff76b$export$3717e9f3cef35195; });
$parcel$export(module.exports, "DELETE", function () { return $186636d2a7dff76b$export$4bd2facc4a3e6aa1; });
$parcel$export(module.exports, "FROM_SIGNALR", function () { return $186636d2a7dff76b$export$5e5681c39cb93dd7; });
$parcel$export(module.exports, "MOVE_ITEM", function () { return $186636d2a7dff76b$export$41c09ed761ad8908; });
$parcel$export(module.exports, "REASSIGN_TOC_NUMBERS", function () { return $186636d2a7dff76b$export$5db4b16d450baa30; });
$parcel$export(module.exports, "REFRESH", function () { return $186636d2a7dff76b$export$6c953e829e7f40b1; });
$parcel$export(module.exports, "SAVE_FAIL", function () { return $186636d2a7dff76b$export$edc98118e39a5f08; });
$parcel$export(module.exports, "SAVE_SUCCESS", function () { return $186636d2a7dff76b$export$c97525462b847b71; });
$parcel$export(module.exports, "SAVING_TOC_ITEM_VIA_TLF", function () { return $186636d2a7dff76b$export$3c137f51be687a9; });
$parcel$export(module.exports, "SET_TOC_REQUEST_STATUS", function () { return $186636d2a7dff76b$export$62389da2c73c504f; });
$parcel$export(module.exports, "SET_TYPE_FILTER", function () { return $186636d2a7dff76b$export$ec772941a6ed73d2; });
$parcel$export(module.exports, "SHOW_TOC_NEED_REFRESH", function () { return $186636d2a7dff76b$export$9df14b3306a3dc55; });
$parcel$export(module.exports, "SHOW_TOC_SAVE_ALERT", function () { return $186636d2a7dff76b$export$6b7f955731436599; });
$parcel$export(module.exports, "SORT_TOC", function () { return $186636d2a7dff76b$export$6e957318c416b9ca; });
$parcel$export(module.exports, "UPDATE_AFTER_PATCH", function () { return $186636d2a7dff76b$export$d4684aa5138afe65; });
$parcel$export(module.exports, "UPDATE_COMMENTS_FILTER", function () { return $186636d2a7dff76b$export$e5be5d1ddab7a027; });
$parcel$export(module.exports, "UPDATE_ENTRY", function () { return $186636d2a7dff76b$export$8e3020b6be7d753a; });
$parcel$export(module.exports, "UPDATE_LAST_MAJOR_VERSION_SAVED_AT", function () { return $186636d2a7dff76b$export$d5abd8e8b336f12c; });
$parcel$export(module.exports, "UPDATE_SEARCH_TEXT", function () { return $186636d2a7dff76b$export$7995e32e37a98def; });
$parcel$export(module.exports, "UPDATE_SECTION", function () { return $186636d2a7dff76b$export$6b6dcf2c69db97d3; });
$parcel$export(module.exports, "UPDATE_TRAFFIC_LIGHTS_FILTER", function () { return $186636d2a7dff76b$export$b25f651b871e7eb7; });
$parcel$export(module.exports, "UPDATE_VIEW_TIFO", function () { return $186636d2a7dff76b$export$6db0c9048fe59122; });
const $186636d2a7dff76b$export$b34d12c25bb2dd91 = "ADD_NEW_TOC_ENTRIES";
const $186636d2a7dff76b$export$c7111862174a3986 = "ADD_SECTION";
const $186636d2a7dff76b$export$d1bc7c5f629d50ed = "CLEAR_REMOVED";
const $186636d2a7dff76b$export$99d31802a554c5b = "CLOSE_TOC_NEED_REFRESH";
const $186636d2a7dff76b$export$3717e9f3cef35195 = "CLOSE_TOC_SAVE_ALERT";
const $186636d2a7dff76b$export$4bd2facc4a3e6aa1 = "DELETE";
const $186636d2a7dff76b$export$5e5681c39cb93dd7 = "FROM_SIGNALR";
const $186636d2a7dff76b$export$41c09ed761ad8908 = "MOVE_ITEM";
const $186636d2a7dff76b$export$5db4b16d450baa30 = "REASSIGN_TOC_NUMBERS";
const $186636d2a7dff76b$export$6c953e829e7f40b1 = "REFRESH";
const $186636d2a7dff76b$export$edc98118e39a5f08 = "SAVE_FAIL";
const $186636d2a7dff76b$export$c97525462b847b71 = "SAVE_SUCCESS";
const $186636d2a7dff76b$export$3c137f51be687a9 = "SAVING_TOC_ITEM_VIA_TLF";
const $186636d2a7dff76b$export$62389da2c73c504f = "SET_TOC_REQUEST_STATUS";
const $186636d2a7dff76b$export$ec772941a6ed73d2 = "SET_TYPE_FILTER";
const $186636d2a7dff76b$export$9df14b3306a3dc55 = "SHOW_TOC_NEED_REFRESH";
const $186636d2a7dff76b$export$6b7f955731436599 = "SHOW_TOC_SAVE_ALERT";
const $186636d2a7dff76b$export$6e957318c416b9ca = "SORT_TOC";
const $186636d2a7dff76b$export$d4684aa5138afe65 = "UPDATE_AFTER_PATCH";
const $186636d2a7dff76b$export$e5be5d1ddab7a027 = "UPDATE_COMMENTS_FILTER";
const $186636d2a7dff76b$export$8e3020b6be7d753a = "UPDATE_ENTRY";
const $186636d2a7dff76b$export$d5abd8e8b336f12c = "UPDATE_LAST_MAJOR_VERSION_SAVED_AT";
const $186636d2a7dff76b$export$7995e32e37a98def = "UPDATE_SEARCH_TEXT";
const $186636d2a7dff76b$export$6b6dcf2c69db97d3 = "UPDATE_SECTION";
const $186636d2a7dff76b$export$b25f651b871e7eb7 = "UPDATE_TRAFFIC_LIGHTS_FILTER";
const $186636d2a7dff76b$export$6db0c9048fe59122 = "UPDATE_VIEW_TIFO";

});

parcelRegister("h4Ok8", function(module, exports) {
$parcel$export(module.exports, "toc_addNewTocEntries", function () { return (parcelRequire("4DSpH")).toc_addNewTocEntries; });
$parcel$export(module.exports, "toc_addSection", function () { return (parcelRequire("hQpv0")).toc_addSection; });
$parcel$export(module.exports, "toc_clearRemoved", function () { return (parcelRequire("jf4N1")).toc_clearRemoved; });
$parcel$export(module.exports, "toc_closeTocNeedRefresh", function () { return (parcelRequire("5nHT1")).toc_closeTocNeedRefresh; });
$parcel$export(module.exports, "toc_closeTocSaveAlert", function () { return (parcelRequire("jpf00")).toc_closeTocSaveAlert; });
$parcel$export(module.exports, "toc_delete", function () { return (parcelRequire("fsWUX")).toc_delete; });
$parcel$export(module.exports, "toc_fromSignalR", function () { return (parcelRequire("4ZllF")).toc_fromSignalR; });
$parcel$export(module.exports, "toc_moveItem", function () { return (parcelRequire("aKevL")).toc_moveItem; });
$parcel$export(module.exports, "toc_reassignTocNumbers", function () { return (parcelRequire("hvFWq")).toc_reassignTocNumbers; });
$parcel$export(module.exports, "toc_refresh", function () { return (parcelRequire("lfPoH")).toc_refresh; });
$parcel$export(module.exports, "toc_saveFail", function () { return (parcelRequire("85LhP")).toc_saveFail; });
$parcel$export(module.exports, "toc_saveSuccess", function () { return (parcelRequire("de3cU")).toc_saveSuccess; });
$parcel$export(module.exports, "toc_savingTocItemViaTlf", function () { return (parcelRequire("88SIw")).toc_savingTocItemViaTlf; });
$parcel$export(module.exports, "toc_setTocRequestStatus", function () { return (parcelRequire("goO3C")).toc_setTocRequestStatus; });
$parcel$export(module.exports, "toc_setTypeFilter", function () { return (parcelRequire("brYBY")).toc_setTypeFilter; });
$parcel$export(module.exports, "toc_showTocNeedRefresh", function () { return (parcelRequire("eCOue")).toc_showTocNeedRefresh; });
$parcel$export(module.exports, "toc_showTocSaveAlert", function () { return (parcelRequire("1jxAP")).toc_showTocSaveAlert; });
$parcel$export(module.exports, "toc_sortToc", function () { return (parcelRequire("a0QnL")).toc_sortToc; });
$parcel$export(module.exports, "toc_updateAfterPatch", function () { return (parcelRequire("2JOzY")).toc_updateAfterPatch; });
$parcel$export(module.exports, "toc_updateCommentsFilter", function () { return (parcelRequire("9kbdQ")).toc_updateCommentsFilter; });
$parcel$export(module.exports, "toc_updateEntry", function () { return (parcelRequire("5REiI")).toc_updateEntry; });
$parcel$export(module.exports, "toc_updateLastMajorVersionSavedAt", function () { return (parcelRequire("6oN9f")).toc_updateLastMajorVersionSavedAt; });
$parcel$export(module.exports, "toc_updateSearchText", function () { return (parcelRequire("bzDbj")).toc_updateSearchText; });
$parcel$export(module.exports, "toc_updateSection", function () { return (parcelRequire("f3Oq5")).toc_updateSection; });
$parcel$export(module.exports, "toc_updateTrafficLightsFilter", function () { return (parcelRequire("f6aTn")).toc_updateTrafficLightsFilter; });
$parcel$export(module.exports, "toc_updateViewTiFo", function () { return (parcelRequire("93waG")).toc_updateViewTiFo; });
parcelRequire("4DSpH");
parcelRequire("hQpv0");
parcelRequire("jf4N1");
parcelRequire("5nHT1");
parcelRequire("jpf00");
parcelRequire("fsWUX");
parcelRequire("4ZllF");
parcelRequire("aKevL");
parcelRequire("hvFWq");
parcelRequire("lfPoH");
parcelRequire("85LhP");
parcelRequire("de3cU");
parcelRequire("88SIw");
parcelRequire("goO3C");
parcelRequire("brYBY");
parcelRequire("eCOue");
parcelRequire("1jxAP");
parcelRequire("a0QnL");
parcelRequire("2JOzY");
parcelRequire("9kbdQ");
parcelRequire("5REiI");
parcelRequire("6oN9f");
parcelRequire("bzDbj");
parcelRequire("f3Oq5");
parcelRequire("f6aTn");
parcelRequire("93waG");

});
parcelRegister("4DSpH", function(module, exports) {

$parcel$export(module.exports, "toc_addNewTocEntries", function () { return $8340016488c859de$export$ca84015e21a0e92f; });
const $8340016488c859de$export$ca84015e21a0e92f = (state, action)=>{
    const newState = {
        ...state
    };
    const existingIds = newState.tocItems.map((item)=>item.id);
    newState.tocItems = [
        ...newState.tocItems,
        ...action.entries.filter((item)=>!existingIds.includes(item.id))
    ].sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- reducer items should already carry a persisted order value.
        0) - (second.tocOrder ?? // istanbul ignore next -- reducer items should already carry a persisted order value.
        0));
    newState.saving = false;
    newState.lastMinorVersionSavedAt = action.loadTimeStamp;
    newState.sendUpdate = true;
    return newState;
};

});

parcelRegister("hQpv0", function(module, exports) {

$parcel$export(module.exports, "toc_addSection", function () { return $d032d892afbb4059$export$9905c9b4e7c93cf3; });

var $bVMOy = parcelRequire("bVMOy");
const $d032d892afbb4059$export$9905c9b4e7c93cf3 = (state, action)=>{
    const newState = {
        ...state
    };
    /* istanbul ignore else -- reducer callers only dispatch unique identifiers. */ if (newState.tocItems.findIndex((item)=>item.id === action.newId) === -1) {
        const newSection = new (0, $bVMOy.MosaicTocSectionClass)({
            id: action.newId,
            primaryHierarchyId: newState.hierarchyId,
            sectionLabel: "",
            sectionNumber: "",
            order: newState.tocItems.map((item)=>item.tocOrder ?? // istanbul ignore next -- all ToC items should carry an order before insertion.
                0).reduce((first, second)=>Math.min(first, second), 0) - 1,
            changed: true
        });
        newState.tocItems.splice(0, 0, newSection);
        newState.saving = true;
    }
    return newState;
};

});
parcelRegister("bVMOy", function(module, exports) {

$parcel$export(module.exports, "MosaicTocSectionClass", function () { return $7807c17910de1272$export$3a645995f5f4e506; });
parcelRequire("P0x5y");
var $8CFpa = parcelRequire("8CFpa");

var $7Wd8C = parcelRequire("7Wd8C");

var $jH6Z1 = parcelRequire("jH6Z1");
const $7807c17910de1272$export$6e61049aca2d3937 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    return typeof obj.id === "string" && typeof obj.sectionNumber === "string" && typeof obj.sectionLabel === "string" && typeof obj.order === "number" && typeof obj.primaryHierarchyId === "string";
};
class $7807c17910de1272$export$3a645995f5f4e506 extends (0, $jH6Z1.MosaicTocBaseClass) {
    /**
   * Construct a `MosaicTocSectionClass` from either an expanded section or DTO.
   *
   * @param input - Source object either expanded (`ITocSectionExpanded`) or DTO form.
   */ constructor(input){
        const feedSuper = $7807c17910de1272$export$6e61049aca2d3937(input) ? {
            id: input.id,
            primaryHierarchyId: input.primaryHierarchyId,
            tocLabel: input.sectionLabel,
            tocNumber: input.sectionNumber,
            tocOrder: input.order,
            changed: input.changed ?? false,
            inError: false
        } : input;
        super(feedSuper), this.type = (0, $7Wd8C.eTlfItemType).section;
    }
    /**
   * Return the data transfer object representation of this section.
   *
   * @returns A `MosaicTocSectionDto` representing this section's persisted shape.
   */ get data() {
        return {
            id: this.id,
            type: this.type,
            primaryHierarchyId: this.primaryHierarchyId,
            tocLabel: this.tocLabel,
            tocNumber: this.tocNumber,
            tocOrder: this.tocOrder,
            changed: this.changed,
            inError: this.inError
        };
    }
}

});
parcelRegister("jH6Z1", function(module, exports) {

$parcel$export(module.exports, "MosaicTocBaseClass", function () { return $a5e19e94c7c78d5e$export$8c30cd20218100fd; });
class $a5e19e94c7c78d5e$export$8c30cd20218100fd {
    /**
   * Gets the unique identifier for this TOC item.
   */ get id() {
        return this._id;
    }
    /**
   * Gets whether this item has unsaved changes.
   */ get changed() {
        return this._changed;
    }
    /**
   * Gets whether this item has a save error.
   */ get inError() {
        return this._inError;
    }
    /**
   * Gets the primary hierarchy ID for this item.
   */ get primaryHierarchyId() {
        return this._primaryHierarchyId;
    }
    /**
   * Gets the timestamp of the last update.
   */ get updateTimestamp() {
        return this._updateTimestamp;
    }
    /**
   * Gets the TOC number (e.g., "1.2.3").
   */ get tocNumber() {
        return this._tocNumber;
    }
    /**
   * Gets the TOC label text.
   */ get tocLabel() {
        return this._tocLabel;
    }
    /**
   * Gets the sort order for this TOC item.
   */ get tocOrder() {
        return this._tocOrder;
    }
    /**
   * Creates a new TOC base class instance.
   *
   * @param input - The TOC base data to initialise from
   */ constructor(input){
        this._id = "";
        this._changed = false;
        this._inError = false;
        this._primaryHierarchyId = "";
        this._updateTimestamp = null;
        this._tocNumber = "";
        this._tocLabel = "";
        this._tocOrder = -1;
        const errCheck = [];
        if (input.id.trim().length === 0) errCheck.push("mosaicTocItem: contructor: id cannot be blank");
        else if (input.id.match(/^[A-Za-z0-9-_]+$/) === null) errCheck.push(`mosaicTocItem: contructor: id (${input.id}) must contain alphanumerics, hyphen and underscore`);
        if (errCheck.length > 0) throw errCheck.join("\n");
        this._id = input.id;
        this._primaryHierarchyId = input.primaryHierarchyId;
        this._tocNumber = input.tocNumber ?? // istanbul ignore next
        "";
        this._tocLabel = input.tocLabel ?? // istanbul ignore next
        "";
        this._updateTimestamp = new Date().getTime();
        this._tocOrder = input.tocOrder ?? // istanbul ignore next
        -1;
        this._changed = input.changed;
        this._inError = input.inError;
    }
    /**
   * Marks this item as successfully saved.
   */ markSaved() {
        this._changed = false;
        this._inError = false;
        this._updateTimestamp = new Date().getTime();
    }
    /**
   * Marks this item as having a save failure.
   */ markSaveFailed() {
        this._changed = true;
        this._inError = true;
        this._updateTimestamp = new Date().getTime();
    }
    /**
   * Updates this TOC item with new values.
   *
   * @param update - The update data to apply
   * @param now - Optional. The timestamp for this update
   */ update(update, now = null) {
        if (update.id !== this._id) throw new Error("Cannot update a section with a different id");
        now = now ?? new Date().getTime();
        if (update.primaryHierarchyId !== undefined && this._primaryHierarchyId !== update.primaryHierarchyId) {
            this._primaryHierarchyId = update.primaryHierarchyId;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
        if (update.tocNumber !== undefined && this._tocNumber !== update.tocNumber) {
            this._tocNumber = update.tocNumber;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
        if (update.tocLabel !== undefined && this._tocLabel !== update.tocLabel) {
            this._tocLabel = update.tocLabel;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
        if (update.tocOrder !== undefined && this._tocOrder !== update.tocOrder) {
            this._tocOrder = update.tocOrder;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
    }
}

});



parcelRegister("jf4N1", function(module, exports) {

$parcel$export(module.exports, "toc_clearRemoved", function () { return $c98a517a495c78c7$export$7250148a97c9b0a1; });
const $c98a517a495c78c7$export$7250148a97c9b0a1 = (state)=>({
        ...state,
        removedItems: [],
        changed: false
    });

});

parcelRegister("5nHT1", function(module, exports) {

$parcel$export(module.exports, "toc_closeTocNeedRefresh", function () { return $c3a1eba6079e1167$export$667658cd9f64b286; });
const $c3a1eba6079e1167$export$667658cd9f64b286 = (state)=>({
        ...state,
        showNeedRefresh: false
    });

});

parcelRegister("jpf00", function(module, exports) {

$parcel$export(module.exports, "toc_closeTocSaveAlert", function () { return $57309131c5c243ed$export$327d020828e9fb64; });
const $57309131c5c243ed$export$327d020828e9fb64 = (state)=>({
        ...state,
        showSaveAlert: false,
        tocIdFromMessage: undefined
    });

});

parcelRegister("fsWUX", function(module, exports) {

$parcel$export(module.exports, "toc_delete", function () { return $541059e073bf2099$export$43af0e84986eaf51; });
const $541059e073bf2099$export$43af0e84986eaf51 = (state, action)=>{
    const newState = {
        ...state
    };
    const removed = newState.tocItems.find((item)=>item.id === action.itemId);
    /* istanbul ignore else -- callers only request deletion for visible ToC items. */ if (removed) {
        newState.tocItems = newState.tocItems.filter((item)=>item.id !== action.itemId);
        if (removed.type === "Section") newState.removedItems.push({
            id: removed.id,
            changed: true
        });
        else newState.removedItems.push({
            id: removed.id,
            azsolId: removed.azsolId,
            version: removed.version,
            changed: true
        });
        newState.saving = true;
    }
    return newState;
};

});

parcelRegister("4ZllF", function(module, exports) {

$parcel$export(module.exports, "toc_fromSignalR", function () { return $b5d2af2e1e133687$export$84307661cfc4b7a0; });

var $7Wd8C = parcelRequire("7Wd8C");

var $bVMOy = parcelRequire("bVMOy");
const $b5d2af2e1e133687$export$84307661cfc4b7a0 = (state, action)=>{
    const newState = {
        ...state
    };
    // Delete item if found
    if (newState.tocItems.findIndex((item)=>item.id === action.deletedItemId) > -1) {
        const index = newState.tocItems.findIndex((item)=>item.id === action.deletedItemId);
        newState.removedItems.push(...newState.tocItems.splice(index, 1));
    }
    action.items.forEach((item)=>{
        const index = newState.tocItems.findIndex((currentItem)=>currentItem.id === item.id);
        const current = newState.tocItems[index];
        // Update item when found
        if (index > -1 && item.type === (0, $7Wd8C.eTlfItemType).section && current instanceof (0, $bVMOy.MosaicTocSectionClass)) current.update({
            ...item,
            saved: true
        });
        else if (index > -1 && item.type !== (0, $7Wd8C.eTlfItemType).section && current.type !== (0, $7Wd8C.eTlfItemType).section) newState.tocItems[index] = {
            ...current,
            ...item,
            saved: true
        };
        else if (item.type === (0, $7Wd8C.eTlfItemType).section) {
            const newSection = new (0, $bVMOy.MosaicTocSectionClass)({
                id: item.id,
                sectionNumber: item.tocNumber ?? // istanbul ignore next -- SignalR section updates should include the section number.
                "",
                sectionLabel: item.tocLabel ?? // istanbul ignore next -- SignalR section updates should include the section label.
                "",
                order: item.tocOrder ?? // istanbul ignore next -- SignalR section updates should include the section order.
                0,
                primaryHierarchyId: newState.hierarchyId,
                changed: false
            });
            newState.tocItems.push(newSection);
        } else newState.tocItems.push(item);
    });
    newState.receivedMessages.push(action.receivedMessage);
    newState.tocItems.sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- all ToC items are expected to have a numeric order.
        0) - (second.tocOrder ?? // istanbul ignore next -- all ToC items are expected to have a numeric order.
        0));
    newState.saving = false;
    return newState;
};

});

parcelRegister("aKevL", function(module, exports) {

$parcel$export(module.exports, "toc_moveItem", function () { return $f2cb16861889f11e$export$2028bd3b4beb0dc1; });

var $bVMOy = parcelRequire("bVMOy");
const $f2cb16861889f11e$export$2028bd3b4beb0dc1 = (state, action)=>{
    const newState = {
        ...state
    };
    const moveIndex = newState.tocItems.map((item)=>item.id).indexOf(action.itemId);
    if (moveIndex < 0) return newState;
    /* istanbul ignore else */ if (moveIndex !== action.newIndex) {
        newState.tocItems.splice(action.newIndex, 0, newState.tocItems.splice(moveIndex, 1)[0]);
        newState.tocItems.forEach((item, index)=>{
            if (item.tocOrder !== index) {
                if (item instanceof (0, $bVMOy.MosaicTocSectionClass)) item.update({
                    id: item.id,
                    saved: false,
                    tocOrder: index
                });
                else {
                    item.tocOrder = index;
                    item.changed = true;
                    item.inError = false;
                }
            }
        });
    }
    newState.saving = true;
    return newState;
};

});

parcelRegister("hvFWq", function(module, exports) {

$parcel$export(module.exports, "toc_reassignTocNumbers", function () { return $f003fe593edb615b$export$c2ae119a8cbcdf9e; });

var $bVMOy = parcelRequire("bVMOy");
const $f003fe593edb615b$export$c2ae119a8cbcdf9e = (state)=>{
    const newState = {
        ...state
    };
    newState.tocItems = newState.tocItems.sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- ToC items should already have a numeric order.
        0) - (second.tocOrder ?? // istanbul ignore next -- ToC items should already have a numeric order.
        0));
    let lastSection = "";
    let lastNumber = 0;
    newState.tocItems = newState.tocItems.map((item)=>{
        if (item instanceof (0, $bVMOy.MosaicTocSectionClass)) {
            lastSection = item.tocNumber;
            lastNumber = 0;
            return item;
        }
        lastNumber++;
        const newTocNumber = lastSection !== "" ? `${lastSection}.${lastNumber}` : "";
        if (newTocNumber !== item.tocNumber) return {
            ...item,
            tocNumber: newTocNumber,
            changed: true,
            inError: false
        };
        return item;
    });
    newState.saving = true;
    return newState;
};

});

parcelRegister("lfPoH", function(module, exports) {

$parcel$export(module.exports, "toc_refresh", function () { return $1d1f4893f71446db$export$e1ba7625da1d0d0; });
const $1d1f4893f71446db$export$e1ba7625da1d0d0 = (state, action)=>{
    const newState = {
        ...state
    };
    newState.changed = false;
    newState.hierarchyId = action.hierarchyId;
    newState.removedItems = action.removedItems ?? [];
    newState.saving = false;
    newState.saveError = false;
    newState.sendUpdate = false;
    newState.tocItems = [
        ...action.items
    ];
    newState.tocItems.sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- refreshed ToC items should already carry a persisted order.
        0) - (second.tocOrder ?? // istanbul ignore next -- refreshed ToC items should already carry a persisted order.
        0));
    return newState;
};

});

parcelRegister("85LhP", function(module, exports) {

$parcel$export(module.exports, "toc_saveFail", function () { return $c352a527309f5a70$export$804404ce6ca64db9; });

var $bVMOy = parcelRequire("bVMOy");
const $c352a527309f5a70$export$804404ce6ca64db9 = (state)=>{
    const newState = {
        ...state
    };
    newState.blocked = false;
    newState.changed = true;
    newState.saveError = true;
    newState.saving = false;
    newState.sendUpdate = false;
    newState.tocItems.filter((item)=>item.changed).forEach((item)=>{
        if (item instanceof (0, $bVMOy.MosaicTocSectionClass)) item.markSaveFailed();
        else {
            item.inError = true;
            item.changed = true;
        }
    });
    return newState;
};

});

parcelRegister("de3cU", function(module, exports) {

$parcel$export(module.exports, "toc_saveSuccess", function () { return $1b4ed667a0270d50$export$abbadbf2e22cae26; });

var $bVMOy = parcelRequire("bVMOy");
const $1b4ed667a0270d50$export$abbadbf2e22cae26 = (state, action)=>{
    const newState = {
        ...state
    };
    newState.tocItems.forEach((item)=>{
        if (item instanceof (0, $bVMOy.MosaicTocSectionClass)) item.markSaved();
        else {
            item.inError = false;
            item.changed = false;
        }
    });
    newState.saving = false;
    newState.blocked = false;
    newState.saveError = false;
    newState.changed = false;
    newState.sendUpdate = true;
    newState.lastMinorVersionSavedAt = action.saveTimeStamp;
    return newState;
};

});

parcelRegister("88SIw", function(module, exports) {

$parcel$export(module.exports, "toc_savingTocItemViaTlf", function () { return $f8b9cda45ef87b69$export$3e2d4b4bc5f4bfcf; });
const $f8b9cda45ef87b69$export$3e2d4b4bc5f4bfcf = (state)=>({
        ...state,
        blocked: "patching"
    });

});

parcelRegister("goO3C", function(module, exports) {

$parcel$export(module.exports, "toc_setTocRequestStatus", function () { return $cf8cb2a0318aa41e$export$a7c36566e6d32f46; });
const $cf8cb2a0318aa41e$export$a7c36566e6d32f46 = (state, action)=>({
        ...state,
        tocRequestStatus: action.tocRequestStatus
    });

});

parcelRegister("brYBY", function(module, exports) {

$parcel$export(module.exports, "toc_setTypeFilter", function () { return $91ab86da2a2ea681$export$93cedf76c4089a76; });
const $91ab86da2a2ea681$export$93cedf76c4089a76 = (state, action)=>({
        ...state,
        showTypes: action.showTypes
    });

});

parcelRegister("eCOue", function(module, exports) {

$parcel$export(module.exports, "toc_showTocNeedRefresh", function () { return $e570a3c8192c2af8$export$c37340cbfdd3e708; });
const $e570a3c8192c2af8$export$c37340cbfdd3e708 = (state)=>({
        ...state,
        showNeedRefresh: true
    });

});

parcelRegister("1jxAP", function(module, exports) {

$parcel$export(module.exports, "toc_showTocSaveAlert", function () { return $ca0b751b1118bdad$export$91645051c93c25ba; });
const $ca0b751b1118bdad$export$91645051c93c25ba = (state, action)=>({
        ...state,
        showSaveAlert: true,
        tocIdFromMessage: action.tocIdFromMessage
    });

});

parcelRegister("a0QnL", function(module, exports) {

$parcel$export(module.exports, "toc_sortToc", function () { return $11b1fdc6a900df30$export$de199bb0e6f4f13d; });

var $bVMOy = parcelRequire("bVMOy");

var $jfDHD = parcelRequire("jfDHD");
const $11b1fdc6a900df30$export$de199bb0e6f4f13d = (state)=>{
    const newState = {
        ...state
    };
    newState.tocItems = newState.tocItems.sort((first, second)=>(0, $jfDHD.tocSort)(first.tocNumber, second.tocNumber));
    newState.tocItems.forEach((item, index)=>{
        if (item.tocOrder !== index) {
            if (item instanceof (0, $bVMOy.MosaicTocSectionClass)) item.update({
                id: item.id,
                saved: false,
                tocOrder: index
            });
            else {
                item.tocOrder = index;
                item.changed = true;
                item.inError = false;
            }
        }
    });
    newState.saving = true;
    return newState;
};

});
parcelRegister("jfDHD", function(module, exports) {

$parcel$export(module.exports, "tocSort", function () { return $c83d78ac6b0015a2$export$61f391d90643b342; });
/**
 * Compares two hierarchical string sections (e.g., "1.2.3" vs "1.10.2") and sorts them accordingly.
 *
 * This function splits each input string by the delimiter '.', creating an array of strings.
 * It then iterates over the parts:
 * - If both parts convert to valid numbers, they are compared numerically.
 * - If one or both parts are not numbers, it falls back to a lexical comparison.
 *
 * The function processes up to the maximum number of parts present in either string.
 *
 * @param a - The first section string to compare.
 * @param b - The second section string to compare.
 * @returns A negative number if `a` should come before `b`, a positive number if `a` should come after `b`, or zero if they are equivalent.
 */ const $c83d78ac6b0015a2$export$61f391d90643b342 = (a, b)=>{
    const splitA = (a ?? "").split(".");
    const splitB = (b ?? "").split(".");
    for(let i = 0; i < Math.max(splitA.length, splitB.length); i++){
        const partA = splitA[i] || "";
        const partB = splitB[i] || "";
        const numA = parseInt(partA, 10);
        const numB = parseInt(partB, 10);
        if (!isNaN(numA) && !isNaN(numB)) {
            if (numA !== numB) return numA - numB;
        } else {
            if (partA !== partB) return partA.localeCompare(partB);
        }
    }
    return 0;
};

});


parcelRegister("2JOzY", function(module, exports) {

$parcel$export(module.exports, "toc_updateAfterPatch", function () { return $9a121f5f78835dea$export$e6f50a1d3e36bb5; });
const $9a121f5f78835dea$export$e6f50a1d3e36bb5 = (state)=>({
        ...state,
        blocked: false
    });

});

parcelRegister("9kbdQ", function(module, exports) {

$parcel$export(module.exports, "toc_updateCommentsFilter", function () { return $e30eea8b0467b23f$export$bc8db3b1297c3fec; });
const $e30eea8b0467b23f$export$bc8db3b1297c3fec = (state, action)=>({
        ...state,
        commentsFilter: action.commentsFilter
    });

});

parcelRegister("5REiI", function(module, exports) {

$parcel$export(module.exports, "toc_updateEntry", function () { return $13969c5cf978a8c2$export$f4a7af8f7ebf5793; });

var $k9TPW = parcelRequire("k9TPW");
const $13969c5cf978a8c2$export$f4a7af8f7ebf5793 = (state, action)=>{
    const newState = {
        ...state
    };
    const index = newState.tocItems.findIndex((item)=>item.id === action.update.id && (0, $k9TPW.isTitlesFootnotesReadDto)(item));
    /* istanbul ignore else -- callers only update entries that already exist in ToC state. */ if (index > -1) {
        const current = {
            ...newState.tocItems[index]
        };
        current.inError = false;
        current.changed = false;
        Object.keys(action.update).filter((key)=>![
                "id",
                "saved",
                "changed",
                "inError"
            ].includes(key)).forEach((key)=>{
            if (action.update[key] !== current[key]) current[key] = action.update[key];
        });
        newState.tocItems = [
            ...newState.tocItems.slice(0, index),
            current,
            ...newState.tocItems.slice(index + 1)
        ];
    }
    newState.blocked = "getNewVersion";
    return newState;
};

});
parcelRegister("k9TPW", function(module, exports) {

$parcel$export(module.exports, "isTitlesFootnotesReadDto", function () { return $85eba1dadce90d3c$export$5faa8ae3a91317b9; });

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $cXvVz = parcelRequire("cXvVz");
var $2xRzL = parcelRequire("2xRzL");
var $8CFpa = parcelRequire("8CFpa");

var $bDTjJ = parcelRequire("bDTjJ");

var $7Wd8C = parcelRequire("7Wd8C");

var $7Nk9o = parcelRequire("7Nk9o");
const $85eba1dadce90d3c$export$5faa8ae3a91317b9 = (obj)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check lower interface
    if (!(0, $7Nk9o.isTlfItemIndexReadDto)(obj)) return false;
    // Check basic props
    if (obj.programName !== undefined && typeof obj.programName !== "string") return false;
    if (obj.suffix !== undefined && typeof obj.suffix !== "string") return false;
    if (obj.outputName !== undefined && typeof obj.outputName !== "string") return false;
    if (obj.outputType !== undefined && (typeof obj.outputType !== "string" || !Object.values((0, $7Wd8C.eTlfOutputType)).includes(obj.outputType))) return false;
    if (typeof obj.shellMinorVersion !== "number") return false;
    // Check arrays
    if (!Array.isArray(obj.titles) || !Array.isArray(obj.footnotes)) return false;
    if (!Array.isArray(obj.comments) || obj.comments.some((x)=>!(0, $bDTjJ.isCommentReadDto)(x))) return false;
    if (!Array.isArray(obj.changedTitles) && obj.changedTitles !== undefined) return false;
    // Check array contents
    if (obj.changedTitles?.some((x)=>!(0, $2xRzL.isGridItemTrafficLight)(x))) return false;
    if (!Array.isArray(obj.singles) || obj.singles.some((o)=>!(0, $cXvVz.isAioExternalSingle)(o, (0, $1iDss.isIEditorV3)))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("bDTjJ", function(module, exports) {

$parcel$export(module.exports, "isCommentReadDto", function () { return $e02f6c0393893ddf$export$52d60b9432851981; });

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $8CFpa = parcelRequire("8CFpa");
const $e02f6c0393893ddf$export$52d60b9432851981 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    return(// Check properties types
    typeof obj.id === "string" && typeof obj.authorId === "number" && (0, $1iDss.isIEditorV3)(obj.content) && typeof obj.authorDisplayName === "string" && (obj.parentId === undefined || typeof obj.parentId === "string") && (obj.relatedTo === undefined || typeof obj.relatedTo === "string") && typeof obj.createdAt === "string" && typeof obj.updatedAt === "string" && typeof obj.updateCount === "number" && (obj.entityVersion === undefined || typeof obj.entityVersion === "string"));
};

});

parcelRegister("7Nk9o", function(module, exports) {

$parcel$export(module.exports, "isHierarchyLink", function () { return $09941f3ecf59e8b0$export$492be82763901ee5; });
$parcel$export(module.exports, "isTlfTag", function () { return $09941f3ecf59e8b0$export$c8a4d7e3d2c1d67c; });
$parcel$export(module.exports, "isTlfItemIndexReadDto", function () { return $09941f3ecf59e8b0$export$3259877ac5d52fde; });
parcelRequire("P0x5y");
var $l3p07 = parcelRequire("l3p07");
var $a6nWU = parcelRequire("a6nWU");
var $8CFpa = parcelRequire("8CFpa");

var $8U7rd = parcelRequire("8U7rd");

var $7Wd8C = parcelRequire("7Wd8C");
const $09941f3ecf59e8b0$export$6036fa85d2283ca1 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    return(// Check properties types
    typeof obj.linkId === "string" && typeof obj.linkType === "string" && typeof obj.azsolId === "string" && typeof obj.version === "number" && // Check enums
    obj.linkType in (0, $7Wd8C.eLinkType) && (obj.linkLocation === undefined || obj.linkLocation === null || (0, $8U7rd.isTlfLinkLocation)(obj.linkLocation)) && (obj.linkStatus === undefined || obj.linkStatus === null || typeof obj.linkStatus === "string" && obj.linkStatus in (0, $7Wd8C.eReleaseStatus)));
};
const $09941f3ecf59e8b0$export$492be82763901ee5 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    return typeof obj.hierarchyId === "string" && typeof obj.hierarchyTag === "string" && Object.values((0, $7Wd8C.eHierarchyLevel)).includes(obj.hierarchyLevel);
};
const $09941f3ecf59e8b0$export$c8a4d7e3d2c1d67c = (obj)=>{
    return typeof obj === "object" && obj !== null && "tagId" in obj && "tagValue" in obj && typeof obj.tagId === "string" && typeof obj.tagValue === "string";
};
const $09941f3ecf59e8b0$export$bc294b7706d86ce = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    return typeof obj.reasonCode === "string" && typeof obj.otherText === "string" && (obj.crystalReference === undefined || typeof obj.crystalReference === "string");
};
const $09941f3ecf59e8b0$export$3259877ac5d52fde = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check props
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.azsolId !== "string") return false;
    if (typeof chkObj.version !== "number") return false;
    if (typeof chkObj.primaryHierarchyId !== "string") return false;
    if (typeof chkObj.primaryHierarchyName !== "string") return false;
    if (typeof chkObj.primaryHierarchyLevel !== "string") return false;
    if (typeof chkObj.primaryHierarchyType !== "string") return false;
    if (typeof chkObj.dNumber !== "string") return false;
    if (typeof chkObj.taPrefix !== "string") return false;
    if (typeof chkObj.projectCode !== "string") return false;
    if (chkObj.tocOrder !== undefined && typeof chkObj.tocOrder !== "number") return false;
    if (chkObj.tocNumber !== undefined && typeof chkObj.tocNumber !== "string") return false;
    if (chkObj.tocLabel !== undefined && typeof chkObj.tocLabel !== "string") return false;
    if (chkObj.analysisSetId !== undefined && typeof chkObj.analysisSetId !== "string") return false;
    if (chkObj.tocReleaseStatus !== undefined && typeof chkObj.tocReleaseStatus !== "string") return false;
    if (chkObj.tocOriginTrafficLight !== undefined && typeof chkObj.tocOriginTrafficLight !== "string") return false;
    if (!(0, $a6nWU.isMosaicTrafficLightSwitch)(chkObj.coreTrafficLightSwitch)) return false;
    if (!(0, $l3p07.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    if (chkObj.trafficLightOverrideReason !== undefined && !$09941f3ecf59e8b0$export$bc294b7706d86ce(chkObj.trafficLightOverrideReason)) return false;
    if (typeof chkObj.additionalInformation !== "string") return false;
    if (typeof chkObj.type !== "string") return false;
    if (typeof chkObj.domain !== "string") return false;
    if (chkObj.releaseDate !== undefined && typeof chkObj.releaseDate !== "string") return false;
    if (chkObj.decommissionDate !== undefined && typeof chkObj.decommissionDate !== "string") return false;
    if (typeof chkObj.releaseStatus !== "string") return false;
    if (!Array.isArray(chkObj.relationships) || !chkObj.relationships.every($09941f3ecf59e8b0$export$6036fa85d2283ca1)) return false;
    if (typeof chkObj.isBackupVersion !== "boolean") return false;
    if (!Array.isArray(chkObj.hierarchyLinks) || !chkObj.hierarchyLinks.every($09941f3ecf59e8b0$export$492be82763901ee5)) return false;
    if (typeof chkObj.lastUpdatedFromHistory !== "string") return false;
    if (chkObj.tlfTags !== undefined && (!Array.isArray(chkObj.tlfTags) || !chkObj.tlfTags.every($09941f3ecf59e8b0$export$c8a4d7e3d2c1d67c))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("8U7rd", function(module, exports) {

$parcel$export(module.exports, "isTlfLinkLocation", function () { return $ff8a4135645616d0$export$5619526cd33ee992; });
parcelRequire("P0x5y");
var $8CFpa = parcelRequire("8CFpa");

var $7Wd8C = parcelRequire("7Wd8C");
const $ff8a4135645616d0$export$5619526cd33ee992 = (obj)=>{
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    return(// Check properties types
    typeof obj.linkHierarchyName === "string" && Object.values((0, $7Wd8C.eHierarchyLevel)).includes(obj.linkLevel) && // Check enums
    typeof obj.linkHierarchyId === "string" && typeof obj.linkLevel === "string" && obj.linkLevel in (0, $7Wd8C.eHierarchyLevel));
};

});




parcelRegister("6oN9f", function(module, exports) {

$parcel$export(module.exports, "toc_updateLastMajorVersionSavedAt", function () { return $68176c5449cfa3b4$export$f8b3ad4bc14ce61e; });
const $68176c5449cfa3b4$export$f8b3ad4bc14ce61e = (state, action)=>({
        ...state,
        lastMajorVersionSavedAt: action.savedTimeStamp.getTime()
    });

});

parcelRegister("bzDbj", function(module, exports) {

$parcel$export(module.exports, "toc_updateSearchText", function () { return $2ce2b2339d00d701$export$727702058c237c46; });
const $2ce2b2339d00d701$export$727702058c237c46 = (state, action)=>({
        ...state,
        searchText: action.searchText
    });

});

parcelRegister("f3Oq5", function(module, exports) {

$parcel$export(module.exports, "toc_updateSection", function () { return $f1bb1afce2271e90$export$66d92f1b4b43b1fb; });

var $bVMOy = parcelRequire("bVMOy");
const $f1bb1afce2271e90$export$66d92f1b4b43b1fb = (state, action)=>{
    const newState = {
        ...state
    };
    const index = newState.tocItems.findIndex((item)=>item.id === action.update.id && item instanceof (0, $bVMOy.MosaicTocSectionClass));
    /* istanbul ignore else -- callers only update sections that already exist in ToC state. */ if (index > -1) {
        const current = newState.tocItems[index];
        current.update(action.update);
        if (current.changed) newState.saving = true;
    }
    return newState;
};

});

parcelRegister("f6aTn", function(module, exports) {

$parcel$export(module.exports, "toc_updateTrafficLightsFilter", function () { return $475d510e71821b51$export$439c3f58c30be172; });
const $475d510e71821b51$export$439c3f58c30be172 = (state, action)=>({
        ...state,
        trafficLightsFilter: action.trafficLightFilter
    });

});

parcelRegister("93waG", function(module, exports) {

$parcel$export(module.exports, "toc_updateViewTiFo", function () { return $be5fbf579bf47237$export$abff13325407d3eb; });
const $be5fbf579bf47237$export$abff13325407d3eb = (state, action)=>({
        ...state,
        showTiFo: action.showTiFo
    });

});




parcelRegister("gD2t9", function(module, exports) {

$parcel$export(module.exports, "SignalRContext", function () { return $98a718f68180b564$export$f89226e2c0f985ba; });
$parcel$export(module.exports, "SignalRProvider", function () { return $98a718f68180b564$export$d9137f7c4ee47bfb; });

var $bbzbN = parcelRequire("bbzbN");

var $hGHEx = parcelRequire("hGHEx");
parcelRequire("P0x5y");
var $9eqKP = parcelRequire("9eqKP");

var $hWsmt = parcelRequire("hWsmt");

var $cJrIl = parcelRequire("cJrIl");

var $7fPBF = parcelRequire("7fPBF");

var $7ntzw = parcelRequire("7ntzw");
const $98a718f68180b564$export$f89226e2c0f985ba = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $98a718f68180b564$export$d9137f7c4ee47bfb = ({ children: children })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const [connection, setConnection] = (0, $7fPBF.useState)(null);
    const [joinGroupList, setJoinGroupList] = (0, $7fPBF.useState)(new Set());
    const [groups, setGroups] = (0, $7fPBF.useState)(new Set());
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    const MAX_SIGNALR_CONNECTION_ATTEMPTS = 3;
    // Max is 32K, however we still get errors as 32000, so reducing further
    const MAX_SIGNALR_MESSAGE_LENGTH = 28000;
    const [isConnecting, setIsConnecting] = (0, $7fPBF.useState)(false);
    const [connectionAttempts, setConnectionAttempts] = (0, $7fPBF.useState)(0);
    /**
   * Connect to SignalR hub asynchronously.
   */ const connectToHubAsync = (0, $7fPBF.useEffectEvent)(async ()=>{
        /* istanbul ignore else */ if (appSettings.appSettingsLoaded && appSettings.displayName && (!connection || connection.state === (0, $hGHEx.HubConnectionState).Disconnected)) try {
            setIsConnecting(true);
            setConnectionAttempts(connectionAttempts + 1);
            const connection = await (0, $7ntzw.connectToHub)(`${appSettings.backEndUrl}hubs/notifications`);
            setConnection(connection);
            /**
         * Processes incoming SignalR messages and updates group membership.
         *
         * @param message - The message string to process
         */ const processSignalRMessage = (message)=>{
                const messageDetails = JSON.parse(message);
                if (connection && messageDetails.displayName === connection.connectionId) return;
                console.debug("Received message from group:", messageDetails.groupName, messageDetails);
                if (messageDetails.messageType === "joinGroup") {
                    setGroups((prev)=>new Set(prev).add(messageDetails.groupName));
                    return;
                }
            };
            if (connection && connection.state === (0, $hGHEx.HubConnectionState).Connected) connection.on("SendMessageToGroup", processSignalRMessage);
        } catch (error) {
            /* istanbul ignore next */ console.warn("Error starting SignalR:", error);
        } finally{
            setIsConnecting(false);
        }
    });
    /**
   * Check message size before sending to the group, then add the message to the list of sent messages.
   * @param message Message to send
   * @param groupName Name of the group to send the message to
   */ const checkBeforeSendToGroup = (0, $7fPBF.useCallback)(async (message, groupName)=>{
        /* istanbul ignore else */ if (connection) {
            message.displayName = connection.connectionId;
            const len = JSON.stringify(message).length;
            if (len > MAX_SIGNALR_MESSAGE_LENGTH) {
                message.messageType = "tooBig";
                message.text = [
                    "{}"
                ];
            }
            console.debug("Sending message ", message.messageId, "to group:", groupName, " from:", message.displayName, " - ", connection.connectionId);
            // Wait before sending to allow for state updates
            // Wait for the connection to be connected before invoking.
            /**
         * Wait until the given HubConnection reaches `Connected` state or the timeout expires.
         *
         * @param conn - HubConnection to wait for
         * @param timeout - Timeout in milliseconds
         * @returns true if connected within timeout, false otherwise
         */ const waitForConnected = async (conn, timeout = 2000)=>{
                const start = Date.now();
                while(conn.state !== (0, $hGHEx.HubConnectionState).Connected && Date.now() - start < timeout)await new Promise((r)=>setTimeout(r, 25));
                return conn.state === (0, $hGHEx.HubConnectionState).Connected;
            };
            try {
                const ready = await waitForConnected(connection);
                /* istanbul ignore next */ if (!ready) {
                    console.warn("Connection not ready to send message");
                    return;
                }
                await connection.invoke("SendMessageToGroup", JSON.stringify(message), groupName);
            } catch (err) {
                console.warn("Error sending message to group!", err);
                console.group("Message to group failed");
                console.warn("Message length: ", JSON.stringify(message).length);
                console.warn("Message: ", message);
                console.groupEnd();
            }
        }
    }, [
        connection
    ]);
    /**
   * Send a message to a specific group.
   * @param message The message to send
   * @param groupName The name of the group to send the message to
   * @param messageType The type of the message, defaults to "message"
   * @returns A promise that resolves when the message is sent
   */ const sendMessageToGroup = (0, $7fPBF.useCallback)(async (message, groupName, messageType)=>{
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: messageType,
            text: message.split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Send a Table of Contents (ToC) update to a specific group.
   * @param actionSignal The ToC action signal containing the update details
   * @param groupName The name of the group to send the update to
   * @returns A promise that resolves to the HubGroupMessage sent
   */ const sendTocUpdateToGroup = (0, $7fPBF.useCallback)(async (actionSignal, groupName)=>{
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: "tocUpdate",
            text: JSON.stringify(actionSignal).split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
        return newMessage;
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Send a TLF (Table of Contents) update to a specific group.
   * @param actionSignal The TLF update action signal containing the update details
   * @param groupName The name of the group to send the update to
   * @returns A promise that resolves to the HubGroupMessage sent
   */ const sendTlfUpdateToGroup = (0, $7fPBF.useCallback)(async (actionSignal, groupName)=>{
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: "tlfUpdate",
            text: JSON.stringify(actionSignal).split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
        return newMessage;
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Send a Table of Contents (ToC) save to a specific group.
   * @param saveSignal The ToC save signal containing the new hierarchy
   * @param groupName The name of the group to send the save to
   * @returns A promise that resolves to the HubGroupMessage sent
   */ const sendTocSaveToGroup = (0, $7fPBF.useCallback)(async (saveSignal, groupName)=>{
        const tocAction = {
            hierarchy: saveSignal.newHierarchy,
            items: []
        };
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: "tocSave",
            text: JSON.stringify(tocAction).split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
        return newMessage;
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Connect to a SignalR group.
   * @param group Name of the group to connect to
   * @returns A promise that resolves when the connection is established
   */ const connectToGroup = (0, $7fPBF.useCallback)(async (newGroup)=>{
        /* istanbul ignore else */ if (connection && !groups.has(newGroup) && !joinGroupList.has(newGroup)) {
            await connection.invoke("JoinGroup", newGroup, `${appSettings.displayName}~${connection.connectionId}`);
            startTransition(()=>setJoinGroupList((prev)=>new Set(prev).add(newGroup)));
            console.debug("Joining group:", newGroup);
        }
    }, [
        appSettings.displayName,
        connection,
        groups,
        joinGroupList
    ]);
    /**
   * Effect to connect to SignalR hub when displayName changes or connection is disconnected.
   */ (0, $7fPBF.useEffect)(()=>{
        if ((!connection || connection.state === (0, $hGHEx.HubConnectionState).Disconnected) && !isConnecting && connectionAttempts < MAX_SIGNALR_CONNECTION_ATTEMPTS && !pending) startTransition(()=>connectToHubAsync());
    }, [
        appSettings.displayName,
        connection,
        connectionAttempts,
        isConnecting,
        pending
    ]);
    return connectionAttempts >= MAX_SIGNALR_CONNECTION_ATTEMPTS ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cJrIl.default), {}) : !connection || connection.state !== (0, $hGHEx.HubConnectionState).Connected ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
        text: "Connecting to the server"
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)($98a718f68180b564$export$f89226e2c0f985ba.Provider, {
        value: {
            connectToGroup: connectToGroup,
            connection: connection,
            groups: groups,
            joinGroupList: joinGroupList,
            sendMessageToGroup: sendMessageToGroup,
            sendTlfUpdateToGroup: sendTlfUpdateToGroup,
            sendTocSaveToGroup: sendTocSaveToGroup,
            sendTocUpdateToGroup: sendTocUpdateToGroup
        },
        children: children
    });
};
$98a718f68180b564$export$d9137f7c4ee47bfb.displayName = "SignalRProvider";

});
parcelRegister("cJrIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4784178e4102bc33$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $frJ3w = parcelRequire("frJ3w");

var $5Q4M4 = parcelRequire("5Q4M4");

var $4PTZu = parcelRequire("4PTZu");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");
const $4784178e4102bc33$export$e6dcbb50012c752c = ()=>{
    const maintenanceCassette = "/maintenance-cassette.jpg";
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $4PTZu.useUnsavedChanges)("server-down-page");
    (0, $7fPBF.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Q4M4.TopBar), {
                title: "Server unavailable",
                showUser: false
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                            className: "d-flex justify-content-center",
                            xs: {
                                offset: 2,
                                span: 4
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                                src: maintenanceCassette,
                                alt: "Server unavailable",
                                title: "Server unavailable",
                                width: "400",
                                height: "300"
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                            xs: 4,
                            className: "d-flex justify-content-center align-items-center",
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("h5", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        children: "Sorry, the MOSAIC\xa0Biometrics server is not responding"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        children: "Try again later"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "d-flex justify-content-center mt-3",
                                        children: "\u2639"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $frJ3w.BottomNav), {})
        ]
    });
};
$4784178e4102bc33$export$e6dcbb50012c752c.displayName = "ServerDownPage";
var $4784178e4102bc33$export$2e2bcd8739ae039 = $4784178e4102bc33$export$e6dcbb50012c752c;

});
parcelRegister("frJ3w", function(module, exports) {

$parcel$export(module.exports, "BottomNav", function () { return $598ece0920e8f6f3$export$b77dc13a7753f3ee; });

var $bbzbN = parcelRequire("bbzbN");

var $VvTgq = parcelRequire("VvTgq");

var $hWsmt = parcelRequire("hWsmt");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");
var $k78S3 = parcelRequire("k78S3");

var $fQX2L = parcelRequire("fQX2L");

var $27CYn = parcelRequire("27CYn");
const $598ece0920e8f6f3$export$b77dc13a7753f3ee = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const [showInfo, setShowInfo] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $k78S3.default), {
        variant: "dark",
        bg: "dark",
        style: {
            padding: 0
        },
        fixed: "bottom",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                fluid: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $k78S3.default).Text, {
                    className: "d-flex gap-2 align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("small", {
                            id: "bottomnav-versions",
                            children: [
                                "mbfe",
                                " ",
                                "6.0.0.57",
                                " / ",
                                appSettings.backEndVersion
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fQX2L.default), {
                            id: "bottomnav-info",
                            "aria-label": "Show information panel",
                            onClick: ()=>setShowInfo(!showInfo)
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $VvTgq.ConnectionStatus), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $27CYn.BottomNavInfoModal), {
                show: showInfo,
                setShow: setShowInfo
            })
        ]
    });
};
$598ece0920e8f6f3$export$b77dc13a7753f3ee.displayName = "BottomNav";

});
parcelRegister("VvTgq", function(module, exports) {

$parcel$export(module.exports, "ConnectionStatus", function () { return $5eb078be48fe138c$export$7516420eb880ab68; });

var $bbzbN = parcelRequire("bbzbN");

var $hGHEx = parcelRequire("hGHEx");
parcelRequire("P0x5y");
var $cqVqv = parcelRequire("cqVqv");

var $gD2t9 = parcelRequire("gD2t9");

var $7fPBF = parcelRequire("7fPBF");

var $XNShw = parcelRequire("XNShw");

var $1iMwk = parcelRequire("1iMwk");
const $5eb078be48fe138c$export$7516420eb880ab68 = ()=>{
    const signalR = (0, $7fPBF.useContext)((0, $gD2t9.SignalRContext));
    const connection = signalR?.connection;
    const groups = signalR?.groups;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $XNShw.default), {
        className: (0, $cqVqv.classMerge)([
            connection?.state === (0, $hGHEx.HubConnectionState).Connected ? (0, (/*@__PURE__*/$parcel$interopDefault($1iMwk))).connected : (0, (/*@__PURE__*/$parcel$interopDefault($1iMwk))).notConnected
        ]),
        title: `Connection status: ${connection?.state === (0, $hGHEx.HubConnectionState).Connected ? "Connected" : "Not connected"}` + `\n${Array.from(groups ?? []).join(",\n")}`
    });
};
$5eb078be48fe138c$export$7516420eb880ab68.displayName = "ConnectionStatus";

});
parcelRegister("XNShw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b3c32d77deb5ba2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $0b3c32d77deb5ba2$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $0b3c32d77deb5ba2$var$_extends() {
    return $0b3c32d77deb5ba2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0b3c32d77deb5ba2$var$_extends.apply(null, arguments);
}
function $0b3c32d77deb5ba2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0b3c32d77deb5ba2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0b3c32d77deb5ba2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0b3c32d77deb5ba2$var$CircleFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $0b3c32d77deb5ba2$var$_objectWithoutProperties(_ref, $0b3c32d77deb5ba2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $0b3c32d77deb5ba2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "8"
    }));
});
$0b3c32d77deb5ba2$var$CircleFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0b3c32d77deb5ba2$export$2e2bcd8739ae039 = $0b3c32d77deb5ba2$var$CircleFill;

});

parcelRegister("1iMwk", function(module, exports) {

$parcel$export(module.exports, "connected", function () { return $0f2d1c05eb7a8f1d$export$179c556db9c9a30f; }, function (v) { return $0f2d1c05eb7a8f1d$export$179c556db9c9a30f = v; });
$parcel$export(module.exports, "notConnected", function () { return $0f2d1c05eb7a8f1d$export$e0a79238d4dc4fc8; }, function (v) { return $0f2d1c05eb7a8f1d$export$e0a79238d4dc4fc8 = v; });
var $0f2d1c05eb7a8f1d$export$179c556db9c9a30f;
var $0f2d1c05eb7a8f1d$export$e0a79238d4dc4fc8;
$0f2d1c05eb7a8f1d$export$179c556db9c9a30f = `mos-ConnectionStatus-module-iSGICq-connected`;
$0f2d1c05eb7a8f1d$export$e0a79238d4dc4fc8 = `mos-ConnectionStatus-module-iSGICq-notConnected`;

});


parcelRegister("k78S3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea4b57a4f3e792c5$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $cpnTQ = parcelRequire("cpnTQ");
parcelRequire("ecgdb");
var $9GY4V = parcelRequire("9GY4V");

var $crg1b = parcelRequire("crg1b");

var $baVCj = parcelRequire("baVCj");

var $cAaSE = parcelRequire("cAaSE");

var $1Bdup = parcelRequire("1Bdup");

var $jbn4d = parcelRequire("jbn4d");

var $2VW10 = parcelRequire("2VW10");

var $5M3sM = parcelRequire("5M3sM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $ea4b57a4f3e792c5$var$Navbar = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $9GY4V.default)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $jbn4d.useBootstrapPrefix)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $7fPBF.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $7fPBF.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2VW10.default).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cpnTQ.default).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$ea4b57a4f3e792c5$var$Navbar.displayName = 'Navbar';
var $ea4b57a4f3e792c5$export$2e2bcd8739ae039 = Object.assign($ea4b57a4f3e792c5$var$Navbar, {
    Brand: (0, $crg1b.default),
    Collapse: (0, $baVCj.default),
    Offcanvas: (0, $1Bdup.default),
    Text: (0, $5M3sM.default),
    Toggle: (0, $cAaSE.default)
});

});
parcelRegister("crg1b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90e46e7ffe942099$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $90e46e7ffe942099$var$NavbarBrand = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix)
    });
});
$90e46e7ffe942099$var$NavbarBrand.displayName = 'NavbarBrand';
var $90e46e7ffe942099$export$2e2bcd8739ae039 = $90e46e7ffe942099$var$NavbarBrand;

});

parcelRegister("baVCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $822d5261e05d4e33$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $euDav = parcelRequire("euDav");

var $jbn4d = parcelRequire("jbn4d");

var $2VW10 = parcelRequire("2VW10");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $822d5261e05d4e33$var$NavbarCollapse = /*#__PURE__*/ $7fPBF.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
    const context = (0, $7fPBF.useContext)((0, $2VW10.default));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $euDav.default), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$822d5261e05d4e33$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $822d5261e05d4e33$export$2e2bcd8739ae039 = $822d5261e05d4e33$var$NavbarCollapse;

});

parcelRegister("cAaSE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9291497526a3ecdb$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbhqg = parcelRequire("jbhqg");

var $jbn4d = parcelRequire("jbn4d");

var $2VW10 = parcelRequire("2VW10");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $9291497526a3ecdb$var$NavbarToggle = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $7fPBF.useContext)((0, $2VW10.default)) || {};
    const handleClick = (0, $jbhqg.default)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$9291497526a3ecdb$var$NavbarToggle.displayName = 'NavbarToggle';
var $9291497526a3ecdb$export$2e2bcd8739ae039 = $9291497526a3ecdb$var$NavbarToggle;

});

parcelRegister("1Bdup", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12a3b5dea9b425bd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jbhqg = parcelRequire("jbhqg");

var $aQsQo = parcelRequire("aQsQo");

var $2VW10 = parcelRequire("2VW10");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $12a3b5dea9b425bd$var$NavbarOffcanvas = /*#__PURE__*/ $7fPBF.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $7fPBF.useContext)((0, $2VW10.default));
    const handleHide = (0, $jbhqg.default)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$12a3b5dea9b425bd$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $12a3b5dea9b425bd$export$2e2bcd8739ae039 = $12a3b5dea9b425bd$var$NavbarOffcanvas;

});

parcelRegister("5M3sM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43441f23c200b0a1$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $43441f23c200b0a1$var$NavbarText = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$43441f23c200b0a1$var$NavbarText.displayName = 'NavbarText';
var $43441f23c200b0a1$export$2e2bcd8739ae039 = $43441f23c200b0a1$var$NavbarText;

});


parcelRegister("fQX2L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8a9832ddd80c66b$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $b8a9832ddd80c66b$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $b8a9832ddd80c66b$var$_extends() {
    return $b8a9832ddd80c66b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b8a9832ddd80c66b$var$_extends.apply(null, arguments);
}
function $b8a9832ddd80c66b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b8a9832ddd80c66b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b8a9832ddd80c66b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b8a9832ddd80c66b$var$InfoCircle = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $b8a9832ddd80c66b$var$_objectWithoutProperties(_ref, $b8a9832ddd80c66b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $b8a9832ddd80c66b$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-info-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$b8a9832ddd80c66b$var$InfoCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $b8a9832ddd80c66b$export$2e2bcd8739ae039 = $b8a9832ddd80c66b$var$InfoCircle;

});

parcelRegister("27CYn", function(module, exports) {

$parcel$export(module.exports, "BottomNavInfoModal", function () { return $9f4757191776a144$export$5249b5f981c8cfd5; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $d8uJi = parcelRequire("d8uJi");
var $kYoG1 = parcelRequire("kYoG1");

var $dRarR = parcelRequire("dRarR");
const $9f4757191776a144$export$5249b5f981c8cfd5 = ({ show: show, setShow: setShow })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default), {
        id: "bottomnav-info-modal",
        show: show,
        onHide: ()=>setShow(false),
        size: "lg",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                        children: "Developer information panel"
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                                children: [
                                    "Application version: ",
                                    "mbfe",
                                    " ",
                                    "6.0.0.57"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                                children: [
                                    "Stage: ",
                                    (0, $dRarR.REACT_APP_STAGE)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                                children: [
                                    "Backend URL: ",
                                    appSettings.backEndUrl
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                                children: [
                                    "Backend versions: ",
                                    appSettings.backEndVersion
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                                children: [
                                    "Application permissions:",
                                    appSettings.isAdmin ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                            className: "mx-3",
                                            children: "Admin"
                                        })
                                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}),
                                    appSettings.applicationPermissions.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                            className: "mx-3",
                                            children: "No permissions assigned"
                                        })
                                    }) : appSettings.applicationPermissions.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "mx-3",
                                                children: p
                                            })
                                        }, p))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    id: "hierarchy-context-info"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    id: "toc-context-info"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    id: "tlf-context-info"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$9f4757191776a144$export$5249b5f981c8cfd5.displayName = "BottomNavInfoModal";

});


parcelRegister("5Q4M4", function(module, exports) {

$parcel$export(module.exports, "TopBar", function () { return $4c9dc5a887b4f37d$export$c4e96258f3b6511; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $cqVqv = parcelRequire("cqVqv");

var $lR1Mh = parcelRequire("lR1Mh");

var $hWsmt = parcelRequire("hWsmt");

var $4PTZu = parcelRequire("4PTZu");

var $jTidw = parcelRequire("jTidw");

var $30qK6 = parcelRequire("30qK6");

var $joxdZ = parcelRequire("joxdZ");

var $5Pwtv = parcelRequire("5Pwtv");

var $ICooD = parcelRequire("ICooD");

const $4c9dc5a887b4f37d$export$c4e96258f3b6511 = ({ title: title, fileEntry: fileEntry, settingsEntry: settingsEntry, showUser: showUser = true })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const logo = new URL((parcelRequire("2Sbgo")));
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("top-bar");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).grid,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).gridBrandCell,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).brandHolder,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).brandBackgroud,
                        id: "topbar-brand",
                        onClick: ()=>navigate("/"),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            src: logo.href,
                            alt: "Mosaic logo",
                            title: "Mosaic logo",
                            width: "214",
                            height: "63"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                id: "topbar-top-row",
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).gridRowOne,
                    "bg-light"
                ]),
                children: [
                    !appSettings.maintenanceMode && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).menuHolder,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $30qK6.NewItemDropMenu), {
                                fileEntry: fileEntry
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Pwtv.SettingsDropMenu), {
                                settingsEntry: settingsEntry
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        id: "topbar-title",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).center,
                        title: title,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: (0, $cqVqv.classMerge)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).titleText,
                                    "text-dark",
                                    "fw-bold"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lR1Mh.TocSaveIndicator), {})
                        ]
                    }),
                    showUser && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $joxdZ.RightDropMenu), {})
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).gridRowTwo,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jTidw.HierarchyCrumbs), {})
            })
        ]
    });
};
$4c9dc5a887b4f37d$export$c4e96258f3b6511.displayName = "TopBar";

});
parcelRegister("lR1Mh", function(module, exports) {

$parcel$export(module.exports, "TocSaveIndicator", function () { return $865fa170f8c7a7fc$export$46c00358fae4df76; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $7fPBF = parcelRequire("7fPBF");

var $is84V = parcelRequire("is84V");

const $865fa170f8c7a7fc$export$46c00358fae4df76 = ()=>{
    const { state: state } = (0, $hWsmt.useTocContext)();
    const [showIndicator, setShowIndicator] = (0, $7fPBF.useState)(false);
    const lastTriggeredAtRef = (0, $7fPBF.useRef)(null);
    const hideTimerRef = (0, $7fPBF.useRef)(null);
    const triggerTimerRef = (0, $7fPBF.useRef)(null);
    /**
   * Trigger the indicator in response to an external event.
   * Scheduled from an effect via a timer to avoid synchronous setState.
   */ const triggerIndicator = (0, $7fPBF.useEffectEvent)(()=>{
        setShowIndicator(true);
        // Clear any previous hide timers and schedule dismissal in 2 seconds
        if (hideTimerRef.current !== null) clearTimeout(hideTimerRef.current);
        hideTimerRef.current = window.setTimeout(()=>{
            setShowIndicator(false);
            hideTimerRef.current = null;
        }, 2000);
    });
    (0, $7fPBF.useEffect)(()=>{
        // React to a successful save completion timestamp rather than version maths
        if (state.sendUpdate && !state.saveError && state.lastMinorVersionSavedAt !== null && state.lastMinorVersionSavedAt !== undefined) {
            const prev = lastTriggeredAtRef.current;
            const hasChanged = prev !== state.lastMinorVersionSavedAt;
            // Trigger on every new save timestamp to restart the 2-second flash
            if (hasChanged) {
                lastTriggeredAtRef.current = state.lastMinorVersionSavedAt;
                // Clear any previous trigger timer
                if (triggerTimerRef.current !== null) clearTimeout(triggerTimerRef.current);
                // Schedule indicator update asynchronously to avoid React warning about synchronous setState in effect
                triggerTimerRef.current = window.setTimeout(()=>{
                    triggerIndicator();
                    triggerTimerRef.current = null;
                }, 0);
            }
        }
    }, [
        state.lastMinorVersionSavedAt,
        state.sendUpdate,
        state.saveError
    ]);
    // Cleanup timers on unmount
    (0, $7fPBF.useEffect)(()=>()=>{
            if (triggerTimerRef.current !== null) clearTimeout(triggerTimerRef.current);
            if (hideTimerRef.current !== null) clearTimeout(hideTimerRef.current);
        }, []);
    return showIndicator && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "toc-save-indicator",
        title: "TOC saved",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $is84V.default), {
            className: "save-icon-flash toc-save-icon",
            size: 16
        })
    });
};
$865fa170f8c7a7fc$export$46c00358fae4df76.displayName = "TocSaveIndicator";

});
parcelRegister("is84V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6f11bb959042593$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $d6f11bb959042593$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $d6f11bb959042593$var$_extends() {
    return $d6f11bb959042593$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d6f11bb959042593$var$_extends.apply(null, arguments);
}
function $d6f11bb959042593$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $d6f11bb959042593$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $d6f11bb959042593$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $d6f11bb959042593$var$FloppyFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $d6f11bb959042593$var$_objectWithoutProperties(_ref, $d6f11bb959042593$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $d6f11bb959042593$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-floppy-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M0 1.5A1.5 1.5 0 0 1 1.5 0H3v5.5A1.5 1.5 0 0 0 4.5 7h7A1.5 1.5 0 0 0 13 5.5V0h.086a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5H14v-5.5A1.5 1.5 0 0 0 12.5 9h-9A1.5 1.5 0 0 0 2 10.5V16h-.5A1.5 1.5 0 0 1 0 14.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M3 16h10v-5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5zm9-16H4v5.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5zM9 1h2v4H9z"
    }));
});
$d6f11bb959042593$var$FloppyFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $d6f11bb959042593$export$2e2bcd8739ae039 = $d6f11bb959042593$var$FloppyFill;

});


parcelRegister("jTidw", function(module, exports) {

$parcel$export(module.exports, "HierarchyCrumbs", function () { return $147e8239c729eb1c$export$37236bf3d3d32cd7; });

var $bbzbN = parcelRequire("bbzbN");

var $j96Rr = parcelRequire("j96Rr");

var $aLtkT = parcelRequire("aLtkT");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $9BAl1 = parcelRequire("9BAl1");

var $7fPBF = parcelRequire("7fPBF");

var $1Uu59 = parcelRequire("1Uu59");

var $5FdgL = parcelRequire("5FdgL");
const $147e8239c729eb1c$export$37236bf3d3d32cd7 = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const breadcrumbRef = (0, $7fPBF.useRef)(null);
    const [fullWidth, setFullWidth] = (0, $7fPBF.useState)(0);
    const [measuredNodes, setMeasuredNodes] = (0, $7fPBF.useState)(0);
    const [hideTree, setHideTree] = (0, $7fPBF.useState)(false);
    const hierarchies = (0, $7fPBF.useMemo)(()=>hierarchyContext && hierarchyContext.hierarchy ? [
            hierarchyContext.hierarchy,
            ...(0, $9BAl1.getThisAndParentHierarchies)(hierarchyContext.hierarchy.parentId, hierarchyContext.hierarchyNodes)
        ].map((h)=>({
                name: h.name,
                id: h.id,
                url: (0, $wPq5H.getHierarchyBaseUrl)(h)
            })).reverse() : [], [
        hierarchyContext
    ]);
    // Get expanded size
    (0, $7fPBF.useEffect)(()=>{
        const breadcrumb = breadcrumbRef.current;
        const container = breadcrumb?.parentElement;
        if (breadcrumb && container && !hideTree && (measuredNodes !== hierarchies.length || fullWidth === 0)) {
            // Get max width
            setFullWidth(breadcrumb.offsetWidth);
            setMeasuredNodes(hierarchies.length);
        }
    }, [
        fullWidth,
        hideTree,
        hierarchies.length,
        measuredNodes
    ]);
    // Add resize observer
    (0, $7fPBF.useEffect)(()=>{
        // Get parent element (which changes size with document)
        const container = breadcrumbRef.current?.parentElement;
        if (container && fullWidth) {
            // Set resize observer to check for overflow
            /**
       * Check container width and toggle compact breadcrumb mode when necessary.
       */ const checkContainerSize = ()=>{
                setHideTree(container.offsetWidth < fullWidth + 40);
            };
            const resizeObserver = new ResizeObserver(checkContainerSize);
            resizeObserver.observe(container);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        fullWidth
    ]);
    return !hierarchyContext?.hierarchy ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $1Uu59.default), {
        ref: breadcrumbRef,
        className: "text-nowrap d-block",
        children: [
            hideTree && hierarchies.length >= 2 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1Uu59.default).Item, {
                id: `breadcrumbs-up`,
                linkAs: (0, $j96Rr.ActiveNavLink),
                linkProps: {
                    to: `${hierarchies[hierarchies.length - 2].url}`,
                    end: true
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5FdgL.default), {})
            }, `breadcrumbs-up`),
            hierarchies.slice(hideTree ? hierarchies.length - 1 : 0).map((hierarchy)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $1Uu59.default).Item, {
                    id: `breadcrumbs-${hierarchy.name}`,
                    linkAs: (0, $j96Rr.ActiveNavLink),
                    linkProps: {
                        to: `${hierarchy.url}`,
                        end: true
                    },
                    children: hierarchy.name
                }, hierarchy.id)),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aLtkT.CommentPanel), {
                activeContext: "Hierarchy"
            })
        ]
    });
};
$147e8239c729eb1c$export$37236bf3d3d32cd7.displayName = "HierarchyCrumbs";

});
parcelRegister("j96Rr", function(module, exports) {

$parcel$export(module.exports, "ActiveNavLink", function () { return $c7c9fb35240856f5$export$7c1c44d1ec04feb2; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $9eqKP = parcelRequire("9eqKP");

var $4PTZu = parcelRequire("4PTZu");

var $gxpCl = parcelRequire("gxpCl");
const $c7c9fb35240856f5$export$7c1c44d1ec04feb2 = (props)=>{
    const { navigate: navigate, isLoading: isLoading } = (0, $4PTZu.useUnsavedChanges)(props.to.toString());
    const location = (0, $gxpCl.useLocation)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "position-relative overflow-hidden",
        children: [
            isLoading === props.to.toString() && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxpCl.NavLink), {
                ...props,
                style: ({ isActive: isActive })=>isActive ? {
                        color: "black",
                        textDecorationLine: "none",
                        cursor: "default"
                    } : {},
                to: props.to,
                end: true,
                onClick: (e)=>{
                    if (e.ctrlKey || e.metaKey || e.button === 1 || e.shiftKey) return; // Allow default behavior for these keys
                    e.preventDefault();
                    e.stopPropagation();
                    if (props.to !== location.pathname) navigate(props.to);
                }
            })
        ]
    });
};
$c7c9fb35240856f5$export$7c1c44d1ec04feb2.displayName = "ActiveNavLink";

});

parcelRegister("aLtkT", function(module, exports) {

$parcel$export(module.exports, "CommentPanelInner", function () { return $f7f14ce43e3b71be$export$f90eb0df6f6898f7; });
$parcel$export(module.exports, "CommentPanel", function () { return $f7f14ce43e3b71be$export$ec8595c232deccb9; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $9eqKP = parcelRequire("9eqKP");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $aQsQo = parcelRequire("aQsQo");
var $kYoG1 = parcelRequire("kYoG1");

var $dA3cL = parcelRequire("dA3cL");
var $jLslC = parcelRequire("jLslC");

var $gxpCl = parcelRequire("gxpCl");

var $aeivC = parcelRequire("aeivC");

var $i2RS8 = parcelRequire("i2RS8");


var $19cj4 = parcelRequire("19cj4");

var $e2aoo = parcelRequire("e2aoo");

var $fcUCK = parcelRequire("fcUCK");

var $5jw83 = parcelRequire("5jw83");

var $5aJa3 = parcelRequire("5aJa3");

var $jIznr = parcelRequire("jIznr");
const $f7f14ce43e3b71be$export$f90eb0df6f6898f7 = ({ activeContext: activeContext })=>{
    // Get contexts
    const { isSubscribed: isSubscribed, toggleCommentsSubscription: toggleCommentsSubscription, toggleCommentsSubscriptionRequest: toggleSubscriptionStatusRequest } = (0, $jIznr.useComments)(activeContext);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "comment-button-header-panel d-flex flex-row justify-content-between",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e2aoo.CreateCommentButton), {
                                activeContext: activeContext
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "d-flex justify-content-end",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $19cj4.CommentSubscriptionButton), {
                                        toggleCommentsSubscription: toggleCommentsSubscription,
                                        isSubscribed: isSubscribed,
                                        toggleSubscriptionStatusRequest: toggleSubscriptionStatusRequest
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fcUCK.ResolveAllCommentsButton), {
                                        activeContext: activeContext
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aeivC.CommentFilter), {
                        activeContext: activeContext
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $i2RS8.CommentThreads), {
                        activeContext: activeContext
                    })
                })
            })
        ]
    });
};
$f7f14ce43e3b71be$export$f90eb0df6f6898f7.displayName = "CommentPanelInner";
/**
 * Icon for the comment button. Filled variant when comments exist.
 *
 * @param props - Component props.
 * @param props.anyComments - When true, show the filled icon.
 */ const $f7f14ce43e3b71be$var$CommentIcon = (props)=>{
    return props.anyComments ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jLslC.default), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dA3cL.default), {});
};
$f7f14ce43e3b71be$var$CommentIcon.displayName = "CommentIcon";
const $f7f14ce43e3b71be$export$ec8595c232deccb9 = ({ activeContext: activeContext, asButton: asButton = false, disabled: disabled })=>{
    // Get contexts
    const { comments: comments, commentPanelStatus: commentPanelStatus, setCommentPanelStatus: setCommentPanelStatus, title: title } = (0, $jIznr.useComments)(activeContext);
    const location = (0, $gxpCl.useLocation)();
    const isDisabled = disabled ?? false;
    // Component render
    return !comments || !commentPanelStatus || !setCommentPanelStatus ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            asButton ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                id: "tlf-comments-button",
                "aria-label": title,
                variant: "primary",
                size: "sm",
                className: "d-flex align-items-center gap-2",
                disabled: isDisabled,
                title: isDisabled ? (0, $5jw83.NEW_TLF_COMMENT_TOOLTIP) : undefined,
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setCommentPanelStatus({
                        ...commentPanelStatus,
                        showComments: !commentPanelStatus.showComments
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($f7f14ce43e3b71be$var$CommentIcon, {
                        anyComments: comments.length > 0
                    }),
                    title
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "comment-panel-button align-self-start ms-2",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setCommentPanelStatus({
                        ...commentPanelStatus,
                        showComments: !commentPanelStatus.showComments
                    });
                },
                "aria-label": title,
                title: title,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($f7f14ce43e3b71be$var$CommentIcon, {
                    anyComments: comments.length > 0
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aQsQo.default), {
                show: commentPanelStatus.showComments,
                placement: "end",
                onHide: ()=>setCommentPanelStatus({
                        ...commentPanelStatus,
                        showComments: false
                    }),
                backdrop: false,
                scroll: true,
                children: [
                    (0, $5aJa3.isRedirectingFromNotifications)(location.search) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                        text: "Redirecting to comment..."
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Header, {
                        closeButton: true,
                        className: "comments-offcanvas-header",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Title, {
                            className: "comments-offcanvas-title me-2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Body, {
                        className: "comments-offcanvas-body",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($f7f14ce43e3b71be$export$f90eb0df6f6898f7, {
                            activeContext: activeContext
                        })
                    })
                ]
            })
        ]
    });
};
$f7f14ce43e3b71be$export$ec8595c232deccb9.displayName = "CommentPanel";

});
parcelRegister("dA3cL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e311f939fa66fbd$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $9e311f939fa66fbd$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $9e311f939fa66fbd$var$_extends() {
    return $9e311f939fa66fbd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9e311f939fa66fbd$var$_extends.apply(null, arguments);
}
function $9e311f939fa66fbd$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $9e311f939fa66fbd$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $9e311f939fa66fbd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $9e311f939fa66fbd$var$ChatLeftDots = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $9e311f939fa66fbd$var$_objectWithoutProperties(_ref, $9e311f939fa66fbd$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $9e311f939fa66fbd$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chat-left-dots',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$9e311f939fa66fbd$var$ChatLeftDots.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $9e311f939fa66fbd$export$2e2bcd8739ae039 = $9e311f939fa66fbd$var$ChatLeftDots;

});

parcelRegister("jLslC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e63865599fea0961$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $e63865599fea0961$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $e63865599fea0961$var$_extends() {
    return $e63865599fea0961$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e63865599fea0961$var$_extends.apply(null, arguments);
}
function $e63865599fea0961$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e63865599fea0961$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e63865599fea0961$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e63865599fea0961$var$ChatLeftDotsFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $e63865599fea0961$var$_objectWithoutProperties(_ref, $e63865599fea0961$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $e63865599fea0961$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chat-left-dots-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }));
});
$e63865599fea0961$var$ChatLeftDotsFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $e63865599fea0961$export$2e2bcd8739ae039 = $e63865599fea0961$var$ChatLeftDotsFill;

});

parcelRegister("aeivC", function(module, exports) {

$parcel$export(module.exports, "CommentFilter", function () { return $9446271f8d8c246d$export$deea89e42080a68; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $isQD0 = parcelRequire("isQD0");

var $jIznr = parcelRequire("jIznr");
const $9446271f8d8c246d$export$ff651bac85597a6d = [
    {
        value: "all",
        label: "All Comments"
    },
    {
        value: "resolved",
        label: "Resolved Comments Only"
    },
    {
        value: "open",
        label: "Open Comments Only"
    }
];
const $9446271f8d8c246d$export$deea89e42080a68 = ({ activeContext: activeContext })=>{
    const { commentFilter: commentFilter, setCommentFilter: setCommentFilter } = (0, $jIznr.useComments)(activeContext);
    return !setCommentFilter ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
        id: "toc-comment-filter",
        label: "Comment filter",
        labelWidth: "auto",
        value: commentFilter,
        options: $9446271f8d8c246d$export$ff651bac85597a6d,
        setValue: (ret)=>{
            setCommentFilter(ret);
        }
    });
};
$9446271f8d8c246d$export$deea89e42080a68.displayName = "CommentFilter";

});
parcelRegister("jIznr", function(module, exports) {

$parcel$export(module.exports, "useComments", function () { return $6f16e1a11c374bc7$export$80ad823ea511ef0f; });
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $9Jgpw = parcelRequire("9Jgpw");

var $gD2t9 = parcelRequire("gD2t9");

var $dDC3L = parcelRequire("dDC3L");

var $6E9u3 = parcelRequire("6E9u3");

var $1WHQK = parcelRequire("1WHQK");

var $bsJQj = parcelRequire("bsJQj");

var $e89FC = parcelRequire("e89FC");

var $gwv0F = parcelRequire("gwv0F");

var $lCMva = parcelRequire("lCMva");

var $7Wd8C = parcelRequire("7Wd8C");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $6hWPd = parcelRequire("6hWPd");

var $k5SrI = parcelRequire("k5SrI");
const $6f16e1a11c374bc7$export$80ad823ea511ef0f = (activeContext, tocId)=>{
    // Get contexts
    const signalR = (0, $7fPBF.useContext)((0, $gD2t9.SignalRContext));
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const level = hierarchyContext?.hierarchy?.level;
    const { state: tocState } = (0, $hWsmt.useTocContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const { state: state, dispatch: dispatch } = (0, $hWsmt.useTocContext)();
    // #region Variables based on context
    /**
   * Title for the comments section based on the active context.
   */ const title = `${activeContext === "Hierarchy" && level ? level : activeContext === "TlfItem" && tlfContext && tlfContext.tlfData && tlfContext.tlfData.primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report ? "Shell" : activeContext === "TlfItem" && tlfContext.tlfData ? "Template" : "Unknown"} comments`;
    /**
   * Entity ID based on the active context.
   */ const entityId = activeContext === "Hierarchy" ? hierarchyContext?.hierarchy?.id : tlfContext.tlfData?.id;
    /**
   * Check if the current context is subscribed to comments.
   */ const isSubscribed = activeContext === "Hierarchy" && hierarchyContext ? hierarchyContext.isSubscribed : activeContext === "TlfItem" && tlfContext ? tlfContext.isSubscribed : false;
    /**
   * Current comment panel status based on the active context.
   */ const commentPanelStatus = activeContext === "Hierarchy" && hierarchyContext ? hierarchyContext?.commentPanelStatus : activeContext === "TlfItem" && tlfContext ? tlfContext.commentPanelStatus : null;
    /**
   * Current comment filter based on the active context.
   */ const commentFilter = activeContext === "Toc" ? state.commentsFilter : commentPanelStatus?.commentFilter ?? "all";
    /**
   * Details for the active context to use in server requests.
   */ const xdetails = activeContext === "Hierarchy" && hierarchyContext?.hierarchy ? {
        hierarchyId: hierarchyContext?.hierarchy.id
    } : activeContext === "TlfItem" && tlfContext.tlfData ? {
        id: tlfContext.tlfData.id,
        azsolId: tlfContext.tlfData.azsolId,
        version: tlfContext.tlfData.version
    } : null;
    /**
   * Fetches comments from the active context and cleans up any bad parentIds.
   */ const comments = activeContext === "Hierarchy" && hierarchyContext?.hierarchy?.comments ? hierarchyContext.hierarchy.comments : activeContext === "TlfItem" && tlfContext.tlfData && "comments" in tlfContext.tlfData ? tlfContext.tlfData.comments : tocState.tocItems.find((item)=>item.id === tocId && "comments" in item)?.comments ?? [];
    // Clean bad parentIds
    comments.forEach((c)=>{
        if (c.parentId && !comments.find((p)=>p.id === c.parentId)) c.parentId = undefined;
    });
    // #endregion
    // #region Utility functions
    /**
   * Sets the comment panel status in the appropriate context based on the active context.
   *
   * @param status - The new comment panel status to set.
   *        This should be of type CommentPanelStatus.
   */ const setCommentPanelStatusInContext = (status)=>{
        if (activeContext === "Hierarchy") hierarchyContext?.dispatch({
            operation: (0, $9Jgpw.SET_HIERARCHY_COMMENT_PANEL),
            commentPanelStatus: status
        });
        else tlfContext.dispatch({
            operation: (0, $dDC3L.SET_TLF_COMMENT_PANEL),
            calledFrom: "useComments:setCommentPanelStatus",
            commentPanelStatus: status
        });
    };
    /**
   * Sets the comment filter in the appropriate context based on the active context.
   *
   * @param commentFilter - The new comment filter to set.
   *        This should be of type CommentFilterOptionValue.
   */ const setCommentFilterInContext = (commentFilter)=>{
        switch(activeContext){
            case "Hierarchy":
            case "TlfItem":
                /* istanbul ignore else */ if (commentPanelStatus) setCommentPanelStatusInContext({
                    ...commentPanelStatus,
                    commentFilter: commentFilter
                });
                break;
            case "Toc":
                dispatch({
                    operation: (0, $6E9u3.UPDATE_COMMENTS_FILTER),
                    commentsFilter: commentFilter
                });
                break;
        }
    };
    /**
   * Signal R groupname
   */ const signalRgroup = activeContext === "Hierarchy" ? `hie${hierarchyContext?.hierarchy?.id}` : `tlf${tlfContext.tlfData?.id}`;
    /**
   * Send a comment update to other users in the assigned context
   *
   * @param commentsPatch - Comments patch to send
   * @returns Promise resolving to the sent message
   */ const sendCommentPatchToOthers = async (commentsPatch)=>{
        return await signalR?.sendMessageToGroup(JSON.stringify(commentsPatch), signalRgroup, "commentsPatch");
    };
    /**
   * Sets the comments in the appropriate context based on the active context.
   *
   * @param newComments - The new comments to set in the context.
   * @param sendPatch - When true, send a patch of the changes to other users.
   */ const setCommentsInContext = (newComments, sendPatch = false)=>{
        /* istanbul ignore else */ if (sendPatch && comments) {
            const patch = (0, $6hWPd.createPatch)(comments.sort((0, $k5SrI.sortCommentsAscending)), newComments.sort((0, $k5SrI.sortCommentsAscending)));
            /* istanbul ignore else */ if (patch.length > 0) sendCommentPatchToOthers(patch);
        }
        /* istanbul ignore else */ if (activeContext === "Hierarchy" && hierarchyContext && hierarchyContext.hierarchy && !(0, $gSkQi.isEqual)(newComments, hierarchyContext.hierarchy.comments)) {
            const hierarchyPatch = {
                comments: newComments
            };
            hierarchyContext.dispatch({
                operation: (0, $9Jgpw.UPDATE_HIERARCHY),
                hierarchy: hierarchyPatch
            });
        } else if (activeContext === "TlfItem" && hierarchyContext && tlfContext && tlfContext.tlfData && "comments" in tlfContext.tlfData && !(0, $gSkQi.isEqual)(newComments, tlfContext.tlfData.comments)) tlfContext.dispatch({
            operation: (0, $dDC3L.UPDATE_TLF),
            tlfData: {
                comments: newComments
            },
            calledFrom: "useComments:setCommentsInContext",
            doNotAddUndo: true
        });
    };
    /**
   * Updates the subscription status in the appropriate context based on the active context.
   *
   * @param status - A boolean indicating the subscription status to set.
   *        `true` means subscribed, and `false` means unsubscribed.
   */ const setSubscriptionStatusInContext = (status)=>{
        if (activeContext === "Hierarchy") hierarchyContext?.dispatch({
            operation: (0, $9Jgpw.SET_HIERARCHY_SUBSCRIPTION_STATUS),
            isSubscribed: status
        });
        else tlfContext.dispatch({
            operation: (0, $dDC3L.SET_TLF_SUBSCRIPTION_STATUS),
            calledFrom: "useComments:setSubscriptionStatus",
            isSubscribed: status
        });
    };
    /**
   * Create a new comment in the assigned context
   *
   * @param parentId - Id of the parent comment, if any
   * @param relatedTo - Section/Item/Id in assigned context the comment relates to
   */ const createComment = (parentId, relatedTo)=>{
        /* istanbul ignore else */ if (comments && appSettings.userId && appSettings.userId > -1) {
            const now = new Date().toISOString();
            const newComment = {
                id: `new-${crypto.randomUUID()}`,
                authorDisplayName: appSettings.displayName,
                authorId: appSettings.userId,
                commentReviewStatus: (0, $gwv0F.eCommentReviewStatus).open,
                content: {
                    lines: [
                        {
                            textBlocks: [
                                {
                                    text: ""
                                }
                            ]
                        }
                    ]
                },
                createdAt: now,
                parentId: parentId,
                relatedTo: relatedTo,
                updateCount: 0,
                updatedAt: now,
                canDelete: true
            };
            setCommentsInContext([
                ...comments,
                newComment
            ]);
            return newComment;
        }
    };
    /**
   * Read an existing comment from the assigned context
   *
   * @param commentId - Assigned comment id
   */ const readComment = (commentId)=>comments?.find((c)=>c.id === commentId);
    /**
   * Send a comment to other users in the assigned context
   *
   * @param comment - Comment to send
   * @returns Promise resolving to the sent message
   */ const sendCommentToOthers = async (comment)=>{
        return await signalR?.sendMessageToGroup(JSON.stringify(comment), signalRgroup, "comment");
    };
    /**
   * Delete a comment for other users in the assigned context
   *
   * @param commentId - Id of the comment to delete
   * @returns Promise resolving to the sent message
   */ const deleteCommentForOthers = async (commentId)=>{
        return await signalR?.sendMessageToGroup(JSON.stringify({
            id: commentId
        }), signalRgroup, "deleteComment");
    };
    // Update request status
    const [updateRequest, setUpdateRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Post comment to the server,
   * status of the request is in the postRequest variable
   *
   * @param commentId - Id of the comment to save
   * @param commentContents - New content for the comment
   */ const updateCommentInContext = async (commentId, commentContents)=>{
        const newComments = [
            ...comments
        ];
        const ix = newComments.findIndex((c)=>c.id === commentId);
        // Check comment is found and can be posted
        /* istanbul ignore else */ if (ix > -1 && xdetails) {
            const thisComment = newComments[ix];
            // Remove any errors
            setUpdateRequest({
                ...updateRequest,
                error: false
            });
            // Set request
            let request;
            // Add new comment to the server & context
            if (thisComment.id.startsWith("new")) {
                const dto = {
                    content: commentContents,
                    parentId: thisComment.parentId,
                    relatedTo: thisComment.relatedTo,
                    ...xdetails
                };
                request = await (0, $30Ra3.loadWrapper)((0, $1WHQK.addComment), dto, {
                    ...updateRequest,
                    requestedId: undefined
                }, setUpdateRequest, appSettings.backEndUrl);
            } else {
                const dto = {
                    commentId: thisComment.id,
                    content: commentContents,
                    ...xdetails
                };
                request = await (0, $30Ra3.loadWrapper)((0, $lCMva.updateComment), dto, {
                    ...updateRequest,
                    requestedId: undefined
                }, setUpdateRequest, appSettings.backEndUrl);
            }
            // Process successful return
            /* istanbul ignore else */ if (request?.success) {
                newComments.splice(ix, 1, request.data);
                setCommentsInContext(newComments);
                sendCommentToOthers(request.data);
                /* istanbul ignore else */ if (!isSubscribed) setSubscriptionStatusInContext(true);
            }
        }
    };
    // Delete request status.
    const [deleteRequest, setDeleteRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Delete a comment in the assigned context,
   * status of the request is in the deleteRequest variable
   *
   * @param commentId - Id of the comment to delete
   */ const deleteCommentFromContext = async (commentId)=>{
        const newComments = [
            ...comments
        ];
        const ix = comments.findIndex((c)=>c.id === commentId);
        /* istanbul ignore else */ if (ix > -1 && xdetails) {
            const thisComment = newComments[ix];
            let response = null;
            // Send request to delete existing comment
            if (!thisComment.id.startsWith("new")) response = await (0, $30Ra3.loadWrapper)((0, $bsJQj.deleteComment), {
                commentId: commentId,
                ...xdetails
            }, deleteRequest, setDeleteRequest, appSettings.backEndUrl);
            else response = {
                success: true
            };
            // Update on success
            /* istanbul ignore else */ if (response && response.success) {
                newComments.splice(ix, 1);
                setCommentsInContext(newComments);
                deleteCommentForOthers(thisComment.id);
            }
            // Remove any highlight for deleted comment
            /* istanbul ignore else */ if (commentPanelStatus && commentPanelStatus.highlightCommentId === commentId) setCommentPanelStatusInContext({
                ...commentPanelStatus,
                highlightCommentId: "",
                activeRelatedTo: ""
            });
        }
    };
    // Toggle comment subscription request status.
    const [toggleCommentsSubscriptionRequest, setToggleCommentsSubscriptionRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Toggle comments subscription for the active context
   */ const toggleCommentsSubscription = async ()=>{
        if (!entityId || activeContext === "Toc") return;
        const action = isSubscribed ? "unsubscribe" : "subscribe";
        const response = await (0, $30Ra3.loadWrapper)((0, $e89FC.handleCommentsSubscription), {
            activeContext: activeContext,
            entityId: entityId,
            action: action
        }, toggleCommentsSubscriptionRequest, setToggleCommentsSubscriptionRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) setSubscriptionStatusInContext(response.data);
    };
    // #endregion
    return {
        commentFilter: commentFilter,
        commentPanelStatus: commentPanelStatus,
        comments: comments,
        createComment: createComment,
        deleteComment: deleteCommentFromContext,
        deleteRequest: deleteRequest,
        isSubscribed: isSubscribed,
        readComment: readComment,
        setCommentFilter: setCommentFilterInContext,
        setCommentPanelStatus: setCommentPanelStatusInContext,
        setComments: setCommentsInContext,
        title: title,
        toggleCommentsSubscription: toggleCommentsSubscription,
        toggleCommentsSubscriptionRequest: toggleCommentsSubscriptionRequest,
        updateComment: updateCommentInContext,
        updateRequest: updateRequest
    };
};

});
parcelRegister("1WHQK", function(module, exports) {

$parcel$export(module.exports, "addComment", function () { return $e78fe658b024bf55$export$1cab2cf04e810197; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $e78fe658b024bf55$export$1cab2cf04e810197 = async (backEndUrl, details, controller)=>{
    try {
        if (details.hierarchyId) {
            const hdets = details;
            const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comments`;
            const ret = await (0, $a04va.default).post(url, {
                content: details.content,
                parentId: details.parentId,
                relatedTo: details.relatedTo
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        } else {
            const tdets = details;
            const url = `${backEndUrl}TlfItems/${tdets.id}/Comments`;
            const ret = await (0, $a04va.default).post(url, {
                content: details.content,
                parentId: details.parentId,
                relatedTo: details.relatedTo
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        }
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Add comment failed", error);
    }
};

});

parcelRegister("bsJQj", function(module, exports) {

$parcel$export(module.exports, "deleteComment", function () { return $7b04149abed8f08a$export$2e6e3ad634e3776; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $7b04149abed8f08a$export$2e6e3ad634e3776 = async (backEndUrl, details, controller)=>{
    try {
        if (details.hierarchyId) {
            const hdets = details;
            const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comment/${hdets.commentId}`;
            await (0, $a04va.default).delete(url, {
                signal: controller.signal
            });
            return {
                success: true
            };
        } else {
            const tdets = details;
            const url = `${backEndUrl}TlfItems/${tdets.id}/Comment/${tdets.commentId}`;
            await (0, $a04va.default).delete(url, {
                signal: controller.signal
            });
            return {
                success: true
            };
        }
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Delete comment failed", error);
    }
};

});

parcelRegister("e89FC", function(module, exports) {

$parcel$export(module.exports, "handleCommentsSubscription", function () { return $c962076d1ada4ca3$export$d5e5af18e4d63273; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $c962076d1ada4ca3$export$d5e5af18e4d63273 = async (backEndUrl, details, controller)=>{
    try {
        const url = `${backEndUrl}Comments/${details.activeContext}/${details.entityId}/${details.action}`;
        const response = await (0, $a04va.default).put(url, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)(`Failed to ${details.action}`, error);
    }
};

});

parcelRegister("gwv0F", function(module, exports) {

$parcel$export(module.exports, "eCommentReviewStatus", function () { return $a0a8758c2e5289da$export$150f08c6992f2990; });
var $a0a8758c2e5289da$export$150f08c6992f2990 = /*#__PURE__*/ function(eCommentReviewStatus) {
    eCommentReviewStatus["open"] = "Open";
    eCommentReviewStatus["resolved"] = "Resolved";
    return eCommentReviewStatus;
}({});

});

parcelRegister("lCMva", function(module, exports) {

$parcel$export(module.exports, "updateComment", function () { return $b316b9e97d8796b5$export$5a1cd239009d83a6; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $b316b9e97d8796b5$export$5a1cd239009d83a6 = async (backEndUrl, details, controller)=>{
    try {
        if (details.hierarchyId) {
            const hdets = details;
            const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comment/${hdets.commentId}`;
            const ret = await (0, $a04va.default).put(url, {
                content: details.content
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        } else {
            const tdets = details;
            const url = `${backEndUrl}TlfItems/${tdets.id}/Comment/${tdets.commentId}`;
            const ret = await (0, $a04va.default).put(url, {
                content: details.content
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        }
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Update comment failed", error);
    }
};

});



parcelRegister("i2RS8", function(module, exports) {

$parcel$export(module.exports, "CommentThreads", function () { return $04adc58a0d62912b$export$e6645788a16b92c0; });

var $bbzbN = parcelRequire("bbzbN");

var $lQI22 = parcelRequire("lQI22");

var $8RXwd = parcelRequire("8RXwd");

var $3gwzz = parcelRequire("3gwzz");

var $k5SrI = parcelRequire("k5SrI");

var $jIznr = parcelRequire("jIznr");
const $04adc58a0d62912b$export$e6645788a16b92c0 = ({ activeContext: activeContext, tocId: tocId })=>{
    const { comments: comments, commentFilter: commentFilter } = (0, $jIznr.useComments)(activeContext, tocId);
    const parentComments = comments.filter((c)=>c.parentId === undefined);
    const visibleComments = parentComments.sort((0, $k5SrI.sortComments)).filter((comment)=>(0, $3gwzz.shouldShowCommentThread)(comment.id, comments, commentFilter));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: parentComments.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "text-muted text-center d-block",
            children: /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                children: "No comments"
            })
        }) : visibleComments.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "text-muted text-center d-block",
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("em", {
                children: [
                    "No ",
                    commentFilter,
                    " comments"
                ]
            })
        }) : visibleComments.map((comment)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "comment-initial-thread",
                children: [
                    activeContext !== "Toc" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8RXwd.ResolveThreadCommentsButton), {
                        activeContext: activeContext,
                        commentId: comment.id
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lQI22.CommentThread), {
                        id: comment.id,
                        activeContext: activeContext,
                        tocId: tocId
                    })
                ]
            }, comment.id))
    });
};
$04adc58a0d62912b$export$e6645788a16b92c0.displayName = "CommentThreads";

});
parcelRegister("lQI22", function(module, exports) {

$parcel$export(module.exports, "CommentThread", function () { return $e6479d651d62d02d$export$534dc0e681c6a2d7; });

var $bbzbN = parcelRequire("bbzbN");

var $1Pr9b = parcelRequire("1Pr9b");

var $k5SrI = parcelRequire("k5SrI");

var $jIznr = parcelRequire("jIznr");
const $e6479d651d62d02d$export$534dc0e681c6a2d7 = ({ id: id, activeContext: activeContext, tocId: tocId })=>{
    // Get contexts
    const { comments: comments, commentPanelStatus: commentPanelStatus, setCommentPanelStatus: setCommentPanelStatus, readComment: readComment } = (0, $jIznr.useComments)(activeContext, tocId);
    const thisComment = readComment(id);
    return !thisComment || (!commentPanelStatus || !setCommentPanelStatus) && activeContext !== "Toc" ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1Pr9b.CommentBox), {
                commentId: id,
                activeContext: activeContext,
                disabled: activeContext === "Toc" || comments.some((c)=>c.parentId === id),
                tocId: tocId
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "comment-reply-holder",
                children: comments.filter((c)=>c.parentId === id).sort((0, $k5SrI.sortCommentsAscending)).map((c)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "comment-reply",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e6479d651d62d02d$export$534dc0e681c6a2d7, {
                            id: c.id,
                            activeContext: activeContext,
                            tocId: tocId
                        })
                    }, c.id))
            })
        ]
    });
};
$e6479d651d62d02d$export$534dc0e681c6a2d7.displayName = "CommentThread";

});
parcelRegister("1Pr9b", function(module, exports) {

$parcel$export(module.exports, "CommentBox", function () { return $3752e8721e326fc9$export$b201898d93a12223; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $lUIe4 = parcelRequire("lUIe4");

var $hWsmt = parcelRequire("hWsmt");

var $cbQns = parcelRequire("cbQns");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");


var $e2aoo = parcelRequire("e2aoo");

var $e7rkw = parcelRequire("e7rkw");

var $gDPkH = parcelRequire("gDPkH");

var $5aJa3 = parcelRequire("5aJa3");

var $9vFh4 = parcelRequire("9vFh4");

var $bef3l = parcelRequire("bef3l");

var $jIznr = parcelRequire("jIznr");
const $3752e8721e326fc9$export$b201898d93a12223 = ({ activeContext: activeContext, commentId: commentId, disabled: disabled, tocId: tocId })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    // Get contexts
    const appSettings = (0, $hWsmt.useAppSettings)();
    const { commentPanelStatus: commentPanelStatus, readComment: readComment, setCommentPanelStatus: setCommentPanelStatus, commentFilter: commentFilter } = (0, $jIznr.useComments)(activeContext, tocId);
    const location = (0, $gxpCl.useLocation)();
    // Ref to the comment box element for managing focus
    const commentBoxRef = (0, $7fPBF.useRef)(null);
    /**
   * Reads the comment with the given ID from the context
   */ const thisComment = readComment(commentId);
    /**
   * Initializes the original text of the comment
   */ const originalText = thisComment?.content ?? (0, $1iDss.stringToV3)("");
    /**
   * Determines if the current user can edit the comment
   */ const canEdit = (0, $7fPBF.useMemo)(()=>thisComment?.authorId === appSettings.userId && !disabled && thisComment.commentReviewStatus !== "Resolved", [
        appSettings.userId,
        disabled,
        thisComment?.authorId,
        thisComment?.commentReviewStatus
    ]);
    /**
   * State to manage the current content of the comment editor
   */ const [currentContent, setCurrentContent] = (0, $7fPBF.useState)(originalText);
    /**
   * State to manage the current status of the comment save button
   */ const [currentStatus, setCurrentStatus] = (0, $7fPBF.useState)(!canEdit ? "disabled" : thisComment?.id.startsWith("new-") ? "new" : "saved");
    /**
   * Update currentStatus if canEdit changes, shouldn't be possible to have new comments with a resolved status
   */ (0, $7fPBF.useEffect)(()=>{
        if (canEdit && currentStatus === "disabled" && !thisComment?.id.startsWith("new-")) startTransition(()=>setCurrentStatus("saved"));
    }, [
        canEdit,
        currentStatus,
        thisComment?.id
    ]);
    /**
   * Effect to reset the current content when the comment is updated from the top down and is not in editing or new status
   */ (0, $7fPBF.useEffect)(()=>{
        if (!(0, $gSkQi.isEqual)(currentContent, originalText) && ![
            "editing",
            "new"
        ].includes(currentStatus)) startTransition(()=>setCurrentContent(originalText));
    }, [
        currentContent,
        currentStatus,
        originalText
    ]);
    /**
   * Effect to set activeRelatedTo when the comment is focused from notifications
   */ (0, $7fPBF.useEffect)(()=>{
        if (thisComment?.relatedTo && commentPanelStatus?.highlightCommentId === commentId && thisComment?.relatedTo !== commentPanelStatus.activeRelatedTo) setCommentPanelStatus({
            ...commentPanelStatus,
            activeRelatedTo: thisComment.relatedTo
        });
    }, [
        thisComment?.relatedTo,
        commentId,
        commentPanelStatus,
        setCommentPanelStatus
    ]);
    /**
   * Determines if the user can post this comment based on the current status and content
   */ const canPost = (0, $7fPBF.useMemo)(()=>canEdit && (currentStatus === "new" || currentStatus === "editing") && (0, $1iDss.getTextFromEditorV3)(currentContent).join("").trim() !== "" && !(0, $1iDss.cleanIsEqual)(currentContent, originalText), [
        canEdit,
        currentContent,
        currentStatus,
        originalText
    ]);
    /**
   * Function to handle the @ mention list for the editor
   * @param typedString - The string currently being typed in the editor
   * @returns A promise that resolves to a list of users matching the typed string
   */ const atListFunction = (0, $7fPBF.useCallback)(async (typedString)=>{
        if (typedString.length === 1) return [
            {
                text: "Waiting...",
                data: {}
            }
        ];
        const request = await (0, $cbQns.searchUsers)(appSettings.backEndUrl, typedString.slice(1));
        const ret = [];
        /* istanbul ignore else */ if (request?.success) request.data?.sort((a, b)=>`${a.displayName}`.localeCompare(`${b.displayName}`)).forEach((u)=>{
            /* istanbul ignore else */ if (u.displayName && u.prid) ret.push({
                text: u.displayName,
                data: {
                    prid: u.prid
                }
            });
        });
        return ret;
    }, [
        appSettings.backEndUrl
    ]);
    /**
   * Function to update the comment panel status
   * @param updates - Updates to the comment panel status
   */ const updateCommentPanelStatus = (0, $7fPBF.useCallback)((updates)=>{
        /* istanbul ignore else */ if (setCommentPanelStatus && commentPanelStatus) setCommentPanelStatus({
            ...commentPanelStatus,
            ...updates
        });
    }, [
        setCommentPanelStatus,
        commentPanelStatus
    ]);
    /**
   * Determines if the comment should be visible based on the filter and review status.
   */ const shouldShowComment = (0, $7fPBF.useMemo)(()=>(0, $gDPkH.isCommentVisible)(commentFilter, thisComment?.commentReviewStatus), [
        commentFilter,
        thisComment?.commentReviewStatus
    ]);
    /**
   * Memo for the class name for the comment based on its status
   */ const getCommentClassName = (0, $7fPBF.useMemo)(()=>{
        if (commentPanelStatus?.highlightCommentId === commentId || commentPanelStatus?.activeRelatedTo && commentPanelStatus?.activeRelatedTo === thisComment?.relatedTo) return "highlight";
        return "";
    }, [
        commentId,
        commentPanelStatus,
        thisComment
    ]);
    // Add global mousedown handler to clear highlight when clicking outside comment box
    const handleDocumentMouseDown = (0, $7fPBF.useCallback)((e)=>{
        if (e.target && commentBoxRef.current && !commentBoxRef.current.contains(e.target) && (commentPanelStatus?.activeRelatedTo !== "" || commentPanelStatus?.highlightCommentId !== "")) updateCommentPanelStatus({
            highlightCommentId: "",
            activeRelatedTo: ""
        });
    }, [
        commentPanelStatus?.activeRelatedTo,
        commentPanelStatus?.highlightCommentId,
        updateCommentPanelStatus
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (commentPanelStatus?.highlightCommentId === commentId && !(0, $5aJa3.isRedirectingFromNotifications)(location.search)) {
            document.addEventListener("mousedown", handleDocumentMouseDown);
            return ()=>{
                document.removeEventListener("mousedown", handleDocumentMouseDown);
            };
        }
    }, [
        handleDocumentMouseDown,
        commentId,
        commentPanelStatus?.highlightCommentId,
        location.search
    ]);
    /**
   * Shared onBlur handler for comment box and editor
   */ const handleBlur = (0, $7fPBF.useCallback)((e)=>{
        const commentBox = commentBoxRef.current;
        const nextFocused = e.relatedTarget;
        // Only handle blur if this is the outermost comment box
        if ((0, $5aJa3.isRedirectingFromNotifications)(location.search) || "currentTarget" in e && e.currentTarget && commentBox && e.currentTarget !== commentBox) return;
        if (!nextFocused || !commentBox?.contains(nextFocused)) updateCommentPanelStatus({
            highlightCommentId: "",
            activeRelatedTo: ""
        });
    }, [
        updateCommentPanelStatus,
        location.search
    ]);
    return !thisComment || !shouldShowComment ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `comment ${getCommentClassName}`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: "comment-text-holder position-relative",
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "comment-box",
                role: "region",
                id: `comment-${commentId}-box`,
                tabIndex: 0,
                ref: commentBoxRef,
                onBlur: handleBlur,
                onFocus: ()=>{
                    if (commentPanelStatus && (thisComment.relatedTo ?? "") !== commentPanelStatus.activeRelatedTo) updateCommentPanelStatus({
                        highlightCommentId: thisComment.id,
                        activeRelatedTo: thisComment.relatedTo
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "comment-header col pe-0",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "comment-header-name",
                                children: thisComment.authorDisplayName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "col",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1iDss.EditorV3), {
                                    className: "comment-editor",
                                    id: `comment-${commentId}`,
                                    input: currentContent,
                                    allowNewLine: true,
                                    atListFunction: atListFunction,
                                    debounceMilliseconds: -1,
                                    "aria-label": "Comment text",
                                    "aria-readonly": [
                                        "editing",
                                        "new"
                                    ].includes(currentStatus),
                                    editable: [
                                        "editing",
                                        "new"
                                    ].includes(currentStatus),
                                    setObject: (ret)=>{
                                        setCurrentContent({
                                            lines: ret.lines
                                        });
                                    },
                                    resize: !disabled ? "vertical" : undefined,
                                    onBlur: handleBlur
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "comment-button-holder d-flex flex-column gap-1 col pt-1",
                                    children: [
                                        !disabled && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: "d-flex flex-row gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bef3l.UpdateCommentButton), {
                                                    activeContext: activeContext,
                                                    currentStatus: currentStatus,
                                                    disabled: [
                                                        "new",
                                                        "editing"
                                                    ].includes(currentStatus) ? !canPost : !canEdit,
                                                    commentId: commentId,
                                                    currentContent: currentContent,
                                                    setCurrentStatus: setCurrentStatus
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e7rkw.DeleteCommentButton), {
                                                    activeContext: activeContext,
                                                    commentId: commentId,
                                                    canEdit: canEdit
                                                })
                                            ]
                                        }),
                                        activeContext !== "Toc" && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9vFh4.ResolveCommentButton), {
                                                    activeContext: activeContext,
                                                    commentId: commentId,
                                                    disabled: [
                                                        "new",
                                                        "editing",
                                                        "error"
                                                    ].includes(currentStatus)
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e2aoo.CreateCommentButton), {
                                                    id: `reply-comment-${commentId}`,
                                                    activeContext: activeContext,
                                                    parentId: commentId,
                                                    relatedTo: thisComment.relatedTo,
                                                    reply: true,
                                                    disabled: [
                                                        "new",
                                                        "editing",
                                                        "error"
                                                    ].includes(currentStatus) || thisComment.commentReviewStatus === "Resolved"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "row w-100 pe-0",
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "comment-header comment-header-time col pe-0 text-muted",
                                    children: [
                                        thisComment.entityVersion && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: "comment-header-version",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("em", {
                                                children: [
                                                    "Added on version ",
                                                    thisComment.entityVersion
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("em", {
                                            children: [
                                                thisComment.updateCount >= 1 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                                                    children: "Edited "
                                                }),
                                                (0, $lUIe4.convertDateToLocaleString)(thisComment.updatedAt)
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
$3752e8721e326fc9$export$b201898d93a12223.displayName = "CommentBox";

});
parcelRegister("cbQns", function(module, exports) {

$parcel$export(module.exports, "searchUsers", function () { return $724a62d9d7929629$export$c996479cb76ab18b; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $724a62d9d7929629$export$c996479cb76ab18b = async (backEndUrl, searchText, controller)=>{
    const url = `${backEndUrl}Users/search?search=${searchText}`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load all users failed", error);
    }
};

});

parcelRegister("e2aoo", function(module, exports) {

$parcel$export(module.exports, "CreateCommentButton", function () { return $14922fcda3559c2f$export$b70263bc36c4d2b6; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $dA3cL = parcelRequire("dA3cL");

var $jIznr = parcelRequire("jIznr");
const $14922fcda3559c2f$export$b70263bc36c4d2b6 = ({ id: id = "create-comment-button", activeContext: activeContext, parentId: parentId, relatedTo: relatedTo, reply: reply = false, disabled: disabled = false, label: label = reply ? "Reply" : "Create comment" })=>{
    // Get contexts
    const { createComment: createComment } = (0, $jIznr.useComments)(activeContext);
    /**
   * Handle click event to create a new comment.
   *
   * @param e - Mouse event
   */ const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (!disabled) createComment(parentId, relatedTo);
    };
    // Component render
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
        id: id,
        title: label,
        "aria-label": label,
        onClick: handleClick,
        size: "sm",
        disabled: disabled,
        children: [
            label === "Create comment" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dA3cL.default), {
                className: "me-1"
            }),
            label
        ]
    });
};
$14922fcda3559c2f$export$b70263bc36c4d2b6.displayName = "CreateCommentButton";

});

parcelRegister("e7rkw", function(module, exports) {

$parcel$export(module.exports, "DeleteCommentButton", function () { return $ef09806ac2e062e5$export$fdf3fce3c5515e3b; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $7fPBF = parcelRequire("7fPBF");

var $e1yiN = parcelRequire("e1yiN");

var $jIznr = parcelRequire("jIznr");
const $ef09806ac2e062e5$export$fdf3fce3c5515e3b = ({ activeContext: activeContext, commentId: commentId, canEdit: canEdit })=>{
    const { deleteComment: deleteComment, comments: comments, readComment: readComment, deleteRequest: deleteRequest } = (0, $jIznr.useComments)(activeContext);
    const thisComment = readComment(commentId);
    /**
   * Handle click event to delete the comment.
   *
   * @param e - Mouse event
   */ const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        deleteComment(commentId);
    };
    const disabled = (0, $7fPBF.useMemo)(()=>!thisComment?.canDelete || !canEdit || comments.filter((c)=>c.parentId === thisComment.id).length > 0, [
        thisComment,
        canEdit,
        comments
    ]);
    return thisComment && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
        size: "sm",
        "aria-label": "Delete comment",
        disabled: disabled,
        id: `delete-comment-${thisComment.id}`,
        className: "align-self-top",
        onClick: handleClick,
        variant: "danger",
        requestStatus: deleteRequest,
        title: disabled ? "Comment cannot be deleted" : "Delete comment",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e1yiN.default), {
            size: 14
        })
    });
};
$ef09806ac2e062e5$export$fdf3fce3c5515e3b.displayName = "DeleteCommentButton";

});
parcelRegister("e1yiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a35bc4632a384c00$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $a35bc4632a384c00$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $a35bc4632a384c00$var$_extends() {
    return $a35bc4632a384c00$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a35bc4632a384c00$var$_extends.apply(null, arguments);
}
function $a35bc4632a384c00$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a35bc4632a384c00$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a35bc4632a384c00$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a35bc4632a384c00$var$TrashFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $a35bc4632a384c00$var$_objectWithoutProperties(_ref, $a35bc4632a384c00$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $a35bc4632a384c00$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-trash-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
    }));
});
$a35bc4632a384c00$var$TrashFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $a35bc4632a384c00$export$2e2bcd8739ae039 = $a35bc4632a384c00$var$TrashFill;

});


parcelRegister("gDPkH", function(module, exports) {

$parcel$export(module.exports, "isCommentVisible", function () { return $809cdd8a0c3796b2$export$8dc79b823b8935c4; });
const $809cdd8a0c3796b2$export$8dc79b823b8935c4 = (commentFilter, commentReviewStatus)=>{
    return commentFilter === "all" || commentFilter === "open" && commentReviewStatus === "Open" || commentFilter === "resolved" && commentReviewStatus === "Resolved";
};

});

parcelRegister("5aJa3", function(module, exports) {

$parcel$export(module.exports, "isRedirectingFromNotifications", function () { return $e3c1ed99065138e1$export$c50291a50a530ee0; });
/**
 * Check whether the URL search string contains comment highlighting parameters from notifications.
 *
 * @param search - The URL search string to check
 * @returns True if redirecting from notifications with comment parameters
 */ const $e3c1ed99065138e1$export$c50291a50a530ee0 = (search)=>{
    const searchParams = new URLSearchParams(search);
    return searchParams.has("showTlfItemComments") || searchParams.has("commentId") || searchParams.has("showHierarchyComments");
};

});

parcelRegister("9vFh4", function(module, exports) {

$parcel$export(module.exports, "ResolveCommentButton", function () { return $6ea7054caf66f50e$export$9cd9729cf91515f8; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $gwv0F = parcelRequire("gwv0F");

var $22ANz = parcelRequire("22ANz");

var $7Wd8C = parcelRequire("7Wd8C");

var $7fPBF = parcelRequire("7fPBF");

var $jIznr = parcelRequire("jIznr");
const $6ea7054caf66f50e$export$9cd9729cf91515f8 = ({ activeContext: activeContext, commentId: commentId, disabled: disabled })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const { comments: comments, readComment: readComment, setComments: setComments } = (0, $jIznr.useComments)(activeContext);
    const thisComment = readComment(commentId);
    const newStatus = thisComment?.commentReviewStatus === (0, $gwv0F.eCommentReviewStatus).resolved ? (0, $gwv0F.eCommentReviewStatus).open : (0, $gwv0F.eCommentReviewStatus).resolved;
    const buttonAction = newStatus === (0, $gwv0F.eCommentReviewStatus).resolved ? "Resolve" : "Open";
    const thisCommentRequestDto = (0, $7fPBF.useMemo)(()=>{
        if (activeContext === "Hierarchy" && hierarchy) return {
            activeContext: "Hierarchy",
            hierarchyId: hierarchy.id,
            commentId: commentId,
            newStatus: newStatus
        };
        else if ([
            "TlfItem"
        ].includes(activeContext) && tlfData) return {
            activeContext: "TlfItem",
            id: tlfData.id,
            azsolId: tlfData.azsolId,
            version: tlfData.version,
            commentId: commentId,
            newStatus: newStatus
        };
        return null;
    }, [
        activeContext,
        commentId,
        hierarchy,
        newStatus,
        tlfData
    ]);
    const [patchCommentStatusRequest, setPatchCommentStatusRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const handleClick = (0, $7fPBF.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (thisCommentRequestDto) {
            const request = await (0, $30Ra3.loadWrapper)((0, $22ANz.patchCommentStatus), thisCommentRequestDto, {
                ...patchCommentStatusRequest,
                requestedId: undefined,
                error: false
            }, setPatchCommentStatusRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) {
                const newComments = [
                    ...comments.filter((c)=>c.id !== request.data.id),
                    request.data
                ];
                setComments(newComments, true);
            }
        }
    }, [
        appSettings.backEndUrl,
        comments,
        patchCommentStatusRequest,
        setComments,
        thisCommentRequestDto
    ]);
    return thisComment && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
        id: `resolve-comment-${commentId}`,
        "aria-label": `${buttonAction} comment`,
        className: "resolve-button",
        title: `${buttonAction} this comment`,
        size: "sm",
        variant: newStatus === (0, $gwv0F.eCommentReviewStatus).resolved ? "success" : "warning",
        disabled: disabled || !hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).MaintainHierarchyComments) || !thisCommentRequestDto,
        requestStatus: patchCommentStatusRequest,
        onClick: handleClick,
        children: buttonAction
    });
};
$6ea7054caf66f50e$export$9cd9729cf91515f8.displayName = "ResolveCommentButton";

});
parcelRegister("22ANz", function(module, exports) {

$parcel$export(module.exports, "patchCommentStatus", function () { return $dba903f32bd0ed2f$export$62cae3389f875941; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $dba903f32bd0ed2f$export$62cae3389f875941 = async (backEndUrl, details, controller)=>{
    const url = details.activeContext === "Hierarchy" ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentStatus/${details.commentId}` : `${backEndUrl}TlfItems/${details.id}/CommentStatus/${details.commentId}`;
    try {
        const commentStatusUpdate = {
            status: details.newStatus
        };
        const ret = await (0, $a04va.default).patch(url, commentStatusUpdate, {
            signal: controller.signal
        });
        return {
            success: true,
            data: ret.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Update comment failed", error);
    }
};

});


parcelRegister("bef3l", function(module, exports) {

$parcel$export(module.exports, "UpdateCommentButton", function () { return $f6890f3af318e15b$export$dc74a7fec1111808; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("7fPBF");

var $ghRXW = parcelRequire("ghRXW");
var $1b90P = parcelRequire("1b90P");

var $jIznr = parcelRequire("jIznr");
const $f6890f3af318e15b$export$dc74a7fec1111808 = ({ activeContext: activeContext, currentStatus: currentStatus, disabled: disabled, commentId: commentId, currentContent: currentContent, setCurrentStatus: setCurrentStatus })=>{
    const { updateComment: updateComment, updateRequest: updateRequest } = (0, $jIznr.useComments)(activeContext);
    /**
   * Handle click event to post or edit the comment.
   *
   * @param e - Mouse event
   */ const handleClick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        switch(currentStatus){
            case "new":
            case "editing":
                await updateComment(commentId, currentContent);
                setCurrentStatus("saved");
                break;
            case "saved":
                setCurrentStatus("editing");
                break;
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
        size: "sm",
        "aria-label": [
            "new",
            "editing"
        ].includes(currentStatus) ? "Post comment" : "Edit comment",
        disabled: disabled,
        id: `update-comment-${commentId}`,
        onClick: handleClick,
        variant: currentStatus === "editing" ? "primary" : "outline-primary",
        requestStatus: updateRequest,
        children: [
            "new",
            "editing"
        ].includes(currentStatus) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ghRXW.default), {
            size: 14
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1b90P.default), {
            size: 14
        })
    });
};
$f6890f3af318e15b$export$dc74a7fec1111808.displayName = "UpdateCommentButton";

});
parcelRegister("ghRXW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdb81857080999f1$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $bdb81857080999f1$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $bdb81857080999f1$var$_extends() {
    return $bdb81857080999f1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bdb81857080999f1$var$_extends.apply(null, arguments);
}
function $bdb81857080999f1$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bdb81857080999f1$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bdb81857080999f1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bdb81857080999f1$var$Floppy = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $bdb81857080999f1$var$_objectWithoutProperties(_ref, $bdb81857080999f1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $bdb81857080999f1$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-floppy',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11 2H9v3h2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"
    }));
});
$bdb81857080999f1$var$Floppy.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $bdb81857080999f1$export$2e2bcd8739ae039 = $bdb81857080999f1$var$Floppy;

});

parcelRegister("1b90P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dbdcf2e6e4d62ec$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $0dbdcf2e6e4d62ec$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $0dbdcf2e6e4d62ec$var$_extends() {
    return $0dbdcf2e6e4d62ec$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0dbdcf2e6e4d62ec$var$_extends.apply(null, arguments);
}
function $0dbdcf2e6e4d62ec$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0dbdcf2e6e4d62ec$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0dbdcf2e6e4d62ec$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0dbdcf2e6e4d62ec$var$PenFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $0dbdcf2e6e4d62ec$var$_objectWithoutProperties(_ref, $0dbdcf2e6e4d62ec$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $0dbdcf2e6e4d62ec$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pen-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001"
    }));
});
$0dbdcf2e6e4d62ec$var$PenFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0dbdcf2e6e4d62ec$export$2e2bcd8739ae039 = $0dbdcf2e6e4d62ec$var$PenFill;

});




parcelRegister("8RXwd", function(module, exports) {

$parcel$export(module.exports, "ResolveThreadCommentsButton", function () { return $9aad04b4fe52d3c8$export$45b5ec0e58aa670f; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $gwv0F = parcelRequire("gwv0F");

var $atHM3 = parcelRequire("atHM3");

var $7Wd8C = parcelRequire("7Wd8C");

var $7fPBF = parcelRequire("7fPBF");

var $ggM0l = parcelRequire("ggM0l");

var $jIznr = parcelRequire("jIznr");
const $9aad04b4fe52d3c8$export$45b5ec0e58aa670f = ({ activeContext: activeContext, commentId: commentId })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const { comments: comments, readComment: readComment, setComments: setComments } = (0, $jIznr.useComments)(activeContext);
    const thisComment = readComment(commentId);
    /**
   * Check if a comment thread has any unresolved (open) comments.
   * @param parentCommentId - Id of the root comment for the recursive check.
   * @returns True if any comment in the thread is open, false otherwise.
   */ const isCommentThreadOpen = (0, $7fPBF.useCallback)((parentCommentId)=>{
        /**
       * Recursive check for any open child comments.
       *
       * @param commentId - Id of the root comment for the recursive check.
       */ const hasOpenChildComments = (commentId)=>{
            const currentComment = comments.find((comment)=>comment.id === commentId);
            if (currentComment && (!currentComment.commentReviewStatus || currentComment.commentReviewStatus === "Open")) return true;
            const childComments = comments.filter((comment)=>comment.parentId === commentId);
            return childComments.some((childComment)=>hasOpenChildComments(childComment.id));
        };
        return hasOpenChildComments(parentCommentId);
    }, [
        comments
    ]);
    const thisCommentRequestDto = (0, $7fPBF.useMemo)(()=>{
        if (activeContext === "Hierarchy" && hierarchy) return {
            activeContext: "Hierarchy",
            hierarchyId: hierarchy.id,
            commentId: commentId,
            newStatus: (0, $gwv0F.eCommentReviewStatus).resolved
        };
        else if (activeContext === "TlfItem" && tlfData) return {
            activeContext: "TlfItem",
            id: tlfData.id,
            azsolId: tlfData.azsolId,
            version: tlfData.version,
            commentId: commentId,
            newStatus: (0, $gwv0F.eCommentReviewStatus).resolved
        };
        return null;
    }, [
        activeContext,
        commentId,
        hierarchy,
        tlfData
    ]);
    const [patchCommentStatusRequest, setPatchCommentStatusRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const handleClick = (0, $7fPBF.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (thisCommentRequestDto) {
            const request = await (0, $30Ra3.loadWrapper)((0, $atHM3.patchCommentThreadStatus), thisCommentRequestDto, {
                ...patchCommentStatusRequest,
                requestedId: undefined,
                error: false
            }, setPatchCommentStatusRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) {
                const newComments = [
                    ...comments.filter((c)=>!request.data.map((c)=>c.id).includes(c.id)),
                    ...request.data
                ];
                setComments(newComments, true);
            }
        }
    }, [
        appSettings.backEndUrl,
        comments,
        patchCommentStatusRequest,
        setComments,
        thisCommentRequestDto
    ]);
    return thisComment && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
        id: `resolve-thread-comments-${commentId}`,
        className: "resolve-thread-button mb-1",
        title: "Resolve thread",
        size: "sm",
        variant: "success",
        disabled: !hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).MaintainHierarchyComments) || !isCommentThreadOpen(commentId) || commentId.startsWith("new-"),
        requestStatus: patchCommentStatusRequest,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ggM0l.default), {
                className: "me-1"
            }),
            "Resolve thread"
        ]
    });
};
$9aad04b4fe52d3c8$export$45b5ec0e58aa670f.displayName = "ResolveThreadCommentsButton";

});
parcelRegister("atHM3", function(module, exports) {

$parcel$export(module.exports, "patchCommentThreadStatus", function () { return $fb8500580b982053$export$599d2005bf5bc9d5; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $fb8500580b982053$export$599d2005bf5bc9d5 = async (backEndUrl, details, controller)=>{
    const url = details.activeContext === "Hierarchy" ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentThreadStatus/${details.commentId}` : `${backEndUrl}TlfItems/${details.id}/CommentThreadStatus/${details.commentId}`;
    try {
        const ret = await (0, $a04va.default).patch(url, {
            status: details.newStatus
        }, {
            signal: controller.signal
        });
        return {
            success: true,
            data: ret.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Update comment failed", error);
    }
};

});


parcelRegister("3gwzz", function(module, exports) {

$parcel$export(module.exports, "shouldShowCommentThread", function () { return $4547e39a6c854888$export$7bcab44e898bd894; });

var $gDPkH = parcelRequire("gDPkH");
const $4547e39a6c854888$export$7bcab44e898bd894 = (id, comments, commentFilter)=>{
    if (commentFilter === "all") return true;
    const comment = comments.find((c)=>c.id === id);
    if ((0, $gDPkH.isCommentVisible)(commentFilter, comment?.commentReviewStatus)) return true;
    const hasMatchingChildren = comments.some((c)=>{
        if (c.parentId === id) return $4547e39a6c854888$export$7bcab44e898bd894(c.id, comments, commentFilter);
        return false;
    });
    return (0, $gDPkH.isCommentVisible)(commentFilter, comment?.commentReviewStatus) || hasMatchingChildren;
};

});


parcelRegister("19cj4", function(module, exports) {

$parcel$export(module.exports, "CommentSubscriptionButton", function () { return $a7011f0683dfa32c$export$b3d298092c86ec1d; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $kIA79 = parcelRequire("kIA79");
var $b83zd = parcelRequire("b83zd");
const $a7011f0683dfa32c$export$b3d298092c86ec1d = ({ isSubscribed: isSubscribed, toggleCommentsSubscription: toggleCommentsSubscription, toggleSubscriptionStatusRequest: toggleSubscriptionStatusRequest })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
        id: "comment-subscription-button",
        size: "sm",
        onClick: (e)=>{
            toggleCommentsSubscription();
            e.preventDefault();
            e.stopPropagation();
        },
        title: isSubscribed ? "Unsubscribe from Comments notifications" : "Subscribe to comments",
        requestStatus: toggleSubscriptionStatusRequest,
        children: isSubscribed ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b83zd.default), {
                    className: "me-1"
                }),
                "Unsubscribe"
            ]
        }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kIA79.default), {
                    className: "me-1"
                }),
                "Subscribe"
            ]
        })
    });
};
$a7011f0683dfa32c$export$b3d298092c86ec1d.displayName = "CommentSubscriptionButton";

});
parcelRegister("kIA79", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f153ee406ce03d53$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $f153ee406ce03d53$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $f153ee406ce03d53$var$_extends() {
    return $f153ee406ce03d53$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f153ee406ce03d53$var$_extends.apply(null, arguments);
}
function $f153ee406ce03d53$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f153ee406ce03d53$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f153ee406ce03d53$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $f153ee406ce03d53$var$BellFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $f153ee406ce03d53$var$_objectWithoutProperties(_ref, $f153ee406ce03d53$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $f153ee406ce03d53$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-bell-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901"
    }));
});
$f153ee406ce03d53$var$BellFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $f153ee406ce03d53$export$2e2bcd8739ae039 = $f153ee406ce03d53$var$BellFill;

});

parcelRegister("b83zd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81a3355f61fe0bde$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $81a3355f61fe0bde$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $81a3355f61fe0bde$var$_extends() {
    return $81a3355f61fe0bde$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $81a3355f61fe0bde$var$_extends.apply(null, arguments);
}
function $81a3355f61fe0bde$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $81a3355f61fe0bde$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $81a3355f61fe0bde$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $81a3355f61fe0bde$var$BellSlashFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $81a3355f61fe0bde$var$_objectWithoutProperties(_ref, $81a3355f61fe0bde$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $81a3355f61fe0bde$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-bell-slash-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.164 14H15c-1.5-1-2-5.902-2-7q0-.396-.06-.776zm6.288-10.617A5 5 0 0 0 8.995 2.1a1 1 0 1 0-1.99 0A5 5 0 0 0 3 7c0 .898-.335 4.342-1.278 6.113zM10 15a2 2 0 1 1-4 0zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75z"
    }));
});
$81a3355f61fe0bde$var$BellSlashFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $81a3355f61fe0bde$export$2e2bcd8739ae039 = $81a3355f61fe0bde$var$BellSlashFill;

});


parcelRegister("fcUCK", function(module, exports) {

$parcel$export(module.exports, "ResolveAllCommentsButton", function () { return $5f3f3f136cbd2479$export$e6dfe2d8494c7210; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $gwv0F = parcelRequire("gwv0F");

var $9y7MG = parcelRequire("9y7MG");

var $7Wd8C = parcelRequire("7Wd8C");

var $7fPBF = parcelRequire("7fPBF");

var $6IIOe = parcelRequire("6IIOe");

var $jIznr = parcelRequire("jIznr");
const $5f3f3f136cbd2479$export$e6dfe2d8494c7210 = ({ activeContext: activeContext })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const { setComments: setComments } = (0, $jIznr.useComments)(activeContext);
    const canResolveAll = (0, $7fPBF.useMemo)(()=>{
        if (activeContext === "Hierarchy") return hierarchyContext?.hierarchy?.comments?.some((c)=>c.commentReviewStatus === (0, $gwv0F.eCommentReviewStatus).open) ?? false;
        else return tlfContext.tlfData?.comments?.some((c)=>c.commentReviewStatus === (0, $gwv0F.eCommentReviewStatus).open) ?? false;
    }, [
        activeContext,
        hierarchyContext,
        tlfContext
    ]);
    const thisCommentRequestDto = (0, $7fPBF.useMemo)(()=>{
        if (activeContext === "Hierarchy") {
            if (!hierarchy) return null;
            return {
                activeContext: "Hierarchy",
                hierarchyId: hierarchy.id,
                newStatus: (0, $gwv0F.eCommentReviewStatus).resolved
            };
        } else {
            if (!tlfData) return null;
            return {
                activeContext: "TlfItem",
                id: tlfData.id,
                azsolId: tlfData.azsolId,
                version: tlfData.version,
                newStatus: (0, $gwv0F.eCommentReviewStatus).resolved
            };
        }
    }, [
        activeContext,
        hierarchy,
        tlfData
    ]);
    const [patchCommentStatusRequest, setPatchCommentStatusRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const handleClick = (0, $7fPBF.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (thisCommentRequestDto) {
            const request = await (0, $30Ra3.loadWrapper)((0, $9y7MG.patchAllCommentStatus), thisCommentRequestDto, {
                ...patchCommentStatusRequest,
                requestedId: undefined,
                error: false
            }, setPatchCommentStatusRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) setComments(request.data, true);
        }
    }, [
        appSettings.backEndUrl,
        patchCommentStatusRequest,
        setComments,
        thisCommentRequestDto
    ]);
    return !thisCommentRequestDto ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
        id: `resolve-all-comments-${activeContext}`,
        className: "resolve-all-button ms-2",
        title: "Resolve all",
        size: "sm",
        variant: "success",
        disabled: !hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).MaintainHierarchyComments) || !canResolveAll,
        requestStatus: patchCommentStatusRequest,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6IIOe.default), {
                className: "me-1"
            }),
            "Resolve all"
        ]
    });
};
$5f3f3f136cbd2479$export$e6dfe2d8494c7210.displayName = "ResolveAllCommentsButton";

});
parcelRegister("9y7MG", function(module, exports) {

$parcel$export(module.exports, "patchAllCommentStatus", function () { return $bf637a092e9be18a$export$640adaa654676056; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $bf637a092e9be18a$export$640adaa654676056 = async (backEndUrl, details, controller)=>{
    const url = details.activeContext === "Hierarchy" ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentStatus` : `${backEndUrl}TlfItems/${details.id}/CommentStatus`;
    try {
        const ret = await (0, $a04va.default).patch(url, {
            status: details.newStatus
        }, {
            signal: controller.signal
        });
        return {
            success: true,
            data: ret.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Update comment failed", error);
    }
};

});

parcelRegister("6IIOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e499c48f413b576$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $4e499c48f413b576$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $4e499c48f413b576$var$_extends() {
    return $4e499c48f413b576$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e499c48f413b576$var$_extends.apply(null, arguments);
}
function $4e499c48f413b576$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4e499c48f413b576$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4e499c48f413b576$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4e499c48f413b576$var$Check2All = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $4e499c48f413b576$var$_objectWithoutProperties(_ref, $4e499c48f413b576$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $4e499c48f413b576$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-check2-all',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"
    }));
});
$4e499c48f413b576$var$Check2All.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $4e499c48f413b576$export$2e2bcd8739ae039 = $4e499c48f413b576$var$Check2All;

});


parcelRegister("5jw83", function(module, exports) {

$parcel$export(module.exports, "NEW_TLF_COMMENT_TOOLTIP", function () { return $62b0a08b0af9e71a$export$c7af62884c02a609; });
const $62b0a08b0af9e71a$export$c7af62884c02a609 = "Save the TLF item before adding comments";

});


parcelRegister("wPq5H", function(module, exports) {

$parcel$export(module.exports, "getHierarchyBaseUrl", function () { return $d460ae61fcd27dae$export$67f15bf95912850; });

var $7Wd8C = parcelRequire("7Wd8C");
const $d460ae61fcd27dae$export$67f15bf95912850 = (hierarchy, pathName)=>{
    /**
   * Joins non-empty string/number path segments into a slash-separated URL path.
   *
   * @param parts - Path segments to join; empty strings, booleans, and undefined values are omitted
   * @returns The joined path, always starting with a leading slash
   */ const buildPath = (...parts)=>"/" + parts.filter((p)=>typeof p === "string" && p !== "" || typeof p === "number").join("/");
    // Generate the base URL
    let baseUrl;
    switch(hierarchy.level){
        case (0, $7Wd8C.eHierarchyLevel).TA:
            baseUrl = buildPath(hierarchy.taPrefix);
            break;
        case (0, $7Wd8C.eHierarchyLevel).Project:
            baseUrl = buildPath(hierarchy.taPrefix, hierarchy.projectCode);
            break;
        case (0, $7Wd8C.eHierarchyLevel).Study:
            baseUrl = buildPath(hierarchy.taPrefix, hierarchy.projectCode, hierarchy.hierarchyTag);
            break;
        case (0, $7Wd8C.eHierarchyLevel).Report:
            {
                const isBackup = "isBackupVersion" in hierarchy && hierarchy.isBackupVersion === true && hierarchy.tocMajorVersion !== undefined;
                // Full ancestor-path format.
                baseUrl = isBackup ? buildPath(hierarchy.taPrefix, hierarchy.projectCode, hierarchy.parentTag, hierarchy.name, "Version", hierarchy.tocMajorVersion) : buildPath(hierarchy.taPrefix, hierarchy.projectCode, hierarchy.parentTag, hierarchy.name);
                break;
            }
        case (0, $7Wd8C.eHierarchyLevel).Corporate, (0, $7Wd8C.eHierarchyLevel).TopLevel:
        default:
            baseUrl = "/Corporate";
    }
    // Navigate to the same path as needed.
    if (pathName) {
        const decodedPathName = decodeURIComponent(pathName);
        /* istanbul ignore else */ if (decodedPathName.startsWith(baseUrl) && decodedPathName.length > baseUrl.length) {
            const remainingPath = decodedPathName.substring(baseUrl.length);
            return `${baseUrl}${remainingPath}`;
        }
    }
    return baseUrl;
};

});

parcelRegister("1Uu59", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16425b1b5b9bf844$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $7GnOK = parcelRequire("7GnOK");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $16425b1b5b9bf844$var$Breadcrumb = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, listProps: listProps = {}, children: children, label: label = 'breadcrumb', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'nav', ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'breadcrumb');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        "aria-label": label,
        className: className,
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("ol", {
            ...listProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(prefix, listProps == null ? void 0 : listProps.className),
            children: children
        })
    });
});
$16425b1b5b9bf844$var$Breadcrumb.displayName = 'Breadcrumb';
var $16425b1b5b9bf844$export$2e2bcd8739ae039 = Object.assign($16425b1b5b9bf844$var$Breadcrumb, {
    Item: (0, $7GnOK.default)
});

});
parcelRegister("7GnOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $597eee52fc706634$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $hq4kX = parcelRequire("hq4kX");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $597eee52fc706634$var$BreadcrumbItem = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, active: active = false, children: children, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'li', linkAs: LinkComponent = (0, $hq4kX.default), linkProps: linkProps = {}, href: href, title: title, target: target, ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'breadcrumb-item');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(prefix, className, {
            active: active
        }),
        "aria-current": active ? 'page' : undefined,
        children: active ? children : /*#__PURE__*/ (0, $bbzbN.jsx)(LinkComponent, {
            ...linkProps,
            href: href,
            title: title,
            target: target,
            children: children
        })
    });
});
$597eee52fc706634$var$BreadcrumbItem.displayName = 'BreadcrumbItem';
var $597eee52fc706634$export$2e2bcd8739ae039 = $597eee52fc706634$var$BreadcrumbItem;

});


parcelRegister("5FdgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41fb131c53a5e025$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $41fb131c53a5e025$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $41fb131c53a5e025$var$_extends() {
    return $41fb131c53a5e025$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $41fb131c53a5e025$var$_extends.apply(null, arguments);
}
function $41fb131c53a5e025$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $41fb131c53a5e025$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $41fb131c53a5e025$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $41fb131c53a5e025$var$ArrowUpSquare = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $41fb131c53a5e025$var$_objectWithoutProperties(_ref, $41fb131c53a5e025$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $41fb131c53a5e025$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-up-square',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"
    }));
});
$41fb131c53a5e025$var$ArrowUpSquare.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $41fb131c53a5e025$export$2e2bcd8739ae039 = $41fb131c53a5e025$var$ArrowUpSquare;

});


parcelRegister("30qK6", function(module, exports) {

$parcel$export(module.exports, "NewItemDropMenu", function () { return $22cf008fdf2a6c60$export$c7cc4c9bbf63ebdd; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $9eqKP = parcelRequire("9eqKP");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $7Wd8C = parcelRequire("7Wd8C");

var $4mMRX = parcelRequire("4mMRX");

var $gxpCl = parcelRequire("gxpCl");

var $dRarR = parcelRequire("dRarR");
const $22cf008fdf2a6c60$export$c7cc4c9bbf63ebdd = ({ fileEntry: fileEntry })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const navigation = (0, $gxpCl.useNavigation)();
    const hierarchyBaseUrl = hierarchyContext && hierarchyContext.hierarchy && hierarchyContext.hierarchy.level !== (0, $7Wd8C.eHierarchyLevel).Study ? (0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy) : "/Corporate";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4mMRX.default), {
        id: "topbar-file",
        title: "File",
        style: {
            paddingLeft: "12px",
            position: "relative"
        },
        children: [
            navigation.state === "loading" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                text: "Loading New Template..."
            }),
            hierarchyContext?.hierarchy?.arsEnabled && [
                "local",
                "development",
                "test",
                "__REACT_APP_STAGE__"
            ].includes((0, $dRarR.REACT_APP_STAGE)) && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                        id: "topbar-new-ars-table-link",
                        as: (0, $gxpCl.Link),
                        to: `${hierarchyBaseUrl}/NewTlf/newArsTable`,
                        children: "New ARS Table"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                        id: "topbar-new-ars-listing-link",
                        as: (0, $gxpCl.Link),
                        to: `${hierarchyBaseUrl}/NewTlf/newArsListing`,
                        children: "New ARS Listing"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                id: "topbar-new-table-link",
                as: (0, $gxpCl.Link),
                to: `${hierarchyBaseUrl}/NewTlf/newTable`,
                children: "New Table"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                id: "topbar-new-listing-link",
                as: (0, $gxpCl.Link),
                to: "/Corporate/AZLBL01/2",
                children: "New Listing"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                id: "topbar-new-figure-link",
                as: (0, $gxpCl.Link),
                to: `${hierarchyBaseUrl}/NewTlf/newFigure`,
                children: "New Interactive Figure"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                id: "topbar-new-v1figure-link",
                as: (0, $gxpCl.Link),
                to: `${hierarchyBaseUrl}/NewTlf/newV1Figure`,
                children: "New Static Figure"
            }),
            fileEntry !== undefined && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                children: fileEntry
            })
        ]
    });
};
$22cf008fdf2a6c60$export$c7cc4c9bbf63ebdd.displayName = "NewItemDropMenu";

});
parcelRegister("4mMRX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32df1fe4eb2ef4ed$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $kpGzy = parcelRequire("kpGzy");

var $87bIP = parcelRequire("87bIP");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $32df1fe4eb2ef4ed$var$NavDropdown = /*#__PURE__*/ $7fPBF.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $jbn4d.useBootstrapPrefix)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kpGzy.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kpGzy.default).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $87bIP.default),
                children: title
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kpGzy.default).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$32df1fe4eb2ef4ed$var$NavDropdown.displayName = 'NavDropdown';
var $32df1fe4eb2ef4ed$export$2e2bcd8739ae039 = Object.assign($32df1fe4eb2ef4ed$var$NavDropdown, {
    Item: (0, $kpGzy.default).Item,
    ItemText: (0, $kpGzy.default).ItemText,
    Divider: (0, $kpGzy.default).Divider,
    Header: (0, $kpGzy.default).Header
});

});
parcelRegister("kpGzy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edc72a79517b6a93$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $1Xts3 = parcelRequire("1Xts3");
parcelRequire("ecgdb");
var $9GY4V = parcelRequire("9GY4V");

var $jbhqg = parcelRequire("jbhqg");

var $eMaZ7 = parcelRequire("eMaZ7");

var $1cSgw = parcelRequire("1cSgw");

var $ebKNk = parcelRequire("ebKNk");

var $jTJSG = parcelRequire("jTJSG");

var $11s4n = parcelRequire("11s4n");

var $77wN1 = parcelRequire("77wN1");

var $ipGAg = parcelRequire("ipGAg");

var $fidmb = parcelRequire("fidmb");

var $jbn4d = parcelRequire("jbn4d");


var $bbzbN = parcelRequire("bbzbN");
"use client";
const $edc72a79517b6a93$var$Dropdown = /*#__PURE__*/ $7fPBF.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $9GY4V.default)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $7fPBF.useContext)((0, $fidmb.default));
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown');
    const isRTL = (0, $jbn4d.useIsRTL)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $jbhqg.default)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $77wN1.getDropdownMenuPlacement)(alignEnd, drop, isRTL);
    const contextValue = (0, $7fPBF.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eMaZ7.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1Xts3.default), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$edc72a79517b6a93$var$Dropdown.displayName = 'Dropdown';
var $edc72a79517b6a93$export$2e2bcd8739ae039 = Object.assign($edc72a79517b6a93$var$Dropdown, {
    Toggle: (0, $ipGAg.default),
    Menu: (0, $77wN1.default),
    Item: (0, $jTJSG.default),
    ItemText: (0, $11s4n.default),
    Divider: (0, $1cSgw.default),
    Header: (0, $ebKNk.default)
});

});
parcelRegister("1Xts3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d22591519d9098$export$2e2bcd8739ae039; });

var $cKYDs = parcelRequire("cKYDs");

var $8S3wI = parcelRequire("8S3wI");

var $7fPBF = parcelRequire("7fPBF");

var $k9tSY = parcelRequire("k9tSY");

var $aJTM3 = parcelRequire("aJTM3");

var $aRhbx = parcelRequire("aRhbx");

var $4HOKy = parcelRequire("4HOKy");

var $29zbc = parcelRequire("29zbc");

var $bbYcr = parcelRequire("bbYcr");

var $c3nAg = parcelRequire("c3nAg");

var $f8avL = parcelRequire("f8avL");

var $7dbQL = parcelRequire("7dbQL");

var $cpnTQ = parcelRequire("cpnTQ");

var $1l3ik = parcelRequire("1l3ik");

var $2HPLt = parcelRequire("2HPLt");

var $bbzbN = parcelRequire("bbzbN");
function $16d22591519d9098$var$useRefWithUpdate() {
    const forceUpdate = (0, $aRhbx.default)();
    const ref = (0, $7fPBF.useRef)(null);
    const attachRef = (0, $7fPBF.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $16d22591519d9098$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $1l3ik.dataAttr)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $2HPLt.default)();
    const [show, onToggle] = (0, $k9tSY.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $16d22591519d9098$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $16d22591519d9098$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $aJTM3.default)(show);
    const lastSourceEvent = (0, $7fPBF.useRef)(null);
    const focusInDropdown = (0, $7fPBF.useRef)(false);
    const onSelectCtx = (0, $7fPBF.useContext)((0, $cpnTQ.default));
    const toggle = (0, $7fPBF.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $29zbc.default)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $7fPBF.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $29zbc.default)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $29zbc.default)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $f8avL.isRoleMenu)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $cKYDs.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $7fPBF.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $7fPBF.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $cKYDs.default)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $4HOKy.default)((0, $7fPBF.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $8S3wI.default)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cpnTQ.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbYcr.default).Provider, {
            value: context,
            children: children
        })
    });
}
$16d22591519d9098$var$Dropdown.displayName = 'Dropdown';
$16d22591519d9098$var$Dropdown.Menu = (0, $c3nAg.default);
$16d22591519d9098$var$Dropdown.Toggle = (0, $f8avL.default);
$16d22591519d9098$var$Dropdown.Item = (0, $7dbQL.default);
var $16d22591519d9098$export$2e2bcd8739ae039 = $16d22591519d9098$var$Dropdown;

});
parcelRegister("bbYcr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $825f6b2e3d01a4b8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
const $825f6b2e3d01a4b8$var$DropdownContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $825f6b2e3d01a4b8$export$2e2bcd8739ae039 = $825f6b2e3d01a4b8$var$DropdownContext;

});

parcelRegister("c3nAg", function(module, exports) {

$parcel$export(module.exports, "useDropdownMenu", function () { return $8c680f2044e979de$export$133c4d08f3775d64; });
$parcel$export(module.exports, "default", function () { return $8c680f2044e979de$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $je0yT = parcelRequire("je0yT");

var $bbYcr = parcelRequire("bbYcr");

var $4xfLr = parcelRequire("4xfLr");

var $hLV9x = parcelRequire("hLV9x");

var $jsHER = parcelRequire("jsHER");

var $bbzbN = parcelRequire("bbzbN");
const $8c680f2044e979de$var$_excluded = [
    "children",
    "usePopper"
];
function $8c680f2044e979de$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $8c680f2044e979de$var$noop = ()=>{};
function $8c680f2044e979de$export$133c4d08f3775d64(options = {}) {
    const context = (0, $7fPBF.useContext)((0, $bbYcr.default));
    const [arrowElement, attachArrowRef] = (0, $je0yT.default)();
    const hasShownRef = (0, $7fPBF.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $4xfLr.default)(toggleElement, menuElement, (0, $jsHER.default)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $8c680f2044e979de$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $hLV9x.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $8c680f2044e979de$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $8c680f2044e979de$var$_objectWithoutPropertiesLoose(_ref, $8c680f2044e979de$var$_excluded);
    const [props, meta] = $8c680f2044e979de$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: children(props, meta)
    });
}
$8c680f2044e979de$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $8c680f2044e979de$export$2e2bcd8739ae039 = $8c680f2044e979de$var$DropdownMenu;

});
parcelRegister("4xfLr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d678f0dff4f17f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $gNqsN = parcelRequire("gNqsN");

var $2J5Ze = parcelRequire("2J5Ze");

var $8gi16 = parcelRequire("8gi16");
const $34d678f0dff4f17f$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $34d678f0dff4f17f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $34d678f0dff4f17f$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $34d678f0dff4f17f$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $34d678f0dff4f17f$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $34d678f0dff4f17f$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $34d678f0dff4f17f$var$EMPTY_MODIFIERS } = _ref, config = $34d678f0dff4f17f$var$_objectWithoutPropertiesLoose(_ref, $34d678f0dff4f17f$var$_excluded);
    const prevModifiers = (0, $7fPBF.useRef)(modifiers);
    const popperInstanceRef = (0, $7fPBF.useRef)();
    const update = (0, $7fPBF.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $7fPBF.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $2J5Ze.default)((0, $7fPBF.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $7fPBF.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $7fPBF.useMemo)(()=>{
        if (!(0, $gNqsN.dequal)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $34d678f0dff4f17f$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $8gi16.createPopper)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $34d678f0dff4f17f$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $34d678f0dff4f17f$export$2e2bcd8739ae039 = $34d678f0dff4f17f$var$usePopper;

});
parcelRegister("gNqsN", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $77ed2de27e076439$export$de8294bb3be0322f; });
var $77ed2de27e076439$var$has = Object.prototype.hasOwnProperty;
function $77ed2de27e076439$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($77ed2de27e076439$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $77ed2de27e076439$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $77ed2de27e076439$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $77ed2de27e076439$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $77ed2de27e076439$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$77ed2de27e076439$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($77ed2de27e076439$var$has.call(foo, ctor) && ++len && !$77ed2de27e076439$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$77ed2de27e076439$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});

parcelRegister("2J5Ze", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc46d8af773a097$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $h3OEp = parcelRequire("h3OEp");
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $1fc46d8af773a097$var$useSafeState(state) {
    const isMounted = (0, $h3OEp.default)();
    return [
        state[0],
        (0, $7fPBF.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $1fc46d8af773a097$export$2e2bcd8739ae039 = $1fc46d8af773a097$var$useSafeState;

});

parcelRegister("8gi16", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $603dcb1ad953e751$export$8f7491d57c8f97a9; });

var $jUFYE = parcelRequire("jUFYE");

var $eWblW = parcelRequire("eWblW");

var $1PRym = parcelRequire("1PRym");

var $exXrj = parcelRequire("exXrj");

var $a2tLm = parcelRequire("a2tLm");

var $eylfk = parcelRequire("eylfk");

var $jh6oc = parcelRequire("jh6oc");

var $hOZ6Q = parcelRequire("hOZ6Q");


var $bDLFF = parcelRequire("bDLFF");
const $603dcb1ad953e751$export$8f7491d57c8f97a9 = (0, $bDLFF.popperGenerator)({
    defaultModifiers: [
        (0, $a2tLm.default),
        (0, $jh6oc.default),
        (0, $eWblW.default),
        (0, $1PRym.default),
        (0, $eylfk.default),
        (0, $exXrj.default),
        (0, $hOZ6Q.default),
        (0, $jUFYE.default)
    ]
});

});
parcelRegister("jUFYE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7f3cf13e0769248$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aooBM = parcelRequire("aooBM");

var $ltVxa = parcelRequire("ltVxa");

var $9vuui = parcelRequire("9vuui");

var $4p02M = parcelRequire("4p02M");

var $1MeQS = parcelRequire("1MeQS");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");

var $aHbEK = parcelRequire("aHbEK");
var $e7f3cf13e0769248$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $lVDOe.default)(typeof padding !== 'number' ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
};
function $e7f3cf13e0769248$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var axis = (0, $4p02M.default)(basePlacement);
    var isVertical = [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $e7f3cf13e0769248$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $aooBM.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $aHbEK.top) : (0, $aHbEK.left);
    var maxProp = axis === 'y' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $9vuui.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1MeQS.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $e7f3cf13e0769248$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ltVxa.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $e7f3cf13e0769248$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $e7f3cf13e0769248$var$arrow,
    effect: $e7f3cf13e0769248$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("3ZGTg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e8856bdb677ff8e$export$2e2bcd8739ae039; });

function $2e8856bdb677ff8e$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("aooBM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790f3bf845b39e8e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");
function $790f3bf845b39e8e$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $jTgmx.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("jTgmx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7afd89efa353b85$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");

var $hsTEw = parcelRequire("hsTEw");

var $7LvDQ = parcelRequire("7LvDQ");

var $fv6RK = parcelRequire("fv6RK");
function $e7afd89efa353b85$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $kWkO0.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hsTEw.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hsTEw.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $kWkO0.isElement)(element) ? (0, $7LvDQ.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fv6RK.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("kWkO0", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $f3e95cf60f991b3e$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $f3e95cf60f991b3e$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $f3e95cf60f991b3e$export$af51f0f06c0f328a; });

var $7LvDQ = parcelRequire("7LvDQ");
function $f3e95cf60f991b3e$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $7LvDQ.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $f3e95cf60f991b3e$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $7LvDQ.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $f3e95cf60f991b3e$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $7LvDQ.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("7LvDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7577945ba4d648$export$2e2bcd8739ae039; });
function $5a7577945ba4d648$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("hsTEw", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $cb70389d1b75072d$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cb70389d1b75072d$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cb70389d1b75072d$export$2077e0241d6afd3c; });
var $cb70389d1b75072d$export$8960430cfd85939f = Math.max;
var $cb70389d1b75072d$export$96ec731ed4dcb222 = Math.min;
var $cb70389d1b75072d$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("fv6RK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48f13af3862f004$export$2e2bcd8739ae039; });

var $h7lOM = parcelRequire("h7lOM");
function $b48f13af3862f004$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $h7lOM.default)());
}

});
parcelRegister("h7lOM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c76403bd29ed319a$export$2e2bcd8739ae039; });
function $c76403bd29ed319a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("ltVxa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa38ef77d76834a0$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $fa38ef77d76834a0$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $kWkO0.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("9vuui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6ebea87f6f98e49c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $fRINz = parcelRequire("fRINz");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $KQ9YG = parcelRequire("KQ9YG");

var $d8xUD = parcelRequire("d8xUD");

var $h7lOM = parcelRequire("h7lOM");
function $6ebea87f6f98e49c$var$getTrueOffsetParent(element) {
    if (!(0, $kWkO0.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $5lm85.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $6ebea87f6f98e49c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $h7lOM.default)());
    var isIE = /Trident/i.test((0, $h7lOM.default)());
    if (isIE && (0, $kWkO0.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $5lm85.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $d8xUD.default)(element);
    if ((0, $kWkO0.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $kWkO0.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $fRINz.default)(currentNode)) < 0){
        var css = (0, $5lm85.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $6ebea87f6f98e49c$export$2e2bcd8739ae039(element) {
    var window = (0, $7LvDQ.default)(element);
    var offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $KQ9YG.default)(offsetParent) && (0, $5lm85.default)(offsetParent).position === 'static')offsetParent = $6ebea87f6f98e49c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $fRINz.default)(offsetParent) === 'html' || (0, $fRINz.default)(offsetParent) === 'body' && (0, $5lm85.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $6ebea87f6f98e49c$var$getContainingBlock(element) || window;
}

});
parcelRegister("fRINz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ce8e5214ef2302$export$2e2bcd8739ae039; });
function $b8ce8e5214ef2302$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("5lm85", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e40145ffd569d9c$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $3e40145ffd569d9c$export$2e2bcd8739ae039(element) {
    return (0, $7LvDQ.default)(element).getComputedStyle(element);
}

});

parcelRegister("KQ9YG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08ccc1de57d53c59$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");
function $08ccc1de57d53c59$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $fRINz.default)(element)) >= 0;
}

});

parcelRegister("d8xUD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9906540837c752ea$export$2e2bcd8739ae039; });

var $fRINz = parcelRequire("fRINz");

var $aMuSx = parcelRequire("aMuSx");

var $kWkO0 = parcelRequire("kWkO0");
function $9906540837c752ea$export$2e2bcd8739ae039(element) {
    if ((0, $fRINz.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $kWkO0.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $aMuSx.default)(element) // fallback
    );
}

});
parcelRegister("aMuSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d9656f011992b2b$export$2e2bcd8739ae039; });

var $kWkO0 = parcelRequire("kWkO0");
function $7d9656f011992b2b$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $kWkO0.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("4p02M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $334987ecb6fc56c7$export$2e2bcd8739ae039; });
function $334987ecb6fc56c7$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("1MeQS", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $14b5cb667dce379f$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $14b5cb667dce379f$export$86c8af6d3ef0b4a; });

var $hsTEw = parcelRequire("hsTEw");
function $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max) {
    return (0, $hsTEw.max)(min, (0, $hsTEw.min)(value, max));
}
function $14b5cb667dce379f$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $14b5cb667dce379f$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("lVDOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff6dcd1b0906e9b8$export$2e2bcd8739ae039; });

var $2CmeP = parcelRequire("2CmeP");
function $ff6dcd1b0906e9b8$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2CmeP.default)(), paddingObject);
}

});
parcelRegister("2CmeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e806166c2cdf48d$export$2e2bcd8739ae039; });
function $1e806166c2cdf48d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hf3yY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d699eb93b3090c$export$2e2bcd8739ae039; });
function $c8d699eb93b3090c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});

parcelRegister("aHbEK", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $7c96f63dd602b579$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $7c96f63dd602b579$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $7c96f63dd602b579$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $7c96f63dd602b579$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $7c96f63dd602b579$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $7c96f63dd602b579$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $7c96f63dd602b579$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $7c96f63dd602b579$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $7c96f63dd602b579$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $7c96f63dd602b579$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $7c96f63dd602b579$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $7c96f63dd602b579$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $7c96f63dd602b579$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $7c96f63dd602b579$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $7c96f63dd602b579$export$d087d3878fdf71d5; });
var $7c96f63dd602b579$export$1e95b668f3b82d = 'top';
var $7c96f63dd602b579$export$40e543e69a8b3fbb = 'bottom';
var $7c96f63dd602b579$export$79ffe56a765070d2 = 'right';
var $7c96f63dd602b579$export$eabcd2c8791e7bf4 = 'left';
var $7c96f63dd602b579$export$dfb5619354ba860 = 'auto';
var $7c96f63dd602b579$export$aec2ce47c367b8c3 = [
    $7c96f63dd602b579$export$1e95b668f3b82d,
    $7c96f63dd602b579$export$40e543e69a8b3fbb,
    $7c96f63dd602b579$export$79ffe56a765070d2,
    $7c96f63dd602b579$export$eabcd2c8791e7bf4
];
var $7c96f63dd602b579$export$b3571188c770cc5a = 'start';
var $7c96f63dd602b579$export$bd5df0f255a350f8 = 'end';
var $7c96f63dd602b579$export$390fd549c5303b4d = 'clippingParents';
var $7c96f63dd602b579$export$d7b7311ec04a3e8f = 'viewport';
var $7c96f63dd602b579$export$ae5ab1c730825774 = 'popper';
var $7c96f63dd602b579$export$ca50aac9f3ba507f = 'reference';
var $7c96f63dd602b579$export$368f9a87e87fa4e1 = /*#__PURE__*/ $7c96f63dd602b579$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []);
var $7c96f63dd602b579$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($7c96f63dd602b579$export$aec2ce47c367b8c3, [
    $7c96f63dd602b579$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $7c96f63dd602b579$export$b3571188c770cc5a,
        placement + "-" + $7c96f63dd602b579$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $7c96f63dd602b579$export$421679a7c3d56e = 'beforeRead';
var $7c96f63dd602b579$export$aafa59e2e03f2942 = 'read';
var $7c96f63dd602b579$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $7c96f63dd602b579$export$c65e99957a05207c = 'beforeMain';
var $7c96f63dd602b579$export$f22da7240b7add18 = 'main';
var $7c96f63dd602b579$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $7c96f63dd602b579$export$8d4d2d70e7d46032 = 'beforeWrite';
var $7c96f63dd602b579$export$68d8715fc104d294 = 'write';
var $7c96f63dd602b579$export$70a6e5159acce2e6 = 'afterWrite';
var $7c96f63dd602b579$export$d087d3878fdf71d5 = [
    $7c96f63dd602b579$export$421679a7c3d56e,
    $7c96f63dd602b579$export$aafa59e2e03f2942,
    $7c96f63dd602b579$export$6964f6c886723980,
    $7c96f63dd602b579$export$c65e99957a05207c,
    $7c96f63dd602b579$export$f22da7240b7add18,
    $7c96f63dd602b579$export$bab79516f2d662fe,
    $7c96f63dd602b579$export$8d4d2d70e7d46032,
    $7c96f63dd602b579$export$68d8715fc104d294,
    $7c96f63dd602b579$export$70a6e5159acce2e6
];

});


parcelRegister("eWblW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $adff49e8d09ee1e5$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $9vuui = parcelRequire("9vuui");

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $hsTEw = parcelRequire("hsTEw");
var $adff49e8d09ee1e5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $adff49e8d09ee1e5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hsTEw.round)(x * dpr) / dpr || 0,
        y: (0, $hsTEw.round)(y * dpr) / dpr || 0
    };
}
function $adff49e8d09ee1e5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $aHbEK.left);
    var sideY = (0, $aHbEK.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $9vuui.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $7LvDQ.default)(popper)) {
            offsetParent = (0, $aMuSx.default)(popper);
            if ((0, $5lm85.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $aHbEK.top) || (placement === (0, $aHbEK.left) || placement === (0, $aHbEK.right)) && variation === (0, $aHbEK.end)) {
            sideY = (0, $aHbEK.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $aHbEK.left) || (placement === (0, $aHbEK.top) || placement === (0, $aHbEK.bottom)) && variation === (0, $aHbEK.end)) {
            sideX = (0, $aHbEK.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $adff49e8d09ee1e5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $adff49e8d09ee1e5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $7LvDQ.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $adff49e8d09ee1e5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3ZGTg.default)(state.placement),
        variation: (0, $hD45i.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $adff49e8d09ee1e5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $adff49e8d09ee1e5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $adff49e8d09ee1e5$var$computeStyles,
    data: {}
};

});
parcelRegister("hD45i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd593f453867f36a$export$2e2bcd8739ae039; });
function $cd593f453867f36a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("1PRym", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1564186ea0096528$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
var $1564186ea0096528$var$passive = {
    passive: true
};
function $1564186ea0096528$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $7LvDQ.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $1564186ea0096528$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $1564186ea0096528$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $1564186ea0096528$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $1564186ea0096528$var$effect,
    data: {}
};

});

parcelRegister("exXrj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a97241372b70cd07$export$2e2bcd8739ae039; });

var $910or = parcelRequire("910or");

var $3ZGTg = parcelRequire("3ZGTg");

var $1EPiP = parcelRequire("1EPiP");

var $74FGG = parcelRequire("74FGG");

var $ewHfg = parcelRequire("ewHfg");

var $aHbEK = parcelRequire("aHbEK");

var $hD45i = parcelRequire("hD45i");
function $a97241372b70cd07$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto)) return [];
    var oppositePlacement = (0, $910or.default)(placement);
    return [
        (0, $1EPiP.default)(placement),
        oppositePlacement,
        (0, $1EPiP.default)(oppositePlacement)
    ];
}
function $a97241372b70cd07$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3ZGTg.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $910or.default)(preferredPlacement)
    ] : $a97241372b70cd07$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3ZGTg.default)(placement) === (0, $aHbEK.auto) ? (0, $ewHfg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3ZGTg.default)(placement);
        var isStartVariation = (0, $hD45i.default)(placement) === (0, $aHbEK.start);
        var isVertical = [
            (0, $aHbEK.top),
            (0, $aHbEK.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $aHbEK.right) : (0, $aHbEK.left) : isStartVariation ? (0, $aHbEK.bottom) : (0, $aHbEK.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $910or.default)(mainVariationSide);
        var altVariationSide = (0, $910or.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a97241372b70cd07$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a97241372b70cd07$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("910or", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690483208b9a3207$export$2e2bcd8739ae039; });
var $690483208b9a3207$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $690483208b9a3207$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $690483208b9a3207$var$hash[matched];
    });
}

});

parcelRegister("1EPiP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13515282412eb271$export$2e2bcd8739ae039; });
var $13515282412eb271$var$hash = {
    start: 'end',
    end: 'start'
};
function $13515282412eb271$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $13515282412eb271$var$hash[matched];
    });
}

});

parcelRegister("74FGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52693e6050d55014$export$2e2bcd8739ae039; });

var $bxNPU = parcelRequire("bxNPU");

var $aMuSx = parcelRequire("aMuSx");

var $jTgmx = parcelRequire("jTgmx");

var $gIQYz = parcelRequire("gIQYz");

var $245PV = parcelRequire("245PV");

var $aHbEK = parcelRequire("aHbEK");

var $kWkO0 = parcelRequire("kWkO0");

var $lVDOe = parcelRequire("lVDOe");

var $hf3yY = parcelRequire("hf3yY");
function $52693e6050d55014$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $aHbEK.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $aHbEK.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $aHbEK.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $lVDOe.default)(typeof padding !== 'number' ? padding : (0, $hf3yY.default)(padding, (0, $aHbEK.basePlacements)));
    var altContext = elementContext === (0, $aHbEK.popper) ? (0, $aHbEK.reference) : (0, $aHbEK.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $bxNPU.default)((0, $kWkO0.isElement)(element) ? element : element.contextElement || (0, $aMuSx.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $jTgmx.default)(state.elements.reference);
    var popperOffsets = (0, $gIQYz.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $245PV.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $aHbEK.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $aHbEK.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $aHbEK.right),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $aHbEK.top),
                (0, $aHbEK.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("bxNPU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86796f3d3717fc99$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $tIQGN = parcelRequire("tIQGN");

var $kNUmP = parcelRequire("kNUmP");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $kWkO0 = parcelRequire("kWkO0");

var $jTgmx = parcelRequire("jTgmx");

var $d8xUD = parcelRequire("d8xUD");

var $ltVxa = parcelRequire("ltVxa");

var $fRINz = parcelRequire("fRINz");

var $245PV = parcelRequire("245PV");

var $hsTEw = parcelRequire("hsTEw");
function $86796f3d3717fc99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $jTgmx.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $aHbEK.viewport) ? (0, $245PV.default)((0, $tIQGN.default)(element, strategy)) : (0, $kWkO0.isElement)(clippingParent) ? $86796f3d3717fc99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $245PV.default)((0, $kNUmP.default)((0, $aMuSx.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $86796f3d3717fc99$var$getClippingParents(element) {
    var clippingParents = (0, $5fhgl.default)((0, $d8xUD.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $5lm85.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $kWkO0.isHTMLElement)(element) ? (0, $9vuui.default)(element) : element;
    if (!(0, $kWkO0.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $kWkO0.isElement)(clippingParent) && (0, $ltVxa.default)(clippingParent, clipperElement) && (0, $fRINz.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $86796f3d3717fc99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $86796f3d3717fc99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $86796f3d3717fc99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hsTEw.max)(rect.top, accRect.top);
        accRect.right = (0, $hsTEw.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hsTEw.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hsTEw.max)(rect.left, accRect.left);
        return accRect;
    }, $86796f3d3717fc99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("tIQGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05957f974ad3b041$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");

var $aMuSx = parcelRequire("aMuSx");

var $jhPl0 = parcelRequire("jhPl0");

var $fv6RK = parcelRequire("fv6RK");
function $05957f974ad3b041$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $7LvDQ.default)(element);
    var html = (0, $aMuSx.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fv6RK.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $jhPl0.default)(element),
        y: y
    };
}

});
parcelRegister("jhPl0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0a76d77d33c9d6e$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $aMuSx = parcelRequire("aMuSx");

var $k28Ly = parcelRequire("k28Ly");
function $e0a76d77d33c9d6e$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $jTgmx.default)((0, $aMuSx.default)(element)).left + (0, $k28Ly.default)(element).scrollLeft;
}

});
parcelRegister("k28Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e95acb4acf5ee909$export$2e2bcd8739ae039; });

var $7LvDQ = parcelRequire("7LvDQ");
function $e95acb4acf5ee909$export$2e2bcd8739ae039(node) {
    var win = (0, $7LvDQ.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("kNUmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2541b971d258cf0$export$2e2bcd8739ae039; });

var $aMuSx = parcelRequire("aMuSx");

var $5lm85 = parcelRequire("5lm85");

var $jhPl0 = parcelRequire("jhPl0");

var $k28Ly = parcelRequire("k28Ly");

var $hsTEw = parcelRequire("hsTEw");
function $f2541b971d258cf0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $aMuSx.default)(element);
    var winScroll = (0, $k28Ly.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hsTEw.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hsTEw.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $jhPl0.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $5lm85.default)(body || html).direction === 'rtl') x += (0, $hsTEw.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("5fhgl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d1bbe7c8c599173$export$2e2bcd8739ae039; });

var $2vPbO = parcelRequire("2vPbO");

var $d8xUD = parcelRequire("d8xUD");

var $7LvDQ = parcelRequire("7LvDQ");

var $dbfQ4 = parcelRequire("dbfQ4");
function $3d1bbe7c8c599173$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2vPbO.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $7LvDQ.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $dbfQ4.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3d1bbe7c8c599173$export$2e2bcd8739ae039((0, $d8xUD.default)(target)));
}

});
parcelRegister("2vPbO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d462f2c86b4c65a$export$2e2bcd8739ae039; });

var $d8xUD = parcelRequire("d8xUD");

var $dbfQ4 = parcelRequire("dbfQ4");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");
function $1d462f2c86b4c65a$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $fRINz.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $kWkO0.isHTMLElement)(node) && (0, $dbfQ4.default)(node)) return node;
    return $1d462f2c86b4c65a$export$2e2bcd8739ae039((0, $d8xUD.default)(node));
}

});
parcelRegister("dbfQ4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $998896b7349c78b7$export$2e2bcd8739ae039; });

var $5lm85 = parcelRequire("5lm85");
function $998896b7349c78b7$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $5lm85.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("245PV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18107b7e48021ffa$export$2e2bcd8739ae039; });
function $18107b7e48021ffa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("gIQYz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c9d9550c09d816$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $hD45i = parcelRequire("hD45i");

var $4p02M = parcelRequire("4p02M");

var $aHbEK = parcelRequire("aHbEK");
function $c2c9d9550c09d816$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3ZGTg.default)(placement) : null;
    var variation = placement ? (0, $hD45i.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $aHbEK.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $aHbEK.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $aHbEK.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $aHbEK.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4p02M.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $aHbEK.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $aHbEK.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("ewHfg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a935996b3496591b$export$2e2bcd8739ae039; });

var $hD45i = parcelRequire("hD45i");

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");

var $3ZGTg = parcelRequire("3ZGTg");
function $a935996b3496591b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $aHbEK.placements) : _options$allowedAutoP;
    var variation = (0, $hD45i.default)(placement);
    var placements = variation ? flipVariations ? (0, $aHbEK.variationPlacements) : (0, $aHbEK.variationPlacements).filter(function(placement) {
        return (0, $hD45i.default)(placement) === variation;
    }) : (0, $aHbEK.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $74FGG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3ZGTg.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("a2tLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f12d998f890694$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $74FGG = parcelRequire("74FGG");
function $74f12d998f890694$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $74f12d998f890694$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $aHbEK.top),
        (0, $aHbEK.right),
        (0, $aHbEK.bottom),
        (0, $aHbEK.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $74f12d998f890694$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $74FGG.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $74FGG.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $74f12d998f890694$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $74f12d998f890694$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $74f12d998f890694$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $74f12d998f890694$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $74f12d998f890694$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $74f12d998f890694$var$hide
};

});

parcelRegister("eylfk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a984b8b647b41eeb$export$2e2bcd8739ae039; });

var $3ZGTg = parcelRequire("3ZGTg");

var $aHbEK = parcelRequire("aHbEK");
function $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3ZGTg.default)(placement);
    var invertDistance = [
        (0, $aHbEK.left),
        (0, $aHbEK.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $aHbEK.left),
        (0, $aHbEK.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a984b8b647b41eeb$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $aHbEK.placements).reduce(function(acc, placement) {
        acc[placement] = $a984b8b647b41eeb$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a984b8b647b41eeb$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a984b8b647b41eeb$var$offset
};

});

parcelRegister("jh6oc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0848fa64ca744df$export$2e2bcd8739ae039; });

var $gIQYz = parcelRequire("gIQYz");
function $e0848fa64ca744df$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $gIQYz.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0848fa64ca744df$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0848fa64ca744df$var$popperOffsets,
    data: {}
};

});

parcelRegister("hOZ6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf968237b9d7dd4a$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");

var $3ZGTg = parcelRequire("3ZGTg");

var $4p02M = parcelRequire("4p02M");

var $c8xyK = parcelRequire("c8xyK");

var $1MeQS = parcelRequire("1MeQS");

var $aooBM = parcelRequire("aooBM");

var $9vuui = parcelRequire("9vuui");

var $74FGG = parcelRequire("74FGG");

var $hD45i = parcelRequire("hD45i");

var $2CmeP = parcelRequire("2CmeP");

var $hsTEw = parcelRequire("hsTEw");
function $cf968237b9d7dd4a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $74FGG.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3ZGTg.default)(state.placement);
    var variation = (0, $hD45i.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4p02M.default)(basePlacement);
    var altAxis = (0, $c8xyK.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var altSide = mainAxis === 'y' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $aHbEK.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $aHbEK.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $aooBM.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $2CmeP.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1MeQS.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $9vuui.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1MeQS.within)(tether ? (0, $hsTEw.min)(min, tetherMin) : min, offset, tether ? (0, $hsTEw.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $aHbEK.top) : (0, $aHbEK.left);
        var _altSide = mainAxis === 'x' ? (0, $aHbEK.bottom) : (0, $aHbEK.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $aHbEK.top),
            (0, $aHbEK.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1MeQS.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1MeQS.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $cf968237b9d7dd4a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $cf968237b9d7dd4a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("c8xyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d60439f259d6a8c$export$2e2bcd8739ae039; });
function $8d60439f259d6a8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});


parcelRegister("bDLFF", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $879850b738b0fd85$export$ed5e13716264f202; });

var $7A5zv = parcelRequire("7A5zv");

var $aooBM = parcelRequire("aooBM");

var $5fhgl = parcelRequire("5fhgl");

var $9vuui = parcelRequire("9vuui");

var $1HbbS = parcelRequire("1HbbS");

var $6zw26 = parcelRequire("6zw26");

var $4irPP = parcelRequire("4irPP");


var $kWkO0 = parcelRequire("kWkO0");
var $879850b738b0fd85$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $879850b738b0fd85$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $879850b738b0fd85$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $879850b738b0fd85$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $879850b738b0fd85$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $kWkO0.isElement)(reference) ? (0, $5fhgl.default)(reference) : reference.contextElement ? (0, $5fhgl.default)(reference.contextElement) : [],
                    popper: (0, $5fhgl.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $1HbbS.default)((0, $4irPP.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $7A5zv.default)(reference, (0, $9vuui.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $aooBM.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $6zw26.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$879850b738b0fd85$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $879850b738b0fd85$export$8f7491d57c8f97a9 = /*#__PURE__*/ $879850b738b0fd85$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("7A5zv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $585037a155f95873$export$2e2bcd8739ae039; });

var $jTgmx = parcelRequire("jTgmx");

var $luMSI = parcelRequire("luMSI");

var $fRINz = parcelRequire("fRINz");

var $kWkO0 = parcelRequire("kWkO0");

var $jhPl0 = parcelRequire("jhPl0");

var $aMuSx = parcelRequire("aMuSx");

var $dbfQ4 = parcelRequire("dbfQ4");

var $hsTEw = parcelRequire("hsTEw");
function $585037a155f95873$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hsTEw.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hsTEw.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $585037a155f95873$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $kWkO0.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $kWkO0.isHTMLElement)(offsetParent) && $585037a155f95873$var$isElementScaled(offsetParent);
    var documentElement = (0, $aMuSx.default)(offsetParent);
    var rect = (0, $jTgmx.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $fRINz.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $dbfQ4.default)(documentElement)) scroll = (0, $luMSI.default)(offsetParent);
        if ((0, $kWkO0.isHTMLElement)(offsetParent)) {
            offsets = (0, $jTgmx.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $jhPl0.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("luMSI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa62512f527d34a4$export$2e2bcd8739ae039; });

var $k28Ly = parcelRequire("k28Ly");

var $7LvDQ = parcelRequire("7LvDQ");

var $kWkO0 = parcelRequire("kWkO0");

var $91ESz = parcelRequire("91ESz");
function $fa62512f527d34a4$export$2e2bcd8739ae039(node) {
    if (node === (0, $7LvDQ.default)(node) || !(0, $kWkO0.isHTMLElement)(node)) return (0, $k28Ly.default)(node);
    else return (0, $91ESz.default)(node);
}

});
parcelRegister("91ESz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6923eaccf7a43aef$export$2e2bcd8739ae039; });
function $6923eaccf7a43aef$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("1HbbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13c27cceb4b24b2f$export$2e2bcd8739ae039; });

var $aHbEK = parcelRequire("aHbEK");
function $13c27cceb4b24b2f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $13c27cceb4b24b2f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $13c27cceb4b24b2f$var$order(modifiers); // order based on phase
    return (0, $aHbEK.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("6zw26", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c8edc0cb4d5666b$export$2e2bcd8739ae039; });
function $4c8edc0cb4d5666b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("4irPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $320e6f4d2835a922$export$2e2bcd8739ae039; });
function $320e6f4d2835a922$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});




parcelRegister("hLV9x", function(module, exports) {

$parcel$export(module.exports, "getRefTarget", function () { return $cf0328cb57381dc4$export$347601c75fcd4732; });
$parcel$export(module.exports, "default", function () { return $cf0328cb57381dc4$export$2e2bcd8739ae039; });

var $lvBJh = parcelRequire("lvBJh");

var $22FgH = parcelRequire("22FgH");

var $eSNaH = parcelRequire("eSNaH");

var $7fPBF = parcelRequire("7fPBF");

var $29zbc = parcelRequire("29zbc");

var $6Buvl = parcelRequire("6Buvl");
const $cf0328cb57381dc4$var$noop = ()=>{};
function $cf0328cb57381dc4$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $cf0328cb57381dc4$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $cf0328cb57381dc4$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $cf0328cb57381dc4$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $cf0328cb57381dc4$var$useClickOutside(ref, onClickOutside = $cf0328cb57381dc4$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $7fPBF.useRef)(false);
    const waitingForTrigger = (0, $7fPBF.useRef)(false);
    const handleMouseCapture = (0, $7fPBF.useCallback)((e)=>{
        const currentTarget = $cf0328cb57381dc4$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $cf0328cb57381dc4$var$isModifiedEvent(e) || !$cf0328cb57381dc4$var$isLeftClickEvent(e) || !!(0, $lvBJh.default)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $29zbc.default)((e)=>{
        const currentTarget = $cf0328cb57381dc4$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $lvBJh.default)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $29zbc.default)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $7fPBF.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $eSNaH.default)($cf0328cb57381dc4$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($cf0328cb57381dc4$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $22FgH.default)(doc, $cf0328cb57381dc4$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $22FgH.default)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $22FgH.default)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $22FgH.default)(el, 'mousemove', $cf0328cb57381dc4$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $cf0328cb57381dc4$export$2e2bcd8739ae039 = $cf0328cb57381dc4$var$useClickOutside;

});

parcelRegister("jsHER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2b27f6b17c85bfc$export$2e2bcd8739ae039; });
function $e2b27f6b17c85bfc$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $e2b27f6b17c85bfc$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $e2b27f6b17c85bfc$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $e2b27f6b17c85bfc$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $e2b27f6b17c85bfc$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

});


parcelRegister("f8avL", function(module, exports) {

$parcel$export(module.exports, "isRoleMenu", function () { return $b03fc1b53e02d641$export$386b1213cf9779d8; });
$parcel$export(module.exports, "useDropdownToggle", function () { return $b03fc1b53e02d641$export$96df6c7c5036b9a2; });
$parcel$export(module.exports, "default", function () { return $b03fc1b53e02d641$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $kLJoI = parcelRequire("kLJoI");

var $bbYcr = parcelRequire("bbYcr");

var $bbzbN = parcelRequire("bbzbN");
const $b03fc1b53e02d641$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $b03fc1b53e02d641$var$noop = ()=>{};
function $b03fc1b53e02d641$export$96df6c7c5036b9a2() {
    const id = (0, $kLJoI.useSSRSafeId)();
    const { show: show = false, toggle: toggle = $b03fc1b53e02d641$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $7fPBF.useContext)((0, $bbYcr.default)) || {};
    const handleClick = (0, $7fPBF.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $b03fc1b53e02d641$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $b03fc1b53e02d641$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $b03fc1b53e02d641$var$DropdownToggle({ children: children }) {
    const [props, meta] = $b03fc1b53e02d641$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: children(props, meta)
    });
}
$b03fc1b53e02d641$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $b03fc1b53e02d641$export$2e2bcd8739ae039 = $b03fc1b53e02d641$var$DropdownToggle;

});

parcelRegister("7dbQL", function(module, exports) {

$parcel$export(module.exports, "useDropdownItem", function () { return $5402f076181b4b72$export$522d7e1e4e0e22b2; });
$parcel$export(module.exports, "default", function () { return $5402f076181b4b72$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $29zbc = parcelRequire("29zbc");

var $cpnTQ = parcelRequire("cpnTQ");

var $68Mia = parcelRequire("68Mia");

var $bqB2L = parcelRequire("bqB2L");

var $1l3ik = parcelRequire("1l3ik");

var $bbzbN = parcelRequire("bbzbN");
const $5402f076181b4b72$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $5402f076181b4b72$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $5402f076181b4b72$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $7fPBF.useContext)((0, $cpnTQ.default));
    const navContext = (0, $7fPBF.useContext)((0, $68Mia.default));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $cpnTQ.makeEventKey)(key, href);
    const isActive = active == null && key != null ? (0, $cpnTQ.makeEventKey)(activeKey) === eventKey : active;
    const handleClick = (0, $29zbc.default)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $1l3ik.dataAttr)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $5402f076181b4b72$var$DropdownItem = /*#__PURE__*/ $7fPBF.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $bqB2L.default) } = _ref, props = $5402f076181b4b72$var$_objectWithoutPropertiesLoose(_ref, $5402f076181b4b72$var$_excluded);
    const [dropdownItemProps] = $5402f076181b4b72$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$5402f076181b4b72$var$DropdownItem.displayName = 'DropdownItem';
var $5402f076181b4b72$export$2e2bcd8739ae039 = $5402f076181b4b72$var$DropdownItem;

});


parcelRegister("eMaZ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1e11bf562da125$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $ac1e11bf562da125$var$DropdownContext = /*#__PURE__*/ $7fPBF.createContext({});
$ac1e11bf562da125$var$DropdownContext.displayName = 'DropdownContext';
var $ac1e11bf562da125$export$2e2bcd8739ae039 = $ac1e11bf562da125$var$DropdownContext;

});

parcelRegister("1cSgw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e1101693551e379$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $0e1101693551e379$var$DropdownDivider = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$0e1101693551e379$var$DropdownDivider.displayName = 'DropdownDivider';
var $0e1101693551e379$export$2e2bcd8739ae039 = $0e1101693551e379$var$DropdownDivider;

});

parcelRegister("ebKNk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a546642f738d48e4$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a546642f738d48e4$var$DropdownHeader = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$a546642f738d48e4$var$DropdownHeader.displayName = 'DropdownHeader';
var $a546642f738d48e4$export$2e2bcd8739ae039 = $a546642f738d48e4$var$DropdownHeader;

});

parcelRegister("jTJSG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7c6be5e9d651d1a$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $7dbQL = parcelRequire("7dbQL");

var $hq4kX = parcelRequire("hq4kX");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $e7c6be5e9d651d1a$var$DropdownItem = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $hq4kX.default), ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $7dbQL.useDropdownItem)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$e7c6be5e9d651d1a$var$DropdownItem.displayName = 'DropdownItem';
var $e7c6be5e9d651d1a$export$2e2bcd8739ae039 = $e7c6be5e9d651d1a$var$DropdownItem;

});

parcelRegister("11s4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0beba87f0a7c0733$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $0beba87f0a7c0733$var$DropdownItemText = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$0beba87f0a7c0733$var$DropdownItemText.displayName = 'DropdownItemText';
var $0beba87f0a7c0733$export$2e2bcd8739ae039 = $0beba87f0a7c0733$var$DropdownItemText;

});

parcelRegister("77wN1", function(module, exports) {

$parcel$export(module.exports, "getDropdownMenuPlacement", function () { return $52f29f38e4995775$export$a2c648e264f4a946; });
$parcel$export(module.exports, "default", function () { return $52f29f38e4995775$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $c3nAg = parcelRequire("c3nAg");

var $lKzMT = parcelRequire("lKzMT");

var $kbUnX = parcelRequire("kbUnX");

var $6Buvl = parcelRequire("6Buvl");

var $eMaZ7 = parcelRequire("eMaZ7");

var $fidmb = parcelRequire("fidmb");

var $2VW10 = parcelRequire("2VW10");

var $jbn4d = parcelRequire("jbn4d");

var $6V1ZJ = parcelRequire("6V1ZJ");


var $bbzbN = parcelRequire("bbzbN");
"use client";
function $52f29f38e4995775$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $52f29f38e4995775$var$DropdownMenu = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $7fPBF.useContext)((0, $2VW10.default));
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $7fPBF.useContext)((0, $eMaZ7.default));
    align = align || contextAlign;
    const isInputGroup = (0, $7fPBF.useContext)((0, $fidmb.default));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(keys.length === 1, 'There should only be 1 breakpoint when passing an object to `align`');
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $52f29f38e4995775$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $c3nAg.useDropdownMenu)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $kbUnX.default)((0, $6V1ZJ.default)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $lKzMT.default)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$52f29f38e4995775$var$DropdownMenu.displayName = 'DropdownMenu';
var $52f29f38e4995775$export$2e2bcd8739ae039 = $52f29f38e4995775$var$DropdownMenu;

});
parcelRegister("fidmb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b222e5d62d7337cc$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $b222e5d62d7337cc$var$context = /*#__PURE__*/ $7fPBF.createContext(null);
$b222e5d62d7337cc$var$context.displayName = 'InputGroupContext';
var $b222e5d62d7337cc$export$2e2bcd8739ae039 = $b222e5d62d7337cc$var$context;

});

parcelRegister("6V1ZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50999d130f7fd0e0$export$2e2bcd8739ae039; });

var $9ZxFg = parcelRequire("9ZxFg");

var $7fPBF = parcelRequire("7fPBF");

var $kbUnX = parcelRequire("kbUnX");
function $50999d130f7fd0e0$export$2e2bcd8739ae039(ref, componentName) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const warningRef = (0, $7fPBF.useCallback)((refValue)=>{
        !(refValue == null || !refValue.isReactComponent) && (0, (/*@__PURE__*/$parcel$interopDefault($9ZxFg)))(false, `${componentName} injected a ref to a provided \`as\` component that resolved to a component instance instead of a DOM element. ` + 'Use `React.forwardRef` to provide the injected ref to the class component as a prop in order to pass it directly to a DOM element');
    }, [
        componentName
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $kbUnX.default)(warningRef, ref);
}

});


parcelRegister("ipGAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d67b9813666e076f$export$2e2bcd8739ae039; });

var $kbUnX = parcelRequire("kbUnX");

var $bbYcr = parcelRequire("bbYcr");

var $f8avL = parcelRequire("f8avL");

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $b6fw7 = parcelRequire("b6fw7");

var $jbn4d = parcelRequire("jbn4d");

var $6V1ZJ = parcelRequire("6V1ZJ");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $d67b9813666e076f$var$DropdownToggle = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $b6fw7.default), ...props }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $7fPBF.useContext)((0, $bbYcr.default));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $f8avL.useDropdownToggle)();
    toggleProps.ref = (0, $kbUnX.default)(toggleProps.ref, (0, $6V1ZJ.default)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$d67b9813666e076f$var$DropdownToggle.displayName = 'DropdownToggle';
var $d67b9813666e076f$export$2e2bcd8739ae039 = $d67b9813666e076f$var$DropdownToggle;

});




parcelRegister("joxdZ", function(module, exports) {

$parcel$export(module.exports, "RightDropMenu", function () { return $392d0f61d1815657$export$9e7bb86d1e89feab; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $k78S3 = parcelRequire("k78S3");

var $hNiQC = parcelRequire("hNiQC");

var $6FqTq = parcelRequire("6FqTq");

var $bAMg4 = parcelRequire("bAMg4");

var $ICooD = parcelRequire("ICooD");
const $392d0f61d1815657$export$9e7bb86d1e89feab = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        id: "rhs-menu",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).rightNav,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bAMg4.TocNavigate), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k78S3.default).Text, {
                id: "rightdropmenu-displayname",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ICooD))).rightNavText,
                children: appSettings.displayName
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hNiQC.HelpLinkDropDown), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6FqTq.NotificationsButton), {})
        ]
    });
};
$392d0f61d1815657$export$9e7bb86d1e89feab.displayName = "RightDropMenu";

});
parcelRegister("hNiQC", function(module, exports) {

$parcel$export(module.exports, "HelpLinkDropDown", function () { return $70dd9e481709808b$export$a2b0e0b3122aace; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $4mMRX = parcelRequire("4mMRX");

var $gxpCl = parcelRequire("gxpCl");
const $70dd9e481709808b$export$a2b0e0b3122aace = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $4mMRX.default), {
        id: "topbar-help",
        title: "Help",
        children: [
            (appSettings.isAdmin || appSettings.applicationPermissions.filter((p)=>[
                    (0, $7Wd8C.eApplicationPermission).AllowHelpEdit,
                    (0, $7Wd8C.eApplicationPermission).AllowNewsEdit
                ].includes(p)).length > 0) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                id: "topbar-admin-link",
                as: (0, $gxpCl.Link),
                to: "/Admin#news",
                children: "Admin page"
            }),
            appSettings.helpLinks.map((h, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                    id: `topbar-help-link-${i}`,
                    target: "_blank",
                    href: h.linkUrl,
                    children: h.linkLabel
                }, i))
        ]
    });
};
$70dd9e481709808b$export$a2b0e0b3122aace.displayName = "HelpLinkDropDown";

});

parcelRegister("6FqTq", function(module, exports) {

$parcel$export(module.exports, "NotificationsButton", function () { return $8f8721b31dbe7c77$export$40e326b1271b1326; });

var $bbzbN = parcelRequire("bbzbN");

var $hGHEx = parcelRequire("hGHEx");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $wPq5H = parcelRequire("wPq5H");

var $9Jgpw = parcelRequire("9Jgpw");

var $gD2t9 = parcelRequire("gD2t9");

var $7KklJ = parcelRequire("7KklJ");

var $dDC3L = parcelRequire("dDC3L");

var $4PTZu = parcelRequire("4PTZu");

var $boY0Q = parcelRequire("boY0Q");

var $7fPBF = parcelRequire("7fPBF");

var $bNVAi = parcelRequire("bNVAi");
var $5M3sM = parcelRequire("5M3sM");

var $eETAC = parcelRequire("eETAC");

var $gxpCl = parcelRequire("gxpCl");

var $dhn58 = parcelRequire("dhn58");
const $8f8721b31dbe7c77$export$40e326b1271b1326 = ()=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const signalR = (0, $7fPBF.useContext)((0, $gD2t9.SignalRContext));
    const connection = signalR?.connection;
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("topbar-notifications-button");
    const [searchParams] = (0, $gxpCl.useSearchParams)();
    const urlParams = (0, $gxpCl.useParams)();
    const [loadRequest, setLoadRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [notificationsList, setNotificationsList] = (0, $7fPBF.useState)([]);
    const [showNotifications, setShowNotifications] = (0, $7fPBF.useState)(false);
    const newNotificationCount = notificationsList.filter((rn)=>!rn.notificationViewed).length;
    const loadNotifications = (0, $7fPBF.useEffectEvent)(async ()=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $boY0Q.getUserNotifications), "load", loadRequest, setLoadRequest, appSettings.backEndUrl);
        if (response?.success) startTransition(()=>setNotificationsList(response.data));
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!loadRequest.requesting && !loadRequest.requestedId && !loadRequest.error) loadNotifications();
    }, [
        loadRequest
    ]);
    const [sendGroupRequest, setSendGroupRequest] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (connection && connection.state === (0, $hGHEx.HubConnectionState).Connected && !sendGroupRequest && appSettings.userId) {
            signalR.connectToGroup(`user-${appSettings.userId}`);
            startTransition(()=>{
                setSendGroupRequest(true);
            });
        }
    }, [
        appSettings.userId,
        connection,
        connection?.state,
        sendGroupRequest,
        signalR
    ]);
    /**
   * Process comments update messages from back end
   */ (0, $7fPBF.useEffect)(()=>{
        /**
     * Process a SignalR group message containing comments updates.
     *
     * @param message - JSON string payload describing the update
     */ const processCommentsMessage = (message)=>{
            const update = JSON.parse(message);
            if (update.messageType === "commentsUpdate" && update.comments) setNotificationsList(update.comments);
        };
        signalR?.connection?.on("SendMessageToGroup", processCommentsMessage);
    // return () => {
    //   signalR?.connection?.off("SendMessageToGroup", processCommentsMessage);
    // };
    }, [
        signalR
    ]);
    const setCommentPanelStatusInContext = (0, $7fPBF.useEffectEvent)((highlightCommentId, showComments, notificationContext)=>{
        let redirectUrl = "";
        /* istanbul ignore else */ if (notificationContext === "Hierarchy" && hierarchyContext?.hierarchy) {
            hierarchyContext.dispatch({
                operation: (0, $9Jgpw.SET_HIERARCHY_COMMENT_PANEL),
                commentPanelStatus: {
                    ...hierarchyContext.commentPanelStatus,
                    highlightCommentId: highlightCommentId,
                    showComments: showComments
                }
            });
            redirectUrl = (0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy);
        } else if (notificationContext === "TlfItem" && tlfContext.tlfData && hierarchyContext?.hierarchy) {
            tlfContext.dispatch({
                operation: (0, $dDC3L.SET_TLF_COMMENT_PANEL),
                commentPanelStatus: {
                    ...tlfContext.commentPanelStatus,
                    highlightCommentId: highlightCommentId,
                    showComments: showComments
                },
                calledFrom: "NotificationsButton:setCommentPanelStatusInContext"
            });
            redirectUrl = (0, $7KklJ.getTlfUrl)(hierarchyContext.hierarchy, tlfContext.tlfData);
        }
        /* istanbul ignore else */ if (redirectUrl) navigate(redirectUrl, {
            replace: true
        });
    });
    // Handle Comments Panel status on redirection from Notification
    (0, $7fPBF.useEffect)(()=>{
        if ((searchParams.has("showHierarchyComments") || searchParams.has("showTlfItemComments")) && hierarchyContext?.hierarchy) {
            const commentIdFromNotification = searchParams.get("commentId");
            /* istanbul ignore else */ if (searchParams.get("showHierarchyComments") === "true") {
                // A valid notification comment is handled above; the fallback only opens the panel when it is closed.
                /* istanbul ignore else */ if (commentIdFromNotification && hierarchyContext.hierarchy.comments.some((c)=>c.id === commentIdFromNotification) && hierarchyContext.commentPanelStatus.highlightCommentId !== commentIdFromNotification) setCommentPanelStatusInContext(commentIdFromNotification, true, "Hierarchy");
                else if (!hierarchyContext.commentPanelStatus.showComments) setCommentPanelStatusInContext("", true, "Hierarchy");
            } else if (searchParams.get("showTlfItemComments") === "true" && tlfContext.tlfData) {
                /* istanbul ignore else */ if (commentIdFromNotification && tlfContext.tlfData.comments.some((c)=>c.id === commentIdFromNotification) && tlfContext.commentPanelStatus.highlightCommentId !== commentIdFromNotification) setCommentPanelStatusInContext(commentIdFromNotification, true, "TlfItem");
                else if (!tlfContext.commentPanelStatus.showComments) setCommentPanelStatusInContext("", true, "TlfItem");
            }
        }
    }, [
        hierarchyContext,
        tlfContext,
        searchParams,
        urlParams
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            showNotifications && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dhn58.NotificationsPanel), {
                notificationsList: notificationsList,
                setNotificationsList: setNotificationsList,
                showNotifications: showNotifications,
                setShowNotifications: setShowNotifications,
                loadNotificationsRequest: loadRequest
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5M3sM.default), {
                id: "topbar-notifications-button",
                style: {
                    cursor: "pointer"
                },
                title: "View Notifications",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setShowNotifications(!showNotifications);
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    style: {
                        minWidth: "32px",
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center"
                    },
                    "aria-label": "Show notifications",
                    children: newNotificationCount > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bNVAi.default), {
                        pill: true,
                        bg: "primary",
                        "aria-label": `${newNotificationCount} new notification${newNotificationCount !== 1 ? "s" : ""}`,
                        children: newNotificationCount < 10 ? newNotificationCount : "9+"
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eETAC.default), {
                        size: 20
                    })
                })
            })
        ]
    });
};
$8f8721b31dbe7c77$export$40e326b1271b1326.displayName = "NotificationsButton";

});
parcelRegister("7KklJ", function(module, exports) {

$parcel$export(module.exports, "getTlfUrl", function () { return $b934fc98ef716a2c$export$32607bc73b33f5a3; });

var $7Wd8C = parcelRequire("7Wd8C");

var $wPq5H = parcelRequire("wPq5H");
const $b934fc98ef716a2c$export$32607bc73b33f5a3 = (hierarchy, tlfItem)=>tlfItem.primaryHierarchyLevel !== (0, $7Wd8C.eHierarchyLevel).Report ? `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchy)}/Template/${tlfItem.azsolId}/${tlfItem.version}` : tlfItem.version === hierarchy.tocMajorVersion && tlfItem.tocNumber ? `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchy)}/${tlfItem.tocNumber}` : tlfItem.tocNumber ? `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchy)}/Version/${tlfItem.version}/${tlfItem.tocNumber}` : (0, $wPq5H.getHierarchyBaseUrl)(hierarchy);

});

parcelRegister("boY0Q", function(module, exports) {

$parcel$export(module.exports, "getUserNotifications", function () { return $402567c74526be2a$export$7c48cc3fe3d2cf5d; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $402567c74526be2a$export$7c48cc3fe3d2cf5d = async (backEndUrl, _, controller)=>{
    // Get data
    try {
        const response = await (0, $a04va.default).get(`${backEndUrl}Comments/GetUserNotifications`, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load Notifications failed", error);
    }
};

});

parcelRegister("eETAC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aabfec0de80e64ee$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $aabfec0de80e64ee$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $aabfec0de80e64ee$var$_extends() {
    return $aabfec0de80e64ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aabfec0de80e64ee$var$_extends.apply(null, arguments);
}
function $aabfec0de80e64ee$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $aabfec0de80e64ee$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $aabfec0de80e64ee$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $aabfec0de80e64ee$var$Bell = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $aabfec0de80e64ee$var$_objectWithoutProperties(_ref, $aabfec0de80e64ee$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $aabfec0de80e64ee$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-bell',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6"
    }));
});
$aabfec0de80e64ee$var$Bell.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $aabfec0de80e64ee$export$2e2bcd8739ae039 = $aabfec0de80e64ee$var$Bell;

});

parcelRegister("dhn58", function(module, exports) {

$parcel$export(module.exports, "NotificationsPanel", function () { return $52c159009cfd15ac$export$2ed25852fd4f5fb5; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $9eqKP = parcelRequire("9eqKP");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $aQsQo = parcelRequire("aQsQo");
var $kYoG1 = parcelRequire("kYoG1");

var $iThBM = parcelRequire("iThBM");

var $d9dYI = parcelRequire("d9dYI");
const $52c159009cfd15ac$export$2ed25852fd4f5fb5 = ({ notificationsList: notificationsList, setNotificationsList: setNotificationsList, showNotifications: showNotifications, setShowNotifications: setShowNotifications, loadNotificationsRequest: loadNotificationsRequest })=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aQsQo.default), {
        show: showNotifications,
        placement: "end",
        onHide: ()=>{
            setShowNotifications(false);
        },
        backdrop: false,
        scroll: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Header, {
                closeButton: true,
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Title, {
                    children: "Notifications"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aQsQo.default).Body, {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                    children: [
                        loadNotificationsRequest.requesting && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                            text: "Fetching Notifications..."
                        }),
                        loadNotificationsRequest.error ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                            children: " Something went wrong when fetching your notifications... "
                        }) : notificationsList.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                        xs: {
                                            span: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9dYI.NotificationsReadButton), {
                                            notificationsList: notificationsList,
                                            setNotificationsList: setNotificationsList
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iThBM.NotificationsList), {
                                            notificationsList: notificationsList,
                                            setNotificationsList: setNotificationsList,
                                            showNotifications: showNotifications,
                                            setShowNotifications: setShowNotifications
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                            children: "No Notifications Yet...!"
                        })
                    ]
                })
            })
        ]
    });
$52c159009cfd15ac$export$2ed25852fd4f5fb5.displayName = "NotificationsPanel";

});
parcelRegister("iThBM", function(module, exports) {

$parcel$export(module.exports, "NotificationsList", function () { return $d3332c9539da113e$export$e3c71f1cd4cf6a5e; });

var $bbzbN = parcelRequire("bbzbN");

var $aubmP = parcelRequire("aubmP");

var $gyMcJ = parcelRequire("gyMcJ");
const $d3332c9539da113e$export$e3c71f1cd4cf6a5e = ({ notificationsList: notificationsList, setNotificationsList: setNotificationsList, setShowNotifications: setShowNotifications })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "position-relative",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aubmP.default), {
            children: notificationsList.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $gyMcJ.NotificationListItem), {
                    notification: n,
                    setNotificationsList: setNotificationsList,
                    setShowNotifications: setShowNotifications
                }, n.notificationId))
        })
    });
};
$d3332c9539da113e$export$e3c71f1cd4cf6a5e.displayName = "NotificationsList";

});
parcelRegister("aubmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a25860746fe7ba2$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $6Buvl = parcelRequire("6Buvl");
parcelRequire("ecgdb");
var $9GY4V = parcelRequire("9GY4V");

var $bNAtM = parcelRequire("bNAtM");

var $jbn4d = parcelRequire("jbn4d");

var $4oJqf = parcelRequire("4oJqf");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $7a25860746fe7ba2$var$ListGroup = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $9GY4V.default)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $jbn4d.useBootstrapPrefix)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(!(horizontal && variant === 'flush'), '`variant="flush"` and `horizontal` should not be used together.');
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bNAtM.default), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$7a25860746fe7ba2$var$ListGroup.displayName = 'ListGroup';
var $7a25860746fe7ba2$export$2e2bcd8739ae039 = Object.assign($7a25860746fe7ba2$var$ListGroup, {
    Item: (0, $4oJqf.default)
});

});
parcelRegister("4oJqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $333ca342d46d29ce$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $6Buvl = parcelRequire("6Buvl");

var $jbhqg = parcelRequire("jbhqg");

var $3rd7w = parcelRequire("3rd7w");

var $cpnTQ = parcelRequire("cpnTQ");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $333ca342d46d29ce$var$ListGroupItem = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $3rd7w.useNavItem)({
        key: (0, $cpnTQ.makeEventKey)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $jbhqg.default)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    (0, (/*@__PURE__*/$parcel$interopDefault($6Buvl)))(as || !(!action && props.href), '`action=false` and `href` should not be used together.');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$333ca342d46d29ce$var$ListGroupItem.displayName = 'ListGroupItem';
var $333ca342d46d29ce$export$2e2bcd8739ae039 = $333ca342d46d29ce$var$ListGroupItem;

});


parcelRegister("gyMcJ", function(module, exports) {

$parcel$export(module.exports, "NotificationListItem", function () { return $87a670228e351d09$export$f73cbc6bc7eb6c67; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $lUIe4 = parcelRequire("lUIe4");
var $30Ra3 = parcelRequire("30Ra3");
var $9eqKP = parcelRequire("9eqKP");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $4PTZu = parcelRequire("4PTZu");

var $eXuLI = parcelRequire("eXuLI");

var $7fPBF = parcelRequire("7fPBF");

var $aubmP = parcelRequire("aubmP");

var $5IuIz = parcelRequire("5IuIz");
const $87a670228e351d09$export$f9d3f62cd416668 = (prev, notification)=>prev.map((n)=>n.notificationId === notification.notificationId ? {
            ...n,
            notificationViewed: notification.notificationViewed
        } : n);
const $87a670228e351d09$export$f73cbc6bc7eb6c67 = ({ notification: n, setNotificationsList: setNotificationsList, setShowNotifications: setShowNotifications })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const { navigate: navigate, isLoading: isLoading } = (0, $4PTZu.useUnsavedChanges)("NotificationListItem");
    const [doNavigate, setDoNavigate] = (0, $7fPBF.useState)(false);
    const [isNavigating, setIsNavigating] = (0, $7fPBF.useState)(false);
    const [updateNotificationStatusRequest, setUpdateNotificationStatusRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Toggle the viewed status of a notification.
   *
   * @param notificationId - ID of the notification to update
   */ const toggleNotificationStatus = async (notificationId)=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $eXuLI.updateNotificationStatus), {
            notificationId: notificationId
        }, {
            ...updateNotificationStatusRequest,
            requestedId: undefined
        }, setUpdateNotificationStatusRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) setNotificationsList((prev)=>$87a670228e351d09$export$f9d3f62cd416668(prev, response.data));
    };
    // Close notifications after navigating
    (0, $7fPBF.useEffect)(()=>{
        if (doNavigate && isLoading && !isNavigating) startTransition(()=>{
            setIsNavigating(true);
            setDoNavigate(false);
        });
        else if (isNavigating && !isLoading) startTransition(()=>{
            setShowNotifications(false);
            setIsNavigating(false);
        });
    }, [
        doNavigate,
        isLoading,
        isNavigating,
        setShowNotifications
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aubmP.default), {
        id: `notification-${n.notificationId}`,
        horizontal: true,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $aubmP.default).Item, {
                action: true,
                active: false,
                title: n.commentId ? "Click to View the associated Comment" : "Associated Comment has been deleted",
                id: `notification-${n.notificationId}-content`,
                className: "d-flex justify-content-between align-items-start",
                style: {
                    cursor: "pointer"
                },
                variant: n.notificationViewed ? "light" : "primary",
                onClick: async (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    /* istanbul ignore else */ if (!n.notificationViewed) toggleNotificationStatus(n.notificationId);
                    const commentId = n.commentId ? `&commentId=${n.commentId}` : "";
                    const target = n.entityType === "Hierarchy" ? {
                        pathname: `/H/${n.entityId}`,
                        search: `showHierarchyComments=true${commentId}`
                    } : {
                        pathname: `/TlfDesigner/${n.entityId}`,
                        search: `showTlfItemComments=true${commentId}`
                    };
                    /* istanbul ignore else */ if (n.entityType === "Hierarchy" && n.entityId !== hierarchyContext?.hierarchy?.id || n.entityType === "TlfItem" && n.entityId !== tlfContext.tlfData?.id) setDoNavigate(true);
                    else setShowNotifications(false);
                    navigate(target);
                },
                children: [
                    (doNavigate || isNavigating) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                        text: "Loading comment..."
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "ms-2 me-auto",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: n.notificationViewed ? "fw-normal" : "fw-bold",
                                children: n.notificationContent
                            }),
                            !n.commentId && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                                    className: "text-info",
                                    children: "(Comment has been deleted)"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                                className: "text-muted",
                                children: (0, $lUIe4.convertDateToLocaleString)(n.notificationDateTimeStamp)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5IuIz.NotificationListItemEnvelope), {
                id: n.notificationId,
                viewed: n.notificationViewed,
                toggleNotificationStatus: toggleNotificationStatus
            })
        ]
    });
};
$87a670228e351d09$export$f73cbc6bc7eb6c67.displayName = "NotificationListItem";

});
parcelRegister("eXuLI", function(module, exports) {

$parcel$export(module.exports, "updateNotificationStatus", function () { return $9ff28f1832b23d03$export$2f22adba7b8517; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $9ff28f1832b23d03$export$2f22adba7b8517 = async (backEndUrl, notification, controller)=>{
    // Send data
    try {
        const url = `${backEndUrl}Comments/ToggleNotificationViewedStatus/${notification.notificationId}`;
        const response = await (0, $a04va.default).put(url, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("update notification status failed", error);
    }
};

});

parcelRegister("5IuIz", function(module, exports) {

$parcel$export(module.exports, "NotificationListItemEnvelope", function () { return $41d40f7a9e321efa$export$e100b8270aee5325; });

var $bbzbN = parcelRequire("bbzbN");

var $aubmP = parcelRequire("aubmP");

var $lIf3x = parcelRequire("lIf3x");
var $7rEjL = parcelRequire("7rEjL");
const $41d40f7a9e321efa$export$e100b8270aee5325 = ({ id: id, viewed: viewed, toggleNotificationStatus: toggleNotificationStatus })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $aubmP.default).Item, {
        id: `notification-${id}-toggle`,
        className: "d-flex align-items-center",
        style: {
            cursor: "pointer"
        },
        title: `Mark as ${viewed ? "unread" : "read"}`,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            toggleNotificationStatus(id);
        },
        children: viewed ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7rEjL.default), {
            size: "20"
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lIf3x.default), {
            size: "20"
        })
    }, `${id}-toggle`);
$41d40f7a9e321efa$export$e100b8270aee5325.displayName = "NotificationListItemEnvelope";

});
parcelRegister("lIf3x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fce962dd714dc482$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $fce962dd714dc482$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $fce962dd714dc482$var$_extends() {
    return $fce962dd714dc482$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fce962dd714dc482$var$_extends.apply(null, arguments);
}
function $fce962dd714dc482$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $fce962dd714dc482$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $fce962dd714dc482$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $fce962dd714dc482$var$EnvelopeFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $fce962dd714dc482$var$_objectWithoutProperties(_ref, $fce962dd714dc482$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $fce962dd714dc482$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-envelope-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"
    }));
});
$fce962dd714dc482$var$EnvelopeFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $fce962dd714dc482$export$2e2bcd8739ae039 = $fce962dd714dc482$var$EnvelopeFill;

});

parcelRegister("7rEjL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56ba544b00a05be9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $56ba544b00a05be9$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $56ba544b00a05be9$var$_extends() {
    return $56ba544b00a05be9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $56ba544b00a05be9$var$_extends.apply(null, arguments);
}
function $56ba544b00a05be9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $56ba544b00a05be9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $56ba544b00a05be9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $56ba544b00a05be9$var$EnvelopeOpen = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $56ba544b00a05be9$var$_objectWithoutProperties(_ref, $56ba544b00a05be9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $56ba544b00a05be9$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-envelope-open',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l5.75 3.45L8 8.917l1.25.75L15 6.217V5.4a1 1 0 0 0-.53-.882zM15 7.383l-4.778 2.867L15 13.117zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734ZM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765z"
    }));
});
$56ba544b00a05be9$var$EnvelopeOpen.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $56ba544b00a05be9$export$2e2bcd8739ae039 = $56ba544b00a05be9$var$EnvelopeOpen;

});




parcelRegister("d9dYI", function(module, exports) {

$parcel$export(module.exports, "NotificationsReadButton", function () { return $610582ffaa656cab$export$e0e93bab5111aa5f; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");

var $lT9hs = parcelRequire("lT9hs");

var $7fPBF = parcelRequire("7fPBF");

var $6IIOe = parcelRequire("6IIOe");
const $610582ffaa656cab$export$e0e93bab5111aa5f = ({ notificationsList: notificationsList, setNotificationsList: setNotificationsList })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hasUnreadNotifications = (0, $7fPBF.useMemo)(()=>{
        return notificationsList.some((n)=>!n.notificationViewed);
    }, [
        notificationsList
    ]);
    const [updateNotificationsStatusRequest, setUpdateNotifcationsStatusRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const markAllNotificationsAsViewed = (0, $7fPBF.useCallback)(async ()=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $lT9hs.updateAllNotificationsAsViewed), "UpdateAll", {
            ...updateNotificationsStatusRequest,
            requestedId: undefined
        }, setUpdateNotifcationsStatusRequest, appSettings.backEndUrl);
        if (response?.success) setNotificationsList(notificationsList.map((notification)=>({
                ...notification,
                notificationViewed: response.data.find((n)=>n.notificationId === notification.notificationId)?.notificationViewed ?? notification.notificationViewed
            })));
    }, [
        appSettings.backEndUrl,
        notificationsList,
        setNotificationsList,
        updateNotificationsStatusRequest
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
        id: "mark-all-notifications-button",
        disabled: !hasUnreadNotifications,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            markAllNotificationsAsViewed();
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6IIOe.default), {
                className: "justify-self-center me-2"
            }),
            "Mark all as read"
        ]
    });
};
$610582ffaa656cab$export$e0e93bab5111aa5f.displayName = "NotificationsReadButton";

});
parcelRegister("lT9hs", function(module, exports) {

$parcel$export(module.exports, "updateAllNotificationsAsViewed", function () { return $0aaa43e949e8ef66$export$116ade397598058a; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $0aaa43e949e8ef66$export$116ade397598058a = async (backEndUrl, _, controller)=>{
    // Send data
    try {
        const url = `${backEndUrl}Comments/MarkAllNotificationsAsViewed`;
        const response = await (0, $a04va.default).put(url, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("update notifications status failed", error);
    }
};

});




parcelRegister("bAMg4", function(module, exports) {

$parcel$export(module.exports, "TocNavigate", function () { return $cf4a0bdaa341bb75$export$551491cff6ff209f; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $7KklJ = parcelRequire("7KklJ");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $87hiV = parcelRequire("87hiV");
var $cnmTv = parcelRequire("cnmTv");
const $cf4a0bdaa341bb75$export$551491cff6ff209f = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tocContext = (0, $hWsmt.useTocContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("toc-navigate");
    if (!hierarchy || !tocContext || !tlfContext) return null;
    const tlf = tlfContext.tlfData;
    const toc = tocContext.state.tocItems.filter((item)=>item.type !== (0, $7Wd8C.eTlfItemType).section).sort((a, b)=>(a.tocOrder ?? 0) - (b.tocOrder ?? 0));
    const thisTocItemIndex = toc.findIndex((item)=>item.id === tlf?.id);
    const leftToc = thisTocItemIndex > 0 ? toc[thisTocItemIndex - 1] : null;
    const leftDest = leftToc && hierarchy.tocMajorVersion !== undefined ? (0, $7KklJ.getTlfUrl)(hierarchy, leftToc) : null;
    const rightToc = thisTocItemIndex > -1 && thisTocItemIndex < toc.length - 1 ? toc[thisTocItemIndex + 1] : null;
    const rightDest = rightToc && hierarchy.tocMajorVersion !== undefined ? (0, $7KklJ.getTlfUrl)(hierarchy, rightToc) : null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87hiV.default), {
                style: {
                    cursor: leftDest ? "pointer" : "not-allowed",
                    color: leftDest ? "black" : "grey"
                },
                "aria-label": "Navigate to previous ToC entry",
                title: leftToc?.tocNumber,
                onClick: ()=>leftDest && navigate(leftDest)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cnmTv.default), {
                style: {
                    cursor: rightDest ? "pointer" : "not-allowed",
                    color: rightDest ? "black" : "grey"
                },
                "aria-label": "Navigate to next ToC entry",
                title: rightToc?.tocNumber,
                onClick: ()=>rightDest && navigate(rightDest)
            })
        ]
    });
};
$cf4a0bdaa341bb75$export$551491cff6ff209f.displayName = "TocNavigate";

});

parcelRegister("ICooD", function(module, exports) {

$parcel$export(module.exports, "brandBackgroud", function () { return $0861e41fbe55d7fa$export$29f8578c16b69ca6; }, function (v) { return $0861e41fbe55d7fa$export$29f8578c16b69ca6 = v; });
$parcel$export(module.exports, "brandHolder", function () { return $0861e41fbe55d7fa$export$829121345dabd4a0; }, function (v) { return $0861e41fbe55d7fa$export$829121345dabd4a0 = v; });
$parcel$export(module.exports, "center", function () { return $0861e41fbe55d7fa$export$3481c78889e8fbe8; }, function (v) { return $0861e41fbe55d7fa$export$3481c78889e8fbe8 = v; });
$parcel$export(module.exports, "endSection", function () { return $0861e41fbe55d7fa$export$dde49f02c5dd1db6; }, function (v) { return $0861e41fbe55d7fa$export$dde49f02c5dd1db6 = v; });
$parcel$export(module.exports, "grid", function () { return $0861e41fbe55d7fa$export$85fc379452d91af0; }, function (v) { return $0861e41fbe55d7fa$export$85fc379452d91af0 = v; });
$parcel$export(module.exports, "gridBrandCell", function () { return $0861e41fbe55d7fa$export$20e01b73bbde4d50; }, function (v) { return $0861e41fbe55d7fa$export$20e01b73bbde4d50 = v; });
$parcel$export(module.exports, "gridRowOne", function () { return $0861e41fbe55d7fa$export$632ba9f24b430add; }, function (v) { return $0861e41fbe55d7fa$export$632ba9f24b430add = v; });
$parcel$export(module.exports, "gridRowTwo", function () { return $0861e41fbe55d7fa$export$64aaea269ec583d; }, function (v) { return $0861e41fbe55d7fa$export$64aaea269ec583d = v; });
$parcel$export(module.exports, "leftNav", function () { return $0861e41fbe55d7fa$export$297a118919f0a00e; }, function (v) { return $0861e41fbe55d7fa$export$297a118919f0a00e = v; });
$parcel$export(module.exports, "menuHolder", function () { return $0861e41fbe55d7fa$export$26ae2fe8547c1936; }, function (v) { return $0861e41fbe55d7fa$export$26ae2fe8547c1936 = v; });
$parcel$export(module.exports, "rightNav", function () { return $0861e41fbe55d7fa$export$ef76859433d279a; }, function (v) { return $0861e41fbe55d7fa$export$ef76859433d279a = v; });
$parcel$export(module.exports, "rightNavText", function () { return $0861e41fbe55d7fa$export$c91f82058224546b; }, function (v) { return $0861e41fbe55d7fa$export$c91f82058224546b = v; });
$parcel$export(module.exports, "titleText", function () { return $0861e41fbe55d7fa$export$318bb85fd83e5f1a; }, function (v) { return $0861e41fbe55d7fa$export$318bb85fd83e5f1a = v; });
var $0861e41fbe55d7fa$export$29f8578c16b69ca6;
var $0861e41fbe55d7fa$export$829121345dabd4a0;
var $0861e41fbe55d7fa$export$3481c78889e8fbe8;
var $0861e41fbe55d7fa$export$dde49f02c5dd1db6;
var $0861e41fbe55d7fa$export$85fc379452d91af0;
var $0861e41fbe55d7fa$export$20e01b73bbde4d50;
var $0861e41fbe55d7fa$export$632ba9f24b430add;
var $0861e41fbe55d7fa$export$64aaea269ec583d;
var $0861e41fbe55d7fa$export$297a118919f0a00e;
var $0861e41fbe55d7fa$export$26ae2fe8547c1936;
var $0861e41fbe55d7fa$export$ef76859433d279a;
var $0861e41fbe55d7fa$export$c91f82058224546b;
var $0861e41fbe55d7fa$export$318bb85fd83e5f1a;
$0861e41fbe55d7fa$export$29f8578c16b69ca6 = `mos-TopBar-module-8BkwSq-brandBackgroud`;
$0861e41fbe55d7fa$export$829121345dabd4a0 = `mos-TopBar-module-8BkwSq-brandHolder`;
$0861e41fbe55d7fa$export$3481c78889e8fbe8 = `mos-TopBar-module-8BkwSq-center`;
$0861e41fbe55d7fa$export$dde49f02c5dd1db6 = `mos-TopBar-module-8BkwSq-endSection`;
$0861e41fbe55d7fa$export$85fc379452d91af0 = `mos-TopBar-module-8BkwSq-grid`;
$0861e41fbe55d7fa$export$20e01b73bbde4d50 = `mos-TopBar-module-8BkwSq-gridBrandCell`;
$0861e41fbe55d7fa$export$632ba9f24b430add = `mos-TopBar-module-8BkwSq-gridRowOne`;
$0861e41fbe55d7fa$export$64aaea269ec583d = `mos-TopBar-module-8BkwSq-gridRowTwo`;
$0861e41fbe55d7fa$export$297a118919f0a00e = `mos-TopBar-module-8BkwSq-leftNav`;
$0861e41fbe55d7fa$export$26ae2fe8547c1936 = `mos-TopBar-module-8BkwSq-menuHolder`;
$0861e41fbe55d7fa$export$ef76859433d279a = `mos-TopBar-module-8BkwSq-rightNav`;
$0861e41fbe55d7fa$export$c91f82058224546b = `mos-TopBar-module-8BkwSq-rightNavText`;
$0861e41fbe55d7fa$export$318bb85fd83e5f1a = `mos-TopBar-module-8BkwSq-titleText`;

});


parcelRegister("5Pwtv", function(module, exports) {

$parcel$export(module.exports, "SettingsDropMenu", function () { return $b4015f40c46c552c$export$46562ffa19c7132e; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $4mMRX = parcelRequire("4mMRX");
const $b4015f40c46c552c$export$46562ffa19c7132e = ({ settingsEntry: settingsEntry })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchies = hierarchyContext && hierarchyContext.hierarchy ? Array.from(new Set([
        hierarchyContext.hierarchy,
        ...hierarchyContext.hierarchyNodes
    ])) : undefined;
    return !hierarchies || !settingsEntry ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default), {
        title: "Settings",
        id: "settingsdropmenu",
        className: "align-self-center",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            style: {
                maxHeight: "75vh",
                overflowY: "auto"
            },
            children: settingsEntry
        })
    });
};
$b4015f40c46c552c$export$46562ffa19c7132e.displayName = "SettingsDropMenu";

});

parcelRegister("2Sbgo", function(module, exports) {
module.exports = $parcel$resolve("9WmYe");

});



parcelRegister("7ntzw", function(module, exports) {

$parcel$export(module.exports, "connectToHub", function () { return $9af307ca6c8edf68$export$edc82a61196017a3; });

var $lboOL = parcelRequire("lboOL");
var $2lJPz = parcelRequire("2lJPz");
const $9af307ca6c8edf68$export$edc82a61196017a3 = async (url)=>{
    // Custom retry policy: 0ms, 2s, 10s, 30s delays between reconnect attempts.
    const retryDelays = [
        0,
        2000,
        10000,
        30000
    ];
    const retryPolicy = {
        nextRetryDelayInMilliseconds (retryContext) {
            if (retryContext.previousRetryCount >= retryDelays.length) return null;
            return retryDelays[retryContext.previousRetryCount];
        }
    };
    const conn = new (0, $lboOL.HubConnectionBuilder)().withUrl(url).configureLogging((0, $2lJPz.LogLevel).Warning).withAutomaticReconnect(retryPolicy).build();
    await conn.start();
    return conn;
};

});
parcelRegister("lboOL", function(module, exports) {

$parcel$export(module.exports, "HubConnectionBuilder", function () { return $f6bde0528734a862$export$afccb10c24910b13; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $47J0i = parcelRequire("47J0i");

var $lsRAg = parcelRequire("lsRAg");

var $hGHEx = parcelRequire("hGHEx");

var $2lJPz = parcelRequire("2lJPz");

var $c4g9F = parcelRequire("c4g9F");

var $6Ulgh = parcelRequire("6Ulgh");

var $2ni4V = parcelRequire("2ni4V");
const $f6bde0528734a862$var$LogLevelNameMapping = {
    trace: (0, $2lJPz.LogLevel).Trace,
    debug: (0, $2lJPz.LogLevel).Debug,
    info: (0, $2lJPz.LogLevel).Information,
    information: (0, $2lJPz.LogLevel).Information,
    warn: (0, $2lJPz.LogLevel).Warning,
    warning: (0, $2lJPz.LogLevel).Warning,
    error: (0, $2lJPz.LogLevel).Error,
    critical: (0, $2lJPz.LogLevel).Critical,
    none: (0, $2lJPz.LogLevel).None
};
function $f6bde0528734a862$var$parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    const mapping = $f6bde0528734a862$var$LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") return mapping;
    else throw new Error(`Unknown log level: ${name}`);
}
class $f6bde0528734a862$export$afccb10c24910b13 {
    configureLogging(logging) {
        (0, $2ni4V.Arg).isRequired(logging, "logging");
        if ($f6bde0528734a862$var$isLogger(logging)) this.logger = logging;
        else if (typeof logging === "string") {
            const logLevel = $f6bde0528734a862$var$parseLogLevel(logging);
            this.logger = new (0, $2ni4V.ConsoleLogger)(logLevel);
        } else this.logger = new (0, $2ni4V.ConsoleLogger)(logging);
        return this;
    }
    withUrl(url, transportTypeOrOptions) {
        (0, $2ni4V.Arg).isRequired(url, "url");
        (0, $2ni4V.Arg).isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            ...transportTypeOrOptions
        };
        else this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            transport: transportTypeOrOptions
        };
        return this;
    }
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */ withHubProtocol(protocol) {
        (0, $2ni4V.Arg).isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    }
    withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) throw new Error("A reconnectPolicy has already been set.");
        if (!retryDelaysOrReconnectPolicy) this.reconnectPolicy = new (0, $47J0i.DefaultReconnectPolicy)();
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) this.reconnectPolicy = new (0, $47J0i.DefaultReconnectPolicy)(retryDelaysOrReconnectPolicy);
        else this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withServerTimeout(milliseconds) {
        (0, $2ni4V.Arg).isRequired(milliseconds, "milliseconds");
        this._serverTimeoutInMilliseconds = milliseconds;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withKeepAliveInterval(milliseconds) {
        (0, $2ni4V.Arg).isRequired(milliseconds, "milliseconds");
        this._keepAliveIntervalInMilliseconds = milliseconds;
        return this;
    }
    /** Enables and configures options for the Stateful Reconnect feature.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withStatefulReconnect(options) {
        if (this.httpConnectionOptions === undefined) this.httpConnectionOptions = {};
        this.httpConnectionOptions._useStatefulReconnect = true;
        this._statefulReconnectBufferSize = options === null || options === void 0 ? void 0 : options.bufferSize;
        return this;
    }
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */ build() {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        const httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
        httpConnectionOptions.logger = this.logger;
        // Now create the connection
        if (!this.url) throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        const connection = new (0, $lsRAg.HttpConnection)(this.url, httpConnectionOptions);
        return (0, $hGHEx.HubConnection).create(connection, this.logger || (0, $6Ulgh.NullLogger).instance, this.protocol || new (0, $c4g9F.JsonHubProtocol)(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
    }
}
function $f6bde0528734a862$var$isLogger(logger) {
    return logger.log !== undefined;
}

});
parcelRegister("47J0i", function(module, exports) {

$parcel$export(module.exports, "DefaultReconnectPolicy", function () { return $300ab9adc702df5b$export$97bc471d6a059e6e; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// 0, 2, 10, 30 second delays before reconnect attempts.
const $300ab9adc702df5b$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [
    0,
    2000,
    10000,
    30000,
    null
];
class $300ab9adc702df5b$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays,
            null
        ] : $300ab9adc702df5b$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    nextRetryDelayInMilliseconds(retryContext) {
        return this._retryDelays[retryContext.previousRetryCount];
    }
}

});

parcelRegister("lsRAg", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", function () { return $fa05c729d79bb7aa$export$13c1f9cf8a283575; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $52Hoh = parcelRequire("52Hoh");

var $equCX = parcelRequire("equCX");

var $e70Ea = parcelRequire("e70Ea");

var $2lJPz = parcelRequire("2lJPz");

var $5XgIu = parcelRequire("5XgIu");

var $ee4Gf = parcelRequire("ee4Gf");

var $kcoxl = parcelRequire("kcoxl");

var $2ni4V = parcelRequire("2ni4V");

var $6GOaP = parcelRequire("6GOaP");
const $fa05c729d79bb7aa$var$MAX_REDIRECTS = 100;
class $fa05c729d79bb7aa$export$13c1f9cf8a283575 {
    constructor(url, options = {}){
        this._stopPromiseResolver = ()=>{};
        this.features = {};
        this._negotiateVersion = 1;
        (0, $2ni4V.Arg).isRequired(url, "url");
        this._logger = (0, $2ni4V.createLogger)(options.logger);
        this.baseUrl = this._resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        else throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        options.timeout = options.timeout === undefined ? 100000 : options.timeout;
        let webSocketModule = null;
        let eventSourceModule = null;
        if ((0, $2ni4V.Platform).isNode && true) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!(0, $2ni4V.Platform).isNode && typeof WebSocket !== "undefined" && !options.WebSocket) options.WebSocket = WebSocket;
        else if ((0, $2ni4V.Platform).isNode && !options.WebSocket) {
            if (webSocketModule) options.WebSocket = webSocketModule;
        }
        if (!(0, $2ni4V.Platform).isNode && typeof EventSource !== "undefined" && !options.EventSource) options.EventSource = EventSource;
        else if ((0, $2ni4V.Platform).isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") options.EventSource = eventSourceModule;
        }
        this._httpClient = new (0, $52Hoh.AccessTokenHttpClient)(options.httpClient || new (0, $equCX.DefaultHttpClient)(this._logger), options.accessTokenFactory);
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        this._connectionStarted = false;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async start(transferFormat) {
        transferFormat = transferFormat || (0, $5XgIu.TransferFormat).Binary;
        (0, $2ni4V.Arg).isIn(transferFormat, (0, $5XgIu.TransferFormat), "transferFormat");
        this._logger.log((0, $2lJPz.LogLevel).Debug, `Starting connection with transfer format '${(0, $5XgIu.TransferFormat)[transferFormat]}'.`);
        if (this._connectionState !== "Disconnected" /* ConnectionState.Disconnected */ ) return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        this._connectionState = "Connecting" /* ConnectionState.Connecting */ ;
        this._startInternalPromise = this._startInternal(transferFormat);
        await this._startInternalPromise;
        // The TypeScript compiler thinks that connectionState must be Connecting here. The TypeScript compiler is wrong.
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "Failed to start the HttpConnection before stop() was called.";
            this._logger.log((0, $2lJPz.LogLevel).Error, message);
            // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
            await this._stopPromise;
            return Promise.reject(new (0, $e70Ea.AbortError)(message));
        } else if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
            this._logger.log((0, $2lJPz.LogLevel).Error, message);
            return Promise.reject(new (0, $e70Ea.AbortError)(message));
        }
        this._connectionStarted = true;
    }
    send(data) {
        if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        if (!this._sendQueue) this._sendQueue = new $fa05c729d79bb7aa$export$ff09921d3884e946(this.transport);
        // Transport will not be null if state is connected
        return this._sendQueue.send(data);
    }
    async stop(error) {
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = "Disconnecting" /* ConnectionState.Disconnecting */ ;
        this._stopPromise = new Promise((resolve)=>{
            // Don't complete stop() until stopConnection() completes.
            this._stopPromiseResolver = resolve;
        });
        // stopInternal should never throw so just observe it.
        await this._stopInternal(error);
        await this._stopPromise;
    }
    async _stopInternal(error) {
        // Set error as soon as possible otherwise there is a race between
        // the transport closing and providing an error and the error from a close message
        // We would prefer the close message error.
        this._stopError = error;
        try {
            await this._startInternalPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
        // The transport's onclose will trigger stopConnection which will run our onclose event.
        // The transport should always be set if currently connected. If it wasn't set, it's likely because
        // stop was called during start() and start() failed.
        if (this.transport) {
            try {
                await this.transport.stop();
            } catch (e) {
                this._logger.log((0, $2lJPz.LogLevel).Error, `HttpConnection.transport.stop() threw error '${e}'.`);
                this._stopConnection();
            }
            this.transport = undefined;
        } else this._logger.log((0, $2lJPz.LogLevel).Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
    }
    async _startInternal(transferFormat) {
        // Store the original base url and the access token factory since they may change
        // as part of negotiating
        let url = this.baseUrl;
        this._accessTokenFactory = this._options.accessTokenFactory;
        this._httpClient._accessTokenFactory = this._accessTokenFactory;
        try {
            if (this._options.skipNegotiation) {
                if (this._options.transport === (0, $5XgIu.HttpTransportType).WebSockets) {
                    // No need to add a connection ID in this case
                    this.transport = this._constructTransport((0, $5XgIu.HttpTransportType).WebSockets);
                    // We should just call connect directly in this case.
                    // No fallback or negotiate in this case.
                    await this._startTransport(url, transferFormat);
                } else throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            } else {
                let negotiateResponse = null;
                let redirects = 0;
                do {
                    negotiateResponse = await this._getNegotiationResponse(url);
                    // the user tries to stop the connection when it is being started
                    if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */  || this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) throw new (0, $e70Ea.AbortError)("The connection was stopped during negotiation.");
                    if (negotiateResponse.error) throw new Error(negotiateResponse.error);
                    if (negotiateResponse.ProtocolVersion) throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    if (negotiateResponse.url) url = negotiateResponse.url;
                    if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        const accessToken = negotiateResponse.accessToken;
                        this._accessTokenFactory = ()=>accessToken;
                        // set the factory to undefined so the AccessTokenHttpClient won't retry with the same token, since we know it won't change until a connection restart
                        this._httpClient._accessToken = accessToken;
                        this._httpClient._accessTokenFactory = undefined;
                    }
                    redirects++;
                }while (negotiateResponse.url && redirects < $fa05c729d79bb7aa$var$MAX_REDIRECTS);
                if (redirects === $fa05c729d79bb7aa$var$MAX_REDIRECTS && negotiateResponse.url) throw new Error("Negotiate redirection limit exceeded.");
                await this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            }
            if (this.transport instanceof (0, $ee4Gf.LongPollingTransport)) this.features.inherentKeepAlive = true;
            if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log((0, $2lJPz.LogLevel).Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* ConnectionState.Connected */ ;
            }
        // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
        // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
        // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
        } catch (e) {
            this._logger.log((0, $2lJPz.LogLevel).Error, "Failed to start the connection: " + e);
            this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
            this.transport = undefined;
            // if start fails, any active calls to stop assume that start will complete the stop promise
            this._stopPromiseResolver();
            return Promise.reject(e);
        }
    }
    async _getNegotiationResponse(url) {
        const headers = {};
        const [name, value] = (0, $2ni4V.getUserAgentHeader)();
        headers[name] = value;
        const negotiateUrl = this._resolveNegotiateUrl(url);
        this._logger.log((0, $2lJPz.LogLevel).Debug, `Sending negotiation request: ${negotiateUrl}.`);
        try {
            const response = await this._httpClient.post(negotiateUrl, {
                content: "",
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            });
            if (response.statusCode !== 200) return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
            const negotiateResponse = JSON.parse(response.content);
            if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) // Negotiate version 0 doesn't use connectionToken
            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
            negotiateResponse.connectionToken = negotiateResponse.connectionId;
            if (negotiateResponse.useStatefulReconnect && this._options._useStatefulReconnect !== true) return Promise.reject(new (0, $e70Ea.FailedToNegotiateWithServerError)("Client didn't negotiate Stateful Reconnect but the server did."));
            return negotiateResponse;
        } catch (e) {
            let errorMessage = "Failed to complete negotiation with the server: " + e;
            if (e instanceof (0, $e70Ea.HttpError)) {
                if (e.statusCode === 404) errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
            }
            this._logger.log((0, $2lJPz.LogLevel).Error, errorMessage);
            return Promise.reject(new (0, $e70Ea.FailedToNegotiateWithServerError)(errorMessage));
        }
    }
    _createConnectUrl(url, connectionToken) {
        if (!connectionToken) return url;
        return url + (url.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
    }
    async _createTransport(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        let connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
        if (this._isITransport(requestedTransport)) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, "Connection was provided an instance of ITransport, using that directly.");
            this.transport = requestedTransport;
            await this._startTransport(connectUrl, requestedTransferFormat);
            this.connectionId = negotiateResponse.connectionId;
            return;
        }
        const transportExceptions = [];
        const transports = negotiateResponse.availableTransports || [];
        let negotiate = negotiateResponse;
        for (const endpoint of transports){
            const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, (negotiate === null || negotiate === void 0 ? void 0 : negotiate.useStatefulReconnect) === true);
            if (transportOrError instanceof Error) {
                // Store the error and continue, we don't want to cause a re-negotiate in these cases
                transportExceptions.push(`${endpoint.transport} failed:`);
                transportExceptions.push(transportOrError);
            } else if (this._isITransport(transportOrError)) {
                this.transport = transportOrError;
                if (!negotiate) {
                    try {
                        negotiate = await this._getNegotiationResponse(url);
                    } catch (ex) {
                        return Promise.reject(ex);
                    }
                    connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
                }
                try {
                    await this._startTransport(connectUrl, requestedTransferFormat);
                    this.connectionId = negotiate.connectionId;
                    return;
                } catch (ex) {
                    this._logger.log((0, $2lJPz.LogLevel).Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
                    negotiate = undefined;
                    transportExceptions.push(new (0, $e70Ea.FailedToStartTransportError)(`${endpoint.transport} failed: ${ex}`, (0, $5XgIu.HttpTransportType)[endpoint.transport]));
                    if (this._connectionState !== "Connecting" /* ConnectionState.Connecting */ ) {
                        const message = "Failed to select transport before stop() was called.";
                        this._logger.log((0, $2lJPz.LogLevel).Debug, message);
                        return Promise.reject(new (0, $e70Ea.AbortError)(message));
                    }
                }
            }
        }
        if (transportExceptions.length > 0) return Promise.reject(new (0, $e70Ea.AggregateErrors)(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
        return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
    }
    _constructTransport(transport) {
        switch(transport){
            case (0, $5XgIu.HttpTransportType).WebSockets:
                if (!this._options.WebSocket) throw new Error("'WebSocket' is not supported in your environment.");
                return new (0, $6GOaP.WebSocketTransport)(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
            case (0, $5XgIu.HttpTransportType).ServerSentEvents:
                if (!this._options.EventSource) throw new Error("'EventSource' is not supported in your environment.");
                return new (0, $kcoxl.ServerSentEventsTransport)(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
            case (0, $5XgIu.HttpTransportType).LongPolling:
                return new (0, $ee4Gf.LongPollingTransport)(this._httpClient, this._logger, this._options);
            default:
                throw new Error(`Unknown transport: ${transport}.`);
        }
    }
    _startTransport(url, transferFormat) {
        this.transport.onreceive = this.onreceive;
        if (this.features.reconnect) this.transport.onclose = async (e)=>{
            let callStop = false;
            if (this.features.reconnect) try {
                this.features.disconnected();
                await this.transport.connect(url, transferFormat);
                await this.features.resend();
            } catch  {
                callStop = true;
            }
            else {
                this._stopConnection(e);
                return;
            }
            if (callStop) this._stopConnection(e);
        };
        else this.transport.onclose = (e)=>this._stopConnection(e);
        return this.transport.connect(url, transferFormat);
    }
    _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, useStatefulReconnect) {
        const transport = (0, $5XgIu.HttpTransportType)[endpoint.transport];
        if (transport === null || transport === undefined) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
            return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
        } else if ($fa05c729d79bb7aa$var$transportMatches(requestedTransport, transport)) {
            const transferFormats = endpoint.transferFormats.map((s)=>(0, $5XgIu.TransferFormat)[s]);
            if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                if (transport === (0, $5XgIu.HttpTransportType).WebSockets && !this._options.WebSocket || transport === (0, $5XgIu.HttpTransportType).ServerSentEvents && !this._options.EventSource) {
                    this._logger.log((0, $2lJPz.LogLevel).Debug, `Skipping transport '${(0, $5XgIu.HttpTransportType)[transport]}' because it is not supported in your environment.'`);
                    return new (0, $e70Ea.UnsupportedTransportError)(`'${(0, $5XgIu.HttpTransportType)[transport]}' is not supported in your environment.`, transport);
                } else {
                    this._logger.log((0, $2lJPz.LogLevel).Debug, `Selecting transport '${(0, $5XgIu.HttpTransportType)[transport]}'.`);
                    try {
                        this.features.reconnect = transport === (0, $5XgIu.HttpTransportType).WebSockets ? useStatefulReconnect : undefined;
                        return this._constructTransport(transport);
                    } catch (ex) {
                        return ex;
                    }
                }
            } else {
                this._logger.log((0, $2lJPz.LogLevel).Debug, `Skipping transport '${(0, $5XgIu.HttpTransportType)[transport]}' because it does not support the requested transfer format '${(0, $5XgIu.TransferFormat)[requestedTransferFormat]}'.`);
                return new Error(`'${(0, $5XgIu.HttpTransportType)[transport]}' does not support ${(0, $5XgIu.TransferFormat)[requestedTransferFormat]}.`);
            }
        } else {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Skipping transport '${(0, $5XgIu.HttpTransportType)[transport]}' because it was disabled by the client.`);
            return new (0, $e70Ea.DisabledTransportError)(`'${(0, $5XgIu.HttpTransportType)[transport]}' is disabled by the client.`, transport);
        }
    }
    _isITransport(transport) {
        return transport && typeof transport === "object" && "connect" in transport;
    }
    _stopConnection(error) {
        this._logger.log((0, $2lJPz.LogLevel).Debug, `HttpConnection.stopConnection(${error}) called while in state ${this._connectionState}.`);
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this._stopError || error;
        this._stopError = undefined;
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $2lJPz.LogLevel).Debug, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is already in the disconnected state.`);
            return;
        }
        if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
            this._logger.log((0, $2lJPz.LogLevel).Warning, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is still in the connecting state.`);
            throw new Error(`HttpConnection.stopConnection(${error}) was called while the connection is still in the connecting state.`);
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) // A call to stop() induced this call to stopConnection and needs to be completed.
        // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
        this._stopPromiseResolver();
        if (error) this._logger.log((0, $2lJPz.LogLevel).Error, `Connection disconnected with error '${error}'.`);
        else this._logger.log((0, $2lJPz.LogLevel).Information, "Connection disconnected.");
        if (this._sendQueue) {
            this._sendQueue.stop().catch((e)=>{
                this._logger.log((0, $2lJPz.LogLevel).Error, `TransportSendQueue.stop() threw error '${e}'.`);
            });
            this._sendQueue = undefined;
        }
        this.connectionId = undefined;
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        if (this._connectionStarted) {
            this._connectionStarted = false;
            try {
                if (this.onclose) this.onclose(error);
            } catch (e) {
                this._logger.log((0, $2lJPz.LogLevel).Error, `HttpConnection.onclose(${error}) threw error '${e}'.`);
            }
        }
    }
    _resolveUrl(url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) return url;
        if (!(0, $2ni4V.Platform).isBrowser) throw new Error(`Cannot resolve '${url}'.`);
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        const aTag = window.document.createElement("a");
        aTag.href = url;
        this._logger.log((0, $2lJPz.LogLevel).Information, `Normalizing '${url}' to '${aTag.href}'.`);
        return aTag.href;
    }
    _resolveNegotiateUrl(url) {
        const negotiateUrl = new URL(url);
        if (negotiateUrl.pathname.endsWith('/')) negotiateUrl.pathname += "negotiate";
        else negotiateUrl.pathname += "/negotiate";
        const searchParams = new URLSearchParams(negotiateUrl.searchParams);
        if (!searchParams.has("negotiateVersion")) searchParams.append("negotiateVersion", this._negotiateVersion.toString());
        if (searchParams.has("useStatefulReconnect")) {
            if (searchParams.get("useStatefulReconnect") === "true") this._options._useStatefulReconnect = true;
        } else if (this._options._useStatefulReconnect === true) searchParams.append("useStatefulReconnect", "true");
        negotiateUrl.search = searchParams.toString();
        return negotiateUrl.toString();
    }
}
function $fa05c729d79bb7aa$var$transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
class $fa05c729d79bb7aa$export$ff09921d3884e946 {
    constructor(_transport){
        this._transport = _transport;
        this._buffer = [];
        this._executing = true;
        this._sendBufferedData = new $fa05c729d79bb7aa$var$PromiseSource();
        this._transportResult = new $fa05c729d79bb7aa$var$PromiseSource();
        this._sendLoopPromise = this._sendLoop();
    }
    send(data) {
        this._bufferData(data);
        if (!this._transportResult) this._transportResult = new $fa05c729d79bb7aa$var$PromiseSource();
        return this._transportResult.promise;
    }
    stop() {
        this._executing = false;
        this._sendBufferedData.resolve();
        return this._sendLoopPromise;
    }
    _bufferData(data) {
        if (this._buffer.length && typeof this._buffer[0] !== typeof data) throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof data}`);
        this._buffer.push(data);
        this._sendBufferedData.resolve();
    }
    async _sendLoop() {
        while(true){
            await this._sendBufferedData.promise;
            if (!this._executing) {
                if (this._transportResult) this._transportResult.reject("Connection stopped.");
                break;
            }
            this._sendBufferedData = new $fa05c729d79bb7aa$var$PromiseSource();
            const transportResult = this._transportResult;
            this._transportResult = undefined;
            const data = typeof this._buffer[0] === "string" ? this._buffer.join("") : $fa05c729d79bb7aa$export$ff09921d3884e946._concatBuffers(this._buffer);
            this._buffer.length = 0;
            try {
                await this._transport.send(data);
                transportResult.resolve();
            } catch (error) {
                transportResult.reject(error);
            }
        }
    }
    static _concatBuffers(arrayBuffers) {
        const totalLength = arrayBuffers.map((b)=>b.byteLength).reduce((a, b)=>a + b);
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const item of arrayBuffers){
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    }
}
class $fa05c729d79bb7aa$var$PromiseSource {
    constructor(){
        this.promise = new Promise((resolve, reject)=>([this._resolver, this._rejecter] = [
                resolve,
                reject
            ]));
    }
    resolve() {
        this._resolver();
    }
    reject(reason) {
        this._rejecter(reason);
    }
}

});
parcelRegister("52Hoh", function(module, exports) {

$parcel$export(module.exports, "AccessTokenHttpClient", function () { return $3abecc1cc9656120$export$981ab95414418dd3; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $i6cTK = parcelRequire("i6cTK");

var $8affm = parcelRequire("8affm");
class $3abecc1cc9656120$export$981ab95414418dd3 extends (0, $8affm.HttpClient) {
    constructor(innerClient, accessTokenFactory){
        super();
        this._innerClient = innerClient;
        this._accessTokenFactory = accessTokenFactory;
    }
    async send(request) {
        let allowRetry = true;
        if (this._accessTokenFactory && (!this._accessToken || request.url && request.url.indexOf("/negotiate?") > 0)) {
            // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
            allowRetry = false;
            this._accessToken = await this._accessTokenFactory();
        }
        this._setAuthorizationHeader(request);
        const response = await this._innerClient.send(request);
        if (allowRetry && response.statusCode === 401 && this._accessTokenFactory) {
            this._accessToken = await this._accessTokenFactory();
            this._setAuthorizationHeader(request);
            return await this._innerClient.send(request);
        }
        return response;
    }
    _setAuthorizationHeader(request) {
        if (!request.headers) request.headers = {};
        if (this._accessToken) request.headers[(0, $i6cTK.HeaderNames).Authorization] = `Bearer ${this._accessToken}`;
        else if (this._accessTokenFactory) {
            if (request.headers[(0, $i6cTK.HeaderNames).Authorization]) delete request.headers[(0, $i6cTK.HeaderNames).Authorization];
        }
    }
    getCookieString(url) {
        return this._innerClient.getCookieString(url);
    }
}

});
parcelRegister("i6cTK", function(module, exports) {

$parcel$export(module.exports, "HeaderNames", function () { return $d2d2cad879ae3412$export$28d77f87efed1d88; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
class $d2d2cad879ae3412$export$28d77f87efed1d88 {
}
$d2d2cad879ae3412$export$28d77f87efed1d88.Authorization = "Authorization";
$d2d2cad879ae3412$export$28d77f87efed1d88.Cookie = "Cookie";

});

parcelRegister("8affm", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", function () { return $5f1b15940ef7cad1$export$1d94dfe0d9d1f1e7; });
$parcel$export(module.exports, "HttpClient", function () { return $5f1b15940ef7cad1$export$8c6ee871e681f0f4; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Represents an HTTP response. */ class $5f1b15940ef7cad1$export$1d94dfe0d9d1f1e7 {
    constructor(statusCode, statusText, content){
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
}
class $5f1b15940ef7cad1$export$8c6ee871e681f0f4 {
    get(url, options) {
        return this.send({
            ...options,
            method: "GET",
            url: url
        });
    }
    post(url, options) {
        return this.send({
            ...options,
            method: "POST",
            url: url
        });
    }
    delete(url, options) {
        return this.send({
            ...options,
            method: "DELETE",
            url: url
        });
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */ // @ts-ignore
    getCookieString(url) {
        return "";
    }
}

});


parcelRegister("equCX", function(module, exports) {

$parcel$export(module.exports, "DefaultHttpClient", function () { return $a80b405df4006b79$export$4f11ab3560c519e5; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $e70Ea = parcelRequire("e70Ea");

var $6JwWN = parcelRequire("6JwWN");

var $8affm = parcelRequire("8affm");

var $2ni4V = parcelRequire("2ni4V");

var $bK0D2 = parcelRequire("bK0D2");
class $a80b405df4006b79$export$4f11ab3560c519e5 extends (0, $8affm.HttpClient) {
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */ constructor(logger){
        super();
        if (typeof fetch !== "undefined" || (0, $2ni4V.Platform).isNode) this._httpClient = new (0, $6JwWN.FetchHttpClient)(logger);
        else if (typeof XMLHttpRequest !== "undefined") this._httpClient = new (0, $bK0D2.XhrHttpClient)(logger);
        else throw new Error("No usable HttpClient found.");
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $e70Ea.AbortError)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return this._httpClient.send(request);
    }
    getCookieString(url) {
        return this._httpClient.getCookieString(url);
    }
}

});
parcelRegister("6JwWN", function(module, exports) {

$parcel$export(module.exports, "FetchHttpClient", function () { return $4e7080af7da6c8a8$export$1b51ed6f7c8f947b; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $e70Ea = parcelRequire("e70Ea");

var $8affm = parcelRequire("8affm");

var $2lJPz = parcelRequire("2lJPz");

var $2ni4V = parcelRequire("2ni4V");
class $4e7080af7da6c8a8$export$1b51ed6f7c8f947b extends (0, $8affm.HttpClient) {
    constructor(logger){
        super();
        this._logger = logger;
        // Node added a fetch implementation to the global scope starting in v18.
        // We need to add a cookie jar in node to be able to share cookies with WebSocket
        if (typeof fetch === "undefined" || (0, $2ni4V.Platform).isNode) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            this._jar = new (requireFunc("tough-cookie")).CookieJar();
            if (typeof fetch === "undefined") this._fetchType = requireFunc("node-fetch");
            else // Use fetch from Node if available
            this._fetchType = fetch;
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
        } else this._fetchType = fetch.bind((0, $2ni4V.getGlobalThis)());
        if (typeof AbortController === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            this._abortControllerType = requireFunc("abort-controller");
        } else this._abortControllerType = AbortController;
    }
    /** @inheritDoc */ async send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) throw new (0, $e70Ea.AbortError)();
        if (!request.method) throw new Error("No method defined.");
        if (!request.url) throw new Error("No url defined.");
        const abortController = new this._abortControllerType();
        let error;
        // Hook our abortSignal into the abort controller
        if (request.abortSignal) request.abortSignal.onabort = ()=>{
            abortController.abort();
            error = new (0, $e70Ea.AbortError)();
        };
        // If a timeout has been passed in, setup a timeout to call abort
        // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
        let timeoutId = null;
        if (request.timeout) {
            const msTimeout = request.timeout;
            timeoutId = setTimeout(()=>{
                abortController.abort();
                this._logger.log((0, $2lJPz.LogLevel).Warning, `Timeout from HTTP request.`);
                error = new (0, $e70Ea.TimeoutError)();
            }, msTimeout);
        }
        if (request.content === "") request.content = undefined;
        if (request.content) {
            // Explicitly setting the Content-Type header for React Native on Android platform.
            request.headers = request.headers || {};
            if ((0, $2ni4V.isArrayBuffer)(request.content)) request.headers["Content-Type"] = "application/octet-stream";
            else request.headers["Content-Type"] = "text/plain;charset=UTF-8";
        }
        let response;
        try {
            response = await this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    ...request.headers
                },
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal
            });
        } catch (e) {
            if (error) throw error;
            this._logger.log((0, $2lJPz.LogLevel).Warning, `Error from HTTP request. ${e}.`);
            throw e;
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (request.abortSignal) request.abortSignal.onabort = null;
        }
        if (!response.ok) {
            const errorMessage = await $4e7080af7da6c8a8$var$deserializeContent(response, "text");
            throw new (0, $e70Ea.HttpError)(errorMessage || response.statusText, response.status);
        }
        const content = $4e7080af7da6c8a8$var$deserializeContent(response, request.responseType);
        const payload = await content;
        return new (0, $8affm.HttpResponse)(response.status, response.statusText, payload);
    }
    getCookieString(url) {
        let cookies = "";
        if ((0, $2ni4V.Platform).isNode && this._jar) // @ts-ignore: unused variable
        this._jar.getCookies(url, (e, c)=>cookies = c.join("; "));
        return cookies;
    }
}
function $4e7080af7da6c8a8$var$deserializeContent(response, responseType) {
    let content;
    switch(responseType){
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(`${responseType} is not supported.`);
        default:
            content = response.text();
            break;
    }
    return content;
}

});

parcelRegister("bK0D2", function(module, exports) {

$parcel$export(module.exports, "XhrHttpClient", function () { return $88c47a726c469aa4$export$33b9ed1bd07561aa; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $e70Ea = parcelRequire("e70Ea");

var $8affm = parcelRequire("8affm");

var $2lJPz = parcelRequire("2lJPz");

var $2ni4V = parcelRequire("2ni4V");
class $88c47a726c469aa4$export$33b9ed1bd07561aa extends (0, $8affm.HttpClient) {
    constructor(logger){
        super();
        this._logger = logger;
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $e70Ea.AbortError)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            if (request.content === "") request.content = undefined;
            if (request.content) {
                // Explicitly setting the Content-Type header for React Native on Android platform.
                if ((0, $2ni4V.isArrayBuffer)(request.content)) xhr.setRequestHeader("Content-Type", "application/octet-stream");
                else xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            }
            const headers = request.headers;
            if (headers) Object.keys(headers).forEach((header)=>{
                xhr.setRequestHeader(header, headers[header]);
            });
            if (request.responseType) xhr.responseType = request.responseType;
            if (request.abortSignal) request.abortSignal.onabort = ()=>{
                xhr.abort();
                reject(new (0, $e70Ea.AbortError)());
            };
            if (request.timeout) xhr.timeout = request.timeout;
            xhr.onload = ()=>{
                if (request.abortSignal) request.abortSignal.onabort = null;
                if (xhr.status >= 200 && xhr.status < 300) resolve(new (0, $8affm.HttpResponse)(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                else reject(new (0, $e70Ea.HttpError)(xhr.response || xhr.responseText || xhr.statusText, xhr.status));
            };
            xhr.onerror = ()=>{
                this._logger.log((0, $2lJPz.LogLevel).Warning, `Error from HTTP request. ${xhr.status}: ${xhr.statusText}.`);
                reject(new (0, $e70Ea.HttpError)(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = ()=>{
                this._logger.log((0, $2lJPz.LogLevel).Warning, `Timeout from HTTP request.`);
                reject(new (0, $e70Ea.TimeoutError)());
            };
            xhr.send(request.content);
        });
    }
}

});


parcelRegister("5XgIu", function(module, exports) {

$parcel$export(module.exports, "HttpTransportType", function () { return $455f6e07128930bf$export$789ba40ee1a75f0; });
$parcel$export(module.exports, "TransferFormat", function () { return $455f6e07128930bf$export$f29afaa8e8d2989a; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */ var $455f6e07128930bf$export$789ba40ee1a75f0;
(function(HttpTransportType) {
    /** Specifies no transport preference. */ HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */ HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */ HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */ HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})($455f6e07128930bf$export$789ba40ee1a75f0 || ($455f6e07128930bf$export$789ba40ee1a75f0 = {}));
var $455f6e07128930bf$export$f29afaa8e8d2989a;
(function(TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */ TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */ TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})($455f6e07128930bf$export$f29afaa8e8d2989a || ($455f6e07128930bf$export$f29afaa8e8d2989a = {}));

});

parcelRegister("ee4Gf", function(module, exports) {

$parcel$export(module.exports, "LongPollingTransport", function () { return $a5b600f07e69c927$export$fbd8c90d2cca1300; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $bkBLz = parcelRequire("bkBLz");

var $e70Ea = parcelRequire("e70Ea");

var $2lJPz = parcelRequire("2lJPz");

var $5XgIu = parcelRequire("5XgIu");

var $2ni4V = parcelRequire("2ni4V");
class $a5b600f07e69c927$export$fbd8c90d2cca1300 {
    // This is an internal type, not exported from 'index' so this is really just internal.
    get pollAborted() {
        return this._pollAbort.aborted;
    }
    constructor(httpClient, logger, options){
        this._httpClient = httpClient;
        this._logger = logger;
        this._pollAbort = new (0, $bkBLz.AbortController)();
        this._options = options;
        this._running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $2ni4V.Arg).isRequired(url, "url");
        (0, $2ni4V.Arg).isRequired(transferFormat, "transferFormat");
        (0, $2ni4V.Arg).isIn(transferFormat, (0, $5XgIu.TransferFormat), "transferFormat");
        this._url = url;
        this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) Connecting.");
        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
        if (transferFormat === (0, $5XgIu.TransferFormat).Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string") throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        const [name, value] = (0, $2ni4V.getUserAgentHeader)();
        const headers = {
            [name]: value,
            ...this._options.headers
        };
        const pollOptions = {
            abortSignal: this._pollAbort.signal,
            headers: headers,
            timeout: 100000,
            withCredentials: this._options.withCredentials
        };
        if (transferFormat === (0, $5XgIu.TransferFormat).Binary) pollOptions.responseType = "arraybuffer";
        // Make initial long polling request
        // Server uses first long polling request to finish initializing connection and it returns without data
        const pollUrl = `${url}&_=${Date.now()}`;
        this._logger.log((0, $2lJPz.LogLevel).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
        const response = await this._httpClient.get(pollUrl, pollOptions);
        if (response.statusCode !== 200) {
            this._logger.log((0, $2lJPz.LogLevel).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            // Mark running as false so that the poll immediately ends and runs the close logic
            this._closeError = new (0, $e70Ea.HttpError)(response.statusText || "", response.statusCode);
            this._running = false;
        } else this._running = true;
        this._receiving = this._poll(this._url, pollOptions);
    }
    async _poll(url, pollOptions) {
        try {
            while(this._running)try {
                const pollUrl = `${url}&_=${Date.now()}`;
                this._logger.log((0, $2lJPz.LogLevel).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
                const response = await this._httpClient.get(pollUrl, pollOptions);
                if (response.statusCode === 204) {
                    this._logger.log((0, $2lJPz.LogLevel).Information, "(LongPolling transport) Poll terminated by server.");
                    this._running = false;
                } else if (response.statusCode !== 200) {
                    this._logger.log((0, $2lJPz.LogLevel).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
                    // Unexpected status code
                    this._closeError = new (0, $e70Ea.HttpError)(response.statusText || "", response.statusCode);
                    this._running = false;
                } else // Process the response
                if (response.content) {
                    this._logger.log((0, $2lJPz.LogLevel).Trace, `(LongPolling transport) data received. ${(0, $2ni4V.getDataDetail)(response.content, this._options.logMessageContent)}.`);
                    if (this.onreceive) this.onreceive(response.content);
                } else // This is another way timeout manifest.
                this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) Poll timed out, reissuing.");
            } catch (e) {
                if (!this._running) // Log but disregard errors that occur after stopping
                this._logger.log((0, $2lJPz.LogLevel).Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
                else if (e instanceof (0, $e70Ea.TimeoutError)) // Ignore timeouts and reissue the poll.
                this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) Poll timed out, reissuing.");
                else {
                    // Close the connection with the error as the result.
                    this._closeError = e;
                    this._running = false;
                }
            }
        } finally{
            this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) Polling complete.");
            // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
            if (!this.pollAborted) this._raiseOnClose();
        }
    }
    async send(data) {
        if (!this._running) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $2ni4V.sendMessage)(this._logger, "LongPolling", this._httpClient, this._url, data, this._options);
    }
    async stop() {
        this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) Stopping polling.");
        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
        this._running = false;
        this._pollAbort.abort();
        try {
            await this._receiving;
            // Send DELETE to clean up long polling on the server
            this._logger.log((0, $2lJPz.LogLevel).Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
            const headers = {};
            const [name, value] = (0, $2ni4V.getUserAgentHeader)();
            headers[name] = value;
            const deleteOptions = {
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            };
            let error;
            try {
                await this._httpClient.delete(this._url, deleteOptions);
            } catch (err) {
                error = err;
            }
            if (error) {
                if (error instanceof (0, $e70Ea.HttpError)) {
                    if (error.statusCode === 404) this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.");
                    else this._logger.log((0, $2lJPz.LogLevel).Trace, `(LongPolling transport) Error sending a DELETE request: ${error}`);
                }
            } else this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) DELETE request accepted.");
        } finally{
            this._logger.log((0, $2lJPz.LogLevel).Trace, "(LongPolling transport) Stop finished.");
            // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent
            this._raiseOnClose();
        }
    }
    _raiseOnClose() {
        if (this.onclose) {
            let logMessage = "(LongPolling transport) Firing onclose event.";
            if (this._closeError) logMessage += " Error: " + this._closeError;
            this._logger.log((0, $2lJPz.LogLevel).Trace, logMessage);
            this.onclose(this._closeError);
        }
    }
}

});
parcelRegister("bkBLz", function(module, exports) {

$parcel$export(module.exports, "AbortController", function () { return $83fedb8ffb711517$export$48f7e099c149af88; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */ class $83fedb8ffb711517$export$48f7e099c149af88 {
    constructor(){
        this._isAborted = false;
        this.onabort = null;
    }
    abort() {
        if (!this._isAborted) {
            this._isAborted = true;
            if (this.onabort) this.onabort();
        }
    }
    get signal() {
        return this;
    }
    get aborted() {
        return this._isAborted;
    }
}

});


parcelRegister("kcoxl", function(module, exports) {

$parcel$export(module.exports, "ServerSentEventsTransport", function () { return $eb47f61c8d732bb0$export$f0d4dc62ec317948; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $2lJPz = parcelRequire("2lJPz");

var $5XgIu = parcelRequire("5XgIu");

var $2ni4V = parcelRequire("2ni4V");
class $eb47f61c8d732bb0$export$f0d4dc62ec317948 {
    constructor(httpClient, accessToken, logger, options){
        this._httpClient = httpClient;
        this._accessToken = accessToken;
        this._logger = logger;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $2ni4V.Arg).isRequired(url, "url");
        (0, $2ni4V.Arg).isRequired(transferFormat, "transferFormat");
        (0, $2ni4V.Arg).isIn(transferFormat, (0, $5XgIu.TransferFormat), "transferFormat");
        this._logger.log((0, $2lJPz.LogLevel).Trace, "(SSE transport) Connecting.");
        // set url before accessTokenFactory because this._url is only for send and we set the auth header instead of the query string for send
        this._url = url;
        if (this._accessToken) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`;
        return new Promise((resolve, reject)=>{
            let opened = false;
            if (transferFormat !== (0, $5XgIu.TransferFormat).Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
            }
            let eventSource;
            if ((0, $2ni4V.Platform).isBrowser || (0, $2ni4V.Platform).isWebWorker) eventSource = new this._options.EventSource(url, {
                withCredentials: this._options.withCredentials
            });
            else {
                // Non-browser passes cookies via the dictionary
                const cookies = this._httpClient.getCookieString(url);
                const headers = {};
                headers.Cookie = cookies;
                const [name, value] = (0, $2ni4V.getUserAgentHeader)();
                headers[name] = value;
                eventSource = new this._options.EventSource(url, {
                    withCredentials: this._options.withCredentials,
                    headers: {
                        ...headers,
                        ...this._options.headers
                    }
                });
            }
            try {
                eventSource.onmessage = (e)=>{
                    if (this.onreceive) try {
                        this._logger.log((0, $2lJPz.LogLevel).Trace, `(SSE transport) data received. ${(0, $2ni4V.getDataDetail)(e.data, this._options.logMessageContent)}.`);
                        this.onreceive(e.data);
                    } catch (error) {
                        this._close(error);
                        return;
                    }
                };
                // @ts-ignore: not using event on purpose
                eventSource.onerror = (e)=>{
                    // EventSource doesn't give any useful information about server side closes.
                    if (opened) this._close();
                    else reject(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
                };
                eventSource.onopen = ()=>{
                    this._logger.log((0, $2lJPz.LogLevel).Information, `SSE connected to ${this._url}`);
                    this._eventSource = eventSource;
                    opened = true;
                    resolve();
                };
            } catch (e) {
                reject(e);
                return;
            }
        });
    }
    async send(data) {
        if (!this._eventSource) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $2ni4V.sendMessage)(this._logger, "SSE", this._httpClient, this._url, data, this._options);
    }
    stop() {
        this._close();
        return Promise.resolve();
    }
    _close(e) {
        if (this._eventSource) {
            this._eventSource.close();
            this._eventSource = undefined;
            if (this.onclose) this.onclose(e);
        }
    }
}

});

parcelRegister("6GOaP", function(module, exports) {

$parcel$export(module.exports, "WebSocketTransport", function () { return $4ded95c2d80203e8$export$de21836fc42c6f9c; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $i6cTK = parcelRequire("i6cTK");

var $2lJPz = parcelRequire("2lJPz");

var $5XgIu = parcelRequire("5XgIu");

var $2ni4V = parcelRequire("2ni4V");
class $4ded95c2d80203e8$export$de21836fc42c6f9c {
    constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers){
        this._logger = logger;
        this._accessTokenFactory = accessTokenFactory;
        this._logMessageContent = logMessageContent;
        this._webSocketConstructor = webSocketConstructor;
        this._httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this._headers = headers;
    }
    async connect(url, transferFormat) {
        (0, $2ni4V.Arg).isRequired(url, "url");
        (0, $2ni4V.Arg).isRequired(transferFormat, "transferFormat");
        (0, $2ni4V.Arg).isIn(transferFormat, (0, $5XgIu.TransferFormat), "transferFormat");
        this._logger.log((0, $2lJPz.LogLevel).Trace, "(WebSockets transport) Connecting.");
        let token;
        if (this._accessTokenFactory) token = await this._accessTokenFactory();
        return new Promise((resolve, reject)=>{
            url = url.replace(/^http/, "ws");
            let webSocket;
            const cookies = this._httpClient.getCookieString(url);
            let opened = false;
            if ((0, $2ni4V.Platform).isNode || (0, $2ni4V.Platform).isReactNative) {
                const headers = {};
                const [name, value] = (0, $2ni4V.getUserAgentHeader)();
                headers[name] = value;
                if (token) headers[(0, $i6cTK.HeaderNames).Authorization] = `Bearer ${token}`;
                if (cookies) headers[(0, $i6cTK.HeaderNames).Cookie] = cookies;
                // Only pass headers when in non-browser environments
                webSocket = new this._webSocketConstructor(url, undefined, {
                    headers: {
                        ...headers,
                        ...this._headers
                    }
                });
            } else if (token) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
            if (!webSocket) // Chrome is not happy with passing 'undefined' as protocol
            webSocket = new this._webSocketConstructor(url);
            if (transferFormat === (0, $5XgIu.TransferFormat).Binary) webSocket.binaryType = "arraybuffer";
            webSocket.onopen = (_event)=>{
                this._logger.log((0, $2lJPz.LogLevel).Information, `WebSocket connected to ${url}.`);
                this._webSocket = webSocket;
                opened = true;
                resolve();
            };
            webSocket.onerror = (event)=>{
                let error = null;
                // ErrorEvent is a browser only type we need to check if the type exists before using it
                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                else error = "There was an error with the transport";
                this._logger.log((0, $2lJPz.LogLevel).Information, `(WebSockets transport) ${error}.`);
            };
            webSocket.onmessage = (message)=>{
                this._logger.log((0, $2lJPz.LogLevel).Trace, `(WebSockets transport) data received. ${(0, $2ni4V.getDataDetail)(message.data, this._logMessageContent)}.`);
                if (this.onreceive) try {
                    this.onreceive(message.data);
                } catch (error) {
                    this._close(error);
                    return;
                }
            };
            webSocket.onclose = (event)=>{
                // Don't call close handler if connection was never established
                // We'll reject the connect call instead
                if (opened) this._close(event);
                else {
                    let error = null;
                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                    else error = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.";
                    reject(new Error(error));
                }
            };
        });
    }
    send(data) {
        if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
            this._logger.log((0, $2lJPz.LogLevel).Trace, `(WebSockets transport) sending data. ${(0, $2ni4V.getDataDetail)(data, this._logMessageContent)}.`);
            this._webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    }
    stop() {
        if (this._webSocket) // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
        // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
        this._close(undefined);
        return Promise.resolve();
    }
    _close(event) {
        // webSocket will be null if the transport did not start successfully
        if (this._webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this._webSocket.onclose = ()=>{};
            this._webSocket.onmessage = ()=>{};
            this._webSocket.onerror = ()=>{};
            this._webSocket.close();
            this._webSocket = undefined;
        }
        this._logger.log((0, $2lJPz.LogLevel).Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
            else if (event instanceof Error) this.onclose(event);
            else this.onclose();
        }
    }
    _isCloseEvent(event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
}

});


parcelRegister("c4g9F", function(module, exports) {

$parcel$export(module.exports, "JsonHubProtocol", function () { return $8c9263cdbf450d3e$export$11f4f8ecec1ad0c8; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $c7ba6 = parcelRequire("c7ba6");

var $2lJPz = parcelRequire("2lJPz");

var $5XgIu = parcelRequire("5XgIu");

var $6Ulgh = parcelRequire("6Ulgh");

var $lYlVt = parcelRequire("lYlVt");
const $8c9263cdbf450d3e$var$JSON_HUB_PROTOCOL_NAME = "json";
class $8c9263cdbf450d3e$export$11f4f8ecec1ad0c8 {
    constructor(){
        /** @inheritDoc */ this.name = $8c9263cdbf450d3e$var$JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */ this.version = 2;
        /** @inheritDoc */ this.transferFormat = (0, $5XgIu.TransferFormat).Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */ parseMessages(input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        if (!input) return [];
        if (logger === null) logger = (0, $6Ulgh.NullLogger).instance;
        // Parse the messages
        const messages = (0, $lYlVt.TextMessageFormat).parse(input);
        const hubMessages = [];
        for (const message of messages){
            const parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") throw new Error("Invalid payload.");
            switch(parsedMessage.type){
                case (0, $c7ba6.MessageType).Invocation:
                    this._isInvocationMessage(parsedMessage);
                    break;
                case (0, $c7ba6.MessageType).StreamItem:
                    this._isStreamItemMessage(parsedMessage);
                    break;
                case (0, $c7ba6.MessageType).Completion:
                    this._isCompletionMessage(parsedMessage);
                    break;
                case (0, $c7ba6.MessageType).Ping:
                    break;
                case (0, $c7ba6.MessageType).Close:
                    break;
                case (0, $c7ba6.MessageType).Ack:
                    this._isAckMessage(parsedMessage);
                    break;
                case (0, $c7ba6.MessageType).Sequence:
                    this._isSequenceMessage(parsedMessage);
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log((0, $2lJPz.LogLevel).Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */ writeMessage(message) {
        return (0, $lYlVt.TextMessageFormat).write(JSON.stringify(message));
    }
    _isInvocationMessage(message) {
        this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
    }
    _isStreamItemMessage(message) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) throw new Error("Invalid payload for StreamItem message.");
    }
    _isCompletionMessage(message) {
        if (message.result && message.error) throw new Error("Invalid payload for Completion message.");
        if (!message.result && message.error) this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
    _isAckMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Ack message.");
    }
    _isSequenceMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Sequence message.");
    }
    _assertNotEmptyString(value, errorMessage) {
        if (typeof value !== "string" || value === "") throw new Error(errorMessage);
    }
}

});





parcelRegister("4Klmq", function(module, exports) {

$parcel$export(module.exports, "hierarchyLegacyTagRedirectLoader", function () { return $e7a82e31abb9faa4$export$e55775b1a1e8d134; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $wPq5H = parcelRequire("wPq5H");

var $gxpCl = parcelRequire("gxpCl");

var $k79Le = parcelRequire("k79Le");
const $e7a82e31abb9faa4$export$e55775b1a1e8d134 = async ({ params: params, request: request })=>{
    const url = new URL(request.url);
    const searchParams = new URLSearchParams(url.search);
    // Build the loader URL depending on which route params are present.
    // Report routes carry studyName + reportName; all other hierarchy routes
    // carry a single hierarchyTag.
    // getHierarchyLoaderUrl now always builds a query-string URL (e.g.,
    // Hierarchy/Loader?hierarchyTag=... or Hierarchy/Loader?studyTag=...&reportName=...),
    // which returns the full HierarchyLoaderReturn including taPrefix / projectCode.
    let loaderUrl;
    if (params.studyName !== undefined && params.reportName !== undefined) loaderUrl = (0, $k79Le.getHierarchyLoaderUrl)({
        studyTag: params.studyName,
        reportName: params.reportName,
        tocMajorVersion: params.tocMajorVersion
    });
    else if (params.hierarchyTag !== undefined) loaderUrl = (0, $k79Le.getHierarchyLoaderUrl)({
        hierarchyTag: params.hierarchyTag
    });
    if (loaderUrl !== undefined) {
        const response = await (0, $a04va.default).get(loaderUrl);
        /* istanbul ignore else */ if (response?.data?.hierarchy) {
            // Concatenate params.more and the splat wildcard when both are present so
            // that multi-segment deep links (e.g. /TA/CARDIO/Access/Extra) are fully
            // preserved rather than silently truncated to only the first tail segment.
            const trailingPath = params.more !== undefined && params["*"] !== undefined ? `${params.more}/${params["*"]}` : params.more ?? params["*"];
            const newPath = (0, $wPq5H.getHierarchyBaseUrl)(response.data.hierarchy) + (trailingPath !== undefined && trailingPath !== "" ? `/${trailingPath}` : "");
            const redirectTo = new URL(url.origin + newPath);
            redirectTo.search = searchParams.toString();
            return (0, $gxpCl.redirect)(redirectTo.toString());
        }
    }
    return (0, $gxpCl.redirect)("/Corporate");
};

});
parcelRegister("k79Le", function(module, exports) {

$parcel$export(module.exports, "getHierarchyLoaderUrl", function () { return $47f32c40a3da2562$export$1b22695b5769746; });
$parcel$export(module.exports, "getHierarchyLoaderData", function () { return $47f32c40a3da2562$export$a567ee8e80e3e23; });
$parcel$export(module.exports, "hierarchyLoader", function () { return $47f32c40a3da2562$export$2c5c2c1bafe112f7; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $5RbkJ = parcelRequire("5RbkJ");

var $dRarR = parcelRequire("dRarR");

var $cDJgj = parcelRequire("cDJgj");
const $47f32c40a3da2562$export$1b22695b5769746 = (params)=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    const queryParams = new URLSearchParams();
    if (params.primaryHierarchyId) queryParams.set("primaryHierarchyId", params.primaryHierarchyId);
    if (params.hierarchyTag) queryParams.set("hierarchyTag", params.hierarchyTag);
    if (params.taPrefix) queryParams.set("taPrefix", params.taPrefix);
    if (params.projectCode) queryParams.set("projectCode", params.projectCode);
    if (params.studyTag) queryParams.set("studyTag", params.studyTag);
    if (params.reportName) queryParams.set("reportName", params.reportName);
    if (params.tocMajorVersion !== undefined) queryParams.set("tocMajorVersion", params.tocMajorVersion);
    if (queryParams.size === 0) queryParams.set("hierarchyTag", "Corporate");
    const queryString = queryParams.toString();
    return `${backEndUrl}Hierarchy/Loader?${queryString}`;
};
const $47f32c40a3da2562$export$a567ee8e80e3e23 = async (params)=>{
    const hierarchyLoader = await (0, $a04va.default).get($47f32c40a3da2562$export$1b22695b5769746(params));
    if (!hierarchyLoader || !hierarchyLoader.data) throw new Error("Invalid response from HierarchyLoader, no data returned");
    const subscriptionStatusLoader = await (0, $cDJgj.getSubscriptionStatusLoaderData)({
        params: {
            entityType: "Hierarchy",
            entityId: hierarchyLoader.data.hierarchy.id
        }
    });
    const ret = {
        hierarchy: hierarchyLoader.data.hierarchy,
        parentHierarchies: hierarchyLoader.data.parentHierarchies,
        accessRights: hierarchyLoader.data.accessRights,
        isHierarchySubscribed: subscriptionStatusLoader.isSubscribed
    };
    return ret;
};
const $47f32c40a3da2562$export$2c5c2c1bafe112f7 = async ({ params: params })=>$47f32c40a3da2562$export$a567ee8e80e3e23(params);

});
parcelRegister("cDJgj", function(module, exports) {

$parcel$export(module.exports, "getSubscriptionStatusLoaderData", function () { return $0b6da15248513377$export$e4de5290d9ba3c03; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $5RbkJ = parcelRequire("5RbkJ");

var $gSkQi = parcelRequire("gSkQi");

var $dRarR = parcelRequire("dRarR");
/**
 * Constructs the subscription status URL based on the entity type and ID.
 *
 * @param entityType - The type of the entity (e.g., "TlfItem", "Hierarchy").
 * @param entityId - The unique identifier of the entity.
 * @returns The constructed subscription status URL.
 */ const $0b6da15248513377$var$getSubscriptionUrl = (entityType, entityId)=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    return `${backEndUrl}Comments/${entityType}/${entityId}/GetSubscriptionStatus`;
};
const $0b6da15248513377$export$e4de5290d9ba3c03 = async ({ params: params })=>{
    const subscriptionStatusLoaderData = await (0, $a04va.default).get($0b6da15248513377$var$getSubscriptionUrl(params.entityType, params.entityId));
    if (!subscriptionStatusLoaderData || subscriptionStatusLoaderData.data === undefined || !(0, $gSkQi.isBoolean)(subscriptionStatusLoaderData.data)) throw new Error("Invalid or No response from SubscriptionStatus Loader");
    return {
        isSubscribed: subscriptionStatusLoaderData.data
    };
};

});



parcelRegister("fgSZv", function(module, exports) {

$parcel$export(module.exports, "hierarchyRedirectLoader", function () { return $c25be17e5e7fc800$export$479e664e1298840b; });

var $5RbkJ = parcelRequire("5RbkJ");

var $wPq5H = parcelRequire("wPq5H");

var $gxpCl = parcelRequire("gxpCl");

var $dRarR = parcelRequire("dRarR");

var $1ddQW = parcelRequire("1ddQW");
const $c25be17e5e7fc800$export$479e664e1298840b = async ({ params: params, request: request })=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    const hierarchyId = params.hierarchyId;
    const url = new URL(request.url);
    const searchParams = new URLSearchParams(url.search);
    /* istanbul ignore else */ if (hierarchyId !== undefined) {
        const hierarchyRequest = await (0, $1ddQW.loadHierarchy)(backEndUrl, {
            hierarchyId: hierarchyId
        });
        /* istanbul ignore else */ if (hierarchyRequest.success && hierarchyRequest.data) {
            const redirectTo = new URL(url.origin + (0, $wPq5H.getHierarchyBaseUrl)(hierarchyRequest.data) + (params.more !== undefined ? `/${params.more}` : ""));
            /* istanbul ignore else */ if (searchParams !== undefined) redirectTo.search = searchParams.toString();
            return (0, $gxpCl.redirect)(redirectTo.toString());
        }
    }
    return (0, $gxpCl.redirect)("/Corporate");
};

});
parcelRegister("1ddQW", function(module, exports) {

$parcel$export(module.exports, "loadHierarchy", function () { return $2c2ee3a59544bb68$export$73f90be9b2bf9d68; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $2c2ee3a59544bb68$export$73f90be9b2bf9d68 = async (backEndUrl, hierarchyQuery, controller)=>{
    let url = hierarchyQuery.hierarchyName ? `${backEndUrl}Hierarchy/Name/${hierarchyQuery.hierarchyName}` : `${backEndUrl}Hierarchy/Id/${hierarchyQuery.hierarchyId}`;
    if (hierarchyQuery.parentTag) url += `?parentTag=${hierarchyQuery.parentTag}`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load hierarchy failed", error);
    }
};

});


parcelRegister("e1HPF", function(module, exports) {

$parcel$export(module.exports, "newTlfLoader", function () { return $406fd05aa602ae14$export$f6716b75c06b3864; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $5RbkJ = parcelRequire("5RbkJ");

var $gxpCl = parcelRequire("gxpCl");

var $dRarR = parcelRequire("dRarR");

var $k79Le = parcelRequire("k79Le");

var $fYbUW = parcelRequire("fYbUW");
const $406fd05aa602ae14$export$f6716b75c06b3864 = async ({ params: params })=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    if (!params.newType) return (0, $gxpCl.redirect)("/NotFound");
    const hierarchyLoaderUrl = (0, $k79Le.getHierarchyLoaderUrl)(params);
    const requests = await Promise.all([
        (0, $a04va.default).get(`${backEndUrl}NewTlfItems/${params.newType}`),
        (0, $a04va.default).get(hierarchyLoaderUrl)
    ]);
    const newTlfItem = requests[0]?.data;
    const hierarchyLoader = requests[1]?.data;
    if (!newTlfItem || !hierarchyLoader.hierarchy) return (0, $gxpCl.redirect)("/NotFound");
    const isHierarchySubscribed = (await (0, $a04va.default).get(`${backEndUrl}Comments/Hierarchy/${hierarchyLoader.hierarchy.id}/GetSubscriptionStatus`)).data;
    newTlfItem.azsolId = "";
    newTlfItem.primaryHierarchyId = hierarchyLoader.hierarchy.id;
    newTlfItem.primaryHierarchyName = hierarchyLoader.hierarchy.name;
    newTlfItem.primaryHierarchyLevel = hierarchyLoader.hierarchy.level;
    newTlfItem.primaryHierarchyType = hierarchyLoader.hierarchy.type;
    newTlfItem.id = params.newType;
    // Ensure columnIds and columnInformation for new TLF items
    /* istanbul ignore else */ if ("bodyData" in newTlfItem.body && "headerData" in newTlfItem.body) newTlfItem.body = (0, $fYbUW.addColumnInformation)(newTlfItem.body);
    const ret = {
        tlfItem: newTlfItem,
        hierarchy: hierarchyLoader.hierarchy,
        parentHierarchies: hierarchyLoader.parentHierarchies,
        accessRights: hierarchyLoader.accessRights,
        isHierarchySubscribed: isHierarchySubscribed,
        isTlfSubscribed: false,
        isTlfNew: true
    };
    return ret;
};

});
parcelRegister("fYbUW", function(module, exports) {

$parcel$export(module.exports, "addColumnInformation", function () { return $6542cc16d9fe57d2$export$dc3d3c973936c665; });

var $94lfO = parcelRequire("94lfO");

var $cd7YP = parcelRequire("cd7YP");
const $6542cc16d9fe57d2$export$dc3d3c973936c665 = (body)=>{
    // Generate columnIds from the body
    const columnIds = (0, $cd7YP.generateColumnIds)(body);
    // If no columns detected, return body with empty columnInformation
    if (columnIds.length === 0) return {
        ...body,
        columnInformation: []
    };
    // Only generate columnInformation if empty or mismatched
    const columnInformation = body.columnInformation && body.columnInformation.length > 0 && columnIds.length === body.columnInformation.length ? body.columnInformation : columnIds.map((columnId, index)=>({
            columnId: columnId,
            originalColumnIndex: index
        }));
    // Check if columnIds already exist on the cells
    const hasExistingColumnIds = body.headerData && typeof body.headerData === "object" && "rows" in body.headerData && Array.isArray(body.headerData.rows) && body.headerData.rows.length > 0 && "cells" in body.headerData.rows[0] && Array.isArray(body.headerData.rows[0].cells) && body.headerData.rows[0].cells.every((cell)=>cell.columnId && cell.columnId !== "") || body.bodyData && Array.isArray(body.bodyData) && body.bodyData.length > 0 && body.bodyData[0].rows.length > 0 && "cells" in body.bodyData[0].rows[0] && Array.isArray(body.bodyData[0].rows[0].cells) && body.bodyData[0].rows[0].cells.every((cell)=>cell.columnId && cell.columnId !== "");
    // If columnIds don't exist, assign them to cells
    if (!hasExistingColumnIds) {
        const bodyWithColumnIds = {
            ...body
        };
        // Assign columnIds to header and body cells
        (0, $94lfO.assignColumnIdsToCells)(bodyWithColumnIds, columnIds);
        return {
            ...bodyWithColumnIds,
            columnInformation: columnInformation
        };
    }
    // ColumnIds exist, just ensure columnInformation is present
    return {
        ...body,
        columnInformation: columnInformation
    };
};

});
parcelRegister("94lfO", function(module, exports) {

$parcel$export(module.exports, "assignColumnIdsToCells", function () { return $4743bb0fe9502b67$export$80aaca323a4572d0; });
/**
 * Assigns columnIds to header and body cells in a table body structure.
 * This function mutates the provided body object by assigning columnIds to all cells
 * based on their column position (index within each row).
 *
 * @param body - The table body containing headerData and bodyData
 * @param body.headerData - Optional header data with rows and cells
 * @param body.bodyData - Array of body groups, each with rows and cells
 * @param columnIds - Array of columnIds to assign (one per column)
 */ const $4743bb0fe9502b67$export$80aaca323a4572d0 = (body, columnIds)=>{
    if (!body.bodyData || body.bodyData.length < 1 || body.bodyData[0].rows.length < 1 || body.bodyData[0].rows[0].cells.length !== columnIds.length || columnIds.some((id)=>!id)) throw new Error(`Bad columnIds array provided`);
    // Assign columnIds to header cells if header exists
    if (body.headerData && typeof body.headerData === "object" && "rows" in body.headerData) body.headerData.rows = body.headerData.rows.map((row)=>({
            ...row,
            cells: row.cells.map((cell, index)=>({
                    ...cell,
                    columnId: columnIds[index]
                }))
        }));
    // Assign columnIds to body cells
    /* istanbul ignore else */ if (body.bodyData && Array.isArray(body.bodyData)) body.bodyData = body.bodyData.map((group)=>({
            ...group,
            rows: group.rows.map((row)=>({
                    ...row,
                    cells: row.cells.map((cell, index)=>({
                            ...cell,
                            columnId: columnIds[index]
                        }))
                }))
        }));
};

});

parcelRegister("cd7YP", function(module, exports) {

$parcel$export(module.exports, "generateColumnIds", function () { return $dde1a5d5cb1bc8d0$export$606f894fac65fbb3; });
const $dde1a5d5cb1bc8d0$export$606f894fac65fbb3 = (tableData)=>{
    // Try to get column count and existing columnIds from header first
    if (tableData.headerData && typeof tableData.headerData === "object" && "rows" in tableData.headerData && Array.isArray(tableData.headerData.rows) && tableData.headerData.rows.length > 0) {
        const firstRow = tableData.headerData.rows[0];
        /* istanbul ignore else */ if ("cells" in firstRow && Array.isArray(firstRow.cells)) return firstRow.cells.map((cell)=>cell.columnId && cell.columnId !== "" ? cell.columnId : crypto.randomUUID());
    } else if (tableData.bodyData && Array.isArray(tableData.bodyData) && tableData.bodyData.length > 0 && tableData.bodyData[0].rows.length > 0) {
        const firstRow = tableData.bodyData[0].rows[0];
        /* istanbul ignore else */ if ("cells" in firstRow && Array.isArray(firstRow.cells)) return firstRow.cells.map((cell)=>cell.columnId && cell.columnId !== "" ? cell.columnId : crypto.randomUUID());
    }
    // Return empty array if no columns exist
    return [];
};

});



parcelRegister("8lP2T", function(module, exports) {

$parcel$export(module.exports, "tlfLoader", function () { return $cc1615844001ec77$export$99dd3289769a705a; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $5RbkJ = parcelRequire("5RbkJ");

var $dRarR = parcelRequire("dRarR");

var $cDJgj = parcelRequire("cDJgj");

var $7Wd8C = parcelRequire("7Wd8C");

var $k79Le = parcelRequire("k79Le");

var $khRaj = parcelRequire("khRaj");

var $7bZh8 = parcelRequire("7bZh8");
const $cc1615844001ec77$export$c1efadf725f85a8 = (params)=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    return params.azsolId !== undefined && params.version !== undefined ? `${backEndUrl}TlfItems/${params.azsolId}/${params.version}` : params.studyTag && params.reportName && params.tocNumber ? `${backEndUrl}TlfItems/${params.studyTag}/${params.reportName}/${params.tocNumber}${params.tocMajorVersion ? `?version=${params.tocMajorVersion}` : ""}` : params.id ? `${backEndUrl}TlfItems/${params.id}` : null;
};
const $cc1615844001ec77$export$5ea2b17da505df9b = async (params)=>{
    const url = $cc1615844001ec77$export$c1efadf725f85a8(params);
    if (!url) return {
        tlfItem: undefined,
        isTlfSubscribed: false,
        isTlfNew: false
    };
    const tlfLoaderData = (await (0, $a04va.default).get(url)).data;
    const subscriptionStatusLoaderData = tlfLoaderData ? await (0, $cDJgj.getSubscriptionStatusLoaderData)({
        params: {
            entityType: "TlfItem",
            entityId: tlfLoaderData.id
        }
    }) : undefined;
    const ret = {
        tlfItem: tlfLoaderData !== undefined ? (0, $7bZh8.tlfPreProcess)(tlfLoaderData) : undefined,
        isTlfSubscribed: subscriptionStatusLoaderData?.isSubscribed ?? false,
        isTlfNew: false
    };
    return ret;
};
const $cc1615844001ec77$export$99dd3289769a705a = async ({ params: params })=>{
    const hierarchyLoader = (0, $k79Le.getHierarchyLoaderData)(params);
    const thisTlfLoader = $cc1615844001ec77$export$5ea2b17da505df9b(params);
    const [tlfLoaderData, hierarchyLoaderData] = await Promise.all([
        thisTlfLoader,
        hierarchyLoader
    ]);
    // Hydrate ARS items into ArsTable
    if (tlfLoaderData.tlfItem?.type === (0, $7Wd8C.eTlfItemType).arsTable) (0, $khRaj.hydrateArsTableBody)([
        hierarchyLoaderData.hierarchy,
        ...hierarchyLoaderData.parentHierarchies
    ], tlfLoaderData.tlfItem);
    const ret = {
        tlfItem: tlfLoaderData.tlfItem,
        hierarchy: hierarchyLoaderData.hierarchy,
        parentHierarchies: hierarchyLoaderData.parentHierarchies,
        accessRights: hierarchyLoaderData.accessRights,
        isHierarchySubscribed: hierarchyLoaderData.isHierarchySubscribed,
        isTlfSubscribed: tlfLoaderData.isTlfSubscribed,
        isTlfNew: tlfLoaderData.isTlfNew
    };
    return ret;
};

});
parcelRegister("khRaj", function(module, exports) {

$parcel$export(module.exports, "hydrateArsTableBody", function () { return $f90c42722d3a1748$export$63c092d7f3ee6571; });
parcelRequire("P0x5y");
var $40D4s = parcelRequire("40D4s");
/**
 * Coalesces ARS items from multiple hierarchies into a single collection.
 *
 * @param hierarchies - Array of hierarchy objects containing ARS items
 * @returns Coalesced ARS items from all provided hierarchies
 */ const $f90c42722d3a1748$var$coalesceArsItemsFromHierarchies = (hierarchies)=>{
    const arsItems = {
        analysisMethods: [
            ...hierarchies.flatMap((h)=>h.analysisMethods).filter((am)=>am !== undefined)
        ],
        operations: [],
        analysisSets: [
            ...hierarchies.flatMap((h)=>h.analysisSets).filter((as)=>as !== undefined)
        ],
        dataSubsets: [
            ...hierarchies.flatMap((h)=>h.dataSubsets).filter((ds)=>ds !== undefined)
        ],
        groupingFactors: [
            ...hierarchies.flatMap((h)=>h.groupingFactors).filter((gf)=>gf !== undefined)
        ]
    };
    arsItems.operations = arsItems.analysisMethods.flatMap((am)=>am.operations);
    return arsItems;
};
/**
 * Hydrates a single table group with the corresponding ARS items based on its identifiers.
 *
 * @param group - The table group to hydrate
 * @param arsItems - Available ARS items for hydration
 */ const $f90c42722d3a1748$var$hydrateArsTableGroup = (group, arsItems)=>{
    // Implement the hydration logic for the ArsTableGroup here
    if ("analysisMethodId" in group) group.analysisMethod = arsItems.analysisMethods.find((am)=>am.id === group.analysisMethodId);
    else if ("operationId" in group) group.operation = arsItems.operations.find((op)=>op.id === group.operationId);
    else if ("groupingFactorId" in group) group.groupingFactor = arsItems.groupingFactors.find((gf)=>gf.id === group.groupingFactorId) ?? // If the grouping factor is not found, then add a placeholder item
    {
        ...(0, $40D4s.totalSidebarItem).data().dropItem,
        id: group.groupingFactorId
    };
    group.subGroups?.forEach((sg)=>$f90c42722d3a1748$var$hydrateArsTableGroup(sg, arsItems));
};
const $f90c42722d3a1748$export$63c092d7f3ee6571 = (hierarchies, tlfItem)=>{
    // Implement the hydration logic for ARS items into the ArsTable here
    const body = tlfItem.body;
    const arsItems = $f90c42722d3a1748$var$coalesceArsItemsFromHierarchies(hierarchies);
    body.columns.forEach((g)=>$f90c42722d3a1748$var$hydrateArsTableGroup(g, arsItems));
    body.rows.forEach((g)=>$f90c42722d3a1748$var$hydrateArsTableGroup(g, arsItems));
};

});

parcelRegister("7bZh8", function(module, exports) {

$parcel$export(module.exports, "tlfPreProcess", function () { return $05fa99db17583dbd$export$699823975d605571; });

var $1iDss = parcelRequire("1iDss");

var $7Wd8C = parcelRequire("7Wd8C");

var $bPMMg = parcelRequire("bPMMg");

var $cd7YP = parcelRequire("cd7YP");

var $5dCiS = parcelRequire("5dCiS");

var $eLCrw = parcelRequire("eLCrw");
const $05fa99db17583dbd$export$699823975d605571 = (tlf)=>{
    if (tlf.type === (0, $7Wd8C.eTlfItemType).table || tlf.type === (0, $7Wd8C.eTlfItemType).listing) {
        // Generate columnIds once and use for both header and body
        const columnIds = (0, $cd7YP.generateColumnIds)(tlf.body);
        // Generate columnInformation if empty
        const columnInformation = tlf.body.columnInformation && tlf.body.columnInformation.length > 0 && columnIds.length === tlf.body.columnInformation.length ? tlf.body.columnInformation : columnIds.map((columnId, index)=>({
                columnId: columnId,
                originalColumnIndex: index
            }));
        const headerData = (0, $eLCrw.headerPreProcess)(60, (0, $1iDss.stringToV3)(""), columnIds, (0, $5dCiS.handleCellText)(tlf.body.headerData));
        const bodyData = (0, $bPMMg.bodyPreProcess)(60, (0, $1iDss.stringToV3)(""), columnIds, (0, $5dCiS.handleCellText)(tlf.body.bodyData));
        return {
            ...tlf,
            body: {
                ...tlf.body,
                columnInformation: columnInformation,
                headerData: headerData,
                bodyData: bodyData
            }
        };
    } else return tlf;
};

});
parcelRegister("bPMMg", function(module, exports) {

$parcel$export(module.exports, "bodyPreProcess", function () { return $3d352a5e2b8175b6$export$d09f1d3f3e5e9255; });

var $km340 = parcelRequire("km340");
const $3d352a5e2b8175b6$export$d09f1d3f3e5e9255 = (defaultCellWidth, blank, columnIds, rgs)=>{
    return (rgs ?? []).map((rg)=>{
        return {
            ...rg,
            rows: (0, $km340.rowPreProcess)(defaultCellWidth, blank, columnIds, rg.rows),
            aitid: rg.aitid ?? crypto.randomUUID()
        };
    });
};

});
parcelRegister("km340", function(module, exports) {

$parcel$export(module.exports, "rowPreProcess", function () { return $393f55687b27110f$export$19762d706eaf2a12; });
parcelRequire("P0x5y");
var $3LImB = parcelRequire("3LImB");

var $2080v = parcelRequire("2080v");
const $393f55687b27110f$export$19762d706eaf2a12 = (defaultCellWidth, blank, columnIds, rs)=>{
    // Return an empty row if there is nothing
    if (rs === undefined) return [
        (0, $3LImB.newRow)(defaultCellWidth, blank, 0, [])
    ];
    // Check aitid
    return rs.map((r)=>({
            ...r,
            cells: (0, $2080v.cellPreProcess)(defaultCellWidth, blank, columnIds, r.cells),
            aitid: r.aitid ?? crypto.randomUUID(),
            rowRepeat: undefined
        }));
};

});
parcelRegister("2080v", function(module, exports) {

$parcel$export(module.exports, "cellPreProcess", function () { return $8517985551f1d40b$export$ed34dd7e0f89bb75; });
parcelRequire("P0x5y");
var $iIj1X = parcelRequire("iIj1X");
const $8517985551f1d40b$export$ed34dd7e0f89bb75 = (defaultCellWidth, blank, columnIds, cs)=>{
    if (cs === undefined) {
        if (!columnIds || columnIds.length === 0) throw new Error("cellPreProcess: no column Id defined for the cell");
        const columnId = columnIds[0];
        return [
            (0, $iIj1X.newCell)(defaultCellWidth, blank, columnId)
        ];
    }
    // Check aitid and columnId
    return cs.map((c, index)=>{
        // Use provided columnId if available, otherwise use existing columnId, or generate new one
        const columnId = columnIds && columnIds.length > index ? columnIds[index] : c.columnId;
        return {
            aitid: c.aitid && c.aitid.length > 4 ? c.aitid : crypto.randomUUID(),
            text: c.text,
            justifyText: c.justifyText,
            comments: c.comments,
            colWidth: c.colWidth ?? defaultCellWidth,
            textIndents: c.textIndents,
            replacedText: undefined,
            spaceAfterRepeat: undefined,
            coreTrafficLight: c.coreTrafficLight,
            templateAitId: c.templateAitId,
            templateColumnAitId: c.templateColumnAitId,
            columnId: columnId
        };
    });
};

});



parcelRegister("5dCiS", function(module, exports) {

$parcel$export(module.exports, "handleCellText", function () { return $18da4bfc23ea2afa$export$b1a4e7cadaf459ae; });

var $1iDss = parcelRequire("1iDss");
/**
 * Ensure an editor input has at least one text block and normalised lines.
 *
 * @param input - Optional editor input
 * @returns Normalised IEditorV3 instance
 */ function $18da4bfc23ea2afa$var$processInput(input) {
    if (!input) return (0, $1iDss.stringToV3)("");
    input.lines = !input.lines || input.lines.length === 0 ? [
        {
            textBlocks: [
                {
                    text: "",
                    type: "text"
                }
            ]
        }
    ] : input.lines.filter((line, ix)=>ix === 0 && input.lines.every((l)=>!l.textBlocks || l.textBlocks.length === 0) || line.textBlocks && line.textBlocks.length > 0).map((line)=>{
        if (line.textBlocks.length === 0) line.textBlocks.push({
            text: "",
            type: "text"
        });
        return line;
    });
    return input;
}
/**
 * Process text for an array of cells.
 *
 * @param cells - Cells to process
 * @returns Cells with normalised text content
 */ const $18da4bfc23ea2afa$var$processCellsText = (cells)=>cells.map((cell)=>({
            ...cell,
            text: $18da4bfc23ea2afa$var$processInput(cell.text)
        }));
function $18da4bfc23ea2afa$export$b1a4e7cadaf459ae(body) {
    if (body === null || body === undefined || typeof body !== "object") return body;
    const obj = body;
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        // Update cells text
        if (key === "cells") obj[key] = $18da4bfc23ea2afa$var$processCellsText(value);
        else if (key === "comments" && typeof value === "object" && value !== null && "lines" in value) obj[key] = $18da4bfc23ea2afa$var$processInput(value);
        else if (value && typeof value === "object") obj[key] = $18da4bfc23ea2afa$export$b1a4e7cadaf459ae(value);
    });
    return body;
}

});

parcelRegister("eLCrw", function(module, exports) {

$parcel$export(module.exports, "headerPreProcess", function () { return $b4f3c0dc61c42c26$export$86ad0a71dced94ac; });

var $7QLdO = parcelRequire("7QLdO");
const $b4f3c0dc61c42c26$export$86ad0a71dced94ac = (defaultCellWidth, blank, columnIds, rg)=>{
    if (rg === undefined) return {
        aitid: crypto.randomUUID(),
        rows: [],
        coreTrafficLight: "BlankNotEvaluated"
    };
    if (rg === false) return false;
    return {
        ...rg,
        rows: (0, $7QLdO.headerRowPreProcess)(defaultCellWidth, blank, columnIds, rg.rows),
        aitid: rg.aitid ?? crypto.randomUUID()
    };
};

});
parcelRegister("7QLdO", function(module, exports) {

$parcel$export(module.exports, "headerRowPreProcess", function () { return $57e34172254dc239$export$8b2bff07d93d8652; });
parcelRequire("P0x5y");
var $3LImB = parcelRequire("3LImB");

var $8R3tZ = parcelRequire("8R3tZ");
const $57e34172254dc239$export$8b2bff07d93d8652 = (defaultCellWidth, blank, columnIds, rs)=>{
    // Return an empty row if there is nothing
    if (rs === undefined) return [
        (0, $3LImB.newHeaderRow)(defaultCellWidth, blank, 0, [])
    ];
    // Check aitid
    return rs.map((r)=>({
            ...r,
            cells: (0, $8R3tZ.headerCellPreProcess)(defaultCellWidth, blank, columnIds, r.cells),
            aitid: r.aitid ?? crypto.randomUUID(),
            spaceAfter: r.spaceAfter ?? false,
            rowRepeat: undefined
        }));
};

});
parcelRegister("8R3tZ", function(module, exports) {

$parcel$export(module.exports, "headerCellPreProcess", function () { return $e24a89d3645a39bc$export$97b9976bb98eb3da; });
parcelRequire("P0x5y");
var $iIj1X = parcelRequire("iIj1X");
const $e24a89d3645a39bc$export$97b9976bb98eb3da = (defaultCellWidth, blank, columnIds, cs)=>{
    if (cs === undefined) {
        const columnId = columnIds && columnIds.length > 0 ? columnIds[0] : crypto.randomUUID();
        return [
            (0, $iIj1X.newHeaderCell)(defaultCellWidth, blank, columnId)
        ];
    }
    // Check aitid and columnId and ensure defaults where necessary
    return cs.map((c, index)=>{
        // Use provided columnId if available, otherwise use existing columnId
        const columnId = columnIds && columnIds.length > index ? columnIds[index] : c.columnId;
        return {
            aitid: c.aitid && c.aitid.length > 4 ? c.aitid : crypto.randomUUID(),
            text: c.text,
            justifyText: c.justifyText,
            comments: c.comments,
            colWidth: c.colWidth ?? defaultCellWidth,
            textIndents: c.textIndents,
            replacedText: undefined,
            repeatRowSpan: undefined,
            spaceAfterRepeat: undefined,
            spaceAfterSpan: undefined,
            colSpan: c.colSpan ?? 1,
            rowSpan: c.rowSpan ?? 1,
            repeatColSpan: undefined,
            coreTrafficLight: c.coreTrafficLight,
            templateAitId: c.templateAitId,
            templateColumnAitId: c.templateColumnAitId,
            columnId: columnId
        };
    });
};

});





parcelRegister("gVAKq", function(module, exports) {

$parcel$export(module.exports, "tlfRedirectLoader", function () { return $9bccda8fe023b178$export$f461775690242f9d; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $5RbkJ = parcelRequire("5RbkJ");

var $7KklJ = parcelRequire("7KklJ");

var $dA19B = parcelRequire("dA19B");

var $gxpCl = parcelRequire("gxpCl");

var $dRarR = parcelRequire("dRarR");

var $1ddQW = parcelRequire("1ddQW");
const $9bccda8fe023b178$export$f461775690242f9d = async ({ params: params, request: request })=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    const url = params.id ? `${backEndUrl}TlfItems/ById/${params.id}${params.azsolId && (0, $dA19B.isValidUriString)(params.azsolId) ? `/${params.azsolId}` : ""}` : params.azsolId !== undefined && params.version !== undefined ? `${backEndUrl}TlfItems/${params.azsolId}/${params.version}` : undefined;
    if (url) {
        // Get TLF item
        const tlfLoader = await (0, $a04va.default).get(url);
        const tlfItem = tlfLoader.data;
        /* istanbul ignore else */ if (tlfItem?.primaryHierarchyId !== undefined) {
            // Get Hierarchy
            const hierarchyRequest = await (0, $1ddQW.loadHierarchy)(backEndUrl, {
                hierarchyId: tlfItem.primaryHierarchyId
            });
            // Redirect
            /* istanbul ignore else */ if (hierarchyRequest.success) {
                const requestUrl = new URL(request.url);
                const redirectTo = requestUrl.origin + `${(0, $7KklJ.getTlfUrl)(hierarchyRequest.data, tlfItem)}`;
                const redirectUrl = new URL(redirectTo);
                // Add search params if available
                const searchParams = new URLSearchParams(requestUrl.search);
                /* istanbul ignore else */ if (searchParams !== undefined) redirectUrl.search = searchParams.toString();
                return (0, $gxpCl.redirect)(redirectUrl.toString());
            }
        }
    }
    return (0, $gxpCl.redirect)("/NotFound");
};

});
parcelRegister("dA19B", function(module, exports) {

$parcel$export(module.exports, "isValidUriString", function () { return $2269abee784e741c$export$87c852e82b53e1d5; });
/**
 * Validates if a string is a valid URI string.
 *
 * @param azsolId - The AZSOL identifier string to validate as a valid URI
 * @returns boolean
 */ const $2269abee784e741c$export$87c852e82b53e1d5 = (azsolId)=>{
    // Check that the given azsolId or any sring that is passed is URI compatible
    // Should only alphanumeric characters, spaces, underscores, and hyphens
    const validPattern = /^[a-zA-Z0-9 _-]+$/;
    return validPattern.test(azsolId);
};

});


parcelRegister("aQn9V", function(module, exports) {

$parcel$export(module.exports, "appSettingsLoader", function () { return $74867ce5b59efe81$export$db14d4734a3bb44b; });

var $5RbkJ = parcelRequire("5RbkJ");

var $dRarR = parcelRequire("dRarR");

var $l5vE1 = parcelRequire("l5vE1");

var $9PAGX = parcelRequire("9PAGX");

var $9lafv = parcelRequire("9lafv");

var $bMKqD = parcelRequire("bMKqD");

var $lAj4c = parcelRequire("lAj4c");

var $98Em8 = parcelRequire("98Em8");

var $7gog7 = parcelRequire("7gog7");
const $74867ce5b59efe81$export$db14d4734a3bb44b = async ()=>{
    const backEndUrl = (0, $dRarR.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5RbkJ.defaultSettings).backEndUrl : (0, $dRarR.REACT_APP_BACKENDURL);
    const me = (0, $7gog7.getMe)(backEndUrl);
    const crystalUrl = (0, $dRarR.REACT_APP_CRYSTALURL).includes("_REACT_APP_CRYSTALURL_") ? (0, $5RbkJ.defaultSettings).crystalUrl : (0, $dRarR.REACT_APP_CRYSTALURL);
    const backEndVersion = (0, $bMKqD.getBackEndVersion)(backEndUrl);
    const maintenanceMode = (0, $l5vE1.loadMaintenanceMode)(backEndUrl);
    const helpLinks = (0, $lAj4c.loadHelpLinks)(backEndUrl);
    const styles = (0, $98Em8.getAllStyles)(backEndUrl);
    const annotationComparatorTypes = (0, $9PAGX.getComparatorTypes)(backEndUrl);
    const figureSettings = (0, $9lafv.getFigureTypeOptions)(backEndUrl);
    const request = await Promise.all([
        me,
        backEndVersion,
        maintenanceMode,
        helpLinks,
        styles,
        annotationComparatorTypes,
        figureSettings
    ]);
    if (request.some((r)=>r.success === false)) throw new Error("App settings loader failed");
    const ret = {
        backEndUrl: backEndUrl,
        crystalUrl: crystalUrl,
        me: request[0].data,
        backEndVersion: request[1].data,
        maintenanceMode: request[2].data,
        helpLinks: request[3].data,
        styles: request[4].data,
        annotationComparatorTypes: request[5].data,
        figureSettings: request[6].data
    };
    return ret;
};

});
parcelRegister("l5vE1", function(module, exports) {

$parcel$export(module.exports, "loadMaintenanceMode", function () { return $ccccb55e99ba0d3a$export$c7d7d8f442777898; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $ccccb55e99ba0d3a$export$c7d7d8f442777898 = async (backEndUrl, _, controller)=>{
    // Get data
    try {
        const response = await (0, $a04va.default).get(`${backEndUrl}Settings/MaintenanceMode`, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: {
                maintenanceMode: response.data.value !== "",
                maintenanceMessage: response.data.value
            }
        };
    } catch (error) {
        // Handle if no setting exists yet
        if (error.response?.status === 404) return {
            success: true,
            data: {
                maintenanceMode: false
            }
        };
        return (0, $8A5VF.processAxiosError)("Load Maintenance Mode failed", error);
    }
};

});

parcelRegister("9PAGX", function(module, exports) {

$parcel$export(module.exports, "getComparatorTypes", function () { return $c7a1eba60a5897c3$export$7046b8b657e89481; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $c7a1eba60a5897c3$export$7046b8b657e89481 = async (backEndUrl)=>{
    const url = `${backEndUrl}Annotations/Comparators`;
    try {
        const response = await (0, $a04va.default).get(url);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load comparator types failed", error);
    }
};

});

parcelRegister("9lafv", function(module, exports) {

$parcel$export(module.exports, "getFigureTypeOptions", function () { return $b2192a909e6de0aa$export$63c537751473bff1; });
parcelRequire("P0x5y");
var $aSzWy = parcelRequire("aSzWy");
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $b2192a909e6de0aa$export$63c537751473bff1 = async (backEndUrl)=>{
    const url = `${backEndUrl}Settings/figureTypeOptions`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url);
        const returnedObject = JSON.parse(response.data.value);
        // Validate returned data
        if (!(0, $aSzWy.isFigureSettingsDto)(returnedObject)) {
            console.error("getFigureTypeOptions: returnedObject failed isFigureSettingsDto check");
            return {
                success: false,
                errorText: "Load figure type options failed: invalid data format"
            };
        }
        const returnedFigureSettings = returnedObject;
        // Return successful result
        return {
            success: true,
            data: returnedFigureSettings
        };
    } catch (error) {
        console.debug("getFigureTypeOptions: caught error", error);
        return (0, $8A5VF.processAxiosError)("Load figure type options failed", error);
    }
};

});

parcelRegister("bMKqD", function(module, exports) {

$parcel$export(module.exports, "getBackEndVersion", function () { return $7ec90d40b86e3d17$export$9db84f9861043ae; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $7ec90d40b86e3d17$export$9db84f9861043ae = async (backEndUrl, _, controller)=>{
    const url = `${backEndUrl}Version`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: `mbbe ${response.data.backendVersion}`
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load back end version failed", error);
    }
};

});

parcelRegister("lAj4c", function(module, exports) {

$parcel$export(module.exports, "loadHelpLinks", function () { return $54ecc1608f57cba1$export$cc3035ff1a2ee2c6; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $54ecc1608f57cba1$export$cc3035ff1a2ee2c6 = async (backEndUrl)=>{
    // Get data
    try {
        const response = await (0, $a04va.default).get(`${backEndUrl}Settings/HelpLinks`);
        // Return successful result
        return {
            success: true,
            data: JSON.parse(response.data.value)
        };
    } catch (error) {
        // Handle if no setting exists yet
        if (error.response?.status === 404) return {
            success: true,
            data: []
        };
        return (0, $8A5VF.processAxiosError)("Load help links failed", error);
    }
};

});

parcelRegister("7gog7", function(module, exports) {

$parcel$export(module.exports, "getMe", function () { return $9901c7be9af165f2$export$dd7946daa6163e94; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $9901c7be9af165f2$export$dd7946daa6163e94 = async (backEndUrl)=>{
    const url = `${backEndUrl}Users/Me`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url);
        // Return successful result
        return {
            success: true,
            data: {
                userId: response.data.userId,
                isAdmin: response.data.isAdmin,
                applicationPermissions: response.data.applicationPermissions
            }
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load me failed", error);
    }
};

});


parcelRegister("87sNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5285b8c62448006$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $4PTZu = parcelRequire("4PTZu");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");
const $f5285b8c62448006$export$6395761c98695de7 = ()=>{
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $4PTZu.useUnsavedChanges)("redirecting-page");
    (0, $7fPBF.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    style: {
                        paddingTop: "4rem"
                    },
                    children: "Redirecting..."
                })
            })
        })
    });
};
$f5285b8c62448006$export$6395761c98695de7.displayName = "RedirectingPage";
var $f5285b8c62448006$export$2e2bcd8739ae039 = $f5285b8c62448006$export$6395761c98695de7;

});

parcelRegister("bEjPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f39cac71cc6da190$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $bkizz = parcelRequire("bkizz");

var $frJ3w = parcelRequire("frJ3w");

var $5Q4M4 = parcelRequire("5Q4M4");

var $4PTZu = parcelRequire("4PTZu");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");
const $f39cac71cc6da190$export$41ce7963b9cec023 = ()=>{
    const error = (0, $gxpCl.useRouteError)();
    const errorString = JSON.stringify(error?.message ?? error, undefined, 2);
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $4PTZu.useUnsavedChanges)("router-error-boundary");
    (0, $7fPBF.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Q4M4.TopBar), {
                title: "An error has occurred",
                showUser: false
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bkizz.ErrorDetails), {
                error: error,
                errorMessage: errorString
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $frJ3w.BottomNav), {})
        ]
    });
};
$f39cac71cc6da190$export$41ce7963b9cec023.displayName = "RouterErrorBoundary";
var $f39cac71cc6da190$export$2e2bcd8739ae039 = $f39cac71cc6da190$export$41ce7963b9cec023;

});
parcelRegister("bkizz", function(module, exports) {

$parcel$export(module.exports, "ErrorDetails", function () { return $f42abdf0848426a8$export$d053ec805ce391aa; });

var $bbzbN = parcelRequire("bbzbN");

var $h3OEn = parcelRequire("h3OEn");

var $1AaMV = parcelRequire("1AaMV");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");

const $f42abdf0848426a8$export$d053ec805ce391aa = ({ error: error, errorMessage: errorMessage })=>{
    const errorCassette = new URL((parcelRequire("9DEKR")));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("h5", {
                            children: [
                                "I am broken ",
                                "\u2639"
                            ]
                        }),
                        error instanceof (0, $h3OEn.AxiosError) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "d-flex flex-column justify-content-left align-items-center nowrap",
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                className: "text-center",
                                children: [
                                    "Error: ",
                                    error.status,
                                    " ",
                                    error.code
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                        className: "d-flex justify-content-center align-items-center",
                        xs: {
                            span: 4
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("img", {
                            src: errorCassette.href,
                            className: "img",
                            alt: "Error",
                            title: "Error",
                            width: "350px",
                            height: "350px"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                        xs: 8,
                        className: "d-flex flex-column justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                "The error was something like:",
                                /*#__PURE__*/ (0, $bbzbN.jsx)("pre", {
                                    className: "m-2 p-4 border border-primary rounded bg-primary bg-opacity-50",
                                    style: {
                                        maxWidth: "800px",
                                        maxHeight: "600px",
                                        overflow: "auto"
                                    },
                                    children: errorMessage
                                }),
                                "whatever that means,",
                                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                    className: "button-link mx-1",
                                    onClick: (0, $1AaMV.doReload),
                                    children: "Refresh"
                                }),
                                "might get back to normal, but if it doesn't please report this to",
                                /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                    className: "px-1",
                                    href: "mailto:MOSAICBiometrics@astrazeneca.com",
                                    children: "MOSAICBiometrics@astrazeneca.com"
                                }),
                                "\uD83D\uDE2A"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
$f42abdf0848426a8$export$d053ec805ce391aa.displayName = "ErrorDetails";

});
parcelRegister("1AaMV", function(module, exports) {

$parcel$export(module.exports, "doReload", function () { return $932f2bb7e98be0a2$export$296fe50bcc783caa; });
// istanbul ignore next
/**
 * Helper function to reload the current web page.
 */ const $932f2bb7e98be0a2$export$296fe50bcc783caa = ()=>{
    window.location.reload();
};

});

parcelRegister("9DEKR", function(module, exports) {
module.exports = $parcel$resolve("iMF9Y");

});



parcelRegister("9fTRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd62103a516e0d01$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $9pA3o = parcelRequire("9pA3o");

var $62Jtk = parcelRequire("62Jtk");

var $8gd3L = parcelRequire("8gd3L");

var $hhVe3 = parcelRequire("hhVe3");

var $frJ3w = parcelRequire("frJ3w");

var $5Q4M4 = parcelRequire("5Q4M4");

var $hWsmt = parcelRequire("hWsmt");

var $9Jgpw = parcelRequire("9Jgpw");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $h1iST = parcelRequire("h1iST");

var $5UDwf = parcelRequire("5UDwf");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $4mMRX = parcelRequire("4mMRX");
var $kYoG1 = parcelRequire("kYoG1");

var $gxpCl = parcelRequire("gxpCl");
const $cd62103a516e0d01$export$bc2fb203e7c919f = ()=>{
    const { applicationPermissions: applicationPermissions, dispatch: dispatch, hierarchyState: hierarchyState, backEndUrl: backEndUrl } = (0, $hWsmt.useAppSettings)();
    (0, $5UDwf.useDocumentTitle)("Home page");
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $4PTZu.useUnsavedChanges)("start-page");
    (0, $7fPBF.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (hierarchyState.hierarchy) dispatch({
            operation: (0, $9Jgpw.CLEAR_HIERARCHY)
        });
    }, [
        hierarchyState.hierarchy,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9pA3o.default), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Q4M4.TopBar), {
                title: "MOSAIC Biometrics",
                fileEntry: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                            id: "topbar-load-link",
                            as: (0, $gxpCl.Link),
                            to: "/Corporate/Load",
                            children: "Load TLF"
                        }),
                        applicationPermissions.includes((0, $7Wd8C.eApplicationPermission).AllowJsonDownload) && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Divider, {}),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                                    onClick: ()=>{
                                        (0, $h1iST.downloadStats)(backEndUrl);
                                    },
                                    children: "Download JSON statistics data"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                fluid: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                            id: "start-page-lhs",
                            xs: 2,
                            className: "small-scrollbar col-between-top-and-bottom",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hhVe3.HierarchyLinks), {})
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                            id: "start-page-rhs",
                            xs: 10,
                            className: "position-relative d-flex flex-column col-between-top-and-bottom",
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                                className: "small-scrollbar",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gd3L.Search), {}),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $62Jtk.News), {})
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $frJ3w.BottomNav), {})
        ]
    });
};
$cd62103a516e0d01$export$bc2fb203e7c919f.displayName = "StartPage";
var $cd62103a516e0d01$export$2e2bcd8739ae039 = $cd62103a516e0d01$export$bc2fb203e7c919f;

});
parcelRegister("9pA3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd0a860d8274452$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $bkizz = parcelRequire("bkizz");
/**
 * Error boundary component that catches React errors and displays a fallback UI.
 *  No display name required
 */ class $0bd0a860d8274452$var$ErrorBoundary extends (0, $7fPBF.Component) {
    static #_ = this.displayName = "ErrorBoundary";
    /**
   * Derives error state from caught errors.
   *
   * @param error - The caught error object
   */ static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            errorMessage: error.message
        };
    }
    /**
   * Logs error details to console when errors are caught.
   *
   * @param error - The caught error object
   * @param errorInfo - Additional error information from React
   */ componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }
    /**
   * Renders children or error UI based on error state.
   */ render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bkizz.ErrorDetails), {
            errorMessage: this.state.errorMessage
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false,
            errorMessage: ""
        };
    }
}
var $0bd0a860d8274452$export$2e2bcd8739ae039 = $0bd0a860d8274452$var$ErrorBoundary;

});

parcelRegister("62Jtk", function(module, exports) {

$parcel$export(module.exports, "News", function () { return $c773bde87849ddc2$export$aec6fe3795564851; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");
var $9eqKP = parcelRequire("9eqKP");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $4Rd2t = parcelRequire("4Rd2t");

var $3UZ3q = parcelRequire("3UZ3q");

var $7fPBF = parcelRequire("7fPBF");

var $bsSFb = parcelRequire("bsSFb");
var $h1xuz = parcelRequire("h1xuz");
var $kYoG1 = parcelRequire("kYoG1");

var $3eSBo = parcelRequire("3eSBo");
const $c773bde87849ddc2$export$aec6fe3795564851 = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const [newsItems, setNewsItems] = (0, $7fPBF.useState)([]);
    const [changed, setChanged] = (0, $7fPBF.useState)(false);
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    const [loadRequest, setLoadRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [saveRequest, setSaveRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const allowNewsEdit = appSettings.applicationPermissions.findIndex((p)=>p === (0, $7Wd8C.eApplicationPermission).AllowNewsEdit) > -1 || appSettings.isAdmin;
    const refreshNews = (0, $7fPBF.useEffectEvent)(async ()=>{
        // Get news
        const request = await (0, $30Ra3.loadWrapper)((0, $4Rd2t.loadNews), "loadNews", {
            ...loadRequest,
            requesting: false
        }, setLoadRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) startTransition(()=>setNewsItems(request.data));
        else if (request?.errorText) {
            startTransition(()=>setNewsItems([]));
            console.warn(`Load news failed: ${request?.errorText}`);
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        /* istanbul ignore else */ if (newsItems.length === 0 && !loadRequest.error && !loadRequest.requesting) refreshNews();
    }, [
        loadRequest.error,
        loadRequest.requesting,
        newsItems.length
    ]);
    /**
   * Add a new blank news item
   */ const addNews = ()=>{
        const nN = [
            ...newsItems
        ];
        const n = {
            timestamp: Date.now(),
            displayName: appSettings.displayName ?? // istanbul ignore next
            "Test user",
            title: "",
            text: ""
        };
        nN.push(n);
        setNewsItems(nN);
        setChanged(true);
    };
    /**
   * Update a news item
   *
   * @param newNews - the updated news item
   * @param i - index to update
   */ const updateNews = (newNews, i)=>{
        const nN = [
            ...newsItems ?? // istanbul ignore next
            []
        ];
        nN.splice(i, 1, newNews);
        setNewsItems(nN);
        setChanged(true);
    };
    /**
   * Remove a news item
   *
   * @param i - index to remove
   */ const removeNews = (i)=>{
        const nN = [
            ...newsItems ?? // istanbul ignore next
            []
        ];
        nN.splice(i, 1);
        setNewsItems(nN);
        setChanged(true);
    };
    /**
   * Save the current news items
   */ const saveCurrentNews = async ()=>{
        const request = await (0, $30Ra3.loadWrapper)((0, $3UZ3q.saveNews), newsItems ?? // istanbul ignore next
        [], {
            ...saveRequest,
            requesting: false
        }, setSaveRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) {
            setNewsItems(request.data);
            setChanged(false);
        } else if (request?.errorText) console.warn(`Save failed for news: ${request?.errorText} `);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
        className: "pb-3 position-relative",
        children: [
            (loadRequest.requesting || pending) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                text: "Loading news..."
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                        children: "News"
                    }),
                    newsItems && newsItems.map((n, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3eSBo.NewsItemsDisplay), {
                            id: `news-item-${i}`,
                            item: n,
                            setItem: allowNewsEdit ? (ret)=>updateNews(ret, i) : undefined,
                            removeItem: allowNewsEdit ? ()=>removeNews(i) : undefined
                        }, i)),
                    newsItems && newsItems.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3eSBo.NewsItemsDisplay), {
                        id: "news-display-0",
                        item: {
                            title: "",
                            displayName: "",
                            timestamp: 0,
                            text: "The news is, there is no news"
                        }
                    }),
                    allowNewsEdit && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bsSFb.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                id: "news-add",
                                "aria-label": "Add news",
                                style: {
                                    marginLeft: "130px"
                                },
                                onClick: ()=>addNews(),
                                variant: "primary",
                                size: "sm",
                                children: "Add news"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                id: "news-save",
                                "aria-label": "Save news",
                                "aria-disabled": !changed,
                                disabled: !changed,
                                variant: "primary",
                                onClick: ()=>saveCurrentNews(),
                                style: {
                                    minWidth: "100px",
                                    minHeight: "38px",
                                    position: "relative"
                                },
                                requestStatus: saveRequest,
                                pauseCoverText: "Saving...",
                                children: "Save news"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$c773bde87849ddc2$export$aec6fe3795564851.displayName = "News";

});
parcelRegister("4Rd2t", function(module, exports) {

$parcel$export(module.exports, "loadNews", function () { return $1844bc81b218ff88$export$6be879aaed7294f2; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $1844bc81b218ff88$export$6be879aaed7294f2 = async (backEndUrl)=>{
    // Get data
    try {
        const response = await (0, $a04va.default).get(`${backEndUrl}Settings/News`);
        // Return successful result
        return {
            success: true,
            data: JSON.parse(response.data.value).sort((a, b)=>b.timestamp - a.timestamp)
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load news failed", error);
    }
};

});

parcelRegister("3UZ3q", function(module, exports) {

$parcel$export(module.exports, "saveNews", function () { return $caaf72652b6f8bb4$export$1eb3ac603c3bde71; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $caaf72652b6f8bb4$export$1eb3ac603c3bde71 = async (backEndUrl, news, controller)=>{
    // Send data
    try {
        const data = {
            value: JSON.stringify(news)
        };
        const response = await (0, $a04va.default).put(`${backEndUrl}Settings/News`, data, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: JSON.parse(response.data.value)
        };
    } catch (error) {
        console.warn(error);
        return (0, $8A5VF.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("bsSFb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $858cb63907f0b1d4$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $858cb63907f0b1d4$var$ButtonGroup = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$858cb63907f0b1d4$var$ButtonGroup.displayName = 'ButtonGroup';
var $858cb63907f0b1d4$export$2e2bcd8739ae039 = $858cb63907f0b1d4$var$ButtonGroup;

});

parcelRegister("3eSBo", function(module, exports) {

$parcel$export(module.exports, "NewsItemsDisplay", function () { return $7da00425b24a62b4$export$1f516c22ed0f5483; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $5m3yv = parcelRequire("5m3yv");
var $eYprk = parcelRequire("eYprk");

var $hWsmt = parcelRequire("hWsmt");

var $7fPBF = parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");

var $2jFYR = parcelRequire("2jFYR");
const $7da00425b24a62b4$export$1f516c22ed0f5483 = ({ id: id, item: item, setItem: setItem, removeItem: removeItem })=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const appSettings = (0, $hWsmt.useAppSettings)();
    const [editing, setEditing] = (0, $7fPBF.useState)(false);
    // Hold current values and send back onBlur
    const [currentTitle, setCurrentTitle] = (0, $7fPBF.useState)(item.title);
    const [currentText, setCurrentText] = (0, $7fPBF.useState)(item.text);
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>{
            setCurrentTitle(item.title);
            setCurrentText(item.text);
        });
    }, [
        item
    ]);
    /**
   * Return updated data
   */ const returnData = ()=>{
        const nN = {
            title: currentTitle,
            text: currentText,
            displayName: appSettings.displayName ?? // istanbul ignore next
            "Test user",
            timestamp: Date.now()
        };
        setItem?.(nN);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: id,
        className: "pb-2",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            style: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    style: {
                        minWidth: "100px"
                    },
                    children: new Date(item.timestamp).toISOString().split("T")[0]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    style: {
                        minWidth: "32px",
                        width: "32px"
                    },
                    className: "align-items-center justify-items-center",
                    children: typeof removeItem === "function" ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
                                id: `${id}-remove`,
                                onClick: ()=>{
                                    removeItem();
                                },
                                iconName: "aioxMinus",
                                tipText: "Remove news item",
                                "aria-label": "Remove news item",
                                style: {
                                    paddingLeft: "8px",
                                    paddingRight: "8px"
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2jFYR.default), {
                                id: `${id}-edit`,
                                onClick: ()=>setEditing(!editing),
                                style: {
                                    marginLeft: "8px"
                                },
                                "aria-label": "Edit news item"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                        children: "\xa0"
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        flexGrow: 1
                    },
                    children: [
                        setItem && editing ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                            id: `${id}-title-editor`,
                            style: {
                                marginBottom: "4px"
                            },
                            value: currentTitle,
                            placeholder: "Add title",
                            onChange: (e)=>setCurrentTitle(e.currentTarget.value),
                            onBlur: ()=>returnData(),
                            "aria-label": "News title",
                            spellCheck: true
                        }) : item.title !== "" ? /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                            id: `${id}-title`,
                            className: "mb-0",
                            children: item.title
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("small", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                children: // istanbul ignore next
                                item.displayName ?? appSettings.displayName ?? // istanbul ignore next
                                "Test user"
                            })
                        }),
                        setItem && editing ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                            id: `${id}-news-editor`,
                            as: "textarea",
                            rows: 3,
                            value: currentText,
                            onChange: (e)=>setCurrentText(e.currentTarget.value),
                            placeholder: "Add news",
                            onBlur: ()=>returnData(),
                            "aria-label": "News text",
                            spellCheck: true
                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            id: `${id}-news`,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eYprk.InTextLink), {
                                text: item.text
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$7da00425b24a62b4$export$1f516c22ed0f5483.displayName = "NewsItemsDisplay";

});


parcelRegister("8gd3L", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $028a3ef15a93e165$export$4b85d3515bd863a5; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");

var $nD4qy = parcelRequire("nD4qy");

var $9ayVk = parcelRequire("9ayVk");
const $028a3ef15a93e165$export$4b85d3515bd863a5 = ()=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const [subText, setSubText] = (0, $7fPBF.useState)("");
    const [currentValue, setCurrentValue] = (0, $7fPBF.useState)("");
    const [searchText, setSearchText] = (0, $7fPBF.useState)(null);
    // Update subtext
    (0, $7fPBF.useEffect)(()=>{
        startTransition(()=>{
            setSubText(currentValue.trim().length < 3 ? "Enter 3 or more characters to search" : currentValue !== searchText ? "..." : "");
        });
    }, [
        currentValue,
        searchText
    ]);
    // Search results + debounce
    (0, $7fPBF.useEffect)(()=>{
        const update = setTimeout(()=>{
            if (currentValue !== searchText && currentValue.trim().length > 2) setSearchText(currentValue);
        }, 1000);
        return ()=>clearTimeout(update);
    }, [
        currentValue,
        searchText
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
                controlId: "search-entry",
                as: (0, $kYoG1.default),
                className: "d-flex under-nav-sticky",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                        column: true,
                        sm: 2,
                        style: {
                            minHeight: "70px"
                        },
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                        sm: 10,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                                className: "m-1",
                                type: "text",
                                value: currentValue,
                                onChange: (e)=>setCurrentValue(e.currentTarget.value),
                                spellCheck: true
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Text, {
                                children: subText
                            })
                        ]
                    })
                ]
            }),
            searchText !== null && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $nD4qy.SearchResultsHierarchy), {
                                searchText: searchText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9ayVk.SearchResultsTlf), {
                                searchText: searchText
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$028a3ef15a93e165$export$4b85d3515bd863a5.displayName = "Search";

});
parcelRegister("nD4qy", function(module, exports) {

$parcel$export(module.exports, "SearchResultsHierarchy", function () { return $5259285bb91ac01b$export$a0eb29ebe1f3e23a; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $j96Rr = parcelRequire("j96Rr");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $iC7Pk = parcelRequire("iC7Pk");

var $7fPBF = parcelRequire("7fPBF");

var $4WD1L = parcelRequire("4WD1L");
const $5259285bb91ac01b$export$a0eb29ebe1f3e23a = ({ searchText: searchText, updateable: updateable = false })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    const [searchStatus, setSearchStatus] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [searchResults, setSearchResults] = (0, $7fPBF.useState)([]);
    // Run search
    const search = (0, $7fPBF.useEffectEvent)(async (searchText)=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $iC7Pk.searchAllHierarchies), searchText, {
            ...searchStatus,
            error: false
        }, setSearchStatus, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) startTransition(()=>setSearchResults(response.data));
        else if (response && response.success === false) startTransition(()=>setSearchResults([]));
    });
    (0, $7fPBF.useEffect)(()=>{
        search(searchText);
    }, [
        searchText
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: searchStatus.requesting || pending ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "my-2",
            children: [
                "Loading search results for Hierarchies...",
                " ",
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4WD1L.default), {
                    animation: "border",
                    size: "sm",
                    variant: "dark"
                })
            ]
        }) : searchStatus.error ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
            className: "text-danger",
            children: searchStatus.errorText
        }) : !updateable && searchResults.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
            children: "No results for Hierarchies"
        }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                    className: "mt-1",
                    style: {
                        fontSize: "24px"
                    },
                    children: "Hierarchies"
                }),
                searchResults.map((h, hi)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                                to: `/H/${h.id}`,
                                children: h.level === (0, $7Wd8C.eHierarchyLevel).Report ? `${h.parentTag}/${h.name}` : h.name
                            }),
                            " - ",
                            !h.description || h.description === "" ? /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                children: "No description"
                            }) : h.description
                        ]
                    }, hi))
            ]
        })
    });
};
$5259285bb91ac01b$export$a0eb29ebe1f3e23a.displayName = "SearchResultsHierarchy";

});
parcelRegister("iC7Pk", function(module, exports) {

$parcel$export(module.exports, "searchAllHierarchies", function () { return $24db572d2948fe89$export$176ea7a8c923d374; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $cg0e3 = parcelRequire("cg0e3");

var $8A5VF = parcelRequire("8A5VF");
const $24db572d2948fe89$export$176ea7a8c923d374 = async (backEndUrl, searchText, controller)=>{
    const url = new URL(`${backEndUrl}Hierarchy/Search`);
    // Get data
    try {
        const searchTextParts = (0, $cg0e3.getSearchTextParts)(searchText);
        searchTextParts.forEach((searchTextPart)=>{
            url.searchParams.append("searchText", searchTextPart);
        });
        const response = await (0, $a04va.default).get(url.href, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Search all hierarchies failed", error);
    }
};

});
parcelRegister("cg0e3", function(module, exports) {

$parcel$export(module.exports, "getSearchTextParts", function () { return $44382a51f4f13cbe$export$54c04952233faee7; });
/**
 * Splits the search text into parts based on non-alphanumeric characters,
 *
 * @param searchText - The search text to split into searchable parts
 * @returns string[]
 */ const $44382a51f4f13cbe$export$54c04952233faee7 = (searchText)=>{
    // Use a regular expression to match non-alphanumeric characters
    // except for underscores (_), hyphens (-), and spaces ( )
    const regex = /[^a-zA-Z0-9_ -]+/g;
    // Split the searchText by the non-alphanumeric characters and filter out empty parts
    const parts = searchText.split(regex).filter((part)=>part.trim() !== "" && part.trim().length > 2);
    return parts;
};

});



parcelRegister("9ayVk", function(module, exports) {

$parcel$export(module.exports, "SearchResultsTlf", function () { return $07bb7ad215417578$export$c7792cfc98406f09; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $hIwWM = parcelRequire("hIwWM");

var $7fPBF = parcelRequire("7fPBF");

var $4WD1L = parcelRequire("4WD1L");

var $20AtX = parcelRequire("20AtX");
/**
 * Inner table used by the search results page to render a list of TLF
 * items for a specific category (e.g. Templates or ToC Items).
 *
 * @param props - Destructured props object.
 * @param props.id - DOM id used for the table instance.
 * @param props.label - Label for the table section shown to users.
 * @param props.searchResults - Array of TLF index DTOs to display.
 * @param props.searchStatus - Request status controlling loading and errors.
 */ const $07bb7ad215417578$var$InnerTable = ({ id: id, label: label, searchResults: searchResults, searchStatus: searchStatus })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: searchStatus.requesting ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "my-2",
            children: [
                "Loading search results for ",
                label,
                "...",
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4WD1L.default), {
                    className: "mx-1",
                    animation: "border",
                    size: "sm",
                    variant: "dark"
                })
            ]
        }) : searchStatus.error ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
            className: "text-danger",
            children: searchStatus.errorText
        }) : searchResults.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)("p", {
            children: [
                "No results for ",
                label
            ]
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            style: {
                height: "400px"
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20AtX.TlfItemTable), {
                id: id,
                label: label,
                searchResults: searchResults,
                showSearchResults: label === "Templates",
                showTocSearchResults: label === "ToC Items"
            })
        })
    });
$07bb7ad215417578$var$InnerTable.displayName = "InnerTable";
const $07bb7ad215417578$export$c7792cfc98406f09 = ({ searchText: searchText })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    const [searchStatus, setSearchStatus] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [searchResults, setSearchResults] = (0, $7fPBF.useState)([]);
    // Run search
    const search = (0, $7fPBF.useEffectEvent)(async (searchText)=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $hIwWM.searchAllTlfs), searchText, {
            ...searchStatus,
            error: false,
            errorText: undefined
        }, setSearchStatus, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) startTransition(()=>setSearchResults(response.data));
        else if (response && response.success === false) startTransition(()=>setSearchResults([]));
    });
    (0, $7fPBF.useEffect)(()=>{
        search(searchText);
    }, [
        searchText
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($07bb7ad215417578$var$InnerTable, {
                id: "searchResultsTemplates",
                label: "Templates",
                searchResults: searchResults.filter((r)=>r.primaryHierarchyLevel !== (0, $7Wd8C.eHierarchyLevel).Report),
                searchStatus: {
                    ...searchStatus,
                    requesting: searchStatus.requesting || pending
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($07bb7ad215417578$var$InnerTable, {
                id: "searchResultsTocItems",
                label: "ToC Items",
                searchResults: searchResults.filter((r)=>r.primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report),
                searchStatus: {
                    ...searchStatus,
                    requesting: searchStatus.requesting || pending
                }
            })
        ]
    });
};
$07bb7ad215417578$export$c7792cfc98406f09.displayName = "SearchResultsTlf";

});
parcelRegister("hIwWM", function(module, exports) {

$parcel$export(module.exports, "searchAllTlfs", function () { return $6eae1222bd848189$export$edab17d62c0a241f; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $cg0e3 = parcelRequire("cg0e3");

var $8A5VF = parcelRequire("8A5VF");
const $6eae1222bd848189$export$edab17d62c0a241f = async (backEndUrl, searchText, controller)=>{
    const url = new URL(`${backEndUrl}TlfItems/Search`);
    // Get data
    try {
        const searchTextParts = (0, $cg0e3.getSearchTextParts)(searchText);
        searchTextParts.forEach((searchTextPart)=>{
            url.searchParams.append("searchText", searchTextPart);
        });
        const response = await (0, $a04va.default).get(url.href, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load search all Tlfs failed", error);
    }
};

});

parcelRegister("20AtX", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableContext", function () { return $5d4716da40c581c8$export$59677028152dedd0; });
$parcel$export(module.exports, "TlfItemTable", function () { return $5d4716da40c581c8$export$fead804da0b61a61; });

var $bbzbN = parcelRequire("bbzbN");

var $drJNc = parcelRequire("drJNc");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");
var $9eqKP = parcelRequire("9eqKP");

var $3Znsq = parcelRequire("3Znsq");

var $kHUCl = parcelRequire("kHUCl");

var $hWsmt = parcelRequire("hWsmt");

var $9Jgpw = parcelRequire("9Jgpw");

var $7Wd8C = parcelRequire("7Wd8C");

var $cPBZD = parcelRequire("cPBZD");

var $fhe29 = parcelRequire("fhe29");

var $dP8dW = parcelRequire("dP8dW");

var $1AaMV = parcelRequire("1AaMV");

var $7fPBF = parcelRequire("7fPBF");

var $74iEK = parcelRequire("74iEK");
var $aNfx0 = parcelRequire("aNfx0");

var $2i5hM = parcelRequire("2i5hM");


var $ijJl3 = parcelRequire("ijJl3");

var $2xmRz = parcelRequire("2xmRz");
const $5d4716da40c581c8$export$59677028152dedd0 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    canDelete: false
});
const $5d4716da40c581c8$export$fead804da0b61a61 = ({ id: id, label: label, showDelete: showDelete = false, selectedItems: selectedItems, setSelectedItems: setSelectedItems, searchResults: searchResults = [], showSearchResults: showSearchResults = false, showTocSearchResults: showTocSearchResults = false })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hbc = (0, $7fPBF.useContext)((0, $3Znsq.HierarchyBrowserContext));
    // Get hierarchy from the correct context
    const currentSelection = hbc?.state.treeList.find((h)=>h.id === hbc.state.currentHierarchy)?.data;
    const currentHierarchy = (0, $cPBZD.isHierarchyReadDto)(currentSelection) ? currentSelection : null;
    const hierarchy = currentHierarchy ?? hierarchyContext?.hierarchy;
    // Get TLF items from the correct context
    let tlfItems = hbc?.state.hierarchyTlfItemIndex?.find((i)=>i.hierarchyId === hbc.state.currentHierarchy)?.tlfItemIndex ?? hierarchyContext?.tlfItemIndex ?? [];
    // Remove ARS items if the hierarchy does not accept them
    if (hbc && !hierarchyContext?.hierarchy?.arsEnabled) tlfItems = tlfItems.filter((t)=>t.type !== (0, $7Wd8C.eTlfItemType).arsListing && t.type !== (0, $7Wd8C.eTlfItemType).arsTable);
    // #region DELETE
    // Delete request
    const [deleteRequest, setDeleteRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const deleteTlfItem = (0, $7fPBF.useCallback)(async (removeId)=>{
        const request = await (0, $30Ra3.loadWrapper)((0, $dP8dW.deleteTlf), removeId, {
            ...deleteRequest,
            requestedId: undefined,
            error: false
        }, setDeleteRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request && request.success && hierarchyContext && hierarchyContext.tlfItemIndex) {
            const newItems = hierarchyContext.tlfItemIndex.filter((i)=>removeId !== `${i.id}`);
            hierarchyContext.dispatch({
                operation: (0, $9Jgpw.UPDATE_TLF_ITEM_INDEX),
                tlfItemIndex: newItems
            });
        }
    }, [
        appSettings.backEndUrl,
        deleteRequest,
        hierarchyContext
    ]);
    // ID to remove
    const [removeId, setRemoveId] = (0, $7fPBF.useState)("");
    const [removeName, setRemoveName] = (0, $7fPBF.useState)("");
    // Show remove modal
    const [showRemoveModal, setShowRemoveModal] = (0, $7fPBF.useState)(false);
    // Trigger modal when a delete button is pressed
    const checkDelete = (0, $7fPBF.useCallback)((id, azsolId, version)=>{
        setRemoveName(`${azsolId}/${version}`);
        setRemoveId(id);
        setShowRemoveModal(true);
    }, []);
    // #endregion DELETE
    // #region REFRESH
    const [loadStatus, setLoadStatus] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    // Refresh TLF items call
    /**
   * Fetches TLF items for the specified hierarchy query parameters.
   *
   * @param hierarchyQueryParams - The parameters defining the hierarchy to fetch TLF items for
   * @param force - Optional flag to force reload, bypassing any cached data
   */ const getTlfItems = (0, $7fPBF.useCallback)(async (hierarchyQueryParams, force)=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $fhe29.loadHierarchyTlfs), hierarchyQueryParams, {
            ...loadStatus,
            error: false,
            requestedId: force ? undefined : loadStatus.requestedId
        }, setLoadStatus, appSettings.backEndUrl);
        if (response?.success) {
            // Refresh hierarchy browser
            if (hbc && hierarchyQueryParams.hierarchyId) hbc.dispatch({
                operation: (0, $kHUCl.UPSERT_HIERARCHY_TLF_ITEM_INDEX),
                nodeId: hierarchyQueryParams.hierarchyId,
                tlfItemIndex: response.data
            });
            else hierarchyContext?.dispatch({
                operation: (0, $9Jgpw.UPDATE_TLF_ITEM_INDEX),
                tlfItemIndex: response.data
            });
        }
    }, [
        appSettings.backEndUrl,
        hbc,
        hierarchyContext,
        loadStatus
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (hbc) {
            const currentHierarchy = hbc.state.treeList.find((h)=>h.id === hbc.state.currentHierarchy)?.data;
            const hierarchyQueryParams = {
                hierarchyId: currentHierarchy?.id,
                parentTag: currentHierarchy?.parentTag
            };
            if (loadStatus.requestingId?.hierarchyId !== hbc.state.currentHierarchy && loadStatus.requestedId?.hierarchyId !== hbc.state.currentHierarchy && !loadStatus.error && hierarchyQueryParams.hierarchyId && hierarchyQueryParams.parentTag) getTlfItems(hierarchyQueryParams);
        } else if (hierarchy && loadStatus.requestingId?.hierarchyId !== hierarchy.id && loadStatus.requestedId?.hierarchyId !== hierarchy.id && !loadStatus.error && hierarchyContext && hierarchyContext.tlfItemIndex === null) getTlfItems({
            hierarchyId: hierarchy.id,
            parentTag: hierarchy.parentTag
        });
    }, [
        getTlfItems,
        hbc,
        hierarchy,
        hierarchyContext,
        loadStatus.error,
        loadStatus.requestedId?.hierarchyId,
        loadStatus.requestingId?.hierarchyId
    ]);
    // #endregion REFRESH
    const tableHeader = (0, $7fPBF.useMemo)(()=>{
        if (label) return label;
        else if (hierarchy) return `${hierarchy.name} ${![
            (0, $7Wd8C.eHierarchy).TopLevel,
            (0, $7Wd8C.eHierarchy).Report
        ].includes(hierarchy.type) && hierarchy.level !== (0, $7Wd8C.eHierarchyLevel).Corporate ? `${hierarchy.level} ` : ""}${hierarchy.type === (0, $7Wd8C.eHierarchy).Report ? "ToC items" : "templates"}`;
        return "";
    }, [
        hierarchy,
        label
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($5d4716da40c581c8$export$59677028152dedd0, {
        value: {
            canDelete: showDelete && hierarchy !== undefined && hierarchy !== null && [
                (0, $7Wd8C.eHierarchy).Directory
            ].includes(hierarchy.type),
            deleteClick: checkDelete
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    loadStatus.requesting && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                        text: "Loading TLF items..."
                    }),
                    deleteRequest.requesting && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                        text: "Deleting TLF item..."
                    }),
                    loadStatus.error ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aNfx0.default), {}),
                            " Error loading items; you may not have access. Please",
                            " ",
                            /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                className: "button-link",
                                onClick: (0, $1AaMV.doReload),
                                children: "refresh"
                            }),
                            ", or contact the relevant Lead."
                        ]
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            style: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $74iEK.default), {
                                id: `${id}-refresh`,
                                "aria-label": "Refresh TLF items",
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    right: "4px",
                                    zIndex: 3
                                },
                                onClick: ()=>{
                                    setLoadStatus({
                                        requesting: false,
                                        error: false
                                    });
                                    /* istanbul ignore else */ if (hierarchy) {
                                        const hierarchyQueryParams = {
                                            hierarchyId: hierarchy?.id,
                                            parentTag: hierarchy?.parentTag
                                        };
                                        getTlfItems(hierarchyQueryParams, true);
                                    }
                                }
                            })
                        })
                    }),
                    loadStatus.requesting ? null : tlfItems.length === 0 && !(showSearchResults || showTocSearchResults) ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h4", {
                                children: tableHeader
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: "No items in this hierarchy"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $drJNc.SimpleTable), {
                        id: id,
                        headerLabel: tableHeader,
                        tableClassName: "tlf-item-table",
                        fields: (0, $ijJl3.getTemplateHeaders)(showSearchResults, showTocSearchResults, hierarchy?.level ?? (0, $7Wd8C.eHierarchyLevel).Corporate),
                        keyField: "id",
                        data: (showSearchResults || showTocSearchResults ? searchResults : tlfItems).map((0, $2xmRz.mapTlfItemTableRow)),
                        filterLabel: "Hide retired/decommissioned",
                        showSearch: showSearchResults || showTocSearchResults ? false : true,
                        showFilter: true,
                        initialFilterSelected: true,
                        selectable: setSelectedItems !== undefined,
                        currentSelection: selectedItems,
                        setCurrentSelection: (ret)=>{
                            /* istanbul ignore else */ if (setSelectedItems) setSelectedItems(ret.filter((r)=>typeof r === "string"));
                        },
                        selectedBackgroundColor: "rgb(0,0,0,0.2)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2i5hM.RemoveModal), {
                id: "remove-template-modal",
                show: showRemoveModal,
                beingRemovedType: "Template",
                beingRemovedName: removeName,
                onOk: async ()=>{
                    const rid = removeId;
                    setRemoveId("Deleting...");
                    await deleteTlfItem(rid);
                    setShowRemoveModal(false);
                    setRemoveId("");
                    setRemoveName("");
                },
                onCancel: ()=>{
                    setShowRemoveModal(false);
                }
            })
        ]
    });
};
$5d4716da40c581c8$export$fead804da0b61a61.displayName = "TlfItemTable";

});
parcelRegister("drJNc", function(module, exports) {

$parcel$export(module.exports, "SimpleTable", function () { return $9ca15166a9eda0b2$export$3fe48f9151d0ecc2; });
$parcel$export(module.exports, "simpleTableSortFn", function () { return $9ca15166a9eda0b2$export$6cbd403afa8090eb; });


var $9tqwB = parcelRequire("9tqwB");

var $2qxEV = parcelRequire("2qxEV");

var $bLhVg = parcelRequire("bLhVg");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gSkQi = parcelRequire("gSkQi");

var $fw0lo = parcelRequire("fw0lo");
function $9ca15166a9eda0b2$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $9ca15166a9eda0b2$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $9ca15166a9eda0b2$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $9ca15166a9eda0b2$var$$b65191f6d0a0a991$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$b65191f6d0a0a991$exports, "SimpleTable", function() {
    return $9ca15166a9eda0b2$export$3fe48f9151d0ecc2;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$b65191f6d0a0a991$exports, "SimpleTableNullDate", function() {
    return $9ca15166a9eda0b2$export$eaad410fa83c9417;
});
var $9ca15166a9eda0b2$var$$2d0562c3236da942$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$2d0562c3236da942$exports, "columnFilterValue", function() {
    return $9ca15166a9eda0b2$export$5813a5ff74a5f299;
});
var $9ca15166a9eda0b2$var$$2121208b4d86b049$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$2121208b4d86b049$exports, "convertDateToLocaleString", function() {
    return $9ca15166a9eda0b2$export$886dc98a901f1d4f;
});
const $9ca15166a9eda0b2$export$886dc98a901f1d4f = (s)=>{
    const d = s instanceof Date ? s : new Date(s);
    return !isNaN(d.getTime()) ? `${new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16).replace(/[T]/, " ")}` : "Invalid date";
};
const $9ca15166a9eda0b2$export$5813a5ff74a5f299 = (dataItem, showBlank = true, customFilterValueFn)=>{
    if (customFilterValueFn) return customFilterValueFn(dataItem);
    if (!showBlank && (dataItem === null || dataItem === undefined || typeof dataItem === "string" && dataItem.trim() === "")) return [
        ""
    ];
    switch(typeof dataItem){
        case "number":
        case "boolean":
        case "bigint":
            return [
                `${dataItem}`
            ];
        case "string":
            return dataItem.trim() === "" ? [
                "<blank>"
            ] : dataItem.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/) ? [
                $9ca15166a9eda0b2$export$886dc98a901f1d4f(new Date(dataItem))
            ] : [
                dataItem
            ];
        case "object":
            if (dataItem === null) return [
                "<blank>"
            ];
            if (Array.isArray(dataItem)) return dataItem.flatMap((item)=>$9ca15166a9eda0b2$export$5813a5ff74a5f299(item, showBlank));
            if (dataItem instanceof Date) return [
                $9ca15166a9eda0b2$export$886dc98a901f1d4f(dataItem)
            ];
            return Object.values(dataItem).flatMap((item)=>$9ca15166a9eda0b2$export$5813a5ff74a5f299(item, showBlank));
        case "function":
            return [
                "\uD83D\uDEE0\uFE0F\uD83D\uDEE0\uFE0F"
            ];
        // Only undefined and Symbol are left
        default:
            return dataItem === undefined ? [
                "<blank>"
            ] : [
                "\u2049\uFE0F\u2049\uFE0F"
            ];
    }
};
var $9ca15166a9eda0b2$var$$9a300121ef89926b$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "footerHolder", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$b203872abf836b30;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$b203872abf836b30 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "holder", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$f57c6e831b0d072a;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$f57c6e831b0d072a = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "main", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$f22da7240b7add18;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$f22da7240b7add18 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "scroll", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$209876d7b1ac8f3;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$209876d7b1ac8f3 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "table", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$9852986a3ec5f6a0;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$9852986a3ec5f6a0 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "title", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$fb184b623420d9be;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$fb184b623420d9be = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$9a300121ef89926b$exports, "titleHolder", function() {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$9835d85acf04d22e;
}, function(v) {
    return $9ca15166a9eda0b2$var$$9a300121ef89926b$export$9835d85acf04d22e = v;
});
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$b203872abf836b30;
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$f57c6e831b0d072a;
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$f22da7240b7add18;
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$209876d7b1ac8f3;
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$9852986a3ec5f6a0;
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$fb184b623420d9be;
var $9ca15166a9eda0b2$var$$9a300121ef89926b$export$9835d85acf04d22e;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$b203872abf836b30 = `ast-SimpleTable-module-byZixa-footerHolder`;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$f57c6e831b0d072a = `ast-SimpleTable-module-byZixa-holder`;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$f22da7240b7add18 = `ast-SimpleTable-module-byZixa-main`;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$209876d7b1ac8f3 = `ast-SimpleTable-module-byZixa-scroll`;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$9852986a3ec5f6a0 = `ast-SimpleTable-module-byZixa-table`;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$fb184b623420d9be = `ast-SimpleTable-module-byZixa-title`;
$9ca15166a9eda0b2$var$$9a300121ef89926b$export$9835d85acf04d22e = `ast-SimpleTable-module-byZixa-titleHolder`;
var $9ca15166a9eda0b2$var$$54193bdb0fc035ea$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$54193bdb0fc035ea$exports, "noKeyField", function() {
    return $9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$32cccc561cbc974b;
}, function(v) {
    return $9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$32cccc561cbc974b = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$54193bdb0fc035ea$exports, "tbody", function() {
    return $9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c;
}, function(v) {
    return $9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c = v;
});
var $9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$32cccc561cbc974b;
var $9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c;
$9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$32cccc561cbc974b = `ast-SimpleTableBody-module-Y-lNqW-noKeyField`;
$9ca15166a9eda0b2$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c = `ast-SimpleTableBody-module-Y-lNqW-tbody`;
// istanbul ignore next
const $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn = ()=>{};
const $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fba198b5b2e37fa = {
    id: "simple-table",
    fields: [],
    keyField: "",
    viewData: [],
    totalRows: 0,
    setTableData: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setFilterData: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setSearchText: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    updateSortBy: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    currentSelection: [],
    toggleAllCurrentSelection: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    toggleSelection: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setColumnWidth: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    pageRows: 50,
    setPageRows: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    firstRow: 0,
    setFirstRow: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    columnWidths: [],
    currentColumnItems: [],
    currentColumnFilter: null,
    currentColumnFilters: [],
    setCurrentColumnFilter: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setCurrentColumnFilters: $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$var$defaultFn
};
const $9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554 = (0, $7fPBF.createContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fba198b5b2e37fa);
var $9ca15166a9eda0b2$var$$e344397c31793d24$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$e344397c31793d24$exports, "cell", function() {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$e2e1361cdc35271d;
}, function(v) {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$e2e1361cdc35271d = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$e344397c31793d24$exports, "overflowHidden", function() {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$2d30eef276ffb91a;
}, function(v) {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$2d30eef276ffb91a = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$e344397c31793d24$exports, "textLeft", function() {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$354e346024ee0461;
}, function(v) {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$354e346024ee0461 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$e344397c31793d24$exports, "textRight", function() {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$19e1b6471a572b37;
}, function(v) {
    return $9ca15166a9eda0b2$var$$e344397c31793d24$export$19e1b6471a572b37 = v;
});
var $9ca15166a9eda0b2$var$$e344397c31793d24$export$e2e1361cdc35271d;
var $9ca15166a9eda0b2$var$$e344397c31793d24$export$2d30eef276ffb91a;
var $9ca15166a9eda0b2$var$$e344397c31793d24$export$354e346024ee0461;
var $9ca15166a9eda0b2$var$$e344397c31793d24$export$19e1b6471a572b37;
$9ca15166a9eda0b2$var$$e344397c31793d24$export$e2e1361cdc35271d = `ast-SimpleTableCell-module-KqO2pa-cell`;
$9ca15166a9eda0b2$var$$e344397c31793d24$export$2d30eef276ffb91a = `ast-SimpleTableCell-module-KqO2pa-overflowHidden`;
$9ca15166a9eda0b2$var$$e344397c31793d24$export$354e346024ee0461 = `ast-SimpleTableCell-module-KqO2pa-textLeft`;
$9ca15166a9eda0b2$var$$e344397c31793d24$export$19e1b6471a572b37 = `ast-SimpleTableCell-module-KqO2pa-textRight`;
const $9ca15166a9eda0b2$export$eaad410fa83c9417 = ({ cellField: cellField, field: field, rowData: rowData })=>(0, $bbzbN.jsx)("div", {
        className: [
            `simple-table-null-date-cell`,
            /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$e344397c31793d24$exports).overflowHidden,
            typeof rowData[cellField] === "number" ? /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$e344397c31793d24$exports).textRight : /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$e344397c31793d24$exports).textLeft
        ].join(" "),
        children: (0, $bbzbN.jsx)("span", {
            children: $9ca15166a9eda0b2$export$5813a5ff74a5f299(rowData[cellField], false, field.columnFilterValueFn)
        })
    });
$9ca15166a9eda0b2$export$eaad410fa83c9417.displayName = "SimpleTableNullDate";
const $9ca15166a9eda0b2$var$$6fafd1e93a2ba7ab$export$48b23f1dbb795221 = ({ rowId: rowId, cellField: cellField, columnNumber: columnNumber, rowNumber: rowNumber })=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const field = simpleTableContext.fields.find((f)=>f.name === cellField);
    const rowData = simpleTableContext.viewData.find((d)=>d[simpleTableContext.keyField] === rowId);
    var _field_name, _field_renderFn;
    return (0, $bbzbN.jsx)("td", {
        id: `${simpleTableContext.id}-row-${String(rowId).toLowerCase().trim()}-cell-${(_field_name = field === null || field === void 0 ? void 0 : field.name) !== null && _field_name !== void 0 ? _field_name : columnNumber}`,
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$e344397c31793d24$exports).cell,
        children: !field || !rowData ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
            children: `${!rowData ? "Row data" : ""}${!rowData && !field ? ", " : ""}${!field ? "Field" : ""} not found`
        }) : (0, $7fPBF.createElement)((_field_renderFn = field.renderFn) !== null && _field_renderFn !== void 0 ? _field_renderFn : $9ca15166a9eda0b2$export$eaad410fa83c9417, {
            rowData: rowData,
            columnNumber: columnNumber,
            field: field,
            cellField: field.name,
            rowNumber: rowNumber
        })
    }, cellField);
};
$9ca15166a9eda0b2$var$$6fafd1e93a2ba7ab$export$48b23f1dbb795221.displayName = "SimpleTableCell";
var $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$exports, "firstcol", function() {
    return $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$209b552db59e98b8;
}, function(v) {
    return $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$209b552db59e98b8 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$exports, "selected", function() {
    return $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7;
}, function(v) {
    return $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7 = v;
});
var $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$209b552db59e98b8;
var $9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7;
$9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$209b552db59e98b8 = `ast-SimpleTableRow-module-KPelGa-firstcol`;
$9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7 = `ast-SimpleTableRow-module-KPelGa-selected`;
const $9ca15166a9eda0b2$var$$3b4572511bdc4efe$export$31fe1c7fa47941f3 = ({ rowId: rowId, rowNumber: rowNumber })=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    return (0, $bbzbN.jsxs)("tr", {
        id: `${simpleTableContext.id}-row-${rowId}`,
        className: simpleTableContext.currentSelection.findIndex((s)=>s === rowId) > -1 ? /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$exports).selected : undefined,
        children: [
            simpleTableContext.selectable && (0, $bbzbN.jsx)("td", {
                className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$3d4c690f3daa4ef7$exports).firstcol,
                children: (0, $bbzbN.jsx)("div", {
                    children: (0, $bbzbN.jsx)("input", {
                        id: `${simpleTableContext.id}-check-row-${rowId}`,
                        role: "checkbox",
                        type: "checkbox",
                        className: simpleTableContext.filterCheckClassName,
                        checked: simpleTableContext.currentSelection.findIndex((s)=>s === rowId) > -1,
                        onChange: ()=>simpleTableContext.toggleSelection && simpleTableContext.toggleSelection(rowId)
                    })
                })
            }),
            simpleTableContext.fields.filter((f)=>!f.hidden).map((field, ci)=>(0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$6fafd1e93a2ba7ab$export$48b23f1dbb795221, {
                    rowId: rowId,
                    rowNumber: rowNumber,
                    columnNumber: ci,
                    cellField: field.name
                }, ci))
        ]
    });
};
$9ca15166a9eda0b2$var$$3b4572511bdc4efe$export$31fe1c7fa47941f3.displayName = "SimpleTableRow";
const $9ca15166a9eda0b2$var$$688bd579c4247c44$export$166eb73abdd0a383 = ()=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    return (0, $bbzbN.jsx)("tbody", {
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$54193bdb0fc035ea$exports).tbody,
        children: simpleTableContext.viewData.slice(simpleTableContext.firstRow, simpleTableContext.firstRow + simpleTableContext.pageRows).map((row, ri)=>{
            const chk = typeof row[simpleTableContext.keyField] === "string" || typeof row[simpleTableContext.keyField] === "number";
            return chk ? (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$3b4572511bdc4efe$export$31fe1c7fa47941f3, {
                rowId: row[simpleTableContext.keyField],
                rowNumber: ri + simpleTableContext.firstRow
            }, row[simpleTableContext.keyField]) : (0, $bbzbN.jsx)("tr", {
                children: (0, $bbzbN.jsx)("td", {
                    colSpan: simpleTableContext.fields.filter((f)=>!f.hidden).length,
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$54193bdb0fc035ea$exports).noKeyField,
                    children: "keyField has not been found"
                })
            }, ri);
        })
    });
};
$9ca15166a9eda0b2$var$$688bd579c4247c44$export$166eb73abdd0a383.displayName = "SimpleTableBody";
var $9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports, "checkboxContainer", function() {
    return $9ca15166a9eda0b2$var$$33dfa4f31432acb8$export$be69ea624d82a314;
}, function(v) {
    return $9ca15166a9eda0b2$var$$33dfa4f31432acb8$export$be69ea624d82a314 = v;
});
var $9ca15166a9eda0b2$var$$33dfa4f31432acb8$export$be69ea624d82a314;
$9ca15166a9eda0b2$var$$33dfa4f31432acb8$export$be69ea624d82a314 = `ast-SimpleTableCheckBox-module-rhSufG-checkboxContainer`;
var $9ca15166a9eda0b2$var$$6121304767059332$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6121304767059332$exports, "holder", function() {
    return $9ca15166a9eda0b2$var$$6121304767059332$export$f57c6e831b0d072a;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6121304767059332$export$f57c6e831b0d072a = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6121304767059332$exports, "label", function() {
    return $9ca15166a9eda0b2$var$$6121304767059332$export$1237798dc640739a;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6121304767059332$export$1237798dc640739a = v;
});
var $9ca15166a9eda0b2$var$$6121304767059332$export$f57c6e831b0d072a;
var $9ca15166a9eda0b2$var$$6121304767059332$export$1237798dc640739a;
$9ca15166a9eda0b2$var$$6121304767059332$export$f57c6e831b0d072a = `ast-SimpleTableFilter-module-Q8L8jW-holder`;
$9ca15166a9eda0b2$var$$6121304767059332$export$1237798dc640739a = `ast-SimpleTableFilter-module-Q8L8jW-label`;
const $9ca15166a9eda0b2$var$$37494a5c2c819927$export$3a5aecd8506640b7 = ()=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    var _simpleTableContext_filterLabel;
    return (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6121304767059332$exports).holder,
        onClick: ()=>simpleTableContext.setFilterData && simpleTableContext.setFilterData(!simpleTableContext.filterData),
        children: [
            (0, $bbzbN.jsx)("div", {
                className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports).checkboxContainer,
                children: (0, $bbzbN.jsx)("input", {
                    id: `${simpleTableContext.id}-filter`,
                    type: "checkbox",
                    role: "checkbox",
                    className: simpleTableContext.filterCheckClassName,
                    checked: simpleTableContext.filterData !== undefined ? simpleTableContext.filterData : false,
                    onChange: ()=>true,
                    "aria-labelledby": `${simpleTableContext.id}-filter-label`
                })
            }),
            (0, $bbzbN.jsx)("span", {
                id: `${simpleTableContext.id}-filter-label`,
                className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6121304767059332$exports).label,
                children: (_simpleTableContext_filterLabel = simpleTableContext.filterLabel) !== null && _simpleTableContext_filterLabel !== void 0 ? _simpleTableContext_filterLabel : "Filter"
            })
        ]
    });
};
$9ca15166a9eda0b2$var$$37494a5c2c819927$export$3a5aecd8506640b7.displayName = "SimpleTableFilter";
var $9ca15166a9eda0b2$var$$3b8de475d255db9f$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$3b8de475d255db9f$exports, "cell", function() {
    return $9ca15166a9eda0b2$var$$3b8de475d255db9f$export$e2e1361cdc35271d;
}, function(v) {
    return $9ca15166a9eda0b2$var$$3b8de475d255db9f$export$e2e1361cdc35271d = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$3b8de475d255db9f$exports, "resizeHandle", function() {
    return $9ca15166a9eda0b2$var$$3b8de475d255db9f$export$8e36b812ea421d73;
}, function(v) {
    return $9ca15166a9eda0b2$var$$3b8de475d255db9f$export$8e36b812ea421d73 = v;
});
var $9ca15166a9eda0b2$var$$3b8de475d255db9f$export$e2e1361cdc35271d;
var $9ca15166a9eda0b2$var$$3b8de475d255db9f$export$8e36b812ea421d73;
$9ca15166a9eda0b2$var$$3b8de475d255db9f$export$e2e1361cdc35271d = `ast-SimpleTableHeader-module-rCOiMq-cell`;
$9ca15166a9eda0b2$var$$3b8de475d255db9f$export$8e36b812ea421d73 = `ast-SimpleTableHeader-module-rCOiMq-resizeHandle`;
var $9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports, "boxHeader", function() {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$67350385bd9f1355;
}, function(v) {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$67350385bd9f1355 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports, "close", function() {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$8360e631d277ea4d;
}, function(v) {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$8360e631d277ea4d = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports, "scroll", function() {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$209876d7b1ac8f3;
}, function(v) {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$209876d7b1ac8f3 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports, "search", function() {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$d76128d007d19019;
}, function(v) {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$d76128d007d19019 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports, "table", function() {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0;
}, function(v) {
    return $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0 = v;
});
var $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$67350385bd9f1355;
var $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$8360e631d277ea4d;
var $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$209876d7b1ac8f3;
var $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$d76128d007d19019;
var $9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0;
$9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$67350385bd9f1355 = `ast-SimpleTableColumnFilter-module-us4d8a-boxHeader`;
$9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$8360e631d277ea4d = `ast-SimpleTableColumnFilter-module-us4d8a-close`;
$9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$209876d7b1ac8f3 = `ast-SimpleTableColumnFilter-module-us4d8a-scroll`;
$9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$d76128d007d19019 = `ast-SimpleTableColumnFilter-module-us4d8a-search`;
$9ca15166a9eda0b2$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0 = `ast-SimpleTableColumnFilter-module-us4d8a-table`;
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$efd2611dc765ff3f = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        "aria-label": "Close filter",
        children: (0, $bbzbN.jsx)("path", {
            d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$efd2611dc765ff3f.displayName = "SimpleTableClose";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$f9f275e56b491797 = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bbzbN.jsx)("path", {
            d: "M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$f9f275e56b491797.displayName = "SimpleTableSortAsc";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$d6e14943d35dcd63 = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bbzbN.jsx)("path", {
            d: "M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$d6e14943d35dcd63.displayName = "SimpleTableSortDesc";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$4c49c2f0ba062656 = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bbzbN.jsx)("path", {
            d: "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$4c49c2f0ba062656.displayName = "SimpleTableFilterInactive";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$b72ac73842ff2e5f = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--st-select-active)",
        viewBox: "0 0 16 16",
        children: (0, $bbzbN.jsx)("path", {
            d: "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$b72ac73842ff2e5f.displayName = "SimpleTableFilterActive";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$6d7b1be640d775 = (props)=>(0, $bbzbN.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: [
            (0, $bbzbN.jsx)("path", {
                d: "M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L8.404 7.304Z"
            }),
            (0, $bbzbN.jsx)("path", {
                d: "M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L.404 7.304Z"
            })
        ]
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$6d7b1be640d775.displayName = "SimpleTablePagerStart";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$5843adf024675d72 = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bbzbN.jsx)("path", {
            d: "m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$5843adf024675d72.displayName = "SimpleTablePagerPrev";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$384c7abeb3a2ff53 = (props)=>(0, $bbzbN.jsx)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bbzbN.jsx)("path", {
            d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
        })
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$384c7abeb3a2ff53.displayName = "SimpleTablePagerNext";
const $9ca15166a9eda0b2$var$$67fa7036c02790e7$export$f8b8c716218840a = (props)=>(0, $bbzbN.jsxs)("svg", (0, $2qxEV._)((0, $9tqwB._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: [
            (0, $bbzbN.jsx)("path", {
                d: "M7.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
            }),
            (0, $bbzbN.jsx)("path", {
                d: "M15.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
            })
        ]
    }));
$9ca15166a9eda0b2$var$$67fa7036c02790e7$export$f8b8c716218840a.displayName = "SimpleTablePagerEnd";
const $9ca15166a9eda0b2$var$$b8a87bcd44c7ea21$export$bdb6d3fce58542c9 = ({ columnName: columnName })=>{
    var _simpleTableContext_currentColumnItems_find, _simpleTableContext_currentColumnFilters_find, _simpleTableContext_currentColumnFilters;
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const allCheck = (0, $7fPBF.useRef)(null);
    const searchCheck = (0, $7fPBF.useRef)(null);
    const inputRef = (0, $7fPBF.useRef)(null);
    const [localFilter, setLocalFilter] = (0, $7fPBF.useState)("");
    const matchCheck = (0, $7fPBF.useRef)(null);
    const [matchSearch, setMatchSearch] = (0, $7fPBF.useState)(false);
    var _simpleTableContext_currentColumnItems_find_values_sort;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const availableList = (_simpleTableContext_currentColumnItems_find_values_sort = (_simpleTableContext_currentColumnItems_find = simpleTableContext.currentColumnItems.find((cf)=>cf.columnName === columnName)) === null || _simpleTableContext_currentColumnItems_find === void 0 ? void 0 : _simpleTableContext_currentColumnItems_find.values.sort((a, b)=>a.localeCompare(b))) !== null && _simpleTableContext_currentColumnItems_find_values_sort !== void 0 ? _simpleTableContext_currentColumnItems_find_values_sort : [];
    var _simpleTableContext_currentColumnFilters_find_values;
    const [currentFilter, setCurrentFilter] = (0, $7fPBF.useState)((_simpleTableContext_currentColumnFilters_find_values = (_simpleTableContext_currentColumnFilters = simpleTableContext.currentColumnFilters) === null || _simpleTableContext_currentColumnFilters === void 0 ? void 0 : (_simpleTableContext_currentColumnFilters_find = _simpleTableContext_currentColumnFilters.find((cf)=>cf.columnName === columnName)) === null || _simpleTableContext_currentColumnFilters_find === void 0 ? void 0 : _simpleTableContext_currentColumnFilters_find.values) !== null && _simpleTableContext_currentColumnFilters_find_values !== void 0 ? _simpleTableContext_currentColumnFilters_find_values : availableList);
    const filteredItems = availableList.filter((v)=>v.toLowerCase().includes(localFilter.toLowerCase()));
    const filteredOutItems = availableList.filter((v)=>!v.toLowerCase().includes(localFilter.toLowerCase()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onClose = (values)=>{
        // istanbul ignore else
        if (simpleTableContext.setCurrentColumnFilters) {
            const newColumnFilters = [
                ...simpleTableContext.currentColumnFilters
            ];
            const newColumnFilter = {
                columnName: columnName,
                values: values !== null && values !== void 0 ? values : currentFilter
            };
            const ix = simpleTableContext.currentColumnFilters.findIndex((cf)=>cf.columnName === columnName);
            // If the current filter is the same as the available list, remove it
            if ((0, $gSkQi.isEqual)(availableList, currentFilter)) {
                if (ix > -1) newColumnFilters.splice(ix, 1);
            } else if (ix > -1) newColumnFilters.splice(ix, 1, newColumnFilter);
            else newColumnFilters.push(newColumnFilter);
            simpleTableContext.setCurrentColumnFilters(newColumnFilters);
        }
        setLocalFilter("");
        setCurrentFilter([]);
        simpleTableContext.setCurrentColumnFilter(null);
    };
    // Handle typing into the filter box
    const handleFilterChange = (e)=>{
        const newFilter = e.currentTarget.value;
        const newMatchSearch = localFilter.trim().length === 0 && newFilter.trim().length > 0 ? true : localFilter.trim().length > 0 && newFilter.trim().length === 0 ? false : matchSearch;
        setLocalFilter(newFilter);
        setMatchSearch(newMatchSearch);
        setCurrentFilter(newMatchSearch ? availableList.filter((v)=>v.toLowerCase().includes(newFilter.toLowerCase())) : availableList);
    };
    // Toggle all viewed rows
    const toggleCurrentColumnFilter = ()=>{
        // Add all items if they are not already in the current filter
        if (currentFilter.length < availableList.length) setCurrentFilter(availableList);
        else setCurrentFilter([]);
    };
    // Toggle all viewed rows
    const toggleCurrentColumnSearchFilter = ()=>{
        // istanbul ignore else
        if (availableList) {
            const searchedItems = availableList.filter((v)=>v.toLowerCase().includes(localFilter.toLowerCase()));
            // Add selection if any are not included
            if (searchedItems.some((item)=>!currentFilter.includes(item))) {
                setCurrentFilter([
                    ...searchedItems,
                    ...currentFilter.filter((v)=>!searchedItems.includes(v))
                ]);
                setMatchSearch(true);
            } else {
                setCurrentFilter(currentFilter.filter((v)=>!searchedItems.includes(v)));
                setMatchSearch(false);
            }
        }
    };
    const selectBodyRow = (e, v)=>{
        e.stopPropagation();
        e.preventDefault();
        const newFilter = [
            ...currentFilter
        ];
        const ix = newFilter.findIndex((cf)=>cf === v);
        if (ix > -1) newFilter.splice(ix, 1);
        else newFilter.push(v);
        setCurrentFilter(newFilter);
    };
    const bodyRow = (v, i)=>(0, $bbzbN.jsxs)("tr", {
            children: [
                (0, $bbzbN.jsx)("td", {
                    children: (0, $bbzbN.jsx)("div", {
                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports).checkboxContainer,
                        onClick: (e)=>selectBodyRow(e, v),
                        children: (0, $bbzbN.jsx)("input", {
                            "aria-label": v,
                            id: `${simpleTableContext.id}-columnfilter-${columnName}-check-${i}`,
                            type: "checkbox",
                            role: "checkbox",
                            className: simpleTableContext.filterCheckClassName,
                            checked: currentFilter.includes(v),
                            onChange: (e)=>selectBodyRow(e, v)
                        })
                    })
                }),
                (0, $bbzbN.jsx)("td", {
                    children: v
                })
            ]
        }, i);
    (0, $7fPBF.useEffect)(()=>{
        const attemptFocus = ()=>{
            if (inputRef.current && document.activeElement !== inputRef.current) inputRef.current.focus();
        };
        attemptFocus();
        const timer1 = setTimeout(attemptFocus, 50);
        const timer2 = setTimeout(attemptFocus, 150);
        return ()=>{
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Enter") onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onClose
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // istanbul ignore else
        if (matchCheck.current) matchCheck.current.checked = matchSearch;
    }, [
        matchSearch
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // istanbul ignore else
        if (allCheck.current) {
            if ((currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.length) === (availableList === null || availableList === void 0 ? void 0 : availableList.length)) {
                allCheck.current.checked = true;
                allCheck.current.indeterminate = false;
            } else if (currentFilter.length === 0) {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = false;
            } else {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = true;
            }
        }
        // istanbul ignore else
        if (searchCheck.current) {
            const searchResults = availableList === null || availableList === void 0 ? void 0 : availableList.filter((v)=>v.toLowerCase().includes(localFilter.toLowerCase()));
            if (localFilter.trim().length === 0 || (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) === 0 || !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.some((v)=>currentFilter.includes(v)))) {
                searchCheck.current.checked = false;
                searchCheck.current.indeterminate = false;
            } else if (searchResults === null || searchResults === void 0 ? void 0 : searchResults.every((v)=>currentFilter.includes(v))) {
                searchCheck.current.checked = true;
                searchCheck.current.indeterminate = false;
            } else {
                searchCheck.current.checked = false;
                searchCheck.current.indeterminate = true;
            }
        }
    }, [
        availableList,
        availableList === null || availableList === void 0 ? void 0 : availableList.length,
        currentFilter,
        currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.length,
        localFilter
    ]);
    return (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: (0, $bbzbN.jsxs)("table", {
            className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).table,
            children: [
                (0, $bbzbN.jsxs)("thead", {
                    children: [
                        (0, $bbzbN.jsxs)("tr", {
                            children: [
                                (0, $bbzbN.jsx)("th", {
                                    children: "\xa0"
                                }),
                                (0, $bbzbN.jsx)("th", {
                                    children: (0, $bbzbN.jsxs)("div", {
                                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).search,
                                        children: [
                                            (0, $bbzbN.jsx)("input", {
                                                ref: inputRef,
                                                id: `${simpleTableContext.id}-columnfilter-${columnName}-filter`,
                                                "aria-label": "Column filter search",
                                                value: localFilter,
                                                onChange: handleFilterChange
                                            }),
                                            (0, $bbzbN.jsx)("div", {
                                                className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).close,
                                                children: (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$efd2611dc765ff3f, {
                                                    onClick: ()=>onClose()
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0, $bbzbN.jsxs)("tr", {
                            children: [
                                (0, $bbzbN.jsx)("th", {
                                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).boxHeader,
                                    children: (0, $bbzbN.jsx)("div", {
                                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports).checkboxContainer,
                                        onClick: ()=>setMatchSearch(!matchSearch),
                                        children: (0, $bbzbN.jsx)("input", {
                                            ref: matchCheck,
                                            id: `${simpleTableContext.id}-columnfilter-${columnName}-match-search`,
                                            "aria-label": "Match search filter",
                                            className: simpleTableContext.filterCheckClassName,
                                            type: "checkbox",
                                            role: "checkbox"
                                        })
                                    })
                                }),
                                (0, $bbzbN.jsx)("th", {
                                    children: "Match search filter"
                                })
                            ]
                        }),
                        (0, $bbzbN.jsxs)("tr", {
                            children: [
                                (0, $bbzbN.jsx)("th", {
                                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).boxHeader,
                                    children: (0, $bbzbN.jsx)("div", {
                                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports).checkboxContainer,
                                        onClick: ()=>{
                                            if (localFilter.trim().length > 0) toggleCurrentColumnSearchFilter();
                                        },
                                        children: (0, $bbzbN.jsx)("input", {
                                            id: `${simpleTableContext.id}-columnsearchfilter-${columnName}-check-all`,
                                            "aria-label": "Column search filter toggle",
                                            className: simpleTableContext.filterCheckClassName,
                                            ref: searchCheck,
                                            type: "checkbox",
                                            role: "checkbox"
                                        })
                                    })
                                }),
                                (0, $bbzbN.jsx)("th", {
                                    children: "Toggle search values"
                                })
                            ]
                        }),
                        (0, $bbzbN.jsxs)("tr", {
                            children: [
                                (0, $bbzbN.jsx)("th", {
                                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).boxHeader,
                                    children: (0, $bbzbN.jsx)("div", {
                                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$33dfa4f31432acb8$exports).checkboxContainer,
                                        onClick: ()=>toggleCurrentColumnFilter(),
                                        children: (0, $bbzbN.jsx)("input", {
                                            id: `${simpleTableContext.id}-columnfilter-${columnName}-check-all`,
                                            "aria-label": "Column filter toggle",
                                            className: simpleTableContext.filterCheckClassName,
                                            ref: allCheck,
                                            type: "checkbox",
                                            role: "checkbox"
                                        })
                                    })
                                }),
                                (0, $bbzbN.jsx)("th", {
                                    children: "Select all"
                                })
                            ]
                        })
                    ]
                }),
                (0, $bbzbN.jsxs)("tbody", {
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$a9a06f824c5a210d$exports).scroll,
                    children: [
                        filteredItems.length === 0 ? (0, $bbzbN.jsx)("tr", {
                            children: (0, $bbzbN.jsx)("td", {
                                colSpan: 2,
                                style: {
                                    textAlign: "center"
                                },
                                children: "No matching items"
                            })
                        }) : filteredItems.map(bodyRow),
                        filteredOutItems.length > 0 && (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                (0, $bbzbN.jsx)("tr", {
                                    children: (0, $bbzbN.jsx)("th", {
                                        colSpan: 2,
                                        style: {
                                            backgroundColor: "grey"
                                        }
                                    })
                                }),
                                filteredOutItems.map(bodyRow)
                            ]
                        })
                    ]
                }),
                (0, $bbzbN.jsx)("tfoot", {
                    children: (0, $bbzbN.jsx)("tr", {
                        children: (0, $bbzbN.jsx)("td", {
                            colSpan: 2,
                            children: (0, $bbzbN.jsx)("small", {
                                children: `${currentFilter.length} item${currentFilter.length !== 1 ? "s" : ""} selected`
                            })
                        })
                    })
                })
            ]
        })
    });
};
$9ca15166a9eda0b2$var$$b8a87bcd44c7ea21$export$bdb6d3fce58542c9.displayName = "SimpleTableColumnFilter";
var $9ca15166a9eda0b2$var$$6778322675caae03$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6778322675caae03$exports, "clickable", function() {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$60d5655c6babb2a0;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$60d5655c6babb2a0 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6778322675caae03$exports, "clickableDisabled", function() {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$b81be63c99ce521;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$b81be63c99ce521 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6778322675caae03$exports, "filterHolder", function() {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$f8ca79fc2b1d5fa9;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$f8ca79fc2b1d5fa9 = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6778322675caae03$exports, "iconHolder", function() {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$8826a4de072b82bd;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$8826a4de072b82bd = v;
});
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$6778322675caae03$exports, "text", function() {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$6f093cfa640b7166;
}, function(v) {
    return $9ca15166a9eda0b2$var$$6778322675caae03$export$6f093cfa640b7166 = v;
});
var $9ca15166a9eda0b2$var$$6778322675caae03$export$60d5655c6babb2a0;
var $9ca15166a9eda0b2$var$$6778322675caae03$export$b81be63c99ce521;
var $9ca15166a9eda0b2$var$$6778322675caae03$export$f8ca79fc2b1d5fa9;
var $9ca15166a9eda0b2$var$$6778322675caae03$export$8826a4de072b82bd;
var $9ca15166a9eda0b2$var$$6778322675caae03$export$6f093cfa640b7166;
$9ca15166a9eda0b2$var$$6778322675caae03$export$60d5655c6babb2a0 = `ast-SimpleTableHeaderContents-module-hte7-q-clickable`;
$9ca15166a9eda0b2$var$$6778322675caae03$export$b81be63c99ce521 = `ast-SimpleTableHeaderContents-module-hte7-q-clickableDisabled`;
$9ca15166a9eda0b2$var$$6778322675caae03$export$f8ca79fc2b1d5fa9 = `ast-SimpleTableHeaderContents-module-hte7-q-filterHolder`;
$9ca15166a9eda0b2$var$$6778322675caae03$export$8826a4de072b82bd = `ast-SimpleTableHeaderContents-module-hte7-q-iconHolder`;
$9ca15166a9eda0b2$var$$6778322675caae03$export$6f093cfa640b7166 = `ast-SimpleTableHeaderContents-module-hte7-q-text`;
const $9ca15166a9eda0b2$var$$4c31c909a3b65e1b$export$54be34308c33172a = (_param)=>{
    var { children: children, isVisible: isVisible, anchorElementRef: anchorElementRef, onClose: onClose } = _param, rest = (0, $bLhVg._)(_param, [
        "children",
        "isVisible",
        "anchorElementRef",
        "onClose"
    ]);
    const [position, setPosition] = (0, $7fPBF.useState)({
        top: undefined,
        left: undefined,
        right: undefined
    });
    const [alignment, setAlignment] = (0, $7fPBF.useState)("left");
    const popoverRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        const anchorElement = anchorElementRef.current;
        const updatePosition = ()=>{
            if (!anchorElement || !popoverRef.current) return;
            const anchorRect = anchorElement.getBoundingClientRect();
            const popoverRect = popoverRef.current.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            // Close if the anchor is not visible
            if (anchorRect.bottom < 8 || anchorRect.right < 8 || anchorRect.top > windowHeight || anchorRect.right > windowWidth) {
                onClose();
                return;
            }
            // Default position below the anchor
            const top = anchorRect.bottom;
            const left = anchorRect.left;
            const right = anchorRect.right;
            // Check horizontal boundaries
            if (alignment === "right") {
                // Close if there is no room
                if (right - popoverRect.width <= 0 && left + popoverRect.width >= windowWidth) {
                    onClose();
                    return;
                }
                // If right alignment goes out of bounds, switch to left alignment
                if (left + popoverRect.width < windowWidth - 8) setAlignment("left");
            } else {
                // Close if there is no room
                if (left + popoverRect.width >= windowWidth - 8 && right - popoverRect.width <= 0) {
                    onClose();
                    return;
                }
                // If left alignment goes out of bounds, switch to right alignment
                if (left + popoverRect.width >= windowWidth - 8 && right - popoverRect.width > 0) setAlignment("right");
            }
            // Check vertical boundaries
            if (top + popoverRect.height > windowHeight) {
                const newHeight = windowHeight - top - 24;
                if (newHeight < 100) {
                    onClose();
                    return;
                }
                popoverRef.current.style.height = `${newHeight}px`;
            }
            const newPosition = {
                top: top,
                left: alignment === "left" ? left : undefined,
                right: alignment === "right" ? windowWidth - right : undefined
            };
            setPosition(newPosition);
        };
        // Initial position update
        updatePosition();
        // Set up observers and event listeners
        const handleScroll = ()=>updatePosition();
        const handleResize = ()=>updatePosition();
        // Handle escape key press
        const handleKeyDown = (event)=>{
            // istanbul ignore else
            if (event.key === "Escape") {
                window.removeEventListener("keydown", handleKeyDown);
                onClose();
            }
        };
        const resizeObserver = new ResizeObserver(updatePosition);
        // Observe the popover and anchor element for resizing
        if (popoverRef.current) {
            resizeObserver.observe(popoverRef.current);
            // Observe the parent elements up to the body to detect layout changes
            let el = anchorElement;
            while(el && el !== document.body){
                resizeObserver.observe(el);
                el = el.parentElement;
            }
        }
        // Listen for scroll and resize events
        window.addEventListener("scroll", handleScroll, true);
        window.addEventListener("resize", handleResize);
        window.addEventListener("keydown", handleKeyDown);
        // Clean up all event listeners and observers
        return ()=>{
            resizeObserver.disconnect();
            window.removeEventListener("scroll", handleScroll, true);
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        alignment,
        anchorElementRef,
        isVisible,
        onClose
    ]);
    if (!isVisible) return null;
    return (0, $fw0lo.createPortal)((0, $bbzbN.jsx)("div", (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
        ref: popoverRef,
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6778322675caae03$exports).filterHolder,
        style: {
            visibility: position.top !== undefined ? "visible" : "hidden",
            top: position.top !== undefined ? `${position.top}px` : "auto",
            bottom: "auto",
            left: position.left !== undefined ? `${position.left}px` : "auto",
            right: position.right !== undefined ? `${position.right}px` : "auto",
            resize: alignment === "right" ? "vertical" : undefined
        },
        children: children
    })), document.body);
};
const $9ca15166a9eda0b2$var$$995a7ed18b2c70d1$export$623e74e451244509 = ({ field: field, columnNumber: columnNumber })=>{
    var _simpleTableContext_currentColumnFilters_find, _simpleTableContext_currentColumnItems_find, _simpleTableContext_sortBy, _simpleTableContext_sortBy1, _simpleTableContext_sortBy2;
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const filterIconRef = (0, $7fPBF.useRef)(null);
    const isFilterActive = simpleTableContext.currentColumnFilter === columnNumber;
    const thisColumnFilter = (_simpleTableContext_currentColumnFilters_find = simpleTableContext.currentColumnFilters.find((cf)=>cf.columnName === field.name)) === null || _simpleTableContext_currentColumnFilters_find === void 0 ? void 0 : _simpleTableContext_currentColumnFilters_find.values;
    const thisColumnItems = (_simpleTableContext_currentColumnItems_find = simpleTableContext.currentColumnItems.find((cf)=>cf.columnName === field.name)) === null || _simpleTableContext_currentColumnItems_find === void 0 ? void 0 : _simpleTableContext_currentColumnItems_find.values;
    const toggleFilter = async (e)=>{
        var _simpleTableContext_setCurrentColumnFilter;
        e.stopPropagation();
        e.preventDefault();
        (_simpleTableContext_setCurrentColumnFilter = simpleTableContext.setCurrentColumnFilter) === null || _simpleTableContext_setCurrentColumnFilter === void 0 || _simpleTableContext_setCurrentColumnFilter.call(simpleTableContext, simpleTableContext.currentColumnFilter !== columnNumber ? columnNumber : null);
    };
    return (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            field.canColumnFilter && (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$4c31c909a3b65e1b$export$54be34308c33172a, {
                isVisible: isFilterActive,
                anchorElementRef: filterIconRef,
                onClose: ()=>simpleTableContext.setCurrentColumnFilter(null),
                children: (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$b8a87bcd44c7ea21$export$bdb6d3fce58542c9, {
                    columnName: field.name
                })
            }),
            (0, $bbzbN.jsxs)("div", {
                className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6778322675caae03$exports).text,
                children: [
                    (0, $bbzbN.jsx)("span", {
                        className: field.sortFn ? /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6778322675caae03$exports).clickable : /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6778322675caae03$exports).clickableDisabled,
                        onClick: ()=>{
                            if (field.sortFn) simpleTableContext.updateSortBy(field);
                        },
                        children: (0, $bbzbN.jsx)("span", {
                            className: ((_simpleTableContext_sortBy = simpleTableContext.sortBy) === null || _simpleTableContext_sortBy === void 0 ? void 0 : _simpleTableContext_sortBy.name) === field.name ? "sorted" : "unsorted",
                            children: field.headerRenderFn ? (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                                children: field.headerRenderFn({
                                    field: field,
                                    columnNumber: columnNumber
                                })
                            }) : (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                                children: field.label
                            })
                        })
                    }),
                    (0, $bbzbN.jsxs)("div", {
                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$6778322675caae03$exports).iconHolder,
                        children: [
                            ((_simpleTableContext_sortBy1 = simpleTableContext.sortBy) === null || _simpleTableContext_sortBy1 === void 0 ? void 0 : _simpleTableContext_sortBy1.name) === field.name ? ((_simpleTableContext_sortBy2 = simpleTableContext.sortBy) === null || _simpleTableContext_sortBy2 === void 0 ? void 0 : _simpleTableContext_sortBy2.asc) ? (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$f9f275e56b491797, {}) : (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$d6e14943d35dcd63, {}) : undefined,
                            field.canColumnFilter && (0, $bbzbN.jsx)("span", {
                                ref: filterIconRef,
                                children: thisColumnFilter && thisColumnFilter.length !== (thisColumnItems === null || thisColumnItems === void 0 ? void 0 : thisColumnItems.length) ? (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$b72ac73842ff2e5f, {
                                    "aria-label": "Column filter (Active)",
                                    onClick: toggleFilter
                                }) : (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$4c49c2f0ba062656, {
                                    "aria-label": "Column filter",
                                    onClick: toggleFilter
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$9ca15166a9eda0b2$var$$995a7ed18b2c70d1$export$623e74e451244509.displayName = "SimpleTableHeaderContents";
const $9ca15166a9eda0b2$var$$01515f53c0c8c9ec$export$91068a7395f62723 = ()=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const targetCell = (0, $7fPBF.useRef)(null);
    const mouseUpRef = (0, $7fPBF.useRef)(null);
    const mouseMove = (e)=>{
        // istanbul ignore else
        if (targetCell.current !== null) {
            const t = targetCell.current;
            const width = e.clientX - window.scrollX - t.getBoundingClientRect().x;
            if (width > 16) t.style.width = `${width}px`;
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const mouseUp = ()=>{
        // istanbul ignore else
        if (targetCell.current) {
            const name = targetCell.current.dataset.columnName;
            const width = targetCell.current.style.width;
            // istanbul ignore else
            if (simpleTableContext.setColumnWidth && name && width) simpleTableContext.setColumnWidth(name, targetCell.current.style.width);
            targetCell.current = null;
            window.removeEventListener("mousemove", mouseMove);
            // istanbul ignore else
            if (mouseUpRef.current) window.removeEventListener("mouseup", mouseUpRef.current);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        mouseUpRef.current = mouseUp;
    }, [
        mouseUp
    ]);
    const mouseDown = (e)=>{
        e.preventDefault();
        targetCell.current = e.currentTarget.parentElement;
        // istanbul ignore else
        if (targetCell.current) {
            window.addEventListener("mousemove", mouseMove);
            window.addEventListener("mouseup", mouseUp);
        }
    };
    return (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: simpleTableContext.fields.filter((f)=>!f.hidden).map((field, columnNumber)=>{
            var _simpleTableContext_columnWidths_find;
            var _simpleTableContext_columnWidths_find_width;
            return (0, $bbzbN.jsxs)("th", {
                id: `${simpleTableContext.id}-header-${field.name}`,
                "data-column-name": field.name,
                className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$3b8de475d255db9f$exports).cell,
                style: {
                    width: (_simpleTableContext_columnWidths_find_width = (_simpleTableContext_columnWidths_find = simpleTableContext.columnWidths.find((w)=>w.name === field.name)) === null || _simpleTableContext_columnWidths_find === void 0 ? void 0 : _simpleTableContext_columnWidths_find.width) !== null && _simpleTableContext_columnWidths_find_width !== void 0 ? _simpleTableContext_columnWidths_find_width : "100px"
                },
                children: [
                    (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$995a7ed18b2c70d1$export$623e74e451244509, {
                        field: field,
                        columnNumber: columnNumber
                    }),
                    (0, $bbzbN.jsx)("div", {
                        "aria-orientation": "vertical",
                        tabIndex: columnNumber,
                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$3b8de475d255db9f$exports).resizeHandle,
                        role: "separator",
                        onMouseDown: mouseDown
                    })
                ]
            }, field.name);
        })
    });
};
$9ca15166a9eda0b2$var$$01515f53c0c8c9ec$export$91068a7395f62723.displayName = "SimpleTableHeader";
var $9ca15166a9eda0b2$var$$35a5bc35282fd524$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$35a5bc35282fd524$exports, "baseSelect", function() {
    return $9ca15166a9eda0b2$var$$35a5bc35282fd524$export$a332407e56744979;
}, function(v) {
    return $9ca15166a9eda0b2$var$$35a5bc35282fd524$export$a332407e56744979 = v;
});
var $9ca15166a9eda0b2$var$$35a5bc35282fd524$export$a332407e56744979;
$9ca15166a9eda0b2$var$$35a5bc35282fd524$export$a332407e56744979 = `ast-Select-module-SkswYq-baseSelect`;
var $9ca15166a9eda0b2$var$$107c82067973eee5$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$107c82067973eee5$exports, "footer", function() {
    return $9ca15166a9eda0b2$var$$107c82067973eee5$export$adb608be33961c98;
}, function(v) {
    return $9ca15166a9eda0b2$var$$107c82067973eee5$export$adb608be33961c98 = v;
});
var $9ca15166a9eda0b2$var$$107c82067973eee5$export$adb608be33961c98;
$9ca15166a9eda0b2$var$$107c82067973eee5$export$adb608be33961c98 = `ast-SimpleTablePager-module-P9pQIa-footer`;
const $9ca15166a9eda0b2$var$$3b94566e8ce64411$export$4b6ad0e8a3e0376c = ()=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    return (0, $bbzbN.jsx)("div", {
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$107c82067973eee5$exports).footer,
        children: (0, $bbzbN.jsxs)("span", {
            children: [
                "Showing\xa0",
                (0, $bbzbN.jsxs)("select", {
                    id: `${simpleTableContext.id}-pager-visible-rows`,
                    "aria-label": "Visible rows",
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$35a5bc35282fd524$exports).baseSelect,
                    value: `${simpleTableContext.pageRows === Infinity ? "All" : simpleTableContext.pageRows}`,
                    onChange: (e)=>simpleTableContext.setPageRows && simpleTableContext.setPageRows(e.currentTarget.value === "All" ? Infinity : parseInt(e.currentTarget.value)),
                    children: [
                        (0, $bbzbN.jsx)("option", {
                            children: "10"
                        }),
                        (0, $bbzbN.jsx)("option", {
                            children: "25"
                        }),
                        (0, $bbzbN.jsx)("option", {
                            children: "50"
                        }),
                        (0, $bbzbN.jsx)("option", {
                            children: "100"
                        }),
                        (0, $bbzbN.jsx)("option", {
                            children: "250"
                        }),
                        (0, $bbzbN.jsx)("option", {
                            children: "500"
                        }),
                        (0, $bbzbN.jsx)("option", {
                            children: "All"
                        })
                    ]
                }),
                "\xa0of\xa0",
                simpleTableContext.viewData.length,
                "\xa0rows",
                simpleTableContext.viewData.length !== simpleTableContext.totalRows && ` (${simpleTableContext.totalRows} unfiltered)`,
                "\xa0from\xa0",
                (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$6d7b1be640d775, {
                    "aria-label": "Go to first page",
                    onClick: ()=>simpleTableContext.setFirstRow && simpleTableContext.setFirstRow(0)
                }),
                (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$5843adf024675d72, {
                    "aria-label": "Go to previous page",
                    onClick: ()=>simpleTableContext.setFirstRow && simpleTableContext.setFirstRow(Math.max(0, simpleTableContext.firstRow - simpleTableContext.pageRows))
                }),
                "row\xa0",
                (0, $bbzbN.jsx)("select", {
                    id: `${simpleTableContext.id}-pager-first-row`,
                    "aria-label": "First row",
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$35a5bc35282fd524$exports).baseSelect,
                    value: simpleTableContext.firstRow,
                    onChange: (e)=>{
                        simpleTableContext.setFirstRow(parseInt(e.currentTarget.value));
                    },
                    children: simpleTableContext.pageRows === Infinity ? (0, $bbzbN.jsx)("option", {
                        children: "1"
                    }) : Array.from({
                        length: Math.ceil(simpleTableContext.viewData.length / simpleTableContext.pageRows)
                    }, (_, i)=>i * simpleTableContext.pageRows).map((rn)=>(0, $bbzbN.jsx)("option", {
                            value: rn,
                            children: rn + 1
                        }, rn))
                }),
                (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$384c7abeb3a2ff53, {
                    "aria-label": "Go to next page",
                    onClick: ()=>simpleTableContext.setFirstRow && simpleTableContext.firstRow + simpleTableContext.pageRows < simpleTableContext.viewData.length && simpleTableContext.setFirstRow(simpleTableContext.firstRow + simpleTableContext.pageRows)
                }),
                (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$67fa7036c02790e7$export$f8b8c716218840a, {
                    "aria-label": "Go to last page",
                    onClick: ()=>{
                        simpleTableContext.setFirstRow(Math.floor((simpleTableContext.viewData.length - 1) / simpleTableContext.pageRows) * simpleTableContext.pageRows);
                    }
                })
            ]
        })
    });
};
$9ca15166a9eda0b2$var$$3b94566e8ce64411$export$4b6ad0e8a3e0376c.displayName = "SimpleTablePager";
var $9ca15166a9eda0b2$var$$e901f27a85018fde$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$e901f27a85018fde$exports, "holder", function() {
    return $9ca15166a9eda0b2$var$$e901f27a85018fde$export$f57c6e831b0d072a;
}, function(v) {
    return $9ca15166a9eda0b2$var$$e901f27a85018fde$export$f57c6e831b0d072a = v;
});
var $9ca15166a9eda0b2$var$$e901f27a85018fde$export$f57c6e831b0d072a;
$9ca15166a9eda0b2$var$$e901f27a85018fde$export$f57c6e831b0d072a = `ast-SimpleTableSearch-module-xBXwEq-holder`;
const $9ca15166a9eda0b2$var$$47fed6d59054ee6e$export$66026d92cfdafe91 = ()=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    var _simpleTableContext_searchLabel, _simpleTableContext_searchText;
    return (0, $bbzbN.jsxs)("div", {
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$e901f27a85018fde$exports).holder,
        children: [
            (0, $bbzbN.jsx)("label", {
                id: `${simpleTableContext.id}-search-label`,
                htmlFor: `${simpleTableContext.id}-search`,
                className: simpleTableContext.searchLabelClassName,
                children: (_simpleTableContext_searchLabel = simpleTableContext.searchLabel) !== null && _simpleTableContext_searchLabel !== void 0 ? _simpleTableContext_searchLabel : "Search"
            }),
            (0, $bbzbN.jsx)("div", {
                children: (0, $bbzbN.jsx)("input", {
                    id: `${simpleTableContext.id}-search`,
                    className: simpleTableContext.searchInputClassName,
                    role: "searchbox",
                    type: "string",
                    value: (_simpleTableContext_searchText = simpleTableContext.searchText) !== null && _simpleTableContext_searchText !== void 0 ? _simpleTableContext_searchText : "",
                    disabled: !simpleTableContext.setSearchText,
                    onChange: (e)=>{
                        simpleTableContext.setSearchText(e.currentTarget.value);
                    }
                })
            })
        ]
    });
};
$9ca15166a9eda0b2$var$$47fed6d59054ee6e$export$66026d92cfdafe91.displayName = "SimpleTableSearch";
var $9ca15166a9eda0b2$var$$20518f3fca73c5aa$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$20518f3fca73c5aa$exports, "cell", function() {
    return $9ca15166a9eda0b2$var$$20518f3fca73c5aa$export$e2e1361cdc35271d;
}, function(v) {
    return $9ca15166a9eda0b2$var$$20518f3fca73c5aa$export$e2e1361cdc35271d = v;
});
var $9ca15166a9eda0b2$var$$20518f3fca73c5aa$export$e2e1361cdc35271d;
$9ca15166a9eda0b2$var$$20518f3fca73c5aa$export$e2e1361cdc35271d = `ast-SimpleTableSelectHeader-module-pMQ3rq-cell`;
const $9ca15166a9eda0b2$var$$06184096f9fd7746$export$fe2caba3b87edbe3 = ()=>{
    const simpleTableContext = (0, $7fPBF.useContext)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const allCheck = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        // istanbul ignore else
        if (allCheck.current) {
            var _simpleTableContext_currentSelection;
            if (((_simpleTableContext_currentSelection = simpleTableContext.currentSelection) === null || _simpleTableContext_currentSelection === void 0 ? void 0 : _simpleTableContext_currentSelection.length) === simpleTableContext.totalRows) {
                allCheck.current.checked = true;
                allCheck.current.indeterminate = false;
            } else if (simpleTableContext.currentSelection.length === 0) {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = false;
            } else {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = true;
            }
        }
    }, [
        simpleTableContext.currentSelection.length,
        simpleTableContext.totalRows
    ]);
    return (0, $bbzbN.jsx)("th", {
        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$20518f3fca73c5aa$exports).cell,
        children: (0, $bbzbN.jsx)("div", {
            children: (0, $bbzbN.jsx)("input", {
                id: `${simpleTableContext.id}-check-all`,
                type: "checkbox",
                role: "checkbox",
                className: simpleTableContext.filterCheckClassName,
                ref: allCheck,
                onChange: simpleTableContext.toggleAllCurrentSelection
            })
        })
    });
};
$9ca15166a9eda0b2$var$$06184096f9fd7746$export$fe2caba3b87edbe3.displayName = "SimpleTableSelectHeader";
// Type guard for SimpleTableLocalSettings
const $9ca15166a9eda0b2$var$$8bf0d84dcf2ec6e7$var$isSimpleTableLocalSettings = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const settings = obj;
    if (settings.pageRows !== undefined) {
        if (typeof settings.pageRows !== "number" && typeof settings.pageRows !== "string") return false;
    }
    if (settings.headerWidths !== undefined) {
        if (!Array.isArray(settings.headerWidths)) return false;
    }
    return true;
};
const $9ca15166a9eda0b2$export$3fe48f9151d0ecc2 = (_param)=>{
    var { id: id, currentSelection: currentSelection = [], data: data, fields: fields, filterCheckClassName: filterCheckClassName = "form-check-input", filterLabel: filterLabel = "Filter", filterLabelClassName: filterLabelClassName = "form-check-label", headerBackgroundColor: headerBackgroundColor = "white", headerLabel: headerLabel, initialFilterSelected: initialFilterSelected = false, inputGroupClassName: inputGroupClassName = "form-group", keyField: keyField, mainBackgroundColor: mainBackgroundColor = "white", onPagerChange: onPagerChange, onWidthChange: onWidthChange, searchInputClassName: searchInputClassName = "form-control form-control-sm", searchLabel: searchLabel = "Search", searchLabelClassName: searchLabelClassName = "form-label", selectActiveColor: selectActiveColor = "rgb(255, 153, 0)", selectInactiveColor: selectInactiveColor = "rgb(0, 0, 0, 0.2)", selectable: selectable = false, selectedBackgroundColor: selectedBackgroundColor = "rgba(0, 0, 0, 0.8)", setCurrentSelection: setCurrentSelection, showFilter: showFilter = false, showHeader: showHeader = true, showPager: showPager = true, showSearch: showSearch = true, tableClassName: tableClassName = "" } = _param, rest = (0, $bLhVg._)(_param, [
        "id",
        "currentSelection",
        "data",
        "fields",
        "filterCheckClassName",
        "filterLabel",
        "filterLabelClassName",
        "headerBackgroundColor",
        "headerLabel",
        "initialFilterSelected",
        "inputGroupClassName",
        "keyField",
        "mainBackgroundColor",
        "onPagerChange",
        "onWidthChange",
        "searchInputClassName",
        "searchLabel",
        "searchLabelClassName",
        "selectActiveColor",
        "selectInactiveColor",
        "selectable",
        "selectedBackgroundColor",
        "setCurrentSelection",
        "showFilter",
        "showHeader",
        "showPager",
        "showSearch",
        "tableClassName"
    ]);
    // Load local settings once on mount
    const localSettingsText = typeof window !== "undefined" ? window.localStorage.getItem(`asup.simple-table.${id}.settings`) : null;
    const parsedSettings = localSettingsText ? JSON.parse(localSettingsText) : null;
    const localSettings = $9ca15166a9eda0b2$var$$8bf0d84dcf2ec6e7$var$isSimpleTableLocalSettings(parsedSettings) ? parsedSettings : null;
    const columnFilterValueFns = fields.filter((f)=>f.columnFilterValueFn).reduce((acc, f)=>{
        acc[f.name] = f.columnFilterValueFn;
        return acc;
    }, {});
    // Sync external data prop changes
    const [tableData, setTableData] = (0, $7fPBF.useState)(data);
    (0, $7fPBF.useEffect)(()=>{
        (0, $7fPBF.startTransition)(()=>setTableData(data));
    }, [
        data
    ]);
    const [filterData, setFilterData] = (0, $7fPBF.useState)(initialFilterSelected);
    const [sortBy, setSortBy] = (0, $7fPBF.useState)(null);
    const [searchText, setSearchText] = (0, $7fPBF.useState)("");
    // Initialize columnWidths from localStorage or fields
    const [columnWidths, setColumnWidths] = (0, $7fPBF.useState)(()=>{
        if ((localSettings === null || localSettings === void 0 ? void 0 : localSettings.headerWidths) && Array.isArray(localSettings.headerWidths)) {
            // Check if it's the old format (string[]) or new format ({ name, width }[])
            if (localSettings.headerWidths.length > 0 && !localSettings.headerWidths.every((c)=>typeof c === "string" || c === null)) return localSettings.headerWidths;
        }
        return fields.filter((f)=>f.width !== undefined).map((f)=>({
                name: f.name,
                width: f.width
            }));
    });
    // Initialize pageRows from localStorage or props
    const [firstRow, setFirstRow] = (0, $7fPBF.useState)(showPager === false ? 0 : 0);
    const [pageRows, setPageRows] = (0, $7fPBF.useState)(()=>{
        if (showPager === false) return Infinity;
        if ((localSettings === null || localSettings === void 0 ? void 0 : localSettings.pageRows) && showPager) {
            if (localSettings.pageRows === "Infinity") return Infinity;
            return typeof localSettings.pageRows === "string" ? parseInt(localSettings.pageRows, 10) : localSettings.pageRows;
        }
        return 25;
    });
    (0, $7fPBF.useEffect)(()=>{
        if (showPager === false) (0, $7fPBF.startTransition)(()=>{
            setFirstRow(0);
            setPageRows(Infinity);
        });
    }, [
        showPager
    ]);
    const [currentColumnFilter, setCurrentColumnFilter] = (0, $7fPBF.useState)(null);
    const [currentColumnFilters, setCurrentColumnFilters] = (0, $7fPBF.useState)([]);
    const filterFn = (row)=>{
        if (showFilter && filterData) {
            const filterFns = fields.filter((f)=>f.filterOutFn).map((f)=>f.filterOutFn);
            return !filterFns.some((fn)=>fn(row));
        } else return true;
    };
    const searchFn = (row)=>{
        if (showSearch && searchText.trim().length > 0) {
            const searchFns = fields.filter((f)=>f.searchFn).map((f)=>f.searchFn);
            return searchFns.some((fn)=>fn(row, searchText));
        } else return true;
    };
    const sortFn = (rowa, rowb)=>{
        try {
            var _fields_find;
            const sortFn = (_fields_find = fields.find((f)=>f.name === (sortBy === null || sortBy === void 0 ? void 0 : sortBy.name))) === null || _fields_find === void 0 ? void 0 : _fields_find.sortFn;
            if (sortFn && sortBy) return sortBy.asc ? sortFn(rowa, rowb, sortBy) : -sortFn(rowa, rowb, sortBy);
            else return 0;
        } catch (error) {
            console.warn(`Sort failed because ${error}`);
            return 0;
        }
    };
    // Get view data
    const viewData = tableData.filter(filterFn).filter(searchFn).filter((row)=>{
        return currentColumnFilters.map((cf)=>{
            const columnValue = $9ca15166a9eda0b2$export$5813a5ff74a5f299(row[cf.columnName], true, columnFilterValueFns[cf.columnName]);
            return cf.values.some((v)=>columnValue.includes(v));
        }).reduce((prev, cur)=>prev && cur, true);
    }).sort(sortFn);
    (0, $7fPBF.useEffect)(()=>{
        if (viewData.length <= firstRow && viewData.length > 0) (0, $7fPBF.startTransition)(()=>setFirstRow(0));
    }, [
        viewData.length,
        firstRow
    ]);
    // Update sort order
    const updateSortBy = (field)=>{
        if (field.name === (sortBy === null || sortBy === void 0 ? void 0 : sortBy.name) && (sortBy === null || sortBy === void 0 ? void 0 : sortBy.asc) === false) setSortBy(null);
        else setSortBy({
            name: field.name,
            asc: field.name === (sortBy === null || sortBy === void 0 ? void 0 : sortBy.name) ? !sortBy.asc : true,
            columnFilterValueFn: columnFilterValueFns[field.name]
        });
    };
    // Get current column items
    // For each column, show values that exist after applying OTHER column filters (Excel-like behavior)
    const currentColumnItems = fields.filter((f)=>f.canColumnFilter).map((f)=>({
            columnName: f.name,
            values: Array.from(new Set(tableData.filter((row)=>{
                // Apply all column filters EXCEPT the one for this column
                return currentColumnFilters.filter((cf)=>cf.columnName !== f.name).map((cf)=>{
                    const columnValue = $9ca15166a9eda0b2$export$5813a5ff74a5f299(row[cf.columnName], true, columnFilterValueFns[cf.columnName]);
                    return cf.values.some((v)=>columnValue.includes(v));
                }).reduce((prev, cur)=>prev && cur, true);
            }).flatMap((t)=>$9ca15166a9eda0b2$export$5813a5ff74a5f299(t[f.name], true, columnFilterValueFns[f.name]))))
        }));
    // Toggle all viewed rows
    const toggleAllCurrentSelection = ()=>{
        // Select available if some are not selected
        const viewedKeys = viewData.filter((rowData)=>typeof rowData[keyField] === "string" || typeof rowData[keyField] === "number").map((rowData)=>rowData[keyField]);
        // Add if any of the current selection are not selected
        if (viewedKeys.some((v)=>!(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.includes(v)))) setCurrentSelection === null || setCurrentSelection === void 0 || setCurrentSelection([
            ...currentSelection,
            ...viewedKeys.filter((v)=>!(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.includes(v)))
        ]);
        else setCurrentSelection === null || setCurrentSelection === void 0 || setCurrentSelection(currentSelection.filter((s)=>!viewedKeys.includes(s)));
    };
    // Toggle individual row
    const toggleSelection = (rowId)=>{
        // Check key exists
        // istanbul ignore else
        if (tableData.findIndex((row)=>row[keyField] === rowId) > -1) {
            // Create new selection
            const newSelection = [
                ...currentSelection
            ];
            const ix = newSelection.findIndex((s)=>s === rowId);
            if (ix > -1) newSelection.splice(ix, 1);
            else newSelection.push(rowId);
            setCurrentSelection === null || setCurrentSelection === void 0 || setCurrentSelection(newSelection);
        }
    };
    // Save local settings
    const updateLocalSettings = (setting, value)=>{
        const localSettingsText = window.localStorage.getItem(`asup.simple-table.${id}.settings`);
        const localSettings = JSON.parse(localSettingsText !== null && localSettingsText !== void 0 ? localSettingsText : "{}");
        // istanbul ignore else
        if (setting === "pageRows" && value && !Array.isArray(value)) localSettings.pageRows = value === Infinity ? "Infinity" : value;
        else if (setting === "headerWidths" && value && Array.isArray(value)) localSettings.headerWidths = value;
        window.localStorage.setItem(`asup.simple-table.${id}.settings`, JSON.stringify(localSettings));
    };
    (0, $7fPBF.useEffect)(()=>{
        // istanbul ignore else
        if (mainBackgroundColor) document.documentElement.style.setProperty("--st-main-background-color", mainBackgroundColor);
        // istanbul ignore else
        if (headerBackgroundColor) document.documentElement.style.setProperty("--st-header-background-color", headerBackgroundColor);
        // istanbul ignore else
        if (selectedBackgroundColor) document.documentElement.style.setProperty("--st-selected-background-color", selectedBackgroundColor);
        // istanbul ignore else
        if (selectActiveColor) document.documentElement.style.setProperty("--st-select-active", selectActiveColor);
        // istanbul ignore else
        if (selectInactiveColor) document.documentElement.style.setProperty("--st-select-inactive", selectInactiveColor);
        return ()=>{
            // Reset to defaults when component unmounts
            document.documentElement.style.removeProperty("--st-main-background-color");
            document.documentElement.style.removeProperty("--st-header-background-color");
            document.documentElement.style.removeProperty("--st-selected-background-color");
            document.documentElement.style.removeProperty("--st-select-active");
            document.documentElement.style.removeProperty("--st-select-inactive");
        };
    }, [
        mainBackgroundColor,
        headerBackgroundColor,
        selectedBackgroundColor,
        selectActiveColor,
        selectInactiveColor
    ]);
    return (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554.Provider, {
        value: {
            id: id,
            fields: fields,
            keyField: keyField,
            viewData: viewData,
            totalRows: tableData.length,
            setTableData: setTableData,
            selectable: selectable,
            showSearch: showSearch,
            showFilter: showFilter,
            filterLabel: filterLabel,
            filterData: filterData,
            setFilterData: setFilterData,
            searchLabel: searchLabel,
            searchText: searchText,
            setSearchText: setSearchText,
            sortBy: sortBy,
            updateSortBy: updateSortBy,
            currentSelection: currentSelection,
            toggleAllCurrentSelection: toggleAllCurrentSelection,
            toggleSelection: toggleSelection,
            columnWidths: columnWidths,
            setColumnWidth: (name, width)=>{
                const newColumnWidths = [
                    ...columnWidths
                ];
                // istanbul ignore else
                if (fields.map((f)=>f.name).includes(name)) {
                    const ix = newColumnWidths.findIndex((c)=>c.name === name);
                    if (ix === -1) newColumnWidths.push({
                        name: name,
                        width: width
                    });
                    else newColumnWidths[ix] = {
                        name: name,
                        width: width
                    };
                }
                setColumnWidths(newColumnWidths);
                updateLocalSettings("headerWidths", newColumnWidths);
                onWidthChange === null || onWidthChange === void 0 || onWidthChange(newColumnWidths);
            },
            pageRows: pageRows,
            setPageRows: (ret)=>{
                setPageRows(ret);
                updateLocalSettings("pageRows", ret);
                onPagerChange === null || onPagerChange === void 0 || onPagerChange({
                    firstRow: firstRow,
                    pageRows: ret
                });
            },
            firstRow: firstRow,
            setFirstRow: (ret)=>{
                setFirstRow(ret);
                onPagerChange === null || onPagerChange === void 0 || onPagerChange({
                    firstRow: ret,
                    pageRows: pageRows
                });
            },
            currentColumnItems: currentColumnItems,
            currentColumnFilter: currentColumnFilter,
            setCurrentColumnFilter: setCurrentColumnFilter,
            currentColumnFilters: currentColumnFilters,
            setCurrentColumnFilters: setCurrentColumnFilters,
            inputGroupClassName: inputGroupClassName,
            filterLabelClassName: filterLabelClassName,
            filterCheckClassName: filterCheckClassName,
            searchLabelClassName: searchLabelClassName,
            searchInputClassName: searchInputClassName,
            headerBackgroundColor: headerBackgroundColor
        },
        children: (0, $bbzbN.jsxs)("div", {
            className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).main,
            children: [
                (showHeader || showSearch || showFilter) && (0, $bbzbN.jsxs)("div", {
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).titleHolder,
                    children: [
                        (0, $bbzbN.jsx)("h5", {
                            className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).title,
                            children: showHeader && (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    headerLabel,
                                    selectable && currentSelection.length > 0 && (0, $bbzbN.jsxs)("small", {
                                        children: [
                                            currentSelection.length,
                                            " selected"
                                        ]
                                    })
                                ]
                            })
                        }),
                        showSearch && fields.filter((f)=>f.searchFn).length > 0 && (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$47fed6d59054ee6e$export$66026d92cfdafe91, {}),
                        showFilter && fields.filter((f)=>f.filterOutFn).length > 0 && (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$37494a5c2c819927$export$3a5aecd8506640b7, {})
                    ]
                }),
                (0, $bbzbN.jsx)("div", {
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).scroll,
                    style: {
                        height: `calc(100% ${showHeader || showSearch || showFilter ? "- 46px" : ""} ${showPager ? " - 1.75rem" : ""}`
                    },
                    children: (0, $bbzbN.jsx)("div", {
                        className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).holder,
                        children: (0, $bbzbN.jsxs)("table", (0, $2qxEV._)((0, $9tqwB._)({}, rest), {
                            id: id,
                            className: [
                                /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).table,
                                tableClassName
                            ].join(" "),
                            children: [
                                (0, $bbzbN.jsx)("thead", {
                                    children: (0, $bbzbN.jsxs)("tr", {
                                        children: [
                                            selectable && (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$06184096f9fd7746$export$fe2caba3b87edbe3, {}),
                                            (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$01515f53c0c8c9ec$export$91068a7395f62723, {})
                                        ]
                                    })
                                }),
                                (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$688bd579c4247c44$export$166eb73abdd0a383, {})
                            ]
                        }))
                    })
                }),
                showPager && (0, $bbzbN.jsx)("div", {
                    className: /*@__PURE__*/ $9ca15166a9eda0b2$var$$parcel$interopDefault($9ca15166a9eda0b2$var$$9a300121ef89926b$exports).footerHolder,
                    children: (0, $bbzbN.jsx)($9ca15166a9eda0b2$var$$3b94566e8ce64411$export$4b6ad0e8a3e0376c, {})
                })
            ]
        })
    });
};
$9ca15166a9eda0b2$export$3fe48f9151d0ecc2.displayName = "SimpleTable";
var $9ca15166a9eda0b2$var$$bed788c620775009$exports = {};
$9ca15166a9eda0b2$var$$parcel$exportWildcard($9ca15166a9eda0b2$var$$b65191f6d0a0a991$exports, $9ca15166a9eda0b2$var$$bed788c620775009$exports);
var $9ca15166a9eda0b2$var$$3d005c8713d7dfb7$exports = {};
var $9ca15166a9eda0b2$var$$b5ad5f5c6daca351$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$b5ad5f5c6daca351$exports, "convertLocaleDateToUTCString", function() {
    return $9ca15166a9eda0b2$export$e50c52e1a45b9cde;
});
const $9ca15166a9eda0b2$export$e50c52e1a45b9cde = (s)=>{
    const d = new Date(s);
    return d instanceof Date && !isNaN(d.getTime()) ? `${new Date(d.getTime()).toISOString()}` : "Invalid date";
};
var $9ca15166a9eda0b2$var$$e186acb03c99a462$exports = {};
$9ca15166a9eda0b2$var$$parcel$export($9ca15166a9eda0b2$var$$e186acb03c99a462$exports, "simpleTableSortFn", function() {
    return $9ca15166a9eda0b2$export$6cbd403afa8090eb;
});
function $9ca15166a9eda0b2$export$6cbd403afa8090eb(a, b, sortBy) {
    var _columnFilterValue_, _columnFilterValue_1, _columnFilterValue_2, _columnFilterValue_3;
    const ret = sortBy.columnFilterValueFn ? ((_columnFilterValue_ = $9ca15166a9eda0b2$export$5813a5ff74a5f299(a[sortBy.name], false, sortBy.columnFilterValueFn)[0]) !== null && _columnFilterValue_ !== void 0 ? _columnFilterValue_ : "").localeCompare((_columnFilterValue_1 = $9ca15166a9eda0b2$export$5813a5ff74a5f299(b[sortBy.name], false, sortBy.columnFilterValueFn)[0]) !== null && _columnFilterValue_1 !== void 0 ? _columnFilterValue_1 : "") : typeof a[sortBy.name] === "number" || typeof b[sortBy.name] === "number" ? (typeof a[sortBy.name] === "number" ? a[sortBy.name] : -Infinity) - (typeof b[sortBy.name] === "number" ? b[sortBy.name] : -Infinity) : a[sortBy.name] instanceof Date && b[sortBy.name] instanceof Date ? a[sortBy.name].getTime() - b[sortBy.name].getTime() : ((_columnFilterValue_2 = $9ca15166a9eda0b2$export$5813a5ff74a5f299(a[sortBy.name], false)[0]) !== null && _columnFilterValue_2 !== void 0 ? _columnFilterValue_2 : "").localeCompare((_columnFilterValue_3 = $9ca15166a9eda0b2$export$5813a5ff74a5f299(b[sortBy.name], false)[0]) !== null && _columnFilterValue_3 !== void 0 ? _columnFilterValue_3 : "");
    return ret;
}
$9ca15166a9eda0b2$var$$parcel$exportWildcard($9ca15166a9eda0b2$var$$3d005c8713d7dfb7$exports, $9ca15166a9eda0b2$var$$2d0562c3236da942$exports);
$9ca15166a9eda0b2$var$$parcel$exportWildcard($9ca15166a9eda0b2$var$$3d005c8713d7dfb7$exports, $9ca15166a9eda0b2$var$$2121208b4d86b049$exports);
$9ca15166a9eda0b2$var$$parcel$exportWildcard($9ca15166a9eda0b2$var$$3d005c8713d7dfb7$exports, $9ca15166a9eda0b2$var$$b5ad5f5c6daca351$exports);
$9ca15166a9eda0b2$var$$parcel$exportWildcard($9ca15166a9eda0b2$var$$3d005c8713d7dfb7$exports, $9ca15166a9eda0b2$var$$e186acb03c99a462$exports);

});
parcelRegister("9tqwB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e5b65c9cbae0db9$export$71511d61b312f219; });

var $cv8cX = parcelRequire("cv8cX");
function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cv8cX._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cv8cX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $919ebf39980bf8f3$export$71511d61b312f219; });
function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("2qxEV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1c481e73824c6361$export$71511d61b312f219; });
function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("bLhVg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8901fc92b5563702$export$71511d61b312f219; });

var $a7m7Z = parcelRequire("a7m7Z");
function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $a7m7Z._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("a7m7Z", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $75dbb8f78ee65245$export$71511d61b312f219; });
function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});



parcelRegister("3Znsq", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowserContext", function () { return $779cc220e8a60e25$export$23f42ade2fafade; });

var $7fPBF = parcelRequire("7fPBF");
const $779cc220e8a60e25$export$23f42ade2fafade = /*#__PURE__*/ (0, $7fPBF.createContext)(null);

});

parcelRegister("kHUCl", function(module, exports) {

$parcel$export(module.exports, "ADD_HIERARCHY_NODES", function () { return $533c2bc6f0a8ea3e$export$af63543297d305d3; });
$parcel$export(module.exports, "ADD_SELECTION", function () { return $533c2bc6f0a8ea3e$export$6ba84af01431fe0; });
$parcel$export(module.exports, "REMOVE_SELECTION", function () { return $533c2bc6f0a8ea3e$export$a8fed2245b9507b5; });
$parcel$export(module.exports, "SET_CORPORATE_HIERARCHY", function () { return $533c2bc6f0a8ea3e$export$b00dbe3808fef36f; });
$parcel$export(module.exports, "SET_CURRENT_ACCESS_RIGHTS", function () { return $533c2bc6f0a8ea3e$export$d411c4e5fe6c5871; });
$parcel$export(module.exports, "SET_CURRENT_HIERARCHY", function () { return $533c2bc6f0a8ea3e$export$b96e71bcd0964407; });
$parcel$export(module.exports, "SET_NEW_REPORT_DETAILS", function () { return $533c2bc6f0a8ea3e$export$e847a50d934a402d; });
$parcel$export(module.exports, "SET_NEW_TLF_ITEM_DETAILS", function () { return $533c2bc6f0a8ea3e$export$3f901f85ef0e0322; });
$parcel$export(module.exports, "SET_NEW_TLF_ITEM_DETAILS_VALID", function () { return $533c2bc6f0a8ea3e$export$58d3c4e185e84e9; });
$parcel$export(module.exports, "SET_SELECTIONS", function () { return $533c2bc6f0a8ea3e$export$38e8e7a6c9f10add; });
$parcel$export(module.exports, "UPSERT_HIERARCHY_TLF_ITEM_INDEX", function () { return $533c2bc6f0a8ea3e$export$f7b70b86cfb27269; });
const $533c2bc6f0a8ea3e$export$af63543297d305d3 = "ADD_HIERARCHY_NODES";
const $533c2bc6f0a8ea3e$export$6ba84af01431fe0 = "ADD_SELECTION";
const $533c2bc6f0a8ea3e$export$a8fed2245b9507b5 = "REMOVE_SELECTION";
const $533c2bc6f0a8ea3e$export$b00dbe3808fef36f = "SET_CORPORATE_HIERARCHY";
const $533c2bc6f0a8ea3e$export$d411c4e5fe6c5871 = "SET_CURRENT_ACCESS_RIGHTS";
const $533c2bc6f0a8ea3e$export$b96e71bcd0964407 = "SET_CURRENT_HIERARCHY";
const $533c2bc6f0a8ea3e$export$e847a50d934a402d = "SET_NEW_REPORT_DETAILS";
const $533c2bc6f0a8ea3e$export$3f901f85ef0e0322 = "SET_NEW_TLF_ITEM_DETAILS";
const $533c2bc6f0a8ea3e$export$58d3c4e185e84e9 = "SET_NEW_TLF_ITEM_DETAILS_VALID";
const $533c2bc6f0a8ea3e$export$38e8e7a6c9f10add = "SET_SELECTIONS";
const $533c2bc6f0a8ea3e$export$f7b70b86cfb27269 = "UPSERT_HIERARCHY_TLF_ITEM_INDEX";

});

parcelRegister("cPBZD", function(module, exports) {

$parcel$export(module.exports, "isHierarchyReadDto", function () { return $7550f6f7b748f7a9$export$104ac68fec1129b0; });

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $cXvVz = parcelRequire("cXvVz");
var $04Jlz = parcelRequire("04Jlz");
var $ek4hO = parcelRequire("ek4hO");

var $bDTjJ = parcelRequire("bDTjJ");

var $7Wd8C = parcelRequire("7Wd8C");

var $aEDCh = parcelRequire("aEDCh");

var $7Nk9o = parcelRequire("7Nk9o");

var $48DGs = parcelRequire("48DGs");

var $iqQqc = parcelRequire("iqQqc");

var $UkG2K = parcelRequire("UkG2K");

var $1fqMC = parcelRequire("1fqMC");

var $7hwqv = parcelRequire("7hwqv");
const $7550f6f7b748f7a9$export$104ac68fec1129b0 = (obj)=>{
    // Check object
    if (!obj || typeof obj !== "object") return false;
    // Check basic properties
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.parentTag !== "string") return false;
    if (typeof chkObj.name !== "string") return false;
    if (typeof chkObj.parentId !== "string") return false;
    if (typeof chkObj.taPrefix !== "string") return false;
    if (typeof chkObj.projectCode !== "string") return false;
    if (typeof chkObj.dNumber !== "string") return false;
    if (typeof chkObj.description !== "string") return false;
    if (chkObj.phase && typeof chkObj.phase !== "string") return false;
    if (typeof chkObj.hierarchyTag !== "string") return false;
    if (chkObj.reportType && typeof chkObj.reportType !== "string") return false;
    if (chkObj.status && typeof chkObj.status !== "string") return false;
    if (chkObj.studyStandardsDate && typeof chkObj.studyStandardsDate !== "string") return false;
    if (chkObj.tocMajorVersion && typeof chkObj.tocMajorVersion !== "number") return false;
    if (chkObj.tocMinorVersion && typeof chkObj.tocMinorVersion !== "number") return false;
    if (typeof chkObj.isBackupVersion !== "boolean") return false;
    if (chkObj.originHierarchyId && typeof chkObj.originHierarchyId !== "string") return false;
    if (typeof chkObj.hasClinicalLibrary !== "boolean") return false;
    if (chkObj.analysisMethods !== undefined && (!Array.isArray(chkObj.analysisMethods) || chkObj.analysisMethods.some((x)=>!(0, $ek4hO.isAnalysisMethod)(x)))) return false;
    // Check enums
    if (!Object.values((0, $7Wd8C.eHierarchy)).includes(chkObj.type)) return false;
    if (!Object.values((0, $7Wd8C.eHierarchyLevel)).includes(chkObj.level)) return false;
    // Check arrays
    if (!Array.isArray(chkObj.lists) || chkObj.lists.some((x)=>!(0, $cXvVz.isAioExternalReplacements)(x, (0, $1iDss.isIEditorV3)))) return false;
    if (!Array.isArray(chkObj.domainReplacements) || chkObj.domainReplacements.some((x)=>!(0, $48DGs.isDomainReplacements)(x))) return false;
    if (!Array.isArray(chkObj.rowGroups) || chkObj.rowGroups.some((x)=>!(0, $04Jlz.isAitRowGroupData)(x, (0, $1iDss.isIEditorV3), true))) return false;
    if (!Array.isArray(chkObj.sections) || chkObj.sections.some((x)=>!(0, $1fqMC.isITocSection)(x))) return false;
    if (!Array.isArray(chkObj.singles) || chkObj.singles.some((x)=>!(0, $cXvVz.isAioExternalSingle)(x, (0, $1iDss.isIEditorV3)))) return false;
    if (!Array.isArray(chkObj.domainList) || chkObj.domainList.some((x)=>typeof x !== "string")) return false;
    if (!Array.isArray(chkObj.children) || chkObj.children.some((x)=>!(0, $iqQqc.isHierarchyChildReadDto)(x))) return false;
    if (!Array.isArray(chkObj.history) || chkObj.history.some((x)=>!(0, $UkG2K.isHierarchyHistoryDto)(x))) return false;
    if (chkObj.tocMajorVersionDescriptions && (!Array.isArray(chkObj.tocMajorVersionDescriptions) || chkObj.tocMajorVersionDescriptions.some((x)=>!(0, $7hwqv.isTocMajorVersionDescription)(x)))) return false;
    if (!Array.isArray(chkObj.comments) || chkObj.comments.some((x)=>!(0, $bDTjJ.isCommentReadDto)(x))) return false;
    if (!Array.isArray(chkObj.hierarchyLinks) || chkObj.hierarchyLinks.some((x)=>!(0, $7Nk9o.isHierarchyLink)(x))) return false;
    // Check optional objects
    if (chkObj.clinicalLibrary && !(0, $aEDCh.isClinicalLibraryReadDto)(chkObj.clinicalLibrary)) return false;
    if (chkObj.tlfTags !== undefined && (!Array.isArray(chkObj.tlfTags) || chkObj.tlfTags.some((x)=>!(0, $7Nk9o.isTlfTag)(x)))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("aEDCh", function(module, exports) {

$parcel$export(module.exports, "isClinicalLibraryReadDto", function () { return $50e9b8a23f58b1c6$export$7d89a111a4e504ab; });

var $7Wd8C = parcelRequire("7Wd8C");
const $50e9b8a23f58b1c6$export$7d89a111a4e504ab = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    if (typeof chkObj.id !== "number") return false;
    if (typeof chkObj.hierarchyId !== "string") return false;
    if (!Object.values((0, $7Wd8C.eHierarchyLevel)).includes(chkObj.hierarchyLevel)) return false;
    if (typeof chkObj.corporateId !== "string") return false;
    if (typeof chkObj.taId !== "undefined" && typeof chkObj.taId !== "string") return false;
    if (typeof chkObj.projectId !== "undefined" && typeof chkObj.projectId !== "string") return false;
    if (typeof chkObj.studyId !== "undefined" && typeof chkObj.studyId !== "string") return false;
    if (typeof chkObj.version !== "number") return false;
    // Check arrays (basic check only)
    if (!Array.isArray(chkObj.clinicalDatasets)) return false;
    if (!Array.isArray(chkObj.clinicalCodeLists)) return false;
    if (!Array.isArray(chkObj.clinicalValueLists)) return false;
    if (!Array.isArray(chkObj.clinicalComments)) return false;
    if (!Array.isArray(chkObj.clinicalMethods)) return false;
    if (!Array.isArray(chkObj.clinicalWhereClauses)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("48DGs", function(module, exports) {

$parcel$export(module.exports, "isDomainReplacements", function () { return $63df1a28217a1663$export$232af6082ec77c87; });

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $cXvVz = parcelRequire("cXvVz");
const $63df1a28217a1663$export$232af6082ec77c87 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    // Check lower interface
    if (!(0, $cXvVz.isAioExternalSingle)(chkObj, (0, $1iDss.isIEditorV3))) return false;
    if (typeof chkObj.domain !== "string") return false;
    return true;
};

});

parcelRegister("iqQqc", function(module, exports) {

$parcel$export(module.exports, "isHierarchyChildReadDto", function () { return $aaaad5254b6c34e1$export$20b938e0d0df0cff; });

var $7Wd8C = parcelRequire("7Wd8C");
const $aaaad5254b6c34e1$export$20b938e0d0df0cff = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist and types
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.name !== "string") return false;
    if (typeof chkObj.hierarchyTag !== "string") return false;
    if (typeof chkObj.parentTag !== "string") return false;
    // taPrefix, projectCode and dNumber are optional
    if (chkObj.taPrefix !== undefined && typeof chkObj.taPrefix !== "string") return false;
    if (chkObj.projectCode !== undefined && typeof chkObj.projectCode !== "string") return false;
    if (chkObj.dNumber !== undefined && typeof chkObj.dNumber !== "string") return false;
    if (typeof chkObj.tocMajorVersion !== "undefined" && typeof chkObj.tocMajorVersion !== "number") return false;
    if (typeof chkObj.tocMinorVersion !== "undefined" && typeof chkObj.tocMinorVersion !== "number") return false;
    // Check enums
    if (!Object.values((0, $7Wd8C.eHierarchyLevel)).includes(chkObj.level)) return false;
    if (!Object.values((0, $7Wd8C.eHierarchy)).includes(chkObj.type)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("UkG2K", function(module, exports) {

$parcel$export(module.exports, "isHierarchyHistoryDto", function () { return $cde48c2aae83fc08$export$d854e2c508ca373; });
const $cde48c2aae83fc08$export$d854e2c508ca373 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist and types
    const chkObj = obj;
    if (typeof chkObj.id !== "number") return false;
    if (typeof chkObj.date !== "string") return false;
    if (typeof chkObj.action !== "string") return false;
    if (typeof chkObj.comment !== "string") return false;
    if (typeof chkObj.userId !== "number") return false;
    if (typeof chkObj.userName !== "string") return false;
    // Everything is good
    return true;
};

});

parcelRegister("1fqMC", function(module, exports) {

$parcel$export(module.exports, "isITocSection", function () { return $70013023153c2503$export$49229f7b5bd6f832; });
const $70013023153c2503$export$49229f7b5bd6f832 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.sectionNumber !== "string") return false;
    if (typeof chkObj.sectionLabel !== "string") return false;
    if (typeof chkObj.order !== "number") return false;
    // Everything is good
    return true;
};

});

parcelRegister("7hwqv", function(module, exports) {

$parcel$export(module.exports, "isTocMajorVersionDescription", function () { return $2c51ed8df6c58c17$export$81848127fef549a3; });
const $2c51ed8df6c58c17$export$81848127fef549a3 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    if (typeof chkObj.tocMajorVersion !== "number") return false;
    if (typeof chkObj.description !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("fhe29", function(module, exports) {

$parcel$export(module.exports, "loadHierarchyTlfs", function () { return $e2d1db5e341ff73c$export$3ad0469119ed0599; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $e2d1db5e341ff73c$export$3ad0469119ed0599 = async (backEndUrl, hierarchy, controller)=>{
    let url = `${backEndUrl}TlfItems/Hierarchy/${hierarchy.hierarchyId}`;
    if (hierarchy.parentTag) url += `?parentTag=${hierarchy.parentTag}`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load hierarchy tlfs failed", error);
    }
};

});

parcelRegister("dP8dW", function(module, exports) {

$parcel$export(module.exports, "deleteTlf", function () { return $242a15ddcc5be020$export$e7f0fa1c6d367608; });

var $5ar9z = parcelRequire("5ar9z");
const $242a15ddcc5be020$export$e7f0fa1c6d367608 = async (backEndUrl, id)=>{
    return await (0, $5ar9z.deleteData)(`${backEndUrl}TlfItems/${id}`);
};

});
parcelRegister("5ar9z", function(module, exports) {

$parcel$export(module.exports, "deleteData", function () { return $f53507dd7a45100e$export$759f93bbe12f0fab; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $f53507dd7a45100e$export$759f93bbe12f0fab = async (url)=>{
    // Get data
    try {
        await (0, $a04va.default).delete(url);
        // Return successful result
        return {
            success: true
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Delete failed", error);
    }
};

});


parcelRegister("74iEK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $525760de6f45ee4a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $525760de6f45ee4a$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $525760de6f45ee4a$var$_extends() {
    return $525760de6f45ee4a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $525760de6f45ee4a$var$_extends.apply(null, arguments);
}
function $525760de6f45ee4a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $525760de6f45ee4a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $525760de6f45ee4a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $525760de6f45ee4a$var$ArrowRepeat = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $525760de6f45ee4a$var$_objectWithoutProperties(_ref, $525760de6f45ee4a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $525760de6f45ee4a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-repeat',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
    }));
});
$525760de6f45ee4a$var$ArrowRepeat.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $525760de6f45ee4a$export$2e2bcd8739ae039 = $525760de6f45ee4a$var$ArrowRepeat;

});

parcelRegister("2i5hM", function(module, exports) {

$parcel$export(module.exports, "RemoveModal", function () { return $ad7f0e98a2a84291$export$5a5d118b9e96c9dd; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $d8uJi = parcelRequire("d8uJi");
var $kYoG1 = parcelRequire("kYoG1");
const $ad7f0e98a2a84291$export$5a5d118b9e96c9dd = ({ id: id, show: show, beingRemovedType: beingRemovedType, beingRemovedName: beingRemovedName, onOk: onOk, onCancel: onCancel })=>{
    // Render modal
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default), {
            id: id,
            show: show,
            onHide: onCancel,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                            children: [
                                "Remove ",
                                beingRemovedType
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                                        children: "Are you sure you want to remove"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                            children: [
                                                beingRemovedName,
                                                "?"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                                    className: "d-flex justify-content-center",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                        id: `${id}-ok`,
                                        variant: "danger",
                                        "aria-label": `Remove ${beingRemovedName}`,
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onOk();
                                        },
                                        children: "Remove"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Footer, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: `${id}-cancel`,
                        "aria-label": "Cancel",
                        variant: "secondary",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onCancel();
                        },
                        children: "Cancel"
                    })
                })
            ]
        })
    });
};
$ad7f0e98a2a84291$export$5a5d118b9e96c9dd.displayName = "RemoveModal";

});

parcelRegister("ijJl3", function(module, exports) {

$parcel$export(module.exports, "getTemplateHeaders", function () { return $9dedcf936410cecc$export$e84f728d34e83276; });

var $7Wd8C = parcelRequire("7Wd8C");

var $2sspk = parcelRequire("2sspk");

var $yudD4 = parcelRequire("yudD4");

var $25OuR = parcelRequire("25OuR");
const $9dedcf936410cecc$export$e84f728d34e83276 = (showSearchResults, showTocSearchResults, hierarchyLevel)=>showSearchResults ? (0, $2sspk.SearchResultsHeaders) : showTocSearchResults ? (0, $2sspk.SearchTocHeaders) : hierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report ? (0, $25OuR.TocHeaders) : (0, $yudD4.templateHeaders)(hierarchyLevel);

});
parcelRegister("2sspk", function(module, exports) {

$parcel$export(module.exports, "SearchResultsHeaders", function () { return $8582a5da8679ac37$export$647afdd8d6828a96; });
$parcel$export(module.exports, "SearchTocHeaders", function () { return $8582a5da8679ac37$export$3505d8dcc63ab819; });

var $drJNc = parcelRequire("drJNc");

var $kmx90 = parcelRequire("kmx90");

var $8GoVy = parcelRequire("8GoVy");

var $9owz3 = parcelRequire("9owz3");

var $cSnif = parcelRequire("cSnif");

var $eCGLT = parcelRequire("eCGLT");
const $8582a5da8679ac37$export$647afdd8d6828a96 = [
    {
        name: "azsolIdVersion",
        label: "AZSOL ID/Version",
        width: "130px",
        sortFn: (0, $drJNc.simpleTableSortFn),
        searchFn: (0, $eCGLT.searchTemplatesWithText),
        filterOutFn: (0, $cSnif.filterTemplates),
        renderFn: (0, $8GoVy.TlfItemTableLinkCell),
        canColumnFilter: true
    },
    {
        name: "releaseStatus",
        label: "Status",
        width: "80px",
        sortFn: (0, $drJNc.simpleTableSortFn),
        canColumnFilter: true,
        renderFn: (0, $kmx90.RenderReleaseStatus)
    },
    {
        name: "tlfTagValues",
        label: "Tags",
        width: "200px",
        canColumnFilter: true,
        renderFn: (0, $9owz3.TlfItemTableTagsCell)
    },
    {
        name: "tocLabel",
        label: "Title",
        width: "600px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    },
    {
        name: "additionalInformation",
        label: "Additional information",
        width: "800px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    }
];
const $8582a5da8679ac37$export$3505d8dcc63ab819 = [
    {
        name: "taPrefix",
        label: "TA",
        width: "100px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    },
    {
        name: "projectCode",
        label: "Project",
        width: "100px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    },
    {
        name: "dNumber",
        label: "D Number",
        width: "100px",
        sortFn: (0, $drJNc.simpleTableSortFn),
        canColumnFilter: true,
        searchFn: (0, $eCGLT.searchTemplatesWithText)
    },
    {
        name: "primaryHierarchyName",
        label: "Report",
        width: "200px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    },
    {
        name: "tlfTagValues",
        label: "Tags",
        width: "200px",
        canColumnFilter: true,
        renderFn: (0, $9owz3.TlfItemTableTagsCell)
    },
    {
        name: "tocNumber",
        label: "ToC Number",
        width: "100px",
        sortFn: (0, $drJNc.simpleTableSortFn),
        renderFn: (0, $8GoVy.TlfItemTableLinkCell),
        canColumnFilter: true
    },
    {
        name: "tocLabel",
        label: "Title",
        width: "600px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    },
    {
        name: "additionalInformation",
        label: "Additional information",
        width: "800px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    },
    {
        name: "lastUpdatedFromHistory",
        label: "Last updated",
        width: "120px",
        canColumnFilter: true,
        sortFn: (0, $drJNc.simpleTableSortFn)
    }
];

});
parcelRegister("kmx90", function(module, exports) {

$parcel$export(module.exports, "RenderReleaseStatus", function () { return $899e26a540d48d68$export$bac764dd5a399843; });

var $bbzbN = parcelRequire("bbzbN");

var $7Wd8C = parcelRequire("7Wd8C");
const $899e26a540d48d68$export$bac764dd5a399843 = ({ rowData: rowData })=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "overflow-hidden",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            children: rowData.primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report ? "" : rowData.releaseStatus === (0, $7Wd8C.eReleaseStatus).ReleasePending ? (0, $7Wd8C.eReleaseStatus).Draft : [
                (0, $7Wd8C.eReleaseStatus).DecommissingPending,
                (0, $7Wd8C.eReleaseStatus).RetirePending
            ].includes(rowData.releaseStatus) ? (0, $7Wd8C.eReleaseStatus).Valid : rowData.releaseStatus
        })
    });
$899e26a540d48d68$export$bac764dd5a399843.displayName = "RenderReleaseStatus";

});

parcelRegister("8GoVy", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableLinkCell", function () { return $82c7c180302a5a86$export$1a7099def93c1d51; });

var $bbzbN = parcelRequire("bbzbN");

var $7Wd8C = parcelRequire("7Wd8C");

var $j96Rr = parcelRequire("j96Rr");
const $82c7c180302a5a86$export$1a7099def93c1d51 = ({ rowData: rowData })=>{
    const searchParams = rowData.searchParams;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
        id: `tlfitemtable-link-${rowData.id}`,
        to: rowData.primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report ? `/TlfDesigner/${rowData.id}${searchParams ? `?${searchParams.toString()}` : ""}` : `/TlfDesigner/${rowData.azsolId}/${rowData.version}${searchParams ? `?${searchParams.toString()}` : ""}`,
        children: rowData.primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report ? `${rowData.tocNumber ?? "!!toc!! not set"}` : `${rowData.azsolId}/${rowData.version}`
    });
};
$82c7c180302a5a86$export$1a7099def93c1d51.displayName = "TlfItemTableLinkCell";

});

parcelRegister("9owz3", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableTagsCell", function () { return $e8d2c20a5620dd32$export$2979fe2b0cabb035; });

var $bbzbN = parcelRequire("bbzbN");

var $bNVAi = parcelRequire("bNVAi");
const $e8d2c20a5620dd32$export$2979fe2b0cabb035 = ({ rowData: rowData })=>{
    const tags = Array.isArray(rowData.tlfTags) ? rowData.tlfTags : [];
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "tlf-tags-cell",
        children: tags.map((tag)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $bNVAi.default), {
                bg: "secondary",
                className: "me-1",
                children: tag.tagValue
            }, tag.tagId || tag.tagValue))
    });
};
$e8d2c20a5620dd32$export$2979fe2b0cabb035.displayName = "TlfItemTableTagsCell";

});

parcelRegister("cSnif", function(module, exports) {

$parcel$export(module.exports, "filterTemplates", function () { return $20b21876017e8e7b$export$883cc5315f212021; });

var $7Wd8C = parcelRequire("7Wd8C");
const $20b21876017e8e7b$export$883cc5315f212021 = (row)=>[
        (0, $7Wd8C.eReleaseStatus).Retired,
        (0, $7Wd8C.eReleaseStatus).Decommissioned
    ].includes(row.releaseStatus);

});

parcelRegister("eCGLT", function(module, exports) {

$parcel$export(module.exports, "searchTemplatesWithText", function () { return $ed771e3e28d15ce9$export$6a11aa7c47593815; });
const $ed771e3e28d15ce9$export$6a11aa7c47593815 = (row, searchText)=>{
    const needle = searchText.toLowerCase().trim();
    return `${row.azsolIdVersion ?? ""}`.toLowerCase().includes(needle) || `${row.title ?? ""}`.toLowerCase().includes(needle) || `${row.tocLabel ?? ""}`.toLowerCase().includes(needle) || Array.isArray(row.tlfTags) && row.tlfTags.some((tag)=>tag.tagValue.toLowerCase().includes(needle));
};

});


parcelRegister("yudD4", function(module, exports) {

$parcel$export(module.exports, "templateHeaders", function () { return $ff4689ce4098cfea$export$c3aa695d49f838b0; });

var $drJNc = parcelRequire("drJNc");

var $7Wd8C = parcelRequire("7Wd8C");

var $leOyb = parcelRequire("leOyb");

var $kmx90 = parcelRequire("kmx90");

var $bV4hN = parcelRequire("bV4hN");

var $8GoVy = parcelRequire("8GoVy");

var $9owz3 = parcelRequire("9owz3");

var $99edv = parcelRequire("99edv");

var $cSnif = parcelRequire("cSnif");

var $eCGLT = parcelRequire("eCGLT");
/** Hierarchy levels that show the parent template column. */ const $ff4689ce4098cfea$var$parentTemplateLevels = [
    (0, $7Wd8C.eHierarchyLevel).TA,
    (0, $7Wd8C.eHierarchyLevel).Project
];
/** Hierarchy levels that show the versions available column. */ const $ff4689ce4098cfea$var$versionsLevels = [
    (0, $7Wd8C.eHierarchyLevel).Corporate
];
const $ff4689ce4098cfea$export$c3aa695d49f838b0 = (hierarchyLevel)=>[
        {
            name: "azsolIdVersion",
            label: "AZSOL ID/Version",
            width: "110px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn),
            searchFn: (0, $eCGLT.searchTemplatesWithText),
            filterOutFn: (0, $cSnif.filterTemplates),
            renderFn: (0, $8GoVy.TlfItemTableLinkCell)
        },
        {
            name: "tlfTagValues",
            label: "Tags",
            width: "200px",
            canColumnFilter: true,
            renderFn: (0, $9owz3.TlfItemTableTagsCell)
        },
        {
            name: "flags",
            label: "",
            width: "50px",
            renderFn: (0, $bV4hN.TlfItemTableFlags)
        },
        {
            name: "domain",
            label: "Domain",
            width: "100px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn)
        },
        ...$ff4689ce4098cfea$var$parentTemplateLevels.includes(hierarchyLevel) ? [
            {
                name: "parentTemplate",
                label: "Parent Template",
                width: "100px",
                canColumnFilter: true,
                renderFn: (0, $leOyb.ParentTemplateLink),
                sortFn: (0, $drJNc.simpleTableSortFn)
            }
        ] : [],
        ...$ff4689ce4098cfea$var$versionsLevels.includes(hierarchyLevel) ? [
            {
                name: "taVersionsAvailable",
                label: "TA Versions Available",
                width: "200px",
                canColumnFilter: true,
                renderFn: (0, $99edv.TlfItemTaVersionsLinks)
            }
        ] : [],
        {
            name: "tocLabel",
            label: "Title",
            width: "550px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn)
        },
        {
            name: "type",
            label: "Type",
            width: "80px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn)
        },
        {
            name: "releaseStatus",
            label: "Status",
            width: "80px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn),
            renderFn: (0, $kmx90.RenderReleaseStatus)
        },
        {
            name: "releaseDate",
            label: "Release date",
            width: "100px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn)
        },
        {
            name: "decommissionDate",
            label: "Decommission date",
            width: "100px",
            canColumnFilter: true,
            sortFn: (0, $drJNc.simpleTableSortFn)
        },
        {
            name: "additionalInformation",
            label: "Additional information",
            width: "150px",
            canColumnFilter: true
        }
    ];

});
parcelRegister("leOyb", function(module, exports) {

$parcel$export(module.exports, "ParentTemplateLink", function () { return $360f3c2c642b4dbb$export$4ae481549536e242; });

var $bbzbN = parcelRequire("bbzbN");

var $7Wd8C = parcelRequire("7Wd8C");

var $8GoVy = parcelRequire("8GoVy");
const $360f3c2c642b4dbb$export$4ae481549536e242 = (props)=>{
    const relationships = props.rowData["relationships"];
    const basedOnLink = relationships?.findLast((r)=>r.linkType === (0, $7Wd8C.eLinkType).BasedOn);
    return basedOnLink ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8GoVy.TlfItemTableLinkCell), {
        ...props,
        rowData: {
            ...basedOnLink,
            primaryHierarchyLevel: basedOnLink.linkLocation?.linkLevel
        }
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
};
$360f3c2c642b4dbb$export$4ae481549536e242.displayName = "ParentTemplateLink";

});

parcelRegister("bV4hN", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableFlags", function () { return $2c9f8ee70b4488e3$export$972db95c9f1ccfe1; });

var $bbzbN = parcelRequire("bbzbN");

var $7Wd8C = parcelRequire("7Wd8C");

var $7Nk9o = parcelRequire("7Nk9o");

var $7fPBF = parcelRequire("7fPBF");

var $kjMKy = parcelRequire("kjMKy");
var $sHWPE = parcelRequire("sHWPE");
var $4tHM3 = parcelRequire("4tHM3");

var $20AtX = parcelRequire("20AtX");
const $2c9f8ee70b4488e3$export$972db95c9f1ccfe1 = ({ rowData: rowData })=>{
    const tlfItemTableContext = (0, $7fPBF.useContext)((0, $20AtX.TlfItemTableContext));
    const [, startTransition] = (0, $7fPBF.useTransition)();
    const thisRowData = (0, $7Nk9o.isTlfItemIndexReadDto)(rowData) ? rowData : null;
    const [renderTime, setRenderTime] = (0, $7fPBF.useState)(0);
    (0, $7fPBF.useEffect)(()=>{
        // Set current time after mount to avoid calling an impure function during render.
        // Added as useEffect to statisfy React v19's rules of hooks.
        startTransition(()=>setRenderTime(Date.now()));
    }, []);
    return !thisRowData ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        style: {
            width: "100%"
        },
        className: "d-flex justify-content-center",
        children: [
            thisRowData.releaseStatus === (0, $7Wd8C.eReleaseStatus).Valid && thisRowData.releaseDate && new Date(thisRowData.releaseDate).getTime() >= renderTime - 2419200000 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $sHWPE.default), {
                title: "New",
                "aria-label": "New item"
            }),
            [
                (0, $7Wd8C.eReleaseStatus).Valid,
                (0, $7Wd8C.eReleaseStatus).DecommissingPending
            ].includes(thisRowData.releaseStatus) && thisRowData.relationships.filter((r)=>r.linkType === (0, $7Wd8C.eLinkType).Successor).length > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kjMKy.default), {
                title: "New draft exists",
                "aria-label": "New draft exists"
            }),
            tlfItemTableContext.canDelete && tlfItemTableContext.deleteClick && [
                (0, $7Wd8C.eReleaseStatus).Draft,
                (0, $7Wd8C.eReleaseStatus).ReleasePending
            ].includes(thisRowData.releaseStatus) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tHM3.default), {
                title: "Delete",
                "aria-label": "Delete item",
                color: "var(--bs-danger)",
                onClick: ()=>tlfItemTableContext.deleteClick && tlfItemTableContext.deleteClick(rowData.id, rowData.azsolId, rowData.version)
            })
        ]
    });
};
$2c9f8ee70b4488e3$export$972db95c9f1ccfe1.displayName = "TlfItemTableFlags";

});
parcelRegister("kjMKy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecab65ba291a21ca$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $ecab65ba291a21ca$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $ecab65ba291a21ca$var$_extends() {
    return $ecab65ba291a21ca$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ecab65ba291a21ca$var$_extends.apply(null, arguments);
}
function $ecab65ba291a21ca$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ecab65ba291a21ca$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ecab65ba291a21ca$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ecab65ba291a21ca$var$HourglassSplit = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $ecab65ba291a21ca$var$_objectWithoutProperties(_ref, $ecab65ba291a21ca$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $ecab65ba291a21ca$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-hourglass-split',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"
    }));
});
$ecab65ba291a21ca$var$HourglassSplit.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $ecab65ba291a21ca$export$2e2bcd8739ae039 = $ecab65ba291a21ca$var$HourglassSplit;

});

parcelRegister("sHWPE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0564b4c7151f8254$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $0564b4c7151f8254$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $0564b4c7151f8254$var$_extends() {
    return $0564b4c7151f8254$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0564b4c7151f8254$var$_extends.apply(null, arguments);
}
function $0564b4c7151f8254$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0564b4c7151f8254$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0564b4c7151f8254$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0564b4c7151f8254$var$Star = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $0564b4c7151f8254$var$_objectWithoutProperties(_ref, $0564b4c7151f8254$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $0564b4c7151f8254$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-star',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"
    }));
});
$0564b4c7151f8254$var$Star.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $0564b4c7151f8254$export$2e2bcd8739ae039 = $0564b4c7151f8254$var$Star;

});

parcelRegister("4tHM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $342bd37d54968caa$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $342bd37d54968caa$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $342bd37d54968caa$var$_extends() {
    return $342bd37d54968caa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $342bd37d54968caa$var$_extends.apply(null, arguments);
}
function $342bd37d54968caa$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $342bd37d54968caa$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $342bd37d54968caa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $342bd37d54968caa$var$Trash = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $342bd37d54968caa$var$_objectWithoutProperties(_ref, $342bd37d54968caa$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $342bd37d54968caa$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-trash',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
    }));
});
$342bd37d54968caa$var$Trash.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $342bd37d54968caa$export$2e2bcd8739ae039 = $342bd37d54968caa$var$Trash;

});


parcelRegister("99edv", function(module, exports) {

$parcel$export(module.exports, "TlfItemTaVersionsLinks", function () { return $ecb86a32c9011f6e$export$80f06044444f0845; });

var $bbzbN = parcelRequire("bbzbN");

var $7Wd8C = parcelRequire("7Wd8C");

var $8GoVy = parcelRequire("8GoVy");
const $ecb86a32c9011f6e$export$80f06044444f0845 = (props)=>{
    const links = props.rowData["relationships"]?.filter((r)=>r.linkType === (0, $7Wd8C.eLinkType).HasVersion && r.linkLocation?.linkLevel === (0, $7Wd8C.eHierarchyLevel).TA).sort((a, b)=>`${a.azsolId}/${a.version}`.localeCompare(`${b.azsolId}/${b.version}`));
    return links && links.length > 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: "d-inline-flex flex-wrap align-items-center",
        children: links.map((link, index)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                className: "d-inline-flex align-items-center",
                children: [
                    index > 0 && ", ",
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8GoVy.TlfItemTableLinkCell), {
                        ...props,
                        rowData: {
                            ...link,
                            id: `${props.rowData.id}-${link.linkId}`,
                            primaryHierarchyLevel: link.linkLocation?.linkLevel
                        }
                    })
                ]
            }, link.linkId))
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
};
$ecb86a32c9011f6e$export$80f06044444f0845.displayName = "TlfItemVersionsLinks";

});


parcelRegister("25OuR", function(module, exports) {

$parcel$export(module.exports, "TocHeaders", function () { return $24793f27a0e89712$export$aa09c984a793627c; });

var $drJNc = parcelRequire("drJNc");

var $jfDHD = parcelRequire("jfDHD");

var $8GoVy = parcelRequire("8GoVy");

var $9owz3 = parcelRequire("9owz3");
const $24793f27a0e89712$export$aa09c984a793627c = [
    {
        name: "tocNumber",
        label: "Number",
        width: "110px",
        // Sort TOC items by number using custom sort function.
        sortFn: (a, b)=>(0, $jfDHD.tocSort)(a.tocNumber, b.tocNumber),
        // Search TOC items by number, label, copied-from template ID, or tags.
        searchFn: (row, searchText)=>{
            const normalised = searchText.toLowerCase().trim();
            const matchesTextFields = row.tocNumber?.toLowerCase().includes(normalised) || row.tocLabel?.toLowerCase().includes(normalised) || row.tlfCopiedFromLink?.azsolId?.toLowerCase().includes(normalised);
            const matchesTags = Array.isArray(row.tlfTags) && row.tlfTags.some((tag)=>tag.tagValue.toLowerCase().includes(normalised));
            return (matchesTextFields ?? false) || matchesTags;
        },
        canColumnFilter: true,
        renderFn: (0, $8GoVy.TlfItemTableLinkCell)
    },
    {
        name: "tlfTagValues",
        label: "Tags",
        width: "200px",
        canColumnFilter: true,
        renderFn: (0, $9owz3.TlfItemTableTagsCell)
    },
    {
        name: "tocLabel",
        label: "Title",
        width: "600px",
        sortFn: (0, $drJNc.simpleTableSortFn),
        canColumnFilter: true
    }
];

});


parcelRegister("2xmRz", function(module, exports) {

$parcel$export(module.exports, "mapTlfItemTableRow", function () { return $f47736e39e72e69f$export$e94ec2ae64671f9c; });

var $7Wd8C = parcelRequire("7Wd8C");

var $53GsP = parcelRequire("53GsP");
const $f47736e39e72e69f$export$e94ec2ae64671f9c = (row)=>{
    const basedOnTemplate = (0, $53GsP.getBasedOnRelationship)(row);
    return {
        ...row,
        azsolIdVersion: `${row.azsolId}/${row.version}`,
        tlfTagValues: row.tlfTags?.map((tag)=>tag.tagValue) ?? [],
        parentTemplate: basedOnTemplate ? `${basedOnTemplate.azsolId}/${basedOnTemplate.version}` : "",
        taVersionsAvailable: row.relationships.filter((r)=>r.linkType === (0, $7Wd8C.eLinkType).HasVersion).map((r)=>`${r.azsolId}/${r.version}`)
    };
};

});
parcelRegister("53GsP", function(module, exports) {

$parcel$export(module.exports, "getBasedOnRelationship", function () { return $9f2a45bc03401163$export$131767e367a48189; });

var $7Wd8C = parcelRequire("7Wd8C");
const $9f2a45bc03401163$export$131767e367a48189 = (tlfItem)=>{
    const basedOnLinks = tlfItem?.relationships?.filter((r)=>r.linkType === (0, $7Wd8C.eLinkType).BasedOn) ?? [];
    if (basedOnLinks.length === 0) return undefined;
    return basedOnLinks.at(-1);
};

});





parcelRegister("hhVe3", function(module, exports) {

$parcel$export(module.exports, "HierarchyLinks", function () { return $3086e6896cd9dab3$export$e5a43fec3653b666; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $6yajm = parcelRequire("6yajm");

var $grLpx = parcelRequire("grLpx");

var $3uLZ3 = parcelRequire("3uLZ3");

var $cRPPh = parcelRequire("cRPPh");

var $jztSD = parcelRequire("jztSD");

var $5jUws = parcelRequire("5jUws");
const $3086e6896cd9dab3$export$e5a43fec3653b666 = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const showStudyTree = hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5jUws.TypeLinks), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6yajm.ArsLinks), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {
                className: "mt-3"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3uLZ3.ParentLink), {}),
            showStudyTree ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jztSD.StudyTree), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $grLpx.ChildLinks), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cRPPh.RecentLinks), {})
        ]
    });
};
$3086e6896cd9dab3$export$e5a43fec3653b666.displayName = "HierarchyLinks";

});
parcelRegister("6yajm", function(module, exports) {

$parcel$export(module.exports, "ArsLinks", function () { return $102d114f295ba323$export$8df58c370553035e; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $j96Rr = parcelRequire("j96Rr");
const $102d114f295ba323$export$8df58c370553035e = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    // Only show ARS links when arsEnabled is true
    const arsEnabled = hierarchyContext?.hierarchy?.arsEnabled;
    return !hierarchyContext?.hierarchy || !arsEnabled ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                    id: "hierarchylinks-analysis-methods",
                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/AnalysisMethods`,
                    children: "Analysis methods"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                    id: "hierarchylinks-analysis-sets",
                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/AnalysisSets`,
                    children: "Analysis sets"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                    id: "hierarchylinks-data-subsets",
                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/DataSubsets`,
                    children: "Data subsets"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                    id: "hierarchylinks-grouping-factors",
                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/GroupingFactors`,
                    children: "Grouping factors"
                })
            })
        ]
    });
};
$102d114f295ba323$export$8df58c370553035e.displayName = "ArsLinks";

});

parcelRegister("grLpx", function(module, exports) {

$parcel$export(module.exports, "ChildLinks", function () { return $e20b4321d5accdf6$export$438f839f575eb05a; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");
var $9eqKP = parcelRequire("9eqKP");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $1ddQW = parcelRequire("1ddQW");

var $etHEK = parcelRequire("etHEK");

var $7fPBF = parcelRequire("7fPBF");

var $eEIPt = parcelRequire("eEIPt");

var $j2AuU = parcelRequire("j2AuU");
const $e20b4321d5accdf6$export$438f839f575eb05a = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const [pending, startTransition] = (0, $7fPBF.useTransition)();
    const [corpRequest, setCorpRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [corp, setCorp] = (0, $7fPBF.useState)(null);
    const getCorporate = (0, $7fPBF.useEffectEvent)(async ()=>{
        const request = await (0, $30Ra3.loadWrapper)((0, $1ddQW.loadHierarchy), {
            hierarchyName: "Corporate"
        }, corpRequest, setCorpRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) startTransition(()=>setCorp(request.data));
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!hierarchyContext?.hierarchy) getCorporate();
    }, [
        hierarchyContext?.hierarchy
    ]);
    const children = hierarchyContext && hierarchyContext.hierarchy ? hierarchyContext.hierarchy.children : corp?.children;
    const nlevel = hierarchyContext?.hierarchy ? (0, $etHEK.childHierarchyLevel)(hierarchyContext.hierarchy) : (0, $7Wd8C.eHierarchyLevel).TA;
    return hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            (corpRequest.requesting || pending) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {}),
            !children || children.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                children: [
                    "No",
                    nlevel === (0, $7Wd8C.eHierarchyLevel).Study ? " Studies" : ` ${nlevel}s`
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                        children: nlevel
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "small-scrollbar",
                        style: {
                            maxHeight: "400px"
                        },
                        children: children.sort((a, b)=>a.name.localeCompare(b.name)).map((h, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $j2AuU.ChildLink), {
                                hierarchy: h
                            }, i))
                    })
                ]
            }),
            hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).CreateHierarchy) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eEIPt.AddHierarchyButton), {}, hierarchyContext.hierarchy?.id),
            /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {})
        ]
    });
};
$e20b4321d5accdf6$export$438f839f575eb05a.displayName = "ChildLinks";

});
parcelRegister("etHEK", function(module, exports) {

$parcel$export(module.exports, "childHierarchyLevel", function () { return $d76d1e251d0bfd3a$export$4c246000a1b0489b; });

var $7Wd8C = parcelRequire("7Wd8C");
const $d76d1e251d0bfd3a$export$4c246000a1b0489b = (hierarchy)=>{
    switch(hierarchy.level){
        case (0, $7Wd8C.eHierarchyLevel).TopLevel:
            return (0, $7Wd8C.eHierarchyLevel).Corporate;
        case (0, $7Wd8C.eHierarchyLevel).Corporate:
            return (0, $7Wd8C.eHierarchyLevel).TA;
        case (0, $7Wd8C.eHierarchyLevel).TA:
            return (0, $7Wd8C.eHierarchyLevel).Project;
        case (0, $7Wd8C.eHierarchyLevel).Project:
            return (0, $7Wd8C.eHierarchyLevel).Study;
        case (0, $7Wd8C.eHierarchyLevel).Study:
            return (0, $7Wd8C.eHierarchyLevel).Report;
        case (0, $7Wd8C.eHierarchyLevel).Report:
            return null;
    }
};

});

parcelRegister("eEIPt", function(module, exports) {

$parcel$export(module.exports, "AddHierarchyButton", function () { return $cfb4c66593b93062$export$9eb3c1ed3eac6f97; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");
var $9eqKP = parcelRequire("9eqKP");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $9Jgpw = parcelRequire("9Jgpw");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $4mSD2 = parcelRequire("4mSD2");

var $etHEK = parcelRequire("etHEK");

var $2pUHr = parcelRequire("2pUHr");

var $7fPBF = parcelRequire("7fPBF");

var $aNfx0 = parcelRequire("aNfx0");
var $6dv4K = parcelRequire("6dv4K");

var $idCYl = parcelRequire("idCYl");

var $9U0Qm = parcelRequire("9U0Qm");
const $cfb4c66593b93062$export$9eb3c1ed3eac6f97 = ()=>{
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("add-hierarchy-button");
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const [showAddModal, setShowAddModal] = (0, $7fPBF.useState)(false);
    // Current hierarchy information
    const nLevel = hierarchyContext?.hierarchy && (0, $etHEK.childHierarchyLevel)(hierarchyContext.hierarchy);
    const isReportLevel = nLevel === (0, $7Wd8C.eHierarchyLevel).Report;
    // Modal inputs
    const modalInputs = hierarchyContext && nLevel ? [
        {
            inputLabel: "Name",
            inputName: "Name",
            validCondition: (0, $2pUHr.hierarchyNameValidator),
            validationRequestUrl: appSettings.backEndUrl,
            validationOptions: {
                existingValues: hierarchyContext.hierarchy?.children.map((c)=>c.name) ?? // istanbul ignore next
                [],
                otherValues: {
                    level: nLevel,
                    parentTag: hierarchyContext.hierarchy?.hierarchyTag ?? // istanbul ignore next
                    ""
                }
            }
        },
        ...appSettings.defaultLevelProperties[nLevel].filter((h)=>h.mandatory).map((p)=>{
            // Always pass the parent hierarchy tag and sibling tags to scope uniqueness
            const parentTag = hierarchyContext.hierarchy?.hierarchyTag ?? // istanbul ignore next
            "";
            return {
                inputLabel: p.label,
                inputName: p.key,
                validCondition: p.validCondition,
                validationOptions: {
                    existingValues: hierarchyContext.hierarchy?.children.map((c)=>c.hierarchyTag) ?? // istanbul ignore next
                    [],
                    otherValues: {
                        parentTag: parentTag
                    }
                },
                validationRequestUrl: appSettings.backEndUrl
            };
        })
    ] : null;
    // Save request state
    const [saveRequest, setSaveRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Add a new child hierarchy beneath the current hierarchy.
   *
   * @param newChildData - Keyed data for the new child hierarchy
   */ const addChild = async (newChildData)=>{
        /* istanbul ignore else */ if (hierarchyContext && hierarchyContext.hierarchy && nLevel) {
            setShowAddModal(false);
            // Create new hierarchy
            const newChild = {
                parentId: hierarchyContext.hierarchy.id,
                parentParentTag: hierarchyContext.hierarchy.parentTag,
                name: newChildData.Name.trim(),
                hierarchyTag: isReportLevel ? `${hierarchyContext.hierarchy.hierarchyTag}/Report/${newChildData.Name.trim()}` : newChildData[appSettings.defaultLevelProperties[nLevel]?.find((p)=>p.type === "hierarchyTag")?.key ?? // istanbul ignore next
                ""] ?? // istanbul ignore next
                crypto.randomUUID(),
                description: isReportLevel && newChildData.Description ? newChildData.Description.trim() : "",
                reportType: isReportLevel && newChildData["ReportType"] ? newChildData["ReportType"].trim() : ""
            };
            // Create new node
            const response = await (0, $30Ra3.loadWrapper)((0, $4mSD2.saveHierarchyData), newChild, saveRequest, setSaveRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (response?.success) {
                hierarchyContext.dispatch({
                    operation: (0, $9Jgpw.ADD_HIERARCHY_NODES),
                    hierarchyNodes: [
                        response.data
                    ]
                });
                hierarchyContext.dispatch({
                    operation: (0, $9Jgpw.SET_HIERARCHY_ID),
                    hierarchyId: response.data.id
                });
                navigate(`${(0, $wPq5H.getHierarchyBaseUrl)(response.data)}`);
            }
        }
    };
    return !hierarchyContext || !modalInputs ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: hierarchyContext.accessRights?.includes((0, $7Wd8C.eAccessRights).CreateHierarchy) && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "position-relative",
            children: [
                saveRequest.requesting && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9eqKP.PauseCover), {
                    text: "Saving..."
                }),
                saveRequest.error && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aNfx0.default), {
                            className: "pr-1"
                        }),
                        saveRequest.errorText ?? // istanbul ignore next
                        "Error adding hierarchy"
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    id: "hierarchylinks-add",
                    onClick: ()=>{
                        setShowAddModal(true);
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
                            id: "hierarchylinks-add-icon",
                            "aria-label": `Add new ${nLevel}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                            style: {
                                marginLeft: "0.5rem"
                            },
                            children: [
                                "Add ",
                                nLevel
                            ]
                        })
                    ]
                }),
                showAddModal && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                    children: isReportLevel ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9U0Qm.NewReportModal), {
                        show: showAddModal,
                        onOk: addChild,
                        onCancel: ()=>{
                            setShowAddModal(false);
                        }
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $idCYl.WordModal), {
                        id: "hierarchylinks-add-modal",
                        show: showAddModal,
                        title: `Add new ${nLevel}`,
                        buttonLabel: "Add",
                        onOk: addChild,
                        onCancel: ()=>{
                            setShowAddModal(false);
                        },
                        inputs: modalInputs
                    })
                })
            ]
        })
    });
};
$cfb4c66593b93062$export$9eb3c1ed3eac6f97.displayName = "AddHierarchyButton";

});
parcelRegister("4mSD2", function(module, exports) {

$parcel$export(module.exports, "saveHierarchyData", function () { return $e4d9597d8c48f4fe$export$6c3d826539cabf49; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $e4d9597d8c48f4fe$export$6c3d826539cabf49 = async (backEndUrl, hierarchy, controller)=>{
    let url;
    let method;
    if ((hierarchy.id ?? "") !== "") {
        url = `${backEndUrl}Hierarchy/${hierarchy.id}`;
        method = "PUT";
    } else {
        url = `${backEndUrl}Hierarchy`;
        method = "POST";
    }
    // Set headers, send method
    const headers = {
        "Content-Type": "application/json;charset=utf-8"
    };
    // Send data
    try {
        const response = await (0, $a04va.default).request({
            method: method,
            url: url,
            data: hierarchy,
            headers: headers,
            signal: controller?.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("2pUHr", function(module, exports) {

$parcel$export(module.exports, "allowedHierarchyNamePattern", function () { return $5d9686e58cdeac59$export$60628da97efcdfce; });
$parcel$export(module.exports, "hierarchyNameValidator", function () { return $5d9686e58cdeac59$export$5ea5d8d7cdb7f353; });

var $lyHxg = parcelRequire("lyHxg");
const $5d9686e58cdeac59$export$60628da97efcdfce = /^[A-Za-z0-9_ -]+$/;
const $5d9686e58cdeac59$export$5ea5d8d7cdb7f353 = async (_backEndUrl, target, _controller)=>{
    const hierarchyNameNormalized = target.value.trim().toLowerCase();
    const level = target.options?.otherValues?.level;
    if (hierarchyNameNormalized === "") return {
        success: true,
        data: {
            valid: false,
            validationText: "Name cannot be empty"
        }
    };
    if (!$5d9686e58cdeac59$export$60628da97efcdfce.test(hierarchyNameNormalized)) return {
        success: true,
        data: {
            valid: false,
            validationText: "Name may only contain letters, numbers, spaces, hyphens, and underscores"
        }
    };
    const existingValues = target.options?.existingValues ?? [];
    const isDuplicate = existingValues.some((v)=>v.trim().toLowerCase() === hierarchyNameNormalized);
    if (isDuplicate) return {
        success: true,
        data: {
            valid: false,
            validationText: !level ? "Hierarchy name is already used within current parent hierarchy" : `${level} name is already used within current ${(0, $lyHxg.parentHierarchyLevel)(level)}`
        }
    };
    return {
        success: true,
        data: {
            valid: true,
            validationText: ""
        }
    };
};

});
parcelRegister("lyHxg", function(module, exports) {

$parcel$export(module.exports, "parentHierarchyLevel", function () { return $18ad792ea9a85392$export$48ae3920b2fddddf; });

var $7Wd8C = parcelRequire("7Wd8C");
const $18ad792ea9a85392$export$48ae3920b2fddddf = (hierarchyLevel)=>{
    switch(hierarchyLevel){
        case (0, $7Wd8C.eHierarchyLevel).TopLevel:
        case (0, $7Wd8C.eHierarchyLevel).Corporate:
            return (0, $7Wd8C.eHierarchyLevel).TopLevel;
        case (0, $7Wd8C.eHierarchyLevel).TA:
            return (0, $7Wd8C.eHierarchyLevel).Corporate;
        case (0, $7Wd8C.eHierarchyLevel).Project:
            return (0, $7Wd8C.eHierarchyLevel).TA;
        case (0, $7Wd8C.eHierarchyLevel).Study:
            return (0, $7Wd8C.eHierarchyLevel).Project;
        case (0, $7Wd8C.eHierarchyLevel).Report:
            return (0, $7Wd8C.eHierarchyLevel).Study;
    }
};

});


parcelRegister("idCYl", function(module, exports) {

$parcel$export(module.exports, "WordModal", function () { return $c30ba8057c146fac$export$b57c1d984f6ab8a3; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $dImYe = parcelRequire("dImYe");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");
var $8d4Ob = parcelRequire("8d4Ob");
var $d8uJi = parcelRequire("d8uJi");
const $c30ba8057c146fac$export$b57c1d984f6ab8a3 = ({ id: id, buttonLabel: buttonLabel = "OK", clearOnClose: clearOnClose = true, externalValues: externalValues, inputs: inputs, message: message, onCancel: onCancel, onFieldChange: onFieldChange, onOk: onOk, requestStatus: requestStatus, show: show, spellCheck: spellCheck = true, title: title, ...rest })=>{
    const [currentValues, setCurrentValues] = (0, $7fPBF.useState)(Object.fromEntries(inputs.filter((inp)=>!inp.computeValue).map((inp)=>[
            inp.inputName,
            inp.initialValue ?? ""
        ])));
    const [textValid, setTextValid] = (0, $7fPBF.useState)(inputs.map((inp)=>{
        const isHidden = typeof inp.hidden === "function" ? inp.hidden(currentValues) : false;
        return isHidden || !inp.validCondition;
    }));
    /**
   * Clears the input fields if clearOnClose is true
   */ const clearFields = ()=>clearOnClose && setCurrentValues(Object.fromEntries(inputs.filter((inp)=>!inp.computeValue).map((inp)=>[
                inp.inputName,
                inp.initialValue ?? // istanbul ignore next
                ""
            ])));
    /**
   * Cancel button click handler
   */ const onCancelClick = ()=>{
        clearFields();
        onCancel();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default), {
        ...rest,
        id: id,
        show: show,
        onHide: ()=>{
            onCancelClick();
            rest.onHide?.();
        },
        onExited: (n)=>{
            rest.onExited?.(n);
            clearFields();
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default), {
            id: `${id}-form`,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                        children: [
                            message,
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dImYe.ControlsGroup), {
                                baseId: `${id}-form`,
                                currentValues: {
                                    ...currentValues,
                                    ...externalValues
                                },
                                inputs: inputs,
                                onFieldChange: onFieldChange,
                                setCurrentValues: (vals)=>setCurrentValues(vals),
                                setTextValid: setTextValid,
                                spellCheck: spellCheck
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default).Footer, {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                            id: `${id}-ok`,
                            variant: "primary",
                            disabled: textValid.some((value, ix)=>{
                                const isHidden = typeof inputs[ix].hidden === "function" ? inputs[ix].hidden(currentValues) : false;
                                return !isHidden && !value;
                            }),
                            onClick: ()=>onOk(currentValues),
                            requestStatus: requestStatus,
                            children: buttonLabel
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                            id: `${id}-cancel`,
                            variant: "secondary",
                            onClick: onCancelClick,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
};
$c30ba8057c146fac$export$b57c1d984f6ab8a3.displayName = "WordModal";

});

parcelRegister("9U0Qm", function(module, exports) {

$parcel$export(module.exports, "NewReportModal", function () { return $e8dfbbc842efa2fd$export$77ffd4341c3bbdd6; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");

var $3d9YA = parcelRequire("3d9YA");

var $bvvhK = parcelRequire("bvvhK");

var $7fPBF = parcelRequire("7fPBF");

var $idCYl = parcelRequire("idCYl");

var $hrazC = parcelRequire("hrazC");
const $e8dfbbc842efa2fd$export$77ffd4341c3bbdd6 = ({ show: show, onOk: onOk, onCancel: onCancel })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const [reportTypes, setReportTypes] = (0, $7fPBF.useState)([]);
    const [reportSuffixes, setReportSuffixes] = (0, $7fPBF.useState)([]);
    const [requestTypes, setRequestTypes] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const getReportTypesData = (0, $7fPBF.useEffectEvent)(async ()=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $bvvhK.getReportTypes), null, requestTypes, setRequestTypes, appSettings.backEndUrl);
        if (response?.success) (0, $7fPBF.startTransition)(()=>setReportTypes(response.data));
    });
    const [requestSuffixes, setRequestSuffixes] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const getReportSuffixesData = (0, $7fPBF.useEffectEvent)(async ()=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $3d9YA.getReportSuffixes), null, requestSuffixes, setRequestSuffixes, appSettings.backEndUrl);
        if (response?.success) (0, $7fPBF.startTransition)(()=>setReportSuffixes(response.data));
    });
    (0, $7fPBF.useEffect)(()=>{
        getReportTypesData();
        getReportSuffixesData();
    }, []);
    return !hierarchy ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $idCYl.WordModal), {
        id: "hierarchylinks-add-modal",
        show: show,
        title: "Add new Report",
        buttonLabel: "Add",
        onOk: onOk,
        onCancel: onCancel,
        message: requestTypes.error || requestSuffixes.error ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "text-danger",
            children: "Error loading report types or suffixes"
        }) : undefined,
        inputs: (0, $hrazC.newReportInputs)(hierarchy.children.map((r)=>r.name.toLowerCase()), reportTypes, reportSuffixes),
        spellCheck: false
    });
};
$e8dfbbc842efa2fd$export$77ffd4341c3bbdd6.displayName = "NewReportModal";

});
parcelRegister("3d9YA", function(module, exports) {

$parcel$export(module.exports, "getReportSuffixes", function () { return $509a215a22d0e351$export$3c1a8fcc0319ca60; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $509a215a22d0e351$export$3c1a8fcc0319ca60 = async (backEndUrl, _, controller)=>{
    try {
        const response = await (0, $a04va.default).get(`${backEndUrl}Hierarchy/ReportSuffixes`, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Failed to retrieve report suffixes", error);
    }
};

});

parcelRegister("bvvhK", function(module, exports) {

$parcel$export(module.exports, "getReportTypes", function () { return $b17953644bd326ac$export$79b431954e55b5e; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $b17953644bd326ac$export$79b431954e55b5e = async (backEndUrl, _, controller)=>{
    try {
        const response = await (0, $a04va.default).get(`${backEndUrl}Hierarchy/ReportTypes`, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Failed to retrieve report types", error);
    }
};

});

parcelRegister("hrazC", function(module, exports) {

$parcel$export(module.exports, "newReportInputs", function () { return $a0d6c7c766e71cea$export$323cf9afa6c029ea; });
const $a0d6c7c766e71cea$export$323cf9afa6c029ea = (existingNames, reportTypes, reportSuffixes)=>[
        {
            inputLabel: "Report type",
            inputName: "ReportType",
            dropdownOptions: reportTypes,
            validCondition: async (_backEndUrl, target)=>{
                const reportType = target.value;
                const isValid = reportType !== "";
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Report type is required"
                    }
                };
            }
        },
        {
            inputLabel: "Report number",
            inputName: "Report number",
            validCondition: async (_, target)=>{
                const reportNumber = target.value;
                const isValid = reportNumber === "" || /^\d{2}$/.test(reportNumber);
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Report number must be exactly two digits (e.g., 01) or blank"
                    }
                };
            },
            placeholder: "00",
            hidden: (values)=>values["ReportType"] === ""
        },
        {
            inputLabel: "Report suffix",
            inputName: "Report suffix",
            dropdownOptions: [
                "",
                ...reportSuffixes
            ],
            hidden: (values)=>values["ReportType"] === ""
        },
        {
            inputLabel: "Custom suffix",
            inputName: "Custom suffix",
            hidden: (values)=>values["Report suffix"] !== "<<other>>" && values["Report suffix"] !== "<<country>>",
            validCondition: async (_backEndUrl, target)=>{
                const customSuffix = target.value.trim();
                const validationText = customSuffix.length === 0 ? "Custom suffix is required" : !/^[A-Za-z0-9]+$/.test(customSuffix) ? "Custom suffix can only contain letters and numbers" : "";
                return {
                    success: true,
                    data: {
                        valid: validationText === "",
                        validationText: validationText
                    }
                };
            }
        },
        {
            inputLabel: "Suffix number",
            inputName: "Suffix number",
            validCondition: async (_, target)=>{
                const suffixNumber = target.value;
                const isValid = suffixNumber === "" || /^\d{2}$/.test(suffixNumber);
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Suffix number must be exactly two digits (e.g., 01) or blank"
                    }
                };
            },
            hidden: (values)=>values["Report suffix"] === "",
            placeholder: "00"
        },
        {
            inputLabel: "Name",
            inputName: "Name",
            computeValue: (values)=>{
                const suffix = values["Report suffix"] ?? // istanbul ignore next
                "";
                const customSuffix = values["Custom suffix"] ?? // istanbul ignore next
                "";
                const suffixNumber = values["Suffix number"] ?? // istanbul ignore next
                "";
                if (suffix === "") return `${values["ReportType"] ?? // istanbul ignore next
                ""}${values["Report number"] ?? // istanbul ignore next
                ""}`;
                const actualSuffix = suffix === "<<other>>" || suffix === "<<country>>" ? customSuffix : suffix;
                return `${values["ReportType"] ?? // istanbul ignore next
                ""}${values["Report number"] ?? // istanbul ignore next
                ""}_${actualSuffix}${suffixNumber}`;
            },
            readonly: true,
            validCondition: async (_, target)=>{
                const reportName = target.value.trim();
                const isDuplicate = existingNames.includes(reportName.toLowerCase());
                return {
                    success: true,
                    data: {
                        valid: !isDuplicate,
                        validationText: isDuplicate ? "This name is taken" : ""
                    }
                };
            }
        },
        {
            inputLabel: "Description",
            inputName: "Description",
            validCondition: async (_, target)=>{
                const description = target.value.trim();
                const isValid = description.length > 0;
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Description is required"
                    }
                };
            }
        }
    ];

});



parcelRegister("j2AuU", function(module, exports) {

$parcel$export(module.exports, "ChildLink", function () { return $db6743a02d1901d9$export$33b860458c4a8e93; });

var $bbzbN = parcelRequire("bbzbN");

var $j96Rr = parcelRequire("j96Rr");

var $wPq5H = parcelRequire("wPq5H");
const $db6743a02d1901d9$export$33b860458c4a8e93 = ({ hierarchy: hierarchy })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
            id: `hierarchylinks-child-${name}`,
            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchy)}`,
            style: {
                paddingLeft: "0.75rem",
                textIndent: "-0.75rem"
            },
            children: hierarchy.name
        })
    });
};
$db6743a02d1901d9$export$33b860458c4a8e93.displayName = "ChildLink";

});


parcelRegister("3uLZ3", function(module, exports) {

$parcel$export(module.exports, "ParentLink", function () { return $28545a2744ea5a73$export$eaf30ed8fd9c8e09; });

var $bbzbN = parcelRequire("bbzbN");

var $j96Rr = parcelRequire("j96Rr");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");
const $28545a2744ea5a73$export$eaf30ed8fd9c8e09 = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    // Current hierarchy information
    const parent = hierarchyContext && hierarchyContext.hierarchy && hierarchyContext.hierarchyNodes.find((h)=>h.hierarchyTag === hierarchyContext.hierarchy.parentTag);
    return parent && hierarchyContext?.hierarchy?.level !== "Corporate" ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                children: parent.level
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                        id: "hierarchylinks-parent-link",
                        to: `${(0, $wPq5H.getHierarchyBaseUrl)(parent)}`,
                        children: parent.name
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {
                        className: "mt-3"
                    })
                ]
            })
        ]
    }) : hierarchyContext?.hierarchy?.level === "Corporate" ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                id: "hierarchylinks-corporate",
                to: "/Corporate",
                children: "Corporate"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {
                className: "mt-3"
            })
        ]
    });
};
$28545a2744ea5a73$export$eaf30ed8fd9c8e09.displayName = "ParentLink";

});

parcelRegister("cRPPh", function(module, exports) {

$parcel$export(module.exports, "RecentLinks", function () { return $8e1defa53ff6ba9a$export$f44baf4f1214e7bf; });

var $bbzbN = parcelRequire("bbzbN");

var $j96Rr = parcelRequire("j96Rr");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $7fPBF = parcelRequire("7fPBF");

var $1Vem2 = parcelRequire("1Vem2");
const $8e1defa53ff6ba9a$export$d2934f991c6d2dc2 = (obj)=>{
    return typeof obj === "object" && obj !== null && typeof obj.id === "string" && typeof obj.name === "string" && typeof obj.type === "string" && typeof obj.path === "string";
};
const $8e1defa53ff6ba9a$export$f44baf4f1214e7bf = ()=>{
    const [_isPending, startTransition] = (0, $7fPBF.useTransition)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    // Get current links
    const [recentLinks, setRecentLinks] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useLayoutEffect)(()=>{
        const storedLinks = window.localStorage.getItem("recentHierarchies") ?? "";
        try {
            const parsedLinks = JSON.parse(storedLinks);
            if (Array.isArray(parsedLinks)) {
                const validLinks = parsedLinks.filter($8e1defa53ff6ba9a$export$d2934f991c6d2dc2);
                startTransition(()=>setRecentLinks(validLinks));
            } else startTransition(()=>setRecentLinks([]));
        } catch  {
            startTransition(()=>setRecentLinks([]));
        }
    }, []);
    // Function for minus button press
    const removeRecent = (0, $7fPBF.useCallback)((id)=>{
        // Cannot be called while recentLinks is null due to button not rendering
        const rl = recentLinks.filter((rl)=>rl.id !== id);
        window.localStorage.setItem("recentHierarchies", JSON.stringify(rl));
        setRecentLinks(rl);
    }, [
        recentLinks
    ]);
    // Update links list
    (0, $7fPBF.useEffect)(()=>{
        // Add most recent value
        if (hierarchyContext && hierarchyContext.hierarchy && hierarchyContext.hierarchy.id && hierarchyContext.hierarchy.name && hierarchyContext.hierarchy.type && !hierarchyContext.hierarchy.isBackupVersion && recentLinks && (recentLinks.length === 0 || recentLinks.length > 0 && (hierarchyContext.hierarchy.id !== recentLinks[0].id || hierarchyContext.hierarchy.name !== recentLinks[0].name))) {
            const newPath = (0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy);
            const newRecentLinks = [
                {
                    id: hierarchyContext.hierarchy.id,
                    name: hierarchyContext.hierarchy.name,
                    type: hierarchyContext.hierarchy.type,
                    path: newPath
                },
                ...recentLinks.filter((h)=>h.id !== hierarchyContext.hierarchy.id && h.path !== newPath).map((h)=>{
                    // Check for name updates
                    const hnchk = hierarchyContext.hierarchyNodes.find((hn)=>hn.id === h.id);
                    if (hnchk && hnchk.name !== h.name) return {
                        ...h,
                        name: hnchk.name,
                        path: (0, $wPq5H.getHierarchyBaseUrl)(hnchk)
                    };
                    else return h;
                })
            ];
            // Save back to storage
            window.localStorage.setItem("recentHierarchies", JSON.stringify(newRecentLinks));
            startTransition(()=>setRecentLinks(newRecentLinks.slice(0, 9)));
        }
    }, [
        hierarchyContext,
        recentLinks
    ]);
    // Return header and links
    return !recentLinks || recentLinks.length === 0 ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                children: "Recently viewed"
            }),
            recentLinks.map((h, i)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            style: {
                                marginRight: "4px",
                                width: "16px"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1Vem2.default), {
                                "aria-label": `Remove recent link to ${h.name}`,
                                id: `recentlinks-remove-${h.name}`,
                                onClick: ()=>removeRecent(h.id),
                                style: {
                                    color: "var(--bs-danger)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: `recentlinks-link-${h.name}`,
                            to: h.path,
                            style: {
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            },
                            children: h.name
                        })
                    ]
                }, `${i}-${h.id}`))
        ]
    });
};
$8e1defa53ff6ba9a$export$f44baf4f1214e7bf.displayName = "RecentLinks";

});

parcelRegister("jztSD", function(module, exports) {

$parcel$export(module.exports, "StudyTree", function () { return $93d41936aa6ea7bc$export$ff3bc663dbc9bf12; });

var $bbzbN = parcelRequire("bbzbN");

var $h6WyF = parcelRequire("h6WyF");

var $cSt5x = parcelRequire("cSt5x");

var $hWsmt = parcelRequire("hWsmt");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $eEIPt = parcelRequire("eEIPt");
const $93d41936aa6ea7bc$export$ff3bc663dbc9bf12 = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const navigate = (0, $4PTZu.useUnsavedChanges)("study-tree").navigate;
    const showStudyTree = hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report;
    const studyHierarchy = hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report ? hierarchyContext?.hierarchyNodes.find((h)=>h.id === hierarchyContext?.hierarchy?.parentId) : hierarchyContext?.hierarchy;
    const nodeList = studyHierarchy ? (0, $cSt5x.hierarchyToNodes)([
        studyHierarchy
    ]) : null;
    /**
   * Handle click on a node in the study tree.
   *
   * @param ret - The selected node ID(s)
   */ const handleSelect = (ret)=>{
        const node = nodeList?.find((n)=>n.id === ret);
        /* istanbul ignore else */ if (node?.data) navigate(node.data.url);
    };
    return !studyHierarchy || !showStudyTree || !nodeList ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h6WyF.TreeOfNodes), {
                id: "study-tree",
                handleSelect: handleSelect,
                initiallyExpandedNodes: [
                    studyHierarchy.id
                ],
                nodeHighlight: "rgb(0,0,0)",
                nodeList: nodeList,
                roots: [
                    studyHierarchy.id
                ],
                selected: hierarchyContext.hierarchy.id,
                textHighlight: "rgba(33,35,211,0.1)"
            }),
            hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).CreateHierarchy) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $eEIPt.AddHierarchyButton), {}, studyHierarchy.id),
            /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {})
        ]
    });
};
$93d41936aa6ea7bc$export$ff3bc663dbc9bf12.displayName = "StudyTree";

});
parcelRegister("h6WyF", function(module, exports) {

$parcel$export(module.exports, "TreeOfNodes", function () { return $c7506ba1da06f905$export$5580fff3e08a8be5; });


var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $541p6 = parcelRequire("541p6");
var $5FuV0 = parcelRequire("5FuV0");
var $h1QlT = parcelRequire("h1QlT");
var $30cFq = parcelRequire("30cFq");

var $4WD1L = parcelRequire("4WD1L");
function $c7506ba1da06f905$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $c7506ba1da06f905$var$$b65191f6d0a0a991$exports = {};
$c7506ba1da06f905$var$$parcel$export($c7506ba1da06f905$var$$b65191f6d0a0a991$exports, "TreeNode", function() {
    return $c7506ba1da06f905$export$2eba8ec3a333fdbb;
});
$c7506ba1da06f905$var$$parcel$export($c7506ba1da06f905$var$$b65191f6d0a0a991$exports, "TreeOfNodes", function() {
    return $c7506ba1da06f905$export$5580fff3e08a8be5;
});
$c7506ba1da06f905$var$$parcel$export($c7506ba1da06f905$var$$b65191f6d0a0a991$exports, "WordEntry", function() {
    return $c7506ba1da06f905$export$14f190ac910bde69;
});
const $c7506ba1da06f905$export$c6fd3ab3f44300d0 = (id, included, hierarchyNodes)=>{
    const processIds = Array.isArray(id) ? id : [
        id
    ];
    const current = processIds.map((i)=>hierarchyNodes.find((h)=>h.id === i)).filter((h)=>h !== undefined);
    if (current.length === 0) return included;
    const parents = current.map((h)=>h.parentId).map((pid)=>hierarchyNodes.find((h)=>pid === h.id)).filter((p)=>p !== undefined);
    if (parents.length === 0) return included;
    else return $c7506ba1da06f905$export$c6fd3ab3f44300d0(parents.map((p)=>p.id), [
        ...included,
        ...parents.filter((p)=>!included.includes(p))
    ], hierarchyNodes);
};
const $c7506ba1da06f905$var$$33abc00b1ca5c55c$export$bd923365b402cb04 = (id, hierarchyNodes)=>{
    const processIds = Array.isArray(id) ? id : [
        id
    ];
    const newChildren = hierarchyNodes.filter((h)=>h.parentId !== undefined && processIds.includes(h.parentId) && !processIds.includes(h.id)).map((h)=>h.id);
    return newChildren.length === 0 ? processIds : $c7506ba1da06f905$var$$33abc00b1ca5c55c$export$bd923365b402cb04([
        ...processIds,
        ...newChildren
    ], hierarchyNodes);
};
const $c7506ba1da06f905$var$$886f402bccb0fd30$export$29ec378200e05207 = (0, $7fPBF.createContext)(undefined);
const $c7506ba1da06f905$export$14f190ac910bde69 = (0, $7fPBF.forwardRef)(({ id: id, className: className, value: value, editing: editing, saving: saving, setValue: setValue, sendEscape: sendEscape, style: style, spellCheck: spellCheck = "true" }, ref)=>{
    const [currentValue, setCurrentValue] = (0, $7fPBF.useState)(value !== null && value !== void 0 ? value : "");
    (0, $7fPBF.useEffect)(()=>{
        setCurrentValue(value !== null && value !== void 0 ? value : "");
    }, [
        value
    ]);
    const keyPress = (e)=>{
        if (e.code === "Escape") {
            setCurrentValue(value !== null && value !== void 0 ? value : "");
            sendEscape === null || sendEscape === void 0 || sendEscape();
        } else if (e.code === "Enter") setValue === null || setValue === void 0 || setValue(currentValue);
    };
    (0, $7fPBF.useEffect)(()=>{
        const handleMouseDown = (e)=>{
            const target = e.target;
            if (editing && target.id !== `${id}` && target.id !== `${id}-holder` && target.id !== `${id}-spinner` && target.className !== "ton-rename") {
                e.preventDefault();
                e.stopPropagation();
                setValue === null || setValue === void 0 || setValue(currentValue);
            }
        };
        window.addEventListener("mousedown", handleMouseDown);
        return ()=>{
            window.removeEventListener("mousedown", handleMouseDown);
        };
    }, [
        currentValue,
        editing,
        id,
        setValue
    ]);
    return !editing ? (0, $bbzbN.jsx)("span", {
        className: "ton-label-span",
        style: style,
        id: `${id}`,
        children: value ? value : (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
            children: "\xa0"
        })
    }) : (0, $bbzbN.jsxs)("div", {
        style: style,
        id: `${id}-holder`,
        className: "ton-rename-holder",
        children: [
            saving && (0, $bbzbN.jsx)((0, $4WD1L.default), {
                id: `${id}-spinner`,
                size: "sm",
                animation: "border"
            }),
            (0, $bbzbN.jsx)("input", {
                autoFocus: true,
                spellCheck: spellCheck,
                id: String(id),
                ref: ref,
                type: "text",
                className: [
                    "ton-rename",
                    className
                ].filter(Boolean).join(" "),
                value: currentValue,
                disabled: saving,
                onChange: (e)=>setCurrentValue(e.currentTarget.value),
                onBlur: (e)=>setValue === null || setValue === void 0 ? void 0 : setValue(e.currentTarget.value),
                onKeyDownCapture: keyPress
            })
        ]
    });
});
$c7506ba1da06f905$export$14f190ac910bde69.displayName = "WordEntry";
const $c7506ba1da06f905$export$2eba8ec3a333fdbb = ({ id: id, canRemove: canRemove, canRename: canRename, canAddChildren: canAddChildren, canRemoveChildren: canRemoveChildren, canRenameChildren: canRenameChildren })=>{
    // Contexts
    const treeContext = (0, $7fPBF.useContext)($c7506ba1da06f905$var$$886f402bccb0fd30$export$29ec378200e05207);
    // Node information
    const thisNode = treeContext === null || treeContext === void 0 ? void 0 : treeContext.nodeList.find((n)=>n.id === id);
    const childNodes = treeContext === null || treeContext === void 0 ? void 0 : treeContext.nodeList.filter((n)=>n.parentId === id);
    var _treeContext_nodeList;
    const descendents = $c7506ba1da06f905$var$$33abc00b1ca5c55c$export$bd923365b402cb04(id, (_treeContext_nodeList = treeContext === null || treeContext === void 0 ? void 0 : treeContext.nodeList) !== null && _treeContext_nodeList !== void 0 ? _treeContext_nodeList : []);
    // State
    const [error, setError] = (0, $7fPBF.useState)(false);
    const [errorText, setErrorText] = (0, $7fPBF.useState)("");
    var _treeContext_expandedNodes_findIndex;
    const expanded = ((_treeContext_expandedNodes_findIndex = treeContext === null || treeContext === void 0 ? void 0 : treeContext.expandedNodes.findIndex((e)=>e === id)) !== null && _treeContext_expandedNodes_findIndex !== void 0 ? _treeContext_expandedNodes_findIndex : -1) > -1;
    // Checkbox
    const checkRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (checkRef.current) {
            if (treeContext === null || treeContext === void 0 ? void 0 : treeContext.selected.includes(id)) {
                checkRef.current.checked = true;
                checkRef.current.indeterminate = false;
            } else if (descendents.some((d)=>treeContext === null || treeContext === void 0 ? void 0 : treeContext.selected.includes(d))) {
                checkRef.current.checked = false;
                checkRef.current.indeterminate = true;
            } else {
                checkRef.current.checked = false;
                checkRef.current.indeterminate = false;
            }
        }
    }, [
        descendents,
        id,
        treeContext === null || treeContext === void 0 ? void 0 : treeContext.selected
    ]);
    // Apply selected border
    const currentBorder = (treeContext === null || treeContext === void 0 ? void 0 : treeContext.selected.includes(id)) ? "1px solid black" : "";
    const nodeColour = (()=>{
        if (treeContext && treeContext.selected) {
            const anc = $c7506ba1da06f905$export$c6fd3ab3f44300d0(treeContext.selected, [], treeContext === null || treeContext === void 0 ? void 0 : treeContext.nodeList).map((n)=>n.id);
            if ([
                ...anc,
                treeContext.selected
            ].includes(id)) return treeContext.nodeHighlight;
        }
        return;
    })();
    // New node parameters
    const newNameRef = (0, $7fPBF.useRef)(null);
    const [showNewNode, setShowNewNode] = (0, $7fPBF.useState)(false);
    const [savingNewNode, setSavingNewNode] = (0, $7fPBF.useState)(false);
    // Rename parameters
    const currentNameRef = (0, $7fPBF.useRef)(null);
    const [renaming, setRenaming] = (0, $7fPBF.useState)(false);
    const [updatingNode, setUpdatingNode] = (0, $7fPBF.useState)(false);
    // Context functions
    const handleReturn = (ret)=>{
        if (!ret.success) {
            setError(true);
            var _ret_ErrorText;
            setErrorText((_ret_ErrorText = ret.ErrorText) !== null && _ret_ErrorText !== void 0 ? _ret_ErrorText : "An unknown error has occured");
        } else {
            setError(false);
            setErrorText("");
        }
    };
    const confirmNewNode = async (label)=>{
        setSavingNewNode(true);
        if (treeContext === null || treeContext === void 0 ? void 0 : treeContext.onAddChild) handleReturn(await treeContext.onAddChild(id, label));
        setSavingNewNode(false);
        setShowNewNode(false);
    };
    const renameNode = async (newLabel)=>{
        setRenaming(false);
        if (treeContext === null || treeContext === void 0 ? void 0 : treeContext.onRename) {
            setUpdatingNode(true);
            handleReturn(await treeContext.onRename(id, newLabel));
            setUpdatingNode(false);
        }
    };
    const deleteThis = async ()=>{
        if (treeContext === null || treeContext === void 0 ? void 0 : treeContext.onRemove) {
            setUpdatingNode(true);
            handleReturn(await treeContext.onRemove(id));
            setUpdatingNode(false);
        }
    };
    // Context actions
    const addChild = ()=>{
        var _treeContext_handleExpandClick;
        setShowNewNode(true);
        treeContext === null || treeContext === void 0 || (_treeContext_handleExpandClick = treeContext.handleExpandClick) === null || _treeContext_handleExpandClick === void 0 || _treeContext_handleExpandClick.call(treeContext, id, true);
    };
    const renameThis = ()=>{
        var _treeContext_handleSelect;
        setRenaming(true);
        treeContext === null || treeContext === void 0 || (_treeContext_handleSelect = treeContext.handleSelect) === null || _treeContext_handleSelect === void 0 || _treeContext_handleSelect.call(treeContext, id);
    };
    // Context menu
    const menuItems = [];
    if (canAddChildren) menuItems.push({
        label: "Add",
        action: addChild
    });
    if (canRename) menuItems.push({
        label: "Rename",
        action: renameThis
    });
    if (canRemove && (childNodes === undefined || childNodes.length === 0)) menuItems.push({
        label: "Delete",
        action: deleteThis
    });
    (0, $7fPBF.useEffect)(()=>{
        if (showNewNode === true && newNameRef.current) newNameRef.current.focus();
    }, [
        showNewNode
    ]);
    // Return node
    return !treeContext ? null : (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                menuItems: menuItems,
                style: {
                    display: "inline-block",
                    width: "100%"
                },
                children: (0, $bbzbN.jsx)("div", {
                    id: `${treeContext.id}-treenode-${id}`,
                    className: "treenode",
                    children: error ? (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            (0, $bbzbN.jsx)((0, $30cFq.default), {
                                color: "var(--bs-danger)"
                            }),
                            " ",
                            errorText
                        ]
                    }) : (0, $bbzbN.jsxs)("div", {
                        className: "ton-node",
                        children: [
                            treeContext.showCheckBox && (0, $bbzbN.jsx)("input", {
                                ref: checkRef,
                                type: "checkbox",
                                role: "checkbox",
                                className: "ton-checkbox",
                                id: `${treeContext.id}-treenode-checkbox-${id}`,
                                onClick: ()=>{
                                    var _treeContext_handleSelect;
                                    return (_treeContext_handleSelect = treeContext.handleSelect) === null || _treeContext_handleSelect === void 0 ? void 0 : _treeContext_handleSelect.call(treeContext, descendents);
                                }
                            }),
                            childNodes && childNodes.length > 0 ? !expanded ? (0, $bbzbN.jsx)((0, $h1QlT.default), {
                                id: `${treeContext.id}-treenode-caret-${id}`,
                                style: {
                                    width: "16px",
                                    height: "16px"
                                },
                                className: "ton-expander",
                                role: "button",
                                color: nodeColour,
                                "aria-expanded": false,
                                "aria-label": "Expander",
                                onClick: ()=>treeContext.handleExpandClick(id)
                            }) : (0, $bbzbN.jsx)((0, $541p6.default), {
                                id: `${treeContext.id}-treenode-caret-${id}`,
                                className: "ton-expander",
                                role: "button",
                                "aria-expanded": true,
                                "aria-label": "Expander",
                                color: nodeColour,
                                onClick: ()=>treeContext.handleExpandClick(id)
                            }) : (0, $bbzbN.jsx)((0, $5FuV0.default), {
                                id: `${treeContext.id}-treenode-caret-${id}`,
                                className: "ton-expander",
                                role: "button",
                                color: nodeColour,
                                "aria-expanded": false,
                                "aria-label": "Disabled expander",
                                onClick: ()=>{
                                    var _treeContext_handleSelect;
                                    return (_treeContext_handleSelect = treeContext.handleSelect) === null || _treeContext_handleSelect === void 0 ? void 0 : _treeContext_handleSelect.call(treeContext, id);
                                }
                            }),
                            thisNode && (0, $bbzbN.jsx)("div", {
                                className: "ton-label",
                                style: {
                                    width: `calc(100% - ${treeContext.showCheckBox ? "32px" : "16px"})`
                                },
                                onContextMenuCapture: ()=>{
                                    var _treeContext_handleSelect;
                                    return (_treeContext_handleSelect = treeContext.handleSelect) === null || _treeContext_handleSelect === void 0 ? void 0 : _treeContext_handleSelect.call(treeContext, id);
                                },
                                onClickCapture: ()=>{
                                    var _treeContext_handleSelect;
                                    if (!treeContext.expandedNodes.includes(id)) treeContext.handleExpandClick(id);
                                    (_treeContext_handleSelect = treeContext.handleSelect) === null || _treeContext_handleSelect === void 0 || _treeContext_handleSelect.call(treeContext, id);
                                },
                                onFocusCapture: ()=>{
                                    var _treeContext_handleSelect;
                                    return (_treeContext_handleSelect = treeContext.handleSelect) === null || _treeContext_handleSelect === void 0 ? void 0 : _treeContext_handleSelect.call(treeContext, id);
                                },
                                children: (0, $bbzbN.jsx)($c7506ba1da06f905$export$14f190ac910bde69, {
                                    id: `${treeContext.id}-treenode-entry-${id}`,
                                    className: currentBorder ? "selected" : "",
                                    ref: currentNameRef,
                                    value: thisNode.label,
                                    editing: renaming,
                                    saving: updatingNode,
                                    setValue: (ret)=>renameNode(ret),
                                    sendEscape: ()=>setRenaming(false),
                                    style: {
                                        border: currentBorder,
                                        margin: currentBorder === "" ? "1px" : "",
                                        backgroundColor: currentBorder === "" ? "" : treeContext.textHighlight
                                    },
                                    spellCheck: treeContext.spellCheck
                                })
                            })
                        ]
                    })
                })
            }),
            childNodes && (0, $bbzbN.jsx)("div", {
                className: `ton-collapsible-wrapper ${expanded && childNodes.length > 0 ? "" : "collapsed"}`,
                children: childNodes.length > 0 && (0, $bbzbN.jsx)("div", {
                    className: "ton-collapsible",
                    children: childNodes.map((h)=>(0, $bbzbN.jsx)("span", {
                            id: `${treeContext.id}-treenode-child-${h.id}`,
                            className: "ton-child",
                            children: (0, $bbzbN.jsx)($c7506ba1da06f905$export$2eba8ec3a333fdbb, {
                                id: h.id,
                                canRemove: canRemoveChildren,
                                canRename: canRenameChildren,
                                canAddChildren: canAddChildren,
                                canRemoveChildren: canRemoveChildren,
                                canRenameChildren: canRenameChildren
                            })
                        }, h.id))
                })
            }),
            showNewNode && (0, $bbzbN.jsx)($c7506ba1da06f905$export$14f190ac910bde69, {
                style: {
                    marginLeft: "14px"
                },
                id: `treenode-new-${id}`,
                ref: newNameRef,
                editing: true,
                setValue: (ret)=>confirmNewNode(ret),
                saving: savingNewNode,
                sendEscape: ()=>setShowNewNode(false),
                spellCheck: treeContext.spellCheck
            })
        ]
    });
};
$c7506ba1da06f905$export$2eba8ec3a333fdbb.displayName = "TreeNode";
const $c7506ba1da06f905$var$$c7008d808d3e1c7a$export$40c47a7ac5f85aba = (nodeList, selected, expandedNodes)=>{
    return [
        ...expandedNodes,
        ...$c7506ba1da06f905$export$c6fd3ab3f44300d0(selected, [], nodeList).map((n)=>n.id).filter((k)=>!expandedNodes.includes(k))
    ].sort((a, b)=>`${a}`.localeCompare(`${b}`));
};
const $c7506ba1da06f905$export$5580fff3e08a8be5 = ({ alwaysShowSelected: alwaysShowSelected = "first", canAddChildren: canAddChildren = false, canRemoveChildren: canRemoveChildren = false, canRemoveRoot: canRemoveRoot = false, canRenameChildren: canRenameChildren = false, canRenameRoot: canRenameRoot = false, handleSelect: handleSelect, id: id, initiallyExpandedNodes: initiallyExpandedNodes = [], nodeHighlight: nodeHighlight = "red", nodeList: nodeList, onAdd: onAdd, onRemove: onRemove, onRename: onRename, roots: roots, selected: selected = [], showCheckBox: showCheckBox = false, spellCheck: spellCheck = "true", textHighlight: textHighlight = "rgba(255, 0, 0, 0.2)" })=>{
    const [firstRender, setFirstRender] = (0, $7fPBF.useState)(alwaysShowSelected === "first");
    const [expandedNodes, setExpandedNodes] = (0, $7fPBF.useState)(initiallyExpandedNodes);
    (0, $7fPBF.useEffect)(()=>{
        const selectedArray = Array.isArray(selected) ? selected : [
            selected
        ];
        if ((alwaysShowSelected === "always" || firstRender) && selectedArray.length > 0) {
            // Check all nodes are showing that should be
            const shouldExpand = $c7506ba1da06f905$var$$c7008d808d3e1c7a$export$40c47a7ac5f85aba(nodeList, selectedArray, expandedNodes);
            if (shouldExpand.filter((n)=>!expandedNodes.includes(n)).length > 0) setExpandedNodes(shouldExpand);
            setFirstRender(false);
        }
    }, [
        alwaysShowSelected,
        firstRender,
        expandedNodes,
        nodeList,
        selected
    ]);
    // Change expansion and update contexts
    const changeExpand = (eKey, force)=>{
        const newExpandedNodes = [
            ...expandedNodes
        ];
        const ix = newExpandedNodes.findIndex((nKey)=>nKey === eKey);
        if (ix === -1 && force === undefined || force === true) newExpandedNodes.push(eKey);
        else newExpandedNodes.splice(ix, 1);
        setExpandedNodes(newExpandedNodes);
    };
    return (0, $bbzbN.jsx)("div", {
        id: id,
        className: "tree-of-nodes",
        children: (0, $bbzbN.jsx)($c7506ba1da06f905$var$$886f402bccb0fd30$export$29ec378200e05207, {
            value: {
                id: id,
                expandedNodes: expandedNodes,
                handleExpandClick: (r, f)=>changeExpand(r, f),
                handleSelect: handleSelect,
                nodeHighlight: nodeHighlight,
                nodeList: nodeList,
                onAddChild: onAdd,
                onRemove: onRemove,
                onRename: onRename,
                selected: Array.isArray(selected) ? selected : [
                    selected
                ],
                showCheckBox: showCheckBox,
                spellCheck: spellCheck,
                textHighlight: textHighlight
            },
            children: roots.map((r)=>(0, $bbzbN.jsx)($c7506ba1da06f905$export$2eba8ec3a333fdbb, {
                    id: r,
                    canRemove: canRemoveRoot,
                    canAddChildren: canAddChildren,
                    canRename: canRenameRoot,
                    canRemoveChildren: canRemoveChildren,
                    canRenameChildren: canRenameChildren
                }, r))
        })
    });
};
$c7506ba1da06f905$export$5580fff3e08a8be5.displayName = "TreeOfNodes";
var $c7506ba1da06f905$var$$3d005c8713d7dfb7$exports = {};
$c7506ba1da06f905$var$$parcel$export($c7506ba1da06f905$var$$3d005c8713d7dfb7$exports, "getParents", function() {
    return $c7506ba1da06f905$export$c6fd3ab3f44300d0;
});

});
parcelRegister("541p6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3afe6a42322f4432$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $3afe6a42322f4432$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $3afe6a42322f4432$var$_extends() {
    return $3afe6a42322f4432$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3afe6a42322f4432$var$_extends.apply(null, arguments);
}
function $3afe6a42322f4432$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3afe6a42322f4432$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3afe6a42322f4432$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3afe6a42322f4432$var$CaretDownFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $3afe6a42322f4432$var$_objectWithoutProperties(_ref, $3afe6a42322f4432$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $3afe6a42322f4432$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-down-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
    }));
});
$3afe6a42322f4432$var$CaretDownFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $3afe6a42322f4432$export$2e2bcd8739ae039 = $3afe6a42322f4432$var$CaretDownFill;

});

parcelRegister("5FuV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4208c3d39a60f9a9$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $4208c3d39a60f9a9$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $4208c3d39a60f9a9$var$_extends() {
    return $4208c3d39a60f9a9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4208c3d39a60f9a9$var$_extends.apply(null, arguments);
}
function $4208c3d39a60f9a9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4208c3d39a60f9a9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4208c3d39a60f9a9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4208c3d39a60f9a9$var$CaretRight = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $4208c3d39a60f9a9$var$_objectWithoutProperties(_ref, $4208c3d39a60f9a9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $4208c3d39a60f9a9$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753"
    }));
});
$4208c3d39a60f9a9$var$CaretRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $4208c3d39a60f9a9$export$2e2bcd8739ae039 = $4208c3d39a60f9a9$var$CaretRight;

});

parcelRegister("h1QlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c65b23b324ce210f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $c65b23b324ce210f$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $c65b23b324ce210f$var$_extends() {
    return $c65b23b324ce210f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c65b23b324ce210f$var$_extends.apply(null, arguments);
}
function $c65b23b324ce210f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c65b23b324ce210f$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c65b23b324ce210f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c65b23b324ce210f$var$CaretRightFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $c65b23b324ce210f$var$_objectWithoutProperties(_ref, $c65b23b324ce210f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $c65b23b324ce210f$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-right-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
    }));
});
$c65b23b324ce210f$var$CaretRightFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $c65b23b324ce210f$export$2e2bcd8739ae039 = $c65b23b324ce210f$var$CaretRightFill;

});

parcelRegister("30cFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22fb32a3ce2a5b22$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $22fb32a3ce2a5b22$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $22fb32a3ce2a5b22$var$_extends() {
    return $22fb32a3ce2a5b22$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $22fb32a3ce2a5b22$var$_extends.apply(null, arguments);
}
function $22fb32a3ce2a5b22$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $22fb32a3ce2a5b22$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $22fb32a3ce2a5b22$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $22fb32a3ce2a5b22$var$ExclamationCircleFill = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $22fb32a3ce2a5b22$var$_objectWithoutProperties(_ref, $22fb32a3ce2a5b22$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $22fb32a3ce2a5b22$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    }));
});
$22fb32a3ce2a5b22$var$ExclamationCircleFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $22fb32a3ce2a5b22$export$2e2bcd8739ae039 = $22fb32a3ce2a5b22$var$ExclamationCircleFill;

});


parcelRegister("cSt5x", function(module, exports) {

$parcel$export(module.exports, "hierarchyToNodes", function () { return $61a451d83f31b974$export$8abf8519cf7cc467; });

var $wPq5H = parcelRequire("wPq5H");
const $61a451d83f31b974$export$8abf8519cf7cc467 = (hierarchyNodes)=>{
    const treeNodes = [];
    hierarchyNodes.forEach((h)=>{
        treeNodes.push({
            id: h.id,
            label: h.name,
            parentId: h.parentId,
            data: {
                ...h,
                url: (0, $wPq5H.getHierarchyBaseUrl)(h)
            }
        });
    });
    hierarchyNodes.forEach((h)=>{
        if (h.children && h.children.length > 0) h.children.forEach((c)=>{
            if (treeNodes.findIndex((t)=>t.id === c.id) === -1) treeNodes.push({
                id: c.id,
                label: c.name,
                parentId: h.id,
                data: {
                    ...c,
                    url: (0, $wPq5H.getHierarchyBaseUrl)(c)
                }
            });
        });
    });
    treeNodes.sort((a, b)=>a.label.localeCompare(b.label));
    return treeNodes;
};

});


parcelRegister("5jUws", function(module, exports) {

$parcel$export(module.exports, "TypeLinks", function () { return $6611565d64b66362$export$621d3e5937244948; });

var $bbzbN = parcelRequire("bbzbN");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $7Wd8C = parcelRequire("7Wd8C");

var $j96Rr = parcelRequire("j96Rr");
const $6611565d64b66362$export$621d3e5937244948 = ()=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    return !hierarchyContext || hierarchyContext.hierarchy?.type !== (0, $7Wd8C.eHierarchy).Report && hierarchyContext.hierarchy?.type !== (0, $7Wd8C.eHierarchy).Directory && hierarchyContext.hierarchy?.type !== (0, $7Wd8C.eHierarchy).StudyDirectory ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                className: "mt-1",
                id: "hierarchylinks-current-hierarchy",
                children: hierarchyContext.title
            }),
            hierarchyContext.hierarchy?.type === (0, $7Wd8C.eHierarchy).Report ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            end: true,
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}`,
                            children: "Table of contents"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            end: true,
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Review`,
                            children: "Review"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Properties`,
                                    children: "Properties"
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                                    end: true,
                                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Versions`,
                                    children: "Report Versions"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                    id: "hierarchylinks-properties",
                    end: true,
                    to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}`,
                    children: "Properties"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-access-rights",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Access`,
                            children: "Access rights"
                        })
                    }),
                    hierarchyContext.hierarchy?.hasClinicalLibrary && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "clinical-library",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/ClinicalLibrary`,
                            children: "Clinical library"
                        })
                    }),
                    ![
                        (0, $7Wd8C.eHierarchyLevel).Study,
                        (0, $7Wd8C.eHierarchy).Report
                    ].includes(hierarchyContext.hierarchy.level) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-domain-replacements",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/DomainReplacements`,
                            children: "Domain replacements"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-group-replacements",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Lists`,
                            children: "Group replacement lists"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-row-group-templates",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/RowGroups`,
                            children: "Row group templates"
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-single-replacements",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Replacements`,
                            children: "Single replacements"
                        })
                    }),
                    ![
                        (0, $7Wd8C.eHierarchyLevel).Study,
                        (0, $7Wd8C.eHierarchyLevel).Report
                    ].includes(hierarchyContext.hierarchy.level) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-tags",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Tags`,
                            children: "Tags"
                        })
                    }),
                    (hierarchyContext.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Project || hierarchyContext.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study) && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j96Rr.ActiveNavLink), {
                            id: "hierarchylinks-version-history",
                            to: `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Versions`,
                            children: "Version History"
                        })
                    })
                ]
            })
        ]
    });
};
$6611565d64b66362$export$621d3e5937244948.displayName = "TypeLinks";

});


parcelRegister("h1iST", function(module, exports) {

$parcel$export(module.exports, "downloadStats", function () { return $d2ddf77faeb8f3a6$export$427c3c36ecfcdaf7; });

var $jDVSO = parcelRequire("jDVSO");
const $d2ddf77faeb8f3a6$export$427c3c36ecfcdaf7 = async (backEndUrl)=>{
    const fileName = "OriginTrafficLight.json";
    const response = await (0, $jDVSO.downloadFile)({
        url: `${backEndUrl}Hierarchy/StatsReport`,
        fileName: fileName,
        fileType: "application/json",
        blob: true,
        successMessage: "File successfully downloaded",
        errorMessage: "An error has occurred downloading the file",
        controller: new AbortController()
    });
    return response;
};

});
parcelRegister("jDVSO", function(module, exports) {

$parcel$export(module.exports, "downloadFile", function () { return $9000cf726a03ccbc$export$bb3b75778e3e272; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");
const $9000cf726a03ccbc$export$bb3b75778e3e272 = async ({ url: url, fileName: fileName, fileType: fileType, successMessage: successMessage, errorMessage: errorMessage, blob: blob, controller: controller })=>{
    try {
        const response = await (0, $a04va.default).get(url, blob ? {
            responseType: "blob",
            signal: controller.signal
        } : {
            signal: controller.signal
        });
        const fileContents = !blob ? JSON.stringify(response.data) : response.data;
        const downloadBlob = new Blob([
            fileContents
        ], {
            type: fileType
        });
        // Create object URL and download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(downloadBlob);
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link); // Append to DOM for Firefox compatibility
        link.click();
        link.remove();
        URL.revokeObjectURL(link.href);
        return {
            success: true,
            data: successMessage
        };
    } catch (error) {
        /**
     * Processes an Axios error to extract a meaningful message
     *
     * @param error - The error object from the failed download attempt
     * @returns A string containing an extracted or default error message.
     */ const processError = async (error)=>{
            console.warn("DOWNLOAD FILE ERROR");
            let message = errorMessage;
            if (blob && error.response?.data) message = JSON.parse(await new Response(error.response?.data).text())?.message;
            else message = error.response?.data?.message;
            return message;
        };
        return {
            success: false,
            errorText: await processError(error)
        };
    }
};

});


parcelRegister("5UDwf", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitle", function () { return $23b4eb788854b968$export$4b208edda918084f; });

var $7fPBF = parcelRequire("7fPBF");
const $23b4eb788854b968$export$4b208edda918084f = (title)=>{
    (0, $7fPBF.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
};

});


parcelRegister("kIGng", function(module, exports) {

$parcel$export(module.exports, "TlfReviewRHS", function () { return $a1f23d8e3320704a$export$693ebee4d3097e72; });
$parcel$export(module.exports, "default", function () { return $a1f23d8e3320704a$export$2e2bcd8739ae039; });

var $bbzbN = parcelRequire("bbzbN");

var $95ovP = parcelRequire("95ovP");

var $aLtkT = parcelRequire("aLtkT");

var $9pA3o = parcelRequire("9pA3o");

var $9OQEa = parcelRequire("9OQEa");

var $equz4 = parcelRequire("equz4");

var $ozlyW = parcelRequire("ozlyW");

var $frJ3w = parcelRequire("frJ3w");
parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $j3Csp = parcelRequire("j3Csp");

var $fKICc = parcelRequire("fKICc");

var $6Ue2X = parcelRequire("6Ue2X");

var $alDlg = parcelRequire("alDlg");

var $gxpCl = parcelRequire("gxpCl");
const $a1f23d8e3320704a$export$249422c74d329dcd = ()=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $9pA3o.default), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $j3Csp.HierarchyContextProvider), {
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6Ue2X.TocContextProvider), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9OQEa.HierarchyTopBar), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "col-between-top-and-bottom",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $95ovP.Allotment), {
                            defaultSizes: [
                                1,
                                5
                            ],
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95ovP.Allotment).Pane, {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "small-scrollbar col-between-top-and-bottom",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ozlyW.TocTree), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95ovP.Allotment).Pane, {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gxpCl.Outlet), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $frJ3w.BottomNav), {})
                ]
            })
        })
    });
$a1f23d8e3320704a$export$249422c74d329dcd.displayName = "TlfReview";
const $a1f23d8e3320704a$export$693ebee4d3097e72 = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fKICc.TlfContextProvider), {
        readOnly: true,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($a1f23d8e3320704a$var$TlfReviewContent, {})
    });
};
/**
 * Renders the active review TLF, or an empty state when the route has no selected item.
 */ const $a1f23d8e3320704a$var$TlfReviewContent = ()=>{
    const { tlfData: tlfData } = (0, $cgEO2.useTlfContext)();
    return !tlfData ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "w-100 d-flex align-items-center justify-content-center",
        children: "No Tlf loaded"
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $95ovP.Allotment), {
        defaultSizes: [
            4,
            1
        ],
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95ovP.Allotment).Pane, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "small-scrollbar col-between-top-and-bottom",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $equz4.TlfInner), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95ovP.Allotment).Pane, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "small-scrollbar col-between-top-and-bottom",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aLtkT.CommentPanelInner), {
                        activeContext: "TlfItem"
                    })
                })
            })
        ]
    });
};
$a1f23d8e3320704a$var$TlfReviewContent.displayName = "TlfReviewContent";
$a1f23d8e3320704a$export$693ebee4d3097e72.displayName = "TlfReviewRHS";
var $a1f23d8e3320704a$export$2e2bcd8739ae039 = $a1f23d8e3320704a$export$249422c74d329dcd;

});
parcelRegister("95ovP", function(module, exports) {

$parcel$export(module.exports, "Allotment", function () { return $69d7985982c222e4$export$7250f71dae467feb; });

var $7fPBF = parcelRequire("7fPBF");
function $69d7985982c222e4$var$_extends() {
    return $69d7985982c222e4$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $69d7985982c222e4$var$_extends.apply(null, arguments);
}
var $69d7985982c222e4$var$l = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $69d7985982c222e4$var$u(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $69d7985982c222e4$var$c, $69d7985982c222e4$var$m = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ var $69d7985982c222e4$var$d, $69d7985982c222e4$var$f, $69d7985982c222e4$var$p, $69d7985982c222e4$var$v = ($69d7985982c222e4$var$c || ($69d7985982c222e4$var$c = 1, $69d7985982c222e4$var$d = $69d7985982c222e4$var$m, function() {
    var e = {}.hasOwnProperty;
    function t() {
        for(var e = "", t = 0; t < arguments.length; t++){
            var n = arguments[t];
            n && (e = s(e, i(n)));
        }
        return e;
    }
    function i(i) {
        if ("string" == typeof i || "number" == typeof i) return i;
        if ("object" != typeof i) return "";
        if (Array.isArray(i)) return t.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) return i.toString();
        var n = "";
        for(var r in i)e.call(i, r) && i[r] && (n = s(n, r));
        return n;
    }
    function s(e, t) {
        return t ? e ? e + " " + t : e + t : e;
    }
    $69d7985982c222e4$var$d.exports ? (t.default = t, $69d7985982c222e4$var$d.exports = t) : window.classNames = t;
}()), $69d7985982c222e4$var$m.exports), $69d7985982c222e4$var$S = $69d7985982c222e4$var$u($69d7985982c222e4$var$v);
var $69d7985982c222e4$var$z, $69d7985982c222e4$var$w, $69d7985982c222e4$var$g = ($69d7985982c222e4$var$p || ($69d7985982c222e4$var$p = 1, $69d7985982c222e4$var$f = function e(t, i) {
    if (t === i) return !0;
    if (t && i && "object" == typeof t && "object" == typeof i) {
        if (t.constructor !== i.constructor) return !1;
        var s, n, r;
        if (Array.isArray(t)) {
            if ((s = t.length) != i.length) return !1;
            for(n = s; 0 !== n--;)if (!e(t[n], i[n])) return !1;
            return !0;
        }
        if (t instanceof Map && i instanceof Map) {
            if (t.size !== i.size) return !1;
            for (n of t.entries())if (!i.has(n[0])) return !1;
            for (n of t.entries())if (!e(n[1], i.get(n[0]))) return !1;
            return !0;
        }
        if (t instanceof Set && i instanceof Set) {
            if (t.size !== i.size) return !1;
            for (n of t.entries())if (!i.has(n[0])) return !1;
            return !0;
        }
        if (ArrayBuffer.isView(t) && ArrayBuffer.isView(i)) {
            if ((s = t.length) != i.length) return !1;
            for(n = s; 0 !== n--;)if (t[n] !== i[n]) return !1;
            return !0;
        }
        if (t.constructor === RegExp) return t.source === i.source && t.flags === i.flags;
        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === i.valueOf();
        if (t.toString !== Object.prototype.toString) return t.toString() === i.toString();
        if ((s = (r = Object.keys(t)).length) !== Object.keys(i).length) return !1;
        for(n = s; 0 !== n--;)if (!Object.prototype.hasOwnProperty.call(i, r[n])) return !1;
        for(n = s; 0 !== n--;){
            var o = r[n];
            if (!e(t[o], i[o])) return !1;
        }
        return !0;
    }
    return t != t && i != i;
}), $69d7985982c222e4$var$f), $69d7985982c222e4$var$y = $69d7985982c222e4$var$u($69d7985982c222e4$var$g);
var $69d7985982c222e4$var$b, $69d7985982c222e4$var$I, $69d7985982c222e4$var$x = $69d7985982c222e4$var$u(function() {
    if ($69d7985982c222e4$var$w) return $69d7985982c222e4$var$z;
    $69d7985982c222e4$var$w = 1;
    var e = /^\s+|\s+$/g, t = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, n = parseInt, r = Object.prototype.toString;
    function o(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function a(a) {
        if ("number" == typeof a) return a;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && "[object Symbol]" == r.call(e);
        }(a)) return NaN;
        if (o(a)) {
            var h = "function" == typeof a.valueOf ? a.valueOf() : a;
            a = o(h) ? h + "" : h;
        }
        if ("string" != typeof a) return 0 === a ? a : +a;
        a = a.replace(e, "");
        var l = i.test(a);
        return l || s.test(a) ? n(a.slice(2), l ? 2 : 8) : t.test(a) ? NaN : +a;
    }
    return $69d7985982c222e4$var$z = function z(e, t, i) {
        return void 0 === i && (i = t, t = void 0), void 0 !== i && (i = (i = a(i)) == i ? i : 0), void 0 !== t && (t = (t = a(t)) == t ? t : 0), function(e, t, i) {
            return e == e && (void 0 !== i && (e = e <= i ? e : i), void 0 !== t && (e = e >= t ? e : t)), e;
        }(a(e), t, i);
    };
}());
var $69d7985982c222e4$var$_ = $69d7985982c222e4$var$u(function() {
    if ($69d7985982c222e4$var$I) return $69d7985982c222e4$var$b;
    $69d7985982c222e4$var$I = 1;
    var e = /^\s+|\s+$/g, t = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, n = parseInt, r = "object" == typeof $69d7985982c222e4$var$l && $69d7985982c222e4$var$l && $69d7985982c222e4$var$l.Object === Object && $69d7985982c222e4$var$l, o = "object" == typeof self && self && self.Object === Object && self, a = r || o || Function("return this")(), h = Object.prototype.toString, u = Math.max, c = Math.min, m = function m() {
        return a.Date.now();
    };
    function d(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function f(r) {
        if ("number" == typeof r) return r;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && "[object Symbol]" == h.call(e);
        }(r)) return NaN;
        if (d(r)) {
            var o = "function" == typeof r.valueOf ? r.valueOf() : r;
            r = d(o) ? o + "" : o;
        }
        if ("string" != typeof r) return 0 === r ? r : +r;
        r = r.replace(e, "");
        var a = i.test(r);
        return a || s.test(r) ? n(r.slice(2), a ? 2 : 8) : t.test(r) ? NaN : +r;
    }
    return $69d7985982c222e4$var$b = function b(e, t, i) {
        var s, n, r, o, a, h, l = 0, p = !1, v = !1, S = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        function z(t) {
            var i = s, r = n;
            return s = n = void 0, l = t, o = e.apply(r, i);
        }
        function w(e) {
            var i = e - h;
            return void 0 === h || i >= t || i < 0 || v && e - l >= r;
        }
        function g() {
            var e = m();
            if (w(e)) return y(e);
            a = setTimeout(g, function(e) {
                var i = t - (e - h);
                return v ? c(i, r - (e - l)) : i;
            }(e));
        }
        function y(e) {
            return a = void 0, S && s ? z(e) : (s = n = void 0, o);
        }
        function b() {
            var e = m(), i = w(e);
            if (s = arguments, n = this, h = e, i) {
                if (void 0 === a) return function(e) {
                    return l = e, a = setTimeout(g, t), p ? z(e) : o;
                }(h);
                if (v) return a = setTimeout(g, t), z(h);
            }
            return void 0 === a && (a = setTimeout(g, t)), o;
        }
        return t = f(t) || 0, d(i) && (p = !!i.leading, r = (v = "maxWait" in i) ? u(f(i.maxWait) || 0, t) : r, S = "trailing" in i ? !!i.trailing : S), b.cancel = function() {
            void 0 !== a && clearTimeout(a), l = 0, s = h = n = a = void 0;
        }, b.flush = function() {
            return void 0 === a ? o : y(m());
        }, b;
    };
}());
var $69d7985982c222e4$var$V = {
    width: void 0,
    height: void 0
};
function $69d7985982c222e4$var$E(e) {
    var { ref: r, box: o = "content-box" } = e, [{ width: a, height: h }, l] = (0, $7fPBF.useState)($69d7985982c222e4$var$V), u = function() {
        var e = (0, $7fPBF.useRef)(!1);
        return (0, $7fPBF.useEffect)(()=>(e.current = !0, ()=>{
                e.current = !1;
            }), []), (0, $7fPBF.useCallback)(()=>e.current, []);
    }(), c = (0, $7fPBF.useRef)($69d7985982c222e4$var$_extends({}, $69d7985982c222e4$var$V)), m = (0, $7fPBF.useRef)(void 0);
    return m.current = e.onResize, (0, $7fPBF.useEffect)(()=>{
        if (!r.current) return;
        if ("undefined" == typeof window || !("ResizeObserver" in window)) return;
        var e = new ResizeObserver((_ref)=>{
            var [e] = _ref;
            var t = "border-box" === o ? "borderBoxSize" : "device-pixel-content-box" === o ? "devicePixelContentBoxSize" : "contentBoxSize", i = $69d7985982c222e4$var$N(e, t, "inlineSize"), s = $69d7985982c222e4$var$N(e, t, "blockSize");
            if (c.current.width !== i || c.current.height !== s) {
                var _e2 = {
                    width: i,
                    height: s
                };
                c.current.width = i, c.current.height = s, m.current ? m.current(_e2) : u() && l(_e2);
            }
        });
        return e.observe(r.current, {
            box: o
        }), ()=>{
            e.disconnect();
        };
    }, [
        o,
        r,
        u
    ]), {
        width: a,
        height: h
    };
}
function $69d7985982c222e4$var$N(e, t, i) {
    return e[t] ? Array.isArray(e[t]) ? e[t][0][i] : e[t][i] : "contentBoxSize" === t ? e.contentRect["inlineSize" === i ? "width" : "height"] : void 0;
}
var $69d7985982c222e4$var$L = "allotment-module_splitView__L-yRc", $69d7985982c222e4$var$D = "allotment-module_sashContainer__fzwJF", $69d7985982c222e4$var$O = "allotment-module_splitViewContainer__rQnVa", $69d7985982c222e4$var$M = "allotment-module_splitViewView__MGZ6O", $69d7985982c222e4$var$P = "allotment-module_vertical__WSwwa", $69d7985982c222e4$var$T = "allotment-module_horizontal__7doS8", $69d7985982c222e4$var$C = "allotment-module_separatorBorder__x-rDS";
var $69d7985982c222e4$var$A, $69d7985982c222e4$var$j = !1, $69d7985982c222e4$var$F = !1;
"object" == typeof navigator && ($69d7985982c222e4$var$A = navigator.userAgent, $69d7985982c222e4$var$F = $69d7985982c222e4$var$A.indexOf("Macintosh") >= 0, $69d7985982c222e4$var$j = ($69d7985982c222e4$var$A.indexOf("Macintosh") >= 0 || $69d7985982c222e4$var$A.indexOf("iPad") >= 0 || $69d7985982c222e4$var$A.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
var $69d7985982c222e4$var$H = $69d7985982c222e4$var$j, $69d7985982c222e4$var$Y = $69d7985982c222e4$var$F, $69d7985982c222e4$var$k = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
class $69d7985982c222e4$var$$ {
    constructor(){
        this._size = void 0;
    }
    getSize() {
        return this._size;
    }
    setSize(e) {
        this._size = e;
    }
}
function $69d7985982c222e4$var$B(e, t) {
    var i = e.length, s = i - t.length;
    return s >= 0 && e.slice(s, i) === t;
}
var $69d7985982c222e4$var$R, $69d7985982c222e4$var$W = {
    exports: {}
};
var $69d7985982c222e4$var$X = ($69d7985982c222e4$var$R || ($69d7985982c222e4$var$R = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, i = "~";
    function s() {}
    function n(e, t, i) {
        this.fn = e, this.context = t, this.once = i || !1;
    }
    function r(e, t, s, r, o) {
        if ("function" != typeof s) throw new TypeError("The listener must be a function");
        var a = new n(s, r || e, o), h = i ? i + t : t;
        return e._events[h] ? e._events[h].fn ? e._events[h] = [
            e._events[h],
            a
        ] : e._events[h].push(a) : (e._events[h] = a, e._eventsCount++), e;
    }
    function o(e, t) {
        0 === --e._eventsCount ? e._events = new s() : delete e._events[t];
    }
    function a() {
        this._events = new s(), this._eventsCount = 0;
    }
    Object.create && (s.prototype = Object.create(null), new s().__proto__ || (i = !1)), a.prototype.eventNames = function() {
        var e, s, n = [];
        if (0 === this._eventsCount) return n;
        for(s in e = this._events)t.call(e, s) && n.push(i ? s.slice(1) : s);
        return Object.getOwnPropertySymbols ? n.concat(Object.getOwnPropertySymbols(e)) : n;
    }, a.prototype.listeners = function(e) {
        var t = i ? i + e : e, s = this._events[t];
        if (!s) return [];
        if (s.fn) return [
            s.fn
        ];
        for(var n = 0, r = s.length, o = new Array(r); n < r; n++)o[n] = s[n].fn;
        return o;
    }, a.prototype.listenerCount = function(e) {
        var t = i ? i + e : e, s = this._events[t];
        return s ? s.fn ? 1 : s.length : 0;
    }, a.prototype.emit = function(e, t, s, n, r, o) {
        var a = i ? i + e : e;
        if (!this._events[a]) return !1;
        var h, l, u = this._events[a], c = arguments.length;
        if (u.fn) {
            switch(u.once && this.removeListener(e, u.fn, void 0, !0), c){
                case 1:
                    return u.fn.call(u.context), !0;
                case 2:
                    return u.fn.call(u.context, t), !0;
                case 3:
                    return u.fn.call(u.context, t, s), !0;
                case 4:
                    return u.fn.call(u.context, t, s, n), !0;
                case 5:
                    return u.fn.call(u.context, t, s, n, r), !0;
                case 6:
                    return u.fn.call(u.context, t, s, n, r, o), !0;
            }
            for(l = 1, h = new Array(c - 1); l < c; l++)h[l - 1] = arguments[l];
            u.fn.apply(u.context, h);
        } else {
            var m, d = u.length;
            for(l = 0; l < d; l++)switch(u[l].once && this.removeListener(e, u[l].fn, void 0, !0), c){
                case 1:
                    u[l].fn.call(u[l].context);
                    break;
                case 2:
                    u[l].fn.call(u[l].context, t);
                    break;
                case 3:
                    u[l].fn.call(u[l].context, t, s);
                    break;
                case 4:
                    u[l].fn.call(u[l].context, t, s, n);
                    break;
                default:
                    if (!h) for(m = 1, h = new Array(c - 1); m < c; m++)h[m - 1] = arguments[m];
                    u[l].fn.apply(u[l].context, h);
            }
        }
        return !0;
    }, a.prototype.on = function(e, t, i) {
        return r(this, e, t, i, !1);
    }, a.prototype.once = function(e, t, i) {
        return r(this, e, t, i, !0);
    }, a.prototype.removeListener = function(e, t, s, n) {
        var r = i ? i + e : e;
        if (!this._events[r]) return this;
        if (!t) return o(this, r), this;
        var a = this._events[r];
        if (a.fn) a.fn !== t || n && !a.once || s && a.context !== s || o(this, r);
        else {
            for(var h = 0, l = [], u = a.length; h < u; h++)(a[h].fn !== t || n && !a[h].once || s && a[h].context !== s) && l.push(a[h]);
            l.length ? this._events[r] = 1 === l.length ? l[0] : l : o(this, r);
        }
        return this;
    }, a.prototype.removeAllListeners = function(e) {
        var t;
        return e ? (t = i ? i + e : e, this._events[t] && o(this, t)) : (this._events = new s(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = i, a.EventEmitter = a, e.exports = a;
}($69d7985982c222e4$var$W)), $69d7985982c222e4$var$W.exports), $69d7985982c222e4$var$G = $69d7985982c222e4$var$u($69d7985982c222e4$var$X);
function $69d7985982c222e4$var$J(e, t) {
    var i = e.indexOf(t);
    i > -1 && (e.splice(i, 1), e.unshift(t));
}
function $69d7985982c222e4$var$U(e, t) {
    var i = e.indexOf(t);
    i > -1 && (e.splice(i, 1), e.push(t));
}
function $69d7985982c222e4$var$K(e, t, i) {
    if (i === void 0) i = 1;
    var s = Math.max(0, Math.ceil((t - e) / i)), n = new Array(s);
    var r = -1;
    for(; ++r < s;)n[r] = e + r * i;
    return n;
}
var $69d7985982c222e4$var$Z = "sash-module_sash__K-9lB", $69d7985982c222e4$var$Q = "sash-module_disabled__Hm-wx", $69d7985982c222e4$var$q = "sash-module_mac__Jf6OJ", $69d7985982c222e4$var$ee = "sash-module_vertical__pB-rs", $69d7985982c222e4$var$te = "sash-module_minimum__-UKxp", $69d7985982c222e4$var$ie = "sash-module_maximum__TCWxD", $69d7985982c222e4$var$se = "sash-module_horizontal__kFbiw", $69d7985982c222e4$var$ne = "sash-module_hover__80W6I", $69d7985982c222e4$var$re = "sash-module_active__bJspD";
var $69d7985982c222e4$var$oe = function(e) {
    return e.Vertical = "VERTICAL", e.Horizontal = "HORIZONTAL", e;
}({}), $69d7985982c222e4$var$ae = function(e) {
    return e.Disabled = "DISABLED", e.Minimum = "MINIMUM", e.Maximum = "MAXIMUM", e.Enabled = "ENABLED", e;
}({}), $69d7985982c222e4$var$he = $69d7985982c222e4$var$H ? 20 : 8;
var $69d7985982c222e4$var$le = new $69d7985982c222e4$var$G();
class $69d7985982c222e4$var$ue extends $69d7985982c222e4$var$G {
    get state() {
        return this._state;
    }
    set state(e) {
        this._state !== e && (this.el.classList.toggle($69d7985982c222e4$var$Q, e === $69d7985982c222e4$var$ae.Disabled), this.el.classList.toggle("sash-disabled", e === $69d7985982c222e4$var$ae.Disabled), this.el.classList.toggle($69d7985982c222e4$var$te, e === $69d7985982c222e4$var$ae.Minimum), this.el.classList.toggle("sash-minimum", e === $69d7985982c222e4$var$ae.Minimum), this.el.classList.toggle($69d7985982c222e4$var$ie, e === $69d7985982c222e4$var$ae.Maximum), this.el.classList.toggle("sash-maximum", e === $69d7985982c222e4$var$ae.Maximum), this._state = e, this.emit("enablementChange", e));
    }
    constructor(e, t, i){
        var _i$orientation;
        super(), this.el = void 0, this.layoutProvider = void 0, this.orientation = void 0, this.size = void 0, this.hoverDelay = 300, this.hoverDelayer = $69d7985982c222e4$var$_((e)=>e.classList.add("sash-hover", $69d7985982c222e4$var$ne), this.hoverDelay), this._state = $69d7985982c222e4$var$ae.Enabled, this.onPointerStart = (e)=>{
            var t = e.pageX, i = e.pageY, s = {
                startX: t,
                currentX: t,
                startY: i,
                currentY: i
            };
            this.el.classList.add("sash-active", $69d7985982c222e4$var$re), this.emit("start", s), this.el.setPointerCapture(e.pointerId);
            var n = (e)=>{
                e.preventDefault();
                var s = {
                    startX: t,
                    currentX: e.pageX,
                    startY: i,
                    currentY: e.pageY
                };
                this.emit("change", s);
            }, r = (e)=>{
                e.preventDefault(), this.el.classList.remove("sash-active", $69d7985982c222e4$var$re), this.hoverDelayer.cancel(), this.emit("end"), this.el.releasePointerCapture(e.pointerId), window.removeEventListener("pointermove", n), window.removeEventListener("pointerup", r);
            };
            window.addEventListener("pointermove", n), window.addEventListener("pointerup", r);
        }, this.onPointerDoublePress = ()=>{
            this.emit("reset");
        }, this.onMouseEnter = ()=>{
            this.el.classList.contains($69d7985982c222e4$var$re) ? (this.hoverDelayer.cancel(), this.el.classList.add("sash-hover", $69d7985982c222e4$var$ne)) : this.hoverDelayer(this.el);
        }, this.onMouseLeave = ()=>{
            this.hoverDelayer.cancel(), this.el.classList.remove("sash-hover", $69d7985982c222e4$var$ne);
        }, this.el = document.createElement("div"), this.el.classList.add("sash", $69d7985982c222e4$var$Z), this.el.dataset.testid = "sash", e.append(this.el), $69d7985982c222e4$var$Y && this.el.classList.add("sash-mac", $69d7985982c222e4$var$q), this.el.addEventListener("pointerdown", this.onPointerStart), this.el.addEventListener("dblclick", this.onPointerDoublePress), this.el.addEventListener("mouseenter", this.onMouseEnter), this.el.addEventListener("mouseleave", this.onMouseLeave), "number" == typeof i.size ? (this.size = i.size, i.orientation === $69d7985982c222e4$var$oe.Vertical ? this.el.style.width = this.size + "px" : this.el.style.height = this.size + "px") : (this.size = $69d7985982c222e4$var$he, $69d7985982c222e4$var$le.on("onDidChangeGlobalSize", (e)=>{
            this.size = e, this.layout();
        })), this.layoutProvider = t, this.orientation = (_i$orientation = i.orientation) != null ? _i$orientation : $69d7985982c222e4$var$oe.Vertical, this.orientation === $69d7985982c222e4$var$oe.Horizontal ? (this.el.classList.add("sash-horizontal", $69d7985982c222e4$var$se), this.el.classList.remove("sash-vertical", $69d7985982c222e4$var$ee)) : (this.el.classList.remove("sash-horizontal", $69d7985982c222e4$var$se), this.el.classList.add("sash-vertical", $69d7985982c222e4$var$ee)), this.layout();
    }
    layout() {
        if (this.orientation === $69d7985982c222e4$var$oe.Vertical) {
            var _e3 = this.layoutProvider;
            this.el.style.left = _e3.getVerticalSashLeft(this) - this.size / 2 + "px", _e3.getVerticalSashTop && (this.el.style.top = _e3.getVerticalSashTop(this) + "px"), _e3.getVerticalSashHeight && (this.el.style.height = _e3.getVerticalSashHeight(this) + "px");
        } else {
            var _e4 = this.layoutProvider;
            this.el.style.top = _e4.getHorizontalSashTop(this) - this.size / 2 + "px", _e4.getHorizontalSashLeft && (this.el.style.left = _e4.getHorizontalSashLeft(this) + "px"), _e4.getHorizontalSashWidth && (this.el.style.width = _e4.getHorizontalSashWidth(this) + "px");
        }
    }
    dispose() {
        this.el.removeEventListener("pointerdown", this.onPointerStart), this.el.removeEventListener("dblclick", this.onPointerDoublePress), this.el.removeEventListener("mouseenter", this.onMouseEnter), this.el.removeEventListener("mouseleave", ()=>this.onMouseLeave), this.el.remove();
    }
}
var $69d7985982c222e4$var$ce;
var $69d7985982c222e4$var$me;
($69d7985982c222e4$var$me = $69d7985982c222e4$var$ce || ($69d7985982c222e4$var$ce = {})).Distribute = {
    type: "distribute"
}, $69d7985982c222e4$var$me.Split = function(e) {
    return {
        type: "split",
        index: e
    };
}, $69d7985982c222e4$var$me.Invisible = function(e) {
    return {
        type: "invisible",
        cachedVisibleSize: e
    };
};
var $69d7985982c222e4$export$56807b11ea7db5ce = function(e) {
    return e.Normal = "NORMAL", e.Low = "LOW", e.High = "HIGH", e;
}({});
class $69d7985982c222e4$var$fe {
    constructor(e, t, i){
        this.container = void 0, this.view = void 0, this._size = void 0, this._cachedVisibleSize = void 0, this.container = e, this.view = t, this.container.classList.add("split-view-view", $69d7985982c222e4$var$M), this.container.dataset.testid = "split-view-view", "number" == typeof i ? (this._size = i, this._cachedVisibleSize = void 0, e.classList.add("split-view-view-visible")) : (this._size = 0, this._cachedVisibleSize = i.cachedVisibleSize);
    }
    set size(e) {
        this._size = e;
    }
    get size() {
        return this._size;
    }
    get priority() {
        return this.view.priority;
    }
    get snap() {
        return !!this.view.snap;
    }
    get cachedVisibleSize() {
        return this._cachedVisibleSize;
    }
    get visible() {
        return void 0 === this._cachedVisibleSize;
    }
    setVisible(e, t) {
        e !== this.visible && (e ? (this.size = $69d7985982c222e4$var$x(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = "number" == typeof t ? t : this.size, this.size = 0), this.container.classList.toggle("split-view-view-visible", e), this.view.setVisible && this.view.setVisible(e));
    }
    get minimumSize() {
        return this.visible ? this.view.minimumSize : 0;
    }
    get viewMinimumSize() {
        return this.view.minimumSize;
    }
    get maximumSize() {
        return this.visible ? this.view.maximumSize : 0;
    }
    get viewMaximumSize() {
        return this.view.maximumSize;
    }
    set enabled(e) {
        this.container.style.pointerEvents = e ? "" : "none";
    }
    layout(e) {
        this.layoutContainer(e), this.view.layout(this.size, e);
    }
}
class $69d7985982c222e4$var$pe extends $69d7985982c222e4$var$fe {
    layoutContainer(e) {
        this.container.style.left = e + "px", this.container.style.width = this.size + "px";
    }
}
class $69d7985982c222e4$var$ve extends $69d7985982c222e4$var$fe {
    layoutContainer(e) {
        this.container.style.top = e + "px", this.container.style.height = this.size + "px";
    }
}
class $69d7985982c222e4$var$Se extends $69d7985982c222e4$var$G {
    get startSnappingEnabled() {
        return this._startSnappingEnabled;
    }
    set startSnappingEnabled(e) {
        this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
    }
    get endSnappingEnabled() {
        return this._endSnappingEnabled;
    }
    set endSnappingEnabled(e) {
        this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
    }
    constructor(e, t, i, s, n){
        var _t$orientation, _t$proportionalLayout;
        if (t === void 0) t = {};
        if (super(), this.onDidChange = void 0, this.onDidDragStart = void 0, this.onDidDragEnd = void 0, this.orientation = void 0, this.sashContainer = void 0, this.size = 0, this.contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.sashDragState = void 0, this.proportionalLayout = void 0, this.getSashOrthogonalSize = void 0, this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onSashEnd = (e)=>{
            this.emit("sashchange", e), this.saveProportions();
            for (var _e5 of this.viewItems)_e5.enabled = !0;
        }, this.orientation = (_t$orientation = t.orientation) != null ? _t$orientation : $69d7985982c222e4$var$oe.Vertical, this.proportionalLayout = (_t$proportionalLayout = t.proportionalLayout) != null ? _t$proportionalLayout : !0, this.getSashOrthogonalSize = t.getSashOrthogonalSize, i && (this.onDidChange = i), s && (this.onDidDragStart = s), n && (this.onDidDragEnd = n), this.sashContainer = document.createElement("div"), this.sashContainer.classList.add("sash-container", $69d7985982c222e4$var$D), e.prepend(this.sashContainer), t.descriptor) {
            this.size = t.descriptor.size;
            for (var [_e6, _i] of t.descriptor.views.entries()){
                var _t = _i.size, _s = _i.container, _n = _i.view;
                this.addView(_s, _n, _t, _e6, !0);
            }
            this.contentSize = this.viewItems.reduce((e, t)=>e + t.size, 0), this.saveProportions();
        }
    }
    addView(e, t, i, s, n) {
        if (s === void 0) s = this.viewItems.length;
        var r;
        r = "number" == typeof i ? i : "split" === i.type ? this.getViewSize(i.index) / 2 : "invisible" === i.type ? {
            cachedVisibleSize: i.cachedVisibleSize
        } : t.minimumSize;
        var o = this.orientation === $69d7985982c222e4$var$oe.Vertical ? new $69d7985982c222e4$var$ve(e, t, r) : new $69d7985982c222e4$var$pe(e, t, r);
        if (this.viewItems.splice(s, 0, o), this.viewItems.length > 1) {
            var _e7 = this.orientation === $69d7985982c222e4$var$oe.Vertical ? new $69d7985982c222e4$var$ue(this.sashContainer, {
                getHorizontalSashTop: (e)=>this.getSashPosition(e),
                getHorizontalSashWidth: this.getSashOrthogonalSize
            }, {
                orientation: $69d7985982c222e4$var$oe.Horizontal
            }) : new $69d7985982c222e4$var$ue(this.sashContainer, {
                getVerticalSashLeft: (e)=>this.getSashPosition(e),
                getVerticalSashHeight: this.getSashOrthogonalSize
            }, {
                orientation: $69d7985982c222e4$var$oe.Vertical
            }), _t2 = this.orientation === $69d7985982c222e4$var$oe.Vertical ? (t)=>({
                    sash: _e7,
                    start: t.startY,
                    current: t.currentY
                }) : (t)=>({
                    sash: _e7,
                    start: t.startX,
                    current: t.currentX
                });
            _e7.on("start", (e)=>{
                var _this$onDidDragStart;
                this.emit("sashDragStart"), this.onSashStart(_t2(e));
                var i = this.viewItems.map((e)=>e.size);
                (_this$onDidDragStart = this.onDidDragStart) == null || _this$onDidDragStart.call(this, i);
            }), _e7.on("change", (e)=>this.onSashChange(_t2(e))), _e7.on("end", ()=>{
                var _this$onDidDragEnd;
                this.emit("sashDragEnd"), this.onSashEnd(this.sashItems.findIndex((t)=>t.sash === _e7));
                var t = this.viewItems.map((e)=>e.size);
                (_this$onDidDragEnd = this.onDidDragEnd) == null || _this$onDidDragEnd.call(this, t);
            }), _e7.on("reset", ()=>{
                var t = this.sashItems.findIndex((t)=>t.sash === _e7), i = $69d7985982c222e4$var$K(t, -1, -1), s = $69d7985982c222e4$var$K(t + 1, this.viewItems.length), n = this.findFirstSnapIndex(i), r = this.findFirstSnapIndex(s);
                ("number" != typeof n || this.viewItems[n].visible) && ("number" != typeof r || this.viewItems[r].visible) && this.emit("sashreset", t);
            });
            var _i2 = {
                sash: _e7
            };
            this.sashItems.splice(s - 1, 0, _i2);
        }
        n || this.relayout(), n || "number" == typeof i || "distribute" !== i.type || this.distributeViewSizes();
    }
    removeView(e, t) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        var i = this.viewItems.splice(e, 1)[0].view;
        if (this.viewItems.length >= 1) {
            var _t3 = Math.max(e - 1, 0);
            this.sashItems.splice(_t3, 1)[0].sash.dispose();
        }
        return this.relayout(), t && "distribute" === t.type && this.distributeViewSizes(), i;
    }
    moveView(e, t, i) {
        var s = this.getViewCachedVisibleSize(t), n = void 0 === s ? this.getViewSize(t) : $69d7985982c222e4$var$ce.Invisible(s), r = this.removeView(t);
        this.addView(e, r, n, i);
    }
    getViewCachedVisibleSize(e) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        return this.viewItems[e].cachedVisibleSize;
    }
    layout(e) {
        if (e === void 0) e = this.size;
        var t = Math.max(this.size, this.contentSize);
        if (this.size = e, this.proportions) for(var _t4 = 0; _t4 < this.viewItems.length; _t4++){
            var _i3 = this.viewItems[_t4];
            _i3.size = $69d7985982c222e4$var$x(Math.round(this.proportions[_t4] * e), _i3.minimumSize, _i3.maximumSize);
        }
        else {
            var _i4 = $69d7985982c222e4$var$K(0, this.viewItems.length), _s2 = _i4.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.Low), _n2 = _i4.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.High);
            this.resize(this.viewItems.length - 1, e - t, void 0, _s2, _n2);
        }
        this.distributeEmptySpace(), this.layoutViews();
    }
    resizeView(e, t) {
        if (e < 0 || e >= this.viewItems.length) return;
        var i = $69d7985982c222e4$var$K(0, this.viewItems.length).filter((t)=>t !== e), s = [
            ...i.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.Low),
            e
        ], n = i.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.High), r = this.viewItems[e];
        t = Math.round(t), t = $69d7985982c222e4$var$x(t, r.minimumSize, Math.min(r.maximumSize, this.size)), r.size = t, this.relayout(s, n);
    }
    resizeViews(e) {
        for(var _t5 = 0; _t5 < e.length; _t5++){
            var _i5 = this.viewItems[_t5];
            var _s3 = e[_t5];
            _s3 = Math.round(_s3), _s3 = $69d7985982c222e4$var$x(_s3, _i5.minimumSize, Math.min(_i5.maximumSize, this.size)), _i5.size = _s3;
        }
        this.contentSize = this.viewItems.reduce((e, t)=>e + t.size, 0), this.saveProportions(), this.layout(this.size);
    }
    getViewSize(e) {
        return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
    }
    isViewVisible(e) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        return this.viewItems[e].visible;
    }
    setViewVisible(e, t) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        this.viewItems[e].setVisible(t), this.distributeEmptySpace(e), this.layoutViews(), this.saveProportions();
    }
    distributeViewSizes() {
        var e = [];
        var t = 0;
        for (var _i6 of this.viewItems)_i6.maximumSize - _i6.minimumSize > 0 && (e.push(_i6), t += _i6.size);
        var i = Math.floor(t / e.length);
        for (var _t6 of e)_t6.size = $69d7985982c222e4$var$x(i, _t6.minimumSize, _t6.maximumSize);
        var s = $69d7985982c222e4$var$K(0, this.viewItems.length), n = s.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.Low), r = s.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.High);
        this.relayout(n, r);
    }
    dispose() {
        this.sashItems.forEach((e)=>e.sash.dispose()), this.sashItems = [], this.sashContainer.remove();
    }
    relayout(e, t) {
        var i = this.viewItems.reduce((e, t)=>e + t.size, 0);
        this.resize(this.viewItems.length - 1, this.size - i, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
    }
    onSashStart(_ref2) {
        var { sash: e, start: t } = _ref2;
        var i = this.sashItems.findIndex((t)=>t.sash === e);
        ((e)=>{
            var t = this.viewItems.map((e)=>e.size);
            var s, n, r = Number.NEGATIVE_INFINITY, o = Number.POSITIVE_INFINITY;
            var a = $69d7985982c222e4$var$K(i, -1, -1), h = $69d7985982c222e4$var$K(i + 1, this.viewItems.length), l = a.reduce((e, i)=>e + (this.viewItems[i].minimumSize - t[i]), 0), u = a.reduce((e, i)=>e + (this.viewItems[i].viewMaximumSize - t[i]), 0), c = 0 === h.length ? Number.POSITIVE_INFINITY : h.reduce((e, i)=>e + (t[i] - this.viewItems[i].minimumSize), 0), m = 0 === h.length ? Number.NEGATIVE_INFINITY : h.reduce((e, i)=>e + (t[i] - this.viewItems[i].viewMaximumSize), 0);
            r = Math.max(l, m), o = Math.min(c, u);
            var d = this.findFirstSnapIndex(a), f = this.findFirstSnapIndex(h);
            if ("number" == typeof d) {
                var _e8 = this.viewItems[d], _t7 = Math.floor(_e8.viewMinimumSize / 2);
                s = {
                    index: d,
                    limitDelta: _e8.visible ? r - _t7 : r + _t7,
                    size: _e8.size
                };
            }
            if ("number" == typeof f) {
                var _e9 = this.viewItems[f], _t8 = Math.floor(_e9.viewMinimumSize / 2);
                n = {
                    index: f,
                    limitDelta: _e9.visible ? o + _t8 : o - _t8,
                    size: _e9.size
                };
            }
            this.sashDragState = {
                start: e,
                current: e,
                index: i,
                sizes: t,
                minDelta: r,
                maxDelta: o,
                snapBefore: s,
                snapAfter: n
            };
        })(t);
    }
    onSashChange(_ref3) {
        var { current: e } = _ref3;
        var { index: t, start: i, sizes: s, minDelta: n, maxDelta: r, snapBefore: o, snapAfter: a } = this.sashDragState;
        this.sashDragState.current = e;
        var h = e - i;
        this.resize(t, h, s, void 0, void 0, n, r, o, a), this.distributeEmptySpace(), this.layoutViews();
    }
    getSashPosition(e) {
        var t = 0;
        for(var _i7 = 0; _i7 < this.sashItems.length; _i7++)if (t += this.viewItems[_i7].size, this.sashItems[_i7].sash === e) return t;
        return 0;
    }
    resize(e, t, i, s, n, r, o, a, h) {
        if (i === void 0) i = this.viewItems.map((e)=>e.size);
        if (r === void 0) r = Number.NEGATIVE_INFINITY;
        if (o === void 0) o = Number.POSITIVE_INFINITY;
        if (e < 0 || e >= this.viewItems.length) return 0;
        var l = $69d7985982c222e4$var$K(e, -1, -1), u = $69d7985982c222e4$var$K(e + 1, this.viewItems.length);
        if (n) for (var _e0 of n)$69d7985982c222e4$var$J(l, _e0), $69d7985982c222e4$var$J(u, _e0);
        if (s) for (var _e1 of s)$69d7985982c222e4$var$U(l, _e1), $69d7985982c222e4$var$U(u, _e1);
        var c = l.map((e)=>this.viewItems[e]), m = l.map((e)=>i[e]), d = u.map((e)=>this.viewItems[e]), f = u.map((e)=>i[e]), p = l.reduce((e, t)=>e + (this.viewItems[t].minimumSize - i[t]), 0), v = l.reduce((e, t)=>e + (this.viewItems[t].maximumSize - i[t]), 0), S = 0 === u.length ? Number.POSITIVE_INFINITY : u.reduce((e, t)=>e + (i[t] - this.viewItems[t].minimumSize), 0), z = 0 === u.length ? Number.NEGATIVE_INFINITY : u.reduce((e, t)=>e + (i[t] - this.viewItems[t].maximumSize), 0), w = Math.max(p, z, r), g = Math.min(S, v, o);
        var y = !1;
        if (a) {
            var _e10 = this.viewItems[a.index], _i8 = t >= a.limitDelta;
            y = _i8 !== _e10.visible, _e10.setVisible(_i8, a.size);
        }
        if (!y && h) {
            var _e11 = this.viewItems[h.index], _i9 = t < h.limitDelta;
            y = _i9 !== _e11.visible, _e11.setVisible(_i9, h.size);
        }
        if (y) return this.resize(e, t, i, s, n, r, o);
        for(var _e12 = 0, _i0 = t = $69d7985982c222e4$var$x(t, w, g); _e12 < c.length; _e12++){
            var _t9 = c[_e12], _s4 = $69d7985982c222e4$var$x(m[_e12] + _i0, _t9.minimumSize, _t9.maximumSize);
            _i0 -= _s4 - m[_e12], _t9.size = _s4;
        }
        for(var _e13 = 0, _i1 = t; _e13 < d.length; _e13++){
            var _t0 = d[_e13], _s5 = $69d7985982c222e4$var$x(f[_e13] - _i1, _t0.minimumSize, _t0.maximumSize);
            _i1 += _s5 - f[_e13], _t0.size = _s5;
        }
        return t;
    }
    distributeEmptySpace(e) {
        var t = this.viewItems.reduce((e, t)=>e + t.size, 0);
        var i = this.size - t;
        var s = $69d7985982c222e4$var$K(0, this.viewItems.length), n = [], r = s.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.Low), o = s.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.Normal), a = s.filter((e)=>this.viewItems[e].priority === $69d7985982c222e4$export$56807b11ea7db5ce.High);
        n.push(...a, ...o, ...r), "number" == typeof e && $69d7985982c222e4$var$U(n, e);
        for(var _e14 = 0; 0 !== i && _e14 < n.length; _e14++){
            var _t1 = this.viewItems[n[_e14]], _s6 = $69d7985982c222e4$var$x(_t1.size + i, _t1.minimumSize, _t1.maximumSize);
            i -= _s6 - _t1.size, _t1.size = _s6;
        }
    }
    layoutViews() {
        var _this$onDidChange;
        this.contentSize = this.viewItems.reduce((e, t)=>e + t.size, 0);
        var e = 0;
        for (var _t10 of this.viewItems)_t10.layout(e), e += _t10.size;
        (_this$onDidChange = this.onDidChange) != null && _this$onDidChange.call(this, this.viewItems.map((e)=>e.size)), this.sashItems.forEach((e)=>e.sash.layout()), this.updateSashEnablement();
    }
    saveProportions() {
        this.proportionalLayout && this.contentSize > 0 && (this.proportions = this.viewItems.map((e)=>e.size / this.contentSize));
    }
    updateSashEnablement() {
        var e = !1;
        var t = this.viewItems.map((t)=>e = t.size - t.minimumSize > 0 || e);
        e = !1;
        var i = this.viewItems.map((t)=>e = t.maximumSize - t.size > 0 || e), s = [
            ...this.viewItems
        ].reverse();
        e = !1;
        var n = s.map((t)=>e = t.size - t.minimumSize > 0 || e).reverse();
        e = !1;
        var r = s.map((t)=>e = t.maximumSize - t.size > 0 || e).reverse();
        var o = 0;
        for(var _e15 = 0; _e15 < this.sashItems.length; _e15++){
            var { sash: _s7 } = this.sashItems[_e15];
            o += this.viewItems[_e15].size;
            var _a = !(t[_e15] && r[_e15 + 1]), _h = !(i[_e15] && n[_e15 + 1]);
            if (_a && _h) {
                var _i10 = $69d7985982c222e4$var$K(_e15, -1, -1), _r = $69d7985982c222e4$var$K(_e15 + 1, this.viewItems.length), _a2 = this.findFirstSnapIndex(_i10), _h2 = this.findFirstSnapIndex(_r), _l = "number" == typeof _a2 && !this.viewItems[_a2].visible, _u = "number" == typeof _h2 && !this.viewItems[_h2].visible;
                _l && n[_e15] && (o > 0 || this.startSnappingEnabled) ? _s7.state = $69d7985982c222e4$var$ae.Minimum : _u && t[_e15] && (o < this.contentSize || this.endSnappingEnabled) ? _s7.state = $69d7985982c222e4$var$ae.Maximum : _s7.state = $69d7985982c222e4$var$ae.Disabled;
            } else _s7.state = _a && !_h ? $69d7985982c222e4$var$ae.Minimum : !_a && _h ? $69d7985982c222e4$var$ae.Maximum : $69d7985982c222e4$var$ae.Enabled;
        }
    }
    findFirstSnapIndex(e) {
        for (var _t11 of e){
            var _e16 = this.viewItems[_t11];
            if (_e16.visible && _e16.snap) return _t11;
        }
        for (var _t12 of e){
            var _e17 = this.viewItems[_t12];
            if (_e17.visible && _e17.maximumSize - _e17.minimumSize > 0) return;
            if (!_e17.visible && _e17.snap) return _t12;
        }
    }
}
class $69d7985982c222e4$var$ze {
    constructor(e){
        this.size = void 0, this.size = e;
    }
    getPreferredSize() {
        return this.size;
    }
}
class $69d7985982c222e4$var$we {
    constructor(e, t){
        this.proportion = void 0, this.layoutService = void 0, this.proportion = e, this.layoutService = t;
    }
    getPreferredSize() {
        return this.proportion * this.layoutService.getSize();
    }
}
class $69d7985982c222e4$var$ge {
    getPreferredSize() {}
}
class $69d7985982c222e4$var$ye {
    get preferredSize() {
        return this.layoutStrategy.getPreferredSize();
    }
    set preferredSize(e) {
        if ("number" == typeof e) this.layoutStrategy = new $69d7985982c222e4$var$ze(e);
        else if ("string" == typeof e) {
            var _t13 = e.trim();
            if ($69d7985982c222e4$var$B(_t13, "%")) {
                var _e18 = Number(_t13.slice(0, -1)) / 100;
                this.layoutStrategy = new $69d7985982c222e4$var$we(_e18, this.layoutService);
            } else if ($69d7985982c222e4$var$B(_t13, "px")) {
                var _e19 = Number(_t13.slice(0, -2)) / 100;
                this.layoutStrategy = new $69d7985982c222e4$var$ze(_e19);
            } else if ("number" == typeof Number.parseFloat(_t13)) {
                var _e20 = Number.parseFloat(_t13);
                this.layoutStrategy = new $69d7985982c222e4$var$ze(_e20);
            } else this.layoutStrategy = new $69d7985982c222e4$var$ge();
        } else this.layoutStrategy = new $69d7985982c222e4$var$ge();
    }
    constructor(e, t){
        var _t$priority;
        if (this.minimumSize = 0, this.maximumSize = Number.POSITIVE_INFINITY, this.element = void 0, this.priority = void 0, this.snap = void 0, this.layoutService = void 0, this.layoutStrategy = void 0, this.layoutService = e, this.element = t.element, this.minimumSize = "number" == typeof t.minimumSize ? t.minimumSize : 30, this.maximumSize = "number" == typeof t.maximumSize ? t.maximumSize : Number.POSITIVE_INFINITY, "number" == typeof t.preferredSize) this.layoutStrategy = new $69d7985982c222e4$var$ze(t.preferredSize);
        else if ("string" == typeof t.preferredSize) {
            var _e21 = t.preferredSize.trim();
            if ($69d7985982c222e4$var$B(_e21, "%")) {
                var _t14 = Number(_e21.slice(0, -1)) / 100;
                this.layoutStrategy = new $69d7985982c222e4$var$we(_t14, this.layoutService);
            } else if ($69d7985982c222e4$var$B(_e21, "px")) {
                var _t15 = Number(_e21.slice(0, -2));
                this.layoutStrategy = new $69d7985982c222e4$var$ze(_t15);
            } else if ("number" == typeof Number.parseFloat(_e21)) {
                var _t16 = Number.parseFloat(_e21);
                this.layoutStrategy = new $69d7985982c222e4$var$ze(_t16);
            } else this.layoutStrategy = new $69d7985982c222e4$var$ge();
        } else this.layoutStrategy = new $69d7985982c222e4$var$ge();
        this.priority = (_t$priority = t.priority) != null ? _t$priority : $69d7985982c222e4$export$56807b11ea7db5ce.Normal, this.snap = "boolean" == typeof t.snap && t.snap;
    }
    layout(e) {}
}
function $69d7985982c222e4$var$be(e) {
    return void 0 !== e.minSize || void 0 !== e.maxSize || void 0 !== e.preferredSize || void 0 !== e.priority || void 0 !== e.visible;
}
var $69d7985982c222e4$var$Ie = (0, $7fPBF.forwardRef)((_ref4, s)=>{
    var { className: t, children: i } = _ref4;
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ref: s,
        className: $69d7985982c222e4$var$S("split-view-view", $69d7985982c222e4$var$M, t)
    }, i);
});
$69d7985982c222e4$var$Ie.displayName = "Allotment.Pane";
var $69d7985982c222e4$var$xe = (0, $7fPBF.forwardRef)((_ref5, _)=>{
    var { children: r, className: o, id: l, maxSize: u = 1 / 0, minSize: c = 30, proportionalLayout: m = !0, separator: d = !0, sizes: f, defaultSizes: p = f, snap: v = !1, vertical: z = !1, onChange: w, onReset: g, onVisibleChange: b, onDragStart: I, onDragEnd: x } = _ref5;
    var V = (0, $7fPBF.useRef)(null), N = (0, $7fPBF.useRef)([]), D = (0, $7fPBF.useRef)(new Map()), M = (0, $7fPBF.useRef)(null), A = (0, $7fPBF.useRef)(new Map()), j = (0, $7fPBF.useRef)(new $69d7985982c222e4$var$$()), F = (0, $7fPBF.useRef)([]), [Y, B] = (0, $7fPBF.useState)(!1);
    f && console.warn("Prop sizes is deprecated. Please use defaultSizes instead.");
    var R = (0, $7fPBF.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.toArray(r).filter((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement), [
        r
    ]), W = (0, $7fPBF.useCallback)((e)=>{
        var _F$current, _M$current;
        var t = (_F$current = F.current) == null ? void 0 : _F$current[e];
        return "number" == typeof (t == null ? void 0 : t.preferredSize) && ((_M$current = M.current) != null && _M$current.resizeView(e, Math.round(t.preferredSize)), !0);
    }, []);
    return (0, $7fPBF.useImperativeHandle)(_, ()=>({
            reset: ()=>{
                if (g) g();
                else {
                    var _M$current2;
                    (_M$current2 = M.current) == null || _M$current2.distributeViewSizes();
                    for(var _e22 = 0; _e22 < F.current.length; _e22++)W(_e22);
                }
            },
            resize: (e)=>{
                var _M$current3;
                (_M$current3 = M.current) == null || _M$current3.resizeViews(e);
            }
        })), $69d7985982c222e4$var$k(()=>{
        var e = !0;
        p && A.current.size !== p.length && (e = !1, console.warn("Expected " + p.length + " children based on defaultSizes but found " + A.current.size)), e && p && (N.current = R.map((e)=>e.key));
        var t = $69d7985982c222e4$var$_extends({
            orientation: z ? $69d7985982c222e4$var$oe.Vertical : $69d7985982c222e4$var$oe.Horizontal,
            proportionalLayout: m
        }, e && p && {
            descriptor: {
                size: p.reduce((e, t)=>e + t, 0),
                views: p.map((e, t)=>{
                    var _i$minSize, _i$maxSize, _i$priority, _i$snap;
                    var i = D.current.get(N.current[t]), s = new $69d7985982c222e4$var$ye(j.current, $69d7985982c222e4$var$_extends({
                        element: document.createElement("div"),
                        minimumSize: (_i$minSize = i == null ? void 0 : i.minSize) != null ? _i$minSize : c,
                        maximumSize: (_i$maxSize = i == null ? void 0 : i.maxSize) != null ? _i$maxSize : u,
                        priority: (_i$priority = i == null ? void 0 : i.priority) != null ? _i$priority : $69d7985982c222e4$export$56807b11ea7db5ce.Normal
                    }, (i == null ? void 0 : i.preferredSize) && {
                        preferredSize: i == null ? void 0 : i.preferredSize
                    }, {
                        snap: (_i$snap = i == null ? void 0 : i.snap) != null ? _i$snap : v
                    }));
                    return F.current.push(s), {
                        container: [
                            ...A.current.values()
                        ][t],
                        size: e,
                        view: s
                    };
                })
            }
        });
        M.current = new $69d7985982c222e4$var$Se(V.current, t, w, I, x), M.current.on("sashDragStart", ()=>{
            var _V$current;
            (_V$current = V.current) == null || _V$current.classList.add("split-view-sash-dragging");
        }), M.current.on("sashDragEnd", ()=>{
            var _V$current2;
            (_V$current2 = V.current) == null || _V$current2.classList.remove("split-view-sash-dragging");
        }), M.current.on("sashchange", (e)=>{
            if (b && M.current) {
                var _e23 = R.map((e)=>e.key);
                for(var _t17 = 0; _t17 < _e23.length; _t17++){
                    var _i11 = D.current.get(_e23[_t17]);
                    void 0 !== (_i11 == null ? void 0 : _i11.visible) && _i11.visible !== M.current.isViewVisible(_t17) && b(_t17, M.current.isViewVisible(_t17));
                }
            }
        }), M.current.on("sashreset", (e)=>{
            if (g) g();
            else {
                var _M$current4;
                if (W(e)) return;
                if (W(e + 1)) return;
                (_M$current4 = M.current) == null || _M$current4.distributeViewSizes();
            }
        });
        var i = M.current;
        return ()=>{
            i.dispose();
        };
    }, []), $69d7985982c222e4$var$k(()=>{
        if (Y) {
            var _e24 = R.map((e)=>e.key), _t18 = [
                ...N.current
            ], _i12 = _e24.filter((e)=>!N.current.includes(e)), _s8 = _e24.filter((e)=>N.current.includes(e)), _n3 = N.current.map((t)=>!_e24.includes(t));
            for(var _e25 = _n3.length - 1; _e25 >= 0; _e25--){
                var _M$current5;
                _n3[_e25] && ((_M$current5 = M.current) != null && _M$current5.removeView(_e25), _t18.splice(_e25, 1), F.current.splice(_e25, 1));
            }
            var _loop = function _loop(_s9) {
                var _i$minSize2, _i$maxSize2, _i$priority2, _i$snap2, _M$current7;
                var i = D.current.get(_s9), n = new $69d7985982c222e4$var$ye(j.current, $69d7985982c222e4$var$_extends({
                    element: document.createElement("div"),
                    minimumSize: (_i$minSize2 = i == null ? void 0 : i.minSize) != null ? _i$minSize2 : c,
                    maximumSize: (_i$maxSize2 = i == null ? void 0 : i.maxSize) != null ? _i$maxSize2 : u,
                    priority: (_i$priority2 = i == null ? void 0 : i.priority) != null ? _i$priority2 : $69d7985982c222e4$export$56807b11ea7db5ce.Normal
                }, (i == null ? void 0 : i.preferredSize) && {
                    preferredSize: i == null ? void 0 : i.preferredSize
                }, {
                    snap: (_i$snap2 = i == null ? void 0 : i.snap) != null ? _i$snap2 : v
                }));
                (_M$current7 = M.current) != null && _M$current7.addView(A.current.get(_s9), n, $69d7985982c222e4$var$ce.Distribute, _e24.findIndex((e)=>e === _s9)), _t18.splice(_e24.findIndex((e)=>e === _s9), 0, _s9), F.current.splice(_e24.findIndex((e)=>e === _s9), 0, n);
            };
            for (var _s9 of _i12)_loop(_s9);
            for(; !$69d7985982c222e4$var$y(_e24, _t18);){
                var _loop2 = function _loop2(_s0) {
                    var e = _t18.findIndex((e)=>e === _s0);
                    if (e !== _i13) {
                        var _M$current6;
                        (_M$current6 = M.current) == null || _M$current6.moveView(A.current.get(_s0), e, _i13);
                        var _n4 = _t18[e];
                        _t18.splice(e, 1), _t18.splice(_i13, 0, _n4);
                        return 1; // break
                    }
                };
                for (var [_i13, _s0] of _e24.entries()){
                    if (_loop2(_s0)) break;
                }
            }
            var _loop3 = function _loop3(_t19) {
                var _M$current8;
                var i = _e24.findIndex((e)=>e === _t19), s = F.current[i].preferredSize;
                void 0 !== s && ((_M$current8 = M.current) == null || _M$current8.resizeView(i, s));
            };
            for (var _t19 of _i12)_loop3(_t19);
            var _loop4 = function _loop4(_t20) {
                var _M$current9, _M$current0;
                var i = D.current.get(_t20), s = _e24.findIndex((e)=>e === _t20);
                i && $69d7985982c222e4$var$be(i) && void 0 !== i.visible && ((_M$current9 = M.current) == null ? void 0 : _M$current9.isViewVisible(s)) !== i.visible && ((_M$current0 = M.current) == null || _M$current0.setViewVisible(s, i.visible));
            };
            for (var _t20 of [
                ..._i12,
                ..._s8
            ])_loop4(_t20);
            var _loop5 = function _loop5(_t21) {
                var i = D.current.get(_t21), s = _e24.findIndex((e)=>e === _t21);
                if (i && $69d7985982c222e4$var$be(i)) {
                    var _M$current1;
                    void 0 !== i.preferredSize && F.current[s].preferredSize !== i.preferredSize && (F.current[s].preferredSize = i.preferredSize);
                    var _e26 = !1;
                    void 0 !== i.minSize && F.current[s].minimumSize !== i.minSize && (F.current[s].minimumSize = i.minSize, _e26 = !0), void 0 !== i.maxSize && F.current[s].maximumSize !== i.maxSize && (F.current[s].maximumSize = i.maxSize, _e26 = !0), _e26 && ((_M$current1 = M.current) == null || _M$current1.layout());
                }
            };
            for (var _t21 of _s8)_loop5(_t21);
            (_i12.length > 0 || _n3.length > 0) && (N.current = _e24);
        }
    }, [
        R,
        Y,
        u,
        c,
        v
    ]), (0, $7fPBF.useEffect)(()=>{
        M.current && (M.current.onDidChange = w);
    }, [
        w
    ]), (0, $7fPBF.useEffect)(()=>{
        M.current && (M.current.onDidDragStart = I);
    }, [
        I
    ]), (0, $7fPBF.useEffect)(()=>{
        M.current && (M.current.onDidDragEnd = x);
    }, [
        x
    ]), $69d7985982c222e4$var$E({
        ref: V,
        onResize: (_ref6)=>{
            var _M$current10;
            var { width: e, height: t } = _ref6;
            e && t && ((_M$current10 = M.current) != null && _M$current10.layout(z ? t : e), j.current.setSize(z ? t : e), B(!0));
        }
    }), (0, $7fPBF.useEffect)(()=>{
        $69d7985982c222e4$var$H && $69d7985982c222e4$export$aed1c99c50218917(20);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ref: V,
        className: $69d7985982c222e4$var$S("split-view", z ? "split-view-vertical" : "split-view-horizontal", {
            "split-view-separator-border": d
        }, $69d7985982c222e4$var$L, z ? $69d7985982c222e4$var$P : $69d7985982c222e4$var$T, {
            [$69d7985982c222e4$var$C]: d
        }, o),
        id: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: $69d7985982c222e4$var$S("split-view-container", $69d7985982c222e4$var$O)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.toArray(r).map((t)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(t)) return null;
        var i = t.key;
        return "Allotment.Pane" === t.type.displayName ? (D.current.set(i, t.props), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(t, {
            key: i,
            ref: (e)=>{
                var s = t.ref;
                s && (s.current = e), e ? A.current.set(i, e) : A.current.delete(i);
            }
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($69d7985982c222e4$var$Ie, {
            key: i,
            ref: (e)=>{
                e ? A.current.set(i, e) : A.current.delete(i);
            }
        }, t);
    })));
});
function $69d7985982c222e4$export$aed1c99c50218917(e) {
    var t = $69d7985982c222e4$var$x(e, 4, 20), i = $69d7985982c222e4$var$x(e, 1, 8);
    document.documentElement.style.setProperty("--sash-size", t + "px"), document.documentElement.style.setProperty("--sash-hover-size", i + "px"), function(e) {
        $69d7985982c222e4$var$he = e, $69d7985982c222e4$var$le.emit("onDidChangeGlobalSize", e);
    }(t);
}
$69d7985982c222e4$var$xe.displayName = "Allotment";
var $69d7985982c222e4$export$7250f71dae467feb = Object.assign($69d7985982c222e4$var$xe, {
    Pane: $69d7985982c222e4$var$Ie
});

});

parcelRegister("9OQEa", function(module, exports) {

$parcel$export(module.exports, "HierarchyTopBar", function () { return $3bf0496fc5e7fef4$export$10e6861c7889bdb3; });

var $bbzbN = parcelRequire("bbzbN");

var $dJxWt = parcelRequire("dJxWt");

var $bkoms = parcelRequire("bkoms");

var $2bXTH = parcelRequire("2bXTH");

var $BxD6l = parcelRequire("BxD6l");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $9Jgpw = parcelRequire("9Jgpw");

var $5Iom1 = parcelRequire("5Iom1");

var $7Wd8C = parcelRequire("7Wd8C");

var $9469n = parcelRequire("9469n");

var $1RXOp = parcelRequire("1RXOp");

var $5UDwf = parcelRequire("5UDwf");

var $7fPBF = parcelRequire("7fPBF");

var $4mMRX = parcelRequire("4mMRX");

var $gxpCl = parcelRequire("gxpCl");

var $5Q4M4 = parcelRequire("5Q4M4");

var $9r5CO = parcelRequire("9r5CO");
const $3bf0496fc5e7fef4$export$10e6861c7889bdb3 = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const location = (0, $gxpCl.useLocation)();
    const urlParams = (0, $gxpCl.useParams)();
    const [showCopyModal, setShowCopyModal] = (0, $7fPBF.useState)(false);
    const [showLoadModal, setShowLoadModal] = (0, $7fPBF.useState)(false);
    const [showRemoveStylesModal, setShowRemoveStylesModal] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (hierarchyContext && urlParams.hierarchyId !== undefined && hierarchyContext.id !== urlParams.hierarchyId) hierarchyContext.dispatch({
            operation: (0, $9Jgpw.SET_HIERARCHY_ID),
            hierarchyId: urlParams.hierarchyId
        });
    }, [
        hierarchyContext,
        urlParams
    ]);
    (0, $5UDwf.useDocumentTitle)(hierarchyContext?.title ?? "Loading hierarchy...");
    const tocVersion = ` (${(0, $5Iom1.tocVersionString)(hierarchyContext?.hierarchy?.tocMajorVersion, hierarchyContext?.hierarchy?.tocMinorVersion, hierarchyContext?.hierarchy?.isBackupVersion)})`;
    // Determine if we should show Remove Styles option based on current route
    const shouldShowRemoveStyles = (hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report) && (location?.pathname?.includes("/Lists") || location?.pathname?.includes("/Replacements")) && hierarchyContext?.accessRights?.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy);
    const replacementLevelFromPath = location?.pathname?.includes("/Lists") ? "HierarchyLists" : "HierarchySingles";
    /**
   * Check if there are styles to remove in the current hierarchy context.
   * Calculated inline to determine if the menu option should be disabled.
   */ const hasStylesToRemove = hierarchyContext?.hierarchy && (replacementLevelFromPath === "HierarchyLists" ? (0, $dJxWt.hasStylesToRemoveInLists)(hierarchyContext.hierarchy.lists) : (0, $bkoms.hasStylesToRemoveInSingles)(hierarchyContext.hierarchy.singles));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Q4M4.TopBar), {
                title: `${!hierarchyContext?.title ? "MOSAIC Biometrics" : hierarchyContext.title}${hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report ? tocVersion : ""}${hierarchyContext?.changed ? "*" : ""}`,
                fileEntry: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                            id: "topbar-load-link",
                            as: (0, $gxpCl.Link),
                            to: `${hierarchyContext && hierarchyContext.hierarchy ? (0, $wPq5H.getHierarchyBaseUrl)(hierarchyContext.hierarchy) : "Corporate"}/Load`,
                            children: "Load TLF"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Divider, {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                            id: "hierarchypage-topbar-save-link",
                            disabled: !hierarchyContext?.accessRights?.includes((0, $7Wd8C.eAccessRights).MaintainHierarchy),
                            onClick: ()=>{
                                hierarchyContext?.dispatch({
                                    operation: (0, $9Jgpw.SAVE_HIERARCHY)
                                });
                            },
                            children: "Save"
                        }),
                        (hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                            id: "hierarchypage-topbar-download-ars-json",
                            disabled: hierarchyContext.changed,
                            onClick: ()=>{
                                (0, $1RXOp.downloadArsReport)(appSettings.backEndUrl, hierarchyContext.id, hierarchyContext.hierarchy.name);
                            },
                            children: "Export ARS document"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Divider, {}),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                            id: "hierarchypage-topbar-remove-styles",
                            onClick: ()=>{
                                setShowRemoveStylesModal(replacementLevelFromPath);
                            },
                            disabled: !shouldShowRemoveStyles || !hasStylesToRemove,
                            children: "Remove styles"
                        }),
                        (hierarchyContext?.accessRights?.includes((0, $7Wd8C.eAccessRights).CreateHierarchy) || appSettings.applicationPermissions.includes((0, $7Wd8C.eApplicationPermission).AllowDefineXmlUpload)) && (hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Corporate || hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).TA || hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study) && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                                    onClick: ()=>{
                                        setShowLoadModal(true);
                                    },
                                    children: "Upload XML"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9r5CO.LoadXmlLibraryModal), {
                                    onClose: ()=>{
                                        setShowLoadModal(false);
                                    },
                                    show: showLoadModal
                                })
                            ]
                        }),
                        hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                                    id: "reportpage-topbar-download-annotations-csv",
                                    disabled: hierarchyContext.changed,
                                    onClick: ()=>{
                                        const dNumber = hierarchyContext?.hierarchyNodes.find((h)=>h.id === hierarchyContext.hierarchy?.parentId)?.dNumber ?? // istanbul ignore next
                                        "Report";
                                        (0, $9469n.downloadAnnotationsCSV)(`${appSettings?.backEndUrl}Reports/${hierarchyContext.id}/AnnotatedVariables`, `Annotations_${dNumber}_${hierarchyContext.hierarchy.name}.csv`);
                                    },
                                    children: "Download annotations CSV"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4mMRX.default).Item, {
                                    id: "reportpage-topbar-copy-link",
                                    disabled: hierarchyContext.changed,
                                    onClick: ()=>{
                                        setShowCopyModal(true);
                                    },
                                    children: "Copy report"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $BxD6l.CopyReportModal), {
                                    onClose: ()=>{
                                        setShowCopyModal(false);
                                    },
                                    show: showCopyModal
                                })
                            ]
                        })
                    ]
                })
            }),
            showRemoveStylesModal && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2bXTH.RemoveStylesModal), {
                styleRemovalLevel: showRemoveStylesModal,
                onClose: ()=>{
                    setShowRemoveStylesModal(null);
                }
            })
        ]
    });
};
$3bf0496fc5e7fef4$export$10e6861c7889bdb3.displayName = "HierarchyTopBar";

});
parcelRegister("dJxWt", function(module, exports) {

$parcel$export(module.exports, "hasStylesToRemoveInLists", function () { return $05c9d0e0eb07241a$export$dc1e6cf611122cea; });

var $4mqqb = parcelRequire("4mqqb");
const $05c9d0e0eb07241a$export$dc1e6cf611122cea = (lists)=>{
    return lists.some((list)=>(0, $4mqqb.hasStylesInReplacementValues)(list.newTexts));
};

});
parcelRegister("4mqqb", function(module, exports) {

$parcel$export(module.exports, "hasStylesInReplacementValues", function () { return $1d77af25d252a4c6$export$cb2aae72774353a2; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $1d77af25d252a4c6$export$cb2aae72774353a2 = (newTexts)=>{
    return newTexts.some((newText)=>{
        // Check texts in this level
        const hasStylesInTexts = newText.texts.some((text)=>(0, $1iDss.hasStylesToRemove)(text, [
                ...(0, $dRarR.STYLES_TO_DELETE),
                ...(0, $dRarR.STYLES_TO_CLEAN)
            ]));
        // Recursively check sublists if they exist
        const hasStylesInSubLists = newText.subLists?.some((subList)=>$1d77af25d252a4c6$export$cb2aae72774353a2(subList.newTexts)) ?? false;
        return hasStylesInTexts || hasStylesInSubLists;
    });
};

});


parcelRegister("bkoms", function(module, exports) {

$parcel$export(module.exports, "hasStylesToRemoveInSingles", function () { return $6ebec512cf1a5fc0$export$c08aa94bd65bbf4f; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $6ebec512cf1a5fc0$export$c08aa94bd65bbf4f = (singles)=>{
    return singles.some((single)=>(0, $1iDss.hasStylesToRemove)(single.newText, [
            ...(0, $dRarR.STYLES_TO_DELETE),
            ...(0, $dRarR.STYLES_TO_CLEAN)
        ]));
};

});

parcelRegister("2bXTH", function(module, exports) {

$parcel$export(module.exports, "RemoveStylesModal", function () { return $c6c296014cd8b0b2$export$cde5a31d43c9ce66; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $fZCs4 = parcelRequire("fZCs4");

var $6VdBt = parcelRequire("6VdBt");

var $jT8qJ = parcelRequire("jT8qJ");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $9Jgpw = parcelRequire("9Jgpw");

var $fqHWo = parcelRequire("fqHWo");

var $bStV3 = parcelRequire("bStV3");

var $dDC3L = parcelRequire("dDC3L");

var $lNt9u = parcelRequire("lNt9u");

var $7fPBF = parcelRequire("7fPBF");

var $dRarR = parcelRequire("dRarR");

var $1uDvG = parcelRequire("1uDvG");

var $4mqqb = parcelRequire("4mqqb");

var $dJxWt = parcelRequire("dJxWt");

var $bkoms = parcelRequire("bkoms");

var $kEDxN = parcelRequire("kEDxN");

var $cySLc = parcelRequire("cySLc");

var $77Qqo = parcelRequire("77Qqo");

var $3rU39 = parcelRequire("3rU39");
const $c6c296014cd8b0b2$export$cde5a31d43c9ce66 = ({ styleRemovalLevel: styleRemovalLevel, onClose: onClose })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: ars } = (0, $fZCs4.useArsContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const [isPending, startTransition] = (0, $7fPBF.useTransition)();
    const tlfData = (0, $lNt9u.isTlfItemReadDto)(tlfContext.tlfData) ? tlfContext.tlfData : null;
    // TLF-level data (only needed for TlfLevel)
    const externalSinglesForTiFo = styleRemovalLevel === "Tlf" && tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $bStV3.getExternalSingles)(tlfData.tocNumber, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements) : [];
    const externalLists = styleRemovalLevel === "Tlf" && tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $fqHWo.getExternalLists)(tlfData.primaryHierarchyId, tlfData.primaryHierarchyLevel, tlfData.releaseStatus, hierarchyContext.hierarchy.lists, hierarchyContext.parentTemplates.lists) : [];
    // Collect arrays of external items with styles for detailed warning
    const externalSinglesWithStyles = externalSinglesForTiFo.filter((single)=>single.source !== (0, $9Jgpw.eSingleSource).tlfItem && (0, $1iDss.hasStylesToRemove)(single.newText, [
            ...(0, $dRarR.STYLES_TO_DELETE),
            ...(0, $dRarR.STYLES_TO_CLEAN)
        ]));
    const externalListsWithStyles = externalLists.filter((list)=>(0, $4mqqb.hasStylesInReplacementValues)(list.newTexts));
    /**
   * Handles closing the RemoveStylesModal.
   * - For TlfContext: dispatches CLOSE_MODAL_WINDOW to close modal via context.
   * - For HierarchyContext: relies on the onClose prop from parent to close modal.
   */ const handleClose = ()=>{
        if (styleRemovalLevel === "Tlf") tlfContext.dispatch({
            operation: (0, $dDC3L.CLOSE_MODAL_WINDOW),
            calledFrom: "RemoveStylesModal:onClose"
        });
        else onClose?.();
    };
    /**
   * Processes TLF content to remove Optional and Notes styles from titles, footnotes, page by,
   * body content, and singles. Promotes external singles with styles to TLF-level singles.
   */ const handleRemoveStylesFromTlf = ()=>{
        /* istanbul ignore else */ if (tlfData) {
            const styleRemovedData = (0, $3rU39.removeStylesFromTlf)(tlfData, externalSinglesForTiFo, externalLists);
            // Standards Notes and Programmer Notes are intentionally not processed
            tlfContext.dispatch({
                operation: (0, $dDC3L.UPDATE_TLF),
                tlfData: styleRemovedData,
                calledFrom: "RemoveStylesModal:RemoveStyles"
            });
        }
    };
    /**
   * Handles style removal for hierarchy-level singles
   */ const handleRemoveStylesFromHierarchySingles = ()=>{
        /* istanbul ignore else */ if (hierarchyContext?.hierarchy) {
            const newSingles = (0, $77Qqo.removeStylesFromSingles)(hierarchyContext.hierarchy.singles);
            hierarchyContext.dispatch({
                operation: (0, $9Jgpw.UPDATE_HIERARCHY),
                hierarchy: {
                    singles: newSingles
                }
            });
        }
    };
    /**
   * Handles style removal for hierarchy-level lists
   */ const handleRemoveStylesFromHierarchyLists = ()=>{
        /* istanbul ignore else */ if (hierarchyContext?.hierarchy) {
            const newLists = (0, $cySLc.removeStylesFromExternalLists)(hierarchyContext.hierarchy.lists);
            hierarchyContext.dispatch({
                operation: (0, $9Jgpw.UPDATE_HIERARCHY),
                hierarchy: {
                    lists: newLists
                }
            });
        }
    };
    /**
   * Main handler that delegates to the appropriate function based on replacement level.
   * Uses startTransition to mark the operation as a non-urgent update, allowing React
   * to keep the UI responsive during potentially long-running style removal operations.
   * The modal will automatically close when the transition completes via requestStatus.
   */ const handleRemoveStyles = ()=>{
        startTransition(()=>{
            switch(styleRemovalLevel){
                case "Tlf":
                    handleRemoveStylesFromTlf();
                    break;
                case "HierarchySingles":
                    handleRemoveStylesFromHierarchySingles();
                    break;
                case "HierarchyLists":
                    handleRemoveStylesFromHierarchyLists();
                    break;
            }
        });
    };
    /**
   * Determines whether styles exist that need to be removed.
   * Uses lazy initialization to calculate only once at mount time,
   * preventing recalculation after styles are removed.
   */ const [hasStylesToRemoveInData] = (0, $7fPBF.useState)(()=>styleRemovalLevel === "Tlf" ? (0, $kEDxN.hasStylesToRemoveInTlf)(tlfData, externalSinglesForTiFo, externalLists) : styleRemovalLevel === "HierarchySingles" ? !!hierarchyContext?.hierarchy && (0, $bkoms.hasStylesToRemoveInSingles)(hierarchyContext.hierarchy.singles) : !!hierarchyContext?.hierarchy && (0, $dJxWt.hasStylesToRemoveInLists)(hierarchyContext.hierarchy.lists));
    /**
   * Generates the appropriate message based on replacement level
   */ const getMessage = ()=>{
        switch(styleRemovalLevel){
            case "Tlf":
                return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                            children: "This will convert Optional (green) to black and remove Notes (blue) from Titles, Page by, Body and Footnotes"
                        }),
                        (externalSinglesWithStyles.length > 0 || externalListsWithStyles.length > 0) && hierarchyContext?.hierarchy && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "fw-bold",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    className: "mb-1",
                                    children: "Warning: This will also embed styled replacements into the TLF. It is strongly recommended to remove the styles from the hierarchy replacements before proceeding."
                                }),
                                (0, $1uDvG.getHierarchyLinksDescriptorsForStyledReplacements)({
                                    hierarchy: hierarchyContext.hierarchy,
                                    parentTemplates: hierarchyContext.parentTemplates,
                                    hierarchyNodes: hierarchyContext.hierarchyNodes,
                                    externalSinglesWithStyles: externalSinglesWithStyles,
                                    externalListsWithStyles: externalListsWithStyles
                                }).map((desc, idx)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                            href: desc.type === "singles" ? `${desc.baseUrl}/Replacements` : `${desc.baseUrl}/Lists`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: `View ${desc.hierarchyName} ${desc.type}`
                                        })
                                    }, idx))
                            ]
                        })
                    ]
                });
            case "HierarchySingles":
                return /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    children: "This action will convert Optional (green) to black text and remove Notes (blue) text from all single replacements in this hierarchy level."
                });
            case "HierarchyLists":
                return /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    children: "This action will convert Optional (green) to black text and remove Notes (blue) text from all replacement lists in this hierarchy level."
                });
        }
    };
    return !hasStylesToRemoveInData ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jT8qJ.PopupAlertModal), {
        id: "no-styles-to-remove-modal",
        show: true,
        title: "No styles to remove",
        message: "There are no Optional (green) or Notes (blue) styles present in this content.",
        onClose: handleClose
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6VdBt.AreYouSureModal), {
        id: "remove-styles-modal",
        show: true,
        title: "Remove styles",
        message: getMessage(),
        onOk: handleRemoveStyles,
        onClose: handleClose,
        requestStatus: {
            requesting: isPending,
            error: false
        }
    });
};
$c6c296014cd8b0b2$export$cde5a31d43c9ce66.displayName = "RemoveStylesModal";

});
parcelRegister("6VdBt", function(module, exports) {

$parcel$export(module.exports, "AreYouSureModal", function () { return $40b20168e98f2af0$export$9d984f3cf29e7f51; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $7fPBF = parcelRequire("7fPBF");

var $d8uJi = parcelRequire("d8uJi");
const $40b20168e98f2af0$export$9d984f3cf29e7f51 = ({ id: id, show: show, title: title = "Are you sure?", message: message, onOk: onOk, onClose: onClose, requestStatus: requestStatus })=>{
    // Track previous requesting state
    const prevRequesting = (0, $7fPBF.useRef)(false);
    const requesting = requestStatus?.requesting ?? false;
    /**
   * Closes the modal automatically when the async request completes.
   * Detects when requestStatus transitions from requesting=true to requesting=false,
   * and calls onClose to close the modal. This ensures the spinner is visible during
   * the async operation and the modal closes only after completion.
   *
   * @param requesting - Current request status (true if async operation is in progress)
   * @param onClose - Callback to close the modal
   */ (0, $7fPBF.useEffect)(()=>{
        // If previously requesting and now not requesting, close modal
        if (prevRequesting.current && !requesting) onClose?.();
        prevRequesting.current = requesting;
    }, [
        requesting,
        onClose
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default), {
        id: id,
        show: show,
        onHide: onClose,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                children: typeof message === "string" ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    children: message
                }) : message
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default).Footer, {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: `${id}-ok`,
                        variant: "primary",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onOk();
                        },
                        requestStatus: requestStatus,
                        children: "OK"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: `${id}-close`,
                        variant: "secondary",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onClose?.();
                        },
                        children: "Close"
                    })
                ]
            })
        ]
    });
};
$40b20168e98f2af0$export$9d984f3cf29e7f51.displayName = "AreYouSureModal";

});

parcelRegister("jT8qJ", function(module, exports) {

$parcel$export(module.exports, "PopupAlertModal", function () { return $970281e8b0fe4a2d$export$b2a56dfff857ab63; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $d8uJi = parcelRequire("d8uJi");
const $970281e8b0fe4a2d$export$b2a56dfff857ab63 = ({ id: id, show: show, title: title, message: message, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default), {
        id: id,
        show: show,
        onHide: onClose,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Footer, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                    id: `${id}-close`,
                    name: "close",
                    variant: "secondary",
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        onClose();
                    },
                    children: "Close"
                })
            })
        ]
    });
};
$970281e8b0fe4a2d$export$b2a56dfff857ab63.displayName = "PopupAlertModal";

});

parcelRegister("fqHWo", function(module, exports) {

$parcel$export(module.exports, "getExternalLists", function () { return $eb06a4f7d7bb391b$export$61c0246df4799355; });

var $7Wd8C = parcelRequire("7Wd8C");
const $eb06a4f7d7bb391b$export$61c0246df4799355 = (primaryHierarchyId, primaryHierarchyLevel, releaseStatus, lists, parentLists)=>{
    if ([
        (0, $7Wd8C.eReleaseStatus).Draft,
        (0, $7Wd8C.eReleaseStatus).ReleasePending
    ].includes(releaseStatus) || primaryHierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Report) {
        const el = [
            ...parentLists.filter((list)=>!lists.some((l)=>list.givenName === l.givenName)),
            ...lists.map((list)=>({
                    ...list,
                    fromHierarchyId: primaryHierarchyId
                }))
        ];
        return el;
    } else return [];
};

});

parcelRegister("bStV3", function(module, exports) {

$parcel$export(module.exports, "getExternalSingles", function () { return $7c1f3eab0243962f$export$7ad85b6a62430903; });

var $1iDss = parcelRequire("1iDss");

var $9Jgpw = parcelRequire("9Jgpw");

var $7Wd8C = parcelRequire("7Wd8C");
const $7c1f3eab0243962f$export$7ad85b6a62430903 = (tocNumber = "", analysisSetLabel = "", releaseStatus = (0, $7Wd8C.eReleaseStatus).Draft, domain = "", tlfSingles = [], level = (0, $7Wd8C.eHierarchyLevel).Corporate, hierarchySingles = [], domainReplacements = [], parentSingles = [], parentDomainReplacements = [])=>{
    const es = [
        // Add ToC replacement for reports
        ...level === (0, $7Wd8C.eHierarchyLevel).Report && tocNumber ? [
            {
                airid: "toc",
                oldText: "!!toc!!",
                newText: (0, $1iDss.stringToV3)(tocNumber),
                source: (0, $9Jgpw.eSingleSource).tlfItem
            }
        ] : [],
        // Add analysis set label replacement for reports
        ...level === (0, $7Wd8C.eHierarchyLevel).Report && analysisSetLabel ? [
            {
                airid: "analysisSetLabel",
                oldText: "[[Analysis set]]",
                newText: (0, $1iDss.stringToV3)(analysisSetLabel),
                source: (0, $9Jgpw.eSingleSource).tlfItem
            }
        ] : [],
        // Add TLF-specific singles
        ...tlfSingles,
        // Add domain replacements for draft templates (release pending should have had them applied)
        ...level !== (0, $7Wd8C.eHierarchyLevel).Report && [
            (0, $7Wd8C.eReleaseStatus).Draft
        ].includes(releaseStatus) ? [
            ...domainReplacements.filter((dr)=>dr.domain === domain).map((dr)=>({
                    airid: dr.airid,
                    oldText: dr.oldText,
                    newText: dr.newText,
                    source: (0, $9Jgpw.eSingleSource).domain
                })),
            ...parentDomainReplacements.filter((dr)=>dr.domain === domain).map((dr)=>({
                    airid: dr.airid,
                    oldText: dr.oldText,
                    newText: dr.newText,
                    source: (0, $9Jgpw.eSingleSource).domain
                }))
        ] : [],
        // Add normal singles for reports or drafts
        ...level === (0, $7Wd8C.eHierarchyLevel).Report || [
            (0, $7Wd8C.eReleaseStatus).ReleasePending,
            (0, $7Wd8C.eReleaseStatus).Draft
        ].includes(releaseStatus) ? [
            ...hierarchySingles,
            ...parentSingles
        ] : []
    ];
    return es;
};

});

parcelRegister("lNt9u", function(module, exports) {

$parcel$export(module.exports, "isEditorPageBy", function () { return $9dd35b7c3fdd3584$export$70933415fe713e0a; });
$parcel$export(module.exports, "isTlfItemReadDto", function () { return $9dd35b7c3fdd3584$export$32c72733f7fa0be7; });

var $1iDss = parcelRequire("1iDss");

var $7Wd8C = parcelRequire("7Wd8C");

var $k9TPW = parcelRequire("k9TPW");
const $9dd35b7c3fdd3584$export$c01ff0332521efb1 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (![
        "string",
        "undefined"
    ].includes(typeof chkObj.timestamp)) return false;
    if (chkObj.id === undefined || typeof chkObj.id !== "number") return false;
    if (chkObj.updateType === undefined || !Object.values((0, $7Wd8C.eHistoryType)).includes(chkObj.updateType)) return false;
    if (chkObj.comment === undefined || typeof chkObj.comment !== "string") return false;
    if (chkObj.userName === undefined || typeof chkObj.userName !== "string") return false;
    return true;
};
const $9dd35b7c3fdd3584$export$70933415fe713e0a = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    return (0, $1iDss.isIEditorV3)(obj.content);
};
const $9dd35b7c3fdd3584$export$51859ba8c7a6071a = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.groupingFactorId !== "string") return false;
    if (chkObj.label !== undefined && !(0, $1iDss.isIEditorV3)(chkObj.label)) return false;
    return true;
};
const $9dd35b7c3fdd3584$export$32c72733f7fa0be7 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check lower interface
    if (!(0, $k9TPW.isTitlesFootnotesReadDto)(obj)) return false;
    // Check basic props
    const chkObj = obj;
    if (![
        "undefined",
        "string"
    ].includes(typeof chkObj.crystalReference)) return false;
    if (typeof chkObj.sapReference !== "string") return false;
    if (!(0, $1iDss.isIEditorV3)(chkObj.standardsNotes)) return false;
    if (!(0, $1iDss.isIEditorV3)(chkObj.programmerNotes)) return false;
    if (typeof chkObj.body !== "object") return false;
    // Check arrays
    if (!Array.isArray(chkObj.history) || chkObj.history.some((x)=>!$9dd35b7c3fdd3584$export$c01ff0332521efb1(x))) return false;
    if (chkObj.pageBy === undefined) return false;
    if ((chkObj.type === (0, $7Wd8C.eTlfItemType).arsListing || chkObj.type === (0, $7Wd8C.eTlfItemType).arsTable) && (!Array.isArray(chkObj.pageBy) || chkObj.pageBy.some((item)=>!$9dd35b7c3fdd3584$export$51859ba8c7a6071a(item)))) return false;
    if (chkObj.type !== (0, $7Wd8C.eTlfItemType).arsListing && chkObj.type !== (0, $7Wd8C.eTlfItemType).arsTable && !$9dd35b7c3fdd3584$export$70933415fe713e0a(chkObj.pageBy)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("1uDvG", function(module, exports) {

$parcel$export(module.exports, "getHierarchyLinksDescriptorsForStyledReplacements", function () { return $a62f51b124db3787$export$19f295ed9ec3a690; });

var $1iDss = parcelRequire("1iDss");

var $wPq5H = parcelRequire("wPq5H");

var $9Jgpw = parcelRequire("9Jgpw");

var $dRarR = parcelRequire("dRarR");

var $4mqqb = parcelRequire("4mqqb");
/**
 * Push a hierarchy replacement link descriptor into `links` when `condition` is true.
 *
 * @param links - Accumulator array for link descriptors
 * @param condition - Whether to push the link
 * @param baseUrl - Base URL for the hierarchy
 * @param hierarchyName - Display name of the hierarchy
 * @param type - 'singles' or 'lists'
 * @param keyPrefix - Prefix used to form React keys
 */ const $a62f51b124db3787$var$pushLinkIf = (links, condition, baseUrl, hierarchyName, type, keyPrefix)=>{
    if (condition) links.push({
        baseUrl: baseUrl,
        hierarchyName: hierarchyName,
        type: type,
        keyPrefix: keyPrefix
    });
};
const $a62f51b124db3787$export$19f295ed9ec3a690 = ({ hierarchy: hierarchy, parentTemplates: parentTemplates, hierarchyNodes: hierarchyNodes, externalSinglesWithStyles: externalSinglesWithStyles, externalListsWithStyles: externalListsWithStyles })=>{
    const links = [];
    // Current hierarchy
    const currentHasStyledSingles = hierarchy.singles.some((single)=>(0, $1iDss.hasStylesToRemove)(single.newText, [
            ...(0, $dRarR.STYLES_TO_DELETE),
            ...(0, $dRarR.STYLES_TO_CLEAN)
        ]));
    const currentHasStyledLists = hierarchy.lists.some((list)=>(0, $4mqqb.hasStylesInReplacementValues)(list.newTexts));
    const hasExternalSinglesFromCurrent = externalSinglesWithStyles.some((single)=>single.source === (0, $9Jgpw.eSingleSource).hierarchy);
    const hasExternalListsFromCurrent = externalListsWithStyles.length > 0;
    const currentBaseUrl = (0, $wPq5H.getHierarchyBaseUrl)(hierarchy);
    $a62f51b124db3787$var$pushLinkIf(links, currentHasStyledSingles && hasExternalSinglesFromCurrent, currentBaseUrl, hierarchy.name, "singles", "current");
    $a62f51b124db3787$var$pushLinkIf(links, currentHasStyledLists && hasExternalListsFromCurrent, currentBaseUrl, hierarchy.name, "lists", "current");
    // Parent hierarchy - group by fromHierarchyId to find which parent hierarchies have styled content
    if (hierarchyNodes) {
        // Collect unique hierarchy IDs from parent templates with styles
        const parentHierarchyIds = new Set();
        parentTemplates.singles.forEach((single)=>{
            /* istanbul ignore else */ if ((0, $1iDss.hasStylesToRemove)(single.newText, [
                ...(0, $dRarR.STYLES_TO_DELETE),
                ...(0, $dRarR.STYLES_TO_CLEAN)
            ])) parentHierarchyIds.add(single.fromHierarchyId);
        });
        parentTemplates.lists.forEach((list)=>{
            /* istanbul ignore else */ if ((0, $4mqqb.hasStylesInReplacementValues)(list.newTexts)) parentHierarchyIds.add(list.fromHierarchyId);
        });
        // Generate links for each parent hierarchy with styled content
        parentHierarchyIds.forEach((hierarchyId)=>{
            const parentNode = hierarchyNodes.find((node)=>node.id === hierarchyId);
            if (parentNode) {
                const parentBaseUrl = (0, $wPq5H.getHierarchyBaseUrl)(parentNode);
                $a62f51b124db3787$var$pushLinkIf(links, parentTemplates.singles.some((s)=>s.fromHierarchyId === hierarchyId && (0, $1iDss.hasStylesToRemove)(s.newText, [
                        ...(0, $dRarR.STYLES_TO_DELETE),
                        ...(0, $dRarR.STYLES_TO_CLEAN)
                    ])), parentBaseUrl, parentNode.name, "singles", "parent");
                $a62f51b124db3787$var$pushLinkIf(links, parentTemplates.lists.some((l)=>l.fromHierarchyId === hierarchyId && (0, $4mqqb.hasStylesInReplacementValues)(l.newTexts)), parentBaseUrl, parentNode.name, "lists", "parent");
            }
        });
    }
    return links;
};

});

parcelRegister("kEDxN", function(module, exports) {

$parcel$export(module.exports, "hasStylesToRemoveInTlf", function () { return $08b44b7eb873b44d$export$596f2f2ff891a47d; });

var $1iDss = parcelRequire("1iDss");

var $9Jgpw = parcelRequire("9Jgpw");

var $7Wd8C = parcelRequire("7Wd8C");

var $lNt9u = parcelRequire("lNt9u");

var $dRarR = parcelRequire("dRarR");

var $hpVbR = parcelRequire("hpVbR");

var $4mqqb = parcelRequire("4mqqb");

var $fkIPE = parcelRequire("fkIPE");

var $bkoms = parcelRequire("bkoms");
const $08b44b7eb873b44d$export$596f2f2ff891a47d = (tlfData, externalSinglesForTiFo, externalLists)=>{
    if (!tlfData) return false;
    const stylesToCheck = [
        ...(0, $dRarR.STYLES_TO_DELETE),
        ...(0, $dRarR.STYLES_TO_CLEAN)
    ];
    // Check titles (left, center, right positions)
    if (tlfData.titles.some((line)=>(0, $hpVbR.hasStylesInBlockLine)(line))) return true;
    // Check footnotes (left, center, right positions)
    if (tlfData.footnotes.some((line)=>(0, $hpVbR.hasStylesInBlockLine)(line))) return true;
    // Check page by
    if ((0, $lNt9u.isEditorPageBy)(tlfData.pageBy) && (0, $1iDss.hasStylesToRemove)(tlfData.pageBy.content, stylesToCheck)) return true;
    if (Array.isArray(tlfData.pageBy) && tlfData.pageBy.some((pageByItem)=>pageByItem.label !== undefined && (0, $1iDss.hasStylesToRemove)(pageByItem.label, stylesToCheck))) return true;
    // Check body (only for tables and listings)
    if (tlfData.type === (0, $7Wd8C.eTlfItemType).table || tlfData.type === (0, $7Wd8C.eTlfItemType).listing) {
        if ((0, $fkIPE.hasStylesInTableData)(tlfData.body)) return true;
    }
    // Check TLF singles
    if ((0, $bkoms.hasStylesToRemoveInSingles)(tlfData.singles)) return true;
    // Check if any external singles would be promoted (have styles and not already in TLF singles)
    const hasExternalSinglesToPromote = externalSinglesForTiFo.some((single)=>single.source !== (0, $9Jgpw.eSingleSource).tlfItem && (0, $1iDss.hasStylesToRemove)(single.newText, stylesToCheck) && !tlfData.singles.some((tlfSingle)=>tlfSingle.oldText === single.oldText));
    if (hasExternalSinglesToPromote) return true;
    // Check if any external lists have styles that would be merged into table replacements
    // This is only relevant for tables/listings which can have replacements in their body
    if (tlfData.type === (0, $7Wd8C.eTlfItemType).table || tlfData.type === (0, $7Wd8C.eTlfItemType).listing) {
        const hasExternalListsWithStyles = externalLists.some((externalList)=>(0, $4mqqb.hasStylesInReplacementValues)(externalList.newTexts));
        if (hasExternalListsWithStyles) return true;
    }
    return false;
};

});
parcelRegister("hpVbR", function(module, exports) {

$parcel$export(module.exports, "hasStylesInBlockLine", function () { return $b01269993c0cbe38$export$500d193e1775c66d; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $b01269993c0cbe38$export$500d193e1775c66d = (line)=>{
    const stylesToCheck = [
        ...(0, $dRarR.STYLES_TO_DELETE),
        ...(0, $dRarR.STYLES_TO_CLEAN)
    ];
    return (0, $1iDss.hasStylesToRemove)(line.left, stylesToCheck) || (0, $1iDss.hasStylesToRemove)(line.center, stylesToCheck) || (0, $1iDss.hasStylesToRemove)(line.right, stylesToCheck);
};

});

parcelRegister("fkIPE", function(module, exports) {

$parcel$export(module.exports, "hasStylesInTableData", function () { return $3e808b5411491088$export$808e13e471447668; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");

var $4ojEw = parcelRequire("4ojEw");
const $3e808b5411491088$export$808e13e471447668 = (tableData)=>{
    const stylesToCheck = [
        ...(0, $dRarR.STYLES_TO_DELETE),
        ...(0, $dRarR.STYLES_TO_CLEAN)
    ];
    // Check table comments
    if ((0, $1iDss.hasStylesToRemove)(tableData.comments, stylesToCheck)) return true;
    // Check header data if it exists
    if (tableData.headerData && (0, $4ojEw.hasStylesInRowGroup)(tableData.headerData)) return true;
    // Check body data row groups
    return tableData.bodyData.some((rowGroup)=>(0, $4ojEw.hasStylesInRowGroup)(rowGroup));
};

});
parcelRegister("4ojEw", function(module, exports) {

$parcel$export(module.exports, "hasStylesInRowGroup", function () { return $870b62e707d73390$export$cd385cd0e465ec5b; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");

var $4mqqb = parcelRequire("4mqqb");

var $9VgRN = parcelRequire("9VgRN");
const $870b62e707d73390$export$cd385cd0e465ec5b = (rowGroup)=>{
    const hasStylesInRows = rowGroup.rows.some((row)=>(0, $9VgRN.hasStylesInRow)(row));
    const hasStylesInComments = (0, $1iDss.hasStylesToRemove)(rowGroup.comments, [
        ...(0, $dRarR.STYLES_TO_CLEAN),
        ...(0, $dRarR.STYLES_TO_DELETE)
    ]);
    const hasStylesInReplacements = (rowGroup.replacements ?? []).some((replacement)=>(0, $4mqqb.hasStylesInReplacementValues)(replacement.newTexts ?? []));
    return hasStylesInRows || hasStylesInComments || hasStylesInReplacements;
};

});
parcelRegister("9VgRN", function(module, exports) {

$parcel$export(module.exports, "hasStylesInRow", function () { return $ec28a7c085016275$export$27f8697e61313413; });

var $k5gHA = parcelRequire("k5gHA");
const $ec28a7c085016275$export$27f8697e61313413 = (row)=>{
    return row.cells.some((cell)=>(0, $k5gHA.hasStylesInCell)(cell));
};

});
parcelRegister("k5gHA", function(module, exports) {

$parcel$export(module.exports, "hasStylesInCell", function () { return $d1bb09911f923e0b$export$299a2dd7a2d92b5e; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $d1bb09911f923e0b$export$299a2dd7a2d92b5e = (cell)=>{
    const stylesToCheck = [
        ...(0, $dRarR.STYLES_TO_DELETE),
        ...(0, $dRarR.STYLES_TO_CLEAN)
    ];
    const hasStylesInText = (0, $1iDss.hasStylesToRemove)(cell.text, stylesToCheck);
    const hasStylesInComments = (0, $1iDss.hasStylesToRemove)(cell.comments, stylesToCheck);
    return hasStylesInText || hasStylesInComments;
};

});





parcelRegister("cySLc", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromExternalLists", function () { return $63c028c691c33b93$export$8224a05f6104d036; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");

var $e1aSN = parcelRequire("e1aSN");
const $63c028c691c33b93$export$8224a05f6104d036 = (lists)=>{
    return lists.map((list)=>({
            ...list,
            newTexts: list.newTexts.map((newText)=>({
                    ...newText,
                    texts: newText.texts.map((text)=>(0, $1iDss.removeStylesFromEditorV3)(text, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))),
                    subLists: (0, $e1aSN.removeStylesFromSubLists)(newText.subLists)
                }))
        }));
};

});
parcelRegister("e1aSN", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromSubLists", function () { return $3168381d2de6167d$export$e19e566c25e266f5; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $3168381d2de6167d$export$e19e566c25e266f5 = (subLists)=>{
    if (!subLists) return undefined;
    return subLists.map((subList)=>({
            ...subList,
            newTexts: subList.newTexts.map((newText)=>({
                    ...newText,
                    texts: newText.texts.map((text)=>(0, $1iDss.removeStylesFromEditorV3)(text, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))),
                    subLists: $3168381d2de6167d$export$e19e566c25e266f5(newText.subLists)
                }))
        }));
};

});


parcelRegister("77Qqo", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromSingles", function () { return $2b2a363df4f929d2$export$b3a0f36878bc8703; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $2b2a363df4f929d2$export$b3a0f36878bc8703 = (singles)=>{
    return singles.map((single)=>({
            ...single,
            newText: (0, $1iDss.removeStylesFromEditorV3)(single.newText, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))
        }));
};

});

parcelRegister("3rU39", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromTlf", function () { return $4f23c885122da6e3$export$ab8091d94bdbd067; });

var $1iDss = parcelRequire("1iDss");

var $9Jgpw = parcelRequire("9Jgpw");

var $7Wd8C = parcelRequire("7Wd8C");

var $lNt9u = parcelRequire("lNt9u");

var $dRarR = parcelRequire("dRarR");

var $6SF11 = parcelRequire("6SF11");

var $77Qqo = parcelRequire("77Qqo");

var $MOK6x = parcelRequire("MOK6x");
const $4f23c885122da6e3$export$ab8091d94bdbd067 = (tlfData, externalSinglesForTiFo, externalLists)=>{
    const newTitles = tlfData.titles.map((line)=>(0, $6SF11.removeStylesFromBlockLine)(line));
    const newFootnotes = tlfData.footnotes.map((line)=>(0, $6SF11.removeStylesFromBlockLine)(line));
    // Only tables/listings have AitTableData bodies with styled text
    const newBody = tlfData.type === (0, $7Wd8C.eTlfItemType).table || tlfData.type === (0, $7Wd8C.eTlfItemType).listing ? (0, $MOK6x.removeStylesFromTableData)(tlfData.body, externalLists) : undefined;
    // Promote external singles with styles to TLF-level singles, but only if their oldText is not already present in TLF-level singles (after style removal)
    const externalSinglesWithStylesToPromote = externalSinglesForTiFo.filter((single)=>single.source !== (0, $9Jgpw.eSingleSource).tlfItem && (0, $1iDss.hasStylesToRemove)(single.newText, [
            ...(0, $dRarR.STYLES_TO_DELETE),
            ...(0, $dRarR.STYLES_TO_CLEAN)
        ]) && !tlfData.singles.some((tlfSingle)=>tlfSingle.oldText === single.oldText)).map((single)=>({
            ...single,
            source: (0, $9Jgpw.eSingleSource).tlfItem
        }));
    const newSingles = (0, $77Qqo.removeStylesFromSingles)([
        ...tlfData.singles,
        ...externalSinglesWithStylesToPromote
    ]);
    if ((0, $lNt9u.isEditorPageBy)(tlfData.pageBy)) {
        const newTlfData = {
            titles: newTitles,
            footnotes: newFootnotes,
            pageBy: {
                ...tlfData.pageBy,
                content: (0, $1iDss.removeStylesFromEditorV3)(tlfData.pageBy.content, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))
            },
            singles: newSingles
        };
        if (newBody !== undefined) newTlfData.body = newBody;
        return newTlfData;
    }
    const newTlfData = {
        titles: newTitles,
        footnotes: newFootnotes,
        pageBy: tlfData.pageBy.map((pageByItem)=>({
                ...pageByItem,
                label: pageByItem.label === undefined ? undefined : (0, $1iDss.removeStylesFromEditorV3)(pageByItem.label, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))
            })),
        singles: newSingles
    };
    return newTlfData;
};

});
parcelRegister("6SF11", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromBlockLine", function () { return $ea54198e58a1c590$export$19140abdbd9cddc1; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $ea54198e58a1c590$export$19140abdbd9cddc1 = (line)=>{
    return {
        ...line,
        left: (0, $1iDss.removeStylesFromEditorV3)(line.left, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN)),
        center: (0, $1iDss.removeStylesFromEditorV3)(line.center, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN)),
        right: (0, $1iDss.removeStylesFromEditorV3)(line.right, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))
    };
};

});

parcelRegister("MOK6x", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromTableData", function () { return $e7c546f927ce8e48$export$8805fc971e822318; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");

var $k6Mq3 = parcelRequire("k6Mq3");
const $e7c546f927ce8e48$export$8805fc971e822318 = (tableData, externalLists)=>{
    return {
        ...tableData,
        headerData: tableData.headerData ? (0, $k6Mq3.removeStylesFromRowGroup)(tableData.headerData, externalLists) : tableData.headerData,
        bodyData: tableData.bodyData.map((rowGroup)=>(0, $k6Mq3.removeStylesFromRowGroup)(rowGroup, externalLists)),
        comments: (0, $1iDss.removeStylesFromEditorV3)(tableData.comments, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))
    };
};

});
parcelRegister("k6Mq3", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromRowGroup", function () { return $0936432cd39ae02d$export$940ab79ef60d1210; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");

var $hE0Md = parcelRequire("hE0Md");

var $6KTxQ = parcelRequire("6KTxQ");
const $0936432cd39ae02d$export$940ab79ef60d1210 = (rowGroup, externalLists)=>{
    const { processedReplacements: processedReplacements } = (0, $hE0Md.removeStylesFromReplacementLists)(rowGroup.replacements, externalLists);
    return {
        ...rowGroup,
        rows: rowGroup.rows.map((row)=>(0, $6KTxQ.removeStylesFromRow)(row)),
        comments: (0, $1iDss.removeStylesFromEditorV3)(rowGroup.comments, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN)),
        replacements: processedReplacements
    };
};

});
parcelRegister("hE0Md", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromReplacementLists", function () { return $cf0552cc82fb1e66$export$578d8c46ae474a37; });

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $jBp7n = parcelRequire("jBp7n");

var $dRarR = parcelRequire("dRarR");

var $5ncCI = parcelRequire("5ncCI");
const $cf0552cc82fb1e66$export$578d8c46ae474a37 = (replacements, externalLists)=>{
    if (!replacements) return {
        processedReplacements: undefined,
        hadStyles: false
    };
    let replacementHadStyles = false;
    const processedReplacements = replacements.map((replacement)=>{
        // Use external list if it has styles, otherwise keep internal replacement
        const mergedReplacement = (0, $5ncCI.shouldMergeExternal)(replacement, externalLists) ? (0, $jBp7n.updateExternal)(replacement, externalLists) : replacement;
        // Remove styles from all texts in the replacement and recursively process subLists.
        let hadStylesToRemove = false;
        const processedTexts = mergedReplacement.newTexts.map((newText)=>{
            const processedInnerTexts = newText.texts.map((text)=>{
                if ((0, $1iDss.hasStylesToRemove)(text, [
                    ...(0, $dRarR.STYLES_TO_DELETE),
                    ...(0, $dRarR.STYLES_TO_CLEAN)
                ])) hadStylesToRemove = true;
                return (0, $1iDss.removeStylesFromEditorV3)(text, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN));
            });
            // Recursively process subLists if they exist
            const { processedReplacements: processedSubLists, hadStyles: subListsHadStyles } = $cf0552cc82fb1e66$export$578d8c46ae474a37(newText.subLists, externalLists);
            // Track if nested subLists had styles
            if (subListsHadStyles) hadStylesToRemove = true;
            return {
                ...newText,
                texts: processedInnerTexts,
                subLists: processedSubLists
            };
        });
        // Track if any replacement in the array had styles
        replacementHadStyles ||= hadStylesToRemove;
        return {
            ...mergedReplacement,
            newTexts: processedTexts,
            externalName: hadStylesToRemove ? undefined : mergedReplacement.externalName
        };
    });
    return {
        processedReplacements: processedReplacements,
        hadStyles: replacementHadStyles
    };
};

});
parcelRegister("5ncCI", function(module, exports) {

$parcel$export(module.exports, "shouldMergeExternal", function () { return $da14266d2d753119$export$902c8157d2574bb1; });

var $4mqqb = parcelRequire("4mqqb");
const $da14266d2d753119$export$902c8157d2574bb1 = (replacement, externalLists)=>{
    // Find matching external list if this replacement references one
    const externalList = externalLists?.find((ext)=>replacement.externalName && ext.givenName === replacement.externalName);
    // Check if external list contains styles that need removal (recursively checks sublists)
    return externalList ? (0, $4mqqb.hasStylesInReplacementValues)(externalList.newTexts) : false;
};

});


parcelRegister("6KTxQ", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromRow", function () { return $8a29aa4cc5d268ae$export$1861605d95197c30; });

var $3GXtU = parcelRequire("3GXtU");
const $8a29aa4cc5d268ae$export$1861605d95197c30 = (row)=>{
    return {
        ...row,
        cells: row.cells.map((cell)=>(0, $3GXtU.removeStylesFromCell)(cell))
    };
};

});
parcelRegister("3GXtU", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromCell", function () { return $4eebd31012669f85$export$dbc6b57b896d5479; });

var $1iDss = parcelRequire("1iDss");

var $dRarR = parcelRequire("dRarR");
const $4eebd31012669f85$export$dbc6b57b896d5479 = (cell)=>{
    return {
        ...cell,
        text: (0, $1iDss.removeStylesFromEditorV3)(cell.text, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN)),
        comments: (0, $1iDss.removeStylesFromEditorV3)(cell.comments, (0, $dRarR.STYLES_TO_DELETE), (0, $dRarR.STYLES_TO_CLEAN))
    };
};

});






parcelRegister("BxD6l", function(module, exports) {

$parcel$export(module.exports, "CopyReportModal", function () { return $7e3d9ca9b9fe7034$export$d5c21f22ac41750d; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $6aEge = parcelRequire("6aEge");

var $alDlg = parcelRequire("alDlg");
var $d8uJi = parcelRequire("d8uJi");

var $7NdbJ = parcelRequire("7NdbJ");

var $fCyVX = parcelRequire("fCyVX");

var $8YtG5 = parcelRequire("8YtG5");
const $7e3d9ca9b9fe7034$export$d5c21f22ac41750d = ({ show: show, onClose: onCancel })=>{
    /**
   * Handles modal close action.
   */ const cx = ()=>onCancel();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default), {
        enforceFocus: false,
        fullscreen: "xl-down",
        onHide: cx,
        show: show,
        size: "xl",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $6aEge.HierarchyBrowserContextProvider), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                            children: "Copy report"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7NdbJ.HierarchyBrowser), {
                                heightPx: 450
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fCyVX.CopyReportModalName), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default).Footer, {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                            id: "copyreportmodal-cancel",
                            variant: "secondary",
                            onClick: cx,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8YtG5.CopyReportModalOk), {
                            onClick: cx
                        })
                    ]
                })
            ]
        })
    });
};
$7e3d9ca9b9fe7034$export$d5c21f22ac41750d.displayName = "CopyReportModal";

});
parcelRegister("6aEge", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowserContextProvider", function () { return $cfd8f304cddd80a4$export$70151fc5312f6f84; });
$parcel$export(module.exports, "useHBC", function () { return $cfd8f304cddd80a4$export$2ccd25337205a8d; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $cPBZD = parcelRequire("cPBZD");

var $1ddQW = parcelRequire("1ddQW");

var $jOvyw = parcelRequire("jOvyw");

var $7fPBF = parcelRequire("7fPBF");

var $3Znsq = parcelRequire("3Znsq");

var $hmNQT = parcelRequire("hmNQT");

var $cSt5x = parcelRequire("cSt5x");

var $kHUCl = parcelRequire("kHUCl");
const $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1 = {
    id: "hierarchy-browser",
    root: "",
    treeList: [],
    currentHierarchy: "",
    currentHierarchyType: null,
    currentAccessRights: [],
    showTableLinks: false,
    canSelect: false,
    selections: [],
    hierarchyTlfItemIndex: []
};
const $cfd8f304cddd80a4$export$70151fc5312f6f84 = ({ initialState: initialState, children: children })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const [state, dispatch] = (0, $7fPBF.useReducer)((0, $hmNQT.hierarchyBrowserReducer), {
        id: initialState?.id ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.id,
        root: initialState?.root ?? hierarchyContext?.hierarchyNodes.find((h)=>h.level === (0, $7Wd8C.eHierarchyLevel).Corporate)?.id ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.root,
        treeList: initialState?.treeList ?? (hierarchyContext !== null ? (0, $cSt5x.hierarchyToNodes)(hierarchyContext.hierarchyNodes) : $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.treeList),
        currentHierarchy: initialState?.currentHierarchy ?? hierarchyContext?.hierarchy?.id ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.currentHierarchy,
        currentHierarchyType: hierarchyContext?.hierarchyNodes.find((h)=>h.id === (initialState?.currentHierarchy ?? hierarchyContext?.hierarchy?.id ?? // istanbul ignore next
            $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.currentHierarchy))?.type ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.currentHierarchyType,
        currentAccessRights: $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.currentAccessRights,
        showTableLinks: initialState?.showTableLinks ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.showTableLinks,
        canSelect: initialState?.canSelect ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.canSelect,
        selections: initialState?.selections ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.selections,
        hierarchyTlfItemIndex: initialState?.hierarchyTlfItemIndex ?? $cfd8f304cddd80a4$export$cf131ad2cb2b8ec1.hierarchyTlfItemIndex
    });
    const [corpRequest, setCorpRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const getCorporate = (0, $7fPBF.useEffectEvent)(async ()=>{
        const request = await (0, $30Ra3.loadWrapper)((0, $1ddQW.loadHierarchy), {
            hierarchyName: "Corporate"
        }, corpRequest, setCorpRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) dispatch({
            operation: (0, $kHUCl.SET_CORPORATE_HIERARCHY),
            hierarchyNode: request.data
        });
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!hierarchyContext?.hierarchy) getCorporate();
    }, [
        hierarchyContext?.hierarchy
    ]);
    // Update current if an unknown item is selected
    const [loadCurrent, setLoadCurrent] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const getHierarchyAsync = (0, $7fPBF.useCallback)(async (hierarchyId)=>{
        /* istanbul ignore else */ if (hierarchyContext) {
            const response = await (0, $30Ra3.loadWrapper)((0, $1ddQW.loadHierarchy), {
                hierarchyId: hierarchyId
            }, {
                ...loadCurrent,
                error: false,
                errorText: undefined
            }, setLoadCurrent, appSettings.backEndUrl);
            if (response?.success) {
                dispatch({
                    operation: (0, $kHUCl.ADD_HIERARCHY_NODES),
                    treeListData: (0, $cSt5x.hierarchyToNodes)([
                        response.data
                    ])
                });
                hierarchyContext.dispatch({
                    operation: (0, $kHUCl.ADD_HIERARCHY_NODES),
                    hierarchyNodes: [
                        response.data
                    ]
                });
            }
        }
    }, [
        appSettings.backEndUrl,
        hierarchyContext,
        loadCurrent
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const currentNode = state.treeList.find((n)=>n.id === state.currentHierarchy);
        if (state.currentHierarchy && (!currentNode || !(0, $cPBZD.isHierarchyReadDto)(currentNode.data))) getHierarchyAsync(state.currentHierarchy);
    }, [
        getHierarchyAsync,
        state
    ]);
    // Get current access rights
    const [arRequest, setArRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const updateAccessRights = (0, $7fPBF.useCallback)(async (hierarchyId)=>{
        if (hierarchyId !== "") {
            const request = await (0, $30Ra3.loadWrapper)((0, $jOvyw.getMyAccess), hierarchyId, arRequest, setArRequest, appSettings.backEndUrl);
            if (request?.success) dispatch({
                operation: (0, $kHUCl.SET_CURRENT_ACCESS_RIGHTS),
                accessRights: request.data
            });
            else if (request?.success === false) dispatch({
                operation: (0, $kHUCl.SET_CURRENT_ACCESS_RIGHTS),
                accessRights: []
            });
        } else dispatch({
            operation: (0, $kHUCl.SET_CURRENT_ACCESS_RIGHTS),
            accessRights: []
        });
    }, [
        appSettings.backEndUrl,
        arRequest
    ]);
    (0, $7fPBF.useEffect)(()=>{
        updateAccessRights(state.currentHierarchy);
    }, [
        state.currentHierarchy,
        updateAccessRights
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3Znsq.HierarchyBrowserContext).Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            arRequest: arRequest,
            loadCurrent: loadCurrent
        },
        children: children
    });
};
$cfd8f304cddd80a4$export$70151fc5312f6f84.displayName = "HierarchyBrowserContextProvider";
const $cfd8f304cddd80a4$export$2ccd25337205a8d = ()=>{
    const context = (0, $7fPBF.useContext)((0, $3Znsq.HierarchyBrowserContext));
    return !context ? {
        state: null,
        dispatch: null,
        loadCurrent: {
            error: false,
            requesting: false
        },
        arRequest: {
            error: false,
            requesting: false
        }
    } : context;
};

});
parcelRegister("jOvyw", function(module, exports) {

$parcel$export(module.exports, "getMyAccess", function () { return $994b14b8e659f768$export$defb43a444190f21; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $994b14b8e659f768$export$defb43a444190f21 = async (backEndUrl, hierarchyId, controller)=>{
    const url = `${backEndUrl}UserAccess/UserPermissions/Me/Hierarchies/${hierarchyId}`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load my access failed", error);
    }
};

});

parcelRegister("hmNQT", function(module, exports) {

$parcel$export(module.exports, "hierarchyBrowserReducer", function () { return $b49b41d83230574d$export$b72ff9b49dc01c40; });

var $cSt5x = parcelRequire("cSt5x");

var $kHUCl = parcelRequire("kHUCl");
const $b49b41d83230574d$export$b72ff9b49dc01c40 = (state, action)=>{
    switch(action.operation){
        case 0, $kHUCl.ADD_HIERARCHY_NODES:
            {
                const newTreeList = [
                    ...state.treeList.filter((hn)=>!action.treeListData.find((h)=>h.id === hn.id)),
                    ...action.treeListData
                ].sort((a, b)=>a.label.localeCompare(b.label));
                return {
                    ...state,
                    treeList: newTreeList
                };
            }
        case 0, $kHUCl.ADD_SELECTION:
            {
                const newSelections = [
                    ...state.selections.filter((s)=>s.id !== action.selection.id),
                    action.selection
                ].sort((a, b)=>a.id.localeCompare(b.id));
                return {
                    ...state,
                    selections: newSelections
                };
            }
        case 0, $kHUCl.REMOVE_SELECTION:
            {
                const newSelections = state.selections.filter((s)=>s.id !== action.selection.id);
                return {
                    ...state,
                    selections: newSelections
                };
            }
        case 0, $kHUCl.SET_CORPORATE_HIERARCHY:
            {
                const treeList = (0, $cSt5x.hierarchyToNodes)([
                    action.hierarchyNode
                ]);
                return {
                    ...state,
                    root: action.hierarchyNode.id,
                    treeList: treeList,
                    currentHierarchy: action.hierarchyNode.id,
                    currentHierarchyType: action.hierarchyNode.type
                };
            }
        case 0, $kHUCl.SET_CURRENT_ACCESS_RIGHTS:
            return {
                ...state,
                currentAccessRights: action.accessRights
            };
        case 0, $kHUCl.SET_CURRENT_HIERARCHY:
            {
                const data = state.treeList.find((h)=>h.id === action.nodeId)?.data;
                return {
                    ...state,
                    currentHierarchy: action.nodeId,
                    currentHierarchyType: data ? data.type : state.currentHierarchyType
                };
            }
        case 0, $kHUCl.SET_NEW_REPORT_DETAILS:
            return {
                ...state,
                newReportDescription: action.newReportDescription,
                newReportName: action.newReportName,
                newReportType: action.newReportType,
                newReportValid: action.newReportValid
            };
        case 0, $kHUCl.SET_NEW_TLF_ITEM_DETAILS:
            return {
                ...state,
                newTlfItemDetails: action.tlfItemDetails
            };
        case 0, $kHUCl.SET_NEW_TLF_ITEM_DETAILS_VALID:
            return {
                ...state,
                newTlfItemDetailsValid: action.tlfItemDetailsValid
            };
        case 0, $kHUCl.SET_SELECTIONS:
            return {
                ...state,
                selections: action.selections
            };
        case 0, $kHUCl.UPSERT_HIERARCHY_TLF_ITEM_INDEX:
            {
                const index = state.hierarchyTlfItemIndex.findIndex((i)=>i.hierarchyId === action.nodeId);
                if (index !== -1) {
                    const newHierarchyTlfItemIndex = state.hierarchyTlfItemIndex.map((item, idx)=>idx === index ? {
                            ...item,
                            tlfItemIndex: action.tlfItemIndex
                        } : item);
                    return {
                        ...state,
                        hierarchyTlfItemIndex: newHierarchyTlfItemIndex
                    };
                } else {
                    const newHierarchyTlfItemIndex = [
                        ...state.hierarchyTlfItemIndex,
                        {
                            hierarchyId: action.nodeId,
                            tlfItemIndex: action.tlfItemIndex
                        }
                    ];
                    return {
                        ...state,
                        hierarchyTlfItemIndex: newHierarchyTlfItemIndex
                    };
                }
            }
    }
};

});


parcelRegister("7NdbJ", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowser", function () { return $6edb657040f1518c$export$ef322457c1fb71bb; });

var $bbzbN = parcelRequire("bbzbN");

var $20AtX = parcelRequire("20AtX");


var $6aEge = parcelRequire("6aEge");

var $jHxne = parcelRequire("jHxne");

var $kHUCl = parcelRequire("kHUCl");
const $6edb657040f1518c$export$ef322457c1fb71bb = ({ heightPx: heightPx = 400, width: width = "100%" })=>{
    const { state: state, dispatch: dispatch } = (0, $6aEge.useHBC)();
    return !state ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        id: `${state?.id}`,
        className: "hierarchy-browser",
        style: {
            position: "relative",
            minHeight: `${heightPx}px`,
            height: `${heightPx}px`,
            maxHeight: `${heightPx}px`,
            minWidth: width,
            width: width,
            maxWidth: width
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jHxne.HierarchyBrowserLhs), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                id: `${state.id}-right`,
                className: "hb-right",
                style: {
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "hb-container",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $20AtX.TlfItemTable), {
                        id: `tlfitemtable-${state.currentHierarchyType}`,
                        selectedItems: state.selections?.map((s)=>s.id),
                        setSelectedItems: state.canSelect ? (ret)=>{
                            const thisHierarchyIndex = state.hierarchyTlfItemIndex.find((ix)=>ix.hierarchyId === state.currentHierarchy)?.tlfItemIndex;
                            /* istanbul ignore else */ if (thisHierarchyIndex) dispatch({
                                operation: (0, $kHUCl.SET_SELECTIONS),
                                selections: ret.map((id)=>thisHierarchyIndex.find((tlf)=>tlf.id === id)).filter((tlf)=>tlf !== undefined).map((tlf)=>({
                                        id: tlf.id,
                                        azsolId: tlf.azsolId,
                                        domain: tlf.domain
                                    }))
                            });
                        } : undefined
                    })
                })
            })
        ]
    });
};
$6edb657040f1518c$export$ef322457c1fb71bb.displayName = "HierarchyBrowser";

});
parcelRegister("jHxne", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowserLhs", function () { return $6b260829b86b4f69$export$1fdc21900c94165d; });

var $bbzbN = parcelRequire("bbzbN");

var $h6WyF = parcelRequire("h6WyF");

var $7fPBF = parcelRequire("7fPBF");

var $3Znsq = parcelRequire("3Znsq");

var $kHUCl = parcelRequire("kHUCl");
const $6b260829b86b4f69$export$1fdc21900c94165d = ()=>{
    const hbc = (0, $7fPBF.useContext)((0, $3Znsq.HierarchyBrowserContext));
    return hbc && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        id: `${hbc.state.id}-left`,
        className: "hb-left",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                children: "Directory"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "hb-container small-scrollbar",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h6WyF.TreeOfNodes), {
                    id: "hierarchy-tree",
                    roots: [
                        hbc.state.root
                    ],
                    selected: hbc.state.currentHierarchy,
                    nodeList: hbc.state.treeList,
                    canRemoveRoot: false,
                    canAddChildren: false,
                    canRenameRoot: false,
                    canRemoveChildren: false,
                    canRenameChildren: false,
                    nodeHighlight: "rgb(33,35,241)",
                    textHighlight: "rgba(33,35,211,0.1)",
                    handleSelect: (ret)=>{
                        /* istanbul ignore else */ if (!Array.isArray(ret) && typeof ret === "string") hbc.dispatch({
                            operation: (0, $kHUCl.SET_CURRENT_HIERARCHY),
                            nodeId: ret
                        });
                    }
                })
            })
        ]
    });
};
$6b260829b86b4f69$export$1fdc21900c94165d.displayName = "HierarchyBrowserLhs";

});


parcelRegister("fCyVX", function(module, exports) {

$parcel$export(module.exports, "CopyReportModalName", function () { return $7974787363e881ab$export$b24bc63375e601fc; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $dImYe = parcelRequire("dImYe");
var $30Ra3 = parcelRequire("30Ra3");

var $6aEge = parcelRequire("6aEge");

var $kHUCl = parcelRequire("kHUCl");

var $hrazC = parcelRequire("hrazC");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $3d9YA = parcelRequire("3d9YA");

var $bvvhK = parcelRequire("bvvhK");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $8d4Ob = parcelRequire("8d4Ob");
var $kYoG1 = parcelRequire("kYoG1");
const $7974787363e881ab$export$b24bc63375e601fc = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: state, dispatch: dispatch } = (0, $6aEge.useHBC)();
    const [reportTypes, setReportTypes] = (0, $7fPBF.useState)([]);
    const [reportSuffixes, setReportSuffixes] = (0, $7fPBF.useState)([]);
    const [requestTypes, setRequestTypes] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const getReportTypesData = (0, $7fPBF.useEffectEvent)(async ()=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $bvvhK.getReportTypes), null, requestTypes, setRequestTypes, appSettings.backEndUrl);
        if (response?.success) (0, $7fPBF.startTransition)(()=>setReportTypes(response.data));
    });
    const [requestSuffixes, setRequestSuffixes] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const getReportSuffixesData = (0, $7fPBF.useEffectEvent)(async ()=>{
        const response = await (0, $30Ra3.loadWrapper)((0, $3d9YA.getReportSuffixes), null, requestSuffixes, setRequestSuffixes, appSettings.backEndUrl);
        if (response?.success) (0, $7fPBF.startTransition)(()=>setReportSuffixes(response.data));
    });
    (0, $7fPBF.useEffect)(()=>{
        getReportTypesData();
        getReportSuffixesData();
    }, []);
    const currentHierarchy = hierarchyContext?.hierarchyNodes.find((h)=>h.id === state?.currentHierarchy);
    const thisHierarchyNewReportInputs = (0, $hrazC.newReportInputs)(currentHierarchy?.children.map((r)=>r.name.toLowerCase()) ?? [], reportTypes, reportSuffixes);
    const [currentValues, setCurrentValues] = (0, $7fPBF.useState)(Object.fromEntries(thisHierarchyNewReportInputs.filter((inp)=>!inp.computeValue).map((inp)=>[
            inp.inputName,
            inp.initialValue ?? ""
        ])));
    const [textValid, setTextValid] = (0, $7fPBF.useState)(thisHierarchyNewReportInputs.map((inp)=>{
        const isHidden = typeof inp.hidden === "function" ? inp.hidden(currentValues) : inp.hidden ?? false;
        return !inp.validCondition || isHidden;
    }));
    /**
   * Effect to dispatch when names change
   */ (0, $7fPBF.useEffect)(()=>{
        dispatch?.({
            operation: (0, $kHUCl.SET_NEW_REPORT_DETAILS),
            newReportName: (currentValues["Name"] ?? "").trim(),
            newReportDescription: (currentValues["Description"] ?? // istanbul ignore next
            "").trim(),
            newReportType: (currentValues["ReportType"] ?? // istanbul ignore next
            "").trim(),
            newReportValid: (currentValues["Name"] ?? // istanbul ignore next
            "").trim() !== "" && (currentValues["Description"] ?? // istanbul ignore next
            "").trim() !== "" && (currentValues["ReportType"] ?? // istanbul ignore next
            "").trim() !== "" && !textValid.some((v)=>v === false)
        });
    }, [
        currentValues,
        dispatch,
        textValid
    ]);
    return !state ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default), {
        className: "mt-3",
        children: state.currentHierarchyType !== (0, $7Wd8C.eHierarchy).StudyDirectory ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
            className: "my-1",
            style: {
                height: "55px"
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                className: "d-flex justify-content-center",
                children: "Reports have to be saved to studies"
            })
        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dImYe.ControlsGroup), {
            baseId: `copy-report-new-name-form`,
            currentValues: currentValues,
            inputs: (0, $hrazC.newReportInputs)(currentHierarchy?.children.map((r)=>r.name.toLowerCase()) ?? // istanbul ignore next
            [], reportTypes, reportSuffixes),
            setCurrentValues: (vals)=>setCurrentValues(vals),
            setTextValid: setTextValid,
            spellCheck: false
        })
    });
};
$7974787363e881ab$export$b24bc63375e601fc.displayName = "CopyReportModalName";

});

parcelRegister("8YtG5", function(module, exports) {

$parcel$export(module.exports, "CopyReportModalOk", function () { return $b3be9914c0fdfd67$export$a217f00d7854ef73; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");

var $6aEge = parcelRequire("6aEge");

var $hWsmt = parcelRequire("hWsmt");

var $9Jgpw = parcelRequire("9Jgpw");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $75BPL = parcelRequire("75BPL");

var $7fPBF = parcelRequire("7fPBF");
const $b3be9914c0fdfd67$export$a217f00d7854ef73 = ({ onClick: onClick })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: state, arRequest: arRequest } = (0, $6aEge.useHBC)();
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("copy-report-modal-ok");
    const [copyRequest, setCopyRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    if (!state || !hierarchyContext || !hierarchyContext.hierarchy) return null;
    /**
   * Calls the API to copy the report and handles the response.
   */ const callCopyReport = async ()=>{
        /* istanbul ignore else */ if (state.currentHierarchyType === (0, $7Wd8C.eHierarchy).StudyDirectory && state.newReportName) {
            const request = await (0, $30Ra3.loadWrapper)((0, $75BPL.copyReport), {
                reportId: hierarchyContext.hierarchy.id,
                hierarchyId: state.currentHierarchy,
                newReportName: state.newReportName,
                parentTag: hierarchyContext.hierarchyNodes.find((h)=>h.id === state.currentHierarchy)?.parentTag ?? // istanbul ignore next
                "",
                description: state?.newReportDescription ?? "",
                reportType: state?.newReportType ?? ""
            }, copyRequest, setCopyRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) {
                hierarchyContext.dispatch({
                    operation: (0, $9Jgpw.ADD_HIERARCHY_NODES),
                    hierarchyNodes: [
                        request.data
                    ]
                });
                navigate(`/R/${request.data.id}`);
                onClick();
            }
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
        id: "copyreportmodal-save",
        style: {
            minWidth: "120px",
            minHeight: "32px",
            position: "relative"
        },
        variant: arRequest.error || copyRequest.error ? "danger" : state.currentAccessRights?.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy) ? "primary" : "secondary",
        disabled: !state.newReportValid || !state.currentHierarchy || arRequest.error || arRequest.requesting || !state.currentAccessRights || !state.currentAccessRights.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy) || copyRequest.requesting || state.currentHierarchyType !== (0, $7Wd8C.eHierarchy).StudyDirectory,
        onClick: ()=>{
            callCopyReport();
        },
        title: arRequest.errorText ?? copyRequest.errorText,
        requestStatus: [
            {
                ...arRequest,
                errorText: "Error getting rights"
            },
            {
                ...copyRequest,
                errorText: "Error copying, please refresh the page"
            }
        ],
        pauseCoverText: arRequest.requesting ? "Loading rights..." : "Copying...",
        children: state.currentAccessRights && state.currentAccessRights.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy) ? "Copy" : "No write access to this level"
    });
};
$b3be9914c0fdfd67$export$a217f00d7854ef73.displayName = "CopyReportModalOk";

});
parcelRegister("75BPL", function(module, exports) {

$parcel$export(module.exports, "copyReport", function () { return $ad82babdfae6b340$export$2e68418460eeee93; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $ad82babdfae6b340$export$2e68418460eeee93 = async (backEndUrl, params, controller)=>{
    const url = `${backEndUrl}Reports/CopyReport/${params.reportId}`;
    const { reportId: _reportId, ...body } = params;
    try {
        const response = await (0, $a04va.default).post(url, body, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Copy report failed", error);
    }
};

});



parcelRegister("5Iom1", function(module, exports) {

$parcel$export(module.exports, "tocVersionString", function () { return $1ce7ea61d7d9d57b$export$fe862cde0b06443c; });
/**
 * Build a human-readable TOC version string from major/minor numbers.
 *
 * @param tocMajorVersion - Major version number for the TOC.
 * @param tocMinorVersion - Minor version number for the TOC (zero-padded to 4 digits).
 * @param isBackupVersion - When true, append a backup indicator to the string.
 * @returns A formatted version string like `1.0001` or `1.0001 - backup version`.
 */ const $1ce7ea61d7d9d57b$export$fe862cde0b06443c = (tocMajorVersion = 0, tocMinorVersion = 0, isBackupVersion = false)=>{
    let version = `${tocMajorVersion}.${tocMinorVersion.toString().padStart(4, "0")}`;
    if (isBackupVersion) version += " - backup version";
    return version;
};

});

parcelRegister("9469n", function(module, exports) {

$parcel$export(module.exports, "downloadAnnotationsCSV", function () { return $93ff7ed3dec6578d$export$b6d6d5a2ff359cfd; });

var $jDVSO = parcelRequire("jDVSO");
const $93ff7ed3dec6578d$export$b6d6d5a2ff359cfd = async (url, fileName)=>{
    const response = await (0, $jDVSO.downloadFile)({
        url: url,
        fileName: fileName,
        fileType: "text/csv",
        blob: true,
        successMessage: "File successfully downloaded",
        errorMessage: "An error has occurred downloading the file",
        controller: new AbortController()
    });
    return response;
};

});

parcelRegister("1RXOp", function(module, exports) {

$parcel$export(module.exports, "downloadArsReport", function () { return $69b0a01dcf41819b$export$ee82a6af634d7224; });

var $jDVSO = parcelRequire("jDVSO");
const $69b0a01dcf41819b$export$ee82a6af634d7224 = async (backEndUrl, hierarchyId, reportName)=>{
    const fileName = `${reportName}_ars.json`;
    const response = await (0, $jDVSO.downloadFile)({
        url: `${backEndUrl}Ars/Hierarchy/${hierarchyId}`,
        fileName: fileName,
        fileType: "application/json",
        blob: false,
        successMessage: "ARS document successfully downloaded",
        errorMessage: "An error has occurred downloading the ARS document",
        controller: new AbortController()
    });
    return response;
};

});

parcelRegister("9r5CO", function(module, exports) {

$parcel$export(module.exports, "LoadXmlLibraryModal", function () { return $d1e773c58740a129$export$fc53bd89838d8f4b; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
var $30Ra3 = parcelRequire("30Ra3");

var $hWsmt = parcelRequire("hWsmt");

var $cUYwh = parcelRequire("cUYwh");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");
var $8d4Ob = parcelRequire("8d4Ob");
var $d8uJi = parcelRequire("d8uJi");
var $kYoG1 = parcelRequire("kYoG1");
const $d1e773c58740a129$export$fc53bd89838d8f4b = ({ show: show, onClose: onClose })=>{
    const [xmlFile, setXmlFile] = (0, $7fPBF.useState)(null);
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchyId = hierarchyContext?.hierarchy?.id;
    const [loadRequest, setLoadRequest] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    /**
   * Closes the modal and resets state.
   */ const cx = ()=>{
        setXmlFile(null);
        setLoadRequest({
            requesting: false,
            error: false
        });
        onClose();
    };
    /**
   * Handles loading the XML file: reads the file, validates it, and if valid,
   *
   * @param xmlFile - The XML file to be processed.
   */ const onLoad = async (xmlFile)=>{
        const text = await xmlFile.text();
        /* istanbul ignore else */ if (hierarchyId && text.length > 0) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(text, "text/xml");
            const parseError = xmlDoc.querySelector("parsererror");
            if (parseError) setLoadRequest({
                requesting: false,
                error: true,
                errorText: "Invalid XML file. Please upload a well-formed XML."
            });
            else await (0, $30Ra3.loadWrapper)((0, $cUYwh.loadClinicalLibrary), {
                hierarchyId: hierarchyId,
                xmlText: text
            }, loadRequest, setLoadRequest, appSettings.backEndUrl);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default), {
        show: show,
        size: "lg",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Header, {
                closeButton: true,
                onHide: cx,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Title, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                        children: "Upload clinical library XML file"
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8uJi.default).Body, {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
                        className: "m-2",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h5", {
                                className: "mb-2",
                                children: "Select a file"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Group, {
                                controlId: "upload-xml",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Control, {
                                    "aria-label": "XML file upload",
                                    className: "mb-2",
                                    type: "file",
                                    accept: ".xml",
                                    onChange: (e)=>{
                                        const files = e.target.files;
                                        /* istanbul ignore else */ if (files && files.length > 0) setXmlFile(files[0]);
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8uJi.default).Footer, {
                children: [
                    loadRequest.requestedId?.hierarchyId === hierarchyId && /*#__PURE__*/ (0, $bbzbN.jsx)("h6", {
                        className: "text-success",
                        children: "File processed successfully"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: "load-xml-button",
                        className: "mt-2",
                        disabled: !xmlFile,
                        requestStatus: loadRequest,
                        onClick: ()=>onLoad(xmlFile),
                        children: "Load"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: "loadxmllibrarymodal-cancel",
                        variant: "secondary",
                        onClick: cx,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
};
$d1e773c58740a129$export$fc53bd89838d8f4b.displayName = "LoadXmlLibraryModal";

});
parcelRegister("cUYwh", function(module, exports) {

$parcel$export(module.exports, "loadClinicalLibrary", function () { return $8fd2288226fb6416$export$e05e15be8fb7128f; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
// Get CHUNK_SIZE from environment variable or default to 2MB
const $8fd2288226fb6416$var$CHUNK_SIZE_MB = parseInt(undefined ?? "2");
const $8fd2288226fb6416$var$CHUNK_SIZE = 1048576 * $8fd2288226fb6416$var$CHUNK_SIZE_MB; // Convert MB to bytes
const $8fd2288226fb6416$var$MAX_PARALLEL_UPLOADS = parseInt(undefined ?? "3");
const $8fd2288226fb6416$export$e05e15be8fb7128f = async (backEndUrl, params, controller, onProgress)=>{
    /* Endpoint accepting chunked uploads (FormData with fileId, sequenceNumber, totalChunks, chunk). */ const uploadChunkUrl = `${backEndUrl}ClinicalLibrary/UploadChunks`;
    /* Endpoint to signal completion of all chunk uploads (FormData with fileId, hierarchyId). */ const completeUploadUrl = `${backEndUrl}ClinicalLibrary/CompleteUpload`;
    try {
        // Convert XML string to Uint8Array for chunking
        const encoder = new TextEncoder();
        /* UTF-8 encoded byte representation of the XML text.*/ const xmlData = encoder.encode(params.xmlText);
        // Calculate chunks
        const totalChunks = Math.ceil(xmlData.length / $8fd2288226fb6416$var$CHUNK_SIZE);
        /**
     * Unique identifier used to associate all chunks and the completion request.
     * This must be stable across all requests in a single upload.
     */ const fileId = crypto.randomUUID();
        let uploadedChunks = 0;
        // Upload chunks in small parallel batches
        for(let i = 0; i < totalChunks; i += $8fd2288226fb6416$var$MAX_PARALLEL_UPLOADS){
            const batch = Array.from({
                length: Math.min($8fd2288226fb6416$var$MAX_PARALLEL_UPLOADS, totalChunks - i)
            }, (_, j)=>i + j);
            await Promise.all(batch.map(async (sequenceNumber)=>{
                const start = sequenceNumber * $8fd2288226fb6416$var$CHUNK_SIZE;
                const end = Math.min((sequenceNumber + 1) * $8fd2288226fb6416$var$CHUNK_SIZE, xmlData.length);
                const chunkData = xmlData.slice(start, end);
                const chunkBlob = new Blob([
                    chunkData
                ], {
                    type: "application/xml"
                });
                const formData = new FormData();
                formData.append("fileId", fileId);
                formData.append("sequenceNumber", sequenceNumber.toString());
                formData.append("totalChunks", totalChunks.toString());
                formData.append("hierarchyId", params.hierarchyId);
                formData.append("chunk", chunkBlob, `chunk_${sequenceNumber}.xml`);
                await (0, $a04va.default).post(uploadChunkUrl, formData, {
                    signal: controller.signal
                });
                uploadedChunks++;
                onProgress?.(Math.round(uploadedChunks / totalChunks * 100));
            }));
        }
        // Notify backend all chunks are uploaded
        const completeForm = new FormData();
        completeForm.append("fileId", fileId);
        completeForm.append("hierarchyId", params.hierarchyId);
        await (0, $a04va.default).post(completeUploadUrl, completeForm, {
            signal: controller.signal
        });
        onProgress?.(100);
        return {
            success: true
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load clinical library in chunks failed", error);
    }
};

});



parcelRegister("equz4", function(module, exports) {

$parcel$export(module.exports, "TlfInner", function () { return $435fada92fc519c7$export$451f3024d6ddacc9; });
$parcel$export(module.exports, "Tlf", function () { return $435fada92fc519c7$export$26ac70fba7792550; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $7Wd8C = parcelRequire("7Wd8C");

var $lNt9u = parcelRequire("lNt9u");

var $h1xuz = parcelRequire("h1xuz");
var $kYoG1 = parcelRequire("kYoG1");

var $3wCT0 = parcelRequire("3wCT0");

var $81Xb6 = parcelRequire("81Xb6");

var $bjTvQ = parcelRequire("bjTvQ");

var $gtWPA = parcelRequire("gtWPA");

var $c0CTk = parcelRequire("c0CTk");

var $kU4Z3 = parcelRequire("kU4Z3");

var $1oDpR = parcelRequire("1oDpR");

var $5SKwd = parcelRequire("5SKwd");

var $5uyDP = parcelRequire("5uyDP");

var $jHuGz = parcelRequire("jHuGz");

var $1TSz4 = parcelRequire("1TSz4");

var $54Uke = parcelRequire("54Uke");

var $1vibC = parcelRequire("1vibC");
const $435fada92fc519c7$export$451f3024d6ddacc9 = ()=>{
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    return !tlfContext || tlfData?.id === undefined ? null : !(0, $lNt9u.isTlfItemReadDto)(tlfData) ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
            className: "d-flex justify-content-center mt-4 ",
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "text-danger",
                    children: "The TLF data for this item is corrupdated/incorrect. Please contact support quoting id:"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "ms-1",
                    children: tlfData.id
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    className: "d-flex justify-content-center",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5uyDP.Titles), {})
                })
            }),
            tlfData.type === (0, $7Wd8C.eTlfItemType).arsListing || tlfData.type === (0, $7Wd8C.eTlfItemType).arsTable ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3wCT0.ArsPageBy), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c0CTk.PageBy), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $54Uke.TlfUndoButtons), {}),
            tlfData.type === (0, $7Wd8C.eTlfItemType).v1figure ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar",
                    style: {
                        display: "grid",
                        placeItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1vibC.V1Figure), {})
                })
            }) : tlfData.type === (0, $7Wd8C.eTlfItemType).figure ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                id: "tlf-body-holder-row",
                className: "mb-3 w-100",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    id: "tlf-body-holder-col",
                    className: "w-100",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bjTvQ.InteractiveFigure), {})
                })
            }) : tlfData.type === (0, $7Wd8C.eTlfItemType).arsListing ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar position-relative",
                    style: {
                        display: "grid",
                        placeItems: "center",
                        height: "calc(100% + 1em)"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jHuGz.TlfArsListing), {})
                })
            }) : tlfData.type === (0, $7Wd8C.eTlfItemType).arsTable ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar position-relative",
                    style: {
                        display: "grid",
                        placeItems: "center",
                        height: "calc(100% + 1em)"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1TSz4.TlfArsTable), {})
                })
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar",
                    style: {
                        display: "grid",
                        placeItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5SKwd.TableListing), {})
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                className: "my-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $81Xb6.Footnotes), {
                        canAddFirstRow: true
                    })
                })
            })
        ]
    });
};
$435fada92fc519c7$export$451f3024d6ddacc9.displayName = "TlfInner";
const $435fada92fc519c7$export$26ac70fba7792550 = ()=>{
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    return !tlfData ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
        id: "tlf-row",
        className: "mt-4 flex-grow-1 small-scrollbar w-100",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
            className: "d-flex justify-content-center",
            style: {
                position: "relative"
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                children: "No TLF loaded, go to File -> Load TLF"
            })
        })
    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($435fada92fc519c7$export$451f3024d6ddacc9, {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kU4Z3.ProgrammerNotes), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gtWPA.NotesTable), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1oDpR.StandardsNotes), {})
        ]
    });
};
$435fada92fc519c7$export$26ac70fba7792550.displayName = "Tlf";

});
parcelRegister("3wCT0", function(module, exports) {

$parcel$export(module.exports, "ArsPageBy", function () { return $bbca33eb8bf638b4$export$d5a278c5d83793d; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $iGqDA = parcelRequire("iGqDA");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $7Wd8C = parcelRequire("7Wd8C");

var $lNt9u = parcelRequire("lNt9u");

var $h1xuz = parcelRequire("h1xuz");
var $kYoG1 = parcelRequire("kYoG1");
const $bbca33eb8bf638b4$var$dropText = {
    lines: [
        {
            textBlocks: [
                {
                    text: "Drop grouping factors here",
                    style: "OptionalLocked",
                    type: "text"
                }
            ]
        }
    ]
};
const $bbca33eb8bf638b4$export$d5a278c5d83793d = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    if (!tlfContext || !(0, $lNt9u.isTlfItemReadDto)(tlfData) || tlfData.type !== (0, $7Wd8C.eTlfItemType).arsListing && tlfData.type !== (0, $7Wd8C.eTlfItemType).arsTable) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
        className: "my-4",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $iGqDA.ArsBlock), {
                disabled: tlfContext.readOnly,
                dropText: $bbca33eb8bf638b4$var$dropText,
                editorDefns: (0, $lQquc.v3EditorProps),
                id: `ars-page-by-${tlfData.id}`,
                setValue: (pageBy)=>tlfContext.dispatch({
                        operation: (0, $dDC3L.UPDATE_TLF),
                        tlfData: {
                            pageBy: pageBy
                        },
                        calledFrom: "ArsPageBy onChange"
                    }),
                style: appSettings.defaultTableStyle,
                value: tlfData.pageBy
            })
        })
    });
};
$bbca33eb8bf638b4$export$d5a278c5d83793d.displayName = "ArsPageBy";

});
parcelRegister("lQquc", function(module, exports) {

$parcel$export(module.exports, "v3EditorProps", function () { return $96695a937ce69c83$export$12fbebec3959af1b; });

var $1iDss = parcelRequire("1iDss");

var $buR8L = parcelRequire("buR8L");
const $96695a937ce69c83$export$12fbebec3959af1b = {
    Editor: (0, $buR8L.EditorV3Wrapper),
    blankT: (0, $1iDss.stringToV3)(""),
    getTextFromT: (0, $1iDss.getTextFromEditorV3),
    isT: (0, $1iDss.isIEditorV3),
    joinTintoBlock: (0, $1iDss.joinV3intoBlock),
    replaceTextInT: (0, $1iDss.replaceTextInEditorV3),
    splitTintoLines: (0, $1iDss.splitV3intoLines),
    textToT: (0, $1iDss.stringToV3)
};

});
parcelRegister("buR8L", function(module, exports) {

$parcel$export(module.exports, "EditorV3Wrapper", function () { return $0383e65ac1559779$export$1948bd376c6a2ec2; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");

var $hWsmt = parcelRequire("hWsmt");

var $7Wd8C = parcelRequire("7Wd8C");

var $98Em8 = parcelRequire("98Em8");

var $iQGjt = parcelRequire("iQGjt");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $aBGeK = parcelRequire("aBGeK");

var $fZLKg = parcelRequire("fZLKg");
const $0383e65ac1559779$export$1948bd376c6a2ec2 = ({ id: id, value: value, setValue: setValue, editable: editable, preReplacedText: preReplacedText, textAlignment: textAlignment, allowNewLine: allowNewLine, commentConfig: commentConfig, ...rest })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    // Timestamp when pre-replaced text was shown (null means not showing)
    const [showPreReplacedText, setShowPreReplacedText] = (0, $7fPBF.useState)(null);
    const wrapperRef = (0, $7fPBF.useRef)(null);
    // Request animation frame ref
    const rafRef = (0, $7fPBF.useRef)(null);
    // Mouse and focus state ref
    const stateRef = (0, $7fPBF.useRef)({
        focused: false,
        mouse: {
            x: 0,
            y: 0
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (showPreReplacedText === null) return;
        /**
     * Tracks mouse position for pre-replacement text preview positioning.
     *
     * @param e - The mouse event containing cursor coordinates
     */ const handleMouseMove = (e)=>{
            stateRef.current.mouse = {
                x: e.clientX,
                y: e.clientY
            };
        };
        document.addEventListener("mousemove", handleMouseMove);
        return ()=>document.removeEventListener("mousemove", handleMouseMove);
    }, [
        showPreReplacedText
    ]);
    /**
   * Memoized replacement text check
   */ const replacement = (0, $7fPBF.useMemo)(()=>editable && preReplacedText && !(0, $gSkQi.isEqual)((0, $1iDss.getTextFromEditorV3)(value), (0, $1iDss.getTextFromEditorV3)(preReplacedText)), [
        editable,
        preReplacedText,
        value
    ]);
    /**
   * Comprehensive check function that verifies mouse position and focus
   */ const performComprehensiveCheck = (0, $7fPBF.useEffectEvent)(()=>{
        // Look for table cell if there is one, otherwise use the wrapper
        const el = wrapperRef.current?.closest("td") ?? wrapperRef.current;
        const EXTRA_MOUSE_COVER_PX = 8;
        const MIN_SHOW_TIME_MS = 500;
        /**
     * Performs the comprehensive check for hiding pre-replaced text
     */ const check = ()=>{
            /* istanbul ignore else */ if (el && replacement) {
                const hasFocus = el.contains(document.activeElement) || stateRef.current.focused;
                const rect = el.getBoundingClientRect();
                const { x: x, y: y } = stateRef.current.mouse;
                const mouseOver = x >= rect.left - EXTRA_MOUSE_COVER_PX && x <= rect.right + EXTRA_MOUSE_COVER_PX && y >= rect.top - EXTRA_MOUSE_COVER_PX && y <= rect.bottom + EXTRA_MOUSE_COVER_PX;
                const now = Date.now();
                const elapsed = now - (showPreReplacedText ?? // istanbul ignore next
                0);
                if (elapsed > MIN_SHOW_TIME_MS && !(hasFocus || mouseOver)) {
                    // Only hide if at least 500ms has passed
                    setShowPreReplacedText(null);
                    rafRef.current = null;
                    return;
                }
                rafRef.current = window.requestAnimationFrame(check);
            }
        };
        check();
    });
    /**
   * Stop comprehensive checking and clean up when pre-replaced text is hidden
   */ (0, $7fPBF.useEffect)(()=>{
        if (showPreReplacedText !== null && replacement && rafRef.current === null) rafRef.current = window.requestAnimationFrame(performComprehensiveCheck);
        return ()=>{
            if (rafRef.current !== null) {
                window.cancelAnimationFrame(rafRef.current);
                rafRef.current = null;
            }
        };
    }, [
        showPreReplacedText,
        replacement
    ]);
    /**
   * Handle mouse enter
   */ const handleMouseEnter = ()=>{
        if (replacement && showPreReplacedText === null) setShowPreReplacedText(Date.now());
    };
    /**
   * Handle focus event
   */ const handleFocus = ()=>{
        stateRef.current.focused = true;
        if (replacement && showPreReplacedText === null) setShowPreReplacedText(Date.now());
    };
    /**
   * Handle blur event
   */ const handleBlur = ()=>{
        stateRef.current.focused = false;
    };
    /**
   * Determine custom style map based on hierarchy level
   */ const thisCustomStyleMap = (0, $fZLKg.stylesToV3)(appSettings.styles, hierarchyContext?.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report ? (0, $98Em8.eTlfType).Shell : (0, $98Em8.eTlfType).Template);
    /**
   * Determine if window view and markdown are allowed
   */ const allowWindowViewMarkdown = (0, $7fPBF.useMemo)(()=>editable && hierarchyContext?.hierarchy?.level !== (0, $7Wd8C.eHierarchyLevel).Report, [
        editable,
        hierarchyContext?.hierarchy?.level
    ]);
    const editorElement = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1iDss.EditorV3), {
        ...rest,
        id: id,
        className: [
            rest.className ?? "",
            replacement && showPreReplacedText === null ? "has-replaced-text" : ""
        ].filter((s)=>s.trim() !== "").join(" "),
        allowMarkdown: allowWindowViewMarkdown,
        allowNewLine: allowNewLine ?? true,
        allowWindowView: allowWindowViewMarkdown,
        customStyleMap: thisCustomStyleMap,
        debounceMilliseconds: -1,
        editable: editable,
        input: showPreReplacedText !== null && preReplacedText ? preReplacedText : value,
        noBorder: true,
        onBlur: handleBlur,
        onFocus: handleFocus,
        resize: false,
        /**
       * Ensure that only line differences are returned/processed
       *
       * @param obj - Object containing `lines` property produced by the editor.
       */ setObject: (obj)=>{
            const ret = {
                lines: obj.lines
            };
            const diff = (0, $1iDss.getObjectDiff)((0, $iQGjt.omitDeep)(preReplacedText ?? value, [
                "isLocked"
            ]), (0, $iQGjt.omitDeep)(ret, [
                "isLocked"
            ]));
            if (diff) setValue(ret);
        },
        spellCheck: false,
        textAlignment: textAlignment
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        ref: wrapperRef,
        className: "editor-wrapper",
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: commentConfig ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
            id: commentConfig.id,
            activeContext: commentConfig.activeContext,
            commentLabel: commentConfig.label,
            disabled: commentConfig.disabled,
            iconPosition: commentConfig.iconPosition,
            noIcon: commentConfig.noIcon,
            children: editorElement
        }) : editorElement
    });
};
$0383e65ac1559779$export$1948bd376c6a2ec2.displayName = "EditorV3Wrapper";

});
parcelRegister("aBGeK", function(module, exports) {

$parcel$export(module.exports, "CommentScope", function () { return $691f9633ef6d96e5$export$e81cb27db2f9c16f; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");
parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $7fPBF = parcelRequire("7fPBF");

var $jLslC = parcelRequire("jLslC");


var $5jw83 = parcelRequire("5jw83");

var $jIznr = parcelRequire("jIznr");
const $691f9633ef6d96e5$export$e81cb27db2f9c16f = ({ id: id, activeContext: activeContext, children: children, className: className = "", commentLabel: commentLabel, disabled: disabled = false, iconPosition: iconPosition = {
    top: "-6px",
    left: "20px"
}, noIcon: noIcon = false, style: style, wrap: wrap = false })=>{
    // Get contexts
    const { comments: comments, commentPanelStatus: commentPanelStatus, setCommentPanelStatus: setCommentPanelStatus, createComment: createComment } = (0, $jIznr.useComments)(activeContext);
    const tlfContext = (0, $cgEO2.useTlfContext)();
    // isTlfNew is set by the TLF loader (tlfLoader vs newTlfLoader), not derived from azsolId here
    const isTlfNew = activeContext === "TlfItem" && tlfContext.isTlfNew;
    // Handle border
    const activeBorder = (0, $7fPBF.useMemo)(()=>commentPanelStatus?.showComments && commentPanelStatus?.activeRelatedTo === id, [
        commentPanelStatus?.activeRelatedTo,
        id,
        commentPanelStatus?.showComments
    ]);
    const targetComment = (0, $7fPBF.useMemo)(()=>comments?.find((c)=>c.relatedTo === id), [
        comments,
        id
    ]);
    /**
   * Create a new comment and open the comment panel for the related target.
   *
   * @param relatedTo - The id of the element the comment relates to.
   */ const addNewComment = (relatedTo)=>{
        /* istanbul ignore else */ if (commentPanelStatus && setCommentPanelStatus) {
            const comment = createComment(undefined, relatedTo);
            /* istanbul ignore else */ if (comment) {
                // Focus if the comments panel is open, otherwise it will be focused by the CommentPanel event
                /* istanbul ignore else */ if (commentPanelStatus.showComments === true) {
                    /**
           * Focus the newly created comment editor element if present.
           */ const doFocus = ()=>{
                        // Get element
                        const el = document.getElementById(`comment-${comment.id}-editable`);
                        // Check if element exists and is focused
                        /* istanbul ignore else */ if (el && document.activeElement !== el) el.focus();
                    };
                    // Run focus in timeout to ensure the comment is visible
                    setTimeout(doFocus, 100);
                }
                setCommentPanelStatus({
                    ...commentPanelStatus,
                    activeRelatedTo: comment.relatedTo ?? "",
                    highlightCommentId: comment.id,
                    showComments: true
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ContextMenuHandler), {
        menuItems: !disabled ? [
            {
                label: isTlfNew ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    "aria-label": commentLabel,
                    "aria-disabled": isTlfNew,
                    className: "contextMenuItemLabel",
                    title: (0, $5jw83.NEW_TLF_COMMENT_TOOLTIP),
                    children: commentLabel
                }) : commentLabel,
                disabled: isTlfNew,
                action: ()=>addNewComment(id)
            }
        ] : [],
        style: wrap ? {
            width: "fit-content",
            height: "fit-content"
        } : {
            width: "100%",
            height: "100%"
        },
        children: [
            !noIcon && !disabled && setCommentPanelStatus && commentPanelStatus && comments && comments.findIndex((c)=>c.relatedTo === id) !== -1 && targetComment && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "position-relative",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jLslC.default), {
                    size: "12",
                    "aria-label": "Show comments",
                    style: {
                        ...iconPosition,
                        position: "absolute",
                        zIndex: 1
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        setCommentPanelStatus({
                            ...commentPanelStatus,
                            activeRelatedTo: targetComment.relatedTo,
                            highlightCommentId: targetComment.id,
                            showComments: true
                        });
                        // Focus on the comment in timeout, ensure it is visible
                        setTimeout(()=>{
                            document.getElementById(`comment-${targetComment.id}-box`)?.focus();
                        }, 250);
                    }
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: `comment-limit-border ${!disabled && activeBorder ? "active" : ""} ${className}`,
                style: style,
                children: children
            })
        ]
    });
};
$691f9633ef6d96e5$export$e81cb27db2f9c16f.displayName = "CommentScope";

});

parcelRegister("fZLKg", function(module, exports) {

$parcel$export(module.exports, "stylesToV3", function () { return $1ad99c20a06b8617$export$f9582f333a7b6c17; });
const $1ad99c20a06b8617$export$f9582f333a7b6c17 = (styles, type)=>{
    const customStyleMap = {};
    const filteredStyles = styles.filter((s)=>s.tlfItemType === type && s.name !== "NoStyle");
    filteredStyles.forEach((s)=>{
        customStyleMap[s.name] = {};
        const thisStyle = customStyleMap[s.name];
        s.styleAttributes.forEach((a)=>{
            thisStyle[a.key] = a.value;
        });
    });
    return customStyleMap;
};

});




parcelRegister("81Xb6", function(module, exports) {

$parcel$export(module.exports, "Footnotes", function () { return $8cab9fbb445e0c78$export$adb5ddffcfa29b3; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $79DyI = parcelRequire("79DyI");
var $hG9sA = parcelRequire("hG9sA");
var $fZCs4 = parcelRequire("fZCs4");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $bStV3 = parcelRequire("bStV3");

var $dDC3L = parcelRequire("dDC3L");

var $k9TPW = parcelRequire("k9TPW");

var $aBGeK = parcelRequire("aBGeK");
const $8cab9fbb445e0c78$export$adb5ddffcfa29b3 = ({ canAddFirstRow: canAddFirstRow = false, noComments: noComments = false, patch: patch = false, tocId: tocId })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: tocState } = (0, $hWsmt.useTocContext)();
    const { state: ars } = (0, $fZCs4.useArsContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tocId ? tocState.tocItems.find((tlf)=>tlf.id === tocId && (0, $k9TPW.isTitlesFootnotesReadDto)(tlf)) : tlfContext.tlfData;
    if (!hierarchyContext?.hierarchy || !tlfData || !tlfContext) return null;
    const patchTlf = tlfContext.patchTlf;
    const externalSingles = (0, $bStV3.getExternalSingles)(undefined, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
        id: "footnotes-comment",
        activeContext: "TlfItem",
        commentLabel: "New footnotes comment",
        disabled: noComments,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG9sA.AsupInternalBlock), {
            id: "footnotes",
            canAddFirstRow: canAddFirstRow,
            lineStyle: {
                ...appSettings.defaultTableStyle
            },
            lines: tlfData.footnotes,
            disabled: tlfContext.readOnly,
            onChange: (ret)=>{
                if (patch) patchTlf(tlfData.id, tlfData.azsolId, "footnotes", ret);
                else tlfContext.dispatch({
                    operation: (0, $dDC3L.UPDATE_TLF),
                    tlfData: {
                        footnotes: ret
                    },
                    calledFrom: "Footnotes:Update"
                });
            },
            externalSingles: externalSingles,
            defaultType: (0, $79DyI.AibLineType).leftOnly,
            editorProps: (0, $lQquc.v3EditorProps),
            noComments: noComments,
            noTrafficLights: true
        })
    });
};
$8cab9fbb445e0c78$export$adb5ddffcfa29b3.displayName = "Footnotes";

});

parcelRegister("bjTvQ", function(module, exports) {

$parcel$export(module.exports, "InteractiveFigure", function () { return $5e20e150f3fc37ec$export$8137e822eaf7457c; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $ladZM = parcelRequire("ladZM");
var $Hzrzh = parcelRequire("Hzrzh");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $7Wd8C = parcelRequire("7Wd8C");

var $45b9x = parcelRequire("45b9x");

var $lNt9u = parcelRequire("lNt9u");
parcelRequire("7fPBF");
const $5e20e150f3fc37ec$export$8137e822eaf7457c = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const body = (0, $lNt9u.isTlfItemReadDto)(tlfContext.tlfData) ? tlfContext.tlfData.body : undefined;
    const clinicalLibrary = hierarchyContext?.hierarchy?.clinicalLibrary;
    const varNames = clinicalLibrary?.clinicalDatasets.flatMap((ds)=>{
        const vars = ds.clinicalVariables.map((v)=>v.name);
        return vars.map((v)=>({
                value: `${ds.name}.${v}`
            }));
    }) ?? [
        {
            value: "No variables available"
        }
    ];
    const figureInput = tlfContext.tlfData?.type === (0, $7Wd8C.eTlfItemType).figure ? (0, $Hzrzh.preProcessFigureInput)(appSettings.figureSettings, body) : undefined;
    return !figureInput || !tlfContext ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ladZM.BeFigure), {
        backEndUrl: appSettings.backEndUrl,
        externalFigureRequest: (0, $45b9x.getFigure),
        figureSettings: appSettings.figureSettings,
        figureInput: figureInput,
        varNames: varNames,
        updateFigureInput: (newBody)=>{
            tlfContext.dispatch({
                operation: (0, $dDC3L.UPDATE_TLF),
                tlfData: {
                    body: newBody
                },
                calledFrom: "BeFigureOptions:updateFigureInput"
            });
        }
    });
};
$5e20e150f3fc37ec$export$8137e822eaf7457c.displayName = "InteractiveFigure";

});
parcelRegister("45b9x", function(module, exports) {

$parcel$export(module.exports, "getFigure", function () { return $2b1c2218074c69fe$export$7821d24ab666bc1c; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $2b1c2218074c69fe$export$7821d24ab666bc1c = async (backEndUrl, params, controller)=>{
    try {
        const url = `${backEndUrl}Figure/generate`;
        const response = await (0, $a04va.default).post(url, params, {
            headers: {
                "Content-Type": "application/json"
            },
            responseType: "blob",
            signal: controller.signal
        });
        // Convert blob to base64 data URL
        const blob = new Blob([
            response.data
        ], {
            type: "image/png"
        });
        const reader = new FileReader();
        return new Promise((resolve)=>{
            reader.onload = ()=>{
                resolve({
                    success: true,
                    data: reader.result
                });
            };
            reader.onerror = ()=>{
                resolve({
                    success: false,
                    errorText: "Failed to process image data"
                });
            };
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Generate BE figure failed", error);
    }
};

});


parcelRegister("gtWPA", function(module, exports) {

$parcel$export(module.exports, "NotesTable", function () { return $a946f4a655a19de6$export$86076345fd01ba79; });

var $bbzbN = parcelRequire("bbzbN");

var $drJNc = parcelRequire("drJNc");

var $1iDss = parcelRequire("1iDss");

var $fZLKg = parcelRequire("fZLKg");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $98Em8 = parcelRequire("98Em8");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");

/**
 * Inline editor wrapper used by the notes table to render V3 editor content.
 *
 * @param props - Table cell render props containing `rowData` and indexing info.
 */ const $a946f4a655a19de6$var$EditorV3SimpleTable = (props)=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1iDss.EditorV3), {
        id: `notes-cell-${props.rowNumber}-${props.columnNumber}`,
        input: props.rowData.notesContent,
        noBorder: true,
        customStyleMap: (0, $fZLKg.stylesToV3)(appSettings.styles, (0, $98Em8.eTlfType).Template),
        setObject: // istanbul ignore next
        ()=>{},
        editable: false
    });
};
$a946f4a655a19de6$var$EditorV3SimpleTable.displayName = "EditorV3SimpleTable";
const $a946f4a655a19de6$var$headers = [
    {
        name: "optionType",
        label: "Option Type",
        width: "180px"
    },
    {
        name: "notesText",
        label: "Notes Text",
        width: "600px",
        renderFn: $a946f4a655a19de6$var$EditorV3SimpleTable
    },
    {
        name: "notesAt",
        label: "Notes at",
        width: "300px",
        /**
     * Renders the 'Notes at' cell for the notes table, showing a location string.
     *
     * @param props - Table cell render props containing `rowData`.
     */ renderFn: (props)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                style: {
                    textAlign: "center",
                    width: "100%"
                },
                children: props.rowData.notesAt
            })
    }
];
const $a946f4a655a19de6$export$86076345fd01ba79 = ()=>{
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const notes = (0, $7fPBF.useMemo)(()=>{
        const currentNotes = [];
        if (tlfContext && tlfContext.tlfData && "body" in tlfContext.tlfData && tlfContext.tlfData.type !== "V1Figure") {
            const tableData = tlfContext.tlfData.body;
            currentNotes.push({
                optionType: "Table",
                notesContent: tableData.comments,
                notesAt: "Table"
            });
            /* istanbul ignore else */ if (tableData.headerData) {
                currentNotes.push({
                    optionType: "Header",
                    notesContent: tableData.headerData.comments,
                    notesAt: "Header"
                });
                tableData.headerData.rows.forEach((row, ri)=>{
                    row.cells.forEach((cell, ci)=>{
                        /* istanbul ignore else */ if (cell.comments) currentNotes.push({
                            optionType: "Cell",
                            notesContent: cell.comments,
                            notesAt: `Header, Row-${ri + 1}, Cell-${ci + 1}`
                        });
                    });
                });
            }
            tableData.bodyData?.forEach((rowGroup, rgi)=>{
                currentNotes.push({
                    optionType: "RowGroup",
                    notesContent: rowGroup.comments,
                    notesAt: `Body, RowGroup-${rgi + 1}`
                });
                rowGroup.rows.forEach((row, ri)=>{
                    row.cells.forEach((cell, ci)=>{
                        /* istanbul ignore else */ if (cell.comments) currentNotes.push({
                            optionType: "Cell",
                            notesContent: cell.comments,
                            notesAt: `Body, RowGroup-${rgi + 1}, Row-${ri + 1}, Cell-${ci + 1}`
                        });
                    });
                });
            });
        }
        const transposed = currentNotes.map((a)=>({
                ...a,
                notesContent: new (0, $1iDss.EditorV3Content)(a.notesContent)
            }));
        const filtered = transposed.filter((notes)=>notes.notesContent.text.trim() !== "");
        return filtered;
    }, [
        tlfContext
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
            className: "mb-4 annotations-table-holder",
            children: !notes || notes.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                children: "No legacy annotations or notes."
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $drJNc.SimpleTable), {
                id: "notes-table",
                fields: $a946f4a655a19de6$var$headers,
                keyField: "notesAt",
                data: notes,
                headerLabel: "Legacy annotations and notes",
                showPager: false,
                tableClassName: "notes-table"
            })
        })
    });
};
$a946f4a655a19de6$export$86076345fd01ba79.displayName = "NotesTable";

});

parcelRegister("c0CTk", function(module, exports) {

$parcel$export(module.exports, "PageBy", function () { return $35891919ea851428$export$8311119bbe60fe92; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $79DyI = parcelRequire("79DyI");
var $hG9sA = parcelRequire("hG9sA");
var $fZCs4 = parcelRequire("fZCs4");

var $2ocuT = parcelRequire("2ocuT");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $bStV3 = parcelRequire("bStV3");

var $dDC3L = parcelRequire("dDC3L");

var $lNt9u = parcelRequire("lNt9u");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");
const $35891919ea851428$export$8311119bbe60fe92 = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: ars } = (0, $fZCs4.useArsContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = (0, $lNt9u.isTlfItemReadDto)(tlfContext.tlfData) ? tlfContext.tlfData : undefined;
    const pageByData = tlfData && !Array.isArray(tlfData.pageBy) ? tlfData.pageBy : undefined;
    const externalSingles = (0, $bStV3.getExternalSingles)(undefined, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData?.releaseStatus, tlfData?.domain, tlfData?.singles, hierarchyContext?.hierarchy?.level, hierarchyContext?.hierarchy?.singles, hierarchyContext?.hierarchy?.domainReplacements, hierarchyContext?.parentTemplates.singles, hierarchyContext?.parentTemplates.domainReplacements);
    const pageBy = (0, $7fPBF.useMemo)(()=>{
        return [
            {
                aifid: "page-by",
                left: pageByData?.content ?? (0, $1iDss.stringToV3)(""),
                lineType: (0, $79DyI.AibLineType).leftOnly,
                addBelow: false,
                canChangeType: false,
                canEdit: true,
                canRemove: false,
                canMove: false,
                center: null,
                right: null,
                coreTrafficLight: "BlankNotEvaluated"
            }
        ];
    }, [
        pageByData
    ]);
    /**
   * Handle updates to the Page By block lines, sending changes to TLF context as an IEditorV3.
   *
   * @param ret - Updated array of AibBlockLine items.
   */ const setPageBy = (ret)=>{
        // Update TLF context if content has changed
        /* istanbul ignore else */ if (pageByData && !(0, $gSkQi.isEqual)(ret[0].left, pageByData.content)) tlfContext.dispatch({
            operation: (0, $dDC3L.UPDATE_TLF),
            tlfData: {
                pageBy: {
                    content: ret[0].left ?? // istanbul ignore next
                    (0, $1iDss.stringToV3)(""),
                    annotation: pageByData.annotation
                }
            },
            calledFrom: "PageBy:setLines"
        });
    };
    return !tlfContext || !tlfData || !pageByData ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ocuT.AnnotationButton), {
                        buttonId: "pageby-annotation",
                        annotationType: "PageBy",
                        existingAnnotation: pageByData.annotation,
                        hidden: tlfContext.tlfViewMode.value !== "ANNOTATIONS",
                        showPreview: tlfContext.tlfViewMode.value === "ANNOTATIONS"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG9sA.AsupInternalBlock), {
                        id: "pageby",
                        lineStyle: appSettings.defaultTableStyle,
                        lines: pageBy,
                        disabled: tlfContext.readOnly,
                        onChange: setPageBy,
                        externalSingles: externalSingles,
                        minLines: 1,
                        maxLines: 1,
                        defaultType: (0, $79DyI.AibLineType).leftOnly,
                        editorProps: (0, $lQquc.v3EditorProps),
                        noTrafficLights: true
                    })
                ]
            })
        })
    });
};
$35891919ea851428$export$8311119bbe60fe92.displayName = "PageBy";

});

parcelRegister("kU4Z3", function(module, exports) {

$parcel$export(module.exports, "ProgrammerNotes", function () { return $bc7b28c88dae4a28$export$f771ac3bae608de8; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");

var $fZLKg = parcelRequire("fZLKg");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $98Em8 = parcelRequire("98Em8");

var $gSkQi = parcelRequire("gSkQi");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");
const $bc7b28c88dae4a28$export$f771ac3bae608de8 = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext && tlfContext.tlfData && "programmerNotes" in tlfContext.tlfData ? tlfContext.tlfData : null;
    return !tlfContext || !tlfData ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h4", {
                        children: "Programmer notes"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "notes-box",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1iDss.EditorV3), {
                            id: "programmernotes",
                            allowNewLine: true,
                            customStyleMap: (0, $fZLKg.stylesToV3)(appSettings.styles, (0, $98Em8.eTlfType).Template),
                            debounceMilliseconds: -1,
                            editable: !tlfContext.readOnly,
                            input: tlfData.programmerNotes,
                            setObject: (ret)=>{
                                /* istanbul ignore else */ if (!(0, $gSkQi.isEqual)(ret, tlfData.programmerNotes)) tlfContext.dispatch({
                                    operation: (0, $dDC3L.UPDATE_TLF),
                                    tlfData: {
                                        programmerNotes: ret ?? // istanbul ignore next
                                        tlfData.programmerNotes
                                    },
                                    calledFrom: "ProgrammerNotes:Update"
                                });
                            },
                            style: {
                                ...appSettings.defaultTableStyle,
                                minHeight: "120px",
                                height: "120px",
                                border: "none"
                            }
                        })
                    })
                ]
            })
        })
    });
};
$bc7b28c88dae4a28$export$f771ac3bae608de8.displayName = "ProgrammerNotes";

});

parcelRegister("1oDpR", function(module, exports) {

$parcel$export(module.exports, "StandardsNotes", function () { return $4887e9ba35bfe3cd$export$6c0b870ee57f0a35; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");

var $fZLKg = parcelRequire("fZLKg");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $7Wd8C = parcelRequire("7Wd8C");

var $98Em8 = parcelRequire("98Em8");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");
const $4887e9ba35bfe3cd$export$6c0b870ee57f0a35 = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext && tlfContext.tlfData && "standardsNotes" in tlfContext.tlfData ? tlfContext.tlfData : null;
    const standardNotes = tlfContext.tlfData?.standardsNotes ?? // istanbul ignore next
    (0, $1iDss.stringToV3)("");
    return !hierarchyContext || !hierarchyContext.hierarchy || !tlfContext || !tlfData ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h4", {
                        children: "Standards notes"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "notes-box",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1iDss.EditorV3), {
                            id: "standardsnotes",
                            allowNewLine: true,
                            customStyleMap: (0, $fZLKg.stylesToV3)(appSettings.styles, (0, $98Em8.eTlfType).Template),
                            debounceMilliseconds: -1,
                            editable: !tlfContext.readOnly && [
                                (0, $7Wd8C.eHierarchyLevel).Corporate,
                                (0, $7Wd8C.eHierarchyLevel).TA,
                                (0, $7Wd8C.eHierarchyLevel).Project
                            ].includes(hierarchyContext.hierarchy.level),
                            input: standardNotes,
                            setObject: (ret)=>{
                                tlfContext.dispatch({
                                    operation: (0, $dDC3L.UPDATE_TLF),
                                    tlfData: {
                                        standardsNotes: ret
                                    },
                                    calledFrom: "StandardsNotes:setValue"
                                });
                            },
                            style: {
                                ...appSettings.defaultTableStyle,
                                minHeight: "120px",
                                height: "120px",
                                border: "none",
                                backgroundColor: !tlfContext.readOnly && [
                                    (0, $7Wd8C.eHierarchyLevel).Corporate,
                                    (0, $7Wd8C.eHierarchyLevel).TA,
                                    (0, $7Wd8C.eHierarchyLevel).Project
                                ].includes(hierarchyContext?.hierarchy?.level) ? undefined : "rgba(211, 211, 211, 0.16)"
                            }
                        })
                    })
                ]
            })
        })
    });
};
$4887e9ba35bfe3cd$export$6c0b870ee57f0a35.displayName = "StandardsNotes";

});

parcelRegister("5SKwd", function(module, exports) {

$parcel$export(module.exports, "TableListing", function () { return $2f003eb999722486$export$92027266d92ba953; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $c3Q0Y = parcelRequire("c3Q0Y");
var $fZCs4 = parcelRequire("fZCs4");

var $aBGeK = parcelRequire("aBGeK");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $fqHWo = parcelRequire("fqHWo");

var $bStV3 = parcelRequire("bStV3");

var $c8aRJ = parcelRequire("c8aRJ");

var $dDC3L = parcelRequire("dDC3L");

var $7Wd8C = parcelRequire("7Wd8C");
const $2f003eb999722486$export$92027266d92ba953 = ()=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: ars } = (0, $fZCs4.useArsContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const externalSingles = tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $bStV3.getExternalSingles)(tlfData.tocNumber, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements) : [];
    const externalLsts = tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $fqHWo.getExternalLists)(tlfData.primaryHierarchyId, tlfData.primaryHierarchyLevel, tlfData.releaseStatus, hierarchyContext.hierarchy.lists, hierarchyContext.parentTemplates.lists) : [];
    const groupTemplates = (0, $c8aRJ.getGroupTemplates)(hierarchyContext?.hierarchy?.rowGroups, hierarchyContext?.parentTemplates.rowGroups);
    return !hierarchyContext || !tlfData ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
        id: "tlf-table-comment",
        activeContext: "TlfItem",
        wrap: true,
        iconPosition: {
            top: "16px",
            left: "38px"
        },
        commentLabel: "New table comment",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c3Q0Y.AsupInternalTable), {
            id: "tlf-table",
            tableData: tlfData.body,
            isEditable: !tlfContext.readOnly,
            onChange: (ret)=>tlfContext.dispatch({
                    operation: (0, $dDC3L.UPDATE_TLF),
                    tlfData: {
                        body: ret
                    },
                    calledFrom: "TableListing:setTableData"
                }),
            noTrafficLights: !tlfContext.showTrafficLights || tlfData.primaryHierarchyLevel !== (0, $7Wd8C.eHierarchyLevel).Report || tlfData.coreTrafficLightSwitch === "DoNotCalculate",
            style: {
                ...appSettings.defaultTableStyle,
                margin: "1rem"
            },
            showCellBorders: true,
            externalLists: externalLsts,
            externalSingles: externalSingles,
            groupTemplates: groupTemplates,
            colWidthMod: appSettings.colWidthMod,
            defaultCellWidth: appSettings.defaultColumnWidth,
            editorProps: (0, $lQquc.v3EditorProps),
            tlfViewMode: tlfContext.tlfViewMode
        })
    });
};
$2f003eb999722486$export$92027266d92ba953.displayName = "TableListing";

});
parcelRegister("c8aRJ", function(module, exports) {

$parcel$export(module.exports, "getGroupTemplates", function () { return $9424ce70c508bd96$export$44460f30febb3d04; });
const $9424ce70c508bd96$export$44460f30febb3d04 = (rowGroups = [], parentRowGroups = [])=>{
    return [
        ...parentRowGroups.filter((group)=>!rowGroups.some((g)=>g.name === group.name)),
        ...rowGroups
    ];
};

});


parcelRegister("5uyDP", function(module, exports) {

$parcel$export(module.exports, "Titles", function () { return $5d65e769f9df2ed4$export$67b504e93d0b2f2b; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $79DyI = parcelRequire("79DyI");
var $hG9sA = parcelRequire("hG9sA");
var $fZCs4 = parcelRequire("fZCs4");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $bStV3 = parcelRequire("bStV3");

var $dDC3L = parcelRequire("dDC3L");

var $7Wd8C = parcelRequire("7Wd8C");

var $k9TPW = parcelRequire("k9TPW");

var $aBGeK = parcelRequire("aBGeK");
const $5d65e769f9df2ed4$export$67b504e93d0b2f2b = ({ firstLine: firstLine = 1, lastLine: lastLine = 10, noComments: noComments = false, patch: patch = false, tocId: tocId })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const { state: tocState } = (0, $hWsmt.useTocContext)();
    const { state: ars } = (0, $fZCs4.useArsContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tocId ? tocState.tocItems.find((tlf)=>tlf.id === tocId && (0, $k9TPW.isTitlesFootnotesReadDto)(tlf)) : tlfContext.tlfData;
    if (!hierarchyContext?.hierarchy || !tlfData || !tlfContext) return null;
    const patchTlf = tlfContext.patchTlf;
    const externalSingles = (0, $bStV3.getExternalSingles)(tlfData.tocNumber, ars.analysisSets[tlfData.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
        id: "titles-comment",
        activeContext: "TlfItem",
        commentLabel: "New titles comment",
        disabled: noComments,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hG9sA.AsupInternalBlock), {
            id: "titles",
            lineStyle: appSettings.defaultTableStyle,
            lines: tlfData.titles.slice(firstLine - 1, lastLine),
            disabled: tlfContext.readOnly,
            onChange: (ret)=>{
                const newTitles = [
                    ...tlfData.titles.slice(0, firstLine - 1),
                    ...ret,
                    ...tlfData.titles.slice(lastLine)
                ];
                if (patch) patchTlf(tlfData.id, tlfData.azsolId, "titles", newTitles);
                else tlfContext.dispatch({
                    operation: (0, $dDC3L.UPDATE_TLF),
                    tlfData: {
                        titles: newTitles
                    },
                    calledFrom: "Titles:Update"
                });
            },
            externalSingles: externalSingles,
            minLines: 5 - firstLine,
            defaultType: (0, $79DyI.AibLineType).centerOnly,
            editorProps: (0, $lQquc.v3EditorProps),
            noComments: noComments,
            noTrafficLights: !tlfContext.showTrafficLights || tlfData.primaryHierarchyLevel !== (0, $7Wd8C.eHierarchyLevel).Report || tlfData.coreTrafficLightSwitch === "DoNotCalculate",
            changedBlocks: tlfData.changedTitles
        })
    });
};
$5d65e769f9df2ed4$export$67b504e93d0b2f2b.displayName = "Titles";

});

parcelRegister("jHuGz", function(module, exports) {

$parcel$export(module.exports, "TlfArsListing", function () { return $c0ee0dbce0674649$export$ac30f6468f253a3d; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $lremW = parcelRequire("lremW");
var $awEAB = parcelRequire("awEAB");
var $30Ra3 = parcelRequire("30Ra3");
var $ihppY = parcelRequire("ihppY");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $aBGeK = parcelRequire("aBGeK");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $lgsGt = parcelRequire("lgsGt");

var $lNt9u = parcelRequire("lNt9u");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");

var $fzB3U = parcelRequire("fzB3U");

var $410tS = parcelRequire("410tS");
const $c0ee0dbce0674649$export$ac30f6468f253a3d = ()=>{
    // Contexts
    const appSettings = (0, $hWsmt.useAppSettings)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const arsContext = (0, $fZCs4.useArsContext)();
    const body = tlfContext && (0, $lNt9u.isTlfItemReadDto)(tlfData) && (0, $awEAB.isArsListingBody)(tlfData.body, (0, $1iDss.isIEditorV3)) ? tlfData.body : null;
    const disabled = tlfContext.readOnly;
    // Component state items
    const [calculatedTableRows, setCalculatedTableRows] = (0, $7fPBF.useState)([]);
    const [requestingCalculation, setRequestingCalculation] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [errorText, setErrorText] = (0, $7fPBF.useState)(null);
    const getCalculatedRows = (0, $7fPBF.useEffectEvent)(async (body)=>{
        const analysisSet = tlfData?.analysisSetId ? arsContext.state.analysisSets[tlfData.analysisSetId] : undefined;
        const dataSubset = body.dataSubsetId && Object.keys(arsContext.state.dataSubsets).includes(body.dataSubsetId) ? arsContext.state.dataSubsets[body.dataSubsetId] : undefined;
        const arsListingCalculationDto = {
            arsListingBody: body,
            analysisSet: analysisSet,
            dataSubset: dataSubset
        };
        const request = await (0, $30Ra3.loadWrapper)((0, $lgsGt.getArsListingCalculation), arsListingCalculationDto, requestingCalculation, setRequestingCalculation, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) {
            arsContext.dispatch({
                operation: (0, $cIJV5.SET_VARIABLES_IN_USE),
                variablesInUse: request.data.variables
            });
            (0, $7fPBF.startTransition)(()=>{
                setCalculatedTableRows(request.data.rows);
                setErrorText(null);
            });
        } else if (request?.success === false) (0, $7fPBF.startTransition)(()=>setErrorText(request.errorText));
    });
    (0, $7fPBF.useEffect)(()=>{
        if (body) getCalculatedRows(body);
    }, [
        body
    ]);
    return !tlfContext || !body ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $alDlg.default), {
        fluid: true,
        style: {
            minHeight: "400px"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                        className: "d-flex align-items-start flex-row gap-1 py-3",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $410tS.ArsSetPicker), {
                                type: "analysisSet",
                                itemId: tlfData?.analysisSetId ?? "",
                                onChange: (newId)=>{
                                    tlfContext.dispatch({
                                        operation: (0, $dDC3L.UPDATE_TLF),
                                        tlfData: {
                                            analysisSetId: newId
                                        },
                                        calledFrom: "ArsListing onChange:AnalysisSet"
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $410tS.ArsSetPicker), {
                                type: "dataSubset",
                                itemId: body.dataSubsetId ?? "",
                                onChange: (newId)=>{
                                    tlfContext.dispatch({
                                        operation: (0, $dDC3L.UPDATE_TLF),
                                        tlfData: {
                                            body: {
                                                ...body,
                                                dataSubsetId: newId
                                            }
                                        },
                                        calledFrom: "ArsListing onChange:DataSubset"
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ihppY.MultipleDatasetCheck), {})
                        ]
                    })
                }),
                errorText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                        className: "text-danger m-3",
                        children: errorText
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                        className: "d-flex position-relative",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fzB3U.ArsItemRequestingSpinner), {
                                requestingCalculation: requestingCalculation,
                                requestingLabel: "Recalculating"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "m-auto px-3",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
                                    id: "ars-listing-comment",
                                    activeContext: "TlfItem",
                                    wrap: true,
                                    iconPosition: {
                                        top: "-16px",
                                        left: "-16px"
                                    },
                                    commentLabel: "New table comment",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lremW.ArsListing), {
                                        arsListingBody: body,
                                        calculatedTableRows: calculatedTableRows,
                                        disabled: disabled,
                                        editorProps: (0, $lQquc.v3EditorProps),
                                        justification: "center",
                                        sidebarStyle: {
                                            paddingBottom: "40px"
                                        },
                                        style: appSettings.defaultTableStyle,
                                        tlfViewMode: tlfContext.tlfViewMode,
                                        updateArsListingBody: (newBody)=>tlfContext.dispatch({
                                                operation: (0, $dDC3L.UPDATE_TLF),
                                                tlfData: {
                                                    body: newBody
                                                },
                                                calledFrom: "TlfArsListing onChange"
                                            })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
$c0ee0dbce0674649$export$ac30f6468f253a3d.displayName = "TlfArsListing";

});
parcelRegister("lgsGt", function(module, exports) {

$parcel$export(module.exports, "getArsListingCalculation", function () { return $15a60ce6ccb7af06$export$42c68949b0874b17; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $15a60ce6ccb7af06$export$42c68949b0874b17 = async (backEndUrl, params, controller)=>{
    try {
        const url = `${backEndUrl}Ars/ArsListingCalculation`;
        const response = await (0, $a04va.default).post(url, params, {
            signal: controller.signal
        });
        return {
            success: true,
            data: {
                rows: response.data.rows,
                variables: new Set(response.data.variables)
            }
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Get ARS listing calculation failed - please refresh the page and try again", error);
    }
};

});

parcelRegister("fzB3U", function(module, exports) {

$parcel$export(module.exports, "ArsItemRequestingSpinner", function () { return $3c491cd049d679fa$export$e9ee708a0312426; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $cqVqv = parcelRequire("cqVqv");

var $hWsmt = parcelRequire("hWsmt");

var $4WD1L = parcelRequire("4WD1L");
const $3c491cd049d679fa$export$e9ee708a0312426 = ({ requestingCalculation: requestingCalculation, requestingLabel: requestingLabel })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    return (requestingCalculation.requesting || hierarchyContext?.isClinicalLibraryLoading) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4WD1L.default), {
        variant: "primary",
        size: "sm",
        animation: "border",
        role: "status",
        "aria-label": `${(0, $cqVqv.classMerge)([
            requestingCalculation.requesting ? requestingLabel : "",
            hierarchyContext?.isClinicalLibraryLoading ? "Loading clinical library" : ""
        ])}`,
        style: {
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: 1000
        }
    });
};
$3c491cd049d679fa$export$e9ee708a0312426.displayName = "ArsItemRequestingSpinner";

});

parcelRegister("410tS", function(module, exports) {

$parcel$export(module.exports, "ArsSetPicker", function () { return $0369160427b7bd09$export$522ae4fc4efd905d; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $cqVqv = parcelRequire("cqVqv");
var $awEAB = parcelRequire("awEAB");
var $GtyWr = parcelRequire("GtyWr");
var $fZCs4 = parcelRequire("fZCs4");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $7Wd8C = parcelRequire("7Wd8C");

var $7fPBF = parcelRequire("7fPBF");

var $cvdxK = parcelRequire("cvdxK");
var $6dv4K = parcelRequire("6dv4K");

var $6ls2G = parcelRequire("6ls2G");

var $grQqK = parcelRequire("grQqK");

var $ajZ7G = parcelRequire("ajZ7G");
const $0369160427b7bd09$export$522ae4fc4efd905d = ({ type: type, itemId: itemId, onChange: onChange, ...rest })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const ars = (0, $fZCs4.useArsContext)();
    const [showWindow, setShowWindow] = (0, $7fPBF.useState)(false);
    const canEdit = hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy) ?? false;
    const body = (0, $awEAB.isArsListingBody)(tlfContext.tlfData?.body, (0, $1iDss.isIEditorV3)) || (0, $GtyWr.isArsTableBody)(tlfContext.tlfData?.body, (0, $1iDss.isIEditorV3)) ? tlfContext.tlfData.body : null;
    const hasSelection = type === "analysisMethod" ? ars.state.analysisMethods[itemId] !== undefined : type === "analysisSet" ? ars.state.analysisSets[itemId] !== undefined : type === "dataSubset" ? ars.state.dataSubsets[itemId] !== undefined : ars.state.groupingFactors[itemId] !== undefined;
    const selectLabel = (0, $ajZ7G.ARS_SET_TYPES)[type].selectLabel;
    const glyphText = (0, $ajZ7G.ARS_SET_TYPES)[type].glyphText;
    return !hierarchyContext?.hierarchy || !body ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                ...rest,
                id: itemId,
                title: selectLabel,
                type: "button",
                "aria-label": selectLabel,
                onClick: ()=>setShowWindow((prev)=>!prev),
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).annotationBtn,
                    !hasSelection && [
                        "analysisMethod",
                        "analysisSet"
                    ].includes(type) ? (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).badEmpty : !hasSelection ? (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).empty : undefined,
                    "position-relative"
                ]),
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).glyph,
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $cqVqv.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).icon,
                            (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).wide
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).letter,
                                children: glyphText
                            }),
                            canEdit && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($6ls2G))).hoverIcon,
                                children: hasSelection ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cvdxK.default), {
                                    size: 12
                                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6dv4K.default), {
                                    size: 12
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $grQqK.ArsSetWindow), {
                itemId: itemId,
                type: type,
                visible: showWindow,
                onClose: (newItemId)=>{
                    setShowWindow(false);
                    // Undefined returned on cancel.
                    // Empty string returned on delete.
                    if (newItemId !== undefined) onChange(newItemId !== "" ? newItemId : undefined);
                }
            })
        ]
    });
};
$0369160427b7bd09$export$522ae4fc4efd905d.displayName = "ArsSetPicker";

});
parcelRegister("cvdxK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a2e2bb997e3ef2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $91a2e2bb997e3ef2$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $91a2e2bb997e3ef2$var$_extends() {
    return $91a2e2bb997e3ef2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $91a2e2bb997e3ef2$var$_extends.apply(null, arguments);
}
function $91a2e2bb997e3ef2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $91a2e2bb997e3ef2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $91a2e2bb997e3ef2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $91a2e2bb997e3ef2$var$PencilSquare = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $91a2e2bb997e3ef2$var$_objectWithoutProperties(_ref, $91a2e2bb997e3ef2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $91a2e2bb997e3ef2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pencil-square',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
    }));
});
$91a2e2bb997e3ef2$var$PencilSquare.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $91a2e2bb997e3ef2$export$2e2bcd8739ae039 = $91a2e2bb997e3ef2$var$PencilSquare;

});

parcelRegister("6ls2G", function(module, exports) {

$parcel$export(module.exports, "annotationBtn", function () { return $49ea74d8dfcd7974$export$2c1bbb5dc6e1a1c3; }, function (v) { return $49ea74d8dfcd7974$export$2c1bbb5dc6e1a1c3 = v; });
$parcel$export(module.exports, "badEmpty", function () { return $49ea74d8dfcd7974$export$e73814cfefd51fbe; }, function (v) { return $49ea74d8dfcd7974$export$e73814cfefd51fbe = v; });
$parcel$export(module.exports, "empty", function () { return $49ea74d8dfcd7974$export$6e22c362a0406a2c; }, function (v) { return $49ea74d8dfcd7974$export$6e22c362a0406a2c = v; });
$parcel$export(module.exports, "glyph", function () { return $49ea74d8dfcd7974$export$f1f5ddeb20d14f; }, function (v) { return $49ea74d8dfcd7974$export$f1f5ddeb20d14f = v; });
$parcel$export(module.exports, "hoverIcon", function () { return $49ea74d8dfcd7974$export$5a7c758e1af5ce6; }, function (v) { return $49ea74d8dfcd7974$export$5a7c758e1af5ce6 = v; });
$parcel$export(module.exports, "icon", function () { return $49ea74d8dfcd7974$export$1ca1ec8b29a4ce27; }, function (v) { return $49ea74d8dfcd7974$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "letter", function () { return $49ea74d8dfcd7974$export$30780d0b6b610af8; }, function (v) { return $49ea74d8dfcd7974$export$30780d0b6b610af8 = v; });
$parcel$export(module.exports, "wide", function () { return $49ea74d8dfcd7974$export$163ab120a2115199; }, function (v) { return $49ea74d8dfcd7974$export$163ab120a2115199 = v; });
var $49ea74d8dfcd7974$export$2c1bbb5dc6e1a1c3;
var $49ea74d8dfcd7974$export$e73814cfefd51fbe;
var $49ea74d8dfcd7974$export$6e22c362a0406a2c;
var $49ea74d8dfcd7974$export$f1f5ddeb20d14f;
var $49ea74d8dfcd7974$export$5a7c758e1af5ce6;
var $49ea74d8dfcd7974$export$1ca1ec8b29a4ce27;
var $49ea74d8dfcd7974$export$30780d0b6b610af8;
var $49ea74d8dfcd7974$export$163ab120a2115199;
$49ea74d8dfcd7974$export$2c1bbb5dc6e1a1c3 = `mos-AnnotationButton-module-S3bPeq-annotationBtn`;
$49ea74d8dfcd7974$export$e73814cfefd51fbe = `mos-AnnotationButton-module-S3bPeq-badEmpty`;
$49ea74d8dfcd7974$export$6e22c362a0406a2c = `mos-AnnotationButton-module-S3bPeq-empty`;
$49ea74d8dfcd7974$export$f1f5ddeb20d14f = `mos-AnnotationButton-module-S3bPeq-glyph`;
$49ea74d8dfcd7974$export$5a7c758e1af5ce6 = `mos-AnnotationButton-module-S3bPeq-hoverIcon`;
$49ea74d8dfcd7974$export$1ca1ec8b29a4ce27 = `mos-AnnotationButton-module-S3bPeq-icon`;
$49ea74d8dfcd7974$export$30780d0b6b610af8 = `mos-AnnotationButton-module-S3bPeq-letter`;
$49ea74d8dfcd7974$export$163ab120a2115199 = `mos-AnnotationButton-module-S3bPeq-wide`;

});

parcelRegister("grQqK", function(module, exports) {

$parcel$export(module.exports, "ArsSetWindow", function () { return $726a344535e2f9ed$export$72bfa98672dbebf; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");
parcelRequire("P0x5y");
var $7uNID = parcelRequire("7uNID");
var $9ijW6 = parcelRequire("9ijW6");
var $8HzIe = parcelRequire("8HzIe");
var $isQD0 = parcelRequire("isQD0");
var $3CgTd = parcelRequire("3CgTd");
var $b1QeS = parcelRequire("b1QeS");
var $bRDEW = parcelRequire("bRDEW");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $7Wd8C = parcelRequire("7Wd8C");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");

var $6VdBt = parcelRequire("6VdBt");
const $726a344535e2f9ed$export$72bfa98672dbebf = ({ type: type, itemId: itemId, onClose: onClose, visible: visible })=>{
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const canEdit = hierarchyContext?.accessRights.includes((0, $7Wd8C.eAccessRights).WriteToTlfItemsInHierarchy) ?? false;
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const { state: state, dispatch: dispatch } = (0, $fZCs4.useArsContext)();
    const [selectedId, setSelectedId] = (0, $7fPBF.useState)(itemId);
    const [showAreYouSure, setShowAreYouSure] = (0, $7fPBF.useState)(false);
    // This makes sure all changes trigger a rerender
    const hasUpdates = tlfContext.delayedHierarchyUpdates || state.changed;
    // Mount/unmount listener for Escape key to trigger discard confirmation when there are pending changes
    (0, $7fPBF.useEffect)(()=>{
        /**
     * Handles Escape-key presses while there are pending changes.
     *
     * @param event - Keyboard event used to detect Escape.
     */ const handleKeyDown = (event)=>{
            /* istanbul ignore else - Unreachable when event.key is not Escape or when visible/hasPendingChanges is false */ if (event.key === "Escape" && visible && hasUpdates) {
                event.preventDefault();
                setShowAreYouSure(true);
            }
        };
        if (visible && hasUpdates) {
            document.addEventListener("keydown", handleKeyDown);
            return ()=>document.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        hasUpdates,
        visible
    ]);
    if (!hierarchyContext || !tlfContext) return null;
    const selectedEntity = (()=>{
        switch(type){
            case "analysisMethod":
                return state.analysisMethods[selectedId];
            case "analysisSet":
                return state.analysisSets[selectedId];
            case "dataSubset":
                return state.dataSubsets[selectedId];
            case "groupingFactor":
                return state.groupingFactors[selectedId];
        }
    })();
    /**
   * Creates a new entity for the active type in hierarchy context.
   */ const handleCreateNew = ()=>{
        let newId;
        switch(type){
            case "analysisSet":
                {
                    const newLength = Object.values(state.analysisSets).length + 1;
                    const newSet = (0, $3CgTd.createNewAnalysisSet)(`AnalysisSet_${newLength}`);
                    newId = newSet.id;
                    dispatch({
                        operation: (0, $cIJV5.PATCH_ARS_STATE),
                        updates: [
                            {
                                dataPath: `/analysisSets/${newId}`,
                                value: newSet
                            }
                        ]
                    });
                    setSelectedId(newId);
                    break;
                }
            case "dataSubset":
                {
                    const newLength = Object.values(state.dataSubsets).length + 1;
                    const newSubset = (0, $3CgTd.createNewDataSubset)(`DataSubset_${newLength}`);
                    newId = newSubset.id;
                    dispatch({
                        operation: (0, $cIJV5.PATCH_ARS_STATE),
                        updates: [
                            {
                                dataPath: `/dataSubsets/${newId}`,
                                value: newSubset
                            }
                        ]
                    });
                    setSelectedId(newId);
                    break;
                }
            case "groupingFactor":
                {
                    const newLength = Object.values(state.groupingFactors).length + 1;
                    const newGroupingFactor = {
                        ...(0, $3CgTd.createNewGroupingFactor)(`GroupingFactor_${newLength}`)
                    };
                    newId = newGroupingFactor.id;
                    dispatch({
                        operation: (0, $cIJV5.PATCH_ARS_STATE),
                        updates: [
                            {
                                dataPath: `/groupingFactors/${newId}`,
                                value: newGroupingFactor
                            }
                        ]
                    });
                    setSelectedId(newId);
                    break;
                }
            // istanbul ignore next
            default:
                break;
        }
    };
    /**
   * Creates a copy of the selected entity for the active type in hierarchy context.
   */ const handleCopyAndEdit = ()=>{
        /* istanbul ignore else -- copy actions are only reachable when a selectable entity exists with edit access */ if (selectedEntity) {
            const copyId = crypto.randomUUID();
            switch(type){
                case "analysisSet":
                    {
                        const copy = {
                            ...selectedEntity,
                            id: copyId,
                            name: `Copy of ${selectedEntity.name}`,
                            order: Object.values(state.analysisSets).length + 1
                        };
                        dispatch({
                            operation: (0, $cIJV5.PATCH_ARS_STATE),
                            updates: [
                                {
                                    dataPath: `/analysisSets/${copyId}`,
                                    value: copy
                                }
                            ]
                        });
                        setSelectedId(copyId);
                        break;
                    }
                case "dataSubset":
                    {
                        const copy = {
                            ...selectedEntity,
                            id: copyId,
                            name: `Copy of ${selectedEntity.name}`,
                            order: Object.values(state.dataSubsets).length + 1
                        };
                        dispatch({
                            operation: (0, $cIJV5.PATCH_ARS_STATE),
                            updates: [
                                {
                                    dataPath: `/dataSubsets/${copyId}`,
                                    value: copy
                                }
                            ]
                        });
                        setSelectedId(copyId);
                        break;
                    }
                case "groupingFactor":
                    {
                        const copy = {
                            ...selectedEntity,
                            id: copyId,
                            name: `Copy of ${selectedEntity.name}`
                        };
                        dispatch({
                            operation: (0, $cIJV5.PATCH_ARS_STATE),
                            updates: [
                                {
                                    dataPath: `/groupingFactors/${copyId}`,
                                    value: copy
                                }
                            ]
                        });
                        setSelectedId(copyId);
                        break;
                    }
                // istanbul ignore next
                default:
                    break;
            }
        }
    };
    /**
   * Saves active selection changes to TLF context and closes.
   */ const handleSaveAndClose = ()=>{
        tlfContext.dispatch({
            operation: (0, $dDC3L.APPLY_ARS_UPDATES),
            calledFrom: "ArsSetWindow handleSaveAndClose"
        });
        onClose(selectedId !== itemId ? selectedId : undefined);
    };
    /**
   * Closes the window or shows discard confirmation if there are pending changes.
   */ const handleClose = ()=>{
        if (hasUpdates) setShowAreYouSure(true);
        else onClose();
    };
    /**
   * Discards pending entities and closes the window.
   */ const handleCancel = ()=>{
        /* istanbul ignore else -- discard confirmation is only shown when ARS changes exist */ if (hasUpdates) tlfContext.dispatch({
            operation: (0, $dDC3L.DISCARD_ARS_UPDATES),
            calledFrom: "ArsSetWindow:handleCancel"
        });
        setSelectedId(itemId);
        setShowAreYouSure(false);
        onClose();
    };
    const title = type.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase().replace(/^\w/, (c)=>c.toUpperCase());
    const modalIdPrefix = type.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    const options = (()=>{
        switch(type){
            case "analysisMethod":
                return [
                    ...selectedId === "" ? [
                        {
                            value: "",
                            label: "--- Select an analysis method ---"
                        }
                    ] : [],
                    ...Object.values(state.analysisMethods).map((method)=>({
                            value: method.id,
                            label: method.name
                        }))
                ];
            case "analysisSet":
                return [
                    ...selectedId === "" ? [
                        {
                            value: "",
                            label: "--- Select an analysis set ---"
                        }
                    ] : [],
                    ...Object.values(state.analysisSets).map((set)=>({
                            value: set.id,
                            label: set.name
                        }))
                ];
            case "dataSubset":
                return [
                    {
                        value: "",
                        label: "--- No data subset ---"
                    },
                    ...Object.values(state.dataSubsets).map((subset)=>({
                            value: subset.id,
                            label: subset.name
                        }))
                ];
            case "groupingFactor":
                return [
                    ...selectedId === "" ? [
                        {
                            value: "",
                            label: "--- Select a grouping factor ---"
                        }
                    ] : [],
                    ...Object.values(state.groupingFactors).map((factor)=>({
                            value: factor.id,
                            label: factor.name
                        }))
                ];
        }
    })();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextWindow), {
                id: `${modalIdPrefix}-picker-modal`,
                title: title,
                visible: visible,
                style: {
                    minWidth: "800px"
                },
                onOpen: ()=>{
                    // Reset state on open
                    setSelectedId(itemId);
                },
                onClose: ()=>{
                    handleClose();
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                            id: `${modalIdPrefix}-select`,
                            label: title,
                            disabled: !canEdit,
                            options: options,
                            value: selectedId,
                            setValue: setSelectedId
                        }),
                        type === "analysisMethod" && selectedEntity && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7uNID.AnalysisMethodControl), {
                            dataPath: `/analysisMethods/${selectedId}`,
                            canRename: false,
                            disabled: true
                        }),
                        type === "analysisSet" && selectedEntity && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9ijW6.AnalysisSetControl), {
                            dataPath: `/analysisSets/${selectedId}`,
                            canRename: canEdit,
                            disabled: !canEdit
                        }),
                        type === "dataSubset" && selectedId && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b1QeS.DataSubsetControl), {
                            dataPath: `/dataSubsets/${selectedId}`,
                            canRename: canEdit,
                            disabled: !canEdit
                        }),
                        type === "groupingFactor" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bRDEW.GroupingFactorControl), {
                            dataPath: `/groupingFactors/${selectedId}`,
                            canRename: canEdit,
                            disabled: !canEdit
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "d-flex justify-content-end gap-2 mb-3",
                            style: {
                                bottom: 0
                            },
                            children: [
                                canEdit && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                            id: `create-new-${modalIdPrefix}-button`,
                                            variant: "outline-secondary",
                                            onClick: handleCreateNew,
                                            "aria-label": "Create new",
                                            disabled: type === "analysisMethod",
                                            children: "New"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                            id: `edit-existing-${modalIdPrefix}-button`,
                                            variant: "primary",
                                            onClick: handleCopyAndEdit,
                                            "aria-label": `Create a copy of the ${title.toLowerCase()} for editing`,
                                            disabled: !selectedId || type === "analysisMethod",
                                            children: "Copy"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                            id: `set-${modalIdPrefix}-button`,
                                            variant: "primary",
                                            onClick: handleSaveAndClose,
                                            disabled: !hasUpdates && selectedId === itemId,
                                            "aria-label": "Set",
                                            children: hasUpdates ? "Save" : "Set"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                                    id: `close-${modalIdPrefix}-picker-button`,
                                    variant: "secondary",
                                    onClick: handleCancel,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6VdBt.AreYouSureModal), {
                id: `discard-${modalIdPrefix}-changes`,
                show: showAreYouSure,
                title: "Discard changes?",
                message: `You have unsaved changes, do you want to discard them?`,
                onOk: handleCancel,
                onClose: ()=>setShowAreYouSure(false)
            })
        ]
    });
};
$726a344535e2f9ed$export$72bfa98672dbebf.displayName = "ArsSetWindow";

});

parcelRegister("ajZ7G", function(module, exports) {

$parcel$export(module.exports, "ARS_SET_TYPES", function () { return $72270325626fe33d$export$d3bfaacefda794e2; });
/**
 * Supported ARS set types for the shared picker/window components.
 */ const $72270325626fe33d$export$d3bfaacefda794e2 = {
    analysisMethod: {
        value: "analysisMethod",
        selectLabel: "Select analysis method",
        glyphText: "AM"
    },
    analysisSet: {
        value: "analysisSet",
        selectLabel: "Select analysis set",
        glyphText: "AS"
    },
    dataSubset: {
        value: "dataSubset",
        selectLabel: "Select data subset",
        glyphText: "DS"
    },
    groupingFactor: {
        value: "groupingFactor",
        selectLabel: "Select grouping factor",
        glyphText: "GF"
    }
};

});



parcelRegister("1TSz4", function(module, exports) {

$parcel$export(module.exports, "TlfArsTable", function () { return $4032c54af084891a$export$deb136cfa686642b; });

var $bbzbN = parcelRequire("bbzbN");

var $1iDss = parcelRequire("1iDss");
parcelRequire("P0x5y");
var $3Q1wz = parcelRequire("3Q1wz");
var $GtyWr = parcelRequire("GtyWr");
var $30Ra3 = parcelRequire("30Ra3");
var $ihppY = parcelRequire("ihppY");
var $cIJV5 = parcelRequire("cIJV5");
var $fZCs4 = parcelRequire("fZCs4");

var $aBGeK = parcelRequire("aBGeK");

var $lQquc = parcelRequire("lQquc");

var $hWsmt = parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $bjMxp = parcelRequire("bjMxp");

var $lNt9u = parcelRequire("lNt9u");

var $7fPBF = parcelRequire("7fPBF");

var $h1xuz = parcelRequire("h1xuz");
var $alDlg = parcelRequire("alDlg");
var $kYoG1 = parcelRequire("kYoG1");

var $fzB3U = parcelRequire("fzB3U");

var $410tS = parcelRequire("410tS");
const $4032c54af084891a$export$deb136cfa686642b = ()=>{
    // Contexts
    const appSettings = (0, $hWsmt.useAppSettings)();
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const arsContext = (0, $fZCs4.useArsContext)();
    // Derived from contexts
    const body = tlfContext && (0, $lNt9u.isTlfItemReadDto)(tlfData) && (0, $GtyWr.isArsTableBody)(tlfData.body, (0, $1iDss.isIEditorV3)) ? tlfData.body : null;
    const disabled = tlfContext.readOnly;
    // Component state items
    const [calculatedTableRows, setCalculatedTableRows] = (0, $7fPBF.useState)([]);
    const [requestingCalculation, setRequestingCalculation] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [errorText, setErrorText] = (0, $7fPBF.useState)(null);
    const getCalculatedRows = (0, $7fPBF.useEffectEvent)(async (body)=>{
        const analysisSet = tlfData?.analysisSetId ? arsContext.state.analysisSets[tlfData.analysisSetId] : undefined;
        const dataSubset = body.dataSubsetId && Object.keys(arsContext.state.dataSubsets).includes(body.dataSubsetId) ? arsContext.state.dataSubsets[body.dataSubsetId] : undefined;
        const arsCalculationDto = {
            arsTableBody: body,
            analysisSet: analysisSet,
            dataSubset: dataSubset
        };
        const request = await (0, $30Ra3.loadWrapper)((0, $bjMxp.getArsTableCalculation), arsCalculationDto, {
            ...requestingCalculation,
            error: false
        }, setRequestingCalculation, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) {
            arsContext.dispatch({
                operation: (0, $cIJV5.SET_VARIABLES_IN_USE),
                variablesInUse: request.data.variables
            });
            (0, $7fPBF.startTransition)(()=>{
                setCalculatedTableRows(request.data.rows);
                setErrorText(null);
            });
        } else if (request?.success === false) (0, $7fPBF.startTransition)(()=>setErrorText(request.errorText));
    });
    const checkAnalysisMethod = (0, $7fPBF.useEffectEvent)(async (body)=>{
        /* istanbul ignore else */ if (body.analysisMethodId !== arsContext.state.currentSidebar.analysisMethodId) arsContext.dispatch({
            operation: (0, $cIJV5.SET_SIDEBAR_ANALYSIS_METHOD_ID),
            analysisMethodId: body.analysisMethodId
        });
    });
    (0, $7fPBF.useEffect)(()=>{
        if (body && !tlfContext.requestStatus.requesting) {
            getCalculatedRows(body);
            checkAnalysisMethod(body);
        }
    }, [
        body,
        tlfContext.requestStatus.requesting
    ]);
    return !tlfContext || !body ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
        fluid: true,
        style: {
            minHeight: "400px"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                    className: "d-flex align-items-start flex-row gap-1 py-3",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $410tS.ArsSetPicker), {
                            type: "analysisSet",
                            itemId: tlfData?.analysisSetId ?? "",
                            onChange: (newId)=>{
                                tlfContext.dispatch({
                                    operation: (0, $dDC3L.UPDATE_TLF),
                                    tlfData: {
                                        analysisSetId: newId
                                    },
                                    calledFrom: "TlfArsTable onChange:AnalysisSet"
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $410tS.ArsSetPicker), {
                            type: "dataSubset",
                            itemId: body.dataSubsetId ?? "",
                            onChange: (newId)=>{
                                tlfContext.dispatch({
                                    operation: (0, $dDC3L.UPDATE_TLF),
                                    tlfData: {
                                        body: {
                                            ...body,
                                            dataSubsetId: newId
                                        }
                                    },
                                    calledFrom: "TlfArsTable onChange:DataSubset"
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ihppY.MultipleDatasetCheck), {})
                    ]
                })
            }),
            errorText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                    className: "text-danger m-3",
                    children: errorText
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kYoG1.default), {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $h1xuz.default), {
                    className: "d-flex position-relative",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fzB3U.ArsItemRequestingSpinner), {
                            requestingCalculation: requestingCalculation,
                            requestingLabel: "Recalculating"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "m-auto px-3",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
                                id: "ars-table-comment",
                                activeContext: "TlfItem",
                                wrap: true,
                                iconPosition: {
                                    top: "-16px",
                                    left: "-16px"
                                },
                                commentLabel: "New table comment",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3Q1wz.ArsTable), {
                                    arsTableBody: body,
                                    calculatedTableRows: calculatedTableRows,
                                    disabled: disabled,
                                    editorProps: (0, $lQquc.v3EditorProps),
                                    sidebarStyle: {
                                        paddingBottom: "40px"
                                    },
                                    style: appSettings.defaultTableStyle,
                                    tlfViewMode: tlfContext.tlfViewMode,
                                    updateArsTableBody: (newBody, calculatedTableRows)=>{
                                        setCalculatedTableRows(calculatedTableRows);
                                        tlfContext.dispatch({
                                            operation: (0, $dDC3L.UPDATE_TLF),
                                            tlfData: {
                                                body: newBody
                                            },
                                            calledFrom: "TlfArsTable onChange"
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$4032c54af084891a$export$deb136cfa686642b.displayName = "TlfArsTable";

});
parcelRegister("bjMxp", function(module, exports) {

$parcel$export(module.exports, "getArsTableCalculation", function () { return $def935fc0707e998$export$73a831d39d310941; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $def935fc0707e998$export$73a831d39d310941 = async (backEndUrl, params, controller)=>{
    try {
        const url = `${backEndUrl}Ars/ArsTableCalculation`;
        const response = await (0, $a04va.default).post(url, params, {
            signal: controller.signal
        });
        return {
            success: true,
            data: {
                rows: response.data.rows,
                variables: new Set(response.data.variables)
            }
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Get ARS table calculation failed - please refresh the page and try again", error);
    }
};

});


parcelRegister("54Uke", function(module, exports) {

$parcel$export(module.exports, "TlfUndoButtons", function () { return $6c2ce887dd5b5108$export$b3dce601057c91be; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $bsSFb = parcelRequire("bsSFb");

var $9vhuO = parcelRequire("9vhuO");
var $FC3dJ = parcelRequire("FC3dJ");
const $6c2ce887dd5b5108$export$b3dce601057c91be = ()=>{
    const tlfContext = (0, $cgEO2.useTlfContext)();
    return !tlfContext.tlfData || tlfContext.readOnly ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        style: {
            position: "relative",
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bsSFb.default), {
            style: {
                position: "absolute",
                top: "-16px",
                right: 0,
                zIndex: 2
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                    id: "tlf-undo-button",
                    className: "border border-dark",
                    variant: "warning",
                    size: "sm",
                    "aria-label": "Undo",
                    onClick: ()=>tlfContext.dispatch({
                            operation: (0, $dDC3L.UNDO_TLF_CHANGE),
                            calledFrom: "TlfUndoButtons:Undo"
                        }),
                    disabled: tlfContext.readOnly || tlfContext.ixTlfDataVersion === 0,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $FC3dJ.default), {})
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                    id: "tlf-redo-button",
                    className: "border border-dark",
                    variant: "warning",
                    size: "sm",
                    "aria-label": "Redo",
                    onClick: ()=>tlfContext.dispatch({
                            operation: (0, $dDC3L.REDO_TLF_CHANGE),
                            calledFrom: "TlfUndoButtons:Redo"
                        }),
                    disabled: tlfContext.readOnly || tlfContext.ixTlfDataVersion >= tlfContext.tlfDataVersions.length - 1,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9vhuO.default), {})
                })
            ]
        })
    });
};
$6c2ce887dd5b5108$export$b3dce601057c91be.displayName = "TlfUndoButtons";

});
parcelRegister("9vhuO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb4949e4a0fe5a2$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $6eb4949e4a0fe5a2$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $6eb4949e4a0fe5a2$var$_extends() {
    return $6eb4949e4a0fe5a2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6eb4949e4a0fe5a2$var$_extends.apply(null, arguments);
}
function $6eb4949e4a0fe5a2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6eb4949e4a0fe5a2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $6eb4949e4a0fe5a2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6eb4949e4a0fe5a2$var$ArrowClockwise = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $6eb4949e4a0fe5a2$var$_objectWithoutProperties(_ref, $6eb4949e4a0fe5a2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $6eb4949e4a0fe5a2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-clockwise',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
    }));
});
$6eb4949e4a0fe5a2$var$ArrowClockwise.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $6eb4949e4a0fe5a2$export$2e2bcd8739ae039 = $6eb4949e4a0fe5a2$var$ArrowClockwise;

});

parcelRegister("FC3dJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07d1589330acf8c5$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $07d1589330acf8c5$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $07d1589330acf8c5$var$_extends() {
    return $07d1589330acf8c5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $07d1589330acf8c5$var$_extends.apply(null, arguments);
}
function $07d1589330acf8c5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $07d1589330acf8c5$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $07d1589330acf8c5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $07d1589330acf8c5$var$ArrowCounterclockwise = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $07d1589330acf8c5$var$_objectWithoutProperties(_ref, $07d1589330acf8c5$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $07d1589330acf8c5$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-counterclockwise',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"
    }));
});
$07d1589330acf8c5$var$ArrowCounterclockwise.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $07d1589330acf8c5$export$2e2bcd8739ae039 = $07d1589330acf8c5$var$ArrowCounterclockwise;

});


parcelRegister("1vibC", function(module, exports) {

$parcel$export(module.exports, "V1Figure", function () { return $862ba522aca95917$export$621458e076b060e; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $aBGeK = parcelRequire("aBGeK");
parcelRequire("hWsmt");
var $cgEO2 = parcelRequire("cgEO2");

var $dDC3L = parcelRequire("dDC3L");

var $7fPBF = parcelRequire("7fPBF");

var $97wH2 = parcelRequire("97wH2");

var $6fLud = parcelRequire("6fLud");
const $862ba522aca95917$export$621458e076b060e = ()=>{
    const tlfContext = (0, $cgEO2.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const figureData = tlfData && tlfData.body ? tlfData.body : {
        figureString: "",
        coreTrafficLight: "BlankNotEvaluated"
    };
    const [message, setMessage] = (0, $7fPBF.useState)([]);
    const [isDragActive, setIsDragActive] = (0, $7fPBF.useState)(false);
    const inputRef = (0, $7fPBF.useRef)(null);
    const handleFiles = (0, $7fPBF.useCallback)(async (files)=>{
        /* istanbul ignore else */ if (tlfContext && !tlfContext.readOnly && files) {
            // Set up check message
            const acceptedFiles = Array.from(files);
            const newMessage = [];
            // Check one image file has been loaded
            if (acceptedFiles.length !== 1) newMessage.push("Only one file can be added.");
            const newImage = acceptedFiles[0];
            if ([
                "image/png",
                "image/jpeg"
            ].indexOf(newImage.type) === -1) newMessage.push("Only PNG and JPG images are accepted.");
            if (newImage.size > 160000) newMessage.push("Image must be 150K or less in size.");
            // Update message here
            setMessage(newMessage);
            // Process if everything is ok
            if (newMessage.length === 0) {
                // Set up to convert to base64
                const fileReader = new FileReader();
                fileReader.onload = (fileLoadedEvent)=>{
                    /* istanbul ignore else */ if (fileLoadedEvent.target) {
                        const base64 = fileLoadedEvent.target.result;
                        /* istanbul ignore else */ if (typeof base64 === "string") tlfContext.dispatch({
                            operation: (0, $dDC3L.UPDATE_TLF),
                            tlfData: {
                                body: {
                                    figureString: base64,
                                    coreTrafficLight: "BlankNotEvaluated"
                                }
                            },
                            calledFrom: "V1Figure:setFigureData"
                        });
                    }
                };
                // Read image
                fileReader.readAsDataURL(newImage);
            }
        }
    }, [
        tlfContext
    ]);
    return !tlfData ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aBGeK.CommentScope), {
        id: `tlf-legacy-figure-${tlfData.id}`,
        activeContext: "TlfItem",
        commentLabel: "New figure comment",
        iconPosition: {
            top: "0",
            left: "24px"
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            "aria-label": "Drop JPG or PNG image",
            style: {
                border: "1px blue dashed",
                borderRadius: "10px",
                padding: "1px",
                margin: "1rem",
                height: "603px"
            },
            onDragOver: (e)=>{
                e.preventDefault();
                setIsDragActive(true);
            },
            onDragLeave: ()=>setIsDragActive(false),
            onDrop: (e)=>{
                e.preventDefault();
                setIsDragActive(false);
                handleFiles(e.dataTransfer.files);
            },
            onClick: ()=>inputRef.current?.click(),
            children: [
                !tlfContext.readOnly && /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                    ref: inputRef,
                    type: "file",
                    id: "dropzoneinput",
                    "aria-label": "Dropzone input for image upload",
                    accept: "image/jpeg,image/png",
                    onChange: (e)=>void handleFiles(e.target.files),
                    style: {
                        display: "none"
                    }
                }),
                figureData.figureString && figureData.figureString.startsWith("data:image") ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    className: "d-flex justify-content-center",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $97wH2.default), {
                            src: figureData.figureString,
                            style: {
                                objectFit: "contain",
                                objectPosition: "0%",
                                height: "600px",
                                maxWidth: "100%"
                            }
                        }),
                        !tlfContext.readOnly && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "position-absolute",
                            style: {
                                top: "0",
                                right: "0"
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8HzIe.AsyncButton), {
                                id: "tlf-figure-remove-button",
                                "aria-label": "Remove image",
                                variant: "danger",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                    tlfContext.dispatch({
                                        operation: (0, $dDC3L.UPDATE_TLF),
                                        tlfData: {
                                            body: {
                                                figureString: "",
                                                coreTrafficLight: "BlankNotEvaluated"
                                            }
                                        },
                                        calledFrom: "V1Figure:newFigure"
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6fLud.default), {}),
                                    " Remove"
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    style: {
                        height: "600px",
                        position: "relative"
                    },
                    className: "d-flex justify-content-center align-items-center",
                    children: isDragActive ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: "Drop the file here ..."
                    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: "Drag and drop a file here, or click to select file"
                            }),
                            message.map((m, mi)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    children: m
                                }, mi))
                        ]
                    })
                })
            ]
        })
    });
};
$862ba522aca95917$export$621458e076b060e.displayName = "V1Figure";

});
parcelRegister("6fLud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d8fa9c8518ddf6$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $48d8fa9c8518ddf6$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $48d8fa9c8518ddf6$var$_extends() {
    return $48d8fa9c8518ddf6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $48d8fa9c8518ddf6$var$_extends.apply(null, arguments);
}
function $48d8fa9c8518ddf6$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $48d8fa9c8518ddf6$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $48d8fa9c8518ddf6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $48d8fa9c8518ddf6$var$XCircle = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $48d8fa9c8518ddf6$var$_objectWithoutProperties(_ref, $48d8fa9c8518ddf6$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", $48d8fa9c8518ddf6$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-x-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
    }));
});
$48d8fa9c8518ddf6$var$XCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string
};
var $48d8fa9c8518ddf6$export$2e2bcd8739ae039 = $48d8fa9c8518ddf6$var$XCircle;

});



parcelRegister("ozlyW", function(module, exports) {

$parcel$export(module.exports, "TocTree", function () { return $3c753b564cb63f8b$export$f75ce8d70daf068e; });

var $bbzbN = parcelRequire("bbzbN");

var $h6WyF = parcelRequire("h6WyF");
parcelRequire("P0x5y");
var $9Er6k = parcelRequire("9Er6k");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $2egIW = parcelRequire("2egIW");

var $4PTZu = parcelRequire("4PTZu");

var $7fPBF = parcelRequire("7fPBF");

var $alDlg = parcelRequire("alDlg");

var $gxpCl = parcelRequire("gxpCl");

const $3c753b564cb63f8b$export$f75ce8d70daf068e = ()=>{
    const location = (0, $gxpCl.useLocation)();
    const params = (0, $gxpCl.useParams)();
    const hierarchyContext = (0, $hWsmt.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("toc-tree");
    const { state: state } = (0, $hWsmt.useTocContext)();
    const [filter, setFilter] = (0, $7fPBF.useState)("");
    const tocList = (0, $2egIW.getTreeListFromTocItems)(state.tocItems, filter);
    const selectedId = params.tocNumber ? tocList.find((n)=>n.data === params.tocNumber)?.id : undefined;
    /**
   * Handles selection of a ToC tree node by navigating to its review URL.
   *
   * @param id - The identifier of the selected tree node.
   */ const handleSelect = (id)=>{
        /* istanbul ignore else */ if (hierarchy) {
            const node = tocList.find((n)=>n.id === id);
            /* istanbul ignore else */ if (node?.data) {
                const newUrl = `${(0, $wPq5H.getHierarchyBaseUrl)(hierarchy)}/Review/${node.data}`;
                /* istanbul ignore else */ if (newUrl !== location.pathname) navigate(newUrl);
            }
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $alDlg.default), {
        id: "toc-tree-container",
        className: "w-100 ml-2 mt-2",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h4", {
                className: "text-lg",
                children: "Table of contents"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                value: filter,
                setValue: setFilter,
                label: "Filter",
                id: "toc-tree-filter",
                labelWidth: "auto"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h6WyF.TreeOfNodes), {
                id: "toc-tree",
                nodeList: tocList,
                roots: tocList.filter((n)=>!n.parentId).map((n)=>n.id),
                handleSelect: handleSelect,
                selected: selectedId ? [
                    selectedId
                ] : [],
                nodeHighlight: "rgb(33,35,241)",
                textHighlight: "rgba(33,35,211,0.1)"
            })
        ]
    });
};
$3c753b564cb63f8b$export$f75ce8d70daf068e.displayName = "TocTree";

});
parcelRegister("2egIW", function(module, exports) {

$parcel$export(module.exports, "getTreeListFromTocItems", function () { return $d6016bc2fde68724$export$5dd4be79322012bb; });

var $bVMOy = parcelRequire("bVMOy");

var $jfDHD = parcelRequire("jfDHD");
const $d6016bc2fde68724$export$5dd4be79322012bb = (tocItems, filter = "")=>{
    let ret = [];
    // Get all sections
    let lastSection = "__NOPE!!__";
    let lastSectionTocNumber = "__NOPE!!__";
    const sections = tocItems.filter((n)=>n instanceof (0, $bVMOy.MosaicTocSectionClass));
    const sectionNodes = sections.sort((a, b)=>(0, $jfDHD.tocSort)(a.tocNumber, b.tocNumber)).map((n)=>{
        const node = {
            id: n.id,
            label: `${n.tocNumber} ${n.tocLabel}`,
            parentId: n.tocNumber.startsWith(lastSectionTocNumber) ? lastSection : undefined,
            data: null
        };
        lastSection = n.id;
        lastSectionTocNumber = n.tocNumber;
        return node;
    });
    // Assign entry to the section that matches the most characters at the start of tocNumber
    const entryNodes = tocItems.filter((n)=>!(n instanceof (0, $bVMOy.MosaicTocSectionClass))).map((n)=>{
        const parentSection = sections.filter((s)=>(n.tocNumber ?? // istanbul ignore next
            "").startsWith(s.tocNumber ?? // istanbul ignore next
            "")).sort((a, b)=>(0, $jfDHD.tocSort)(a.tocNumber ?? // istanbul ignore next
            "", b.tocNumber ?? // istanbul ignore next
            "")).pop();
        const node = {
            id: n.id,
            label: `${n.tocNumber} ${n.tocLabel}`,
            data: n.tocNumber ?? // istanbul ignore next
            "",
            parentId: parentSection ? parentSection.id : undefined
        };
        return node;
    });
    // Filter entries based on the provided filter
    if (filter) {
        const filterLower = filter.toLowerCase();
        const filteredEntries = entryNodes.filter((n)=>n.label.toLowerCase().includes(filterLower));
        // Add sections for the filtered entries recursively for parentIds
        const filteredSections = sectionNodes.filter((s)=>filteredEntries.some((e)=>e.parentId === s.id) || s.label.toLowerCase().includes(filterLower));
        while(filteredSections.some((s)=>s.parentId && !filteredSections.map((fs)=>fs.id).includes(s.parentId))){
            const missingNodes = sectionNodes.filter((s)=>filteredSections.map((fs)=>fs.parentId).includes(s.id));
            filteredSections.push(...missingNodes);
        }
        // Combine filtered sections and entries
        ret = [
            ...filteredSections,
            ...filteredEntries
        ];
    } else ret = [
        ...sectionNodes,
        ...entryNodes
    ];
    return ret.sort((a, b)=>{
        return (0, $jfDHD.tocSort)(a.label.split(" ")[0], b.label.split(" ")[0]);
    });
};

});


parcelRegister("j3Csp", function(module, exports) {

$parcel$export(module.exports, "HierarchyContextProvider", function () { return $89e5d711762bf4a9$export$c7a55eb27c9fa62a; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");

var $hWsmt = parcelRequire("hWsmt");

var $wPq5H = parcelRequire("wPq5H");

var $9Jgpw = parcelRequire("9Jgpw");

var $9sVtA = parcelRequire("9sVtA");
const $89e5d711762bf4a9$export$c7a55eb27c9fa62a = ({ children: children })=>{
    const { hierarchyState: state, dispatch: dispatch } = (0, $hWsmt.useAppSettings)();
    const hierarchyLoaderData = (0, $gxpCl.useLoaderData)();
    const { setCurrentBaseUrl: setCurrentBaseUrl } = (0, $9sVtA.useHierarchyEffects)();
    /**
   * Add loader data into context
   * Check if the loader data is valid and if the hierarchy has changed
   */ (0, $7fPBF.useEffect)(()=>{
        if (hierarchyLoaderData && hierarchyLoaderData.hierarchy && hierarchyLoaderData.accessRights && hierarchyLoaderData.parentHierarchies && // Reload if the Hierarchy is changed even if the name change is not saved
        (!state.isNameChanged || !state.hierarchy || state.hierarchy.id !== hierarchyLoaderData.hierarchy.id) && (!state.hierarchy || (0, $wPq5H.getHierarchyBaseUrl)(state.hierarchy) !== (0, $wPq5H.getHierarchyBaseUrl)(hierarchyLoaderData.hierarchy))) {
            dispatch({
                operation: (0, $9Jgpw.LOAD_HIERARCHY),
                hierarchy: hierarchyLoaderData.hierarchy,
                hierarchyNodes: hierarchyLoaderData.parentHierarchies,
                accessRights: hierarchyLoaderData.accessRights,
                isSubscribed: hierarchyLoaderData.isHierarchySubscribed
            });
            setCurrentBaseUrl((0, $wPq5H.getHierarchyBaseUrl)(hierarchyLoaderData.hierarchy));
        }
    }, [
        dispatch,
        hierarchyLoaderData,
        setCurrentBaseUrl,
        state.hierarchy,
        state.id,
        state.isNameChanged
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: "hierarchyContextProvider",
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        children: children
    });
};
$89e5d711762bf4a9$export$c7a55eb27c9fa62a.displayName = "HierarchyContextProvider";

});
parcelRegister("9sVtA", function(module, exports) {

$parcel$export(module.exports, "useHierarchyEffects", function () { return $751e17e94edfed09$export$a403c608a5c01552; });

var $hGHEx = parcelRequire("hGHEx");
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $9Zudk = parcelRequire("9Zudk");

var $4mSD2 = parcelRequire("4mSD2");

var $g1MAF = parcelRequire("g1MAF");

var $ddsuT = parcelRequire("ddsuT");

var $9bDuL = parcelRequire("9bDuL");

var $5UDwf = parcelRequire("5UDwf");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $hWsmt = parcelRequire("hWsmt");

var $gD2t9 = parcelRequire("gD2t9");

var $6E9u3 = parcelRequire("6E9u3");

var $7KW2P = parcelRequire("7KW2P");

var $iK0dj = parcelRequire("iK0dj");

var $arm5P = parcelRequire("arm5P");

var $cc07l = parcelRequire("cc07l");

var $wPq5H = parcelRequire("wPq5H");

var $9Jgpw = parcelRequire("9Jgpw");
const $751e17e94edfed09$export$a403c608a5c01552 = ()=>{
    const { state: appSettings, dispatch: dispatch } = (0, $7fPBF.useContext)((0, $hWsmt.AppSettingsContext));
    const state = appSettings.hierarchyState;
    const signalR = (0, $7fPBF.useContext)((0, $gD2t9.SignalRContext));
    const { navigateAfterSave: navigateAfterSave, registerUnsavedChanges: registerUnsavedChanges } = (0, $4PTZu.useUnsavedChanges)("hierarchy-context-provider");
    const saveRequestStatus = state.saveRequestStatus;
    const saveTocRequestStatus = state.saveTocRequestStatus;
    const setSaveRequestStatus = (0, $7fPBF.useCallback)((status)=>dispatch({
            operation: (0, $9Jgpw.SET_HIERARCHY_SAVE_REQUEST_STATUS),
            saveRequestStatus: status
        }), [
        dispatch
    ]);
    const setSaveTocRequestStatus = (0, $7fPBF.useCallback)((status)=>dispatch({
            operation: (0, $9Jgpw.SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS),
            saveTocRequestStatus: status
        }), [
        dispatch
    ]);
    const [clinicalLibrariesLoadStatus, setClinicalLibrariesLoadStatus] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const [, startTransition] = (0, $7fPBF.useTransition)();
    const tocState = appSettings.tocState;
    const [tocSaveRequestStatus, setTocSaveRequestStatus] = (0, $7fPBF.useState)({
        requesting: false,
        error: false
    });
    const setTocRequestStatus = (0, $7fPBF.useCallback)((status)=>dispatch({
            operation: (0, $6E9u3.SET_TOC_REQUEST_STATUS),
            tocRequestStatus: status
        }), [
        dispatch
    ]);
    // Messages already processed or sent by this client, used to de-duplicate SignalR echoes
    const [receivedMessages, setReceivedMessages] = (0, $7fPBF.useState)([]);
    const currentBaseUrlRef = (0, $7fPBF.useRef)("");
    /**
   * Update the tracked current base URL used to detect hierarchy/report navigation after a save.
   * Called by {@link HierarchyContextProvider} when new loader data is applied.
   *
   * @param baseUrl - The base URL of the hierarchy currently loaded into context
   */ const setCurrentBaseUrl = (0, $7fPBF.useCallback)((baseUrl)=>{
        currentBaseUrlRef.current = baseUrl;
    }, []);
    /**
   * Memoised parent hierarchy nodes filtered by hierarchyLinks.
   * Only includes hierarchy nodes that are parents of the current hierarchy
   * based on the hierarchyLinks array.
   */ const parentNodes = (0, $7fPBF.useMemo)(()=>{
        const parentHierarchyIds = state.hierarchy?.hierarchyLinks?.map((link)=>link.hierarchyId) ?? [];
        return state.hierarchyNodes.filter((node)=>parentHierarchyIds.includes(node.id));
    }, [
        state.hierarchy?.hierarchyLinks,
        state.hierarchyNodes
    ]);
    /**
   * Send a SignalR update to the group when the hierarchyId is changed because of a save major version
   * @param oldHierarchyId Old hierarchy ID
   * @param newHierarchy New hierarchy data
   */ const sendSignalRHierarchyUpdate = (0, $7fPBF.useCallback)(async (oldHierarchyId, newHierarchy)=>{
        if (signalR && signalR.connection?.state === (0, $hGHEx.HubConnectionState).Connected) signalR.sendTocSaveToGroup({
            oldHierarchyId: oldHierarchyId,
            newHierarchy: newHierarchy
        }, `toc${oldHierarchyId}`);
    }, [
        signalR
    ]);
    /**
   * Lazy load clinical libraries for the current hierarchy and parent hierarchies.
   * This callback runs after the hierarchy is loaded and loads clinical libraries separately.
   * It resolves the hierarchy IDs that should participate in the batch lookup,
   * fetches their clinical libraries, and dispatches them to the context state.
   * If the load fails or returns no data, it sets the loading flag to false.
   *
   */ const loadClinicalLibraries = (0, $7fPBF.useCallback)(async ()=>{
        const clinicalLibraryHierarchyIds = (0, $cc07l.getClinicalLibraryHierarchyIds)(state.hierarchy, state.id);
        const response = await (0, $30Ra3.loadWrapper)((0, $ddsuT.getLibraries), clinicalLibraryHierarchyIds, clinicalLibrariesLoadStatus, setClinicalLibrariesLoadStatus, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) dispatch({
            operation: (0, $9Jgpw.LOAD_CLINICAL_LIBRARY),
            clinicalLibrary: response.data
        });
        else if (response?.success === false) dispatch({
            operation: (0, $9Jgpw.SET_CLINICAL_LIBRARY_LOADING),
            isClinicalLibraryLoading: false
        });
    }, [
        appSettings.backEndUrl,
        clinicalLibrariesLoadStatus,
        dispatch,
        state.hierarchy,
        state.id
    ]);
    /**
   * Effect to trigger clinical library loading when needed.
   * Runs when the hierarchy or parent hierarchy nodes change and checks if any of them
   * have the hasClinicalLibrary flag set but don't have the clinicalLibrary data loaded.
   * Sets the loading state and calls loadClinicalLibraries to fetch the data.
   *
   * Report hierarchies only request their study parent's library (see
   * getClinicalLibraryHierarchyIds), so only the study parent's load state is checked;
   * the report's own flags and other ancestors are never populated by that response.
   * Reports can never have a clinical library of their own - it can only exist at study
   * level - so there is no fallback to the report's own flags when it has no study parent.
   * Study hierarchies only request their own library (see getClinicalLibraryHierarchyIds),
   * so their Template-level ancestors are never populated by that response either; parent
   * nodes are therefore never checked for Study hierarchies, to avoid an ancestor with a
   * stale hasClinicalLibrary flag causing the load to be re-triggered indefinitely.
   */ (0, $7fPBF.useEffect)(()=>{
        const isReport = state.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Report;
        const studyParent = parentNodes.find((ph)=>ph.level === (0, $7Wd8C.eHierarchyLevel).Study);
        const currentHierarchyNeedsLoad = isReport ? Boolean(studyParent?.hasClinicalLibrary && !studyParent.clinicalLibrary) : Boolean(state.hierarchy?.hasClinicalLibrary && !state.hierarchy.clinicalLibrary);
        const parentNodesNeedLoad = isReport || state.hierarchy?.level === (0, $7Wd8C.eHierarchyLevel).Study ? false : parentNodes.some((ph)=>ph.hasClinicalLibrary && !ph.clinicalLibrary);
        if (!state.isClinicalLibraryLoading && !clinicalLibrariesLoadStatus.requesting && !clinicalLibrariesLoadStatus.error && (currentHierarchyNeedsLoad || parentNodesNeedLoad)) {
            dispatch({
                operation: (0, $9Jgpw.SET_CLINICAL_LIBRARY_LOADING),
                isClinicalLibraryLoading: true
            });
            loadClinicalLibraries();
        }
    }, [
        clinicalLibrariesLoadStatus.error,
        clinicalLibrariesLoadStatus.requesting,
        dispatch,
        loadClinicalLibraries,
        parentNodes,
        state.hierarchy,
        state.isClinicalLibraryLoading
    ]);
    /**
   * Save the current hierarchy state
   * Does not send a SignalR update
   */ const saveHierarchy = (0, $7fPBF.useEffectEvent)(async ()=>{
        /* istanbul ignore else */ if (state.hierarchy) {
            const updateDto = {
                id: state.hierarchy.id,
                name: state.hierarchy.name,
                parentTag: state.hierarchy.parentTag,
                description: state.hierarchy.description,
                lists: state.hierarchy.lists,
                phase: state.hierarchy.phase,
                reportType: state.hierarchy.reportType,
                rowGroups: state.hierarchy.rowGroups,
                sections: state.hierarchy.sections,
                singles: state.hierarchy.singles,
                status: state.hierarchy.status,
                domainList: state.hierarchy.domainList,
                domainReplacements: state.hierarchy.domainReplacements,
                arsEnabled: state.hierarchy.arsEnabled,
                analysisMethods: state.hierarchy.analysisMethods,
                analysisSets: state.hierarchy.analysisSets,
                dataSubsets: state.hierarchy.dataSubsets,
                groupingFactors: state.hierarchy.groupingFactors,
                tlfTags: state.hierarchy.tlfTags
            };
            const response = state.hierarchy.isBackupVersion && state.hierarchy.type === (0, $7Wd8C.eHierarchy).Report ? await (0, $30Ra3.loadWrapper)((0, $9Zudk.restoreBackupReport), updateDto, {
                ...saveRequestStatus,
                error: false,
                requestedId: undefined,
                errorText: undefined
            }, setSaveRequestStatus, appSettings.backEndUrl) : await (0, $30Ra3.loadWrapper)((0, $4mSD2.saveHierarchyData), updateDto, {
                ...saveRequestStatus,
                error: false,
                requestedId: undefined,
                errorText: undefined
            }, setSaveRequestStatus, appSettings.backEndUrl);
            /* istanbul ignore else */ if (response?.success) {
                dispatch({
                    operation: (0, $9Jgpw.SAVE_HIERARCHY_COMPLETED),
                    hierarchy: {
                        ...response.data,
                        clinicalLibrary: state.hierarchy.clinicalLibrary
                    }
                });
                startTransition(()=>setClinicalLibrariesLoadStatus({
                        requesting: false,
                        error: false
                    }));
                // istanbul ignore else
                if (!state.noRedirect) {
                    const newBaseUrl = (0, $wPq5H.getHierarchyBaseUrl)(response.data);
                    // When restoring a back up, this should trigger
                    if (state.hierarchy.originHierarchyId) await sendSignalRHierarchyUpdate(state.hierarchy.originHierarchyId, response.data);
                    if (response.data.id !== state.hierarchy.id || newBaseUrl !== currentBaseUrlRef.current) {
                        currentBaseUrlRef.current = newBaseUrl;
                        navigateAfterSave(newBaseUrl);
                    }
                }
            } else if (response?.success === false) {
                console.warn(`Save failed for hierarchy: ${saveRequestStatus.errorText}`);
                dispatch({
                    operation: (0, $9Jgpw.SAVE_HIERARCHY_FAILED)
                });
            }
        }
    });
    (0, $7fPBF.useEffect)(()=>{
        if (state.doSave && !saveRequestStatus.requesting) saveHierarchy();
    }, [
        saveRequestStatus.requesting,
        state.doSave
    ]);
    /**
   * Save the current hierarchy as a new major version
   * This will send a SignalR update to the group to indicate that the hierarchyId has changed
   * @param saveTocDescription Description for the save
   */ const saveTocMajor = (0, $7fPBF.useEffectEvent)(async (saveTocDescription)=>{
        /* istanbul ignore else */ if (state.hierarchy) {
            const updateDto = {
                id: state.hierarchy.id,
                name: state.hierarchy.name,
                parentTag: state.hierarchy.parentTag,
                description: state.hierarchy.description,
                lists: state.hierarchy.lists,
                phase: state.hierarchy.phase,
                reportType: state.hierarchy.reportType,
                rowGroups: state.hierarchy.rowGroups,
                sections: state.hierarchy.sections,
                singles: state.hierarchy.singles,
                status: state.hierarchy.status,
                domainList: state.hierarchy.domainList,
                domainReplacements: state.hierarchy.domainReplacements,
                arsEnabled: state.hierarchy.arsEnabled,
                analysisMethods: state.hierarchy.analysisMethods,
                analysisSets: state.hierarchy.analysisSets,
                dataSubsets: state.hierarchy.dataSubsets,
                groupingFactors: state.hierarchy.groupingFactors,
                tlfTags: state.hierarchy.tlfTags
            };
            const response = await (0, $30Ra3.loadWrapper)((0, $g1MAF.saveTocAsMajorVersion), {
                hierarchy: updateDto,
                hierarchyId: updateDto.id,
                parentTag: updateDto.parentTag,
                saveTocDescription: saveTocDescription
            }, {
                ...saveTocRequestStatus,
                error: false,
                requestedId: undefined,
                errorText: undefined
            }, setSaveTocRequestStatus, appSettings.backEndUrl);
            /* istanbul ignore else */ if (response?.success) {
                startTransition(()=>setClinicalLibrariesLoadStatus({
                        requesting: false,
                        error: false
                    }));
                dispatch({
                    operation: (0, $9Jgpw.SAVE_HIERARCHY_COMPLETED),
                    hierarchy: {
                        ...response.data,
                        clinicalLibrary: state.hierarchy.clinicalLibrary
                    },
                    oldHierarchyId: state.hierarchy.id
                });
                // Always send signalR update
                await sendSignalRHierarchyUpdate(state.hierarchy.id, response.data);
                /* istanbul ignore else */ if (response.data.id !== state.hierarchy.id) {
                    const newBaseUrl = (0, $wPq5H.getHierarchyBaseUrl)(response.data);
                    currentBaseUrlRef.current = newBaseUrl;
                    navigateAfterSave(newBaseUrl);
                }
            } else if (response?.success === false) {
                console.warn(`Save failed for hierarchy: ${saveRequestStatus.errorText}`);
                dispatch({
                    operation: (0, $9Jgpw.SAVE_HIERARCHY_FAILED)
                });
            }
        }
    });
    /**
   * Effect to save the ToC as a major version when the state.doTocSave is true
   */ (0, $7fPBF.useEffect)(()=>{
        if (state.doTocSave && !saveTocRequestStatus.requesting && state.saveTocDescription) saveTocMajor(state.saveTocDescription);
    }, [
        saveTocRequestStatus.requesting,
        state.doTocSave,
        state.saveTocDescription
    ]);
    /**
   * Join signalR group for the hierarchy
   * This is done to receive comment updates for the hierarchy
   */ const [sendGroupRequest, setSendGroupRequest] = (0, $7fPBF.useState)("\u2744\uFE0F");
    (0, $7fPBF.useEffect)(()=>{
        if (signalR && signalR.connection?.state === (0, $hGHEx.HubConnectionState).Connected && state.hierarchy && sendGroupRequest !== `hie${state.hierarchy.id}`) {
            signalR.connectToGroup(`hie${state.hierarchy.id}`);
            startTransition(()=>{
                setSendGroupRequest(`hie${state.hierarchy.id}`);
            });
        }
    }, [
        sendGroupRequest,
        signalR,
        signalR?.connection?.state,
        state.hierarchy
    ]);
    // ToC SignalR group, based on the current hierarchy
    const tocSignalRGroup = state.hierarchy ? `toc${state.hierarchy.id}` : null;
    /**
   * Load ToC view mode filter from localStorage on initialisation
   */ (0, $7fPBF.useEffect)(()=>{
        const savedFilter = (0, $arm5P.loadTocTlfItemFilterFromStorage)();
        if (!(0, $gSkQi.isEqual)(savedFilter, tocState.showTypes)) dispatch({
            operation: (0, $6E9u3.SET_TYPE_FILTER),
            showTypes: savedFilter
        });
    }, [
        dispatch,
        tocState.showTypes
    ]);
    /**
   * Join signalR group for the ToC
   * This is done to receive tocSave and tocUpdate messages
   */ const [tocSendGroupRequest, setTocSendGroupRequest] = (0, $7fPBF.useState)("\u2744\uFE0F");
    (0, $7fPBF.useEffect)(()=>{
        if (signalR && signalR.connection?.state === (0, $hGHEx.HubConnectionState).Connected && tocSignalRGroup && tocSendGroupRequest !== tocSignalRGroup) {
            signalR.connectToGroup(tocSignalRGroup);
            startTransition(()=>{
                setTocSendGroupRequest(tocSignalRGroup);
            });
        }
    }, [
        tocSendGroupRequest,
        signalR,
        tocSignalRGroup,
        signalR?.connection?.state
    ]);
    /**
   * Save ToC items provider function
   * @param tocItemsToUpdate - The items to update
   */ const saveTocItems = (0, $7fPBF.useEffectEvent)(async (tocItemsToUpdate)=>{
        const changeList = tocState.tocItems.filter((i)=>i.changed).map((i)=>i.id);
        const response = await (0, $30Ra3.loadWrapper)((0, $9bDuL.updateTocItems), tocItemsToUpdate, {
            ...tocSaveRequestStatus,
            requestedId: undefined
        }, setTocSaveRequestStatus, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success && state.hierarchy) {
            const newHierarchy = {
                ...state.hierarchy,
                tocMajorVersion: response.data.tocMajorVersion,
                tocMinorVersion: response.data.tocMinorVersion,
                sections: response.data.sections
            };
            dispatch({
                operation: (0, $9Jgpw.UPDATE_HIERARCHY),
                hierarchy: newHierarchy
            });
            dispatch({
                operation: (0, $6E9u3.SAVE_SUCCESS),
                itemsUpdate: tocItemsToUpdate,
                saveTimeStamp: Date.now()
            });
            /* istanbul ignore else */ if (tocSignalRGroup && signalR) {
                const signalRUpdate = {
                    hierarchy: newHierarchy,
                    items: [
                        ...response.data.sections.filter((i)=>changeList.includes(i.id)).map((s)=>({
                                id: s.id,
                                primaryHierarchyId: newHierarchy.id,
                                tocNumber: s.sectionNumber,
                                tocLabel: s.sectionLabel,
                                type: (0, $7Wd8C.eTlfItemType).section,
                                tocOrder: s.order,
                                changed: false,
                                inError: false
                            })),
                        ...response.data.shells.filter((i)=>changeList.includes(i.id)).map((i)=>({
                                ...i,
                                changed: false,
                                inError: false
                            }))
                    ],
                    deletedItemId: tocItemsToUpdate.deletedItemId
                };
                const sentMessage = await signalR.sendTocUpdateToGroup(signalRUpdate, tocSignalRGroup);
                const newTlfMessage = {
                    messageId: sentMessage.messageId,
                    updatedIds: [
                        "sentMessage"
                    ],
                    updateTS: new Date(sentMessage.timeStamp)
                };
                setReceivedMessages([
                    ...receivedMessages,
                    newTlfMessage
                ]);
            }
        } else if (response?.success === false) {
            console.warn("Save failed", response?.errorText);
            dispatch({
                operation: (0, $6E9u3.SAVE_FAIL)
            });
        }
    });
    /**
   * Save effect for ToC items
   */ (0, $7fPBF.useEffect)(()=>{
        if (tocState.saving && !tocSaveRequestStatus.requesting && state.hierarchy) {
            const tocItemsToUpdate = {
                hierarchyId: tocState.hierarchyId,
                items: tocState.tocItems.filter((i)=>i.changed).map((n)=>({
                        tocId: n.id,
                        tocNumber: n.tocNumber ?? // istanbul ignore next
                        "",
                        tocLabel: n.tocLabel ?? // istanbul ignore next
                        "",
                        tlfType: n.type,
                        order: n.tocOrder ?? // istanbul ignore next
                        0
                    })),
                deletedItemId: tocState.removedItems?.findLast((i)=>i.changed)?.id
            };
            startTransition(()=>{
                saveTocItems(tocItemsToUpdate);
            });
        }
    }, [
        state.hierarchy,
        tocSaveRequestStatus.requesting,
        tocState.hierarchyId,
        tocState.removedItems,
        tocState.saving,
        tocState.tocItems
    ]);
    /**
   * Send update to get the current hierarchy version
   */ (0, $7fPBF.useEffect)(()=>{
        if (tocState.blocked === "getNewVersion" && !tocSaveRequestStatus.requesting && state.hierarchy) {
            const tocItemsToUpdate = {
                hierarchyId: tocState.hierarchyId,
                items: []
            };
            startTransition(()=>{
                saveTocItems(tocItemsToUpdate);
            });
        }
    }, [
        state.hierarchy,
        tocSaveRequestStatus.requesting,
        tocState.blocked,
        tocState.hierarchyId
    ]);
    /**
   * Initial load of ToC items
   */ (0, $7fPBF.useEffect)(()=>{
        if (state.hierarchy && state.hierarchy.level === (0, $7Wd8C.eHierarchyLevel).Report) // Check if there are zero items loaded
        {
            if (tocState.tocItems.length === 0 || tocState.hierarchyId !== state.hierarchy.id) (0, $iK0dj.refreshToc)(tocState.tocRequestStatus, setTocRequestStatus, appSettings.backEndUrl, state.hierarchy, dispatch, false);
        }
    }, [
        appSettings.backEndUrl,
        dispatch,
        setTocRequestStatus,
        state.hierarchy,
        tocState.hierarchyId,
        tocState.tocItems.length,
        tocState.tocRequestStatus
    ]);
    /**
   * Create the combined hierarchy/ToC signalR group listener
   */ (0, $7fPBF.useEffect)(()=>{
        /**
     * Handle incoming SignalR group messages for both hierarchy and ToC updates.
     *
     * @param message - Raw JSON string containing the group message payload.
     */ const processSignalRMessage = (message)=>{
            const groupUpdate = JSON.parse(message);
            // Hierarchy comment updates
            if (groupUpdate.groupName === `hie${state.hierarchy?.id}` && groupUpdate.displayName !== signalR?.connection?.connectionId && groupUpdate.displayName !== "Backend" && groupUpdate.text && state.hierarchy?.comments) switch(groupUpdate.messageType){
                case "deleteComment":
                    try {
                        const hieDelCommentId = JSON.parse(groupUpdate.text[0]).id;
                        /* istanbul ignore else */ if (hieDelCommentId) dispatch({
                            operation: (0, $9Jgpw.REMOVE_HIERARCHY_COMMENT),
                            commentId: hieDelCommentId
                        });
                    } catch (error) {
                        // istanbul ignore next
                        console.warn("Error processing delete comment update:", error);
                    }
                    break;
                case "comment":
                    try {
                        const hieUpdateMessage = JSON.parse(groupUpdate.text[0]);
                        /* istanbul ignore else */ if (hieUpdateMessage) dispatch({
                            operation: (0, $9Jgpw.UPDATE_HIERARCHY_COMMENT),
                            comment: hieUpdateMessage
                        });
                    } catch (error) {
                        // istanbul ignore next
                        console.warn("Error processing comment update:", error);
                    }
                    break;
                case "commentsPatch":
                    try {
                        const commentsPatch = JSON.parse(groupUpdate.text[0]);
                        /* istanbul ignore else */ if (commentsPatch) dispatch({
                            operation: (0, $9Jgpw.PATCH_HIERARCHY_COMMENTS),
                            patch: commentsPatch
                        });
                    } catch (error) {
                        // istanbul ignore next
                        console.warn("Error processing comments patch update:", error);
                    }
                    break;
            }
            // ToC updates
            const tocItemsToUpdate = groupUpdate.text && groupUpdate.text[0].startsWith("{") ? JSON.parse(groupUpdate.text[0]) : undefined;
            if (groupUpdate.messageType === "tooBig" && groupUpdate.displayName !== signalR?.connection?.connectionId) {
                dispatch({
                    operation: (0, $6E9u3.SHOW_TOC_NEED_REFRESH)
                });
                return;
            }
            if (state.hierarchy && groupUpdate.displayName !== signalR?.connection?.connectionId && groupUpdate.displayName !== "Backend" && [
                "tocUpdate",
                "tocSave"
            ].includes(groupUpdate.messageType) && tocItemsToUpdate && !receivedMessages.find((r)=>r.messageId === groupUpdate.messageId)) {
                // Update processing
                const newAction = (0, $7KW2P.processActionFromSignal)(groupUpdate.messageId, tocItemsToUpdate);
                setReceivedMessages([
                    ...receivedMessages,
                    newAction.receivedMessage
                ]);
                /* istanbul ignore else */ if (tocItemsToUpdate.hierarchy.id === state.hierarchy.id && groupUpdate.messageType === "tocUpdate") {
                    dispatch(newAction);
                    dispatch({
                        operation: (0, $6E9u3.SAVE_SUCCESS),
                        saveTimeStamp: Date.now()
                    });
                    dispatch({
                        operation: (0, $9Jgpw.SAVE_HIERARCHY_COMPLETED),
                        hierarchy: tocItemsToUpdate.hierarchy
                    });
                } else if (tocItemsToUpdate.hierarchy.id !== state.hierarchy.id && groupUpdate.messageType === "tocSave") {
                    dispatch({
                        operation: (0, $6E9u3.SHOW_TOC_SAVE_ALERT),
                        tocIdFromMessage: tocItemsToUpdate.hierarchy.id
                    });
                    dispatch({
                        operation: (0, $9Jgpw.SET_HIERARCHY_ID),
                        hierarchyId: tocItemsToUpdate.hierarchy.id
                    });
                }
            }
        };
        signalR?.connection?.on("SendMessageToGroup", processSignalRMessage);
    // return () => {
    //   signalR?.connection?.off("SendMessageToGroup", processSignalRMessage);
    // };
    }, [
        dispatch,
        receivedMessages,
        signalR?.connection,
        state.hierarchy
    ]);
    /**
   * Page title based on hierarchy state
   */ const title = state.hierarchy ? `${state.hierarchy.name}` : `Loading hierarchy... ${state.id}`;
    (0, $5UDwf.useDocumentTitle)(title);
    /**
   * Effect to register unsaved changes when the hierarchy state changes
   */ (0, $7fPBF.useEffect)(()=>{
        registerUnsavedChanges("Hierarchy", state.changed);
    }, [
        registerUnsavedChanges,
        state.changed
    ]);
    return {
        title: title,
        saveRequestStatus: saveRequestStatus,
        saveTocRequestStatus: saveTocRequestStatus,
        setCurrentBaseUrl: setCurrentBaseUrl
    };
};

});
parcelRegister("9Zudk", function(module, exports) {

$parcel$export(module.exports, "restoreBackupReport", function () { return $5f95a6182499715d$export$e08e6890a7240833; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $5f95a6182499715d$export$e08e6890a7240833 = async (backEndUrl, hierarchy)=>{
    const url = new URL(`${backEndUrl}Reports/${hierarchy.id}/RestoreBackupVersion?parentTag=${hierarchy.parentTag}`);
    try {
        const response = await (0, $a04va.default).post(url.href);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Restore Backup report failed", error);
    }
};

});

parcelRegister("g1MAF", function(module, exports) {

$parcel$export(module.exports, "saveTocAsMajorVersion", function () { return $8f108e382cda56fc$export$77a8386cbfe89eba; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $8f108e382cda56fc$export$77a8386cbfe89eba = async (backEndUrl, update, controller)=>{
    // Send data
    try {
        const url = `${backEndUrl}Reports/${update.hierarchyId}/SaveTocAsMajorVersion?parentTag=${update.parentTag}`;
        const data = {
            description: update.saveTocDescription,
            hierarchy: update.hierarchy
        };
        const response = await (0, $a04va.default).put(url, data, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("ddsuT", function(module, exports) {

$parcel$export(module.exports, "getLibraries", function () { return $022b55b67435148d$export$4df02d1b89e14240; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $022b55b67435148d$export$4df02d1b89e14240 = async (backEndUrl, hierarchyIds, controller)=>{
    const url = new URL(`${backEndUrl}ClinicalLibrary/batch`);
    try {
        hierarchyIds.forEach((hierarchyId)=>{
            url.searchParams.append("hierarchyIds", hierarchyId);
        });
        const response = await (0, $a04va.default).get(url.href, {
            signal: controller?.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("get libraries failed", error);
    }
};

});

parcelRegister("9bDuL", function(module, exports) {

$parcel$export(module.exports, "updateTocItems", function () { return $0f36f10eceb203d3$export$5f1ade7139d02a99; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $0f36f10eceb203d3$export$5f1ade7139d02a99 = async (backEndUrl, tocItemsUpdate, controller)=>{
    let url = `${backEndUrl}Reports/${tocItemsUpdate.hierarchyId}/UpdateTocItems`;
    /* istanbul ignore else */ if (tocItemsUpdate.deletedItemId) url += `?deletedItemId=${tocItemsUpdate.deletedItemId}`;
    try {
        const response = await (0, $a04va.default).put(url, tocItemsUpdate.items, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Create new Version failed", error);
    }
};

});

parcelRegister("7KW2P", function(module, exports) {

$parcel$export(module.exports, "processActionFromSignal", function () { return $467a5f455db87db2$export$61c43e37ca87fe32; });

var $6E9u3 = parcelRequire("6E9u3");
const $467a5f455db87db2$export$61c43e37ca87fe32 = (messageId, actionSignal)=>{
    const updatedIds = [
        actionSignal.deletedItemId,
        ...actionSignal.items.map((x)=>x.id)
    ].filter((x)=>x !== undefined);
    return {
        operation: (0, $6E9u3.FROM_SIGNALR),
        items: actionSignal.items,
        deletedItemId: actionSignal.deletedItemId,
        receivedMessage: {
            messageId: messageId,
            updateTS: new Date(),
            updatedIds: updatedIds
        }
    };
};

});

parcelRegister("iK0dj", function(module, exports) {

$parcel$export(module.exports, "refreshToc", function () { return $645f3034b97f0049$export$f2e4f3b130330184; });
parcelRequire("P0x5y");
var $30Ra3 = parcelRequire("30Ra3");

var $kLs9x = parcelRequire("kLs9x");

var $6E9u3 = parcelRequire("6E9u3");

var $bVMOy = parcelRequire("bVMOy");
const $645f3034b97f0049$export$f2e4f3b130330184 = async (tocRequest, setTocRequest, backEndUrl, hierarchy, dispatch, force)=>{
    if (!tocRequest.requesting) {
        // Get links
        const tocItems = await (0, $30Ra3.loadWrapper)((0, $kLs9x.loadHierarchyTlfTifos), {
            hierarchyId: hierarchy.id,
            parentTag: hierarchy.parentTag
        }, {
            ...tocRequest,
            requestedId: force ? undefined : tocRequest.requestedId,
            error: false
        }, setTocRequest, backEndUrl);
        // Process successful return
        if (tocItems?.success) {
            const tlfItems = tocItems.data.map((e)=>{
                const tlfItem = {
                    ...e,
                    tocNumber: e.tocNumber,
                    tocLabel: e.tocLabel,
                    tocOrder: e.tocOrder,
                    changed: false,
                    inError: false,
                    changedTitles: e.changedTitles ?? []
                };
                return tlfItem;
            });
            const sections = hierarchy.sections.map((section)=>new (0, $bVMOy.MosaicTocSectionClass)({
                    primaryHierarchyId: hierarchy.id,
                    ...section
                }));
            const returnedItems = [
                ...tlfItems,
                ...sections
            ].sort((a, b)=>(a.tocOrder ?? // istanbul ignore next
                0) - (b.tocOrder ?? // istanbul ignore next
                0));
            dispatch({
                operation: (0, $6E9u3.REFRESH),
                hierarchyId: hierarchy.id,
                items: returnedItems
            });
            return returnedItems;
        }
    }
};

});
parcelRegister("kLs9x", function(module, exports) {

$parcel$export(module.exports, "loadHierarchyTlfTifos", function () { return $0044ffd737818117$export$d5d149c494d12cbc; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $8A5VF = parcelRequire("8A5VF");
const $0044ffd737818117$export$d5d149c494d12cbc = async (backEndUrl, hierarchy, controller)=>{
    const url = `${backEndUrl}TlfItems/Hierarchy/${hierarchy.hierarchyId}/TitlesFootnotes`;
    // Get data
    try {
        const response = await (0, $a04va.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Load hierarchy tifos failed", error);
    }
};

});


parcelRegister("arm5P", function(module, exports) {

$parcel$export(module.exports, "TOC_TLF_ITEM_FILTER", function () { return $ff0ca2356386322d$export$6c1a7d5fdedfef9c; });
$parcel$export(module.exports, "loadTocTlfItemFilterFromStorage", function () { return $ff0ca2356386322d$export$2290e9bbd395f9c8; });
$parcel$export(module.exports, "saveTocTlfItemFilterToStorage", function () { return $ff0ca2356386322d$export$6d1b83c60218a085; });

var $7Wd8C = parcelRequire("7Wd8C");
const $ff0ca2356386322d$export$6c1a7d5fdedfef9c = [
    {
        type: (0, $7Wd8C.eTlfItemType).arsTable,
        label: "ARS tables",
        show: true
    },
    {
        type: (0, $7Wd8C.eTlfItemType).arsListing,
        label: "ARS listings",
        show: true
    },
    {
        type: (0, $7Wd8C.eTlfItemType).figure,
        label: "Interactive figures",
        show: true
    },
    {
        type: (0, $7Wd8C.eTlfItemType).table,
        label: "Tables",
        show: true
    },
    {
        type: (0, $7Wd8C.eTlfItemType).listing,
        label: "Listings",
        show: true
    },
    {
        type: (0, $7Wd8C.eTlfItemType).v1figure,
        label: "Legacy figures",
        show: true
    },
    {
        type: (0, $7Wd8C.eTlfItemType).section,
        label: "Sections",
        show: true
    }
];
// Helper functions for localStorage
const $ff0ca2356386322d$var$TOC_TLF_ITEM_FILTER_STORAGE_KEY = "tocTlfItemFilter";
const $ff0ca2356386322d$export$2290e9bbd395f9c8 = ()=>{
    const stored = localStorage.getItem($ff0ca2356386322d$var$TOC_TLF_ITEM_FILTER_STORAGE_KEY);
    // Use stored as a filter if it exists
    if (stored) {
        const storedTypes = stored.split(",");
        return storedTypes;
    }
    // Default to all shown
    return $ff0ca2356386322d$export$6c1a7d5fdedfef9c.filter((i)=>i.show).map((i)=>i.type);
};
const $ff0ca2356386322d$export$6d1b83c60218a085 = (filter)=>{
    try {
        localStorage.setItem($ff0ca2356386322d$var$TOC_TLF_ITEM_FILTER_STORAGE_KEY, filter.join(","));
    } catch  {
    // Ignore localStorage errors
    }
};

});

parcelRegister("cc07l", function(module, exports) {

$parcel$export(module.exports, "getClinicalLibraryHierarchyIds", function () { return $3bb79157411a2add$export$a538615567ac0ffe; });

var $7Wd8C = parcelRequire("7Wd8C");
const $3bb79157411a2add$export$a538615567ac0ffe = (hierarchy, hierarchyId)=>!hierarchy ? [] : hierarchy.level === (0, $7Wd8C.eHierarchyLevel).Study ? [
        hierarchy.id
    ] : hierarchy.level === (0, $7Wd8C.eHierarchyLevel).Report ? [
        hierarchy.hierarchyLinks.find((link)=>link.hierarchyLevel === (0, $7Wd8C.eHierarchyLevel).Study)?.hierarchyId ?? hierarchy.id
    ] : Array.from(new Set([
        hierarchyId,
        ...hierarchy.hierarchyLinks.filter((link)=>link.hierarchyLevel !== (0, $7Wd8C.eHierarchyLevel).TopLevel).map((link)=>link.hierarchyId)
    ]));

});



parcelRegister("fKICc", function(module, exports) {

$parcel$export(module.exports, "TlfContextProvider", function () { return $67f4f8d91569ff65$export$680e0d87d8e0479e; });

var $bbzbN = parcelRequire("bbzbN");

var $6EAXQ = parcelRequire("6EAXQ");
const $67f4f8d91569ff65$export$680e0d87d8e0479e = ({ children: children, readOnly: readOnly = false })=>{
    (0, $6EAXQ.useTlfEffects)(readOnly);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: children
    });
};
$67f4f8d91569ff65$export$680e0d87d8e0479e.displayName = "TlfContextProvider";

});
parcelRegister("6EAXQ", function(module, exports) {

$parcel$export(module.exports, "useTlfEffects", function () { return $4a2cb659010e8f3b$export$197746ee55933210; });

var $hGHEx = parcelRequire("hGHEx");

var $4PTZu = parcelRequire("4PTZu");

var $7Wd8C = parcelRequire("7Wd8C");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $gxpCl = parcelRequire("gxpCl");

var $hWsmt = parcelRequire("hWsmt");

var $gD2t9 = parcelRequire("gD2t9");

var $6E9u3 = parcelRequire("6E9u3");

var $7KklJ = parcelRequire("7KklJ");

var $dDC3L = parcelRequire("dDC3L");

var $ck5cB = parcelRequire("ck5cB");
const $4a2cb659010e8f3b$export$197746ee55933210 = (readOnly = false)=>{
    const loaderData = (0, $gxpCl.useLoaderData)();
    const tlfData = loaderData?.tlfItem;
    const isSubscribed = loaderData?.isTlfSubscribed ?? false;
    const isTlfNew = loaderData?.isTlfNew ?? false;
    const [searchParams] = (0, $gxpCl.useSearchParams)();
    const { tlfState: tlfState, hierarchyState: hierarchyState, tocState: tocState, dispatch: dispatch } = (0, $hWsmt.useAppSettings)();
    const hierarchy = hierarchyState.hierarchy;
    const signalR = (0, $7fPBF.useContext)((0, $gD2t9.SignalRContext));
    const { navigate: navigate, registerUnsavedChanges: registerUnsavedChanges } = (0, $4PTZu.useUnsavedChanges)("tlf-context");
    (0, $7fPBF.useEffect)(()=>{
        const savedViewMode = (0, $ck5cB.loadTlfViewModeFromStorage)();
        if (savedViewMode.value !== tlfState.tlfViewMode?.value) dispatch({
            operation: (0, $dDC3L.SET_VIEW_MODE),
            calledFrom: "useTlfEffects:InitializeViewMode",
            tlfViewMode: savedViewMode
        });
    }, [
        dispatch,
        tlfState.tlfViewMode?.value
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // Route effects run only when loader data differs from the current TLF state.
        /* istanbul ignore else */ if (tlfData && !(0, $gSkQi.isEqual)(tlfData, tlfState.tlfData)) /* istanbul ignore else */ {
            if (tlfData.id !== tlfState.tlfData?.id || !tlfState.changed && !tlfState.forcePushToParent && tlfState.ixSaveVersion === tlfState.ixTlfDataVersion) dispatch({
                operation: (0, $dDC3L.LOAD_TLF),
                calledFrom: "useTlfEffects:Initial",
                tlfData: tlfData,
                isSubscribed: isSubscribed,
                isTlfNew: isTlfNew,
                readOnly: readOnly
            });
        }
    }, [
        dispatch,
        isSubscribed,
        isTlfNew,
        readOnly,
        tlfState,
        tlfData
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (tlfState.readOnly !== readOnly) dispatch({
            operation: (0, $dDC3L.SET_TLF_READ_ONLY),
            calledFrom: "useTlfEffects:ReadOnly",
            readOnly: readOnly
        });
    }, [
        dispatch,
        readOnly,
        tlfState.readOnly
    ]);
    const signalRGroup = (0, $7fPBF.useMemo)(()=>tlfState.tlfData ? `tlf${tlfState.tlfData.id}` : null, [
        tlfState.tlfData
    ]);
    const [lastSignalRGroupRequest, setLastSignalRGroupRequest] = (0, $7fPBF.useState)("");
    const sendGroupRequest = (0, $7fPBF.useEffectEvent)(async (group)=>{
        signalR?.connectToGroup(group);
        (0, $7fPBF.startTransition)(()=>setLastSignalRGroupRequest(group));
    });
    (0, $7fPBF.useEffect)(()=>{
        // SignalR group requests are made only after the provider reports a connected group.
        /* istanbul ignore else */ if (signalR?.connection?.state === (0, $hGHEx.HubConnectionState).Connected && signalRGroup && lastSignalRGroupRequest !== signalRGroup) sendGroupRequest(signalRGroup);
    }, [
        lastSignalRGroupRequest,
        signalR?.connection?.state,
        signalRGroup
    ]);
    (0, $7fPBF.useEffect)(()=>{
        /* istanbul ignore else */ if (hierarchy && tlfState.tlfData && searchParams.has("searchText") && searchParams.has("blocksToSearch")) {
            const searchText = searchParams.get("searchText");
            const blocksToSearch = searchParams.getAll("blocksToSearch").filter((label)=>Object.values((0, $7Wd8C.SearchableEditorBlocks)).includes(label)).map((label)=>label);
            const editorBlocksSearchPanelStatus = {
                searchText: searchText,
                blocksToSearch: blocksToSearch,
                showSearchPanel: true
            };
            if (!(0, $gSkQi.isEqual)(editorBlocksSearchPanelStatus, tlfState.editorBlocksSearchPanelStatus)) {
                dispatch({
                    operation: (0, $dDC3L.SET_EDITOR_BLOCKS_SEARCH_PANEL),
                    calledFrom: "useTlfEffects:UrlSearchEditorText",
                    editorBlocksSearchPanelStatus: editorBlocksSearchPanelStatus
                });
                navigate((0, $7KklJ.getTlfUrl)(hierarchy, tlfState.tlfData), {
                    replace: true
                });
            }
        }
    }, [
        dispatch,
        hierarchy,
        navigate,
        searchParams,
        tlfState.editorBlocksSearchPanelStatus,
        tlfState.tlfData
    ]);
    (0, $7fPBF.useEffect)(()=>{
        /**
     * Processes a SignalR group message for the current TLF.
     *
     * @param message - Serialised SignalR message containing a TLF update or comment event.
     */ const updateFromSignalR = (message)=>{
            const tlfUpdate = JSON.parse(message);
            const tlfUpdatePatch = tlfUpdate.text && tlfUpdate.text[0].startsWith("{") ? JSON.parse(tlfUpdate.text[0]) : undefined;
            /* istanbul ignore else */ if (tlfUpdatePatch && tlfState.tlfData?.id === tlfUpdatePatch.updatedItemId && tlfUpdate.displayName !== signalR?.connection?.connectionId && tlfUpdate.displayName !== "Backend" && tlfUpdate.messageType === "tlfUpdate" && !tlfState.receivedMessages.some((message)=>message.messageId === tlfUpdate.messageId)) {
                dispatch({
                    operation: (0, $dDC3L.ADD_RECEIVED_MESSAGE),
                    calledFrom: "SignalR:TlfUpdate",
                    receivedMessage: tlfUpdate
                });
                dispatch({
                    operation: (0, $dDC3L.PROCESS_SIGNALR_NOTIFICATION),
                    calledFrom: "SignalR",
                    patch: tlfUpdatePatch.patch
                });
            // Comment updates are only received for the active TLF and its comment collection.
            /* istanbul ignore else */ } else if (tlfUpdate.groupName === `tlf${tlfState.tlfData?.id}` && tlfUpdate.displayName !== signalR?.connection?.connectionId && tlfUpdate.displayName !== "Backend" && tlfUpdate.text && tlfState.tlfData?.comments) switch(tlfUpdate.messageType){
                case "deleteComment":
                    try {
                        const commentId = JSON.parse(tlfUpdate.text[0]).id;
                        /* istanbul ignore else -- valid delete-comment payloads always include an ID. */ if (commentId) dispatch({
                            operation: (0, $dDC3L.REMOVE_TLF_COMMENT),
                            commentId: commentId,
                            calledFrom: "SignalR:DeleteComment"
                        });
                    } catch (error) {
                        console.warn("Error processing delete comment update:", error);
                    }
                    break;
                case "comment":
                    try {
                        const comment = JSON.parse(tlfUpdate.text[0]);
                        /* istanbul ignore else -- valid comment payloads always contain a comment object. */ if (comment) dispatch({
                            operation: (0, $dDC3L.UPDATE_TLF_COMMENT),
                            comment: comment,
                            calledFrom: "SignalR:Comment"
                        });
                    } catch (error) {
                        console.warn("Error processing comment update:", error);
                    }
                    break;
                case "commentsPatch":
                    try {
                        const patch = JSON.parse(tlfUpdate.text[0]);
                        /* istanbul ignore else -- valid patch payloads always contain a patch value. */ if (patch) dispatch({
                            operation: (0, $dDC3L.PATCH_TLF_COMMENTS),
                            calledFrom: "SignalR:CommentsPatch",
                            patch: patch
                        });
                    } catch (error) {
                        console.warn("Error processing comments patch update:", error);
                    }
                    break;
            }
        };
        // The listener is registered only while a TLF item is active.
        /* istanbul ignore else */ if (tlfState.tlfData) {
            signalR?.connection?.on("SendMessageToGroup", updateFromSignalR);
            return ()=>signalR?.connection?.off("SendMessageToGroup");
        }
    }, [
        dispatch,
        signalR?.connection,
        tlfState.receivedMessages,
        tlfState.tlfData
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (tlfState.requestStatus.requesting && tocState.blocked !== "patching") dispatch({
            operation: (0, $6E9u3.SAVING_TOC_ITEM_VIA_TLF)
        });
    }, [
        dispatch,
        tocState.blocked,
        tlfState.requestStatus
    ]);
    (0, $7fPBF.useEffect)(()=>{
        registerUnsavedChanges("TLF", tlfState.changed || tlfState.delayedHierarchyUpdates);
        return ()=>{
            registerUnsavedChanges("TLF", false);
        };
    }, [
        dispatch,
        registerUnsavedChanges,
        tlfState.changed,
        tlfState.delayedHierarchyUpdates
    ]);
    /** Unmount if the component is being removed from the DOM. */ (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            dispatch({
                operation: (0, $dDC3L.CLEAR_TLF),
                calledFrom: "useTlfEffects:Unmount"
            });
        };
    }, [
        dispatch
    ]);
};

});
parcelRegister("ck5cB", function(module, exports) {

$parcel$export(module.exports, "loadTlfViewModeFromStorage", function () { return $ea11e1b90fd96e83$export$a51b555dcf7204b9; });
$parcel$export(module.exports, "saveTlfViewModeToStorage", function () { return $ea11e1b90fd96e83$export$2db8bdcfdf50c331; });
parcelRequire("P0x5y");
var $gMkmM = parcelRequire("gMkmM");
// Helper functions for localStorage
const $ea11e1b90fd96e83$var$TLF_VIEW_MODE_STORAGE_KEY = "tlfViewMode";
const $ea11e1b90fd96e83$export$a51b555dcf7204b9 = ()=>{
    try {
        const stored = localStorage.getItem($ea11e1b90fd96e83$var$TLF_VIEW_MODE_STORAGE_KEY);
        if (stored && (0, $gMkmM.TLF_VIEW_MODES).map((mode)=>mode.value).includes(stored)) return (0, $gMkmM.TLF_VIEW_MODES).find((mode)=>mode.value === stored);
    } catch  {
    // Fall back to default if localStorage is not available or contains invalid data
    }
    return (0, $gMkmM.TLF_VIEW_MODES)[0];
};
const $ea11e1b90fd96e83$export$2db8bdcfdf50c331 = (viewMode)=>{
    try {
        localStorage.setItem($ea11e1b90fd96e83$var$TLF_VIEW_MODE_STORAGE_KEY, viewMode.value);
    } catch  {
    // Ignore localStorage errors
    }
};

});



parcelRegister("6Ue2X", function(module, exports) {

$parcel$export(module.exports, "TocContextProvider", function () { return $cd76dd0b620c04bd$export$610cc28fd797e14f; });

var $bbzbN = parcelRequire("bbzbN");

var $jT8qJ = parcelRequire("jT8qJ");

var $4PTZu = parcelRequire("4PTZu");

var $1AaMV = parcelRequire("1AaMV");

var $hWsmt = parcelRequire("hWsmt");

var $6E9u3 = parcelRequire("6E9u3");
const $cd76dd0b620c04bd$export$610cc28fd797e14f = ({ children: children })=>{
    const { state: state, dispatch: dispatch } = (0, $hWsmt.useTocContext)();
    const { navigate: navigate } = (0, $4PTZu.useUnsavedChanges)("toc-context-provider");
    // TODO: This should be moved to the signal-R provider
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jT8qJ.PopupAlertModal), {
                id: "toc-save-alert",
                show: state.showSaveAlert,
                title: "New Major Version Available",
                message: "The ToC has been updated and saved as a new version. Please close this Popup to redirect.",
                onClose: ()=>{
                    dispatch({
                        operation: (0, $6E9u3.CLOSE_TOC_SAVE_ALERT)
                    });
                    navigate(`/R/${state.tocIdFromMessage}`);
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jT8qJ.PopupAlertModal), {
                id: "toc-need-refresh",
                show: state.showNeedRefresh,
                title: "Large change made",
                message: "The ToC has been updated by someone else/in another browser tab, and needs to be refreshed.",
                onClose: ()=>{
                    dispatch({
                        operation: (0, $6E9u3.CLOSE_TOC_NEED_REFRESH)
                    });
                    (0, $1AaMV.doReload)();
                }
            })
        ]
    });
};
$cd76dd0b620c04bd$export$610cc28fd797e14f.displayName = "TocContextProvider";
var $cd76dd0b620c04bd$export$2e2bcd8739ae039 = $cd76dd0b620c04bd$export$610cc28fd797e14f;

});


parcelRegister("hRJrV", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("6nued")),
    $parcel$import("hDFTo")
]).then(()=>parcelRequire('f0bwV'));

});
parcelRegister("9GZv3", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lhSAP", function(module, exports) {
module.exports = $parcel$import("eBXHv").then(()=>parcelRequire('4V2Sg'));

});

parcelRegister("9U5RK", function(module, exports) {
module.exports = $parcel$import("jgWiR").then(()=>parcelRequire('5RBfg'));

});

parcelRegister("jA3bI", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("caD1X")),
    $parcel$import("3NBg9"),
    $parcel$import("ihcFi")
]).then(()=>parcelRequire('c23kt'));

});

parcelRegister("8ISDu", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("7tyjL")),
    $parcel$import("9N66w")
]).then(()=>parcelRequire('PyqQs'));

});

parcelRegister("eAVG6", function(module, exports) {
module.exports = $parcel$import("9thxK").then(()=>parcelRequire('it9BD'));

});

parcelRegister("lHEd3", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("l74Zm")),
    $parcel$import("4APPu")
]).then(()=>parcelRequire('7ipID'));

});

parcelRegister("aY3gf", function(module, exports) {
module.exports = $parcel$import("iKeQy").then(()=>parcelRequire('7W7hR'));

});

parcelRegister("kyGdZ", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("dyhud")),
    $parcel$import("lFY3j")
]).then(()=>parcelRequire('8VgVF'));

});

parcelRegister("likeG", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("kmI6J")),
    $parcel$import("fwHvr")
]).then(()=>parcelRequire('2xF24'));

});

parcelRegister("cWHH6", function(module, exports) {
module.exports = $parcel$import("gbBln").then(()=>parcelRequire('lMncU'));

});

parcelRegister("cjUIt", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("3TDGB")),
    $parcel$import("jhVYK")
]).then(()=>parcelRequire('hiiZZ'));

});

parcelRegister("itAGi", function(module, exports) {
module.exports = $parcel$import("5KjUQ").then(()=>parcelRequire('4mlnP'));

});

parcelRegister("HdcsK", function(module, exports) {
module.exports = $parcel$import("ctMtP").then(()=>parcelRequire('5LsPu'));

});

parcelRegister("9OqCd", function(module, exports) {
module.exports = $parcel$import("isaub").then(()=>parcelRequire('cBUFV'));

});

parcelRegister("6Wv5Q", function(module, exports) {
module.exports = $parcel$import("dmCTu").then(()=>parcelRequire('XpoOS'));

});

parcelRegister("bLP2B", function(module, exports) {
module.exports = $parcel$import("3MSmQ").then(()=>parcelRequire('6gfLk'));

});

parcelRegister("edhEb", function(module, exports) {
module.exports = $parcel$import("2n3sP").then(()=>parcelRequire('cGT2P'));

});

parcelRegister("8zjnF", function(module, exports) {
module.exports = $parcel$import("5vJ5f").then(()=>parcelRequire('hlONW'));

});

parcelRegister("6vA7u", function(module, exports) {
module.exports = $parcel$import("br6Ib").then(()=>parcelRequire('7TYQ5'));

});

parcelRegister("l3DSi", function(module, exports) {
module.exports = $parcel$import("2Hfk6").then(()=>parcelRequire('kTOrX'));

});

parcelRegister("g8Sep", function(module, exports) {
module.exports = $parcel$import("lV3D7").then(()=>parcelRequire('lFwSw'));

});

parcelRegister("lvvd5", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("9GZv3"))($parcel$resolve("4PQp8")),
    $parcel$import("3NBg9"),
    (parcelRequire("9GZv3"))($parcel$resolve("3TDGB")),
    $parcel$import("jhVYK"),
    $parcel$import("etYwV")
]).then(()=>parcelRequire('dzbVQ'));

});





parcelRegister("jDoW3", function(module, exports) {

$parcel$export(module.exports, "patchTlfItem", function () { return $000b6dd9bd094ed1$export$94d36c67b5728e69; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $dA19B = parcelRequire("dA19B");

var $8A5VF = parcelRequire("8A5VF");

var $7bZh8 = parcelRequire("7bZh8");
const $000b6dd9bd094ed1$export$94d36c67b5728e69 = async (backEndUrl, patchDetails, controller)=>{
    try {
        const patch = {
            op: "replace",
            path: `/${patchDetails.key}`,
            value: patchDetails.newValue
        };
        let url = `${backEndUrl}TlfItems/${patchDetails.id}`;
        if (patchDetails.azsolId && (0, $dA19B.isValidUriString)(patchDetails.azsolId)) url += `/${patchDetails.azsolId}`;
        const response = await (0, $a04va.default).patch(url, [
            patch
        ], {
            headers: {
                "Content-Type": "application/json-patch+json"
            },
            signal: controller.signal
        });
        return {
            success: true,
            data: (0, $7bZh8.tlfPreProcess)(response.data)
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Patch TLF item failed", error);
    }
};

});

parcelRegister("1Kj4K", function(module, exports) {

$parcel$export(module.exports, "saveTlfItem", function () { return $0f91e48a2b740362$export$c617bed2b10fc78d; });
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $dA19B = parcelRequire("dA19B");

var $7Wd8C = parcelRequire("7Wd8C");

var $8A5VF = parcelRequire("8A5VF");

var $7bZh8 = parcelRequire("7bZh8");
const $0f91e48a2b740362$export$c617bed2b10fc78d = async (backEndUrl, saveDetails, controller)=>{
    try {
        let res;
        const tlfItem = saveDetails.tlfItem;
        const basedOnTlfLookup = {
            id: "",
            azsolId: "",
            version: -1
        };
        /* istanbul ignore else */ if (saveDetails.tlfItem.relationships.some((r)=>r.linkType === (0, $7Wd8C.eLinkType).BasedOn)) {
            const basedOnLink = saveDetails.tlfItem.relationships.filter((r)=>r.linkType === (0, $7Wd8C.eLinkType).BasedOn)[0];
            basedOnTlfLookup.azsolId = basedOnLink.azsolId;
            basedOnTlfLookup.version = basedOnLink.version;
            basedOnTlfLookup.id = basedOnLink.linkId;
        }
        // Create
        if (saveDetails.newDetails) {
            const newDetails = saveDetails.newDetails;
            // Get template reference
            const newRels = [];
            const copiedFromTlfLookup = {
                id: "",
                azsolId: "",
                version: -1
            };
            copiedFromTlfLookup.id = saveDetails.tlfItem.id;
            copiedFromTlfLookup.azsolId = saveDetails.tlfItem.azsolId;
            copiedFromTlfLookup.version = saveDetails.tlfItem.version;
            const newTlfItem = {
                azsolId: newDetails.azsolId,
                additionalInformation: newDetails.additionalInformation,
                type: tlfItem.type,
                domain: newDetails.domain,
                crystalReference: tlfItem.crystalReference ?? "",
                programName: tlfItem.programName ?? "",
                suffix: tlfItem.suffix ?? "",
                outputName: tlfItem.outputName ?? "",
                outputType: tlfItem.outputType ?? (0, $7Wd8C.eTlfOutputType).Rtf,
                sapReference: tlfItem.sapReference,
                standardsNotes: tlfItem.standardsNotes,
                programmerNotes: tlfItem.programmerNotes,
                titles: tlfItem.titles,
                pageBy: tlfItem.pageBy,
                body: tlfItem.body,
                footnotes: tlfItem.footnotes,
                singles: tlfItem.singles,
                primaryHierarchyId: newDetails.primaryHierarchyId,
                relationships: newRels,
                tocOrder: tlfItem.tocOrder,
                tocNumber: tlfItem.tocNumber,
                copiedFromTlfLookup: copiedFromTlfLookup,
                basedOnTlfLookup: basedOnTlfLookup,
                copiedFromHierarchyLevel: saveDetails.copiedFromHierarchyLevel,
                tlfTags: tlfItem.tlfTags?.map((tag)=>({
                        ...tag,
                        tagId: tag.tagId ? tag.tagId : crypto.randomUUID()
                    })),
                analysisSetId: tlfItem.analysisSetId
            };
            res = await (0, $a04va.default).post(`${backEndUrl}TlfItems`, newTlfItem, {
                signal: controller.signal
            });
        } else {
            // Update body depending on type
            const newBody = tlfItem.body;
            /* istanbul ignore else */ if (tlfItem.type === (0, $7Wd8C.eTlfItemType).table || tlfItem.type === (0, $7Wd8C.eTlfItemType).listing) {
                newBody.changedColumns = [];
                newBody.changedRowGroups = [];
            }
            const updateTlfItem = {
                additionalInformation: tlfItem.additionalInformation,
                type: tlfItem.type,
                domain: tlfItem.domain,
                crystalReference: tlfItem.crystalReference ?? "",
                coreTrafficLightSwitch: tlfItem.coreTrafficLightSwitch,
                programName: tlfItem.programName ?? "",
                suffix: tlfItem.suffix ?? "",
                outputName: tlfItem.outputName ?? "",
                outputType: tlfItem.outputType ?? (0, $7Wd8C.eTlfOutputType).Rtf,
                sapReference: tlfItem.sapReference,
                standardsNotes: tlfItem.standardsNotes,
                programmerNotes: tlfItem.programmerNotes,
                titles: tlfItem.titles,
                pageBy: tlfItem.pageBy,
                body: newBody,
                footnotes: tlfItem.footnotes,
                singles: tlfItem.singles,
                shellMinorVersion: tlfItem.primaryHierarchyType === (0, $7Wd8C.eHierarchy).Report && tlfItem.shellMinorVersion !== undefined ? tlfItem.shellMinorVersion + 1 : tlfItem.shellMinorVersion,
                analysisSetId: tlfItem.analysisSetId
            };
            res = await (0, $a04va.default).put(`${backEndUrl}TlfItems/${tlfItem.id}${(0, $dA19B.isValidUriString)(tlfItem.azsolId) ? `/${tlfItem.azsolId}` : ""}`, updateTlfItem, {
                signal: controller.signal
            });
        }
        return {
            success: true,
            data: (0, $7bZh8.tlfPreProcess)(res.data)
        };
    } catch (error) {
        return (0, $8A5VF.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("3cBoK", function(module, exports) {

$parcel$export(module.exports, "toIndexDto", function () { return $a715a77e8f16202c$export$ac1fa944a44ed3d4; });
const $a715a77e8f16202c$export$ac1fa944a44ed3d4 = (tlfItem)=>({
        id: tlfItem.id,
        azsolId: tlfItem.azsolId,
        version: tlfItem.version,
        primaryHierarchyId: tlfItem.primaryHierarchyId,
        primaryHierarchyLevel: tlfItem.primaryHierarchyLevel,
        primaryHierarchyName: tlfItem.primaryHierarchyName,
        primaryHierarchyType: tlfItem.primaryHierarchyType,
        taPrefix: tlfItem.taPrefix,
        projectCode: tlfItem.projectCode,
        dNumber: tlfItem.dNumber,
        hierarchyLinks: tlfItem.hierarchyLinks,
        singles: tlfItem.singles,
        tocOrder: tlfItem.tocOrder,
        tocNumber: tlfItem.tocNumber,
        tocLabel: tlfItem.tocLabel,
        tocReleaseStatus: tlfItem.tocReleaseStatus,
        tocOriginTrafficLight: tlfItem.tocOriginTrafficLight,
        coreTrafficLight: tlfItem.coreTrafficLight,
        coreTrafficLightSwitch: tlfItem.coreTrafficLightSwitch,
        additionalInformation: tlfItem.additionalInformation,
        type: tlfItem.type,
        domain: tlfItem.domain,
        tlfTags: tlfItem.tlfTags,
        releaseDate: tlfItem.releaseDate,
        decommissionDate: tlfItem.decommissionDate,
        releaseStatus: tlfItem.releaseStatus,
        relationships: tlfItem.relationships,
        isBackupVersion: tlfItem.isBackupVersion,
        lastUpdatedFromHistory: tlfItem.lastUpdatedFromHistory
    });

});



parcelRegister("gBRiD", function(module, exports) {

$parcel$export(module.exports, "getClinicalDataWithInheritance", function () { return $0a8cae561cf43cb1$export$35e718bcf13f7e1a; });
const $0a8cae561cf43cb1$export$35e718bcf13f7e1a = (parentClinicalDatasets, parentClinicalCodeLists, parentClinicalValueLists, parentClinicalComments, parentClinicalMethods, parentClinicalWhereClauses, currentLibrary)=>{
    if (!currentLibrary) return {
        clinicalDatasets: parentClinicalDatasets,
        clinicalCodeLists: parentClinicalCodeLists,
        clinicalValueLists: parentClinicalValueLists,
        clinicalComments: parentClinicalComments,
        clinicalMethods: parentClinicalMethods,
        clinicalWhereClauses: parentClinicalWhereClauses
    };
    // merge parent data with current data (current takes precedence)
    return {
        clinicalDatasets: $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData(parentClinicalDatasets, currentLibrary.clinicalDatasets, (d)=>d.oid),
        clinicalCodeLists: $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData(parentClinicalCodeLists, currentLibrary.clinicalCodeLists, (c)=>c.oid),
        clinicalValueLists: $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData(parentClinicalValueLists, currentLibrary.clinicalValueLists, (v)=>v.oid),
        clinicalComments: $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData(parentClinicalComments, currentLibrary.clinicalComments, (c)=>c.oid),
        clinicalMethods: $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData(parentClinicalMethods, currentLibrary.clinicalMethods, (m)=>m.oid),
        clinicalWhereClauses: $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData(parentClinicalWhereClauses, currentLibrary.clinicalWhereClauses, (w)=>w.oid)
    };
};
/**
 * Efficiently merges inherited (parent) items with current items, ensuring current items override parent duplicates.
 *
 * This function uses Set-based deduplication for optimal performance when dealing with large datasets.
 * The merging strategy places current items first to ensure they take precedence, followed by non-duplicate
 * parent items, preserving the original order within each group.
 *
 * @param parentItems - Items from parent hierarchical levels to be inherited
 * @param currentItems - Items from current library that take precedence over parent items
 * @param getKey - Function to extract a unique identifier (typically OID) from each item for deduplication
 * @returns Combined array with current items first, followed by inherited parent items with no duplicates based on key
 */ const $0a8cae561cf43cb1$var$mergeWithInheritedClinicalData = (parentItems, currentItems, getKey)=>{
    const currentItemKeys = new Set(currentItems.map(getKey));
    const inherited = parentItems.filter((p)=>!currentItemKeys.has(getKey(p)));
    return [
        ...currentItems,
        ...inherited
    ];
};

});

parcelRegister("etWjK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8b102c8f537fb9a$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("ecgdb");
var $9GY4V = parcelRequire("9GY4V");

var $jbhqg = parcelRequire("jbhqg");

var $jbn4d = parcelRequire("jbn4d");

var $8fIUF = parcelRequire("8fIUF");

var $g9xqw = parcelRequire("g9xqw");

var $e2eQx = parcelRequire("e2eQx");

var $gYgRC = parcelRequire("gYgRC");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $a8b102c8f537fb9a$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $e2eQx.default), ...props } = (0, $9GY4V.default)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'alert');
    const handleClose = (0, $jbhqg.default)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $e2eQx.default) : transition;
    const alert = /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gYgRC.default), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$a8b102c8f537fb9a$var$Alert.displayName = 'Alert';
var $a8b102c8f537fb9a$export$2e2bcd8739ae039 = Object.assign($a8b102c8f537fb9a$var$Alert, {
    Link: (0, $g9xqw.default),
    Heading: (0, $8fIUF.default)
});

});
parcelRegister("8fIUF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6022903995da320f$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $kmq8T = parcelRequire("kmq8T");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $6022903995da320f$var$DivStyledAsH4 = (0, $kmq8T.default)('h4');
$6022903995da320f$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $6022903995da320f$var$AlertHeading = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $6022903995da320f$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$6022903995da320f$var$AlertHeading.displayName = 'AlertHeading';
var $6022903995da320f$export$2e2bcd8739ae039 = $6022903995da320f$var$AlertHeading;

});

parcelRegister("g9xqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc276a75d8690d82$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $hq4kX = parcelRequire("hq4kX");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $bc276a75d8690d82$var$AlertLink = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $hq4kX.default), ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$bc276a75d8690d82$var$AlertLink.displayName = 'AlertLink';
var $bc276a75d8690d82$export$2e2bcd8739ae039 = $bc276a75d8690d82$var$AlertLink;

});


parcelRegister("ifbDg", function(module, exports) {

$parcel$export(module.exports, "AnnotationActionButtons", function () { return $6f7f0c4781f49215$export$622a0c576a88d8fd; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");
const $6f7f0c4781f49215$export$622a0c576a88d8fd = ({ isUnchanged: isUnchanged, isFormValid: isFormValid, isClinicalLibraryAvailable: isClinicalLibraryAvailable, disabled: disabled = false, onReset: onReset, onCancel: onCancel, onSave: onSave, isPending: isPending })=>{
    const saveButtonText = "Save";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "d-flex justify-content-between w-100 mt-2 pt-2 border-top",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                    id: "annotation-reset-button",
                    variant: "outline-secondary",
                    className: "me-2",
                    onClick: onReset,
                    disabled: disabled || isUnchanged,
                    size: "sm",
                    children: "Reset"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: "annotation-cancel-button",
                        variant: "secondary",
                        className: "me-2",
                        onClick: onCancel,
                        size: "sm",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                        id: "annotation-save-button",
                        variant: "primary",
                        onClick: onSave,
                        disabled: disabled || !isFormValid || !isClinicalLibraryAvailable || isUnchanged || isPending,
                        size: "sm",
                        requestStatus: isPending ? {
                            requesting: true,
                            error: false
                        } : undefined,
                        pauseCoverText: "Saving...",
                        children: saveButtonText
                    })
                ]
            })
        ]
    });
};
$6f7f0c4781f49215$export$622a0c576a88d8fd.displayName = "AnnotationActionButtons";

});

parcelRegister("8rXpb", function(module, exports) {

$parcel$export(module.exports, "AnnotationNavigationHeader", function () { return $8ea7fee4677284de$export$268e1f64317e140; });

var $bbzbN = parcelRequire("bbzbN");

var $7TsGo = parcelRequire("7TsGo");
const $8ea7fee4677284de$export$268e1f64317e140 = ({ currentClauseIndex: currentClauseIndex, totalClauseCount: totalClauseCount, canRemoveClause: canRemoveClause, canAddNewClause: canAddNewClause, disabled: disabled = false, onPrevious: onPrevious, onNext: onNext, onRemove: onRemove, onAdd: onAdd })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "d-flex justify-content-between align-items-center mb-3",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("strong", {
                    children: [
                        "Annotation ",
                        currentClauseIndex + 1,
                        " of ",
                        totalClauseCount
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7TsGo.AnnotationNavigationButtons), {
                currentClauseIndex: currentClauseIndex,
                totalClauseCount: totalClauseCount,
                canRemoveClause: canRemoveClause,
                canAddNewClause: canAddNewClause,
                disabled: disabled,
                onPrevious: onPrevious,
                onNext: onNext,
                onRemove: onRemove,
                onAdd: onAdd
            })
        ]
    });
};
$8ea7fee4677284de$export$268e1f64317e140.displayName = "AnnotationNavigationHeader";

});
parcelRegister("7TsGo", function(module, exports) {

$parcel$export(module.exports, "AnnotationNavigationButtons", function () { return $d7a0e990f00d64c3$export$968ba00b62ff271d; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $8HzIe = parcelRequire("8HzIe");

var $87hiV = parcelRequire("87hiV");
var $cnmTv = parcelRequire("cnmTv");
var $4tHM3 = parcelRequire("4tHM3");
const $d7a0e990f00d64c3$export$968ba00b62ff271d = ({ currentClauseIndex: currentClauseIndex, totalClauseCount: totalClauseCount, canRemoveClause: canRemoveClause, canAddNewClause: canAddNewClause, disabled: disabled = false, onPrevious: onPrevious, onNext: onNext, onRemove: onRemove, onAdd: onAdd })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                id: "annotation-prev-clause",
                variant: "outline-secondary",
                className: "me-2",
                onClick: onPrevious,
                disabled: disabled || currentClauseIndex === 0,
                size: "sm",
                title: "Previous clause",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $87hiV.default), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                id: "annotation-next-clause",
                variant: "outline-secondary",
                className: "me-2",
                onClick: onNext,
                disabled: disabled || currentClauseIndex >= totalClauseCount - 1,
                size: "sm",
                title: "Next clause",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cnmTv.default), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                id: "annotation-remove-clause",
                variant: "outline-danger",
                className: "me-2",
                onClick: onRemove,
                disabled: disabled || !canRemoveClause,
                size: "sm",
                title: "Remove current clause",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4tHM3.default), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8HzIe.AsyncButton), {
                id: "annotation-add-clause",
                variant: "primary",
                onClick: ()=>onAdd("AND"),
                disabled: disabled || !canAddNewClause,
                size: "sm",
                title: canAddNewClause ? "Add new clause" : "Complete current clause first",
                children: "AND"
            })
        ]
    });
};
$d7a0e990f00d64c3$export$968ba00b62ff271d.displayName = "AnnotationNavigationButtons";

});


parcelRegister("24HWe", function(module, exports) {

$parcel$export(module.exports, "AnnotationNotesField", function () { return $df7e450713584136$export$b445cc7ea75978cd; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $9Er6k = parcelRequire("9Er6k");
const $df7e450713584136$export$b445cc7ea75978cd = ({ value: value, onChange: onChange, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
        id: "notes-textarea",
        label: "Additional notes",
        labelWidth: "auto",
        maxWidthCols: 12,
        value: value,
        setValue: onChange,
        type: "textarea",
        rows: 2,
        placeholder: "Enter any additional notes or context for this annotation...",
        disabled: disabled
    });
};
$df7e450713584136$export$b445cc7ea75978cd.displayName = "AnnotationNotesField";

});

parcelRegister("c1NeV", function(module, exports) {

$parcel$export(module.exports, "AnnotationPreview", function () { return $61962af72fc91e0b$export$e34b0d3474931596; });

var $bbzbN = parcelRequire("bbzbN");

var $etWjK = parcelRequire("etWjK");
const $61962af72fc91e0b$export$e34b0d3474931596 = ({ previewText: previewText })=>{
    const isEmpty = !previewText || previewText === "No annotation clauses configured";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("h6", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                    children: "Annotation Preview"
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $etWjK.default), {
                variant: isEmpty ? "light" : "info",
                className: "mb-3",
                children: isEmpty ? /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                    className: "text-muted",
                    children: "Complete the annotation expression to see preview"
                }) : previewText
            })
        ]
    });
};
$61962af72fc91e0b$export$e34b0d3474931596.displayName = "AnnotationPreview";

});

parcelRegister("9vpQh", function(module, exports) {

$parcel$export(module.exports, "CompanionVariableControl", function () { return $4ef06ac45ca7833a$export$2537be9a62cfd173; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $ktLOc = parcelRequire("ktLOc");
var $7Tnbh = parcelRequire("7Tnbh");

var $8d4Ob = parcelRequire("8d4Ob");

var $jDzCC = parcelRequire("jDzCC");
const $4ef06ac45ca7833a$export$2537be9a62cfd173 = ({ datasets: datasets, primaryDataset: primaryDataset, companionVariables: companionVariables, onChange: onChange, disabled: disabled = false })=>{
    const hasPrimaryVariable = Boolean(primaryDataset);
    /**
   * Get variables available for companion selection (from primary dataset only)
   */ const dataset = datasets.find((ds)=>ds.name === primaryDataset);
    const variableOptions = dataset ? dataset.clinicalVariables.map((v)=>({
            value: `${primaryDataset}.${v.name}`
        })) : [
        {
            value: "No variables available"
        }
    ];
    /**
   * Get available companion types (exclude already used types)
   *
   * @param currentType - The current type of the companion being edited, excluded from used types to allow re-selection
   */ const getAvailableTypes = (currentType)=>{
        const allTypes = [
            "Order",
            "Label",
            "Unit"
        ];
        const usedTypes = companionVariables.map((c)=>c.type).filter((t)=>t !== currentType);
        return allTypes.filter((t)=>!usedTypes.includes(t));
    };
    /**
   * Handler for adding a new companion variable
   */ const handleAdd = ()=>{
        const availableTypes = getAvailableTypes();
        onChange({
            companionVariables: [
                ...companionVariables,
                {
                    variable: "",
                    type: availableTypes[0]
                }
            ]
        });
    };
    /**
   * Removes a companion variable from the list based on its type.
   *
   * @param type - Companion type to remove (Order, Label, or Unit)
   */ const handleRemove = (type)=>{
        onChange({
            companionVariables: companionVariables.filter((c)=>c.type !== type)
        });
    };
    /**
   * Updates the selected variable for a specific companion type.
   * Ignores placeholder values and updates only the matching companion.
   *
   * @param type - Companion type whose variable selection is being changed
   * @param value - New variable name in format "dataset.variableName"
   */ const handleVariableChange = (type, value)=>{
        if (value === "No variables available") return;
        onChange({
            companionVariables: companionVariables.map((c)=>c.type === type ? {
                    ...c,
                    variable: value
                } : c)
        });
    };
    /**
   * Changes a companion's type while preserving its variable selection.
   * Used when user selects a different type from the dropdown.
   *
   * @param oldType - Current type of the companion being modified
   * @param newType - New type to assign to the companion
   */ const handleTypeChange = (oldType, newType)=>{
        onChange({
            companionVariables: companionVariables.map((c)=>c.type === oldType ? {
                    ...c,
                    type: newType
                } : c)
        });
    };
    /**
   * Retrieves the selected variable name for a specific companion type.
   *
   * @param type - Companion type to look up
   * @returns Selected variable name for the companion, or empty string if not found
   */ const getVariableValue = (type)=>{
        return companionVariables.find((c)=>c.type === type)?.variable ?? // istanbul ignore next -- Default only hit if companion not in array (impossible in practice)
        "";
    };
    /**
   * Handles reordering companions via drag and drop.
   * Updates the companions array to reflect the new order.
   *
   * @param event - Drag end event containing active and target items
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore next -- Defensive check: over is always set by the mock in tests */ if (!over || active.id === over.id) return;
        const oldIndex = companionVariables.findIndex((c)=>c.type === active.id);
        const newIndex = companionVariables.findIndex((c)=>c.type === over.id);
        /* istanbul ignore next -- Defensive check: IDs are always valid companion types in practice */ if (oldIndex === -1 || newIndex === -1) return;
        const newCompanions = [
            ...companionVariables
        ];
        const [removed] = newCompanions.splice(oldIndex, 1);
        newCompanions.splice(newIndex, 0, removed);
        onChange({
            companionVariables: newCompanions
        });
    };
    // Check if all existing companions have variables selected
    const allCompanionsHaveVariables = companionVariables.every((c)=>c.variable !== "");
    const canAddMore = companionVariables.length < 2 && hasPrimaryVariable && allCompanionsHaveVariables && !disabled;
    const canMove = companionVariables.length > 1 && !disabled;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            companionVariables.length > 0 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Label, {
                className: "mb-2",
                children: [
                    "Companion Variable",
                    companionVariables.length > 1 ? "s" : ""
                ]
            }),
            companionVariables.length > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7Tnbh.SortableListHolder), {
                canMove: canMove,
                handleDragEnd: handleDragEnd,
                showBorder: false,
                items: companionVariables.map((companion, index)=>({
                        id: companion.type,
                        element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jDzCC.CompanionRow), {
                            type: companion.type,
                            index: index,
                            variableOptions: variableOptions,
                            getVariableValue: getVariableValue,
                            getAvailableTypes: getAvailableTypes,
                            handleVariableChange: handleVariableChange,
                            handleTypeChange: handleTypeChange,
                            handleRemove: handleRemove,
                            disabled: disabled
                        })
                    }))
            }),
            companionVariables.length < 2 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ktLOc.AddLinkButton), {
                label: "Companion Variable",
                onClick: handleAdd,
                disabled: !canAddMore
            })
        ]
    });
};
$4ef06ac45ca7833a$export$2537be9a62cfd173.displayName = "CompanionVariableControl";

});
parcelRegister("jDzCC", function(module, exports) {

$parcel$export(module.exports, "CompanionRow", function () { return $9e150e529621a600$export$ab591e56aff52091; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $isQD0 = parcelRequire("isQD0");
var $k6Ixm = parcelRequire("k6Ixm");

var $b6fw7 = parcelRequire("b6fw7");
var $h1xuz = parcelRequire("h1xuz");
var $kYoG1 = parcelRequire("kYoG1");

var $jVHe9 = parcelRequire("jVHe9");
const $9e150e529621a600$export$ab591e56aff52091 = ({ type: type, index: index, variableOptions: variableOptions, getVariableValue: getVariableValue, getAvailableTypes: getAvailableTypes, handleVariableChange: handleVariableChange, handleTypeChange: handleTypeChange, handleRemove: handleRemove, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $kYoG1.default), {
        className: "mb-2",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                sm: 6,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k6Ixm.ControlTypeAhead), {
                    id: `companion-variable-${index}`,
                    label: "",
                    labelWidth: 0,
                    value: getVariableValue(type),
                    setValue: (value)=>handleVariableChange(type, value),
                    maxWidthCols: 12,
                    availableList: variableOptions,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                sm: 5,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                    id: `companion-type-${index}`,
                    label: `Companion ${index + 1} type`,
                    labelWidth: 0,
                    maxWidthCols: 12,
                    value: type,
                    options: getAvailableTypes(type),
                    setValue: (value)=>handleTypeChange(type, value),
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h1xuz.default), {
                sm: 1,
                className: "d-flex justify-content-center align-items-start",
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b6fw7.default), {
                    variant: "link",
                    className: "p-0 text-danger",
                    style: {
                        paddingTop: "0.15rem"
                    },
                    onClick: ()=>handleRemove(type),
                    disabled: disabled,
                    "aria-label": `Remove companion ${index + 1}`,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jVHe9.default), {
                        size: 20
                    })
                })
            })
        ]
    });
};
$9e150e529621a600$export$ab591e56aff52091.displayName = "CompanionRow";

});


parcelRegister("gPXbA", function(module, exports) {

$parcel$export(module.exports, "getContextDisplayText", function () { return $23367970183af49f$export$4cd279dff103abad; });
parcelRequire("P0x5y");
var $feHBz = parcelRequire("feHBz");
const $23367970183af49f$export$4cd279dff103abad = (location)=>{
    if (!location) return "";
    switch(location.position){
        case (0, $feHBz.AitTablePosition).table:
            return "";
        case (0, $feHBz.AitTablePosition).column:
            return `at column-${location.originalColumn + 1}`;
        case (0, $feHBz.AitTablePosition).headerRow:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        case (0, $feHBz.AitTablePosition).headerCell:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        case (0, $feHBz.AitTablePosition).bodyRowGroup:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1}`;
        case (0, $feHBz.AitTablePosition).bodyRow:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        case (0, $feHBz.AitTablePosition).bodyCell:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        default:
            return "";
    }
};

});

parcelRegister("iNYVQ", function(module, exports) {

$parcel$export(module.exports, "PrimaryVariableSelector", function () { return $e9289bb8f90e714e$export$e0073dc7cfd64d35; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $k6Ixm = parcelRequire("k6Ixm");
const $e9289bb8f90e714e$export$e0073dc7cfd64d35 = ({ datasets: datasets, selectedValue: selectedValue, onChange: onChange, disabled: disabled = false })=>{
    /**
   * Generate list of all variables in "dataset.variable" format
   */ const options = datasets.flatMap((ds)=>{
        const vars = ds.clinicalVariables.map((v)=>v.name);
        return vars.map((v)=>({
                value: `${ds.name}.${v}`
            }));
    });
    const variableOptions = options.length > 0 ? options : [
        {
            value: "No variables available"
        }
    ];
    /**
   * Handler for primary variable selection
   *
   * @param value - Selected variable value in "dataset.variable" format
   */ const handleChange = (value)=>{
        if (value !== "No variables available") onChange(value);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $k6Ixm.ControlTypeAhead), {
        id: "primary-variable-select",
        label: "Primary Variable",
        labelWidth: 3,
        value: selectedValue,
        setValue: handleChange,
        maxWidthCols: 12,
        availableList: variableOptions,
        disabled: disabled
    });
};
$e9289bb8f90e714e$export$e0073dc7cfd64d35.displayName = "PrimaryVariableSelector";

});

parcelRegister("kWPAB", function(module, exports) {

$parcel$export(module.exports, "TerminologySelector", function () { return $455ba7d4b511e279$export$20cdecc32a0af66c; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $9Er6k = parcelRequire("9Er6k");
var $isQD0 = parcelRequire("isQD0");
var $creWj = parcelRequire("creWj");

var $7fPBF = parcelRequire("7fPBF");

var $8d4Ob = parcelRequire("8d4Ob");
const $455ba7d4b511e279$export$20cdecc32a0af66c = ({ formState: formState, codeLists: codeLists, comparatorTypes: comparatorTypes, updateFormField: updateFormField, disabled: disabled = false })=>{
    const codes = (0, $7fPBF.useMemo)(()=>{
        if (!formState.selectedTerminology) return [];
        const codeList = codeLists.find((cl)=>cl.name === formState.selectedTerminology);
        return codeList?.clinicalCodes ?? [];
    }, [
        codeLists,
        formState.selectedTerminology
    ]);
    const termOptions = (0, $7fPBF.useMemo)(()=>{
        const mappedCodeList = formState.selectedVariable?.clinicalCodeListId ? codeLists.find((cl)=>cl.id === formState.selectedVariable.clinicalCodeListId) : undefined;
        if (!mappedCodeList) return [];
        return [
            {
                value: "",
                label: "Select term..."
            },
            ...codes.map((code)=>({
                    value: code.codedValue,
                    label: `${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}`
                }))
        ];
    }, [
        formState.selectedVariable,
        codeLists,
        codes
    ]);
    const handleComparatorChange = (0, $7fPBF.useCallback)((comparatorName)=>{
        updateFormField("comparator", comparatorName);
    }, [
        updateFormField
    ]);
    const handleTermChange = (0, $7fPBF.useCallback)((codedValue)=>{
        updateFormField("value", codedValue);
    }, [
        updateFormField
    ]);
    const handleValueEntry = (0, $7fPBF.useCallback)((value)=>{
        updateFormField("value", value);
    }, [
        updateFormField
    ]);
    const handleGroupValueChange = (0, $7fPBF.useCallback)((selectedValues)=>{
        const codedValues = selectedValues.map((displayValue)=>{
            const matchingCode = codes.find((code)=>`${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}` === displayValue);
            // istanbul ignore next
            return matchingCode?.codedValue ?? displayValue;
        }).filter((v)=>v !== "");
        updateFormField("value", codedValues.join("\n"));
    }, [
        updateFormField,
        codes
    ]);
    const handleGroupTextEntry = (0, $7fPBF.useCallback)((value)=>{
        updateFormField("value", value);
    }, [
        updateFormField
    ]);
    const comparatorOptions = comparatorTypes.map((comparator)=>({
            value: comparator.name,
            label: comparator.denotation
        }));
    const selectedComparatorType = comparatorTypes.find((c)=>c.name === formState.comparator);
    const rhsType = selectedComparatorType?.rhsType ?? "None";
    const currentGroupValues = (0, $7fPBF.useMemo)(()=>{
        if (rhsType !== "Group" || !formState.value) return [];
        const storedValues = formState.value.split("\n").map((v)=>v.trim()).filter((v)=>v !== "");
        return storedValues.map((codedValue)=>{
            const code = codes.find((c)=>c.codedValue === codedValue);
            return code ? `${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}` : codedValue;
        });
    }, [
        rhsType,
        formState.value,
        codes
    ]);
    const groupTermOptions = (0, $7fPBF.useMemo)(()=>{
        return codes.map((code)=>`${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}`);
    }, [
        codes
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                id: "comparator-select",
                label: "Comparator",
                labelWidth: 3,
                value: formState.comparator ?? "",
                disabled: disabled || !formState.selectedVariable,
                options: [
                    {
                        value: "",
                        label: "None"
                    },
                    ...comparatorOptions
                ],
                setValue: handleComparatorChange
            }),
            formState.selectedTerminology && formState.comparator && rhsType !== "None" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                id: "mapped-code-list",
                label: "Terminology",
                labelWidth: 3,
                value: `${formState.selectedTerminology}`,
                disabled: disabled
            }),
            formState.comparator && rhsType !== "None" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                children: rhsType === "Group" ? formState.selectedTerminology ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8d4Ob.default).Group, {
                    className: "row mb-2",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d4Ob.default).Label, {
                            column: true,
                            sm: 3,
                            htmlFor: "group-value-tags",
                            children: "Values"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "col-sm-9",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $creWj.ControlTags), {
                                availableOptions: groupTermOptions,
                                selectedTags: currentGroupValues,
                                onSelectionChange: handleGroupValueChange,
                                placeholder: "Select values...",
                                disabled: disabled || !formState.selectedTerminology
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                    id: "group-value-textarea",
                    label: "Values",
                    labelWidth: 3,
                    value: formState.value ?? "",
                    setValue: handleGroupTextEntry,
                    type: "textarea",
                    rows: 4,
                    allowCarriageReturn: true,
                    disabled: disabled || !formState.selectedVariable,
                    subText: "Enter each value on a new line (press Enter between values)"
                }) : formState.selectedTerminology ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $isQD0.Control211), {
                    id: "term-select",
                    label: "Value",
                    labelWidth: 3,
                    value: formState.value ?? "",
                    disabled: disabled || !formState.selectedTerminology,
                    options: termOptions,
                    setValue: handleTermChange
                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9Er6k.Control210), {
                    id: "value-text",
                    label: "Value",
                    labelWidth: 3,
                    value: formState.value ?? "",
                    setValue: handleValueEntry,
                    disabled: disabled || !formState.selectedVariable
                })
            })
        ]
    });
};
$455ba7d4b511e279$export$20cdecc32a0af66c.displayName = "TerminologySelector";

});

parcelRegister("6oeuS", function(module, exports) {

$parcel$export(module.exports, "updateTableDataWithAnnotations", function () { return $269393371d1d0c5e$export$77f22004624c7b1c; });
parcelRequire("P0x5y");
var $feHBz = parcelRequire("feHBz");
const $269393371d1d0c5e$export$77f22004624c7b1c = (tableData, location, annotation)=>{
    switch(location.position){
        case (0, $feHBz.AitTablePosition).table:
            // Update the global annotation for the entire table
            return {
                ...tableData,
                tableAnnotation: annotation
            };
        case (0, $feHBz.AitTablePosition).header:
            // Update the column annotation in the headerData
            if (tableData.headerData) return {
                ...tableData,
                headerData: {
                    ...tableData.headerData,
                    annotation: annotation
                }
            };
            return tableData;
        case (0, $feHBz.AitTablePosition).headerRow:
            // Update the annotation for a specific header row
            if (tableData.headerData) return {
                ...tableData,
                headerData: {
                    ...tableData.headerData,
                    rows: tableData.headerData.rows.map((row)=>row.aitid === location.rowId ? {
                            ...row,
                            annotation: annotation
                        } : row)
                }
            };
            return tableData;
        case (0, $feHBz.AitTablePosition).column:
            if (location.columnId) {
                const columnId = location.columnId;
                const originalColumnIndex = location.originalColumn;
                // Handle annotation removal
                if (!annotation) {
                    const updatedColumnInformation = tableData.columnInformation.map((ca)=>ca.columnId === columnId ? {
                            ...ca,
                            annotation: undefined
                        } : ca);
                    return {
                        ...tableData,
                        columnInformation: updatedColumnInformation
                    };
                }
                // Handle annotation addition/update
                const currentIdx = tableData.columnInformation.findIndex((ca)=>ca.columnId === columnId);
                const newColumnInfo = {
                    columnId: columnId,
                    originalColumnIndex: originalColumnIndex,
                    annotation: annotation
                };
                // istanbul ignore next - Defensive fallback: columnInformation ?? [] is unreachable since line 77 would have thrown if undefined
                const updatedColumnInformation = currentIdx >= 0 ? tableData.columnInformation.map((ca, idx)=>idx === currentIdx ? newColumnInfo : ca) : [
                    ...tableData.columnInformation ?? [],
                    newColumnInfo
                ];
                return {
                    ...tableData,
                    columnInformation: updatedColumnInformation
                };
            }
            return tableData;
        case (0, $feHBz.AitTablePosition).bodyRowGroup:
            // Update the annotation for a specific body row group
            return {
                ...tableData,
                bodyData: tableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                        ...rowGroup,
                        annotation: annotation
                    } : rowGroup)
            };
        case (0, $feHBz.AitTablePosition).bodyRow:
            // Update the annotation for a specific body row
            return {
                ...tableData,
                bodyData: tableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                        ...rowGroup,
                        rows: rowGroup.rows.map((row)=>row.aitid === location.rowId ? {
                                ...row,
                                annotation: annotation
                            } : row)
                    } : rowGroup)
            };
        default:
            return tableData;
    }
};

});

parcelRegister("f05qt", function(module, exports) {

$parcel$export(module.exports, "useAnnotationContextWindow", function () { return $4a727215cfb37ab7$export$fedc436bbf7436e4; });

var $hWsmt = parcelRequire("hWsmt");

var $gSkQi = parcelRequire("gSkQi");

var $7fPBF = parcelRequire("7fPBF");

var $2R8xn = parcelRequire("2R8xn");

var $cqlKJ = parcelRequire("cqlKJ");
const $4a727215cfb37ab7$export$fedc436bbf7436e4 = ({ annotationLocation: annotationLocation, annotationType: annotationType, clinicalLibrary: clinicalLibrary, initialAnnotation: initialAnnotation })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    const comparatorTypes = appSettings.annotationComparatorTypes;
    // #region Base Data
    const datasets = (0, $7fPBF.useMemo)(()=>clinicalLibrary?.clinicalDatasets ?? [], [
        clinicalLibrary
    ]);
    const codeLists = (0, $7fPBF.useMemo)(()=>clinicalLibrary?.clinicalCodeLists ?? [], [
        clinicalLibrary
    ]);
    // #endregion
    // #region Utility Functions
    /**
   * Find a dataset by name from the available datasets.
   *
   * @param name - Name of the dataset to search for
   * @returns Dataset if found, undefined otherwise
   */ const findDatasetByName = (0, $7fPBF.useCallback)((name)=>datasets.find((d)=>d.name === name), [
        datasets
    ]);
    /**
   * Creates baseline form state and clauses from an annotation.
   * Used for initializing and restoring annotation data.
   *
   * @param annotation - Annotation to extract state from
   * @returns Object containing form state and clauses
   */ const createBaselineStateAndClauses = (0, $7fPBF.useCallback)((annotation)=>{
        const firstClause = annotation.clauses[0];
        if (!firstClause) return {
            formState: {
                selectedDataset: "",
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                comparator: undefined,
                additionalNotes: annotation.additionalNotes ?? "",
                companionVariables: []
            },
            clauses: []
        };
        const dataset = findDatasetByName(firstClause.left.dataset);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === firstClause?.left.nameVariable);
        const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
        return {
            formState: {
                selectedDataset: dataset?.name ?? "",
                selectedVariable: variable,
                selectedTerminology: mappedCodeList?.name ?? "",
                value: firstClause?.right ?? "",
                comparator: firstClause?.comparator,
                additionalNotes: annotation.additionalNotes ?? "",
                companionVariables: firstClause.left.companionVariables ?? []
            },
            clauses: annotation.clauses
        };
    }, [
        findDatasetByName,
        codeLists
    ]);
    /**
   * Creates a VariableDto from a clinical variable and dataset name.
   *
   * @param variable - Clinical variable to convert
   * @param datasetName - Name of the Dataset containing the variable
   * @returns VariableDto with mapped properties
   */ const createVariableDto = (variable, datasetName)=>({
            nameVariable: variable.name,
            dataset: datasetName
        });
    /**
   * Creates an empty where clause with default values.
   *
   * @returns New WhereClauseOp with empty values and unique ID
   */ const createEmptyClause = ()=>({
            id: crypto.randomUUID(),
            left: {
                nameVariable: "",
                dataset: ""
            },
            comparator: undefined,
            right: ""
        });
    // #endregion
    // #region State Management
    const [whereClauses, setWhereClauses] = (0, $7fPBF.useState)(()=>{
        if (initialAnnotation) return createBaselineStateAndClauses(initialAnnotation).clauses;
        return [];
    });
    const [currentClauseIndex, setCurrentClauseIndex] = (0, $7fPBF.useState)(0);
    const [formState, setFormState] = (0, $7fPBF.useState)(()=>{
        if (initialAnnotation) return createBaselineStateAndClauses(initialAnnotation).formState;
        return {
            selectedDataset: "",
            selectedVariable: undefined,
            selectedTerminology: "",
            value: "",
            comparator: undefined,
            additionalNotes: "",
            companionVariables: []
        };
    });
    // Track previous values to detect changes
    const prevInitialAnnotationRef = (0, $7fPBF.useRef)(initialAnnotation);
    const prevDatasetsLengthRef = (0, $7fPBF.useRef)(datasets.length);
    /**
   * Effect event for updating form state from annotation.
   */ const updateFormFromAnnotation = (0, $7fPBF.useEffectEvent)(()=>{
        if (initialAnnotation) {
            const { formState: newFormState, clauses: clauses } = createBaselineStateAndClauses(initialAnnotation);
            setFormState(newFormState);
            setWhereClauses(clauses);
            setCurrentClauseIndex(0);
        } else {
            setFormState({
                selectedDataset: "",
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                comparator: undefined,
                additionalNotes: "",
                companionVariables: []
            });
            setWhereClauses([]);
            setCurrentClauseIndex(0);
        }
    });
    /**
   * Sync state when initialAnnotation changes or when clinical library loads.
   * This ensures the form displays the correct values when reopening with a saved annotation,
   * and also handles the case where the clinical library loads lazily after the component mounts.
   */ (0, $7fPBF.useEffect)(()=>{
        const annotationChanged = !(0, $gSkQi.isEqual)(prevInitialAnnotationRef.current, initialAnnotation);
        const clinicalLibraryLoaded = prevDatasetsLengthRef.current === 0 && datasets.length > 0 && initialAnnotation;
        // Update if annotation changed OR if clinical library just loaded while we have an annotation
        if (annotationChanged || clinicalLibraryLoaded) {
            prevInitialAnnotationRef.current = initialAnnotation;
            prevDatasetsLengthRef.current = datasets.length;
            updateFormFromAnnotation();
        }
    }, [
        initialAnnotation,
        datasets
    ]);
    // #endregion
    // #region Additional Utility Functions
    /**
   * Creates a where clause from form state and variable data.
   *
   * @param variable - Clinical variable for the clause
   * @param datasetName - Name of the Dataset containing the variable
   * @param existingId - Optional ID to preserve when updating
   * @param precedingLogic - Optional logical operator for multi-clause groups
   * @returns New WhereClauseOp with form state data
   */ const createWhereClause = (variable, datasetName, existingId, precedingLogic)=>{
        const baseDto = createVariableDto(variable, datasetName);
        const left = {
            ...baseDto,
            ...formState.companionVariables.length > 0 && {
                companionVariables: formState.companionVariables
            }
        };
        return {
            id: existingId ?? crypto.randomUUID(),
            left: left,
            comparator: formState.comparator,
            right: formState.value,
            precedingLogic: precedingLogic
        };
    };
    /**
   * Helper to build the current annotation object from form and clause state.
   * Used for isUnchanged and buildFinalAnnotation.
   * Removes precedingLogic from the first clause, preserves for others.
   *
   * @returns Current annotation object or undefined if no valid clauses
   */ const getCurrentAnnotationObject = ()=>{
        const allClauses = [
            ...whereClauses
        ];
        if (formState.selectedDataset && formState.selectedVariable) {
            const currentWhereClause = createWhereClause(formState.selectedVariable, formState.selectedDataset, whereClauses[currentClauseIndex]?.id, whereClauses[currentClauseIndex]?.precedingLogic);
            allClauses[currentClauseIndex] = currentWhereClause;
        }
        const validClauses = allClauses.filter((clause)=>(0, $cqlKJ.validateWhereClause)(clause, comparatorTypes));
        if (validClauses.length === 0) return undefined;
        const clausesWithCorrectLogic = validClauses.map((clause, index)=>{
            if (index === 0) {
                const { precedingLogic: _precedingLogic, ...clauseWithoutLogic } = clause;
                return clauseWithoutLogic;
            } else return clause;
        });
        return {
            id: initialAnnotation?.id ?? crypto.randomUUID(),
            clauses: clausesWithCorrectLogic,
            additionalNotes: formState.additionalNotes
        };
    };
    // #endregion
    // #region Derived Data
    const availableVariables = (0, $7fPBF.useMemo)(()=>formState.selectedDataset ? findDatasetByName(formState.selectedDataset)?.clinicalVariables ?? [] : [], [
        formState.selectedDataset,
        findDatasetByName
    ]);
    const datasetOptions = (0, $7fPBF.useMemo)(()=>datasets.map((dataset)=>({
                name: dataset.name
            })), [
        datasets
    ]);
    const variableOptions = (0, $7fPBF.useMemo)(()=>availableVariables.map((variable)=>({
                displayValue: `${variable.name} - ${variable.dataType}`,
                name: variable.name
            })), [
        availableVariables
    ]);
    // #endregion
    // #region Form Management
    /**
   * Resets the form to empty state and clears all clauses.
   * Should be called when closing or canceling the modal.
   */ const resetForm = ()=>{
        setFormState({
            selectedDataset: "",
            selectedVariable: undefined,
            selectedTerminology: "",
            value: "",
            comparator: undefined,
            additionalNotes: "",
            companionVariables: []
        });
        setWhereClauses([]);
        setCurrentClauseIndex(0);
    };
    /**
   * Creates baseline form state and clauses from an annotation using current datasets and codeLists.
   * Used for initializing and restoring annotation data with up-to-date clinical library data.
   *
   * @param annotation - The annotation to extract state from
   * @returns Object containing form state and clauses
   */ const getBaselineStateAndClauses = (annotation)=>{
        const firstClause = annotation.clauses[0];
        if (!firstClause) return {
            formState: {
                selectedDataset: "",
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                comparator: undefined,
                additionalNotes: annotation.additionalNotes ?? /* istanbul ignore next */ "",
                companionVariables: []
            },
            clauses: []
        };
        const dataset = datasets.find((d)=>d.name === firstClause.left.dataset);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === firstClause?.left.nameVariable);
        const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
        return {
            formState: {
                selectedDataset: dataset?.name ?? /* istanbul ignore next */ "",
                selectedVariable: variable,
                selectedTerminology: mappedCodeList?.name ?? /* istanbul ignore next */ "",
                value: firstClause?.right ?? /* istanbul ignore next */ "",
                comparator: firstClause?.comparator,
                additionalNotes: annotation.additionalNotes ?? /* istanbul ignore next */ "",
                companionVariables: firstClause.left.companionVariables ?? []
            },
            clauses: annotation.clauses
        };
    };
    /**
   * Restores the form to the initial annotation state.
   * Should be called when canceling edits to revert to initial values.
   */ const restoreInitial = ()=>{
        if (initialAnnotation) {
            const { formState: initialFormState, clauses: clauses } = getBaselineStateAndClauses(initialAnnotation);
            setFormState(initialFormState);
            setWhereClauses(clauses);
            setCurrentClauseIndex(0);
        } else resetForm();
    };
    // #endregion
    // #region Validation and State Derived Properties
    const isFormValid = (()=>{
        // Check if current unsaved clause is valid (including companion variables check)
        const currentClauseIsValid = (0, $cqlKJ.validateWhereClause)({
            selectedDataset: formState.selectedDataset,
            selectedVariable: formState.selectedVariable,
            comparator: formState.comparator,
            value: formState.value,
            companionVariables: formState.companionVariables
        }, comparatorTypes);
        // Check all saved clauses (excluding the current one being edited)
        const savedClausesExcludingCurrent = whereClauses.filter((_, idx)=>idx !== currentClauseIndex);
        const allOtherClausesValid = savedClausesExcludingCurrent.every((clause)=>(0, $cqlKJ.validateWhereClause)(clause, comparatorTypes));
        // Allow saving when there's an initial annotation and all clauses have been removed (to enable removing all annotations)
        const canRemoveAllAnnotations = initialAnnotation && whereClauses.length === 0 && !currentClauseIsValid;
        // Form is valid if:
        // 1. All other saved clauses are valid AND current clause is valid, OR
        // 2. We're removing all (existing) annotations
        return !!(allOtherClausesValid && currentClauseIsValid || canRemoveAllAnnotations);
    })();
    const isCurrentClauseValid = (0, $cqlKJ.validateWhereClause)({
        selectedDataset: formState.selectedDataset,
        selectedVariable: formState.selectedVariable,
        comparator: formState.comparator,
        value: formState.value,
        companionVariables: formState.companionVariables
    }, comparatorTypes);
    const canAddNewClause = isCurrentClauseValid;
    // #endregion
    // #region Clause Management
    /**
   * Saves the current form state as a where clause in the clauses list.
   * Updates existing clause at current index or creates new one.
   */ const saveCurrentClause = ()=>{
        if (!formState.selectedDataset || !formState.selectedVariable) return;
        const whereClause = createWhereClause(formState.selectedVariable, formState.selectedDataset, whereClauses[currentClauseIndex]?.id, whereClauses[currentClauseIndex]?.precedingLogic);
        setWhereClauses((prev)=>{
            const updated = [
                ...prev
            ];
            updated[currentClauseIndex] = whereClause;
            return updated;
        });
    };
    /**
   * Loads a saved clause into the form for editing.
   *
   * @param clauseIndex - Index of the clause to load
   */ const loadClauseIntoForm = (0, $7fPBF.useCallback)((clauseIndex)=>{
        const clause = whereClauses[clauseIndex];
        const dataset = findDatasetByName(clause.left.dataset);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === clause.left.nameVariable);
        const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
        setFormState((prev)=>({
                ...prev,
                selectedDataset: dataset?.name ?? /* istanbul ignore next */ "",
                selectedVariable: variable,
                selectedTerminology: mappedCodeList?.name ?? /* istanbul ignore next */ "",
                value: clause.right ?? /* istanbul ignore next */ "",
                comparator: clause.comparator,
                companionVariables: clause.left.companionVariables ?? []
            }));
    }, [
        codeLists,
        findDatasetByName,
        whereClauses
    ]);
    /**
   * Navigate to the previous clause, saving the current clause if valid.
   */ const goToPreviousClause = ()=>{
        /* istanbul ignore else */ if (currentClauseIndex > 0) {
            if (isCurrentClauseValid) saveCurrentClause();
            setCurrentClauseIndex(currentClauseIndex - 1);
            loadClauseIntoForm(currentClauseIndex - 1);
        }
    };
    /**
   * Navigate to the next clause, saving the current clause if valid.
   */ const goToNextClause = ()=>{
        /* istanbul ignore else */ if (currentClauseIndex < whereClauses.length - 1) {
            if (isCurrentClauseValid) saveCurrentClause();
            setCurrentClauseIndex(currentClauseIndex + 1);
            loadClauseIntoForm(currentClauseIndex + 1);
        }
    };
    /**
   * Adds a new empty where clause and navigates to it.
   * Saves current clause before adding if it's valid.
   * New clause will have precedingLogic set to the specified logical operator.
   *
   * @param logicalOperator - Logical operator for the new clause (AND/OR)
   */ const addNewWhereClause = (logicalOperator)=>{
        const newClause = createEmptyClause();
        // Set precedingLogic from the button that was clicked
        newClause.precedingLogic = logicalOperator;
        setWhereClauses((prev)=>{
            const updated = [
                ...prev
            ];
            if (isCurrentClauseValid && formState.selectedDataset && formState.selectedVariable) {
                const whereClause = createWhereClause(formState.selectedVariable, formState.selectedDataset, prev[currentClauseIndex]?.id, prev[currentClauseIndex]?.precedingLogic);
                if (currentClauseIndex >= updated.length) while(updated.length <= currentClauseIndex)updated.push(createEmptyClause());
                updated[currentClauseIndex] = whereClause;
            }
            updated.push(newClause);
            return updated;
        });
        const newIndex = isCurrentClauseValid ? Math.max(whereClauses.length, currentClauseIndex + 1) : whereClauses.length;
        setCurrentClauseIndex(newIndex);
        setFormState((prev)=>({
                ...prev,
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                selectedDataset: "",
                comparator: undefined,
                companionVariables: []
            }));
    };
    /**
   * Remove the current clause and update the active clause index and form state.
   */ const removeCurrentClause = ()=>{
        setWhereClauses((prev)=>{
            const updated = [
                ...prev
            ];
            updated.splice(currentClauseIndex, 1);
            // After removal, if no clauses remain, reset formState
            if (updated.length === 0) {
                setFormState((prevForm)=>({
                        selectedDataset: "",
                        selectedVariable: undefined,
                        selectedTerminology: "",
                        value: "",
                        comparator: undefined,
                        additionalNotes: prevForm.additionalNotes,
                        companionVariables: []
                    }));
                setCurrentClauseIndex(0);
            } else {
                // Otherwise, move to previous clause or first
                const newIndex = Math.min(currentClauseIndex, Math.max(0, updated.length - 1));
                setCurrentClauseIndex(newIndex);
                // Load the clause at the new index
                const clause = updated[newIndex];
                /* istanbul ignore else */ if (clause) {
                    const dataset = findDatasetByName(clause.left.dataset);
                    const variable = dataset?.clinicalVariables.find((v)=>v.name === clause.left.nameVariable);
                    const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
                    setFormState((prevForm)=>({
                            ...prevForm,
                            selectedDataset: dataset?.name ?? /* istanbul ignore next */ "",
                            selectedVariable: variable,
                            selectedTerminology: mappedCodeList?.name,
                            value: clause.right,
                            comparator: clause.comparator,
                            companionVariables: clause.left.companionVariables ?? []
                        }));
                }
            }
            return updated;
        });
    };
    /**
   * Determines if the current clause can be removed.
   *
   * @returns True if there are clauses to remove
   */ const canRemoveClause = whereClauses.length > 0;
    /**
   * Calculates total clause count including unsaved current clause.
   *
   * @returns Total number of clauses for display
   */ const totalClauseCount = currentClauseIndex < whereClauses.length ? Math.max(whereClauses.length, 1) : Math.max(whereClauses.length + 1, 1);
    /**
   * Determines if the current state matches the initial annotation.
   * Compares the built annotation from current state with the initial annotation using deep equality.
   *
   * @returns True if no changes have been made
   */ const isUnchanged = (()=>{
        const currentAnnotation = getCurrentAnnotationObject();
        if (initialAnnotation) return (0, $gSkQi.isEqual)(currentAnnotation, initialAnnotation);
        return currentAnnotation === undefined;
    })();
    /**
   * Builds the final annotation object from current state.
   * Returns undefined when all clauses are removed to enable annotation removal.
   * Does not perform any table I/O operations.
   * Ensures first clause has no precedingLogic, subsequent clauses have "AND".
   *
   * @returns Final annotation or undefined if all clauses removed
   */ const buildFinalAnnotation = ()=>{
        saveCurrentClause();
        return getCurrentAnnotationObject();
    };
    // #endregion
    // #region Simplified Field Handlers
    /**
   * Generic handler for form field changes with special case handling.
   * Clears dependent fields when dataset changes.
   *
   * @param field - Name of the field being changed
   * @param value - New value for the field
   */ const handleFieldChange = (field, value)=>{
        if (field === "selectedDataset") setFormState((prev)=>({
                ...prev,
                selectedDataset: value,
                selectedVariable: undefined,
                selectedTerminology: "",
                value: ""
            }));
        else if (field === "selectedVariable") {
            const variable = availableVariables?.find((v)=>v.name === value);
            const codeList = variable?.clinicalCodeListId ? codeLists.find((cl)=>cl.id === variable.clinicalCodeListId) : undefined;
            setFormState((prev)=>({
                    ...prev,
                    selectedVariable: variable,
                    selectedTerminology: codeList?.name ?? "",
                    value: ""
                }));
        } else setFormState((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    /**
   * Sets both dataset and variable fields in a single atomic update.
   * Used when selecting from "dataset.variable" format to avoid state update race conditions.
   *
   * @param datasetName - Name of the clinical dataset to select
   * @param variableName - Name of the clinical variable within the dataset to select
   */ const setDatasetAndVariable = (datasetName, variableName)=>{
        const dataset = datasets.find((d)=>d.name === datasetName);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === variableName);
        if (dataset && variable) {
            const codeList = variable.clinicalCodeListId ? codeLists.find((cl)=>cl.id === variable.clinicalCodeListId) : undefined;
            setFormState((prev)=>({
                    ...prev,
                    selectedDataset: datasetName,
                    selectedVariable: variable,
                    selectedTerminology: codeList?.name ?? "",
                    value: ""
                }));
        }
    };
    // #endregion
    // #region Preview and Output
    /**
   * Generates preview text for all where clauses.
   * Includes current unsaved clause if valid.
   *
   * @returns Preview of the annotation logic
   */ const previewText = (()=>{
        const allClauses = [
            ...whereClauses
        ];
        if (formState.selectedVariable) {
            const selectedVariableDto = formState.selectedVariable;
            const variableDto = {
                nameVariable: selectedVariableDto.name,
                dataset: formState.selectedDataset,
                ...formState.companionVariables.length > 0 && {
                    companionVariables: formState.companionVariables
                }
            };
            const currentWhereClause = {
                id: whereClauses[currentClauseIndex]?.id ?? crypto.randomUUID(),
                left: variableDto,
                comparator: formState.comparator,
                right: formState.value,
                precedingLogic: whereClauses[currentClauseIndex]?.precedingLogic
            };
            allClauses[currentClauseIndex] = currentWhereClause;
        }
        const validClauses = allClauses.filter((clause)=>(0, $cqlKJ.validateWhereClause)(clause, comparatorTypes));
        if (validClauses.length === 0) return "No annotation clauses configured";
        return (0, $2R8xn.generatePreviewText)(validClauses, comparatorTypes);
    })();
    // #endregion
    /**
   * Update a single form field by name.
   *
   * @param field - Name of the field to update
   * @param value - New value for the field (type matches the field's type in AnnotationControlsState)
   */ const updateFormField = (field, value)=>{
        setFormState((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    return {
        formState: // Core state and validation
        formState,
        isFormValid: isFormValid,
        isCurrentClauseValid: isCurrentClauseValid,
        canAddNewClause: canAddNewClause,
        canRemoveClause: canRemoveClause,
        isUnchanged: isUnchanged,
        initialAnnotation: initialAnnotation,
        updateFormField: // Core actions (wrapper functions to allow external calls)
        updateFormField,
        resetForm: resetForm,
        restoreInitial: restoreInitial,
        buildFinalAnnotation: buildFinalAnnotation,
        handleFieldChange: // Centralized annotations field change handler
        handleFieldChange,
        setDatasetAndVariable: setDatasetAndVariable,
        whereClauses: // Multi-clause management
        whereClauses,
        currentClauseIndex: currentClauseIndex,
        goToPreviousClause: goToPreviousClause,
        goToNextClause: goToNextClause,
        addNewWhereClause: addNewWhereClause,
        removeCurrentClause: removeCurrentClause,
        saveCurrentClause: saveCurrentClause,
        datasetOptions: // Data for selectors
        datasetOptions,
        variableOptions: variableOptions,
        codeLists: codeLists,
        comparatorTypes: comparatorTypes,
        annotationLocation: annotationLocation,
        annotationType: annotationType,
        previewText: // Preview data
        previewText,
        totalClauseCount: totalClauseCount
    };
};

});
parcelRegister("2R8xn", function(module, exports) {

$parcel$export(module.exports, "generatePreviewText", function () { return $deda37748407e12a$export$6af7c3d4d6b539c4; });

var $gbb4D = parcelRequire("gbb4D");
/**
 * Generate preview text for a single where clause operation.
 *
 * @param whereClause - The where clause to generate a preview for
 * @param comparatorTypes - Available comparator types used to determine formatting
 * @returns Preview text string
 */ const $deda37748407e12a$var$generateSingleClausePreviewFromOp = (whereClause, comparatorTypes)=>{
    if (!whereClause.left?.dataset || !whereClause.left) return "";
    let text = `${whereClause.left.dataset}.${whereClause.left.nameVariable}`;
    // Add companions in the order they appear in the array
    if (whereClause.left.companionVariables && whereClause.left.companionVariables.length > 0) whereClause.left.companionVariables.forEach((companion)=>{
        const formatFn = (0, $gbb4D.COMPANION_TYPE_CONFIG)[companion.type];
        text += formatFn(companion.variable);
    });
    if (!whereClause.comparator) return text;
    // Look up the full comparator object by name
    const comparatorType = comparatorTypes.find((c)=>c.name === whereClause.comparator);
    if (!comparatorType) return text;
    // Check if comparator doesn't require right-hand side value
    if (comparatorType.rhsType === "None") text += ` ${comparatorType.denotation}`;
    else if (whereClause.right) {
        if (comparatorType.rhsType === "Group") {
            // For group comparators, parse values separated by newlines
            const values = whereClause.right.split("\n").map((v)=>v.trim()).filter((v)=>v !== "");
            const isNumeric = values.every((v)=>/^\d+(\.\d+)?$/.test(v));
            const formattedValues = values.map((v)=>isNumeric ? v : `"${v}"`).join(", ");
            text += ` ${comparatorType.denotation} (${formattedValues})`;
        } else {
            // For single value comparators
            const isNumeric = /^\d+(\.\d+)?$/.test(whereClause.right);
            const formattedValue = isNumeric ? whereClause.right : `"${whereClause.right}"`;
            text += ` ${comparatorType.denotation} ${formattedValue}`;
        }
    }
    return text;
};
const $deda37748407e12a$export$6af7c3d4d6b539c4 = (whereClauses, comparatorTypes)=>{
    const previews = whereClauses.map((clause, idx)=>{
        const clausePreview = $deda37748407e12a$var$generateSingleClausePreviewFromOp(clause, comparatorTypes);
        if (clausePreview === "") return "";
        // Only show precedingLogic for clauses after the first
        const logicText = idx > 0 && clause.precedingLogic ? `${clause.precedingLogic} ` : "";
        return `${logicText}${clausePreview}`;
    }).filter((preview)=>preview !== "");
    return previews.join(" ");
};

});
parcelRegister("gbb4D", function(module, exports) {

$parcel$export(module.exports, "COMPANION_TYPE_CONFIG", function () { return $2cf948e91cf114e8$export$150b644aabea4fbb; });
$parcel$export(module.exports, "isVariableDto", function () { return $2cf948e91cf114e8$export$580697d40ab95f51; });
/**
 * Companion variable type options
 */ const $2cf948e91cf114e8$export$150b644aabea4fbb = {
    Order: (variable)=>`/${variable}`,
    Label: (variable)=>`/${variable}`,
    Unit: (variable)=>` (${variable})`
};
const $2cf948e91cf114e8$export$580697d40ab95f51 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.nameVariable !== "string") return false;
    if (typeof chkObj.dataset !== "string") return false;
    // Check optional companionVariables array
    if (chkObj.companionVariables !== undefined) {
        if (!Array.isArray(chkObj.companionVariables)) return false;
        for (const companion of chkObj.companionVariables){
            if (typeof companion !== "object" || companion === null) return false;
            if (typeof companion.variable !== "string") return false;
            if (![
                "Order",
                "Label",
                "Unit"
            ].includes(companion.type)) return false;
        }
    }
    // Everything is good
    return true;
};

});


parcelRegister("cqlKJ", function(module, exports) {

$parcel$export(module.exports, "validateWhereClause", function () { return $cb1377e1f5f72ee5$export$3daeae5176c2a71c; });

var $8sYvr = parcelRequire("8sYvr");
const $cb1377e1f5f72ee5$export$3daeae5176c2a71c = (data, comparatorTypes)=>{
    // Convert to ValidatableWhereClause format based on input type
    const validatable = (0, $8sYvr.isWhereClause)(data) ? {
        dataset: data.left?.dataset,
        nameVariable: data.left?.nameVariable,
        comparator: data.comparator,
        value: data.right,
        companionVariables: data.left?.companionVariables
    } : "selectedDataset" in data ? {
        dataset: data.selectedDataset,
        nameVariable: data.selectedVariable?.name,
        comparator: data.comparator,
        value: data.value,
        companionVariables: data.companionVariables
    } : data;
    const { dataset: dataset, nameVariable: nameVariable, comparator: comparator, value: value, companionVariables: companionVariables } = validatable;
    // Check basic required fields (dataset and variable are always required)
    if (!dataset || !nameVariable) return false;
    // Check that all companion variables have a value selected
    if (companionVariables?.some((companion)=>!companion.variable || companion.variable.split(".")[0] !== dataset)) return false;
    // If no comparator is selected, the clause is still valid (just references the variable)
    if (!comparator) return true;
    // Check if comparator requires a value (only validate if comparatorType is found)
    const comparatorType = comparatorTypes?.find((ct)=>ct.name === comparator);
    if (comparatorType && comparatorType.rhsType !== "None" && !value) return false;
    return true;
};

});
parcelRegister("8sYvr", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseOp", function () { return $6c1efbfe8475913a$export$db8818ddfdcc306b; });
$parcel$export(module.exports, "isWhereClause", function () { return $6c1efbfe8475913a$export$2c9b8aab4e488ca5; });

var $eT7bk = parcelRequire("eT7bk");

var $gbb4D = parcelRequire("gbb4D");
const $6c1efbfe8475913a$export$db8818ddfdcc306b = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.left !== "object" || !(0, $gbb4D.isVariableDto)(chkObj.left)) return false;
    if (chkObj.comparator !== undefined && typeof chkObj.comparator !== "string") return false;
    if (chkObj.right !== undefined && typeof chkObj.right !== "string") return false;
    if (chkObj.precedingLogic !== undefined && !(0, $eT7bk.isLogicalOperator)(chkObj.precedingLogic)) return false;
    // Everything is good
    return true;
};
const $6c1efbfe8475913a$export$2c9b8aab4e488ca5 = (data)=>"left" in data;

});
parcelRegister("eT7bk", function(module, exports) {

$parcel$export(module.exports, "isLogicalOperator", function () { return $aab8fd970fd07798$export$787487a2edbfc02e; });
/**
 * Logical operators for combining where groups.
 * Currently supports AND and OR operations.
 */ const $aab8fd970fd07798$export$787487a2edbfc02e = (obj)=>{
    return typeof obj === "string" && [
        "AND",
        "OR"
    ].includes(obj);
};

});





parcelRegister("aKDek", function(module, exports) {

$parcel$export(module.exports, "AnnotationPreviewBubble", function () { return $799e2fe3b7ea8638$export$1d96d319de4d1c3a; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("P0x5y");
var $cqVqv = parcelRequire("cqVqv");

var $hWsmt = parcelRequire("hWsmt");

var $7fPBF = parcelRequire("7fPBF");

var $6tWb8 = parcelRequire("6tWb8");
var $7fR5Z = parcelRequire("7fR5Z");

var $limyv = parcelRequire("limyv");

var $2R8xn = parcelRequire("2R8xn");
const $799e2fe3b7ea8638$export$1d96d319de4d1c3a = ({ annotation: annotation, className: className = "", position: position = "right", variant: variant = "bubble", onClick: onClick, target: target, repositionKey: repositionKey })=>{
    const appSettings = (0, $hWsmt.useAppSettings)();
    /**
   * Container for Overlay popover. Uses target's parent or document.body.
   */ /* istanbul ignore next */ const container = target.current?.parentElement ?? (typeof document !== "undefined" ? document.body : undefined);
    /**
   * Memoized preview text for annotation clauses.
   */ const previewText = (0, $7fPBF.useMemo)(()=>annotation ? (0, $2R8xn.generatePreviewText)(annotation.clauses, appSettings.annotationComparatorTypes) : "", [
        annotation,
        appSettings.annotationComparatorTypes
    ]);
    /**
   * Keyboard event handler for accessibility.
   * Triggers onClick when Enter or Space is pressed.
   *
   * @param e - Keyboard event
   */ const handleKeyDown = onClick ? (e)=>{
        /* istanbul ignore else */ if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
        }
    } : /* istanbul ignore next */ undefined;
    // Bubble variant - Bootstrap Overlay with Popover
    return !annotation || !annotation.clauses || annotation.clauses.length === 0 ? null : variant === "column" ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($limyv))).columnPreview,
            className
        ]),
        onClick: onClick,
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : undefined,
        onKeyDown: handleKeyDown,
        "aria-label": onClick ? "Annotation preview" : undefined,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($limyv))).bubbleContent,
            children: previewText && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($limyv))).bubbleText,
                children: previewText
            })
        })
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6tWb8.default), {
        placement: position,
        target: target?.current,
        show: true,
        container: container,
        popperConfig: {
            modifiers: [
                {
                    name: "arrow",
                    enabled: false
                },
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            2
                        ]
                    }
                },
                {
                    name: "eventListeners",
                    options: {
                        scroll: true,
                        resize: true
                    }
                },
                {
                    name: "flip",
                    enabled: true,
                    options: {
                        // Only allow horizontal flipping (left <-> right), not vertical (top <-> bottom)
                        fallbackPlacements: position === "left" || position === "right" ? [
                            position === "left" ? "right" : "left"
                        ] : []
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                        boundary: "viewport"
                    }
                }
            ]
        },
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fR5Z.default), {
            id: `annotation-preview-${annotation.id}`,
            className: (0, $cqVqv.classMerge)([
                (0, (/*@__PURE__*/$parcel$interopDefault($limyv))).annotationPreviewBubble,
                className
            ]),
            onClick: onClick,
            role: onClick ? "button" : undefined,
            tabIndex: onClick ? 0 : undefined,
            onKeyDown: handleKeyDown,
            "aria-label": onClick ? "Annotation preview bubble" : undefined,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7fR5Z.default).Body, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($limyv))).bubbleContent,
                children: previewText && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($limyv))).bubbleText,
                    children: previewText
                })
            })
        })
    }, repositionKey !== undefined ? `overlay-${repositionKey}` : undefined);
};
$799e2fe3b7ea8638$export$1d96d319de4d1c3a.displayName = "AnnotationPreviewBubble";

});
parcelRegister("6tWb8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b82948dc1e1226d$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $lOnKm = parcelRequire("lOnKm");

var $jbhqg = parcelRequire("jbhqg");

var $lKzMT = parcelRequire("lKzMT");

var $kbUnX = parcelRequire("kbUnX");

var $9Yz7D = parcelRequire("9Yz7D");

var $e2eQx = parcelRequire("e2eQx");

var $46NT0 = parcelRequire("46NT0");

var $bbzbN = parcelRequire("bbzbN");
"use client";
function $4b82948dc1e1226d$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $46NT0.default)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $46NT0.default)(r)));
}
const $4b82948dc1e1226d$var$Overlay = /*#__PURE__*/ $7fPBF.forwardRef(({ children: overlay, transition: transition = (0, $e2eQx.default), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $7fPBF.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $7fPBF.useState)(null);
    const [ref, modifiers] = (0, $9Yz7D.default)(outerProps.offset);
    const mergedRef = (0, $kbUnX.default)(outerRef, ref);
    const actualTransition = transition === true ? (0, $e2eQx.default) : transition || undefined;
    const handleFirstUpdate = (0, $jbhqg.default)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $lKzMT.default)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lOnKm.default), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $4b82948dc1e1226d$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $7fPBF.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$4b82948dc1e1226d$var$Overlay.displayName = 'Overlay';
var $4b82948dc1e1226d$export$2e2bcd8739ae039 = $4b82948dc1e1226d$var$Overlay;

});
parcelRegister("lOnKm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe10b01477d7d24e$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $je0yT = parcelRequire("je0yT");

var $f2Ftg = parcelRequire("f2Ftg");

var $4xfLr = parcelRequire("4xfLr");

var $2ANdU = parcelRequire("2ANdU");

var $5Gx8F = parcelRequire("5Gx8F");

var $jsHER = parcelRequire("jsHER");

var $5aSAE = parcelRequire("5aSAE");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $fe10b01477d7d24e$var$Overlay = /*#__PURE__*/ $7fPBF.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $je0yT.default)();
    const [arrowElement, attachArrowRef] = (0, $je0yT.default)();
    const mergedRef = (0, $f2Ftg.default)(attachRef, outerRef);
    const container = (0, $5Gx8F.default)(props.container);
    const target = (0, $5Gx8F.default)(props.target);
    const [exited, setExited] = (0, $7fPBF.useState)(!props.show);
    const popper = (0, $4xfLr.default)(target, rootElement, (0, $jsHER.default)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $2ANdU.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $5aSAE.renderTransition)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).createPortal(child, container) : null;
});
$fe10b01477d7d24e$var$Overlay.displayName = 'Overlay';
var $fe10b01477d7d24e$export$2e2bcd8739ae039 = $fe10b01477d7d24e$var$Overlay;

});
parcelRegister("2ANdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e352050eced2f2f$export$2e2bcd8739ae039; });

var $22FgH = parcelRequire("22FgH");

var $eSNaH = parcelRequire("eSNaH");

var $7fPBF = parcelRequire("7fPBF");

var $29zbc = parcelRequire("29zbc");

var $hLV9x = parcelRequire("hLV9x");

var $lfw25 = parcelRequire("lfw25");
const $1e352050eced2f2f$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $1e352050eced2f2f$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $1e352050eced2f2f$var$noop;
    (0, $hLV9x.default)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $29zbc.default)((e)=>{
        if ((0, $lfw25.isEscKey)(e)) onClose(e);
    });
    (0, $7fPBF.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $eSNaH.default)((0, $hLV9x.getRefTarget)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $22FgH.default)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $1e352050eced2f2f$export$2e2bcd8739ae039 = $1e352050eced2f2f$var$useRootClose;

});


parcelRegister("9Yz7D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7434f6297aa1ff1a$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $85lB0 = parcelRequire("85lB0");

var $jbn4d = parcelRequire("jbn4d");

var $7fR5Z = parcelRequire("7fR5Z");

var $11cQc = parcelRequire("11cQc");
"use client";
function $7434f6297aa1ff1a$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $7fPBF.useRef)(null);
    const popoverClass = (0, $jbn4d.useBootstrapPrefix)(undefined, 'popover');
    const tooltipClass = (0, $jbn4d.useBootstrapPrefix)(undefined, 'tooltip');
    const offset = (0, $7fPBF.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $85lB0.default)(overlayRef.current, popoverClass)) return (0, $7fR5Z.default).POPPER_OFFSET;
                        if ((0, $85lB0.default)(overlayRef.current, tooltipClass)) return (0, $11cQc.default).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}

});
parcelRegister("7fR5Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54831ece6ef8895d$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $b15yi = parcelRequire("b15yi");

var $cOOq1 = parcelRequire("cOOq1");

var $kfn5W = parcelRequire("kfn5W");

var $1ba0m = parcelRequire("1ba0m");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $54831ece6ef8895d$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'popover');
    const isRTL = (0, $jbn4d.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $kfn5W.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $1ba0m.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cOOq1.default), {
                children: children
            }) : children
        ]
    });
});
$54831ece6ef8895d$var$Popover.displayName = 'Popover';
var $54831ece6ef8895d$export$2e2bcd8739ae039 = Object.assign($54831ece6ef8895d$var$Popover, {
    Header: (0, $b15yi.default),
    Body: (0, $cOOq1.default),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});

});
parcelRegister("b15yi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80541842d6dd26d3$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $80541842d6dd26d3$var$PopoverHeader = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$80541842d6dd26d3$var$PopoverHeader.displayName = 'PopoverHeader';
var $80541842d6dd26d3$export$2e2bcd8739ae039 = $80541842d6dd26d3$var$PopoverHeader;

});

parcelRegister("cOOq1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $955143ad267c21f0$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $jicu4 = parcelRequire("jicu4");

var $jbn4d = parcelRequire("jbn4d");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $955143ad267c21f0$var$PopoverBody = /*#__PURE__*/ $7fPBF.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix),
        ...props
    });
});
$955143ad267c21f0$var$PopoverBody.displayName = 'PopoverBody';
var $955143ad267c21f0$export$2e2bcd8739ae039 = $955143ad267c21f0$var$PopoverBody;

});

parcelRegister("kfn5W", function(module, exports) {

$parcel$export(module.exports, "getOverlayDirection", function () { return $ebd71f7d7ef1b007$export$c15856915a9b3464; });

var $7fPBF = parcelRequire("7fPBF");
class $ebd71f7d7ef1b007$export$34582a676b91ff07 extends $7fPBF.Component {
}
function $ebd71f7d7ef1b007$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}

});

parcelRegister("1ba0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0dbe94446d63b271$export$2e2bcd8739ae039; });
function $0dbe94446d63b271$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}

});


parcelRegister("11cQc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bdfd86055efb882$export$2e2bcd8739ae039; });

var $jicu4 = parcelRequire("jicu4");

var $7fPBF = parcelRequire("7fPBF");

var $jbn4d = parcelRequire("jbn4d");

var $kfn5W = parcelRequire("kfn5W");

var $1ba0m = parcelRequire("1ba0m");

var $bbzbN = parcelRequire("bbzbN");
"use client";
const $0bdfd86055efb882$var$Tooltip = /*#__PURE__*/ $7fPBF.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $jbn4d.useBootstrapPrefix)(bsPrefix, 'tooltip');
    const isRTL = (0, $jbn4d.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $kfn5W.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $1ba0m.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jicu4)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$0bdfd86055efb882$var$Tooltip.displayName = 'Tooltip';
var $0bdfd86055efb882$export$2e2bcd8739ae039 = Object.assign($0bdfd86055efb882$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});

});



parcelRegister("limyv", function(module, exports) {

$parcel$export(module.exports, "annotationBtn", function () { return $f80cc67720eb1617$export$2c1bbb5dc6e1a1c3; }, function (v) { return $f80cc67720eb1617$export$2c1bbb5dc6e1a1c3 = v; });
$parcel$export(module.exports, "annotationPreviewBubble", function () { return $f80cc67720eb1617$export$3b5a6760338ba651; }, function (v) { return $f80cc67720eb1617$export$3b5a6760338ba651 = v; });
$parcel$export(module.exports, "bubbleContent", function () { return $f80cc67720eb1617$export$2a2787b3ff8c035; }, function (v) { return $f80cc67720eb1617$export$2a2787b3ff8c035 = v; });
$parcel$export(module.exports, "bubbleText", function () { return $f80cc67720eb1617$export$bc489a46220551d3; }, function (v) { return $f80cc67720eb1617$export$bc489a46220551d3 = v; });
$parcel$export(module.exports, "columnPreview", function () { return $f80cc67720eb1617$export$b59caf56f5de4e5d; }, function (v) { return $f80cc67720eb1617$export$b59caf56f5de4e5d = v; });
var $f80cc67720eb1617$export$2c1bbb5dc6e1a1c3;
var $f80cc67720eb1617$export$3b5a6760338ba651;
var $f80cc67720eb1617$export$2a2787b3ff8c035;
var $f80cc67720eb1617$export$bc489a46220551d3;
var $f80cc67720eb1617$export$b59caf56f5de4e5d;
$f80cc67720eb1617$export$2c1bbb5dc6e1a1c3 = `mos-AnnotationPreviewBubble-module-p9ZkTW-annotationBtn`;
$f80cc67720eb1617$export$3b5a6760338ba651 = `mos-AnnotationPreviewBubble-module-p9ZkTW-annotationPreviewBubble`;
$f80cc67720eb1617$export$2a2787b3ff8c035 = `mos-AnnotationPreviewBubble-module-p9ZkTW-bubbleContent`;
$f80cc67720eb1617$export$bc489a46220551d3 = `mos-AnnotationPreviewBubble-module-p9ZkTW-bubbleText`;
$f80cc67720eb1617$export$b59caf56f5de4e5d = `mos-AnnotationPreviewBubble-module-p9ZkTW-columnPreview`;

});




parcelRegister("hcezh", function(module, exports) {

$parcel$export(module.exports, "AitRemoveColumnButton", function () { return $2bb4dfe4991977e2$export$4db8d1216848fd27; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $5m3yv = parcelRequire("5m3yv");

var $88YCB = parcelRequire("88YCB");

var $feHBz = parcelRequire("feHBz");
const $2bb4dfe4991977e2$export$4db8d1216848fd27 = ({ originalColumnIndex: originalColumnIndex })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const cellIds = (0, $7fPBF.useMemo)(()=>{
        if (!state) return [];
        return [
            ...state.originalTableData.headerData !== false ? state.originalTableData.headerData.rows.flatMap((r)=>r.cells[originalColumnIndex].aitid) : [],
            ...state.originalTableData.bodyData.flatMap((rg)=>rg.rows.flatMap((r)=>r.cells[originalColumnIndex].aitid))
        ];
    }, [
        state,
        originalColumnIndex
    ]);
    return !state ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${state.id}-remcol-${originalColumnIndex}`,
        tipText: "Remove column",
        iconName: "aioxMinus",
        onClick: ()=>{
            dispatch({
                operation: (0, $feHBz.REMOVE_COLUMN),
                value: originalColumnIndex,
                cellIds: cellIds
            });
        }
    });
};
$2bb4dfe4991977e2$export$4db8d1216848fd27.displayName = "AitRemoveColumnButton";

});



parcelRegister("1qN19", function(module, exports) {

$parcel$export(module.exports, "AitCell", function () { return $fe5764741fdbbf09$export$3425f453fd376cda; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $8vQMY = parcelRequire("8vQMY");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");

var $cqVqv = parcelRequire("cqVqv");

var $asuxf = parcelRequire("asuxf");

var $llmyo = parcelRequire("llmyo");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");

var $88YCB = parcelRequire("88YCB");
const $fe5764741fdbbf09$export$3425f453fd376cda = ({ location: location, ...rest })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const Editor = state?.editorProps.Editor;
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const displayText = thisCell?.replacedText ?? thisCell?.text ?? state?.editorProps.blankT ?? (0, $jP37Y.defaultEditorDefns).blankT;
    // Static options/variables
    const currentReadOnly = (0, $7fPBF.useMemo)(()=>!state || !thisCell ? true : !state.editable || location.isRepeat, [
        location.isRepeat,
        state,
        thisCell
    ]);
    // Update cell style when options change
    const cellStyle = (0, $7fPBF.useMemo)(()=>{
        return !state || !thisCell ? {} : {
            overflow: "visible",
            width: `${state.colWidthMod * (thisCell.colWidth ?? // istanbul ignore next
            state.defaultCellWidth)}px`,
            paddingLeft: location.cellType === (0, $feHBz.AitCellType).rowHeader && thisCell.textIndents !== undefined ? `${thisCell.textIndents}rem` : undefined,
            borderLeft: state.showCellBorders ? "1px dashed burlywood" : "",
            borderBottom: state.showCellBorders ? "1px dashed burlywood" : "",
            borderRight: state.showCellBorders && location.column === (state.processedTableData?.rowHeaderColumns ?? // istanbul ignore next
            0) - 1 ? "1px solid burlywood" : state.showCellBorders ? "1px dashed burlywood" : "",
            borderTop: state.showCellBorders && location.row === 0 && location.rowGroup !== undefined && location.rowGroup > 0 ? "1px solid burlywood" : state.showCellBorders ? "1px dashed burlywood" : ""
        };
    }, [
        location.cellType,
        location.column,
        location.row,
        location.rowGroup,
        state,
        thisCell
    ]);
    // Traffic light
    const cellTrafficLight = !state?.noTrafficLights && !location.isRepeat && thisCell && ![
        "BlankNotEvaluated",
        "GreenOk"
    ].includes(thisCell.coreTrafficLight) ? new (0, $8vQMY.MosaicTrafficLightClass)(thisCell.coreTrafficLight, "-4px", "-8px", "absolute").element : null;
    // Render element
    return !state || !id || !state.processedTableData || !Editor || !thisCell ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
        ...rest,
        id: id,
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
            location.cellType === (0, $feHBz.AitCellType).rowHeader ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitRowHeaderCell : (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitBodyCell,
            currentReadOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitReadonlyCell : ""
        ]),
        style: cellStyle,
        role: "cell",
        onClick: (0, $llmyo.clickCell),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                style: {
                    width: `calc(${cellStyle.width} - ${thisCell.textIndents ?? // istanbul ignore next
                    0}rem)`,
                    height: "100%"
                },
                children: [
                    cellTrafficLight,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder,
                        menuItems: [
                            {
                                label: "Show cell options",
                                action: ()=>{
                                    const focusDummy = document.createElement("input");
                                    document.body.appendChild(focusDummy);
                                    focusDummy.focus();
                                    focusDummy.remove();
                                    dispatch({
                                        operation: (0, $feHBz.SHOW_OPTIONS_WINDOW),
                                        location: location
                                    });
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                            id: `${id}-editor`,
                            decimalAlignPercent: state.processedTableData.decimalAlignPercent,
                            editable: !currentReadOnly,
                            preReplacedText: thisCell.text,
                            setValue: (ret)=>{
                                dispatch({
                                    operation: (0, $feHBz.UPDATE_TABLE_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                });
                            },
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).editorInput,
                            textAlignment: !thisCell.justifyText || thisCell.justifyText === "default" ? location.column < (state.processedTableData.rowHeaderColumns ?? // istanbul ignore next
                            0) ? "left" : "center" : thisCell.justifyText,
                            value: displayText,
                            commentConfig: {
                                id: id,
                                activeContext: "TlfItem",
                                label: "New cell comment",
                                iconPosition: {
                                    top: "-2px",
                                    left: "-2px"
                                },
                                noIcon: location.isRepeat
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $asuxf.AitCellWindow), {
                location: location
            })
        ]
    });
};
$fe5764741fdbbf09$export$3425f453fd376cda.displayName = "AitCell";

});
parcelRegister("asuxf", function(module, exports) {

$parcel$export(module.exports, "AitCellWindow", function () { return $0c007216466669f2$export$733ecc2d57f07177; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $gSkQi = parcelRequire("gSkQi");

var $gOa7m = parcelRequire("gOa7m");

var $dNXfz = parcelRequire("dNXfz");

var $c51fb = parcelRequire("c51fb");

var $9WSJ8 = parcelRequire("9WSJ8");

var $fQdeH = parcelRequire("fQdeH");

var $a9tvf = parcelRequire("a9tvf");

var $8gmiT = parcelRequire("8gmiT");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");

var $88YCB = parcelRequire("88YCB");
const $0c007216466669f2$export$733ecc2d57f07177 = ({ location: location })=>{
    // Context
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const Editor = state?.editorProps.Editor;
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    return !Editor || !thisCell ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ContextWindow), {
        id: `${id}-window`,
        title: "Cell options",
        visible: state.showOptionsWindow.findIndex((l)=>(0, $gSkQi.isEqual)(l, location)) > -1,
        onClose: ()=>{
            dispatch({
                operation: (0, $feHBz.HIDE_OPTIONS_WINDOW),
                location: location
            });
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gmiT.AitCommentRow), {
                location: location
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                        id: `${id}-unprocessed-label`,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioLabel,
                        htmlFor: `${id}-unprocessed`,
                        children: "Unprocessed text:"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioInputHolder,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                            id: `${id}-unprocessed`,
                            value: thisCell.text,
                            setValue: (ret)=>location.position === (0, $feHBz.AitTablePosition).bodyCell ? dispatch({
                                    operation: (0, $feHBz.UPDATE_TABLE_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                }) : dispatch({
                                    operation: (0, $feHBz.UPDATE_HEADER_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                }),
                            editable: !thisCell.readOnly && !location.isRepeat && state.editable,
                            className: !thisCell.readOnly && !location.isRepeat && state.editable ? "can-edit" : "readonly",
                            textAlignment: thisCell.justifyText,
                            decimalAlignPercent: state.processedTableData?.decimalAlignPercent,
                            "aria-labelledby": `${id}-unprocessed-label`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dNXfz.AitCellAlign), {
                location: location
            }),
            location.position === (0, $feHBz.AitTablePosition).headerCell && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a9tvf.AitCellWidth), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fQdeH.AitCellRowSpans), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c51fb.AitCellColSpans), {
                        location: location
                    })
                ]
            }),
            location.cellType === (0, $feHBz.AitCellType).rowHeader && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9WSJ8.AitCellIndents), {
                location: location
            })
        ]
    }, "Cell");
};
$0c007216466669f2$export$733ecc2d57f07177.displayName = "AitCellWindow";

});
parcelRegister("dNXfz", function(module, exports) {

$parcel$export(module.exports, "AitCellAlign", function () { return $e356fa4577d22d10$export$e5f5529ff06758f9; });

var $bbzbN = parcelRequire("bbzbN");

var $hbWqi = parcelRequire("hbWqi");

var $gOa7m = parcelRequire("gOa7m");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");

var $88YCB = parcelRequire("88YCB");
const $e356fa4577d22d10$export$e5f5529ff06758f9 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    return !thisCell ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hbWqi.AioSelect), {
            id: `${id}-justify`,
            label: "Justify text",
            value: thisCell.justifyText === undefined ? "Default" : thisCell.justifyText.charAt(0).toUpperCase() + thisCell.justifyText.substring(1).toLowerCase(),
            availableValues: [
                "Default",
                "Left",
                "Center",
                "Right",
                "Decimal"
            ],
            setValue: !thisCell.readOnly && !location.isRepeat ? (ret)=>location.position === (0, $feHBz.AitTablePosition).headerCell ? dispatch({
                    operation: (0, $feHBz.UPDATE_HEADER_CELL),
                    location: location,
                    cellData: {
                        justifyText: ret.toLowerCase()
                    }
                }) : dispatch({
                    operation: (0, $feHBz.UPDATE_TABLE_CELL),
                    location: location,
                    cellData: {
                        justifyText: ret.toLowerCase()
                    }
                }) : undefined
        })
    });
};
$e356fa4577d22d10$export$e5f5529ff06758f9.displayName = "AitCellAlign";

});

parcelRegister("c51fb", function(module, exports) {

$parcel$export(module.exports, "AitCellColSpans", function () { return $b124c2e987340593$export$c3eed5616b8ae6c5; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $3zeKa = parcelRequire("3zeKa");

var $fCWrt = parcelRequire("fCWrt");

var $gpwEh = parcelRequire("gpwEh");

var $88YCB = parcelRequire("88YCB");
const $b124c2e987340593$export$c3eed5616b8ae6c5 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const originalHeaderData = state?.originalTableData.headerData;
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const changeColSpan = (0, $7fPBF.useMemo)(()=>{
        if (originalHeaderData && thisCell) {
            const canAdd = (0, $3zeKa.trCanAddColSpan)(originalHeaderData, location, thisCell.colSpan + 1, state?.originalTableData.rowHeaderColumns ?? // istanbul ignore next
            0);
            const canRemove = (0, $gpwEh.trCanRemoveColSpan)(originalHeaderData, location, thisCell.colSpan - 1);
            return {
                canAdd: canAdd.canAdd,
                canRemove: canRemove.canRemove
            };
        }
        return {
            canAdd: false,
            canRemove: false
        };
    }, [
        location,
        originalHeaderData,
        state?.originalTableData.rowHeaderColumns,
        thisCell
    ]);
    return !thisCell ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioLabel,
                children: "Column span: "
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioRoValue,
                children: thisCell.repeatColSpan ?? thisCell.colSpan
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButtonHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).padding2
                ]),
                children: [
                    changeColSpan.canAdd !== false ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        id: `${id}-add-colspan`,
                        className: (0, $cqVqv.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxPlus
                        ]),
                        title: "Add column span",
                        "aria-label": "Add column span",
                        onClick: ()=>dispatch({
                                operation: (0, $feHBz.ADD_COLUMN_SPAN),
                                location: location,
                                newSpan: thisCell.colSpan + 1
                            })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton
                    }),
                    changeColSpan.canRemove !== false && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        id: `${id}-remove-colspan`,
                        className: (0, $cqVqv.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxMinus
                        ]),
                        title: "Remove column span",
                        "aria-label": "Remove column span",
                        onClick: ()=>dispatch({
                                operation: (0, $feHBz.REMOVE_COLUMN_SPAN),
                                location: location,
                                newSpan: thisCell.colSpan - 1
                            })
                    })
                ]
            })
        ]
    });
};
$b124c2e987340593$export$c3eed5616b8ae6c5.displayName = "AitCellColSpans";

});

parcelRegister("9WSJ8", function(module, exports) {

$parcel$export(module.exports, "AitCellIndents", function () { return $d250ac7913925bfe$export$23c33c832c8301fd; });

var $bbzbN = parcelRequire("bbzbN");

var $4gy1I = parcelRequire("4gy1I");

var $gOa7m = parcelRequire("gOa7m");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");

var $88YCB = parcelRequire("88YCB");
const $d250ac7913925bfe$export$23c33c832c8301fd = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    return !thisCell || location.cellType !== (0, $feHBz.AitCellType).rowHeader ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4gy1I.AioNumber), {
            id: `${id}-indents`,
            label: "Text indents",
            value: thisCell.textIndents ?? // istanbul ignore next
            0,
            setValue: !thisCell.readOnly && !location.isRepeat ? (ret)=>dispatch({
                    operation: (0, $feHBz.UPDATE_TABLE_CELL),
                    location: location,
                    cellData: {
                        textIndents: ret
                    }
                }) : undefined
        })
    });
};
$d250ac7913925bfe$export$23c33c832c8301fd.displayName = "AitCellIndents";

});

parcelRegister("fQdeH", function(module, exports) {

$parcel$export(module.exports, "AitCellRowSpans", function () { return $7bea0ae23d4214b9$export$740be5db2e61b2a3; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $dAmd5 = parcelRequire("dAmd5");

var $fCWrt = parcelRequire("fCWrt");

var $ey1Zf = parcelRequire("ey1Zf");

var $88YCB = parcelRequire("88YCB");
const $7bea0ae23d4214b9$export$740be5db2e61b2a3 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const originalHeaderData = state?.originalTableData.headerData;
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const changeRowSpan = (0, $7fPBF.useMemo)(()=>{
        if (originalHeaderData && thisCell) {
            const canAdd = (0, $dAmd5.trCanAddRowSpan)(originalHeaderData, location, thisCell.rowSpan + 1);
            const canRemove = (0, $ey1Zf.trCanRemoveRowSpan)(originalHeaderData, location, thisCell.rowSpan - 1);
            return {
                canAdd: canAdd.canAdd,
                canRemove: canRemove.canRemove
            };
        }
        return {
            canAdd: false,
            canRemove: false
        };
    }, [
        originalHeaderData,
        thisCell,
        location
    ]);
    return !thisCell ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioLabel,
                children: "Row span: "
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioRoValue,
                children: thisCell.repeatRowSpan ?? thisCell.rowSpan
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButtonHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).padding2
                ]),
                children: [
                    changeRowSpan.canAdd ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        id: `${id}-add-rowspan`,
                        className: (0, $cqVqv.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxPlus
                        ]),
                        title: "Add row span",
                        "aria-label": "Add row span",
                        onClick: ()=>dispatch({
                                operation: (0, $feHBz.ADD_ROW_SPAN),
                                location: location,
                                newSpan: thisCell.rowSpan + 1
                            })
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton
                    }),
                    changeRowSpan.canRemove && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        id: `${id}-remove-rowspan`,
                        className: (0, $cqVqv.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxMinus
                        ]),
                        title: "Remove row span",
                        "aria-label": "Remove row span",
                        onClick: ()=>dispatch({
                                operation: (0, $feHBz.REMOVE_ROW_SPAN),
                                location: location,
                                newSpan: thisCell.rowSpan - 1
                            })
                    })
                ]
            })
        ]
    });
};
$7bea0ae23d4214b9$export$740be5db2e61b2a3.displayName = "AitCellRowSpans";

});

parcelRegister("a9tvf", function(module, exports) {

$parcel$export(module.exports, "AitCellWidth", function () { return $0c229e670e273dc8$export$dc84ad22932f5ba1; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $4gy1I = parcelRequire("4gy1I");

var $gOa7m = parcelRequire("gOa7m");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $0c229e670e273dc8$export$dc84ad22932f5ba1 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const displayColWidth = (0, $7fPBF.useMemo)(()=>{
        if (state && location.position === (0, $feHBz.AitTablePosition).headerCell && thisCell) {
            const thisHeaderCell = thisCell;
            if (thisHeaderCell.colSpan >= 2) {
                const thisHeaderRow = (0, $5mBpH.trGetPositionFromLocation)(state, {
                    ...location,
                    position: (0, $feHBz.AitTablePosition).headerRow
                }).data;
                /* istanbul ignore else */ if (thisHeaderRow) return {
                    width: thisHeaderRow.cells.slice(location.column, location.column + thisHeaderCell.colSpan).map((c)=>c.colWidth ?? // istanbul ignore next
                        state.defaultCellWidth).reduce((a, b)=>a + b, 0),
                    calculated: true
                };
            }
        }
        return {
            width: thisCell?.colWidth
        };
    }, [
        location,
        state,
        thisCell
    ]);
    return !state || !thisCell ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4gy1I.AioNumber), {
            id: `${id}-width`,
            label: "Width (mm)",
            value: displayColWidth.width ?? // istanbul ignore next
            state.defaultCellWidth,
            setValue: state.editable && !displayColWidth.calculated && !location.isRepeat ? (ret)=>dispatch({
                    operation: (0, $feHBz.UPDATE_COLUMN_WIDTH),
                    location: location,
                    value: ret
                }) : undefined
        })
    });
};
$0c229e670e273dc8$export$dc84ad22932f5ba1.displayName = "AitCellWidth";

});

parcelRegister("8gmiT", function(module, exports) {

$parcel$export(module.exports, "AitCommentRow", function () { return $6911ac8cc37ea850$export$c897d27006e3cd3a; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cniV6 = parcelRequire("cniV6");

var $gOa7m = parcelRequire("gOa7m");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $6911ac8cc37ea850$export$c897d27006e3cd3a = ({ location: location })=>{
    const id = (0, $7fPBF.useId)();
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const locationPoint = (0, $5mBpH.trGetPositionFromLocation)(state, location, true);
    const thisComment = locationPoint.data && "comments" in locationPoint.data ? locationPoint.data.comments : "";
    const isLocationRepeat = "isRepeat" in location ? location.isRepeat : false;
    return !state ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cniV6.AioComment), {
            id: `${state.id}-${location.position}-comment-${id}`,
            label: "Notes",
            value: thisComment,
            editable: state.editable && !isLocationRepeat,
            setValue: (ret)=>{
                dispatch({
                    operation: (0, $feHBz.UPDATE_COMMENTS),
                    location: location,
                    comment: ret
                });
            }
        })
    });
};
$6911ac8cc37ea850$export$c897d27006e3cd3a.displayName = "AitCommentRow";

});


parcelRegister("llmyo", function(module, exports) {

$parcel$export(module.exports, "clickCell", function () { return $ab3f343cc001b4b7$export$42e583b3f7d813c2; });
$parcel$export(module.exports, "AitHeaderCell", function () { return $ab3f343cc001b4b7$export$bf406f4913f10b4a; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $7fPBF = parcelRequire("7fPBF");

var $gOa7m = parcelRequire("gOa7m");

var $8vQMY = parcelRequire("8vQMY");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");

var $cqVqv = parcelRequire("cqVqv");

var $asuxf = parcelRequire("asuxf");

var $88YCB = parcelRequire("88YCB");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $fCWrt = parcelRequire("fCWrt");

var $5mBpH = parcelRequire("5mBpH");
const $ab3f343cc001b4b7$export$42e583b3f7d813c2 = (e)=>{
    e.preventDefault();
    e.stopPropagation();
    if (e.target instanceof HTMLTableCellElement) {
        const innerClick = new MouseEvent("click", {
            bubbles: true,
            cancelable: true
        });
        const editor = e.target.querySelector("div.aiev3");
        editor?.dispatchEvent(innerClick);
    }
};
const $ab3f343cc001b4b7$export$bf406f4913f10b4a = ({ location: location, ...rest })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const Editor = state?.editorProps.Editor;
    const thisCell = state?.processedTableData ? (0, $fCWrt.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const thisHeaderRow = (0, $5mBpH.trGetPositionFromLocation)(state, {
        ...location,
        position: (0, $feHBz.AitTablePosition).headerRow
    }, true).data;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const displayText = thisCell?.replacedText ?? thisCell?.text ?? state?.editorProps.blankT ?? (0, $jP37Y.defaultEditorDefns).blankT;
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 1;
    const decimalAlignPercent = state?.processedTableData?.decimalAlignPercent ?? 60;
    // Static options/variables
    const currentReadOnly = (0, $7fPBF.useMemo)(()=>!state || !thisCell ? true : !state.editable || location.isRepeat, [
        location.isRepeat,
        state,
        thisCell
    ]);
    const displayColWidth = (0, $7fPBF.useMemo)(()=>{
        if ((thisCell?.repeatColSpan ?? thisCell?.colSpan ?? 1) >= 2) {
            /* istanbul ignore else */ if (thisHeaderRow) return {
                width: thisHeaderRow.cells.slice(location.column, location.column + (thisCell.repeatColSpan ?? thisCell.colSpan)).map((c)=>c.colWidth ?? // istanbul ignore next
                    state.defaultCellWidth).reduce((a, b)=>a + b, 0),
                calculated: true
            };
        }
        return {
            width: thisCell?.colWidth ?? 0
        };
    }, [
        location.column,
        state,
        thisCell,
        thisHeaderRow
    ]);
    // Update cell style when options change
    const cellStyle = (0, $7fPBF.useMemo)(()=>!state || !thisCell ? {} : {
            overflow: "visible",
            width: `${state.colWidthMod * displayColWidth.width}px`,
            borderLeft: state.showCellBorders ? "1px dashed burlywood" : "",
            borderBottom: state.showCellBorders ? "1px dashed burlywood" : "",
            borderRight: state.showCellBorders && location.column === (state.processedTableData?.rowHeaderColumns ?? // istanbul ignore next
            0) - thisCell.colSpan ? "1px solid burlywood" : state.showCellBorders ? "1px dashed burlywood" : "",
            borderTop: state.showCellBorders && location.row === 0 && location.rowGroup !== undefined && state.showCellBorders ? "1px dashed burlywood" : ""
        }, [
        displayColWidth.width,
        location.column,
        location.row,
        location.rowGroup,
        state,
        thisCell
    ]);
    // Traffic light
    const cellTrafficLight = !state?.noTrafficLights && !location.isRepeat && thisCell && ![
        "BlankNotEvaluated",
        "GreenOk"
    ].includes(thisCell.coreTrafficLight) ? new (0, $8vQMY.MosaicTrafficLightClass)(thisCell.coreTrafficLight, "-4px", "-8px", "absolute").element : null;
    // Render element
    return !Editor || !thisCell || thisCell.colSpan === 0 || thisCell.rowSpan === 0 || thisCell.repeatColSpan === 0 || thisCell.repeatRowSpan === 0 || location.row === undefined || location.column === undefined ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
        ...rest,
        id: id,
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitHeaderCell,
            currentReadOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitReadonlyCell : ""
        ]),
        colSpan: thisCell.repeatColSpan ?? thisCell.colSpan,
        rowSpan: (thisCell.repeatRowSpan ?? thisCell.rowSpan) + (thisCell.spaceAfterSpan ?? 0),
        style: cellStyle,
        onClick: $ab3f343cc001b4b7$export$42e583b3f7d813c2,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                style: {
                    width: cellStyle.width,
                    height: "100%"
                },
                children: [
                    cellTrafficLight,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d8dTd.ContextMenuHandler), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder,
                        menuItems: [
                            {
                                label: "Show cell options",
                                action: ()=>{
                                    const focusDummy = document.createElement("input");
                                    document.body.appendChild(focusDummy);
                                    focusDummy.focus();
                                    focusDummy.remove();
                                    dispatch({
                                        operation: (0, $feHBz.SHOW_OPTIONS_WINDOW),
                                        location: location
                                    });
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Editor, {
                            id: `${id}-editor`,
                            decimalAlignPercent: decimalAlignPercent,
                            editable: !currentReadOnly,
                            preReplacedText: thisCell.text,
                            setValue: (ret)=>{
                                dispatch({
                                    operation: (0, $feHBz.UPDATE_HEADER_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                });
                            },
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).editorInput,
                            textAlignment: !thisCell.justifyText || thisCell.justifyText === "default" ? location.column < (rowHeaderColumns ?? // istanbul ignore next
                            0) ? "left" : "center" : thisCell.justifyText,
                            value: displayText,
                            commentConfig: {
                                id: id ?? // istanbul ignore next
                                "",
                                activeContext: "TlfItem",
                                label: "New cell comment",
                                iconPosition: {
                                    top: "-2px",
                                    left: "-2px"
                                },
                                noIcon: location.isRepeat
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $asuxf.AitCellWindow), {
                location: location
            })
        ]
    });
};
$ab3f343cc001b4b7$export$bf406f4913f10b4a.displayName = "AitHeaderCell";

});


parcelRegister("95odm", function(module, exports) {

$parcel$export(module.exports, "AitColumnAnnotationPreviewRow", function () { return $97d007455fba4ca4$export$3ca059bedcde62a; });

var $bbzbN = parcelRequire("bbzbN");

var $giacK = parcelRequire("giacK");

var $aKDek = parcelRequire("aKDek");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

var $cqVqv = parcelRequire("cqVqv");

var $5Gkzg = parcelRequire("5Gkzg");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $97d007455fba4ca4$export$3ca059bedcde62a = ()=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const headerData = state?.processedTableData?.headerData;
    const ref = (0, $7fPBF.useRef)(null);
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    const columnRepeats = state?.processedTableData?.columnRepeats ?? // istanbul ignore next
    [];
    const [annotationModalState, setAnnotationModalState] = (0, $7fPBF.useState)({
        isOpen: false
    });
    if (!showAnnotationPreview || !headerData) return null;
    // Get the last row of the header to access column annotations
    const lastHeaderRow = headerData.rows[headerData.rows.length - 1];
    if (!lastHeaderRow) return null;
    const annotationModal = annotationModalState.isOpen && annotationModalState.cellId !== undefined && annotationModalState.columnIndex !== undefined && annotationModalState.originalColumnIndex !== undefined ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $giacK.AnnotationContextWindow), {
        isOpen: annotationModalState.isOpen,
        onClose: ()=>setAnnotationModalState({
                isOpen: false
            }),
        annotationLocation: {
            position: (0, $feHBz.AitTablePosition).column,
            columnId: annotationModalState.cellId,
            originalColumn: annotationModalState.originalColumnIndex
        },
        annotationType: "Column",
        contextAnnotation: state.originalTableData.columnInformation?.find((ci)=>ci.columnId === annotationModalState.cellId)?.annotation,
        disabled: !state.editable
    }) : null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                        className: "ait-cell"
                    }),
                    lastHeaderRow.cells.map((cell, ci)=>{
                        // Calculate effective colspan (accounts for column repeats)
                        const effectiveColSpan = cell.repeatColSpan ?? cell.colSpan;
                        // Calculate the width based on effective colspan
                        const cellWidth = effectiveColSpan >= 2 ? lastHeaderRow.cells.slice(ci, ci + effectiveColSpan).map((c)=>c.colWidth ?? // istanbul ignore next
                            state.defaultCellWidth).reduce((a, b)=>a + b, 0) : cell.colWidth ?? // istanbul ignore next
                        state.defaultCellWidth;
                        const displayWidth = `${state.colWidthMod * cellWidth}px`;
                        // Get original column index from columnRepeats
                        const originalColumnIndex = columnRepeats[ci]?.columnIndex ?? // istanbul ignore next
                        ci;
                        const isColumnRepeat = columnRepeats[ci] !== undefined && columnRepeats[ci].colRepeat !== undefined ? columnRepeats[ci].colRepeat.match(/^[[\]0,]+$/) === null : false;
                        // Get the annotation for this column from columnInformation
                        const columnAnnotation = state.originalTableData.columnInformation?.find((colInfo)=>colInfo.columnId === cell.columnId)?.annotation;
                        return /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                            className: (0, $cqVqv.classMerge)([
                                `ait-cell ${(0, (/*@__PURE__*/$parcel$interopDefault($5Gkzg))).columnAnnotationCell}`
                            ]),
                            colSpan: effectiveColSpan,
                            style: {
                                width: displayWidth,
                                minWidth: displayWidth,
                                maxWidth: displayWidth
                            },
                            children: !isColumnRepeat && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $aKDek.AnnotationPreviewBubble), {
                                annotation: columnAnnotation,
                                variant: "column",
                                target: ref,
                                onClick: ()=>{
                                    setAnnotationModalState({
                                        isOpen: true,
                                        cellId: cell.columnId,
                                        columnIndex: ci,
                                        originalColumnIndex: originalColumnIndex
                                    });
                                }
                            })
                        }, `col-annotation-${cell.columnId}-${ci}`);
                    })
                ]
            }),
            annotationModal && typeof document !== "undefined" ? /*#__PURE__*/ (0, $fw0lo.createPortal)(annotationModal, document.body) : null
        ]
    });
};
$97d007455fba4ca4$export$3ca059bedcde62a.displayName = "AitColumnAnnotationPreviewRow";

});
parcelRegister("5Gkzg", function(module, exports) {

$parcel$export(module.exports, "columnAnnotationCell", function () { return $4230d455fb9173ba$export$35fa903b7f71b39; }, function (v) { return $4230d455fb9173ba$export$35fa903b7f71b39 = v; });
var $4230d455fb9173ba$export$35fa903b7f71b39;
$4230d455fb9173ba$export$35fa903b7f71b39 = `mos-AitColumnAnnotationPreviewRow-module-lKuulq-columnAnnotationCell`;

});


parcelRegister("3ZsBw", function(module, exports) {

$parcel$export(module.exports, "AitHeader", function () { return $b6a992a8c3d04ae0$export$602f446165ff67c5; });

var $bbzbN = parcelRequire("bbzbN");

var $3s4yO = parcelRequire("3s4yO");

var $95odm = parcelRequire("95odm");

var $34Mfo = parcelRequire("34Mfo");

var $88YCB = parcelRequire("88YCB");

var $feHBz = parcelRequire("feHBz");
const $b6a992a8c3d04ae0$export$602f446165ff67c5 = ()=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisHeader = state?.processedTableData?.headerData;
    const id = `${state?.id}-header`;
    const rows = thisHeader ? thisHeader.rows : [];
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    return !state ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("thead", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3s4yO.AitBorderRow), {
                id: `${id}-top-border`,
                spaceAfter: true,
                topBorder: true
            }),
            showAnnotationPreview && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $95odm.AitColumnAnnotationPreviewRow), {}),
            thisHeader && rows.map((row, ri)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $34Mfo.AitHeaderRow), {
                    location: {
                        tableSection: (0, $feHBz.AitRowType).header,
                        position: (0, $feHBz.AitTablePosition).headerRow,
                        rowGroup: 0,
                        rowGroupId: thisHeader.aitid,
                        rowId: row.aitid,
                        rowRepeat: undefined,
                        row: ri,
                        isRepeat: false
                    }
                }, row.aitid)),
            // No border required if thisHeader is false/undefined
            !thisHeader || rows.length === 0 ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3s4yO.AitBorderRow), {
                id: `${id}-midtable-border`,
                spaceBefore: true,
                spaceAfter: true
            })
        ]
    });
};
$b6a992a8c3d04ae0$export$602f446165ff67c5.displayName = "AitHeader";

});
parcelRegister("34Mfo", function(module, exports) {

$parcel$export(module.exports, "AitHeaderRow", function () { return $0f3437a2bb504935$export$7b1459f869ce1381; });

var $bbzbN = parcelRequire("bbzbN");

var $llmyo = parcelRequire("llmyo");

var $fBigz = parcelRequire("fBigz");

var $5Kh11 = parcelRequire("5Kh11");

var $88YCB = parcelRequire("88YCB");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");
const $0f3437a2bb504935$export$7b1459f869ce1381 = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const thisHeaderRow = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const columnRepeats = state?.processedTableData?.columnRepeats;
    return !state || !state.processedTableData || !thisHeaderRow || !columnRepeats || location.row === undefined ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
        id: id,
        role: "row",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fBigz.AitHeaderRowFirstCell), {
                location: location
            }),
            thisHeaderRow.cells.map((cell, ci)=>{
                // Get cell from column repeat
                const cr = Array.isArray(columnRepeats) && columnRepeats.length > ci ? columnRepeats[ci] : undefined;
                const isColumnRepeat = cr !== undefined && cr.colRepeat !== undefined ? cr.colRepeat.match(/^[[\]0,]+$/) === null : false;
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $llmyo.AitHeaderCell), {
                    location: {
                        ...location,
                        position: (0, $feHBz.AitTablePosition).headerCell,
                        cellId: cell.aitid,
                        cellType: (0, $feHBz.AitCellType).header,
                        column: ci,
                        colRepeat: cr?.colRepeat ?? "",
                        isRepeat: location.isRepeat || isColumnRepeat,
                        originalColumn: columnRepeats[ci].columnIndex
                    }
                }, `${cell.aitid}-${ci}`);
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5Kh11.AitHeaderRowLastCell), {
                location: location
            })
        ]
    });
};
$0f3437a2bb504935$export$7b1459f869ce1381.displayName = "AitHeaderRow";

});
parcelRegister("fBigz", function(module, exports) {

$parcel$export(module.exports, "AitHeaderRowFirstCell", function () { return $f583e550d70c894e$export$e63bcac22f65f481; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $kbkyI = parcelRequire("kbkyI");

var $5f5pt = parcelRequire("5f5pt");

var $jq6k8 = parcelRequire("jq6k8");

var $feHBz = parcelRequire("feHBz");
const $f583e550d70c894e$export$e63bcac22f65f481 = ({ location: location })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
        width: "50px",
        children: [
            location.row === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jq6k8.AitRowGroupTrafficLight), {
                location: {
                    ...location,
                    position: (0, $feHBz.AitTablePosition).header
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitRowGroupButtons,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexRowEnd
                ]),
                children: location.row === 0 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f5pt.AitRowGroupOptionsButton), {
                            location: {
                                position: (0, $feHBz.AitTablePosition).header,
                                tableSection: location.tableSection,
                                rowGroup: location.rowGroup,
                                rowGroupId: location.rowGroupId
                            }
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kbkyI.AitHeaderOptionsWindow), {})
                    ]
                })
            })
        ]
    });
$f583e550d70c894e$export$e63bcac22f65f481.displayName = "AitHeaderRowFirstCell";

});
parcelRegister("kbkyI", function(module, exports) {

$parcel$export(module.exports, "AitHeaderOptionsWindow", function () { return $d6d0767758da90cb$export$f138948b670bdfe5; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $gSkQi = parcelRequire("gSkQi");

var $8gmiT = parcelRequire("8gmiT");

var $h5qDy = parcelRequire("h5qDy");

var $gW6K8 = parcelRequire("gW6K8");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $d6d0767758da90cb$export$f138948b670bdfe5 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const headerData = state?.processedTableData?.headerData;
    const location = {
        position: (0, $feHBz.AitTablePosition).header,
        tableSection: (0, $feHBz.AitRowType).header,
        rowGroup: 0,
        rowGroupId: headerData ? headerData.aitid : ""
    };
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    return !headerData ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ContextWindow), {
        id: `${id}-header-options-window`,
        title: "Header options",
        visible: state.showOptionsWindow.findIndex((l)=>(0, $gSkQi.isEqual)(l, location)) > -1,
        onClose: ()=>{
            dispatch({
                operation: (0, $feHBz.HIDE_OPTIONS_WINDOW),
                location: location
            });
        },
        style: {
            maxHeight: "75vh"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gmiT.AitCommentRow), {
                location: location
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $gW6K8.AitRowHeaderColumns), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h5qDy.AitRowGroupReplacements), {
                location: location
            })
        ]
    });
};
$d6d0767758da90cb$export$f138948b670bdfe5.displayName = "AitHeaderOptionsWindow";

});
parcelRegister("h5qDy", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupReplacements", function () { return $e006cb17e6e1c39d$export$2f4ea3c13f465f1b; });

var $bbzbN = parcelRequire("bbzbN");

var $3gAtF = parcelRequire("3gAtF");

var $gOa7m = parcelRequire("gOa7m");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $e006cb17e6e1c39d$export$2f4ea3c13f465f1b = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const thisRowGroup = state?.processedTableData ? (0, $5mBpH.trGetPositionFromLocation)(state, location).data : undefined;
    const id = `${(0, $gqx25.getBaseId)(location, state?.id)}-replacements`;
    return !state || !thisRowGroup ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3gAtF.AioReplacementList), {
            id: id,
            label: "Replacements",
            replacements: thisRowGroup.replacements ?? // istanbul ignore next
            [],
            setReplacements: state.editable ? (ret)=>dispatch({
                    operation: (0, $feHBz.SET_REPLACEMENTS),
                    location: location,
                    replacements: ret
                }) : undefined,
            externalLists: state.externalLists,
            dontAskSpace: location.tableSection === (0, $feHBz.AitRowType).header,
            dontAskTrail: location.tableSection === (0, $feHBz.AitRowType).header,
            editorProps: state.editorProps,
            level: 0
        })
    });
};
$e006cb17e6e1c39d$export$2f4ea3c13f465f1b.displayName = "AitRowGroupReplacements";

});

parcelRegister("gW6K8", function(module, exports) {

$parcel$export(module.exports, "AitRowHeaderColumns", function () { return $acdea9e3e2f8e945$export$b23b6e9eae0c3bf5; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $qLJkH = parcelRequire("qLJkH");

var $afZri = parcelRequire("afZri");

var $88YCB = parcelRequire("88YCB");
const $acdea9e3e2f8e945$export$b23b6e9eae0c3bf5 = ()=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns !== undefined ? state.processedTableData.rowHeaderColumns : 1;
    return !state ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioLabel,
                children: "Row headers: "
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                "aria-label": "Row headers",
                role: "status",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioRoValue,
                children: rowHeaderColumns
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButtonHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).padding2
                ]),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $qLJkH.AitRowHeaderColumnsAdd), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afZri.AitRowHeaderColumnsRemove), {})
                ]
            })
        ]
    });
};
$acdea9e3e2f8e945$export$b23b6e9eae0c3bf5.displayName = "AitRowHeaderColumns";

});
parcelRegister("qLJkH", function(module, exports) {

$parcel$export(module.exports, "AitRowHeaderColumnsAdd", function () { return $332d72e8bf93332f$export$7275d6cab1e25d6; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $332d72e8bf93332f$export$7275d6cab1e25d6 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns !== undefined ? state.processedTableData.rowHeaderColumns : 1;
    return state && state.editable && state.processedTableData?.bodyData && state.processedTableData?.bodyData.length > 0 && state.processedTableData?.bodyData[0].rows.length > 0 && rowHeaderColumns < state.processedTableData?.bodyData[0].rows[0].cells.length - 1 ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: `${state.id}-add-row-header-column`,
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxPlus
        ]),
        "aria-label": "Increase row header columns",
        role: "button",
        onClick: ()=>dispatch({
                operation: (0, $feHBz.SET_ROW_HEADER_COLUMNS),
                value: rowHeaderColumns + 1
            })
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton
    });
};
$332d72e8bf93332f$export$7275d6cab1e25d6.displayName = "AitRowHeaderColumnsAdd";

});

parcelRegister("afZri", function(module, exports) {

$parcel$export(module.exports, "AitRowHeaderColumnsRemove", function () { return $0b10c84edf638d07$export$107228130358bd8b; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $0b10c84edf638d07$export$107228130358bd8b = ()=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns !== undefined ? state.processedTableData.rowHeaderColumns : 1;
    return !state || !state.editable || rowHeaderColumns === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton
    }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, $cqVqv.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxButton,
            (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aioxMinus
        ]),
        id: `${state.id}-remove-row-header-column`,
        "aria-label": "Decrease row header columns",
        role: "button",
        onClick: ()=>dispatch({
                operation: (0, $feHBz.SET_ROW_HEADER_COLUMNS),
                value: rowHeaderColumns - 1
            })
    });
};
$0b10c84edf638d07$export$107228130358bd8b.displayName = "AitRowHeaderColumnsRemove";

});



parcelRegister("5f5pt", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupOptionsButton", function () { return $5eea3c2473832fb5$export$217609e4806a14a5; });

var $bbzbN = parcelRequire("bbzbN");

var $gSkQi = parcelRequire("gSkQi");

var $5m3yv = parcelRequire("5m3yv");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $5eea3c2473832fb5$export$217609e4806a14a5 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${id}-rowgroup-options`,
        tipText: location.position === (0, $feHBz.AitTablePosition).header ? "Header options" : "Row group options",
        iconName: "aioxButtonRowGroup",
        onClick: ()=>{
            dispatch({
                operation: state?.showOptionsWindow.findIndex((l)=>(0, $gSkQi.isEqual)(l, location)) === -1 ? (0, $feHBz.SHOW_OPTIONS_WINDOW) : (0, $feHBz.HIDE_OPTIONS_WINDOW),
                location: location
            });
        }
    });
};
$5eea3c2473832fb5$export$217609e4806a14a5.displayName = "AitRowGroupOptionsButton";

});

parcelRegister("jq6k8", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupTrafficLight", function () { return $e46c55bc72800ea0$export$d38eccab70eaa01d; });

var $8vQMY = parcelRequire("8vQMY");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $e46c55bc72800ea0$export$d38eccab70eaa01d = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const coreTrafficLight = thisRowGroup?.coreTrafficLight ?? "BlankNotEvaluated";
    return !state?.noTrafficLights && coreTrafficLight !== "BlankNotEvaluated" ? new (0, $8vQMY.MosaicTrafficLightClass)(coreTrafficLight, "4px", "-16px").element : null;
};
$e46c55bc72800ea0$export$d38eccab70eaa01d.displayName = "AitRowGroupTrafficLight";

});


parcelRegister("5Kh11", function(module, exports) {

$parcel$export(module.exports, "AitHeaderRowLastCell", function () { return $95948ab03beae052$export$500807074636dbe2; });

var $bbzbN = parcelRequire("bbzbN");

var $2ocuT = parcelRequire("2ocuT");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $5LsQw = parcelRequire("5LsQw");

var $bx6jT = parcelRequire("bx6jT");

var $bilUw = parcelRequire("bilUw");

var $33DLH = parcelRequire("33DLH");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $95948ab03beae052$export$500807074636dbe2 = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRow = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
        width: "50px",
        children: [
            location.row === 0 && !location.isRepeat && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $33DLH.AitRowGroupDeletedItemTrafficLight), {
                location: {
                    position: (0, $feHBz.AitTablePosition).header,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bilUw.AitRowDeletedItemTrafficLight), {
                location: location
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexRowStart,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder
                ]),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitRowButtons,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5LsQw.AitAddRowButton), {
                                location: location
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bx6jT.AitRemoveRowButton), {
                                location: location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ocuT.AnnotationButton), {
                        buttonId: `${location.position}-row-${location.rowId}-annotation`,
                        annotationType: "Row",
                        annotationLocation: location,
                        existingAnnotation: thisRow?.annotation,
                        hidden: state?.tlfViewMode.value !== "ANNOTATIONS",
                        showPreview: state?.tlfViewMode.value === "ANNOTATIONS"
                    })
                ]
            })
        ]
    });
};
$95948ab03beae052$export$500807074636dbe2.displayName = "AitHeaderRowLastCell";

});
parcelRegister("bx6jT", function(module, exports) {

$parcel$export(module.exports, "AitRemoveRowButton", function () { return $9bc62929e6cefdde$export$11bf415b53ace422; });

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $5m3yv = parcelRequire("5m3yv");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $9bc62929e6cefdde$export$11bf415b53ace422 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const thisRowGroup = location.position === (0, $feHBz.AitTablePosition).headerRow ? state?.originalTableData.headerData : state?.originalTableData.bodyData.find((group)=>group.aitid === location.rowGroupId);
    const canRemoveRow = (0, $7fPBF.useMemo)(()=>{
        return state?.editable && thisRowGroup ? thisRowGroup.rows.length > 1 : false;
    }, [
        state?.editable,
        thisRowGroup
    ]);
    return !state || !thisRowGroup || !canRemoveRow ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${state.id}-remove-row`,
        tipText: "Remove row",
        iconName: "aioxMinus",
        "aria-label": "Remove row",
        onClick: ()=>{
            dispatch({
                operation: (0, $feHBz.REMOVE_ROW),
                location: location,
                newLength: thisRowGroup.rows.length - 1
            });
        }
    });
};
$9bc62929e6cefdde$export$11bf415b53ace422.displayName = "AitRemoveRowButton";

});

parcelRegister("bilUw", function(module, exports) {

$parcel$export(module.exports, "AitRowDeletedItemTrafficLight", function () { return $4e1ac624b50a639b$export$d7787c39ff111c99; });

var $8vQMY = parcelRequire("8vQMY");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $4e1ac624b50a639b$export$d7787c39ff111c99 = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, {
        position: location.position === (0, $feHBz.AitTablePosition).headerRow ? (0, $feHBz.AitTablePosition).header : (0, $feHBz.AitTablePosition).bodyRowGroup,
        tableSection: location.tableSection,
        rowGroup: location.rowGroup,
        rowGroupId: location.rowGroupId
    }, true).data;
    const deletedItemTrafficLight = (thisRowGroup?.changedRows?.filter((dr)=>dr.coreTrafficLight === "RedError" && dr.idAfterTrafficLightIsShown === location.rowId).length ?? 0) > 0 ? "RedError" : "BlankNotEvaluated";
    return !state?.noTrafficLights && deletedItemTrafficLight !== "BlankNotEvaluated" ? new (0, $8vQMY.MosaicTrafficLightClass)(deletedItemTrafficLight, "-4px", "-8px").element : null;
};
$4e1ac624b50a639b$export$d7787c39ff111c99.displayName = "AitRowDeletedItemTrafficLight";

});

parcelRegister("33DLH", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupDeletedItemTrafficLight", function () { return $c260e0886a523338$export$b7931672b030692d; });

var $8vQMY = parcelRequire("8vQMY");

var $88YCB = parcelRequire("88YCB");
const $c260e0886a523338$export$b7931672b030692d = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const deletedItemTrafficLight = (state?.processedTableData?.changedRowGroups?.filter((drg)=>drg.coreTrafficLight === "RedError" && drg.idAfterTrafficLightIsShown === location.rowGroupId).length ?? 0) > 0 ? "RedError" : "BlankNotEvaluated";
    return !state?.noTrafficLights && deletedItemTrafficLight !== "BlankNotEvaluated" ? new (0, $8vQMY.MosaicTrafficLightClass)(deletedItemTrafficLight, "-8px", "40px").element : null;
};
$c260e0886a523338$export$b7931672b030692d.displayName = "AitRowGroupDeletedItemTrafficLight";

});




parcelRegister("6DbFS", function(module, exports) {

$parcel$export(module.exports, "AitRemoveRowGroupButton", function () { return $f6afe60b288e6aa2$export$be06a28eb12bcc76; });

var $bbzbN = parcelRequire("bbzbN");

var $5m3yv = parcelRequire("5m3yv");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $f6afe60b288e6aa2$export$be06a28eb12bcc76 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    return !state || !thisRowGroup || !state.editable || !state.processedTableData || state.processedTableData.bodyData.length < 2 ? null : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5m3yv.AioIconButton), {
        id: `${id}-remove-rowgroup`,
        tipText: "Remove row group",
        iconName: "aioxMinus",
        onClick: ()=>dispatch({
                operation: (0, $feHBz.REMOVE_ROW_GROUP),
                location: location,
                newLength: state.originalTableData.bodyData.length - 1
            })
    });
};
$f6afe60b288e6aa2$export$be06a28eb12bcc76.displayName = "AitRemoveRowGroupButton";

});

parcelRegister("l2vMU", function(module, exports) {

$parcel$export(module.exports, "AitRow", function () { return $d08f137819fdbc96$export$7cfeb9b0bb6a5b0b; });

var $bbzbN = parcelRequire("bbzbN");

var $3s4yO = parcelRequire("3s4yO");

var $1qN19 = parcelRequire("1qN19");

var $kzPKK = parcelRequire("kzPKK");

var $guNKk = parcelRequire("guNKk");

var $88YCB = parcelRequire("88YCB");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");
const $d08f137819fdbc96$export$7cfeb9b0bb6a5b0b = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const thisRow = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const columnRepeats = state?.processedTableData?.columnRepeats ?? [];
    const cells = thisRow?.cells ?? [];
    const spaceAfter = thisRow?.spaceAfter ?? false;
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 0;
    return !thisRow ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                id: `${id}`,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $kzPKK.AitRowFirstCell), {
                        location: location
                    }),
                    cells.map((cell, ci)=>{
                        // Get cell from column repeat
                        const cr = Array.isArray(columnRepeats) && columnRepeats.length > ci ? columnRepeats[ci] : undefined;
                        const isColumnRepeat = cr !== undefined && cr.colRepeat !== undefined ? cr.colRepeat.match(/^[[\]0,]+$/) === null : false;
                        // Render object
                        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $1qN19.AitCell), {
                            location: {
                                ...location,
                                position: (0, $feHBz.AitTablePosition).bodyCell,
                                column: ci,
                                colRepeat: cr?.colRepeat ?? "",
                                cellId: cell.aitid,
                                cellType: (cr?.columnIndex ?? // istanbul ignore next
                                1) < rowHeaderColumns ? (0, $feHBz.AitCellType).rowHeader : (0, $feHBz.AitCellType).body,
                                isRepeat: location.isRepeat || isColumnRepeat,
                                originalColumn: columnRepeats[ci]?.columnIndex ?? // istanbul ignore next
                                ci
                            }
                        }, isColumnRepeat && cr ? `${cell.aitid}-${JSON.stringify(cr.colRepeat)}` : cell.aitid);
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $guNKk.AitRowLastCell), {
                        location: location
                    })
                ]
            }),
            (spaceAfter !== false || cells.some((c)=>c.spaceAfterRepeat)) && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3s4yO.AitBorderRow), {
                id: `${id}-spaceafter-row`,
                spaceAfter: true,
                noBorder: true
            })
        ]
    });
};
$d08f137819fdbc96$export$7cfeb9b0bb6a5b0b.displayName = "AitRow";

});
parcelRegister("kzPKK", function(module, exports) {

$parcel$export(module.exports, "AitRowFirstCell", function () { return $2ef3af6aabd6a164$export$7602816e942f3095; });

var $bbzbN = parcelRequire("bbzbN");

var $gOa7m = parcelRequire("gOa7m");

var $7QFkw = parcelRequire("7QFkw");

var $jq6k8 = parcelRequire("jq6k8");

var $feHBz = parcelRequire("feHBz");
const $2ef3af6aabd6a164$export$7602816e942f3095 = ({ location: location })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
        width: "50px",
        children: [
            location.row === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jq6k8.AitRowGroupTrafficLight), {
                location: {
                    position: (0, $feHBz.AitTablePosition).bodyRowGroup,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            }),
            location.row === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7QFkw.AitRowGroupButtons), {
                location: {
                    position: (0, $feHBz.AitTablePosition).bodyRowGroup,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            })
        ]
    });
$2ef3af6aabd6a164$export$7602816e942f3095.displayName = "AitRowFirstCell";

});
parcelRegister("7QFkw", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupButtons", function () { return $1abd8865190004e4$export$e388b51195b92d37; });

var $bbzbN = parcelRequire("bbzbN");

var $2ocuT = parcelRequire("2ocuT");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $tzgiU = parcelRequire("tzgiU");

var $6DbFS = parcelRequire("6DbFS");

var $5f5pt = parcelRequire("5f5pt");

var $lH8yx = parcelRequire("lH8yx");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $1abd8865190004e4$export$e388b51195b92d37 = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const showAnnotation = state?.tlfViewMode.value === "ANNOTATIONS";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ocuT.AnnotationButton), {
                buttonId: `${location.position}-rowgroup-${location.rowGroupId}-annotation`,
                annotationType: "RowGroup",
                annotationLocation: location,
                existingAnnotation: thisRowGroup?.annotation,
                hidden: !showAnnotation,
                showPreview: showAnnotation
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitRowGroupButtons,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexRowEnd
                ]),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6DbFS.AitRemoveRowGroupButton), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $tzgiU.AitAddRowGroupButton), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f5pt.AitRowGroupOptionsButton), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $lH8yx.AitRowGroupOptionsWindow), {
                        location: location
                    })
                ]
            })
        ]
    });
};
$1abd8865190004e4$export$e388b51195b92d37.displayName = "AitRowGroupButtons";

});
parcelRegister("lH8yx", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupOptionsWindow", function () { return $fea7316c4b3bd52f$export$a7e35f4b581e7232; });

var $bbzbN = parcelRequire("bbzbN");

var $d8dTd = parcelRequire("d8dTd");

var $gSkQi = parcelRequire("gSkQi");

var $8gmiT = parcelRequire("8gmiT");

var $h5qDy = parcelRequire("h5qDy");

var $hOlvX = parcelRequire("hOlvX");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $fea7316c4b3bd52f$export$a7e35f4b581e7232 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location).data;
    const showRowGroupOptions = state && state.showOptionsWindow.findIndex((l)=>(0, $gSkQi.isEqual)(l, location)) > -1;
    return !thisRowGroup || !showRowGroupOptions ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d8dTd.ContextWindow), {
        id: `${id}-rowgroup-options-window`,
        title: "Row group options",
        visible: showRowGroupOptions,
        onClose: ()=>{
            dispatch({
                operation: (0, $feHBz.HIDE_OPTIONS_WINDOW),
                location: location
            });
        },
        style: {
            maxHeight: "75vh"
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8gmiT.AitCommentRow), {
                location: location
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $hOlvX.AitRowGroupSpaceAfter), {
                location: location
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $h5qDy.AitRowGroupReplacements), {
                location: location
            })
        ]
    });
};
$fea7316c4b3bd52f$export$a7e35f4b581e7232.displayName = "AitRowGroupOptionsWindow";

});
parcelRegister("hOlvX", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupSpaceAfter", function () { return $bdbf4c0fc06d33ee$export$26b0f783a13903e; });

var $bbzbN = parcelRequire("bbzbN");

var $jWyw9 = parcelRequire("jWyw9");

var $gOa7m = parcelRequire("gOa7m");

var $gqx25 = parcelRequire("gqx25");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $bdbf4c0fc06d33ee$export$26b0f783a13903e = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $88YCB.useTableContext)();
    const id = (0, $gqx25.getBaseId)(location, state?.id);
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location).data;
    return !state || !thisRowGroup ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $jWyw9.AioBoolean), {
            id: `${id}-spaceafter-group`,
            label: "Space after group",
            value: thisRowGroup.spaceAfter ?? // istanbul ignore next
            false,
            disabled: !state.editable,
            setValue: (bool)=>{
                dispatch({
                    operation: (0, $feHBz.SET_SPACE_AFTER),
                    location: location,
                    bool: bool
                });
            }
        })
    });
};
$bdbf4c0fc06d33ee$export$26b0f783a13903e.displayName = "AitRowGroupSpaceAfter";

});




parcelRegister("guNKk", function(module, exports) {

$parcel$export(module.exports, "AitRowLastCell", function () { return $72a99c72b1fcd6b6$export$a0c0b9565704f2b8; });

var $bbzbN = parcelRequire("bbzbN");

var $2ocuT = parcelRequire("2ocuT");

var $gOa7m = parcelRequire("gOa7m");

var $cqVqv = parcelRequire("cqVqv");

var $5LsQw = parcelRequire("5LsQw");

var $bx6jT = parcelRequire("bx6jT");

var $bilUw = parcelRequire("bilUw");

var $33DLH = parcelRequire("33DLH");

var $9u87i = parcelRequire("9u87i");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $72a99c72b1fcd6b6$export$a0c0b9565704f2b8 = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRow = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const showRowTrafficLight = thisRow?.coreTrafficLight === "ChangedUnknown";
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitCell,
        width: "50px",
        children: [
            showRowTrafficLight && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9u87i.AitRowTrafficLight), {
                location: location
            }),
            location.row === 0 && !location.isRepeat && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $33DLH.AitRowGroupDeletedItemTrafficLight), {
                location: {
                    position: (0, $feHBz.AitTablePosition).bodyRowGroup,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bilUw.AitRowDeletedItemTrafficLight), {
                location: location
            }),
            !location.isRepeat && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $cqVqv.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).flexRowStart,
                    (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitAieHolder
                ]),
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitRowButtons,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5LsQw.AitAddRowButton), {
                                location: location
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bx6jT.AitRemoveRowButton), {
                                location: location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ocuT.AnnotationButton), {
                        buttonId: `${location.position}-row-${location.rowId}-annotation`,
                        annotationType: "Row",
                        annotationLocation: location,
                        existingAnnotation: thisRow?.annotation,
                        hidden: state?.tlfViewMode.value !== "ANNOTATIONS",
                        showPreview: showAnnotationPreview
                    })
                ]
            })
        ]
    });
};
$72a99c72b1fcd6b6$export$a0c0b9565704f2b8.displayName = "AitRowLastCell";

});
parcelRegister("9u87i", function(module, exports) {

$parcel$export(module.exports, "AitRowTrafficLight", function () { return $13587e714d4b4b8c$export$279bce6043283abb; });

var $8vQMY = parcelRequire("8vQMY");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $13587e714d4b4b8c$export$279bce6043283abb = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRow = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    const coreTrafficLight = thisRow?.coreTrafficLight ?? // istanbul ignore next
    "BlankNotEvaluated";
    return !state?.noTrafficLights && coreTrafficLight !== "BlankNotEvaluated" ? new (0, $8vQMY.MosaicTrafficLightClass)(coreTrafficLight, "4px", "-16px").element : null;
};
$13587e714d4b4b8c$export$279bce6043283abb.displayName = "AitRowTrafficLight";

});



parcelRegister("brOC3", function(module, exports) {

$parcel$export(module.exports, "AitRowGroup", function () { return $a7895106ee5f0d40$export$940f0b7b4d70b6d6; });

var $bbzbN = parcelRequire("bbzbN");

var $l2vMU = parcelRequire("l2vMU");

var $feHBz = parcelRequire("feHBz");

var $5mBpH = parcelRequire("5mBpH");

var $88YCB = parcelRequire("88YCB");
const $a7895106ee5f0d40$export$940f0b7b4d70b6d6 = ({ location: location })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const thisRowGroup = (0, $5mBpH.trGetPositionFromLocation)(state, location, true).data;
    // Output the rows
    return !thisRowGroup ? null : /*#__PURE__*/ (0, $bbzbN.jsx)("tbody", {
        children: thisRowGroup.rows.map((row, ri)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $l2vMU.AitRow), {
                location: {
                    ...location,
                    position: (0, $feHBz.AitTablePosition).bodyRow,
                    rowId: row.aitid,
                    row: ri,
                    rowRepeat: !row.rowRepeat?.match(/^[[\]0,]+$/) ? row.rowRepeat ?? // istanbul ignore next
                    "" : undefined,
                    isRepeat: (row.rowRepeat ?? // istanbul ignore next
                    "") !== "" && row.rowRepeat?.match(/^[[\]0,]+$/) === null
                }
            }, `row-${ri}-${row.aitid}`))
    });
};
$a7895106ee5f0d40$export$940f0b7b4d70b6d6.displayName = "AitRowGroup";

});

parcelRegister("6u5Us", function(module, exports) {

$parcel$export(module.exports, "AitTable", function () { return $5267a470c9fd7815$export$2f7b0fa48de90557; });

var $bbzbN = parcelRequire("bbzbN");

var $2ocuT = parcelRequire("2ocuT");

var $gOa7m = parcelRequire("gOa7m");

var $3s4yO = parcelRequire("3s4yO");

var $3ZsBw = parcelRequire("3ZsBw");

var $brOC3 = parcelRequire("brOC3");

var $feHBz = parcelRequire("feHBz");

var $88YCB = parcelRequire("88YCB");
const $5267a470c9fd7815$export$2f7b0fa48de90557 = ({ id: id, style: style })=>{
    const { state: state } = (0, $88YCB.useTableContext)();
    const bodyData = state?.processedTableData?.bodyData;
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    // Calculate total number of columns for repositioning key
    // This ensures the preview bubble repositions when columns are added/removed
    const columnCount = bodyData?.[0]?.rows?.[0]?.cells?.length ?? 0;
    return !bodyData ? null : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitHolder,
        style: style,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2ocuT.AnnotationButton), {
                buttonId: `${state.id}-table-annotation`,
                annotationType: "Table",
                annotationLocation: {
                    position: (0, $feHBz.AitTablePosition).table
                },
                existingAnnotation: state?.originalTableData.tableAnnotation,
                hidden: state?.tlfViewMode.value !== "ANNOTATIONS",
                showPreview: showAnnotationPreview,
                repositionKey: columnCount
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                id: id,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gOa7m))).aitTable,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3ZsBw.AitHeader), {}),
                    bodyData.map((rowGroup, rgi)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $brOC3.AitRowGroup), {
                            location: {
                                tableSection: (0, $feHBz.AitRowType).body,
                                position: (0, $feHBz.AitTablePosition).bodyRowGroup,
                                rowGroup: rgi,
                                rowGroupId: rowGroup.aitid
                            }
                        }, `row-group-${rgi}-${rowGroup.aitid}`)),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("tbody", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3s4yO.AitBorderRow), {
                            id: `${id}-bottom-border`
                        })
                    })
                ]
            })
        ]
    });
};
$5267a470c9fd7815$export$2f7b0fa48de90557.displayName = "AitTable";

});

parcelRegister("c3Q0Y", function(module, exports) {

$parcel$export(module.exports, "AsupInternalTable", function () { return $34281e8fb88ef488$export$587223f259f21e10; });

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
parcelRequire("2nuru");
var $jP37Y = parcelRequire("jP37Y");
var $gMkmM = parcelRequire("gMkmM");

var $6u5Us = parcelRequire("6u5Us");

var $88YCB = parcelRequire("88YCB");
const $34281e8fb88ef488$export$587223f259f21e10 = ({ id: id, tableData: tableData, isEditable: isEditable = true, onChange: onChange, externalLists: externalLists = [], externalSingles: externalSingles = [], style: style, showCellBorders: showCellBorders = true, groupTemplates: groupTemplates, colWidthMod: colWidthMod = 2, defaultCellWidth: defaultCellWidth = 60, noTableOptions: noTableOptions = false, noTrafficLights: noTrafficLights = false, editorProps: editorProps = (0, $jP37Y.defaultEditorDefns), tlfViewMode: tlfViewMode = (0, $gMkmM.TLF_VIEW_MODES)[0] })=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $88YCB.TableContextProvider), {
        initialState: {
            originalTableData: {
                ...tableData,
                changedRowGroups: tableData.changedRowGroups ?? // istanbul ignore next
                [],
                changedColumns: tableData.changedColumns ?? // istanbul ignore next
                []
            },
            colWidthMod: colWidthMod,
            defaultCellWidth: defaultCellWidth,
            editorProps: editorProps,
            editable: isEditable,
            externalLists: externalLists,
            externalSingles: externalSingles,
            groupTemplates: groupTemplates,
            id: id,
            noTableOptions: noTableOptions,
            noTrafficLights: noTrafficLights,
            showCellBorders: showCellBorders,
            tlfViewMode: tlfViewMode
        },
        onChange: onChange,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6u5Us.AitTable), {
            id: id,
            style: style
        })
    });
$34281e8fb88ef488$export$587223f259f21e10.displayName = "AsupInternalTable";

});

parcelRegister("f63Eo", function(module, exports) {
$parcel$export(module.exports, "isAitRowGroupData", function () { return (parcelRequire("04Jlz")).isAitRowGroupData; });
$parcel$export(module.exports, "isGridItemTrafficLight", function () { return (parcelRequire("2xRzL")).isGridItemTrafficLight; });
$parcel$export(module.exports, "AitTablePosition", function () { return (parcelRequire("feHBz")).AitTablePosition; });
$parcel$export(module.exports, "newCell", function () { return (parcelRequire("iIj1X")).newCell; });
$parcel$export(module.exports, "newHeaderCell", function () { return (parcelRequire("iIj1X")).newHeaderCell; });
$parcel$export(module.exports, "newHeaderRow", function () { return (parcelRequire("3LImB")).newHeaderRow; });
$parcel$export(module.exports, "newRow", function () { return (parcelRequire("3LImB")).newRow; });
$parcel$export(module.exports, "newRowGroup", function () { return (parcelRequire("5mofv")).newRowGroup; });
parcelRequire("gTCZf");
parcelRequire("aKD4E");
parcelRequire("04Jlz");
parcelRequire("dtJ3W");
parcelRequire("gqx25");
parcelRequire("2xRzL");
parcelRequire("feHBz");
parcelRequire("iIj1X");
parcelRequire("3LImB");
parcelRequire("5mofv");
parcelRequire("lDYsF");
parcelRequire("U6yOc");
parcelRequire("7s2RK");
parcelRequire("gKnse");
parcelRequire("hnJfr");
parcelRequire("2htje");
parcelRequire("kCyUQ");
parcelRequire("3IXBZ");
parcelRequire("3zeKa");
parcelRequire("5IOQZ");
parcelRequire("h5gNQ");
parcelRequire("bT2kY");
parcelRequire("dAmd5");
parcelRequire("gNU2R");
parcelRequire("9Oxbr");
parcelRequire("kYiTl");
parcelRequire("dRjEq");
parcelRequire("fCWrt");
parcelRequire("5mBpH");
parcelRequire("bnhRS");
parcelRequire("gpwEh");
parcelRequire("3hAid");
parcelRequire("k56mL");
parcelRequire("ey1Zf");
parcelRequire("iWz50");
parcelRequire("6B5Zi");
parcelRequire("euIy3");

});
parcelRegister("gTCZf", function(module, exports) {

$parcel$export(module.exports, "isAitCellData", function () { return $0156c050190cfa0c$export$7bac3abcce3f492b; });
parcelRequire("hU1Hd");
var $l3p07 = parcelRequire("l3p07");
const $0156c050190cfa0c$export$7bac3abcce3f492b = (obj, isT, noColumnIdCheck)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic property
    const chkObj = obj;
    if (typeof chkObj.aitid !== "string") return false;
    if (!isT(chkObj.text)) return false;
    if (!isT(chkObj.comments)) return false;
    if (!noColumnIdCheck && typeof chkObj.columnId !== "string") return false;
    if (typeof chkObj.colWidth !== "undefined" && typeof chkObj.colWidth !== "number") return false;
    if (typeof chkObj.textIndents !== "undefined" && typeof chkObj.textIndents !== "number") return false;
    if (chkObj.replacedText !== undefined && !isT(chkObj.replacedText)) return false;
    if (typeof chkObj.spaceAfterRepeat !== "undefined" && typeof chkObj.spaceAfterRepeat !== "boolean") return false;
    if (typeof chkObj.templateAitId !== "undefined" && typeof chkObj.templateAitId !== "string") return false;
    if (typeof chkObj.templateColumnAitId !== "undefined" && typeof chkObj.templateColumnAitId !== "string") return false;
    if (typeof chkObj.showCellOptions !== "undefined" && typeof chkObj.showCellOptions !== "boolean") return false;
    if (typeof chkObj.readOnly !== "undefined" && typeof chkObj.readOnly !== "boolean") return false;
    // Check types
    if (chkObj.justifyText !== undefined && ![
        "left",
        "center",
        "right",
        "justify",
        "decimal",
        "default"
    ].includes(chkObj.justifyText)) return false;
    if (!(0, $l3p07.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("hU1Hd", function(module, exports) {
$parcel$export(module.exports, "MosaicTrafficLightClass", function () { return (parcelRequire("8vQMY")).MosaicTrafficLightClass; });
$parcel$export(module.exports, "MosaicTrafficLightColors", function () { return (parcelRequire("8vQMY")).MosaicTrafficLightColors; });
$parcel$export(module.exports, "isMosaicTrafficLightsValue", function () { return (parcelRequire("l3p07")).isMosaicTrafficLightsValue; });
$parcel$export(module.exports, "isMosaicTrafficLightSwitch", function () { return (parcelRequire("a6nWU")).isMosaicTrafficLightSwitch; });
parcelRequire("8vQMY");
parcelRequire("l3p07");
parcelRequire("a6nWU");

});
parcelRegister("l3p07", function(module, exports) {

$parcel$export(module.exports, "isMosaicTrafficLightsValue", function () { return $de2906048016d138$export$f9ab8bbf5b7da0c3; });
/**
 * Available traffic light values
 */ const $de2906048016d138$export$f9ab8bbf5b7da0c3 = (obj)=>typeof obj === "string" && [
        "none",
        "FromScratch",
        "FromBasicLayout",
        "FromTemplate",
        "RedError",
        "AmberChangeExpected",
        "GreenOk",
        "BlankNotEvaluated",
        "ChangedUnknown",
        "GreenOverride"
    ].includes(obj);

});

parcelRegister("a6nWU", function(module, exports) {

$parcel$export(module.exports, "isMosaicTrafficLightSwitch", function () { return $0e487a1fca9e5825$export$e651a6276e9ff426; });
const $0e487a1fca9e5825$export$e651a6276e9ff426 = (obj)=>{
    return typeof obj === "string" && [
        "DoNotCalculate",
        "Calculate"
    ].includes(obj);
};

});



parcelRegister("aKD4E", function(module, exports) {

$parcel$export(module.exports, "isAitRowData", function () { return $e2d906fe17c72386$export$d7117232a007430b; });

var $hY7Md = parcelRequire("hY7Md");
parcelRequire("hU1Hd");
var $l3p07 = parcelRequire("l3p07");

var $gTCZf = parcelRequire("gTCZf");
const $e2d906fe17c72386$export$d7117232a007430b = (obj, isT, noColumnIdCheck)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic property
    const chkObj = obj;
    if (typeof chkObj.aitid !== "string") return false;
    if (typeof chkObj.rowRepeat !== "undefined" && typeof chkObj.rowRepeat !== "string") return false;
    if (typeof chkObj.spaceAfter !== "undefined" && typeof chkObj.spaceAfter !== "boolean") return false;
    if (typeof chkObj.templateAitId !== "undefined" && typeof chkObj.templateAitId !== "string") return false;
    // Check arrays
    if (!Array.isArray(chkObj.cells) || chkObj.cells.some((cell)=>!(0, $gTCZf.isAitCellData)(cell, isT, noColumnIdCheck))) return false;
    // Check types
    if (!(0, $l3p07.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    // Check lower level objects
    if (typeof chkObj.annotation !== "undefined" && !(0, $hY7Md.isAnnotationWhereGroup)(chkObj.annotation)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("hY7Md", function(module, exports) {

$parcel$export(module.exports, "isAnnotationWhereGroup", function () { return $4eee6782c98b8109$export$bd254dfc157df8f7; });

var $8sYvr = parcelRequire("8sYvr");
const $4eee6782c98b8109$export$bd254dfc157df8f7 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (!Array.isArray(chkObj.clauses) || chkObj.clauses.some((c)=>!(0, $8sYvr.isWhereClauseOp)(c))) return false;
    // Check optional props
    if (chkObj.additionalNotes !== undefined && typeof chkObj.additionalNotes !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("04Jlz", function(module, exports) {

$parcel$export(module.exports, "isAitRowGroupData", function () { return $c05f6064a8a572a1$export$147e7523057ffe20; });

var $hY7Md = parcelRequire("hY7Md");
parcelRequire("152v7");
var $cXvVz = parcelRequire("cXvVz");
parcelRequire("hU1Hd");
var $l3p07 = parcelRequire("l3p07");

var $aKD4E = parcelRequire("aKD4E");

var $2xRzL = parcelRequire("2xRzL");
const $c05f6064a8a572a1$export$147e7523057ffe20 = (obj, isT, noColumnIdCheck)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check lower interface
    const chkObj = obj;
    if (typeof chkObj.aitid !== "string") return false;
    if (typeof chkObj.name !== "undefined" && typeof chkObj.name !== "string") return false;
    if (!Array.isArray(chkObj.rows) || chkObj.rows.some((x)=>!(0, $aKD4E.isAitRowData)(x, isT, noColumnIdCheck))) return false;
    if (typeof chkObj.comments !== "undefined" && !isT(chkObj.comments)) return false;
    if (typeof chkObj.spaceAfter !== "undefined" && typeof chkObj.spaceAfter !== "boolean") return false;
    if (typeof chkObj.replacements !== "undefined" && chkObj.replacements.some((x)=>!(0, $cXvVz.isAioReplacement)(x, isT))) return false;
    if (!(0, $l3p07.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    if (typeof chkObj.changedRows !== "undefined" && chkObj.changedRows.some((x)=>!(0, $2xRzL.isGridItemTrafficLight)(x))) return false;
    if (typeof chkObj.templateAitId !== "undefined" && typeof chkObj.templateAitId !== "string") return false;
    if (typeof chkObj.annotation !== "undefined" && !(0, $hY7Md.isAnnotationWhereGroup)(chkObj.annotation)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("2xRzL", function(module, exports) {

$parcel$export(module.exports, "isGridItemTrafficLight", function () { return $3bf5e2167068c790$export$e6b70f04b92d6b8e; });

var $8CFpa = parcelRequire("8CFpa");
parcelRequire("hU1Hd");
var $l3p07 = parcelRequire("l3p07");
const $3bf5e2167068c790$export$e6b70f04b92d6b8e = (obj)=>{
    // Check object
    if (!(0, $8CFpa.isObjectRecord)(obj)) return false;
    // Check basic property types
    if (typeof obj.coreTrafficLight !== "string" || typeof obj.gridItemId !== "string" || typeof obj.isOptional !== "boolean" || typeof obj.gridItemChangeType !== "string") return false;
    // Check optional property types
    if (obj.idAfterTrafficLightIsShown !== undefined && typeof obj.idAfterTrafficLightIsShown !== "string") return false;
    // Check enums
    if (!(0, $l3p07.isMosaicTrafficLightsValue)(obj.coreTrafficLight)) return false;
    // All good
    return true;
};

});


parcelRegister("iWz50", function(module, exports) {

var $feHBz = parcelRequire("feHBz");
/**
 * Update the core traffic-light value on a row, row-group and table.
 *
 * Internal helper used to synchronise `coreTrafficLight` across a row,
 * its parent row-group and the table data when a change occurs.
 *
 * @template T - The row/cell payload type
 * @param coreTrafficLight - New `MosaicTrafficLightsValue` to set
 * @param row - The row to update
 * @param rowGroup - The parent row group or header group
 * @param tableData - The table data object which will have its `coreTrafficLight` updated
 */ const $a2288b9918e78432$var$updateCoreTrafficLight = (coreTrafficLight, row, rowGroup, tableData)=>{
    row.coreTrafficLight = coreTrafficLight;
    rowGroup.coreTrafficLight = coreTrafficLight;
    tableData.coreTrafficLight = coreTrafficLight;
};
const $a2288b9918e78432$export$783eb81b2852b9bb = (state, location)=>{
    if (location.position === (0, $feHBz.AitTablePosition).headerCell && state.originalTableData && state.originalTableData.headerData) {
        const headerData = state.originalTableData.headerData;
        const row = headerData.rows[location.row];
        /* istanbul ignore else */ if (row && row.coreTrafficLight !== "ChangedUnknown") $a2288b9918e78432$var$updateCoreTrafficLight("ChangedUnknown", row, headerData, state.originalTableData);
    }
    if (location.position === (0, $feHBz.AitTablePosition).bodyCell && state.originalTableData) {
        const bodyData = state.originalTableData.bodyData;
        const rowGroup = bodyData[location.rowGroup];
        /* istanbul ignore else */ if (rowGroup) {
            const row = rowGroup.rows[location.row];
            /* istanbul ignore else */ if (row && row.coreTrafficLight !== "ChangedUnknown") $a2288b9918e78432$var$updateCoreTrafficLight("ChangedUnknown", row, rowGroup, state.originalTableData);
        }
    }
};

});




var $4573d697ec3888b6$exports = {};
$parcel$extendImportMap({
    "9WmYe": "Mosaic.11531866.png",
    "iMF9Y": "error-cassette.ddf1a09a.png",
    "hDFTo": "AdminPage.1c7bb3ed.js",
    "6nued": "AdminPage.d3e3a3a5.css",
    "eBXHv": "MaintenancePage.a3e5fa23.js",
    "jgWiR": "NotAllowedPage.be50cfd0.js",
    "ihcFi": "HierarchyPage.e00f829e.js",
    "3NBg9": "HierarchyPage.adfaa102.js",
    "caD1X": "HierarchyPage.f13b23d1.css",
    "9N66w": "TOC.868adb37.js",
    "7tyjL": "TOC.b84a6591.css",
    "9thxK": "HierarchyProperties.a12d0a85.js",
    "4APPu": "AccessRights.fa2de6aa.js",
    "l74Zm": "AccessRights.cc9ced2d.css",
    "iKeQy": "LibraryNavigation.0799e562.js",
    "lFY3j": "LibraryTable.909b28d6.js",
    "dyhud": "LibraryTable.b41d3acb.css",
    "fwHvr": "HierarchyDomainReplacements.f26e94f4.js",
    "kmI6J": "HierarchyDomainReplacements.9021fe0f.css",
    "gbBln": "HierarchyLists.3694a951.js",
    "jhVYK": "ExternalSinglesTable.20bc2ea5.js",
    "3TDGB": "ExternalSinglesTable.7148ba62.css",
    "5KjUQ": "HierarchyTags.77645871.js",
    "ctMtP": "HierarchyRowGroups.290c9ef4.js",
    "isaub": "HierarchyAnalysisMethods.1a51e67e.js",
    "dmCTu": "HierarchyAnalysisSets.51ec70db.js",
    "3MSmQ": "HierarchyDataSubsets.d4e3309b.js",
    "2n3sP": "HierarchyGroupingFactors.6d62a818.js",
    "5vJ5f": "NotFound.53da020a.js",
    "br6Ib": "ReportVersions.0e4f76da.js",
    "2Hfk6": "HierarchyHistoryTable.119c0e31.js",
    "lV3D7": "EditorBlocksSearchControls.dcc7169e.js",
    "etYwV": "TlfPage.02eb95d9.js",
    "4PQp8": "TlfPage.4a1d4f03.css"
});


var $bbzbN = parcelRequire("bbzbN");

var $lp1At = parcelRequire("lp1At");

var $it3LR = parcelRequire("it3LR");


var $bbzbN = parcelRequire("bbzbN");

var $it3LR = parcelRequire("it3LR");
parcelRequire("h3OEn");
var $a04va = parcelRequire("a04va");

var $dRarR = parcelRequire("dRarR");
const $625364a45b510798$export$f6d610d2730cbf1a = {
    auth: {
        clientId: `${(0, $dRarR.REACT_APP_AUTH_CLIENTID)}`,
        authority: `${(0, $dRarR.REACT_APP_AUTH_AUTHORITY)}`,
        redirectUri: `${(0, $dRarR.REACT_APP_AUTH_REDIRECT_URI)}`
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};
const $625364a45b510798$export$be6c432b2463c5eb = {
    scopes: [
        `${(0, $dRarR.REACT_APP_AUTH_SCOPE)}`
    ]
};
const $625364a45b510798$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


function $f3e491862a2782d7$export$777ddc80de65caa7(instance, account, stage) {
    return async function intercept(config) {
        if (stage !== "local") {
            if (!account) throw Error("No active account! Verify a user has been signed in.");
            const response = await instance.acquireTokenSilent({
                ...(0, $625364a45b510798$export$be6c432b2463c5eb),
                account: account
            });
            const bearer = `Bearer ${response.accessToken}`;
            if (config && config.headers) config.headers.Authorization = bearer;
        }
        return config;
    };
}
/**
 * Axios request interceptor that adds authentication tokens to outgoing requests.
 *
 * @param props - The component props
 * @param props.children - Child components to render
 */ const $f3e491862a2782d7$var$RequestInterceptor = ({ children: children })=>{
    const { instance: instance, accounts: accounts } = (0, $it3LR.useMsal)();
    const account = (0, $it3LR.useAccount)(accounts[0]);
    const interceptor = $f3e491862a2782d7$export$777ddc80de65caa7(instance, account, undefined);
    (0, $a04va.default).interceptors.request.use(interceptor);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: children
    });
};
$f3e491862a2782d7$var$RequestInterceptor.displayName = "RequestInterceptor";
var $f3e491862a2782d7$export$2e2bcd8739ae039 = $f3e491862a2782d7$var$RequestInterceptor;


parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};
'use strict';
function $f11ec298ebcca059$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$f11ec298ebcca059$exports = (parcelRequire("cP50D"));



var $gxpCl = parcelRequire("gxpCl");/**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v7.18.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gxpCl = parcelRequire("gxpCl");

var $7fPBF = parcelRequire("7fPBF");
var $df501c7d159a7726$exports = {};
"use strict";
Object.defineProperty($df501c7d159a7726$exports, "__esModule", {
    value: true
});
$df501c7d159a7726$exports.parseCookie = $df501c7d159a7726$var$parseCookie;
$df501c7d159a7726$exports.parse = $df501c7d159a7726$var$parseCookie;
$df501c7d159a7726$exports.stringifyCookie = $df501c7d159a7726$var$stringifyCookie;
$df501c7d159a7726$exports.stringifySetCookie = $df501c7d159a7726$var$stringifySetCookie;
$df501c7d159a7726$exports.serialize = $df501c7d159a7726$var$stringifySetCookie;
$df501c7d159a7726$exports.parseSetCookie = $df501c7d159a7726$var$parseSetCookie;
$df501c7d159a7726$exports.stringifySetCookie = $df501c7d159a7726$var$stringifySetCookie;
$df501c7d159a7726$exports.serialize = $df501c7d159a7726$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $df501c7d159a7726$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $df501c7d159a7726$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $df501c7d159a7726$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $df501c7d159a7726$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $df501c7d159a7726$var$maxAgeRegExp = /^-?\d+$/;
const $df501c7d159a7726$var$__toString = Object.prototype.toString;
const $df501c7d159a7726$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $df501c7d159a7726$var$parseCookie(str, options) {
    const obj = new $df501c7d159a7726$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $df501c7d159a7726$var$decode;
    let index = 0;
    do {
        const eqIdx = $df501c7d159a7726$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $df501c7d159a7726$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $df501c7d159a7726$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($df501c7d159a7726$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $df501c7d159a7726$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$df501c7d159a7726$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$df501c7d159a7726$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $df501c7d159a7726$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$df501c7d159a7726$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$df501c7d159a7726$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$df501c7d159a7726$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$df501c7d159a7726$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$df501c7d159a7726$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $df501c7d159a7726$var$parseSetCookie(str, options) {
    const dec = options?.decode || $df501c7d159a7726$var$decode;
    const len = str.length;
    const endIdx = $df501c7d159a7726$var$endIndex(str, 0, len);
    const eqIdx = $df501c7d159a7726$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($df501c7d159a7726$var$valueSlice(str, 0, endIdx))
    } : {
        name: $df501c7d159a7726$var$valueSlice(str, 0, eqIdx),
        value: dec($df501c7d159a7726$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $df501c7d159a7726$var$endIndex(str, index, len);
        const eqIdx = $df501c7d159a7726$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $df501c7d159a7726$var$valueSlice(str, index, endIdx) : $df501c7d159a7726$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $df501c7d159a7726$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $df501c7d159a7726$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $df501c7d159a7726$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $df501c7d159a7726$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $df501c7d159a7726$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $df501c7d159a7726$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $df501c7d159a7726$var$isDate(val) {
    return $df501c7d159a7726$var$__toString.call(val) === "[object Date]";
}


var $3029e7cf334d9b3f$exports = {};
"use strict";
var $3029e7cf334d9b3f$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $3029e7cf334d9b3f$var$isForbiddenKey(key) {
    return typeof key !== "string" || key in {};
}
function $3029e7cf334d9b3f$var$createNullObj() {
    return Object.create(null);
}
function $3029e7cf334d9b3f$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $3029e7cf334d9b3f$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($3029e7cf334d9b3f$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $3029e7cf334d9b3f$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $3029e7cf334d9b3f$var$defaultParseOptions, options) : $3029e7cf334d9b3f$var$defaultParseOptions;
    if ($3029e7cf334d9b3f$var$isForbiddenKey(name)) return null;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser: failed to decode cookie value. Set options.decodeValues=false to disable decoding.", e);
    }
    var cookie = $3029e7cf334d9b3f$var$createNullObj();
    cookie.name = name;
    cookie.value = value;
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        if ($3029e7cf334d9b3f$var$isForbiddenKey(key)) return;
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") {
            var n = parseInt(value, 10);
            if (!Number.isNaN(n)) cookie.maxAge = n;
        } else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else if (key) cookie[key] = value;
    });
    return cookie;
}
function $3029e7cf334d9b3f$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $3029e7cf334d9b3f$var$parse(input, options) {
    options = options ? Object.assign({}, $3029e7cf334d9b3f$var$defaultParseOptions, options) : $3029e7cf334d9b3f$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return $3029e7cf334d9b3f$var$createNullObj();
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case)
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($3029e7cf334d9b3f$var$isNonEmptyString).map(function(str) {
        return $3029e7cf334d9b3f$var$parseString(str, options);
    }).filter(Boolean);
    else {
        var cookies = $3029e7cf334d9b3f$var$createNullObj();
        return input.filter($3029e7cf334d9b3f$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $3029e7cf334d9b3f$var$parseString(str, options);
            if (cookie && !$3029e7cf334d9b3f$var$isForbiddenKey(cookie.name)) cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $3029e7cf334d9b3f$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$3029e7cf334d9b3f$exports = $3029e7cf334d9b3f$var$parse;
$3029e7cf334d9b3f$exports.parse = $3029e7cf334d9b3f$var$parse;
$3029e7cf334d9b3f$exports.parseString = $3029e7cf334d9b3f$var$parseString;
$3029e7cf334d9b3f$exports.splitCookiesString = $3029e7cf334d9b3f$var$splitCookiesString;


function $1a84a3b286610033$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = (0, $gxpCl.createServerRoutes)(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && (0, $gxpCl.shouldHydrateRouteLoader)(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = (0, $gxpCl.createStaticRouter)(routes, context.staticHandlerContext, {
        branches: context.branches
    });
    return /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.FrameworkContext).Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            nonce: nonce,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RemixErrorBoundary), {
        location: router.state.location
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.StaticRouterProvider), {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $7fPBF.createElement($7fPBF.Suspense, null, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.StreamTransfer), {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $1a84a3b286610033$export$bea31554c7dfd2ad(routes, _context) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $7fPBF.useRef();
        let frameworkContextRef = $7fPBF.useRef();
        if (routerRef.current == null) {
            frameworkContextRef.current = {
                future: {
                    v8_passThroughRequests: future?.v8_passThroughRequests === true,
                    v8_middleware: future?.v8_middleware === true,
                    v8_trailingSlashAwareDataRequests: future?.v8_trailingSlashAwareDataRequests === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = $1a84a3b286610033$var$processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `RouteObject`
            (0, $gxpCl.convertRoutesToDataRoutes)(routes, (r)=>r), _context !== void 0 ? _context : future?.v8_middleware ? new (0, $gxpCl.RouterContextProvider)() : {}, frameworkContextRef.current.manifest, frameworkContextRef.current.routeModules);
            routerRef.current = (0, $gxpCl.createMemoryRouter)(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.FrameworkContext).Provider, {
            value: frameworkContextRef.current
        }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RouterProvider), {
            router: routerRef.current
        }));
    };
}
function $1a84a3b286610033$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in react-router processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? (0, $gxpCl.withComponentProps)(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? (0, $gxpCl.withHydrateFallbackProps)(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? (0, $gxpCl.withErrorBoundaryProps)(route.ErrorBoundary) : void 0,
            action: route.action ? (args)=>route.action({
                    ...args,
                    context: context
                }) : void 0,
            loader: route.loader ? (args)=>route.loader({
                    ...args,
                    context: context
                }) : void 0,
            middleware: route.middleware ? route.middleware.map((mw)=>(...args)=>mw({
                        ...args[0],
                        context: context
                    }, args[1])) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || (0, $gxpCl.Outlet),
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $1a84a3b286610033$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $1a84a3b286610033$var$encoder = /* @__PURE__ */ new TextEncoder();
var $1a84a3b286610033$var$sign = async (value, secret)=>{
    let data2 = $1a84a3b286610033$var$encoder.encode(value);
    let key = await $1a84a3b286610033$var$createKey(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $1a84a3b286610033$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $1a84a3b286610033$var$encoder.encode(value);
    let key = await $1a84a3b286610033$var$createKey(secret, [
        "verify"
    ]);
    try {
        let signature = $1a84a3b286610033$var$byteStringToUint8Array(atob(hash));
        let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
        return valid ? value : false;
    } catch (e) {
        return false;
    }
};
var $1a84a3b286610033$var$createKey = async (secret, usages)=>crypto.subtle.importKey("raw", $1a84a3b286610033$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $1a84a3b286610033$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $1a84a3b286610033$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $1a84a3b286610033$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $df501c7d159a7726$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $1a84a3b286610033$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $df501c7d159a7726$exports.serialize)(name, value === "" ? "" : await $1a84a3b286610033$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $1a84a3b286610033$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $1a84a3b286610033$var$encodeCookieValue(value, secrets) {
    let encoded = $1a84a3b286610033$var$encodeData(value);
    if (secrets.length > 0) encoded = await $1a84a3b286610033$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $1a84a3b286610033$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $1a84a3b286610033$var$unsign(value, secret);
            if (unsignedValue !== false) return $1a84a3b286610033$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $1a84a3b286610033$var$decodeData(value);
}
function $1a84a3b286610033$var$encodeData(value) {
    return btoa($1a84a3b286610033$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $1a84a3b286610033$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($1a84a3b286610033$var$myEscape(atob(value))));
    } catch (e) {
        return {};
    }
}
function $1a84a3b286610033$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $1a84a3b286610033$var$hex(code, 2);
            else result += "%u" + $1a84a3b286610033$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $1a84a3b286610033$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $1a84a3b286610033$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $1a84a3b286610033$var$warnOnceAboutExpiresCookie(name, expires) {
    (0, $gxpCl.warnOnce)(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $1a84a3b286610033$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo, routeId)=>{
        let route = manifest[routeId];
        if (route) memo[routeId] = route.module;
        return memo;
    }, {});
}
// lib/server-runtime/mode.ts
var $1a84a3b286610033$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($1a84a3b286610033$export$e7973f87fd96e4f2 || {});
function $1a84a3b286610033$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $1a84a3b286610033$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $1a84a3b286610033$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $1a84a3b286610033$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $1a84a3b286610033$var$serializeError(error, serverMode) {
    let sanitized = $1a84a3b286610033$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
// lib/server-runtime/invariant.ts
function $1a84a3b286610033$var$invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routeMatching.ts
function $1a84a3b286610033$var$matchServerRoutes(manifest, dataRoutes, branches, pathname, basename) {
    let matches = (0, $gxpCl.matchRoutesImpl)(dataRoutes, pathname, basename ?? "/", false, branches);
    if (!matches) return null;
    return matches.map((match)=>{
        let route = manifest[match.route.id];
        $1a84a3b286610033$var$invariant(route, `Route with id "${match.route.id}" not found in manifest.`);
        return {
            params: match.params,
            pathname: match.pathname,
            route: route
        };
    });
}
// lib/server-runtime/data.ts
async function $1a84a3b286610033$var$callRouteHandler(handler, args, future) {
    let result = await handler({
        request: future.v8_passThroughRequests ? args.request : $1a84a3b286610033$var$stripRoutesParam($1a84a3b286610033$var$stripIndexParam(args.request)),
        url: args.url,
        params: args.params,
        context: args.context,
        pattern: args.pattern
    });
    if ((0, $gxpCl.isDataWithResponseInit)(result) && result.init && result.init.status && (0, $gxpCl.isRedirectStatusCode)(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $1a84a3b286610033$var$stripIndexParam(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $1a84a3b286610033$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/dev.ts
var $1a84a3b286610033$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $1a84a3b286610033$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$1a84a3b286610033$var$globalDevServerHooksKey] = devServerHooks;
}
function $1a84a3b286610033$var$getDevServerHooks() {
    return globalThis[$1a84a3b286610033$var$globalDevServerHooksKey];
}
function $1a84a3b286610033$var$getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function $1a84a3b286610033$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $1a84a3b286610033$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $1a84a3b286610033$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            middleware: route.module.middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = $1a84a3b286610033$var$getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $1a84a3b286610033$var$invariant(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await (0, $gxpCl.decodeViaTurboStream)(stream, $parcel$global);
                    let data2 = decoded.value;
                    if (data2 && (0, $gxpCl.SingleFetchRedirectSymbol) in data2) {
                        let result = data2[0, $gxpCl.SingleFetchRedirectSymbol];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw (0, $gxpCl.redirectDocument)(result.redirect, init);
                        else if (result.replace) throw (0, $gxpCl.replace)(result.redirect, init);
                        else throw (0, $gxpCl.redirect)(result.redirect, init);
                    } else {
                        $1a84a3b286610033$var$invariant(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        $1a84a3b286610033$var$invariant("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await $1a84a3b286610033$var$callRouteHandler(route.module.loader, args, future);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$1a84a3b286610033$var$callRouteHandler(route.module.action, args, future) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $1a84a3b286610033$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/serverHandoff.ts
function $1a84a3b286610033$var$createServerHandoffString(serverHandoff) {
    return (0, $gxpCl.escapeHtml)(JSON.stringify(serverHandoff));
}
function $1a84a3b286610033$var$getDocumentHeaders(context, build) {
    return $1a84a3b286610033$var$getDocumentHeadersImpl(context, (m)=>{
        let route = build.routes[m.route.id];
        $1a84a3b286610033$var$invariant(route, `Route with id "${m.route.id}" not found in build`);
        return route.module.headers;
    });
}
function $1a84a3b286610033$var$getDocumentHeadersImpl(context, getRouteHeadersFn, _defaultHeaders) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    const defaultHeaders = new Headers(_defaultHeaders);
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        let headersFn = getRouteHeadersFn(match);
        if (headersFn == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $1a84a3b286610033$var$prependCookies(errorHeaders, headers2);
            $1a84a3b286610033$var$prependCookies(actionHeaders, headers2);
            $1a84a3b286610033$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(typeof headersFn === "function" ? headersFn({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : headersFn);
        if (includeErrorCookies) $1a84a3b286610033$var$prependCookies(errorHeaders, headers);
        $1a84a3b286610033$var$prependCookies(actionHeaders, headers);
        $1a84a3b286610033$var$prependCookies(loaderHeaders, headers);
        $1a84a3b286610033$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers(defaultHeaders));
}
function $1a84a3b286610033$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $3029e7cf334d9b3f$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/actions.ts
function $1a84a3b286610033$var$throwIfPotentialCSRFAttack(request, allowedActionOrigins) {
    let originHeader = request.headers.get("origin");
    let originDomain = null;
    let originUrl = null;
    try {
        if (typeof originHeader === "string" && originHeader !== "null") {
            originUrl = new URL(originHeader);
            originDomain = originUrl.host;
        } else originDomain = originHeader;
    } catch  {
        throw new Error(`\`origin\` header is not a valid URL. Aborting the action.`);
    }
    let requestUrl = new URL(request.url);
    let originMatchesRequest = originUrl ? originUrl.origin === requestUrl.origin : originDomain === requestUrl.host;
    if (originDomain && !originMatchesRequest) {
        if (!$1a84a3b286610033$var$isAllowedOrigin(originDomain, allowedActionOrigins)) throw new Error("The `request.url` origin does not match `origin` header from a forwarded action request. Aborting the action.");
    }
}
function $1a84a3b286610033$var$matchWildcardDomain(domain, pattern) {
    const domainParts = domain.split(".");
    const patternParts = pattern.split(".");
    if (patternParts.length < 1) return false;
    if (domainParts.length < patternParts.length) return false;
    while(patternParts.length){
        const patternPart = patternParts.pop();
        const domainPart = domainParts.pop();
        switch(patternPart){
            case "":
                return false;
            case "*":
                if (domainPart) continue;
                else return false;
            case "**":
                if (patternParts.length > 0) return false;
                return domainPart !== void 0;
            case void 0:
            default:
                if (domainPart !== patternPart) return false;
        }
    }
    return domainParts.length === 0;
}
function $1a84a3b286610033$var$isAllowedOrigin(originDomain, allowedActionOrigins = []) {
    return allowedActionOrigins.some((allowedOrigin)=>allowedOrigin && (allowedOrigin === originDomain || $1a84a3b286610033$var$matchWildcardDomain(originDomain, allowedOrigin)));
}
// lib/server-runtime/urls.ts
function $1a84a3b286610033$var$getNormalizedPath(request, basename, future) {
    basename = basename || "/";
    let url = new URL(request.url);
    let pathname = url.pathname;
    if (future?.v8_trailingSlashAwareDataRequests) {
        if (pathname.endsWith("/_.data")) pathname = pathname.replace(/_\.data$/, "");
        else pathname = pathname.replace(/\.data$/, "");
    } else {
        if ((0, $gxpCl.stripBasename)(pathname, basename) === "/_root.data") pathname = basename;
        else if (pathname.endsWith(".data")) pathname = pathname.replace(/\.data$/, "");
        if ((0, $gxpCl.stripBasename)(pathname, basename) !== "/" && pathname.endsWith("/")) pathname = pathname.slice(0, -1);
    }
    let searchParams = new URLSearchParams(url.search);
    searchParams.delete("_routes");
    let search = searchParams.toString();
    if (search) search = `?${search}`;
    return {
        pathname: pathname,
        search: search,
        // No hashes on the server
        hash: ""
    };
}
// lib/server-runtime/single-fetch.ts
var $1a84a3b286610033$var$SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...(0, $gxpCl.NO_BODY_STATUS_CODES),
    304
]);
async function $1a84a3b286610033$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        try {
            $1a84a3b286610033$var$throwIfPotentialCSRFAttack(request, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        } catch (e) {
            return handleQueryError(new Error("Bad Request"), 400);
        }
        let handlerRequest = build.future.v8_passThroughRequests ? request : new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0,
            normalizePath: (r)=>$1a84a3b286610033$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $gxpCl.isResponse)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error, status = 500) {
        handleError(error);
        return $1a84a3b286610033$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: status
        });
    }
    function staticContextToResponse(context) {
        let headers = $1a84a3b286610033$var$getDocumentHeaders(context, build);
        if ((0, $gxpCl.isRedirectStatusCode)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $gxpCl.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $1a84a3b286610033$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return $1a84a3b286610033$var$generateSingleFetchResponse(request, build, serverMode, {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        });
    }
}
async function $1a84a3b286610033$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    let routesParam = new URL(request.url).searchParams.get("_routes");
    let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
    try {
        let handlerRequest = build.future.v8_passThroughRequests ? request : new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0,
            normalizePath: (r)=>$1a84a3b286610033$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $gxpCl.isResponse)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $1a84a3b286610033$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $1a84a3b286610033$var$getDocumentHeaders(context, build);
        if ((0, $gxpCl.isRedirectStatusCode)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $gxpCl.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $1a84a3b286610033$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
        if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
            error: error
        };
        for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
            data: data2
        };
        return $1a84a3b286610033$var$generateSingleFetchResponse(request, build, serverMode, {
            result: results,
            headers: headers,
            status: context.statusCode
        });
    }
}
function $1a84a3b286610033$var$generateSingleFetchResponse(request, build, serverMode, { result: result, headers: headers, status: status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($1a84a3b286610033$var$SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    resultHeaders.delete("Content-Length");
    return new Response($1a84a3b286610033$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function $1a84a3b286610033$var$generateSingleFetchRedirectResponse(redirectResponse, request, build, serverMode) {
    let redirect2 = $1a84a3b286610033$var$getSingleFetchRedirect(redirectResponse.status, redirectResponse.headers, build.basename);
    let headers = new Headers(redirectResponse.headers);
    headers.delete("Location");
    headers.set("Content-Type", "text/x-script");
    return $1a84a3b286610033$var$generateSingleFetchResponse(request, build, serverMode, {
        result: request.method === "GET" ? {
            [(0, $gxpCl.SingleFetchRedirectSymbol)]: redirect2
        } : redirect2,
        headers: headers,
        status: (0, $gxpCl.SINGLE_FETCH_REDIRECT_STATUS)
    });
}
function $1a84a3b286610033$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = (0, $gxpCl.stripBasename)(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $1a84a3b286610033$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>{
        controller.abort(new Error("Server Timeout"));
        cleanupCallbacks();
    }, typeof streamTimeout === "number" ? streamTimeout : 4950);
    let abortControllerOnRequestAbort = ()=>{
        controller.abort(requestSignal.reason);
        cleanupCallbacks();
    };
    requestSignal.addEventListener("abort", abortControllerOnRequestAbort);
    let cleanupCallbacks = ()=>{
        clearTimeout(timeoutId);
        requestSignal.removeEventListener("abort", abortControllerOnRequestAbort);
    };
    return (0, $gxpCl.encode)(data2, {
        signal: controller.signal,
        onComplete: cleanupCallbacks,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $1a84a3b286610033$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof (0, $gxpCl.ErrorResponseImpl)) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && (0, $gxpCl.SingleFetchRedirectSymbol) in value) return [
                    "SingleFetchRedirect",
                    value[0, $gxpCl.SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $1a84a3b286610033$var$derive(build, mode) {
    let dataRoutes = $1a84a3b286610033$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $1a84a3b286610033$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = (0, $gxpCl.createStaticHandler)(dataRoutes, {
        basename: build.basename,
        instrumentations: build.entry.module.instrumentations,
        future: build.future
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        (0, $gxpCl.isRouteErrorResponse)(error) && error.error ? error.error : error);
    });
    let requestHandler = async (request, initialContext)=>{
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $1a84a3b286610033$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (build.future.v8_middleware) {
            if (initialContext && !(initialContext instanceof (0, $gxpCl.RouterContextProvider))) {
                let error = new Error("Invalid `context` value provided to `handleRequest`. When middleware is enabled you must return an instance of `RouterContextProvider` from your `getLoadContext` function.");
                handleError(error);
                return $1a84a3b286610033$var$returnLastResortErrorResponse(error, serverMode);
            }
            loadContext = initialContext || new (0, $gxpCl.RouterContextProvider)();
        } else loadContext = initialContext || {};
        let requestUrl = new URL(request.url);
        let normalizedPathname = $1a84a3b286610033$var$getNormalizedPath(request, build.basename, build.future).pathname;
        let isSpaMode = $1a84a3b286610033$var$getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!build.ssr) {
            let decodedPath = decodeURI(normalizedPathname);
            if (build.basename && build.basename !== "/") {
                let strippedPath = (0, $gxpCl.stripBasename)(decodedPath, build.basename);
                if (strippedPath == null) {
                    errorHandler(new (0, $gxpCl.ErrorResponseImpl)(404, "Not Found", `Refusing to prerender the \`${decodedPath}\` path because it does not start with the basename \`${build.basename}\``), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                }
                decodedPath = strippedPath;
            }
            if (build.prerender.length === 0) isSpaMode = true;
            else if (!build.prerender.includes(decodedPath.replace(/\/$/, "")) && !build.prerender.includes(decodedPath.replace(/[^/]$/, "/"))) {
                if (requestUrl.pathname.endsWith(".data")) {
                    errorHandler(new (0, $gxpCl.ErrorResponseImpl)(404, "Not Found", `Refusing to SSR the path \`${decodedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = (0, $gxpCl.getManifestPath)(build.routeDiscovery.manifestPath, build.basename);
        if (build.routeDiscovery.mode === "lazy" && requestUrl.pathname === manifestUrl) try {
            let res = await $1a84a3b286610033$var$handleManifestRequest(build, staticHandler.dataRoutes, staticHandler._internalRouteBranches, requestUrl);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $1a84a3b286610033$var$matchServerRoutes(build.routes, staticHandler.dataRoutes, staticHandler._internalRouteBranches, normalizedPathname, build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (requestUrl.pathname.endsWith(".data")) {
            response = await $1a84a3b286610033$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, normalizedPathname, loadContext, handleError);
            if ((0, $gxpCl.isRedirectResponse)(response)) response = $1a84a3b286610033$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            if (build.entry.module.handleDataRequest) {
                response = await build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: matches ? matches[0].params : {},
                    request: request
                });
                if ((0, $gxpCl.isRedirectResponse)(response)) response = $1a84a3b286610033$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $1a84a3b286610033$var$handleResourceRequest(serverMode, build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname: pathname } = requestUrl;
            let criticalCss = void 0;
            if (build.unstable_getCriticalCss) criticalCss = await build.unstable_getCriticalCss({
                pathname: pathname
            });
            else if (mode === "development" /* Development */  && $1a84a3b286610033$var$getDevServerHooks()?.getCriticalCss) criticalCss = await $1a84a3b286610033$var$getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await $1a84a3b286610033$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
    if (build.entry.module.instrumentations) requestHandler = (0, $gxpCl.instrumentHandler)(requestHandler, build.entry.module.instrumentations.map((i)=>i.handler).filter(Boolean));
    return {
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler,
        requestHandler: requestHandler
    };
}
var $1a84a3b286610033$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let serverMode;
    let staticHandler;
    let errorHandler;
    let _requestHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $1a84a3b286610033$var$derive(_build, mode);
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        } else if (!serverMode || !staticHandler || !errorHandler || !_requestHandler) {
            let derived = $1a84a3b286610033$var$derive(_build, mode);
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        }
        return _requestHandler(request, initialContext);
    };
};
async function $1a84a3b286610033$var$handleManifestRequest(build, dataRoutes, branches, url) {
    if (url.toString().length > (0, $gxpCl.URL_LIMIT)) return new Response(null, {
        statusText: "Bad Request",
        status: 400
    });
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("paths")) {
        let pathParam = url.searchParams.get("paths") || "";
        let paths = new Set(pathParam.split(",").filter(Boolean));
        for (let path of paths){
            if (!path.startsWith("/")) path = `/${path}`;
            let matches = $1a84a3b286610033$var$matchServerRoutes(build.routes, dataRoutes, branches, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $1a84a3b286610033$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, normalizedPath, loadContext, handleError) {
    let handlerUrl = new URL(request.url);
    handlerUrl.pathname = normalizedPath;
    let response = (0, $gxpCl.isMutationMethod)(request.method) ? await $1a84a3b286610033$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $1a84a3b286610033$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function $1a84a3b286610033$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        if ((0, $gxpCl.isMutationMethod)(request.method)) try {
            $1a84a3b286610033$var$throwIfPotentialCSRFAttack(request, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        } catch (e) {
            handleError(e);
            return new Response("Bad Request", {
                status: 400
            });
        }
        let result = await staticHandler.query(request, {
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(request);
                    if (!(0, $gxpCl.isResponse)(innerResult)) innerResult = await renderHtml(innerResult, isSpaMode);
                    return innerResult;
                } catch (error) {
                    handleError(error);
                    return new Response(null, {
                        status: 500
                    });
                }
            } : void 0,
            normalizePath: (r)=>$1a84a3b286610033$var$getNormalizedPath(r, build.basename, build.future)
        });
        if (!(0, $gxpCl.isResponse)(result)) result = await renderHtml(result, isSpaMode);
        return result;
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        let headers = $1a84a3b286610033$var$getDocumentHeaders(context, build);
        if ($1a84a3b286610033$var$SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $gxpCl.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $1a84a3b286610033$var$sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: context.errors
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            branches: staticHandler._internalRouteBranches,
            routeModules: $1a84a3b286610033$var$createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss: criticalCss,
            serverHandoffString: $1a84a3b286610033$var$createServerHandoffString({
                ...baseServerHandoff,
                criticalCss: criticalCss
            }),
            serverHandoffStream: $1a84a3b286610033$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>$1a84a3b286610033$var$serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if ((0, $gxpCl.isResponse)(error)) try {
                let data2 = await $1a84a3b286610033$var$unwrapResponse(error);
                errorForSecondRender = new (0, $gxpCl.ErrorResponseImpl)(error.status, error.statusText, data2);
            } catch (e) {}
            context = (0, $gxpCl.getStaticContextFromError)(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = $1a84a3b286610033$var$sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: $1a84a3b286610033$var$createServerHandoffString(baseServerHandoff),
                serverHandoffStream: $1a84a3b286610033$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return $1a84a3b286610033$var$returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function $1a84a3b286610033$var$handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let result = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (queryRoute)=>{
                try {
                    let innerResult = await queryRoute(request);
                    return handleQueryRouteResult(innerResult);
                } catch (error) {
                    return handleQueryRouteError(error);
                }
            } : void 0,
            normalizePath: (r)=>$1a84a3b286610033$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryRouteResult(result);
    } catch (error) {
        return handleQueryRouteError(error);
    }
    function handleQueryRouteResult(result) {
        if ((0, $gxpCl.isResponse)(result)) return result;
        if (typeof result === "string") return new Response(result);
        return Response.json(result);
    }
    function handleQueryRouteError(error) {
        if ((0, $gxpCl.isResponse)(error)) return error;
        if ((0, $gxpCl.isRouteErrorResponse)(error)) {
            handleError(error);
            return $1a84a3b286610033$var$errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return $1a84a3b286610033$var$returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return $1a84a3b286610033$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $1a84a3b286610033$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($1a84a3b286610033$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText
    });
}
function $1a84a3b286610033$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $1a84a3b286610033$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $1a84a3b286610033$var$flash(name) {
    return `__flash_${name}__`;
}
var $1a84a3b286610033$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($1a84a3b286610033$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $1a84a3b286610033$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($1a84a3b286610033$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $1a84a3b286610033$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $1a84a3b286610033$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $1a84a3b286610033$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $1a84a3b286610033$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $1a84a3b286610033$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $1a84a3b286610033$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $1a84a3b286610033$var$warnOnceAboutSigningSessionCookie(cookie) {
    (0, $gxpCl.warnOnce)(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $1a84a3b286610033$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $1a84a3b286610033$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $1a84a3b286610033$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $1a84a3b286610033$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $1a84a3b286610033$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $1a84a3b286610033$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $1a84a3b286610033$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $1a84a3b286610033$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    let result = $1a84a3b286610033$var$trimTrailingSplat(path).replace(/\/:([\w-]+)(\?)?/g, // same regex as in .\router\utils.ts: compilePath().
    (_, param, questionMark)=>{
        const isRequired = questionMark === void 0;
        const value = params?.[param];
        if (isRequired && value === void 0) throw new Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value === void 0 ? "" : "/" + value;
    });
    if (path.endsWith("*")) {
        const value = params?.["*"];
        if (value !== void 0) result += "/" + value;
    }
    return result || "/";
}
function $1a84a3b286610033$var$trimTrailingSplat(path) {
    let i = path.length - 1;
    let char = path[i];
    if (char !== "*" && char !== "/") return path;
    i--;
    for(; i >= 0; i--){
        if (path[i] !== "/") break;
    }
    return path.slice(0, i + 1);
}
// lib/rsc/html-stream/server.ts
var $1a84a3b286610033$var$encoder2 = new TextEncoder();
var $1a84a3b286610033$var$trailer = "</body></html>";
function $1a84a3b286610033$var$injectRSCPayload(rscStream) {
    let decoder = new TextDecoder();
    let resolveFlightDataPromise;
    let flightDataPromise = new Promise((resolve)=>resolveFlightDataPromise = resolve);
    let startedRSC = false;
    let buffered = [];
    let timeout = null;
    function flushBufferedChunks(controller) {
        for (let chunk of buffered){
            let buf = decoder.decode(chunk, {
                stream: true
            });
            if (buf.endsWith($1a84a3b286610033$var$trailer)) buf = buf.slice(0, -$1a84a3b286610033$var$trailer.length);
            controller.enqueue($1a84a3b286610033$var$encoder2.encode(buf));
        }
        buffered.length = 0;
        timeout = null;
    }
    return new TransformStream({
        transform (chunk, controller) {
            buffered.push(chunk);
            if (timeout) return;
            timeout = setTimeout(async ()=>{
                flushBufferedChunks(controller);
                if (!startedRSC) {
                    startedRSC = true;
                    $1a84a3b286610033$var$writeRSCStream(rscStream, controller).catch((err)=>controller.error(err)).then(resolveFlightDataPromise);
                }
            }, 0);
        },
        async flush (controller) {
            await flightDataPromise;
            if (timeout) {
                clearTimeout(timeout);
                flushBufferedChunks(controller);
            }
            controller.enqueue($1a84a3b286610033$var$encoder2.encode("</body></html>"));
        }
    });
}
async function $1a84a3b286610033$var$writeRSCStream(rscStream, controller) {
    let decoder = new TextDecoder("utf-8", {
        fatal: true
    });
    const reader = rscStream.getReader();
    try {
        let read;
        while((read = await reader.read()) && !read.done){
            const chunk = read.value;
            try {
                $1a84a3b286610033$var$writeChunk(JSON.stringify(decoder.decode(chunk, {
                    stream: true
                })), controller);
            } catch (e) {
                let base64 = JSON.stringify(btoa(String.fromCodePoint(...chunk)));
                $1a84a3b286610033$var$writeChunk(`Uint8Array.from(atob(${base64}), m => m.codePointAt(0))`, controller);
            }
        }
    } finally{
        reader.releaseLock();
    }
    let remaining = decoder.decode();
    if (remaining.length) $1a84a3b286610033$var$writeChunk(JSON.stringify(remaining), controller);
}
function $1a84a3b286610033$var$writeChunk(chunk, controller) {
    controller.enqueue($1a84a3b286610033$var$encoder2.encode(`<script>${$1a84a3b286610033$var$escapeScript(`(self.__FLIGHT_DATA||=[]).push(${chunk})`)}</script>`));
}
function $1a84a3b286610033$var$escapeScript(script) {
    return script.replace(/<!--/g, "<\\!--").replace(/<\/(script)/gi, "</\\$1");
}
var $1a84a3b286610033$export$ea608ff93320d416 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: null,
            location: props.location
        };
        return {
            error: state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1a84a3b286610033$var$RSCDefaultRootErrorBoundaryImpl, {
            error: this.state.error,
            renderAppShell: true
        });
        else return this.props.children;
    }
};
function $1a84a3b286610033$var$ErrorWrapper({ renderAppShell: renderAppShell, title: title, children: children }) {
    if (!renderAppShell) return children;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("head", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("title", null, title)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("body", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children)));
}
function $1a84a3b286610033$var$RSCDefaultRootErrorBoundaryImpl({ error: error, renderAppShell: renderAppShell }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $gxpCl.isRouteErrorResponse)(error)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1a84a3b286610033$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), (0, $gxpCl.ENABLE_DEV_WARNINGS) ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1a84a3b286610033$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Application Error!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $1a84a3b286610033$export$a55eecbda762d267({ hasRootLayout: hasRootLayout }) {
    let error = (0, $gxpCl.useRouteError)();
    if (hasRootLayout === void 0) throw new Error("Missing 'hasRootLayout' prop");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($1a84a3b286610033$var$RSCDefaultRootErrorBoundaryImpl, {
        renderAppShell: !hasRootLayout,
        error: error
    });
}
// lib/rsc/route-modules.ts
function $1a84a3b286610033$var$createRSCRouteModules(payload) {
    const routeModules = {};
    for (const match of payload.matches)$1a84a3b286610033$export$93a6ee970ac9d016(routeModules, match);
    return routeModules;
}
function $1a84a3b286610033$export$93a6ee970ac9d016(routeModules, matches) {
    matches = Array.isArray(matches) ? matches : [
        matches
    ];
    for (const match of matches)routeModules[match.id] = {
        links: match.links,
        meta: match.meta,
        default: $1a84a3b286610033$var$noopComponent
    };
}
var $1a84a3b286610033$var$noopComponent = ()=>null;
// lib/rsc/server.ssr.tsx
var $1a84a3b286610033$var$defaultManifestPath = "/__manifest";
var $1a84a3b286610033$var$REACT_USE = "use";
var $1a84a3b286610033$var$useImpl = $7fPBF[$1a84a3b286610033$var$REACT_USE];
function $1a84a3b286610033$var$useSafe(promise) {
    if ($1a84a3b286610033$var$useImpl) return $1a84a3b286610033$var$useImpl(promise);
    throw new Error("React Router v7 requires React 19+ for RSC features.");
}
async function $1a84a3b286610033$export$144ccff01a5655fc({ request: request, serverResponse: serverResponse, createFromReadableStream: createFromReadableStream, renderHTML: renderHTML, hydrate: hydrate = true }) {
    const url = new URL(request.url);
    const isDataRequest = $1a84a3b286610033$var$isReactServerRequest(url);
    const respondWithRSCPayload = isDataRequest || $1a84a3b286610033$var$isManifestRequest(url) || request.headers.has("rsc-action-id");
    if (respondWithRSCPayload || serverResponse.headers.get("React-Router-Resource") === "true") return serverResponse;
    if (!serverResponse.body) throw new Error("Missing body in server response");
    const detectRedirectResponse = serverResponse.clone();
    let serverResponseB = null;
    if (hydrate) serverResponseB = serverResponse.clone();
    const body = serverResponse.body;
    let buffer;
    let streamControllers = [];
    const createStream = ()=>{
        if (!buffer) {
            buffer = [];
            return body.pipeThrough(new TransformStream({
                transform (chunk, controller) {
                    buffer.push(chunk);
                    controller.enqueue(chunk);
                    streamControllers.forEach((c)=>c.enqueue(chunk));
                },
                flush () {
                    streamControllers.forEach((c)=>c.close());
                    streamControllers = [];
                }
            }));
        }
        return new ReadableStream({
            start (controller) {
                buffer.forEach((chunk)=>controller.enqueue(chunk));
                streamControllers.push(controller);
            }
        });
    };
    let deepestRenderedBoundaryId = null;
    const getPayload = ()=>{
        const payloadPromise = Promise.resolve(createFromReadableStream(createStream()));
        return Object.defineProperties(payloadPromise, {
            _deepestRenderedBoundaryId: {
                get () {
                    return deepestRenderedBoundaryId;
                },
                set (boundaryId1) {
                    deepestRenderedBoundaryId = boundaryId1;
                }
            },
            formState: {
                get () {
                    return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                }
            }
        });
    };
    let renderRedirect;
    let renderError;
    try {
        if (!detectRedirectResponse.body) throw new Error("Failed to clone server response");
        const payload = await createFromReadableStream(detectRedirectResponse.body);
        if (serverResponse.status === (0, $gxpCl.SINGLE_FETCH_REDIRECT_STATUS) && payload.type === "redirect") {
            if ((0, $gxpCl.hasInvalidProtocol)(payload.location)) throw new Error("Invalid redirect location");
            const headers2 = new Headers(serverResponse.headers);
            headers2.delete("Content-Encoding");
            headers2.delete("Content-Length");
            headers2.delete("Content-Type");
            headers2.delete("X-Remix-Response");
            headers2.set("Location", payload.location);
            return new Response(serverResponseB?.body || "", {
                headers: headers2,
                status: payload.status,
                statusText: serverResponse.statusText
            });
        }
        let reactHeaders = new Headers();
        let status = serverResponse.status;
        let statusText = serverResponse.statusText;
        let html = await renderHTML(getPayload, {
            onError (error) {
                if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
                    renderRedirect = (0, $gxpCl.decodeRedirectErrorDigest)(error.digest);
                    if (renderRedirect) return error.digest;
                    let routeErrorResponse = (0, $gxpCl.decodeRouteErrorResponseDigest)(error.digest);
                    if (routeErrorResponse) {
                        renderError = routeErrorResponse;
                        status = routeErrorResponse.status;
                        statusText = routeErrorResponse.statusText;
                        return error.digest;
                    }
                }
            },
            onHeaders (headers2) {
                for (const [key, value] of headers2)reactHeaders.append(key, value);
            }
        });
        const headers = new Headers(reactHeaders);
        for (const [key, value] of serverResponse.headers)headers.append(key, value);
        headers.set("Content-Type", "text/html; charset=utf-8");
        if (renderRedirect) {
            if ((0, $gxpCl.hasInvalidProtocol)(renderRedirect.location)) throw new Error("Invalid redirect location");
            headers.set("Location", renderRedirect.location);
            return new Response(html, {
                status: renderRedirect.status,
                headers: headers
            });
        }
        const redirectTransform = new TransformStream({
            flush (controller) {
                if (renderRedirect) {
                    if ((0, $gxpCl.hasInvalidProtocol)(renderRedirect.location)) return;
                    controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $gxpCl.escapeAttribute)(renderRedirect.location)}"/>`));
                }
            }
        });
        if (!hydrate) return new Response(html.pipeThrough(redirectTransform), {
            status: status,
            statusText: statusText,
            headers: headers
        });
        if (!serverResponseB?.body) throw new Error("Failed to clone server response");
        const body2 = html.pipeThrough($1a84a3b286610033$var$injectRSCPayload(serverResponseB.body)).pipeThrough(redirectTransform);
        return new Response(body2, {
            status: status,
            statusText: statusText,
            headers: headers
        });
    } catch (error) {
        if (error instanceof Response) return error;
        if (renderRedirect) {
            if ((0, $gxpCl.hasInvalidProtocol)(renderRedirect.location)) throw new Error("Invalid redirect location");
            return new Response(`Redirect: ${renderRedirect.location}`, {
                status: renderRedirect.status,
                headers: {
                    Location: renderRedirect.location
                }
            });
        }
        try {
            let normalizedError = renderError ?? error;
            let [status, statusText] = (0, $gxpCl.isRouteErrorResponse)(normalizedError) ? [
                normalizedError.status,
                normalizedError.statusText
            ] : [
                500,
                ""
            ];
            let retryRedirect;
            let reactHeaders = new Headers();
            const html = await renderHTML(()=>{
                const decoded = Promise.resolve(createFromReadableStream(createStream()));
                const payloadPromise = decoded.then((payload)=>Object.assign(payload, {
                        status: status,
                        errors: deepestRenderedBoundaryId ? {
                            [deepestRenderedBoundaryId]: normalizedError
                        } : {}
                    }));
                return Object.defineProperties(payloadPromise, {
                    _deepestRenderedBoundaryId: {
                        get () {
                            return deepestRenderedBoundaryId;
                        },
                        set (boundaryId1) {
                            deepestRenderedBoundaryId = boundaryId1;
                        }
                    },
                    formState: {
                        get () {
                            return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                        }
                    }
                });
            }, {
                onError (error2) {
                    if (typeof error2 === "object" && error2 && "digest" in error2 && typeof error2.digest === "string") {
                        retryRedirect = (0, $gxpCl.decodeRedirectErrorDigest)(error2.digest);
                        if (retryRedirect) return error2.digest;
                        let routeErrorResponse = (0, $gxpCl.decodeRouteErrorResponseDigest)(error2.digest);
                        if (routeErrorResponse) {
                            status = routeErrorResponse.status;
                            statusText = routeErrorResponse.statusText;
                            return error2.digest;
                        }
                    }
                },
                onHeaders (headers2) {
                    for (const [key, value] of headers2)reactHeaders.append(key, value);
                }
            });
            const headers = new Headers(reactHeaders);
            for (const [key, value] of serverResponse.headers)headers.append(key, value);
            headers.set("Content-Type", "text/html; charset=utf-8");
            if (retryRedirect) {
                if ((0, $gxpCl.hasInvalidProtocol)(retryRedirect.location)) throw new Error("Invalid redirect location");
                headers.set("Location", retryRedirect.location);
                return new Response(html, {
                    status: retryRedirect.status,
                    headers: headers
                });
            }
            const retryRedirectTransform = new TransformStream({
                flush (controller) {
                    if (retryRedirect) {
                        if ((0, $gxpCl.hasInvalidProtocol)(retryRedirect.location)) return;
                        controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $gxpCl.escapeAttribute)(retryRedirect.location)}"/>`));
                    }
                }
            });
            if (!hydrate) return new Response(html.pipeThrough(retryRedirectTransform), {
                status: status,
                statusText: statusText,
                headers: headers
            });
            if (!serverResponseB?.body) throw new Error("Failed to clone server response");
            const body2 = html.pipeThrough($1a84a3b286610033$var$injectRSCPayload(serverResponseB.body)).pipeThrough(retryRedirectTransform);
            return new Response(body2, {
                status: status,
                statusText: statusText,
                headers: headers
            });
        } catch (error2) {}
        throw error;
    }
}
function $1a84a3b286610033$export$7f2da8ab5e593830({ getPayload: getPayload }) {
    const decoded = getPayload();
    const payload = $1a84a3b286610033$var$useSafe(decoded);
    if (payload.type === "redirect") {
        if ((0, $gxpCl.hasInvalidProtocol)(payload.location)) throw new Error("Invalid redirect location");
        throw new Response(null, {
            status: payload.status,
            headers: {
                Location: payload.location
            }
        });
    }
    if (payload.type !== "render") return null;
    let patchedLoaderData = {
        ...payload.loaderData
    };
    for (const match of payload.matches)if ((0, $gxpCl.shouldHydrateRouteLoader)(match.id, match.clientLoader, match.hasLoader, false) && (match.hydrateFallbackElement || !match.hasLoader)) delete patchedLoaderData[match.id];
    const context = {
        get _deepestRenderedBoundaryId () {
            return decoded._deepestRenderedBoundaryId ?? null;
        },
        set _deepestRenderedBoundaryId (boundaryId){
            decoded._deepestRenderedBoundaryId = boundaryId;
        },
        actionData: payload.actionData,
        actionHeaders: {},
        basename: payload.basename,
        errors: payload.errors,
        loaderData: patchedLoaderData,
        loaderHeaders: {},
        location: payload.location,
        statusCode: 200,
        matches: payload.matches.map((match)=>({
                params: match.params,
                pathname: match.pathname,
                pathnameBase: match.pathnameBase,
                route: {
                    id: match.id,
                    action: match.hasAction || !!match.clientAction,
                    handle: match.handle,
                    hasErrorBoundary: match.hasErrorBoundary,
                    loader: match.hasLoader || !!match.clientLoader,
                    index: match.index,
                    path: match.path,
                    shouldRevalidate: match.shouldRevalidate
                }
            }))
    };
    const router = (0, $gxpCl.createStaticRouter)(payload.matches.reduceRight((previous, match)=>{
        const route = {
            id: match.id,
            action: match.hasAction || !!match.clientAction,
            element: match.element,
            errorElement: match.errorElement,
            handle: match.handle,
            hasErrorBoundary: !!match.errorElement,
            hydrateFallbackElement: match.hydrateFallbackElement,
            index: match.index,
            loader: match.hasLoader || !!match.clientLoader,
            path: match.path,
            shouldRevalidate: match.shouldRevalidate
        };
        if (previous.length > 0) route.children = previous;
        return [
            route
        ];
    }, []), context);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            v8_trailingSlashAwareDataRequests: true,
            // always on for RSC
            v8_passThroughRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: payload.routeDiscovery.mode === "initial" ? {
            mode: "initial",
            manifestPath: $1a84a3b286610033$var$defaultManifestPath
        } : {
            mode: "lazy",
            manifestPath: payload.routeDiscovery.manifestPath || $1a84a3b286610033$var$defaultManifestPath
        },
        routeModules: $1a84a3b286610033$var$createRSCRouteModules(payload)
    };
    return /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RSCRouterContext).Provider, {
        value: true
    }, /* @__PURE__ */ $7fPBF.createElement($1a84a3b286610033$export$ea608ff93320d416, {
        location: payload.location
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.FrameworkContext).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.StaticRouterProvider), {
        context: context,
        router: router,
        hydrate: false,
        nonce: payload.nonce
    }))));
}
function $1a84a3b286610033$var$isReactServerRequest(url) {
    return url.pathname.endsWith(".rsc");
}
function $1a84a3b286610033$var$isManifestRequest(url) {
    return url.pathname.endsWith(".manifest");
}
// lib/dom/ssr/hydration.tsx
function $1a84a3b286610033$export$6fa8d910d97963ad({ state: state, routes: routes, getRouteInfo: getRouteInfo, location: location, basename: basename, isSpaMode: isSpaMode }) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = (0, $gxpCl.matchRoutes)(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if ((0, $gxpCl.shouldHydrateRouteLoader)(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}



var $gxpCl = parcelRequire("gxpCl");

var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
"use client";
function $c7aa18acde4aa33a$export$323e4fc2fa4753fb(props) {
    return /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RouterProvider), {
        flushSync: $fw0lo.flushSync,
        ...props
    });
}
var $c7aa18acde4aa33a$var$ssrInfo = null;
var $c7aa18acde4aa33a$var$router = null;
function $c7aa18acde4aa33a$var$initSsrInfo() {
    if (!$c7aa18acde4aa33a$var$ssrInfo && window.__reactRouterContext && window.__reactRouterManifest && window.__reactRouterRouteModules) {
        if (window.__reactRouterManifest.sri === true) {
            const importMap = document.querySelector("script[rr-importmap]");
            if (importMap?.textContent) try {
                window.__reactRouterManifest.sri = JSON.parse(importMap.textContent).integrity;
            } catch (err) {
                console.error("Failed to parse import map", err);
            }
        }
        $c7aa18acde4aa33a$var$ssrInfo = {
            context: window.__reactRouterContext,
            manifest: window.__reactRouterManifest,
            routeModules: window.__reactRouterRouteModules,
            stateDecodingPromise: void 0,
            router: void 0,
            routerInitialized: false
        };
    }
}
function $c7aa18acde4aa33a$var$createHydratedRouter({ getContext: getContext, instrumentations: instrumentations }) {
    $c7aa18acde4aa33a$var$initSsrInfo();
    if (!$c7aa18acde4aa33a$var$ssrInfo) throw new Error("You must be using the SSR features of React Router in order to skip passing a `router` prop to `<RouterProvider>`");
    let localSsrInfo = $c7aa18acde4aa33a$var$ssrInfo;
    if (!$c7aa18acde4aa33a$var$ssrInfo.stateDecodingPromise) {
        let stream = $c7aa18acde4aa33a$var$ssrInfo.context.stream;
        (0, $gxpCl.invariant)(stream, "No stream found for single fetch decoding");
        $c7aa18acde4aa33a$var$ssrInfo.context.stream = void 0;
        $c7aa18acde4aa33a$var$ssrInfo.stateDecodingPromise = (0, $gxpCl.decodeViaTurboStream)(stream, window).then((value)=>{
            $c7aa18acde4aa33a$var$ssrInfo.context.state = value.value;
            localSsrInfo.stateDecodingPromise.value = true;
        }).catch((e)=>{
            localSsrInfo.stateDecodingPromise.error = e;
        });
    }
    if ($c7aa18acde4aa33a$var$ssrInfo.stateDecodingPromise.error) throw $c7aa18acde4aa33a$var$ssrInfo.stateDecodingPromise.error;
    if (!$c7aa18acde4aa33a$var$ssrInfo.stateDecodingPromise.value) throw $c7aa18acde4aa33a$var$ssrInfo.stateDecodingPromise;
    let routes = (0, $gxpCl.createClientRoutes)($c7aa18acde4aa33a$var$ssrInfo.manifest.routes, $c7aa18acde4aa33a$var$ssrInfo.routeModules, $c7aa18acde4aa33a$var$ssrInfo.context.state, $c7aa18acde4aa33a$var$ssrInfo.context.ssr, $c7aa18acde4aa33a$var$ssrInfo.context.isSpaMode);
    let hydrationData = void 0;
    if ($c7aa18acde4aa33a$var$ssrInfo.context.isSpaMode) {
        let { loaderData: loaderData } = $c7aa18acde4aa33a$var$ssrInfo.context.state;
        if ($c7aa18acde4aa33a$var$ssrInfo.manifest.routes.root?.hasLoader && loaderData && "root" in loaderData) hydrationData = {
            loaderData: {
                root: loaderData.root
            }
        };
    } else hydrationData = (0, $1a84a3b286610033$export$6fa8d910d97963ad)({
        state: $c7aa18acde4aa33a$var$ssrInfo.context.state,
        routes: routes,
        getRouteInfo: (routeId)=>({
                clientLoader: $c7aa18acde4aa33a$var$ssrInfo.routeModules[routeId]?.clientLoader,
                hasLoader: $c7aa18acde4aa33a$var$ssrInfo.manifest.routes[routeId]?.hasLoader === true,
                hasHydrateFallback: $c7aa18acde4aa33a$var$ssrInfo.routeModules[routeId]?.HydrateFallback != null
            }),
        location: window.location,
        basename: window.__reactRouterContext?.basename,
        isSpaMode: $c7aa18acde4aa33a$var$ssrInfo.context.isSpaMode
    });
    if (window.history.state && window.history.state.masked) window.history.replaceState({
        ...window.history.state,
        masked: void 0
    }, "");
    let router2 = (0, $gxpCl.createRouter)({
        routes: routes,
        history: (0, $gxpCl.createBrowserHistory)(),
        basename: $c7aa18acde4aa33a$var$ssrInfo.context.basename,
        getContext: getContext,
        hydrationData: hydrationData,
        hydrationRouteProperties: $gxpCl.hydrationRouteProperties,
        instrumentations: instrumentations,
        mapRouteProperties: $gxpCl.mapRouteProperties,
        future: {
            v8_passThroughRequests: $c7aa18acde4aa33a$var$ssrInfo.context.future.v8_passThroughRequests
        },
        dataStrategy: (0, $gxpCl.getTurboStreamSingleFetchDataStrategy)(()=>router2, $c7aa18acde4aa33a$var$ssrInfo.manifest, $c7aa18acde4aa33a$var$ssrInfo.routeModules, $c7aa18acde4aa33a$var$ssrInfo.context.ssr, $c7aa18acde4aa33a$var$ssrInfo.context.basename, $c7aa18acde4aa33a$var$ssrInfo.context.future.v8_trailingSlashAwareDataRequests),
        patchRoutesOnNavigation: (0, $gxpCl.getPatchRoutesOnNavigationFunction)(()=>router2, $c7aa18acde4aa33a$var$ssrInfo.manifest, $c7aa18acde4aa33a$var$ssrInfo.routeModules, $c7aa18acde4aa33a$var$ssrInfo.context.ssr, $c7aa18acde4aa33a$var$ssrInfo.context.routeDiscovery, $c7aa18acde4aa33a$var$ssrInfo.context.isSpaMode, $c7aa18acde4aa33a$var$ssrInfo.context.basename)
    });
    $c7aa18acde4aa33a$var$ssrInfo.router = router2;
    if (router2.state.initialized) {
        $c7aa18acde4aa33a$var$ssrInfo.routerInitialized = true;
        router2.initialize();
    }
    router2.createRoutesForHMR = /* spacer so ts-ignore does not affect the right hand of the assignment */ (0, $gxpCl.createClientRoutesWithHMRRevalidationOptOut);
    window.__reactRouterDataRouter = router2;
    return router2;
}
function $c7aa18acde4aa33a$export$63ce90781bf4d238(props) {
    if (!$c7aa18acde4aa33a$var$router) $c7aa18acde4aa33a$var$router = $c7aa18acde4aa33a$var$createHydratedRouter({
        getContext: props.getContext,
        instrumentations: props.instrumentations
    });
    let [criticalCss, setCriticalCss] = $7fPBF.useState(void 0);
    $7fPBF.useEffect(()=>{}, []);
    $7fPBF.useEffect(()=>{
        var element;
    }, [
        criticalCss
    ]);
    let [location2, setLocation] = $7fPBF.useState($c7aa18acde4aa33a$var$router.state.location);
    $7fPBF.useLayoutEffect(()=>{
        if ($c7aa18acde4aa33a$var$ssrInfo && $c7aa18acde4aa33a$var$ssrInfo.router && !$c7aa18acde4aa33a$var$ssrInfo.routerInitialized) {
            $c7aa18acde4aa33a$var$ssrInfo.routerInitialized = true;
            $c7aa18acde4aa33a$var$ssrInfo.router.initialize();
        }
    }, []);
    $7fPBF.useLayoutEffect(()=>{
        if ($c7aa18acde4aa33a$var$ssrInfo && $c7aa18acde4aa33a$var$ssrInfo.router) return $c7aa18acde4aa33a$var$ssrInfo.router.subscribe((newState)=>{
            if (newState.location !== location2) setLocation(newState.location);
        });
    }, [
        location2
    ]);
    (0, $gxpCl.invariant)($c7aa18acde4aa33a$var$ssrInfo, "ssrInfo unavailable for HydratedRouter");
    (0, $gxpCl.useFogOFWarDiscovery)($c7aa18acde4aa33a$var$router, $c7aa18acde4aa33a$var$ssrInfo.manifest, $c7aa18acde4aa33a$var$ssrInfo.routeModules, $c7aa18acde4aa33a$var$ssrInfo.context.ssr, $c7aa18acde4aa33a$var$ssrInfo.context.routeDiscovery, $c7aa18acde4aa33a$var$ssrInfo.context.isSpaMode);
    return(// This fragment is important to ensure we match the <ServerRouter> JSX
    // structure so that useId values hydrate correctly
    /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.FrameworkContext).Provider, {
        value: {
            manifest: $c7aa18acde4aa33a$var$ssrInfo.manifest,
            routeModules: $c7aa18acde4aa33a$var$ssrInfo.routeModules,
            future: $c7aa18acde4aa33a$var$ssrInfo.context.future,
            criticalCss: criticalCss,
            ssr: $c7aa18acde4aa33a$var$ssrInfo.context.ssr,
            isSpaMode: $c7aa18acde4aa33a$var$ssrInfo.context.isSpaMode,
            routeDiscovery: $c7aa18acde4aa33a$var$ssrInfo.context.routeDiscovery
        }
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RemixErrorBoundary), {
        location: location2
    }, /* @__PURE__ */ $7fPBF.createElement($c7aa18acde4aa33a$export$323e4fc2fa4753fb, {
        router: $c7aa18acde4aa33a$var$router,
        useTransitions: props.useTransitions,
        onError: props.onError
    }))), /* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null)));
}
var $c7aa18acde4aa33a$var$defaultManifestPath = "/__manifest";
function $c7aa18acde4aa33a$export$e5e8f3607b669df({ createFromReadableStream: createFromReadableStream, createTemporaryReferenceSet: createTemporaryReferenceSet, encodeReply: encodeReply, fetch: fetchImplementation = fetch }) {
    const globalVar = window;
    let landedActionId = 0;
    return async (id, args)=>{
        let actionId = globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
        const temporaryReferences = createTemporaryReferenceSet();
        const payloadPromise = fetchImplementation(new Request(location.href, {
            body: await encodeReply(args, {
                temporaryReferences: temporaryReferences
            }),
            method: "POST",
            headers: {
                Accept: "text/x-component",
                "rsc-action-id": id
            }
        })).then((response)=>{
            if (!response.body) throw new Error("No response body");
            return createFromReadableStream(response.body, {
                temporaryReferences: temporaryReferences
            });
        });
        $7fPBF.startTransition(()=>// @ts-expect-error - Needs React 19 types
            Promise.resolve(payloadPromise).then(async (payload)=>{
                if (payload.type === "redirect") {
                    let location2 = $c7aa18acde4aa33a$var$normalizeRedirectLocation(payload.location);
                    (0, $gxpCl.validateNavigationTarget)(payload.location, location2, new URL(window.location.href), "allow-explicit");
                    if (payload.reload || $c7aa18acde4aa33a$var$isExternalLocation(location2)) {
                        if ((0, $gxpCl.hasInvalidProtocol)(location2)) throw new Error("Invalid redirect location");
                        window.location.href = location2;
                        return;
                    }
                    $7fPBF.startTransition(()=>{
                        globalVar.__reactRouterDataRouter.navigate(location2, {
                            replace: payload.replace
                        });
                    });
                    return;
                }
                if (payload.type !== "action") throw new Error("Unexpected payload type");
                const rerender = await payload.rerender;
                if (rerender && landedActionId < actionId && globalVar.__routerActionID <= actionId) {
                    if (rerender.type === "redirect") {
                        let location2 = $c7aa18acde4aa33a$var$normalizeRedirectLocation(rerender.location);
                        (0, $gxpCl.validateNavigationTarget)(rerender.location, location2, new URL(window.location.href), "allow-explicit");
                        if (rerender.reload || $c7aa18acde4aa33a$var$isExternalLocation(location2)) {
                            if ((0, $gxpCl.hasInvalidProtocol)(location2)) throw new Error("Invalid redirect location");
                            window.location.href = location2;
                            return;
                        }
                        $7fPBF.startTransition(()=>{
                            globalVar.__reactRouterDataRouter.navigate(location2, {
                                replace: rerender.replace
                            });
                        });
                        return;
                    }
                    $7fPBF.startTransition(()=>{
                        let lastMatch;
                        for (const match of rerender.matches){
                            globalVar.__reactRouterDataRouter.patchRoutes(lastMatch?.id ?? null, [
                                $c7aa18acde4aa33a$var$createRouteFromServerManifest(match)
                            ], true);
                            lastMatch = match;
                        }
                        window.__reactRouterDataRouter._internalSetStateDoNotUseOrYouWillBreakYourApp({
                            loaderData: Object.assign({}, globalVar.__reactRouterDataRouter.state.loaderData, rerender.loaderData),
                            errors: rerender.errors ? Object.assign({}, globalVar.__reactRouterDataRouter.state.errors, rerender.errors) : null
                        });
                    });
                }
            }).catch(()=>{}));
        return payloadPromise.then((payload)=>{
            if (payload.type !== "action" && payload.type !== "redirect") throw new Error("Unexpected payload type");
            return payload.actionResult;
        });
    };
}
function $c7aa18acde4aa33a$var$createRouterFromPayload({ fetchImplementation: fetchImplementation, createFromReadableStream: createFromReadableStream, getContext: getContext, payload: payload }) {
    const globalVar = window;
    if (globalVar.__reactRouterDataRouter && globalVar.__reactRouterRouteModules) return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
    if (payload.type !== "render") throw new Error("Invalid payload type");
    globalVar.__reactRouterRouteModules = globalVar.__reactRouterRouteModules ?? {};
    (0, $1a84a3b286610033$export$93a6ee970ac9d016)(globalVar.__reactRouterRouteModules, payload.matches);
    let routes = payload.matches.reduceRight((previous, match)=>{
        const route = $c7aa18acde4aa33a$var$createRouteFromServerManifest(match, payload);
        if (previous.length > 0) route.children = previous;
        else if (!route.index) route.children = [];
        return [
            route
        ];
    }, []);
    let applyPatchesPromise;
    globalVar.__reactRouterDataRouter = (0, $gxpCl.createRouter)({
        routes: routes,
        getContext: getContext,
        basename: payload.basename,
        history: (0, $gxpCl.createBrowserHistory)(),
        hydrationData: (0, $1a84a3b286610033$export$6fa8d910d97963ad)({
            state: {
                loaderData: payload.loaderData,
                actionData: payload.actionData,
                errors: payload.errors
            },
            routes: routes,
            getRouteInfo: (routeId)=>{
                let match = payload.matches.find((m)=>m.id === routeId);
                (0, $gxpCl.invariant)(match, "Route not found in payload");
                return {
                    clientLoader: match.clientLoader,
                    hasLoader: match.hasLoader,
                    hasHydrateFallback: match.hydrateFallbackElement != null
                };
            },
            location: payload.location,
            basename: payload.basename,
            isSpaMode: false
        }),
        async patchRoutesOnNavigation ({ path: path, signal: signal }) {
            if (payload.routeDiscovery.mode === "initial") {
                if (!applyPatchesPromise) applyPatchesPromise = (async ()=>{
                    if (!payload.patches) return;
                    let patches = await payload.patches;
                    $7fPBF.startTransition(()=>{
                        patches.forEach((p)=>{
                            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                                $c7aa18acde4aa33a$var$createRouteFromServerManifest(p)
                            ]);
                        });
                    });
                })();
                await applyPatchesPromise;
                return;
            }
            if ($c7aa18acde4aa33a$var$discoveredPaths.has(path)) return;
            await $c7aa18acde4aa33a$var$fetchAndApplyManifestPatches([
                path
            ], createFromReadableStream, fetchImplementation, signal);
        },
        // FIXME: Pass `build.ssr` into this function
        dataStrategy: $c7aa18acde4aa33a$var$getRSCSingleFetchDataStrategy(()=>globalVar.__reactRouterDataRouter, true, payload.basename, createFromReadableStream, fetchImplementation)
    });
    if (globalVar.__reactRouterDataRouter.state.initialized) {
        globalVar.__routerInitialized = true;
        globalVar.__reactRouterDataRouter.initialize();
    } else globalVar.__routerInitialized = false;
    let lastLoaderData = void 0;
    globalVar.__reactRouterDataRouter.subscribe(({ loaderData: loaderData, actionData: actionData })=>{
        if (lastLoaderData !== loaderData) globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
    });
    globalVar.__reactRouterDataRouter._updateRoutesForHMR = (routeUpdateByRouteId)=>{
        const oldRoutes = window.__reactRouterDataRouter.routes;
        const newRoutes = [];
        function walkRoutes(routes2, parentId) {
            return routes2.map((route)=>{
                const routeUpdate = routeUpdateByRouteId.get(route.id);
                if (routeUpdate) {
                    const { routeModule: routeModule, hasAction: hasAction, hasComponent: hasComponent, hasErrorBoundary: hasErrorBoundary, hasLoader: hasLoader } = routeUpdate;
                    const newRoute = $c7aa18acde4aa33a$var$createRouteFromServerManifest({
                        clientAction: routeModule.clientAction,
                        clientLoader: routeModule.clientLoader,
                        element: route.element,
                        errorElement: route.errorElement,
                        handle: route.handle,
                        hasAction: hasAction,
                        hasComponent: hasComponent,
                        hasErrorBoundary: hasErrorBoundary,
                        hasLoader: hasLoader,
                        hydrateFallbackElement: route.hydrateFallbackElement,
                        id: route.id,
                        index: route.index,
                        links: routeModule.links,
                        meta: routeModule.meta,
                        parentId: parentId,
                        path: route.path,
                        shouldRevalidate: routeModule.shouldRevalidate
                    });
                    if (route.children) newRoute.children = walkRoutes(route.children, route.id);
                    return newRoute;
                }
                const updatedRoute = {
                    ...route
                };
                if (route.children) updatedRoute.children = walkRoutes(route.children, route.id);
                return updatedRoute;
            });
        }
        newRoutes.push(...walkRoutes(oldRoutes, void 0));
        window.__reactRouterDataRouter._internalSetRoutes(newRoutes);
    };
    return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
}
var $c7aa18acde4aa33a$var$renderedRoutesContext = (0, $gxpCl.createContext)();
function $c7aa18acde4aa33a$var$getRSCSingleFetchDataStrategy(getRouter, ssr, basename, createFromReadableStream, fetchImplementation) {
    let dataStrategy = (0, $gxpCl.getSingleFetchDataStrategyImpl)(getRouter, (match)=>{
        let M = match;
        return {
            hasLoader: M.route.hasLoader,
            hasClientLoader: M.route.hasClientLoader,
            hasComponent: M.route.hasComponent,
            hasAction: M.route.hasAction,
            hasClientAction: M.route.hasClientAction
        };
    }, // pass map into fetchAndDecode so it can add payloads
    $c7aa18acde4aa33a$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation), ssr, basename, // .rsc requests are always trailing slash aware
    true, // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    (match)=>{
        let M = match;
        return M.route.hasComponent && !M.route.element;
    });
    return async (args)=>args.runClientMiddleware(async ()=>{
            let context = args.context;
            context.set($c7aa18acde4aa33a$var$renderedRoutesContext, []);
            let results = await dataStrategy(args);
            const renderedRoutesById = /* @__PURE__ */ new Map();
            for (const route of context.get($c7aa18acde4aa33a$var$renderedRoutesContext)){
                if (!renderedRoutesById.has(route.id)) renderedRoutesById.set(route.id, []);
                renderedRoutesById.get(route.id).push(route);
            }
            $7fPBF.startTransition(()=>{
                for (const match of args.matches){
                    const renderedRoutes = renderedRoutesById.get(match.route.id);
                    if (renderedRoutes) for (const rendered of renderedRoutes)window.__reactRouterDataRouter.patchRoutes(rendered.parentId ?? null, [
                        $c7aa18acde4aa33a$var$createRouteFromServerManifest(rendered)
                    ], true);
                }
            });
            return results;
        });
}
function $c7aa18acde4aa33a$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation) {
    return async (args, basename, trailingSlashAware, targetRoutes)=>{
        let { request: request, context: context } = args;
        let url = (0, $gxpCl.singleFetchUrl)(request.url, basename, trailingSlashAware, "rsc");
        if (request.method === "GET") {
            url = (0, $gxpCl.stripIndexParam)(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let res = await fetchImplementation(new Request(url, await (0, $gxpCl.createRequestInit)(request)));
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $gxpCl.ErrorResponseImpl)(res.status, res.statusText, await res.text());
        (0, $gxpCl.invariant)(res.body, "No response body to decode");
        try {
            const payload = await createFromReadableStream(res.body, {
                temporaryReferences: void 0
            });
            if (payload.type === "redirect") return {
                status: res.status,
                data: {
                    redirect: {
                        redirect: payload.location,
                        reload: payload.reload,
                        replace: payload.replace,
                        revalidate: false,
                        status: payload.status
                    }
                }
            };
            if (payload.type !== "render") throw new Error("Unexpected payload type");
            context.get($c7aa18acde4aa33a$var$renderedRoutesContext).push(...payload.matches);
            let results = {
                routes: {}
            };
            const dataKey = (0, $gxpCl.isMutationMethod)(request.method) ? "actionData" : "loaderData";
            for (let [routeId, data] of Object.entries(payload[dataKey] || {}))results.routes[routeId] = {
                data: data
            };
            if (payload.errors) for (let [routeId, error] of Object.entries(payload.errors))results.routes[routeId] = {
                error: error
            };
            return {
                status: res.status,
                data: results
            };
        } catch (cause) {
            throw new Error("Unable to decode RSC response", {
                cause: cause
            });
        }
    };
}
function $c7aa18acde4aa33a$export$af9dbdb90aaefbae({ createFromReadableStream: createFromReadableStream, fetch: fetchImplementation = fetch, payload: payload, getContext: getContext }) {
    if (payload.type !== "render") throw new Error("Invalid payload type");
    let { routeDiscovery: routeDiscovery } = payload;
    let { router: router2, routeModules: routeModules } = $7fPBF.useMemo(()=>$c7aa18acde4aa33a$var$createRouterFromPayload({
            payload: payload,
            fetchImplementation: fetchImplementation,
            getContext: getContext,
            createFromReadableStream: createFromReadableStream
        }), [
        createFromReadableStream,
        payload,
        fetchImplementation,
        getContext
    ]);
    $7fPBF.useEffect(()=>{
        (0, $gxpCl.setIsHydrated)();
    }, []);
    $7fPBF.useLayoutEffect(()=>{
        const globalVar = window;
        if (!globalVar.__routerInitialized) {
            globalVar.__routerInitialized = true;
            globalVar.__reactRouterDataRouter.initialize();
        }
    }, []);
    let [{ routes: routes, state: state }, setState] = $7fPBF.useState(()=>({
            routes: $c7aa18acde4aa33a$var$cloneRoutes(router2.routes),
            state: router2.state
        }));
    $7fPBF.useLayoutEffect(()=>router2.subscribe((newState)=>{
            if ($c7aa18acde4aa33a$var$diffRoutes(router2.routes, routes)) $7fPBF.startTransition(()=>{
                setState({
                    routes: $c7aa18acde4aa33a$var$cloneRoutes(router2.routes),
                    state: newState
                });
            });
        }), [
        router2.subscribe,
        routes,
        router2
    ]);
    const transitionEnabledRouter = $7fPBF.useMemo(()=>({
            ...router2,
            state: state,
            routes: routes
        }), [
        router2,
        routes,
        state
    ]);
    $7fPBF.useEffect(()=>{
        if (routeDiscovery.mode === "initial" || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$c7aa18acde4aa33a$var$discoveredPaths.has(pathname)) $c7aa18acde4aa33a$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let paths = Array.from($c7aa18acde4aa33a$var$nextPaths.keys()).filter((path)=>{
                if ($c7aa18acde4aa33a$var$discoveredPaths.has(path)) {
                    $c7aa18acde4aa33a$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (paths.length === 0) return;
            try {
                await $c7aa18acde4aa33a$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $c7aa18acde4aa33a$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
    }, [
        routeDiscovery,
        createFromReadableStream,
        fetchImplementation
    ]);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            v8_trailingSlashAwareDataRequests: true,
            // always on for RSC
            v8_passThroughRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: payload.routeDiscovery.mode === "initial" ? {
            mode: "initial",
            manifestPath: $c7aa18acde4aa33a$var$defaultManifestPath
        } : {
            mode: "lazy",
            manifestPath: payload.routeDiscovery.manifestPath || $c7aa18acde4aa33a$var$defaultManifestPath
        },
        routeModules: routeModules
    };
    return /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RSCRouterContext).Provider, {
        value: true
    }, /* @__PURE__ */ $7fPBF.createElement((0, $1a84a3b286610033$export$ea608ff93320d416), {
        location: state.location
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.FrameworkContext).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $7fPBF.createElement((0, $gxpCl.RouterProvider), {
        router: transitionEnabledRouter,
        flushSync: $fw0lo.flushSync
    }))));
}
function $c7aa18acde4aa33a$var$createRouteFromServerManifest(match, payload) {
    let hasInitialData = payload && match.id in payload.loaderData;
    let initialData = payload?.loaderData[match.id];
    let hasInitialError = payload?.errors && match.id in payload.errors;
    let initialError = payload?.errors?.[match.id];
    let isHydrationRequest = match.clientLoader?.hydrate === true || !match.hasLoader || // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    match.hasComponent && !match.element;
    (0, $gxpCl.invariant)(window.__reactRouterRouteModules);
    (0, $1a84a3b286610033$export$93a6ee970ac9d016)(window.__reactRouterRouteModules, match);
    let dataRoute = {
        id: match.id,
        element: match.element,
        errorElement: match.errorElement,
        handle: match.handle,
        hasErrorBoundary: match.hasErrorBoundary,
        hydrateFallbackElement: match.hydrateFallbackElement,
        index: match.index,
        loader: match.clientLoader ? async (args, singleFetch)=>{
            let _isHydrationRequest = isHydrationRequest;
            isHydrationRequest = false;
            let result = await match.clientLoader({
                ...args,
                serverLoader: ()=>{
                    $c7aa18acde4aa33a$var$preventInvalidServerHandlerCall("loader", match.id, match.hasLoader);
                    if (_isHydrationRequest) {
                        if (hasInitialData) return initialData;
                        if (hasInitialError) throw initialError;
                    }
                    return $c7aa18acde4aa33a$var$callSingleFetch(singleFetch);
                }
            });
            return result;
        } : // We always make the call in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        (_, singleFetch)=>$c7aa18acde4aa33a$var$callSingleFetch(singleFetch),
        action: match.clientAction ? (args, singleFetch)=>match.clientAction({
                ...args,
                serverAction: async ()=>{
                    $c7aa18acde4aa33a$var$preventInvalidServerHandlerCall("action", match.id, match.hasLoader);
                    return await $c7aa18acde4aa33a$var$callSingleFetch(singleFetch);
                }
            }) : match.hasAction ? (_, singleFetch)=>$c7aa18acde4aa33a$var$callSingleFetch(singleFetch) : ()=>{
            throw (0, $gxpCl.noActionDefinedError)("action", match.id);
        },
        path: match.path,
        shouldRevalidate: match.shouldRevalidate,
        // We always have a "loader" in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        hasLoader: true,
        hasClientLoader: match.clientLoader != null,
        hasAction: match.hasAction,
        hasClientAction: match.clientAction != null
    };
    if (typeof dataRoute.loader === "function") dataRoute.loader.hydrate = (0, $gxpCl.shouldHydrateRouteLoader)(match.id, match.clientLoader, match.hasLoader, false);
    return dataRoute;
}
function $c7aa18acde4aa33a$var$callSingleFetch(singleFetch) {
    (0, $gxpCl.invariant)(typeof singleFetch === "function", "Invalid singleFetch parameter");
    return singleFetch();
}
function $c7aa18acde4aa33a$var$preventInvalidServerHandlerCall(type, routeId, hasHandler) {
    if (!hasHandler) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${routeId}")`;
        console.error(msg);
        throw new (0, $gxpCl.ErrorResponseImpl)(400, "Bad Request", new Error(msg), true);
    }
}
var $c7aa18acde4aa33a$var$nextPaths = /* @__PURE__ */ new Set();
var $c7aa18acde4aa33a$var$discoveredPathsMaxSize = 1e3;
var $c7aa18acde4aa33a$var$discoveredPaths = /* @__PURE__ */ new Set();
function $c7aa18acde4aa33a$var$getManifestUrl(paths) {
    if (paths.length === 0) return null;
    if (paths.length === 1) return new URL(`${paths[0]}.manifest`, window.location.origin);
    const globalVar = window;
    let basename = (globalVar.__reactRouterDataRouter.basename ?? "").replace(/^\/|\/$/g, "");
    let url = new URL(`${basename}/.manifest`, window.location.origin);
    url.searchParams.set("paths", paths.sort().join(","));
    return url;
}
async function $c7aa18acde4aa33a$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation, signal) {
    paths = (0, $gxpCl.getPathsWithAncestors)(paths);
    let url = $c7aa18acde4aa33a$var$getManifestUrl(paths);
    if (url == null) return;
    if (url.toString().length > (0, $gxpCl.URL_LIMIT)) {
        $c7aa18acde4aa33a$var$nextPaths.clear();
        return;
    }
    let response = await fetchImplementation(new Request(url, {
        signal: signal
    }));
    if (!response.body || response.status < 200 || response.status >= 300) throw new Error("Unable to fetch new route matches from the server");
    let payload = await createFromReadableStream(response.body, {
        temporaryReferences: void 0
    });
    if (payload.type !== "manifest") throw new Error("Failed to patch routes");
    paths.forEach((p)=>$c7aa18acde4aa33a$var$addToFifoQueue(p, $c7aa18acde4aa33a$var$discoveredPaths));
    let patches = await payload.patches;
    $7fPBF.startTransition(()=>{
        patches.forEach((p)=>{
            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                $c7aa18acde4aa33a$var$createRouteFromServerManifest(p)
            ]);
        });
    });
}
function $c7aa18acde4aa33a$var$addToFifoQueue(path, queue) {
    if (queue.size >= $c7aa18acde4aa33a$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (typeof first === "string") queue.delete(first);
    }
    queue.add(path);
}
function $c7aa18acde4aa33a$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
function $c7aa18acde4aa33a$var$isExternalLocation(location2) {
    const newLocation = new URL(location2, window.location.href);
    return newLocation.origin !== window.location.origin;
}
function $c7aa18acde4aa33a$var$normalizeRedirectLocation(location2) {
    if ((0, $gxpCl.PROTOCOL_RELATIVE_URL_REGEX).test(location2)) {
        let path = (0, $gxpCl.resolvePath)(location2);
        return path.pathname + path.search + path.hash;
    }
    return location2;
}
function $c7aa18acde4aa33a$var$cloneRoutes(routes) {
    if (!routes) return void 0;
    return routes.map((route)=>({
            ...route,
            children: $c7aa18acde4aa33a$var$cloneRoutes(route.children)
        }));
}
function $c7aa18acde4aa33a$var$diffRoutes(a, b) {
    if (a.length !== b.length) return true;
    return a.some((route, index)=>{
        if (route.element !== b[index].element) return true;
        if (route.errorElement !== b[index].errorElement) return true;
        if (route.hydrateFallbackElement !== b[index].hydrateFallbackElement) return true;
        if (route.hasErrorBoundary !== b[index].hasErrorBoundary) return true;
        if (route.hasLoader !== b[index].hasLoader) return true;
        if (route.hasClientLoader !== b[index].hasClientLoader) return true;
        if (route.hasAction !== b[index].hasAction) return true;
        if (route.hasClientAction !== b[index].hasClientAction) return true;
        return $c7aa18acde4aa33a$var$diffRoutes(route.children || [], b[index].children || []);
    });
}
// lib/rsc/html-stream/browser.ts
function $c7aa18acde4aa33a$export$f4bb6b48866e43b() {
    let encoder = new TextEncoder();
    let streamController = null;
    let rscStream = new ReadableStream({
        start (controller) {
            if (typeof window === "undefined") return;
            let handleChunk = (chunk)=>{
                if (typeof chunk === "string") controller.enqueue(encoder.encode(chunk));
                else controller.enqueue(chunk);
            };
            window.__FLIGHT_DATA || (window.__FLIGHT_DATA = []);
            window.__FLIGHT_DATA.forEach(handleChunk);
            window.__FLIGHT_DATA.push = (chunk)=>{
                handleChunk(chunk);
                return 0;
            };
            streamController = controller;
        }
    });
    if (typeof document !== "undefined" && document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        streamController?.close();
    });
    else streamController?.close();
    return rscStream;
}






var $f4Ua7 = parcelRequire("f4Ua7");
const $d7ff3ee147cb4273$var$msalInstance = new (0, $lp1At.PublicClientApplication)((0, $625364a45b510798$export$f6d610d2730cbf1a));
const $d7ff3ee147cb4273$var$container = document.getElementById("root");
/**
 * The Base App component
 */ const $d7ff3ee147cb4273$var$App = ()=>{
    const router = (0, $gxpCl.createBrowserRouter)((0, $f4Ua7.routes));
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c7aa18acde4aa33a$export$323e4fc2fa4753fb), {
        router: router
    });
};
$d7ff3ee147cb4273$var$App.displayName = "App";
if ($d7ff3ee147cb4273$var$container) {
    const root = (0, $f11ec298ebcca059$exports.createRoot)($d7ff3ee147cb4273$var$container);
    root.render(/*#__PURE__*/ (0, $bbzbN.jsx)((0, $it3LR.MsalProvider), {
        instance: $d7ff3ee147cb4273$var$msalInstance,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $it3LR.MsalAuthenticationTemplate), {
            interactionType: (0, $lp1At.InteractionType).Redirect,
            authenticationRequest: (0, $625364a45b510798$export$be6c432b2463c5eb),
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f3e491862a2782d7$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($d7ff3ee147cb4273$var$App, {})
            })
        })
    }));
}


//# sourceMappingURL=public.68d344f2.js.map
